export const countryDetails = {
  AD: {
    name: "Andorra",
    native: "Andorra",
    phone: "376",
    continent: "EU",
    capital: "Andorra la Vella",
    currency: "EUR",
    languages: ["ca"],
    emoji: "🇦🇩",
    emojiU: "U+1F1E6 U+1F1E9",
    states: {
      "Andorra la Vella": [],
      Canillo: [
        {
          id: "6449",
          name: "Canillo",
          state_id: "169",
        },
      ],
      Encamp: [
        {
          id: "6450",
          name: "Encamp",
          state_id: "170",
        },
      ],
      "La Massana": [],
      "Les Escaldes": [],
      Ordino: [
        {
          id: "6451",
          name: "Ordino",
          state_id: "173",
        },
      ],
      "Sant Julia de Loria": [],
    },
  },
  AE: {
    name: "United Arab Emirates",
    native: "دولة الإمارات العربية المتحدة",
    phone: "971",
    continent: "AS",
    capital: "Abu Dhabi",
    currency: "AED",
    languages: ["ar"],
    emoji: "🇦🇪",
    emojiU: "U+1F1E6 U+1F1EA",
    states: {
      "Abu Zabi": [],
      Ajman: [
        {
          id: "41388",
          name: "Ajman",
          state_id: "3797",
        },
      ],
      Dubai: [
        {
          id: "41389",
          name: "Al Qusais",
          state_id: "3798",
        },
        {
          id: "41390",
          name: "Deira",
          state_id: "3798",
        },
        {
          id: "41391",
          name: "Dubai",
          state_id: "3798",
        },
        {
          id: "41392",
          name: "Jebel Ali",
          state_id: "3798",
        },
      ],
      "Ras al-Khaymah": [],
      Sharjah: [
        {
          id: "41393",
          name: "Sharjah",
          state_id: "3800",
        },
      ],
      Sharjha: [],
      "Umm al Qaywayn": [],
      "al-Fujayrah": [
        {
          id: "41394",
          name: "Khawr Fakkan",
          state_id: "3803",
        },
        {
          id: "41395",
          name: "al-Fujayrah",
          state_id: "3803",
        },
      ],
      "ash-Shariqah": [],
    },
  },
  AF: {
    name: "Afghanistan",
    native: "افغانستان",
    phone: "93",
    continent: "AS",
    capital: "Kabul",
    currency: "AFN",
    languages: ["ps", "uz", "tk"],
    emoji: "🇦🇫",
    emojiU: "U+1F1E6 U+1F1EB",
    states: {
      Badakhshan: [
        {
          id: "5909",
          name: "Eshkashem",
          state_id: "42",
        },
        {
          id: "5910",
          name: "Fayzabad",
          state_id: "42",
        },
        {
          id: "5911",
          name: "Jurm",
          state_id: "42",
        },
        {
          id: "5912",
          name: "Khandud",
          state_id: "42",
        },
        {
          id: "5913",
          name: "Qal''eh-ye Panjeh",
          state_id: "42",
        },
      ],
      Badgis: [
        {
          id: "5914",
          name: "Bala Morghab",
          state_id: "43",
        },
        {
          id: "5915",
          name: "Qal''eh-ye Naw",
          state_id: "43",
        },
      ],
      Baglan: [
        {
          id: "5916",
          name: "Andarab",
          state_id: "44",
        },
        {
          id: "5917",
          name: "Baghlan",
          state_id: "44",
        },
        {
          id: "5918",
          name: "Dahaneh-ye Ghawri",
          state_id: "44",
        },
        {
          id: "5919",
          name: "Nahrin",
          state_id: "44",
        },
        {
          id: "5920",
          name: "Pol-e Khumri",
          state_id: "44",
        },
      ],
      Balkh: [
        {
          id: "5921",
          name: "Balkh",
          state_id: "45",
        },
        {
          id: "5922",
          name: "Dawlatabad",
          state_id: "45",
        },
        {
          id: "5923",
          name: "Mazar-e Sharif",
          state_id: "45",
        },
        {
          id: "5924",
          name: "Qarchi Gak",
          state_id: "45",
        },
        {
          id: "5925",
          name: "Shulgara",
          state_id: "45",
        },
        {
          id: "5926",
          name: "Tash Gozar",
          state_id: "45",
        },
      ],
      Bamiyan: [
        {
          id: "5927",
          name: "Bamiyan",
          state_id: "46",
        },
        {
          id: "5928",
          name: "Panjab",
          state_id: "46",
        },
        {
          id: "5929",
          name: "Qil Qal''eh",
          state_id: "46",
        },
      ],
      Farah: [
        {
          id: "5930",
          name: "Anar Darreh",
          state_id: "47",
        },
        {
          id: "5931",
          name: "Farah",
          state_id: "47",
        },
        {
          id: "5932",
          name: "Shindand",
          state_id: "47",
        },
      ],
      Faryab: [
        {
          id: "5933",
          name: "Andkhvoy",
          state_id: "48",
        },
        {
          id: "5934",
          name: "Darzi Ab",
          state_id: "48",
        },
        {
          id: "5935",
          name: "Dawlatabad",
          state_id: "48",
        },
        {
          id: "5936",
          name: "Maymanah",
          state_id: "48",
        },
      ],
      Gawr: [
        {
          id: "5937",
          name: "Chaghcharan",
          state_id: "49",
        },
        {
          id: "5938",
          name: "Shahrak",
          state_id: "49",
        },
        {
          id: "5939",
          name: "Taywarah",
          state_id: "49",
        },
      ],
      Gazni: [
        {
          id: "5940",
          name: "Ghazni",
          state_id: "50",
        },
      ],
      Herat: [
        {
          id: "5941",
          name: "Awbeh",
          state_id: "51",
        },
        {
          id: "5942",
          name: "Eslam Qal''eh",
          state_id: "51",
        },
        {
          id: "5943",
          name: "Ghurian",
          state_id: "51",
        },
        {
          id: "5944",
          name: "Herat",
          state_id: "51",
        },
        {
          id: "5945",
          name: "Karukh",
          state_id: "51",
        },
        {
          id: "5946",
          name: "Kuhestan",
          state_id: "51",
        },
        {
          id: "5947",
          name: "Kushk",
          state_id: "51",
        },
        {
          id: "5948",
          name: "Qarabagh",
          state_id: "51",
        },
        {
          id: "5949",
          name: "Tawraghudi",
          state_id: "51",
        },
        {
          id: "5950",
          name: "Tir Pol",
          state_id: "51",
        },
        {
          id: "5951",
          name: "Zendejan",
          state_id: "51",
        },
      ],
      Hilmand: [
        {
          id: "5952",
          name: "Baghran",
          state_id: "52",
        },
        {
          id: "5953",
          name: "Darwishan",
          state_id: "52",
        },
        {
          id: "5954",
          name: "Deh Shu",
          state_id: "52",
        },
        {
          id: "5955",
          name: "Gereshk",
          state_id: "52",
        },
        {
          id: "5956",
          name: "Lashkar Gah",
          state_id: "52",
        },
        {
          id: "5957",
          name: "Sangin",
          state_id: "52",
        },
      ],
      Jawzjan: [
        {
          id: "5958",
          name: "Aqchah",
          state_id: "53",
        },
        {
          id: "5959",
          name: "Qarqin",
          state_id: "53",
        },
        {
          id: "5960",
          name: "Sang-e Charak",
          state_id: "53",
        },
        {
          id: "5961",
          name: "Shibarghan",
          state_id: "53",
        },
      ],
      Kabul: [
        {
          id: "5962",
          name: "Baghrami",
          state_id: "54",
        },
        {
          id: "5963",
          name: "Kabul",
          state_id: "54",
        },
        {
          id: "5964",
          name: "Mir Bachchekut",
          state_id: "54",
        },
        {
          id: "5965",
          name: "Paghman",
          state_id: "54",
        },
        {
          id: "5966",
          name: "Qarabagh",
          state_id: "54",
        },
        {
          id: "5967",
          name: "Sarawbi",
          state_id: "54",
        },
      ],
      Kapisa: [
        {
          id: "5968",
          name: "Mahmud-e Raqi",
          state_id: "55",
        },
        {
          id: "5969",
          name: "Taghab",
          state_id: "55",
        },
      ],
      Khawst: [
        {
          id: "5970",
          name: "Khawst",
          state_id: "56",
        },
      ],
      Kunar: [
        {
          id: "5971",
          name: "Asadabad",
          state_id: "57",
        },
        {
          id: "5972",
          name: "Asmar",
          state_id: "57",
        },
      ],
      Lagman: [
        {
          id: "5973",
          name: "Mehtar Lam",
          state_id: "58",
        },
      ],
      Lawghar: [
        {
          id: "5974",
          name: "Azraw",
          state_id: "59",
        },
        {
          id: "5975",
          name: "Baraki Barak",
          state_id: "59",
        },
        {
          id: "5976",
          name: "Pol-e Alam",
          state_id: "59",
        },
      ],
      Nangarhar: [
        {
          id: "5977",
          name: "Achin",
          state_id: "60",
        },
        {
          id: "5978",
          name: "Batsawul",
          state_id: "60",
        },
        {
          id: "5979",
          name: "Hugyani",
          state_id: "60",
        },
        {
          id: "5980",
          name: "Jalalabad",
          state_id: "60",
        },
        {
          id: "5981",
          name: "Nader Shah Kawt",
          state_id: "60",
        },
      ],
      Nimruz: [
        {
          id: "5982",
          name: "Chahar Burjak",
          state_id: "61",
        },
        {
          id: "5983",
          name: "Chakhansur",
          state_id: "61",
        },
        {
          id: "5984",
          name: "Khash",
          state_id: "61",
        },
        {
          id: "5985",
          name: "Mirabad",
          state_id: "61",
        },
        {
          id: "5986",
          name: "Rudbar",
          state_id: "61",
        },
        {
          id: "5987",
          name: "Zaranj",
          state_id: "61",
        },
      ],
      Nuristan: [
        {
          id: "5988",
          name: "Nuristan",
          state_id: "62",
        },
      ],
      Paktika: [
        {
          id: "5989",
          name: "Orgun",
          state_id: "63",
        },
        {
          id: "5990",
          name: "Zareh Sharan",
          state_id: "63",
        },
        {
          id: "5991",
          name: "Zarghun Shahr",
          state_id: "63",
        },
      ],
      Paktiya: [
        {
          id: "5992",
          name: "Ali Khayl",
          state_id: "64",
        },
        {
          id: "5993",
          name: "Ghardez",
          state_id: "64",
        },
      ],
      Parwan: [
        {
          id: "5994",
          name: "Charikar",
          state_id: "65",
        },
        {
          id: "5995",
          name: "Jabal-os-Saraj",
          state_id: "65",
        },
      ],
      Qandahar: [
        {
          id: "5996",
          name: "Qandahar",
          state_id: "66",
        },
      ],
      Qunduz: [
        {
          id: "5997",
          name: "Dasht-e Archa",
          state_id: "67",
        },
        {
          id: "5998",
          name: "Emam Saheb",
          state_id: "67",
        },
        {
          id: "5999",
          name: "Hazart Imam",
          state_id: "67",
        },
        {
          id: "6000",
          name: "Khanabad",
          state_id: "67",
        },
        {
          id: "6001",
          name: "Qal''eh-ye Zal",
          state_id: "67",
        },
        {
          id: "6002",
          name: "Qunduz",
          state_id: "67",
        },
      ],
      Samangan: [
        {
          id: "6003",
          name: "Aybak",
          state_id: "68",
        },
        {
          id: "6004",
          name: "Kholm",
          state_id: "68",
        },
      ],
      "Sar-e Pul": [],
      Takhar: [
        {
          id: "6005",
          name: "Chah Ab",
          state_id: "70",
        },
        {
          id: "6006",
          name: "Eshkamesh",
          state_id: "70",
        },
        {
          id: "6007",
          name: "Farkhar",
          state_id: "70",
        },
        {
          id: "6008",
          name: "Khwajeh Ghar",
          state_id: "70",
        },
        {
          id: "6009",
          name: "Rostaq",
          state_id: "70",
        },
        {
          id: "6010",
          name: "Taloqan",
          state_id: "70",
        },
        {
          id: "6011",
          name: "Yangi Qal''eh",
          state_id: "70",
        },
      ],
      Uruzgan: [
        {
          id: "6012",
          name: "Deh Rawud",
          state_id: "71",
        },
        {
          id: "6013",
          name: "Gaz Ab",
          state_id: "71",
        },
        {
          id: "6014",
          name: "Tarin Kawt",
          state_id: "71",
        },
        {
          id: "6015",
          name: "Uruzgan",
          state_id: "71",
        },
      ],
      Wardag: [
        {
          id: "6016",
          name: "Gardan Diwal",
          state_id: "72",
        },
        {
          id: "6017",
          name: "Maydanshahr",
          state_id: "72",
        },
      ],
      Zabul: [
        {
          id: "6018",
          name: "Qalat-e Ghilzay",
          state_id: "73",
        },
      ],
    },
  },
  AG: {
    name: "Antigua and Barbuda",
    native: "Antigua and Barbuda",
    phone: "1268",
    continent: "NA",
    capital: "Saint John's",
    currency: "XCD",
    languages: ["en"],
    emoji: "🇦🇬",
    emojiU: "U+1F1E6 U+1F1EC",
    states: {
      Barbuda: [
        {
          id: "6483",
          name: "Codrington",
          state_id: "201",
        },
      ],
      "Saint George": [],
      "Saint John": [],
      "Saint Mary": [],
      "Saint Paul": [],
      "Saint Peter": [],
      "Saint Philip": [],
    },
  },
  AI: {
    name: "Anguilla",
    native: "Anguilla",
    phone: "1264",
    continent: "NA",
    capital: "The Valley",
    currency: "XCD",
    languages: ["en"],
    emoji: "🇦🇮",
    emojiU: "U+1F1E6 U+1F1EE",
    states: {
      "Other Provinces": [],
    },
  },
  AL: {
    name: "Albania",
    native: "Shqipëria",
    phone: "355",
    continent: "EU",
    capital: "Tirana",
    currency: "ALL",
    languages: ["sq"],
    emoji: "🇦🇱",
    emojiU: "U+1F1E6 U+1F1F1",
    states: {
      Berat: [
        {
          id: "6019",
          name: "Berat",
          state_id: "74",
        },
        {
          id: "6020",
          name: "Polican",
          state_id: "74",
        },
        {
          id: "6021",
          name: "Ure Vajgurore",
          state_id: "74",
        },
      ],
      Bulqize: [
        {
          id: "6022",
          name: "Bulqize",
          state_id: "75",
        },
      ],
      Delvine: [
        {
          id: "6023",
          name: "Delvine",
          state_id: "76",
        },
      ],
      Devoll: [
        {
          id: "6024",
          name: "Bilisht",
          state_id: "77",
        },
      ],
      Dibre: [
        {
          id: "6025",
          name: "Maqellare",
          state_id: "78",
        },
        {
          id: "6026",
          name: "Peshkopi",
          state_id: "78",
        },
      ],
      Durres: [
        {
          id: "6027",
          name: "Durres",
          state_id: "79",
        },
        {
          id: "6028",
          name: "Shijak",
          state_id: "79",
        },
      ],
      Elbasan: [
        {
          id: "6029",
          name: "Cerrik",
          state_id: "80",
        },
        {
          id: "6030",
          name: "Elbasan",
          state_id: "80",
        },
        {
          id: "6031",
          name: "Kerrabe",
          state_id: "80",
        },
      ],
      Fier: [
        {
          id: "6032",
          name: "Fier",
          state_id: "81",
        },
        {
          id: "6033",
          name: "Patos",
          state_id: "81",
        },
        {
          id: "6034",
          name: "Roskovec",
          state_id: "81",
        },
      ],
      Gjirokaster: [
        {
          id: "6035",
          name: "Gjirokaster",
          state_id: "82",
        },
        {
          id: "6036",
          name: "Libohove",
          state_id: "82",
        },
      ],
      Gramsh: [
        {
          id: "6037",
          name: "Gramsh",
          state_id: "83",
        },
      ],
      Has: [
        {
          id: "6038",
          name: "Krume",
          state_id: "84",
        },
      ],
      Kavaje: [
        {
          id: "6039",
          name: "Kavaje",
          state_id: "85",
        },
      ],
      Kolonje: [
        {
          id: "6040",
          name: "Erseke",
          state_id: "86",
        },
        {
          id: "6041",
          name: "Leskovik",
          state_id: "86",
        },
      ],
      Korce: [
        {
          id: "6042",
          name: "Korce",
          state_id: "87",
        },
        {
          id: "6043",
          name: "Maliq",
          state_id: "87",
        },
      ],
      Kruje: [
        {
          id: "6044",
          name: "Fushe-Kruje",
          state_id: "88",
        },
        {
          id: "6045",
          name: "Kruje",
          state_id: "88",
        },
        {
          id: "6046",
          name: "Mamurras",
          state_id: "88",
        },
        {
          id: "6047",
          name: "Milot",
          state_id: "88",
        },
      ],
      Kucove: [
        {
          id: "6048",
          name: "Kucove",
          state_id: "89",
        },
      ],
      Kukes: [
        {
          id: "6049",
          name: "Kukes",
          state_id: "90",
        },
      ],
      Kurbin: [
        {
          id: "6050",
          name: "Lac",
          state_id: "91",
        },
      ],
      Lezhe: [
        {
          id: "6051",
          name: "Lezhe",
          state_id: "92",
        },
        {
          id: "6052",
          name: "Shengjin",
          state_id: "92",
        },
      ],
      Librazhd: [
        {
          id: "6053",
          name: "Librazhd",
          state_id: "93",
        },
        {
          id: "6054",
          name: "Perrenjas",
          state_id: "93",
        },
      ],
      Lushnje: [
        {
          id: "6055",
          name: "Lushnje",
          state_id: "94",
        },
        {
          id: "6056",
          name: "Rrogozhine",
          state_id: "94",
        },
      ],
      Mallakaster: [
        {
          id: "6057",
          name: "Ballsh",
          state_id: "95",
        },
      ],
      "Malsi e Madhe": [],
      Mat: [
        {
          id: "6058",
          name: "Burrel",
          state_id: "97",
        },
        {
          id: "6059",
          name: "Klos",
          state_id: "97",
        },
        {
          id: "6060",
          name: "Kraste",
          state_id: "97",
        },
        {
          id: "6061",
          name: "Ulze",
          state_id: "97",
        },
      ],
      Mirdite: [
        {
          id: "6062",
          name: "Kurbnesh",
          state_id: "98",
        },
        {
          id: "6063",
          name: "Rreshen",
          state_id: "98",
        },
        {
          id: "6064",
          name: "Rubik",
          state_id: "98",
        },
      ],
      Peqin: [
        {
          id: "6065",
          name: "Peqin",
          state_id: "99",
        },
      ],
      Permet: [
        {
          id: "6066",
          name: "Kelcyre",
          state_id: "100",
        },
        {
          id: "6067",
          name: "Permet",
          state_id: "100",
        },
      ],
      Pogradec: [
        {
          id: "6068",
          name: "Pogradec",
          state_id: "101",
        },
      ],
      Puke: [
        {
          id: "6069",
          name: "Fierze",
          state_id: "102",
        },
        {
          id: "6070",
          name: "Fushe-Arrez",
          state_id: "102",
        },
        {
          id: "6071",
          name: "Puke",
          state_id: "102",
        },
      ],
      Sarande: [
        {
          id: "6072",
          name: "Konispol",
          state_id: "103",
        },
        {
          id: "6073",
          name: "Sarande",
          state_id: "103",
        },
      ],
      Shkoder: [
        {
          id: "6074",
          name: "Shkoder",
          state_id: "104",
        },
      ],
      Skrapar: [
        {
          id: "6075",
          name: "Corovode",
          state_id: "105",
        },
      ],
      Tepelene: [
        {
          id: "6076",
          name: "Memaliaj",
          state_id: "106",
        },
        {
          id: "6077",
          name: "Tepelene",
          state_id: "106",
        },
      ],
      Tirane: [
        {
          id: "6078",
          name: "Kamze",
          state_id: "107",
        },
        {
          id: "6079",
          name: "Paskuqan",
          state_id: "107",
        },
        {
          id: "6080",
          name: "Tirane",
          state_id: "107",
        },
        {
          id: "6081",
          name: "Vore",
          state_id: "107",
        },
      ],
      Tropoje: [
        {
          id: "6082",
          name: "Bajram Curri",
          state_id: "108",
        },
      ],
      Vlore: [
        {
          id: "6083",
          name: "Himare",
          state_id: "109",
        },
        {
          id: "6084",
          name: "Orikum",
          state_id: "109",
        },
        {
          id: "6085",
          name: "Selenice",
          state_id: "109",
        },
        {
          id: "6086",
          name: "Vlore",
          state_id: "109",
        },
      ],
    },
  },
  AM: {
    name: "Armenia",
    native: "Հայաստան",
    phone: "374",
    continent: "AS",
    capital: "Yerevan",
    currency: "AMD",
    languages: ["hy", "ru"],
    emoji: "🇦🇲",
    emojiU: "U+1F1E6 U+1F1F2",
    states: {
      Aragatsotn: [
        {
          id: "6522",
          name: "Ashtarak",
          state_id: "232",
        },
        {
          id: "6523",
          name: "Talin",
          state_id: "232",
        },
      ],
      Ararat: [
        {
          id: "6524",
          name: "Ararat",
          state_id: "233",
        },
        {
          id: "6525",
          name: "Artashat",
          state_id: "233",
        },
      ],
      Armavir: [
        {
          id: "6526",
          name: "Armavir",
          state_id: "234",
        },
        {
          id: "6527",
          name: "Vagharshapat",
          state_id: "234",
        },
      ],
      Gegharkunik: [
        {
          id: "6528",
          name: "Gavar",
          state_id: "235",
        },
        {
          id: "6529",
          name: "Martuni",
          state_id: "235",
        },
        {
          id: "6530",
          name: "Sevan",
          state_id: "235",
        },
        {
          id: "6531",
          name: "Vardenis",
          state_id: "235",
        },
      ],
      Kotaik: [
        {
          id: "6532",
          name: "Abovyan",
          state_id: "236",
        },
        {
          id: "6533",
          name: "Arzni",
          state_id: "236",
        },
        {
          id: "6534",
          name: "Charentsavan",
          state_id: "236",
        },
        {
          id: "6535",
          name: "Hrazdan",
          state_id: "236",
        },
      ],
      Lori: [
        {
          id: "6536",
          name: "Akhtala",
          state_id: "237",
        },
        {
          id: "6537",
          name: "Alaverdi",
          state_id: "237",
        },
        {
          id: "6538",
          name: "Spitak",
          state_id: "237",
        },
        {
          id: "6539",
          name: "Stepanavan",
          state_id: "237",
        },
        {
          id: "6540",
          name: "Tashir",
          state_id: "237",
        },
        {
          id: "6541",
          name: "Vanadzor",
          state_id: "237",
        },
      ],
      Shirak: [
        {
          id: "6542",
          name: "Artik",
          state_id: "238",
        },
        {
          id: "6543",
          name: "Gyumri",
          state_id: "238",
        },
      ],
      Stepanakert: [
        {
          id: "6544",
          name: "Stepanakert",
          state_id: "239",
        },
      ],
      Syunik: [
        {
          id: "6545",
          name: "Angeghakot",
          state_id: "240",
        },
        {
          id: "6546",
          name: "Goris",
          state_id: "240",
        },
        {
          id: "6547",
          name: "Kajaran",
          state_id: "240",
        },
        {
          id: "6548",
          name: "Kapan",
          state_id: "240",
        },
        {
          id: "6549",
          name: "Meghri",
          state_id: "240",
        },
        {
          id: "6550",
          name: "Sisian",
          state_id: "240",
        },
      ],
      Tavush: [
        {
          id: "6551",
          name: "Dilijan",
          state_id: "241",
        },
        {
          id: "6552",
          name: "Ijevan",
          state_id: "241",
        },
      ],
      "Vayots Dzor": [],
      Yerevan: [
        {
          id: "6553",
          name: "Yerevan",
          state_id: "243",
        },
      ],
    },
  },
  AO: {
    name: "Angola",
    native: "Angola",
    phone: "244",
    continent: "AF",
    capital: "Luanda",
    currency: "AOA",
    languages: ["pt"],
    emoji: "🇦🇴",
    emojiU: "U+1F1E6 U+1F1F4",
    states: {
      Bengo: [
        {
          id: "6452",
          name: "Caxito",
          state_id: "175",
        },
      ],
      Benguela: [
        {
          id: "6453",
          name: "Benguela",
          state_id: "176",
        },
        {
          id: "6454",
          name: "Lobito",
          state_id: "176",
        },
      ],
      Bie: [
        {
          id: "6455",
          name: "Camacupa",
          state_id: "177",
        },
        {
          id: "6456",
          name: "Catabola",
          state_id: "177",
        },
        {
          id: "6457",
          name: "Catumbela",
          state_id: "177",
        },
        {
          id: "6458",
          name: "Chissamba",
          state_id: "177",
        },
        {
          id: "6459",
          name: "Kuito",
          state_id: "177",
        },
      ],
      Cabinda: [
        {
          id: "6460",
          name: "Cabinda",
          state_id: "178",
        },
      ],
      Cunene: [
        {
          id: "6461",
          name: "Ondjiva",
          state_id: "179",
        },
      ],
      Huambo: [
        {
          id: "6462",
          name: "Caala",
          state_id: "180",
        },
        {
          id: "6463",
          name: "Catchiungo",
          state_id: "180",
        },
        {
          id: "6464",
          name: "Huambo",
          state_id: "180",
        },
        {
          id: "6465",
          name: "Longonjo",
          state_id: "180",
        },
      ],
      Huila: [
        {
          id: "6466",
          name: "Caconda",
          state_id: "181",
        },
        {
          id: "6467",
          name: "Caluquembe",
          state_id: "181",
        },
        {
          id: "6468",
          name: "Lubango",
          state_id: "181",
        },
      ],
      "Kuando-Kubango": [
        {
          id: "6469",
          name: "Menongue",
          state_id: "182",
        },
      ],
      "Kwanza Norte": [],
      "Kwanza Sul": [],
      Luanda: [
        {
          id: "6470",
          name: "Luanda",
          state_id: "185",
        },
      ],
      "Lunda Norte": [],
      "Lunda Sul": [],
      Malanje: [
        {
          id: "6471",
          name: "Malanje",
          state_id: "188",
        },
      ],
      Moxico: [
        {
          id: "6472",
          name: "Cazaje",
          state_id: "189",
        },
        {
          id: "6473",
          name: "Leua",
          state_id: "189",
        },
        {
          id: "6474",
          name: "Luau",
          state_id: "189",
        },
        {
          id: "6475",
          name: "Luena",
          state_id: "189",
        },
        {
          id: "6476",
          name: "Lumeje",
          state_id: "189",
        },
      ],
      Namibe: [
        {
          id: "6477",
          name: "Namibe",
          state_id: "190",
        },
      ],
      Uige: [
        {
          id: "6478",
          name: "Camabatela",
          state_id: "191",
        },
        {
          id: "6479",
          name: "Uige",
          state_id: "191",
        },
      ],
      Zaire: [
        {
          id: "6480",
          name: "M''banza-Kongo",
          state_id: "192",
        },
        {
          id: "6481",
          name: "N''zeto",
          state_id: "192",
        },
        {
          id: "6482",
          name: "Soyo",
          state_id: "192",
        },
      ],
    },
  },
  AQ: {
    name: "Antarctica",
    native: "Antarctica",
    phone: "672",
    continent: "AN",
    capital: "",
    currency: "",
    languages: [],
    emoji: "🇦🇶",
    emojiU: "U+1F1E6 U+1F1F6",
    states: {
      "Sector claimed by Argentina/Ch": [],
      "Sector claimed by Argentina/UK": [],
      "Sector claimed by Australia": [],
      "Sector claimed by France": [],
      "Sector claimed by New Zealand": [],
      "Sector claimed by Norway": [],
      "Unclaimed Sector": [],
    },
  },
  AR: {
    name: "Argentina",
    native: "Argentina",
    phone: "54",
    continent: "SA",
    capital: "Buenos Aires",
    currency: "ARS",
    languages: ["es", "gn"],
    emoji: "🇦🇷",
    emojiU: "U+1F1E6 U+1F1F7",
    states: {
      "Buenos Aires": [],
      Catamarca: [
        {
          id: "6484",
          name: "Catamarca",
          state_id: "209",
        },
      ],
      Chaco: [
        {
          id: "6485",
          name: "Presidencia Roque Saenz Pena",
          state_id: "210",
        },
        {
          id: "6486",
          name: "Resistencia",
          state_id: "210",
        },
      ],
      Chubut: [
        {
          id: "6487",
          name: "Comodoro Rivadavia",
          state_id: "211",
        },
        {
          id: "6488",
          name: "Puerto Madryn",
          state_id: "211",
        },
        {
          id: "6489",
          name: "Rawson",
          state_id: "211",
        },
        {
          id: "6490",
          name: "Trelew",
          state_id: "211",
        },
      ],
      Cordoba: [
        {
          id: "6491",
          name: "Alta Gracia",
          state_id: "212",
        },
        {
          id: "6492",
          name: "Bell Ville",
          state_id: "212",
        },
        {
          id: "6493",
          name: "Cordoba",
          state_id: "212",
        },
        {
          id: "6494",
          name: "Rio Cuarto",
          state_id: "212",
        },
        {
          id: "6495",
          name: "Rio Tercero",
          state_id: "212",
        },
        {
          id: "6496",
          name: "San Francisco",
          state_id: "212",
        },
        {
          id: "6497",
          name: "Villa Carlos Paz",
          state_id: "212",
        },
        {
          id: "6498",
          name: "Villa Maria",
          state_id: "212",
        },
      ],
      Corrientes: [
        {
          id: "6499",
          name: "Corrientes",
          state_id: "213",
        },
        {
          id: "6500",
          name: "Goya",
          state_id: "213",
        },
        {
          id: "6501",
          name: "Mercedes",
          state_id: "213",
        },
        {
          id: "6502",
          name: "San Lorenzo",
          state_id: "213",
        },
      ],
      "Distrito Federal": [],
      "Entre Rios": [],
      Formosa: [
        {
          id: "6503",
          name: "Formosa",
          state_id: "216",
        },
      ],
      Jujuy: [
        {
          id: "6504",
          name: "Jujuy",
          state_id: "217",
        },
        {
          id: "6505",
          name: "Libertador General San Martin",
          state_id: "217",
        },
        {
          id: "6506",
          name: "San Pedro",
          state_id: "217",
        },
      ],
      "La Pampa": [],
      "La Rioja": [],
      Mendoza: [
        {
          id: "6507",
          name: "Godoy Cruz",
          state_id: "220",
        },
        {
          id: "6508",
          name: "Lujan",
          state_id: "220",
        },
        {
          id: "6509",
          name: "Mendoza",
          state_id: "220",
        },
        {
          id: "6510",
          name: "Rivadavia",
          state_id: "220",
        },
        {
          id: "6511",
          name: "San Martin",
          state_id: "220",
        },
        {
          id: "6512",
          name: "San Rafael",
          state_id: "220",
        },
      ],
      Misiones: [
        {
          id: "6513",
          name: "Eldorado",
          state_id: "221",
        },
        {
          id: "6514",
          name: "Obera",
          state_id: "221",
        },
        {
          id: "6515",
          name: "Posadas",
          state_id: "221",
        },
      ],
      Neuquen: [
        {
          id: "6516",
          name: "Cutral Co",
          state_id: "222",
        },
        {
          id: "6517",
          name: "Neuquen",
          state_id: "222",
        },
      ],
      "Rio Negro": [],
      Salta: [
        {
          id: "6518",
          name: "Salta",
          state_id: "224",
        },
        {
          id: "6519",
          name: "San Ramon de la Nueva Oran",
          state_id: "224",
        },
        {
          id: "6520",
          name: "Tartagal",
          state_id: "224",
        },
      ],
      "San Juan": [],
      "San Luis": [],
      "Santa Cruz": [],
      "Santa Fe": [],
      "Santiago del Estero": [],
      "Tierra del Fuego": [],
      Tucuman: [
        {
          id: "6521",
          name: "Tucuman",
          state_id: "231",
        },
      ],
    },
  },
  AS: {
    name: "American Samoa",
    native: "American Samoa",
    phone: "1684",
    continent: "OC",
    capital: "Pago Pago",
    currency: "USD",
    languages: ["en", "sm"],
    emoji: "🇦🇸",
    emojiU: "U+1F1E6 U+1F1F8",
    states: {
      Eastern: [
        {
          id: "6414",
          name: "Afono",
          state_id: "164",
        },
        {
          id: "6415",
          name: "Alao",
          state_id: "164",
        },
        {
          id: "6416",
          name: "Alofau",
          state_id: "164",
        },
        {
          id: "6417",
          name: "Amouli",
          state_id: "164",
        },
        {
          id: "6418",
          name: "Aoa",
          state_id: "164",
        },
        {
          id: "6419",
          name: "Atu''u",
          state_id: "164",
        },
        {
          id: "6420",
          name: "Aua",
          state_id: "164",
        },
        {
          id: "6421",
          name: "Aunu''u",
          state_id: "164",
        },
        {
          id: "6422",
          name: "Faga''alu",
          state_id: "164",
        },
        {
          id: "6423",
          name: "Faga''itua",
          state_id: "164",
        },
        {
          id: "6424",
          name: "Fagasa",
          state_id: "164",
        },
        {
          id: "6425",
          name: "Fagatogo",
          state_id: "164",
        },
        {
          id: "6426",
          name: "Lauli''i",
          state_id: "164",
        },
        {
          id: "6427",
          name: "Leloaloa",
          state_id: "164",
        },
        {
          id: "6428",
          name: "Nu''uuli",
          state_id: "164",
        },
        {
          id: "6429",
          name: "Pago Pago",
          state_id: "164",
        },
        {
          id: "6430",
          name: "Tula",
          state_id: "164",
        },
        {
          id: "6431",
          name: "Utulei",
          state_id: "164",
        },
        {
          id: "6432",
          name: "Vatia",
          state_id: "164",
        },
      ],
      "Manu''a": [
        {
          id: "6433",
          name: "Ofu",
          state_id: "165",
        },
      ],
      "Swains Island": [],
      Western: [
        {
          id: "6434",
          name: "Aoloau",
          state_id: "167",
        },
        {
          id: "6435",
          name: "Faleniu",
          state_id: "167",
        },
        {
          id: "6436",
          name: "Futiga",
          state_id: "167",
        },
        {
          id: "6437",
          name: "Ili''ili",
          state_id: "167",
        },
        {
          id: "6438",
          name: "Leone",
          state_id: "167",
        },
        {
          id: "6439",
          name: "Malaeimi",
          state_id: "167",
        },
        {
          id: "6440",
          name: "Malaeloa-Aitulagi",
          state_id: "167",
        },
        {
          id: "6441",
          name: "Malaeloa-Ituau",
          state_id: "167",
        },
        {
          id: "6442",
          name: "Mapusagafou",
          state_id: "167",
        },
        {
          id: "6443",
          name: "Mesepa",
          state_id: "167",
        },
        {
          id: "6444",
          name: "Pava''ia''i",
          state_id: "167",
        },
        {
          id: "6445",
          name: "Tafuna",
          state_id: "167",
        },
        {
          id: "6446",
          name: "Taputimu",
          state_id: "167",
        },
        {
          id: "6447",
          name: "Vailoatai",
          state_id: "167",
        },
        {
          id: "6448",
          name: "Vaitogi",
          state_id: "167",
        },
      ],
    },
  },
  AT: {
    name: "Austria",
    native: "Österreich",
    phone: "43",
    continent: "EU",
    capital: "Vienna",
    currency: "EUR",
    languages: ["de"],
    emoji: "🇦🇹",
    emojiU: "U+1F1E6 U+1F1F9",
    states: {
      "Bundesland Salzburg": [],
      "Bundesland Steiermark": [],
      "Bundesland Tirol": [],
      Burgenland: [
        {
          id: "6833",
          name: "Eisenstadt",
          state_id: "280",
        },
        {
          id: "6834",
          name: "GroBpetersdorf",
          state_id: "280",
        },
        {
          id: "6835",
          name: "Jennersdorf",
          state_id: "280",
        },
        {
          id: "6836",
          name: "Kemeten",
          state_id: "280",
        },
        {
          id: "6837",
          name: "Mattersburg",
          state_id: "280",
        },
        {
          id: "6838",
          name: "Neudorfl",
          state_id: "280",
        },
        {
          id: "6839",
          name: "Neusiedl am See",
          state_id: "280",
        },
        {
          id: "6840",
          name: "Oberwart",
          state_id: "280",
        },
        {
          id: "6841",
          name: "Pinkafeld",
          state_id: "280",
        },
        {
          id: "6842",
          name: "Rust",
          state_id: "280",
        },
      ],
      Carinthia: [
        {
          id: "6843",
          name: "Maria Rain",
          state_id: "281",
        },
        {
          id: "6844",
          name: "Poggersdorf",
          state_id: "281",
        },
      ],
      Karnten: [
        {
          id: "6845",
          name: "Althofen",
          state_id: "282",
        },
        {
          id: "6846",
          name: "Arnoldstein",
          state_id: "282",
        },
        {
          id: "6847",
          name: "Bad Sankt Leonhard",
          state_id: "282",
        },
        {
          id: "6848",
          name: "Bleiburg",
          state_id: "282",
        },
        {
          id: "6849",
          name: "Ebenthal",
          state_id: "282",
        },
        {
          id: "6850",
          name: "Eberndorf",
          state_id: "282",
        },
        {
          id: "6851",
          name: "Feldkirchen",
          state_id: "282",
        },
        {
          id: "6852",
          name: "Ferlach",
          state_id: "282",
        },
        {
          id: "6853",
          name: "Finkenstein",
          state_id: "282",
        },
        {
          id: "6854",
          name: "Friesach",
          state_id: "282",
        },
        {
          id: "6855",
          name: "Hermagor",
          state_id: "282",
        },
        {
          id: "6856",
          name: "Klagenfurt",
          state_id: "282",
        },
        {
          id: "6857",
          name: "Klagenfurt",
          state_id: "282",
        },
        {
          id: "6858",
          name: "Lohnsburg",
          state_id: "282",
        },
        {
          id: "6859",
          name: "Moosburg",
          state_id: "282",
        },
        {
          id: "6860",
          name: "Paternion",
          state_id: "282",
        },
        {
          id: "6861",
          name: "Radentheim",
          state_id: "282",
        },
        {
          id: "6862",
          name: "Sankt Andra",
          state_id: "282",
        },
        {
          id: "6863",
          name: "Sankt Jakob",
          state_id: "282",
        },
        {
          id: "6864",
          name: "Sankt Veit",
          state_id: "282",
        },
        {
          id: "6865",
          name: "Seeboden",
          state_id: "282",
        },
        {
          id: "6866",
          name: "Spittal",
          state_id: "282",
        },
        {
          id: "6867",
          name: "Velden am Worthersee",
          state_id: "282",
        },
        {
          id: "6868",
          name: "Villach",
          state_id: "282",
        },
        {
          id: "6869",
          name: "Volkermarkt",
          state_id: "282",
        },
        {
          id: "6870",
          name: "Wernberg",
          state_id: "282",
        },
        {
          id: "6871",
          name: "Wolfsberg",
          state_id: "282",
        },
      ],
      Liezen: [],
      "Lower Austria": [],
      Niederosterreich: [
        {
          id: "6872",
          name: "Amstetten",
          state_id: "285",
        },
        {
          id: "6873",
          name: "Bad Voslau",
          state_id: "285",
        },
        {
          id: "6874",
          name: "Baden",
          state_id: "285",
        },
        {
          id: "6875",
          name: "Berndorf",
          state_id: "285",
        },
        {
          id: "6876",
          name: "Boheimkirchen",
          state_id: "285",
        },
        {
          id: "6877",
          name: "Bruck an der Leitha",
          state_id: "285",
        },
        {
          id: "6878",
          name: "Brunn",
          state_id: "285",
        },
        {
          id: "6879",
          name: "Deutsch-Wagram",
          state_id: "285",
        },
        {
          id: "6880",
          name: "Ebreichsdorf",
          state_id: "285",
        },
        {
          id: "6881",
          name: "Eggendorf",
          state_id: "285",
        },
        {
          id: "6882",
          name: "Fischamend",
          state_id: "285",
        },
        {
          id: "6883",
          name: "Gablitz",
          state_id: "285",
        },
        {
          id: "6884",
          name: "Ganserndorf",
          state_id: "285",
        },
        {
          id: "6885",
          name: "Gerasdorf",
          state_id: "285",
        },
        {
          id: "6886",
          name: "Gloggnitz",
          state_id: "285",
        },
        {
          id: "6887",
          name: "Gmund",
          state_id: "285",
        },
        {
          id: "6888",
          name: "Greifenstein",
          state_id: "285",
        },
        {
          id: "6889",
          name: "GroB-Enzersdorf",
          state_id: "285",
        },
        {
          id: "6890",
          name: "GroB-Gerungs",
          state_id: "285",
        },
        {
          id: "6891",
          name: "Guntramsdorf",
          state_id: "285",
        },
        {
          id: "6892",
          name: "Haag",
          state_id: "285",
        },
        {
          id: "6893",
          name: "Hainburg",
          state_id: "285",
        },
        {
          id: "6894",
          name: "Heidenreichstein",
          state_id: "285",
        },
        {
          id: "6895",
          name: "Herzogenburg",
          state_id: "285",
        },
        {
          id: "6896",
          name: "Himberg",
          state_id: "285",
        },
        {
          id: "6897",
          name: "Hollabrunn",
          state_id: "285",
        },
        {
          id: "6898",
          name: "Horn",
          state_id: "285",
        },
        {
          id: "6899",
          name: "Klosterneuburg",
          state_id: "285",
        },
        {
          id: "6900",
          name: "Korneuburg",
          state_id: "285",
        },
        {
          id: "6901",
          name: "Kottingbrunn",
          state_id: "285",
        },
        {
          id: "6902",
          name: "Krems",
          state_id: "285",
        },
        {
          id: "6903",
          name: "Laa",
          state_id: "285",
        },
        {
          id: "6904",
          name: "Langenlois",
          state_id: "285",
        },
        {
          id: "6905",
          name: "Langenzersdorf",
          state_id: "285",
        },
        {
          id: "6906",
          name: "Leobendorf",
          state_id: "285",
        },
        {
          id: "6907",
          name: "Leopoldsdorf",
          state_id: "285",
        },
        {
          id: "6908",
          name: "Lilienfeld",
          state_id: "285",
        },
        {
          id: "6909",
          name: "Loipersdorf",
          state_id: "285",
        },
        {
          id: "6910",
          name: "Maria Enzersdorf",
          state_id: "285",
        },
        {
          id: "6911",
          name: "Melk",
          state_id: "285",
        },
        {
          id: "6912",
          name: "Mistelbach",
          state_id: "285",
        },
        {
          id: "6913",
          name: "Modling",
          state_id: "285",
        },
        {
          id: "6914",
          name: "Neulengbach",
          state_id: "285",
        },
        {
          id: "6915",
          name: "Neunkirchen",
          state_id: "285",
        },
        {
          id: "6916",
          name: "Niederleis",
          state_id: "285",
        },
        {
          id: "6917",
          name: "Ober-Grabendorf",
          state_id: "285",
        },
        {
          id: "6918",
          name: "Perchtoldsdorf",
          state_id: "285",
        },
        {
          id: "6919",
          name: "Pernitz",
          state_id: "285",
        },
        {
          id: "6920",
          name: "Pottendorf",
          state_id: "285",
        },
        {
          id: "6921",
          name: "Poysdorf",
          state_id: "285",
        },
        {
          id: "6922",
          name: "Pressbaum",
          state_id: "285",
        },
        {
          id: "6923",
          name: "Purgstall",
          state_id: "285",
        },
        {
          id: "6924",
          name: "Purkersdorf",
          state_id: "285",
        },
        {
          id: "6925",
          name: "Reichenau",
          state_id: "285",
        },
        {
          id: "6926",
          name: "Retz",
          state_id: "285",
        },
        {
          id: "6927",
          name: "Sankt Andra-Wordern",
          state_id: "285",
        },
        {
          id: "6928",
          name: "Sankt Peter in der Au",
          state_id: "285",
        },
        {
          id: "6929",
          name: "Sankt Polten",
          state_id: "285",
        },
        {
          id: "6930",
          name: "Sankt Valentin",
          state_id: "285",
        },
        {
          id: "6931",
          name: "Scheibbs",
          state_id: "285",
        },
        {
          id: "6932",
          name: "Schrems",
          state_id: "285",
        },
        {
          id: "6933",
          name: "Schwechat",
          state_id: "285",
        },
        {
          id: "6934",
          name: "Seitenstetten",
          state_id: "285",
        },
        {
          id: "6935",
          name: "Sollenau",
          state_id: "285",
        },
        {
          id: "6936",
          name: "Stockerau",
          state_id: "285",
        },
        {
          id: "6937",
          name: "Strasshof",
          state_id: "285",
        },
        {
          id: "6938",
          name: "Ternitz",
          state_id: "285",
        },
        {
          id: "6939",
          name: "Traiskirchen",
          state_id: "285",
        },
        {
          id: "6940",
          name: "Traismauer",
          state_id: "285",
        },
        {
          id: "6941",
          name: "Tulln",
          state_id: "285",
        },
        {
          id: "6942",
          name: "Vosendorf",
          state_id: "285",
        },
        {
          id: "6943",
          name: "Waidhofen",
          state_id: "285",
        },
        {
          id: "6944",
          name: "Wiener Neudorf",
          state_id: "285",
        },
        {
          id: "6945",
          name: "Wiener Neustadt",
          state_id: "285",
        },
        {
          id: "6946",
          name: "Wieselburg",
          state_id: "285",
        },
        {
          id: "6947",
          name: "Wilhelmsburg",
          state_id: "285",
        },
        {
          id: "6948",
          name: "Wolkersdorf",
          state_id: "285",
        },
        {
          id: "6949",
          name: "Ybbs",
          state_id: "285",
        },
        {
          id: "6950",
          name: "Ybbsitz",
          state_id: "285",
        },
        {
          id: "6951",
          name: "Zistersdorf",
          state_id: "285",
        },
        {
          id: "6952",
          name: "Zwettl",
          state_id: "285",
        },
      ],
      Oberosterreich: [
        {
          id: "6953",
          name: "Alkoven",
          state_id: "286",
        },
        {
          id: "6954",
          name: "Altheim",
          state_id: "286",
        },
        {
          id: "6955",
          name: "Altmunster",
          state_id: "286",
        },
        {
          id: "6956",
          name: "Andorf",
          state_id: "286",
        },
        {
          id: "6957",
          name: "Ansfelden",
          state_id: "286",
        },
        {
          id: "6958",
          name: "Asten",
          state_id: "286",
        },
        {
          id: "6959",
          name: "Attnang-Puchheim",
          state_id: "286",
        },
        {
          id: "6960",
          name: "Aurolzmunster",
          state_id: "286",
        },
        {
          id: "6961",
          name: "Bad Goisern",
          state_id: "286",
        },
        {
          id: "6962",
          name: "Bad Hall",
          state_id: "286",
        },
        {
          id: "6963",
          name: "Bad Ischl",
          state_id: "286",
        },
        {
          id: "6964",
          name: "Braunau",
          state_id: "286",
        },
        {
          id: "6965",
          name: "Breitenfurt",
          state_id: "286",
        },
        {
          id: "6966",
          name: "Ebensee",
          state_id: "286",
        },
        {
          id: "6967",
          name: "Eferding",
          state_id: "286",
        },
        {
          id: "6968",
          name: "Engerwitzdorf",
          state_id: "286",
        },
        {
          id: "6969",
          name: "Enns",
          state_id: "286",
        },
        {
          id: "6970",
          name: "Feldkirchen an der Donau",
          state_id: "286",
        },
        {
          id: "6971",
          name: "Frankenburg",
          state_id: "286",
        },
        {
          id: "6972",
          name: "Freistadt",
          state_id: "286",
        },
        {
          id: "6973",
          name: "Gallneukirchen",
          state_id: "286",
        },
        {
          id: "6974",
          name: "Garsten",
          state_id: "286",
        },
        {
          id: "6975",
          name: "Gmunden",
          state_id: "286",
        },
        {
          id: "6976",
          name: "Gramastetten",
          state_id: "286",
        },
        {
          id: "6977",
          name: "Grieskirchen",
          state_id: "286",
        },
        {
          id: "6978",
          name: "Gunskirchen",
          state_id: "286",
        },
        {
          id: "6979",
          name: "Horsching",
          state_id: "286",
        },
        {
          id: "6980",
          name: "Kirchdorf an der Krems",
          state_id: "286",
        },
        {
          id: "6981",
          name: "Kremsmunster",
          state_id: "286",
        },
        {
          id: "6982",
          name: "Krenglbach",
          state_id: "286",
        },
        {
          id: "6983",
          name: "Laakirchen",
          state_id: "286",
        },
        {
          id: "6984",
          name: "Lenzing",
          state_id: "286",
        },
        {
          id: "6985",
          name: "Leonding",
          state_id: "286",
        },
        {
          id: "6986",
          name: "Linz",
          state_id: "286",
        },
        {
          id: "6987",
          name: "Loibichl",
          state_id: "286",
        },
        {
          id: "6988",
          name: "Marchtrenk",
          state_id: "286",
        },
        {
          id: "6989",
          name: "Mattighofen",
          state_id: "286",
        },
        {
          id: "6990",
          name: "Mauthausen",
          state_id: "286",
        },
        {
          id: "6991",
          name: "Micheldorf",
          state_id: "286",
        },
        {
          id: "6992",
          name: "Neuhofen an der Krems",
          state_id: "286",
        },
        {
          id: "6993",
          name: "Ohlsdorf",
          state_id: "286",
        },
        {
          id: "6994",
          name: "Ottensheim",
          state_id: "286",
        },
        {
          id: "6995",
          name: "Pasching",
          state_id: "286",
        },
        {
          id: "6996",
          name: "Perg",
          state_id: "286",
        },
        {
          id: "6997",
          name: "Pettenbach",
          state_id: "286",
        },
        {
          id: "6998",
          name: "Pram",
          state_id: "286",
        },
        {
          id: "6999",
          name: "Pregarten",
          state_id: "286",
        },
        {
          id: "7000",
          name: "Puchenau",
          state_id: "286",
        },
        {
          id: "7001",
          name: "Regau",
          state_id: "286",
        },
        {
          id: "7002",
          name: "Ried",
          state_id: "286",
        },
        {
          id: "7003",
          name: "Rohrbach in Oberosterreich",
          state_id: "286",
        },
        {
          id: "7004",
          name: "Rutzenmoos",
          state_id: "286",
        },
        {
          id: "7005",
          name: "Sankt Florian",
          state_id: "286",
        },
        {
          id: "7006",
          name: "Sankt Georgen",
          state_id: "286",
        },
        {
          id: "7007",
          name: "Sankt Marien",
          state_id: "286",
        },
        {
          id: "7008",
          name: "Scharding",
          state_id: "286",
        },
        {
          id: "7009",
          name: "Scharnstein",
          state_id: "286",
        },
        {
          id: "7010",
          name: "Schwertberg",
          state_id: "286",
        },
        {
          id: "7011",
          name: "Seewalchen",
          state_id: "286",
        },
        {
          id: "7012",
          name: "Sierning",
          state_id: "286",
        },
        {
          id: "7013",
          name: "Stadl-Paura",
          state_id: "286",
        },
        {
          id: "7014",
          name: "Steyr",
          state_id: "286",
        },
        {
          id: "7015",
          name: "Steyregg",
          state_id: "286",
        },
        {
          id: "7016",
          name: "Steyrermuhl",
          state_id: "286",
        },
        {
          id: "7017",
          name: "Thalheim",
          state_id: "286",
        },
        {
          id: "7018",
          name: "Timelkam",
          state_id: "286",
        },
        {
          id: "7019",
          name: "Traun",
          state_id: "286",
        },
        {
          id: "7020",
          name: "Vocklabruck",
          state_id: "286",
        },
        {
          id: "7021",
          name: "Vocklamarkt",
          state_id: "286",
        },
        {
          id: "7022",
          name: "Vorchdorf",
          state_id: "286",
        },
        {
          id: "7023",
          name: "Wels",
          state_id: "286",
        },
        {
          id: "7024",
          name: "Wilhering",
          state_id: "286",
        },
      ],
      Salzburg: [
        {
          id: "7025",
          name: "Abtenau",
          state_id: "287",
        },
        {
          id: "7026",
          name: "Anif",
          state_id: "287",
        },
        {
          id: "7027",
          name: "Bad Gastein",
          state_id: "287",
        },
        {
          id: "7028",
          name: "Bad Hofgastein",
          state_id: "287",
        },
        {
          id: "7029",
          name: "Bergheim",
          state_id: "287",
        },
        {
          id: "7030",
          name: "Bischofshofen",
          state_id: "287",
        },
        {
          id: "7031",
          name: "Bruck an der GroBglocknerstraB",
          state_id: "287",
        },
        {
          id: "7032",
          name: "Burmoos",
          state_id: "287",
        },
        {
          id: "7033",
          name: "Elsbethen",
          state_id: "287",
        },
        {
          id: "7034",
          name: "Eugendorf",
          state_id: "287",
        },
        {
          id: "7035",
          name: "Forstau",
          state_id: "287",
        },
        {
          id: "7036",
          name: "Grodig",
          state_id: "287",
        },
        {
          id: "7037",
          name: "Hallein",
          state_id: "287",
        },
        {
          id: "7038",
          name: "Hallwang",
          state_id: "287",
        },
        {
          id: "7039",
          name: "Henndorf",
          state_id: "287",
        },
        {
          id: "7040",
          name: "Kuchl",
          state_id: "287",
        },
        {
          id: "7041",
          name: "Mayrhofen",
          state_id: "287",
        },
        {
          id: "7042",
          name: "Mittersill",
          state_id: "287",
        },
        {
          id: "7043",
          name: "Neumarkt",
          state_id: "287",
        },
        {
          id: "7044",
          name: "Oberndorf",
          state_id: "287",
        },
        {
          id: "7045",
          name: "Obertrum am See",
          state_id: "287",
        },
        {
          id: "7046",
          name: "Piesendorf",
          state_id: "287",
        },
        {
          id: "7047",
          name: "Puch",
          state_id: "287",
        },
        {
          id: "7048",
          name: "Radstadt",
          state_id: "287",
        },
        {
          id: "7049",
          name: "Saalfelden",
          state_id: "287",
        },
        {
          id: "7050",
          name: "Salzburg",
          state_id: "287",
        },
        {
          id: "7051",
          name: "Sankt Johann im Pongau",
          state_id: "287",
        },
        {
          id: "7052",
          name: "Seekirchen",
          state_id: "287",
        },
        {
          id: "7053",
          name: "Sieghartskirchen",
          state_id: "287",
        },
        {
          id: "7054",
          name: "StraBwalchen",
          state_id: "287",
        },
        {
          id: "7055",
          name: "Strobl",
          state_id: "287",
        },
        {
          id: "7056",
          name: "Tamsweg",
          state_id: "287",
        },
        {
          id: "7057",
          name: "Thalgau",
          state_id: "287",
        },
        {
          id: "7058",
          name: "Wals-Siezenheim",
          state_id: "287",
        },
        {
          id: "7059",
          name: "Wolfgangsee",
          state_id: "287",
        },
        {
          id: "7060",
          name: "Zell am See",
          state_id: "287",
        },
      ],
      "Schleswig-Holstein": [
        {
          id: "7061",
          name: "Albersdorf",
          state_id: "288",
        },
      ],
      Steiermark: [
        {
          id: "7062",
          name: "Bad Aussee",
          state_id: "289",
        },
        {
          id: "7063",
          name: "Barnbach",
          state_id: "289",
        },
        {
          id: "7064",
          name: "Bruck an der Mur",
          state_id: "289",
        },
        {
          id: "7065",
          name: "Deutschlandsberg",
          state_id: "289",
        },
        {
          id: "7066",
          name: "Eisenerz",
          state_id: "289",
        },
        {
          id: "7067",
          name: "Feldbach",
          state_id: "289",
        },
        {
          id: "7068",
          name: "Feldkirchen bei Graz",
          state_id: "289",
        },
        {
          id: "7069",
          name: "Fohnsdorf",
          state_id: "289",
        },
        {
          id: "7070",
          name: "Frohnleiten",
          state_id: "289",
        },
        {
          id: "7071",
          name: "Furstenfeld",
          state_id: "289",
        },
        {
          id: "7072",
          name: "Gleisdorf",
          state_id: "289",
        },
        {
          id: "7073",
          name: "Gratkorn",
          state_id: "289",
        },
        {
          id: "7074",
          name: "Graz",
          state_id: "289",
        },
        {
          id: "7075",
          name: "Hartberg",
          state_id: "289",
        },
        {
          id: "7076",
          name: "Judenburg",
          state_id: "289",
        },
        {
          id: "7077",
          name: "Judendorf-StraBengel",
          state_id: "289",
        },
        {
          id: "7078",
          name: "Kapfenberg",
          state_id: "289",
        },
        {
          id: "7079",
          name: "Karlsdorf",
          state_id: "289",
        },
        {
          id: "7080",
          name: "Kindberg",
          state_id: "289",
        },
        {
          id: "7081",
          name: "Knittelfeld",
          state_id: "289",
        },
        {
          id: "7082",
          name: "Koflach",
          state_id: "289",
        },
        {
          id: "7083",
          name: "Krieglach",
          state_id: "289",
        },
        {
          id: "7084",
          name: "Lannach",
          state_id: "289",
        },
        {
          id: "7085",
          name: "Leibnitz",
          state_id: "289",
        },
        {
          id: "7086",
          name: "Leoben",
          state_id: "289",
        },
        {
          id: "7087",
          name: "Liezen",
          state_id: "289",
        },
        {
          id: "7088",
          name: "Murzzuschlag",
          state_id: "289",
        },
        {
          id: "7089",
          name: "Rottenmann",
          state_id: "289",
        },
        {
          id: "7090",
          name: "Schladming",
          state_id: "289",
        },
        {
          id: "7091",
          name: "Seiersberg",
          state_id: "289",
        },
        {
          id: "7092",
          name: "Spielberg",
          state_id: "289",
        },
        {
          id: "7093",
          name: "Trofaiach",
          state_id: "289",
        },
        {
          id: "7094",
          name: "Voitsberg",
          state_id: "289",
        },
        {
          id: "7095",
          name: "Wagna",
          state_id: "289",
        },
        {
          id: "7096",
          name: "Weiz",
          state_id: "289",
        },
        {
          id: "7097",
          name: "Zeltweg",
          state_id: "289",
        },
      ],
      Styria: [
        {
          id: "7098",
          name: "Deutschfeistritz",
          state_id: "290",
        },
        {
          id: "7099",
          name: "Liezen",
          state_id: "290",
        },
        {
          id: "7100",
          name: "Sankt Bartholoma",
          state_id: "290",
        },
      ],
      Tirol: [
        {
          id: "7101",
          name: "Absam",
          state_id: "291",
        },
        {
          id: "7102",
          name: "Axams",
          state_id: "291",
        },
        {
          id: "7103",
          name: "Ebbs",
          state_id: "291",
        },
        {
          id: "7104",
          name: "Fugen",
          state_id: "291",
        },
        {
          id: "7105",
          name: "Hall",
          state_id: "291",
        },
        {
          id: "7106",
          name: "Haselgehr",
          state_id: "291",
        },
        {
          id: "7107",
          name: "Hopfgarten",
          state_id: "291",
        },
        {
          id: "7108",
          name: "Imst",
          state_id: "291",
        },
        {
          id: "7109",
          name: "Innsbruck",
          state_id: "291",
        },
        {
          id: "7110",
          name: "Jenbach",
          state_id: "291",
        },
        {
          id: "7111",
          name: "Kirchberg",
          state_id: "291",
        },
        {
          id: "7112",
          name: "Kirchbichl",
          state_id: "291",
        },
        {
          id: "7113",
          name: "Kitzbuhel",
          state_id: "291",
        },
        {
          id: "7114",
          name: "Kramsach",
          state_id: "291",
        },
        {
          id: "7115",
          name: "Kufstein",
          state_id: "291",
        },
        {
          id: "7116",
          name: "Landeck",
          state_id: "291",
        },
        {
          id: "7117",
          name: "Lienz",
          state_id: "291",
        },
        {
          id: "7118",
          name: "Matrei",
          state_id: "291",
        },
        {
          id: "7119",
          name: "Neustift im Stubaital",
          state_id: "291",
        },
        {
          id: "7120",
          name: "Reutte",
          state_id: "291",
        },
        {
          id: "7121",
          name: "Rum",
          state_id: "291",
        },
        {
          id: "7122",
          name: "Sankt Johann in Tirol",
          state_id: "291",
        },
        {
          id: "7123",
          name: "Scheffau",
          state_id: "291",
        },
        {
          id: "7124",
          name: "Schwaz",
          state_id: "291",
        },
        {
          id: "7125",
          name: "St. Johann Am Walde",
          state_id: "291",
        },
        {
          id: "7126",
          name: "Telfs",
          state_id: "291",
        },
        {
          id: "7127",
          name: "Vols",
          state_id: "291",
        },
        {
          id: "7128",
          name: "Vomp",
          state_id: "291",
        },
        {
          id: "7129",
          name: "Wattens",
          state_id: "291",
        },
        {
          id: "7130",
          name: "Worgl",
          state_id: "291",
        },
        {
          id: "7131",
          name: "Zirl",
          state_id: "291",
        },
      ],
      "Upper Austria": [],
      Vorarlberg: [
        {
          id: "7132",
          name: "Altach",
          state_id: "293",
        },
        {
          id: "7133",
          name: "Bludenz",
          state_id: "293",
        },
        {
          id: "7134",
          name: "Bregenz",
          state_id: "293",
        },
        {
          id: "7135",
          name: "Chassieu",
          state_id: "293",
        },
        {
          id: "7136",
          name: "Dietmannsried",
          state_id: "293",
        },
        {
          id: "7137",
          name: "Dornbirn",
          state_id: "293",
        },
        {
          id: "7138",
          name: "Feldkirch",
          state_id: "293",
        },
        {
          id: "7139",
          name: "Frastanz",
          state_id: "293",
        },
        {
          id: "7140",
          name: "Gotzis",
          state_id: "293",
        },
        {
          id: "7141",
          name: "Hard",
          state_id: "293",
        },
        {
          id: "7142",
          name: "Hochst",
          state_id: "293",
        },
        {
          id: "7143",
          name: "Hohenems",
          state_id: "293",
        },
        {
          id: "7144",
          name: "Horbranz",
          state_id: "293",
        },
        {
          id: "7145",
          name: "Hufingen",
          state_id: "293",
        },
        {
          id: "7146",
          name: "Lauterach",
          state_id: "293",
        },
        {
          id: "7147",
          name: "Lochau",
          state_id: "293",
        },
        {
          id: "7148",
          name: "Lustenau",
          state_id: "293",
        },
        {
          id: "7149",
          name: "Mittelberg",
          state_id: "293",
        },
        {
          id: "7150",
          name: "Nenzing",
          state_id: "293",
        },
        {
          id: "7151",
          name: "Nuziders",
          state_id: "293",
        },
        {
          id: "7152",
          name: "Rankweil",
          state_id: "293",
        },
        {
          id: "7153",
          name: "Schruns",
          state_id: "293",
        },
        {
          id: "7154",
          name: "Thuringen",
          state_id: "293",
        },
        {
          id: "7155",
          name: "Wolfurt",
          state_id: "293",
        },
      ],
      Wien: [
        {
          id: "7156",
          name: "Vienna",
          state_id: "294",
        },
        {
          id: "7157",
          name: "Wien",
          state_id: "294",
        },
      ],
    },
  },
  AU: {
    name: "Australia",
    native: "Australia",
    phone: "61",
    continent: "OC",
    capital: "Canberra",
    currency: "AUD",
    languages: ["en"],
    emoji: "🇦🇺",
    emojiU: "U+1F1E6 U+1F1FA",
    states: {
      "Australian Capital Territory": [],
      "New South Wales": [
        {
          id: "48400",
          name: "Balgolah",
          state_id: "266",
        },
        {
          id: "48401",
          name: "Balmain",
          state_id: "266",
        },
        {
          id: "48402",
          name: "Bankstown",
          state_id: "266",
        },
        {
          id: "48403",
          name: "Baulkham Hills",
          state_id: "266",
        },
        {
          id: "48404",
          name: "Bonnet Bay",
          state_id: "266",
        },
        {
          id: "48406",
          name: "Castle Hill",
          state_id: "266",
        },
        {
          id: "48407",
          name: "Chatswood",
          state_id: "266",
        },
        {
          id: "48408",
          name: "Cherrybrook",
          state_id: "266",
        },
        {
          id: "48414",
          name: "Frenchs Forest",
          state_id: "266",
        },
        {
          id: "48416",
          name: "Jannali",
          state_id: "266",
        },
        {
          id: "48421",
          name: "Wheeler",
          state_id: "266",
        },
      ],
      "Northern Territory": [],
      Queensland: [
        {
          id: "6579",
          name: "Acacia Ridge",
          state_id: "269",
        },
        {
          id: "6580",
          name: "Aitkenvale",
          state_id: "269",
        },
        {
          id: "6581",
          name: "Alderley",
          state_id: "269",
        },
        {
          id: "6582",
          name: "Alexander Hills",
          state_id: "269",
        },
        {
          id: "6583",
          name: "Archerfield",
          state_id: "269",
        },
        {
          id: "6584",
          name: "Ashmore",
          state_id: "269",
        },
        {
          id: "6585",
          name: "Atherton",
          state_id: "269",
        },
        {
          id: "6586",
          name: "Ayr",
          state_id: "269",
        },
        {
          id: "6587",
          name: "Beachmere",
          state_id: "269",
        },
        {
          id: "6588",
          name: "Beenleigh",
          state_id: "269",
        },
        {
          id: "6589",
          name: "Beerwah",
          state_id: "269",
        },
        {
          id: "6590",
          name: "Bell",
          state_id: "269",
        },
        {
          id: "6591",
          name: "Belmont",
          state_id: "269",
        },
        {
          id: "6592",
          name: "Biloela",
          state_id: "269",
        },
        {
          id: "6593",
          name: "Birkdale",
          state_id: "269",
        },
        {
          id: "6594",
          name: "Blackwater",
          state_id: "269",
        },
        {
          id: "6595",
          name: "Bongaree",
          state_id: "269",
        },
        {
          id: "6596",
          name: "Bonogin",
          state_id: "269",
        },
        {
          id: "6597",
          name: "Boonah",
          state_id: "269",
        },
        {
          id: "6598",
          name: "Bowen",
          state_id: "269",
        },
        {
          id: "6599",
          name: "Brendale",
          state_id: "269",
        },
        {
          id: "6600",
          name: "Brisbane",
          state_id: "269",
        },
        {
          id: "6601",
          name: "Buddina",
          state_id: "269",
        },
        {
          id: "6602",
          name: "Buderim",
          state_id: "269",
        },
        {
          id: "6603",
          name: "Bundaberg",
          state_id: "269",
        },
        {
          id: "6604",
          name: "Bundall",
          state_id: "269",
        },
        {
          id: "6605",
          name: "Burleigh Heads",
          state_id: "269",
        },
        {
          id: "6606",
          name: "Burpengary",
          state_id: "269",
        },
        {
          id: "6607",
          name: "Cabaland",
          state_id: "269",
        },
        {
          id: "6608",
          name: "Caboolture",
          state_id: "269",
        },
        {
          id: "6609",
          name: "Cairns",
          state_id: "269",
        },
        {
          id: "6610",
          name: "Cairns Northern Beaches",
          state_id: "269",
        },
        {
          id: "6611",
          name: "Caloundra",
          state_id: "269",
        },
        {
          id: "6612",
          name: "Capalaba",
          state_id: "269",
        },
        {
          id: "6613",
          name: "Charters Towers",
          state_id: "269",
        },
        {
          id: "6614",
          name: "Childers",
          state_id: "269",
        },
        {
          id: "6615",
          name: "Cleveland",
          state_id: "269",
        },
        {
          id: "6616",
          name: "Coolum Beach",
          state_id: "269",
        },
        {
          id: "6617",
          name: "Coopers Plain",
          state_id: "269",
        },
        {
          id: "6618",
          name: "Dalby",
          state_id: "269",
        },
        {
          id: "6619",
          name: "Deception Bay",
          state_id: "269",
        },
        {
          id: "6620",
          name: "Eagle Farm",
          state_id: "269",
        },
        {
          id: "6621",
          name: "Eagleby",
          state_id: "269",
        },
        {
          id: "6622",
          name: "Emerald",
          state_id: "269",
        },
        {
          id: "6623",
          name: "Emundi",
          state_id: "269",
        },
        {
          id: "6624",
          name: "Forest Lake",
          state_id: "269",
        },
        {
          id: "6625",
          name: "Gatton",
          state_id: "269",
        },
        {
          id: "6626",
          name: "Gladstone",
          state_id: "269",
        },
        {
          id: "6627",
          name: "Gold Coast",
          state_id: "269",
        },
        {
          id: "6629",
          name: "Gympie",
          state_id: "269",
        },
        {
          id: "6630",
          name: "Helensvale",
          state_id: "269",
        },
        {
          id: "6631",
          name: "Hervey Bay",
          state_id: "269",
        },
        {
          id: "6632",
          name: "Ingham",
          state_id: "269",
        },
        {
          id: "6633",
          name: "Innisfail",
          state_id: "269",
        },
        {
          id: "6634",
          name: "Ipswich",
          state_id: "269",
        },
        {
          id: "6635",
          name: "Jindalee",
          state_id: "269",
        },
        {
          id: "6636",
          name: "Julatten",
          state_id: "269",
        },
        {
          id: "6637",
          name: "Kawana Waters",
          state_id: "269",
        },
        {
          id: "6638",
          name: "Kingaroy",
          state_id: "269",
        },
        {
          id: "6639",
          name: "Lawnton",
          state_id: "269",
        },
        {
          id: "6640",
          name: "Loganholme",
          state_id: "269",
        },
        {
          id: "6641",
          name: "Mackay",
          state_id: "269",
        },
        {
          id: "6642",
          name: "Mareeba",
          state_id: "269",
        },
        {
          id: "6643",
          name: "Maroochydore",
          state_id: "269",
        },
        {
          id: "6644",
          name: "Maroochydore-Mooloolaba",
          state_id: "269",
        },
        {
          id: "6645",
          name: "Maryborough",
          state_id: "269",
        },
        {
          id: "6646",
          name: "Miami",
          state_id: "269",
        },
        {
          id: "6647",
          name: "Milton",
          state_id: "269",
        },
        {
          id: "6648",
          name: "Molendinar",
          state_id: "269",
        },
        {
          id: "6649",
          name: "Moranbah",
          state_id: "269",
        },
        {
          id: "6650",
          name: "Morayfield",
          state_id: "269",
        },
        {
          id: "6651",
          name: "Mossman",
          state_id: "269",
        },
        {
          id: "6652",
          name: "Mount Glorious",
          state_id: "269",
        },
        {
          id: "6653",
          name: "Mount Isa",
          state_id: "269",
        },
        {
          id: "6654",
          name: "Murarrie",
          state_id: "269",
        },
        {
          id: "6655",
          name: "Nairand Kay",
          state_id: "269",
        },
        {
          id: "6656",
          name: "Nambour",
          state_id: "269",
        },
        {
          id: "6657",
          name: "Nerang",
          state_id: "269",
        },
        {
          id: "6658",
          name: "Nobby Beach",
          state_id: "269",
        },
        {
          id: "6659",
          name: "Noosa Heads",
          state_id: "269",
        },
        {
          id: "6660",
          name: "Noosaville",
          state_id: "269",
        },
        {
          id: "6661",
          name: "Paddington",
          state_id: "269",
        },
        {
          id: "6662",
          name: "Port Douglas",
          state_id: "269",
        },
        {
          id: "6663",
          name: "Robina",
          state_id: "269",
        },
        {
          id: "6664",
          name: "Rockhampton",
          state_id: "269",
        },
        {
          id: "6665",
          name: "Rocklea",
          state_id: "269",
        },
        {
          id: "6666",
          name: "Roma",
          state_id: "269",
        },
        {
          id: "6667",
          name: "Rubyvale",
          state_id: "269",
        },
        {
          id: "6668",
          name: "Sanctuary Cove",
          state_id: "269",
        },
        {
          id: "6669",
          name: "Slade Point",
          state_id: "269",
        },
        {
          id: "6670",
          name: "Southport",
          state_id: "269",
        },
        {
          id: "6671",
          name: "Suburb",
          state_id: "269",
        },
        {
          id: "6672",
          name: "Sunshine Coast",
          state_id: "269",
        },
        {
          id: "6673",
          name: "Tewantin-Noosa",
          state_id: "269",
        },
        {
          id: "6674",
          name: "The Summit",
          state_id: "269",
        },
        {
          id: "6675",
          name: "Toowong",
          state_id: "269",
        },
        {
          id: "6676",
          name: "Toowoomba",
          state_id: "269",
        },
        {
          id: "6677",
          name: "Townsville",
          state_id: "269",
        },
        {
          id: "6678",
          name: "Victoria Point",
          state_id: "269",
        },
        {
          id: "6679",
          name: "Warwick",
          state_id: "269",
        },
        {
          id: "6680",
          name: "Willawong",
          state_id: "269",
        },
        {
          id: "6681",
          name: "Yatala",
          state_id: "269",
        },
        {
          id: "6682",
          name: "Yeppoon",
          state_id: "269",
        },
        {
          id: "6683",
          name: "Zillmere",
          state_id: "269",
        },
        {
          id: "48405",
          name: "Carole Park",
          state_id: "269",
        },
      ],
      "South Australia": [],
      Tasmania: [
        {
          id: "6684",
          name: "Bridgewater-Gagebrook",
          state_id: "271",
        },
        {
          id: "6685",
          name: "Burnie",
          state_id: "271",
        },
        {
          id: "6686",
          name: "Burnie-Devonport",
          state_id: "271",
        },
        {
          id: "6687",
          name: "Glenorchy",
          state_id: "271",
        },
        {
          id: "6688",
          name: "Hobart",
          state_id: "271",
        },
        {
          id: "6689",
          name: "Kingston-Blackmans Bay",
          state_id: "271",
        },
        {
          id: "6690",
          name: "Launceston",
          state_id: "271",
        },
        {
          id: "6691",
          name: "New Norfolk",
          state_id: "271",
        },
        {
          id: "6692",
          name: "Rowella",
          state_id: "271",
        },
        {
          id: "6693",
          name: "Sheffield",
          state_id: "271",
        },
        {
          id: "6694",
          name: "Ulverstone",
          state_id: "271",
        },
      ],
      Victoria: [
        {
          id: "6696",
          name: "Albion",
          state_id: "273",
        },
        {
          id: "6697",
          name: "Ararat",
          state_id: "273",
        },
        {
          id: "6698",
          name: "Avenel",
          state_id: "273",
        },
        {
          id: "6699",
          name: "Avondale Heights",
          state_id: "273",
        },
        {
          id: "6700",
          name: "Baccus Marsh",
          state_id: "273",
        },
        {
          id: "6701",
          name: "Bairnsdale",
          state_id: "273",
        },
        {
          id: "6702",
          name: "Ballarat",
          state_id: "273",
        },
        {
          id: "6703",
          name: "Balwyn",
          state_id: "273",
        },
        {
          id: "6704",
          name: "Batman",
          state_id: "273",
        },
        {
          id: "6705",
          name: "Bayswater",
          state_id: "273",
        },
        {
          id: "6706",
          name: "Belmont",
          state_id: "273",
        },
        {
          id: "6707",
          name: "Benalla",
          state_id: "273",
        },
        {
          id: "6708",
          name: "Bendigo",
          state_id: "273",
        },
        {
          id: "6709",
          name: "Bentleigh East",
          state_id: "273",
        },
        {
          id: "6710",
          name: "Berwick",
          state_id: "273",
        },
        {
          id: "6711",
          name: "Blackburn",
          state_id: "273",
        },
        {
          id: "6712",
          name: "Blue Mountains",
          state_id: "273",
        },
        {
          id: "6713",
          name: "Boonah",
          state_id: "273",
        },
        {
          id: "6714",
          name: "Boronia",
          state_id: "273",
        },
        {
          id: "6715",
          name: "Box Hill",
          state_id: "273",
        },
        {
          id: "6716",
          name: "Brighton East",
          state_id: "273",
        },
        {
          id: "6717",
          name: "Bundoora",
          state_id: "273",
        },
        {
          id: "6718",
          name: "Campbellfield",
          state_id: "273",
        },
        {
          id: "6719",
          name: "Carlton South",
          state_id: "273",
        },
        {
          id: "6720",
          name: "Caroline Springs",
          state_id: "273",
        },
        {
          id: "6721",
          name: "Castle Hill",
          state_id: "273",
        },
        {
          id: "6722",
          name: "Castlemaine",
          state_id: "273",
        },
        {
          id: "6723",
          name: "Caulfield",
          state_id: "273",
        },
        {
          id: "6724",
          name: "Cheltenham",
          state_id: "273",
        },
        {
          id: "6725",
          name: "Chester",
          state_id: "273",
        },
        {
          id: "6726",
          name: "Clayton South",
          state_id: "273",
        },
        {
          id: "6727",
          name: "Clifton Springs",
          state_id: "273",
        },
        {
          id: "6728",
          name: "Coburg",
          state_id: "273",
        },
        {
          id: "6729",
          name: "Colac",
          state_id: "273",
        },
        {
          id: "6730",
          name: "Collingwood",
          state_id: "273",
        },
        {
          id: "6731",
          name: "Craigieburn",
          state_id: "273",
        },
        {
          id: "6732",
          name: "Cranbourne",
          state_id: "273",
        },
        {
          id: "6733",
          name: "Crib Point",
          state_id: "273",
        },
        {
          id: "6734",
          name: "Dandenong",
          state_id: "273",
        },
        {
          id: "6735",
          name: "Devon Meadows",
          state_id: "273",
        },
        {
          id: "6736",
          name: "Diamond Creek",
          state_id: "273",
        },
        {
          id: "6737",
          name: "Doncaster East",
          state_id: "273",
        },
        {
          id: "6738",
          name: "Doncester",
          state_id: "273",
        },
        {
          id: "6739",
          name: "Donvale",
          state_id: "273",
        },
        {
          id: "6740",
          name: "Echuca-Moama",
          state_id: "273",
        },
        {
          id: "6741",
          name: "Elsternwick",
          state_id: "273",
        },
        {
          id: "6742",
          name: "Eltham",
          state_id: "273",
        },
        {
          id: "6743",
          name: "Fairfield",
          state_id: "273",
        },
        {
          id: "6744",
          name: "Fitzroy",
          state_id: "273",
        },
        {
          id: "6745",
          name: "Frnakston",
          state_id: "273",
        },
        {
          id: "6746",
          name: "Geelong",
          state_id: "273",
        },
        {
          id: "6747",
          name: "Glen Waverley",
          state_id: "273",
        },
        {
          id: "6748",
          name: "Glenorchy",
          state_id: "273",
        },
        {
          id: "6749",
          name: "Hallam",
          state_id: "273",
        },
        {
          id: "6750",
          name: "Hamilton",
          state_id: "273",
        },
        {
          id: "6751",
          name: "Hastings",
          state_id: "273",
        },
        {
          id: "6752",
          name: "Healesville",
          state_id: "273",
        },
        {
          id: "6753",
          name: "Horsham",
          state_id: "273",
        },
        {
          id: "6754",
          name: "Hughesdale",
          state_id: "273",
        },
        {
          id: "6755",
          name: "Ivanhoe",
          state_id: "273",
        },
        {
          id: "6756",
          name: "Keilor",
          state_id: "273",
        },
        {
          id: "6757",
          name: "Kensington",
          state_id: "273",
        },
        {
          id: "6758",
          name: "Kerang",
          state_id: "273",
        },
        {
          id: "6759",
          name: "Kilmore",
          state_id: "273",
        },
        {
          id: "6760",
          name: "Kilsyth",
          state_id: "273",
        },
        {
          id: "6761",
          name: "Kyabram",
          state_id: "273",
        },
        {
          id: "6762",
          name: "Lakes Entrance",
          state_id: "273",
        },
        {
          id: "6763",
          name: "Lalor",
          state_id: "273",
        },
        {
          id: "6764",
          name: "Lara",
          state_id: "273",
        },
        {
          id: "6765",
          name: "Laverton North",
          state_id: "273",
        },
        {
          id: "6766",
          name: "Leopold",
          state_id: "273",
        },
        {
          id: "6767",
          name: "Lower Templestowe",
          state_id: "273",
        },
        {
          id: "6768",
          name: "Maidstone",
          state_id: "273",
        },
        {
          id: "6769",
          name: "Malvern",
          state_id: "273",
        },
        {
          id: "6770",
          name: "Maryborough",
          state_id: "273",
        },
        {
          id: "6771",
          name: "Melbourne",
          state_id: "273",
        },
        {
          id: "6772",
          name: "Melton",
          state_id: "273",
        },
        {
          id: "6773",
          name: "Middle Park",
          state_id: "273",
        },
        {
          id: "6774",
          name: "Mildura",
          state_id: "273",
        },
        {
          id: "6775",
          name: "Mitcham",
          state_id: "273",
        },
        {
          id: "6776",
          name: "Moe-Yallourn",
          state_id: "273",
        },
        {
          id: "6777",
          name: "Moorabbin",
          state_id: "273",
        },
        {
          id: "6778",
          name: "Mordialloc",
          state_id: "273",
        },
        {
          id: "6779",
          name: "Morwell",
          state_id: "273",
        },
        {
          id: "6780",
          name: "Mulgrave",
          state_id: "273",
        },
        {
          id: "6781",
          name: "Murrumbeena",
          state_id: "273",
        },
        {
          id: "6782",
          name: "Neerim South",
          state_id: "273",
        },
        {
          id: "6783",
          name: "Noble Park North",
          state_id: "273",
        },
        {
          id: "6784",
          name: "Notting Hill",
          state_id: "273",
        },
        {
          id: "6785",
          name: "Oak Park",
          state_id: "273",
        },
        {
          id: "6786",
          name: "Ocean Grove-Barwon Heads",
          state_id: "273",
        },
        {
          id: "6787",
          name: "Olinda",
          state_id: "273",
        },
        {
          id: "6788",
          name: "Pakenham",
          state_id: "273",
        },
        {
          id: "6789",
          name: "Park Orchards",
          state_id: "273",
        },
        {
          id: "6790",
          name: "Port Melbourne",
          state_id: "273",
        },
        {
          id: "6791",
          name: "Portland",
          state_id: "273",
        },
        {
          id: "6792",
          name: "Prahran",
          state_id: "273",
        },
        {
          id: "6793",
          name: "Preston",
          state_id: "273",
        },
        {
          id: "6794",
          name: "Pritbourne",
          state_id: "273",
        },
        {
          id: "6795",
          name: "Queenscliff",
          state_id: "273",
        },
        {
          id: "6796",
          name: "Reservoir",
          state_id: "273",
        },
        {
          id: "6797",
          name: "Ringwood",
          state_id: "273",
        },
        {
          id: "6798",
          name: "Rowville",
          state_id: "273",
        },
        {
          id: "6799",
          name: "Sale",
          state_id: "273",
        },
        {
          id: "6800",
          name: "Sandringham",
          state_id: "273",
        },
        {
          id: "6801",
          name: "Scoresby",
          state_id: "273",
        },
        {
          id: "6802",
          name: "Sebastopol",
          state_id: "273",
        },
        {
          id: "6803",
          name: "Seymour",
          state_id: "273",
        },
        {
          id: "6804",
          name: "Shepparton-Mooroopna",
          state_id: "273",
        },
        {
          id: "6805",
          name: "Somerville",
          state_id: "273",
        },
        {
          id: "6806",
          name: "South Yarra",
          state_id: "273",
        },
        {
          id: "6807",
          name: "Southbank",
          state_id: "273",
        },
        {
          id: "6808",
          name: "St. Albans",
          state_id: "273",
        },
        {
          id: "6809",
          name: "St. Kilda East",
          state_id: "273",
        },
        {
          id: "6810",
          name: "Stawell",
          state_id: "273",
        },
        {
          id: "6811",
          name: "Sunbury",
          state_id: "273",
        },
        {
          id: "6812",
          name: "Sunshine West",
          state_id: "273",
        },
        {
          id: "6813",
          name: "Swan Hill",
          state_id: "273",
        },
        {
          id: "6814",
          name: "Tatura",
          state_id: "273",
        },
        {
          id: "6815",
          name: "Thomastown",
          state_id: "273",
        },
        {
          id: "6816",
          name: "Thornbury",
          state_id: "273",
        },
        {
          id: "6817",
          name: "Tongala",
          state_id: "273",
        },
        {
          id: "6818",
          name: "Torquay",
          state_id: "273",
        },
        {
          id: "6819",
          name: "Traralgon",
          state_id: "273",
        },
        {
          id: "6820",
          name: "Tullamarine",
          state_id: "273",
        },
        {
          id: "6821",
          name: "Vermont",
          state_id: "273",
        },
        {
          id: "6822",
          name: "Wangaratta",
          state_id: "273",
        },
        {
          id: "6823",
          name: "Wantirna",
          state_id: "273",
        },
        {
          id: "6824",
          name: "Warragul",
          state_id: "273",
        },
        {
          id: "6825",
          name: "Warrnambool",
          state_id: "273",
        },
        {
          id: "6826",
          name: "Welshpool",
          state_id: "273",
        },
        {
          id: "6827",
          name: "Wendouree",
          state_id: "273",
        },
        {
          id: "6828",
          name: "Wonthaggi",
          state_id: "273",
        },
        {
          id: "6829",
          name: "Woodend",
          state_id: "273",
        },
        {
          id: "6830",
          name: "Yarrawonga-Mulwala",
          state_id: "273",
        },
        {
          id: "6831",
          name: "Yea",
          state_id: "273",
        },
        {
          id: "48409",
          name: "Clayton",
          state_id: "273",
        },
        {
          id: "48410",
          name: "Camberwell",
          state_id: "273",
        },
        {
          id: "48411",
          name: "Caulfield",
          state_id: "273",
        },
        {
          id: "48412",
          name: "Cheltenham",
          state_id: "273",
        },
        {
          id: "48413",
          name: "Collingwood",
          state_id: "273",
        },
        {
          id: "48415",
          name: "Hawthorn",
          state_id: "273",
        },
        {
          id: "48417",
          name: "Knoxfield",
          state_id: "273",
        },
        {
          id: "48418",
          name: "Melbourne",
          state_id: "273",
        },
        {
          id: "48419",
          name: "Templestowe",
          state_id: "273",
        },
        {
          id: "48420",
          name: "Werribee South",
          state_id: "273",
        },
        {
          id: "48422",
          name: "Balwyn North",
          state_id: "273",
        },
        {
          id: "48423",
          name: "Balwyn East",
          state_id: "273",
        },
        {
          id: "48425",
          name: "Croydon",
          state_id: "273",
        },
      ],
      "Western Australia": [
        {
          id: "48424",
          name: "Perth",
          state_id: "275",
        },
      ],
    },
  },
  AW: {
    name: "Aruba",
    native: "Aruba",
    phone: "297",
    continent: "NA",
    capital: "Oranjestad",
    currency: "AWG",
    languages: ["nl", "pa"],
    emoji: "🇦🇼",
    emojiU: "U+1F1E6 U+1F1FC",
    states: {
      Aruba: [
        {
          id: "6554",
          name: "Aruba",
          state_id: "244",
        },
      ],
    },
  },
  AX: {
    name: "Åland",
    native: "Åland",
    phone: "358",
    continent: "EU",
    capital: "Mariehamn",
    currency: "EUR",
    languages: ["sv"],
    emoji: "🇦🇽",
    emojiU: "U+1F1E6 U+1F1FD",
    states: {},
  },
  AZ: {
    name: "Azerbaijan",
    native: "Azərbaycan",
    phone: "994",
    continent: "AS",
    capital: "Baku",
    currency: "AZN",
    languages: ["az"],
    emoji: "🇦🇿",
    emojiU: "U+1F1E6 U+1F1FF",
    states: {
      Abseron: [
        {
          id: "7158",
          name: "Alat",
          state_id: "295",
        },
        {
          id: "7159",
          name: "Artyom",
          state_id: "295",
        },
        {
          id: "7160",
          name: "Baki",
          state_id: "295",
        },
        {
          id: "7161",
          name: "Bakixanov",
          state_id: "295",
        },
        {
          id: "7162",
          name: "Balaxani",
          state_id: "295",
        },
        {
          id: "7163",
          name: "Bilacari",
          state_id: "295",
        },
        {
          id: "7164",
          name: "Bilqax",
          state_id: "295",
        },
        {
          id: "7165",
          name: "Bina",
          state_id: "295",
        },
        {
          id: "7166",
          name: "Buzovna",
          state_id: "295",
        },
        {
          id: "7167",
          name: "Haci Zeynalabdin",
          state_id: "295",
        },
        {
          id: "7168",
          name: "Hovsan",
          state_id: "295",
        },
        {
          id: "7169",
          name: "Lokbatan",
          state_id: "295",
        },
        {
          id: "7170",
          name: "Mastaga",
          state_id: "295",
        },
        {
          id: "7171",
          name: "Puta",
          state_id: "295",
        },
        {
          id: "7172",
          name: "Qarasuxur",
          state_id: "295",
        },
        {
          id: "7173",
          name: "Qobustan",
          state_id: "295",
        },
        {
          id: "7174",
          name: "Rasulzada",
          state_id: "295",
        },
        {
          id: "7175",
          name: "Sabuncu",
          state_id: "295",
        },
        {
          id: "7176",
          name: "Sanqacal",
          state_id: "295",
        },
        {
          id: "7177",
          name: "Sumqayit",
          state_id: "295",
        },
        {
          id: "7178",
          name: "Suraxani",
          state_id: "295",
        },
        {
          id: "7179",
          name: "Xirdalan",
          state_id: "295",
        },
        {
          id: "7180",
          name: "Zirya",
          state_id: "295",
        },
      ],
      "Baki Sahari": [],
      Ganca: [
        {
          id: "7181",
          name: "Daskasan",
          state_id: "297",
        },
        {
          id: "7182",
          name: "Ganca",
          state_id: "297",
        },
        {
          id: "7183",
          name: "Xanlar",
          state_id: "297",
        },
      ],
      Ganja: [
        {
          id: "7184",
          name: "Ganja",
          state_id: "298",
        },
      ],
      Kalbacar: [
        {
          id: "7185",
          name: "Cabrayil",
          state_id: "299",
        },
        {
          id: "7186",
          name: "Kalbacar",
          state_id: "299",
        },
        {
          id: "7187",
          name: "Lacin",
          state_id: "299",
        },
      ],
      Lankaran: [
        {
          id: "7188",
          name: "Astara",
          state_id: "300",
        },
        {
          id: "7189",
          name: "Goytapa",
          state_id: "300",
        },
        {
          id: "7190",
          name: "Lankaran",
          state_id: "300",
        },
        {
          id: "7191",
          name: "Masalli",
          state_id: "300",
        },
        {
          id: "7192",
          name: "Neftcala",
          state_id: "300",
        },
      ],
      "Mil-Qarabax": [
        {
          id: "7193",
          name: "Agcabadi",
          state_id: "301",
        },
        {
          id: "7194",
          name: "Agdam",
          state_id: "301",
        },
        {
          id: "7195",
          name: "Barda",
          state_id: "301",
        },
        {
          id: "7196",
          name: "Mingacevir",
          state_id: "301",
        },
        {
          id: "7197",
          name: "Tartar",
          state_id: "301",
        },
        {
          id: "7198",
          name: "Yevlax",
          state_id: "301",
        },
      ],
      "Mugan-Salyan": [
        {
          id: "7199",
          name: "Ali Bayramli",
          state_id: "302",
        },
        {
          id: "7200",
          name: "Bilasuvar",
          state_id: "302",
        },
        {
          id: "7201",
          name: "Calilabad",
          state_id: "302",
        },
        {
          id: "7202",
          name: "Qarasu",
          state_id: "302",
        },
        {
          id: "7203",
          name: "Qazimammad",
          state_id: "302",
        },
        {
          id: "7204",
          name: "Saatli",
          state_id: "302",
        },
        {
          id: "7205",
          name: "Sabirabad",
          state_id: "302",
        },
        {
          id: "7206",
          name: "Salyan",
          state_id: "302",
        },
      ],
      "Nagorni-Qarabax": [
        {
          id: "7207",
          name: "Susa",
          state_id: "303",
        },
        {
          id: "7208",
          name: "Xankandi",
          state_id: "303",
        },
        {
          id: "7209",
          name: "Xocavand",
          state_id: "303",
        },
      ],
      Naxcivan: [
        {
          id: "7210",
          name: "Culfa",
          state_id: "304",
        },
        {
          id: "7211",
          name: "Naxcivan",
          state_id: "304",
        },
        {
          id: "7212",
          name: "Ordubad",
          state_id: "304",
        },
        {
          id: "7213",
          name: "Sadarak",
          state_id: "304",
        },
        {
          id: "7214",
          name: "Sarur",
          state_id: "304",
        },
      ],
      Priaraks: [
        {
          id: "7215",
          name: "Beylaqan",
          state_id: "305",
        },
        {
          id: "7216",
          name: "Fuzuli",
          state_id: "305",
        },
        {
          id: "7217",
          name: "Imisli",
          state_id: "305",
        },
      ],
      Qazax: [
        {
          id: "7218",
          name: "Agstafa",
          state_id: "306",
        },
        {
          id: "7219",
          name: "Gadabay",
          state_id: "306",
        },
        {
          id: "7220",
          name: "Kovlar",
          state_id: "306",
        },
        {
          id: "7221",
          name: "Qaracamirli",
          state_id: "306",
        },
        {
          id: "7222",
          name: "Qazax",
          state_id: "306",
        },
        {
          id: "7223",
          name: "Samkir",
          state_id: "306",
        },
        {
          id: "7224",
          name: "Tovuz",
          state_id: "306",
        },
      ],
      Saki: [
        {
          id: "7225",
          name: "Amircan",
          state_id: "307",
        },
        {
          id: "7226",
          name: "Balakan",
          state_id: "307",
        },
        {
          id: "7227",
          name: "Katex",
          state_id: "307",
        },
        {
          id: "7228",
          name: "Oguz",
          state_id: "307",
        },
        {
          id: "7229",
          name: "Qabala",
          state_id: "307",
        },
        {
          id: "7230",
          name: "Qax",
          state_id: "307",
        },
        {
          id: "7231",
          name: "Saki",
          state_id: "307",
        },
        {
          id: "7232",
          name: "Zaqatala",
          state_id: "307",
        },
      ],
      Sirvan: [
        {
          id: "7233",
          name: "Agdas",
          state_id: "308",
        },
        {
          id: "7234",
          name: "Agsu",
          state_id: "308",
        },
        {
          id: "7235",
          name: "Goycay",
          state_id: "308",
        },
        {
          id: "7236",
          name: "Ismayilli",
          state_id: "308",
        },
        {
          id: "7237",
          name: "Kurdamir",
          state_id: "308",
        },
        {
          id: "7238",
          name: "Samaxi",
          state_id: "308",
        },
        {
          id: "7239",
          name: "Ucar",
          state_id: "308",
        },
        {
          id: "7240",
          name: "Zardab",
          state_id: "308",
        },
      ],
      Xacmaz: [
        {
          id: "7241",
          name: "Davaci",
          state_id: "309",
        },
        {
          id: "7242",
          name: "Quba",
          state_id: "309",
        },
        {
          id: "7243",
          name: "Qusar",
          state_id: "309",
        },
        {
          id: "7244",
          name: "Siyazan",
          state_id: "309",
        },
        {
          id: "7245",
          name: "Xacmaz",
          state_id: "309",
        },
        {
          id: "7246",
          name: "Xudat",
          state_id: "309",
        },
      ],
    },
  },
  BA: {
    name: "Bosnia and Herzegovina",
    native: "Bosna i Hercegovina",
    phone: "387",
    continent: "EU",
    capital: "Sarajevo",
    currency: "BAM",
    languages: ["bs", "hr", "sr"],
    emoji: "🇧🇦",
    emojiU: "U+1F1E7 U+1F1E6",
    states: {
      "Federacija Bosna i Hercegovina": [],
      "Republika Srpska": [],
    },
  },
  BB: {
    name: "Barbados",
    native: "Barbados",
    phone: "1246",
    continent: "NA",
    capital: "Bridgetown",
    currency: "BBD",
    languages: ["en"],
    emoji: "🇧🇧",
    emojiU: "U+1F1E7 U+1F1E7",
    states: {
      "Christ Church": [],
      "Saint Andrew": [],
      "Saint George": [],
      "Saint James": [],
      "Saint John": [],
      "Saint Joseph": [],
      "Saint Lucy": [],
      "Saint Michael": [],
      "Saint Peter": [],
      "Saint Philip": [],
      "Saint Thomas": [],
    },
  },
  BD: {
    name: "Bangladesh",
    native: "Bangladesh",
    phone: "880",
    continent: "AS",
    capital: "Dhaka",
    currency: "BDT",
    languages: ["bn"],
    emoji: "🇧🇩",
    emojiU: "U+1F1E7 U+1F1E9",
    states: {
      "Bagar Hat": [],
      Bandarban: [
        {
          id: "7264",
          name: "Bandarban",
          state_id: "338",
        },
      ],
      Barguna: [
        {
          id: "7265",
          name: "Barguna",
          state_id: "339",
        },
      ],
      Barisal: [
        {
          id: "7266",
          name: "Barisal",
          state_id: "340",
        },
        {
          id: "7267",
          name: "Gaurnadi",
          state_id: "340",
        },
        {
          id: "7268",
          name: "Mehendiganj",
          state_id: "340",
        },
        {
          id: "7269",
          name: "Nalchiti",
          state_id: "340",
        },
      ],
      Bhola: [
        {
          id: "7270",
          name: "Bhola",
          state_id: "341",
        },
        {
          id: "7271",
          name: "Burhanuddin",
          state_id: "341",
        },
        {
          id: "7272",
          name: "Char Fasson",
          state_id: "341",
        },
        {
          id: "7273",
          name: "Lalmohan",
          state_id: "341",
        },
      ],
      Bogora: [
        {
          id: "7274",
          name: "Adamighi",
          state_id: "342",
        },
        {
          id: "7275",
          name: "Bogora",
          state_id: "342",
        },
        {
          id: "7276",
          name: "Sherpur",
          state_id: "342",
        },
      ],
      "Brahman Bariya": [],
      Chandpur: [
        {
          id: "7277",
          name: "Chandpur",
          state_id: "344",
        },
        {
          id: "7278",
          name: "Hajiganj",
          state_id: "344",
        },
      ],
      Chattagam: [
        {
          id: "7279",
          name: "Boalkhali",
          state_id: "345",
        },
        {
          id: "7280",
          name: "Chattagam",
          state_id: "345",
        },
        {
          id: "7281",
          name: "Fatikchhari",
          state_id: "345",
        },
        {
          id: "7282",
          name: "Lohagara",
          state_id: "345",
        },
        {
          id: "7283",
          name: "Patiya",
          state_id: "345",
        },
        {
          id: "7284",
          name: "Rangunia",
          state_id: "345",
        },
        {
          id: "7285",
          name: "Raozan",
          state_id: "345",
        },
        {
          id: "7286",
          name: "Sandip",
          state_id: "345",
        },
        {
          id: "7287",
          name: "Satkaniya",
          state_id: "345",
        },
      ],
      "Chittagong Division": [],
      Chuadanga: [
        {
          id: "7288",
          name: "Alamdanga",
          state_id: "347",
        },
        {
          id: "7289",
          name: "Chuadanga",
          state_id: "347",
        },
        {
          id: "7290",
          name: "Damurhuda",
          state_id: "347",
        },
      ],
      Dhaka: [
        {
          id: "7291",
          name: "Dhaka",
          state_id: "348",
        },
        {
          id: "7292",
          name: "Dhamrai",
          state_id: "348",
        },
        {
          id: "7293",
          name: "Dohar",
          state_id: "348",
        },
      ],
      Dinajpur: [
        {
          id: "7294",
          name: "Bochanganj",
          state_id: "349",
        },
        {
          id: "7295",
          name: "Dinajpur",
          state_id: "349",
        },
        {
          id: "7296",
          name: "Fulbari",
          state_id: "349",
        },
        {
          id: "7297",
          name: "Parbatipur",
          state_id: "349",
        },
      ],
      Faridpur: [
        {
          id: "7298",
          name: "Bhanga",
          state_id: "350",
        },
        {
          id: "7299",
          name: "Char Bhadrasan",
          state_id: "350",
        },
        {
          id: "7300",
          name: "Faridpur",
          state_id: "350",
        },
      ],
      Feni: [
        {
          id: "7301",
          name: "Chhagalnaiya",
          state_id: "351",
        },
        {
          id: "7302",
          name: "Feni",
          state_id: "351",
        },
      ],
      Gaybanda: [
        {
          id: "7303",
          name: "Gaybanda",
          state_id: "352",
        },
      ],
      Gazipur: [
        {
          id: "7304",
          name: "Gazipur",
          state_id: "353",
        },
        {
          id: "7305",
          name: "Tungi",
          state_id: "353",
        },
      ],
      Gopalganj: [
        {
          id: "7306",
          name: "Gopalganj",
          state_id: "354",
        },
        {
          id: "7307",
          name: "Tungi Para",
          state_id: "354",
        },
      ],
      Habiganj: [
        {
          id: "7308",
          name: "Baniachang",
          state_id: "355",
        },
        {
          id: "7309",
          name: "Habiganj",
          state_id: "355",
        },
      ],
      "Jaipur Hat": [],
      Jamalpur: [
        {
          id: "7310",
          name: "Jamalpur",
          state_id: "357",
        },
        {
          id: "7311",
          name: "Sarishabari",
          state_id: "357",
        },
      ],
      Jessor: [
        {
          id: "7312",
          name: "Abhaynagar",
          state_id: "358",
        },
        {
          id: "7313",
          name: "Jessor",
          state_id: "358",
        },
        {
          id: "7314",
          name: "Jhikargachha",
          state_id: "358",
        },
        {
          id: "7315",
          name: "Keshabpur",
          state_id: "358",
        },
      ],
      Jhalakati: [
        {
          id: "7316",
          name: "Jhalakati",
          state_id: "359",
        },
      ],
      Jhanaydah: [
        {
          id: "7317",
          name: "Jhanaydah",
          state_id: "360",
        },
        {
          id: "7318",
          name: "Kaliganj",
          state_id: "360",
        },
        {
          id: "7319",
          name: "Kotchandpur",
          state_id: "360",
        },
        {
          id: "7320",
          name: "Shailkupa",
          state_id: "360",
        },
      ],
      Khagrachhari: [
        {
          id: "7321",
          name: "Khagrachari",
          state_id: "361",
        },
        {
          id: "7322",
          name: "Manikchhari",
          state_id: "361",
        },
        {
          id: "7323",
          name: "Ramgarh",
          state_id: "361",
        },
      ],
      Khulna: [
        {
          id: "7324",
          name: "Khulna",
          state_id: "362",
        },
        {
          id: "7325",
          name: "Phultala",
          state_id: "362",
        },
      ],
      Kishorganj: [
        {
          id: "7326",
          name: "Bajitpur",
          state_id: "363",
        },
        {
          id: "7327",
          name: "Bhairab Bazar",
          state_id: "363",
        },
        {
          id: "7328",
          name: "Itna",
          state_id: "363",
        },
        {
          id: "7329",
          name: "Kishorganj",
          state_id: "363",
        },
      ],
      "Koks Bazar": [],
      Komilla: [
        {
          id: "7330",
          name: "Komilla",
          state_id: "365",
        },
        {
          id: "7331",
          name: "Laksham",
          state_id: "365",
        },
      ],
      Kurigram: [
        {
          id: "7332",
          name: "Chilmari",
          state_id: "366",
        },
        {
          id: "7333",
          name: "Kurigram",
          state_id: "366",
        },
        {
          id: "7334",
          name: "Nageshwari",
          state_id: "366",
        },
        {
          id: "7335",
          name: "Ulipur",
          state_id: "366",
        },
      ],
      Kushtiya: [
        {
          id: "7336",
          name: "Bheramara",
          state_id: "367",
        },
        {
          id: "7337",
          name: "Kushtiya",
          state_id: "367",
        },
      ],
      Lakshmipur: [
        {
          id: "7338",
          name: "Lakshmipur",
          state_id: "368",
        },
        {
          id: "7339",
          name: "Ramganj",
          state_id: "368",
        },
        {
          id: "7340",
          name: "Ramgati",
          state_id: "368",
        },
        {
          id: "7341",
          name: "Raypur",
          state_id: "368",
        },
      ],
      "Lalmanir Hat": [],
      Madaripur: [
        {
          id: "7342",
          name: "Madaripur",
          state_id: "370",
        },
      ],
      Magura: [
        {
          id: "7343",
          name: "Magura",
          state_id: "371",
        },
      ],
      Maimansingh: [
        {
          id: "7344",
          name: "Bhaluka",
          state_id: "372",
        },
        {
          id: "7345",
          name: "Fulbaria",
          state_id: "372",
        },
        {
          id: "7346",
          name: "Gafargaon",
          state_id: "372",
        },
        {
          id: "7347",
          name: "Ishwarganj",
          state_id: "372",
        },
        {
          id: "7348",
          name: "Maimansingh",
          state_id: "372",
        },
        {
          id: "7349",
          name: "Muktagachha",
          state_id: "372",
        },
        {
          id: "7350",
          name: "Trishal",
          state_id: "372",
        },
      ],
      Manikganj: [
        {
          id: "7351",
          name: "Manikganj",
          state_id: "373",
        },
      ],
      "Maulvi Bazar": [],
      Meherpur: [
        {
          id: "7352",
          name: "Meherpur",
          state_id: "375",
        },
      ],
      Munshiganj: [
        {
          id: "7353",
          name: "Munshiganj",
          state_id: "376",
        },
      ],
      Naral: [
        {
          id: "7354",
          name: "Kalia",
          state_id: "377",
        },
        {
          id: "7355",
          name: "Naral",
          state_id: "377",
        },
      ],
      Narayanganj: [
        {
          id: "7356",
          name: "Narayanganj",
          state_id: "378",
        },
        {
          id: "7357",
          name: "Rupganj",
          state_id: "378",
        },
      ],
      Narsingdi: [
        {
          id: "7358",
          name: "Narsingdi",
          state_id: "379",
        },
        {
          id: "7359",
          name: "Roypura",
          state_id: "379",
        },
      ],
      Nator: [
        {
          id: "7360",
          name: "Gurudaspur",
          state_id: "380",
        },
        {
          id: "7361",
          name: "Nator",
          state_id: "380",
        },
      ],
      Naugaon: [
        {
          id: "7362",
          name: "Naugaon",
          state_id: "381",
        },
      ],
      Nawabganj: [
        {
          id: "7363",
          name: "Gomastapur",
          state_id: "382",
        },
        {
          id: "7364",
          name: "Nawabganj",
          state_id: "382",
        },
        {
          id: "7365",
          name: "Shibganj",
          state_id: "382",
        },
      ],
      Netrakona: [
        {
          id: "7366",
          name: "Netrakona",
          state_id: "383",
        },
      ],
      Nilphamari: [
        {
          id: "7367",
          name: "Domar",
          state_id: "384",
        },
        {
          id: "7368",
          name: "Nilphamari",
          state_id: "384",
        },
        {
          id: "7369",
          name: "Sa''idpur",
          state_id: "384",
        },
      ],
      Noakhali: [
        {
          id: "7370",
          name: "Begamganj",
          state_id: "385",
        },
        {
          id: "7371",
          name: "Noakhali",
          state_id: "385",
        },
        {
          id: "7372",
          name: "Senbagh",
          state_id: "385",
        },
      ],
      Pabna: [
        {
          id: "7373",
          name: "Bera",
          state_id: "386",
        },
        {
          id: "7374",
          name: "Bhangura",
          state_id: "386",
        },
        {
          id: "7375",
          name: "Ishurdi",
          state_id: "386",
        },
        {
          id: "7376",
          name: "Pabna",
          state_id: "386",
        },
      ],
      Panchagarh: [
        {
          id: "7377",
          name: "Panchagarh",
          state_id: "387",
        },
      ],
      Patuakhali: [
        {
          id: "7378",
          name: "Patuakhali",
          state_id: "388",
        },
      ],
      Pirojpur: [
        {
          id: "7379",
          name: "Bhandaria",
          state_id: "389",
        },
        {
          id: "7380",
          name: "Mathbaria",
          state_id: "389",
        },
        {
          id: "7381",
          name: "Nesarabad",
          state_id: "389",
        },
        {
          id: "7382",
          name: "Pirojpur",
          state_id: "389",
        },
      ],
      Rajbari: [
        {
          id: "7383",
          name: "Pangsha",
          state_id: "390",
        },
        {
          id: "7384",
          name: "Rajbari",
          state_id: "390",
        },
      ],
      Rajshahi: [
        {
          id: "7385",
          name: "Rajshahi",
          state_id: "391",
        },
      ],
      Rangamati: [
        {
          id: "7386",
          name: "Kaptai",
          state_id: "392",
        },
        {
          id: "7387",
          name: "Rangamati",
          state_id: "392",
        },
      ],
      Rangpur: [
        {
          id: "7388",
          name: "Badarganj",
          state_id: "393",
        },
        {
          id: "7389",
          name: "Kaunia",
          state_id: "393",
        },
        {
          id: "7390",
          name: "Rangpur",
          state_id: "393",
        },
      ],
      Satkhira: [
        {
          id: "7391",
          name: "Satkhira",
          state_id: "394",
        },
      ],
      Shariatpur: [
        {
          id: "7392",
          name: "Palang",
          state_id: "395",
        },
      ],
      Sherpur: [
        {
          id: "7393",
          name: "Nalitabari",
          state_id: "396",
        },
        {
          id: "7394",
          name: "Sherpur",
          state_id: "396",
        },
      ],
      Silhat: [
        {
          id: "7395",
          name: "Silhat",
          state_id: "397",
        },
      ],
      Sirajganj: [
        {
          id: "7396",
          name: "Shahjadpur",
          state_id: "398",
        },
        {
          id: "7397",
          name: "Sirajganj",
          state_id: "398",
        },
      ],
      Sunamganj: [
        {
          id: "7398",
          name: "Chhatak",
          state_id: "399",
        },
        {
          id: "7399",
          name: "Sunamganj",
          state_id: "399",
        },
      ],
      Tangayal: [
        {
          id: "7400",
          name: "Gopalpur",
          state_id: "400",
        },
        {
          id: "7401",
          name: "Mirzapur",
          state_id: "400",
        },
        {
          id: "7402",
          name: "Sakhipur",
          state_id: "400",
        },
        {
          id: "7403",
          name: "Tangayal",
          state_id: "400",
        },
      ],
      Thakurgaon: [
        {
          id: "7404",
          name: "Pirganj",
          state_id: "401",
        },
        {
          id: "7405",
          name: "Thakurgaon",
          state_id: "401",
        },
      ],
    },
  },
  BE: {
    name: "Belgium",
    native: "België",
    phone: "32",
    continent: "EU",
    capital: "Brussels",
    currency: "EUR",
    languages: ["nl", "fr", "de"],
    emoji: "🇧🇪",
    emojiU: "U+1F1E7 U+1F1EA",
    states: {
      Antwerpen: [
        {
          id: "7491",
          name: "Aartselaar",
          state_id: "422",
        },
        {
          id: "7492",
          name: "Antwerpen",
          state_id: "422",
        },
        {
          id: "7493",
          name: "Arendonk",
          state_id: "422",
        },
        {
          id: "7494",
          name: "Baarle-Hertog",
          state_id: "422",
        },
        {
          id: "7495",
          name: "Balen",
          state_id: "422",
        },
        {
          id: "7496",
          name: "Beerse",
          state_id: "422",
        },
        {
          id: "7497",
          name: "Berlaar",
          state_id: "422",
        },
        {
          id: "7498",
          name: "Boechout",
          state_id: "422",
        },
        {
          id: "7499",
          name: "Bonheiden",
          state_id: "422",
        },
        {
          id: "7500",
          name: "Boom",
          state_id: "422",
        },
        {
          id: "7501",
          name: "Bornem",
          state_id: "422",
        },
        {
          id: "7502",
          name: "Borsbeek",
          state_id: "422",
        },
        {
          id: "7503",
          name: "Brasschaat",
          state_id: "422",
        },
        {
          id: "7504",
          name: "Brecht",
          state_id: "422",
        },
        {
          id: "7505",
          name: "Dessel",
          state_id: "422",
        },
        {
          id: "7506",
          name: "Deurne",
          state_id: "422",
        },
        {
          id: "7507",
          name: "Duffel",
          state_id: "422",
        },
        {
          id: "7508",
          name: "Edegem",
          state_id: "422",
        },
        {
          id: "7509",
          name: "Ekeren",
          state_id: "422",
        },
        {
          id: "7510",
          name: "Essen",
          state_id: "422",
        },
        {
          id: "7511",
          name: "Geel",
          state_id: "422",
        },
        {
          id: "7512",
          name: "Geluvele",
          state_id: "422",
        },
        {
          id: "7513",
          name: "Grobbendonk",
          state_id: "422",
        },
        {
          id: "7514",
          name: "Heist-op-den-Berg",
          state_id: "422",
        },
        {
          id: "7515",
          name: "Hemiksem",
          state_id: "422",
        },
        {
          id: "7516",
          name: "Herentals",
          state_id: "422",
        },
        {
          id: "7517",
          name: "Herenthout",
          state_id: "422",
        },
        {
          id: "7518",
          name: "Herselt",
          state_id: "422",
        },
        {
          id: "7519",
          name: "Hoogstraten",
          state_id: "422",
        },
        {
          id: "7520",
          name: "Hove",
          state_id: "422",
        },
        {
          id: "7521",
          name: "Hulshout",
          state_id: "422",
        },
        {
          id: "7522",
          name: "Kalmpthout",
          state_id: "422",
        },
        {
          id: "7523",
          name: "Kalmthout",
          state_id: "422",
        },
        {
          id: "7524",
          name: "Kapellen",
          state_id: "422",
        },
        {
          id: "7525",
          name: "Kasterlee",
          state_id: "422",
        },
        {
          id: "7526",
          name: "Kontich",
          state_id: "422",
        },
        {
          id: "7527",
          name: "Laakdal",
          state_id: "422",
        },
        {
          id: "7528",
          name: "Lier",
          state_id: "422",
        },
        {
          id: "7529",
          name: "Lille",
          state_id: "422",
        },
        {
          id: "7530",
          name: "Lint",
          state_id: "422",
        },
        {
          id: "7531",
          name: "Malle",
          state_id: "422",
        },
        {
          id: "7532",
          name: "Mechelen",
          state_id: "422",
        },
        {
          id: "7533",
          name: "Meerhout",
          state_id: "422",
        },
        {
          id: "7534",
          name: "Merksplas",
          state_id: "422",
        },
        {
          id: "7535",
          name: "Mol",
          state_id: "422",
        },
        {
          id: "7536",
          name: "Mortsel",
          state_id: "422",
        },
        {
          id: "7537",
          name: "Niel",
          state_id: "422",
        },
        {
          id: "7538",
          name: "Nijlen",
          state_id: "422",
        },
        {
          id: "7539",
          name: "Olen",
          state_id: "422",
        },
        {
          id: "7540",
          name: "Oud-Turnhout",
          state_id: "422",
        },
        {
          id: "7541",
          name: "Putte",
          state_id: "422",
        },
        {
          id: "7542",
          name: "Puurs",
          state_id: "422",
        },
        {
          id: "7543",
          name: "Ranst",
          state_id: "422",
        },
        {
          id: "7544",
          name: "Ravels",
          state_id: "422",
        },
        {
          id: "7545",
          name: "Retie",
          state_id: "422",
        },
        {
          id: "7546",
          name: "Rijkevorsel",
          state_id: "422",
        },
        {
          id: "7547",
          name: "Robrechts",
          state_id: "422",
        },
        {
          id: "7548",
          name: "Rumst",
          state_id: "422",
        },
        {
          id: "7549",
          name: "Schelle",
          state_id: "422",
        },
        {
          id: "7550",
          name: "Schilde",
          state_id: "422",
        },
        {
          id: "7551",
          name: "Schoten",
          state_id: "422",
        },
        {
          id: "7552",
          name: "Sint-Amands",
          state_id: "422",
        },
        {
          id: "7553",
          name: "Sint-Katelijne-Waver",
          state_id: "422",
        },
        {
          id: "7554",
          name: "Stabroek",
          state_id: "422",
        },
        {
          id: "7555",
          name: "Turnhout",
          state_id: "422",
        },
        {
          id: "7556",
          name: "Vorselaar",
          state_id: "422",
        },
        {
          id: "7557",
          name: "Vosselaar",
          state_id: "422",
        },
        {
          id: "7558",
          name: "Westerlo",
          state_id: "422",
        },
        {
          id: "7559",
          name: "Wijnegem",
          state_id: "422",
        },
        {
          id: "7560",
          name: "Willebroek",
          state_id: "422",
        },
        {
          id: "7561",
          name: "Wilrijk",
          state_id: "422",
        },
        {
          id: "7562",
          name: "Wommelgem",
          state_id: "422",
        },
        {
          id: "7563",
          name: "Wuustwezel",
          state_id: "422",
        },
        {
          id: "7564",
          name: "Zandhoven",
          state_id: "422",
        },
        {
          id: "7565",
          name: "Zoersel",
          state_id: "422",
        },
        {
          id: "7566",
          name: "Zwijndrecht",
          state_id: "422",
        },
      ],
      Berchem: [
        {
          id: "7567",
          name: "Berchem",
          state_id: "423",
        },
      ],
      Brabant: [
        {
          id: "7568",
          name: "Alsemberg",
          state_id: "424",
        },
        {
          id: "7569",
          name: "Asse Zellik",
          state_id: "424",
        },
        {
          id: "7570",
          name: "Brussels",
          state_id: "424",
        },
        {
          id: "7571",
          name: "Bruxelles",
          state_id: "424",
        },
        {
          id: "7572",
          name: "Diegem",
          state_id: "424",
        },
      ],
      "Brabant Wallon": [
        {
          id: "7573",
          name: "Alsemberg",
          state_id: "425",
        },
        {
          id: "7574",
          name: "Asse Zellik",
          state_id: "425",
        },
        {
          id: "7575",
          name: "Brussels",
          state_id: "425",
        },
        {
          id: "7576",
          name: "Bruxelles",
          state_id: "425",
        },
        {
          id: "7577",
          name: "Diegem",
          state_id: "425",
        },
      ],
      Brussel: [
        {
          id: "7578",
          name: "Brussel",
          state_id: "426",
        },
      ],
      "East Flanders": [],
      Hainaut: [
        {
          id: "7579",
          name: "Aiseau-Presles",
          state_id: "428",
        },
        {
          id: "7580",
          name: "Anderlues",
          state_id: "428",
        },
        {
          id: "7581",
          name: "Antoing",
          state_id: "428",
        },
        {
          id: "7582",
          name: "Ath",
          state_id: "428",
        },
        {
          id: "7583",
          name: "Beaumont",
          state_id: "428",
        },
        {
          id: "7584",
          name: "Beloeil",
          state_id: "428",
        },
        {
          id: "7585",
          name: "Bernissart",
          state_id: "428",
        },
        {
          id: "7586",
          name: "Binche",
          state_id: "428",
        },
        {
          id: "7587",
          name: "Boussu",
          state_id: "428",
        },
        {
          id: "7588",
          name: "Braine-le-Comte",
          state_id: "428",
        },
        {
          id: "7589",
          name: "Brugelette",
          state_id: "428",
        },
        {
          id: "7590",
          name: "Brunehaut",
          state_id: "428",
        },
        {
          id: "7591",
          name: "Celles",
          state_id: "428",
        },
        {
          id: "7592",
          name: "Chapelle-lez-Herlaimont",
          state_id: "428",
        },
        {
          id: "7593",
          name: "Charleroi",
          state_id: "428",
        },
        {
          id: "7594",
          name: "Chatelet",
          state_id: "428",
        },
        {
          id: "7595",
          name: "Chievres",
          state_id: "428",
        },
        {
          id: "7596",
          name: "Chimay",
          state_id: "428",
        },
        {
          id: "7597",
          name: "Colfontaine",
          state_id: "428",
        },
        {
          id: "7598",
          name: "Comines-Warneton",
          state_id: "428",
        },
        {
          id: "7599",
          name: "Courcelles",
          state_id: "428",
        },
        {
          id: "7600",
          name: "Dour",
          state_id: "428",
        },
        {
          id: "7601",
          name: "Ecaussinnes",
          state_id: "428",
        },
        {
          id: "7602",
          name: "Ellezelles",
          state_id: "428",
        },
        {
          id: "7603",
          name: "Enghien",
          state_id: "428",
        },
        {
          id: "7604",
          name: "Erquelinnes",
          state_id: "428",
        },
        {
          id: "7605",
          name: "Estaimpuis",
          state_id: "428",
        },
        {
          id: "7606",
          name: "Estinnes",
          state_id: "428",
        },
        {
          id: "7607",
          name: "Farciennes",
          state_id: "428",
        },
        {
          id: "7608",
          name: "Fleurus",
          state_id: "428",
        },
        {
          id: "7609",
          name: "Flobecq",
          state_id: "428",
        },
        {
          id: "7610",
          name: "Fontaine-l''Eveque",
          state_id: "428",
        },
        {
          id: "7611",
          name: "Frameries",
          state_id: "428",
        },
        {
          id: "7612",
          name: "Frasnes-lez-Anvaing",
          state_id: "428",
        },
        {
          id: "7613",
          name: "Froidchapelle",
          state_id: "428",
        },
        {
          id: "7614",
          name: "Gerpinnes",
          state_id: "428",
        },
        {
          id: "7615",
          name: "Haine-Saint-Pierre",
          state_id: "428",
        },
        {
          id: "7616",
          name: "Ham-sur-Heure-Nalinnes",
          state_id: "428",
        },
        {
          id: "7617",
          name: "Hensies",
          state_id: "428",
        },
        {
          id: "7618",
          name: "Honnelles",
          state_id: "428",
        },
        {
          id: "7619",
          name: "Jurbise",
          state_id: "428",
        },
        {
          id: "7620",
          name: "La Louviere",
          state_id: "428",
        },
        {
          id: "7621",
          name: "Le Roeulx",
          state_id: "428",
        },
        {
          id: "7622",
          name: "Lens",
          state_id: "428",
        },
        {
          id: "7623",
          name: "Les Bons Villers",
          state_id: "428",
        },
        {
          id: "7624",
          name: "Lessines",
          state_id: "428",
        },
        {
          id: "7625",
          name: "Leuze-en-Hainaut",
          state_id: "428",
        },
        {
          id: "7626",
          name: "Lobbes",
          state_id: "428",
        },
        {
          id: "7627",
          name: "Manage",
          state_id: "428",
        },
        {
          id: "7628",
          name: "Merbes-le-Chateau",
          state_id: "428",
        },
        {
          id: "7629",
          name: "Momignies",
          state_id: "428",
        },
        {
          id: "7630",
          name: "Mons",
          state_id: "428",
        },
        {
          id: "7631",
          name: "Mont-de-l''Enclus",
          state_id: "428",
        },
        {
          id: "7632",
          name: "Montigny-le-Tilleul",
          state_id: "428",
        },
        {
          id: "7633",
          name: "Morlanwelz",
          state_id: "428",
        },
        {
          id: "7634",
          name: "Mouscron",
          state_id: "428",
        },
        {
          id: "7635",
          name: "Pecq",
          state_id: "428",
        },
        {
          id: "7636",
          name: "Peruwelz",
          state_id: "428",
        },
        {
          id: "7637",
          name: "Pont-a-Celles",
          state_id: "428",
        },
        {
          id: "7638",
          name: "Quaregnon",
          state_id: "428",
        },
        {
          id: "7639",
          name: "Quevy",
          state_id: "428",
        },
        {
          id: "7640",
          name: "Quievrain",
          state_id: "428",
        },
        {
          id: "7641",
          name: "Rumes",
          state_id: "428",
        },
        {
          id: "7642",
          name: "Saint-Ghislain",
          state_id: "428",
        },
        {
          id: "7643",
          name: "Seneffe",
          state_id: "428",
        },
        {
          id: "7644",
          name: "Silly",
          state_id: "428",
        },
        {
          id: "7645",
          name: "Sivry-Rance",
          state_id: "428",
        },
        {
          id: "7646",
          name: "Soignies",
          state_id: "428",
        },
        {
          id: "7647",
          name: "Thuin",
          state_id: "428",
        },
        {
          id: "7648",
          name: "Tournai",
          state_id: "428",
        },
      ],
      Liege: [
        {
          id: "7649",
          name: "Amay",
          state_id: "429",
        },
        {
          id: "7650",
          name: "Amel",
          state_id: "429",
        },
        {
          id: "7651",
          name: "Angleur",
          state_id: "429",
        },
        {
          id: "7652",
          name: "Ans",
          state_id: "429",
        },
        {
          id: "7653",
          name: "Anthisnes",
          state_id: "429",
        },
        {
          id: "7654",
          name: "Aubel",
          state_id: "429",
        },
        {
          id: "7655",
          name: "Awans",
          state_id: "429",
        },
        {
          id: "7656",
          name: "Aywaille",
          state_id: "429",
        },
        {
          id: "7657",
          name: "Baelen",
          state_id: "429",
        },
        {
          id: "7658",
          name: "Bassenge",
          state_id: "429",
        },
        {
          id: "7659",
          name: "Berloz",
          state_id: "429",
        },
        {
          id: "7660",
          name: "Beyne-Heusay",
          state_id: "429",
        },
        {
          id: "7661",
          name: "Blegny",
          state_id: "429",
        },
        {
          id: "7662",
          name: "Braives",
          state_id: "429",
        },
        {
          id: "7663",
          name: "Bullingen",
          state_id: "429",
        },
        {
          id: "7664",
          name: "Burdinne",
          state_id: "429",
        },
        {
          id: "7665",
          name: "Burg-Reuland",
          state_id: "429",
        },
        {
          id: "7666",
          name: "Butgenbach",
          state_id: "429",
        },
        {
          id: "7667",
          name: "Chaudfontaine",
          state_id: "429",
        },
        {
          id: "7668",
          name: "Clavier",
          state_id: "429",
        },
        {
          id: "7669",
          name: "Comblain-au-Pont",
          state_id: "429",
        },
        {
          id: "7670",
          name: "Crisnee",
          state_id: "429",
        },
        {
          id: "7671",
          name: "Dalhem",
          state_id: "429",
        },
        {
          id: "7672",
          name: "Dison",
          state_id: "429",
        },
        {
          id: "7673",
          name: "Donceel",
          state_id: "429",
        },
        {
          id: "7674",
          name: "Engis",
          state_id: "429",
        },
        {
          id: "7675",
          name: "Esneux",
          state_id: "429",
        },
        {
          id: "7676",
          name: "Eupen",
          state_id: "429",
        },
        {
          id: "7677",
          name: "Faimes",
          state_id: "429",
        },
        {
          id: "7678",
          name: "Ferrieres",
          state_id: "429",
        },
        {
          id: "7679",
          name: "Fexhe-le-Haut-Clocher",
          state_id: "429",
        },
        {
          id: "7680",
          name: "Flemalle",
          state_id: "429",
        },
        {
          id: "7681",
          name: "Fleron",
          state_id: "429",
        },
        {
          id: "7682",
          name: "Geer",
          state_id: "429",
        },
        {
          id: "7683",
          name: "Grace-Hollogne",
          state_id: "429",
        },
        {
          id: "7684",
          name: "Hamoir",
          state_id: "429",
        },
        {
          id: "7685",
          name: "Hannut",
          state_id: "429",
        },
        {
          id: "7686",
          name: "Heron",
          state_id: "429",
        },
        {
          id: "7687",
          name: "Herstal",
          state_id: "429",
        },
        {
          id: "7688",
          name: "Herve",
          state_id: "429",
        },
        {
          id: "7689",
          name: "Huy",
          state_id: "429",
        },
        {
          id: "7690",
          name: "Jalhay",
          state_id: "429",
        },
        {
          id: "7691",
          name: "Juprelle",
          state_id: "429",
        },
        {
          id: "7692",
          name: "Kelmis",
          state_id: "429",
        },
        {
          id: "7693",
          name: "Liege",
          state_id: "429",
        },
        {
          id: "7694",
          name: "Lierneux",
          state_id: "429",
        },
        {
          id: "7695",
          name: "Limbourg",
          state_id: "429",
        },
        {
          id: "7696",
          name: "Lincent",
          state_id: "429",
        },
        {
          id: "7697",
          name: "Lontzen",
          state_id: "429",
        },
        {
          id: "7698",
          name: "Malmedy",
          state_id: "429",
        },
        {
          id: "7699",
          name: "Marchin",
          state_id: "429",
        },
        {
          id: "7700",
          name: "Modave",
          state_id: "429",
        },
        {
          id: "7701",
          name: "Montzen",
          state_id: "429",
        },
        {
          id: "7702",
          name: "Nandrin",
          state_id: "429",
        },
        {
          id: "7703",
          name: "Neupre",
          state_id: "429",
        },
        {
          id: "7704",
          name: "Olne",
          state_id: "429",
        },
        {
          id: "7705",
          name: "Oreye",
          state_id: "429",
        },
        {
          id: "7706",
          name: "Ouffet",
          state_id: "429",
        },
        {
          id: "7707",
          name: "Oupeye",
          state_id: "429",
        },
        {
          id: "7708",
          name: "Pepinster",
          state_id: "429",
        },
        {
          id: "7709",
          name: "Plombieres",
          state_id: "429",
        },
        {
          id: "7710",
          name: "Racour",
          state_id: "429",
        },
        {
          id: "7711",
          name: "Raeren",
          state_id: "429",
        },
        {
          id: "7712",
          name: "Remicourt",
          state_id: "429",
        },
        {
          id: "7713",
          name: "Saint-Georges-sur-Meuse",
          state_id: "429",
        },
        {
          id: "7714",
          name: "Saint-Nicolas",
          state_id: "429",
        },
        {
          id: "7715",
          name: "Sankt Vith",
          state_id: "429",
        },
        {
          id: "7716",
          name: "Seraing",
          state_id: "429",
        },
        {
          id: "7717",
          name: "Soumagne",
          state_id: "429",
        },
        {
          id: "7718",
          name: "Spa",
          state_id: "429",
        },
        {
          id: "7719",
          name: "Sprimont",
          state_id: "429",
        },
        {
          id: "7720",
          name: "Stavelot",
          state_id: "429",
        },
        {
          id: "7721",
          name: "Stoumont",
          state_id: "429",
        },
        {
          id: "7722",
          name: "Theux",
          state_id: "429",
        },
        {
          id: "7723",
          name: "Thimister-Clermont",
          state_id: "429",
        },
        {
          id: "7724",
          name: "Tinlot",
          state_id: "429",
        },
        {
          id: "7725",
          name: "Trois-Ponts",
          state_id: "429",
        },
        {
          id: "7726",
          name: "Trooz",
          state_id: "429",
        },
        {
          id: "7727",
          name: "Verlaine",
          state_id: "429",
        },
        {
          id: "7728",
          name: "Verviers",
          state_id: "429",
        },
        {
          id: "7729",
          name: "Villers-le-Bouillet",
          state_id: "429",
        },
        {
          id: "7730",
          name: "Vise",
          state_id: "429",
        },
        {
          id: "7731",
          name: "Waimes",
          state_id: "429",
        },
        {
          id: "7732",
          name: "Wanze",
          state_id: "429",
        },
        {
          id: "7733",
          name: "Waremme",
          state_id: "429",
        },
        {
          id: "7734",
          name: "Wasseiges",
          state_id: "429",
        },
        {
          id: "7735",
          name: "Welkenraedt",
          state_id: "429",
        },
      ],
      Limburg: [
        {
          id: "7736",
          name: "Alken",
          state_id: "430",
        },
        {
          id: "7737",
          name: "As",
          state_id: "430",
        },
        {
          id: "7738",
          name: "Beringen",
          state_id: "430",
        },
        {
          id: "7739",
          name: "Bilzen",
          state_id: "430",
        },
        {
          id: "7740",
          name: "Bocholt",
          state_id: "430",
        },
        {
          id: "7741",
          name: "Borgloon",
          state_id: "430",
        },
        {
          id: "7742",
          name: "Bree",
          state_id: "430",
        },
        {
          id: "7743",
          name: "Diepenbeek",
          state_id: "430",
        },
        {
          id: "7744",
          name: "Dilsen-Stokkem",
          state_id: "430",
        },
        {
          id: "7745",
          name: "Genk",
          state_id: "430",
        },
        {
          id: "7746",
          name: "Gingelom",
          state_id: "430",
        },
        {
          id: "7747",
          name: "Halen",
          state_id: "430",
        },
        {
          id: "7748",
          name: "Ham",
          state_id: "430",
        },
        {
          id: "7749",
          name: "Hamont-Achel",
          state_id: "430",
        },
        {
          id: "7750",
          name: "Hasselt",
          state_id: "430",
        },
        {
          id: "7751",
          name: "Hechtel-Eksel",
          state_id: "430",
        },
        {
          id: "7752",
          name: "Heers",
          state_id: "430",
        },
        {
          id: "7753",
          name: "Herk-de-Stad",
          state_id: "430",
        },
        {
          id: "7754",
          name: "Herstappe",
          state_id: "430",
        },
        {
          id: "7755",
          name: "Heusden-Zolder",
          state_id: "430",
        },
        {
          id: "7756",
          name: "Hoeselt",
          state_id: "430",
        },
        {
          id: "7757",
          name: "Houthalen-Helchteren",
          state_id: "430",
        },
        {
          id: "7758",
          name: "Kinrooi",
          state_id: "430",
        },
        {
          id: "7759",
          name: "Kortessem",
          state_id: "430",
        },
        {
          id: "7760",
          name: "Kuringen",
          state_id: "430",
        },
        {
          id: "7761",
          name: "Lanaken",
          state_id: "430",
        },
        {
          id: "7762",
          name: "Leopoldsburg",
          state_id: "430",
        },
        {
          id: "7763",
          name: "Lommel",
          state_id: "430",
        },
        {
          id: "7764",
          name: "Lummen",
          state_id: "430",
        },
        {
          id: "7765",
          name: "Maaseik",
          state_id: "430",
        },
        {
          id: "7766",
          name: "Maasmechelen",
          state_id: "430",
        },
        {
          id: "7767",
          name: "Meeuwen-Gruitrode",
          state_id: "430",
        },
        {
          id: "7768",
          name: "Neerpelt",
          state_id: "430",
        },
        {
          id: "7769",
          name: "Nieuwerkerken",
          state_id: "430",
        },
        {
          id: "7770",
          name: "Opglabbeek",
          state_id: "430",
        },
        {
          id: "7771",
          name: "Overpelt",
          state_id: "430",
        },
        {
          id: "7772",
          name: "Peer",
          state_id: "430",
        },
        {
          id: "7773",
          name: "Riemst",
          state_id: "430",
        },
        {
          id: "7774",
          name: "Sint-Truiden",
          state_id: "430",
        },
        {
          id: "7775",
          name: "Tessenderlo",
          state_id: "430",
        },
        {
          id: "7776",
          name: "Tongeren",
          state_id: "430",
        },
        {
          id: "7777",
          name: "Voeren",
          state_id: "430",
        },
        {
          id: "7778",
          name: "Wellen",
          state_id: "430",
        },
        {
          id: "7779",
          name: "Zonhoven",
          state_id: "430",
        },
        {
          id: "7780",
          name: "Zutendaal",
          state_id: "430",
        },
      ],
      Luxembourg: [
        {
          id: "7781",
          name: "Arlon",
          state_id: "431",
        },
        {
          id: "7782",
          name: "Attert",
          state_id: "431",
        },
        {
          id: "7783",
          name: "Aubange",
          state_id: "431",
        },
        {
          id: "7784",
          name: "Bastogne",
          state_id: "431",
        },
        {
          id: "7785",
          name: "Bertogne",
          state_id: "431",
        },
        {
          id: "7786",
          name: "Bertrix",
          state_id: "431",
        },
        {
          id: "7787",
          name: "Bouillon",
          state_id: "431",
        },
        {
          id: "7788",
          name: "Chiny",
          state_id: "431",
        },
        {
          id: "7789",
          name: "Daverdisse",
          state_id: "431",
        },
        {
          id: "7790",
          name: "Durbuy",
          state_id: "431",
        },
        {
          id: "7791",
          name: "Erezee",
          state_id: "431",
        },
        {
          id: "7792",
          name: "Etalle",
          state_id: "431",
        },
        {
          id: "7793",
          name: "Fauvillers",
          state_id: "431",
        },
        {
          id: "7794",
          name: "Florenville",
          state_id: "431",
        },
        {
          id: "7795",
          name: "Gouvy",
          state_id: "431",
        },
        {
          id: "7796",
          name: "Grapfontaine",
          state_id: "431",
        },
        {
          id: "7797",
          name: "Habay",
          state_id: "431",
        },
        {
          id: "7798",
          name: "Herbeumont",
          state_id: "431",
        },
        {
          id: "7799",
          name: "Hotton",
          state_id: "431",
        },
        {
          id: "7800",
          name: "Houffalize",
          state_id: "431",
        },
        {
          id: "7801",
          name: "La Roche-en-Ardenne",
          state_id: "431",
        },
        {
          id: "7802",
          name: "Leglise",
          state_id: "431",
        },
        {
          id: "7803",
          name: "Libin",
          state_id: "431",
        },
        {
          id: "7804",
          name: "Libramont-Chevigny",
          state_id: "431",
        },
        {
          id: "7805",
          name: "Manhay",
          state_id: "431",
        },
        {
          id: "7806",
          name: "Marche-en-Famenne",
          state_id: "431",
        },
        {
          id: "7807",
          name: "Marloie",
          state_id: "431",
        },
        {
          id: "7808",
          name: "Martelange",
          state_id: "431",
        },
        {
          id: "7809",
          name: "Meix-devant-Virton",
          state_id: "431",
        },
        {
          id: "7810",
          name: "Messancy",
          state_id: "431",
        },
        {
          id: "7811",
          name: "Musson",
          state_id: "431",
        },
        {
          id: "7812",
          name: "Nassogne",
          state_id: "431",
        },
        {
          id: "7813",
          name: "Neufchateau",
          state_id: "431",
        },
        {
          id: "7814",
          name: "Paliseul",
          state_id: "431",
        },
        {
          id: "7815",
          name: "Rendeux",
          state_id: "431",
        },
        {
          id: "7816",
          name: "Rouvroy",
          state_id: "431",
        },
        {
          id: "7817",
          name: "Saint-Hubert",
          state_id: "431",
        },
        {
          id: "7818",
          name: "Saint-Leger",
          state_id: "431",
        },
        {
          id: "7819",
          name: "Sainte-Ode",
          state_id: "431",
        },
        {
          id: "7820",
          name: "Tellin",
          state_id: "431",
        },
        {
          id: "7821",
          name: "Tenneville",
          state_id: "431",
        },
        {
          id: "7822",
          name: "Tintigny",
          state_id: "431",
        },
        {
          id: "7823",
          name: "Vaux-sur-Sure",
          state_id: "431",
        },
        {
          id: "7824",
          name: "Vielsalm",
          state_id: "431",
        },
        {
          id: "7825",
          name: "Virton",
          state_id: "431",
        },
        {
          id: "7826",
          name: "Wellin",
          state_id: "431",
        },
      ],
      Namur: [
        {
          id: "7827",
          name: "Andenne",
          state_id: "432",
        },
        {
          id: "7828",
          name: "Anhee",
          state_id: "432",
        },
        {
          id: "7829",
          name: "Assesse",
          state_id: "432",
        },
        {
          id: "7830",
          name: "Beauraing",
          state_id: "432",
        },
        {
          id: "7831",
          name: "Bievre",
          state_id: "432",
        },
        {
          id: "7832",
          name: "Cerfontaine",
          state_id: "432",
        },
        {
          id: "7833",
          name: "Ciney",
          state_id: "432",
        },
        {
          id: "7834",
          name: "Couvin",
          state_id: "432",
        },
        {
          id: "7835",
          name: "Dinant",
          state_id: "432",
        },
        {
          id: "7836",
          name: "Doische",
          state_id: "432",
        },
        {
          id: "7837",
          name: "Eghezee",
          state_id: "432",
        },
        {
          id: "7838",
          name: "Fernelmont",
          state_id: "432",
        },
        {
          id: "7839",
          name: "Floreffe",
          state_id: "432",
        },
        {
          id: "7840",
          name: "Florennes",
          state_id: "432",
        },
        {
          id: "7841",
          name: "Fosses-la-Ville",
          state_id: "432",
        },
        {
          id: "7842",
          name: "Gedinne",
          state_id: "432",
        },
        {
          id: "7843",
          name: "Gembloux",
          state_id: "432",
        },
        {
          id: "7844",
          name: "Gesves",
          state_id: "432",
        },
        {
          id: "7845",
          name: "Hamois",
          state_id: "432",
        },
        {
          id: "7846",
          name: "Hastiere",
          state_id: "432",
        },
        {
          id: "7847",
          name: "Havelange",
          state_id: "432",
        },
        {
          id: "7848",
          name: "Houyet",
          state_id: "432",
        },
        {
          id: "7849",
          name: "Jambes",
          state_id: "432",
        },
        {
          id: "7850",
          name: "Jemeppe-sur-Sambre",
          state_id: "432",
        },
        {
          id: "7851",
          name: "La Bruyere",
          state_id: "432",
        },
        {
          id: "7852",
          name: "Malonne",
          state_id: "432",
        },
        {
          id: "7853",
          name: "Mettet",
          state_id: "432",
        },
        {
          id: "7854",
          name: "Namur",
          state_id: "432",
        },
        {
          id: "7855",
          name: "Ohey",
          state_id: "432",
        },
        {
          id: "7856",
          name: "Onhaye",
          state_id: "432",
        },
        {
          id: "7857",
          name: "Philippeville",
          state_id: "432",
        },
        {
          id: "7858",
          name: "Profondeville",
          state_id: "432",
        },
        {
          id: "7859",
          name: "Rochefort",
          state_id: "432",
        },
        {
          id: "7860",
          name: "Sambreville",
          state_id: "432",
        },
        {
          id: "7861",
          name: "Sombreffe",
          state_id: "432",
        },
        {
          id: "7862",
          name: "Somme-Leuze",
          state_id: "432",
        },
        {
          id: "7863",
          name: "Suarlee",
          state_id: "432",
        },
        {
          id: "7864",
          name: "Viroinval",
          state_id: "432",
        },
        {
          id: "7865",
          name: "Vresse-sur-Semois",
          state_id: "432",
        },
        {
          id: "7866",
          name: "Walcourt",
          state_id: "432",
        },
        {
          id: "7867",
          name: "Yvoir",
          state_id: "432",
        },
      ],
      Ontario: [
        {
          id: "7868",
          name: "Gullegem",
          state_id: "433",
        },
        {
          id: "7869",
          name: "Langdorp",
          state_id: "433",
        },
      ],
      "Oost-Vlaanderen": [
        {
          id: "7870",
          name: "Aalst",
          state_id: "434",
        },
        {
          id: "7871",
          name: "Aalter",
          state_id: "434",
        },
        {
          id: "7872",
          name: "Assenede",
          state_id: "434",
        },
        {
          id: "7873",
          name: "Berlare",
          state_id: "434",
        },
        {
          id: "7874",
          name: "Beveren",
          state_id: "434",
        },
        {
          id: "7875",
          name: "Brakel",
          state_id: "434",
        },
        {
          id: "7876",
          name: "Buggenhout",
          state_id: "434",
        },
        {
          id: "7877",
          name: "De Pinte",
          state_id: "434",
        },
        {
          id: "7878",
          name: "Deinze",
          state_id: "434",
        },
        {
          id: "7879",
          name: "Denderleeuw",
          state_id: "434",
        },
        {
          id: "7880",
          name: "Dendermonde",
          state_id: "434",
        },
        {
          id: "7881",
          name: "Destelbergen",
          state_id: "434",
        },
        {
          id: "7882",
          name: "Drongen",
          state_id: "434",
        },
        {
          id: "7883",
          name: "Eeklo",
          state_id: "434",
        },
        {
          id: "7884",
          name: "Erembodegem",
          state_id: "434",
        },
        {
          id: "7885",
          name: "Erpe-Mere",
          state_id: "434",
        },
        {
          id: "7886",
          name: "Evergem",
          state_id: "434",
        },
        {
          id: "7887",
          name: "Gavere",
          state_id: "434",
        },
        {
          id: "7888",
          name: "Gent",
          state_id: "434",
        },
        {
          id: "7889",
          name: "Geraardsbergen",
          state_id: "434",
        },
        {
          id: "7890",
          name: "Ghent",
          state_id: "434",
        },
        {
          id: "7891",
          name: "Haaltert",
          state_id: "434",
        },
        {
          id: "7892",
          name: "Hamme",
          state_id: "434",
        },
        {
          id: "7893",
          name: "Herzele",
          state_id: "434",
        },
        {
          id: "7894",
          name: "Horebeke",
          state_id: "434",
        },
        {
          id: "7895",
          name: "Kaprijke",
          state_id: "434",
        },
        {
          id: "7896",
          name: "Kerksken",
          state_id: "434",
        },
        {
          id: "7897",
          name: "Kluisbergen",
          state_id: "434",
        },
        {
          id: "7898",
          name: "Knesselare",
          state_id: "434",
        },
        {
          id: "7899",
          name: "Kruibeke",
          state_id: "434",
        },
        {
          id: "7900",
          name: "Kruishoutem",
          state_id: "434",
        },
        {
          id: "7901",
          name: "Laarne",
          state_id: "434",
        },
        {
          id: "7902",
          name: "Lebbeke",
          state_id: "434",
        },
        {
          id: "7903",
          name: "Lede",
          state_id: "434",
        },
        {
          id: "7904",
          name: "Lierde",
          state_id: "434",
        },
        {
          id: "7905",
          name: "Lochristi",
          state_id: "434",
        },
        {
          id: "7906",
          name: "Lokeren",
          state_id: "434",
        },
        {
          id: "7907",
          name: "Lovendegem",
          state_id: "434",
        },
        {
          id: "7908",
          name: "Maarkedal",
          state_id: "434",
        },
        {
          id: "7909",
          name: "Maldegem",
          state_id: "434",
        },
        {
          id: "7910",
          name: "Melle",
          state_id: "434",
        },
        {
          id: "7911",
          name: "Merelbeke",
          state_id: "434",
        },
        {
          id: "7912",
          name: "Moerbeke",
          state_id: "434",
        },
        {
          id: "7913",
          name: "Nazareth",
          state_id: "434",
        },
        {
          id: "7914",
          name: "Nevele",
          state_id: "434",
        },
        {
          id: "7915",
          name: "Ninove",
          state_id: "434",
        },
        {
          id: "7916",
          name: "Oosterzele",
          state_id: "434",
        },
        {
          id: "7917",
          name: "Oudenaarde",
          state_id: "434",
        },
        {
          id: "7918",
          name: "Ronse",
          state_id: "434",
        },
        {
          id: "7919",
          name: "Semmerzake",
          state_id: "434",
        },
        {
          id: "7920",
          name: "Sint-Gillis-Waas",
          state_id: "434",
        },
        {
          id: "7921",
          name: "Sint-Laureins",
          state_id: "434",
        },
        {
          id: "7922",
          name: "Sint-Lievens-Houtem",
          state_id: "434",
        },
        {
          id: "7923",
          name: "Sint-Martens-Latem",
          state_id: "434",
        },
        {
          id: "7924",
          name: "Sint-Niklaas",
          state_id: "434",
        },
        {
          id: "7925",
          name: "Stekene",
          state_id: "434",
        },
        {
          id: "7926",
          name: "Temse",
          state_id: "434",
        },
        {
          id: "7927",
          name: "Waarschoot",
          state_id: "434",
        },
        {
          id: "7928",
          name: "Waasmunster",
          state_id: "434",
        },
        {
          id: "7929",
          name: "Wachtebeke",
          state_id: "434",
        },
        {
          id: "7930",
          name: "Wetteren",
          state_id: "434",
        },
        {
          id: "7931",
          name: "Wichelen",
          state_id: "434",
        },
        {
          id: "7932",
          name: "Wortegem-Petegem",
          state_id: "434",
        },
        {
          id: "7933",
          name: "Zele",
          state_id: "434",
        },
        {
          id: "7934",
          name: "Zelzate",
          state_id: "434",
        },
        {
          id: "7935",
          name: "Zingem",
          state_id: "434",
        },
        {
          id: "7936",
          name: "Zomergem",
          state_id: "434",
        },
        {
          id: "7937",
          name: "Zottegem",
          state_id: "434",
        },
        {
          id: "7938",
          name: "Zulte",
          state_id: "434",
        },
        {
          id: "7939",
          name: "Zwalm",
          state_id: "434",
        },
        {
          id: "7940",
          name: "Zwijnaarde",
          state_id: "434",
        },
      ],
      "Provincie Brabant": [],
      "Vlaams-Brabant": [
        {
          id: "7941",
          name: "Aarschot",
          state_id: "436",
        },
        {
          id: "7942",
          name: "Affligem",
          state_id: "436",
        },
        {
          id: "7943",
          name: "Asse",
          state_id: "436",
        },
        {
          id: "7944",
          name: "Beersel",
          state_id: "436",
        },
        {
          id: "7945",
          name: "Begijnendijk",
          state_id: "436",
        },
        {
          id: "7946",
          name: "Bekkevoort",
          state_id: "436",
        },
        {
          id: "7947",
          name: "Bertem",
          state_id: "436",
        },
        {
          id: "7948",
          name: "Bever",
          state_id: "436",
        },
        {
          id: "7949",
          name: "Bierbeek",
          state_id: "436",
        },
        {
          id: "7950",
          name: "Boortmeerbeek",
          state_id: "436",
        },
        {
          id: "7951",
          name: "Boutersem",
          state_id: "436",
        },
        {
          id: "7952",
          name: "Diest",
          state_id: "436",
        },
        {
          id: "7953",
          name: "Dilbeek",
          state_id: "436",
        },
        {
          id: "7954",
          name: "Drogenbos",
          state_id: "436",
        },
        {
          id: "7955",
          name: "Galmaarden",
          state_id: "436",
        },
        {
          id: "7956",
          name: "Geetbets",
          state_id: "436",
        },
        {
          id: "7957",
          name: "Glabbeek",
          state_id: "436",
        },
        {
          id: "7958",
          name: "Gooik",
          state_id: "436",
        },
        {
          id: "7959",
          name: "Grimbergen",
          state_id: "436",
        },
        {
          id: "7960",
          name: "Haacht",
          state_id: "436",
        },
        {
          id: "7961",
          name: "Halle",
          state_id: "436",
        },
        {
          id: "7962",
          name: "Herent",
          state_id: "436",
        },
        {
          id: "7963",
          name: "Herne",
          state_id: "436",
        },
        {
          id: "7964",
          name: "Hoegaarden",
          state_id: "436",
        },
        {
          id: "7965",
          name: "Hoeilaart",
          state_id: "436",
        },
        {
          id: "7966",
          name: "Holsbeek",
          state_id: "436",
        },
        {
          id: "7967",
          name: "Huldenberg",
          state_id: "436",
        },
        {
          id: "7968",
          name: "Kampenhout",
          state_id: "436",
        },
        {
          id: "7969",
          name: "Kapelle-op-den-Bos",
          state_id: "436",
        },
        {
          id: "7970",
          name: "Keerbergen",
          state_id: "436",
        },
        {
          id: "7971",
          name: "Kortenaken",
          state_id: "436",
        },
        {
          id: "7972",
          name: "Kortenberg",
          state_id: "436",
        },
        {
          id: "7973",
          name: "Kraainem",
          state_id: "436",
        },
        {
          id: "7974",
          name: "Landen",
          state_id: "436",
        },
        {
          id: "7975",
          name: "Lennik",
          state_id: "436",
        },
        {
          id: "7976",
          name: "Leuven",
          state_id: "436",
        },
        {
          id: "7977",
          name: "Liedekerke",
          state_id: "436",
        },
        {
          id: "7978",
          name: "Linkebeek",
          state_id: "436",
        },
        {
          id: "7979",
          name: "Linter",
          state_id: "436",
        },
        {
          id: "7980",
          name: "Londerzeel",
          state_id: "436",
        },
        {
          id: "7981",
          name: "Lubbeek",
          state_id: "436",
        },
        {
          id: "7982",
          name: "Machelen",
          state_id: "436",
        },
        {
          id: "7983",
          name: "Meise",
          state_id: "436",
        },
        {
          id: "7984",
          name: "Merchtem",
          state_id: "436",
        },
        {
          id: "7985",
          name: "Opwijk",
          state_id: "436",
        },
        {
          id: "7986",
          name: "Oud-Heverlee",
          state_id: "436",
        },
        {
          id: "7987",
          name: "Overijse",
          state_id: "436",
        },
        {
          id: "7988",
          name: "Pepingen",
          state_id: "436",
        },
        {
          id: "7989",
          name: "Roosdaal",
          state_id: "436",
        },
        {
          id: "7990",
          name: "Rotselaar",
          state_id: "436",
        },
        {
          id: "7991",
          name: "Scherpenheuvel-Zichem",
          state_id: "436",
        },
        {
          id: "7992",
          name: "Sint-Genesius-Rode",
          state_id: "436",
        },
        {
          id: "7993",
          name: "Sint-Pieters-Leeuw",
          state_id: "436",
        },
        {
          id: "7994",
          name: "Steenokkerzeel",
          state_id: "436",
        },
        {
          id: "7995",
          name: "Ternat",
          state_id: "436",
        },
        {
          id: "7996",
          name: "Tervuren",
          state_id: "436",
        },
        {
          id: "7997",
          name: "Tielt-Winge",
          state_id: "436",
        },
        {
          id: "7998",
          name: "Tienen",
          state_id: "436",
        },
        {
          id: "7999",
          name: "Tremelo",
          state_id: "436",
        },
        {
          id: "8000",
          name: "Vilvoorde",
          state_id: "436",
        },
        {
          id: "8001",
          name: "Wemmel",
          state_id: "436",
        },
        {
          id: "8002",
          name: "Wezembeek-Oppem",
          state_id: "436",
        },
        {
          id: "8003",
          name: "Zaventem",
          state_id: "436",
        },
        {
          id: "8004",
          name: "Zemst",
          state_id: "436",
        },
        {
          id: "8005",
          name: "Zoutleeuw",
          state_id: "436",
        },
      ],
      Wallonne: [
        {
          id: "8006",
          name: "Callenelle",
          state_id: "437",
        },
        {
          id: "8007",
          name: "Marcinelle",
          state_id: "437",
        },
        {
          id: "8008",
          name: "Strepy-Bracquegnies",
          state_id: "437",
        },
      ],
      "West-Vlaanderen": [
        {
          id: "8009",
          name: "Alveringem",
          state_id: "438",
        },
        {
          id: "8010",
          name: "Anzegem",
          state_id: "438",
        },
        {
          id: "8011",
          name: "Ardooie",
          state_id: "438",
        },
        {
          id: "8012",
          name: "Avelgem",
          state_id: "438",
        },
        {
          id: "8013",
          name: "Beernem",
          state_id: "438",
        },
        {
          id: "8014",
          name: "Blankenberge",
          state_id: "438",
        },
        {
          id: "8015",
          name: "Bredene",
          state_id: "438",
        },
        {
          id: "8016",
          name: "Brugge",
          state_id: "438",
        },
        {
          id: "8017",
          name: "Damme",
          state_id: "438",
        },
        {
          id: "8018",
          name: "De Haan",
          state_id: "438",
        },
        {
          id: "8019",
          name: "De Panne",
          state_id: "438",
        },
        {
          id: "8020",
          name: "Deerlijk",
          state_id: "438",
        },
        {
          id: "8021",
          name: "Dentergem",
          state_id: "438",
        },
        {
          id: "8022",
          name: "Diksmuide",
          state_id: "438",
        },
        {
          id: "8023",
          name: "Geluveld",
          state_id: "438",
        },
        {
          id: "8024",
          name: "Gistel",
          state_id: "438",
        },
        {
          id: "8025",
          name: "Harelbeke",
          state_id: "438",
        },
        {
          id: "8026",
          name: "Heuvelland",
          state_id: "438",
        },
        {
          id: "8027",
          name: "Hooglede",
          state_id: "438",
        },
        {
          id: "8028",
          name: "Houthulst",
          state_id: "438",
        },
        {
          id: "8029",
          name: "Ichtegem",
          state_id: "438",
        },
        {
          id: "8030",
          name: "Ieper",
          state_id: "438",
        },
        {
          id: "8031",
          name: "Ingelmunster",
          state_id: "438",
        },
        {
          id: "8032",
          name: "Ingooigem",
          state_id: "438",
        },
        {
          id: "8033",
          name: "Izegem",
          state_id: "438",
        },
        {
          id: "8034",
          name: "Jabbeke",
          state_id: "438",
        },
        {
          id: "8035",
          name: "Knokke-Heist",
          state_id: "438",
        },
        {
          id: "8036",
          name: "Koekelare",
          state_id: "438",
        },
        {
          id: "8037",
          name: "Koksijde",
          state_id: "438",
        },
        {
          id: "8038",
          name: "Kortemark",
          state_id: "438",
        },
        {
          id: "8039",
          name: "Kortrijk",
          state_id: "438",
        },
        {
          id: "8040",
          name: "Kuurne",
          state_id: "438",
        },
        {
          id: "8041",
          name: "Langemark-Poelkapelle",
          state_id: "438",
        },
        {
          id: "8042",
          name: "Ledegem",
          state_id: "438",
        },
        {
          id: "8043",
          name: "Lendelede",
          state_id: "438",
        },
        {
          id: "8044",
          name: "Lichtervelde",
          state_id: "438",
        },
        {
          id: "8045",
          name: "Lo-Reninge",
          state_id: "438",
        },
        {
          id: "8046",
          name: "Menen",
          state_id: "438",
        },
        {
          id: "8047",
          name: "Mesen",
          state_id: "438",
        },
        {
          id: "8048",
          name: "Meulebeke",
          state_id: "438",
        },
        {
          id: "8049",
          name: "Middelkerke",
          state_id: "438",
        },
        {
          id: "8050",
          name: "Moorslede",
          state_id: "438",
        },
        {
          id: "8051",
          name: "Nieuwpoort",
          state_id: "438",
        },
        {
          id: "8052",
          name: "Oostende",
          state_id: "438",
        },
        {
          id: "8053",
          name: "Oostkamp",
          state_id: "438",
        },
        {
          id: "8054",
          name: "Oostrozebeke",
          state_id: "438",
        },
        {
          id: "8055",
          name: "Oudenburg",
          state_id: "438",
        },
        {
          id: "8056",
          name: "Pittem",
          state_id: "438",
        },
        {
          id: "8057",
          name: "Poperinge",
          state_id: "438",
        },
        {
          id: "8058",
          name: "Roeselare",
          state_id: "438",
        },
        {
          id: "8059",
          name: "Ruiselede",
          state_id: "438",
        },
        {
          id: "8060",
          name: "Spiere-Helkijn",
          state_id: "438",
        },
        {
          id: "8061",
          name: "Staden",
          state_id: "438",
        },
        {
          id: "8062",
          name: "Tielt",
          state_id: "438",
        },
        {
          id: "8063",
          name: "Torhout",
          state_id: "438",
        },
        {
          id: "8064",
          name: "Veurne",
          state_id: "438",
        },
        {
          id: "8065",
          name: "Vleteren",
          state_id: "438",
        },
        {
          id: "8066",
          name: "Waregem",
          state_id: "438",
        },
        {
          id: "8067",
          name: "Wervik",
          state_id: "438",
        },
        {
          id: "8068",
          name: "Wevelgem",
          state_id: "438",
        },
        {
          id: "8069",
          name: "Wielsbeke",
          state_id: "438",
        },
        {
          id: "8070",
          name: "Wingene",
          state_id: "438",
        },
        {
          id: "8071",
          name: "Zedelgem",
          state_id: "438",
        },
        {
          id: "8072",
          name: "Zeebrugge",
          state_id: "438",
        },
        {
          id: "8073",
          name: "Zonnebeke",
          state_id: "438",
        },
        {
          id: "8074",
          name: "Zuienkerke",
          state_id: "438",
        },
        {
          id: "8075",
          name: "Zwevegem",
          state_id: "438",
        },
      ],
    },
  },
  BF: {
    name: "Burkina Faso",
    native: "Burkina Faso",
    phone: "226",
    continent: "AF",
    capital: "Ouagadougou",
    currency: "XOF",
    languages: ["fr", "ff"],
    emoji: "🇧🇫",
    emojiU: "U+1F1E7 U+1F1EB",
    states: {
      Bale: [
        {
          id: "9943",
          name: "Boromo",
          state_id: "575",
        },
      ],
      Bam: [
        {
          id: "9944",
          name: "Kongoussi",
          state_id: "576",
        },
      ],
      Bazega: [
        {
          id: "9945",
          name: "Kombissiri",
          state_id: "577",
        },
      ],
      Bougouriba: [
        {
          id: "9946",
          name: "Diebougou",
          state_id: "578",
        },
        {
          id: "9947",
          name: "Pa",
          state_id: "578",
        },
      ],
      Boulgou: [
        {
          id: "9948",
          name: "Garango",
          state_id: "579",
        },
        {
          id: "9949",
          name: "Tenkodogo",
          state_id: "579",
        },
      ],
      Boulkiemde: [
        {
          id: "9950",
          name: "Koudougou",
          state_id: "580",
        },
      ],
      Comoe: [
        {
          id: "9951",
          name: "Banfora",
          state_id: "581",
        },
      ],
      Ganzourgou: [
        {
          id: "9952",
          name: "Zorgo",
          state_id: "582",
        },
      ],
      Gnagna: [
        {
          id: "9953",
          name: "Bogande",
          state_id: "583",
        },
      ],
      Gourma: [
        {
          id: "9954",
          name: "Fada N''gourma",
          state_id: "584",
        },
      ],
      Houet: [
        {
          id: "9955",
          name: "Bekuy",
          state_id: "585",
        },
        {
          id: "9956",
          name: "Bobo Dioulasso",
          state_id: "585",
        },
      ],
      Ioba: [
        {
          id: "9957",
          name: "Dano",
          state_id: "586",
        },
      ],
      Kadiogo: [
        {
          id: "9958",
          name: "Ouagadougou",
          state_id: "587",
        },
      ],
      Kenedougou: [
        {
          id: "9959",
          name: "Koalla",
          state_id: "588",
        },
        {
          id: "9960",
          name: "Koloko",
          state_id: "588",
        },
        {
          id: "9961",
          name: "Orodara",
          state_id: "588",
        },
      ],
      Komandjari: [
        {
          id: "9962",
          name: "Gayeri",
          state_id: "589",
        },
      ],
      Kompienga: [
        {
          id: "9963",
          name: "Pama",
          state_id: "590",
        },
      ],
      Kossi: [
        {
          id: "9964",
          name: "Nouna",
          state_id: "591",
        },
      ],
      Kouritenga: [
        {
          id: "9965",
          name: "Koupela",
          state_id: "592",
        },
      ],
      Kourweogo: [
        {
          id: "9966",
          name: "Bousse",
          state_id: "593",
        },
      ],
      Leraba: [
        {
          id: "9967",
          name: "Sindou",
          state_id: "594",
        },
      ],
      Mouhoun: [
        {
          id: "9968",
          name: "Dedougou",
          state_id: "595",
        },
      ],
      Nahouri: [
        {
          id: "9969",
          name: "Po",
          state_id: "596",
        },
      ],
      Namentenga: [
        {
          id: "9970",
          name: "Boulsa",
          state_id: "597",
        },
      ],
      Noumbiel: [
        {
          id: "9971",
          name: "Batie",
          state_id: "598",
        },
      ],
      Oubritenga: [
        {
          id: "9972",
          name: "Ziniare",
          state_id: "599",
        },
      ],
      Oudalan: [
        {
          id: "9973",
          name: "Gorom-Gorom",
          state_id: "600",
        },
      ],
      Passore: [
        {
          id: "9974",
          name: "Yako",
          state_id: "601",
        },
      ],
      Poni: [
        {
          id: "9975",
          name: "Gaoua",
          state_id: "602",
        },
        {
          id: "9976",
          name: "Kampti",
          state_id: "602",
        },
        {
          id: "9977",
          name: "Loropeni",
          state_id: "602",
        },
      ],
      Sanguie: [
        {
          id: "9978",
          name: "Reo",
          state_id: "603",
        },
      ],
      Sanmatenga: [
        {
          id: "9979",
          name: "Kaya",
          state_id: "604",
        },
      ],
      Seno: [
        {
          id: "9980",
          name: "Dori",
          state_id: "605",
        },
      ],
      Sissili: [
        {
          id: "9981",
          name: "Gao",
          state_id: "606",
        },
        {
          id: "9982",
          name: "Leo",
          state_id: "606",
        },
      ],
      Soum: [
        {
          id: "9983",
          name: "Aribinda",
          state_id: "607",
        },
        {
          id: "9984",
          name: "Djibo",
          state_id: "607",
        },
      ],
      Sourou: [
        {
          id: "9985",
          name: "Louta",
          state_id: "608",
        },
        {
          id: "9986",
          name: "Tougan",
          state_id: "608",
        },
      ],
      Tapoa: [
        {
          id: "9987",
          name: "Diapaga",
          state_id: "609",
        },
        {
          id: "9988",
          name: "Kantchari",
          state_id: "609",
        },
      ],
      Tuy: [
        {
          id: "9989",
          name: "Hounde",
          state_id: "610",
        },
      ],
      Yatenga: [
        {
          id: "9990",
          name: "Ouahigouya",
          state_id: "611",
        },
      ],
      Zondoma: [
        {
          id: "9991",
          name: "Gourcy",
          state_id: "612",
        },
      ],
      Zoundweogo: [
        {
          id: "9992",
          name: "Manga",
          state_id: "613",
        },
      ],
    },
  },
  BG: {
    name: "Bulgaria",
    native: "България",
    phone: "359",
    continent: "EU",
    capital: "Sofia",
    currency: "BGN",
    languages: ["bg"],
    emoji: "🇧🇬",
    emojiU: "U+1F1E7 U+1F1EC",
    states: {
      Blagoevgrad: [
        {
          id: "9743",
          name: "Bansko",
          state_id: "545",
        },
        {
          id: "9744",
          name: "Belica",
          state_id: "545",
        },
        {
          id: "9745",
          name: "Blagoevgrad",
          state_id: "545",
        },
        {
          id: "9746",
          name: "Goce Delchev",
          state_id: "545",
        },
        {
          id: "9747",
          name: "Hadzhidimovo",
          state_id: "545",
        },
        {
          id: "9748",
          name: "Jakoruda",
          state_id: "545",
        },
        {
          id: "9749",
          name: "Kresna",
          state_id: "545",
        },
        {
          id: "9750",
          name: "Melnik",
          state_id: "545",
        },
        {
          id: "9751",
          name: "Petrich",
          state_id: "545",
        },
        {
          id: "9752",
          name: "Razlog",
          state_id: "545",
        },
        {
          id: "9753",
          name: "Sandanski",
          state_id: "545",
        },
        {
          id: "9754",
          name: "Simitli",
          state_id: "545",
        },
      ],
      Burgas: [
        {
          id: "9755",
          name: "Ahtopol",
          state_id: "546",
        },
        {
          id: "9756",
          name: "Ajtos",
          state_id: "546",
        },
        {
          id: "9757",
          name: "Balgarovo",
          state_id: "546",
        },
        {
          id: "9758",
          name: "Bourgas",
          state_id: "546",
        },
        {
          id: "9759",
          name: "Burgas",
          state_id: "546",
        },
        {
          id: "9760",
          name: "Carevo",
          state_id: "546",
        },
        {
          id: "9761",
          name: "Kableshkovo",
          state_id: "546",
        },
        {
          id: "9762",
          name: "Kameno",
          state_id: "546",
        },
        {
          id: "9763",
          name: "Karnobat",
          state_id: "546",
        },
        {
          id: "9764",
          name: "Malko Tarnovo",
          state_id: "546",
        },
        {
          id: "9765",
          name: "Nesebar",
          state_id: "546",
        },
        {
          id: "9766",
          name: "Obzor",
          state_id: "546",
        },
        {
          id: "9767",
          name: "Pomorie",
          state_id: "546",
        },
        {
          id: "9768",
          name: "Primorsko",
          state_id: "546",
        },
        {
          id: "9769",
          name: "Sozopol",
          state_id: "546",
        },
        {
          id: "9770",
          name: "Sredec",
          state_id: "546",
        },
        {
          id: "9771",
          name: "Sungurlare",
          state_id: "546",
        },
        {
          id: "9772",
          name: "Tvardica",
          state_id: "546",
        },
      ],
      Dobrich: [
        {
          id: "9773",
          name: "Balchik",
          state_id: "547",
        },
        {
          id: "9774",
          name: "Dobrich",
          state_id: "547",
        },
        {
          id: "9775",
          name: "General-Toshevo",
          state_id: "547",
        },
        {
          id: "9776",
          name: "Kavarna",
          state_id: "547",
        },
        {
          id: "9777",
          name: "Loznica",
          state_id: "547",
        },
        {
          id: "9778",
          name: "Shabla",
          state_id: "547",
        },
        {
          id: "9779",
          name: "Tervel",
          state_id: "547",
        },
      ],
      Gabrovo: [
        {
          id: "9780",
          name: "Drjanovo",
          state_id: "548",
        },
        {
          id: "9781",
          name: "Gabrovo",
          state_id: "548",
        },
        {
          id: "9782",
          name: "Plachkovci",
          state_id: "548",
        },
        {
          id: "9783",
          name: "Sevlievo",
          state_id: "548",
        },
        {
          id: "9784",
          name: "Trjavna",
          state_id: "548",
        },
      ],
      Haskovo: [
        {
          id: "9785",
          name: "Dimitrovgrad",
          state_id: "549",
        },
        {
          id: "9786",
          name: "Harmanli",
          state_id: "549",
        },
        {
          id: "9787",
          name: "Haskovo",
          state_id: "549",
        },
        {
          id: "9788",
          name: "Ivajlovgrad",
          state_id: "549",
        },
        {
          id: "9789",
          name: "Ljubimec",
          state_id: "549",
        },
        {
          id: "9790",
          name: "Madzharovo",
          state_id: "549",
        },
        {
          id: "9791",
          name: "Merichleri",
          state_id: "549",
        },
        {
          id: "9792",
          name: "Simeonovgrad",
          state_id: "549",
        },
        {
          id: "9793",
          name: "Svilengrad",
          state_id: "549",
        },
      ],
      Jambol: [
        {
          id: "9794",
          name: "Boljarovo",
          state_id: "550",
        },
        {
          id: "9795",
          name: "Elhovo",
          state_id: "550",
        },
        {
          id: "9796",
          name: "Jambol",
          state_id: "550",
        },
        {
          id: "9797",
          name: "Straldzha",
          state_id: "550",
        },
        {
          id: "9798",
          name: "Topolovgrad",
          state_id: "550",
        },
      ],
      Kardzhali: [
        {
          id: "9799",
          name: "Ardino",
          state_id: "551",
        },
        {
          id: "9800",
          name: "Dzhebel",
          state_id: "551",
        },
        {
          id: "9801",
          name: "Kardzhali",
          state_id: "551",
        },
        {
          id: "9802",
          name: "Krumovgrad",
          state_id: "551",
        },
        {
          id: "9803",
          name: "Momchilgrad",
          state_id: "551",
        },
      ],
      Kjustendil: [
        {
          id: "9804",
          name: "Boboshevo",
          state_id: "552",
        },
        {
          id: "9805",
          name: "Bobovdol",
          state_id: "552",
        },
        {
          id: "9806",
          name: "Dupnica",
          state_id: "552",
        },
        {
          id: "9807",
          name: "Kjustendil",
          state_id: "552",
        },
        {
          id: "9808",
          name: "Kocherinovo",
          state_id: "552",
        },
        {
          id: "9809",
          name: "Rila",
          state_id: "552",
        },
        {
          id: "9810",
          name: "Sapareva Banja",
          state_id: "552",
        },
        {
          id: "9811",
          name: "Zemen",
          state_id: "552",
        },
      ],
      Lovech: [
        {
          id: "9812",
          name: "Aprilci",
          state_id: "553",
        },
        {
          id: "9813",
          name: "Jablanica",
          state_id: "553",
        },
        {
          id: "9814",
          name: "Letnica",
          state_id: "553",
        },
        {
          id: "9815",
          name: "Lovech",
          state_id: "553",
        },
        {
          id: "9816",
          name: "Lukovit",
          state_id: "553",
        },
        {
          id: "9817",
          name: "Sopot",
          state_id: "553",
        },
        {
          id: "9818",
          name: "Teteven",
          state_id: "553",
        },
        {
          id: "9819",
          name: "Trojan",
          state_id: "553",
        },
        {
          id: "9820",
          name: "Ugarchin",
          state_id: "553",
        },
      ],
      Montana: [
        {
          id: "9821",
          name: "Berkovica",
          state_id: "554",
        },
        {
          id: "9822",
          name: "Bojchinovci",
          state_id: "554",
        },
        {
          id: "9823",
          name: "Brusarci",
          state_id: "554",
        },
        {
          id: "9824",
          name: "Chiprovci",
          state_id: "554",
        },
        {
          id: "9825",
          name: "Lom",
          state_id: "554",
        },
        {
          id: "9826",
          name: "Montana",
          state_id: "554",
        },
        {
          id: "9827",
          name: "Valchedram",
          state_id: "554",
        },
        {
          id: "9828",
          name: "Varshec",
          state_id: "554",
        },
      ],
      "Oblast Sofiya-Grad": [],
      Pazardzhik: [
        {
          id: "9829",
          name: "Batak",
          state_id: "556",
        },
        {
          id: "9830",
          name: "Belovo",
          state_id: "556",
        },
        {
          id: "9831",
          name: "Bracigovo",
          state_id: "556",
        },
        {
          id: "9832",
          name: "Koprivshtica",
          state_id: "556",
        },
        {
          id: "9833",
          name: "Panagjurishte",
          state_id: "556",
        },
        {
          id: "9834",
          name: "Pazardzhik",
          state_id: "556",
        },
        {
          id: "9835",
          name: "Peshtera",
          state_id: "556",
        },
        {
          id: "9836",
          name: "Rakitovo",
          state_id: "556",
        },
        {
          id: "9837",
          name: "Septemvri",
          state_id: "556",
        },
        {
          id: "9838",
          name: "Strelcha",
          state_id: "556",
        },
        {
          id: "9839",
          name: "Velingrad",
          state_id: "556",
        },
      ],
      Pernik: [
        {
          id: "9840",
          name: "Bankja",
          state_id: "557",
        },
        {
          id: "9841",
          name: "Batanovci",
          state_id: "557",
        },
        {
          id: "9842",
          name: "Breznik",
          state_id: "557",
        },
        {
          id: "9843",
          name: "Pernik",
          state_id: "557",
        },
        {
          id: "9844",
          name: "Radomir",
          state_id: "557",
        },
        {
          id: "9845",
          name: "Tran",
          state_id: "557",
        },
      ],
      Pleven: [
        {
          id: "9846",
          name: "Belene",
          state_id: "558",
        },
        {
          id: "9847",
          name: "Cherven Brjag",
          state_id: "558",
        },
        {
          id: "9848",
          name: "Dolna Mitropolija",
          state_id: "558",
        },
        {
          id: "9849",
          name: "Dolni Dabnik",
          state_id: "558",
        },
        {
          id: "9850",
          name: "Guljanci",
          state_id: "558",
        },
        {
          id: "9851",
          name: "Levski",
          state_id: "558",
        },
        {
          id: "9852",
          name: "Nikopol",
          state_id: "558",
        },
        {
          id: "9853",
          name: "Pleven",
          state_id: "558",
        },
        {
          id: "9854",
          name: "Pordim",
          state_id: "558",
        },
        {
          id: "9855",
          name: "Slavjanovo",
          state_id: "558",
        },
        {
          id: "9856",
          name: "Trashtenik",
          state_id: "558",
        },
        {
          id: "9857",
          name: "Varbica",
          state_id: "558",
        },
      ],
      Plovdiv: [
        {
          id: "9858",
          name: "Asenovgrad",
          state_id: "559",
        },
        {
          id: "9859",
          name: "Brezovo",
          state_id: "559",
        },
        {
          id: "9860",
          name: "Car Kalojan",
          state_id: "559",
        },
        {
          id: "9861",
          name: "Hisarja",
          state_id: "559",
        },
        {
          id: "9862",
          name: "Kalofer",
          state_id: "559",
        },
        {
          id: "9863",
          name: "Karlovo",
          state_id: "559",
        },
        {
          id: "9864",
          name: "Klisura",
          state_id: "559",
        },
        {
          id: "9865",
          name: "Krichim",
          state_id: "559",
        },
        {
          id: "9866",
          name: "Parvomaj",
          state_id: "559",
        },
        {
          id: "9867",
          name: "Perushtica",
          state_id: "559",
        },
        {
          id: "9868",
          name: "Plovdiv",
          state_id: "559",
        },
        {
          id: "9869",
          name: "Rakovski",
          state_id: "559",
        },
        {
          id: "9870",
          name: "Sadovo",
          state_id: "559",
        },
        {
          id: "9871",
          name: "Saedinenie",
          state_id: "559",
        },
        {
          id: "9872",
          name: "Stambolijski",
          state_id: "559",
        },
      ],
      Razgrad: [
        {
          id: "9873",
          name: "Isperih",
          state_id: "560",
        },
        {
          id: "9874",
          name: "Kubrat",
          state_id: "560",
        },
        {
          id: "9875",
          name: "Razgrad",
          state_id: "560",
        },
        {
          id: "9876",
          name: "Senovo",
          state_id: "560",
        },
        {
          id: "9877",
          name: "Zavet",
          state_id: "560",
        },
      ],
      Ruse: [
        {
          id: "9878",
          name: "Bjala",
          state_id: "561",
        },
        {
          id: "9879",
          name: "Borovo",
          state_id: "561",
        },
        {
          id: "9880",
          name: "Dve Mogili",
          state_id: "561",
        },
        {
          id: "9881",
          name: "Ruse",
          state_id: "561",
        },
        {
          id: "9882",
          name: "Russe",
          state_id: "561",
        },
        {
          id: "9883",
          name: "Vetovo",
          state_id: "561",
        },
      ],
      Shumen: [
        {
          id: "9884",
          name: "Kaolinovo",
          state_id: "562",
        },
        {
          id: "9885",
          name: "Kaspichan",
          state_id: "562",
        },
        {
          id: "9886",
          name: "Novi Pazar",
          state_id: "562",
        },
        {
          id: "9887",
          name: "Pliska",
          state_id: "562",
        },
        {
          id: "9888",
          name: "Shumen",
          state_id: "562",
        },
        {
          id: "9889",
          name: "Smjadovo",
          state_id: "562",
        },
        {
          id: "9890",
          name: "Veliki Preslav",
          state_id: "562",
        },
      ],
      Silistra: [
        {
          id: "9891",
          name: "Alfatar",
          state_id: "563",
        },
        {
          id: "9892",
          name: "Dulovo",
          state_id: "563",
        },
        {
          id: "9893",
          name: "Glavinica",
          state_id: "563",
        },
        {
          id: "9894",
          name: "Silistra",
          state_id: "563",
        },
        {
          id: "9895",
          name: "Tutrakan",
          state_id: "563",
        },
      ],
      Sliven: [
        {
          id: "9896",
          name: "Kermen",
          state_id: "564",
        },
        {
          id: "9897",
          name: "Kotel",
          state_id: "564",
        },
        {
          id: "9898",
          name: "Nova Zagora",
          state_id: "564",
        },
        {
          id: "9899",
          name: "Shivachevo",
          state_id: "564",
        },
        {
          id: "9900",
          name: "Sliven",
          state_id: "564",
        },
      ],
      Smoljan: [
        {
          id: "9901",
          name: "Chepelare",
          state_id: "565",
        },
        {
          id: "9902",
          name: "Devin",
          state_id: "565",
        },
        {
          id: "9903",
          name: "Dospat",
          state_id: "565",
        },
        {
          id: "9904",
          name: "Laki",
          state_id: "565",
        },
        {
          id: "9905",
          name: "Madan",
          state_id: "565",
        },
        {
          id: "9906",
          name: "Nedelino",
          state_id: "565",
        },
        {
          id: "9907",
          name: "Rudozem",
          state_id: "565",
        },
        {
          id: "9908",
          name: "Smoljan",
          state_id: "565",
        },
        {
          id: "9909",
          name: "Zlatograd",
          state_id: "565",
        },
      ],
      "Sofija grad": [],
      "Sofijska oblast": [],
      "Stara Zagora": [],
      Targovishte: [
        {
          id: "9910",
          name: "Antonovo",
          state_id: "569",
        },
        {
          id: "9911",
          name: "Omurtag",
          state_id: "569",
        },
        {
          id: "9912",
          name: "Opaka",
          state_id: "569",
        },
        {
          id: "9913",
          name: "Popovo",
          state_id: "569",
        },
        {
          id: "9914",
          name: "Targovishte",
          state_id: "569",
        },
      ],
      Varna: [
        {
          id: "9915",
          name: "Beloslav",
          state_id: "570",
        },
        {
          id: "9916",
          name: "Bjala",
          state_id: "570",
        },
        {
          id: "9917",
          name: "Dalgopol",
          state_id: "570",
        },
        {
          id: "9918",
          name: "Devnja",
          state_id: "570",
        },
        {
          id: "9919",
          name: "Iskar",
          state_id: "570",
        },
        {
          id: "9920",
          name: "Provadija",
          state_id: "570",
        },
        {
          id: "9921",
          name: "Suvorovo",
          state_id: "570",
        },
        {
          id: "9922",
          name: "Valchi Dol",
          state_id: "570",
        },
        {
          id: "9923",
          name: "Varna",
          state_id: "570",
        },
      ],
      "Veliko Tarnovo": [],
      Vidin: [
        {
          id: "9924",
          name: "Belogradchik",
          state_id: "572",
        },
        {
          id: "9925",
          name: "Bregovo",
          state_id: "572",
        },
        {
          id: "9926",
          name: "Dimovo",
          state_id: "572",
        },
        {
          id: "9927",
          name: "Dolni Chiflik",
          state_id: "572",
        },
        {
          id: "9928",
          name: "Dunavci",
          state_id: "572",
        },
        {
          id: "9929",
          name: "Gramada",
          state_id: "572",
        },
        {
          id: "9930",
          name: "Kula",
          state_id: "572",
        },
        {
          id: "9931",
          name: "Vidin",
          state_id: "572",
        },
      ],
      Vraca: [
        {
          id: "9932",
          name: "Bjala Slatina",
          state_id: "573",
        },
        {
          id: "9933",
          name: "Knezha",
          state_id: "573",
        },
        {
          id: "9934",
          name: "Kojnare",
          state_id: "573",
        },
        {
          id: "9935",
          name: "Kozloduj",
          state_id: "573",
        },
        {
          id: "9936",
          name: "Krivodol",
          state_id: "573",
        },
        {
          id: "9937",
          name: "Mezdra",
          state_id: "573",
        },
        {
          id: "9938",
          name: "Mizija",
          state_id: "573",
        },
        {
          id: "9939",
          name: "Orjahovo",
          state_id: "573",
        },
        {
          id: "9940",
          name: "Roman",
          state_id: "573",
        },
        {
          id: "9941",
          name: "Vraca",
          state_id: "573",
        },
      ],
      Yablaniza: [
        {
          id: "9942",
          name: "Yablaniza",
          state_id: "574",
        },
      ],
    },
  },
  BH: {
    name: "Bahrain",
    native: "‏البحرين",
    phone: "973",
    continent: "AS",
    capital: "Manama",
    currency: "BHD",
    languages: ["ar"],
    emoji: "🇧🇭",
    emojiU: "U+1F1E7 U+1F1ED",
    states: {
      Isa: [
        {
          id: "7255",
          name: "Isa",
          state_id: "327",
        },
      ],
      Badiyah: [
        {
          id: "7256",
          name: "Badiyah",
          state_id: "328",
        },
      ],
      Hidd: [
        {
          id: "7257",
          name: "Hidd",
          state_id: "329",
        },
      ],
      "Jidd Hafs": [],
      Mahama: [
        {
          id: "7258",
          name: "Mahama",
          state_id: "331",
        },
      ],
      Manama: [
        {
          id: "7259",
          name: "Manama",
          state_id: "332",
        },
      ],
      Sitrah: [
        {
          id: "7260",
          name: "Sitrah",
          state_id: "333",
        },
      ],
      "al-Manamah": [
        {
          id: "7261",
          name: "al-Manamah",
          state_id: "334",
        },
      ],
      "al-Muharraq": [
        {
          id: "7262",
          name: "al-Muharraq",
          state_id: "335",
        },
      ],
      "ar-Rifa''a": [
        {
          id: "7263",
          name: "ar-Rifa''a",
          state_id: "336",
        },
      ],
    },
  },
  BI: {
    name: "Burundi",
    native: "Burundi",
    phone: "257",
    continent: "AF",
    capital: "Bujumbura",
    currency: "BIF",
    languages: ["fr", "rn"],
    emoji: "🇧🇮",
    emojiU: "U+1F1E7 U+1F1EE",
    states: {
      Bubanza: [
        {
          id: "9993",
          name: "Bubanza",
          state_id: "614",
        },
      ],
      Bujumbura: [
        {
          id: "9994",
          name: "Bujumbura",
          state_id: "615",
        },
      ],
      Bururi: [
        {
          id: "9995",
          name: "Bururi",
          state_id: "616",
        },
      ],
      Cankuzo: [
        {
          id: "9996",
          name: "Cankuzo",
          state_id: "617",
        },
      ],
      Cibitoke: [
        {
          id: "9997",
          name: "Cibitoke",
          state_id: "618",
        },
      ],
      Gitega: [
        {
          id: "9998",
          name: "Gitega",
          state_id: "619",
        },
      ],
      Karuzi: [
        {
          id: "9999",
          name: "Karuzi",
          state_id: "620",
        },
      ],
      Kayanza: [
        {
          id: "10000",
          name: "Kayanza",
          state_id: "621",
        },
      ],
      Kirundo: [
        {
          id: "10001",
          name: "Kirundo",
          state_id: "622",
        },
      ],
      Makamba: [
        {
          id: "10002",
          name: "Makamba",
          state_id: "623",
        },
      ],
      Muramvya: [
        {
          id: "10003",
          name: "Muramvya",
          state_id: "624",
        },
      ],
      Muyinga: [
        {
          id: "10004",
          name: "Muyinga",
          state_id: "625",
        },
      ],
      Ngozi: [
        {
          id: "10005",
          name: "Ngozi",
          state_id: "626",
        },
      ],
      Rutana: [
        {
          id: "10006",
          name: "Rutana",
          state_id: "627",
        },
      ],
      Ruyigi: [
        {
          id: "10007",
          name: "Ruyigi",
          state_id: "628",
        },
      ],
    },
  },
  BJ: {
    name: "Benin",
    native: "Bénin",
    phone: "229",
    continent: "AF",
    capital: "Porto-Novo",
    currency: "XOF",
    languages: ["fr"],
    emoji: "🇧🇯",
    emojiU: "U+1F1E7 U+1F1EF",
    states: {
      Alibori: [
        {
          id: "8083",
          name: "Kandi",
          state_id: "445",
        },
        {
          id: "8084",
          name: "Malanville",
          state_id: "445",
        },
      ],
      Atacora: [
        {
          id: "8085",
          name: "Batia",
          state_id: "446",
        },
        {
          id: "8086",
          name: "Boukombe",
          state_id: "446",
        },
        {
          id: "8087",
          name: "Kouande",
          state_id: "446",
        },
        {
          id: "8088",
          name: "Natitingou",
          state_id: "446",
        },
      ],
      Atlantique: [
        {
          id: "8089",
          name: "Allada",
          state_id: "447",
        },
        {
          id: "8090",
          name: "Cotonou",
          state_id: "447",
        },
        {
          id: "8091",
          name: "Ouidah",
          state_id: "447",
        },
        {
          id: "8092",
          name: "Tanguiete",
          state_id: "447",
        },
      ],
      Borgou: [
        {
          id: "8093",
          name: "Bembereke",
          state_id: "448",
        },
        {
          id: "8094",
          name: "Nikki",
          state_id: "448",
        },
        {
          id: "8095",
          name: "Parakou",
          state_id: "448",
        },
        {
          id: "8096",
          name: "Tchaourou",
          state_id: "448",
        },
      ],
      Collines: [
        {
          id: "8097",
          name: "Dassa",
          state_id: "449",
        },
        {
          id: "8098",
          name: "Savalou",
          state_id: "449",
        },
        {
          id: "8099",
          name: "Save",
          state_id: "449",
        },
      ],
      Couffo: [
        {
          id: "8100",
          name: "Aplahoue",
          state_id: "450",
        },
        {
          id: "8101",
          name: "Dogbo",
          state_id: "450",
        },
      ],
      Donga: [
        {
          id: "8102",
          name: "Djougou",
          state_id: "451",
        },
      ],
      Littoral: [
        {
          id: "8103",
          name: "Cotonou",
          state_id: "452",
        },
      ],
      Mono: [
        {
          id: "8104",
          name: "Athieme",
          state_id: "453",
        },
        {
          id: "8105",
          name: "Come",
          state_id: "453",
        },
        {
          id: "8106",
          name: "Grand Popo",
          state_id: "453",
        },
        {
          id: "8107",
          name: "Lokossa",
          state_id: "453",
        },
      ],
      Oueme: [
        {
          id: "8108",
          name: "Adjohoun",
          state_id: "454",
        },
        {
          id: "8109",
          name: "Porto Novo",
          state_id: "454",
        },
      ],
      Plateau: [
        {
          id: "8110",
          name: "Ketou",
          state_id: "455",
        },
        {
          id: "8111",
          name: "Pobe",
          state_id: "455",
        },
        {
          id: "8112",
          name: "Sakete",
          state_id: "455",
        },
      ],
      Zou: [
        {
          id: "8113",
          name: "Abomey",
          state_id: "456",
        },
        {
          id: "8114",
          name: "Bohicon",
          state_id: "456",
        },
        {
          id: "8115",
          name: "Cove",
          state_id: "456",
        },
        {
          id: "8116",
          name: "Zagnanado",
          state_id: "456",
        },
      ],
    },
  },
  BL: {
    name: "Saint Barthélemy",
    native: "Saint-Barthélemy",
    phone: "590",
    continent: "NA",
    capital: "Gustavia",
    currency: "EUR",
    languages: ["fr"],
    emoji: "🇧🇱",
    emojiU: "U+1F1E7 U+1F1F1",
    states: {},
  },
  BM: {
    name: "Bermuda",
    native: "Bermuda",
    phone: "1441",
    continent: "NA",
    capital: "Hamilton",
    currency: "BMD",
    languages: ["en"],
    emoji: "🇧🇲",
    emojiU: "U+1F1E7 U+1F1F2",
    states: {
      Hamilton: [
        {
          id: "8117",
          name: "Hamilton",
          state_id: "457",
        },
      ],
      "Saint George": [],
    },
  },
  BN: {
    name: "Brunei",
    native: "Negara Brunei Darussalam",
    phone: "673",
    continent: "AS",
    capital: "Bandar Seri Begawan",
    currency: "BND",
    languages: ["ms"],
    emoji: "🇧🇳",
    emojiU: "U+1F1E7 U+1F1F3",
    states: {
      Belait: [
        {
          id: "9738",
          name: "Kuala Belait",
          state_id: "541",
        },
        {
          id: "9739",
          name: "Seria",
          state_id: "541",
        },
      ],
      "Brunei-Muara": [
        {
          id: "9740",
          name: "Bandar Seri Begawan",
          state_id: "542",
        },
      ],
      Temburong: [
        {
          id: "9741",
          name: "Bangar",
          state_id: "543",
        },
      ],
      Tutong: [
        {
          id: "9742",
          name: "Tutong",
          state_id: "544",
        },
      ],
    },
  },
  BO: {
    name: "Bolivia",
    native: "Bolivia",
    phone: "591",
    continent: "SA",
    capital: "Sucre",
    currency: "BOB,BOV",
    languages: ["es", "ay", "qu"],
    emoji: "🇧🇴",
    emojiU: "U+1F1E7 U+1F1F4",
    states: {
      Beni: [
        {
          id: "8139",
          name: "Guayaramerin",
          state_id: "477",
        },
        {
          id: "8140",
          name: "Magdalena",
          state_id: "477",
        },
        {
          id: "8141",
          name: "Reyes",
          state_id: "477",
        },
        {
          id: "8142",
          name: "Riberalta",
          state_id: "477",
        },
        {
          id: "8143",
          name: "Rurrenabaque",
          state_id: "477",
        },
        {
          id: "8144",
          name: "San Borja",
          state_id: "477",
        },
        {
          id: "8145",
          name: "San Ignacio",
          state_id: "477",
        },
        {
          id: "8146",
          name: "San Ramon",
          state_id: "477",
        },
        {
          id: "8147",
          name: "Santa Ana",
          state_id: "477",
        },
        {
          id: "8148",
          name: "Santa Rosa",
          state_id: "477",
        },
        {
          id: "8149",
          name: "Trinidad",
          state_id: "477",
        },
      ],
      Chuquisaca: [
        {
          id: "8150",
          name: "Camargo",
          state_id: "478",
        },
        {
          id: "8151",
          name: "Monteagudo",
          state_id: "478",
        },
        {
          id: "8152",
          name: "Muyupampa",
          state_id: "478",
        },
        {
          id: "8153",
          name: "Padilla",
          state_id: "478",
        },
        {
          id: "8154",
          name: "Sucre",
          state_id: "478",
        },
        {
          id: "8155",
          name: "Tarabuco",
          state_id: "478",
        },
        {
          id: "8156",
          name: "Villa Serano",
          state_id: "478",
        },
      ],
      Cochabamba: [
        {
          id: "8157",
          name: "Aiquile",
          state_id: "479",
        },
        {
          id: "8158",
          name: "Arani",
          state_id: "479",
        },
        {
          id: "8159",
          name: "Capinota",
          state_id: "479",
        },
        {
          id: "8160",
          name: "Chimore",
          state_id: "479",
        },
        {
          id: "8161",
          name: "Cliza",
          state_id: "479",
        },
        {
          id: "8162",
          name: "Cochabamba",
          state_id: "479",
        },
        {
          id: "8163",
          name: "Colomi",
          state_id: "479",
        },
        {
          id: "8164",
          name: "Entre Rios",
          state_id: "479",
        },
        {
          id: "8165",
          name: "Irpa Irpa",
          state_id: "479",
        },
        {
          id: "8166",
          name: "Ivirgarzama",
          state_id: "479",
        },
        {
          id: "8167",
          name: "Mizque",
          state_id: "479",
        },
        {
          id: "8168",
          name: "Punata",
          state_id: "479",
        },
        {
          id: "8169",
          name: "Shinahota",
          state_id: "479",
        },
        {
          id: "8170",
          name: "Sipe Sipe",
          state_id: "479",
        },
        {
          id: "8171",
          name: "Tarata",
          state_id: "479",
        },
        {
          id: "8172",
          name: "Ucurena",
          state_id: "479",
        },
      ],
      "La Paz": [],
      Oruro: [
        {
          id: "8173",
          name: "Caracollo",
          state_id: "481",
        },
        {
          id: "8174",
          name: "Challapata",
          state_id: "481",
        },
        {
          id: "8175",
          name: "Eucaliptus",
          state_id: "481",
        },
        {
          id: "8176",
          name: "Huanuni",
          state_id: "481",
        },
        {
          id: "8177",
          name: "Machacamarca",
          state_id: "481",
        },
        {
          id: "8178",
          name: "Oruro",
          state_id: "481",
        },
        {
          id: "8179",
          name: "Poopo",
          state_id: "481",
        },
        {
          id: "8180",
          name: "Santiago de Huari",
          state_id: "481",
        },
        {
          id: "8181",
          name: "Totoral",
          state_id: "481",
        },
      ],
      Pando: [
        {
          id: "8182",
          name: "Cobija",
          state_id: "482",
        },
      ],
      Potosi: [
        {
          id: "8183",
          name: "Atocha",
          state_id: "483",
        },
        {
          id: "8184",
          name: "Betanzos",
          state_id: "483",
        },
        {
          id: "8185",
          name: "Colquechaca",
          state_id: "483",
        },
        {
          id: "8186",
          name: "Llallagua",
          state_id: "483",
        },
        {
          id: "8187",
          name: "Potosi",
          state_id: "483",
        },
        {
          id: "8188",
          name: "Santa Barbara",
          state_id: "483",
        },
        {
          id: "8189",
          name: "Tupiza",
          state_id: "483",
        },
        {
          id: "8190",
          name: "Uncia",
          state_id: "483",
        },
        {
          id: "8191",
          name: "Uyuni",
          state_id: "483",
        },
        {
          id: "8192",
          name: "Villazon",
          state_id: "483",
        },
      ],
      "Santa Cruz": [],
      Tarija: [
        {
          id: "8193",
          name: "Bermejo",
          state_id: "485",
        },
        {
          id: "8194",
          name: "Entre Rios",
          state_id: "485",
        },
        {
          id: "8195",
          name: "San Lorenzo",
          state_id: "485",
        },
        {
          id: "8196",
          name: "Tarija",
          state_id: "485",
        },
        {
          id: "8197",
          name: "Villamontes",
          state_id: "485",
        },
        {
          id: "8198",
          name: "Yacuiba",
          state_id: "485",
        },
      ],
    },
  },
  BQ: {
    name: "Bonaire",
    native: "Bonaire",
    phone: "5997",
    continent: "NA",
    capital: "Kralendijk",
    currency: "USD",
    languages: ["nl"],
    emoji: "🇧🇶",
    emojiU: "U+1F1E7 U+1F1F6",
    states: {},
  },
  BR: {
    name: "Brazil",
    native: "Brasil",
    phone: "55",
    continent: "SA",
    capital: "Brasília",
    currency: "BRL",
    languages: ["pt"],
    emoji: "🇧🇷",
    emojiU: "U+1F1E7 U+1F1F7",
    states: {
      Acre: [
        {
          id: "8509",
          name: "Acrelandia",
          state_id: "512",
        },
        {
          id: "8510",
          name: "Brasileia",
          state_id: "512",
        },
        {
          id: "8511",
          name: "Cruzeiro do Sul",
          state_id: "512",
        },
        {
          id: "8512",
          name: "Epitaciolandia",
          state_id: "512",
        },
        {
          id: "8513",
          name: "Feijo",
          state_id: "512",
        },
        {
          id: "8514",
          name: "Mancio Lima",
          state_id: "512",
        },
        {
          id: "8515",
          name: "Manoel Urbano",
          state_id: "512",
        },
        {
          id: "8516",
          name: "Marechal Thaumaturgo",
          state_id: "512",
        },
        {
          id: "8517",
          name: "Placido de Castro",
          state_id: "512",
        },
        {
          id: "8518",
          name: "Porto Walter",
          state_id: "512",
        },
        {
          id: "8519",
          name: "Rio Branco",
          state_id: "512",
        },
        {
          id: "8520",
          name: "Rodrigues Alves",
          state_id: "512",
        },
        {
          id: "8521",
          name: "Sena Madureira",
          state_id: "512",
        },
        {
          id: "8522",
          name: "Senador Guiomard",
          state_id: "512",
        },
        {
          id: "8523",
          name: "Tarauaca",
          state_id: "512",
        },
        {
          id: "8524",
          name: "Xapuri",
          state_id: "512",
        },
      ],
      Alagoas: [
        {
          id: "8525",
          name: "Agua Branca",
          state_id: "513",
        },
        {
          id: "8526",
          name: "Anadia",
          state_id: "513",
        },
        {
          id: "8527",
          name: "Arapiraca",
          state_id: "513",
        },
        {
          id: "8528",
          name: "Atalaia",
          state_id: "513",
        },
        {
          id: "8529",
          name: "Barra de Santo Antonio",
          state_id: "513",
        },
        {
          id: "8530",
          name: "Batalha",
          state_id: "513",
        },
        {
          id: "8531",
          name: "Boca da Mata",
          state_id: "513",
        },
        {
          id: "8532",
          name: "Cacimbinhas",
          state_id: "513",
        },
        {
          id: "8533",
          name: "Cajueiro",
          state_id: "513",
        },
        {
          id: "8534",
          name: "Campo Alegre",
          state_id: "513",
        },
        {
          id: "8535",
          name: "Campo Grande",
          state_id: "513",
        },
        {
          id: "8536",
          name: "Canapi",
          state_id: "513",
        },
        {
          id: "8537",
          name: "Capela",
          state_id: "513",
        },
        {
          id: "8538",
          name: "Coite do Noia",
          state_id: "513",
        },
        {
          id: "8539",
          name: "Colonia Leopoldina",
          state_id: "513",
        },
        {
          id: "8540",
          name: "Coruripe",
          state_id: "513",
        },
        {
          id: "8541",
          name: "Craibas",
          state_id: "513",
        },
        {
          id: "8542",
          name: "Delmiro Gouveia",
          state_id: "513",
        },
        {
          id: "8543",
          name: "Dois Riachos",
          state_id: "513",
        },
        {
          id: "8544",
          name: "Estrela de Alagoas",
          state_id: "513",
        },
        {
          id: "8545",
          name: "Feira Grande",
          state_id: "513",
        },
        {
          id: "8546",
          name: "Flexeiras",
          state_id: "513",
        },
        {
          id: "8547",
          name: "Girau do Ponciano",
          state_id: "513",
        },
        {
          id: "8548",
          name: "Ibateguara",
          state_id: "513",
        },
        {
          id: "8549",
          name: "Igaci",
          state_id: "513",
        },
        {
          id: "8550",
          name: "Igreja Nova",
          state_id: "513",
        },
        {
          id: "8551",
          name: "Inhapi",
          state_id: "513",
        },
        {
          id: "8552",
          name: "Joaquim Gomes",
          state_id: "513",
        },
        {
          id: "8553",
          name: "Jundia",
          state_id: "513",
        },
        {
          id: "8554",
          name: "Junqueiro",
          state_id: "513",
        },
        {
          id: "8555",
          name: "Lagoa da Canoa",
          state_id: "513",
        },
        {
          id: "8556",
          name: "Limoeiro de Anadia",
          state_id: "513",
        },
        {
          id: "8557",
          name: "Maceio",
          state_id: "513",
        },
        {
          id: "8558",
          name: "Major Isidoro",
          state_id: "513",
        },
        {
          id: "8559",
          name: "Maragogi",
          state_id: "513",
        },
        {
          id: "8560",
          name: "Maravilha",
          state_id: "513",
        },
        {
          id: "8561",
          name: "Marechal Deodoro",
          state_id: "513",
        },
        {
          id: "8562",
          name: "Maribondo",
          state_id: "513",
        },
        {
          id: "8563",
          name: "Mata Grande",
          state_id: "513",
        },
        {
          id: "8564",
          name: "Matriz de Camaragibe",
          state_id: "513",
        },
        {
          id: "8565",
          name: "Messias",
          state_id: "513",
        },
        {
          id: "8566",
          name: "Minador do Negrao",
          state_id: "513",
        },
        {
          id: "8567",
          name: "Murici",
          state_id: "513",
        },
        {
          id: "8568",
          name: "Novo Lino",
          state_id: "513",
        },
        {
          id: "8569",
          name: "Olho d''Agua das Flores",
          state_id: "513",
        },
        {
          id: "8570",
          name: "Olivenca",
          state_id: "513",
        },
        {
          id: "8571",
          name: "Palmeira dos Indios",
          state_id: "513",
        },
        {
          id: "8572",
          name: "Pao de Acucar",
          state_id: "513",
        },
        {
          id: "8573",
          name: "Passo de Camaragibe",
          state_id: "513",
        },
        {
          id: "8574",
          name: "Penedo",
          state_id: "513",
        },
        {
          id: "8575",
          name: "Piacabucu",
          state_id: "513",
        },
        {
          id: "8576",
          name: "Pilar",
          state_id: "513",
        },
        {
          id: "8577",
          name: "Piranhas",
          state_id: "513",
        },
        {
          id: "8578",
          name: "Poco das Trincheiras",
          state_id: "513",
        },
        {
          id: "8579",
          name: "Porto Calvo",
          state_id: "513",
        },
        {
          id: "8580",
          name: "Porto Real do Colegio",
          state_id: "513",
        },
        {
          id: "8581",
          name: "Quebrangulo",
          state_id: "513",
        },
        {
          id: "8582",
          name: "Rio Largo",
          state_id: "513",
        },
        {
          id: "8583",
          name: "Santana do Ipanema",
          state_id: "513",
        },
        {
          id: "8584",
          name: "Santana do Mundau",
          state_id: "513",
        },
        {
          id: "8585",
          name: "Sao Jose da Laje",
          state_id: "513",
        },
        {
          id: "8586",
          name: "Sao Jose da Tapera",
          state_id: "513",
        },
        {
          id: "8587",
          name: "Sao Luis do Quitunde",
          state_id: "513",
        },
        {
          id: "8588",
          name: "Sao Miguel dos Campos",
          state_id: "513",
        },
        {
          id: "8589",
          name: "Sao Sebastiao",
          state_id: "513",
        },
        {
          id: "8590",
          name: "Satuba",
          state_id: "513",
        },
        {
          id: "8591",
          name: "Senador Rui Palmeira",
          state_id: "513",
        },
        {
          id: "8592",
          name: "Taquarana",
          state_id: "513",
        },
        {
          id: "8593",
          name: "Teotonio Vilela",
          state_id: "513",
        },
        {
          id: "8594",
          name: "Traipu",
          state_id: "513",
        },
        {
          id: "8595",
          name: "Uniao dos Palmares",
          state_id: "513",
        },
        {
          id: "8596",
          name: "Vicosa",
          state_id: "513",
        },
      ],
      Amapa: [
        {
          id: "8597",
          name: "Amapa",
          state_id: "514",
        },
        {
          id: "8598",
          name: "Laranjal do Jari",
          state_id: "514",
        },
        {
          id: "8599",
          name: "Macapa",
          state_id: "514",
        },
        {
          id: "8600",
          name: "Mazagao",
          state_id: "514",
        },
        {
          id: "8601",
          name: "Oiapoque",
          state_id: "514",
        },
        {
          id: "8602",
          name: "Santana",
          state_id: "514",
        },
      ],
      Amazonas: [
        {
          id: "8603",
          name: "Alvaraes",
          state_id: "515",
        },
        {
          id: "8604",
          name: "Anori",
          state_id: "515",
        },
        {
          id: "8605",
          name: "Apui",
          state_id: "515",
        },
        {
          id: "8606",
          name: "Autazes",
          state_id: "515",
        },
        {
          id: "8607",
          name: "Barcelos",
          state_id: "515",
        },
        {
          id: "8608",
          name: "Barreirinha",
          state_id: "515",
        },
        {
          id: "8609",
          name: "Benjamin Constant",
          state_id: "515",
        },
        {
          id: "8610",
          name: "Boca do Acre",
          state_id: "515",
        },
        {
          id: "8611",
          name: "Borba",
          state_id: "515",
        },
        {
          id: "8612",
          name: "Canutama",
          state_id: "515",
        },
        {
          id: "8613",
          name: "Carauari",
          state_id: "515",
        },
        {
          id: "8614",
          name: "Careiro",
          state_id: "515",
        },
        {
          id: "8615",
          name: "Careiro da Varzea",
          state_id: "515",
        },
        {
          id: "8616",
          name: "Coari",
          state_id: "515",
        },
        {
          id: "8617",
          name: "Codajas",
          state_id: "515",
        },
        {
          id: "8618",
          name: "Eirunepe",
          state_id: "515",
        },
        {
          id: "8619",
          name: "Envira",
          state_id: "515",
        },
        {
          id: "8620",
          name: "Fonte Boa",
          state_id: "515",
        },
        {
          id: "8621",
          name: "Guajara",
          state_id: "515",
        },
        {
          id: "8622",
          name: "Humaita",
          state_id: "515",
        },
        {
          id: "8623",
          name: "Ipixuna",
          state_id: "515",
        },
        {
          id: "8624",
          name: "Iranduba",
          state_id: "515",
        },
        {
          id: "8625",
          name: "Itacoatiara",
          state_id: "515",
        },
        {
          id: "8626",
          name: "Japura",
          state_id: "515",
        },
        {
          id: "8627",
          name: "Jutai",
          state_id: "515",
        },
        {
          id: "8628",
          name: "Labrea",
          state_id: "515",
        },
        {
          id: "8629",
          name: "Manacapuru",
          state_id: "515",
        },
        {
          id: "8630",
          name: "Manaquiri",
          state_id: "515",
        },
        {
          id: "8631",
          name: "Manaus",
          state_id: "515",
        },
        {
          id: "8632",
          name: "Manicore",
          state_id: "515",
        },
        {
          id: "8633",
          name: "Maraa",
          state_id: "515",
        },
        {
          id: "8634",
          name: "Maues",
          state_id: "515",
        },
        {
          id: "8635",
          name: "Nhamunda",
          state_id: "515",
        },
        {
          id: "8636",
          name: "Nova Olinda do Norte",
          state_id: "515",
        },
        {
          id: "8637",
          name: "Novo Airao",
          state_id: "515",
        },
        {
          id: "8638",
          name: "Novo Aripuana",
          state_id: "515",
        },
        {
          id: "8639",
          name: "Parintins",
          state_id: "515",
        },
        {
          id: "8640",
          name: "Pauini",
          state_id: "515",
        },
        {
          id: "8641",
          name: "Rio Preto da Eva",
          state_id: "515",
        },
        {
          id: "8642",
          name: "Santa Isabel do Rio Negro",
          state_id: "515",
        },
        {
          id: "8643",
          name: "Santo Antonio do Ica",
          state_id: "515",
        },
        {
          id: "8644",
          name: "Sao Gabriel da Cachoeira",
          state_id: "515",
        },
        {
          id: "8645",
          name: "Sao Paulo de Olivenca",
          state_id: "515",
        },
        {
          id: "8646",
          name: "Tabatinga",
          state_id: "515",
        },
        {
          id: "8647",
          name: "Tapaua",
          state_id: "515",
        },
        {
          id: "8648",
          name: "Tefe",
          state_id: "515",
        },
        {
          id: "8649",
          name: "Tonantins",
          state_id: "515",
        },
        {
          id: "8650",
          name: "Uarini",
          state_id: "515",
        },
        {
          id: "8651",
          name: "Urucara",
          state_id: "515",
        },
        {
          id: "8652",
          name: "Urucurituba",
          state_id: "515",
        },
      ],
      Bahia: [
        {
          id: "8653",
          name: "Acajutiba",
          state_id: "516",
        },
        {
          id: "8654",
          name: "Alagoinhas",
          state_id: "516",
        },
        {
          id: "8655",
          name: "Amargosa",
          state_id: "516",
        },
        {
          id: "8656",
          name: "Amelia Rodrigues",
          state_id: "516",
        },
        {
          id: "8657",
          name: "America Dourada",
          state_id: "516",
        },
        {
          id: "8658",
          name: "Anage",
          state_id: "516",
        },
        {
          id: "8659",
          name: "Araci",
          state_id: "516",
        },
        {
          id: "8660",
          name: "Aurelino Leal",
          state_id: "516",
        },
        {
          id: "8661",
          name: "Baixa Grande",
          state_id: "516",
        },
        {
          id: "8662",
          name: "Barra",
          state_id: "516",
        },
        {
          id: "8663",
          name: "Barra da Estiva",
          state_id: "516",
        },
        {
          id: "8664",
          name: "Barra do Choca",
          state_id: "516",
        },
        {
          id: "8665",
          name: "Barreiras",
          state_id: "516",
        },
        {
          id: "8666",
          name: "Belmonte",
          state_id: "516",
        },
        {
          id: "8667",
          name: "Boa Vista do Tupim",
          state_id: "516",
        },
        {
          id: "8668",
          name: "Bom Jesus da Lapa",
          state_id: "516",
        },
        {
          id: "8669",
          name: "Boquira",
          state_id: "516",
        },
        {
          id: "8670",
          name: "Brumado",
          state_id: "516",
        },
        {
          id: "8671",
          name: "Buerarema",
          state_id: "516",
        },
        {
          id: "8672",
          name: "Cachoeira",
          state_id: "516",
        },
        {
          id: "8673",
          name: "Cacule",
          state_id: "516",
        },
        {
          id: "8674",
          name: "Caetite",
          state_id: "516",
        },
        {
          id: "8675",
          name: "Cafarnaum",
          state_id: "516",
        },
        {
          id: "8676",
          name: "Camacan",
          state_id: "516",
        },
        {
          id: "8677",
          name: "Camacari",
          state_id: "516",
        },
        {
          id: "8678",
          name: "Camamu",
          state_id: "516",
        },
        {
          id: "8679",
          name: "Campo Alegre de Lourdes",
          state_id: "516",
        },
        {
          id: "8680",
          name: "Campo Formoso",
          state_id: "516",
        },
        {
          id: "8681",
          name: "Canarana",
          state_id: "516",
        },
        {
          id: "8682",
          name: "Canavieiras",
          state_id: "516",
        },
        {
          id: "8683",
          name: "Candeias",
          state_id: "516",
        },
        {
          id: "8684",
          name: "Candido Sales",
          state_id: "516",
        },
        {
          id: "8685",
          name: "Cansancao",
          state_id: "516",
        },
        {
          id: "8686",
          name: "Capim Grosso",
          state_id: "516",
        },
        {
          id: "8687",
          name: "Caravelas",
          state_id: "516",
        },
        {
          id: "8688",
          name: "Carinhanha",
          state_id: "516",
        },
        {
          id: "8689",
          name: "Casa Nova",
          state_id: "516",
        },
        {
          id: "8690",
          name: "Castro Alves",
          state_id: "516",
        },
        {
          id: "8691",
          name: "Catu",
          state_id: "516",
        },
        {
          id: "8692",
          name: "Cicero Dantas",
          state_id: "516",
        },
        {
          id: "8693",
          name: "Cipo",
          state_id: "516",
        },
        {
          id: "8694",
          name: "Coaraci",
          state_id: "516",
        },
        {
          id: "8695",
          name: "Conceicao da Feira",
          state_id: "516",
        },
        {
          id: "8696",
          name: "Conceicao do Almeida",
          state_id: "516",
        },
        {
          id: "8697",
          name: "Conceicao do Coite",
          state_id: "516",
        },
        {
          id: "8698",
          name: "Conceicao do Jacuipe",
          state_id: "516",
        },
        {
          id: "8699",
          name: "Conde",
          state_id: "516",
        },
        {
          id: "8700",
          name: "Coracao de Maria",
          state_id: "516",
        },
        {
          id: "8701",
          name: "Coronel Joao Sa",
          state_id: "516",
        },
        {
          id: "8702",
          name: "Correntina",
          state_id: "516",
        },
        {
          id: "8703",
          name: "Cruz das Almas",
          state_id: "516",
        },
        {
          id: "8704",
          name: "Curaca",
          state_id: "516",
        },
        {
          id: "8705",
          name: "Dias d''Avila",
          state_id: "516",
        },
        {
          id: "8706",
          name: "Encruzilhada",
          state_id: "516",
        },
        {
          id: "8707",
          name: "Entre Rios",
          state_id: "516",
        },
        {
          id: "8708",
          name: "Esplanada",
          state_id: "516",
        },
        {
          id: "8709",
          name: "Euclides da Cunha",
          state_id: "516",
        },
        {
          id: "8710",
          name: "Eunapolis",
          state_id: "516",
        },
        {
          id: "8711",
          name: "Feira de Santana",
          state_id: "516",
        },
        {
          id: "8712",
          name: "Filadelfia",
          state_id: "516",
        },
        {
          id: "8713",
          name: "Formosa do Rio Preto",
          state_id: "516",
        },
        {
          id: "8714",
          name: "Gandu",
          state_id: "516",
        },
        {
          id: "8715",
          name: "Guanambi",
          state_id: "516",
        },
        {
          id: "8716",
          name: "Guaratinga",
          state_id: "516",
        },
        {
          id: "8717",
          name: "Iacu",
          state_id: "516",
        },
        {
          id: "8718",
          name: "Ibicarai",
          state_id: "516",
        },
        {
          id: "8719",
          name: "Ibicui",
          state_id: "516",
        },
        {
          id: "8721",
          name: "Ibirapitanga",
          state_id: "516",
        },
        {
          id: "8722",
          name: "Ibirataia",
          state_id: "516",
        },
        {
          id: "8723",
          name: "Ibotirama",
          state_id: "516",
        },
        {
          id: "8724",
          name: "Iguai",
          state_id: "516",
        },
        {
          id: "8725",
          name: "Ilheus",
          state_id: "516",
        },
        {
          id: "8726",
          name: "Inhambupe",
          state_id: "516",
        },
        {
          id: "8727",
          name: "Ipiau",
          state_id: "516",
        },
        {
          id: "8728",
          name: "Ipira",
          state_id: "516",
        },
        {
          id: "8729",
          name: "Iraquara",
          state_id: "516",
        },
        {
          id: "8730",
          name: "Irara",
          state_id: "516",
        },
        {
          id: "8731",
          name: "Irece",
          state_id: "516",
        },
        {
          id: "8732",
          name: "Itabela",
          state_id: "516",
        },
        {
          id: "8733",
          name: "Itaberaba",
          state_id: "516",
        },
        {
          id: "8734",
          name: "Itabuna",
          state_id: "516",
        },
        {
          id: "8735",
          name: "Itacare",
          state_id: "516",
        },
        {
          id: "8736",
          name: "Itagi",
          state_id: "516",
        },
        {
          id: "8737",
          name: "Itagiba",
          state_id: "516",
        },
        {
          id: "8738",
          name: "Itajuipe",
          state_id: "516",
        },
        {
          id: "8739",
          name: "Itamaraju",
          state_id: "516",
        },
        {
          id: "8740",
          name: "Itambe",
          state_id: "516",
        },
        {
          id: "8741",
          name: "Itanhem",
          state_id: "516",
        },
        {
          id: "8742",
          name: "Itaparica",
          state_id: "516",
        },
        {
          id: "8743",
          name: "Itapetinga",
          state_id: "516",
        },
        {
          id: "8744",
          name: "Itapicuru",
          state_id: "516",
        },
        {
          id: "8745",
          name: "Itarantim",
          state_id: "516",
        },
        {
          id: "8746",
          name: "Itirucu",
          state_id: "516",
        },
        {
          id: "8747",
          name: "Itiuba",
          state_id: "516",
        },
        {
          id: "8748",
          name: "Itororo",
          state_id: "516",
        },
        {
          id: "8749",
          name: "Ituacu",
          state_id: "516",
        },
        {
          id: "8750",
          name: "Itubera",
          state_id: "516",
        },
        {
          id: "8751",
          name: "Jacobina",
          state_id: "516",
        },
        {
          id: "8752",
          name: "Jaguaquara",
          state_id: "516",
        },
        {
          id: "8753",
          name: "Jaguarari",
          state_id: "516",
        },
        {
          id: "8754",
          name: "Jequie",
          state_id: "516",
        },
        {
          id: "8755",
          name: "Jeremoabo",
          state_id: "516",
        },
        {
          id: "8756",
          name: "Jitauna",
          state_id: "516",
        },
        {
          id: "8757",
          name: "Joao Dourado",
          state_id: "516",
        },
        {
          id: "8758",
          name: "Juazeiro",
          state_id: "516",
        },
        {
          id: "8759",
          name: "Jussara",
          state_id: "516",
        },
        {
          id: "8760",
          name: "Laje",
          state_id: "516",
        },
        {
          id: "8761",
          name: "Lapao",
          state_id: "516",
        },
        {
          id: "8762",
          name: "Lauro de Freitas",
          state_id: "516",
        },
        {
          id: "8763",
          name: "Livramento",
          state_id: "516",
        },
        {
          id: "8764",
          name: "Macarani",
          state_id: "516",
        },
        {
          id: "8765",
          name: "Macaubas",
          state_id: "516",
        },
        {
          id: "8766",
          name: "Madre de Deus",
          state_id: "516",
        },
        {
          id: "8767",
          name: "Mairi",
          state_id: "516",
        },
        {
          id: "8768",
          name: "Maracas",
          state_id: "516",
        },
        {
          id: "8769",
          name: "Maragogipe",
          state_id: "516",
        },
        {
          id: "8770",
          name: "Marau",
          state_id: "516",
        },
        {
          id: "8771",
          name: "Mascote",
          state_id: "516",
        },
        {
          id: "8772",
          name: "Mata de Sao Joao",
          state_id: "516",
        },
        {
          id: "8773",
          name: "Medeiros Neto",
          state_id: "516",
        },
        {
          id: "8774",
          name: "Miguel Calmon",
          state_id: "516",
        },
        {
          id: "8775",
          name: "Milagres",
          state_id: "516",
        },
        {
          id: "8776",
          name: "Monte Santo",
          state_id: "516",
        },
        {
          id: "8777",
          name: "Morro de Chapeu",
          state_id: "516",
        },
        {
          id: "8778",
          name: "Mucuri",
          state_id: "516",
        },
        {
          id: "8779",
          name: "Mundo Novo",
          state_id: "516",
        },
        {
          id: "8780",
          name: "Muritiba",
          state_id: "516",
        },
        {
          id: "8781",
          name: "Mutuipe",
          state_id: "516",
        },
        {
          id: "8782",
          name: "Nazare",
          state_id: "516",
        },
        {
          id: "8783",
          name: "Nova Soure",
          state_id: "516",
        },
        {
          id: "8784",
          name: "Nova Vicosa",
          state_id: "516",
        },
        {
          id: "8785",
          name: "Olindina",
          state_id: "516",
        },
        {
          id: "8786",
          name: "Oliveira dos Brejinhos",
          state_id: "516",
        },
        {
          id: "8787",
          name: "Palmas de Monte Alto",
          state_id: "516",
        },
        {
          id: "8788",
          name: "Paramirim",
          state_id: "516",
        },
        {
          id: "8789",
          name: "Paratinga",
          state_id: "516",
        },
        {
          id: "8790",
          name: "Paripiranga",
          state_id: "516",
        },
        {
          id: "8791",
          name: "Pau Brasil",
          state_id: "516",
        },
        {
          id: "8792",
          name: "Paulo Afonso",
          state_id: "516",
        },
        {
          id: "8793",
          name: "Pilao Arcado",
          state_id: "516",
        },
        {
          id: "8794",
          name: "Pindobacu",
          state_id: "516",
        },
        {
          id: "8795",
          name: "Piritiba",
          state_id: "516",
        },
        {
          id: "8796",
          name: "Planalto",
          state_id: "516",
        },
        {
          id: "8797",
          name: "Pocoes",
          state_id: "516",
        },
        {
          id: "8798",
          name: "Pojuca",
          state_id: "516",
        },
        {
          id: "8799",
          name: "Ponto Novo",
          state_id: "516",
        },
        {
          id: "8800",
          name: "Porto Seguro",
          state_id: "516",
        },
        {
          id: "8801",
          name: "Prado",
          state_id: "516",
        },
        {
          id: "8802",
          name: "Presidente Tancredo Neves",
          state_id: "516",
        },
        {
          id: "8803",
          name: "Queimadas",
          state_id: "516",
        },
        {
          id: "8804",
          name: "Quijingue",
          state_id: "516",
        },
        {
          id: "8805",
          name: "Rafael Jambeiro",
          state_id: "516",
        },
        {
          id: "8806",
          name: "Remanso",
          state_id: "516",
        },
        {
          id: "8807",
          name: "Riachao das Neves",
          state_id: "516",
        },
        {
          id: "8808",
          name: "Riachao do Jacuipe",
          state_id: "516",
        },
        {
          id: "8809",
          name: "Riacho de Santana",
          state_id: "516",
        },
        {
          id: "8810",
          name: "Ribeira do Pombal",
          state_id: "516",
        },
        {
          id: "8811",
          name: "Rio Real",
          state_id: "516",
        },
        {
          id: "8812",
          name: "Ruy Barbosa",
          state_id: "516",
        },
        {
          id: "8813",
          name: "Salvador",
          state_id: "516",
        },
        {
          id: "8814",
          name: "Santa Cruz Cabralia",
          state_id: "516",
        },
        {
          id: "8815",
          name: "Santa Ines",
          state_id: "516",
        },
        {
          id: "8816",
          name: "Santa Maria da Vitoria",
          state_id: "516",
        },
        {
          id: "8817",
          name: "Santa Rita de Cassia",
          state_id: "516",
        },
        {
          id: "8818",
          name: "Santaluz",
          state_id: "516",
        },
        {
          id: "8819",
          name: "Santana",
          state_id: "516",
        },
        {
          id: "8820",
          name: "Santo Amaro",
          state_id: "516",
        },
        {
          id: "8821",
          name: "Santo Antonio de Jesus",
          state_id: "516",
        },
        {
          id: "8822",
          name: "Santo Estevao",
          state_id: "516",
        },
        {
          id: "8823",
          name: "Sao Desiderio",
          state_id: "516",
        },
        {
          id: "8824",
          name: "Sao Felipe",
          state_id: "516",
        },
        {
          id: "8825",
          name: "Sao Francisco do Conde",
          state_id: "516",
        },
        {
          id: "8826",
          name: "Sao Gabriel",
          state_id: "516",
        },
        {
          id: "8827",
          name: "Sao Goncalo dos Campos",
          state_id: "516",
        },
        {
          id: "8828",
          name: "Sao Sebastiao do Passe",
          state_id: "516",
        },
        {
          id: "8829",
          name: "Saubara",
          state_id: "516",
        },
        {
          id: "8830",
          name: "Seabra",
          state_id: "516",
        },
        {
          id: "8831",
          name: "Senhor do Bonfim",
          state_id: "516",
        },
        {
          id: "8832",
          name: "Sento Se",
          state_id: "516",
        },
        {
          id: "8833",
          name: "Serra Dourada",
          state_id: "516",
        },
        {
          id: "8834",
          name: "Serra do Ramalho",
          state_id: "516",
        },
        {
          id: "8835",
          name: "Serrinha",
          state_id: "516",
        },
        {
          id: "8836",
          name: "Simoes Filho",
          state_id: "516",
        },
        {
          id: "8837",
          name: "Sobradinho",
          state_id: "516",
        },
        {
          id: "8838",
          name: "Souto Soares",
          state_id: "516",
        },
        {
          id: "8839",
          name: "Tanhacu",
          state_id: "516",
        },
        {
          id: "8840",
          name: "Taperoa",
          state_id: "516",
        },
        {
          id: "8841",
          name: "Tapiramuta",
          state_id: "516",
        },
        {
          id: "8842",
          name: "Teixeira de Freitas",
          state_id: "516",
        },
        {
          id: "8843",
          name: "Teofilandia",
          state_id: "516",
        },
        {
          id: "8844",
          name: "Terra Nova",
          state_id: "516",
        },
        {
          id: "8845",
          name: "Tremedal",
          state_id: "516",
        },
        {
          id: "8846",
          name: "Tucano",
          state_id: "516",
        },
        {
          id: "8847",
          name: "Uaua",
          state_id: "516",
        },
        {
          id: "8848",
          name: "Ubaira",
          state_id: "516",
        },
        {
          id: "8849",
          name: "Ubaitaba",
          state_id: "516",
        },
        {
          id: "8850",
          name: "Ubata",
          state_id: "516",
        },
        {
          id: "8851",
          name: "Una",
          state_id: "516",
        },
        {
          id: "8852",
          name: "Urucuca",
          state_id: "516",
        },
        {
          id: "8853",
          name: "Utinga",
          state_id: "516",
        },
        {
          id: "8854",
          name: "Valenca",
          state_id: "516",
        },
        {
          id: "8855",
          name: "Valente",
          state_id: "516",
        },
        {
          id: "8856",
          name: "Vera Cruz",
          state_id: "516",
        },
        {
          id: "8857",
          name: "Vitoria da Conquista",
          state_id: "516",
        },
        {
          id: "8858",
          name: "Wenceslau Guimaraes",
          state_id: "516",
        },
        {
          id: "8859",
          name: "Xique-Xique",
          state_id: "516",
        },
      ],
      Ceara: [
        {
          id: "8860",
          name: "Acarau",
          state_id: "517",
        },
        {
          id: "8861",
          name: "Acopiara",
          state_id: "517",
        },
        {
          id: "8862",
          name: "Amontada",
          state_id: "517",
        },
        {
          id: "8863",
          name: "Aquiraz",
          state_id: "517",
        },
        {
          id: "8864",
          name: "Aracati",
          state_id: "517",
        },
        {
          id: "8865",
          name: "Aracoiaba",
          state_id: "517",
        },
        {
          id: "8866",
          name: "Araripe",
          state_id: "517",
        },
        {
          id: "8867",
          name: "Assare",
          state_id: "517",
        },
        {
          id: "8868",
          name: "Aurora",
          state_id: "517",
        },
        {
          id: "8869",
          name: "Barbalha",
          state_id: "517",
        },
        {
          id: "8870",
          name: "Barro",
          state_id: "517",
        },
        {
          id: "8871",
          name: "Barroquinha",
          state_id: "517",
        },
        {
          id: "8872",
          name: "Baturite",
          state_id: "517",
        },
        {
          id: "8873",
          name: "Beberibe",
          state_id: "517",
        },
        {
          id: "8874",
          name: "Bela Cruz",
          state_id: "517",
        },
        {
          id: "8875",
          name: "Boa Viagem",
          state_id: "517",
        },
        {
          id: "8876",
          name: "Brejo Santo",
          state_id: "517",
        },
        {
          id: "8877",
          name: "Camocim",
          state_id: "517",
        },
        {
          id: "8878",
          name: "Campos Sales",
          state_id: "517",
        },
        {
          id: "8879",
          name: "Caninde",
          state_id: "517",
        },
        {
          id: "8880",
          name: "Carire",
          state_id: "517",
        },
        {
          id: "8881",
          name: "Caririacu",
          state_id: "517",
        },
        {
          id: "8882",
          name: "Cascavel",
          state_id: "517",
        },
        {
          id: "8883",
          name: "Caucaia",
          state_id: "517",
        },
        {
          id: "8884",
          name: "Cedro",
          state_id: "517",
        },
        {
          id: "8885",
          name: "Chorozinho",
          state_id: "517",
        },
        {
          id: "8886",
          name: "Coreau",
          state_id: "517",
        },
        {
          id: "8887",
          name: "Crateus",
          state_id: "517",
        },
        {
          id: "8888",
          name: "Crato",
          state_id: "517",
        },
        {
          id: "8889",
          name: "Cruz",
          state_id: "517",
        },
        {
          id: "8890",
          name: "Eusebio",
          state_id: "517",
        },
        {
          id: "8891",
          name: "Farias Brito",
          state_id: "517",
        },
        {
          id: "8892",
          name: "Forquilha",
          state_id: "517",
        },
        {
          id: "8893",
          name: "Fortaleza",
          state_id: "517",
        },
        {
          id: "8894",
          name: "Granja",
          state_id: "517",
        },
        {
          id: "8895",
          name: "Guaiuba",
          state_id: "517",
        },
        {
          id: "8896",
          name: "Guaraciaba do Norte",
          state_id: "517",
        },
        {
          id: "8897",
          name: "Hidrolandia",
          state_id: "517",
        },
        {
          id: "8898",
          name: "Horizonte",
          state_id: "517",
        },
        {
          id: "8899",
          name: "Ibiapina",
          state_id: "517",
        },
        {
          id: "8900",
          name: "Ico",
          state_id: "517",
        },
        {
          id: "8901",
          name: "Iguatu",
          state_id: "517",
        },
        {
          id: "8902",
          name: "Independencia",
          state_id: "517",
        },
        {
          id: "8903",
          name: "Ipu",
          state_id: "517",
        },
        {
          id: "8904",
          name: "Ipueiras",
          state_id: "517",
        },
        {
          id: "8905",
          name: "Iraucuba",
          state_id: "517",
        },
        {
          id: "8906",
          name: "Itaitinga",
          state_id: "517",
        },
        {
          id: "8907",
          name: "Itapage",
          state_id: "517",
        },
        {
          id: "8908",
          name: "Itapipoca",
          state_id: "517",
        },
        {
          id: "8909",
          name: "Itarema",
          state_id: "517",
        },
        {
          id: "8910",
          name: "Jaguaribe",
          state_id: "517",
        },
        {
          id: "8911",
          name: "Jaguaruana",
          state_id: "517",
        },
        {
          id: "8912",
          name: "Jardim",
          state_id: "517",
        },
        {
          id: "8913",
          name: "Juazeiro do Norte",
          state_id: "517",
        },
        {
          id: "8914",
          name: "Jucas",
          state_id: "517",
        },
        {
          id: "8915",
          name: "Lavras da Mangabeira",
          state_id: "517",
        },
        {
          id: "8916",
          name: "Limoeiro do Norte",
          state_id: "517",
        },
        {
          id: "8917",
          name: "Maracanau",
          state_id: "517",
        },
        {
          id: "8918",
          name: "Maranguape",
          state_id: "517",
        },
        {
          id: "8919",
          name: "Marco",
          state_id: "517",
        },
        {
          id: "8920",
          name: "Massape",
          state_id: "517",
        },
        {
          id: "8921",
          name: "Mauriti",
          state_id: "517",
        },
        {
          id: "8922",
          name: "Milagres",
          state_id: "517",
        },
        {
          id: "8923",
          name: "Missao Velha",
          state_id: "517",
        },
        {
          id: "8924",
          name: "Mombaca",
          state_id: "517",
        },
        {
          id: "8925",
          name: "Morada Nova",
          state_id: "517",
        },
        {
          id: "8926",
          name: "Nova Russas",
          state_id: "517",
        },
        {
          id: "8927",
          name: "Novo Oriente",
          state_id: "517",
        },
        {
          id: "8928",
          name: "Ocara",
          state_id: "517",
        },
        {
          id: "8929",
          name: "Oros",
          state_id: "517",
        },
        {
          id: "8930",
          name: "Pacajus",
          state_id: "517",
        },
        {
          id: "8931",
          name: "Pacatuba",
          state_id: "517",
        },
        {
          id: "8932",
          name: "Paracuru",
          state_id: "517",
        },
        {
          id: "8933",
          name: "Paraipaba",
          state_id: "517",
        },
        {
          id: "8934",
          name: "Parambu",
          state_id: "517",
        },
        {
          id: "8935",
          name: "Pedra Branca",
          state_id: "517",
        },
        {
          id: "8936",
          name: "Pentecoste",
          state_id: "517",
        },
        {
          id: "8937",
          name: "Quixada",
          state_id: "517",
        },
        {
          id: "8938",
          name: "Quixeramobim",
          state_id: "517",
        },
        {
          id: "8939",
          name: "Quixere",
          state_id: "517",
        },
        {
          id: "8940",
          name: "Redencao",
          state_id: "517",
        },
        {
          id: "8941",
          name: "Reriutaba",
          state_id: "517",
        },
        {
          id: "8942",
          name: "Russas",
          state_id: "517",
        },
        {
          id: "8943",
          name: "Santa Quiteria",
          state_id: "517",
        },
        {
          id: "8944",
          name: "Santana do Acarau",
          state_id: "517",
        },
        {
          id: "8945",
          name: "Sao Benedito",
          state_id: "517",
        },
        {
          id: "8946",
          name: "Sao Goncalo do Amarante",
          state_id: "517",
        },
        {
          id: "8947",
          name: "Senador Pompeu",
          state_id: "517",
        },
        {
          id: "8948",
          name: "Sobral",
          state_id: "517",
        },
        {
          id: "8949",
          name: "Tabuleiro do Norte",
          state_id: "517",
        },
        {
          id: "8950",
          name: "Tamboril",
          state_id: "517",
        },
        {
          id: "8951",
          name: "Taua",
          state_id: "517",
        },
        {
          id: "8952",
          name: "Tiangua",
          state_id: "517",
        },
        {
          id: "8953",
          name: "Trairi",
          state_id: "517",
        },
        {
          id: "8954",
          name: "Ubajara",
          state_id: "517",
        },
        {
          id: "8955",
          name: "Umirim",
          state_id: "517",
        },
        {
          id: "8956",
          name: "Uruburetama",
          state_id: "517",
        },
        {
          id: "8957",
          name: "Varjota",
          state_id: "517",
        },
        {
          id: "8958",
          name: "Varzea Alegre",
          state_id: "517",
        },
        {
          id: "8959",
          name: "Vicosa do Ceara",
          state_id: "517",
        },
      ],
      "Distrito Federal": [],
      "Espirito Santo": [],
      "Estado de Sao Paulo": [],
      Goias: [
        {
          id: "8960",
          name: "Abadiania",
          state_id: "521",
        },
        {
          id: "8961",
          name: "Acreuna",
          state_id: "521",
        },
        {
          id: "8962",
          name: "Aguas Lindas de Goias",
          state_id: "521",
        },
        {
          id: "8963",
          name: "Alexania",
          state_id: "521",
        },
        {
          id: "8964",
          name: "Anapolis",
          state_id: "521",
        },
        {
          id: "8965",
          name: "Anicuns",
          state_id: "521",
        },
        {
          id: "8966",
          name: "Aparecida de Goiania",
          state_id: "521",
        },
        {
          id: "8967",
          name: "Aragarcas",
          state_id: "521",
        },
        {
          id: "8968",
          name: "Bela Vista de Goias",
          state_id: "521",
        },
        {
          id: "8969",
          name: "Bom Jesus de Goias",
          state_id: "521",
        },
        {
          id: "8970",
          name: "Buriti Alegre",
          state_id: "521",
        },
        {
          id: "8971",
          name: "Cacu",
          state_id: "521",
        },
        {
          id: "8972",
          name: "Caiaponia",
          state_id: "521",
        },
        {
          id: "8973",
          name: "Caldas Novas",
          state_id: "521",
        },
        {
          id: "8974",
          name: "Campos Belos",
          state_id: "521",
        },
        {
          id: "8975",
          name: "Campos Verdes",
          state_id: "521",
        },
        {
          id: "8976",
          name: "Carmo do Rio Verde",
          state_id: "521",
        },
        {
          id: "8977",
          name: "Catalao",
          state_id: "521",
        },
        {
          id: "8978",
          name: "Cavalcante",
          state_id: "521",
        },
        {
          id: "8979",
          name: "Ceres",
          state_id: "521",
        },
        {
          id: "8980",
          name: "Cidade Ocidental",
          state_id: "521",
        },
        {
          id: "8981",
          name: "Cocalzinho de Coias",
          state_id: "521",
        },
        {
          id: "8982",
          name: "Cristalina",
          state_id: "521",
        },
        {
          id: "8983",
          name: "Crixas",
          state_id: "521",
        },
        {
          id: "8984",
          name: "Doverlandia",
          state_id: "521",
        },
        {
          id: "8985",
          name: "Edeia",
          state_id: "521",
        },
        {
          id: "8986",
          name: "Firminopolis",
          state_id: "521",
        },
        {
          id: "8987",
          name: "Formosa",
          state_id: "521",
        },
        {
          id: "8988",
          name: "Goianapolis",
          state_id: "521",
        },
        {
          id: "8989",
          name: "Goianesia",
          state_id: "521",
        },
        {
          id: "8990",
          name: "Goiania",
          state_id: "521",
        },
        {
          id: "8991",
          name: "Goianira",
          state_id: "521",
        },
        {
          id: "8992",
          name: "Goias",
          state_id: "521",
        },
        {
          id: "8993",
          name: "Goiatuba",
          state_id: "521",
        },
        {
          id: "8994",
          name: "Guapo",
          state_id: "521",
        },
        {
          id: "8995",
          name: "Hidrolandia",
          state_id: "521",
        },
        {
          id: "8996",
          name: "Iaciara",
          state_id: "521",
        },
        {
          id: "8997",
          name: "Indiara",
          state_id: "521",
        },
        {
          id: "8998",
          name: "Inhumas",
          state_id: "521",
        },
        {
          id: "8999",
          name: "Ipameri",
          state_id: "521",
        },
        {
          id: "9000",
          name: "Ipora",
          state_id: "521",
        },
        {
          id: "9001",
          name: "Itaberai",
          state_id: "521",
        },
        {
          id: "9002",
          name: "Itapaci",
          state_id: "521",
        },
        {
          id: "9003",
          name: "Itapirapua",
          state_id: "521",
        },
        {
          id: "9004",
          name: "Itapuranga",
          state_id: "521",
        },
        {
          id: "9005",
          name: "Itumbiara",
          state_id: "521",
        },
        {
          id: "9006",
          name: "Jaragua",
          state_id: "521",
        },
        {
          id: "9007",
          name: "Jatai",
          state_id: "521",
        },
        {
          id: "9008",
          name: "Jussara",
          state_id: "521",
        },
        {
          id: "9009",
          name: "Luziania",
          state_id: "521",
        },
        {
          id: "9010",
          name: "Mara Rosa",
          state_id: "521",
        },
        {
          id: "9011",
          name: "Minacu",
          state_id: "521",
        },
        {
          id: "9012",
          name: "Mineiros",
          state_id: "521",
        },
        {
          id: "9013",
          name: "Morrinhos",
          state_id: "521",
        },
        {
          id: "9014",
          name: "Mozarlandia",
          state_id: "521",
        },
        {
          id: "9015",
          name: "Neropolis",
          state_id: "521",
        },
        {
          id: "9016",
          name: "Niquelandia",
          state_id: "521",
        },
        {
          id: "9017",
          name: "Nova Crixas",
          state_id: "521",
        },
        {
          id: "9018",
          name: "Novo Gama",
          state_id: "521",
        },
        {
          id: "9019",
          name: "Orizona",
          state_id: "521",
        },
        {
          id: "9020",
          name: "Padre Bernardo",
          state_id: "521",
        },
        {
          id: "9021",
          name: "Palmeiras de Goias",
          state_id: "521",
        },
        {
          id: "9022",
          name: "Parauna",
          state_id: "521",
        },
        {
          id: "9023",
          name: "Petrolina de Goias",
          state_id: "521",
        },
        {
          id: "9024",
          name: "Piracanjuba",
          state_id: "521",
        },
        {
          id: "9025",
          name: "Piranhas",
          state_id: "521",
        },
        {
          id: "9026",
          name: "Pirenopolis",
          state_id: "521",
        },
        {
          id: "9027",
          name: "Pires do Rio",
          state_id: "521",
        },
        {
          id: "9028",
          name: "Planaltina",
          state_id: "521",
        },
        {
          id: "9029",
          name: "Pontalina",
          state_id: "521",
        },
        {
          id: "9030",
          name: "Porangatu",
          state_id: "521",
        },
        {
          id: "9031",
          name: "Posse",
          state_id: "521",
        },
        {
          id: "9032",
          name: "Quirinopolis",
          state_id: "521",
        },
        {
          id: "9033",
          name: "Rialma",
          state_id: "521",
        },
        {
          id: "9034",
          name: "Rio Verde",
          state_id: "521",
        },
        {
          id: "9035",
          name: "Rubiataba",
          state_id: "521",
        },
        {
          id: "9036",
          name: "Santa Helena de Goias",
          state_id: "521",
        },
        {
          id: "9037",
          name: "Santa Terezinha de Goias",
          state_id: "521",
        },
        {
          id: "9038",
          name: "Santo Antonio do Descoberto",
          state_id: "521",
        },
        {
          id: "9039",
          name: "Sao Domingos",
          state_id: "521",
        },
        {
          id: "9040",
          name: "Sao Luis de Montes Belos",
          state_id: "521",
        },
        {
          id: "9041",
          name: "Sao Miguel do Araguaia",
          state_id: "521",
        },
        {
          id: "9042",
          name: "Sao Simao",
          state_id: "521",
        },
        {
          id: "9043",
          name: "Senador Canedo",
          state_id: "521",
        },
        {
          id: "9044",
          name: "Silvania",
          state_id: "521",
        },
        {
          id: "9045",
          name: "Trindade",
          state_id: "521",
        },
        {
          id: "9046",
          name: "Uruacu",
          state_id: "521",
        },
        {
          id: "9047",
          name: "Uruana",
          state_id: "521",
        },
        {
          id: "9048",
          name: "Valparaiso de Goias",
          state_id: "521",
        },
        {
          id: "9049",
          name: "Vianopolis",
          state_id: "521",
        },
      ],
      Maranhao: [
        {
          id: "9050",
          name: "Acailandia",
          state_id: "522",
        },
        {
          id: "9051",
          name: "Alcantara",
          state_id: "522",
        },
        {
          id: "9052",
          name: "Aldeias Altas",
          state_id: "522",
        },
        {
          id: "9053",
          name: "Alto Alegre do Pindare",
          state_id: "522",
        },
        {
          id: "9054",
          name: "Amarante do Maranhao",
          state_id: "522",
        },
        {
          id: "9055",
          name: "Anajatuba",
          state_id: "522",
        },
        {
          id: "9056",
          name: "Araioses",
          state_id: "522",
        },
        {
          id: "9057",
          name: "Arame",
          state_id: "522",
        },
        {
          id: "9058",
          name: "Arari",
          state_id: "522",
        },
        {
          id: "9059",
          name: "Bacabal",
          state_id: "522",
        },
        {
          id: "9060",
          name: "Balsas",
          state_id: "522",
        },
        {
          id: "9061",
          name: "Barra do Corda",
          state_id: "522",
        },
        {
          id: "9062",
          name: "Barreirinhas",
          state_id: "522",
        },
        {
          id: "9063",
          name: "Bequimao",
          state_id: "522",
        },
        {
          id: "9064",
          name: "Bom Jardim",
          state_id: "522",
        },
        {
          id: "9065",
          name: "Brejo",
          state_id: "522",
        },
        {
          id: "9066",
          name: "Buriti",
          state_id: "522",
        },
        {
          id: "9067",
          name: "Buriti Bravo",
          state_id: "522",
        },
        {
          id: "9068",
          name: "Buriticupu",
          state_id: "522",
        },
        {
          id: "9069",
          name: "Candido Mendes",
          state_id: "522",
        },
        {
          id: "9070",
          name: "Cantanhede",
          state_id: "522",
        },
        {
          id: "9071",
          name: "Carolina",
          state_id: "522",
        },
        {
          id: "9072",
          name: "Carutapera",
          state_id: "522",
        },
        {
          id: "9073",
          name: "Caxias",
          state_id: "522",
        },
        {
          id: "9074",
          name: "Chapadinha",
          state_id: "522",
        },
        {
          id: "9075",
          name: "Codo",
          state_id: "522",
        },
        {
          id: "9076",
          name: "Coelho Neto",
          state_id: "522",
        },
        {
          id: "9077",
          name: "Colinas",
          state_id: "522",
        },
        {
          id: "9078",
          name: "Coroata",
          state_id: "522",
        },
        {
          id: "9079",
          name: "Cururupu",
          state_id: "522",
        },
        {
          id: "9080",
          name: "Davinopolis",
          state_id: "522",
        },
        {
          id: "9081",
          name: "Dom Pedro",
          state_id: "522",
        },
        {
          id: "9082",
          name: "Esperantinopolis",
          state_id: "522",
        },
        {
          id: "9083",
          name: "Estreito",
          state_id: "522",
        },
        {
          id: "9084",
          name: "Fortuna",
          state_id: "522",
        },
        {
          id: "9085",
          name: "Godofredo Viana",
          state_id: "522",
        },
        {
          id: "9086",
          name: "Governador Eugenio Barros",
          state_id: "522",
        },
        {
          id: "9087",
          name: "Governador Nunes Freire",
          state_id: "522",
        },
        {
          id: "9088",
          name: "Grajau",
          state_id: "522",
        },
        {
          id: "9089",
          name: "Humberto de Campos",
          state_id: "522",
        },
        {
          id: "9090",
          name: "Icatu",
          state_id: "522",
        },
        {
          id: "9091",
          name: "Imperatriz",
          state_id: "522",
        },
        {
          id: "9092",
          name: "Itapecuru Mirim",
          state_id: "522",
        },
        {
          id: "9093",
          name: "Itinga do Maranhao",
          state_id: "522",
        },
        {
          id: "9094",
          name: "Joao Lisboa",
          state_id: "522",
        },
        {
          id: "9095",
          name: "Lago da Pedra",
          state_id: "522",
        },
        {
          id: "9096",
          name: "Lago do Junco",
          state_id: "522",
        },
        {
          id: "9097",
          name: "Maracacume",
          state_id: "522",
        },
        {
          id: "9098",
          name: "Matinha",
          state_id: "522",
        },
        {
          id: "9099",
          name: "Matoes",
          state_id: "522",
        },
        {
          id: "9100",
          name: "Mirador",
          state_id: "522",
        },
        {
          id: "9101",
          name: "Miranda do Norte",
          state_id: "522",
        },
        {
          id: "9102",
          name: "Moncao",
          state_id: "522",
        },
        {
          id: "9103",
          name: "Montes Altos",
          state_id: "522",
        },
        {
          id: "9104",
          name: "Morros",
          state_id: "522",
        },
        {
          id: "9105",
          name: "Nova Olinda do Maranhao",
          state_id: "522",
        },
        {
          id: "9106",
          name: "Olho d''Agua das Cunhas",
          state_id: "522",
        },
        {
          id: "9107",
          name: "Paco do Lumiar",
          state_id: "522",
        },
        {
          id: "9108",
          name: "Paraibano",
          state_id: "522",
        },
        {
          id: "9109",
          name: "Parnarama",
          state_id: "522",
        },
        {
          id: "9110",
          name: "Passagem Franca",
          state_id: "522",
        },
        {
          id: "9111",
          name: "Pastos Bons",
          state_id: "522",
        },
        {
          id: "9112",
          name: "Paulo Ramos",
          state_id: "522",
        },
        {
          id: "9113",
          name: "Pedreiras",
          state_id: "522",
        },
        {
          id: "9114",
          name: "Penalva",
          state_id: "522",
        },
        {
          id: "9115",
          name: "Pindare Mirim",
          state_id: "522",
        },
        {
          id: "9116",
          name: "Pinheiro",
          state_id: "522",
        },
        {
          id: "9117",
          name: "Pio XII",
          state_id: "522",
        },
        {
          id: "9118",
          name: "Pirapemas",
          state_id: "522",
        },
        {
          id: "9119",
          name: "Pocao de Pedras",
          state_id: "522",
        },
        {
          id: "9120",
          name: "Porto Franco",
          state_id: "522",
        },
        {
          id: "9121",
          name: "Presidente Dutra",
          state_id: "522",
        },
        {
          id: "9122",
          name: "Raposa",
          state_id: "522",
        },
        {
          id: "9123",
          name: "Riachao",
          state_id: "522",
        },
        {
          id: "9124",
          name: "Rosario",
          state_id: "522",
        },
        {
          id: "9125",
          name: "Santa Helena",
          state_id: "522",
        },
        {
          id: "9126",
          name: "Santa Ines",
          state_id: "522",
        },
        {
          id: "9127",
          name: "Santa Luzia",
          state_id: "522",
        },
        {
          id: "9128",
          name: "Santa Luzia do Parua",
          state_id: "522",
        },
        {
          id: "9129",
          name: "Santa Quiteria do Maranhao",
          state_id: "522",
        },
        {
          id: "9130",
          name: "Santa Rita",
          state_id: "522",
        },
        {
          id: "9131",
          name: "Sao Benedito do Rio Preto",
          state_id: "522",
        },
        {
          id: "9132",
          name: "Sao Bento",
          state_id: "522",
        },
        {
          id: "9133",
          name: "Sao Bernardo",
          state_id: "522",
        },
        {
          id: "9134",
          name: "Sao Domingos do Maranhao",
          state_id: "522",
        },
        {
          id: "9135",
          name: "Sao Joao Batista",
          state_id: "522",
        },
        {
          id: "9136",
          name: "Sao Joao dos Patos",
          state_id: "522",
        },
        {
          id: "9137",
          name: "Sao Jose de Ribamar",
          state_id: "522",
        },
        {
          id: "9138",
          name: "Sao Luis",
          state_id: "522",
        },
        {
          id: "9139",
          name: "Sao Luis Gonzaga do Maranhao",
          state_id: "522",
        },
        {
          id: "9140",
          name: "Sao Mateus do Maranhao",
          state_id: "522",
        },
        {
          id: "9141",
          name: "Sao Pedro da Agua Branca",
          state_id: "522",
        },
        {
          id: "9142",
          name: "Sao Raimundo das Mangabeiras",
          state_id: "522",
        },
        {
          id: "9143",
          name: "Timbiras",
          state_id: "522",
        },
        {
          id: "9144",
          name: "Timon",
          state_id: "522",
        },
        {
          id: "9145",
          name: "Trizidela do Vale",
          state_id: "522",
        },
        {
          id: "9146",
          name: "Tuntum",
          state_id: "522",
        },
        {
          id: "9147",
          name: "Turiacu",
          state_id: "522",
        },
        {
          id: "9148",
          name: "Tutoia",
          state_id: "522",
        },
        {
          id: "9149",
          name: "Urbano Santos",
          state_id: "522",
        },
        {
          id: "9150",
          name: "Vargem Grande",
          state_id: "522",
        },
        {
          id: "9151",
          name: "Viana",
          state_id: "522",
        },
        {
          id: "9152",
          name: "Vitoria do Mearim",
          state_id: "522",
        },
        {
          id: "9153",
          name: "Vitorino Freire",
          state_id: "522",
        },
        {
          id: "9154",
          name: "Ze Doca",
          state_id: "522",
        },
      ],
      "Mato Grosso": [],
      "Mato Grosso do Sul": [],
      "Minas Gerais": [],
      Para: [
        {
          id: "9155",
          name: "Abaetetuba",
          state_id: "526",
        },
        {
          id: "9156",
          name: "Acara",
          state_id: "526",
        },
        {
          id: "9157",
          name: "Afua",
          state_id: "526",
        },
        {
          id: "9158",
          name: "Agua Azul do Norte",
          state_id: "526",
        },
        {
          id: "9159",
          name: "Alenquer",
          state_id: "526",
        },
        {
          id: "9160",
          name: "Almeirim",
          state_id: "526",
        },
        {
          id: "9161",
          name: "Altamira",
          state_id: "526",
        },
        {
          id: "9162",
          name: "Ananindeua",
          state_id: "526",
        },
        {
          id: "9163",
          name: "Augusto Correa",
          state_id: "526",
        },
        {
          id: "9164",
          name: "Baiao",
          state_id: "526",
        },
        {
          id: "9165",
          name: "Barcarena",
          state_id: "526",
        },
        {
          id: "9166",
          name: "Belem",
          state_id: "526",
        },
        {
          id: "9167",
          name: "Benevides",
          state_id: "526",
        },
        {
          id: "9168",
          name: "Braganca",
          state_id: "526",
        },
        {
          id: "9169",
          name: "Breu Branco",
          state_id: "526",
        },
        {
          id: "9170",
          name: "Breves",
          state_id: "526",
        },
        {
          id: "9171",
          name: "Bujaru",
          state_id: "526",
        },
        {
          id: "9172",
          name: "Cameta",
          state_id: "526",
        },
        {
          id: "9173",
          name: "Capanema",
          state_id: "526",
        },
        {
          id: "9174",
          name: "Capitao Poco",
          state_id: "526",
        },
        {
          id: "9175",
          name: "Castanhal",
          state_id: "526",
        },
        {
          id: "9176",
          name: "Conceicao do Araguaia",
          state_id: "526",
        },
        {
          id: "9177",
          name: "Concordia do Para",
          state_id: "526",
        },
        {
          id: "9178",
          name: "Curionopolis",
          state_id: "526",
        },
        {
          id: "9179",
          name: "Curuca",
          state_id: "526",
        },
        {
          id: "9180",
          name: "Dom Eliseu",
          state_id: "526",
        },
        {
          id: "9181",
          name: "Eldorado dos Carajas",
          state_id: "526",
        },
        {
          id: "9182",
          name: "Garrafao do Norte",
          state_id: "526",
        },
        {
          id: "9183",
          name: "Goianesia do Para",
          state_id: "526",
        },
        {
          id: "9184",
          name: "Gurupa",
          state_id: "526",
        },
        {
          id: "9185",
          name: "Igarape-Acu",
          state_id: "526",
        },
        {
          id: "9186",
          name: "Igarape-Miri",
          state_id: "526",
        },
        {
          id: "9187",
          name: "Irituia",
          state_id: "526",
        },
        {
          id: "9188",
          name: "Itaituba",
          state_id: "526",
        },
        {
          id: "9189",
          name: "Itupiranga",
          state_id: "526",
        },
        {
          id: "9190",
          name: "Jacareacanga",
          state_id: "526",
        },
        {
          id: "9191",
          name: "Jacunda",
          state_id: "526",
        },
        {
          id: "9192",
          name: "Juruti",
          state_id: "526",
        },
        {
          id: "9193",
          name: "Limoeiro do Ajuru",
          state_id: "526",
        },
        {
          id: "9194",
          name: "Mae do Rio",
          state_id: "526",
        },
        {
          id: "9195",
          name: "Maraba",
          state_id: "526",
        },
        {
          id: "9196",
          name: "Maracana",
          state_id: "526",
        },
        {
          id: "9197",
          name: "Marapanim",
          state_id: "526",
        },
        {
          id: "9198",
          name: "Marituba",
          state_id: "526",
        },
        {
          id: "9199",
          name: "Medicilandia",
          state_id: "526",
        },
        {
          id: "9200",
          name: "Mocajuba",
          state_id: "526",
        },
        {
          id: "9201",
          name: "Moju",
          state_id: "526",
        },
        {
          id: "9202",
          name: "Monte Alegre",
          state_id: "526",
        },
        {
          id: "9203",
          name: "Muana",
          state_id: "526",
        },
        {
          id: "9204",
          name: "Novo Progresso",
          state_id: "526",
        },
        {
          id: "9205",
          name: "Novo Repartimento",
          state_id: "526",
        },
        {
          id: "9206",
          name: "Obidos",
          state_id: "526",
        },
        {
          id: "9207",
          name: "Oeiras do Para",
          state_id: "526",
        },
        {
          id: "9208",
          name: "Oriximina",
          state_id: "526",
        },
        {
          id: "9209",
          name: "Ourem",
          state_id: "526",
        },
        {
          id: "9210",
          name: "Ourilandia",
          state_id: "526",
        },
        {
          id: "9211",
          name: "Pacaja",
          state_id: "526",
        },
        {
          id: "9212",
          name: "Paragominas",
          state_id: "526",
        },
        {
          id: "9213",
          name: "Parauapebas",
          state_id: "526",
        },
        {
          id: "9214",
          name: "Portel",
          state_id: "526",
        },
        {
          id: "9215",
          name: "Porto de Moz",
          state_id: "526",
        },
        {
          id: "9216",
          name: "Prainha",
          state_id: "526",
        },
        {
          id: "9217",
          name: "Redencao",
          state_id: "526",
        },
        {
          id: "9218",
          name: "Rio Maria",
          state_id: "526",
        },
        {
          id: "9219",
          name: "Rondon do Para",
          state_id: "526",
        },
        {
          id: "9220",
          name: "Ruropolis",
          state_id: "526",
        },
        {
          id: "9221",
          name: "Salinopolis",
          state_id: "526",
        },
        {
          id: "9222",
          name: "Santa Isabel do Para",
          state_id: "526",
        },
        {
          id: "9223",
          name: "Santa Luzia do Para",
          state_id: "526",
        },
        {
          id: "9224",
          name: "Santa Maria do Para",
          state_id: "526",
        },
        {
          id: "9225",
          name: "Santana do Araguaia",
          state_id: "526",
        },
        {
          id: "9226",
          name: "Santarem",
          state_id: "526",
        },
        {
          id: "9227",
          name: "Santo Antonio do Taua",
          state_id: "526",
        },
        {
          id: "9228",
          name: "Sao Caetano de Odivelas",
          state_id: "526",
        },
        {
          id: "9229",
          name: "Sao Domingos do Araguaia",
          state_id: "526",
        },
        {
          id: "9230",
          name: "Sao Domingos do Capim",
          state_id: "526",
        },
        {
          id: "9231",
          name: "Sao Felix do Xingu",
          state_id: "526",
        },
        {
          id: "9232",
          name: "Sao Geraldo do Araguaia",
          state_id: "526",
        },
        {
          id: "9233",
          name: "Sao Joao de Pirabas",
          state_id: "526",
        },
        {
          id: "9234",
          name: "Sao Miguel do Guama",
          state_id: "526",
        },
        {
          id: "9235",
          name: "Senador Jose Porfirio",
          state_id: "526",
        },
        {
          id: "9236",
          name: "Soure",
          state_id: "526",
        },
        {
          id: "9237",
          name: "Tailandia",
          state_id: "526",
        },
        {
          id: "9238",
          name: "Terra Santa",
          state_id: "526",
        },
        {
          id: "9239",
          name: "Tome-Acu",
          state_id: "526",
        },
        {
          id: "9240",
          name: "Tucuma",
          state_id: "526",
        },
        {
          id: "9241",
          name: "Tucurui",
          state_id: "526",
        },
        {
          id: "9242",
          name: "Ulianopolis",
          state_id: "526",
        },
        {
          id: "9243",
          name: "Uruara",
          state_id: "526",
        },
        {
          id: "9244",
          name: "Vigia",
          state_id: "526",
        },
        {
          id: "9245",
          name: "Viseu",
          state_id: "526",
        },
        {
          id: "9246",
          name: "Xinguara",
          state_id: "526",
        },
      ],
      Paraiba: [
        {
          id: "9247",
          name: "Alagoa Grande",
          state_id: "527",
        },
        {
          id: "9248",
          name: "Alagoa Nova",
          state_id: "527",
        },
        {
          id: "9249",
          name: "Alagoinha",
          state_id: "527",
        },
        {
          id: "9250",
          name: "Alhandra",
          state_id: "527",
        },
        {
          id: "9251",
          name: "Aracagi",
          state_id: "527",
        },
        {
          id: "9252",
          name: "Arara",
          state_id: "527",
        },
        {
          id: "9253",
          name: "Araruna",
          state_id: "527",
        },
        {
          id: "9254",
          name: "Areia",
          state_id: "527",
        },
        {
          id: "9255",
          name: "Aroeiras",
          state_id: "527",
        },
        {
          id: "9256",
          name: "Bananeiras",
          state_id: "527",
        },
        {
          id: "9257",
          name: "Barra de Santa Rosa",
          state_id: "527",
        },
        {
          id: "9258",
          name: "Bayeux",
          state_id: "527",
        },
        {
          id: "9259",
          name: "Belem",
          state_id: "527",
        },
        {
          id: "9260",
          name: "Boqueirao",
          state_id: "527",
        },
        {
          id: "9261",
          name: "Brejo do Cruz",
          state_id: "527",
        },
        {
          id: "9262",
          name: "Caapora",
          state_id: "527",
        },
        {
          id: "9263",
          name: "Cabedelo",
          state_id: "527",
        },
        {
          id: "9264",
          name: "Cacimba de Dentro",
          state_id: "527",
        },
        {
          id: "9265",
          name: "Cajazeiras",
          state_id: "527",
        },
        {
          id: "9266",
          name: "Campina Grande",
          state_id: "527",
        },
        {
          id: "9267",
          name: "Catole do Rocha",
          state_id: "527",
        },
        {
          id: "9268",
          name: "Conceicao",
          state_id: "527",
        },
        {
          id: "9269",
          name: "Conde",
          state_id: "527",
        },
        {
          id: "9270",
          name: "Coremas",
          state_id: "527",
        },
        {
          id: "9271",
          name: "Cruz do Espirito Santo",
          state_id: "527",
        },
        {
          id: "9272",
          name: "Cuite",
          state_id: "527",
        },
        {
          id: "9273",
          name: "Desterro",
          state_id: "527",
        },
        {
          id: "9274",
          name: "Dona Ines",
          state_id: "527",
        },
        {
          id: "9275",
          name: "Esperanca",
          state_id: "527",
        },
        {
          id: "9276",
          name: "Fagundes",
          state_id: "527",
        },
        {
          id: "9277",
          name: "Guarabira",
          state_id: "527",
        },
        {
          id: "9278",
          name: "Gurinhem",
          state_id: "527",
        },
        {
          id: "9279",
          name: "Imaculada",
          state_id: "527",
        },
        {
          id: "9280",
          name: "Inga",
          state_id: "527",
        },
        {
          id: "9281",
          name: "Itabaiana",
          state_id: "527",
        },
        {
          id: "9282",
          name: "Itaporanga",
          state_id: "527",
        },
        {
          id: "9283",
          name: "Itapororoca",
          state_id: "527",
        },
        {
          id: "9284",
          name: "Itatuba",
          state_id: "527",
        },
        {
          id: "9285",
          name: "Jacarau",
          state_id: "527",
        },
        {
          id: "9286",
          name: "Joao Pessoa",
          state_id: "527",
        },
        {
          id: "9287",
          name: "Juazeirinho",
          state_id: "527",
        },
        {
          id: "9288",
          name: "Juripiranga",
          state_id: "527",
        },
        {
          id: "9289",
          name: "Juru",
          state_id: "527",
        },
        {
          id: "9290",
          name: "Lagoa Seca",
          state_id: "527",
        },
        {
          id: "9291",
          name: "Mamanguape",
          state_id: "527",
        },
        {
          id: "9292",
          name: "Manaira",
          state_id: "527",
        },
        {
          id: "9293",
          name: "Mari",
          state_id: "527",
        },
        {
          id: "9294",
          name: "Massaranduba",
          state_id: "527",
        },
        {
          id: "9295",
          name: "Mogeiro",
          state_id: "527",
        },
        {
          id: "9296",
          name: "Monteiro",
          state_id: "527",
        },
        {
          id: "9297",
          name: "Mulungu",
          state_id: "527",
        },
        {
          id: "9298",
          name: "Natuba",
          state_id: "527",
        },
        {
          id: "9299",
          name: "Nova Floresta",
          state_id: "527",
        },
        {
          id: "9300",
          name: "Patos",
          state_id: "527",
        },
        {
          id: "9301",
          name: "Paulista",
          state_id: "527",
        },
        {
          id: "9302",
          name: "Pedras de Fogo",
          state_id: "527",
        },
        {
          id: "9303",
          name: "Pianco",
          state_id: "527",
        },
        {
          id: "9304",
          name: "Picui",
          state_id: "527",
        },
        {
          id: "9305",
          name: "Pilar",
          state_id: "527",
        },
        {
          id: "9306",
          name: "Pirpirituba",
          state_id: "527",
        },
        {
          id: "9307",
          name: "Pitimbu",
          state_id: "527",
        },
        {
          id: "9308",
          name: "Pocinhos",
          state_id: "527",
        },
        {
          id: "9309",
          name: "Pombal",
          state_id: "527",
        },
        {
          id: "9310",
          name: "Princesa Isabel",
          state_id: "527",
        },
        {
          id: "9311",
          name: "Puxinana",
          state_id: "527",
        },
        {
          id: "9312",
          name: "Queimadas",
          state_id: "527",
        },
        {
          id: "9313",
          name: "Remigio",
          state_id: "527",
        },
        {
          id: "9314",
          name: "Rio Tinto",
          state_id: "527",
        },
        {
          id: "9315",
          name: "Salgado de Sao Felix",
          state_id: "527",
        },
        {
          id: "9316",
          name: "Santa Luzia",
          state_id: "527",
        },
        {
          id: "9317",
          name: "Santa Rita",
          state_id: "527",
        },
        {
          id: "9318",
          name: "Sao Bento",
          state_id: "527",
        },
        {
          id: "9319",
          name: "Sao Joao do Rio do Peixe",
          state_id: "527",
        },
        {
          id: "9320",
          name: "Sao Jose de Piranhas",
          state_id: "527",
        },
        {
          id: "9321",
          name: "Sao Sebastiao de Lagoa de Roca",
          state_id: "527",
        },
        {
          id: "9322",
          name: "Sape",
          state_id: "527",
        },
        {
          id: "9323",
          name: "Serra Branca",
          state_id: "527",
        },
        {
          id: "9324",
          name: "Solanea",
          state_id: "527",
        },
        {
          id: "9325",
          name: "Soledade",
          state_id: "527",
        },
        {
          id: "9326",
          name: "Sousa",
          state_id: "527",
        },
        {
          id: "9327",
          name: "Sume",
          state_id: "527",
        },
        {
          id: "9328",
          name: "Taperoa",
          state_id: "527",
        },
        {
          id: "9329",
          name: "Tavares",
          state_id: "527",
        },
        {
          id: "9330",
          name: "Teixeira",
          state_id: "527",
        },
        {
          id: "9331",
          name: "Triunfo",
          state_id: "527",
        },
        {
          id: "9332",
          name: "Uirauna",
          state_id: "527",
        },
        {
          id: "9333",
          name: "Umbuzeiro",
          state_id: "527",
        },
      ],
      Parana: [
        {
          id: "9334",
          name: "Almirante Tamandare",
          state_id: "528",
        },
        {
          id: "9335",
          name: "Alto Parana",
          state_id: "528",
        },
        {
          id: "9336",
          name: "Alto Piquiri",
          state_id: "528",
        },
        {
          id: "9337",
          name: "Altonia",
          state_id: "528",
        },
        {
          id: "9338",
          name: "Ampere",
          state_id: "528",
        },
        {
          id: "9339",
          name: "Andira",
          state_id: "528",
        },
        {
          id: "9340",
          name: "Antonina",
          state_id: "528",
        },
        {
          id: "9341",
          name: "Apucarana",
          state_id: "528",
        },
        {
          id: "9342",
          name: "Arapongas",
          state_id: "528",
        },
        {
          id: "9343",
          name: "Arapoti",
          state_id: "528",
        },
        {
          id: "9344",
          name: "Araucaria",
          state_id: "528",
        },
        {
          id: "9345",
          name: "Assai",
          state_id: "528",
        },
        {
          id: "9346",
          name: "Assis Chateaubriand",
          state_id: "528",
        },
        {
          id: "9347",
          name: "Astorga",
          state_id: "528",
        },
        {
          id: "9348",
          name: "Bandeirantes",
          state_id: "528",
        },
        {
          id: "9349",
          name: "Barbosa Ferraz",
          state_id: "528",
        },
        {
          id: "9350",
          name: "Bela Vista do Paraiso",
          state_id: "528",
        },
        {
          id: "9351",
          name: "Cambara",
          state_id: "528",
        },
        {
          id: "9352",
          name: "Cambe",
          state_id: "528",
        },
        {
          id: "9353",
          name: "Campina Grande do Sul",
          state_id: "528",
        },
        {
          id: "9354",
          name: "Campina da Lagoa",
          state_id: "528",
        },
        {
          id: "9355",
          name: "Campo Largo",
          state_id: "528",
        },
        {
          id: "9356",
          name: "Campo Murao",
          state_id: "528",
        },
        {
          id: "9357",
          name: "Candido de Abreu",
          state_id: "528",
        },
        {
          id: "9358",
          name: "Capitao Leonidas Marques",
          state_id: "528",
        },
        {
          id: "9359",
          name: "Carambei",
          state_id: "528",
        },
        {
          id: "9360",
          name: "Cascavel",
          state_id: "528",
        },
        {
          id: "9361",
          name: "Castro",
          state_id: "528",
        },
        {
          id: "9362",
          name: "Centenario do Sul",
          state_id: "528",
        },
        {
          id: "9363",
          name: "Chopinzinho",
          state_id: "528",
        },
        {
          id: "9364",
          name: "Cianorte",
          state_id: "528",
        },
        {
          id: "9365",
          name: "Clevelandia",
          state_id: "528",
        },
        {
          id: "9366",
          name: "Colombo",
          state_id: "528",
        },
        {
          id: "9367",
          name: "Colorado",
          state_id: "528",
        },
        {
          id: "9368",
          name: "Contenda",
          state_id: "528",
        },
        {
          id: "9369",
          name: "Corbelia",
          state_id: "528",
        },
        {
          id: "9370",
          name: "Cornelio Procopio",
          state_id: "528",
        },
        {
          id: "9371",
          name: "Coronel Vivida",
          state_id: "528",
        },
        {
          id: "9372",
          name: "Cruzeiro do Oeste",
          state_id: "528",
        },
        {
          id: "9373",
          name: "Curitiba",
          state_id: "528",
        },
        {
          id: "9374",
          name: "Dois Vizinhos",
          state_id: "528",
        },
        {
          id: "9375",
          name: "Engenheiro Beltrao",
          state_id: "528",
        },
        {
          id: "9376",
          name: "Faxinal",
          state_id: "528",
        },
        {
          id: "9377",
          name: "Fazenda Rio Grande",
          state_id: "528",
        },
        {
          id: "9378",
          name: "Florestopolis",
          state_id: "528",
        },
        {
          id: "9379",
          name: "Foz do Iguacu",
          state_id: "528",
        },
        {
          id: "9380",
          name: "Francisco Beltrao",
          state_id: "528",
        },
        {
          id: "9381",
          name: "Goioere",
          state_id: "528",
        },
        {
          id: "9382",
          name: "Guaira",
          state_id: "528",
        },
        {
          id: "9383",
          name: "Guaraniacu",
          state_id: "528",
        },
        {
          id: "9384",
          name: "Guarapuava",
          state_id: "528",
        },
        {
          id: "9385",
          name: "Guaratuba",
          state_id: "528",
        },
        {
          id: "9386",
          name: "Ibaiti",
          state_id: "528",
        },
        {
          id: "9387",
          name: "Ibipora",
          state_id: "528",
        },
        {
          id: "9388",
          name: "Imbituva",
          state_id: "528",
        },
        {
          id: "9389",
          name: "Ipora",
          state_id: "528",
        },
        {
          id: "9390",
          name: "Irati",
          state_id: "528",
        },
        {
          id: "9391",
          name: "Itaperucu",
          state_id: "528",
        },
        {
          id: "9392",
          name: "Ivaipora",
          state_id: "528",
        },
        {
          id: "9393",
          name: "Jacarezinho",
          state_id: "528",
        },
        {
          id: "9394",
          name: "Jaguariaiva",
          state_id: "528",
        },
        {
          id: "9395",
          name: "Jandaia do Sul",
          state_id: "528",
        },
        {
          id: "9396",
          name: "Jataizinho",
          state_id: "528",
        },
        {
          id: "9397",
          name: "Lapa",
          state_id: "528",
        },
        {
          id: "9398",
          name: "Laranjeiras do Sul",
          state_id: "528",
        },
        {
          id: "9399",
          name: "Loanda",
          state_id: "528",
        },
        {
          id: "9400",
          name: "Londrina",
          state_id: "528",
        },
        {
          id: "9401",
          name: "Mandaguacu",
          state_id: "528",
        },
        {
          id: "9402",
          name: "Mandaguari",
          state_id: "528",
        },
        {
          id: "9403",
          name: "Marechal Candido Rondon",
          state_id: "528",
        },
        {
          id: "9404",
          name: "Marialva",
          state_id: "528",
        },
        {
          id: "9405",
          name: "Maringa",
          state_id: "528",
        },
        {
          id: "9406",
          name: "Matelandia",
          state_id: "528",
        },
        {
          id: "9407",
          name: "Matinhos",
          state_id: "528",
        },
        {
          id: "9408",
          name: "Medianeira",
          state_id: "528",
        },
        {
          id: "9409",
          name: "Moreira Sales",
          state_id: "528",
        },
        {
          id: "9410",
          name: "Nova Aurora",
          state_id: "528",
        },
        {
          id: "9411",
          name: "Nova Esperanca",
          state_id: "528",
        },
        {
          id: "9412",
          name: "Nova Londrina",
          state_id: "528",
        },
        {
          id: "9413",
          name: "Ortigueira",
          state_id: "528",
        },
        {
          id: "9414",
          name: "Paicandu",
          state_id: "528",
        },
        {
          id: "9415",
          name: "Palmas",
          state_id: "528",
        },
        {
          id: "9416",
          name: "Palmeira",
          state_id: "528",
        },
        {
          id: "9417",
          name: "Palotina",
          state_id: "528",
        },
        {
          id: "9418",
          name: "Paranagua",
          state_id: "528",
        },
        {
          id: "9419",
          name: "Paranavai",
          state_id: "528",
        },
        {
          id: "9420",
          name: "Pato Branco",
          state_id: "528",
        },
        {
          id: "9421",
          name: "Peabiru",
          state_id: "528",
        },
        {
          id: "9422",
          name: "Pinhais",
          state_id: "528",
        },
        {
          id: "9423",
          name: "Pinhao",
          state_id: "528",
        },
        {
          id: "9424",
          name: "Pirai do Sul",
          state_id: "528",
        },
        {
          id: "9425",
          name: "Piraquara",
          state_id: "528",
        },
        {
          id: "9426",
          name: "Pitanga",
          state_id: "528",
        },
        {
          id: "9427",
          name: "Ponta Grossa",
          state_id: "528",
        },
        {
          id: "9428",
          name: "Pontal do Parana",
          state_id: "528",
        },
        {
          id: "9429",
          name: "Porecatu",
          state_id: "528",
        },
        {
          id: "9430",
          name: "Primero de Maio",
          state_id: "528",
        },
        {
          id: "9431",
          name: "Prudentopolis",
          state_id: "528",
        },
        {
          id: "9432",
          name: "Quatro Barras",
          state_id: "528",
        },
        {
          id: "9433",
          name: "Quedas do Iguacu",
          state_id: "528",
        },
        {
          id: "9434",
          name: "Realeza",
          state_id: "528",
        },
        {
          id: "9435",
          name: "Reserva",
          state_id: "528",
        },
        {
          id: "9436",
          name: "Ribeirao do Pinhal",
          state_id: "528",
        },
        {
          id: "9437",
          name: "Rio Branco do Sul",
          state_id: "528",
        },
        {
          id: "9438",
          name: "Rio Negro",
          state_id: "528",
        },
        {
          id: "9439",
          name: "Rolandia",
          state_id: "528",
        },
        {
          id: "9440",
          name: "Santa Helena",
          state_id: "528",
        },
        {
          id: "9441",
          name: "Santa Terezinha de Itaipu",
          state_id: "528",
        },
        {
          id: "9442",
          name: "Santo Antonio da Platina",
          state_id: "528",
        },
        {
          id: "9443",
          name: "Santo Antonio do Sudoeste",
          state_id: "528",
        },
        {
          id: "9444",
          name: "Sao Joao do Ivai",
          state_id: "528",
        },
        {
          id: "9445",
          name: "Sao Jose dos Pinhais",
          state_id: "528",
        },
        {
          id: "9446",
          name: "Sao Mateus do Sul",
          state_id: "528",
        },
        {
          id: "9447",
          name: "Sao Miguel do Iguacu",
          state_id: "528",
        },
        {
          id: "9448",
          name: "Sarandi",
          state_id: "528",
        },
        {
          id: "9449",
          name: "Senges",
          state_id: "528",
        },
        {
          id: "9450",
          name: "Sertanopolis",
          state_id: "528",
        },
        {
          id: "9451",
          name: "Siquera Campos",
          state_id: "528",
        },
        {
          id: "9452",
          name: "Tapejara",
          state_id: "528",
        },
        {
          id: "9453",
          name: "Telemaco Borba",
          state_id: "528",
        },
        {
          id: "9454",
          name: "Terra Boa",
          state_id: "528",
        },
        {
          id: "9455",
          name: "Terra Rica",
          state_id: "528",
        },
        {
          id: "9456",
          name: "Terra Roxa",
          state_id: "528",
        },
        {
          id: "9457",
          name: "Tibagi",
          state_id: "528",
        },
        {
          id: "9458",
          name: "Toledo",
          state_id: "528",
        },
        {
          id: "9459",
          name: "Ubirata",
          state_id: "528",
        },
        {
          id: "9460",
          name: "Umuarama",
          state_id: "528",
        },
        {
          id: "9461",
          name: "Uniao da Victoria",
          state_id: "528",
        },
        {
          id: "9462",
          name: "Wenceslau Braz",
          state_id: "528",
        },
      ],
      Pernambuco: [
        {
          id: "9463",
          name: "Abreu e Lima",
          state_id: "529",
        },
        {
          id: "9464",
          name: "Afogados da Ingazeira",
          state_id: "529",
        },
        {
          id: "9465",
          name: "Agrestina",
          state_id: "529",
        },
        {
          id: "9466",
          name: "Agua Preta",
          state_id: "529",
        },
        {
          id: "9467",
          name: "Aguas Belas",
          state_id: "529",
        },
        {
          id: "9468",
          name: "Alianca",
          state_id: "529",
        },
        {
          id: "9469",
          name: "Altinho",
          state_id: "529",
        },
        {
          id: "9470",
          name: "Amaraji",
          state_id: "529",
        },
        {
          id: "9471",
          name: "Aracoiaba",
          state_id: "529",
        },
        {
          id: "9472",
          name: "Araripina",
          state_id: "529",
        },
        {
          id: "9473",
          name: "Arcoverde",
          state_id: "529",
        },
        {
          id: "9474",
          name: "Barra de Guabiraba",
          state_id: "529",
        },
        {
          id: "9475",
          name: "Barreiros",
          state_id: "529",
        },
        {
          id: "9476",
          name: "Belem de Sao Francisco",
          state_id: "529",
        },
        {
          id: "9477",
          name: "Belo Jardim",
          state_id: "529",
        },
        {
          id: "9478",
          name: "Bezerros",
          state_id: "529",
        },
        {
          id: "9479",
          name: "Bodoco",
          state_id: "529",
        },
        {
          id: "9480",
          name: "Bom Conselho",
          state_id: "529",
        },
        {
          id: "9481",
          name: "Bom Jardim",
          state_id: "529",
        },
        {
          id: "9482",
          name: "Bonito",
          state_id: "529",
        },
        {
          id: "9483",
          name: "Brejo da Madre de Deus",
          state_id: "529",
        },
        {
          id: "9484",
          name: "Buique",
          state_id: "529",
        },
        {
          id: "9485",
          name: "Cabo de Santo Agostinho",
          state_id: "529",
        },
        {
          id: "9486",
          name: "Cabrobo",
          state_id: "529",
        },
        {
          id: "9487",
          name: "Cachoeirinha",
          state_id: "529",
        },
        {
          id: "9488",
          name: "Caetes",
          state_id: "529",
        },
        {
          id: "9489",
          name: "Camaragibe",
          state_id: "529",
        },
        {
          id: "9490",
          name: "Camocim de Sao Felix",
          state_id: "529",
        },
        {
          id: "9491",
          name: "Canhotinho",
          state_id: "529",
        },
        {
          id: "9492",
          name: "Capoeiras",
          state_id: "529",
        },
        {
          id: "9493",
          name: "Carnaiba",
          state_id: "529",
        },
        {
          id: "9494",
          name: "Carpina",
          state_id: "529",
        },
        {
          id: "9495",
          name: "Caruaru",
          state_id: "529",
        },
        {
          id: "9496",
          name: "Catende",
          state_id: "529",
        },
        {
          id: "9497",
          name: "Cha Grande",
          state_id: "529",
        },
        {
          id: "9498",
          name: "Condado",
          state_id: "529",
        },
        {
          id: "9499",
          name: "Cumaru",
          state_id: "529",
        },
        {
          id: "9500",
          name: "Cupira",
          state_id: "529",
        },
        {
          id: "9501",
          name: "Custodia",
          state_id: "529",
        },
        {
          id: "9502",
          name: "Escada",
          state_id: "529",
        },
        {
          id: "9503",
          name: "Exu",
          state_id: "529",
        },
        {
          id: "9504",
          name: "Feira Nova",
          state_id: "529",
        },
        {
          id: "9505",
          name: "Fernando de Noronha",
          state_id: "529",
        },
        {
          id: "9506",
          name: "Flores",
          state_id: "529",
        },
        {
          id: "9507",
          name: "Floresta",
          state_id: "529",
        },
        {
          id: "9508",
          name: "Gameleira",
          state_id: "529",
        },
        {
          id: "9509",
          name: "Garanhuns",
          state_id: "529",
        },
        {
          id: "9510",
          name: "Gloria do Goita",
          state_id: "529",
        },
        {
          id: "9511",
          name: "Goiana",
          state_id: "529",
        },
        {
          id: "9512",
          name: "Gravata",
          state_id: "529",
        },
        {
          id: "9513",
          name: "Ibimirim",
          state_id: "529",
        },
        {
          id: "9514",
          name: "Igarassu",
          state_id: "529",
        },
        {
          id: "9515",
          name: "Inaja",
          state_id: "529",
        },
        {
          id: "9516",
          name: "Ipojuca",
          state_id: "529",
        },
        {
          id: "9517",
          name: "Ipubi",
          state_id: "529",
        },
        {
          id: "9518",
          name: "Itaiba",
          state_id: "529",
        },
        {
          id: "9519",
          name: "Itamaraca",
          state_id: "529",
        },
        {
          id: "9520",
          name: "Itambe",
          state_id: "529",
        },
        {
          id: "9521",
          name: "Itapissuma",
          state_id: "529",
        },
        {
          id: "9522",
          name: "Itaquitinga",
          state_id: "529",
        },
        {
          id: "9523",
          name: "Jaboatao",
          state_id: "529",
        },
        {
          id: "9524",
          name: "Joao Alfredo",
          state_id: "529",
        },
        {
          id: "9525",
          name: "Joaquim Nabuco",
          state_id: "529",
        },
        {
          id: "9526",
          name: "Lagoa do Itaenga",
          state_id: "529",
        },
        {
          id: "9527",
          name: "Lajedo",
          state_id: "529",
        },
        {
          id: "9528",
          name: "Limoeiro",
          state_id: "529",
        },
        {
          id: "9529",
          name: "Macaparana",
          state_id: "529",
        },
        {
          id: "9530",
          name: "Maraial",
          state_id: "529",
        },
        {
          id: "9531",
          name: "Moreno",
          state_id: "529",
        },
        {
          id: "9532",
          name: "Nazare da Mata",
          state_id: "529",
        },
        {
          id: "9533",
          name: "Olinda",
          state_id: "529",
        },
        {
          id: "9534",
          name: "Orobo",
          state_id: "529",
        },
        {
          id: "9535",
          name: "Ouricuri",
          state_id: "529",
        },
        {
          id: "9536",
          name: "Palmares",
          state_id: "529",
        },
        {
          id: "9537",
          name: "Panelas",
          state_id: "529",
        },
        {
          id: "9538",
          name: "Parnamirim",
          state_id: "529",
        },
        {
          id: "9539",
          name: "Passira",
          state_id: "529",
        },
        {
          id: "9540",
          name: "Paudalho",
          state_id: "529",
        },
        {
          id: "9541",
          name: "Paulista",
          state_id: "529",
        },
        {
          id: "9542",
          name: "Pedra",
          state_id: "529",
        },
        {
          id: "9543",
          name: "Pesqueira",
          state_id: "529",
        },
        {
          id: "9544",
          name: "Petrolandia",
          state_id: "529",
        },
        {
          id: "9545",
          name: "Petrolina",
          state_id: "529",
        },
        {
          id: "9546",
          name: "Pombos",
          state_id: "529",
        },
        {
          id: "9547",
          name: "Quipapa",
          state_id: "529",
        },
        {
          id: "9548",
          name: "Recife",
          state_id: "529",
        },
        {
          id: "9549",
          name: "Ribeirao",
          state_id: "529",
        },
        {
          id: "9550",
          name: "Rio Formoso",
          state_id: "529",
        },
        {
          id: "9551",
          name: "Salgueiro",
          state_id: "529",
        },
        {
          id: "9552",
          name: "Santa Cruz do Capibaribe",
          state_id: "529",
        },
        {
          id: "9553",
          name: "Santa Maria da Boa Vista",
          state_id: "529",
        },
        {
          id: "9554",
          name: "Sao Bento do Una",
          state_id: "529",
        },
        {
          id: "9555",
          name: "Sao Caitano",
          state_id: "529",
        },
        {
          id: "9556",
          name: "Sao Joao",
          state_id: "529",
        },
        {
          id: "9557",
          name: "Sao Joaquim do Monte",
          state_id: "529",
        },
        {
          id: "9558",
          name: "Sao Jose da Coroa Grande",
          state_id: "529",
        },
        {
          id: "9559",
          name: "Sao Jose do Belmonte",
          state_id: "529",
        },
        {
          id: "9560",
          name: "Sao Jose do Egito",
          state_id: "529",
        },
        {
          id: "9561",
          name: "Sao Lourenco da Mata",
          state_id: "529",
        },
        {
          id: "9562",
          name: "Serra Talhada",
          state_id: "529",
        },
        {
          id: "9563",
          name: "Sertania",
          state_id: "529",
        },
        {
          id: "9564",
          name: "Sirinhaem",
          state_id: "529",
        },
        {
          id: "9565",
          name: "Surubim",
          state_id: "529",
        },
        {
          id: "9566",
          name: "Tabira",
          state_id: "529",
        },
        {
          id: "9567",
          name: "Tamandare",
          state_id: "529",
        },
        {
          id: "9568",
          name: "Taquaritinga do Norte",
          state_id: "529",
        },
        {
          id: "9569",
          name: "Timbauba",
          state_id: "529",
        },
        {
          id: "9570",
          name: "Toritama",
          state_id: "529",
        },
        {
          id: "9571",
          name: "Trindade",
          state_id: "529",
        },
        {
          id: "9572",
          name: "Triunfo",
          state_id: "529",
        },
        {
          id: "9573",
          name: "Tupanatinga",
          state_id: "529",
        },
        {
          id: "9574",
          name: "Vicencia",
          state_id: "529",
        },
        {
          id: "9575",
          name: "Vitoria de Santo Antao",
          state_id: "529",
        },
      ],
      Piaui: [
        {
          id: "9576",
          name: "Agua Branca",
          state_id: "530",
        },
        {
          id: "9577",
          name: "Alto Longa",
          state_id: "530",
        },
        {
          id: "9578",
          name: "Altos",
          state_id: "530",
        },
        {
          id: "9579",
          name: "Amarante",
          state_id: "530",
        },
        {
          id: "9580",
          name: "Avelino Lopes",
          state_id: "530",
        },
        {
          id: "9581",
          name: "Barras",
          state_id: "530",
        },
        {
          id: "9582",
          name: "Batalha",
          state_id: "530",
        },
        {
          id: "9583",
          name: "Beneditinos",
          state_id: "530",
        },
        {
          id: "9584",
          name: "Bom Jesus",
          state_id: "530",
        },
        {
          id: "9585",
          name: "Buriti dos Lopes",
          state_id: "530",
        },
        {
          id: "9586",
          name: "Campo Maior",
          state_id: "530",
        },
        {
          id: "9587",
          name: "Canto do Buriti",
          state_id: "530",
        },
        {
          id: "9588",
          name: "Castelo do Piaui",
          state_id: "530",
        },
        {
          id: "9589",
          name: "Cocal",
          state_id: "530",
        },
        {
          id: "9590",
          name: "Corrente",
          state_id: "530",
        },
        {
          id: "9591",
          name: "Demerval Lobao",
          state_id: "530",
        },
        {
          id: "9592",
          name: "Elesbao Veloso",
          state_id: "530",
        },
        {
          id: "9593",
          name: "Esperantina",
          state_id: "530",
        },
        {
          id: "9594",
          name: "Floriano",
          state_id: "530",
        },
        {
          id: "9595",
          name: "Gilbues",
          state_id: "530",
        },
        {
          id: "9596",
          name: "Guadalupe",
          state_id: "530",
        },
        {
          id: "9597",
          name: "Inhuma",
          state_id: "530",
        },
        {
          id: "9598",
          name: "Itainopolis",
          state_id: "530",
        },
        {
          id: "9599",
          name: "Itaueira",
          state_id: "530",
        },
        {
          id: "9600",
          name: "Jaicos",
          state_id: "530",
        },
        {
          id: "9601",
          name: "Joaquim Pires",
          state_id: "530",
        },
        {
          id: "9602",
          name: "Jose de Freitas",
          state_id: "530",
        },
        {
          id: "9603",
          name: "Luis Correia",
          state_id: "530",
        },
        {
          id: "9604",
          name: "Luzilandia",
          state_id: "530",
        },
        {
          id: "9605",
          name: "Matias Olimpio",
          state_id: "530",
        },
        {
          id: "9606",
          name: "Miguel Alves",
          state_id: "530",
        },
        {
          id: "9607",
          name: "Monsenhor Gil",
          state_id: "530",
        },
        {
          id: "9608",
          name: "Oeiras",
          state_id: "530",
        },
        {
          id: "9609",
          name: "Palmeirais",
          state_id: "530",
        },
        {
          id: "9610",
          name: "Parnaiba",
          state_id: "530",
        },
        {
          id: "9611",
          name: "Pedro II",
          state_id: "530",
        },
        {
          id: "9612",
          name: "Picos",
          state_id: "530",
        },
        {
          id: "9613",
          name: "Pimenteiras",
          state_id: "530",
        },
        {
          id: "9614",
          name: "Pio IX",
          state_id: "530",
        },
        {
          id: "9615",
          name: "Piracuruca",
          state_id: "530",
        },
        {
          id: "9616",
          name: "Piripiri",
          state_id: "530",
        },
        {
          id: "9617",
          name: "Porto",
          state_id: "530",
        },
        {
          id: "9618",
          name: "Regeneracao",
          state_id: "530",
        },
        {
          id: "9619",
          name: "Sao Joao do Piaui",
          state_id: "530",
        },
        {
          id: "9620",
          name: "Sao Miguel do Tapuio",
          state_id: "530",
        },
        {
          id: "9621",
          name: "Sao Pedro do Piaui",
          state_id: "530",
        },
        {
          id: "9622",
          name: "Sao Raimundo Nonato",
          state_id: "530",
        },
        {
          id: "9623",
          name: "Simoes",
          state_id: "530",
        },
        {
          id: "9624",
          name: "Simplicio Mendes",
          state_id: "530",
        },
        {
          id: "9625",
          name: "Teresina",
          state_id: "530",
        },
        {
          id: "9626",
          name: "Uniao",
          state_id: "530",
        },
        {
          id: "9627",
          name: "Urucui",
          state_id: "530",
        },
        {
          id: "9628",
          name: "Valenca do Piaui",
          state_id: "530",
        },
      ],
      "Rio Grande do Norte": [],
      "Rio Grande do Sul": [],
      "Rio de Janeiro": [],
      Rondonia: [
        {
          id: "9629",
          name: "Alta Floresta d''Oeste",
          state_id: "534",
        },
        {
          id: "9630",
          name: "Alto Alegre do Parecis",
          state_id: "534",
        },
        {
          id: "9631",
          name: "Alto Paraiso",
          state_id: "534",
        },
        {
          id: "9632",
          name: "Alvorada d''Oeste",
          state_id: "534",
        },
        {
          id: "9633",
          name: "Ariquemes",
          state_id: "534",
        },
        {
          id: "9634",
          name: "Buritis",
          state_id: "534",
        },
        {
          id: "9635",
          name: "Cacoal",
          state_id: "534",
        },
        {
          id: "9636",
          name: "Candeias do Jamari",
          state_id: "534",
        },
        {
          id: "9637",
          name: "Cerejeiras",
          state_id: "534",
        },
        {
          id: "9638",
          name: "Colorado do Oeste",
          state_id: "534",
        },
        {
          id: "9639",
          name: "Corumbiara",
          state_id: "534",
        },
        {
          id: "9640",
          name: "Espigao d''Oeste",
          state_id: "534",
        },
        {
          id: "9641",
          name: "Governador Jorge Teixeira",
          state_id: "534",
        },
        {
          id: "9642",
          name: "Guajara-Mirim",
          state_id: "534",
        },
        {
          id: "9643",
          name: "Jaru",
          state_id: "534",
        },
        {
          id: "9644",
          name: "Ji-Parana",
          state_id: "534",
        },
        {
          id: "9645",
          name: "Machadinho d''Oeste",
          state_id: "534",
        },
        {
          id: "9646",
          name: "Ministro Andreazza",
          state_id: "534",
        },
        {
          id: "9647",
          name: "Mirante da Serra",
          state_id: "534",
        },
        {
          id: "9648",
          name: "Nova Brasilandia d''Oeste",
          state_id: "534",
        },
        {
          id: "9649",
          name: "Nova Mamore",
          state_id: "534",
        },
        {
          id: "9650",
          name: "Novo Horizonte do Oeste",
          state_id: "534",
        },
        {
          id: "9651",
          name: "Ouro Preto do Oeste",
          state_id: "534",
        },
        {
          id: "9652",
          name: "Pimenta Bueno",
          state_id: "534",
        },
        {
          id: "9653",
          name: "Porto Velho",
          state_id: "534",
        },
        {
          id: "9654",
          name: "Presidente Medici",
          state_id: "534",
        },
        {
          id: "9655",
          name: "Rolim de Moura",
          state_id: "534",
        },
        {
          id: "9656",
          name: "Santa Luzia d''Oeste",
          state_id: "534",
        },
        {
          id: "9657",
          name: "Sao Miguel do Guapore",
          state_id: "534",
        },
        {
          id: "9658",
          name: "Urupa",
          state_id: "534",
        },
        {
          id: "9659",
          name: "Vale do Paraiso",
          state_id: "534",
        },
        {
          id: "9660",
          name: "Vilhena",
          state_id: "534",
        },
      ],
      Roraima: [
        {
          id: "9661",
          name: "Alto Alegre",
          state_id: "535",
        },
        {
          id: "9662",
          name: "Boa Vista",
          state_id: "535",
        },
        {
          id: "9663",
          name: "Bonfim",
          state_id: "535",
        },
        {
          id: "9664",
          name: "Caracarai",
          state_id: "535",
        },
        {
          id: "9665",
          name: "Mucajai",
          state_id: "535",
        },
        {
          id: "9666",
          name: "Normandia",
          state_id: "535",
        },
        {
          id: "9667",
          name: "Sao Joao da Baliza",
          state_id: "535",
        },
        {
          id: "9668",
          name: "Sao Luiz",
          state_id: "535",
        },
      ],
      "Santa Catarina": [],
      "Sao Paulo": [],
      Sergipe: [
        {
          id: "9669",
          name: "Aquidaba",
          state_id: "538",
        },
        {
          id: "9670",
          name: "Aracaju",
          state_id: "538",
        },
        {
          id: "9671",
          name: "Araua",
          state_id: "538",
        },
        {
          id: "9672",
          name: "Areia Branca",
          state_id: "538",
        },
        {
          id: "9673",
          name: "Barra dos Coqueiros",
          state_id: "538",
        },
        {
          id: "9674",
          name: "Boquim",
          state_id: "538",
        },
        {
          id: "9675",
          name: "Campo do Brito",
          state_id: "538",
        },
        {
          id: "9676",
          name: "Caninde de Sao Francisco",
          state_id: "538",
        },
        {
          id: "9677",
          name: "Capela",
          state_id: "538",
        },
        {
          id: "9678",
          name: "Carira",
          state_id: "538",
        },
        {
          id: "9679",
          name: "Cristinapolis",
          state_id: "538",
        },
        {
          id: "9680",
          name: "Estancia",
          state_id: "538",
        },
        {
          id: "9681",
          name: "Frei Paulo",
          state_id: "538",
        },
        {
          id: "9682",
          name: "Gararu",
          state_id: "538",
        },
        {
          id: "9683",
          name: "Indiaroba",
          state_id: "538",
        },
        {
          id: "9684",
          name: "Itabaiana",
          state_id: "538",
        },
        {
          id: "9685",
          name: "Itabaianinha",
          state_id: "538",
        },
        {
          id: "9686",
          name: "Itaporanga d''Ajuda",
          state_id: "538",
        },
        {
          id: "9687",
          name: "Japaratuba",
          state_id: "538",
        },
        {
          id: "9688",
          name: "Japoata",
          state_id: "538",
        },
        {
          id: "9689",
          name: "Lagarto",
          state_id: "538",
        },
        {
          id: "9690",
          name: "Laranjeiras",
          state_id: "538",
        },
        {
          id: "9691",
          name: "Malhador",
          state_id: "538",
        },
        {
          id: "9692",
          name: "Maruim",
          state_id: "538",
        },
        {
          id: "9693",
          name: "Moita Bonita",
          state_id: "538",
        },
        {
          id: "9694",
          name: "Monte Alegre de Sergipe",
          state_id: "538",
        },
        {
          id: "9695",
          name: "Neopolis",
          state_id: "538",
        },
        {
          id: "9696",
          name: "Nossa Senhora da Gloria",
          state_id: "538",
        },
        {
          id: "9697",
          name: "Nossa Senhora das Dores",
          state_id: "538",
        },
        {
          id: "9698",
          name: "Nossa Senhora do Socorro",
          state_id: "538",
        },
        {
          id: "9699",
          name: "Pacatuba",
          state_id: "538",
        },
        {
          id: "9700",
          name: "Poco Verde",
          state_id: "538",
        },
        {
          id: "9701",
          name: "Porto da Folha",
          state_id: "538",
        },
        {
          id: "9702",
          name: "Propria",
          state_id: "538",
        },
        {
          id: "9703",
          name: "Riachao do Dantas",
          state_id: "538",
        },
        {
          id: "9704",
          name: "Ribeiropolis",
          state_id: "538",
        },
        {
          id: "9705",
          name: "Salgado",
          state_id: "538",
        },
        {
          id: "9706",
          name: "Santa Luzia do Itanhy",
          state_id: "538",
        },
        {
          id: "9707",
          name: "Santo Amaro das Brotas",
          state_id: "538",
        },
        {
          id: "9708",
          name: "Sao Cristovao",
          state_id: "538",
        },
        {
          id: "9709",
          name: "Simao Dias",
          state_id: "538",
        },
        {
          id: "9710",
          name: "Tobias Barreto",
          state_id: "538",
        },
        {
          id: "9711",
          name: "Tomar do Geru",
          state_id: "538",
        },
        {
          id: "9712",
          name: "Umbauba",
          state_id: "538",
        },
      ],
      Tocantins: [
        {
          id: "9713",
          name: "Alvorada",
          state_id: "539",
        },
        {
          id: "9714",
          name: "Ananas",
          state_id: "539",
        },
        {
          id: "9715",
          name: "Araguacu",
          state_id: "539",
        },
        {
          id: "9716",
          name: "Araguaina",
          state_id: "539",
        },
        {
          id: "9717",
          name: "Araguatins",
          state_id: "539",
        },
        {
          id: "9718",
          name: "Arraias",
          state_id: "539",
        },
        {
          id: "9719",
          name: "Augustinopolis",
          state_id: "539",
        },
        {
          id: "9720",
          name: "Axixa do Tocantins",
          state_id: "539",
        },
        {
          id: "9721",
          name: "Colinas do Tocantins",
          state_id: "539",
        },
        {
          id: "9722",
          name: "Dianopolis",
          state_id: "539",
        },
        {
          id: "9723",
          name: "Formoso do Araguaia",
          state_id: "539",
        },
        {
          id: "9724",
          name: "Goiatins",
          state_id: "539",
        },
        {
          id: "9725",
          name: "Guarai",
          state_id: "539",
        },
        {
          id: "9726",
          name: "Gurupi",
          state_id: "539",
        },
        {
          id: "9727",
          name: "Miracema do Tocantins",
          state_id: "539",
        },
        {
          id: "9728",
          name: "Miranorte",
          state_id: "539",
        },
        {
          id: "9729",
          name: "Palmas",
          state_id: "539",
        },
        {
          id: "9730",
          name: "Paraiso",
          state_id: "539",
        },
        {
          id: "9731",
          name: "Parana",
          state_id: "539",
        },
        {
          id: "9732",
          name: "Porto Nacional",
          state_id: "539",
        },
        {
          id: "9733",
          name: "Sitio Novo do Tocantins",
          state_id: "539",
        },
        {
          id: "9734",
          name: "Taguatinga",
          state_id: "539",
        },
        {
          id: "9735",
          name: "Tocantinopolis",
          state_id: "539",
        },
        {
          id: "9736",
          name: "Wanderlandia",
          state_id: "539",
        },
        {
          id: "9737",
          name: "Xambioa",
          state_id: "539",
        },
      ],
    },
  },
  BS: {
    name: "Bahamas",
    native: "Bahamas",
    phone: "1242",
    continent: "NA",
    capital: "Nassau",
    currency: "BSD",
    languages: ["en"],
    emoji: "🇧🇸",
    emojiU: "U+1F1E7 U+1F1F8",
    states: {
      Abaco: [
        {
          id: "7247",
          name: "Coopers Town",
          state_id: "310",
        },
        {
          id: "7248",
          name: "Marsh Harbour",
          state_id: "310",
        },
      ],
      "Acklins Island": [],
      Andros: [
        {
          id: "7249",
          name: "Andros Town",
          state_id: "312",
        },
        {
          id: "7250",
          name: "Nicholls Town",
          state_id: "312",
        },
      ],
      "Berry Islands": [],
      Biminis: [
        {
          id: "7251",
          name: "Alice Town",
          state_id: "314",
        },
      ],
      "Cat Island": [],
      "Crooked Island": [],
      Eleuthera: [
        {
          id: "7252",
          name: "Freetown",
          state_id: "317",
        },
        {
          id: "7253",
          name: "Rock Sound",
          state_id: "317",
        },
      ],
      "Exuma and Cays": [],
      "Grand Bahama": [],
      "Inagua Islands": [],
      "Long Island": [],
      Mayaguana: [
        {
          id: "7254",
          name: "Pirates Well",
          state_id: "322",
        },
      ],
      "New Providence": [],
      "Ragged Island": [],
      "Rum Cay": [],
      "San Salvador": [],
    },
  },
  BT: {
    name: "Bhutan",
    native: "ʼbrug-yul",
    phone: "975",
    continent: "AS",
    capital: "Thimphu",
    currency: "BTN,INR",
    languages: ["dz"],
    emoji: "🇧🇹",
    emojiU: "U+1F1E7 U+1F1F9",
    states: {
      Bumthang: [
        {
          id: "8118",
          name: "Jakar",
          state_id: "459",
        },
      ],
      Chhukha: [
        {
          id: "8119",
          name: "Chhukha",
          state_id: "460",
        },
        {
          id: "8120",
          name: "Phuentsholing",
          state_id: "460",
        },
      ],
      Chirang: [
        {
          id: "8121",
          name: "Damphu",
          state_id: "461",
        },
      ],
      Daga: [
        {
          id: "8122",
          name: "Taga Dzong",
          state_id: "462",
        },
      ],
      Geylegphug: [
        {
          id: "8123",
          name: "Geylegphug",
          state_id: "463",
        },
      ],
      Ha: [
        {
          id: "8124",
          name: "Ha",
          state_id: "464",
        },
      ],
      Lhuntshi: [
        {
          id: "8125",
          name: "Lhuntshi",
          state_id: "465",
        },
      ],
      Mongar: [
        {
          id: "8126",
          name: "Mongar",
          state_id: "466",
        },
      ],
      Pemagatsel: [
        {
          id: "8127",
          name: "Pemagatsel",
          state_id: "467",
        },
      ],
      Punakha: [
        {
          id: "8128",
          name: "Gasa",
          state_id: "468",
        },
        {
          id: "8129",
          name: "Punakha",
          state_id: "468",
        },
      ],
      Rinpung: [
        {
          id: "8130",
          name: "Paro",
          state_id: "469",
        },
      ],
      Samchi: [
        {
          id: "8131",
          name: "Phuntsholing",
          state_id: "470",
        },
        {
          id: "8132",
          name: "Samchi",
          state_id: "470",
        },
      ],
      "Samdrup Jongkhar": [],
      Shemgang: [
        {
          id: "8133",
          name: "Shemgang",
          state_id: "472",
        },
      ],
      Tashigang: [
        {
          id: "8134",
          name: "Tashigang",
          state_id: "473",
        },
      ],
      Timphu: [
        {
          id: "8135",
          name: "Thimphu",
          state_id: "474",
        },
        {
          id: "8136",
          name: "Timphu",
          state_id: "474",
        },
      ],
      Tongsa: [
        {
          id: "8137",
          name: "Tongsa",
          state_id: "475",
        },
      ],
      Wangdiphodrang: [
        {
          id: "8138",
          name: "Wangdiphodrang",
          state_id: "476",
        },
      ],
    },
  },
  BV: {
    name: "Bouvet Island",
    native: "Bouvetøya",
    phone: "47",
    continent: "AN",
    capital: "",
    currency: "NOK",
    languages: ["no", "nb", "nn"],
    emoji: "🇧🇻",
    emojiU: "U+1F1E7 U+1F1FB",
    states: {
      "Bouvet Island": [],
    },
  },
  BW: {
    name: "Botswana",
    native: "Botswana",
    phone: "267",
    continent: "AF",
    capital: "Gaborone",
    currency: "BWP",
    languages: ["en", "tn"],
    emoji: "🇧🇼",
    emojiU: "U+1F1E7 U+1F1FC",
    states: {
      "Central Bobonong": [],
      "Central Boteti": [],
      "Central Mahalapye": [],
      "Central Serowe-Palapye": [],
      "Central Tutume": [],
      Chobe: [
        {
          id: "8199",
          name: "Kachikau",
          state_id: "493",
        },
        {
          id: "8200",
          name: "Kasane",
          state_id: "493",
        },
        {
          id: "8201",
          name: "Kavimba",
          state_id: "493",
        },
        {
          id: "8202",
          name: "Kazungula",
          state_id: "493",
        },
        {
          id: "8203",
          name: "Lesoma",
          state_id: "493",
        },
        {
          id: "8204",
          name: "Muchinje-Mabale",
          state_id: "493",
        },
        {
          id: "8205",
          name: "Pandamatenga",
          state_id: "493",
        },
        {
          id: "8206",
          name: "Pandamatenga Botswana Defence",
          state_id: "493",
        },
        {
          id: "8207",
          name: "Parakarungu",
          state_id: "493",
        },
        {
          id: "8208",
          name: "Satau",
          state_id: "493",
        },
      ],
      Francistown: [
        {
          id: "8209",
          name: "Francistown",
          state_id: "494",
        },
      ],
      Gaborone: [
        {
          id: "8210",
          name: "Gaborone",
          state_id: "495",
        },
      ],
      Ghanzi: [
        {
          id: "8211",
          name: "Bere",
          state_id: "496",
        },
        {
          id: "8212",
          name: "Charles Hill",
          state_id: "496",
        },
        {
          id: "8213",
          name: "Chobokwane",
          state_id: "496",
        },
        {
          id: "8214",
          name: "Dekar",
          state_id: "496",
        },
        {
          id: "8215",
          name: "East Hanahai",
          state_id: "496",
        },
        {
          id: "8216",
          name: "Ghanzi",
          state_id: "496",
        },
        {
          id: "8217",
          name: "Groote Laagte",
          state_id: "496",
        },
        {
          id: "8218",
          name: "Kacgae",
          state_id: "496",
        },
        {
          id: "8219",
          name: "Karakobis",
          state_id: "496",
        },
        {
          id: "8220",
          name: "Kuke Quarantine Camp",
          state_id: "496",
        },
        {
          id: "8221",
          name: "Kule",
          state_id: "496",
        },
        {
          id: "8222",
          name: "Makunda",
          state_id: "496",
        },
        {
          id: "8223",
          name: "Ncojane",
          state_id: "496",
        },
        {
          id: "8224",
          name: "New Xade",
          state_id: "496",
        },
        {
          id: "8225",
          name: "New Xanagas",
          state_id: "496",
        },
        {
          id: "8226",
          name: "Qabo",
          state_id: "496",
        },
        {
          id: "8227",
          name: "Tsootsha",
          state_id: "496",
        },
        {
          id: "8228",
          name: "West Hanahai",
          state_id: "496",
        },
      ],
      Jwaneng: [
        {
          id: "8229",
          name: "Jwaneng",
          state_id: "497",
        },
      ],
      "Kgalagadi North": [],
      "Kgalagadi South": [],
      Kgatleng: [
        {
          id: "8230",
          name: "Artisia",
          state_id: "500",
        },
        {
          id: "8231",
          name: "Bokaa",
          state_id: "500",
        },
        {
          id: "8232",
          name: "Dikgonye",
          state_id: "500",
        },
        {
          id: "8233",
          name: "Dikwididi",
          state_id: "500",
        },
        {
          id: "8234",
          name: "Kgomodiatshaba",
          state_id: "500",
        },
        {
          id: "8235",
          name: "Khurutshe",
          state_id: "500",
        },
        {
          id: "8236",
          name: "Leshibitse",
          state_id: "500",
        },
        {
          id: "8237",
          name: "Mabalane",
          state_id: "500",
        },
        {
          id: "8238",
          name: "Malolwane",
          state_id: "500",
        },
        {
          id: "8239",
          name: "Malotwana Siding",
          state_id: "500",
        },
        {
          id: "8240",
          name: "Matebeleng",
          state_id: "500",
        },
        {
          id: "8241",
          name: "Mmamashia",
          state_id: "500",
        },
        {
          id: "8242",
          name: "Mmathubudukwane",
          state_id: "500",
        },
        {
          id: "8243",
          name: "Mochudi",
          state_id: "500",
        },
        {
          id: "8244",
          name: "Modipane",
          state_id: "500",
        },
        {
          id: "8245",
          name: "Morwa",
          state_id: "500",
        },
        {
          id: "8246",
          name: "Oliphants Drift",
          state_id: "500",
        },
        {
          id: "8247",
          name: "Oodi",
          state_id: "500",
        },
        {
          id: "8248",
          name: "Pilane",
          state_id: "500",
        },
        {
          id: "8249",
          name: "Ramonaka",
          state_id: "500",
        },
        {
          id: "8250",
          name: "Ramotlabaki",
          state_id: "500",
        },
        {
          id: "8251",
          name: "Rasesa",
          state_id: "500",
        },
        {
          id: "8252",
          name: "Sikwane",
          state_id: "500",
        },
      ],
      Kweneng: [
        {
          id: "8253",
          name: "Boatlaname",
          state_id: "501",
        },
        {
          id: "8254",
          name: "Botlhapatlou",
          state_id: "501",
        },
        {
          id: "8255",
          name: "Diagane",
          state_id: "501",
        },
        {
          id: "8256",
          name: "Diphudugodu",
          state_id: "501",
        },
        {
          id: "8257",
          name: "Diremogolo Lands",
          state_id: "501",
        },
        {
          id: "8258",
          name: "Ditshegwane",
          state_id: "501",
        },
        {
          id: "8259",
          name: "Ditshukudu",
          state_id: "501",
        },
        {
          id: "8260",
          name: "Dumadumane",
          state_id: "501",
        },
        {
          id: "8261",
          name: "Dutlwe",
          state_id: "501",
        },
        {
          id: "8262",
          name: "Gabane",
          state_id: "501",
        },
        {
          id: "8263",
          name: "Gakgatla",
          state_id: "501",
        },
        {
          id: "8264",
          name: "Gakuto",
          state_id: "501",
        },
        {
          id: "8265",
          name: "Galekgatshwane",
          state_id: "501",
        },
        {
          id: "8266",
          name: "Gamodubu",
          state_id: "501",
        },
        {
          id: "8267",
          name: "Gaphatshwa",
          state_id: "501",
        },
        {
          id: "8268",
          name: "Hatsalatladi",
          state_id: "501",
        },
        {
          id: "8269",
          name: "Kamenakwe",
          state_id: "501",
        },
        {
          id: "8270",
          name: "Kaudwane",
          state_id: "501",
        },
        {
          id: "8271",
          name: "Kgaphamadi",
          state_id: "501",
        },
        {
          id: "8272",
          name: "Kgope",
          state_id: "501",
        },
        {
          id: "8273",
          name: "Khekhenya-Chepetese",
          state_id: "501",
        },
        {
          id: "8274",
          name: "Khudumelapye",
          state_id: "501",
        },
        {
          id: "8275",
          name: "Kopong",
          state_id: "501",
        },
        {
          id: "8276",
          name: "Kotolaname",
          state_id: "501",
        },
        {
          id: "8277",
          name: "Kubung",
          state_id: "501",
        },
        {
          id: "8278",
          name: "Kumakwane",
          state_id: "501",
        },
        {
          id: "8279",
          name: "Kweneng",
          state_id: "501",
        },
        {
          id: "8280",
          name: "Lentsweletau",
          state_id: "501",
        },
        {
          id: "8281",
          name: "Lephepe",
          state_id: "501",
        },
        {
          id: "8282",
          name: "Lesirane",
          state_id: "501",
        },
        {
          id: "8283",
          name: "Letlhakeng",
          state_id: "501",
        },
        {
          id: "8284",
          name: "Losilakgokong",
          state_id: "501",
        },
        {
          id: "8285",
          name: "Maboane",
          state_id: "501",
        },
        {
          id: "8286",
          name: "Mahetlwe",
          state_id: "501",
        },
        {
          id: "8287",
          name: "Makabanyane-Dikgokong",
          state_id: "501",
        },
        {
          id: "8288",
          name: "Malwelwe",
          state_id: "501",
        },
        {
          id: "8289",
          name: "Mamhiko",
          state_id: "501",
        },
        {
          id: "8290",
          name: "Manaledi",
          state_id: "501",
        },
        {
          id: "8291",
          name: "Mantshwabisi",
          state_id: "501",
        },
        {
          id: "8292",
          name: "Marejwane",
          state_id: "501",
        },
        {
          id: "8293",
          name: "Masebele",
          state_id: "501",
        },
        {
          id: "8294",
          name: "Medie",
          state_id: "501",
        },
        {
          id: "8295",
          name: "Metsibotlhoko",
          state_id: "501",
        },
        {
          id: "8296",
          name: "Metsimotlhaba",
          state_id: "501",
        },
        {
          id: "8297",
          name: "Mmakanke",
          state_id: "501",
        },
        {
          id: "8298",
          name: "Mmankgodi",
          state_id: "501",
        },
        {
          id: "8299",
          name: "Mmanoko",
          state_id: "501",
        },
        {
          id: "8300",
          name: "Mmokolodi",
          state_id: "501",
        },
        {
          id: "8301",
          name: "Mmopane",
          state_id: "501",
        },
        {
          id: "8302",
          name: "Mmopane Lands",
          state_id: "501",
        },
        {
          id: "8303",
          name: "Mogoditshane",
          state_id: "501",
        },
        {
          id: "8304",
          name: "Mogoditshane Botswana Defence",
          state_id: "501",
        },
        {
          id: "8305",
          name: "Mogoditshane Lands",
          state_id: "501",
        },
        {
          id: "8306",
          name: "Mogonono",
          state_id: "501",
        },
        {
          id: "8307",
          name: "Molepolole",
          state_id: "501",
        },
        {
          id: "8308",
          name: "Mononyane",
          state_id: "501",
        },
        {
          id: "8309",
          name: "Monwane",
          state_id: "501",
        },
        {
          id: "8310",
          name: "Morabane",
          state_id: "501",
        },
        {
          id: "8311",
          name: "Morope",
          state_id: "501",
        },
        {
          id: "8312",
          name: "Moshaweng",
          state_id: "501",
        },
        {
          id: "8313",
          name: "Mosokotswe",
          state_id: "501",
        },
        {
          id: "8314",
          name: "Motokwe",
          state_id: "501",
        },
        {
          id: "8315",
          name: "Ngware",
          state_id: "501",
        },
        {
          id: "8316",
          name: "Nkoyaphiri",
          state_id: "501",
        },
        {
          id: "8317",
          name: "Ramaphatlhe",
          state_id: "501",
        },
        {
          id: "8318",
          name: "Salajwe",
          state_id: "501",
        },
        {
          id: "8319",
          name: "Serinane",
          state_id: "501",
        },
        {
          id: "8320",
          name: "Sesung",
          state_id: "501",
        },
        {
          id: "8321",
          name: "Shadishadi",
          state_id: "501",
        },
        {
          id: "8322",
          name: "Sojwe",
          state_id: "501",
        },
        {
          id: "8323",
          name: "Sorilatholo",
          state_id: "501",
        },
        {
          id: "8324",
          name: "Suping",
          state_id: "501",
        },
        {
          id: "8325",
          name: "Takatokwane",
          state_id: "501",
        },
        {
          id: "8326",
          name: "Thamaga",
          state_id: "501",
        },
        {
          id: "8327",
          name: "Thebephatshwa",
          state_id: "501",
        },
        {
          id: "8328",
          name: "Tlowaneng",
          state_id: "501",
        },
        {
          id: "8329",
          name: "Tsetseng",
          state_id: "501",
        },
        {
          id: "8330",
          name: "Tswaane",
          state_id: "501",
        },
      ],
      Lobatse: [
        {
          id: "8331",
          name: "Lobatse",
          state_id: "502",
        },
      ],
      Ngamiland: [
        {
          id: "8332",
          name: "Bodibeng",
          state_id: "503",
        },
        {
          id: "8333",
          name: "Boro",
          state_id: "503",
        },
        {
          id: "8334",
          name: "Botlhatlogo",
          state_id: "503",
        },
        {
          id: "8335",
          name: "Chanoga",
          state_id: "503",
        },
        {
          id: "8336",
          name: "Chuchubega",
          state_id: "503",
        },
        {
          id: "8337",
          name: "Daonara",
          state_id: "503",
        },
        {
          id: "8338",
          name: "Ditshiping",
          state_id: "503",
        },
        {
          id: "8339",
          name: "Habu",
          state_id: "503",
        },
        {
          id: "8340",
          name: "Jao",
          state_id: "503",
        },
        {
          id: "8341",
          name: "Kareng",
          state_id: "503",
        },
        {
          id: "8342",
          name: "Katamaga",
          state_id: "503",
        },
        {
          id: "8343",
          name: "Kgakge",
          state_id: "503",
        },
        {
          id: "8344",
          name: "Khwai Camp",
          state_id: "503",
        },
        {
          id: "8345",
          name: "Komana",
          state_id: "503",
        },
        {
          id: "8346",
          name: "Legotlhwana",
          state_id: "503",
        },
        {
          id: "8347",
          name: "Mababe",
          state_id: "503",
        },
        {
          id: "8348",
          name: "Makalamabedi",
          state_id: "503",
        },
        {
          id: "8349",
          name: "Matlapana",
          state_id: "503",
        },
        {
          id: "8350",
          name: "Matsaudi",
          state_id: "503",
        },
        {
          id: "8351",
          name: "Mawana",
          state_id: "503",
        },
        {
          id: "8352",
          name: "Mokgalo-Haka",
          state_id: "503",
        },
        {
          id: "8353",
          name: "Morutsha",
          state_id: "503",
        },
        {
          id: "8354",
          name: "Nxharaga",
          state_id: "503",
        },
        {
          id: "8355",
          name: "Phuduhudu",
          state_id: "503",
        },
        {
          id: "8356",
          name: "Samodupi",
          state_id: "503",
        },
        {
          id: "8357",
          name: "Sankuyo",
          state_id: "503",
        },
        {
          id: "8358",
          name: "Sehithwa",
          state_id: "503",
        },
        {
          id: "8359",
          name: "Semboyo",
          state_id: "503",
        },
        {
          id: "8360",
          name: "Sexaxa",
          state_id: "503",
        },
        {
          id: "8361",
          name: "Shakawe",
          state_id: "503",
        },
        {
          id: "8362",
          name: "Shorobe",
          state_id: "503",
        },
        {
          id: "8363",
          name: "Somela",
          state_id: "503",
        },
        {
          id: "8364",
          name: "Toteng",
          state_id: "503",
        },
        {
          id: "8365",
          name: "Tsanekona",
          state_id: "503",
        },
        {
          id: "8366",
          name: "Tsao",
          state_id: "503",
        },
        {
          id: "8367",
          name: "Xaxaba",
          state_id: "503",
        },
        {
          id: "8368",
          name: "Xhobe",
          state_id: "503",
        },
      ],
      Ngwaketse: [
        {
          id: "8369",
          name: "Bethel",
          state_id: "504",
        },
        {
          id: "8370",
          name: "Borobadilepe",
          state_id: "504",
        },
        {
          id: "8371",
          name: "Diabo",
          state_id: "504",
        },
        {
          id: "8372",
          name: "Digawana",
          state_id: "504",
        },
        {
          id: "8373",
          name: "Dikhukhung",
          state_id: "504",
        },
        {
          id: "8374",
          name: "Dinatshana",
          state_id: "504",
        },
        {
          id: "8375",
          name: "Dipotsana",
          state_id: "504",
        },
        {
          id: "8376",
          name: "Ditlharapa",
          state_id: "504",
        },
        {
          id: "8377",
          name: "Gamajalela",
          state_id: "504",
        },
        {
          id: "8378",
          name: "Gasita",
          state_id: "504",
        },
        {
          id: "8379",
          name: "Gathwane",
          state_id: "504",
        },
        {
          id: "8380",
          name: "Good Hope",
          state_id: "504",
        },
        {
          id: "8381",
          name: "Goora-seno",
          state_id: "504",
        },
        {
          id: "8382",
          name: "Gopong",
          state_id: "504",
        },
        {
          id: "8383",
          name: "Hebron",
          state_id: "504",
        },
        {
          id: "8384",
          name: "Itholoke",
          state_id: "504",
        },
        {
          id: "8385",
          name: "Kanaku",
          state_id: "504",
        },
        {
          id: "8386",
          name: "Kangwe",
          state_id: "504",
        },
        {
          id: "8387",
          name: "Kanye",
          state_id: "504",
        },
        {
          id: "8388",
          name: "Keng",
          state_id: "504",
        },
        {
          id: "8389",
          name: "Kgomokasitwa",
          state_id: "504",
        },
        {
          id: "8390",
          name: "Kgoro",
          state_id: "504",
        },
        {
          id: "8391",
          name: "Khakhea",
          state_id: "504",
        },
        {
          id: "8392",
          name: "Khonkhwa",
          state_id: "504",
        },
        {
          id: "8393",
          name: "Kokong",
          state_id: "504",
        },
        {
          id: "8394",
          name: "Lehoko",
          state_id: "504",
        },
        {
          id: "8395",
          name: "Lejwana",
          state_id: "504",
        },
        {
          id: "8396",
          name: "Lekgolobotlo",
          state_id: "504",
        },
        {
          id: "8397",
          name: "Leporung",
          state_id: "504",
        },
        {
          id: "8398",
          name: "Logagane",
          state_id: "504",
        },
        {
          id: "8399",
          name: "Lorolwana",
          state_id: "504",
        },
        {
          id: "8400",
          name: "Lorwana",
          state_id: "504",
        },
        {
          id: "8401",
          name: "Lotlhakane",
          state_id: "504",
        },
        {
          id: "8402",
          name: "Lotlhakane West",
          state_id: "504",
        },
        {
          id: "8403",
          name: "Mabule",
          state_id: "504",
        },
        {
          id: "8404",
          name: "Mabutsane",
          state_id: "504",
        },
        {
          id: "8405",
          name: "Madingwana",
          state_id: "504",
        },
        {
          id: "8406",
          name: "Magoriapitse",
          state_id: "504",
        },
        {
          id: "8407",
          name: "Magotlhawane",
          state_id: "504",
        },
        {
          id: "8408",
          name: "Mahotshwane",
          state_id: "504",
        },
        {
          id: "8409",
          name: "Maisane",
          state_id: "504",
        },
        {
          id: "8410",
          name: "Makokwe",
          state_id: "504",
        },
        {
          id: "8411",
          name: "Malokaganyane",
          state_id: "504",
        },
        {
          id: "8412",
          name: "Manyana",
          state_id: "504",
        },
        {
          id: "8413",
          name: "Maokane",
          state_id: "504",
        },
        {
          id: "8414",
          name: "Marojane",
          state_id: "504",
        },
        {
          id: "8415",
          name: "Maruswa",
          state_id: "504",
        },
        {
          id: "8416",
          name: "Metlobo",
          state_id: "504",
        },
        {
          id: "8417",
          name: "Metlojane",
          state_id: "504",
        },
        {
          id: "8418",
          name: "Mmakgori",
          state_id: "504",
        },
        {
          id: "8419",
          name: "Mmathethe",
          state_id: "504",
        },
        {
          id: "8420",
          name: "Mogojogojo",
          state_id: "504",
        },
        {
          id: "8421",
          name: "Mogonye",
          state_id: "504",
        },
        {
          id: "8422",
          name: "Mogwalale",
          state_id: "504",
        },
        {
          id: "8423",
          name: "Mokatako",
          state_id: "504",
        },
        {
          id: "8424",
          name: "Mokgomane",
          state_id: "504",
        },
        {
          id: "8425",
          name: "Mokhomba",
          state_id: "504",
        },
        {
          id: "8426",
          name: "Molapowabojang",
          state_id: "504",
        },
        {
          id: "8427",
          name: "Molete",
          state_id: "504",
        },
        {
          id: "8428",
          name: "Morwamosu",
          state_id: "504",
        },
        {
          id: "8429",
          name: "Moshaneng",
          state_id: "504",
        },
        {
          id: "8430",
          name: "Moshupa",
          state_id: "504",
        },
        {
          id: "8431",
          name: "Motlhwatse",
          state_id: "504",
        },
        {
          id: "8432",
          name: "Motsentshe",
          state_id: "504",
        },
        {
          id: "8433",
          name: "Musi",
          state_id: "504",
        },
        {
          id: "8434",
          name: "Ngwatsau",
          state_id: "504",
        },
        {
          id: "8435",
          name: "Ntlhantlhe",
          state_id: "504",
        },
        {
          id: "8436",
          name: "Papatlo",
          state_id: "504",
        },
        {
          id: "8437",
          name: "Phihitshwane",
          state_id: "504",
        },
        {
          id: "8438",
          name: "Pitsana-Potokwe",
          state_id: "504",
        },
        {
          id: "8439",
          name: "Pitsane",
          state_id: "504",
        },
        {
          id: "8440",
          name: "Pitseng-Ralekgetho",
          state_id: "504",
        },
        {
          id: "8441",
          name: "Pitshane Molopo",
          state_id: "504",
        },
        {
          id: "8442",
          name: "Rakhuna",
          state_id: "504",
        },
        {
          id: "8443",
          name: "Ralekgetho",
          state_id: "504",
        },
        {
          id: "8444",
          name: "Ramatlabama",
          state_id: "504",
        },
        {
          id: "8445",
          name: "Ranaka",
          state_id: "504",
        },
        {
          id: "8446",
          name: "Sedibeng",
          state_id: "504",
        },
        {
          id: "8447",
          name: "Segakwana",
          state_id: "504",
        },
        {
          id: "8448",
          name: "Segwagwa",
          state_id: "504",
        },
        {
          id: "8449",
          name: "Seherelela",
          state_id: "504",
        },
        {
          id: "8450",
          name: "Sekhutlane",
          state_id: "504",
        },
        {
          id: "8451",
          name: "Sekoma",
          state_id: "504",
        },
        {
          id: "8452",
          name: "Selokolela",
          state_id: "504",
        },
        {
          id: "8453",
          name: "Semane",
          state_id: "504",
        },
        {
          id: "8454",
          name: "Sese",
          state_id: "504",
        },
        {
          id: "8455",
          name: "Sesung",
          state_id: "504",
        },
        {
          id: "8456",
          name: "Sheep Farm",
          state_id: "504",
        },
        {
          id: "8457",
          name: "Tlhankane",
          state_id: "504",
        },
        {
          id: "8458",
          name: "Tlhareseleele",
          state_id: "504",
        },
        {
          id: "8459",
          name: "Tshidilamolomo",
          state_id: "504",
        },
        {
          id: "8460",
          name: "Tshwaane",
          state_id: "504",
        },
        {
          id: "8461",
          name: "Tsonyane",
          state_id: "504",
        },
        {
          id: "8462",
          name: "Tswaaneng",
          state_id: "504",
        },
        {
          id: "8463",
          name: "Tswagare-Lothoje-Lokalana",
          state_id: "504",
        },
        {
          id: "8464",
          name: "Tswanyaneng",
          state_id: "504",
        },
      ],
      "North East": [],
      Okavango: [
        {
          id: "8465",
          name: "Beetsha",
          state_id: "506",
        },
        {
          id: "8466",
          name: "Eretsha",
          state_id: "506",
        },
        {
          id: "8467",
          name: "Etsha 1",
          state_id: "506",
        },
        {
          id: "8468",
          name: "Etsha 13",
          state_id: "506",
        },
        {
          id: "8469",
          name: "Etsha 6",
          state_id: "506",
        },
        {
          id: "8470",
          name: "Etsha 8",
          state_id: "506",
        },
        {
          id: "8471",
          name: "Etsha 9",
          state_id: "506",
        },
        {
          id: "8472",
          name: "Gane",
          state_id: "506",
        },
        {
          id: "8473",
          name: "Gonutsuga",
          state_id: "506",
        },
        {
          id: "8474",
          name: "Gowe",
          state_id: "506",
        },
        {
          id: "8475",
          name: "Gudingwa",
          state_id: "506",
        },
        {
          id: "8476",
          name: "Gumare",
          state_id: "506",
        },
        {
          id: "8477",
          name: "Ikoga",
          state_id: "506",
        },
        {
          id: "8478",
          name: "Kajaja",
          state_id: "506",
        },
        {
          id: "8479",
          name: "Kapotora Lands",
          state_id: "506",
        },
        {
          id: "8480",
          name: "Kauxwhi",
          state_id: "506",
        },
        {
          id: "8481",
          name: "Matswee",
          state_id: "506",
        },
        {
          id: "8482",
          name: "Maun",
          state_id: "506",
        },
        {
          id: "8483",
          name: "Moaha",
          state_id: "506",
        },
        {
          id: "8484",
          name: "Mohembo East",
          state_id: "506",
        },
        {
          id: "8485",
          name: "Mohembo West",
          state_id: "506",
        },
        {
          id: "8486",
          name: "Mokgacha",
          state_id: "506",
        },
        {
          id: "8487",
          name: "Ngarange",
          state_id: "506",
        },
        {
          id: "8488",
          name: "Nokaneng",
          state_id: "506",
        },
        {
          id: "8489",
          name: "Nxamasere",
          state_id: "506",
        },
        {
          id: "8490",
          name: "Nxaunxau",
          state_id: "506",
        },
        {
          id: "8491",
          name: "Nxwee",
          state_id: "506",
        },
        {
          id: "8492",
          name: "Qangwa",
          state_id: "506",
        },
        {
          id: "8493",
          name: "Roye",
          state_id: "506",
        },
        {
          id: "8494",
          name: "Samochema",
          state_id: "506",
        },
        {
          id: "8495",
          name: "Sekondomboro",
          state_id: "506",
        },
        {
          id: "8496",
          name: "Sepopa",
          state_id: "506",
        },
        {
          id: "8497",
          name: "Seronga",
          state_id: "506",
        },
        {
          id: "8498",
          name: "Shaowe",
          state_id: "506",
        },
        {
          id: "8499",
          name: "Tobere Lands",
          state_id: "506",
        },
        {
          id: "8500",
          name: "Tubu",
          state_id: "506",
        },
        {
          id: "8501",
          name: "Tubu Lands",
          state_id: "506",
        },
        {
          id: "8502",
          name: "Xadau",
          state_id: "506",
        },
        {
          id: "8503",
          name: "Xakao",
          state_id: "506",
        },
        {
          id: "8504",
          name: "Xaxa",
          state_id: "506",
        },
        {
          id: "8505",
          name: "Xhauga",
          state_id: "506",
        },
        {
          id: "8506",
          name: "Xurube",
          state_id: "506",
        },
      ],
      Orapa: [
        {
          id: "8507",
          name: "Orapa",
          state_id: "507",
        },
      ],
      "Selibe Phikwe": [],
      "South East": [],
      Sowa: [
        {
          id: "8508",
          name: "Sowa",
          state_id: "510",
        },
      ],
    },
  },
  BY: {
    name: "Belarus",
    native: "Белару́сь",
    phone: "375",
    continent: "EU",
    capital: "Minsk",
    currency: "BYR",
    languages: ["be", "ru"],
    emoji: "🇧🇾",
    emojiU: "U+1F1E7 U+1F1FE",
    states: {
      Brest: [
        {
          id: "7406",
          name: "Baranavichy",
          state_id: "413",
        },
        {
          id: "7407",
          name: "Bjaroza",
          state_id: "413",
        },
        {
          id: "7408",
          name: "Bjeloozersk",
          state_id: "413",
        },
        {
          id: "7409",
          name: "Brest",
          state_id: "413",
        },
        {
          id: "7410",
          name: "David-Haradok",
          state_id: "413",
        },
        {
          id: "7411",
          name: "Drahichyn",
          state_id: "413",
        },
        {
          id: "7412",
          name: "Hancavichy",
          state_id: "413",
        },
        {
          id: "7413",
          name: "Ivacevichy",
          state_id: "413",
        },
        {
          id: "7414",
          name: "Ivanava",
          state_id: "413",
        },
        {
          id: "7415",
          name: "Kamjenec",
          state_id: "413",
        },
        {
          id: "7416",
          name: "Kobryn",
          state_id: "413",
        },
        {
          id: "7417",
          name: "Kosava",
          state_id: "413",
        },
        {
          id: "7418",
          name: "Ljahavichy",
          state_id: "413",
        },
        {
          id: "7419",
          name: "Luninjec",
          state_id: "413",
        },
        {
          id: "7420",
          name: "Malaryta",
          state_id: "413",
        },
        {
          id: "7421",
          name: "Mikashevichy",
          state_id: "413",
        },
        {
          id: "7422",
          name: "Pinsk",
          state_id: "413",
        },
        {
          id: "7423",
          name: "Pruzhany",
          state_id: "413",
        },
        {
          id: "7424",
          name: "Stolin",
          state_id: "413",
        },
        {
          id: "7425",
          name: "Vysokoje",
          state_id: "413",
        },
        {
          id: "7426",
          name: "Zhabinka",
          state_id: "413",
        },
      ],
      Homjel: [
        {
          id: "7427",
          name: "Buda Kosheljovo",
          state_id: "414",
        },
        {
          id: "7428",
          name: "Chechersk",
          state_id: "414",
        },
        {
          id: "7429",
          name: "Dobrush",
          state_id: "414",
        },
        {
          id: "7430",
          name: "Hojniki",
          state_id: "414",
        },
        {
          id: "7431",
          name: "Homjel",
          state_id: "414",
        },
        {
          id: "7432",
          name: "Jel''sk",
          state_id: "414",
        },
        {
          id: "7433",
          name: "Kalinkavichy",
          state_id: "414",
        },
        {
          id: "7434",
          name: "Kascjukovka",
          state_id: "414",
        },
        {
          id: "7435",
          name: "Mazyr",
          state_id: "414",
        },
        {
          id: "7436",
          name: "Narovlja",
          state_id: "414",
        },
        {
          id: "7437",
          name: "Pjetrykav",
          state_id: "414",
        },
        {
          id: "7438",
          name: "Rahachow",
          state_id: "414",
        },
        {
          id: "7439",
          name: "Rechyca",
          state_id: "414",
        },
        {
          id: "7440",
          name: "Svetlahorsk",
          state_id: "414",
        },
        {
          id: "7441",
          name: "Vasilevichy",
          state_id: "414",
        },
        {
          id: "7442",
          name: "Vjetka",
          state_id: "414",
        },
        {
          id: "7443",
          name: "Zhlobin",
          state_id: "414",
        },
        {
          id: "7444",
          name: "Zhytkavichy",
          state_id: "414",
        },
      ],
      Hrodna: [
        {
          id: "7445",
          name: "Ashmjany",
          state_id: "415",
        },
        {
          id: "7446",
          name: "Berjozovka",
          state_id: "415",
        },
        {
          id: "7447",
          name: "Hrodna",
          state_id: "415",
        },
        {
          id: "7448",
          name: "Lida",
          state_id: "415",
        },
        {
          id: "7449",
          name: "Masty",
          state_id: "415",
        },
        {
          id: "7450",
          name: "Navahrudak",
          state_id: "415",
        },
        {
          id: "7451",
          name: "Shchuchyn",
          state_id: "415",
        },
        {
          id: "7452",
          name: "Skidel",
          state_id: "415",
        },
        {
          id: "7453",
          name: "Slonim",
          state_id: "415",
        },
        {
          id: "7454",
          name: "Smarhon",
          state_id: "415",
        },
        {
          id: "7455",
          name: "Vawkavysk",
          state_id: "415",
        },
      ],
      Mahiljow: [
        {
          id: "7456",
          name: "Asipovichy",
          state_id: "416",
        },
        {
          id: "7457",
          name: "Babrujsk",
          state_id: "416",
        },
        {
          id: "7458",
          name: "Byhau",
          state_id: "416",
        },
        {
          id: "7459",
          name: "Chausy",
          state_id: "416",
        },
        {
          id: "7460",
          name: "Cherikov",
          state_id: "416",
        },
        {
          id: "7461",
          name: "Horki",
          state_id: "416",
        },
        {
          id: "7462",
          name: "Kascjukovichy",
          state_id: "416",
        },
        {
          id: "7463",
          name: "Klimavichy",
          state_id: "416",
        },
        {
          id: "7464",
          name: "Krychaw",
          state_id: "416",
        },
        {
          id: "7465",
          name: "Mahiljow",
          state_id: "416",
        },
        {
          id: "7466",
          name: "Mstislav",
          state_id: "416",
        },
        {
          id: "7467",
          name: "Shklov",
          state_id: "416",
        },
        {
          id: "7468",
          name: "Slaeuharad",
          state_id: "416",
        },
      ],
      "Mahilyowskaya Voblasts": [],
      Minsk: [
        {
          id: "7469",
          name: "Minsk",
          state_id: "418",
        },
      ],
      "Minskaja Voblasts": [],
      Petrik: [
        {
          id: "7470",
          name: "Petrikov",
          state_id: "420",
        },
      ],
      Vicebsk: [
        {
          id: "7471",
          name: "Baran",
          state_id: "421",
        },
        {
          id: "7472",
          name: "Braslav",
          state_id: "421",
        },
        {
          id: "7473",
          name: "Chashniki",
          state_id: "421",
        },
        {
          id: "7474",
          name: "Disna",
          state_id: "421",
        },
        {
          id: "7475",
          name: "Dokshicy",
          state_id: "421",
        },
        {
          id: "7476",
          name: "Dubrovna",
          state_id: "421",
        },
        {
          id: "7477",
          name: "Haradok",
          state_id: "421",
        },
        {
          id: "7478",
          name: "Hlybokaje",
          state_id: "421",
        },
        {
          id: "7479",
          name: "Ljepjel",
          state_id: "421",
        },
        {
          id: "7480",
          name: "Mjory",
          state_id: "421",
        },
        {
          id: "7481",
          name: "Navapolack",
          state_id: "421",
        },
        {
          id: "7482",
          name: "Novalukoml",
          state_id: "421",
        },
        {
          id: "7483",
          name: "Orsha",
          state_id: "421",
        },
        {
          id: "7484",
          name: "Pastavy",
          state_id: "421",
        },
        {
          id: "7485",
          name: "Polack",
          state_id: "421",
        },
        {
          id: "7486",
          name: "Polotsk",
          state_id: "421",
        },
        {
          id: "7487",
          name: "Senno",
          state_id: "421",
        },
        {
          id: "7488",
          name: "Talachyn",
          state_id: "421",
        },
        {
          id: "7489",
          name: "Verhnjadzvimsk",
          state_id: "421",
        },
        {
          id: "7490",
          name: "Vicebsk",
          state_id: "421",
        },
      ],
    },
  },
  BZ: {
    name: "Belize",
    native: "Belize",
    phone: "501",
    continent: "NA",
    capital: "Belmopan",
    currency: "BZD",
    languages: ["en", "es"],
    emoji: "🇧🇿",
    emojiU: "U+1F1E7 U+1F1FF",
    states: {
      Belize: [
        {
          id: "8076",
          name: "Belize",
          state_id: "439",
        },
        {
          id: "8077",
          name: "San Pedro",
          state_id: "439",
        },
      ],
      Cayo: [
        {
          id: "8078",
          name: "Belmopan",
          state_id: "440",
        },
        {
          id: "8079",
          name: "Benque Viejo",
          state_id: "440",
        },
        {
          id: "8080",
          name: "San Ignacio",
          state_id: "440",
        },
      ],
      Corozal: [
        {
          id: "8081",
          name: "Corozal",
          state_id: "441",
        },
      ],
      "Orange Walk": [],
      "Stann Creek": [],
      Toledo: [
        {
          id: "8082",
          name: "Punta Gorda",
          state_id: "444",
        },
      ],
    },
  },
  CA: {
    name: "Canada",
    native: "Canada",
    phone: "1",
    continent: "NA",
    capital: "Ottawa",
    currency: "CAD",
    languages: ["en", "fr"],
    emoji: "🇨🇦",
    emojiU: "U+1F1E8 U+1F1E6",
    states: {
      Alberta: [
        {
          id: "10093",
          name: "Airdrie",
          state_id: "663",
        },
        {
          id: "10094",
          name: "Athabasca",
          state_id: "663",
        },
        {
          id: "10095",
          name: "Banff",
          state_id: "663",
        },
        {
          id: "10096",
          name: "Barrhead",
          state_id: "663",
        },
        {
          id: "10097",
          name: "Bassano",
          state_id: "663",
        },
        {
          id: "10098",
          name: "Beaumont",
          state_id: "663",
        },
        {
          id: "10099",
          name: "Beaverlodge",
          state_id: "663",
        },
        {
          id: "10100",
          name: "Black Diamond",
          state_id: "663",
        },
        {
          id: "10101",
          name: "Blackfalds",
          state_id: "663",
        },
        {
          id: "10102",
          name: "Blairmore",
          state_id: "663",
        },
        {
          id: "10103",
          name: "Bon Accord",
          state_id: "663",
        },
        {
          id: "10104",
          name: "Bonnyville",
          state_id: "663",
        },
        {
          id: "10105",
          name: "Bow Island",
          state_id: "663",
        },
        {
          id: "10106",
          name: "Brooks",
          state_id: "663",
        },
        {
          id: "10107",
          name: "Calgary",
          state_id: "663",
        },
        {
          id: "10108",
          name: "Calmar",
          state_id: "663",
        },
        {
          id: "10109",
          name: "Camrose",
          state_id: "663",
        },
        {
          id: "10110",
          name: "Canmore",
          state_id: "663",
        },
        {
          id: "10111",
          name: "Cardston",
          state_id: "663",
        },
        {
          id: "10112",
          name: "Carstairs",
          state_id: "663",
        },
        {
          id: "10113",
          name: "Chateau Lake Louise",
          state_id: "663",
        },
        {
          id: "10114",
          name: "Chestermere",
          state_id: "663",
        },
        {
          id: "10115",
          name: "Clairmont",
          state_id: "663",
        },
        {
          id: "10116",
          name: "Claresholm",
          state_id: "663",
        },
        {
          id: "10117",
          name: "Coaldale",
          state_id: "663",
        },
        {
          id: "10118",
          name: "Coalhurst",
          state_id: "663",
        },
        {
          id: "10119",
          name: "Cochrane",
          state_id: "663",
        },
        {
          id: "10120",
          name: "Crossfield",
          state_id: "663",
        },
        {
          id: "10121",
          name: "Devon",
          state_id: "663",
        },
        {
          id: "10122",
          name: "Didsbury",
          state_id: "663",
        },
        {
          id: "10123",
          name: "Drayton Valley",
          state_id: "663",
        },
        {
          id: "10124",
          name: "Drumheller",
          state_id: "663",
        },
        {
          id: "10125",
          name: "Edmonton",
          state_id: "663",
        },
        {
          id: "10126",
          name: "Edson",
          state_id: "663",
        },
        {
          id: "10127",
          name: "Elk Point",
          state_id: "663",
        },
        {
          id: "10128",
          name: "Fairview",
          state_id: "663",
        },
        {
          id: "10129",
          name: "Falher",
          state_id: "663",
        },
        {
          id: "10130",
          name: "Fort MacLeod",
          state_id: "663",
        },
        {
          id: "10131",
          name: "Fox Creek",
          state_id: "663",
        },
        {
          id: "10132",
          name: "Gibbons",
          state_id: "663",
        },
        {
          id: "10133",
          name: "Grand Centre",
          state_id: "663",
        },
        {
          id: "10134",
          name: "Grande Cache",
          state_id: "663",
        },
        {
          id: "10135",
          name: "Grande Prairie",
          state_id: "663",
        },
        {
          id: "10136",
          name: "Grimshaw",
          state_id: "663",
        },
        {
          id: "10137",
          name: "Hanna",
          state_id: "663",
        },
        {
          id: "10138",
          name: "High Level",
          state_id: "663",
        },
        {
          id: "10139",
          name: "High Prairie",
          state_id: "663",
        },
        {
          id: "10140",
          name: "High River",
          state_id: "663",
        },
        {
          id: "10141",
          name: "Hinton",
          state_id: "663",
        },
        {
          id: "10142",
          name: "Irricana",
          state_id: "663",
        },
        {
          id: "10143",
          name: "Jasper",
          state_id: "663",
        },
        {
          id: "10144",
          name: "Killam",
          state_id: "663",
        },
        {
          id: "10145",
          name: "La Crete",
          state_id: "663",
        },
        {
          id: "10146",
          name: "Lac la Biche",
          state_id: "663",
        },
        {
          id: "10147",
          name: "Lacombe",
          state_id: "663",
        },
        {
          id: "10148",
          name: "Lamont",
          state_id: "663",
        },
        {
          id: "10149",
          name: "Leduc",
          state_id: "663",
        },
        {
          id: "10150",
          name: "Lethbridge",
          state_id: "663",
        },
        {
          id: "10151",
          name: "Lloydminster",
          state_id: "663",
        },
        {
          id: "10152",
          name: "Magrath",
          state_id: "663",
        },
        {
          id: "10153",
          name: "Manning",
          state_id: "663",
        },
        {
          id: "10154",
          name: "Mayerthorpe",
          state_id: "663",
        },
        {
          id: "10155",
          name: "McMurray",
          state_id: "663",
        },
        {
          id: "10156",
          name: "Medicine Hat",
          state_id: "663",
        },
        {
          id: "10157",
          name: "Millet",
          state_id: "663",
        },
        {
          id: "10158",
          name: "Morinville",
          state_id: "663",
        },
        {
          id: "10159",
          name: "Nanton",
          state_id: "663",
        },
        {
          id: "10160",
          name: "Okotoks",
          state_id: "663",
        },
        {
          id: "10161",
          name: "Olds",
          state_id: "663",
        },
        {
          id: "10162",
          name: "Peace River",
          state_id: "663",
        },
        {
          id: "10163",
          name: "Penhold",
          state_id: "663",
        },
        {
          id: "10164",
          name: "Picture Butte",
          state_id: "663",
        },
        {
          id: "10165",
          name: "Pincher Creek",
          state_id: "663",
        },
        {
          id: "10166",
          name: "Ponoka",
          state_id: "663",
        },
        {
          id: "10167",
          name: "Provost",
          state_id: "663",
        },
        {
          id: "10168",
          name: "Raymond",
          state_id: "663",
        },
        {
          id: "10169",
          name: "Red Deer",
          state_id: "663",
        },
        {
          id: "10170",
          name: "Redwater",
          state_id: "663",
        },
        {
          id: "10171",
          name: "Rimbey",
          state_id: "663",
        },
        {
          id: "10172",
          name: "Rocky Mountain House",
          state_id: "663",
        },
        {
          id: "10173",
          name: "Rocky View",
          state_id: "663",
        },
        {
          id: "10174",
          name: "Saint Paul",
          state_id: "663",
        },
        {
          id: "10175",
          name: "Sexsmith",
          state_id: "663",
        },
        {
          id: "10176",
          name: "Sherwood Park",
          state_id: "663",
        },
        {
          id: "10177",
          name: "Slave Lake",
          state_id: "663",
        },
        {
          id: "10178",
          name: "Smoky Lake",
          state_id: "663",
        },
        {
          id: "10179",
          name: "Spirit River",
          state_id: "663",
        },
        {
          id: "10180",
          name: "Spruce Grove",
          state_id: "663",
        },
        {
          id: "10181",
          name: "Stettler",
          state_id: "663",
        },
        {
          id: "10182",
          name: "Stony Plain",
          state_id: "663",
        },
        {
          id: "10183",
          name: "Strathmore",
          state_id: "663",
        },
        {
          id: "10184",
          name: "Sundre",
          state_id: "663",
        },
        {
          id: "10185",
          name: "Swan Hills",
          state_id: "663",
        },
        {
          id: "10186",
          name: "Sylvan Lake",
          state_id: "663",
        },
        {
          id: "10187",
          name: "Taber",
          state_id: "663",
        },
        {
          id: "10188",
          name: "Three Hills",
          state_id: "663",
        },
        {
          id: "10189",
          name: "Tofield",
          state_id: "663",
        },
        {
          id: "10190",
          name: "Two Hills",
          state_id: "663",
        },
        {
          id: "10191",
          name: "Valleyview",
          state_id: "663",
        },
        {
          id: "10192",
          name: "Vegreville",
          state_id: "663",
        },
        {
          id: "10193",
          name: "Vermilion",
          state_id: "663",
        },
        {
          id: "10194",
          name: "Viking",
          state_id: "663",
        },
        {
          id: "10195",
          name: "Vulcan",
          state_id: "663",
        },
        {
          id: "10196",
          name: "Wainwright",
          state_id: "663",
        },
        {
          id: "10197",
          name: "Wembley",
          state_id: "663",
        },
        {
          id: "10198",
          name: "Westlock",
          state_id: "663",
        },
        {
          id: "10199",
          name: "Wetaskiwin",
          state_id: "663",
        },
        {
          id: "10200",
          name: "Whitecourt",
          state_id: "663",
        },
        {
          id: "10201",
          name: "Wood Buffalo",
          state_id: "663",
        },
      ],
      "British Columbia": [],
      Manitoba: [
        {
          id: "10202",
          name: "Altona",
          state_id: "665",
        },
        {
          id: "10203",
          name: "Beausejour",
          state_id: "665",
        },
        {
          id: "10204",
          name: "Boissevain",
          state_id: "665",
        },
        {
          id: "10205",
          name: "Brandon",
          state_id: "665",
        },
        {
          id: "10206",
          name: "Carberry",
          state_id: "665",
        },
        {
          id: "10207",
          name: "Carman",
          state_id: "665",
        },
        {
          id: "10208",
          name: "Dauphin",
          state_id: "665",
        },
        {
          id: "10209",
          name: "Deloraine",
          state_id: "665",
        },
        {
          id: "10210",
          name: "Dugald",
          state_id: "665",
        },
        {
          id: "10211",
          name: "Flin Flon",
          state_id: "665",
        },
        {
          id: "10212",
          name: "Gimli",
          state_id: "665",
        },
        {
          id: "10213",
          name: "Hamiota",
          state_id: "665",
        },
        {
          id: "10214",
          name: "Killarney",
          state_id: "665",
        },
        {
          id: "10215",
          name: "Lac du Bonnet",
          state_id: "665",
        },
        {
          id: "10216",
          name: "Leaf Rapids",
          state_id: "665",
        },
        {
          id: "10217",
          name: "Lorette",
          state_id: "665",
        },
        {
          id: "10218",
          name: "Melita",
          state_id: "665",
        },
        {
          id: "10219",
          name: "Minnedosa",
          state_id: "665",
        },
        {
          id: "10220",
          name: "Morden",
          state_id: "665",
        },
        {
          id: "10221",
          name: "Morris",
          state_id: "665",
        },
        {
          id: "10222",
          name: "Neepawa",
          state_id: "665",
        },
        {
          id: "10223",
          name: "Niverville",
          state_id: "665",
        },
        {
          id: "10224",
          name: "Pinawa",
          state_id: "665",
        },
        {
          id: "10225",
          name: "Portage la Prairie",
          state_id: "665",
        },
        {
          id: "10226",
          name: "Ritchot",
          state_id: "665",
        },
        {
          id: "10227",
          name: "Rivers",
          state_id: "665",
        },
        {
          id: "10228",
          name: "Roblin",
          state_id: "665",
        },
        {
          id: "10229",
          name: "Saint Adolphe",
          state_id: "665",
        },
        {
          id: "10230",
          name: "Sainte Anne",
          state_id: "665",
        },
        {
          id: "10231",
          name: "Sainte Rose du Lac",
          state_id: "665",
        },
        {
          id: "10232",
          name: "Selkirk",
          state_id: "665",
        },
        {
          id: "10233",
          name: "Shilo",
          state_id: "665",
        },
        {
          id: "10234",
          name: "Snow Lake",
          state_id: "665",
        },
        {
          id: "10235",
          name: "Souris",
          state_id: "665",
        },
        {
          id: "10236",
          name: "Springfield",
          state_id: "665",
        },
        {
          id: "10237",
          name: "Steinbach",
          state_id: "665",
        },
        {
          id: "10238",
          name: "Stonewall",
          state_id: "665",
        },
        {
          id: "10239",
          name: "Stony Mountain",
          state_id: "665",
        },
        {
          id: "10240",
          name: "Swan River",
          state_id: "665",
        },
        {
          id: "10241",
          name: "The Pas",
          state_id: "665",
        },
        {
          id: "10242",
          name: "Thompson",
          state_id: "665",
        },
        {
          id: "10243",
          name: "Virden",
          state_id: "665",
        },
        {
          id: "10244",
          name: "Winkler",
          state_id: "665",
        },
        {
          id: "10245",
          name: "Winnipeg",
          state_id: "665",
        },
      ],
      "New Brunswick": [],
      "Newfoundland and Labrador": [],
      "Northwest Territories": [],
      "Nova Scotia": [],
      Nunavut: [
        {
          id: "10246",
          name: "Clyde River",
          state_id: "670",
        },
        {
          id: "10247",
          name: "Iqaluit",
          state_id: "670",
        },
        {
          id: "10248",
          name: "Kangerdlinerk",
          state_id: "670",
        },
        {
          id: "10249",
          name: "Oqsuqtooq",
          state_id: "670",
        },
        {
          id: "10250",
          name: "Pangnirtung",
          state_id: "670",
        },
        {
          id: "10251",
          name: "Tununirusiq",
          state_id: "670",
        },
      ],
      Ontario: [
        {
          id: "10252",
          name: "Acton",
          state_id: "671",
        },
        {
          id: "10253",
          name: "Ajax",
          state_id: "671",
        },
        {
          id: "10254",
          name: "Alexandria",
          state_id: "671",
        },
        {
          id: "10255",
          name: "Alfred",
          state_id: "671",
        },
        {
          id: "10256",
          name: "Alliston",
          state_id: "671",
        },
        {
          id: "10257",
          name: "Almonte",
          state_id: "671",
        },
        {
          id: "10258",
          name: "Amherstburg",
          state_id: "671",
        },
        {
          id: "10259",
          name: "Amigo Beach",
          state_id: "671",
        },
        {
          id: "10260",
          name: "Angus-Borden",
          state_id: "671",
        },
        {
          id: "10261",
          name: "Arnprior",
          state_id: "671",
        },
        {
          id: "10262",
          name: "Arthur",
          state_id: "671",
        },
        {
          id: "10263",
          name: "Athens",
          state_id: "671",
        },
        {
          id: "10264",
          name: "Atikokan",
          state_id: "671",
        },
        {
          id: "10265",
          name: "Attawapiskat",
          state_id: "671",
        },
        {
          id: "10266",
          name: "Aurora",
          state_id: "671",
        },
        {
          id: "10267",
          name: "Aylmer",
          state_id: "671",
        },
        {
          id: "10268",
          name: "Ayr",
          state_id: "671",
        },
        {
          id: "10269",
          name: "Barrie",
          state_id: "671",
        },
        {
          id: "10270",
          name: "Barry''s Bay",
          state_id: "671",
        },
        {
          id: "10271",
          name: "Beamsville",
          state_id: "671",
        },
        {
          id: "10272",
          name: "Beaverton",
          state_id: "671",
        },
        {
          id: "10273",
          name: "Beeton",
          state_id: "671",
        },
        {
          id: "10274",
          name: "Belleville",
          state_id: "671",
        },
        {
          id: "10275",
          name: "Belmont",
          state_id: "671",
        },
        {
          id: "10276",
          name: "Blenheim",
          state_id: "671",
        },
        {
          id: "10277",
          name: "Blind River",
          state_id: "671",
        },
        {
          id: "10278",
          name: "Bobcaygeon",
          state_id: "671",
        },
        {
          id: "10279",
          name: "Bolton",
          state_id: "671",
        },
        {
          id: "10280",
          name: "Bourget",
          state_id: "671",
        },
        {
          id: "10281",
          name: "Bowmanville-Newcastle",
          state_id: "671",
        },
        {
          id: "10282",
          name: "Bracebridge",
          state_id: "671",
        },
        {
          id: "10283",
          name: "Bradford",
          state_id: "671",
        },
        {
          id: "10284",
          name: "Brampton",
          state_id: "671",
        },
        {
          id: "10285",
          name: "Brantford",
          state_id: "671",
        },
        {
          id: "10286",
          name: "Bridgenorth-Chemong Park Area",
          state_id: "671",
        },
        {
          id: "10287",
          name: "Brighton",
          state_id: "671",
        },
        {
          id: "10288",
          name: "Brockville",
          state_id: "671",
        },
        {
          id: "10289",
          name: "Brooklin",
          state_id: "671",
        },
        {
          id: "10290",
          name: "Brussels",
          state_id: "671",
        },
        {
          id: "10291",
          name: "Burford",
          state_id: "671",
        },
        {
          id: "10292",
          name: "Burlington",
          state_id: "671",
        },
        {
          id: "10293",
          name: "Caledon",
          state_id: "671",
        },
        {
          id: "10294",
          name: "Caledon East",
          state_id: "671",
        },
        {
          id: "10295",
          name: "Caledonia",
          state_id: "671",
        },
        {
          id: "10296",
          name: "Cambridge",
          state_id: "671",
        },
        {
          id: "10297",
          name: "Campbellford",
          state_id: "671",
        },
        {
          id: "10298",
          name: "Campbellville",
          state_id: "671",
        },
        {
          id: "10299",
          name: "Cannington",
          state_id: "671",
        },
        {
          id: "10300",
          name: "Capreol",
          state_id: "671",
        },
        {
          id: "10301",
          name: "Cardinal",
          state_id: "671",
        },
        {
          id: "10302",
          name: "Carleton Place",
          state_id: "671",
        },
        {
          id: "10303",
          name: "Carlisle",
          state_id: "671",
        },
        {
          id: "10304",
          name: "Casselman",
          state_id: "671",
        },
        {
          id: "10305",
          name: "Cayuga",
          state_id: "671",
        },
        {
          id: "10306",
          name: "Chalk River",
          state_id: "671",
        },
        {
          id: "10307",
          name: "Chapleau",
          state_id: "671",
        },
        {
          id: "10308",
          name: "Chatham",
          state_id: "671",
        },
        {
          id: "10309",
          name: "Chesley",
          state_id: "671",
        },
        {
          id: "10310",
          name: "Chesterville",
          state_id: "671",
        },
        {
          id: "10311",
          name: "Clinton",
          state_id: "671",
        },
        {
          id: "10312",
          name: "Cobourg",
          state_id: "671",
        },
        {
          id: "10313",
          name: "Cochrane",
          state_id: "671",
        },
        {
          id: "10314",
          name: "Colborne",
          state_id: "671",
        },
        {
          id: "10315",
          name: "Colchester",
          state_id: "671",
        },
        {
          id: "10316",
          name: "Collingwood",
          state_id: "671",
        },
        {
          id: "10317",
          name: "Concord",
          state_id: "671",
        },
        {
          id: "10318",
          name: "Constance Bay",
          state_id: "671",
        },
        {
          id: "10319",
          name: "Cookstown",
          state_id: "671",
        },
        {
          id: "10320",
          name: "Cornwall",
          state_id: "671",
        },
        {
          id: "10321",
          name: "Creemore",
          state_id: "671",
        },
        {
          id: "10322",
          name: "Crystal Beach",
          state_id: "671",
        },
        {
          id: "10323",
          name: "Deep River",
          state_id: "671",
        },
        {
          id: "10324",
          name: "Delhi",
          state_id: "671",
        },
        {
          id: "10325",
          name: "Deseronto",
          state_id: "671",
        },
        {
          id: "10326",
          name: "Downsview",
          state_id: "671",
        },
        {
          id: "10327",
          name: "Drayton",
          state_id: "671",
        },
        {
          id: "10328",
          name: "Dresden",
          state_id: "671",
        },
        {
          id: "10329",
          name: "Dryden",
          state_id: "671",
        },
        {
          id: "10330",
          name: "Dundalk",
          state_id: "671",
        },
        {
          id: "10331",
          name: "Dunnville",
          state_id: "671",
        },
        {
          id: "10332",
          name: "Durham",
          state_id: "671",
        },
        {
          id: "10333",
          name: "Dutton",
          state_id: "671",
        },
        {
          id: "10334",
          name: "Eganville",
          state_id: "671",
        },
        {
          id: "10335",
          name: "Elliot Lake",
          state_id: "671",
        },
        {
          id: "10336",
          name: "Elmira",
          state_id: "671",
        },
        {
          id: "10337",
          name: "Elmvale",
          state_id: "671",
        },
        {
          id: "10338",
          name: "Embrun",
          state_id: "671",
        },
        {
          id: "10339",
          name: "Englehart",
          state_id: "671",
        },
        {
          id: "10340",
          name: "Erin",
          state_id: "671",
        },
        {
          id: "10341",
          name: "Espanola",
          state_id: "671",
        },
        {
          id: "10342",
          name: "Essex",
          state_id: "671",
        },
        {
          id: "10343",
          name: "Etobicoke",
          state_id: "671",
        },
        {
          id: "10344",
          name: "Everett",
          state_id: "671",
        },
        {
          id: "10345",
          name: "Exeter",
          state_id: "671",
        },
        {
          id: "10346",
          name: "Fenelon Falls",
          state_id: "671",
        },
        {
          id: "10347",
          name: "Fergus",
          state_id: "671",
        },
        {
          id: "10348",
          name: "Forest",
          state_id: "671",
        },
        {
          id: "10349",
          name: "Fort Erie",
          state_id: "671",
        },
        {
          id: "10350",
          name: "Fort Frances",
          state_id: "671",
        },
        {
          id: "10351",
          name: "Frankford",
          state_id: "671",
        },
        {
          id: "10352",
          name: "Gananoque",
          state_id: "671",
        },
        {
          id: "10353",
          name: "Georgetown",
          state_id: "671",
        },
        {
          id: "10354",
          name: "Georgina",
          state_id: "671",
        },
        {
          id: "10355",
          name: "Geraldton",
          state_id: "671",
        },
        {
          id: "10356",
          name: "Glencoe",
          state_id: "671",
        },
        {
          id: "10357",
          name: "Goderich",
          state_id: "671",
        },
        {
          id: "10358",
          name: "Golden",
          state_id: "671",
        },
        {
          id: "10359",
          name: "Gormley",
          state_id: "671",
        },
        {
          id: "10360",
          name: "Grand Bend",
          state_id: "671",
        },
        {
          id: "10361",
          name: "Grand Valley",
          state_id: "671",
        },
        {
          id: "10362",
          name: "Gravenhurst",
          state_id: "671",
        },
        {
          id: "10363",
          name: "Guelph",
          state_id: "671",
        },
        {
          id: "10364",
          name: "Hagersville",
          state_id: "671",
        },
        {
          id: "10365",
          name: "Haileybury",
          state_id: "671",
        },
        {
          id: "10366",
          name: "Hamilton",
          state_id: "671",
        },
        {
          id: "10367",
          name: "Hanover",
          state_id: "671",
        },
        {
          id: "10368",
          name: "Harriston",
          state_id: "671",
        },
        {
          id: "10369",
          name: "Harrow",
          state_id: "671",
        },
        {
          id: "10370",
          name: "Hastings",
          state_id: "671",
        },
        {
          id: "10371",
          name: "Havelock",
          state_id: "671",
        },
        {
          id: "10372",
          name: "Hawkesbury",
          state_id: "671",
        },
        {
          id: "10373",
          name: "Hearst",
          state_id: "671",
        },
        {
          id: "10374",
          name: "Hensall",
          state_id: "671",
        },
        {
          id: "10375",
          name: "Hillsburgh",
          state_id: "671",
        },
        {
          id: "10376",
          name: "Hornepayne",
          state_id: "671",
        },
        {
          id: "10377",
          name: "Huntsville",
          state_id: "671",
        },
        {
          id: "10378",
          name: "Ingersoll",
          state_id: "671",
        },
        {
          id: "10379",
          name: "Innisfil",
          state_id: "671",
        },
        {
          id: "10380",
          name: "Iroquois",
          state_id: "671",
        },
        {
          id: "10381",
          name: "Iroquois Falls",
          state_id: "671",
        },
        {
          id: "10382",
          name: "Jarvis",
          state_id: "671",
        },
        {
          id: "10383",
          name: "Kanata",
          state_id: "671",
        },
        {
          id: "10384",
          name: "Kapuskasing",
          state_id: "671",
        },
        {
          id: "10385",
          name: "Kars",
          state_id: "671",
        },
        {
          id: "10386",
          name: "Kemptville",
          state_id: "671",
        },
        {
          id: "10387",
          name: "Kenora",
          state_id: "671",
        },
        {
          id: "10388",
          name: "Kincardine",
          state_id: "671",
        },
        {
          id: "10389",
          name: "Kingston",
          state_id: "671",
        },
        {
          id: "10390",
          name: "Kirkland Lake",
          state_id: "671",
        },
        {
          id: "10391",
          name: "Kitchener",
          state_id: "671",
        },
        {
          id: "10392",
          name: "L''Original",
          state_id: "671",
        },
        {
          id: "10393",
          name: "Lakefield",
          state_id: "671",
        },
        {
          id: "10394",
          name: "Lanark",
          state_id: "671",
        },
        {
          id: "10395",
          name: "Leamington",
          state_id: "671",
        },
        {
          id: "10396",
          name: "Lindsay",
          state_id: "671",
        },
        {
          id: "10397",
          name: "Listowel",
          state_id: "671",
        },
        {
          id: "10398",
          name: "Little Current",
          state_id: "671",
        },
        {
          id: "10399",
          name: "Lively",
          state_id: "671",
        },
        {
          id: "10400",
          name: "London",
          state_id: "671",
        },
        {
          id: "10401",
          name: "Longlac",
          state_id: "671",
        },
        {
          id: "10402",
          name: "Lucan",
          state_id: "671",
        },
        {
          id: "10403",
          name: "Lucknow",
          state_id: "671",
        },
        {
          id: "10404",
          name: "Madoc",
          state_id: "671",
        },
        {
          id: "10405",
          name: "Manitouwadge",
          state_id: "671",
        },
        {
          id: "10406",
          name: "Maple",
          state_id: "671",
        },
        {
          id: "10407",
          name: "Marathon",
          state_id: "671",
        },
        {
          id: "10408",
          name: "Markdale",
          state_id: "671",
        },
        {
          id: "10409",
          name: "Markham",
          state_id: "671",
        },
        {
          id: "10410",
          name: "Marmora",
          state_id: "671",
        },
        {
          id: "10411",
          name: "Mattawa",
          state_id: "671",
        },
        {
          id: "10412",
          name: "Meaford",
          state_id: "671",
        },
        {
          id: "10413",
          name: "Metcalfe",
          state_id: "671",
        },
        {
          id: "10414",
          name: "Midland",
          state_id: "671",
        },
        {
          id: "10415",
          name: "Mildmay",
          state_id: "671",
        },
        {
          id: "10416",
          name: "Millbrook",
          state_id: "671",
        },
        {
          id: "10417",
          name: "Milton",
          state_id: "671",
        },
        {
          id: "10418",
          name: "Milverton",
          state_id: "671",
        },
        {
          id: "10419",
          name: "Mississauga",
          state_id: "671",
        },
        {
          id: "10420",
          name: "Mississauga Beach",
          state_id: "671",
        },
        {
          id: "10421",
          name: "Mitchell",
          state_id: "671",
        },
        {
          id: "10422",
          name: "Moose Factory",
          state_id: "671",
        },
        {
          id: "10423",
          name: "Morrisburg",
          state_id: "671",
        },
        {
          id: "10424",
          name: "Mount Albert",
          state_id: "671",
        },
        {
          id: "10425",
          name: "Mount Brydges",
          state_id: "671",
        },
        {
          id: "10426",
          name: "Mount Forest",
          state_id: "671",
        },
        {
          id: "10427",
          name: "Munster",
          state_id: "671",
        },
        {
          id: "10428",
          name: "Nanticoke",
          state_id: "671",
        },
        {
          id: "10429",
          name: "Napanee",
          state_id: "671",
        },
        {
          id: "10430",
          name: "Nepean",
          state_id: "671",
        },
        {
          id: "10431",
          name: "New Hamburg",
          state_id: "671",
        },
        {
          id: "10432",
          name: "Newmarket",
          state_id: "671",
        },
        {
          id: "10433",
          name: "Newtonville",
          state_id: "671",
        },
        {
          id: "10434",
          name: "Nobleton",
          state_id: "671",
        },
        {
          id: "10435",
          name: "North Bay",
          state_id: "671",
        },
        {
          id: "10436",
          name: "North Gower",
          state_id: "671",
        },
        {
          id: "10437",
          name: "North York",
          state_id: "671",
        },
        {
          id: "10438",
          name: "Norwich",
          state_id: "671",
        },
        {
          id: "10439",
          name: "Norwood",
          state_id: "671",
        },
        {
          id: "10440",
          name: "Oakville",
          state_id: "671",
        },
        {
          id: "10441",
          name: "Omemee",
          state_id: "671",
        },
        {
          id: "10442",
          name: "Onaping-Levack",
          state_id: "671",
        },
        {
          id: "10443",
          name: "Ontario",
          state_id: "671",
        },
        {
          id: "10444",
          name: "Orangeville",
          state_id: "671",
        },
        {
          id: "10445",
          name: "Orillia",
          state_id: "671",
        },
        {
          id: "10446",
          name: "Orono",
          state_id: "671",
        },
        {
          id: "10447",
          name: "Osgoode",
          state_id: "671",
        },
        {
          id: "10448",
          name: "Oshawa",
          state_id: "671",
        },
        {
          id: "10449",
          name: "Ottawa",
          state_id: "671",
        },
        {
          id: "10450",
          name: "Owen Sound",
          state_id: "671",
        },
        {
          id: "10451",
          name: "Paisley",
          state_id: "671",
        },
        {
          id: "10452",
          name: "Palmerston",
          state_id: "671",
        },
        {
          id: "10453",
          name: "Paris",
          state_id: "671",
        },
        {
          id: "10454",
          name: "Parkhill",
          state_id: "671",
        },
        {
          id: "10455",
          name: "Parry Sound",
          state_id: "671",
        },
        {
          id: "10456",
          name: "Pembroke",
          state_id: "671",
        },
        {
          id: "10457",
          name: "Perth",
          state_id: "671",
        },
        {
          id: "10458",
          name: "Petawawa",
          state_id: "671",
        },
        {
          id: "10459",
          name: "Peterborough",
          state_id: "671",
        },
        {
          id: "10460",
          name: "Petrolia",
          state_id: "671",
        },
        {
          id: "10461",
          name: "Pickering",
          state_id: "671",
        },
        {
          id: "10462",
          name: "Picton",
          state_id: "671",
        },
        {
          id: "10463",
          name: "Porcupine",
          state_id: "671",
        },
        {
          id: "10464",
          name: "Port Credit",
          state_id: "671",
        },
        {
          id: "10465",
          name: "Port Dover",
          state_id: "671",
        },
        {
          id: "10466",
          name: "Port Elgin",
          state_id: "671",
        },
        {
          id: "10467",
          name: "Port Hope",
          state_id: "671",
        },
        {
          id: "10468",
          name: "Port Perry",
          state_id: "671",
        },
        {
          id: "10469",
          name: "Port Stanley",
          state_id: "671",
        },
        {
          id: "10470",
          name: "Powassan",
          state_id: "671",
        },
        {
          id: "10471",
          name: "Prescott",
          state_id: "671",
        },
        {
          id: "10472",
          name: "Queensville",
          state_id: "671",
        },
        {
          id: "10473",
          name: "Renfrew",
          state_id: "671",
        },
        {
          id: "10474",
          name: "Richmond",
          state_id: "671",
        },
        {
          id: "10475",
          name: "Richmond Hill",
          state_id: "671",
        },
        {
          id: "10476",
          name: "Ridgetown",
          state_id: "671",
        },
        {
          id: "10477",
          name: "Rockland",
          state_id: "671",
        },
        {
          id: "10478",
          name: "Rockwood",
          state_id: "671",
        },
        {
          id: "10479",
          name: "Rodney",
          state_id: "671",
        },
        {
          id: "10480",
          name: "Saint Catharines",
          state_id: "671",
        },
        {
          id: "10481",
          name: "Saint Catharines-Niagara",
          state_id: "671",
        },
        {
          id: "10482",
          name: "Saint George",
          state_id: "671",
        },
        {
          id: "10483",
          name: "Saint Jacobs",
          state_id: "671",
        },
        {
          id: "10484",
          name: "Saint Marys",
          state_id: "671",
        },
        {
          id: "10485",
          name: "Saint Thomas",
          state_id: "671",
        },
        {
          id: "10486",
          name: "Sarnia",
          state_id: "671",
        },
        {
          id: "10487",
          name: "Sault Sainte Marie",
          state_id: "671",
        },
        {
          id: "10488",
          name: "Scarborough",
          state_id: "671",
        },
        {
          id: "10489",
          name: "Schomberg",
          state_id: "671",
        },
        {
          id: "10490",
          name: "Seaforth",
          state_id: "671",
        },
        {
          id: "10491",
          name: "Shelburne",
          state_id: "671",
        },
        {
          id: "10492",
          name: "Simcoe",
          state_id: "671",
        },
        {
          id: "10493",
          name: "Sioux Lookout",
          state_id: "671",
        },
        {
          id: "10494",
          name: "Smiths Falls",
          state_id: "671",
        },
        {
          id: "10495",
          name: "Smithville",
          state_id: "671",
        },
        {
          id: "10496",
          name: "South River",
          state_id: "671",
        },
        {
          id: "10497",
          name: "Southampton",
          state_id: "671",
        },
        {
          id: "10498",
          name: "Stayner",
          state_id: "671",
        },
        {
          id: "10499",
          name: "Stirling",
          state_id: "671",
        },
        {
          id: "10500",
          name: "Stoney Creek",
          state_id: "671",
        },
        {
          id: "10501",
          name: "Stoney Point",
          state_id: "671",
        },
        {
          id: "10502",
          name: "Stouffville",
          state_id: "671",
        },
        {
          id: "10503",
          name: "Stratford",
          state_id: "671",
        },
        {
          id: "10504",
          name: "Strathroy",
          state_id: "671",
        },
        {
          id: "10505",
          name: "Sturgeon Falls",
          state_id: "671",
        },
        {
          id: "10506",
          name: "Sudbury",
          state_id: "671",
        },
        {
          id: "10507",
          name: "Sutton",
          state_id: "671",
        },
        {
          id: "10508",
          name: "Tavistock",
          state_id: "671",
        },
        {
          id: "10509",
          name: "Teeswater",
          state_id: "671",
        },
        {
          id: "10510",
          name: "Terrace Bay",
          state_id: "671",
        },
        {
          id: "10511",
          name: "Thamesford",
          state_id: "671",
        },
        {
          id: "10512",
          name: "Thessalon",
          state_id: "671",
        },
        {
          id: "10513",
          name: "Thornbury",
          state_id: "671",
        },
        {
          id: "10514",
          name: "Thornhill",
          state_id: "671",
        },
        {
          id: "10515",
          name: "Thunder Bay",
          state_id: "671",
        },
        {
          id: "10516",
          name: "Tilbury",
          state_id: "671",
        },
        {
          id: "10517",
          name: "Tilsonburg",
          state_id: "671",
        },
        {
          id: "10518",
          name: "Timmins",
          state_id: "671",
        },
        {
          id: "10519",
          name: "Toronto",
          state_id: "671",
        },
        {
          id: "10520",
          name: "Tory Hill",
          state_id: "671",
        },
        {
          id: "10521",
          name: "Tottenham",
          state_id: "671",
        },
        {
          id: "10522",
          name: "Tweed",
          state_id: "671",
        },
        {
          id: "10523",
          name: "Uxbridge",
          state_id: "671",
        },
        {
          id: "10524",
          name: "Valley East",
          state_id: "671",
        },
        {
          id: "10525",
          name: "Vankleek Hill",
          state_id: "671",
        },
        {
          id: "10526",
          name: "Vaughan",
          state_id: "671",
        },
        {
          id: "10527",
          name: "Vineland",
          state_id: "671",
        },
        {
          id: "10528",
          name: "Walkerton",
          state_id: "671",
        },
        {
          id: "10529",
          name: "Wallaceburg",
          state_id: "671",
        },
        {
          id: "10530",
          name: "Wasaga Beach",
          state_id: "671",
        },
        {
          id: "10531",
          name: "Waterdown",
          state_id: "671",
        },
        {
          id: "10532",
          name: "Waterford",
          state_id: "671",
        },
        {
          id: "10533",
          name: "Waterloo",
          state_id: "671",
        },
        {
          id: "10534",
          name: "Watford",
          state_id: "671",
        },
        {
          id: "10535",
          name: "Wawa",
          state_id: "671",
        },
        {
          id: "10536",
          name: "Welland",
          state_id: "671",
        },
        {
          id: "10537",
          name: "Wellesley",
          state_id: "671",
        },
        {
          id: "10538",
          name: "Wellington",
          state_id: "671",
        },
        {
          id: "10539",
          name: "West Lorne",
          state_id: "671",
        },
        {
          id: "10540",
          name: "Wheatley",
          state_id: "671",
        },
        {
          id: "10541",
          name: "Whitby",
          state_id: "671",
        },
        {
          id: "10542",
          name: "Whitchurch-Stouffville",
          state_id: "671",
        },
        {
          id: "10543",
          name: "Wiarton",
          state_id: "671",
        },
        {
          id: "10544",
          name: "Wikwemikong",
          state_id: "671",
        },
        {
          id: "10545",
          name: "Willowdale",
          state_id: "671",
        },
        {
          id: "10546",
          name: "Winchester",
          state_id: "671",
        },
        {
          id: "10547",
          name: "Windsor",
          state_id: "671",
        },
        {
          id: "10548",
          name: "Wingham",
          state_id: "671",
        },
        {
          id: "10549",
          name: "Woodbridge",
          state_id: "671",
        },
        {
          id: "10550",
          name: "Woodstock",
          state_id: "671",
        },
        {
          id: "10551",
          name: "Wyoming",
          state_id: "671",
        },
      ],
      "Prince Edward Island": [],
      Quebec: [
        {
          id: "10552",
          name: "Acton Vale",
          state_id: "673",
        },
        {
          id: "10553",
          name: "Albanel",
          state_id: "673",
        },
        {
          id: "10554",
          name: "Alencon",
          state_id: "673",
        },
        {
          id: "10555",
          name: "Alma",
          state_id: "673",
        },
        {
          id: "10556",
          name: "Amos",
          state_id: "673",
        },
        {
          id: "10557",
          name: "Amqui",
          state_id: "673",
        },
        {
          id: "10558",
          name: "Anjou",
          state_id: "673",
        },
        {
          id: "10559",
          name: "Asbestos",
          state_id: "673",
        },
        {
          id: "10560",
          name: "Bagotville",
          state_id: "673",
        },
        {
          id: "10561",
          name: "Baie-Comeau",
          state_id: "673",
        },
        {
          id: "10562",
          name: "Baie-Saint-Paul",
          state_id: "673",
        },
        {
          id: "10563",
          name: "Barraute",
          state_id: "673",
        },
        {
          id: "10564",
          name: "Beauceville",
          state_id: "673",
        },
        {
          id: "10565",
          name: "Beaupre",
          state_id: "673",
        },
        {
          id: "10566",
          name: "Bedford",
          state_id: "673",
        },
        {
          id: "10567",
          name: "Beloeil",
          state_id: "673",
        },
        {
          id: "10568",
          name: "Bernierville",
          state_id: "673",
        },
        {
          id: "10569",
          name: "Berthierville",
          state_id: "673",
        },
        {
          id: "10570",
          name: "Betsiamites",
          state_id: "673",
        },
        {
          id: "10571",
          name: "Boisbriand",
          state_id: "673",
        },
        {
          id: "10572",
          name: "Bonaventure",
          state_id: "673",
        },
        {
          id: "10573",
          name: "Boucherville",
          state_id: "673",
        },
        {
          id: "10574",
          name: "Bromont",
          state_id: "673",
        },
        {
          id: "10575",
          name: "Brossard",
          state_id: "673",
        },
        {
          id: "10576",
          name: "Brownsburg",
          state_id: "673",
        },
        {
          id: "10577",
          name: "Buckingham",
          state_id: "673",
        },
        {
          id: "10578",
          name: "Cabano",
          state_id: "673",
        },
        {
          id: "10579",
          name: "Candiac",
          state_id: "673",
        },
        {
          id: "10580",
          name: "Cap-Chat",
          state_id: "673",
        },
        {
          id: "10581",
          name: "Cap-aux-Meules",
          state_id: "673",
        },
        {
          id: "10582",
          name: "Carleton",
          state_id: "673",
        },
        {
          id: "10583",
          name: "Causapscal",
          state_id: "673",
        },
        {
          id: "10584",
          name: "Chandler",
          state_id: "673",
        },
        {
          id: "10585",
          name: "Chapais",
          state_id: "673",
        },
        {
          id: "10586",
          name: "Charlesbourg",
          state_id: "673",
        },
        {
          id: "10587",
          name: "Chateau-Richer",
          state_id: "673",
        },
        {
          id: "10588",
          name: "Chibougamou",
          state_id: "673",
        },
        {
          id: "10589",
          name: "Chicoutimi-Jonquiere",
          state_id: "673",
        },
        {
          id: "10590",
          name: "Chisasibi",
          state_id: "673",
        },
        {
          id: "10591",
          name: "Chute-aux-Outardes",
          state_id: "673",
        },
        {
          id: "10592",
          name: "Clermont",
          state_id: "673",
        },
        {
          id: "10593",
          name: "Coaticook",
          state_id: "673",
        },
        {
          id: "10594",
          name: "Coleraine",
          state_id: "673",
        },
        {
          id: "10595",
          name: "Contrecoeur",
          state_id: "673",
        },
        {
          id: "10596",
          name: "Cookshire",
          state_id: "673",
        },
        {
          id: "10597",
          name: "Cowansville",
          state_id: "673",
        },
        {
          id: "10598",
          name: "Crabtree",
          state_id: "673",
        },
        {
          id: "10599",
          name: "Danville",
          state_id: "673",
        },
        {
          id: "10600",
          name: "Daveluyville",
          state_id: "673",
        },
        {
          id: "10601",
          name: "Degelis",
          state_id: "673",
        },
        {
          id: "10602",
          name: "Desbiens",
          state_id: "673",
        },
        {
          id: "10603",
          name: "Disraeli",
          state_id: "673",
        },
        {
          id: "10604",
          name: "Dolbeau",
          state_id: "673",
        },
        {
          id: "10605",
          name: "Donnacona",
          state_id: "673",
        },
        {
          id: "10606",
          name: "Dorval",
          state_id: "673",
        },
        {
          id: "10607",
          name: "Drummondville",
          state_id: "673",
        },
        {
          id: "10608",
          name: "East Angus",
          state_id: "673",
        },
        {
          id: "10609",
          name: "East Broughton",
          state_id: "673",
        },
        {
          id: "10610",
          name: "Farnham",
          state_id: "673",
        },
        {
          id: "10611",
          name: "Ferme-Neuve",
          state_id: "673",
        },
        {
          id: "10612",
          name: "Fermont",
          state_id: "673",
        },
        {
          id: "10613",
          name: "Filion",
          state_id: "673",
        },
        {
          id: "10614",
          name: "Forestville",
          state_id: "673",
        },
        {
          id: "10615",
          name: "Fort-Coulonge",
          state_id: "673",
        },
        {
          id: "10616",
          name: "Gaspe",
          state_id: "673",
        },
        {
          id: "10617",
          name: "Gentilly",
          state_id: "673",
        },
        {
          id: "10618",
          name: "Granby",
          state_id: "673",
        },
        {
          id: "10619",
          name: "Grande-Riviere",
          state_id: "673",
        },
        {
          id: "10620",
          name: "Grenville",
          state_id: "673",
        },
        {
          id: "10621",
          name: "Ham Nord",
          state_id: "673",
        },
        {
          id: "10622",
          name: "Hampstead",
          state_id: "673",
        },
        {
          id: "10623",
          name: "Hauterive",
          state_id: "673",
        },
        {
          id: "10624",
          name: "Havre-Saint-Pierre",
          state_id: "673",
        },
        {
          id: "10625",
          name: "Hebertville",
          state_id: "673",
        },
        {
          id: "10626",
          name: "Huntingdon",
          state_id: "673",
        },
        {
          id: "10627",
          name: "Joliette",
          state_id: "673",
        },
        {
          id: "10628",
          name: "Kingsey Falls",
          state_id: "673",
        },
        {
          id: "10629",
          name: "L''Annonciation",
          state_id: "673",
        },
        {
          id: "10630",
          name: "L''Ascension-de-Notre-Seigneur",
          state_id: "673",
        },
        {
          id: "10631",
          name: "L''Epiphanie",
          state_id: "673",
        },
        {
          id: "10632",
          name: "La Malbaie",
          state_id: "673",
        },
        {
          id: "10633",
          name: "La Pocatiere",
          state_id: "673",
        },
        {
          id: "10634",
          name: "La Sarre",
          state_id: "673",
        },
        {
          id: "10635",
          name: "La Tuque",
          state_id: "673",
        },
        {
          id: "10636",
          name: "Labelle",
          state_id: "673",
        },
        {
          id: "10637",
          name: "Lac-Etchemin",
          state_id: "673",
        },
        {
          id: "10638",
          name: "Lac-Lapierre",
          state_id: "673",
        },
        {
          id: "10639",
          name: "Lac-Megantic",
          state_id: "673",
        },
        {
          id: "10640",
          name: "Lac-au-Saumon",
          state_id: "673",
        },
        {
          id: "10641",
          name: "Lachine",
          state_id: "673",
        },
        {
          id: "10642",
          name: "Lachute",
          state_id: "673",
        },
        {
          id: "10643",
          name: "Lacolle",
          state_id: "673",
        },
        {
          id: "10644",
          name: "Lasalle",
          state_id: "673",
        },
        {
          id: "10645",
          name: "Laurentides",
          state_id: "673",
        },
        {
          id: "10646",
          name: "Laurier-Station",
          state_id: "673",
        },
        {
          id: "10647",
          name: "Laval",
          state_id: "673",
        },
        {
          id: "10648",
          name: "Lavaltrie",
          state_id: "673",
        },
        {
          id: "10649",
          name: "Le Bic",
          state_id: "673",
        },
        {
          id: "10650",
          name: "Lebel-sur-Quevillon",
          state_id: "673",
        },
        {
          id: "10651",
          name: "Les Cedres",
          state_id: "673",
        },
        {
          id: "10652",
          name: "Les Coteaux",
          state_id: "673",
        },
        {
          id: "10653",
          name: "Les Escoumins",
          state_id: "673",
        },
        {
          id: "10654",
          name: "Liniere",
          state_id: "673",
        },
        {
          id: "10655",
          name: "Longueuil",
          state_id: "673",
        },
        {
          id: "10656",
          name: "Louiseville",
          state_id: "673",
        },
        {
          id: "10657",
          name: "Luceville",
          state_id: "673",
        },
        {
          id: "10658",
          name: "Macamic",
          state_id: "673",
        },
        {
          id: "10659",
          name: "Magog",
          state_id: "673",
        },
        {
          id: "10660",
          name: "Malartic",
          state_id: "673",
        },
        {
          id: "10661",
          name: "Maniwaki",
          state_id: "673",
        },
        {
          id: "10662",
          name: "Marieville",
          state_id: "673",
        },
        {
          id: "10663",
          name: "Maskinonge",
          state_id: "673",
        },
        {
          id: "10664",
          name: "Matagami",
          state_id: "673",
        },
        {
          id: "10665",
          name: "Matane",
          state_id: "673",
        },
        {
          id: "10666",
          name: "Metabetchouan",
          state_id: "673",
        },
        {
          id: "10667",
          name: "Mirabel",
          state_id: "673",
        },
        {
          id: "10668",
          name: "Mistissini",
          state_id: "673",
        },
        {
          id: "10669",
          name: "Mont-Joli",
          state_id: "673",
        },
        {
          id: "10670",
          name: "Mont-Laurier",
          state_id: "673",
        },
        {
          id: "10671",
          name: "Montmagny",
          state_id: "673",
        },
        {
          id: "10672",
          name: "Montreal",
          state_id: "673",
        },
        {
          id: "10673",
          name: "Murdochville",
          state_id: "673",
        },
        {
          id: "10674",
          name: "Napierville",
          state_id: "673",
        },
        {
          id: "10675",
          name: "New Richmond",
          state_id: "673",
        },
        {
          id: "10676",
          name: "Nicolet",
          state_id: "673",
        },
        {
          id: "10677",
          name: "Normandin",
          state_id: "673",
        },
        {
          id: "10678",
          name: "Notre-Dame-du-Bon-Conseil",
          state_id: "673",
        },
        {
          id: "10679",
          name: "Notre-Dame-du-Lac",
          state_id: "673",
        },
        {
          id: "10680",
          name: "Notre-Dame-du-Mont-Carmel",
          state_id: "673",
        },
        {
          id: "10681",
          name: "Oka-Kanesatake",
          state_id: "673",
        },
        {
          id: "10682",
          name: "Ormstown",
          state_id: "673",
        },
        {
          id: "10683",
          name: "Papineauville",
          state_id: "673",
        },
        {
          id: "10684",
          name: "Pierreville",
          state_id: "673",
        },
        {
          id: "10685",
          name: "Plessisville",
          state_id: "673",
        },
        {
          id: "10686",
          name: "Pointe-Claire",
          state_id: "673",
        },
        {
          id: "10687",
          name: "Pont-Rouge",
          state_id: "673",
        },
        {
          id: "10688",
          name: "Port-Alfred-Bagotville",
          state_id: "673",
        },
        {
          id: "10689",
          name: "Port-Cartier",
          state_id: "673",
        },
        {
          id: "10690",
          name: "Portneuf",
          state_id: "673",
        },
        {
          id: "10691",
          name: "Price",
          state_id: "673",
        },
        {
          id: "10692",
          name: "Princeville",
          state_id: "673",
        },
        {
          id: "10693",
          name: "Quebec",
          state_id: "673",
        },
        {
          id: "10694",
          name: "Rawdon",
          state_id: "673",
        },
        {
          id: "10695",
          name: "Repentigny",
          state_id: "673",
        },
        {
          id: "10696",
          name: "Richmond",
          state_id: "673",
        },
        {
          id: "10697",
          name: "Rigaud",
          state_id: "673",
        },
        {
          id: "10698",
          name: "Rimouski",
          state_id: "673",
        },
        {
          id: "10699",
          name: "Riviere-au-Renard",
          state_id: "673",
        },
        {
          id: "10700",
          name: "Riviere-du-Loup",
          state_id: "673",
        },
        {
          id: "10701",
          name: "Roberval",
          state_id: "673",
        },
        {
          id: "10702",
          name: "Rougemont",
          state_id: "673",
        },
        {
          id: "10703",
          name: "Rouyn-Noranda",
          state_id: "673",
        },
        {
          id: "10704",
          name: "Saint-Agapit",
          state_id: "673",
        },
        {
          id: "10705",
          name: "Saint-Alexandre",
          state_id: "673",
        },
        {
          id: "10706",
          name: "Saint-Alexis-des-Monts",
          state_id: "673",
        },
        {
          id: "10707",
          name: "Saint-Ambroise",
          state_id: "673",
        },
        {
          id: "10708",
          name: "Saint-Andre-Avellin",
          state_id: "673",
        },
        {
          id: "10709",
          name: "Saint-Anselme",
          state_id: "673",
        },
        {
          id: "10710",
          name: "Saint-Apollinaire",
          state_id: "673",
        },
        {
          id: "10711",
          name: "Saint-Augustin",
          state_id: "673",
        },
        {
          id: "10712",
          name: "Saint-Basile-Sud",
          state_id: "673",
        },
        {
          id: "10713",
          name: "Saint-Bruno",
          state_id: "673",
        },
        {
          id: "10714",
          name: "Saint-Canut",
          state_id: "673",
        },
        {
          id: "10715",
          name: "Saint-Cesaire",
          state_id: "673",
        },
        {
          id: "10716",
          name: "Saint-Cyrill-de-Wendover",
          state_id: "673",
        },
        {
          id: "10718",
          name: "Saint-Damien-de-Buckland",
          state_id: "673",
        },
        {
          id: "10719",
          name: "Saint-Denis",
          state_id: "673",
        },
        {
          id: "10720",
          name: "Saint-Donat-de-Montcalm",
          state_id: "673",
        },
        {
          id: "10721",
          name: "Saint-Ephrem-de-Tring",
          state_id: "673",
        },
        {
          id: "10722",
          name: "Saint-Fabien",
          state_id: "673",
        },
        {
          id: "10723",
          name: "Saint-Felicien",
          state_id: "673",
        },
        {
          id: "10724",
          name: "Saint-Felix-de-Valois",
          state_id: "673",
        },
        {
          id: "10725",
          name: "Saint-Gabriel",
          state_id: "673",
        },
        {
          id: "10726",
          name: "Saint-Gedeon",
          state_id: "673",
        },
        {
          id: "10727",
          name: "Saint-Georges",
          state_id: "673",
        },
        {
          id: "10728",
          name: "Saint-Germain-de-Grantham",
          state_id: "673",
        },
        {
          id: "10729",
          name: "Saint-Gregoire",
          state_id: "673",
        },
        {
          id: "10730",
          name: "Saint-Henri-de-Levis",
          state_id: "673",
        },
        {
          id: "10731",
          name: "Saint-Honore",
          state_id: "673",
        },
        {
          id: "10732",
          name: "Saint-Hyacinthe",
          state_id: "673",
        },
        {
          id: "10733",
          name: "Saint-Jacques",
          state_id: "673",
        },
        {
          id: "10734",
          name: "Saint-Jean-Port-Joli",
          state_id: "673",
        },
        {
          id: "10735",
          name: "Saint-Jean-de-Dieu",
          state_id: "673",
        },
        {
          id: "10736",
          name: "Saint-Jean-sur-Richelieu",
          state_id: "673",
        },
        {
          id: "10737",
          name: "Saint-Jerome",
          state_id: "673",
        },
        {
          id: "10738",
          name: "Saint-Josephe-de-Beauce",
          state_id: "673",
        },
        {
          id: "10739",
          name: "Saint-Josephe-de-Lanoraie",
          state_id: "673",
        },
        {
          id: "10740",
          name: "Saint-Josephe-de-la-Riviere-Bl",
          state_id: "673",
        },
        {
          id: "10741",
          name: "Saint-Jovite",
          state_id: "673",
        },
        {
          id: "10742",
          name: "Saint-Laurent",
          state_id: "673",
        },
        {
          id: "10743",
          name: "Saint-Liboire",
          state_id: "673",
        },
        {
          id: "10744",
          name: "Saint-Marc-des-Carrieres",
          state_id: "673",
        },
        {
          id: "10745",
          name: "Saint-Martin",
          state_id: "673",
        },
        {
          id: "10746",
          name: "Saint-Michel-des-Saints",
          state_id: "673",
        },
        {
          id: "10747",
          name: "Saint-Pacome",
          state_id: "673",
        },
        {
          id: "10748",
          name: "Saint-Pascal",
          state_id: "673",
        },
        {
          id: "10749",
          name: "Saint-Pie",
          state_id: "673",
        },
        {
          id: "10750",
          name: "Saint-Prosper",
          state_id: "673",
        },
        {
          id: "10751",
          name: "Saint-Raphael",
          state_id: "673",
        },
        {
          id: "10752",
          name: "Saint-Raymond",
          state_id: "673",
        },
        {
          id: "10753",
          name: "Saint-Remi",
          state_id: "673",
        },
        {
          id: "10754",
          name: "Saint-Roch-de-l''Achigan",
          state_id: "673",
        },
        {
          id: "10755",
          name: "Saint-Sauveur-des-Monts",
          state_id: "673",
        },
        {
          id: "10756",
          name: "Saint-Tite",
          state_id: "673",
        },
        {
          id: "10757",
          name: "Sainte-Adele",
          state_id: "673",
        },
        {
          id: "10758",
          name: "Sainte-Agathe-des-Monts",
          state_id: "673",
        },
        {
          id: "10759",
          name: "Sainte-Anne-des-Monts",
          state_id: "673",
        },
        {
          id: "10760",
          name: "Sainte-Anne-des-Plaines",
          state_id: "673",
        },
        {
          id: "10761",
          name: "Sainte-Catherine",
          state_id: "673",
        },
        {
          id: "10762",
          name: "Sainte-Claire",
          state_id: "673",
        },
        {
          id: "10763",
          name: "Sainte-Julienne",
          state_id: "673",
        },
        {
          id: "10764",
          name: "Sainte-Justine",
          state_id: "673",
        },
        {
          id: "10765",
          name: "Sainte-Madeleine",
          state_id: "673",
        },
        {
          id: "10766",
          name: "Sainte-Marie",
          state_id: "673",
        },
        {
          id: "10767",
          name: "Sainte-Martine",
          state_id: "673",
        },
        {
          id: "10768",
          name: "Sainte-Sophie",
          state_id: "673",
        },
        {
          id: "10769",
          name: "Sainte-Thecle",
          state_id: "673",
        },
        {
          id: "10770",
          name: "Sainte-Therese",
          state_id: "673",
        },
        {
          id: "10771",
          name: "Salaberry-de-Valleyfield",
          state_id: "673",
        },
        {
          id: "10772",
          name: "Sayabec",
          state_id: "673",
        },
        {
          id: "10773",
          name: "Senneterre",
          state_id: "673",
        },
        {
          id: "10774",
          name: "Sept-Iles",
          state_id: "673",
        },
        {
          id: "10775",
          name: "Shawinigan",
          state_id: "673",
        },
        {
          id: "10776",
          name: "Shawville",
          state_id: "673",
        },
        {
          id: "10777",
          name: "Sherbrooke",
          state_id: "673",
        },
        {
          id: "10778",
          name: "Sorel",
          state_id: "673",
        },
        {
          id: "10779",
          name: "St Faustin",
          state_id: "673",
        },
        {
          id: "10780",
          name: "St. Hubert",
          state_id: "673",
        },
        {
          id: "10781",
          name: "St. Jean Chrysostome",
          state_id: "673",
        },
        {
          id: "10782",
          name: "Temiscaming",
          state_id: "673",
        },
        {
          id: "10783",
          name: "Terrebonne",
          state_id: "673",
        },
        {
          id: "10784",
          name: "Thetford Mines",
          state_id: "673",
        },
        {
          id: "10785",
          name: "Thurso",
          state_id: "673",
        },
        {
          id: "10786",
          name: "Trois-Pistoles",
          state_id: "673",
        },
        {
          id: "10787",
          name: "Trois-Rivieres",
          state_id: "673",
        },
        {
          id: "10788",
          name: "Val-David",
          state_id: "673",
        },
        {
          id: "10789",
          name: "Val-d''Or",
          state_id: "673",
        },
        {
          id: "10790",
          name: "Valcourt",
          state_id: "673",
        },
        {
          id: "10791",
          name: "Vallee-Jonction",
          state_id: "673",
        },
        {
          id: "10792",
          name: "Vaudreuil",
          state_id: "673",
        },
        {
          id: "10793",
          name: "Vercheres",
          state_id: "673",
        },
        {
          id: "10794",
          name: "Victoriaville",
          state_id: "673",
        },
        {
          id: "10795",
          name: "Ville-Marie",
          state_id: "673",
        },
        {
          id: "10796",
          name: "Warwick",
          state_id: "673",
        },
        {
          id: "10797",
          name: "Waterloo",
          state_id: "673",
        },
        {
          id: "10798",
          name: "Weedon Centre",
          state_id: "673",
        },
        {
          id: "10799",
          name: "Westmount",
          state_id: "673",
        },
        {
          id: "10800",
          name: "Wickham",
          state_id: "673",
        },
        {
          id: "10801",
          name: "Windsor",
          state_id: "673",
        },
        {
          id: "10802",
          name: "Yamachiche",
          state_id: "673",
        },
      ],
      Saskatchewan: [
        {
          id: "10803",
          name: "Assiniboia",
          state_id: "674",
        },
        {
          id: "10804",
          name: "Biggar",
          state_id: "674",
        },
        {
          id: "10805",
          name: "Canora",
          state_id: "674",
        },
        {
          id: "10806",
          name: "Carlyle",
          state_id: "674",
        },
        {
          id: "10807",
          name: "Carnduff",
          state_id: "674",
        },
        {
          id: "10808",
          name: "Caronport",
          state_id: "674",
        },
        {
          id: "10809",
          name: "Carrot",
          state_id: "674",
        },
        {
          id: "10810",
          name: "Dalmeny",
          state_id: "674",
        },
        {
          id: "10811",
          name: "Davidson",
          state_id: "674",
        },
        {
          id: "10812",
          name: "Esterhazy",
          state_id: "674",
        },
        {
          id: "10813",
          name: "Estevan",
          state_id: "674",
        },
        {
          id: "10814",
          name: "Eston",
          state_id: "674",
        },
        {
          id: "10815",
          name: "Foam Lake",
          state_id: "674",
        },
        {
          id: "10816",
          name: "Fort Qu''Appelle",
          state_id: "674",
        },
        {
          id: "10817",
          name: "Gravelbourg",
          state_id: "674",
        },
        {
          id: "10818",
          name: "Grenfell",
          state_id: "674",
        },
        {
          id: "10819",
          name: "Gull Lake",
          state_id: "674",
        },
        {
          id: "10820",
          name: "Hudson Bay",
          state_id: "674",
        },
        {
          id: "10821",
          name: "Humboldt",
          state_id: "674",
        },
        {
          id: "10822",
          name: "Indian Head",
          state_id: "674",
        },
        {
          id: "10823",
          name: "Kamsack",
          state_id: "674",
        },
        {
          id: "10824",
          name: "Kelvington",
          state_id: "674",
        },
        {
          id: "10825",
          name: "Kerrobert",
          state_id: "674",
        },
        {
          id: "10826",
          name: "Kindersley",
          state_id: "674",
        },
        {
          id: "10827",
          name: "Kipling",
          state_id: "674",
        },
        {
          id: "10828",
          name: "La Ronge",
          state_id: "674",
        },
        {
          id: "10829",
          name: "Langenburg",
          state_id: "674",
        },
        {
          id: "10830",
          name: "Langham",
          state_id: "674",
        },
        {
          id: "10831",
          name: "Lanigan",
          state_id: "674",
        },
        {
          id: "10832",
          name: "Lloydminster",
          state_id: "674",
        },
        {
          id: "10833",
          name: "Lumsden",
          state_id: "674",
        },
        {
          id: "10834",
          name: "Macklin",
          state_id: "674",
        },
        {
          id: "10835",
          name: "Maple Creek",
          state_id: "674",
        },
        {
          id: "10836",
          name: "Martensville",
          state_id: "674",
        },
        {
          id: "10837",
          name: "Meadow Lake",
          state_id: "674",
        },
        {
          id: "10838",
          name: "Melfort",
          state_id: "674",
        },
        {
          id: "10839",
          name: "Melville",
          state_id: "674",
        },
        {
          id: "10840",
          name: "Moose Jaw",
          state_id: "674",
        },
        {
          id: "10841",
          name: "Moosomin",
          state_id: "674",
        },
        {
          id: "10842",
          name: "Nipawin",
          state_id: "674",
        },
        {
          id: "10843",
          name: "North Battleford",
          state_id: "674",
        },
        {
          id: "10844",
          name: "Outlook",
          state_id: "674",
        },
        {
          id: "10845",
          name: "Oxbow",
          state_id: "674",
        },
        {
          id: "10846",
          name: "Pilot Butte",
          state_id: "674",
        },
        {
          id: "10847",
          name: "Preeceville",
          state_id: "674",
        },
        {
          id: "10848",
          name: "Prince Albert",
          state_id: "674",
        },
        {
          id: "10849",
          name: "Regina",
          state_id: "674",
        },
        {
          id: "10850",
          name: "Rosetown",
          state_id: "674",
        },
        {
          id: "10851",
          name: "Rosthem",
          state_id: "674",
        },
        {
          id: "10852",
          name: "Saskatoon",
          state_id: "674",
        },
        {
          id: "10853",
          name: "Shaunavon",
          state_id: "674",
        },
        {
          id: "10854",
          name: "Shellbrook",
          state_id: "674",
        },
        {
          id: "10855",
          name: "Swift Current",
          state_id: "674",
        },
        {
          id: "10856",
          name: "Tisdale",
          state_id: "674",
        },
        {
          id: "10857",
          name: "Unity",
          state_id: "674",
        },
        {
          id: "10858",
          name: "Wadena",
          state_id: "674",
        },
        {
          id: "10859",
          name: "Warman",
          state_id: "674",
        },
        {
          id: "10860",
          name: "Watrous",
          state_id: "674",
        },
        {
          id: "10861",
          name: "Weyburn",
          state_id: "674",
        },
        {
          id: "10862",
          name: "White City",
          state_id: "674",
        },
        {
          id: "10863",
          name: "Wilkie",
          state_id: "674",
        },
        {
          id: "10864",
          name: "Wynyard",
          state_id: "674",
        },
        {
          id: "10865",
          name: "Yorkton",
          state_id: "674",
        },
      ],
      Yukon: [
        {
          id: "10866",
          name: "Haines Junction",
          state_id: "675",
        },
        {
          id: "10867",
          name: "Mayo",
          state_id: "675",
        },
        {
          id: "10868",
          name: "Whitehorse",
          state_id: "675",
        },
      ],
    },
  },
  CC: {
    name: "Cocos [Keeling] Islands",
    native: "Cocos (Keeling) Islands",
    phone: "61",
    continent: "AS",
    capital: "West Island",
    currency: "AUD",
    languages: ["en"],
    emoji: "🇨🇨",
    emojiU: "U+1F1E8 U+1F1E8",
    states: {
      "Cocos (Keeling) Islands": [],
    },
  },
  CD: {
    name: "Democratic Republic of the Congo",
    native: "République démocratique du Congo",
    phone: "243",
    continent: "AF",
    capital: "Kinshasa",
    currency: "CDF",
    languages: ["fr", "ln", "kg", "sw", "lu"],
    emoji: "🇨🇩",
    emojiU: "U+1F1E8 U+1F1E9",
    states: {
      Bandundu: [
        {
          id: "13567",
          name: "Bandundu",
          state_id: "821",
        },
        {
          id: "13568",
          name: "Bolobo",
          state_id: "821",
        },
        {
          id: "13569",
          name: "Bulungu",
          state_id: "821",
        },
        {
          id: "13570",
          name: "Gungu",
          state_id: "821",
        },
        {
          id: "13571",
          name: "Idiofa",
          state_id: "821",
        },
        {
          id: "13572",
          name: "Inongo",
          state_id: "821",
        },
        {
          id: "13573",
          name: "Kahemba",
          state_id: "821",
        },
        {
          id: "13574",
          name: "Kasongo-Lunda",
          state_id: "821",
        },
        {
          id: "13575",
          name: "Kenge",
          state_id: "821",
        },
        {
          id: "13576",
          name: "Kikwit",
          state_id: "821",
        },
        {
          id: "13577",
          name: "Kiri",
          state_id: "821",
        },
        {
          id: "13578",
          name: "Kutu",
          state_id: "821",
        },
        {
          id: "13579",
          name: "Lusanga",
          state_id: "821",
        },
        {
          id: "13580",
          name: "Mangai",
          state_id: "821",
        },
        {
          id: "13581",
          name: "Mushie",
          state_id: "821",
        },
        {
          id: "13582",
          name: "Nioki",
          state_id: "821",
        },
      ],
      "Bas-Congo": [
        {
          id: "13583",
          name: "Boma",
          state_id: "822",
        },
        {
          id: "13584",
          name: "Kasangulu",
          state_id: "822",
        },
        {
          id: "13585",
          name: "Kimpese",
          state_id: "822",
        },
        {
          id: "13586",
          name: "Madimba",
          state_id: "822",
        },
        {
          id: "13587",
          name: "Matadi",
          state_id: "822",
        },
        {
          id: "13588",
          name: "Mbanza-Ngungu",
          state_id: "822",
        },
        {
          id: "13589",
          name: "Muanda",
          state_id: "822",
        },
        {
          id: "13590",
          name: "Tshela",
          state_id: "822",
        },
      ],
      Equateur: [
        {
          id: "13591",
          name: "Basankusu",
          state_id: "823",
        },
        {
          id: "13592",
          name: "Binga",
          state_id: "823",
        },
        {
          id: "13593",
          name: "Bodalangi",
          state_id: "823",
        },
        {
          id: "13594",
          name: "Boende",
          state_id: "823",
        },
        {
          id: "13595",
          name: "Bongandanga",
          state_id: "823",
        },
        {
          id: "13596",
          name: "Bosobolo",
          state_id: "823",
        },
        {
          id: "13597",
          name: "Bumba",
          state_id: "823",
        },
        {
          id: "13598",
          name: "Businga",
          state_id: "823",
        },
        {
          id: "13599",
          name: "Gbadolite",
          state_id: "823",
        },
        {
          id: "13600",
          name: "Gemena",
          state_id: "823",
        },
        {
          id: "13601",
          name: "Ikela",
          state_id: "823",
        },
        {
          id: "13602",
          name: "Libenge",
          state_id: "823",
        },
        {
          id: "13603",
          name: "Lisala",
          state_id: "823",
        },
        {
          id: "13604",
          name: "Makanza",
          state_id: "823",
        },
        {
          id: "13605",
          name: "Mbandaka",
          state_id: "823",
        },
        {
          id: "13606",
          name: "Mobayi-Mbongo",
          state_id: "823",
        },
        {
          id: "13607",
          name: "Yakoma",
          state_id: "823",
        },
        {
          id: "13608",
          name: "Yandongi",
          state_id: "823",
        },
        {
          id: "13609",
          name: "Yumbi",
          state_id: "823",
        },
        {
          id: "13610",
          name: "Zongo",
          state_id: "823",
        },
      ],
      "Haut-Congo": [
        {
          id: "13611",
          name: "Aba",
          state_id: "824",
        },
        {
          id: "13612",
          name: "Aketi",
          state_id: "824",
        },
        {
          id: "13613",
          name: "Bafwasende",
          state_id: "824",
        },
        {
          id: "13614",
          name: "Banalia",
          state_id: "824",
        },
        {
          id: "13615",
          name: "Basoko",
          state_id: "824",
        },
        {
          id: "13616",
          name: "Bondo",
          state_id: "824",
        },
        {
          id: "13617",
          name: "Bunia",
          state_id: "824",
        },
        {
          id: "13618",
          name: "Buta",
          state_id: "824",
        },
        {
          id: "13619",
          name: "Djugu",
          state_id: "824",
        },
        {
          id: "13620",
          name: "Faradje",
          state_id: "824",
        },
        {
          id: "13621",
          name: "Gwane",
          state_id: "824",
        },
        {
          id: "13622",
          name: "Isiro",
          state_id: "824",
        },
        {
          id: "13623",
          name: "Itoko",
          state_id: "824",
        },
        {
          id: "13624",
          name: "Kisangani",
          state_id: "824",
        },
        {
          id: "13625",
          name: "Mambasa",
          state_id: "824",
        },
        {
          id: "13626",
          name: "Mongbwalu",
          state_id: "824",
        },
        {
          id: "13627",
          name: "Niangara",
          state_id: "824",
        },
        {
          id: "13628",
          name: "Poko",
          state_id: "824",
        },
        {
          id: "13629",
          name: "Simba",
          state_id: "824",
        },
        {
          id: "13630",
          name: "Titule",
          state_id: "824",
        },
        {
          id: "13631",
          name: "Ubundu",
          state_id: "824",
        },
        {
          id: "13632",
          name: "Wamba",
          state_id: "824",
        },
        {
          id: "13633",
          name: "Watsa",
          state_id: "824",
        },
        {
          id: "13634",
          name: "Yangambi",
          state_id: "824",
        },
      ],
      "Kasai-Occidental": [
        {
          id: "13635",
          name: "Demba",
          state_id: "825",
        },
        {
          id: "13636",
          name: "Dibaya",
          state_id: "825",
        },
        {
          id: "13637",
          name: "Ilebo",
          state_id: "825",
        },
        {
          id: "13638",
          name: "Kananga",
          state_id: "825",
        },
        {
          id: "13639",
          name: "Kazumba",
          state_id: "825",
        },
        {
          id: "13640",
          name: "Luebo",
          state_id: "825",
        },
        {
          id: "13641",
          name: "Mweka",
          state_id: "825",
        },
        {
          id: "13642",
          name: "Tshikapa",
          state_id: "825",
        },
      ],
      "Kasai-Oriental": [
        {
          id: "13643",
          name: "Gandajika",
          state_id: "826",
        },
        {
          id: "13644",
          name: "Kabinda",
          state_id: "826",
        },
        {
          id: "13645",
          name: "Katako-Kombe",
          state_id: "826",
        },
        {
          id: "13646",
          name: "Kole",
          state_id: "826",
        },
        {
          id: "13647",
          name: "Lodja",
          state_id: "826",
        },
        {
          id: "13648",
          name: "Lubao",
          state_id: "826",
        },
        {
          id: "13649",
          name: "Lubefu",
          state_id: "826",
        },
        {
          id: "13650",
          name: "Lusambo",
          state_id: "826",
        },
        {
          id: "13651",
          name: "Mbuji-Mayi",
          state_id: "826",
        },
        {
          id: "13652",
          name: "Mwene-Ditu",
          state_id: "826",
        },
        {
          id: "13653",
          name: "Tshilenge",
          state_id: "826",
        },
        {
          id: "13654",
          name: "Tshofa",
          state_id: "826",
        },
      ],
      Katanga: [
        {
          id: "13655",
          name: "Bukama",
          state_id: "827",
        },
        {
          id: "13656",
          name: "Dilolo",
          state_id: "827",
        },
        {
          id: "13657",
          name: "Kabalo",
          state_id: "827",
        },
        {
          id: "13658",
          name: "Kalemie",
          state_id: "827",
        },
        {
          id: "13659",
          name: "Kambove",
          state_id: "827",
        },
        {
          id: "13660",
          name: "Kamina",
          state_id: "827",
        },
        {
          id: "13661",
          name: "Kaniama",
          state_id: "827",
        },
        {
          id: "13662",
          name: "Kikondjo",
          state_id: "827",
        },
        {
          id: "13663",
          name: "Kipushi",
          state_id: "827",
        },
        {
          id: "13664",
          name: "Kolwezi",
          state_id: "827",
        },
        {
          id: "13665",
          name: "Kongolo",
          state_id: "827",
        },
        {
          id: "13666",
          name: "Le Marinel",
          state_id: "827",
        },
        {
          id: "13667",
          name: "Likasi",
          state_id: "827",
        },
        {
          id: "13668",
          name: "Lubudi",
          state_id: "827",
        },
        {
          id: "13669",
          name: "Lubumbashi",
          state_id: "827",
        },
        {
          id: "13670",
          name: "Malemba-Nkulu",
          state_id: "827",
        },
        {
          id: "13671",
          name: "Manono",
          state_id: "827",
        },
        {
          id: "13672",
          name: "Moba",
          state_id: "827",
        },
        {
          id: "13673",
          name: "Mulongo",
          state_id: "827",
        },
        {
          id: "13674",
          name: "Mwanza",
          state_id: "827",
        },
        {
          id: "13675",
          name: "Nyunzu",
          state_id: "827",
        },
        {
          id: "13676",
          name: "Sakania",
          state_id: "827",
        },
        {
          id: "13677",
          name: "Shinkolobwe",
          state_id: "827",
        },
      ],
      Kinshasa: [
        {
          id: "13678",
          name: "Kinshasa",
          state_id: "828",
        },
      ],
      Maniema: [
        {
          id: "13679",
          name: "Kalima",
          state_id: "829",
        },
        {
          id: "13680",
          name: "Kasongo",
          state_id: "829",
        },
        {
          id: "13681",
          name: "Kindu",
          state_id: "829",
        },
      ],
      "Nord-Kivu": [
        {
          id: "13682",
          name: "Beni",
          state_id: "830",
        },
        {
          id: "13683",
          name: "Butembo",
          state_id: "830",
        },
        {
          id: "13684",
          name: "Goma",
          state_id: "830",
        },
      ],
      "Sud-Kivu": [
        {
          id: "13685",
          name: "Bukavu",
          state_id: "831",
        },
        {
          id: "13686",
          name: "Kabare",
          state_id: "831",
        },
        {
          id: "13687",
          name: "Kama",
          state_id: "831",
        },
        {
          id: "13688",
          name: "Kampene",
          state_id: "831",
        },
        {
          id: "13689",
          name: "Kibombo",
          state_id: "831",
        },
        {
          id: "13690",
          name: "Uvira",
          state_id: "831",
        },
      ],
    },
  },
  CF: {
    name: "Central African Republic",
    native: "Ködörösêse tî Bêafrîka",
    phone: "236",
    continent: "AF",
    capital: "Bangui",
    currency: "XAF",
    languages: ["fr", "sg"],
    emoji: "🇨🇫",
    emojiU: "U+1F1E8 U+1F1EB",
    states: {
      "Bamingui-Bangoran": [
        {
          id: "10875",
          name: "Ndele",
          state_id: "686",
        },
      ],
      Bangui: [
        {
          id: "10876",
          name: "Bangui",
          state_id: "687",
        },
      ],
      "Basse-Kotto": [
        {
          id: "10877",
          name: "Alindao",
          state_id: "688",
        },
        {
          id: "10878",
          name: "Kembe",
          state_id: "688",
        },
        {
          id: "10879",
          name: "Mobaye",
          state_id: "688",
        },
      ],
      "Haut-Mbomou": [
        {
          id: "10880",
          name: "Obo",
          state_id: "689",
        },
        {
          id: "10881",
          name: "Zemio",
          state_id: "689",
        },
      ],
      "Haute-Kotto": [
        {
          id: "10882",
          name: "Bria",
          state_id: "690",
        },
        {
          id: "10883",
          name: "Ouadda",
          state_id: "690",
        },
      ],
      Kemo: [
        {
          id: "10884",
          name: "Dekoa",
          state_id: "691",
        },
        {
          id: "10885",
          name: "Sibut",
          state_id: "691",
        },
      ],
      Lobaye: [
        {
          id: "10886",
          name: "Boda",
          state_id: "692",
        },
        {
          id: "10887",
          name: "Mbaiki",
          state_id: "692",
        },
        {
          id: "10888",
          name: "Mongoumba",
          state_id: "692",
        },
      ],
      "Mambere-Kadei": [
        {
          id: "10889",
          name: "Berberati",
          state_id: "693",
        },
        {
          id: "10890",
          name: "Carnot",
          state_id: "693",
        },
        {
          id: "10891",
          name: "Gamboula",
          state_id: "693",
        },
      ],
      Mbomou: [
        {
          id: "10892",
          name: "Bangassou",
          state_id: "694",
        },
        {
          id: "10893",
          name: "Gambo",
          state_id: "694",
        },
        {
          id: "10894",
          name: "Ouango",
          state_id: "694",
        },
        {
          id: "10895",
          name: "Rafai",
          state_id: "694",
        },
      ],
      "Nana-Gribizi": [
        {
          id: "10896",
          name: "Kaga-Bandoro",
          state_id: "695",
        },
      ],
      "Nana-Mambere": [
        {
          id: "10897",
          name: "Baboua",
          state_id: "696",
        },
        {
          id: "10898",
          name: "Baoro",
          state_id: "696",
        },
        {
          id: "10899",
          name: "Bouar",
          state_id: "696",
        },
      ],
      "Ombella Mpoko": [],
      Ouaka: [
        {
          id: "10900",
          name: "Bambari",
          state_id: "698",
        },
        {
          id: "10901",
          name: "Grimari",
          state_id: "698",
        },
        {
          id: "10902",
          name: "Ippy",
          state_id: "698",
        },
        {
          id: "10903",
          name: "Kouango",
          state_id: "698",
        },
      ],
      Ouham: [
        {
          id: "10904",
          name: "Batangafo",
          state_id: "699",
        },
        {
          id: "10905",
          name: "Bossangoa",
          state_id: "699",
        },
        {
          id: "10906",
          name: "Bouca",
          state_id: "699",
        },
        {
          id: "10907",
          name: "Kabo",
          state_id: "699",
        },
      ],
      "Ouham-Pende": [
        {
          id: "10908",
          name: "Bocaranga",
          state_id: "700",
        },
        {
          id: "10909",
          name: "Bozoum",
          state_id: "700",
        },
        {
          id: "10910",
          name: "Paoua",
          state_id: "700",
        },
      ],
      "Sangha-Mbaere": [
        {
          id: "10911",
          name: "Nola",
          state_id: "701",
        },
      ],
      Vakaga: [
        {
          id: "10912",
          name: "Birao",
          state_id: "702",
        },
      ],
    },
  },
  CG: {
    name: "Republic of the Congo",
    native: "République du Congo",
    phone: "242",
    continent: "AF",
    capital: "Brazzaville",
    currency: "XAF",
    languages: ["fr", "ln"],
    emoji: "🇨🇬",
    emojiU: "U+1F1E8 U+1F1EC",
    states: {
      Bouenza: [
        {
          id: "13537",
          name: "Loudima",
          state_id: "811",
        },
        {
          id: "13538",
          name: "Madingou",
          state_id: "811",
        },
        {
          id: "13539",
          name: "Nkayi",
          state_id: "811",
        },
      ],
      Brazzaville: [
        {
          id: "13540",
          name: "Brazzaville",
          state_id: "812",
        },
      ],
      Cuvette: [
        {
          id: "13541",
          name: "Ewo",
          state_id: "813",
        },
        {
          id: "13542",
          name: "Kelle",
          state_id: "813",
        },
        {
          id: "13543",
          name: "Makoua",
          state_id: "813",
        },
        {
          id: "13544",
          name: "Mossaka",
          state_id: "813",
        },
        {
          id: "13545",
          name: "Owando",
          state_id: "813",
        },
      ],
      Kouilou: [
        {
          id: "13546",
          name: "Loandjili",
          state_id: "814",
        },
        {
          id: "13547",
          name: "Ngamaba-Mfilou",
          state_id: "814",
        },
        {
          id: "13548",
          name: "Pointe Noire",
          state_id: "814",
        },
      ],
      Lekoumou: [
        {
          id: "13549",
          name: "Sibiti",
          state_id: "815",
        },
        {
          id: "13550",
          name: "Zanaga",
          state_id: "815",
        },
      ],
      Likouala: [
        {
          id: "13551",
          name: "Dongou",
          state_id: "816",
        },
        {
          id: "13552",
          name: "Epena",
          state_id: "816",
        },
        {
          id: "13553",
          name: "Impfondo",
          state_id: "816",
        },
      ],
      Niari: [
        {
          id: "13554",
          name: "Kibangou",
          state_id: "817",
        },
        {
          id: "13555",
          name: "Loubomo",
          state_id: "817",
        },
        {
          id: "13556",
          name: "Matsanga",
          state_id: "817",
        },
        {
          id: "13557",
          name: "Mossendjo",
          state_id: "817",
        },
      ],
      Plateaux: [
        {
          id: "13558",
          name: "Djambala",
          state_id: "818",
        },
        {
          id: "13559",
          name: "Gamboma",
          state_id: "818",
        },
      ],
      Pool: [
        {
          id: "13560",
          name: "Boko",
          state_id: "819",
        },
        {
          id: "13561",
          name: "Kinkala",
          state_id: "819",
        },
        {
          id: "13562",
          name: "Mindouli",
          state_id: "819",
        },
      ],
      Sangha: [
        {
          id: "13563",
          name: "Ikelemba",
          state_id: "820",
        },
        {
          id: "13564",
          name: "Ouesso",
          state_id: "820",
        },
        {
          id: "13565",
          name: "Sembe",
          state_id: "820",
        },
        {
          id: "13566",
          name: "Souanke",
          state_id: "820",
        },
      ],
    },
  },
  CH: {
    name: "Switzerland",
    native: "Schweiz",
    phone: "41",
    continent: "EU",
    capital: "Bern",
    currency: "CHE,CHF,CHW",
    languages: ["de", "fr", "it"],
    emoji: "🇨🇭",
    emojiU: "U+1F1E8 U+1F1ED",
    states: {
      Aargau: [
        {
          id: "39221",
          name: "Aarau",
          state_id: "3424",
        },
        {
          id: "39222",
          name: "Aarburg",
          state_id: "3424",
        },
        {
          id: "39223",
          name: "Baden",
          state_id: "3424",
        },
        {
          id: "39224",
          name: "Bevilard",
          state_id: "3424",
        },
        {
          id: "39225",
          name: "Bremgarten",
          state_id: "3424",
        },
        {
          id: "39226",
          name: "Brugg",
          state_id: "3424",
        },
        {
          id: "39227",
          name: "Buchs",
          state_id: "3424",
        },
        {
          id: "39228",
          name: "Chevenez",
          state_id: "3424",
        },
        {
          id: "39229",
          name: "Fislisbach",
          state_id: "3424",
        },
        {
          id: "39230",
          name: "Granichen",
          state_id: "3424",
        },
        {
          id: "39231",
          name: "Hagglingen",
          state_id: "3424",
        },
        {
          id: "39232",
          name: "Kaiseraugst",
          state_id: "3424",
        },
        {
          id: "39233",
          name: "Kleindoettingen",
          state_id: "3424",
        },
        {
          id: "39234",
          name: "Klingnau",
          state_id: "3424",
        },
        {
          id: "39235",
          name: "Kuttigen",
          state_id: "3424",
        },
        {
          id: "39236",
          name: "Lenzburg",
          state_id: "3424",
        },
        {
          id: "39237",
          name: "Menziken",
          state_id: "3424",
        },
        {
          id: "39238",
          name: "Mohlin",
          state_id: "3424",
        },
        {
          id: "39239",
          name: "Mumpf",
          state_id: "3424",
        },
        {
          id: "39240",
          name: "Muri",
          state_id: "3424",
        },
        {
          id: "39241",
          name: "Neuenhof",
          state_id: "3424",
        },
        {
          id: "39242",
          name: "Niederlenz",
          state_id: "3424",
        },
        {
          id: "39243",
          name: "Niederwangen",
          state_id: "3424",
        },
        {
          id: "39244",
          name: "Niederwil",
          state_id: "3424",
        },
        {
          id: "39245",
          name: "Oberentfelden",
          state_id: "3424",
        },
        {
          id: "39246",
          name: "Obersiggenthal",
          state_id: "3424",
        },
        {
          id: "39247",
          name: "Oftringen",
          state_id: "3424",
        },
        {
          id: "39248",
          name: "Reinach",
          state_id: "3424",
        },
        {
          id: "39249",
          name: "Rheinfelden",
          state_id: "3424",
        },
        {
          id: "39250",
          name: "Rosshausern",
          state_id: "3424",
        },
        {
          id: "39251",
          name: "Rothrist",
          state_id: "3424",
        },
        {
          id: "39252",
          name: "Rupperswil",
          state_id: "3424",
        },
        {
          id: "39253",
          name: "Schmitten",
          state_id: "3424",
        },
        {
          id: "39254",
          name: "Seon",
          state_id: "3424",
        },
        {
          id: "39255",
          name: "Spreitenbach",
          state_id: "3424",
        },
        {
          id: "39256",
          name: "Stein",
          state_id: "3424",
        },
        {
          id: "39257",
          name: "Suhr",
          state_id: "3424",
        },
        {
          id: "39258",
          name: "Trogen",
          state_id: "3424",
        },
        {
          id: "39259",
          name: "Untersiggenthal",
          state_id: "3424",
        },
        {
          id: "39260",
          name: "Villmergen",
          state_id: "3424",
        },
        {
          id: "39261",
          name: "Wettingen",
          state_id: "3424",
        },
        {
          id: "39262",
          name: "Windisch",
          state_id: "3424",
        },
        {
          id: "39263",
          name: "Wohlen",
          state_id: "3424",
        },
        {
          id: "39264",
          name: "Wurenlos",
          state_id: "3424",
        },
        {
          id: "39265",
          name: "Zofingen",
          state_id: "3424",
        },
      ],
      "Appenzell Inner-Rhoden": [],
      "Appenzell-Ausser Rhoden": [],
      "Basel-Landschaft": [
        {
          id: "39266",
          name: "Aesch",
          state_id: "3427",
        },
        {
          id: "39267",
          name: "Allschwil",
          state_id: "3427",
        },
        {
          id: "39268",
          name: "Arlesheim",
          state_id: "3427",
        },
        {
          id: "39269",
          name: "Binningen",
          state_id: "3427",
        },
        {
          id: "39270",
          name: "Birsfelden",
          state_id: "3427",
        },
        {
          id: "39271",
          name: "Bottmingen",
          state_id: "3427",
        },
        {
          id: "39272",
          name: "Ettingen",
          state_id: "3427",
        },
        {
          id: "39273",
          name: "Frenkendorf",
          state_id: "3427",
        },
        {
          id: "39274",
          name: "Gelterkinden",
          state_id: "3427",
        },
        {
          id: "39275",
          name: "Laufen",
          state_id: "3427",
        },
        {
          id: "39276",
          name: "Lausen",
          state_id: "3427",
        },
        {
          id: "39277",
          name: "Liestal",
          state_id: "3427",
        },
        {
          id: "39278",
          name: "Munchenstein",
          state_id: "3427",
        },
        {
          id: "39279",
          name: "Muttenz",
          state_id: "3427",
        },
        {
          id: "39280",
          name: "Oberwil",
          state_id: "3427",
        },
        {
          id: "39281",
          name: "Pratteln",
          state_id: "3427",
        },
        {
          id: "39282",
          name: "Reinach",
          state_id: "3427",
        },
        {
          id: "39283",
          name: "Sissach",
          state_id: "3427",
        },
        {
          id: "39284",
          name: "Therwil",
          state_id: "3427",
        },
      ],
      "Basel-Stadt": [
        {
          id: "39285",
          name: "Basel",
          state_id: "3428",
        },
        {
          id: "39286",
          name: "Riehen",
          state_id: "3428",
        },
      ],
      Bern: [
        {
          id: "39287",
          name: "Belp",
          state_id: "3429",
        },
        {
          id: "39288",
          name: "Bern",
          state_id: "3429",
        },
        {
          id: "39289",
          name: "Berne",
          state_id: "3429",
        },
        {
          id: "39290",
          name: "Biel",
          state_id: "3429",
        },
        {
          id: "39291",
          name: "Biel-Bienne",
          state_id: "3429",
        },
        {
          id: "39292",
          name: "Bolligen",
          state_id: "3429",
        },
        {
          id: "39293",
          name: "Burgdorf",
          state_id: "3429",
        },
        {
          id: "39294",
          name: "Frutigen",
          state_id: "3429",
        },
        {
          id: "39295",
          name: "Heimberg",
          state_id: "3429",
        },
        {
          id: "39296",
          name: "Herzogenbuchsee",
          state_id: "3429",
        },
        {
          id: "39297",
          name: "Huttwil",
          state_id: "3429",
        },
        {
          id: "39298",
          name: "Interlaken",
          state_id: "3429",
        },
        {
          id: "39299",
          name: "Ittigen",
          state_id: "3429",
        },
        {
          id: "39300",
          name: "Kirchberg",
          state_id: "3429",
        },
        {
          id: "39301",
          name: "Koniz",
          state_id: "3429",
        },
        {
          id: "39302",
          name: "Konolfingen",
          state_id: "3429",
        },
        {
          id: "39303",
          name: "Langenthal",
          state_id: "3429",
        },
        {
          id: "39304",
          name: "Langnau",
          state_id: "3429",
        },
        {
          id: "39305",
          name: "Lengnau",
          state_id: "3429",
        },
        {
          id: "39306",
          name: "Lyss",
          state_id: "3429",
        },
        {
          id: "39307",
          name: "Meiringen",
          state_id: "3429",
        },
        {
          id: "39308",
          name: "Moutier",
          state_id: "3429",
        },
        {
          id: "39309",
          name: "Munchenbuchsee",
          state_id: "3429",
        },
        {
          id: "39310",
          name: "Munsingen",
          state_id: "3429",
        },
        {
          id: "39311",
          name: "Muri",
          state_id: "3429",
        },
        {
          id: "39312",
          name: "Nidau",
          state_id: "3429",
        },
        {
          id: "39313",
          name: "Orpund",
          state_id: "3429",
        },
        {
          id: "39314",
          name: "Ostermundingen",
          state_id: "3429",
        },
        {
          id: "39315",
          name: "Pieterlen",
          state_id: "3429",
        },
        {
          id: "39316",
          name: "Saanen",
          state_id: "3429",
        },
        {
          id: "39317",
          name: "Saint-Imier",
          state_id: "3429",
        },
        {
          id: "39318",
          name: "Sonceboz",
          state_id: "3429",
        },
        {
          id: "39319",
          name: "Spiez",
          state_id: "3429",
        },
        {
          id: "39320",
          name: "Steffisburg",
          state_id: "3429",
        },
        {
          id: "39321",
          name: "Sumiswald",
          state_id: "3429",
        },
        {
          id: "39322",
          name: "Thun",
          state_id: "3429",
        },
        {
          id: "39323",
          name: "Uetendorf",
          state_id: "3429",
        },
        {
          id: "39324",
          name: "Unterseen",
          state_id: "3429",
        },
        {
          id: "39325",
          name: "Urtenen",
          state_id: "3429",
        },
        {
          id: "39326",
          name: "Vechingen",
          state_id: "3429",
        },
        {
          id: "39327",
          name: "Wahlern",
          state_id: "3429",
        },
        {
          id: "39328",
          name: "Wohlen",
          state_id: "3429",
        },
        {
          id: "39329",
          name: "Worb",
          state_id: "3429",
        },
        {
          id: "39330",
          name: "Zollikofen",
          state_id: "3429",
        },
      ],
      "Canton Ticino": [],
      Fribourg: [
        {
          id: "39331",
          name: "Bulle",
          state_id: "3431",
        },
        {
          id: "39332",
          name: "Dudingen",
          state_id: "3431",
        },
        {
          id: "39333",
          name: "Fribourg",
          state_id: "3431",
        },
        {
          id: "39334",
          name: "Granges-Paccot",
          state_id: "3431",
        },
        {
          id: "39335",
          name: "Marly",
          state_id: "3431",
        },
        {
          id: "39336",
          name: "Muntelier",
          state_id: "3431",
        },
        {
          id: "39337",
          name: "Murten",
          state_id: "3431",
        },
        {
          id: "39338",
          name: "Remaufens",
          state_id: "3431",
        },
        {
          id: "39339",
          name: "Villars-sur-Glane",
          state_id: "3431",
        },
        {
          id: "39340",
          name: "Villaz-Saint-Pierre",
          state_id: "3431",
        },
        {
          id: "39341",
          name: "Wunnewil-Flamatt",
          state_id: "3431",
        },
      ],
      Geneve: [
        {
          id: "39342",
          name: "Bernex",
          state_id: "3432",
        },
        {
          id: "39343",
          name: "Carouge",
          state_id: "3432",
        },
        {
          id: "39344",
          name: "Chene-Bougeries",
          state_id: "3432",
        },
        {
          id: "39345",
          name: "Chene-Bourg",
          state_id: "3432",
        },
        {
          id: "39346",
          name: "Collonge-Bellerive",
          state_id: "3432",
        },
        {
          id: "39347",
          name: "Cologny",
          state_id: "3432",
        },
        {
          id: "39348",
          name: "Geneva",
          state_id: "3432",
        },
        {
          id: "39349",
          name: "Geneve",
          state_id: "3432",
        },
        {
          id: "39350",
          name: "Lancy",
          state_id: "3432",
        },
        {
          id: "39351",
          name: "Le Grand-Saconnex",
          state_id: "3432",
        },
        {
          id: "39352",
          name: "Meyrin",
          state_id: "3432",
        },
        {
          id: "39353",
          name: "Onex",
          state_id: "3432",
        },
        {
          id: "39354",
          name: "Plan-les-Ouates",
          state_id: "3432",
        },
        {
          id: "39355",
          name: "Thonex",
          state_id: "3432",
        },
        {
          id: "39356",
          name: "Vernier",
          state_id: "3432",
        },
        {
          id: "39357",
          name: "Versoix",
          state_id: "3432",
        },
        {
          id: "39358",
          name: "Veyrier",
          state_id: "3432",
        },
      ],
      Glarus: [
        {
          id: "39359",
          name: "Glarus",
          state_id: "3433",
        },
        {
          id: "39360",
          name: "Nafels",
          state_id: "3433",
        },
      ],
      Graubunden: [
        {
          id: "39361",
          name: "Arosa",
          state_id: "3434",
        },
        {
          id: "39362",
          name: "Chur",
          state_id: "3434",
        },
        {
          id: "39363",
          name: "Davos",
          state_id: "3434",
        },
        {
          id: "39364",
          name: "Domat",
          state_id: "3434",
        },
        {
          id: "39365",
          name: "Igis",
          state_id: "3434",
        },
        {
          id: "39366",
          name: "Landquart",
          state_id: "3434",
        },
        {
          id: "39367",
          name: "Maienfeld",
          state_id: "3434",
        },
        {
          id: "39368",
          name: "Sankt Moritz",
          state_id: "3434",
        },
      ],
      Heerbrugg: [
        {
          id: "39369",
          name: "Heerbrugg",
          state_id: "3435",
        },
      ],
      Jura: [
        {
          id: "39370",
          name: "Delemont",
          state_id: "3436",
        },
        {
          id: "39371",
          name: "Glovelier",
          state_id: "3436",
        },
        {
          id: "39372",
          name: "Le Noirmont",
          state_id: "3436",
        },
        {
          id: "39373",
          name: "Porrentruy",
          state_id: "3436",
        },
      ],
      "Kanton Aargau": [],
      Luzern: [
        {
          id: "39374",
          name: "Adligenswil",
          state_id: "3438",
        },
        {
          id: "39375",
          name: "Ballwil",
          state_id: "3438",
        },
        {
          id: "39376",
          name: "Buchrain",
          state_id: "3438",
        },
        {
          id: "39377",
          name: "Ebikon",
          state_id: "3438",
        },
        {
          id: "39378",
          name: "Emmen",
          state_id: "3438",
        },
        {
          id: "39379",
          name: "Hochdorf",
          state_id: "3438",
        },
        {
          id: "39380",
          name: "Horw",
          state_id: "3438",
        },
        {
          id: "39381",
          name: "Kriens",
          state_id: "3438",
        },
        {
          id: "39382",
          name: "Littau",
          state_id: "3438",
        },
        {
          id: "39383",
          name: "Luzern",
          state_id: "3438",
        },
        {
          id: "39384",
          name: "Malters",
          state_id: "3438",
        },
        {
          id: "39385",
          name: "Meggen",
          state_id: "3438",
        },
        {
          id: "39386",
          name: "Neuenkirch",
          state_id: "3438",
        },
        {
          id: "39387",
          name: "Perlern",
          state_id: "3438",
        },
        {
          id: "39388",
          name: "Rothenburg",
          state_id: "3438",
        },
        {
          id: "39389",
          name: "Ruswil",
          state_id: "3438",
        },
        {
          id: "39390",
          name: "Sursee",
          state_id: "3438",
        },
      ],
      "Morbio Inferiore": [],
      Muhen: [
        {
          id: "39391",
          name: "Muhen",
          state_id: "3440",
        },
      ],
      Neuchatel: [
        {
          id: "39392",
          name: "Bole",
          state_id: "3441",
        },
        {
          id: "39393",
          name: "Boudry",
          state_id: "3441",
        },
        {
          id: "39394",
          name: "Colombier",
          state_id: "3441",
        },
        {
          id: "39395",
          name: "La Chaux-de-Fonds",
          state_id: "3441",
        },
        {
          id: "39396",
          name: "Le Locle",
          state_id: "3441",
        },
        {
          id: "39397",
          name: "Neuchatel",
          state_id: "3441",
        },
        {
          id: "39398",
          name: "Peseux",
          state_id: "3441",
        },
      ],
      Nidwalden: [
        {
          id: "39399",
          name: "Buochs",
          state_id: "3442",
        },
        {
          id: "39400",
          name: "Hergiswil",
          state_id: "3442",
        },
        {
          id: "39401",
          name: "Stans",
          state_id: "3442",
        },
        {
          id: "39402",
          name: "Stansstad",
          state_id: "3442",
        },
      ],
      Obwalden: [
        {
          id: "39403",
          name: "Alpnach",
          state_id: "3443",
        },
        {
          id: "39404",
          name: "Kerns",
          state_id: "3443",
        },
        {
          id: "39405",
          name: "Sachseln",
          state_id: "3443",
        },
        {
          id: "39406",
          name: "Sarnen",
          state_id: "3443",
        },
      ],
      "Sankt Gallen": [],
      Schaffhausen: [
        {
          id: "39407",
          name: "Neuhausen",
          state_id: "3445",
        },
        {
          id: "39408",
          name: "Schaffhausen",
          state_id: "3445",
        },
      ],
      Schwyz: [
        {
          id: "39409",
          name: "Altendorf",
          state_id: "3446",
        },
        {
          id: "39410",
          name: "Arth",
          state_id: "3446",
        },
        {
          id: "39411",
          name: "Buron",
          state_id: "3446",
        },
        {
          id: "39412",
          name: "Einsiedeln",
          state_id: "3446",
        },
        {
          id: "39413",
          name: "Feusisberg",
          state_id: "3446",
        },
        {
          id: "39414",
          name: "Freienbach",
          state_id: "3446",
        },
        {
          id: "39415",
          name: "Ingenbohl",
          state_id: "3446",
        },
        {
          id: "39416",
          name: "Kussnacht",
          state_id: "3446",
        },
        {
          id: "39417",
          name: "Lachen",
          state_id: "3446",
        },
        {
          id: "39418",
          name: "Schubelbach",
          state_id: "3446",
        },
        {
          id: "39419",
          name: "Schwyz",
          state_id: "3446",
        },
        {
          id: "39420",
          name: "Wangen",
          state_id: "3446",
        },
        {
          id: "39421",
          name: "Wollerau",
          state_id: "3446",
        },
      ],
      Solothurn: [
        {
          id: "39422",
          name: "Balsthal",
          state_id: "3447",
        },
        {
          id: "39423",
          name: "Bellach",
          state_id: "3447",
        },
        {
          id: "39424",
          name: "Bettlach",
          state_id: "3447",
        },
        {
          id: "39425",
          name: "Biberist",
          state_id: "3447",
        },
        {
          id: "39426",
          name: "Derendingen",
          state_id: "3447",
        },
        {
          id: "39427",
          name: "Dornach",
          state_id: "3447",
        },
        {
          id: "39428",
          name: "Dulliken",
          state_id: "3447",
        },
        {
          id: "39429",
          name: "Feldbrunnen",
          state_id: "3447",
        },
        {
          id: "39430",
          name: "Gerlafingen",
          state_id: "3447",
        },
        {
          id: "39431",
          name: "Grenchen",
          state_id: "3447",
        },
        {
          id: "39432",
          name: "Hagendorf",
          state_id: "3447",
        },
        {
          id: "39433",
          name: "Olten",
          state_id: "3447",
        },
        {
          id: "39434",
          name: "Schonenwerd",
          state_id: "3447",
        },
        {
          id: "39435",
          name: "Solothurn",
          state_id: "3447",
        },
        {
          id: "39436",
          name: "Trimbach",
          state_id: "3447",
        },
        {
          id: "39437",
          name: "Wangen",
          state_id: "3447",
        },
        {
          id: "39438",
          name: "Zuchwil",
          state_id: "3447",
        },
      ],
      Thurgau: [
        {
          id: "39439",
          name: "Aadorf",
          state_id: "3448",
        },
        {
          id: "39440",
          name: "Amriswil",
          state_id: "3448",
        },
        {
          id: "39441",
          name: "Arbon",
          state_id: "3448",
        },
        {
          id: "39442",
          name: "Bischofszell",
          state_id: "3448",
        },
        {
          id: "39443",
          name: "Felben-Wellhausen",
          state_id: "3448",
        },
        {
          id: "39444",
          name: "Frauenfeld",
          state_id: "3448",
        },
        {
          id: "39445",
          name: "Guttingen",
          state_id: "3448",
        },
        {
          id: "39446",
          name: "Kreuzlingen",
          state_id: "3448",
        },
        {
          id: "39447",
          name: "Romanshorn",
          state_id: "3448",
        },
        {
          id: "39448",
          name: "Sirnach",
          state_id: "3448",
        },
        {
          id: "39449",
          name: "Sulgen",
          state_id: "3448",
        },
        {
          id: "39450",
          name: "Tagerwilen",
          state_id: "3448",
        },
        {
          id: "39451",
          name: "Weinfelden",
          state_id: "3448",
        },
      ],
      Ticino: [
        {
          id: "39452",
          name: "Ascona",
          state_id: "3449",
        },
        {
          id: "39453",
          name: "Bellinzona",
          state_id: "3449",
        },
        {
          id: "39454",
          name: "Biasca",
          state_id: "3449",
        },
        {
          id: "39455",
          name: "Breganzona",
          state_id: "3449",
        },
        {
          id: "39456",
          name: "Cadempino",
          state_id: "3449",
        },
        {
          id: "39457",
          name: "Chiasso",
          state_id: "3449",
        },
        {
          id: "39458",
          name: "Giubiasco",
          state_id: "3449",
        },
        {
          id: "39459",
          name: "Locarno",
          state_id: "3449",
        },
        {
          id: "39460",
          name: "Losone",
          state_id: "3449",
        },
        {
          id: "39461",
          name: "Lugano",
          state_id: "3449",
        },
        {
          id: "39462",
          name: "Massagno",
          state_id: "3449",
        },
        {
          id: "39463",
          name: "Melide",
          state_id: "3449",
        },
        {
          id: "39464",
          name: "Mendrisio",
          state_id: "3449",
        },
        {
          id: "39465",
          name: "Mezzovico",
          state_id: "3449",
        },
        {
          id: "39466",
          name: "Minusio",
          state_id: "3449",
        },
        {
          id: "39467",
          name: "Porza",
          state_id: "3449",
        },
        {
          id: "39468",
          name: "Pregassona",
          state_id: "3449",
        },
        {
          id: "39469",
          name: "Viganello",
          state_id: "3449",
        },
      ],
      Uri: [
        {
          id: "39470",
          name: "Altdorf",
          state_id: "3450",
        },
        {
          id: "39471",
          name: "Schattdorf",
          state_id: "3450",
        },
      ],
      Valais: [
        {
          id: "39472",
          name: "Bagnes",
          state_id: "3451",
        },
        {
          id: "39473",
          name: "Brig-Glis",
          state_id: "3451",
        },
        {
          id: "39474",
          name: "Collombey-Muraz",
          state_id: "3451",
        },
        {
          id: "39475",
          name: "Conthey",
          state_id: "3451",
        },
        {
          id: "39476",
          name: "Evionnaz",
          state_id: "3451",
        },
        {
          id: "39477",
          name: "Fully",
          state_id: "3451",
        },
        {
          id: "39478",
          name: "Martigny",
          state_id: "3451",
        },
        {
          id: "39479",
          name: "Monthey",
          state_id: "3451",
        },
        {
          id: "39480",
          name: "Naters",
          state_id: "3451",
        },
        {
          id: "39481",
          name: "Nendaz",
          state_id: "3451",
        },
        {
          id: "39482",
          name: "Niederwald",
          state_id: "3451",
        },
        {
          id: "39483",
          name: "Saviese",
          state_id: "3451",
        },
        {
          id: "39484",
          name: "Sierre",
          state_id: "3451",
        },
        {
          id: "39485",
          name: "Sion",
          state_id: "3451",
        },
        {
          id: "39486",
          name: "Visp",
          state_id: "3451",
        },
        {
          id: "39487",
          name: "Vouvry",
          state_id: "3451",
        },
        {
          id: "39488",
          name: "Zermatt",
          state_id: "3451",
        },
      ],
      Vaud: [
        {
          id: "39489",
          name: "Aigle",
          state_id: "3452",
        },
        {
          id: "39490",
          name: "Ballaigues",
          state_id: "3452",
        },
        {
          id: "39491",
          name: "Bex",
          state_id: "3452",
        },
        {
          id: "39492",
          name: "Blonay",
          state_id: "3452",
        },
        {
          id: "39493",
          name: "Bussigny",
          state_id: "3452",
        },
        {
          id: "39494",
          name: "Chavannes",
          state_id: "3452",
        },
        {
          id: "39495",
          name: "Crissier",
          state_id: "3452",
        },
        {
          id: "39496",
          name: "Ecublens",
          state_id: "3452",
        },
        {
          id: "39497",
          name: "Epalinges",
          state_id: "3452",
        },
        {
          id: "39498",
          name: "Gland",
          state_id: "3452",
        },
        {
          id: "39499",
          name: "La Tour-de-Peilz",
          state_id: "3452",
        },
        {
          id: "39500",
          name: "Lausanne",
          state_id: "3452",
        },
        {
          id: "39501",
          name: "Le Mont-sur-Lausanne",
          state_id: "3452",
        },
        {
          id: "39502",
          name: "Lucerne",
          state_id: "3452",
        },
        {
          id: "39503",
          name: "Lutry",
          state_id: "3452",
        },
        {
          id: "39504",
          name: "Montreux",
          state_id: "3452",
        },
        {
          id: "39505",
          name: "Morges",
          state_id: "3452",
        },
        {
          id: "39506",
          name: "Nyon",
          state_id: "3452",
        },
        {
          id: "39507",
          name: "Ollon",
          state_id: "3452",
        },
        {
          id: "39508",
          name: "Orbe",
          state_id: "3452",
        },
        {
          id: "39509",
          name: "Payerne",
          state_id: "3452",
        },
        {
          id: "39510",
          name: "Prilly",
          state_id: "3452",
        },
        {
          id: "39511",
          name: "Puidoux",
          state_id: "3452",
        },
        {
          id: "39512",
          name: "Pully",
          state_id: "3452",
        },
        {
          id: "39513",
          name: "Renens",
          state_id: "3452",
        },
        {
          id: "39514",
          name: "Romainmotier",
          state_id: "3452",
        },
        {
          id: "39515",
          name: "Saint Sulpice",
          state_id: "3452",
        },
        {
          id: "39516",
          name: "Vevey",
          state_id: "3452",
        },
        {
          id: "39517",
          name: "Yverdon",
          state_id: "3452",
        },
      ],
      Vauffelin: [
        {
          id: "39518",
          name: "Vauffelin",
          state_id: "3453",
        },
      ],
      Zug: [
        {
          id: "39519",
          name: "Baar",
          state_id: "3454",
        },
        {
          id: "39520",
          name: "Cham",
          state_id: "3454",
        },
        {
          id: "39521",
          name: "Hunenberg",
          state_id: "3454",
        },
        {
          id: "39522",
          name: "Menzingen",
          state_id: "3454",
        },
        {
          id: "39523",
          name: "Neuheim",
          state_id: "3454",
        },
        {
          id: "39524",
          name: "Oberageri",
          state_id: "3454",
        },
        {
          id: "39525",
          name: "Risch",
          state_id: "3454",
        },
        {
          id: "39526",
          name: "Risch-Rotkreuz",
          state_id: "3454",
        },
        {
          id: "39527",
          name: "Steinhausen",
          state_id: "3454",
        },
        {
          id: "39528",
          name: "Unterageri",
          state_id: "3454",
        },
        {
          id: "39529",
          name: "Zug",
          state_id: "3454",
        },
      ],
      Zurich: [
        {
          id: "39530",
          name: "Adliswil",
          state_id: "3455",
        },
        {
          id: "39531",
          name: "Affoltern",
          state_id: "3455",
        },
        {
          id: "39532",
          name: "Bachenbulach",
          state_id: "3455",
        },
        {
          id: "39533",
          name: "Bassersdorf",
          state_id: "3455",
        },
        {
          id: "39534",
          name: "Birmensdorf",
          state_id: "3455",
        },
        {
          id: "39535",
          name: "Bubikon",
          state_id: "3455",
        },
        {
          id: "39536",
          name: "Bulach",
          state_id: "3455",
        },
        {
          id: "39537",
          name: "Dielsdorf",
          state_id: "3455",
        },
        {
          id: "39538",
          name: "Dietikon",
          state_id: "3455",
        },
        {
          id: "39539",
          name: "Dietlikon",
          state_id: "3455",
        },
        {
          id: "39540",
          name: "Dubendorf",
          state_id: "3455",
        },
        {
          id: "39541",
          name: "Durnten",
          state_id: "3455",
        },
        {
          id: "39542",
          name: "Ebmatingen",
          state_id: "3455",
        },
        {
          id: "39543",
          name: "Egg",
          state_id: "3455",
        },
        {
          id: "39544",
          name: "Embrach",
          state_id: "3455",
        },
        {
          id: "39545",
          name: "Erlenbach",
          state_id: "3455",
        },
        {
          id: "39546",
          name: "Fallanden",
          state_id: "3455",
        },
        {
          id: "39547",
          name: "Fehraltdorf",
          state_id: "3455",
        },
        {
          id: "39548",
          name: "Geroldswil",
          state_id: "3455",
        },
        {
          id: "39549",
          name: "Gossau",
          state_id: "3455",
        },
        {
          id: "39550",
          name: "Greifensee",
          state_id: "3455",
        },
        {
          id: "39551",
          name: "Herrliberg",
          state_id: "3455",
        },
        {
          id: "39552",
          name: "Hinwil",
          state_id: "3455",
        },
        {
          id: "39553",
          name: "Hombrechtikon",
          state_id: "3455",
        },
        {
          id: "39554",
          name: "Horgen",
          state_id: "3455",
        },
        {
          id: "39555",
          name: "Illnau-Effretikon",
          state_id: "3455",
        },
        {
          id: "39556",
          name: "Kilchberg",
          state_id: "3455",
        },
        {
          id: "39557",
          name: "Kloten",
          state_id: "3455",
        },
        {
          id: "39558",
          name: "Kusnacht",
          state_id: "3455",
        },
        {
          id: "39559",
          name: "Langnau",
          state_id: "3455",
        },
        {
          id: "39560",
          name: "Mannedorf",
          state_id: "3455",
        },
        {
          id: "39561",
          name: "Maur",
          state_id: "3455",
        },
        {
          id: "39562",
          name: "Meilen",
          state_id: "3455",
        },
        {
          id: "39563",
          name: "Neftenbach",
          state_id: "3455",
        },
        {
          id: "39564",
          name: "Niederhasli",
          state_id: "3455",
        },
        {
          id: "39565",
          name: "Nurensdorf",
          state_id: "3455",
        },
        {
          id: "39566",
          name: "Oberengstringen",
          state_id: "3455",
        },
        {
          id: "39567",
          name: "Oberglatt",
          state_id: "3455",
        },
        {
          id: "39568",
          name: "Oberrieden",
          state_id: "3455",
        },
        {
          id: "39569",
          name: "Opfikon",
          state_id: "3455",
        },
        {
          id: "39570",
          name: "Pfaffikon",
          state_id: "3455",
        },
        {
          id: "39571",
          name: "Rafz",
          state_id: "3455",
        },
        {
          id: "39572",
          name: "Regensdorf",
          state_id: "3455",
        },
        {
          id: "39573",
          name: "Richterswil",
          state_id: "3455",
        },
        {
          id: "39574",
          name: "Rumlang",
          state_id: "3455",
        },
        {
          id: "39575",
          name: "Ruschlikon",
          state_id: "3455",
        },
        {
          id: "39576",
          name: "Ruti",
          state_id: "3455",
        },
        {
          id: "39577",
          name: "Schlieren",
          state_id: "3455",
        },
        {
          id: "39578",
          name: "Schwerzenbach",
          state_id: "3455",
        },
        {
          id: "39579",
          name: "Seuzach",
          state_id: "3455",
        },
        {
          id: "39580",
          name: "Stafa",
          state_id: "3455",
        },
        {
          id: "39581",
          name: "Thalwil",
          state_id: "3455",
        },
        {
          id: "39582",
          name: "Uetikon",
          state_id: "3455",
        },
        {
          id: "39583",
          name: "Urdorf",
          state_id: "3455",
        },
        {
          id: "39584",
          name: "Uster",
          state_id: "3455",
        },
        {
          id: "39585",
          name: "Volketswil",
          state_id: "3455",
        },
        {
          id: "39586",
          name: "Wadenswil",
          state_id: "3455",
        },
        {
          id: "39587",
          name: "Wald",
          state_id: "3455",
        },
        {
          id: "39588",
          name: "Wallisellen",
          state_id: "3455",
        },
        {
          id: "39589",
          name: "Wangen-Bruttisellen",
          state_id: "3455",
        },
        {
          id: "39590",
          name: "Weiningen",
          state_id: "3455",
        },
        {
          id: "39591",
          name: "Wetzikon",
          state_id: "3455",
        },
        {
          id: "39592",
          name: "Winterthur",
          state_id: "3455",
        },
        {
          id: "39593",
          name: "Zell",
          state_id: "3455",
        },
        {
          id: "39594",
          name: "Zollikon",
          state_id: "3455",
        },
        {
          id: "39595",
          name: "Zumikon",
          state_id: "3455",
        },
        {
          id: "39596",
          name: "Zurich",
          state_id: "3455",
        },
      ],
    },
  },
  CI: {
    name: "Ivory Coast",
    native: "Côte d'Ivoire",
    phone: "225",
    continent: "AF",
    capital: "Yamoussoukro",
    currency: "XOF",
    languages: ["fr"],
    emoji: "🇨🇮",
    emojiU: "U+1F1E8 U+1F1EE",
    states: {
      Abidjan: [
        {
          id: "13849",
          name: "Marcory",
          state_id: "850",
        },
      ],
      Agneby: [
        {
          id: "13850",
          name: "Adzope",
          state_id: "851",
        },
        {
          id: "13851",
          name: "Affery",
          state_id: "851",
        },
        {
          id: "13852",
          name: "Agboville",
          state_id: "851",
        },
        {
          id: "13853",
          name: "Akoupe",
          state_id: "851",
        },
        {
          id: "13854",
          name: "Rubino",
          state_id: "851",
        },
      ],
      Bafing: [
        {
          id: "13855",
          name: "Touba",
          state_id: "852",
        },
      ],
      Denguele: [
        {
          id: "13856",
          name: "Bako",
          state_id: "853",
        },
        {
          id: "13857",
          name: "Odienne",
          state_id: "853",
        },
      ],
      "Dix-huit Montagnes": [],
      Fromager: [
        {
          id: "13858",
          name: "Gagnoa",
          state_id: "855",
        },
        {
          id: "13859",
          name: "Guiberoua",
          state_id: "855",
        },
        {
          id: "13860",
          name: "Hire",
          state_id: "855",
        },
        {
          id: "13861",
          name: "Ndouci",
          state_id: "855",
        },
        {
          id: "13862",
          name: "Oume",
          state_id: "855",
        },
        {
          id: "13863",
          name: "Ouragahio",
          state_id: "855",
        },
      ],
      "Haut-Sassandra": [
        {
          id: "13864",
          name: "Daloa",
          state_id: "856",
        },
        {
          id: "13865",
          name: "Issia",
          state_id: "856",
        },
        {
          id: "13866",
          name: "Vavoua",
          state_id: "856",
        },
      ],
      Lacs: [
        {
          id: "13867",
          name: "Ndiekro",
          state_id: "857",
        },
        {
          id: "13868",
          name: "Tiebissou",
          state_id: "857",
        },
        {
          id: "13869",
          name: "Toumodi",
          state_id: "857",
        },
        {
          id: "13870",
          name: "Yamoussoukro",
          state_id: "857",
        },
      ],
      Lagunes: [
        {
          id: "13871",
          name: "Abidjan",
          state_id: "858",
        },
        {
          id: "13872",
          name: "Alepe",
          state_id: "858",
        },
        {
          id: "13873",
          name: "Anyama",
          state_id: "858",
        },
        {
          id: "13874",
          name: "Bingerville",
          state_id: "858",
        },
        {
          id: "13875",
          name: "Dabou",
          state_id: "858",
        },
        {
          id: "13876",
          name: "Grand-Lahou",
          state_id: "858",
        },
        {
          id: "13877",
          name: "Jacqueville",
          state_id: "858",
        },
        {
          id: "13878",
          name: "Tiassale",
          state_id: "858",
        },
      ],
      Marahoue: [
        {
          id: "13879",
          name: "Bouafle",
          state_id: "859",
        },
        {
          id: "13880",
          name: "Sinfra",
          state_id: "859",
        },
        {
          id: "13881",
          name: "Zuenoula",
          state_id: "859",
        },
      ],
      "Moyen-Cavally": [
        {
          id: "13882",
          name: "Duekoue",
          state_id: "860",
        },
        {
          id: "13883",
          name: "Guiglo",
          state_id: "860",
        },
        {
          id: "13884",
          name: "Toulepleu",
          state_id: "860",
        },
      ],
      "Moyen-Comoe": [
        {
          id: "13885",
          name: "Abengourou",
          state_id: "861",
        },
        {
          id: "13886",
          name: "Agnibilekrou",
          state_id: "861",
        },
      ],
      "N''zi-Comoe": [
        {
          id: "13887",
          name: "Arrah",
          state_id: "862",
        },
        {
          id: "13888",
          name: "Bocanda",
          state_id: "862",
        },
        {
          id: "13889",
          name: "Bongouanou",
          state_id: "862",
        },
        {
          id: "13890",
          name: "Daoukro",
          state_id: "862",
        },
        {
          id: "13891",
          name: "Dimbokro",
          state_id: "862",
        },
        {
          id: "13892",
          name: "M''bahiakro",
          state_id: "862",
        },
        {
          id: "13893",
          name: "Mbatto",
          state_id: "862",
        },
        {
          id: "13894",
          name: "N''zi-Comoe",
          state_id: "862",
        },
      ],
      Sassandra: [
        {
          id: "13895",
          name: "San-Pedro",
          state_id: "863",
        },
        {
          id: "13896",
          name: "Sassandra",
          state_id: "863",
        },
        {
          id: "13897",
          name: "Soubre",
          state_id: "863",
        },
        {
          id: "13898",
          name: "Tabou",
          state_id: "863",
        },
      ],
      Savanes: [
        {
          id: "13899",
          name: "Boundiali",
          state_id: "864",
        },
        {
          id: "13900",
          name: "Dikodougou",
          state_id: "864",
        },
        {
          id: "13901",
          name: "Ferkessedougou",
          state_id: "864",
        },
        {
          id: "13902",
          name: "Korhogo",
          state_id: "864",
        },
        {
          id: "13903",
          name: "Tingrela",
          state_id: "864",
        },
      ],
      "Sud-Bandama": [
        {
          id: "13904",
          name: "Divo",
          state_id: "865",
        },
        {
          id: "13905",
          name: "Fresco",
          state_id: "865",
        },
        {
          id: "13906",
          name: "Lakota",
          state_id: "865",
        },
      ],
      "Sud-Comoe": [
        {
          id: "13907",
          name: "Aboisso",
          state_id: "866",
        },
        {
          id: "13908",
          name: "Adiake",
          state_id: "866",
        },
        {
          id: "13909",
          name: "Ayame",
          state_id: "866",
        },
        {
          id: "13910",
          name: "Bonoua",
          state_id: "866",
        },
        {
          id: "13911",
          name: "Grand Bassam",
          state_id: "866",
        },
      ],
      "Vallee du Bandama": [],
      Worodougou: [
        {
          id: "13912",
          name: "Kani",
          state_id: "868",
        },
        {
          id: "13913",
          name: "Mankono",
          state_id: "868",
        },
        {
          id: "13914",
          name: "Seguela",
          state_id: "868",
        },
      ],
      Zanzan: [
        {
          id: "13915",
          name: "Bondoukou",
          state_id: "869",
        },
        {
          id: "13916",
          name: "Bouna",
          state_id: "869",
        },
        {
          id: "13917",
          name: "Tanda",
          state_id: "869",
        },
      ],
    },
  },
  CK: {
    name: "Cook Islands",
    native: "Cook Islands",
    phone: "682",
    continent: "OC",
    capital: "Avarua",
    currency: "NZD",
    languages: ["en"],
    emoji: "🇨🇰",
    emojiU: "U+1F1E8 U+1F1F0",
    states: {
      Aitutaki: [
        {
          id: "13691",
          name: "Amuri",
          state_id: "832",
        },
      ],
      Atiu: [
        {
          id: "13692",
          name: "Atiu",
          state_id: "833",
        },
      ],
      Mangaia: [
        {
          id: "13693",
          name: "Mangaia",
          state_id: "834",
        },
      ],
      Manihiki: [
        {
          id: "13694",
          name: "Tauhunu",
          state_id: "835",
        },
      ],
      Mauke: [
        {
          id: "13695",
          name: "Mauke",
          state_id: "836",
        },
      ],
      Mitiaro: [
        {
          id: "13696",
          name: "Mitiaro",
          state_id: "837",
        },
      ],
      Nassau: [
        {
          id: "13697",
          name: "Nassau",
          state_id: "838",
        },
      ],
      Pukapuka: [
        {
          id: "13698",
          name: "Roto",
          state_id: "839",
        },
      ],
      Rakahanga: [
        {
          id: "13699",
          name: "Rakahanga",
          state_id: "840",
        },
      ],
      Rarotonga: [
        {
          id: "13700",
          name: "Avarua",
          state_id: "841",
        },
      ],
      Tongareva: [
        {
          id: "13701",
          name: "Omoka",
          state_id: "842",
        },
      ],
    },
  },
  CL: {
    name: "Chile",
    native: "Chile",
    phone: "56",
    continent: "SA",
    capital: "Santiago",
    currency: "CLF,CLP",
    languages: ["es"],
    emoji: "🇨🇱",
    emojiU: "U+1F1E8 U+1F1F1",
    states: {
      Aisen: [
        {
          id: "10956",
          name: "Aisen",
          state_id: "717",
        },
        {
          id: "10957",
          name: "Chile Chico",
          state_id: "717",
        },
        {
          id: "10958",
          name: "Cisnes",
          state_id: "717",
        },
        {
          id: "10959",
          name: "Cochrane",
          state_id: "717",
        },
        {
          id: "10960",
          name: "Coihaique",
          state_id: "717",
        },
        {
          id: "10961",
          name: "Guaitecas",
          state_id: "717",
        },
        {
          id: "10962",
          name: "Lago Verde",
          state_id: "717",
        },
        {
          id: "10963",
          name: "O''Higgins",
          state_id: "717",
        },
        {
          id: "10964",
          name: "Rio Ibanez",
          state_id: "717",
        },
        {
          id: "10965",
          name: "Tortel",
          state_id: "717",
        },
      ],
      Antofagasta: [
        {
          id: "10966",
          name: "Antofagasta",
          state_id: "718",
        },
        {
          id: "10967",
          name: "Calama",
          state_id: "718",
        },
        {
          id: "10968",
          name: "Maria Elena",
          state_id: "718",
        },
        {
          id: "10969",
          name: "Mejilones",
          state_id: "718",
        },
        {
          id: "10970",
          name: "Ollague",
          state_id: "718",
        },
        {
          id: "10971",
          name: "San Pedro de Atacama",
          state_id: "718",
        },
        {
          id: "10972",
          name: "Sierra Gorda",
          state_id: "718",
        },
        {
          id: "10973",
          name: "Taltal",
          state_id: "718",
        },
        {
          id: "10974",
          name: "Tocopilla",
          state_id: "718",
        },
      ],
      Araucania: [
        {
          id: "10975",
          name: "Angol",
          state_id: "719",
        },
        {
          id: "10976",
          name: "Carahue",
          state_id: "719",
        },
        {
          id: "10977",
          name: "Collipulli",
          state_id: "719",
        },
        {
          id: "10978",
          name: "Cunco",
          state_id: "719",
        },
        {
          id: "10979",
          name: "Curacautin",
          state_id: "719",
        },
        {
          id: "10980",
          name: "Curarrehue",
          state_id: "719",
        },
        {
          id: "10981",
          name: "Ercilla",
          state_id: "719",
        },
        {
          id: "10982",
          name: "Freire",
          state_id: "719",
        },
        {
          id: "10983",
          name: "Galvarino",
          state_id: "719",
        },
        {
          id: "10984",
          name: "Gorbea",
          state_id: "719",
        },
        {
          id: "10985",
          name: "Lautaro",
          state_id: "719",
        },
        {
          id: "10986",
          name: "Loncoche",
          state_id: "719",
        },
        {
          id: "10987",
          name: "Lonquimay",
          state_id: "719",
        },
        {
          id: "10988",
          name: "Los Sauces",
          state_id: "719",
        },
        {
          id: "10989",
          name: "Lumaco",
          state_id: "719",
        },
        {
          id: "10990",
          name: "Melipeuco",
          state_id: "719",
        },
        {
          id: "10991",
          name: "Nueva Imperial",
          state_id: "719",
        },
        {
          id: "10992",
          name: "Padre las Casas",
          state_id: "719",
        },
        {
          id: "10993",
          name: "Perquenco",
          state_id: "719",
        },
        {
          id: "10994",
          name: "Pitrufquen",
          state_id: "719",
        },
        {
          id: "10995",
          name: "Pucon",
          state_id: "719",
        },
        {
          id: "10996",
          name: "Puren",
          state_id: "719",
        },
        {
          id: "10997",
          name: "Renaico",
          state_id: "719",
        },
        {
          id: "10998",
          name: "Saavedra",
          state_id: "719",
        },
        {
          id: "10999",
          name: "Temuco",
          state_id: "719",
        },
        {
          id: "11000",
          name: "Teodoro Schmidt",
          state_id: "719",
        },
        {
          id: "11001",
          name: "Tolten",
          state_id: "719",
        },
        {
          id: "11002",
          name: "Traiguen",
          state_id: "719",
        },
        {
          id: "11003",
          name: "Victoria",
          state_id: "719",
        },
        {
          id: "11004",
          name: "Vilcun",
          state_id: "719",
        },
        {
          id: "11005",
          name: "Villarica",
          state_id: "719",
        },
      ],
      Atacama: [
        {
          id: "11006",
          name: "Alto del Carmen",
          state_id: "720",
        },
        {
          id: "11007",
          name: "Caldera",
          state_id: "720",
        },
        {
          id: "11008",
          name: "Chanaral",
          state_id: "720",
        },
        {
          id: "11009",
          name: "Copiapo",
          state_id: "720",
        },
        {
          id: "11010",
          name: "Diego de Almagro",
          state_id: "720",
        },
        {
          id: "11011",
          name: "Freirina",
          state_id: "720",
        },
        {
          id: "11012",
          name: "Huasco",
          state_id: "720",
        },
        {
          id: "11013",
          name: "Tierra Amarilla",
          state_id: "720",
        },
        {
          id: "11014",
          name: "Vallenar",
          state_id: "720",
        },
      ],
      "Bio Bio": [],
      Coquimbo: [
        {
          id: "11015",
          name: "Andacollo",
          state_id: "722",
        },
        {
          id: "11016",
          name: "Canela",
          state_id: "722",
        },
        {
          id: "11017",
          name: "Combarbala",
          state_id: "722",
        },
        {
          id: "11018",
          name: "Coquimbo",
          state_id: "722",
        },
        {
          id: "11019",
          name: "Illapel",
          state_id: "722",
        },
        {
          id: "11020",
          name: "La Higuera",
          state_id: "722",
        },
        {
          id: "11021",
          name: "La Serena",
          state_id: "722",
        },
        {
          id: "11022",
          name: "Los Vilos",
          state_id: "722",
        },
        {
          id: "11023",
          name: "Monte Patria",
          state_id: "722",
        },
        {
          id: "11024",
          name: "Ovalle",
          state_id: "722",
        },
        {
          id: "11025",
          name: "Paiguano",
          state_id: "722",
        },
        {
          id: "11026",
          name: "Punitaci",
          state_id: "722",
        },
        {
          id: "11027",
          name: "Rio Hurtado",
          state_id: "722",
        },
        {
          id: "11028",
          name: "Salamanca",
          state_id: "722",
        },
        {
          id: "11029",
          name: "Vicuna",
          state_id: "722",
        },
      ],
      "Libertador General Bernardo O": [],
      "Los Lagos": [],
      Magellanes: [
        {
          id: "11030",
          name: "Cabo de Horno",
          state_id: "725",
        },
        {
          id: "11031",
          name: "Laguna Blanca",
          state_id: "725",
        },
        {
          id: "11032",
          name: "Natales",
          state_id: "725",
        },
        {
          id: "11033",
          name: "Porvenir",
          state_id: "725",
        },
        {
          id: "11034",
          name: "Primavera",
          state_id: "725",
        },
        {
          id: "11035",
          name: "Punta Arenas",
          state_id: "725",
        },
        {
          id: "11036",
          name: "Rio Verde",
          state_id: "725",
        },
        {
          id: "11037",
          name: "San Gregorio",
          state_id: "725",
        },
        {
          id: "11038",
          name: "Timaukel",
          state_id: "725",
        },
        {
          id: "11039",
          name: "Torres del Paine",
          state_id: "725",
        },
      ],
      Maule: [
        {
          id: "11040",
          name: "Cauquenes",
          state_id: "726",
        },
        {
          id: "11041",
          name: "Chanco",
          state_id: "726",
        },
        {
          id: "11042",
          name: "Colbun",
          state_id: "726",
        },
        {
          id: "11043",
          name: "Constitucion",
          state_id: "726",
        },
        {
          id: "11044",
          name: "Curepto",
          state_id: "726",
        },
        {
          id: "11045",
          name: "Curico",
          state_id: "726",
        },
        {
          id: "11046",
          name: "Empedrado",
          state_id: "726",
        },
        {
          id: "11047",
          name: "Hualane",
          state_id: "726",
        },
        {
          id: "11048",
          name: "Licanten",
          state_id: "726",
        },
        {
          id: "11049",
          name: "Linares",
          state_id: "726",
        },
        {
          id: "11050",
          name: "Longavi",
          state_id: "726",
        },
        {
          id: "11051",
          name: "Maule",
          state_id: "726",
        },
        {
          id: "11052",
          name: "Molina",
          state_id: "726",
        },
        {
          id: "11053",
          name: "Parral",
          state_id: "726",
        },
        {
          id: "11054",
          name: "Pelarco",
          state_id: "726",
        },
        {
          id: "11055",
          name: "Pelluhue",
          state_id: "726",
        },
        {
          id: "11056",
          name: "Pencahue",
          state_id: "726",
        },
        {
          id: "11057",
          name: "Rauco",
          state_id: "726",
        },
        {
          id: "11058",
          name: "Retiro",
          state_id: "726",
        },
        {
          id: "11059",
          name: "Rio Claro",
          state_id: "726",
        },
        {
          id: "11060",
          name: "Romeral",
          state_id: "726",
        },
        {
          id: "11061",
          name: "Sagrada Familia",
          state_id: "726",
        },
        {
          id: "11062",
          name: "San Clemente",
          state_id: "726",
        },
        {
          id: "11063",
          name: "San Javier",
          state_id: "726",
        },
        {
          id: "11064",
          name: "San Rafael",
          state_id: "726",
        },
        {
          id: "11065",
          name: "Talca",
          state_id: "726",
        },
        {
          id: "11066",
          name: "Teno",
          state_id: "726",
        },
        {
          id: "11067",
          name: "Vichuquen",
          state_id: "726",
        },
        {
          id: "11068",
          name: "Villa Alegre",
          state_id: "726",
        },
        {
          id: "11069",
          name: "Yerbas Buenas",
          state_id: "726",
        },
      ],
      Metropolitana: [
        {
          id: "11070",
          name: "Alhue",
          state_id: "727",
        },
        {
          id: "11071",
          name: "Buin",
          state_id: "727",
        },
        {
          id: "11072",
          name: "Calera de Tango",
          state_id: "727",
        },
        {
          id: "11073",
          name: "Colina",
          state_id: "727",
        },
        {
          id: "11074",
          name: "Curacavi",
          state_id: "727",
        },
        {
          id: "11075",
          name: "El Monte",
          state_id: "727",
        },
        {
          id: "11076",
          name: "Isla de Maipo",
          state_id: "727",
        },
        {
          id: "11077",
          name: "Lampa",
          state_id: "727",
        },
        {
          id: "11078",
          name: "Maria Pinto",
          state_id: "727",
        },
        {
          id: "11079",
          name: "Melipilla",
          state_id: "727",
        },
        {
          id: "11080",
          name: "Padre Hurtado",
          state_id: "727",
        },
        {
          id: "11081",
          name: "Paine",
          state_id: "727",
        },
        {
          id: "11082",
          name: "Penaflor",
          state_id: "727",
        },
        {
          id: "11083",
          name: "Pirque",
          state_id: "727",
        },
        {
          id: "11084",
          name: "Puente Alto",
          state_id: "727",
        },
        {
          id: "11085",
          name: "Quilicura",
          state_id: "727",
        },
        {
          id: "11086",
          name: "San Bernardo",
          state_id: "727",
        },
        {
          id: "11087",
          name: "San Jose de Maipo",
          state_id: "727",
        },
        {
          id: "11088",
          name: "San Pedro",
          state_id: "727",
        },
        {
          id: "11089",
          name: "Santiago",
          state_id: "727",
        },
        {
          id: "11090",
          name: "Talagante",
          state_id: "727",
        },
        {
          id: "11091",
          name: "Tiltil",
          state_id: "727",
        },
      ],
      "Metropolitana de Santiago": [
        {
          id: "11092",
          name: "Alhue",
          state_id: "728",
        },
        {
          id: "11093",
          name: "Buin",
          state_id: "728",
        },
        {
          id: "11094",
          name: "Calera de Tango",
          state_id: "728",
        },
        {
          id: "11095",
          name: "Colina",
          state_id: "728",
        },
        {
          id: "11096",
          name: "Curacavi",
          state_id: "728",
        },
        {
          id: "11097",
          name: "El Monte",
          state_id: "728",
        },
        {
          id: "11098",
          name: "Isla de Maipo",
          state_id: "728",
        },
        {
          id: "11099",
          name: "Lampa",
          state_id: "728",
        },
        {
          id: "11100",
          name: "Maria Pinto",
          state_id: "728",
        },
        {
          id: "11101",
          name: "Melipilla",
          state_id: "728",
        },
        {
          id: "11102",
          name: "Padre Hurtado",
          state_id: "728",
        },
        {
          id: "11103",
          name: "Paine",
          state_id: "728",
        },
        {
          id: "11104",
          name: "Penaflor",
          state_id: "728",
        },
        {
          id: "11105",
          name: "Pirque",
          state_id: "728",
        },
        {
          id: "11106",
          name: "Puente Alto",
          state_id: "728",
        },
        {
          id: "11107",
          name: "Quilicura",
          state_id: "728",
        },
        {
          id: "11108",
          name: "San Bernardo",
          state_id: "728",
        },
        {
          id: "11109",
          name: "San Jose de Maipo",
          state_id: "728",
        },
        {
          id: "11110",
          name: "San Pedro",
          state_id: "728",
        },
        {
          id: "11111",
          name: "Santiago",
          state_id: "728",
        },
        {
          id: "11112",
          name: "Talagante",
          state_id: "728",
        },
        {
          id: "11113",
          name: "Tiltil",
          state_id: "728",
        },
      ],
      Tarapaca: [
        {
          id: "11114",
          name: "Arica",
          state_id: "729",
        },
        {
          id: "11115",
          name: "Camarones",
          state_id: "729",
        },
        {
          id: "11116",
          name: "Camina",
          state_id: "729",
        },
        {
          id: "11117",
          name: "Colchane",
          state_id: "729",
        },
        {
          id: "11118",
          name: "General Lagos",
          state_id: "729",
        },
        {
          id: "11119",
          name: "Huara",
          state_id: "729",
        },
        {
          id: "11120",
          name: "Iquique",
          state_id: "729",
        },
        {
          id: "11121",
          name: "Pica",
          state_id: "729",
        },
        {
          id: "11122",
          name: "Pozo Almonte",
          state_id: "729",
        },
        {
          id: "11123",
          name: "Putre",
          state_id: "729",
        },
      ],
      Valparaiso: [
        {
          id: "11124",
          name: "Algarrobo",
          state_id: "730",
        },
        {
          id: "11125",
          name: "Cabildo",
          state_id: "730",
        },
        {
          id: "11126",
          name: "Calera",
          state_id: "730",
        },
        {
          id: "11127",
          name: "Calle Larga",
          state_id: "730",
        },
        {
          id: "11128",
          name: "Cartagena",
          state_id: "730",
        },
        {
          id: "11129",
          name: "Casablanca",
          state_id: "730",
        },
        {
          id: "11130",
          name: "Catemu",
          state_id: "730",
        },
        {
          id: "11131",
          name: "Concon",
          state_id: "730",
        },
        {
          id: "11132",
          name: "El Quisco",
          state_id: "730",
        },
        {
          id: "11133",
          name: "El Tabo",
          state_id: "730",
        },
        {
          id: "11134",
          name: "Hijuelas",
          state_id: "730",
        },
        {
          id: "11135",
          name: "La Cruz",
          state_id: "730",
        },
        {
          id: "11136",
          name: "La Ligua",
          state_id: "730",
        },
        {
          id: "11137",
          name: "Limache",
          state_id: "730",
        },
        {
          id: "11138",
          name: "Llaillay",
          state_id: "730",
        },
        {
          id: "11139",
          name: "Los Andes",
          state_id: "730",
        },
        {
          id: "11140",
          name: "Nogales",
          state_id: "730",
        },
        {
          id: "11141",
          name: "Olmue",
          state_id: "730",
        },
        {
          id: "11142",
          name: "Panquehue",
          state_id: "730",
        },
        {
          id: "11143",
          name: "Papudo",
          state_id: "730",
        },
        {
          id: "11144",
          name: "Petorca",
          state_id: "730",
        },
        {
          id: "11145",
          name: "Puchuncavi",
          state_id: "730",
        },
        {
          id: "11146",
          name: "Putaendeo",
          state_id: "730",
        },
        {
          id: "11147",
          name: "Quillota",
          state_id: "730",
        },
        {
          id: "11148",
          name: "Quilpue",
          state_id: "730",
        },
        {
          id: "11149",
          name: "Quintero",
          state_id: "730",
        },
        {
          id: "11150",
          name: "Rinconada",
          state_id: "730",
        },
        {
          id: "11151",
          name: "San Antonio",
          state_id: "730",
        },
        {
          id: "11152",
          name: "San Esteban",
          state_id: "730",
        },
        {
          id: "11153",
          name: "San Felipe",
          state_id: "730",
        },
        {
          id: "11154",
          name: "Santa Maria",
          state_id: "730",
        },
        {
          id: "11155",
          name: "Santo Domingo",
          state_id: "730",
        },
        {
          id: "11156",
          name: "Valparaiso",
          state_id: "730",
        },
        {
          id: "11157",
          name: "Villa Alemana",
          state_id: "730",
        },
        {
          id: "11158",
          name: "Vina del Mar",
          state_id: "730",
        },
        {
          id: "11159",
          name: "Zapallar",
          state_id: "730",
        },
      ],
    },
  },
  CM: {
    name: "Cameroon",
    native: "Cameroon",
    phone: "237",
    continent: "AF",
    capital: "Yaoundé",
    currency: "XAF",
    languages: ["en", "fr"],
    emoji: "🇨🇲",
    emojiU: "U+1F1E8 U+1F1F2",
    states: {
      Adamaoua: [
        {
          id: "10013",
          name: "Banyo",
          state_id: "653",
        },
        {
          id: "10014",
          name: "Meiganga",
          state_id: "653",
        },
        {
          id: "10015",
          name: "Ngaoundere",
          state_id: "653",
        },
        {
          id: "10016",
          name: "Tibati",
          state_id: "653",
        },
        {
          id: "10017",
          name: "Tignere",
          state_id: "653",
        },
      ],
      Centre: [
        {
          id: "10018",
          name: "Akonolinga",
          state_id: "654",
        },
        {
          id: "10019",
          name: "Bafia",
          state_id: "654",
        },
        {
          id: "10020",
          name: "Eseka",
          state_id: "654",
        },
        {
          id: "10021",
          name: "Mbalmayo",
          state_id: "654",
        },
        {
          id: "10022",
          name: "Mfou",
          state_id: "654",
        },
        {
          id: "10023",
          name: "Monatele",
          state_id: "654",
        },
        {
          id: "10024",
          name: "Nanga Eboko",
          state_id: "654",
        },
        {
          id: "10025",
          name: "Obala",
          state_id: "654",
        },
        {
          id: "10026",
          name: "Ombesa",
          state_id: "654",
        },
        {
          id: "10027",
          name: "Saa",
          state_id: "654",
        },
        {
          id: "10028",
          name: "Yaounde",
          state_id: "654",
        },
      ],
      Est: [
        {
          id: "10029",
          name: "Abong Mbang",
          state_id: "655",
        },
        {
          id: "10030",
          name: "Batouri",
          state_id: "655",
        },
        {
          id: "10031",
          name: "Bertoua",
          state_id: "655",
        },
        {
          id: "10032",
          name: "Betare Oya",
          state_id: "655",
        },
        {
          id: "10033",
          name: "Djoum",
          state_id: "655",
        },
        {
          id: "10034",
          name: "Doume",
          state_id: "655",
        },
        {
          id: "10035",
          name: "Lomie",
          state_id: "655",
        },
        {
          id: "10036",
          name: "Yokadouma",
          state_id: "655",
        },
      ],
      Littoral: [
        {
          id: "10037",
          name: "Bonaberi",
          state_id: "656",
        },
        {
          id: "10038",
          name: "Dibombari",
          state_id: "656",
        },
        {
          id: "10039",
          name: "Douala",
          state_id: "656",
        },
        {
          id: "10040",
          name: "Edea",
          state_id: "656",
        },
        {
          id: "10041",
          name: "Loum",
          state_id: "656",
        },
        {
          id: "10042",
          name: "Manjo",
          state_id: "656",
        },
        {
          id: "10043",
          name: "Mbanga",
          state_id: "656",
        },
        {
          id: "10044",
          name: "Nkongsamba",
          state_id: "656",
        },
        {
          id: "10045",
          name: "Yabassi",
          state_id: "656",
        },
      ],
      Nord: [
        {
          id: "10046",
          name: "Figuif",
          state_id: "657",
        },
        {
          id: "10047",
          name: "Garoua",
          state_id: "657",
        },
        {
          id: "10048",
          name: "Guider",
          state_id: "657",
        },
        {
          id: "10049",
          name: "Lagdo",
          state_id: "657",
        },
        {
          id: "10050",
          name: "Poli",
          state_id: "657",
        },
        {
          id: "10051",
          name: "Rey Bouba",
          state_id: "657",
        },
        {
          id: "10052",
          name: "Tchollire",
          state_id: "657",
        },
      ],
      "Nord Extreme": [
        {
          id: "10053",
          name: "Figuif",
          state_id: "658",
        },
        {
          id: "10054",
          name: "Garoua",
          state_id: "658",
        },
        {
          id: "10055",
          name: "Guider",
          state_id: "658",
        },
        {
          id: "10056",
          name: "Lagdo",
          state_id: "658",
        },
        {
          id: "10057",
          name: "Poli",
          state_id: "658",
        },
        {
          id: "10058",
          name: "Rey Bouba",
          state_id: "658",
        },
        {
          id: "10059",
          name: "Tchollire",
          state_id: "658",
        },
      ],
      Nordouest: [
        {
          id: "10060",
          name: "Bamenda",
          state_id: "659",
        },
        {
          id: "10061",
          name: "Kumbo",
          state_id: "659",
        },
        {
          id: "10062",
          name: "Mbengwi",
          state_id: "659",
        },
        {
          id: "10063",
          name: "Mme",
          state_id: "659",
        },
        {
          id: "10064",
          name: "Njinikom",
          state_id: "659",
        },
        {
          id: "10065",
          name: "Nkambe",
          state_id: "659",
        },
        {
          id: "10066",
          name: "Wum",
          state_id: "659",
        },
      ],
      Ouest: [
        {
          id: "10067",
          name: "Bafang",
          state_id: "660",
        },
        {
          id: "10068",
          name: "Bafoussam",
          state_id: "660",
        },
        {
          id: "10069",
          name: "Bafut",
          state_id: "660",
        },
        {
          id: "10070",
          name: "Bali",
          state_id: "660",
        },
        {
          id: "10071",
          name: "Bana",
          state_id: "660",
        },
        {
          id: "10072",
          name: "Bangangte",
          state_id: "660",
        },
        {
          id: "10073",
          name: "Djang",
          state_id: "660",
        },
        {
          id: "10074",
          name: "Fontem",
          state_id: "660",
        },
        {
          id: "10075",
          name: "Foumban",
          state_id: "660",
        },
        {
          id: "10076",
          name: "Foumbot",
          state_id: "660",
        },
        {
          id: "10077",
          name: "Mbouda",
          state_id: "660",
        },
      ],
      Sud: [
        {
          id: "10078",
          name: "Akom",
          state_id: "661",
        },
        {
          id: "10079",
          name: "Ambam",
          state_id: "661",
        },
        {
          id: "10080",
          name: "Ebolowa",
          state_id: "661",
        },
        {
          id: "10081",
          name: "Kribi",
          state_id: "661",
        },
        {
          id: "10082",
          name: "Lolodorf",
          state_id: "661",
        },
        {
          id: "10083",
          name: "Moloundou",
          state_id: "661",
        },
        {
          id: "10084",
          name: "Mvangue",
          state_id: "661",
        },
        {
          id: "10085",
          name: "Sangmelima",
          state_id: "661",
        },
      ],
      Sudouest: [
        {
          id: "10086",
          name: "Buea",
          state_id: "662",
        },
        {
          id: "10087",
          name: "Idenao",
          state_id: "662",
        },
        {
          id: "10088",
          name: "Kumba",
          state_id: "662",
        },
        {
          id: "10089",
          name: "Limbe",
          state_id: "662",
        },
        {
          id: "10090",
          name: "Mamfe",
          state_id: "662",
        },
        {
          id: "10091",
          name: "Muyuka",
          state_id: "662",
        },
        {
          id: "10092",
          name: "Tiko",
          state_id: "662",
        },
      ],
    },
  },
  CN: {
    name: "China",
    native: "中国",
    phone: "86",
    continent: "AS",
    capital: "Beijing",
    currency: "CNY",
    languages: ["zh"],
    emoji: "🇨🇳",
    emojiU: "U+1F1E8 U+1F1F3",
    states: {
      Anhui: [
        {
          id: "11160",
          name: "Fengyang",
          state_id: "731",
        },
        {
          id: "11161",
          name: "Guangde",
          state_id: "731",
        },
        {
          id: "11162",
          name: "Liuan",
          state_id: "731",
        },
        {
          id: "11163",
          name: "Ningguo",
          state_id: "731",
        },
        {
          id: "11164",
          name: "Shucheng",
          state_id: "731",
        },
        {
          id: "11165",
          name: "Xinchang",
          state_id: "731",
        },
        {
          id: "11166",
          name: "Xuancheng",
          state_id: "731",
        },
      ],
      "Anhui Province": [
        {
          id: "11167",
          name: "Fengyang",
          state_id: "732",
        },
        {
          id: "11168",
          name: "Guangde",
          state_id: "732",
        },
        {
          id: "11169",
          name: "Liuan",
          state_id: "732",
        },
        {
          id: "11170",
          name: "Ningguo",
          state_id: "732",
        },
        {
          id: "11171",
          name: "Shucheng",
          state_id: "732",
        },
        {
          id: "11172",
          name: "Xinchang",
          state_id: "732",
        },
        {
          id: "11173",
          name: "Xuancheng",
          state_id: "732",
        },
      ],
      "Anhui Sheng": [
        {
          id: "11174",
          name: "Fengyang",
          state_id: "733",
        },
        {
          id: "11175",
          name: "Guangde",
          state_id: "733",
        },
        {
          id: "11176",
          name: "Liuan",
          state_id: "733",
        },
        {
          id: "11177",
          name: "Ningguo",
          state_id: "733",
        },
        {
          id: "11178",
          name: "Shucheng",
          state_id: "733",
        },
        {
          id: "11179",
          name: "Xinchang",
          state_id: "733",
        },
        {
          id: "11180",
          name: "Xuancheng",
          state_id: "733",
        },
      ],
      Aomen: [
        {
          id: "11181",
          name: "Aomen",
          state_id: "734",
        },
      ],
      Beijing: [
        {
          id: "11182",
          name: "Beijing",
          state_id: "735",
        },
        {
          id: "11183",
          name: "Changping",
          state_id: "735",
        },
        {
          id: "11184",
          name: "Fangshan",
          state_id: "735",
        },
        {
          id: "11185",
          name: "Huangcun",
          state_id: "735",
        },
        {
          id: "11186",
          name: "Liangxiang",
          state_id: "735",
        },
        {
          id: "11187",
          name: "Mentougou",
          state_id: "735",
        },
        {
          id: "11188",
          name: "Shunyi",
          state_id: "735",
        },
        {
          id: "11189",
          name: "Tongzhou",
          state_id: "735",
        },
      ],
      "Beijing Shi": [
        {
          id: "11190",
          name: "Beijing",
          state_id: "736",
        },
        {
          id: "11191",
          name: "Changping",
          state_id: "736",
        },
        {
          id: "11192",
          name: "Fangshan",
          state_id: "736",
        },
        {
          id: "11193",
          name: "Huangcun",
          state_id: "736",
        },
        {
          id: "11194",
          name: "Liangxiang",
          state_id: "736",
        },
        {
          id: "11195",
          name: "Mentougou",
          state_id: "736",
        },
        {
          id: "11196",
          name: "Shunyi",
          state_id: "736",
        },
        {
          id: "11197",
          name: "Tongzhou",
          state_id: "736",
        },
      ],
      Chongqing: [
        {
          id: "11198",
          name: "Beibei",
          state_id: "737",
        },
        {
          id: "11199",
          name: "Chongqing",
          state_id: "737",
        },
        {
          id: "11200",
          name: "Fuling",
          state_id: "737",
        },
        {
          id: "11201",
          name: "Longhua",
          state_id: "737",
        },
        {
          id: "11202",
          name: "Nantongkuang",
          state_id: "737",
        },
        {
          id: "11203",
          name: "Wanxian",
          state_id: "737",
        },
        {
          id: "11204",
          name: "Xiuma",
          state_id: "737",
        },
        {
          id: "11205",
          name: "Yubei",
          state_id: "737",
        },
        {
          id: "11206",
          name: "Yudong",
          state_id: "737",
        },
      ],
      Fujian: [
        {
          id: "11207",
          name: "Bantou",
          state_id: "738",
        },
        {
          id: "11208",
          name: "Dongshan",
          state_id: "738",
        },
        {
          id: "11209",
          name: "Fuan",
          state_id: "738",
        },
        {
          id: "11210",
          name: "Fujian",
          state_id: "738",
        },
        {
          id: "11211",
          name: "Fuqing",
          state_id: "738",
        },
        {
          id: "11212",
          name: "Fuzhou",
          state_id: "738",
        },
        {
          id: "11213",
          name: "Gantou",
          state_id: "738",
        },
        {
          id: "11214",
          name: "Hanyang",
          state_id: "738",
        },
        {
          id: "11215",
          name: "Jiangkou",
          state_id: "738",
        },
        {
          id: "11216",
          name: "Jiaocheng",
          state_id: "738",
        },
        {
          id: "11217",
          name: "Jinjiang",
          state_id: "738",
        },
        {
          id: "11218",
          name: "Jinshang",
          state_id: "738",
        },
        {
          id: "11219",
          name: "Longhai",
          state_id: "738",
        },
        {
          id: "11220",
          name: "Longyan",
          state_id: "738",
        },
        {
          id: "11221",
          name: "Luoyang",
          state_id: "738",
        },
        {
          id: "11222",
          name: "Nanan",
          state_id: "738",
        },
        {
          id: "11223",
          name: "Nanping",
          state_id: "738",
        },
        {
          id: "11224",
          name: "Nanpu",
          state_id: "738",
        },
        {
          id: "11225",
          name: "Putian",
          state_id: "738",
        },
        {
          id: "11226",
          name: "Qingyang",
          state_id: "738",
        },
        {
          id: "11227",
          name: "Quanzhou",
          state_id: "738",
        },
        {
          id: "11228",
          name: "Rongcheng",
          state_id: "738",
        },
        {
          id: "11229",
          name: "Sanming",
          state_id: "738",
        },
        {
          id: "11230",
          name: "Shaowu",
          state_id: "738",
        },
        {
          id: "11231",
          name: "Shima",
          state_id: "738",
        },
        {
          id: "11232",
          name: "Shishi",
          state_id: "738",
        },
        {
          id: "11233",
          name: "Tantou",
          state_id: "738",
        },
        {
          id: "11234",
          name: "Tongshan",
          state_id: "738",
        },
        {
          id: "11235",
          name: "Xiamen",
          state_id: "738",
        },
        {
          id: "11236",
          name: "Xiapu",
          state_id: "738",
        },
        {
          id: "11237",
          name: "Xiapu Ningde",
          state_id: "738",
        },
        {
          id: "11238",
          name: "Ximei",
          state_id: "738",
        },
        {
          id: "11239",
          name: "Yongan",
          state_id: "738",
        },
        {
          id: "11240",
          name: "Zhangzhou",
          state_id: "738",
        },
        {
          id: "11241",
          name: "Zhicheng",
          state_id: "738",
        },
      ],
      "Fujian Sheng": [
        {
          id: "11242",
          name: "Bantou",
          state_id: "739",
        },
        {
          id: "11243",
          name: "Dongshan",
          state_id: "739",
        },
        {
          id: "11244",
          name: "Fuan",
          state_id: "739",
        },
        {
          id: "11245",
          name: "Fujian",
          state_id: "739",
        },
        {
          id: "11246",
          name: "Fuqing",
          state_id: "739",
        },
        {
          id: "11247",
          name: "Fuzhou",
          state_id: "739",
        },
        {
          id: "11248",
          name: "Gantou",
          state_id: "739",
        },
        {
          id: "11249",
          name: "Hanyang",
          state_id: "739",
        },
        {
          id: "11250",
          name: "Jiangkou",
          state_id: "739",
        },
        {
          id: "11251",
          name: "Jiaocheng",
          state_id: "739",
        },
        {
          id: "11252",
          name: "Jinjiang",
          state_id: "739",
        },
        {
          id: "11253",
          name: "Jinshang",
          state_id: "739",
        },
        {
          id: "11254",
          name: "Longhai",
          state_id: "739",
        },
        {
          id: "11255",
          name: "Longyan",
          state_id: "739",
        },
        {
          id: "11256",
          name: "Luoyang",
          state_id: "739",
        },
        {
          id: "11257",
          name: "Nanan",
          state_id: "739",
        },
        {
          id: "11258",
          name: "Nanping",
          state_id: "739",
        },
        {
          id: "11259",
          name: "Nanpu",
          state_id: "739",
        },
        {
          id: "11260",
          name: "Putian",
          state_id: "739",
        },
        {
          id: "11261",
          name: "Qingyang",
          state_id: "739",
        },
        {
          id: "11262",
          name: "Quanzhou",
          state_id: "739",
        },
        {
          id: "11263",
          name: "Rongcheng",
          state_id: "739",
        },
        {
          id: "11264",
          name: "Sanming",
          state_id: "739",
        },
        {
          id: "11265",
          name: "Shaowu",
          state_id: "739",
        },
        {
          id: "11266",
          name: "Shima",
          state_id: "739",
        },
        {
          id: "11267",
          name: "Shishi",
          state_id: "739",
        },
        {
          id: "11268",
          name: "Tantou",
          state_id: "739",
        },
        {
          id: "11269",
          name: "Tongshan",
          state_id: "739",
        },
        {
          id: "11270",
          name: "Xiamen",
          state_id: "739",
        },
        {
          id: "11271",
          name: "Xiapu",
          state_id: "739",
        },
        {
          id: "11272",
          name: "Xiapu Ningde",
          state_id: "739",
        },
        {
          id: "11273",
          name: "Ximei",
          state_id: "739",
        },
        {
          id: "11274",
          name: "Yongan",
          state_id: "739",
        },
        {
          id: "11275",
          name: "Zhangzhou",
          state_id: "739",
        },
        {
          id: "11276",
          name: "Zhicheng",
          state_id: "739",
        },
      ],
      Gansu: [
        {
          id: "11277",
          name: "Baiyin",
          state_id: "740",
        },
        {
          id: "11278",
          name: "Baoji",
          state_id: "740",
        },
        {
          id: "11279",
          name: "Beidao",
          state_id: "740",
        },
        {
          id: "11280",
          name: "Jiayuguan",
          state_id: "740",
        },
        {
          id: "11281",
          name: "Jinchang",
          state_id: "740",
        },
        {
          id: "11282",
          name: "Jiuquan",
          state_id: "740",
        },
        {
          id: "11283",
          name: "Lanzhou",
          state_id: "740",
        },
        {
          id: "11284",
          name: "Linxia",
          state_id: "740",
        },
        {
          id: "11285",
          name: "Pingliang",
          state_id: "740",
        },
        {
          id: "11286",
          name: "Qincheng",
          state_id: "740",
        },
        {
          id: "11287",
          name: "Wuwei",
          state_id: "740",
        },
        {
          id: "11288",
          name: "Yaojie",
          state_id: "740",
        },
        {
          id: "11289",
          name: "Yumen",
          state_id: "740",
        },
        {
          id: "11290",
          name: "Zhangye",
          state_id: "740",
        },
        {
          id: "11291",
          name: "Zhuanglang",
          state_id: "740",
        },
      ],
      Guangdong: [
        {
          id: "11292",
          name: "Anbu",
          state_id: "741",
        },
        {
          id: "11293",
          name: "Chaozhou",
          state_id: "741",
        },
        {
          id: "11294",
          name: "Chenghai",
          state_id: "741",
        },
        {
          id: "11295",
          name: "Chuncheng",
          state_id: "741",
        },
        {
          id: "11296",
          name: "Daliang",
          state_id: "741",
        },
        {
          id: "11297",
          name: "Danshui",
          state_id: "741",
        },
        {
          id: "11298",
          name: "Dongguan",
          state_id: "741",
        },
        {
          id: "11299",
          name: "Donghai",
          state_id: "741",
        },
        {
          id: "11300",
          name: "Dongli",
          state_id: "741",
        },
        {
          id: "11301",
          name: "Dongzhen",
          state_id: "741",
        },
        {
          id: "11302",
          name: "Ducheng",
          state_id: "741",
        },
        {
          id: "11303",
          name: "Encheng",
          state_id: "741",
        },
        {
          id: "11304",
          name: "Foahn",
          state_id: "741",
        },
        {
          id: "11305",
          name: "Foshan",
          state_id: "741",
        },
        {
          id: "11306",
          name: "Gaozhou",
          state_id: "741",
        },
        {
          id: "11307",
          name: "Guangdong",
          state_id: "741",
        },
        {
          id: "11308",
          name: "Guangzhou",
          state_id: "741",
        },
        {
          id: "11309",
          name: "Guanjiao",
          state_id: "741",
        },
        {
          id: "11310",
          name: "Haicheng",
          state_id: "741",
        },
        {
          id: "11311",
          name: "Haimen",
          state_id: "741",
        },
        {
          id: "11312",
          name: "Hepo",
          state_id: "741",
        },
        {
          id: "11313",
          name: "Houpu",
          state_id: "741",
        },
        {
          id: "11314",
          name: "Huaicheng",
          state_id: "741",
        },
        {
          id: "11315",
          name: "Huanggang",
          state_id: "741",
        },
        {
          id: "11316",
          name: "Huangpu",
          state_id: "741",
        },
        {
          id: "11317",
          name: "Huazhou",
          state_id: "741",
        },
        {
          id: "11318",
          name: "Huicheng",
          state_id: "741",
        },
        {
          id: "11319",
          name: "Huizhou",
          state_id: "741",
        },
        {
          id: "11320",
          name: "Humen",
          state_id: "741",
        },
        {
          id: "11321",
          name: "Jiangmen",
          state_id: "741",
        },
        {
          id: "11322",
          name: "Jiazi",
          state_id: "741",
        },
        {
          id: "11323",
          name: "Jieshi",
          state_id: "741",
        },
        {
          id: "11324",
          name: "Jieyang",
          state_id: "741",
        },
        {
          id: "11325",
          name: "Lecheng",
          state_id: "741",
        },
        {
          id: "11326",
          name: "Leicheng",
          state_id: "741",
        },
        {
          id: "11327",
          name: "Liancheng",
          state_id: "741",
        },
        {
          id: "11328",
          name: "Lianzhou",
          state_id: "741",
        },
        {
          id: "11329",
          name: "Licheng",
          state_id: "741",
        },
        {
          id: "11330",
          name: "Liusha",
          state_id: "741",
        },
        {
          id: "11331",
          name: "Longgang",
          state_id: "741",
        },
        {
          id: "11332",
          name: "Lubu",
          state_id: "741",
        },
        {
          id: "11333",
          name: "Luocheng",
          state_id: "741",
        },
        {
          id: "11334",
          name: "Luohu",
          state_id: "741",
        },
        {
          id: "11335",
          name: "Luoyang",
          state_id: "741",
        },
        {
          id: "11336",
          name: "Maba",
          state_id: "741",
        },
        {
          id: "11337",
          name: "Maoming",
          state_id: "741",
        },
        {
          id: "11338",
          name: "Mata",
          state_id: "741",
        },
        {
          id: "11339",
          name: "Meilu",
          state_id: "741",
        },
        {
          id: "11340",
          name: "Meizhou",
          state_id: "741",
        },
        {
          id: "11341",
          name: "Mianchang",
          state_id: "741",
        },
        {
          id: "11342",
          name: "Nanfeng",
          state_id: "741",
        },
        {
          id: "11343",
          name: "Nanhai",
          state_id: "741",
        },
        {
          id: "11344",
          name: "Pingshan",
          state_id: "741",
        },
        {
          id: "11345",
          name: "Qingtang",
          state_id: "741",
        },
        {
          id: "11346",
          name: "Qingyuan",
          state_id: "741",
        },
        {
          id: "11347",
          name: "Rongcheng",
          state_id: "741",
        },
        {
          id: "11348",
          name: "Sanbu",
          state_id: "741",
        },
        {
          id: "11349",
          name: "Shantou",
          state_id: "741",
        },
        {
          id: "11350",
          name: "Shanwei",
          state_id: "741",
        },
        {
          id: "11351",
          name: "Shaoguan",
          state_id: "741",
        },
        {
          id: "11352",
          name: "Shaping",
          state_id: "741",
        },
        {
          id: "11353",
          name: "Shenzhen",
          state_id: "741",
        },
        {
          id: "11354",
          name: "Shilong",
          state_id: "741",
        },
        {
          id: "11355",
          name: "Shiqiao",
          state_id: "741",
        },
        {
          id: "11356",
          name: "Shiwan",
          state_id: "741",
        },
        {
          id: "11357",
          name: "Shuizhai",
          state_id: "741",
        },
        {
          id: "11358",
          name: "Shunde",
          state_id: "741",
        },
        {
          id: "11359",
          name: "Suicheng",
          state_id: "741",
        },
        {
          id: "11360",
          name: "Taicheng",
          state_id: "741",
        },
        {
          id: "11361",
          name: "Tangping",
          state_id: "741",
        },
        {
          id: "11362",
          name: "Xiaolan",
          state_id: "741",
        },
        {
          id: "11363",
          name: "Xinan",
          state_id: "741",
        },
        {
          id: "11364",
          name: "Xingcheng",
          state_id: "741",
        },
        {
          id: "11365",
          name: "Xiongzhou",
          state_id: "741",
        },
        {
          id: "11366",
          name: "Xucheng",
          state_id: "741",
        },
        {
          id: "11367",
          name: "Yangjiang",
          state_id: "741",
        },
        {
          id: "11368",
          name: "Yingcheng",
          state_id: "741",
        },
        {
          id: "11369",
          name: "Yuancheng",
          state_id: "741",
        },
        {
          id: "11370",
          name: "Yuncheng",
          state_id: "741",
        },
        {
          id: "11371",
          name: "Yunfu",
          state_id: "741",
        },
        {
          id: "11372",
          name: "Zengcheng",
          state_id: "741",
        },
        {
          id: "11373",
          name: "Zhanjiang",
          state_id: "741",
        },
        {
          id: "11374",
          name: "Zhaoqing",
          state_id: "741",
        },
        {
          id: "11375",
          name: "Zhilong",
          state_id: "741",
        },
        {
          id: "11376",
          name: "Zhongshan",
          state_id: "741",
        },
        {
          id: "11377",
          name: "Zhuhai",
          state_id: "741",
        },
      ],
      "Guangdong Sheng": [
        {
          id: "11378",
          name: "Anbu",
          state_id: "742",
        },
        {
          id: "11379",
          name: "Chaozhou",
          state_id: "742",
        },
        {
          id: "11380",
          name: "Chenghai",
          state_id: "742",
        },
        {
          id: "11381",
          name: "Chuncheng",
          state_id: "742",
        },
        {
          id: "11382",
          name: "Daliang",
          state_id: "742",
        },
        {
          id: "11383",
          name: "Danshui",
          state_id: "742",
        },
        {
          id: "11384",
          name: "Dongguan",
          state_id: "742",
        },
        {
          id: "11385",
          name: "Donghai",
          state_id: "742",
        },
        {
          id: "11386",
          name: "Dongli",
          state_id: "742",
        },
        {
          id: "11387",
          name: "Dongzhen",
          state_id: "742",
        },
        {
          id: "11388",
          name: "Ducheng",
          state_id: "742",
        },
        {
          id: "11389",
          name: "Encheng",
          state_id: "742",
        },
        {
          id: "11390",
          name: "Foahn",
          state_id: "742",
        },
        {
          id: "11391",
          name: "Foshan",
          state_id: "742",
        },
        {
          id: "11392",
          name: "Gaozhou",
          state_id: "742",
        },
        {
          id: "11393",
          name: "Guangdong",
          state_id: "742",
        },
        {
          id: "11394",
          name: "Guangzhou",
          state_id: "742",
        },
        {
          id: "11395",
          name: "Guanjiao",
          state_id: "742",
        },
        {
          id: "11396",
          name: "Haicheng",
          state_id: "742",
        },
        {
          id: "11397",
          name: "Haimen",
          state_id: "742",
        },
        {
          id: "11398",
          name: "Hepo",
          state_id: "742",
        },
        {
          id: "11399",
          name: "Houpu",
          state_id: "742",
        },
        {
          id: "11400",
          name: "Huaicheng",
          state_id: "742",
        },
        {
          id: "11401",
          name: "Huanggang",
          state_id: "742",
        },
        {
          id: "11402",
          name: "Huangpu",
          state_id: "742",
        },
        {
          id: "11403",
          name: "Huazhou",
          state_id: "742",
        },
        {
          id: "11404",
          name: "Huicheng",
          state_id: "742",
        },
        {
          id: "11405",
          name: "Huizhou",
          state_id: "742",
        },
        {
          id: "11406",
          name: "Humen",
          state_id: "742",
        },
        {
          id: "11407",
          name: "Jiangmen",
          state_id: "742",
        },
        {
          id: "11408",
          name: "Jiazi",
          state_id: "742",
        },
        {
          id: "11409",
          name: "Jieshi",
          state_id: "742",
        },
        {
          id: "11410",
          name: "Jieyang",
          state_id: "742",
        },
        {
          id: "11411",
          name: "Lecheng",
          state_id: "742",
        },
        {
          id: "11412",
          name: "Leicheng",
          state_id: "742",
        },
        {
          id: "11413",
          name: "Liancheng",
          state_id: "742",
        },
        {
          id: "11414",
          name: "Lianzhou",
          state_id: "742",
        },
        {
          id: "11415",
          name: "Licheng",
          state_id: "742",
        },
        {
          id: "11416",
          name: "Liusha",
          state_id: "742",
        },
        {
          id: "11417",
          name: "Longgang",
          state_id: "742",
        },
        {
          id: "11418",
          name: "Lubu",
          state_id: "742",
        },
        {
          id: "11419",
          name: "Luocheng",
          state_id: "742",
        },
        {
          id: "11420",
          name: "Luohu",
          state_id: "742",
        },
        {
          id: "11421",
          name: "Luoyang",
          state_id: "742",
        },
        {
          id: "11422",
          name: "Maba",
          state_id: "742",
        },
        {
          id: "11423",
          name: "Maoming",
          state_id: "742",
        },
        {
          id: "11424",
          name: "Mata",
          state_id: "742",
        },
        {
          id: "11425",
          name: "Meilu",
          state_id: "742",
        },
        {
          id: "11426",
          name: "Meizhou",
          state_id: "742",
        },
        {
          id: "11427",
          name: "Mianchang",
          state_id: "742",
        },
        {
          id: "11428",
          name: "Nanfeng",
          state_id: "742",
        },
        {
          id: "11429",
          name: "Nanhai",
          state_id: "742",
        },
        {
          id: "11430",
          name: "Pingshan",
          state_id: "742",
        },
        {
          id: "11431",
          name: "Qingtang",
          state_id: "742",
        },
        {
          id: "11432",
          name: "Qingyuan",
          state_id: "742",
        },
        {
          id: "11433",
          name: "Rongcheng",
          state_id: "742",
        },
        {
          id: "11434",
          name: "Sanbu",
          state_id: "742",
        },
        {
          id: "11435",
          name: "Shantou",
          state_id: "742",
        },
        {
          id: "11436",
          name: "Shanwei",
          state_id: "742",
        },
        {
          id: "11437",
          name: "Shaoguan",
          state_id: "742",
        },
        {
          id: "11438",
          name: "Shaping",
          state_id: "742",
        },
        {
          id: "11439",
          name: "Shenzhen",
          state_id: "742",
        },
        {
          id: "11440",
          name: "Shilong",
          state_id: "742",
        },
        {
          id: "11441",
          name: "Shiqiao",
          state_id: "742",
        },
        {
          id: "11442",
          name: "Shiwan",
          state_id: "742",
        },
        {
          id: "11443",
          name: "Shuizhai",
          state_id: "742",
        },
        {
          id: "11444",
          name: "Shunde",
          state_id: "742",
        },
        {
          id: "11445",
          name: "Suicheng",
          state_id: "742",
        },
        {
          id: "11446",
          name: "Taicheng",
          state_id: "742",
        },
        {
          id: "11447",
          name: "Tangping",
          state_id: "742",
        },
        {
          id: "11448",
          name: "Xiaolan",
          state_id: "742",
        },
        {
          id: "11449",
          name: "Xinan",
          state_id: "742",
        },
        {
          id: "11450",
          name: "Xingcheng",
          state_id: "742",
        },
        {
          id: "11451",
          name: "Xiongzhou",
          state_id: "742",
        },
        {
          id: "11452",
          name: "Xucheng",
          state_id: "742",
        },
        {
          id: "11453",
          name: "Yangjiang",
          state_id: "742",
        },
        {
          id: "11454",
          name: "Yingcheng",
          state_id: "742",
        },
        {
          id: "11455",
          name: "Yuancheng",
          state_id: "742",
        },
        {
          id: "11456",
          name: "Yuncheng",
          state_id: "742",
        },
        {
          id: "11457",
          name: "Yunfu",
          state_id: "742",
        },
        {
          id: "11458",
          name: "Zengcheng",
          state_id: "742",
        },
        {
          id: "11459",
          name: "Zhanjiang",
          state_id: "742",
        },
        {
          id: "11460",
          name: "Zhaoqing",
          state_id: "742",
        },
        {
          id: "11461",
          name: "Zhilong",
          state_id: "742",
        },
        {
          id: "11462",
          name: "Zhongshan",
          state_id: "742",
        },
        {
          id: "11463",
          name: "Zhuhai",
          state_id: "742",
        },
      ],
      Guangxi: [
        {
          id: "11464",
          name: "Babu",
          state_id: "743",
        },
        {
          id: "11465",
          name: "Baihe",
          state_id: "743",
        },
        {
          id: "11466",
          name: "Baise",
          state_id: "743",
        },
        {
          id: "11467",
          name: "Beihai",
          state_id: "743",
        },
        {
          id: "11468",
          name: "Binzhou",
          state_id: "743",
        },
        {
          id: "11469",
          name: "Bose",
          state_id: "743",
        },
        {
          id: "11470",
          name: "Fangchenggang",
          state_id: "743",
        },
        {
          id: "11471",
          name: "Guicheng",
          state_id: "743",
        },
        {
          id: "11472",
          name: "Guilin",
          state_id: "743",
        },
        {
          id: "11473",
          name: "Guiping",
          state_id: "743",
        },
        {
          id: "11474",
          name: "Jinchengjiang",
          state_id: "743",
        },
        {
          id: "11475",
          name: "Jinji",
          state_id: "743",
        },
        {
          id: "11476",
          name: "Laibin",
          state_id: "743",
        },
        {
          id: "11477",
          name: "Lianzhou",
          state_id: "743",
        },
        {
          id: "11478",
          name: "Liuzhou",
          state_id: "743",
        },
        {
          id: "11479",
          name: "Luorong",
          state_id: "743",
        },
        {
          id: "11480",
          name: "Matong",
          state_id: "743",
        },
        {
          id: "11481",
          name: "Nandu",
          state_id: "743",
        },
        {
          id: "11482",
          name: "Nanning",
          state_id: "743",
        },
        {
          id: "11483",
          name: "Pingnan",
          state_id: "743",
        },
        {
          id: "11484",
          name: "Pumiao",
          state_id: "743",
        },
        {
          id: "11485",
          name: "Qinzhou",
          state_id: "743",
        },
        {
          id: "11486",
          name: "Songhua",
          state_id: "743",
        },
        {
          id: "11487",
          name: "Wuzhou",
          state_id: "743",
        },
        {
          id: "11488",
          name: "Yashan",
          state_id: "743",
        },
        {
          id: "11489",
          name: "Yulin",
          state_id: "743",
        },
      ],
      Guizhou: [
        {
          id: "11490",
          name: "Anshun",
          state_id: "744",
        },
        {
          id: "11491",
          name: "Bijie",
          state_id: "744",
        },
        {
          id: "11492",
          name: "Caohai",
          state_id: "744",
        },
        {
          id: "11493",
          name: "Duyun",
          state_id: "744",
        },
        {
          id: "11494",
          name: "Guiyang",
          state_id: "744",
        },
        {
          id: "11495",
          name: "Kaili",
          state_id: "744",
        },
        {
          id: "11496",
          name: "Liupanshui",
          state_id: "744",
        },
        {
          id: "11497",
          name: "Luoyang",
          state_id: "744",
        },
        {
          id: "11498",
          name: "Pingzhai",
          state_id: "744",
        },
        {
          id: "11499",
          name: "Tongren",
          state_id: "744",
        },
        {
          id: "11500",
          name: "Tongzi",
          state_id: "744",
        },
        {
          id: "11501",
          name: "Xiaoweizhai",
          state_id: "744",
        },
        {
          id: "11502",
          name: "Xingyi",
          state_id: "744",
        },
        {
          id: "11503",
          name: "Zunyi",
          state_id: "744",
        },
      ],
      Hainan: [
        {
          id: "11504",
          name: "Chengmai",
          state_id: "745",
        },
        {
          id: "11505",
          name: "Dingan",
          state_id: "745",
        },
        {
          id: "11506",
          name: "Haikou",
          state_id: "745",
        },
        {
          id: "11507",
          name: "Lingao",
          state_id: "745",
        },
        {
          id: "11508",
          name: "Qiongshan",
          state_id: "745",
        },
        {
          id: "11509",
          name: "Sansha",
          state_id: "745",
        },
        {
          id: "11510",
          name: "Sanya",
          state_id: "745",
        },
        {
          id: "11511",
          name: "Wanning",
          state_id: "745",
        },
      ],
      Hebei: [
        {
          id: "11512",
          name: "Anping",
          state_id: "746",
        },
        {
          id: "11513",
          name: "Baoding",
          state_id: "746",
        },
        {
          id: "11514",
          name: "Botou",
          state_id: "746",
        },
        {
          id: "11515",
          name: "Cangzhou",
          state_id: "746",
        },
        {
          id: "11516",
          name: "Changli",
          state_id: "746",
        },
        {
          id: "11517",
          name: "Chengde",
          state_id: "746",
        },
        {
          id: "11518",
          name: "Dingzhou",
          state_id: "746",
        },
        {
          id: "11519",
          name: "Fengfeng",
          state_id: "746",
        },
        {
          id: "11520",
          name: "Fengrun",
          state_id: "746",
        },
        {
          id: "11521",
          name: "Guye",
          state_id: "746",
        },
        {
          id: "11522",
          name: "Handan",
          state_id: "746",
        },
        {
          id: "11523",
          name: "Hebei",
          state_id: "746",
        },
        {
          id: "11524",
          name: "Hecun",
          state_id: "746",
        },
        {
          id: "11525",
          name: "Hejian",
          state_id: "746",
        },
        {
          id: "11526",
          name: "Hengshui",
          state_id: "746",
        },
        {
          id: "11527",
          name: "Huanghua",
          state_id: "746",
        },
        {
          id: "11528",
          name: "Jingxingkuang",
          state_id: "746",
        },
        {
          id: "11529",
          name: "Jinzhou",
          state_id: "746",
        },
        {
          id: "11530",
          name: "Langfang",
          state_id: "746",
        },
        {
          id: "11531",
          name: "Lianzhou",
          state_id: "746",
        },
        {
          id: "11532",
          name: "Linshui",
          state_id: "746",
        },
        {
          id: "11533",
          name: "Linxi",
          state_id: "746",
        },
        {
          id: "11534",
          name: "Longyao County",
          state_id: "746",
        },
        {
          id: "11535",
          name: "Nangong",
          state_id: "746",
        },
        {
          id: "11536",
          name: "Pengcheng",
          state_id: "746",
        },
        {
          id: "11537",
          name: "Qinhuangdao",
          state_id: "746",
        },
        {
          id: "11538",
          name: "Renqiu",
          state_id: "746",
        },
        {
          id: "11539",
          name: "Shahe",
          state_id: "746",
        },
        {
          id: "11540",
          name: "Shijiazhuang",
          state_id: "746",
        },
        {
          id: "11541",
          name: "Tangjiazhuang",
          state_id: "746",
        },
        {
          id: "11542",
          name: "Tangshan",
          state_id: "746",
        },
        {
          id: "11543",
          name: "Wuan",
          state_id: "746",
        },
        {
          id: "11544",
          name: "Xian County",
          state_id: "746",
        },
        {
          id: "11545",
          name: "Xingtai",
          state_id: "746",
        },
        {
          id: "11546",
          name: "Xinji",
          state_id: "746",
        },
        {
          id: "11547",
          name: "Xinle",
          state_id: "746",
        },
        {
          id: "11548",
          name: "Xuanhua",
          state_id: "746",
        },
        {
          id: "11549",
          name: "Zhangjiakou",
          state_id: "746",
        },
        {
          id: "11550",
          name: "Zhaogezhuang",
          state_id: "746",
        },
        {
          id: "11551",
          name: "Zhuozhou",
          state_id: "746",
        },
      ],
      Heilongjiang: [
        {
          id: "11552",
          name: "Acheng",
          state_id: "747",
        },
        {
          id: "11553",
          name: "Anda",
          state_id: "747",
        },
        {
          id: "11554",
          name: "Angangxi",
          state_id: "747",
        },
        {
          id: "11555",
          name: "Baiquan",
          state_id: "747",
        },
        {
          id: "11556",
          name: "Bamiantong",
          state_id: "747",
        },
        {
          id: "11557",
          name: "Baoqing",
          state_id: "747",
        },
        {
          id: "11558",
          name: "Baoshan",
          state_id: "747",
        },
        {
          id: "11559",
          name: "Bayan",
          state_id: "747",
        },
        {
          id: "11560",
          name: "Beian",
          state_id: "747",
        },
        {
          id: "11561",
          name: "Binzhou",
          state_id: "747",
        },
        {
          id: "11562",
          name: "Boli",
          state_id: "747",
        },
        {
          id: "11563",
          name: "Chaihe",
          state_id: "747",
        },
        {
          id: "11564",
          name: "Chengzihe",
          state_id: "747",
        },
        {
          id: "11565",
          name: "Cuiluan",
          state_id: "747",
        },
        {
          id: "11566",
          name: "Daqing",
          state_id: "747",
        },
        {
          id: "11567",
          name: "Didao",
          state_id: "747",
        },
        {
          id: "11568",
          name: "Dongning",
          state_id: "747",
        },
        {
          id: "11569",
          name: "Fujin",
          state_id: "747",
        },
        {
          id: "11570",
          name: "Fuli",
          state_id: "747",
        },
        {
          id: "11571",
          name: "Fulitun",
          state_id: "747",
        },
        {
          id: "11572",
          name: "Fuyu",
          state_id: "747",
        },
        {
          id: "11573",
          name: "Gannan",
          state_id: "747",
        },
        {
          id: "11574",
          name: "Hailin",
          state_id: "747",
        },
        {
          id: "11575",
          name: "Hailun",
          state_id: "747",
        },
        {
          id: "11576",
          name: "Harbin",
          state_id: "747",
        },
        {
          id: "11577",
          name: "Hegang",
          state_id: "747",
        },
        {
          id: "11578",
          name: "Heihe",
          state_id: "747",
        },
        {
          id: "11579",
          name: "Hengshan",
          state_id: "747",
        },
        {
          id: "11580",
          name: "Honggang",
          state_id: "747",
        },
        {
          id: "11581",
          name: "Huanan",
          state_id: "747",
        },
        {
          id: "11582",
          name: "Hulan",
          state_id: "747",
        },
        {
          id: "11583",
          name: "Hulan Ergi",
          state_id: "747",
        },
        {
          id: "11584",
          name: "Jiamusi",
          state_id: "747",
        },
        {
          id: "11585",
          name: "Jidong",
          state_id: "747",
        },
        {
          id: "11586",
          name: "Jixi",
          state_id: "747",
        },
        {
          id: "11587",
          name: "Keshan",
          state_id: "747",
        },
        {
          id: "11588",
          name: "Langxiang",
          state_id: "747",
        },
        {
          id: "11589",
          name: "Lanxi",
          state_id: "747",
        },
        {
          id: "11590",
          name: "Lingdong",
          state_id: "747",
        },
        {
          id: "11591",
          name: "Linkou",
          state_id: "747",
        },
        {
          id: "11592",
          name: "Lishu",
          state_id: "747",
        },
        {
          id: "11593",
          name: "Longfeng",
          state_id: "747",
        },
        {
          id: "11594",
          name: "Longjiang",
          state_id: "747",
        },
        {
          id: "11595",
          name: "Mingshui",
          state_id: "747",
        },
        {
          id: "11596",
          name: "Mishan",
          state_id: "747",
        },
        {
          id: "11597",
          name: "Mudanjiang",
          state_id: "747",
        },
        {
          id: "11598",
          name: "Nancha",
          state_id: "747",
        },
        {
          id: "11599",
          name: "Nehe",
          state_id: "747",
        },
        {
          id: "11600",
          name: "Nenjiang",
          state_id: "747",
        },
        {
          id: "11601",
          name: "Nianzishan",
          state_id: "747",
        },
        {
          id: "11602",
          name: "Ningan",
          state_id: "747",
        },
        {
          id: "11603",
          name: "Qingan",
          state_id: "747",
        },
        {
          id: "11604",
          name: "Qinggang",
          state_id: "747",
        },
        {
          id: "11605",
          name: "Qiqihar",
          state_id: "747",
        },
        {
          id: "11606",
          name: "Qitaihe",
          state_id: "747",
        },
        {
          id: "11607",
          name: "Ranghulu",
          state_id: "747",
        },
        {
          id: "11608",
          name: "Saertu",
          state_id: "747",
        },
        {
          id: "11609",
          name: "Shangzhi",
          state_id: "747",
        },
        {
          id: "11610",
          name: "Shanhetun",
          state_id: "747",
        },
        {
          id: "11611",
          name: "Shuangcheng",
          state_id: "747",
        },
        {
          id: "11612",
          name: "Shuangyashan",
          state_id: "747",
        },
        {
          id: "11613",
          name: "Sifantan",
          state_id: "747",
        },
        {
          id: "11614",
          name: "Suifenhe",
          state_id: "747",
        },
        {
          id: "11615",
          name: "Suihua",
          state_id: "747",
        },
        {
          id: "11616",
          name: "Suileng",
          state_id: "747",
        },
        {
          id: "11617",
          name: "Tahe",
          state_id: "747",
        },
        {
          id: "11618",
          name: "Taikang",
          state_id: "747",
        },
        {
          id: "11619",
          name: "Tailai",
          state_id: "747",
        },
        {
          id: "11620",
          name: "Tieli",
          state_id: "747",
        },
        {
          id: "11621",
          name: "Wangkui",
          state_id: "747",
        },
        {
          id: "11622",
          name: "Weihe",
          state_id: "747",
        },
        {
          id: "11623",
          name: "Wuchang",
          state_id: "747",
        },
        {
          id: "11624",
          name: "Xinglongzhen",
          state_id: "747",
        },
        {
          id: "11625",
          name: "Xinqing",
          state_id: "747",
        },
        {
          id: "11626",
          name: "Yian",
          state_id: "747",
        },
        {
          id: "11627",
          name: "Yichun",
          state_id: "747",
        },
        {
          id: "11628",
          name: "Yilan",
          state_id: "747",
        },
        {
          id: "11629",
          name: "Youhao",
          state_id: "747",
        },
        {
          id: "11630",
          name: "Zhaodong",
          state_id: "747",
        },
        {
          id: "11631",
          name: "Zhaoyuan",
          state_id: "747",
        },
        {
          id: "11632",
          name: "Zhaozhou",
          state_id: "747",
        },
      ],
      Henan: [
        {
          id: "11633",
          name: "Anyang",
          state_id: "748",
        },
        {
          id: "11634",
          name: "Changying",
          state_id: "748",
        },
        {
          id: "11635",
          name: "Dancheng",
          state_id: "748",
        },
        {
          id: "11636",
          name: "Daokou",
          state_id: "748",
        },
        {
          id: "11637",
          name: "Dengzhou",
          state_id: "748",
        },
        {
          id: "11638",
          name: "Gongyi",
          state_id: "748",
        },
        {
          id: "11639",
          name: "Gushi",
          state_id: "748",
        },
        {
          id: "11640",
          name: "Hebi",
          state_id: "748",
        },
        {
          id: "11641",
          name: "Huaidian",
          state_id: "748",
        },
        {
          id: "11642",
          name: "Huangchuan",
          state_id: "748",
        },
        {
          id: "11643",
          name: "Huangzhai",
          state_id: "748",
        },
        {
          id: "11644",
          name: "Jiaozuo",
          state_id: "748",
        },
        {
          id: "11645",
          name: "Jishui",
          state_id: "748",
        },
        {
          id: "11646",
          name: "Kaifeng",
          state_id: "748",
        },
        {
          id: "11647",
          name: "Liupen",
          state_id: "748",
        },
        {
          id: "11648",
          name: "Luohe",
          state_id: "748",
        },
        {
          id: "11649",
          name: "Luoyang",
          state_id: "748",
        },
        {
          id: "11650",
          name: "Luyang",
          state_id: "748",
        },
        {
          id: "11651",
          name: "Mengzhou",
          state_id: "748",
        },
        {
          id: "11652",
          name: "Minggang",
          state_id: "748",
        },
        {
          id: "11653",
          name: "Nandun",
          state_id: "748",
        },
        {
          id: "11654",
          name: "Nanyang",
          state_id: "748",
        },
        {
          id: "11655",
          name: "Pingdingshan",
          state_id: "748",
        },
        {
          id: "11656",
          name: "Puyang",
          state_id: "748",
        },
        {
          id: "11657",
          name: "Sanmenxia",
          state_id: "748",
        },
        {
          id: "11658",
          name: "Shangqiu",
          state_id: "748",
        },
        {
          id: "11659",
          name: "Tanghe",
          state_id: "748",
        },
        {
          id: "11660",
          name: "Xiaoyi",
          state_id: "748",
        },
        {
          id: "11661",
          name: "Xihua",
          state_id: "748",
        },
        {
          id: "11662",
          name: "Xinxiang",
          state_id: "748",
        },
        {
          id: "11663",
          name: "Xinyang",
          state_id: "748",
        },
        {
          id: "11664",
          name: "Xinye",
          state_id: "748",
        },
        {
          id: "11665",
          name: "Xixiang",
          state_id: "748",
        },
        {
          id: "11666",
          name: "Xuanwu",
          state_id: "748",
        },
        {
          id: "11667",
          name: "Xuchang",
          state_id: "748",
        },
        {
          id: "11668",
          name: "Yigou",
          state_id: "748",
        },
        {
          id: "11669",
          name: "Yima",
          state_id: "748",
        },
        {
          id: "11670",
          name: "Yinzhuang",
          state_id: "748",
        },
        {
          id: "11671",
          name: "Yunyang",
          state_id: "748",
        },
        {
          id: "11672",
          name: "Yuzhou",
          state_id: "748",
        },
        {
          id: "11673",
          name: "Zhecheng",
          state_id: "748",
        },
        {
          id: "11674",
          name: "Zhengzhou",
          state_id: "748",
        },
        {
          id: "11675",
          name: "Zhenping",
          state_id: "748",
        },
        {
          id: "11676",
          name: "Zhoukou",
          state_id: "748",
        },
        {
          id: "11677",
          name: "Zhumadian",
          state_id: "748",
        },
      ],
      Hubei: [
        {
          id: "11678",
          name: "Anlu",
          state_id: "749",
        },
        {
          id: "11679",
          name: "Baisha",
          state_id: "749",
        },
        {
          id: "11680",
          name: "Buhe",
          state_id: "749",
        },
        {
          id: "11681",
          name: "Caidian",
          state_id: "749",
        },
        {
          id: "11682",
          name: "Caohe",
          state_id: "749",
        },
        {
          id: "11683",
          name: "Danjiangkou",
          state_id: "749",
        },
        {
          id: "11684",
          name: "Daye",
          state_id: "749",
        },
        {
          id: "11685",
          name: "Duobao",
          state_id: "749",
        },
        {
          id: "11686",
          name: "Enshi",
          state_id: "749",
        },
        {
          id: "11687",
          name: "Ezhou",
          state_id: "749",
        },
        {
          id: "11688",
          name: "Fengkou",
          state_id: "749",
        },
        {
          id: "11689",
          name: "Guangshui",
          state_id: "749",
        },
        {
          id: "11690",
          name: "Gucheng",
          state_id: "749",
        },
        {
          id: "11691",
          name: "Hanchuan",
          state_id: "749",
        },
        {
          id: "11692",
          name: "Hongan",
          state_id: "749",
        },
        {
          id: "11693",
          name: "Honghu",
          state_id: "749",
        },
        {
          id: "11694",
          name: "Huangmei",
          state_id: "749",
        },
        {
          id: "11695",
          name: "Huangpi",
          state_id: "749",
        },
        {
          id: "11696",
          name: "Huangshi",
          state_id: "749",
        },
        {
          id: "11697",
          name: "Huangzhou",
          state_id: "749",
        },
        {
          id: "11698",
          name: "Jingmen",
          state_id: "749",
        },
        {
          id: "11699",
          name: "Jingzhou",
          state_id: "749",
        },
        {
          id: "11700",
          name: "Laohekou",
          state_id: "749",
        },
        {
          id: "11701",
          name: "Lichuan",
          state_id: "749",
        },
        {
          id: "11702",
          name: "Macheng",
          state_id: "749",
        },
        {
          id: "11703",
          name: "Nanhai",
          state_id: "749",
        },
        {
          id: "11704",
          name: "Nanzhang",
          state_id: "749",
        },
        {
          id: "11705",
          name: "Puqi",
          state_id: "749",
        },
        {
          id: "11706",
          name: "Qianjiang",
          state_id: "749",
        },
        {
          id: "11707",
          name: "Qingquan",
          state_id: "749",
        },
        {
          id: "11708",
          name: "Qixingtai",
          state_id: "749",
        },
        {
          id: "11709",
          name: "Rongcheng",
          state_id: "749",
        },
        {
          id: "11710",
          name: "Shashi",
          state_id: "749",
        },
        {
          id: "11711",
          name: "Shishou",
          state_id: "749",
        },
        {
          id: "11712",
          name: "Shiyan",
          state_id: "749",
        },
        {
          id: "11713",
          name: "Suizhou",
          state_id: "749",
        },
        {
          id: "11714",
          name: "Tianmen",
          state_id: "749",
        },
        {
          id: "11715",
          name: "Tongcheng",
          state_id: "749",
        },
        {
          id: "11716",
          name: "Wuhan",
          state_id: "749",
        },
        {
          id: "11717",
          name: "Wuxue",
          state_id: "749",
        },
        {
          id: "11718",
          name: "Xiangfan",
          state_id: "749",
        },
        {
          id: "11719",
          name: "Xianning",
          state_id: "749",
        },
        {
          id: "11720",
          name: "Xiantao",
          state_id: "749",
        },
        {
          id: "11721",
          name: "Xiaogan",
          state_id: "749",
        },
        {
          id: "11722",
          name: "Xiaoxita",
          state_id: "749",
        },
        {
          id: "11723",
          name: "Xiaxindian",
          state_id: "749",
        },
        {
          id: "11724",
          name: "Xihe",
          state_id: "749",
        },
        {
          id: "11725",
          name: "Xinpu",
          state_id: "749",
        },
        {
          id: "11726",
          name: "Xinshi",
          state_id: "749",
        },
        {
          id: "11727",
          name: "Xinzhou",
          state_id: "749",
        },
        {
          id: "11728",
          name: "Yichang",
          state_id: "749",
        },
        {
          id: "11729",
          name: "Yicheng",
          state_id: "749",
        },
        {
          id: "11730",
          name: "Yingcheng",
          state_id: "749",
        },
        {
          id: "11731",
          name: "Yingzhong",
          state_id: "749",
        },
        {
          id: "11732",
          name: "Zaoyang",
          state_id: "749",
        },
        {
          id: "11733",
          name: "Zhengchang",
          state_id: "749",
        },
        {
          id: "11734",
          name: "Zhicheng",
          state_id: "749",
        },
        {
          id: "11735",
          name: "Zhifang",
          state_id: "749",
        },
        {
          id: "11736",
          name: "Zhongxiang",
          state_id: "749",
        },
      ],
      Hunan: [
        {
          id: "11737",
          name: "Anjiang",
          state_id: "750",
        },
        {
          id: "11738",
          name: "Anxiang",
          state_id: "750",
        },
        {
          id: "11739",
          name: "Changde",
          state_id: "750",
        },
        {
          id: "11740",
          name: "Changsha",
          state_id: "750",
        },
        {
          id: "11741",
          name: "Chenzhou",
          state_id: "750",
        },
        {
          id: "11742",
          name: "Dayong",
          state_id: "750",
        },
        {
          id: "11743",
          name: "Hengyang",
          state_id: "750",
        },
        {
          id: "11744",
          name: "Hongjiang",
          state_id: "750",
        },
        {
          id: "11745",
          name: "Huaihua",
          state_id: "750",
        },
        {
          id: "11746",
          name: "Jinshi",
          state_id: "750",
        },
        {
          id: "11747",
          name: "Jishou",
          state_id: "750",
        },
        {
          id: "11748",
          name: "Leiyang",
          state_id: "750",
        },
        {
          id: "11749",
          name: "Lengshuijiang",
          state_id: "750",
        },
        {
          id: "11750",
          name: "Lengshuitan",
          state_id: "750",
        },
        {
          id: "11751",
          name: "Lianyuan",
          state_id: "750",
        },
        {
          id: "11752",
          name: "Liling",
          state_id: "750",
        },
        {
          id: "11753",
          name: "Liuyang",
          state_id: "750",
        },
        {
          id: "11754",
          name: "Loudi",
          state_id: "750",
        },
        {
          id: "11755",
          name: "Matian",
          state_id: "750",
        },
        {
          id: "11756",
          name: "Nanzhou",
          state_id: "750",
        },
        {
          id: "11757",
          name: "Ningxiang",
          state_id: "750",
        },
        {
          id: "11758",
          name: "Qidong",
          state_id: "750",
        },
        {
          id: "11759",
          name: "Qiyang",
          state_id: "750",
        },
        {
          id: "11760",
          name: "Shaoyang",
          state_id: "750",
        },
        {
          id: "11761",
          name: "Xiangtan",
          state_id: "750",
        },
        {
          id: "11762",
          name: "Xiangxiang",
          state_id: "750",
        },
        {
          id: "11763",
          name: "Xiangyin",
          state_id: "750",
        },
        {
          id: "11764",
          name: "Xinhua",
          state_id: "750",
        },
        {
          id: "11765",
          name: "Yiyang",
          state_id: "750",
        },
        {
          id: "11766",
          name: "Yongfeng",
          state_id: "750",
        },
        {
          id: "11767",
          name: "Yongzhou",
          state_id: "750",
        },
        {
          id: "11768",
          name: "Yuanjiang",
          state_id: "750",
        },
        {
          id: "11769",
          name: "Yueyang",
          state_id: "750",
        },
        {
          id: "11770",
          name: "Zhuzhou",
          state_id: "750",
        },
      ],
      Jiangsu: [
        {
          id: "11771",
          name: "Baoying",
          state_id: "751",
        },
        {
          id: "11772",
          name: "Changzhou",
          state_id: "751",
        },
        {
          id: "11773",
          name: "Dachang",
          state_id: "751",
        },
        {
          id: "11774",
          name: "Dafeng",
          state_id: "751",
        },
        {
          id: "11775",
          name: "Danyang",
          state_id: "751",
        },
        {
          id: "11776",
          name: "Dingshu",
          state_id: "751",
        },
        {
          id: "11777",
          name: "Dongkan",
          state_id: "751",
        },
        {
          id: "11778",
          name: "Dongtai",
          state_id: "751",
        },
        {
          id: "11779",
          name: "Fengxian",
          state_id: "751",
        },
        {
          id: "11780",
          name: "Gaogou",
          state_id: "751",
        },
        {
          id: "11781",
          name: "Gaoyou",
          state_id: "751",
        },
        {
          id: "11782",
          name: "Guiren",
          state_id: "751",
        },
        {
          id: "11783",
          name: "Haian",
          state_id: "751",
        },
        {
          id: "11784",
          name: "Haizhou",
          state_id: "751",
        },
        {
          id: "11785",
          name: "Hede",
          state_id: "751",
        },
        {
          id: "11786",
          name: "Huaicheng",
          state_id: "751",
        },
        {
          id: "11787",
          name: "Huaiyin",
          state_id: "751",
        },
        {
          id: "11788",
          name: "Huilong",
          state_id: "751",
        },
        {
          id: "11789",
          name: "Hutang",
          state_id: "751",
        },
        {
          id: "11790",
          name: "Jiangdu",
          state_id: "751",
        },
        {
          id: "11791",
          name: "Jiangyan",
          state_id: "751",
        },
        {
          id: "11792",
          name: "Jiangyin",
          state_id: "751",
        },
        {
          id: "11793",
          name: "Jiangyuan",
          state_id: "751",
        },
        {
          id: "11794",
          name: "Jianhu",
          state_id: "751",
        },
        {
          id: "11795",
          name: "Jingcheng",
          state_id: "751",
        },
        {
          id: "11796",
          name: "Jinsha",
          state_id: "751",
        },
        {
          id: "11797",
          name: "Jintan",
          state_id: "751",
        },
        {
          id: "11798",
          name: "Juegang",
          state_id: "751",
        },
        {
          id: "11799",
          name: "Jurong",
          state_id: "751",
        },
        {
          id: "11800",
          name: "Kunshan",
          state_id: "751",
        },
        {
          id: "11801",
          name: "Lianyungang",
          state_id: "751",
        },
        {
          id: "11802",
          name: "Liucheng",
          state_id: "751",
        },
        {
          id: "11803",
          name: "Liyang",
          state_id: "751",
        },
        {
          id: "11804",
          name: "Luodu",
          state_id: "751",
        },
        {
          id: "11805",
          name: "Mudu",
          state_id: "751",
        },
        {
          id: "11806",
          name: "Nanjing",
          state_id: "751",
        },
        {
          id: "11807",
          name: "Nantong",
          state_id: "751",
        },
        {
          id: "11808",
          name: "Pecheng",
          state_id: "751",
        },
        {
          id: "11809",
          name: "Pukou",
          state_id: "751",
        },
        {
          id: "11810",
          name: "Qidong",
          state_id: "751",
        },
        {
          id: "11811",
          name: "Qinnan",
          state_id: "751",
        },
        {
          id: "11812",
          name: "Qixia",
          state_id: "751",
        },
        {
          id: "11813",
          name: "Rucheng",
          state_id: "751",
        },
        {
          id: "11814",
          name: "Songling",
          state_id: "751",
        },
        {
          id: "11815",
          name: "Sucheng",
          state_id: "751",
        },
        {
          id: "11816",
          name: "Suicheng",
          state_id: "751",
        },
        {
          id: "11817",
          name: "Suqian",
          state_id: "751",
        },
        {
          id: "11818",
          name: "Suzhou",
          state_id: "751",
        },
        {
          id: "11819",
          name: "Taicang",
          state_id: "751",
        },
        {
          id: "11820",
          name: "Taixing",
          state_id: "751",
        },
        {
          id: "11821",
          name: "Wujiang",
          state_id: "751",
        },
        {
          id: "11822",
          name: "Wuxi",
          state_id: "751",
        },
        {
          id: "11823",
          name: "Xiaolingwei",
          state_id: "751",
        },
        {
          id: "11824",
          name: "Xiaoshi",
          state_id: "751",
        },
        {
          id: "11825",
          name: "Xinan",
          state_id: "751",
        },
        {
          id: "11826",
          name: "Xinpu",
          state_id: "751",
        },
        {
          id: "11827",
          name: "Xuzhou",
          state_id: "751",
        },
        {
          id: "11828",
          name: "Yancheng",
          state_id: "751",
        },
        {
          id: "11829",
          name: "Yangshe",
          state_id: "751",
        },
        {
          id: "11830",
          name: "Yangzhou",
          state_id: "751",
        },
        {
          id: "11831",
          name: "Yizheng",
          state_id: "751",
        },
        {
          id: "11832",
          name: "Yunhe",
          state_id: "751",
        },
        {
          id: "11833",
          name: "Yunyang",
          state_id: "751",
        },
        {
          id: "11834",
          name: "Yushan",
          state_id: "751",
        },
        {
          id: "11835",
          name: "Zhangjiagang",
          state_id: "751",
        },
        {
          id: "11836",
          name: "Zhangjiangang",
          state_id: "751",
        },
        {
          id: "11837",
          name: "Zhaoyang",
          state_id: "751",
        },
        {
          id: "11838",
          name: "Zhenjiang",
          state_id: "751",
        },
        {
          id: "11839",
          name: "Zhongxing",
          state_id: "751",
        },
      ],
      "Jiangsu Sheng": [
        {
          id: "11840",
          name: "Baoying",
          state_id: "752",
        },
        {
          id: "11841",
          name: "Changzhou",
          state_id: "752",
        },
        {
          id: "11842",
          name: "Dachang",
          state_id: "752",
        },
        {
          id: "11843",
          name: "Dafeng",
          state_id: "752",
        },
        {
          id: "11844",
          name: "Danyang",
          state_id: "752",
        },
        {
          id: "11845",
          name: "Dingshu",
          state_id: "752",
        },
        {
          id: "11846",
          name: "Dongkan",
          state_id: "752",
        },
        {
          id: "11847",
          name: "Dongtai",
          state_id: "752",
        },
        {
          id: "11848",
          name: "Fengxian",
          state_id: "752",
        },
        {
          id: "11849",
          name: "Gaogou",
          state_id: "752",
        },
        {
          id: "11850",
          name: "Gaoyou",
          state_id: "752",
        },
        {
          id: "11851",
          name: "Guiren",
          state_id: "752",
        },
        {
          id: "11852",
          name: "Haian",
          state_id: "752",
        },
        {
          id: "11853",
          name: "Haizhou",
          state_id: "752",
        },
        {
          id: "11854",
          name: "Hede",
          state_id: "752",
        },
        {
          id: "11855",
          name: "Huaicheng",
          state_id: "752",
        },
        {
          id: "11856",
          name: "Huaiyin",
          state_id: "752",
        },
        {
          id: "11857",
          name: "Huilong",
          state_id: "752",
        },
        {
          id: "11858",
          name: "Hutang",
          state_id: "752",
        },
        {
          id: "11859",
          name: "Jiangdu",
          state_id: "752",
        },
        {
          id: "11860",
          name: "Jiangyan",
          state_id: "752",
        },
        {
          id: "11861",
          name: "Jiangyin",
          state_id: "752",
        },
        {
          id: "11862",
          name: "Jiangyuan",
          state_id: "752",
        },
        {
          id: "11863",
          name: "Jianhu",
          state_id: "752",
        },
        {
          id: "11864",
          name: "Jingcheng",
          state_id: "752",
        },
        {
          id: "11865",
          name: "Jinsha",
          state_id: "752",
        },
        {
          id: "11866",
          name: "Jintan",
          state_id: "752",
        },
        {
          id: "11867",
          name: "Juegang",
          state_id: "752",
        },
        {
          id: "11868",
          name: "Jurong",
          state_id: "752",
        },
        {
          id: "11869",
          name: "Kunshan",
          state_id: "752",
        },
        {
          id: "11870",
          name: "Lianyungang",
          state_id: "752",
        },
        {
          id: "11871",
          name: "Liucheng",
          state_id: "752",
        },
        {
          id: "11872",
          name: "Liyang",
          state_id: "752",
        },
        {
          id: "11873",
          name: "Luodu",
          state_id: "752",
        },
        {
          id: "11874",
          name: "Mudu",
          state_id: "752",
        },
        {
          id: "11875",
          name: "Nanjing",
          state_id: "752",
        },
        {
          id: "11876",
          name: "Nantong",
          state_id: "752",
        },
        {
          id: "11877",
          name: "Pecheng",
          state_id: "752",
        },
        {
          id: "11878",
          name: "Pukou",
          state_id: "752",
        },
        {
          id: "11879",
          name: "Qidong",
          state_id: "752",
        },
        {
          id: "11880",
          name: "Qinnan",
          state_id: "752",
        },
        {
          id: "11881",
          name: "Qixia",
          state_id: "752",
        },
        {
          id: "11882",
          name: "Rucheng",
          state_id: "752",
        },
        {
          id: "11883",
          name: "Songling",
          state_id: "752",
        },
        {
          id: "11884",
          name: "Sucheng",
          state_id: "752",
        },
        {
          id: "11885",
          name: "Suicheng",
          state_id: "752",
        },
        {
          id: "11886",
          name: "Suqian",
          state_id: "752",
        },
        {
          id: "11887",
          name: "Suzhou",
          state_id: "752",
        },
        {
          id: "11888",
          name: "Taicang",
          state_id: "752",
        },
        {
          id: "11889",
          name: "Taixing",
          state_id: "752",
        },
        {
          id: "11890",
          name: "Wujiang",
          state_id: "752",
        },
        {
          id: "11891",
          name: "Wuxi",
          state_id: "752",
        },
        {
          id: "11892",
          name: "Xiaolingwei",
          state_id: "752",
        },
        {
          id: "11893",
          name: "Xiaoshi",
          state_id: "752",
        },
        {
          id: "11894",
          name: "Xinan",
          state_id: "752",
        },
        {
          id: "11895",
          name: "Xinpu",
          state_id: "752",
        },
        {
          id: "11896",
          name: "Xuzhou",
          state_id: "752",
        },
        {
          id: "11897",
          name: "Yancheng",
          state_id: "752",
        },
        {
          id: "11898",
          name: "Yangshe",
          state_id: "752",
        },
        {
          id: "11899",
          name: "Yangzhou",
          state_id: "752",
        },
        {
          id: "11900",
          name: "Yizheng",
          state_id: "752",
        },
        {
          id: "11901",
          name: "Yunhe",
          state_id: "752",
        },
        {
          id: "11902",
          name: "Yunyang",
          state_id: "752",
        },
        {
          id: "11903",
          name: "Yushan",
          state_id: "752",
        },
        {
          id: "11904",
          name: "Zhangjiagang",
          state_id: "752",
        },
        {
          id: "11905",
          name: "Zhangjiangang",
          state_id: "752",
        },
        {
          id: "11906",
          name: "Zhaoyang",
          state_id: "752",
        },
        {
          id: "11907",
          name: "Zhenjiang",
          state_id: "752",
        },
        {
          id: "11908",
          name: "Zhongxing",
          state_id: "752",
        },
      ],
      Jiangxi: [
        {
          id: "11909",
          name: "Fengxin",
          state_id: "753",
        },
        {
          id: "11910",
          name: "Fenyi",
          state_id: "753",
        },
        {
          id: "11911",
          name: "Ganzhou",
          state_id: "753",
        },
        {
          id: "11912",
          name: "Jian",
          state_id: "753",
        },
        {
          id: "11913",
          name: "Jiangguang",
          state_id: "753",
        },
        {
          id: "11914",
          name: "Jingdezhen",
          state_id: "753",
        },
        {
          id: "11915",
          name: "Jiujiang",
          state_id: "753",
        },
        {
          id: "11916",
          name: "Leping",
          state_id: "753",
        },
        {
          id: "11917",
          name: "Linchuan",
          state_id: "753",
        },
        {
          id: "11918",
          name: "Nanchang",
          state_id: "753",
        },
        {
          id: "11919",
          name: "Pingxiang",
          state_id: "753",
        },
        {
          id: "11920",
          name: "Poyang",
          state_id: "753",
        },
        {
          id: "11921",
          name: "Shangrao",
          state_id: "753",
        },
        {
          id: "11922",
          name: "Xiangdong",
          state_id: "753",
        },
        {
          id: "11923",
          name: "Xingan",
          state_id: "753",
        },
        {
          id: "11924",
          name: "Xinjian",
          state_id: "753",
        },
        {
          id: "11925",
          name: "Xinyu",
          state_id: "753",
        },
        {
          id: "11926",
          name: "Xiongshi",
          state_id: "753",
        },
        {
          id: "11927",
          name: "Yichun",
          state_id: "753",
        },
        {
          id: "11928",
          name: "Yingtai",
          state_id: "753",
        },
        {
          id: "11929",
          name: "Yingtan",
          state_id: "753",
        },
        {
          id: "11930",
          name: "Zhangshui",
          state_id: "753",
        },
      ],
      Jilin: [
        {
          id: "11931",
          name: "Badaojiang",
          state_id: "754",
        },
        {
          id: "11932",
          name: "Baicheng",
          state_id: "754",
        },
        {
          id: "11933",
          name: "Baishishan",
          state_id: "754",
        },
        {
          id: "11934",
          name: "Changchun",
          state_id: "754",
        },
        {
          id: "11935",
          name: "Changling",
          state_id: "754",
        },
        {
          id: "11936",
          name: "Chaoyang",
          state_id: "754",
        },
        {
          id: "11937",
          name: "Daan",
          state_id: "754",
        },
        {
          id: "11938",
          name: "Dashitou",
          state_id: "754",
        },
        {
          id: "11939",
          name: "Dehui",
          state_id: "754",
        },
        {
          id: "11940",
          name: "Dongchang",
          state_id: "754",
        },
        {
          id: "11941",
          name: "Dongfeng",
          state_id: "754",
        },
        {
          id: "11942",
          name: "Dunhua",
          state_id: "754",
        },
        {
          id: "11943",
          name: "Erdaojiang",
          state_id: "754",
        },
        {
          id: "11944",
          name: "Fuyu",
          state_id: "754",
        },
        {
          id: "11945",
          name: "Gongzhuling",
          state_id: "754",
        },
        {
          id: "11946",
          name: "Helong",
          state_id: "754",
        },
        {
          id: "11947",
          name: "Hongmei",
          state_id: "754",
        },
        {
          id: "11948",
          name: "Huadian",
          state_id: "754",
        },
        {
          id: "11949",
          name: "Huangnihe",
          state_id: "754",
        },
        {
          id: "11950",
          name: "Huinan",
          state_id: "754",
        },
        {
          id: "11951",
          name: "Hunchun",
          state_id: "754",
        },
        {
          id: "11952",
          name: "Jiaohe",
          state_id: "754",
        },
        {
          id: "11953",
          name: "Jilin",
          state_id: "754",
        },
        {
          id: "11954",
          name: "Jishu",
          state_id: "754",
        },
        {
          id: "11955",
          name: "Jiutai",
          state_id: "754",
        },
        {
          id: "11956",
          name: "Kaitong",
          state_id: "754",
        },
        {
          id: "11957",
          name: "Kouqian",
          state_id: "754",
        },
        {
          id: "11958",
          name: "Liaoyuan",
          state_id: "754",
        },
        {
          id: "11959",
          name: "Linjiang",
          state_id: "754",
        },
        {
          id: "11960",
          name: "Lishu",
          state_id: "754",
        },
        {
          id: "11961",
          name: "Liuhe",
          state_id: "754",
        },
        {
          id: "11962",
          name: "Longjing",
          state_id: "754",
        },
        {
          id: "11963",
          name: "Meihekou",
          state_id: "754",
        },
        {
          id: "11964",
          name: "Mingyue",
          state_id: "754",
        },
        {
          id: "11965",
          name: "Nongan",
          state_id: "754",
        },
        {
          id: "11966",
          name: "Panshi",
          state_id: "754",
        },
        {
          id: "11967",
          name: "Pizhou",
          state_id: "754",
        },
        {
          id: "11968",
          name: "Qianan",
          state_id: "754",
        },
        {
          id: "11969",
          name: "Qianguo",
          state_id: "754",
        },
        {
          id: "11970",
          name: "Sanchazi",
          state_id: "754",
        },
        {
          id: "11971",
          name: "Shuangyang",
          state_id: "754",
        },
        {
          id: "11972",
          name: "Shulan",
          state_id: "754",
        },
        {
          id: "11973",
          name: "Siping",
          state_id: "754",
        },
        {
          id: "11974",
          name: "Songjianghe",
          state_id: "754",
        },
        {
          id: "11975",
          name: "Taonan",
          state_id: "754",
        },
        {
          id: "11976",
          name: "Tumen",
          state_id: "754",
        },
        {
          id: "11977",
          name: "Wangou",
          state_id: "754",
        },
        {
          id: "11978",
          name: "Wangqing",
          state_id: "754",
        },
        {
          id: "11979",
          name: "Xinglongshan",
          state_id: "754",
        },
        {
          id: "11980",
          name: "Yanji",
          state_id: "754",
        },
        {
          id: "11981",
          name: "Yantongshan",
          state_id: "754",
        },
        {
          id: "11982",
          name: "Yushu",
          state_id: "754",
        },
        {
          id: "11983",
          name: "Zhengjiatun",
          state_id: "754",
        },
        {
          id: "11984",
          name: "Zhenlai",
          state_id: "754",
        },
      ],
      Liaoning: [
        {
          id: "11985",
          name: "Anshan",
          state_id: "755",
        },
        {
          id: "11986",
          name: "Beipiao",
          state_id: "755",
        },
        {
          id: "11987",
          name: "Benxi",
          state_id: "755",
        },
        {
          id: "11988",
          name: "Changtu",
          state_id: "755",
        },
        {
          id: "11989",
          name: "Chaoyang",
          state_id: "755",
        },
        {
          id: "11990",
          name: "Dalian",
          state_id: "755",
        },
        {
          id: "11991",
          name: "Dalianwan",
          state_id: "755",
        },
        {
          id: "11992",
          name: "Dalinghe",
          state_id: "755",
        },
        {
          id: "11993",
          name: "Dandong",
          state_id: "755",
        },
        {
          id: "11994",
          name: "Dashiqiao",
          state_id: "755",
        },
        {
          id: "11995",
          name: "Dongling",
          state_id: "755",
        },
        {
          id: "11996",
          name: "Fengcheng",
          state_id: "755",
        },
        {
          id: "11997",
          name: "Fushun",
          state_id: "755",
        },
        {
          id: "11998",
          name: "Fuxin",
          state_id: "755",
        },
        {
          id: "11999",
          name: "Haicheng",
          state_id: "755",
        },
        {
          id: "12000",
          name: "Heishan",
          state_id: "755",
        },
        {
          id: "12001",
          name: "Huanren",
          state_id: "755",
        },
        {
          id: "12002",
          name: "Huludao",
          state_id: "755",
        },
        {
          id: "12003",
          name: "Hushitai",
          state_id: "755",
        },
        {
          id: "12004",
          name: "Jinxi",
          state_id: "755",
        },
        {
          id: "12005",
          name: "Jinzhou",
          state_id: "755",
        },
        {
          id: "12006",
          name: "Jiupu",
          state_id: "755",
        },
        {
          id: "12007",
          name: "Kaiyuan",
          state_id: "755",
        },
        {
          id: "12008",
          name: "Kuandian",
          state_id: "755",
        },
        {
          id: "12009",
          name: "Langtou",
          state_id: "755",
        },
        {
          id: "12010",
          name: "Liaoyang",
          state_id: "755",
        },
        {
          id: "12011",
          name: "Liaozhong",
          state_id: "755",
        },
        {
          id: "12012",
          name: "Lingyuan",
          state_id: "755",
        },
        {
          id: "12013",
          name: "Liuerbao",
          state_id: "755",
        },
        {
          id: "12014",
          name: "Lushunkou",
          state_id: "755",
        },
        {
          id: "12015",
          name: "Nantai",
          state_id: "755",
        },
        {
          id: "12016",
          name: "Panjin",
          state_id: "755",
        },
        {
          id: "12017",
          name: "Pulandian",
          state_id: "755",
        },
        {
          id: "12018",
          name: "Shenyang",
          state_id: "755",
        },
        {
          id: "12019",
          name: "Sujiatun",
          state_id: "755",
        },
        {
          id: "12020",
          name: "Tieling",
          state_id: "755",
        },
        {
          id: "12021",
          name: "Wafangdian",
          state_id: "755",
        },
        {
          id: "12022",
          name: "Xiaoshi",
          state_id: "755",
        },
        {
          id: "12023",
          name: "Xifeng",
          state_id: "755",
        },
        {
          id: "12024",
          name: "Xinchengxi",
          state_id: "755",
        },
        {
          id: "12025",
          name: "Xingcheng",
          state_id: "755",
        },
        {
          id: "12026",
          name: "Xinmin",
          state_id: "755",
        },
        {
          id: "12027",
          name: "Xiongyue",
          state_id: "755",
        },
        {
          id: "12028",
          name: "Xiuyan",
          state_id: "755",
        },
        {
          id: "12029",
          name: "Yebaishou",
          state_id: "755",
        },
        {
          id: "12030",
          name: "Yingkou",
          state_id: "755",
        },
        {
          id: "12031",
          name: "Yuhong",
          state_id: "755",
        },
        {
          id: "12032",
          name: "Zhuanghe",
          state_id: "755",
        },
      ],
      "Liaoning Sheng": [
        {
          id: "12033",
          name: "Anshan",
          state_id: "756",
        },
        {
          id: "12034",
          name: "Beipiao",
          state_id: "756",
        },
        {
          id: "12035",
          name: "Benxi",
          state_id: "756",
        },
        {
          id: "12036",
          name: "Changtu",
          state_id: "756",
        },
        {
          id: "12037",
          name: "Chaoyang",
          state_id: "756",
        },
        {
          id: "12038",
          name: "Dalian",
          state_id: "756",
        },
        {
          id: "12039",
          name: "Dalianwan",
          state_id: "756",
        },
        {
          id: "12040",
          name: "Dalinghe",
          state_id: "756",
        },
        {
          id: "12041",
          name: "Dandong",
          state_id: "756",
        },
        {
          id: "12042",
          name: "Dashiqiao",
          state_id: "756",
        },
        {
          id: "12043",
          name: "Dongling",
          state_id: "756",
        },
        {
          id: "12044",
          name: "Fengcheng",
          state_id: "756",
        },
        {
          id: "12045",
          name: "Fushun",
          state_id: "756",
        },
        {
          id: "12046",
          name: "Fuxin",
          state_id: "756",
        },
        {
          id: "12047",
          name: "Haicheng",
          state_id: "756",
        },
        {
          id: "12048",
          name: "Heishan",
          state_id: "756",
        },
        {
          id: "12049",
          name: "Huanren",
          state_id: "756",
        },
        {
          id: "12050",
          name: "Huludao",
          state_id: "756",
        },
        {
          id: "12051",
          name: "Hushitai",
          state_id: "756",
        },
        {
          id: "12052",
          name: "Jinxi",
          state_id: "756",
        },
        {
          id: "12053",
          name: "Jinzhou",
          state_id: "756",
        },
        {
          id: "12054",
          name: "Jiupu",
          state_id: "756",
        },
        {
          id: "12055",
          name: "Kaiyuan",
          state_id: "756",
        },
        {
          id: "12056",
          name: "Kuandian",
          state_id: "756",
        },
        {
          id: "12057",
          name: "Langtou",
          state_id: "756",
        },
        {
          id: "12058",
          name: "Liaoyang",
          state_id: "756",
        },
        {
          id: "12059",
          name: "Liaozhong",
          state_id: "756",
        },
        {
          id: "12060",
          name: "Lingyuan",
          state_id: "756",
        },
        {
          id: "12061",
          name: "Liuerbao",
          state_id: "756",
        },
        {
          id: "12062",
          name: "Lushunkou",
          state_id: "756",
        },
        {
          id: "12063",
          name: "Nantai",
          state_id: "756",
        },
        {
          id: "12064",
          name: "Panjin",
          state_id: "756",
        },
        {
          id: "12065",
          name: "Pulandian",
          state_id: "756",
        },
        {
          id: "12066",
          name: "Shenyang",
          state_id: "756",
        },
        {
          id: "12067",
          name: "Sujiatun",
          state_id: "756",
        },
        {
          id: "12068",
          name: "Tieling",
          state_id: "756",
        },
        {
          id: "12069",
          name: "Wafangdian",
          state_id: "756",
        },
        {
          id: "12070",
          name: "Xiaoshi",
          state_id: "756",
        },
        {
          id: "12071",
          name: "Xifeng",
          state_id: "756",
        },
        {
          id: "12072",
          name: "Xinchengxi",
          state_id: "756",
        },
        {
          id: "12073",
          name: "Xingcheng",
          state_id: "756",
        },
        {
          id: "12074",
          name: "Xinmin",
          state_id: "756",
        },
        {
          id: "12075",
          name: "Xiongyue",
          state_id: "756",
        },
        {
          id: "12076",
          name: "Xiuyan",
          state_id: "756",
        },
        {
          id: "12077",
          name: "Yebaishou",
          state_id: "756",
        },
        {
          id: "12078",
          name: "Yingkou",
          state_id: "756",
        },
        {
          id: "12079",
          name: "Yuhong",
          state_id: "756",
        },
        {
          id: "12080",
          name: "Zhuanghe",
          state_id: "756",
        },
      ],
      "Nei Monggol": [],
      "Ningxia Hui": [],
      Qinghai: [
        {
          id: "12081",
          name: "Qiatou",
          state_id: "759",
        },
        {
          id: "12082",
          name: "Xining",
          state_id: "759",
        },
      ],
      Shaanxi: [
        {
          id: "12083",
          name: "Ankang",
          state_id: "760",
        },
        {
          id: "12084",
          name: "Baoji",
          state_id: "760",
        },
        {
          id: "12085",
          name: "Guozhen",
          state_id: "760",
        },
        {
          id: "12086",
          name: "Hancheng",
          state_id: "760",
        },
        {
          id: "12087",
          name: "Hanzhong",
          state_id: "760",
        },
        {
          id: "12088",
          name: "Lishan",
          state_id: "760",
        },
        {
          id: "12089",
          name: "Qili",
          state_id: "760",
        },
        {
          id: "12090",
          name: "Tongchuan",
          state_id: "760",
        },
        {
          id: "12091",
          name: "Weinan",
          state_id: "760",
        },
        {
          id: "12092",
          name: "Xian",
          state_id: "760",
        },
        {
          id: "12093",
          name: "Xianyang",
          state_id: "760",
        },
        {
          id: "12094",
          name: "Yanan",
          state_id: "760",
        },
        {
          id: "12095",
          name: "Yanliang",
          state_id: "760",
        },
        {
          id: "12096",
          name: "Yulin",
          state_id: "760",
        },
        {
          id: "12097",
          name: "Yuxia",
          state_id: "760",
        },
      ],
      Shandong: [
        {
          id: "12098",
          name: "Anqiu",
          state_id: "761",
        },
        {
          id: "12099",
          name: "Bianzhuang",
          state_id: "761",
        },
        {
          id: "12100",
          name: "Binzhou",
          state_id: "761",
        },
        {
          id: "12101",
          name: "Boshan",
          state_id: "761",
        },
        {
          id: "12102",
          name: "Boxing County",
          state_id: "761",
        },
        {
          id: "12103",
          name: "Caocheng",
          state_id: "761",
        },
        {
          id: "12104",
          name: "Changqing",
          state_id: "761",
        },
        {
          id: "12105",
          name: "Chengyang",
          state_id: "761",
        },
        {
          id: "12106",
          name: "Dengzhou",
          state_id: "761",
        },
        {
          id: "12107",
          name: "Dezhou",
          state_id: "761",
        },
        {
          id: "12108",
          name: "Dingtao",
          state_id: "761",
        },
        {
          id: "12109",
          name: "Dongcun",
          state_id: "761",
        },
        {
          id: "12110",
          name: "Dongdu",
          state_id: "761",
        },
        {
          id: "12111",
          name: "Donge County",
          state_id: "761",
        },
        {
          id: "12112",
          name: "Dongying",
          state_id: "761",
        },
        {
          id: "12113",
          name: "Feicheng",
          state_id: "761",
        },
        {
          id: "12114",
          name: "Fushan",
          state_id: "761",
        },
        {
          id: "12115",
          name: "Gaomi",
          state_id: "761",
        },
        {
          id: "12116",
          name: "Haiyang",
          state_id: "761",
        },
        {
          id: "12117",
          name: "Hanting",
          state_id: "761",
        },
        {
          id: "12118",
          name: "Hekou",
          state_id: "761",
        },
        {
          id: "12119",
          name: "Heze",
          state_id: "761",
        },
        {
          id: "12120",
          name: "Jiaonan",
          state_id: "761",
        },
        {
          id: "12121",
          name: "Jiaozhou",
          state_id: "761",
        },
        {
          id: "12122",
          name: "Jiehu",
          state_id: "761",
        },
        {
          id: "12123",
          name: "Jimo",
          state_id: "761",
        },
        {
          id: "12124",
          name: "Jinan",
          state_id: "761",
        },
        {
          id: "12125",
          name: "Jining",
          state_id: "761",
        },
        {
          id: "12126",
          name: "Juxian",
          state_id: "761",
        },
        {
          id: "12127",
          name: "Juye",
          state_id: "761",
        },
        {
          id: "12128",
          name: "Kunlun",
          state_id: "761",
        },
        {
          id: "12129",
          name: "Laiwu",
          state_id: "761",
        },
        {
          id: "12130",
          name: "Laiyang",
          state_id: "761",
        },
        {
          id: "12131",
          name: "Laizhou",
          state_id: "761",
        },
        {
          id: "12132",
          name: "Leling",
          state_id: "761",
        },
        {
          id: "12133",
          name: "Liaocheng",
          state_id: "761",
        },
        {
          id: "12134",
          name: "Licung",
          state_id: "761",
        },
        {
          id: "12135",
          name: "Linqing",
          state_id: "761",
        },
        {
          id: "12136",
          name: "Linqu",
          state_id: "761",
        },
        {
          id: "12137",
          name: "Linshu",
          state_id: "761",
        },
        {
          id: "12138",
          name: "Linyi",
          state_id: "761",
        },
        {
          id: "12139",
          name: "Longkou",
          state_id: "761",
        },
        {
          id: "12140",
          name: "Mengyin",
          state_id: "761",
        },
        {
          id: "12141",
          name: "Mingshui",
          state_id: "761",
        },
        {
          id: "12142",
          name: "Nanchou",
          state_id: "761",
        },
        {
          id: "12143",
          name: "Nanding",
          state_id: "761",
        },
        {
          id: "12144",
          name: "Nanma",
          state_id: "761",
        },
        {
          id: "12145",
          name: "Ninghai",
          state_id: "761",
        },
        {
          id: "12146",
          name: "Ningyang",
          state_id: "761",
        },
        {
          id: "12147",
          name: "Pingdu",
          state_id: "761",
        },
        {
          id: "12148",
          name: "Pingyi",
          state_id: "761",
        },
        {
          id: "12149",
          name: "Pingyin",
          state_id: "761",
        },
        {
          id: "12150",
          name: "Qingdao",
          state_id: "761",
        },
        {
          id: "12151",
          name: "Qingzhou",
          state_id: "761",
        },
        {
          id: "12152",
          name: "Qixia",
          state_id: "761",
        },
        {
          id: "12153",
          name: "Qufu",
          state_id: "761",
        },
        {
          id: "12154",
          name: "Rizhao",
          state_id: "761",
        },
        {
          id: "12155",
          name: "Rongcheng",
          state_id: "761",
        },
        {
          id: "12156",
          name: "Shancheng",
          state_id: "761",
        },
        {
          id: "12157",
          name: "Shanting",
          state_id: "761",
        },
        {
          id: "12158",
          name: "Shengzhuang",
          state_id: "761",
        },
        {
          id: "12159",
          name: "Shenxian",
          state_id: "761",
        },
        {
          id: "12160",
          name: "Shizilu",
          state_id: "761",
        },
        {
          id: "12161",
          name: "Shouguang",
          state_id: "761",
        },
        {
          id: "12162",
          name: "Shuiji",
          state_id: "761",
        },
        {
          id: "12163",
          name: "Sishui",
          state_id: "761",
        },
        {
          id: "12164",
          name: "Suozhen",
          state_id: "761",
        },
        {
          id: "12165",
          name: "Taian",
          state_id: "761",
        },
        {
          id: "12166",
          name: "Tancheng",
          state_id: "761",
        },
        {
          id: "12167",
          name: "Taozhuang",
          state_id: "761",
        },
        {
          id: "12168",
          name: "Tengzhou",
          state_id: "761",
        },
        {
          id: "12169",
          name: "Weifang",
          state_id: "761",
        },
        {
          id: "12170",
          name: "Weihai",
          state_id: "761",
        },
        {
          id: "12171",
          name: "Wencheng",
          state_id: "761",
        },
        {
          id: "12172",
          name: "Wendeng",
          state_id: "761",
        },
        {
          id: "12173",
          name: "Wenshang",
          state_id: "761",
        },
        {
          id: "12174",
          name: "Wudi",
          state_id: "761",
        },
        {
          id: "12175",
          name: "Xiazhen",
          state_id: "761",
        },
        {
          id: "12176",
          name: "Xincheng",
          state_id: "761",
        },
        {
          id: "12177",
          name: "Xindian",
          state_id: "761",
        },
        {
          id: "12178",
          name: "Xintai",
          state_id: "761",
        },
        {
          id: "12179",
          name: "Yanggu",
          state_id: "761",
        },
        {
          id: "12180",
          name: "Yangshan",
          state_id: "761",
        },
        {
          id: "12181",
          name: "Yantai",
          state_id: "761",
        },
        {
          id: "12182",
          name: "Yanzhou",
          state_id: "761",
        },
        {
          id: "12183",
          name: "Yatou",
          state_id: "761",
        },
        {
          id: "12184",
          name: "Yidu",
          state_id: "761",
        },
        {
          id: "12185",
          name: "Yishui",
          state_id: "761",
        },
        {
          id: "12186",
          name: "Yucheng",
          state_id: "761",
        },
        {
          id: "12187",
          name: "Yuncheng",
          state_id: "761",
        },
        {
          id: "12188",
          name: "Zaozhuang",
          state_id: "761",
        },
        {
          id: "12189",
          name: "Zhangdian",
          state_id: "761",
        },
        {
          id: "12190",
          name: "Zhangjiawa",
          state_id: "761",
        },
        {
          id: "12191",
          name: "Zhangqiu",
          state_id: "761",
        },
        {
          id: "12192",
          name: "Zhaocheng",
          state_id: "761",
        },
        {
          id: "12193",
          name: "Zhoucheng",
          state_id: "761",
        },
        {
          id: "12194",
          name: "Zhoucun",
          state_id: "761",
        },
        {
          id: "12195",
          name: "Zhucheng",
          state_id: "761",
        },
        {
          id: "12196",
          name: "Zhuwang",
          state_id: "761",
        },
        {
          id: "12197",
          name: "Zicheng",
          state_id: "761",
        },
        {
          id: "12198",
          name: "Zouping",
          state_id: "761",
        },
        {
          id: "12199",
          name: "Zouxian",
          state_id: "761",
        },
      ],
      "Shandong Sheng": [
        {
          id: "12200",
          name: "Anqiu",
          state_id: "762",
        },
        {
          id: "12201",
          name: "Bianzhuang",
          state_id: "762",
        },
        {
          id: "12202",
          name: "Binzhou",
          state_id: "762",
        },
        {
          id: "12203",
          name: "Boshan",
          state_id: "762",
        },
        {
          id: "12204",
          name: "Boxing County",
          state_id: "762",
        },
        {
          id: "12205",
          name: "Caocheng",
          state_id: "762",
        },
        {
          id: "12206",
          name: "Changqing",
          state_id: "762",
        },
        {
          id: "12207",
          name: "Chengyang",
          state_id: "762",
        },
        {
          id: "12208",
          name: "Dengzhou",
          state_id: "762",
        },
        {
          id: "12209",
          name: "Dezhou",
          state_id: "762",
        },
        {
          id: "12210",
          name: "Dingtao",
          state_id: "762",
        },
        {
          id: "12211",
          name: "Dongcun",
          state_id: "762",
        },
        {
          id: "12212",
          name: "Dongdu",
          state_id: "762",
        },
        {
          id: "12213",
          name: "Donge County",
          state_id: "762",
        },
        {
          id: "12214",
          name: "Dongying",
          state_id: "762",
        },
        {
          id: "12215",
          name: "Feicheng",
          state_id: "762",
        },
        {
          id: "12216",
          name: "Fushan",
          state_id: "762",
        },
        {
          id: "12217",
          name: "Gaomi",
          state_id: "762",
        },
        {
          id: "12218",
          name: "Haiyang",
          state_id: "762",
        },
        {
          id: "12219",
          name: "Hanting",
          state_id: "762",
        },
        {
          id: "12220",
          name: "Hekou",
          state_id: "762",
        },
        {
          id: "12221",
          name: "Heze",
          state_id: "762",
        },
        {
          id: "12222",
          name: "Jiaonan",
          state_id: "762",
        },
        {
          id: "12223",
          name: "Jiaozhou",
          state_id: "762",
        },
        {
          id: "12224",
          name: "Jiehu",
          state_id: "762",
        },
        {
          id: "12225",
          name: "Jimo",
          state_id: "762",
        },
        {
          id: "12226",
          name: "Jinan",
          state_id: "762",
        },
        {
          id: "12227",
          name: "Jining",
          state_id: "762",
        },
        {
          id: "12228",
          name: "Juxian",
          state_id: "762",
        },
        {
          id: "12229",
          name: "Juye",
          state_id: "762",
        },
        {
          id: "12230",
          name: "Kunlun",
          state_id: "762",
        },
        {
          id: "12231",
          name: "Laiwu",
          state_id: "762",
        },
        {
          id: "12232",
          name: "Laiyang",
          state_id: "762",
        },
        {
          id: "12233",
          name: "Laizhou",
          state_id: "762",
        },
        {
          id: "12234",
          name: "Leling",
          state_id: "762",
        },
        {
          id: "12235",
          name: "Liaocheng",
          state_id: "762",
        },
        {
          id: "12236",
          name: "Licung",
          state_id: "762",
        },
        {
          id: "12237",
          name: "Linqing",
          state_id: "762",
        },
        {
          id: "12238",
          name: "Linqu",
          state_id: "762",
        },
        {
          id: "12239",
          name: "Linshu",
          state_id: "762",
        },
        {
          id: "12240",
          name: "Linyi",
          state_id: "762",
        },
        {
          id: "12241",
          name: "Longkou",
          state_id: "762",
        },
        {
          id: "12242",
          name: "Mengyin",
          state_id: "762",
        },
        {
          id: "12243",
          name: "Mingshui",
          state_id: "762",
        },
        {
          id: "12244",
          name: "Nanchou",
          state_id: "762",
        },
        {
          id: "12245",
          name: "Nanding",
          state_id: "762",
        },
        {
          id: "12246",
          name: "Nanma",
          state_id: "762",
        },
        {
          id: "12247",
          name: "Ninghai",
          state_id: "762",
        },
        {
          id: "12248",
          name: "Ningyang",
          state_id: "762",
        },
        {
          id: "12249",
          name: "Pingdu",
          state_id: "762",
        },
        {
          id: "12250",
          name: "Pingyi",
          state_id: "762",
        },
        {
          id: "12251",
          name: "Pingyin",
          state_id: "762",
        },
        {
          id: "12252",
          name: "Qingdao",
          state_id: "762",
        },
        {
          id: "12253",
          name: "Qingzhou",
          state_id: "762",
        },
        {
          id: "12254",
          name: "Qixia",
          state_id: "762",
        },
        {
          id: "12255",
          name: "Qufu",
          state_id: "762",
        },
        {
          id: "12256",
          name: "Rizhao",
          state_id: "762",
        },
        {
          id: "12257",
          name: "Rongcheng",
          state_id: "762",
        },
        {
          id: "12258",
          name: "Shancheng",
          state_id: "762",
        },
        {
          id: "12259",
          name: "Shanting",
          state_id: "762",
        },
        {
          id: "12260",
          name: "Shengzhuang",
          state_id: "762",
        },
        {
          id: "12261",
          name: "Shenxian",
          state_id: "762",
        },
        {
          id: "12262",
          name: "Shizilu",
          state_id: "762",
        },
        {
          id: "12263",
          name: "Shouguang",
          state_id: "762",
        },
        {
          id: "12264",
          name: "Shuiji",
          state_id: "762",
        },
        {
          id: "12265",
          name: "Sishui",
          state_id: "762",
        },
        {
          id: "12266",
          name: "Suozhen",
          state_id: "762",
        },
        {
          id: "12267",
          name: "Taian",
          state_id: "762",
        },
        {
          id: "12268",
          name: "Tancheng",
          state_id: "762",
        },
        {
          id: "12269",
          name: "Taozhuang",
          state_id: "762",
        },
        {
          id: "12270",
          name: "Tengzhou",
          state_id: "762",
        },
        {
          id: "12271",
          name: "Weifang",
          state_id: "762",
        },
        {
          id: "12272",
          name: "Weihai",
          state_id: "762",
        },
        {
          id: "12273",
          name: "Wencheng",
          state_id: "762",
        },
        {
          id: "12274",
          name: "Wendeng",
          state_id: "762",
        },
        {
          id: "12275",
          name: "Wenshang",
          state_id: "762",
        },
        {
          id: "12276",
          name: "Wudi",
          state_id: "762",
        },
        {
          id: "12277",
          name: "Xiazhen",
          state_id: "762",
        },
        {
          id: "12278",
          name: "Xincheng",
          state_id: "762",
        },
        {
          id: "12279",
          name: "Xindian",
          state_id: "762",
        },
        {
          id: "12280",
          name: "Xintai",
          state_id: "762",
        },
        {
          id: "12281",
          name: "Yanggu",
          state_id: "762",
        },
        {
          id: "12282",
          name: "Yangshan",
          state_id: "762",
        },
        {
          id: "12283",
          name: "Yantai",
          state_id: "762",
        },
        {
          id: "12284",
          name: "Yanzhou",
          state_id: "762",
        },
        {
          id: "12285",
          name: "Yatou",
          state_id: "762",
        },
        {
          id: "12286",
          name: "Yidu",
          state_id: "762",
        },
        {
          id: "12287",
          name: "Yishui",
          state_id: "762",
        },
        {
          id: "12288",
          name: "Yucheng",
          state_id: "762",
        },
        {
          id: "12289",
          name: "Yuncheng",
          state_id: "762",
        },
        {
          id: "12290",
          name: "Zaozhuang",
          state_id: "762",
        },
        {
          id: "12291",
          name: "Zhangdian",
          state_id: "762",
        },
        {
          id: "12292",
          name: "Zhangjiawa",
          state_id: "762",
        },
        {
          id: "12293",
          name: "Zhangqiu",
          state_id: "762",
        },
        {
          id: "12294",
          name: "Zhaocheng",
          state_id: "762",
        },
        {
          id: "12295",
          name: "Zhoucheng",
          state_id: "762",
        },
        {
          id: "12296",
          name: "Zhoucun",
          state_id: "762",
        },
        {
          id: "12297",
          name: "Zhucheng",
          state_id: "762",
        },
        {
          id: "12298",
          name: "Zhuwang",
          state_id: "762",
        },
        {
          id: "12299",
          name: "Zicheng",
          state_id: "762",
        },
        {
          id: "12300",
          name: "Zouping",
          state_id: "762",
        },
        {
          id: "12301",
          name: "Zouxian",
          state_id: "762",
        },
      ],
      Shanghai: [
        {
          id: "12302",
          name: "Jiading",
          state_id: "763",
        },
        {
          id: "12303",
          name: "Minhang",
          state_id: "763",
        },
        {
          id: "12304",
          name: "Shanghai",
          state_id: "763",
        },
        {
          id: "12305",
          name: "Songjiang",
          state_id: "763",
        },
        {
          id: "12306",
          name: "Trencin",
          state_id: "763",
        },
      ],
      Shanxi: [
        {
          id: "12307",
          name: "Changzhi",
          state_id: "764",
        },
        {
          id: "12308",
          name: "Datong",
          state_id: "764",
        },
        {
          id: "12309",
          name: "Houma",
          state_id: "764",
        },
        {
          id: "12310",
          name: "Jiexiu",
          state_id: "764",
        },
        {
          id: "12311",
          name: "Jincheng",
          state_id: "764",
        },
        {
          id: "12312",
          name: "Linfen",
          state_id: "764",
        },
        {
          id: "12313",
          name: "Taiyuan",
          state_id: "764",
        },
        {
          id: "12314",
          name: "Xian",
          state_id: "764",
        },
        {
          id: "12315",
          name: "Xinzhi",
          state_id: "764",
        },
        {
          id: "12316",
          name: "Xinzhou",
          state_id: "764",
        },
        {
          id: "12317",
          name: "Yangquan",
          state_id: "764",
        },
        {
          id: "12318",
          name: "Yuanping",
          state_id: "764",
        },
        {
          id: "12319",
          name: "Yuci",
          state_id: "764",
        },
        {
          id: "12320",
          name: "Yuncheng",
          state_id: "764",
        },
      ],
      Sichuan: [
        {
          id: "12321",
          name: "Anju",
          state_id: "765",
        },
        {
          id: "12322",
          name: "Baoning",
          state_id: "765",
        },
        {
          id: "12323",
          name: "Chengdu",
          state_id: "765",
        },
        {
          id: "12324",
          name: "Daan",
          state_id: "765",
        },
        {
          id: "12325",
          name: "Dawan",
          state_id: "765",
        },
        {
          id: "12326",
          name: "Daxian",
          state_id: "765",
        },
        {
          id: "12327",
          name: "Deyang",
          state_id: "765",
        },
        {
          id: "12328",
          name: "Dujiangyan City",
          state_id: "765",
        },
        {
          id: "12329",
          name: "Guangkou",
          state_id: "765",
        },
        {
          id: "12330",
          name: "Guangyuan",
          state_id: "765",
        },
        {
          id: "12331",
          name: "Guihu",
          state_id: "765",
        },
        {
          id: "12332",
          name: "Heyang",
          state_id: "765",
        },
        {
          id: "12333",
          name: "Huayang",
          state_id: "765",
        },
        {
          id: "12334",
          name: "Jiancheng",
          state_id: "765",
        },
        {
          id: "12335",
          name: "Jiangyou",
          state_id: "765",
        },
        {
          id: "12336",
          name: "Jijiang",
          state_id: "765",
        },
        {
          id: "12337",
          name: "Leshan",
          state_id: "765",
        },
        {
          id: "12338",
          name: "Linqiong",
          state_id: "765",
        },
        {
          id: "12339",
          name: "Luocheng",
          state_id: "765",
        },
        {
          id: "12340",
          name: "Luzhou",
          state_id: "765",
        },
        {
          id: "12341",
          name: "Mianyang",
          state_id: "765",
        },
        {
          id: "12342",
          name: "Nanchong",
          state_id: "765",
        },
        {
          id: "12343",
          name: "Nanlong",
          state_id: "765",
        },
        {
          id: "12344",
          name: "Neijiang",
          state_id: "765",
        },
        {
          id: "12345",
          name: "Panzhihua",
          state_id: "765",
        },
        {
          id: "12346",
          name: "Shifang",
          state_id: "765",
        },
        {
          id: "12347",
          name: "Suining",
          state_id: "765",
        },
        {
          id: "12348",
          name: "Taihe",
          state_id: "765",
        },
        {
          id: "12349",
          name: "Tianpeng",
          state_id: "765",
        },
        {
          id: "12350",
          name: "Tongchuan",
          state_id: "765",
        },
        {
          id: "12351",
          name: "Xichang",
          state_id: "765",
        },
        {
          id: "12352",
          name: "Xunchang",
          state_id: "765",
        },
        {
          id: "12353",
          name: "Yaan",
          state_id: "765",
        },
        {
          id: "12354",
          name: "Yibin",
          state_id: "765",
        },
        {
          id: "12355",
          name: "Yongchang",
          state_id: "765",
        },
        {
          id: "12356",
          name: "Zhonglong",
          state_id: "765",
        },
        {
          id: "12357",
          name: "Zigong",
          state_id: "765",
        },
        {
          id: "12358",
          name: "Ziyang",
          state_id: "765",
        },
      ],
      Tianjin: [
        {
          id: "12359",
          name: "Beichen",
          state_id: "766",
        },
        {
          id: "12360",
          name: "Gangdong",
          state_id: "766",
        },
        {
          id: "12361",
          name: "Hangu",
          state_id: "766",
        },
        {
          id: "12362",
          name: "Jinghai",
          state_id: "766",
        },
        {
          id: "12363",
          name: "Nankai",
          state_id: "766",
        },
        {
          id: "12364",
          name: "Tanggu",
          state_id: "766",
        },
        {
          id: "12365",
          name: "Tianjin",
          state_id: "766",
        },
        {
          id: "12366",
          name: "Xianshuigu",
          state_id: "766",
        },
        {
          id: "12367",
          name: "Yangcun",
          state_id: "766",
        },
        {
          id: "12368",
          name: "Yangliuqing",
          state_id: "766",
        },
      ],
      Xianggang: [
        {
          id: "12369",
          name: "Guiqing",
          state_id: "767",
        },
        {
          id: "12370",
          name: "Jiulong",
          state_id: "767",
        },
        {
          id: "12371",
          name: "Quanwan",
          state_id: "767",
        },
        {
          id: "12372",
          name: "Saigong",
          state_id: "767",
        },
        {
          id: "12373",
          name: "Shatin",
          state_id: "767",
        },
        {
          id: "12374",
          name: "Taipo",
          state_id: "767",
        },
        {
          id: "12375",
          name: "Tuanmun",
          state_id: "767",
        },
        {
          id: "12376",
          name: "Xianggang",
          state_id: "767",
        },
        {
          id: "12377",
          name: "Yuanlong",
          state_id: "767",
        },
      ],
      Xinjiang: [
        {
          id: "12378",
          name: "Aksu",
          state_id: "768",
        },
        {
          id: "12379",
          name: "Baijiantan",
          state_id: "768",
        },
        {
          id: "12380",
          name: "Changji",
          state_id: "768",
        },
        {
          id: "12381",
          name: "Dongshan",
          state_id: "768",
        },
        {
          id: "12382",
          name: "Hami",
          state_id: "768",
        },
        {
          id: "12383",
          name: "Hetian",
          state_id: "768",
        },
        {
          id: "12384",
          name: "Karamay",
          state_id: "768",
        },
        {
          id: "12385",
          name: "Kashi",
          state_id: "768",
        },
        {
          id: "12386",
          name: "Korla",
          state_id: "768",
        },
        {
          id: "12387",
          name: "Kuche",
          state_id: "768",
        },
        {
          id: "12388",
          name: "Kuytun",
          state_id: "768",
        },
        {
          id: "12389",
          name: "Shache",
          state_id: "768",
        },
        {
          id: "12390",
          name: "Shihezi",
          state_id: "768",
        },
        {
          id: "12391",
          name: "Shuimogou",
          state_id: "768",
        },
        {
          id: "12392",
          name: "Toutunhe",
          state_id: "768",
        },
        {
          id: "12393",
          name: "Urumqi",
          state_id: "768",
        },
        {
          id: "12394",
          name: "Yining",
          state_id: "768",
        },
      ],
      Xizang: [
        {
          id: "12395",
          name: "Lasa",
          state_id: "769",
        },
      ],
      Yunnan: [
        {
          id: "12396",
          name: "Dali",
          state_id: "770",
        },
        {
          id: "12397",
          name: "Gejiu",
          state_id: "770",
        },
        {
          id: "12398",
          name: "Haikou",
          state_id: "770",
        },
        {
          id: "12399",
          name: "Heilin",
          state_id: "770",
        },
        {
          id: "12400",
          name: "Jinma",
          state_id: "770",
        },
        {
          id: "12401",
          name: "Kaihua",
          state_id: "770",
        },
        {
          id: "12402",
          name: "Kaiyuan",
          state_id: "770",
        },
        {
          id: "12403",
          name: "Kunming",
          state_id: "770",
        },
        {
          id: "12404",
          name: "Lianran",
          state_id: "770",
        },
        {
          id: "12405",
          name: "Longquan",
          state_id: "770",
        },
        {
          id: "12406",
          name: "Lucheng",
          state_id: "770",
        },
        {
          id: "12407",
          name: "Mabai",
          state_id: "770",
        },
        {
          id: "12408",
          name: "Majie",
          state_id: "770",
        },
        {
          id: "12409",
          name: "Miyang",
          state_id: "770",
        },
        {
          id: "12410",
          name: "Qujing",
          state_id: "770",
        },
        {
          id: "12411",
          name: "Rongcheng",
          state_id: "770",
        },
        {
          id: "12412",
          name: "Simao",
          state_id: "770",
        },
        {
          id: "12413",
          name: "Wufeng",
          state_id: "770",
        },
        {
          id: "12414",
          name: "Yunjinghong",
          state_id: "770",
        },
        {
          id: "12415",
          name: "Yuxi Municipal",
          state_id: "770",
        },
        {
          id: "12416",
          name: "Zhaotong",
          state_id: "770",
        },
        {
          id: "12417",
          name: "Zhenhai",
          state_id: "770",
        },
        {
          id: "12418",
          name: "Zhongshu",
          state_id: "770",
        },
        {
          id: "12419",
          name: "Zhoucheng",
          state_id: "770",
        },
        {
          id: "12420",
          name: "Zhuocheng",
          state_id: "770",
        },
      ],
      Zhejiang: [
        {
          id: "12421",
          name: "Aojiang",
          state_id: "771",
        },
        {
          id: "12422",
          name: "Choucheng",
          state_id: "771",
        },
        {
          id: "12423",
          name: "Cixi",
          state_id: "771",
        },
        {
          id: "12424",
          name: "Daqiao",
          state_id: "771",
        },
        {
          id: "12425",
          name: "Deqing",
          state_id: "771",
        },
        {
          id: "12426",
          name: "Dinghai",
          state_id: "771",
        },
        {
          id: "12427",
          name: "Dongyang",
          state_id: "771",
        },
        {
          id: "12428",
          name: "Fuyang",
          state_id: "771",
        },
        {
          id: "12429",
          name: "Haining",
          state_id: "771",
        },
        {
          id: "12430",
          name: "Haiyan",
          state_id: "771",
        },
        {
          id: "12431",
          name: "Hangzhou",
          state_id: "771",
        },
        {
          id: "12432",
          name: "Huangyan",
          state_id: "771",
        },
        {
          id: "12433",
          name: "Hushan",
          state_id: "771",
        },
        {
          id: "12434",
          name: "Huzhou",
          state_id: "771",
        },
        {
          id: "12435",
          name: "Jiaojiang",
          state_id: "771",
        },
        {
          id: "12436",
          name: "Jiaxing",
          state_id: "771",
        },
        {
          id: "12437",
          name: "Jinhua",
          state_id: "771",
        },
        {
          id: "12438",
          name: "Jinxiang",
          state_id: "771",
        },
        {
          id: "12439",
          name: "Kaihua",
          state_id: "771",
        },
        {
          id: "12440",
          name: "Kunyang",
          state_id: "771",
        },
        {
          id: "12441",
          name: "Lanxi",
          state_id: "771",
        },
        {
          id: "12442",
          name: "Linan City",
          state_id: "771",
        },
        {
          id: "12443",
          name: "Linhai",
          state_id: "771",
        },
        {
          id: "12444",
          name: "Linping",
          state_id: "771",
        },
        {
          id: "12445",
          name: "Lishui",
          state_id: "771",
        },
        {
          id: "12446",
          name: "Liushi",
          state_id: "771",
        },
        {
          id: "12447",
          name: "Ningbo",
          state_id: "771",
        },
        {
          id: "12448",
          name: "Ninghai",
          state_id: "771",
        },
        {
          id: "12449",
          name: "Pinghu",
          state_id: "771",
        },
        {
          id: "12450",
          name: "Quzhou",
          state_id: "771",
        },
        {
          id: "12451",
          name: "Ruian",
          state_id: "771",
        },
        {
          id: "12452",
          name: "Shangyu",
          state_id: "771",
        },
        {
          id: "12453",
          name: "Shaoxing",
          state_id: "771",
        },
        {
          id: "12454",
          name: "Shenjiamen",
          state_id: "771",
        },
        {
          id: "12455",
          name: "Taizhou City",
          state_id: "771",
        },
        {
          id: "12456",
          name: "Tonglu",
          state_id: "771",
        },
        {
          id: "12457",
          name: "Wenling",
          state_id: "771",
        },
        {
          id: "12458",
          name: "Wenzhou",
          state_id: "771",
        },
        {
          id: "12459",
          name: "Wuning",
          state_id: "771",
        },
        {
          id: "12460",
          name: "Wuyi",
          state_id: "771",
        },
        {
          id: "12461",
          name: "Xianju",
          state_id: "771",
        },
        {
          id: "12462",
          name: "Xiaoshan",
          state_id: "771",
        },
        {
          id: "12463",
          name: "Xiashi",
          state_id: "771",
        },
        {
          id: "12464",
          name: "Xushan",
          state_id: "771",
        },
        {
          id: "12465",
          name: "Yiwu",
          state_id: "771",
        },
        {
          id: "12466",
          name: "Yongkang",
          state_id: "771",
        },
        {
          id: "12467",
          name: "Yueqing",
          state_id: "771",
        },
        {
          id: "12468",
          name: "Yuhuan",
          state_id: "771",
        },
        {
          id: "12469",
          name: "Yuyao",
          state_id: "771",
        },
        {
          id: "12470",
          name: "Zhejiang",
          state_id: "771",
        },
        {
          id: "12471",
          name: "Zhenhai",
          state_id: "771",
        },
        {
          id: "12472",
          name: "Zhicheng",
          state_id: "771",
        },
        {
          id: "12473",
          name: "Zhuji",
          state_id: "771",
        },
        {
          id: "12474",
          name: "fenghua",
          state_id: "771",
        },
        {
          id: "12475",
          name: "jiashan",
          state_id: "771",
        },
      ],
      "Zhejiang Sheng": [
        {
          id: "12476",
          name: "Aojiang",
          state_id: "772",
        },
        {
          id: "12477",
          name: "Choucheng",
          state_id: "772",
        },
        {
          id: "12478",
          name: "Cixi",
          state_id: "772",
        },
        {
          id: "12479",
          name: "Daqiao",
          state_id: "772",
        },
        {
          id: "12480",
          name: "Deqing",
          state_id: "772",
        },
        {
          id: "12481",
          name: "Dinghai",
          state_id: "772",
        },
        {
          id: "12482",
          name: "Dongyang",
          state_id: "772",
        },
        {
          id: "12483",
          name: "Fuyang",
          state_id: "772",
        },
        {
          id: "12484",
          name: "Haining",
          state_id: "772",
        },
        {
          id: "12485",
          name: "Haiyan",
          state_id: "772",
        },
        {
          id: "12486",
          name: "Hangzhou",
          state_id: "772",
        },
        {
          id: "12487",
          name: "Huangyan",
          state_id: "772",
        },
        {
          id: "12488",
          name: "Hushan",
          state_id: "772",
        },
        {
          id: "12489",
          name: "Huzhou",
          state_id: "772",
        },
        {
          id: "12490",
          name: "Jiaojiang",
          state_id: "772",
        },
        {
          id: "12491",
          name: "Jiaxing",
          state_id: "772",
        },
        {
          id: "12492",
          name: "Jinhua",
          state_id: "772",
        },
        {
          id: "12493",
          name: "Jinxiang",
          state_id: "772",
        },
        {
          id: "12494",
          name: "Kaihua",
          state_id: "772",
        },
        {
          id: "12495",
          name: "Kunyang",
          state_id: "772",
        },
        {
          id: "12496",
          name: "Lanxi",
          state_id: "772",
        },
        {
          id: "12497",
          name: "Linan City",
          state_id: "772",
        },
        {
          id: "12498",
          name: "Linhai",
          state_id: "772",
        },
        {
          id: "12499",
          name: "Linping",
          state_id: "772",
        },
        {
          id: "12500",
          name: "Lishui",
          state_id: "772",
        },
        {
          id: "12501",
          name: "Liushi",
          state_id: "772",
        },
        {
          id: "12502",
          name: "Ningbo",
          state_id: "772",
        },
        {
          id: "12503",
          name: "Ninghai",
          state_id: "772",
        },
        {
          id: "12504",
          name: "Pinghu",
          state_id: "772",
        },
        {
          id: "12505",
          name: "Quzhou",
          state_id: "772",
        },
        {
          id: "12506",
          name: "Ruian",
          state_id: "772",
        },
        {
          id: "12507",
          name: "Shangyu",
          state_id: "772",
        },
        {
          id: "12508",
          name: "Shaoxing",
          state_id: "772",
        },
        {
          id: "12509",
          name: "Shenjiamen",
          state_id: "772",
        },
        {
          id: "12510",
          name: "Taizhou City",
          state_id: "772",
        },
        {
          id: "12511",
          name: "Tonglu",
          state_id: "772",
        },
        {
          id: "12512",
          name: "Wenling",
          state_id: "772",
        },
        {
          id: "12513",
          name: "Wenzhou",
          state_id: "772",
        },
        {
          id: "12514",
          name: "Wuning",
          state_id: "772",
        },
        {
          id: "12515",
          name: "Wuyi",
          state_id: "772",
        },
        {
          id: "12516",
          name: "Xianju",
          state_id: "772",
        },
        {
          id: "12517",
          name: "Xiaoshan",
          state_id: "772",
        },
        {
          id: "12518",
          name: "Xiashi",
          state_id: "772",
        },
        {
          id: "12519",
          name: "Xushan",
          state_id: "772",
        },
        {
          id: "12520",
          name: "Yiwu",
          state_id: "772",
        },
        {
          id: "12521",
          name: "Yongkang",
          state_id: "772",
        },
        {
          id: "12522",
          name: "Yueqing",
          state_id: "772",
        },
        {
          id: "12523",
          name: "Yuhuan",
          state_id: "772",
        },
        {
          id: "12524",
          name: "Yuyao",
          state_id: "772",
        },
        {
          id: "12525",
          name: "Zhejiang",
          state_id: "772",
        },
        {
          id: "12526",
          name: "Zhenhai",
          state_id: "772",
        },
        {
          id: "12527",
          name: "Zhicheng",
          state_id: "772",
        },
        {
          id: "12528",
          name: "Zhuji",
          state_id: "772",
        },
        {
          id: "12529",
          name: "fenghua",
          state_id: "772",
        },
        {
          id: "12530",
          name: "jiashan",
          state_id: "772",
        },
      ],
    },
  },
  CO: {
    name: "Colombia",
    native: "Colombia",
    phone: "57",
    continent: "SA",
    capital: "Bogotá",
    currency: "COP",
    languages: ["es"],
    emoji: "🇨🇴",
    emojiU: "U+1F1E8 U+1F1F4",
    states: {
      Amazonas: [
        {
          id: "12531",
          name: "Leticia",
          state_id: "775",
        },
        {
          id: "12532",
          name: "Puerto Narino",
          state_id: "775",
        },
      ],
      Antioquia: [
        {
          id: "12533",
          name: "Abejorral",
          state_id: "776",
        },
        {
          id: "12534",
          name: "Abriaqui",
          state_id: "776",
        },
        {
          id: "12535",
          name: "Alejandria",
          state_id: "776",
        },
        {
          id: "12536",
          name: "Amaga",
          state_id: "776",
        },
        {
          id: "12537",
          name: "Amalfi",
          state_id: "776",
        },
        {
          id: "12538",
          name: "Andes",
          state_id: "776",
        },
        {
          id: "12539",
          name: "Angelopolis",
          state_id: "776",
        },
        {
          id: "12540",
          name: "Angostura",
          state_id: "776",
        },
        {
          id: "12541",
          name: "Anori",
          state_id: "776",
        },
        {
          id: "12542",
          name: "Antioquia",
          state_id: "776",
        },
        {
          id: "12543",
          name: "Anza",
          state_id: "776",
        },
        {
          id: "12544",
          name: "Apartado",
          state_id: "776",
        },
        {
          id: "12545",
          name: "Arboletes",
          state_id: "776",
        },
        {
          id: "12546",
          name: "Argelia",
          state_id: "776",
        },
        {
          id: "12547",
          name: "Armenia",
          state_id: "776",
        },
        {
          id: "12548",
          name: "Barbosa",
          state_id: "776",
        },
        {
          id: "12549",
          name: "Bello",
          state_id: "776",
        },
        {
          id: "12550",
          name: "Belmira",
          state_id: "776",
        },
        {
          id: "12551",
          name: "Betania",
          state_id: "776",
        },
        {
          id: "12552",
          name: "Betulia",
          state_id: "776",
        },
        {
          id: "12553",
          name: "Bolivar",
          state_id: "776",
        },
        {
          id: "12554",
          name: "Briceno",
          state_id: "776",
        },
        {
          id: "12555",
          name: "Buritica",
          state_id: "776",
        },
        {
          id: "12556",
          name: "Caceres",
          state_id: "776",
        },
        {
          id: "12557",
          name: "Caicedo",
          state_id: "776",
        },
        {
          id: "12558",
          name: "Caldas",
          state_id: "776",
        },
        {
          id: "12559",
          name: "Campamento",
          state_id: "776",
        },
        {
          id: "12560",
          name: "Canasgordas",
          state_id: "776",
        },
        {
          id: "12561",
          name: "Caracoli",
          state_id: "776",
        },
        {
          id: "12562",
          name: "Caramanta",
          state_id: "776",
        },
        {
          id: "12563",
          name: "Carepa",
          state_id: "776",
        },
        {
          id: "12564",
          name: "Carmen de Viboral",
          state_id: "776",
        },
        {
          id: "12565",
          name: "Carolina",
          state_id: "776",
        },
        {
          id: "12566",
          name: "Caucasia",
          state_id: "776",
        },
        {
          id: "12567",
          name: "Chigorodo",
          state_id: "776",
        },
        {
          id: "12568",
          name: "Cisneros",
          state_id: "776",
        },
        {
          id: "12569",
          name: "Cocorna",
          state_id: "776",
        },
        {
          id: "12570",
          name: "Concepcion",
          state_id: "776",
        },
        {
          id: "12571",
          name: "Concordia",
          state_id: "776",
        },
        {
          id: "12572",
          name: "Copacabana",
          state_id: "776",
        },
        {
          id: "12573",
          name: "Dabeiba",
          state_id: "776",
        },
        {
          id: "12574",
          name: "Don Matias",
          state_id: "776",
        },
        {
          id: "12575",
          name: "Ebejico",
          state_id: "776",
        },
        {
          id: "12576",
          name: "El Bagre",
          state_id: "776",
        },
        {
          id: "12577",
          name: "Entrerrios",
          state_id: "776",
        },
        {
          id: "12578",
          name: "Envigado",
          state_id: "776",
        },
        {
          id: "12579",
          name: "Fredonia",
          state_id: "776",
        },
        {
          id: "12580",
          name: "Frontino",
          state_id: "776",
        },
        {
          id: "12581",
          name: "Giraldo",
          state_id: "776",
        },
        {
          id: "12582",
          name: "Girardota",
          state_id: "776",
        },
        {
          id: "12583",
          name: "Gomez Plata",
          state_id: "776",
        },
        {
          id: "12584",
          name: "Granada",
          state_id: "776",
        },
        {
          id: "12585",
          name: "Guadalupe",
          state_id: "776",
        },
        {
          id: "12586",
          name: "Guarne",
          state_id: "776",
        },
        {
          id: "12587",
          name: "Guatape",
          state_id: "776",
        },
        {
          id: "12588",
          name: "Heliconia",
          state_id: "776",
        },
        {
          id: "12589",
          name: "Hispania",
          state_id: "776",
        },
        {
          id: "12590",
          name: "Itagui",
          state_id: "776",
        },
        {
          id: "12591",
          name: "Ituango",
          state_id: "776",
        },
        {
          id: "12592",
          name: "Jardin",
          state_id: "776",
        },
        {
          id: "12593",
          name: "Jerico",
          state_id: "776",
        },
        {
          id: "12594",
          name: "La Ceja",
          state_id: "776",
        },
        {
          id: "12595",
          name: "La Estrella",
          state_id: "776",
        },
        {
          id: "12596",
          name: "La Pintada",
          state_id: "776",
        },
        {
          id: "12597",
          name: "La Union",
          state_id: "776",
        },
        {
          id: "12598",
          name: "Liborina",
          state_id: "776",
        },
        {
          id: "12599",
          name: "Maceo",
          state_id: "776",
        },
        {
          id: "12600",
          name: "Marinilla",
          state_id: "776",
        },
        {
          id: "12601",
          name: "Medellin",
          state_id: "776",
        },
        {
          id: "12602",
          name: "Montebello",
          state_id: "776",
        },
        {
          id: "12603",
          name: "Murindo",
          state_id: "776",
        },
        {
          id: "12604",
          name: "Mutata",
          state_id: "776",
        },
        {
          id: "12605",
          name: "Narino",
          state_id: "776",
        },
        {
          id: "12606",
          name: "Nechi",
          state_id: "776",
        },
        {
          id: "12607",
          name: "Necocli",
          state_id: "776",
        },
        {
          id: "12608",
          name: "Olaya",
          state_id: "776",
        },
        {
          id: "12609",
          name: "Penol",
          state_id: "776",
        },
        {
          id: "12610",
          name: "Peque",
          state_id: "776",
        },
        {
          id: "12611",
          name: "Pueblorrico",
          state_id: "776",
        },
        {
          id: "12612",
          name: "Puerto Berrio",
          state_id: "776",
        },
        {
          id: "12613",
          name: "Puerto Nare",
          state_id: "776",
        },
        {
          id: "12614",
          name: "Puerto Triunfo",
          state_id: "776",
        },
        {
          id: "12615",
          name: "Remedios",
          state_id: "776",
        },
        {
          id: "12616",
          name: "Retiro",
          state_id: "776",
        },
        {
          id: "12617",
          name: "Rionegro",
          state_id: "776",
        },
        {
          id: "12618",
          name: "Sabanalarga",
          state_id: "776",
        },
        {
          id: "12619",
          name: "Sabaneta",
          state_id: "776",
        },
        {
          id: "12620",
          name: "Salgar",
          state_id: "776",
        },
        {
          id: "12621",
          name: "San Andres",
          state_id: "776",
        },
        {
          id: "12622",
          name: "San Carlos",
          state_id: "776",
        },
        {
          id: "12623",
          name: "San Francisco",
          state_id: "776",
        },
        {
          id: "12624",
          name: "San Jeronimo",
          state_id: "776",
        },
        {
          id: "12625",
          name: "San Jose de la Montana",
          state_id: "776",
        },
        {
          id: "12626",
          name: "San Juan de Uraba",
          state_id: "776",
        },
        {
          id: "12627",
          name: "San Luis",
          state_id: "776",
        },
        {
          id: "12628",
          name: "San Pedro",
          state_id: "776",
        },
        {
          id: "12629",
          name: "San Pedro de Uraba",
          state_id: "776",
        },
        {
          id: "12630",
          name: "San Rafael",
          state_id: "776",
        },
        {
          id: "12631",
          name: "San Roque",
          state_id: "776",
        },
        {
          id: "12632",
          name: "San Vicente",
          state_id: "776",
        },
        {
          id: "12633",
          name: "Santa Barbara",
          state_id: "776",
        },
        {
          id: "12634",
          name: "Santa Rosa de Osos",
          state_id: "776",
        },
        {
          id: "12635",
          name: "Santo Domingo",
          state_id: "776",
        },
        {
          id: "12636",
          name: "Santuario",
          state_id: "776",
        },
        {
          id: "12637",
          name: "Segovia",
          state_id: "776",
        },
        {
          id: "12638",
          name: "Sonson",
          state_id: "776",
        },
        {
          id: "12639",
          name: "Sopetran",
          state_id: "776",
        },
        {
          id: "12640",
          name: "Tamesis",
          state_id: "776",
        },
        {
          id: "12641",
          name: "Taraza",
          state_id: "776",
        },
        {
          id: "12642",
          name: "Tarso",
          state_id: "776",
        },
        {
          id: "12643",
          name: "Titiribi",
          state_id: "776",
        },
        {
          id: "12644",
          name: "Toledo",
          state_id: "776",
        },
        {
          id: "12645",
          name: "Turbo",
          state_id: "776",
        },
        {
          id: "12646",
          name: "Uramita",
          state_id: "776",
        },
        {
          id: "12647",
          name: "Urrao",
          state_id: "776",
        },
        {
          id: "12648",
          name: "Valdivia",
          state_id: "776",
        },
        {
          id: "12649",
          name: "Valparaiso",
          state_id: "776",
        },
        {
          id: "12650",
          name: "Vegachi",
          state_id: "776",
        },
        {
          id: "12651",
          name: "Venecia",
          state_id: "776",
        },
        {
          id: "12652",
          name: "Vigia del Fuerte",
          state_id: "776",
        },
        {
          id: "12653",
          name: "Yali",
          state_id: "776",
        },
        {
          id: "12654",
          name: "Yarumal",
          state_id: "776",
        },
        {
          id: "12655",
          name: "Yolombo",
          state_id: "776",
        },
        {
          id: "12656",
          name: "Yondo",
          state_id: "776",
        },
        {
          id: "12657",
          name: "Zaragoza",
          state_id: "776",
        },
      ],
      Arauca: [
        {
          id: "12658",
          name: "Arauca",
          state_id: "777",
        },
        {
          id: "12659",
          name: "Arauquita",
          state_id: "777",
        },
        {
          id: "12660",
          name: "Cravo Norte",
          state_id: "777",
        },
        {
          id: "12661",
          name: "Fortul",
          state_id: "777",
        },
        {
          id: "12662",
          name: "Puerto Rondon",
          state_id: "777",
        },
        {
          id: "12663",
          name: "Saravena",
          state_id: "777",
        },
        {
          id: "12664",
          name: "Tame",
          state_id: "777",
        },
      ],
      Atlantico: [
        {
          id: "12665",
          name: "Baranoa",
          state_id: "778",
        },
        {
          id: "12666",
          name: "Barranquilla",
          state_id: "778",
        },
        {
          id: "12667",
          name: "Campo de la Cruz",
          state_id: "778",
        },
        {
          id: "12668",
          name: "Candelaria",
          state_id: "778",
        },
        {
          id: "12669",
          name: "Galapa",
          state_id: "778",
        },
        {
          id: "12670",
          name: "Juan de Acosta",
          state_id: "778",
        },
        {
          id: "12671",
          name: "Luruaco",
          state_id: "778",
        },
        {
          id: "12672",
          name: "Malambo",
          state_id: "778",
        },
        {
          id: "12673",
          name: "Manati",
          state_id: "778",
        },
        {
          id: "12674",
          name: "Palmar de Varela",
          state_id: "778",
        },
        {
          id: "12675",
          name: "Piojo",
          state_id: "778",
        },
        {
          id: "12676",
          name: "Polo Nuevo",
          state_id: "778",
        },
        {
          id: "12677",
          name: "Ponedera",
          state_id: "778",
        },
        {
          id: "12678",
          name: "Puerto Colombia",
          state_id: "778",
        },
        {
          id: "12679",
          name: "Repelon",
          state_id: "778",
        },
        {
          id: "12680",
          name: "Sabanagrande",
          state_id: "778",
        },
        {
          id: "12681",
          name: "Sabanalarga",
          state_id: "778",
        },
        {
          id: "12682",
          name: "Santa Lucia",
          state_id: "778",
        },
        {
          id: "12683",
          name: "Santo Tomas",
          state_id: "778",
        },
        {
          id: "12684",
          name: "Soledad",
          state_id: "778",
        },
        {
          id: "12685",
          name: "Suan",
          state_id: "778",
        },
        {
          id: "12686",
          name: "Tubara",
          state_id: "778",
        },
        {
          id: "12687",
          name: "Usiacuri",
          state_id: "778",
        },
      ],
      Bogota: [
        {
          id: "12688",
          name: "Bogota",
          state_id: "779",
        },
      ],
      Bolivar: [
        {
          id: "12689",
          name: "Achi",
          state_id: "780",
        },
        {
          id: "12690",
          name: "Altos del Rosario",
          state_id: "780",
        },
        {
          id: "12691",
          name: "Arenal",
          state_id: "780",
        },
        {
          id: "12692",
          name: "Arjona",
          state_id: "780",
        },
        {
          id: "12693",
          name: "Arroyohondo",
          state_id: "780",
        },
        {
          id: "12694",
          name: "Barranco de Loba",
          state_id: "780",
        },
        {
          id: "12695",
          name: "Calamar",
          state_id: "780",
        },
        {
          id: "12696",
          name: "Cantagallo",
          state_id: "780",
        },
        {
          id: "12697",
          name: "Cartagena",
          state_id: "780",
        },
        {
          id: "12698",
          name: "Cicuco",
          state_id: "780",
        },
        {
          id: "12699",
          name: "Clemencia",
          state_id: "780",
        },
        {
          id: "12700",
          name: "Cordoba",
          state_id: "780",
        },
        {
          id: "12701",
          name: "El Carmen de Bolivar",
          state_id: "780",
        },
        {
          id: "12702",
          name: "El Guamo",
          state_id: "780",
        },
        {
          id: "12703",
          name: "El Penon",
          state_id: "780",
        },
        {
          id: "12704",
          name: "Hatillo de Loba",
          state_id: "780",
        },
        {
          id: "12705",
          name: "Magangue",
          state_id: "780",
        },
        {
          id: "12706",
          name: "Mahates",
          state_id: "780",
        },
        {
          id: "12707",
          name: "Margarita",
          state_id: "780",
        },
        {
          id: "12708",
          name: "Maria la Baja",
          state_id: "780",
        },
        {
          id: "12709",
          name: "Mompos",
          state_id: "780",
        },
        {
          id: "12710",
          name: "Montecristo",
          state_id: "780",
        },
        {
          id: "12711",
          name: "Morales",
          state_id: "780",
        },
        {
          id: "12712",
          name: "Pinillos",
          state_id: "780",
        },
        {
          id: "12713",
          name: "Regidor",
          state_id: "780",
        },
        {
          id: "12714",
          name: "Rio Viejo",
          state_id: "780",
        },
        {
          id: "12715",
          name: "San Cristobal",
          state_id: "780",
        },
        {
          id: "12716",
          name: "San Estanislao",
          state_id: "780",
        },
        {
          id: "12717",
          name: "San Fernando",
          state_id: "780",
        },
        {
          id: "12718",
          name: "San Jacinto",
          state_id: "780",
        },
        {
          id: "12719",
          name: "San Jacinto del Cauca",
          state_id: "780",
        },
        {
          id: "12720",
          name: "San Juan Nepomuceno",
          state_id: "780",
        },
        {
          id: "12721",
          name: "San Martin de Loba",
          state_id: "780",
        },
        {
          id: "12722",
          name: "San Pablo",
          state_id: "780",
        },
        {
          id: "12723",
          name: "Santa Catalina",
          state_id: "780",
        },
        {
          id: "12724",
          name: "Santa Rosa",
          state_id: "780",
        },
        {
          id: "12725",
          name: "Santa Rosa del Sur",
          state_id: "780",
        },
        {
          id: "12726",
          name: "Simiti",
          state_id: "780",
        },
        {
          id: "12727",
          name: "Soplaviento",
          state_id: "780",
        },
        {
          id: "12728",
          name: "Talaigua Nuevo",
          state_id: "780",
        },
        {
          id: "12729",
          name: "Tiquisio",
          state_id: "780",
        },
        {
          id: "12730",
          name: "Turbaco",
          state_id: "780",
        },
        {
          id: "12731",
          name: "Turbana",
          state_id: "780",
        },
        {
          id: "12732",
          name: "Villanueva",
          state_id: "780",
        },
        {
          id: "12733",
          name: "Zambrano",
          state_id: "780",
        },
      ],
      Boyaca: [
        {
          id: "12734",
          name: "Almeida",
          state_id: "781",
        },
        {
          id: "12735",
          name: "Aquitania",
          state_id: "781",
        },
        {
          id: "12736",
          name: "Arcabuco",
          state_id: "781",
        },
        {
          id: "12737",
          name: "Belen",
          state_id: "781",
        },
        {
          id: "12738",
          name: "Berbeo",
          state_id: "781",
        },
        {
          id: "12739",
          name: "Beteitiva",
          state_id: "781",
        },
        {
          id: "12740",
          name: "Boavita",
          state_id: "781",
        },
        {
          id: "12741",
          name: "Boyaca",
          state_id: "781",
        },
        {
          id: "12742",
          name: "Briceno",
          state_id: "781",
        },
        {
          id: "12743",
          name: "Buenavista",
          state_id: "781",
        },
        {
          id: "12744",
          name: "Busbanza",
          state_id: "781",
        },
        {
          id: "12745",
          name: "Caldas",
          state_id: "781",
        },
        {
          id: "12746",
          name: "Campohermoso",
          state_id: "781",
        },
        {
          id: "12747",
          name: "Cerinza",
          state_id: "781",
        },
        {
          id: "12748",
          name: "Chinavita",
          state_id: "781",
        },
        {
          id: "12749",
          name: "Chiquinquira",
          state_id: "781",
        },
        {
          id: "12750",
          name: "Chiquiza",
          state_id: "781",
        },
        {
          id: "12751",
          name: "Chiscas",
          state_id: "781",
        },
        {
          id: "12752",
          name: "Chita",
          state_id: "781",
        },
        {
          id: "12753",
          name: "Chitaraque",
          state_id: "781",
        },
        {
          id: "12754",
          name: "Chivata",
          state_id: "781",
        },
        {
          id: "12755",
          name: "Chivor",
          state_id: "781",
        },
        {
          id: "12756",
          name: "Cienega",
          state_id: "781",
        },
        {
          id: "12757",
          name: "Combita",
          state_id: "781",
        },
        {
          id: "12758",
          name: "Coper",
          state_id: "781",
        },
        {
          id: "12759",
          name: "Corrales",
          state_id: "781",
        },
        {
          id: "12760",
          name: "Covarachia",
          state_id: "781",
        },
        {
          id: "12761",
          name: "Cubara",
          state_id: "781",
        },
        {
          id: "12762",
          name: "Cucaita",
          state_id: "781",
        },
        {
          id: "12763",
          name: "Cuitiva",
          state_id: "781",
        },
        {
          id: "12764",
          name: "Duitama",
          state_id: "781",
        },
        {
          id: "12765",
          name: "El Cocuy",
          state_id: "781",
        },
        {
          id: "12766",
          name: "El Espino",
          state_id: "781",
        },
        {
          id: "12767",
          name: "Firavitoba",
          state_id: "781",
        },
        {
          id: "12768",
          name: "Floresta",
          state_id: "781",
        },
        {
          id: "12769",
          name: "Gachantiva",
          state_id: "781",
        },
        {
          id: "12770",
          name: "Gameza",
          state_id: "781",
        },
        {
          id: "12771",
          name: "Garagoa",
          state_id: "781",
        },
        {
          id: "12772",
          name: "Guacamayas",
          state_id: "781",
        },
        {
          id: "12773",
          name: "Guateque",
          state_id: "781",
        },
        {
          id: "12774",
          name: "Guayata",
          state_id: "781",
        },
        {
          id: "12775",
          name: "Guican",
          state_id: "781",
        },
        {
          id: "12776",
          name: "Iza",
          state_id: "781",
        },
        {
          id: "12777",
          name: "Jenesano",
          state_id: "781",
        },
        {
          id: "12778",
          name: "Jerico",
          state_id: "781",
        },
        {
          id: "12779",
          name: "La Capilla",
          state_id: "781",
        },
        {
          id: "12780",
          name: "La Uvita",
          state_id: "781",
        },
        {
          id: "12781",
          name: "La Victoria",
          state_id: "781",
        },
        {
          id: "12782",
          name: "Labranzagrande",
          state_id: "781",
        },
        {
          id: "12783",
          name: "Leiva",
          state_id: "781",
        },
        {
          id: "12784",
          name: "Macanal",
          state_id: "781",
        },
        {
          id: "12785",
          name: "Maripi",
          state_id: "781",
        },
        {
          id: "12786",
          name: "Miraflores",
          state_id: "781",
        },
        {
          id: "12787",
          name: "Mongua",
          state_id: "781",
        },
        {
          id: "12788",
          name: "Mongui",
          state_id: "781",
        },
        {
          id: "12789",
          name: "Moniquira",
          state_id: "781",
        },
        {
          id: "12790",
          name: "Motavita",
          state_id: "781",
        },
        {
          id: "12791",
          name: "Muzo",
          state_id: "781",
        },
        {
          id: "12792",
          name: "Nobsa",
          state_id: "781",
        },
        {
          id: "12793",
          name: "Nuevo Colon",
          state_id: "781",
        },
        {
          id: "12794",
          name: "Oicata",
          state_id: "781",
        },
        {
          id: "12795",
          name: "Otanche",
          state_id: "781",
        },
        {
          id: "12796",
          name: "Pachavita",
          state_id: "781",
        },
        {
          id: "12797",
          name: "Paez",
          state_id: "781",
        },
        {
          id: "12798",
          name: "Paipa",
          state_id: "781",
        },
        {
          id: "12799",
          name: "Pajarito",
          state_id: "781",
        },
        {
          id: "12800",
          name: "Panqueba",
          state_id: "781",
        },
        {
          id: "12801",
          name: "Pauna",
          state_id: "781",
        },
        {
          id: "12802",
          name: "Paya",
          state_id: "781",
        },
        {
          id: "12803",
          name: "Paz del Rio",
          state_id: "781",
        },
        {
          id: "12804",
          name: "Pesca",
          state_id: "781",
        },
        {
          id: "12805",
          name: "Pisba",
          state_id: "781",
        },
        {
          id: "12806",
          name: "Puerto Boyaca",
          state_id: "781",
        },
        {
          id: "12807",
          name: "Quipama",
          state_id: "781",
        },
        {
          id: "12808",
          name: "Ramiriqui",
          state_id: "781",
        },
        {
          id: "12809",
          name: "Raquira",
          state_id: "781",
        },
        {
          id: "12810",
          name: "Rondon",
          state_id: "781",
        },
        {
          id: "12811",
          name: "Saboya",
          state_id: "781",
        },
        {
          id: "12812",
          name: "Sachica",
          state_id: "781",
        },
        {
          id: "12813",
          name: "Samaca",
          state_id: "781",
        },
        {
          id: "12814",
          name: "San Eduardo",
          state_id: "781",
        },
        {
          id: "12815",
          name: "San Jose de Pare",
          state_id: "781",
        },
        {
          id: "12816",
          name: "San Luis de Gaceno",
          state_id: "781",
        },
        {
          id: "12817",
          name: "San Mateo",
          state_id: "781",
        },
        {
          id: "12818",
          name: "San Miguel de Sema",
          state_id: "781",
        },
        {
          id: "12820",
          name: "Santa Maria",
          state_id: "781",
        },
        {
          id: "12821",
          name: "Santa Rosa de Viterbo",
          state_id: "781",
        },
        {
          id: "12822",
          name: "Santa Sofia",
          state_id: "781",
        },
        {
          id: "12823",
          name: "Santana",
          state_id: "781",
        },
        {
          id: "12824",
          name: "Sativanorte",
          state_id: "781",
        },
        {
          id: "12825",
          name: "Sativasur",
          state_id: "781",
        },
        {
          id: "12826",
          name: "Siachoque",
          state_id: "781",
        },
        {
          id: "12827",
          name: "Soata",
          state_id: "781",
        },
        {
          id: "12828",
          name: "Socha",
          state_id: "781",
        },
        {
          id: "12829",
          name: "Socota",
          state_id: "781",
        },
        {
          id: "12830",
          name: "Sogamoso",
          state_id: "781",
        },
        {
          id: "12831",
          name: "Somondoco",
          state_id: "781",
        },
        {
          id: "12832",
          name: "Sora",
          state_id: "781",
        },
        {
          id: "12833",
          name: "Soraca",
          state_id: "781",
        },
        {
          id: "12834",
          name: "Sotaquira",
          state_id: "781",
        },
        {
          id: "12835",
          name: "Susacon",
          state_id: "781",
        },
        {
          id: "12836",
          name: "Sutamarchan",
          state_id: "781",
        },
        {
          id: "12837",
          name: "Sutatenza",
          state_id: "781",
        },
        {
          id: "12838",
          name: "Tasco",
          state_id: "781",
        },
        {
          id: "12839",
          name: "Tenza",
          state_id: "781",
        },
        {
          id: "12840",
          name: "Tibana",
          state_id: "781",
        },
        {
          id: "12841",
          name: "Tibasosa",
          state_id: "781",
        },
        {
          id: "12842",
          name: "Tinjaca",
          state_id: "781",
        },
        {
          id: "12843",
          name: "Tipacoque",
          state_id: "781",
        },
        {
          id: "12844",
          name: "Toca",
          state_id: "781",
        },
        {
          id: "12845",
          name: "Togui",
          state_id: "781",
        },
        {
          id: "12846",
          name: "Topaga",
          state_id: "781",
        },
        {
          id: "12847",
          name: "Tota",
          state_id: "781",
        },
        {
          id: "12848",
          name: "Tunja",
          state_id: "781",
        },
        {
          id: "12849",
          name: "Tunungua",
          state_id: "781",
        },
        {
          id: "12850",
          name: "Turmeque",
          state_id: "781",
        },
        {
          id: "12851",
          name: "Tuta",
          state_id: "781",
        },
        {
          id: "12852",
          name: "Tutasa",
          state_id: "781",
        },
        {
          id: "12853",
          name: "Umbita",
          state_id: "781",
        },
        {
          id: "12854",
          name: "Ventaquemada",
          state_id: "781",
        },
        {
          id: "12855",
          name: "Viracacha",
          state_id: "781",
        },
        {
          id: "12856",
          name: "Zetaquira",
          state_id: "781",
        },
      ],
      Caldas: [
        {
          id: "12857",
          name: "Aguadas",
          state_id: "782",
        },
        {
          id: "12858",
          name: "Anserma",
          state_id: "782",
        },
        {
          id: "12859",
          name: "Aranzazu",
          state_id: "782",
        },
        {
          id: "12860",
          name: "Belalcazar",
          state_id: "782",
        },
        {
          id: "12861",
          name: "Chinchina",
          state_id: "782",
        },
        {
          id: "12862",
          name: "Filadelfia",
          state_id: "782",
        },
        {
          id: "12863",
          name: "La Dorada",
          state_id: "782",
        },
        {
          id: "12864",
          name: "La Merced",
          state_id: "782",
        },
        {
          id: "12865",
          name: "Manizales",
          state_id: "782",
        },
        {
          id: "12866",
          name: "Manzanares",
          state_id: "782",
        },
        {
          id: "12867",
          name: "Marmato",
          state_id: "782",
        },
        {
          id: "12868",
          name: "Marquetalia",
          state_id: "782",
        },
        {
          id: "12869",
          name: "Marulanda",
          state_id: "782",
        },
        {
          id: "12870",
          name: "Neira",
          state_id: "782",
        },
        {
          id: "12871",
          name: "Norcasia",
          state_id: "782",
        },
        {
          id: "12872",
          name: "Pacora",
          state_id: "782",
        },
        {
          id: "12873",
          name: "Palestina",
          state_id: "782",
        },
        {
          id: "12874",
          name: "Pensilvania",
          state_id: "782",
        },
        {
          id: "12875",
          name: "Riosucio",
          state_id: "782",
        },
        {
          id: "12876",
          name: "Risaralda",
          state_id: "782",
        },
        {
          id: "12877",
          name: "Salamina",
          state_id: "782",
        },
        {
          id: "12878",
          name: "Samana",
          state_id: "782",
        },
        {
          id: "12879",
          name: "San Jose",
          state_id: "782",
        },
        {
          id: "12880",
          name: "Supia",
          state_id: "782",
        },
        {
          id: "12881",
          name: "Victoria",
          state_id: "782",
        },
        {
          id: "12882",
          name: "Villamaria",
          state_id: "782",
        },
        {
          id: "12883",
          name: "Viterbo",
          state_id: "782",
        },
      ],
      Caqueta: [
        {
          id: "12884",
          name: "Albania",
          state_id: "783",
        },
        {
          id: "12885",
          name: "Belen Andaquies",
          state_id: "783",
        },
        {
          id: "12886",
          name: "Cartagena del Chaira",
          state_id: "783",
        },
        {
          id: "12887",
          name: "Curillo",
          state_id: "783",
        },
        {
          id: "12888",
          name: "El Doncello",
          state_id: "783",
        },
        {
          id: "12889",
          name: "El Paujil",
          state_id: "783",
        },
        {
          id: "12890",
          name: "Florencia",
          state_id: "783",
        },
        {
          id: "12891",
          name: "La Montanita",
          state_id: "783",
        },
        {
          id: "12892",
          name: "Milan",
          state_id: "783",
        },
        {
          id: "12893",
          name: "Morelia",
          state_id: "783",
        },
        {
          id: "12894",
          name: "Puerto Rico",
          state_id: "783",
        },
        {
          id: "12895",
          name: "San Jose de Fragua",
          state_id: "783",
        },
        {
          id: "12896",
          name: "San Vicente del Caguan",
          state_id: "783",
        },
        {
          id: "12897",
          name: "Solano",
          state_id: "783",
        },
        {
          id: "12898",
          name: "Solita",
          state_id: "783",
        },
        {
          id: "12899",
          name: "Valparaiso",
          state_id: "783",
        },
      ],
      Casanare: [
        {
          id: "12900",
          name: "Aguazul",
          state_id: "784",
        },
        {
          id: "12901",
          name: "Chameza",
          state_id: "784",
        },
        {
          id: "12902",
          name: "Hato Corozal",
          state_id: "784",
        },
        {
          id: "12903",
          name: "La Salina",
          state_id: "784",
        },
        {
          id: "12904",
          name: "Mani",
          state_id: "784",
        },
        {
          id: "12905",
          name: "Monterrey",
          state_id: "784",
        },
        {
          id: "12906",
          name: "Nunchia",
          state_id: "784",
        },
        {
          id: "12907",
          name: "Orocue",
          state_id: "784",
        },
        {
          id: "12908",
          name: "Paz de Ariporo",
          state_id: "784",
        },
        {
          id: "12909",
          name: "Pore",
          state_id: "784",
        },
        {
          id: "12910",
          name: "Recetor",
          state_id: "784",
        },
        {
          id: "12911",
          name: "Sabanalarga",
          state_id: "784",
        },
        {
          id: "12912",
          name: "Sacama",
          state_id: "784",
        },
        {
          id: "12913",
          name: "San Luis de Palenque",
          state_id: "784",
        },
        {
          id: "12914",
          name: "Tamara",
          state_id: "784",
        },
        {
          id: "12915",
          name: "Tauramena",
          state_id: "784",
        },
        {
          id: "12916",
          name: "Trinidad",
          state_id: "784",
        },
        {
          id: "12917",
          name: "Villanueva",
          state_id: "784",
        },
        {
          id: "12918",
          name: "Yopal",
          state_id: "784",
        },
      ],
      Cauca: [
        {
          id: "12919",
          name: "Almaguer",
          state_id: "785",
        },
        {
          id: "12920",
          name: "Argelia",
          state_id: "785",
        },
        {
          id: "12921",
          name: "Balboa",
          state_id: "785",
        },
        {
          id: "12922",
          name: "Bolivar",
          state_id: "785",
        },
        {
          id: "12923",
          name: "Buenos Aires",
          state_id: "785",
        },
        {
          id: "12924",
          name: "Cajibio",
          state_id: "785",
        },
        {
          id: "12925",
          name: "Caldono",
          state_id: "785",
        },
        {
          id: "12926",
          name: "Caloto",
          state_id: "785",
        },
        {
          id: "12927",
          name: "Corinto",
          state_id: "785",
        },
        {
          id: "12928",
          name: "El Bordo",
          state_id: "785",
        },
        {
          id: "12929",
          name: "El Tambo",
          state_id: "785",
        },
        {
          id: "12930",
          name: "Florencia",
          state_id: "785",
        },
        {
          id: "12931",
          name: "Guapi",
          state_id: "785",
        },
        {
          id: "12932",
          name: "Inza",
          state_id: "785",
        },
        {
          id: "12933",
          name: "Jambalo",
          state_id: "785",
        },
        {
          id: "12934",
          name: "La Sierra",
          state_id: "785",
        },
        {
          id: "12935",
          name: "La Vega",
          state_id: "785",
        },
        {
          id: "12936",
          name: "Lopez",
          state_id: "785",
        },
        {
          id: "12937",
          name: "Mercaderes",
          state_id: "785",
        },
        {
          id: "12938",
          name: "Miranda",
          state_id: "785",
        },
        {
          id: "12939",
          name: "Morales",
          state_id: "785",
        },
        {
          id: "12940",
          name: "Padilla",
          state_id: "785",
        },
        {
          id: "12941",
          name: "Paez",
          state_id: "785",
        },
        {
          id: "12942",
          name: "Piamonte",
          state_id: "785",
        },
        {
          id: "12943",
          name: "Piendamo",
          state_id: "785",
        },
        {
          id: "12944",
          name: "Popayan",
          state_id: "785",
        },
        {
          id: "12945",
          name: "Puerto Tejada",
          state_id: "785",
        },
        {
          id: "12946",
          name: "Purace",
          state_id: "785",
        },
        {
          id: "12947",
          name: "Rosas",
          state_id: "785",
        },
        {
          id: "12948",
          name: "San Sebastian",
          state_id: "785",
        },
        {
          id: "12949",
          name: "Santa Rosa",
          state_id: "785",
        },
        {
          id: "12950",
          name: "Santander de Quilichao",
          state_id: "785",
        },
        {
          id: "12951",
          name: "Silvia",
          state_id: "785",
        },
        {
          id: "12952",
          name: "Sotara",
          state_id: "785",
        },
        {
          id: "12953",
          name: "Suarez",
          state_id: "785",
        },
        {
          id: "12954",
          name: "Sucre",
          state_id: "785",
        },
        {
          id: "12955",
          name: "Timbio",
          state_id: "785",
        },
        {
          id: "12956",
          name: "Timbiqui",
          state_id: "785",
        },
        {
          id: "12957",
          name: "Toribio",
          state_id: "785",
        },
        {
          id: "12958",
          name: "Totoro",
          state_id: "785",
        },
        {
          id: "12959",
          name: "Villa Rica",
          state_id: "785",
        },
      ],
      Cesar: [
        {
          id: "12960",
          name: "Aguachica",
          state_id: "786",
        },
        {
          id: "12961",
          name: "Agustin Codazzi",
          state_id: "786",
        },
        {
          id: "12962",
          name: "Astrea",
          state_id: "786",
        },
        {
          id: "12963",
          name: "Becerril",
          state_id: "786",
        },
        {
          id: "12964",
          name: "Bosconia",
          state_id: "786",
        },
        {
          id: "12965",
          name: "Chimichagua",
          state_id: "786",
        },
        {
          id: "12966",
          name: "Chiriguana",
          state_id: "786",
        },
        {
          id: "12967",
          name: "Curumani",
          state_id: "786",
        },
        {
          id: "12968",
          name: "El Copey",
          state_id: "786",
        },
        {
          id: "12969",
          name: "El Paso",
          state_id: "786",
        },
        {
          id: "12970",
          name: "Gamarra",
          state_id: "786",
        },
        {
          id: "12971",
          name: "Gonzalez",
          state_id: "786",
        },
        {
          id: "12972",
          name: "La Gloria",
          state_id: "786",
        },
        {
          id: "12973",
          name: "La Jagua Ibirico",
          state_id: "786",
        },
        {
          id: "12974",
          name: "Manaure",
          state_id: "786",
        },
        {
          id: "12975",
          name: "Pailitas",
          state_id: "786",
        },
        {
          id: "12976",
          name: "Pelaya",
          state_id: "786",
        },
        {
          id: "12977",
          name: "Pueblo Bello",
          state_id: "786",
        },
        {
          id: "12978",
          name: "Rio de Oro",
          state_id: "786",
        },
        {
          id: "12979",
          name: "Robles la Paz",
          state_id: "786",
        },
        {
          id: "12980",
          name: "San Alberto",
          state_id: "786",
        },
        {
          id: "12981",
          name: "San Diego",
          state_id: "786",
        },
        {
          id: "12982",
          name: "San Martin",
          state_id: "786",
        },
        {
          id: "12983",
          name: "Tamalameque",
          state_id: "786",
        },
        {
          id: "12984",
          name: "Valledupar",
          state_id: "786",
        },
      ],
      Choco: [
        {
          id: "12985",
          name: "Acandi",
          state_id: "787",
        },
        {
          id: "12986",
          name: "Alto Baudo",
          state_id: "787",
        },
        {
          id: "12987",
          name: "Atrato",
          state_id: "787",
        },
        {
          id: "12988",
          name: "Bagado",
          state_id: "787",
        },
        {
          id: "12989",
          name: "Bahia Solano",
          state_id: "787",
        },
        {
          id: "12990",
          name: "Bajo Baudo",
          state_id: "787",
        },
        {
          id: "12991",
          name: "Bojaya",
          state_id: "787",
        },
        {
          id: "12992",
          name: "Canton de San Pablo",
          state_id: "787",
        },
        {
          id: "12993",
          name: "Carmen del Darien",
          state_id: "787",
        },
        {
          id: "12994",
          name: "Certegui",
          state_id: "787",
        },
        {
          id: "12995",
          name: "Condoto",
          state_id: "787",
        },
        {
          id: "12996",
          name: "El Carmen",
          state_id: "787",
        },
        {
          id: "12997",
          name: "Istmina",
          state_id: "787",
        },
        {
          id: "12998",
          name: "Jurado",
          state_id: "787",
        },
        {
          id: "12999",
          name: "Litoral del San Juan",
          state_id: "787",
        },
        {
          id: "13000",
          name: "Lloro",
          state_id: "787",
        },
        {
          id: "13001",
          name: "Medio Atrato",
          state_id: "787",
        },
        {
          id: "13002",
          name: "Medio Baudo",
          state_id: "787",
        },
        {
          id: "13003",
          name: "Medio San Juan",
          state_id: "787",
        },
        {
          id: "13004",
          name: "Novita",
          state_id: "787",
        },
        {
          id: "13005",
          name: "Nuqui",
          state_id: "787",
        },
        {
          id: "13006",
          name: "Quibdo",
          state_id: "787",
        },
        {
          id: "13007",
          name: "Rio Iro",
          state_id: "787",
        },
        {
          id: "13008",
          name: "Rio Quito",
          state_id: "787",
        },
        {
          id: "13009",
          name: "Riosucio",
          state_id: "787",
        },
        {
          id: "13010",
          name: "San Jose del Palmar",
          state_id: "787",
        },
        {
          id: "13011",
          name: "Sipi",
          state_id: "787",
        },
        {
          id: "13012",
          name: "Tado",
          state_id: "787",
        },
        {
          id: "13013",
          name: "Unguia",
          state_id: "787",
        },
        {
          id: "13014",
          name: "Union Panamericana",
          state_id: "787",
        },
      ],
      Cordoba: [
        {
          id: "13015",
          name: "Ayapel",
          state_id: "788",
        },
        {
          id: "13016",
          name: "Buenavista",
          state_id: "788",
        },
        {
          id: "13017",
          name: "Canalete",
          state_id: "788",
        },
        {
          id: "13018",
          name: "Cerete",
          state_id: "788",
        },
        {
          id: "13019",
          name: "Chima",
          state_id: "788",
        },
        {
          id: "13020",
          name: "Chinu",
          state_id: "788",
        },
        {
          id: "13021",
          name: "Cienaga de Oro",
          state_id: "788",
        },
        {
          id: "13022",
          name: "Cotorra",
          state_id: "788",
        },
        {
          id: "13023",
          name: "La Apartada",
          state_id: "788",
        },
        {
          id: "13024",
          name: "Lorica",
          state_id: "788",
        },
        {
          id: "13025",
          name: "Los Cordobas",
          state_id: "788",
        },
        {
          id: "13026",
          name: "Momil",
          state_id: "788",
        },
        {
          id: "13027",
          name: "Monitos",
          state_id: "788",
        },
        {
          id: "13028",
          name: "Montelibano",
          state_id: "788",
        },
        {
          id: "13029",
          name: "Monteria",
          state_id: "788",
        },
        {
          id: "13030",
          name: "Planeta Rica",
          state_id: "788",
        },
        {
          id: "13031",
          name: "Pueblo Nuevo",
          state_id: "788",
        },
        {
          id: "13032",
          name: "Puerto Escondido",
          state_id: "788",
        },
        {
          id: "13033",
          name: "Puerto Libertador",
          state_id: "788",
        },
        {
          id: "13034",
          name: "Purisima",
          state_id: "788",
        },
        {
          id: "13035",
          name: "Sahagun",
          state_id: "788",
        },
        {
          id: "13036",
          name: "San Andres Sotavento",
          state_id: "788",
        },
        {
          id: "13037",
          name: "San Antero",
          state_id: "788",
        },
        {
          id: "13038",
          name: "San Bernardo Viento",
          state_id: "788",
        },
        {
          id: "13039",
          name: "San Carlos",
          state_id: "788",
        },
        {
          id: "13040",
          name: "San Pelayo",
          state_id: "788",
        },
        {
          id: "13041",
          name: "Tierralta",
          state_id: "788",
        },
        {
          id: "13042",
          name: "Valencia",
          state_id: "788",
        },
      ],
      Cundinamarca: [
        {
          id: "13043",
          name: "Agua de Dios",
          state_id: "789",
        },
        {
          id: "13044",
          name: "Alban",
          state_id: "789",
        },
        {
          id: "13045",
          name: "Anapoima",
          state_id: "789",
        },
        {
          id: "13046",
          name: "Anolaima",
          state_id: "789",
        },
        {
          id: "13047",
          name: "Arbelaez",
          state_id: "789",
        },
        {
          id: "13048",
          name: "Beltran",
          state_id: "789",
        },
        {
          id: "13049",
          name: "Bituima",
          state_id: "789",
        },
        {
          id: "13050",
          name: "Bojaca",
          state_id: "789",
        },
        {
          id: "13051",
          name: "Cabrera",
          state_id: "789",
        },
        {
          id: "13052",
          name: "Cachipay",
          state_id: "789",
        },
        {
          id: "13053",
          name: "Cajica",
          state_id: "789",
        },
        {
          id: "13054",
          name: "Caparrapi",
          state_id: "789",
        },
        {
          id: "13055",
          name: "Caqueza",
          state_id: "789",
        },
        {
          id: "13056",
          name: "Carmen de Carupa",
          state_id: "789",
        },
        {
          id: "13057",
          name: "Chaguani",
          state_id: "789",
        },
        {
          id: "13058",
          name: "Chia",
          state_id: "789",
        },
        {
          id: "13059",
          name: "Chipaque",
          state_id: "789",
        },
        {
          id: "13060",
          name: "Choachi",
          state_id: "789",
        },
        {
          id: "13061",
          name: "Choconta",
          state_id: "789",
        },
        {
          id: "13062",
          name: "Cogua",
          state_id: "789",
        },
        {
          id: "13063",
          name: "Cota",
          state_id: "789",
        },
        {
          id: "13064",
          name: "Cucunuba",
          state_id: "789",
        },
        {
          id: "13065",
          name: "El Colegio",
          state_id: "789",
        },
        {
          id: "13066",
          name: "El Penon",
          state_id: "789",
        },
        {
          id: "13067",
          name: "El Rosal",
          state_id: "789",
        },
        {
          id: "13068",
          name: "Facatativa",
          state_id: "789",
        },
        {
          id: "13069",
          name: "Fomeque",
          state_id: "789",
        },
        {
          id: "13070",
          name: "Fosca",
          state_id: "789",
        },
        {
          id: "13071",
          name: "Funza",
          state_id: "789",
        },
        {
          id: "13072",
          name: "Fuquene",
          state_id: "789",
        },
        {
          id: "13073",
          name: "Fusagasuga",
          state_id: "789",
        },
        {
          id: "13074",
          name: "Gachala",
          state_id: "789",
        },
        {
          id: "13075",
          name: "Gachancipa",
          state_id: "789",
        },
        {
          id: "13076",
          name: "Gacheta",
          state_id: "789",
        },
        {
          id: "13077",
          name: "Gama",
          state_id: "789",
        },
        {
          id: "13078",
          name: "Girardot",
          state_id: "789",
        },
        {
          id: "13079",
          name: "Granada",
          state_id: "789",
        },
        {
          id: "13080",
          name: "Guacheta",
          state_id: "789",
        },
        {
          id: "13081",
          name: "Guaduas",
          state_id: "789",
        },
        {
          id: "13082",
          name: "Guasca",
          state_id: "789",
        },
        {
          id: "13083",
          name: "Guataqui",
          state_id: "789",
        },
        {
          id: "13084",
          name: "Guatavita",
          state_id: "789",
        },
        {
          id: "13085",
          name: "Guayabal de Siquima",
          state_id: "789",
        },
        {
          id: "13086",
          name: "Guayabetal",
          state_id: "789",
        },
        {
          id: "13087",
          name: "Gutierrez",
          state_id: "789",
        },
        {
          id: "13088",
          name: "Jerusalen",
          state_id: "789",
        },
        {
          id: "13089",
          name: "Junin",
          state_id: "789",
        },
        {
          id: "13090",
          name: "La Calera",
          state_id: "789",
        },
        {
          id: "13091",
          name: "La Mesa",
          state_id: "789",
        },
        {
          id: "13092",
          name: "La Palma",
          state_id: "789",
        },
        {
          id: "13093",
          name: "La Pena",
          state_id: "789",
        },
        {
          id: "13094",
          name: "La Vega",
          state_id: "789",
        },
        {
          id: "13095",
          name: "Lenguazaque",
          state_id: "789",
        },
        {
          id: "13096",
          name: "Macheta",
          state_id: "789",
        },
        {
          id: "13097",
          name: "Madrid",
          state_id: "789",
        },
        {
          id: "13098",
          name: "Manta",
          state_id: "789",
        },
        {
          id: "13099",
          name: "Medina",
          state_id: "789",
        },
        {
          id: "13100",
          name: "Mosquera",
          state_id: "789",
        },
        {
          id: "13101",
          name: "Narino",
          state_id: "789",
        },
        {
          id: "13102",
          name: "Nemocon",
          state_id: "789",
        },
        {
          id: "13103",
          name: "Nilo",
          state_id: "789",
        },
        {
          id: "13104",
          name: "Nimaima",
          state_id: "789",
        },
        {
          id: "13105",
          name: "Nocaima",
          state_id: "789",
        },
        {
          id: "13106",
          name: "Ospina Perez",
          state_id: "789",
        },
        {
          id: "13107",
          name: "Pacho",
          state_id: "789",
        },
        {
          id: "13108",
          name: "Paime",
          state_id: "789",
        },
        {
          id: "13109",
          name: "Pandi",
          state_id: "789",
        },
        {
          id: "13110",
          name: "Paratebueno",
          state_id: "789",
        },
        {
          id: "13111",
          name: "Pasca",
          state_id: "789",
        },
        {
          id: "13112",
          name: "Puerto Salgar",
          state_id: "789",
        },
        {
          id: "13113",
          name: "Puli",
          state_id: "789",
        },
        {
          id: "13114",
          name: "Quebradanegra",
          state_id: "789",
        },
        {
          id: "13115",
          name: "Quetame",
          state_id: "789",
        },
        {
          id: "13116",
          name: "Quipile",
          state_id: "789",
        },
        {
          id: "13117",
          name: "Rafael Reyes",
          state_id: "789",
        },
        {
          id: "13118",
          name: "Ricaurte",
          state_id: "789",
        },
        {
          id: "13119",
          name: "San Antonio del Tequendama",
          state_id: "789",
        },
        {
          id: "13120",
          name: "San Bernardo",
          state_id: "789",
        },
        {
          id: "13121",
          name: "San Cayetano",
          state_id: "789",
        },
        {
          id: "13122",
          name: "San Francisco",
          state_id: "789",
        },
        {
          id: "13123",
          name: "San Juan de Rioseco",
          state_id: "789",
        },
        {
          id: "13124",
          name: "Sasaima",
          state_id: "789",
        },
        {
          id: "13125",
          name: "Sesquile",
          state_id: "789",
        },
        {
          id: "13126",
          name: "Sibate",
          state_id: "789",
        },
        {
          id: "13127",
          name: "Silvania",
          state_id: "789",
        },
        {
          id: "13128",
          name: "Simijaca",
          state_id: "789",
        },
        {
          id: "13129",
          name: "Soacha",
          state_id: "789",
        },
        {
          id: "13130",
          name: "Sopo",
          state_id: "789",
        },
        {
          id: "13131",
          name: "Subachoque",
          state_id: "789",
        },
        {
          id: "13132",
          name: "Suesca",
          state_id: "789",
        },
        {
          id: "13133",
          name: "Supata",
          state_id: "789",
        },
        {
          id: "13134",
          name: "Susa",
          state_id: "789",
        },
        {
          id: "13135",
          name: "Sutatausa",
          state_id: "789",
        },
        {
          id: "13136",
          name: "Tabio",
          state_id: "789",
        },
        {
          id: "13137",
          name: "Tausa",
          state_id: "789",
        },
        {
          id: "13138",
          name: "Tena",
          state_id: "789",
        },
        {
          id: "13139",
          name: "Tenjo",
          state_id: "789",
        },
        {
          id: "13140",
          name: "Tibacuy",
          state_id: "789",
        },
        {
          id: "13141",
          name: "Tibirita",
          state_id: "789",
        },
        {
          id: "13142",
          name: "Tocaima",
          state_id: "789",
        },
        {
          id: "13143",
          name: "Tocancipa",
          state_id: "789",
        },
        {
          id: "13144",
          name: "Topaipi",
          state_id: "789",
        },
        {
          id: "13145",
          name: "Ubala",
          state_id: "789",
        },
        {
          id: "13146",
          name: "Ubaque",
          state_id: "789",
        },
        {
          id: "13147",
          name: "Ubate",
          state_id: "789",
        },
        {
          id: "13148",
          name: "Une",
          state_id: "789",
        },
        {
          id: "13149",
          name: "Utica",
          state_id: "789",
        },
        {
          id: "13150",
          name: "Vergara",
          state_id: "789",
        },
        {
          id: "13151",
          name: "Viani",
          state_id: "789",
        },
        {
          id: "13152",
          name: "Villagomez",
          state_id: "789",
        },
        {
          id: "13153",
          name: "Villapinzon",
          state_id: "789",
        },
        {
          id: "13154",
          name: "Villeta",
          state_id: "789",
        },
        {
          id: "13155",
          name: "Viota",
          state_id: "789",
        },
        {
          id: "13156",
          name: "Yacopi",
          state_id: "789",
        },
        {
          id: "13157",
          name: "Zipacon",
          state_id: "789",
        },
        {
          id: "13158",
          name: "Zipaquira",
          state_id: "789",
        },
      ],
      Guainia: [
        {
          id: "13159",
          name: "Inirida",
          state_id: "790",
        },
      ],
      Guaviare: [
        {
          id: "13160",
          name: "Calamar",
          state_id: "791",
        },
        {
          id: "13161",
          name: "El Retorno",
          state_id: "791",
        },
        {
          id: "13162",
          name: "Miraflores",
          state_id: "791",
        },
        {
          id: "13163",
          name: "San Jose del Guaviare",
          state_id: "791",
        },
      ],
      Huila: [
        {
          id: "13164",
          name: "Acevedo",
          state_id: "792",
        },
        {
          id: "13165",
          name: "Agrado",
          state_id: "792",
        },
        {
          id: "13166",
          name: "Aipe",
          state_id: "792",
        },
        {
          id: "13167",
          name: "Algeciras",
          state_id: "792",
        },
        {
          id: "13168",
          name: "Altamira",
          state_id: "792",
        },
        {
          id: "13169",
          name: "Baraya",
          state_id: "792",
        },
        {
          id: "13170",
          name: "Campoalegre",
          state_id: "792",
        },
        {
          id: "13171",
          name: "Colombia",
          state_id: "792",
        },
        {
          id: "13172",
          name: "Elias",
          state_id: "792",
        },
        {
          id: "13173",
          name: "Garzon",
          state_id: "792",
        },
        {
          id: "13174",
          name: "Gigante",
          state_id: "792",
        },
        {
          id: "13175",
          name: "Guadalupe",
          state_id: "792",
        },
        {
          id: "13176",
          name: "Hobo",
          state_id: "792",
        },
        {
          id: "13177",
          name: "Iquira",
          state_id: "792",
        },
        {
          id: "13178",
          name: "Isnos",
          state_id: "792",
        },
        {
          id: "13179",
          name: "La Argentina",
          state_id: "792",
        },
        {
          id: "13180",
          name: "La Plata",
          state_id: "792",
        },
        {
          id: "13181",
          name: "Nataga",
          state_id: "792",
        },
        {
          id: "13182",
          name: "Neiva",
          state_id: "792",
        },
        {
          id: "13183",
          name: "Oporapa",
          state_id: "792",
        },
        {
          id: "13184",
          name: "Paicol",
          state_id: "792",
        },
        {
          id: "13185",
          name: "Palermo",
          state_id: "792",
        },
        {
          id: "13186",
          name: "Palestina",
          state_id: "792",
        },
        {
          id: "13187",
          name: "Pital",
          state_id: "792",
        },
        {
          id: "13188",
          name: "Pitalito",
          state_id: "792",
        },
        {
          id: "13189",
          name: "Rivera",
          state_id: "792",
        },
        {
          id: "13190",
          name: "Saladoblanco",
          state_id: "792",
        },
        {
          id: "13191",
          name: "San Agustin",
          state_id: "792",
        },
        {
          id: "13192",
          name: "Santa Maria",
          state_id: "792",
        },
        {
          id: "13193",
          name: "Suaza",
          state_id: "792",
        },
        {
          id: "13194",
          name: "Tarqui",
          state_id: "792",
        },
        {
          id: "13195",
          name: "Tello",
          state_id: "792",
        },
        {
          id: "13196",
          name: "Teruel",
          state_id: "792",
        },
        {
          id: "13197",
          name: "Tesalia",
          state_id: "792",
        },
        {
          id: "13198",
          name: "Timana",
          state_id: "792",
        },
        {
          id: "13199",
          name: "Villavieja",
          state_id: "792",
        },
        {
          id: "13200",
          name: "Yaguara",
          state_id: "792",
        },
      ],
      "La Guajira": [],
      Magdalena: [
        {
          id: "13201",
          name: "Algarrobo",
          state_id: "794",
        },
        {
          id: "13202",
          name: "Aracataca",
          state_id: "794",
        },
        {
          id: "13203",
          name: "Ariguani",
          state_id: "794",
        },
        {
          id: "13204",
          name: "Cerro San Antonio",
          state_id: "794",
        },
        {
          id: "13205",
          name: "Chivolo",
          state_id: "794",
        },
        {
          id: "13206",
          name: "Cienaga",
          state_id: "794",
        },
        {
          id: "13207",
          name: "Concordia",
          state_id: "794",
        },
        {
          id: "13208",
          name: "El Banco",
          state_id: "794",
        },
        {
          id: "13209",
          name: "El Pinon",
          state_id: "794",
        },
        {
          id: "13210",
          name: "El Reten",
          state_id: "794",
        },
        {
          id: "13211",
          name: "Fundacion",
          state_id: "794",
        },
        {
          id: "13212",
          name: "Guamal",
          state_id: "794",
        },
        {
          id: "13213",
          name: "Nueva Granada",
          state_id: "794",
        },
        {
          id: "13214",
          name: "Pedraza",
          state_id: "794",
        },
        {
          id: "13215",
          name: "Pijino del Carmen",
          state_id: "794",
        },
        {
          id: "13216",
          name: "Pivijay",
          state_id: "794",
        },
        {
          id: "13217",
          name: "Plato",
          state_id: "794",
        },
        {
          id: "13218",
          name: "Puebloviejo",
          state_id: "794",
        },
        {
          id: "13219",
          name: "Remolino",
          state_id: "794",
        },
        {
          id: "13220",
          name: "Sabanas de San Angel",
          state_id: "794",
        },
        {
          id: "13221",
          name: "Salamina",
          state_id: "794",
        },
        {
          id: "13222",
          name: "San Sebastian",
          state_id: "794",
        },
        {
          id: "13223",
          name: "San Zenon",
          state_id: "794",
        },
        {
          id: "13224",
          name: "Santa Ana",
          state_id: "794",
        },
        {
          id: "13225",
          name: "Santa Barbara de Pinto",
          state_id: "794",
        },
        {
          id: "13226",
          name: "Santa Marta",
          state_id: "794",
        },
        {
          id: "13227",
          name: "Sitionuevo",
          state_id: "794",
        },
        {
          id: "13228",
          name: "Tenerife",
          state_id: "794",
        },
        {
          id: "13229",
          name: "Zapayan",
          state_id: "794",
        },
        {
          id: "13230",
          name: "Zona Bananera",
          state_id: "794",
        },
      ],
      Meta: [
        {
          id: "13231",
          name: "Acacias",
          state_id: "795",
        },
        {
          id: "13232",
          name: "Barranca de Upia",
          state_id: "795",
        },
        {
          id: "13233",
          name: "Cabuyaro",
          state_id: "795",
        },
        {
          id: "13234",
          name: "Castilla la Nueva",
          state_id: "795",
        },
        {
          id: "13235",
          name: "Cubarral",
          state_id: "795",
        },
        {
          id: "13236",
          name: "Cumaral",
          state_id: "795",
        },
        {
          id: "13237",
          name: "El Calvario",
          state_id: "795",
        },
        {
          id: "13238",
          name: "El Castillo",
          state_id: "795",
        },
        {
          id: "13239",
          name: "El Dorado",
          state_id: "795",
        },
        {
          id: "13240",
          name: "Fuente de Oro",
          state_id: "795",
        },
        {
          id: "13241",
          name: "Granada",
          state_id: "795",
        },
        {
          id: "13242",
          name: "Guamal",
          state_id: "795",
        },
        {
          id: "13243",
          name: "La Macarena",
          state_id: "795",
        },
        {
          id: "13244",
          name: "La Uribe",
          state_id: "795",
        },
        {
          id: "13245",
          name: "Lejanias",
          state_id: "795",
        },
        {
          id: "13246",
          name: "Mapiripan",
          state_id: "795",
        },
        {
          id: "13247",
          name: "Mesetas",
          state_id: "795",
        },
        {
          id: "13248",
          name: "Puerto Concordia",
          state_id: "795",
        },
        {
          id: "13249",
          name: "Puerto Gaitan",
          state_id: "795",
        },
        {
          id: "13250",
          name: "Puerto Lleras",
          state_id: "795",
        },
        {
          id: "13251",
          name: "Puerto Lopez",
          state_id: "795",
        },
        {
          id: "13252",
          name: "Puerto Rico",
          state_id: "795",
        },
        {
          id: "13253",
          name: "Restrepo",
          state_id: "795",
        },
        {
          id: "13254",
          name: "San Carlos Guaroa",
          state_id: "795",
        },
        {
          id: "13255",
          name: "San Juan de Arama",
          state_id: "795",
        },
        {
          id: "13256",
          name: "San Juanito",
          state_id: "795",
        },
        {
          id: "13257",
          name: "San Martin",
          state_id: "795",
        },
        {
          id: "13258",
          name: "Villavicencio",
          state_id: "795",
        },
        {
          id: "13259",
          name: "Vista Hermosa",
          state_id: "795",
        },
      ],
      Narino: [
        {
          id: "13260",
          name: "Alban",
          state_id: "796",
        },
        {
          id: "13261",
          name: "Aldana",
          state_id: "796",
        },
        {
          id: "13262",
          name: "Ancuya",
          state_id: "796",
        },
        {
          id: "13263",
          name: "Arboleda",
          state_id: "796",
        },
        {
          id: "13264",
          name: "Barbacoas",
          state_id: "796",
        },
        {
          id: "13265",
          name: "Belen",
          state_id: "796",
        },
        {
          id: "13266",
          name: "Buesaco",
          state_id: "796",
        },
        {
          id: "13267",
          name: "Chachagui",
          state_id: "796",
        },
        {
          id: "13268",
          name: "Colon",
          state_id: "796",
        },
        {
          id: "13269",
          name: "Consaca",
          state_id: "796",
        },
        {
          id: "13270",
          name: "Contadero",
          state_id: "796",
        },
        {
          id: "13271",
          name: "Cordoba",
          state_id: "796",
        },
        {
          id: "13272",
          name: "Cuaspud",
          state_id: "796",
        },
        {
          id: "13273",
          name: "Cumbal",
          state_id: "796",
        },
        {
          id: "13274",
          name: "Cumbitara",
          state_id: "796",
        },
        {
          id: "13275",
          name: "El Charco",
          state_id: "796",
        },
        {
          id: "13276",
          name: "El Penol",
          state_id: "796",
        },
        {
          id: "13277",
          name: "El Rosario",
          state_id: "796",
        },
        {
          id: "13278",
          name: "El Tablon",
          state_id: "796",
        },
        {
          id: "13279",
          name: "El Tambo",
          state_id: "796",
        },
        {
          id: "13280",
          name: "Funes",
          state_id: "796",
        },
        {
          id: "13281",
          name: "Guachucal",
          state_id: "796",
        },
        {
          id: "13282",
          name: "Guaitarilla",
          state_id: "796",
        },
        {
          id: "13283",
          name: "Gualmatan",
          state_id: "796",
        },
        {
          id: "13284",
          name: "Iles",
          state_id: "796",
        },
        {
          id: "13285",
          name: "Imues",
          state_id: "796",
        },
        {
          id: "13286",
          name: "Ipiales",
          state_id: "796",
        },
        {
          id: "13287",
          name: "La Cruz",
          state_id: "796",
        },
        {
          id: "13288",
          name: "La Florida",
          state_id: "796",
        },
        {
          id: "13289",
          name: "La Llanada",
          state_id: "796",
        },
        {
          id: "13290",
          name: "La Tola",
          state_id: "796",
        },
        {
          id: "13291",
          name: "La Union",
          state_id: "796",
        },
        {
          id: "13292",
          name: "Leiva",
          state_id: "796",
        },
        {
          id: "13293",
          name: "Linares",
          state_id: "796",
        },
        {
          id: "13294",
          name: "Los Andes",
          state_id: "796",
        },
        {
          id: "13295",
          name: "Magui",
          state_id: "796",
        },
        {
          id: "13296",
          name: "Mallama",
          state_id: "796",
        },
        {
          id: "13297",
          name: "Mosquera",
          state_id: "796",
        },
        {
          id: "13298",
          name: "Narino",
          state_id: "796",
        },
        {
          id: "13299",
          name: "Olaya Herrera",
          state_id: "796",
        },
        {
          id: "13300",
          name: "Ospina",
          state_id: "796",
        },
        {
          id: "13301",
          name: "Pasto",
          state_id: "796",
        },
        {
          id: "13302",
          name: "Pizarro",
          state_id: "796",
        },
        {
          id: "13303",
          name: "Policarpa",
          state_id: "796",
        },
        {
          id: "13304",
          name: "Potosi",
          state_id: "796",
        },
        {
          id: "13305",
          name: "Providencia",
          state_id: "796",
        },
        {
          id: "13306",
          name: "Puerres",
          state_id: "796",
        },
        {
          id: "13307",
          name: "Pupiales",
          state_id: "796",
        },
        {
          id: "13308",
          name: "Ricaurte",
          state_id: "796",
        },
        {
          id: "13309",
          name: "Roberto Payan",
          state_id: "796",
        },
        {
          id: "13310",
          name: "Samaniego",
          state_id: "796",
        },
        {
          id: "13311",
          name: "San Bernardo",
          state_id: "796",
        },
        {
          id: "13312",
          name: "San Lorenzo",
          state_id: "796",
        },
        {
          id: "13313",
          name: "San Pablo",
          state_id: "796",
        },
        {
          id: "13314",
          name: "San Pedro de Cartago",
          state_id: "796",
        },
        {
          id: "13315",
          name: "Sandona",
          state_id: "796",
        },
        {
          id: "13316",
          name: "Santa Barbara",
          state_id: "796",
        },
        {
          id: "13317",
          name: "Santacruz",
          state_id: "796",
        },
        {
          id: "13318",
          name: "Sapuyes",
          state_id: "796",
        },
        {
          id: "13319",
          name: "Taminango",
          state_id: "796",
        },
        {
          id: "13320",
          name: "Tangua",
          state_id: "796",
        },
        {
          id: "13321",
          name: "Tumaco",
          state_id: "796",
        },
        {
          id: "13322",
          name: "Tuquerres",
          state_id: "796",
        },
        {
          id: "13323",
          name: "Yacuanquer",
          state_id: "796",
        },
      ],
      "Norte de Santander": [],
      Putumayo: [
        {
          id: "13324",
          name: "Colon",
          state_id: "798",
        },
        {
          id: "13325",
          name: "Mocoa",
          state_id: "798",
        },
        {
          id: "13326",
          name: "Orito",
          state_id: "798",
        },
        {
          id: "13327",
          name: "Puerto Asis",
          state_id: "798",
        },
        {
          id: "13328",
          name: "Puerto Caycedo",
          state_id: "798",
        },
        {
          id: "13329",
          name: "Puerto Guzman",
          state_id: "798",
        },
        {
          id: "13330",
          name: "Puerto Leguizamo",
          state_id: "798",
        },
        {
          id: "13331",
          name: "San Francisco",
          state_id: "798",
        },
        {
          id: "13332",
          name: "San Miguel",
          state_id: "798",
        },
        {
          id: "13333",
          name: "Santiago",
          state_id: "798",
        },
        {
          id: "13334",
          name: "Sibundoy",
          state_id: "798",
        },
        {
          id: "13335",
          name: "Valle del Guamuez",
          state_id: "798",
        },
        {
          id: "13336",
          name: "Villagarzon",
          state_id: "798",
        },
      ],
      Quindio: [
        {
          id: "13337",
          name: "Armenia",
          state_id: "799",
        },
        {
          id: "13338",
          name: "Buenavista",
          state_id: "799",
        },
        {
          id: "13339",
          name: "Calarca",
          state_id: "799",
        },
        {
          id: "13340",
          name: "Circasia",
          state_id: "799",
        },
        {
          id: "13341",
          name: "Cordoba",
          state_id: "799",
        },
        {
          id: "13342",
          name: "Filandia",
          state_id: "799",
        },
        {
          id: "13343",
          name: "Genova",
          state_id: "799",
        },
        {
          id: "13344",
          name: "La Tebaida",
          state_id: "799",
        },
        {
          id: "13345",
          name: "Montenegro",
          state_id: "799",
        },
        {
          id: "13346",
          name: "Pijao",
          state_id: "799",
        },
        {
          id: "13347",
          name: "Quimbaya",
          state_id: "799",
        },
        {
          id: "13348",
          name: "Salento",
          state_id: "799",
        },
      ],
      Risaralda: [
        {
          id: "13349",
          name: "Apia",
          state_id: "800",
        },
        {
          id: "13350",
          name: "Balboa",
          state_id: "800",
        },
        {
          id: "13351",
          name: "Belen de Umbria",
          state_id: "800",
        },
        {
          id: "13352",
          name: "Dos Quebradas",
          state_id: "800",
        },
        {
          id: "13353",
          name: "Guatica",
          state_id: "800",
        },
        {
          id: "13354",
          name: "La Celia",
          state_id: "800",
        },
        {
          id: "13355",
          name: "La Virginia",
          state_id: "800",
        },
        {
          id: "13356",
          name: "Marsella",
          state_id: "800",
        },
        {
          id: "13357",
          name: "Mistrato",
          state_id: "800",
        },
        {
          id: "13358",
          name: "Pereira",
          state_id: "800",
        },
        {
          id: "13359",
          name: "Pueblo Rico",
          state_id: "800",
        },
        {
          id: "13360",
          name: "Quinchia",
          state_id: "800",
        },
        {
          id: "13361",
          name: "Santa Rosa de Cabal",
          state_id: "800",
        },
        {
          id: "13362",
          name: "Santuario",
          state_id: "800",
        },
      ],
      "San Andres y Providencia": [],
      Santander: [
        {
          id: "13363",
          name: "Aguada",
          state_id: "802",
        },
        {
          id: "13364",
          name: "Albania",
          state_id: "802",
        },
        {
          id: "13365",
          name: "Aratoca",
          state_id: "802",
        },
        {
          id: "13366",
          name: "Barbosa",
          state_id: "802",
        },
        {
          id: "13367",
          name: "Barichara",
          state_id: "802",
        },
        {
          id: "13368",
          name: "Barrancabermeja",
          state_id: "802",
        },
        {
          id: "13369",
          name: "Betulia",
          state_id: "802",
        },
        {
          id: "13370",
          name: "Bolivar",
          state_id: "802",
        },
        {
          id: "13371",
          name: "Bucaramanga",
          state_id: "802",
        },
        {
          id: "13372",
          name: "Cabrera",
          state_id: "802",
        },
        {
          id: "13373",
          name: "California",
          state_id: "802",
        },
        {
          id: "13374",
          name: "Capitanejo",
          state_id: "802",
        },
        {
          id: "13375",
          name: "Carcasi",
          state_id: "802",
        },
        {
          id: "13376",
          name: "Cepita",
          state_id: "802",
        },
        {
          id: "13377",
          name: "Cerrito",
          state_id: "802",
        },
        {
          id: "13378",
          name: "Charala",
          state_id: "802",
        },
        {
          id: "13379",
          name: "Charta",
          state_id: "802",
        },
        {
          id: "13380",
          name: "Chima",
          state_id: "802",
        },
        {
          id: "13381",
          name: "Chipata",
          state_id: "802",
        },
        {
          id: "13382",
          name: "Cimitarra",
          state_id: "802",
        },
        {
          id: "13383",
          name: "Concepcion",
          state_id: "802",
        },
        {
          id: "13384",
          name: "Confines",
          state_id: "802",
        },
        {
          id: "13385",
          name: "Contratacion",
          state_id: "802",
        },
        {
          id: "13386",
          name: "Coromoro",
          state_id: "802",
        },
        {
          id: "13387",
          name: "Curiti",
          state_id: "802",
        },
        {
          id: "13388",
          name: "El Carmen",
          state_id: "802",
        },
        {
          id: "13389",
          name: "El Guacamayo",
          state_id: "802",
        },
        {
          id: "13390",
          name: "El Penon",
          state_id: "802",
        },
        {
          id: "13391",
          name: "El Playon",
          state_id: "802",
        },
        {
          id: "13392",
          name: "Encino",
          state_id: "802",
        },
        {
          id: "13393",
          name: "Enciso",
          state_id: "802",
        },
        {
          id: "13394",
          name: "Florian",
          state_id: "802",
        },
        {
          id: "13395",
          name: "Floridablanca",
          state_id: "802",
        },
        {
          id: "13396",
          name: "Galan",
          state_id: "802",
        },
        {
          id: "13397",
          name: "Gambita",
          state_id: "802",
        },
        {
          id: "13398",
          name: "Giron",
          state_id: "802",
        },
        {
          id: "13399",
          name: "Guaca",
          state_id: "802",
        },
        {
          id: "13400",
          name: "Guadalupe",
          state_id: "802",
        },
        {
          id: "13401",
          name: "Guapota",
          state_id: "802",
        },
        {
          id: "13402",
          name: "Guavata",
          state_id: "802",
        },
        {
          id: "13403",
          name: "Guepsa",
          state_id: "802",
        },
        {
          id: "13404",
          name: "Hato",
          state_id: "802",
        },
        {
          id: "13405",
          name: "Jesus Maria",
          state_id: "802",
        },
        {
          id: "13406",
          name: "Jordan",
          state_id: "802",
        },
        {
          id: "13407",
          name: "La Belleza",
          state_id: "802",
        },
        {
          id: "13408",
          name: "La Paz",
          state_id: "802",
        },
        {
          id: "13409",
          name: "Landazuri",
          state_id: "802",
        },
        {
          id: "13410",
          name: "Lebrija",
          state_id: "802",
        },
        {
          id: "13411",
          name: "Los Santos",
          state_id: "802",
        },
        {
          id: "13412",
          name: "Macaravita",
          state_id: "802",
        },
        {
          id: "13413",
          name: "Malaga",
          state_id: "802",
        },
        {
          id: "13414",
          name: "Matanza",
          state_id: "802",
        },
        {
          id: "13415",
          name: "Mogotes",
          state_id: "802",
        },
        {
          id: "13416",
          name: "Molagavita",
          state_id: "802",
        },
        {
          id: "13417",
          name: "Ocamonte",
          state_id: "802",
        },
        {
          id: "13418",
          name: "Oiba",
          state_id: "802",
        },
        {
          id: "13419",
          name: "Onzaga",
          state_id: "802",
        },
        {
          id: "13420",
          name: "Palmar",
          state_id: "802",
        },
        {
          id: "13421",
          name: "Palmas del Socorro",
          state_id: "802",
        },
        {
          id: "13422",
          name: "Paramo",
          state_id: "802",
        },
        {
          id: "13423",
          name: "Piedecuesta",
          state_id: "802",
        },
        {
          id: "13424",
          name: "Pinchote",
          state_id: "802",
        },
        {
          id: "13425",
          name: "Puente Nacional",
          state_id: "802",
        },
        {
          id: "13426",
          name: "Puerto Parra",
          state_id: "802",
        },
        {
          id: "13427",
          name: "Puerto Wilches",
          state_id: "802",
        },
        {
          id: "13428",
          name: "Rionegro",
          state_id: "802",
        },
        {
          id: "13429",
          name: "Sabana de Torres",
          state_id: "802",
        },
        {
          id: "13430",
          name: "San Andres",
          state_id: "802",
        },
        {
          id: "13431",
          name: "San Benito",
          state_id: "802",
        },
        {
          id: "13432",
          name: "San Gil",
          state_id: "802",
        },
        {
          id: "13433",
          name: "San Joaquin",
          state_id: "802",
        },
        {
          id: "13434",
          name: "San Jose de Miranda",
          state_id: "802",
        },
        {
          id: "13435",
          name: "San Miguel",
          state_id: "802",
        },
        {
          id: "13436",
          name: "San Vicente de Chucuri",
          state_id: "802",
        },
        {
          id: "13437",
          name: "Santa Barbara",
          state_id: "802",
        },
        {
          id: "13438",
          name: "Santa Helena",
          state_id: "802",
        },
        {
          id: "13439",
          name: "Simacota",
          state_id: "802",
        },
        {
          id: "13440",
          name: "Socorro",
          state_id: "802",
        },
        {
          id: "13441",
          name: "Suaita",
          state_id: "802",
        },
        {
          id: "13442",
          name: "Sucre",
          state_id: "802",
        },
        {
          id: "13443",
          name: "Surata",
          state_id: "802",
        },
        {
          id: "13444",
          name: "Tona",
          state_id: "802",
        },
        {
          id: "13445",
          name: "Valle San Jose",
          state_id: "802",
        },
        {
          id: "13446",
          name: "Velez",
          state_id: "802",
        },
        {
          id: "13447",
          name: "Vetas",
          state_id: "802",
        },
        {
          id: "13448",
          name: "Villanueva",
          state_id: "802",
        },
        {
          id: "13449",
          name: "Zapatoca",
          state_id: "802",
        },
      ],
      Sucre: [
        {
          id: "13450",
          name: "Buenavista",
          state_id: "803",
        },
        {
          id: "13451",
          name: "Caimito",
          state_id: "803",
        },
        {
          id: "13452",
          name: "Chalan",
          state_id: "803",
        },
        {
          id: "13453",
          name: "Coloso",
          state_id: "803",
        },
        {
          id: "13454",
          name: "Corozal",
          state_id: "803",
        },
        {
          id: "13455",
          name: "El Roble",
          state_id: "803",
        },
        {
          id: "13456",
          name: "Galeras",
          state_id: "803",
        },
        {
          id: "13457",
          name: "Guaranda",
          state_id: "803",
        },
        {
          id: "13458",
          name: "La Union",
          state_id: "803",
        },
        {
          id: "13459",
          name: "Los Palmitos",
          state_id: "803",
        },
        {
          id: "13460",
          name: "Majagual",
          state_id: "803",
        },
        {
          id: "13461",
          name: "Morroa",
          state_id: "803",
        },
        {
          id: "13462",
          name: "Ovejas",
          state_id: "803",
        },
        {
          id: "13463",
          name: "Palmito",
          state_id: "803",
        },
        {
          id: "13464",
          name: "Sampues",
          state_id: "803",
        },
        {
          id: "13465",
          name: "San Benito Abad",
          state_id: "803",
        },
        {
          id: "13466",
          name: "San Juan de Betulia",
          state_id: "803",
        },
        {
          id: "13467",
          name: "San Marcos",
          state_id: "803",
        },
        {
          id: "13468",
          name: "San Onofre",
          state_id: "803",
        },
        {
          id: "13469",
          name: "San Pedro",
          state_id: "803",
        },
        {
          id: "13470",
          name: "Since",
          state_id: "803",
        },
        {
          id: "13471",
          name: "Sincelejo",
          state_id: "803",
        },
        {
          id: "13472",
          name: "Sucre",
          state_id: "803",
        },
        {
          id: "13473",
          name: "Tolu",
          state_id: "803",
        },
        {
          id: "13474",
          name: "Toluviejo",
          state_id: "803",
        },
      ],
      Tolima: [
        {
          id: "13475",
          name: "Alpujarra",
          state_id: "804",
        },
        {
          id: "13476",
          name: "Alvarado",
          state_id: "804",
        },
        {
          id: "13477",
          name: "Ambalema",
          state_id: "804",
        },
        {
          id: "13478",
          name: "Anzoategui",
          state_id: "804",
        },
        {
          id: "13479",
          name: "Ataco",
          state_id: "804",
        },
        {
          id: "13480",
          name: "Cajamarca",
          state_id: "804",
        },
        {
          id: "13481",
          name: "Carmen de Apicala",
          state_id: "804",
        },
        {
          id: "13482",
          name: "Casabianca",
          state_id: "804",
        },
        {
          id: "13483",
          name: "Chaparral",
          state_id: "804",
        },
        {
          id: "13484",
          name: "Coello",
          state_id: "804",
        },
        {
          id: "13485",
          name: "Coyaima",
          state_id: "804",
        },
        {
          id: "13486",
          name: "Cunday",
          state_id: "804",
        },
        {
          id: "13487",
          name: "Dolores",
          state_id: "804",
        },
        {
          id: "13488",
          name: "Espinal",
          state_id: "804",
        },
        {
          id: "13489",
          name: "Falan",
          state_id: "804",
        },
        {
          id: "13490",
          name: "Flandes",
          state_id: "804",
        },
        {
          id: "13491",
          name: "Fresno",
          state_id: "804",
        },
        {
          id: "13492",
          name: "Guamo",
          state_id: "804",
        },
        {
          id: "13493",
          name: "Guayabal",
          state_id: "804",
        },
        {
          id: "13494",
          name: "Herveo",
          state_id: "804",
        },
        {
          id: "13495",
          name: "Honda",
          state_id: "804",
        },
        {
          id: "13496",
          name: "Ibague",
          state_id: "804",
        },
        {
          id: "13497",
          name: "Icononzo",
          state_id: "804",
        },
        {
          id: "13498",
          name: "Lerida",
          state_id: "804",
        },
        {
          id: "13499",
          name: "Libano",
          state_id: "804",
        },
        {
          id: "13500",
          name: "Mariquita",
          state_id: "804",
        },
        {
          id: "13501",
          name: "Melgar",
          state_id: "804",
        },
        {
          id: "13502",
          name: "Murillo",
          state_id: "804",
        },
        {
          id: "13503",
          name: "Natagaima",
          state_id: "804",
        },
        {
          id: "13504",
          name: "Ortega",
          state_id: "804",
        },
        {
          id: "13505",
          name: "Palocabildo",
          state_id: "804",
        },
        {
          id: "13506",
          name: "Piedras",
          state_id: "804",
        },
        {
          id: "13507",
          name: "Planadas",
          state_id: "804",
        },
        {
          id: "13508",
          name: "Prado",
          state_id: "804",
        },
        {
          id: "13509",
          name: "Purificacion",
          state_id: "804",
        },
        {
          id: "13510",
          name: "Rioblanco",
          state_id: "804",
        },
        {
          id: "13511",
          name: "Roncesvalles",
          state_id: "804",
        },
        {
          id: "13512",
          name: "Rovira",
          state_id: "804",
        },
        {
          id: "13513",
          name: "Saldana",
          state_id: "804",
        },
        {
          id: "13514",
          name: "San Antonio",
          state_id: "804",
        },
        {
          id: "13515",
          name: "San Luis",
          state_id: "804",
        },
        {
          id: "13516",
          name: "Santa Isabel",
          state_id: "804",
        },
        {
          id: "13517",
          name: "Suarez",
          state_id: "804",
        },
        {
          id: "13518",
          name: "Valle de San Juan",
          state_id: "804",
        },
        {
          id: "13519",
          name: "Venadillo",
          state_id: "804",
        },
        {
          id: "13520",
          name: "Villahermosa",
          state_id: "804",
        },
        {
          id: "13521",
          name: "Villarrica",
          state_id: "804",
        },
      ],
      "Valle del Cauca": [],
      Vaupes: [
        {
          id: "13522",
          name: "Acaricuara",
          state_id: "806",
        },
        {
          id: "13523",
          name: "Mitu",
          state_id: "806",
        },
        {
          id: "13524",
          name: "Papunaua",
          state_id: "806",
        },
        {
          id: "13525",
          name: "Taraira",
          state_id: "806",
        },
        {
          id: "13526",
          name: "Villa Fatima",
          state_id: "806",
        },
        {
          id: "13527",
          name: "Yavarate",
          state_id: "806",
        },
      ],
      Vichada: [
        {
          id: "13528",
          name: "Cumaribo",
          state_id: "807",
        },
        {
          id: "13529",
          name: "La Primavera",
          state_id: "807",
        },
        {
          id: "13530",
          name: "Puerto Carreno",
          state_id: "807",
        },
        {
          id: "13531",
          name: "Santa Rosalia",
          state_id: "807",
        },
      ],
    },
  },
  CR: {
    name: "Costa Rica",
    native: "Costa Rica",
    phone: "506",
    continent: "NA",
    capital: "San José",
    currency: "CRC",
    languages: ["es"],
    emoji: "🇨🇷",
    emojiU: "U+1F1E8 U+1F1F7",
    states: {
      Alajuela: [
        {
          id: "13702",
          name: "Alajuela",
          state_id: "843",
        },
        {
          id: "13703",
          name: "Atenas",
          state_id: "843",
        },
        {
          id: "13704",
          name: "Bijagua",
          state_id: "843",
        },
        {
          id: "13705",
          name: "Buenos Aires",
          state_id: "843",
        },
        {
          id: "13706",
          name: "Carrillos",
          state_id: "843",
        },
        {
          id: "13707",
          name: "Desemparados",
          state_id: "843",
        },
        {
          id: "13708",
          name: "Dos Rios",
          state_id: "843",
        },
        {
          id: "13709",
          name: "Esquipulas",
          state_id: "843",
        },
        {
          id: "13710",
          name: "Florencia",
          state_id: "843",
        },
        {
          id: "13711",
          name: "Fortuna",
          state_id: "843",
        },
        {
          id: "13712",
          name: "Grecia",
          state_id: "843",
        },
        {
          id: "13713",
          name: "Guacimo",
          state_id: "843",
        },
        {
          id: "13714",
          name: "Laguna",
          state_id: "843",
        },
        {
          id: "13715",
          name: "Los Chiles",
          state_id: "843",
        },
        {
          id: "13716",
          name: "Mastate",
          state_id: "843",
        },
        {
          id: "13717",
          name: "Naranjo",
          state_id: "843",
        },
        {
          id: "13718",
          name: "Orotina",
          state_id: "843",
        },
        {
          id: "13719",
          name: "Palmares",
          state_id: "843",
        },
        {
          id: "13720",
          name: "Piedades Norte",
          state_id: "843",
        },
        {
          id: "13721",
          name: "Pital",
          state_id: "843",
        },
        {
          id: "13722",
          name: "Pocosol",
          state_id: "843",
        },
        {
          id: "13723",
          name: "Quesada",
          state_id: "843",
        },
        {
          id: "13724",
          name: "Rio Segundo",
          state_id: "843",
        },
        {
          id: "13725",
          name: "Sabanilla",
          state_id: "843",
        },
        {
          id: "13726",
          name: "San Antonio",
          state_id: "843",
        },
        {
          id: "13727",
          name: "San Jose",
          state_id: "843",
        },
        {
          id: "13728",
          name: "San Juan",
          state_id: "843",
        },
        {
          id: "13729",
          name: "San Mateo",
          state_id: "843",
        },
        {
          id: "13730",
          name: "San Pedro",
          state_id: "843",
        },
        {
          id: "13731",
          name: "San Rafael",
          state_id: "843",
        },
        {
          id: "13732",
          name: "San Ramon",
          state_id: "843",
        },
        {
          id: "13733",
          name: "San Roque",
          state_id: "843",
        },
        {
          id: "13734",
          name: "Santiago",
          state_id: "843",
        },
        {
          id: "13735",
          name: "Sarchi Norte",
          state_id: "843",
        },
        {
          id: "13736",
          name: "Sarchi Sur",
          state_id: "843",
        },
        {
          id: "13737",
          name: "Tigra",
          state_id: "843",
        },
        {
          id: "13738",
          name: "Turricares",
          state_id: "843",
        },
        {
          id: "13739",
          name: "Upala",
          state_id: "843",
        },
        {
          id: "13740",
          name: "Venado",
          state_id: "843",
        },
        {
          id: "13741",
          name: "Zarcero",
          state_id: "843",
        },
      ],
      Cartago: [
        {
          id: "13742",
          name: "Aguacaliente",
          state_id: "844",
        },
        {
          id: "13743",
          name: "Capellades",
          state_id: "844",
        },
        {
          id: "13744",
          name: "Carmen",
          state_id: "844",
        },
        {
          id: "13745",
          name: "Cartago",
          state_id: "844",
        },
        {
          id: "13746",
          name: "Concepcion",
          state_id: "844",
        },
        {
          id: "13747",
          name: "Cot",
          state_id: "844",
        },
        {
          id: "13748",
          name: "Dulce Nombre",
          state_id: "844",
        },
        {
          id: "13749",
          name: "El Tejar",
          state_id: "844",
        },
        {
          id: "13750",
          name: "Guadalupe",
          state_id: "844",
        },
        {
          id: "13751",
          name: "Juan Vinas",
          state_id: "844",
        },
        {
          id: "13752",
          name: "La Suiza",
          state_id: "844",
        },
        {
          id: "13753",
          name: "Orosi",
          state_id: "844",
        },
        {
          id: "13754",
          name: "Pacayas",
          state_id: "844",
        },
        {
          id: "13755",
          name: "Paraiso",
          state_id: "844",
        },
        {
          id: "13756",
          name: "Pejibaye",
          state_id: "844",
        },
        {
          id: "13757",
          name: "San Diego",
          state_id: "844",
        },
        {
          id: "13758",
          name: "San Isidro",
          state_id: "844",
        },
        {
          id: "13759",
          name: "San Juan",
          state_id: "844",
        },
        {
          id: "13760",
          name: "San Nicolas",
          state_id: "844",
        },
        {
          id: "13761",
          name: "San Rafael",
          state_id: "844",
        },
        {
          id: "13762",
          name: "San Ramon",
          state_id: "844",
        },
        {
          id: "13763",
          name: "Tierra Blanca",
          state_id: "844",
        },
        {
          id: "13764",
          name: "Tobosi",
          state_id: "844",
        },
        {
          id: "13765",
          name: "Tres Rios",
          state_id: "844",
        },
        {
          id: "13766",
          name: "Tucurrique",
          state_id: "844",
        },
        {
          id: "13767",
          name: "Turrialba",
          state_id: "844",
        },
      ],
      Guanacaste: [
        {
          id: "13768",
          name: "Bagaces",
          state_id: "845",
        },
        {
          id: "13769",
          name: "Belen",
          state_id: "845",
        },
        {
          id: "13770",
          name: "Canas",
          state_id: "845",
        },
        {
          id: "13771",
          name: "Filadeldia",
          state_id: "845",
        },
        {
          id: "13772",
          name: "Fortuna",
          state_id: "845",
        },
        {
          id: "13773",
          name: "Hojancha",
          state_id: "845",
        },
        {
          id: "13774",
          name: "Juntas",
          state_id: "845",
        },
        {
          id: "13775",
          name: "La Cruz",
          state_id: "845",
        },
        {
          id: "13776",
          name: "Liberia",
          state_id: "845",
        },
        {
          id: "13777",
          name: "Mogote",
          state_id: "845",
        },
        {
          id: "13778",
          name: "Nandayure",
          state_id: "845",
        },
        {
          id: "13779",
          name: "Nicoya",
          state_id: "845",
        },
        {
          id: "13780",
          name: "Samara",
          state_id: "845",
        },
        {
          id: "13781",
          name: "Santa Cruz",
          state_id: "845",
        },
        {
          id: "13782",
          name: "Sardinal",
          state_id: "845",
        },
        {
          id: "13783",
          name: "Tilaran",
          state_id: "845",
        },
      ],
      Heredia: [
        {
          id: "13784",
          name: "Angeles",
          state_id: "846",
        },
        {
          id: "13785",
          name: "Asuncion",
          state_id: "846",
        },
        {
          id: "13786",
          name: "Barrantes",
          state_id: "846",
        },
        {
          id: "13787",
          name: "Barva",
          state_id: "846",
        },
        {
          id: "13788",
          name: "Heredia",
          state_id: "846",
        },
        {
          id: "13789",
          name: "Horquetas",
          state_id: "846",
        },
        {
          id: "13790",
          name: "Llorente",
          state_id: "846",
        },
        {
          id: "13791",
          name: "Mercedes",
          state_id: "846",
        },
        {
          id: "13792",
          name: "Puerto Viejo",
          state_id: "846",
        },
        {
          id: "13793",
          name: "Rivera",
          state_id: "846",
        },
        {
          id: "13794",
          name: "San Antonio",
          state_id: "846",
        },
        {
          id: "13795",
          name: "San Francisco",
          state_id: "846",
        },
        {
          id: "13796",
          name: "San Isidro",
          state_id: "846",
        },
        {
          id: "13797",
          name: "San Joaquin",
          state_id: "846",
        },
        {
          id: "13798",
          name: "San Jose",
          state_id: "846",
        },
        {
          id: "13799",
          name: "San Josecito",
          state_id: "846",
        },
        {
          id: "13800",
          name: "San Juan",
          state_id: "846",
        },
        {
          id: "13801",
          name: "San Miguel",
          state_id: "846",
        },
        {
          id: "13802",
          name: "San Pablo",
          state_id: "846",
        },
        {
          id: "13803",
          name: "San Pedro",
          state_id: "846",
        },
        {
          id: "13804",
          name: "San Rafael",
          state_id: "846",
        },
        {
          id: "13805",
          name: "San Roque",
          state_id: "846",
        },
        {
          id: "13806",
          name: "San Vicente",
          state_id: "846",
        },
        {
          id: "13807",
          name: "Santa Barbara",
          state_id: "846",
        },
        {
          id: "13808",
          name: "Santa Lucia",
          state_id: "846",
        },
        {
          id: "13809",
          name: "Santa Rosa",
          state_id: "846",
        },
        {
          id: "13810",
          name: "Santiago",
          state_id: "846",
        },
        {
          id: "13811",
          name: "Santo Domingo",
          state_id: "846",
        },
        {
          id: "13812",
          name: "Santo Tomas",
          state_id: "846",
        },
        {
          id: "13813",
          name: "Ulloa",
          state_id: "846",
        },
      ],
      Limon: [
        {
          id: "13814",
          name: "Batan",
          state_id: "847",
        },
        {
          id: "13815",
          name: "Cahuita",
          state_id: "847",
        },
        {
          id: "13816",
          name: "Cariari",
          state_id: "847",
        },
        {
          id: "13817",
          name: "Guacimo",
          state_id: "847",
        },
        {
          id: "13818",
          name: "Guapiles",
          state_id: "847",
        },
        {
          id: "13819",
          name: "Jimenez",
          state_id: "847",
        },
        {
          id: "13820",
          name: "Limon",
          state_id: "847",
        },
        {
          id: "13821",
          name: "Matina",
          state_id: "847",
        },
        {
          id: "13822",
          name: "Pocora",
          state_id: "847",
        },
        {
          id: "13823",
          name: "Rita",
          state_id: "847",
        },
        {
          id: "13824",
          name: "Roxana",
          state_id: "847",
        },
        {
          id: "13825",
          name: "Siquirres",
          state_id: "847",
        },
        {
          id: "13826",
          name: "Sixaola",
          state_id: "847",
        },
        {
          id: "13827",
          name: "Valle la Estrella",
          state_id: "847",
        },
      ],
      Puntarenas: [
        {
          id: "13828",
          name: "Buenos Aires",
          state_id: "848",
        },
        {
          id: "13829",
          name: "Canoas",
          state_id: "848",
        },
        {
          id: "13830",
          name: "Chacarita",
          state_id: "848",
        },
        {
          id: "13831",
          name: "Corredor",
          state_id: "848",
        },
        {
          id: "13832",
          name: "Esparta",
          state_id: "848",
        },
        {
          id: "13833",
          name: "Espiritu Santo",
          state_id: "848",
        },
        {
          id: "13834",
          name: "Golfito",
          state_id: "848",
        },
        {
          id: "13835",
          name: "Guaycara",
          state_id: "848",
        },
        {
          id: "13836",
          name: "Jaco",
          state_id: "848",
        },
        {
          id: "13837",
          name: "La Cuesta",
          state_id: "848",
        },
        {
          id: "13838",
          name: "Macacona",
          state_id: "848",
        },
        {
          id: "13839",
          name: "Manzanillo",
          state_id: "848",
        },
        {
          id: "13840",
          name: "Miramar",
          state_id: "848",
        },
        {
          id: "13841",
          name: "Palmar",
          state_id: "848",
        },
        {
          id: "13842",
          name: "Paquera",
          state_id: "848",
        },
        {
          id: "13843",
          name: "Parrita",
          state_id: "848",
        },
        {
          id: "13844",
          name: "Puerto Cortes",
          state_id: "848",
        },
        {
          id: "13845",
          name: "Puerto Jimenez",
          state_id: "848",
        },
        {
          id: "13846",
          name: "Puntarenas",
          state_id: "848",
        },
        {
          id: "13847",
          name: "Quepos",
          state_id: "848",
        },
        {
          id: "13848",
          name: "San Vito",
          state_id: "848",
        },
      ],
      "San Jose": [],
    },
  },
  CU: {
    name: "Cuba",
    native: "Cuba",
    phone: "53",
    continent: "NA",
    capital: "Havana",
    currency: "CUC,CUP",
    languages: ["es"],
    emoji: "🇨🇺",
    emojiU: "U+1F1E8 U+1F1FA",
    states: {
      Camaguey: [
        {
          id: "14546",
          name: "Camaguey",
          state_id: "893",
        },
        {
          id: "14547",
          name: "Caney",
          state_id: "893",
        },
        {
          id: "14548",
          name: "Carlos Manuel de Cespedes",
          state_id: "893",
        },
        {
          id: "14549",
          name: "Esmeralda",
          state_id: "893",
        },
        {
          id: "14550",
          name: "Florida",
          state_id: "893",
        },
        {
          id: "14551",
          name: "Guaimaro",
          state_id: "893",
        },
        {
          id: "14552",
          name: "Minas",
          state_id: "893",
        },
        {
          id: "14553",
          name: "Nuevitas",
          state_id: "893",
        },
        {
          id: "14554",
          name: "Santa Cruz del Sur",
          state_id: "893",
        },
        {
          id: "14555",
          name: "Sibanicu",
          state_id: "893",
        },
        {
          id: "14556",
          name: "Vertientes",
          state_id: "893",
        },
      ],
      "Ciego de Avila": [],
      Cienfuegos: [
        {
          id: "14557",
          name: "Cienfuegos",
          state_id: "895",
        },
        {
          id: "14558",
          name: "Cruces",
          state_id: "895",
        },
        {
          id: "14559",
          name: "Cumanayagua",
          state_id: "895",
        },
        {
          id: "14560",
          name: "Palmira",
          state_id: "895",
        },
        {
          id: "14561",
          name: "Rodas",
          state_id: "895",
        },
      ],
      "Ciudad de la Habana": [],
      Granma: [
        {
          id: "14562",
          name: "Bayamo",
          state_id: "897",
        },
        {
          id: "14563",
          name: "Campechuela",
          state_id: "897",
        },
        {
          id: "14564",
          name: "Guisa",
          state_id: "897",
        },
        {
          id: "14565",
          name: "Jiguani",
          state_id: "897",
        },
        {
          id: "14566",
          name: "Manzanillo",
          state_id: "897",
        },
        {
          id: "14567",
          name: "Media Luna",
          state_id: "897",
        },
        {
          id: "14568",
          name: "Niquero",
          state_id: "897",
        },
        {
          id: "14569",
          name: "Pilon",
          state_id: "897",
        },
        {
          id: "14570",
          name: "Rio Cauto",
          state_id: "897",
        },
        {
          id: "14571",
          name: "Yara",
          state_id: "897",
        },
      ],
      Guantanamo: [
        {
          id: "14572",
          name: "Baracoa",
          state_id: "898",
        },
        {
          id: "14573",
          name: "Guantanamo",
          state_id: "898",
        },
        {
          id: "14574",
          name: "Yateras",
          state_id: "898",
        },
      ],
      Habana: [
        {
          id: "14575",
          name: "Havana",
          state_id: "899",
        },
      ],
      Holguin: [
        {
          id: "14576",
          name: "Antilla",
          state_id: "900",
        },
        {
          id: "14577",
          name: "Baguanos",
          state_id: "900",
        },
        {
          id: "14578",
          name: "Banes",
          state_id: "900",
        },
        {
          id: "14579",
          name: "Cacocum",
          state_id: "900",
        },
        {
          id: "14580",
          name: "Cauto Cristo",
          state_id: "900",
        },
        {
          id: "14581",
          name: "Cueto",
          state_id: "900",
        },
        {
          id: "14582",
          name: "Gibara",
          state_id: "900",
        },
        {
          id: "14583",
          name: "Holguin",
          state_id: "900",
        },
        {
          id: "14584",
          name: "Jobabo",
          state_id: "900",
        },
        {
          id: "14585",
          name: "Moa",
          state_id: "900",
        },
        {
          id: "14586",
          name: "Sagua de Tanamo",
          state_id: "900",
        },
      ],
      "Isla de la Juventud": [],
      "La Habana": [],
      "Las Tunas": [],
      Matanzas: [
        {
          id: "14587",
          name: "Abreus",
          state_id: "904",
        },
        {
          id: "14588",
          name: "Agramonte",
          state_id: "904",
        },
        {
          id: "14589",
          name: "Aguacate",
          state_id: "904",
        },
        {
          id: "14590",
          name: "Aguada de Pasajeros",
          state_id: "904",
        },
        {
          id: "14591",
          name: "Alacranes",
          state_id: "904",
        },
        {
          id: "14592",
          name: "Bolondron",
          state_id: "904",
        },
        {
          id: "14593",
          name: "Calimete",
          state_id: "904",
        },
        {
          id: "14594",
          name: "Cardenas",
          state_id: "904",
        },
        {
          id: "14595",
          name: "Carlos Rojas",
          state_id: "904",
        },
        {
          id: "14596",
          name: "Colon",
          state_id: "904",
        },
        {
          id: "14597",
          name: "Corralillo",
          state_id: "904",
        },
        {
          id: "14598",
          name: "Jaguey Grande",
          state_id: "904",
        },
        {
          id: "14599",
          name: "Jovellanos",
          state_id: "904",
        },
        {
          id: "14600",
          name: "Juan Gualberto Gomez",
          state_id: "904",
        },
        {
          id: "14601",
          name: "Los Arabos",
          state_id: "904",
        },
        {
          id: "14602",
          name: "Manguito",
          state_id: "904",
        },
        {
          id: "14603",
          name: "Marti",
          state_id: "904",
        },
        {
          id: "14604",
          name: "Matanzas",
          state_id: "904",
        },
        {
          id: "14605",
          name: "Maximo Gomez",
          state_id: "904",
        },
        {
          id: "14606",
          name: "Pedro Betancourt",
          state_id: "904",
        },
        {
          id: "14607",
          name: "Perico",
          state_id: "904",
        },
        {
          id: "14608",
          name: "Union de Reyes",
          state_id: "904",
        },
        {
          id: "14609",
          name: "Varadero",
          state_id: "904",
        },
      ],
      "Pinar del Rio": [],
      "Sancti Spiritus": [],
      "Santiago de Cuba": [],
      "Villa Clara": [],
    },
  },
  CV: {
    name: "Cape Verde",
    native: "Cabo Verde",
    phone: "238",
    continent: "AF",
    capital: "Praia",
    currency: "CVE",
    languages: ["pt"],
    emoji: "🇨🇻",
    emojiU: "U+1F1E8 U+1F1FB",
    states: {
      Boavista: [
        {
          id: "10869",
          name: "Sal Rei",
          state_id: "676",
        },
      ],
      Brava: [
        {
          id: "10870",
          name: "Nova Sintra",
          state_id: "677",
        },
      ],
      Fogo: [
        {
          id: "10871",
          name: "Mosteiros",
          state_id: "678",
        },
        {
          id: "10872",
          name: "Sao Filipe",
          state_id: "678",
        },
      ],
      Maio: [
        {
          id: "10873",
          name: "Vila do Maio",
          state_id: "679",
        },
      ],
      Sal: [
        {
          id: "10874",
          name: "Santa Maria",
          state_id: "680",
        },
      ],
      "Santo Antao": [],
      "Sao Nicolau": [],
      "Sao Tiago": [],
      "Sao Vicente": [],
    },
  },
  CW: {
    name: "Curacao",
    native: "Curaçao",
    phone: "5999",
    continent: "NA",
    capital: "Willemstad",
    currency: "ANG",
    languages: ["nl", "pa", "en"],
    emoji: "🇨🇼",
    emojiU: "U+1F1E8 U+1F1FC",
    states: {},
  },
  CX: {
    name: "Christmas Island",
    native: "Christmas Island",
    phone: "61",
    continent: "AS",
    capital: "Flying Fish Cove",
    currency: "AUD",
    languages: ["en"],
    emoji: "🇨🇽",
    emojiU: "U+1F1E8 U+1F1FD",
    states: {
      "Christmas Island": [],
    },
  },
  CY: {
    name: "Cyprus",
    native: "Κύπρος",
    phone: "357",
    continent: "EU",
    capital: "Nicosia",
    currency: "EUR",
    languages: ["el", "tr", "hy"],
    emoji: "🇨🇾",
    emojiU: "U+1F1E8 U+1F1FE",
    states: {
      "Government controlled area": [],
      Limassol: [
        {
          id: "14610",
          name: "Limassol",
          state_id: "910",
        },
      ],
      "Nicosia District": [],
      Paphos: [
        {
          id: "14611",
          name: "Paphos",
          state_id: "912",
        },
      ],
      "Turkish controlled area": [],
    },
  },
  CZ: {
    name: "Czech Republic",
    native: "Česká republika",
    phone: "420",
    continent: "EU",
    capital: "Prague",
    currency: "CZK",
    languages: ["cs", "sk"],
    emoji: "🇨🇿",
    emojiU: "U+1F1E8 U+1F1FF",
    states: {
      "Central Bohemian": [],
      Frycovice: [
        {
          id: "14612",
          name: "Frycovice",
          state_id: "915",
        },
      ],
      "Jihocesky Kraj": [],
      Jihochesky: [
        {
          id: "14613",
          name: "Bechyne",
          state_id: "917",
        },
        {
          id: "14614",
          name: "Blatna",
          state_id: "917",
        },
        {
          id: "14615",
          name: "Cheske Budejovice",
          state_id: "917",
        },
        {
          id: "14616",
          name: "Chesky Krumlov",
          state_id: "917",
        },
        {
          id: "14617",
          name: "Dachice",
          state_id: "917",
        },
        {
          id: "14618",
          name: "Jindrichuv Hradec",
          state_id: "917",
        },
        {
          id: "14619",
          name: "Kaplice",
          state_id: "917",
        },
        {
          id: "14620",
          name: "Milevsko",
          state_id: "917",
        },
        {
          id: "14621",
          name: "Pisek",
          state_id: "917",
        },
        {
          id: "14622",
          name: "Prachatice",
          state_id: "917",
        },
        {
          id: "14623",
          name: "Protivin",
          state_id: "917",
        },
        {
          id: "14624",
          name: "Sezimovo Usti",
          state_id: "917",
        },
        {
          id: "14625",
          name: "Sobeslav",
          state_id: "917",
        },
        {
          id: "14626",
          name: "Strakonice",
          state_id: "917",
        },
        {
          id: "14627",
          name: "Tabor",
          state_id: "917",
        },
        {
          id: "14628",
          name: "Trebon",
          state_id: "917",
        },
        {
          id: "14629",
          name: "Tyn nad Vltavou",
          state_id: "917",
        },
        {
          id: "14630",
          name: "Veseli nad Luzhnici",
          state_id: "917",
        },
        {
          id: "14631",
          name: "Vimperk",
          state_id: "917",
        },
        {
          id: "14632",
          name: "Vodnany",
          state_id: "917",
        },
      ],
      Jihomoravsky: [
        {
          id: "14633",
          name: "Adamov",
          state_id: "918",
        },
        {
          id: "14634",
          name: "Blansko",
          state_id: "918",
        },
        {
          id: "14635",
          name: "Boskovice",
          state_id: "918",
        },
        {
          id: "14636",
          name: "Breclav",
          state_id: "918",
        },
        {
          id: "14637",
          name: "Brno",
          state_id: "918",
        },
        {
          id: "14638",
          name: "Buchovice",
          state_id: "918",
        },
        {
          id: "14639",
          name: "Dubnany",
          state_id: "918",
        },
        {
          id: "14640",
          name: "Hodonin",
          state_id: "918",
        },
        {
          id: "14641",
          name: "Hrusky",
          state_id: "918",
        },
        {
          id: "14642",
          name: "Hustopeche",
          state_id: "918",
        },
        {
          id: "14643",
          name: "Ivanchice",
          state_id: "918",
        },
        {
          id: "14644",
          name: "Kurim",
          state_id: "918",
        },
        {
          id: "14645",
          name: "Kyjov",
          state_id: "918",
        },
        {
          id: "14646",
          name: "Letovice",
          state_id: "918",
        },
        {
          id: "14647",
          name: "Mikulov",
          state_id: "918",
        },
        {
          id: "14648",
          name: "Moravsky Krumlov",
          state_id: "918",
        },
        {
          id: "14649",
          name: "Namesht'' nad Oslavou",
          state_id: "918",
        },
        {
          id: "14650",
          name: "Rosice",
          state_id: "918",
        },
        {
          id: "14651",
          name: "Shlapanice",
          state_id: "918",
        },
        {
          id: "14652",
          name: "Slavkov u Brna",
          state_id: "918",
        },
        {
          id: "14653",
          name: "Tishnov",
          state_id: "918",
        },
        {
          id: "14654",
          name: "Vyshkov",
          state_id: "918",
        },
        {
          id: "14655",
          name: "Znojmo",
          state_id: "918",
        },
      ],
      Karlovarsky: [
        {
          id: "14656",
          name: "Ash",
          state_id: "919",
        },
        {
          id: "14657",
          name: "Bozicany",
          state_id: "919",
        },
        {
          id: "14658",
          name: "Cheb",
          state_id: "919",
        },
        {
          id: "14659",
          name: "Chodov",
          state_id: "919",
        },
        {
          id: "14660",
          name: "Frantishkovy Lazne",
          state_id: "919",
        },
        {
          id: "14661",
          name: "Horni Slavkov",
          state_id: "919",
        },
        {
          id: "14662",
          name: "Karlovy Vary",
          state_id: "919",
        },
        {
          id: "14663",
          name: "Kraslice",
          state_id: "919",
        },
        {
          id: "14664",
          name: "Kynshperk nad Ohri",
          state_id: "919",
        },
        {
          id: "14665",
          name: "Marianske Lazne",
          state_id: "919",
        },
        {
          id: "14666",
          name: "Nejdek",
          state_id: "919",
        },
        {
          id: "14667",
          name: "Ostrov",
          state_id: "919",
        },
        {
          id: "14668",
          name: "Sokolov",
          state_id: "919",
        },
      ],
      Klecany: [
        {
          id: "14669",
          name: "Klecany",
          state_id: "920",
        },
      ],
      Kralovehradecky: [
        {
          id: "14670",
          name: "Broumov",
          state_id: "921",
        },
        {
          id: "14671",
          name: "Cherveny Kostelec",
          state_id: "921",
        },
        {
          id: "14672",
          name: "Cheska Skalice",
          state_id: "921",
        },
        {
          id: "14673",
          name: "Chlumec nad Cidlinou",
          state_id: "921",
        },
        {
          id: "14674",
          name: "Dobrushka",
          state_id: "921",
        },
        {
          id: "14675",
          name: "Dvur Kralove",
          state_id: "921",
        },
        {
          id: "14676",
          name: "Habartov",
          state_id: "921",
        },
        {
          id: "14677",
          name: "Holice",
          state_id: "921",
        },
        {
          id: "14678",
          name: "Horice",
          state_id: "921",
        },
        {
          id: "14679",
          name: "Hostinne",
          state_id: "921",
        },
        {
          id: "14680",
          name: "Hradec Kralove",
          state_id: "921",
        },
        {
          id: "14681",
          name: "Hronov",
          state_id: "921",
        },
        {
          id: "14682",
          name: "Jaromer",
          state_id: "921",
        },
        {
          id: "14683",
          name: "Jichin",
          state_id: "921",
        },
        {
          id: "14684",
          name: "Kostelec nad Orlici",
          state_id: "921",
        },
        {
          id: "14685",
          name: "Nachod",
          state_id: "921",
        },
        {
          id: "14686",
          name: "Nova Paka",
          state_id: "921",
        },
        {
          id: "14687",
          name: "Nove Mesto nad Metuji",
          state_id: "921",
        },
        {
          id: "14688",
          name: "Novy Bydzhov",
          state_id: "921",
        },
        {
          id: "14689",
          name: "Rychnov nad Knezhnou",
          state_id: "921",
        },
        {
          id: "14690",
          name: "Trebechovice pod Orebem",
          state_id: "921",
        },
        {
          id: "14691",
          name: "Trutnov",
          state_id: "921",
        },
        {
          id: "14692",
          name: "Tynishte nad Orlici",
          state_id: "921",
        },
        {
          id: "14693",
          name: "Upice",
          state_id: "921",
        },
        {
          id: "14694",
          name: "Vrchlabi",
          state_id: "921",
        },
      ],
      Liberecky: [
        {
          id: "14695",
          name: "Ceska Lipa",
          state_id: "922",
        },
        {
          id: "14696",
          name: "Cheska Kamenice",
          state_id: "922",
        },
        {
          id: "14697",
          name: "Cheska Lipa",
          state_id: "922",
        },
        {
          id: "14698",
          name: "Chrastava",
          state_id: "922",
        },
        {
          id: "14699",
          name: "Doksy",
          state_id: "922",
        },
        {
          id: "14700",
          name: "Frydlant",
          state_id: "922",
        },
        {
          id: "14701",
          name: "Hradek",
          state_id: "922",
        },
        {
          id: "14702",
          name: "Jablonec",
          state_id: "922",
        },
        {
          id: "14703",
          name: "Jilemnice",
          state_id: "922",
        },
        {
          id: "14704",
          name: "Liberec",
          state_id: "922",
        },
        {
          id: "14705",
          name: "Lomnice nad Popelkou",
          state_id: "922",
        },
        {
          id: "14706",
          name: "Mimon",
          state_id: "922",
        },
        {
          id: "14707",
          name: "Novy Bor",
          state_id: "922",
        },
        {
          id: "14708",
          name: "Semily",
          state_id: "922",
        },
        {
          id: "14709",
          name: "Tanvald",
          state_id: "922",
        },
        {
          id: "14710",
          name: "Turnov",
          state_id: "922",
        },
        {
          id: "14711",
          name: "Zhelezny Brod",
          state_id: "922",
        },
      ],
      Lipov: [
        {
          id: "14712",
          name: "Lipov",
          state_id: "923",
        },
      ],
      Moravskoslezsky: [
        {
          id: "14713",
          name: "Bilovec",
          state_id: "924",
        },
        {
          id: "14714",
          name: "Bohumin",
          state_id: "924",
        },
        {
          id: "14715",
          name: "Bruntal",
          state_id: "924",
        },
        {
          id: "14716",
          name: "Chesky Teshin",
          state_id: "924",
        },
        {
          id: "14717",
          name: "Frenshtat",
          state_id: "924",
        },
        {
          id: "14718",
          name: "Frydek-Mistek",
          state_id: "924",
        },
        {
          id: "14719",
          name: "Frydlant nad Ostravici",
          state_id: "924",
        },
        {
          id: "14720",
          name: "Fulnek",
          state_id: "924",
        },
        {
          id: "14721",
          name: "Havirov",
          state_id: "924",
        },
        {
          id: "14722",
          name: "Hluchin",
          state_id: "924",
        },
        {
          id: "14723",
          name: "Hradec nad Moravice",
          state_id: "924",
        },
        {
          id: "14724",
          name: "Jablunkov",
          state_id: "924",
        },
        {
          id: "14725",
          name: "Karvina",
          state_id: "924",
        },
        {
          id: "14726",
          name: "Koprivnice",
          state_id: "924",
        },
        {
          id: "14727",
          name: "Kravare",
          state_id: "924",
        },
        {
          id: "14728",
          name: "Krnov",
          state_id: "924",
        },
        {
          id: "14729",
          name: "Novy Jichin",
          state_id: "924",
        },
        {
          id: "14730",
          name: "Odry",
          state_id: "924",
        },
        {
          id: "14731",
          name: "Opava",
          state_id: "924",
        },
        {
          id: "14732",
          name: "Orlova",
          state_id: "924",
        },
        {
          id: "14733",
          name: "Ostrava",
          state_id: "924",
        },
        {
          id: "14734",
          name: "Petrvald",
          state_id: "924",
        },
        {
          id: "14735",
          name: "Pribor",
          state_id: "924",
        },
        {
          id: "14736",
          name: "Rychvald",
          state_id: "924",
        },
        {
          id: "14737",
          name: "Rymarov",
          state_id: "924",
        },
        {
          id: "14738",
          name: "Shenov",
          state_id: "924",
        },
        {
          id: "14739",
          name: "Studenka",
          state_id: "924",
        },
        {
          id: "14740",
          name: "Trinec",
          state_id: "924",
        },
        {
          id: "14741",
          name: "Vitkov",
          state_id: "924",
        },
        {
          id: "14742",
          name: "Vratimov",
          state_id: "924",
        },
        {
          id: "14743",
          name: "Vrbno pod Pradedem",
          state_id: "924",
        },
      ],
      Olomoucky: [
        {
          id: "14744",
          name: "Hranice",
          state_id: "925",
        },
        {
          id: "14745",
          name: "Jesenik",
          state_id: "925",
        },
        {
          id: "14746",
          name: "Kojetin",
          state_id: "925",
        },
        {
          id: "14747",
          name: "Lipnik nad Becvou",
          state_id: "925",
        },
        {
          id: "14748",
          name: "Litovel",
          state_id: "925",
        },
        {
          id: "14749",
          name: "Mohelnice",
          state_id: "925",
        },
        {
          id: "14750",
          name: "Olomouc",
          state_id: "925",
        },
        {
          id: "14751",
          name: "Prerov",
          state_id: "925",
        },
        {
          id: "14752",
          name: "Prostejov",
          state_id: "925",
        },
        {
          id: "14753",
          name: "Shternberk",
          state_id: "925",
        },
        {
          id: "14754",
          name: "Shumperk",
          state_id: "925",
        },
        {
          id: "14755",
          name: "Unichov",
          state_id: "925",
        },
        {
          id: "14756",
          name: "Zabreh",
          state_id: "925",
        },
      ],
      "Olomoucky Kraj": [
        {
          id: "14757",
          name: "Hranice",
          state_id: "926",
        },
        {
          id: "14758",
          name: "Jesenik",
          state_id: "926",
        },
        {
          id: "14759",
          name: "Kojetin",
          state_id: "926",
        },
        {
          id: "14760",
          name: "Lipnik nad Becvou",
          state_id: "926",
        },
        {
          id: "14761",
          name: "Litovel",
          state_id: "926",
        },
        {
          id: "14762",
          name: "Mohelnice",
          state_id: "926",
        },
        {
          id: "14763",
          name: "Olomouc",
          state_id: "926",
        },
        {
          id: "14764",
          name: "Prerov",
          state_id: "926",
        },
        {
          id: "14765",
          name: "Prostejov",
          state_id: "926",
        },
        {
          id: "14766",
          name: "Shternberk",
          state_id: "926",
        },
        {
          id: "14767",
          name: "Shumperk",
          state_id: "926",
        },
        {
          id: "14768",
          name: "Unichov",
          state_id: "926",
        },
        {
          id: "14769",
          name: "Zabreh",
          state_id: "926",
        },
      ],
      Pardubicky: [
        {
          id: "14770",
          name: "Cheska Trebova",
          state_id: "927",
        },
        {
          id: "14771",
          name: "Chocen",
          state_id: "927",
        },
        {
          id: "14772",
          name: "Chrudim",
          state_id: "927",
        },
        {
          id: "14773",
          name: "Chvaletice",
          state_id: "927",
        },
        {
          id: "14774",
          name: "Hermanuv Mestec",
          state_id: "927",
        },
        {
          id: "14775",
          name: "Hlinsko",
          state_id: "927",
        },
        {
          id: "14776",
          name: "Lanshkroun",
          state_id: "927",
        },
        {
          id: "14777",
          name: "Letohrad",
          state_id: "927",
        },
        {
          id: "14778",
          name: "Litomyshl",
          state_id: "927",
        },
        {
          id: "14779",
          name: "Moravska Trebova",
          state_id: "927",
        },
        {
          id: "14780",
          name: "Pardubice",
          state_id: "927",
        },
        {
          id: "14781",
          name: "Polichka",
          state_id: "927",
        },
        {
          id: "14782",
          name: "Policka",
          state_id: "927",
        },
        {
          id: "14783",
          name: "Prelouch",
          state_id: "927",
        },
        {
          id: "14784",
          name: "Skutech",
          state_id: "927",
        },
        {
          id: "14785",
          name: "Svitavy",
          state_id: "927",
        },
        {
          id: "14786",
          name: "Usti nad Orlici",
          state_id: "927",
        },
        {
          id: "14787",
          name: "Vysoke Myto",
          state_id: "927",
        },
        {
          id: "14788",
          name: "Zhamberk",
          state_id: "927",
        },
      ],
      Plzensky: [
        {
          id: "14789",
          name: "Dobrany",
          state_id: "928",
        },
        {
          id: "14790",
          name: "Domazhlice",
          state_id: "928",
        },
        {
          id: "14791",
          name: "Horazhd''ovice",
          state_id: "928",
        },
        {
          id: "14792",
          name: "Horshovky Tyn",
          state_id: "928",
        },
        {
          id: "14793",
          name: "Kdyne",
          state_id: "928",
        },
        {
          id: "14794",
          name: "Klatovy",
          state_id: "928",
        },
        {
          id: "14795",
          name: "Nyrany",
          state_id: "928",
        },
        {
          id: "14796",
          name: "Nyrsko",
          state_id: "928",
        },
        {
          id: "14797",
          name: "Plana",
          state_id: "928",
        },
        {
          id: "14798",
          name: "Plzen",
          state_id: "928",
        },
        {
          id: "14799",
          name: "Preshtice",
          state_id: "928",
        },
        {
          id: "14800",
          name: "Radnice",
          state_id: "928",
        },
        {
          id: "14801",
          name: "Rokycany",
          state_id: "928",
        },
        {
          id: "14802",
          name: "Stribro",
          state_id: "928",
        },
        {
          id: "14803",
          name: "Sushice",
          state_id: "928",
        },
        {
          id: "14804",
          name: "Tachov",
          state_id: "928",
        },
      ],
      Praha: [
        {
          id: "14805",
          name: "Prague",
          state_id: "929",
        },
        {
          id: "14806",
          name: "Praha",
          state_id: "929",
        },
      ],
      Rajhrad: [
        {
          id: "14807",
          name: "Rajhrad",
          state_id: "930",
        },
      ],
      Smirice: [
        {
          id: "14808",
          name: "Smirice",
          state_id: "931",
        },
      ],
      "South Moravian": [],
      "Straz nad Nisou": [],
      Stredochesky: [
        {
          id: "14809",
          name: "Benatky nad Jizerou",
          state_id: "934",
        },
        {
          id: "14810",
          name: "Beneshov",
          state_id: "934",
        },
        {
          id: "14811",
          name: "Beroun",
          state_id: "934",
        },
        {
          id: "14812",
          name: "Brandys nad Labem-Stara Bolesl",
          state_id: "934",
        },
        {
          id: "14813",
          name: "Chaslav",
          state_id: "934",
        },
        {
          id: "14814",
          name: "Chavaletice",
          state_id: "934",
        },
        {
          id: "14815",
          name: "Chelakovice",
          state_id: "934",
        },
        {
          id: "14816",
          name: "Chesky Brod",
          state_id: "934",
        },
        {
          id: "14817",
          name: "Dobrish",
          state_id: "934",
        },
        {
          id: "14818",
          name: "Horovice",
          state_id: "934",
        },
        {
          id: "14819",
          name: "Kladno",
          state_id: "934",
        },
        {
          id: "14820",
          name: "Kolin",
          state_id: "934",
        },
        {
          id: "14821",
          name: "Kralupy nad Vltavou",
          state_id: "934",
        },
        {
          id: "14822",
          name: "Kutna Hora",
          state_id: "934",
        },
        {
          id: "14823",
          name: "Lysa nad Labem",
          state_id: "934",
        },
        {
          id: "14824",
          name: "Melnik",
          state_id: "934",
        },
        {
          id: "14825",
          name: "Mlada Boleslav",
          state_id: "934",
        },
        {
          id: "14826",
          name: "Mnichovo Hradishte",
          state_id: "934",
        },
        {
          id: "14827",
          name: "Neratovice",
          state_id: "934",
        },
        {
          id: "14828",
          name: "Nove Strasheci",
          state_id: "934",
        },
        {
          id: "14829",
          name: "Nymburk",
          state_id: "934",
        },
        {
          id: "14830",
          name: "Podebrady",
          state_id: "934",
        },
        {
          id: "14831",
          name: "Pribram",
          state_id: "934",
        },
        {
          id: "14832",
          name: "Rakovnik",
          state_id: "934",
        },
        {
          id: "14833",
          name: "Richany",
          state_id: "934",
        },
        {
          id: "14834",
          name: "Rousinov",
          state_id: "934",
        },
        {
          id: "14835",
          name: "Roztoky",
          state_id: "934",
        },
        {
          id: "14836",
          name: "Sedlcany",
          state_id: "934",
        },
        {
          id: "14837",
          name: "Slany",
          state_id: "934",
        },
        {
          id: "14838",
          name: "Stochov",
          state_id: "934",
        },
        {
          id: "14839",
          name: "Vlashim",
          state_id: "934",
        },
        {
          id: "14840",
          name: "Zruch nad Sazavou",
          state_id: "934",
        },
      ],
      Unicov: [
        {
          id: "14841",
          name: "Unicov",
          state_id: "935",
        },
      ],
      Ustecky: [
        {
          id: "14842",
          name: "Bilina",
          state_id: "936",
        },
        {
          id: "14843",
          name: "Chomutov",
          state_id: "936",
        },
        {
          id: "14844",
          name: "Dechin",
          state_id: "936",
        },
        {
          id: "14845",
          name: "Dubi",
          state_id: "936",
        },
        {
          id: "14846",
          name: "Duchcov",
          state_id: "936",
        },
        {
          id: "14847",
          name: "Jilove",
          state_id: "936",
        },
        {
          id: "14849",
          name: "Kadan",
          state_id: "936",
        },
        {
          id: "14850",
          name: "Klasterec nad Ohri",
          state_id: "936",
        },
        {
          id: "14851",
          name: "Krupka",
          state_id: "936",
        },
        {
          id: "14852",
          name: "Litomerice",
          state_id: "936",
        },
        {
          id: "14853",
          name: "Litvinov",
          state_id: "936",
        },
        {
          id: "14854",
          name: "Louny",
          state_id: "936",
        },
        {
          id: "14855",
          name: "Lovosice",
          state_id: "936",
        },
        {
          id: "14856",
          name: "Mezibori",
          state_id: "936",
        },
        {
          id: "14857",
          name: "Most",
          state_id: "936",
        },
        {
          id: "14858",
          name: "Osek",
          state_id: "936",
        },
        {
          id: "14859",
          name: "Podborany",
          state_id: "936",
        },
        {
          id: "14860",
          name: "Roudnice",
          state_id: "936",
        },
        {
          id: "14861",
          name: "Rumburk",
          state_id: "936",
        },
        {
          id: "14862",
          name: "Shluknov",
          state_id: "936",
        },
        {
          id: "14863",
          name: "Shteti",
          state_id: "936",
        },
        {
          id: "14864",
          name: "Teplice",
          state_id: "936",
        },
        {
          id: "14865",
          name: "Usti",
          state_id: "936",
        },
        {
          id: "14866",
          name: "Varnsdorf",
          state_id: "936",
        },
        {
          id: "14867",
          name: "Zatec",
          state_id: "936",
        },
      ],
      Valletta: [
        {
          id: "14868",
          name: "Valletta",
          state_id: "937",
        },
      ],
      Velesin: [
        {
          id: "14869",
          name: "Velesin",
          state_id: "938",
        },
      ],
      Vysochina: [
        {
          id: "14870",
          name: "Bystrice nad Pernshtejnem",
          state_id: "939",
        },
        {
          id: "14871",
          name: "Chotebor",
          state_id: "939",
        },
        {
          id: "14872",
          name: "Havlichkuv Brod",
          state_id: "939",
        },
        {
          id: "14873",
          name: "Humpolec",
          state_id: "939",
        },
        {
          id: "14874",
          name: "Jihlava",
          state_id: "939",
        },
        {
          id: "14875",
          name: "Ledech",
          state_id: "939",
        },
        {
          id: "14876",
          name: "Moravske Budejovice",
          state_id: "939",
        },
        {
          id: "14877",
          name: "Nove Mesto na Morave",
          state_id: "939",
        },
        {
          id: "14878",
          name: "Okrisky",
          state_id: "939",
        },
        {
          id: "14879",
          name: "Pacov",
          state_id: "939",
        },
        {
          id: "14880",
          name: "Pelhrimov",
          state_id: "939",
        },
        {
          id: "14881",
          name: "Polna",
          state_id: "939",
        },
        {
          id: "14882",
          name: "Svetla nad Sazavou",
          state_id: "939",
        },
        {
          id: "14883",
          name: "Telch",
          state_id: "939",
        },
        {
          id: "14884",
          name: "Trebich",
          state_id: "939",
        },
        {
          id: "14885",
          name: "Tresht",
          state_id: "939",
        },
        {
          id: "14886",
          name: "Velke Mezirichi",
          state_id: "939",
        },
        {
          id: "14887",
          name: "Zhd''ar",
          state_id: "939",
        },
      ],
      Zlinsky: [
        {
          id: "14888",
          name: "Brumov",
          state_id: "940",
        },
        {
          id: "14889",
          name: "Bystrice pod Hostynem",
          state_id: "940",
        },
        {
          id: "14890",
          name: "Chropyne",
          state_id: "940",
        },
        {
          id: "14891",
          name: "Holeshov",
          state_id: "940",
        },
        {
          id: "14892",
          name: "Hulin",
          state_id: "940",
        },
        {
          id: "14893",
          name: "Kromerizh",
          state_id: "940",
        },
        {
          id: "14894",
          name: "Kunovice",
          state_id: "940",
        },
        {
          id: "14895",
          name: "Napajedla",
          state_id: "940",
        },
        {
          id: "14896",
          name: "Otrokovice",
          state_id: "940",
        },
        {
          id: "14897",
          name: "Rozhnov",
          state_id: "940",
        },
        {
          id: "14898",
          name: "Roznov pod Radhostem",
          state_id: "940",
        },
        {
          id: "14899",
          name: "Slavicin",
          state_id: "940",
        },
        {
          id: "14900",
          name: "Slusovice",
          state_id: "940",
        },
        {
          id: "14901",
          name: "Stare Mesto",
          state_id: "940",
        },
        {
          id: "14902",
          name: "Strazhnice",
          state_id: "940",
        },
        {
          id: "14903",
          name: "Uherske Hradishte",
          state_id: "940",
        },
        {
          id: "14904",
          name: "Uhersky Brod",
          state_id: "940",
        },
        {
          id: "14905",
          name: "Valashske Klobouky",
          state_id: "940",
        },
        {
          id: "14906",
          name: "Valashske Mezirichi",
          state_id: "940",
        },
        {
          id: "14907",
          name: "Veseli nad Moravou",
          state_id: "940",
        },
        {
          id: "14908",
          name: "Vsetin",
          state_id: "940",
        },
        {
          id: "14909",
          name: "Zborovice",
          state_id: "940",
        },
        {
          id: "14910",
          name: "Zlin",
          state_id: "940",
        },
      ],
    },
  },
  DE: {
    name: "Germany",
    native: "Deutschland",
    phone: "49",
    continent: "EU",
    capital: "Berlin",
    currency: "EUR",
    languages: ["de"],
    emoji: "🇩🇪",
    emojiU: "U+1F1E9 U+1F1EA",
    states: {
      Auvergne: [],
      "Baden-Wurttemberg": [
        {
          id: "18316",
          name: "Aalen",
          state_id: "1355",
        },
        {
          id: "18317",
          name: "Achern",
          state_id: "1355",
        },
        {
          id: "18318",
          name: "Aichtal",
          state_id: "1355",
        },
        {
          id: "18319",
          name: "Albstadt",
          state_id: "1355",
        },
        {
          id: "18320",
          name: "Aldingen",
          state_id: "1355",
        },
        {
          id: "18321",
          name: "Allmersbach",
          state_id: "1355",
        },
        {
          id: "18322",
          name: "Alpirsbach",
          state_id: "1355",
        },
        {
          id: "18323",
          name: "Altensteig",
          state_id: "1355",
        },
        {
          id: "18324",
          name: "Altlussheim",
          state_id: "1355",
        },
        {
          id: "18325",
          name: "Ammerbuch",
          state_id: "1355",
        },
        {
          id: "18326",
          name: "Appenweier",
          state_id: "1355",
        },
        {
          id: "18327",
          name: "Asperg",
          state_id: "1355",
        },
        {
          id: "18328",
          name: "Backnang",
          state_id: "1355",
        },
        {
          id: "18329",
          name: "Bad Durrheim",
          state_id: "1355",
        },
        {
          id: "18330",
          name: "Bad Friedrichshall",
          state_id: "1355",
        },
        {
          id: "18331",
          name: "Bad Krozingen",
          state_id: "1355",
        },
        {
          id: "18332",
          name: "Bad Liebenzell",
          state_id: "1355",
        },
        {
          id: "18333",
          name: "Bad Mergentheim",
          state_id: "1355",
        },
        {
          id: "18334",
          name: "Bad Rappenau",
          state_id: "1355",
        },
        {
          id: "18335",
          name: "Bad Sackingen",
          state_id: "1355",
        },
        {
          id: "18336",
          name: "Bad Schonborn",
          state_id: "1355",
        },
        {
          id: "18337",
          name: "Bad Urach",
          state_id: "1355",
        },
        {
          id: "18338",
          name: "Bad Waldsee",
          state_id: "1355",
        },
        {
          id: "18339",
          name: "Bad Wurzach",
          state_id: "1355",
        },
        {
          id: "18340",
          name: "Baden-Baden",
          state_id: "1355",
        },
        {
          id: "18341",
          name: "Bahlingen",
          state_id: "1355",
        },
        {
          id: "18342",
          name: "Baiersbronn",
          state_id: "1355",
        },
        {
          id: "18343",
          name: "Balgheim",
          state_id: "1355",
        },
        {
          id: "18344",
          name: "Balingen",
          state_id: "1355",
        },
        {
          id: "18345",
          name: "Ballrechten-Dottingen",
          state_id: "1355",
        },
        {
          id: "18346",
          name: "Besigheim",
          state_id: "1355",
        },
        {
          id: "18347",
          name: "Biberach",
          state_id: "1355",
        },
        {
          id: "18348",
          name: "Bietigheim-Bissingen",
          state_id: "1355",
        },
        {
          id: "18349",
          name: "Binzen",
          state_id: "1355",
        },
        {
          id: "18350",
          name: "Birkenfeld",
          state_id: "1355",
        },
        {
          id: "18351",
          name: "Bisingen",
          state_id: "1355",
        },
        {
          id: "18352",
          name: "Bitz",
          state_id: "1355",
        },
        {
          id: "18353",
          name: "Blaubeuren",
          state_id: "1355",
        },
        {
          id: "18354",
          name: "Blaustein",
          state_id: "1355",
        },
        {
          id: "18355",
          name: "Blumberg",
          state_id: "1355",
        },
        {
          id: "18356",
          name: "Boblingen",
          state_id: "1355",
        },
        {
          id: "18357",
          name: "Bodelshausen",
          state_id: "1355",
        },
        {
          id: "18358",
          name: "Bonndorf",
          state_id: "1355",
        },
        {
          id: "18359",
          name: "Bonnigheim",
          state_id: "1355",
        },
        {
          id: "18360",
          name: "Bopfingen",
          state_id: "1355",
        },
        {
          id: "18361",
          name: "Bottingen",
          state_id: "1355",
        },
        {
          id: "18362",
          name: "Brackenheim",
          state_id: "1355",
        },
        {
          id: "18363",
          name: "Breisach",
          state_id: "1355",
        },
        {
          id: "18364",
          name: "Bretten",
          state_id: "1355",
        },
        {
          id: "18365",
          name: "Bretzfeld",
          state_id: "1355",
        },
        {
          id: "18366",
          name: "Bruchsal",
          state_id: "1355",
        },
        {
          id: "18367",
          name: "Bruhl",
          state_id: "1355",
        },
        {
          id: "18368",
          name: "Buchen",
          state_id: "1355",
        },
        {
          id: "18369",
          name: "Buchenbach",
          state_id: "1355",
        },
        {
          id: "18370",
          name: "Buhl",
          state_id: "1355",
        },
        {
          id: "18371",
          name: "Burgstetten",
          state_id: "1355",
        },
        {
          id: "18372",
          name: "Burladingen",
          state_id: "1355",
        },
        {
          id: "18373",
          name: "Calw",
          state_id: "1355",
        },
        {
          id: "18374",
          name: "Crailsheim",
          state_id: "1355",
        },
        {
          id: "18375",
          name: "Denkendorf",
          state_id: "1355",
        },
        {
          id: "18376",
          name: "Denzlingen",
          state_id: "1355",
        },
        {
          id: "18377",
          name: "Dettingen",
          state_id: "1355",
        },
        {
          id: "18378",
          name: "Dietenheim",
          state_id: "1355",
        },
        {
          id: "18379",
          name: "Ditzingen",
          state_id: "1355",
        },
        {
          id: "18380",
          name: "Donaueschingen",
          state_id: "1355",
        },
        {
          id: "18381",
          name: "Donzdorf",
          state_id: "1355",
        },
        {
          id: "18382",
          name: "Dornhan",
          state_id: "1355",
        },
        {
          id: "18383",
          name: "Dornstadt",
          state_id: "1355",
        },
        {
          id: "18384",
          name: "Dornstetten",
          state_id: "1355",
        },
        {
          id: "18385",
          name: "Dossenheim",
          state_id: "1355",
        },
        {
          id: "18386",
          name: "Durbheim",
          state_id: "1355",
        },
        {
          id: "18387",
          name: "Durmersheim",
          state_id: "1355",
        },
        {
          id: "18388",
          name: "Eberbach",
          state_id: "1355",
        },
        {
          id: "18389",
          name: "Ebersbach",
          state_id: "1355",
        },
        {
          id: "18390",
          name: "Edingen",
          state_id: "1355",
        },
        {
          id: "18391",
          name: "Edingen-Neckarhausen",
          state_id: "1355",
        },
        {
          id: "18392",
          name: "Eggenstein-Leopoldshafen",
          state_id: "1355",
        },
        {
          id: "18393",
          name: "Ehingen",
          state_id: "1355",
        },
        {
          id: "18394",
          name: "Eislingen",
          state_id: "1355",
        },
        {
          id: "18395",
          name: "Ellhofen",
          state_id: "1355",
        },
        {
          id: "18396",
          name: "Ellwangen",
          state_id: "1355",
        },
        {
          id: "18397",
          name: "Emmendingen",
          state_id: "1355",
        },
        {
          id: "18398",
          name: "Emmingen-Liptingen",
          state_id: "1355",
        },
        {
          id: "18399",
          name: "Engen",
          state_id: "1355",
        },
        {
          id: "18400",
          name: "Eningen",
          state_id: "1355",
        },
        {
          id: "18401",
          name: "Eppelheim",
          state_id: "1355",
        },
        {
          id: "18402",
          name: "Eppingen",
          state_id: "1355",
        },
        {
          id: "18403",
          name: "Erbach",
          state_id: "1355",
        },
        {
          id: "18404",
          name: "Eriskirch",
          state_id: "1355",
        },
        {
          id: "18405",
          name: "Eschach",
          state_id: "1355",
        },
        {
          id: "18406",
          name: "Esslingen",
          state_id: "1355",
        },
        {
          id: "18407",
          name: "Ettenheim",
          state_id: "1355",
        },
        {
          id: "18408",
          name: "Ettlingen",
          state_id: "1355",
        },
        {
          id: "18409",
          name: "Fellbach",
          state_id: "1355",
        },
        {
          id: "18410",
          name: "Filderstadt",
          state_id: "1355",
        },
        {
          id: "18411",
          name: "Freiberg",
          state_id: "1355",
        },
        {
          id: "18412",
          name: "Freiburg",
          state_id: "1355",
        },
        {
          id: "18413",
          name: "Freudenstadt",
          state_id: "1355",
        },
        {
          id: "18414",
          name: "Frickenhausen",
          state_id: "1355",
        },
        {
          id: "18415",
          name: "Fridingen",
          state_id: "1355",
        },
        {
          id: "18416",
          name: "Friedrichshafen",
          state_id: "1355",
        },
        {
          id: "18417",
          name: "Friesenheim",
          state_id: "1355",
        },
        {
          id: "18418",
          name: "Frittlingen",
          state_id: "1355",
        },
        {
          id: "18419",
          name: "Furtwangen",
          state_id: "1355",
        },
        {
          id: "18420",
          name: "Gaggenau",
          state_id: "1355",
        },
        {
          id: "18421",
          name: "Gaildorf",
          state_id: "1355",
        },
        {
          id: "18422",
          name: "Gartringen",
          state_id: "1355",
        },
        {
          id: "18423",
          name: "Gaufelden",
          state_id: "1355",
        },
        {
          id: "18424",
          name: "Geislingen",
          state_id: "1355",
        },
        {
          id: "18425",
          name: "Gengenbach",
          state_id: "1355",
        },
        {
          id: "18426",
          name: "Gerlingen",
          state_id: "1355",
        },
        {
          id: "18427",
          name: "Gernsbach",
          state_id: "1355",
        },
        {
          id: "18428",
          name: "Gerstetten",
          state_id: "1355",
        },
        {
          id: "18429",
          name: "Giengen",
          state_id: "1355",
        },
        {
          id: "18430",
          name: "Goppingen",
          state_id: "1355",
        },
        {
          id: "18431",
          name: "Gottmadingen",
          state_id: "1355",
        },
        {
          id: "18432",
          name: "Graben-Neudorf",
          state_id: "1355",
        },
        {
          id: "18433",
          name: "Grafenberg",
          state_id: "1355",
        },
        {
          id: "18434",
          name: "Grafenhausen",
          state_id: "1355",
        },
        {
          id: "18435",
          name: "Grenzach-Wyhlen",
          state_id: "1355",
        },
        {
          id: "18436",
          name: "GroBbettlingen",
          state_id: "1355",
        },
        {
          id: "18437",
          name: "Grunkraut",
          state_id: "1355",
        },
        {
          id: "18438",
          name: "Gschwend",
          state_id: "1355",
        },
        {
          id: "18439",
          name: "Guglingen",
          state_id: "1355",
        },
        {
          id: "18440",
          name: "Gundelfingen",
          state_id: "1355",
        },
        {
          id: "18441",
          name: "Gutach",
          state_id: "1355",
        },
        {
          id: "18442",
          name: "Haigerloch",
          state_id: "1355",
        },
        {
          id: "18443",
          name: "Haiterbach",
          state_id: "1355",
        },
        {
          id: "18444",
          name: "Harmersabch",
          state_id: "1355",
        },
        {
          id: "18445",
          name: "Hausach",
          state_id: "1355",
        },
        {
          id: "18446",
          name: "Hechingen",
          state_id: "1355",
        },
        {
          id: "18447",
          name: "Heddesheim",
          state_id: "1355",
        },
        {
          id: "18448",
          name: "Heidelberg",
          state_id: "1355",
        },
        {
          id: "18449",
          name: "Heidenheim",
          state_id: "1355",
        },
        {
          id: "18450",
          name: "Heilbronn",
          state_id: "1355",
        },
        {
          id: "18451",
          name: "Hemsbach",
          state_id: "1355",
        },
        {
          id: "18452",
          name: "Herbrechtingen",
          state_id: "1355",
        },
        {
          id: "18453",
          name: "Herrenberg",
          state_id: "1355",
        },
        {
          id: "18454",
          name: "Heubach",
          state_id: "1355",
        },
        {
          id: "18455",
          name: "Hirschberg",
          state_id: "1355",
        },
        {
          id: "18456",
          name: "Hockenheim",
          state_id: "1355",
        },
        {
          id: "18457",
          name: "Holzgerlingen",
          state_id: "1355",
        },
        {
          id: "18458",
          name: "Horb",
          state_id: "1355",
        },
        {
          id: "18459",
          name: "Hufingen",
          state_id: "1355",
        },
        {
          id: "18460",
          name: "Huttlingen",
          state_id: "1355",
        },
        {
          id: "18461",
          name: "Isny",
          state_id: "1355",
        },
        {
          id: "18462",
          name: "Ispringen",
          state_id: "1355",
        },
        {
          id: "18463",
          name: "Jungingen",
          state_id: "1355",
        },
        {
          id: "18464",
          name: "Karlsbad",
          state_id: "1355",
        },
        {
          id: "18465",
          name: "Karlsruhe",
          state_id: "1355",
        },
        {
          id: "18466",
          name: "Kehl",
          state_id: "1355",
        },
        {
          id: "18467",
          name: "Kernen",
          state_id: "1355",
        },
        {
          id: "18468",
          name: "Ketsch",
          state_id: "1355",
        },
        {
          id: "18469",
          name: "Kieselbronn",
          state_id: "1355",
        },
        {
          id: "18470",
          name: "Kirchberg an der Jagst",
          state_id: "1355",
        },
        {
          id: "18471",
          name: "Kirchheim",
          state_id: "1355",
        },
        {
          id: "18472",
          name: "Kirchzarten",
          state_id: "1355",
        },
        {
          id: "18473",
          name: "Kisslegg",
          state_id: "1355",
        },
        {
          id: "18474",
          name: "Klettgau",
          state_id: "1355",
        },
        {
          id: "18475",
          name: "Kongen",
          state_id: "1355",
        },
        {
          id: "18476",
          name: "Konigsbach-Stein",
          state_id: "1355",
        },
        {
          id: "18477",
          name: "Konigsbronn",
          state_id: "1355",
        },
        {
          id: "18478",
          name: "Konstanz",
          state_id: "1355",
        },
        {
          id: "18479",
          name: "Korb",
          state_id: "1355",
        },
        {
          id: "18480",
          name: "Korntal-Munchingen",
          state_id: "1355",
        },
        {
          id: "18481",
          name: "Kornwestheim",
          state_id: "1355",
        },
        {
          id: "18482",
          name: "Kraichtal",
          state_id: "1355",
        },
        {
          id: "18483",
          name: "Kressbronn an Bodensee",
          state_id: "1355",
        },
        {
          id: "18484",
          name: "Kronau",
          state_id: "1355",
        },
        {
          id: "18485",
          name: "Kuessaberg",
          state_id: "1355",
        },
        {
          id: "18486",
          name: "Kunzelsau",
          state_id: "1355",
        },
        {
          id: "18487",
          name: "Ladenburg",
          state_id: "1355",
        },
        {
          id: "18488",
          name: "Lahr",
          state_id: "1355",
        },
        {
          id: "18489",
          name: "Laichingen",
          state_id: "1355",
        },
        {
          id: "18490",
          name: "Langenau",
          state_id: "1355",
        },
        {
          id: "18491",
          name: "Lauda-Konigshofen",
          state_id: "1355",
        },
        {
          id: "18492",
          name: "Lauffen",
          state_id: "1355",
        },
        {
          id: "18493",
          name: "Laupheim",
          state_id: "1355",
        },
        {
          id: "18494",
          name: "Leimen",
          state_id: "1355",
        },
        {
          id: "18495",
          name: "Leinfelden-Echterdingen",
          state_id: "1355",
        },
        {
          id: "18496",
          name: "Leingarten",
          state_id: "1355",
        },
        {
          id: "18497",
          name: "Lenningen",
          state_id: "1355",
        },
        {
          id: "18498",
          name: "Lenzkirch",
          state_id: "1355",
        },
        {
          id: "18499",
          name: "Leonberg",
          state_id: "1355",
        },
        {
          id: "18500",
          name: "Leutenbach",
          state_id: "1355",
        },
        {
          id: "18501",
          name: "Leutkirch",
          state_id: "1355",
        },
        {
          id: "18502",
          name: "Lichtenstein",
          state_id: "1355",
        },
        {
          id: "18503",
          name: "Linkenheim-Hochstetten",
          state_id: "1355",
        },
        {
          id: "18504",
          name: "Lorch",
          state_id: "1355",
        },
        {
          id: "18505",
          name: "Lorrach",
          state_id: "1355",
        },
        {
          id: "18506",
          name: "Ludwigsburg",
          state_id: "1355",
        },
        {
          id: "18507",
          name: "Malsch",
          state_id: "1355",
        },
        {
          id: "18508",
          name: "Mannheim",
          state_id: "1355",
        },
        {
          id: "18509",
          name: "Marbach",
          state_id: "1355",
        },
        {
          id: "18510",
          name: "Markdorf",
          state_id: "1355",
        },
        {
          id: "18511",
          name: "Markgroningen",
          state_id: "1355",
        },
        {
          id: "18512",
          name: "Maulburg",
          state_id: "1355",
        },
        {
          id: "18513",
          name: "MeBstetten",
          state_id: "1355",
        },
        {
          id: "18514",
          name: "Meckenbeuren",
          state_id: "1355",
        },
        {
          id: "18515",
          name: "Meckesheim",
          state_id: "1355",
        },
        {
          id: "18516",
          name: "Meersburg",
          state_id: "1355",
        },
        {
          id: "18517",
          name: "Mengen",
          state_id: "1355",
        },
        {
          id: "18518",
          name: "Metzingen",
          state_id: "1355",
        },
        {
          id: "18519",
          name: "Mockmuhl",
          state_id: "1355",
        },
        {
          id: "18520",
          name: "Moglingen",
          state_id: "1355",
        },
        {
          id: "18521",
          name: "Monsheim",
          state_id: "1355",
        },
        {
          id: "18522",
          name: "Mosbach",
          state_id: "1355",
        },
        {
          id: "18523",
          name: "Mossingen",
          state_id: "1355",
        },
        {
          id: "18524",
          name: "Muhlacker",
          state_id: "1355",
        },
        {
          id: "18525",
          name: "Mullheim",
          state_id: "1355",
        },
        {
          id: "18526",
          name: "Munsingen",
          state_id: "1355",
        },
        {
          id: "18527",
          name: "Murrhardt",
          state_id: "1355",
        },
        {
          id: "18528",
          name: "Nagold",
          state_id: "1355",
        },
        {
          id: "18529",
          name: "Neckargemund",
          state_id: "1355",
        },
        {
          id: "18530",
          name: "Neckarsulm",
          state_id: "1355",
        },
        {
          id: "18531",
          name: "Neresheim",
          state_id: "1355",
        },
        {
          id: "18532",
          name: "Neuenburg",
          state_id: "1355",
        },
        {
          id: "18533",
          name: "Neuhausen",
          state_id: "1355",
        },
        {
          id: "18534",
          name: "Niederstetten",
          state_id: "1355",
        },
        {
          id: "18535",
          name: "Niefern-Oschelbronn",
          state_id: "1355",
        },
        {
          id: "18536",
          name: "NuBloch",
          state_id: "1355",
        },
        {
          id: "18537",
          name: "Nurtingen",
          state_id: "1355",
        },
        {
          id: "18538",
          name: "Oberhausen-Rheinhausen",
          state_id: "1355",
        },
        {
          id: "18539",
          name: "Oberkirch",
          state_id: "1355",
        },
        {
          id: "18540",
          name: "Oberndorf",
          state_id: "1355",
        },
        {
          id: "18541",
          name: "Oberstenfeld",
          state_id: "1355",
        },
        {
          id: "18542",
          name: "Obersulm",
          state_id: "1355",
        },
        {
          id: "18543",
          name: "Ochsenhausen",
          state_id: "1355",
        },
        {
          id: "18544",
          name: "Offenburg",
          state_id: "1355",
        },
        {
          id: "18545",
          name: "Ofterdingen",
          state_id: "1355",
        },
        {
          id: "18546",
          name: "Oftersheim",
          state_id: "1355",
        },
        {
          id: "18547",
          name: "Oggelshausen",
          state_id: "1355",
        },
        {
          id: "18548",
          name: "Ohringen",
          state_id: "1355",
        },
        {
          id: "18549",
          name: "Olbronn-Durrn",
          state_id: "1355",
        },
        {
          id: "18550",
          name: "Oppenweiler",
          state_id: "1355",
        },
        {
          id: "18551",
          name: "Ostfildern",
          state_id: "1355",
        },
        {
          id: "18552",
          name: "Ostringen",
          state_id: "1355",
        },
        {
          id: "18553",
          name: "Otisheim",
          state_id: "1355",
        },
        {
          id: "18554",
          name: "Pfalzgrafenweiler",
          state_id: "1355",
        },
        {
          id: "18555",
          name: "Pfinztal",
          state_id: "1355",
        },
        {
          id: "18556",
          name: "Pforzheim",
          state_id: "1355",
        },
        {
          id: "18557",
          name: "Pfullendorf",
          state_id: "1355",
        },
        {
          id: "18558",
          name: "Pfullingen",
          state_id: "1355",
        },
        {
          id: "18559",
          name: "Philippsburg",
          state_id: "1355",
        },
        {
          id: "18560",
          name: "Plankstadt",
          state_id: "1355",
        },
        {
          id: "18561",
          name: "Pleidelsheim",
          state_id: "1355",
        },
        {
          id: "18562",
          name: "Pliezhausen",
          state_id: "1355",
        },
        {
          id: "18563",
          name: "Plochingen",
          state_id: "1355",
        },
        {
          id: "18564",
          name: "Pluderhausen",
          state_id: "1355",
        },
        {
          id: "18565",
          name: "Radolfzell",
          state_id: "1355",
        },
        {
          id: "18566",
          name: "Rastatt",
          state_id: "1355",
        },
        {
          id: "18567",
          name: "Ravensburg",
          state_id: "1355",
        },
        {
          id: "18568",
          name: "Reilingen",
          state_id: "1355",
        },
        {
          id: "18569",
          name: "Remchingen",
          state_id: "1355",
        },
        {
          id: "18570",
          name: "Remseck",
          state_id: "1355",
        },
        {
          id: "18571",
          name: "Remshalden",
          state_id: "1355",
        },
        {
          id: "18572",
          name: "Renchen",
          state_id: "1355",
        },
        {
          id: "18573",
          name: "Renningen",
          state_id: "1355",
        },
        {
          id: "18574",
          name: "Reutlingen",
          state_id: "1355",
        },
        {
          id: "18575",
          name: "Rheinau",
          state_id: "1355",
        },
        {
          id: "18576",
          name: "Rheinfelden",
          state_id: "1355",
        },
        {
          id: "18577",
          name: "Rheinmunster",
          state_id: "1355",
        },
        {
          id: "18578",
          name: "Rheinstetten",
          state_id: "1355",
        },
        {
          id: "18579",
          name: "Riederich",
          state_id: "1355",
        },
        {
          id: "18580",
          name: "Riedlingen",
          state_id: "1355",
        },
        {
          id: "18581",
          name: "Rielasingen-Worblingen",
          state_id: "1355",
        },
        {
          id: "18582",
          name: "Rosenfeld",
          state_id: "1355",
        },
        {
          id: "18583",
          name: "Rottenburg",
          state_id: "1355",
        },
        {
          id: "18584",
          name: "Rottweil",
          state_id: "1355",
        },
        {
          id: "18585",
          name: "Rudersberg",
          state_id: "1355",
        },
        {
          id: "18586",
          name: "Rutesheim",
          state_id: "1355",
        },
        {
          id: "18587",
          name: "Sachsenheim",
          state_id: "1355",
        },
        {
          id: "18588",
          name: "Salem",
          state_id: "1355",
        },
        {
          id: "18589",
          name: "Sandhausen",
          state_id: "1355",
        },
        {
          id: "18590",
          name: "Sankt Georgen",
          state_id: "1355",
        },
        {
          id: "18591",
          name: "Sankt Leon-Rot",
          state_id: "1355",
        },
        {
          id: "18592",
          name: "Saulgau",
          state_id: "1355",
        },
        {
          id: "18593",
          name: "Scheer",
          state_id: "1355",
        },
        {
          id: "18594",
          name: "Schlierbach",
          state_id: "1355",
        },
        {
          id: "18595",
          name: "Schonaich",
          state_id: "1355",
        },
        {
          id: "18596",
          name: "Schopfheim",
          state_id: "1355",
        },
        {
          id: "18597",
          name: "Schorndorf",
          state_id: "1355",
        },
        {
          id: "18598",
          name: "Schramberg",
          state_id: "1355",
        },
        {
          id: "18599",
          name: "Schriesheim",
          state_id: "1355",
        },
        {
          id: "18600",
          name: "Schwabisch Gmund",
          state_id: "1355",
        },
        {
          id: "18601",
          name: "Schwabisch Hall",
          state_id: "1355",
        },
        {
          id: "18602",
          name: "Schwaigern",
          state_id: "1355",
        },
        {
          id: "18603",
          name: "Schwetzingen",
          state_id: "1355",
        },
        {
          id: "18604",
          name: "Schwieberdingen",
          state_id: "1355",
        },
        {
          id: "18605",
          name: "Seitingen-Oberflacht",
          state_id: "1355",
        },
        {
          id: "18606",
          name: "Sexau",
          state_id: "1355",
        },
        {
          id: "18607",
          name: "Sigmaringen",
          state_id: "1355",
        },
        {
          id: "18608",
          name: "Sindelfingen",
          state_id: "1355",
        },
        {
          id: "18609",
          name: "Singen",
          state_id: "1355",
        },
        {
          id: "18610",
          name: "Sinsheim",
          state_id: "1355",
        },
        {
          id: "18611",
          name: "Sinzheim",
          state_id: "1355",
        },
        {
          id: "18612",
          name: "Sonnenbuhl",
          state_id: "1355",
        },
        {
          id: "18613",
          name: "Sontheim",
          state_id: "1355",
        },
        {
          id: "18614",
          name: "Spaichingen",
          state_id: "1355",
        },
        {
          id: "18615",
          name: "Stegen",
          state_id: "1355",
        },
        {
          id: "18616",
          name: "Steinen",
          state_id: "1355",
        },
        {
          id: "18617",
          name: "Steinheim",
          state_id: "1355",
        },
        {
          id: "18618",
          name: "Steinmauern",
          state_id: "1355",
        },
        {
          id: "18619",
          name: "Stockach",
          state_id: "1355",
        },
        {
          id: "18620",
          name: "Straubenhardt",
          state_id: "1355",
        },
        {
          id: "18621",
          name: "Stutensee",
          state_id: "1355",
        },
        {
          id: "18622",
          name: "Stuttgart",
          state_id: "1355",
        },
        {
          id: "18623",
          name: "SuBen",
          state_id: "1355",
        },
        {
          id: "18624",
          name: "Sulz",
          state_id: "1355",
        },
        {
          id: "18625",
          name: "Sulzfeld",
          state_id: "1355",
        },
        {
          id: "18626",
          name: "Tamm",
          state_id: "1355",
        },
        {
          id: "18627",
          name: "Tauberbischofsheim",
          state_id: "1355",
        },
        {
          id: "18628",
          name: "Teningen",
          state_id: "1355",
        },
        {
          id: "18629",
          name: "Tettnang",
          state_id: "1355",
        },
        {
          id: "18630",
          name: "Titisee-Neustadt",
          state_id: "1355",
        },
        {
          id: "18631",
          name: "Trossingen",
          state_id: "1355",
        },
        {
          id: "18632",
          name: "Tubingen",
          state_id: "1355",
        },
        {
          id: "18633",
          name: "Tuningen",
          state_id: "1355",
        },
        {
          id: "18634",
          name: "Tuttlingen",
          state_id: "1355",
        },
        {
          id: "18635",
          name: "Uberlingen",
          state_id: "1355",
        },
        {
          id: "18636",
          name: "Ubstadt-Weiher",
          state_id: "1355",
        },
        {
          id: "18637",
          name: "Uhingen",
          state_id: "1355",
        },
        {
          id: "18638",
          name: "Ulm",
          state_id: "1355",
        },
        {
          id: "18639",
          name: "Umkirch",
          state_id: "1355",
        },
        {
          id: "18640",
          name: "Vaihingen",
          state_id: "1355",
        },
        {
          id: "18641",
          name: "Villingen-Schwenningen",
          state_id: "1355",
        },
        {
          id: "18642",
          name: "Villingendorf",
          state_id: "1355",
        },
        {
          id: "18643",
          name: "Waghausel",
          state_id: "1355",
        },
        {
          id: "18644",
          name: "Waiblingen",
          state_id: "1355",
        },
        {
          id: "18645",
          name: "Waldbronn",
          state_id: "1355",
        },
        {
          id: "18646",
          name: "Waldkirch",
          state_id: "1355",
        },
        {
          id: "18647",
          name: "Waldlaubersheim",
          state_id: "1355",
        },
        {
          id: "18648",
          name: "Waldshut-Tiengen",
          state_id: "1355",
        },
        {
          id: "18649",
          name: "Walldorf",
          state_id: "1355",
        },
        {
          id: "18650",
          name: "Walldurn",
          state_id: "1355",
        },
        {
          id: "18651",
          name: "Walzbachtal",
          state_id: "1355",
        },
        {
          id: "18652",
          name: "Wangen",
          state_id: "1355",
        },
        {
          id: "18653",
          name: "Wehr",
          state_id: "1355",
        },
        {
          id: "18654",
          name: "Weikersheim",
          state_id: "1355",
        },
        {
          id: "18655",
          name: "Weil",
          state_id: "1355",
        },
        {
          id: "18656",
          name: "Weil am Rhein",
          state_id: "1355",
        },
        {
          id: "18657",
          name: "Weil der Stadt",
          state_id: "1355",
        },
        {
          id: "18658",
          name: "Weil im Schonbuch",
          state_id: "1355",
        },
        {
          id: "18659",
          name: "Weilheim",
          state_id: "1355",
        },
        {
          id: "18660",
          name: "Weingarten",
          state_id: "1355",
        },
        {
          id: "18661",
          name: "Weinheim",
          state_id: "1355",
        },
        {
          id: "18662",
          name: "Weinsberg",
          state_id: "1355",
        },
        {
          id: "18663",
          name: "Weinstadt",
          state_id: "1355",
        },
        {
          id: "18664",
          name: "Wellendingen",
          state_id: "1355",
        },
        {
          id: "18665",
          name: "Welzheim",
          state_id: "1355",
        },
        {
          id: "18666",
          name: "Wendlingen",
          state_id: "1355",
        },
        {
          id: "18667",
          name: "Wernau",
          state_id: "1355",
        },
        {
          id: "18668",
          name: "Wertheim",
          state_id: "1355",
        },
        {
          id: "18669",
          name: "Wiesloch",
          state_id: "1355",
        },
        {
          id: "18670",
          name: "Wildbad",
          state_id: "1355",
        },
        {
          id: "18671",
          name: "Wildberg",
          state_id: "1355",
        },
        {
          id: "18672",
          name: "Winnenden",
          state_id: "1355",
        },
        {
          id: "18673",
          name: "Wolpertshausen",
          state_id: "1355",
        },
        {
          id: "18674",
          name: "Zuzenhausen",
          state_id: "1355",
        },
      ],
      Bavaria: [
        {
          id: "18675",
          name: "Ahorn",
          state_id: "1356",
        },
        {
          id: "18676",
          name: "Allershausen",
          state_id: "1356",
        },
        {
          id: "18677",
          name: "Attenhofen",
          state_id: "1356",
        },
        {
          id: "18678",
          name: "Bad Birnbach",
          state_id: "1356",
        },
        {
          id: "18679",
          name: "Bad Endorf",
          state_id: "1356",
        },
        {
          id: "18680",
          name: "Bad Gronenbach",
          state_id: "1356",
        },
        {
          id: "18681",
          name: "Barbing",
          state_id: "1356",
        },
        {
          id: "18682",
          name: "Benediktbeuern",
          state_id: "1356",
        },
        {
          id: "18683",
          name: "Breitenberg",
          state_id: "1356",
        },
        {
          id: "18684",
          name: "Bruckberg",
          state_id: "1356",
        },
        {
          id: "18685",
          name: "Brunnthal",
          state_id: "1356",
        },
        {
          id: "18686",
          name: "Burgheim",
          state_id: "1356",
        },
        {
          id: "18687",
          name: "Chiemsee",
          state_id: "1356",
        },
        {
          id: "18688",
          name: "Emersacker",
          state_id: "1356",
        },
        {
          id: "18689",
          name: "Eresing",
          state_id: "1356",
        },
        {
          id: "18690",
          name: "Fahrenzhausen",
          state_id: "1356",
        },
        {
          id: "18691",
          name: "Faulbach",
          state_id: "1356",
        },
        {
          id: "18692",
          name: "Finning",
          state_id: "1356",
        },
        {
          id: "18693",
          name: "Forstinning",
          state_id: "1356",
        },
        {
          id: "18694",
          name: "Georgensgmund",
          state_id: "1356",
        },
        {
          id: "18695",
          name: "Haldenwang",
          state_id: "1356",
        },
        {
          id: "18696",
          name: "Heideck",
          state_id: "1356",
        },
        {
          id: "18697",
          name: "Heimenkirch",
          state_id: "1356",
        },
        {
          id: "18698",
          name: "Hergensweiler",
          state_id: "1356",
        },
        {
          id: "18699",
          name: "Hirschau",
          state_id: "1356",
        },
        {
          id: "18700",
          name: "Iffeldorf",
          state_id: "1356",
        },
        {
          id: "18701",
          name: "Karlstein",
          state_id: "1356",
        },
        {
          id: "18702",
          name: "Kleinheubach",
          state_id: "1356",
        },
        {
          id: "18703",
          name: "Kleinwallstadt",
          state_id: "1356",
        },
        {
          id: "18704",
          name: "Kotz",
          state_id: "1356",
        },
        {
          id: "18705",
          name: "Krailling",
          state_id: "1356",
        },
        {
          id: "18706",
          name: "Langenbach",
          state_id: "1356",
        },
        {
          id: "18707",
          name: "Laudenbach",
          state_id: "1356",
        },
        {
          id: "18708",
          name: "Leutershausen",
          state_id: "1356",
        },
        {
          id: "18709",
          name: "Mammendorf",
          state_id: "1356",
        },
        {
          id: "18710",
          name: "Mombris",
          state_id: "1356",
        },
        {
          id: "18711",
          name: "Munnerstadt",
          state_id: "1356",
        },
        {
          id: "18712",
          name: "Neu-Ulm",
          state_id: "1356",
        },
        {
          id: "18713",
          name: "Niederlauer",
          state_id: "1356",
        },
        {
          id: "18714",
          name: "Obernburg",
          state_id: "1356",
        },
        {
          id: "18715",
          name: "Oberpfaffenhofen",
          state_id: "1356",
        },
        {
          id: "18716",
          name: "Ostallgau",
          state_id: "1356",
        },
        {
          id: "18717",
          name: "Prittriching",
          state_id: "1356",
        },
        {
          id: "18718",
          name: "Prutting",
          state_id: "1356",
        },
        {
          id: "18719",
          name: "Pullach",
          state_id: "1356",
        },
        {
          id: "18720",
          name: "Putzbrunn",
          state_id: "1356",
        },
        {
          id: "18721",
          name: "Randersacker",
          state_id: "1356",
        },
        {
          id: "18722",
          name: "Rednitzhembach",
          state_id: "1356",
        },
        {
          id: "18723",
          name: "Ronsberg",
          state_id: "1356",
        },
        {
          id: "18724",
          name: "Ruckersdorf",
          state_id: "1356",
        },
        {
          id: "18725",
          name: "Schaufling",
          state_id: "1356",
        },
        {
          id: "18726",
          name: "Schonberg",
          state_id: "1356",
        },
        {
          id: "18727",
          name: "Seefeld",
          state_id: "1356",
        },
        {
          id: "18728",
          name: "Sengenthal",
          state_id: "1356",
        },
        {
          id: "18729",
          name: "Sondheim v.d.Rhon",
          state_id: "1356",
        },
        {
          id: "18730",
          name: "Steinwiesen",
          state_id: "1356",
        },
        {
          id: "18731",
          name: "Stockheim",
          state_id: "1356",
        },
        {
          id: "18732",
          name: "Tagmersheim",
          state_id: "1356",
        },
        {
          id: "18733",
          name: "Uettingen",
          state_id: "1356",
        },
        {
          id: "18734",
          name: "Unterfohring",
          state_id: "1356",
        },
        {
          id: "18735",
          name: "Weibensberg",
          state_id: "1356",
        },
        {
          id: "18736",
          name: "Wiesthal",
          state_id: "1356",
        },
        {
          id: "18737",
          name: "Wildflecken",
          state_id: "1356",
        },
        {
          id: "18738",
          name: "Wolfertschwenden",
          state_id: "1356",
        },
        {
          id: "18739",
          name: "Zorneding",
          state_id: "1356",
        },
      ],
      Bayern: [
        {
          id: "18740",
          name: "Abensberg",
          state_id: "1357",
        },
        {
          id: "18741",
          name: "Aichach",
          state_id: "1357",
        },
        {
          id: "18742",
          name: "Ainring",
          state_id: "1357",
        },
        {
          id: "18743",
          name: "Altdorf",
          state_id: "1357",
        },
        {
          id: "18744",
          name: "Altotting",
          state_id: "1357",
        },
        {
          id: "18745",
          name: "Altusried",
          state_id: "1357",
        },
        {
          id: "18746",
          name: "Alzenau",
          state_id: "1357",
        },
        {
          id: "18747",
          name: "Amberg",
          state_id: "1357",
        },
        {
          id: "18748",
          name: "Amerang",
          state_id: "1357",
        },
        {
          id: "18750",
          name: "Aschaffenburg",
          state_id: "1357",
        },
        {
          id: "18751",
          name: "Augsburg",
          state_id: "1357",
        },
        {
          id: "18752",
          name: "Bad Aibling",
          state_id: "1357",
        },
        {
          id: "18753",
          name: "Bad Kissingen",
          state_id: "1357",
        },
        {
          id: "18754",
          name: "Bad Neustadt",
          state_id: "1357",
        },
        {
          id: "18755",
          name: "Bad Reichenhall",
          state_id: "1357",
        },
        {
          id: "18756",
          name: "Bad Tolz",
          state_id: "1357",
        },
        {
          id: "18757",
          name: "Bad Windsheim",
          state_id: "1357",
        },
        {
          id: "18758",
          name: "Bad Worishofen",
          state_id: "1357",
        },
        {
          id: "18759",
          name: "Bamberg",
          state_id: "1357",
        },
        {
          id: "18760",
          name: "Bayreuth",
          state_id: "1357",
        },
        {
          id: "18761",
          name: "Bobingen",
          state_id: "1357",
        },
        {
          id: "18762",
          name: "Bogen",
          state_id: "1357",
        },
        {
          id: "18763",
          name: "Bruckmuhl",
          state_id: "1357",
        },
        {
          id: "18764",
          name: "Buchloe",
          state_id: "1357",
        },
        {
          id: "18765",
          name: "Burghausen",
          state_id: "1357",
        },
        {
          id: "18766",
          name: "Burgkirchen",
          state_id: "1357",
        },
        {
          id: "18767",
          name: "Burglengenfeld",
          state_id: "1357",
        },
        {
          id: "18768",
          name: "Burgthann",
          state_id: "1357",
        },
        {
          id: "18769",
          name: "Buttenheim",
          state_id: "1357",
        },
        {
          id: "18770",
          name: "Cadolzburg",
          state_id: "1357",
        },
        {
          id: "18771",
          name: "Castell",
          state_id: "1357",
        },
        {
          id: "18772",
          name: "Cham",
          state_id: "1357",
        },
        {
          id: "18773",
          name: "Coburg",
          state_id: "1357",
        },
        {
          id: "18774",
          name: "Dachau",
          state_id: "1357",
        },
        {
          id: "18775",
          name: "Deggendorf",
          state_id: "1357",
        },
        {
          id: "18776",
          name: "DieBen",
          state_id: "1357",
        },
        {
          id: "18777",
          name: "Diedorf",
          state_id: "1357",
        },
        {
          id: "18778",
          name: "Dietmannsried",
          state_id: "1357",
        },
        {
          id: "18779",
          name: "Dietramszell",
          state_id: "1357",
        },
        {
          id: "18780",
          name: "Dillingen",
          state_id: "1357",
        },
        {
          id: "18781",
          name: "Dingolfing",
          state_id: "1357",
        },
        {
          id: "18782",
          name: "Dinkelsbuhl",
          state_id: "1357",
        },
        {
          id: "18783",
          name: "Dombuhl",
          state_id: "1357",
        },
        {
          id: "18784",
          name: "Donauworth",
          state_id: "1357",
        },
        {
          id: "18785",
          name: "Dorfen",
          state_id: "1357",
        },
        {
          id: "18786",
          name: "Ebersberg",
          state_id: "1357",
        },
        {
          id: "18787",
          name: "Eching",
          state_id: "1357",
        },
        {
          id: "18788",
          name: "Eckental",
          state_id: "1357",
        },
        {
          id: "18789",
          name: "Eggenfelden",
          state_id: "1357",
        },
        {
          id: "18790",
          name: "Eichenau",
          state_id: "1357",
        },
        {
          id: "18791",
          name: "Eichstatt",
          state_id: "1357",
        },
        {
          id: "18792",
          name: "Elchingen",
          state_id: "1357",
        },
        {
          id: "18793",
          name: "Erding",
          state_id: "1357",
        },
        {
          id: "18794",
          name: "Ergolding",
          state_id: "1357",
        },
        {
          id: "18795",
          name: "Erlangen",
          state_id: "1357",
        },
        {
          id: "18796",
          name: "Erlenbach",
          state_id: "1357",
        },
        {
          id: "18797",
          name: "Essenbach",
          state_id: "1357",
        },
        {
          id: "18798",
          name: "Feldafing",
          state_id: "1357",
        },
        {
          id: "18799",
          name: "Feldkirchen-Westerham",
          state_id: "1357",
        },
        {
          id: "18800",
          name: "Feucht",
          state_id: "1357",
        },
        {
          id: "18801",
          name: "Feuchtwangen",
          state_id: "1357",
        },
        {
          id: "18802",
          name: "Forchheim",
          state_id: "1357",
        },
        {
          id: "18803",
          name: "Freilassing",
          state_id: "1357",
        },
        {
          id: "18804",
          name: "Freising",
          state_id: "1357",
        },
        {
          id: "18805",
          name: "Fridolfing",
          state_id: "1357",
        },
        {
          id: "18806",
          name: "Friedberg",
          state_id: "1357",
        },
        {
          id: "18807",
          name: "Furstenfeldbruck",
          state_id: "1357",
        },
        {
          id: "18808",
          name: "Furth",
          state_id: "1357",
        },
        {
          id: "18809",
          name: "Furth im Wald",
          state_id: "1357",
        },
        {
          id: "18810",
          name: "Fussen",
          state_id: "1357",
        },
        {
          id: "18811",
          name: "Gachenbach",
          state_id: "1357",
        },
        {
          id: "18812",
          name: "Gaimersheim",
          state_id: "1357",
        },
        {
          id: "18813",
          name: "Garching",
          state_id: "1357",
        },
        {
          id: "18814",
          name: "Garmisch-Partenkirchen",
          state_id: "1357",
        },
        {
          id: "18815",
          name: "Gauting",
          state_id: "1357",
        },
        {
          id: "18816",
          name: "Gemunden",
          state_id: "1357",
        },
        {
          id: "18817",
          name: "Geretsried",
          state_id: "1357",
        },
        {
          id: "18818",
          name: "Germering",
          state_id: "1357",
        },
        {
          id: "18819",
          name: "Gersthofen",
          state_id: "1357",
        },
        {
          id: "18820",
          name: "Gilching",
          state_id: "1357",
        },
        {
          id: "18821",
          name: "Goldbach",
          state_id: "1357",
        },
        {
          id: "18822",
          name: "Grafelfing",
          state_id: "1357",
        },
        {
          id: "18823",
          name: "Grafenau",
          state_id: "1357",
        },
        {
          id: "18824",
          name: "Grafing",
          state_id: "1357",
        },
        {
          id: "18825",
          name: "GroBostheim",
          state_id: "1357",
        },
        {
          id: "18826",
          name: "Grobenstadt",
          state_id: "1357",
        },
        {
          id: "18827",
          name: "Grobenzell",
          state_id: "1357",
        },
        {
          id: "18828",
          name: "Grunwald",
          state_id: "1357",
        },
        {
          id: "18829",
          name: "Gunzburg",
          state_id: "1357",
        },
        {
          id: "18830",
          name: "Gunzenhausen",
          state_id: "1357",
        },
        {
          id: "18831",
          name: "HaBfurt",
          state_id: "1357",
        },
        {
          id: "18832",
          name: "Haar",
          state_id: "1357",
        },
        {
          id: "18833",
          name: "Hammelburg",
          state_id: "1357",
        },
        {
          id: "18834",
          name: "Hasloch",
          state_id: "1357",
        },
        {
          id: "18835",
          name: "Hauzenberg",
          state_id: "1357",
        },
        {
          id: "18836",
          name: "Helmbrechts",
          state_id: "1357",
        },
        {
          id: "18837",
          name: "Henfenfeld",
          state_id: "1357",
        },
        {
          id: "18838",
          name: "Hersbruck",
          state_id: "1357",
        },
        {
          id: "18839",
          name: "Herzogenaurach",
          state_id: "1357",
        },
        {
          id: "18840",
          name: "Hilpoltstein",
          state_id: "1357",
        },
        {
          id: "18841",
          name: "Hirschaid",
          state_id: "1357",
        },
        {
          id: "18842",
          name: "Hochstadt",
          state_id: "1357",
        },
        {
          id: "18843",
          name: "Hof",
          state_id: "1357",
        },
        {
          id: "18844",
          name: "Holzkirchen",
          state_id: "1357",
        },
        {
          id: "18845",
          name: "Hosbach",
          state_id: "1357",
        },
        {
          id: "18846",
          name: "Illertissen",
          state_id: "1357",
        },
        {
          id: "18847",
          name: "Immenstadt",
          state_id: "1357",
        },
        {
          id: "18848",
          name: "Ingolstadt",
          state_id: "1357",
        },
        {
          id: "18849",
          name: "Inning",
          state_id: "1357",
        },
        {
          id: "18850",
          name: "Ismaning",
          state_id: "1357",
        },
        {
          id: "18851",
          name: "Karlsfeld",
          state_id: "1357",
        },
        {
          id: "18852",
          name: "Karlstadt",
          state_id: "1357",
        },
        {
          id: "18853",
          name: "Kaufbeuren",
          state_id: "1357",
        },
        {
          id: "18854",
          name: "Kelheim",
          state_id: "1357",
        },
        {
          id: "18855",
          name: "Kempten",
          state_id: "1357",
        },
        {
          id: "18856",
          name: "Kiefersfelden",
          state_id: "1357",
        },
        {
          id: "18857",
          name: "Kirchheim",
          state_id: "1357",
        },
        {
          id: "18858",
          name: "Kissing",
          state_id: "1357",
        },
        {
          id: "18859",
          name: "Kitzingen",
          state_id: "1357",
        },
        {
          id: "18860",
          name: "Kleinostheim",
          state_id: "1357",
        },
        {
          id: "18861",
          name: "Klingenberg",
          state_id: "1357",
        },
        {
          id: "18862",
          name: "Kolbermoor",
          state_id: "1357",
        },
        {
          id: "18863",
          name: "Konigsbrunn",
          state_id: "1357",
        },
        {
          id: "18864",
          name: "Kreuzwertheim",
          state_id: "1357",
        },
        {
          id: "18865",
          name: "Kronach",
          state_id: "1357",
        },
        {
          id: "18866",
          name: "Krumbach",
          state_id: "1357",
        },
        {
          id: "18867",
          name: "Kulmbach",
          state_id: "1357",
        },
        {
          id: "18868",
          name: "Kummersbruck",
          state_id: "1357",
        },
        {
          id: "18869",
          name: "Landau",
          state_id: "1357",
        },
        {
          id: "18870",
          name: "Landsberg",
          state_id: "1357",
        },
        {
          id: "18871",
          name: "Landshut",
          state_id: "1357",
        },
        {
          id: "18872",
          name: "Langenzenn",
          state_id: "1357",
        },
        {
          id: "18873",
          name: "Lappersdorf",
          state_id: "1357",
        },
        {
          id: "18874",
          name: "Lauf",
          state_id: "1357",
        },
        {
          id: "18875",
          name: "Lauingen",
          state_id: "1357",
        },
        {
          id: "18876",
          name: "Leinburg",
          state_id: "1357",
        },
        {
          id: "18877",
          name: "Lenggries",
          state_id: "1357",
        },
        {
          id: "18878",
          name: "Lichtenfels",
          state_id: "1357",
        },
        {
          id: "18879",
          name: "Lindach",
          state_id: "1357",
        },
        {
          id: "18880",
          name: "Lindau",
          state_id: "1357",
        },
        {
          id: "18881",
          name: "Lindenberg",
          state_id: "1357",
        },
        {
          id: "18882",
          name: "Lohr",
          state_id: "1357",
        },
        {
          id: "18883",
          name: "Mainburg",
          state_id: "1357",
        },
        {
          id: "18884",
          name: "Maisach",
          state_id: "1357",
        },
        {
          id: "18885",
          name: "Manching",
          state_id: "1357",
        },
        {
          id: "18886",
          name: "Markt Schwaben",
          state_id: "1357",
        },
        {
          id: "18887",
          name: "Marktheidenfeld",
          state_id: "1357",
        },
        {
          id: "18888",
          name: "Marktoberdorf",
          state_id: "1357",
        },
        {
          id: "18889",
          name: "Marktredwitz",
          state_id: "1357",
        },
        {
          id: "18890",
          name: "Maxhutte-Haidhof",
          state_id: "1357",
        },
        {
          id: "18891",
          name: "Meitingen",
          state_id: "1357",
        },
        {
          id: "18892",
          name: "Memmingen",
          state_id: "1357",
        },
        {
          id: "18893",
          name: "Mering",
          state_id: "1357",
        },
        {
          id: "18894",
          name: "Miesbach",
          state_id: "1357",
        },
        {
          id: "18895",
          name: "Miltenberg",
          state_id: "1357",
        },
        {
          id: "18896",
          name: "Mindelheim",
          state_id: "1357",
        },
        {
          id: "18897",
          name: "Moosburg",
          state_id: "1357",
        },
        {
          id: "18898",
          name: "Muhldorf",
          state_id: "1357",
        },
        {
          id: "18899",
          name: "Munchberg",
          state_id: "1357",
        },
        {
          id: "18900",
          name: "Munchen",
          state_id: "1357",
        },
        {
          id: "18901",
          name: "Munningen",
          state_id: "1357",
        },
        {
          id: "18902",
          name: "Murnau",
          state_id: "1357",
        },
        {
          id: "18903",
          name: "Naila",
          state_id: "1357",
        },
        {
          id: "18904",
          name: "Neubiberg",
          state_id: "1357",
        },
        {
          id: "18905",
          name: "Neuburg",
          state_id: "1357",
        },
        {
          id: "18906",
          name: "Neufahrn",
          state_id: "1357",
        },
        {
          id: "18907",
          name: "Neumarkt",
          state_id: "1357",
        },
        {
          id: "18908",
          name: "Neuried",
          state_id: "1357",
        },
        {
          id: "18909",
          name: "NeusaB",
          state_id: "1357",
        },
        {
          id: "18910",
          name: "Neustadt",
          state_id: "1357",
        },
        {
          id: "18911",
          name: "Neutraubling",
          state_id: "1357",
        },
        {
          id: "18912",
          name: "Nordlingen",
          state_id: "1357",
        },
        {
          id: "18913",
          name: "Nuremberg",
          state_id: "1357",
        },
        {
          id: "18914",
          name: "Nurnberg",
          state_id: "1357",
        },
        {
          id: "18915",
          name: "Oberasbach",
          state_id: "1357",
        },
        {
          id: "18916",
          name: "Oberhaching",
          state_id: "1357",
        },
        {
          id: "18917",
          name: "OberschleiBheim",
          state_id: "1357",
        },
        {
          id: "18918",
          name: "Oberstdorf",
          state_id: "1357",
        },
        {
          id: "18919",
          name: "Ochsenfurt",
          state_id: "1357",
        },
        {
          id: "18920",
          name: "Olching",
          state_id: "1357",
        },
        {
          id: "18921",
          name: "Osterhofen",
          state_id: "1357",
        },
        {
          id: "18922",
          name: "Ostheim",
          state_id: "1357",
        },
        {
          id: "18923",
          name: "Ottobrunn",
          state_id: "1357",
        },
        {
          id: "18924",
          name: "Parsberg",
          state_id: "1357",
        },
        {
          id: "18925",
          name: "Passau",
          state_id: "1357",
        },
        {
          id: "18926",
          name: "Pegnitz",
          state_id: "1357",
        },
        {
          id: "18927",
          name: "PeiBenberg",
          state_id: "1357",
        },
        {
          id: "18928",
          name: "Peiting",
          state_id: "1357",
        },
        {
          id: "18929",
          name: "Pentling",
          state_id: "1357",
        },
        {
          id: "18930",
          name: "Penzberg",
          state_id: "1357",
        },
        {
          id: "18931",
          name: "Pfaffenhofen",
          state_id: "1357",
        },
        {
          id: "18932",
          name: "Pfarrkirchen",
          state_id: "1357",
        },
        {
          id: "18933",
          name: "Planegg",
          state_id: "1357",
        },
        {
          id: "18934",
          name: "Plattling",
          state_id: "1357",
        },
        {
          id: "18935",
          name: "Pocking",
          state_id: "1357",
        },
        {
          id: "18936",
          name: "Poing",
          state_id: "1357",
        },
        {
          id: "18937",
          name: "Polling",
          state_id: "1357",
        },
        {
          id: "18938",
          name: "Pommelsbrunn",
          state_id: "1357",
        },
        {
          id: "18939",
          name: "Prien",
          state_id: "1357",
        },
        {
          id: "18940",
          name: "Puchheim",
          state_id: "1357",
        },
        {
          id: "18941",
          name: "Rannersdorf",
          state_id: "1357",
        },
        {
          id: "18942",
          name: "Raubling",
          state_id: "1357",
        },
        {
          id: "18943",
          name: "Regen",
          state_id: "1357",
        },
        {
          id: "18944",
          name: "Regensburg",
          state_id: "1357",
        },
        {
          id: "18945",
          name: "Regenstauf",
          state_id: "1357",
        },
        {
          id: "18946",
          name: "Rehau",
          state_id: "1357",
        },
        {
          id: "18947",
          name: "Rodental",
          state_id: "1357",
        },
        {
          id: "18948",
          name: "Roding",
          state_id: "1357",
        },
        {
          id: "18949",
          name: "Rosenheim",
          state_id: "1357",
        },
        {
          id: "18950",
          name: "Roth",
          state_id: "1357",
        },
        {
          id: "18951",
          name: "Rothenbach",
          state_id: "1357",
        },
        {
          id: "18952",
          name: "Rothenburg",
          state_id: "1357",
        },
        {
          id: "18953",
          name: "Ruhstorf",
          state_id: "1357",
        },
        {
          id: "18954",
          name: "Schnelldorf",
          state_id: "1357",
        },
        {
          id: "18955",
          name: "Schongau",
          state_id: "1357",
        },
        {
          id: "18956",
          name: "Schrobenhausen",
          state_id: "1357",
        },
        {
          id: "18957",
          name: "Schwabach",
          state_id: "1357",
        },
        {
          id: "18958",
          name: "Schwabmunchen",
          state_id: "1357",
        },
        {
          id: "18959",
          name: "Schwandorf",
          state_id: "1357",
        },
        {
          id: "18960",
          name: "Schwarzenbach",
          state_id: "1357",
        },
        {
          id: "18961",
          name: "Schweinfurt",
          state_id: "1357",
        },
        {
          id: "18962",
          name: "Selb",
          state_id: "1357",
        },
        {
          id: "18963",
          name: "Selbitz",
          state_id: "1357",
        },
        {
          id: "18964",
          name: "Senden",
          state_id: "1357",
        },
        {
          id: "18965",
          name: "Simbach",
          state_id: "1357",
        },
        {
          id: "18966",
          name: "Sonthofen",
          state_id: "1357",
        },
        {
          id: "18967",
          name: "Spalt",
          state_id: "1357",
        },
        {
          id: "18968",
          name: "Stadtbergen",
          state_id: "1357",
        },
        {
          id: "18969",
          name: "Staffelstein",
          state_id: "1357",
        },
        {
          id: "18970",
          name: "Starnberg",
          state_id: "1357",
        },
        {
          id: "18971",
          name: "Stein",
          state_id: "1357",
        },
        {
          id: "18972",
          name: "Stephanskirchen",
          state_id: "1357",
        },
        {
          id: "18973",
          name: "Straubing",
          state_id: "1357",
        },
        {
          id: "18974",
          name: "Sulzbach-Rosenberg",
          state_id: "1357",
        },
        {
          id: "18975",
          name: "Taufkirchen",
          state_id: "1357",
        },
        {
          id: "18976",
          name: "Thansau",
          state_id: "1357",
        },
        {
          id: "18977",
          name: "Tirschenreuth",
          state_id: "1357",
        },
        {
          id: "18978",
          name: "Toging",
          state_id: "1357",
        },
        {
          id: "18979",
          name: "Traunreut",
          state_id: "1357",
        },
        {
          id: "18980",
          name: "Traunstein",
          state_id: "1357",
        },
        {
          id: "18981",
          name: "Treuchtlingen",
          state_id: "1357",
        },
        {
          id: "18982",
          name: "Trostberg",
          state_id: "1357",
        },
        {
          id: "18983",
          name: "Tutzing",
          state_id: "1357",
        },
        {
          id: "18984",
          name: "Unterbergen",
          state_id: "1357",
        },
        {
          id: "18985",
          name: "Unterhaching",
          state_id: "1357",
        },
        {
          id: "18986",
          name: "UnterschleiBheim",
          state_id: "1357",
        },
        {
          id: "18987",
          name: "Valley",
          state_id: "1357",
        },
        {
          id: "18988",
          name: "Vaterstetten",
          state_id: "1357",
        },
        {
          id: "18989",
          name: "Veitshochheim",
          state_id: "1357",
        },
        {
          id: "18990",
          name: "Viechtach",
          state_id: "1357",
        },
        {
          id: "18991",
          name: "Vilgertshofen",
          state_id: "1357",
        },
        {
          id: "18992",
          name: "Vilsbiburg",
          state_id: "1357",
        },
        {
          id: "18993",
          name: "Vilshofen",
          state_id: "1357",
        },
        {
          id: "18994",
          name: "Vohringen",
          state_id: "1357",
        },
        {
          id: "18995",
          name: "Volkach",
          state_id: "1357",
        },
        {
          id: "18996",
          name: "Waldkirchen",
          state_id: "1357",
        },
        {
          id: "18997",
          name: "Waldkraiburg",
          state_id: "1357",
        },
        {
          id: "18998",
          name: "Walkertshofen",
          state_id: "1357",
        },
        {
          id: "18999",
          name: "Wasserburg",
          state_id: "1357",
        },
        {
          id: "19000",
          name: "WeiBenburg",
          state_id: "1357",
        },
        {
          id: "19001",
          name: "WeiBenhorn",
          state_id: "1357",
        },
        {
          id: "19002",
          name: "Weiden",
          state_id: "1357",
        },
        {
          id: "19003",
          name: "Weidenberg",
          state_id: "1357",
        },
        {
          id: "19004",
          name: "Weilheim",
          state_id: "1357",
        },
        {
          id: "19005",
          name: "Wendelstein",
          state_id: "1357",
        },
        {
          id: "19006",
          name: "Werneck",
          state_id: "1357",
        },
        {
          id: "19007",
          name: "Wessling",
          state_id: "1357",
        },
        {
          id: "19008",
          name: "Wolfratshausen",
          state_id: "1357",
        },
        {
          id: "19009",
          name: "Wolnzach",
          state_id: "1357",
        },
        {
          id: "19010",
          name: "Wunsiedel",
          state_id: "1357",
        },
        {
          id: "19011",
          name: "Wurzburg",
          state_id: "1357",
        },
        {
          id: "19012",
          name: "Zirndorf",
          state_id: "1357",
        },
        {
          id: "19013",
          name: "Zwiesel",
          state_id: "1357",
        },
      ],
      "Beilstein Wurtt": [],
      Berlin: [
        {
          id: "19014",
          name: "Berlin",
          state_id: "1359",
        },
        {
          id: "19015",
          name: "Panketal",
          state_id: "1359",
        },
        {
          id: "19016",
          name: "Steinfeld",
          state_id: "1359",
        },
      ],
      Brandenburg: [
        {
          id: "19017",
          name: "Angermunde",
          state_id: "1360",
        },
        {
          id: "19018",
          name: "Bad Freienwalde",
          state_id: "1360",
        },
        {
          id: "19019",
          name: "Bad Liebenwerda",
          state_id: "1360",
        },
        {
          id: "19020",
          name: "Barnim",
          state_id: "1360",
        },
        {
          id: "19021",
          name: "Beeskow",
          state_id: "1360",
        },
        {
          id: "19022",
          name: "Bernau",
          state_id: "1360",
        },
        {
          id: "19023",
          name: "Blankenfelde",
          state_id: "1360",
        },
        {
          id: "19024",
          name: "Brandenburg",
          state_id: "1360",
        },
        {
          id: "19025",
          name: "Brieselang",
          state_id: "1360",
        },
        {
          id: "19026",
          name: "Cottbus",
          state_id: "1360",
        },
        {
          id: "19027",
          name: "Dahlewitz",
          state_id: "1360",
        },
        {
          id: "19028",
          name: "Dahme",
          state_id: "1360",
        },
        {
          id: "19029",
          name: "Eberswalde",
          state_id: "1360",
        },
        {
          id: "19030",
          name: "Eisenhuttenstadt",
          state_id: "1360",
        },
        {
          id: "19031",
          name: "Elsterwerda",
          state_id: "1360",
        },
        {
          id: "19032",
          name: "Erkner",
          state_id: "1360",
        },
        {
          id: "19033",
          name: "Falkensee",
          state_id: "1360",
        },
        {
          id: "19034",
          name: "Finsterwalde",
          state_id: "1360",
        },
        {
          id: "19035",
          name: "Forst",
          state_id: "1360",
        },
        {
          id: "19036",
          name: "Frankfurt",
          state_id: "1360",
        },
        {
          id: "19037",
          name: "Fredersdorf-Vogelsdorf",
          state_id: "1360",
        },
        {
          id: "19038",
          name: "Furstenwalde",
          state_id: "1360",
        },
        {
          id: "19039",
          name: "Glienicke",
          state_id: "1360",
        },
        {
          id: "19040",
          name: "Gransee",
          state_id: "1360",
        },
        {
          id: "19041",
          name: "GroBraschen",
          state_id: "1360",
        },
        {
          id: "19042",
          name: "Guben",
          state_id: "1360",
        },
        {
          id: "19043",
          name: "Heidesee",
          state_id: "1360",
        },
        {
          id: "19044",
          name: "Hennigsdorf",
          state_id: "1360",
        },
        {
          id: "19045",
          name: "Herzberg",
          state_id: "1360",
        },
        {
          id: "19046",
          name: "Hohen Neuendorf",
          state_id: "1360",
        },
        {
          id: "19047",
          name: "Jacobsdorf",
          state_id: "1360",
        },
        {
          id: "19048",
          name: "Juterbog",
          state_id: "1360",
        },
        {
          id: "19049",
          name: "Kleinmachnow",
          state_id: "1360",
        },
        {
          id: "19050",
          name: "Kolkwitz",
          state_id: "1360",
        },
        {
          id: "19051",
          name: "Konigs Wusterhausen",
          state_id: "1360",
        },
        {
          id: "19052",
          name: "Kyritz",
          state_id: "1360",
        },
        {
          id: "19053",
          name: "Lauchhammer",
          state_id: "1360",
        },
        {
          id: "19054",
          name: "Lubben",
          state_id: "1360",
        },
        {
          id: "19055",
          name: "Lubbenau",
          state_id: "1360",
        },
        {
          id: "19056",
          name: "Luckenwalde",
          state_id: "1360",
        },
        {
          id: "19057",
          name: "Ludwigsfelde",
          state_id: "1360",
        },
        {
          id: "19058",
          name: "Nauen",
          state_id: "1360",
        },
        {
          id: "19059",
          name: "Neuenhagen",
          state_id: "1360",
        },
        {
          id: "19060",
          name: "Neuruppin",
          state_id: "1360",
        },
        {
          id: "19061",
          name: "Oranienburg",
          state_id: "1360",
        },
        {
          id: "19062",
          name: "Perleberg",
          state_id: "1360",
        },
        {
          id: "19063",
          name: "Petershagen-Eggersdorf",
          state_id: "1360",
        },
        {
          id: "19064",
          name: "Potsdam",
          state_id: "1360",
        },
        {
          id: "19065",
          name: "Premnitz",
          state_id: "1360",
        },
        {
          id: "19066",
          name: "Prenzlau",
          state_id: "1360",
        },
        {
          id: "19067",
          name: "Pritzwalk",
          state_id: "1360",
        },
        {
          id: "19068",
          name: "Rathenow",
          state_id: "1360",
        },
        {
          id: "19069",
          name: "Rudersdorf",
          state_id: "1360",
        },
        {
          id: "19070",
          name: "Schonefeld",
          state_id: "1360",
        },
        {
          id: "19071",
          name: "Schoneiche",
          state_id: "1360",
        },
        {
          id: "19072",
          name: "Schwedt",
          state_id: "1360",
        },
        {
          id: "19073",
          name: "Schwielowsee",
          state_id: "1360",
        },
        {
          id: "19074",
          name: "Senftenberg",
          state_id: "1360",
        },
        {
          id: "19075",
          name: "Spremberg",
          state_id: "1360",
        },
        {
          id: "19076",
          name: "Strausberg",
          state_id: "1360",
        },
        {
          id: "19077",
          name: "Teltow",
          state_id: "1360",
        },
        {
          id: "19078",
          name: "Templin",
          state_id: "1360",
        },
        {
          id: "19079",
          name: "Velten",
          state_id: "1360",
        },
        {
          id: "19080",
          name: "Werder",
          state_id: "1360",
        },
        {
          id: "19081",
          name: "Wildau",
          state_id: "1360",
        },
        {
          id: "19082",
          name: "Wittenberge",
          state_id: "1360",
        },
        {
          id: "19083",
          name: "Wittstock",
          state_id: "1360",
        },
        {
          id: "19084",
          name: "Zehdenick",
          state_id: "1360",
        },
        {
          id: "19085",
          name: "Zepernick",
          state_id: "1360",
        },
      ],
      Bremen: [
        {
          id: "19086",
          name: "Bremen",
          state_id: "1361",
        },
        {
          id: "19087",
          name: "Bremerhaven",
          state_id: "1361",
        },
      ],
      Dreisbach: [],
      "Freistaat Bayern": [],
      Hamburg: [
        {
          id: "19088",
          name: "Berne",
          state_id: "1364",
        },
        {
          id: "19089",
          name: "Hamburg",
          state_id: "1364",
        },
      ],
      Hannover: [
        {
          id: "19090",
          name: "Diekholzen",
          state_id: "1365",
        },
      ],
      Heroldstatt: [
        {
          id: "19091",
          name: "Heroldstatt",
          state_id: "1366",
        },
      ],
      Hessen: [
        {
          id: "19092",
          name: "ABlar",
          state_id: "1367",
        },
        {
          id: "19093",
          name: "Alsbach-HÃƒÂ¤hnlein",
          state_id: "1367",
        },
        {
          id: "19094",
          name: "Alsfeld",
          state_id: "1367",
        },
        {
          id: "19095",
          name: "Altenstadt",
          state_id: "1367",
        },
        {
          id: "19096",
          name: "Angelburg",
          state_id: "1367",
        },
        {
          id: "19097",
          name: "Arolsen",
          state_id: "1367",
        },
        {
          id: "19098",
          name: "Asslar",
          state_id: "1367",
        },
        {
          id: "19099",
          name: "Babenhausen",
          state_id: "1367",
        },
        {
          id: "19100",
          name: "Bad Camberg",
          state_id: "1367",
        },
        {
          id: "19101",
          name: "Bad Hersfeld",
          state_id: "1367",
        },
        {
          id: "19102",
          name: "Bad Homburg",
          state_id: "1367",
        },
        {
          id: "19103",
          name: "Bad Nauheim",
          state_id: "1367",
        },
        {
          id: "19104",
          name: "Bad Orb",
          state_id: "1367",
        },
        {
          id: "19105",
          name: "Bad Schwalbach",
          state_id: "1367",
        },
        {
          id: "19106",
          name: "Bad Soden",
          state_id: "1367",
        },
        {
          id: "19107",
          name: "Bad Soden-Salmunster",
          state_id: "1367",
        },
        {
          id: "19108",
          name: "Bad Sooden-Allendorf",
          state_id: "1367",
        },
        {
          id: "19109",
          name: "Bad Vilbel",
          state_id: "1367",
        },
        {
          id: "19110",
          name: "Bad Wildungen",
          state_id: "1367",
        },
        {
          id: "19111",
          name: "Baunatal",
          state_id: "1367",
        },
        {
          id: "19112",
          name: "Bebra",
          state_id: "1367",
        },
        {
          id: "19113",
          name: "Beerfelden",
          state_id: "1367",
        },
        {
          id: "19114",
          name: "Bensheim",
          state_id: "1367",
        },
        {
          id: "19115",
          name: "Berkatal",
          state_id: "1367",
        },
        {
          id: "19116",
          name: "Biblis",
          state_id: "1367",
        },
        {
          id: "19117",
          name: "Bickenbach",
          state_id: "1367",
        },
        {
          id: "19118",
          name: "Biebertal",
          state_id: "1367",
        },
        {
          id: "19119",
          name: "Biedenkopf",
          state_id: "1367",
        },
        {
          id: "19120",
          name: "Birkenau",
          state_id: "1367",
        },
        {
          id: "19121",
          name: "Bischofsheim",
          state_id: "1367",
        },
        {
          id: "19122",
          name: "Borken",
          state_id: "1367",
        },
        {
          id: "19123",
          name: "Braunfels",
          state_id: "1367",
        },
        {
          id: "19124",
          name: "Breidenbach",
          state_id: "1367",
        },
        {
          id: "19125",
          name: "Bruchkobel",
          state_id: "1367",
        },
        {
          id: "19126",
          name: "Budingen",
          state_id: "1367",
        },
        {
          id: "19127",
          name: "Burstadt",
          state_id: "1367",
        },
        {
          id: "19128",
          name: "Buseck",
          state_id: "1367",
        },
        {
          id: "19129",
          name: "Buttelborn",
          state_id: "1367",
        },
        {
          id: "19130",
          name: "Butzbach",
          state_id: "1367",
        },
        {
          id: "19131",
          name: "Darmstadt",
          state_id: "1367",
        },
        {
          id: "19132",
          name: "Dautphetal",
          state_id: "1367",
        },
        {
          id: "19133",
          name: "Dieburg",
          state_id: "1367",
        },
        {
          id: "19134",
          name: "Dietzenbach",
          state_id: "1367",
        },
        {
          id: "19135",
          name: "Dillenburg",
          state_id: "1367",
        },
        {
          id: "19136",
          name: "Dreieich",
          state_id: "1367",
        },
        {
          id: "19137",
          name: "Egelsbach",
          state_id: "1367",
        },
        {
          id: "19138",
          name: "Eichenzell",
          state_id: "1367",
        },
        {
          id: "19139",
          name: "Eltville",
          state_id: "1367",
        },
        {
          id: "19140",
          name: "Eppstein",
          state_id: "1367",
        },
        {
          id: "19141",
          name: "Erbach",
          state_id: "1367",
        },
        {
          id: "19142",
          name: "Erlensee",
          state_id: "1367",
        },
        {
          id: "19143",
          name: "Erzhausen",
          state_id: "1367",
        },
        {
          id: "19144",
          name: "Eschborn",
          state_id: "1367",
        },
        {
          id: "19145",
          name: "Eschenburg",
          state_id: "1367",
        },
        {
          id: "19146",
          name: "Eschwege",
          state_id: "1367",
        },
        {
          id: "19147",
          name: "Felsberg",
          state_id: "1367",
        },
        {
          id: "19148",
          name: "Fernwald",
          state_id: "1367",
        },
        {
          id: "19149",
          name: "Florsheim",
          state_id: "1367",
        },
        {
          id: "19150",
          name: "Frankenberg",
          state_id: "1367",
        },
        {
          id: "19151",
          name: "Frankfurt",
          state_id: "1367",
        },
        {
          id: "19152",
          name: "Freigericht",
          state_id: "1367",
        },
        {
          id: "19153",
          name: "Friedberg",
          state_id: "1367",
        },
        {
          id: "19154",
          name: "Friedrichsdorf",
          state_id: "1367",
        },
        {
          id: "19155",
          name: "Fritzlar",
          state_id: "1367",
        },
        {
          id: "19156",
          name: "Fulda",
          state_id: "1367",
        },
        {
          id: "19157",
          name: "Fuldabruck",
          state_id: "1367",
        },
        {
          id: "19158",
          name: "Fuldatal",
          state_id: "1367",
        },
        {
          id: "19159",
          name: "Geisenheim",
          state_id: "1367",
        },
        {
          id: "19160",
          name: "Gelnhausen",
          state_id: "1367",
        },
        {
          id: "19161",
          name: "Gernsheim",
          state_id: "1367",
        },
        {
          id: "19162",
          name: "GieBen",
          state_id: "1367",
        },
        {
          id: "19163",
          name: "Giessen",
          state_id: "1367",
        },
        {
          id: "19164",
          name: "Ginsheim-Gustavsburg",
          state_id: "1367",
        },
        {
          id: "19165",
          name: "Gladenbach",
          state_id: "1367",
        },
        {
          id: "19166",
          name: "Griesheim",
          state_id: "1367",
        },
        {
          id: "19167",
          name: "GroB-Gerau",
          state_id: "1367",
        },
        {
          id: "19168",
          name: "GroB-Umstadt",
          state_id: "1367",
        },
        {
          id: "19169",
          name: "GroB-Zimmern",
          state_id: "1367",
        },
        {
          id: "19170",
          name: "Grossenluder",
          state_id: "1367",
        },
        {
          id: "19171",
          name: "Gruenberg",
          state_id: "1367",
        },
        {
          id: "19172",
          name: "Grunberg",
          state_id: "1367",
        },
        {
          id: "19173",
          name: "Grundau",
          state_id: "1367",
        },
        {
          id: "19174",
          name: "Hadamar",
          state_id: "1367",
        },
        {
          id: "19175",
          name: "Haiger",
          state_id: "1367",
        },
        {
          id: "19176",
          name: "Hainburg",
          state_id: "1367",
        },
        {
          id: "19177",
          name: "Hanau",
          state_id: "1367",
        },
        {
          id: "19178",
          name: "Hattersheim",
          state_id: "1367",
        },
        {
          id: "19179",
          name: "Heppenheim",
          state_id: "1367",
        },
        {
          id: "19180",
          name: "Herborn",
          state_id: "1367",
        },
        {
          id: "19181",
          name: "Hessisch Lichtenau",
          state_id: "1367",
        },
        {
          id: "19182",
          name: "Heuchelheim",
          state_id: "1367",
        },
        {
          id: "19183",
          name: "Heusenstamm",
          state_id: "1367",
        },
        {
          id: "19184",
          name: "Hochheim",
          state_id: "1367",
        },
        {
          id: "19185",
          name: "Hochst",
          state_id: "1367",
        },
        {
          id: "19186",
          name: "Hofbieber",
          state_id: "1367",
        },
        {
          id: "19187",
          name: "Hofgeismar",
          state_id: "1367",
        },
        {
          id: "19188",
          name: "Hofheim",
          state_id: "1367",
        },
        {
          id: "19189",
          name: "Homberg",
          state_id: "1367",
        },
        {
          id: "19190",
          name: "Hunfeld",
          state_id: "1367",
        },
        {
          id: "19191",
          name: "Hunfelden",
          state_id: "1367",
        },
        {
          id: "19192",
          name: "Hungen",
          state_id: "1367",
        },
        {
          id: "19193",
          name: "Huttenberg",
          state_id: "1367",
        },
        {
          id: "19194",
          name: "Idstein",
          state_id: "1367",
        },
        {
          id: "19195",
          name: "Karben",
          state_id: "1367",
        },
        {
          id: "19196",
          name: "Kassel",
          state_id: "1367",
        },
        {
          id: "19197",
          name: "Kaufungen",
          state_id: "1367",
        },
        {
          id: "19198",
          name: "Kelkheim",
          state_id: "1367",
        },
        {
          id: "19199",
          name: "Kelsterbach",
          state_id: "1367",
        },
        {
          id: "19200",
          name: "Kirchhain",
          state_id: "1367",
        },
        {
          id: "19201",
          name: "Konigstein",
          state_id: "1367",
        },
        {
          id: "19202",
          name: "Korbach",
          state_id: "1367",
        },
        {
          id: "19203",
          name: "Kriftel",
          state_id: "1367",
        },
        {
          id: "19204",
          name: "Kronberg",
          state_id: "1367",
        },
        {
          id: "19205",
          name: "Kunzell",
          state_id: "1367",
        },
        {
          id: "19206",
          name: "Lahnau",
          state_id: "1367",
        },
        {
          id: "19207",
          name: "Lahntal",
          state_id: "1367",
        },
        {
          id: "19208",
          name: "Lampertheim",
          state_id: "1367",
        },
        {
          id: "19209",
          name: "Langen",
          state_id: "1367",
        },
        {
          id: "19210",
          name: "Langenselbold",
          state_id: "1367",
        },
        {
          id: "19211",
          name: "Langgons",
          state_id: "1367",
        },
        {
          id: "19212",
          name: "Laubach",
          state_id: "1367",
        },
        {
          id: "19213",
          name: "Lauterbach",
          state_id: "1367",
        },
        {
          id: "19214",
          name: "Lich",
          state_id: "1367",
        },
        {
          id: "19215",
          name: "Limburg",
          state_id: "1367",
        },
        {
          id: "19216",
          name: "Linden",
          state_id: "1367",
        },
        {
          id: "19217",
          name: "Lindenholzhausen",
          state_id: "1367",
        },
        {
          id: "19218",
          name: "Linsengericht",
          state_id: "1367",
        },
        {
          id: "19219",
          name: "Lohfelden",
          state_id: "1367",
        },
        {
          id: "19220",
          name: "Lollar",
          state_id: "1367",
        },
        {
          id: "19221",
          name: "Lorsch",
          state_id: "1367",
        },
        {
          id: "19222",
          name: "Maintal",
          state_id: "1367",
        },
        {
          id: "19223",
          name: "Marburg",
          state_id: "1367",
        },
        {
          id: "19224",
          name: "Melsungen",
          state_id: "1367",
        },
        {
          id: "19225",
          name: "Mengerskirchen",
          state_id: "1367",
        },
        {
          id: "19226",
          name: "Michelstadt",
          state_id: "1367",
        },
        {
          id: "19227",
          name: "Morfelden-Walldorf",
          state_id: "1367",
        },
        {
          id: "19228",
          name: "Morlenbach",
          state_id: "1367",
        },
        {
          id: "19229",
          name: "Mucke",
          state_id: "1367",
        },
        {
          id: "19230",
          name: "Muhlheim",
          state_id: "1367",
        },
        {
          id: "19231",
          name: "Muhltal",
          state_id: "1367",
        },
        {
          id: "19232",
          name: "Munster",
          state_id: "1367",
        },
        {
          id: "19233",
          name: "Nauheim",
          state_id: "1367",
        },
        {
          id: "19234",
          name: "Neu-Anspach",
          state_id: "1367",
        },
        {
          id: "19235",
          name: "Neu-Isenburg",
          state_id: "1367",
        },
        {
          id: "19236",
          name: "Neuhof",
          state_id: "1367",
        },
        {
          id: "19237",
          name: "Neustadt",
          state_id: "1367",
        },
        {
          id: "19238",
          name: "Nidda",
          state_id: "1367",
        },
        {
          id: "19239",
          name: "Niddatal",
          state_id: "1367",
        },
        {
          id: "19240",
          name: "Nidderau",
          state_id: "1367",
        },
        {
          id: "19241",
          name: "Niederdorfelden",
          state_id: "1367",
        },
        {
          id: "19242",
          name: "Niedernhausen",
          state_id: "1367",
        },
        {
          id: "19243",
          name: "Niestetal",
          state_id: "1367",
        },
        {
          id: "19244",
          name: "Ober-Ramstedt",
          state_id: "1367",
        },
        {
          id: "19245",
          name: "Obertshausen",
          state_id: "1367",
        },
        {
          id: "19246",
          name: "Oberursel",
          state_id: "1367",
        },
        {
          id: "19247",
          name: "Oestrich-Winkel",
          state_id: "1367",
        },
        {
          id: "19248",
          name: "Offenbach",
          state_id: "1367",
        },
        {
          id: "19249",
          name: "Petersberg",
          state_id: "1367",
        },
        {
          id: "19250",
          name: "Pfungstadt",
          state_id: "1367",
        },
        {
          id: "19251",
          name: "Pohlheim",
          state_id: "1367",
        },
        {
          id: "19252",
          name: "Raunheim",
          state_id: "1367",
        },
        {
          id: "19253",
          name: "Reichelsheim",
          state_id: "1367",
        },
        {
          id: "19254",
          name: "Reinheim",
          state_id: "1367",
        },
        {
          id: "19255",
          name: "Reiskirchen",
          state_id: "1367",
        },
        {
          id: "19256",
          name: "Riedstadt",
          state_id: "1367",
        },
        {
          id: "19257",
          name: "Rimbach",
          state_id: "1367",
        },
        {
          id: "19258",
          name: "RoBdorf",
          state_id: "1367",
        },
        {
          id: "19259",
          name: "Rodenbach",
          state_id: "1367",
        },
        {
          id: "19260",
          name: "Rodermark",
          state_id: "1367",
        },
        {
          id: "19261",
          name: "Rodgau",
          state_id: "1367",
        },
        {
          id: "19262",
          name: "Rosbach",
          state_id: "1367",
        },
        {
          id: "19263",
          name: "Rotenburg",
          state_id: "1367",
        },
        {
          id: "19264",
          name: "Rudesheim",
          state_id: "1367",
        },
        {
          id: "19265",
          name: "Runkel",
          state_id: "1367",
        },
        {
          id: "19266",
          name: "Russelsheim",
          state_id: "1367",
        },
        {
          id: "19267",
          name: "Schauenburg",
          state_id: "1367",
        },
        {
          id: "19268",
          name: "Schlangenbad",
          state_id: "1367",
        },
        {
          id: "19269",
          name: "Schlitz",
          state_id: "1367",
        },
        {
          id: "19270",
          name: "Schluchtern",
          state_id: "1367",
        },
        {
          id: "19271",
          name: "Schoneck",
          state_id: "1367",
        },
        {
          id: "19272",
          name: "Schotten",
          state_id: "1367",
        },
        {
          id: "19273",
          name: "Schwalbach",
          state_id: "1367",
        },
        {
          id: "19274",
          name: "Schwalbach am Taunus",
          state_id: "1367",
        },
        {
          id: "19275",
          name: "Schwalmstadt",
          state_id: "1367",
        },
        {
          id: "19276",
          name: "Seeheim-Jugenheim",
          state_id: "1367",
        },
        {
          id: "19277",
          name: "Seligenstadt",
          state_id: "1367",
        },
        {
          id: "19278",
          name: "Selters",
          state_id: "1367",
        },
        {
          id: "19279",
          name: "Sinntal",
          state_id: "1367",
        },
        {
          id: "19280",
          name: "Solms",
          state_id: "1367",
        },
        {
          id: "19281",
          name: "Sontra",
          state_id: "1367",
        },
        {
          id: "19282",
          name: "Spangenberg",
          state_id: "1367",
        },
        {
          id: "19283",
          name: "Stadtallendorf",
          state_id: "1367",
        },
        {
          id: "19284",
          name: "Steinau",
          state_id: "1367",
        },
        {
          id: "19285",
          name: "Steinbach",
          state_id: "1367",
        },
        {
          id: "19286",
          name: "Taunusstein",
          state_id: "1367",
        },
        {
          id: "19287",
          name: "Trebur",
          state_id: "1367",
        },
        {
          id: "19288",
          name: "Ulrichstein",
          state_id: "1367",
        },
        {
          id: "19289",
          name: "Usingen",
          state_id: "1367",
        },
        {
          id: "19290",
          name: "Vellmar",
          state_id: "1367",
        },
        {
          id: "19291",
          name: "Viernheim",
          state_id: "1367",
        },
        {
          id: "19292",
          name: "Volkmarsen",
          state_id: "1367",
        },
        {
          id: "19293",
          name: "Wachtersbach",
          state_id: "1367",
        },
        {
          id: "19294",
          name: "Wald-Michelbach",
          state_id: "1367",
        },
        {
          id: "19295",
          name: "Waldbrunn",
          state_id: "1367",
        },
        {
          id: "19296",
          name: "Waldems",
          state_id: "1367",
        },
        {
          id: "19297",
          name: "Wehrheim",
          state_id: "1367",
        },
        {
          id: "19298",
          name: "Weilburg",
          state_id: "1367",
        },
        {
          id: "19299",
          name: "Weilmunster",
          state_id: "1367",
        },
        {
          id: "19300",
          name: "Weiterstadt",
          state_id: "1367",
        },
        {
          id: "19301",
          name: "Wettenberg",
          state_id: "1367",
        },
        {
          id: "19302",
          name: "Wetter",
          state_id: "1367",
        },
        {
          id: "19303",
          name: "Wetzlar",
          state_id: "1367",
        },
        {
          id: "19304",
          name: "Wiesbaden",
          state_id: "1367",
        },
        {
          id: "19305",
          name: "Witzenhausen",
          state_id: "1367",
        },
        {
          id: "19306",
          name: "Wolfersheim",
          state_id: "1367",
        },
        {
          id: "19307",
          name: "Wolfhagen",
          state_id: "1367",
        },
        {
          id: "19308",
          name: "Zwingenberg",
          state_id: "1367",
        },
      ],
      Kortenberg: [
        {
          id: "19309",
          name: "Kortenberg",
          state_id: "1368",
        },
      ],
      Laasdorf: [
        {
          id: "19310",
          name: "Laasdorf",
          state_id: "1369",
        },
      ],
      "Land Baden-Wurttemberg": [],
      "Land Bayern": [],
      "Land Brandenburg": [],
      "Land Hessen": [],
      "Land Mecklenburg-Vorpommern": [],
      "Land Nordrhein-Westfalen": [],
      "Land Rheinland-Pfalz": [],
      "Land Sachsen": [],
      "Land Sachsen-Anhalt": [],
      "Land Thuringen": [],
      "Lower Saxony": [],
      "Mecklenburg-Vorpommern": [
        {
          id: "19311",
          name: "Anklam",
          state_id: "1381",
        },
        {
          id: "19312",
          name: "Bad Doberan",
          state_id: "1381",
        },
        {
          id: "19313",
          name: "Barth",
          state_id: "1381",
        },
        {
          id: "19314",
          name: "Bergen",
          state_id: "1381",
        },
        {
          id: "19315",
          name: "Boizenburg",
          state_id: "1381",
        },
        {
          id: "19316",
          name: "Butzow",
          state_id: "1381",
        },
        {
          id: "19317",
          name: "Demmin",
          state_id: "1381",
        },
        {
          id: "19318",
          name: "Gagelow",
          state_id: "1381",
        },
        {
          id: "19319",
          name: "Gallin",
          state_id: "1381",
        },
        {
          id: "19320",
          name: "Grabow",
          state_id: "1381",
        },
        {
          id: "19321",
          name: "Greifswald",
          state_id: "1381",
        },
        {
          id: "19322",
          name: "Grevesmuhlen",
          state_id: "1381",
        },
        {
          id: "19323",
          name: "Grimmen",
          state_id: "1381",
        },
        {
          id: "19324",
          name: "Gustrow",
          state_id: "1381",
        },
        {
          id: "19325",
          name: "Hagenow",
          state_id: "1381",
        },
        {
          id: "19326",
          name: "Konigsee",
          state_id: "1381",
        },
        {
          id: "19327",
          name: "Lubtheen",
          state_id: "1381",
        },
        {
          id: "19328",
          name: "Ludersdorf",
          state_id: "1381",
        },
        {
          id: "19329",
          name: "Ludwigslust",
          state_id: "1381",
        },
        {
          id: "19330",
          name: "Malchin",
          state_id: "1381",
        },
        {
          id: "19331",
          name: "Neubrandenburg",
          state_id: "1381",
        },
        {
          id: "19332",
          name: "Neustrelitz",
          state_id: "1381",
        },
        {
          id: "19333",
          name: "Parchim",
          state_id: "1381",
        },
        {
          id: "19334",
          name: "Pasewalk",
          state_id: "1381",
        },
        {
          id: "19335",
          name: "Ribnitz-Damgarten",
          state_id: "1381",
        },
        {
          id: "19336",
          name: "Rostock",
          state_id: "1381",
        },
        {
          id: "19337",
          name: "SaBnitz",
          state_id: "1381",
        },
        {
          id: "19338",
          name: "Schweina",
          state_id: "1381",
        },
        {
          id: "19339",
          name: "Schwerin",
          state_id: "1381",
        },
        {
          id: "19340",
          name: "Selmsdorf",
          state_id: "1381",
        },
        {
          id: "19341",
          name: "Stralsund",
          state_id: "1381",
        },
        {
          id: "19342",
          name: "Teterow",
          state_id: "1381",
        },
        {
          id: "19343",
          name: "Torgelow",
          state_id: "1381",
        },
        {
          id: "19344",
          name: "Ueckermunde",
          state_id: "1381",
        },
        {
          id: "19345",
          name: "Waren",
          state_id: "1381",
        },
        {
          id: "19346",
          name: "Wismar",
          state_id: "1381",
        },
        {
          id: "19347",
          name: "Wolgast",
          state_id: "1381",
        },
        {
          id: "19348",
          name: "Zarrentin",
          state_id: "1381",
        },
      ],
      Mulfingen: [
        {
          id: "19349",
          name: "Mulfingen",
          state_id: "1382",
        },
      ],
      Munich: [
        {
          id: "19350",
          name: "Grafing bei Munchen",
          state_id: "1383",
        },
      ],
      Neubeuern: [
        {
          id: "19351",
          name: "Neubeuern",
          state_id: "1384",
        },
      ],
      Niedersachsen: [
        {
          id: "19352",
          name: "Achim",
          state_id: "1385",
        },
        {
          id: "19353",
          name: "Adendorf",
          state_id: "1385",
        },
        {
          id: "19354",
          name: "Aerzen",
          state_id: "1385",
        },
        {
          id: "19355",
          name: "Alfeld",
          state_id: "1385",
        },
        {
          id: "19356",
          name: "Ankum",
          state_id: "1385",
        },
        {
          id: "19357",
          name: "Apen",
          state_id: "1385",
        },
        {
          id: "19358",
          name: "Aurich",
          state_id: "1385",
        },
        {
          id: "19359",
          name: "Bad Bentheim",
          state_id: "1385",
        },
        {
          id: "19360",
          name: "Bad Bevensen",
          state_id: "1385",
        },
        {
          id: "19361",
          name: "Bad Essen",
          state_id: "1385",
        },
        {
          id: "19362",
          name: "Bad Gandersheim",
          state_id: "1385",
        },
        {
          id: "19363",
          name: "Bad Harzburg",
          state_id: "1385",
        },
        {
          id: "19364",
          name: "Bad Iburg",
          state_id: "1385",
        },
        {
          id: "19365",
          name: "Bad Laer",
          state_id: "1385",
        },
        {
          id: "19366",
          name: "Bad Lauterberg",
          state_id: "1385",
        },
        {
          id: "19367",
          name: "Bad Munder",
          state_id: "1385",
        },
        {
          id: "19368",
          name: "Bad Nenndorf",
          state_id: "1385",
        },
        {
          id: "19369",
          name: "Bad Pyrmont",
          state_id: "1385",
        },
        {
          id: "19370",
          name: "Bad Sachsa",
          state_id: "1385",
        },
        {
          id: "19371",
          name: "Bad Salzdetfurth",
          state_id: "1385",
        },
        {
          id: "19372",
          name: "Bad Zwischenahn",
          state_id: "1385",
        },
        {
          id: "19373",
          name: "BarBel",
          state_id: "1385",
        },
        {
          id: "19374",
          name: "Barsinghausen",
          state_id: "1385",
        },
        {
          id: "19375",
          name: "Bassum",
          state_id: "1385",
        },
        {
          id: "19376",
          name: "Beesten",
          state_id: "1385",
        },
        {
          id: "19377",
          name: "Belm",
          state_id: "1385",
        },
        {
          id: "19378",
          name: "Bergen",
          state_id: "1385",
        },
        {
          id: "19379",
          name: "Bissendorf",
          state_id: "1385",
        },
        {
          id: "19380",
          name: "Bleckede",
          state_id: "1385",
        },
        {
          id: "19381",
          name: "Bockenem",
          state_id: "1385",
        },
        {
          id: "19382",
          name: "Bohmte",
          state_id: "1385",
        },
        {
          id: "19383",
          name: "Bovenden",
          state_id: "1385",
        },
        {
          id: "19384",
          name: "Brake",
          state_id: "1385",
        },
        {
          id: "19385",
          name: "Bramsche",
          state_id: "1385",
        },
        {
          id: "19386",
          name: "Braunschweig",
          state_id: "1385",
        },
        {
          id: "19387",
          name: "Bremervorde",
          state_id: "1385",
        },
        {
          id: "19388",
          name: "Brockel",
          state_id: "1385",
        },
        {
          id: "19389",
          name: "Brunswick",
          state_id: "1385",
        },
        {
          id: "19390",
          name: "Buchholz",
          state_id: "1385",
        },
        {
          id: "19391",
          name: "Buckeburg",
          state_id: "1385",
        },
        {
          id: "19392",
          name: "Burgdorf",
          state_id: "1385",
        },
        {
          id: "19393",
          name: "Burgwedel",
          state_id: "1385",
        },
        {
          id: "19394",
          name: "Buxtehude",
          state_id: "1385",
        },
        {
          id: "19395",
          name: "Celle",
          state_id: "1385",
        },
        {
          id: "19396",
          name: "Clausthal-Zellerfeld",
          state_id: "1385",
        },
        {
          id: "19397",
          name: "Clenze",
          state_id: "1385",
        },
        {
          id: "19398",
          name: "Cloppenburg",
          state_id: "1385",
        },
        {
          id: "19399",
          name: "Cremlingen",
          state_id: "1385",
        },
        {
          id: "19400",
          name: "Cuxhaven",
          state_id: "1385",
        },
        {
          id: "19401",
          name: "Dahlenburg",
          state_id: "1385",
        },
        {
          id: "19402",
          name: "Damme",
          state_id: "1385",
        },
        {
          id: "19403",
          name: "Dannenberg",
          state_id: "1385",
        },
        {
          id: "19404",
          name: "Dassel",
          state_id: "1385",
        },
        {
          id: "19405",
          name: "Deinste",
          state_id: "1385",
        },
        {
          id: "19406",
          name: "Delmenhorst",
          state_id: "1385",
        },
        {
          id: "19407",
          name: "Diepholz",
          state_id: "1385",
        },
        {
          id: "19408",
          name: "Dinklage",
          state_id: "1385",
        },
        {
          id: "19409",
          name: "Dorverden",
          state_id: "1385",
        },
        {
          id: "19410",
          name: "Dransfeld",
          state_id: "1385",
        },
        {
          id: "19411",
          name: "Drochtersen",
          state_id: "1385",
        },
        {
          id: "19412",
          name: "Duderstadt",
          state_id: "1385",
        },
        {
          id: "19413",
          name: "Edemissen",
          state_id: "1385",
        },
        {
          id: "19414",
          name: "Edewecht",
          state_id: "1385",
        },
        {
          id: "19415",
          name: "Einbeck",
          state_id: "1385",
        },
        {
          id: "19416",
          name: "Elsfleth",
          state_id: "1385",
        },
        {
          id: "19417",
          name: "Elze",
          state_id: "1385",
        },
        {
          id: "19418",
          name: "Emden",
          state_id: "1385",
        },
        {
          id: "19419",
          name: "Emlichheim",
          state_id: "1385",
        },
        {
          id: "19420",
          name: "Emmerthal",
          state_id: "1385",
        },
        {
          id: "19421",
          name: "Emsburen",
          state_id: "1385",
        },
        {
          id: "19422",
          name: "Eppendorf",
          state_id: "1385",
        },
        {
          id: "19423",
          name: "Fallingbostel",
          state_id: "1385",
        },
        {
          id: "19424",
          name: "Frellstedt",
          state_id: "1385",
        },
        {
          id: "19425",
          name: "Friedeburg",
          state_id: "1385",
        },
        {
          id: "19426",
          name: "Friedland",
          state_id: "1385",
        },
        {
          id: "19427",
          name: "Friesoythe",
          state_id: "1385",
        },
        {
          id: "19428",
          name: "Ganderkesee",
          state_id: "1385",
        },
        {
          id: "19429",
          name: "Garbsen",
          state_id: "1385",
        },
        {
          id: "19430",
          name: "Garrel",
          state_id: "1385",
        },
        {
          id: "19431",
          name: "Geeste",
          state_id: "1385",
        },
        {
          id: "19432",
          name: "Gehrden",
          state_id: "1385",
        },
        {
          id: "19433",
          name: "Georgsmarienhutte",
          state_id: "1385",
        },
        {
          id: "19434",
          name: "Gifhorn",
          state_id: "1385",
        },
        {
          id: "19435",
          name: "Gleichen",
          state_id: "1385",
        },
        {
          id: "19436",
          name: "Goslar",
          state_id: "1385",
        },
        {
          id: "19437",
          name: "Gottingen",
          state_id: "1385",
        },
        {
          id: "19438",
          name: "GroBefehn",
          state_id: "1385",
        },
        {
          id: "19439",
          name: "GroBenkneten",
          state_id: "1385",
        },
        {
          id: "19440",
          name: "Hagen",
          state_id: "1385",
        },
        {
          id: "19441",
          name: "Hambergen",
          state_id: "1385",
        },
        {
          id: "19442",
          name: "Hameln",
          state_id: "1385",
        },
        {
          id: "19443",
          name: "Hannover",
          state_id: "1385",
        },
        {
          id: "19444",
          name: "Hannoversch Munden",
          state_id: "1385",
        },
        {
          id: "19445",
          name: "Haren",
          state_id: "1385",
        },
        {
          id: "19446",
          name: "Harsum",
          state_id: "1385",
        },
        {
          id: "19447",
          name: "Hasbergen",
          state_id: "1385",
        },
        {
          id: "19448",
          name: "Haselunne",
          state_id: "1385",
        },
        {
          id: "19449",
          name: "Hatten",
          state_id: "1385",
        },
        {
          id: "19450",
          name: "Hauslingen",
          state_id: "1385",
        },
        {
          id: "19451",
          name: "Helmstedt",
          state_id: "1385",
        },
        {
          id: "19452",
          name: "Hemmingen",
          state_id: "1385",
        },
        {
          id: "19453",
          name: "Herzberg",
          state_id: "1385",
        },
        {
          id: "19454",
          name: "Hessisch Oldendorf",
          state_id: "1385",
        },
        {
          id: "19455",
          name: "Hildesheim",
          state_id: "1385",
        },
        {
          id: "19456",
          name: "Hilter",
          state_id: "1385",
        },
        {
          id: "19457",
          name: "Hittfeld",
          state_id: "1385",
        },
        {
          id: "19458",
          name: "Holzminden",
          state_id: "1385",
        },
        {
          id: "19459",
          name: "Hoya",
          state_id: "1385",
        },
        {
          id: "19460",
          name: "Hude",
          state_id: "1385",
        },
        {
          id: "19461",
          name: "Ihlow",
          state_id: "1385",
        },
        {
          id: "19462",
          name: "Ilsede",
          state_id: "1385",
        },
        {
          id: "19463",
          name: "Isernhagen",
          state_id: "1385",
        },
        {
          id: "19464",
          name: "Jade",
          state_id: "1385",
        },
        {
          id: "19465",
          name: "Jever",
          state_id: "1385",
        },
        {
          id: "19466",
          name: "Jork",
          state_id: "1385",
        },
        {
          id: "19467",
          name: "Kalefeld",
          state_id: "1385",
        },
        {
          id: "19468",
          name: "Kirchlinteln",
          state_id: "1385",
        },
        {
          id: "19469",
          name: "Knesebeck",
          state_id: "1385",
        },
        {
          id: "19470",
          name: "Konigslutter",
          state_id: "1385",
        },
        {
          id: "19471",
          name: "Krummhorn",
          state_id: "1385",
        },
        {
          id: "19472",
          name: "Laatzen",
          state_id: "1385",
        },
        {
          id: "19473",
          name: "Lahstedt",
          state_id: "1385",
        },
        {
          id: "19474",
          name: "Langelsheim",
          state_id: "1385",
        },
        {
          id: "19475",
          name: "Langen",
          state_id: "1385",
        },
        {
          id: "19476",
          name: "Langenhagen",
          state_id: "1385",
        },
        {
          id: "19477",
          name: "Langwedel",
          state_id: "1385",
        },
        {
          id: "19478",
          name: "Lastrup",
          state_id: "1385",
        },
        {
          id: "19479",
          name: "Leer",
          state_id: "1385",
        },
        {
          id: "19480",
          name: "Lehre",
          state_id: "1385",
        },
        {
          id: "19481",
          name: "Lehrte",
          state_id: "1385",
        },
        {
          id: "19482",
          name: "Lemforde",
          state_id: "1385",
        },
        {
          id: "19483",
          name: "Lengede",
          state_id: "1385",
        },
        {
          id: "19484",
          name: "Liebenburg",
          state_id: "1385",
        },
        {
          id: "19485",
          name: "Lilienthal",
          state_id: "1385",
        },
        {
          id: "19486",
          name: "Lingen",
          state_id: "1385",
        },
        {
          id: "19487",
          name: "Lohne",
          state_id: "1385",
        },
        {
          id: "19488",
          name: "Loningen",
          state_id: "1385",
        },
        {
          id: "19489",
          name: "Lorup",
          state_id: "1385",
        },
        {
          id: "19490",
          name: "Loxstedt",
          state_id: "1385",
        },
        {
          id: "19491",
          name: "Luchow",
          state_id: "1385",
        },
        {
          id: "19492",
          name: "Luneburg",
          state_id: "1385",
        },
        {
          id: "19493",
          name: "Melle",
          state_id: "1385",
        },
        {
          id: "19494",
          name: "Meppen",
          state_id: "1385",
        },
        {
          id: "19495",
          name: "Moormerland",
          state_id: "1385",
        },
        {
          id: "19496",
          name: "Munster",
          state_id: "1385",
        },
        {
          id: "19497",
          name: "Neu Wulmstorf",
          state_id: "1385",
        },
        {
          id: "19498",
          name: "Neustadt",
          state_id: "1385",
        },
        {
          id: "19499",
          name: "Nienburg",
          state_id: "1385",
        },
        {
          id: "19500",
          name: "Norden",
          state_id: "1385",
        },
        {
          id: "19501",
          name: "Nordenham",
          state_id: "1385",
        },
        {
          id: "19502",
          name: "Nordhorn",
          state_id: "1385",
        },
        {
          id: "19503",
          name: "Nordstemmen",
          state_id: "1385",
        },
        {
          id: "19504",
          name: "Norten-Hardenberg",
          state_id: "1385",
        },
        {
          id: "19505",
          name: "Northeim",
          state_id: "1385",
        },
        {
          id: "19506",
          name: "Obernkirchen",
          state_id: "1385",
        },
        {
          id: "19507",
          name: "Oldenburg",
          state_id: "1385",
        },
        {
          id: "19508",
          name: "Osnabruck",
          state_id: "1385",
        },
        {
          id: "19509",
          name: "Ostercappeln",
          state_id: "1385",
        },
        {
          id: "19510",
          name: "Osterholz-Scharmbeck",
          state_id: "1385",
        },
        {
          id: "19511",
          name: "Osterode",
          state_id: "1385",
        },
        {
          id: "19512",
          name: "Ostrhauderfehn",
          state_id: "1385",
        },
        {
          id: "19513",
          name: "Ottersberg",
          state_id: "1385",
        },
        {
          id: "19514",
          name: "Oyten",
          state_id: "1385",
        },
        {
          id: "19515",
          name: "Papenburg",
          state_id: "1385",
        },
        {
          id: "19516",
          name: "Pattensen",
          state_id: "1385",
        },
        {
          id: "19517",
          name: "Peine",
          state_id: "1385",
        },
        {
          id: "19518",
          name: "Quakenbruck",
          state_id: "1385",
        },
        {
          id: "19519",
          name: "Rastede",
          state_id: "1385",
        },
        {
          id: "19520",
          name: "Rehburg-Loccum",
          state_id: "1385",
        },
        {
          id: "19521",
          name: "Rhauderfehn",
          state_id: "1385",
        },
        {
          id: "19522",
          name: "Rinteln",
          state_id: "1385",
        },
        {
          id: "19523",
          name: "Ritterhude",
          state_id: "1385",
        },
        {
          id: "19524",
          name: "Ronnenberg",
          state_id: "1385",
        },
        {
          id: "19525",
          name: "Rosdorf",
          state_id: "1385",
        },
        {
          id: "19526",
          name: "Rosengarten",
          state_id: "1385",
        },
        {
          id: "19527",
          name: "Rotenburg",
          state_id: "1385",
        },
        {
          id: "19528",
          name: "Salzgitter",
          state_id: "1385",
        },
        {
          id: "19529",
          name: "Salzhemmendorf",
          state_id: "1385",
        },
        {
          id: "19530",
          name: "Sarstedt",
          state_id: "1385",
        },
        {
          id: "19531",
          name: "Saterland",
          state_id: "1385",
        },
        {
          id: "19532",
          name: "ScheeBel",
          state_id: "1385",
        },
        {
          id: "19533",
          name: "Schiffdorf",
          state_id: "1385",
        },
        {
          id: "19534",
          name: "Schneverdingen",
          state_id: "1385",
        },
        {
          id: "19535",
          name: "Schoningen",
          state_id: "1385",
        },
        {
          id: "19536",
          name: "Schortens",
          state_id: "1385",
        },
        {
          id: "19537",
          name: "Schuttorf",
          state_id: "1385",
        },
        {
          id: "19538",
          name: "Schwanewede",
          state_id: "1385",
        },
        {
          id: "19539",
          name: "Seelze",
          state_id: "1385",
        },
        {
          id: "19540",
          name: "Seesen",
          state_id: "1385",
        },
        {
          id: "19541",
          name: "Seevetal",
          state_id: "1385",
        },
        {
          id: "19542",
          name: "Sehnde",
          state_id: "1385",
        },
        {
          id: "19543",
          name: "Soltau",
          state_id: "1385",
        },
        {
          id: "19544",
          name: "Springe",
          state_id: "1385",
        },
        {
          id: "19545",
          name: "Stade",
          state_id: "1385",
        },
        {
          id: "19546",
          name: "Stadthagen",
          state_id: "1385",
        },
        {
          id: "19547",
          name: "Stadtoldendorf",
          state_id: "1385",
        },
        {
          id: "19548",
          name: "Stelle",
          state_id: "1385",
        },
        {
          id: "19549",
          name: "Stuhr",
          state_id: "1385",
        },
        {
          id: "19550",
          name: "Sudbrookmerland",
          state_id: "1385",
        },
        {
          id: "19551",
          name: "Sulingen",
          state_id: "1385",
        },
        {
          id: "19552",
          name: "Syke",
          state_id: "1385",
        },
        {
          id: "19553",
          name: "Tarmstedt",
          state_id: "1385",
        },
        {
          id: "19554",
          name: "Tostedt",
          state_id: "1385",
        },
        {
          id: "19555",
          name: "Twistringen",
          state_id: "1385",
        },
        {
          id: "19556",
          name: "Uchte",
          state_id: "1385",
        },
        {
          id: "19557",
          name: "Uelzen",
          state_id: "1385",
        },
        {
          id: "19558",
          name: "Uetze",
          state_id: "1385",
        },
        {
          id: "19559",
          name: "Uplengen",
          state_id: "1385",
        },
        {
          id: "19560",
          name: "Uslar",
          state_id: "1385",
        },
        {
          id: "19561",
          name: "Varel",
          state_id: "1385",
        },
        {
          id: "19562",
          name: "Vechelde",
          state_id: "1385",
        },
        {
          id: "19563",
          name: "Vechta",
          state_id: "1385",
        },
        {
          id: "19564",
          name: "Verden",
          state_id: "1385",
        },
        {
          id: "19565",
          name: "Vienenburg",
          state_id: "1385",
        },
        {
          id: "19566",
          name: "Visselhovede",
          state_id: "1385",
        },
        {
          id: "19567",
          name: "Walkenried",
          state_id: "1385",
        },
        {
          id: "19568",
          name: "Wallenhorst",
          state_id: "1385",
        },
        {
          id: "19569",
          name: "Walsrode",
          state_id: "1385",
        },
        {
          id: "19570",
          name: "Wangerland",
          state_id: "1385",
        },
        {
          id: "19571",
          name: "Wardenburg",
          state_id: "1385",
        },
        {
          id: "19572",
          name: "Wedemark",
          state_id: "1385",
        },
        {
          id: "19573",
          name: "Weener",
          state_id: "1385",
        },
        {
          id: "19574",
          name: "Wendeburg",
          state_id: "1385",
        },
        {
          id: "19575",
          name: "Wennigsen",
          state_id: "1385",
        },
        {
          id: "19576",
          name: "Westerstede",
          state_id: "1385",
        },
        {
          id: "19577",
          name: "Westoverledingen",
          state_id: "1385",
        },
        {
          id: "19578",
          name: "Weyhe",
          state_id: "1385",
        },
        {
          id: "19579",
          name: "Wiefelstede",
          state_id: "1385",
        },
        {
          id: "19580",
          name: "Wiesmoor",
          state_id: "1385",
        },
        {
          id: "19581",
          name: "Wildeshausen",
          state_id: "1385",
        },
        {
          id: "19582",
          name: "Wilhelmshaven",
          state_id: "1385",
        },
        {
          id: "19583",
          name: "Winsen",
          state_id: "1385",
        },
        {
          id: "19584",
          name: "Wittingen",
          state_id: "1385",
        },
        {
          id: "19585",
          name: "Wittmund",
          state_id: "1385",
        },
        {
          id: "19586",
          name: "Wolfenbuttel",
          state_id: "1385",
        },
        {
          id: "19587",
          name: "Wolfsburg",
          state_id: "1385",
        },
        {
          id: "19588",
          name: "Worpswede",
          state_id: "1385",
        },
        {
          id: "19589",
          name: "Wunstorf",
          state_id: "1385",
        },
        {
          id: "19590",
          name: "Zetel",
          state_id: "1385",
        },
        {
          id: "19591",
          name: "Zeven",
          state_id: "1385",
        },
      ],
      "Noord-Holland": [
        {
          id: "19592",
          name: "Middenbeemster",
          state_id: "1386",
        },
      ],
      "Nordrhein-Westfalen": [
        {
          id: "19593",
          name: "Aachen",
          state_id: "1387",
        },
        {
          id: "19594",
          name: "Ahaus",
          state_id: "1387",
        },
        {
          id: "19595",
          name: "Ahlen",
          state_id: "1387",
        },
        {
          id: "19596",
          name: "Aldenhoven",
          state_id: "1387",
        },
        {
          id: "19597",
          name: "Alfter",
          state_id: "1387",
        },
        {
          id: "19598",
          name: "Alpen",
          state_id: "1387",
        },
        {
          id: "19599",
          name: "Alsdorf",
          state_id: "1387",
        },
        {
          id: "19600",
          name: "Altena",
          state_id: "1387",
        },
        {
          id: "19601",
          name: "Altendorf",
          state_id: "1387",
        },
        {
          id: "19602",
          name: "Anrochte",
          state_id: "1387",
        },
        {
          id: "19603",
          name: "Arnsberg",
          state_id: "1387",
        },
        {
          id: "19604",
          name: "Ascheberg",
          state_id: "1387",
        },
        {
          id: "19605",
          name: "Attendorn",
          state_id: "1387",
        },
        {
          id: "19606",
          name: "Augustdorf",
          state_id: "1387",
        },
        {
          id: "19607",
          name: "Bad Berleburg",
          state_id: "1387",
        },
        {
          id: "19608",
          name: "Bad Driburg",
          state_id: "1387",
        },
        {
          id: "19609",
          name: "Bad Honnef",
          state_id: "1387",
        },
        {
          id: "19610",
          name: "Bad Laasphe",
          state_id: "1387",
        },
        {
          id: "19611",
          name: "Bad Lippspringe",
          state_id: "1387",
        },
        {
          id: "19612",
          name: "Bad Munstereifel",
          state_id: "1387",
        },
        {
          id: "19613",
          name: "Bad Oeynhausen",
          state_id: "1387",
        },
        {
          id: "19614",
          name: "Bad Salzuflen",
          state_id: "1387",
        },
        {
          id: "19615",
          name: "Bad Sassendorf",
          state_id: "1387",
        },
        {
          id: "19616",
          name: "Baesweiler",
          state_id: "1387",
        },
        {
          id: "19617",
          name: "Balve",
          state_id: "1387",
        },
        {
          id: "19618",
          name: "Barntrup",
          state_id: "1387",
        },
        {
          id: "19619",
          name: "Beckum",
          state_id: "1387",
        },
        {
          id: "19620",
          name: "Bedburg",
          state_id: "1387",
        },
        {
          id: "19621",
          name: "Bedburg-Hau",
          state_id: "1387",
        },
        {
          id: "19622",
          name: "Bergheim",
          state_id: "1387",
        },
        {
          id: "19623",
          name: "Bergisch Gladbach",
          state_id: "1387",
        },
        {
          id: "19624",
          name: "Bergkamen",
          state_id: "1387",
        },
        {
          id: "19625",
          name: "Bergneustadt",
          state_id: "1387",
        },
        {
          id: "19626",
          name: "Bestwig",
          state_id: "1387",
        },
        {
          id: "19627",
          name: "Beverungen",
          state_id: "1387",
        },
        {
          id: "19628",
          name: "Bielefeld",
          state_id: "1387",
        },
        {
          id: "19629",
          name: "Billerbeck",
          state_id: "1387",
        },
        {
          id: "19630",
          name: "Blomberg",
          state_id: "1387",
        },
        {
          id: "19631",
          name: "Bocholt",
          state_id: "1387",
        },
        {
          id: "19632",
          name: "Bochum",
          state_id: "1387",
        },
        {
          id: "19633",
          name: "Bocket",
          state_id: "1387",
        },
        {
          id: "19634",
          name: "Bonen",
          state_id: "1387",
        },
        {
          id: "19635",
          name: "Bonn",
          state_id: "1387",
        },
        {
          id: "19636",
          name: "Borchen",
          state_id: "1387",
        },
        {
          id: "19637",
          name: "Borgentreich",
          state_id: "1387",
        },
        {
          id: "19638",
          name: "Borgholzhausen",
          state_id: "1387",
        },
        {
          id: "19639",
          name: "Borken",
          state_id: "1387",
        },
        {
          id: "19640",
          name: "Bornheim",
          state_id: "1387",
        },
        {
          id: "19641",
          name: "Bottrop",
          state_id: "1387",
        },
        {
          id: "19642",
          name: "Brakel",
          state_id: "1387",
        },
        {
          id: "19643",
          name: "Brilon",
          state_id: "1387",
        },
        {
          id: "19644",
          name: "Bruggen",
          state_id: "1387",
        },
        {
          id: "19645",
          name: "Bruhl",
          state_id: "1387",
        },
        {
          id: "19646",
          name: "Bunde",
          state_id: "1387",
        },
        {
          id: "19647",
          name: "Burbach",
          state_id: "1387",
        },
        {
          id: "19648",
          name: "Buren",
          state_id: "1387",
        },
        {
          id: "19649",
          name: "Burscheid",
          state_id: "1387",
        },
        {
          id: "19650",
          name: "Castrop-Rauxel",
          state_id: "1387",
        },
        {
          id: "19651",
          name: "Coesfeld",
          state_id: "1387",
        },
        {
          id: "19652",
          name: "Cologne",
          state_id: "1387",
        },
        {
          id: "19653",
          name: "Datteln",
          state_id: "1387",
        },
        {
          id: "19654",
          name: "Delbruck",
          state_id: "1387",
        },
        {
          id: "19655",
          name: "Denklingen",
          state_id: "1387",
        },
        {
          id: "19656",
          name: "Detmold",
          state_id: "1387",
        },
        {
          id: "19657",
          name: "Dingden",
          state_id: "1387",
        },
        {
          id: "19658",
          name: "Dinslaken",
          state_id: "1387",
        },
        {
          id: "19659",
          name: "Dormagen",
          state_id: "1387",
        },
        {
          id: "19660",
          name: "Dorsten",
          state_id: "1387",
        },
        {
          id: "19661",
          name: "Dortmund",
          state_id: "1387",
        },
        {
          id: "19662",
          name: "Drensteinfurt",
          state_id: "1387",
        },
        {
          id: "19663",
          name: "Drolshagen",
          state_id: "1387",
        },
        {
          id: "19664",
          name: "Duisburg",
          state_id: "1387",
        },
        {
          id: "19665",
          name: "Dulmen",
          state_id: "1387",
        },
        {
          id: "19666",
          name: "Duren",
          state_id: "1387",
        },
        {
          id: "19667",
          name: "Dusseldorf",
          state_id: "1387",
        },
        {
          id: "19668",
          name: "Eitorf",
          state_id: "1387",
        },
        {
          id: "19669",
          name: "Elsdorf",
          state_id: "1387",
        },
        {
          id: "19670",
          name: "Emmerich",
          state_id: "1387",
        },
        {
          id: "19671",
          name: "Emsdetten",
          state_id: "1387",
        },
        {
          id: "19672",
          name: "Engelskirchen",
          state_id: "1387",
        },
        {
          id: "19673",
          name: "Enger",
          state_id: "1387",
        },
        {
          id: "19674",
          name: "Ennepetal",
          state_id: "1387",
        },
        {
          id: "19675",
          name: "Ennigerloh",
          state_id: "1387",
        },
        {
          id: "19676",
          name: "Ense",
          state_id: "1387",
        },
        {
          id: "19677",
          name: "Erftstadt",
          state_id: "1387",
        },
        {
          id: "19678",
          name: "Erkelenz",
          state_id: "1387",
        },
        {
          id: "19679",
          name: "Erkrath",
          state_id: "1387",
        },
        {
          id: "19680",
          name: "Erwitte",
          state_id: "1387",
        },
        {
          id: "19681",
          name: "Espelkamp",
          state_id: "1387",
        },
        {
          id: "19682",
          name: "Essen",
          state_id: "1387",
        },
        {
          id: "19683",
          name: "Euskirchen",
          state_id: "1387",
        },
        {
          id: "19684",
          name: "Extertal",
          state_id: "1387",
        },
        {
          id: "19685",
          name: "Finnentrop",
          state_id: "1387",
        },
        {
          id: "19686",
          name: "Frechen",
          state_id: "1387",
        },
        {
          id: "19687",
          name: "Freudenberg",
          state_id: "1387",
        },
        {
          id: "19688",
          name: "Frondenberg",
          state_id: "1387",
        },
        {
          id: "19689",
          name: "Gangelt",
          state_id: "1387",
        },
        {
          id: "19690",
          name: "Geilenkirchen",
          state_id: "1387",
        },
        {
          id: "19691",
          name: "Geldern",
          state_id: "1387",
        },
        {
          id: "19692",
          name: "Gelsenkirchen",
          state_id: "1387",
        },
        {
          id: "19693",
          name: "Gescher",
          state_id: "1387",
        },
        {
          id: "19694",
          name: "Geseke",
          state_id: "1387",
        },
        {
          id: "19695",
          name: "Gevelsberg",
          state_id: "1387",
        },
        {
          id: "19696",
          name: "Gladbeck",
          state_id: "1387",
        },
        {
          id: "19697",
          name: "Goch",
          state_id: "1387",
        },
        {
          id: "19698",
          name: "Grefrath",
          state_id: "1387",
        },
        {
          id: "19699",
          name: "Greven",
          state_id: "1387",
        },
        {
          id: "19700",
          name: "Grevenbroich",
          state_id: "1387",
        },
        {
          id: "19701",
          name: "Gronau",
          state_id: "1387",
        },
        {
          id: "19702",
          name: "Gummersbach",
          state_id: "1387",
        },
        {
          id: "19703",
          name: "Gutersloh",
          state_id: "1387",
        },
        {
          id: "19704",
          name: "Haan",
          state_id: "1387",
        },
        {
          id: "19705",
          name: "Hagen",
          state_id: "1387",
        },
        {
          id: "19706",
          name: "Halle",
          state_id: "1387",
        },
        {
          id: "19707",
          name: "Haltern",
          state_id: "1387",
        },
        {
          id: "19708",
          name: "Halver",
          state_id: "1387",
        },
        {
          id: "19709",
          name: "Hamm",
          state_id: "1387",
        },
        {
          id: "19710",
          name: "Hamminkeln",
          state_id: "1387",
        },
        {
          id: "19711",
          name: "Harsewinkel",
          state_id: "1387",
        },
        {
          id: "19712",
          name: "Hattingen",
          state_id: "1387",
        },
        {
          id: "19713",
          name: "Havixbeck",
          state_id: "1387",
        },
        {
          id: "19714",
          name: "Heiligenhaus",
          state_id: "1387",
        },
        {
          id: "19715",
          name: "Heinsberg",
          state_id: "1387",
        },
        {
          id: "19716",
          name: "Hemer",
          state_id: "1387",
        },
        {
          id: "19717",
          name: "Hennef",
          state_id: "1387",
        },
        {
          id: "19718",
          name: "Herdecke",
          state_id: "1387",
        },
        {
          id: "19719",
          name: "Herford",
          state_id: "1387",
        },
        {
          id: "19720",
          name: "Herne",
          state_id: "1387",
        },
        {
          id: "19721",
          name: "Herten",
          state_id: "1387",
        },
        {
          id: "19722",
          name: "Herzebrock-Clarholz",
          state_id: "1387",
        },
        {
          id: "19723",
          name: "Herzogenrath",
          state_id: "1387",
        },
        {
          id: "19724",
          name: "Hiddenhausen",
          state_id: "1387",
        },
        {
          id: "19725",
          name: "Hilchenbach",
          state_id: "1387",
        },
        {
          id: "19726",
          name: "Hilden",
          state_id: "1387",
        },
        {
          id: "19727",
          name: "Hille",
          state_id: "1387",
        },
        {
          id: "19728",
          name: "Holzwickede",
          state_id: "1387",
        },
        {
          id: "19729",
          name: "Horn-Bad Meinberg",
          state_id: "1387",
        },
        {
          id: "19730",
          name: "Horstel",
          state_id: "1387",
        },
        {
          id: "19731",
          name: "Hovelhof",
          state_id: "1387",
        },
        {
          id: "19732",
          name: "Hoxter",
          state_id: "1387",
        },
        {
          id: "19733",
          name: "Huckelhoven",
          state_id: "1387",
        },
        {
          id: "19734",
          name: "Huckeswagen",
          state_id: "1387",
        },
        {
          id: "19735",
          name: "Hullhorst",
          state_id: "1387",
        },
        {
          id: "19736",
          name: "Hunxe",
          state_id: "1387",
        },
        {
          id: "19737",
          name: "Hurth",
          state_id: "1387",
        },
        {
          id: "19738",
          name: "Ibbenburen",
          state_id: "1387",
        },
        {
          id: "19739",
          name: "Iserlohn",
          state_id: "1387",
        },
        {
          id: "19740",
          name: "Isselburg",
          state_id: "1387",
        },
        {
          id: "19741",
          name: "Issum",
          state_id: "1387",
        },
        {
          id: "19742",
          name: "Juchen",
          state_id: "1387",
        },
        {
          id: "19743",
          name: "Julich",
          state_id: "1387",
        },
        {
          id: "19744",
          name: "Kaarst",
          state_id: "1387",
        },
        {
          id: "19745",
          name: "Kalkar",
          state_id: "1387",
        },
        {
          id: "19746",
          name: "Kall",
          state_id: "1387",
        },
        {
          id: "19747",
          name: "Kalletal",
          state_id: "1387",
        },
        {
          id: "19748",
          name: "Kamen",
          state_id: "1387",
        },
        {
          id: "19749",
          name: "Kamp-Lintfort",
          state_id: "1387",
        },
        {
          id: "19750",
          name: "Kempen",
          state_id: "1387",
        },
        {
          id: "19751",
          name: "Kerken",
          state_id: "1387",
        },
        {
          id: "19752",
          name: "Kerpen",
          state_id: "1387",
        },
        {
          id: "19753",
          name: "Kevelaer",
          state_id: "1387",
        },
        {
          id: "19754",
          name: "Kierspe",
          state_id: "1387",
        },
        {
          id: "19755",
          name: "Kirchhundem",
          state_id: "1387",
        },
        {
          id: "19756",
          name: "Kirchlengern",
          state_id: "1387",
        },
        {
          id: "19757",
          name: "Kleve",
          state_id: "1387",
        },
        {
          id: "19758",
          name: "Koln",
          state_id: "1387",
        },
        {
          id: "19759",
          name: "Konigswinter",
          state_id: "1387",
        },
        {
          id: "19760",
          name: "Korschenbroich",
          state_id: "1387",
        },
        {
          id: "19761",
          name: "Krefeld",
          state_id: "1387",
        },
        {
          id: "19762",
          name: "Kreuzau",
          state_id: "1387",
        },
        {
          id: "19763",
          name: "Kreuztal",
          state_id: "1387",
        },
        {
          id: "19764",
          name: "Kurten",
          state_id: "1387",
        },
        {
          id: "19765",
          name: "Lage",
          state_id: "1387",
        },
        {
          id: "19766",
          name: "Langenfeld",
          state_id: "1387",
        },
        {
          id: "19767",
          name: "Langerwehe",
          state_id: "1387",
        },
        {
          id: "19768",
          name: "Leichlingen",
          state_id: "1387",
        },
        {
          id: "19769",
          name: "Lemgo",
          state_id: "1387",
        },
        {
          id: "19770",
          name: "Lengerich",
          state_id: "1387",
        },
        {
          id: "19771",
          name: "Lennestadt",
          state_id: "1387",
        },
        {
          id: "19772",
          name: "Leopoldshohe",
          state_id: "1387",
        },
        {
          id: "19773",
          name: "Leverkusen",
          state_id: "1387",
        },
        {
          id: "19774",
          name: "Lichtenau",
          state_id: "1387",
        },
        {
          id: "19775",
          name: "Lindlar",
          state_id: "1387",
        },
        {
          id: "19776",
          name: "Linnich",
          state_id: "1387",
        },
        {
          id: "19777",
          name: "Lippetal",
          state_id: "1387",
        },
        {
          id: "19778",
          name: "Lippstadt",
          state_id: "1387",
        },
        {
          id: "19779",
          name: "Lohmar",
          state_id: "1387",
        },
        {
          id: "19780",
          name: "Lohne",
          state_id: "1387",
        },
        {
          id: "19781",
          name: "Lotte",
          state_id: "1387",
        },
        {
          id: "19782",
          name: "Lubbecke",
          state_id: "1387",
        },
        {
          id: "19783",
          name: "Ludenscheid",
          state_id: "1387",
        },
        {
          id: "19784",
          name: "Ludinghausen",
          state_id: "1387",
        },
        {
          id: "19785",
          name: "Lugde",
          state_id: "1387",
        },
        {
          id: "19786",
          name: "Lunen",
          state_id: "1387",
        },
        {
          id: "19787",
          name: "Marienheide",
          state_id: "1387",
        },
        {
          id: "19788",
          name: "Marl",
          state_id: "1387",
        },
        {
          id: "19789",
          name: "Marsberg",
          state_id: "1387",
        },
        {
          id: "19790",
          name: "Mechernich",
          state_id: "1387",
        },
        {
          id: "19791",
          name: "Meckenheim",
          state_id: "1387",
        },
        {
          id: "19792",
          name: "Meerbusch",
          state_id: "1387",
        },
        {
          id: "19793",
          name: "Meinerzhagen",
          state_id: "1387",
        },
        {
          id: "19794",
          name: "Menden",
          state_id: "1387",
        },
        {
          id: "19795",
          name: "Meschede",
          state_id: "1387",
        },
        {
          id: "19796",
          name: "Mettingen",
          state_id: "1387",
        },
        {
          id: "19797",
          name: "Mettmann",
          state_id: "1387",
        },
        {
          id: "19798",
          name: "Minden",
          state_id: "1387",
        },
        {
          id: "19799",
          name: "Moers",
          state_id: "1387",
        },
        {
          id: "19800",
          name: "Mohnesee",
          state_id: "1387",
        },
        {
          id: "19801",
          name: "Monchengladbach",
          state_id: "1387",
        },
        {
          id: "19802",
          name: "Monheim",
          state_id: "1387",
        },
        {
          id: "19803",
          name: "Monschau",
          state_id: "1387",
        },
        {
          id: "19804",
          name: "Morsbach",
          state_id: "1387",
        },
        {
          id: "19805",
          name: "Much",
          state_id: "1387",
        },
        {
          id: "19806",
          name: "Mulheim",
          state_id: "1387",
        },
        {
          id: "19807",
          name: "Munster",
          state_id: "1387",
        },
        {
          id: "19808",
          name: "Netphen",
          state_id: "1387",
        },
        {
          id: "19809",
          name: "Nettetal",
          state_id: "1387",
        },
        {
          id: "19810",
          name: "Neuenkirchen",
          state_id: "1387",
        },
        {
          id: "19811",
          name: "Neuenrade",
          state_id: "1387",
        },
        {
          id: "19812",
          name: "Neukirchen-Vluyn",
          state_id: "1387",
        },
        {
          id: "19813",
          name: "Neunkirchen",
          state_id: "1387",
        },
        {
          id: "19814",
          name: "Neunkirchen-Seelscheid",
          state_id: "1387",
        },
        {
          id: "19815",
          name: "Neuss",
          state_id: "1387",
        },
        {
          id: "19816",
          name: "Nideggen",
          state_id: "1387",
        },
        {
          id: "19817",
          name: "Niederkassel",
          state_id: "1387",
        },
        {
          id: "19818",
          name: "Niederkruchten",
          state_id: "1387",
        },
        {
          id: "19819",
          name: "Niederzier",
          state_id: "1387",
        },
        {
          id: "19820",
          name: "Nordkirchen",
          state_id: "1387",
        },
        {
          id: "19821",
          name: "Norvenich",
          state_id: "1387",
        },
        {
          id: "19822",
          name: "Nottuln",
          state_id: "1387",
        },
        {
          id: "19823",
          name: "Numbrecht",
          state_id: "1387",
        },
        {
          id: "19824",
          name: "Oberhausen",
          state_id: "1387",
        },
        {
          id: "19825",
          name: "Ochtrup",
          state_id: "1387",
        },
        {
          id: "19826",
          name: "Odenthal",
          state_id: "1387",
        },
        {
          id: "19827",
          name: "Oelde",
          state_id: "1387",
        },
        {
          id: "19828",
          name: "Oer-Erkenschwick",
          state_id: "1387",
        },
        {
          id: "19829",
          name: "Oerlinghausen",
          state_id: "1387",
        },
        {
          id: "19830",
          name: "Olfen",
          state_id: "1387",
        },
        {
          id: "19831",
          name: "Olpe",
          state_id: "1387",
        },
        {
          id: "19832",
          name: "Olsberg",
          state_id: "1387",
        },
        {
          id: "19833",
          name: "Overath",
          state_id: "1387",
        },
        {
          id: "19834",
          name: "Paderborn",
          state_id: "1387",
        },
        {
          id: "19835",
          name: "Petershagen",
          state_id: "1387",
        },
        {
          id: "19836",
          name: "Plettenberg",
          state_id: "1387",
        },
        {
          id: "19837",
          name: "Porta Westfalica",
          state_id: "1387",
        },
        {
          id: "19838",
          name: "PreuBisch Oldendorf",
          state_id: "1387",
        },
        {
          id: "19839",
          name: "Pulheim",
          state_id: "1387",
        },
        {
          id: "19840",
          name: "Radevormwald",
          state_id: "1387",
        },
        {
          id: "19841",
          name: "Raesfeld",
          state_id: "1387",
        },
        {
          id: "19842",
          name: "Rahden",
          state_id: "1387",
        },
        {
          id: "19843",
          name: "Ratingen",
          state_id: "1387",
        },
        {
          id: "19844",
          name: "Recke",
          state_id: "1387",
        },
        {
          id: "19845",
          name: "Recklinghausen",
          state_id: "1387",
        },
        {
          id: "19846",
          name: "Rees",
          state_id: "1387",
        },
        {
          id: "19847",
          name: "Reichshof",
          state_id: "1387",
        },
        {
          id: "19848",
          name: "Reken",
          state_id: "1387",
        },
        {
          id: "19849",
          name: "Remscheid",
          state_id: "1387",
        },
        {
          id: "19850",
          name: "Rheda-Wiedenbruck",
          state_id: "1387",
        },
        {
          id: "19851",
          name: "Rhede",
          state_id: "1387",
        },
        {
          id: "19852",
          name: "Rheinbach",
          state_id: "1387",
        },
        {
          id: "19853",
          name: "Rheinberg",
          state_id: "1387",
        },
        {
          id: "19854",
          name: "Rheine",
          state_id: "1387",
        },
        {
          id: "19855",
          name: "Rietberg",
          state_id: "1387",
        },
        {
          id: "19856",
          name: "Rommerskirchen",
          state_id: "1387",
        },
        {
          id: "19857",
          name: "Rosendahl",
          state_id: "1387",
        },
        {
          id: "19858",
          name: "Rosrath",
          state_id: "1387",
        },
        {
          id: "19859",
          name: "Ruthen",
          state_id: "1387",
        },
        {
          id: "19860",
          name: "Salzkotten",
          state_id: "1387",
        },
        {
          id: "19861",
          name: "Sassenberg",
          state_id: "1387",
        },
        {
          id: "19862",
          name: "Schalksmuhle",
          state_id: "1387",
        },
        {
          id: "19863",
          name: "Schermbeck",
          state_id: "1387",
        },
        {
          id: "19864",
          name: "Schieder-Schwalenberg",
          state_id: "1387",
        },
        {
          id: "19865",
          name: "Schleiden",
          state_id: "1387",
        },
        {
          id: "19866",
          name: "SchloB Holte-Stukenbrock",
          state_id: "1387",
        },
        {
          id: "19867",
          name: "Schmallenberg",
          state_id: "1387",
        },
        {
          id: "19868",
          name: "Schwalmtal",
          state_id: "1387",
        },
        {
          id: "19869",
          name: "Schwelm",
          state_id: "1387",
        },
        {
          id: "19870",
          name: "Schwerte",
          state_id: "1387",
        },
        {
          id: "19871",
          name: "Selm",
          state_id: "1387",
        },
        {
          id: "19872",
          name: "Senden",
          state_id: "1387",
        },
        {
          id: "19873",
          name: "Sendenhorst",
          state_id: "1387",
        },
        {
          id: "19874",
          name: "Siegburg",
          state_id: "1387",
        },
        {
          id: "19875",
          name: "Siegen",
          state_id: "1387",
        },
        {
          id: "19876",
          name: "Simmerath",
          state_id: "1387",
        },
        {
          id: "19877",
          name: "Soest",
          state_id: "1387",
        },
        {
          id: "19878",
          name: "Solingen",
          state_id: "1387",
        },
        {
          id: "19879",
          name: "Sonsbeck",
          state_id: "1387",
        },
        {
          id: "19880",
          name: "Spenge",
          state_id: "1387",
        },
        {
          id: "19881",
          name: "Sprockhovel",
          state_id: "1387",
        },
        {
          id: "19882",
          name: "Stadtlohn",
          state_id: "1387",
        },
        {
          id: "19883",
          name: "Steinfurt",
          state_id: "1387",
        },
        {
          id: "19884",
          name: "Steinhagen",
          state_id: "1387",
        },
        {
          id: "19885",
          name: "Steinheim",
          state_id: "1387",
        },
        {
          id: "19886",
          name: "Stemwede",
          state_id: "1387",
        },
        {
          id: "19887",
          name: "Stolberg",
          state_id: "1387",
        },
        {
          id: "19888",
          name: "Straelen",
          state_id: "1387",
        },
        {
          id: "19889",
          name: "Sundern",
          state_id: "1387",
        },
        {
          id: "19890",
          name: "Swisttal",
          state_id: "1387",
        },
        {
          id: "19891",
          name: "Tecklenburg",
          state_id: "1387",
        },
        {
          id: "19892",
          name: "Telgte",
          state_id: "1387",
        },
        {
          id: "19893",
          name: "Tonisvorst",
          state_id: "1387",
        },
        {
          id: "19894",
          name: "Troisdorf",
          state_id: "1387",
        },
        {
          id: "19895",
          name: "Ubach-Palenberg",
          state_id: "1387",
        },
        {
          id: "19896",
          name: "Unna",
          state_id: "1387",
        },
        {
          id: "19897",
          name: "Velbert",
          state_id: "1387",
        },
        {
          id: "19898",
          name: "Velen",
          state_id: "1387",
        },
        {
          id: "19899",
          name: "Verl",
          state_id: "1387",
        },
        {
          id: "19900",
          name: "Versmold",
          state_id: "1387",
        },
        {
          id: "19901",
          name: "Viersen",
          state_id: "1387",
        },
        {
          id: "19902",
          name: "Vlotho",
          state_id: "1387",
        },
        {
          id: "19903",
          name: "Voerde",
          state_id: "1387",
        },
        {
          id: "19904",
          name: "Vreden",
          state_id: "1387",
        },
        {
          id: "19905",
          name: "Wachtberg",
          state_id: "1387",
        },
        {
          id: "19906",
          name: "Wachtendonk",
          state_id: "1387",
        },
        {
          id: "19907",
          name: "Wadersloh",
          state_id: "1387",
        },
        {
          id: "19908",
          name: "Waldbrol",
          state_id: "1387",
        },
        {
          id: "19909",
          name: "Waltrop",
          state_id: "1387",
        },
        {
          id: "19910",
          name: "Warburg",
          state_id: "1387",
        },
        {
          id: "19911",
          name: "Warendorf",
          state_id: "1387",
        },
        {
          id: "19912",
          name: "Warstein",
          state_id: "1387",
        },
        {
          id: "19913",
          name: "Wassenberg",
          state_id: "1387",
        },
        {
          id: "19914",
          name: "Weeze",
          state_id: "1387",
        },
        {
          id: "19915",
          name: "Wegberg",
          state_id: "1387",
        },
        {
          id: "19916",
          name: "Weilerswist",
          state_id: "1387",
        },
        {
          id: "19917",
          name: "Welver",
          state_id: "1387",
        },
        {
          id: "19918",
          name: "Wenden",
          state_id: "1387",
        },
        {
          id: "19919",
          name: "Werdohl",
          state_id: "1387",
        },
        {
          id: "19920",
          name: "Werl",
          state_id: "1387",
        },
        {
          id: "19921",
          name: "Wermelskirchen",
          state_id: "1387",
        },
        {
          id: "19922",
          name: "Werne",
          state_id: "1387",
        },
        {
          id: "19923",
          name: "Werther",
          state_id: "1387",
        },
        {
          id: "19924",
          name: "Wesel",
          state_id: "1387",
        },
        {
          id: "19925",
          name: "Wesseling",
          state_id: "1387",
        },
        {
          id: "19926",
          name: "Westerkappeln",
          state_id: "1387",
        },
        {
          id: "19927",
          name: "Wetter",
          state_id: "1387",
        },
        {
          id: "19928",
          name: "Wickede",
          state_id: "1387",
        },
        {
          id: "19929",
          name: "Wiehl",
          state_id: "1387",
        },
        {
          id: "19930",
          name: "Willich",
          state_id: "1387",
        },
        {
          id: "19931",
          name: "Wilnsdorf",
          state_id: "1387",
        },
        {
          id: "19932",
          name: "Windeck",
          state_id: "1387",
        },
        {
          id: "19933",
          name: "Winterberg",
          state_id: "1387",
        },
        {
          id: "19934",
          name: "Wipperfurth",
          state_id: "1387",
        },
        {
          id: "19935",
          name: "Witten",
          state_id: "1387",
        },
        {
          id: "19936",
          name: "Wulfrath",
          state_id: "1387",
        },
        {
          id: "19937",
          name: "Wunnenberg",
          state_id: "1387",
        },
        {
          id: "19938",
          name: "Wuppertal",
          state_id: "1387",
        },
        {
          id: "19939",
          name: "Wurselen",
          state_id: "1387",
        },
        {
          id: "19940",
          name: "Xanten",
          state_id: "1387",
        },
        {
          id: "19941",
          name: "Zulpich",
          state_id: "1387",
        },
      ],
      "North Rhine-Westphalia": [],
      Osterode: [
        {
          id: "19942",
          name: "Herzberg am Harz",
          state_id: "1389",
        },
      ],
      "Rheinland-Pfalz": [
        {
          id: "19943",
          name: "Alzey",
          state_id: "1390",
        },
        {
          id: "19944",
          name: "Andernach",
          state_id: "1390",
        },
        {
          id: "19945",
          name: "Bad Durkheim",
          state_id: "1390",
        },
        {
          id: "19946",
          name: "Bad Ems",
          state_id: "1390",
        },
        {
          id: "19947",
          name: "Bad Kreuznach",
          state_id: "1390",
        },
        {
          id: "19948",
          name: "Bad Neuenahr-Ahrweiler",
          state_id: "1390",
        },
        {
          id: "19949",
          name: "Bendorf",
          state_id: "1390",
        },
        {
          id: "19950",
          name: "Betzdorf",
          state_id: "1390",
        },
        {
          id: "19951",
          name: "Bingen",
          state_id: "1390",
        },
        {
          id: "19952",
          name: "Bitburg",
          state_id: "1390",
        },
        {
          id: "19953",
          name: "Bobenheim-Roxheim",
          state_id: "1390",
        },
        {
          id: "19954",
          name: "Bohl-Iggelheim",
          state_id: "1390",
        },
        {
          id: "19955",
          name: "Boppard",
          state_id: "1390",
        },
        {
          id: "19956",
          name: "Daun",
          state_id: "1390",
        },
        {
          id: "19957",
          name: "Diez",
          state_id: "1390",
        },
        {
          id: "19958",
          name: "Eisenberg",
          state_id: "1390",
        },
        {
          id: "19959",
          name: "Essingen",
          state_id: "1390",
        },
        {
          id: "19960",
          name: "Frankenthal",
          state_id: "1390",
        },
        {
          id: "19961",
          name: "Gau-Odernheim",
          state_id: "1390",
        },
        {
          id: "19962",
          name: "Germersheim",
          state_id: "1390",
        },
        {
          id: "19963",
          name: "Grunstadt",
          state_id: "1390",
        },
        {
          id: "19964",
          name: "HaBloch",
          state_id: "1390",
        },
        {
          id: "19965",
          name: "Hahnstatten",
          state_id: "1390",
        },
        {
          id: "19966",
          name: "Hallschlag",
          state_id: "1390",
        },
        {
          id: "19967",
          name: "Herschbach",
          state_id: "1390",
        },
        {
          id: "19968",
          name: "Herxheim",
          state_id: "1390",
        },
        {
          id: "19969",
          name: "Hirschhorn",
          state_id: "1390",
        },
        {
          id: "19970",
          name: "Hohr-Grenzhausen",
          state_id: "1390",
        },
        {
          id: "19971",
          name: "Holzheim",
          state_id: "1390",
        },
        {
          id: "19972",
          name: "Idar-Oberstein",
          state_id: "1390",
        },
        {
          id: "19973",
          name: "Ingelheim",
          state_id: "1390",
        },
        {
          id: "19974",
          name: "Kaisersesch",
          state_id: "1390",
        },
        {
          id: "19975",
          name: "Kaiserslautern",
          state_id: "1390",
        },
        {
          id: "19976",
          name: "Kastellaun",
          state_id: "1390",
        },
        {
          id: "19977",
          name: "Kindsbach",
          state_id: "1390",
        },
        {
          id: "19978",
          name: "Kirchen",
          state_id: "1390",
        },
        {
          id: "19979",
          name: "Kirn",
          state_id: "1390",
        },
        {
          id: "19980",
          name: "Koblenz",
          state_id: "1390",
        },
        {
          id: "19981",
          name: "Lahnstein",
          state_id: "1390",
        },
        {
          id: "19982",
          name: "Landau",
          state_id: "1390",
        },
        {
          id: "19983",
          name: "Limburgerhof",
          state_id: "1390",
        },
        {
          id: "19984",
          name: "Luckenburg",
          state_id: "1390",
        },
        {
          id: "19985",
          name: "Ludwigshafen",
          state_id: "1390",
        },
        {
          id: "19986",
          name: "Mainz",
          state_id: "1390",
        },
        {
          id: "19987",
          name: "Mayen",
          state_id: "1390",
        },
        {
          id: "19988",
          name: "Montabaur",
          state_id: "1390",
        },
        {
          id: "19989",
          name: "Morbach",
          state_id: "1390",
        },
        {
          id: "19990",
          name: "Mulheim-Karlich",
          state_id: "1390",
        },
        {
          id: "19991",
          name: "Mundersbach",
          state_id: "1390",
        },
        {
          id: "19992",
          name: "Mutterstadt",
          state_id: "1390",
        },
        {
          id: "19993",
          name: "Nassau",
          state_id: "1390",
        },
        {
          id: "19994",
          name: "Neitersen",
          state_id: "1390",
        },
        {
          id: "19995",
          name: "Neustadt",
          state_id: "1390",
        },
        {
          id: "19996",
          name: "Neuwied",
          state_id: "1390",
        },
        {
          id: "19997",
          name: "Niederzissen",
          state_id: "1390",
        },
        {
          id: "19998",
          name: "Pirmasens",
          state_id: "1390",
        },
        {
          id: "19999",
          name: "Plaidt",
          state_id: "1390",
        },
        {
          id: "20000",
          name: "Remagen",
          state_id: "1390",
        },
        {
          id: "20001",
          name: "Schifferstadt",
          state_id: "1390",
        },
        {
          id: "20002",
          name: "Schoenenberg Kuebelberg",
          state_id: "1390",
        },
        {
          id: "20003",
          name: "Sinzig",
          state_id: "1390",
        },
        {
          id: "20004",
          name: "Speyer",
          state_id: "1390",
        },
        {
          id: "20005",
          name: "St. Goar",
          state_id: "1390",
        },
        {
          id: "20006",
          name: "Trier",
          state_id: "1390",
        },
        {
          id: "20007",
          name: "Vallendar",
          state_id: "1390",
        },
        {
          id: "20008",
          name: "Winterbach",
          state_id: "1390",
        },
        {
          id: "20009",
          name: "Wittlich",
          state_id: "1390",
        },
        {
          id: "20010",
          name: "Worms",
          state_id: "1390",
        },
        {
          id: "20011",
          name: "Worth",
          state_id: "1390",
        },
        {
          id: "20012",
          name: "Zweibrucken",
          state_id: "1390",
        },
      ],
      "Rhineland-Palatinate": [
        {
          id: "20013",
          name: "Adenau",
          state_id: "1391",
        },
        {
          id: "20014",
          name: "Anhausen",
          state_id: "1391",
        },
        {
          id: "20015",
          name: "Barbelroth",
          state_id: "1391",
        },
        {
          id: "20016",
          name: "Berndroth",
          state_id: "1391",
        },
        {
          id: "20017",
          name: "Bernkastel-Kues",
          state_id: "1391",
        },
        {
          id: "20018",
          name: "Burgbrohl",
          state_id: "1391",
        },
        {
          id: "20019",
          name: "Dieblich",
          state_id: "1391",
        },
        {
          id: "20020",
          name: "Dierdorf",
          state_id: "1391",
        },
        {
          id: "20021",
          name: "Dreisbach",
          state_id: "1391",
        },
        {
          id: "20022",
          name: "Elsoff",
          state_id: "1391",
        },
        {
          id: "20023",
          name: "Enkenbach-Alsenborn",
          state_id: "1391",
        },
        {
          id: "20024",
          name: "Etzbach",
          state_id: "1391",
        },
        {
          id: "20025",
          name: "Flonheim",
          state_id: "1391",
        },
        {
          id: "20026",
          name: "Fohren",
          state_id: "1391",
        },
        {
          id: "20027",
          name: "Grafschaft",
          state_id: "1391",
        },
        {
          id: "20028",
          name: "Hochspeyer",
          state_id: "1391",
        },
        {
          id: "20029",
          name: "Leiningen",
          state_id: "1391",
        },
        {
          id: "20030",
          name: "Moschheim",
          state_id: "1391",
        },
        {
          id: "20031",
          name: "Murlenbach",
          state_id: "1391",
        },
        {
          id: "20032",
          name: "Neuhofen",
          state_id: "1391",
        },
        {
          id: "20033",
          name: "Nievern",
          state_id: "1391",
        },
        {
          id: "20034",
          name: "Norken",
          state_id: "1391",
        },
        {
          id: "20035",
          name: "Oberlahr",
          state_id: "1391",
        },
        {
          id: "20036",
          name: "Otterstadt",
          state_id: "1391",
        },
        {
          id: "20037",
          name: "Rennerod",
          state_id: "1391",
        },
        {
          id: "20038",
          name: "Rheinbreitbach",
          state_id: "1391",
        },
        {
          id: "20039",
          name: "Rieschweiler-Muhlbach",
          state_id: "1391",
        },
        {
          id: "20040",
          name: "Saarburg",
          state_id: "1391",
        },
        {
          id: "20041",
          name: "Stahlhofen",
          state_id: "1391",
        },
        {
          id: "20042",
          name: "Steinebach",
          state_id: "1391",
        },
        {
          id: "20043",
          name: "Weinsheim",
          state_id: "1391",
        },
        {
          id: "20044",
          name: "Winnweiler",
          state_id: "1391",
        },
        {
          id: "20045",
          name: "Wissen",
          state_id: "1391",
        },
      ],
      Saarland: [
        {
          id: "20046",
          name: "Beckingen",
          state_id: "1392",
        },
        {
          id: "20047",
          name: "Bexbach",
          state_id: "1392",
        },
        {
          id: "20048",
          name: "Blieskastel",
          state_id: "1392",
        },
        {
          id: "20049",
          name: "Dillingen",
          state_id: "1392",
        },
        {
          id: "20050",
          name: "Duppenweiler",
          state_id: "1392",
        },
        {
          id: "20051",
          name: "Eppelborn",
          state_id: "1392",
        },
        {
          id: "20052",
          name: "Friedrichsthal",
          state_id: "1392",
        },
        {
          id: "20053",
          name: "GroBrosseln",
          state_id: "1392",
        },
        {
          id: "20054",
          name: "Heusweiler",
          state_id: "1392",
        },
        {
          id: "20055",
          name: "Homburg",
          state_id: "1392",
        },
        {
          id: "20056",
          name: "Illingen",
          state_id: "1392",
        },
        {
          id: "20057",
          name: "Kirkel",
          state_id: "1392",
        },
        {
          id: "20058",
          name: "Kleinblittersdorf",
          state_id: "1392",
        },
        {
          id: "20059",
          name: "Lebach",
          state_id: "1392",
        },
        {
          id: "20060",
          name: "Losheim",
          state_id: "1392",
        },
        {
          id: "20061",
          name: "Mandelbachtal",
          state_id: "1392",
        },
        {
          id: "20062",
          name: "Marpingen",
          state_id: "1392",
        },
        {
          id: "20063",
          name: "Merchweiler",
          state_id: "1392",
        },
        {
          id: "20064",
          name: "Merzig",
          state_id: "1392",
        },
        {
          id: "20065",
          name: "Mettlach",
          state_id: "1392",
        },
        {
          id: "20066",
          name: "Nalbach",
          state_id: "1392",
        },
        {
          id: "20067",
          name: "Neunkirchen",
          state_id: "1392",
        },
        {
          id: "20068",
          name: "Nohfelden",
          state_id: "1392",
        },
        {
          id: "20069",
          name: "Nonnweiler",
          state_id: "1392",
        },
        {
          id: "20070",
          name: "Oberthal",
          state_id: "1392",
        },
        {
          id: "20071",
          name: "Ottweiler",
          state_id: "1392",
        },
        {
          id: "20072",
          name: "Puttlingen",
          state_id: "1392",
        },
        {
          id: "20073",
          name: "Quierschied",
          state_id: "1392",
        },
        {
          id: "20074",
          name: "Rehlingen-Siersburg",
          state_id: "1392",
        },
        {
          id: "20075",
          name: "Riegelsberg",
          state_id: "1392",
        },
        {
          id: "20076",
          name: "Saarbrucken",
          state_id: "1392",
        },
        {
          id: "20077",
          name: "Saarlouis",
          state_id: "1392",
        },
        {
          id: "20078",
          name: "Saarwellingen",
          state_id: "1392",
        },
        {
          id: "20079",
          name: "Sankt Ingbert",
          state_id: "1392",
        },
        {
          id: "20080",
          name: "Sankt Wendel",
          state_id: "1392",
        },
        {
          id: "20081",
          name: "Schiffweiler",
          state_id: "1392",
        },
        {
          id: "20082",
          name: "Schmelz",
          state_id: "1392",
        },
        {
          id: "20083",
          name: "Schwalbach",
          state_id: "1392",
        },
        {
          id: "20084",
          name: "Spiesen-Elversberg",
          state_id: "1392",
        },
        {
          id: "20085",
          name: "Sulzbach",
          state_id: "1392",
        },
        {
          id: "20086",
          name: "Tholey",
          state_id: "1392",
        },
        {
          id: "20087",
          name: "Uberherrn",
          state_id: "1392",
        },
        {
          id: "20088",
          name: "Volklingen",
          state_id: "1392",
        },
        {
          id: "20089",
          name: "Wadern",
          state_id: "1392",
        },
        {
          id: "20090",
          name: "Wadgassen",
          state_id: "1392",
        },
        {
          id: "20091",
          name: "Wallerfangen",
          state_id: "1392",
        },
        {
          id: "20092",
          name: "Weiskirchen",
          state_id: "1392",
        },
      ],
      Sachsen: [
        {
          id: "20093",
          name: "Annaberg-Buchholz",
          state_id: "1393",
        },
        {
          id: "20094",
          name: "Aue",
          state_id: "1393",
        },
        {
          id: "20095",
          name: "Auerbach",
          state_id: "1393",
        },
        {
          id: "20096",
          name: "Bautzen",
          state_id: "1393",
        },
        {
          id: "20097",
          name: "Bischofswerda",
          state_id: "1393",
        },
        {
          id: "20098",
          name: "Borna",
          state_id: "1393",
        },
        {
          id: "20099",
          name: "Brand-Erbisdorf",
          state_id: "1393",
        },
        {
          id: "20100",
          name: "Burgstadt",
          state_id: "1393",
        },
        {
          id: "20101",
          name: "Chemnitz",
          state_id: "1393",
        },
        {
          id: "20102",
          name: "Coswig",
          state_id: "1393",
        },
        {
          id: "20103",
          name: "Crimmitschau",
          state_id: "1393",
        },
        {
          id: "20104",
          name: "Delitzsch",
          state_id: "1393",
        },
        {
          id: "20105",
          name: "Dobeln",
          state_id: "1393",
        },
        {
          id: "20106",
          name: "Dresden",
          state_id: "1393",
        },
        {
          id: "20107",
          name: "Ebersbach",
          state_id: "1393",
        },
        {
          id: "20108",
          name: "Eilenburg",
          state_id: "1393",
        },
        {
          id: "20109",
          name: "Falkenstein",
          state_id: "1393",
        },
        {
          id: "20110",
          name: "Floha",
          state_id: "1393",
        },
        {
          id: "20111",
          name: "Frankenberg",
          state_id: "1393",
        },
        {
          id: "20112",
          name: "Freiberg",
          state_id: "1393",
        },
        {
          id: "20113",
          name: "Freital",
          state_id: "1393",
        },
        {
          id: "20114",
          name: "Friedewald",
          state_id: "1393",
        },
        {
          id: "20115",
          name: "Glauchau",
          state_id: "1393",
        },
        {
          id: "20116",
          name: "Gorlitz",
          state_id: "1393",
        },
        {
          id: "20117",
          name: "Grimma",
          state_id: "1393",
        },
        {
          id: "20118",
          name: "GroBenhain",
          state_id: "1393",
        },
        {
          id: "20119",
          name: "Groditz",
          state_id: "1393",
        },
        {
          id: "20120",
          name: "Hainichen",
          state_id: "1393",
        },
        {
          id: "20121",
          name: "Heidenau",
          state_id: "1393",
        },
        {
          id: "20122",
          name: "Hirschstein",
          state_id: "1393",
        },
        {
          id: "20123",
          name: "Hohenstein-Ernstthal",
          state_id: "1393",
        },
        {
          id: "20124",
          name: "Hoyerswerda",
          state_id: "1393",
        },
        {
          id: "20125",
          name: "Kamenz",
          state_id: "1393",
        },
        {
          id: "20126",
          name: "Klingenthal",
          state_id: "1393",
        },
        {
          id: "20127",
          name: "Leipzig",
          state_id: "1393",
        },
        {
          id: "20128",
          name: "Lichtenstein",
          state_id: "1393",
        },
        {
          id: "20129",
          name: "Limbach-Oberfrohna",
          state_id: "1393",
        },
        {
          id: "20130",
          name: "LoBnitz",
          state_id: "1393",
        },
        {
          id: "20131",
          name: "Lobau",
          state_id: "1393",
        },
        {
          id: "20132",
          name: "Lugau",
          state_id: "1393",
        },
        {
          id: "20133",
          name: "Marienberg",
          state_id: "1393",
        },
        {
          id: "20134",
          name: "Markkleeberg",
          state_id: "1393",
        },
        {
          id: "20135",
          name: "Meerane",
          state_id: "1393",
        },
        {
          id: "20136",
          name: "MeiBen",
          state_id: "1393",
        },
        {
          id: "20137",
          name: "Mittweida",
          state_id: "1393",
        },
        {
          id: "20138",
          name: "Muldenhammer",
          state_id: "1393",
        },
        {
          id: "20139",
          name: "Neustadt",
          state_id: "1393",
        },
        {
          id: "20140",
          name: "Niesky",
          state_id: "1393",
        },
        {
          id: "20141",
          name: "Oelsnitz",
          state_id: "1393",
        },
        {
          id: "20142",
          name: "Olbernhau",
          state_id: "1393",
        },
        {
          id: "20143",
          name: "Olbersdorf",
          state_id: "1393",
        },
        {
          id: "20144",
          name: "Oschatz",
          state_id: "1393",
        },
        {
          id: "20145",
          name: "Pirna",
          state_id: "1393",
        },
        {
          id: "20146",
          name: "Plauen",
          state_id: "1393",
        },
        {
          id: "20147",
          name: "Radeberg",
          state_id: "1393",
        },
        {
          id: "20148",
          name: "Radebeul",
          state_id: "1393",
        },
        {
          id: "20149",
          name: "Reichenbach",
          state_id: "1393",
        },
        {
          id: "20150",
          name: "Riesa",
          state_id: "1393",
        },
        {
          id: "20151",
          name: "Rietschen",
          state_id: "1393",
        },
        {
          id: "20152",
          name: "Schkeuditz",
          state_id: "1393",
        },
        {
          id: "20153",
          name: "Schneeberg",
          state_id: "1393",
        },
        {
          id: "20154",
          name: "Schwarzenberg",
          state_id: "1393",
        },
        {
          id: "20155",
          name: "Sebnitz",
          state_id: "1393",
        },
        {
          id: "20156",
          name: "Stollberg",
          state_id: "1393",
        },
        {
          id: "20157",
          name: "Taubenheim",
          state_id: "1393",
        },
        {
          id: "20158",
          name: "Taucha",
          state_id: "1393",
        },
        {
          id: "20159",
          name: "Thalheim",
          state_id: "1393",
        },
        {
          id: "20160",
          name: "Torgau",
          state_id: "1393",
        },
        {
          id: "20161",
          name: "Waldheim",
          state_id: "1393",
        },
        {
          id: "20162",
          name: "WeiBwasser",
          state_id: "1393",
        },
        {
          id: "20163",
          name: "Werdau",
          state_id: "1393",
        },
        {
          id: "20164",
          name: "Wilkau-HaBlau",
          state_id: "1393",
        },
        {
          id: "20165",
          name: "Wurzen",
          state_id: "1393",
        },
        {
          id: "20166",
          name: "Zittau",
          state_id: "1393",
        },
        {
          id: "20167",
          name: "Zschopau",
          state_id: "1393",
        },
        {
          id: "20168",
          name: "Zwickau",
          state_id: "1393",
        },
        {
          id: "20169",
          name: "Zwonitz",
          state_id: "1393",
        },
      ],
      "Sachsen-Anhalt": [
        {
          id: "20170",
          name: "Aken",
          state_id: "1394",
        },
        {
          id: "20171",
          name: "Aschersleben",
          state_id: "1394",
        },
        {
          id: "20172",
          name: "Bad Durrenberg",
          state_id: "1394",
        },
        {
          id: "20173",
          name: "Bebitz",
          state_id: "1394",
        },
        {
          id: "20174",
          name: "Bernburg",
          state_id: "1394",
        },
        {
          id: "20175",
          name: "Bitterfeld",
          state_id: "1394",
        },
        {
          id: "20176",
          name: "Blankenburg",
          state_id: "1394",
        },
        {
          id: "20177",
          name: "Braunsbedra",
          state_id: "1394",
        },
        {
          id: "20178",
          name: "Burg",
          state_id: "1394",
        },
        {
          id: "20179",
          name: "Calbe",
          state_id: "1394",
        },
        {
          id: "20180",
          name: "Coswig",
          state_id: "1394",
        },
        {
          id: "20181",
          name: "Dessau",
          state_id: "1394",
        },
        {
          id: "20182",
          name: "Eisleben",
          state_id: "1394",
        },
        {
          id: "20183",
          name: "Gardelegen",
          state_id: "1394",
        },
        {
          id: "20184",
          name: "Genthin",
          state_id: "1394",
        },
        {
          id: "20185",
          name: "Gommern",
          state_id: "1394",
        },
        {
          id: "20186",
          name: "Grafenhainichen",
          state_id: "1394",
        },
        {
          id: "20187",
          name: "Halberstadt",
          state_id: "1394",
        },
        {
          id: "20188",
          name: "Haldensleben",
          state_id: "1394",
        },
        {
          id: "20189",
          name: "Halle",
          state_id: "1394",
        },
        {
          id: "20190",
          name: "Hettstedt",
          state_id: "1394",
        },
        {
          id: "20191",
          name: "Heyrothsberge",
          state_id: "1394",
        },
        {
          id: "20192",
          name: "Hotensleben",
          state_id: "1394",
        },
        {
          id: "20193",
          name: "Kothen",
          state_id: "1394",
        },
        {
          id: "20194",
          name: "Leuna",
          state_id: "1394",
        },
        {
          id: "20195",
          name: "Magdeburg",
          state_id: "1394",
        },
        {
          id: "20196",
          name: "Merseburg",
          state_id: "1394",
        },
        {
          id: "20197",
          name: "Naumburg",
          state_id: "1394",
        },
        {
          id: "20198",
          name: "Oschersleben",
          state_id: "1394",
        },
        {
          id: "20199",
          name: "Osterburg",
          state_id: "1394",
        },
        {
          id: "20200",
          name: "Osterwieck",
          state_id: "1394",
        },
        {
          id: "20201",
          name: "Quedlinburg",
          state_id: "1394",
        },
        {
          id: "20202",
          name: "Querfurt",
          state_id: "1394",
        },
        {
          id: "20203",
          name: "Raguhn",
          state_id: "1394",
        },
        {
          id: "20204",
          name: "RoBlau",
          state_id: "1394",
        },
        {
          id: "20205",
          name: "Salzwedel",
          state_id: "1394",
        },
        {
          id: "20206",
          name: "Sangerhausen",
          state_id: "1394",
        },
        {
          id: "20207",
          name: "Schonebeck",
          state_id: "1394",
        },
        {
          id: "20208",
          name: "StaBfurt",
          state_id: "1394",
        },
        {
          id: "20209",
          name: "Stendal",
          state_id: "1394",
        },
        {
          id: "20210",
          name: "Tangermunde",
          state_id: "1394",
        },
        {
          id: "20211",
          name: "Thale",
          state_id: "1394",
        },
        {
          id: "20212",
          name: "WeiBenfels",
          state_id: "1394",
        },
        {
          id: "20213",
          name: "Wittenberg",
          state_id: "1394",
        },
        {
          id: "20214",
          name: "Wolfen",
          state_id: "1394",
        },
        {
          id: "20215",
          name: "Wolmirstedt",
          state_id: "1394",
        },
        {
          id: "20216",
          name: "Zeitz",
          state_id: "1394",
        },
        {
          id: "20217",
          name: "Zerbst",
          state_id: "1394",
        },
      ],
      Saxony: [
        {
          id: "20218",
          name: "Bad Lausick",
          state_id: "1395",
        },
        {
          id: "20219",
          name: "Bernsdorf",
          state_id: "1395",
        },
        {
          id: "20220",
          name: "Borde-Hakel",
          state_id: "1395",
        },
        {
          id: "20221",
          name: "Gelenau",
          state_id: "1395",
        },
        {
          id: "20222",
          name: "Groberkmannsdorf",
          state_id: "1395",
        },
        {
          id: "20223",
          name: "Hartha",
          state_id: "1395",
        },
        {
          id: "20224",
          name: "Kreischa",
          state_id: "1395",
        },
        {
          id: "20225",
          name: "Malschwitz",
          state_id: "1395",
        },
        {
          id: "20226",
          name: "Naunhof",
          state_id: "1395",
        },
        {
          id: "20227",
          name: "Pausa",
          state_id: "1395",
        },
        {
          id: "20228",
          name: "Seiffen",
          state_id: "1395",
        },
        {
          id: "20229",
          name: "Stutzengrun",
          state_id: "1395",
        },
      ],
      "Schleswig-Holstein": [
        {
          id: "20230",
          name: "Ahrensbok",
          state_id: "1396",
        },
        {
          id: "20231",
          name: "Ahrensburg",
          state_id: "1396",
        },
        {
          id: "20232",
          name: "Altenholz",
          state_id: "1396",
        },
        {
          id: "20233",
          name: "Alveslohe",
          state_id: "1396",
        },
        {
          id: "20234",
          name: "Ammersbek",
          state_id: "1396",
        },
        {
          id: "20235",
          name: "Bad Bramstedt",
          state_id: "1396",
        },
        {
          id: "20236",
          name: "Bad Oldesloe",
          state_id: "1396",
        },
        {
          id: "20237",
          name: "Bad Schwartau",
          state_id: "1396",
        },
        {
          id: "20238",
          name: "Bad Segeberg",
          state_id: "1396",
        },
        {
          id: "20239",
          name: "Bargteheide",
          state_id: "1396",
        },
        {
          id: "20240",
          name: "Barmstedt",
          state_id: "1396",
        },
        {
          id: "20241",
          name: "Barsbuttel",
          state_id: "1396",
        },
        {
          id: "20242",
          name: "Bredstedt",
          state_id: "1396",
        },
        {
          id: "20243",
          name: "Brunsbuttel",
          state_id: "1396",
        },
        {
          id: "20244",
          name: "Budelsdorf",
          state_id: "1396",
        },
        {
          id: "20245",
          name: "Eckernforde",
          state_id: "1396",
        },
        {
          id: "20246",
          name: "Eddelak",
          state_id: "1396",
        },
        {
          id: "20247",
          name: "Elmshorn",
          state_id: "1396",
        },
        {
          id: "20248",
          name: "Eutin",
          state_id: "1396",
        },
        {
          id: "20249",
          name: "Flensburg",
          state_id: "1396",
        },
        {
          id: "20250",
          name: "Friedrichstadt",
          state_id: "1396",
        },
        {
          id: "20251",
          name: "Geesthacht",
          state_id: "1396",
        },
        {
          id: "20252",
          name: "Glinde",
          state_id: "1396",
        },
        {
          id: "20253",
          name: "Gluckstadt",
          state_id: "1396",
        },
        {
          id: "20254",
          name: "Grob Pampau",
          state_id: "1396",
        },
        {
          id: "20255",
          name: "Halstenbek",
          state_id: "1396",
        },
        {
          id: "20256",
          name: "Hamfelde",
          state_id: "1396",
        },
        {
          id: "20257",
          name: "Harrislee",
          state_id: "1396",
        },
        {
          id: "20258",
          name: "Hartenholm",
          state_id: "1396",
        },
        {
          id: "20259",
          name: "Heide",
          state_id: "1396",
        },
        {
          id: "20260",
          name: "Heiligenhafen",
          state_id: "1396",
        },
        {
          id: "20261",
          name: "Henstedt-Ulzburg",
          state_id: "1396",
        },
        {
          id: "20262",
          name: "Honenwestedt",
          state_id: "1396",
        },
        {
          id: "20263",
          name: "Husum",
          state_id: "1396",
        },
        {
          id: "20264",
          name: "Itzehoe",
          state_id: "1396",
        },
        {
          id: "20265",
          name: "Kaltenkirchen",
          state_id: "1396",
        },
        {
          id: "20266",
          name: "Kappeln",
          state_id: "1396",
        },
        {
          id: "20267",
          name: "Kiel",
          state_id: "1396",
        },
        {
          id: "20268",
          name: "Kronshagen",
          state_id: "1396",
        },
        {
          id: "20269",
          name: "Lauenburg",
          state_id: "1396",
        },
        {
          id: "20270",
          name: "Lensahn",
          state_id: "1396",
        },
        {
          id: "20271",
          name: "Lubeck",
          state_id: "1396",
        },
        {
          id: "20272",
          name: "Malente",
          state_id: "1396",
        },
        {
          id: "20273",
          name: "Mielkendorf",
          state_id: "1396",
        },
        {
          id: "20274",
          name: "Molfsee",
          state_id: "1396",
        },
        {
          id: "20275",
          name: "Molln",
          state_id: "1396",
        },
        {
          id: "20276",
          name: "Neuenbrook",
          state_id: "1396",
        },
        {
          id: "20277",
          name: "Neumunster",
          state_id: "1396",
        },
        {
          id: "20278",
          name: "Neustadt",
          state_id: "1396",
        },
        {
          id: "20279",
          name: "Norderstedt",
          state_id: "1396",
        },
        {
          id: "20280",
          name: "Oldenburg",
          state_id: "1396",
        },
        {
          id: "20281",
          name: "Oststeinbek",
          state_id: "1396",
        },
        {
          id: "20282",
          name: "Pinneberg",
          state_id: "1396",
        },
        {
          id: "20283",
          name: "Plon",
          state_id: "1396",
        },
        {
          id: "20284",
          name: "Preetz",
          state_id: "1396",
        },
        {
          id: "20285",
          name: "Quickborn",
          state_id: "1396",
        },
        {
          id: "20286",
          name: "Ratekau",
          state_id: "1396",
        },
        {
          id: "20287",
          name: "Ratzeburg",
          state_id: "1396",
        },
        {
          id: "20288",
          name: "Reinbek",
          state_id: "1396",
        },
        {
          id: "20289",
          name: "Reinfeld",
          state_id: "1396",
        },
        {
          id: "20290",
          name: "Rellingen",
          state_id: "1396",
        },
        {
          id: "20291",
          name: "Rendsburg",
          state_id: "1396",
        },
        {
          id: "20292",
          name: "Rethwisch",
          state_id: "1396",
        },
        {
          id: "20293",
          name: "Satrup",
          state_id: "1396",
        },
        {
          id: "20294",
          name: "Scharbeutz",
          state_id: "1396",
        },
        {
          id: "20295",
          name: "Schenefeld",
          state_id: "1396",
        },
        {
          id: "20296",
          name: "Schleswig",
          state_id: "1396",
        },
        {
          id: "20297",
          name: "Schmalfeld",
          state_id: "1396",
        },
        {
          id: "20298",
          name: "Schoenkirchen",
          state_id: "1396",
        },
        {
          id: "20299",
          name: "Schwarzenbek",
          state_id: "1396",
        },
        {
          id: "20300",
          name: "Seefeld",
          state_id: "1396",
        },
        {
          id: "20301",
          name: "Sievershutten",
          state_id: "1396",
        },
        {
          id: "20302",
          name: "Stockelsdorf",
          state_id: "1396",
        },
        {
          id: "20303",
          name: "Tangstedt",
          state_id: "1396",
        },
        {
          id: "20304",
          name: "Timmendorfer Strand",
          state_id: "1396",
        },
        {
          id: "20305",
          name: "Tornesch",
          state_id: "1396",
        },
        {
          id: "20306",
          name: "Travemunde",
          state_id: "1396",
        },
        {
          id: "20307",
          name: "Uetersen",
          state_id: "1396",
        },
        {
          id: "20308",
          name: "Wahlstedt",
          state_id: "1396",
        },
        {
          id: "20309",
          name: "Wedel",
          state_id: "1396",
        },
        {
          id: "20310",
          name: "Wentorf",
          state_id: "1396",
        },
        {
          id: "20311",
          name: "Westerland",
          state_id: "1396",
        },
        {
          id: "20312",
          name: "Westerronfeld",
          state_id: "1396",
        },
        {
          id: "20313",
          name: "Wohltorf",
          state_id: "1396",
        },
        {
          id: "20314",
          name: "Wotersen",
          state_id: "1396",
        },
      ],
      Thuringia: [
        {
          id: "20315",
          name: "Altenburg",
          state_id: "1397",
        },
        {
          id: "20316",
          name: "Apolda",
          state_id: "1397",
        },
        {
          id: "20317",
          name: "Arnstadt",
          state_id: "1397",
        },
        {
          id: "20318",
          name: "Bad Frankenhausen",
          state_id: "1397",
        },
        {
          id: "20319",
          name: "Bad Langensalza",
          state_id: "1397",
        },
        {
          id: "20320",
          name: "Bad Salzungen",
          state_id: "1397",
        },
        {
          id: "20321",
          name: "Cursdorf",
          state_id: "1397",
        },
        {
          id: "20322",
          name: "Dornburg",
          state_id: "1397",
        },
        {
          id: "20323",
          name: "Eisenach",
          state_id: "1397",
        },
        {
          id: "20324",
          name: "Eisenberg",
          state_id: "1397",
        },
        {
          id: "20325",
          name: "Erfurt",
          state_id: "1397",
        },
        {
          id: "20326",
          name: "Gera",
          state_id: "1397",
        },
        {
          id: "20327",
          name: "Geschwenda",
          state_id: "1397",
        },
        {
          id: "20328",
          name: "Gotha",
          state_id: "1397",
        },
        {
          id: "20329",
          name: "Greiz",
          state_id: "1397",
        },
        {
          id: "20330",
          name: "Heiligenstadt",
          state_id: "1397",
        },
        {
          id: "20331",
          name: "Hermsdorf",
          state_id: "1397",
        },
        {
          id: "20332",
          name: "Hildburghausen",
          state_id: "1397",
        },
        {
          id: "20333",
          name: "Ilmenau",
          state_id: "1397",
        },
        {
          id: "20334",
          name: "Immelborn",
          state_id: "1397",
        },
        {
          id: "20335",
          name: "Jena",
          state_id: "1397",
        },
        {
          id: "20336",
          name: "Leinefelde",
          state_id: "1397",
        },
        {
          id: "20337",
          name: "Leutenberg",
          state_id: "1397",
        },
        {
          id: "20338",
          name: "Meiningen",
          state_id: "1397",
        },
        {
          id: "20339",
          name: "Meuselwitz",
          state_id: "1397",
        },
        {
          id: "20340",
          name: "Muhlhausen",
          state_id: "1397",
        },
        {
          id: "20341",
          name: "Neustadt",
          state_id: "1397",
        },
        {
          id: "20342",
          name: "Nordhausen",
          state_id: "1397",
        },
        {
          id: "20343",
          name: "PoBneck",
          state_id: "1397",
        },
        {
          id: "20344",
          name: "Rosenthal",
          state_id: "1397",
        },
        {
          id: "20345",
          name: "Rositz",
          state_id: "1397",
        },
        {
          id: "20346",
          name: "Rudolstadt",
          state_id: "1397",
        },
        {
          id: "20347",
          name: "Ruhla",
          state_id: "1397",
        },
        {
          id: "20348",
          name: "Saalfeld",
          state_id: "1397",
        },
        {
          id: "20349",
          name: "Schmalkalden",
          state_id: "1397",
        },
        {
          id: "20350",
          name: "Schmolln",
          state_id: "1397",
        },
        {
          id: "20351",
          name: "Sommerda",
          state_id: "1397",
        },
        {
          id: "20352",
          name: "Sondershausen",
          state_id: "1397",
        },
        {
          id: "20353",
          name: "Sonneberg",
          state_id: "1397",
        },
        {
          id: "20354",
          name: "Suhl",
          state_id: "1397",
        },
        {
          id: "20355",
          name: "Triptis",
          state_id: "1397",
        },
        {
          id: "20356",
          name: "Uhlstadt",
          state_id: "1397",
        },
        {
          id: "20357",
          name: "Waltershausen",
          state_id: "1397",
        },
        {
          id: "20358",
          name: "Weida",
          state_id: "1397",
        },
        {
          id: "20359",
          name: "Weimar",
          state_id: "1397",
        },
        {
          id: "20360",
          name: "Wernigerode",
          state_id: "1397",
        },
        {
          id: "20361",
          name: "Wormstedt",
          state_id: "1397",
        },
        {
          id: "20362",
          name: "Zella-Mehlis",
          state_id: "1397",
        },
        {
          id: "20363",
          name: "Zeulenroda",
          state_id: "1397",
        },
      ],
      Webling: [
        {
          id: "20364",
          name: "Webling",
          state_id: "1398",
        },
      ],
      Weinstrabe: [
        {
          id: "20365",
          name: "Neustadt",
          state_id: "1399",
        },
      ],
      schlobborn: [
        {
          id: "20366",
          name: "Schlobborn",
          state_id: "1400",
        },
      ],
    },
  },
  DJ: {
    name: "Djibouti",
    native: "Djibouti",
    phone: "253",
    continent: "AF",
    capital: "Djibouti",
    currency: "DJF",
    languages: ["fr", "ar"],
    emoji: "🇩🇯",
    emojiU: "U+1F1E9 U+1F1EF",
    states: {
      "Ali Sabih": [],
      Dikhil: [
        {
          id: "15257",
          name: "Dikhil",
          state_id: "965",
        },
      ],
      Jibuti: [
        {
          id: "15258",
          name: "Jibuti",
          state_id: "966",
        },
      ],
      Tajurah: [
        {
          id: "15259",
          name: "Tajurah",
          state_id: "967",
        },
      ],
      Ubuk: [
        {
          id: "15260",
          name: "Ubuk",
          state_id: "968",
        },
      ],
    },
  },
  DK: {
    name: "Denmark",
    native: "Danmark",
    phone: "45",
    continent: "EU",
    capital: "Copenhagen",
    currency: "DKK",
    languages: ["da"],
    emoji: "🇩🇰",
    emojiU: "U+1F1E9 U+1F1F0",
    states: {
      Arhus: [
        {
          id: "14911",
          name: "Aarhus",
          state_id: "941",
        },
        {
          id: "14912",
          name: "Allingabro",
          state_id: "941",
        },
        {
          id: "14913",
          name: "Arhus",
          state_id: "941",
        },
        {
          id: "14914",
          name: "Assentoft",
          state_id: "941",
        },
        {
          id: "14915",
          name: "Auning",
          state_id: "941",
        },
        {
          id: "14916",
          name: "Beder",
          state_id: "941",
        },
        {
          id: "14917",
          name: "Brabrand",
          state_id: "941",
        },
        {
          id: "14918",
          name: "Ebeltoft",
          state_id: "941",
        },
        {
          id: "14919",
          name: "Framlev",
          state_id: "941",
        },
        {
          id: "14920",
          name: "Galten",
          state_id: "941",
        },
        {
          id: "14921",
          name: "Grenaa",
          state_id: "941",
        },
        {
          id: "14922",
          name: "Hadsten",
          state_id: "941",
        },
        {
          id: "14923",
          name: "Hammel",
          state_id: "941",
        },
        {
          id: "14924",
          name: "Hinnerup",
          state_id: "941",
        },
        {
          id: "14925",
          name: "Hjortshoj",
          state_id: "941",
        },
        {
          id: "14926",
          name: "Horning",
          state_id: "941",
        },
        {
          id: "14927",
          name: "Hornslet",
          state_id: "941",
        },
        {
          id: "14928",
          name: "Kolt",
          state_id: "941",
        },
        {
          id: "14929",
          name: "Langa",
          state_id: "941",
        },
        {
          id: "14930",
          name: "Logten",
          state_id: "941",
        },
        {
          id: "14931",
          name: "Lystrup",
          state_id: "941",
        },
        {
          id: "14932",
          name: "Malling",
          state_id: "941",
        },
        {
          id: "14933",
          name: "Mariager",
          state_id: "941",
        },
        {
          id: "14934",
          name: "Marslet",
          state_id: "941",
        },
        {
          id: "14935",
          name: "Odder",
          state_id: "941",
        },
        {
          id: "14936",
          name: "Randers",
          state_id: "941",
        },
        {
          id: "14937",
          name: "Risskov",
          state_id: "941",
        },
        {
          id: "14938",
          name: "Ronde",
          state_id: "941",
        },
        {
          id: "14939",
          name: "Ry",
          state_id: "941",
        },
        {
          id: "14940",
          name: "Ryomgard",
          state_id: "941",
        },
        {
          id: "14941",
          name: "Sabro",
          state_id: "941",
        },
        {
          id: "14942",
          name: "Silkeborg",
          state_id: "941",
        },
        {
          id: "14943",
          name: "Skanderborg",
          state_id: "941",
        },
        {
          id: "14944",
          name: "Skovby",
          state_id: "941",
        },
        {
          id: "14945",
          name: "Soften",
          state_id: "941",
        },
        {
          id: "14946",
          name: "Solbjerg",
          state_id: "941",
        },
        {
          id: "14947",
          name: "Spentrup",
          state_id: "941",
        },
        {
          id: "14948",
          name: "Stavtrup",
          state_id: "941",
        },
        {
          id: "14949",
          name: "Stilling",
          state_id: "941",
        },
        {
          id: "14950",
          name: "Svejbak",
          state_id: "941",
        },
        {
          id: "14951",
          name: "Tranbjerg",
          state_id: "941",
        },
        {
          id: "14952",
          name: "Trige",
          state_id: "941",
        },
        {
          id: "14953",
          name: "Virklund",
          state_id: "941",
        },
      ],
      Bornholm: [
        {
          id: "14954",
          name: "Aakirkeby",
          state_id: "942",
        },
        {
          id: "14955",
          name: "Allinge-Sandvig",
          state_id: "942",
        },
        {
          id: "14956",
          name: "Nexo",
          state_id: "942",
        },
        {
          id: "14957",
          name: "Ronne",
          state_id: "942",
        },
      ],
      Frederiksborg: [
        {
          id: "14958",
          name: "Allerod",
          state_id: "943",
        },
        {
          id: "14959",
          name: "Birkerod",
          state_id: "943",
        },
        {
          id: "14960",
          name: "Blovstrod",
          state_id: "943",
        },
        {
          id: "14961",
          name: "Espergarde",
          state_id: "943",
        },
        {
          id: "14962",
          name: "Farum",
          state_id: "943",
        },
        {
          id: "14963",
          name: "Fredensborg",
          state_id: "943",
        },
        {
          id: "14964",
          name: "Frederikssund",
          state_id: "943",
        },
        {
          id: "14965",
          name: "Frederiksvark",
          state_id: "943",
        },
        {
          id: "14966",
          name: "Ganlose",
          state_id: "943",
        },
        {
          id: "14967",
          name: "Gilleleje",
          state_id: "943",
        },
        {
          id: "14968",
          name: "Grasted",
          state_id: "943",
        },
        {
          id: "14969",
          name: "Hellebak",
          state_id: "943",
        },
        {
          id: "14970",
          name: "Helsinge",
          state_id: "943",
        },
        {
          id: "14971",
          name: "Helsingor",
          state_id: "943",
        },
        {
          id: "14972",
          name: "Hillerod",
          state_id: "943",
        },
        {
          id: "14973",
          name: "Hornbak",
          state_id: "943",
        },
        {
          id: "14974",
          name: "Horsholm",
          state_id: "943",
        },
        {
          id: "14975",
          name: "Humlebak",
          state_id: "943",
        },
        {
          id: "14976",
          name: "Hundested",
          state_id: "943",
        },
        {
          id: "14977",
          name: "Jagerspris",
          state_id: "943",
        },
        {
          id: "14978",
          name: "Kvistgaard",
          state_id: "943",
        },
        {
          id: "14979",
          name: "Lillerod",
          state_id: "943",
        },
        {
          id: "14980",
          name: "Liseleje",
          state_id: "943",
        },
        {
          id: "14981",
          name: "Lynge",
          state_id: "943",
        },
        {
          id: "14982",
          name: "Niva",
          state_id: "943",
        },
        {
          id: "14983",
          name: "Nodebo",
          state_id: "943",
        },
        {
          id: "14984",
          name: "Olstykke",
          state_id: "943",
        },
        {
          id: "14985",
          name: "Skibby",
          state_id: "943",
        },
        {
          id: "14986",
          name: "Slangerup",
          state_id: "943",
        },
        {
          id: "14987",
          name: "Stavnsholt",
          state_id: "943",
        },
        {
          id: "14988",
          name: "Stenlose",
          state_id: "943",
        },
        {
          id: "14989",
          name: "Valby",
          state_id: "943",
        },
        {
          id: "14990",
          name: "Vekso",
          state_id: "943",
        },
      ],
      Fyn: [
        {
          id: "14991",
          name: "Aarup",
          state_id: "944",
        },
        {
          id: "14992",
          name: "Arslev",
          state_id: "944",
        },
        {
          id: "14993",
          name: "Assens",
          state_id: "944",
        },
        {
          id: "14994",
          name: "Bellinge",
          state_id: "944",
        },
        {
          id: "14995",
          name: "Blommenslyst",
          state_id: "944",
        },
        {
          id: "14996",
          name: "Bogense",
          state_id: "944",
        },
        {
          id: "14997",
          name: "Brenderup",
          state_id: "944",
        },
        {
          id: "14998",
          name: "Broby",
          state_id: "944",
        },
        {
          id: "14999",
          name: "Bullerup",
          state_id: "944",
        },
        {
          id: "15000",
          name: "Ejby",
          state_id: "944",
        },
        {
          id: "15001",
          name: "Faaborg",
          state_id: "944",
        },
        {
          id: "15002",
          name: "Glamsbjerg",
          state_id: "944",
        },
        {
          id: "15003",
          name: "Haarby",
          state_id: "944",
        },
        {
          id: "15004",
          name: "Hojby",
          state_id: "944",
        },
        {
          id: "15005",
          name: "Kerteminde",
          state_id: "944",
        },
        {
          id: "15006",
          name: "Langeskov",
          state_id: "944",
        },
        {
          id: "15007",
          name: "Marstal",
          state_id: "944",
        },
        {
          id: "15008",
          name: "Middelfart",
          state_id: "944",
        },
        {
          id: "15009",
          name: "Munkebo",
          state_id: "944",
        },
        {
          id: "15010",
          name: "Neder Holluf",
          state_id: "944",
        },
        {
          id: "15011",
          name: "Norre Aaby",
          state_id: "944",
        },
        {
          id: "15012",
          name: "Nyborg",
          state_id: "944",
        },
        {
          id: "15013",
          name: "Odense",
          state_id: "944",
        },
        {
          id: "15014",
          name: "Otterup",
          state_id: "944",
        },
        {
          id: "15015",
          name: "Ringe",
          state_id: "944",
        },
        {
          id: "15016",
          name: "Rudkobing",
          state_id: "944",
        },
        {
          id: "15017",
          name: "Sankt Klemens",
          state_id: "944",
        },
        {
          id: "15018",
          name: "Seden",
          state_id: "944",
        },
        {
          id: "15019",
          name: "Sonderso",
          state_id: "944",
        },
        {
          id: "15020",
          name: "Stige",
          state_id: "944",
        },
        {
          id: "15021",
          name: "Strib",
          state_id: "944",
        },
        {
          id: "15022",
          name: "Svendborg",
          state_id: "944",
        },
        {
          id: "15023",
          name: "Thuro",
          state_id: "944",
        },
        {
          id: "15024",
          name: "Tommerup",
          state_id: "944",
        },
        {
          id: "15025",
          name: "Ullerslev",
          state_id: "944",
        },
        {
          id: "15026",
          name: "Vindeby",
          state_id: "944",
        },
        {
          id: "15027",
          name: "Vissenbjerg",
          state_id: "944",
        },
      ],
      Hovedstaden: [
        {
          id: "15028",
          name: "Ballerup",
          state_id: "945",
        },
        {
          id: "15029",
          name: "Brondby",
          state_id: "945",
        },
        {
          id: "15030",
          name: "Stenlose",
          state_id: "945",
        },
        {
          id: "15031",
          name: "Vallensbaek",
          state_id: "945",
        },
      ],
      Kobenhavn: [
        {
          id: "15032",
          name: "Dragor",
          state_id: "946",
        },
        {
          id: "15033",
          name: "Flong",
          state_id: "946",
        },
        {
          id: "15034",
          name: "Gentofte",
          state_id: "946",
        },
        {
          id: "15035",
          name: "Glostrup",
          state_id: "946",
        },
        {
          id: "15036",
          name: "Herlev",
          state_id: "946",
        },
        {
          id: "15037",
          name: "Hvidovre",
          state_id: "946",
        },
        {
          id: "15038",
          name: "Ishoj",
          state_id: "946",
        },
        {
          id: "15039",
          name: "Kastrup",
          state_id: "946",
        },
        {
          id: "15040",
          name: "Lyngby",
          state_id: "946",
        },
        {
          id: "15041",
          name: "Malov",
          state_id: "946",
        },
        {
          id: "15042",
          name: "Smorumnedre",
          state_id: "946",
        },
        {
          id: "15043",
          name: "Taastrup",
          state_id: "946",
        },
        {
          id: "15044",
          name: "Trorod",
          state_id: "946",
        },
        {
          id: "15045",
          name: "Vanlose",
          state_id: "946",
        },
        {
          id: "15046",
          name: "Varlose",
          state_id: "946",
        },
      ],
      "Kobenhavns Amt": [],
      "Kobenhavns Kommune": [],
      Nordjylland: [
        {
          id: "15047",
          name: "Aabybro",
          state_id: "949",
        },
        {
          id: "15048",
          name: "Aalborg",
          state_id: "949",
        },
        {
          id: "15049",
          name: "Aars",
          state_id: "949",
        },
        {
          id: "15050",
          name: "Arden",
          state_id: "949",
        },
        {
          id: "15051",
          name: "Bindslev",
          state_id: "949",
        },
        {
          id: "15052",
          name: "Bronderslev",
          state_id: "949",
        },
        {
          id: "15053",
          name: "Brovst",
          state_id: "949",
        },
        {
          id: "15054",
          name: "Dronninglund",
          state_id: "949",
        },
        {
          id: "15055",
          name: "Farso",
          state_id: "949",
        },
        {
          id: "15056",
          name: "Fjerritslev",
          state_id: "949",
        },
        {
          id: "15057",
          name: "Frederikshavn",
          state_id: "949",
        },
        {
          id: "15058",
          name: "Frejlev",
          state_id: "949",
        },
        {
          id: "15059",
          name: "Gistrup",
          state_id: "949",
        },
        {
          id: "15060",
          name: "Gorlose",
          state_id: "949",
        },
        {
          id: "15061",
          name: "Hadsund",
          state_id: "949",
        },
        {
          id: "15062",
          name: "Hals",
          state_id: "949",
        },
        {
          id: "15063",
          name: "Hirtshals",
          state_id: "949",
        },
        {
          id: "15064",
          name: "Hjallerup",
          state_id: "949",
        },
        {
          id: "15065",
          name: "Hjorring",
          state_id: "949",
        },
        {
          id: "15066",
          name: "Hobro",
          state_id: "949",
        },
        {
          id: "15067",
          name: "Kas",
          state_id: "949",
        },
        {
          id: "15068",
          name: "Klarup",
          state_id: "949",
        },
        {
          id: "15069",
          name: "Logstor",
          state_id: "949",
        },
        {
          id: "15070",
          name: "Nibe",
          state_id: "949",
        },
        {
          id: "15071",
          name: "Norresundby",
          state_id: "949",
        },
        {
          id: "15072",
          name: "NÃƒÂƒÃ‚Â¸rresundby",
          state_id: "949",
        },
        {
          id: "15073",
          name: "Pandrup",
          state_id: "949",
        },
        {
          id: "15074",
          name: "Saby",
          state_id: "949",
        },
        {
          id: "15075",
          name: "Sindal",
          state_id: "949",
        },
        {
          id: "15076",
          name: "Skagen",
          state_id: "949",
        },
        {
          id: "15077",
          name: "Skorping",
          state_id: "949",
        },
        {
          id: "15078",
          name: "Storvorde",
          state_id: "949",
        },
        {
          id: "15079",
          name: "Stovring",
          state_id: "949",
        },
        {
          id: "15080",
          name: "Strandby",
          state_id: "949",
        },
        {
          id: "15081",
          name: "Sulsted",
          state_id: "949",
        },
        {
          id: "15082",
          name: "Svenstrup",
          state_id: "949",
        },
        {
          id: "15083",
          name: "Tars",
          state_id: "949",
        },
        {
          id: "15084",
          name: "Tranekaer",
          state_id: "949",
        },
        {
          id: "15085",
          name: "Vadum",
          state_id: "949",
        },
        {
          id: "15086",
          name: "Vestbjerg",
          state_id: "949",
        },
        {
          id: "15087",
          name: "Vester Hassing",
          state_id: "949",
        },
        {
          id: "15088",
          name: "Vodskov",
          state_id: "949",
        },
        {
          id: "15089",
          name: "Vra",
          state_id: "949",
        },
      ],
      Ribe: [
        {
          id: "15090",
          name: "Ansager",
          state_id: "950",
        },
        {
          id: "15091",
          name: "Billund",
          state_id: "950",
        },
        {
          id: "15092",
          name: "Bramming",
          state_id: "950",
        },
        {
          id: "15093",
          name: "Brorup",
          state_id: "950",
        },
        {
          id: "15094",
          name: "Esbjerg",
          state_id: "950",
        },
        {
          id: "15095",
          name: "Grindsted",
          state_id: "950",
        },
        {
          id: "15096",
          name: "Holsted",
          state_id: "950",
        },
        {
          id: "15097",
          name: "Nordby",
          state_id: "950",
        },
        {
          id: "15098",
          name: "Oksbol",
          state_id: "950",
        },
        {
          id: "15099",
          name: "Olgod",
          state_id: "950",
        },
        {
          id: "15100",
          name: "Ribe",
          state_id: "950",
        },
        {
          id: "15101",
          name: "Tjareborg",
          state_id: "950",
        },
        {
          id: "15102",
          name: "Varde",
          state_id: "950",
        },
        {
          id: "15103",
          name: "Vejen",
          state_id: "950",
        },
        {
          id: "15104",
          name: "Vorbasse",
          state_id: "950",
        },
      ],
      Ringkobing: [
        {
          id: "15105",
          name: "Aulum",
          state_id: "951",
        },
        {
          id: "15106",
          name: "Bording",
          state_id: "951",
        },
        {
          id: "15107",
          name: "Brande",
          state_id: "951",
        },
        {
          id: "15108",
          name: "Gjellerup Kirkeby",
          state_id: "951",
        },
        {
          id: "15109",
          name: "Hammerum",
          state_id: "951",
        },
        {
          id: "15110",
          name: "Harboore",
          state_id: "951",
        },
        {
          id: "15111",
          name: "Herning",
          state_id: "951",
        },
        {
          id: "15112",
          name: "Holstebro",
          state_id: "951",
        },
        {
          id: "15113",
          name: "Hvide Sande",
          state_id: "951",
        },
        {
          id: "15114",
          name: "Ikast",
          state_id: "951",
        },
        {
          id: "15115",
          name: "Kibak",
          state_id: "951",
        },
        {
          id: "15116",
          name: "Lemvig",
          state_id: "951",
        },
        {
          id: "15117",
          name: "Lind",
          state_id: "951",
        },
        {
          id: "15118",
          name: "Ringkobing",
          state_id: "951",
        },
        {
          id: "15119",
          name: "Skaerbaek",
          state_id: "951",
        },
        {
          id: "15120",
          name: "Skjern",
          state_id: "951",
        },
        {
          id: "15121",
          name: "Snejbjerg",
          state_id: "951",
        },
        {
          id: "15122",
          name: "Struer",
          state_id: "951",
        },
        {
          id: "15123",
          name: "Sunds",
          state_id: "951",
        },
        {
          id: "15124",
          name: "Tarm",
          state_id: "951",
        },
        {
          id: "15125",
          name: "Thyboron",
          state_id: "951",
        },
        {
          id: "15126",
          name: "Ulfborg",
          state_id: "951",
        },
        {
          id: "15127",
          name: "Videbak",
          state_id: "951",
        },
        {
          id: "15128",
          name: "Vildbjerg",
          state_id: "951",
        },
        {
          id: "15129",
          name: "Vinderup",
          state_id: "951",
        },
      ],
      Roervig: [
        {
          id: "15130",
          name: "Roervig",
          state_id: "952",
        },
      ],
      Roskilde: [
        {
          id: "15131",
          name: "Bjaverskov",
          state_id: "953",
        },
        {
          id: "15132",
          name: "Borup",
          state_id: "953",
        },
        {
          id: "15133",
          name: "Ejby",
          state_id: "953",
        },
        {
          id: "15134",
          name: "Greve Strand",
          state_id: "953",
        },
        {
          id: "15135",
          name: "Gundsomagle",
          state_id: "953",
        },
        {
          id: "15136",
          name: "Harlev",
          state_id: "953",
        },
        {
          id: "15137",
          name: "Havdrup",
          state_id: "953",
        },
        {
          id: "15138",
          name: "Hvalso",
          state_id: "953",
        },
        {
          id: "15139",
          name: "Jyllinge",
          state_id: "953",
        },
        {
          id: "15140",
          name: "Koge",
          state_id: "953",
        },
        {
          id: "15141",
          name: "Lejre",
          state_id: "953",
        },
        {
          id: "15142",
          name: "Osted",
          state_id: "953",
        },
        {
          id: "15143",
          name: "Roskilde",
          state_id: "953",
        },
        {
          id: "15144",
          name: "Solrod",
          state_id: "953",
        },
        {
          id: "15145",
          name: "Stroby Egede",
          state_id: "953",
        },
        {
          id: "15146",
          name: "Svogerslev",
          state_id: "953",
        },
        {
          id: "15147",
          name: "Tune",
          state_id: "953",
        },
        {
          id: "15148",
          name: "Viby",
          state_id: "953",
        },
        {
          id: "15149",
          name: "Vindinge",
          state_id: "953",
        },
      ],
      Roslev: [
        {
          id: "15150",
          name: "Glyngore",
          state_id: "954",
        },
      ],
      Sjaelland: [
        {
          id: "15151",
          name: "Karise",
          state_id: "955",
        },
        {
          id: "15152",
          name: "Naestved",
          state_id: "955",
        },
      ],
      Soeborg: [
        {
          id: "15153",
          name: "Soeborg",
          state_id: "956",
        },
      ],
      Sonderjylland: [
        {
          id: "15154",
          name: "Aabenraa",
          state_id: "957",
        },
        {
          id: "15155",
          name: "Aarsleve",
          state_id: "957",
        },
        {
          id: "15156",
          name: "Augustenborg",
          state_id: "957",
        },
        {
          id: "15157",
          name: "Broager",
          state_id: "957",
        },
        {
          id: "15158",
          name: "Christiansfeld",
          state_id: "957",
        },
        {
          id: "15159",
          name: "Dybbol",
          state_id: "957",
        },
        {
          id: "15160",
          name: "Gram",
          state_id: "957",
        },
        {
          id: "15161",
          name: "Grasten",
          state_id: "957",
        },
        {
          id: "15162",
          name: "Guderup",
          state_id: "957",
        },
        {
          id: "15163",
          name: "Haderslev",
          state_id: "957",
        },
        {
          id: "15164",
          name: "Horuphav",
          state_id: "957",
        },
        {
          id: "15165",
          name: "Krusa",
          state_id: "957",
        },
        {
          id: "15166",
          name: "Logumkloster",
          state_id: "957",
        },
        {
          id: "15167",
          name: "Lojt Kirkeby",
          state_id: "957",
        },
        {
          id: "15168",
          name: "Nordborg",
          state_id: "957",
        },
        {
          id: "15169",
          name: "Padborg",
          state_id: "957",
        },
        {
          id: "15170",
          name: "Rodding",
          state_id: "957",
        },
        {
          id: "15171",
          name: "Rodekro",
          state_id: "957",
        },
        {
          id: "15172",
          name: "Skarbak",
          state_id: "957",
        },
        {
          id: "15173",
          name: "Sonderborg",
          state_id: "957",
        },
        {
          id: "15174",
          name: "Starup",
          state_id: "957",
        },
        {
          id: "15175",
          name: "Tinglev",
          state_id: "957",
        },
        {
          id: "15176",
          name: "Toftlund",
          state_id: "957",
        },
        {
          id: "15177",
          name: "Tonder",
          state_id: "957",
        },
        {
          id: "15178",
          name: "Vojens",
          state_id: "957",
        },
      ],
      Storstrom: [
        {
          id: "15179",
          name: "Fakse",
          state_id: "958",
        },
        {
          id: "15180",
          name: "Fakse Ladeplads",
          state_id: "958",
        },
        {
          id: "15181",
          name: "Fensmark",
          state_id: "958",
        },
        {
          id: "15182",
          name: "Holeby",
          state_id: "958",
        },
        {
          id: "15183",
          name: "Maribo",
          state_id: "958",
        },
        {
          id: "15184",
          name: "Nakskov",
          state_id: "958",
        },
        {
          id: "15185",
          name: "Nastved",
          state_id: "958",
        },
        {
          id: "15186",
          name: "Neder Vindinge",
          state_id: "958",
        },
        {
          id: "15187",
          name: "Norre Alslev",
          state_id: "958",
        },
        {
          id: "15188",
          name: "Nykobing",
          state_id: "958",
        },
        {
          id: "15189",
          name: "Nyrad",
          state_id: "958",
        },
        {
          id: "15190",
          name: "Orslev",
          state_id: "958",
        },
        {
          id: "15191",
          name: "Prasto",
          state_id: "958",
        },
        {
          id: "15192",
          name: "Rodby",
          state_id: "958",
        },
        {
          id: "15193",
          name: "Rodbyhavn",
          state_id: "958",
        },
        {
          id: "15194",
          name: "Ronnede",
          state_id: "958",
        },
        {
          id: "15195",
          name: "Sakskobing",
          state_id: "958",
        },
        {
          id: "15196",
          name: "Stege",
          state_id: "958",
        },
        {
          id: "15197",
          name: "Store Heddinge",
          state_id: "958",
        },
        {
          id: "15198",
          name: "Stubbekobing",
          state_id: "958",
        },
        {
          id: "15199",
          name: "Sundby",
          state_id: "958",
        },
        {
          id: "15200",
          name: "Vordingborg",
          state_id: "958",
        },
      ],
      Syddanmark: [
        {
          id: "15201",
          name: "Bylderup-Bov",
          state_id: "959",
        },
        {
          id: "15202",
          name: "Fovling",
          state_id: "959",
        },
      ],
      Toelloese: [
        {
          id: "15203",
          name: "Toelloese",
          state_id: "960",
        },
      ],
      Vejle: [
        {
          id: "15204",
          name: "Borkop",
          state_id: "961",
        },
        {
          id: "15205",
          name: "Bradstrup",
          state_id: "961",
        },
        {
          id: "15206",
          name: "Brejning",
          state_id: "961",
        },
        {
          id: "15207",
          name: "Egtved",
          state_id: "961",
        },
        {
          id: "15208",
          name: "Fredericia",
          state_id: "961",
        },
        {
          id: "15209",
          name: "Give",
          state_id: "961",
        },
        {
          id: "15210",
          name: "Hedensted",
          state_id: "961",
        },
        {
          id: "15211",
          name: "Horsens",
          state_id: "961",
        },
        {
          id: "15212",
          name: "Jelling",
          state_id: "961",
        },
        {
          id: "15213",
          name: "Juelsminde",
          state_id: "961",
        },
        {
          id: "15214",
          name: "Kolding",
          state_id: "961",
        },
        {
          id: "15215",
          name: "Lunderskov",
          state_id: "961",
        },
        {
          id: "15216",
          name: "Snoghoj",
          state_id: "961",
        },
        {
          id: "15217",
          name: "Sonder Bjert",
          state_id: "961",
        },
        {
          id: "15218",
          name: "Taulov",
          state_id: "961",
        },
        {
          id: "15219",
          name: "Torring",
          state_id: "961",
        },
        {
          id: "15220",
          name: "Vamdrup",
          state_id: "961",
        },
        {
          id: "15221",
          name: "Vejle",
          state_id: "961",
        },
      ],
      Vestsjalland: [
        {
          id: "15222",
          name: "Asnas",
          state_id: "962",
        },
        {
          id: "15223",
          name: "Dianalund",
          state_id: "962",
        },
        {
          id: "15224",
          name: "Forlev",
          state_id: "962",
        },
        {
          id: "15225",
          name: "Frederiksberg",
          state_id: "962",
        },
        {
          id: "15226",
          name: "Fuglebjerg",
          state_id: "962",
        },
        {
          id: "15227",
          name: "Gorlev",
          state_id: "962",
        },
        {
          id: "15228",
          name: "Haslev",
          state_id: "962",
        },
        {
          id: "15229",
          name: "Holbaek",
          state_id: "962",
        },
        {
          id: "15230",
          name: "Hong",
          state_id: "962",
        },
        {
          id: "15231",
          name: "Horve",
          state_id: "962",
        },
        {
          id: "15232",
          name: "Jyderup",
          state_id: "962",
        },
        {
          id: "15233",
          name: "Kalundborg",
          state_id: "962",
        },
        {
          id: "15234",
          name: "Korsor",
          state_id: "962",
        },
        {
          id: "15235",
          name: "Nykobing",
          state_id: "962",
        },
        {
          id: "15236",
          name: "Ringsted",
          state_id: "962",
        },
        {
          id: "15237",
          name: "Skalskor",
          state_id: "962",
        },
        {
          id: "15238",
          name: "Slagelse",
          state_id: "962",
        },
        {
          id: "15239",
          name: "Soro",
          state_id: "962",
        },
        {
          id: "15240",
          name: "Svebolle",
          state_id: "962",
        },
        {
          id: "15241",
          name: "Svinninge",
          state_id: "962",
        },
        {
          id: "15242",
          name: "Tollose",
          state_id: "962",
        },
        {
          id: "15243",
          name: "Vipperod",
          state_id: "962",
        },
      ],
      Viborg: [
        {
          id: "15244",
          name: "Aalestrup",
          state_id: "963",
        },
        {
          id: "15245",
          name: "Bjerringbro",
          state_id: "963",
        },
        {
          id: "15246",
          name: "Hanstholm",
          state_id: "963",
        },
        {
          id: "15247",
          name: "Hojslev",
          state_id: "963",
        },
        {
          id: "15248",
          name: "Hurup",
          state_id: "963",
        },
        {
          id: "15249",
          name: "Karup",
          state_id: "963",
        },
        {
          id: "15250",
          name: "Kjellerup",
          state_id: "963",
        },
        {
          id: "15251",
          name: "Nykobing",
          state_id: "963",
        },
        {
          id: "15252",
          name: "Skive",
          state_id: "963",
        },
        {
          id: "15253",
          name: "Stoholm",
          state_id: "963",
        },
        {
          id: "15254",
          name: "Thisted",
          state_id: "963",
        },
        {
          id: "15255",
          name: "Ulstrup",
          state_id: "963",
        },
        {
          id: "15256",
          name: "Viborg",
          state_id: "963",
        },
      ],
    },
  },
  DM: {
    name: "Dominica",
    native: "Dominica",
    phone: "1767",
    continent: "NA",
    capital: "Roseau",
    currency: "XCD",
    languages: ["en"],
    emoji: "🇩🇲",
    emojiU: "U+1F1E9 U+1F1F2",
    states: {
      "Saint Andrew": [],
      "Saint David": [],
      "Saint George": [],
      "Saint John": [],
      "Saint Joseph": [],
      "Saint Luke": [],
      "Saint Mark": [],
      "Saint Patrick": [],
      "Saint Paul": [],
      "Saint Peter": [],
    },
  },
  DO: {
    name: "Dominican Republic",
    native: "República Dominicana",
    phone: "1809,1829,1849",
    continent: "NA",
    capital: "Santo Domingo",
    currency: "DOP",
    languages: ["es"],
    emoji: "🇩🇴",
    emojiU: "U+1F1E9 U+1F1F4",
    states: {
      Azua: [
        {
          id: "15261",
          name: "Azua",
          state_id: "979",
        },
        {
          id: "15262",
          name: "Sabana Yegua",
          state_id: "979",
        },
      ],
      Bahoruco: [
        {
          id: "15263",
          name: "Neyba",
          state_id: "980",
        },
        {
          id: "15264",
          name: "Tamayo",
          state_id: "980",
        },
      ],
      Barahona: [
        {
          id: "15265",
          name: "Barahona",
          state_id: "981",
        },
        {
          id: "15266",
          name: "Cabral",
          state_id: "981",
        },
        {
          id: "15267",
          name: "El Penon",
          state_id: "981",
        },
      ],
      Dajabon: [
        {
          id: "15268",
          name: "Dajabon",
          state_id: "982",
        },
      ],
      "Distrito Nacional": [],
      Duarte: [
        {
          id: "15269",
          name: "Las Guaranas",
          state_id: "984",
        },
        {
          id: "15270",
          name: "Pimentel",
          state_id: "984",
        },
        {
          id: "15271",
          name: "San Francisco de Macoris",
          state_id: "984",
        },
      ],
      "El Seybo": [],
      "Elias Pina": [],
      Espaillat: [
        {
          id: "15272",
          name: "Moca",
          state_id: "987",
        },
      ],
      "Hato Mayor": [],
      Independencia: [
        {
          id: "15273",
          name: "Duverge",
          state_id: "989",
        },
        {
          id: "15274",
          name: "Jimani",
          state_id: "989",
        },
      ],
      "La Altagracia": [],
      "La Romana": [],
      "La Vega": [],
      "Maria Trinidad Sanchez": [],
      "Monsenor Nouel": [],
      "Monte Cristi": [],
      "Monte Plata": [],
      Pedernales: [
        {
          id: "15275",
          name: "Pedernales",
          state_id: "997",
        },
      ],
      Peravia: [
        {
          id: "15276",
          name: "Bani",
          state_id: "998",
        },
        {
          id: "15277",
          name: "Ocoa",
          state_id: "998",
        },
      ],
      "Puerto Plata": [],
      Salcedo: [
        {
          id: "15278",
          name: "Salcedo",
          state_id: "1000",
        },
      ],
      Samana: [
        {
          id: "15279",
          name: "Samana",
          state_id: "1001",
        },
        {
          id: "15280",
          name: "Sanchez",
          state_id: "1001",
        },
      ],
      "San Cristobal": [],
      "San Juan": [],
      "San Pedro de Macoris": [],
      "Sanchez Ramirez": [],
      Santiago: [
        {
          id: "15281",
          name: "Santiago",
          state_id: "1006",
        },
        {
          id: "15282",
          name: "Tamboril",
          state_id: "1006",
        },
        {
          id: "15283",
          name: "Villa Bisono",
          state_id: "1006",
        },
      ],
      "Santiago Rodriguez": [
        {
          id: "15284",
          name: "Santiago",
          state_id: "1007",
        },
        {
          id: "15285",
          name: "Tamboril",
          state_id: "1007",
        },
        {
          id: "15286",
          name: "Villa Bisono",
          state_id: "1007",
        },
      ],
      Valverde: [
        {
          id: "15287",
          name: "Esperanza",
          state_id: "1008",
        },
        {
          id: "15288",
          name: "Mao",
          state_id: "1008",
        },
      ],
    },
  },
  DZ: {
    name: "Algeria",
    native: "الجزائر",
    phone: "213",
    continent: "AF",
    capital: "Algiers",
    currency: "DZD",
    languages: ["ar"],
    emoji: "🇩🇿",
    emojiU: "U+1F1E9 U+1F1FF",
    states: {
      "Ayn Daflah": [],
      "Ayn Tamushanat": [],
      Adrar: [
        {
          id: "6087",
          name: "Adrar",
          state_id: "112",
        },
        {
          id: "6088",
          name: "Awlaf",
          state_id: "112",
        },
        {
          id: "6089",
          name: "Rijan",
          state_id: "112",
        },
        {
          id: "6090",
          name: "Timimun",
          state_id: "112",
        },
      ],
      Algiers: [
        {
          id: "6091",
          name: "Hydra",
          state_id: "113",
        },
        {
          id: "6092",
          name: "Kouba",
          state_id: "113",
        },
      ],
      Annabah: [
        {
          id: "6093",
          name: "Annabah",
          state_id: "114",
        },
        {
          id: "6094",
          name: "Birrahhal",
          state_id: "114",
        },
        {
          id: "6095",
          name: "Saraydih",
          state_id: "114",
        },
        {
          id: "6096",
          name: "Sidi Amar",
          state_id: "114",
        },
        {
          id: "6097",
          name: "al-Buni",
          state_id: "114",
        },
        {
          id: "6098",
          name: "al-Hajar",
          state_id: "114",
        },
      ],
      Bashshar: [
        {
          id: "6099",
          name: "Abadlah",
          state_id: "115",
        },
        {
          id: "6100",
          name: "Bani Wanif",
          state_id: "115",
        },
        {
          id: "6101",
          name: "Bashshar",
          state_id: "115",
        },
        {
          id: "6102",
          name: "Qanadsan",
          state_id: "115",
        },
        {
          id: "6103",
          name: "Taghit",
          state_id: "115",
        },
      ],
      Batnah: [
        {
          id: "6104",
          name: "Aris",
          state_id: "116",
        },
        {
          id: "6105",
          name: "Ayn Tutah",
          state_id: "116",
        },
        {
          id: "6106",
          name: "Barikah",
          state_id: "116",
        },
        {
          id: "6107",
          name: "Batnah",
          state_id: "116",
        },
        {
          id: "6108",
          name: "Marwanah",
          state_id: "116",
        },
        {
          id: "6109",
          name: "Naghaus",
          state_id: "116",
        },
        {
          id: "6110",
          name: "Ra''s-al-''Ayun",
          state_id: "116",
        },
        {
          id: "6111",
          name: "Tazult",
          state_id: "116",
        },
      ],
      Bijayah: [
        {
          id: "6112",
          name: "Ayt Rizin",
          state_id: "117",
        },
        {
          id: "6113",
          name: "Akbu",
          state_id: "117",
        },
        {
          id: "6114",
          name: "Amizur",
          state_id: "117",
        },
        {
          id: "6115",
          name: "Barbasha",
          state_id: "117",
        },
        {
          id: "6116",
          name: "Bijayah",
          state_id: "117",
        },
        {
          id: "6117",
          name: "Farrawn",
          state_id: "117",
        },
        {
          id: "6118",
          name: "Ighram",
          state_id: "117",
        },
        {
          id: "6119",
          name: "Sadduk",
          state_id: "117",
        },
        {
          id: "6120",
          name: "Shamini",
          state_id: "117",
        },
        {
          id: "6121",
          name: "Sidi ''Aysh",
          state_id: "117",
        },
        {
          id: "6122",
          name: "Taskaryut",
          state_id: "117",
        },
        {
          id: "6123",
          name: "Tazmalt",
          state_id: "117",
        },
        {
          id: "6124",
          name: "Timazrit",
          state_id: "117",
        },
        {
          id: "6125",
          name: "Uz-al-Laqin",
          state_id: "117",
        },
        {
          id: "6126",
          name: "al-Qasr",
          state_id: "117",
        },
      ],
      Biskrah: [
        {
          id: "6127",
          name: "Awlad Jallal",
          state_id: "118",
        },
        {
          id: "6128",
          name: "Biskrah",
          state_id: "118",
        },
        {
          id: "6129",
          name: "Sidi Khalid",
          state_id: "118",
        },
        {
          id: "6130",
          name: "Sidi Ukbah",
          state_id: "118",
        },
        {
          id: "6131",
          name: "Tulja",
          state_id: "118",
        },
        {
          id: "6132",
          name: "Um''ash",
          state_id: "118",
        },
        {
          id: "6133",
          name: "Zaribat-al-Wad",
          state_id: "118",
        },
      ],
      Blidah: [
        {
          id: "6134",
          name: "Awlad Salam",
          state_id: "119",
        },
        {
          id: "6135",
          name: "Awlad Yaysh",
          state_id: "119",
        },
        {
          id: "6136",
          name: "Bani Khalil",
          state_id: "119",
        },
        {
          id: "6137",
          name: "Bani Marad",
          state_id: "119",
        },
        {
          id: "6138",
          name: "Bani Tamu",
          state_id: "119",
        },
        {
          id: "6139",
          name: "Blidah",
          state_id: "119",
        },
        {
          id: "6140",
          name: "Bu Arfa",
          state_id: "119",
        },
        {
          id: "6141",
          name: "Bufarik",
          state_id: "119",
        },
        {
          id: "6142",
          name: "Buinan",
          state_id: "119",
        },
        {
          id: "6143",
          name: "Buqara",
          state_id: "119",
        },
        {
          id: "6144",
          name: "Maftah",
          state_id: "119",
        },
        {
          id: "6145",
          name: "Muzayah",
          state_id: "119",
        },
        {
          id: "6146",
          name: "Shabli",
          state_id: "119",
        },
        {
          id: "6147",
          name: "Shari''ah",
          state_id: "119",
        },
        {
          id: "6148",
          name: "Shiffa",
          state_id: "119",
        },
        {
          id: "6149",
          name: "Sidi Mussa",
          state_id: "119",
        },
        {
          id: "6150",
          name: "Suma",
          state_id: "119",
        },
        {
          id: "6151",
          name: "Wadi al-Allagh",
          state_id: "119",
        },
        {
          id: "6152",
          name: "al-''Afrun",
          state_id: "119",
        },
        {
          id: "6153",
          name: "al-Arba''a",
          state_id: "119",
        },
      ],
      Buirah: [
        {
          id: "6154",
          name: "Ayn Bissim",
          state_id: "120",
        },
        {
          id: "6155",
          name: "Aghbalu",
          state_id: "120",
        },
        {
          id: "6156",
          name: "Bi''r Ghabalu",
          state_id: "120",
        },
        {
          id: "6157",
          name: "Buirah",
          state_id: "120",
        },
        {
          id: "6158",
          name: "Lakhdariyah",
          state_id: "120",
        },
        {
          id: "6159",
          name: "Shurfa",
          state_id: "120",
        },
        {
          id: "6160",
          name: "Sur-al-Ghuzlan",
          state_id: "120",
        },
      ],
      Bumardas: [
        {
          id: "6161",
          name: "Ayn Tayah",
          state_id: "121",
        },
        {
          id: "6162",
          name: "Awlad Haddaj",
          state_id: "121",
        },
        {
          id: "6163",
          name: "Awlad Mussa",
          state_id: "121",
        },
        {
          id: "6164",
          name: "Bani Amran",
          state_id: "121",
        },
        {
          id: "6165",
          name: "Budwawu",
          state_id: "121",
        },
        {
          id: "6166",
          name: "Budwawu al-Bahri",
          state_id: "121",
        },
        {
          id: "6167",
          name: "Bumardas",
          state_id: "121",
        },
        {
          id: "6168",
          name: "Burj Minayal",
          state_id: "121",
        },
        {
          id: "6169",
          name: "Dalis",
          state_id: "121",
        },
        {
          id: "6170",
          name: "Hammadi",
          state_id: "121",
        },
        {
          id: "6171",
          name: "Issar",
          state_id: "121",
        },
        {
          id: "6172",
          name: "Khamis-al-Khashnah",
          state_id: "121",
        },
        {
          id: "6173",
          name: "Nasiriyah",
          state_id: "121",
        },
        {
          id: "6174",
          name: "Raghayah",
          state_id: "121",
        },
        {
          id: "6175",
          name: "Sa''abat",
          state_id: "121",
        },
        {
          id: "6176",
          name: "Tinyah",
          state_id: "121",
        },
        {
          id: "6177",
          name: "al-Arba''a Tash",
          state_id: "121",
        },
        {
          id: "6178",
          name: "ar-Ruwibah",
          state_id: "121",
        },
      ],
      "Burj Bu Arririj": [],
      Ghalizan: [
        {
          id: "6179",
          name: "Ammi Mussa",
          state_id: "123",
        },
        {
          id: "6180",
          name: "Ghalizan",
          state_id: "123",
        },
        {
          id: "6181",
          name: "Jidiwiyah",
          state_id: "123",
        },
        {
          id: "6182",
          name: "Mazunah",
          state_id: "123",
        },
        {
          id: "6183",
          name: "Sidi Muhammad Ban ''Ali",
          state_id: "123",
        },
        {
          id: "6184",
          name: "Wadi Rahiyu",
          state_id: "123",
        },
        {
          id: "6185",
          name: "Zammurah",
          state_id: "123",
        },
      ],
      Ghardayah: [
        {
          id: "6186",
          name: "Biryan",
          state_id: "124",
        },
        {
          id: "6187",
          name: "Bu Nura",
          state_id: "124",
        },
        {
          id: "6188",
          name: "Ghardaia",
          state_id: "124",
        },
        {
          id: "6189",
          name: "Ghardayah",
          state_id: "124",
        },
        {
          id: "6190",
          name: "Matlili",
          state_id: "124",
        },
        {
          id: "6191",
          name: "al-Ghuli''ah",
          state_id: "124",
        },
        {
          id: "6192",
          name: "al-Qararah",
          state_id: "124",
        },
      ],
      Ilizi: [
        {
          id: "6193",
          name: "Ilizi",
          state_id: "125",
        },
      ],
      Jijili: [
        {
          id: "6194",
          name: "Amir ''Abd-al-Qadar",
          state_id: "126",
        },
        {
          id: "6195",
          name: "Jijili",
          state_id: "126",
        },
        {
          id: "6196",
          name: "Shifka",
          state_id: "126",
        },
        {
          id: "6197",
          name: "Tahar",
          state_id: "126",
        },
        {
          id: "6198",
          name: "al-Miliyah",
          state_id: "126",
        },
      ],
      Jilfah: [
        {
          id: "6199",
          name: "Ayn Wissarah",
          state_id: "127",
        },
        {
          id: "6200",
          name: "Ayn-al-Ibil",
          state_id: "127",
        },
        {
          id: "6201",
          name: "Birin",
          state_id: "127",
        },
        {
          id: "6202",
          name: "Dar Shiyukh",
          state_id: "127",
        },
        {
          id: "6203",
          name: "Hassi Bahbah",
          state_id: "127",
        },
        {
          id: "6204",
          name: "Jilfah",
          state_id: "127",
        },
        {
          id: "6205",
          name: "Mis''ad",
          state_id: "127",
        },
        {
          id: "6206",
          name: "Sharif",
          state_id: "127",
        },
        {
          id: "6207",
          name: "al-Idrisiyah",
          state_id: "127",
        },
      ],
      Khanshalah: [
        {
          id: "6208",
          name: "Khanshalah",
          state_id: "128",
        },
        {
          id: "6209",
          name: "Sharshar",
          state_id: "128",
        },
        {
          id: "6210",
          name: "Tawziyanat",
          state_id: "128",
        },
        {
          id: "6211",
          name: "al-Mahmal",
          state_id: "128",
        },
      ],
      Masilah: [
        {
          id: "6212",
          name: "Ayn-al-Hajal",
          state_id: "129",
        },
        {
          id: "6213",
          name: "Ayn-al-Milh",
          state_id: "129",
        },
        {
          id: "6214",
          name: "Bu Sa''adah",
          state_id: "129",
        },
        {
          id: "6215",
          name: "Hammam Dhala''a",
          state_id: "129",
        },
        {
          id: "6216",
          name: "Ma''adid",
          state_id: "129",
        },
        {
          id: "6217",
          name: "Maghra",
          state_id: "129",
        },
        {
          id: "6218",
          name: "Masilah",
          state_id: "129",
        },
        {
          id: "6219",
          name: "Sidi ''Aysa",
          state_id: "129",
        },
        {
          id: "6220",
          name: "Wanugha",
          state_id: "129",
        },
      ],
      Midyah: [
        {
          id: "6221",
          name: "Ayn Bu Sif",
          state_id: "130",
        },
        {
          id: "6222",
          name: "Birwaghiyah",
          state_id: "130",
        },
        {
          id: "6223",
          name: "Midyah",
          state_id: "130",
        },
        {
          id: "6224",
          name: "Qasr-al-Bukhari",
          state_id: "130",
        },
        {
          id: "6225",
          name: "Shillalah",
          state_id: "130",
        },
        {
          id: "6226",
          name: "Tablat",
          state_id: "130",
        },
      ],
      Milah: [
        {
          id: "6227",
          name: "Farjiwah",
          state_id: "131",
        },
        {
          id: "6228",
          name: "Milah",
          state_id: "131",
        },
        {
          id: "6229",
          name: "Qararam Quqa",
          state_id: "131",
        },
        {
          id: "6230",
          name: "Ruwashad",
          state_id: "131",
        },
        {
          id: "6231",
          name: "Salghum-al-''Ayd",
          state_id: "131",
        },
        {
          id: "6232",
          name: "Sidi Maruf",
          state_id: "131",
        },
        {
          id: "6233",
          name: "Sidi Marwan",
          state_id: "131",
        },
        {
          id: "6234",
          name: "Tajananah",
          state_id: "131",
        },
        {
          id: "6235",
          name: "Talighmah",
          state_id: "131",
        },
        {
          id: "6236",
          name: "Wadi Athmaniyah",
          state_id: "131",
        },
      ],
      Muaskar: [
        {
          id: "6237",
          name: "Bu Khanifiyah",
          state_id: "132",
        },
        {
          id: "6238",
          name: "Muaskar",
          state_id: "132",
        },
        {
          id: "6239",
          name: "Muhammadiyah",
          state_id: "132",
        },
        {
          id: "6240",
          name: "Siq",
          state_id: "132",
        },
        {
          id: "6241",
          name: "Tighinnif",
          state_id: "132",
        },
        {
          id: "6242",
          name: "Wadi al-Abtal",
          state_id: "132",
        },
        {
          id: "6243",
          name: "Zahana",
          state_id: "132",
        },
      ],
      Mustaghanam: [
        {
          id: "6244",
          name: "Ayn Tadalas",
          state_id: "133",
        },
        {
          id: "6245",
          name: "Hassi Mamash",
          state_id: "133",
        },
        {
          id: "6246",
          name: "Mazaghran",
          state_id: "133",
        },
        {
          id: "6247",
          name: "Mustaghanam",
          state_id: "133",
        },
        {
          id: "6248",
          name: "Sidi Ali",
          state_id: "133",
        },
      ],
      Naama: [
        {
          id: "6249",
          name: "Ayn Safra",
          state_id: "134",
        },
        {
          id: "6250",
          name: "Mishriyah",
          state_id: "134",
        },
        {
          id: "6251",
          name: "Naama",
          state_id: "134",
        },
      ],
      Oran: [
        {
          id: "6252",
          name: "Oran",
          state_id: "135",
        },
      ],
      Ouargla: [
        {
          id: "6253",
          name: "Ouargla",
          state_id: "136",
        },
      ],
      Qalmah: [
        {
          id: "6254",
          name: "Ayn Bardah",
          state_id: "137",
        },
        {
          id: "6255",
          name: "Bumahra Ahmad",
          state_id: "137",
        },
        {
          id: "6256",
          name: "Hamman Awlad ''Ali",
          state_id: "137",
        },
        {
          id: "6257",
          name: "Qalmah",
          state_id: "137",
        },
        {
          id: "6258",
          name: "Wadi Zinati",
          state_id: "137",
        },
      ],
      Qustantinah: [
        {
          id: "6259",
          name: "Ayn Abid",
          state_id: "138",
        },
        {
          id: "6260",
          name: "Ayn Samara",
          state_id: "138",
        },
        {
          id: "6261",
          name: "Didush Murad",
          state_id: "138",
        },
        {
          id: "6262",
          name: "Hamma Bu Ziyan",
          state_id: "138",
        },
        {
          id: "6263",
          name: "Qustantinah",
          state_id: "138",
        },
        {
          id: "6264",
          name: "Zighut Yusuf",
          state_id: "138",
        },
        {
          id: "6265",
          name: "al-Khurub",
          state_id: "138",
        },
      ],
      Sakikdah: [
        {
          id: "6266",
          name: "Azzabah",
          state_id: "139",
        },
        {
          id: "6267",
          name: "Amjaz Adshish",
          state_id: "139",
        },
        {
          id: "6268",
          name: "Fil Fila",
          state_id: "139",
        },
        {
          id: "6269",
          name: "Karkira",
          state_id: "139",
        },
        {
          id: "6270",
          name: "Ramadan Jamal",
          state_id: "139",
        },
        {
          id: "6271",
          name: "Sakikdah",
          state_id: "139",
        },
        {
          id: "6272",
          name: "Shataybih",
          state_id: "139",
        },
        {
          id: "6273",
          name: "Tamalus",
          state_id: "139",
        },
        {
          id: "6274",
          name: "al-Harush",
          state_id: "139",
        },
        {
          id: "6275",
          name: "al-Qull",
          state_id: "139",
        },
      ],
      Satif: [
        {
          id: "6276",
          name: "Ayn ''Azl",
          state_id: "140",
        },
        {
          id: "6277",
          name: "Ayn Arnat",
          state_id: "140",
        },
        {
          id: "6278",
          name: "Ayn Taqrut",
          state_id: "140",
        },
        {
          id: "6279",
          name: "Ayn Wilman",
          state_id: "140",
        },
        {
          id: "6280",
          name: "Ayn-al-Khabira",
          state_id: "140",
        },
        {
          id: "6281",
          name: "Bouira",
          state_id: "140",
        },
        {
          id: "6282",
          name: "Buq''ah",
          state_id: "140",
        },
        {
          id: "6283",
          name: "Salah Bay",
          state_id: "140",
        },
        {
          id: "6284",
          name: "Satif",
          state_id: "140",
        },
        {
          id: "6285",
          name: "Setif",
          state_id: "140",
        },
        {
          id: "6286",
          name: "Ziyama Mansuriyah",
          state_id: "140",
        },
        {
          id: "6287",
          name: "al-''Ulmah",
          state_id: "140",
        },
      ],
      Sayda: [
        {
          id: "6288",
          name: "Ayn-al-Hajar",
          state_id: "141",
        },
        {
          id: "6289",
          name: "Sayda",
          state_id: "141",
        },
      ],
      "Sidi ban-al-''Abbas": [],
      "Suq Ahras": [],
      Tamanghasat: [
        {
          id: "6290",
          name: "Ayn Qazzan",
          state_id: "144",
        },
        {
          id: "6291",
          name: "Ayn Salah",
          state_id: "144",
        },
        {
          id: "6292",
          name: "Tamanghasat",
          state_id: "144",
        },
      ],
      Tibazah: [
        {
          id: "6293",
          name: "Ayn Binyan",
          state_id: "145",
        },
        {
          id: "6294",
          name: "Bu Isma''il",
          state_id: "145",
        },
        {
          id: "6295",
          name: "Bu Midfar''ah",
          state_id: "145",
        },
        {
          id: "6296",
          name: "Damus",
          state_id: "145",
        },
        {
          id: "6297",
          name: "Duwirah",
          state_id: "145",
        },
        {
          id: "6298",
          name: "Hajut",
          state_id: "145",
        },
        {
          id: "6299",
          name: "Hammam Righa",
          state_id: "145",
        },
        {
          id: "6300",
          name: "Sawlah",
          state_id: "145",
        },
        {
          id: "6301",
          name: "Shiragha",
          state_id: "145",
        },
        {
          id: "6302",
          name: "Shirshall",
          state_id: "145",
        },
        {
          id: "6303",
          name: "Sidi Farj",
          state_id: "145",
        },
        {
          id: "6304",
          name: "Stawali",
          state_id: "145",
        },
        {
          id: "6305",
          name: "Tibazah",
          state_id: "145",
        },
        {
          id: "6306",
          name: "Ziralda",
          state_id: "145",
        },
        {
          id: "6307",
          name: "al-Qull''ah",
          state_id: "145",
        },
      ],
      Tibissah: [
        {
          id: "6308",
          name: "Bi''r-al-''Itir",
          state_id: "146",
        },
        {
          id: "6309",
          name: "Hammamat",
          state_id: "146",
        },
        {
          id: "6310",
          name: "Mursut",
          state_id: "146",
        },
        {
          id: "6311",
          name: "Shariyah",
          state_id: "146",
        },
        {
          id: "6312",
          name: "Tibissah",
          state_id: "146",
        },
        {
          id: "6313",
          name: "Winzah",
          state_id: "146",
        },
        {
          id: "6314",
          name: "al-''Awaynat",
          state_id: "146",
        },
      ],
      Tilimsan: [
        {
          id: "6315",
          name: "Awlad Mimun",
          state_id: "147",
        },
        {
          id: "6316",
          name: "Bani Mastar",
          state_id: "147",
        },
        {
          id: "6317",
          name: "Bani Sikran",
          state_id: "147",
        },
        {
          id: "6318",
          name: "Ghazawat",
          state_id: "147",
        },
        {
          id: "6319",
          name: "Hannayah",
          state_id: "147",
        },
        {
          id: "6320",
          name: "Maghniyah",
          state_id: "147",
        },
        {
          id: "6321",
          name: "Nidruma",
          state_id: "147",
        },
        {
          id: "6322",
          name: "Ramsh",
          state_id: "147",
        },
        {
          id: "6323",
          name: "Sabra",
          state_id: "147",
        },
        {
          id: "6324",
          name: "Shatwan",
          state_id: "147",
        },
        {
          id: "6325",
          name: "Sibdu",
          state_id: "147",
        },
        {
          id: "6326",
          name: "Sidi ''Abdallah",
          state_id: "147",
        },
        {
          id: "6327",
          name: "Tilimsan",
          state_id: "147",
        },
        {
          id: "6328",
          name: "al-Mansurah",
          state_id: "147",
        },
      ],
      Tinduf: [
        {
          id: "6329",
          name: "Tinduf",
          state_id: "148",
        },
      ],
      Tisamsilt: [
        {
          id: "6330",
          name: "Thaniyat-al-Had",
          state_id: "149",
        },
        {
          id: "6331",
          name: "Tisamsilt",
          state_id: "149",
        },
      ],
      Tiyarat: [
        {
          id: "6332",
          name: "Ayn Dhahab",
          state_id: "150",
        },
        {
          id: "6333",
          name: "Firindah",
          state_id: "150",
        },
        {
          id: "6334",
          name: "Mahdiyah",
          state_id: "150",
        },
        {
          id: "6335",
          name: "Mashra''a Asfa",
          state_id: "150",
        },
        {
          id: "6336",
          name: "Qasr Shillalah",
          state_id: "150",
        },
        {
          id: "6337",
          name: "Rahuyah",
          state_id: "150",
        },
        {
          id: "6338",
          name: "Sughar",
          state_id: "150",
        },
        {
          id: "6339",
          name: "Takhamarat",
          state_id: "150",
        },
        {
          id: "6340",
          name: "Tiyarat",
          state_id: "150",
        },
      ],
      "Tizi Wazu": [],
      "Umm-al-Bawaghi": [
        {
          id: "6341",
          name: "Ayn Bayda",
          state_id: "152",
        },
        {
          id: "6342",
          name: "Ayn Fakrun",
          state_id: "152",
        },
        {
          id: "6343",
          name: "Ayn Kirshah",
          state_id: "152",
        },
        {
          id: "6344",
          name: "Ayn Malilah",
          state_id: "152",
        },
        {
          id: "6345",
          name: "Bi''r Shuhada",
          state_id: "152",
        },
        {
          id: "6346",
          name: "Miskyanah",
          state_id: "152",
        },
        {
          id: "6347",
          name: "Shamurah",
          state_id: "152",
        },
        {
          id: "6348",
          name: "Umm-al-Bawaghi",
          state_id: "152",
        },
      ],
      Wahran: [
        {
          id: "6349",
          name: "Ayn Biya",
          state_id: "153",
        },
        {
          id: "6350",
          name: "Ayn-at-Turk",
          state_id: "153",
        },
        {
          id: "6351",
          name: "Arzu",
          state_id: "153",
        },
        {
          id: "6352",
          name: "Bi''r-al-Jir",
          state_id: "153",
        },
        {
          id: "6353",
          name: "Butlilis",
          state_id: "153",
        },
        {
          id: "6354",
          name: "Hassi Bu Nif",
          state_id: "153",
        },
        {
          id: "6355",
          name: "Mars-al-Kabir",
          state_id: "153",
        },
        {
          id: "6356",
          name: "Qadayal",
          state_id: "153",
        },
        {
          id: "6357",
          name: "Sidi ash-Shami",
          state_id: "153",
        },
        {
          id: "6358",
          name: "Wadi Thalatha",
          state_id: "153",
        },
        {
          id: "6359",
          name: "Wahran",
          state_id: "153",
        },
        {
          id: "6360",
          name: "al-Ansur",
          state_id: "153",
        },
        {
          id: "6361",
          name: "as-Saniyah",
          state_id: "153",
        },
      ],
      Warqla: [
        {
          id: "6362",
          name: "Hassi Mas''ud",
          state_id: "154",
        },
        {
          id: "6363",
          name: "Nazla",
          state_id: "154",
        },
        {
          id: "6364",
          name: "Ruwisiyat",
          state_id: "154",
        },
        {
          id: "6365",
          name: "Tabisbast",
          state_id: "154",
        },
        {
          id: "6366",
          name: "Tamalhat",
          state_id: "154",
        },
        {
          id: "6367",
          name: "Tamasin",
          state_id: "154",
        },
        {
          id: "6368",
          name: "Tayabat-al-Janubiyah",
          state_id: "154",
        },
        {
          id: "6369",
          name: "Tughghurt",
          state_id: "154",
        },
        {
          id: "6370",
          name: "Warqla",
          state_id: "154",
        },
        {
          id: "6371",
          name: "al-Hajirah",
          state_id: "154",
        },
      ],
      "Wilaya d Alger": [],
      "Wilaya de Bejaia": [],
      "Wilaya de Constantine": [],
      "al-Aghwat": [
        {
          id: "6372",
          name: "Aflu",
          state_id: "158",
        },
        {
          id: "6373",
          name: "Hassi al-Raml",
          state_id: "158",
        },
        {
          id: "6374",
          name: "al-Aghwat",
          state_id: "158",
        },
      ],
      "al-Bayadh": [
        {
          id: "6375",
          name: "Brizyanah",
          state_id: "159",
        },
        {
          id: "6376",
          name: "al-Abyad Sidi Shaykh",
          state_id: "159",
        },
        {
          id: "6377",
          name: "al-Bayadh",
          state_id: "159",
        },
      ],
      "al-Jaza''ir": [
        {
          id: "6378",
          name: "Bab Azwar",
          state_id: "160",
        },
        {
          id: "6379",
          name: "Baraki",
          state_id: "160",
        },
        {
          id: "6380",
          name: "Bir Murad Rais",
          state_id: "160",
        },
        {
          id: "6381",
          name: "Birkhadam",
          state_id: "160",
        },
        {
          id: "6382",
          name: "Burj-al-Kiffan",
          state_id: "160",
        },
        {
          id: "6383",
          name: "Dar-al-Bayda",
          state_id: "160",
        },
        {
          id: "6384",
          name: "al-Jaza''ir",
          state_id: "160",
        },
      ],
      "al-Wad": [
        {
          id: "6385",
          name: "Bayadha",
          state_id: "161",
        },
        {
          id: "6386",
          name: "Dabilah",
          state_id: "161",
        },
        {
          id: "6387",
          name: "Hassan ''Abd-al-Karim",
          state_id: "161",
        },
        {
          id: "6388",
          name: "Hassi Halifa",
          state_id: "161",
        },
        {
          id: "6389",
          name: "Jama''a",
          state_id: "161",
        },
        {
          id: "6390",
          name: "Maqran",
          state_id: "161",
        },
        {
          id: "6391",
          name: "Qamar",
          state_id: "161",
        },
        {
          id: "6392",
          name: "Raqiba",
          state_id: "161",
        },
        {
          id: "6393",
          name: "Rubbah",
          state_id: "161",
        },
        {
          id: "6394",
          name: "Sidi Amran",
          state_id: "161",
        },
        {
          id: "6395",
          name: "al-Mighair",
          state_id: "161",
        },
        {
          id: "6396",
          name: "al-Wad",
          state_id: "161",
        },
      ],
      "ash-Shalif": [
        {
          id: "6397",
          name: "Ayn Maran",
          state_id: "162",
        },
        {
          id: "6398",
          name: "Abu al-Hassan",
          state_id: "162",
        },
        {
          id: "6399",
          name: "Bani Hawa",
          state_id: "162",
        },
        {
          id: "6400",
          name: "Bu Qadir",
          state_id: "162",
        },
        {
          id: "6401",
          name: "Sidi Ukaskah",
          state_id: "162",
        },
        {
          id: "6402",
          name: "Tanas",
          state_id: "162",
        },
        {
          id: "6403",
          name: "Wadi Sali",
          state_id: "162",
        },
        {
          id: "6404",
          name: "Wadi al-Fiddah",
          state_id: "162",
        },
        {
          id: "6405",
          name: "ash-Shalif",
          state_id: "162",
        },
        {
          id: "6406",
          name: "ash-Shattiyah",
          state_id: "162",
        },
      ],
      "at-Tarif": [
        {
          id: "6407",
          name: "Ban Mahdi",
          state_id: "163",
        },
        {
          id: "6408",
          name: "Bani Amar",
          state_id: "163",
        },
        {
          id: "6409",
          name: "Basbas",
          state_id: "163",
        },
        {
          id: "6410",
          name: "Dariyan",
          state_id: "163",
        },
        {
          id: "6411",
          name: "Saba''ita Muk",
          state_id: "163",
        },
        {
          id: "6412",
          name: "al-Qal''ah",
          state_id: "163",
        },
        {
          id: "6413",
          name: "at-Tarif",
          state_id: "163",
        },
      ],
    },
  },
  EC: {
    name: "Ecuador",
    native: "Ecuador",
    phone: "593",
    continent: "SA",
    capital: "Quito",
    currency: "USD",
    languages: ["es"],
    emoji: "🇪🇨",
    emojiU: "U+1F1EA U+1F1E8",
    states: {
      Azuay: [
        {
          id: "15307",
          name: "Cuenca",
          state_id: "1022",
        },
        {
          id: "15308",
          name: "Gualaceo",
          state_id: "1022",
        },
      ],
      Bolivar: [
        {
          id: "15309",
          name: "Guaranda",
          state_id: "1023",
        },
        {
          id: "15310",
          name: "San Miguel",
          state_id: "1023",
        },
      ],
      Canar: [
        {
          id: "15311",
          name: "Azogues",
          state_id: "1024",
        },
        {
          id: "15312",
          name: "Canar",
          state_id: "1024",
        },
        {
          id: "15313",
          name: "La Troncal",
          state_id: "1024",
        },
      ],
      Carchi: [
        {
          id: "15314",
          name: "El Angel",
          state_id: "1025",
        },
        {
          id: "15315",
          name: "San Gabriel",
          state_id: "1025",
        },
        {
          id: "15316",
          name: "Tulcan",
          state_id: "1025",
        },
      ],
      Chimborazo: [
        {
          id: "15317",
          name: "Alausi",
          state_id: "1026",
        },
        {
          id: "15318",
          name: "Guano",
          state_id: "1026",
        },
        {
          id: "15319",
          name: "Riobamba",
          state_id: "1026",
        },
      ],
      Cotopaxi: [
        {
          id: "15320",
          name: "La Mana",
          state_id: "1027",
        },
        {
          id: "15321",
          name: "Latacunga",
          state_id: "1027",
        },
        {
          id: "15322",
          name: "Pujili",
          state_id: "1027",
        },
        {
          id: "15323",
          name: "San Miguel",
          state_id: "1027",
        },
        {
          id: "15324",
          name: "Saquisili",
          state_id: "1027",
        },
      ],
      "El Oro": [],
      Esmeraldas: [
        {
          id: "15325",
          name: "Esmeraldas",
          state_id: "1029",
        },
        {
          id: "15326",
          name: "Muisne",
          state_id: "1029",
        },
        {
          id: "15327",
          name: "Rosa Zarate",
          state_id: "1029",
        },
        {
          id: "15328",
          name: "San Lorenzo",
          state_id: "1029",
        },
        {
          id: "15329",
          name: "Valdez",
          state_id: "1029",
        },
      ],
      Galapagos: [
        {
          id: "15330",
          name: "Puerto Ayora",
          state_id: "1030",
        },
        {
          id: "15331",
          name: "Puerto Baquerizo Moreno",
          state_id: "1030",
        },
        {
          id: "15332",
          name: "San Cristobal",
          state_id: "1030",
        },
      ],
      Guayas: [
        {
          id: "15333",
          name: "Alfredo Baquerizo Moreno",
          state_id: "1031",
        },
        {
          id: "15334",
          name: "Balao",
          state_id: "1031",
        },
        {
          id: "15335",
          name: "Balzar",
          state_id: "1031",
        },
        {
          id: "15336",
          name: "Colimes",
          state_id: "1031",
        },
        {
          id: "15337",
          name: "Coronel Mariduena",
          state_id: "1031",
        },
        {
          id: "15338",
          name: "Daule",
          state_id: "1031",
        },
        {
          id: "15339",
          name: "El Salitre",
          state_id: "1031",
        },
        {
          id: "15340",
          name: "El Triunfo",
          state_id: "1031",
        },
        {
          id: "15341",
          name: "Eloy Alfaro",
          state_id: "1031",
        },
        {
          id: "15342",
          name: "Guayaquil",
          state_id: "1031",
        },
        {
          id: "15343",
          name: "La Libertad",
          state_id: "1031",
        },
        {
          id: "15344",
          name: "Lomas de Sargentillo",
          state_id: "1031",
        },
        {
          id: "15345",
          name: "Mapasingue",
          state_id: "1031",
        },
        {
          id: "15346",
          name: "Milagro",
          state_id: "1031",
        },
        {
          id: "15347",
          name: "Naranjal",
          state_id: "1031",
        },
        {
          id: "15348",
          name: "Naranjito",
          state_id: "1031",
        },
        {
          id: "15349",
          name: "Palestina",
          state_id: "1031",
        },
        {
          id: "15350",
          name: "Pedro Carbo",
          state_id: "1031",
        },
        {
          id: "15351",
          name: "Playas",
          state_id: "1031",
        },
        {
          id: "15352",
          name: "Salinas",
          state_id: "1031",
        },
        {
          id: "15353",
          name: "Samborondon",
          state_id: "1031",
        },
        {
          id: "15354",
          name: "Santa Elena",
          state_id: "1031",
        },
        {
          id: "15355",
          name: "Santa Lucia",
          state_id: "1031",
        },
        {
          id: "15356",
          name: "Velasco Ibarra",
          state_id: "1031",
        },
        {
          id: "15357",
          name: "Yaguachi",
          state_id: "1031",
        },
      ],
      Imbabura: [
        {
          id: "15358",
          name: "Atuntaqui",
          state_id: "1032",
        },
        {
          id: "15359",
          name: "Cotacachi",
          state_id: "1032",
        },
        {
          id: "15360",
          name: "Ibarra",
          state_id: "1032",
        },
        {
          id: "15361",
          name: "Otavalo",
          state_id: "1032",
        },
        {
          id: "15362",
          name: "Pimampiro",
          state_id: "1032",
        },
      ],
      Loja: [
        {
          id: "15363",
          name: "Alamor",
          state_id: "1033",
        },
        {
          id: "15364",
          name: "Cariamanga",
          state_id: "1033",
        },
        {
          id: "15365",
          name: "Catacocha",
          state_id: "1033",
        },
        {
          id: "15366",
          name: "Catamayo",
          state_id: "1033",
        },
        {
          id: "15367",
          name: "Celica",
          state_id: "1033",
        },
        {
          id: "15368",
          name: "Loja",
          state_id: "1033",
        },
        {
          id: "15369",
          name: "Macara",
          state_id: "1033",
        },
      ],
      "Los Rios": [],
      Manabi: [
        {
          id: "15370",
          name: "Bahia de Caraquez",
          state_id: "1035",
        },
        {
          id: "15371",
          name: "Calceta",
          state_id: "1035",
        },
        {
          id: "15372",
          name: "Chone",
          state_id: "1035",
        },
        {
          id: "15373",
          name: "El Carmen",
          state_id: "1035",
        },
        {
          id: "15374",
          name: "Jipijapa",
          state_id: "1035",
        },
        {
          id: "15375",
          name: "Junin",
          state_id: "1035",
        },
        {
          id: "15376",
          name: "Manta",
          state_id: "1035",
        },
        {
          id: "15377",
          name: "Montecristi",
          state_id: "1035",
        },
        {
          id: "15378",
          name: "Pajan",
          state_id: "1035",
        },
        {
          id: "15379",
          name: "Pedernales",
          state_id: "1035",
        },
        {
          id: "15380",
          name: "Portoviejo",
          state_id: "1035",
        },
        {
          id: "15381",
          name: "Rocafuerte",
          state_id: "1035",
        },
        {
          id: "15382",
          name: "Santa Ana",
          state_id: "1035",
        },
        {
          id: "15383",
          name: "Sucre",
          state_id: "1035",
        },
        {
          id: "15384",
          name: "Tosagua",
          state_id: "1035",
        },
      ],
      "Morona Santiago": [],
      Napo: [
        {
          id: "15385",
          name: "Archidona",
          state_id: "1037",
        },
        {
          id: "15386",
          name: "Tena",
          state_id: "1037",
        },
      ],
      Orellana: [
        {
          id: "15387",
          name: "Orellana",
          state_id: "1038",
        },
      ],
      Pastaza: [
        {
          id: "15388",
          name: "Puyo",
          state_id: "1039",
        },
      ],
      Pichincha: [
        {
          id: "15389",
          name: "Cayambe",
          state_id: "1040",
        },
        {
          id: "15390",
          name: "Machachi",
          state_id: "1040",
        },
        {
          id: "15391",
          name: "Quito",
          state_id: "1040",
        },
        {
          id: "15392",
          name: "Sangolqui",
          state_id: "1040",
        },
        {
          id: "15393",
          name: "Santo Domingo",
          state_id: "1040",
        },
      ],
      Sucumbios: [
        {
          id: "15394",
          name: "Nueva Loja",
          state_id: "1041",
        },
        {
          id: "15395",
          name: "Shushufindi",
          state_id: "1041",
        },
      ],
      Tungurahua: [
        {
          id: "15396",
          name: "Ambato",
          state_id: "1042",
        },
        {
          id: "15397",
          name: "Banos",
          state_id: "1042",
        },
        {
          id: "15398",
          name: "Pelileo",
          state_id: "1042",
        },
        {
          id: "15399",
          name: "Pillaro",
          state_id: "1042",
        },
      ],
      "Zamora Chinchipe": [],
    },
  },
  EE: {
    name: "Estonia",
    native: "Eesti",
    phone: "372",
    continent: "EU",
    capital: "Tallinn",
    currency: "EUR",
    languages: ["et"],
    emoji: "🇪🇪",
    emojiU: "U+1F1EA U+1F1EA",
    states: {
      Harju: [
        {
          id: "15685",
          name: "Aasmae",
          state_id: "1104",
        },
        {
          id: "15686",
          name: "Aaviku",
          state_id: "1104",
        },
        {
          id: "15687",
          name: "Aegviidu",
          state_id: "1104",
        },
        {
          id: "15688",
          name: "Aigrumae",
          state_id: "1104",
        },
        {
          id: "15689",
          name: "Aila",
          state_id: "1104",
        },
        {
          id: "15690",
          name: "Alavere",
          state_id: "1104",
        },
        {
          id: "15691",
          name: "Alliku",
          state_id: "1104",
        },
        {
          id: "15692",
          name: "Amari",
          state_id: "1104",
        },
        {
          id: "15693",
          name: "Anija",
          state_id: "1104",
        },
        {
          id: "15694",
          name: "Ardu",
          state_id: "1104",
        },
        {
          id: "15695",
          name: "Arukula",
          state_id: "1104",
        },
        {
          id: "15696",
          name: "Aruvalla",
          state_id: "1104",
        },
        {
          id: "15697",
          name: "Assaku",
          state_id: "1104",
        },
        {
          id: "15698",
          name: "Ellamaa",
          state_id: "1104",
        },
        {
          id: "15699",
          name: "Haabneeme",
          state_id: "1104",
        },
        {
          id: "15700",
          name: "Habaja",
          state_id: "1104",
        },
        {
          id: "15701",
          name: "Haiba",
          state_id: "1104",
        },
        {
          id: "15702",
          name: "Haljava",
          state_id: "1104",
        },
        {
          id: "15703",
          name: "Hara",
          state_id: "1104",
        },
        {
          id: "15704",
          name: "Harju-Risti",
          state_id: "1104",
        },
        {
          id: "15705",
          name: "Harku",
          state_id: "1104",
        },
        {
          id: "15706",
          name: "Harkujarve",
          state_id: "1104",
        },
        {
          id: "15707",
          name: "Harma",
          state_id: "1104",
        },
        {
          id: "15708",
          name: "Huuru",
          state_id: "1104",
        },
        {
          id: "15709",
          name: "Ilmandu",
          state_id: "1104",
        },
        {
          id: "15710",
          name: "Iru",
          state_id: "1104",
        },
        {
          id: "15711",
          name: "Jagala",
          state_id: "1104",
        },
        {
          id: "15712",
          name: "Jalgimae",
          state_id: "1104",
        },
        {
          id: "15713",
          name: "Jarsi",
          state_id: "1104",
        },
        {
          id: "15714",
          name: "Jarvekula",
          state_id: "1104",
        },
        {
          id: "15715",
          name: "Jogisoo",
          state_id: "1104",
        },
        {
          id: "15716",
          name: "Juri",
          state_id: "1104",
        },
        {
          id: "15717",
          name: "Kaasiku",
          state_id: "1104",
        },
        {
          id: "15718",
          name: "Kaberneeme",
          state_id: "1104",
        },
        {
          id: "15719",
          name: "Kahala",
          state_id: "1104",
        },
        {
          id: "15720",
          name: "Kalesi",
          state_id: "1104",
        },
        {
          id: "15721",
          name: "Kallavere",
          state_id: "1104",
        },
        {
          id: "15722",
          name: "Karjakula",
          state_id: "1104",
        },
        {
          id: "15723",
          name: "Karla",
          state_id: "1104",
        },
        {
          id: "15724",
          name: "Kasepere",
          state_id: "1104",
        },
        {
          id: "15725",
          name: "Kasispea",
          state_id: "1104",
        },
        {
          id: "15726",
          name: "Kehra",
          state_id: "1104",
        },
        {
          id: "15727",
          name: "Keila",
          state_id: "1104",
        },
        {
          id: "15728",
          name: "Keila-Joa",
          state_id: "1104",
        },
        {
          id: "15729",
          name: "Kelvingi",
          state_id: "1104",
        },
        {
          id: "15730",
          name: "Kiia",
          state_id: "1104",
        },
        {
          id: "15731",
          name: "Kiili",
          state_id: "1104",
        },
        {
          id: "15732",
          name: "Kiisa",
          state_id: "1104",
        },
        {
          id: "15733",
          name: "Kiiu",
          state_id: "1104",
        },
        {
          id: "15734",
          name: "Klooga",
          state_id: "1104",
        },
        {
          id: "15735",
          name: "Kloogaranna",
          state_id: "1104",
        },
        {
          id: "15736",
          name: "Kohatu",
          state_id: "1104",
        },
        {
          id: "15737",
          name: "Kolga",
          state_id: "1104",
        },
        {
          id: "15738",
          name: "Kolga-Aabla",
          state_id: "1104",
        },
        {
          id: "15739",
          name: "Kolgakula",
          state_id: "1104",
        },
        {
          id: "15740",
          name: "Konnu",
          state_id: "1104",
        },
        {
          id: "15741",
          name: "Kose",
          state_id: "1104",
        },
        {
          id: "15742",
          name: "Kose-Uuemoisa",
          state_id: "1104",
        },
        {
          id: "15743",
          name: "Kostivere",
          state_id: "1104",
        },
        {
          id: "15744",
          name: "Krei",
          state_id: "1104",
        },
        {
          id: "15745",
          name: "Kuivajoe",
          state_id: "1104",
        },
        {
          id: "15746",
          name: "Kumna",
          state_id: "1104",
        },
        {
          id: "15747",
          name: "Kurtna",
          state_id: "1104",
        },
        {
          id: "15748",
          name: "Kuusalu",
          state_id: "1104",
        },
        {
          id: "15749",
          name: "Laabi",
          state_id: "1104",
        },
        {
          id: "15750",
          name: "Laagri",
          state_id: "1104",
        },
        {
          id: "15751",
          name: "Lagedi",
          state_id: "1104",
        },
        {
          id: "15752",
          name: "Laitse",
          state_id: "1104",
        },
        {
          id: "15753",
          name: "Laulasmaa",
          state_id: "1104",
        },
        {
          id: "15754",
          name: "Lehetu",
          state_id: "1104",
        },
        {
          id: "15755",
          name: "Lehola",
          state_id: "1104",
        },
        {
          id: "15756",
          name: "Lehtmetsa",
          state_id: "1104",
        },
        {
          id: "15757",
          name: "Leppneeme",
          state_id: "1104",
        },
        {
          id: "15758",
          name: "Liikva",
          state_id: "1104",
        },
        {
          id: "15759",
          name: "Lilli",
          state_id: "1104",
        },
        {
          id: "15760",
          name: "Lohusalu",
          state_id: "1104",
        },
        {
          id: "15761",
          name: "Loksa",
          state_id: "1104",
        },
        {
          id: "15762",
          name: "Lokuti",
          state_id: "1104",
        },
        {
          id: "15763",
          name: "Loo",
          state_id: "1104",
        },
        {
          id: "15764",
          name: "Lubja",
          state_id: "1104",
        },
        {
          id: "15765",
          name: "Luige",
          state_id: "1104",
        },
        {
          id: "15766",
          name: "Maardu",
          state_id: "1104",
        },
        {
          id: "15767",
          name: "Maidla",
          state_id: "1104",
        },
        {
          id: "15768",
          name: "Manniku",
          state_id: "1104",
        },
        {
          id: "15769",
          name: "Metsakasti",
          state_id: "1104",
        },
        {
          id: "15770",
          name: "Metsanurme",
          state_id: "1104",
        },
        {
          id: "15771",
          name: "Miiduranna",
          state_id: "1104",
        },
        {
          id: "15772",
          name: "Munalaskme",
          state_id: "1104",
        },
        {
          id: "15773",
          name: "Muraste",
          state_id: "1104",
        },
        {
          id: "15774",
          name: "Muuga",
          state_id: "1104",
        },
        {
          id: "15775",
          name: "Nabala",
          state_id: "1104",
        },
        {
          id: "15776",
          name: "Neeme",
          state_id: "1104",
        },
        {
          id: "15777",
          name: "Ohtu",
          state_id: "1104",
        },
        {
          id: "15778",
          name: "Ojasoo",
          state_id: "1104",
        },
        {
          id: "15779",
          name: "Oru",
          state_id: "1104",
        },
        {
          id: "15780",
          name: "Padise",
          state_id: "1104",
        },
        {
          id: "15781",
          name: "Pae",
          state_id: "1104",
        },
        {
          id: "15782",
          name: "Paekna",
          state_id: "1104",
        },
        {
          id: "15783",
          name: "Pajupea",
          state_id: "1104",
        },
        {
          id: "15784",
          name: "Paldiski",
          state_id: "1104",
        },
        {
          id: "15785",
          name: "Palvere",
          state_id: "1104",
        },
        {
          id: "15786",
          name: "Parispea",
          state_id: "1104",
        },
        {
          id: "15787",
          name: "Patika",
          state_id: "1104",
        },
        {
          id: "15788",
          name: "Paunkula",
          state_id: "1104",
        },
        {
          id: "15789",
          name: "Peetri",
          state_id: "1104",
        },
        {
          id: "15790",
          name: "Peningi",
          state_id: "1104",
        },
        {
          id: "15791",
          name: "Perila",
          state_id: "1104",
        },
        {
          id: "15792",
          name: "Pikva",
          state_id: "1104",
        },
        {
          id: "15793",
          name: "Pillapalu",
          state_id: "1104",
        },
        {
          id: "15794",
          name: "Pringi",
          state_id: "1104",
        },
        {
          id: "15795",
          name: "Puunsi",
          state_id: "1104",
        },
        {
          id: "15796",
          name: "Raasiku",
          state_id: "1104",
        },
        {
          id: "15797",
          name: "Rae",
          state_id: "1104",
        },
        {
          id: "15798",
          name: "Randvere",
          state_id: "1104",
        },
        {
          id: "15799",
          name: "Rannamoisa",
          state_id: "1104",
        },
        {
          id: "15800",
          name: "Ravila",
          state_id: "1104",
        },
        {
          id: "15801",
          name: "Riisipere",
          state_id: "1104",
        },
        {
          id: "15802",
          name: "Rohuneeme",
          state_id: "1104",
        },
        {
          id: "15803",
          name: "Roobuka",
          state_id: "1104",
        },
        {
          id: "15804",
          name: "Ruila",
          state_id: "1104",
        },
        {
          id: "15805",
          name: "Rummu",
          state_id: "1104",
        },
        {
          id: "15806",
          name: "Saha",
          state_id: "1104",
        },
        {
          id: "15807",
          name: "Saku",
          state_id: "1104",
        },
        {
          id: "15808",
          name: "Saue",
          state_id: "1104",
        },
        {
          id: "15809",
          name: "Saula",
          state_id: "1104",
        },
        {
          id: "15810",
          name: "Saunja",
          state_id: "1104",
        },
        {
          id: "15811",
          name: "Suurpea",
          state_id: "1104",
        },
        {
          id: "15812",
          name: "Suurupi",
          state_id: "1104",
        },
        {
          id: "15813",
          name: "Tabasalu",
          state_id: "1104",
        },
        {
          id: "15814",
          name: "Tagadi",
          state_id: "1104",
        },
        {
          id: "15815",
          name: "Tagametsa",
          state_id: "1104",
        },
        {
          id: "15816",
          name: "Tallinn",
          state_id: "1104",
        },
        {
          id: "15817",
          name: "Tammneeme",
          state_id: "1104",
        },
        {
          id: "15818",
          name: "Tiskre",
          state_id: "1104",
        },
        {
          id: "15819",
          name: "Todva",
          state_id: "1104",
        },
        {
          id: "15820",
          name: "Turba",
          state_id: "1104",
        },
        {
          id: "15821",
          name: "Turisalu",
          state_id: "1104",
        },
        {
          id: "15822",
          name: "Tutermaa",
          state_id: "1104",
        },
        {
          id: "15823",
          name: "Tuula",
          state_id: "1104",
        },
        {
          id: "15824",
          name: "Tuulna",
          state_id: "1104",
        },
        {
          id: "15825",
          name: "Uksnurme",
          state_id: "1104",
        },
        {
          id: "15826",
          name: "Ulejoe",
          state_id: "1104",
        },
        {
          id: "15827",
          name: "Uuri",
          state_id: "1104",
        },
        {
          id: "15828",
          name: "Uuskula",
          state_id: "1104",
        },
        {
          id: "15829",
          name: "Vaana",
          state_id: "1104",
        },
        {
          id: "15830",
          name: "Vaana-Joesuu",
          state_id: "1104",
        },
        {
          id: "15831",
          name: "Vaida",
          state_id: "1104",
        },
        {
          id: "15832",
          name: "Vaidasoo",
          state_id: "1104",
        },
        {
          id: "15833",
          name: "Valingu",
          state_id: "1104",
        },
        {
          id: "15834",
          name: "Valkla",
          state_id: "1104",
        },
        {
          id: "15835",
          name: "Vanamoisa",
          state_id: "1104",
        },
        {
          id: "15836",
          name: "Vardja",
          state_id: "1104",
        },
        {
          id: "15837",
          name: "Vasalemma",
          state_id: "1104",
        },
        {
          id: "15838",
          name: "Vaskjala",
          state_id: "1104",
        },
        {
          id: "15839",
          name: "Vatsla",
          state_id: "1104",
        },
        {
          id: "15840",
          name: "Veskikula",
          state_id: "1104",
        },
        {
          id: "15841",
          name: "Vihasoo",
          state_id: "1104",
        },
        {
          id: "15842",
          name: "Viimsi",
          state_id: "1104",
        },
        {
          id: "15843",
          name: "Viinistu",
          state_id: "1104",
        },
        {
          id: "15844",
          name: "Viti",
          state_id: "1104",
        },
      ],
      Hiiu: [
        {
          id: "15845",
          name: "Emmaste",
          state_id: "1105",
        },
        {
          id: "15846",
          name: "Jausa",
          state_id: "1105",
        },
        {
          id: "15847",
          name: "Kaina",
          state_id: "1105",
        },
        {
          id: "15848",
          name: "Kardla",
          state_id: "1105",
        },
        {
          id: "15849",
          name: "Korgessaare",
          state_id: "1105",
        },
        {
          id: "15850",
          name: "Lauka",
          state_id: "1105",
        },
        {
          id: "15851",
          name: "Lope",
          state_id: "1105",
        },
        {
          id: "15852",
          name: "Mannamaa",
          state_id: "1105",
        },
        {
          id: "15853",
          name: "Putkaste",
          state_id: "1105",
        },
        {
          id: "15854",
          name: "Suuremoisa",
          state_id: "1105",
        },
      ],
      "Ida-Viru": [
        {
          id: "15855",
          name: "Aa",
          state_id: "1106",
        },
        {
          id: "15856",
          name: "Alajoe",
          state_id: "1106",
        },
        {
          id: "15857",
          name: "Aseri",
          state_id: "1106",
        },
        {
          id: "15858",
          name: "Avinurme",
          state_id: "1106",
        },
        {
          id: "15859",
          name: "Edise",
          state_id: "1106",
        },
        {
          id: "15860",
          name: "Erra",
          state_id: "1106",
        },
        {
          id: "15861",
          name: "Iisaku",
          state_id: "1106",
        },
        {
          id: "15862",
          name: "Jarve",
          state_id: "1106",
        },
        {
          id: "15863",
          name: "Johvi",
          state_id: "1106",
        },
        {
          id: "15864",
          name: "Kahula",
          state_id: "1106",
        },
        {
          id: "15865",
          name: "Kiikla",
          state_id: "1106",
        },
        {
          id: "15866",
          name: "Kivioli",
          state_id: "1106",
        },
        {
          id: "15867",
          name: "Kohtla-Jarve",
          state_id: "1106",
        },
        {
          id: "15868",
          name: "Kohtla-Nomme",
          state_id: "1106",
        },
        {
          id: "15869",
          name: "Konju",
          state_id: "1106",
        },
        {
          id: "15870",
          name: "Kose",
          state_id: "1106",
        },
        {
          id: "15871",
          name: "Kuremae",
          state_id: "1106",
        },
        {
          id: "15872",
          name: "Kurtna",
          state_id: "1106",
        },
        {
          id: "15873",
          name: "Lohusuu",
          state_id: "1106",
        },
        {
          id: "15874",
          name: "Luganuse",
          state_id: "1106",
        },
        {
          id: "15875",
          name: "Maetaguse",
          state_id: "1106",
        },
        {
          id: "15876",
          name: "Maidla",
          state_id: "1106",
        },
        {
          id: "15877",
          name: "Narva",
          state_id: "1106",
        },
        {
          id: "15878",
          name: "Narva-Joesuu",
          state_id: "1106",
        },
        {
          id: "15879",
          name: "Olgina",
          state_id: "1106",
        },
        {
          id: "15880",
          name: "Pagari",
          state_id: "1106",
        },
        {
          id: "15881",
          name: "Puhajoe",
          state_id: "1106",
        },
        {
          id: "15882",
          name: "Purtse",
          state_id: "1106",
        },
        {
          id: "15883",
          name: "Pussi",
          state_id: "1106",
        },
        {
          id: "15884",
          name: "Rannu",
          state_id: "1106",
        },
        {
          id: "15885",
          name: "Saka",
          state_id: "1106",
        },
        {
          id: "15886",
          name: "Savala",
          state_id: "1106",
        },
        {
          id: "15887",
          name: "Sillamae",
          state_id: "1106",
        },
        {
          id: "15888",
          name: "Sinimae",
          state_id: "1106",
        },
        {
          id: "15889",
          name: "Soldina",
          state_id: "1106",
        },
        {
          id: "15890",
          name: "Sompa",
          state_id: "1106",
        },
        {
          id: "15891",
          name: "Sonda",
          state_id: "1106",
        },
        {
          id: "15892",
          name: "Tammiku",
          state_id: "1106",
        },
        {
          id: "15893",
          name: "Toila",
          state_id: "1106",
        },
        {
          id: "15894",
          name: "Tudulinna",
          state_id: "1106",
        },
        {
          id: "15895",
          name: "Ulvi",
          state_id: "1106",
        },
        {
          id: "15896",
          name: "Vaivara",
          state_id: "1106",
        },
        {
          id: "15897",
          name: "Varja",
          state_id: "1106",
        },
        {
          id: "15898",
          name: "Vasavere",
          state_id: "1106",
        },
        {
          id: "15899",
          name: "Voka",
          state_id: "1106",
        },
      ],
      Jarva: [
        {
          id: "15900",
          name: "Ahula",
          state_id: "1107",
        },
        {
          id: "15901",
          name: "Aiamaa",
          state_id: "1107",
        },
        {
          id: "15902",
          name: "Albu",
          state_id: "1107",
        },
        {
          id: "15903",
          name: "Ambla",
          state_id: "1107",
        },
        {
          id: "15904",
          name: "Anari",
          state_id: "1107",
        },
        {
          id: "15905",
          name: "Anna",
          state_id: "1107",
        },
        {
          id: "15906",
          name: "Aravete",
          state_id: "1107",
        },
        {
          id: "15907",
          name: "Ervita",
          state_id: "1107",
        },
        {
          id: "15908",
          name: "Imavere",
          state_id: "1107",
        },
        {
          id: "15909",
          name: "Janeda",
          state_id: "1107",
        },
        {
          id: "15910",
          name: "Jarva-Jaani",
          state_id: "1107",
        },
        {
          id: "15911",
          name: "Jogisoo",
          state_id: "1107",
        },
        {
          id: "15912",
          name: "Jootme",
          state_id: "1107",
        },
        {
          id: "15913",
          name: "Kaalepi",
          state_id: "1107",
        },
        {
          id: "15914",
          name: "Kabala",
          state_id: "1107",
        },
        {
          id: "15915",
          name: "Kahala",
          state_id: "1107",
        },
        {
          id: "15916",
          name: "Karavete",
          state_id: "1107",
        },
        {
          id: "15917",
          name: "Karevere",
          state_id: "1107",
        },
        {
          id: "15918",
          name: "Karinu",
          state_id: "1107",
        },
        {
          id: "15919",
          name: "Kasukonna",
          state_id: "1107",
        },
        {
          id: "15920",
          name: "Kirna",
          state_id: "1107",
        },
        {
          id: "15921",
          name: "Koeru",
          state_id: "1107",
        },
        {
          id: "15922",
          name: "Koigi",
          state_id: "1107",
        },
        {
          id: "15923",
          name: "Kolu",
          state_id: "1107",
        },
        {
          id: "15924",
          name: "Kuksema",
          state_id: "1107",
        },
        {
          id: "15925",
          name: "Laupa",
          state_id: "1107",
        },
        {
          id: "15926",
          name: "Lehtse",
          state_id: "1107",
        },
        {
          id: "15927",
          name: "Lokuta",
          state_id: "1107",
        },
        {
          id: "15928",
          name: "Loola",
          state_id: "1107",
        },
        {
          id: "15929",
          name: "Muusleri",
          state_id: "1107",
        },
        {
          id: "15930",
          name: "Oisu",
          state_id: "1107",
        },
        {
          id: "15931",
          name: "Paide",
          state_id: "1107",
        },
        {
          id: "15932",
          name: "Painurme",
          state_id: "1107",
        },
        {
          id: "15933",
          name: "Peetri",
          state_id: "1107",
        },
        {
          id: "15934",
          name: "Poikva",
          state_id: "1107",
        },
        {
          id: "15935",
          name: "Reopalu",
          state_id: "1107",
        },
        {
          id: "15936",
          name: "Retla",
          state_id: "1107",
        },
        {
          id: "15937",
          name: "Roa",
          state_id: "1107",
        },
        {
          id: "15938",
          name: "Roosna",
          state_id: "1107",
        },
        {
          id: "15939",
          name: "Roosna-Alliku",
          state_id: "1107",
        },
        {
          id: "15940",
          name: "Sarevere",
          state_id: "1107",
        },
        {
          id: "15941",
          name: "Sargvere",
          state_id: "1107",
        },
        {
          id: "15942",
          name: "Taikse",
          state_id: "1107",
        },
        {
          id: "15943",
          name: "Tarbja",
          state_id: "1107",
        },
        {
          id: "15944",
          name: "Turi",
          state_id: "1107",
        },
        {
          id: "15945",
          name: "Turi-Alliku",
          state_id: "1107",
        },
        {
          id: "15946",
          name: "Vaatsa",
          state_id: "1107",
        },
        {
          id: "15947",
          name: "Vahukula",
          state_id: "1107",
        },
        {
          id: "15948",
          name: "Vao",
          state_id: "1107",
        },
        {
          id: "15949",
          name: "Viisu",
          state_id: "1107",
        },
        {
          id: "15950",
          name: "Villevere",
          state_id: "1107",
        },
      ],
      Jogeva: [
        {
          id: "15951",
          name: "Adavere",
          state_id: "1108",
        },
        {
          id: "15952",
          name: "Esku",
          state_id: "1108",
        },
        {
          id: "15953",
          name: "Harjanurme",
          state_id: "1108",
        },
        {
          id: "15954",
          name: "Jogeva",
          state_id: "1108",
        },
        {
          id: "15955",
          name: "Kaarepere",
          state_id: "1108",
        },
        {
          id: "15956",
          name: "Kalana",
          state_id: "1108",
        },
        {
          id: "15957",
          name: "Kalme",
          state_id: "1108",
        },
        {
          id: "15958",
          name: "Kamari",
          state_id: "1108",
        },
        {
          id: "15959",
          name: "Karde",
          state_id: "1108",
        },
        {
          id: "15960",
          name: "Kasepaa",
          state_id: "1108",
        },
        {
          id: "15961",
          name: "Kassinurme",
          state_id: "1108",
        },
        {
          id: "15962",
          name: "Konnu",
          state_id: "1108",
        },
        {
          id: "15963",
          name: "Kudina",
          state_id: "1108",
        },
        {
          id: "15964",
          name: "Kukita",
          state_id: "1108",
        },
        {
          id: "15965",
          name: "Kuremaa",
          state_id: "1108",
        },
        {
          id: "15966",
          name: "Kurista",
          state_id: "1108",
        },
        {
          id: "15967",
          name: "Lahavere",
          state_id: "1108",
        },
        {
          id: "15968",
          name: "Laiuse",
          state_id: "1108",
        },
        {
          id: "15969",
          name: "Laiusevalja",
          state_id: "1108",
        },
        {
          id: "15970",
          name: "Leedi",
          state_id: "1108",
        },
        {
          id: "15971",
          name: "Lustivere",
          state_id: "1108",
        },
        {
          id: "15972",
          name: "Luua",
          state_id: "1108",
        },
        {
          id: "15973",
          name: "Maarja",
          state_id: "1108",
        },
        {
          id: "15974",
          name: "Mallikvere",
          state_id: "1108",
        },
        {
          id: "15975",
          name: "Metsakula",
          state_id: "1108",
        },
        {
          id: "15976",
          name: "Mohkula",
          state_id: "1108",
        },
        {
          id: "15977",
          name: "Mustvee",
          state_id: "1108",
        },
        {
          id: "15978",
          name: "Neanurme",
          state_id: "1108",
        },
        {
          id: "15979",
          name: "Nova",
          state_id: "1108",
        },
        {
          id: "15980",
          name: "Omedu",
          state_id: "1108",
        },
        {
          id: "15981",
          name: "Ouna",
          state_id: "1108",
        },
        {
          id: "15982",
          name: "Painkula",
          state_id: "1108",
        },
        {
          id: "15983",
          name: "Pajusi",
          state_id: "1108",
        },
        {
          id: "15984",
          name: "Pala",
          state_id: "1108",
        },
        {
          id: "15985",
          name: "Palamuse",
          state_id: "1108",
        },
        {
          id: "15986",
          name: "Pataste",
          state_id: "1108",
        },
        {
          id: "15987",
          name: "Pauastvere",
          state_id: "1108",
        },
        {
          id: "15988",
          name: "Pikkjarve",
          state_id: "1108",
        },
        {
          id: "15989",
          name: "Pikknurme",
          state_id: "1108",
        },
        {
          id: "15990",
          name: "Pisisaare",
          state_id: "1108",
        },
        {
          id: "15991",
          name: "Poltsamaa",
          state_id: "1108",
        },
        {
          id: "15992",
          name: "Poora",
          state_id: "1108",
        },
        {
          id: "15993",
          name: "Puurmani",
          state_id: "1108",
        },
        {
          id: "15994",
          name: "Raabise",
          state_id: "1108",
        },
        {
          id: "15995",
          name: "Raja",
          state_id: "1108",
        },
        {
          id: "15996",
          name: "Saare",
          state_id: "1108",
        },
        {
          id: "15997",
          name: "Sadala",
          state_id: "1108",
        },
        {
          id: "15998",
          name: "Sadukula",
          state_id: "1108",
        },
        {
          id: "15999",
          name: "Siimusti",
          state_id: "1108",
        },
        {
          id: "16000",
          name: "Tabivere",
          state_id: "1108",
        },
        {
          id: "16001",
          name: "Tahkvere",
          state_id: "1108",
        },
        {
          id: "16002",
          name: "Tiheda",
          state_id: "1108",
        },
        {
          id: "16003",
          name: "Toikvere",
          state_id: "1108",
        },
        {
          id: "16004",
          name: "Torma",
          state_id: "1108",
        },
        {
          id: "16005",
          name: "Umbusi",
          state_id: "1108",
        },
        {
          id: "16006",
          name: "Vagari",
          state_id: "1108",
        },
        {
          id: "16007",
          name: "Vaiatu",
          state_id: "1108",
        },
        {
          id: "16008",
          name: "Vaike-Kamari",
          state_id: "1108",
        },
        {
          id: "16009",
          name: "Vaimastvere",
          state_id: "1108",
        },
        {
          id: "16010",
          name: "Valgma",
          state_id: "1108",
        },
        {
          id: "16011",
          name: "Visusti",
          state_id: "1108",
        },
        {
          id: "16012",
          name: "Voduvere",
          state_id: "1108",
        },
        {
          id: "16013",
          name: "Vohmanomme",
          state_id: "1108",
        },
        {
          id: "16014",
          name: "Voisiku",
          state_id: "1108",
        },
        {
          id: "16015",
          name: "Voldi",
          state_id: "1108",
        },
        {
          id: "16016",
          name: "Voore",
          state_id: "1108",
        },
        {
          id: "16017",
          name: "Votikvere",
          state_id: "1108",
        },
      ],
      Laane: [
        {
          id: "16018",
          name: "Haapsalu",
          state_id: "1109",
        },
        {
          id: "16019",
          name: "Hullo",
          state_id: "1109",
        },
        {
          id: "16020",
          name: "Joodre",
          state_id: "1109",
        },
        {
          id: "16021",
          name: "Kirbla",
          state_id: "1109",
        },
        {
          id: "16022",
          name: "Kirimae",
          state_id: "1109",
        },
        {
          id: "16023",
          name: "Koluvere",
          state_id: "1109",
        },
        {
          id: "16024",
          name: "Komsi",
          state_id: "1109",
        },
        {
          id: "16025",
          name: "Kullamaa",
          state_id: "1109",
        },
        {
          id: "16026",
          name: "Lihula",
          state_id: "1109",
        },
        {
          id: "16027",
          name: "Liivi",
          state_id: "1109",
        },
        {
          id: "16028",
          name: "Linnamae",
          state_id: "1109",
        },
        {
          id: "16029",
          name: "Martna",
          state_id: "1109",
        },
        {
          id: "16030",
          name: "Nigula",
          state_id: "1109",
        },
        {
          id: "16031",
          name: "Nova",
          state_id: "1109",
        },
        {
          id: "16032",
          name: "Palivere",
          state_id: "1109",
        },
        {
          id: "16033",
          name: "Palli",
          state_id: "1109",
        },
        {
          id: "16034",
          name: "Panga",
          state_id: "1109",
        },
        {
          id: "16035",
          name: "Paralepa",
          state_id: "1109",
        },
        {
          id: "16036",
          name: "Piirsalu",
          state_id: "1109",
        },
        {
          id: "16037",
          name: "Purksi",
          state_id: "1109",
        },
        {
          id: "16038",
          name: "Rannakula",
          state_id: "1109",
        },
        {
          id: "16039",
          name: "Risti",
          state_id: "1109",
        },
        {
          id: "16040",
          name: "Roude",
          state_id: "1109",
        },
        {
          id: "16041",
          name: "Sutlepa",
          state_id: "1109",
        },
        {
          id: "16042",
          name: "Taebla",
          state_id: "1109",
        },
        {
          id: "16043",
          name: "Tuudi",
          state_id: "1109",
        },
        {
          id: "16044",
          name: "Uuemoisa",
          state_id: "1109",
        },
        {
          id: "16045",
          name: "Variku",
          state_id: "1109",
        },
        {
          id: "16046",
          name: "Vatla",
          state_id: "1109",
        },
        {
          id: "16047",
          name: "Virtsu",
          state_id: "1109",
        },
      ],
      "Laane-Viru": [
        {
          id: "16048",
          name: "Aaspere",
          state_id: "1110",
        },
        {
          id: "16049",
          name: "Ama",
          state_id: "1110",
        },
        {
          id: "16050",
          name: "Arkna",
          state_id: "1110",
        },
        {
          id: "16051",
          name: "Assamalla",
          state_id: "1110",
        },
        {
          id: "16052",
          name: "Avanduse",
          state_id: "1110",
        },
        {
          id: "16053",
          name: "Avispea",
          state_id: "1110",
        },
        {
          id: "16054",
          name: "Ebavere",
          state_id: "1110",
        },
        {
          id: "16055",
          name: "Eipri",
          state_id: "1110",
        },
        {
          id: "16056",
          name: "Essu",
          state_id: "1110",
        },
        {
          id: "16057",
          name: "Haljala",
          state_id: "1110",
        },
        {
          id: "16058",
          name: "Hulja",
          state_id: "1110",
        },
        {
          id: "16059",
          name: "Imastu",
          state_id: "1110",
        },
        {
          id: "16060",
          name: "Inju",
          state_id: "1110",
        },
        {
          id: "16061",
          name: "Kadapiku",
          state_id: "1110",
        },
        {
          id: "16062",
          name: "Kadila",
          state_id: "1110",
        },
        {
          id: "16063",
          name: "Kadrina",
          state_id: "1110",
        },
        {
          id: "16064",
          name: "Kakumae",
          state_id: "1110",
        },
        {
          id: "16065",
          name: "Karitsa",
          state_id: "1110",
        },
        {
          id: "16066",
          name: "Karu",
          state_id: "1110",
        },
        {
          id: "16067",
          name: "Kasmu",
          state_id: "1110",
        },
        {
          id: "16068",
          name: "Kihlevere",
          state_id: "1110",
        },
        {
          id: "16069",
          name: "Kiku",
          state_id: "1110",
        },
        {
          id: "16070",
          name: "Kiltsi",
          state_id: "1110",
        },
        {
          id: "16071",
          name: "Kohala",
          state_id: "1110",
        },
        {
          id: "16072",
          name: "Kunda",
          state_id: "1110",
        },
        {
          id: "16073",
          name: "Kuti",
          state_id: "1110",
        },
        {
          id: "16074",
          name: "Laekvere",
          state_id: "1110",
        },
        {
          id: "16075",
          name: "Lasila",
          state_id: "1110",
        },
        {
          id: "16076",
          name: "Lepna",
          state_id: "1110",
        },
        {
          id: "16077",
          name: "Levala",
          state_id: "1110",
        },
        {
          id: "16078",
          name: "Liigvalla",
          state_id: "1110",
        },
        {
          id: "16079",
          name: "Modriku",
          state_id: "1110",
        },
        {
          id: "16080",
          name: "Moe",
          state_id: "1110",
        },
        {
          id: "16081",
          name: "Moora",
          state_id: "1110",
        },
        {
          id: "16082",
          name: "Muuga",
          state_id: "1110",
        },
        {
          id: "16083",
          name: "Napi",
          state_id: "1110",
        },
        {
          id: "16084",
          name: "Paasvere",
          state_id: "1110",
        },
        {
          id: "16085",
          name: "Pajusti",
          state_id: "1110",
        },
        {
          id: "16086",
          name: "Pandivere",
          state_id: "1110",
        },
        {
          id: "16087",
          name: "Piira",
          state_id: "1110",
        },
        {
          id: "16088",
          name: "Pikevere",
          state_id: "1110",
        },
        {
          id: "16089",
          name: "Podrangu",
          state_id: "1110",
        },
        {
          id: "16090",
          name: "Podruse",
          state_id: "1110",
        },
        {
          id: "16091",
          name: "Porkuni",
          state_id: "1110",
        },
        {
          id: "16092",
          name: "Rahkla",
          state_id: "1110",
        },
        {
          id: "16093",
          name: "Rakke",
          state_id: "1110",
        },
        {
          id: "16094",
          name: "Rakvere",
          state_id: "1110",
        },
        {
          id: "16095",
          name: "Ridakula",
          state_id: "1110",
        },
        {
          id: "16096",
          name: "Roela",
          state_id: "1110",
        },
        {
          id: "16097",
          name: "Roodevalja",
          state_id: "1110",
        },
        {
          id: "16098",
          name: "Saase",
          state_id: "1110",
        },
        {
          id: "16099",
          name: "Salda",
          state_id: "1110",
        },
        {
          id: "16100",
          name: "Salla",
          state_id: "1110",
        },
        {
          id: "16101",
          name: "Simuna",
          state_id: "1110",
        },
        {
          id: "16102",
          name: "Someru",
          state_id: "1110",
        },
        {
          id: "16103",
          name: "Taaravainu",
          state_id: "1110",
        },
        {
          id: "16104",
          name: "Tamsalu",
          state_id: "1110",
        },
        {
          id: "16105",
          name: "Tapa",
          state_id: "1110",
        },
        {
          id: "16106",
          name: "Torma",
          state_id: "1110",
        },
        {
          id: "16107",
          name: "Torremae",
          state_id: "1110",
        },
        {
          id: "16108",
          name: "Triigi",
          state_id: "1110",
        },
        {
          id: "16109",
          name: "Tudu",
          state_id: "1110",
        },
        {
          id: "16110",
          name: "Ubja",
          state_id: "1110",
        },
        {
          id: "16111",
          name: "Udriku",
          state_id: "1110",
        },
        {
          id: "16112",
          name: "Uhtna",
          state_id: "1110",
        },
        {
          id: "16113",
          name: "Ulvi",
          state_id: "1110",
        },
        {
          id: "16114",
          name: "Undla",
          state_id: "1110",
        },
        {
          id: "16115",
          name: "Ussimae",
          state_id: "1110",
        },
        {
          id: "16116",
          name: "Uudekula",
          state_id: "1110",
        },
        {
          id: "16117",
          name: "Vaekula",
          state_id: "1110",
        },
        {
          id: "16118",
          name: "Vahakulmu",
          state_id: "1110",
        },
        {
          id: "16119",
          name: "Vaiatu",
          state_id: "1110",
        },
        {
          id: "16120",
          name: "Vaike-Maarja",
          state_id: "1110",
        },
        {
          id: "16121",
          name: "Vajangu",
          state_id: "1110",
        },
        {
          id: "16122",
          name: "Vao",
          state_id: "1110",
        },
        {
          id: "16123",
          name: "Veltsi",
          state_id: "1110",
        },
        {
          id: "16124",
          name: "Venevere",
          state_id: "1110",
        },
        {
          id: "16125",
          name: "Vergi",
          state_id: "1110",
        },
        {
          id: "16126",
          name: "Vetiku",
          state_id: "1110",
        },
        {
          id: "16127",
          name: "Vihula",
          state_id: "1110",
        },
        {
          id: "16128",
          name: "Viitna",
          state_id: "1110",
        },
        {
          id: "16129",
          name: "Vinni",
          state_id: "1110",
        },
        {
          id: "16130",
          name: "Viru-Jaagupi",
          state_id: "1110",
        },
        {
          id: "16131",
          name: "Viru-Kabala",
          state_id: "1110",
        },
        {
          id: "16132",
          name: "Viru-Nigula",
          state_id: "1110",
        },
        {
          id: "16133",
          name: "Vohnja",
          state_id: "1110",
        },
        {
          id: "16134",
          name: "Vosu",
          state_id: "1110",
        },
        {
          id: "16135",
          name: "Vosupere",
          state_id: "1110",
        },
      ],
      Parnu: [
        {
          id: "16136",
          name: "Ahaste",
          state_id: "1111",
        },
        {
          id: "16137",
          name: "Aluste",
          state_id: "1111",
        },
        {
          id: "16138",
          name: "Are",
          state_id: "1111",
        },
        {
          id: "16139",
          name: "Arumetsa",
          state_id: "1111",
        },
        {
          id: "16140",
          name: "Audru",
          state_id: "1111",
        },
        {
          id: "16141",
          name: "Eametsa",
          state_id: "1111",
        },
        {
          id: "16142",
          name: "Haademeeste",
          state_id: "1111",
        },
        {
          id: "16143",
          name: "Halinga",
          state_id: "1111",
        },
        {
          id: "16144",
          name: "Ikla",
          state_id: "1111",
        },
        {
          id: "16145",
          name: "Ilvese",
          state_id: "1111",
        },
        {
          id: "16146",
          name: "Jaamakula",
          state_id: "1111",
        },
        {
          id: "16147",
          name: "Jaarja",
          state_id: "1111",
        },
        {
          id: "16148",
          name: "Joesuu",
          state_id: "1111",
        },
        {
          id: "16149",
          name: "Joopre",
          state_id: "1111",
        },
        {
          id: "16150",
          name: "Kaansoo",
          state_id: "1111",
        },
        {
          id: "16151",
          name: "Kabli",
          state_id: "1111",
        },
        {
          id: "16152",
          name: "Kadjaste",
          state_id: "1111",
        },
        {
          id: "16153",
          name: "Kaisma",
          state_id: "1111",
        },
        {
          id: "16154",
          name: "Kalita",
          state_id: "1111",
        },
        {
          id: "16155",
          name: "Kanakula",
          state_id: "1111",
        },
        {
          id: "16156",
          name: "Kergu",
          state_id: "1111",
        },
        {
          id: "16157",
          name: "Kihlepa",
          state_id: "1111",
        },
        {
          id: "16158",
          name: "Kilingi-Nomme",
          state_id: "1111",
        },
        {
          id: "16159",
          name: "Kilksama",
          state_id: "1111",
        },
        {
          id: "16160",
          name: "Koima",
          state_id: "1111",
        },
        {
          id: "16161",
          name: "Koonga",
          state_id: "1111",
        },
        {
          id: "16162",
          name: "Krundikula",
          state_id: "1111",
        },
        {
          id: "16163",
          name: "Laadi",
          state_id: "1111",
        },
        {
          id: "16164",
          name: "Langerma",
          state_id: "1111",
        },
        {
          id: "16165",
          name: "Lavassaare",
          state_id: "1111",
        },
        {
          id: "16166",
          name: "Leipste",
          state_id: "1111",
        },
        {
          id: "16167",
          name: "Lemmetsa",
          state_id: "1111",
        },
        {
          id: "16168",
          name: "Lemsi",
          state_id: "1111",
        },
        {
          id: "16169",
          name: "Libatse",
          state_id: "1111",
        },
        {
          id: "16170",
          name: "Linakula",
          state_id: "1111",
        },
        {
          id: "16171",
          name: "Lindi",
          state_id: "1111",
        },
        {
          id: "16172",
          name: "Liu",
          state_id: "1111",
        },
        {
          id: "16173",
          name: "Lodja",
          state_id: "1111",
        },
        {
          id: "16174",
          name: "Lope",
          state_id: "1111",
        },
        {
          id: "16175",
          name: "Malda",
          state_id: "1111",
        },
        {
          id: "16176",
          name: "Mannikuste",
          state_id: "1111",
        },
        {
          id: "16177",
          name: "Massiaru",
          state_id: "1111",
        },
        {
          id: "16178",
          name: "Metsaaare",
          state_id: "1111",
        },
        {
          id: "16179",
          name: "Metsapoole",
          state_id: "1111",
        },
        {
          id: "16180",
          name: "Moisakula",
          state_id: "1111",
        },
        {
          id: "16181",
          name: "Muraka",
          state_id: "1111",
        },
        {
          id: "16182",
          name: "Niidu",
          state_id: "1111",
        },
        {
          id: "16183",
          name: "Nurme",
          state_id: "1111",
        },
        {
          id: "16184",
          name: "Oara",
          state_id: "1111",
        },
        {
          id: "16185",
          name: "Oidrema",
          state_id: "1111",
        },
        {
          id: "16186",
          name: "Paikuse",
          state_id: "1111",
        },
        {
          id: "16187",
          name: "Papsaare",
          state_id: "1111",
        },
        {
          id: "16188",
          name: "Parnjoe",
          state_id: "1111",
        },
        {
          id: "16189",
          name: "Parnu",
          state_id: "1111",
        },
        {
          id: "16190",
          name: "Parnu-Jaagupi",
          state_id: "1111",
        },
        {
          id: "16191",
          name: "Penu",
          state_id: "1111",
        },
        {
          id: "16192",
          name: "Piistaoja",
          state_id: "1111",
        },
        {
          id: "16193",
          name: "Pohara",
          state_id: "1111",
        },
        {
          id: "16194",
          name: "Poldeotsa",
          state_id: "1111",
        },
        {
          id: "16195",
          name: "Pootsi",
          state_id: "1111",
        },
        {
          id: "16196",
          name: "Pulli",
          state_id: "1111",
        },
        {
          id: "16197",
          name: "Rannametsa",
          state_id: "1111",
        },
        {
          id: "16198",
          name: "Ratsepa",
          state_id: "1111",
        },
        {
          id: "16199",
          name: "Reiu",
          state_id: "1111",
        },
        {
          id: "16200",
          name: "Ridalepa",
          state_id: "1111",
        },
        {
          id: "16201",
          name: "Rootsikula",
          state_id: "1111",
        },
        {
          id: "16202",
          name: "Saarde",
          state_id: "1111",
        },
        {
          id: "16203",
          name: "Saare",
          state_id: "1111",
        },
        {
          id: "16204",
          name: "Sauga",
          state_id: "1111",
        },
        {
          id: "16205",
          name: "Seliste",
          state_id: "1111",
        },
        {
          id: "16206",
          name: "Selja",
          state_id: "1111",
        },
        {
          id: "16207",
          name: "Seljametsa",
          state_id: "1111",
        },
        {
          id: "16208",
          name: "Silla",
          state_id: "1111",
        },
        {
          id: "16209",
          name: "Sindi",
          state_id: "1111",
        },
        {
          id: "16210",
          name: "Soeva",
          state_id: "1111",
        },
        {
          id: "16211",
          name: "Soometsa",
          state_id: "1111",
        },
        {
          id: "16212",
          name: "Suigu",
          state_id: "1111",
        },
        {
          id: "16213",
          name: "Surju",
          state_id: "1111",
        },
        {
          id: "16214",
          name: "Suurejoe",
          state_id: "1111",
        },
        {
          id: "16215",
          name: "Taali",
          state_id: "1111",
        },
        {
          id: "16216",
          name: "Tahkuranna",
          state_id: "1111",
        },
        {
          id: "16217",
          name: "Tali",
          state_id: "1111",
        },
        {
          id: "16218",
          name: "Tammiste",
          state_id: "1111",
        },
        {
          id: "16219",
          name: "Tammuru",
          state_id: "1111",
        },
        {
          id: "16220",
          name: "Tihemetsa",
          state_id: "1111",
        },
        {
          id: "16221",
          name: "Tolla",
          state_id: "1111",
        },
        {
          id: "16222",
          name: "Tootsi",
          state_id: "1111",
        },
        {
          id: "16223",
          name: "Tori",
          state_id: "1111",
        },
        {
          id: "16224",
          name: "Tostamaa",
          state_id: "1111",
        },
        {
          id: "16225",
          name: "Tousi",
          state_id: "1111",
        },
        {
          id: "16226",
          name: "Treimani",
          state_id: "1111",
        },
        {
          id: "16227",
          name: "Urge",
          state_id: "1111",
        },
        {
          id: "16228",
          name: "Uulu",
          state_id: "1111",
        },
        {
          id: "16229",
          name: "Vahenurme",
          state_id: "1111",
        },
        {
          id: "16230",
          name: "Vaki",
          state_id: "1111",
        },
        {
          id: "16231",
          name: "Vandra",
          state_id: "1111",
        },
        {
          id: "16232",
          name: "Varbla",
          state_id: "1111",
        },
        {
          id: "16233",
          name: "Veelikse",
          state_id: "1111",
        },
        {
          id: "16234",
          name: "Vihtra",
          state_id: "1111",
        },
        {
          id: "16235",
          name: "Voidu",
          state_id: "1111",
        },
        {
          id: "16236",
          name: "Voiste",
          state_id: "1111",
        },
      ],
      Polva: [
        {
          id: "16237",
          name: "Aarna",
          state_id: "1112",
        },
        {
          id: "16238",
          name: "Ahja",
          state_id: "1112",
        },
        {
          id: "16239",
          name: "Erastvere",
          state_id: "1112",
        },
        {
          id: "16240",
          name: "Himma",
          state_id: "1112",
        },
        {
          id: "16241",
          name: "Himmaste",
          state_id: "1112",
        },
        {
          id: "16242",
          name: "Holvandi",
          state_id: "1112",
        },
        {
          id: "16243",
          name: "Ihamaru",
          state_id: "1112",
        },
        {
          id: "16244",
          name: "Jaanimoisa",
          state_id: "1112",
        },
        {
          id: "16245",
          name: "Kanepi",
          state_id: "1112",
        },
        {
          id: "16246",
          name: "Karilatsi",
          state_id: "1112",
        },
        {
          id: "16247",
          name: "Karsa",
          state_id: "1112",
        },
        {
          id: "16248",
          name: "Karste",
          state_id: "1112",
        },
        {
          id: "16249",
          name: "Kauksi",
          state_id: "1112",
        },
        {
          id: "16250",
          name: "Kiidjarve",
          state_id: "1112",
        },
        {
          id: "16251",
          name: "Kostrimae",
          state_id: "1112",
        },
        {
          id: "16252",
          name: "Krootuse",
          state_id: "1112",
        },
        {
          id: "16253",
          name: "Leevaku",
          state_id: "1112",
        },
        {
          id: "16254",
          name: "Leevi",
          state_id: "1112",
        },
        {
          id: "16255",
          name: "Leevijoe",
          state_id: "1112",
        },
        {
          id: "16256",
          name: "Linte",
          state_id: "1112",
        },
        {
          id: "16257",
          name: "Lootvina",
          state_id: "1112",
        },
        {
          id: "16258",
          name: "Maaritsa",
          state_id: "1112",
        },
        {
          id: "16259",
          name: "Mammaste",
          state_id: "1112",
        },
        {
          id: "16260",
          name: "Metste",
          state_id: "1112",
        },
        {
          id: "16261",
          name: "Mikitamae",
          state_id: "1112",
        },
        {
          id: "16262",
          name: "Mooste",
          state_id: "1112",
        },
        {
          id: "16263",
          name: "Naha",
          state_id: "1112",
        },
        {
          id: "16264",
          name: "Orava",
          state_id: "1112",
        },
        {
          id: "16265",
          name: "Pahtpaa",
          state_id: "1112",
        },
        {
          id: "16266",
          name: "Partsi",
          state_id: "1112",
        },
        {
          id: "16267",
          name: "Peri",
          state_id: "1112",
        },
        {
          id: "16268",
          name: "Piigandi",
          state_id: "1112",
        },
        {
          id: "16269",
          name: "Polgaste",
          state_id: "1112",
        },
        {
          id: "16270",
          name: "Polva",
          state_id: "1112",
        },
        {
          id: "16271",
          name: "Prangli",
          state_id: "1112",
        },
        {
          id: "16272",
          name: "Puuri",
          state_id: "1112",
        },
        {
          id: "16273",
          name: "Raadama",
          state_id: "1112",
        },
        {
          id: "16274",
          name: "Rahumae",
          state_id: "1112",
        },
        {
          id: "16275",
          name: "Raigla",
          state_id: "1112",
        },
        {
          id: "16276",
          name: "Rapina",
          state_id: "1112",
        },
        {
          id: "16277",
          name: "Rasina",
          state_id: "1112",
        },
        {
          id: "16278",
          name: "Ristipalo",
          state_id: "1112",
        },
        {
          id: "16279",
          name: "Rosma",
          state_id: "1112",
        },
        {
          id: "16280",
          name: "Ruusa",
          state_id: "1112",
        },
        {
          id: "16281",
          name: "Saverna",
          state_id: "1112",
        },
        {
          id: "16282",
          name: "Sillapaa",
          state_id: "1112",
        },
        {
          id: "16283",
          name: "Soodoma",
          state_id: "1112",
        },
        {
          id: "16284",
          name: "Suurkula",
          state_id: "1112",
        },
        {
          id: "16285",
          name: "Taevaskoja",
          state_id: "1112",
        },
        {
          id: "16286",
          name: "Tannassilma",
          state_id: "1112",
        },
        {
          id: "16287",
          name: "Tilsi",
          state_id: "1112",
        },
        {
          id: "16288",
          name: "Treski",
          state_id: "1112",
        },
        {
          id: "16289",
          name: "Vaike-Rosna",
          state_id: "1112",
        },
        {
          id: "16290",
          name: "Valgjarve",
          state_id: "1112",
        },
        {
          id: "16291",
          name: "Vana-Koiola",
          state_id: "1112",
        },
        {
          id: "16292",
          name: "Vardja",
          state_id: "1112",
        },
        {
          id: "16293",
          name: "Varska",
          state_id: "1112",
        },
        {
          id: "16294",
          name: "Vastse-Kuuste",
          state_id: "1112",
        },
        {
          id: "16295",
          name: "Veriora",
          state_id: "1112",
        },
        {
          id: "16296",
          name: "Viluste",
          state_id: "1112",
        },
        {
          id: "16297",
          name: "Voopsu",
          state_id: "1112",
        },
      ],
      Rapla: [
        {
          id: "16298",
          name: "Aespa",
          state_id: "1113",
        },
        {
          id: "16299",
          name: "Alu",
          state_id: "1113",
        },
        {
          id: "16300",
          name: "Eidapere",
          state_id: "1113",
        },
        {
          id: "16301",
          name: "Hageri",
          state_id: "1113",
        },
        {
          id: "16302",
          name: "Hagudi",
          state_id: "1113",
        },
        {
          id: "16303",
          name: "Haimre",
          state_id: "1113",
        },
        {
          id: "16304",
          name: "Hertu",
          state_id: "1113",
        },
        {
          id: "16305",
          name: "Iira",
          state_id: "1113",
        },
        {
          id: "16306",
          name: "Ingliste",
          state_id: "1113",
        },
        {
          id: "16307",
          name: "Jarlepa",
          state_id: "1113",
        },
        {
          id: "16308",
          name: "Jarvakandi",
          state_id: "1113",
        },
        {
          id: "16309",
          name: "Juuru",
          state_id: "1113",
        },
        {
          id: "16310",
          name: "Kaerepere",
          state_id: "1113",
        },
        {
          id: "16311",
          name: "Kaiu",
          state_id: "1113",
        },
        {
          id: "16312",
          name: "Kalbu",
          state_id: "1113",
        },
        {
          id: "16313",
          name: "Karu",
          state_id: "1113",
        },
        {
          id: "16314",
          name: "Kasti",
          state_id: "1113",
        },
        {
          id: "16315",
          name: "Keava",
          state_id: "1113",
        },
        {
          id: "16316",
          name: "Kehtna",
          state_id: "1113",
        },
        {
          id: "16317",
          name: "Kivi-Vigala",
          state_id: "1113",
        },
        {
          id: "16318",
          name: "Kodila",
          state_id: "1113",
        },
        {
          id: "16319",
          name: "Kohila",
          state_id: "1113",
        },
        {
          id: "16320",
          name: "Kuimetsa",
          state_id: "1113",
        },
        {
          id: "16321",
          name: "Kuusiku",
          state_id: "1113",
        },
        {
          id: "16322",
          name: "Laukna",
          state_id: "1113",
        },
        {
          id: "16323",
          name: "Lelle",
          state_id: "1113",
        },
        {
          id: "16324",
          name: "Lipa",
          state_id: "1113",
        },
        {
          id: "16325",
          name: "Lohu",
          state_id: "1113",
        },
        {
          id: "16326",
          name: "Lokuta",
          state_id: "1113",
        },
        {
          id: "16327",
          name: "Maidla",
          state_id: "1113",
        },
        {
          id: "16328",
          name: "Marjamaa",
          state_id: "1113",
        },
        {
          id: "16329",
          name: "Masti",
          state_id: "1113",
        },
        {
          id: "16330",
          name: "Moisamaa",
          state_id: "1113",
        },
        {
          id: "16331",
          name: "Naravere",
          state_id: "1113",
        },
        {
          id: "16332",
          name: "Orgita",
          state_id: "1113",
        },
        {
          id: "16333",
          name: "Paardu",
          state_id: "1113",
        },
        {
          id: "16334",
          name: "Pae",
          state_id: "1113",
        },
        {
          id: "16335",
          name: "Pahkla",
          state_id: "1113",
        },
        {
          id: "16336",
          name: "Pihali",
          state_id: "1113",
        },
        {
          id: "16337",
          name: "Pirgu",
          state_id: "1113",
        },
        {
          id: "16338",
          name: "Prillimae",
          state_id: "1113",
        },
        {
          id: "16339",
          name: "Purila",
          state_id: "1113",
        },
        {
          id: "16340",
          name: "Purku",
          state_id: "1113",
        },
        {
          id: "16341",
          name: "Rabivere",
          state_id: "1113",
        },
        {
          id: "16342",
          name: "Raikkula",
          state_id: "1113",
        },
        {
          id: "16343",
          name: "Rangu",
          state_id: "1113",
        },
        {
          id: "16344",
          name: "Rapla",
          state_id: "1113",
        },
        {
          id: "16345",
          name: "Salutaguse",
          state_id: "1113",
        },
        {
          id: "16346",
          name: "Sipa",
          state_id: "1113",
        },
        {
          id: "16347",
          name: "Sotke",
          state_id: "1113",
        },
        {
          id: "16348",
          name: "Sutlema",
          state_id: "1113",
        },
        {
          id: "16349",
          name: "Tamme",
          state_id: "1113",
        },
        {
          id: "16350",
          name: "Teenuse",
          state_id: "1113",
        },
        {
          id: "16351",
          name: "Uuskula",
          state_id: "1113",
        },
        {
          id: "16352",
          name: "Vahastu",
          state_id: "1113",
        },
        {
          id: "16353",
          name: "Valgu",
          state_id: "1113",
        },
        {
          id: "16354",
          name: "Valtu",
          state_id: "1113",
        },
        {
          id: "16355",
          name: "Vana-Kaiu",
          state_id: "1113",
        },
        {
          id: "16356",
          name: "Vana-Vigala",
          state_id: "1113",
        },
        {
          id: "16357",
          name: "Varbola",
          state_id: "1113",
        },
        {
          id: "16358",
          name: "Vilivere",
          state_id: "1113",
        },
      ],
      Saare: [
        {
          id: "16359",
          name: "Arandi",
          state_id: "1114",
        },
        {
          id: "16360",
          name: "Aste",
          state_id: "1114",
        },
        {
          id: "16361",
          name: "Eikla",
          state_id: "1114",
        },
        {
          id: "16362",
          name: "Hellamaa",
          state_id: "1114",
        },
        {
          id: "16363",
          name: "Kao",
          state_id: "1114",
        },
        {
          id: "16364",
          name: "Karja",
          state_id: "1114",
        },
        {
          id: "16365",
          name: "Karla",
          state_id: "1114",
        },
        {
          id: "16366",
          name: "Kihelkonna",
          state_id: "1114",
        },
        {
          id: "16367",
          name: "Koimla",
          state_id: "1114",
        },
        {
          id: "16368",
          name: "Koljala",
          state_id: "1114",
        },
        {
          id: "16369",
          name: "Korkkula",
          state_id: "1114",
        },
        {
          id: "16370",
          name: "Korkvere",
          state_id: "1114",
        },
        {
          id: "16371",
          name: "Kudjape",
          state_id: "1114",
        },
        {
          id: "16372",
          name: "Kuressaare",
          state_id: "1114",
        },
        {
          id: "16373",
          name: "Laatsa",
          state_id: "1114",
        },
        {
          id: "16374",
          name: "Lahekula",
          state_id: "1114",
        },
        {
          id: "16375",
          name: "Laimjala",
          state_id: "1114",
        },
        {
          id: "16376",
          name: "Leisi",
          state_id: "1114",
        },
        {
          id: "16377",
          name: "Liiva",
          state_id: "1114",
        },
        {
          id: "16378",
          name: "Lumanda",
          state_id: "1114",
        },
        {
          id: "16379",
          name: "Metskula",
          state_id: "1114",
        },
        {
          id: "16380",
          name: "Mustjala",
          state_id: "1114",
        },
        {
          id: "16381",
          name: "Nasva",
          state_id: "1114",
        },
        {
          id: "16382",
          name: "Nommkula",
          state_id: "1114",
        },
        {
          id: "16383",
          name: "Orissaare",
          state_id: "1114",
        },
        {
          id: "16384",
          name: "Pahkla",
          state_id: "1114",
        },
        {
          id: "16385",
          name: "Parsama",
          state_id: "1114",
        },
        {
          id: "16386",
          name: "Pihtla",
          state_id: "1114",
        },
        {
          id: "16387",
          name: "Sakla",
          state_id: "1114",
        },
        {
          id: "16388",
          name: "Salme",
          state_id: "1114",
        },
        {
          id: "16389",
          name: "Sandla",
          state_id: "1114",
        },
        {
          id: "16390",
          name: "Tagavere",
          state_id: "1114",
        },
        {
          id: "16391",
          name: "Tornimae",
          state_id: "1114",
        },
        {
          id: "16392",
          name: "Valjala",
          state_id: "1114",
        },
        {
          id: "16393",
          name: "Vohma",
          state_id: "1114",
        },
      ],
      Tartu: [
        {
          id: "16394",
          name: "Aardla",
          state_id: "1115",
        },
        {
          id: "16395",
          name: "Aksi",
          state_id: "1115",
        },
        {
          id: "16396",
          name: "Alasoo",
          state_id: "1115",
        },
        {
          id: "16397",
          name: "Alatskivi",
          state_id: "1115",
        },
        {
          id: "16398",
          name: "Annikoru",
          state_id: "1115",
        },
        {
          id: "16399",
          name: "Aravu",
          state_id: "1115",
        },
        {
          id: "16400",
          name: "Elva",
          state_id: "1115",
        },
        {
          id: "16401",
          name: "Erala",
          state_id: "1115",
        },
        {
          id: "16402",
          name: "Ervu",
          state_id: "1115",
        },
        {
          id: "16403",
          name: "Haage",
          state_id: "1115",
        },
        {
          id: "16404",
          name: "Haaslava",
          state_id: "1115",
        },
        {
          id: "16405",
          name: "Ignase",
          state_id: "1115",
        },
        {
          id: "16406",
          name: "Illi",
          state_id: "1115",
        },
        {
          id: "16407",
          name: "Ilmatsalu",
          state_id: "1115",
        },
        {
          id: "16408",
          name: "Kaagvere",
          state_id: "1115",
        },
        {
          id: "16409",
          name: "Kaardi",
          state_id: "1115",
        },
        {
          id: "16410",
          name: "Kaarlijarve",
          state_id: "1115",
        },
        {
          id: "16411",
          name: "Kallaste",
          state_id: "1115",
        },
        {
          id: "16412",
          name: "Kalme",
          state_id: "1115",
        },
        {
          id: "16413",
          name: "Kambja",
          state_id: "1115",
        },
        {
          id: "16414",
          name: "Kandikula",
          state_id: "1115",
        },
        {
          id: "16415",
          name: "Karevere",
          state_id: "1115",
        },
        {
          id: "16416",
          name: "Karkna",
          state_id: "1115",
        },
        {
          id: "16417",
          name: "Kasepaa",
          state_id: "1115",
        },
        {
          id: "16418",
          name: "Kavastu",
          state_id: "1115",
        },
        {
          id: "16419",
          name: "Kirepi",
          state_id: "1115",
        },
        {
          id: "16420",
          name: "Kodukula",
          state_id: "1115",
        },
        {
          id: "16421",
          name: "Kokora",
          state_id: "1115",
        },
        {
          id: "16422",
          name: "Kolkja",
          state_id: "1115",
        },
        {
          id: "16423",
          name: "Konguta",
          state_id: "1115",
        },
        {
          id: "16424",
          name: "Koosa",
          state_id: "1115",
        },
        {
          id: "16425",
          name: "Koruste",
          state_id: "1115",
        },
        {
          id: "16426",
          name: "Korvekula",
          state_id: "1115",
        },
        {
          id: "16427",
          name: "Kulitse",
          state_id: "1115",
        },
        {
          id: "16428",
          name: "Kurekula",
          state_id: "1115",
        },
        {
          id: "16429",
          name: "Kurista",
          state_id: "1115",
        },
        {
          id: "16430",
          name: "Laaniste",
          state_id: "1115",
        },
        {
          id: "16431",
          name: "Laeva",
          state_id: "1115",
        },
        {
          id: "16432",
          name: "Lahte",
          state_id: "1115",
        },
        {
          id: "16433",
          name: "Lalli",
          state_id: "1115",
        },
        {
          id: "16434",
          name: "Lapetukme",
          state_id: "1115",
        },
        {
          id: "16435",
          name: "Lemmatsi",
          state_id: "1115",
        },
        {
          id: "16436",
          name: "Lohkva",
          state_id: "1115",
        },
        {
          id: "16437",
          name: "Lossimae",
          state_id: "1115",
        },
        {
          id: "16438",
          name: "Luke",
          state_id: "1115",
        },
        {
          id: "16439",
          name: "Luunja",
          state_id: "1115",
        },
        {
          id: "16440",
          name: "Maksa",
          state_id: "1115",
        },
        {
          id: "16441",
          name: "Maramaa",
          state_id: "1115",
        },
        {
          id: "16442",
          name: "Marja",
          state_id: "1115",
        },
        {
          id: "16443",
          name: "Meeksi",
          state_id: "1115",
        },
        {
          id: "16444",
          name: "Meeri",
          state_id: "1115",
        },
        {
          id: "16445",
          name: "Mehikoorma",
          state_id: "1115",
        },
        {
          id: "16446",
          name: "Melliste",
          state_id: "1115",
        },
        {
          id: "16447",
          name: "Metsakivi",
          state_id: "1115",
        },
        {
          id: "16448",
          name: "Metsalaane",
          state_id: "1115",
        },
        {
          id: "16449",
          name: "Moisanurme",
          state_id: "1115",
        },
        {
          id: "16450",
          name: "Nina",
          state_id: "1115",
        },
        {
          id: "16451",
          name: "Nogiaru",
          state_id: "1115",
        },
        {
          id: "16452",
          name: "Noo",
          state_id: "1115",
        },
        {
          id: "16453",
          name: "Pilka",
          state_id: "1115",
        },
        {
          id: "16454",
          name: "Poka",
          state_id: "1115",
        },
        {
          id: "16455",
          name: "Pooritsa",
          state_id: "1115",
        },
        {
          id: "16456",
          name: "Puhja",
          state_id: "1115",
        },
        {
          id: "16457",
          name: "Rahinge",
          state_id: "1115",
        },
        {
          id: "16458",
          name: "Raigaste",
          state_id: "1115",
        },
        {
          id: "16459",
          name: "Ramsi",
          state_id: "1115",
        },
        {
          id: "16460",
          name: "Rani",
          state_id: "1115",
        },
        {
          id: "16461",
          name: "Rannu",
          state_id: "1115",
        },
        {
          id: "16462",
          name: "Rebase",
          state_id: "1115",
        },
        {
          id: "16463",
          name: "Reola",
          state_id: "1115",
        },
        {
          id: "16464",
          name: "Rohu",
          state_id: "1115",
        },
        {
          id: "16465",
          name: "Roiu",
          state_id: "1115",
        },
        {
          id: "16466",
          name: "Rongu",
          state_id: "1115",
        },
        {
          id: "16467",
          name: "Saadjarve",
          state_id: "1115",
        },
        {
          id: "16468",
          name: "Sinikula",
          state_id: "1115",
        },
        {
          id: "16469",
          name: "Sirgu",
          state_id: "1115",
        },
        {
          id: "16470",
          name: "Soinaste",
          state_id: "1115",
        },
        {
          id: "16471",
          name: "Sojamaa",
          state_id: "1115",
        },
        {
          id: "16472",
          name: "Tahtvere",
          state_id: "1115",
        },
        {
          id: "16473",
          name: "Tammiste",
          state_id: "1115",
        },
        {
          id: "16474",
          name: "Tammistu",
          state_id: "1115",
        },
        {
          id: "16475",
          name: "Tartu",
          state_id: "1115",
        },
        {
          id: "16476",
          name: "Teedla",
          state_id: "1115",
        },
        {
          id: "16477",
          name: "Tilga",
          state_id: "1115",
        },
        {
          id: "16478",
          name: "Toravere",
          state_id: "1115",
        },
        {
          id: "16479",
          name: "Torvandi",
          state_id: "1115",
        },
        {
          id: "16480",
          name: "Tuki",
          state_id: "1115",
        },
        {
          id: "16481",
          name: "Uderna",
          state_id: "1115",
        },
        {
          id: "16482",
          name: "Uhti",
          state_id: "1115",
        },
        {
          id: "16483",
          name: "Ulenurme",
          state_id: "1115",
        },
        {
          id: "16484",
          name: "Ulila",
          state_id: "1115",
        },
        {
          id: "16485",
          name: "Unikula",
          state_id: "1115",
        },
        {
          id: "16486",
          name: "Vahi",
          state_id: "1115",
        },
        {
          id: "16487",
          name: "Vaike-Rakke",
          state_id: "1115",
        },
        {
          id: "16488",
          name: "Valguta",
          state_id: "1115",
        },
        {
          id: "16489",
          name: "Vana-Kuuste",
          state_id: "1115",
        },
        {
          id: "16490",
          name: "Vara",
          state_id: "1115",
        },
        {
          id: "16491",
          name: "Varnja",
          state_id: "1115",
        },
        {
          id: "16492",
          name: "Vasula",
          state_id: "1115",
        },
        {
          id: "16493",
          name: "Vedu",
          state_id: "1115",
        },
        {
          id: "16494",
          name: "Vesneri",
          state_id: "1115",
        },
        {
          id: "16495",
          name: "Vissi",
          state_id: "1115",
        },
        {
          id: "16496",
          name: "Voibla",
          state_id: "1115",
        },
        {
          id: "16497",
          name: "Voika",
          state_id: "1115",
        },
        {
          id: "16498",
          name: "Vonnu",
          state_id: "1115",
        },
        {
          id: "16499",
          name: "Voopste",
          state_id: "1115",
        },
        {
          id: "16500",
          name: "Vorbuse",
          state_id: "1115",
        },
      ],
      Valga: [
        {
          id: "16501",
          name: "Aakre",
          state_id: "1116",
        },
        {
          id: "16502",
          name: "Ala",
          state_id: "1116",
        },
        {
          id: "16503",
          name: "Hargla",
          state_id: "1116",
        },
        {
          id: "16504",
          name: "Hellenurme",
          state_id: "1116",
        },
        {
          id: "16505",
          name: "Helme",
          state_id: "1116",
        },
        {
          id: "16506",
          name: "Hummuli",
          state_id: "1116",
        },
        {
          id: "16507",
          name: "Jeti",
          state_id: "1116",
        },
        {
          id: "16508",
          name: "Jogeveste",
          state_id: "1116",
        },
        {
          id: "16509",
          name: "Kaagjarve",
          state_id: "1116",
        },
        {
          id: "16510",
          name: "Kalme",
          state_id: "1116",
        },
        {
          id: "16511",
          name: "Karjatnurme",
          state_id: "1116",
        },
        {
          id: "16512",
          name: "Karula",
          state_id: "1116",
        },
        {
          id: "16513",
          name: "Keeni",
          state_id: "1116",
        },
        {
          id: "16514",
          name: "Koikkula",
          state_id: "1116",
        },
        {
          id: "16515",
          name: "Laanemetsa",
          state_id: "1116",
        },
        {
          id: "16516",
          name: "Laatre",
          state_id: "1116",
        },
        {
          id: "16517",
          name: "Laukula",
          state_id: "1116",
        },
        {
          id: "16518",
          name: "Leebiku",
          state_id: "1116",
        },
        {
          id: "16519",
          name: "Linna",
          state_id: "1116",
        },
        {
          id: "16520",
          name: "Lossikula",
          state_id: "1116",
        },
        {
          id: "16521",
          name: "Lullemae",
          state_id: "1116",
        },
        {
          id: "16522",
          name: "Moldre",
          state_id: "1116",
        },
        {
          id: "16523",
          name: "Nouni",
          state_id: "1116",
        },
        {
          id: "16524",
          name: "Nupli",
          state_id: "1116",
        },
        {
          id: "16525",
          name: "Oru",
          state_id: "1116",
        },
        {
          id: "16526",
          name: "Oruste",
          state_id: "1116",
        },
        {
          id: "16527",
          name: "Otepaa",
          state_id: "1116",
        },
        {
          id: "16528",
          name: "Paidla",
          state_id: "1116",
        },
        {
          id: "16529",
          name: "Paju",
          state_id: "1116",
        },
        {
          id: "16530",
          name: "Palupera",
          state_id: "1116",
        },
        {
          id: "16531",
          name: "Patkula",
          state_id: "1116",
        },
        {
          id: "16532",
          name: "Piiri",
          state_id: "1116",
        },
        {
          id: "16533",
          name: "Pikasilla",
          state_id: "1116",
        },
        {
          id: "16534",
          name: "Pilkuse",
          state_id: "1116",
        },
        {
          id: "16535",
          name: "Puhajarve",
          state_id: "1116",
        },
        {
          id: "16536",
          name: "Puka",
          state_id: "1116",
        },
        {
          id: "16537",
          name: "Restu",
          state_id: "1116",
        },
        {
          id: "16538",
          name: "Riidaja",
          state_id: "1116",
        },
        {
          id: "16539",
          name: "Sangaste",
          state_id: "1116",
        },
        {
          id: "16540",
          name: "Sihva",
          state_id: "1116",
        },
        {
          id: "16541",
          name: "Sooru",
          state_id: "1116",
        },
        {
          id: "16542",
          name: "Taagepera",
          state_id: "1116",
        },
        {
          id: "16543",
          name: "Tagula",
          state_id: "1116",
        },
        {
          id: "16544",
          name: "Taheva",
          state_id: "1116",
        },
        {
          id: "16545",
          name: "Tiidu",
          state_id: "1116",
        },
        {
          id: "16546",
          name: "Tolliste",
          state_id: "1116",
        },
        {
          id: "16547",
          name: "Torva",
          state_id: "1116",
        },
        {
          id: "16548",
          name: "Tsirguliina",
          state_id: "1116",
        },
        {
          id: "16549",
          name: "Valga",
          state_id: "1116",
        },
        {
          id: "16550",
          name: "Vana-Otepaa",
          state_id: "1116",
        },
      ],
      Viljandi: [
        {
          id: "16551",
          name: "Abja-Paluoja",
          state_id: "1117",
        },
        {
          id: "16552",
          name: "Abja-Vanamoisa",
          state_id: "1117",
        },
        {
          id: "16553",
          name: "Aidu",
          state_id: "1117",
        },
        {
          id: "16554",
          name: "Angi",
          state_id: "1117",
        },
        {
          id: "16555",
          name: "Anikatsi",
          state_id: "1117",
        },
        {
          id: "16556",
          name: "Arikula",
          state_id: "1117",
        },
        {
          id: "16557",
          name: "Halliste",
          state_id: "1117",
        },
        {
          id: "16558",
          name: "Heimtali",
          state_id: "1117",
        },
        {
          id: "16559",
          name: "Holstre",
          state_id: "1117",
        },
        {
          id: "16560",
          name: "Intsu",
          state_id: "1117",
        },
        {
          id: "16561",
          name: "Jamejala",
          state_id: "1117",
        },
        {
          id: "16562",
          name: "Jaska",
          state_id: "1117",
        },
        {
          id: "16563",
          name: "Kaavere",
          state_id: "1117",
        },
        {
          id: "16564",
          name: "Kamara",
          state_id: "1117",
        },
        {
          id: "16565",
          name: "Karksi",
          state_id: "1117",
        },
        {
          id: "16566",
          name: "Karksi-Nuia",
          state_id: "1117",
        },
        {
          id: "16567",
          name: "Karstna",
          state_id: "1117",
        },
        {
          id: "16568",
          name: "Karula",
          state_id: "1117",
        },
        {
          id: "16569",
          name: "Kobruvere",
          state_id: "1117",
        },
        {
          id: "16570",
          name: "Koidama",
          state_id: "1117",
        },
        {
          id: "16571",
          name: "Koksvere",
          state_id: "1117",
        },
        {
          id: "16572",
          name: "Kolga-Jaani",
          state_id: "1117",
        },
        {
          id: "16573",
          name: "Koo",
          state_id: "1117",
        },
        {
          id: "16574",
          name: "Kopu",
          state_id: "1117",
        },
        {
          id: "16575",
          name: "Kulla",
          state_id: "1117",
        },
        {
          id: "16576",
          name: "Lalsi",
          state_id: "1117",
        },
        {
          id: "16577",
          name: "Leie",
          state_id: "1117",
        },
        {
          id: "16578",
          name: "Lilli",
          state_id: "1117",
        },
        {
          id: "16579",
          name: "Lohavere",
          state_id: "1117",
        },
        {
          id: "16580",
          name: "Loodi",
          state_id: "1117",
        },
        {
          id: "16581",
          name: "Maeltkula",
          state_id: "1117",
        },
        {
          id: "16582",
          name: "Matapera",
          state_id: "1117",
        },
        {
          id: "16583",
          name: "Meleski",
          state_id: "1117",
        },
        {
          id: "16584",
          name: "Metskula",
          state_id: "1117",
        },
        {
          id: "16585",
          name: "Moisakula",
          state_id: "1117",
        },
        {
          id: "16586",
          name: "Monnaste",
          state_id: "1117",
        },
        {
          id: "16587",
          name: "Mustivere",
          state_id: "1117",
        },
        {
          id: "16588",
          name: "Mustla",
          state_id: "1117",
        },
        {
          id: "16589",
          name: "Navesti",
          state_id: "1117",
        },
        {
          id: "16590",
          name: "Odiste",
          state_id: "1117",
        },
        {
          id: "16591",
          name: "Oisu",
          state_id: "1117",
        },
        {
          id: "16592",
          name: "Olustvere",
          state_id: "1117",
        },
        {
          id: "16593",
          name: "Pahuvere",
          state_id: "1117",
        },
        {
          id: "16594",
          name: "Paistu",
          state_id: "1117",
        },
        {
          id: "16595",
          name: "Parakula",
          state_id: "1117",
        },
        {
          id: "16596",
          name: "Pari",
          state_id: "1117",
        },
        {
          id: "16597",
          name: "Parsti",
          state_id: "1117",
        },
        {
          id: "16598",
          name: "Peetrimoisa",
          state_id: "1117",
        },
        {
          id: "16599",
          name: "Pilistvere",
          state_id: "1117",
        },
        {
          id: "16600",
          name: "Pinska",
          state_id: "1117",
        },
        {
          id: "16601",
          name: "Polde",
          state_id: "1117",
        },
        {
          id: "16602",
          name: "Polli",
          state_id: "1117",
        },
        {
          id: "16603",
          name: "Puiatu",
          state_id: "1117",
        },
        {
          id: "16604",
          name: "Ramsi",
          state_id: "1117",
        },
        {
          id: "16605",
          name: "Reegoldi",
          state_id: "1117",
        },
        {
          id: "16606",
          name: "Saarepeedi",
          state_id: "1117",
        },
        {
          id: "16607",
          name: "Savikoti",
          state_id: "1117",
        },
        {
          id: "16608",
          name: "Sinialliku",
          state_id: "1117",
        },
        {
          id: "16609",
          name: "Soe",
          state_id: "1117",
        },
        {
          id: "16610",
          name: "Soomevere",
          state_id: "1117",
        },
        {
          id: "16611",
          name: "Sudiste",
          state_id: "1117",
        },
        {
          id: "16612",
          name: "Suislepa",
          state_id: "1117",
        },
        {
          id: "16613",
          name: "Sultsi",
          state_id: "1117",
        },
        {
          id: "16614",
          name: "Supsi",
          state_id: "1117",
        },
        {
          id: "16615",
          name: "Surgavere",
          state_id: "1117",
        },
        {
          id: "16616",
          name: "Suure-Jaani",
          state_id: "1117",
        },
        {
          id: "16617",
          name: "Taaksi",
          state_id: "1117",
        },
        {
          id: "16618",
          name: "Tanassilma",
          state_id: "1117",
        },
        {
          id: "16619",
          name: "Tinnikuru",
          state_id: "1117",
        },
        {
          id: "16620",
          name: "Tohvri",
          state_id: "1117",
        },
        {
          id: "16621",
          name: "Tuhalaane",
          state_id: "1117",
        },
        {
          id: "16622",
          name: "Tusti",
          state_id: "1117",
        },
        {
          id: "16623",
          name: "Ulde",
          state_id: "1117",
        },
        {
          id: "16624",
          name: "Ulensi",
          state_id: "1117",
        },
        {
          id: "16625",
          name: "Uusna",
          state_id: "1117",
        },
        {
          id: "16626",
          name: "Valgita",
          state_id: "1117",
        },
        {
          id: "16627",
          name: "Valma",
          state_id: "1117",
        },
        {
          id: "16628",
          name: "Valuste",
          state_id: "1117",
        },
        {
          id: "16629",
          name: "Vana-Kariste",
          state_id: "1117",
        },
        {
          id: "16630",
          name: "Vana-Voidu",
          state_id: "1117",
        },
        {
          id: "16631",
          name: "Vardi",
          state_id: "1117",
        },
        {
          id: "16632",
          name: "Vardja",
          state_id: "1117",
        },
        {
          id: "16633",
          name: "Vastemoisa",
          state_id: "1117",
        },
        {
          id: "16634",
          name: "Veelikse",
          state_id: "1117",
        },
        {
          id: "16635",
          name: "Verilaske",
          state_id: "1117",
        },
        {
          id: "16636",
          name: "Veskimae",
          state_id: "1117",
        },
        {
          id: "16637",
          name: "Viiratsi",
          state_id: "1117",
        },
        {
          id: "16638",
          name: "Viljandi",
          state_id: "1117",
        },
        {
          id: "16639",
          name: "Villa",
          state_id: "1117",
        },
        {
          id: "16640",
          name: "Vohma",
          state_id: "1117",
        },
        {
          id: "16641",
          name: "Voivaku",
          state_id: "1117",
        },
        {
          id: "16642",
          name: "Vooru",
          state_id: "1117",
        },
      ],
      Voru: [
        {
          id: "16643",
          name: "Antsla",
          state_id: "1118",
        },
        {
          id: "16644",
          name: "Haanja",
          state_id: "1118",
        },
        {
          id: "16645",
          name: "Jarvere",
          state_id: "1118",
        },
        {
          id: "16646",
          name: "Kaapa",
          state_id: "1118",
        },
        {
          id: "16647",
          name: "Kirumpaa",
          state_id: "1118",
        },
        {
          id: "16648",
          name: "Kobela",
          state_id: "1118",
        },
        {
          id: "16649",
          name: "Kollino",
          state_id: "1118",
        },
        {
          id: "16650",
          name: "Kose",
          state_id: "1118",
        },
        {
          id: "16651",
          name: "Kraavi",
          state_id: "1118",
        },
        {
          id: "16652",
          name: "Krabi",
          state_id: "1118",
        },
        {
          id: "16653",
          name: "Kulaoru",
          state_id: "1118",
        },
        {
          id: "16654",
          name: "Kuldre",
          state_id: "1118",
        },
        {
          id: "16655",
          name: "Kuutsi",
          state_id: "1118",
        },
        {
          id: "16656",
          name: "Lasva",
          state_id: "1118",
        },
        {
          id: "16657",
          name: "Loosu",
          state_id: "1118",
        },
        {
          id: "16658",
          name: "Lusti",
          state_id: "1118",
        },
        {
          id: "16659",
          name: "Meegomae",
          state_id: "1118",
        },
        {
          id: "16660",
          name: "Meremae",
          state_id: "1118",
        },
        {
          id: "16661",
          name: "Misso",
          state_id: "1118",
        },
        {
          id: "16662",
          name: "Moniste",
          state_id: "1118",
        },
        {
          id: "16663",
          name: "Navi",
          state_id: "1118",
        },
        {
          id: "16664",
          name: "Nursi",
          state_id: "1118",
        },
        {
          id: "16665",
          name: "Obinitsa",
          state_id: "1118",
        },
        {
          id: "16666",
          name: "Osula",
          state_id: "1118",
        },
        {
          id: "16667",
          name: "Otsa",
          state_id: "1118",
        },
        {
          id: "16668",
          name: "Parksepa",
          state_id: "1118",
        },
        {
          id: "16669",
          name: "Puiga",
          state_id: "1118",
        },
        {
          id: "16670",
          name: "Raiste",
          state_id: "1118",
        },
        {
          id: "16671",
          name: "Rimmi",
          state_id: "1118",
        },
        {
          id: "16672",
          name: "Rouge",
          state_id: "1118",
        },
        {
          id: "16673",
          name: "Ruusmae",
          state_id: "1118",
        },
        {
          id: "16674",
          name: "Saru",
          state_id: "1118",
        },
        {
          id: "16675",
          name: "Somerpalu",
          state_id: "1118",
        },
        {
          id: "16676",
          name: "Sulbi",
          state_id: "1118",
        },
        {
          id: "16677",
          name: "Taberlaane",
          state_id: "1118",
        },
        {
          id: "16678",
          name: "Tagakula",
          state_id: "1118",
        },
        {
          id: "16679",
          name: "Tsolgo",
          state_id: "1118",
        },
        {
          id: "16680",
          name: "Tsooru",
          state_id: "1118",
        },
        {
          id: "16681",
          name: "Urvaste",
          state_id: "1118",
        },
        {
          id: "16682",
          name: "Uue-Antsla",
          state_id: "1118",
        },
        {
          id: "16683",
          name: "Vaabina",
          state_id: "1118",
        },
        {
          id: "16684",
          name: "Vagula",
          state_id: "1118",
        },
        {
          id: "16685",
          name: "Vaimela",
          state_id: "1118",
        },
        {
          id: "16686",
          name: "Vana-Antsla",
          state_id: "1118",
        },
        {
          id: "16687",
          name: "Vana-Roosa",
          state_id: "1118",
        },
        {
          id: "16688",
          name: "Vana-Vastseliina",
          state_id: "1118",
        },
        {
          id: "16689",
          name: "Varstu",
          state_id: "1118",
        },
        {
          id: "16690",
          name: "Vastseliina",
          state_id: "1118",
        },
        {
          id: "16691",
          name: "Verijarve",
          state_id: "1118",
        },
        {
          id: "16692",
          name: "Viitina",
          state_id: "1118",
        },
        {
          id: "16693",
          name: "Viitka",
          state_id: "1118",
        },
        {
          id: "16694",
          name: "Visela",
          state_id: "1118",
        },
        {
          id: "16695",
          name: "Voru",
          state_id: "1118",
        },
        {
          id: "16696",
          name: "Vorumoisa",
          state_id: "1118",
        },
      ],
    },
  },
  EG: {
    name: "Egypt",
    native: "مصر‎",
    phone: "20",
    continent: "AF",
    capital: "Cairo",
    currency: "EGP",
    languages: ["ar"],
    emoji: "🇪🇬",
    emojiU: "U+1F1EA U+1F1EC",
    states: {
      Aswan: [
        {
          id: "15400",
          name: "Aswan",
          state_id: "1044",
        },
        {
          id: "15401",
          name: "Daraw",
          state_id: "1044",
        },
        {
          id: "15402",
          name: "Kawm Umbu",
          state_id: "1044",
        },
        {
          id: "15403",
          name: "an-Nasir",
          state_id: "1044",
        },
      ],
      Asyut: [
        {
          id: "15404",
          name: "Abnub",
          state_id: "1045",
        },
        {
          id: "15405",
          name: "Abu Tij",
          state_id: "1045",
        },
        {
          id: "15406",
          name: "Asyut",
          state_id: "1045",
        },
        {
          id: "15407",
          name: "Bani Muhammadiyat",
          state_id: "1045",
        },
        {
          id: "15408",
          name: "Dayrut",
          state_id: "1045",
        },
        {
          id: "15409",
          name: "Dayrut-ash-Sharif",
          state_id: "1045",
        },
        {
          id: "15410",
          name: "Manfalut",
          state_id: "1045",
        },
        {
          id: "15411",
          name: "Musha",
          state_id: "1045",
        },
        {
          id: "15412",
          name: "Sahil Salim",
          state_id: "1045",
        },
        {
          id: "15413",
          name: "Sanabu",
          state_id: "1045",
        },
        {
          id: "15414",
          name: "Umm-al-Qusur",
          state_id: "1045",
        },
        {
          id: "15415",
          name: "al-Badari",
          state_id: "1045",
        },
        {
          id: "15416",
          name: "al-Qusiyah",
          state_id: "1045",
        },
        {
          id: "15417",
          name: "an-Nukhaylah",
          state_id: "1045",
        },
      ],
      "Bani Suwayf": [],
      "Bur Sa''id": [],
      Cairo: [
        {
          id: "15418",
          name: "6th of October City",
          state_id: "1048",
        },
        {
          id: "15419",
          name: "Ataba",
          state_id: "1048",
        },
        {
          id: "15420",
          name: "Cairo",
          state_id: "1048",
        },
        {
          id: "15421",
          name: "Nasr",
          state_id: "1048",
        },
        {
          id: "15422",
          name: "Nasr City",
          state_id: "1048",
        },
        {
          id: "15423",
          name: "Obour City",
          state_id: "1048",
        },
      ],
      Dumyat: [
        {
          id: "15424",
          name: "Izbat-al-Burj",
          state_id: "1049",
        },
        {
          id: "15425",
          name: "Damietta",
          state_id: "1049",
        },
        {
          id: "15426",
          name: "Dumyat",
          state_id: "1049",
        },
        {
          id: "15427",
          name: "El-Zarka",
          state_id: "1049",
        },
        {
          id: "15428",
          name: "Faraskur",
          state_id: "1049",
        },
        {
          id: "15429",
          name: "Kafr Sa''d",
          state_id: "1049",
        },
        {
          id: "15430",
          name: "Kafr-al-Battikh",
          state_id: "1049",
        },
        {
          id: "15431",
          name: "az-Zarqa",
          state_id: "1049",
        },
      ],
      "Kafr-ash-Shaykh": [
        {
          id: "15432",
          name: "Biyala",
          state_id: "1050",
        },
        {
          id: "15433",
          name: "Disuq",
          state_id: "1050",
        },
        {
          id: "15434",
          name: "Fuwah",
          state_id: "1050",
        },
        {
          id: "15435",
          name: "Kafr-al-Jara''idah",
          state_id: "1050",
        },
        {
          id: "15436",
          name: "Kafr-ash-Shaykh",
          state_id: "1050",
        },
        {
          id: "15437",
          name: "Mutubis",
          state_id: "1050",
        },
        {
          id: "15438",
          name: "Qallin",
          state_id: "1050",
        },
        {
          id: "15439",
          name: "Sidi Salim",
          state_id: "1050",
        },
        {
          id: "15440",
          name: "al-Burj",
          state_id: "1050",
        },
        {
          id: "15441",
          name: "al-Burullus",
          state_id: "1050",
        },
        {
          id: "15442",
          name: "al-Haddadi",
          state_id: "1050",
        },
        {
          id: "15443",
          name: "al-Hamul",
          state_id: "1050",
        },
      ],
      Matruh: [
        {
          id: "15444",
          name: "Marsa Matruh",
          state_id: "1051",
        },
        {
          id: "15445",
          name: "Nasr",
          state_id: "1051",
        },
        {
          id: "15446",
          name: "Sidi Barrani",
          state_id: "1051",
        },
        {
          id: "15447",
          name: "Zawiyat Shammas",
          state_id: "1051",
        },
        {
          id: "15448",
          name: "ad-Da''ba",
          state_id: "1051",
        },
      ],
      "Muhafazat ad Daqahliyah": [],
      "Muhafazat al Fayyum": [],
      "Muhafazat al Gharbiyah": [],
      "Muhafazat al Iskandariyah": [],
      "Muhafazat al Qahirah": [],
      Qina: [
        {
          id: "15449",
          name: "Armant",
          state_id: "1057",
        },
        {
          id: "15450",
          name: "Asfun-al-Mata''inah",
          state_id: "1057",
        },
        {
          id: "15451",
          name: "Dandarah",
          state_id: "1057",
        },
        {
          id: "15452",
          name: "Dishna",
          state_id: "1057",
        },
        {
          id: "15453",
          name: "Farshut",
          state_id: "1057",
        },
        {
          id: "15454",
          name: "Hijazah",
          state_id: "1057",
        },
        {
          id: "15455",
          name: "Hiw",
          state_id: "1057",
        },
        {
          id: "15456",
          name: "Idfu",
          state_id: "1057",
        },
        {
          id: "15457",
          name: "Isna",
          state_id: "1057",
        },
        {
          id: "15458",
          name: "Kiman-al-Mata''inah",
          state_id: "1057",
        },
        {
          id: "15459",
          name: "Naj'' Hammadi",
          state_id: "1057",
        },
        {
          id: "15460",
          name: "Naqadah",
          state_id: "1057",
        },
        {
          id: "15461",
          name: "Qift",
          state_id: "1057",
        },
        {
          id: "15462",
          name: "Qina",
          state_id: "1057",
        },
        {
          id: "15463",
          name: "Qus",
          state_id: "1057",
        },
        {
          id: "15464",
          name: "ad-Dabbiyah",
          state_id: "1057",
        },
        {
          id: "15465",
          name: "ad-Dayr",
          state_id: "1057",
        },
        {
          id: "15466",
          name: "al-Ballas",
          state_id: "1057",
        },
        {
          id: "15467",
          name: "al-Karnak",
          state_id: "1057",
        },
        {
          id: "15468",
          name: "al-Waqf",
          state_id: "1057",
        },
        {
          id: "15469",
          name: "ar-Radisiyat-al-Bahriyah",
          state_id: "1057",
        },
      ],
      Sawhaj: [
        {
          id: "15470",
          name: "Akhmim",
          state_id: "1058",
        },
        {
          id: "15471",
          name: "Awlad Tawq Sharq",
          state_id: "1058",
        },
        {
          id: "15472",
          name: "Dar-as-Salam",
          state_id: "1058",
        },
        {
          id: "15473",
          name: "Jirja",
          state_id: "1058",
        },
        {
          id: "15474",
          name: "Juhaynah",
          state_id: "1058",
        },
        {
          id: "15475",
          name: "Sawhaj",
          state_id: "1058",
        },
        {
          id: "15476",
          name: "Tahta",
          state_id: "1058",
        },
        {
          id: "15477",
          name: "Tima",
          state_id: "1058",
        },
        {
          id: "15478",
          name: "al-Balyana",
          state_id: "1058",
        },
        {
          id: "15479",
          name: "al-Manshah",
          state_id: "1058",
        },
        {
          id: "15480",
          name: "al-Maragah",
          state_id: "1058",
        },
      ],
      "Sina al-Janubiyah": [],
      "Sina ash-Shamaliyah": [],
      "ad-Daqahliyah": [
        {
          id: "15481",
          name: "Aja",
          state_id: "1061",
        },
        {
          id: "15482",
          name: "Bahut",
          state_id: "1061",
        },
        {
          id: "15483",
          name: "Bilqas",
          state_id: "1061",
        },
        {
          id: "15484",
          name: "Dikirnis",
          state_id: "1061",
        },
        {
          id: "15485",
          name: "Minyat-an-Nasr",
          state_id: "1061",
        },
        {
          id: "15486",
          name: "Mit Gamr",
          state_id: "1061",
        },
        {
          id: "15487",
          name: "Shirbin",
          state_id: "1061",
        },
        {
          id: "15488",
          name: "Talkha",
          state_id: "1061",
        },
        {
          id: "15489",
          name: "al-Jamaliyah",
          state_id: "1061",
        },
        {
          id: "15490",
          name: "al-Ma''sarah",
          state_id: "1061",
        },
        {
          id: "15491",
          name: "al-Mansurah",
          state_id: "1061",
        },
        {
          id: "15492",
          name: "al-Manzilah",
          state_id: "1061",
        },
        {
          id: "15493",
          name: "al-Matariyah",
          state_id: "1061",
        },
        {
          id: "15494",
          name: "as-Sinbillawayn",
          state_id: "1061",
        },
      ],
      "al-Bahr-al-Ahmar": [
        {
          id: "15495",
          name: "Ras Gharib",
          state_id: "1062",
        },
        {
          id: "15496",
          name: "Safaja",
          state_id: "1062",
        },
        {
          id: "15497",
          name: "al-Ghardaqah",
          state_id: "1062",
        },
        {
          id: "15498",
          name: "al-Qusayr",
          state_id: "1062",
        },
      ],
      "al-Buhayrah": [
        {
          id: "15499",
          name: "Abu Hummus",
          state_id: "1063",
        },
        {
          id: "15500",
          name: "Abu al-Matamir",
          state_id: "1063",
        },
        {
          id: "15501",
          name: "Buturis",
          state_id: "1063",
        },
        {
          id: "15502",
          name: "Damanhur",
          state_id: "1063",
        },
        {
          id: "15503",
          name: "Edfina",
          state_id: "1063",
        },
        {
          id: "15504",
          name: "Hawsh ''Isa",
          state_id: "1063",
        },
        {
          id: "15505",
          name: "Idku",
          state_id: "1063",
        },
        {
          id: "15506",
          name: "Ityay-al-Barud",
          state_id: "1063",
        },
        {
          id: "15507",
          name: "Kafr Salim",
          state_id: "1063",
        },
        {
          id: "15508",
          name: "Kafr-ad-Dawwar",
          state_id: "1063",
        },
        {
          id: "15509",
          name: "Kawm Hamada",
          state_id: "1063",
        },
        {
          id: "15510",
          name: "Nubaria",
          state_id: "1063",
        },
        {
          id: "15511",
          name: "Rashid",
          state_id: "1063",
        },
        {
          id: "15512",
          name: "Shubra Khit",
          state_id: "1063",
        },
        {
          id: "15513",
          name: "Zawiyat Sidi Gazi",
          state_id: "1063",
        },
        {
          id: "15514",
          name: "ad-Dilinjat",
          state_id: "1063",
        },
        {
          id: "15515",
          name: "al-Kawm-al-Akhdar",
          state_id: "1063",
        },
        {
          id: "15516",
          name: "al-Mahmudiyah",
          state_id: "1063",
        },
        {
          id: "15517",
          name: "ar-Rahmaniyah",
          state_id: "1063",
        },
      ],
      "al-Fayyum": [
        {
          id: "15518",
          name: "Fidimin",
          state_id: "1064",
        },
        {
          id: "15519",
          name: "Ibshaway",
          state_id: "1064",
        },
        {
          id: "15520",
          name: "Itsa",
          state_id: "1064",
        },
        {
          id: "15521",
          name: "Qasr Qarun",
          state_id: "1064",
        },
        {
          id: "15522",
          name: "Sanhur",
          state_id: "1064",
        },
        {
          id: "15523",
          name: "Sinnuris",
          state_id: "1064",
        },
        {
          id: "15524",
          name: "Tamiyah",
          state_id: "1064",
        },
        {
          id: "15525",
          name: "al-Fayyum",
          state_id: "1064",
        },
      ],
      "al-Gharbiyah": [
        {
          id: "15526",
          name: "Abyar",
          state_id: "1065",
        },
        {
          id: "15527",
          name: "Basyun",
          state_id: "1065",
        },
        {
          id: "15528",
          name: "Kafr-az-Zayyat",
          state_id: "1065",
        },
        {
          id: "15529",
          name: "Mahallat Marhum",
          state_id: "1065",
        },
        {
          id: "15530",
          name: "Nisf Thani Bashbish",
          state_id: "1065",
        },
        {
          id: "15531",
          name: "Qutur",
          state_id: "1065",
        },
        {
          id: "15532",
          name: "Samannud",
          state_id: "1065",
        },
        {
          id: "15533",
          name: "Tanta",
          state_id: "1065",
        },
        {
          id: "15534",
          name: "Zifta",
          state_id: "1065",
        },
        {
          id: "15535",
          name: "ad-Daljamun",
          state_id: "1065",
        },
        {
          id: "15536",
          name: "al-Mahallah al-Kubra",
          state_id: "1065",
        },
        {
          id: "15537",
          name: "as-Santah",
          state_id: "1065",
        },
      ],
      "al-Iskandariyah": [
        {
          id: "15538",
          name: "Agamy",
          state_id: "1066",
        },
        {
          id: "15539",
          name: "al-Iskandariyah",
          state_id: "1066",
        },
        {
          id: "15540",
          name: "al-Maks",
          state_id: "1066",
        },
      ],
      "al-Ismailiyah": [
        {
          id: "15541",
          name: "Fa''id",
          state_id: "1067",
        },
        {
          id: "15542",
          name: "Sarabiyum",
          state_id: "1067",
        },
        {
          id: "15543",
          name: "al-Ismailiyah",
          state_id: "1067",
        },
      ],
      "al-Jizah": [
        {
          id: "15544",
          name: "Atfih",
          state_id: "1068",
        },
        {
          id: "15545",
          name: "Awsim",
          state_id: "1068",
        },
        {
          id: "15546",
          name: "Giza",
          state_id: "1068",
        },
        {
          id: "15547",
          name: "Madinat Sittah Uktubar",
          state_id: "1068",
        },
        {
          id: "15548",
          name: "Nahya",
          state_id: "1068",
        },
        {
          id: "15549",
          name: "Saqqarah",
          state_id: "1068",
        },
        {
          id: "15550",
          name: "al-''Ayyat",
          state_id: "1068",
        },
        {
          id: "15551",
          name: "al-Badrashayn",
          state_id: "1068",
        },
        {
          id: "15552",
          name: "al-Hawamidiyah",
          state_id: "1068",
        },
        {
          id: "15553",
          name: "al-Jizah",
          state_id: "1068",
        },
        {
          id: "15554",
          name: "al-Mansuriyah",
          state_id: "1068",
        },
        {
          id: "15555",
          name: "al-Wahat-al-Bahriyah",
          state_id: "1068",
        },
        {
          id: "15556",
          name: "as-Saff",
          state_id: "1068",
        },
      ],
      "al-Minufiyah": [
        {
          id: "15557",
          name: "Ashmun",
          state_id: "1069",
        },
        {
          id: "15558",
          name: "Birkat-as-Sab",
          state_id: "1069",
        },
        {
          id: "15559",
          name: "Milij",
          state_id: "1069",
        },
        {
          id: "15560",
          name: "Minuf",
          state_id: "1069",
        },
        {
          id: "15561",
          name: "Quwaysina",
          state_id: "1069",
        },
        {
          id: "15562",
          name: "Shibin-al-Kawm",
          state_id: "1069",
        },
        {
          id: "15563",
          name: "Sirs-al-Layyanah",
          state_id: "1069",
        },
        {
          id: "15564",
          name: "Tala",
          state_id: "1069",
        },
        {
          id: "15565",
          name: "al-Bajur",
          state_id: "1069",
        },
        {
          id: "15566",
          name: "al-Batanun",
          state_id: "1069",
        },
        {
          id: "15567",
          name: "ash-Shuhada",
          state_id: "1069",
        },
      ],
      "al-Minya": [
        {
          id: "15568",
          name: "Abu Qurqas",
          state_id: "1070",
        },
        {
          id: "15569",
          name: "Bani Mazar",
          state_id: "1070",
        },
        {
          id: "15570",
          name: "Dayr Mawas",
          state_id: "1070",
        },
        {
          id: "15571",
          name: "Magagah",
          state_id: "1070",
        },
        {
          id: "15572",
          name: "Mallawi",
          state_id: "1070",
        },
        {
          id: "15573",
          name: "Matay",
          state_id: "1070",
        },
        {
          id: "15574",
          name: "Samalut",
          state_id: "1070",
        },
        {
          id: "15575",
          name: "Tallah",
          state_id: "1070",
        },
        {
          id: "15576",
          name: "Tandah",
          state_id: "1070",
        },
        {
          id: "15577",
          name: "al-Anayim",
          state_id: "1070",
        },
        {
          id: "15578",
          name: "al-Fikriyah",
          state_id: "1070",
        },
        {
          id: "15579",
          name: "al-Minya",
          state_id: "1070",
        },
        {
          id: "15580",
          name: "ar-Rawdah",
          state_id: "1070",
        },
      ],
      "al-Qahira": [
        {
          id: "15581",
          name: "Badr City",
          state_id: "1071",
        },
        {
          id: "15582",
          name: "Heliopolis",
          state_id: "1071",
        },
        {
          id: "15583",
          name: "al-Qahira",
          state_id: "1071",
        },
      ],
      "al-Qalyubiyah": [
        {
          id: "15584",
          name: "Abu Za''bal",
          state_id: "1072",
        },
        {
          id: "15585",
          name: "Banha",
          state_id: "1072",
        },
        {
          id: "15586",
          name: "Qalyub",
          state_id: "1072",
        },
        {
          id: "15587",
          name: "Shubra al-Khaymah",
          state_id: "1072",
        },
        {
          id: "15588",
          name: "Sibin-al-Qanatir",
          state_id: "1072",
        },
        {
          id: "15589",
          name: "Tukh",
          state_id: "1072",
        },
        {
          id: "15590",
          name: "al-Khankah",
          state_id: "1072",
        },
        {
          id: "15591",
          name: "al-Qanatir-al-Khayriyah",
          state_id: "1072",
        },
      ],
      "al-Uqsur": [
        {
          id: "15592",
          name: "al-Uqsur",
          state_id: "1073",
        },
      ],
      "al-Wadi al-Jadid": [],
      "as-Suways": [
        {
          id: "15593",
          name: "as-Suways",
          state_id: "1075",
        },
      ],
      "ash-Sharqiyah": [
        {
          id: "15594",
          name: "Abu Hammad",
          state_id: "1076",
        },
        {
          id: "15595",
          name: "Abu Kabir",
          state_id: "1076",
        },
        {
          id: "15596",
          name: "Bilbays",
          state_id: "1076",
        },
        {
          id: "15597",
          name: "Diyarb Najm",
          state_id: "1076",
        },
        {
          id: "15598",
          name: "Faqus",
          state_id: "1076",
        },
        {
          id: "15599",
          name: "Hihya",
          state_id: "1076",
        },
        {
          id: "15600",
          name: "Kafr Saqr",
          state_id: "1076",
        },
        {
          id: "15601",
          name: "Mashtul-as-Suq",
          state_id: "1076",
        },
        {
          id: "15602",
          name: "Minyat-al-Qamh",
          state_id: "1076",
        },
        {
          id: "15603",
          name: "al-Ashir mir-Ramadan",
          state_id: "1076",
        },
        {
          id: "15604",
          name: "al-Husayniyah",
          state_id: "1076",
        },
        {
          id: "15605",
          name: "al-Ibrahimiyah",
          state_id: "1076",
        },
        {
          id: "15606",
          name: "al-Qanayat",
          state_id: "1076",
        },
        {
          id: "15607",
          name: "al-Qassasin",
          state_id: "1076",
        },
        {
          id: "15608",
          name: "al-Qurayn",
          state_id: "1076",
        },
        {
          id: "15609",
          name: "as-Salihiyah",
          state_id: "1076",
        },
        {
          id: "15610",
          name: "at-Tall-al-Kabir",
          state_id: "1076",
        },
        {
          id: "15611",
          name: "az-Zaqaziq",
          state_id: "1076",
        },
      ],
    },
  },
  EH: {
    name: "Western Sahara",
    native: "الصحراء الغربية",
    phone: "212",
    continent: "AF",
    capital: "El Aaiún",
    currency: "MAD,DZD,MRO",
    languages: ["es"],
    emoji: "🇪🇭",
    emojiU: "U+1F1EA U+1F1ED",
    states: {
      "Bu Jaydur": [],
      "Wad-adh-Dhahab": [
        {
          id: "47405",
          name: "ad-Dakhlah",
          state_id: "4074",
        },
      ],
      "al-''Ayun": [
        {
          id: "47406",
          name: "al-''Ayun",
          state_id: "4075",
        },
      ],
      "as-Samarah": [
        {
          id: "47407",
          name: "as-Samarah",
          state_id: "4076",
        },
      ],
    },
  },
  ER: {
    name: "Eritrea",
    native: "ኤርትራ",
    phone: "291",
    continent: "AF",
    capital: "Asmara",
    currency: "ERN",
    languages: ["ti", "ar", "en"],
    emoji: "🇪🇷",
    emojiU: "U+1F1EA U+1F1F7",
    states: {
      Anseba: [
        {
          id: "15667",
          name: "Keren",
          state_id: "1098",
        },
      ],
      Debub: [
        {
          id: "15668",
          name: "Addi Kwala",
          state_id: "1099",
        },
        {
          id: "15669",
          name: "Addi Ugri",
          state_id: "1099",
        },
      ],
      "Debub-Keih-Bahri": [
        {
          id: "15670",
          name: "Asseb",
          state_id: "1100",
        },
        {
          id: "15671",
          name: "Beylul",
          state_id: "1100",
        },
        {
          id: "15672",
          name: "Edd",
          state_id: "1100",
        },
        {
          id: "15673",
          name: "Mersa Fatma",
          state_id: "1100",
        },
      ],
      "Gash-Barka": [
        {
          id: "15674",
          name: "Ak''ordat",
          state_id: "1101",
        },
        {
          id: "15675",
          name: "Barentu",
          state_id: "1101",
        },
        {
          id: "15676",
          name: "Teseney",
          state_id: "1101",
        },
      ],
      Maekel: [
        {
          id: "15677",
          name: "Asmara",
          state_id: "1102",
        },
        {
          id: "15678",
          name: "Ginda",
          state_id: "1102",
        },
        {
          id: "15679",
          name: "Himbirti",
          state_id: "1102",
        },
        {
          id: "15680",
          name: "Nefasit",
          state_id: "1102",
        },
      ],
      "Semien-Keih-Bahri": [
        {
          id: "15681",
          name: "Addi K''eyih",
          state_id: "1103",
        },
        {
          id: "15682",
          name: "Dek''emhare",
          state_id: "1103",
        },
        {
          id: "15683",
          name: "Mitsiwa",
          state_id: "1103",
        },
        {
          id: "15684",
          name: "Sen''afe",
          state_id: "1103",
        },
      ],
    },
  },
  ES: {
    name: "Spain",
    native: "España",
    phone: "34",
    continent: "EU",
    capital: "Madrid",
    currency: "EUR",
    languages: ["es", "eu", "ca", "gl", "oc"],
    emoji: "🇪🇸",
    emojiU: "U+1F1EA U+1F1F8",
    states: {
      "A Coruna": [],
      Alacant: [
        {
          id: "38131",
          name: "ALbatera",
          state_id: "3255",
        },
        {
          id: "38132",
          name: "Alacant",
          state_id: "3255",
        },
        {
          id: "38133",
          name: "Alcoi",
          state_id: "3255",
        },
        {
          id: "38134",
          name: "Almoradi",
          state_id: "3255",
        },
        {
          id: "38135",
          name: "Altea",
          state_id: "3255",
        },
        {
          id: "38136",
          name: "Aspe",
          state_id: "3255",
        },
        {
          id: "38137",
          name: "Benidorm",
          state_id: "3255",
        },
        {
          id: "38138",
          name: "Benissa",
          state_id: "3255",
        },
        {
          id: "38139",
          name: "Callosa de Segura",
          state_id: "3255",
        },
        {
          id: "38140",
          name: "Calp",
          state_id: "3255",
        },
        {
          id: "38141",
          name: "Cocentaina",
          state_id: "3255",
        },
        {
          id: "38142",
          name: "Crevillent",
          state_id: "3255",
        },
        {
          id: "38143",
          name: "Denia",
          state_id: "3255",
        },
        {
          id: "38144",
          name: "El Campello",
          state_id: "3255",
        },
        {
          id: "38145",
          name: "Elda",
          state_id: "3255",
        },
        {
          id: "38146",
          name: "Elx",
          state_id: "3255",
        },
        {
          id: "38147",
          name: "Guardamar del Segura",
          state_id: "3255",
        },
        {
          id: "38148",
          name: "Ibi",
          state_id: "3255",
        },
        {
          id: "38149",
          name: "L''Alfas del Pi",
          state_id: "3255",
        },
        {
          id: "38150",
          name: "La Vila Joiosa",
          state_id: "3255",
        },
        {
          id: "38151",
          name: "Monover",
          state_id: "3255",
        },
        {
          id: "38152",
          name: "Mutxamel",
          state_id: "3255",
        },
        {
          id: "38153",
          name: "Novelda",
          state_id: "3255",
        },
        {
          id: "38154",
          name: "Orihuela",
          state_id: "3255",
        },
        {
          id: "38155",
          name: "Pedreguer",
          state_id: "3255",
        },
        {
          id: "38156",
          name: "Pego",
          state_id: "3255",
        },
        {
          id: "38157",
          name: "Petrer",
          state_id: "3255",
        },
        {
          id: "38158",
          name: "Pilar de la Horadada",
          state_id: "3255",
        },
        {
          id: "38159",
          name: "Pinoso",
          state_id: "3255",
        },
        {
          id: "38160",
          name: "Rojales",
          state_id: "3255",
        },
        {
          id: "38161",
          name: "Sant Joan d''Alacant",
          state_id: "3255",
        },
        {
          id: "38162",
          name: "Sant Vicent del Raspeig",
          state_id: "3255",
        },
        {
          id: "38163",
          name: "Santa Pola",
          state_id: "3255",
        },
        {
          id: "38164",
          name: "Sax",
          state_id: "3255",
        },
        {
          id: "38165",
          name: "Teulada",
          state_id: "3255",
        },
        {
          id: "38166",
          name: "Torrevieja",
          state_id: "3255",
        },
        {
          id: "38167",
          name: "Villena",
          state_id: "3255",
        },
        {
          id: "38168",
          name: "Xabia",
          state_id: "3255",
        },
      ],
      Alava: [
        {
          id: "38169",
          name: "Amurrio",
          state_id: "3256",
        },
        {
          id: "38170",
          name: "Llodio",
          state_id: "3256",
        },
        {
          id: "38171",
          name: "Vitoria",
          state_id: "3256",
        },
      ],
      Albacete: [
        {
          id: "38172",
          name: "Albacete",
          state_id: "3257",
        },
        {
          id: "38173",
          name: "Almansa",
          state_id: "3257",
        },
        {
          id: "38174",
          name: "Caudete",
          state_id: "3257",
        },
        {
          id: "38175",
          name: "Hellin",
          state_id: "3257",
        },
        {
          id: "38176",
          name: "La Roda",
          state_id: "3257",
        },
        {
          id: "38177",
          name: "Villarrobledo",
          state_id: "3257",
        },
      ],
      Almeria: [
        {
          id: "38178",
          name: "Adra",
          state_id: "3258",
        },
        {
          id: "38179",
          name: "Albox",
          state_id: "3258",
        },
        {
          id: "38180",
          name: "Almeria",
          state_id: "3258",
        },
        {
          id: "38181",
          name: "Berja",
          state_id: "3258",
        },
        {
          id: "38182",
          name: "Cuevas del Almanzora",
          state_id: "3258",
        },
        {
          id: "38183",
          name: "El Ejido",
          state_id: "3258",
        },
        {
          id: "38184",
          name: "Huercal de Almeria",
          state_id: "3258",
        },
        {
          id: "38185",
          name: "Huercal-Overa",
          state_id: "3258",
        },
        {
          id: "38186",
          name: "Nijar",
          state_id: "3258",
        },
        {
          id: "38187",
          name: "Roquetas de Mar",
          state_id: "3258",
        },
        {
          id: "38188",
          name: "Vicar",
          state_id: "3258",
        },
      ],
      Andalucia: [
        {
          id: "38189",
          name: "Benalmadena",
          state_id: "3259",
        },
      ],
      Asturias: [
        {
          id: "38190",
          name: "Aller",
          state_id: "3260",
        },
        {
          id: "38191",
          name: "Aviles",
          state_id: "3260",
        },
        {
          id: "38192",
          name: "C/ Pena Salon",
          state_id: "3260",
        },
        {
          id: "38193",
          name: "Cangas del Narcea",
          state_id: "3260",
        },
        {
          id: "38194",
          name: "Carreno",
          state_id: "3260",
        },
        {
          id: "38195",
          name: "Castrillon",
          state_id: "3260",
        },
        {
          id: "38196",
          name: "Corvera de Asturias",
          state_id: "3260",
        },
        {
          id: "38197",
          name: "Gijon",
          state_id: "3260",
        },
        {
          id: "38198",
          name: "Gozon",
          state_id: "3260",
        },
        {
          id: "38199",
          name: "Grado",
          state_id: "3260",
        },
        {
          id: "38200",
          name: "Langreo",
          state_id: "3260",
        },
        {
          id: "38201",
          name: "Laviana",
          state_id: "3260",
        },
        {
          id: "38202",
          name: "Lena",
          state_id: "3260",
        },
        {
          id: "38203",
          name: "Llanera",
          state_id: "3260",
        },
        {
          id: "38204",
          name: "Llanes",
          state_id: "3260",
        },
        {
          id: "38205",
          name: "Mieres",
          state_id: "3260",
        },
        {
          id: "38206",
          name: "Navia",
          state_id: "3260",
        },
        {
          id: "38207",
          name: "Oviedo",
          state_id: "3260",
        },
        {
          id: "38208",
          name: "Pilona",
          state_id: "3260",
        },
        {
          id: "38209",
          name: "Pravia",
          state_id: "3260",
        },
        {
          id: "38210",
          name: "San Martin del Rey Aurelio",
          state_id: "3260",
        },
        {
          id: "38211",
          name: "Siero",
          state_id: "3260",
        },
        {
          id: "38212",
          name: "Tineo",
          state_id: "3260",
        },
        {
          id: "38213",
          name: "Valdes",
          state_id: "3260",
        },
        {
          id: "38214",
          name: "Villaviciosa",
          state_id: "3260",
        },
      ],
      Avila: [
        {
          id: "38215",
          name: "Avila",
          state_id: "3261",
        },
      ],
      Badajoz: [
        {
          id: "38216",
          name: "Almendralejo",
          state_id: "3262",
        },
        {
          id: "38217",
          name: "Azuaga",
          state_id: "3262",
        },
        {
          id: "38218",
          name: "Badajoz",
          state_id: "3262",
        },
        {
          id: "38219",
          name: "Don Benito",
          state_id: "3262",
        },
        {
          id: "38220",
          name: "Jerez de los Caballeros",
          state_id: "3262",
        },
        {
          id: "38221",
          name: "Merida",
          state_id: "3262",
        },
        {
          id: "38222",
          name: "Montijo",
          state_id: "3262",
        },
        {
          id: "38223",
          name: "Olivenza",
          state_id: "3262",
        },
        {
          id: "38224",
          name: "Villafranca de los Barros",
          state_id: "3262",
        },
        {
          id: "38225",
          name: "Villanueva de la Serena",
          state_id: "3262",
        },
        {
          id: "38226",
          name: "Zafra",
          state_id: "3262",
        },
      ],
      Balears: [
        {
          id: "38227",
          name: "Alayor-Menorca",
          state_id: "3263",
        },
        {
          id: "38228",
          name: "Alcudia",
          state_id: "3263",
        },
        {
          id: "38229",
          name: "Calvia",
          state_id: "3263",
        },
        {
          id: "38230",
          name: "Capdepera",
          state_id: "3263",
        },
        {
          id: "38231",
          name: "Ciutadella de Menorca",
          state_id: "3263",
        },
        {
          id: "38232",
          name: "Eivissa",
          state_id: "3263",
        },
        {
          id: "38233",
          name: "Felanitx",
          state_id: "3263",
        },
        {
          id: "38234",
          name: "Inca",
          state_id: "3263",
        },
        {
          id: "38235",
          name: "Llucmajor",
          state_id: "3263",
        },
        {
          id: "38236",
          name: "Mahon",
          state_id: "3263",
        },
        {
          id: "38237",
          name: "Manacor",
          state_id: "3263",
        },
        {
          id: "38238",
          name: "Marratxi",
          state_id: "3263",
        },
        {
          id: "38239",
          name: "Palma",
          state_id: "3263",
        },
        {
          id: "38240",
          name: "Pollenca",
          state_id: "3263",
        },
        {
          id: "38241",
          name: "Sa Pobla",
          state_id: "3263",
        },
        {
          id: "38242",
          name: "Sant Antoni de Portmany",
          state_id: "3263",
        },
        {
          id: "38243",
          name: "Sant Josep de sa Talaia",
          state_id: "3263",
        },
        {
          id: "38244",
          name: "Santa Eulalia del Rio",
          state_id: "3263",
        },
        {
          id: "38245",
          name: "Santanyi",
          state_id: "3263",
        },
        {
          id: "38246",
          name: "Soller",
          state_id: "3263",
        },
      ],
      Barcelona: [
        {
          id: "38247",
          name: "Abrera",
          state_id: "3264",
        },
        {
          id: "38248",
          name: "Alella",
          state_id: "3264",
        },
        {
          id: "38249",
          name: "Arenys de Mar",
          state_id: "3264",
        },
        {
          id: "38250",
          name: "Argentona",
          state_id: "3264",
        },
        {
          id: "38251",
          name: "Badalona",
          state_id: "3264",
        },
        {
          id: "38252",
          name: "Badia del Valles",
          state_id: "3264",
        },
        {
          id: "38253",
          name: "Barbera del Valles",
          state_id: "3264",
        },
        {
          id: "38254",
          name: "Barcelona",
          state_id: "3264",
        },
        {
          id: "38255",
          name: "Berga",
          state_id: "3264",
        },
        {
          id: "38256",
          name: "Cabrera de Mar",
          state_id: "3264",
        },
        {
          id: "38257",
          name: "Caldes de Montbui",
          state_id: "3264",
        },
        {
          id: "38258",
          name: "Calella",
          state_id: "3264",
        },
        {
          id: "38259",
          name: "Canet de Mar",
          state_id: "3264",
        },
        {
          id: "38260",
          name: "Canovelles",
          state_id: "3264",
        },
        {
          id: "38261",
          name: "Cardedeu",
          state_id: "3264",
        },
        {
          id: "38262",
          name: "Castellar del Valles",
          state_id: "3264",
        },
        {
          id: "38263",
          name: "Castellbisbal",
          state_id: "3264",
        },
        {
          id: "38264",
          name: "Castelldefels",
          state_id: "3264",
        },
        {
          id: "38265",
          name: "Cerdanyola",
          state_id: "3264",
        },
        {
          id: "38266",
          name: "Corbera de Llobregat",
          state_id: "3264",
        },
        {
          id: "38267",
          name: "Cornella",
          state_id: "3264",
        },
        {
          id: "38268",
          name: "El Masnou",
          state_id: "3264",
        },
        {
          id: "38269",
          name: "El Prat de Llobregat",
          state_id: "3264",
        },
        {
          id: "38270",
          name: "Esparreguera",
          state_id: "3264",
        },
        {
          id: "38271",
          name: "Esplugues de Llobregat",
          state_id: "3264",
        },
        {
          id: "38272",
          name: "Gava",
          state_id: "3264",
        },
        {
          id: "38273",
          name: "Granollers",
          state_id: "3264",
        },
        {
          id: "38274",
          name: "Igualada",
          state_id: "3264",
        },
        {
          id: "38275",
          name: "L''Hospitalet de Llobregat",
          state_id: "3264",
        },
        {
          id: "38276",
          name: "La Garriga",
          state_id: "3264",
        },
        {
          id: "38277",
          name: "La Llagosta",
          state_id: "3264",
        },
        {
          id: "38278",
          name: "Les Franquesas del Valles",
          state_id: "3264",
        },
        {
          id: "38279",
          name: "Llica d''Amunt",
          state_id: "3264",
        },
        {
          id: "38280",
          name: "Malgrat de Mar",
          state_id: "3264",
        },
        {
          id: "38281",
          name: "Manlleu",
          state_id: "3264",
        },
        {
          id: "38282",
          name: "Manresa",
          state_id: "3264",
        },
        {
          id: "38283",
          name: "Martorell",
          state_id: "3264",
        },
        {
          id: "38284",
          name: "Mataro",
          state_id: "3264",
        },
        {
          id: "38285",
          name: "Molins de Rei",
          state_id: "3264",
        },
        {
          id: "38286",
          name: "Mollet del Valles",
          state_id: "3264",
        },
        {
          id: "38287",
          name: "Montcada i Reixac",
          state_id: "3264",
        },
        {
          id: "38288",
          name: "Montgat",
          state_id: "3264",
        },
        {
          id: "38289",
          name: "Montmelo",
          state_id: "3264",
        },
        {
          id: "38290",
          name: "Montornes del Valles",
          state_id: "3264",
        },
        {
          id: "38291",
          name: "Olesa de Montserrat",
          state_id: "3264",
        },
        {
          id: "38292",
          name: "Palau-solita i Plegamans",
          state_id: "3264",
        },
        {
          id: "38293",
          name: "Palleja",
          state_id: "3264",
        },
        {
          id: "38294",
          name: "Parets del Valles",
          state_id: "3264",
        },
        {
          id: "38295",
          name: "Piera",
          state_id: "3264",
        },
        {
          id: "38296",
          name: "Pineda de Mar",
          state_id: "3264",
        },
        {
          id: "38297",
          name: "Premia de Dalt",
          state_id: "3264",
        },
        {
          id: "38298",
          name: "Premia de Mar",
          state_id: "3264",
        },
        {
          id: "38299",
          name: "Ripollet",
          state_id: "3264",
        },
        {
          id: "38300",
          name: "Rubi",
          state_id: "3264",
        },
        {
          id: "38301",
          name: "Sabadell",
          state_id: "3264",
        },
        {
          id: "38302",
          name: "Sant Adria de Besos",
          state_id: "3264",
        },
        {
          id: "38303",
          name: "Sant Andreu de la Barca",
          state_id: "3264",
        },
        {
          id: "38304",
          name: "Sant Boi de Llobregat",
          state_id: "3264",
        },
        {
          id: "38305",
          name: "Sant Celoni",
          state_id: "3264",
        },
        {
          id: "38306",
          name: "Sant Cugat del Valles",
          state_id: "3264",
        },
        {
          id: "38307",
          name: "Sant Feliu de Llobregat",
          state_id: "3264",
        },
        {
          id: "38308",
          name: "Sant Joan Despi",
          state_id: "3264",
        },
        {
          id: "38309",
          name: "Sant Joan de Vilatorrada",
          state_id: "3264",
        },
        {
          id: "38310",
          name: "Sant Just Desvern",
          state_id: "3264",
        },
        {
          id: "38311",
          name: "Sant Pere de Ribes",
          state_id: "3264",
        },
        {
          id: "38312",
          name: "Sant Quirze del Valles",
          state_id: "3264",
        },
        {
          id: "38313",
          name: "Sant Sadurni d''Anoia",
          state_id: "3264",
        },
        {
          id: "38314",
          name: "Sant Vicenc dels Horts",
          state_id: "3264",
        },
        {
          id: "38315",
          name: "Santa Coloma de Gramenet",
          state_id: "3264",
        },
        {
          id: "38316",
          name: "Santa Margarida de Montbui",
          state_id: "3264",
        },
        {
          id: "38317",
          name: "Santa Perpetua de Mogoda",
          state_id: "3264",
        },
        {
          id: "38318",
          name: "Sitges",
          state_id: "3264",
        },
        {
          id: "38319",
          name: "Son Servera",
          state_id: "3264",
        },
        {
          id: "38320",
          name: "Terrassa",
          state_id: "3264",
        },
        {
          id: "38321",
          name: "Tordera",
          state_id: "3264",
        },
        {
          id: "38322",
          name: "Torello",
          state_id: "3264",
        },
        {
          id: "38323",
          name: "Vallirana",
          state_id: "3264",
        },
        {
          id: "38324",
          name: "Vic",
          state_id: "3264",
        },
        {
          id: "38325",
          name: "Viladecans",
          state_id: "3264",
        },
        {
          id: "38326",
          name: "Viladecavalls",
          state_id: "3264",
        },
        {
          id: "38327",
          name: "Vilafranca del Penedes",
          state_id: "3264",
        },
        {
          id: "38328",
          name: "Vilanova del Cami",
          state_id: "3264",
        },
        {
          id: "38329",
          name: "Vilanova i la Geltru",
          state_id: "3264",
        },
        {
          id: "38330",
          name: "Vilassar del Mar",
          state_id: "3264",
        },
      ],
      Bertamirans: [
        {
          id: "38331",
          name: "Bertamirans",
          state_id: "3265",
        },
      ],
      Biscay: [
        {
          id: "38332",
          name: "Berriatua",
          state_id: "3266",
        },
        {
          id: "38333",
          name: "Derio",
          state_id: "3266",
        },
        {
          id: "38334",
          name: "Elorio",
          state_id: "3266",
        },
        {
          id: "38335",
          name: "Loiu",
          state_id: "3266",
        },
      ],
      Burgos: [
        {
          id: "38336",
          name: "Aranda de Duero",
          state_id: "3267",
        },
        {
          id: "38337",
          name: "Burgos",
          state_id: "3267",
        },
        {
          id: "38338",
          name: "Miranda de Ebro",
          state_id: "3267",
        },
      ],
      Caceres: [
        {
          id: "38339",
          name: "Caceres",
          state_id: "3268",
        },
        {
          id: "38340",
          name: "Coria",
          state_id: "3268",
        },
        {
          id: "38341",
          name: "Miajadas",
          state_id: "3268",
        },
        {
          id: "38342",
          name: "Navalmoral de la Mata",
          state_id: "3268",
        },
        {
          id: "38343",
          name: "Plasencia",
          state_id: "3268",
        },
        {
          id: "38344",
          name: "Talayuela",
          state_id: "3268",
        },
        {
          id: "38345",
          name: "Trujillo",
          state_id: "3268",
        },
      ],
      Cadiz: [
        {
          id: "38346",
          name: "Algeciras",
          state_id: "3269",
        },
        {
          id: "38347",
          name: "Arcos de la Frontera",
          state_id: "3269",
        },
        {
          id: "38348",
          name: "Barbate",
          state_id: "3269",
        },
        {
          id: "38349",
          name: "Cadiz",
          state_id: "3269",
        },
        {
          id: "38350",
          name: "Chiclana",
          state_id: "3269",
        },
        {
          id: "38351",
          name: "Chipiona",
          state_id: "3269",
        },
        {
          id: "38352",
          name: "Conil",
          state_id: "3269",
        },
        {
          id: "38353",
          name: "El Puerto de Santa Maria",
          state_id: "3269",
        },
        {
          id: "38354",
          name: "Jerez",
          state_id: "3269",
        },
        {
          id: "38355",
          name: "Jimena de la Frontera",
          state_id: "3269",
        },
        {
          id: "38356",
          name: "La Linea",
          state_id: "3269",
        },
        {
          id: "38357",
          name: "Los Barrios",
          state_id: "3269",
        },
        {
          id: "38358",
          name: "Medina-Sidonia",
          state_id: "3269",
        },
        {
          id: "38359",
          name: "Olvera",
          state_id: "3269",
        },
        {
          id: "38360",
          name: "Puerto Real",
          state_id: "3269",
        },
        {
          id: "38361",
          name: "Rota",
          state_id: "3269",
        },
        {
          id: "38362",
          name: "San Fernando",
          state_id: "3269",
        },
        {
          id: "38363",
          name: "San Roque",
          state_id: "3269",
        },
        {
          id: "38364",
          name: "Sanlucar de Barrameda",
          state_id: "3269",
        },
        {
          id: "38365",
          name: "Tarifa",
          state_id: "3269",
        },
        {
          id: "38366",
          name: "Ubrique",
          state_id: "3269",
        },
        {
          id: "38367",
          name: "Vejer de la Frontera",
          state_id: "3269",
        },
        {
          id: "38368",
          name: "Villamartin",
          state_id: "3269",
        },
      ],
      Cantabria: [
        {
          id: "38369",
          name: "Camargo",
          state_id: "3270",
        },
        {
          id: "38370",
          name: "Castro-Urdiales",
          state_id: "3270",
        },
        {
          id: "38371",
          name: "El Astillero",
          state_id: "3270",
        },
        {
          id: "38372",
          name: "Laredo",
          state_id: "3270",
        },
        {
          id: "38373",
          name: "Los Corrales de Buelna",
          state_id: "3270",
        },
        {
          id: "38374",
          name: "Pielagos",
          state_id: "3270",
        },
        {
          id: "38375",
          name: "Reinosa",
          state_id: "3270",
        },
        {
          id: "38376",
          name: "San Felices De Buelna",
          state_id: "3270",
        },
        {
          id: "38377",
          name: "Santa Cruz de Bezana",
          state_id: "3270",
        },
        {
          id: "38378",
          name: "Santander",
          state_id: "3270",
        },
        {
          id: "38379",
          name: "Santona",
          state_id: "3270",
        },
        {
          id: "38380",
          name: "Torrelavega",
          state_id: "3270",
        },
      ],
      Castello: [
        {
          id: "38381",
          name: "Almassora",
          state_id: "3271",
        },
        {
          id: "38382",
          name: "Benicarlo",
          state_id: "3271",
        },
        {
          id: "38383",
          name: "Benicassim",
          state_id: "3271",
        },
        {
          id: "38384",
          name: "Burriana",
          state_id: "3271",
        },
        {
          id: "38385",
          name: "Castello",
          state_id: "3271",
        },
        {
          id: "38386",
          name: "L''Alcora",
          state_id: "3271",
        },
        {
          id: "38387",
          name: "La Vall d''Uixo",
          state_id: "3271",
        },
        {
          id: "38388",
          name: "Nules",
          state_id: "3271",
        },
        {
          id: "38389",
          name: "Onda",
          state_id: "3271",
        },
        {
          id: "38390",
          name: "Segorbe",
          state_id: "3271",
        },
        {
          id: "38391",
          name: "Vila-real",
          state_id: "3271",
        },
        {
          id: "38392",
          name: "Vinaros",
          state_id: "3271",
        },
      ],
      Catalunya: [
        {
          id: "38393",
          name: "Barcelona",
          state_id: "3272",
        },
      ],
      Ceuta: [
        {
          id: "38394",
          name: "Ceuta",
          state_id: "3273",
        },
      ],
      "Ciudad Real": [],
      "Comunidad Autonoma de Canarias": [],
      "Comunidad Autonoma de Cataluna": [],
      "Comunidad Autonoma de Galicia": [],
      "Comunidad Autonoma de las Isla": [],
      "Comunidad Autonoma del Princip": [],
      "Comunidad Valenciana": [],
      Cordoba: [
        {
          id: "38395",
          name: "Aguilar de la Frontera",
          state_id: "3281",
        },
        {
          id: "38396",
          name: "Baena",
          state_id: "3281",
        },
        {
          id: "38397",
          name: "Bujalance",
          state_id: "3281",
        },
        {
          id: "38398",
          name: "Cabra",
          state_id: "3281",
        },
        {
          id: "38399",
          name: "Cordoba",
          state_id: "3281",
        },
        {
          id: "38400",
          name: "Fernan-Nunez",
          state_id: "3281",
        },
        {
          id: "38401",
          name: "Fuente Palmera",
          state_id: "3281",
        },
        {
          id: "38402",
          name: "La Carlota",
          state_id: "3281",
        },
        {
          id: "38403",
          name: "Lucena",
          state_id: "3281",
        },
        {
          id: "38404",
          name: "Luque",
          state_id: "3281",
        },
        {
          id: "38405",
          name: "Montilla",
          state_id: "3281",
        },
        {
          id: "38406",
          name: "Montoro",
          state_id: "3281",
        },
        {
          id: "38407",
          name: "Palma del Rio",
          state_id: "3281",
        },
        {
          id: "38408",
          name: "Penarroya-Pueblonuevo",
          state_id: "3281",
        },
        {
          id: "38409",
          name: "Pozoblanco",
          state_id: "3281",
        },
        {
          id: "38410",
          name: "Priego de Cordoba",
          state_id: "3281",
        },
        {
          id: "38411",
          name: "Puente Genil",
          state_id: "3281",
        },
        {
          id: "38412",
          name: "Rute",
          state_id: "3281",
        },
        {
          id: "38413",
          name: "Villanueva de Cordoba",
          state_id: "3281",
        },
      ],
      Cuenca: [
        {
          id: "38414",
          name: "Cuenca",
          state_id: "3282",
        },
        {
          id: "38415",
          name: "Tarancon",
          state_id: "3282",
        },
      ],
      Gipuzkoa: [
        {
          id: "38416",
          name: "Aduna",
          state_id: "3283",
        },
        {
          id: "38417",
          name: "Lazakao",
          state_id: "3283",
        },
      ],
      Girona: [
        {
          id: "38418",
          name: "Banyoles",
          state_id: "3284",
        },
        {
          id: "38419",
          name: "Blanes",
          state_id: "3284",
        },
        {
          id: "38420",
          name: "Empuriabrava",
          state_id: "3284",
        },
        {
          id: "38421",
          name: "Figueres",
          state_id: "3284",
        },
        {
          id: "38422",
          name: "Girona",
          state_id: "3284",
        },
        {
          id: "38423",
          name: "La Bisbal d''Emporda",
          state_id: "3284",
        },
        {
          id: "38424",
          name: "Lloret de Mar",
          state_id: "3284",
        },
        {
          id: "38425",
          name: "Massanet de la Selva",
          state_id: "3284",
        },
        {
          id: "38426",
          name: "Olot",
          state_id: "3284",
        },
        {
          id: "38427",
          name: "Palafrugell",
          state_id: "3284",
        },
        {
          id: "38428",
          name: "Palamos",
          state_id: "3284",
        },
        {
          id: "38429",
          name: "Ripoll",
          state_id: "3284",
        },
        {
          id: "38430",
          name: "Roses",
          state_id: "3284",
        },
        {
          id: "38431",
          name: "Salt",
          state_id: "3284",
        },
        {
          id: "38432",
          name: "Sant Feliu de Guixols",
          state_id: "3284",
        },
        {
          id: "38433",
          name: "Santa Coloma de Farners",
          state_id: "3284",
        },
        {
          id: "38434",
          name: "Torroella de Montgri",
          state_id: "3284",
        },
      ],
      Granada: [
        {
          id: "38435",
          name: "Albolote",
          state_id: "3285",
        },
        {
          id: "38436",
          name: "Almunecar",
          state_id: "3285",
        },
        {
          id: "38437",
          name: "Armilla",
          state_id: "3285",
        },
        {
          id: "38438",
          name: "Atarfe",
          state_id: "3285",
        },
        {
          id: "38439",
          name: "Baza",
          state_id: "3285",
        },
        {
          id: "38440",
          name: "Granada",
          state_id: "3285",
        },
        {
          id: "38441",
          name: "Guadix",
          state_id: "3285",
        },
        {
          id: "38442",
          name: "Huescar",
          state_id: "3285",
        },
        {
          id: "38443",
          name: "Huetor Tajar",
          state_id: "3285",
        },
        {
          id: "38444",
          name: "Huetor Vega",
          state_id: "3285",
        },
        {
          id: "38445",
          name: "Illora",
          state_id: "3285",
        },
        {
          id: "38446",
          name: "La Zubia",
          state_id: "3285",
        },
        {
          id: "38447",
          name: "Las Gabias",
          state_id: "3285",
        },
        {
          id: "38448",
          name: "Loja",
          state_id: "3285",
        },
        {
          id: "38449",
          name: "Maracena",
          state_id: "3285",
        },
        {
          id: "38450",
          name: "Motril",
          state_id: "3285",
        },
        {
          id: "38451",
          name: "Ogijares",
          state_id: "3285",
        },
        {
          id: "38452",
          name: "Peligros",
          state_id: "3285",
        },
        {
          id: "38453",
          name: "Pinos Puente",
          state_id: "3285",
        },
        {
          id: "38454",
          name: "Salobrena",
          state_id: "3285",
        },
        {
          id: "38455",
          name: "Santa Fe",
          state_id: "3285",
        },
      ],
      Guadalajara: [
        {
          id: "38456",
          name: "Azuqueca de Henares",
          state_id: "3286",
        },
        {
          id: "38457",
          name: "Guadalajara",
          state_id: "3286",
        },
      ],
      Guipuzcoa: [
        {
          id: "38458",
          name: "Andoain",
          state_id: "3287",
        },
        {
          id: "38459",
          name: "Anoeta",
          state_id: "3287",
        },
        {
          id: "38460",
          name: "Arrasate",
          state_id: "3287",
        },
        {
          id: "38461",
          name: "Azkoitia",
          state_id: "3287",
        },
        {
          id: "38462",
          name: "Azpeitia",
          state_id: "3287",
        },
        {
          id: "38463",
          name: "Beasain",
          state_id: "3287",
        },
        {
          id: "38464",
          name: "Bergara",
          state_id: "3287",
        },
        {
          id: "38465",
          name: "Donostia",
          state_id: "3287",
        },
        {
          id: "38466",
          name: "Eibar",
          state_id: "3287",
        },
        {
          id: "38467",
          name: "Elgoibar",
          state_id: "3287",
        },
        {
          id: "38468",
          name: "Errenteria",
          state_id: "3287",
        },
        {
          id: "38469",
          name: "Guipuuzcoa",
          state_id: "3287",
        },
        {
          id: "38470",
          name: "Hernani",
          state_id: "3287",
        },
        {
          id: "38471",
          name: "Hondarribia",
          state_id: "3287",
        },
        {
          id: "38472",
          name: "Irun",
          state_id: "3287",
        },
        {
          id: "38473",
          name: "Legazpi",
          state_id: "3287",
        },
        {
          id: "38474",
          name: "Mendaro",
          state_id: "3287",
        },
        {
          id: "38475",
          name: "Mondragon",
          state_id: "3287",
        },
        {
          id: "38476",
          name: "Oiartzun",
          state_id: "3287",
        },
        {
          id: "38477",
          name: "Onati",
          state_id: "3287",
        },
        {
          id: "38478",
          name: "Ordizia",
          state_id: "3287",
        },
        {
          id: "38479",
          name: "Oria",
          state_id: "3287",
        },
        {
          id: "38480",
          name: "Pasaia",
          state_id: "3287",
        },
        {
          id: "38481",
          name: "Tolosa",
          state_id: "3287",
        },
        {
          id: "38482",
          name: "Zarautz",
          state_id: "3287",
        },
        {
          id: "38483",
          name: "Zumaia",
          state_id: "3287",
        },
        {
          id: "38484",
          name: "Zumarraga",
          state_id: "3287",
        },
      ],
      Huelva: [
        {
          id: "38485",
          name: "Aljaraque",
          state_id: "3288",
        },
        {
          id: "38486",
          name: "Almonte",
          state_id: "3288",
        },
        {
          id: "38487",
          name: "Ayamonte",
          state_id: "3288",
        },
        {
          id: "38488",
          name: "Bollullos Par del Condado",
          state_id: "3288",
        },
        {
          id: "38489",
          name: "Cartaya",
          state_id: "3288",
        },
        {
          id: "38490",
          name: "Gibraleon",
          state_id: "3288",
        },
        {
          id: "38491",
          name: "Huelva",
          state_id: "3288",
        },
        {
          id: "38492",
          name: "Isla Cristina",
          state_id: "3288",
        },
        {
          id: "38493",
          name: "La Palma del Condado",
          state_id: "3288",
        },
        {
          id: "38494",
          name: "Lepe",
          state_id: "3288",
        },
        {
          id: "38495",
          name: "Moguer",
          state_id: "3288",
        },
        {
          id: "38496",
          name: "Punta Umbria",
          state_id: "3288",
        },
        {
          id: "38497",
          name: "Valverde del Camino",
          state_id: "3288",
        },
      ],
      Huesca: [
        {
          id: "38498",
          name: "Barbastro",
          state_id: "3289",
        },
        {
          id: "38499",
          name: "Binefar",
          state_id: "3289",
        },
        {
          id: "38500",
          name: "Fraga",
          state_id: "3289",
        },
        {
          id: "38501",
          name: "Huesca",
          state_id: "3289",
        },
        {
          id: "38502",
          name: "Jaca",
          state_id: "3289",
        },
        {
          id: "38503",
          name: "Monzon",
          state_id: "3289",
        },
        {
          id: "38504",
          name: "Sabinanigo",
          state_id: "3289",
        },
      ],
      Jaen: [
        {
          id: "38505",
          name: "Alcala la Real",
          state_id: "3290",
        },
        {
          id: "38506",
          name: "Alcaudete",
          state_id: "3290",
        },
        {
          id: "38507",
          name: "Andujar",
          state_id: "3290",
        },
        {
          id: "38508",
          name: "Baeza",
          state_id: "3290",
        },
        {
          id: "38509",
          name: "Bailen",
          state_id: "3290",
        },
        {
          id: "38510",
          name: "Cazorla",
          state_id: "3290",
        },
        {
          id: "38511",
          name: "Jaen",
          state_id: "3290",
        },
        {
          id: "38512",
          name: "Jodar",
          state_id: "3290",
        },
        {
          id: "38513",
          name: "La Carolina",
          state_id: "3290",
        },
        {
          id: "38514",
          name: "Linares",
          state_id: "3290",
        },
        {
          id: "38515",
          name: "Mancha Real",
          state_id: "3290",
        },
        {
          id: "38516",
          name: "Martos",
          state_id: "3290",
        },
        {
          id: "38517",
          name: "Mengibar",
          state_id: "3290",
        },
        {
          id: "38518",
          name: "Torre del Campo",
          state_id: "3290",
        },
        {
          id: "38519",
          name: "Torredonjimeno",
          state_id: "3290",
        },
        {
          id: "38520",
          name: "Ubeda",
          state_id: "3290",
        },
        {
          id: "38521",
          name: "Villacarrillo",
          state_id: "3290",
        },
        {
          id: "38522",
          name: "Villanueva del Arzobispo",
          state_id: "3290",
        },
      ],
      "La Rioja": [],
      "Las Palmas": [],
      Leon: [
        {
          id: "38523",
          name: "Astorga",
          state_id: "3293",
        },
        {
          id: "38524",
          name: "Bembibre",
          state_id: "3293",
        },
        {
          id: "38525",
          name: "La Baneza",
          state_id: "3293",
        },
        {
          id: "38526",
          name: "Leon",
          state_id: "3293",
        },
        {
          id: "38527",
          name: "Ponferrada",
          state_id: "3293",
        },
        {
          id: "38528",
          name: "San Andres del Rabanedo",
          state_id: "3293",
        },
        {
          id: "38529",
          name: "Villablino",
          state_id: "3293",
        },
        {
          id: "38530",
          name: "Villaquilambre",
          state_id: "3293",
        },
      ],
      Lerida: [
        {
          id: "38531",
          name: "Tora",
          state_id: "3294",
        },
      ],
      Lleida: [
        {
          id: "38532",
          name: "Balaguer",
          state_id: "3295",
        },
        {
          id: "38533",
          name: "La Seu d''Urgell",
          state_id: "3295",
        },
        {
          id: "38534",
          name: "Lleida",
          state_id: "3295",
        },
        {
          id: "38535",
          name: "Mollerussa",
          state_id: "3295",
        },
        {
          id: "38536",
          name: "Tarrega",
          state_id: "3295",
        },
      ],
      Lugo: [
        {
          id: "38537",
          name: "Burela",
          state_id: "3296",
        },
        {
          id: "38538",
          name: "Cervo",
          state_id: "3296",
        },
        {
          id: "38539",
          name: "Chantada",
          state_id: "3296",
        },
        {
          id: "38540",
          name: "Foz",
          state_id: "3296",
        },
        {
          id: "38541",
          name: "Lugo",
          state_id: "3296",
        },
        {
          id: "38542",
          name: "Monforte de Lemos",
          state_id: "3296",
        },
        {
          id: "38543",
          name: "Ribadeo",
          state_id: "3296",
        },
        {
          id: "38544",
          name: "Sarria",
          state_id: "3296",
        },
        {
          id: "38545",
          name: "Vilalba",
          state_id: "3296",
        },
        {
          id: "38546",
          name: "Viveiro",
          state_id: "3296",
        },
      ],
      Madrid: [
        {
          id: "38547",
          name: "Alcala de Henares",
          state_id: "3297",
        },
        {
          id: "38548",
          name: "Alcobendas",
          state_id: "3297",
        },
        {
          id: "38549",
          name: "Alcorcon",
          state_id: "3297",
        },
        {
          id: "38550",
          name: "Algete",
          state_id: "3297",
        },
        {
          id: "38551",
          name: "Alpedrete",
          state_id: "3297",
        },
        {
          id: "38552",
          name: "Aranjuez",
          state_id: "3297",
        },
        {
          id: "38553",
          name: "Arganda del Rey",
          state_id: "3297",
        },
        {
          id: "38554",
          name: "Boadilla del Monte",
          state_id: "3297",
        },
        {
          id: "38555",
          name: "Ciempozuelos",
          state_id: "3297",
        },
        {
          id: "38556",
          name: "Collado Villalba",
          state_id: "3297",
        },
        {
          id: "38557",
          name: "Colmenar Viejo",
          state_id: "3297",
        },
        {
          id: "38558",
          name: "Coslada",
          state_id: "3297",
        },
        {
          id: "38559",
          name: "El Escorial",
          state_id: "3297",
        },
        {
          id: "38560",
          name: "Fuenlabrada",
          state_id: "3297",
        },
        {
          id: "38561",
          name: "Galapagar",
          state_id: "3297",
        },
        {
          id: "38562",
          name: "Getafe",
          state_id: "3297",
        },
        {
          id: "38563",
          name: "Guadarrama",
          state_id: "3297",
        },
        {
          id: "38564",
          name: "Humanes de Madrid",
          state_id: "3297",
        },
        {
          id: "38565",
          name: "Las Rozas de Madrid",
          state_id: "3297",
        },
        {
          id: "38566",
          name: "Leganes",
          state_id: "3297",
        },
        {
          id: "38567",
          name: "Madrid",
          state_id: "3297",
        },
        {
          id: "38568",
          name: "Majadahonda",
          state_id: "3297",
        },
        {
          id: "38569",
          name: "Meco",
          state_id: "3297",
        },
        {
          id: "38570",
          name: "Mejorada del Campo",
          state_id: "3297",
        },
        {
          id: "38571",
          name: "Mostoles",
          state_id: "3297",
        },
        {
          id: "38572",
          name: "Navalcarnero",
          state_id: "3297",
        },
        {
          id: "38573",
          name: "Parla",
          state_id: "3297",
        },
        {
          id: "38574",
          name: "Pinto",
          state_id: "3297",
        },
        {
          id: "38575",
          name: "Pozuelo de Alarcon",
          state_id: "3297",
        },
        {
          id: "38576",
          name: "Rivas-Vaciamadrid",
          state_id: "3297",
        },
        {
          id: "38577",
          name: "San Fernando de Henares",
          state_id: "3297",
        },
        {
          id: "38578",
          name: "San Lorenzo de El Escorial",
          state_id: "3297",
        },
        {
          id: "38579",
          name: "San Martin de la Vega",
          state_id: "3297",
        },
        {
          id: "38580",
          name: "San Sebastian de los Reyes",
          state_id: "3297",
        },
        {
          id: "38581",
          name: "Torrejon de Ardoz",
          state_id: "3297",
        },
        {
          id: "38582",
          name: "Torrelodones",
          state_id: "3297",
        },
        {
          id: "38583",
          name: "Tres Cantos",
          state_id: "3297",
        },
        {
          id: "38584",
          name: "Valdemoro",
          state_id: "3297",
        },
        {
          id: "38585",
          name: "Velilla de San Antonio",
          state_id: "3297",
        },
        {
          id: "38586",
          name: "Villanueva de la Canada",
          state_id: "3297",
        },
        {
          id: "38587",
          name: "Villaviciosa de Odon",
          state_id: "3297",
        },
      ],
      Malaga: [
        {
          id: "38588",
          name: "Alhaurin de la Torre",
          state_id: "3298",
        },
        {
          id: "38589",
          name: "Alhaurin el Grande",
          state_id: "3298",
        },
        {
          id: "38590",
          name: "Alora",
          state_id: "3298",
        },
        {
          id: "38591",
          name: "Antequera",
          state_id: "3298",
        },
        {
          id: "38592",
          name: "Apartado",
          state_id: "3298",
        },
        {
          id: "38593",
          name: "Archidona",
          state_id: "3298",
        },
        {
          id: "38594",
          name: "Benalmadena",
          state_id: "3298",
        },
        {
          id: "38595",
          name: "Cartama",
          state_id: "3298",
        },
        {
          id: "38596",
          name: "Coin",
          state_id: "3298",
        },
        {
          id: "38597",
          name: "Estepona",
          state_id: "3298",
        },
        {
          id: "38598",
          name: "Fuengirola",
          state_id: "3298",
        },
        {
          id: "38599",
          name: "Malaga",
          state_id: "3298",
        },
        {
          id: "38600",
          name: "Marbella",
          state_id: "3298",
        },
        {
          id: "38601",
          name: "Mijas",
          state_id: "3298",
        },
        {
          id: "38602",
          name: "Nerja",
          state_id: "3298",
        },
        {
          id: "38603",
          name: "Rincon de la Victoria",
          state_id: "3298",
        },
        {
          id: "38604",
          name: "Ronda",
          state_id: "3298",
        },
        {
          id: "38605",
          name: "Torremolinos",
          state_id: "3298",
        },
        {
          id: "38606",
          name: "Torrox",
          state_id: "3298",
        },
        {
          id: "38607",
          name: "Velez-Malaga",
          state_id: "3298",
        },
        {
          id: "38608",
          name: "maro",
          state_id: "3298",
        },
      ],
      Melilla: [
        {
          id: "38609",
          name: "Melilla",
          state_id: "3299",
        },
      ],
      Murcia: [
        {
          id: "38610",
          name: "Abaran",
          state_id: "3300",
        },
        {
          id: "38611",
          name: "Aguilas",
          state_id: "3300",
        },
        {
          id: "38612",
          name: "Alcantarilla",
          state_id: "3300",
        },
        {
          id: "38613",
          name: "Alhama de Murcia",
          state_id: "3300",
        },
        {
          id: "38614",
          name: "Archena",
          state_id: "3300",
        },
        {
          id: "38615",
          name: "Beniel",
          state_id: "3300",
        },
        {
          id: "38616",
          name: "Bullas",
          state_id: "3300",
        },
        {
          id: "38617",
          name: "Calasparra",
          state_id: "3300",
        },
        {
          id: "38618",
          name: "Caravaca de la Cruz",
          state_id: "3300",
        },
        {
          id: "38619",
          name: "Cartagena",
          state_id: "3300",
        },
        {
          id: "38620",
          name: "Cehegin",
          state_id: "3300",
        },
        {
          id: "38621",
          name: "Cieza",
          state_id: "3300",
        },
        {
          id: "38622",
          name: "Fuente Alamo de Murcia",
          state_id: "3300",
        },
        {
          id: "38623",
          name: "Jumilla",
          state_id: "3300",
        },
        {
          id: "38624",
          name: "La Union",
          state_id: "3300",
        },
        {
          id: "38625",
          name: "Las Torres de Cotillas",
          state_id: "3300",
        },
        {
          id: "38626",
          name: "Lorca",
          state_id: "3300",
        },
        {
          id: "38627",
          name: "Los Alcazares",
          state_id: "3300",
        },
        {
          id: "38628",
          name: "Mazarron",
          state_id: "3300",
        },
        {
          id: "38629",
          name: "Molina de Segura",
          state_id: "3300",
        },
        {
          id: "38630",
          name: "Moratella",
          state_id: "3300",
        },
        {
          id: "38631",
          name: "Mula",
          state_id: "3300",
        },
        {
          id: "38632",
          name: "Murcia",
          state_id: "3300",
        },
        {
          id: "38633",
          name: "Puerto Lumbreras",
          state_id: "3300",
        },
        {
          id: "38634",
          name: "San Javier",
          state_id: "3300",
        },
        {
          id: "38635",
          name: "San Pedro del Pinatar",
          state_id: "3300",
        },
        {
          id: "38636",
          name: "Santomera",
          state_id: "3300",
        },
        {
          id: "38637",
          name: "Torre Pacheco",
          state_id: "3300",
        },
        {
          id: "38638",
          name: "Torre-Pacheco",
          state_id: "3300",
        },
        {
          id: "38639",
          name: "Totana",
          state_id: "3300",
        },
        {
          id: "38640",
          name: "Yecla",
          state_id: "3300",
        },
      ],
      Navarra: [
        {
          id: "38641",
          name: "Ansoain",
          state_id: "3301",
        },
        {
          id: "38642",
          name: "Atarrabia",
          state_id: "3301",
        },
        {
          id: "38643",
          name: "Baranain",
          state_id: "3301",
        },
        {
          id: "38644",
          name: "Burlata",
          state_id: "3301",
        },
        {
          id: "38645",
          name: "Iruna",
          state_id: "3301",
        },
        {
          id: "38646",
          name: "Lizarra",
          state_id: "3301",
        },
        {
          id: "38647",
          name: "Navarra",
          state_id: "3301",
        },
        {
          id: "38648",
          name: "Orkoien",
          state_id: "3301",
        },
        {
          id: "38649",
          name: "Tafalla",
          state_id: "3301",
        },
        {
          id: "38650",
          name: "Tudela",
          state_id: "3301",
        },
        {
          id: "38651",
          name: "Zizur Nagusia",
          state_id: "3301",
        },
      ],
      Ourense: [
        {
          id: "38652",
          name: "O Barco de Valdeorras",
          state_id: "3302",
        },
        {
          id: "38653",
          name: "O Carballino",
          state_id: "3302",
        },
        {
          id: "38654",
          name: "Ourense",
          state_id: "3302",
        },
        {
          id: "38655",
          name: "Verin",
          state_id: "3302",
        },
        {
          id: "38656",
          name: "Xinzo de Limia",
          state_id: "3302",
        },
      ],
      "Pais Vasco": [],
      Palencia: [
        {
          id: "38657",
          name: "Guardo",
          state_id: "3304",
        },
        {
          id: "38658",
          name: "Palencia",
          state_id: "3304",
        },
      ],
      Pontevedra: [
        {
          id: "38659",
          name: "A Estrada",
          state_id: "3305",
        },
        {
          id: "38660",
          name: "A Guarda",
          state_id: "3305",
        },
        {
          id: "38661",
          name: "Baiona",
          state_id: "3305",
        },
        {
          id: "38662",
          name: "Bueu",
          state_id: "3305",
        },
        {
          id: "38663",
          name: "Caldas de Reis",
          state_id: "3305",
        },
        {
          id: "38664",
          name: "Cambados",
          state_id: "3305",
        },
        {
          id: "38665",
          name: "Cangas",
          state_id: "3305",
        },
        {
          id: "38666",
          name: "Cangas De Morrazo",
          state_id: "3305",
        },
        {
          id: "38667",
          name: "Gondomar",
          state_id: "3305",
        },
        {
          id: "38668",
          name: "Lalin",
          state_id: "3305",
        },
        {
          id: "38669",
          name: "Marin",
          state_id: "3305",
        },
        {
          id: "38670",
          name: "Moana",
          state_id: "3305",
        },
        {
          id: "38671",
          name: "Mos",
          state_id: "3305",
        },
        {
          id: "38672",
          name: "Nigran",
          state_id: "3305",
        },
        {
          id: "38673",
          name: "O Grove",
          state_id: "3305",
        },
        {
          id: "38674",
          name: "O Porrino",
          state_id: "3305",
        },
        {
          id: "38675",
          name: "Poio",
          state_id: "3305",
        },
        {
          id: "38676",
          name: "Ponteareas",
          state_id: "3305",
        },
        {
          id: "38677",
          name: "Pontevedra",
          state_id: "3305",
        },
        {
          id: "38678",
          name: "Redondela",
          state_id: "3305",
        },
        {
          id: "38679",
          name: "Salvaterra de Mino",
          state_id: "3305",
        },
        {
          id: "38680",
          name: "Sanxenxo",
          state_id: "3305",
        },
        {
          id: "38681",
          name: "Silleda",
          state_id: "3305",
        },
        {
          id: "38682",
          name: "Tomino",
          state_id: "3305",
        },
        {
          id: "38683",
          name: "Tui",
          state_id: "3305",
        },
        {
          id: "38684",
          name: "Vigo",
          state_id: "3305",
        },
        {
          id: "38685",
          name: "Vilagarcia de Arousa",
          state_id: "3305",
        },
        {
          id: "38686",
          name: "Vilanova de Arousa",
          state_id: "3305",
        },
      ],
      Salamanca: [
        {
          id: "38687",
          name: "Bejar",
          state_id: "3306",
        },
        {
          id: "38688",
          name: "Ciudad Rodrigo",
          state_id: "3306",
        },
        {
          id: "38689",
          name: "Salamanca",
          state_id: "3306",
        },
        {
          id: "38690",
          name: "Santa Marta de Tormes",
          state_id: "3306",
        },
      ],
      "Santa Cruz de Tenerife": [],
      Segovia: [
        {
          id: "38691",
          name: "Cuellar",
          state_id: "3308",
        },
        {
          id: "38692",
          name: "Segovia",
          state_id: "3308",
        },
      ],
      Sevilla: [
        {
          id: "38693",
          name: "Alcala de Guadaira",
          state_id: "3309",
        },
        {
          id: "38694",
          name: "Alcala del Rio",
          state_id: "3309",
        },
        {
          id: "38695",
          name: "Arahal",
          state_id: "3309",
        },
        {
          id: "38696",
          name: "Bormujos",
          state_id: "3309",
        },
        {
          id: "38697",
          name: "Brenes",
          state_id: "3309",
        },
        {
          id: "38698",
          name: "Camas",
          state_id: "3309",
        },
        {
          id: "38699",
          name: "Cantillana",
          state_id: "3309",
        },
        {
          id: "38700",
          name: "Carmona",
          state_id: "3309",
        },
        {
          id: "38701",
          name: "Castilleja de la Cuesta",
          state_id: "3309",
        },
        {
          id: "38702",
          name: "Coria del Rio",
          state_id: "3309",
        },
        {
          id: "38703",
          name: "Dos Hermanas",
          state_id: "3309",
        },
        {
          id: "38704",
          name: "Ecija",
          state_id: "3309",
        },
        {
          id: "38705",
          name: "El Viso del Alcor",
          state_id: "3309",
        },
        {
          id: "38706",
          name: "Estepa",
          state_id: "3309",
        },
        {
          id: "38707",
          name: "Gines",
          state_id: "3309",
        },
        {
          id: "38708",
          name: "Guillena",
          state_id: "3309",
        },
        {
          id: "38709",
          name: "La Algaba",
          state_id: "3309",
        },
        {
          id: "38710",
          name: "La Puebla de Cazalla",
          state_id: "3309",
        },
        {
          id: "38711",
          name: "La Puebla del Rio",
          state_id: "3309",
        },
        {
          id: "38712",
          name: "La Rinconada",
          state_id: "3309",
        },
        {
          id: "38713",
          name: "Las Cabezas de San Juan",
          state_id: "3309",
        },
        {
          id: "38714",
          name: "Lebrija",
          state_id: "3309",
        },
        {
          id: "38715",
          name: "Lora del Rio",
          state_id: "3309",
        },
        {
          id: "38716",
          name: "Los Palacios y Villafranca",
          state_id: "3309",
        },
        {
          id: "38717",
          name: "Mairena del Alcor",
          state_id: "3309",
        },
        {
          id: "38718",
          name: "Mairena del Aljarafe",
          state_id: "3309",
        },
        {
          id: "38719",
          name: "Marchena",
          state_id: "3309",
        },
        {
          id: "38720",
          name: "Moron de la Frontera",
          state_id: "3309",
        },
        {
          id: "38721",
          name: "Olivares",
          state_id: "3309",
        },
        {
          id: "38722",
          name: "Osuna",
          state_id: "3309",
        },
        {
          id: "38723",
          name: "Pilas",
          state_id: "3309",
        },
        {
          id: "38724",
          name: "San Juan de Aznalfarache",
          state_id: "3309",
        },
        {
          id: "38725",
          name: "Sanlucar la Mayor",
          state_id: "3309",
        },
        {
          id: "38726",
          name: "Sevilla",
          state_id: "3309",
        },
        {
          id: "38727",
          name: "Tocina",
          state_id: "3309",
        },
        {
          id: "38728",
          name: "Tomares",
          state_id: "3309",
        },
        {
          id: "38729",
          name: "Utrera",
          state_id: "3309",
        },
      ],
      Soria: [
        {
          id: "38730",
          name: "Soria",
          state_id: "3310",
        },
      ],
      Tarragona: [
        {
          id: "38731",
          name: "Alcanar",
          state_id: "3311",
        },
        {
          id: "38732",
          name: "Amposta",
          state_id: "3311",
        },
        {
          id: "38733",
          name: "Calafell",
          state_id: "3311",
        },
        {
          id: "38734",
          name: "Cambrils",
          state_id: "3311",
        },
        {
          id: "38735",
          name: "Deltrebe",
          state_id: "3311",
        },
        {
          id: "38736",
          name: "El Vendrell",
          state_id: "3311",
        },
        {
          id: "38737",
          name: "Reus",
          state_id: "3311",
        },
        {
          id: "38738",
          name: "Salou",
          state_id: "3311",
        },
        {
          id: "38739",
          name: "Sant Carles de la Rapita",
          state_id: "3311",
        },
        {
          id: "38740",
          name: "Tarragona",
          state_id: "3311",
        },
        {
          id: "38741",
          name: "Torredembarra",
          state_id: "3311",
        },
        {
          id: "38742",
          name: "Tortosa",
          state_id: "3311",
        },
        {
          id: "38743",
          name: "Valls",
          state_id: "3311",
        },
        {
          id: "38744",
          name: "Vila-seca",
          state_id: "3311",
        },
      ],
      Tenerife: [
        {
          id: "38745",
          name: "Tenerife",
          state_id: "3312",
        },
      ],
      Teruel: [
        {
          id: "38746",
          name: "Alcaniz",
          state_id: "3313",
        },
        {
          id: "38747",
          name: "Teruel",
          state_id: "3313",
        },
      ],
      Toledo: [
        {
          id: "38748",
          name: "Consuegra",
          state_id: "3314",
        },
        {
          id: "38749",
          name: "Illescas",
          state_id: "3314",
        },
        {
          id: "38750",
          name: "Madridejos",
          state_id: "3314",
        },
        {
          id: "38751",
          name: "Mora",
          state_id: "3314",
        },
        {
          id: "38752",
          name: "Pepino",
          state_id: "3314",
        },
        {
          id: "38753",
          name: "Quintanar de la Orden",
          state_id: "3314",
        },
        {
          id: "38754",
          name: "Sonseca",
          state_id: "3314",
        },
        {
          id: "38755",
          name: "Talavera de la Reina",
          state_id: "3314",
        },
        {
          id: "38756",
          name: "Toledo",
          state_id: "3314",
        },
        {
          id: "38757",
          name: "Torrijos",
          state_id: "3314",
        },
        {
          id: "38758",
          name: "Villacanas",
          state_id: "3314",
        },
      ],
      Valencia: [
        {
          id: "38759",
          name: "Agullent",
          state_id: "3315",
        },
        {
          id: "38760",
          name: "Alaquas",
          state_id: "3315",
        },
        {
          id: "38761",
          name: "Albal",
          state_id: "3315",
        },
        {
          id: "38762",
          name: "Alberic",
          state_id: "3315",
        },
        {
          id: "38763",
          name: "Alboraya",
          state_id: "3315",
        },
        {
          id: "38764",
          name: "Aldaia",
          state_id: "3315",
        },
        {
          id: "38765",
          name: "Alfafar",
          state_id: "3315",
        },
        {
          id: "38766",
          name: "Algemesi",
          state_id: "3315",
        },
        {
          id: "38767",
          name: "Alginet",
          state_id: "3315",
        },
        {
          id: "38768",
          name: "Alzira",
          state_id: "3315",
        },
        {
          id: "38769",
          name: "Benaguasil",
          state_id: "3315",
        },
        {
          id: "38770",
          name: "Benetusser",
          state_id: "3315",
        },
        {
          id: "38771",
          name: "Benifaio",
          state_id: "3315",
        },
        {
          id: "38772",
          name: "Beniparrell",
          state_id: "3315",
        },
        {
          id: "38773",
          name: "Betera",
          state_id: "3315",
        },
        {
          id: "38774",
          name: "Bunol",
          state_id: "3315",
        },
        {
          id: "38775",
          name: "Burjassot",
          state_id: "3315",
        },
        {
          id: "38776",
          name: "Canals",
          state_id: "3315",
        },
        {
          id: "38777",
          name: "Carcaixent",
          state_id: "3315",
        },
        {
          id: "38778",
          name: "Carlet",
          state_id: "3315",
        },
        {
          id: "38779",
          name: "Catarroja",
          state_id: "3315",
        },
        {
          id: "38780",
          name: "Chiva",
          state_id: "3315",
        },
        {
          id: "38781",
          name: "Cullera",
          state_id: "3315",
        },
        {
          id: "38782",
          name: "Elche",
          state_id: "3315",
        },
        {
          id: "38783",
          name: "Gandia",
          state_id: "3315",
        },
        {
          id: "38784",
          name: "Godella",
          state_id: "3315",
        },
        {
          id: "38785",
          name: "L''Alcudia",
          state_id: "3315",
        },
        {
          id: "38786",
          name: "L''Eliana",
          state_id: "3315",
        },
        {
          id: "38787",
          name: "La Pobla de Vallbona",
          state_id: "3315",
        },
        {
          id: "38788",
          name: "Lliria",
          state_id: "3315",
        },
        {
          id: "38789",
          name: "Los Montesinos",
          state_id: "3315",
        },
        {
          id: "38790",
          name: "Manises",
          state_id: "3315",
        },
        {
          id: "38791",
          name: "Massamagrell",
          state_id: "3315",
        },
        {
          id: "38792",
          name: "Meliana",
          state_id: "3315",
        },
        {
          id: "38793",
          name: "Mislata",
          state_id: "3315",
        },
        {
          id: "38794",
          name: "Moncada",
          state_id: "3315",
        },
        {
          id: "38795",
          name: "Oliva",
          state_id: "3315",
        },
        {
          id: "38796",
          name: "Ontinyent",
          state_id: "3315",
        },
        {
          id: "38797",
          name: "Paiporta",
          state_id: "3315",
        },
        {
          id: "38798",
          name: "Paterna",
          state_id: "3315",
        },
        {
          id: "38799",
          name: "Picanya",
          state_id: "3315",
        },
        {
          id: "38800",
          name: "Picassent",
          state_id: "3315",
        },
        {
          id: "38801",
          name: "Pucol",
          state_id: "3315",
        },
        {
          id: "38802",
          name: "Quart de Poblet",
          state_id: "3315",
        },
        {
          id: "38803",
          name: "Requena",
          state_id: "3315",
        },
        {
          id: "38804",
          name: "Riba-roja de Turia",
          state_id: "3315",
        },
        {
          id: "38805",
          name: "Sagunt",
          state_id: "3315",
        },
        {
          id: "38806",
          name: "Sedavi",
          state_id: "3315",
        },
        {
          id: "38807",
          name: "Silla",
          state_id: "3315",
        },
        {
          id: "38808",
          name: "Sueca",
          state_id: "3315",
        },
        {
          id: "38809",
          name: "Tavernes Blanques",
          state_id: "3315",
        },
        {
          id: "38810",
          name: "Tavernes de la Valldigna",
          state_id: "3315",
        },
        {
          id: "38811",
          name: "Torrent",
          state_id: "3315",
        },
        {
          id: "38812",
          name: "Utiel",
          state_id: "3315",
        },
        {
          id: "38813",
          name: "Valencia",
          state_id: "3315",
        },
        {
          id: "38814",
          name: "Xativa",
          state_id: "3315",
        },
        {
          id: "38815",
          name: "Xirivella",
          state_id: "3315",
        },
      ],
      Valladolid: [
        {
          id: "38816",
          name: "Laguna de Duero",
          state_id: "3316",
        },
        {
          id: "38817",
          name: "Medina del Campo",
          state_id: "3316",
        },
        {
          id: "38818",
          name: "Tordesillas",
          state_id: "3316",
        },
        {
          id: "38819",
          name: "Valladolid",
          state_id: "3316",
        },
      ],
      Vizcaya: [
        {
          id: "38820",
          name: "Abadiano",
          state_id: "3317",
        },
        {
          id: "38821",
          name: "Abanto Zierbena",
          state_id: "3317",
        },
        {
          id: "38822",
          name: "Amorebieta",
          state_id: "3317",
        },
        {
          id: "38823",
          name: "Arrigorriaga",
          state_id: "3317",
        },
        {
          id: "38824",
          name: "Barakaldo",
          state_id: "3317",
        },
        {
          id: "38825",
          name: "Basauri",
          state_id: "3317",
        },
        {
          id: "38826",
          name: "Bermeo",
          state_id: "3317",
        },
        {
          id: "38827",
          name: "Berriz",
          state_id: "3317",
        },
        {
          id: "38828",
          name: "Bilbao",
          state_id: "3317",
        },
        {
          id: "38829",
          name: "Durango",
          state_id: "3317",
        },
        {
          id: "38830",
          name: "Erandio",
          state_id: "3317",
        },
        {
          id: "38831",
          name: "Ermua",
          state_id: "3317",
        },
        {
          id: "38832",
          name: "Etxano",
          state_id: "3317",
        },
        {
          id: "38833",
          name: "Galdakao",
          state_id: "3317",
        },
        {
          id: "38834",
          name: "Gernika-Lumo",
          state_id: "3317",
        },
        {
          id: "38835",
          name: "Getxo",
          state_id: "3317",
        },
        {
          id: "38836",
          name: "Igorre",
          state_id: "3317",
        },
        {
          id: "38837",
          name: "Leioa",
          state_id: "3317",
        },
        {
          id: "38838",
          name: "Mungia",
          state_id: "3317",
        },
        {
          id: "38839",
          name: "Ondarroa",
          state_id: "3317",
        },
        {
          id: "38840",
          name: "Ortuella",
          state_id: "3317",
        },
        {
          id: "38841",
          name: "Portugalete",
          state_id: "3317",
        },
        {
          id: "38842",
          name: "Santurtzi",
          state_id: "3317",
        },
        {
          id: "38843",
          name: "Sestao",
          state_id: "3317",
        },
        {
          id: "38844",
          name: "Sopelana",
          state_id: "3317",
        },
        {
          id: "38845",
          name: "Trapagaran",
          state_id: "3317",
        },
        {
          id: "38846",
          name: "Zamudio",
          state_id: "3317",
        },
      ],
      Zamora: [
        {
          id: "38847",
          name: "Benavente",
          state_id: "3318",
        },
        {
          id: "38848",
          name: "Toro",
          state_id: "3318",
        },
        {
          id: "38849",
          name: "Zamora",
          state_id: "3318",
        },
      ],
      Zaragoza: [
        {
          id: "38850",
          name: "Calatayud",
          state_id: "3319",
        },
        {
          id: "38851",
          name: "Ejea de los Caballeros",
          state_id: "3319",
        },
        {
          id: "38852",
          name: "Tarazona",
          state_id: "3319",
        },
        {
          id: "38853",
          name: "Utebo",
          state_id: "3319",
        },
        {
          id: "38854",
          name: "Zaragoza",
          state_id: "3319",
        },
      ],
    },
  },
  ET: {
    name: "Ethiopia",
    native: "ኢትዮጵያ",
    phone: "251",
    continent: "AF",
    capital: "Addis Ababa",
    currency: "ETB",
    languages: ["am"],
    emoji: "🇪🇹",
    emojiU: "U+1F1EA U+1F1F9",
    states: {
      "Addis Abeba": [],
      Afar: [
        {
          id: "16697",
          name: "Asayita",
          state_id: "1120",
        },
        {
          id: "16698",
          name: "Awash",
          state_id: "1120",
        },
        {
          id: "16699",
          name: "Dubti",
          state_id: "1120",
        },
        {
          id: "16700",
          name: "Gewane",
          state_id: "1120",
        },
      ],
      Amhara: [
        {
          id: "16701",
          name: "Addi Ark''ay",
          state_id: "1121",
        },
        {
          id: "16702",
          name: "Addis ''Alem",
          state_id: "1121",
        },
        {
          id: "16703",
          name: "Addis Zemen",
          state_id: "1121",
        },
        {
          id: "16704",
          name: "Adet",
          state_id: "1121",
        },
        {
          id: "16705",
          name: "Bahir Dar",
          state_id: "1121",
        },
        {
          id: "16706",
          name: "Bati",
          state_id: "1121",
        },
        {
          id: "16707",
          name: "Bichena",
          state_id: "1121",
        },
        {
          id: "16708",
          name: "Bure",
          state_id: "1121",
        },
        {
          id: "16709",
          name: "Chagni",
          state_id: "1121",
        },
        {
          id: "16710",
          name: "Dabat",
          state_id: "1121",
        },
        {
          id: "16711",
          name: "Dangla",
          state_id: "1121",
        },
        {
          id: "16712",
          name: "Debark",
          state_id: "1121",
        },
        {
          id: "16713",
          name: "Debre Birhan",
          state_id: "1121",
        },
        {
          id: "16714",
          name: "Debre Mark''os",
          state_id: "1121",
        },
        {
          id: "16715",
          name: "Debre Sina",
          state_id: "1121",
        },
        {
          id: "16716",
          name: "Debre Tabor",
          state_id: "1121",
        },
        {
          id: "16717",
          name: "Debre Werk",
          state_id: "1121",
        },
        {
          id: "16718",
          name: "Dejen",
          state_id: "1121",
        },
        {
          id: "16719",
          name: "Dese",
          state_id: "1121",
        },
        {
          id: "16720",
          name: "Finote Selam",
          state_id: "1121",
        },
        {
          id: "16721",
          name: "Gondar",
          state_id: "1121",
        },
        {
          id: "16722",
          name: "K''obo",
          state_id: "1121",
        },
        {
          id: "16723",
          name: "Kembolcha",
          state_id: "1121",
        },
        {
          id: "16724",
          name: "Kemise",
          state_id: "1121",
        },
        {
          id: "16725",
          name: "Lalibela",
          state_id: "1121",
        },
        {
          id: "16726",
          name: "Mott''a",
          state_id: "1121",
        },
        {
          id: "16727",
          name: "Nefas Mewcha",
          state_id: "1121",
        },
        {
          id: "16728",
          name: "Sek''ot''a",
          state_id: "1121",
        },
        {
          id: "16729",
          name: "Shewa Robit",
          state_id: "1121",
        },
        {
          id: "16730",
          name: "Weldiya",
          state_id: "1121",
        },
        {
          id: "16731",
          name: "Were Ilu",
          state_id: "1121",
        },
        {
          id: "16732",
          name: "Werota",
          state_id: "1121",
        },
      ],
      Benishangul: [
        {
          id: "16733",
          name: "Asosa",
          state_id: "1122",
        },
      ],
      Diredawa: [
        {
          id: "16734",
          name: "Dire Dawa",
          state_id: "1123",
        },
      ],
      Gambella: [
        {
          id: "16735",
          name: "Gambela",
          state_id: "1124",
        },
      ],
      Harar: [
        {
          id: "16736",
          name: "Harer",
          state_id: "1125",
        },
      ],
      Jigjiga: [
        {
          id: "16737",
          name: "Jigjiga",
          state_id: "1126",
        },
      ],
      Mekele: [],
      Oromia: [
        {
          id: "16738",
          name: "Alem Maya",
          state_id: "1128",
        },
        {
          id: "16739",
          name: "Abomsa",
          state_id: "1128",
        },
        {
          id: "16740",
          name: "Agaro",
          state_id: "1128",
        },
        {
          id: "16741",
          name: "Asasa",
          state_id: "1128",
        },
        {
          id: "16742",
          name: "Asbe Teferi",
          state_id: "1128",
        },
        {
          id: "16743",
          name: "Assela",
          state_id: "1128",
        },
        {
          id: "16744",
          name: "Bako",
          state_id: "1128",
        },
        {
          id: "16745",
          name: "Bedele",
          state_id: "1128",
        },
        {
          id: "16746",
          name: "Bedesa",
          state_id: "1128",
        },
        {
          id: "16747",
          name: "Burayu",
          state_id: "1128",
        },
        {
          id: "16748",
          name: "Debre Zeyit",
          state_id: "1128",
        },
        {
          id: "16749",
          name: "Deder",
          state_id: "1128",
        },
        {
          id: "16750",
          name: "Dembi Dolo",
          state_id: "1128",
        },
        {
          id: "16751",
          name: "Dodola",
          state_id: "1128",
        },
        {
          id: "16752",
          name: "Fiche",
          state_id: "1128",
        },
        {
          id: "16753",
          name: "Gebre Guracha",
          state_id: "1128",
        },
        {
          id: "16754",
          name: "Gedo",
          state_id: "1128",
        },
        {
          id: "16755",
          name: "Gelemso",
          state_id: "1128",
        },
        {
          id: "16756",
          name: "Gimbi",
          state_id: "1128",
        },
        {
          id: "16757",
          name: "Ginch''i",
          state_id: "1128",
        },
        {
          id: "16758",
          name: "Ginir",
          state_id: "1128",
        },
        {
          id: "16759",
          name: "Giyon",
          state_id: "1128",
        },
        {
          id: "16760",
          name: "Goba",
          state_id: "1128",
        },
        {
          id: "16761",
          name: "Gore",
          state_id: "1128",
        },
        {
          id: "16762",
          name: "Guder",
          state_id: "1128",
        },
        {
          id: "16763",
          name: "Hagere Hiywet",
          state_id: "1128",
        },
        {
          id: "16764",
          name: "Hagere Maryam",
          state_id: "1128",
        },
        {
          id: "16765",
          name: "Hirna",
          state_id: "1128",
        },
        {
          id: "16766",
          name: "Holeta Genet",
          state_id: "1128",
        },
        {
          id: "16767",
          name: "Huruta",
          state_id: "1128",
        },
        {
          id: "16768",
          name: "Jimma",
          state_id: "1128",
        },
        {
          id: "16769",
          name: "Kibre Mengist",
          state_id: "1128",
        },
        {
          id: "16770",
          name: "Kofele",
          state_id: "1128",
        },
        {
          id: "16771",
          name: "Mega",
          state_id: "1128",
        },
        {
          id: "16772",
          name: "Mek''i",
          state_id: "1128",
        },
        {
          id: "16773",
          name: "Mendi",
          state_id: "1128",
        },
        {
          id: "16774",
          name: "Metehara",
          state_id: "1128",
        },
        {
          id: "16775",
          name: "Metu",
          state_id: "1128",
        },
        {
          id: "16776",
          name: "Mojo",
          state_id: "1128",
        },
        {
          id: "16777",
          name: "Moyale",
          state_id: "1128",
        },
        {
          id: "16778",
          name: "Nazret",
          state_id: "1128",
        },
        {
          id: "16779",
          name: "Nedjo",
          state_id: "1128",
        },
        {
          id: "16780",
          name: "Negele",
          state_id: "1128",
        },
        {
          id: "16781",
          name: "Nek''emte",
          state_id: "1128",
        },
        {
          id: "16782",
          name: "Robe",
          state_id: "1128",
        },
        {
          id: "16783",
          name: "Sebeta",
          state_id: "1128",
        },
        {
          id: "16784",
          name: "Sendafa",
          state_id: "1128",
        },
        {
          id: "16785",
          name: "Shakiso",
          state_id: "1128",
        },
        {
          id: "16786",
          name: "Shambu",
          state_id: "1128",
        },
        {
          id: "16787",
          name: "Shashemenne",
          state_id: "1128",
        },
        {
          id: "16788",
          name: "Sheh Hussen",
          state_id: "1128",
        },
        {
          id: "16789",
          name: "Sire",
          state_id: "1128",
        },
        {
          id: "16790",
          name: "Tulu Bolo",
          state_id: "1128",
        },
        {
          id: "16791",
          name: "Welench''iti",
          state_id: "1128",
        },
        {
          id: "16792",
          name: "Welk''it''e",
          state_id: "1128",
        },
        {
          id: "16793",
          name: "Wonji",
          state_id: "1128",
        },
        {
          id: "16794",
          name: "Yabelo",
          state_id: "1128",
        },
        {
          id: "16795",
          name: "Ziway",
          state_id: "1128",
        },
      ],
      Somali: [
        {
          id: "16796",
          name: "Bircot",
          state_id: "1129",
        },
        {
          id: "16797",
          name: "Degeh Bur",
          state_id: "1129",
        },
        {
          id: "16798",
          name: "Dollo Odo",
          state_id: "1129",
        },
        {
          id: "16799",
          name: "Imi",
          state_id: "1129",
        },
        {
          id: "16800",
          name: "Jijiga",
          state_id: "1129",
        },
        {
          id: "16801",
          name: "Werder",
          state_id: "1129",
        },
      ],
      Southern: [
        {
          id: "16802",
          name: "Alaba Kulito",
          state_id: "1130",
        },
        {
          id: "16803",
          name: "Arba Minch",
          state_id: "1130",
        },
        {
          id: "16804",
          name: "Areka",
          state_id: "1130",
        },
        {
          id: "16805",
          name: "Awassa",
          state_id: "1130",
        },
        {
          id: "16806",
          name: "Bako",
          state_id: "1130",
        },
        {
          id: "16807",
          name: "Boditi",
          state_id: "1130",
        },
        {
          id: "16808",
          name: "Bonga",
          state_id: "1130",
        },
        {
          id: "16809",
          name: "Butajira",
          state_id: "1130",
        },
        {
          id: "16810",
          name: "Ch''ench''a",
          state_id: "1130",
        },
        {
          id: "16811",
          name: "Dilla",
          state_id: "1130",
        },
        {
          id: "16812",
          name: "Gidole",
          state_id: "1130",
        },
        {
          id: "16813",
          name: "Hossa''ina",
          state_id: "1130",
        },
        {
          id: "16814",
          name: "Jinka",
          state_id: "1130",
        },
        {
          id: "16815",
          name: "Leku",
          state_id: "1130",
        },
        {
          id: "16816",
          name: "Mizan Teferi",
          state_id: "1130",
        },
        {
          id: "16817",
          name: "Sawla",
          state_id: "1130",
        },
        {
          id: "16818",
          name: "Soddo",
          state_id: "1130",
        },
        {
          id: "16819",
          name: "Teppi",
          state_id: "1130",
        },
        {
          id: "16820",
          name: "Wendo",
          state_id: "1130",
        },
        {
          id: "16821",
          name: "Yirga Alem",
          state_id: "1130",
        },
        {
          id: "16822",
          name: "Yirga Ch''efe",
          state_id: "1130",
        },
      ],
      Tigray: [
        {
          id: "16823",
          name: "Abiy Adi",
          state_id: "1131",
        },
        {
          id: "16824",
          name: "Addigrat",
          state_id: "1131",
        },
        {
          id: "16825",
          name: "Adwa",
          state_id: "1131",
        },
        {
          id: "16826",
          name: "Aksum",
          state_id: "1131",
        },
        {
          id: "16827",
          name: "Alamat''a",
          state_id: "1131",
        },
        {
          id: "16828",
          name: "Endasilasie",
          state_id: "1131",
        },
        {
          id: "16829",
          name: "Hagere Selam",
          state_id: "1131",
        },
        {
          id: "16830",
          name: "Himora",
          state_id: "1131",
        },
        {
          id: "16831",
          name: "Korem",
          state_id: "1131",
        },
        {
          id: "16832",
          name: "Maych''ew",
          state_id: "1131",
        },
        {
          id: "16833",
          name: "Mek''ele",
          state_id: "1131",
        },
        {
          id: "16834",
          name: "Mekele",
          state_id: "1131",
        },
        {
          id: "16835",
          name: "Wik''ro",
          state_id: "1131",
        },
      ],
    },
  },
  FI: {
    name: "Finland",
    native: "Suomi",
    phone: "358",
    continent: "EU",
    capital: "Helsinki",
    currency: "EUR",
    languages: ["fi", "sv"],
    emoji: "🇫🇮",
    emojiU: "U+1F1EB U+1F1EE",
    states: {
      Ahvenanmaa: [
        {
          id: "16881",
          name: "Maarianhamina",
          state_id: "1151",
        },
      ],
      "Etela-Karjala": [
        {
          id: "16882",
          name: "Imatra",
          state_id: "1152",
        },
        {
          id: "16883",
          name: "Joutseno",
          state_id: "1152",
        },
        {
          id: "16884",
          name: "Lappeenranta",
          state_id: "1152",
        },
      ],
      "Etela-Pohjanmaa": [
        {
          id: "16885",
          name: "Hyllykallio",
          state_id: "1153",
        },
        {
          id: "16886",
          name: "Ilmajoki",
          state_id: "1153",
        },
        {
          id: "16887",
          name: "Kauhajoki",
          state_id: "1153",
        },
        {
          id: "16888",
          name: "Kurikka",
          state_id: "1153",
        },
        {
          id: "16889",
          name: "Lapua",
          state_id: "1153",
        },
        {
          id: "16890",
          name: "Seinajoki",
          state_id: "1153",
        },
      ],
      "Etela-Savo": [
        {
          id: "16891",
          name: "Mikkeli",
          state_id: "1154",
        },
        {
          id: "16892",
          name: "Savonlinna",
          state_id: "1154",
        },
      ],
      "Etela-Suomen Laani": [],
      "Ita-Suomen Laani": [],
      "Ita-Uusimaa": [
        {
          id: "16893",
          name: "Loviisa",
          state_id: "1157",
        },
        {
          id: "16894",
          name: "Orimattila",
          state_id: "1157",
        },
        {
          id: "16895",
          name: "Porvoo",
          state_id: "1157",
        },
      ],
      Kainuu: [
        {
          id: "16896",
          name: "Kajaani",
          state_id: "1158",
        },
      ],
      "Kanta-Hame": [
        {
          id: "16897",
          name: "Forssa",
          state_id: "1159",
        },
        {
          id: "16898",
          name: "Hameenlinna",
          state_id: "1159",
        },
        {
          id: "16899",
          name: "Janakkala",
          state_id: "1159",
        },
        {
          id: "16900",
          name: "Riihimaki",
          state_id: "1159",
        },
      ],
      "Keski-Pohjanmaa": [
        {
          id: "16901",
          name: "Kokkola",
          state_id: "1160",
        },
      ],
      "Keski-Suomi": [
        {
          id: "16902",
          name: "Aanekoski",
          state_id: "1161",
        },
        {
          id: "16903",
          name: "Jamsa",
          state_id: "1161",
        },
        {
          id: "16904",
          name: "Jyvaskyla",
          state_id: "1161",
        },
        {
          id: "16905",
          name: "Keuruu",
          state_id: "1161",
        },
        {
          id: "16906",
          name: "Laukaa",
          state_id: "1161",
        },
        {
          id: "16907",
          name: "Lieto",
          state_id: "1161",
        },
      ],
      Kymenlaakso: [
        {
          id: "16909",
          name: "Hamina",
          state_id: "1162",
        },
        {
          id: "16910",
          name: "Kotka",
          state_id: "1162",
        },
        {
          id: "16911",
          name: "Kouvola",
          state_id: "1162",
        },
        {
          id: "16912",
          name: "Kuusankoski",
          state_id: "1162",
        },
        {
          id: "16913",
          name: "Valkeala",
          state_id: "1162",
        },
        {
          id: "16914",
          name: "Vehkalahti",
          state_id: "1162",
        },
      ],
      "Lansi-Suomen Laani": [],
      Lappi: [
        {
          id: "16915",
          name: "Kemi",
          state_id: "1164",
        },
        {
          id: "16916",
          name: "Kemijarvi",
          state_id: "1164",
        },
        {
          id: "16917",
          name: "Rovaniemi",
          state_id: "1164",
        },
        {
          id: "16918",
          name: "Sonka",
          state_id: "1164",
        },
        {
          id: "16919",
          name: "Tornio",
          state_id: "1164",
        },
      ],
      "Northern Savonia": [],
      Ostrobothnia: [
        {
          id: "16920",
          name: "Jakobstad",
          state_id: "1166",
        },
        {
          id: "16921",
          name: "Oulunsalo",
          state_id: "1166",
        },
      ],
      "Oulun Laani": [],
      "Paijat-Hame": [
        {
          id: "16922",
          name: "Heinola",
          state_id: "1168",
        },
        {
          id: "16923",
          name: "Hollola",
          state_id: "1168",
        },
        {
          id: "16924",
          name: "Lahti",
          state_id: "1168",
        },
        {
          id: "16925",
          name: "Nastola",
          state_id: "1168",
        },
      ],
      Pirkanmaa: [
        {
          id: "16926",
          name: "Kangasala",
          state_id: "1169",
        },
        {
          id: "16927",
          name: "Lempaala",
          state_id: "1169",
        },
        {
          id: "16928",
          name: "Nokia",
          state_id: "1169",
        },
        {
          id: "16929",
          name: "Pirkkala",
          state_id: "1169",
        },
        {
          id: "16930",
          name: "Sastamala",
          state_id: "1169",
        },
        {
          id: "16931",
          name: "Tampere",
          state_id: "1169",
        },
        {
          id: "16932",
          name: "Valkeakoski",
          state_id: "1169",
        },
        {
          id: "16933",
          name: "Ylojarvi",
          state_id: "1169",
        },
      ],
      Pohjanmaa: [
        {
          id: "16934",
          name: "Kristiinankaupunki",
          state_id: "1170",
        },
        {
          id: "16935",
          name: "Mustasaari",
          state_id: "1170",
        },
        {
          id: "16936",
          name: "Pietarsaari",
          state_id: "1170",
        },
        {
          id: "16937",
          name: "Uusikarlepyy",
          state_id: "1170",
        },
        {
          id: "16938",
          name: "Vaasa",
          state_id: "1170",
        },
      ],
      "Pohjois-Karjala": [
        {
          id: "16939",
          name: "Joensuu",
          state_id: "1171",
        },
        {
          id: "16940",
          name: "Lieksa",
          state_id: "1171",
        },
      ],
      "Pohjois-Pohjanmaa": [
        {
          id: "16941",
          name: "Haukipudas",
          state_id: "1172",
        },
        {
          id: "16942",
          name: "Kempele",
          state_id: "1172",
        },
        {
          id: "16943",
          name: "Kuusamo",
          state_id: "1172",
        },
        {
          id: "16944",
          name: "Muhos",
          state_id: "1172",
        },
        {
          id: "16945",
          name: "Nivala",
          state_id: "1172",
        },
        {
          id: "16946",
          name: "Oulainen",
          state_id: "1172",
        },
        {
          id: "16947",
          name: "Oulu",
          state_id: "1172",
        },
        {
          id: "16948",
          name: "Raahe",
          state_id: "1172",
        },
        {
          id: "16949",
          name: "Ylivieska",
          state_id: "1172",
        },
      ],
      "Pohjois-Savo": [
        {
          id: "16950",
          name: "Iisalmi",
          state_id: "1173",
        },
        {
          id: "16951",
          name: "Kuopio",
          state_id: "1173",
        },
        {
          id: "16952",
          name: "Sillinjarvi",
          state_id: "1173",
        },
        {
          id: "16953",
          name: "Varkaus",
          state_id: "1173",
        },
      ],
      Saarijarvi: [
        {
          id: "16954",
          name: "Saarijarvi",
          state_id: "1174",
        },
      ],
      Satakunta: [
        {
          id: "16955",
          name: "Eura",
          state_id: "1175",
        },
        {
          id: "16956",
          name: "Eurajoki",
          state_id: "1175",
        },
        {
          id: "16957",
          name: "Harjavalta",
          state_id: "1175",
        },
        {
          id: "16958",
          name: "Huittinen",
          state_id: "1175",
        },
        {
          id: "16959",
          name: "Kankaanpaa",
          state_id: "1175",
        },
        {
          id: "16960",
          name: "Kokemaki",
          state_id: "1175",
        },
        {
          id: "16961",
          name: "Lappi",
          state_id: "1175",
        },
        {
          id: "16962",
          name: "Nakkila",
          state_id: "1175",
        },
        {
          id: "16963",
          name: "Noormarkku",
          state_id: "1175",
        },
        {
          id: "16964",
          name: "Pori",
          state_id: "1175",
        },
        {
          id: "16965",
          name: "Rauma",
          state_id: "1175",
        },
        {
          id: "16966",
          name: "Sakyla",
          state_id: "1175",
        },
        {
          id: "16967",
          name: "Ulvila",
          state_id: "1175",
        },
        {
          id: "16968",
          name: "Vammala",
          state_id: "1175",
        },
      ],
      "Southern Savonia": [],
      "Tavastia Proper": [],
      "Uleaborgs Lan": [],
      Uusimaa: [
        {
          id: "16969",
          name: "Espoo",
          state_id: "1179",
        },
        {
          id: "16970",
          name: "Hanko",
          state_id: "1179",
        },
        {
          id: "16971",
          name: "Helsinki",
          state_id: "1179",
        },
        {
          id: "16972",
          name: "Hyvinkaa",
          state_id: "1179",
        },
        {
          id: "16973",
          name: "Jarvenpaa",
          state_id: "1179",
        },
        {
          id: "16974",
          name: "Kauniainen",
          state_id: "1179",
        },
        {
          id: "16975",
          name: "Kerava",
          state_id: "1179",
        },
        {
          id: "16976",
          name: "Kirkkonummi",
          state_id: "1179",
        },
        {
          id: "16977",
          name: "Lohja",
          state_id: "1179",
        },
        {
          id: "16978",
          name: "Mantsala",
          state_id: "1179",
        },
        {
          id: "16979",
          name: "Nurmijarvi",
          state_id: "1179",
        },
        {
          id: "16980",
          name: "Sipoo",
          state_id: "1179",
        },
        {
          id: "16981",
          name: "Tammisaari",
          state_id: "1179",
        },
        {
          id: "16982",
          name: "Tuusula",
          state_id: "1179",
        },
        {
          id: "16983",
          name: "Vantaa",
          state_id: "1179",
        },
        {
          id: "16984",
          name: "Vihti",
          state_id: "1179",
        },
      ],
      "Varsinais-Suomi": [
        {
          id: "16985",
          name: "Kaarina",
          state_id: "1180",
        },
        {
          id: "16986",
          name: "Naantali",
          state_id: "1180",
        },
        {
          id: "16987",
          name: "Parainen",
          state_id: "1180",
        },
        {
          id: "16988",
          name: "Raisio",
          state_id: "1180",
        },
        {
          id: "16989",
          name: "Salo",
          state_id: "1180",
        },
        {
          id: "16990",
          name: "Turku",
          state_id: "1180",
        },
        {
          id: "16991",
          name: "Uusikaupunki",
          state_id: "1180",
        },
      ],
    },
  },
  FJ: {
    name: "Fiji",
    native: "Fiji",
    phone: "679",
    continent: "OC",
    capital: "Suva",
    currency: "FJD",
    languages: ["en", "fj", "hi", "ur"],
    emoji: "🇫🇯",
    emojiU: "U+1F1EB U+1F1EF",
    states: {
      Central: [
        {
          id: "16860",
          name: "Deuba",
          state_id: "1146",
        },
        {
          id: "16861",
          name: "Korovou",
          state_id: "1146",
        },
        {
          id: "16862",
          name: "Lami",
          state_id: "1146",
        },
        {
          id: "16863",
          name: "Namosi",
          state_id: "1146",
        },
        {
          id: "16864",
          name: "Nausori",
          state_id: "1146",
        },
        {
          id: "16865",
          name: "Navua",
          state_id: "1146",
        },
        {
          id: "16866",
          name: "Suva",
          state_id: "1146",
        },
      ],
      Eastern: [
        {
          id: "16867",
          name: "Levuka",
          state_id: "1147",
        },
        {
          id: "16868",
          name: "Malhaha",
          state_id: "1147",
        },
        {
          id: "16869",
          name: "Tubou",
          state_id: "1147",
        },
        {
          id: "16870",
          name: "Vunisea",
          state_id: "1147",
        },
      ],
      Northern: [
        {
          id: "16871",
          name: "Korokade",
          state_id: "1148",
        },
        {
          id: "16872",
          name: "Labasa",
          state_id: "1148",
        },
        {
          id: "16873",
          name: "Savusavu",
          state_id: "1148",
        },
      ],
      "South Pacific": [],
      Western: [
        {
          id: "16874",
          name: "Ba",
          state_id: "1150",
        },
        {
          id: "16875",
          name: "Lautoka",
          state_id: "1150",
        },
        {
          id: "16876",
          name: "Nadi",
          state_id: "1150",
        },
        {
          id: "16877",
          name: "Rakiraki",
          state_id: "1150",
        },
        {
          id: "16878",
          name: "Sigatoka",
          state_id: "1150",
        },
        {
          id: "16879",
          name: "Tavua",
          state_id: "1150",
        },
        {
          id: "16880",
          name: "Vatukoula",
          state_id: "1150",
        },
      ],
    },
  },
  FK: {
    name: "Falkland Islands",
    native: "Falkland Islands",
    phone: "500",
    continent: "SA",
    capital: "Stanley",
    currency: "FKP",
    languages: ["en"],
    emoji: "🇫🇰",
    emojiU: "U+1F1EB U+1F1F0",
    states: {
      "Falkland Islands": [],
      "South Georgia": [],
    },
  },
  FM: {
    name: "Micronesia",
    native: "Micronesia",
    phone: "691",
    continent: "OC",
    capital: "Palikir",
    currency: "USD",
    languages: ["en"],
    emoji: "🇫🇲",
    emojiU: "U+1F1EB U+1F1F2",
    states: {
      Chuuk: [
        {
          id: "29505",
          name: "Tol",
          state_id: "2460",
        },
        {
          id: "29506",
          name: "Weno",
          state_id: "2460",
        },
      ],
      Kusaie: [
        {
          id: "29507",
          name: "Lelu",
          state_id: "2461",
        },
      ],
      Pohnpei: [
        {
          id: "29508",
          name: "Kolonia",
          state_id: "2462",
        },
        {
          id: "29509",
          name: "Palikir",
          state_id: "2462",
        },
      ],
      Yap: [
        {
          id: "29510",
          name: "Colonia",
          state_id: "2463",
        },
      ],
    },
  },
  FO: {
    name: "Faroe Islands",
    native: "Føroyar",
    phone: "298",
    continent: "EU",
    capital: "Tórshavn",
    currency: "DKK",
    languages: ["fo"],
    emoji: "🇫🇴",
    emojiU: "U+1F1EB U+1F1F4",
    states: {
      Klaksvik: [
        {
          id: "16836",
          name: "Hvannasund",
          state_id: "1137",
        },
        {
          id: "16837",
          name: "Klaksvik",
          state_id: "1137",
        },
      ],
      "Nor ara Eysturoy": [],
      "Nor oy": [],
      Sandoy: [
        {
          id: "16838",
          name: "Husavik",
          state_id: "1140",
        },
        {
          id: "16839",
          name: "Sands",
          state_id: "1140",
        },
        {
          id: "16840",
          name: "Skalavik",
          state_id: "1140",
        },
        {
          id: "16841",
          name: "Skopun",
          state_id: "1140",
        },
        {
          id: "16842",
          name: "Skuvoy",
          state_id: "1140",
        },
      ],
      Streymoy: [
        {
          id: "16843",
          name: "Haldarsvik",
          state_id: "1141",
        },
        {
          id: "16844",
          name: "Hests",
          state_id: "1141",
        },
        {
          id: "16845",
          name: "Hosvik",
          state_id: "1141",
        },
        {
          id: "16846",
          name: "Hvalvik",
          state_id: "1141",
        },
        {
          id: "16847",
          name: "Kirkjubo",
          state_id: "1141",
        },
        {
          id: "16848",
          name: "Kollafjar",
          state_id: "1141",
        },
        {
          id: "16849",
          name: "Kvivik",
          state_id: "1141",
        },
        {
          id: "16850",
          name: "Nolsoy",
          state_id: "1141",
        },
        {
          id: "16851",
          name: "Saksun",
          state_id: "1141",
        },
        {
          id: "16852",
          name: "Torshavn",
          state_id: "1141",
        },
        {
          id: "16853",
          name: "Vestmanna",
          state_id: "1141",
        },
      ],
      "Su uroy": [],
      "Sy ra Eysturoy": [],
      Torshavn: [
        {
          id: "16854",
          name: "Torshavn",
          state_id: "1144",
        },
      ],
      Vaga: [
        {
          id: "16855",
          name: "Biggjar",
          state_id: "1145",
        },
        {
          id: "16856",
          name: "Midvags",
          state_id: "1145",
        },
        {
          id: "16857",
          name: "Mykines",
          state_id: "1145",
        },
        {
          id: "16858",
          name: "Sandavags",
          state_id: "1145",
        },
        {
          id: "16859",
          name: "Sorvags",
          state_id: "1145",
        },
      ],
    },
  },
  FR: {
    name: "France",
    native: "France",
    phone: "33",
    continent: "EU",
    capital: "Paris",
    currency: "EUR",
    languages: ["fr"],
    emoji: "🇫🇷",
    emojiU: "U+1F1EB U+1F1F7",
    states: {
      Ain: [
        {
          id: "16992",
          name: "Amberieu-en-Bugey",
          state_id: "1181",
        },
        {
          id: "16993",
          name: "Bellegarde-sur-Valserine",
          state_id: "1181",
        },
        {
          id: "16994",
          name: "Bourg-en-Bresse",
          state_id: "1181",
        },
        {
          id: "16995",
          name: "Oyonnax",
          state_id: "1181",
        },
      ],
      Aisne: [
        {
          id: "16996",
          name: "Chateau-Thierry",
          state_id: "1182",
        },
        {
          id: "16997",
          name: "Chauny",
          state_id: "1182",
        },
        {
          id: "16998",
          name: "Hirson",
          state_id: "1182",
        },
        {
          id: "16999",
          name: "Laon",
          state_id: "1182",
        },
        {
          id: "17000",
          name: "Saint-Quentin",
          state_id: "1182",
        },
        {
          id: "17001",
          name: "Soissons",
          state_id: "1182",
        },
        {
          id: "17002",
          name: "Strassbourg",
          state_id: "1182",
        },
        {
          id: "17003",
          name: "Tergnier",
          state_id: "1182",
        },
      ],
      "Albi Le Sequestre": [],
      Allier: [
        {
          id: "17004",
          name: "Cusset",
          state_id: "1184",
        },
        {
          id: "17005",
          name: "Montlucon",
          state_id: "1184",
        },
        {
          id: "17006",
          name: "Moulins",
          state_id: "1184",
        },
        {
          id: "17007",
          name: "Vichy",
          state_id: "1184",
        },
        {
          id: "17008",
          name: "Yzeure",
          state_id: "1184",
        },
      ],
      "Alpes-Cote dAzur": [],
      "Alpes-Maritimes": [
        {
          id: "17009",
          name: "Antibes",
          state_id: "1186",
        },
        {
          id: "17010",
          name: "Beausoleil",
          state_id: "1186",
        },
        {
          id: "17011",
          name: "Cagnes-sur-Mer",
          state_id: "1186",
        },
        {
          id: "17012",
          name: "Cannes",
          state_id: "1186",
        },
        {
          id: "17013",
          name: "Carros",
          state_id: "1186",
        },
        {
          id: "17014",
          name: "Grasse",
          state_id: "1186",
        },
        {
          id: "17015",
          name: "La Trinite",
          state_id: "1186",
        },
        {
          id: "17016",
          name: "Le Cannet",
          state_id: "1186",
        },
        {
          id: "17017",
          name: "Mandelieu-la-Napoule",
          state_id: "1186",
        },
        {
          id: "17018",
          name: "Menton",
          state_id: "1186",
        },
        {
          id: "17019",
          name: "Mougins",
          state_id: "1186",
        },
        {
          id: "17020",
          name: "Nice",
          state_id: "1186",
        },
        {
          id: "17021",
          name: "Roquebrune-Cap-Martin",
          state_id: "1186",
        },
        {
          id: "17022",
          name: "Saint-Laurent-du-Var",
          state_id: "1186",
        },
        {
          id: "17023",
          name: "Valbonne",
          state_id: "1186",
        },
        {
          id: "17024",
          name: "Vallauris",
          state_id: "1186",
        },
        {
          id: "17025",
          name: "Vence",
          state_id: "1186",
        },
        {
          id: "17026",
          name: "Villeneuve-Loubet",
          state_id: "1186",
        },
      ],
      "Alpes-de-Haute-Provence": [
        {
          id: "17027",
          name: "Digne-les-Bains",
          state_id: "1187",
        },
        {
          id: "17028",
          name: "Manosque",
          state_id: "1187",
        },
      ],
      Alsace: [
        {
          id: "17029",
          name: "Adainville",
          state_id: "1188",
        },
        {
          id: "17030",
          name: "Alby-sur-Cheran",
          state_id: "1188",
        },
        {
          id: "17031",
          name: "Aubervilliers",
          state_id: "1188",
        },
        {
          id: "17032",
          name: "Auterive",
          state_id: "1188",
        },
        {
          id: "17033",
          name: "Baillet",
          state_id: "1188",
        },
        {
          id: "17034",
          name: "Beaune",
          state_id: "1188",
        },
        {
          id: "17035",
          name: "Beauzelle",
          state_id: "1188",
        },
        {
          id: "17036",
          name: "Bonnet De Mure",
          state_id: "1188",
        },
        {
          id: "17037",
          name: "Bormes-les-Mimosas",
          state_id: "1188",
        },
        {
          id: "17038",
          name: "Brindas",
          state_id: "1188",
        },
        {
          id: "17039",
          name: "Burlats",
          state_id: "1188",
        },
        {
          id: "17040",
          name: "Buzancais",
          state_id: "1188",
        },
        {
          id: "17041",
          name: "Candillargues",
          state_id: "1188",
        },
        {
          id: "17042",
          name: "Carry-le-Rouet",
          state_id: "1188",
        },
        {
          id: "17043",
          name: "Cassis",
          state_id: "1188",
        },
        {
          id: "17044",
          name: "Cessenon-Sur-Orb",
          state_id: "1188",
        },
        {
          id: "17045",
          name: "Chanac",
          state_id: "1188",
        },
        {
          id: "17046",
          name: "Chevigny",
          state_id: "1188",
        },
        {
          id: "17047",
          name: "Cogolin",
          state_id: "1188",
        },
        {
          id: "17048",
          name: "Collioure",
          state_id: "1188",
        },
        {
          id: "17049",
          name: "Cremieu",
          state_id: "1188",
        },
        {
          id: "17050",
          name: "Drulingen",
          state_id: "1188",
        },
        {
          id: "17051",
          name: "Ecouen",
          state_id: "1188",
        },
        {
          id: "17052",
          name: "Eschau",
          state_id: "1188",
        },
        {
          id: "17053",
          name: "Feignies",
          state_id: "1188",
        },
        {
          id: "17054",
          name: "Ferus",
          state_id: "1188",
        },
        {
          id: "17055",
          name: "Fourqueux",
          state_id: "1188",
        },
        {
          id: "17056",
          name: "Franqueville",
          state_id: "1188",
        },
        {
          id: "17057",
          name: "Gignac",
          state_id: "1188",
        },
        {
          id: "17058",
          name: "Gravigny",
          state_id: "1188",
        },
        {
          id: "17059",
          name: "Hangenbieten",
          state_id: "1188",
        },
        {
          id: "17060",
          name: "Hunspach",
          state_id: "1188",
        },
        {
          id: "17061",
          name: "Kilstett",
          state_id: "1188",
        },
        {
          id: "17062",
          name: "La Chevroliere",
          state_id: "1188",
        },
        {
          id: "17063",
          name: "La-Fare-Les-Oliviers",
          state_id: "1188",
        },
        {
          id: "17064",
          name: "Lanvellec",
          state_id: "1188",
        },
        {
          id: "17065",
          name: "Le Faget",
          state_id: "1188",
        },
        {
          id: "17066",
          name: "Lesigny",
          state_id: "1188",
        },
        {
          id: "17067",
          name: "Lesquin",
          state_id: "1188",
        },
        {
          id: "17068",
          name: "Limonest",
          state_id: "1188",
        },
        {
          id: "17069",
          name: "Messein",
          state_id: "1188",
        },
        {
          id: "17070",
          name: "Morgat",
          state_id: "1188",
        },
        {
          id: "17071",
          name: "Mundolsheim",
          state_id: "1188",
        },
        {
          id: "17072",
          name: "Nantiat",
          state_id: "1188",
        },
        {
          id: "17073",
          name: "Niederbronn-les-Bain",
          state_id: "1188",
        },
        {
          id: "17074",
          name: "Nimes",
          state_id: "1188",
        },
        {
          id: "17075",
          name: "Opoul",
          state_id: "1188",
        },
        {
          id: "17076",
          name: "Pance",
          state_id: "1188",
        },
        {
          id: "17077",
          name: "Peronne",
          state_id: "1188",
        },
        {
          id: "17078",
          name: "Ploneour Lanvern",
          state_id: "1188",
        },
        {
          id: "17079",
          name: "Realmont",
          state_id: "1188",
        },
        {
          id: "17080",
          name: "Reichstett",
          state_id: "1188",
        },
        {
          id: "17081",
          name: "Saint Aubin",
          state_id: "1188",
        },
        {
          id: "17082",
          name: "Saint Christophe",
          state_id: "1188",
        },
        {
          id: "17083",
          name: "Saint Martin dÃƒÂ¢Ã‚Â€Ã‚Â™Here",
          state_id: "1188",
        },
        {
          id: "17084",
          name: "Saint-Berthevin",
          state_id: "1188",
        },
        {
          id: "17085",
          name: "Saint-Cergues",
          state_id: "1188",
        },
        {
          id: "17086",
          name: "Sancerre",
          state_id: "1188",
        },
        {
          id: "17087",
          name: "Sarzeau",
          state_id: "1188",
        },
        {
          id: "17088",
          name: "Seltz",
          state_id: "1188",
        },
        {
          id: "17089",
          name: "Seyssins",
          state_id: "1188",
        },
        {
          id: "17090",
          name: "Souffelweyersheim",
          state_id: "1188",
        },
        {
          id: "17091",
          name: "Vireux-Molhain",
          state_id: "1188",
        },
        {
          id: "17092",
          name: "Voves",
          state_id: "1188",
        },
        {
          id: "17093",
          name: "Wambrechies",
          state_id: "1188",
        },
        {
          id: "17094",
          name: "Wervocq Sud",
          state_id: "1188",
        },
      ],
      Aquitaine: [
        {
          id: "17095",
          name: "Abzac",
          state_id: "1189",
        },
        {
          id: "17096",
          name: "Bidart",
          state_id: "1189",
        },
        {
          id: "17097",
          name: "Biganos",
          state_id: "1189",
        },
        {
          id: "17098",
          name: "Buzet-sur-Baise",
          state_id: "1189",
        },
        {
          id: "17099",
          name: "Coursac",
          state_id: "1189",
        },
        {
          id: "17100",
          name: "Hasparren",
          state_id: "1189",
        },
        {
          id: "17101",
          name: "Landiras",
          state_id: "1189",
        },
        {
          id: "17102",
          name: "Le Haillan",
          state_id: "1189",
        },
        {
          id: "17103",
          name: "Ledat",
          state_id: "1189",
        },
        {
          id: "17104",
          name: "Martillac",
          state_id: "1189",
        },
        {
          id: "17105",
          name: "Puyoo",
          state_id: "1189",
        },
        {
          id: "17106",
          name: "Saint-Jean-dIllac",
          state_id: "1189",
        },
        {
          id: "17107",
          name: "Seignosse",
          state_id: "1189",
        },
        {
          id: "17108",
          name: "Tresses",
          state_id: "1189",
        },
      ],
      Ardeche: [
        {
          id: "17109",
          name: "Annonay",
          state_id: "1190",
        },
        {
          id: "17110",
          name: "Aubenas",
          state_id: "1190",
        },
        {
          id: "17111",
          name: "Guilherand-Granges",
          state_id: "1190",
        },
        {
          id: "17112",
          name: "Privas",
          state_id: "1190",
        },
        {
          id: "17113",
          name: "Tournon-sur-Rhone",
          state_id: "1190",
        },
      ],
      Ardennes: [
        {
          id: "17114",
          name: "Charleville-Mezieres",
          state_id: "1191",
        },
        {
          id: "17115",
          name: "Les Hautes-Rivieres",
          state_id: "1191",
        },
        {
          id: "17116",
          name: "Revin",
          state_id: "1191",
        },
        {
          id: "17117",
          name: "Sedan",
          state_id: "1191",
        },
      ],
      Ariege: [
        {
          id: "17118",
          name: "Foix",
          state_id: "1192",
        },
        {
          id: "17119",
          name: "Pamier",
          state_id: "1192",
        },
      ],
      Aube: [
        {
          id: "17120",
          name: "Bar-sur-Seine",
          state_id: "1193",
        },
        {
          id: "17121",
          name: "Romilly-sur-Seine",
          state_id: "1193",
        },
        {
          id: "17122",
          name: "Saint-Andre-les-Vergers",
          state_id: "1193",
        },
        {
          id: "17123",
          name: "Sainte-Savine",
          state_id: "1193",
        },
        {
          id: "17124",
          name: "Troyes",
          state_id: "1193",
        },
      ],
      Aude: [
        {
          id: "17125",
          name: "Carcassonne",
          state_id: "1194",
        },
        {
          id: "17126",
          name: "Castelnaudary",
          state_id: "1194",
        },
        {
          id: "17127",
          name: "Limoux",
          state_id: "1194",
        },
        {
          id: "17128",
          name: "Narbonne",
          state_id: "1194",
        },
      ],
      Auvergne: [
        {
          id: "17129",
          name: "Ambert",
          state_id: "1195",
        },
        {
          id: "17130",
          name: "Creuzier-le-Vieux",
          state_id: "1195",
        },
        {
          id: "17131",
          name: "Ferrieres",
          state_id: "1195",
        },
        {
          id: "17132",
          name: "Peschadoires",
          state_id: "1195",
        },
        {
          id: "17133",
          name: "Riotord",
          state_id: "1195",
        },
        {
          id: "17134",
          name: "Saint-Pal-de-Chalencon",
          state_id: "1195",
        },
        {
          id: "17135",
          name: "Saint-Romain-Lachalm",
          state_id: "1195",
        },
        {
          id: "17136",
          name: "Saint-Vidal",
          state_id: "1195",
        },
        {
          id: "17137",
          name: "Sainte-Sigolene",
          state_id: "1195",
        },
      ],
      Aveyron: [
        {
          id: "17138",
          name: "Millau",
          state_id: "1196",
        },
        {
          id: "17139",
          name: "Onet-le-Chataeu",
          state_id: "1196",
        },
        {
          id: "17140",
          name: "Rodez",
          state_id: "1196",
        },
        {
          id: "17141",
          name: "Villefranche-de-Rouergue",
          state_id: "1196",
        },
      ],
      "Bas-Rhin": [
        {
          id: "17142",
          name: "Bischheim",
          state_id: "1197",
        },
        {
          id: "17143",
          name: "Bischwiller",
          state_id: "1197",
        },
        {
          id: "17144",
          name: "Haguenau",
          state_id: "1197",
        },
        {
          id: "17145",
          name: "Hoenheim",
          state_id: "1197",
        },
        {
          id: "17146",
          name: "Illkirch-Graffenstaden",
          state_id: "1197",
        },
        {
          id: "17147",
          name: "Lingolsheim",
          state_id: "1197",
        },
        {
          id: "17148",
          name: "Obernai",
          state_id: "1197",
        },
        {
          id: "17149",
          name: "Ostwald",
          state_id: "1197",
        },
        {
          id: "17150",
          name: "Saverne",
          state_id: "1197",
        },
        {
          id: "17151",
          name: "Schiltigheim",
          state_id: "1197",
        },
        {
          id: "17152",
          name: "Selestat",
          state_id: "1197",
        },
        {
          id: "17153",
          name: "Strasbourg",
          state_id: "1197",
        },
      ],
      "Basse-Normandie": [
        {
          id: "17154",
          name: "Deauville",
          state_id: "1198",
        },
      ],
      "Bouches-du-Rhone": [
        {
          id: "17155",
          name: "Aix-en-Provence",
          state_id: "1199",
        },
        {
          id: "17156",
          name: "Allauch",
          state_id: "1199",
        },
        {
          id: "17157",
          name: "Arles",
          state_id: "1199",
        },
        {
          id: "17158",
          name: "Aubagne",
          state_id: "1199",
        },
        {
          id: "17159",
          name: "Berre-l''Etang",
          state_id: "1199",
        },
        {
          id: "17160",
          name: "Bouc-Bel-Air",
          state_id: "1199",
        },
        {
          id: "17161",
          name: "Chateauneuf-les-Martigues",
          state_id: "1199",
        },
        {
          id: "17162",
          name: "Chateaurenard",
          state_id: "1199",
        },
        {
          id: "17163",
          name: "Fos-sur-Mer",
          state_id: "1199",
        },
        {
          id: "17164",
          name: "Gardanne",
          state_id: "1199",
        },
        {
          id: "17165",
          name: "Istres",
          state_id: "1199",
        },
        {
          id: "17166",
          name: "La Ciotat",
          state_id: "1199",
        },
        {
          id: "17167",
          name: "Les Pennes-Mirabeau",
          state_id: "1199",
        },
        {
          id: "17168",
          name: "Maillane",
          state_id: "1199",
        },
        {
          id: "17169",
          name: "Marignane",
          state_id: "1199",
        },
        {
          id: "17170",
          name: "Marseille",
          state_id: "1199",
        },
        {
          id: "17171",
          name: "Martigues",
          state_id: "1199",
        },
        {
          id: "17172",
          name: "Miramas",
          state_id: "1199",
        },
        {
          id: "17173",
          name: "Plan-de-Cuques",
          state_id: "1199",
        },
        {
          id: "17174",
          name: "Port-de-Bouc",
          state_id: "1199",
        },
        {
          id: "17175",
          name: "Rognac",
          state_id: "1199",
        },
        {
          id: "17176",
          name: "Saint-Martin-de-Crau",
          state_id: "1199",
        },
        {
          id: "17177",
          name: "Saint-Remy-de-Provence",
          state_id: "1199",
        },
        {
          id: "17178",
          name: "Salon-de-Provence",
          state_id: "1199",
        },
        {
          id: "17179",
          name: "Septemes-les-Vallons",
          state_id: "1199",
        },
        {
          id: "17180",
          name: "Tarascon",
          state_id: "1199",
        },
        {
          id: "17181",
          name: "Vitrolles",
          state_id: "1199",
        },
      ],
      Bourgogne: [
        {
          id: "17182",
          name: "Migennes",
          state_id: "1200",
        },
      ],
      Bretagne: [
        {
          id: "17183",
          name: "Javene",
          state_id: "1201",
        },
        {
          id: "17184",
          name: "Plouha",
          state_id: "1201",
        },
      ],
      Brittany: [
        {
          id: "17185",
          name: "Brehan",
          state_id: "1202",
        },
        {
          id: "17186",
          name: "Broons",
          state_id: "1202",
        },
        {
          id: "17187",
          name: "Guipry",
          state_id: "1202",
        },
        {
          id: "17188",
          name: "Miniac-Morvan",
          state_id: "1202",
        },
        {
          id: "17189",
          name: "Ploudaniel",
          state_id: "1202",
        },
        {
          id: "17190",
          name: "Vern-sur-Seiche",
          state_id: "1202",
        },
      ],
      Burgundy: [
        {
          id: "17191",
          name: "Aillant-sur-Tholon",
          state_id: "1203",
        },
      ],
      Calvados: [
        {
          id: "17192",
          name: "Bayeux",
          state_id: "1204",
        },
        {
          id: "17193",
          name: "Caen",
          state_id: "1204",
        },
        {
          id: "17194",
          name: "Herouville-Saint-Clair",
          state_id: "1204",
        },
        {
          id: "17195",
          name: "Lisieux",
          state_id: "1204",
        },
        {
          id: "17196",
          name: "Mondeville",
          state_id: "1204",
        },
        {
          id: "17197",
          name: "Vire",
          state_id: "1204",
        },
      ],
      Cantal: [
        {
          id: "17198",
          name: "Aurillac",
          state_id: "1205",
        },
      ],
      Cedex: [
        {
          id: "17199",
          name: "Brumath",
          state_id: "1206",
        },
        {
          id: "17200",
          name: "Courtaboeuf",
          state_id: "1206",
        },
        {
          id: "17201",
          name: "Iregny",
          state_id: "1206",
        },
        {
          id: "17202",
          name: "cedex",
          state_id: "1206",
        },
      ],
      Centre: [
        {
          id: "17203",
          name: "Azay-le-Rideau",
          state_id: "1207",
        },
        {
          id: "17204",
          name: "Chevillon-sur-Huillard",
          state_id: "1207",
        },
        {
          id: "17205",
          name: "Cloyes-sur-le-Loir",
          state_id: "1207",
        },
        {
          id: "17206",
          name: "Gellainville",
          state_id: "1207",
        },
        {
          id: "17207",
          name: "La Chaussse-Saint-Victor",
          state_id: "1207",
        },
        {
          id: "17208",
          name: "La Ville-aux-Clercs",
          state_id: "1207",
        },
        {
          id: "17209",
          name: "Ladon",
          state_id: "1207",
        },
        {
          id: "17210",
          name: "Le Chatelet",
          state_id: "1207",
        },
      ],
      Charente: [
        {
          id: "17211",
          name: "Angouleme",
          state_id: "1208",
        },
        {
          id: "17212",
          name: "Cognac",
          state_id: "1208",
        },
        {
          id: "17213",
          name: "Lencloitre",
          state_id: "1208",
        },
        {
          id: "17214",
          name: "Soyaux",
          state_id: "1208",
        },
      ],
      "Charente-Maritime": [
        {
          id: "17215",
          name: "La Rochelle",
          state_id: "1209",
        },
        {
          id: "17216",
          name: "Rochefort",
          state_id: "1209",
        },
        {
          id: "17217",
          name: "Royan",
          state_id: "1209",
        },
        {
          id: "17218",
          name: "Saintes",
          state_id: "1209",
        },
      ],
      Cher: [
        {
          id: "17219",
          name: "Bourges",
          state_id: "1210",
        },
        {
          id: "17220",
          name: "Saint-Amand-Montrond",
          state_id: "1210",
        },
        {
          id: "17221",
          name: "Saint-Doulchard",
          state_id: "1210",
        },
        {
          id: "17222",
          name: "Vierzon",
          state_id: "1210",
        },
      ],
      Correze: [
        {
          id: "17223",
          name: "Brive-la-Gaillarde",
          state_id: "1211",
        },
        {
          id: "17224",
          name: "Tulle",
          state_id: "1211",
        },
        {
          id: "17225",
          name: "Ussel",
          state_id: "1211",
        },
      ],
      "Corse-du-Sud": [
        {
          id: "17226",
          name: "Ajaccio",
          state_id: "1212",
        },
        {
          id: "17227",
          name: "Porto-Vecchio",
          state_id: "1212",
        },
      ],
      "Cote-d''Or": [
        {
          id: "17228",
          name: "Beaune",
          state_id: "1213",
        },
        {
          id: "17229",
          name: "Chenove",
          state_id: "1213",
        },
        {
          id: "17230",
          name: "Dijon",
          state_id: "1213",
        },
        {
          id: "17231",
          name: "Quetigny",
          state_id: "1213",
        },
        {
          id: "17232",
          name: "Talant",
          state_id: "1213",
        },
      ],
      "Cotes-d''Armor": [
        {
          id: "17233",
          name: "Dinan",
          state_id: "1214",
        },
        {
          id: "17234",
          name: "Lamballe",
          state_id: "1214",
        },
        {
          id: "17235",
          name: "Lannion",
          state_id: "1214",
        },
        {
          id: "17236",
          name: "Loudeac",
          state_id: "1214",
        },
        {
          id: "17237",
          name: "Plerin",
          state_id: "1214",
        },
        {
          id: "17238",
          name: "Ploufragan",
          state_id: "1214",
        },
        {
          id: "17239",
          name: "Saint-Brieuc",
          state_id: "1214",
        },
      ],
      Creuse: [
        {
          id: "17240",
          name: "Gueret",
          state_id: "1215",
        },
      ],
      Crolles: [
        {
          id: "17241",
          name: "Crolles",
          state_id: "1216",
        },
      ],
      "Deux-Sevres": [
        {
          id: "17242",
          name: "Bressuire",
          state_id: "1217",
        },
        {
          id: "17243",
          name: "Niort",
          state_id: "1217",
        },
        {
          id: "17244",
          name: "Parthenay",
          state_id: "1217",
        },
        {
          id: "17245",
          name: "Thouars",
          state_id: "1217",
        },
      ],
      Dordogne: [
        {
          id: "17246",
          name: "Bergerac",
          state_id: "1218",
        },
        {
          id: "17247",
          name: "Perigueux",
          state_id: "1218",
        },
        {
          id: "17248",
          name: "Sarlat-la-Caneda",
          state_id: "1218",
        },
      ],
      Doubs: [
        {
          id: "17249",
          name: "Audincourt",
          state_id: "1219",
        },
        {
          id: "17250",
          name: "Besancon",
          state_id: "1219",
        },
        {
          id: "17251",
          name: "Beure",
          state_id: "1219",
        },
        {
          id: "17252",
          name: "Montbeliard",
          state_id: "1219",
        },
        {
          id: "17253",
          name: "Pontarlier",
          state_id: "1219",
        },
        {
          id: "17254",
          name: "Valentigney",
          state_id: "1219",
        },
      ],
      Drome: [
        {
          id: "17255",
          name: "Bourg-les-Valence",
          state_id: "1220",
        },
        {
          id: "17256",
          name: "Montelimar",
          state_id: "1220",
        },
        {
          id: "17257",
          name: "Pierrelatte",
          state_id: "1220",
        },
        {
          id: "17258",
          name: "Romans-sur-Isere",
          state_id: "1220",
        },
        {
          id: "17259",
          name: "Valence",
          state_id: "1220",
        },
      ],
      Essonne: [
        {
          id: "17260",
          name: "Athis-Mons",
          state_id: "1221",
        },
        {
          id: "17261",
          name: "Bretigny-sur-Orge",
          state_id: "1221",
        },
        {
          id: "17262",
          name: "Brunoy",
          state_id: "1221",
        },
        {
          id: "17263",
          name: "Bures-sur-Yvette",
          state_id: "1221",
        },
        {
          id: "17264",
          name: "Chilly-Mazarin",
          state_id: "1221",
        },
        {
          id: "17265",
          name: "Corbeil-Essonnes",
          state_id: "1221",
        },
        {
          id: "17266",
          name: "Courcouronnes",
          state_id: "1221",
        },
        {
          id: "17267",
          name: "Dourdan",
          state_id: "1221",
        },
        {
          id: "17268",
          name: "Draveil",
          state_id: "1221",
        },
        {
          id: "17269",
          name: "Epinay-sous-Senart",
          state_id: "1221",
        },
        {
          id: "17270",
          name: "Epinay-sur-Orge",
          state_id: "1221",
        },
        {
          id: "17271",
          name: "Etampes",
          state_id: "1221",
        },
        {
          id: "17272",
          name: "Evry",
          state_id: "1221",
        },
        {
          id: "17273",
          name: "Fleury-Merogis",
          state_id: "1221",
        },
        {
          id: "17274",
          name: "Gif-sur-Yvette",
          state_id: "1221",
        },
        {
          id: "17275",
          name: "Grigny",
          state_id: "1221",
        },
        {
          id: "17276",
          name: "Igny",
          state_id: "1221",
        },
        {
          id: "17277",
          name: "Juvisy-sur-Orge",
          state_id: "1221",
        },
        {
          id: "17278",
          name: "Les Ulis",
          state_id: "1221",
        },
        {
          id: "17279",
          name: "Longjumeau",
          state_id: "1221",
        },
        {
          id: "17280",
          name: "Massy",
          state_id: "1221",
        },
        {
          id: "17281",
          name: "Mennecy",
          state_id: "1221",
        },
        {
          id: "17282",
          name: "Montgeron",
          state_id: "1221",
        },
        {
          id: "17283",
          name: "Morangis",
          state_id: "1221",
        },
        {
          id: "17284",
          name: "Morsang-sur-Orge",
          state_id: "1221",
        },
        {
          id: "17285",
          name: "Orsay",
          state_id: "1221",
        },
        {
          id: "17286",
          name: "Palaiseau",
          state_id: "1221",
        },
        {
          id: "17287",
          name: "Ris-Orangis",
          state_id: "1221",
        },
        {
          id: "17288",
          name: "Saint-Michel-sur-Orge",
          state_id: "1221",
        },
        {
          id: "17289",
          name: "Sainte-Genevieve-des-Bois",
          state_id: "1221",
        },
        {
          id: "17290",
          name: "Savigny-sur-Orge",
          state_id: "1221",
        },
        {
          id: "17291",
          name: "Verrieres-le-Buisson",
          state_id: "1221",
        },
        {
          id: "17292",
          name: "Vigneux-sur-Seine",
          state_id: "1221",
        },
        {
          id: "17293",
          name: "Villebon-sur-Yvette",
          state_id: "1221",
        },
        {
          id: "17294",
          name: "Viry-Chatillon",
          state_id: "1221",
        },
        {
          id: "17295",
          name: "Yerres",
          state_id: "1221",
        },
      ],
      Eure: [
        {
          id: "17296",
          name: "Bernay",
          state_id: "1222",
        },
        {
          id: "17297",
          name: "Evreux",
          state_id: "1222",
        },
        {
          id: "17298",
          name: "Gisors",
          state_id: "1222",
        },
        {
          id: "17299",
          name: "Louviers",
          state_id: "1222",
        },
        {
          id: "17300",
          name: "Pont-Audemer",
          state_id: "1222",
        },
        {
          id: "17301",
          name: "Val-de-Reuil",
          state_id: "1222",
        },
        {
          id: "17302",
          name: "Vernon",
          state_id: "1222",
        },
      ],
      "Eure-et-Loir": [
        {
          id: "17303",
          name: "Chartres",
          state_id: "1223",
        },
        {
          id: "17304",
          name: "Chateaudun",
          state_id: "1223",
        },
        {
          id: "17305",
          name: "Dreux",
          state_id: "1223",
        },
        {
          id: "17306",
          name: "Luce",
          state_id: "1223",
        },
        {
          id: "17307",
          name: "Mainvillier",
          state_id: "1223",
        },
        {
          id: "17308",
          name: "Nogent-le-Rotrou",
          state_id: "1223",
        },
        {
          id: "17309",
          name: "Vernouillet",
          state_id: "1223",
        },
      ],
      Feucherolles: [
        {
          id: "17310",
          name: "Feucherolles",
          state_id: "1224",
        },
      ],
      Finistere: [
        {
          id: "17311",
          name: "Brest",
          state_id: "1225",
        },
        {
          id: "17312",
          name: "Concarneau",
          state_id: "1225",
        },
        {
          id: "17313",
          name: "Douarnenez",
          state_id: "1225",
        },
        {
          id: "17314",
          name: "Guipavas",
          state_id: "1225",
        },
        {
          id: "17315",
          name: "Landerneau",
          state_id: "1225",
        },
        {
          id: "17316",
          name: "Le Relecq-Kerhoun",
          state_id: "1225",
        },
        {
          id: "17317",
          name: "Morlaix",
          state_id: "1225",
        },
        {
          id: "17318",
          name: "Plougastel-Daoulas",
          state_id: "1225",
        },
        {
          id: "17319",
          name: "Plouzane",
          state_id: "1225",
        },
        {
          id: "17320",
          name: "Quimper",
          state_id: "1225",
        },
        {
          id: "17321",
          name: "Quimperle",
          state_id: "1225",
        },
      ],
      "Franche-Comte": [
        {
          id: "17322",
          name: "Charquemont",
          state_id: "1226",
        },
        {
          id: "17323",
          name: "Chemaudin",
          state_id: "1226",
        },
        {
          id: "17324",
          name: "Pelousey",
          state_id: "1226",
        },
        {
          id: "17325",
          name: "Perrigny",
          state_id: "1226",
        },
        {
          id: "17326",
          name: "Pirey",
          state_id: "1226",
        },
        {
          id: "17327",
          name: "Villers-le-Lac",
          state_id: "1226",
        },
      ],
      Gard: [
        {
          id: "17328",
          name: "Ales",
          state_id: "1227",
        },
        {
          id: "17329",
          name: "Bagnols-sur-Ceze",
          state_id: "1227",
        },
        {
          id: "17330",
          name: "Beaucaire",
          state_id: "1227",
        },
        {
          id: "17331",
          name: "Nimes",
          state_id: "1227",
        },
        {
          id: "17332",
          name: "Pont-Saint-Esprit",
          state_id: "1227",
        },
        {
          id: "17333",
          name: "Saint-Gilles",
          state_id: "1227",
        },
        {
          id: "17334",
          name: "Vauvert",
          state_id: "1227",
        },
        {
          id: "17335",
          name: "Villeneuve-les-Avignon",
          state_id: "1227",
        },
      ],
      Gers: [
        {
          id: "17336",
          name: "Auch",
          state_id: "1228",
        },
        {
          id: "17337",
          name: "Beraut",
          state_id: "1228",
        },
      ],
      Gironde: [
        {
          id: "17338",
          name: "Ambares-et-Lagrave",
          state_id: "1229",
        },
        {
          id: "17339",
          name: "Arcachon",
          state_id: "1229",
        },
        {
          id: "17340",
          name: "Begles",
          state_id: "1229",
        },
        {
          id: "17341",
          name: "Blanquefort",
          state_id: "1229",
        },
        {
          id: "17342",
          name: "Bordeaux",
          state_id: "1229",
        },
        {
          id: "17343",
          name: "Bruges",
          state_id: "1229",
        },
        {
          id: "17344",
          name: "Cenon",
          state_id: "1229",
        },
        {
          id: "17345",
          name: "Cestas",
          state_id: "1229",
        },
        {
          id: "17346",
          name: "Eysines",
          state_id: "1229",
        },
        {
          id: "17347",
          name: "Floirac",
          state_id: "1229",
        },
        {
          id: "17348",
          name: "Gradignan",
          state_id: "1229",
        },
        {
          id: "17349",
          name: "Gujan-Mestras",
          state_id: "1229",
        },
        {
          id: "17350",
          name: "La Teste-de-Buch",
          state_id: "1229",
        },
        {
          id: "17351",
          name: "Le Bouscat",
          state_id: "1229",
        },
        {
          id: "17352",
          name: "Libourne",
          state_id: "1229",
        },
        {
          id: "17353",
          name: "Lormont",
          state_id: "1229",
        },
        {
          id: "17354",
          name: "Merignac",
          state_id: "1229",
        },
        {
          id: "17355",
          name: "Pessac",
          state_id: "1229",
        },
        {
          id: "17356",
          name: "Saint-Medard-en-Jalles",
          state_id: "1229",
        },
        {
          id: "17357",
          name: "Talence",
          state_id: "1229",
        },
        {
          id: "17358",
          name: "Villenave-d''Ornon",
          state_id: "1229",
        },
      ],
      "Haut-Rhin": [
        {
          id: "17359",
          name: "Cernay",
          state_id: "1230",
        },
        {
          id: "17360",
          name: "Colmar",
          state_id: "1230",
        },
        {
          id: "17361",
          name: "Guebwiller",
          state_id: "1230",
        },
        {
          id: "17362",
          name: "Illzach",
          state_id: "1230",
        },
        {
          id: "17363",
          name: "Kingersheim",
          state_id: "1230",
        },
        {
          id: "17364",
          name: "Mulhouse",
          state_id: "1230",
        },
        {
          id: "17365",
          name: "Riediesheim",
          state_id: "1230",
        },
        {
          id: "17366",
          name: "Rixheim",
          state_id: "1230",
        },
        {
          id: "17367",
          name: "Saint-Louis",
          state_id: "1230",
        },
        {
          id: "17368",
          name: "Wittelsheim",
          state_id: "1230",
        },
        {
          id: "17369",
          name: "Wittenheim",
          state_id: "1230",
        },
      ],
      "Haute-Corse": [
        {
          id: "17370",
          name: "Bastia",
          state_id: "1231",
        },
      ],
      "Haute-Garonne": [
        {
          id: "17371",
          name: "Balma",
          state_id: "1232",
        },
        {
          id: "17372",
          name: "Blagnac",
          state_id: "1232",
        },
        {
          id: "17373",
          name: "Colomiers",
          state_id: "1232",
        },
        {
          id: "17374",
          name: "Cugnaux",
          state_id: "1232",
        },
        {
          id: "17375",
          name: "L''Union",
          state_id: "1232",
        },
        {
          id: "17376",
          name: "Muret",
          state_id: "1232",
        },
        {
          id: "17377",
          name: "Plaisance-du-Touch",
          state_id: "1232",
        },
        {
          id: "17378",
          name: "Ramonville-Saint-Agne",
          state_id: "1232",
        },
        {
          id: "17379",
          name: "Saint-Gaudens",
          state_id: "1232",
        },
        {
          id: "17380",
          name: "Saint-Orens-de-Gameville",
          state_id: "1232",
        },
        {
          id: "17381",
          name: "Toulouse",
          state_id: "1232",
        },
        {
          id: "17382",
          name: "Tournefeuille",
          state_id: "1232",
        },
      ],
      "Haute-Loire": [
        {
          id: "17383",
          name: "Blanzac",
          state_id: "1233",
        },
        {
          id: "17384",
          name: "Le Puy-en-Velay",
          state_id: "1233",
        },
      ],
      "Haute-Marne": [
        {
          id: "17385",
          name: "Chaumont",
          state_id: "1234",
        },
        {
          id: "17386",
          name: "Langres",
          state_id: "1234",
        },
        {
          id: "17387",
          name: "Saint-Dizier",
          state_id: "1234",
        },
      ],
      "Haute-Saone": [
        {
          id: "17388",
          name: "Hericourt",
          state_id: "1235",
        },
        {
          id: "17389",
          name: "Lure",
          state_id: "1235",
        },
        {
          id: "17390",
          name: "Luxeuil-les-Bains",
          state_id: "1235",
        },
        {
          id: "17391",
          name: "Vesoul",
          state_id: "1235",
        },
      ],
      "Haute-Savoie": [
        {
          id: "17392",
          name: "Annecy",
          state_id: "1236",
        },
        {
          id: "17393",
          name: "Annecy-le-Vieux",
          state_id: "1236",
        },
        {
          id: "17394",
          name: "Annemasse",
          state_id: "1236",
        },
        {
          id: "17395",
          name: "Archamps",
          state_id: "1236",
        },
        {
          id: "17396",
          name: "Bonneville",
          state_id: "1236",
        },
        {
          id: "17397",
          name: "Chamonix-Mont-Blanc",
          state_id: "1236",
        },
        {
          id: "17398",
          name: "Cluses",
          state_id: "1236",
        },
        {
          id: "17399",
          name: "Contamine sur Arve",
          state_id: "1236",
        },
        {
          id: "17400",
          name: "Cran-Gevrier",
          state_id: "1236",
        },
        {
          id: "17401",
          name: "Passy",
          state_id: "1236",
        },
        {
          id: "17402",
          name: "Rumilly",
          state_id: "1236",
        },
        {
          id: "17403",
          name: "Sallanches",
          state_id: "1236",
        },
        {
          id: "17404",
          name: "Seynod",
          state_id: "1236",
        },
        {
          id: "17405",
          name: "Thonon-les-Bains",
          state_id: "1236",
        },
      ],
      "Haute-Vienne": [
        {
          id: "17406",
          name: "Gaillard",
          state_id: "1237",
        },
        {
          id: "17407",
          name: "Limoges",
          state_id: "1237",
        },
        {
          id: "17408",
          name: "Saint-Junien",
          state_id: "1237",
        },
      ],
      "Hautes-Alpes": [
        {
          id: "17409",
          name: "Briancon",
          state_id: "1238",
        },
        {
          id: "17410",
          name: "Gap",
          state_id: "1238",
        },
      ],
      "Hautes-Pyrenees": [
        {
          id: "17411",
          name: "Lourdes",
          state_id: "1239",
        },
        {
          id: "17412",
          name: "Tarbes",
          state_id: "1239",
        },
      ],
      "Hauts-de-Seine": [
        {
          id: "17413",
          name: "Antony",
          state_id: "1240",
        },
        {
          id: "17414",
          name: "Asnieres-sur-Seine",
          state_id: "1240",
        },
        {
          id: "17415",
          name: "Bagneux",
          state_id: "1240",
        },
        {
          id: "17416",
          name: "Bois-Colombes",
          state_id: "1240",
        },
        {
          id: "17417",
          name: "Boulogne-Billancourt",
          state_id: "1240",
        },
        {
          id: "17418",
          name: "Bourg-la-Reine",
          state_id: "1240",
        },
        {
          id: "17419",
          name: "Chatenay-Malabry",
          state_id: "1240",
        },
        {
          id: "17420",
          name: "Chatillon",
          state_id: "1240",
        },
        {
          id: "17421",
          name: "Chaville",
          state_id: "1240",
        },
        {
          id: "17422",
          name: "Clamart",
          state_id: "1240",
        },
        {
          id: "17423",
          name: "Clichy",
          state_id: "1240",
        },
        {
          id: "17424",
          name: "Colombes",
          state_id: "1240",
        },
        {
          id: "17425",
          name: "Courbevoie",
          state_id: "1240",
        },
        {
          id: "17426",
          name: "Fontenay-aux-Roses",
          state_id: "1240",
        },
        {
          id: "17427",
          name: "Garches",
          state_id: "1240",
        },
        {
          id: "17428",
          name: "Gennevillers",
          state_id: "1240",
        },
        {
          id: "17429",
          name: "Issy-les-Moulineaux",
          state_id: "1240",
        },
        {
          id: "17430",
          name: "La Garenne-Colombes",
          state_id: "1240",
        },
        {
          id: "17431",
          name: "Le Plessis-Robinson",
          state_id: "1240",
        },
        {
          id: "17432",
          name: "Levallois-Perret",
          state_id: "1240",
        },
        {
          id: "17433",
          name: "Malakoff",
          state_id: "1240",
        },
        {
          id: "17434",
          name: "Meudon",
          state_id: "1240",
        },
        {
          id: "17435",
          name: "Montrouge",
          state_id: "1240",
        },
        {
          id: "17436",
          name: "Nanterre",
          state_id: "1240",
        },
        {
          id: "17437",
          name: "Neuilly-sur-Seine",
          state_id: "1240",
        },
        {
          id: "17438",
          name: "Puteaux",
          state_id: "1240",
        },
        {
          id: "17439",
          name: "Rueil-Malmaison",
          state_id: "1240",
        },
        {
          id: "17440",
          name: "Saint-Cloud",
          state_id: "1240",
        },
        {
          id: "17441",
          name: "Sceaux",
          state_id: "1240",
        },
        {
          id: "17442",
          name: "Sevres",
          state_id: "1240",
        },
        {
          id: "17443",
          name: "Suresnes",
          state_id: "1240",
        },
        {
          id: "17444",
          name: "Vanves",
          state_id: "1240",
        },
        {
          id: "17445",
          name: "Ville-d''Avray",
          state_id: "1240",
        },
        {
          id: "17446",
          name: "Villeneuve-la-Garenne",
          state_id: "1240",
        },
      ],
      Herault: [
        {
          id: "17447",
          name: "Agde",
          state_id: "1241",
        },
        {
          id: "17448",
          name: "Beziers",
          state_id: "1241",
        },
        {
          id: "17449",
          name: "Castelnau-le-Lez",
          state_id: "1241",
        },
        {
          id: "17450",
          name: "Frontignan",
          state_id: "1241",
        },
        {
          id: "17451",
          name: "Lattes",
          state_id: "1241",
        },
        {
          id: "17452",
          name: "Lunel",
          state_id: "1241",
        },
        {
          id: "17453",
          name: "Mauguio",
          state_id: "1241",
        },
        {
          id: "17454",
          name: "Montpellier",
          state_id: "1241",
        },
        {
          id: "17455",
          name: "Sete",
          state_id: "1241",
        },
      ],
      "Ile-de-France": [
        {
          id: "17456",
          name: "Champagne-sur-Oise",
          state_id: "1242",
        },
        {
          id: "17457",
          name: "Croissy-Beaubourg",
          state_id: "1242",
        },
        {
          id: "17458",
          name: "Gennevilliers",
          state_id: "1242",
        },
        {
          id: "17459",
          name: "Le Mesnil-le-Roi",
          state_id: "1242",
        },
        {
          id: "17460",
          name: "Le Plessis-Bouchard",
          state_id: "1242",
        },
        {
          id: "17461",
          name: "Rebais",
          state_id: "1242",
        },
        {
          id: "17462",
          name: "Saint-Thibault-des-Vignes",
          state_id: "1242",
        },
      ],
      "Ille-et-Vilaine": [
        {
          id: "17463",
          name: "Cesson-Sevigne",
          state_id: "1243",
        },
        {
          id: "17464",
          name: "Dinard",
          state_id: "1243",
        },
        {
          id: "17465",
          name: "Fougeres",
          state_id: "1243",
        },
        {
          id: "17466",
          name: "Rennes",
          state_id: "1243",
        },
        {
          id: "17467",
          name: "Saint-Malo",
          state_id: "1243",
        },
        {
          id: "17468",
          name: "Vitre",
          state_id: "1243",
        },
      ],
      Indre: [
        {
          id: "17469",
          name: "Chateauroux",
          state_id: "1244",
        },
        {
          id: "17470",
          name: "Issoudun",
          state_id: "1244",
        },
      ],
      "Indre-et-Loire": [
        {
          id: "17471",
          name: "Amboise",
          state_id: "1245",
        },
        {
          id: "17472",
          name: "Joue-les-Tours",
          state_id: "1245",
        },
        {
          id: "17473",
          name: "Saint-Avertin",
          state_id: "1245",
        },
        {
          id: "17474",
          name: "Saint-Cyr-sur-Loire",
          state_id: "1245",
        },
        {
          id: "17475",
          name: "Saint-Pierre-des-Corps",
          state_id: "1245",
        },
        {
          id: "17476",
          name: "Tours",
          state_id: "1245",
        },
      ],
      Isere: [
        {
          id: "17477",
          name: "Bourgoin-Jallieu",
          state_id: "1246",
        },
        {
          id: "17478",
          name: "Crolles",
          state_id: "1246",
        },
        {
          id: "17479",
          name: "Echirolles",
          state_id: "1246",
        },
        {
          id: "17480",
          name: "Fontaine",
          state_id: "1246",
        },
        {
          id: "17481",
          name: "Grenoble",
          state_id: "1246",
        },
        {
          id: "17482",
          name: "Le Pont-de-Claix",
          state_id: "1246",
        },
        {
          id: "17483",
          name: "Meylan",
          state_id: "1246",
        },
        {
          id: "17484",
          name: "Saint-Egreve",
          state_id: "1246",
        },
        {
          id: "17485",
          name: "Saint-Martin-d''Heres",
          state_id: "1246",
        },
        {
          id: "17486",
          name: "Seyssinet-Pariset",
          state_id: "1246",
        },
        {
          id: "17487",
          name: "Vienne",
          state_id: "1246",
        },
        {
          id: "17488",
          name: "Villefontaine",
          state_id: "1246",
        },
        {
          id: "17489",
          name: "Voiron",
          state_id: "1246",
        },
      ],
      Jura: [
        {
          id: "17490",
          name: "Champagnole",
          state_id: "1247",
        },
        {
          id: "17491",
          name: "Dole",
          state_id: "1247",
        },
        {
          id: "17492",
          name: "Lons-le-Saunier",
          state_id: "1247",
        },
        {
          id: "17493",
          name: "Saint-Claude",
          state_id: "1247",
        },
      ],
      Klagenfurt: [
        {
          id: "17494",
          name: "Sebastiangasse",
          state_id: "1248",
        },
      ],
      Landes: [
        {
          id: "17495",
          name: "Biscarrosse",
          state_id: "1249",
        },
        {
          id: "17496",
          name: "Dax",
          state_id: "1249",
        },
        {
          id: "17497",
          name: "Hagetmau",
          state_id: "1249",
        },
        {
          id: "17498",
          name: "Landes",
          state_id: "1249",
        },
        {
          id: "17499",
          name: "Mont-de-Marsan",
          state_id: "1249",
        },
        {
          id: "17500",
          name: "Saint-Paul-les-Dax",
          state_id: "1249",
        },
        {
          id: "17501",
          name: "Tarnos",
          state_id: "1249",
        },
      ],
      "Languedoc-Roussillon": [
        {
          id: "17502",
          name: "Codolet",
          state_id: "1250",
        },
        {
          id: "17503",
          name: "Cuxac-d''Aude",
          state_id: "1250",
        },
        {
          id: "17504",
          name: "Gigean",
          state_id: "1250",
        },
        {
          id: "17505",
          name: "Grabels",
          state_id: "1250",
        },
        {
          id: "17506",
          name: "Lamalou-les-Bains",
          state_id: "1250",
        },
        {
          id: "17507",
          name: "Perols",
          state_id: "1250",
        },
        {
          id: "17508",
          name: "Peyrens",
          state_id: "1250",
        },
        {
          id: "17509",
          name: "Tuchan",
          state_id: "1250",
        },
      ],
      Larcay: [
        {
          id: "17510",
          name: "Larcay",
          state_id: "1251",
        },
      ],
      "Le Castellet": [],
      "Le Creusot": [],
      Limousin: [
        {
          id: "17511",
          name: "Voutezac",
          state_id: "1254",
        },
      ],
      "Loir-et-Cher": [
        {
          id: "17512",
          name: "Blois",
          state_id: "1255",
        },
        {
          id: "17513",
          name: "Romorantin-Lanthenay",
          state_id: "1255",
        },
        {
          id: "17514",
          name: "Vendome",
          state_id: "1255",
        },
      ],
      Loire: [
        {
          id: "17515",
          name: "Andrezieux-Boutheon",
          state_id: "1256",
        },
        {
          id: "17516",
          name: "Firminy",
          state_id: "1256",
        },
        {
          id: "17517",
          name: "La Ricamarie",
          state_id: "1256",
        },
        {
          id: "17518",
          name: "Le Chambon-Feugerolles",
          state_id: "1256",
        },
        {
          id: "17519",
          name: "Montbrison",
          state_id: "1256",
        },
        {
          id: "17520",
          name: "Riorges",
          state_id: "1256",
        },
        {
          id: "17521",
          name: "Rive-de-Gier",
          state_id: "1256",
        },
        {
          id: "17522",
          name: "Roanne",
          state_id: "1256",
        },
        {
          id: "17523",
          name: "Roche-la-Moliere",
          state_id: "1256",
        },
        {
          id: "17524",
          name: "Saint-Chamond",
          state_id: "1256",
        },
        {
          id: "17525",
          name: "Saint-Etienne",
          state_id: "1256",
        },
        {
          id: "17526",
          name: "Saint-Just-Saint-Rambert",
          state_id: "1256",
        },
      ],
      "Loire-Atlantique": [
        {
          id: "17527",
          name: "Bouguenais",
          state_id: "1257",
        },
        {
          id: "17528",
          name: "Carquefou",
          state_id: "1257",
        },
        {
          id: "17529",
          name: "Chateaubriant",
          state_id: "1257",
        },
        {
          id: "17530",
          name: "Coueron",
          state_id: "1257",
        },
        {
          id: "17531",
          name: "Guerande",
          state_id: "1257",
        },
        {
          id: "17532",
          name: "La Baule-Escoublac",
          state_id: "1257",
        },
        {
          id: "17533",
          name: "La Chapelle-sur-Erdre",
          state_id: "1257",
        },
        {
          id: "17534",
          name: "Nantes",
          state_id: "1257",
        },
        {
          id: "17535",
          name: "Orvault",
          state_id: "1257",
        },
        {
          id: "17536",
          name: "Reze",
          state_id: "1257",
        },
        {
          id: "17537",
          name: "Saint Etienne de Mer Morte",
          state_id: "1257",
        },
        {
          id: "17538",
          name: "Saint-Herblain",
          state_id: "1257",
        },
        {
          id: "17539",
          name: "Saint-Nazaire",
          state_id: "1257",
        },
        {
          id: "17540",
          name: "Saint-Sebastien-sur-Loire",
          state_id: "1257",
        },
        {
          id: "17541",
          name: "Sainte-Luce-sur-Loire",
          state_id: "1257",
        },
        {
          id: "17542",
          name: "Vertou",
          state_id: "1257",
        },
      ],
      Loiret: [
        {
          id: "17543",
          name: "Amilly",
          state_id: "1258",
        },
        {
          id: "17544",
          name: "Chalette-sur-Loing",
          state_id: "1258",
        },
        {
          id: "17545",
          name: "Fleury-les-Aubrais",
          state_id: "1258",
        },
        {
          id: "17546",
          name: "Gien",
          state_id: "1258",
        },
        {
          id: "17547",
          name: "Montargis",
          state_id: "1258",
        },
        {
          id: "17548",
          name: "Olivet",
          state_id: "1258",
        },
        {
          id: "17549",
          name: "Orleans",
          state_id: "1258",
        },
        {
          id: "17550",
          name: "Pithiviers",
          state_id: "1258",
        },
        {
          id: "17551",
          name: "Saint-Jean-de-Braye",
          state_id: "1258",
        },
        {
          id: "17552",
          name: "Saint-Jean-de-la-Ruelle",
          state_id: "1258",
        },
        {
          id: "17553",
          name: "Saran",
          state_id: "1258",
        },
      ],
      Lorraine: [
        {
          id: "17554",
          name: "Montbronn",
          state_id: "1259",
        },
      ],
      Lot: [
        {
          id: "17555",
          name: "Cahors",
          state_id: "1260",
        },
        {
          id: "17556",
          name: "Figeac",
          state_id: "1260",
        },
      ],
      "Lot-et-Garonne": [
        {
          id: "17557",
          name: "Agen",
          state_id: "1261",
        },
        {
          id: "17558",
          name: "Le Passage",
          state_id: "1261",
        },
        {
          id: "17559",
          name: "Marmande",
          state_id: "1261",
        },
        {
          id: "17560",
          name: "Tonneins",
          state_id: "1261",
        },
        {
          id: "17561",
          name: "Villeneuve-sur-Lot",
          state_id: "1261",
        },
      ],
      "Lower Normandy": [],
      Lozere: [
        {
          id: "17562",
          name: "Mende",
          state_id: "1263",
        },
      ],
      "Maine-et-Loire": [
        {
          id: "17563",
          name: "Angers",
          state_id: "1264",
        },
        {
          id: "17564",
          name: "Avrille",
          state_id: "1264",
        },
        {
          id: "17565",
          name: "Cholet",
          state_id: "1264",
        },
        {
          id: "17566",
          name: "Les Ponts-de-Ce",
          state_id: "1264",
        },
        {
          id: "17567",
          name: "Saint-Barthelemy-d''Anjou",
          state_id: "1264",
        },
        {
          id: "17568",
          name: "Saumur",
          state_id: "1264",
        },
        {
          id: "17569",
          name: "Torfou",
          state_id: "1264",
        },
        {
          id: "17570",
          name: "Trelaze",
          state_id: "1264",
        },
      ],
      Manche: [
        {
          id: "17571",
          name: "Cherbourg",
          state_id: "1265",
        },
        {
          id: "17572",
          name: "Coutances",
          state_id: "1265",
        },
        {
          id: "17573",
          name: "Equeurdreville-Hainneville",
          state_id: "1265",
        },
        {
          id: "17574",
          name: "Granville",
          state_id: "1265",
        },
        {
          id: "17575",
          name: "Octeville",
          state_id: "1265",
        },
        {
          id: "17576",
          name: "Saint-Lo",
          state_id: "1265",
        },
        {
          id: "17577",
          name: "Tourlaville",
          state_id: "1265",
        },
      ],
      Marne: [
        {
          id: "17578",
          name: "Chalons-en-Champagne",
          state_id: "1266",
        },
        {
          id: "17579",
          name: "Epernay",
          state_id: "1266",
        },
        {
          id: "17580",
          name: "Reims",
          state_id: "1266",
        },
        {
          id: "17581",
          name: "Tinqueux",
          state_id: "1266",
        },
        {
          id: "17582",
          name: "Vitry-le-Francois",
          state_id: "1266",
        },
      ],
      Mayenne: [
        {
          id: "17583",
          name: "Chateau-Gontier",
          state_id: "1267",
        },
        {
          id: "17584",
          name: "Laval",
          state_id: "1267",
        },
        {
          id: "17585",
          name: "Mayenne",
          state_id: "1267",
        },
        {
          id: "17586",
          name: "Montsurs",
          state_id: "1267",
        },
      ],
      "Meurthe-et-Moselle": [
        {
          id: "17587",
          name: "Dombasle-sur-Meurthe",
          state_id: "1268",
        },
        {
          id: "17588",
          name: "Jarville-la-Malgrange",
          state_id: "1268",
        },
        {
          id: "17589",
          name: "Laxou",
          state_id: "1268",
        },
        {
          id: "17590",
          name: "Longwy",
          state_id: "1268",
        },
        {
          id: "17591",
          name: "Luneville",
          state_id: "1268",
        },
        {
          id: "17592",
          name: "Nancy",
          state_id: "1268",
        },
        {
          id: "17593",
          name: "Pont-a-Mousson",
          state_id: "1268",
        },
        {
          id: "17594",
          name: "Saint-Max",
          state_id: "1268",
        },
        {
          id: "17595",
          name: "Toul",
          state_id: "1268",
        },
        {
          id: "17596",
          name: "Vandoeuvre-les-Nancy",
          state_id: "1268",
        },
        {
          id: "17597",
          name: "Villers-les-Nancy",
          state_id: "1268",
        },
        {
          id: "17598",
          name: "Villerupt",
          state_id: "1268",
        },
      ],
      Meuse: [
        {
          id: "17599",
          name: "Bar-le-Duc",
          state_id: "1269",
        },
        {
          id: "17600",
          name: "Verdun",
          state_id: "1269",
        },
      ],
      "Midi-Pyrenees": [
        {
          id: "17601",
          name: "Boissezon",
          state_id: "1270",
        },
        {
          id: "17602",
          name: "Hauterive",
          state_id: "1270",
        },
        {
          id: "17603",
          name: "Launaguet",
          state_id: "1270",
        },
        {
          id: "17604",
          name: "Mauleon",
          state_id: "1270",
        },
        {
          id: "17605",
          name: "Maurens-Scopont",
          state_id: "1270",
        },
      ],
      Morbihan: [
        {
          id: "17606",
          name: "Auray",
          state_id: "1271",
        },
        {
          id: "17607",
          name: "Guidel",
          state_id: "1271",
        },
        {
          id: "17608",
          name: "Hennebont",
          state_id: "1271",
        },
        {
          id: "17609",
          name: "Lanester",
          state_id: "1271",
        },
        {
          id: "17610",
          name: "Lorient",
          state_id: "1271",
        },
        {
          id: "17611",
          name: "Ploemeur",
          state_id: "1271",
        },
        {
          id: "17612",
          name: "Pontivy",
          state_id: "1271",
        },
        {
          id: "17613",
          name: "Vannes",
          state_id: "1271",
        },
      ],
      Moselle: [
        {
          id: "17614",
          name: "Amneville",
          state_id: "1272",
        },
        {
          id: "17615",
          name: "Behren-les-Forbach",
          state_id: "1272",
        },
        {
          id: "17616",
          name: "Creutzwald",
          state_id: "1272",
        },
        {
          id: "17617",
          name: "Fameck",
          state_id: "1272",
        },
        {
          id: "17618",
          name: "Florange",
          state_id: "1272",
        },
        {
          id: "17619",
          name: "Forbach",
          state_id: "1272",
        },
        {
          id: "17620",
          name: "Freyming-Merlebach",
          state_id: "1272",
        },
        {
          id: "17621",
          name: "Hagondange",
          state_id: "1272",
        },
        {
          id: "17622",
          name: "Hayange",
          state_id: "1272",
        },
        {
          id: "17623",
          name: "Hombourg-Haut",
          state_id: "1272",
        },
        {
          id: "17624",
          name: "Maizieres-les-Metz",
          state_id: "1272",
        },
        {
          id: "17625",
          name: "Marly",
          state_id: "1272",
        },
        {
          id: "17626",
          name: "Metz",
          state_id: "1272",
        },
        {
          id: "17627",
          name: "Montigny-les-Metz",
          state_id: "1272",
        },
        {
          id: "17628",
          name: "Moyeuvre-Grande",
          state_id: "1272",
        },
        {
          id: "17629",
          name: "Rombas",
          state_id: "1272",
        },
        {
          id: "17630",
          name: "Saint-Avold",
          state_id: "1272",
        },
        {
          id: "17631",
          name: "Sarrebourg",
          state_id: "1272",
        },
        {
          id: "17632",
          name: "Sarreguemines",
          state_id: "1272",
        },
        {
          id: "17633",
          name: "Stiring-Wendel",
          state_id: "1272",
        },
        {
          id: "17634",
          name: "Thionville",
          state_id: "1272",
        },
        {
          id: "17635",
          name: "Uckange",
          state_id: "1272",
        },
        {
          id: "17636",
          name: "Woippy",
          state_id: "1272",
        },
        {
          id: "17637",
          name: "Yutz",
          state_id: "1272",
        },
      ],
      Nievre: [
        {
          id: "17638",
          name: "Cosne-Cours-sur-Loire",
          state_id: "1273",
        },
        {
          id: "17639",
          name: "Nevers",
          state_id: "1273",
        },
        {
          id: "17640",
          name: "Varennes-Vauzelles",
          state_id: "1273",
        },
      ],
      Nord: [
        {
          id: "17641",
          name: "Aniche",
          state_id: "1274",
        },
        {
          id: "17642",
          name: "Annoeullin",
          state_id: "1274",
        },
        {
          id: "17643",
          name: "Anzin",
          state_id: "1274",
        },
        {
          id: "17644",
          name: "Armentieres",
          state_id: "1274",
        },
        {
          id: "17645",
          name: "Aulnoye-Aymeries",
          state_id: "1274",
        },
        {
          id: "17646",
          name: "Bailleul",
          state_id: "1274",
        },
        {
          id: "17647",
          name: "Bondues",
          state_id: "1274",
        },
        {
          id: "17648",
          name: "Bruay-sur-l''Escaut",
          state_id: "1274",
        },
        {
          id: "17649",
          name: "Cambrai",
          state_id: "1274",
        },
        {
          id: "17650",
          name: "Cappelle-la-Grande",
          state_id: "1274",
        },
        {
          id: "17651",
          name: "Caudry",
          state_id: "1274",
        },
        {
          id: "17652",
          name: "Comines",
          state_id: "1274",
        },
        {
          id: "17653",
          name: "Conde-sur-l''Escaut",
          state_id: "1274",
        },
        {
          id: "17654",
          name: "Coudekerque-Branche",
          state_id: "1274",
        },
        {
          id: "17655",
          name: "Croix",
          state_id: "1274",
        },
        {
          id: "17656",
          name: "Denain",
          state_id: "1274",
        },
        {
          id: "17657",
          name: "Douai",
          state_id: "1274",
        },
        {
          id: "17658",
          name: "Douchy-les-Mines",
          state_id: "1274",
        },
        {
          id: "17659",
          name: "Dunkerque",
          state_id: "1274",
        },
        {
          id: "17660",
          name: "Escaudain",
          state_id: "1274",
        },
        {
          id: "17661",
          name: "Fache-Thumesnil",
          state_id: "1274",
        },
        {
          id: "17662",
          name: "Fourmies",
          state_id: "1274",
        },
        {
          id: "17663",
          name: "Grande-Synthe",
          state_id: "1274",
        },
        {
          id: "17664",
          name: "Graveline",
          state_id: "1274",
        },
        {
          id: "17665",
          name: "Halluin",
          state_id: "1274",
        },
        {
          id: "17666",
          name: "Haubourdin",
          state_id: "1274",
        },
        {
          id: "17667",
          name: "Hautmont",
          state_id: "1274",
        },
        {
          id: "17668",
          name: "Hazebrouck",
          state_id: "1274",
        },
        {
          id: "17669",
          name: "Hem",
          state_id: "1274",
        },
        {
          id: "17670",
          name: "Hulluch",
          state_id: "1274",
        },
        {
          id: "17671",
          name: "Jeumont",
          state_id: "1274",
        },
        {
          id: "17672",
          name: "La Madeleine",
          state_id: "1274",
        },
        {
          id: "17673",
          name: "Lambersart",
          state_id: "1274",
        },
        {
          id: "17674",
          name: "Leers",
          state_id: "1274",
        },
        {
          id: "17675",
          name: "Lille",
          state_id: "1274",
        },
        {
          id: "17676",
          name: "Lomme",
          state_id: "1274",
        },
        {
          id: "17677",
          name: "Loos",
          state_id: "1274",
        },
        {
          id: "17678",
          name: "Lys-lez-Lannoy",
          state_id: "1274",
        },
        {
          id: "17679",
          name: "Marcq-en-Baroeul",
          state_id: "1274",
        },
        {
          id: "17680",
          name: "Marennes",
          state_id: "1274",
        },
        {
          id: "17681",
          name: "Marly",
          state_id: "1274",
        },
        {
          id: "17682",
          name: "Marquette-lez-Lille",
          state_id: "1274",
        },
        {
          id: "17683",
          name: "Maubeuge",
          state_id: "1274",
        },
        {
          id: "17684",
          name: "Merville",
          state_id: "1274",
        },
        {
          id: "17685",
          name: "Mons-en-Baroeul",
          state_id: "1274",
        },
        {
          id: "17686",
          name: "Mouvaux",
          state_id: "1274",
        },
        {
          id: "17687",
          name: "Neuville-en-Ferrain",
          state_id: "1274",
        },
        {
          id: "17688",
          name: "Onnaing",
          state_id: "1274",
        },
        {
          id: "17689",
          name: "Raismes",
          state_id: "1274",
        },
        {
          id: "17690",
          name: "Ronchin",
          state_id: "1274",
        },
        {
          id: "17691",
          name: "Roncq",
          state_id: "1274",
        },
        {
          id: "17692",
          name: "Roubaix",
          state_id: "1274",
        },
        {
          id: "17693",
          name: "Saint-Amand-les-Eaux",
          state_id: "1274",
        },
        {
          id: "17694",
          name: "Saint-Andre-lez-Lille",
          state_id: "1274",
        },
        {
          id: "17695",
          name: "Saint-Pol-sur-Mer",
          state_id: "1274",
        },
        {
          id: "17696",
          name: "Saint-Saulve",
          state_id: "1274",
        },
        {
          id: "17697",
          name: "Seclin",
          state_id: "1274",
        },
        {
          id: "17698",
          name: "Sin-le-Noble",
          state_id: "1274",
        },
        {
          id: "17699",
          name: "Somain",
          state_id: "1274",
        },
        {
          id: "17700",
          name: "Tourcoing",
          state_id: "1274",
        },
        {
          id: "17701",
          name: "Valenciennes",
          state_id: "1274",
        },
        {
          id: "17702",
          name: "Vieux-Conde",
          state_id: "1274",
        },
        {
          id: "17703",
          name: "Villeneuve-d''Ascq",
          state_id: "1274",
        },
        {
          id: "17704",
          name: "Wasquehal",
          state_id: "1274",
        },
        {
          id: "17705",
          name: "Wattignies",
          state_id: "1274",
        },
        {
          id: "17706",
          name: "Wattrelos",
          state_id: "1274",
        },
        {
          id: "17707",
          name: "Waziers",
          state_id: "1274",
        },
      ],
      "Nord-Pas-de-Calais": [
        {
          id: "17708",
          name: "Esquelbecq",
          state_id: "1275",
        },
      ],
      Oise: [
        {
          id: "17709",
          name: "Beauvais",
          state_id: "1276",
        },
        {
          id: "17710",
          name: "Chantilly",
          state_id: "1276",
        },
        {
          id: "17711",
          name: "Clermont",
          state_id: "1276",
        },
        {
          id: "17712",
          name: "Compiegne",
          state_id: "1276",
        },
        {
          id: "17713",
          name: "Creil",
          state_id: "1276",
        },
        {
          id: "17714",
          name: "Crepy-en-Valois",
          state_id: "1276",
        },
        {
          id: "17715",
          name: "Gouvieux",
          state_id: "1276",
        },
        {
          id: "17716",
          name: "Meru",
          state_id: "1276",
        },
        {
          id: "17717",
          name: "Montataire",
          state_id: "1276",
        },
        {
          id: "17718",
          name: "Nogent-sur-Oise",
          state_id: "1276",
        },
        {
          id: "17719",
          name: "Noyon",
          state_id: "1276",
        },
        {
          id: "17720",
          name: "Pont-Sainte-Maxence",
          state_id: "1276",
        },
        {
          id: "17721",
          name: "Senlis",
          state_id: "1276",
        },
      ],
      Orne: [
        {
          id: "17722",
          name: "Alencon",
          state_id: "1277",
        },
        {
          id: "17723",
          name: "Argentan",
          state_id: "1277",
        },
        {
          id: "17724",
          name: "Flers",
          state_id: "1277",
        },
        {
          id: "17725",
          name: "L''Aigle",
          state_id: "1277",
        },
      ],
      Paris: [
        {
          id: "17726",
          name: "Paris",
          state_id: "1278",
        },
      ],
      "Pas-de-Calais": [
        {
          id: "17727",
          name: "Aire-sur-la-Lys",
          state_id: "1279",
        },
        {
          id: "17728",
          name: "Arras",
          state_id: "1279",
        },
        {
          id: "17729",
          name: "Auchel",
          state_id: "1279",
        },
        {
          id: "17730",
          name: "Avion",
          state_id: "1279",
        },
        {
          id: "17731",
          name: "Berck",
          state_id: "1279",
        },
        {
          id: "17732",
          name: "Bethune",
          state_id: "1279",
        },
        {
          id: "17733",
          name: "Boulogne-sur-Mer",
          state_id: "1279",
        },
        {
          id: "17734",
          name: "Bruay-la-Brussiere",
          state_id: "1279",
        },
        {
          id: "17735",
          name: "Bully-les-Mines",
          state_id: "1279",
        },
        {
          id: "17736",
          name: "Calais",
          state_id: "1279",
        },
        {
          id: "17737",
          name: "Carvin",
          state_id: "1279",
        },
        {
          id: "17738",
          name: "Courrieres",
          state_id: "1279",
        },
        {
          id: "17739",
          name: "Etaples",
          state_id: "1279",
        },
        {
          id: "17740",
          name: "Harnes",
          state_id: "1279",
        },
        {
          id: "17741",
          name: "Henin-Beaumont",
          state_id: "1279",
        },
        {
          id: "17742",
          name: "Le Portel",
          state_id: "1279",
        },
        {
          id: "17743",
          name: "Lens",
          state_id: "1279",
        },
        {
          id: "17744",
          name: "Libercourt",
          state_id: "1279",
        },
        {
          id: "17745",
          name: "Lievin",
          state_id: "1279",
        },
        {
          id: "17746",
          name: "Lillers",
          state_id: "1279",
        },
        {
          id: "17747",
          name: "Longuenesse",
          state_id: "1279",
        },
        {
          id: "17748",
          name: "Marck",
          state_id: "1279",
        },
        {
          id: "17749",
          name: "Mericourt",
          state_id: "1279",
        },
        {
          id: "17750",
          name: "Montigny-en-Gohelle",
          state_id: "1279",
        },
        {
          id: "17751",
          name: "Noeux-les-Mines",
          state_id: "1279",
        },
        {
          id: "17752",
          name: "Oignies",
          state_id: "1279",
        },
        {
          id: "17753",
          name: "Outreau",
          state_id: "1279",
        },
        {
          id: "17754",
          name: "Rouvroy",
          state_id: "1279",
        },
        {
          id: "17755",
          name: "Saint-Martin-Boulogne",
          state_id: "1279",
        },
        {
          id: "17756",
          name: "Saint-Omer",
          state_id: "1279",
        },
        {
          id: "17757",
          name: "Sallaumines",
          state_id: "1279",
        },
        {
          id: "17758",
          name: "Vendin-le-Vieil",
          state_id: "1279",
        },
      ],
      "Pays de la Loire": [],
      "Pays-de-la-Loire": [
        {
          id: "17759",
          name: "Loiron",
          state_id: "1281",
        },
        {
          id: "17760",
          name: "Marolles-les-Braults",
          state_id: "1281",
        },
        {
          id: "17761",
          name: "Mortagne-sur-Sevre",
          state_id: "1281",
        },
        {
          id: "17762",
          name: "Mouzillon",
          state_id: "1281",
        },
        {
          id: "17763",
          name: "Noirmoutier-en-l''ÃƒÂŽle",
          state_id: "1281",
        },
      ],
      Picardy: [
        {
          id: "17764",
          name: "Friville",
          state_id: "1282",
        },
        {
          id: "17765",
          name: "Liancourt",
          state_id: "1282",
        },
        {
          id: "17766",
          name: "Maizy",
          state_id: "1282",
        },
        {
          id: "17767",
          name: "Oust-Marest",
          state_id: "1282",
        },
        {
          id: "17768",
          name: "Puiseux-le-Hauberger",
          state_id: "1282",
        },
        {
          id: "17769",
          name: "Saint-Crepin-Ibouvillers",
          state_id: "1282",
        },
      ],
      "Puy-de-Dome": [
        {
          id: "17770",
          name: "Aubiere",
          state_id: "1283",
        },
        {
          id: "17771",
          name: "Beaumont",
          state_id: "1283",
        },
        {
          id: "17772",
          name: "Chamalieres",
          state_id: "1283",
        },
        {
          id: "17773",
          name: "Clermont-Ferrand",
          state_id: "1283",
        },
        {
          id: "17774",
          name: "Cournon-d''Auvergne",
          state_id: "1283",
        },
        {
          id: "17775",
          name: "Gerzat",
          state_id: "1283",
        },
        {
          id: "17776",
          name: "Issoire",
          state_id: "1283",
        },
        {
          id: "17777",
          name: "Riom",
          state_id: "1283",
        },
        {
          id: "17778",
          name: "Thiers",
          state_id: "1283",
        },
      ],
      "Pyrenees-Atlantiques": [
        {
          id: "17779",
          name: "Anglet",
          state_id: "1284",
        },
        {
          id: "17780",
          name: "Bayonne",
          state_id: "1284",
        },
        {
          id: "17781",
          name: "Biarritz",
          state_id: "1284",
        },
        {
          id: "17782",
          name: "Billere",
          state_id: "1284",
        },
        {
          id: "17783",
          name: "Hendaye",
          state_id: "1284",
        },
        {
          id: "17784",
          name: "Lons",
          state_id: "1284",
        },
        {
          id: "17785",
          name: "Oloron-Sainte-Marie",
          state_id: "1284",
        },
        {
          id: "17786",
          name: "Orthez",
          state_id: "1284",
        },
        {
          id: "17787",
          name: "Pau",
          state_id: "1284",
        },
        {
          id: "17788",
          name: "Saint-Jean-de-Luz",
          state_id: "1284",
        },
      ],
      "Pyrenees-Orientales": [
        {
          id: "17789",
          name: "Perpignan",
          state_id: "1285",
        },
        {
          id: "17790",
          name: "Saint-Esteve",
          state_id: "1285",
        },
      ],
      Quelmes: [
        {
          id: "17791",
          name: "Quelmes",
          state_id: "1286",
        },
      ],
      Rhone: [
        {
          id: "17792",
          name: "Brignais",
          state_id: "1287",
        },
        {
          id: "17793",
          name: "Bron",
          state_id: "1287",
        },
        {
          id: "17794",
          name: "Caluire-et-Cuire",
          state_id: "1287",
        },
        {
          id: "17795",
          name: "Decines-Charpieu",
          state_id: "1287",
        },
        {
          id: "17796",
          name: "Ecully",
          state_id: "1287",
        },
        {
          id: "17797",
          name: "Francheville",
          state_id: "1287",
        },
        {
          id: "17798",
          name: "Genas",
          state_id: "1287",
        },
        {
          id: "17799",
          name: "Genay",
          state_id: "1287",
        },
        {
          id: "17800",
          name: "Givors",
          state_id: "1287",
        },
        {
          id: "17801",
          name: "Lyon",
          state_id: "1287",
        },
        {
          id: "17802",
          name: "Meyzieu",
          state_id: "1287",
        },
        {
          id: "17803",
          name: "Mions",
          state_id: "1287",
        },
        {
          id: "17804",
          name: "Oullins",
          state_id: "1287",
        },
        {
          id: "17805",
          name: "Pierre-Benite",
          state_id: "1287",
        },
        {
          id: "17806",
          name: "Rillieux-la-Pape",
          state_id: "1287",
        },
        {
          id: "17807",
          name: "Saint-Fons",
          state_id: "1287",
        },
        {
          id: "17808",
          name: "Saint-Genis-Laval",
          state_id: "1287",
        },
        {
          id: "17809",
          name: "Saint-Priest",
          state_id: "1287",
        },
        {
          id: "17810",
          name: "Sainte-Foy-les-Lyon",
          state_id: "1287",
        },
        {
          id: "17811",
          name: "Tarare",
          state_id: "1287",
        },
        {
          id: "17812",
          name: "Tassin-la-Demi-Lune",
          state_id: "1287",
        },
        {
          id: "17813",
          name: "Vaulx-en-Velin",
          state_id: "1287",
        },
        {
          id: "17814",
          name: "Venissieux",
          state_id: "1287",
        },
        {
          id: "17815",
          name: "Villefranche-sur-Saone",
          state_id: "1287",
        },
        {
          id: "17816",
          name: "Villeurbanne",
          state_id: "1287",
        },
      ],
      "Rhone-Alpes": [
        {
          id: "17817",
          name: "Beauvoir-en-Royans",
          state_id: "1288",
        },
        {
          id: "17818",
          name: "Belley",
          state_id: "1288",
        },
        {
          id: "17819",
          name: "Bons-en-Chablais",
          state_id: "1288",
        },
        {
          id: "17820",
          name: "Chalain-d''Uzore",
          state_id: "1288",
        },
        {
          id: "17821",
          name: "Chassieu",
          state_id: "1288",
        },
        {
          id: "17822",
          name: "Chavanod",
          state_id: "1288",
        },
        {
          id: "17823",
          name: "Chazay-d-Azergues",
          state_id: "1288",
        },
        {
          id: "17824",
          name: "Chimilin",
          state_id: "1288",
        },
        {
          id: "17825",
          name: "Civrieux-d Azergues",
          state_id: "1288",
        },
        {
          id: "17826",
          name: "Corbas",
          state_id: "1288",
        },
        {
          id: "17827",
          name: "Courzieu",
          state_id: "1288",
        },
        {
          id: "17828",
          name: "Dardilly",
          state_id: "1288",
        },
        {
          id: "17829",
          name: "Guereins",
          state_id: "1288",
        },
        {
          id: "17830",
          name: "Izernore",
          state_id: "1288",
        },
        {
          id: "17831",
          name: "La Talaudiere",
          state_id: "1288",
        },
        {
          id: "17832",
          name: "La Tronche",
          state_id: "1288",
        },
        {
          id: "17833",
          name: "La Verpilliere",
          state_id: "1288",
        },
        {
          id: "17834",
          name: "Le Cheylard",
          state_id: "1288",
        },
        {
          id: "17835",
          name: "Le Cheylas",
          state_id: "1288",
        },
        {
          id: "17836",
          name: "Mery",
          state_id: "1288",
        },
        {
          id: "17837",
          name: "Moirans",
          state_id: "1288",
        },
        {
          id: "17838",
          name: "Montalieu-Vercieu",
          state_id: "1288",
        },
        {
          id: "17839",
          name: "Montmiral",
          state_id: "1288",
        },
        {
          id: "17840",
          name: "Peronnas",
          state_id: "1288",
        },
        {
          id: "17841",
          name: "Poncin",
          state_id: "1288",
        },
        {
          id: "17842",
          name: "Quincie-en-Beaujolais",
          state_id: "1288",
        },
        {
          id: "17843",
          name: "Saint-Quentin-sur-Isere",
          state_id: "1288",
        },
        {
          id: "17844",
          name: "Sainte Agathe la Bouteresse",
          state_id: "1288",
        },
        {
          id: "17845",
          name: "Sainte-Consorce",
          state_id: "1288",
        },
        {
          id: "17846",
          name: "Sisteron",
          state_id: "1288",
        },
        {
          id: "17847",
          name: "Trevoux",
          state_id: "1288",
        },
        {
          id: "17848",
          name: "Villard-Bonnot",
          state_id: "1288",
        },
      ],
      "Saint Ouen": [],
      "Saint Viatre": [],
      "Saone-et-Loire": [
        {
          id: "17849",
          name: "Autun",
          state_id: "1291",
        },
        {
          id: "17850",
          name: "Chalon-sur-Saone",
          state_id: "1291",
        },
        {
          id: "17851",
          name: "Digoin",
          state_id: "1291",
        },
        {
          id: "17852",
          name: "Gueugnon",
          state_id: "1291",
        },
        {
          id: "17853",
          name: "Le Creusot",
          state_id: "1291",
        },
        {
          id: "17854",
          name: "Macon",
          state_id: "1291",
        },
        {
          id: "17855",
          name: "Montceau-les-Mines",
          state_id: "1291",
        },
        {
          id: "17856",
          name: "Paray-le-Monial",
          state_id: "1291",
        },
        {
          id: "17857",
          name: "Saint-Vallier",
          state_id: "1291",
        },
      ],
      Sarthe: [
        {
          id: "17858",
          name: "Allonnes",
          state_id: "1292",
        },
        {
          id: "17859",
          name: "La Ferte-Bernard",
          state_id: "1292",
        },
        {
          id: "17860",
          name: "La Fleche",
          state_id: "1292",
        },
        {
          id: "17861",
          name: "Le Mans",
          state_id: "1292",
        },
        {
          id: "17862",
          name: "Sable-sur-Sarthe",
          state_id: "1292",
        },
      ],
      Savoie: [
        {
          id: "17863",
          name: "Aix-les-Bains",
          state_id: "1293",
        },
        {
          id: "17864",
          name: "Albertville",
          state_id: "1293",
        },
        {
          id: "17865",
          name: "Chambery",
          state_id: "1293",
        },
        {
          id: "17866",
          name: "La Motte-Servolex",
          state_id: "1293",
        },
        {
          id: "17867",
          name: "Saint-Jean-de-Maurienne",
          state_id: "1293",
        },
      ],
      "Seine-Maritime": [
        {
          id: "17868",
          name: "Barentin",
          state_id: "1294",
        },
        {
          id: "17869",
          name: "Bihorel",
          state_id: "1294",
        },
        {
          id: "17870",
          name: "Bois-Guillaume",
          state_id: "1294",
        },
        {
          id: "17871",
          name: "Bolbec",
          state_id: "1294",
        },
        {
          id: "17872",
          name: "Canteleu",
          state_id: "1294",
        },
        {
          id: "17873",
          name: "Caudebec-les-Elbeuf",
          state_id: "1294",
        },
        {
          id: "17874",
          name: "Darnetal",
          state_id: "1294",
        },
        {
          id: "17875",
          name: "Deville-les-Rouen",
          state_id: "1294",
        },
        {
          id: "17876",
          name: "Dieppe",
          state_id: "1294",
        },
        {
          id: "17877",
          name: "Elbeuf",
          state_id: "1294",
        },
        {
          id: "17878",
          name: "Fecamp",
          state_id: "1294",
        },
        {
          id: "17879",
          name: "Gonfreville-l''Orcher",
          state_id: "1294",
        },
        {
          id: "17880",
          name: "Grand-Couronne",
          state_id: "1294",
        },
        {
          id: "17881",
          name: "Harfleur",
          state_id: "1294",
        },
        {
          id: "17882",
          name: "Le Grand-Quevilly",
          state_id: "1294",
        },
        {
          id: "17883",
          name: "Le Havre",
          state_id: "1294",
        },
        {
          id: "17884",
          name: "Le Petit-Quevilly",
          state_id: "1294",
        },
        {
          id: "17885",
          name: "Lillebonne",
          state_id: "1294",
        },
        {
          id: "17886",
          name: "Maromme",
          state_id: "1294",
        },
        {
          id: "17887",
          name: "Mont-Saint-Aignan",
          state_id: "1294",
        },
        {
          id: "17888",
          name: "Montivilliers",
          state_id: "1294",
        },
        {
          id: "17889",
          name: "Notre-Dame-de-Gravenchon",
          state_id: "1294",
        },
        {
          id: "17890",
          name: "Oissel",
          state_id: "1294",
        },
        {
          id: "17891",
          name: "Rouen",
          state_id: "1294",
        },
        {
          id: "17892",
          name: "Saint-Etienne-du-Rouvray",
          state_id: "1294",
        },
        {
          id: "17893",
          name: "Sotteville-les-Rouen",
          state_id: "1294",
        },
        {
          id: "17894",
          name: "Yvetot",
          state_id: "1294",
        },
      ],
      "Seine-Saint-Denis": [
        {
          id: "17895",
          name: "Aubervillers",
          state_id: "1295",
        },
        {
          id: "17896",
          name: "Aulnay-sous-Bois",
          state_id: "1295",
        },
        {
          id: "17897",
          name: "Bagnolet",
          state_id: "1295",
        },
        {
          id: "17898",
          name: "Bobigny",
          state_id: "1295",
        },
        {
          id: "17899",
          name: "Bondy",
          state_id: "1295",
        },
        {
          id: "17900",
          name: "Clichy-sous-Bois",
          state_id: "1295",
        },
        {
          id: "17901",
          name: "Drancy",
          state_id: "1295",
        },
        {
          id: "17902",
          name: "Epinay-sur-Seine",
          state_id: "1295",
        },
        {
          id: "17903",
          name: "Gagny",
          state_id: "1295",
        },
        {
          id: "17904",
          name: "La Courneuve",
          state_id: "1295",
        },
        {
          id: "17905",
          name: "Le Blanc-Mesnil",
          state_id: "1295",
        },
        {
          id: "17906",
          name: "Le Bourget",
          state_id: "1295",
        },
        {
          id: "17907",
          name: "Le Pre-Saint-Gervais",
          state_id: "1295",
        },
        {
          id: "17908",
          name: "Le Raincy",
          state_id: "1295",
        },
        {
          id: "17909",
          name: "Les Lilas",
          state_id: "1295",
        },
        {
          id: "17910",
          name: "Les Pavillons-sous-Bois",
          state_id: "1295",
        },
        {
          id: "17911",
          name: "Livry-Gargan",
          state_id: "1295",
        },
        {
          id: "17912",
          name: "Montfermeil",
          state_id: "1295",
        },
        {
          id: "17913",
          name: "Montreuil",
          state_id: "1295",
        },
        {
          id: "17914",
          name: "Neuilly-Plaisance",
          state_id: "1295",
        },
        {
          id: "17915",
          name: "Neuilly-sur-Marne",
          state_id: "1295",
        },
        {
          id: "17916",
          name: "Noisy-le-Grand",
          state_id: "1295",
        },
        {
          id: "17917",
          name: "Noisy-le-Sec",
          state_id: "1295",
        },
        {
          id: "17918",
          name: "Pantin",
          state_id: "1295",
        },
        {
          id: "17919",
          name: "Pierrefitte-sur-Seine",
          state_id: "1295",
        },
        {
          id: "17920",
          name: "Romainville",
          state_id: "1295",
        },
        {
          id: "17921",
          name: "Rosny-sous-Bois",
          state_id: "1295",
        },
        {
          id: "17922",
          name: "Saint-Denis",
          state_id: "1295",
        },
        {
          id: "17923",
          name: "Saint-Ouen",
          state_id: "1295",
        },
        {
          id: "17924",
          name: "Sevran",
          state_id: "1295",
        },
        {
          id: "17925",
          name: "Stains",
          state_id: "1295",
        },
        {
          id: "17926",
          name: "Tremblay-en-France",
          state_id: "1295",
        },
        {
          id: "17927",
          name: "Villemomble",
          state_id: "1295",
        },
        {
          id: "17928",
          name: "Villepinte",
          state_id: "1295",
        },
        {
          id: "17929",
          name: "Villetaneuse",
          state_id: "1295",
        },
      ],
      "Seine-et-Marne": [
        {
          id: "17930",
          name: "Avon",
          state_id: "1296",
        },
        {
          id: "17931",
          name: "Brie-Comte-Robert",
          state_id: "1296",
        },
        {
          id: "17932",
          name: "Champs-sur-Marne",
          state_id: "1296",
        },
        {
          id: "17933",
          name: "Chelles",
          state_id: "1296",
        },
        {
          id: "17934",
          name: "Claye-Souilly",
          state_id: "1296",
        },
        {
          id: "17935",
          name: "Combs-la-Ville",
          state_id: "1296",
        },
        {
          id: "17936",
          name: "Coulommiers",
          state_id: "1296",
        },
        {
          id: "17937",
          name: "Dammarie-les-Lys",
          state_id: "1296",
        },
        {
          id: "17938",
          name: "Fontainebleau",
          state_id: "1296",
        },
        {
          id: "17939",
          name: "Lagny-sur-Marne",
          state_id: "1296",
        },
        {
          id: "17940",
          name: "Le Mee-sur-Seine",
          state_id: "1296",
        },
        {
          id: "17941",
          name: "Lognes",
          state_id: "1296",
        },
        {
          id: "17942",
          name: "Meaux",
          state_id: "1296",
        },
        {
          id: "17943",
          name: "Melun",
          state_id: "1296",
        },
        {
          id: "17944",
          name: "Mitry-Mory",
          state_id: "1296",
        },
        {
          id: "17945",
          name: "Moissy-Cramayel",
          state_id: "1296",
        },
        {
          id: "17946",
          name: "Montereau-Fault-Yonne",
          state_id: "1296",
        },
        {
          id: "17947",
          name: "Nemours",
          state_id: "1296",
        },
        {
          id: "17948",
          name: "Noisiel",
          state_id: "1296",
        },
        {
          id: "17949",
          name: "Ozoir-la-Ferriere",
          state_id: "1296",
        },
        {
          id: "17950",
          name: "Pontault-Combault",
          state_id: "1296",
        },
        {
          id: "17951",
          name: "Provins",
          state_id: "1296",
        },
        {
          id: "17952",
          name: "Roissy-en-Brie",
          state_id: "1296",
        },
        {
          id: "17953",
          name: "Saint-Fargeau-Ponthierry",
          state_id: "1296",
        },
        {
          id: "17954",
          name: "Savigny-le-Temple",
          state_id: "1296",
        },
        {
          id: "17955",
          name: "Torcy",
          state_id: "1296",
        },
        {
          id: "17956",
          name: "Vaires-sur-Marne",
          state_id: "1296",
        },
        {
          id: "17957",
          name: "Veneux",
          state_id: "1296",
        },
        {
          id: "17958",
          name: "Villeparisis",
          state_id: "1296",
        },
      ],
      Somme: [
        {
          id: "17959",
          name: "Abbeville",
          state_id: "1297",
        },
        {
          id: "17960",
          name: "Albert",
          state_id: "1297",
        },
        {
          id: "17961",
          name: "Amiens",
          state_id: "1297",
        },
      ],
      "Sophia Antipolis": [],
      Souvans: [
        {
          id: "17962",
          name: "Souvans",
          state_id: "1299",
        },
      ],
      Tarn: [
        {
          id: "17963",
          name: "Albi",
          state_id: "1300",
        },
        {
          id: "17964",
          name: "Carmaux",
          state_id: "1300",
        },
        {
          id: "17965",
          name: "Castres",
          state_id: "1300",
        },
        {
          id: "17966",
          name: "Gaillac",
          state_id: "1300",
        },
        {
          id: "17967",
          name: "Graulhet",
          state_id: "1300",
        },
        {
          id: "17968",
          name: "Mazamet",
          state_id: "1300",
        },
      ],
      "Tarn-et-Garonne": [
        {
          id: "17969",
          name: "Castelsarassin",
          state_id: "1301",
        },
        {
          id: "17970",
          name: "Moissac",
          state_id: "1301",
        },
        {
          id: "17971",
          name: "Montauban",
          state_id: "1301",
        },
      ],
      "Territoire de Belfort": [],
      Treignac: [
        {
          id: "17972",
          name: "Chamberet",
          state_id: "1303",
        },
      ],
      "Upper Normandy": [],
      "Val-d''Oise": [
        {
          id: "17973",
          name: "Argenteuil",
          state_id: "1305",
        },
        {
          id: "17974",
          name: "Arnouville-les-Gonesse",
          state_id: "1305",
        },
        {
          id: "17975",
          name: "Beauchamps",
          state_id: "1305",
        },
        {
          id: "17976",
          name: "Bezons",
          state_id: "1305",
        },
        {
          id: "17977",
          name: "Cergy",
          state_id: "1305",
        },
        {
          id: "17978",
          name: "Cormeilles-en-Parisis",
          state_id: "1305",
        },
        {
          id: "17979",
          name: "Deuil-la-Barre",
          state_id: "1305",
        },
        {
          id: "17980",
          name: "Domont",
          state_id: "1305",
        },
        {
          id: "17981",
          name: "Eaubonne",
          state_id: "1305",
        },
        {
          id: "17982",
          name: "Enghien-les-Bains",
          state_id: "1305",
        },
        {
          id: "17983",
          name: "Eragny",
          state_id: "1305",
        },
        {
          id: "17984",
          name: "Ermont",
          state_id: "1305",
        },
        {
          id: "17985",
          name: "Ezanville",
          state_id: "1305",
        },
        {
          id: "17986",
          name: "Fosses",
          state_id: "1305",
        },
        {
          id: "17987",
          name: "Franconville",
          state_id: "1305",
        },
        {
          id: "17988",
          name: "Garges-les-Gonesse",
          state_id: "1305",
        },
        {
          id: "17989",
          name: "Gonesse",
          state_id: "1305",
        },
        {
          id: "17990",
          name: "Goussainville",
          state_id: "1305",
        },
        {
          id: "17991",
          name: "Herblay",
          state_id: "1305",
        },
        {
          id: "17992",
          name: "Jouy-le-Moutier",
          state_id: "1305",
        },
        {
          id: "17993",
          name: "L''Isle-Adam",
          state_id: "1305",
        },
        {
          id: "17994",
          name: "Montigny-les-Cormeilles",
          state_id: "1305",
        },
        {
          id: "17995",
          name: "Montmagny",
          state_id: "1305",
        },
        {
          id: "17996",
          name: "Montmorency",
          state_id: "1305",
        },
        {
          id: "17997",
          name: "Osny",
          state_id: "1305",
        },
        {
          id: "17998",
          name: "Persan",
          state_id: "1305",
        },
        {
          id: "17999",
          name: "Pontoise",
          state_id: "1305",
        },
        {
          id: "18000",
          name: "Saint-Brice-sous-Foret",
          state_id: "1305",
        },
        {
          id: "18001",
          name: "Saint-Gratien",
          state_id: "1305",
        },
        {
          id: "18002",
          name: "Saint-Leu-la-Foret",
          state_id: "1305",
        },
        {
          id: "18003",
          name: "Saint-Ouen-l''Aumone",
          state_id: "1305",
        },
        {
          id: "18004",
          name: "Sannois",
          state_id: "1305",
        },
        {
          id: "18005",
          name: "Sarcelles",
          state_id: "1305",
        },
        {
          id: "18006",
          name: "Soisy-sous-Montmorency",
          state_id: "1305",
        },
        {
          id: "18007",
          name: "Taverny",
          state_id: "1305",
        },
        {
          id: "18008",
          name: "Vaureal",
          state_id: "1305",
        },
        {
          id: "18009",
          name: "Villiers-le-Bel",
          state_id: "1305",
        },
      ],
      "Val-de-Marne": [
        {
          id: "18010",
          name: "Alfortville",
          state_id: "1306",
        },
        {
          id: "18011",
          name: "Arcueil",
          state_id: "1306",
        },
        {
          id: "18012",
          name: "Boissy-Saint-Leger",
          state_id: "1306",
        },
        {
          id: "18013",
          name: "Bonneuil",
          state_id: "1306",
        },
        {
          id: "18014",
          name: "Bry-sur-Marne",
          state_id: "1306",
        },
        {
          id: "18015",
          name: "Cachan",
          state_id: "1306",
        },
        {
          id: "18016",
          name: "Champigny-sur-Marne",
          state_id: "1306",
        },
        {
          id: "18017",
          name: "Charenton-le-Pont",
          state_id: "1306",
        },
        {
          id: "18018",
          name: "Chennevieres-sur-Marne",
          state_id: "1306",
        },
        {
          id: "18019",
          name: "Chevilly-Larue",
          state_id: "1306",
        },
        {
          id: "18020",
          name: "Choisy-le-Roi",
          state_id: "1306",
        },
        {
          id: "18021",
          name: "Creteil",
          state_id: "1306",
        },
        {
          id: "18022",
          name: "Fontenay-sous-Bois",
          state_id: "1306",
        },
        {
          id: "18023",
          name: "Fresnes",
          state_id: "1306",
        },
        {
          id: "18024",
          name: "Gentilly",
          state_id: "1306",
        },
        {
          id: "18025",
          name: "Ivry-sur-Seine",
          state_id: "1306",
        },
        {
          id: "18026",
          name: "Joinville-le-Pont",
          state_id: "1306",
        },
        {
          id: "18027",
          name: "L''Hay-les-Roses",
          state_id: "1306",
        },
        {
          id: "18028",
          name: "La Queue-en-Brie",
          state_id: "1306",
        },
        {
          id: "18029",
          name: "Le Kremlin-Bicetre",
          state_id: "1306",
        },
        {
          id: "18030",
          name: "Le Perreux-sur-Marne",
          state_id: "1306",
        },
        {
          id: "18031",
          name: "Le Plessis-Trevise",
          state_id: "1306",
        },
        {
          id: "18032",
          name: "Limeil-Brevannes",
          state_id: "1306",
        },
        {
          id: "18033",
          name: "Maisons-Alfort",
          state_id: "1306",
        },
        {
          id: "18034",
          name: "Nogent-sur-Marne",
          state_id: "1306",
        },
        {
          id: "18035",
          name: "Orly",
          state_id: "1306",
        },
        {
          id: "18036",
          name: "Ormesson-sur-Marne",
          state_id: "1306",
        },
        {
          id: "18037",
          name: "Saint-Mande",
          state_id: "1306",
        },
        {
          id: "18038",
          name: "Saint-Maur-des-Fosses",
          state_id: "1306",
        },
        {
          id: "18039",
          name: "Saint-Maurice",
          state_id: "1306",
        },
        {
          id: "18040",
          name: "Sucy-en-Brie",
          state_id: "1306",
        },
        {
          id: "18041",
          name: "Thiais",
          state_id: "1306",
        },
        {
          id: "18042",
          name: "Valenton",
          state_id: "1306",
        },
        {
          id: "18043",
          name: "Villejuif",
          state_id: "1306",
        },
        {
          id: "18044",
          name: "Villeneuve-Saint-Georges",
          state_id: "1306",
        },
        {
          id: "18045",
          name: "Villeneuve-le-Roi",
          state_id: "1306",
        },
        {
          id: "18046",
          name: "Villiers-sur-Marne",
          state_id: "1306",
        },
        {
          id: "18047",
          name: "Vincennes",
          state_id: "1306",
        },
        {
          id: "18048",
          name: "Vitry-sur-Seine",
          state_id: "1306",
        },
      ],
      Var: [
        {
          id: "18049",
          name: "Brignoles",
          state_id: "1307",
        },
        {
          id: "18050",
          name: "Draguignan",
          state_id: "1307",
        },
        {
          id: "18051",
          name: "Frejus",
          state_id: "1307",
        },
        {
          id: "18052",
          name: "Hyeres",
          state_id: "1307",
        },
        {
          id: "18053",
          name: "La Crau",
          state_id: "1307",
        },
        {
          id: "18054",
          name: "La Garde",
          state_id: "1307",
        },
        {
          id: "18055",
          name: "La Seyne-sur-Mer",
          state_id: "1307",
        },
        {
          id: "18056",
          name: "La Valette-du-Var",
          state_id: "1307",
        },
        {
          id: "18057",
          name: "Le Pradet",
          state_id: "1307",
        },
        {
          id: "18058",
          name: "Ollioules",
          state_id: "1307",
        },
        {
          id: "18059",
          name: "Roquebrune-sur-Argens",
          state_id: "1307",
        },
        {
          id: "18060",
          name: "Saint-Maximin-la-Sainte-Baume",
          state_id: "1307",
        },
        {
          id: "18061",
          name: "Saint-Raphael",
          state_id: "1307",
        },
        {
          id: "18062",
          name: "Sainte-Maxime",
          state_id: "1307",
        },
        {
          id: "18063",
          name: "Sanary-sur-Mer",
          state_id: "1307",
        },
        {
          id: "18064",
          name: "Six-Fours-les-Plages",
          state_id: "1307",
        },
        {
          id: "18065",
          name: "Sollies-Pont",
          state_id: "1307",
        },
        {
          id: "18066",
          name: "Toulon",
          state_id: "1307",
        },
      ],
      Vaucluse: [
        {
          id: "18067",
          name: "Apt",
          state_id: "1308",
        },
        {
          id: "18068",
          name: "Avignon",
          state_id: "1308",
        },
        {
          id: "18069",
          name: "Bollene",
          state_id: "1308",
        },
        {
          id: "18070",
          name: "Carpentras",
          state_id: "1308",
        },
        {
          id: "18071",
          name: "Cavaillon",
          state_id: "1308",
        },
        {
          id: "18072",
          name: "L''Isle-sur-la-Sorgue",
          state_id: "1308",
        },
        {
          id: "18073",
          name: "Le Pontet",
          state_id: "1308",
        },
        {
          id: "18074",
          name: "Orange",
          state_id: "1308",
        },
        {
          id: "18075",
          name: "Pertuis",
          state_id: "1308",
        },
        {
          id: "18076",
          name: "Sorgues",
          state_id: "1308",
        },
        {
          id: "18077",
          name: "Valreas",
          state_id: "1308",
        },
      ],
      Vellise: [
        {
          id: "18078",
          name: "Vellise",
          state_id: "1309",
        },
      ],
      Vendee: [
        {
          id: "18079",
          name: "Challans",
          state_id: "1310",
        },
        {
          id: "18080",
          name: "Chateau-d''Olonne",
          state_id: "1310",
        },
        {
          id: "18081",
          name: "Fontenay-le-Comte",
          state_id: "1310",
        },
        {
          id: "18082",
          name: "La Chasnis",
          state_id: "1310",
        },
        {
          id: "18083",
          name: "La Roche-sur-Yon",
          state_id: "1310",
        },
        {
          id: "18084",
          name: "Les Herbiers",
          state_id: "1310",
        },
        {
          id: "18085",
          name: "Les Sables-d''Olonne",
          state_id: "1310",
        },
        {
          id: "18086",
          name: "Longeville-sur-Mer",
          state_id: "1310",
        },
      ],
      Vienne: [
        {
          id: "18087",
          name: "Chatellerault",
          state_id: "1311",
        },
        {
          id: "18088",
          name: "Poitiers",
          state_id: "1311",
        },
      ],
      Vosges: [
        {
          id: "18089",
          name: "Epinal",
          state_id: "1312",
        },
        {
          id: "18090",
          name: "Gerardmer",
          state_id: "1312",
        },
        {
          id: "18091",
          name: "Remiremont",
          state_id: "1312",
        },
        {
          id: "18092",
          name: "Saint-Die",
          state_id: "1312",
        },
      ],
      Yonne: [
        {
          id: "18093",
          name: "Auxerre",
          state_id: "1313",
        },
        {
          id: "18094",
          name: "Avallon",
          state_id: "1313",
        },
        {
          id: "18095",
          name: "Joigny",
          state_id: "1313",
        },
        {
          id: "18096",
          name: "Sens",
          state_id: "1313",
        },
      ],
      Yvelines: [
        {
          id: "18097",
          name: "Acheres",
          state_id: "1314",
        },
        {
          id: "18098",
          name: "Andresy",
          state_id: "1314",
        },
        {
          id: "18099",
          name: "Aubergenville",
          state_id: "1314",
        },
        {
          id: "18100",
          name: "Bois-d''Arcy",
          state_id: "1314",
        },
        {
          id: "18101",
          name: "Carrieres-sous-Poissy",
          state_id: "1314",
        },
        {
          id: "18102",
          name: "Carrieres-sur-Seine",
          state_id: "1314",
        },
        {
          id: "18103",
          name: "Chanteloup-les-Vignes",
          state_id: "1314",
        },
        {
          id: "18104",
          name: "Chatou",
          state_id: "1314",
        },
        {
          id: "18105",
          name: "Conflans-Sainte-Honorine",
          state_id: "1314",
        },
        {
          id: "18106",
          name: "Croissy-sur-Seine",
          state_id: "1314",
        },
        {
          id: "18107",
          name: "Elancourt",
          state_id: "1314",
        },
        {
          id: "18108",
          name: "Fontenay-le-Fleury",
          state_id: "1314",
        },
        {
          id: "18109",
          name: "Guyancourt",
          state_id: "1314",
        },
        {
          id: "18110",
          name: "Houilles",
          state_id: "1314",
        },
        {
          id: "18111",
          name: "La Celle-Saint-Cloud",
          state_id: "1314",
        },
        {
          id: "18112",
          name: "Le Chesnay",
          state_id: "1314",
        },
        {
          id: "18113",
          name: "Le Pecq",
          state_id: "1314",
        },
        {
          id: "18114",
          name: "Le Vesinet",
          state_id: "1314",
        },
        {
          id: "18115",
          name: "Les Clayes-sous-Bois",
          state_id: "1314",
        },
        {
          id: "18116",
          name: "Les Mureaux",
          state_id: "1314",
        },
        {
          id: "18117",
          name: "Limay",
          state_id: "1314",
        },
        {
          id: "18118",
          name: "Maisons-Laffitte",
          state_id: "1314",
        },
        {
          id: "18119",
          name: "Mantes-la-Jolie",
          state_id: "1314",
        },
        {
          id: "18120",
          name: "Mantes-la-Ville",
          state_id: "1314",
        },
        {
          id: "18121",
          name: "Marly-le-Roi",
          state_id: "1314",
        },
        {
          id: "18122",
          name: "Maurepas",
          state_id: "1314",
        },
        {
          id: "18123",
          name: "Montesson",
          state_id: "1314",
        },
        {
          id: "18124",
          name: "Montigny-le-Bretonneux",
          state_id: "1314",
        },
        {
          id: "18125",
          name: "Plaisir",
          state_id: "1314",
        },
        {
          id: "18126",
          name: "Poissy",
          state_id: "1314",
        },
        {
          id: "18127",
          name: "Rambouillet",
          state_id: "1314",
        },
        {
          id: "18128",
          name: "Saint-Cyr-l''Ecole",
          state_id: "1314",
        },
        {
          id: "18129",
          name: "Saint-Germain-en-Laye",
          state_id: "1314",
        },
        {
          id: "18130",
          name: "Sartrouville",
          state_id: "1314",
        },
        {
          id: "18131",
          name: "Trappes",
          state_id: "1314",
        },
        {
          id: "18132",
          name: "Triel-sur-Seine",
          state_id: "1314",
        },
        {
          id: "18133",
          name: "Velizy-Villacoublay",
          state_id: "1314",
        },
        {
          id: "18134",
          name: "Verneuil-sur-Seine",
          state_id: "1314",
        },
        {
          id: "18135",
          name: "Versailles",
          state_id: "1314",
        },
        {
          id: "18136",
          name: "Viroflay",
          state_id: "1314",
        },
        {
          id: "18137",
          name: "Voisins-le-Bretonneux",
          state_id: "1314",
        },
      ],
    },
  },
  GA: {
    name: "Gabon",
    native: "Gabon",
    phone: "241",
    continent: "AF",
    capital: "Libreville",
    currency: "XAF",
    languages: ["fr"],
    emoji: "🇬🇦",
    emojiU: "U+1F1EC U+1F1E6",
    states: {
      Estuaire: [
        {
          id: "18215",
          name: "Cocobeach",
          state_id: "1325",
        },
        {
          id: "18216",
          name: "Kango",
          state_id: "1325",
        },
        {
          id: "18217",
          name: "Libreville",
          state_id: "1325",
        },
        {
          id: "18218",
          name: "Nkan",
          state_id: "1325",
        },
        {
          id: "18219",
          name: "Ntoum",
          state_id: "1325",
        },
      ],
      "Haut-Ogooue": [
        {
          id: "18220",
          name: "Lekoni",
          state_id: "1326",
        },
        {
          id: "18221",
          name: "Masuku",
          state_id: "1326",
        },
        {
          id: "18222",
          name: "Moanda",
          state_id: "1326",
        },
        {
          id: "18223",
          name: "Mounana",
          state_id: "1326",
        },
        {
          id: "18224",
          name: "Okandja",
          state_id: "1326",
        },
      ],
      "Moyen-Ogooue": [
        {
          id: "18225",
          name: "Lambarene",
          state_id: "1327",
        },
        {
          id: "18226",
          name: "Ndjole",
          state_id: "1327",
        },
      ],
      Ngounie: [
        {
          id: "18227",
          name: "Fougamou",
          state_id: "1328",
        },
        {
          id: "18228",
          name: "Mbigou",
          state_id: "1328",
        },
        {
          id: "18229",
          name: "Mimongo",
          state_id: "1328",
        },
        {
          id: "18230",
          name: "Mouila",
          state_id: "1328",
        },
        {
          id: "18231",
          name: "Ndende",
          state_id: "1328",
        },
      ],
      Nyanga: [
        {
          id: "18232",
          name: "Mayumba",
          state_id: "1329",
        },
        {
          id: "18233",
          name: "Tchibanga",
          state_id: "1329",
        },
        {
          id: "18234",
          name: "Tsogni",
          state_id: "1329",
        },
      ],
      "Ogooue-Ivindo": [
        {
          id: "18235",
          name: "Booue",
          state_id: "1330",
        },
        {
          id: "18236",
          name: "Makokou",
          state_id: "1330",
        },
        {
          id: "18237",
          name: "Mekambo",
          state_id: "1330",
        },
      ],
      "Ogooue-Lolo": [
        {
          id: "18238",
          name: "Koulamoutou",
          state_id: "1331",
        },
        {
          id: "18239",
          name: "Lastoursville",
          state_id: "1331",
        },
      ],
      "Ogooue-Maritime": [
        {
          id: "18240",
          name: "Gamba",
          state_id: "1332",
        },
        {
          id: "18241",
          name: "Omboue",
          state_id: "1332",
        },
        {
          id: "18242",
          name: "Port-Gentil",
          state_id: "1332",
        },
        {
          id: "18243",
          name: "Sette Cama",
          state_id: "1332",
        },
      ],
      "Woleu-Ntem": [
        {
          id: "18244",
          name: "Bitam",
          state_id: "1333",
        },
        {
          id: "18245",
          name: "Lalara",
          state_id: "1333",
        },
        {
          id: "18246",
          name: "Medouneu",
          state_id: "1333",
        },
        {
          id: "18247",
          name: "Minvoul",
          state_id: "1333",
        },
        {
          id: "18248",
          name: "Mitzic",
          state_id: "1333",
        },
        {
          id: "18249",
          name: "Oyem",
          state_id: "1333",
        },
      ],
    },
  },
  GB: {
    name: "United Kingdom",
    native: "United Kingdom",
    phone: "44",
    continent: "EU",
    capital: "London",
    currency: "GBP",
    languages: ["en"],
    emoji: "🇬🇧",
    emojiU: "U+1F1EC U+1F1E7",
    states: {
      Aberdeen: [
        {
          id: "41396",
          name: "Cleveland",
          state_id: "3805",
        },
        {
          id: "41397",
          name: "Gilberdyke",
          state_id: "3805",
        },
        {
          id: "41398",
          name: "Llanrwst",
          state_id: "3805",
        },
        {
          id: "41399",
          name: "Swadlincote",
          state_id: "3805",
        },
        {
          id: "41400",
          name: "Turriff",
          state_id: "3805",
        },
      ],
      Aberdeenshire: [
        {
          id: "41401",
          name: "Westhill",
          state_id: "3806",
        },
      ],
      Argyll: [
        {
          id: "41402",
          name: "Oban",
          state_id: "3807",
        },
      ],
      Armagh: [
        {
          id: "41403",
          name: "Craigavon",
          state_id: "3808",
        },
      ],
      Bedfordshire: [
        {
          id: "41404",
          name: "Barton-le-Clay",
          state_id: "3809",
        },
        {
          id: "41405",
          name: "Bedford",
          state_id: "3809",
        },
        {
          id: "41406",
          name: "Biggleswade",
          state_id: "3809",
        },
        {
          id: "41407",
          name: "Caddington",
          state_id: "3809",
        },
        {
          id: "41408",
          name: "Flitton",
          state_id: "3809",
        },
        {
          id: "41409",
          name: "Flitwick",
          state_id: "3809",
        },
        {
          id: "41410",
          name: "Leighton Buzzard",
          state_id: "3809",
        },
        {
          id: "41411",
          name: "Marston Moretaine",
          state_id: "3809",
        },
        {
          id: "41412",
          name: "Sandy",
          state_id: "3809",
        },
        {
          id: "41413",
          name: "Westoning",
          state_id: "3809",
        },
      ],
      Belfast: [
        {
          id: "41414",
          name: "Dundonald",
          state_id: "3810",
        },
        {
          id: "41415",
          name: "Holywood",
          state_id: "3810",
        },
      ],
      Berkshire: [
        {
          id: "41416",
          name: "Berkshire",
          state_id: "3811",
        },
        {
          id: "41417",
          name: "Bracknell",
          state_id: "3811",
        },
        {
          id: "41418",
          name: "Littlewick Green",
          state_id: "3811",
        },
        {
          id: "41419",
          name: "Maidenhead",
          state_id: "3811",
        },
        {
          id: "41420",
          name: "Newbury",
          state_id: "3811",
        },
        {
          id: "41421",
          name: "Reading",
          state_id: "3811",
        },
        {
          id: "41422",
          name: "Sandhurst",
          state_id: "3811",
        },
        {
          id: "41423",
          name: "Slough",
          state_id: "3811",
        },
        {
          id: "41424",
          name: "Sunninghill",
          state_id: "3811",
        },
        {
          id: "41425",
          name: "Twyford",
          state_id: "3811",
        },
        {
          id: "41426",
          name: "Windsor",
          state_id: "3811",
        },
        {
          id: "41427",
          name: "Wokingham",
          state_id: "3811",
        },
        {
          id: "41428",
          name: "Woodley",
          state_id: "3811",
        },
      ],
      Birmingham: [
        {
          id: "41429",
          name: "Coleshill",
          state_id: "3812",
        },
        {
          id: "41430",
          name: "Edgbaston",
          state_id: "3812",
        },
        {
          id: "41431",
          name: "Hockley",
          state_id: "3812",
        },
        {
          id: "41432",
          name: "Ladywood",
          state_id: "3812",
        },
        {
          id: "41433",
          name: "Nechells",
          state_id: "3812",
        },
        {
          id: "41434",
          name: "Rubery",
          state_id: "3812",
        },
        {
          id: "41435",
          name: "Small Heath",
          state_id: "3812",
        },
      ],
      Brechin: [
        {
          id: "41436",
          name: "Angus",
          state_id: "3813",
        },
      ],
      Bridgnorth: [
        {
          id: "41437",
          name: "Bridgnorth",
          state_id: "3814",
        },
      ],
      Bristol: [
        {
          id: "41438",
          name: "Avon",
          state_id: "3815",
        },
        {
          id: "41439",
          name: "Fishponds",
          state_id: "3815",
        },
        {
          id: "41440",
          name: "Henleaze",
          state_id: "3815",
        },
        {
          id: "41441",
          name: "Thornbury",
          state_id: "3815",
        },
        {
          id: "41442",
          name: "Warmley",
          state_id: "3815",
        },
      ],
      Buckinghamshire: [
        {
          id: "41443",
          name: "Amersham",
          state_id: "3816",
        },
        {
          id: "41444",
          name: "Aston Clinton",
          state_id: "3816",
        },
        {
          id: "41445",
          name: "Beaconsfield",
          state_id: "3816",
        },
        {
          id: "41446",
          name: "Bletchley",
          state_id: "3816",
        },
        {
          id: "41447",
          name: "Bourne End",
          state_id: "3816",
        },
        {
          id: "41448",
          name: "Buckingham",
          state_id: "3816",
        },
        {
          id: "41449",
          name: "High Wycombe",
          state_id: "3816",
        },
        {
          id: "41450",
          name: "Iver",
          state_id: "3816",
        },
        {
          id: "41451",
          name: "Marlow",
          state_id: "3816",
        },
        {
          id: "41452",
          name: "Milton Keynes",
          state_id: "3816",
        },
        {
          id: "41453",
          name: "Newport Pagnell",
          state_id: "3816",
        },
        {
          id: "41454",
          name: "Piddington",
          state_id: "3816",
        },
        {
          id: "41455",
          name: "Princes Risborough",
          state_id: "3816",
        },
        {
          id: "41456",
          name: "Rowsham",
          state_id: "3816",
        },
      ],
      Cambridge: [
        {
          id: "41457",
          name: "Cambridge",
          state_id: "3817",
        },
        {
          id: "41458",
          name: "Ely",
          state_id: "3817",
        },
        {
          id: "41459",
          name: "Huntingdon",
          state_id: "3817",
        },
        {
          id: "41460",
          name: "Peterborough",
          state_id: "3817",
        },
      ],
      Cambridgeshire: [
        {
          id: "41461",
          name: "Cambridge",
          state_id: "3818",
        },
        {
          id: "41462",
          name: "Haddenham",
          state_id: "3818",
        },
        {
          id: "41463",
          name: "Sawtry",
          state_id: "3818",
        },
        {
          id: "41464",
          name: "Wisbech",
          state_id: "3818",
        },
      ],
      "Channel Islands": [],
      Cheshire: [
        {
          id: "41465",
          name: "Alderley Edge",
          state_id: "3820",
        },
        {
          id: "41466",
          name: "Altrincham",
          state_id: "3820",
        },
        {
          id: "41467",
          name: "Betley",
          state_id: "3820",
        },
        {
          id: "41468",
          name: "Cheadle Gatley",
          state_id: "3820",
        },
        {
          id: "41469",
          name: "Cheadle Hulme",
          state_id: "3820",
        },
        {
          id: "41470",
          name: "Crewe",
          state_id: "3820",
        },
        {
          id: "41471",
          name: "Dukinfield",
          state_id: "3820",
        },
        {
          id: "41472",
          name: "Holmes Chapel",
          state_id: "3820",
        },
        {
          id: "41473",
          name: "Hyde",
          state_id: "3820",
        },
        {
          id: "41474",
          name: "Knuntsford",
          state_id: "3820",
        },
        {
          id: "41475",
          name: "Knutsford",
          state_id: "3820",
        },
        {
          id: "41476",
          name: "Lymm",
          state_id: "3820",
        },
        {
          id: "41477",
          name: "Malpas",
          state_id: "3820",
        },
        {
          id: "41478",
          name: "Merseyside",
          state_id: "3820",
        },
        {
          id: "41479",
          name: "Middlewich",
          state_id: "3820",
        },
        {
          id: "41480",
          name: "Mobberley",
          state_id: "3820",
        },
        {
          id: "41481",
          name: "Nantwich",
          state_id: "3820",
        },
        {
          id: "41482",
          name: "Saltney",
          state_id: "3820",
        },
        {
          id: "41483",
          name: "Sandbach",
          state_id: "3820",
        },
        {
          id: "41484",
          name: "Stalybridge",
          state_id: "3820",
        },
        {
          id: "41485",
          name: "Stockport",
          state_id: "3820",
        },
        {
          id: "41486",
          name: "Tarporley",
          state_id: "3820",
        },
        {
          id: "41487",
          name: "Timperley",
          state_id: "3820",
        },
        {
          id: "41488",
          name: "Widnes",
          state_id: "3820",
        },
        {
          id: "41489",
          name: "Winsford",
          state_id: "3820",
        },
      ],
      Cleveland: [
        {
          id: "41490",
          name: "Redcar",
          state_id: "3821",
        },
        {
          id: "41491",
          name: "Stockton-on-Tees",
          state_id: "3821",
        },
      ],
      "Co Fermanagh": [],
      Conwy: [
        {
          id: "41492",
          name: "Conwy",
          state_id: "3823",
        },
        {
          id: "41493",
          name: "Llandudno",
          state_id: "3823",
        },
      ],
      Cornwall: [
        {
          id: "41494",
          name: "Bude",
          state_id: "3824",
        },
        {
          id: "41495",
          name: "Camborne",
          state_id: "3824",
        },
        {
          id: "41496",
          name: "Fowey",
          state_id: "3824",
        },
        {
          id: "41497",
          name: "Hayle",
          state_id: "3824",
        },
        {
          id: "41498",
          name: "Helston",
          state_id: "3824",
        },
        {
          id: "41499",
          name: "Launceston",
          state_id: "3824",
        },
        {
          id: "41500",
          name: "Liskeard",
          state_id: "3824",
        },
        {
          id: "41501",
          name: "Looe",
          state_id: "3824",
        },
        {
          id: "41502",
          name: "Mevegissey",
          state_id: "3824",
        },
        {
          id: "41503",
          name: "Newquay",
          state_id: "3824",
        },
        {
          id: "41504",
          name: "Penryn",
          state_id: "3824",
        },
        {
          id: "41505",
          name: "Penzance",
          state_id: "3824",
        },
        {
          id: "41506",
          name: "St. Ives",
          state_id: "3824",
        },
        {
          id: "41507",
          name: "Truro",
          state_id: "3824",
        },
        {
          id: "41508",
          name: "Wadebridge",
          state_id: "3824",
        },
      ],
      Coventry: [
        {
          id: "41509",
          name: "Holbrooks",
          state_id: "3825",
        },
      ],
      "Craven Arms": [],
      Cumbria: [
        {
          id: "41510",
          name: "Askam-in-Furness",
          state_id: "3827",
        },
        {
          id: "41511",
          name: "Flookburgh",
          state_id: "3827",
        },
        {
          id: "41512",
          name: "Grasmere",
          state_id: "3827",
        },
        {
          id: "41513",
          name: "Kendal",
          state_id: "3827",
        },
        {
          id: "41514",
          name: "Keswick",
          state_id: "3827",
        },
        {
          id: "41515",
          name: "Kirkby Stephen",
          state_id: "3827",
        },
        {
          id: "41516",
          name: "Milnthorpe",
          state_id: "3827",
        },
        {
          id: "41517",
          name: "Penrith",
          state_id: "3827",
        },
        {
          id: "41518",
          name: "Ulverston",
          state_id: "3827",
        },
        {
          id: "41519",
          name: "Windermere",
          state_id: "3827",
        },
      ],
      Denbighshire: [
        {
          id: "41520",
          name: "Denbigh",
          state_id: "3828",
        },
      ],
      Derby: [
        {
          id: "41521",
          name: "Ashbourne",
          state_id: "3829",
        },
        {
          id: "41522",
          name: "Buxton",
          state_id: "3829",
        },
        {
          id: "41523",
          name: "Chesterfield",
          state_id: "3829",
        },
        {
          id: "41524",
          name: "Eckington",
          state_id: "3829",
        },
      ],
      Derbyshire: [
        {
          id: "41525",
          name: "Bakewell",
          state_id: "3830",
        },
        {
          id: "41526",
          name: "Belper",
          state_id: "3830",
        },
        {
          id: "41527",
          name: "Breaston",
          state_id: "3830",
        },
        {
          id: "41528",
          name: "Derby",
          state_id: "3830",
        },
        {
          id: "41529",
          name: "Ilkeston",
          state_id: "3830",
        },
        {
          id: "41530",
          name: "Matlock",
          state_id: "3830",
        },
        {
          id: "41531",
          name: "Ripley",
          state_id: "3830",
        },
      ],
      Devon: [
        {
          id: "41532",
          name: "Axminster",
          state_id: "3831",
        },
        {
          id: "41533",
          name: "Barnstaple",
          state_id: "3831",
        },
        {
          id: "41534",
          name: "Beaworthy",
          state_id: "3831",
        },
        {
          id: "41535",
          name: "Bideford",
          state_id: "3831",
        },
        {
          id: "41536",
          name: "Bovey Tracey",
          state_id: "3831",
        },
        {
          id: "41537",
          name: "Braunton",
          state_id: "3831",
        },
        {
          id: "41538",
          name: "Brixham",
          state_id: "3831",
        },
        {
          id: "41539",
          name: "Chudleigh",
          state_id: "3831",
        },
        {
          id: "41540",
          name: "Crediton",
          state_id: "3831",
        },
        {
          id: "41541",
          name: "Dalwood",
          state_id: "3831",
        },
        {
          id: "41542",
          name: "Dartmouth",
          state_id: "3831",
        },
        {
          id: "41543",
          name: "Dawlish",
          state_id: "3831",
        },
        {
          id: "41544",
          name: "Exeter",
          state_id: "3831",
        },
        {
          id: "41545",
          name: "Exmouth",
          state_id: "3831",
        },
        {
          id: "41546",
          name: "Great Torrington",
          state_id: "3831",
        },
        {
          id: "41547",
          name: "Holsworthy",
          state_id: "3831",
        },
        {
          id: "41548",
          name: "Kingsbridge",
          state_id: "3831",
        },
        {
          id: "41549",
          name: "Modbury",
          state_id: "3831",
        },
        {
          id: "41550",
          name: "Newton Abbot",
          state_id: "3831",
        },
        {
          id: "41551",
          name: "Okehampton",
          state_id: "3831",
        },
        {
          id: "41552",
          name: "Plymouth",
          state_id: "3831",
        },
        {
          id: "41553",
          name: "Plympton",
          state_id: "3831",
        },
        {
          id: "41554",
          name: "Salcombe",
          state_id: "3831",
        },
        {
          id: "41555",
          name: "Tiverton",
          state_id: "3831",
        },
        {
          id: "41556",
          name: "Torquay",
          state_id: "3831",
        },
        {
          id: "41557",
          name: "Totnes",
          state_id: "3831",
        },
        {
          id: "41558",
          name: "Winkleigh",
          state_id: "3831",
        },
        {
          id: "41559",
          name: "Woodburyd",
          state_id: "3831",
        },
        {
          id: "41560",
          name: "Yelverton",
          state_id: "3831",
        },
      ],
      "Dial Code Dungannon": [],
      Didcot: [
        {
          id: "41561",
          name: "Didcot",
          state_id: "3833",
        },
      ],
      Dorset: [
        {
          id: "41562",
          name: "Beaminster",
          state_id: "3834",
        },
        {
          id: "41563",
          name: "Blandford Forum",
          state_id: "3834",
        },
        {
          id: "41564",
          name: "Christchurch",
          state_id: "3834",
        },
        {
          id: "41565",
          name: "Dorset",
          state_id: "3834",
        },
        {
          id: "41566",
          name: "Poole",
          state_id: "3834",
        },
        {
          id: "41567",
          name: "Sherborne",
          state_id: "3834",
        },
        {
          id: "41568",
          name: "Sturminster Newton",
          state_id: "3834",
        },
        {
          id: "41569",
          name: "Swanage",
          state_id: "3834",
        },
        {
          id: "41570",
          name: "Verwood",
          state_id: "3834",
        },
        {
          id: "41571",
          name: "Wimborne",
          state_id: "3834",
        },
      ],
      Dunbartonshire: [
        {
          id: "41572",
          name: "Alexandria",
          state_id: "3835",
        },
      ],
      Durham: [
        {
          id: "41573",
          name: "Crook",
          state_id: "3836",
        },
        {
          id: "41574",
          name: "Spennymoor",
          state_id: "3836",
        },
      ],
      "East Dunbartonshire": [],
      "East Lothian": [],
      "East Midlands": [],
      "East Sussex": [],
      "East Yorkshire": [],
      England: [
        {
          id: "41575",
          name: "Abingdon",
          state_id: "3842",
        },
        {
          id: "41576",
          name: "Accrington",
          state_id: "3842",
        },
        {
          id: "41577",
          name: "Aldershot",
          state_id: "3842",
        },
        {
          id: "41578",
          name: "Alfreton",
          state_id: "3842",
        },
        {
          id: "41579",
          name: "Altrincham",
          state_id: "3842",
        },
        {
          id: "41580",
          name: "Amersham",
          state_id: "3842",
        },
        {
          id: "41581",
          name: "Andover",
          state_id: "3842",
        },
        {
          id: "41582",
          name: "Arnold",
          state_id: "3842",
        },
        {
          id: "41583",
          name: "Ashford",
          state_id: "3842",
        },
        {
          id: "41584",
          name: "Ashington",
          state_id: "3842",
        },
        {
          id: "41585",
          name: "Ashton-in-Makerfield",
          state_id: "3842",
        },
        {
          id: "41586",
          name: "Ashton-under-Lyne",
          state_id: "3842",
        },
        {
          id: "41587",
          name: "Atherton",
          state_id: "3842",
        },
        {
          id: "41588",
          name: "Aylesbury",
          state_id: "3842",
        },
        {
          id: "41589",
          name: "Aylesford-East Malling",
          state_id: "3842",
        },
        {
          id: "41590",
          name: "Banbury",
          state_id: "3842",
        },
        {
          id: "41591",
          name: "Banstead-Tadworth",
          state_id: "3842",
        },
        {
          id: "41592",
          name: "Barnsley",
          state_id: "3842",
        },
        {
          id: "41593",
          name: "Barnstaple",
          state_id: "3842",
        },
        {
          id: "41594",
          name: "Barrow-in-Furness",
          state_id: "3842",
        },
        {
          id: "41595",
          name: "Basildon",
          state_id: "3842",
        },
        {
          id: "41596",
          name: "Basingstoke",
          state_id: "3842",
        },
        {
          id: "41597",
          name: "Bath",
          state_id: "3842",
        },
        {
          id: "41598",
          name: "Batley",
          state_id: "3842",
        },
        {
          id: "41599",
          name: "Bebington",
          state_id: "3842",
        },
        {
          id: "41600",
          name: "Bedford",
          state_id: "3842",
        },
        {
          id: "41601",
          name: "Bedworth",
          state_id: "3842",
        },
        {
          id: "41602",
          name: "Beeston and Stapleford",
          state_id: "3842",
        },
        {
          id: "41603",
          name: "Benfleet",
          state_id: "3842",
        },
        {
          id: "41604",
          name: "Bentley",
          state_id: "3842",
        },
        {
          id: "41605",
          name: "Berwick-upon-Tweed",
          state_id: "3842",
        },
        {
          id: "41606",
          name: "Beverley",
          state_id: "3842",
        },
        {
          id: "41607",
          name: "Bexhil",
          state_id: "3842",
        },
        {
          id: "41608",
          name: "Bicester",
          state_id: "3842",
        },
        {
          id: "41609",
          name: "Bideford",
          state_id: "3842",
        },
        {
          id: "41610",
          name: "Billericay",
          state_id: "3842",
        },
        {
          id: "41611",
          name: "Billingham",
          state_id: "3842",
        },
        {
          id: "41612",
          name: "Birkenhead",
          state_id: "3842",
        },
        {
          id: "41613",
          name: "Birmingham",
          state_id: "3842",
        },
        {
          id: "41614",
          name: "Bishop Auckland",
          state_id: "3842",
        },
        {
          id: "41615",
          name: "Bishop''s Stortford",
          state_id: "3842",
        },
        {
          id: "41616",
          name: "Blackburn",
          state_id: "3842",
        },
        {
          id: "41617",
          name: "Blackpool",
          state_id: "3842",
        },
        {
          id: "41618",
          name: "Bletchley",
          state_id: "3842",
        },
        {
          id: "41619",
          name: "Blyth",
          state_id: "3842",
        },
        {
          id: "41620",
          name: "Bodmin",
          state_id: "3842",
        },
        {
          id: "41621",
          name: "Bognor Regis",
          state_id: "3842",
        },
        {
          id: "41622",
          name: "Bolton",
          state_id: "3842",
        },
        {
          id: "41623",
          name: "Bootle",
          state_id: "3842",
        },
        {
          id: "41624",
          name: "Boston",
          state_id: "3842",
        },
        {
          id: "41625",
          name: "Bournemouth",
          state_id: "3842",
        },
        {
          id: "41626",
          name: "Bracknell",
          state_id: "3842",
        },
        {
          id: "41627",
          name: "Bradford",
          state_id: "3842",
        },
        {
          id: "41628",
          name: "Braintree",
          state_id: "3842",
        },
        {
          id: "41629",
          name: "Bredbury and Romiley",
          state_id: "3842",
        },
        {
          id: "41630",
          name: "Brentwood",
          state_id: "3842",
        },
        {
          id: "41631",
          name: "Bridgwater",
          state_id: "3842",
        },
        {
          id: "41632",
          name: "Bridlington",
          state_id: "3842",
        },
        {
          id: "41633",
          name: "Brigg",
          state_id: "3842",
        },
        {
          id: "41634",
          name: "Brighouse",
          state_id: "3842",
        },
        {
          id: "41635",
          name: "Brighton",
          state_id: "3842",
        },
        {
          id: "41636",
          name: "Bristol",
          state_id: "3842",
        },
        {
          id: "41637",
          name: "Broadstairs",
          state_id: "3842",
        },
        {
          id: "41638",
          name: "Bromley Cross-Bradshaw",
          state_id: "3842",
        },
        {
          id: "41639",
          name: "Bromsgrove-Catshill",
          state_id: "3842",
        },
        {
          id: "41640",
          name: "Burgess Hill",
          state_id: "3842",
        },
        {
          id: "41641",
          name: "Burnley",
          state_id: "3842",
        },
        {
          id: "41642",
          name: "Burntwood",
          state_id: "3842",
        },
        {
          id: "41643",
          name: "Burton-upon-Trent",
          state_id: "3842",
        },
        {
          id: "41644",
          name: "Bury",
          state_id: "3842",
        },
        {
          id: "41645",
          name: "Bury Saint Edmunds",
          state_id: "3842",
        },
        {
          id: "41646",
          name: "Camberley-Frimley",
          state_id: "3842",
        },
        {
          id: "41647",
          name: "Cambourne-Redruth",
          state_id: "3842",
        },
        {
          id: "41648",
          name: "Cambridge",
          state_id: "3842",
        },
        {
          id: "41649",
          name: "Cannock",
          state_id: "3842",
        },
        {
          id: "41650",
          name: "Canterbury",
          state_id: "3842",
        },
        {
          id: "41651",
          name: "Canvey Island",
          state_id: "3842",
        },
        {
          id: "41652",
          name: "Carlisle",
          state_id: "3842",
        },
        {
          id: "41653",
          name: "Carlton",
          state_id: "3842",
        },
        {
          id: "41654",
          name: "Castleford",
          state_id: "3842",
        },
        {
          id: "41655",
          name: "Caterham and Warlingham",
          state_id: "3842",
        },
        {
          id: "41656",
          name: "Chadderton",
          state_id: "3842",
        },
        {
          id: "41657",
          name: "Chapeltown",
          state_id: "3842",
        },
        {
          id: "41658",
          name: "Chatham",
          state_id: "3842",
        },
        {
          id: "41659",
          name: "Cheadle and Gatley",
          state_id: "3842",
        },
        {
          id: "41660",
          name: "Chelmsford",
          state_id: "3842",
        },
        {
          id: "41661",
          name: "Cheltenham",
          state_id: "3842",
        },
        {
          id: "41662",
          name: "Chesham",
          state_id: "3842",
        },
        {
          id: "41663",
          name: "Cheshunt",
          state_id: "3842",
        },
        {
          id: "41664",
          name: "Chessington",
          state_id: "3842",
        },
        {
          id: "41665",
          name: "Chester",
          state_id: "3842",
        },
        {
          id: "41666",
          name: "Chester-le-Street",
          state_id: "3842",
        },
        {
          id: "41667",
          name: "Chesterfield",
          state_id: "3842",
        },
        {
          id: "41668",
          name: "Chichester",
          state_id: "3842",
        },
        {
          id: "41669",
          name: "Chippenham",
          state_id: "3842",
        },
        {
          id: "41670",
          name: "Chipping Sodbury",
          state_id: "3842",
        },
        {
          id: "41671",
          name: "Chorley",
          state_id: "3842",
        },
        {
          id: "41672",
          name: "Christchurch",
          state_id: "3842",
        },
        {
          id: "41673",
          name: "Clacton-on-Sea",
          state_id: "3842",
        },
        {
          id: "41674",
          name: "Clay Cross-North Wingfield",
          state_id: "3842",
        },
        {
          id: "41675",
          name: "Cleethorpes",
          state_id: "3842",
        },
        {
          id: "41676",
          name: "Clevedon",
          state_id: "3842",
        },
        {
          id: "41677",
          name: "Coalville",
          state_id: "3842",
        },
        {
          id: "41678",
          name: "Colchester",
          state_id: "3842",
        },
        {
          id: "41679",
          name: "Congleton",
          state_id: "3842",
        },
        {
          id: "41680",
          name: "Consett",
          state_id: "3842",
        },
        {
          id: "41681",
          name: "Corby",
          state_id: "3842",
        },
        {
          id: "41682",
          name: "Coventry",
          state_id: "3842",
        },
        {
          id: "41683",
          name: "Cramlington",
          state_id: "3842",
        },
        {
          id: "41684",
          name: "Crawley",
          state_id: "3842",
        },
        {
          id: "41685",
          name: "Crosby",
          state_id: "3842",
        },
        {
          id: "41686",
          name: "Crowthorne",
          state_id: "3842",
        },
        {
          id: "41687",
          name: "Darlington",
          state_id: "3842",
        },
        {
          id: "41688",
          name: "Dartford",
          state_id: "3842",
        },
        {
          id: "41689",
          name: "Darwen",
          state_id: "3842",
        },
        {
          id: "41690",
          name: "Deal",
          state_id: "3842",
        },
        {
          id: "41691",
          name: "Denton",
          state_id: "3842",
        },
        {
          id: "41692",
          name: "Derby",
          state_id: "3842",
        },
        {
          id: "41693",
          name: "Dewsbury",
          state_id: "3842",
        },
        {
          id: "41694",
          name: "Doncaster",
          state_id: "3842",
        },
        {
          id: "41695",
          name: "Dorchester",
          state_id: "3842",
        },
        {
          id: "41696",
          name: "Dover",
          state_id: "3842",
        },
        {
          id: "41697",
          name: "Droitwich",
          state_id: "3842",
        },
        {
          id: "41698",
          name: "Dronfield",
          state_id: "3842",
        },
        {
          id: "41699",
          name: "Droylsden",
          state_id: "3842",
        },
        {
          id: "41700",
          name: "Dudley",
          state_id: "3842",
        },
        {
          id: "41701",
          name: "Dunstable",
          state_id: "3842",
        },
        {
          id: "41702",
          name: "Durham",
          state_id: "3842",
        },
        {
          id: "41703",
          name: "East Grinstead",
          state_id: "3842",
        },
        {
          id: "41704",
          name: "East Retford",
          state_id: "3842",
        },
        {
          id: "41705",
          name: "Eastbourne",
          state_id: "3842",
        },
        {
          id: "41706",
          name: "Eastleigh",
          state_id: "3842",
        },
        {
          id: "41707",
          name: "Eaton Socon-Saint Neots",
          state_id: "3842",
        },
        {
          id: "41708",
          name: "Eccles",
          state_id: "3842",
        },
        {
          id: "41709",
          name: "Egham",
          state_id: "3842",
        },
        {
          id: "41710",
          name: "Ellesmere Port",
          state_id: "3842",
        },
        {
          id: "41711",
          name: "Epsom and Ewell",
          state_id: "3842",
        },
        {
          id: "41712",
          name: "Esher-Molesey",
          state_id: "3842",
        },
        {
          id: "41713",
          name: "Eston and South Bank",
          state_id: "3842",
        },
        {
          id: "41714",
          name: "Exeter",
          state_id: "3842",
        },
        {
          id: "41715",
          name: "Failsworth",
          state_id: "3842",
        },
        {
          id: "41716",
          name: "Falmouth-Penryn",
          state_id: "3842",
        },
        {
          id: "41717",
          name: "Fareham",
          state_id: "3842",
        },
        {
          id: "41718",
          name: "Farnborough",
          state_id: "3842",
        },
        {
          id: "41719",
          name: "Farnham",
          state_id: "3842",
        },
        {
          id: "41720",
          name: "Farnworth",
          state_id: "3842",
        },
        {
          id: "41721",
          name: "Farring",
          state_id: "3842",
        },
        {
          id: "41722",
          name: "Felixtowe",
          state_id: "3842",
        },
        {
          id: "41723",
          name: "Felling",
          state_id: "3842",
        },
        {
          id: "41724",
          name: "Ferndown",
          state_id: "3842",
        },
        {
          id: "41725",
          name: "Fleetwood",
          state_id: "3842",
        },
        {
          id: "41726",
          name: "Folkestone",
          state_id: "3842",
        },
        {
          id: "41727",
          name: "Formby",
          state_id: "3842",
        },
        {
          id: "41728",
          name: "Frome",
          state_id: "3842",
        },
        {
          id: "41729",
          name: "Fulham",
          state_id: "3842",
        },
        {
          id: "41730",
          name: "Gateshead",
          state_id: "3842",
        },
        {
          id: "41731",
          name: "Gillingham",
          state_id: "3842",
        },
        {
          id: "41732",
          name: "Glossop",
          state_id: "3842",
        },
        {
          id: "41733",
          name: "Gloucester",
          state_id: "3842",
        },
        {
          id: "41734",
          name: "Godalming",
          state_id: "3842",
        },
        {
          id: "41735",
          name: "Golborne",
          state_id: "3842",
        },
        {
          id: "41736",
          name: "Gosforth",
          state_id: "3842",
        },
        {
          id: "41737",
          name: "Gosport",
          state_id: "3842",
        },
        {
          id: "41738",
          name: "Grantham",
          state_id: "3842",
        },
        {
          id: "41739",
          name: "Gravesend",
          state_id: "3842",
        },
        {
          id: "41740",
          name: "Grays",
          state_id: "3842",
        },
        {
          id: "41741",
          name: "Greasby",
          state_id: "3842",
        },
        {
          id: "41742",
          name: "Great Malvern",
          state_id: "3842",
        },
        {
          id: "41743",
          name: "Great Sankey",
          state_id: "3842",
        },
        {
          id: "41744",
          name: "Great Yarmouth",
          state_id: "3842",
        },
        {
          id: "41745",
          name: "Grimsby",
          state_id: "3842",
        },
        {
          id: "41746",
          name: "Guildford",
          state_id: "3842",
        },
        {
          id: "41747",
          name: "Guiseley-Yeadon",
          state_id: "3842",
        },
        {
          id: "41748",
          name: "Halesowen",
          state_id: "3842",
        },
        {
          id: "41749",
          name: "Halifax",
          state_id: "3842",
        },
        {
          id: "41750",
          name: "Harlow",
          state_id: "3842",
        },
        {
          id: "41751",
          name: "Harpenden",
          state_id: "3842",
        },
        {
          id: "41752",
          name: "Harrogate",
          state_id: "3842",
        },
        {
          id: "41753",
          name: "Hartlepool",
          state_id: "3842",
        },
        {
          id: "41754",
          name: "Hastings",
          state_id: "3842",
        },
        {
          id: "41755",
          name: "Hatfield",
          state_id: "3842",
        },
        {
          id: "41756",
          name: "Hatfield-Stainforth",
          state_id: "3842",
        },
        {
          id: "41757",
          name: "Havant",
          state_id: "3842",
        },
        {
          id: "41758",
          name: "Haywards Heath",
          state_id: "3842",
        },
        {
          id: "41759",
          name: "Hazel Grove and Bramhill",
          state_id: "3842",
        },
        {
          id: "41760",
          name: "Hazlemere",
          state_id: "3842",
        },
        {
          id: "41761",
          name: "Heanor",
          state_id: "3842",
        },
        {
          id: "41762",
          name: "Hemel Hempstead",
          state_id: "3842",
        },
        {
          id: "41763",
          name: "Hereford",
          state_id: "3842",
        },
        {
          id: "41764",
          name: "Herne Bay",
          state_id: "3842",
        },
        {
          id: "41765",
          name: "Hertford",
          state_id: "3842",
        },
        {
          id: "41766",
          name: "Heswall",
          state_id: "3842",
        },
        {
          id: "41767",
          name: "Heywood",
          state_id: "3842",
        },
        {
          id: "41768",
          name: "High Wycombe",
          state_id: "3842",
        },
        {
          id: "41769",
          name: "Hinckley",
          state_id: "3842",
        },
        {
          id: "41770",
          name: "Hindley",
          state_id: "3842",
        },
        {
          id: "41771",
          name: "Hitchin",
          state_id: "3842",
        },
        {
          id: "41772",
          name: "Hoddesdon",
          state_id: "3842",
        },
        {
          id: "41773",
          name: "Holmfirth-Honley",
          state_id: "3842",
        },
        {
          id: "41774",
          name: "Honiton",
          state_id: "3842",
        },
        {
          id: "41775",
          name: "Horsham",
          state_id: "3842",
        },
        {
          id: "41776",
          name: "Houghton-le-Spring",
          state_id: "3842",
        },
        {
          id: "41777",
          name: "Hove",
          state_id: "3842",
        },
        {
          id: "41778",
          name: "Hoylake-West Kirby",
          state_id: "3842",
        },
        {
          id: "41779",
          name: "Hucknall",
          state_id: "3842",
        },
        {
          id: "41780",
          name: "Huddersfield",
          state_id: "3842",
        },
        {
          id: "41781",
          name: "Huyton-with-Roby",
          state_id: "3842",
        },
        {
          id: "41782",
          name: "Hyde",
          state_id: "3842",
        },
        {
          id: "41783",
          name: "Ilfracombe",
          state_id: "3842",
        },
        {
          id: "41784",
          name: "Ilkeston",
          state_id: "3842",
        },
        {
          id: "41785",
          name: "Ipswich",
          state_id: "3842",
        },
        {
          id: "41786",
          name: "Ivybridge",
          state_id: "3842",
        },
        {
          id: "41787",
          name: "Jarrow",
          state_id: "3842",
        },
        {
          id: "41788",
          name: "Keighley",
          state_id: "3842",
        },
        {
          id: "41789",
          name: "Kendal",
          state_id: "3842",
        },
        {
          id: "41790",
          name: "Kenilworth",
          state_id: "3842",
        },
        {
          id: "41791",
          name: "Kettering",
          state_id: "3842",
        },
        {
          id: "41792",
          name: "Kidderminster",
          state_id: "3842",
        },
        {
          id: "41793",
          name: "Kidsgrove",
          state_id: "3842",
        },
        {
          id: "41794",
          name: "King''s Lynn",
          state_id: "3842",
        },
        {
          id: "41795",
          name: "Kingsteignton",
          state_id: "3842",
        },
        {
          id: "41796",
          name: "Kingston upon Hull",
          state_id: "3842",
        },
        {
          id: "41797",
          name: "Kingswood",
          state_id: "3842",
        },
        {
          id: "41798",
          name: "Kirby in Ashfield",
          state_id: "3842",
        },
        {
          id: "41799",
          name: "Kirkby",
          state_id: "3842",
        },
        {
          id: "41800",
          name: "Lancaster",
          state_id: "3842",
        },
        {
          id: "41801",
          name: "Leamington",
          state_id: "3842",
        },
        {
          id: "41802",
          name: "Leatherhead",
          state_id: "3842",
        },
        {
          id: "41803",
          name: "Leeds",
          state_id: "3842",
        },
        {
          id: "41804",
          name: "Leicester",
          state_id: "3842",
        },
        {
          id: "41805",
          name: "Leigh",
          state_id: "3842",
        },
        {
          id: "41806",
          name: "Leighton Buzzard",
          state_id: "3842",
        },
        {
          id: "41807",
          name: "Letchworth",
          state_id: "3842",
        },
        {
          id: "41808",
          name: "Lewes",
          state_id: "3842",
        },
        {
          id: "41809",
          name: "Leyland",
          state_id: "3842",
        },
        {
          id: "41810",
          name: "Lichfield",
          state_id: "3842",
        },
        {
          id: "41811",
          name: "Lincoln",
          state_id: "3842",
        },
        {
          id: "41812",
          name: "Litherland",
          state_id: "3842",
        },
        {
          id: "41813",
          name: "Littlehampton",
          state_id: "3842",
        },
        {
          id: "41814",
          name: "Liverpool",
          state_id: "3842",
        },
        {
          id: "41815",
          name: "Locks Heath",
          state_id: "3842",
        },
        {
          id: "41816",
          name: "London",
          state_id: "3842",
        },
        {
          id: "41817",
          name: "Long Benton-Killingworth",
          state_id: "3842",
        },
        {
          id: "41818",
          name: "Long Eaton",
          state_id: "3842",
        },
        {
          id: "41819",
          name: "Loughborough",
          state_id: "3842",
        },
        {
          id: "41820",
          name: "Loughton",
          state_id: "3842",
        },
        {
          id: "41821",
          name: "Louth",
          state_id: "3842",
        },
        {
          id: "41822",
          name: "Lowestoft",
          state_id: "3842",
        },
        {
          id: "41823",
          name: "Luton",
          state_id: "3842",
        },
        {
          id: "41824",
          name: "Lyminge",
          state_id: "3842",
        },
        {
          id: "41825",
          name: "Lytham Saint Anne''s",
          state_id: "3842",
        },
        {
          id: "41826",
          name: "Mablethorpe and Sutton",
          state_id: "3842",
        },
        {
          id: "41827",
          name: "Macclesfield",
          state_id: "3842",
        },
        {
          id: "41828",
          name: "Maghull-Lydiate",
          state_id: "3842",
        },
        {
          id: "41829",
          name: "Maidenhead",
          state_id: "3842",
        },
        {
          id: "41830",
          name: "Maidstone",
          state_id: "3842",
        },
        {
          id: "41831",
          name: "Manchester",
          state_id: "3842",
        },
        {
          id: "41832",
          name: "Mangotsfield",
          state_id: "3842",
        },
        {
          id: "41833",
          name: "Mansfield",
          state_id: "3842",
        },
        {
          id: "41834",
          name: "Margate",
          state_id: "3842",
        },
        {
          id: "41835",
          name: "Matlock",
          state_id: "3842",
        },
        {
          id: "41836",
          name: "Melton Mowbray",
          state_id: "3842",
        },
        {
          id: "41837",
          name: "Middlesbrough",
          state_id: "3842",
        },
        {
          id: "41838",
          name: "Middleton",
          state_id: "3842",
        },
        {
          id: "41839",
          name: "Midsomer Norton",
          state_id: "3842",
        },
        {
          id: "41840",
          name: "Milton Keynes",
          state_id: "3842",
        },
        {
          id: "41841",
          name: "Morecambe",
          state_id: "3842",
        },
        {
          id: "41842",
          name: "Morley",
          state_id: "3842",
        },
        {
          id: "41843",
          name: "Nailsea",
          state_id: "3842",
        },
        {
          id: "41844",
          name: "Nantwich",
          state_id: "3842",
        },
        {
          id: "41845",
          name: "Nelson",
          state_id: "3842",
        },
        {
          id: "41846",
          name: "New Addington",
          state_id: "3842",
        },
        {
          id: "41847",
          name: "New Milton-Barton-on-Sea",
          state_id: "3842",
        },
        {
          id: "41848",
          name: "Newark-on-Trent",
          state_id: "3842",
        },
        {
          id: "41849",
          name: "Newburn",
          state_id: "3842",
        },
        {
          id: "41850",
          name: "Newbury",
          state_id: "3842",
        },
        {
          id: "41851",
          name: "Newcastle upon Tyne",
          state_id: "3842",
        },
        {
          id: "41852",
          name: "Newcastle-under-Lyme",
          state_id: "3842",
        },
        {
          id: "41853",
          name: "Newport",
          state_id: "3842",
        },
        {
          id: "41854",
          name: "Newton Abbot",
          state_id: "3842",
        },
        {
          id: "41855",
          name: "Newton Aycliffe",
          state_id: "3842",
        },
        {
          id: "41856",
          name: "North Hykeham",
          state_id: "3842",
        },
        {
          id: "41857",
          name: "North Shields",
          state_id: "3842",
        },
        {
          id: "41858",
          name: "Northallerton",
          state_id: "3842",
        },
        {
          id: "41859",
          name: "Northam",
          state_id: "3842",
        },
        {
          id: "41860",
          name: "Northampton",
          state_id: "3842",
        },
        {
          id: "41861",
          name: "Northfleet",
          state_id: "3842",
        },
        {
          id: "41862",
          name: "Northwich",
          state_id: "3842",
        },
        {
          id: "41863",
          name: "Norwich",
          state_id: "3842",
        },
        {
          id: "41864",
          name: "Nottingham",
          state_id: "3842",
        },
        {
          id: "41865",
          name: "Nuneaton",
          state_id: "3842",
        },
        {
          id: "41866",
          name: "Oakengates-Donnington",
          state_id: "3842",
        },
        {
          id: "41867",
          name: "Oakham",
          state_id: "3842",
        },
        {
          id: "41868",
          name: "Oldbury-Smethwick",
          state_id: "3842",
        },
        {
          id: "41869",
          name: "Oldham",
          state_id: "3842",
        },
        {
          id: "41870",
          name: "Ormskirk",
          state_id: "3842",
        },
        {
          id: "41871",
          name: "Ossett",
          state_id: "3842",
        },
        {
          id: "41872",
          name: "Oxford",
          state_id: "3842",
        },
        {
          id: "41873",
          name: "Paignton",
          state_id: "3842",
        },
        {
          id: "41874",
          name: "Penzance",
          state_id: "3842",
        },
        {
          id: "41875",
          name: "Peterborough",
          state_id: "3842",
        },
        {
          id: "41876",
          name: "Peterlee",
          state_id: "3842",
        },
        {
          id: "41877",
          name: "Plymouth",
          state_id: "3842",
        },
        {
          id: "41878",
          name: "Pontefract",
          state_id: "3842",
        },
        {
          id: "41879",
          name: "Poole",
          state_id: "3842",
        },
        {
          id: "41880",
          name: "Portsmouth",
          state_id: "3842",
        },
        {
          id: "41881",
          name: "Potters Bar",
          state_id: "3842",
        },
        {
          id: "41882",
          name: "Prescot",
          state_id: "3842",
        },
        {
          id: "41883",
          name: "Preston",
          state_id: "3842",
        },
        {
          id: "41884",
          name: "Prestwich",
          state_id: "3842",
        },
        {
          id: "41885",
          name: "Prestwood",
          state_id: "3842",
        },
        {
          id: "41886",
          name: "Pudsey",
          state_id: "3842",
        },
        {
          id: "41887",
          name: "Radcliffe",
          state_id: "3842",
        },
        {
          id: "41888",
          name: "Ramsgate",
          state_id: "3842",
        },
        {
          id: "41889",
          name: "Rawtenstall",
          state_id: "3842",
        },
        {
          id: "41890",
          name: "Rayleigh",
          state_id: "3842",
        },
        {
          id: "41891",
          name: "Reading",
          state_id: "3842",
        },
        {
          id: "41892",
          name: "Redcar",
          state_id: "3842",
        },
        {
          id: "41893",
          name: "Redditch",
          state_id: "3842",
        },
        {
          id: "41894",
          name: "Reigate",
          state_id: "3842",
        },
        {
          id: "41895",
          name: "Rochdale",
          state_id: "3842",
        },
        {
          id: "41896",
          name: "Rochester",
          state_id: "3842",
        },
        {
          id: "41897",
          name: "Rotherham",
          state_id: "3842",
        },
        {
          id: "41898",
          name: "Rottingdean",
          state_id: "3842",
        },
        {
          id: "41899",
          name: "Royal Tunbridge Wells",
          state_id: "3842",
        },
        {
          id: "41900",
          name: "Royton",
          state_id: "3842",
        },
        {
          id: "41901",
          name: "Rugby",
          state_id: "3842",
        },
        {
          id: "41902",
          name: "Rugeley",
          state_id: "3842",
        },
        {
          id: "41903",
          name: "Runcorn",
          state_id: "3842",
        },
        {
          id: "41904",
          name: "Rushden",
          state_id: "3842",
        },
        {
          id: "41905",
          name: "Ryde",
          state_id: "3842",
        },
        {
          id: "41906",
          name: "Saint Albans",
          state_id: "3842",
        },
        {
          id: "41907",
          name: "Saint Austell",
          state_id: "3842",
        },
        {
          id: "41908",
          name: "Saint Helens",
          state_id: "3842",
        },
        {
          id: "41909",
          name: "Sale",
          state_id: "3842",
        },
        {
          id: "41910",
          name: "Salford",
          state_id: "3842",
        },
        {
          id: "41911",
          name: "Salisbury",
          state_id: "3842",
        },
        {
          id: "41912",
          name: "Scarborough",
          state_id: "3842",
        },
        {
          id: "41913",
          name: "Scunthorpe",
          state_id: "3842",
        },
        {
          id: "41914",
          name: "Seaham",
          state_id: "3842",
        },
        {
          id: "41915",
          name: "Sevenoaks",
          state_id: "3842",
        },
        {
          id: "41916",
          name: "Sheffield",
          state_id: "3842",
        },
        {
          id: "41917",
          name: "Shipley",
          state_id: "3842",
        },
        {
          id: "41918",
          name: "Shrewsbury",
          state_id: "3842",
        },
        {
          id: "41919",
          name: "Sidmouth",
          state_id: "3842",
        },
        {
          id: "41920",
          name: "Sittingbourne",
          state_id: "3842",
        },
        {
          id: "41921",
          name: "Skegness",
          state_id: "3842",
        },
        {
          id: "41922",
          name: "Skelmersdale",
          state_id: "3842",
        },
        {
          id: "41923",
          name: "Sleaford",
          state_id: "3842",
        },
        {
          id: "41924",
          name: "Slough",
          state_id: "3842",
        },
        {
          id: "41925",
          name: "Solihull",
          state_id: "3842",
        },
        {
          id: "41926",
          name: "Sompting-Lancing",
          state_id: "3842",
        },
        {
          id: "41927",
          name: "South Shields",
          state_id: "3842",
        },
        {
          id: "41928",
          name: "Southampton",
          state_id: "3842",
        },
        {
          id: "41929",
          name: "Southend-on-Sea",
          state_id: "3842",
        },
        {
          id: "41930",
          name: "Southport",
          state_id: "3842",
        },
        {
          id: "41931",
          name: "Spalding-Pinchbeck",
          state_id: "3842",
        },
        {
          id: "41932",
          name: "St. Helens",
          state_id: "3842",
        },
        {
          id: "41933",
          name: "Stafford",
          state_id: "3842",
        },
        {
          id: "41934",
          name: "Staines",
          state_id: "3842",
        },
        {
          id: "41935",
          name: "Stalybridge",
          state_id: "3842",
        },
        {
          id: "41936",
          name: "Stamford",
          state_id: "3842",
        },
        {
          id: "41937",
          name: "Stanford le Hope-Corringham",
          state_id: "3842",
        },
        {
          id: "41938",
          name: "Stanley-Annfield Plain",
          state_id: "3842",
        },
        {
          id: "41939",
          name: "Staveley",
          state_id: "3842",
        },
        {
          id: "41940",
          name: "Stevenage",
          state_id: "3842",
        },
        {
          id: "41941",
          name: "Stockport",
          state_id: "3842",
        },
        {
          id: "41942",
          name: "Stockton Heath-Thelwall",
          state_id: "3842",
        },
        {
          id: "41943",
          name: "Stockton-on-Tees",
          state_id: "3842",
        },
        {
          id: "41944",
          name: "Stoke-on-Trent",
          state_id: "3842",
        },
        {
          id: "41945",
          name: "Stourbridge",
          state_id: "3842",
        },
        {
          id: "41946",
          name: "Stratford-upon-Avon",
          state_id: "3842",
        },
        {
          id: "41947",
          name: "Stretford",
          state_id: "3842",
        },
        {
          id: "41948",
          name: "Strood",
          state_id: "3842",
        },
        {
          id: "41949",
          name: "Stubbington",
          state_id: "3842",
        },
        {
          id: "41950",
          name: "Sunbury",
          state_id: "3842",
        },
        {
          id: "41951",
          name: "Sunderland",
          state_id: "3842",
        },
        {
          id: "41952",
          name: "Sutton Coldfield",
          state_id: "3842",
        },
        {
          id: "41953",
          name: "Sutton in Ashfield",
          state_id: "3842",
        },
        {
          id: "41954",
          name: "Swadlincote",
          state_id: "3842",
        },
        {
          id: "41955",
          name: "Swanley-Hextable",
          state_id: "3842",
        },
        {
          id: "41956",
          name: "Swindon",
          state_id: "3842",
        },
        {
          id: "41957",
          name: "Swinton and Pendlebury",
          state_id: "3842",
        },
        {
          id: "41958",
          name: "Tamworth",
          state_id: "3842",
        },
        {
          id: "41959",
          name: "Taunton",
          state_id: "3842",
        },
        {
          id: "41960",
          name: "Tavistock",
          state_id: "3842",
        },
        {
          id: "41961",
          name: "Teignmouth",
          state_id: "3842",
        },
        {
          id: "41962",
          name: "Telford",
          state_id: "3842",
        },
        {
          id: "41963",
          name: "Tenbury Wells",
          state_id: "3842",
        },
        {
          id: "41964",
          name: "Thatcham",
          state_id: "3842",
        },
        {
          id: "41965",
          name: "The Deepings",
          state_id: "3842",
        },
        {
          id: "41966",
          name: "Thetford",
          state_id: "3842",
        },
        {
          id: "41967",
          name: "Thornaby",
          state_id: "3842",
        },
        {
          id: "41968",
          name: "Thornton-Cleveleys",
          state_id: "3842",
        },
        {
          id: "41969",
          name: "Tiverton",
          state_id: "3842",
        },
        {
          id: "41970",
          name: "Tonbridge",
          state_id: "3842",
        },
        {
          id: "41971",
          name: "Torquay",
          state_id: "3842",
        },
        {
          id: "41972",
          name: "Totton",
          state_id: "3842",
        },
        {
          id: "41973",
          name: "Trowbridge",
          state_id: "3842",
        },
        {
          id: "41974",
          name: "Truro",
          state_id: "3842",
        },
        {
          id: "41975",
          name: "Tyldesley",
          state_id: "3842",
        },
        {
          id: "41976",
          name: "Urmston",
          state_id: "3842",
        },
        {
          id: "41977",
          name: "Wakefield",
          state_id: "3842",
        },
        {
          id: "41978",
          name: "Walkden",
          state_id: "3842",
        },
        {
          id: "41979",
          name: "Wallasey",
          state_id: "3842",
        },
        {
          id: "41980",
          name: "Wallsend",
          state_id: "3842",
        },
        {
          id: "41981",
          name: "Walsall",
          state_id: "3842",
        },
        {
          id: "41982",
          name: "Walton and Weybridge",
          state_id: "3842",
        },
        {
          id: "41983",
          name: "Warrington",
          state_id: "3842",
        },
        {
          id: "41984",
          name: "Warwick",
          state_id: "3842",
        },
        {
          id: "41985",
          name: "Washington",
          state_id: "3842",
        },
        {
          id: "41986",
          name: "Waterlooville",
          state_id: "3842",
        },
        {
          id: "41987",
          name: "Watford",
          state_id: "3842",
        },
        {
          id: "41988",
          name: "Wellingborough",
          state_id: "3842",
        },
        {
          id: "41989",
          name: "Welwyn Garden City",
          state_id: "3842",
        },
        {
          id: "41990",
          name: "West Bridgeford",
          state_id: "3842",
        },
        {
          id: "41991",
          name: "West Bromwich",
          state_id: "3842",
        },
        {
          id: "41992",
          name: "Westhoughton",
          state_id: "3842",
        },
        {
          id: "41993",
          name: "Weston-super-Mare",
          state_id: "3842",
        },
        {
          id: "41995",
          name: "Whitefield",
          state_id: "3842",
        },
        {
          id: "41996",
          name: "Whitehaven",
          state_id: "3842",
        },
        {
          id: "41997",
          name: "Whitley Bay",
          state_id: "3842",
        },
        {
          id: "41998",
          name: "Wickford",
          state_id: "3842",
        },
        {
          id: "41999",
          name: "Widnes",
          state_id: "3842",
        },
        {
          id: "42000",
          name: "Wigan",
          state_id: "3842",
        },
        {
          id: "42001",
          name: "Wigston",
          state_id: "3842",
        },
        {
          id: "42002",
          name: "Wilmslow",
          state_id: "3842",
        },
        {
          id: "42003",
          name: "Wimbourne Minster",
          state_id: "3842",
        },
        {
          id: "42004",
          name: "Winchester",
          state_id: "3842",
        },
        {
          id: "42005",
          name: "Windsor Berks",
          state_id: "3842",
        },
        {
          id: "42006",
          name: "Windsor-Eton",
          state_id: "3842",
        },
        {
          id: "42007",
          name: "Winsford",
          state_id: "3842",
        },
        {
          id: "42008",
          name: "Wisbech",
          state_id: "3842",
        },
        {
          id: "42009",
          name: "Witham",
          state_id: "3842",
        },
        {
          id: "42010",
          name: "Witney",
          state_id: "3842",
        },
        {
          id: "42011",
          name: "Woking-Byfleet",
          state_id: "3842",
        },
        {
          id: "42012",
          name: "Wokingham",
          state_id: "3842",
        },
        {
          id: "42013",
          name: "Wolverhampton",
          state_id: "3842",
        },
        {
          id: "42014",
          name: "Wolverton-Stony Stratford",
          state_id: "3842",
        },
        {
          id: "42015",
          name: "Worcester",
          state_id: "3842",
        },
        {
          id: "42016",
          name: "Worcestershire",
          state_id: "3842",
        },
        {
          id: "42017",
          name: "Workington",
          state_id: "3842",
        },
        {
          id: "42018",
          name: "Worksop",
          state_id: "3842",
        },
        {
          id: "42019",
          name: "Worthing",
          state_id: "3842",
        },
        {
          id: "42020",
          name: "Yeovil",
          state_id: "3842",
        },
        {
          id: "42021",
          name: "York",
          state_id: "3842",
        },
      ],
      Essex: [
        {
          id: "42022",
          name: "Barking",
          state_id: "3843",
        },
        {
          id: "42023",
          name: "Basildon",
          state_id: "3843",
        },
        {
          id: "42024",
          name: "Brentwood",
          state_id: "3843",
        },
        {
          id: "42025",
          name: "Cambrridge",
          state_id: "3843",
        },
        {
          id: "42026",
          name: "Canvey Island",
          state_id: "3843",
        },
        {
          id: "42027",
          name: "Chelmsford",
          state_id: "3843",
        },
        {
          id: "42028",
          name: "Clacton-on-Sea",
          state_id: "3843",
        },
        {
          id: "42029",
          name: "Colchester",
          state_id: "3843",
        },
        {
          id: "42030",
          name: "Dagenham",
          state_id: "3843",
        },
        {
          id: "42031",
          name: "Dunmow",
          state_id: "3843",
        },
        {
          id: "42032",
          name: "Epping",
          state_id: "3843",
        },
        {
          id: "42033",
          name: "Essex",
          state_id: "3843",
        },
        {
          id: "42034",
          name: "Grays",
          state_id: "3843",
        },
        {
          id: "42035",
          name: "Harlow",
          state_id: "3843",
        },
        {
          id: "42036",
          name: "Ilford",
          state_id: "3843",
        },
        {
          id: "42037",
          name: "Ingatestone",
          state_id: "3843",
        },
        {
          id: "42038",
          name: "Leigh on Sea",
          state_id: "3843",
        },
        {
          id: "42039",
          name: "Rainham",
          state_id: "3843",
        },
        {
          id: "42040",
          name: "Romford",
          state_id: "3843",
        },
        {
          id: "42041",
          name: "Saffron Walden",
          state_id: "3843",
        },
        {
          id: "42042",
          name: "Stansted",
          state_id: "3843",
        },
        {
          id: "42043",
          name: "Wickford",
          state_id: "3843",
        },
      ],
      Fermanagh: [
        {
          id: "42044",
          name: "Ballinamallard",
          state_id: "3844",
        },
      ],
      Fife: [
        {
          id: "42045",
          name: "Kirkcaldy",
          state_id: "3845",
        },
      ],
      Flintshire: [
        {
          id: "42046",
          name: "Ewloe",
          state_id: "3846",
        },
        {
          id: "42047",
          name: "Greenfield",
          state_id: "3846",
        },
      ],
      Fulham: [
        {
          id: "42048",
          name: "Imperial Wharf",
          state_id: "3847",
        },
      ],
      Gainsborough: [
        {
          id: "42049",
          name: "Kirton-in-Lindsey",
          state_id: "3848",
        },
      ],
      Glocestershire: [
        {
          id: "42050",
          name: "Berkeley",
          state_id: "3849",
        },
        {
          id: "42051",
          name: "Cheltenham",
          state_id: "3849",
        },
        {
          id: "42052",
          name: "Churchham",
          state_id: "3849",
        },
        {
          id: "42053",
          name: "Cirencester",
          state_id: "3849",
        },
        {
          id: "42054",
          name: "East Kilbride",
          state_id: "3849",
        },
        {
          id: "42055",
          name: "Gloucester",
          state_id: "3849",
        },
        {
          id: "42056",
          name: "Lechlade",
          state_id: "3849",
        },
        {
          id: "42057",
          name: "Lydney",
          state_id: "3849",
        },
        {
          id: "42058",
          name: "Moreton in Marsh",
          state_id: "3849",
        },
        {
          id: "42059",
          name: "Stroud",
          state_id: "3849",
        },
        {
          id: "42060",
          name: "Tewkesbury",
          state_id: "3849",
        },
      ],
      Gwent: [
        {
          id: "42061",
          name: "Blackwood",
          state_id: "3850",
        },
        {
          id: "42062",
          name: "Blaenavon",
          state_id: "3850",
        },
        {
          id: "42063",
          name: "Newport",
          state_id: "3850",
        },
        {
          id: "42064",
          name: "Tredegar",
          state_id: "3850",
        },
      ],
      Hampshire: [
        {
          id: "42065",
          name: "Aldershot",
          state_id: "3851",
        },
        {
          id: "42066",
          name: "Alton",
          state_id: "3851",
        },
        {
          id: "42067",
          name: "Andover",
          state_id: "3851",
        },
        {
          id: "42068",
          name: "Bordon",
          state_id: "3851",
        },
        {
          id: "42069",
          name: "Botley",
          state_id: "3851",
        },
        {
          id: "42070",
          name: "Fareham",
          state_id: "3851",
        },
        {
          id: "42071",
          name: "Farnborough",
          state_id: "3851",
        },
        {
          id: "42072",
          name: "Fleet",
          state_id: "3851",
        },
        {
          id: "42073",
          name: "Fordingbridge",
          state_id: "3851",
        },
        {
          id: "42074",
          name: "Havant",
          state_id: "3851",
        },
        {
          id: "42075",
          name: "Hayling Island",
          state_id: "3851",
        },
        {
          id: "42076",
          name: "Hook",
          state_id: "3851",
        },
        {
          id: "42077",
          name: "Isle of wight",
          state_id: "3851",
        },
        {
          id: "42078",
          name: "Liphook",
          state_id: "3851",
        },
        {
          id: "42079",
          name: "Longparish",
          state_id: "3851",
        },
        {
          id: "42080",
          name: "Old Bishopstoke",
          state_id: "3851",
        },
        {
          id: "42081",
          name: "Petersfield",
          state_id: "3851",
        },
        {
          id: "42082",
          name: "Portsmouth",
          state_id: "3851",
        },
        {
          id: "42083",
          name: "Ringwood",
          state_id: "3851",
        },
        {
          id: "42084",
          name: "Romsey",
          state_id: "3851",
        },
        {
          id: "42085",
          name: "South Harting",
          state_id: "3851",
        },
        {
          id: "42086",
          name: "Southampton",
          state_id: "3851",
        },
        {
          id: "42087",
          name: "Waterlooville",
          state_id: "3851",
        },
        {
          id: "42088",
          name: "West Wellow",
          state_id: "3851",
        },
        {
          id: "42089",
          name: "Winchester",
          state_id: "3851",
        },
      ],
      Hants: [
        {
          id: "42090",
          name: "Lymington",
          state_id: "3852",
        },
        {
          id: "42091",
          name: "Pennington",
          state_id: "3852",
        },
        {
          id: "42092",
          name: "Southampton",
          state_id: "3852",
        },
      ],
      Herefordshire: [
        {
          id: "42093",
          name: "Kington",
          state_id: "3853",
        },
        {
          id: "42094",
          name: "Ledbury",
          state_id: "3853",
        },
        {
          id: "42095",
          name: "Leominster",
          state_id: "3853",
        },
        {
          id: "42096",
          name: "Saint Albans",
          state_id: "3853",
        },
      ],
      Hertfordshire: [
        {
          id: "42097",
          name: "Barnet",
          state_id: "3854",
        },
        {
          id: "42098",
          name: "Bishops Stortford",
          state_id: "3854",
        },
        {
          id: "42099",
          name: "Borehamwood",
          state_id: "3854",
        },
        {
          id: "42100",
          name: "Brookmans Park",
          state_id: "3854",
        },
        {
          id: "42101",
          name: "Bushey",
          state_id: "3854",
        },
        {
          id: "42102",
          name: "Cheshunt",
          state_id: "3854",
        },
        {
          id: "42103",
          name: "Cuffley",
          state_id: "3854",
        },
        {
          id: "42104",
          name: "Elstree",
          state_id: "3854",
        },
        {
          id: "42105",
          name: "Hemel Hempstead",
          state_id: "3854",
        },
        {
          id: "42106",
          name: "Hertfordshire",
          state_id: "3854",
        },
        {
          id: "42107",
          name: "Kings Langley",
          state_id: "3854",
        },
        {
          id: "42108",
          name: "Much Hadham",
          state_id: "3854",
        },
        {
          id: "42109",
          name: "Radlett",
          state_id: "3854",
        },
        {
          id: "42110",
          name: "Rickmansworth",
          state_id: "3854",
        },
        {
          id: "42111",
          name: "Royston",
          state_id: "3854",
        },
        {
          id: "42112",
          name: "Stevenage",
          state_id: "3854",
        },
        {
          id: "42113",
          name: "Waltham Cross",
          state_id: "3854",
        },
        {
          id: "42114",
          name: "Watford",
          state_id: "3854",
        },
        {
          id: "42115",
          name: "Welwyn",
          state_id: "3854",
        },
      ],
      Ireland: [],
      "Isle Of Man": [],
      "Isle of Wight": [],
      Kenford: [
        {
          id: "42116",
          name: "Newmarket",
          state_id: "3858",
        },
      ],
      Kent: [
        {
          id: "42117",
          name: "Ashford",
          state_id: "3859",
        },
        {
          id: "42118",
          name: "Beckenham",
          state_id: "3859",
        },
        {
          id: "42119",
          name: "Bromley",
          state_id: "3859",
        },
        {
          id: "42120",
          name: "Brookland",
          state_id: "3859",
        },
        {
          id: "42121",
          name: "Charing",
          state_id: "3859",
        },
        {
          id: "42122",
          name: "Chatam",
          state_id: "3859",
        },
        {
          id: "42123",
          name: "Crayford",
          state_id: "3859",
        },
        {
          id: "42124",
          name: "Edenbridge",
          state_id: "3859",
        },
        {
          id: "42125",
          name: "Erith",
          state_id: "3859",
        },
        {
          id: "42126",
          name: "Faversham",
          state_id: "3859",
        },
        {
          id: "42127",
          name: "Five Oak Green",
          state_id: "3859",
        },
        {
          id: "42128",
          name: "Folkestone",
          state_id: "3859",
        },
        {
          id: "42129",
          name: "Gillingham",
          state_id: "3859",
        },
        {
          id: "42130",
          name: "Gravesend",
          state_id: "3859",
        },
        {
          id: "42131",
          name: "Hartlip",
          state_id: "3859",
        },
        {
          id: "42132",
          name: "Hayes",
          state_id: "3859",
        },
        {
          id: "42133",
          name: "Herne Bay",
          state_id: "3859",
        },
        {
          id: "42134",
          name: "Hythe",
          state_id: "3859",
        },
        {
          id: "42135",
          name: "Lenham",
          state_id: "3859",
        },
        {
          id: "42136",
          name: "Maidstone",
          state_id: "3859",
        },
        {
          id: "42137",
          name: "Minster",
          state_id: "3859",
        },
        {
          id: "42138",
          name: "New Romney",
          state_id: "3859",
        },
        {
          id: "42139",
          name: "Orpington",
          state_id: "3859",
        },
        {
          id: "42140",
          name: "Paddock Wood",
          state_id: "3859",
        },
        {
          id: "42141",
          name: "Royal Tunbridge Wells",
          state_id: "3859",
        },
        {
          id: "42142",
          name: "Sandwich",
          state_id: "3859",
        },
        {
          id: "42143",
          name: "Sheerness",
          state_id: "3859",
        },
        {
          id: "42144",
          name: "Sidcup",
          state_id: "3859",
        },
        {
          id: "42145",
          name: "Sittingbourne",
          state_id: "3859",
        },
        {
          id: "42146",
          name: "Staplehurst",
          state_id: "3859",
        },
        {
          id: "42147",
          name: "Tunbridge Wells",
          state_id: "3859",
        },
        {
          id: "42148",
          name: "West Malling",
          state_id: "3859",
        },
        {
          id: "42149",
          name: "Westerham",
          state_id: "3859",
        },
        {
          id: "42150",
          name: "Whitstable",
          state_id: "3859",
        },
        {
          id: "42151",
          name: "canterbury",
          state_id: "3859",
        },
      ],
      Kilmarnock: [
        {
          id: "42152",
          name: "Ayrshire",
          state_id: "3860",
        },
      ],
      Lanarkshire: [
        {
          id: "42153",
          name: "Airdrie",
          state_id: "3861",
        },
        {
          id: "42154",
          name: "Glasgow",
          state_id: "3861",
        },
      ],
      Lancashire: [
        {
          id: "42155",
          name: "Accrington",
          state_id: "3862",
        },
        {
          id: "42156",
          name: "Blackburn",
          state_id: "3862",
        },
        {
          id: "42157",
          name: "Blackpool",
          state_id: "3862",
        },
        {
          id: "42158",
          name: "Burnley",
          state_id: "3862",
        },
        {
          id: "42159",
          name: "Clayton-Le-Moors",
          state_id: "3862",
        },
        {
          id: "42160",
          name: "Cleveleys",
          state_id: "3862",
        },
        {
          id: "42161",
          name: "Darwen",
          state_id: "3862",
        },
        {
          id: "42162",
          name: "Gisburn",
          state_id: "3862",
        },
        {
          id: "42163",
          name: "Glasgow",
          state_id: "3862",
        },
        {
          id: "42164",
          name: "Greater Manchester",
          state_id: "3862",
        },
        {
          id: "42165",
          name: "Hamilton",
          state_id: "3862",
        },
        {
          id: "42166",
          name: "Kirkby Lonsdale",
          state_id: "3862",
        },
        {
          id: "42167",
          name: "Leyland",
          state_id: "3862",
        },
        {
          id: "42168",
          name: "Littleborough",
          state_id: "3862",
        },
        {
          id: "42169",
          name: "Lytham St Annes",
          state_id: "3862",
        },
        {
          id: "42170",
          name: "Nelson",
          state_id: "3862",
        },
        {
          id: "42171",
          name: "Oldham",
          state_id: "3862",
        },
        {
          id: "42172",
          name: "Out Rawcliffe",
          state_id: "3862",
        },
        {
          id: "42173",
          name: "Padiham",
          state_id: "3862",
        },
        {
          id: "42174",
          name: "Preston",
          state_id: "3862",
        },
        {
          id: "42175",
          name: "Rochdale",
          state_id: "3862",
        },
        {
          id: "42176",
          name: "Rossendale",
          state_id: "3862",
        },
        {
          id: "42177",
          name: "Tarleton",
          state_id: "3862",
        },
        {
          id: "42178",
          name: "Todmorden",
          state_id: "3862",
        },
        {
          id: "42179",
          name: "West Lancashire",
          state_id: "3862",
        },
      ],
      Leicestershire: [
        {
          id: "42180",
          name: "Coalville",
          state_id: "3863",
        },
        {
          id: "42181",
          name: "Fleckney",
          state_id: "3863",
        },
        {
          id: "42182",
          name: "Leicester",
          state_id: "3863",
        },
        {
          id: "42183",
          name: "Loughborough",
          state_id: "3863",
        },
        {
          id: "42184",
          name: "Lutterworth",
          state_id: "3863",
        },
        {
          id: "42185",
          name: "Market Harborough",
          state_id: "3863",
        },
        {
          id: "42186",
          name: "Tur Langton",
          state_id: "3863",
        },
      ],
      Lincolnshire: [
        {
          id: "42187",
          name: "Alford",
          state_id: "3864",
        },
        {
          id: "42188",
          name: "Bourne",
          state_id: "3864",
        },
        {
          id: "42189",
          name: "Casewick",
          state_id: "3864",
        },
        {
          id: "42190",
          name: "Digby",
          state_id: "3864",
        },
        {
          id: "42191",
          name: "Gainsborough",
          state_id: "3864",
        },
        {
          id: "42192",
          name: "Grimsby",
          state_id: "3864",
        },
        {
          id: "42193",
          name: "Immingham",
          state_id: "3864",
        },
        {
          id: "42194",
          name: "Laceby",
          state_id: "3864",
        },
        {
          id: "42195",
          name: "Lincoln",
          state_id: "3864",
        },
        {
          id: "42196",
          name: "Louth",
          state_id: "3864",
        },
        {
          id: "42197",
          name: "Market Deeping",
          state_id: "3864",
        },
        {
          id: "42198",
          name: "Market Rasen",
          state_id: "3864",
        },
        {
          id: "42199",
          name: "Spalding",
          state_id: "3864",
        },
        {
          id: "42200",
          name: "Spilsby",
          state_id: "3864",
        },
        {
          id: "42201",
          name: "Swinderby",
          state_id: "3864",
        },
        {
          id: "42202",
          name: "Thurlby",
          state_id: "3864",
        },
        {
          id: "42203",
          name: "Witham St Hughs",
          state_id: "3864",
        },
      ],
      Llanymynech: [
        {
          id: "42204",
          name: "Llanymynech",
          state_id: "3865",
        },
      ],
      London: [
        {
          id: "42205",
          name: "Abbeywood",
          state_id: "3866",
        },
        {
          id: "42206",
          name: "Aldgate",
          state_id: "3866",
        },
        {
          id: "42207",
          name: "Alperton",
          state_id: "3866",
        },
        {
          id: "42208",
          name: "Castledawson",
          state_id: "3866",
        },
        {
          id: "42209",
          name: "Edmonton",
          state_id: "3866",
        },
        {
          id: "42210",
          name: "Enfield",
          state_id: "3866",
        },
        {
          id: "42211",
          name: "Forest Gate",
          state_id: "3866",
        },
        {
          id: "42212",
          name: "Greenwich",
          state_id: "3866",
        },
        {
          id: "42213",
          name: "Hainault",
          state_id: "3866",
        },
        {
          id: "42214",
          name: "Hampstead",
          state_id: "3866",
        },
        {
          id: "42215",
          name: "Harrow Weald",
          state_id: "3866",
        },
        {
          id: "42216",
          name: "Hendon",
          state_id: "3866",
        },
        {
          id: "42217",
          name: "Kensington",
          state_id: "3866",
        },
        {
          id: "42218",
          name: "Leyton",
          state_id: "3866",
        },
        {
          id: "42219",
          name: "London",
          state_id: "3866",
        },
        {
          id: "42220",
          name: "Magherafelt",
          state_id: "3866",
        },
        {
          id: "42221",
          name: "Mill Hill",
          state_id: "3866",
        },
        {
          id: "42222",
          name: "Southwark",
          state_id: "3866",
        },
        {
          id: "42223",
          name: "Suffolk",
          state_id: "3866",
        },
        {
          id: "42224",
          name: "Sulham",
          state_id: "3866",
        },
        {
          id: "42225",
          name: "Victoria",
          state_id: "3866",
        },
        {
          id: "42226",
          name: "Walthamstow",
          state_id: "3866",
        },
        {
          id: "42227",
          name: "Wandsworth",
          state_id: "3866",
        },
        {
          id: "42228",
          name: "Wembley",
          state_id: "3866",
        },
        {
          id: "42229",
          name: "Wimbledon",
          state_id: "3866",
        },
        {
          id: "42230",
          name: "Woolwich",
          state_id: "3866",
        },
      ],
      Ludlow: [
        {
          id: "42231",
          name: "Ludlow",
          state_id: "3867",
        },
      ],
      Manchester: [
        {
          id: "42232",
          name: "Manchester",
          state_id: "3868",
        },
        {
          id: "42233",
          name: "Prestwich",
          state_id: "3868",
        },
        {
          id: "42234",
          name: "Salford",
          state_id: "3868",
        },
        {
          id: "42235",
          name: "Swinton",
          state_id: "3868",
        },
        {
          id: "42236",
          name: "Worsley",
          state_id: "3868",
        },
      ],
      Mayfair: [
        {
          id: "42237",
          name: "Mayfair",
          state_id: "3869",
        },
      ],
      Merseyside: [
        {
          id: "42238",
          name: "Southport",
          state_id: "3870",
        },
      ],
      "Mid Glamorgan": [],
      Middlesex: [
        {
          id: "42239",
          name: "Brentford",
          state_id: "3872",
        },
        {
          id: "42240",
          name: "Brimsdown",
          state_id: "3872",
        },
        {
          id: "42241",
          name: "Drayton",
          state_id: "3872",
        },
        {
          id: "42242",
          name: "Edgware",
          state_id: "3872",
        },
        {
          id: "42243",
          name: "Feltham",
          state_id: "3872",
        },
        {
          id: "42244",
          name: "Greenford",
          state_id: "3872",
        },
        {
          id: "42245",
          name: "Hampton",
          state_id: "3872",
        },
        {
          id: "42246",
          name: "Harmondsworth",
          state_id: "3872",
        },
        {
          id: "42247",
          name: "Harrow",
          state_id: "3872",
        },
        {
          id: "42248",
          name: "Hayes",
          state_id: "3872",
        },
        {
          id: "42249",
          name: "Isleworth",
          state_id: "3872",
        },
        {
          id: "42250",
          name: "Northolt",
          state_id: "3872",
        },
        {
          id: "42251",
          name: "Northwood",
          state_id: "3872",
        },
        {
          id: "42252",
          name: "Perivale",
          state_id: "3872",
        },
        {
          id: "42253",
          name: "Pinner",
          state_id: "3872",
        },
        {
          id: "42254",
          name: "Ruislip",
          state_id: "3872",
        },
        {
          id: "42255",
          name: "Ruislip Manor",
          state_id: "3872",
        },
        {
          id: "42256",
          name: "South Harrow",
          state_id: "3872",
        },
        {
          id: "42257",
          name: "Southall",
          state_id: "3872",
        },
        {
          id: "42258",
          name: "Staines",
          state_id: "3872",
        },
        {
          id: "42259",
          name: "Stamore",
          state_id: "3872",
        },
        {
          id: "42260",
          name: "Stanmore",
          state_id: "3872",
        },
        {
          id: "42261",
          name: "Stanwell",
          state_id: "3872",
        },
        {
          id: "42262",
          name: "Sunbury",
          state_id: "3872",
        },
        {
          id: "42263",
          name: "Teddington",
          state_id: "3872",
        },
        {
          id: "42264",
          name: "Twickenham",
          state_id: "3872",
        },
        {
          id: "42265",
          name: "Uxbridge",
          state_id: "3872",
        },
        {
          id: "42266",
          name: "Watford",
          state_id: "3872",
        },
        {
          id: "42267",
          name: "Wembley",
          state_id: "3872",
        },
        {
          id: "42268",
          name: "West Drayton",
          state_id: "3872",
        },
        {
          id: "42269",
          name: "Wraysbury",
          state_id: "3872",
        },
        {
          id: "42270",
          name: "hounslow",
          state_id: "3872",
        },
      ],
      Mildenhall: [
        {
          id: "42271",
          name: "Mildenhall",
          state_id: "3873",
        },
      ],
      Monmouthshire: [
        {
          id: "42272",
          name: "Abergavenny",
          state_id: "3874",
        },
        {
          id: "42273",
          name: "Monmouth",
          state_id: "3874",
        },
      ],
      "Newton Stewart": [],
      Norfolk: [
        {
          id: "42274",
          name: "Attleborough",
          state_id: "3876",
        },
        {
          id: "42275",
          name: "Bacton",
          state_id: "3876",
        },
        {
          id: "42276",
          name: "Briston",
          state_id: "3876",
        },
        {
          id: "42277",
          name: "Dereham",
          state_id: "3876",
        },
        {
          id: "42278",
          name: "Diss",
          state_id: "3876",
        },
        {
          id: "42279",
          name: "Downham Market",
          state_id: "3876",
        },
        {
          id: "42280",
          name: "Fakenham",
          state_id: "3876",
        },
        {
          id: "42281",
          name: "Garboldisham",
          state_id: "3876",
        },
        {
          id: "42282",
          name: "Gayton",
          state_id: "3876",
        },
        {
          id: "42283",
          name: "Glandford",
          state_id: "3876",
        },
        {
          id: "42284",
          name: "Great Yarmouth",
          state_id: "3876",
        },
        {
          id: "42285",
          name: "Heacham",
          state_id: "3876",
        },
        {
          id: "42286",
          name: "Hopton",
          state_id: "3876",
        },
        {
          id: "42287",
          name: "Kings Lynn",
          state_id: "3876",
        },
        {
          id: "42288",
          name: "Little Cressingham",
          state_id: "3876",
        },
        {
          id: "42289",
          name: "Norwich",
          state_id: "3876",
        },
        {
          id: "42290",
          name: "Sheringham",
          state_id: "3876",
        },
        {
          id: "42291",
          name: "Thetford",
          state_id: "3876",
        },
        {
          id: "42292",
          name: "Trunch",
          state_id: "3876",
        },
        {
          id: "42293",
          name: "Winordhan",
          state_id: "3876",
        },
        {
          id: "42294",
          name: "Wymondham",
          state_id: "3876",
        },
      ],
      "North Humberside": [],
      "North Yorkshire": [],
      Northamptonshire: [
        {
          id: "42295",
          name: "Daventry",
          state_id: "3879",
        },
        {
          id: "42296",
          name: "Irthlingborough",
          state_id: "3879",
        },
        {
          id: "42297",
          name: "Middleton Cheney",
          state_id: "3879",
        },
        {
          id: "42298",
          name: "Oundle",
          state_id: "3879",
        },
        {
          id: "42299",
          name: "Towcester",
          state_id: "3879",
        },
        {
          id: "42300",
          name: "Welford",
          state_id: "3879",
        },
        {
          id: "42301",
          name: "Wellingborough",
          state_id: "3879",
        },
        {
          id: "42302",
          name: "Woodford Halse",
          state_id: "3879",
        },
      ],
      Northants: [
        {
          id: "42303",
          name: "Brackley",
          state_id: "3880",
        },
        {
          id: "42304",
          name: "Desborough",
          state_id: "3880",
        },
        {
          id: "42305",
          name: "weedon",
          state_id: "3880",
        },
      ],
      "Northern Ireland": [],
      Northumberland: [
        {
          id: "42306",
          name: "Bedlington",
          state_id: "3882",
        },
        {
          id: "42307",
          name: "Corbridge",
          state_id: "3882",
        },
        {
          id: "42308",
          name: "Cramlington",
          state_id: "3882",
        },
        {
          id: "42309",
          name: "Morpeth",
          state_id: "3882",
        },
        {
          id: "42310",
          name: "Northumberland",
          state_id: "3882",
        },
        {
          id: "42311",
          name: "Ponteland",
          state_id: "3882",
        },
        {
          id: "42312",
          name: "Wooler",
          state_id: "3882",
        },
      ],
      Nottinghamshire: [
        {
          id: "42313",
          name: "Burton Joyce",
          state_id: "3883",
        },
        {
          id: "42314",
          name: "Cotgraves",
          state_id: "3883",
        },
        {
          id: "42315",
          name: "Gonalston",
          state_id: "3883",
        },
        {
          id: "42316",
          name: "Mansfield",
          state_id: "3883",
        },
        {
          id: "42317",
          name: "Newark",
          state_id: "3883",
        },
        {
          id: "42318",
          name: "Nottingham",
          state_id: "3883",
        },
        {
          id: "42319",
          name: "Pennyfoot Street",
          state_id: "3883",
        },
        {
          id: "42320",
          name: "Sandiacre",
          state_id: "3883",
        },
        {
          id: "42321",
          name: "Southwell",
          state_id: "3883",
        },
        {
          id: "42322",
          name: "Whatton",
          state_id: "3883",
        },
      ],
      Oxford: [
        {
          id: "42323",
          name: "Bampton",
          state_id: "3884",
        },
        {
          id: "42324",
          name: "Banbury",
          state_id: "3884",
        },
        {
          id: "42325",
          name: "Bicester",
          state_id: "3884",
        },
        {
          id: "42326",
          name: "Blewbury",
          state_id: "3884",
        },
        {
          id: "42327",
          name: "Cheltenham",
          state_id: "3884",
        },
        {
          id: "42328",
          name: "Chipping Norton",
          state_id: "3884",
        },
        {
          id: "42329",
          name: "Drayton",
          state_id: "3884",
        },
        {
          id: "42330",
          name: "Eynsham",
          state_id: "3884",
        },
        {
          id: "42331",
          name: "Farringdon",
          state_id: "3884",
        },
        {
          id: "42332",
          name: "Henely on Thames",
          state_id: "3884",
        },
        {
          id: "42333",
          name: "Henley-on-Thames",
          state_id: "3884",
        },
        {
          id: "42334",
          name: "Oxford",
          state_id: "3884",
        },
        {
          id: "42335",
          name: "Shenington",
          state_id: "3884",
        },
        {
          id: "42336",
          name: "Thame",
          state_id: "3884",
        },
        {
          id: "42337",
          name: "Wantage",
          state_id: "3884",
        },
      ],
      Powys: [
        {
          id: "42338",
          name: "Builth Wells",
          state_id: "3885",
        },
        {
          id: "42339",
          name: "Knighton",
          state_id: "3885",
        },
        {
          id: "42340",
          name: "Llanbrynmair",
          state_id: "3885",
        },
        {
          id: "42341",
          name: "New town",
          state_id: "3885",
        },
        {
          id: "42342",
          name: "Newtown",
          state_id: "3885",
        },
        {
          id: "42343",
          name: "Rhaeadr",
          state_id: "3885",
        },
        {
          id: "42344",
          name: "Welshpool",
          state_id: "3885",
        },
      ],
      "Roos-shire": [
        {
          id: "42345",
          name: "Hill of Fearn",
          state_id: "3886",
        },
      ],
      SUSSEX: [
        {
          id: "42346",
          name: "Shoreham",
          state_id: "3887",
        },
      ],
      Sark: [
        {
          id: "42347",
          name: "Sark",
          state_id: "3888",
        },
      ],
      Scotland: [
        {
          id: "42348",
          name: "Aberdeen",
          state_id: "3889",
        },
        {
          id: "42349",
          name: "Alloa",
          state_id: "3889",
        },
        {
          id: "42350",
          name: "Alness",
          state_id: "3889",
        },
        {
          id: "42351",
          name: "Annan",
          state_id: "3889",
        },
        {
          id: "42352",
          name: "Arbroath",
          state_id: "3889",
        },
        {
          id: "42353",
          name: "Ardrossan",
          state_id: "3889",
        },
        {
          id: "42354",
          name: "Armadale",
          state_id: "3889",
        },
        {
          id: "42355",
          name: "Ayr",
          state_id: "3889",
        },
        {
          id: "42356",
          name: "Bathgate",
          state_id: "3889",
        },
        {
          id: "42357",
          name: "Blairgowrie",
          state_id: "3889",
        },
        {
          id: "42358",
          name: "Blantyre-Hamilton",
          state_id: "3889",
        },
        {
          id: "42359",
          name: "Boness",
          state_id: "3889",
        },
        {
          id: "42360",
          name: "Bonnybridge",
          state_id: "3889",
        },
        {
          id: "42361",
          name: "Broxburn",
          state_id: "3889",
        },
        {
          id: "42362",
          name: "Broxham",
          state_id: "3889",
        },
        {
          id: "42363",
          name: "Buckhaven",
          state_id: "3889",
        },
        {
          id: "42364",
          name: "Burntisland",
          state_id: "3889",
        },
        {
          id: "42365",
          name: "Carluke",
          state_id: "3889",
        },
        {
          id: "42366",
          name: "Carnoustie",
          state_id: "3889",
        },
        {
          id: "42367",
          name: "Coatbridge",
          state_id: "3889",
        },
        {
          id: "42368",
          name: "Cowdenbeath",
          state_id: "3889",
        },
        {
          id: "42369",
          name: "Cumbernauld",
          state_id: "3889",
        },
        {
          id: "42370",
          name: "Cumnock",
          state_id: "3889",
        },
        {
          id: "42371",
          name: "Cupar",
          state_id: "3889",
        },
        {
          id: "42372",
          name: "Dalbeattie",
          state_id: "3889",
        },
        {
          id: "42373",
          name: "Dalkeith",
          state_id: "3889",
        },
        {
          id: "42374",
          name: "Dingwall",
          state_id: "3889",
        },
        {
          id: "42375",
          name: "Dumbarton",
          state_id: "3889",
        },
        {
          id: "42376",
          name: "Dumfries",
          state_id: "3889",
        },
        {
          id: "42377",
          name: "Dundee",
          state_id: "3889",
        },
        {
          id: "42378",
          name: "Dunfermline",
          state_id: "3889",
        },
        {
          id: "42379",
          name: "Dunoon",
          state_id: "3889",
        },
        {
          id: "42380",
          name: "East Kilbride",
          state_id: "3889",
        },
        {
          id: "42381",
          name: "Edimburah",
          state_id: "3889",
        },
        {
          id: "42382",
          name: "Edinburgh",
          state_id: "3889",
        },
        {
          id: "42383",
          name: "Elgin",
          state_id: "3889",
        },
        {
          id: "42384",
          name: "Ellon",
          state_id: "3889",
        },
        {
          id: "42385",
          name: "Erskine",
          state_id: "3889",
        },
        {
          id: "42386",
          name: "Falkirk",
          state_id: "3889",
        },
        {
          id: "42387",
          name: "Forfar",
          state_id: "3889",
        },
        {
          id: "42388",
          name: "Forres",
          state_id: "3889",
        },
        {
          id: "42389",
          name: "Fort William",
          state_id: "3889",
        },
        {
          id: "42390",
          name: "Fraserburgh",
          state_id: "3889",
        },
        {
          id: "42391",
          name: "Galashiels",
          state_id: "3889",
        },
        {
          id: "42392",
          name: "Galston-Newmilns",
          state_id: "3889",
        },
        {
          id: "42393",
          name: "Girvan",
          state_id: "3889",
        },
        {
          id: "42394",
          name: "Glasgow",
          state_id: "3889",
        },
        {
          id: "42395",
          name: "Glenrothes",
          state_id: "3889",
        },
        {
          id: "42396",
          name: "Greengairs",
          state_id: "3889",
        },
        {
          id: "42397",
          name: "Greenock",
          state_id: "3889",
        },
        {
          id: "42398",
          name: "Haddington",
          state_id: "3889",
        },
        {
          id: "42399",
          name: "Hawick",
          state_id: "3889",
        },
        {
          id: "42400",
          name: "Helensburgh",
          state_id: "3889",
        },
        {
          id: "42401",
          name: "Insch",
          state_id: "3889",
        },
        {
          id: "42402",
          name: "Inverkeithing-Dalgety Bay",
          state_id: "3889",
        },
        {
          id: "42403",
          name: "Inverness",
          state_id: "3889",
        },
        {
          id: "42404",
          name: "Inverurie",
          state_id: "3889",
        },
        {
          id: "42405",
          name: "Irvine",
          state_id: "3889",
        },
        {
          id: "42406",
          name: "Isle of Lewis",
          state_id: "3889",
        },
        {
          id: "42407",
          name: "Kilmarnock",
          state_id: "3889",
        },
        {
          id: "42408",
          name: "Kilsyth",
          state_id: "3889",
        },
        {
          id: "42409",
          name: "Kilwinning",
          state_id: "3889",
        },
        {
          id: "42410",
          name: "Kirkcaldy",
          state_id: "3889",
        },
        {
          id: "42411",
          name: "Kirkintilloch-Lenzie",
          state_id: "3889",
        },
        {
          id: "42412",
          name: "Kirkwall",
          state_id: "3889",
        },
        {
          id: "42413",
          name: "Lanark",
          state_id: "3889",
        },
        {
          id: "42414",
          name: "Largs",
          state_id: "3889",
        },
        {
          id: "42415",
          name: "Larkhall",
          state_id: "3889",
        },
        {
          id: "42416",
          name: "Lerwick",
          state_id: "3889",
        },
        {
          id: "42417",
          name: "Linlithgow",
          state_id: "3889",
        },
        {
          id: "42418",
          name: "Livingston",
          state_id: "3889",
        },
        {
          id: "42419",
          name: "Loanhead",
          state_id: "3889",
        },
        {
          id: "42420",
          name: "Montrose",
          state_id: "3889",
        },
        {
          id: "42421",
          name: "Motherwell",
          state_id: "3889",
        },
        {
          id: "42422",
          name: "Nairn",
          state_id: "3889",
        },
        {
          id: "42423",
          name: "Newtown Saint Boswells",
          state_id: "3889",
        },
        {
          id: "42424",
          name: "Paisley",
          state_id: "3889",
        },
        {
          id: "42425",
          name: "Penicuik",
          state_id: "3889",
        },
        {
          id: "42426",
          name: "Perth",
          state_id: "3889",
        },
        {
          id: "42427",
          name: "Peterhead",
          state_id: "3889",
        },
        {
          id: "42428",
          name: "Saint Andrews",
          state_id: "3889",
        },
        {
          id: "42429",
          name: "Selkirkshire",
          state_id: "3889",
        },
        {
          id: "42430",
          name: "Shotts",
          state_id: "3889",
        },
        {
          id: "42431",
          name: "Stirling",
          state_id: "3889",
        },
        {
          id: "42432",
          name: "Stonehaven",
          state_id: "3889",
        },
        {
          id: "42433",
          name: "Stornoway",
          state_id: "3889",
        },
        {
          id: "42434",
          name: "Stranraer",
          state_id: "3889",
        },
        {
          id: "42435",
          name: "Tranent",
          state_id: "3889",
        },
        {
          id: "42436",
          name: "Troon",
          state_id: "3889",
        },
        {
          id: "42437",
          name: "Whitburn",
          state_id: "3889",
        },
      ],
      "Scottish Borders": [],
      Shropshire: [
        {
          id: "42438",
          name: "Bishops Castle",
          state_id: "3891",
        },
        {
          id: "42439",
          name: "Bridgnorth",
          state_id: "3891",
        },
        {
          id: "42440",
          name: "Bucknell",
          state_id: "3891",
        },
        {
          id: "42441",
          name: "Drayton",
          state_id: "3891",
        },
        {
          id: "42442",
          name: "Greete",
          state_id: "3891",
        },
        {
          id: "42443",
          name: "Hinstock",
          state_id: "3891",
        },
        {
          id: "42444",
          name: "Jackfield",
          state_id: "3891",
        },
        {
          id: "42445",
          name: "Ludlow",
          state_id: "3891",
        },
        {
          id: "42446",
          name: "Much Wenlock",
          state_id: "3891",
        },
        {
          id: "42447",
          name: "Oswestry",
          state_id: "3891",
        },
        {
          id: "42448",
          name: "Ryton",
          state_id: "3891",
        },
        {
          id: "42449",
          name: "Shifnal",
          state_id: "3891",
        },
        {
          id: "42450",
          name: "Shrewsbury",
          state_id: "3891",
        },
        {
          id: "42451",
          name: "Telford",
          state_id: "3891",
        },
        {
          id: "42452",
          name: "Whitchurch",
          state_id: "3891",
        },
      ],
      Somerset: [
        {
          id: "42453",
          name: "Bath",
          state_id: "3892",
        },
        {
          id: "42454",
          name: "Brent Knoll",
          state_id: "3892",
        },
        {
          id: "42455",
          name: "Castle Cary",
          state_id: "3892",
        },
        {
          id: "42456",
          name: "Shepton Mallet",
          state_id: "3892",
        },
        {
          id: "42457",
          name: "Somerset",
          state_id: "3892",
        },
        {
          id: "42458",
          name: "Taunton",
          state_id: "3892",
        },
        {
          id: "42459",
          name: "Wedmore",
          state_id: "3892",
        },
        {
          id: "42460",
          name: "Wellington",
          state_id: "3892",
        },
        {
          id: "42461",
          name: "Weston-super-Mare",
          state_id: "3892",
        },
      ],
      "South Glamorgan": [],
      "South Wales": [],
      "South Yorkshire": [],
      Southwell: [],
      Staffordshire: [
        {
          id: "42462",
          name: "Burton-on-Trent",
          state_id: "3897",
        },
        {
          id: "42463",
          name: "Hednesford",
          state_id: "3897",
        },
        {
          id: "42464",
          name: "Stoke on Trent",
          state_id: "3897",
        },
        {
          id: "42465",
          name: "Stone",
          state_id: "3897",
        },
      ],
      Strabane: [
        {
          id: "42466",
          name: "Strabane",
          state_id: "3898",
        },
      ],
      Suffolk: [
        {
          id: "42467",
          name: "Bury St Edmunds",
          state_id: "3899",
        },
        {
          id: "42468",
          name: "Felixstowe",
          state_id: "3899",
        },
        {
          id: "42469",
          name: "Haverhill",
          state_id: "3899",
        },
        {
          id: "42470",
          name: "Leiston",
          state_id: "3899",
        },
        {
          id: "42471",
          name: "Lowestoft",
          state_id: "3899",
        },
        {
          id: "42472",
          name: "Stowmarket",
          state_id: "3899",
        },
        {
          id: "42473",
          name: "Sudbury",
          state_id: "3899",
        },
        {
          id: "42474",
          name: "Woodbridge",
          state_id: "3899",
        },
      ],
      Surrey: [
        {
          id: "42475",
          name: "Ashtead",
          state_id: "3900",
        },
        {
          id: "42476",
          name: "Bagshot",
          state_id: "3900",
        },
        {
          id: "42477",
          name: "Betchworth",
          state_id: "3900",
        },
        {
          id: "42478",
          name: "Bletchingley",
          state_id: "3900",
        },
        {
          id: "42479",
          name: "Carshalton",
          state_id: "3900",
        },
        {
          id: "42480",
          name: "Chertsey",
          state_id: "3900",
        },
        {
          id: "42481",
          name: "Claygate",
          state_id: "3900",
        },
        {
          id: "42482",
          name: "Croydon",
          state_id: "3900",
        },
        {
          id: "42483",
          name: "Dorking",
          state_id: "3900",
        },
        {
          id: "42484",
          name: "Effingham",
          state_id: "3900",
        },
        {
          id: "42485",
          name: "Epsom",
          state_id: "3900",
        },
        {
          id: "42486",
          name: "Farnham",
          state_id: "3900",
        },
        {
          id: "42487",
          name: "Haslemere",
          state_id: "3900",
        },
        {
          id: "42488",
          name: "Kingston Upon Thames",
          state_id: "3900",
        },
        {
          id: "42489",
          name: "Leatherhead",
          state_id: "3900",
        },
        {
          id: "42490",
          name: "Mitcham",
          state_id: "3900",
        },
        {
          id: "42491",
          name: "New Malden",
          state_id: "3900",
        },
        {
          id: "42492",
          name: "Redhill",
          state_id: "3900",
        },
        {
          id: "42493",
          name: "Richmond",
          state_id: "3900",
        },
        {
          id: "42494",
          name: "Salfords",
          state_id: "3900",
        },
        {
          id: "42495",
          name: "Shepperton",
          state_id: "3900",
        },
        {
          id: "42496",
          name: "Stoneleigh",
          state_id: "3900",
        },
        {
          id: "42497",
          name: "Surbiton",
          state_id: "3900",
        },
        {
          id: "42498",
          name: "Surrey",
          state_id: "3900",
        },
        {
          id: "42499",
          name: "Tadworth",
          state_id: "3900",
        },
        {
          id: "42500",
          name: "Walton on Thames",
          state_id: "3900",
        },
        {
          id: "42501",
          name: "West Molesey",
          state_id: "3900",
        },
        {
          id: "42502",
          name: "Wisley",
          state_id: "3900",
        },
        {
          id: "42503",
          name: "Woking",
          state_id: "3900",
        },
      ],
      Sussex: [
        {
          id: "42504",
          name: "Brighton",
          state_id: "3901",
        },
        {
          id: "42505",
          name: "Henfield",
          state_id: "3901",
        },
        {
          id: "42506",
          name: "Sussex",
          state_id: "3901",
        },
        {
          id: "42507",
          name: "Worthing",
          state_id: "3901",
        },
      ],
      Twickenham: [
        {
          id: "42508",
          name: "Twickenham",
          state_id: "3902",
        },
      ],
      "Tyne and Wear": [],
      Tyrone: [
        {
          id: "42509",
          name: "Omagh",
          state_id: "3904",
        },
      ],
      Utah: [
        {
          id: "42510",
          name: "Santaquin",
          state_id: "3905",
        },
      ],
      Wales: [
        {
          id: "42511",
          name: "Aberdare",
          state_id: "3906",
        },
        {
          id: "42512",
          name: "Aberystwyth",
          state_id: "3906",
        },
        {
          id: "42513",
          name: "Barry",
          state_id: "3906",
        },
        {
          id: "42514",
          name: "Brecon",
          state_id: "3906",
        },
        {
          id: "42515",
          name: "Bridgend",
          state_id: "3906",
        },
        {
          id: "42516",
          name: "Brynmawr",
          state_id: "3906",
        },
        {
          id: "42517",
          name: "Caernarfon",
          state_id: "3906",
        },
        {
          id: "42518",
          name: "Caerphily",
          state_id: "3906",
        },
        {
          id: "42519",
          name: "Caldicot",
          state_id: "3906",
        },
        {
          id: "42520",
          name: "Cardiff",
          state_id: "3906",
        },
        {
          id: "42521",
          name: "Carmarthen",
          state_id: "3906",
        },
        {
          id: "42522",
          name: "Colwyn Bay",
          state_id: "3906",
        },
        {
          id: "42523",
          name: "Connahs Quay",
          state_id: "3906",
        },
        {
          id: "42524",
          name: "Cwmbran",
          state_id: "3906",
        },
        {
          id: "42525",
          name: "Dolgellau",
          state_id: "3906",
        },
        {
          id: "42526",
          name: "Ebbw Vale",
          state_id: "3906",
        },
        {
          id: "42527",
          name: "Gaerwen",
          state_id: "3906",
        },
        {
          id: "42528",
          name: "Gwynedd",
          state_id: "3906",
        },
        {
          id: "42529",
          name: "Haverfordwest",
          state_id: "3906",
        },
        {
          id: "42530",
          name: "Isle of Anglesey",
          state_id: "3906",
        },
        {
          id: "42531",
          name: "Islwyn",
          state_id: "3906",
        },
        {
          id: "42532",
          name: "Llandrindod Wells",
          state_id: "3906",
        },
        {
          id: "42533",
          name: "Llanelli",
          state_id: "3906",
        },
        {
          id: "42534",
          name: "Llangefni",
          state_id: "3906",
        },
        {
          id: "42535",
          name: "Maesteg",
          state_id: "3906",
        },
        {
          id: "42536",
          name: "Merthyr Tydfil",
          state_id: "3906",
        },
        {
          id: "42537",
          name: "Mold",
          state_id: "3906",
        },
        {
          id: "42538",
          name: "Mountain Ash-Abercynon",
          state_id: "3906",
        },
        {
          id: "42539",
          name: "Neath",
          state_id: "3906",
        },
        {
          id: "42540",
          name: "Newport",
          state_id: "3906",
        },
        {
          id: "42541",
          name: "Pembrokeshire",
          state_id: "3906",
        },
        {
          id: "42542",
          name: "Penarth",
          state_id: "3906",
        },
        {
          id: "42543",
          name: "Pencader",
          state_id: "3906",
        },
        {
          id: "42544",
          name: "Pontypool",
          state_id: "3906",
        },
        {
          id: "42545",
          name: "Pontypridd",
          state_id: "3906",
        },
        {
          id: "42546",
          name: "Port Talbot",
          state_id: "3906",
        },
        {
          id: "42547",
          name: "Queensferry",
          state_id: "3906",
        },
        {
          id: "42548",
          name: "Rhondda",
          state_id: "3906",
        },
        {
          id: "42549",
          name: "Rhyl",
          state_id: "3906",
        },
        {
          id: "42550",
          name: "Ruthin",
          state_id: "3906",
        },
        {
          id: "42551",
          name: "Shotton-Hawarden",
          state_id: "3906",
        },
        {
          id: "42552",
          name: "St. Asaph",
          state_id: "3906",
        },
        {
          id: "42553",
          name: "Swansea",
          state_id: "3906",
        },
        {
          id: "42554",
          name: "West Glamorgan",
          state_id: "3906",
        },
        {
          id: "42555",
          name: "Wrexham",
          state_id: "3906",
        },
      ],
      Warwickshire: [
        {
          id: "42556",
          name: "Alcester",
          state_id: "3907",
        },
        {
          id: "42557",
          name: "Coventry",
          state_id: "3907",
        },
        {
          id: "42558",
          name: "Henley in Arden",
          state_id: "3907",
        },
        {
          id: "42559",
          name: "Nuneaton",
          state_id: "3907",
        },
        {
          id: "42560",
          name: "Pershore",
          state_id: "3907",
        },
        {
          id: "42561",
          name: "Southam",
          state_id: "3907",
        },
        {
          id: "42562",
          name: "Warwick",
          state_id: "3907",
        },
      ],
      "West Lothian": [],
      "West Midlands": [],
      "West Sussex": [],
      "West Yorkshire": [],
      Whissendine: [
        {
          id: "42563",
          name: "Whissendine",
          state_id: "3912",
        },
      ],
      Wiltshire: [
        {
          id: "42564",
          name: "Amesbury",
          state_id: "3913",
        },
        {
          id: "42565",
          name: "Bradford on Avon",
          state_id: "3913",
        },
        {
          id: "42566",
          name: "Calne",
          state_id: "3913",
        },
        {
          id: "42567",
          name: "Chippenham",
          state_id: "3913",
        },
        {
          id: "42568",
          name: "Corsham",
          state_id: "3913",
        },
        {
          id: "42569",
          name: "Cosham",
          state_id: "3913",
        },
        {
          id: "42570",
          name: "Devizes",
          state_id: "3913",
        },
        {
          id: "42571",
          name: "Downton",
          state_id: "3913",
        },
        {
          id: "42572",
          name: "Malmesbury",
          state_id: "3913",
        },
        {
          id: "42573",
          name: "Marlborough",
          state_id: "3913",
        },
        {
          id: "42574",
          name: "Melksham",
          state_id: "3913",
        },
        {
          id: "42575",
          name: "Pewsey",
          state_id: "3913",
        },
        {
          id: "42576",
          name: "Salisbury",
          state_id: "3913",
        },
        {
          id: "42577",
          name: "Southwick",
          state_id: "3913",
        },
        {
          id: "42578",
          name: "Swindon",
          state_id: "3913",
        },
        {
          id: "42579",
          name: "Warminster",
          state_id: "3913",
        },
        {
          id: "42580",
          name: "Westbury",
          state_id: "3913",
        },
      ],
      Wokingham: [
        {
          id: "42581",
          name: "Winnersh",
          state_id: "3914",
        },
      ],
      Worcestershire: [
        {
          id: "42582",
          name: "Evesham",
          state_id: "3915",
        },
        {
          id: "42583",
          name: "Hartlebury",
          state_id: "3915",
        },
        {
          id: "42584",
          name: "Kidderminster",
          state_id: "3915",
        },
        {
          id: "42585",
          name: "Pershore",
          state_id: "3915",
        },
        {
          id: "42586",
          name: "Redditch",
          state_id: "3915",
        },
        {
          id: "42587",
          name: "Worcester",
          state_id: "3915",
        },
      ],
      Wrexham: [
        {
          id: "42588",
          name: "Caergwrle",
          state_id: "3916",
        },
        {
          id: "42589",
          name: "Ruabon",
          state_id: "3916",
        },
      ],
      Wurttemberg: [
        {
          id: "42590",
          name: "Neuffen",
          state_id: "3917",
        },
      ],
      Yorkshire: [
        {
          id: "42591",
          name: "Beverley",
          state_id: "3918",
        },
        {
          id: "42592",
          name: "Malton",
          state_id: "3918",
        },
        {
          id: "42593",
          name: "Mexborough",
          state_id: "3918",
        },
      ],
    },
  },
  GD: {
    name: "Grenada",
    native: "Grenada",
    phone: "1473",
    continent: "NA",
    capital: "St. George's",
    currency: "XCD",
    languages: ["en"],
    emoji: "🇬🇩",
    emojiU: "U+1F1EC U+1F1E9",
    states: {
      "Carriacou-Petite Martinique": [],
      "Saint Andrew": [],
      "Saint Davids": [],
      "Saint George''s": [],
      "Saint John": [],
      "Saint Mark": [],
      "Saint Patrick": [],
    },
  },
  GE: {
    name: "Georgia",
    native: "საქართველო",
    phone: "995",
    continent: "AS",
    capital: "Tbilisi",
    currency: "GEL",
    languages: ["ka"],
    emoji: "🇬🇪",
    emojiU: "U+1F1EC U+1F1EA",
    states: {
      Abhasia: [
        {
          id: "18270",
          name: "Ahali Atoni",
          state_id: "1342",
        },
        {
          id: "18271",
          name: "Bihvinta",
          state_id: "1342",
        },
        {
          id: "18272",
          name: "Gagra",
          state_id: "1342",
        },
        {
          id: "18273",
          name: "Gali",
          state_id: "1342",
        },
        {
          id: "18274",
          name: "Gudauta",
          state_id: "1342",
        },
        {
          id: "18275",
          name: "Gulripshi",
          state_id: "1342",
        },
        {
          id: "18276",
          name: "Ochamchira",
          state_id: "1342",
        },
        {
          id: "18277",
          name: "Suhumi",
          state_id: "1342",
        },
        {
          id: "18278",
          name: "Tkvarcheli",
          state_id: "1342",
        },
      ],
      Ajaria: [
        {
          id: "18279",
          name: "Batumi",
          state_id: "1343",
        },
        {
          id: "18280",
          name: "Dioknisi",
          state_id: "1343",
        },
        {
          id: "18281",
          name: "Kobuleti",
          state_id: "1343",
        },
        {
          id: "18282",
          name: "Mahindzhauri",
          state_id: "1343",
        },
      ],
      Guria: [
        {
          id: "18283",
          name: "Lanchhuti",
          state_id: "1344",
        },
        {
          id: "18284",
          name: "Ozurgeti",
          state_id: "1344",
        },
      ],
      Imereti: [
        {
          id: "18285",
          name: "Bagdadi",
          state_id: "1345",
        },
        {
          id: "18286",
          name: "Chaltubo",
          state_id: "1345",
        },
        {
          id: "18287",
          name: "Chiatura",
          state_id: "1345",
        },
        {
          id: "18288",
          name: "Honi",
          state_id: "1345",
        },
        {
          id: "18289",
          name: "Kutaisi",
          state_id: "1345",
        },
        {
          id: "18290",
          name: "Sachhere",
          state_id: "1345",
        },
        {
          id: "18291",
          name: "Samtredia",
          state_id: "1345",
        },
        {
          id: "18292",
          name: "Terzhola",
          state_id: "1345",
        },
        {
          id: "18293",
          name: "Tkibuli",
          state_id: "1345",
        },
        {
          id: "18294",
          name: "Vani",
          state_id: "1345",
        },
        {
          id: "18295",
          name: "Zestaponi",
          state_id: "1345",
        },
      ],
      Kaheti: [
        {
          id: "18296",
          name: "Ahmeta",
          state_id: "1346",
        },
        {
          id: "18297",
          name: "Cnori",
          state_id: "1346",
        },
        {
          id: "18298",
          name: "Dedoplisckaro",
          state_id: "1346",
        },
        {
          id: "18299",
          name: "Gurdzhaani",
          state_id: "1346",
        },
        {
          id: "18300",
          name: "Kvareli",
          state_id: "1346",
        },
        {
          id: "18301",
          name: "Lagodehi",
          state_id: "1346",
        },
        {
          id: "18302",
          name: "Sagaredzho",
          state_id: "1346",
        },
        {
          id: "18303",
          name: "Signahi",
          state_id: "1346",
        },
        {
          id: "18304",
          name: "Telavi",
          state_id: "1346",
        },
      ],
      "Kvemo Kartli": [],
      "Mcheta-Mtianeti": [
        {
          id: "18305",
          name: "Dusheti",
          state_id: "1348",
        },
        {
          id: "18306",
          name: "Mcheta",
          state_id: "1348",
        },
      ],
      Racha: [
        {
          id: "18307",
          name: "Ambrolauri",
          state_id: "1349",
        },
        {
          id: "18308",
          name: "Cageri",
          state_id: "1349",
        },
        {
          id: "18309",
          name: "Oni",
          state_id: "1349",
        },
      ],
      "Samagrelo-Zemo Svaneti": [],
      "Samche-Zhavaheti": [
        {
          id: "18310",
          name: "Ahalcihe",
          state_id: "1351",
        },
        {
          id: "18311",
          name: "Ahalkalaki",
          state_id: "1351",
        },
        {
          id: "18312",
          name: "Borzhomi",
          state_id: "1351",
        },
        {
          id: "18313",
          name: "Ninocminda",
          state_id: "1351",
        },
        {
          id: "18314",
          name: "Vale",
          state_id: "1351",
        },
      ],
      "Shida Kartli": [],
      Tbilisi: [
        {
          id: "18315",
          name: "Tbilisi",
          state_id: "1353",
        },
      ],
    },
  },
  GF: {
    name: "French Guiana",
    native: "Guyane française",
    phone: "594",
    continent: "SA",
    capital: "Cayenne",
    currency: "EUR",
    languages: ["fr"],
    emoji: "🇬🇫",
    emojiU: "U+1F1EC U+1F1EB",
    states: {
      Cayenne: [
        {
          id: "18138",
          name: "Camopi",
          state_id: "1315",
        },
        {
          id: "18139",
          name: "Cayenne",
          state_id: "1315",
        },
        {
          id: "18140",
          name: "Iracoubo",
          state_id: "1315",
        },
        {
          id: "18141",
          name: "Kourou",
          state_id: "1315",
        },
        {
          id: "18142",
          name: "Macouria",
          state_id: "1315",
        },
        {
          id: "18143",
          name: "Matoury",
          state_id: "1315",
        },
        {
          id: "18144",
          name: "Remire-Montjoly",
          state_id: "1315",
        },
        {
          id: "18145",
          name: "Roura",
          state_id: "1315",
        },
        {
          id: "18146",
          name: "Saint-Georges",
          state_id: "1315",
        },
        {
          id: "18147",
          name: "Sinnamary",
          state_id: "1315",
        },
      ],
      "Saint-Laurent-du-Maroni": [
        {
          id: "18148",
          name: "Apatou",
          state_id: "1316",
        },
        {
          id: "18149",
          name: "Grand-Santi",
          state_id: "1316",
        },
        {
          id: "18150",
          name: "Mana",
          state_id: "1316",
        },
        {
          id: "18151",
          name: "Maripasoula",
          state_id: "1316",
        },
        {
          id: "18152",
          name: "Saint-Laurent-du-Maroni",
          state_id: "1316",
        },
      ],
    },
  },
  GG: {
    name: "Guernsey",
    native: "Guernsey",
    phone: "44",
    continent: "EU",
    capital: "St. Peter Port",
    currency: "GBP",
    languages: ["en", "fr"],
    emoji: "🇬🇬",
    emojiU: "U+1F1EC U+1F1EC",
    states: {},
  },
  GH: {
    name: "Ghana",
    native: "Ghana",
    phone: "233",
    continent: "AF",
    capital: "Accra",
    currency: "GHS",
    languages: ["en"],
    emoji: "🇬🇭",
    emojiU: "U+1F1EC U+1F1ED",
    states: {
      Ashanti: [
        {
          id: "20367",
          name: "Agogo",
          state_id: "1401",
        },
        {
          id: "20368",
          name: "Bekwai",
          state_id: "1401",
        },
        {
          id: "20369",
          name: "Konongo",
          state_id: "1401",
        },
        {
          id: "20370",
          name: "Kumasi",
          state_id: "1401",
        },
        {
          id: "20371",
          name: "Mampong",
          state_id: "1401",
        },
        {
          id: "20372",
          name: "Mankranso",
          state_id: "1401",
        },
        {
          id: "20373",
          name: "Obuasi",
          state_id: "1401",
        },
        {
          id: "20374",
          name: "Ofinso",
          state_id: "1401",
        },
        {
          id: "20375",
          name: "Tafo",
          state_id: "1401",
        },
      ],
      "Brong-Ahafo": [
        {
          id: "20376",
          name: "Bechem",
          state_id: "1402",
        },
        {
          id: "20377",
          name: "Berekum",
          state_id: "1402",
        },
        {
          id: "20378",
          name: "Duayaw Nkwanta",
          state_id: "1402",
        },
        {
          id: "20379",
          name: "Kintampo",
          state_id: "1402",
        },
        {
          id: "20380",
          name: "Sunyani",
          state_id: "1402",
        },
        {
          id: "20381",
          name: "Techiman",
          state_id: "1402",
        },
        {
          id: "20382",
          name: "Wenchi",
          state_id: "1402",
        },
      ],
      Central: [
        {
          id: "20383",
          name: "Apam",
          state_id: "1403",
        },
        {
          id: "20384",
          name: "Cape Coast",
          state_id: "1403",
        },
        {
          id: "20385",
          name: "Dunkwa",
          state_id: "1403",
        },
        {
          id: "20386",
          name: "Elmina",
          state_id: "1403",
        },
        {
          id: "20387",
          name: "Foso",
          state_id: "1403",
        },
        {
          id: "20388",
          name: "Komenda",
          state_id: "1403",
        },
        {
          id: "20389",
          name: "Mauri",
          state_id: "1403",
        },
        {
          id: "20390",
          name: "Mumford",
          state_id: "1403",
        },
        {
          id: "20391",
          name: "Nyakrom",
          state_id: "1403",
        },
        {
          id: "20392",
          name: "Okitsiu",
          state_id: "1403",
        },
        {
          id: "20393",
          name: "Saltpond",
          state_id: "1403",
        },
        {
          id: "20394",
          name: "Swedru",
          state_id: "1403",
        },
        {
          id: "20395",
          name: "Winneba",
          state_id: "1403",
        },
      ],
      Eastern: [
        {
          id: "20396",
          name: "Aburi",
          state_id: "1404",
        },
        {
          id: "20397",
          name: "Ada",
          state_id: "1404",
        },
        {
          id: "20398",
          name: "Akim Swedru",
          state_id: "1404",
        },
        {
          id: "20399",
          name: "Akropong",
          state_id: "1404",
        },
        {
          id: "20400",
          name: "Asamankese",
          state_id: "1404",
        },
        {
          id: "20401",
          name: "Begoro",
          state_id: "1404",
        },
        {
          id: "20402",
          name: "Kade",
          state_id: "1404",
        },
        {
          id: "20403",
          name: "Kibi",
          state_id: "1404",
        },
        {
          id: "20404",
          name: "Koforidua",
          state_id: "1404",
        },
        {
          id: "20405",
          name: "Mpraeso",
          state_id: "1404",
        },
        {
          id: "20406",
          name: "Nkawkaw",
          state_id: "1404",
        },
        {
          id: "20407",
          name: "Nsawam",
          state_id: "1404",
        },
        {
          id: "20408",
          name: "Oda",
          state_id: "1404",
        },
        {
          id: "20409",
          name: "Somanya",
          state_id: "1404",
        },
        {
          id: "20410",
          name: "Suhum",
          state_id: "1404",
        },
      ],
      "Greater Accra": [
        {
          id: "123",
          name: "Accra",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Ada Foah",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Sege",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Adenta",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Ashaiman",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Sowutuom",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Abokobi",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Weija",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Amasaman",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Kapone",
          state_id: "1405",
        },
        {
          id: "123",
          name: "La",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Madina",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Nungua",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Prampram",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Dodowa",
          state_id: "1405",
        },
        {
          id: "123",
          name: "Tema",
          state_id: "1405",
        },
      ],
      Northern: [
        {
          id: "20411",
          name: "Kpandae",
          state_id: "1406",
        },
        {
          id: "20412",
          name: "Salaga",
          state_id: "1406",
        },
        {
          id: "20413",
          name: "Savelugu",
          state_id: "1406",
        },
        {
          id: "20414",
          name: "Tamale",
          state_id: "1406",
        },
        {
          id: "20415",
          name: "Yendi",
          state_id: "1406",
        },
      ],
      "Upper East": [],
      "Upper West": [],
      Volta: [
        {
          id: "20416",
          name: "Aflao",
          state_id: "1409",
        },
        {
          id: "20417",
          name: "Anloga",
          state_id: "1409",
        },
        {
          id: "20418",
          name: "Ho",
          state_id: "1409",
        },
        {
          id: "20419",
          name: "Hohoe",
          state_id: "1409",
        },
        {
          id: "20420",
          name: "Keta",
          state_id: "1409",
        },
        {
          id: "20421",
          name: "Kete-Krachi",
          state_id: "1409",
        },
        {
          id: "20422",
          name: "Kpandu",
          state_id: "1409",
        },
      ],
      Western: [
        {
          id: "20423",
          name: "Aboso",
          state_id: "1410",
        },
        {
          id: "20424",
          name: "Anomabu",
          state_id: "1410",
        },
        {
          id: "20425",
          name: "Axim",
          state_id: "1410",
        },
        {
          id: "20426",
          name: "Bibiani",
          state_id: "1410",
        },
        {
          id: "20427",
          name: "Prestea",
          state_id: "1410",
        },
        {
          id: "20428",
          name: "Sekondi",
          state_id: "1410",
        },
        {
          id: "20429",
          name: "Shama",
          state_id: "1410",
        },
        {
          id: "20430",
          name: "Takoradi",
          state_id: "1410",
        },
        {
          id: "20431",
          name: "Tarkwa",
          state_id: "1410",
        },
      ],
    },
  },
  GI: {
    name: "Gibraltar",
    native: "Gibraltar",
    phone: "350",
    continent: "EU",
    capital: "Gibraltar",
    currency: "GIP",
    languages: ["en"],
    emoji: "🇬🇮",
    emojiU: "U+1F1EC U+1F1EE",
    states: {
      Gibraltar: [
        {
          id: "20432",
          name: "Gibraltar",
          state_id: "1411",
        },
      ],
    },
  },
  GL: {
    name: "Greenland",
    native: "Kalaallit Nunaat",
    phone: "299",
    continent: "NA",
    capital: "Nuuk",
    currency: "DKK",
    languages: ["kl"],
    emoji: "🇬🇱",
    emojiU: "U+1F1EC U+1F1F1",
    states: {
      Aasiaat: [
        {
          id: "20570",
          name: "Aasiaat",
          state_id: "1474",
        },
        {
          id: "20571",
          name: "Akunnaaq",
          state_id: "1474",
        },
        {
          id: "20572",
          name: "Kitsissuarsuit",
          state_id: "1474",
        },
      ],
      Ammassalik: [
        {
          id: "20573",
          name: "Ikkatteq",
          state_id: "1475",
        },
        {
          id: "20574",
          name: "Isortoq",
          state_id: "1475",
        },
        {
          id: "20575",
          name: "Kulusuk",
          state_id: "1475",
        },
        {
          id: "20576",
          name: "Kuumiut",
          state_id: "1475",
        },
        {
          id: "20577",
          name: "Qernertuarssuit",
          state_id: "1475",
        },
        {
          id: "20578",
          name: "Sermiligaaq",
          state_id: "1475",
        },
        {
          id: "20579",
          name: "Tasiilaq",
          state_id: "1475",
        },
        {
          id: "20580",
          name: "Tiniteqilaaq",
          state_id: "1475",
        },
      ],
      Illoqqortoormiut: [
        {
          id: "20581",
          name: "Illoqqortoormiut",
          state_id: "1476",
        },
        {
          id: "20582",
          name: "Itterajivit",
          state_id: "1476",
        },
        {
          id: "20583",
          name: "Uunarteq",
          state_id: "1476",
        },
      ],
      Ilulissat: [
        {
          id: "20584",
          name: "Ilimanaq",
          state_id: "1477",
        },
        {
          id: "20585",
          name: "Ilulissat",
          state_id: "1477",
        },
        {
          id: "20586",
          name: "Oqaatsut",
          state_id: "1477",
        },
        {
          id: "20587",
          name: "Qeqertaq",
          state_id: "1477",
        },
        {
          id: "20588",
          name: "Saqqaq",
          state_id: "1477",
        },
      ],
      Ivittuut: [
        {
          id: "20589",
          name: "Ivittuut",
          state_id: "1478",
        },
        {
          id: "20590",
          name: "Kangilinnguit",
          state_id: "1478",
        },
      ],
      Kangaatsiaq: [
        {
          id: "20591",
          name: "Attu",
          state_id: "1479",
        },
        {
          id: "20592",
          name: "Iginniarfik",
          state_id: "1479",
        },
        {
          id: "20593",
          name: "Ikerasaarsuk",
          state_id: "1479",
        },
        {
          id: "20594",
          name: "Kangaatsiaq",
          state_id: "1479",
        },
        {
          id: "20595",
          name: "Niaqornaarsuk",
          state_id: "1479",
        },
      ],
      Maniitsoq: [
        {
          id: "20596",
          name: "Atammik",
          state_id: "1480",
        },
        {
          id: "20597",
          name: "Kangaamiut",
          state_id: "1480",
        },
        {
          id: "20598",
          name: "Maniitsoq",
          state_id: "1480",
        },
        {
          id: "20599",
          name: "Napasoq",
          state_id: "1480",
        },
      ],
      Nanortalik: [
        {
          id: "20600",
          name: "Aappilattoq",
          state_id: "1481",
        },
        {
          id: "20601",
          name: "Akuliaruseq",
          state_id: "1481",
        },
        {
          id: "20602",
          name: "Alluitsoq",
          state_id: "1481",
        },
        {
          id: "20603",
          name: "Alluitsup Paa",
          state_id: "1481",
        },
        {
          id: "20604",
          name: "Ammassivik",
          state_id: "1481",
        },
        {
          id: "20605",
          name: "Ikerasassuaq",
          state_id: "1481",
        },
        {
          id: "20606",
          name: "Nanortalik",
          state_id: "1481",
        },
        {
          id: "20607",
          name: "Narsarmijit",
          state_id: "1481",
        },
        {
          id: "20608",
          name: "Nuugaarsuk",
          state_id: "1481",
        },
        {
          id: "20609",
          name: "Qallimiut",
          state_id: "1481",
        },
        {
          id: "20610",
          name: "Qortortorsuaq",
          state_id: "1481",
        },
        {
          id: "20611",
          name: "Tasiusaq",
          state_id: "1481",
        },
      ],
      Narsaq: [
        {
          id: "20612",
          name: "Amannguit",
          state_id: "1482",
        },
        {
          id: "20613",
          name: "Atarnaatsoq",
          state_id: "1482",
        },
        {
          id: "20614",
          name: "Eqaluit Ilua",
          state_id: "1482",
        },
        {
          id: "20615",
          name: "Igaliku",
          state_id: "1482",
        },
        {
          id: "20616",
          name: "Igaliku Kujalleq",
          state_id: "1482",
        },
        {
          id: "20617",
          name: "Inneruulalik",
          state_id: "1482",
        },
        {
          id: "20618",
          name: "Issormiut",
          state_id: "1482",
        },
        {
          id: "20619",
          name: "Iterlak",
          state_id: "1482",
        },
        {
          id: "20620",
          name: "Kangerlua",
          state_id: "1482",
        },
        {
          id: "20621",
          name: "Narsaq",
          state_id: "1482",
        },
        {
          id: "20622",
          name: "Narsarsuaq",
          state_id: "1482",
        },
        {
          id: "20623",
          name: "Nunataaq",
          state_id: "1482",
        },
        {
          id: "20624",
          name: "Qassiarsuk",
          state_id: "1482",
        },
        {
          id: "20625",
          name: "Qinngua",
          state_id: "1482",
        },
        {
          id: "20626",
          name: "Qinngua Kangilleq",
          state_id: "1482",
        },
        {
          id: "20627",
          name: "Qolortup Itinnera",
          state_id: "1482",
        },
        {
          id: "20628",
          name: "Sillisit",
          state_id: "1482",
        },
        {
          id: "20629",
          name: "Tasiusaq",
          state_id: "1482",
        },
        {
          id: "20630",
          name: "Timerliit",
          state_id: "1482",
        },
        {
          id: "20631",
          name: "Uummannartuuaraq",
          state_id: "1482",
        },
      ],
      Nuuk: [
        {
          id: "20632",
          name: "Kangerluarsoruseq",
          state_id: "1483",
        },
        {
          id: "20633",
          name: "Kapisillit",
          state_id: "1483",
        },
        {
          id: "20634",
          name: "Neriunaq",
          state_id: "1483",
        },
        {
          id: "20635",
          name: "Nuuk",
          state_id: "1483",
        },
        {
          id: "20636",
          name: "Qeqertarsuatsiaat",
          state_id: "1483",
        },
        {
          id: "20637",
          name: "Qooqqut",
          state_id: "1483",
        },
        {
          id: "20638",
          name: "Qoornoq",
          state_id: "1483",
        },
      ],
      Paamiut: [
        {
          id: "20639",
          name: "Arsuk",
          state_id: "1484",
        },
        {
          id: "20640",
          name: "Paamiut",
          state_id: "1484",
        },
      ],
      Qaanaaq: [
        {
          id: "20641",
          name: "Moriusaq",
          state_id: "1485",
        },
        {
          id: "20642",
          name: "Qaanaaq",
          state_id: "1485",
        },
        {
          id: "20643",
          name: "Qeqertarsuaq",
          state_id: "1485",
        },
        {
          id: "20644",
          name: "Qeqertat",
          state_id: "1485",
        },
        {
          id: "20645",
          name: "Savissivik",
          state_id: "1485",
        },
        {
          id: "20646",
          name: "Siorapaluk",
          state_id: "1485",
        },
      ],
      Qaqortoq: [
        {
          id: "20647",
          name: "Eqalugaarsuit",
          state_id: "1486",
        },
        {
          id: "20648",
          name: "Illorsuit",
          state_id: "1486",
        },
        {
          id: "20649",
          name: "Kangerluarsorujuk",
          state_id: "1486",
        },
        {
          id: "20650",
          name: "Kangerluarsorujuup Qinngua",
          state_id: "1486",
        },
        {
          id: "20651",
          name: "Qanisartuut",
          state_id: "1486",
        },
        {
          id: "20652",
          name: "Qaqortokolook",
          state_id: "1486",
        },
        {
          id: "20653",
          name: "Qaqortoq",
          state_id: "1486",
        },
        {
          id: "20654",
          name: "Qassimiut",
          state_id: "1486",
        },
        {
          id: "20655",
          name: "Saarloq",
          state_id: "1486",
        },
        {
          id: "20656",
          name: "Saqqamiut",
          state_id: "1486",
        },
        {
          id: "20657",
          name: "Tasiluk",
          state_id: "1486",
        },
        {
          id: "20658",
          name: "Upernaviarsuk",
          state_id: "1486",
        },
      ],
      Qasigiannguit: [
        {
          id: "20659",
          name: "Ikamiut",
          state_id: "1487",
        },
        {
          id: "20660",
          name: "Qasigiannguit",
          state_id: "1487",
        },
      ],
      Qeqertarsuaq: [
        {
          id: "20661",
          name: "Kangerluk",
          state_id: "1488",
        },
        {
          id: "20662",
          name: "Qeqertarsuaq",
          state_id: "1488",
        },
      ],
      Sisimiut: [
        {
          id: "20663",
          name: "Itilleq",
          state_id: "1489",
        },
        {
          id: "20664",
          name: "Kangerlussuaq",
          state_id: "1489",
        },
        {
          id: "20665",
          name: "Sarfannguit",
          state_id: "1489",
        },
        {
          id: "20666",
          name: "Sisimiut",
          state_id: "1489",
        },
      ],
      "Udenfor kommunal inddeling": [],
      Upernavik: [
        {
          id: "20667",
          name: "Aappilattoq",
          state_id: "1491",
        },
        {
          id: "20668",
          name: "Ikerakuuk",
          state_id: "1491",
        },
        {
          id: "20669",
          name: "Innarsuit",
          state_id: "1491",
        },
        {
          id: "20670",
          name: "Kangersuatsiaq",
          state_id: "1491",
        },
        {
          id: "20671",
          name: "Kullorsuaq",
          state_id: "1491",
        },
        {
          id: "20672",
          name: "Naajaat",
          state_id: "1491",
        },
        {
          id: "20673",
          name: "Nutaarmiut",
          state_id: "1491",
        },
        {
          id: "20674",
          name: "Nuusuaq",
          state_id: "1491",
        },
        {
          id: "20675",
          name: "Tasiusaq",
          state_id: "1491",
        },
        {
          id: "20676",
          name: "Upernavik",
          state_id: "1491",
        },
      ],
      Uummannaq: [
        {
          id: "20678",
          name: "Ikerasak",
          state_id: "1492",
        },
        {
          id: "20679",
          name: "Illorsuit",
          state_id: "1492",
        },
        {
          id: "20680",
          name: "Niaqornat",
          state_id: "1492",
        },
        {
          id: "20681",
          name: "Nuugaatsiaq",
          state_id: "1492",
        },
        {
          id: "20682",
          name: "Qaarsut",
          state_id: "1492",
        },
        {
          id: "20683",
          name: "Saattut",
          state_id: "1492",
        },
        {
          id: "20684",
          name: "Ukkusissat",
          state_id: "1492",
        },
        {
          id: "20685",
          name: "Uummannaq",
          state_id: "1492",
        },
      ],
    },
  },
  GM: {
    name: "Gambia",
    native: "Gambia",
    phone: "220",
    continent: "AF",
    capital: "Banjul",
    currency: "GMD",
    languages: ["en"],
    emoji: "🇬🇲",
    emojiU: "U+1F1EC U+1F1F2",
    states: {
      Banjul: [
        {
          id: "18250",
          name: "Banjul",
          state_id: "1334",
        },
      ],
      Basse: [
        {
          id: "18251",
          name: "Basse",
          state_id: "1335",
        },
        {
          id: "18252",
          name: "Gambissara",
          state_id: "1335",
        },
        {
          id: "18253",
          name: "Sabi",
          state_id: "1335",
        },
        {
          id: "18254",
          name: "Salikeni",
          state_id: "1335",
        },
      ],
      Brikama: [
        {
          id: "18255",
          name: "Brikama",
          state_id: "1336",
        },
        {
          id: "18256",
          name: "Brufut",
          state_id: "1336",
        },
        {
          id: "18257",
          name: "Gunjur",
          state_id: "1336",
        },
        {
          id: "18258",
          name: "Sukuta",
          state_id: "1336",
        },
      ],
      Janjanbureh: [
        {
          id: "18259",
          name: "Bansang",
          state_id: "1337",
        },
        {
          id: "18260",
          name: "Janjanbureh",
          state_id: "1337",
        },
      ],
      Kanifing: [
        {
          id: "18261",
          name: "Bakau",
          state_id: "1338",
        },
        {
          id: "18262",
          name: "Serekunda",
          state_id: "1338",
        },
      ],
      Kerewan: [
        {
          id: "18263",
          name: "Barra",
          state_id: "1339",
        },
        {
          id: "18264",
          name: "Essau",
          state_id: "1339",
        },
        {
          id: "18265",
          name: "Farafenni",
          state_id: "1339",
        },
        {
          id: "18266",
          name: "Kerewan",
          state_id: "1339",
        },
        {
          id: "18267",
          name: "Lamin",
          state_id: "1339",
        },
      ],
      Kuntaur: [
        {
          id: "18268",
          name: "Kuntaur",
          state_id: "1340",
        },
      ],
      Mansakonko: [
        {
          id: "18269",
          name: "Mansakonko",
          state_id: "1341",
        },
      ],
    },
  },
  GN: {
    name: "Guinea",
    native: "Guinée",
    phone: "224",
    continent: "AF",
    capital: "Conakry",
    currency: "GNF",
    languages: ["fr", "ff"],
    emoji: "🇬🇳",
    emojiU: "U+1F1EC U+1F1F3",
    states: {
      Beyla: [
        {
          id: "20774",
          name: "Beyla",
          state_id: "1557",
        },
      ],
      Boffa: [
        {
          id: "20775",
          name: "Boffa",
          state_id: "1558",
        },
      ],
      Boke: [
        {
          id: "20776",
          name: "Boke",
          state_id: "1559",
        },
      ],
      Conakry: [
        {
          id: "20777",
          name: "Conakry",
          state_id: "1560",
        },
      ],
      Coyah: [
        {
          id: "20778",
          name: "Coyah",
          state_id: "1561",
        },
      ],
      Dabola: [
        {
          id: "20779",
          name: "Dabola",
          state_id: "1562",
        },
      ],
      Dalaba: [
        {
          id: "20780",
          name: "Dalaba",
          state_id: "1563",
        },
      ],
      Dinguiraye: [
        {
          id: "20781",
          name: "Dinguiraye",
          state_id: "1564",
        },
      ],
      Faranah: [
        {
          id: "20782",
          name: "Faranah",
          state_id: "1565",
        },
      ],
      Forecariah: [
        {
          id: "20783",
          name: "Forecariah",
          state_id: "1566",
        },
      ],
      Fria: [
        {
          id: "20784",
          name: "Fria",
          state_id: "1567",
        },
      ],
      Gaoual: [
        {
          id: "20785",
          name: "Gaoual",
          state_id: "1568",
        },
      ],
      Gueckedou: [
        {
          id: "20786",
          name: "Guekedou",
          state_id: "1569",
        },
      ],
      Kankan: [
        {
          id: "20787",
          name: "Kankan",
          state_id: "1570",
        },
      ],
      Kerouane: [
        {
          id: "20788",
          name: "Kerouane",
          state_id: "1571",
        },
      ],
      Kindia: [
        {
          id: "20789",
          name: "Kindia",
          state_id: "1572",
        },
      ],
      Kissidougou: [
        {
          id: "20790",
          name: "Kissidougou",
          state_id: "1573",
        },
      ],
      Koubia: [
        {
          id: "20791",
          name: "Koubia",
          state_id: "1574",
        },
      ],
      Koundara: [
        {
          id: "20792",
          name: "Koundara",
          state_id: "1575",
        },
      ],
      Kouroussa: [
        {
          id: "20793",
          name: "Kouroussa",
          state_id: "1576",
        },
      ],
      Labe: [
        {
          id: "20794",
          name: "Labe",
          state_id: "1577",
        },
      ],
      Lola: [
        {
          id: "20795",
          name: "Lola",
          state_id: "1578",
        },
      ],
      Macenta: [
        {
          id: "20796",
          name: "Macenta",
          state_id: "1579",
        },
      ],
      Mali: [
        {
          id: "20797",
          name: "Mali",
          state_id: "1580",
        },
      ],
      Mamou: [
        {
          id: "20798",
          name: "Mamou",
          state_id: "1581",
        },
      ],
      Mandiana: [
        {
          id: "20799",
          name: "Mandiana",
          state_id: "1582",
        },
      ],
      Nzerekore: [
        {
          id: "20800",
          name: "Nzerekore",
          state_id: "1583",
        },
      ],
      Pita: [
        {
          id: "20801",
          name: "Pita",
          state_id: "1584",
        },
      ],
      Siguiri: [
        {
          id: "20802",
          name: "Siguiri",
          state_id: "1585",
        },
      ],
      Telimele: [
        {
          id: "20803",
          name: "Telimele",
          state_id: "1586",
        },
      ],
      Tougue: [
        {
          id: "20804",
          name: "Tougue",
          state_id: "1587",
        },
      ],
      Yomou: [
        {
          id: "20805",
          name: "Yomou",
          state_id: "1588",
        },
      ],
    },
  },
  GP: {
    name: "Guadeloupe",
    native: "Guadeloupe",
    phone: "590",
    continent: "NA",
    capital: "Basse-Terre",
    currency: "EUR",
    languages: ["fr"],
    emoji: "🇬🇵",
    emojiU: "U+1F1EC U+1F1F5",
    states: {
      "Basse-Terre": [
        {
          id: "20686",
          name: "Baie-Mahault",
          state_id: "1500",
        },
        {
          id: "20687",
          name: "Baillif",
          state_id: "1500",
        },
        {
          id: "20688",
          name: "Basse-Terre",
          state_id: "1500",
        },
        {
          id: "20689",
          name: "Bouillante",
          state_id: "1500",
        },
        {
          id: "20690",
          name: "Capesterre-Belle-Eau",
          state_id: "1500",
        },
        {
          id: "20691",
          name: "Gourbeyre",
          state_id: "1500",
        },
        {
          id: "20692",
          name: "Lamentin",
          state_id: "1500",
        },
        {
          id: "20693",
          name: "Petit-Bourg",
          state_id: "1500",
        },
        {
          id: "20694",
          name: "Pointe-Noire",
          state_id: "1500",
        },
        {
          id: "20695",
          name: "Saint-Claude",
          state_id: "1500",
        },
        {
          id: "20696",
          name: "Sainte-Rose",
          state_id: "1500",
        },
        {
          id: "20697",
          name: "Trois-Rivieres",
          state_id: "1500",
        },
        {
          id: "20698",
          name: "Vieux-Habitants",
          state_id: "1500",
        },
      ],
      "Grande-Terre": [
        {
          id: "20699",
          name: "Anse-Bertrand",
          state_id: "1501",
        },
        {
          id: "20700",
          name: "Le Gosier",
          state_id: "1501",
        },
        {
          id: "20701",
          name: "Le Moule",
          state_id: "1501",
        },
        {
          id: "20702",
          name: "Les Abymes",
          state_id: "1501",
        },
        {
          id: "20703",
          name: "Morne-a-l''Eau",
          state_id: "1501",
        },
        {
          id: "20704",
          name: "Petit-Canal",
          state_id: "1501",
        },
        {
          id: "20705",
          name: "Point-a-Pitre",
          state_id: "1501",
        },
        {
          id: "20706",
          name: "Port-Louis",
          state_id: "1501",
        },
        {
          id: "20707",
          name: "Saint-Francois",
          state_id: "1501",
        },
        {
          id: "20708",
          name: "Sainte-Anne",
          state_id: "1501",
        },
      ],
      "Iles des Saintes": [],
      "La Desirade": [],
      "Marie-Galante": [
        {
          id: "20709",
          name: "Grand-Bourg",
          state_id: "1504",
        },
      ],
      "Saint Barthelemy": [],
      "Saint Martin": [],
    },
  },
  GQ: {
    name: "Equatorial Guinea",
    native: "Guinea Ecuatorial",
    phone: "240",
    continent: "AF",
    capital: "Malabo",
    currency: "XAF",
    languages: ["es", "fr"],
    emoji: "🇬🇶",
    emojiU: "U+1F1EC U+1F1F6",
    states: {
      Annobon: [
        {
          id: "15658",
          name: "Pale",
          state_id: "1091",
        },
      ],
      "Bioko Norte": [],
      "Bioko Sur": [],
      "Centro Sur": [],
      "Kie-Ntem": [
        {
          id: "15659",
          name: "Ebebiyin",
          state_id: "1095",
        },
        {
          id: "15660",
          name: "Mikomeseng",
          state_id: "1095",
        },
      ],
      Litoral: [
        {
          id: "15661",
          name: "Bata",
          state_id: "1096",
        },
        {
          id: "15662",
          name: "Mbini",
          state_id: "1096",
        },
      ],
      "Wele-Nzas": [
        {
          id: "15663",
          name: "Aconibe",
          state_id: "1097",
        },
        {
          id: "15664",
          name: "Anisoc",
          state_id: "1097",
        },
        {
          id: "15665",
          name: "Mongomo",
          state_id: "1097",
        },
        {
          id: "15666",
          name: "Nsok",
          state_id: "1097",
        },
      ],
    },
  },
  GR: {
    name: "Greece",
    native: "Ελλάδα",
    phone: "30",
    continent: "EU",
    capital: "Athens",
    currency: "EUR",
    languages: ["el"],
    emoji: "🇬🇷",
    emojiU: "U+1F1EC U+1F1F7",
    states: {
      Acharnes: [
        {
          id: "20433",
          name: "Elassonos",
          state_id: "1412",
        },
      ],
      Ahaia: [
        {
          id: "20434",
          name: "Aiyion",
          state_id: "1413",
        },
        {
          id: "20435",
          name: "Patra",
          state_id: "1413",
        },
      ],
      "Aitolia kai Akarnania": [],
      Argolis: [
        {
          id: "20436",
          name: "Argos",
          state_id: "1415",
        },
        {
          id: "20437",
          name: "Navplion",
          state_id: "1415",
        },
      ],
      Arkadia: [
        {
          id: "20438",
          name: "Tripoli",
          state_id: "1416",
        },
      ],
      Arta: [
        {
          id: "20439",
          name: "Arta",
          state_id: "1417",
        },
      ],
      Attica: [
        {
          id: "20440",
          name: "Acharnes",
          state_id: "1418",
        },
        {
          id: "20441",
          name: "Agios Ioannis Rentis",
          state_id: "1418",
        },
        {
          id: "20442",
          name: "Drapetsona",
          state_id: "1418",
        },
        {
          id: "20443",
          name: "Koropi",
          state_id: "1418",
        },
        {
          id: "20444",
          name: "Lavrion",
          state_id: "1418",
        },
        {
          id: "20445",
          name: "Mandra",
          state_id: "1418",
        },
        {
          id: "20446",
          name: "Spata",
          state_id: "1418",
        },
      ],
      Attiki: [
        {
          id: "20447",
          name: "Aharna",
          state_id: "1419",
        },
        {
          id: "20448",
          name: "Aiyaleo",
          state_id: "1419",
        },
        {
          id: "20449",
          name: "Alimos",
          state_id: "1419",
        },
        {
          id: "20450",
          name: "Amarousion",
          state_id: "1419",
        },
        {
          id: "20451",
          name: "Ano Liosia",
          state_id: "1419",
        },
        {
          id: "20452",
          name: "Aryiroupoli",
          state_id: "1419",
        },
        {
          id: "20453",
          name: "Aspropirgos",
          state_id: "1419",
        },
        {
          id: "20454",
          name: "Athina",
          state_id: "1419",
        },
        {
          id: "20455",
          name: "Athinai",
          state_id: "1419",
        },
        {
          id: "20456",
          name: "Ayia Barbara",
          state_id: "1419",
        },
        {
          id: "20457",
          name: "Ayia Paraskevi",
          state_id: "1419",
        },
        {
          id: "20458",
          name: "Ayios Anaryiros",
          state_id: "1419",
        },
        {
          id: "20459",
          name: "Ayios Dimitrios",
          state_id: "1419",
        },
        {
          id: "20460",
          name: "Dafne",
          state_id: "1419",
        },
        {
          id: "20461",
          name: "Elevsis",
          state_id: "1419",
        },
        {
          id: "20462",
          name: "Ellenikon",
          state_id: "1419",
        },
        {
          id: "20463",
          name: "Galatsion",
          state_id: "1419",
        },
        {
          id: "20464",
          name: "Glifada",
          state_id: "1419",
        },
        {
          id: "20465",
          name: "Haidarion",
          state_id: "1419",
        },
        {
          id: "20466",
          name: "Halandrion",
          state_id: "1419",
        },
        {
          id: "20467",
          name: "Holargos",
          state_id: "1419",
        },
        {
          id: "20468",
          name: "Ilioupoli",
          state_id: "1419",
        },
        {
          id: "20469",
          name: "Iraklion",
          state_id: "1419",
        },
        {
          id: "20470",
          name: "Kaisariani",
          state_id: "1419",
        },
        {
          id: "20471",
          name: "Kallithea",
          state_id: "1419",
        },
        {
          id: "20472",
          name: "Kamateron",
          state_id: "1419",
        },
        {
          id: "20473",
          name: "Keratea",
          state_id: "1419",
        },
        {
          id: "20474",
          name: "Keratsinion",
          state_id: "1419",
        },
        {
          id: "20475",
          name: "Kifisia",
          state_id: "1419",
        },
        {
          id: "20476",
          name: "Koridallos",
          state_id: "1419",
        },
        {
          id: "20477",
          name: "Kropion",
          state_id: "1419",
        },
        {
          id: "20478",
          name: "Markopoulos Mesogaia",
          state_id: "1419",
        },
        {
          id: "20479",
          name: "Maroussi",
          state_id: "1419",
        },
        {
          id: "20480",
          name: "Megara",
          state_id: "1419",
        },
        {
          id: "20481",
          name: "Melission",
          state_id: "1419",
        },
        {
          id: "20482",
          name: "Metamorfosios",
          state_id: "1419",
        },
        {
          id: "20483",
          name: "Moshatos",
          state_id: "1419",
        },
        {
          id: "20484",
          name: "Nea Filedelfia",
          state_id: "1419",
        },
        {
          id: "20485",
          name: "Nea Ionia",
          state_id: "1419",
        },
        {
          id: "20486",
          name: "Nea Liosia",
          state_id: "1419",
        },
        {
          id: "20487",
          name: "Nea Smirni",
          state_id: "1419",
        },
        {
          id: "20488",
          name: "Nikaia",
          state_id: "1419",
        },
        {
          id: "20489",
          name: "Palaion Faliron",
          state_id: "1419",
        },
        {
          id: "20490",
          name: "Perama",
          state_id: "1419",
        },
        {
          id: "20491",
          name: "Peristerion",
          state_id: "1419",
        },
        {
          id: "20492",
          name: "Petroupoli",
          state_id: "1419",
        },
        {
          id: "20493",
          name: "Pevka",
          state_id: "1419",
        },
        {
          id: "20494",
          name: "Piraeus",
          state_id: "1419",
        },
        {
          id: "20495",
          name: "Salamis",
          state_id: "1419",
        },
        {
          id: "20496",
          name: "Tavros",
          state_id: "1419",
        },
        {
          id: "20497",
          name: "Viron",
          state_id: "1419",
        },
        {
          id: "20498",
          name: "Voula",
          state_id: "1419",
        },
        {
          id: "20499",
          name: "Vrilission",
          state_id: "1419",
        },
        {
          id: "20500",
          name: "Zografos",
          state_id: "1419",
        },
      ],
      "Ayion Oros": [],
      Crete: [
        {
          id: "20501",
          name: "Heraklion",
          state_id: "1421",
        },
      ],
      Dodekanisos: [
        {
          id: "20502",
          name: "Arhangelos",
          state_id: "1422",
        },
        {
          id: "20503",
          name: "Ialysos",
          state_id: "1422",
        },
        {
          id: "20504",
          name: "Kos",
          state_id: "1422",
        },
        {
          id: "20505",
          name: "Rodos",
          state_id: "1422",
        },
      ],
      Drama: [
        {
          id: "20506",
          name: "Drama",
          state_id: "1423",
        },
      ],
      Evia: [
        {
          id: "20507",
          name: "Chalkis",
          state_id: "1424",
        },
      ],
      Evritania: [
        {
          id: "20508",
          name: "Karpenisi",
          state_id: "1425",
        },
      ],
      Evros: [
        {
          id: "20509",
          name: "Alexandroupoli",
          state_id: "1426",
        },
        {
          id: "20510",
          name: "Orestias",
          state_id: "1426",
        },
      ],
      Evvoia: [
        {
          id: "20511",
          name: "Halkida",
          state_id: "1427",
        },
      ],
      Florina: [
        {
          id: "20512",
          name: "Florina",
          state_id: "1428",
        },
      ],
      Fokis: [
        {
          id: "20513",
          name: "Amfissa",
          state_id: "1429",
        },
      ],
      Fthiotis: [
        {
          id: "20514",
          name: "Lamia",
          state_id: "1430",
        },
      ],
      Grevena: [
        {
          id: "20515",
          name: "Grevena",
          state_id: "1431",
        },
      ],
      Halandri: [
        {
          id: "20516",
          name: "Halandri",
          state_id: "1432",
        },
      ],
      Halkidiki: [
        {
          id: "20517",
          name: "Lakkoma",
          state_id: "1433",
        },
        {
          id: "20518",
          name: "N. Kallikrateia",
          state_id: "1433",
        },
        {
          id: "20519",
          name: "Poliyiros",
          state_id: "1433",
        },
      ],
      Hania: [
        {
          id: "20520",
          name: "Hania",
          state_id: "1434",
        },
      ],
      Heraklion: [
        {
          id: "20521",
          name: "Crete",
          state_id: "1435",
        },
      ],
      Hios: [
        {
          id: "20522",
          name: "Hios",
          state_id: "1436",
        },
      ],
      Ilia: [
        {
          id: "20523",
          name: "Pirgos",
          state_id: "1437",
        },
      ],
      Imathia: [
        {
          id: "20524",
          name: "Veroia",
          state_id: "1438",
        },
      ],
      Ioannina: [
        {
          id: "20525",
          name: "Ioannina",
          state_id: "1439",
        },
      ],
      Iraklion: [],
      Karditsa: [
        {
          id: "20526",
          name: "Karditsa",
          state_id: "1441",
        },
      ],
      Kastoria: [
        {
          id: "20527",
          name: "Kastoria",
          state_id: "1442",
        },
      ],
      Kavala: [
        {
          id: "20528",
          name: "Kavala",
          state_id: "1443",
        },
      ],
      Kefallinia: [
        {
          id: "20529",
          name: "Agioi Theodoroi",
          state_id: "1444",
        },
        {
          id: "20530",
          name: "Argostolion",
          state_id: "1444",
        },
      ],
      Kerkira: [
        {
          id: "20531",
          name: "Kerkira",
          state_id: "1445",
        },
      ],
      Kiklades: [
        {
          id: "20532",
          name: "Ermoupoli",
          state_id: "1446",
        },
        {
          id: "20533",
          name: "Fira",
          state_id: "1446",
        },
        {
          id: "20534",
          name: "Mikonos",
          state_id: "1446",
        },
      ],
      Kilkis: [
        {
          id: "20535",
          name: "Kilkis",
          state_id: "1447",
        },
      ],
      Korinthia: [
        {
          id: "20536",
          name: "Korinthos",
          state_id: "1448",
        },
      ],
      Kozani: [
        {
          id: "20537",
          name: "Kozani",
          state_id: "1449",
        },
        {
          id: "20538",
          name: "Ptolemais",
          state_id: "1449",
        },
      ],
      Lakonia: [
        {
          id: "20539",
          name: "Sparti",
          state_id: "1450",
        },
      ],
      Larisa: [
        {
          id: "20540",
          name: "Larisa",
          state_id: "1451",
        },
        {
          id: "20541",
          name: "Larissa",
          state_id: "1451",
        },
      ],
      Lasithi: [
        {
          id: "20542",
          name: "Ayios Nikolaos",
          state_id: "1452",
        },
        {
          id: "20543",
          name: "Ierapetra",
          state_id: "1452",
        },
        {
          id: "20544",
          name: "Sitia",
          state_id: "1452",
        },
      ],
      Lesvos: [
        {
          id: "20545",
          name: "Mitilini",
          state_id: "1453",
        },
      ],
      Levkas: [
        {
          id: "20546",
          name: "Levkas",
          state_id: "1454",
        },
      ],
      Magnisia: [
        {
          id: "20547",
          name: "Volos",
          state_id: "1455",
        },
      ],
      Messinia: [
        {
          id: "20548",
          name: "Kalamata",
          state_id: "1456",
        },
      ],
      "Nomos Attikis": [],
      "Nomos Zakynthou": [],
      Pella: [
        {
          id: "20549",
          name: "Edessa",
          state_id: "1459",
        },
        {
          id: "20550",
          name: "Yiannitsa",
          state_id: "1459",
        },
      ],
      Pieria: [
        {
          id: "20551",
          name: "Katerini",
          state_id: "1460",
        },
      ],
      Piraios: [
        {
          id: "20552",
          name: "Acharne",
          state_id: "1461",
        },
        {
          id: "20553",
          name: "Pallini",
          state_id: "1461",
        },
      ],
      Preveza: [
        {
          id: "20554",
          name: "Preveza",
          state_id: "1462",
        },
      ],
      Rethimni: [
        {
          id: "20555",
          name: "Rethimnon",
          state_id: "1463",
        },
      ],
      Rodopi: [
        {
          id: "20556",
          name: "Komotini",
          state_id: "1464",
        },
      ],
      Samos: [
        {
          id: "20557",
          name: "Samos",
          state_id: "1465",
        },
      ],
      Serrai: [
        {
          id: "20558",
          name: "Serrai",
          state_id: "1466",
        },
      ],
      Thesprotia: [
        {
          id: "20559",
          name: "Igoumenitsa",
          state_id: "1467",
        },
      ],
      Thessaloniki: [
        {
          id: "20560",
          name: "Ampelokipa",
          state_id: "1468",
        },
        {
          id: "20561",
          name: "Kalamaria",
          state_id: "1468",
        },
        {
          id: "20562",
          name: "Neapoli",
          state_id: "1468",
        },
        {
          id: "20563",
          name: "Oristiada",
          state_id: "1468",
        },
        {
          id: "20564",
          name: "Thessaloniki",
          state_id: "1468",
        },
      ],
      Trikala: [
        {
          id: "20565",
          name: "Trikala",
          state_id: "1469",
        },
      ],
      Voiotia: [
        {
          id: "20566",
          name: "Levadia",
          state_id: "1470",
        },
        {
          id: "20567",
          name: "Thivai",
          state_id: "1470",
        },
      ],
      "West Greece": [],
      Xanthi: [
        {
          id: "20568",
          name: "Xanthi",
          state_id: "1472",
        },
      ],
      Zakinthos: [
        {
          id: "20569",
          name: "Zakinthos",
          state_id: "1473",
        },
      ],
    },
  },
  GS: {
    name: "South Georgia and the South Sandwich Islands",
    native: "South Georgia",
    phone: "500",
    continent: "AN",
    capital: "King Edward Point",
    currency: "GBP",
    languages: ["en"],
    emoji: "🇬🇸",
    emojiU: "U+1F1EC U+1F1F8",
    states: {
      "South Georgia": [],
    },
  },
  GT: {
    name: "Guatemala",
    native: "Guatemala",
    phone: "502",
    continent: "NA",
    capital: "Guatemala City",
    currency: "GTQ",
    languages: ["es"],
    emoji: "🇬🇹",
    emojiU: "U+1F1EC U+1F1F9",
    states: {
      "Alta Verapaz": [],
      "Baja Verapaz": [],
      Chimaltenango: [
        {
          id: "20731",
          name: "Chimaltenango",
          state_id: "1525",
        },
        {
          id: "20732",
          name: "Comalapa",
          state_id: "1525",
        },
        {
          id: "20733",
          name: "Itzapa",
          state_id: "1525",
        },
        {
          id: "20734",
          name: "Patzun",
          state_id: "1525",
        },
      ],
      Chiquimula: [
        {
          id: "20735",
          name: "Chiquimula",
          state_id: "1526",
        },
        {
          id: "20736",
          name: "Esquipulas",
          state_id: "1526",
        },
      ],
      "El Progreso": [],
      Escuintla: [
        {
          id: "20737",
          name: "Cotzumalguapa",
          state_id: "1528",
        },
        {
          id: "20738",
          name: "Escuintla",
          state_id: "1528",
        },
        {
          id: "20739",
          name: "Palin",
          state_id: "1528",
        },
        {
          id: "20740",
          name: "San Jose",
          state_id: "1528",
        },
        {
          id: "20741",
          name: "Tiquisate",
          state_id: "1528",
        },
      ],
      Guatemala: [
        {
          id: "20742",
          name: "Amatitlan",
          state_id: "1529",
        },
        {
          id: "20743",
          name: "Chinautla",
          state_id: "1529",
        },
        {
          id: "20744",
          name: "Guatemala",
          state_id: "1529",
        },
        {
          id: "20745",
          name: "Mixco",
          state_id: "1529",
        },
        {
          id: "20746",
          name: "Petapa",
          state_id: "1529",
        },
        {
          id: "20747",
          name: "Villa Nueva",
          state_id: "1529",
        },
      ],
      Huehuetenango: [
        {
          id: "20748",
          name: "Huehuetenango",
          state_id: "1530",
        },
      ],
      Izabal: [
        {
          id: "20749",
          name: "Puerto Barrios",
          state_id: "1531",
        },
      ],
      Jalapa: [
        {
          id: "20750",
          name: "Jalapa",
          state_id: "1532",
        },
      ],
      Jutiapa: [
        {
          id: "20751",
          name: "Asuncion Mita",
          state_id: "1533",
        },
        {
          id: "20752",
          name: "Jutiapa",
          state_id: "1533",
        },
      ],
      Peten: [
        {
          id: "20753",
          name: "Flores",
          state_id: "1534",
        },
        {
          id: "20754",
          name: "San Benito",
          state_id: "1534",
        },
      ],
      Quezaltenango: [
        {
          id: "20755",
          name: "Quezaltenango",
          state_id: "1535",
        },
      ],
      Quiche: [
        {
          id: "20756",
          name: "Quiche",
          state_id: "1536",
        },
      ],
      Retalhuleu: [
        {
          id: "20757",
          name: "Retalhuleu",
          state_id: "1537",
        },
      ],
      Sacatepequez: [
        {
          id: "20758",
          name: "Antigua",
          state_id: "1538",
        },
        {
          id: "20759",
          name: "Ciudad Vieja",
          state_id: "1538",
        },
        {
          id: "20760",
          name: "Jocotenango",
          state_id: "1538",
        },
        {
          id: "20761",
          name: "Santa Maria de Jesus",
          state_id: "1538",
        },
        {
          id: "20762",
          name: "Sumpango",
          state_id: "1538",
        },
      ],
      "San Marcos": [],
      "Santa Rosa": [],
      Solola: [
        {
          id: "20763",
          name: "Atitlan",
          state_id: "1541",
        },
        {
          id: "20764",
          name: "Solola",
          state_id: "1541",
        },
      ],
      Suchitepequez: [
        {
          id: "20765",
          name: "Mazatenango",
          state_id: "1542",
        },
      ],
      Totonicapan: [
        {
          id: "20766",
          name: "Totonicapan",
          state_id: "1543",
        },
      ],
      Zacapa: [
        {
          id: "20767",
          name: "Zacapa",
          state_id: "1544",
        },
      ],
    },
  },
  GU: {
    name: "Guam",
    native: "Guam",
    phone: "1671",
    continent: "OC",
    capital: "Hagåtña",
    currency: "USD",
    languages: ["en", "ch", "es"],
    emoji: "🇬🇺",
    emojiU: "U+1F1EC U+1F1FA",
    states: {
      "Agana Heights": [],
      Agat: [
        {
          id: "20710",
          name: "Agat",
          state_id: "1508",
        },
      ],
      Barrigada: [
        {
          id: "20711",
          name: "Barrigada",
          state_id: "1509",
        },
        {
          id: "20712",
          name: "Barrigada Heights",
          state_id: "1509",
        },
      ],
      "Chalan-Pago-Ordot": [
        {
          id: "20713",
          name: "Chalan Pago",
          state_id: "1510",
        },
        {
          id: "20714",
          name: "Ordot",
          state_id: "1510",
        },
      ],
      Dededo: [
        {
          id: "20715",
          name: "Astumbo",
          state_id: "1511",
        },
        {
          id: "20716",
          name: "Dededo",
          state_id: "1511",
        },
        {
          id: "20717",
          name: "Finegayan Station",
          state_id: "1511",
        },
      ],
      Hagatna: [
        {
          id: "20718",
          name: "Agana",
          state_id: "1512",
        },
        {
          id: "20719",
          name: "Agana Station",
          state_id: "1512",
        },
      ],
      Inarajan: [
        {
          id: "20720",
          name: "Inarajan",
          state_id: "1513",
        },
      ],
      Mangilao: [
        {
          id: "20721",
          name: "Mangilao",
          state_id: "1514",
        },
      ],
      Merizo: [
        {
          id: "20722",
          name: "Merizo",
          state_id: "1515",
        },
      ],
      "Mongmong-Toto-Maite": [
        {
          id: "20723",
          name: "Mongmong",
          state_id: "1516",
        },
        {
          id: "20724",
          name: "Toto",
          state_id: "1516",
        },
      ],
      "Santa Rita": [],
      Sinajana: [
        {
          id: "20725",
          name: "Sinajana",
          state_id: "1518",
        },
      ],
      Talofofo: [
        {
          id: "20726",
          name: "Talofofo",
          state_id: "1519",
        },
      ],
      Tamuning: [
        {
          id: "20727",
          name: "Tamuning",
          state_id: "1520",
        },
      ],
      Yigo: [
        {
          id: "20728",
          name: "Anderson Air Force Base",
          state_id: "1521",
        },
        {
          id: "20729",
          name: "Yigo",
          state_id: "1521",
        },
      ],
      Yona: [
        {
          id: "20730",
          name: "Yona",
          state_id: "1522",
        },
      ],
    },
  },
  GW: {
    name: "Guinea-Bissau",
    native: "Guiné-Bissau",
    phone: "245",
    continent: "AF",
    capital: "Bissau",
    currency: "XOF",
    languages: ["pt"],
    emoji: "🇬🇼",
    emojiU: "U+1F1EC U+1F1FC",
    states: {
      Bafata: [
        {
          id: "20806",
          name: "Bafata",
          state_id: "1589",
        },
      ],
      Bissau: [
        {
          id: "20807",
          name: "Bissau",
          state_id: "1590",
        },
      ],
      Bolama: [
        {
          id: "20808",
          name: "Bolama",
          state_id: "1591",
        },
        {
          id: "20809",
          name: "Bubaque",
          state_id: "1591",
        },
      ],
      Cacheu: [
        {
          id: "20810",
          name: "Cacheu",
          state_id: "1592",
        },
        {
          id: "20811",
          name: "Canchungo",
          state_id: "1592",
        },
      ],
      Gabu: [
        {
          id: "20812",
          name: "Gabu",
          state_id: "1593",
        },
      ],
      Oio: [
        {
          id: "20813",
          name: "Bissora",
          state_id: "1594",
        },
        {
          id: "20814",
          name: "Farim",
          state_id: "1594",
        },
        {
          id: "20815",
          name: "Mansoa",
          state_id: "1594",
        },
      ],
      Quinara: [
        {
          id: "20816",
          name: "Buba",
          state_id: "1595",
        },
        {
          id: "20817",
          name: "Fulacunda",
          state_id: "1595",
        },
        {
          id: "20818",
          name: "Quebo",
          state_id: "1595",
        },
      ],
      Tombali: [
        {
          id: "20819",
          name: "Catio",
          state_id: "1596",
        },
      ],
    },
  },
  GY: {
    name: "Guyana",
    native: "Guyana",
    phone: "592",
    continent: "SA",
    capital: "Georgetown",
    currency: "GYD",
    languages: ["en"],
    emoji: "🇬🇾",
    emojiU: "U+1F1EC U+1F1FE",
    states: {
      "Barima-Waini": [
        {
          id: "20820",
          name: "Mabaruma",
          state_id: "1597",
        },
        {
          id: "20821",
          name: "Morawhanna",
          state_id: "1597",
        },
      ],
      "Cuyuni-Mazaruni": [
        {
          id: "20822",
          name: "Bartica",
          state_id: "1598",
        },
        {
          id: "20823",
          name: "Issano",
          state_id: "1598",
        },
        {
          id: "20824",
          name: "Kamarang",
          state_id: "1598",
        },
      ],
      "Demerara-Mahaica": [
        {
          id: "20825",
          name: "Georgetown",
          state_id: "1599",
        },
        {
          id: "20826",
          name: "Mahaica",
          state_id: "1599",
        },
        {
          id: "20827",
          name: "Paradise",
          state_id: "1599",
        },
        {
          id: "20828",
          name: "Queenstown",
          state_id: "1599",
        },
      ],
      "East Berbice-Corentyne": [],
      "Essequibo Islands-West Demerar": [],
      "Mahaica-Berbice": [
        {
          id: "20829",
          name: "Fort Wellington",
          state_id: "1602",
        },
        {
          id: "20830",
          name: "Mahaicony",
          state_id: "1602",
        },
        {
          id: "20831",
          name: "Rosignol",
          state_id: "1602",
        },
      ],
      "Pomeroon-Supenaam": [
        {
          id: "20832",
          name: "Anna Regina",
          state_id: "1603",
        },
        {
          id: "20833",
          name: "Charity",
          state_id: "1603",
        },
        {
          id: "20834",
          name: "Suddie",
          state_id: "1603",
        },
      ],
      "Potaro-Siparuni": [
        {
          id: "20835",
          name: "Mahdia",
          state_id: "1604",
        },
        {
          id: "20836",
          name: "Tumatumari",
          state_id: "1604",
        },
      ],
      "Upper Demerara-Berbice": [],
      "Upper Takutu-Upper Essequibo": [],
    },
  },
  HK: {
    name: "Hong Kong",
    native: "香港",
    phone: "852",
    continent: "AS",
    capital: "City of Victoria",
    currency: "HKD",
    languages: ["zh", "en"],
    emoji: "🇭🇰",
    emojiU: "U+1F1ED U+1F1F0",
    states: {
      "Hong Kong": [],
    },
  },
  HM: {
    name: "Heard Island and McDonald Islands",
    native: "Heard Island and McDonald Islands",
    phone: "61",
    continent: "AN",
    capital: "",
    currency: "AUD",
    languages: ["en"],
    emoji: "🇭🇲",
    emojiU: "U+1F1ED U+1F1F2",
    states: {
      "Heard and McDonald Islands": [],
    },
  },
  HN: {
    name: "Honduras",
    native: "Honduras",
    phone: "504",
    continent: "NA",
    capital: "Tegucigalpa",
    currency: "HNL",
    languages: ["es"],
    emoji: "🇭🇳",
    emojiU: "U+1F1ED U+1F1F3",
    states: {
      Atlantida: [
        {
          id: "20875",
          name: "La Ceiba",
          state_id: "1617",
        },
        {
          id: "20876",
          name: "Olanchito",
          state_id: "1617",
        },
        {
          id: "20877",
          name: "Tela",
          state_id: "1617",
        },
      ],
      Choluteca: [
        {
          id: "20878",
          name: "Choluteca",
          state_id: "1618",
        },
        {
          id: "20879",
          name: "El Triunfo",
          state_id: "1618",
        },
        {
          id: "20880",
          name: "Pespire",
          state_id: "1618",
        },
      ],
      Colon: [
        {
          id: "20881",
          name: "Sonaguera",
          state_id: "1619",
        },
        {
          id: "20882",
          name: "Tocoa",
          state_id: "1619",
        },
        {
          id: "20883",
          name: "Trujillo",
          state_id: "1619",
        },
      ],
      Comayagua: [
        {
          id: "20884",
          name: "Comayagua",
          state_id: "1620",
        },
        {
          id: "20885",
          name: "Siguatepeque",
          state_id: "1620",
        },
      ],
      Copan: [
        {
          id: "20886",
          name: "Copan",
          state_id: "1621",
        },
        {
          id: "20887",
          name: "Corquin",
          state_id: "1621",
        },
        {
          id: "20888",
          name: "Dulce Nombre",
          state_id: "1621",
        },
        {
          id: "20889",
          name: "El Paraiso",
          state_id: "1621",
        },
        {
          id: "20890",
          name: "San Antonio",
          state_id: "1621",
        },
        {
          id: "20891",
          name: "San Nicolas",
          state_id: "1621",
        },
        {
          id: "20892",
          name: "Santa Rosa de Copan",
          state_id: "1621",
        },
      ],
      Cortes: [
        {
          id: "20893",
          name: "Choloma",
          state_id: "1622",
        },
        {
          id: "20894",
          name: "La Lima",
          state_id: "1622",
        },
        {
          id: "20895",
          name: "Omoa",
          state_id: "1622",
        },
        {
          id: "20896",
          name: "Puerto Cortes",
          state_id: "1622",
        },
        {
          id: "20897",
          name: "San Pedro Sula",
          state_id: "1622",
        },
      ],
      "Distrito Central": [],
      "El Paraiso": [],
      "Francisco Morazan": [],
      "Gracias a Dios": [],
      Intibuca: [
        {
          id: "20898",
          name: "Intibuca",
          state_id: "1627",
        },
        {
          id: "20899",
          name: "La Esperanza",
          state_id: "1627",
        },
        {
          id: "20900",
          name: "Utila",
          state_id: "1627",
        },
      ],
      "Islas de la Bahia": [],
      "La Paz": [],
      Lempira: [
        {
          id: "20901",
          name: "Gracias",
          state_id: "1630",
        },
      ],
      Ocotepeque: [
        {
          id: "20902",
          name: "Ocotepeque",
          state_id: "1631",
        },
        {
          id: "20903",
          name: "San Marcos",
          state_id: "1631",
        },
        {
          id: "20904",
          name: "Sinuapa",
          state_id: "1631",
        },
      ],
      Olancho: [
        {
          id: "20905",
          name: "Catacamas",
          state_id: "1632",
        },
        {
          id: "20906",
          name: "Juticalpa",
          state_id: "1632",
        },
      ],
      "Santa Barbara": [],
      Valle: [
        {
          id: "20907",
          name: "Amapala",
          state_id: "1634",
        },
        {
          id: "20908",
          name: "Langue",
          state_id: "1634",
        },
        {
          id: "20909",
          name: "Nacaome",
          state_id: "1634",
        },
        {
          id: "20910",
          name: "San Lorenzo",
          state_id: "1634",
        },
      ],
      Yoro: [
        {
          id: "20911",
          name: "El Progreso",
          state_id: "1635",
        },
        {
          id: "20912",
          name: "Morazan",
          state_id: "1635",
        },
        {
          id: "20913",
          name: "Santa Rita",
          state_id: "1635",
        },
        {
          id: "20914",
          name: "Yoro",
          state_id: "1635",
        },
      ],
    },
  },
  HR: {
    name: "Croatia",
    native: "Hrvatska",
    phone: "385",
    continent: "EU",
    capital: "Zagreb",
    currency: "HRK",
    languages: ["hr"],
    emoji: "🇭🇷",
    emojiU: "U+1F1ED U+1F1F7",
    states: {
      "Bjelovar-Bilogora": [
        {
          id: "13918",
          name: "Bjelovar",
          state_id: "870",
        },
        {
          id: "13919",
          name: "Brezovac",
          state_id: "870",
        },
        {
          id: "13920",
          name: "Chazma",
          state_id: "870",
        },
        {
          id: "13921",
          name: "Daruvar",
          state_id: "870",
        },
        {
          id: "13922",
          name: "Daruvarski Brestovac",
          state_id: "870",
        },
        {
          id: "13923",
          name: "Dezhanovac",
          state_id: "870",
        },
        {
          id: "13924",
          name: "Dhulovac",
          state_id: "870",
        },
        {
          id: "13925",
          name: "Gareshnica",
          state_id: "870",
        },
        {
          id: "13926",
          name: "Gareshnichki Brestovac",
          state_id: "870",
        },
        {
          id: "13927",
          name: "Grubishno Polje",
          state_id: "870",
        },
        {
          id: "13928",
          name: "Gudovac",
          state_id: "870",
        },
        {
          id: "13929",
          name: "Hercegovac",
          state_id: "870",
        },
        {
          id: "13930",
          name: "Ivanska",
          state_id: "870",
        },
        {
          id: "13931",
          name: "Klokochevac",
          state_id: "870",
        },
        {
          id: "13932",
          name: "Konchanica",
          state_id: "870",
        },
        {
          id: "13933",
          name: "Predavac",
          state_id: "870",
        },
        {
          id: "13934",
          name: "Rovishce",
          state_id: "870",
        },
        {
          id: "13935",
          name: "Shandrovac",
          state_id: "870",
        },
        {
          id: "13936",
          name: "Sirach",
          state_id: "870",
        },
        {
          id: "13937",
          name: "Trojstveni Markovac",
          state_id: "870",
        },
        {
          id: "13938",
          name: "Velika Pisanica",
          state_id: "870",
        },
        {
          id: "13939",
          name: "Veliki Grdhevac",
          state_id: "870",
        },
        {
          id: "13940",
          name: "Veliki Zdenci",
          state_id: "870",
        },
        {
          id: "13941",
          name: "Veliko Trojstvo",
          state_id: "870",
        },
        {
          id: "13942",
          name: "Zhdralovi",
          state_id: "870",
        },
      ],
      "Dubrovnik-Neretva": [
        {
          id: "13943",
          name: "Blato",
          state_id: "871",
        },
        {
          id: "13944",
          name: "Cavtat",
          state_id: "871",
        },
        {
          id: "13945",
          name: "Chibacha",
          state_id: "871",
        },
        {
          id: "13946",
          name: "Chilipi",
          state_id: "871",
        },
        {
          id: "13947",
          name: "Dubrovnik",
          state_id: "871",
        },
        {
          id: "13948",
          name: "Komin",
          state_id: "871",
        },
        {
          id: "13949",
          name: "Korchula",
          state_id: "871",
        },
        {
          id: "13950",
          name: "Lumbarda",
          state_id: "871",
        },
        {
          id: "13951",
          name: "Metkovic",
          state_id: "871",
        },
        {
          id: "13952",
          name: "Mlini",
          state_id: "871",
        },
        {
          id: "13953",
          name: "Mokoshica",
          state_id: "871",
        },
        {
          id: "13954",
          name: "Nova Mokoshica",
          state_id: "871",
        },
        {
          id: "13955",
          name: "Opuzen",
          state_id: "871",
        },
        {
          id: "13956",
          name: "Orebic",
          state_id: "871",
        },
        {
          id: "13957",
          name: "Otrich-Seoci",
          state_id: "871",
        },
        {
          id: "13958",
          name: "Ploche",
          state_id: "871",
        },
        {
          id: "13959",
          name: "Smokvica",
          state_id: "871",
        },
        {
          id: "13960",
          name: "Stashevica",
          state_id: "871",
        },
        {
          id: "13961",
          name: "Vela Luka",
          state_id: "871",
        },
        {
          id: "13962",
          name: "Zaton",
          state_id: "871",
        },
        {
          id: "13963",
          name: "Zhrnovo",
          state_id: "871",
        },
      ],
      "Grad Zagreb": [],
      Istra: [
        {
          id: "13964",
          name: "Bale",
          state_id: "873",
        },
        {
          id: "13965",
          name: "Banjole",
          state_id: "873",
        },
        {
          id: "13966",
          name: "Brtonigla",
          state_id: "873",
        },
        {
          id: "13967",
          name: "Buje",
          state_id: "873",
        },
        {
          id: "13968",
          name: "Buzet",
          state_id: "873",
        },
        {
          id: "13969",
          name: "Fazhana",
          state_id: "873",
        },
        {
          id: "13970",
          name: "Funtana",
          state_id: "873",
        },
        {
          id: "13971",
          name: "Galizhana",
          state_id: "873",
        },
        {
          id: "13972",
          name: "Labin",
          state_id: "873",
        },
        {
          id: "13973",
          name: "Lizhnjan",
          state_id: "873",
        },
        {
          id: "13974",
          name: "Marchana",
          state_id: "873",
        },
        {
          id: "13975",
          name: "Medulin",
          state_id: "873",
        },
        {
          id: "13976",
          name: "Novigrad",
          state_id: "873",
        },
        {
          id: "13977",
          name: "Pazin",
          state_id: "873",
        },
        {
          id: "13978",
          name: "Porech",
          state_id: "873",
        },
        {
          id: "13979",
          name: "Premantura",
          state_id: "873",
        },
        {
          id: "13980",
          name: "Pula",
          state_id: "873",
        },
        {
          id: "13981",
          name: "Rabac",
          state_id: "873",
        },
        {
          id: "13982",
          name: "Rasha",
          state_id: "873",
        },
        {
          id: "13983",
          name: "Rovinj",
          state_id: "873",
        },
        {
          id: "13984",
          name: "Sveti Petar u Shumi",
          state_id: "873",
        },
        {
          id: "13985",
          name: "Tar",
          state_id: "873",
        },
        {
          id: "13986",
          name: "Umag",
          state_id: "873",
        },
        {
          id: "13987",
          name: "Vinezh",
          state_id: "873",
        },
        {
          id: "13988",
          name: "Vodnjan",
          state_id: "873",
        },
        {
          id: "13989",
          name: "Vrsar",
          state_id: "873",
        },
      ],
      Karlovac: [
        {
          id: "13990",
          name: "Cerovac Vukmansichki",
          state_id: "874",
        },
        {
          id: "13991",
          name: "Draganic",
          state_id: "874",
        },
        {
          id: "13992",
          name: "Duga Resa",
          state_id: "874",
        },
        {
          id: "13993",
          name: "Josipdol",
          state_id: "874",
        },
        {
          id: "13994",
          name: "Karlovac",
          state_id: "874",
        },
        {
          id: "13995",
          name: "Mrezhnichki Varosh",
          state_id: "874",
        },
        {
          id: "13996",
          name: "Ogulin",
          state_id: "874",
        },
        {
          id: "13997",
          name: "Oshtarije",
          state_id: "874",
        },
        {
          id: "13998",
          name: "Ozalj",
          state_id: "874",
        },
        {
          id: "13999",
          name: "Plashki",
          state_id: "874",
        },
        {
          id: "14000",
          name: "Slunj",
          state_id: "874",
        },
        {
          id: "14001",
          name: "Vojnic",
          state_id: "874",
        },
      ],
      "Koprivnica-Krizhevci": [
        {
          id: "14002",
          name: "Dhelekovec",
          state_id: "875",
        },
        {
          id: "14003",
          name: "Dhurdhevac",
          state_id: "875",
        },
        {
          id: "14004",
          name: "Drnje",
          state_id: "875",
        },
        {
          id: "14005",
          name: "Ferdinandovac",
          state_id: "875",
        },
        {
          id: "14006",
          name: "Glogovac",
          state_id: "875",
        },
        {
          id: "14007",
          name: "Gola",
          state_id: "875",
        },
        {
          id: "14008",
          name: "Hlebine",
          state_id: "875",
        },
        {
          id: "14009",
          name: "Kalinovac",
          state_id: "875",
        },
        {
          id: "14010",
          name: "Kloshtar Podravski",
          state_id: "875",
        },
        {
          id: "14011",
          name: "Koprivnica",
          state_id: "875",
        },
        {
          id: "14012",
          name: "Koprivnichki Bregi",
          state_id: "875",
        },
        {
          id: "14013",
          name: "Koprivnichki Ivanec",
          state_id: "875",
        },
        {
          id: "14014",
          name: "Krizhevci",
          state_id: "875",
        },
        {
          id: "14015",
          name: "Legrad",
          state_id: "875",
        },
        {
          id: "14016",
          name: "Molve",
          state_id: "875",
        },
        {
          id: "14017",
          name: "Novigrad Podravski",
          state_id: "875",
        },
        {
          id: "14018",
          name: "Novo Virje",
          state_id: "875",
        },
        {
          id: "14019",
          name: "Peteranec",
          state_id: "875",
        },
        {
          id: "14020",
          name: "Podravske Sesvete",
          state_id: "875",
        },
        {
          id: "14021",
          name: "Rasinja",
          state_id: "875",
        },
        {
          id: "14022",
          name: "Reka",
          state_id: "875",
        },
        {
          id: "14023",
          name: "Sigetec",
          state_id: "875",
        },
        {
          id: "14024",
          name: "Starigrad",
          state_id: "875",
        },
        {
          id: "14025",
          name: "Sveti Ivan Zhabno",
          state_id: "875",
        },
        {
          id: "14026",
          name: "Trema",
          state_id: "875",
        },
        {
          id: "14027",
          name: "Virje",
          state_id: "875",
        },
      ],
      "Krapina-Zagorje": [
        {
          id: "14028",
          name: "Andrashevec",
          state_id: "876",
        },
        {
          id: "14029",
          name: "Bedekovchina",
          state_id: "876",
        },
        {
          id: "14030",
          name: "Dhurmanec",
          state_id: "876",
        },
        {
          id: "14031",
          name: "Donja Pachetina",
          state_id: "876",
        },
        {
          id: "14032",
          name: "Donja Shemnica",
          state_id: "876",
        },
        {
          id: "14033",
          name: "Donja Stubica",
          state_id: "876",
        },
        {
          id: "14034",
          name: "Dubrovchan",
          state_id: "876",
        },
        {
          id: "14035",
          name: "Gornja Stubica",
          state_id: "876",
        },
        {
          id: "14036",
          name: "Hum na Sutli",
          state_id: "876",
        },
        {
          id: "14037",
          name: "Klanjec",
          state_id: "876",
        },
        {
          id: "14038",
          name: "Konjishchina",
          state_id: "876",
        },
        {
          id: "14039",
          name: "Krapina",
          state_id: "876",
        },
        {
          id: "14040",
          name: "Krapinske Toplice",
          state_id: "876",
        },
        {
          id: "14041",
          name: "Laz Bistrichki",
          state_id: "876",
        },
        {
          id: "14042",
          name: "Marija Bistrica",
          state_id: "876",
        },
        {
          id: "14043",
          name: "Mihovljan",
          state_id: "876",
        },
        {
          id: "14044",
          name: "Oroslavje",
          state_id: "876",
        },
        {
          id: "14045",
          name: "Podgorje Bistrichko",
          state_id: "876",
        },
        {
          id: "14046",
          name: "Poznanovec",
          state_id: "876",
        },
        {
          id: "14047",
          name: "Pregrada",
          state_id: "876",
        },
        {
          id: "14048",
          name: "Radoboj",
          state_id: "876",
        },
        {
          id: "14049",
          name: "Shkaricevo",
          state_id: "876",
        },
        {
          id: "14050",
          name: "Shpichkovina",
          state_id: "876",
        },
        {
          id: "14051",
          name: "Stubichke Toplice",
          state_id: "876",
        },
        {
          id: "14052",
          name: "Sveti Krizh Zachretje",
          state_id: "876",
        },
        {
          id: "14053",
          name: "Veliko Trgovishce",
          state_id: "876",
        },
        {
          id: "14054",
          name: "Zabok",
          state_id: "876",
        },
        {
          id: "14055",
          name: "Zlatar",
          state_id: "876",
        },
        {
          id: "14056",
          name: "Zlatar-Bistrica",
          state_id: "876",
        },
      ],
      "Lika-Senj": [
        {
          id: "14057",
          name: "Brinje",
          state_id: "877",
        },
        {
          id: "14058",
          name: "Donji Lapac",
          state_id: "877",
        },
        {
          id: "14059",
          name: "Gospic",
          state_id: "877",
        },
        {
          id: "14060",
          name: "Korenica",
          state_id: "877",
        },
        {
          id: "14061",
          name: "Lichki Osik",
          state_id: "877",
        },
        {
          id: "14062",
          name: "Lichko Leshce",
          state_id: "877",
        },
        {
          id: "14063",
          name: "Novalja",
          state_id: "877",
        },
        {
          id: "14064",
          name: "Otochac",
          state_id: "877",
        },
        {
          id: "14065",
          name: "Perushic",
          state_id: "877",
        },
        {
          id: "14066",
          name: "Prozor",
          state_id: "877",
        },
        {
          id: "14067",
          name: "Senj",
          state_id: "877",
        },
      ],
      Medhimurje: [
        {
          id: "14068",
          name: "Belica",
          state_id: "878",
        },
        {
          id: "14069",
          name: "Chakovec",
          state_id: "878",
        },
        {
          id: "14070",
          name: "Cirkovljan",
          state_id: "878",
        },
        {
          id: "14071",
          name: "Dekanovec",
          state_id: "878",
        },
        {
          id: "14072",
          name: "Domashinec",
          state_id: "878",
        },
        {
          id: "14073",
          name: "Donja Dubrava",
          state_id: "878",
        },
        {
          id: "14074",
          name: "Donji Kraljevec",
          state_id: "878",
        },
        {
          id: "14075",
          name: "Donji Vidovec",
          state_id: "878",
        },
        {
          id: "14076",
          name: "Drzhimurec",
          state_id: "878",
        },
        {
          id: "14077",
          name: "Dunjkovec",
          state_id: "878",
        },
        {
          id: "14078",
          name: "Gardinovec",
          state_id: "878",
        },
        {
          id: "14079",
          name: "Gorichan",
          state_id: "878",
        },
        {
          id: "14080",
          name: "Gornji Hrashcan",
          state_id: "878",
        },
        {
          id: "14081",
          name: "Hodoshan",
          state_id: "878",
        },
        {
          id: "14082",
          name: "Ivanovec",
          state_id: "878",
        },
        {
          id: "14083",
          name: "Kotoriba",
          state_id: "878",
        },
        {
          id: "14084",
          name: "Kurshanec",
          state_id: "878",
        },
        {
          id: "14085",
          name: "Lopatinec",
          state_id: "878",
        },
        {
          id: "14086",
          name: "Machkovec",
          state_id: "878",
        },
        {
          id: "14087",
          name: "Mala Subotica",
          state_id: "878",
        },
        {
          id: "14088",
          name: "Mihovljan",
          state_id: "878",
        },
        {
          id: "14089",
          name: "Mursko Sredishce",
          state_id: "878",
        },
        {
          id: "14090",
          name: "Nedelishce",
          state_id: "878",
        },
        {
          id: "14091",
          name: "Novakovec",
          state_id: "878",
        },
        {
          id: "14092",
          name: "Novo Selo Rok",
          state_id: "878",
        },
        {
          id: "14093",
          name: "Orehovica",
          state_id: "878",
        },
        {
          id: "14094",
          name: "Palovec",
          state_id: "878",
        },
        {
          id: "14095",
          name: "Peklenica",
          state_id: "878",
        },
        {
          id: "14096",
          name: "Podturen",
          state_id: "878",
        },
        {
          id: "14097",
          name: "Prelog",
          state_id: "878",
        },
        {
          id: "14098",
          name: "Pribislavec",
          state_id: "878",
        },
        {
          id: "14099",
          name: "Pushcine",
          state_id: "878",
        },
        {
          id: "14100",
          name: "Savska Ves",
          state_id: "878",
        },
        {
          id: "14101",
          name: "Selnica",
          state_id: "878",
        },
        {
          id: "14102",
          name: "Shenkovec",
          state_id: "878",
        },
        {
          id: "14103",
          name: "Strahoninec",
          state_id: "878",
        },
        {
          id: "14104",
          name: "Sveta Marija",
          state_id: "878",
        },
        {
          id: "14105",
          name: "Trnovec",
          state_id: "878",
        },
        {
          id: "14106",
          name: "Vratishinec",
          state_id: "878",
        },
        {
          id: "14107",
          name: "Zasadbreg",
          state_id: "878",
        },
      ],
      "Medimurska Zupanija": [],
      "Osijek-Baranja": [
        {
          id: "14108",
          name: "Antunovac",
          state_id: "880",
        },
        {
          id: "14109",
          name: "Batina",
          state_id: "880",
        },
        {
          id: "14110",
          name: "Beli Manastir",
          state_id: "880",
        },
        {
          id: "14111",
          name: "Belishce",
          state_id: "880",
        },
        {
          id: "14112",
          name: "Beljevina",
          state_id: "880",
        },
        {
          id: "14113",
          name: "Bijelo Brdo",
          state_id: "880",
        },
        {
          id: "14114",
          name: "Bilje",
          state_id: "880",
        },
        {
          id: "14115",
          name: "Bistrinci",
          state_id: "880",
        },
        {
          id: "14116",
          name: "Bizovac",
          state_id: "880",
        },
        {
          id: "14117",
          name: "Branjin Vrh",
          state_id: "880",
        },
        {
          id: "14118",
          name: "Brijeshce",
          state_id: "880",
        },
        {
          id: "14119",
          name: "Brijest",
          state_id: "880",
        },
        {
          id: "14120",
          name: "Ceminac",
          state_id: "880",
        },
        {
          id: "14121",
          name: "Chepin",
          state_id: "880",
        },
        {
          id: "14122",
          name: "Crnkovci",
          state_id: "880",
        },
        {
          id: "14123",
          name: "Dalj",
          state_id: "880",
        },
        {
          id: "14124",
          name: "Darda",
          state_id: "880",
        },
        {
          id: "14125",
          name: "Dhakovo",
          state_id: "880",
        },
        {
          id: "14126",
          name: "Dhurdhenovac",
          state_id: "880",
        },
        {
          id: "14127",
          name: "Donja Motichina",
          state_id: "880",
        },
        {
          id: "14128",
          name: "Donji Miholac",
          state_id: "880",
        },
        {
          id: "14129",
          name: "Erdut",
          state_id: "880",
        },
        {
          id: "14130",
          name: "Ernestinovo",
          state_id: "880",
        },
        {
          id: "14131",
          name: "Ferichanci",
          state_id: "880",
        },
        {
          id: "14132",
          name: "Gashinci",
          state_id: "880",
        },
        {
          id: "14133",
          name: "Gorjani",
          state_id: "880",
        },
        {
          id: "14134",
          name: "Grabovac",
          state_id: "880",
        },
        {
          id: "14135",
          name: "Ivanovac",
          state_id: "880",
        },
        {
          id: "14136",
          name: "Ivanovci Gorjanski",
          state_id: "880",
        },
        {
          id: "14137",
          name: "Jagodnjak",
          state_id: "880",
        },
        {
          id: "14138",
          name: "Jelisavac",
          state_id: "880",
        },
        {
          id: "14139",
          name: "Josipovac",
          state_id: "880",
        },
        {
          id: "14140",
          name: "Josipovac Punitovachki",
          state_id: "880",
        },
        {
          id: "14141",
          name: "Karanac",
          state_id: "880",
        },
        {
          id: "14142",
          name: "Keshinci",
          state_id: "880",
        },
        {
          id: "14143",
          name: "Knezhevi Vinogradi",
          state_id: "880",
        },
        {
          id: "14144",
          name: "Knezhevo",
          state_id: "880",
        },
        {
          id: "14145",
          name: "Koritna",
          state_id: "880",
        },
        {
          id: "14146",
          name: "Koshka",
          state_id: "880",
        },
        {
          id: "14147",
          name: "Kushevac",
          state_id: "880",
        },
        {
          id: "14148",
          name: "Ladimirevci",
          state_id: "880",
        },
        {
          id: "14149",
          name: "Laslovo",
          state_id: "880",
        },
        {
          id: "14150",
          name: "Lug",
          state_id: "880",
        },
        {
          id: "14151",
          name: "Marijanci",
          state_id: "880",
        },
        {
          id: "14152",
          name: "Markovac Nashichki",
          state_id: "880",
        },
        {
          id: "14153",
          name: "Martin",
          state_id: "880",
        },
        {
          id: "14154",
          name: "Mece",
          state_id: "880",
        },
        {
          id: "14155",
          name: "Moslavina Podravska",
          state_id: "880",
        },
        {
          id: "14156",
          name: "Nashice",
          state_id: "880",
        },
        {
          id: "14157",
          name: "Osijek",
          state_id: "880",
        },
        {
          id: "14158",
          name: "Ovchara",
          state_id: "880",
        },
        {
          id: "14159",
          name: "Petlovac",
          state_id: "880",
        },
        {
          id: "14160",
          name: "Petrijevci",
          state_id: "880",
        },
        {
          id: "14161",
          name: "Pishkorevci",
          state_id: "880",
        },
        {
          id: "14162",
          name: "Podgorach",
          state_id: "880",
        },
        {
          id: "14163",
          name: "Popvac",
          state_id: "880",
        },
        {
          id: "14164",
          name: "Rakitovica",
          state_id: "880",
        },
        {
          id: "14165",
          name: "Sarvash",
          state_id: "880",
        },
        {
          id: "14166",
          name: "Satnica Dhakovachka",
          state_id: "880",
        },
        {
          id: "14167",
          name: "Selci Dhakovacki",
          state_id: "880",
        },
        {
          id: "14168",
          name: "Semeljci",
          state_id: "880",
        },
        {
          id: "14169",
          name: "Shiroko Polje",
          state_id: "880",
        },
        {
          id: "14170",
          name: "Strizivojna",
          state_id: "880",
        },
        {
          id: "14171",
          name: "Sveti Dhuradh",
          state_id: "880",
        },
        {
          id: "14172",
          name: "Tenja",
          state_id: "880",
        },
        {
          id: "14173",
          name: "Valpovo",
          state_id: "880",
        },
        {
          id: "14174",
          name: "Velimirovac",
          state_id: "880",
        },
        {
          id: "14175",
          name: "Viljevo",
          state_id: "880",
        },
        {
          id: "14176",
          name: "Vishkovci",
          state_id: "880",
        },
        {
          id: "14177",
          name: "Vishnjevac",
          state_id: "880",
        },
        {
          id: "14178",
          name: "Vladislavci",
          state_id: "880",
        },
        {
          id: "14179",
          name: "Vuka",
          state_id: "880",
        },
        {
          id: "14180",
          name: "Vukojevci",
          state_id: "880",
        },
        {
          id: "14181",
          name: "Zmajevac",
          state_id: "880",
        },
        {
          id: "14182",
          name: "Zoljan",
          state_id: "880",
        },
      ],
      "Osjecko-Baranjska Zupanija": [],
      "Pozhega-Slavonija": [
        {
          id: "14183",
          name: "Badljevina",
          state_id: "882",
        },
        {
          id: "14184",
          name: "Brodski Drenovac",
          state_id: "882",
        },
        {
          id: "14185",
          name: "Dervishaga",
          state_id: "882",
        },
        {
          id: "14186",
          name: "Gradac",
          state_id: "882",
        },
        {
          id: "14187",
          name: "Jakshic",
          state_id: "882",
        },
        {
          id: "14188",
          name: "Kaptol",
          state_id: "882",
        },
        {
          id: "14189",
          name: "Kutjevo",
          state_id: "882",
        },
        {
          id: "14190",
          name: "Lipik",
          state_id: "882",
        },
        {
          id: "14191",
          name: "Pakrac",
          state_id: "882",
        },
        {
          id: "14192",
          name: "Pleternica",
          state_id: "882",
        },
        {
          id: "14193",
          name: "Pozhega",
          state_id: "882",
        },
        {
          id: "14194",
          name: "Prekopkra",
          state_id: "882",
        },
        {
          id: "14195",
          name: "Trenkovo",
          state_id: "882",
        },
        {
          id: "14196",
          name: "Velika",
          state_id: "882",
        },
        {
          id: "14197",
          name: "Vetovo",
          state_id: "882",
        },
        {
          id: "14198",
          name: "Vidovci",
          state_id: "882",
        },
      ],
      "Primorje-Gorski Kotar": [],
      "Shibenik-Knin": [
        {
          id: "14199",
          name: "Bilice",
          state_id: "884",
        },
        {
          id: "14200",
          name: "Brodarica",
          state_id: "884",
        },
        {
          id: "14201",
          name: "Drnish",
          state_id: "884",
        },
        {
          id: "14202",
          name: "Dubrava kod Shibenika",
          state_id: "884",
        },
        {
          id: "14203",
          name: "Grebashtica",
          state_id: "884",
        },
        {
          id: "14204",
          name: "Jezera",
          state_id: "884",
        },
        {
          id: "14205",
          name: "Kistanje",
          state_id: "884",
        },
        {
          id: "14206",
          name: "Knin",
          state_id: "884",
        },
        {
          id: "14207",
          name: "Kovachic",
          state_id: "884",
        },
        {
          id: "14208",
          name: "Murter",
          state_id: "884",
        },
        {
          id: "14209",
          name: "Pirovac",
          state_id: "884",
        },
        {
          id: "14210",
          name: "Primoshten",
          state_id: "884",
        },
        {
          id: "14211",
          name: "Rogoznica",
          state_id: "884",
        },
        {
          id: "14212",
          name: "Shibenik",
          state_id: "884",
        },
        {
          id: "14213",
          name: "Skradin",
          state_id: "884",
        },
        {
          id: "14214",
          name: "Tisno",
          state_id: "884",
        },
        {
          id: "14215",
          name: "Tribunj",
          state_id: "884",
        },
        {
          id: "14216",
          name: "Vodice",
          state_id: "884",
        },
        {
          id: "14217",
          name: "Vrpolje",
          state_id: "884",
        },
        {
          id: "14218",
          name: "Zaton",
          state_id: "884",
        },
      ],
      "Sisak-Moslavina": [
        {
          id: "14219",
          name: "Brestacha",
          state_id: "885",
        },
        {
          id: "14220",
          name: "Brochice",
          state_id: "885",
        },
        {
          id: "14221",
          name: "Budashevo",
          state_id: "885",
        },
        {
          id: "14222",
          name: "Donja Grachenica",
          state_id: "885",
        },
        {
          id: "14223",
          name: "Dvor",
          state_id: "885",
        },
        {
          id: "14224",
          name: "Glina",
          state_id: "885",
        },
        {
          id: "14225",
          name: "Gornja Grachenica",
          state_id: "885",
        },
        {
          id: "14226",
          name: "Gornja Jelenska",
          state_id: "885",
        },
        {
          id: "14227",
          name: "Greda",
          state_id: "885",
        },
        {
          id: "14228",
          name: "Gvozd",
          state_id: "885",
        },
        {
          id: "14229",
          name: "Hrastelnica",
          state_id: "885",
        },
        {
          id: "14230",
          name: "Hrvatska Dubica",
          state_id: "885",
        },
        {
          id: "14231",
          name: "Hrvatska Kostajnica",
          state_id: "885",
        },
        {
          id: "14232",
          name: "Husain",
          state_id: "885",
        },
        {
          id: "14233",
          name: "Ilova",
          state_id: "885",
        },
        {
          id: "14234",
          name: "Kutina",
          state_id: "885",
        },
        {
          id: "14235",
          name: "Lekenik",
          state_id: "885",
        },
        {
          id: "14236",
          name: "Lipovljani",
          state_id: "885",
        },
        {
          id: "14237",
          name: "Moshchenica",
          state_id: "885",
        },
        {
          id: "14238",
          name: "Novska",
          state_id: "885",
        },
        {
          id: "14239",
          name: "Odra Sisachka",
          state_id: "885",
        },
        {
          id: "14240",
          name: "Osekovo",
          state_id: "885",
        },
        {
          id: "14241",
          name: "Peshcenica",
          state_id: "885",
        },
        {
          id: "14242",
          name: "Petrinja",
          state_id: "885",
        },
        {
          id: "14243",
          name: "Popovacha",
          state_id: "885",
        },
        {
          id: "14244",
          name: "Potok",
          state_id: "885",
        },
        {
          id: "14245",
          name: "Rajic",
          state_id: "885",
        },
        {
          id: "14246",
          name: "Repushnica",
          state_id: "885",
        },
        {
          id: "14247",
          name: "Sisak",
          state_id: "885",
        },
        {
          id: "14248",
          name: "Staro Prachno",
          state_id: "885",
        },
        {
          id: "14249",
          name: "Sunja",
          state_id: "885",
        },
        {
          id: "14250",
          name: "Topolovac",
          state_id: "885",
        },
        {
          id: "14251",
          name: "Voloder",
          state_id: "885",
        },
      ],
      "Slavonski Brod-Posavina": [],
      "Split-Dalmacija": [
        {
          id: "14252",
          name: "Bashka Voda",
          state_id: "887",
        },
        {
          id: "14253",
          name: "Bol",
          state_id: "887",
        },
        {
          id: "14254",
          name: "Brela",
          state_id: "887",
        },
        {
          id: "14255",
          name: "Brnaze",
          state_id: "887",
        },
        {
          id: "14256",
          name: "Cista Velika",
          state_id: "887",
        },
        {
          id: "14257",
          name: "Donji Prolozhac",
          state_id: "887",
        },
        {
          id: "14258",
          name: "Donji Vinjani",
          state_id: "887",
        },
        {
          id: "14259",
          name: "Duce",
          state_id: "887",
        },
        {
          id: "14260",
          name: "Dugi Rat",
          state_id: "887",
        },
        {
          id: "14261",
          name: "Dugopolje",
          state_id: "887",
        },
        {
          id: "14262",
          name: "Gala",
          state_id: "887",
        },
        {
          id: "14263",
          name: "Glavice",
          state_id: "887",
        },
        {
          id: "14264",
          name: "Glavina Donja",
          state_id: "887",
        },
        {
          id: "14265",
          name: "Gornji Vincjani",
          state_id: "887",
        },
        {
          id: "14266",
          name: "Gradac",
          state_id: "887",
        },
        {
          id: "14267",
          name: "Grubine",
          state_id: "887",
        },
        {
          id: "14268",
          name: "Hrvace",
          state_id: "887",
        },
        {
          id: "14269",
          name: "Hvar",
          state_id: "887",
        },
        {
          id: "14270",
          name: "Imotski",
          state_id: "887",
        },
        {
          id: "14271",
          name: "Jelsa",
          state_id: "887",
        },
        {
          id: "14272",
          name: "Jesenice",
          state_id: "887",
        },
        {
          id: "14273",
          name: "Kamen",
          state_id: "887",
        },
        {
          id: "14274",
          name: "Kashtel Gambelovac",
          state_id: "887",
        },
        {
          id: "14275",
          name: "Kashtel Gomilica",
          state_id: "887",
        },
        {
          id: "14276",
          name: "Kashtel Lukshic",
          state_id: "887",
        },
        {
          id: "14277",
          name: "Kashtel Novi",
          state_id: "887",
        },
        {
          id: "14278",
          name: "Kashtel Shtafilic",
          state_id: "887",
        },
        {
          id: "14279",
          name: "Kashtel Stari",
          state_id: "887",
        },
        {
          id: "14280",
          name: "Kashtel Sucurac",
          state_id: "887",
        },
        {
          id: "14281",
          name: "Katuni",
          state_id: "887",
        },
        {
          id: "14282",
          name: "Klis",
          state_id: "887",
        },
        {
          id: "14283",
          name: "Komizha",
          state_id: "887",
        },
        {
          id: "14284",
          name: "Koshute",
          state_id: "887",
        },
        {
          id: "14285",
          name: "Lovrec",
          state_id: "887",
        },
        {
          id: "14286",
          name: "Makarska",
          state_id: "887",
        },
        {
          id: "14287",
          name: "Marina",
          state_id: "887",
        },
        {
          id: "14288",
          name: "Mastrinka",
          state_id: "887",
        },
        {
          id: "14289",
          name: "Milna",
          state_id: "887",
        },
        {
          id: "14290",
          name: "Mravince",
          state_id: "887",
        },
        {
          id: "14291",
          name: "Neoric",
          state_id: "887",
        },
        {
          id: "14292",
          name: "Obrovac Sinjski",
          state_id: "887",
        },
        {
          id: "14293",
          name: "Okrug Gornji",
          state_id: "887",
        },
        {
          id: "14294",
          name: "Omish",
          state_id: "887",
        },
        {
          id: "14295",
          name: "Otok",
          state_id: "887",
        },
        {
          id: "14296",
          name: "Podgora",
          state_id: "887",
        },
        {
          id: "14297",
          name: "Podstrana",
          state_id: "887",
        },
        {
          id: "14298",
          name: "Poljica",
          state_id: "887",
        },
        {
          id: "14299",
          name: "Postira",
          state_id: "887",
        },
        {
          id: "14300",
          name: "Postranje",
          state_id: "887",
        },
        {
          id: "14301",
          name: "Potravlje",
          state_id: "887",
        },
        {
          id: "14302",
          name: "Primorski Dolac",
          state_id: "887",
        },
        {
          id: "14303",
          name: "Puchishca",
          state_id: "887",
        },
        {
          id: "14304",
          name: "Ruda",
          state_id: "887",
        },
        {
          id: "14305",
          name: "Runovic",
          state_id: "887",
        },
        {
          id: "14306",
          name: "Seget Donji",
          state_id: "887",
        },
        {
          id: "14307",
          name: "Seget Vranjica",
          state_id: "887",
        },
        {
          id: "14308",
          name: "Selca",
          state_id: "887",
        },
        {
          id: "14309",
          name: "Sinj",
          state_id: "887",
        },
        {
          id: "14310",
          name: "Slatine",
          state_id: "887",
        },
        {
          id: "14311",
          name: "Solin",
          state_id: "887",
        },
        {
          id: "14312",
          name: "Split",
          state_id: "887",
        },
        {
          id: "14313",
          name: "Srinjine",
          state_id: "887",
        },
        {
          id: "14314",
          name: "Stari Grad",
          state_id: "887",
        },
        {
          id: "14315",
          name: "Stobrech",
          state_id: "887",
        },
        {
          id: "14316",
          name: "Supetar",
          state_id: "887",
        },
        {
          id: "14317",
          name: "Trilj",
          state_id: "887",
        },
        {
          id: "14318",
          name: "Trogir",
          state_id: "887",
        },
        {
          id: "14319",
          name: "Tuchepi",
          state_id: "887",
        },
        {
          id: "14320",
          name: "Turjaci",
          state_id: "887",
        },
        {
          id: "14321",
          name: "Vinishce",
          state_id: "887",
        },
        {
          id: "14322",
          name: "Vis",
          state_id: "887",
        },
        {
          id: "14323",
          name: "Vranjic",
          state_id: "887",
        },
        {
          id: "14324",
          name: "Vrgorac",
          state_id: "887",
        },
        {
          id: "14325",
          name: "Vrlika",
          state_id: "887",
        },
        {
          id: "14326",
          name: "Zagvozd",
          state_id: "887",
        },
        {
          id: "14327",
          name: "Zhrnovnica",
          state_id: "887",
        },
        {
          id: "14328",
          name: "Zmijavci",
          state_id: "887",
        },
      ],
      Varazhdin: [
        {
          id: "14329",
          name: "Bedenec",
          state_id: "888",
        },
        {
          id: "14330",
          name: "Beletinec",
          state_id: "888",
        },
        {
          id: "14331",
          name: "Beretinec",
          state_id: "888",
        },
        {
          id: "14332",
          name: "Breznica",
          state_id: "888",
        },
        {
          id: "14333",
          name: "Chreshnjevo",
          state_id: "888",
        },
        {
          id: "14334",
          name: "Donja Voca",
          state_id: "888",
        },
        {
          id: "14335",
          name: "Donje Ladanje",
          state_id: "888",
        },
        {
          id: "14336",
          name: "Gornje Ladanje",
          state_id: "888",
        },
        {
          id: "14337",
          name: "Gornje Vratno",
          state_id: "888",
        },
        {
          id: "14338",
          name: "Gornji Kneginec",
          state_id: "888",
        },
        {
          id: "14339",
          name: "Gornji Kucan",
          state_id: "888",
        },
        {
          id: "14340",
          name: "Hrashcica",
          state_id: "888",
        },
        {
          id: "14341",
          name: "Hrastovsko",
          state_id: "888",
        },
        {
          id: "14342",
          name: "Hrzhenica",
          state_id: "888",
        },
        {
          id: "14343",
          name: "Ivanec",
          state_id: "888",
        },
        {
          id: "14344",
          name: "Jalkovec",
          state_id: "888",
        },
        {
          id: "14345",
          name: "Jalzhabet",
          state_id: "888",
        },
        {
          id: "14346",
          name: "Jerovec",
          state_id: "888",
        },
        {
          id: "14347",
          name: "Klenovnik",
          state_id: "888",
        },
        {
          id: "14348",
          name: "Kljuch",
          state_id: "888",
        },
        {
          id: "14349",
          name: "Kucan Marof",
          state_id: "888",
        },
        {
          id: "14350",
          name: "Lepoglava",
          state_id: "888",
        },
        {
          id: "14351",
          name: "Ljubeshcica",
          state_id: "888",
        },
        {
          id: "14352",
          name: "Ludbreg",
          state_id: "888",
        },
        {
          id: "14353",
          name: "Madzharevo",
          state_id: "888",
        },
        {
          id: "14354",
          name: "Mali Bukovec",
          state_id: "888",
        },
        {
          id: "14355",
          name: "Nedeljanec",
          state_id: "888",
        },
        {
          id: "14356",
          name: "Nova Ves Petrijanec",
          state_id: "888",
        },
        {
          id: "14357",
          name: "Novi Marof",
          state_id: "888",
        },
        {
          id: "14358",
          name: "Petrijanec",
          state_id: "888",
        },
        {
          id: "14359",
          name: "Podevchevo",
          state_id: "888",
        },
        {
          id: "14360",
          name: "Presechno",
          state_id: "888",
        },
        {
          id: "14361",
          name: "Remetinec",
          state_id: "888",
        },
        {
          id: "14362",
          name: "Selnik",
          state_id: "888",
        },
        {
          id: "14363",
          name: "Shemovec",
          state_id: "888",
        },
        {
          id: "14364",
          name: "Srachinec",
          state_id: "888",
        },
        {
          id: "14365",
          name: "Sveti Petar",
          state_id: "888",
        },
        {
          id: "14366",
          name: "Svibovec Podravski",
          state_id: "888",
        },
        {
          id: "14367",
          name: "Trnovec",
          state_id: "888",
        },
        {
          id: "14368",
          name: "Turchin",
          state_id: "888",
        },
        {
          id: "14369",
          name: "Tuzhno",
          state_id: "888",
        },
        {
          id: "14370",
          name: "Varazhdin",
          state_id: "888",
        },
        {
          id: "14371",
          name: "Varazhdin Breg",
          state_id: "888",
        },
        {
          id: "14372",
          name: "Varazhdinske Toplice",
          state_id: "888",
        },
        {
          id: "14373",
          name: "Vidovec",
          state_id: "888",
        },
        {
          id: "14374",
          name: "Vinica",
          state_id: "888",
        },
        {
          id: "14375",
          name: "Zavrshje Podbelsko",
          state_id: "888",
        },
        {
          id: "14376",
          name: "Zharovnica",
          state_id: "888",
        },
      ],
      "Virovitica-Podravina": [
        {
          id: "14377",
          name: "Borova",
          state_id: "889",
        },
        {
          id: "14378",
          name: "Busetina",
          state_id: "889",
        },
        {
          id: "14379",
          name: "Cabuna",
          state_id: "889",
        },
        {
          id: "14380",
          name: "Chachinci",
          state_id: "889",
        },
        {
          id: "14381",
          name: "Gradina",
          state_id: "889",
        },
        {
          id: "14382",
          name: "Korija",
          state_id: "889",
        },
        {
          id: "14383",
          name: "Mikleush",
          state_id: "889",
        },
        {
          id: "14384",
          name: "Milanovac",
          state_id: "889",
        },
        {
          id: "14385",
          name: "Nova Bukovica",
          state_id: "889",
        },
        {
          id: "14386",
          name: "Orahovica",
          state_id: "889",
        },
        {
          id: "14387",
          name: "Pitomacha",
          state_id: "889",
        },
        {
          id: "14388",
          name: "Podgorje",
          state_id: "889",
        },
        {
          id: "14389",
          name: "Rezovac",
          state_id: "889",
        },
        {
          id: "14390",
          name: "Shpishic Bukovica",
          state_id: "889",
        },
        {
          id: "14391",
          name: "Slatina",
          state_id: "889",
        },
        {
          id: "14392",
          name: "Suhopolje",
          state_id: "889",
        },
        {
          id: "14393",
          name: "Turanovac",
          state_id: "889",
        },
        {
          id: "14394",
          name: "Virovitica",
          state_id: "889",
        },
        {
          id: "14395",
          name: "Vocin",
          state_id: "889",
        },
        {
          id: "14396",
          name: "Zdenci",
          state_id: "889",
        },
      ],
      "Vukovar-Srijem": [
        {
          id: "14397",
          name: "Andrijashevci",
          state_id: "890",
        },
        {
          id: "14398",
          name: "Antin",
          state_id: "890",
        },
        {
          id: "14399",
          name: "Babina Greda",
          state_id: "890",
        },
        {
          id: "14400",
          name: "Bapska",
          state_id: "890",
        },
        {
          id: "14401",
          name: "Bobota",
          state_id: "890",
        },
        {
          id: "14402",
          name: "Bogdanovci",
          state_id: "890",
        },
        {
          id: "14403",
          name: "Borovo",
          state_id: "890",
        },
        {
          id: "14404",
          name: "Boshnjaci",
          state_id: "890",
        },
        {
          id: "14405",
          name: "Brshadin",
          state_id: "890",
        },
        {
          id: "14406",
          name: "Ceric",
          state_id: "890",
        },
        {
          id: "14407",
          name: "Cerna",
          state_id: "890",
        },
        {
          id: "14408",
          name: "Drenovci",
          state_id: "890",
        },
        {
          id: "14409",
          name: "Gradishte",
          state_id: "890",
        },
        {
          id: "14410",
          name: "Gunja",
          state_id: "890",
        },
        {
          id: "14411",
          name: "Ilacha",
          state_id: "890",
        },
        {
          id: "14412",
          name: "Ilok",
          state_id: "890",
        },
        {
          id: "14413",
          name: "Ivankovo",
          state_id: "890",
        },
        {
          id: "14414",
          name: "Jarmina",
          state_id: "890",
        },
        {
          id: "14415",
          name: "Komletinci",
          state_id: "890",
        },
        {
          id: "14416",
          name: "Lipovac",
          state_id: "890",
        },
        {
          id: "14417",
          name: "Lovas",
          state_id: "890",
        },
        {
          id: "14418",
          name: "Markushica",
          state_id: "890",
        },
        {
          id: "14419",
          name: "Mirkovci",
          state_id: "890",
        },
        {
          id: "14420",
          name: "Negoslavci",
          state_id: "890",
        },
        {
          id: "14421",
          name: "Nijemci",
          state_id: "890",
        },
        {
          id: "14422",
          name: "Novi Jankovci",
          state_id: "890",
        },
        {
          id: "14423",
          name: "Nushtar",
          state_id: "890",
        },
        {
          id: "14424",
          name: "Otok",
          state_id: "890",
        },
        {
          id: "14425",
          name: "Petrovci",
          state_id: "890",
        },
        {
          id: "14426",
          name: "Posavski Podgajci",
          state_id: "890",
        },
        {
          id: "14427",
          name: "Privlaka",
          state_id: "890",
        },
        {
          id: "14428",
          name: "Rachinovci",
          state_id: "890",
        },
        {
          id: "14429",
          name: "Rajevo Selo",
          state_id: "890",
        },
        {
          id: "14430",
          name: "Retkovci",
          state_id: "890",
        },
        {
          id: "14431",
          name: "Rokovci",
          state_id: "890",
        },
        {
          id: "14432",
          name: "Sharengrad",
          state_id: "890",
        },
        {
          id: "14433",
          name: "Shishkovci",
          state_id: "890",
        },
        {
          id: "14434",
          name: "Shtitar",
          state_id: "890",
        },
        {
          id: "14435",
          name: "Slakovci",
          state_id: "890",
        },
        {
          id: "14436",
          name: "Soljani",
          state_id: "890",
        },
        {
          id: "14437",
          name: "Sotin",
          state_id: "890",
        },
        {
          id: "14438",
          name: "Stari Jankovci",
          state_id: "890",
        },
        {
          id: "14439",
          name: "Stari Mikanovci",
          state_id: "890",
        },
        {
          id: "14440",
          name: "Tordinci",
          state_id: "890",
        },
        {
          id: "14441",
          name: "Tovarnik",
          state_id: "890",
        },
        {
          id: "14442",
          name: "Trpinja",
          state_id: "890",
        },
        {
          id: "14443",
          name: "Vinkovci",
          state_id: "890",
        },
        {
          id: "14444",
          name: "Vodhinci",
          state_id: "890",
        },
        {
          id: "14445",
          name: "Vrbanja",
          state_id: "890",
        },
        {
          id: "14446",
          name: "Vukovar",
          state_id: "890",
        },
        {
          id: "14447",
          name: "Zhupanja",
          state_id: "890",
        },
      ],
      Zadar: [
        {
          id: "14448",
          name: "Benkovac",
          state_id: "891",
        },
        {
          id: "14449",
          name: "Bibinje",
          state_id: "891",
        },
        {
          id: "14450",
          name: "Biograd na Moru",
          state_id: "891",
        },
        {
          id: "14451",
          name: "Debeljak",
          state_id: "891",
        },
        {
          id: "14452",
          name: "Galovac",
          state_id: "891",
        },
        {
          id: "14453",
          name: "Gorica",
          state_id: "891",
        },
        {
          id: "14454",
          name: "Gornji Karin",
          state_id: "891",
        },
        {
          id: "14455",
          name: "Grachac",
          state_id: "891",
        },
        {
          id: "14456",
          name: "Jasenice",
          state_id: "891",
        },
        {
          id: "14457",
          name: "Kali",
          state_id: "891",
        },
        {
          id: "14458",
          name: "Krushevo",
          state_id: "891",
        },
        {
          id: "14459",
          name: "Nin",
          state_id: "891",
        },
        {
          id: "14460",
          name: "Obrovac",
          state_id: "891",
        },
        {
          id: "14461",
          name: "Pag",
          state_id: "891",
        },
        {
          id: "14462",
          name: "Pakoshtane",
          state_id: "891",
        },
        {
          id: "14463",
          name: "Polacha",
          state_id: "891",
        },
        {
          id: "14464",
          name: "Polichnik",
          state_id: "891",
        },
        {
          id: "14465",
          name: "Poljica",
          state_id: "891",
        },
        {
          id: "14466",
          name: "Posedarje",
          state_id: "891",
        },
        {
          id: "14467",
          name: "Preko",
          state_id: "891",
        },
        {
          id: "14468",
          name: "Pridraga",
          state_id: "891",
        },
        {
          id: "14469",
          name: "Privlaka",
          state_id: "891",
        },
        {
          id: "14470",
          name: "Razhanac",
          state_id: "891",
        },
        {
          id: "14471",
          name: "Shkabrnja",
          state_id: "891",
        },
        {
          id: "14472",
          name: "Slivnica",
          state_id: "891",
        },
        {
          id: "14473",
          name: "Starigrad",
          state_id: "891",
        },
        {
          id: "14474",
          name: "Sukoshan",
          state_id: "891",
        },
        {
          id: "14475",
          name: "Sveti Filip i Jakov",
          state_id: "891",
        },
        {
          id: "14476",
          name: "Turanj",
          state_id: "891",
        },
        {
          id: "14477",
          name: "Ugljan",
          state_id: "891",
        },
        {
          id: "14478",
          name: "Vir",
          state_id: "891",
        },
        {
          id: "14479",
          name: "Vrsi",
          state_id: "891",
        },
        {
          id: "14480",
          name: "Zadar",
          state_id: "891",
        },
        {
          id: "14481",
          name: "Zemunik Donji",
          state_id: "891",
        },
      ],
      Zagreb: [
        {
          id: "14482",
          name: "Bestovje",
          state_id: "892",
        },
        {
          id: "14483",
          name: "Bishkupec Zelinski",
          state_id: "892",
        },
        {
          id: "14484",
          name: "Brckovljani",
          state_id: "892",
        },
        {
          id: "14485",
          name: "Brdovec",
          state_id: "892",
        },
        {
          id: "14486",
          name: "Bregana",
          state_id: "892",
        },
        {
          id: "14487",
          name: "Brezje",
          state_id: "892",
        },
        {
          id: "14488",
          name: "Bushevec",
          state_id: "892",
        },
        {
          id: "14489",
          name: "Celine",
          state_id: "892",
        },
        {
          id: "14490",
          name: "Domaslovec",
          state_id: "892",
        },
        {
          id: "14491",
          name: "Donja Bistra",
          state_id: "892",
        },
        {
          id: "14492",
          name: "Donja Kupchina",
          state_id: "892",
        },
        {
          id: "14493",
          name: "Donja Lomnica",
          state_id: "892",
        },
        {
          id: "14494",
          name: "Donja Zdenchina",
          state_id: "892",
        },
        {
          id: "14495",
          name: "Donji Desinec",
          state_id: "892",
        },
        {
          id: "14496",
          name: "Donji Stupnik",
          state_id: "892",
        },
        {
          id: "14497",
          name: "Dubrava",
          state_id: "892",
        },
        {
          id: "14498",
          name: "Dugo Selo",
          state_id: "892",
        },
        {
          id: "14499",
          name: "Gornja Bistra",
          state_id: "892",
        },
        {
          id: "14500",
          name: "Gornji Laduch",
          state_id: "892",
        },
        {
          id: "14501",
          name: "Gornji Stupnik",
          state_id: "892",
        },
        {
          id: "14502",
          name: "Grachec",
          state_id: "892",
        },
        {
          id: "14503",
          name: "Gradici",
          state_id: "892",
        },
        {
          id: "14504",
          name: "Ivan Bistranski",
          state_id: "892",
        },
        {
          id: "14505",
          name: "Ivanic-Grad",
          state_id: "892",
        },
        {
          id: "14506",
          name: "Jablanovec",
          state_id: "892",
        },
        {
          id: "14507",
          name: "Jakovlje",
          state_id: "892",
        },
        {
          id: "14508",
          name: "Jastrebarsko",
          state_id: "892",
        },
        {
          id: "14509",
          name: "Kerestinec",
          state_id: "892",
        },
        {
          id: "14510",
          name: "Klincha Sela",
          state_id: "892",
        },
        {
          id: "14511",
          name: "Kloshtar Ivanic",
          state_id: "892",
        },
        {
          id: "14512",
          name: "Kozinshchak",
          state_id: "892",
        },
        {
          id: "14513",
          name: "Krizh",
          state_id: "892",
        },
        {
          id: "14514",
          name: "Kuche",
          state_id: "892",
        },
        {
          id: "14515",
          name: "Kupinec",
          state_id: "892",
        },
        {
          id: "14516",
          name: "Lonjica",
          state_id: "892",
        },
        {
          id: "14517",
          name: "Luka",
          state_id: "892",
        },
        {
          id: "14518",
          name: "Lukarishce",
          state_id: "892",
        },
        {
          id: "14519",
          name: "Lukavec",
          state_id: "892",
        },
        {
          id: "14520",
          name: "Lupoglav",
          state_id: "892",
        },
        {
          id: "14521",
          name: "Michevec",
          state_id: "892",
        },
        {
          id: "14522",
          name: "Mraclin",
          state_id: "892",
        },
        {
          id: "14523",
          name: "Novaki",
          state_id: "892",
        },
        {
          id: "14524",
          name: "Novo Chiche",
          state_id: "892",
        },
        {
          id: "14525",
          name: "Novoselec",
          state_id: "892",
        },
        {
          id: "14526",
          name: "Oborovo Bistranski",
          state_id: "892",
        },
        {
          id: "14527",
          name: "Oreshje",
          state_id: "892",
        },
        {
          id: "14528",
          name: "Pojatno",
          state_id: "892",
        },
        {
          id: "14529",
          name: "Poljanica Bistranska",
          state_id: "892",
        },
        {
          id: "14530",
          name: "Prigorje Brdovechko",
          state_id: "892",
        },
        {
          id: "14531",
          name: "Rakitje",
          state_id: "892",
        },
        {
          id: "14532",
          name: "Rakov Potok",
          state_id: "892",
        },
        {
          id: "14533",
          name: "Rude",
          state_id: "892",
        },
        {
          id: "14534",
          name: "Samobor",
          state_id: "892",
        },
        {
          id: "14535",
          name: "Strmec",
          state_id: "892",
        },
        {
          id: "14536",
          name: "Sveta Nedelja",
          state_id: "892",
        },
        {
          id: "14537",
          name: "Sveti Ivan Zelina",
          state_id: "892",
        },
        {
          id: "14538",
          name: "Turopolje",
          state_id: "892",
        },
        {
          id: "14539",
          name: "Velika Gorica",
          state_id: "892",
        },
        {
          id: "14540",
          name: "Velika Mlaka",
          state_id: "892",
        },
        {
          id: "14541",
          name: "Velika Ostrna",
          state_id: "892",
        },
        {
          id: "14542",
          name: "Vrbovec",
          state_id: "892",
        },
        {
          id: "14543",
          name: "Vukovina",
          state_id: "892",
        },
        {
          id: "14544",
          name: "Zapreshic",
          state_id: "892",
        },
        {
          id: "14545",
          name: "Zdenci Brdovechki",
          state_id: "892",
        },
      ],
    },
  },
  HT: {
    name: "Haiti",
    native: "Haïti",
    phone: "509",
    continent: "NA",
    capital: "Port-au-Prince",
    currency: "HTG,USD",
    languages: ["fr", "ht"],
    emoji: "🇭🇹",
    emojiU: "U+1F1ED U+1F1F9",
    states: {
      Artibonite: [
        {
          id: "20837",
          name: "Desdunes",
          state_id: "1607",
        },
        {
          id: "20838",
          name: "Dessalines",
          state_id: "1607",
        },
        {
          id: "20839",
          name: "Gonaives",
          state_id: "1607",
        },
        {
          id: "20840",
          name: "Gros-Morne",
          state_id: "1607",
        },
        {
          id: "20841",
          name: "L''Artibonite",
          state_id: "1607",
        },
        {
          id: "20842",
          name: "Saint-Marc",
          state_id: "1607",
        },
        {
          id: "20843",
          name: "Saint-Michel-de-l''Atalaye",
          state_id: "1607",
        },
        {
          id: "20844",
          name: "Saint-Raphael",
          state_id: "1607",
        },
        {
          id: "20845",
          name: "Verrettes",
          state_id: "1607",
        },
      ],
      Centre: [
        {
          id: "20846",
          name: "Hinche",
          state_id: "1608",
        },
        {
          id: "20847",
          name: "Mirebalais",
          state_id: "1608",
        },
      ],
      "Grand''Anse": [
        {
          id: "20848",
          name: "Anse-d''Hainault",
          state_id: "1609",
        },
        {
          id: "20849",
          name: "Dame Marie",
          state_id: "1609",
        },
        {
          id: "20850",
          name: "Jeremie",
          state_id: "1609",
        },
        {
          id: "20851",
          name: "Miragoane",
          state_id: "1609",
        },
      ],
      Nord: [
        {
          id: "20852",
          name: "Cap-Haitien",
          state_id: "1610",
        },
        {
          id: "20853",
          name: "Croix-des-Bouquets",
          state_id: "1610",
        },
        {
          id: "20854",
          name: "Grande Riviere du Nord",
          state_id: "1610",
        },
        {
          id: "20855",
          name: "Limbe",
          state_id: "1610",
        },
        {
          id: "20856",
          name: "Pignon",
          state_id: "1610",
        },
      ],
      "Nord-Est": [
        {
          id: "20857",
          name: "Derac",
          state_id: "1611",
        },
        {
          id: "20858",
          name: "Fort-Liberte",
          state_id: "1611",
        },
        {
          id: "20859",
          name: "Ouanaminthe",
          state_id: "1611",
        },
        {
          id: "20860",
          name: "Trou-du-Nord",
          state_id: "1611",
        },
      ],
      "Nord-Ouest": [
        {
          id: "20861",
          name: "Port-de-Paix",
          state_id: "1612",
        },
        {
          id: "20862",
          name: "Saint-Louis-du-Nord",
          state_id: "1612",
        },
      ],
      Ouest: [
        {
          id: "20863",
          name: "Anse-a-Galets",
          state_id: "1613",
        },
        {
          id: "20864",
          name: "Carrefour",
          state_id: "1613",
        },
        {
          id: "20865",
          name: "Delmas",
          state_id: "1613",
        },
        {
          id: "20866",
          name: "Kenscoff",
          state_id: "1613",
        },
        {
          id: "20867",
          name: "Lascahobas",
          state_id: "1613",
        },
        {
          id: "20868",
          name: "Leogane",
          state_id: "1613",
        },
        {
          id: "20869",
          name: "Petionville",
          state_id: "1613",
        },
        {
          id: "20870",
          name: "Petit Goave",
          state_id: "1613",
        },
        {
          id: "20871",
          name: "Port-au-Prince",
          state_id: "1613",
        },
      ],
      Sud: [
        {
          id: "20872",
          name: "Aquin",
          state_id: "1614",
        },
        {
          id: "20873",
          name: "Les Cayes",
          state_id: "1614",
        },
      ],
      "Sud-Est": [
        {
          id: "20874",
          name: "Jacmel",
          state_id: "1615",
        },
      ],
    },
  },
  HU: {
    name: "Hungary",
    native: "Magyarország",
    phone: "36",
    continent: "EU",
    capital: "Budapest",
    currency: "HUF",
    languages: ["hu"],
    emoji: "🇭🇺",
    emojiU: "U+1F1ED U+1F1FA",
    states: {
      "Bacs-Kiskun": [
        {
          id: "20915",
          name: "Akaszto",
          state_id: "1637",
        },
        {
          id: "20916",
          name: "Bacsalmas",
          state_id: "1637",
        },
        {
          id: "20917",
          name: "Bacsbokod",
          state_id: "1637",
        },
        {
          id: "20918",
          name: "Baja",
          state_id: "1637",
        },
        {
          id: "20919",
          name: "Bugac",
          state_id: "1637",
        },
        {
          id: "20920",
          name: "Davod",
          state_id: "1637",
        },
        {
          id: "20921",
          name: "Dunapataj",
          state_id: "1637",
        },
        {
          id: "20922",
          name: "Dunavecse",
          state_id: "1637",
        },
        {
          id: "20923",
          name: "Fulopszallas",
          state_id: "1637",
        },
        {
          id: "20924",
          name: "Hajos",
          state_id: "1637",
        },
        {
          id: "20925",
          name: "Harta",
          state_id: "1637",
        },
        {
          id: "20926",
          name: "Izsak",
          state_id: "1637",
        },
        {
          id: "20927",
          name: "Jakabszallas",
          state_id: "1637",
        },
        {
          id: "20928",
          name: "Janoshalma",
          state_id: "1637",
        },
        {
          id: "20929",
          name: "Kalocsa",
          state_id: "1637",
        },
        {
          id: "20930",
          name: "Kecel",
          state_id: "1637",
        },
        {
          id: "20931",
          name: "Kecskemet",
          state_id: "1637",
        },
        {
          id: "20932",
          name: "Kiskoros",
          state_id: "1637",
        },
        {
          id: "20933",
          name: "Kiskunfelegyhaza",
          state_id: "1637",
        },
        {
          id: "20934",
          name: "Kiskunhalas",
          state_id: "1637",
        },
        {
          id: "20935",
          name: "Kiskunmajsa",
          state_id: "1637",
        },
        {
          id: "20936",
          name: "Kunfeherto",
          state_id: "1637",
        },
        {
          id: "20937",
          name: "Kunszentmiklos",
          state_id: "1637",
        },
        {
          id: "20938",
          name: "Lajosmizse",
          state_id: "1637",
        },
        {
          id: "20939",
          name: "Lakitelek",
          state_id: "1637",
        },
        {
          id: "20940",
          name: "Madaras",
          state_id: "1637",
        },
        {
          id: "20941",
          name: "Melykut",
          state_id: "1637",
        },
        {
          id: "20942",
          name: "Nagybaracska",
          state_id: "1637",
        },
        {
          id: "20943",
          name: "Orgovany",
          state_id: "1637",
        },
        {
          id: "20944",
          name: "Palmonostora",
          state_id: "1637",
        },
        {
          id: "20945",
          name: "Solt",
          state_id: "1637",
        },
        {
          id: "20946",
          name: "Soltvadkert",
          state_id: "1637",
        },
        {
          id: "20947",
          name: "Sukosd",
          state_id: "1637",
        },
        {
          id: "20948",
          name: "Szabadszallas",
          state_id: "1637",
        },
        {
          id: "20949",
          name: "Szalkszentmarton",
          state_id: "1637",
        },
        {
          id: "20950",
          name: "Tass",
          state_id: "1637",
        },
        {
          id: "20951",
          name: "Tiszakecske",
          state_id: "1637",
        },
        {
          id: "20952",
          name: "Tompa",
          state_id: "1637",
        },
      ],
      Baranya: [
        {
          id: "20953",
          name: "Beremend",
          state_id: "1638",
        },
        {
          id: "20954",
          name: "Boly",
          state_id: "1638",
        },
        {
          id: "20955",
          name: "Dunaszekcso",
          state_id: "1638",
        },
        {
          id: "20956",
          name: "Harkany",
          state_id: "1638",
        },
        {
          id: "20957",
          name: "Hosszuheteny",
          state_id: "1638",
        },
        {
          id: "20958",
          name: "Komlo",
          state_id: "1638",
        },
        {
          id: "20959",
          name: "Magocs",
          state_id: "1638",
        },
        {
          id: "20960",
          name: "Mohacs",
          state_id: "1638",
        },
        {
          id: "20961",
          name: "Pecs",
          state_id: "1638",
        },
        {
          id: "20962",
          name: "Pecsvarad",
          state_id: "1638",
        },
        {
          id: "20963",
          name: "Sasd",
          state_id: "1638",
        },
        {
          id: "20964",
          name: "Sellye",
          state_id: "1638",
        },
        {
          id: "20965",
          name: "Siklos",
          state_id: "1638",
        },
        {
          id: "20966",
          name: "Szentlorinc",
          state_id: "1638",
        },
        {
          id: "20967",
          name: "Szigetvar",
          state_id: "1638",
        },
        {
          id: "20968",
          name: "Vajszlo",
          state_id: "1638",
        },
        {
          id: "20969",
          name: "Villany",
          state_id: "1638",
        },
      ],
      Bekes: [
        {
          id: "20970",
          name: "Battonya",
          state_id: "1639",
        },
        {
          id: "20971",
          name: "Bekes",
          state_id: "1639",
        },
        {
          id: "20972",
          name: "Bekescsaba",
          state_id: "1639",
        },
        {
          id: "20973",
          name: "Bekessamson",
          state_id: "1639",
        },
        {
          id: "20974",
          name: "Bekesszentandras",
          state_id: "1639",
        },
        {
          id: "20975",
          name: "Csorvas",
          state_id: "1639",
        },
        {
          id: "20976",
          name: "Devavanya",
          state_id: "1639",
        },
        {
          id: "20977",
          name: "Doboz",
          state_id: "1639",
        },
        {
          id: "20978",
          name: "Elek",
          state_id: "1639",
        },
        {
          id: "20979",
          name: "Endrod",
          state_id: "1639",
        },
        {
          id: "20980",
          name: "Fuzesgyarmat",
          state_id: "1639",
        },
        {
          id: "20981",
          name: "Gyula",
          state_id: "1639",
        },
        {
          id: "20982",
          name: "Ketegyhaza",
          state_id: "1639",
        },
        {
          id: "20983",
          name: "Kondoros",
          state_id: "1639",
        },
        {
          id: "20984",
          name: "Korosladany",
          state_id: "1639",
        },
        {
          id: "20985",
          name: "Kunagota",
          state_id: "1639",
        },
        {
          id: "20986",
          name: "Lokoshaza",
          state_id: "1639",
        },
        {
          id: "20987",
          name: "Mezobereny",
          state_id: "1639",
        },
        {
          id: "20988",
          name: "Mezohegyes",
          state_id: "1639",
        },
        {
          id: "20989",
          name: "Mezokovacshaza",
          state_id: "1639",
        },
        {
          id: "20990",
          name: "Nagyszenas",
          state_id: "1639",
        },
        {
          id: "20991",
          name: "Oroshaza",
          state_id: "1639",
        },
        {
          id: "20992",
          name: "Sarkad",
          state_id: "1639",
        },
        {
          id: "20993",
          name: "Szabadkigyos",
          state_id: "1639",
        },
        {
          id: "20994",
          name: "Szarvas",
          state_id: "1639",
        },
        {
          id: "20995",
          name: "Szeghalom",
          state_id: "1639",
        },
        {
          id: "20996",
          name: "Totkomlos",
          state_id: "1639",
        },
        {
          id: "20997",
          name: "Veszto",
          state_id: "1639",
        },
      ],
      "Borsod-Abauj-Zemplen": [
        {
          id: "20998",
          name: "Abaujszanto",
          state_id: "1640",
        },
        {
          id: "20999",
          name: "Arlo",
          state_id: "1640",
        },
        {
          id: "21000",
          name: "Bogacs",
          state_id: "1640",
        },
        {
          id: "21001",
          name: "Cigand",
          state_id: "1640",
        },
        {
          id: "21002",
          name: "Edeleny",
          state_id: "1640",
        },
        {
          id: "21003",
          name: "Emod",
          state_id: "1640",
        },
        {
          id: "21004",
          name: "Encs",
          state_id: "1640",
        },
        {
          id: "21005",
          name: "Gonc",
          state_id: "1640",
        },
        {
          id: "21006",
          name: "Karcsa",
          state_id: "1640",
        },
        {
          id: "21007",
          name: "Kazincbarcika",
          state_id: "1640",
        },
        {
          id: "21008",
          name: "Mad",
          state_id: "1640",
        },
        {
          id: "21009",
          name: "Megyaszo",
          state_id: "1640",
        },
        {
          id: "21010",
          name: "Mezokeresztes",
          state_id: "1640",
        },
        {
          id: "21011",
          name: "Mezokovesd",
          state_id: "1640",
        },
        {
          id: "21012",
          name: "Miskolc",
          state_id: "1640",
        },
        {
          id: "21013",
          name: "Monok",
          state_id: "1640",
        },
        {
          id: "21014",
          name: "Nyekladhaza",
          state_id: "1640",
        },
        {
          id: "21015",
          name: "Olaszliszka",
          state_id: "1640",
        },
        {
          id: "21016",
          name: "Onod",
          state_id: "1640",
        },
        {
          id: "21017",
          name: "Ozd",
          state_id: "1640",
        },
        {
          id: "21018",
          name: "Putnok",
          state_id: "1640",
        },
        {
          id: "21019",
          name: "Rudabanya",
          state_id: "1640",
        },
        {
          id: "21020",
          name: "Sajokaza",
          state_id: "1640",
        },
        {
          id: "21021",
          name: "Sajolad",
          state_id: "1640",
        },
        {
          id: "21022",
          name: "Sajoszentpeter",
          state_id: "1640",
        },
        {
          id: "21023",
          name: "Saly",
          state_id: "1640",
        },
        {
          id: "21024",
          name: "Sarospatak",
          state_id: "1640",
        },
        {
          id: "21025",
          name: "Satoraljaujhely",
          state_id: "1640",
        },
        {
          id: "21026",
          name: "Szendro",
          state_id: "1640",
        },
        {
          id: "21027",
          name: "Szentistvan",
          state_id: "1640",
        },
        {
          id: "21028",
          name: "Szerencs",
          state_id: "1640",
        },
        {
          id: "21029",
          name: "Szihalom",
          state_id: "1640",
        },
        {
          id: "21030",
          name: "Szikszo",
          state_id: "1640",
        },
        {
          id: "21031",
          name: "Taktaharkany",
          state_id: "1640",
        },
        {
          id: "21032",
          name: "Taktaszada",
          state_id: "1640",
        },
        {
          id: "21033",
          name: "Tallya",
          state_id: "1640",
        },
        {
          id: "21034",
          name: "Tarcal",
          state_id: "1640",
        },
        {
          id: "21035",
          name: "Tiszaluc",
          state_id: "1640",
        },
        {
          id: "21036",
          name: "Tiszaujvaros",
          state_id: "1640",
        },
        {
          id: "21037",
          name: "Tokaj",
          state_id: "1640",
        },
        {
          id: "21038",
          name: "Tolcsva",
          state_id: "1640",
        },
      ],
      Budapest: [
        {
          id: "21039",
          name: "Budapest",
          state_id: "1641",
        },
      ],
      Csongrad: [
        {
          id: "21040",
          name: "Csongrad",
          state_id: "1642",
        },
        {
          id: "21041",
          name: "Fabiansebestyen",
          state_id: "1642",
        },
        {
          id: "21042",
          name: "Foldeak",
          state_id: "1642",
        },
        {
          id: "21043",
          name: "Hodmezovasarhely",
          state_id: "1642",
        },
        {
          id: "21044",
          name: "Kiskundorozsma",
          state_id: "1642",
        },
        {
          id: "21045",
          name: "Kistelek",
          state_id: "1642",
        },
        {
          id: "21046",
          name: "Kiszombor",
          state_id: "1642",
        },
        {
          id: "21047",
          name: "Mako",
          state_id: "1642",
        },
        {
          id: "21048",
          name: "Mindszent",
          state_id: "1642",
        },
        {
          id: "21049",
          name: "Morahalom",
          state_id: "1642",
        },
        {
          id: "21050",
          name: "Pusztaszer",
          state_id: "1642",
        },
        {
          id: "21051",
          name: "Roszke",
          state_id: "1642",
        },
        {
          id: "21052",
          name: "Sandorfalva",
          state_id: "1642",
        },
        {
          id: "21053",
          name: "Szatymaz",
          state_id: "1642",
        },
        {
          id: "21054",
          name: "Szeged",
          state_id: "1642",
        },
        {
          id: "21055",
          name: "Szegvar",
          state_id: "1642",
        },
        {
          id: "21056",
          name: "Szekkutas",
          state_id: "1642",
        },
        {
          id: "21057",
          name: "Szentes",
          state_id: "1642",
        },
      ],
      Fejer: [
        {
          id: "21058",
          name: "Aba",
          state_id: "1643",
        },
        {
          id: "21059",
          name: "Adony",
          state_id: "1643",
        },
        {
          id: "21060",
          name: "Alap",
          state_id: "1643",
        },
        {
          id: "21061",
          name: "Apostag",
          state_id: "1643",
        },
        {
          id: "21062",
          name: "Bakonycsernye",
          state_id: "1643",
        },
        {
          id: "21063",
          name: "Bicske",
          state_id: "1643",
        },
        {
          id: "21064",
          name: "Bodajk",
          state_id: "1643",
        },
        {
          id: "21065",
          name: "Cece",
          state_id: "1643",
        },
        {
          id: "21066",
          name: "Csakvar",
          state_id: "1643",
        },
        {
          id: "21067",
          name: "Deg",
          state_id: "1643",
        },
        {
          id: "21068",
          name: "Dios",
          state_id: "1643",
        },
        {
          id: "21069",
          name: "Dunaujvaros",
          state_id: "1643",
        },
        {
          id: "21070",
          name: "Enying",
          state_id: "1643",
        },
        {
          id: "21071",
          name: "Ercsi",
          state_id: "1643",
        },
        {
          id: "21072",
          name: "Etyek",
          state_id: "1643",
        },
        {
          id: "21073",
          name: "Fehervarcsurgo",
          state_id: "1643",
        },
        {
          id: "21074",
          name: "Lovasbereny",
          state_id: "1643",
        },
        {
          id: "21075",
          name: "Martonvasar",
          state_id: "1643",
        },
        {
          id: "21076",
          name: "Mezofalva",
          state_id: "1643",
        },
        {
          id: "21077",
          name: "Mezoszilas",
          state_id: "1643",
        },
        {
          id: "21078",
          name: "Mor",
          state_id: "1643",
        },
        {
          id: "21079",
          name: "Pazmand",
          state_id: "1643",
        },
        {
          id: "21080",
          name: "Polgardi",
          state_id: "1643",
        },
        {
          id: "21081",
          name: "Pusztavam",
          state_id: "1643",
        },
        {
          id: "21082",
          name: "Rackeresztur",
          state_id: "1643",
        },
        {
          id: "21083",
          name: "Sarbogard",
          state_id: "1643",
        },
        {
          id: "21084",
          name: "Seregelyes",
          state_id: "1643",
        },
        {
          id: "21085",
          name: "Soponya",
          state_id: "1643",
        },
        {
          id: "21086",
          name: "Szabadbattyan",
          state_id: "1643",
        },
        {
          id: "21087",
          name: "Szekesfehervar",
          state_id: "1643",
        },
        {
          id: "21088",
          name: "Val",
          state_id: "1643",
        },
      ],
      "Gyor-Moson-Sopron": [
        {
          id: "21089",
          name: "Asvanyraro",
          state_id: "1644",
        },
        {
          id: "21090",
          name: "Beled",
          state_id: "1644",
        },
        {
          id: "21091",
          name: "Bosarkany",
          state_id: "1644",
        },
        {
          id: "21092",
          name: "Csorna",
          state_id: "1644",
        },
        {
          id: "21093",
          name: "Fertod",
          state_id: "1644",
        },
        {
          id: "21094",
          name: "Fertorakos",
          state_id: "1644",
        },
        {
          id: "21095",
          name: "Fertoszentmiklos",
          state_id: "1644",
        },
        {
          id: "21096",
          name: "Gyor",
          state_id: "1644",
        },
        {
          id: "21097",
          name: "Gyorujbarat",
          state_id: "1644",
        },
        {
          id: "21098",
          name: "Hunyadi u.",
          state_id: "1644",
        },
        {
          id: "21099",
          name: "Kapuvar",
          state_id: "1644",
        },
        {
          id: "21100",
          name: "Lebeny",
          state_id: "1644",
        },
        {
          id: "21101",
          name: "Mihalyi",
          state_id: "1644",
        },
        {
          id: "21102",
          name: "Mosonmagyarovar",
          state_id: "1644",
        },
        {
          id: "21103",
          name: "Nyul",
          state_id: "1644",
        },
        {
          id: "21104",
          name: "Pannonhalma",
          state_id: "1644",
        },
        {
          id: "21105",
          name: "Rajka",
          state_id: "1644",
        },
        {
          id: "21106",
          name: "Sopron",
          state_id: "1644",
        },
        {
          id: "21107",
          name: "Szany",
          state_id: "1644",
        },
        {
          id: "21108",
          name: "Tet",
          state_id: "1644",
        },
      ],
      "Hajdu-Bihar": [
        {
          id: "21109",
          name: "Balmazujvaros",
          state_id: "1645",
        },
        {
          id: "21110",
          name: "Barand",
          state_id: "1645",
        },
        {
          id: "21111",
          name: "Berettyoujfalu",
          state_id: "1645",
        },
        {
          id: "21112",
          name: "Biharkeresztes",
          state_id: "1645",
        },
        {
          id: "21113",
          name: "Biharnagybajom",
          state_id: "1645",
        },
        {
          id: "21114",
          name: "Debrecen",
          state_id: "1645",
        },
        {
          id: "21115",
          name: "Derecske",
          state_id: "1645",
        },
        {
          id: "21116",
          name: "Egyek",
          state_id: "1645",
        },
        {
          id: "21117",
          name: "Foldes",
          state_id: "1645",
        },
        {
          id: "21118",
          name: "Hajduboszormeny",
          state_id: "1645",
        },
        {
          id: "21119",
          name: "Hajdudorog",
          state_id: "1645",
        },
        {
          id: "21120",
          name: "Hajduhadhaz",
          state_id: "1645",
        },
        {
          id: "21121",
          name: "Hajdusamson",
          state_id: "1645",
        },
        {
          id: "21122",
          name: "Hajduszoboszlo",
          state_id: "1645",
        },
        {
          id: "21123",
          name: "Hajduszovat",
          state_id: "1645",
        },
        {
          id: "21124",
          name: "Hortobagy",
          state_id: "1645",
        },
        {
          id: "21125",
          name: "Hosszupalyi",
          state_id: "1645",
        },
        {
          id: "21126",
          name: "Kaba",
          state_id: "1645",
        },
        {
          id: "21127",
          name: "Komadi",
          state_id: "1645",
        },
        {
          id: "21128",
          name: "Mikepercs",
          state_id: "1645",
        },
        {
          id: "21129",
          name: "Monostorpalyi",
          state_id: "1645",
        },
        {
          id: "21130",
          name: "Nadudvar",
          state_id: "1645",
        },
        {
          id: "21131",
          name: "Nagyleta",
          state_id: "1645",
        },
        {
          id: "21132",
          name: "Nyirabrany",
          state_id: "1645",
        },
        {
          id: "21133",
          name: "Nyiracsad",
          state_id: "1645",
        },
        {
          id: "21134",
          name: "Nyiradony",
          state_id: "1645",
        },
        {
          id: "21135",
          name: "Polgar",
          state_id: "1645",
        },
        {
          id: "21136",
          name: "Puspokladany",
          state_id: "1645",
        },
        {
          id: "21137",
          name: "Sarretudvari",
          state_id: "1645",
        },
        {
          id: "21138",
          name: "Tiszacsege",
          state_id: "1645",
        },
        {
          id: "21139",
          name: "Ujfeherto",
          state_id: "1645",
        },
        {
          id: "21140",
          name: "Vamospercs",
          state_id: "1645",
        },
      ],
      Heves: [
        {
          id: "21141",
          name: "Abasar",
          state_id: "1646",
        },
        {
          id: "21142",
          name: "Andornaktalya",
          state_id: "1646",
        },
        {
          id: "21143",
          name: "Belapatfalva",
          state_id: "1646",
        },
        {
          id: "21144",
          name: "Domoszlo",
          state_id: "1646",
        },
        {
          id: "21145",
          name: "Eger",
          state_id: "1646",
        },
        {
          id: "21146",
          name: "Erdotelek",
          state_id: "1646",
        },
        {
          id: "21147",
          name: "Felsotarkany",
          state_id: "1646",
        },
        {
          id: "21148",
          name: "Fuzesabony",
          state_id: "1646",
        },
        {
          id: "21149",
          name: "Gyongyos",
          state_id: "1646",
        },
        {
          id: "21150",
          name: "Gyongyospata",
          state_id: "1646",
        },
        {
          id: "21151",
          name: "Gyongyossolymos",
          state_id: "1646",
        },
        {
          id: "21152",
          name: "Gyongyostarjan",
          state_id: "1646",
        },
        {
          id: "21153",
          name: "Hatvan",
          state_id: "1646",
        },
        {
          id: "21154",
          name: "Heves",
          state_id: "1646",
        },
        {
          id: "21155",
          name: "Kal",
          state_id: "1646",
        },
        {
          id: "21156",
          name: "Lorinci",
          state_id: "1646",
        },
        {
          id: "21157",
          name: "Matraderecske",
          state_id: "1646",
        },
        {
          id: "21158",
          name: "Parad",
          state_id: "1646",
        },
        {
          id: "21159",
          name: "Petervasara",
          state_id: "1646",
        },
        {
          id: "21160",
          name: "Recsk",
          state_id: "1646",
        },
        {
          id: "21161",
          name: "Sirok",
          state_id: "1646",
        },
        {
          id: "21162",
          name: "Tarnalelesz",
          state_id: "1646",
        },
        {
          id: "21163",
          name: "Verpelet",
          state_id: "1646",
        },
      ],
      "Jasz-Nagykun-Szolnok": [
        {
          id: "21164",
          name: "Abadszalok",
          state_id: "1647",
        },
        {
          id: "21165",
          name: "Besenyszog",
          state_id: "1647",
        },
        {
          id: "21166",
          name: "Cserkeszolo",
          state_id: "1647",
        },
        {
          id: "21167",
          name: "Fegyvernek",
          state_id: "1647",
        },
        {
          id: "21168",
          name: "Hegyeshalom",
          state_id: "1647",
        },
        {
          id: "21169",
          name: "Jaszalsoszentgyorgy",
          state_id: "1647",
        },
        {
          id: "21170",
          name: "Jaszapati",
          state_id: "1647",
        },
        {
          id: "21171",
          name: "Jaszarokszallas",
          state_id: "1647",
        },
        {
          id: "21172",
          name: "Jaszbereny",
          state_id: "1647",
        },
        {
          id: "21173",
          name: "Jaszfenyzaru",
          state_id: "1647",
        },
        {
          id: "21174",
          name: "Jaszjakohalma",
          state_id: "1647",
        },
        {
          id: "21175",
          name: "Jaszkiser",
          state_id: "1647",
        },
        {
          id: "21176",
          name: "Jaszladany",
          state_id: "1647",
        },
        {
          id: "21177",
          name: "Jaszszentandras",
          state_id: "1647",
        },
        {
          id: "21178",
          name: "Karcag",
          state_id: "1647",
        },
        {
          id: "21179",
          name: "Kenderes",
          state_id: "1647",
        },
        {
          id: "21180",
          name: "Kisujszallas",
          state_id: "1647",
        },
        {
          id: "21181",
          name: "Kunhegyes",
          state_id: "1647",
        },
        {
          id: "21182",
          name: "Kunmadaras",
          state_id: "1647",
        },
        {
          id: "21183",
          name: "Kunszentmarton",
          state_id: "1647",
        },
        {
          id: "21184",
          name: "Martfu",
          state_id: "1647",
        },
        {
          id: "21185",
          name: "Mezotur",
          state_id: "1647",
        },
        {
          id: "21186",
          name: "Ocsod",
          state_id: "1647",
        },
        {
          id: "21187",
          name: "Szolnok",
          state_id: "1647",
        },
        {
          id: "21188",
          name: "Tiszabura",
          state_id: "1647",
        },
        {
          id: "21189",
          name: "Tiszafoldvar",
          state_id: "1647",
        },
        {
          id: "21190",
          name: "Tiszafured",
          state_id: "1647",
        },
        {
          id: "21191",
          name: "Tiszapuspoki",
          state_id: "1647",
        },
        {
          id: "21192",
          name: "Tiszaroff",
          state_id: "1647",
        },
        {
          id: "21193",
          name: "Tiszasuly",
          state_id: "1647",
        },
        {
          id: "21194",
          name: "Torokszentmiklos",
          state_id: "1647",
        },
        {
          id: "21195",
          name: "Toszeg",
          state_id: "1647",
        },
        {
          id: "21196",
          name: "Turkeve",
          state_id: "1647",
        },
        {
          id: "21197",
          name: "Ujszasz",
          state_id: "1647",
        },
      ],
      "Komarom-Esztergom": [
        {
          id: "21198",
          name: "Acs",
          state_id: "1648",
        },
        {
          id: "21199",
          name: "Almasfuzito",
          state_id: "1648",
        },
        {
          id: "21200",
          name: "Babolna",
          state_id: "1648",
        },
        {
          id: "21201",
          name: "Bajna",
          state_id: "1648",
        },
        {
          id: "21202",
          name: "Dorog",
          state_id: "1648",
        },
        {
          id: "21203",
          name: "Esztergom",
          state_id: "1648",
        },
        {
          id: "21204",
          name: "Kesztolc",
          state_id: "1648",
        },
        {
          id: "21205",
          name: "Kisber",
          state_id: "1648",
        },
        {
          id: "21206",
          name: "Komarom",
          state_id: "1648",
        },
        {
          id: "21207",
          name: "Kornye",
          state_id: "1648",
        },
        {
          id: "21208",
          name: "Labatlan",
          state_id: "1648",
        },
        {
          id: "21209",
          name: "Mocsa",
          state_id: "1648",
        },
        {
          id: "21210",
          name: "Nagyigmand",
          state_id: "1648",
        },
        {
          id: "21211",
          name: "Nyergesujfalu",
          state_id: "1648",
        },
        {
          id: "21212",
          name: "Oroszlany",
          state_id: "1648",
        },
        {
          id: "21213",
          name: "Sarisap",
          state_id: "1648",
        },
        {
          id: "21214",
          name: "Tardos",
          state_id: "1648",
        },
        {
          id: "21215",
          name: "Tarjan",
          state_id: "1648",
        },
        {
          id: "21216",
          name: "Tata",
          state_id: "1648",
        },
        {
          id: "21217",
          name: "Tatabanya",
          state_id: "1648",
        },
        {
          id: "21218",
          name: "Tokod",
          state_id: "1648",
        },
        {
          id: "21219",
          name: "Vertesszolos",
          state_id: "1648",
        },
      ],
      Nograd: [
        {
          id: "21220",
          name: "Balassagyarmat",
          state_id: "1649",
        },
        {
          id: "21221",
          name: "Batonyterenye",
          state_id: "1649",
        },
        {
          id: "21222",
          name: "Bercel",
          state_id: "1649",
        },
        {
          id: "21223",
          name: "Bujak",
          state_id: "1649",
        },
        {
          id: "21224",
          name: "Diosjeno",
          state_id: "1649",
        },
        {
          id: "21225",
          name: "Karancskeszi",
          state_id: "1649",
        },
        {
          id: "21226",
          name: "Matraverebely",
          state_id: "1649",
        },
        {
          id: "21227",
          name: "Nagyoroszi",
          state_id: "1649",
        },
        {
          id: "21228",
          name: "Paszto",
          state_id: "1649",
        },
        {
          id: "21229",
          name: "Retsag",
          state_id: "1649",
        },
        {
          id: "21230",
          name: "Romhany",
          state_id: "1649",
        },
        {
          id: "21231",
          name: "Salgotarjan",
          state_id: "1649",
        },
        {
          id: "21232",
          name: "Szecseny",
          state_id: "1649",
        },
        {
          id: "21233",
          name: "Tar",
          state_id: "1649",
        },
      ],
      Pest: [
        {
          id: "21234",
          name: "Abony",
          state_id: "1650",
        },
        {
          id: "21235",
          name: "Albertirsa",
          state_id: "1650",
        },
        {
          id: "21236",
          name: "Aszod",
          state_id: "1650",
        },
        {
          id: "21237",
          name: "Biatorbagy",
          state_id: "1650",
        },
        {
          id: "21238",
          name: "Budakalasz",
          state_id: "1650",
        },
        {
          id: "21239",
          name: "Budakeszi",
          state_id: "1650",
        },
        {
          id: "21240",
          name: "Budaors",
          state_id: "1650",
        },
        {
          id: "21241",
          name: "Bugyi",
          state_id: "1650",
        },
        {
          id: "21242",
          name: "Cegled",
          state_id: "1650",
        },
        {
          id: "21243",
          name: "Csobanka",
          state_id: "1650",
        },
        {
          id: "21244",
          name: "Dabas",
          state_id: "1650",
        },
        {
          id: "21245",
          name: "Domsod",
          state_id: "1650",
        },
        {
          id: "21246",
          name: "Dunabogdany",
          state_id: "1650",
        },
        {
          id: "21247",
          name: "Dunaharaszti",
          state_id: "1650",
        },
        {
          id: "21248",
          name: "Dunakeszi",
          state_id: "1650",
        },
        {
          id: "21249",
          name: "Erd",
          state_id: "1650",
        },
        {
          id: "21250",
          name: "Forro",
          state_id: "1650",
        },
        {
          id: "21251",
          name: "Fot",
          state_id: "1650",
        },
        {
          id: "21252",
          name: "Galgaheviz",
          state_id: "1650",
        },
        {
          id: "21253",
          name: "God",
          state_id: "1650",
        },
        {
          id: "21254",
          name: "Godollo",
          state_id: "1650",
        },
        {
          id: "21255",
          name: "Gyomro",
          state_id: "1650",
        },
        {
          id: "21256",
          name: "Hevizgyork",
          state_id: "1650",
        },
        {
          id: "21257",
          name: "Isaszeg",
          state_id: "1650",
        },
        {
          id: "21258",
          name: "Jaszkarajeno",
          state_id: "1650",
        },
        {
          id: "21259",
          name: "Kiskunlachaza",
          state_id: "1650",
        },
        {
          id: "21260",
          name: "Kocser",
          state_id: "1650",
        },
        {
          id: "21261",
          name: "Koka",
          state_id: "1650",
        },
        {
          id: "21262",
          name: "Kosd",
          state_id: "1650",
        },
        {
          id: "21263",
          name: "Maglod",
          state_id: "1650",
        },
        {
          id: "21264",
          name: "Monor",
          state_id: "1650",
        },
        {
          id: "21265",
          name: "Nagykata",
          state_id: "1650",
        },
        {
          id: "21266",
          name: "Nagykoros",
          state_id: "1650",
        },
        {
          id: "21267",
          name: "Nagykovacsi",
          state_id: "1650",
        },
        {
          id: "21268",
          name: "Nagymaros",
          state_id: "1650",
        },
        {
          id: "21269",
          name: "Nagytarcsa",
          state_id: "1650",
        },
        {
          id: "21270",
          name: "Nyaregyhaza",
          state_id: "1650",
        },
        {
          id: "21271",
          name: "Ocsa",
          state_id: "1650",
        },
        {
          id: "21272",
          name: "Orbottyan",
          state_id: "1650",
        },
        {
          id: "21273",
          name: "Orkeny",
          state_id: "1650",
        },
        {
          id: "21274",
          name: "Paty",
          state_id: "1650",
        },
        {
          id: "21275",
          name: "Pecel",
          state_id: "1650",
        },
        {
          id: "21276",
          name: "Perbal",
          state_id: "1650",
        },
        {
          id: "21277",
          name: "Pilis",
          state_id: "1650",
        },
        {
          id: "21278",
          name: "Pilisborosjeno",
          state_id: "1650",
        },
        {
          id: "21279",
          name: "Piliscsaba",
          state_id: "1650",
        },
        {
          id: "21280",
          name: "Pilisszanto",
          state_id: "1650",
        },
        {
          id: "21281",
          name: "Pilisszentivan",
          state_id: "1650",
        },
        {
          id: "21282",
          name: "Pilisszentkereszt",
          state_id: "1650",
        },
        {
          id: "21283",
          name: "Pilisvorosvar",
          state_id: "1650",
        },
        {
          id: "21284",
          name: "Pomaz",
          state_id: "1650",
        },
        {
          id: "21285",
          name: "Racalmas",
          state_id: "1650",
        },
        {
          id: "21286",
          name: "Rackeve",
          state_id: "1650",
        },
        {
          id: "21287",
          name: "Solymar",
          state_id: "1650",
        },
        {
          id: "21288",
          name: "Soskut",
          state_id: "1650",
        },
        {
          id: "21289",
          name: "Szada",
          state_id: "1650",
        },
        {
          id: "21290",
          name: "Szazhalombatta",
          state_id: "1650",
        },
        {
          id: "21291",
          name: "Szentendre",
          state_id: "1650",
        },
        {
          id: "21292",
          name: "Szentmartonkata",
          state_id: "1650",
        },
        {
          id: "21293",
          name: "Szigetcsep",
          state_id: "1650",
        },
        {
          id: "21294",
          name: "Szigetszentmiklos",
          state_id: "1650",
        },
        {
          id: "21295",
          name: "Szigetujfalu",
          state_id: "1650",
        },
        {
          id: "21296",
          name: "Szob",
          state_id: "1650",
        },
        {
          id: "21297",
          name: "Tahitofalu",
          state_id: "1650",
        },
        {
          id: "21298",
          name: "Tapiobicske",
          state_id: "1650",
        },
        {
          id: "21299",
          name: "Tapioszecso",
          state_id: "1650",
        },
        {
          id: "21300",
          name: "Tapioszele",
          state_id: "1650",
        },
        {
          id: "21301",
          name: "Toalmas",
          state_id: "1650",
        },
        {
          id: "21302",
          name: "Torokbalint",
          state_id: "1650",
        },
        {
          id: "21303",
          name: "Tortel",
          state_id: "1650",
        },
        {
          id: "21304",
          name: "Tura",
          state_id: "1650",
        },
        {
          id: "21305",
          name: "Ullo",
          state_id: "1650",
        },
        {
          id: "21306",
          name: "Uri",
          state_id: "1650",
        },
        {
          id: "21307",
          name: "Urom",
          state_id: "1650",
        },
        {
          id: "21308",
          name: "Vac",
          state_id: "1650",
        },
        {
          id: "21309",
          name: "Vecses",
          state_id: "1650",
        },
        {
          id: "21310",
          name: "Veresegyhaz",
          state_id: "1650",
        },
        {
          id: "21311",
          name: "Verocemaros",
          state_id: "1650",
        },
        {
          id: "21312",
          name: "Visegrad",
          state_id: "1650",
        },
        {
          id: "21313",
          name: "Zsambek",
          state_id: "1650",
        },
        {
          id: "21314",
          name: "Zsambok",
          state_id: "1650",
        },
      ],
      Somogy: [
        {
          id: "21315",
          name: "Adand",
          state_id: "1651",
        },
        {
          id: "21316",
          name: "Balatonfoldvar",
          state_id: "1651",
        },
        {
          id: "21317",
          name: "Balatonoszod",
          state_id: "1651",
        },
        {
          id: "21318",
          name: "Balatonszabadi",
          state_id: "1651",
        },
        {
          id: "21319",
          name: "Balatonszarszo",
          state_id: "1651",
        },
        {
          id: "21320",
          name: "Barcs",
          state_id: "1651",
        },
        {
          id: "21321",
          name: "Berzence",
          state_id: "1651",
        },
        {
          id: "21322",
          name: "Boglarlelle",
          state_id: "1651",
        },
        {
          id: "21323",
          name: "Bohonye",
          state_id: "1651",
        },
        {
          id: "21324",
          name: "Csurgo",
          state_id: "1651",
        },
        {
          id: "21325",
          name: "Fonyod",
          state_id: "1651",
        },
        {
          id: "21326",
          name: "Kaposvar",
          state_id: "1651",
        },
        {
          id: "21327",
          name: "Karad",
          state_id: "1651",
        },
        {
          id: "21328",
          name: "Kethely",
          state_id: "1651",
        },
        {
          id: "21329",
          name: "Lengyeltoti",
          state_id: "1651",
        },
        {
          id: "21330",
          name: "Marcali",
          state_id: "1651",
        },
        {
          id: "21331",
          name: "Nagyatad",
          state_id: "1651",
        },
        {
          id: "21332",
          name: "Nagybajom",
          state_id: "1651",
        },
        {
          id: "21333",
          name: "Siofok",
          state_id: "1651",
        },
        {
          id: "21334",
          name: "Somogyvar",
          state_id: "1651",
        },
        {
          id: "21335",
          name: "Tab",
          state_id: "1651",
        },
        {
          id: "21336",
          name: "Zamardi",
          state_id: "1651",
        },
      ],
      "Szabolcs-Szatmar-Bereg": [
        {
          id: "21337",
          name: "Ajak",
          state_id: "1652",
        },
        {
          id: "21338",
          name: "Baktaloranthaza",
          state_id: "1652",
        },
        {
          id: "21339",
          name: "Balkany",
          state_id: "1652",
        },
        {
          id: "21340",
          name: "Buj",
          state_id: "1652",
        },
        {
          id: "21341",
          name: "Demecser",
          state_id: "1652",
        },
        {
          id: "21342",
          name: "Dombrad",
          state_id: "1652",
        },
        {
          id: "21343",
          name: "Fehergyarmat",
          state_id: "1652",
        },
        {
          id: "21344",
          name: "Ibrany",
          state_id: "1652",
        },
        {
          id: "21345",
          name: "Kemecse",
          state_id: "1652",
        },
        {
          id: "21346",
          name: "Kisvarda",
          state_id: "1652",
        },
        {
          id: "21347",
          name: "Kotaj",
          state_id: "1652",
        },
        {
          id: "21348",
          name: "Mandok",
          state_id: "1652",
        },
        {
          id: "21349",
          name: "Mariapocs",
          state_id: "1652",
        },
        {
          id: "21350",
          name: "Mateszalka",
          state_id: "1652",
        },
        {
          id: "21351",
          name: "Nagyecsed",
          state_id: "1652",
        },
        {
          id: "21352",
          name: "Nagyhalasz",
          state_id: "1652",
        },
        {
          id: "21353",
          name: "Nagykallo",
          state_id: "1652",
        },
        {
          id: "21354",
          name: "Nyirbator",
          state_id: "1652",
        },
        {
          id: "21355",
          name: "Nyirbeltek",
          state_id: "1652",
        },
        {
          id: "21356",
          name: "Nyiregyhaza",
          state_id: "1652",
        },
        {
          id: "21357",
          name: "Nyirmada",
          state_id: "1652",
        },
        {
          id: "21358",
          name: "Nyirpazony",
          state_id: "1652",
        },
        {
          id: "21359",
          name: "Nyirtelek",
          state_id: "1652",
        },
        {
          id: "21360",
          name: "Ofeherto",
          state_id: "1652",
        },
        {
          id: "21361",
          name: "Rakamaz",
          state_id: "1652",
        },
        {
          id: "21362",
          name: "Tarpa",
          state_id: "1652",
        },
        {
          id: "21363",
          name: "Tiszabercel",
          state_id: "1652",
        },
        {
          id: "21364",
          name: "Tiszalok",
          state_id: "1652",
        },
        {
          id: "21365",
          name: "Tiszavasvari",
          state_id: "1652",
        },
        {
          id: "21366",
          name: "Tuzser",
          state_id: "1652",
        },
        {
          id: "21367",
          name: "Vaja",
          state_id: "1652",
        },
        {
          id: "21368",
          name: "Vasarosnameny",
          state_id: "1652",
        },
        {
          id: "21369",
          name: "Zahony",
          state_id: "1652",
        },
      ],
      Tolna: [
        {
          id: "21370",
          name: "Bataszek",
          state_id: "1653",
        },
        {
          id: "21371",
          name: "Bonyhad",
          state_id: "1653",
        },
        {
          id: "21372",
          name: "Decs",
          state_id: "1653",
        },
        {
          id: "21373",
          name: "Dombovar",
          state_id: "1653",
        },
        {
          id: "21374",
          name: "Dunafoldvar",
          state_id: "1653",
        },
        {
          id: "21375",
          name: "Fadd",
          state_id: "1653",
        },
        {
          id: "21376",
          name: "Gyonk",
          state_id: "1653",
        },
        {
          id: "21377",
          name: "Hogyesz",
          state_id: "1653",
        },
        {
          id: "21378",
          name: "Iregszemcse",
          state_id: "1653",
        },
        {
          id: "21379",
          name: "Madocsa",
          state_id: "1653",
        },
        {
          id: "21380",
          name: "Nagymagocs",
          state_id: "1653",
        },
        {
          id: "21381",
          name: "Nagymanyok",
          state_id: "1653",
        },
        {
          id: "21382",
          name: "Ozora",
          state_id: "1653",
        },
        {
          id: "21383",
          name: "Paks",
          state_id: "1653",
        },
        {
          id: "21384",
          name: "Pincehely",
          state_id: "1653",
        },
        {
          id: "21385",
          name: "Simontornya",
          state_id: "1653",
        },
        {
          id: "21386",
          name: "Szekszard",
          state_id: "1653",
        },
        {
          id: "21387",
          name: "Szentgal",
          state_id: "1653",
        },
        {
          id: "21388",
          name: "Tamasi",
          state_id: "1653",
        },
        {
          id: "21389",
          name: "Tengelic",
          state_id: "1653",
        },
        {
          id: "21390",
          name: "Tolna",
          state_id: "1653",
        },
        {
          id: "21391",
          name: "Zomba",
          state_id: "1653",
        },
      ],
      Vas: [
        {
          id: "21392",
          name: "Buk",
          state_id: "1654",
        },
        {
          id: "21393",
          name: "Celldomolk",
          state_id: "1654",
        },
        {
          id: "21394",
          name: "Csepreg",
          state_id: "1654",
        },
        {
          id: "21395",
          name: "Gencsapati",
          state_id: "1654",
        },
        {
          id: "21396",
          name: "Jak",
          state_id: "1654",
        },
        {
          id: "21397",
          name: "Janoshaza",
          state_id: "1654",
        },
        {
          id: "21398",
          name: "Kormend",
          state_id: "1654",
        },
        {
          id: "21399",
          name: "Koszeg",
          state_id: "1654",
        },
        {
          id: "21400",
          name: "Sarvar",
          state_id: "1654",
        },
        {
          id: "21401",
          name: "Szentgotthard",
          state_id: "1654",
        },
        {
          id: "21402",
          name: "Szombathely",
          state_id: "1654",
        },
        {
          id: "21403",
          name: "Vasvar",
          state_id: "1654",
        },
        {
          id: "21404",
          name: "Vep",
          state_id: "1654",
        },
      ],
      Veszprem: [
        {
          id: "21405",
          name: "Ajka",
          state_id: "1655",
        },
        {
          id: "21406",
          name: "Badacsonytomaj",
          state_id: "1655",
        },
        {
          id: "21407",
          name: "Balatonalmadi",
          state_id: "1655",
        },
        {
          id: "21408",
          name: "Balatonfured",
          state_id: "1655",
        },
        {
          id: "21409",
          name: "Balatonfuzfo",
          state_id: "1655",
        },
        {
          id: "21410",
          name: "Balatonkenese",
          state_id: "1655",
        },
        {
          id: "21411",
          name: "Band",
          state_id: "1655",
        },
        {
          id: "21412",
          name: "Berhida",
          state_id: "1655",
        },
        {
          id: "21413",
          name: "Csabrendek",
          state_id: "1655",
        },
        {
          id: "21414",
          name: "Devecser",
          state_id: "1655",
        },
        {
          id: "21415",
          name: "Herend",
          state_id: "1655",
        },
        {
          id: "21416",
          name: "Papa",
          state_id: "1655",
        },
        {
          id: "21417",
          name: "Sumeg",
          state_id: "1655",
        },
        {
          id: "21418",
          name: "Tapolca",
          state_id: "1655",
        },
        {
          id: "21419",
          name: "Urkut",
          state_id: "1655",
        },
        {
          id: "21420",
          name: "Varpalota",
          state_id: "1655",
        },
        {
          id: "21421",
          name: "Veszprem",
          state_id: "1655",
        },
        {
          id: "21422",
          name: "Zirc",
          state_id: "1655",
        },
      ],
      Zala: [
        {
          id: "21423",
          name: "Becsehely",
          state_id: "1656",
        },
        {
          id: "21424",
          name: "Heviz",
          state_id: "1656",
        },
        {
          id: "21425",
          name: "Keszthely",
          state_id: "1656",
        },
        {
          id: "21426",
          name: "Lenti",
          state_id: "1656",
        },
        {
          id: "21427",
          name: "Letenye",
          state_id: "1656",
        },
        {
          id: "21428",
          name: "Nagykanizsa",
          state_id: "1656",
        },
        {
          id: "21429",
          name: "Sarmellek",
          state_id: "1656",
        },
        {
          id: "21430",
          name: "Turje",
          state_id: "1656",
        },
        {
          id: "21431",
          name: "Zalaegerszeg",
          state_id: "1656",
        },
        {
          id: "21432",
          name: "Zalakomar",
          state_id: "1656",
        },
        {
          id: "21433",
          name: "Zalalovo",
          state_id: "1656",
        },
        {
          id: "21434",
          name: "Zalaszentgrot",
          state_id: "1656",
        },
      ],
    },
  },
  ID: {
    name: "Indonesia",
    native: "Indonesia",
    phone: "62",
    continent: "AS",
    capital: "Jakarta",
    currency: "IDR",
    languages: ["id"],
    emoji: "🇮🇩",
    emojiU: "U+1F1EE U+1F1E9",
    states: {
      Aceh: [
        {
          id: "21460",
          name: "Banda Aceh",
          state_id: "1666",
        },
        {
          id: "21461",
          name: "Bireun",
          state_id: "1666",
        },
        {
          id: "21462",
          name: "Langsa",
          state_id: "1666",
        },
        {
          id: "21463",
          name: "Lhokseumawe",
          state_id: "1666",
        },
        {
          id: "21464",
          name: "Meulaboh",
          state_id: "1666",
        },
      ],
      Bali: [
        {
          id: "21465",
          name: "Denpasar",
          state_id: "1667",
        },
        {
          id: "21466",
          name: "Karangasem",
          state_id: "1667",
        },
        {
          id: "21467",
          name: "Klungkung",
          state_id: "1667",
        },
        {
          id: "21468",
          name: "Kuta",
          state_id: "1667",
        },
        {
          id: "21469",
          name: "Negara",
          state_id: "1667",
        },
        {
          id: "21470",
          name: "Singaraja",
          state_id: "1667",
        },
        {
          id: "21471",
          name: "Tabanan",
          state_id: "1667",
        },
        {
          id: "21472",
          name: "Ubud",
          state_id: "1667",
        },
      ],
      "Bangka-Belitung": [
        {
          id: "21473",
          name: "Manggar",
          state_id: "1668",
        },
        {
          id: "21474",
          name: "Mentok",
          state_id: "1668",
        },
        {
          id: "21475",
          name: "Pangkal Pinang",
          state_id: "1668",
        },
        {
          id: "21476",
          name: "Sungai Liat",
          state_id: "1668",
        },
        {
          id: "21477",
          name: "Tanjung Pandan",
          state_id: "1668",
        },
        {
          id: "21478",
          name: "Toboali-Rias",
          state_id: "1668",
        },
      ],
      Banten: [
        {
          id: "21479",
          name: "Cikupa",
          state_id: "1669",
        },
        {
          id: "21480",
          name: "Cilegon",
          state_id: "1669",
        },
        {
          id: "21481",
          name: "Ciputat",
          state_id: "1669",
        },
        {
          id: "21482",
          name: "Curug",
          state_id: "1669",
        },
        {
          id: "21483",
          name: "Kresek",
          state_id: "1669",
        },
        {
          id: "21484",
          name: "Labuhan",
          state_id: "1669",
        },
        {
          id: "21485",
          name: "Pandegelang",
          state_id: "1669",
        },
        {
          id: "21486",
          name: "Pondok Aren",
          state_id: "1669",
        },
        {
          id: "21487",
          name: "Rangkasbitung",
          state_id: "1669",
        },
        {
          id: "21488",
          name: "Serang",
          state_id: "1669",
        },
        {
          id: "21489",
          name: "Serpong",
          state_id: "1669",
        },
        {
          id: "21490",
          name: "Tangerang",
          state_id: "1669",
        },
        {
          id: "21491",
          name: "Teluknaga",
          state_id: "1669",
        },
      ],
      Bengkulu: [
        {
          id: "21492",
          name: "Bengkulu",
          state_id: "1670",
        },
        {
          id: "21493",
          name: "Curup",
          state_id: "1670",
        },
      ],
      Gandaria: [
        {
          id: "21494",
          name: "Gandaria",
          state_id: "1671",
        },
      ],
      Gorontalo: [
        {
          id: "21495",
          name: "Gorontalo",
          state_id: "1672",
        },
      ],
      Jakarta: [
        {
          id: "21496",
          name: "Cengkareng",
          state_id: "1673",
        },
        {
          id: "21497",
          name: "Jakarta",
          state_id: "1673",
        },
      ],
      Jambi: [
        {
          id: "21498",
          name: "Jambi",
          state_id: "1674",
        },
        {
          id: "21499",
          name: "Kualatungka",
          state_id: "1674",
        },
        {
          id: "21500",
          name: "Simpang",
          state_id: "1674",
        },
        {
          id: "21501",
          name: "Sungaipenuh",
          state_id: "1674",
        },
      ],
      "Jawa Barat": [],
      "Jawa Tengah": [],
      "Jawa Timur": [],
      "Kalimantan Barat": [],
      "Kalimantan Selatan": [],
      "Kalimantan Tengah": [],
      "Kalimantan Timur": [],
      Kendal: [
        {
          id: "21502",
          name: "Kendal",
          state_id: "1682",
        },
      ],
      Lampung: [
        {
          id: "21503",
          name: "Bandar Lampung",
          state_id: "1683",
        },
        {
          id: "21504",
          name: "Kota Bumi",
          state_id: "1683",
        },
        {
          id: "21505",
          name: "Metro",
          state_id: "1683",
        },
        {
          id: "21506",
          name: "Pringsewu",
          state_id: "1683",
        },
        {
          id: "21507",
          name: "Terbanggi Besar",
          state_id: "1683",
        },
      ],
      Maluku: [
        {
          id: "21508",
          name: "Amahai",
          state_id: "1684",
        },
        {
          id: "21509",
          name: "Ambon",
          state_id: "1684",
        },
        {
          id: "21510",
          name: "Tual",
          state_id: "1684",
        },
      ],
      "Maluku Utara": [
        {
          id: "21511",
          name: "Amahai",
          state_id: "1685",
        },
        {
          id: "21512",
          name: "Ambon",
          state_id: "1685",
        },
        {
          id: "21513",
          name: "Tual",
          state_id: "1685",
        },
      ],
      "Nusa Tenggara Barat": [],
      "Nusa Tenggara Timur": [],
      Papua: [
        {
          id: "21514",
          name: "Aberpura",
          state_id: "1688",
        },
        {
          id: "21515",
          name: "Biak",
          state_id: "1688",
        },
        {
          id: "21516",
          name: "Jaya Pura",
          state_id: "1688",
        },
        {
          id: "21517",
          name: "Manokwari",
          state_id: "1688",
        },
        {
          id: "21518",
          name: "Merauke",
          state_id: "1688",
        },
        {
          id: "21519",
          name: "Sorong",
          state_id: "1688",
        },
      ],
      Riau: [
        {
          id: "21520",
          name: "Balaipungut",
          state_id: "1689",
        },
        {
          id: "21521",
          name: "Bengkalis",
          state_id: "1689",
        },
        {
          id: "21522",
          name: "Dumai",
          state_id: "1689",
        },
        {
          id: "21523",
          name: "Duri",
          state_id: "1689",
        },
        {
          id: "21524",
          name: "Pekan Baru",
          state_id: "1689",
        },
        {
          id: "21525",
          name: "Selatpanjang",
          state_id: "1689",
        },
        {
          id: "21526",
          name: "Tanjung Balai-Meral",
          state_id: "1689",
        },
        {
          id: "21527",
          name: "Tembilahan",
          state_id: "1689",
        },
      ],
      "Riau Kepulauan": [
        {
          id: "21528",
          name: "Balaipungut",
          state_id: "1690",
        },
        {
          id: "21529",
          name: "Bengkalis",
          state_id: "1690",
        },
        {
          id: "21530",
          name: "Dumai",
          state_id: "1690",
        },
        {
          id: "21531",
          name: "Duri",
          state_id: "1690",
        },
        {
          id: "21532",
          name: "Pekan Baru",
          state_id: "1690",
        },
        {
          id: "21533",
          name: "Selatpanjang",
          state_id: "1690",
        },
        {
          id: "21534",
          name: "Tanjung Balai-Meral",
          state_id: "1690",
        },
        {
          id: "21535",
          name: "Tembilahan",
          state_id: "1690",
        },
      ],
      Solo: [
        {
          id: "21536",
          name: "Solo",
          state_id: "1691",
        },
      ],
      "Sulawesi Selatan": [],
      "Sulawesi Tengah": [],
      "Sulawesi Tenggara": [],
      "Sulawesi Utara": [],
      "Sumatera Barat": [],
      "Sumatera Selatan": [],
      "Sumatera Utara": [],
      Yogyakarta: [
        {
          id: "21537",
          name: "Bambanglipuro",
          state_id: "1699",
        },
        {
          id: "21538",
          name: "Banguntapan",
          state_id: "1699",
        },
        {
          id: "21539",
          name: "Bantul",
          state_id: "1699",
        },
        {
          id: "21540",
          name: "Depok",
          state_id: "1699",
        },
        {
          id: "21541",
          name: "Gamping",
          state_id: "1699",
        },
        {
          id: "21542",
          name: "Godean",
          state_id: "1699",
        },
        {
          id: "21543",
          name: "Jetis",
          state_id: "1699",
        },
        {
          id: "21544",
          name: "Kasihan",
          state_id: "1699",
        },
        {
          id: "21545",
          name: "Ngaglik",
          state_id: "1699",
        },
        {
          id: "21546",
          name: "Pandak",
          state_id: "1699",
        },
        {
          id: "21547",
          name: "Pundong",
          state_id: "1699",
        },
        {
          id: "21548",
          name: "Sewon",
          state_id: "1699",
        },
        {
          id: "21549",
          name: "Seyegan",
          state_id: "1699",
        },
        {
          id: "21550",
          name: "Sleman",
          state_id: "1699",
        },
        {
          id: "21551",
          name: "Srandakan",
          state_id: "1699",
        },
        {
          id: "21552",
          name: "Wonosari",
          state_id: "1699",
        },
        {
          id: "21553",
          name: "Yogyakarta",
          state_id: "1699",
        },
      ],
    },
  },
  IE: {
    name: "Ireland",
    native: "Éire",
    phone: "353",
    continent: "EU",
    capital: "Dublin",
    currency: "EUR",
    languages: ["ga", "en"],
    emoji: "🇮🇪",
    emojiU: "U+1F1EE U+1F1EA",
    states: {
      Armagh: [
        {
          id: "21867",
          name: "Moira",
          state_id: "1749",
        },
      ],
      Carlow: [
        {
          id: "21868",
          name: "Bagenalstown",
          state_id: "1750",
        },
        {
          id: "21869",
          name: "Carlow",
          state_id: "1750",
        },
        {
          id: "21870",
          name: "Tullow",
          state_id: "1750",
        },
      ],
      Cavan: [
        {
          id: "21871",
          name: "Bailieborough",
          state_id: "1751",
        },
        {
          id: "21872",
          name: "Belturbet",
          state_id: "1751",
        },
        {
          id: "21873",
          name: "Cavan",
          state_id: "1751",
        },
        {
          id: "21874",
          name: "Coothill",
          state_id: "1751",
        },
      ],
      Clare: [
        {
          id: "21875",
          name: "Ennis",
          state_id: "1752",
        },
        {
          id: "21876",
          name: "Kilkee",
          state_id: "1752",
        },
        {
          id: "21877",
          name: "Kilrush",
          state_id: "1752",
        },
        {
          id: "21878",
          name: "Newmarket-on-Fergus",
          state_id: "1752",
        },
        {
          id: "21879",
          name: "Shannon",
          state_id: "1752",
        },
      ],
      Cork: [
        {
          id: "21880",
          name: "Bandon",
          state_id: "1753",
        },
        {
          id: "21881",
          name: "Bantry",
          state_id: "1753",
        },
        {
          id: "21882",
          name: "Blarney",
          state_id: "1753",
        },
        {
          id: "21883",
          name: "Carrigaline",
          state_id: "1753",
        },
        {
          id: "21884",
          name: "Charleville",
          state_id: "1753",
        },
        {
          id: "21885",
          name: "Clonakilty",
          state_id: "1753",
        },
        {
          id: "21886",
          name: "Cobh",
          state_id: "1753",
        },
        {
          id: "21887",
          name: "Cork",
          state_id: "1753",
        },
        {
          id: "21888",
          name: "Drishane",
          state_id: "1753",
        },
        {
          id: "21889",
          name: "Dunmanway",
          state_id: "1753",
        },
        {
          id: "21890",
          name: "Fermoy",
          state_id: "1753",
        },
        {
          id: "21891",
          name: "Kanturk",
          state_id: "1753",
        },
        {
          id: "21892",
          name: "Kinsale",
          state_id: "1753",
        },
        {
          id: "21893",
          name: "Macroom",
          state_id: "1753",
        },
        {
          id: "21894",
          name: "Mallow",
          state_id: "1753",
        },
        {
          id: "21895",
          name: "Midleton",
          state_id: "1753",
        },
        {
          id: "21896",
          name: "Millstreet",
          state_id: "1753",
        },
        {
          id: "21897",
          name: "Mitchelstown",
          state_id: "1753",
        },
        {
          id: "21898",
          name: "Passage West",
          state_id: "1753",
        },
        {
          id: "21899",
          name: "Skibbereen",
          state_id: "1753",
        },
        {
          id: "21900",
          name: "Youghal",
          state_id: "1753",
        },
      ],
      Donegal: [
        {
          id: "21901",
          name: "Ballybofey",
          state_id: "1754",
        },
        {
          id: "21902",
          name: "Ballyshannon",
          state_id: "1754",
        },
        {
          id: "21903",
          name: "Buncrana",
          state_id: "1754",
        },
        {
          id: "21904",
          name: "Bundoran",
          state_id: "1754",
        },
        {
          id: "21905",
          name: "Carndonagh",
          state_id: "1754",
        },
        {
          id: "21906",
          name: "Donegal",
          state_id: "1754",
        },
        {
          id: "21907",
          name: "Killybegs",
          state_id: "1754",
        },
        {
          id: "21908",
          name: "Letterkenny",
          state_id: "1754",
        },
        {
          id: "21909",
          name: "Lifford",
          state_id: "1754",
        },
        {
          id: "21910",
          name: "Moville",
          state_id: "1754",
        },
      ],
      Dublin: [
        {
          id: "21911",
          name: "Balbriggan",
          state_id: "1755",
        },
        {
          id: "21912",
          name: "Ballsbridge",
          state_id: "1755",
        },
        {
          id: "21913",
          name: "Dublin",
          state_id: "1755",
        },
        {
          id: "21914",
          name: "Leixlip",
          state_id: "1755",
        },
        {
          id: "21915",
          name: "Lucan",
          state_id: "1755",
        },
        {
          id: "21916",
          name: "Malahide",
          state_id: "1755",
        },
        {
          id: "21917",
          name: "Portrane",
          state_id: "1755",
        },
        {
          id: "21918",
          name: "Rathcoole",
          state_id: "1755",
        },
        {
          id: "21919",
          name: "Rush",
          state_id: "1755",
        },
        {
          id: "21920",
          name: "Skerries",
          state_id: "1755",
        },
        {
          id: "21921",
          name: "Swords",
          state_id: "1755",
        },
      ],
      Galway: [
        {
          id: "21922",
          name: "Athenry",
          state_id: "1756",
        },
        {
          id: "21923",
          name: "Ballinasloe",
          state_id: "1756",
        },
        {
          id: "21924",
          name: "Clifden",
          state_id: "1756",
        },
        {
          id: "21925",
          name: "Galway",
          state_id: "1756",
        },
        {
          id: "21926",
          name: "Gort",
          state_id: "1756",
        },
        {
          id: "21927",
          name: "Loughrea",
          state_id: "1756",
        },
        {
          id: "21928",
          name: "Tuam",
          state_id: "1756",
        },
      ],
      Kerry: [
        {
          id: "21929",
          name: "Ballybunion",
          state_id: "1757",
        },
        {
          id: "21930",
          name: "Cahirciveen",
          state_id: "1757",
        },
        {
          id: "21931",
          name: "Castleisland",
          state_id: "1757",
        },
        {
          id: "21932",
          name: "Dingle",
          state_id: "1757",
        },
        {
          id: "21933",
          name: "Kenmare",
          state_id: "1757",
        },
        {
          id: "21934",
          name: "Killarney",
          state_id: "1757",
        },
        {
          id: "21935",
          name: "Killorglin",
          state_id: "1757",
        },
        {
          id: "21936",
          name: "Listowel",
          state_id: "1757",
        },
        {
          id: "21937",
          name: "Tralee",
          state_id: "1757",
        },
      ],
      Kildare: [
        {
          id: "21938",
          name: "Athy",
          state_id: "1758",
        },
        {
          id: "21939",
          name: "Celbridge",
          state_id: "1758",
        },
        {
          id: "21940",
          name: "Clane",
          state_id: "1758",
        },
        {
          id: "21941",
          name: "Kilcock",
          state_id: "1758",
        },
        {
          id: "21942",
          name: "Kilcullen",
          state_id: "1758",
        },
        {
          id: "21943",
          name: "Kildare",
          state_id: "1758",
        },
        {
          id: "21944",
          name: "Maynooth",
          state_id: "1758",
        },
        {
          id: "21945",
          name: "Monasterevan",
          state_id: "1758",
        },
        {
          id: "21946",
          name: "Naas",
          state_id: "1758",
        },
        {
          id: "21947",
          name: "Newbridge",
          state_id: "1758",
        },
      ],
      Kilkenny: [
        {
          id: "21948",
          name: "Callan",
          state_id: "1759",
        },
        {
          id: "21949",
          name: "Castlecomer",
          state_id: "1759",
        },
        {
          id: "21950",
          name: "Kilkenny",
          state_id: "1759",
        },
        {
          id: "21951",
          name: "Thomastown",
          state_id: "1759",
        },
      ],
      Laois: [
        {
          id: "21952",
          name: "Abbeyleix",
          state_id: "1760",
        },
        {
          id: "21953",
          name: "Mountmellick",
          state_id: "1760",
        },
        {
          id: "21954",
          name: "Mountrath",
          state_id: "1760",
        },
        {
          id: "21955",
          name: "Port Laoise",
          state_id: "1760",
        },
        {
          id: "21956",
          name: "Portarlington",
          state_id: "1760",
        },
      ],
      Leinster: [
        {
          id: "21957",
          name: "Meath",
          state_id: "1761",
        },
      ],
      Leitrim: [
        {
          id: "21958",
          name: "Carrick-on-Shannon",
          state_id: "1762",
        },
      ],
      Limerick: [
        {
          id: "21959",
          name: "Abbeyfeale",
          state_id: "1763",
        },
        {
          id: "21960",
          name: "Kilmallock",
          state_id: "1763",
        },
        {
          id: "21961",
          name: "Limerick",
          state_id: "1763",
        },
        {
          id: "21962",
          name: "Newcastle",
          state_id: "1763",
        },
        {
          id: "21963",
          name: "Rathkeale",
          state_id: "1763",
        },
      ],
      "Loch Garman": [],
      Longford: [
        {
          id: "21964",
          name: "Granard",
          state_id: "1765",
        },
        {
          id: "21965",
          name: "Longford",
          state_id: "1765",
        },
        {
          id: "21966",
          name: "Moate",
          state_id: "1765",
        },
      ],
      Louth: [
        {
          id: "21967",
          name: "Ardee",
          state_id: "1766",
        },
        {
          id: "21968",
          name: "Drogheda",
          state_id: "1766",
        },
        {
          id: "21969",
          name: "Drumcar",
          state_id: "1766",
        },
        {
          id: "21970",
          name: "Dundalk",
          state_id: "1766",
        },
      ],
      Mayo: [
        {
          id: "21971",
          name: "Ballina",
          state_id: "1767",
        },
        {
          id: "21972",
          name: "Ballinrobe",
          state_id: "1767",
        },
        {
          id: "21973",
          name: "Ballyhaunis",
          state_id: "1767",
        },
        {
          id: "21974",
          name: "Castlebar",
          state_id: "1767",
        },
        {
          id: "21975",
          name: "Claremorris",
          state_id: "1767",
        },
        {
          id: "21976",
          name: "Swinford",
          state_id: "1767",
        },
        {
          id: "21977",
          name: "Westport",
          state_id: "1767",
        },
      ],
      Meath: [
        {
          id: "21978",
          name: "Ashbourne",
          state_id: "1768",
        },
        {
          id: "21979",
          name: "Duleek",
          state_id: "1768",
        },
        {
          id: "21980",
          name: "Dunboyne",
          state_id: "1768",
        },
        {
          id: "21981",
          name: "Dunshaughlin",
          state_id: "1768",
        },
        {
          id: "21982",
          name: "Kells",
          state_id: "1768",
        },
        {
          id: "21983",
          name: "Laytown",
          state_id: "1768",
        },
        {
          id: "21984",
          name: "Navan",
          state_id: "1768",
        },
        {
          id: "21985",
          name: "Trim",
          state_id: "1768",
        },
      ],
      Monaghan: [
        {
          id: "21986",
          name: "Carrickmacross",
          state_id: "1769",
        },
        {
          id: "21987",
          name: "Castleblayney",
          state_id: "1769",
        },
        {
          id: "21988",
          name: "Clones",
          state_id: "1769",
        },
        {
          id: "21989",
          name: "Monaghan",
          state_id: "1769",
        },
      ],
      Offaly: [
        {
          id: "21990",
          name: "Banagher",
          state_id: "1770",
        },
        {
          id: "21991",
          name: "Birr",
          state_id: "1770",
        },
        {
          id: "21992",
          name: "Clara",
          state_id: "1770",
        },
        {
          id: "21993",
          name: "Edenderry",
          state_id: "1770",
        },
        {
          id: "21994",
          name: "Kilcormac",
          state_id: "1770",
        },
        {
          id: "21995",
          name: "Tullamore",
          state_id: "1770",
        },
      ],
      Roscommon: [
        {
          id: "21996",
          name: "Ballaghaderreen",
          state_id: "1771",
        },
        {
          id: "21997",
          name: "Boyle",
          state_id: "1771",
        },
        {
          id: "21998",
          name: "Castlerea",
          state_id: "1771",
        },
        {
          id: "21999",
          name: "Roscommon",
          state_id: "1771",
        },
      ],
      Sligo: [
        {
          id: "22000",
          name: "Sligo",
          state_id: "1772",
        },
      ],
      "Tipperary North Riding": [],
      "Tipperary South Riding": [],
      Ulster: [
        {
          id: "22001",
          name: "Co Tyrone",
          state_id: "1775",
        },
        {
          id: "22002",
          name: "Downpatrick",
          state_id: "1775",
        },
      ],
      Waterford: [
        {
          id: "22003",
          name: "Dungarvan",
          state_id: "1776",
        },
        {
          id: "22004",
          name: "Tramore",
          state_id: "1776",
        },
        {
          id: "22005",
          name: "Waterford",
          state_id: "1776",
        },
      ],
      Westmeath: [
        {
          id: "22006",
          name: "Athlone",
          state_id: "1777",
        },
        {
          id: "22007",
          name: "Mullingar",
          state_id: "1777",
        },
      ],
      Wexford: [
        {
          id: "22008",
          name: "Enniscorthy",
          state_id: "1778",
        },
        {
          id: "22009",
          name: "Gorey",
          state_id: "1778",
        },
        {
          id: "22010",
          name: "New Ross",
          state_id: "1778",
        },
        {
          id: "22011",
          name: "Wexford",
          state_id: "1778",
        },
      ],
      Wicklow: [
        {
          id: "22012",
          name: "Arklow",
          state_id: "1779",
        },
        {
          id: "22013",
          name: "Baltinglass",
          state_id: "1779",
        },
        {
          id: "22014",
          name: "Blessington",
          state_id: "1779",
        },
        {
          id: "22015",
          name: "Bray",
          state_id: "1779",
        },
        {
          id: "22016",
          name: "Greystones",
          state_id: "1779",
        },
        {
          id: "22017",
          name: "Kilcoole",
          state_id: "1779",
        },
        {
          id: "22018",
          name: "Newtownmountkennedy",
          state_id: "1779",
        },
        {
          id: "22019",
          name: "Rathdrum",
          state_id: "1779",
        },
        {
          id: "22020",
          name: "Wicklow",
          state_id: "1779",
        },
      ],
    },
  },
  IL: {
    name: "Israel",
    native: "יִשְׂרָאֵל",
    phone: "972",
    continent: "AS",
    capital: "Jerusalem",
    currency: "ILS",
    languages: ["he", "ar"],
    emoji: "🇮🇱",
    emojiU: "U+1F1EE U+1F1F1",
    states: {
      "Beit Hanania": [],
      "Ben Gurion Airport": [],
      Bethlehem: [
        {
          id: "22021",
          name: "Bethlehem",
          state_id: "1782",
        },
      ],
      Caesarea: [
        {
          id: "22022",
          name: "Caesarea",
          state_id: "1783",
        },
      ],
      Centre: [
        {
          id: "22023",
          name: "Petach Tikva",
          state_id: "1784",
        },
        {
          id: "22024",
          name: "Ramallah",
          state_id: "1784",
        },
      ],
      Gaza: [
        {
          id: "22025",
          name: "Gaza",
          state_id: "1785",
        },
      ],
      Hadaron: [
        {
          id: "22026",
          name: "Arad",
          state_id: "1786",
        },
        {
          id: "22027",
          name: "Omer",
          state_id: "1786",
        },
        {
          id: "22028",
          name: "Ashdod",
          state_id: "1786",
        },
        {
          id: "22029",
          name: "Ashqelon",
          state_id: "1786",
        },
        {
          id: "22030",
          name: "Be''er Sheva",
          state_id: "1786",
        },
        {
          id: "22031",
          name: "Beersheba",
          state_id: "1786",
        },
        {
          id: "22032",
          name: "Bene Ayish",
          state_id: "1786",
        },
        {
          id: "22033",
          name: "Dimona",
          state_id: "1786",
        },
        {
          id: "22034",
          name: "Elat",
          state_id: "1786",
        },
        {
          id: "22035",
          name: "Gan Yavne",
          state_id: "1786",
        },
        {
          id: "22036",
          name: "Nahal `Oz",
          state_id: "1786",
        },
        {
          id: "22037",
          name: "Netivot",
          state_id: "1786",
        },
        {
          id: "22038",
          name: "Ofaqim",
          state_id: "1786",
        },
        {
          id: "22039",
          name: "Qiryat Gat",
          state_id: "1786",
        },
        {
          id: "22040",
          name: "Qiryat Mal''akhi",
          state_id: "1786",
        },
        {
          id: "22041",
          name: "Sederot",
          state_id: "1786",
        },
        {
          id: "22042",
          name: "Yeroham",
          state_id: "1786",
        },
        {
          id: "22043",
          name: "kiryat Malachi",
          state_id: "1786",
        },
      ],
      "Haifa District": [],
      Hamerkaz: [
        {
          id: "22044",
          name: "Be''er Ya''aqov",
          state_id: "1788",
        },
        {
          id: "22045",
          name: "Beit Shemesh",
          state_id: "1788",
        },
        {
          id: "22046",
          name: "Bene Beraq",
          state_id: "1788",
        },
        {
          id: "22047",
          name: "Bnei Brak",
          state_id: "1788",
        },
        {
          id: "22048",
          name: "Even Yehuda",
          state_id: "1788",
        },
        {
          id: "22049",
          name: "Fureidis",
          state_id: "1788",
        },
        {
          id: "22050",
          name: "Gat Rimon",
          state_id: "1788",
        },
        {
          id: "22051",
          name: "Gedera",
          state_id: "1788",
        },
        {
          id: "22052",
          name: "Givat Shmuel",
          state_id: "1788",
        },
        {
          id: "22053",
          name: "Hibat Zion",
          state_id: "1788",
        },
        {
          id: "22054",
          name: "Hod HaSharon",
          state_id: "1788",
        },
        {
          id: "22055",
          name: "Hogar",
          state_id: "1788",
        },
        {
          id: "22056",
          name: "Jaljulye",
          state_id: "1788",
        },
        {
          id: "22057",
          name: "Jatt",
          state_id: "1788",
        },
        {
          id: "22058",
          name: "Kafar Qasem",
          state_id: "1788",
        },
        {
          id: "22059",
          name: "Kefar Sava",
          state_id: "1788",
        },
        {
          id: "22060",
          name: "Kefar Yona",
          state_id: "1788",
        },
        {
          id: "22061",
          name: "Kfar Saba",
          state_id: "1788",
        },
        {
          id: "22062",
          name: "Kiryag Bialik",
          state_id: "1788",
        },
        {
          id: "22063",
          name: "Lod",
          state_id: "1788",
        },
        {
          id: "22064",
          name: "Mazkeret Batya",
          state_id: "1788",
        },
        {
          id: "22065",
          name: "Modi''in",
          state_id: "1788",
        },
        {
          id: "22066",
          name: "Nes Ziyyona",
          state_id: "1788",
        },
        {
          id: "22067",
          name: "Ness Ziona",
          state_id: "1788",
        },
        {
          id: "22068",
          name: "Netanya",
          state_id: "1788",
        },
        {
          id: "22069",
          name: "Nordiya",
          state_id: "1788",
        },
        {
          id: "22070",
          name: "Pardesiyya",
          state_id: "1788",
        },
        {
          id: "22071",
          name: "Petakh Tiqwa",
          state_id: "1788",
        },
        {
          id: "22072",
          name: "Qadima",
          state_id: "1788",
        },
        {
          id: "22073",
          name: "Qalansawe",
          state_id: "1788",
        },
        {
          id: "22074",
          name: "Qiryat ''Eqron",
          state_id: "1788",
        },
        {
          id: "22075",
          name: "Ra''anana",
          state_id: "1788",
        },
        {
          id: "22076",
          name: "Ramla",
          state_id: "1788",
        },
        {
          id: "22077",
          name: "Rehovot",
          state_id: "1788",
        },
        {
          id: "22078",
          name: "Rekhovot",
          state_id: "1788",
        },
        {
          id: "22079",
          name: "Rinnatya",
          state_id: "1788",
        },
        {
          id: "22080",
          name: "Rishon LeZiyyon",
          state_id: "1788",
        },
        {
          id: "22081",
          name: "Rosh HaAyin",
          state_id: "1788",
        },
        {
          id: "22082",
          name: "Shoham",
          state_id: "1788",
        },
        {
          id: "22083",
          name: "Tayibe",
          state_id: "1788",
        },
        {
          id: "22084",
          name: "Tire",
          state_id: "1788",
        },
        {
          id: "22085",
          name: "Tsur Igal",
          state_id: "1788",
        },
        {
          id: "22086",
          name: "Udim",
          state_id: "1788",
        },
        {
          id: "22087",
          name: "Yavne",
          state_id: "1788",
        },
        {
          id: "22088",
          name: "Yehud",
          state_id: "1788",
        },
      ],
      Hazafon: [
        {
          id: "22089",
          name: "Afula",
          state_id: "1789",
        },
        {
          id: "22090",
          name: "Akko",
          state_id: "1789",
        },
        {
          id: "22091",
          name: "Arrabe",
          state_id: "1789",
        },
        {
          id: "22092",
          name: "Ein Mahel",
          state_id: "1789",
        },
        {
          id: "22093",
          name: "Ilut",
          state_id: "1789",
        },
        {
          id: "22094",
          name: "Abu Sinan",
          state_id: "1789",
        },
        {
          id: "22095",
          name: "Basmat Tab''un",
          state_id: "1789",
        },
        {
          id: "22096",
          name: "Beit Jann",
          state_id: "1789",
        },
        {
          id: "22097",
          name: "Bet She''an",
          state_id: "1789",
        },
        {
          id: "22098",
          name: "Bi''ne",
          state_id: "1789",
        },
        {
          id: "22099",
          name: "Bir-al-Maksur",
          state_id: "1789",
        },
        {
          id: "22100",
          name: "Bu''eine-Nujeidat",
          state_id: "1789",
        },
        {
          id: "22101",
          name: "Dabburye",
          state_id: "1789",
        },
        {
          id: "22102",
          name: "Dayr Hannah",
          state_id: "1789",
        },
        {
          id: "22103",
          name: "Dayr-al-Asad",
          state_id: "1789",
        },
        {
          id: "22104",
          name: "Hazor HaGelilit",
          state_id: "1789",
        },
        {
          id: "22105",
          name: "I''billin",
          state_id: "1789",
        },
        {
          id: "22106",
          name: "Iksal",
          state_id: "1789",
        },
        {
          id: "22107",
          name: "Judeide-Maker",
          state_id: "1789",
        },
        {
          id: "22108",
          name: "Kabul",
          state_id: "1789",
        },
        {
          id: "22109",
          name: "Kafar Kanna",
          state_id: "1789",
        },
        {
          id: "22110",
          name: "Kafar Manda",
          state_id: "1789",
        },
        {
          id: "22111",
          name: "Kafar Yasif",
          state_id: "1789",
        },
        {
          id: "22112",
          name: "Karmiel",
          state_id: "1789",
        },
        {
          id: "22113",
          name: "Kisra-Sumei",
          state_id: "1789",
        },
        {
          id: "22114",
          name: "Ma''alot Tarshikha",
          state_id: "1789",
        },
        {
          id: "22115",
          name: "Majd-al-Kurum",
          state_id: "1789",
        },
        {
          id: "22116",
          name: "Migdal Ha''Emeq",
          state_id: "1789",
        },
        {
          id: "22117",
          name: "Mugar",
          state_id: "1789",
        },
        {
          id: "22118",
          name: "Nahariyya",
          state_id: "1789",
        },
        {
          id: "22119",
          name: "Nahef",
          state_id: "1789",
        },
        {
          id: "22120",
          name: "Nazerat",
          state_id: "1789",
        },
        {
          id: "22121",
          name: "Nazerat ''Illit",
          state_id: "1789",
        },
        {
          id: "22122",
          name: "Qiryat Shemona",
          state_id: "1789",
        },
        {
          id: "22123",
          name: "Qiryat Tiv''on",
          state_id: "1789",
        },
        {
          id: "22124",
          name: "Rame",
          state_id: "1789",
        },
        {
          id: "22125",
          name: "Reine",
          state_id: "1789",
        },
        {
          id: "22126",
          name: "Sakhnin",
          state_id: "1789",
        },
        {
          id: "22127",
          name: "Shefar''am",
          state_id: "1789",
        },
        {
          id: "22128",
          name: "Tamra",
          state_id: "1789",
        },
        {
          id: "22129",
          name: "Tiberias",
          state_id: "1789",
        },
        {
          id: "22130",
          name: "Tur''an",
          state_id: "1789",
        },
        {
          id: "22131",
          name: "Yirka",
          state_id: "1789",
        },
        {
          id: "22132",
          name: "Yoqne''am Illit",
          state_id: "1789",
        },
        {
          id: "22133",
          name: "Zefat",
          state_id: "1789",
        },
        {
          id: "22134",
          name: "Zur Yigal",
          state_id: "1789",
        },
      ],
      Hebron: [
        {
          id: "22135",
          name: "Hebron",
          state_id: "1790",
        },
      ],
      Jaffa: [
        {
          id: "22136",
          name: "Sgula",
          state_id: "1791",
        },
      ],
      Jerusalem: [
        {
          id: "22137",
          name: "Jerusalem",
          state_id: "1792",
        },
      ],
      Khefa: [
        {
          id: "22138",
          name: "Ar''ara",
          state_id: "1793",
        },
        {
          id: "22139",
          name: "Isifya",
          state_id: "1793",
        },
        {
          id: "22140",
          name: "Baqa al-Gharbiyyah",
          state_id: "1793",
        },
        {
          id: "22141",
          name: "Binyamina",
          state_id: "1793",
        },
        {
          id: "22142",
          name: "Daliyat-al-Karmil",
          state_id: "1793",
        },
        {
          id: "22143",
          name: "Jizr-az-Zarqa",
          state_id: "1793",
        },
        {
          id: "22144",
          name: "Khadera",
          state_id: "1793",
        },
        {
          id: "22145",
          name: "Khefa",
          state_id: "1793",
        },
        {
          id: "22146",
          name: "Nesher",
          state_id: "1793",
        },
        {
          id: "22147",
          name: "Or ''Aqiva",
          state_id: "1793",
        },
        {
          id: "22148",
          name: "Pardes Khanna-Karkur",
          state_id: "1793",
        },
        {
          id: "22149",
          name: "Qiryat Atta",
          state_id: "1793",
        },
        {
          id: "22150",
          name: "Qiryat Bialik",
          state_id: "1793",
        },
        {
          id: "22151",
          name: "Qiryat Motzkin",
          state_id: "1793",
        },
        {
          id: "22152",
          name: "Qiryat Yam",
          state_id: "1793",
        },
        {
          id: "22153",
          name: "Rekhasim",
          state_id: "1793",
        },
        {
          id: "22154",
          name: "Tirat Karmel",
          state_id: "1793",
        },
        {
          id: "22155",
          name: "Umm-al-Fahm",
          state_id: "1793",
        },
        {
          id: "22156",
          name: "Zikhron Ya''aqov",
          state_id: "1793",
        },
      ],
      "Kiryat Yam": [],
      "Lower Galilee": [],
      Qalqilya: [
        {
          id: "22157",
          name: "Qalqilya",
          state_id: "1796",
        },
      ],
      "Talme Elazar": [],
      "Tel Aviv": [],
      Tsafon: [
        {
          id: "22158",
          name: "Hadera",
          state_id: "1799",
        },
        {
          id: "22159",
          name: "Kiryag Bialik",
          state_id: "1799",
        },
      ],
      "Umm El Fahem": [],
      Yerushalayim: [
        {
          id: "22160",
          name: "Bet Shemesh",
          state_id: "1801",
        },
        {
          id: "22161",
          name: "Mevasserat Ziyyon",
          state_id: "1801",
        },
        {
          id: "22162",
          name: "Yerushalayim",
          state_id: "1801",
        },
      ],
    },
  },
  IM: {
    name: "Isle of Man",
    native: "Isle of Man",
    phone: "44",
    continent: "EU",
    capital: "Douglas",
    currency: "GBP",
    languages: ["en", "gv"],
    emoji: "🇮🇲",
    emojiU: "U+1F1EE U+1F1F2",
    states: {},
  },
  IN: {
    name: "India",
    native: "भारत",
    phone: "91",
    continent: "AS",
    capital: "New Delhi",
    currency: "INR",
    languages: ["hi", "en"],
    emoji: "🇮🇳",
    emojiU: "U+1F1EE U+1F1F3",
    states: {
      "Andaman and Nicobar Islands": [
        {
          id: "1",
          name: "Bombuflat",
          state_id: "1",
        },
        {
          id: "2",
          name: "Garacharma",
          state_id: "1",
        },
        {
          id: "3",
          name: "Port Blair",
          state_id: "1",
        },
        {
          id: "4",
          name: "Rangat",
          state_id: "1",
        },
      ],
      "Andhra Pradesh": [
        {
          id: "5",
          name: "Addanki",
          state_id: "2",
        },
        {
          id: "6",
          name: "Adivivaram",
          state_id: "2",
        },
        {
          id: "7",
          name: "Adoni",
          state_id: "2",
        },
        {
          id: "8",
          name: "Aganampudi",
          state_id: "2",
        },
        {
          id: "9",
          name: "Ajjaram",
          state_id: "2",
        },
        {
          id: "10",
          name: "Akividu",
          state_id: "2",
        },
        {
          id: "11",
          name: "Akkarampalle",
          state_id: "2",
        },
        {
          id: "12",
          name: "Akkayapalle",
          state_id: "2",
        },
        {
          id: "13",
          name: "Akkireddipalem",
          state_id: "2",
        },
        {
          id: "14",
          name: "Alampur",
          state_id: "2",
        },
        {
          id: "15",
          name: "Amalapuram",
          state_id: "2",
        },
        {
          id: "16",
          name: "Amudalavalasa",
          state_id: "2",
        },
        {
          id: "17",
          name: "Amur",
          state_id: "2",
        },
        {
          id: "18",
          name: "Anakapalle",
          state_id: "2",
        },
        {
          id: "19",
          name: "Anantapur",
          state_id: "2",
        },
        {
          id: "20",
          name: "Andole",
          state_id: "2",
        },
        {
          id: "21",
          name: "Atmakur",
          state_id: "2",
        },
        {
          id: "22",
          name: "Attili",
          state_id: "2",
        },
        {
          id: "23",
          name: "Avanigadda",
          state_id: "2",
        },
        {
          id: "24",
          name: "Badepalli",
          state_id: "2",
        },
        {
          id: "25",
          name: "Badvel",
          state_id: "2",
        },
        {
          id: "26",
          name: "Balapur",
          state_id: "2",
        },
        {
          id: "27",
          name: "Bandarulanka",
          state_id: "2",
        },
        {
          id: "28",
          name: "Banganapalle",
          state_id: "2",
        },
        {
          id: "29",
          name: "Bapatla",
          state_id: "2",
        },
        {
          id: "30",
          name: "Bapulapadu",
          state_id: "2",
        },
        {
          id: "31",
          name: "Belampalli",
          state_id: "2",
        },
        {
          id: "32",
          name: "Bestavaripeta",
          state_id: "2",
        },
        {
          id: "33",
          name: "Betamcherla",
          state_id: "2",
        },
        {
          id: "34",
          name: "Bhattiprolu",
          state_id: "2",
        },
        {
          id: "35",
          name: "Bhimavaram",
          state_id: "2",
        },
        {
          id: "36",
          name: "Bhimunipatnam",
          state_id: "2",
        },
        {
          id: "37",
          name: "Bobbili",
          state_id: "2",
        },
        {
          id: "38",
          name: "Bombuflat",
          state_id: "2",
        },
        {
          id: "39",
          name: "Bommuru",
          state_id: "2",
        },
        {
          id: "40",
          name: "Bugganipalle",
          state_id: "2",
        },
        {
          id: "41",
          name: "Challapalle",
          state_id: "2",
        },
        {
          id: "42",
          name: "Chandur",
          state_id: "2",
        },
        {
          id: "43",
          name: "Chatakonda",
          state_id: "2",
        },
        {
          id: "44",
          name: "Chemmumiahpet",
          state_id: "2",
        },
        {
          id: "45",
          name: "Chidiga",
          state_id: "2",
        },
        {
          id: "46",
          name: "Chilakaluripet",
          state_id: "2",
        },
        {
          id: "47",
          name: "Chimakurthy",
          state_id: "2",
        },
        {
          id: "48",
          name: "Chinagadila",
          state_id: "2",
        },
        {
          id: "49",
          name: "Chinagantyada",
          state_id: "2",
        },
        {
          id: "50",
          name: "Chinnachawk",
          state_id: "2",
        },
        {
          id: "51",
          name: "Chintalavalasa",
          state_id: "2",
        },
        {
          id: "52",
          name: "Chipurupalle",
          state_id: "2",
        },
        {
          id: "53",
          name: "Chirala",
          state_id: "2",
        },
        {
          id: "54",
          name: "Chittoor",
          state_id: "2",
        },
        {
          id: "55",
          name: "Chodavaram",
          state_id: "2",
        },
        {
          id: "56",
          name: "Choutuppal",
          state_id: "2",
        },
        {
          id: "57",
          name: "Chunchupalle",
          state_id: "2",
        },
        {
          id: "58",
          name: "Cuddapah",
          state_id: "2",
        },
        {
          id: "59",
          name: "Cumbum",
          state_id: "2",
        },
        {
          id: "60",
          name: "Darnakal",
          state_id: "2",
        },
        {
          id: "61",
          name: "Dasnapur",
          state_id: "2",
        },
        {
          id: "62",
          name: "Dauleshwaram",
          state_id: "2",
        },
        {
          id: "63",
          name: "Dharmavaram",
          state_id: "2",
        },
        {
          id: "64",
          name: "Dhone",
          state_id: "2",
        },
        {
          id: "65",
          name: "Dommara Nandyal",
          state_id: "2",
        },
        {
          id: "66",
          name: "Dowlaiswaram",
          state_id: "2",
        },
        {
          id: "67",
          name: "East Godavari Dist.",
          state_id: "2",
        },
        {
          id: "68",
          name: "Eddumailaram",
          state_id: "2",
        },
        {
          id: "69",
          name: "Edulapuram",
          state_id: "2",
        },
        {
          id: "70",
          name: "Ekambara kuppam",
          state_id: "2",
        },
        {
          id: "71",
          name: "Eluru",
          state_id: "2",
        },
        {
          id: "72",
          name: "Enikapadu",
          state_id: "2",
        },
        {
          id: "73",
          name: "Fakirtakya",
          state_id: "2",
        },
        {
          id: "74",
          name: "Farrukhnagar",
          state_id: "2",
        },
        {
          id: "75",
          name: "Gaddiannaram",
          state_id: "2",
        },
        {
          id: "76",
          name: "Gajapathinagaram",
          state_id: "2",
        },
        {
          id: "77",
          name: "Gajularega",
          state_id: "2",
        },
        {
          id: "78",
          name: "Gajuvaka",
          state_id: "2",
        },
        {
          id: "79",
          name: "Gannavaram",
          state_id: "2",
        },
        {
          id: "80",
          name: "Garacharma",
          state_id: "2",
        },
        {
          id: "81",
          name: "Garimellapadu",
          state_id: "2",
        },
        {
          id: "82",
          name: "Giddalur",
          state_id: "2",
        },
        {
          id: "83",
          name: "Godavarikhani",
          state_id: "2",
        },
        {
          id: "84",
          name: "Gopalapatnam",
          state_id: "2",
        },
        {
          id: "85",
          name: "Gopalur",
          state_id: "2",
        },
        {
          id: "86",
          name: "Gorrekunta",
          state_id: "2",
        },
        {
          id: "87",
          name: "Gudivada",
          state_id: "2",
        },
        {
          id: "88",
          name: "Gudur",
          state_id: "2",
        },
        {
          id: "89",
          name: "Guntakal",
          state_id: "2",
        },
        {
          id: "90",
          name: "Guntur",
          state_id: "2",
        },
        {
          id: "91",
          name: "Guti",
          state_id: "2",
        },
        {
          id: "92",
          name: "Hindupur",
          state_id: "2",
        },
        {
          id: "93",
          name: "Hukumpeta",
          state_id: "2",
        },
        {
          id: "94",
          name: "Ichchapuram",
          state_id: "2",
        },
        {
          id: "95",
          name: "Isnapur",
          state_id: "2",
        },
        {
          id: "96",
          name: "Jaggayyapeta",
          state_id: "2",
        },
        {
          id: "97",
          name: "Jallaram Kamanpur",
          state_id: "2",
        },
        {
          id: "98",
          name: "Jammalamadugu",
          state_id: "2",
        },
        {
          id: "99",
          name: "Jangampalli",
          state_id: "2",
        },
        {
          id: "100",
          name: "Jarjapupeta",
          state_id: "2",
        },
        {
          id: "101",
          name: "Kadiri",
          state_id: "2",
        },
        {
          id: "102",
          name: "Kaikalur",
          state_id: "2",
        },
        {
          id: "103",
          name: "Kakinada",
          state_id: "2",
        },
        {
          id: "104",
          name: "Kallur",
          state_id: "2",
        },
        {
          id: "105",
          name: "Kalyandurg",
          state_id: "2",
        },
        {
          id: "106",
          name: "Kamalapuram",
          state_id: "2",
        },
        {
          id: "107",
          name: "Kamareddi",
          state_id: "2",
        },
        {
          id: "108",
          name: "Kanapaka",
          state_id: "2",
        },
        {
          id: "109",
          name: "Kanigiri",
          state_id: "2",
        },
        {
          id: "110",
          name: "Kanithi",
          state_id: "2",
        },
        {
          id: "111",
          name: "Kankipadu",
          state_id: "2",
        },
        {
          id: "112",
          name: "Kantabamsuguda",
          state_id: "2",
        },
        {
          id: "113",
          name: "Kanuru",
          state_id: "2",
        },
        {
          id: "114",
          name: "Karnul",
          state_id: "2",
        },
        {
          id: "115",
          name: "Katheru",
          state_id: "2",
        },
        {
          id: "116",
          name: "Kavali",
          state_id: "2",
        },
        {
          id: "117",
          name: "Kazipet",
          state_id: "2",
        },
        {
          id: "118",
          name: "Khanapuram Haveli",
          state_id: "2",
        },
        {
          id: "119",
          name: "Kodar",
          state_id: "2",
        },
        {
          id: "120",
          name: "Kollapur",
          state_id: "2",
        },
        {
          id: "121",
          name: "Kondapalem",
          state_id: "2",
        },
        {
          id: "122",
          name: "Kondapalle",
          state_id: "2",
        },
        {
          id: "123",
          name: "Kondukur",
          state_id: "2",
        },
        {
          id: "124",
          name: "Kosgi",
          state_id: "2",
        },
        {
          id: "125",
          name: "Kothavalasa",
          state_id: "2",
        },
        {
          id: "126",
          name: "Kottapalli",
          state_id: "2",
        },
        {
          id: "127",
          name: "Kovur",
          state_id: "2",
        },
        {
          id: "128",
          name: "Kovurpalle",
          state_id: "2",
        },
        {
          id: "129",
          name: "Kovvur",
          state_id: "2",
        },
        {
          id: "130",
          name: "Krishna",
          state_id: "2",
        },
        {
          id: "131",
          name: "Kuppam",
          state_id: "2",
        },
        {
          id: "132",
          name: "Kurmannapalem",
          state_id: "2",
        },
        {
          id: "133",
          name: "Kurnool",
          state_id: "2",
        },
        {
          id: "134",
          name: "Lakshettipet",
          state_id: "2",
        },
        {
          id: "135",
          name: "Lalbahadur Nagar",
          state_id: "2",
        },
        {
          id: "136",
          name: "Machavaram",
          state_id: "2",
        },
        {
          id: "137",
          name: "Macherla",
          state_id: "2",
        },
        {
          id: "138",
          name: "Machilipatnam",
          state_id: "2",
        },
        {
          id: "139",
          name: "Madanapalle",
          state_id: "2",
        },
        {
          id: "140",
          name: "Madaram",
          state_id: "2",
        },
        {
          id: "141",
          name: "Madhuravada",
          state_id: "2",
        },
        {
          id: "142",
          name: "Madikonda",
          state_id: "2",
        },
        {
          id: "143",
          name: "Madugule",
          state_id: "2",
        },
        {
          id: "144",
          name: "Mahabubnagar",
          state_id: "2",
        },
        {
          id: "145",
          name: "Mahbubabad",
          state_id: "2",
        },
        {
          id: "146",
          name: "Malkajgiri",
          state_id: "2",
        },
        {
          id: "147",
          name: "Mamilapalle",
          state_id: "2",
        },
        {
          id: "148",
          name: "Mancheral",
          state_id: "2",
        },
        {
          id: "149",
          name: "Mandapeta",
          state_id: "2",
        },
        {
          id: "150",
          name: "Mandasa",
          state_id: "2",
        },
        {
          id: "151",
          name: "Mangalagiri",
          state_id: "2",
        },
        {
          id: "152",
          name: "Manthani",
          state_id: "2",
        },
        {
          id: "153",
          name: "Markapur",
          state_id: "2",
        },
        {
          id: "154",
          name: "Marturu",
          state_id: "2",
        },
        {
          id: "155",
          name: "Metpalli",
          state_id: "2",
        },
        {
          id: "156",
          name: "Mindi",
          state_id: "2",
        },
        {
          id: "157",
          name: "Mirpet",
          state_id: "2",
        },
        {
          id: "158",
          name: "Moragudi",
          state_id: "2",
        },
        {
          id: "159",
          name: "Mothugudam",
          state_id: "2",
        },
        {
          id: "160",
          name: "Nagari",
          state_id: "2",
        },
        {
          id: "161",
          name: "Nagireddipalle",
          state_id: "2",
        },
        {
          id: "162",
          name: "Nandigama",
          state_id: "2",
        },
        {
          id: "163",
          name: "Nandikotkur",
          state_id: "2",
        },
        {
          id: "164",
          name: "Nandyal",
          state_id: "2",
        },
        {
          id: "165",
          name: "Narasannapeta",
          state_id: "2",
        },
        {
          id: "166",
          name: "Narasapur",
          state_id: "2",
        },
        {
          id: "167",
          name: "Narasaraopet",
          state_id: "2",
        },
        {
          id: "168",
          name: "Narayanavanam",
          state_id: "2",
        },
        {
          id: "169",
          name: "Narsapur",
          state_id: "2",
        },
        {
          id: "170",
          name: "Narsingi",
          state_id: "2",
        },
        {
          id: "171",
          name: "Narsipatnam",
          state_id: "2",
        },
        {
          id: "172",
          name: "Naspur",
          state_id: "2",
        },
        {
          id: "173",
          name: "Nathayyapalem",
          state_id: "2",
        },
        {
          id: "174",
          name: "Nayudupeta",
          state_id: "2",
        },
        {
          id: "175",
          name: "Nelimaria",
          state_id: "2",
        },
        {
          id: "176",
          name: "Nellore",
          state_id: "2",
        },
        {
          id: "177",
          name: "Nidadavole",
          state_id: "2",
        },
        {
          id: "178",
          name: "Nuzvid",
          state_id: "2",
        },
        {
          id: "179",
          name: "Omerkhan daira",
          state_id: "2",
        },
        {
          id: "180",
          name: "Ongole",
          state_id: "2",
        },
        {
          id: "181",
          name: "Osmania University",
          state_id: "2",
        },
        {
          id: "182",
          name: "Pakala",
          state_id: "2",
        },
        {
          id: "183",
          name: "Palakole",
          state_id: "2",
        },
        {
          id: "184",
          name: "Palakurthi",
          state_id: "2",
        },
        {
          id: "185",
          name: "Palasa",
          state_id: "2",
        },
        {
          id: "186",
          name: "Palempalle",
          state_id: "2",
        },
        {
          id: "187",
          name: "Palkonda",
          state_id: "2",
        },
        {
          id: "188",
          name: "Palmaner",
          state_id: "2",
        },
        {
          id: "189",
          name: "Pamur",
          state_id: "2",
        },
        {
          id: "190",
          name: "Panjim",
          state_id: "2",
        },
        {
          id: "191",
          name: "Papampeta",
          state_id: "2",
        },
        {
          id: "192",
          name: "Parasamba",
          state_id: "2",
        },
        {
          id: "193",
          name: "Parvatipuram",
          state_id: "2",
        },
        {
          id: "194",
          name: "Patancheru",
          state_id: "2",
        },
        {
          id: "195",
          name: "Payakaraopet",
          state_id: "2",
        },
        {
          id: "196",
          name: "Pedagantyada",
          state_id: "2",
        },
        {
          id: "197",
          name: "Pedana",
          state_id: "2",
        },
        {
          id: "198",
          name: "Peddapuram",
          state_id: "2",
        },
        {
          id: "199",
          name: "Pendurthi",
          state_id: "2",
        },
        {
          id: "200",
          name: "Penugonda",
          state_id: "2",
        },
        {
          id: "201",
          name: "Penukonda",
          state_id: "2",
        },
        {
          id: "202",
          name: "Phirangipuram",
          state_id: "2",
        },
        {
          id: "203",
          name: "Pithapuram",
          state_id: "2",
        },
        {
          id: "204",
          name: "Ponnur",
          state_id: "2",
        },
        {
          id: "205",
          name: "Port Blair",
          state_id: "2",
        },
        {
          id: "206",
          name: "Pothinamallayyapalem",
          state_id: "2",
        },
        {
          id: "207",
          name: "Prakasam",
          state_id: "2",
        },
        {
          id: "208",
          name: "Prasadampadu",
          state_id: "2",
        },
        {
          id: "209",
          name: "Prasantinilayam",
          state_id: "2",
        },
        {
          id: "210",
          name: "Proddatur",
          state_id: "2",
        },
        {
          id: "211",
          name: "Pulivendla",
          state_id: "2",
        },
        {
          id: "212",
          name: "Punganuru",
          state_id: "2",
        },
        {
          id: "213",
          name: "Puttur",
          state_id: "2",
        },
        {
          id: "214",
          name: "Qutubullapur",
          state_id: "2",
        },
        {
          id: "215",
          name: "Rajahmundry",
          state_id: "2",
        },
        {
          id: "216",
          name: "Rajamahendri",
          state_id: "2",
        },
        {
          id: "217",
          name: "Rajampet",
          state_id: "2",
        },
        {
          id: "218",
          name: "Rajendranagar",
          state_id: "2",
        },
        {
          id: "219",
          name: "Rajoli",
          state_id: "2",
        },
        {
          id: "220",
          name: "Ramachandrapuram",
          state_id: "2",
        },
        {
          id: "221",
          name: "Ramanayyapeta",
          state_id: "2",
        },
        {
          id: "222",
          name: "Ramapuram",
          state_id: "2",
        },
        {
          id: "223",
          name: "Ramarajupalli",
          state_id: "2",
        },
        {
          id: "224",
          name: "Ramavarappadu",
          state_id: "2",
        },
        {
          id: "225",
          name: "Rameswaram",
          state_id: "2",
        },
        {
          id: "226",
          name: "Rampachodavaram",
          state_id: "2",
        },
        {
          id: "227",
          name: "Ravulapalam",
          state_id: "2",
        },
        {
          id: "228",
          name: "Rayachoti",
          state_id: "2",
        },
        {
          id: "229",
          name: "Rayadrug",
          state_id: "2",
        },
        {
          id: "230",
          name: "Razam",
          state_id: "2",
        },
        {
          id: "231",
          name: "Razole",
          state_id: "2",
        },
        {
          id: "232",
          name: "Renigunta",
          state_id: "2",
        },
        {
          id: "233",
          name: "Repalle",
          state_id: "2",
        },
        {
          id: "234",
          name: "Rishikonda",
          state_id: "2",
        },
        {
          id: "235",
          name: "Salur",
          state_id: "2",
        },
        {
          id: "236",
          name: "Samalkot",
          state_id: "2",
        },
        {
          id: "237",
          name: "Sattenapalle",
          state_id: "2",
        },
        {
          id: "238",
          name: "Seetharampuram",
          state_id: "2",
        },
        {
          id: "239",
          name: "Serilungampalle",
          state_id: "2",
        },
        {
          id: "240",
          name: "Shankarampet",
          state_id: "2",
        },
        {
          id: "241",
          name: "Shar",
          state_id: "2",
        },
        {
          id: "242",
          name: "Singarayakonda",
          state_id: "2",
        },
        {
          id: "243",
          name: "Sirpur",
          state_id: "2",
        },
        {
          id: "244",
          name: "Sirsilla",
          state_id: "2",
        },
        {
          id: "245",
          name: "Sompeta",
          state_id: "2",
        },
        {
          id: "246",
          name: "Sriharikota",
          state_id: "2",
        },
        {
          id: "247",
          name: "Srikakulam",
          state_id: "2",
        },
        {
          id: "248",
          name: "Srikalahasti",
          state_id: "2",
        },
        {
          id: "249",
          name: "Sriramnagar",
          state_id: "2",
        },
        {
          id: "250",
          name: "Sriramsagar",
          state_id: "2",
        },
        {
          id: "251",
          name: "Srisailam",
          state_id: "2",
        },
        {
          id: "252",
          name: "Srisailamgudem Devasthanam",
          state_id: "2",
        },
        {
          id: "253",
          name: "Sulurpeta",
          state_id: "2",
        },
        {
          id: "254",
          name: "Suriapet",
          state_id: "2",
        },
        {
          id: "255",
          name: "Suryaraopet",
          state_id: "2",
        },
        {
          id: "256",
          name: "Tadepalle",
          state_id: "2",
        },
        {
          id: "257",
          name: "Tadepalligudem",
          state_id: "2",
        },
        {
          id: "258",
          name: "Tadpatri",
          state_id: "2",
        },
        {
          id: "259",
          name: "Tallapalle",
          state_id: "2",
        },
        {
          id: "260",
          name: "Tanuku",
          state_id: "2",
        },
        {
          id: "261",
          name: "Tekkali",
          state_id: "2",
        },
        {
          id: "262",
          name: "Tenali",
          state_id: "2",
        },
        {
          id: "263",
          name: "Tigalapahad",
          state_id: "2",
        },
        {
          id: "264",
          name: "Tiruchanur",
          state_id: "2",
        },
        {
          id: "265",
          name: "Tirumala",
          state_id: "2",
        },
        {
          id: "266",
          name: "Tirupati",
          state_id: "2",
        },
        {
          id: "267",
          name: "Tirvuru",
          state_id: "2",
        },
        {
          id: "268",
          name: "Trimulgherry",
          state_id: "2",
        },
        {
          id: "269",
          name: "Tuni",
          state_id: "2",
        },
        {
          id: "270",
          name: "Turangi",
          state_id: "2",
        },
        {
          id: "271",
          name: "Ukkayapalli",
          state_id: "2",
        },
        {
          id: "272",
          name: "Ukkunagaram",
          state_id: "2",
        },
        {
          id: "273",
          name: "Uppal Kalan",
          state_id: "2",
        },
        {
          id: "274",
          name: "Upper Sileru",
          state_id: "2",
        },
        {
          id: "275",
          name: "Uravakonda",
          state_id: "2",
        },
        {
          id: "276",
          name: "Vadlapudi",
          state_id: "2",
        },
        {
          id: "277",
          name: "Vaparala",
          state_id: "2",
        },
        {
          id: "278",
          name: "Vemalwada",
          state_id: "2",
        },
        {
          id: "279",
          name: "Venkatagiri",
          state_id: "2",
        },
        {
          id: "280",
          name: "Venkatapuram",
          state_id: "2",
        },
        {
          id: "281",
          name: "Vepagunta",
          state_id: "2",
        },
        {
          id: "282",
          name: "Vetapalem",
          state_id: "2",
        },
        {
          id: "283",
          name: "Vijayapuri",
          state_id: "2",
        },
        {
          id: "284",
          name: "Vijayapuri South",
          state_id: "2",
        },
        {
          id: "285",
          name: "Vijayawada",
          state_id: "2",
        },
        {
          id: "286",
          name: "Vinukonda",
          state_id: "2",
        },
        {
          id: "287",
          name: "Visakhapatnam",
          state_id: "2",
        },
        {
          id: "288",
          name: "Vizianagaram",
          state_id: "2",
        },
        {
          id: "289",
          name: "Vuyyuru",
          state_id: "2",
        },
        {
          id: "290",
          name: "Wanparti",
          state_id: "2",
        },
        {
          id: "291",
          name: "West Godavari Dist.",
          state_id: "2",
        },
        {
          id: "292",
          name: "Yadagirigutta",
          state_id: "2",
        },
        {
          id: "293",
          name: "Yarada",
          state_id: "2",
        },
        {
          id: "294",
          name: "Yellamanchili",
          state_id: "2",
        },
        {
          id: "295",
          name: "Yemmiganur",
          state_id: "2",
        },
        {
          id: "296",
          name: "Yenamalakudru",
          state_id: "2",
        },
        {
          id: "297",
          name: "Yendada",
          state_id: "2",
        },
        {
          id: "298",
          name: "Yerraguntla",
          state_id: "2",
        },
      ],
      "Arunachal Pradesh": [
        {
          id: "299",
          name: "Along",
          state_id: "3",
        },
        {
          id: "300",
          name: "Basar",
          state_id: "3",
        },
        {
          id: "301",
          name: "Bondila",
          state_id: "3",
        },
        {
          id: "302",
          name: "Changlang",
          state_id: "3",
        },
        {
          id: "303",
          name: "Daporijo",
          state_id: "3",
        },
        {
          id: "304",
          name: "Deomali",
          state_id: "3",
        },
        {
          id: "305",
          name: "Itanagar",
          state_id: "3",
        },
        {
          id: "306",
          name: "Jairampur",
          state_id: "3",
        },
        {
          id: "307",
          name: "Khonsa",
          state_id: "3",
        },
        {
          id: "308",
          name: "Naharlagun",
          state_id: "3",
        },
        {
          id: "309",
          name: "Namsai",
          state_id: "3",
        },
        {
          id: "310",
          name: "Pasighat",
          state_id: "3",
        },
        {
          id: "311",
          name: "Roing",
          state_id: "3",
        },
        {
          id: "312",
          name: "Seppa",
          state_id: "3",
        },
        {
          id: "313",
          name: "Tawang",
          state_id: "3",
        },
        {
          id: "314",
          name: "Tezu",
          state_id: "3",
        },
        {
          id: "315",
          name: "Ziro",
          state_id: "3",
        },
      ],
      Assam: [
        {
          id: "316",
          name: "Abhayapuri",
          state_id: "4",
        },
        {
          id: "317",
          name: "Ambikapur",
          state_id: "4",
        },
        {
          id: "318",
          name: "Amguri",
          state_id: "4",
        },
        {
          id: "319",
          name: "Anand Nagar",
          state_id: "4",
        },
        {
          id: "320",
          name: "Badarpur",
          state_id: "4",
        },
        {
          id: "321",
          name: "Badarpur Railway Town",
          state_id: "4",
        },
        {
          id: "322",
          name: "Bahbari Gaon",
          state_id: "4",
        },
        {
          id: "323",
          name: "Bamun Sualkuchi",
          state_id: "4",
        },
        {
          id: "324",
          name: "Barbari",
          state_id: "4",
        },
        {
          id: "325",
          name: "Barpathar",
          state_id: "4",
        },
        {
          id: "326",
          name: "Barpeta",
          state_id: "4",
        },
        {
          id: "327",
          name: "Barpeta Road",
          state_id: "4",
        },
        {
          id: "328",
          name: "Basugaon",
          state_id: "4",
        },
        {
          id: "329",
          name: "Bihpuria",
          state_id: "4",
        },
        {
          id: "330",
          name: "Bijni",
          state_id: "4",
        },
        {
          id: "331",
          name: "Bilasipara",
          state_id: "4",
        },
        {
          id: "332",
          name: "Biswanath Chariali",
          state_id: "4",
        },
        {
          id: "333",
          name: "Bohori",
          state_id: "4",
        },
        {
          id: "334",
          name: "Bokajan",
          state_id: "4",
        },
        {
          id: "335",
          name: "Bokokhat",
          state_id: "4",
        },
        {
          id: "336",
          name: "Bongaigaon",
          state_id: "4",
        },
        {
          id: "337",
          name: "Bongaigaon Petro-chemical Town",
          state_id: "4",
        },
        {
          id: "338",
          name: "Borgolai",
          state_id: "4",
        },
        {
          id: "339",
          name: "Chabua",
          state_id: "4",
        },
        {
          id: "340",
          name: "Chandrapur Bagicha",
          state_id: "4",
        },
        {
          id: "341",
          name: "Chapar",
          state_id: "4",
        },
        {
          id: "342",
          name: "Chekonidhara",
          state_id: "4",
        },
        {
          id: "343",
          name: "Choto Haibor",
          state_id: "4",
        },
        {
          id: "344",
          name: "Dergaon",
          state_id: "4",
        },
        {
          id: "345",
          name: "Dharapur",
          state_id: "4",
        },
        {
          id: "346",
          name: "Dhekiajuli",
          state_id: "4",
        },
        {
          id: "347",
          name: "Dhemaji",
          state_id: "4",
        },
        {
          id: "348",
          name: "Dhing",
          state_id: "4",
        },
        {
          id: "349",
          name: "Dhubri",
          state_id: "4",
        },
        {
          id: "350",
          name: "Dhuburi",
          state_id: "4",
        },
        {
          id: "351",
          name: "Dibrugarh",
          state_id: "4",
        },
        {
          id: "352",
          name: "Digboi",
          state_id: "4",
        },
        {
          id: "353",
          name: "Digboi Oil Town",
          state_id: "4",
        },
        {
          id: "354",
          name: "Dimaruguri",
          state_id: "4",
        },
        {
          id: "355",
          name: "Diphu",
          state_id: "4",
        },
        {
          id: "356",
          name: "Dispur",
          state_id: "4",
        },
        {
          id: "357",
          name: "Doboka",
          state_id: "4",
        },
        {
          id: "358",
          name: "Dokmoka",
          state_id: "4",
        },
        {
          id: "359",
          name: "Donkamokan",
          state_id: "4",
        },
        {
          id: "360",
          name: "Duliagaon",
          state_id: "4",
        },
        {
          id: "361",
          name: "Duliajan",
          state_id: "4",
        },
        {
          id: "362",
          name: "Duliajan No.1",
          state_id: "4",
        },
        {
          id: "363",
          name: "Dum Duma",
          state_id: "4",
        },
        {
          id: "364",
          name: "Durga Nagar",
          state_id: "4",
        },
        {
          id: "365",
          name: "Gauripur",
          state_id: "4",
        },
        {
          id: "366",
          name: "Goalpara",
          state_id: "4",
        },
        {
          id: "367",
          name: "Gohpur",
          state_id: "4",
        },
        {
          id: "368",
          name: "Golaghat",
          state_id: "4",
        },
        {
          id: "369",
          name: "Golakganj",
          state_id: "4",
        },
        {
          id: "370",
          name: "Gossaigaon",
          state_id: "4",
        },
        {
          id: "371",
          name: "Guwahati",
          state_id: "4",
        },
        {
          id: "372",
          name: "Haflong",
          state_id: "4",
        },
        {
          id: "373",
          name: "Hailakandi",
          state_id: "4",
        },
        {
          id: "374",
          name: "Hamren",
          state_id: "4",
        },
        {
          id: "375",
          name: "Hauli",
          state_id: "4",
        },
        {
          id: "376",
          name: "Hauraghat",
          state_id: "4",
        },
        {
          id: "377",
          name: "Hojai",
          state_id: "4",
        },
        {
          id: "378",
          name: "Jagiroad",
          state_id: "4",
        },
        {
          id: "379",
          name: "Jagiroad Paper Mill",
          state_id: "4",
        },
        {
          id: "380",
          name: "Jogighopa",
          state_id: "4",
        },
        {
          id: "381",
          name: "Jonai Bazar",
          state_id: "4",
        },
        {
          id: "382",
          name: "Jorhat",
          state_id: "4",
        },
        {
          id: "383",
          name: "Kampur Town",
          state_id: "4",
        },
        {
          id: "384",
          name: "Kamrup",
          state_id: "4",
        },
        {
          id: "385",
          name: "Kanakpur",
          state_id: "4",
        },
        {
          id: "386",
          name: "Karimganj",
          state_id: "4",
        },
        {
          id: "387",
          name: "Kharijapikon",
          state_id: "4",
        },
        {
          id: "388",
          name: "Kharupetia",
          state_id: "4",
        },
        {
          id: "389",
          name: "Kochpara",
          state_id: "4",
        },
        {
          id: "390",
          name: "Kokrajhar",
          state_id: "4",
        },
        {
          id: "391",
          name: "Kumar Kaibarta Gaon",
          state_id: "4",
        },
        {
          id: "392",
          name: "Lakhimpur",
          state_id: "4",
        },
        {
          id: "393",
          name: "Lakhipur",
          state_id: "4",
        },
        {
          id: "394",
          name: "Lala",
          state_id: "4",
        },
        {
          id: "395",
          name: "Lanka",
          state_id: "4",
        },
        {
          id: "396",
          name: "Lido Tikok",
          state_id: "4",
        },
        {
          id: "397",
          name: "Lido Town",
          state_id: "4",
        },
        {
          id: "398",
          name: "Lumding",
          state_id: "4",
        },
        {
          id: "399",
          name: "Lumding Railway Colony",
          state_id: "4",
        },
        {
          id: "400",
          name: "Mahur",
          state_id: "4",
        },
        {
          id: "401",
          name: "Maibong",
          state_id: "4",
        },
        {
          id: "402",
          name: "Majgaon",
          state_id: "4",
        },
        {
          id: "403",
          name: "Makum",
          state_id: "4",
        },
        {
          id: "404",
          name: "Mangaldai",
          state_id: "4",
        },
        {
          id: "405",
          name: "Mankachar",
          state_id: "4",
        },
        {
          id: "406",
          name: "Margherita",
          state_id: "4",
        },
        {
          id: "407",
          name: "Mariani",
          state_id: "4",
        },
        {
          id: "408",
          name: "Marigaon",
          state_id: "4",
        },
        {
          id: "409",
          name: "Moran",
          state_id: "4",
        },
        {
          id: "410",
          name: "Moranhat",
          state_id: "4",
        },
        {
          id: "411",
          name: "Nagaon",
          state_id: "4",
        },
        {
          id: "412",
          name: "Naharkatia",
          state_id: "4",
        },
        {
          id: "413",
          name: "Nalbari",
          state_id: "4",
        },
        {
          id: "414",
          name: "Namrup",
          state_id: "4",
        },
        {
          id: "415",
          name: "Naubaisa Gaon",
          state_id: "4",
        },
        {
          id: "416",
          name: "Nazira",
          state_id: "4",
        },
        {
          id: "417",
          name: "New Bongaigaon Railway Colony",
          state_id: "4",
        },
        {
          id: "418",
          name: "Niz-Hajo",
          state_id: "4",
        },
        {
          id: "419",
          name: "North Guwahati",
          state_id: "4",
        },
        {
          id: "420",
          name: "Numaligarh",
          state_id: "4",
        },
        {
          id: "421",
          name: "Palasbari",
          state_id: "4",
        },
        {
          id: "422",
          name: "Panchgram",
          state_id: "4",
        },
        {
          id: "423",
          name: "Pathsala",
          state_id: "4",
        },
        {
          id: "424",
          name: "Raha",
          state_id: "4",
        },
        {
          id: "425",
          name: "Rangapara",
          state_id: "4",
        },
        {
          id: "426",
          name: "Rangia",
          state_id: "4",
        },
        {
          id: "427",
          name: "Salakati",
          state_id: "4",
        },
        {
          id: "428",
          name: "Sapatgram",
          state_id: "4",
        },
        {
          id: "429",
          name: "Sarthebari",
          state_id: "4",
        },
        {
          id: "430",
          name: "Sarupathar",
          state_id: "4",
        },
        {
          id: "431",
          name: "Sarupathar Bengali",
          state_id: "4",
        },
        {
          id: "432",
          name: "Senchoagaon",
          state_id: "4",
        },
        {
          id: "433",
          name: "Sibsagar",
          state_id: "4",
        },
        {
          id: "434",
          name: "Silapathar",
          state_id: "4",
        },
        {
          id: "435",
          name: "Silchar",
          state_id: "4",
        },
        {
          id: "436",
          name: "Silchar Part-X",
          state_id: "4",
        },
        {
          id: "437",
          name: "Sonari",
          state_id: "4",
        },
        {
          id: "438",
          name: "Sorbhog",
          state_id: "4",
        },
        {
          id: "439",
          name: "Sualkuchi",
          state_id: "4",
        },
        {
          id: "440",
          name: "Tangla",
          state_id: "4",
        },
        {
          id: "441",
          name: "Tezpur",
          state_id: "4",
        },
        {
          id: "442",
          name: "Tihu",
          state_id: "4",
        },
        {
          id: "443",
          name: "Tinsukia",
          state_id: "4",
        },
        {
          id: "444",
          name: "Titabor",
          state_id: "4",
        },
        {
          id: "445",
          name: "Udalguri",
          state_id: "4",
        },
        {
          id: "446",
          name: "Umrangso",
          state_id: "4",
        },
        {
          id: "447",
          name: "Uttar Krishnapur Part-I",
          state_id: "4",
        },
      ],
      Bihar: [
        {
          id: "448",
          name: "Amarpur",
          state_id: "5",
        },
        {
          id: "449",
          name: "Ara",
          state_id: "5",
        },
        {
          id: "450",
          name: "Araria",
          state_id: "5",
        },
        {
          id: "451",
          name: "Areraj",
          state_id: "5",
        },
        {
          id: "452",
          name: "Asarganj",
          state_id: "5",
        },
        {
          id: "453",
          name: "Aurangabad",
          state_id: "5",
        },
        {
          id: "454",
          name: "Bagaha",
          state_id: "5",
        },
        {
          id: "455",
          name: "Bahadurganj",
          state_id: "5",
        },
        {
          id: "456",
          name: "Bairgania",
          state_id: "5",
        },
        {
          id: "457",
          name: "Bakhtiyarpur",
          state_id: "5",
        },
        {
          id: "458",
          name: "Banka",
          state_id: "5",
        },
        {
          id: "459",
          name: "Banmankhi",
          state_id: "5",
        },
        {
          id: "460",
          name: "Bar Bigha",
          state_id: "5",
        },
        {
          id: "461",
          name: "Barauli",
          state_id: "5",
        },
        {
          id: "462",
          name: "Barauni Oil Township",
          state_id: "5",
        },
        {
          id: "463",
          name: "Barh",
          state_id: "5",
        },
        {
          id: "464",
          name: "Barhiya",
          state_id: "5",
        },
        {
          id: "465",
          name: "Bariapur",
          state_id: "5",
        },
        {
          id: "466",
          name: "Baruni",
          state_id: "5",
        },
        {
          id: "467",
          name: "Begusarai",
          state_id: "5",
        },
        {
          id: "468",
          name: "Behea",
          state_id: "5",
        },
        {
          id: "469",
          name: "Belsand",
          state_id: "5",
        },
        {
          id: "470",
          name: "Bettiah",
          state_id: "5",
        },
        {
          id: "471",
          name: "Bhabua",
          state_id: "5",
        },
        {
          id: "472",
          name: "Bhagalpur",
          state_id: "5",
        },
        {
          id: "473",
          name: "Bhimnagar",
          state_id: "5",
        },
        {
          id: "474",
          name: "Bhojpur",
          state_id: "5",
        },
        {
          id: "475",
          name: "Bihar",
          state_id: "5",
        },
        {
          id: "476",
          name: "Bihar Sharif",
          state_id: "5",
        },
        {
          id: "477",
          name: "Bihariganj",
          state_id: "5",
        },
        {
          id: "478",
          name: "Bikramganj",
          state_id: "5",
        },
        {
          id: "479",
          name: "Birpur",
          state_id: "5",
        },
        {
          id: "480",
          name: "Bodh Gaya",
          state_id: "5",
        },
        {
          id: "481",
          name: "Buxar",
          state_id: "5",
        },
        {
          id: "482",
          name: "Chakia",
          state_id: "5",
        },
        {
          id: "483",
          name: "Chanpatia",
          state_id: "5",
        },
        {
          id: "484",
          name: "Chhapra",
          state_id: "5",
        },
        {
          id: "485",
          name: "Chhatapur",
          state_id: "5",
        },
        {
          id: "486",
          name: "Colgong",
          state_id: "5",
        },
        {
          id: "487",
          name: "Dalsingh Sarai",
          state_id: "5",
        },
        {
          id: "488",
          name: "Darbhanga",
          state_id: "5",
        },
        {
          id: "489",
          name: "Daudnagar",
          state_id: "5",
        },
        {
          id: "490",
          name: "Dehri",
          state_id: "5",
        },
        {
          id: "491",
          name: "Dhaka",
          state_id: "5",
        },
        {
          id: "492",
          name: "Dighwara",
          state_id: "5",
        },
        {
          id: "493",
          name: "Dinapur",
          state_id: "5",
        },
        {
          id: "494",
          name: "Dinapur Cantonment",
          state_id: "5",
        },
        {
          id: "495",
          name: "Dumra",
          state_id: "5",
        },
        {
          id: "496",
          name: "Dumraon",
          state_id: "5",
        },
        {
          id: "497",
          name: "Fatwa",
          state_id: "5",
        },
        {
          id: "498",
          name: "Forbesganj",
          state_id: "5",
        },
        {
          id: "499",
          name: "Gaya",
          state_id: "5",
        },
        {
          id: "500",
          name: "Gazipur",
          state_id: "5",
        },
        {
          id: "501",
          name: "Ghoghardiha",
          state_id: "5",
        },
        {
          id: "502",
          name: "Gogri Jamalpur",
          state_id: "5",
        },
        {
          id: "503",
          name: "Gopalganj",
          state_id: "5",
        },
        {
          id: "504",
          name: "Habibpur",
          state_id: "5",
        },
        {
          id: "505",
          name: "Hajipur",
          state_id: "5",
        },
        {
          id: "506",
          name: "Hasanpur",
          state_id: "5",
        },
        {
          id: "507",
          name: "Hazaribagh",
          state_id: "5",
        },
        {
          id: "508",
          name: "Hilsa",
          state_id: "5",
        },
        {
          id: "509",
          name: "Hisua",
          state_id: "5",
        },
        {
          id: "510",
          name: "Islampur",
          state_id: "5",
        },
        {
          id: "511",
          name: "Jagdispur",
          state_id: "5",
        },
        {
          id: "512",
          name: "Jahanabad",
          state_id: "5",
        },
        {
          id: "513",
          name: "Jamalpur",
          state_id: "5",
        },
        {
          id: "514",
          name: "Jamhaur",
          state_id: "5",
        },
        {
          id: "515",
          name: "Jamui",
          state_id: "5",
        },
        {
          id: "516",
          name: "Janakpur Road",
          state_id: "5",
        },
        {
          id: "517",
          name: "Janpur",
          state_id: "5",
        },
        {
          id: "518",
          name: "Jaynagar",
          state_id: "5",
        },
        {
          id: "519",
          name: "Jha Jha",
          state_id: "5",
        },
        {
          id: "520",
          name: "Jhanjharpur",
          state_id: "5",
        },
        {
          id: "521",
          name: "Jogbani",
          state_id: "5",
        },
        {
          id: "522",
          name: "Kanti",
          state_id: "5",
        },
        {
          id: "523",
          name: "Kasba",
          state_id: "5",
        },
        {
          id: "524",
          name: "Kataiya",
          state_id: "5",
        },
        {
          id: "525",
          name: "Katihar",
          state_id: "5",
        },
        {
          id: "526",
          name: "Khagaria",
          state_id: "5",
        },
        {
          id: "527",
          name: "Khagaul",
          state_id: "5",
        },
        {
          id: "528",
          name: "Kharagpur",
          state_id: "5",
        },
        {
          id: "529",
          name: "Khusrupur",
          state_id: "5",
        },
        {
          id: "530",
          name: "Kishanganj",
          state_id: "5",
        },
        {
          id: "531",
          name: "Koath",
          state_id: "5",
        },
        {
          id: "532",
          name: "Koilwar",
          state_id: "5",
        },
        {
          id: "533",
          name: "Lakhisarai",
          state_id: "5",
        },
        {
          id: "534",
          name: "Lalganj",
          state_id: "5",
        },
        {
          id: "535",
          name: "Lauthaha",
          state_id: "5",
        },
        {
          id: "536",
          name: "Madhepura",
          state_id: "5",
        },
        {
          id: "537",
          name: "Madhubani",
          state_id: "5",
        },
        {
          id: "538",
          name: "Maharajganj",
          state_id: "5",
        },
        {
          id: "539",
          name: "Mahnar Bazar",
          state_id: "5",
        },
        {
          id: "540",
          name: "Mairwa",
          state_id: "5",
        },
        {
          id: "541",
          name: "Makhdumpur",
          state_id: "5",
        },
        {
          id: "542",
          name: "Maner",
          state_id: "5",
        },
        {
          id: "543",
          name: "Manihari",
          state_id: "5",
        },
        {
          id: "544",
          name: "Marhaura",
          state_id: "5",
        },
        {
          id: "545",
          name: "Masaurhi",
          state_id: "5",
        },
        {
          id: "546",
          name: "Mirganj",
          state_id: "5",
        },
        {
          id: "547",
          name: "Mohiuddinagar",
          state_id: "5",
        },
        {
          id: "548",
          name: "Mokama",
          state_id: "5",
        },
        {
          id: "549",
          name: "Motihari",
          state_id: "5",
        },
        {
          id: "550",
          name: "Motipur",
          state_id: "5",
        },
        {
          id: "551",
          name: "Munger",
          state_id: "5",
        },
        {
          id: "552",
          name: "Murliganj",
          state_id: "5",
        },
        {
          id: "553",
          name: "Muzaffarpur",
          state_id: "5",
        },
        {
          id: "554",
          name: "Nabinagar",
          state_id: "5",
        },
        {
          id: "555",
          name: "Narkatiaganj",
          state_id: "5",
        },
        {
          id: "556",
          name: "Nasriganj",
          state_id: "5",
        },
        {
          id: "557",
          name: "Natwar",
          state_id: "5",
        },
        {
          id: "558",
          name: "Naugachhia",
          state_id: "5",
        },
        {
          id: "559",
          name: "Nawada",
          state_id: "5",
        },
        {
          id: "560",
          name: "Nirmali",
          state_id: "5",
        },
        {
          id: "561",
          name: "Nokha",
          state_id: "5",
        },
        {
          id: "562",
          name: "Paharpur",
          state_id: "5",
        },
        {
          id: "563",
          name: "Patna",
          state_id: "5",
        },
        {
          id: "564",
          name: "Phulwari",
          state_id: "5",
        },
        {
          id: "565",
          name: "Piro",
          state_id: "5",
        },
        {
          id: "566",
          name: "Purnia",
          state_id: "5",
        },
        {
          id: "567",
          name: "Pusa",
          state_id: "5",
        },
        {
          id: "568",
          name: "Rafiganj",
          state_id: "5",
        },
        {
          id: "569",
          name: "Raghunathpur",
          state_id: "5",
        },
        {
          id: "570",
          name: "Rajgir",
          state_id: "5",
        },
        {
          id: "571",
          name: "Ramnagar",
          state_id: "5",
        },
        {
          id: "572",
          name: "Raxaul",
          state_id: "5",
        },
        {
          id: "573",
          name: "Revelganj",
          state_id: "5",
        },
        {
          id: "574",
          name: "Rusera",
          state_id: "5",
        },
        {
          id: "575",
          name: "Sagauli",
          state_id: "5",
        },
        {
          id: "576",
          name: "Saharsa",
          state_id: "5",
        },
        {
          id: "577",
          name: "Samastipur",
          state_id: "5",
        },
        {
          id: "578",
          name: "Sasaram",
          state_id: "5",
        },
        {
          id: "579",
          name: "Shahpur",
          state_id: "5",
        },
        {
          id: "580",
          name: "Shaikhpura",
          state_id: "5",
        },
        {
          id: "581",
          name: "Sherghati",
          state_id: "5",
        },
        {
          id: "582",
          name: "Shivhar",
          state_id: "5",
        },
        {
          id: "583",
          name: "Silao",
          state_id: "5",
        },
        {
          id: "584",
          name: "Sitamarhi",
          state_id: "5",
        },
        {
          id: "585",
          name: "Siwan",
          state_id: "5",
        },
        {
          id: "586",
          name: "Sonepur",
          state_id: "5",
        },
        {
          id: "587",
          name: "Sultanganj",
          state_id: "5",
        },
        {
          id: "588",
          name: "Supaul",
          state_id: "5",
        },
        {
          id: "589",
          name: "Teghra",
          state_id: "5",
        },
        {
          id: "590",
          name: "Tekari",
          state_id: "5",
        },
        {
          id: "591",
          name: "Thakurganj",
          state_id: "5",
        },
        {
          id: "592",
          name: "Vaishali",
          state_id: "5",
        },
        {
          id: "593",
          name: "Waris Aliganj",
          state_id: "5",
        },
      ],
      Chandigarh: [
        {
          id: "594",
          name: "Chandigarh",
          state_id: "6",
        },
      ],
      Chhattisgarh: [
        {
          id: "595",
          name: "Ahiwara",
          state_id: "7",
        },
        {
          id: "596",
          name: "Akaltara",
          state_id: "7",
        },
        {
          id: "597",
          name: "Ambagarh Chauki",
          state_id: "7",
        },
        {
          id: "598",
          name: "Ambikapur",
          state_id: "7",
        },
        {
          id: "599",
          name: "Arang",
          state_id: "7",
        },
        {
          id: "600",
          name: "Bade Bacheli",
          state_id: "7",
        },
        {
          id: "601",
          name: "Bagbahara",
          state_id: "7",
        },
        {
          id: "602",
          name: "Baikunthpur",
          state_id: "7",
        },
        {
          id: "603",
          name: "Balod",
          state_id: "7",
        },
        {
          id: "604",
          name: "Baloda",
          state_id: "7",
        },
        {
          id: "605",
          name: "Baloda Bazar",
          state_id: "7",
        },
        {
          id: "606",
          name: "Banarsi",
          state_id: "7",
        },
        {
          id: "607",
          name: "Basna",
          state_id: "7",
        },
        {
          id: "608",
          name: "Bemetra",
          state_id: "7",
        },
        {
          id: "609",
          name: "Bhanpuri",
          state_id: "7",
        },
        {
          id: "610",
          name: "Bhatapara",
          state_id: "7",
        },
        {
          id: "611",
          name: "Bhatgaon",
          state_id: "7",
        },
        {
          id: "612",
          name: "Bhilai",
          state_id: "7",
        },
        {
          id: "613",
          name: "Bilaspur",
          state_id: "7",
        },
        {
          id: "614",
          name: "Bilha",
          state_id: "7",
        },
        {
          id: "615",
          name: "Birgaon",
          state_id: "7",
        },
        {
          id: "616",
          name: "Bodri",
          state_id: "7",
        },
        {
          id: "617",
          name: "Champa",
          state_id: "7",
        },
        {
          id: "618",
          name: "Charcha",
          state_id: "7",
        },
        {
          id: "619",
          name: "Charoda",
          state_id: "7",
        },
        {
          id: "620",
          name: "Chhuikhadan",
          state_id: "7",
        },
        {
          id: "621",
          name: "Chirmiri",
          state_id: "7",
        },
        {
          id: "622",
          name: "Dantewada",
          state_id: "7",
        },
        {
          id: "623",
          name: "Deori",
          state_id: "7",
        },
        {
          id: "624",
          name: "Dhamdha",
          state_id: "7",
        },
        {
          id: "625",
          name: "Dhamtari",
          state_id: "7",
        },
        {
          id: "626",
          name: "Dharamjaigarh",
          state_id: "7",
        },
        {
          id: "627",
          name: "Dipka",
          state_id: "7",
        },
        {
          id: "628",
          name: "Doman Hill Colliery",
          state_id: "7",
        },
        {
          id: "629",
          name: "Dongargaon",
          state_id: "7",
        },
        {
          id: "630",
          name: "Dongragarh",
          state_id: "7",
        },
        {
          id: "631",
          name: "Durg",
          state_id: "7",
        },
        {
          id: "632",
          name: "Frezarpur",
          state_id: "7",
        },
        {
          id: "633",
          name: "Gandai",
          state_id: "7",
        },
        {
          id: "634",
          name: "Gariaband",
          state_id: "7",
        },
        {
          id: "635",
          name: "Gaurela",
          state_id: "7",
        },
        {
          id: "636",
          name: "Gelhapani",
          state_id: "7",
        },
        {
          id: "637",
          name: "Gharghoda",
          state_id: "7",
        },
        {
          id: "638",
          name: "Gidam",
          state_id: "7",
        },
        {
          id: "639",
          name: "Gobra Nawapara",
          state_id: "7",
        },
        {
          id: "640",
          name: "Gogaon",
          state_id: "7",
        },
        {
          id: "641",
          name: "Hatkachora",
          state_id: "7",
        },
        {
          id: "642",
          name: "Jagdalpur",
          state_id: "7",
        },
        {
          id: "643",
          name: "Jamui",
          state_id: "7",
        },
        {
          id: "644",
          name: "Jashpurnagar",
          state_id: "7",
        },
        {
          id: "645",
          name: "Jhagrakhand",
          state_id: "7",
        },
        {
          id: "646",
          name: "Kanker",
          state_id: "7",
        },
        {
          id: "647",
          name: "Katghora",
          state_id: "7",
        },
        {
          id: "648",
          name: "Kawardha",
          state_id: "7",
        },
        {
          id: "649",
          name: "Khairagarh",
          state_id: "7",
        },
        {
          id: "650",
          name: "Khamhria",
          state_id: "7",
        },
        {
          id: "651",
          name: "Kharod",
          state_id: "7",
        },
        {
          id: "652",
          name: "Kharsia",
          state_id: "7",
        },
        {
          id: "653",
          name: "Khonga Pani",
          state_id: "7",
        },
        {
          id: "654",
          name: "Kirandu",
          state_id: "7",
        },
        {
          id: "655",
          name: "Kirandul",
          state_id: "7",
        },
        {
          id: "656",
          name: "Kohka",
          state_id: "7",
        },
        {
          id: "657",
          name: "Kondagaon",
          state_id: "7",
        },
        {
          id: "658",
          name: "Korba",
          state_id: "7",
        },
        {
          id: "659",
          name: "Korea",
          state_id: "7",
        },
        {
          id: "660",
          name: "Koria Block",
          state_id: "7",
        },
        {
          id: "661",
          name: "Kota",
          state_id: "7",
        },
        {
          id: "662",
          name: "Kumhari",
          state_id: "7",
        },
        {
          id: "663",
          name: "Kumud Katta",
          state_id: "7",
        },
        {
          id: "664",
          name: "Kurasia",
          state_id: "7",
        },
        {
          id: "665",
          name: "Kurud",
          state_id: "7",
        },
        {
          id: "666",
          name: "Lingiyadih",
          state_id: "7",
        },
        {
          id: "667",
          name: "Lormi",
          state_id: "7",
        },
        {
          id: "668",
          name: "Mahasamund",
          state_id: "7",
        },
        {
          id: "669",
          name: "Mahendragarh",
          state_id: "7",
        },
        {
          id: "670",
          name: "Mehmand",
          state_id: "7",
        },
        {
          id: "671",
          name: "Mongra",
          state_id: "7",
        },
        {
          id: "672",
          name: "Mowa",
          state_id: "7",
        },
        {
          id: "673",
          name: "Mungeli",
          state_id: "7",
        },
        {
          id: "674",
          name: "Nailajanjgir",
          state_id: "7",
        },
        {
          id: "675",
          name: "Namna Kalan",
          state_id: "7",
        },
        {
          id: "676",
          name: "Naya Baradwar",
          state_id: "7",
        },
        {
          id: "677",
          name: "Pandariya",
          state_id: "7",
        },
        {
          id: "678",
          name: "Patan",
          state_id: "7",
        },
        {
          id: "679",
          name: "Pathalgaon",
          state_id: "7",
        },
        {
          id: "680",
          name: "Pendra",
          state_id: "7",
        },
        {
          id: "681",
          name: "Phunderdihari",
          state_id: "7",
        },
        {
          id: "682",
          name: "Pithora",
          state_id: "7",
        },
        {
          id: "683",
          name: "Raigarh",
          state_id: "7",
        },
        {
          id: "684",
          name: "Raipur",
          state_id: "7",
        },
        {
          id: "685",
          name: "Rajgamar",
          state_id: "7",
        },
        {
          id: "686",
          name: "Rajhara",
          state_id: "7",
        },
        {
          id: "687",
          name: "Rajnandgaon",
          state_id: "7",
        },
        {
          id: "688",
          name: "Ramanuj Ganj",
          state_id: "7",
        },
        {
          id: "689",
          name: "Ratanpur",
          state_id: "7",
        },
        {
          id: "690",
          name: "Sakti",
          state_id: "7",
        },
        {
          id: "691",
          name: "Saraipali",
          state_id: "7",
        },
        {
          id: "692",
          name: "Sarajpur",
          state_id: "7",
        },
        {
          id: "693",
          name: "Sarangarh",
          state_id: "7",
        },
        {
          id: "694",
          name: "Shivrinarayan",
          state_id: "7",
        },
        {
          id: "695",
          name: "Simga",
          state_id: "7",
        },
        {
          id: "696",
          name: "Sirgiti",
          state_id: "7",
        },
        {
          id: "697",
          name: "Takhatpur",
          state_id: "7",
        },
        {
          id: "698",
          name: "Telgaon",
          state_id: "7",
        },
        {
          id: "699",
          name: "Tildanewra",
          state_id: "7",
        },
        {
          id: "700",
          name: "Urla",
          state_id: "7",
        },
        {
          id: "701",
          name: "Vishrampur",
          state_id: "7",
        },
      ],
      "Dadra and Nagar Haveli": [
        {
          id: "702",
          name: "Amli",
          state_id: "8",
        },
        {
          id: "703",
          name: "Silvassa",
          state_id: "8",
        },
      ],
      "Daman and Diu": [
        {
          id: "704",
          name: "Daman",
          state_id: "9",
        },
        {
          id: "705",
          name: "Diu",
          state_id: "9",
        },
      ],
      Delhi: [
        {
          id: "706",
          name: "Delhi",
          state_id: "10",
        },
        {
          id: "707",
          name: "New Delhi",
          state_id: "10",
        },
      ],
      Goa: [
        {
          id: "708",
          name: "Aldona",
          state_id: "11",
        },
        {
          id: "709",
          name: "Altinho",
          state_id: "11",
        },
        {
          id: "710",
          name: "Aquem",
          state_id: "11",
        },
        {
          id: "711",
          name: "Arpora",
          state_id: "11",
        },
        {
          id: "712",
          name: "Bambolim",
          state_id: "11",
        },
        {
          id: "713",
          name: "Bandora",
          state_id: "11",
        },
        {
          id: "714",
          name: "Bardez",
          state_id: "11",
        },
        {
          id: "715",
          name: "Benaulim",
          state_id: "11",
        },
        {
          id: "716",
          name: "Betora",
          state_id: "11",
        },
        {
          id: "717",
          name: "Bicholim",
          state_id: "11",
        },
        {
          id: "718",
          name: "Calapor",
          state_id: "11",
        },
        {
          id: "719",
          name: "Candolim",
          state_id: "11",
        },
        {
          id: "720",
          name: "Caranzalem",
          state_id: "11",
        },
        {
          id: "721",
          name: "Carapur",
          state_id: "11",
        },
        {
          id: "722",
          name: "Chicalim",
          state_id: "11",
        },
        {
          id: "723",
          name: "Chimbel",
          state_id: "11",
        },
        {
          id: "724",
          name: "Chinchinim",
          state_id: "11",
        },
        {
          id: "725",
          name: "Colvale",
          state_id: "11",
        },
        {
          id: "726",
          name: "Corlim",
          state_id: "11",
        },
        {
          id: "727",
          name: "Cortalim",
          state_id: "11",
        },
        {
          id: "728",
          name: "Cuncolim",
          state_id: "11",
        },
        {
          id: "729",
          name: "Curchorem",
          state_id: "11",
        },
        {
          id: "730",
          name: "Curti",
          state_id: "11",
        },
        {
          id: "731",
          name: "Davorlim",
          state_id: "11",
        },
        {
          id: "732",
          name: "Dona Paula",
          state_id: "11",
        },
        {
          id: "733",
          name: "Goa",
          state_id: "11",
        },
        {
          id: "734",
          name: "Guirim",
          state_id: "11",
        },
        {
          id: "735",
          name: "Jua",
          state_id: "11",
        },
        {
          id: "736",
          name: "Kalangat",
          state_id: "11",
        },
        {
          id: "737",
          name: "Kankon",
          state_id: "11",
        },
        {
          id: "738",
          name: "Kundaim",
          state_id: "11",
        },
        {
          id: "739",
          name: "Loutulim",
          state_id: "11",
        },
        {
          id: "740",
          name: "Madgaon",
          state_id: "11",
        },
        {
          id: "741",
          name: "Mapusa",
          state_id: "11",
        },
        {
          id: "742",
          name: "Margao",
          state_id: "11",
        },
        {
          id: "743",
          name: "Margaon",
          state_id: "11",
        },
        {
          id: "744",
          name: "Miramar",
          state_id: "11",
        },
        {
          id: "745",
          name: "Morjim",
          state_id: "11",
        },
        {
          id: "746",
          name: "Mormugao",
          state_id: "11",
        },
        {
          id: "747",
          name: "Navelim",
          state_id: "11",
        },
        {
          id: "748",
          name: "Pale",
          state_id: "11",
        },
        {
          id: "749",
          name: "Panaji",
          state_id: "11",
        },
        {
          id: "750",
          name: "Parcem",
          state_id: "11",
        },
        {
          id: "751",
          name: "Parra",
          state_id: "11",
        },
        {
          id: "752",
          name: "Penha de Franca",
          state_id: "11",
        },
        {
          id: "753",
          name: "Pernem",
          state_id: "11",
        },
        {
          id: "754",
          name: "Pilerne",
          state_id: "11",
        },
        {
          id: "755",
          name: "Pissurlem",
          state_id: "11",
        },
        {
          id: "756",
          name: "Ponda",
          state_id: "11",
        },
        {
          id: "757",
          name: "Porvorim",
          state_id: "11",
        },
        {
          id: "758",
          name: "Quepem",
          state_id: "11",
        },
        {
          id: "759",
          name: "Queula",
          state_id: "11",
        },
        {
          id: "760",
          name: "Raia",
          state_id: "11",
        },
        {
          id: "761",
          name: "Reis Magos",
          state_id: "11",
        },
        {
          id: "762",
          name: "Salcette",
          state_id: "11",
        },
        {
          id: "763",
          name: "Saligao",
          state_id: "11",
        },
        {
          id: "764",
          name: "Sancoale",
          state_id: "11",
        },
        {
          id: "765",
          name: "Sanguem",
          state_id: "11",
        },
        {
          id: "766",
          name: "Sanquelim",
          state_id: "11",
        },
        {
          id: "767",
          name: "Sanvordem",
          state_id: "11",
        },
        {
          id: "768",
          name: "Sao Jose-de-Areal",
          state_id: "11",
        },
        {
          id: "769",
          name: "Sattari",
          state_id: "11",
        },
        {
          id: "770",
          name: "Serula",
          state_id: "11",
        },
        {
          id: "771",
          name: "Sinquerim",
          state_id: "11",
        },
        {
          id: "772",
          name: "Siolim",
          state_id: "11",
        },
        {
          id: "773",
          name: "Taleigao",
          state_id: "11",
        },
        {
          id: "774",
          name: "Tivim",
          state_id: "11",
        },
        {
          id: "775",
          name: "Valpoi",
          state_id: "11",
        },
        {
          id: "776",
          name: "Varca",
          state_id: "11",
        },
        {
          id: "777",
          name: "Vasco",
          state_id: "11",
        },
        {
          id: "778",
          name: "Verna",
          state_id: "11",
        },
      ],
      Gujarat: [
        {
          id: "779",
          name: "Abrama",
          state_id: "12",
        },
        {
          id: "780",
          name: "Adalaj",
          state_id: "12",
        },
        {
          id: "781",
          name: "Adityana",
          state_id: "12",
        },
        {
          id: "782",
          name: "Advana",
          state_id: "12",
        },
        {
          id: "783",
          name: "Ahmedabad",
          state_id: "12",
        },
        {
          id: "784",
          name: "Ahwa",
          state_id: "12",
        },
        {
          id: "785",
          name: "Alang",
          state_id: "12",
        },
        {
          id: "786",
          name: "Ambaji",
          state_id: "12",
        },
        {
          id: "787",
          name: "Ambaliyasan",
          state_id: "12",
        },
        {
          id: "788",
          name: "Amod",
          state_id: "12",
        },
        {
          id: "789",
          name: "Amreli",
          state_id: "12",
        },
        {
          id: "790",
          name: "Amroli",
          state_id: "12",
        },
        {
          id: "791",
          name: "Anand",
          state_id: "12",
        },
        {
          id: "792",
          name: "Andada",
          state_id: "12",
        },
        {
          id: "793",
          name: "Anjar",
          state_id: "12",
        },
        {
          id: "794",
          name: "Anklav",
          state_id: "12",
        },
        {
          id: "795",
          name: "Ankleshwar",
          state_id: "12",
        },
        {
          id: "796",
          name: "Anklesvar INA",
          state_id: "12",
        },
        {
          id: "797",
          name: "Antaliya",
          state_id: "12",
        },
        {
          id: "798",
          name: "Arambhada",
          state_id: "12",
        },
        {
          id: "799",
          name: "Asarma",
          state_id: "12",
        },
        {
          id: "800",
          name: "Atul",
          state_id: "12",
        },
        {
          id: "801",
          name: "Babra",
          state_id: "12",
        },
        {
          id: "802",
          name: "Bag-e-Firdosh",
          state_id: "12",
        },
        {
          id: "803",
          name: "Bagasara",
          state_id: "12",
        },
        {
          id: "804",
          name: "Bahadarpar",
          state_id: "12",
        },
        {
          id: "805",
          name: "Bajipura",
          state_id: "12",
        },
        {
          id: "806",
          name: "Bajva",
          state_id: "12",
        },
        {
          id: "807",
          name: "Balasinor",
          state_id: "12",
        },
        {
          id: "808",
          name: "Banaskantha",
          state_id: "12",
        },
        {
          id: "809",
          name: "Bansda",
          state_id: "12",
        },
        {
          id: "810",
          name: "Bantva",
          state_id: "12",
        },
        {
          id: "811",
          name: "Bardoli",
          state_id: "12",
        },
        {
          id: "812",
          name: "Barwala",
          state_id: "12",
        },
        {
          id: "813",
          name: "Bayad",
          state_id: "12",
        },
        {
          id: "814",
          name: "Bechar",
          state_id: "12",
        },
        {
          id: "815",
          name: "Bedi",
          state_id: "12",
        },
        {
          id: "816",
          name: "Beyt",
          state_id: "12",
        },
        {
          id: "817",
          name: "Bhachau",
          state_id: "12",
        },
        {
          id: "818",
          name: "Bhanvad",
          state_id: "12",
        },
        {
          id: "819",
          name: "Bharuch",
          state_id: "12",
        },
        {
          id: "820",
          name: "Bharuch INA",
          state_id: "12",
        },
        {
          id: "821",
          name: "Bhavnagar",
          state_id: "12",
        },
        {
          id: "822",
          name: "Bhayavadar",
          state_id: "12",
        },
        {
          id: "823",
          name: "Bhestan",
          state_id: "12",
        },
        {
          id: "824",
          name: "Bhuj",
          state_id: "12",
        },
        {
          id: "825",
          name: "Bilimora",
          state_id: "12",
        },
        {
          id: "826",
          name: "Bilkha",
          state_id: "12",
        },
        {
          id: "827",
          name: "Billimora",
          state_id: "12",
        },
        {
          id: "828",
          name: "Bodakdev",
          state_id: "12",
        },
        {
          id: "829",
          name: "Bodeli",
          state_id: "12",
        },
        {
          id: "830",
          name: "Bopal",
          state_id: "12",
        },
        {
          id: "831",
          name: "Boria",
          state_id: "12",
        },
        {
          id: "832",
          name: "Boriavi",
          state_id: "12",
        },
        {
          id: "833",
          name: "Borsad",
          state_id: "12",
        },
        {
          id: "834",
          name: "Botad",
          state_id: "12",
        },
        {
          id: "835",
          name: "Cambay",
          state_id: "12",
        },
        {
          id: "836",
          name: "Chaklasi",
          state_id: "12",
        },
        {
          id: "837",
          name: "Chala",
          state_id: "12",
        },
        {
          id: "838",
          name: "Chalala",
          state_id: "12",
        },
        {
          id: "839",
          name: "Chalthan",
          state_id: "12",
        },
        {
          id: "840",
          name: "Chanasma",
          state_id: "12",
        },
        {
          id: "841",
          name: "Chandisar",
          state_id: "12",
        },
        {
          id: "842",
          name: "Chandkheda",
          state_id: "12",
        },
        {
          id: "843",
          name: "Chanod",
          state_id: "12",
        },
        {
          id: "844",
          name: "Chaya",
          state_id: "12",
        },
        {
          id: "845",
          name: "Chenpur",
          state_id: "12",
        },
        {
          id: "846",
          name: "Chhapi",
          state_id: "12",
        },
        {
          id: "847",
          name: "Chhaprabhatha",
          state_id: "12",
        },
        {
          id: "848",
          name: "Chhatral",
          state_id: "12",
        },
        {
          id: "849",
          name: "Chhota Udepur",
          state_id: "12",
        },
        {
          id: "850",
          name: "Chikhli",
          state_id: "12",
        },
        {
          id: "851",
          name: "Chiloda",
          state_id: "12",
        },
        {
          id: "852",
          name: "Chorvad",
          state_id: "12",
        },
        {
          id: "853",
          name: "Chotila",
          state_id: "12",
        },
        {
          id: "854",
          name: "Dabhoi",
          state_id: "12",
        },
        {
          id: "855",
          name: "Dadara",
          state_id: "12",
        },
        {
          id: "856",
          name: "Dahod",
          state_id: "12",
        },
        {
          id: "857",
          name: "Dakor",
          state_id: "12",
        },
        {
          id: "858",
          name: "Damnagar",
          state_id: "12",
        },
        {
          id: "859",
          name: "Deesa",
          state_id: "12",
        },
        {
          id: "860",
          name: "Delvada",
          state_id: "12",
        },
        {
          id: "861",
          name: "Devgadh Baria",
          state_id: "12",
        },
        {
          id: "862",
          name: "Devsar",
          state_id: "12",
        },
        {
          id: "863",
          name: "Dhandhuka",
          state_id: "12",
        },
        {
          id: "864",
          name: "Dhanera",
          state_id: "12",
        },
        {
          id: "865",
          name: "Dhangdhra",
          state_id: "12",
        },
        {
          id: "866",
          name: "Dhansura",
          state_id: "12",
        },
        {
          id: "867",
          name: "Dharampur",
          state_id: "12",
        },
        {
          id: "868",
          name: "Dhari",
          state_id: "12",
        },
        {
          id: "869",
          name: "Dhola",
          state_id: "12",
        },
        {
          id: "870",
          name: "Dholka",
          state_id: "12",
        },
        {
          id: "871",
          name: "Dholka Rural",
          state_id: "12",
        },
        {
          id: "872",
          name: "Dhoraji",
          state_id: "12",
        },
        {
          id: "873",
          name: "Dhrangadhra",
          state_id: "12",
        },
        {
          id: "874",
          name: "Dhrol",
          state_id: "12",
        },
        {
          id: "875",
          name: "Dhuva",
          state_id: "12",
        },
        {
          id: "876",
          name: "Dhuwaran",
          state_id: "12",
        },
        {
          id: "877",
          name: "Digvijaygram",
          state_id: "12",
        },
        {
          id: "878",
          name: "Disa",
          state_id: "12",
        },
        {
          id: "879",
          name: "Dungar",
          state_id: "12",
        },
        {
          id: "880",
          name: "Dungarpur",
          state_id: "12",
        },
        {
          id: "881",
          name: "Dungra",
          state_id: "12",
        },
        {
          id: "882",
          name: "Dwarka",
          state_id: "12",
        },
        {
          id: "883",
          name: "Flelanganj",
          state_id: "12",
        },
        {
          id: "884",
          name: "GSFC Complex",
          state_id: "12",
        },
        {
          id: "885",
          name: "Gadhda",
          state_id: "12",
        },
        {
          id: "886",
          name: "Gandevi",
          state_id: "12",
        },
        {
          id: "887",
          name: "Gandhidham",
          state_id: "12",
        },
        {
          id: "888",
          name: "Gandhinagar",
          state_id: "12",
        },
        {
          id: "889",
          name: "Gariadhar",
          state_id: "12",
        },
        {
          id: "890",
          name: "Ghogha",
          state_id: "12",
        },
        {
          id: "891",
          name: "Godhra",
          state_id: "12",
        },
        {
          id: "892",
          name: "Gondal",
          state_id: "12",
        },
        {
          id: "893",
          name: "Hajira INA",
          state_id: "12",
        },
        {
          id: "894",
          name: "Halol",
          state_id: "12",
        },
        {
          id: "895",
          name: "Halvad",
          state_id: "12",
        },
        {
          id: "896",
          name: "Hansot",
          state_id: "12",
        },
        {
          id: "897",
          name: "Harij",
          state_id: "12",
        },
        {
          id: "898",
          name: "Himatnagar",
          state_id: "12",
        },
        {
          id: "899",
          name: "Ichchhapor",
          state_id: "12",
        },
        {
          id: "900",
          name: "Idar",
          state_id: "12",
        },
        {
          id: "901",
          name: "Jafrabad",
          state_id: "12",
        },
        {
          id: "902",
          name: "Jalalpore",
          state_id: "12",
        },
        {
          id: "903",
          name: "Jambusar",
          state_id: "12",
        },
        {
          id: "904",
          name: "Jamjodhpur",
          state_id: "12",
        },
        {
          id: "905",
          name: "Jamnagar",
          state_id: "12",
        },
        {
          id: "906",
          name: "Jasdan",
          state_id: "12",
        },
        {
          id: "907",
          name: "Jawaharnagar",
          state_id: "12",
        },
        {
          id: "908",
          name: "Jetalsar",
          state_id: "12",
        },
        {
          id: "909",
          name: "Jetpur",
          state_id: "12",
        },
        {
          id: "910",
          name: "Jodiya",
          state_id: "12",
        },
        {
          id: "911",
          name: "Joshipura",
          state_id: "12",
        },
        {
          id: "912",
          name: "Junagadh",
          state_id: "12",
        },
        {
          id: "913",
          name: "Kadi",
          state_id: "12",
        },
        {
          id: "914",
          name: "Kadodara",
          state_id: "12",
        },
        {
          id: "915",
          name: "Kalavad",
          state_id: "12",
        },
        {
          id: "916",
          name: "Kali",
          state_id: "12",
        },
        {
          id: "917",
          name: "Kaliawadi",
          state_id: "12",
        },
        {
          id: "918",
          name: "Kalol",
          state_id: "12",
        },
        {
          id: "919",
          name: "Kalol INA",
          state_id: "12",
        },
        {
          id: "920",
          name: "Kandla",
          state_id: "12",
        },
        {
          id: "921",
          name: "Kanjari",
          state_id: "12",
        },
        {
          id: "922",
          name: "Kanodar",
          state_id: "12",
        },
        {
          id: "923",
          name: "Kapadwanj",
          state_id: "12",
        },
        {
          id: "924",
          name: "Karachiya",
          state_id: "12",
        },
        {
          id: "925",
          name: "Karamsad",
          state_id: "12",
        },
        {
          id: "926",
          name: "Karjan",
          state_id: "12",
        },
        {
          id: "927",
          name: "Kathial",
          state_id: "12",
        },
        {
          id: "928",
          name: "Kathor",
          state_id: "12",
        },
        {
          id: "929",
          name: "Katpar",
          state_id: "12",
        },
        {
          id: "930",
          name: "Kavant",
          state_id: "12",
        },
        {
          id: "931",
          name: "Keshod",
          state_id: "12",
        },
        {
          id: "932",
          name: "Kevadiya",
          state_id: "12",
        },
        {
          id: "933",
          name: "Khambhaliya",
          state_id: "12",
        },
        {
          id: "934",
          name: "Khambhat",
          state_id: "12",
        },
        {
          id: "935",
          name: "Kharaghoda",
          state_id: "12",
        },
        {
          id: "936",
          name: "Khed Brahma",
          state_id: "12",
        },
        {
          id: "937",
          name: "Kheda",
          state_id: "12",
        },
        {
          id: "938",
          name: "Kheralu",
          state_id: "12",
        },
        {
          id: "939",
          name: "Kodinar",
          state_id: "12",
        },
        {
          id: "940",
          name: "Kosamba",
          state_id: "12",
        },
        {
          id: "941",
          name: "Kundla",
          state_id: "12",
        },
        {
          id: "942",
          name: "Kutch",
          state_id: "12",
        },
        {
          id: "943",
          name: "Kutiyana",
          state_id: "12",
        },
        {
          id: "944",
          name: "Lakhtar",
          state_id: "12",
        },
        {
          id: "945",
          name: "Lalpur",
          state_id: "12",
        },
        {
          id: "946",
          name: "Lambha",
          state_id: "12",
        },
        {
          id: "947",
          name: "Lathi",
          state_id: "12",
        },
        {
          id: "948",
          name: "Limbdi",
          state_id: "12",
        },
        {
          id: "949",
          name: "Limla",
          state_id: "12",
        },
        {
          id: "950",
          name: "Lunavada",
          state_id: "12",
        },
        {
          id: "951",
          name: "Madhapar",
          state_id: "12",
        },
        {
          id: "952",
          name: "Maflipur",
          state_id: "12",
        },
        {
          id: "953",
          name: "Mahemdavad",
          state_id: "12",
        },
        {
          id: "954",
          name: "Mahudha",
          state_id: "12",
        },
        {
          id: "955",
          name: "Mahuva",
          state_id: "12",
        },
        {
          id: "956",
          name: "Mahuvar",
          state_id: "12",
        },
        {
          id: "957",
          name: "Makarba",
          state_id: "12",
        },
        {
          id: "958",
          name: "Makarpura",
          state_id: "12",
        },
        {
          id: "959",
          name: "Makassar",
          state_id: "12",
        },
        {
          id: "960",
          name: "Maktampur",
          state_id: "12",
        },
        {
          id: "961",
          name: "Malia",
          state_id: "12",
        },
        {
          id: "962",
          name: "Malpur",
          state_id: "12",
        },
        {
          id: "963",
          name: "Manavadar",
          state_id: "12",
        },
        {
          id: "964",
          name: "Mandal",
          state_id: "12",
        },
        {
          id: "965",
          name: "Mandvi",
          state_id: "12",
        },
        {
          id: "966",
          name: "Mangrol",
          state_id: "12",
        },
        {
          id: "967",
          name: "Mansa",
          state_id: "12",
        },
        {
          id: "968",
          name: "Meghraj",
          state_id: "12",
        },
        {
          id: "969",
          name: "Mehsana",
          state_id: "12",
        },
        {
          id: "970",
          name: "Mendarla",
          state_id: "12",
        },
        {
          id: "971",
          name: "Mithapur",
          state_id: "12",
        },
        {
          id: "972",
          name: "Modasa",
          state_id: "12",
        },
        {
          id: "973",
          name: "Mogravadi",
          state_id: "12",
        },
        {
          id: "974",
          name: "Morbi",
          state_id: "12",
        },
        {
          id: "975",
          name: "Morvi",
          state_id: "12",
        },
        {
          id: "976",
          name: "Mundra",
          state_id: "12",
        },
        {
          id: "977",
          name: "Nadiad",
          state_id: "12",
        },
        {
          id: "978",
          name: "Naliya",
          state_id: "12",
        },
        {
          id: "979",
          name: "Nanakvada",
          state_id: "12",
        },
        {
          id: "980",
          name: "Nandej",
          state_id: "12",
        },
        {
          id: "981",
          name: "Nandesari",
          state_id: "12",
        },
        {
          id: "982",
          name: "Nandesari INA",
          state_id: "12",
        },
        {
          id: "983",
          name: "Naroda",
          state_id: "12",
        },
        {
          id: "984",
          name: "Navagadh",
          state_id: "12",
        },
        {
          id: "985",
          name: "Navagam Ghed",
          state_id: "12",
        },
        {
          id: "986",
          name: "Navsari",
          state_id: "12",
        },
        {
          id: "987",
          name: "Ode",
          state_id: "12",
        },
        {
          id: "988",
          name: "Okaf",
          state_id: "12",
        },
        {
          id: "989",
          name: "Okha",
          state_id: "12",
        },
        {
          id: "990",
          name: "Olpad",
          state_id: "12",
        },
        {
          id: "991",
          name: "Paddhari",
          state_id: "12",
        },
        {
          id: "992",
          name: "Padra",
          state_id: "12",
        },
        {
          id: "993",
          name: "Palanpur",
          state_id: "12",
        },
        {
          id: "994",
          name: "Palej",
          state_id: "12",
        },
        {
          id: "995",
          name: "Pali",
          state_id: "12",
        },
        {
          id: "996",
          name: "Palitana",
          state_id: "12",
        },
        {
          id: "997",
          name: "Paliyad",
          state_id: "12",
        },
        {
          id: "998",
          name: "Pandesara",
          state_id: "12",
        },
        {
          id: "999",
          name: "Panoli",
          state_id: "12",
        },
        {
          id: "1000",
          name: "Pardi",
          state_id: "12",
        },
        {
          id: "1001",
          name: "Parnera",
          state_id: "12",
        },
        {
          id: "1002",
          name: "Parvat",
          state_id: "12",
        },
        {
          id: "1003",
          name: "Patan",
          state_id: "12",
        },
        {
          id: "1004",
          name: "Patdi",
          state_id: "12",
        },
        {
          id: "1005",
          name: "Petlad",
          state_id: "12",
        },
        {
          id: "1006",
          name: "Petrochemical Complex",
          state_id: "12",
        },
        {
          id: "1007",
          name: "Porbandar",
          state_id: "12",
        },
        {
          id: "1008",
          name: "Prantij",
          state_id: "12",
        },
        {
          id: "1009",
          name: "Radhanpur",
          state_id: "12",
        },
        {
          id: "1010",
          name: "Raiya",
          state_id: "12",
        },
        {
          id: "1011",
          name: "Rajkot",
          state_id: "12",
        },
        {
          id: "1012",
          name: "Rajpipla",
          state_id: "12",
        },
        {
          id: "1013",
          name: "Rajula",
          state_id: "12",
        },
        {
          id: "1014",
          name: "Ramod",
          state_id: "12",
        },
        {
          id: "1015",
          name: "Ranavav",
          state_id: "12",
        },
        {
          id: "1016",
          name: "Ranoli",
          state_id: "12",
        },
        {
          id: "1017",
          name: "Rapar",
          state_id: "12",
        },
        {
          id: "1018",
          name: "Sahij",
          state_id: "12",
        },
        {
          id: "1019",
          name: "Salaya",
          state_id: "12",
        },
        {
          id: "1020",
          name: "Sanand",
          state_id: "12",
        },
        {
          id: "1021",
          name: "Sankheda",
          state_id: "12",
        },
        {
          id: "1022",
          name: "Santrampur",
          state_id: "12",
        },
        {
          id: "1023",
          name: "Saribujrang",
          state_id: "12",
        },
        {
          id: "1024",
          name: "Sarigam INA",
          state_id: "12",
        },
        {
          id: "1025",
          name: "Sayan",
          state_id: "12",
        },
        {
          id: "1026",
          name: "Sayla",
          state_id: "12",
        },
        {
          id: "1027",
          name: "Shahpur",
          state_id: "12",
        },
        {
          id: "1028",
          name: "Shahwadi",
          state_id: "12",
        },
        {
          id: "1029",
          name: "Shapar",
          state_id: "12",
        },
        {
          id: "1030",
          name: "Shivrajpur",
          state_id: "12",
        },
        {
          id: "1031",
          name: "Siddhapur",
          state_id: "12",
        },
        {
          id: "1032",
          name: "Sidhpur",
          state_id: "12",
        },
        {
          id: "1033",
          name: "Sihor",
          state_id: "12",
        },
        {
          id: "1034",
          name: "Sika",
          state_id: "12",
        },
        {
          id: "1035",
          name: "Singarva",
          state_id: "12",
        },
        {
          id: "1036",
          name: "Sinor",
          state_id: "12",
        },
        {
          id: "1037",
          name: "Sojitra",
          state_id: "12",
        },
        {
          id: "1038",
          name: "Sola",
          state_id: "12",
        },
        {
          id: "1039",
          name: "Songadh",
          state_id: "12",
        },
        {
          id: "1040",
          name: "Suraj Karadi",
          state_id: "12",
        },
        {
          id: "1041",
          name: "Surat",
          state_id: "12",
        },
        {
          id: "1042",
          name: "Surendranagar",
          state_id: "12",
        },
        {
          id: "1043",
          name: "Talaja",
          state_id: "12",
        },
        {
          id: "1044",
          name: "Talala",
          state_id: "12",
        },
        {
          id: "1045",
          name: "Talod",
          state_id: "12",
        },
        {
          id: "1046",
          name: "Tankara",
          state_id: "12",
        },
        {
          id: "1047",
          name: "Tarsali",
          state_id: "12",
        },
        {
          id: "1048",
          name: "Thangadh",
          state_id: "12",
        },
        {
          id: "1049",
          name: "Tharad",
          state_id: "12",
        },
        {
          id: "1050",
          name: "Thasra",
          state_id: "12",
        },
        {
          id: "1051",
          name: "Udyognagar",
          state_id: "12",
        },
        {
          id: "1052",
          name: "Ukai",
          state_id: "12",
        },
        {
          id: "1053",
          name: "Umbergaon",
          state_id: "12",
        },
        {
          id: "1054",
          name: "Umbergaon INA",
          state_id: "12",
        },
        {
          id: "1055",
          name: "Umrala",
          state_id: "12",
        },
        {
          id: "1056",
          name: "Umreth",
          state_id: "12",
        },
        {
          id: "1057",
          name: "Un",
          state_id: "12",
        },
        {
          id: "1058",
          name: "Una",
          state_id: "12",
        },
        {
          id: "1059",
          name: "Unjha",
          state_id: "12",
        },
        {
          id: "1060",
          name: "Upleta",
          state_id: "12",
        },
        {
          id: "1061",
          name: "Utran",
          state_id: "12",
        },
        {
          id: "1062",
          name: "Uttarsanda",
          state_id: "12",
        },
        {
          id: "1063",
          name: "V.U. Nagar",
          state_id: "12",
        },
        {
          id: "1064",
          name: "V.V. Nagar",
          state_id: "12",
        },
        {
          id: "1065",
          name: "Vadia",
          state_id: "12",
        },
        {
          id: "1066",
          name: "Vadla",
          state_id: "12",
        },
        {
          id: "1067",
          name: "Vadnagar",
          state_id: "12",
        },
        {
          id: "1068",
          name: "Vadodara",
          state_id: "12",
        },
        {
          id: "1069",
          name: "Vaghodia INA",
          state_id: "12",
        },
        {
          id: "1070",
          name: "Valbhipur",
          state_id: "12",
        },
        {
          id: "1071",
          name: "Vallabh Vidyanagar",
          state_id: "12",
        },
        {
          id: "1072",
          name: "Valsad",
          state_id: "12",
        },
        {
          id: "1073",
          name: "Valsad INA",
          state_id: "12",
        },
        {
          id: "1074",
          name: "Vanthali",
          state_id: "12",
        },
        {
          id: "1075",
          name: "Vapi",
          state_id: "12",
        },
        {
          id: "1076",
          name: "Vapi INA",
          state_id: "12",
        },
        {
          id: "1077",
          name: "Vartej",
          state_id: "12",
        },
        {
          id: "1078",
          name: "Vasad",
          state_id: "12",
        },
        {
          id: "1079",
          name: "Vasna Borsad INA",
          state_id: "12",
        },
        {
          id: "1080",
          name: "Vaso",
          state_id: "12",
        },
        {
          id: "1081",
          name: "Veraval",
          state_id: "12",
        },
        {
          id: "1082",
          name: "Vidyanagar",
          state_id: "12",
        },
        {
          id: "1083",
          name: "Vijalpor",
          state_id: "12",
        },
        {
          id: "1084",
          name: "Vijapur",
          state_id: "12",
        },
        {
          id: "1085",
          name: "Vinchhiya",
          state_id: "12",
        },
        {
          id: "1086",
          name: "Vinzol",
          state_id: "12",
        },
        {
          id: "1087",
          name: "Virpur",
          state_id: "12",
        },
        {
          id: "1088",
          name: "Visavadar",
          state_id: "12",
        },
        {
          id: "1089",
          name: "Visnagar",
          state_id: "12",
        },
        {
          id: "1090",
          name: "Vyara",
          state_id: "12",
        },
        {
          id: "1091",
          name: "Wadhwan",
          state_id: "12",
        },
        {
          id: "1092",
          name: "Waghai",
          state_id: "12",
        },
        {
          id: "1093",
          name: "Waghodia",
          state_id: "12",
        },
        {
          id: "1094",
          name: "Wankaner",
          state_id: "12",
        },
        {
          id: "1095",
          name: "Zalod",
          state_id: "12",
        },
      ],
      Haryana: [
        {
          id: "1096",
          name: "Ambala",
          state_id: "13",
        },
        {
          id: "1097",
          name: "Ambala Cantt",
          state_id: "13",
        },
        {
          id: "1098",
          name: "Asan Khurd",
          state_id: "13",
        },
        {
          id: "1099",
          name: "Asandh",
          state_id: "13",
        },
        {
          id: "1100",
          name: "Ateli",
          state_id: "13",
        },
        {
          id: "1101",
          name: "Babiyal",
          state_id: "13",
        },
        {
          id: "1102",
          name: "Bahadurgarh",
          state_id: "13",
        },
        {
          id: "1103",
          name: "Ballabgarh",
          state_id: "13",
        },
        {
          id: "1104",
          name: "Barwala",
          state_id: "13",
        },
        {
          id: "1105",
          name: "Bawal",
          state_id: "13",
        },
        {
          id: "1106",
          name: "Bawani Khera",
          state_id: "13",
        },
        {
          id: "1107",
          name: "Beri",
          state_id: "13",
        },
        {
          id: "1108",
          name: "Bhiwani",
          state_id: "13",
        },
        {
          id: "1109",
          name: "Bilaspur",
          state_id: "13",
        },
        {
          id: "1110",
          name: "Buria",
          state_id: "13",
        },
        {
          id: "1111",
          name: "Charkhi Dadri",
          state_id: "13",
        },
        {
          id: "1112",
          name: "Chhachhrauli",
          state_id: "13",
        },
        {
          id: "1113",
          name: "Chita",
          state_id: "13",
        },
        {
          id: "1114",
          name: "Dabwali",
          state_id: "13",
        },
        {
          id: "1115",
          name: "Dharuhera",
          state_id: "13",
        },
        {
          id: "1116",
          name: "Dundahera",
          state_id: "13",
        },
        {
          id: "1117",
          name: "Ellenabad",
          state_id: "13",
        },
        {
          id: "1118",
          name: "Farakhpur",
          state_id: "13",
        },
        {
          id: "1119",
          name: "Faridabad",
          state_id: "13",
        },
        {
          id: "1120",
          name: "Farrukhnagar",
          state_id: "13",
        },
        {
          id: "1121",
          name: "Fatehabad",
          state_id: "13",
        },
        {
          id: "1122",
          name: "Firozpur Jhirka",
          state_id: "13",
        },
        {
          id: "1123",
          name: "Gannaur",
          state_id: "13",
        },
        {
          id: "1124",
          name: "Ghraunda",
          state_id: "13",
        },
        {
          id: "1125",
          name: "Gohana",
          state_id: "13",
        },
        {
          id: "1126",
          name: "Gurgaon",
          state_id: "13",
        },
        {
          id: "1127",
          name: "Haileymandi",
          state_id: "13",
        },
        {
          id: "1128",
          name: "Hansi",
          state_id: "13",
        },
        {
          id: "1129",
          name: "Hasanpur",
          state_id: "13",
        },
        {
          id: "1130",
          name: "Hathin",
          state_id: "13",
        },
        {
          id: "1131",
          name: "Hisar",
          state_id: "13",
        },
        {
          id: "1132",
          name: "Hissar",
          state_id: "13",
        },
        {
          id: "1133",
          name: "Hodal",
          state_id: "13",
        },
        {
          id: "1134",
          name: "Indri",
          state_id: "13",
        },
        {
          id: "1135",
          name: "Jagadhri",
          state_id: "13",
        },
        {
          id: "1136",
          name: "Jakhal Mandi",
          state_id: "13",
        },
        {
          id: "1137",
          name: "Jhajjar",
          state_id: "13",
        },
        {
          id: "1138",
          name: "Jind",
          state_id: "13",
        },
        {
          id: "1139",
          name: "Julana",
          state_id: "13",
        },
        {
          id: "1140",
          name: "Kaithal",
          state_id: "13",
        },
        {
          id: "1141",
          name: "Kalanur",
          state_id: "13",
        },
        {
          id: "1142",
          name: "Kalanwali",
          state_id: "13",
        },
        {
          id: "1143",
          name: "Kalayat",
          state_id: "13",
        },
        {
          id: "1144",
          name: "Kalka",
          state_id: "13",
        },
        {
          id: "1145",
          name: "Kanina",
          state_id: "13",
        },
        {
          id: "1146",
          name: "Kansepur",
          state_id: "13",
        },
        {
          id: "1147",
          name: "Kardhan",
          state_id: "13",
        },
        {
          id: "1148",
          name: "Karnal",
          state_id: "13",
        },
        {
          id: "1149",
          name: "Kharkhoda",
          state_id: "13",
        },
        {
          id: "1150",
          name: "Kheri Sampla",
          state_id: "13",
        },
        {
          id: "1151",
          name: "Kundli",
          state_id: "13",
        },
        {
          id: "1152",
          name: "Kurukshetra",
          state_id: "13",
        },
        {
          id: "1153",
          name: "Ladrawan",
          state_id: "13",
        },
        {
          id: "1154",
          name: "Ladwa",
          state_id: "13",
        },
        {
          id: "1155",
          name: "Loharu",
          state_id: "13",
        },
        {
          id: "1156",
          name: "Maham",
          state_id: "13",
        },
        {
          id: "1157",
          name: "Mahendragarh",
          state_id: "13",
        },
        {
          id: "1158",
          name: "Mustafabad",
          state_id: "13",
        },
        {
          id: "1159",
          name: "Nagai Chaudhry",
          state_id: "13",
        },
        {
          id: "1160",
          name: "Narayangarh",
          state_id: "13",
        },
        {
          id: "1161",
          name: "Narnaul",
          state_id: "13",
        },
        {
          id: "1162",
          name: "Narnaund",
          state_id: "13",
        },
        {
          id: "1163",
          name: "Narwana",
          state_id: "13",
        },
        {
          id: "1164",
          name: "Nilokheri",
          state_id: "13",
        },
        {
          id: "1165",
          name: "Nuh",
          state_id: "13",
        },
        {
          id: "1166",
          name: "Palwal",
          state_id: "13",
        },
        {
          id: "1167",
          name: "Panchkula",
          state_id: "13",
        },
        {
          id: "1168",
          name: "Panipat",
          state_id: "13",
        },
        {
          id: "1169",
          name: "Panipat Taraf Ansar",
          state_id: "13",
        },
        {
          id: "1170",
          name: "Panipat Taraf Makhdum Zadgan",
          state_id: "13",
        },
        {
          id: "1171",
          name: "Panipat Taraf Rajputan",
          state_id: "13",
        },
        {
          id: "1172",
          name: "Pehowa",
          state_id: "13",
        },
        {
          id: "1173",
          name: "Pinjaur",
          state_id: "13",
        },
        {
          id: "1174",
          name: "Punahana",
          state_id: "13",
        },
        {
          id: "1175",
          name: "Pundri",
          state_id: "13",
        },
        {
          id: "1176",
          name: "Radaur",
          state_id: "13",
        },
        {
          id: "1177",
          name: "Raipur Rani",
          state_id: "13",
        },
        {
          id: "1178",
          name: "Rania",
          state_id: "13",
        },
        {
          id: "1179",
          name: "Ratiya",
          state_id: "13",
        },
        {
          id: "1180",
          name: "Rewari",
          state_id: "13",
        },
        {
          id: "1181",
          name: "Rohtak",
          state_id: "13",
        },
        {
          id: "1182",
          name: "Ropar",
          state_id: "13",
        },
        {
          id: "1183",
          name: "Sadauri",
          state_id: "13",
        },
        {
          id: "1184",
          name: "Safidon",
          state_id: "13",
        },
        {
          id: "1185",
          name: "Samalkha",
          state_id: "13",
        },
        {
          id: "1186",
          name: "Sankhol",
          state_id: "13",
        },
        {
          id: "1187",
          name: "Sasauli",
          state_id: "13",
        },
        {
          id: "1188",
          name: "Shahabad",
          state_id: "13",
        },
        {
          id: "1189",
          name: "Sirsa",
          state_id: "13",
        },
        {
          id: "1190",
          name: "Siwani",
          state_id: "13",
        },
        {
          id: "1191",
          name: "Sohna",
          state_id: "13",
        },
        {
          id: "1192",
          name: "Sonipat",
          state_id: "13",
        },
        {
          id: "1193",
          name: "Sukhrali",
          state_id: "13",
        },
        {
          id: "1194",
          name: "Taoru",
          state_id: "13",
        },
        {
          id: "1195",
          name: "Taraori",
          state_id: "13",
        },
        {
          id: "1196",
          name: "Tauru",
          state_id: "13",
        },
        {
          id: "1197",
          name: "Thanesar",
          state_id: "13",
        },
        {
          id: "1198",
          name: "Tilpat",
          state_id: "13",
        },
        {
          id: "1199",
          name: "Tohana",
          state_id: "13",
        },
        {
          id: "1200",
          name: "Tosham",
          state_id: "13",
        },
        {
          id: "1201",
          name: "Uchana",
          state_id: "13",
        },
        {
          id: "1202",
          name: "Uklana Mandi",
          state_id: "13",
        },
        {
          id: "1203",
          name: "Uncha Siwana",
          state_id: "13",
        },
        {
          id: "1204",
          name: "Yamunanagar",
          state_id: "13",
        },
      ],
      "Himachal Pradesh": [
        {
          id: "1205",
          name: "Arki",
          state_id: "14",
        },
        {
          id: "1206",
          name: "Baddi",
          state_id: "14",
        },
        {
          id: "1207",
          name: "Bakloh",
          state_id: "14",
        },
        {
          id: "1208",
          name: "Banjar",
          state_id: "14",
        },
        {
          id: "1209",
          name: "Bhota",
          state_id: "14",
        },
        {
          id: "1210",
          name: "Bhuntar",
          state_id: "14",
        },
        {
          id: "1211",
          name: "Bilaspur",
          state_id: "14",
        },
        {
          id: "1212",
          name: "Chamba",
          state_id: "14",
        },
        {
          id: "1213",
          name: "Chaupal",
          state_id: "14",
        },
        {
          id: "1214",
          name: "Chuari Khas",
          state_id: "14",
        },
        {
          id: "1215",
          name: "Dagshai",
          state_id: "14",
        },
        {
          id: "1216",
          name: "Dalhousie",
          state_id: "14",
        },
        {
          id: "1217",
          name: "Dalhousie Cantonment",
          state_id: "14",
        },
        {
          id: "1218",
          name: "Damtal",
          state_id: "14",
        },
        {
          id: "1219",
          name: "Daulatpur",
          state_id: "14",
        },
        {
          id: "1220",
          name: "Dera Gopipur",
          state_id: "14",
        },
        {
          id: "1221",
          name: "Dhalli",
          state_id: "14",
        },
        {
          id: "1222",
          name: "Dharamshala",
          state_id: "14",
        },
        {
          id: "1223",
          name: "Gagret",
          state_id: "14",
        },
        {
          id: "1224",
          name: "Ghamarwin",
          state_id: "14",
        },
        {
          id: "1225",
          name: "Hamirpur",
          state_id: "14",
        },
        {
          id: "1226",
          name: "Jawala Mukhi",
          state_id: "14",
        },
        {
          id: "1227",
          name: "Jogindarnagar",
          state_id: "14",
        },
        {
          id: "1228",
          name: "Jubbal",
          state_id: "14",
        },
        {
          id: "1229",
          name: "Jutogh",
          state_id: "14",
        },
        {
          id: "1230",
          name: "Kala Amb",
          state_id: "14",
        },
        {
          id: "1231",
          name: "Kalpa",
          state_id: "14",
        },
        {
          id: "1232",
          name: "Kangra",
          state_id: "14",
        },
        {
          id: "1233",
          name: "Kasauli",
          state_id: "14",
        },
        {
          id: "1234",
          name: "Kot Khai",
          state_id: "14",
        },
        {
          id: "1235",
          name: "Kullu",
          state_id: "14",
        },
        {
          id: "1236",
          name: "Kulu",
          state_id: "14",
        },
        {
          id: "1237",
          name: "Manali",
          state_id: "14",
        },
        {
          id: "1238",
          name: "Mandi",
          state_id: "14",
        },
        {
          id: "1239",
          name: "Mant Khas",
          state_id: "14",
        },
        {
          id: "1240",
          name: "Mehatpur Basdehra",
          state_id: "14",
        },
        {
          id: "1241",
          name: "Nadaun",
          state_id: "14",
        },
        {
          id: "1242",
          name: "Nagrota",
          state_id: "14",
        },
        {
          id: "1243",
          name: "Nahan",
          state_id: "14",
        },
        {
          id: "1244",
          name: "Naina Devi",
          state_id: "14",
        },
        {
          id: "1245",
          name: "Nalagarh",
          state_id: "14",
        },
        {
          id: "1246",
          name: "Narkanda",
          state_id: "14",
        },
        {
          id: "1247",
          name: "Nurpur",
          state_id: "14",
        },
        {
          id: "1248",
          name: "Palampur",
          state_id: "14",
        },
        {
          id: "1249",
          name: "Pandoh",
          state_id: "14",
        },
        {
          id: "1250",
          name: "Paonta Sahib",
          state_id: "14",
        },
        {
          id: "1251",
          name: "Parwanoo",
          state_id: "14",
        },
        {
          id: "1252",
          name: "Parwanu",
          state_id: "14",
        },
        {
          id: "1253",
          name: "Rajgarh",
          state_id: "14",
        },
        {
          id: "1254",
          name: "Rampur",
          state_id: "14",
        },
        {
          id: "1255",
          name: "Rawalsar",
          state_id: "14",
        },
        {
          id: "1256",
          name: "Rohru",
          state_id: "14",
        },
        {
          id: "1257",
          name: "Sabathu",
          state_id: "14",
        },
        {
          id: "1258",
          name: "Santokhgarh",
          state_id: "14",
        },
        {
          id: "1259",
          name: "Sarahan",
          state_id: "14",
        },
        {
          id: "1260",
          name: "Sarka Ghat",
          state_id: "14",
        },
        {
          id: "1261",
          name: "Seoni",
          state_id: "14",
        },
        {
          id: "1262",
          name: "Shimla",
          state_id: "14",
        },
        {
          id: "1263",
          name: "Sirmaur",
          state_id: "14",
        },
        {
          id: "1264",
          name: "Solan",
          state_id: "14",
        },
        {
          id: "1265",
          name: "Solon",
          state_id: "14",
        },
        {
          id: "1266",
          name: "Sundarnagar",
          state_id: "14",
        },
        {
          id: "1267",
          name: "Sundernagar",
          state_id: "14",
        },
        {
          id: "1268",
          name: "Talai",
          state_id: "14",
        },
        {
          id: "1269",
          name: "Theog",
          state_id: "14",
        },
        {
          id: "1270",
          name: "Tira Sujanpur",
          state_id: "14",
        },
        {
          id: "1271",
          name: "Una",
          state_id: "14",
        },
        {
          id: "1272",
          name: "Yol",
          state_id: "14",
        },
      ],
      "Jammu and Kashmir": [
        {
          id: "1273",
          name: "Achabal",
          state_id: "15",
        },
        {
          id: "1274",
          name: "Akhnur",
          state_id: "15",
        },
        {
          id: "1275",
          name: "Anantnag",
          state_id: "15",
        },
        {
          id: "1276",
          name: "Arnia",
          state_id: "15",
        },
        {
          id: "1277",
          name: "Awantipora",
          state_id: "15",
        },
        {
          id: "1278",
          name: "Badami Bagh",
          state_id: "15",
        },
        {
          id: "1279",
          name: "Bandipur",
          state_id: "15",
        },
        {
          id: "1280",
          name: "Banihal",
          state_id: "15",
        },
        {
          id: "1281",
          name: "Baramula",
          state_id: "15",
        },
        {
          id: "1282",
          name: "Baramulla",
          state_id: "15",
        },
        {
          id: "1283",
          name: "Bari Brahmana",
          state_id: "15",
        },
        {
          id: "1284",
          name: "Bashohli",
          state_id: "15",
        },
        {
          id: "1285",
          name: "Batote",
          state_id: "15",
        },
        {
          id: "1286",
          name: "Bhaderwah",
          state_id: "15",
        },
        {
          id: "1287",
          name: "Bijbiara",
          state_id: "15",
        },
        {
          id: "1288",
          name: "Billawar",
          state_id: "15",
        },
        {
          id: "1289",
          name: "Birwah",
          state_id: "15",
        },
        {
          id: "1290",
          name: "Bishna",
          state_id: "15",
        },
        {
          id: "1291",
          name: "Budgam",
          state_id: "15",
        },
        {
          id: "1292",
          name: "Charari Sharief",
          state_id: "15",
        },
        {
          id: "1293",
          name: "Chenani",
          state_id: "15",
        },
        {
          id: "1294",
          name: "Doda",
          state_id: "15",
        },
        {
          id: "1295",
          name: "Duru-Verinag",
          state_id: "15",
        },
        {
          id: "1296",
          name: "Gandarbat",
          state_id: "15",
        },
        {
          id: "1297",
          name: "Gho Manhasan",
          state_id: "15",
        },
        {
          id: "1298",
          name: "Gorah Salathian",
          state_id: "15",
        },
        {
          id: "1299",
          name: "Gulmarg",
          state_id: "15",
        },
        {
          id: "1300",
          name: "Hajan",
          state_id: "15",
        },
        {
          id: "1301",
          name: "Handwara",
          state_id: "15",
        },
        {
          id: "1302",
          name: "Hiranagar",
          state_id: "15",
        },
        {
          id: "1303",
          name: "Jammu",
          state_id: "15",
        },
        {
          id: "1304",
          name: "Jammu Cantonment",
          state_id: "15",
        },
        {
          id: "1305",
          name: "Jammu Tawi",
          state_id: "15",
        },
        {
          id: "1306",
          name: "Jourian",
          state_id: "15",
        },
        {
          id: "1307",
          name: "Kargil",
          state_id: "15",
        },
        {
          id: "1308",
          name: "Kathua",
          state_id: "15",
        },
        {
          id: "1309",
          name: "Katra",
          state_id: "15",
        },
        {
          id: "1310",
          name: "Khan Sahib",
          state_id: "15",
        },
        {
          id: "1311",
          name: "Khour",
          state_id: "15",
        },
        {
          id: "1312",
          name: "Khrew",
          state_id: "15",
        },
        {
          id: "1313",
          name: "Kishtwar",
          state_id: "15",
        },
        {
          id: "1314",
          name: "Kud",
          state_id: "15",
        },
        {
          id: "1315",
          name: "Kukernag",
          state_id: "15",
        },
        {
          id: "1316",
          name: "Kulgam",
          state_id: "15",
        },
        {
          id: "1317",
          name: "Kunzer",
          state_id: "15",
        },
        {
          id: "1318",
          name: "Kupwara",
          state_id: "15",
        },
        {
          id: "1319",
          name: "Lakhenpur",
          state_id: "15",
        },
        {
          id: "1320",
          name: "Leh",
          state_id: "15",
        },
        {
          id: "1321",
          name: "Magam",
          state_id: "15",
        },
        {
          id: "1322",
          name: "Mattan",
          state_id: "15",
        },
        {
          id: "1323",
          name: "Naushehra",
          state_id: "15",
        },
        {
          id: "1324",
          name: "Pahalgam",
          state_id: "15",
        },
        {
          id: "1325",
          name: "Pampore",
          state_id: "15",
        },
        {
          id: "1326",
          name: "Parole",
          state_id: "15",
        },
        {
          id: "1327",
          name: "Pattan",
          state_id: "15",
        },
        {
          id: "1328",
          name: "Pulwama",
          state_id: "15",
        },
        {
          id: "1329",
          name: "Punch",
          state_id: "15",
        },
        {
          id: "1330",
          name: "Qazigund",
          state_id: "15",
        },
        {
          id: "1331",
          name: "Rajauri",
          state_id: "15",
        },
        {
          id: "1332",
          name: "Ramban",
          state_id: "15",
        },
        {
          id: "1333",
          name: "Ramgarh",
          state_id: "15",
        },
        {
          id: "1334",
          name: "Ramnagar",
          state_id: "15",
        },
        {
          id: "1335",
          name: "Ranbirsingh Pora",
          state_id: "15",
        },
        {
          id: "1336",
          name: "Reasi",
          state_id: "15",
        },
        {
          id: "1337",
          name: "Rehambal",
          state_id: "15",
        },
        {
          id: "1338",
          name: "Samba",
          state_id: "15",
        },
        {
          id: "1339",
          name: "Shupiyan",
          state_id: "15",
        },
        {
          id: "1340",
          name: "Sopur",
          state_id: "15",
        },
        {
          id: "1341",
          name: "Srinagar",
          state_id: "15",
        },
        {
          id: "1342",
          name: "Sumbal",
          state_id: "15",
        },
        {
          id: "1343",
          name: "Sunderbani",
          state_id: "15",
        },
        {
          id: "1344",
          name: "Talwara",
          state_id: "15",
        },
        {
          id: "1345",
          name: "Thanamandi",
          state_id: "15",
        },
        {
          id: "1346",
          name: "Tral",
          state_id: "15",
        },
        {
          id: "1347",
          name: "Udhampur",
          state_id: "15",
        },
        {
          id: "1348",
          name: "Uri",
          state_id: "15",
        },
        {
          id: "1349",
          name: "Vijaypur",
          state_id: "15",
        },
      ],
      Jharkhand: [
        {
          id: "1350",
          name: "Adityapur",
          state_id: "16",
        },
        {
          id: "1351",
          name: "Amlabad",
          state_id: "16",
        },
        {
          id: "1352",
          name: "Angarpathar",
          state_id: "16",
        },
        {
          id: "1353",
          name: "Ara",
          state_id: "16",
        },
        {
          id: "1354",
          name: "Babua Kalan",
          state_id: "16",
        },
        {
          id: "1355",
          name: "Bagbahra",
          state_id: "16",
        },
        {
          id: "1356",
          name: "Baliapur",
          state_id: "16",
        },
        {
          id: "1357",
          name: "Baliari",
          state_id: "16",
        },
        {
          id: "1358",
          name: "Balkundra",
          state_id: "16",
        },
        {
          id: "1359",
          name: "Bandhgora",
          state_id: "16",
        },
        {
          id: "1360",
          name: "Barajamda",
          state_id: "16",
        },
        {
          id: "1361",
          name: "Barhi",
          state_id: "16",
        },
        {
          id: "1362",
          name: "Barka Kana",
          state_id: "16",
        },
        {
          id: "1363",
          name: "Barki Saraiya",
          state_id: "16",
        },
        {
          id: "1364",
          name: "Barughutu",
          state_id: "16",
        },
        {
          id: "1365",
          name: "Barwadih",
          state_id: "16",
        },
        {
          id: "1366",
          name: "Basaria",
          state_id: "16",
        },
        {
          id: "1367",
          name: "Basukinath",
          state_id: "16",
        },
        {
          id: "1368",
          name: "Bermo",
          state_id: "16",
        },
        {
          id: "1369",
          name: "Bhagatdih",
          state_id: "16",
        },
        {
          id: "1370",
          name: "Bhaurah",
          state_id: "16",
        },
        {
          id: "1371",
          name: "Bhojudih",
          state_id: "16",
        },
        {
          id: "1372",
          name: "Bhuli",
          state_id: "16",
        },
        {
          id: "1373",
          name: "Bokaro",
          state_id: "16",
        },
        {
          id: "1374",
          name: "Borio Bazar",
          state_id: "16",
        },
        {
          id: "1375",
          name: "Bundu",
          state_id: "16",
        },
        {
          id: "1376",
          name: "Chaibasa",
          state_id: "16",
        },
        {
          id: "1377",
          name: "Chaitudih",
          state_id: "16",
        },
        {
          id: "1378",
          name: "Chakradharpur",
          state_id: "16",
        },
        {
          id: "1379",
          name: "Chakulia",
          state_id: "16",
        },
        {
          id: "1380",
          name: "Chandaur",
          state_id: "16",
        },
        {
          id: "1381",
          name: "Chandil",
          state_id: "16",
        },
        {
          id: "1382",
          name: "Chandrapura",
          state_id: "16",
        },
        {
          id: "1383",
          name: "Chas",
          state_id: "16",
        },
        {
          id: "1384",
          name: "Chatra",
          state_id: "16",
        },
        {
          id: "1385",
          name: "Chhatatanr",
          state_id: "16",
        },
        {
          id: "1386",
          name: "Chhotaputki",
          state_id: "16",
        },
        {
          id: "1387",
          name: "Chiria",
          state_id: "16",
        },
        {
          id: "1388",
          name: "Chirkunda",
          state_id: "16",
        },
        {
          id: "1389",
          name: "Churi",
          state_id: "16",
        },
        {
          id: "1390",
          name: "Daltenganj",
          state_id: "16",
        },
        {
          id: "1391",
          name: "Danguwapasi",
          state_id: "16",
        },
        {
          id: "1392",
          name: "Dari",
          state_id: "16",
        },
        {
          id: "1393",
          name: "Deoghar",
          state_id: "16",
        },
        {
          id: "1394",
          name: "Deorikalan",
          state_id: "16",
        },
        {
          id: "1395",
          name: "Devghar",
          state_id: "16",
        },
        {
          id: "1396",
          name: "Dhanbad",
          state_id: "16",
        },
        {
          id: "1397",
          name: "Dhanwar",
          state_id: "16",
        },
        {
          id: "1398",
          name: "Dhaunsar",
          state_id: "16",
        },
        {
          id: "1399",
          name: "Dugda",
          state_id: "16",
        },
        {
          id: "1400",
          name: "Dumarkunda",
          state_id: "16",
        },
        {
          id: "1401",
          name: "Dumka",
          state_id: "16",
        },
        {
          id: "1402",
          name: "Egarkunr",
          state_id: "16",
        },
        {
          id: "1403",
          name: "Gadhra",
          state_id: "16",
        },
        {
          id: "1404",
          name: "Garwa",
          state_id: "16",
        },
        {
          id: "1405",
          name: "Ghatsila",
          state_id: "16",
        },
        {
          id: "1406",
          name: "Ghorabandha",
          state_id: "16",
        },
        {
          id: "1407",
          name: "Gidi",
          state_id: "16",
        },
        {
          id: "1408",
          name: "Giridih",
          state_id: "16",
        },
        {
          id: "1409",
          name: "Gobindpur",
          state_id: "16",
        },
        {
          id: "1410",
          name: "Godda",
          state_id: "16",
        },
        {
          id: "1411",
          name: "Godhar",
          state_id: "16",
        },
        {
          id: "1412",
          name: "Golphalbari",
          state_id: "16",
        },
        {
          id: "1413",
          name: "Gomoh",
          state_id: "16",
        },
        {
          id: "1414",
          name: "Gua",
          state_id: "16",
        },
        {
          id: "1415",
          name: "Gumia",
          state_id: "16",
        },
        {
          id: "1416",
          name: "Gumla",
          state_id: "16",
        },
        {
          id: "1417",
          name: "Haludbani",
          state_id: "16",
        },
        {
          id: "1418",
          name: "Hazaribag",
          state_id: "16",
        },
        {
          id: "1419",
          name: "Hesla",
          state_id: "16",
        },
        {
          id: "1420",
          name: "Husainabad",
          state_id: "16",
        },
        {
          id: "1421",
          name: "Isri",
          state_id: "16",
        },
        {
          id: "1422",
          name: "Jadugora",
          state_id: "16",
        },
        {
          id: "1423",
          name: "Jagannathpur",
          state_id: "16",
        },
        {
          id: "1424",
          name: "Jamadoba",
          state_id: "16",
        },
        {
          id: "1425",
          name: "Jamshedpur",
          state_id: "16",
        },
        {
          id: "1426",
          name: "Jamtara",
          state_id: "16",
        },
        {
          id: "1427",
          name: "Jarangdih",
          state_id: "16",
        },
        {
          id: "1428",
          name: "Jaridih",
          state_id: "16",
        },
        {
          id: "1429",
          name: "Jasidih",
          state_id: "16",
        },
        {
          id: "1430",
          name: "Jena",
          state_id: "16",
        },
        {
          id: "1431",
          name: "Jharia",
          state_id: "16",
        },
        {
          id: "1432",
          name: "Jharia Khas",
          state_id: "16",
        },
        {
          id: "1433",
          name: "Jhinkpani",
          state_id: "16",
        },
        {
          id: "1434",
          name: "Jhumri Tilaiya",
          state_id: "16",
        },
        {
          id: "1435",
          name: "Jorapokhar",
          state_id: "16",
        },
        {
          id: "1436",
          name: "Jugsalai",
          state_id: "16",
        },
        {
          id: "1437",
          name: "Kailudih",
          state_id: "16",
        },
        {
          id: "1438",
          name: "Kalikapur",
          state_id: "16",
        },
        {
          id: "1439",
          name: "Kandra",
          state_id: "16",
        },
        {
          id: "1440",
          name: "Kanke",
          state_id: "16",
        },
        {
          id: "1441",
          name: "Katras",
          state_id: "16",
        },
        {
          id: "1442",
          name: "Kedla",
          state_id: "16",
        },
        {
          id: "1443",
          name: "Kenduadih",
          state_id: "16",
        },
        {
          id: "1444",
          name: "Kharkhari",
          state_id: "16",
        },
        {
          id: "1445",
          name: "Kharsawan",
          state_id: "16",
        },
        {
          id: "1446",
          name: "Khelari",
          state_id: "16",
        },
        {
          id: "1447",
          name: "Khunti",
          state_id: "16",
        },
        {
          id: "1448",
          name: "Kiri Buru",
          state_id: "16",
        },
        {
          id: "1449",
          name: "Kiriburu",
          state_id: "16",
        },
        {
          id: "1450",
          name: "Kodarma",
          state_id: "16",
        },
        {
          id: "1451",
          name: "Kuju",
          state_id: "16",
        },
        {
          id: "1452",
          name: "Kurpania",
          state_id: "16",
        },
        {
          id: "1453",
          name: "Kustai",
          state_id: "16",
        },
        {
          id: "1454",
          name: "Lakarka",
          state_id: "16",
        },
        {
          id: "1455",
          name: "Lapanga",
          state_id: "16",
        },
        {
          id: "1456",
          name: "Latehar",
          state_id: "16",
        },
        {
          id: "1457",
          name: "Lohardaga",
          state_id: "16",
        },
        {
          id: "1458",
          name: "Loiya",
          state_id: "16",
        },
        {
          id: "1459",
          name: "Loyabad",
          state_id: "16",
        },
        {
          id: "1460",
          name: "Madhupur",
          state_id: "16",
        },
        {
          id: "1461",
          name: "Mahesh Mundi",
          state_id: "16",
        },
        {
          id: "1462",
          name: "Maithon",
          state_id: "16",
        },
        {
          id: "1463",
          name: "Malkera",
          state_id: "16",
        },
        {
          id: "1464",
          name: "Mango",
          state_id: "16",
        },
        {
          id: "1465",
          name: "Manoharpur",
          state_id: "16",
        },
        {
          id: "1466",
          name: "Marma",
          state_id: "16",
        },
        {
          id: "1467",
          name: "Meghahatuburu Forest village",
          state_id: "16",
        },
        {
          id: "1468",
          name: "Mera",
          state_id: "16",
        },
        {
          id: "1469",
          name: "Meru",
          state_id: "16",
        },
        {
          id: "1470",
          name: "Mihijam",
          state_id: "16",
        },
        {
          id: "1471",
          name: "Mugma",
          state_id: "16",
        },
        {
          id: "1472",
          name: "Muri",
          state_id: "16",
        },
        {
          id: "1473",
          name: "Mushabani",
          state_id: "16",
        },
        {
          id: "1474",
          name: "Nagri Kalan",
          state_id: "16",
        },
        {
          id: "1475",
          name: "Netarhat",
          state_id: "16",
        },
        {
          id: "1476",
          name: "Nirsa",
          state_id: "16",
        },
        {
          id: "1477",
          name: "Noamundi",
          state_id: "16",
        },
        {
          id: "1478",
          name: "Okni",
          state_id: "16",
        },
        {
          id: "1479",
          name: "Orla",
          state_id: "16",
        },
        {
          id: "1480",
          name: "Pakaur",
          state_id: "16",
        },
        {
          id: "1481",
          name: "Palamau",
          state_id: "16",
        },
        {
          id: "1482",
          name: "Palawa",
          state_id: "16",
        },
        {
          id: "1483",
          name: "Panchet",
          state_id: "16",
        },
        {
          id: "1484",
          name: "Panrra",
          state_id: "16",
        },
        {
          id: "1485",
          name: "Paratdih",
          state_id: "16",
        },
        {
          id: "1486",
          name: "Pathardih",
          state_id: "16",
        },
        {
          id: "1487",
          name: "Patratu",
          state_id: "16",
        },
        {
          id: "1488",
          name: "Phusro",
          state_id: "16",
        },
        {
          id: "1489",
          name: "Pondar Kanali",
          state_id: "16",
        },
        {
          id: "1490",
          name: "Rajmahal",
          state_id: "16",
        },
        {
          id: "1491",
          name: "Ramgarh",
          state_id: "16",
        },
        {
          id: "1492",
          name: "Ranchi",
          state_id: "16",
        },
        {
          id: "1493",
          name: "Ray",
          state_id: "16",
        },
        {
          id: "1494",
          name: "Rehla",
          state_id: "16",
        },
        {
          id: "1495",
          name: "Religara",
          state_id: "16",
        },
        {
          id: "1496",
          name: "Rohraband",
          state_id: "16",
        },
        {
          id: "1497",
          name: "Sahibganj",
          state_id: "16",
        },
        {
          id: "1498",
          name: "Sahnidih",
          state_id: "16",
        },
        {
          id: "1499",
          name: "Saraidhela",
          state_id: "16",
        },
        {
          id: "1500",
          name: "Saraikela",
          state_id: "16",
        },
        {
          id: "1501",
          name: "Sarjamda",
          state_id: "16",
        },
        {
          id: "1502",
          name: "Saunda",
          state_id: "16",
        },
        {
          id: "1503",
          name: "Sewai",
          state_id: "16",
        },
        {
          id: "1504",
          name: "Sijhua",
          state_id: "16",
        },
        {
          id: "1505",
          name: "Sijua",
          state_id: "16",
        },
        {
          id: "1506",
          name: "Simdega",
          state_id: "16",
        },
        {
          id: "1507",
          name: "Sindari",
          state_id: "16",
        },
        {
          id: "1508",
          name: "Sinduria",
          state_id: "16",
        },
        {
          id: "1509",
          name: "Sini",
          state_id: "16",
        },
        {
          id: "1510",
          name: "Sirka",
          state_id: "16",
        },
        {
          id: "1511",
          name: "Siuliban",
          state_id: "16",
        },
        {
          id: "1512",
          name: "Surubera",
          state_id: "16",
        },
        {
          id: "1513",
          name: "Tati",
          state_id: "16",
        },
        {
          id: "1514",
          name: "Tenudam",
          state_id: "16",
        },
        {
          id: "1515",
          name: "Tisra",
          state_id: "16",
        },
        {
          id: "1516",
          name: "Topa",
          state_id: "16",
        },
        {
          id: "1517",
          name: "Topchanchi",
          state_id: "16",
        },
      ],
      Karnataka: [
        {
          id: "1518",
          name: "Adityanagar",
          state_id: "17",
        },
        {
          id: "1519",
          name: "Adityapatna",
          state_id: "17",
        },
        {
          id: "1520",
          name: "Afzalpur",
          state_id: "17",
        },
        {
          id: "1521",
          name: "Ajjampur",
          state_id: "17",
        },
        {
          id: "1522",
          name: "Aland",
          state_id: "17",
        },
        {
          id: "1523",
          name: "Almatti Sitimani",
          state_id: "17",
        },
        {
          id: "1524",
          name: "Alnavar",
          state_id: "17",
        },
        {
          id: "1525",
          name: "Alur",
          state_id: "17",
        },
        {
          id: "1526",
          name: "Ambikanagara",
          state_id: "17",
        },
        {
          id: "1527",
          name: "Anekal",
          state_id: "17",
        },
        {
          id: "1528",
          name: "Ankola",
          state_id: "17",
        },
        {
          id: "1529",
          name: "Annigeri",
          state_id: "17",
        },
        {
          id: "1530",
          name: "Arkalgud",
          state_id: "17",
        },
        {
          id: "1531",
          name: "Arsikere",
          state_id: "17",
        },
        {
          id: "1532",
          name: "Athni",
          state_id: "17",
        },
        {
          id: "1533",
          name: "Aurad",
          state_id: "17",
        },
        {
          id: "1534",
          name: "Badagavettu",
          state_id: "17",
        },
        {
          id: "1535",
          name: "Badami",
          state_id: "17",
        },
        {
          id: "1536",
          name: "Bagalkot",
          state_id: "17",
        },
        {
          id: "1537",
          name: "Bagepalli",
          state_id: "17",
        },
        {
          id: "1538",
          name: "Bailhongal",
          state_id: "17",
        },
        {
          id: "1539",
          name: "Baindur",
          state_id: "17",
        },
        {
          id: "1540",
          name: "Bajala",
          state_id: "17",
        },
        {
          id: "1541",
          name: "Bajpe",
          state_id: "17",
        },
        {
          id: "1542",
          name: "Banavar",
          state_id: "17",
        },
        {
          id: "1543",
          name: "Bangarapet",
          state_id: "17",
        },
        {
          id: "1544",
          name: "Bankapura",
          state_id: "17",
        },
        {
          id: "1545",
          name: "Bannur",
          state_id: "17",
        },
        {
          id: "1546",
          name: "Bantwal",
          state_id: "17",
        },
        {
          id: "1547",
          name: "Basavakalyan",
          state_id: "17",
        },
        {
          id: "1548",
          name: "Basavana Bagevadi",
          state_id: "17",
        },
        {
          id: "1549",
          name: "Belagula",
          state_id: "17",
        },
        {
          id: "1550",
          name: "Belakavadiq",
          state_id: "17",
        },
        {
          id: "1551",
          name: "Belgaum",
          state_id: "17",
        },
        {
          id: "1552",
          name: "Belgaum Cantonment",
          state_id: "17",
        },
        {
          id: "1553",
          name: "Bellary",
          state_id: "17",
        },
        {
          id: "1554",
          name: "Belluru",
          state_id: "17",
        },
        {
          id: "1555",
          name: "Beltangadi",
          state_id: "17",
        },
        {
          id: "1556",
          name: "Belur",
          state_id: "17",
        },
        {
          id: "1557",
          name: "Belvata",
          state_id: "17",
        },
        {
          id: "1558",
          name: "Bengaluru",
          state_id: "17",
        },
        {
          id: "1559",
          name: "Bhadravati",
          state_id: "17",
        },
        {
          id: "1560",
          name: "Bhalki",
          state_id: "17",
        },
        {
          id: "1561",
          name: "Bhatkal",
          state_id: "17",
        },
        {
          id: "1562",
          name: "Bhimarayanagudi",
          state_id: "17",
        },
        {
          id: "1563",
          name: "Bhogadi",
          state_id: "17",
        },
        {
          id: "1564",
          name: "Bidar",
          state_id: "17",
        },
        {
          id: "1565",
          name: "Bijapur",
          state_id: "17",
        },
        {
          id: "1566",
          name: "Bilgi",
          state_id: "17",
        },
        {
          id: "1567",
          name: "Birur",
          state_id: "17",
        },
        {
          id: "1568",
          name: "Bommanahalli",
          state_id: "17",
        },
        {
          id: "1569",
          name: "Bommasandra",
          state_id: "17",
        },
        {
          id: "1570",
          name: "Byadgi",
          state_id: "17",
        },
        {
          id: "1571",
          name: "Byatarayanapura",
          state_id: "17",
        },
        {
          id: "1572",
          name: "Chakranagar Colony",
          state_id: "17",
        },
        {
          id: "1573",
          name: "Challakere",
          state_id: "17",
        },
        {
          id: "1574",
          name: "Chamrajnagar",
          state_id: "17",
        },
        {
          id: "1575",
          name: "Chamundi Betta",
          state_id: "17",
        },
        {
          id: "1576",
          name: "Channagiri",
          state_id: "17",
        },
        {
          id: "1577",
          name: "Channapatna",
          state_id: "17",
        },
        {
          id: "1578",
          name: "Channarayapatna",
          state_id: "17",
        },
        {
          id: "1579",
          name: "Chickballapur",
          state_id: "17",
        },
        {
          id: "1580",
          name: "Chik Ballapur",
          state_id: "17",
        },
        {
          id: "1581",
          name: "Chikkaballapur",
          state_id: "17",
        },
        {
          id: "1582",
          name: "Chikmagalur",
          state_id: "17",
        },
        {
          id: "1583",
          name: "Chiknayakanhalli",
          state_id: "17",
        },
        {
          id: "1584",
          name: "Chikodi",
          state_id: "17",
        },
        {
          id: "1585",
          name: "Chincholi",
          state_id: "17",
        },
        {
          id: "1586",
          name: "Chintamani",
          state_id: "17",
        },
        {
          id: "1587",
          name: "Chitaguppa",
          state_id: "17",
        },
        {
          id: "1588",
          name: "Chitapur",
          state_id: "17",
        },
        {
          id: "1589",
          name: "Chitradurga",
          state_id: "17",
        },
        {
          id: "1590",
          name: "Coorg",
          state_id: "17",
        },
        {
          id: "1591",
          name: "Dandeli",
          state_id: "17",
        },
        {
          id: "1592",
          name: "Dargajogihalli",
          state_id: "17",
        },
        {
          id: "1593",
          name: "Dasarahalli",
          state_id: "17",
        },
        {
          id: "1594",
          name: "Davangere",
          state_id: "17",
        },
        {
          id: "1595",
          name: "Devadurga",
          state_id: "17",
        },
        {
          id: "1596",
          name: "Devagiri",
          state_id: "17",
        },
        {
          id: "1597",
          name: "Devanhalli",
          state_id: "17",
        },
        {
          id: "1598",
          name: "Dharwar",
          state_id: "17",
        },
        {
          id: "1599",
          name: "Dhupdal",
          state_id: "17",
        },
        {
          id: "1600",
          name: "Dod Ballapur",
          state_id: "17",
        },
        {
          id: "1601",
          name: "Donimalai",
          state_id: "17",
        },
        {
          id: "1602",
          name: "Gadag",
          state_id: "17",
        },
        {
          id: "1603",
          name: "Gajendragarh",
          state_id: "17",
        },
        {
          id: "1604",
          name: "Ganeshgudi",
          state_id: "17",
        },
        {
          id: "1605",
          name: "Gangawati",
          state_id: "17",
        },
        {
          id: "1606",
          name: "Gangoli",
          state_id: "17",
        },
        {
          id: "1607",
          name: "Gauribidanur",
          state_id: "17",
        },
        {
          id: "1608",
          name: "Gokak",
          state_id: "17",
        },
        {
          id: "1609",
          name: "Gokak Falls",
          state_id: "17",
        },
        {
          id: "1610",
          name: "Gonikoppal",
          state_id: "17",
        },
        {
          id: "1611",
          name: "Gorur",
          state_id: "17",
        },
        {
          id: "1612",
          name: "Gottikere",
          state_id: "17",
        },
        {
          id: "1613",
          name: "Gubbi",
          state_id: "17",
        },
        {
          id: "1614",
          name: "Gudibanda",
          state_id: "17",
        },
        {
          id: "1615",
          name: "Gulbarga",
          state_id: "17",
        },
        {
          id: "1616",
          name: "Guledgudda",
          state_id: "17",
        },
        {
          id: "1617",
          name: "Gundlupet",
          state_id: "17",
        },
        {
          id: "1618",
          name: "Gurmatkal",
          state_id: "17",
        },
        {
          id: "1619",
          name: "Haliyal",
          state_id: "17",
        },
        {
          id: "1620",
          name: "Hangal",
          state_id: "17",
        },
        {
          id: "1621",
          name: "Harihar",
          state_id: "17",
        },
        {
          id: "1622",
          name: "Harpanahalli",
          state_id: "17",
        },
        {
          id: "1623",
          name: "Hassan",
          state_id: "17",
        },
        {
          id: "1624",
          name: "Hatti",
          state_id: "17",
        },
        {
          id: "1625",
          name: "Hatti Gold Mines",
          state_id: "17",
        },
        {
          id: "1626",
          name: "Haveri",
          state_id: "17",
        },
        {
          id: "1627",
          name: "Hebbagodi",
          state_id: "17",
        },
        {
          id: "1628",
          name: "Hebbalu",
          state_id: "17",
        },
        {
          id: "1629",
          name: "Hebri",
          state_id: "17",
        },
        {
          id: "1630",
          name: "Heggadadevanakote",
          state_id: "17",
        },
        {
          id: "1631",
          name: "Herohalli",
          state_id: "17",
        },
        {
          id: "1632",
          name: "Hidkal",
          state_id: "17",
        },
        {
          id: "1633",
          name: "Hindalgi",
          state_id: "17",
        },
        {
          id: "1634",
          name: "Hirekerur",
          state_id: "17",
        },
        {
          id: "1635",
          name: "Hiriyur",
          state_id: "17",
        },
        {
          id: "1636",
          name: "Holalkere",
          state_id: "17",
        },
        {
          id: "1637",
          name: "Hole Narsipur",
          state_id: "17",
        },
        {
          id: "1638",
          name: "Homnabad",
          state_id: "17",
        },
        {
          id: "1639",
          name: "Honavar",
          state_id: "17",
        },
        {
          id: "1640",
          name: "Honnali",
          state_id: "17",
        },
        {
          id: "1641",
          name: "Hosakote",
          state_id: "17",
        },
        {
          id: "1642",
          name: "Hosanagara",
          state_id: "17",
        },
        {
          id: "1643",
          name: "Hosangadi",
          state_id: "17",
        },
        {
          id: "1644",
          name: "Hosdurga",
          state_id: "17",
        },
        {
          id: "1645",
          name: "Hoskote",
          state_id: "17",
        },
        {
          id: "1646",
          name: "Hospet",
          state_id: "17",
        },
        {
          id: "1647",
          name: "Hubli",
          state_id: "17",
        },
        {
          id: "1648",
          name: "Hukeri",
          state_id: "17",
        },
        {
          id: "1649",
          name: "Hunasagi",
          state_id: "17",
        },
        {
          id: "1650",
          name: "Hunasamaranahalli",
          state_id: "17",
        },
        {
          id: "1651",
          name: "Hungund",
          state_id: "17",
        },
        {
          id: "1652",
          name: "Hunsur",
          state_id: "17",
        },
        {
          id: "1653",
          name: "Huvina Hadagalli",
          state_id: "17",
        },
        {
          id: "1654",
          name: "Ilkal",
          state_id: "17",
        },
        {
          id: "1655",
          name: "Indi",
          state_id: "17",
        },
        {
          id: "1656",
          name: "Jagalur",
          state_id: "17",
        },
        {
          id: "1657",
          name: "Jamkhandi",
          state_id: "17",
        },
        {
          id: "1658",
          name: "Jevargi",
          state_id: "17",
        },
        {
          id: "1659",
          name: "Jog Falls",
          state_id: "17",
        },
        {
          id: "1660",
          name: "Kabini Colony",
          state_id: "17",
        },
        {
          id: "1661",
          name: "Kadur",
          state_id: "17",
        },
        {
          id: "1662",
          name: "Kalghatgi",
          state_id: "17",
        },
        {
          id: "1663",
          name: "Kamalapuram",
          state_id: "17",
        },
        {
          id: "1664",
          name: "Kampli",
          state_id: "17",
        },
        {
          id: "1665",
          name: "Kanakapura",
          state_id: "17",
        },
        {
          id: "1666",
          name: "Kangrali BK",
          state_id: "17",
        },
        {
          id: "1667",
          name: "Kangrali KH",
          state_id: "17",
        },
        {
          id: "1668",
          name: "Kannur",
          state_id: "17",
        },
        {
          id: "1669",
          name: "Karkala",
          state_id: "17",
        },
        {
          id: "1670",
          name: "Karwar",
          state_id: "17",
        },
        {
          id: "1671",
          name: "Kemminja",
          state_id: "17",
        },
        {
          id: "1672",
          name: "Kengeri",
          state_id: "17",
        },
        {
          id: "1673",
          name: "Kerur",
          state_id: "17",
        },
        {
          id: "1674",
          name: "Khanapur",
          state_id: "17",
        },
        {
          id: "1675",
          name: "Kodigenahalli",
          state_id: "17",
        },
        {
          id: "1676",
          name: "Kodiyal",
          state_id: "17",
        },
        {
          id: "1677",
          name: "Kodlipet",
          state_id: "17",
        },
        {
          id: "1678",
          name: "Kolar",
          state_id: "17",
        },
        {
          id: "1679",
          name: "Kollegal",
          state_id: "17",
        },
        {
          id: "1680",
          name: "Konanakunte",
          state_id: "17",
        },
        {
          id: "1681",
          name: "Konanur",
          state_id: "17",
        },
        {
          id: "1682",
          name: "Konnur",
          state_id: "17",
        },
        {
          id: "1683",
          name: "Koppa",
          state_id: "17",
        },
        {
          id: "1684",
          name: "Koppal",
          state_id: "17",
        },
        {
          id: "1685",
          name: "Koratagere",
          state_id: "17",
        },
        {
          id: "1686",
          name: "Kotekara",
          state_id: "17",
        },
        {
          id: "1687",
          name: "Kothnur",
          state_id: "17",
        },
        {
          id: "1688",
          name: "Kotturu",
          state_id: "17",
        },
        {
          id: "1689",
          name: "Krishnapura",
          state_id: "17",
        },
        {
          id: "1690",
          name: "Krishnarajanagar",
          state_id: "17",
        },
        {
          id: "1691",
          name: "Krishnarajapura",
          state_id: "17",
        },
        {
          id: "1692",
          name: "Krishnarajasagara",
          state_id: "17",
        },
        {
          id: "1693",
          name: "Krishnarajpet",
          state_id: "17",
        },
        {
          id: "1694",
          name: "Kudchi",
          state_id: "17",
        },
        {
          id: "1695",
          name: "Kudligi",
          state_id: "17",
        },
        {
          id: "1696",
          name: "Kudremukh",
          state_id: "17",
        },
        {
          id: "1697",
          name: "Kumsi",
          state_id: "17",
        },
        {
          id: "1698",
          name: "Kumta",
          state_id: "17",
        },
        {
          id: "1699",
          name: "Kundapura",
          state_id: "17",
        },
        {
          id: "1700",
          name: "Kundgol",
          state_id: "17",
        },
        {
          id: "1701",
          name: "Kunigal",
          state_id: "17",
        },
        {
          id: "1702",
          name: "Kurgunta",
          state_id: "17",
        },
        {
          id: "1703",
          name: "Kushalnagar",
          state_id: "17",
        },
        {
          id: "1704",
          name: "Kushtagi",
          state_id: "17",
        },
        {
          id: "1705",
          name: "Kyathanahalli",
          state_id: "17",
        },
        {
          id: "1706",
          name: "Lakshmeshwar",
          state_id: "17",
        },
        {
          id: "1707",
          name: "Lingsugur",
          state_id: "17",
        },
        {
          id: "1708",
          name: "Londa",
          state_id: "17",
        },
        {
          id: "1709",
          name: "Maddur",
          state_id: "17",
        },
        {
          id: "1710",
          name: "Madhugiri",
          state_id: "17",
        },
        {
          id: "1711",
          name: "Madikeri",
          state_id: "17",
        },
        {
          id: "1712",
          name: "Magadi",
          state_id: "17",
        },
        {
          id: "1713",
          name: "Magod Falls",
          state_id: "17",
        },
        {
          id: "1714",
          name: "Mahadeswara Hills",
          state_id: "17",
        },
        {
          id: "1715",
          name: "Mahadevapura",
          state_id: "17",
        },
        {
          id: "1716",
          name: "Mahalingpur",
          state_id: "17",
        },
        {
          id: "1717",
          name: "Maisuru",
          state_id: "17",
        },
        {
          id: "1718",
          name: "Maisuru Cantonment",
          state_id: "17",
        },
        {
          id: "1719",
          name: "Malavalli",
          state_id: "17",
        },
        {
          id: "1720",
          name: "Mallar",
          state_id: "17",
        },
        {
          id: "1721",
          name: "Malpe",
          state_id: "17",
        },
        {
          id: "1722",
          name: "Malur",
          state_id: "17",
        },
        {
          id: "1723",
          name: "Manchenahalli",
          state_id: "17",
        },
        {
          id: "1724",
          name: "Mandya",
          state_id: "17",
        },
        {
          id: "1725",
          name: "Mangalore",
          state_id: "17",
        },
        {
          id: "1726",
          name: "Mangaluru",
          state_id: "17",
        },
        {
          id: "1727",
          name: "Manipal",
          state_id: "17",
        },
        {
          id: "1728",
          name: "Manvi",
          state_id: "17",
        },
        {
          id: "1729",
          name: "Maski",
          state_id: "17",
        },
        {
          id: "1730",
          name: "Mastikatte Colony",
          state_id: "17",
        },
        {
          id: "1731",
          name: "Mayakonda",
          state_id: "17",
        },
        {
          id: "1732",
          name: "Melukote",
          state_id: "17",
        },
        {
          id: "1733",
          name: "Molakalmuru",
          state_id: "17",
        },
        {
          id: "1734",
          name: "Mudalgi",
          state_id: "17",
        },
        {
          id: "1735",
          name: "Mudbidri",
          state_id: "17",
        },
        {
          id: "1736",
          name: "Muddebihal",
          state_id: "17",
        },
        {
          id: "1737",
          name: "Mudgal",
          state_id: "17",
        },
        {
          id: "1738",
          name: "Mudhol",
          state_id: "17",
        },
        {
          id: "1739",
          name: "Mudigere",
          state_id: "17",
        },
        {
          id: "1740",
          name: "Mudushedde",
          state_id: "17",
        },
        {
          id: "1741",
          name: "Mulbagal",
          state_id: "17",
        },
        {
          id: "1742",
          name: "Mulgund",
          state_id: "17",
        },
        {
          id: "1743",
          name: "Mulki",
          state_id: "17",
        },
        {
          id: "1744",
          name: "Mulur",
          state_id: "17",
        },
        {
          id: "1745",
          name: "Mundargi",
          state_id: "17",
        },
        {
          id: "1746",
          name: "Mundgod",
          state_id: "17",
        },
        {
          id: "1747",
          name: "Munirabad",
          state_id: "17",
        },
        {
          id: "1748",
          name: "Munnur",
          state_id: "17",
        },
        {
          id: "1749",
          name: "Murudeshwara",
          state_id: "17",
        },
        {
          id: "1750",
          name: "Mysore",
          state_id: "17",
        },
        {
          id: "1751",
          name: "Nagamangala",
          state_id: "17",
        },
        {
          id: "1752",
          name: "Nanjangud",
          state_id: "17",
        },
        {
          id: "1753",
          name: "Naragund",
          state_id: "17",
        },
        {
          id: "1754",
          name: "Narasimharajapura",
          state_id: "17",
        },
        {
          id: "1755",
          name: "Naravi",
          state_id: "17",
        },
        {
          id: "1756",
          name: "Narayanpur",
          state_id: "17",
        },
        {
          id: "1757",
          name: "Naregal",
          state_id: "17",
        },
        {
          id: "1758",
          name: "Navalgund",
          state_id: "17",
        },
        {
          id: "1759",
          name: "Nelmangala",
          state_id: "17",
        },
        {
          id: "1760",
          name: "Nipani",
          state_id: "17",
        },
        {
          id: "1761",
          name: "Nitte",
          state_id: "17",
        },
        {
          id: "1762",
          name: "Nyamati",
          state_id: "17",
        },
        {
          id: "1763",
          name: "Padu",
          state_id: "17",
        },
        {
          id: "1764",
          name: "Pandavapura",
          state_id: "17",
        },
        {
          id: "1765",
          name: "Pattanagere",
          state_id: "17",
        },
        {
          id: "1766",
          name: "Pavagada",
          state_id: "17",
        },
        {
          id: "1767",
          name: "Piriyapatna",
          state_id: "17",
        },
        {
          id: "1768",
          name: "Ponnampet",
          state_id: "17",
        },
        {
          id: "1769",
          name: "Puttur",
          state_id: "17",
        },
        {
          id: "1770",
          name: "Rabkavi",
          state_id: "17",
        },
        {
          id: "1771",
          name: "Raichur",
          state_id: "17",
        },
        {
          id: "1772",
          name: "Ramanagaram",
          state_id: "17",
        },
        {
          id: "1773",
          name: "Ramdurg",
          state_id: "17",
        },
        {
          id: "1774",
          name: "Ranibennur",
          state_id: "17",
        },
        {
          id: "1775",
          name: "Raybag",
          state_id: "17",
        },
        {
          id: "1776",
          name: "Robertsonpet",
          state_id: "17",
        },
        {
          id: "1777",
          name: "Ron",
          state_id: "17",
        },
        {
          id: "1778",
          name: "Sadalgi",
          state_id: "17",
        },
        {
          id: "1779",
          name: "Sagar",
          state_id: "17",
        },
        {
          id: "1780",
          name: "Sakleshpur",
          state_id: "17",
        },
        {
          id: "1781",
          name: "Saligram",
          state_id: "17",
        },
        {
          id: "1782",
          name: "Sandur",
          state_id: "17",
        },
        {
          id: "1783",
          name: "Sanivarsante",
          state_id: "17",
        },
        {
          id: "1784",
          name: "Sankeshwar",
          state_id: "17",
        },
        {
          id: "1785",
          name: "Sargur",
          state_id: "17",
        },
        {
          id: "1786",
          name: "Sathyamangala",
          state_id: "17",
        },
        {
          id: "1787",
          name: "Saundatti Yellamma",
          state_id: "17",
        },
        {
          id: "1788",
          name: "Savanur",
          state_id: "17",
        },
        {
          id: "1789",
          name: "Sedam",
          state_id: "17",
        },
        {
          id: "1790",
          name: "Shahabad",
          state_id: "17",
        },
        {
          id: "1791",
          name: "Shahabad A.C.C.",
          state_id: "17",
        },
        {
          id: "1792",
          name: "Shahapur",
          state_id: "17",
        },
        {
          id: "1793",
          name: "Shahpur",
          state_id: "17",
        },
        {
          id: "1794",
          name: "Shaktinagar",
          state_id: "17",
        },
        {
          id: "1795",
          name: "Shiggaon",
          state_id: "17",
        },
        {
          id: "1796",
          name: "Shikarpur",
          state_id: "17",
        },
        {
          id: "1797",
          name: "Shimoga",
          state_id: "17",
        },
        {
          id: "1798",
          name: "Shirhatti",
          state_id: "17",
        },
        {
          id: "1799",
          name: "Shorapur",
          state_id: "17",
        },
        {
          id: "1800",
          name: "Shravanabelagola",
          state_id: "17",
        },
        {
          id: "1801",
          name: "Shrirangapattana",
          state_id: "17",
        },
        {
          id: "1802",
          name: "Siddapur",
          state_id: "17",
        },
        {
          id: "1803",
          name: "Sidlaghatta",
          state_id: "17",
        },
        {
          id: "1804",
          name: "Sindgi",
          state_id: "17",
        },
        {
          id: "1805",
          name: "Sindhnur",
          state_id: "17",
        },
        {
          id: "1806",
          name: "Sira",
          state_id: "17",
        },
        {
          id: "1807",
          name: "Sirakoppa",
          state_id: "17",
        },
        {
          id: "1808",
          name: "Sirsi",
          state_id: "17",
        },
        {
          id: "1809",
          name: "Siruguppa",
          state_id: "17",
        },
        {
          id: "1810",
          name: "Someshwar",
          state_id: "17",
        },
        {
          id: "1811",
          name: "Somvarpet",
          state_id: "17",
        },
        {
          id: "1812",
          name: "Sorab",
          state_id: "17",
        },
        {
          id: "1813",
          name: "Sringeri",
          state_id: "17",
        },
        {
          id: "1814",
          name: "Srinivaspur",
          state_id: "17",
        },
        {
          id: "1815",
          name: "Sulya",
          state_id: "17",
        },
        {
          id: "1816",
          name: "Suntikopa",
          state_id: "17",
        },
        {
          id: "1817",
          name: "Talikota",
          state_id: "17",
        },
        {
          id: "1818",
          name: "Tarikera",
          state_id: "17",
        },
        {
          id: "1819",
          name: "Tekkalakota",
          state_id: "17",
        },
        {
          id: "1820",
          name: "Terdal",
          state_id: "17",
        },
        {
          id: "1821",
          name: "Thokur",
          state_id: "17",
        },
        {
          id: "1822",
          name: "Thumbe",
          state_id: "17",
        },
        {
          id: "1823",
          name: "Tiptur",
          state_id: "17",
        },
        {
          id: "1824",
          name: "Tirthahalli",
          state_id: "17",
        },
        {
          id: "1825",
          name: "Tirumakudal Narsipur",
          state_id: "17",
        },
        {
          id: "1826",
          name: "Tonse",
          state_id: "17",
        },
        {
          id: "1827",
          name: "Tumkur",
          state_id: "17",
        },
        {
          id: "1828",
          name: "Turuvekere",
          state_id: "17",
        },
        {
          id: "1829",
          name: "Udupi",
          state_id: "17",
        },
        {
          id: "1830",
          name: "Ullal",
          state_id: "17",
        },
        {
          id: "1831",
          name: "Uttarahalli",
          state_id: "17",
        },
        {
          id: "1832",
          name: "Venkatapura",
          state_id: "17",
        },
        {
          id: "1833",
          name: "Vijayapura",
          state_id: "17",
        },
        {
          id: "1834",
          name: "Virarajendrapet",
          state_id: "17",
        },
        {
          id: "1835",
          name: "Wadi",
          state_id: "17",
        },
        {
          id: "1836",
          name: "Wadi A.C.C.",
          state_id: "17",
        },
        {
          id: "1837",
          name: "Yadgir",
          state_id: "17",
        },
        {
          id: "1838",
          name: "Yelahanka",
          state_id: "17",
        },
        {
          id: "1839",
          name: "Yelandur",
          state_id: "17",
        },
        {
          id: "1840",
          name: "Yelbarga",
          state_id: "17",
        },
        {
          id: "1841",
          name: "Yellapur",
          state_id: "17",
        },
        {
          id: "1842",
          name: "Yenagudde",
          state_id: "17",
        },
      ],
      Kenmore: [],
      Kerala: [
        {
          id: "1843",
          name: "Adimaly",
          state_id: "19",
        },
        {
          id: "1844",
          name: "Adoor",
          state_id: "19",
        },
        {
          id: "1845",
          name: "Adur",
          state_id: "19",
        },
        {
          id: "1846",
          name: "Akathiyur",
          state_id: "19",
        },
        {
          id: "1847",
          name: "Alangad",
          state_id: "19",
        },
        {
          id: "1848",
          name: "Alappuzha",
          state_id: "19",
        },
        {
          id: "1849",
          name: "Aluva",
          state_id: "19",
        },
        {
          id: "1850",
          name: "Ancharakandy",
          state_id: "19",
        },
        {
          id: "1851",
          name: "Angamaly",
          state_id: "19",
        },
        {
          id: "1852",
          name: "Aroor",
          state_id: "19",
        },
        {
          id: "1853",
          name: "Arukutti",
          state_id: "19",
        },
        {
          id: "1854",
          name: "Attingal",
          state_id: "19",
        },
        {
          id: "1855",
          name: "Avinissery",
          state_id: "19",
        },
        {
          id: "1856",
          name: "Azhikode North",
          state_id: "19",
        },
        {
          id: "1857",
          name: "Azhikode South",
          state_id: "19",
        },
        {
          id: "1858",
          name: "Azhiyur",
          state_id: "19",
        },
        {
          id: "1859",
          name: "Balussery",
          state_id: "19",
        },
        {
          id: "1860",
          name: "Bangramanjeshwar",
          state_id: "19",
        },
        {
          id: "1861",
          name: "Beypur",
          state_id: "19",
        },
        {
          id: "1862",
          name: "Brahmakulam",
          state_id: "19",
        },
        {
          id: "1863",
          name: "Chala",
          state_id: "19",
        },
        {
          id: "1864",
          name: "Chalakudi",
          state_id: "19",
        },
        {
          id: "1865",
          name: "Changanacheri",
          state_id: "19",
        },
        {
          id: "1866",
          name: "Chauwara",
          state_id: "19",
        },
        {
          id: "1867",
          name: "Chavakkad",
          state_id: "19",
        },
        {
          id: "1868",
          name: "Chelakkara",
          state_id: "19",
        },
        {
          id: "1869",
          name: "Chelora",
          state_id: "19",
        },
        {
          id: "1870",
          name: "Chendamangalam",
          state_id: "19",
        },
        {
          id: "1871",
          name: "Chengamanad",
          state_id: "19",
        },
        {
          id: "1872",
          name: "Chengannur",
          state_id: "19",
        },
        {
          id: "1873",
          name: "Cheranallur",
          state_id: "19",
        },
        {
          id: "1874",
          name: "Cheriyakadavu",
          state_id: "19",
        },
        {
          id: "1875",
          name: "Cherthala",
          state_id: "19",
        },
        {
          id: "1876",
          name: "Cherukunnu",
          state_id: "19",
        },
        {
          id: "1877",
          name: "Cheruthazham",
          state_id: "19",
        },
        {
          id: "1878",
          name: "Cheruvannur",
          state_id: "19",
        },
        {
          id: "1879",
          name: "Cheruvattur",
          state_id: "19",
        },
        {
          id: "1880",
          name: "Chevvur",
          state_id: "19",
        },
        {
          id: "1881",
          name: "Chirakkal",
          state_id: "19",
        },
        {
          id: "1882",
          name: "Chittur",
          state_id: "19",
        },
        {
          id: "1883",
          name: "Chockli",
          state_id: "19",
        },
        {
          id: "1884",
          name: "Churnikkara",
          state_id: "19",
        },
        {
          id: "1885",
          name: "Dharmadam",
          state_id: "19",
        },
        {
          id: "1886",
          name: "Edappal",
          state_id: "19",
        },
        {
          id: "1887",
          name: "Edathala",
          state_id: "19",
        },
        {
          id: "1888",
          name: "Elayavur",
          state_id: "19",
        },
        {
          id: "1889",
          name: "Elur",
          state_id: "19",
        },
        {
          id: "1890",
          name: "Eranholi",
          state_id: "19",
        },
        {
          id: "1891",
          name: "Erattupetta",
          state_id: "19",
        },
        {
          id: "1892",
          name: "Ernakulam",
          state_id: "19",
        },
        {
          id: "1893",
          name: "Eruvatti",
          state_id: "19",
        },
        {
          id: "1894",
          name: "Ettumanoor",
          state_id: "19",
        },
        {
          id: "1895",
          name: "Feroke",
          state_id: "19",
        },
        {
          id: "1896",
          name: "Guruvayur",
          state_id: "19",
        },
        {
          id: "1897",
          name: "Haripad",
          state_id: "19",
        },
        {
          id: "1898",
          name: "Hosabettu",
          state_id: "19",
        },
        {
          id: "1899",
          name: "Idukki",
          state_id: "19",
        },
        {
          id: "1900",
          name: "Iringaprom",
          state_id: "19",
        },
        {
          id: "1901",
          name: "Irinjalakuda",
          state_id: "19",
        },
        {
          id: "1902",
          name: "Iriveri",
          state_id: "19",
        },
        {
          id: "1903",
          name: "Kadachira",
          state_id: "19",
        },
        {
          id: "1904",
          name: "Kadalundi",
          state_id: "19",
        },
        {
          id: "1905",
          name: "Kadamakkudy",
          state_id: "19",
        },
        {
          id: "1906",
          name: "Kadirur",
          state_id: "19",
        },
        {
          id: "1907",
          name: "Kadungallur",
          state_id: "19",
        },
        {
          id: "1908",
          name: "Kakkodi",
          state_id: "19",
        },
        {
          id: "1909",
          name: "Kalady",
          state_id: "19",
        },
        {
          id: "1910",
          name: "Kalamassery",
          state_id: "19",
        },
        {
          id: "1911",
          name: "Kalliasseri",
          state_id: "19",
        },
        {
          id: "1912",
          name: "Kalpetta",
          state_id: "19",
        },
        {
          id: "1913",
          name: "Kanhangad",
          state_id: "19",
        },
        {
          id: "1914",
          name: "Kanhirode",
          state_id: "19",
        },
        {
          id: "1915",
          name: "Kanjikkuzhi",
          state_id: "19",
        },
        {
          id: "1916",
          name: "Kanjikode",
          state_id: "19",
        },
        {
          id: "1917",
          name: "Kanjirappalli",
          state_id: "19",
        },
        {
          id: "1918",
          name: "Kannadiparamba",
          state_id: "19",
        },
        {
          id: "1919",
          name: "Kannangad",
          state_id: "19",
        },
        {
          id: "1920",
          name: "Kannapuram",
          state_id: "19",
        },
        {
          id: "1921",
          name: "Kannur",
          state_id: "19",
        },
        {
          id: "1922",
          name: "Kannur Cantonment",
          state_id: "19",
        },
        {
          id: "1923",
          name: "Karunagappally",
          state_id: "19",
        },
        {
          id: "1924",
          name: "Karuvamyhuruthy",
          state_id: "19",
        },
        {
          id: "1925",
          name: "Kasaragod",
          state_id: "19",
        },
        {
          id: "1926",
          name: "Kasargod",
          state_id: "19",
        },
        {
          id: "1927",
          name: "Kattappana",
          state_id: "19",
        },
        {
          id: "1928",
          name: "Kayamkulam",
          state_id: "19",
        },
        {
          id: "1929",
          name: "Kedamangalam",
          state_id: "19",
        },
        {
          id: "1930",
          name: "Kochi",
          state_id: "19",
        },
        {
          id: "1931",
          name: "Kodamthuruthu",
          state_id: "19",
        },
        {
          id: "1932",
          name: "Kodungallur",
          state_id: "19",
        },
        {
          id: "1933",
          name: "Koduvally",
          state_id: "19",
        },
        {
          id: "1934",
          name: "Koduvayur",
          state_id: "19",
        },
        {
          id: "1935",
          name: "Kokkothamangalam",
          state_id: "19",
        },
        {
          id: "1936",
          name: "Kolazhy",
          state_id: "19",
        },
        {
          id: "1937",
          name: "Kollam",
          state_id: "19",
        },
        {
          id: "1938",
          name: "Komalapuram",
          state_id: "19",
        },
        {
          id: "1939",
          name: "Koothattukulam",
          state_id: "19",
        },
        {
          id: "1940",
          name: "Koratty",
          state_id: "19",
        },
        {
          id: "1941",
          name: "Kothamangalam",
          state_id: "19",
        },
        {
          id: "1942",
          name: "Kottarakkara",
          state_id: "19",
        },
        {
          id: "1943",
          name: "Kottayam",
          state_id: "19",
        },
        {
          id: "1944",
          name: "Kottayam Malabar",
          state_id: "19",
        },
        {
          id: "1945",
          name: "Kottuvally",
          state_id: "19",
        },
        {
          id: "1946",
          name: "Koyilandi",
          state_id: "19",
        },
        {
          id: "1947",
          name: "Kozhikode",
          state_id: "19",
        },
        {
          id: "1948",
          name: "Kudappanakunnu",
          state_id: "19",
        },
        {
          id: "1949",
          name: "Kudlu",
          state_id: "19",
        },
        {
          id: "1950",
          name: "Kumarakom",
          state_id: "19",
        },
        {
          id: "1951",
          name: "Kumily",
          state_id: "19",
        },
        {
          id: "1952",
          name: "Kunnamangalam",
          state_id: "19",
        },
        {
          id: "1953",
          name: "Kunnamkulam",
          state_id: "19",
        },
        {
          id: "1954",
          name: "Kurikkad",
          state_id: "19",
        },
        {
          id: "1955",
          name: "Kurkkanchery",
          state_id: "19",
        },
        {
          id: "1956",
          name: "Kuthuparamba",
          state_id: "19",
        },
        {
          id: "1957",
          name: "Kuttakulam",
          state_id: "19",
        },
        {
          id: "1958",
          name: "Kuttikkattur",
          state_id: "19",
        },
        {
          id: "1959",
          name: "Kuttur",
          state_id: "19",
        },
        {
          id: "1960",
          name: "Malappuram",
          state_id: "19",
        },
        {
          id: "1961",
          name: "Mallappally",
          state_id: "19",
        },
        {
          id: "1962",
          name: "Manjeri",
          state_id: "19",
        },
        {
          id: "1963",
          name: "Manjeshwar",
          state_id: "19",
        },
        {
          id: "1964",
          name: "Mannancherry",
          state_id: "19",
        },
        {
          id: "1965",
          name: "Mannar",
          state_id: "19",
        },
        {
          id: "1966",
          name: "Mannarakkat",
          state_id: "19",
        },
        {
          id: "1967",
          name: "Maradu",
          state_id: "19",
        },
        {
          id: "1968",
          name: "Marathakkara",
          state_id: "19",
        },
        {
          id: "1969",
          name: "Marutharod",
          state_id: "19",
        },
        {
          id: "1970",
          name: "Mattannur",
          state_id: "19",
        },
        {
          id: "1971",
          name: "Mavelikara",
          state_id: "19",
        },
        {
          id: "1972",
          name: "Mavilayi",
          state_id: "19",
        },
        {
          id: "1973",
          name: "Mavur",
          state_id: "19",
        },
        {
          id: "1974",
          name: "Methala",
          state_id: "19",
        },
        {
          id: "1975",
          name: "Muhamma",
          state_id: "19",
        },
        {
          id: "1976",
          name: "Mulavukad",
          state_id: "19",
        },
        {
          id: "1977",
          name: "Mundakayam",
          state_id: "19",
        },
        {
          id: "1978",
          name: "Munderi",
          state_id: "19",
        },
        {
          id: "1979",
          name: "Munnar",
          state_id: "19",
        },
        {
          id: "1980",
          name: "Muthakunnam",
          state_id: "19",
        },
        {
          id: "1981",
          name: "Muvattupuzha",
          state_id: "19",
        },
        {
          id: "1982",
          name: "Muzhappilangad",
          state_id: "19",
        },
        {
          id: "1983",
          name: "Nadapuram",
          state_id: "19",
        },
        {
          id: "1984",
          name: "Nadathara",
          state_id: "19",
        },
        {
          id: "1985",
          name: "Narath",
          state_id: "19",
        },
        {
          id: "1986",
          name: "Nattakam",
          state_id: "19",
        },
        {
          id: "1987",
          name: "Nedumangad",
          state_id: "19",
        },
        {
          id: "1988",
          name: "Nenmenikkara",
          state_id: "19",
        },
        {
          id: "1989",
          name: "New Mahe",
          state_id: "19",
        },
        {
          id: "1990",
          name: "Neyyattinkara",
          state_id: "19",
        },
        {
          id: "1991",
          name: "Nileshwar",
          state_id: "19",
        },
        {
          id: "1992",
          name: "Olavanna",
          state_id: "19",
        },
        {
          id: "1993",
          name: "Ottapalam",
          state_id: "19",
        },
        {
          id: "1994",
          name: "Ottappalam",
          state_id: "19",
        },
        {
          id: "1995",
          name: "Paduvilayi",
          state_id: "19",
        },
        {
          id: "1996",
          name: "Palai",
          state_id: "19",
        },
        {
          id: "1997",
          name: "Palakkad",
          state_id: "19",
        },
        {
          id: "1998",
          name: "Palayad",
          state_id: "19",
        },
        {
          id: "1999",
          name: "Palissery",
          state_id: "19",
        },
        {
          id: "2000",
          name: "Pallikkunnu",
          state_id: "19",
        },
        {
          id: "2001",
          name: "Paluvai",
          state_id: "19",
        },
        {
          id: "2002",
          name: "Panniyannur",
          state_id: "19",
        },
        {
          id: "2003",
          name: "Pantalam",
          state_id: "19",
        },
        {
          id: "2004",
          name: "Panthiramkavu",
          state_id: "19",
        },
        {
          id: "2005",
          name: "Panur",
          state_id: "19",
        },
        {
          id: "2006",
          name: "Pappinisseri",
          state_id: "19",
        },
        {
          id: "2007",
          name: "Parassala",
          state_id: "19",
        },
        {
          id: "2008",
          name: "Paravur",
          state_id: "19",
        },
        {
          id: "2009",
          name: "Pathanamthitta",
          state_id: "19",
        },
        {
          id: "2010",
          name: "Pathanapuram",
          state_id: "19",
        },
        {
          id: "2011",
          name: "Pathiriyad",
          state_id: "19",
        },
        {
          id: "2012",
          name: "Pattambi",
          state_id: "19",
        },
        {
          id: "2013",
          name: "Pattiom",
          state_id: "19",
        },
        {
          id: "2014",
          name: "Pavaratty",
          state_id: "19",
        },
        {
          id: "2015",
          name: "Payyannur",
          state_id: "19",
        },
        {
          id: "2016",
          name: "Peermade",
          state_id: "19",
        },
        {
          id: "2017",
          name: "Perakam",
          state_id: "19",
        },
        {
          id: "2018",
          name: "Peralasseri",
          state_id: "19",
        },
        {
          id: "2019",
          name: "Peringathur",
          state_id: "19",
        },
        {
          id: "2020",
          name: "Perinthalmanna",
          state_id: "19",
        },
        {
          id: "2021",
          name: "Perole",
          state_id: "19",
        },
        {
          id: "2022",
          name: "Perumanna",
          state_id: "19",
        },
        {
          id: "2023",
          name: "Perumbaikadu",
          state_id: "19",
        },
        {
          id: "2024",
          name: "Perumbavoor",
          state_id: "19",
        },
        {
          id: "2025",
          name: "Pinarayi",
          state_id: "19",
        },
        {
          id: "2026",
          name: "Piravam",
          state_id: "19",
        },
        {
          id: "2027",
          name: "Ponnani",
          state_id: "19",
        },
        {
          id: "2028",
          name: "Pottore",
          state_id: "19",
        },
        {
          id: "2029",
          name: "Pudukad",
          state_id: "19",
        },
        {
          id: "2030",
          name: "Punalur",
          state_id: "19",
        },
        {
          id: "2031",
          name: "Puranattukara",
          state_id: "19",
        },
        {
          id: "2032",
          name: "Puthunagaram",
          state_id: "19",
        },
        {
          id: "2033",
          name: "Puthuppariyaram",
          state_id: "19",
        },
        {
          id: "2034",
          name: "Puzhathi",
          state_id: "19",
        },
        {
          id: "2035",
          name: "Ramanattukara",
          state_id: "19",
        },
        {
          id: "2036",
          name: "Shoranur",
          state_id: "19",
        },
        {
          id: "2037",
          name: "Sultans Battery",
          state_id: "19",
        },
        {
          id: "2038",
          name: "Sulthan Bathery",
          state_id: "19",
        },
        {
          id: "2039",
          name: "Talipparamba",
          state_id: "19",
        },
        {
          id: "2040",
          name: "Thaikkad",
          state_id: "19",
        },
        {
          id: "2041",
          name: "Thalassery",
          state_id: "19",
        },
        {
          id: "2042",
          name: "Thannirmukkam",
          state_id: "19",
        },
        {
          id: "2043",
          name: "Theyyalingal",
          state_id: "19",
        },
        {
          id: "2044",
          name: "Thiruvalla",
          state_id: "19",
        },
        {
          id: "2045",
          name: "Thiruvananthapuram",
          state_id: "19",
        },
        {
          id: "2046",
          name: "Thiruvankulam",
          state_id: "19",
        },
        {
          id: "2047",
          name: "Thodupuzha",
          state_id: "19",
        },
        {
          id: "2048",
          name: "Thottada",
          state_id: "19",
        },
        {
          id: "2049",
          name: "Thrippunithura",
          state_id: "19",
        },
        {
          id: "2050",
          name: "Thrissur",
          state_id: "19",
        },
        {
          id: "2051",
          name: "Tirur",
          state_id: "19",
        },
        {
          id: "2052",
          name: "Udma",
          state_id: "19",
        },
        {
          id: "2053",
          name: "Vadakara",
          state_id: "19",
        },
        {
          id: "2054",
          name: "Vaikam",
          state_id: "19",
        },
        {
          id: "2055",
          name: "Valapattam",
          state_id: "19",
        },
        {
          id: "2056",
          name: "Vallachira",
          state_id: "19",
        },
        {
          id: "2057",
          name: "Varam",
          state_id: "19",
        },
        {
          id: "2058",
          name: "Varappuzha",
          state_id: "19",
        },
        {
          id: "2059",
          name: "Varkala",
          state_id: "19",
        },
        {
          id: "2060",
          name: "Vayalar",
          state_id: "19",
        },
        {
          id: "2061",
          name: "Vazhakkala",
          state_id: "19",
        },
        {
          id: "2062",
          name: "Venmanad",
          state_id: "19",
        },
        {
          id: "2063",
          name: "Villiappally",
          state_id: "19",
        },
        {
          id: "2064",
          name: "Wayanad",
          state_id: "19",
        },
      ],
      Lakshadweep: [
        {
          id: "2065",
          name: "Agethi",
          state_id: "20",
        },
        {
          id: "2066",
          name: "Amini",
          state_id: "20",
        },
        {
          id: "2067",
          name: "Androth Island",
          state_id: "20",
        },
        {
          id: "2068",
          name: "Kavaratti",
          state_id: "20",
        },
        {
          id: "2069",
          name: "Minicoy",
          state_id: "20",
        },
      ],
      "Madhya Pradesh": [
        {
          id: "2070",
          name: "Agar",
          state_id: "21",
        },
        {
          id: "2071",
          name: "Ajaigarh",
          state_id: "21",
        },
        {
          id: "2072",
          name: "Akoda",
          state_id: "21",
        },
        {
          id: "2073",
          name: "Akodia",
          state_id: "21",
        },
        {
          id: "2074",
          name: "Alampur",
          state_id: "21",
        },
        {
          id: "2075",
          name: "Alirajpur",
          state_id: "21",
        },
        {
          id: "2076",
          name: "Alot",
          state_id: "21",
        },
        {
          id: "2077",
          name: "Amanganj",
          state_id: "21",
        },
        {
          id: "2078",
          name: "Amarkantak",
          state_id: "21",
        },
        {
          id: "2079",
          name: "Amarpatan",
          state_id: "21",
        },
        {
          id: "2080",
          name: "Amarwara",
          state_id: "21",
        },
        {
          id: "2081",
          name: "Ambada",
          state_id: "21",
        },
        {
          id: "2082",
          name: "Ambah",
          state_id: "21",
        },
        {
          id: "2083",
          name: "Amla",
          state_id: "21",
        },
        {
          id: "2084",
          name: "Amlai",
          state_id: "21",
        },
        {
          id: "2085",
          name: "Anjad",
          state_id: "21",
        },
        {
          id: "2086",
          name: "Antri",
          state_id: "21",
        },
        {
          id: "2087",
          name: "Anuppur",
          state_id: "21",
        },
        {
          id: "2088",
          name: "Aron",
          state_id: "21",
        },
        {
          id: "2089",
          name: "Ashoknagar",
          state_id: "21",
        },
        {
          id: "2090",
          name: "Ashta",
          state_id: "21",
        },
        {
          id: "2091",
          name: "Babai",
          state_id: "21",
        },
        {
          id: "2092",
          name: "Bada Malhera",
          state_id: "21",
        },
        {
          id: "2093",
          name: "Badagaon",
          state_id: "21",
        },
        {
          id: "2094",
          name: "Badagoan",
          state_id: "21",
        },
        {
          id: "2095",
          name: "Badarwas",
          state_id: "21",
        },
        {
          id: "2096",
          name: "Badawada",
          state_id: "21",
        },
        {
          id: "2097",
          name: "Badi",
          state_id: "21",
        },
        {
          id: "2098",
          name: "Badkuhi",
          state_id: "21",
        },
        {
          id: "2099",
          name: "Badnagar",
          state_id: "21",
        },
        {
          id: "2100",
          name: "Badnawar",
          state_id: "21",
        },
        {
          id: "2101",
          name: "Badod",
          state_id: "21",
        },
        {
          id: "2102",
          name: "Badoda",
          state_id: "21",
        },
        {
          id: "2103",
          name: "Badra",
          state_id: "21",
        },
        {
          id: "2104",
          name: "Bagh",
          state_id: "21",
        },
        {
          id: "2105",
          name: "Bagli",
          state_id: "21",
        },
        {
          id: "2106",
          name: "Baihar",
          state_id: "21",
        },
        {
          id: "2107",
          name: "Baikunthpur",
          state_id: "21",
        },
        {
          id: "2108",
          name: "Bakswaha",
          state_id: "21",
        },
        {
          id: "2109",
          name: "Balaghat",
          state_id: "21",
        },
        {
          id: "2110",
          name: "Baldeogarh",
          state_id: "21",
        },
        {
          id: "2111",
          name: "Bamaniya",
          state_id: "21",
        },
        {
          id: "2112",
          name: "Bamhani",
          state_id: "21",
        },
        {
          id: "2113",
          name: "Bamor",
          state_id: "21",
        },
        {
          id: "2114",
          name: "Bamora",
          state_id: "21",
        },
        {
          id: "2115",
          name: "Banda",
          state_id: "21",
        },
        {
          id: "2116",
          name: "Bangawan",
          state_id: "21",
        },
        {
          id: "2117",
          name: "Bansatar Kheda",
          state_id: "21",
        },
        {
          id: "2118",
          name: "Baraily",
          state_id: "21",
        },
        {
          id: "2119",
          name: "Barela",
          state_id: "21",
        },
        {
          id: "2120",
          name: "Barghat",
          state_id: "21",
        },
        {
          id: "2121",
          name: "Bargi",
          state_id: "21",
        },
        {
          id: "2122",
          name: "Barhi",
          state_id: "21",
        },
        {
          id: "2123",
          name: "Barigarh",
          state_id: "21",
        },
        {
          id: "2124",
          name: "Barwaha",
          state_id: "21",
        },
        {
          id: "2125",
          name: "Barwani",
          state_id: "21",
        },
        {
          id: "2126",
          name: "Basoda",
          state_id: "21",
        },
        {
          id: "2127",
          name: "Begamganj",
          state_id: "21",
        },
        {
          id: "2128",
          name: "Beohari",
          state_id: "21",
        },
        {
          id: "2129",
          name: "Berasia",
          state_id: "21",
        },
        {
          id: "2130",
          name: "Betma",
          state_id: "21",
        },
        {
          id: "2131",
          name: "Betul",
          state_id: "21",
        },
        {
          id: "2132",
          name: "Betul Bazar",
          state_id: "21",
        },
        {
          id: "2133",
          name: "Bhainsdehi",
          state_id: "21",
        },
        {
          id: "2134",
          name: "Bhamodi",
          state_id: "21",
        },
        {
          id: "2135",
          name: "Bhander",
          state_id: "21",
        },
        {
          id: "2136",
          name: "Bhanpura",
          state_id: "21",
        },
        {
          id: "2137",
          name: "Bharveli",
          state_id: "21",
        },
        {
          id: "2138",
          name: "Bhaurasa",
          state_id: "21",
        },
        {
          id: "2139",
          name: "Bhavra",
          state_id: "21",
        },
        {
          id: "2140",
          name: "Bhedaghat",
          state_id: "21",
        },
        {
          id: "2141",
          name: "Bhikangaon",
          state_id: "21",
        },
        {
          id: "2142",
          name: "Bhilakhedi",
          state_id: "21",
        },
        {
          id: "2143",
          name: "Bhind",
          state_id: "21",
        },
        {
          id: "2144",
          name: "Bhitarwar",
          state_id: "21",
        },
        {
          id: "2145",
          name: "Bhopal",
          state_id: "21",
        },
        {
          id: "2146",
          name: "Bhuibandh",
          state_id: "21",
        },
        {
          id: "2147",
          name: "Biaora",
          state_id: "21",
        },
        {
          id: "2148",
          name: "Bijawar",
          state_id: "21",
        },
        {
          id: "2149",
          name: "Bijeypur",
          state_id: "21",
        },
        {
          id: "2150",
          name: "Bijrauni",
          state_id: "21",
        },
        {
          id: "2151",
          name: "Bijuri",
          state_id: "21",
        },
        {
          id: "2152",
          name: "Bilaua",
          state_id: "21",
        },
        {
          id: "2153",
          name: "Bilpura",
          state_id: "21",
        },
        {
          id: "2154",
          name: "Bina Railway Colony",
          state_id: "21",
        },
        {
          id: "2155",
          name: "Bina-Etawa",
          state_id: "21",
        },
        {
          id: "2156",
          name: "Birsinghpur",
          state_id: "21",
        },
        {
          id: "2157",
          name: "Boda",
          state_id: "21",
        },
        {
          id: "2158",
          name: "Budhni",
          state_id: "21",
        },
        {
          id: "2159",
          name: "Burhanpur",
          state_id: "21",
        },
        {
          id: "2160",
          name: "Burhar",
          state_id: "21",
        },
        {
          id: "2161",
          name: "Chachaura Binaganj",
          state_id: "21",
        },
        {
          id: "2162",
          name: "Chakghat",
          state_id: "21",
        },
        {
          id: "2163",
          name: "Chandameta Butar",
          state_id: "21",
        },
        {
          id: "2164",
          name: "Chanderi",
          state_id: "21",
        },
        {
          id: "2165",
          name: "Chandia",
          state_id: "21",
        },
        {
          id: "2166",
          name: "Chandla",
          state_id: "21",
        },
        {
          id: "2167",
          name: "Chaurai Khas",
          state_id: "21",
        },
        {
          id: "2168",
          name: "Chhatarpur",
          state_id: "21",
        },
        {
          id: "2169",
          name: "Chhindwara",
          state_id: "21",
        },
        {
          id: "2170",
          name: "Chhota Chhindwara",
          state_id: "21",
        },
        {
          id: "2171",
          name: "Chichli",
          state_id: "21",
        },
        {
          id: "2172",
          name: "Chitrakut",
          state_id: "21",
        },
        {
          id: "2173",
          name: "Churhat",
          state_id: "21",
        },
        {
          id: "2174",
          name: "Daboh",
          state_id: "21",
        },
        {
          id: "2175",
          name: "Dabra",
          state_id: "21",
        },
        {
          id: "2176",
          name: "Damoh",
          state_id: "21",
        },
        {
          id: "2177",
          name: "Damua",
          state_id: "21",
        },
        {
          id: "2178",
          name: "Datia",
          state_id: "21",
        },
        {
          id: "2179",
          name: "Deodara",
          state_id: "21",
        },
        {
          id: "2180",
          name: "Deori",
          state_id: "21",
        },
        {
          id: "2181",
          name: "Deori Khas",
          state_id: "21",
        },
        {
          id: "2182",
          name: "Depalpur",
          state_id: "21",
        },
        {
          id: "2183",
          name: "Devendranagar",
          state_id: "21",
        },
        {
          id: "2184",
          name: "Devhara",
          state_id: "21",
        },
        {
          id: "2185",
          name: "Dewas",
          state_id: "21",
        },
        {
          id: "2186",
          name: "Dhamnod",
          state_id: "21",
        },
        {
          id: "2187",
          name: "Dhana",
          state_id: "21",
        },
        {
          id: "2188",
          name: "Dhanpuri",
          state_id: "21",
        },
        {
          id: "2189",
          name: "Dhar",
          state_id: "21",
        },
        {
          id: "2190",
          name: "Dharampuri",
          state_id: "21",
        },
        {
          id: "2191",
          name: "Dighawani",
          state_id: "21",
        },
        {
          id: "2192",
          name: "Diken",
          state_id: "21",
        },
        {
          id: "2193",
          name: "Dindori",
          state_id: "21",
        },
        {
          id: "2194",
          name: "Dola",
          state_id: "21",
        },
        {
          id: "2195",
          name: "Dumar Kachhar",
          state_id: "21",
        },
        {
          id: "2196",
          name: "Dungariya Chhapara",
          state_id: "21",
        },
        {
          id: "2197",
          name: "Gadarwara",
          state_id: "21",
        },
        {
          id: "2198",
          name: "Gairatganj",
          state_id: "21",
        },
        {
          id: "2199",
          name: "Gandhi Sagar Hydel Colony",
          state_id: "21",
        },
        {
          id: "2200",
          name: "Ganjbasoda",
          state_id: "21",
        },
        {
          id: "2201",
          name: "Garhakota",
          state_id: "21",
        },
        {
          id: "2202",
          name: "Garhi Malhara",
          state_id: "21",
        },
        {
          id: "2203",
          name: "Garoth",
          state_id: "21",
        },
        {
          id: "2204",
          name: "Gautapura",
          state_id: "21",
        },
        {
          id: "2205",
          name: "Ghansor",
          state_id: "21",
        },
        {
          id: "2206",
          name: "Ghuwara",
          state_id: "21",
        },
        {
          id: "2207",
          name: "Gogaon",
          state_id: "21",
        },
        {
          id: "2208",
          name: "Gogapur",
          state_id: "21",
        },
        {
          id: "2209",
          name: "Gohad",
          state_id: "21",
        },
        {
          id: "2210",
          name: "Gormi",
          state_id: "21",
        },
        {
          id: "2211",
          name: "Govindgarh",
          state_id: "21",
        },
        {
          id: "2212",
          name: "Guna",
          state_id: "21",
        },
        {
          id: "2213",
          name: "Gurh",
          state_id: "21",
        },
        {
          id: "2214",
          name: "Gwalior",
          state_id: "21",
        },
        {
          id: "2215",
          name: "Hanumana",
          state_id: "21",
        },
        {
          id: "2216",
          name: "Harda",
          state_id: "21",
        },
        {
          id: "2217",
          name: "Harpalpur",
          state_id: "21",
        },
        {
          id: "2218",
          name: "Harrai",
          state_id: "21",
        },
        {
          id: "2219",
          name: "Harsud",
          state_id: "21",
        },
        {
          id: "2220",
          name: "Hatod",
          state_id: "21",
        },
        {
          id: "2221",
          name: "Hatpipalya",
          state_id: "21",
        },
        {
          id: "2222",
          name: "Hatta",
          state_id: "21",
        },
        {
          id: "2223",
          name: "Hindoria",
          state_id: "21",
        },
        {
          id: "2224",
          name: "Hirapur",
          state_id: "21",
        },
        {
          id: "2225",
          name: "Hoshangabad",
          state_id: "21",
        },
        {
          id: "2226",
          name: "Ichhawar",
          state_id: "21",
        },
        {
          id: "2227",
          name: "Iklehra",
          state_id: "21",
        },
        {
          id: "2228",
          name: "Indergarh",
          state_id: "21",
        },
        {
          id: "2229",
          name: "Indore",
          state_id: "21",
        },
        {
          id: "2230",
          name: "Isagarh",
          state_id: "21",
        },
        {
          id: "2231",
          name: "Itarsi",
          state_id: "21",
        },
        {
          id: "2232",
          name: "Jabalpur",
          state_id: "21",
        },
        {
          id: "2233",
          name: "Jabalpur Cantonment",
          state_id: "21",
        },
        {
          id: "2234",
          name: "Jabalpur G.C.F",
          state_id: "21",
        },
        {
          id: "2235",
          name: "Jaisinghnagar",
          state_id: "21",
        },
        {
          id: "2236",
          name: "Jaithari",
          state_id: "21",
        },
        {
          id: "2237",
          name: "Jaitwara",
          state_id: "21",
        },
        {
          id: "2238",
          name: "Jamai",
          state_id: "21",
        },
        {
          id: "2239",
          name: "Jaora",
          state_id: "21",
        },
        {
          id: "2240",
          name: "Jatachhapar",
          state_id: "21",
        },
        {
          id: "2241",
          name: "Jatara",
          state_id: "21",
        },
        {
          id: "2242",
          name: "Jawad",
          state_id: "21",
        },
        {
          id: "2243",
          name: "Jawar",
          state_id: "21",
        },
        {
          id: "2244",
          name: "Jeronkhalsa",
          state_id: "21",
        },
        {
          id: "2245",
          name: "Jhabua",
          state_id: "21",
        },
        {
          id: "2246",
          name: "Jhundpura",
          state_id: "21",
        },
        {
          id: "2247",
          name: "Jiran",
          state_id: "21",
        },
        {
          id: "2248",
          name: "Jirapur",
          state_id: "21",
        },
        {
          id: "2249",
          name: "Jobat",
          state_id: "21",
        },
        {
          id: "2250",
          name: "Joura",
          state_id: "21",
        },
        {
          id: "2251",
          name: "Kailaras",
          state_id: "21",
        },
        {
          id: "2252",
          name: "Kaimur",
          state_id: "21",
        },
        {
          id: "2253",
          name: "Kakarhati",
          state_id: "21",
        },
        {
          id: "2254",
          name: "Kalichhapar",
          state_id: "21",
        },
        {
          id: "2255",
          name: "Kanad",
          state_id: "21",
        },
        {
          id: "2256",
          name: "Kannod",
          state_id: "21",
        },
        {
          id: "2257",
          name: "Kantaphod",
          state_id: "21",
        },
        {
          id: "2258",
          name: "Kareli",
          state_id: "21",
        },
        {
          id: "2259",
          name: "Karera",
          state_id: "21",
        },
        {
          id: "2260",
          name: "Kari",
          state_id: "21",
        },
        {
          id: "2261",
          name: "Karnawad",
          state_id: "21",
        },
        {
          id: "2262",
          name: "Karrapur",
          state_id: "21",
        },
        {
          id: "2263",
          name: "Kasrawad",
          state_id: "21",
        },
        {
          id: "2264",
          name: "Katangi",
          state_id: "21",
        },
        {
          id: "2265",
          name: "Katni",
          state_id: "21",
        },
        {
          id: "2266",
          name: "Kelhauri",
          state_id: "21",
        },
        {
          id: "2267",
          name: "Khachrod",
          state_id: "21",
        },
        {
          id: "2268",
          name: "Khajuraho",
          state_id: "21",
        },
        {
          id: "2269",
          name: "Khamaria",
          state_id: "21",
        },
        {
          id: "2270",
          name: "Khand",
          state_id: "21",
        },
        {
          id: "2271",
          name: "Khandwa",
          state_id: "21",
        },
        {
          id: "2272",
          name: "Khaniyadhana",
          state_id: "21",
        },
        {
          id: "2273",
          name: "Khargapur",
          state_id: "21",
        },
        {
          id: "2274",
          name: "Khargone",
          state_id: "21",
        },
        {
          id: "2275",
          name: "Khategaon",
          state_id: "21",
        },
        {
          id: "2276",
          name: "Khetia",
          state_id: "21",
        },
        {
          id: "2277",
          name: "Khilchipur",
          state_id: "21",
        },
        {
          id: "2278",
          name: "Khirkiya",
          state_id: "21",
        },
        {
          id: "2279",
          name: "Khujner",
          state_id: "21",
        },
        {
          id: "2280",
          name: "Khurai",
          state_id: "21",
        },
        {
          id: "2281",
          name: "Kolaras",
          state_id: "21",
        },
        {
          id: "2282",
          name: "Kotar",
          state_id: "21",
        },
        {
          id: "2283",
          name: "Kothi",
          state_id: "21",
        },
        {
          id: "2284",
          name: "Kotma",
          state_id: "21",
        },
        {
          id: "2285",
          name: "Kukshi",
          state_id: "21",
        },
        {
          id: "2286",
          name: "Kumbhraj",
          state_id: "21",
        },
        {
          id: "2287",
          name: "Kurwai",
          state_id: "21",
        },
        {
          id: "2288",
          name: "Lahar",
          state_id: "21",
        },
        {
          id: "2289",
          name: "Lakhnadon",
          state_id: "21",
        },
        {
          id: "2290",
          name: "Lateri",
          state_id: "21",
        },
        {
          id: "2291",
          name: "Laundi",
          state_id: "21",
        },
        {
          id: "2292",
          name: "Lidhora Khas",
          state_id: "21",
        },
        {
          id: "2293",
          name: "Lodhikheda",
          state_id: "21",
        },
        {
          id: "2294",
          name: "Loharda",
          state_id: "21",
        },
        {
          id: "2295",
          name: "Machalpur",
          state_id: "21",
        },
        {
          id: "2296",
          name: "Madhogarh",
          state_id: "21",
        },
        {
          id: "2297",
          name: "Maharajpur",
          state_id: "21",
        },
        {
          id: "2298",
          name: "Maheshwar",
          state_id: "21",
        },
        {
          id: "2299",
          name: "Mahidpur",
          state_id: "21",
        },
        {
          id: "2300",
          name: "Maihar",
          state_id: "21",
        },
        {
          id: "2301",
          name: "Majholi",
          state_id: "21",
        },
        {
          id: "2302",
          name: "Makronia",
          state_id: "21",
        },
        {
          id: "2303",
          name: "Maksi",
          state_id: "21",
        },
        {
          id: "2304",
          name: "Malaj Khand",
          state_id: "21",
        },
        {
          id: "2305",
          name: "Malanpur",
          state_id: "21",
        },
        {
          id: "2306",
          name: "Malhargarh",
          state_id: "21",
        },
        {
          id: "2307",
          name: "Manasa",
          state_id: "21",
        },
        {
          id: "2308",
          name: "Manawar",
          state_id: "21",
        },
        {
          id: "2309",
          name: "Mandav",
          state_id: "21",
        },
        {
          id: "2310",
          name: "Mandideep",
          state_id: "21",
        },
        {
          id: "2311",
          name: "Mandla",
          state_id: "21",
        },
        {
          id: "2312",
          name: "Mandleshwar",
          state_id: "21",
        },
        {
          id: "2313",
          name: "Mandsaur",
          state_id: "21",
        },
        {
          id: "2314",
          name: "Manegaon",
          state_id: "21",
        },
        {
          id: "2315",
          name: "Mangawan",
          state_id: "21",
        },
        {
          id: "2316",
          name: "Manglaya Sadak",
          state_id: "21",
        },
        {
          id: "2317",
          name: "Manpur",
          state_id: "21",
        },
        {
          id: "2318",
          name: "Mau",
          state_id: "21",
        },
        {
          id: "2319",
          name: "Mauganj",
          state_id: "21",
        },
        {
          id: "2320",
          name: "Meghnagar",
          state_id: "21",
        },
        {
          id: "2322",
          name: "Mehgaon",
          state_id: "21",
        },
        {
          id: "2323",
          name: "Mhaugaon",
          state_id: "21",
        },
        {
          id: "2324",
          name: "Mhow",
          state_id: "21",
        },
        {
          id: "2325",
          name: "Mihona",
          state_id: "21",
        },
        {
          id: "2326",
          name: "Mohgaon",
          state_id: "21",
        },
        {
          id: "2327",
          name: "Morar",
          state_id: "21",
        },
        {
          id: "2328",
          name: "Morena",
          state_id: "21",
        },
        {
          id: "2329",
          name: "Morwa",
          state_id: "21",
        },
        {
          id: "2330",
          name: "Multai",
          state_id: "21",
        },
        {
          id: "2331",
          name: "Mundi",
          state_id: "21",
        },
        {
          id: "2332",
          name: "Mungaoli",
          state_id: "21",
        },
        {
          id: "2333",
          name: "Murwara",
          state_id: "21",
        },
        {
          id: "2334",
          name: "Nagda",
          state_id: "21",
        },
        {
          id: "2335",
          name: "Nagod",
          state_id: "21",
        },
        {
          id: "2336",
          name: "Nagri",
          state_id: "21",
        },
        {
          id: "2337",
          name: "Naigarhi",
          state_id: "21",
        },
        {
          id: "2338",
          name: "Nainpur",
          state_id: "21",
        },
        {
          id: "2339",
          name: "Nalkheda",
          state_id: "21",
        },
        {
          id: "2340",
          name: "Namli",
          state_id: "21",
        },
        {
          id: "2341",
          name: "Narayangarh",
          state_id: "21",
        },
        {
          id: "2342",
          name: "Narsimhapur",
          state_id: "21",
        },
        {
          id: "2343",
          name: "Narsingarh",
          state_id: "21",
        },
        {
          id: "2344",
          name: "Narsinghpur",
          state_id: "21",
        },
        {
          id: "2345",
          name: "Narwar",
          state_id: "21",
        },
        {
          id: "2346",
          name: "Nasrullaganj",
          state_id: "21",
        },
        {
          id: "2347",
          name: "Naudhia",
          state_id: "21",
        },
        {
          id: "2348",
          name: "Naugaon",
          state_id: "21",
        },
        {
          id: "2349",
          name: "Naurozabad",
          state_id: "21",
        },
        {
          id: "2350",
          name: "Neemuch",
          state_id: "21",
        },
        {
          id: "2351",
          name: "Nepa Nagar",
          state_id: "21",
        },
        {
          id: "2352",
          name: "Neuton Chikhli Kalan",
          state_id: "21",
        },
        {
          id: "2353",
          name: "Nimach",
          state_id: "21",
        },
        {
          id: "2354",
          name: "Niwari",
          state_id: "21",
        },
        {
          id: "2355",
          name: "Obedullaganj",
          state_id: "21",
        },
        {
          id: "2356",
          name: "Omkareshwar",
          state_id: "21",
        },
        {
          id: "2357",
          name: "Orachha",
          state_id: "21",
        },
        {
          id: "2358",
          name: "Ordinance Factory Itarsi",
          state_id: "21",
        },
        {
          id: "2359",
          name: "Pachmarhi",
          state_id: "21",
        },
        {
          id: "2360",
          name: "Pachmarhi Cantonment",
          state_id: "21",
        },
        {
          id: "2361",
          name: "Pachore",
          state_id: "21",
        },
        {
          id: "2362",
          name: "Palchorai",
          state_id: "21",
        },
        {
          id: "2363",
          name: "Palda",
          state_id: "21",
        },
        {
          id: "2364",
          name: "Palera",
          state_id: "21",
        },
        {
          id: "2365",
          name: "Pali",
          state_id: "21",
        },
        {
          id: "2366",
          name: "Panagar",
          state_id: "21",
        },
        {
          id: "2367",
          name: "Panara",
          state_id: "21",
        },
        {
          id: "2368",
          name: "Pandaria",
          state_id: "21",
        },
        {
          id: "2369",
          name: "Pandhana",
          state_id: "21",
        },
        {
          id: "2370",
          name: "Pandhurna",
          state_id: "21",
        },
        {
          id: "2371",
          name: "Panna",
          state_id: "21",
        },
        {
          id: "2372",
          name: "Pansemal",
          state_id: "21",
        },
        {
          id: "2373",
          name: "Parasia",
          state_id: "21",
        },
        {
          id: "2374",
          name: "Pasan",
          state_id: "21",
        },
        {
          id: "2375",
          name: "Patan",
          state_id: "21",
        },
        {
          id: "2376",
          name: "Patharia",
          state_id: "21",
        },
        {
          id: "2377",
          name: "Pawai",
          state_id: "21",
        },
        {
          id: "2378",
          name: "Petlawad",
          state_id: "21",
        },
        {
          id: "2379",
          name: "Phuph Kalan",
          state_id: "21",
        },
        {
          id: "2380",
          name: "Pichhore",
          state_id: "21",
        },
        {
          id: "2381",
          name: "Pipariya",
          state_id: "21",
        },
        {
          id: "2382",
          name: "Pipliya Mandi",
          state_id: "21",
        },
        {
          id: "2383",
          name: "Piploda",
          state_id: "21",
        },
        {
          id: "2384",
          name: "Pithampur",
          state_id: "21",
        },
        {
          id: "2385",
          name: "Polay Kalan",
          state_id: "21",
        },
        {
          id: "2386",
          name: "Porsa",
          state_id: "21",
        },
        {
          id: "2387",
          name: "Prithvipur",
          state_id: "21",
        },
        {
          id: "2388",
          name: "Raghogarh",
          state_id: "21",
        },
        {
          id: "2389",
          name: "Rahatgarh",
          state_id: "21",
        },
        {
          id: "2390",
          name: "Raisen",
          state_id: "21",
        },
        {
          id: "2391",
          name: "Rajakhedi",
          state_id: "21",
        },
        {
          id: "2392",
          name: "Rajgarh",
          state_id: "21",
        },
        {
          id: "2393",
          name: "Rajnagar",
          state_id: "21",
        },
        {
          id: "2394",
          name: "Rajpur",
          state_id: "21",
        },
        {
          id: "2395",
          name: "Rampur Baghelan",
          state_id: "21",
        },
        {
          id: "2396",
          name: "Rampur Naikin",
          state_id: "21",
        },
        {
          id: "2397",
          name: "Rampura",
          state_id: "21",
        },
        {
          id: "2398",
          name: "Ranapur",
          state_id: "21",
        },
        {
          id: "2399",
          name: "Ranipura",
          state_id: "21",
        },
        {
          id: "2400",
          name: "Ratangarh",
          state_id: "21",
        },
        {
          id: "2401",
          name: "Ratlam",
          state_id: "21",
        },
        {
          id: "2402",
          name: "Ratlam Kasba",
          state_id: "21",
        },
        {
          id: "2403",
          name: "Rau",
          state_id: "21",
        },
        {
          id: "2404",
          name: "Rehli",
          state_id: "21",
        },
        {
          id: "2405",
          name: "Rehti",
          state_id: "21",
        },
        {
          id: "2406",
          name: "Rewa",
          state_id: "21",
        },
        {
          id: "2407",
          name: "Sabalgarh",
          state_id: "21",
        },
        {
          id: "2408",
          name: "Sagar",
          state_id: "21",
        },
        {
          id: "2409",
          name: "Sagar Cantonment",
          state_id: "21",
        },
        {
          id: "2410",
          name: "Sailana",
          state_id: "21",
        },
        {
          id: "2411",
          name: "Sanawad",
          state_id: "21",
        },
        {
          id: "2412",
          name: "Sanchi",
          state_id: "21",
        },
        {
          id: "2413",
          name: "Sanwer",
          state_id: "21",
        },
        {
          id: "2414",
          name: "Sarangpur",
          state_id: "21",
        },
        {
          id: "2415",
          name: "Sardarpur",
          state_id: "21",
        },
        {
          id: "2416",
          name: "Sarni",
          state_id: "21",
        },
        {
          id: "2417",
          name: "Satai",
          state_id: "21",
        },
        {
          id: "2418",
          name: "Satna",
          state_id: "21",
        },
        {
          id: "2419",
          name: "Satwas",
          state_id: "21",
        },
        {
          id: "2420",
          name: "Sausar",
          state_id: "21",
        },
        {
          id: "2421",
          name: "Sehore",
          state_id: "21",
        },
        {
          id: "2422",
          name: "Semaria",
          state_id: "21",
        },
        {
          id: "2423",
          name: "Sendhwa",
          state_id: "21",
        },
        {
          id: "2424",
          name: "Seondha",
          state_id: "21",
        },
        {
          id: "2425",
          name: "Seoni",
          state_id: "21",
        },
        {
          id: "2426",
          name: "Seoni Malwa",
          state_id: "21",
        },
        {
          id: "2427",
          name: "Sethia",
          state_id: "21",
        },
        {
          id: "2428",
          name: "Shahdol",
          state_id: "21",
        },
        {
          id: "2429",
          name: "Shahgarh",
          state_id: "21",
        },
        {
          id: "2430",
          name: "Shahpur",
          state_id: "21",
        },
        {
          id: "2431",
          name: "Shahpura",
          state_id: "21",
        },
        {
          id: "2432",
          name: "Shajapur",
          state_id: "21",
        },
        {
          id: "2433",
          name: "Shamgarh",
          state_id: "21",
        },
        {
          id: "2434",
          name: "Sheopur",
          state_id: "21",
        },
        {
          id: "2435",
          name: "Shivpuri",
          state_id: "21",
        },
        {
          id: "2436",
          name: "Shujalpur",
          state_id: "21",
        },
        {
          id: "2437",
          name: "Sidhi",
          state_id: "21",
        },
        {
          id: "2438",
          name: "Sihora",
          state_id: "21",
        },
        {
          id: "2439",
          name: "Singolo",
          state_id: "21",
        },
        {
          id: "2440",
          name: "Singrauli",
          state_id: "21",
        },
        {
          id: "2441",
          name: "Sinhasa",
          state_id: "21",
        },
        {
          id: "2442",
          name: "Sirgora",
          state_id: "21",
        },
        {
          id: "2443",
          name: "Sirmaur",
          state_id: "21",
        },
        {
          id: "2444",
          name: "Sironj",
          state_id: "21",
        },
        {
          id: "2445",
          name: "Sitamau",
          state_id: "21",
        },
        {
          id: "2446",
          name: "Sohagpur",
          state_id: "21",
        },
        {
          id: "2447",
          name: "Sonkatch",
          state_id: "21",
        },
        {
          id: "2448",
          name: "Soyatkalan",
          state_id: "21",
        },
        {
          id: "2449",
          name: "Suhagi",
          state_id: "21",
        },
        {
          id: "2450",
          name: "Sultanpur",
          state_id: "21",
        },
        {
          id: "2451",
          name: "Susner",
          state_id: "21",
        },
        {
          id: "2452",
          name: "Suthaliya",
          state_id: "21",
        },
        {
          id: "2453",
          name: "Tal",
          state_id: "21",
        },
        {
          id: "2454",
          name: "Talen",
          state_id: "21",
        },
        {
          id: "2455",
          name: "Tarana",
          state_id: "21",
        },
        {
          id: "2456",
          name: "Taricharkalan",
          state_id: "21",
        },
        {
          id: "2457",
          name: "Tekanpur",
          state_id: "21",
        },
        {
          id: "2458",
          name: "Tendukheda",
          state_id: "21",
        },
        {
          id: "2459",
          name: "Teonthar",
          state_id: "21",
        },
        {
          id: "2460",
          name: "Thandia",
          state_id: "21",
        },
        {
          id: "2461",
          name: "Tikamgarh",
          state_id: "21",
        },
        {
          id: "2462",
          name: "Timarni",
          state_id: "21",
        },
        {
          id: "2463",
          name: "Tirodi",
          state_id: "21",
        },
        {
          id: "2464",
          name: "Udaipura",
          state_id: "21",
        },
        {
          id: "2465",
          name: "Ujjain",
          state_id: "21",
        },
        {
          id: "2466",
          name: "Ukwa",
          state_id: "21",
        },
        {
          id: "2467",
          name: "Umaria",
          state_id: "21",
        },
        {
          id: "2468",
          name: "Unchahara",
          state_id: "21",
        },
        {
          id: "2469",
          name: "Unhel",
          state_id: "21",
        },
        {
          id: "2470",
          name: "Vehicle Factory Jabalpur",
          state_id: "21",
        },
        {
          id: "2471",
          name: "Vidisha",
          state_id: "21",
        },
        {
          id: "2472",
          name: "Vijayraghavgarh",
          state_id: "21",
        },
        {
          id: "2473",
          name: "Waraseoni",
          state_id: "21",
        },
      ],
      Maharashtra: [
        {
          id: "2474",
          name: "Achalpur",
          state_id: "22",
        },
        {
          id: "2475",
          name: "Aheri",
          state_id: "22",
        },
        {
          id: "2476",
          name: "Ahmadnagar Cantonment",
          state_id: "22",
        },
        {
          id: "2477",
          name: "Ahmadpur",
          state_id: "22",
        },
        {
          id: "2478",
          name: "Ahmednagar",
          state_id: "22",
        },
        {
          id: "2479",
          name: "Ajra",
          state_id: "22",
        },
        {
          id: "2480",
          name: "Akalkot",
          state_id: "22",
        },
        {
          id: "2481",
          name: "Akkalkuwa",
          state_id: "22",
        },
        {
          id: "2482",
          name: "Akola",
          state_id: "22",
        },
        {
          id: "2483",
          name: "Akot",
          state_id: "22",
        },
        {
          id: "2484",
          name: "Alandi",
          state_id: "22",
        },
        {
          id: "2485",
          name: "Alibag",
          state_id: "22",
        },
        {
          id: "2486",
          name: "Allapalli",
          state_id: "22",
        },
        {
          id: "2487",
          name: "Alore",
          state_id: "22",
        },
        {
          id: "2488",
          name: "Amalner",
          state_id: "22",
        },
        {
          id: "2489",
          name: "Ambad",
          state_id: "22",
        },
        {
          id: "2490",
          name: "Ambajogai",
          state_id: "22",
        },
        {
          id: "2491",
          name: "Ambernath",
          state_id: "22",
        },
        {
          id: "2492",
          name: "Ambivali Tarf Wankhal",
          state_id: "22",
        },
        {
          id: "2493",
          name: "Amgaon",
          state_id: "22",
        },
        {
          id: "2494",
          name: "Amravati",
          state_id: "22",
        },
        {
          id: "2495",
          name: "Anjangaon",
          state_id: "22",
        },
        {
          id: "2496",
          name: "Arvi",
          state_id: "22",
        },
        {
          id: "2497",
          name: "Ashta",
          state_id: "22",
        },
        {
          id: "2498",
          name: "Ashti",
          state_id: "22",
        },
        {
          id: "2499",
          name: "Aurangabad",
          state_id: "22",
        },
        {
          id: "2500",
          name: "Aurangabad Cantonment",
          state_id: "22",
        },
        {
          id: "2501",
          name: "Ausa",
          state_id: "22",
        },
        {
          id: "2502",
          name: "Babhulgaon",
          state_id: "22",
        },
        {
          id: "2503",
          name: "Badlapur",
          state_id: "22",
        },
        {
          id: "2504",
          name: "Balapur",
          state_id: "22",
        },
        {
          id: "2505",
          name: "Ballarpur",
          state_id: "22",
        },
        {
          id: "2506",
          name: "Baramati",
          state_id: "22",
        },
        {
          id: "2507",
          name: "Barshi",
          state_id: "22",
        },
        {
          id: "2508",
          name: "Basmat",
          state_id: "22",
        },
        {
          id: "2509",
          name: "Beed",
          state_id: "22",
        },
        {
          id: "2510",
          name: "Bhadravati",
          state_id: "22",
        },
        {
          id: "2511",
          name: "Bhagur",
          state_id: "22",
        },
        {
          id: "2512",
          name: "Bhandara",
          state_id: "22",
        },
        {
          id: "2513",
          name: "Bhigvan",
          state_id: "22",
        },
        {
          id: "2514",
          name: "Bhingar",
          state_id: "22",
        },
        {
          id: "2515",
          name: "Bhiwandi",
          state_id: "22",
        },
        {
          id: "2516",
          name: "Bhokhardan",
          state_id: "22",
        },
        {
          id: "2517",
          name: "Bhor",
          state_id: "22",
        },
        {
          id: "2518",
          name: "Bhosari",
          state_id: "22",
        },
        {
          id: "2519",
          name: "Bhum",
          state_id: "22",
        },
        {
          id: "2520",
          name: "Bhusawal",
          state_id: "22",
        },
        {
          id: "2521",
          name: "Bid",
          state_id: "22",
        },
        {
          id: "2522",
          name: "Biloli",
          state_id: "22",
        },
        {
          id: "2523",
          name: "Birwadi",
          state_id: "22",
        },
        {
          id: "2524",
          name: "Boisar",
          state_id: "22",
        },
        {
          id: "2525",
          name: "Bop Khel",
          state_id: "22",
        },
        {
          id: "2526",
          name: "Brahmapuri",
          state_id: "22",
        },
        {
          id: "2527",
          name: "Budhgaon",
          state_id: "22",
        },
        {
          id: "2528",
          name: "Buldana",
          state_id: "22",
        },
        {
          id: "2529",
          name: "Buldhana",
          state_id: "22",
        },
        {
          id: "2530",
          name: "Butibori",
          state_id: "22",
        },
        {
          id: "2531",
          name: "Chakan",
          state_id: "22",
        },
        {
          id: "2532",
          name: "Chalisgaon",
          state_id: "22",
        },
        {
          id: "2533",
          name: "Chandrapur",
          state_id: "22",
        },
        {
          id: "2534",
          name: "Chandur",
          state_id: "22",
        },
        {
          id: "2535",
          name: "Chandur Bazar",
          state_id: "22",
        },
        {
          id: "2536",
          name: "Chandvad",
          state_id: "22",
        },
        {
          id: "2537",
          name: "Chicholi",
          state_id: "22",
        },
        {
          id: "2538",
          name: "Chikhala",
          state_id: "22",
        },
        {
          id: "2539",
          name: "Chikhaldara",
          state_id: "22",
        },
        {
          id: "2540",
          name: "Chikhli",
          state_id: "22",
        },
        {
          id: "2541",
          name: "Chinchani",
          state_id: "22",
        },
        {
          id: "2542",
          name: "Chinchwad",
          state_id: "22",
        },
        {
          id: "2543",
          name: "Chiplun",
          state_id: "22",
        },
        {
          id: "2544",
          name: "Chopda",
          state_id: "22",
        },
        {
          id: "2545",
          name: "Dabhol",
          state_id: "22",
        },
        {
          id: "2546",
          name: "Dahance",
          state_id: "22",
        },
        {
          id: "2547",
          name: "Dahanu",
          state_id: "22",
        },
        {
          id: "2548",
          name: "Daharu",
          state_id: "22",
        },
        {
          id: "2549",
          name: "Dapoli Camp",
          state_id: "22",
        },
        {
          id: "2550",
          name: "Darwa",
          state_id: "22",
        },
        {
          id: "2551",
          name: "Daryapur",
          state_id: "22",
        },
        {
          id: "2552",
          name: "Dattapur",
          state_id: "22",
        },
        {
          id: "2553",
          name: "Daund",
          state_id: "22",
        },
        {
          id: "2554",
          name: "Davlameti",
          state_id: "22",
        },
        {
          id: "2555",
          name: "Deglur",
          state_id: "22",
        },
        {
          id: "2556",
          name: "Dehu Road",
          state_id: "22",
        },
        {
          id: "2557",
          name: "Deolali",
          state_id: "22",
        },
        {
          id: "2558",
          name: "Deolali Pravara",
          state_id: "22",
        },
        {
          id: "2559",
          name: "Deoli",
          state_id: "22",
        },
        {
          id: "2560",
          name: "Desaiganj",
          state_id: "22",
        },
        {
          id: "2561",
          name: "Deulgaon Raja",
          state_id: "22",
        },
        {
          id: "2562",
          name: "Dewhadi",
          state_id: "22",
        },
        {
          id: "2563",
          name: "Dharangaon",
          state_id: "22",
        },
        {
          id: "2564",
          name: "Dharmabad",
          state_id: "22",
        },
        {
          id: "2565",
          name: "Dharur",
          state_id: "22",
        },
        {
          id: "2566",
          name: "Dhatau",
          state_id: "22",
        },
        {
          id: "2567",
          name: "Dhule",
          state_id: "22",
        },
        {
          id: "2568",
          name: "Digdoh",
          state_id: "22",
        },
        {
          id: "2569",
          name: "Diglur",
          state_id: "22",
        },
        {
          id: "2570",
          name: "Digras",
          state_id: "22",
        },
        {
          id: "2571",
          name: "Dombivli",
          state_id: "22",
        },
        {
          id: "2572",
          name: "Dondaicha",
          state_id: "22",
        },
        {
          id: "2573",
          name: "Dudhani",
          state_id: "22",
        },
        {
          id: "2574",
          name: "Durgapur",
          state_id: "22",
        },
        {
          id: "2575",
          name: "Dyane",
          state_id: "22",
        },
        {
          id: "2576",
          name: "Edandol",
          state_id: "22",
        },
        {
          id: "2577",
          name: "Eklahare",
          state_id: "22",
        },
        {
          id: "2578",
          name: "Faizpur",
          state_id: "22",
        },
        {
          id: "2579",
          name: "Fekari",
          state_id: "22",
        },
        {
          id: "2580",
          name: "Gadchiroli",
          state_id: "22",
        },
        {
          id: "2581",
          name: "Gadhinghaj",
          state_id: "22",
        },
        {
          id: "2582",
          name: "Gandhi Nagar",
          state_id: "22",
        },
        {
          id: "2583",
          name: "Ganeshpur",
          state_id: "22",
        },
        {
          id: "2584",
          name: "Gangakher",
          state_id: "22",
        },
        {
          id: "2585",
          name: "Gangapur",
          state_id: "22",
        },
        {
          id: "2586",
          name: "Gevrai",
          state_id: "22",
        },
        {
          id: "2587",
          name: "Ghatanji",
          state_id: "22",
        },
        {
          id: "2588",
          name: "Ghoti",
          state_id: "22",
        },
        {
          id: "2589",
          name: "Ghugus",
          state_id: "22",
        },
        {
          id: "2590",
          name: "Ghulewadi",
          state_id: "22",
        },
        {
          id: "2591",
          name: "Godoli",
          state_id: "22",
        },
        {
          id: "2592",
          name: "Gondia",
          state_id: "22",
        },
        {
          id: "2593",
          name: "Guhagar",
          state_id: "22",
        },
        {
          id: "2594",
          name: "Hadgaon",
          state_id: "22",
        },
        {
          id: "2595",
          name: "Harnai Beach",
          state_id: "22",
        },
        {
          id: "2596",
          name: "Hinganghat",
          state_id: "22",
        },
        {
          id: "2597",
          name: "Hingoli",
          state_id: "22",
        },
        {
          id: "2598",
          name: "Hupari",
          state_id: "22",
        },
        {
          id: "2599",
          name: "Ichalkaranji",
          state_id: "22",
        },
        {
          id: "2600",
          name: "Igatpuri",
          state_id: "22",
        },
        {
          id: "2601",
          name: "Indapur",
          state_id: "22",
        },
        {
          id: "2602",
          name: "Jaisinghpur",
          state_id: "22",
        },
        {
          id: "2603",
          name: "Jalgaon",
          state_id: "22",
        },
        {
          id: "2604",
          name: "Jalna",
          state_id: "22",
        },
        {
          id: "2605",
          name: "Jamkhed",
          state_id: "22",
        },
        {
          id: "2606",
          name: "Jawhar",
          state_id: "22",
        },
        {
          id: "2607",
          name: "Jaysingpur",
          state_id: "22",
        },
        {
          id: "2608",
          name: "Jejuri",
          state_id: "22",
        },
        {
          id: "2609",
          name: "Jintur",
          state_id: "22",
        },
        {
          id: "2610",
          name: "Junnar",
          state_id: "22",
        },
        {
          id: "2611",
          name: "Kabnur",
          state_id: "22",
        },
        {
          id: "2612",
          name: "Kagal",
          state_id: "22",
        },
        {
          id: "2613",
          name: "Kalamb",
          state_id: "22",
        },
        {
          id: "2614",
          name: "Kalamnuri",
          state_id: "22",
        },
        {
          id: "2615",
          name: "Kalas",
          state_id: "22",
        },
        {
          id: "2616",
          name: "Kalmeshwar",
          state_id: "22",
        },
        {
          id: "2617",
          name: "Kalundre",
          state_id: "22",
        },
        {
          id: "2618",
          name: "Kalyan",
          state_id: "22",
        },
        {
          id: "2619",
          name: "Kamthi",
          state_id: "22",
        },
        {
          id: "2620",
          name: "Kamthi Cantonment",
          state_id: "22",
        },
        {
          id: "2621",
          name: "Kandari",
          state_id: "22",
        },
        {
          id: "2622",
          name: "Kandhar",
          state_id: "22",
        },
        {
          id: "2623",
          name: "Kandri",
          state_id: "22",
        },
        {
          id: "2624",
          name: "Kandri II",
          state_id: "22",
        },
        {
          id: "2625",
          name: "Kanhan",
          state_id: "22",
        },
        {
          id: "2626",
          name: "Kankavli",
          state_id: "22",
        },
        {
          id: "2627",
          name: "Kannad",
          state_id: "22",
        },
        {
          id: "2628",
          name: "Karad",
          state_id: "22",
        },
        {
          id: "2629",
          name: "Karanja",
          state_id: "22",
        },
        {
          id: "2630",
          name: "Karanje Tarf",
          state_id: "22",
        },
        {
          id: "2631",
          name: "Karivali",
          state_id: "22",
        },
        {
          id: "2632",
          name: "Karjat",
          state_id: "22",
        },
        {
          id: "2633",
          name: "Karmala",
          state_id: "22",
        },
        {
          id: "2634",
          name: "Kasara Budruk",
          state_id: "22",
        },
        {
          id: "2635",
          name: "Katai",
          state_id: "22",
        },
        {
          id: "2636",
          name: "Katkar",
          state_id: "22",
        },
        {
          id: "2637",
          name: "Katol",
          state_id: "22",
        },
        {
          id: "2638",
          name: "Kegaon",
          state_id: "22",
        },
        {
          id: "2639",
          name: "Khadkale",
          state_id: "22",
        },
        {
          id: "2640",
          name: "Khadki",
          state_id: "22",
        },
        {
          id: "2641",
          name: "Khamgaon",
          state_id: "22",
        },
        {
          id: "2642",
          name: "Khapa",
          state_id: "22",
        },
        {
          id: "2643",
          name: "Kharadi",
          state_id: "22",
        },
        {
          id: "2644",
          name: "Kharakvasla",
          state_id: "22",
        },
        {
          id: "2645",
          name: "Khed",
          state_id: "22",
        },
        {
          id: "2646",
          name: "Kherdi",
          state_id: "22",
        },
        {
          id: "2647",
          name: "Khoni",
          state_id: "22",
        },
        {
          id: "2648",
          name: "Khopoli",
          state_id: "22",
        },
        {
          id: "2649",
          name: "Khuldabad",
          state_id: "22",
        },
        {
          id: "2650",
          name: "Kinwat",
          state_id: "22",
        },
        {
          id: "2651",
          name: "Kodoli",
          state_id: "22",
        },
        {
          id: "2652",
          name: "Kolhapur",
          state_id: "22",
        },
        {
          id: "2653",
          name: "Kon",
          state_id: "22",
        },
        {
          id: "2654",
          name: "Kondumal",
          state_id: "22",
        },
        {
          id: "2655",
          name: "Kopargaon",
          state_id: "22",
        },
        {
          id: "2656",
          name: "Kopharad",
          state_id: "22",
        },
        {
          id: "2657",
          name: "Koradi",
          state_id: "22",
        },
        {
          id: "2658",
          name: "Koregaon",
          state_id: "22",
        },
        {
          id: "2659",
          name: "Korochi",
          state_id: "22",
        },
        {
          id: "2660",
          name: "Kudal",
          state_id: "22",
        },
        {
          id: "2661",
          name: "Kundaim",
          state_id: "22",
        },
        {
          id: "2662",
          name: "Kundalwadi",
          state_id: "22",
        },
        {
          id: "2663",
          name: "Kurandvad",
          state_id: "22",
        },
        {
          id: "2664",
          name: "Kurduvadi",
          state_id: "22",
        },
        {
          id: "2665",
          name: "Kusgaon Budruk",
          state_id: "22",
        },
        {
          id: "2666",
          name: "Lanja",
          state_id: "22",
        },
        {
          id: "2667",
          name: "Lasalgaon",
          state_id: "22",
        },
        {
          id: "2668",
          name: "Latur",
          state_id: "22",
        },
        {
          id: "2669",
          name: "Loha",
          state_id: "22",
        },
        {
          id: "2670",
          name: "Lohegaon",
          state_id: "22",
        },
        {
          id: "2671",
          name: "Lonar",
          state_id: "22",
        },
        {
          id: "2672",
          name: "Lonavala",
          state_id: "22",
        },
        {
          id: "2673",
          name: "Madhavnagar",
          state_id: "22",
        },
        {
          id: "2674",
          name: "Mahabaleshwar",
          state_id: "22",
        },
        {
          id: "2675",
          name: "Mahad",
          state_id: "22",
        },
        {
          id: "2676",
          name: "Mahadula",
          state_id: "22",
        },
        {
          id: "2677",
          name: "Maindargi",
          state_id: "22",
        },
        {
          id: "2678",
          name: "Majalgaon",
          state_id: "22",
        },
        {
          id: "2679",
          name: "Malegaon",
          state_id: "22",
        },
        {
          id: "2680",
          name: "Malgaon",
          state_id: "22",
        },
        {
          id: "2681",
          name: "Malkapur",
          state_id: "22",
        },
        {
          id: "2682",
          name: "Malwan",
          state_id: "22",
        },
        {
          id: "2683",
          name: "Manadur",
          state_id: "22",
        },
        {
          id: "2684",
          name: "Manchar",
          state_id: "22",
        },
        {
          id: "2685",
          name: "Mangalvedhe",
          state_id: "22",
        },
        {
          id: "2686",
          name: "Mangrul Pir",
          state_id: "22",
        },
        {
          id: "2687",
          name: "Manmad",
          state_id: "22",
        },
        {
          id: "2688",
          name: "Manor",
          state_id: "22",
        },
        {
          id: "2689",
          name: "Mansar",
          state_id: "22",
        },
        {
          id: "2690",
          name: "Manwath",
          state_id: "22",
        },
        {
          id: "2691",
          name: "Mapuca",
          state_id: "22",
        },
        {
          id: "2692",
          name: "Matheran",
          state_id: "22",
        },
        {
          id: "2693",
          name: "Mehkar",
          state_id: "22",
        },
        {
          id: "2694",
          name: "Mhasla",
          state_id: "22",
        },
        {
          id: "2695",
          name: "Mhaswad",
          state_id: "22",
        },
        {
          id: "2696",
          name: "Mira Bhayandar",
          state_id: "22",
        },
        {
          id: "2697",
          name: "Miraj",
          state_id: "22",
        },
        {
          id: "2698",
          name: "Mohpa",
          state_id: "22",
        },
        {
          id: "2699",
          name: "Mohpada",
          state_id: "22",
        },
        {
          id: "2700",
          name: "Moram",
          state_id: "22",
        },
        {
          id: "2701",
          name: "Morshi",
          state_id: "22",
        },
        {
          id: "2702",
          name: "Mowad",
          state_id: "22",
        },
        {
          id: "2703",
          name: "Mudkhed",
          state_id: "22",
        },
        {
          id: "2704",
          name: "Mukhed",
          state_id: "22",
        },
        {
          id: "2705",
          name: "Mul",
          state_id: "22",
        },
        {
          id: "2706",
          name: "Mulshi",
          state_id: "22",
        },
        {
          id: "2707",
          name: "Mumbai",
          state_id: "22",
        },
        {
          id: "2708",
          name: "Murbad",
          state_id: "22",
        },
        {
          id: "2709",
          name: "Murgud",
          state_id: "22",
        },
        {
          id: "2710",
          name: "Murtijapur",
          state_id: "22",
        },
        {
          id: "2711",
          name: "Murud",
          state_id: "22",
        },
        {
          id: "2712",
          name: "Nachane",
          state_id: "22",
        },
        {
          id: "2713",
          name: "Nagardeole",
          state_id: "22",
        },
        {
          id: "2714",
          name: "Nagothane",
          state_id: "22",
        },
        {
          id: "2715",
          name: "Nagpur",
          state_id: "22",
        },
        {
          id: "2716",
          name: "Nakoda",
          state_id: "22",
        },
        {
          id: "2717",
          name: "Nalasopara",
          state_id: "22",
        },
        {
          id: "2718",
          name: "Naldurg",
          state_id: "22",
        },
        {
          id: "2719",
          name: "Nanded",
          state_id: "22",
        },
        {
          id: "2720",
          name: "Nandgaon",
          state_id: "22",
        },
        {
          id: "2721",
          name: "Nandura",
          state_id: "22",
        },
        {
          id: "2722",
          name: "Nandurbar",
          state_id: "22",
        },
        {
          id: "2723",
          name: "Narkhed",
          state_id: "22",
        },
        {
          id: "2724",
          name: "Nashik",
          state_id: "22",
        },
        {
          id: "2725",
          name: "Navapur",
          state_id: "22",
        },
        {
          id: "2726",
          name: "Navi Mumbai",
          state_id: "22",
        },
        {
          id: "2727",
          name: "Navi Mumbai Panvel",
          state_id: "22",
        },
        {
          id: "2728",
          name: "Neral",
          state_id: "22",
        },
        {
          id: "2729",
          name: "Nigdi",
          state_id: "22",
        },
        {
          id: "2730",
          name: "Nilanga",
          state_id: "22",
        },
        {
          id: "2731",
          name: "Nildoh",
          state_id: "22",
        },
        {
          id: "2732",
          name: "Nimbhore",
          state_id: "22",
        },
        {
          id: "2733",
          name: "Ojhar",
          state_id: "22",
        },
        {
          id: "2734",
          name: "Osmanabad",
          state_id: "22",
        },
        {
          id: "2735",
          name: "Pachgaon",
          state_id: "22",
        },
        {
          id: "2736",
          name: "Pachora",
          state_id: "22",
        },
        {
          id: "2737",
          name: "Padagha",
          state_id: "22",
        },
        {
          id: "2738",
          name: "Paithan",
          state_id: "22",
        },
        {
          id: "2739",
          name: "Palghar",
          state_id: "22",
        },
        {
          id: "2740",
          name: "Pali",
          state_id: "22",
        },
        {
          id: "2741",
          name: "Panchgani",
          state_id: "22",
        },
        {
          id: "2742",
          name: "Pandhakarwada",
          state_id: "22",
        },
        {
          id: "2743",
          name: "Pandharpur",
          state_id: "22",
        },
        {
          id: "2744",
          name: "Panhala",
          state_id: "22",
        },
        {
          id: "2745",
          name: "Panvel",
          state_id: "22",
        },
        {
          id: "2746",
          name: "Paranda",
          state_id: "22",
        },
        {
          id: "2747",
          name: "Parbhani",
          state_id: "22",
        },
        {
          id: "2748",
          name: "Parli",
          state_id: "22",
        },
        {
          id: "2749",
          name: "Parola",
          state_id: "22",
        },
        {
          id: "2750",
          name: "Partur",
          state_id: "22",
        },
        {
          id: "2751",
          name: "Pasthal",
          state_id: "22",
        },
        {
          id: "2752",
          name: "Patan",
          state_id: "22",
        },
        {
          id: "2753",
          name: "Pathardi",
          state_id: "22",
        },
        {
          id: "2754",
          name: "Pathri",
          state_id: "22",
        },
        {
          id: "2755",
          name: "Patur",
          state_id: "22",
        },
        {
          id: "2756",
          name: "Pawni",
          state_id: "22",
        },
        {
          id: "2757",
          name: "Pen",
          state_id: "22",
        },
        {
          id: "2758",
          name: "Pethumri",
          state_id: "22",
        },
        {
          id: "2759",
          name: "Phaltan",
          state_id: "22",
        },
        {
          id: "2760",
          name: "Pimpri",
          state_id: "22",
        },
        {
          id: "2761",
          name: "Poladpur",
          state_id: "22",
        },
        {
          id: "2762",
          name: "Pulgaon",
          state_id: "22",
        },
        {
          id: "2763",
          name: "Pune",
          state_id: "22",
        },
        {
          id: "2764",
          name: "Pune Cantonment",
          state_id: "22",
        },
        {
          id: "2765",
          name: "Purna",
          state_id: "22",
        },
        {
          id: "2766",
          name: "Purushottamnagar",
          state_id: "22",
        },
        {
          id: "2767",
          name: "Pusad",
          state_id: "22",
        },
        {
          id: "2768",
          name: "Rahimatpur",
          state_id: "22",
        },
        {
          id: "2769",
          name: "Rahta Pimplas",
          state_id: "22",
        },
        {
          id: "2770",
          name: "Rahuri",
          state_id: "22",
        },
        {
          id: "2771",
          name: "Raigad",
          state_id: "22",
        },
        {
          id: "2772",
          name: "Rajapur",
          state_id: "22",
        },
        {
          id: "2773",
          name: "Rajgurunagar",
          state_id: "22",
        },
        {
          id: "2774",
          name: "Rajur",
          state_id: "22",
        },
        {
          id: "2775",
          name: "Rajura",
          state_id: "22",
        },
        {
          id: "2776",
          name: "Ramtek",
          state_id: "22",
        },
        {
          id: "2777",
          name: "Ratnagiri",
          state_id: "22",
        },
        {
          id: "2778",
          name: "Ravalgaon",
          state_id: "22",
        },
        {
          id: "2779",
          name: "Raver",
          state_id: "22",
        },
        {
          id: "2780",
          name: "Revadanda",
          state_id: "22",
        },
        {
          id: "2781",
          name: "Risod",
          state_id: "22",
        },
        {
          id: "2782",
          name: "Roha Ashtami",
          state_id: "22",
        },
        {
          id: "2783",
          name: "Sakri",
          state_id: "22",
        },
        {
          id: "2784",
          name: "Sandor",
          state_id: "22",
        },
        {
          id: "2785",
          name: "Sangamner",
          state_id: "22",
        },
        {
          id: "2786",
          name: "Sangli",
          state_id: "22",
        },
        {
          id: "2787",
          name: "Sangole",
          state_id: "22",
        },
        {
          id: "2788",
          name: "Sasti",
          state_id: "22",
        },
        {
          id: "2789",
          name: "Sasvad",
          state_id: "22",
        },
        {
          id: "2790",
          name: "Satana",
          state_id: "22",
        },
        {
          id: "2791",
          name: "Satara",
          state_id: "22",
        },
        {
          id: "2792",
          name: "Savantvadi",
          state_id: "22",
        },
        {
          id: "2793",
          name: "Savda",
          state_id: "22",
        },
        {
          id: "2794",
          name: "Savner",
          state_id: "22",
        },
        {
          id: "2795",
          name: "Sawari Jawharnagar",
          state_id: "22",
        },
        {
          id: "2796",
          name: "Selu",
          state_id: "22",
        },
        {
          id: "2797",
          name: "Shahada",
          state_id: "22",
        },
        {
          id: "2798",
          name: "Shahapur",
          state_id: "22",
        },
        {
          id: "2799",
          name: "Shegaon",
          state_id: "22",
        },
        {
          id: "2800",
          name: "Shelar",
          state_id: "22",
        },
        {
          id: "2801",
          name: "Shendurjana",
          state_id: "22",
        },
        {
          id: "2802",
          name: "Shirdi",
          state_id: "22",
        },
        {
          id: "2803",
          name: "Shirgaon",
          state_id: "22",
        },
        {
          id: "2804",
          name: "Shirpur",
          state_id: "22",
        },
        {
          id: "2805",
          name: "Shirur",
          state_id: "22",
        },
        {
          id: "2806",
          name: "Shirwal",
          state_id: "22",
        },
        {
          id: "2807",
          name: "Shivatkar",
          state_id: "22",
        },
        {
          id: "2808",
          name: "Shrigonda",
          state_id: "22",
        },
        {
          id: "2809",
          name: "Shrirampur",
          state_id: "22",
        },
        {
          id: "2810",
          name: "Shrirampur Rural",
          state_id: "22",
        },
        {
          id: "2811",
          name: "Sillewada",
          state_id: "22",
        },
        {
          id: "2812",
          name: "Sillod",
          state_id: "22",
        },
        {
          id: "2813",
          name: "Sindhudurg",
          state_id: "22",
        },
        {
          id: "2814",
          name: "Sindi",
          state_id: "22",
        },
        {
          id: "2815",
          name: "Sindi Turf Hindnagar",
          state_id: "22",
        },
        {
          id: "2816",
          name: "Sindkhed Raja",
          state_id: "22",
        },
        {
          id: "2817",
          name: "Singnapur",
          state_id: "22",
        },
        {
          id: "2818",
          name: "Sinnar",
          state_id: "22",
        },
        {
          id: "2819",
          name: "Sirur",
          state_id: "22",
        },
        {
          id: "2820",
          name: "Sitasawangi",
          state_id: "22",
        },
        {
          id: "2821",
          name: "Solapur",
          state_id: "22",
        },
        {
          id: "2822",
          name: "Sonai",
          state_id: "22",
        },
        {
          id: "2823",
          name: "Sonegaon",
          state_id: "22",
        },
        {
          id: "2824",
          name: "Soyagaon",
          state_id: "22",
        },
        {
          id: "2825",
          name: "Srivardhan",
          state_id: "22",
        },
        {
          id: "2826",
          name: "Surgana",
          state_id: "22",
        },
        {
          id: "2827",
          name: "Talegaon Dabhade",
          state_id: "22",
        },
        {
          id: "2828",
          name: "Taloda",
          state_id: "22",
        },
        {
          id: "2829",
          name: "Taloja",
          state_id: "22",
        },
        {
          id: "2830",
          name: "Talwade",
          state_id: "22",
        },
        {
          id: "2831",
          name: "Tarapur",
          state_id: "22",
        },
        {
          id: "2832",
          name: "Tasgaon",
          state_id: "22",
        },
        {
          id: "2833",
          name: "Tathavade",
          state_id: "22",
        },
        {
          id: "2834",
          name: "Tekadi",
          state_id: "22",
        },
        {
          id: "2835",
          name: "Telhara",
          state_id: "22",
        },
        {
          id: "2836",
          name: "Thane",
          state_id: "22",
        },
        {
          id: "2837",
          name: "Tirira",
          state_id: "22",
        },
        {
          id: "2838",
          name: "Totaladoh",
          state_id: "22",
        },
        {
          id: "2839",
          name: "Trimbak",
          state_id: "22",
        },
        {
          id: "2840",
          name: "Tuljapur",
          state_id: "22",
        },
        {
          id: "2841",
          name: "Tumsar",
          state_id: "22",
        },
        {
          id: "2842",
          name: "Uchgaon",
          state_id: "22",
        },
        {
          id: "2843",
          name: "Udgir",
          state_id: "22",
        },
        {
          id: "2844",
          name: "Ulhasnagar",
          state_id: "22",
        },
        {
          id: "2845",
          name: "Umarga",
          state_id: "22",
        },
        {
          id: "2846",
          name: "Umarkhed",
          state_id: "22",
        },
        {
          id: "2847",
          name: "Umarsara",
          state_id: "22",
        },
        {
          id: "2848",
          name: "Umbar Pada Nandade",
          state_id: "22",
        },
        {
          id: "2849",
          name: "Umred",
          state_id: "22",
        },
        {
          id: "2850",
          name: "Umri Pragane Balapur",
          state_id: "22",
        },
        {
          id: "2851",
          name: "Uran",
          state_id: "22",
        },
        {
          id: "2852",
          name: "Uran Islampur",
          state_id: "22",
        },
        {
          id: "2853",
          name: "Utekhol",
          state_id: "22",
        },
        {
          id: "2854",
          name: "Vada",
          state_id: "22",
        },
        {
          id: "2855",
          name: "Vadgaon",
          state_id: "22",
        },
        {
          id: "2856",
          name: "Vadgaon Kasba",
          state_id: "22",
        },
        {
          id: "2857",
          name: "Vaijapur",
          state_id: "22",
        },
        {
          id: "2858",
          name: "Vanvadi",
          state_id: "22",
        },
        {
          id: "2859",
          name: "Varangaon",
          state_id: "22",
        },
        {
          id: "2860",
          name: "Vasai",
          state_id: "22",
        },
        {
          id: "2861",
          name: "Vasantnagar",
          state_id: "22",
        },
        {
          id: "2862",
          name: "Vashind",
          state_id: "22",
        },
        {
          id: "2863",
          name: "Vengurla",
          state_id: "22",
        },
        {
          id: "2864",
          name: "Virar",
          state_id: "22",
        },
        {
          id: "2865",
          name: "Visapur",
          state_id: "22",
        },
        {
          id: "2866",
          name: "Vite",
          state_id: "22",
        },
        {
          id: "2867",
          name: "Vithalwadi",
          state_id: "22",
        },
        {
          id: "2868",
          name: "Wadi",
          state_id: "22",
        },
        {
          id: "2869",
          name: "Waghapur",
          state_id: "22",
        },
        {
          id: "2870",
          name: "Wai",
          state_id: "22",
        },
        {
          id: "2871",
          name: "Wajegaon",
          state_id: "22",
        },
        {
          id: "2872",
          name: "Walani",
          state_id: "22",
        },
        {
          id: "2873",
          name: "Wanadongri",
          state_id: "22",
        },
        {
          id: "2874",
          name: "Wani",
          state_id: "22",
        },
        {
          id: "2875",
          name: "Wardha",
          state_id: "22",
        },
        {
          id: "2876",
          name: "Warora",
          state_id: "22",
        },
        {
          id: "2877",
          name: "Warthi",
          state_id: "22",
        },
        {
          id: "2878",
          name: "Warud",
          state_id: "22",
        },
        {
          id: "2879",
          name: "Washim",
          state_id: "22",
        },
        {
          id: "2880",
          name: "Yaval",
          state_id: "22",
        },
        {
          id: "2881",
          name: "Yavatmal",
          state_id: "22",
        },
        {
          id: "2882",
          name: "Yeola",
          state_id: "22",
        },
        {
          id: "2883",
          name: "Yerkheda",
          state_id: "22",
        },
      ],
      Manipur: [
        {
          id: "2884",
          name: "Andro",
          state_id: "23",
        },
        {
          id: "2885",
          name: "Bijoy Govinda",
          state_id: "23",
        },
        {
          id: "2886",
          name: "Bishnupur",
          state_id: "23",
        },
        {
          id: "2887",
          name: "Churachandpur",
          state_id: "23",
        },
        {
          id: "2888",
          name: "Heriok",
          state_id: "23",
        },
        {
          id: "2889",
          name: "Imphal",
          state_id: "23",
        },
        {
          id: "2890",
          name: "Jiribam",
          state_id: "23",
        },
        {
          id: "2891",
          name: "Kakching",
          state_id: "23",
        },
        {
          id: "2892",
          name: "Kakching Khunou",
          state_id: "23",
        },
        {
          id: "2893",
          name: "Khongman",
          state_id: "23",
        },
        {
          id: "2894",
          name: "Kumbi",
          state_id: "23",
        },
        {
          id: "2895",
          name: "Kwakta",
          state_id: "23",
        },
        {
          id: "2896",
          name: "Lamai",
          state_id: "23",
        },
        {
          id: "2897",
          name: "Lamjaotongba",
          state_id: "23",
        },
        {
          id: "2898",
          name: "Lamshang",
          state_id: "23",
        },
        {
          id: "2899",
          name: "Lilong",
          state_id: "23",
        },
        {
          id: "2900",
          name: "Mayang Imphal",
          state_id: "23",
        },
        {
          id: "2901",
          name: "Moirang",
          state_id: "23",
        },
        {
          id: "2902",
          name: "Moreh",
          state_id: "23",
        },
        {
          id: "2903",
          name: "Nambol",
          state_id: "23",
        },
        {
          id: "2904",
          name: "Naoriya Pakhanglakpa",
          state_id: "23",
        },
        {
          id: "2905",
          name: "Ningthoukhong",
          state_id: "23",
        },
        {
          id: "2906",
          name: "Oinam",
          state_id: "23",
        },
        {
          id: "2907",
          name: "Porompat",
          state_id: "23",
        },
        {
          id: "2908",
          name: "Samurou",
          state_id: "23",
        },
        {
          id: "2909",
          name: "Sekmai Bazar",
          state_id: "23",
        },
        {
          id: "2910",
          name: "Senapati",
          state_id: "23",
        },
        {
          id: "2911",
          name: "Sikhong Sekmai",
          state_id: "23",
        },
        {
          id: "2912",
          name: "Sugnu",
          state_id: "23",
        },
        {
          id: "2913",
          name: "Thongkhong Laxmi Bazar",
          state_id: "23",
        },
        {
          id: "2914",
          name: "Thoubal",
          state_id: "23",
        },
        {
          id: "2915",
          name: "Torban",
          state_id: "23",
        },
        {
          id: "2916",
          name: "Wangjing",
          state_id: "23",
        },
        {
          id: "2917",
          name: "Wangoi",
          state_id: "23",
        },
        {
          id: "2918",
          name: "Yairipok",
          state_id: "23",
        },
      ],
      Meghalaya: [
        {
          id: "2919",
          name: "Baghmara",
          state_id: "24",
        },
        {
          id: "2920",
          name: "Cherrapunji",
          state_id: "24",
        },
        {
          id: "2921",
          name: "Jawai",
          state_id: "24",
        },
        {
          id: "2922",
          name: "Madanrting",
          state_id: "24",
        },
        {
          id: "2923",
          name: "Mairang",
          state_id: "24",
        },
        {
          id: "2924",
          name: "Mawlai",
          state_id: "24",
        },
        {
          id: "2925",
          name: "Nongmynsong",
          state_id: "24",
        },
        {
          id: "2926",
          name: "Nongpoh",
          state_id: "24",
        },
        {
          id: "2927",
          name: "Nongstoin",
          state_id: "24",
        },
        {
          id: "2928",
          name: "Nongthymmai",
          state_id: "24",
        },
        {
          id: "2929",
          name: "Pynthorumkhrah",
          state_id: "24",
        },
        {
          id: "2930",
          name: "Resubelpara",
          state_id: "24",
        },
        {
          id: "2931",
          name: "Shillong",
          state_id: "24",
        },
        {
          id: "2932",
          name: "Shillong Cantonment",
          state_id: "24",
        },
        {
          id: "2933",
          name: "Tura",
          state_id: "24",
        },
        {
          id: "2934",
          name: "Williamnagar",
          state_id: "24",
        },
      ],
      Mizoram: [
        {
          id: "2935",
          name: "Aizawl",
          state_id: "25",
        },
        {
          id: "2936",
          name: "Bairabi",
          state_id: "25",
        },
        {
          id: "2937",
          name: "Biate",
          state_id: "25",
        },
        {
          id: "2938",
          name: "Champhai",
          state_id: "25",
        },
        {
          id: "2939",
          name: "Darlawn",
          state_id: "25",
        },
        {
          id: "2940",
          name: "Hnahthial",
          state_id: "25",
        },
        {
          id: "2941",
          name: "Kawnpui",
          state_id: "25",
        },
        {
          id: "2942",
          name: "Khawhai",
          state_id: "25",
        },
        {
          id: "2943",
          name: "Khawzawl",
          state_id: "25",
        },
        {
          id: "2944",
          name: "Kolasib",
          state_id: "25",
        },
        {
          id: "2945",
          name: "Lengpui",
          state_id: "25",
        },
        {
          id: "2946",
          name: "Lunglei",
          state_id: "25",
        },
        {
          id: "2947",
          name: "Mamit",
          state_id: "25",
        },
        {
          id: "2948",
          name: "North Vanlaiphai",
          state_id: "25",
        },
        {
          id: "2949",
          name: "Saiha",
          state_id: "25",
        },
        {
          id: "2950",
          name: "Sairang",
          state_id: "25",
        },
        {
          id: "2951",
          name: "Saitul",
          state_id: "25",
        },
        {
          id: "2952",
          name: "Serchhip",
          state_id: "25",
        },
        {
          id: "2953",
          name: "Thenzawl",
          state_id: "25",
        },
        {
          id: "2954",
          name: "Tlabung",
          state_id: "25",
        },
        {
          id: "2955",
          name: "Vairengte",
          state_id: "25",
        },
        {
          id: "2956",
          name: "Zawlnuam",
          state_id: "25",
        },
      ],
      Nagaland: [
        {
          id: "2957",
          name: "Chumukedima",
          state_id: "26",
        },
        {
          id: "2958",
          name: "Dimapur",
          state_id: "26",
        },
        {
          id: "2959",
          name: "Kohima",
          state_id: "26",
        },
        {
          id: "2960",
          name: "Mokokchung",
          state_id: "26",
        },
        {
          id: "2961",
          name: "Mon",
          state_id: "26",
        },
        {
          id: "2962",
          name: "Phek",
          state_id: "26",
        },
        {
          id: "2963",
          name: "Tuensang",
          state_id: "26",
        },
        {
          id: "2964",
          name: "Wokha",
          state_id: "26",
        },
        {
          id: "2965",
          name: "Zunheboto",
          state_id: "26",
        },
      ],
      Narora: [],
      Natwar: [],
      Odisha: [
        {
          id: "2966",
          name: "Anandapur",
          state_id: "29",
        },
        {
          id: "2967",
          name: "Angul",
          state_id: "29",
        },
        {
          id: "2968",
          name: "Aska",
          state_id: "29",
        },
        {
          id: "2969",
          name: "Athgarh",
          state_id: "29",
        },
        {
          id: "2970",
          name: "Athmallik",
          state_id: "29",
        },
        {
          id: "2971",
          name: "Balagoda",
          state_id: "29",
        },
        {
          id: "2972",
          name: "Balangir",
          state_id: "29",
        },
        {
          id: "2973",
          name: "Balasore",
          state_id: "29",
        },
        {
          id: "2974",
          name: "Baleshwar",
          state_id: "29",
        },
        {
          id: "2975",
          name: "Balimeta",
          state_id: "29",
        },
        {
          id: "2976",
          name: "Balugaon",
          state_id: "29",
        },
        {
          id: "2977",
          name: "Banapur",
          state_id: "29",
        },
        {
          id: "2978",
          name: "Bangura",
          state_id: "29",
        },
        {
          id: "2979",
          name: "Banki",
          state_id: "29",
        },
        {
          id: "2980",
          name: "Banposh",
          state_id: "29",
        },
        {
          id: "2981",
          name: "Barbil",
          state_id: "29",
        },
        {
          id: "2982",
          name: "Bargarh",
          state_id: "29",
        },
        {
          id: "2983",
          name: "Baripada",
          state_id: "29",
        },
        {
          id: "2984",
          name: "Barpali",
          state_id: "29",
        },
        {
          id: "2985",
          name: "Basudebpur",
          state_id: "29",
        },
        {
          id: "2986",
          name: "Baudh",
          state_id: "29",
        },
        {
          id: "2987",
          name: "Belagachhia",
          state_id: "29",
        },
        {
          id: "2988",
          name: "Belaguntha",
          state_id: "29",
        },
        {
          id: "2989",
          name: "Belpahar",
          state_id: "29",
        },
        {
          id: "2990",
          name: "Berhampur",
          state_id: "29",
        },
        {
          id: "2991",
          name: "Bhadrak",
          state_id: "29",
        },
        {
          id: "2992",
          name: "Bhanjanagar",
          state_id: "29",
        },
        {
          id: "2993",
          name: "Bhawanipatna",
          state_id: "29",
        },
        {
          id: "2994",
          name: "Bhuban",
          state_id: "29",
        },
        {
          id: "2995",
          name: "Bhubaneswar",
          state_id: "29",
        },
        {
          id: "2996",
          name: "Binika",
          state_id: "29",
        },
        {
          id: "2997",
          name: "Birmitrapur",
          state_id: "29",
        },
        {
          id: "2998",
          name: "Bishama Katek",
          state_id: "29",
        },
        {
          id: "2999",
          name: "Bolangir",
          state_id: "29",
        },
        {
          id: "3000",
          name: "Brahmapur",
          state_id: "29",
        },
        {
          id: "3001",
          name: "Brajrajnagar",
          state_id: "29",
        },
        {
          id: "3002",
          name: "Buguda",
          state_id: "29",
        },
        {
          id: "3003",
          name: "Burla",
          state_id: "29",
        },
        {
          id: "3004",
          name: "Byasanagar",
          state_id: "29",
        },
        {
          id: "3005",
          name: "Champua",
          state_id: "29",
        },
        {
          id: "3006",
          name: "Chandapur",
          state_id: "29",
        },
        {
          id: "3007",
          name: "Chandbali",
          state_id: "29",
        },
        {
          id: "3008",
          name: "Chandili",
          state_id: "29",
        },
        {
          id: "3009",
          name: "Charibatia",
          state_id: "29",
        },
        {
          id: "3010",
          name: "Chatrapur",
          state_id: "29",
        },
        {
          id: "3011",
          name: "Chikitigarh",
          state_id: "29",
        },
        {
          id: "3012",
          name: "Chitrakonda",
          state_id: "29",
        },
        {
          id: "3013",
          name: "Choudwar",
          state_id: "29",
        },
        {
          id: "3014",
          name: "Cuttack",
          state_id: "29",
        },
        {
          id: "3015",
          name: "Dadhapatna",
          state_id: "29",
        },
        {
          id: "3016",
          name: "Daitari",
          state_id: "29",
        },
        {
          id: "3017",
          name: "Damanjodi",
          state_id: "29",
        },
        {
          id: "3018",
          name: "Deogarh",
          state_id: "29",
        },
        {
          id: "3019",
          name: "Deracolliery",
          state_id: "29",
        },
        {
          id: "3020",
          name: "Dhamanagar",
          state_id: "29",
        },
        {
          id: "3021",
          name: "Dhenkanal",
          state_id: "29",
        },
        {
          id: "3022",
          name: "Digapahandi",
          state_id: "29",
        },
        {
          id: "3023",
          name: "Dungamal",
          state_id: "29",
        },
        {
          id: "3024",
          name: "Fertilizer Corporation of Indi",
          state_id: "29",
        },
        {
          id: "3025",
          name: "Ganjam",
          state_id: "29",
        },
        {
          id: "3026",
          name: "Ghantapada",
          state_id: "29",
        },
        {
          id: "3027",
          name: "Gopalpur",
          state_id: "29",
        },
        {
          id: "3028",
          name: "Gudari",
          state_id: "29",
        },
        {
          id: "3029",
          name: "Gunupur",
          state_id: "29",
        },
        {
          id: "3030",
          name: "Hatibandha",
          state_id: "29",
        },
        {
          id: "3031",
          name: "Hinjilikatu",
          state_id: "29",
        },
        {
          id: "3032",
          name: "Hirakud",
          state_id: "29",
        },
        {
          id: "3033",
          name: "Jagatsinghapur",
          state_id: "29",
        },
        {
          id: "3034",
          name: "Jajpur",
          state_id: "29",
        },
        {
          id: "3035",
          name: "Jalda",
          state_id: "29",
        },
        {
          id: "3036",
          name: "Jaleswar",
          state_id: "29",
        },
        {
          id: "3037",
          name: "Jatni",
          state_id: "29",
        },
        {
          id: "3038",
          name: "Jaypur",
          state_id: "29",
        },
        {
          id: "3039",
          name: "Jeypore",
          state_id: "29",
        },
        {
          id: "3040",
          name: "Jharsuguda",
          state_id: "29",
        },
        {
          id: "3041",
          name: "Jhumpura",
          state_id: "29",
        },
        {
          id: "3042",
          name: "Joda",
          state_id: "29",
        },
        {
          id: "3043",
          name: "Junagarh",
          state_id: "29",
        },
        {
          id: "3044",
          name: "Kamakhyanagar",
          state_id: "29",
        },
        {
          id: "3045",
          name: "Kantabanji",
          state_id: "29",
        },
        {
          id: "3046",
          name: "Kantilo",
          state_id: "29",
        },
        {
          id: "3047",
          name: "Karanja",
          state_id: "29",
        },
        {
          id: "3048",
          name: "Kashinagara",
          state_id: "29",
        },
        {
          id: "3049",
          name: "Kataka",
          state_id: "29",
        },
        {
          id: "3050",
          name: "Kavisuryanagar",
          state_id: "29",
        },
        {
          id: "3051",
          name: "Kendrapara",
          state_id: "29",
        },
        {
          id: "3052",
          name: "Kendujhar",
          state_id: "29",
        },
        {
          id: "3053",
          name: "Keonjhar",
          state_id: "29",
        },
        {
          id: "3054",
          name: "Kesinga",
          state_id: "29",
        },
        {
          id: "3055",
          name: "Khaliapali",
          state_id: "29",
        },
        {
          id: "3056",
          name: "Khalikote",
          state_id: "29",
        },
        {
          id: "3057",
          name: "Khandaparha",
          state_id: "29",
        },
        {
          id: "3058",
          name: "Kharhial",
          state_id: "29",
        },
        {
          id: "3059",
          name: "Kharhial Road",
          state_id: "29",
        },
        {
          id: "3060",
          name: "Khatiguda",
          state_id: "29",
        },
        {
          id: "3061",
          name: "Khurda",
          state_id: "29",
        },
        {
          id: "3062",
          name: "Kochinda",
          state_id: "29",
        },
        {
          id: "3063",
          name: "Kodala",
          state_id: "29",
        },
        {
          id: "3064",
          name: "Konark",
          state_id: "29",
        },
        {
          id: "3065",
          name: "Koraput",
          state_id: "29",
        },
        {
          id: "3066",
          name: "Kotaparh",
          state_id: "29",
        },
        {
          id: "3067",
          name: "Lanjigarh",
          state_id: "29",
        },
        {
          id: "3068",
          name: "Lattikata",
          state_id: "29",
        },
        {
          id: "3069",
          name: "Makundapur",
          state_id: "29",
        },
        {
          id: "3070",
          name: "Malkangiri",
          state_id: "29",
        },
        {
          id: "3071",
          name: "Mukhiguda",
          state_id: "29",
        },
        {
          id: "3072",
          name: "Nabarangpur",
          state_id: "29",
        },
        {
          id: "3073",
          name: "Nalco",
          state_id: "29",
        },
        {
          id: "3074",
          name: "Naurangapur",
          state_id: "29",
        },
        {
          id: "3075",
          name: "Nayagarh",
          state_id: "29",
        },
        {
          id: "3076",
          name: "Nilagiri",
          state_id: "29",
        },
        {
          id: "3077",
          name: "Nimaparha",
          state_id: "29",
        },
        {
          id: "3078",
          name: "Nuapada",
          state_id: "29",
        },
        {
          id: "3079",
          name: "Nuapatna",
          state_id: "29",
        },
        {
          id: "3080",
          name: "OCL Industrialship",
          state_id: "29",
        },
        {
          id: "3081",
          name: "Padampur",
          state_id: "29",
        },
        {
          id: "3082",
          name: "Paradip",
          state_id: "29",
        },
        {
          id: "3083",
          name: "Paradwip",
          state_id: "29",
        },
        {
          id: "3084",
          name: "Parlakimidi",
          state_id: "29",
        },
        {
          id: "3085",
          name: "Patamundai",
          state_id: "29",
        },
        {
          id: "3086",
          name: "Patnagarh",
          state_id: "29",
        },
        {
          id: "3087",
          name: "Phulabani",
          state_id: "29",
        },
        {
          id: "3088",
          name: "Pipili",
          state_id: "29",
        },
        {
          id: "3089",
          name: "Polasara",
          state_id: "29",
        },
        {
          id: "3090",
          name: "Pratapsasan",
          state_id: "29",
        },
        {
          id: "3091",
          name: "Puri",
          state_id: "29",
        },
        {
          id: "3092",
          name: "Purushottampur",
          state_id: "29",
        },
        {
          id: "3093",
          name: "Rairangpur",
          state_id: "29",
        },
        {
          id: "3094",
          name: "Raj Gangpur",
          state_id: "29",
        },
        {
          id: "3095",
          name: "Rambha",
          state_id: "29",
        },
        {
          id: "3096",
          name: "Raurkela",
          state_id: "29",
        },
        {
          id: "3097",
          name: "Raurkela Civil Township",
          state_id: "29",
        },
        {
          id: "3098",
          name: "Rayagada",
          state_id: "29",
        },
        {
          id: "3099",
          name: "Redhakhol",
          state_id: "29",
        },
        {
          id: "3100",
          name: "Remuna",
          state_id: "29",
        },
        {
          id: "3101",
          name: "Rengali",
          state_id: "29",
        },
        {
          id: "3102",
          name: "Rourkela",
          state_id: "29",
        },
        {
          id: "3103",
          name: "Sambalpur",
          state_id: "29",
        },
        {
          id: "3104",
          name: "Sinapali",
          state_id: "29",
        },
        {
          id: "3105",
          name: "Sonepur",
          state_id: "29",
        },
        {
          id: "3106",
          name: "Sorada",
          state_id: "29",
        },
        {
          id: "3107",
          name: "Soro",
          state_id: "29",
        },
        {
          id: "3108",
          name: "Sunabeda",
          state_id: "29",
        },
        {
          id: "3109",
          name: "Sundargarh",
          state_id: "29",
        },
        {
          id: "3110",
          name: "Talcher",
          state_id: "29",
        },
        {
          id: "3111",
          name: "Talcher Thermal Power Station",
          state_id: "29",
        },
        {
          id: "3112",
          name: "Tarabha",
          state_id: "29",
        },
        {
          id: "3113",
          name: "Tensa",
          state_id: "29",
        },
        {
          id: "3114",
          name: "Titlagarh",
          state_id: "29",
        },
        {
          id: "3115",
          name: "Udala",
          state_id: "29",
        },
        {
          id: "3116",
          name: "Udayagiri",
          state_id: "29",
        },
        {
          id: "3117",
          name: "Umarkot",
          state_id: "29",
        },
        {
          id: "3118",
          name: "Vikrampur",
          state_id: "29",
        },
      ],
      "Paschim Medinipur": [],
      Pondicherry: [
        {
          id: "3119",
          name: "Ariankuppam",
          state_id: "31",
        },
        {
          id: "3120",
          name: "Karaikal",
          state_id: "31",
        },
        {
          id: "3121",
          name: "Kurumbapet",
          state_id: "31",
        },
        {
          id: "3122",
          name: "Mahe",
          state_id: "31",
        },
        {
          id: "3123",
          name: "Ozhukarai",
          state_id: "31",
        },
        {
          id: "3124",
          name: "Pondicherry",
          state_id: "31",
        },
        {
          id: "3125",
          name: "Villianur",
          state_id: "31",
        },
        {
          id: "3126",
          name: "Yanam",
          state_id: "31",
        },
      ],
      Punjab: [
        {
          id: "3127",
          name: "Abohar",
          state_id: "32",
        },
        {
          id: "3128",
          name: "Adampur",
          state_id: "32",
        },
        {
          id: "3129",
          name: "Ahmedgarh",
          state_id: "32",
        },
        {
          id: "3130",
          name: "Ajnala",
          state_id: "32",
        },
        {
          id: "3131",
          name: "Akalgarh",
          state_id: "32",
        },
        {
          id: "3132",
          name: "Alawalpur",
          state_id: "32",
        },
        {
          id: "3133",
          name: "Amloh",
          state_id: "32",
        },
        {
          id: "3134",
          name: "Amritsar",
          state_id: "32",
        },
        {
          id: "3135",
          name: "Amritsar Cantonment",
          state_id: "32",
        },
        {
          id: "3136",
          name: "Anandpur Sahib",
          state_id: "32",
        },
        {
          id: "3137",
          name: "Badhni Kalan",
          state_id: "32",
        },
        {
          id: "3138",
          name: "Bagh Purana",
          state_id: "32",
        },
        {
          id: "3139",
          name: "Balachaur",
          state_id: "32",
        },
        {
          id: "3140",
          name: "Banaur",
          state_id: "32",
        },
        {
          id: "3141",
          name: "Banga",
          state_id: "32",
        },
        {
          id: "3142",
          name: "Banur",
          state_id: "32",
        },
        {
          id: "3143",
          name: "Baretta",
          state_id: "32",
        },
        {
          id: "3144",
          name: "Bariwala",
          state_id: "32",
        },
        {
          id: "3145",
          name: "Barnala",
          state_id: "32",
        },
        {
          id: "3146",
          name: "Bassi Pathana",
          state_id: "32",
        },
        {
          id: "3147",
          name: "Batala",
          state_id: "32",
        },
        {
          id: "3148",
          name: "Bathinda",
          state_id: "32",
        },
        {
          id: "3149",
          name: "Begowal",
          state_id: "32",
        },
        {
          id: "3150",
          name: "Behrampur",
          state_id: "32",
        },
        {
          id: "3151",
          name: "Bhabat",
          state_id: "32",
        },
        {
          id: "3152",
          name: "Bhadur",
          state_id: "32",
        },
        {
          id: "3153",
          name: "Bhankharpur",
          state_id: "32",
        },
        {
          id: "3154",
          name: "Bharoli Kalan",
          state_id: "32",
        },
        {
          id: "3155",
          name: "Bhawanigarh",
          state_id: "32",
        },
        {
          id: "3156",
          name: "Bhikhi",
          state_id: "32",
        },
        {
          id: "3157",
          name: "Bhikhiwind",
          state_id: "32",
        },
        {
          id: "3158",
          name: "Bhisiana",
          state_id: "32",
        },
        {
          id: "3159",
          name: "Bhogpur",
          state_id: "32",
        },
        {
          id: "3160",
          name: "Bhuch",
          state_id: "32",
        },
        {
          id: "3161",
          name: "Bhulath",
          state_id: "32",
        },
        {
          id: "3162",
          name: "Budha Theh",
          state_id: "32",
        },
        {
          id: "3163",
          name: "Budhlada",
          state_id: "32",
        },
        {
          id: "3164",
          name: "Chima",
          state_id: "32",
        },
        {
          id: "3165",
          name: "Chohal",
          state_id: "32",
        },
        {
          id: "3166",
          name: "Dasuya",
          state_id: "32",
        },
        {
          id: "3167",
          name: "Daulatpur",
          state_id: "32",
        },
        {
          id: "3168",
          name: "Dera Baba Nanak",
          state_id: "32",
        },
        {
          id: "3169",
          name: "Dera Bassi",
          state_id: "32",
        },
        {
          id: "3170",
          name: "Dhanaula",
          state_id: "32",
        },
        {
          id: "3171",
          name: "Dharam Kot",
          state_id: "32",
        },
        {
          id: "3172",
          name: "Dhariwal",
          state_id: "32",
        },
        {
          id: "3173",
          name: "Dhilwan",
          state_id: "32",
        },
        {
          id: "3174",
          name: "Dhuri",
          state_id: "32",
        },
        {
          id: "3175",
          name: "Dinanagar",
          state_id: "32",
        },
        {
          id: "3176",
          name: "Dirba",
          state_id: "32",
        },
        {
          id: "3177",
          name: "Doraha",
          state_id: "32",
        },
        {
          id: "3178",
          name: "Faridkot",
          state_id: "32",
        },
        {
          id: "3179",
          name: "Fateh Nangal",
          state_id: "32",
        },
        {
          id: "3180",
          name: "Fatehgarh Churian",
          state_id: "32",
        },
        {
          id: "3181",
          name: "Fatehgarh Sahib",
          state_id: "32",
        },
        {
          id: "3182",
          name: "Fazilka",
          state_id: "32",
        },
        {
          id: "3183",
          name: "Firozpur",
          state_id: "32",
        },
        {
          id: "3184",
          name: "Firozpur Cantonment",
          state_id: "32",
        },
        {
          id: "3185",
          name: "Gardhiwala",
          state_id: "32",
        },
        {
          id: "3186",
          name: "Garhshankar",
          state_id: "32",
        },
        {
          id: "3187",
          name: "Ghagga",
          state_id: "32",
        },
        {
          id: "3188",
          name: "Ghanaur",
          state_id: "32",
        },
        {
          id: "3189",
          name: "Giddarbaha",
          state_id: "32",
        },
        {
          id: "3190",
          name: "Gobindgarh",
          state_id: "32",
        },
        {
          id: "3191",
          name: "Goniana",
          state_id: "32",
        },
        {
          id: "3192",
          name: "Goraya",
          state_id: "32",
        },
        {
          id: "3193",
          name: "Gurdaspur",
          state_id: "32",
        },
        {
          id: "3194",
          name: "Guru Har Sahai",
          state_id: "32",
        },
        {
          id: "3195",
          name: "Hajipur",
          state_id: "32",
        },
        {
          id: "3196",
          name: "Handiaya",
          state_id: "32",
        },
        {
          id: "3197",
          name: "Hariana",
          state_id: "32",
        },
        {
          id: "3198",
          name: "Hoshiarpur",
          state_id: "32",
        },
        {
          id: "3199",
          name: "Hussainpur",
          state_id: "32",
        },
        {
          id: "3200",
          name: "Jagraon",
          state_id: "32",
        },
        {
          id: "3201",
          name: "Jaitu",
          state_id: "32",
        },
        {
          id: "3202",
          name: "Jalalabad",
          state_id: "32",
        },
        {
          id: "3203",
          name: "Jalandhar",
          state_id: "32",
        },
        {
          id: "3204",
          name: "Jalandhar Cantonment",
          state_id: "32",
        },
        {
          id: "3205",
          name: "Jandiala",
          state_id: "32",
        },
        {
          id: "3206",
          name: "Jugial",
          state_id: "32",
        },
        {
          id: "3207",
          name: "Kalanaur",
          state_id: "32",
        },
        {
          id: "3208",
          name: "Kapurthala",
          state_id: "32",
        },
        {
          id: "3209",
          name: "Karoran",
          state_id: "32",
        },
        {
          id: "3210",
          name: "Kartarpur",
          state_id: "32",
        },
        {
          id: "3211",
          name: "Khamanon",
          state_id: "32",
        },
        {
          id: "3212",
          name: "Khanauri",
          state_id: "32",
        },
        {
          id: "3213",
          name: "Khanna",
          state_id: "32",
        },
        {
          id: "3214",
          name: "Kharar",
          state_id: "32",
        },
        {
          id: "3215",
          name: "Khem Karan",
          state_id: "32",
        },
        {
          id: "3216",
          name: "Kot Fatta",
          state_id: "32",
        },
        {
          id: "3217",
          name: "Kot Isa Khan",
          state_id: "32",
        },
        {
          id: "3218",
          name: "Kot Kapura",
          state_id: "32",
        },
        {
          id: "3219",
          name: "Kotkapura",
          state_id: "32",
        },
        {
          id: "3220",
          name: "Kurali",
          state_id: "32",
        },
        {
          id: "3221",
          name: "Lalru",
          state_id: "32",
        },
        {
          id: "3222",
          name: "Lehra Gaga",
          state_id: "32",
        },
        {
          id: "3223",
          name: "Lodhian Khas",
          state_id: "32",
        },
        {
          id: "3224",
          name: "Longowal",
          state_id: "32",
        },
        {
          id: "3225",
          name: "Ludhiana",
          state_id: "32",
        },
        {
          id: "3226",
          name: "Machhiwara",
          state_id: "32",
        },
        {
          id: "3227",
          name: "Mahilpur",
          state_id: "32",
        },
        {
          id: "3228",
          name: "Majitha",
          state_id: "32",
        },
        {
          id: "3229",
          name: "Makhu",
          state_id: "32",
        },
        {
          id: "3230",
          name: "Malaut",
          state_id: "32",
        },
        {
          id: "3231",
          name: "Malerkotla",
          state_id: "32",
        },
        {
          id: "3232",
          name: "Maloud",
          state_id: "32",
        },
        {
          id: "3233",
          name: "Mandi Gobindgarh",
          state_id: "32",
        },
        {
          id: "3234",
          name: "Mansa",
          state_id: "32",
        },
        {
          id: "3235",
          name: "Maur",
          state_id: "32",
        },
        {
          id: "3236",
          name: "Moga",
          state_id: "32",
        },
        {
          id: "3237",
          name: "Mohali",
          state_id: "32",
        },
        {
          id: "3238",
          name: "Moonak",
          state_id: "32",
        },
        {
          id: "3239",
          name: "Morinda",
          state_id: "32",
        },
        {
          id: "3240",
          name: "Mukerian",
          state_id: "32",
        },
        {
          id: "3241",
          name: "Muktsar",
          state_id: "32",
        },
        {
          id: "3242",
          name: "Mullanpur Dakha",
          state_id: "32",
        },
        {
          id: "3243",
          name: "Mullanpur Garibdas",
          state_id: "32",
        },
        {
          id: "3244",
          name: "Munak",
          state_id: "32",
        },
        {
          id: "3245",
          name: "Muradpura",
          state_id: "32",
        },
        {
          id: "3246",
          name: "Nabha",
          state_id: "32",
        },
        {
          id: "3247",
          name: "Nakodar",
          state_id: "32",
        },
        {
          id: "3248",
          name: "Nangal",
          state_id: "32",
        },
        {
          id: "3249",
          name: "Nawashahr",
          state_id: "32",
        },
        {
          id: "3250",
          name: "Naya Nangal",
          state_id: "32",
        },
        {
          id: "3251",
          name: "Nehon",
          state_id: "32",
        },
        {
          id: "3252",
          name: "Nurmahal",
          state_id: "32",
        },
        {
          id: "3253",
          name: "Pathankot",
          state_id: "32",
        },
        {
          id: "3254",
          name: "Patiala",
          state_id: "32",
        },
        {
          id: "3255",
          name: "Patti",
          state_id: "32",
        },
        {
          id: "3256",
          name: "Pattran",
          state_id: "32",
        },
        {
          id: "3257",
          name: "Payal",
          state_id: "32",
        },
        {
          id: "3258",
          name: "Phagwara",
          state_id: "32",
        },
        {
          id: "3259",
          name: "Phillaur",
          state_id: "32",
        },
        {
          id: "3260",
          name: "Qadian",
          state_id: "32",
        },
        {
          id: "3261",
          name: "Rahon",
          state_id: "32",
        },
        {
          id: "3262",
          name: "Raikot",
          state_id: "32",
        },
        {
          id: "3263",
          name: "Raja Sansi",
          state_id: "32",
        },
        {
          id: "3264",
          name: "Rajpura",
          state_id: "32",
        },
        {
          id: "3265",
          name: "Ram Das",
          state_id: "32",
        },
        {
          id: "3266",
          name: "Raman",
          state_id: "32",
        },
        {
          id: "3267",
          name: "Rampura",
          state_id: "32",
        },
        {
          id: "3268",
          name: "Rayya",
          state_id: "32",
        },
        {
          id: "3269",
          name: "Rupnagar",
          state_id: "32",
        },
        {
          id: "3270",
          name: "Rurki Kasba",
          state_id: "32",
        },
        {
          id: "3271",
          name: "Sahnewal",
          state_id: "32",
        },
        {
          id: "3272",
          name: "Samana",
          state_id: "32",
        },
        {
          id: "3273",
          name: "Samrala",
          state_id: "32",
        },
        {
          id: "3274",
          name: "Sanaur",
          state_id: "32",
        },
        {
          id: "3275",
          name: "Sangat",
          state_id: "32",
        },
        {
          id: "3276",
          name: "Sangrur",
          state_id: "32",
        },
        {
          id: "3277",
          name: "Sansarpur",
          state_id: "32",
        },
        {
          id: "3278",
          name: "Sardulgarh",
          state_id: "32",
        },
        {
          id: "3279",
          name: "Shahkot",
          state_id: "32",
        },
        {
          id: "3280",
          name: "Sham Churasi",
          state_id: "32",
        },
        {
          id: "3281",
          name: "Shekhpura",
          state_id: "32",
        },
        {
          id: "3282",
          name: "Sirhind",
          state_id: "32",
        },
        {
          id: "3283",
          name: "Sri Hargobindpur",
          state_id: "32",
        },
        {
          id: "3284",
          name: "Sujanpur",
          state_id: "32",
        },
        {
          id: "3285",
          name: "Sultanpur Lodhi",
          state_id: "32",
        },
        {
          id: "3286",
          name: "Sunam",
          state_id: "32",
        },
        {
          id: "3287",
          name: "Talwandi Bhai",
          state_id: "32",
        },
        {
          id: "3288",
          name: "Talwara",
          state_id: "32",
        },
        {
          id: "3289",
          name: "Tappa",
          state_id: "32",
        },
        {
          id: "3290",
          name: "Tarn Taran",
          state_id: "32",
        },
        {
          id: "3291",
          name: "Urmar Tanda",
          state_id: "32",
        },
        {
          id: "3292",
          name: "Zira",
          state_id: "32",
        },
        {
          id: "3293",
          name: "Zirakpur",
          state_id: "32",
        },
      ],
      Rajasthan: [
        {
          id: "3294",
          name: "Abu Road",
          state_id: "33",
        },
        {
          id: "3295",
          name: "Ajmer",
          state_id: "33",
        },
        {
          id: "3296",
          name: "Aklera",
          state_id: "33",
        },
        {
          id: "3297",
          name: "Alwar",
          state_id: "33",
        },
        {
          id: "3298",
          name: "Amet",
          state_id: "33",
        },
        {
          id: "3299",
          name: "Antah",
          state_id: "33",
        },
        {
          id: "3300",
          name: "Anupgarh",
          state_id: "33",
        },
        {
          id: "3301",
          name: "Asind",
          state_id: "33",
        },
        {
          id: "3302",
          name: "Bagar",
          state_id: "33",
        },
        {
          id: "3303",
          name: "Bagru",
          state_id: "33",
        },
        {
          id: "3304",
          name: "Bahror",
          state_id: "33",
        },
        {
          id: "3305",
          name: "Bakani",
          state_id: "33",
        },
        {
          id: "3306",
          name: "Bali",
          state_id: "33",
        },
        {
          id: "3307",
          name: "Balotra",
          state_id: "33",
        },
        {
          id: "3308",
          name: "Bandikui",
          state_id: "33",
        },
        {
          id: "3309",
          name: "Banswara",
          state_id: "33",
        },
        {
          id: "3310",
          name: "Baran",
          state_id: "33",
        },
        {
          id: "3311",
          name: "Bari",
          state_id: "33",
        },
        {
          id: "3312",
          name: "Bari Sadri",
          state_id: "33",
        },
        {
          id: "3313",
          name: "Barmer",
          state_id: "33",
        },
        {
          id: "3314",
          name: "Basi",
          state_id: "33",
        },
        {
          id: "3315",
          name: "Basni Belima",
          state_id: "33",
        },
        {
          id: "3316",
          name: "Baswa",
          state_id: "33",
        },
        {
          id: "3317",
          name: "Bayana",
          state_id: "33",
        },
        {
          id: "3318",
          name: "Beawar",
          state_id: "33",
        },
        {
          id: "3319",
          name: "Begun",
          state_id: "33",
        },
        {
          id: "3320",
          name: "Bhadasar",
          state_id: "33",
        },
        {
          id: "3321",
          name: "Bhadra",
          state_id: "33",
        },
        {
          id: "3322",
          name: "Bhalariya",
          state_id: "33",
        },
        {
          id: "3323",
          name: "Bharatpur",
          state_id: "33",
        },
        {
          id: "3324",
          name: "Bhasawar",
          state_id: "33",
        },
        {
          id: "3325",
          name: "Bhawani Mandi",
          state_id: "33",
        },
        {
          id: "3326",
          name: "Bhawri",
          state_id: "33",
        },
        {
          id: "3327",
          name: "Bhilwara",
          state_id: "33",
        },
        {
          id: "3328",
          name: "Bhindar",
          state_id: "33",
        },
        {
          id: "3329",
          name: "Bhinmal",
          state_id: "33",
        },
        {
          id: "3330",
          name: "Bhiwadi",
          state_id: "33",
        },
        {
          id: "3331",
          name: "Bijoliya Kalan",
          state_id: "33",
        },
        {
          id: "3332",
          name: "Bikaner",
          state_id: "33",
        },
        {
          id: "3333",
          name: "Bilara",
          state_id: "33",
        },
        {
          id: "3334",
          name: "Bissau",
          state_id: "33",
        },
        {
          id: "3335",
          name: "Borkhera",
          state_id: "33",
        },
        {
          id: "3336",
          name: "Budhpura",
          state_id: "33",
        },
        {
          id: "3337",
          name: "Bundi",
          state_id: "33",
        },
        {
          id: "3338",
          name: "Chatsu",
          state_id: "33",
        },
        {
          id: "3339",
          name: "Chechat",
          state_id: "33",
        },
        {
          id: "3340",
          name: "Chhabra",
          state_id: "33",
        },
        {
          id: "3341",
          name: "Chhapar",
          state_id: "33",
        },
        {
          id: "3342",
          name: "Chhipa Barod",
          state_id: "33",
        },
        {
          id: "3343",
          name: "Chhoti Sadri",
          state_id: "33",
        },
        {
          id: "3344",
          name: "Chirawa",
          state_id: "33",
        },
        {
          id: "3345",
          name: "Chittaurgarh",
          state_id: "33",
        },
        {
          id: "3346",
          name: "Chittorgarh",
          state_id: "33",
        },
        {
          id: "3347",
          name: "Chomun",
          state_id: "33",
        },
        {
          id: "3348",
          name: "Churu",
          state_id: "33",
        },
        {
          id: "3349",
          name: "Daosa",
          state_id: "33",
        },
        {
          id: "3350",
          name: "Dariba",
          state_id: "33",
        },
        {
          id: "3351",
          name: "Dausa",
          state_id: "33",
        },
        {
          id: "3352",
          name: "Deoli",
          state_id: "33",
        },
        {
          id: "3353",
          name: "Deshnok",
          state_id: "33",
        },
        {
          id: "3354",
          name: "Devgarh",
          state_id: "33",
        },
        {
          id: "3355",
          name: "Devli",
          state_id: "33",
        },
        {
          id: "3356",
          name: "Dhariawad",
          state_id: "33",
        },
        {
          id: "3357",
          name: "Dhaulpur",
          state_id: "33",
        },
        {
          id: "3358",
          name: "Dholpur",
          state_id: "33",
        },
        {
          id: "3359",
          name: "Didwana",
          state_id: "33",
        },
        {
          id: "3360",
          name: "Dig",
          state_id: "33",
        },
        {
          id: "3361",
          name: "Dungargarh",
          state_id: "33",
        },
        {
          id: "3362",
          name: "Dungarpur",
          state_id: "33",
        },
        {
          id: "3363",
          name: "Falna",
          state_id: "33",
        },
        {
          id: "3364",
          name: "Fatehnagar",
          state_id: "33",
        },
        {
          id: "3365",
          name: "Fatehpur",
          state_id: "33",
        },
        {
          id: "3366",
          name: "Gajsinghpur",
          state_id: "33",
        },
        {
          id: "3367",
          name: "Galiakot",
          state_id: "33",
        },
        {
          id: "3368",
          name: "Ganganagar",
          state_id: "33",
        },
        {
          id: "3369",
          name: "Gangapur",
          state_id: "33",
        },
        {
          id: "3370",
          name: "Goredi Chancha",
          state_id: "33",
        },
        {
          id: "3371",
          name: "Gothra",
          state_id: "33",
        },
        {
          id: "3372",
          name: "Govindgarh",
          state_id: "33",
        },
        {
          id: "3373",
          name: "Gulabpura",
          state_id: "33",
        },
        {
          id: "3374",
          name: "Hanumangarh",
          state_id: "33",
        },
        {
          id: "3375",
          name: "Hindaun",
          state_id: "33",
        },
        {
          id: "3376",
          name: "Indragarh",
          state_id: "33",
        },
        {
          id: "3377",
          name: "Jahazpur",
          state_id: "33",
        },
        {
          id: "3378",
          name: "Jaipur",
          state_id: "33",
        },
        {
          id: "3379",
          name: "Jaisalmer",
          state_id: "33",
        },
        {
          id: "3380",
          name: "Jaiselmer",
          state_id: "33",
        },
        {
          id: "3381",
          name: "Jaitaran",
          state_id: "33",
        },
        {
          id: "3382",
          name: "Jalore",
          state_id: "33",
        },
        {
          id: "3383",
          name: "Jhalawar",
          state_id: "33",
        },
        {
          id: "3384",
          name: "Jhalrapatan",
          state_id: "33",
        },
        {
          id: "3385",
          name: "Jhunjhunun",
          state_id: "33",
        },
        {
          id: "3386",
          name: "Jobner",
          state_id: "33",
        },
        {
          id: "3387",
          name: "Jodhpur",
          state_id: "33",
        },
        {
          id: "3388",
          name: "Kaithun",
          state_id: "33",
        },
        {
          id: "3389",
          name: "Kaman",
          state_id: "33",
        },
        {
          id: "3390",
          name: "Kankroli",
          state_id: "33",
        },
        {
          id: "3391",
          name: "Kanor",
          state_id: "33",
        },
        {
          id: "3392",
          name: "Kapasan",
          state_id: "33",
        },
        {
          id: "3393",
          name: "Kaprain",
          state_id: "33",
        },
        {
          id: "3394",
          name: "Karanpura",
          state_id: "33",
        },
        {
          id: "3395",
          name: "Karauli",
          state_id: "33",
        },
        {
          id: "3396",
          name: "Kekri",
          state_id: "33",
        },
        {
          id: "3397",
          name: "Keshorai Patan",
          state_id: "33",
        },
        {
          id: "3398",
          name: "Kesrisinghpur",
          state_id: "33",
        },
        {
          id: "3399",
          name: "Khairthal",
          state_id: "33",
        },
        {
          id: "3400",
          name: "Khandela",
          state_id: "33",
        },
        {
          id: "3401",
          name: "Khanpur",
          state_id: "33",
        },
        {
          id: "3402",
          name: "Kherli",
          state_id: "33",
        },
        {
          id: "3403",
          name: "Kherliganj",
          state_id: "33",
        },
        {
          id: "3404",
          name: "Kherwara Chhaoni",
          state_id: "33",
        },
        {
          id: "3405",
          name: "Khetri",
          state_id: "33",
        },
        {
          id: "3406",
          name: "Kiranipura",
          state_id: "33",
        },
        {
          id: "3407",
          name: "Kishangarh",
          state_id: "33",
        },
        {
          id: "3408",
          name: "Kishangarh Ranwal",
          state_id: "33",
        },
        {
          id: "3409",
          name: "Kolvi Rajendrapura",
          state_id: "33",
        },
        {
          id: "3410",
          name: "Kot Putli",
          state_id: "33",
        },
        {
          id: "3411",
          name: "Kota",
          state_id: "33",
        },
        {
          id: "3412",
          name: "Kuchaman",
          state_id: "33",
        },
        {
          id: "3413",
          name: "Kuchera",
          state_id: "33",
        },
        {
          id: "3414",
          name: "Kumbhalgarh",
          state_id: "33",
        },
        {
          id: "3415",
          name: "Kumbhkot",
          state_id: "33",
        },
        {
          id: "3416",
          name: "Kumher",
          state_id: "33",
        },
        {
          id: "3417",
          name: "Kushalgarh",
          state_id: "33",
        },
        {
          id: "3418",
          name: "Lachhmangarh",
          state_id: "33",
        },
        {
          id: "3419",
          name: "Ladnun",
          state_id: "33",
        },
        {
          id: "3420",
          name: "Lakheri",
          state_id: "33",
        },
        {
          id: "3421",
          name: "Lalsot",
          state_id: "33",
        },
        {
          id: "3422",
          name: "Losal",
          state_id: "33",
        },
        {
          id: "3423",
          name: "Madanganj",
          state_id: "33",
        },
        {
          id: "3424",
          name: "Mahu Kalan",
          state_id: "33",
        },
        {
          id: "3425",
          name: "Mahwa",
          state_id: "33",
        },
        {
          id: "3426",
          name: "Makrana",
          state_id: "33",
        },
        {
          id: "3427",
          name: "Malpura",
          state_id: "33",
        },
        {
          id: "3428",
          name: "Mandal",
          state_id: "33",
        },
        {
          id: "3429",
          name: "Mandalgarh",
          state_id: "33",
        },
        {
          id: "3430",
          name: "Mandawar",
          state_id: "33",
        },
        {
          id: "3431",
          name: "Mandwa",
          state_id: "33",
        },
        {
          id: "3432",
          name: "Mangrol",
          state_id: "33",
        },
        {
          id: "3433",
          name: "Manohar Thana",
          state_id: "33",
        },
        {
          id: "3434",
          name: "Manoharpur",
          state_id: "33",
        },
        {
          id: "3435",
          name: "Marwar",
          state_id: "33",
        },
        {
          id: "3436",
          name: "Merta",
          state_id: "33",
        },
        {
          id: "3437",
          name: "Modak",
          state_id: "33",
        },
        {
          id: "3438",
          name: "Mount Abu",
          state_id: "33",
        },
        {
          id: "3439",
          name: "Mukandgarh",
          state_id: "33",
        },
        {
          id: "3440",
          name: "Mundwa",
          state_id: "33",
        },
        {
          id: "3441",
          name: "Nadbai",
          state_id: "33",
        },
        {
          id: "3442",
          name: "Naenwa",
          state_id: "33",
        },
        {
          id: "3443",
          name: "Nagar",
          state_id: "33",
        },
        {
          id: "3444",
          name: "Nagaur",
          state_id: "33",
        },
        {
          id: "3445",
          name: "Napasar",
          state_id: "33",
        },
        {
          id: "3446",
          name: "Naraina",
          state_id: "33",
        },
        {
          id: "3447",
          name: "Nasirabad",
          state_id: "33",
        },
        {
          id: "3448",
          name: "Nathdwara",
          state_id: "33",
        },
        {
          id: "3449",
          name: "Nawa",
          state_id: "33",
        },
        {
          id: "3450",
          name: "Nawalgarh",
          state_id: "33",
        },
        {
          id: "3451",
          name: "Neem Ka Thana",
          state_id: "33",
        },
        {
          id: "3452",
          name: "Neemrana",
          state_id: "33",
        },
        {
          id: "3453",
          name: "Newa Talai",
          state_id: "33",
        },
        {
          id: "3454",
          name: "Nimaj",
          state_id: "33",
        },
        {
          id: "3455",
          name: "Nimbahera",
          state_id: "33",
        },
        {
          id: "3456",
          name: "Niwai",
          state_id: "33",
        },
        {
          id: "3457",
          name: "Nohar",
          state_id: "33",
        },
        {
          id: "3458",
          name: "Nokha",
          state_id: "33",
        },
        {
          id: "3459",
          name: "One SGM",
          state_id: "33",
        },
        {
          id: "3460",
          name: "Padampur",
          state_id: "33",
        },
        {
          id: "3461",
          name: "Pali",
          state_id: "33",
        },
        {
          id: "3462",
          name: "Partapur",
          state_id: "33",
        },
        {
          id: "3463",
          name: "Parvatsar",
          state_id: "33",
        },
        {
          id: "3464",
          name: "Pasoond",
          state_id: "33",
        },
        {
          id: "3465",
          name: "Phalna",
          state_id: "33",
        },
        {
          id: "3466",
          name: "Phalodi",
          state_id: "33",
        },
        {
          id: "3467",
          name: "Phulera",
          state_id: "33",
        },
        {
          id: "3468",
          name: "Pilani",
          state_id: "33",
        },
        {
          id: "3469",
          name: "Pilibanga",
          state_id: "33",
        },
        {
          id: "3470",
          name: "Pindwara",
          state_id: "33",
        },
        {
          id: "3471",
          name: "Pipalia Kalan",
          state_id: "33",
        },
        {
          id: "3472",
          name: "Pipar",
          state_id: "33",
        },
        {
          id: "3473",
          name: "Pirawa",
          state_id: "33",
        },
        {
          id: "3474",
          name: "Pokaran",
          state_id: "33",
        },
        {
          id: "3475",
          name: "Pratapgarh",
          state_id: "33",
        },
        {
          id: "3476",
          name: "Pushkar",
          state_id: "33",
        },
        {
          id: "3477",
          name: "Raipur",
          state_id: "33",
        },
        {
          id: "3478",
          name: "Raisinghnagar",
          state_id: "33",
        },
        {
          id: "3479",
          name: "Rajakhera",
          state_id: "33",
        },
        {
          id: "3480",
          name: "Rajaldesar",
          state_id: "33",
        },
        {
          id: "3481",
          name: "Rajgarh",
          state_id: "33",
        },
        {
          id: "3482",
          name: "Rajsamand",
          state_id: "33",
        },
        {
          id: "3483",
          name: "Ramganj Mandi",
          state_id: "33",
        },
        {
          id: "3484",
          name: "Ramgarh",
          state_id: "33",
        },
        {
          id: "3485",
          name: "Rani",
          state_id: "33",
        },
        {
          id: "3486",
          name: "Raniwara",
          state_id: "33",
        },
        {
          id: "3487",
          name: "Ratan Nagar",
          state_id: "33",
        },
        {
          id: "3488",
          name: "Ratangarh",
          state_id: "33",
        },
        {
          id: "3489",
          name: "Rawatbhata",
          state_id: "33",
        },
        {
          id: "3490",
          name: "Rawatsar",
          state_id: "33",
        },
        {
          id: "3491",
          name: "Rikhabdev",
          state_id: "33",
        },
        {
          id: "3492",
          name: "Ringas",
          state_id: "33",
        },
        {
          id: "3493",
          name: "Sadri",
          state_id: "33",
        },
        {
          id: "3494",
          name: "Sadulshahar",
          state_id: "33",
        },
        {
          id: "3495",
          name: "Sagwara",
          state_id: "33",
        },
        {
          id: "3496",
          name: "Salumbar",
          state_id: "33",
        },
        {
          id: "3497",
          name: "Sambhar",
          state_id: "33",
        },
        {
          id: "3498",
          name: "Samdari",
          state_id: "33",
        },
        {
          id: "3499",
          name: "Sanchor",
          state_id: "33",
        },
        {
          id: "3500",
          name: "Sangariya",
          state_id: "33",
        },
        {
          id: "3501",
          name: "Sangod",
          state_id: "33",
        },
        {
          id: "3502",
          name: "Sardarshahr",
          state_id: "33",
        },
        {
          id: "3503",
          name: "Sarwar",
          state_id: "33",
        },
        {
          id: "3504",
          name: "Satal Kheri",
          state_id: "33",
        },
        {
          id: "3505",
          name: "Sawai Madhopur",
          state_id: "33",
        },
        {
          id: "3506",
          name: "Sewan Kalan",
          state_id: "33",
        },
        {
          id: "3507",
          name: "Shahpura",
          state_id: "33",
        },
        {
          id: "3508",
          name: "Sheoganj",
          state_id: "33",
        },
        {
          id: "3509",
          name: "Sikar",
          state_id: "33",
        },
        {
          id: "3510",
          name: "Sirohi",
          state_id: "33",
        },
        {
          id: "3511",
          name: "Siwana",
          state_id: "33",
        },
        {
          id: "3512",
          name: "Sogariya",
          state_id: "33",
        },
        {
          id: "3513",
          name: "Sojat",
          state_id: "33",
        },
        {
          id: "3514",
          name: "Sojat Road",
          state_id: "33",
        },
        {
          id: "3515",
          name: "Sri Madhopur",
          state_id: "33",
        },
        {
          id: "3516",
          name: "Sriganganagar",
          state_id: "33",
        },
        {
          id: "3517",
          name: "Sujangarh",
          state_id: "33",
        },
        {
          id: "3518",
          name: "Suket",
          state_id: "33",
        },
        {
          id: "3519",
          name: "Sumerpur",
          state_id: "33",
        },
        {
          id: "3520",
          name: "Sunel",
          state_id: "33",
        },
        {
          id: "3521",
          name: "Surajgarh",
          state_id: "33",
        },
        {
          id: "3522",
          name: "Suratgarh",
          state_id: "33",
        },
        {
          id: "3523",
          name: "Swaroopganj",
          state_id: "33",
        },
        {
          id: "3524",
          name: "Takhatgarh",
          state_id: "33",
        },
        {
          id: "3525",
          name: "Taranagar",
          state_id: "33",
        },
        {
          id: "3526",
          name: "Three STR",
          state_id: "33",
        },
        {
          id: "3527",
          name: "Tijara",
          state_id: "33",
        },
        {
          id: "3528",
          name: "Toda Bhim",
          state_id: "33",
        },
        {
          id: "3529",
          name: "Toda Raisingh",
          state_id: "33",
        },
        {
          id: "3530",
          name: "Todra",
          state_id: "33",
        },
        {
          id: "3531",
          name: "Tonk",
          state_id: "33",
        },
        {
          id: "3532",
          name: "Udaipur",
          state_id: "33",
        },
        {
          id: "3533",
          name: "Udpura",
          state_id: "33",
        },
        {
          id: "3534",
          name: "Uniara",
          state_id: "33",
        },
        {
          id: "3535",
          name: "Vanasthali",
          state_id: "33",
        },
        {
          id: "3536",
          name: "Vidyavihar",
          state_id: "33",
        },
        {
          id: "3537",
          name: "Vijainagar",
          state_id: "33",
        },
        {
          id: "3538",
          name: "Viratnagar",
          state_id: "33",
        },
        {
          id: "3539",
          name: "Wer",
          state_id: "33",
        },
      ],
      Sikkim: [
        {
          id: "3540",
          name: "Gangtok",
          state_id: "34",
        },
        {
          id: "3541",
          name: "Gezing",
          state_id: "34",
        },
        {
          id: "3542",
          name: "Jorethang",
          state_id: "34",
        },
        {
          id: "3543",
          name: "Mangan",
          state_id: "34",
        },
        {
          id: "3544",
          name: "Namchi",
          state_id: "34",
        },
        {
          id: "3545",
          name: "Naya Bazar",
          state_id: "34",
        },
        {
          id: "3546",
          name: "No City",
          state_id: "34",
        },
        {
          id: "3547",
          name: "Rangpo",
          state_id: "34",
        },
        {
          id: "3548",
          name: "Sikkim",
          state_id: "34",
        },
        {
          id: "3549",
          name: "Singtam",
          state_id: "34",
        },
        {
          id: "3550",
          name: "Upper Tadong",
          state_id: "34",
        },
      ],
      "Tamil Nadu": [
        {
          id: "3551",
          name: "Abiramam",
          state_id: "35",
        },
        {
          id: "3552",
          name: "Achampudur",
          state_id: "35",
        },
        {
          id: "3553",
          name: "Acharapakkam",
          state_id: "35",
        },
        {
          id: "3554",
          name: "Acharipallam",
          state_id: "35",
        },
        {
          id: "3555",
          name: "Achipatti",
          state_id: "35",
        },
        {
          id: "3556",
          name: "Adikaratti",
          state_id: "35",
        },
        {
          id: "3557",
          name: "Adiramapattinam",
          state_id: "35",
        },
        {
          id: "3558",
          name: "Aduturai",
          state_id: "35",
        },
        {
          id: "3559",
          name: "Adyar",
          state_id: "35",
        },
        {
          id: "3560",
          name: "Agaram",
          state_id: "35",
        },
        {
          id: "3561",
          name: "Agasthiswaram",
          state_id: "35",
        },
        {
          id: "3562",
          name: "Akkaraipettai",
          state_id: "35",
        },
        {
          id: "3563",
          name: "Alagappapuram",
          state_id: "35",
        },
        {
          id: "3564",
          name: "Alagapuri",
          state_id: "35",
        },
        {
          id: "3565",
          name: "Alampalayam",
          state_id: "35",
        },
        {
          id: "3566",
          name: "Alandur",
          state_id: "35",
        },
        {
          id: "3567",
          name: "Alanganallur",
          state_id: "35",
        },
        {
          id: "3568",
          name: "Alangayam",
          state_id: "35",
        },
        {
          id: "3569",
          name: "Alangudi",
          state_id: "35",
        },
        {
          id: "3570",
          name: "Alangulam",
          state_id: "35",
        },
        {
          id: "3571",
          name: "Alanthurai",
          state_id: "35",
        },
        {
          id: "3572",
          name: "Alapakkam",
          state_id: "35",
        },
        {
          id: "3573",
          name: "Allapuram",
          state_id: "35",
        },
        {
          id: "3574",
          name: "Alur",
          state_id: "35",
        },
        {
          id: "3575",
          name: "Alwar Tirunagari",
          state_id: "35",
        },
        {
          id: "3576",
          name: "Alwarkurichi",
          state_id: "35",
        },
        {
          id: "3577",
          name: "Ambasamudram",
          state_id: "35",
        },
        {
          id: "3578",
          name: "Ambur",
          state_id: "35",
        },
        {
          id: "3579",
          name: "Ammainaickanur",
          state_id: "35",
        },
        {
          id: "3580",
          name: "Ammaparikuppam",
          state_id: "35",
        },
        {
          id: "3581",
          name: "Ammapettai",
          state_id: "35",
        },
        {
          id: "3582",
          name: "Ammavarikuppam",
          state_id: "35",
        },
        {
          id: "3583",
          name: "Ammur",
          state_id: "35",
        },
        {
          id: "3584",
          name: "Anaimalai",
          state_id: "35",
        },
        {
          id: "3585",
          name: "Anaiyur",
          state_id: "35",
        },
        {
          id: "3586",
          name: "Anakaputhur",
          state_id: "35",
        },
        {
          id: "3587",
          name: "Ananthapuram",
          state_id: "35",
        },
        {
          id: "3588",
          name: "Andanappettai",
          state_id: "35",
        },
        {
          id: "3589",
          name: "Andipalayam",
          state_id: "35",
        },
        {
          id: "3590",
          name: "Andippatti",
          state_id: "35",
        },
        {
          id: "3591",
          name: "Anjugramam",
          state_id: "35",
        },
        {
          id: "3592",
          name: "Annamalainagar",
          state_id: "35",
        },
        {
          id: "3593",
          name: "Annavasal",
          state_id: "35",
        },
        {
          id: "3594",
          name: "Annur",
          state_id: "35",
        },
        {
          id: "3595",
          name: "Anthiyur",
          state_id: "35",
        },
        {
          id: "3596",
          name: "Appakudal",
          state_id: "35",
        },
        {
          id: "3597",
          name: "Arachalur",
          state_id: "35",
        },
        {
          id: "3598",
          name: "Arakandanallur",
          state_id: "35",
        },
        {
          id: "3599",
          name: "Arakonam",
          state_id: "35",
        },
        {
          id: "3600",
          name: "Aralvaimozhi",
          state_id: "35",
        },
        {
          id: "3601",
          name: "Arani",
          state_id: "35",
        },
        {
          id: "3602",
          name: "Arani Road",
          state_id: "35",
        },
        {
          id: "3603",
          name: "Arantangi",
          state_id: "35",
        },
        {
          id: "3604",
          name: "Arasiramani",
          state_id: "35",
        },
        {
          id: "3605",
          name: "Aravakurichi",
          state_id: "35",
        },
        {
          id: "3606",
          name: "Aravankadu",
          state_id: "35",
        },
        {
          id: "3607",
          name: "Arcot",
          state_id: "35",
        },
        {
          id: "3608",
          name: "Arimalam",
          state_id: "35",
        },
        {
          id: "3609",
          name: "Ariyalur",
          state_id: "35",
        },
        {
          id: "3610",
          name: "Ariyappampalayam",
          state_id: "35",
        },
        {
          id: "3611",
          name: "Ariyur",
          state_id: "35",
        },
        {
          id: "3612",
          name: "Arni",
          state_id: "35",
        },
        {
          id: "3613",
          name: "Arulmigu Thirumuruganpundi",
          state_id: "35",
        },
        {
          id: "3614",
          name: "Arumanai",
          state_id: "35",
        },
        {
          id: "3615",
          name: "Arumbavur",
          state_id: "35",
        },
        {
          id: "3616",
          name: "Arumuganeri",
          state_id: "35",
        },
        {
          id: "3617",
          name: "Aruppukkottai",
          state_id: "35",
        },
        {
          id: "3618",
          name: "Ashokapuram",
          state_id: "35",
        },
        {
          id: "3619",
          name: "Athani",
          state_id: "35",
        },
        {
          id: "3620",
          name: "Athanur",
          state_id: "35",
        },
        {
          id: "3621",
          name: "Athimarapatti",
          state_id: "35",
        },
        {
          id: "3622",
          name: "Athipattu",
          state_id: "35",
        },
        {
          id: "3623",
          name: "Athur",
          state_id: "35",
        },
        {
          id: "3624",
          name: "Attayyampatti",
          state_id: "35",
        },
        {
          id: "3625",
          name: "Attur",
          state_id: "35",
        },
        {
          id: "3626",
          name: "Auroville",
          state_id: "35",
        },
        {
          id: "3627",
          name: "Avadattur",
          state_id: "35",
        },
        {
          id: "3628",
          name: "Avadi",
          state_id: "35",
        },
        {
          id: "3629",
          name: "Avalpundurai",
          state_id: "35",
        },
        {
          id: "3630",
          name: "Avaniapuram",
          state_id: "35",
        },
        {
          id: "3631",
          name: "Avinashi",
          state_id: "35",
        },
        {
          id: "3632",
          name: "Ayakudi",
          state_id: "35",
        },
        {
          id: "3633",
          name: "Ayanadaippu",
          state_id: "35",
        },
        {
          id: "3634",
          name: "Aygudi",
          state_id: "35",
        },
        {
          id: "3635",
          name: "Ayothiapattinam",
          state_id: "35",
        },
        {
          id: "3636",
          name: "Ayyalur",
          state_id: "35",
        },
        {
          id: "3637",
          name: "Ayyampalayam",
          state_id: "35",
        },
        {
          id: "3638",
          name: "Ayyampettai",
          state_id: "35",
        },
        {
          id: "3639",
          name: "Azhagiapandiapuram",
          state_id: "35",
        },
        {
          id: "3640",
          name: "Balakrishnampatti",
          state_id: "35",
        },
        {
          id: "3641",
          name: "Balakrishnapuram",
          state_id: "35",
        },
        {
          id: "3642",
          name: "Balapallam",
          state_id: "35",
        },
        {
          id: "3643",
          name: "Balasamudram",
          state_id: "35",
        },
        {
          id: "3644",
          name: "Bargur",
          state_id: "35",
        },
        {
          id: "3645",
          name: "Belur",
          state_id: "35",
        },
        {
          id: "3646",
          name: "Berhatty",
          state_id: "35",
        },
        {
          id: "3647",
          name: "Bhavani",
          state_id: "35",
        },
        {
          id: "3648",
          name: "Bhawanisagar",
          state_id: "35",
        },
        {
          id: "3649",
          name: "Bhuvanagiri",
          state_id: "35",
        },
        {
          id: "3650",
          name: "Bikketti",
          state_id: "35",
        },
        {
          id: "3651",
          name: "Bodinayakkanur",
          state_id: "35",
        },
        {
          id: "3652",
          name: "Brahmana Periya Agraharam",
          state_id: "35",
        },
        {
          id: "3653",
          name: "Buthapandi",
          state_id: "35",
        },
        {
          id: "3654",
          name: "Buthipuram",
          state_id: "35",
        },
        {
          id: "3655",
          name: "Chatrapatti",
          state_id: "35",
        },
        {
          id: "3656",
          name: "Chembarambakkam",
          state_id: "35",
        },
        {
          id: "3657",
          name: "Chengalpattu",
          state_id: "35",
        },
        {
          id: "3658",
          name: "Chengam",
          state_id: "35",
        },
        {
          id: "3659",
          name: "Chennai",
          state_id: "35",
        },
        {
          id: "3660",
          name: "Chennasamudram",
          state_id: "35",
        },
        {
          id: "3661",
          name: "Chennimalai",
          state_id: "35",
        },
        {
          id: "3662",
          name: "Cheranmadevi",
          state_id: "35",
        },
        {
          id: "3663",
          name: "Cheruvanki",
          state_id: "35",
        },
        {
          id: "3664",
          name: "Chetpet",
          state_id: "35",
        },
        {
          id: "3665",
          name: "Chettiarpatti",
          state_id: "35",
        },
        {
          id: "3666",
          name: "Chettipalaiyam",
          state_id: "35",
        },
        {
          id: "3667",
          name: "Chettipalayam Cantonment",
          state_id: "35",
        },
        {
          id: "3668",
          name: "Chettithangal",
          state_id: "35",
        },
        {
          id: "3669",
          name: "Cheyur",
          state_id: "35",
        },
        {
          id: "3670",
          name: "Cheyyar",
          state_id: "35",
        },
        {
          id: "3671",
          name: "Chidambaram",
          state_id: "35",
        },
        {
          id: "3672",
          name: "Chinalapatti",
          state_id: "35",
        },
        {
          id: "3673",
          name: "Chinna Anuppanadi",
          state_id: "35",
        },
        {
          id: "3674",
          name: "Chinna Salem",
          state_id: "35",
        },
        {
          id: "3675",
          name: "Chinnakkampalayam",
          state_id: "35",
        },
        {
          id: "3676",
          name: "Chinnammanur",
          state_id: "35",
        },
        {
          id: "3677",
          name: "Chinnampalaiyam",
          state_id: "35",
        },
        {
          id: "3678",
          name: "Chinnasekkadu",
          state_id: "35",
        },
        {
          id: "3679",
          name: "Chinnavedampatti",
          state_id: "35",
        },
        {
          id: "3680",
          name: "Chitlapakkam",
          state_id: "35",
        },
        {
          id: "3681",
          name: "Chittodu",
          state_id: "35",
        },
        {
          id: "3682",
          name: "Cholapuram",
          state_id: "35",
        },
        {
          id: "3683",
          name: "Coimbatore",
          state_id: "35",
        },
        {
          id: "3684",
          name: "Coonoor",
          state_id: "35",
        },
        {
          id: "3685",
          name: "Courtalam",
          state_id: "35",
        },
        {
          id: "3686",
          name: "Cuddalore",
          state_id: "35",
        },
        {
          id: "3687",
          name: "Dalavaipatti",
          state_id: "35",
        },
        {
          id: "3688",
          name: "Darasuram",
          state_id: "35",
        },
        {
          id: "3689",
          name: "Denkanikottai",
          state_id: "35",
        },
        {
          id: "3690",
          name: "Desur",
          state_id: "35",
        },
        {
          id: "3691",
          name: "Devadanapatti",
          state_id: "35",
        },
        {
          id: "3692",
          name: "Devakkottai",
          state_id: "35",
        },
        {
          id: "3693",
          name: "Devakottai",
          state_id: "35",
        },
        {
          id: "3694",
          name: "Devanangurichi",
          state_id: "35",
        },
        {
          id: "3695",
          name: "Devarshola",
          state_id: "35",
        },
        {
          id: "3696",
          name: "Devasthanam",
          state_id: "35",
        },
        {
          id: "3697",
          name: "Dhalavoipuram",
          state_id: "35",
        },
        {
          id: "3698",
          name: "Dhali",
          state_id: "35",
        },
        {
          id: "3699",
          name: "Dhaliyur",
          state_id: "35",
        },
        {
          id: "3700",
          name: "Dharapadavedu",
          state_id: "35",
        },
        {
          id: "3701",
          name: "Dharapuram",
          state_id: "35",
        },
        {
          id: "3702",
          name: "Dharmapuri",
          state_id: "35",
        },
        {
          id: "3703",
          name: "Dindigul",
          state_id: "35",
        },
        {
          id: "3704",
          name: "Dusi",
          state_id: "35",
        },
        {
          id: "3705",
          name: "Edaganasalai",
          state_id: "35",
        },
        {
          id: "3706",
          name: "Edaikodu",
          state_id: "35",
        },
        {
          id: "3707",
          name: "Edakalinadu",
          state_id: "35",
        },
        {
          id: "3708",
          name: "Elathur",
          state_id: "35",
        },
        {
          id: "3709",
          name: "Elayirampannai",
          state_id: "35",
        },
        {
          id: "3710",
          name: "Elumalai",
          state_id: "35",
        },
        {
          id: "3711",
          name: "Eral",
          state_id: "35",
        },
        {
          id: "3712",
          name: "Eraniel",
          state_id: "35",
        },
        {
          id: "3713",
          name: "Eriodu",
          state_id: "35",
        },
        {
          id: "3714",
          name: "Erode",
          state_id: "35",
        },
        {
          id: "3715",
          name: "Erumaipatti",
          state_id: "35",
        },
        {
          id: "3716",
          name: "Eruvadi",
          state_id: "35",
        },
        {
          id: "3717",
          name: "Ethapur",
          state_id: "35",
        },
        {
          id: "3718",
          name: "Ettaiyapuram",
          state_id: "35",
        },
        {
          id: "3719",
          name: "Ettimadai",
          state_id: "35",
        },
        {
          id: "3720",
          name: "Ezhudesam",
          state_id: "35",
        },
        {
          id: "3721",
          name: "Ganapathipuram",
          state_id: "35",
        },
        {
          id: "3722",
          name: "Gandhi Nagar",
          state_id: "35",
        },
        {
          id: "3723",
          name: "Gangaikondan",
          state_id: "35",
        },
        {
          id: "3724",
          name: "Gangavalli",
          state_id: "35",
        },
        {
          id: "3725",
          name: "Ganguvarpatti",
          state_id: "35",
        },
        {
          id: "3726",
          name: "Gingi",
          state_id: "35",
        },
        {
          id: "3727",
          name: "Gopalasamudram",
          state_id: "35",
        },
        {
          id: "3728",
          name: "Gopichettipalaiyam",
          state_id: "35",
        },
        {
          id: "3729",
          name: "Gudalur",
          state_id: "35",
        },
        {
          id: "3730",
          name: "Gudiyattam",
          state_id: "35",
        },
        {
          id: "3731",
          name: "Guduvanchery",
          state_id: "35",
        },
        {
          id: "3732",
          name: "Gummidipoondi",
          state_id: "35",
        },
        {
          id: "3733",
          name: "Hanumanthampatti",
          state_id: "35",
        },
        {
          id: "3734",
          name: "Harur",
          state_id: "35",
        },
        {
          id: "3735",
          name: "Harveypatti",
          state_id: "35",
        },
        {
          id: "3736",
          name: "Highways",
          state_id: "35",
        },
        {
          id: "3737",
          name: "Hosur",
          state_id: "35",
        },
        {
          id: "3738",
          name: "Hubbathala",
          state_id: "35",
        },
        {
          id: "3739",
          name: "Huligal",
          state_id: "35",
        },
        {
          id: "3740",
          name: "Idappadi",
          state_id: "35",
        },
        {
          id: "3741",
          name: "Idikarai",
          state_id: "35",
        },
        {
          id: "3742",
          name: "Ilampillai",
          state_id: "35",
        },
        {
          id: "3743",
          name: "Ilanji",
          state_id: "35",
        },
        {
          id: "3744",
          name: "Iluppaiyurani",
          state_id: "35",
        },
        {
          id: "3745",
          name: "Iluppur",
          state_id: "35",
        },
        {
          id: "3746",
          name: "Inam Karur",
          state_id: "35",
        },
        {
          id: "3747",
          name: "Injambakkam",
          state_id: "35",
        },
        {
          id: "3748",
          name: "Irugur",
          state_id: "35",
        },
        {
          id: "3749",
          name: "Jaffrabad",
          state_id: "35",
        },
        {
          id: "3750",
          name: "Jagathala",
          state_id: "35",
        },
        {
          id: "3751",
          name: "Jalakandapuram",
          state_id: "35",
        },
        {
          id: "3752",
          name: "Jalladiampet",
          state_id: "35",
        },
        {
          id: "3753",
          name: "Jambai",
          state_id: "35",
        },
        {
          id: "3754",
          name: "Jayankondam",
          state_id: "35",
        },
        {
          id: "3755",
          name: "Jolarpet",
          state_id: "35",
        },
        {
          id: "3756",
          name: "Kadambur",
          state_id: "35",
        },
        {
          id: "3757",
          name: "Kadathur",
          state_id: "35",
        },
        {
          id: "3758",
          name: "Kadayal",
          state_id: "35",
        },
        {
          id: "3759",
          name: "Kadayampatti",
          state_id: "35",
        },
        {
          id: "3760",
          name: "Kadayanallur",
          state_id: "35",
        },
        {
          id: "3761",
          name: "Kadiapatti",
          state_id: "35",
        },
        {
          id: "3762",
          name: "Kalakkad",
          state_id: "35",
        },
        {
          id: "3763",
          name: "Kalambur",
          state_id: "35",
        },
        {
          id: "3764",
          name: "Kalapatti",
          state_id: "35",
        },
        {
          id: "3765",
          name: "Kalappanaickenpatti",
          state_id: "35",
        },
        {
          id: "3766",
          name: "Kalavai",
          state_id: "35",
        },
        {
          id: "3767",
          name: "Kalinjur",
          state_id: "35",
        },
        {
          id: "3768",
          name: "Kaliyakkavilai",
          state_id: "35",
        },
        {
          id: "3769",
          name: "Kallakkurichi",
          state_id: "35",
        },
        {
          id: "3770",
          name: "Kallakudi",
          state_id: "35",
        },
        {
          id: "3771",
          name: "Kallidaikurichchi",
          state_id: "35",
        },
        {
          id: "3772",
          name: "Kallukuttam",
          state_id: "35",
        },
        {
          id: "3773",
          name: "Kallupatti",
          state_id: "35",
        },
        {
          id: "3774",
          name: "Kalpakkam",
          state_id: "35",
        },
        {
          id: "3775",
          name: "Kalugumalai",
          state_id: "35",
        },
        {
          id: "3776",
          name: "Kamayagoundanpatti",
          state_id: "35",
        },
        {
          id: "3777",
          name: "Kambainallur",
          state_id: "35",
        },
        {
          id: "3778",
          name: "Kambam",
          state_id: "35",
        },
        {
          id: "3779",
          name: "Kamuthi",
          state_id: "35",
        },
        {
          id: "3780",
          name: "Kanadukathan",
          state_id: "35",
        },
        {
          id: "3781",
          name: "Kanakkampalayam",
          state_id: "35",
        },
        {
          id: "3782",
          name: "Kanam",
          state_id: "35",
        },
        {
          id: "3783",
          name: "Kanchipuram",
          state_id: "35",
        },
        {
          id: "3784",
          name: "Kandanur",
          state_id: "35",
        },
        {
          id: "3785",
          name: "Kangayam",
          state_id: "35",
        },
        {
          id: "3786",
          name: "Kangayampalayam",
          state_id: "35",
        },
        {
          id: "3787",
          name: "Kangeyanallur",
          state_id: "35",
        },
        {
          id: "3788",
          name: "Kaniyur",
          state_id: "35",
        },
        {
          id: "3789",
          name: "Kanjikoil",
          state_id: "35",
        },
        {
          id: "3790",
          name: "Kannadendal",
          state_id: "35",
        },
        {
          id: "3791",
          name: "Kannamangalam",
          state_id: "35",
        },
        {
          id: "3792",
          name: "Kannampalayam",
          state_id: "35",
        },
        {
          id: "3793",
          name: "Kannankurichi",
          state_id: "35",
        },
        {
          id: "3794",
          name: "Kannapalaiyam",
          state_id: "35",
        },
        {
          id: "3795",
          name: "Kannivadi",
          state_id: "35",
        },
        {
          id: "3796",
          name: "Kanyakumari",
          state_id: "35",
        },
        {
          id: "3797",
          name: "Kappiyarai",
          state_id: "35",
        },
        {
          id: "3798",
          name: "Karaikkudi",
          state_id: "35",
        },
        {
          id: "3799",
          name: "Karamadai",
          state_id: "35",
        },
        {
          id: "3800",
          name: "Karambakkam",
          state_id: "35",
        },
        {
          id: "3801",
          name: "Karambakkudi",
          state_id: "35",
        },
        {
          id: "3802",
          name: "Kariamangalam",
          state_id: "35",
        },
        {
          id: "3803",
          name: "Kariapatti",
          state_id: "35",
        },
        {
          id: "3804",
          name: "Karugampattur",
          state_id: "35",
        },
        {
          id: "3805",
          name: "Karumandi Chellipalayam",
          state_id: "35",
        },
        {
          id: "3806",
          name: "Karumathampatti",
          state_id: "35",
        },
        {
          id: "3807",
          name: "Karumbakkam",
          state_id: "35",
        },
        {
          id: "3808",
          name: "Karungal",
          state_id: "35",
        },
        {
          id: "3809",
          name: "Karunguzhi",
          state_id: "35",
        },
        {
          id: "3810",
          name: "Karuppur",
          state_id: "35",
        },
        {
          id: "3811",
          name: "Karur",
          state_id: "35",
        },
        {
          id: "3812",
          name: "Kasipalaiyam",
          state_id: "35",
        },
        {
          id: "3813",
          name: "Kasipalayam G",
          state_id: "35",
        },
        {
          id: "3814",
          name: "Kathirvedu",
          state_id: "35",
        },
        {
          id: "3815",
          name: "Kathujuganapalli",
          state_id: "35",
        },
        {
          id: "3816",
          name: "Katpadi",
          state_id: "35",
        },
        {
          id: "3817",
          name: "Kattivakkam",
          state_id: "35",
        },
        {
          id: "3818",
          name: "Kattumannarkoil",
          state_id: "35",
        },
        {
          id: "3819",
          name: "Kattupakkam",
          state_id: "35",
        },
        {
          id: "3820",
          name: "Kattuputhur",
          state_id: "35",
        },
        {
          id: "3821",
          name: "Kaveripakkam",
          state_id: "35",
        },
        {
          id: "3822",
          name: "Kaveripattinam",
          state_id: "35",
        },
        {
          id: "3823",
          name: "Kavundampalaiyam",
          state_id: "35",
        },
        {
          id: "3824",
          name: "Kavundampalayam",
          state_id: "35",
        },
        {
          id: "3825",
          name: "Kayalpattinam",
          state_id: "35",
        },
        {
          id: "3826",
          name: "Kayattar",
          state_id: "35",
        },
        {
          id: "3827",
          name: "Kelamangalam",
          state_id: "35",
        },
        {
          id: "3828",
          name: "Kelambakkam",
          state_id: "35",
        },
        {
          id: "3829",
          name: "Kembainaickenpalayam",
          state_id: "35",
        },
        {
          id: "3830",
          name: "Kethi",
          state_id: "35",
        },
        {
          id: "3831",
          name: "Kilakarai",
          state_id: "35",
        },
        {
          id: "3832",
          name: "Kilampadi",
          state_id: "35",
        },
        {
          id: "3833",
          name: "Kilkulam",
          state_id: "35",
        },
        {
          id: "3834",
          name: "Kilkunda",
          state_id: "35",
        },
        {
          id: "3835",
          name: "Killiyur",
          state_id: "35",
        },
        {
          id: "3836",
          name: "Killlai",
          state_id: "35",
        },
        {
          id: "3837",
          name: "Kilpennathur",
          state_id: "35",
        },
        {
          id: "3838",
          name: "Kilvelur",
          state_id: "35",
        },
        {
          id: "3839",
          name: "Kinathukadavu",
          state_id: "35",
        },
        {
          id: "3840",
          name: "Kiramangalam",
          state_id: "35",
        },
        {
          id: "3841",
          name: "Kiranur",
          state_id: "35",
        },
        {
          id: "3842",
          name: "Kiripatti",
          state_id: "35",
        },
        {
          id: "3843",
          name: "Kizhapavur",
          state_id: "35",
        },
        {
          id: "3844",
          name: "Kmarasamipatti",
          state_id: "35",
        },
        {
          id: "3845",
          name: "Kochadai",
          state_id: "35",
        },
        {
          id: "3846",
          name: "Kodaikanal",
          state_id: "35",
        },
        {
          id: "3847",
          name: "Kodambakkam",
          state_id: "35",
        },
        {
          id: "3848",
          name: "Kodavasal",
          state_id: "35",
        },
        {
          id: "3849",
          name: "Kodumudi",
          state_id: "35",
        },
        {
          id: "3850",
          name: "Kolachal",
          state_id: "35",
        },
        {
          id: "3851",
          name: "Kolappalur",
          state_id: "35",
        },
        {
          id: "3852",
          name: "Kolathupalayam",
          state_id: "35",
        },
        {
          id: "3853",
          name: "Kolathur",
          state_id: "35",
        },
        {
          id: "3854",
          name: "Kollankodu",
          state_id: "35",
        },
        {
          id: "3855",
          name: "Kollankoil",
          state_id: "35",
        },
        {
          id: "3856",
          name: "Komaralingam",
          state_id: "35",
        },
        {
          id: "3857",
          name: "Komarapalayam",
          state_id: "35",
        },
        {
          id: "3858",
          name: "Kombai",
          state_id: "35",
        },
        {
          id: "3859",
          name: "Konakkarai",
          state_id: "35",
        },
        {
          id: "3860",
          name: "Konavattam",
          state_id: "35",
        },
        {
          id: "3861",
          name: "Kondalampatti",
          state_id: "35",
        },
        {
          id: "3862",
          name: "Konganapuram",
          state_id: "35",
        },
        {
          id: "3863",
          name: "Koradacheri",
          state_id: "35",
        },
        {
          id: "3864",
          name: "Korampallam",
          state_id: "35",
        },
        {
          id: "3865",
          name: "Kotagiri",
          state_id: "35",
        },
        {
          id: "3866",
          name: "Kothinallur",
          state_id: "35",
        },
        {
          id: "3867",
          name: "Kottaiyur",
          state_id: "35",
        },
        {
          id: "3868",
          name: "Kottakuppam",
          state_id: "35",
        },
        {
          id: "3869",
          name: "Kottaram",
          state_id: "35",
        },
        {
          id: "3870",
          name: "Kottivakkam",
          state_id: "35",
        },
        {
          id: "3871",
          name: "Kottur",
          state_id: "35",
        },
        {
          id: "3872",
          name: "Kovilpatti",
          state_id: "35",
        },
        {
          id: "3873",
          name: "Koyampattur",
          state_id: "35",
        },
        {
          id: "3874",
          name: "Krishnagiri",
          state_id: "35",
        },
        {
          id: "3875",
          name: "Krishnarayapuram",
          state_id: "35",
        },
        {
          id: "3876",
          name: "Krishnasamudram",
          state_id: "35",
        },
        {
          id: "3877",
          name: "Kuchanur",
          state_id: "35",
        },
        {
          id: "3878",
          name: "Kuhalur",
          state_id: "35",
        },
        {
          id: "3879",
          name: "Kulasekarappattinam",
          state_id: "35",
        },
        {
          id: "3880",
          name: "Kulasekarapuram",
          state_id: "35",
        },
        {
          id: "3881",
          name: "Kulithalai",
          state_id: "35",
        },
        {
          id: "3882",
          name: "Kumarapalaiyam",
          state_id: "35",
        },
        {
          id: "3883",
          name: "Kumarapalayam",
          state_id: "35",
        },
        {
          id: "3884",
          name: "Kumarapuram",
          state_id: "35",
        },
        {
          id: "3885",
          name: "Kumbakonam",
          state_id: "35",
        },
        {
          id: "3886",
          name: "Kundrathur",
          state_id: "35",
        },
        {
          id: "3887",
          name: "Kuniyamuthur",
          state_id: "35",
        },
        {
          id: "3888",
          name: "Kunnathur",
          state_id: "35",
        },
        {
          id: "3889",
          name: "Kunur",
          state_id: "35",
        },
        {
          id: "3890",
          name: "Kuraikundu",
          state_id: "35",
        },
        {
          id: "3891",
          name: "Kurichi",
          state_id: "35",
        },
        {
          id: "3892",
          name: "Kurinjippadi",
          state_id: "35",
        },
        {
          id: "3893",
          name: "Kurudampalaiyam",
          state_id: "35",
        },
        {
          id: "3894",
          name: "Kurumbalur",
          state_id: "35",
        },
        {
          id: "3895",
          name: "Kuthalam",
          state_id: "35",
        },
        {
          id: "3896",
          name: "Kuthappar",
          state_id: "35",
        },
        {
          id: "3897",
          name: "Kuttalam",
          state_id: "35",
        },
        {
          id: "3898",
          name: "Kuttanallur",
          state_id: "35",
        },
        {
          id: "3899",
          name: "Kuzhithurai",
          state_id: "35",
        },
        {
          id: "3900",
          name: "Labbaikudikadu",
          state_id: "35",
        },
        {
          id: "3901",
          name: "Lakkampatti",
          state_id: "35",
        },
        {
          id: "3902",
          name: "Lalgudi",
          state_id: "35",
        },
        {
          id: "3903",
          name: "Lalpet",
          state_id: "35",
        },
        {
          id: "3904",
          name: "Llayangudi",
          state_id: "35",
        },
        {
          id: "3905",
          name: "Madambakkam",
          state_id: "35",
        },
        {
          id: "3906",
          name: "Madanur",
          state_id: "35",
        },
        {
          id: "3907",
          name: "Madathukulam",
          state_id: "35",
        },
        {
          id: "3908",
          name: "Madhavaram",
          state_id: "35",
        },
        {
          id: "3909",
          name: "Madippakkam",
          state_id: "35",
        },
        {
          id: "3910",
          name: "Madukkarai",
          state_id: "35",
        },
        {
          id: "3911",
          name: "Madukkur",
          state_id: "35",
        },
        {
          id: "3912",
          name: "Madurai",
          state_id: "35",
        },
        {
          id: "3913",
          name: "Maduranthakam",
          state_id: "35",
        },
        {
          id: "3914",
          name: "Maduravoyal",
          state_id: "35",
        },
        {
          id: "3915",
          name: "Mahabalipuram",
          state_id: "35",
        },
        {
          id: "3916",
          name: "Makkinanpatti",
          state_id: "35",
        },
        {
          id: "3917",
          name: "Mallamuppampatti",
          state_id: "35",
        },
        {
          id: "3918",
          name: "Mallankinaru",
          state_id: "35",
        },
        {
          id: "3919",
          name: "Mallapuram",
          state_id: "35",
        },
        {
          id: "3920",
          name: "Mallasamudram",
          state_id: "35",
        },
        {
          id: "3921",
          name: "Mallur",
          state_id: "35",
        },
        {
          id: "3922",
          name: "Mamallapuram",
          state_id: "35",
        },
        {
          id: "3923",
          name: "Mamsapuram",
          state_id: "35",
        },
        {
          id: "3924",
          name: "Manachanallur",
          state_id: "35",
        },
        {
          id: "3925",
          name: "Manali",
          state_id: "35",
        },
        {
          id: "3926",
          name: "Manalmedu",
          state_id: "35",
        },
        {
          id: "3927",
          name: "Manalurpet",
          state_id: "35",
        },
        {
          id: "3928",
          name: "Manamadurai",
          state_id: "35",
        },
        {
          id: "3929",
          name: "Manapakkam",
          state_id: "35",
        },
        {
          id: "3930",
          name: "Manapparai",
          state_id: "35",
        },
        {
          id: "3931",
          name: "Manavalakurichi",
          state_id: "35",
        },
        {
          id: "3932",
          name: "Mandaikadu",
          state_id: "35",
        },
        {
          id: "3933",
          name: "Mandapam",
          state_id: "35",
        },
        {
          id: "3934",
          name: "Mangadu",
          state_id: "35",
        },
        {
          id: "3935",
          name: "Mangalam",
          state_id: "35",
        },
        {
          id: "3936",
          name: "Mangalampet",
          state_id: "35",
        },
        {
          id: "3937",
          name: "Manimutharu",
          state_id: "35",
        },
        {
          id: "3938",
          name: "Mannargudi",
          state_id: "35",
        },
        {
          id: "3939",
          name: "Mappilaiurani",
          state_id: "35",
        },
        {
          id: "3940",
          name: "Maraimalai Nagar",
          state_id: "35",
        },
        {
          id: "3941",
          name: "Marakkanam",
          state_id: "35",
        },
        {
          id: "3942",
          name: "Maramangalathupatti",
          state_id: "35",
        },
        {
          id: "3943",
          name: "Marandahalli",
          state_id: "35",
        },
        {
          id: "3944",
          name: "Markayankottai",
          state_id: "35",
        },
        {
          id: "3945",
          name: "Marudur",
          state_id: "35",
        },
        {
          id: "3946",
          name: "Marungur",
          state_id: "35",
        },
        {
          id: "3947",
          name: "Masinigudi",
          state_id: "35",
        },
        {
          id: "3948",
          name: "Mathigiri",
          state_id: "35",
        },
        {
          id: "3949",
          name: "Mattur",
          state_id: "35",
        },
        {
          id: "3950",
          name: "Mayiladuthurai",
          state_id: "35",
        },
        {
          id: "3951",
          name: "Mecheri",
          state_id: "35",
        },
        {
          id: "3952",
          name: "Melacheval",
          state_id: "35",
        },
        {
          id: "3953",
          name: "Melachokkanathapuram",
          state_id: "35",
        },
        {
          id: "3954",
          name: "Melagaram",
          state_id: "35",
        },
        {
          id: "3955",
          name: "Melamadai",
          state_id: "35",
        },
        {
          id: "3956",
          name: "Melamaiyur",
          state_id: "35",
        },
        {
          id: "3957",
          name: "Melanattam",
          state_id: "35",
        },
        {
          id: "3958",
          name: "Melathiruppanthuruthi",
          state_id: "35",
        },
        {
          id: "3959",
          name: "Melattur",
          state_id: "35",
        },
        {
          id: "3960",
          name: "Melmananbedu",
          state_id: "35",
        },
        {
          id: "3961",
          name: "Melpattampakkam",
          state_id: "35",
        },
        {
          id: "3962",
          name: "Melur",
          state_id: "35",
        },
        {
          id: "3963",
          name: "Melvisharam",
          state_id: "35",
        },
        {
          id: "3964",
          name: "Mettupalayam",
          state_id: "35",
        },
        {
          id: "3965",
          name: "Mettur",
          state_id: "35",
        },
        {
          id: "3966",
          name: "Meyyanur",
          state_id: "35",
        },
        {
          id: "3967",
          name: "Milavittan",
          state_id: "35",
        },
        {
          id: "3968",
          name: "Minakshipuram",
          state_id: "35",
        },
        {
          id: "3969",
          name: "Minambakkam",
          state_id: "35",
        },
        {
          id: "3970",
          name: "Minjur",
          state_id: "35",
        },
        {
          id: "3971",
          name: "Modakurichi",
          state_id: "35",
        },
        {
          id: "3972",
          name: "Mohanur",
          state_id: "35",
        },
        {
          id: "3973",
          name: "Mopperipalayam",
          state_id: "35",
        },
        {
          id: "3974",
          name: "Mudalur",
          state_id: "35",
        },
        {
          id: "3975",
          name: "Mudichur",
          state_id: "35",
        },
        {
          id: "3976",
          name: "Mudukulathur",
          state_id: "35",
        },
        {
          id: "3977",
          name: "Mukasipidariyur",
          state_id: "35",
        },
        {
          id: "3978",
          name: "Mukkudal",
          state_id: "35",
        },
        {
          id: "3979",
          name: "Mulagumudu",
          state_id: "35",
        },
        {
          id: "3980",
          name: "Mulakaraipatti",
          state_id: "35",
        },
        {
          id: "3981",
          name: "Mulanur",
          state_id: "35",
        },
        {
          id: "3982",
          name: "Mullakkadu",
          state_id: "35",
        },
        {
          id: "3983",
          name: "Muruganpalayam",
          state_id: "35",
        },
        {
          id: "3984",
          name: "Musiri",
          state_id: "35",
        },
        {
          id: "3985",
          name: "Muthupet",
          state_id: "35",
        },
        {
          id: "3986",
          name: "Muthur",
          state_id: "35",
        },
        {
          id: "3987",
          name: "Muttayyapuram",
          state_id: "35",
        },
        {
          id: "3988",
          name: "Muttupet",
          state_id: "35",
        },
        {
          id: "3989",
          name: "Muvarasampettai",
          state_id: "35",
        },
        {
          id: "3990",
          name: "Myladi",
          state_id: "35",
        },
        {
          id: "3991",
          name: "Mylapore",
          state_id: "35",
        },
        {
          id: "3992",
          name: "Nadukkuthagai",
          state_id: "35",
        },
        {
          id: "3993",
          name: "Naduvattam",
          state_id: "35",
        },
        {
          id: "3994",
          name: "Nagapattinam",
          state_id: "35",
        },
        {
          id: "3995",
          name: "Nagavakulam",
          state_id: "35",
        },
        {
          id: "3996",
          name: "Nagercoil",
          state_id: "35",
        },
        {
          id: "3997",
          name: "Nagojanahalli",
          state_id: "35",
        },
        {
          id: "3998",
          name: "Nallampatti",
          state_id: "35",
        },
        {
          id: "3999",
          name: "Nallur",
          state_id: "35",
        },
        {
          id: "4000",
          name: "Namagiripettai",
          state_id: "35",
        },
        {
          id: "4001",
          name: "Namakkal",
          state_id: "35",
        },
        {
          id: "4002",
          name: "Nambiyur",
          state_id: "35",
        },
        {
          id: "4003",
          name: "Nambutalai",
          state_id: "35",
        },
        {
          id: "4004",
          name: "Nandambakkam",
          state_id: "35",
        },
        {
          id: "4005",
          name: "Nandivaram",
          state_id: "35",
        },
        {
          id: "4006",
          name: "Nangavalli",
          state_id: "35",
        },
        {
          id: "4007",
          name: "Nangavaram",
          state_id: "35",
        },
        {
          id: "4008",
          name: "Nanguneri",
          state_id: "35",
        },
        {
          id: "4009",
          name: "Nanjikottai",
          state_id: "35",
        },
        {
          id: "4010",
          name: "Nannilam",
          state_id: "35",
        },
        {
          id: "4011",
          name: "Naranammalpuram",
          state_id: "35",
        },
        {
          id: "4012",
          name: "Naranapuram",
          state_id: "35",
        },
        {
          id: "4013",
          name: "Narasimhanaickenpalayam",
          state_id: "35",
        },
        {
          id: "4014",
          name: "Narasingapuram",
          state_id: "35",
        },
        {
          id: "4015",
          name: "Narasojipatti",
          state_id: "35",
        },
        {
          id: "4016",
          name: "Naravarikuppam",
          state_id: "35",
        },
        {
          id: "4017",
          name: "Nasiyanur",
          state_id: "35",
        },
        {
          id: "4018",
          name: "Natham",
          state_id: "35",
        },
        {
          id: "4019",
          name: "Nathampannai",
          state_id: "35",
        },
        {
          id: "4020",
          name: "Natrampalli",
          state_id: "35",
        },
        {
          id: "4021",
          name: "Nattam",
          state_id: "35",
        },
        {
          id: "4022",
          name: "Nattapettai",
          state_id: "35",
        },
        {
          id: "4023",
          name: "Nattarasankottai",
          state_id: "35",
        },
        {
          id: "4024",
          name: "Navalpattu",
          state_id: "35",
        },
        {
          id: "4025",
          name: "Nazarethpettai",
          state_id: "35",
        },
        {
          id: "4026",
          name: "Nazerath",
          state_id: "35",
        },
        {
          id: "4027",
          name: "Neikkarapatti",
          state_id: "35",
        },
        {
          id: "4028",
          name: "Neiyyur",
          state_id: "35",
        },
        {
          id: "4029",
          name: "Nellikkuppam",
          state_id: "35",
        },
        {
          id: "4030",
          name: "Nelliyalam",
          state_id: "35",
        },
        {
          id: "4031",
          name: "Nemili",
          state_id: "35",
        },
        {
          id: "4032",
          name: "Nemilicheri",
          state_id: "35",
        },
        {
          id: "4033",
          name: "Neripperichal",
          state_id: "35",
        },
        {
          id: "4034",
          name: "Nerkunram",
          state_id: "35",
        },
        {
          id: "4035",
          name: "Nerkuppai",
          state_id: "35",
        },
        {
          id: "4036",
          name: "Nerunjipettai",
          state_id: "35",
        },
        {
          id: "4037",
          name: "Neykkarappatti",
          state_id: "35",
        },
        {
          id: "4038",
          name: "Neyveli",
          state_id: "35",
        },
        {
          id: "4039",
          name: "Nidamangalam",
          state_id: "35",
        },
        {
          id: "4040",
          name: "Nilagiri",
          state_id: "35",
        },
        {
          id: "4041",
          name: "Nilakkottai",
          state_id: "35",
        },
        {
          id: "4042",
          name: "Nilankarai",
          state_id: "35",
        },
        {
          id: "4043",
          name: "Odaipatti",
          state_id: "35",
        },
        {
          id: "4044",
          name: "Odaiyakulam",
          state_id: "35",
        },
        {
          id: "4045",
          name: "Oddanchatram",
          state_id: "35",
        },
        {
          id: "4046",
          name: "Odugathur",
          state_id: "35",
        },
        {
          id: "4047",
          name: "Oggiyamduraipakkam",
          state_id: "35",
        },
        {
          id: "4048",
          name: "Olagadam",
          state_id: "35",
        },
        {
          id: "4049",
          name: "Omalur",
          state_id: "35",
        },
        {
          id: "4050",
          name: "Ooty",
          state_id: "35",
        },
        {
          id: "4051",
          name: "Orathanadu",
          state_id: "35",
        },
        {
          id: "4052",
          name: "Othakadai",
          state_id: "35",
        },
        {
          id: "4053",
          name: "Othakalmandapam",
          state_id: "35",
        },
        {
          id: "4054",
          name: "Ottapparai",
          state_id: "35",
        },
        {
          id: "4055",
          name: "Pacode",
          state_id: "35",
        },
        {
          id: "4056",
          name: "Padaividu",
          state_id: "35",
        },
        {
          id: "4057",
          name: "Padianallur",
          state_id: "35",
        },
        {
          id: "4058",
          name: "Padirikuppam",
          state_id: "35",
        },
        {
          id: "4059",
          name: "Padmanabhapuram",
          state_id: "35",
        },
        {
          id: "4060",
          name: "Padririvedu",
          state_id: "35",
        },
        {
          id: "4061",
          name: "Palaganangudy",
          state_id: "35",
        },
        {
          id: "4062",
          name: "Palaimpatti",
          state_id: "35",
        },
        {
          id: "4063",
          name: "Palakkodu",
          state_id: "35",
        },
        {
          id: "4064",
          name: "Palamedu",
          state_id: "35",
        },
        {
          id: "4065",
          name: "Palani",
          state_id: "35",
        },
        {
          id: "4066",
          name: "Palani Chettipatti",
          state_id: "35",
        },
        {
          id: "4067",
          name: "Palavakkam",
          state_id: "35",
        },
        {
          id: "4068",
          name: "Palavansathu",
          state_id: "35",
        },
        {
          id: "4069",
          name: "Palayakayal",
          state_id: "35",
        },
        {
          id: "4070",
          name: "Palayam",
          state_id: "35",
        },
        {
          id: "4071",
          name: "Palayamkottai",
          state_id: "35",
        },
        {
          id: "4072",
          name: "Palladam",
          state_id: "35",
        },
        {
          id: "4073",
          name: "Pallapalayam",
          state_id: "35",
        },
        {
          id: "4074",
          name: "Pallapatti",
          state_id: "35",
        },
        {
          id: "4075",
          name: "Pallattur",
          state_id: "35",
        },
        {
          id: "4076",
          name: "Pallavaram",
          state_id: "35",
        },
        {
          id: "4077",
          name: "Pallikaranai",
          state_id: "35",
        },
        {
          id: "4078",
          name: "Pallikonda",
          state_id: "35",
        },
        {
          id: "4079",
          name: "Pallipalaiyam",
          state_id: "35",
        },
        {
          id: "4080",
          name: "Pallipalaiyam Agraharam",
          state_id: "35",
        },
        {
          id: "4081",
          name: "Pallipattu",
          state_id: "35",
        },
        {
          id: "4082",
          name: "Pammal",
          state_id: "35",
        },
        {
          id: "4083",
          name: "Panagudi",
          state_id: "35",
        },
        {
          id: "4084",
          name: "Panaimarathupatti",
          state_id: "35",
        },
        {
          id: "4085",
          name: "Panapakkam",
          state_id: "35",
        },
        {
          id: "4086",
          name: "Panboli",
          state_id: "35",
        },
        {
          id: "4087",
          name: "Pandamangalam",
          state_id: "35",
        },
        {
          id: "4088",
          name: "Pannaikadu",
          state_id: "35",
        },
        {
          id: "4089",
          name: "Pannaipuram",
          state_id: "35",
        },
        {
          id: "4090",
          name: "Pannuratti",
          state_id: "35",
        },
        {
          id: "4091",
          name: "Panruti",
          state_id: "35",
        },
        {
          id: "4092",
          name: "Papanasam",
          state_id: "35",
        },
        {
          id: "4093",
          name: "Pappankurichi",
          state_id: "35",
        },
        {
          id: "4094",
          name: "Papparapatti",
          state_id: "35",
        },
        {
          id: "4095",
          name: "Pappireddipatti",
          state_id: "35",
        },
        {
          id: "4096",
          name: "Paramakkudi",
          state_id: "35",
        },
        {
          id: "4097",
          name: "Paramankurichi",
          state_id: "35",
        },
        {
          id: "4098",
          name: "Paramathi",
          state_id: "35",
        },
        {
          id: "4099",
          name: "Parangippettai",
          state_id: "35",
        },
        {
          id: "4100",
          name: "Paravai",
          state_id: "35",
        },
        {
          id: "4101",
          name: "Pasur",
          state_id: "35",
        },
        {
          id: "4102",
          name: "Pathamadai",
          state_id: "35",
        },
        {
          id: "4103",
          name: "Pattinam",
          state_id: "35",
        },
        {
          id: "4104",
          name: "Pattiviranpatti",
          state_id: "35",
        },
        {
          id: "4105",
          name: "Pattukkottai",
          state_id: "35",
        },
        {
          id: "4106",
          name: "Pazhugal",
          state_id: "35",
        },
        {
          id: "4107",
          name: "Pennadam",
          state_id: "35",
        },
        {
          id: "4108",
          name: "Pennagaram",
          state_id: "35",
        },
        {
          id: "4109",
          name: "Pennathur",
          state_id: "35",
        },
        {
          id: "4110",
          name: "Peraiyur",
          state_id: "35",
        },
        {
          id: "4111",
          name: "Peralam",
          state_id: "35",
        },
        {
          id: "4112",
          name: "Perambalur",
          state_id: "35",
        },
        {
          id: "4113",
          name: "Peranamallur",
          state_id: "35",
        },
        {
          id: "4114",
          name: "Peravurani",
          state_id: "35",
        },
        {
          id: "4115",
          name: "Periyakodiveri",
          state_id: "35",
        },
        {
          id: "4116",
          name: "Periyakulam",
          state_id: "35",
        },
        {
          id: "4117",
          name: "Periyanayakkanpalaiyam",
          state_id: "35",
        },
        {
          id: "4118",
          name: "Periyanegamam",
          state_id: "35",
        },
        {
          id: "4119",
          name: "Periyapatti",
          state_id: "35",
        },
        {
          id: "4120",
          name: "Periyasemur",
          state_id: "35",
        },
        {
          id: "4121",
          name: "Pernambut",
          state_id: "35",
        },
        {
          id: "4122",
          name: "Perumagalur",
          state_id: "35",
        },
        {
          id: "4123",
          name: "Perumandi",
          state_id: "35",
        },
        {
          id: "4124",
          name: "Perumuchi",
          state_id: "35",
        },
        {
          id: "4125",
          name: "Perundurai",
          state_id: "35",
        },
        {
          id: "4126",
          name: "Perungalathur",
          state_id: "35",
        },
        {
          id: "4127",
          name: "Perungudi",
          state_id: "35",
        },
        {
          id: "4128",
          name: "Perungulam",
          state_id: "35",
        },
        {
          id: "4129",
          name: "Perur",
          state_id: "35",
        },
        {
          id: "4130",
          name: "Perur Chettipalaiyam",
          state_id: "35",
        },
        {
          id: "4131",
          name: "Pethampalayam",
          state_id: "35",
        },
        {
          id: "4132",
          name: "Pethanaickenpalayam",
          state_id: "35",
        },
        {
          id: "4133",
          name: "Pillanallur",
          state_id: "35",
        },
        {
          id: "4134",
          name: "Pirkankaranai",
          state_id: "35",
        },
        {
          id: "4135",
          name: "Polichalur",
          state_id: "35",
        },
        {
          id: "4136",
          name: "Pollachi",
          state_id: "35",
        },
        {
          id: "4137",
          name: "Polur",
          state_id: "35",
        },
        {
          id: "4138",
          name: "Ponmani",
          state_id: "35",
        },
        {
          id: "4139",
          name: "Ponnamaravathi",
          state_id: "35",
        },
        {
          id: "4140",
          name: "Ponnampatti",
          state_id: "35",
        },
        {
          id: "4141",
          name: "Ponneri",
          state_id: "35",
        },
        {
          id: "4142",
          name: "Porur",
          state_id: "35",
        },
        {
          id: "4143",
          name: "Pothanur",
          state_id: "35",
        },
        {
          id: "4144",
          name: "Pothatturpettai",
          state_id: "35",
        },
        {
          id: "4145",
          name: "Pudukadai",
          state_id: "35",
        },
        {
          id: "4146",
          name: "Pudukkottai Cantonment",
          state_id: "35",
        },
        {
          id: "4147",
          name: "Pudukottai",
          state_id: "35",
        },
        {
          id: "4148",
          name: "Pudupalaiyam Aghraharam",
          state_id: "35",
        },
        {
          id: "4149",
          name: "Pudupalayam",
          state_id: "35",
        },
        {
          id: "4150",
          name: "Pudupatti",
          state_id: "35",
        },
        {
          id: "4151",
          name: "Pudupattinam",
          state_id: "35",
        },
        {
          id: "4152",
          name: "Pudur",
          state_id: "35",
        },
        {
          id: "4153",
          name: "Puduvayal",
          state_id: "35",
        },
        {
          id: "4154",
          name: "Pulambadi",
          state_id: "35",
        },
        {
          id: "4155",
          name: "Pulampatti",
          state_id: "35",
        },
        {
          id: "4156",
          name: "Puliyampatti",
          state_id: "35",
        },
        {
          id: "4157",
          name: "Puliyankudi",
          state_id: "35",
        },
        {
          id: "4158",
          name: "Puliyur",
          state_id: "35",
        },
        {
          id: "4159",
          name: "Pullampadi",
          state_id: "35",
        },
        {
          id: "4160",
          name: "Puluvapatti",
          state_id: "35",
        },
        {
          id: "4161",
          name: "Punamalli",
          state_id: "35",
        },
        {
          id: "4162",
          name: "Punjai Puliyampatti",
          state_id: "35",
        },
        {
          id: "4163",
          name: "Punjai Thottakurichi",
          state_id: "35",
        },
        {
          id: "4164",
          name: "Punjaipugalur",
          state_id: "35",
        },
        {
          id: "4165",
          name: "Puthalam",
          state_id: "35",
        },
        {
          id: "4166",
          name: "Putteri",
          state_id: "35",
        },
        {
          id: "4167",
          name: "Puvalur",
          state_id: "35",
        },
        {
          id: "4168",
          name: "Puzhal",
          state_id: "35",
        },
        {
          id: "4169",
          name: "Puzhithivakkam",
          state_id: "35",
        },
        {
          id: "4170",
          name: "Rajapalayam",
          state_id: "35",
        },
        {
          id: "4171",
          name: "Ramanathapuram",
          state_id: "35",
        },
        {
          id: "4172",
          name: "Ramapuram",
          state_id: "35",
        },
        {
          id: "4173",
          name: "Rameswaram",
          state_id: "35",
        },
        {
          id: "4174",
          name: "Ranipet",
          state_id: "35",
        },
        {
          id: "4175",
          name: "Rasipuram",
          state_id: "35",
        },
        {
          id: "4176",
          name: "Rayagiri",
          state_id: "35",
        },
        {
          id: "4177",
          name: "Rithapuram",
          state_id: "35",
        },
        {
          id: "4178",
          name: "Rosalpatti",
          state_id: "35",
        },
        {
          id: "4179",
          name: "Rudravathi",
          state_id: "35",
        },
        {
          id: "4180",
          name: "Sadayankuppam",
          state_id: "35",
        },
        {
          id: "4181",
          name: "Saint Thomas Mount",
          state_id: "35",
        },
        {
          id: "4182",
          name: "Salangapalayam",
          state_id: "35",
        },
        {
          id: "4183",
          name: "Salem",
          state_id: "35",
        },
        {
          id: "4184",
          name: "Samalapuram",
          state_id: "35",
        },
        {
          id: "4185",
          name: "Samathur",
          state_id: "35",
        },
        {
          id: "4186",
          name: "Sambavar Vadagarai",
          state_id: "35",
        },
        {
          id: "4187",
          name: "Sankaramanallur",
          state_id: "35",
        },
        {
          id: "4188",
          name: "Sankarankoil",
          state_id: "35",
        },
        {
          id: "4189",
          name: "Sankarapuram",
          state_id: "35",
        },
        {
          id: "4190",
          name: "Sankari",
          state_id: "35",
        },
        {
          id: "4191",
          name: "Sankarnagar",
          state_id: "35",
        },
        {
          id: "4192",
          name: "Saravanampatti",
          state_id: "35",
        },
        {
          id: "4193",
          name: "Sarcarsamakulam",
          state_id: "35",
        },
        {
          id: "4194",
          name: "Sathiyavijayanagaram",
          state_id: "35",
        },
        {
          id: "4195",
          name: "Sathuvachari",
          state_id: "35",
        },
        {
          id: "4196",
          name: "Sathyamangalam",
          state_id: "35",
        },
        {
          id: "4197",
          name: "Sattankulam",
          state_id: "35",
        },
        {
          id: "4198",
          name: "Sattur",
          state_id: "35",
        },
        {
          id: "4199",
          name: "Sayalgudi",
          state_id: "35",
        },
        {
          id: "4200",
          name: "Sayapuram",
          state_id: "35",
        },
        {
          id: "4201",
          name: "Seithur",
          state_id: "35",
        },
        {
          id: "4202",
          name: "Sembakkam",
          state_id: "35",
        },
        {
          id: "4203",
          name: "Semmipalayam",
          state_id: "35",
        },
        {
          id: "4204",
          name: "Sennirkuppam",
          state_id: "35",
        },
        {
          id: "4205",
          name: "Senthamangalam",
          state_id: "35",
        },
        {
          id: "4206",
          name: "Sentharapatti",
          state_id: "35",
        },
        {
          id: "4207",
          name: "Senur",
          state_id: "35",
        },
        {
          id: "4208",
          name: "Sethiathoppu",
          state_id: "35",
        },
        {
          id: "4209",
          name: "Sevilimedu",
          state_id: "35",
        },
        {
          id: "4210",
          name: "Sevugampatti",
          state_id: "35",
        },
        {
          id: "4211",
          name: "Shenbakkam",
          state_id: "35",
        },
        {
          id: "4212",
          name: "Shencottai",
          state_id: "35",
        },
        {
          id: "4213",
          name: "Shenkottai",
          state_id: "35",
        },
        {
          id: "4214",
          name: "Sholavandan",
          state_id: "35",
        },
        {
          id: "4215",
          name: "Sholinganallur",
          state_id: "35",
        },
        {
          id: "4216",
          name: "Sholingur",
          state_id: "35",
        },
        {
          id: "4217",
          name: "Sholur",
          state_id: "35",
        },
        {
          id: "4218",
          name: "Sikkarayapuram",
          state_id: "35",
        },
        {
          id: "4219",
          name: "Singampuneri",
          state_id: "35",
        },
        {
          id: "4220",
          name: "Singanallur",
          state_id: "35",
        },
        {
          id: "4221",
          name: "Singaperumalkoil",
          state_id: "35",
        },
        {
          id: "4222",
          name: "Sirapalli",
          state_id: "35",
        },
        {
          id: "4223",
          name: "Sirkali",
          state_id: "35",
        },
        {
          id: "4224",
          name: "Sirugamani",
          state_id: "35",
        },
        {
          id: "4225",
          name: "Sirumugai",
          state_id: "35",
        },
        {
          id: "4226",
          name: "Sithayankottai",
          state_id: "35",
        },
        {
          id: "4227",
          name: "Sithurajapuram",
          state_id: "35",
        },
        {
          id: "4228",
          name: "Sivaganga",
          state_id: "35",
        },
        {
          id: "4229",
          name: "Sivagiri",
          state_id: "35",
        },
        {
          id: "4230",
          name: "Sivakasi",
          state_id: "35",
        },
        {
          id: "4231",
          name: "Sivanthipuram",
          state_id: "35",
        },
        {
          id: "4232",
          name: "Sivur",
          state_id: "35",
        },
        {
          id: "4233",
          name: "Soranjeri",
          state_id: "35",
        },
        {
          id: "4234",
          name: "South Kannanur",
          state_id: "35",
        },
        {
          id: "4235",
          name: "South Kodikulam",
          state_id: "35",
        },
        {
          id: "4236",
          name: "Srimushnam",
          state_id: "35",
        },
        {
          id: "4237",
          name: "Sriperumpudur",
          state_id: "35",
        },
        {
          id: "4238",
          name: "Sriramapuram",
          state_id: "35",
        },
        {
          id: "4239",
          name: "Srirangam",
          state_id: "35",
        },
        {
          id: "4240",
          name: "Srivaikuntam",
          state_id: "35",
        },
        {
          id: "4241",
          name: "Srivilliputtur",
          state_id: "35",
        },
        {
          id: "4242",
          name: "Suchindram",
          state_id: "35",
        },
        {
          id: "4243",
          name: "Suliswaranpatti",
          state_id: "35",
        },
        {
          id: "4244",
          name: "Sulur",
          state_id: "35",
        },
        {
          id: "4245",
          name: "Sundarapandiam",
          state_id: "35",
        },
        {
          id: "4246",
          name: "Sundarapandiapuram",
          state_id: "35",
        },
        {
          id: "4247",
          name: "Surampatti",
          state_id: "35",
        },
        {
          id: "4248",
          name: "Surandai",
          state_id: "35",
        },
        {
          id: "4249",
          name: "Suriyampalayam",
          state_id: "35",
        },
        {
          id: "4250",
          name: "Swamimalai",
          state_id: "35",
        },
        {
          id: "4251",
          name: "TNPL Pugalur",
          state_id: "35",
        },
        {
          id: "4252",
          name: "Tambaram",
          state_id: "35",
        },
        {
          id: "4253",
          name: "Taramangalam",
          state_id: "35",
        },
        {
          id: "4254",
          name: "Tattayyangarpettai",
          state_id: "35",
        },
        {
          id: "4255",
          name: "Tayilupatti",
          state_id: "35",
        },
        {
          id: "4256",
          name: "Tenkasi",
          state_id: "35",
        },
        {
          id: "4257",
          name: "Thadikombu",
          state_id: "35",
        },
        {
          id: "4258",
          name: "Thakkolam",
          state_id: "35",
        },
        {
          id: "4259",
          name: "Thalainayar",
          state_id: "35",
        },
        {
          id: "4260",
          name: "Thalakudi",
          state_id: "35",
        },
        {
          id: "4261",
          name: "Thamaraikulam",
          state_id: "35",
        },
        {
          id: "4262",
          name: "Thammampatti",
          state_id: "35",
        },
        {
          id: "4263",
          name: "Thanjavur",
          state_id: "35",
        },
        {
          id: "4264",
          name: "Thanthoni",
          state_id: "35",
        },
        {
          id: "4265",
          name: "Tharangambadi",
          state_id: "35",
        },
        {
          id: "4266",
          name: "Thedavur",
          state_id: "35",
        },
        {
          id: "4267",
          name: "Thenambakkam",
          state_id: "35",
        },
        {
          id: "4268",
          name: "Thengampudur",
          state_id: "35",
        },
        {
          id: "4269",
          name: "Theni",
          state_id: "35",
        },
        {
          id: "4270",
          name: "Theni Allinagaram",
          state_id: "35",
        },
        {
          id: "4271",
          name: "Thenkarai",
          state_id: "35",
        },
        {
          id: "4272",
          name: "Thenthamaraikulam",
          state_id: "35",
        },
        {
          id: "4273",
          name: "Thenthiruperai",
          state_id: "35",
        },
        {
          id: "4274",
          name: "Thesur",
          state_id: "35",
        },
        {
          id: "4275",
          name: "Thevaram",
          state_id: "35",
        },
        {
          id: "4276",
          name: "Thevur",
          state_id: "35",
        },
        {
          id: "4277",
          name: "Thiagadurgam",
          state_id: "35",
        },
        {
          id: "4278",
          name: "Thiagarajar Colony",
          state_id: "35",
        },
        {
          id: "4279",
          name: "Thingalnagar",
          state_id: "35",
        },
        {
          id: "4280",
          name: "Thiruchirapalli",
          state_id: "35",
        },
        {
          id: "4281",
          name: "Thirukarungudi",
          state_id: "35",
        },
        {
          id: "4282",
          name: "Thirukazhukundram",
          state_id: "35",
        },
        {
          id: "4283",
          name: "Thirumalayampalayam",
          state_id: "35",
        },
        {
          id: "4284",
          name: "Thirumazhisai",
          state_id: "35",
        },
        {
          id: "4285",
          name: "Thirunagar",
          state_id: "35",
        },
        {
          id: "4286",
          name: "Thirunageswaram",
          state_id: "35",
        },
        {
          id: "4287",
          name: "Thirunindravur",
          state_id: "35",
        },
        {
          id: "4288",
          name: "Thirunirmalai",
          state_id: "35",
        },
        {
          id: "4289",
          name: "Thiruparankundram",
          state_id: "35",
        },
        {
          id: "4290",
          name: "Thiruparappu",
          state_id: "35",
        },
        {
          id: "4291",
          name: "Thiruporur",
          state_id: "35",
        },
        {
          id: "4292",
          name: "Thiruppanandal",
          state_id: "35",
        },
        {
          id: "4293",
          name: "Thirupuvanam",
          state_id: "35",
        },
        {
          id: "4294",
          name: "Thiruthangal",
          state_id: "35",
        },
        {
          id: "4295",
          name: "Thiruthuraipundi",
          state_id: "35",
        },
        {
          id: "4296",
          name: "Thiruvaivaru",
          state_id: "35",
        },
        {
          id: "4297",
          name: "Thiruvalam",
          state_id: "35",
        },
        {
          id: "4298",
          name: "Thiruvarur",
          state_id: "35",
        },
        {
          id: "4299",
          name: "Thiruvattaru",
          state_id: "35",
        },
        {
          id: "4300",
          name: "Thiruvenkatam",
          state_id: "35",
        },
        {
          id: "4301",
          name: "Thiruvennainallur",
          state_id: "35",
        },
        {
          id: "4302",
          name: "Thiruvithankodu",
          state_id: "35",
        },
        {
          id: "4303",
          name: "Thisayanvilai",
          state_id: "35",
        },
        {
          id: "4304",
          name: "Thittacheri",
          state_id: "35",
        },
        {
          id: "4305",
          name: "Thondamuthur",
          state_id: "35",
        },
        {
          id: "4306",
          name: "Thorapadi",
          state_id: "35",
        },
        {
          id: "4307",
          name: "Thottipalayam",
          state_id: "35",
        },
        {
          id: "4308",
          name: "Thottiyam",
          state_id: "35",
        },
        {
          id: "4309",
          name: "Thudiyalur",
          state_id: "35",
        },
        {
          id: "4310",
          name: "Thuthipattu",
          state_id: "35",
        },
        {
          id: "4311",
          name: "Thuvakudi",
          state_id: "35",
        },
        {
          id: "4312",
          name: "Timiri",
          state_id: "35",
        },
        {
          id: "4313",
          name: "Tindivanam",
          state_id: "35",
        },
        {
          id: "4314",
          name: "Tinnanur",
          state_id: "35",
        },
        {
          id: "4315",
          name: "Tiruchchendur",
          state_id: "35",
        },
        {
          id: "4316",
          name: "Tiruchengode",
          state_id: "35",
        },
        {
          id: "4317",
          name: "Tirukkalukkundram",
          state_id: "35",
        },
        {
          id: "4318",
          name: "Tirukkattuppalli",
          state_id: "35",
        },
        {
          id: "4319",
          name: "Tirukkoyilur",
          state_id: "35",
        },
        {
          id: "4320",
          name: "Tirumangalam",
          state_id: "35",
        },
        {
          id: "4321",
          name: "Tirumullaivasal",
          state_id: "35",
        },
        {
          id: "4322",
          name: "Tirumuruganpundi",
          state_id: "35",
        },
        {
          id: "4323",
          name: "Tirunageswaram",
          state_id: "35",
        },
        {
          id: "4324",
          name: "Tirunelveli",
          state_id: "35",
        },
        {
          id: "4325",
          name: "Tirupathur",
          state_id: "35",
        },
        {
          id: "4326",
          name: "Tirupattur",
          state_id: "35",
        },
        {
          id: "4327",
          name: "Tiruppuvanam",
          state_id: "35",
        },
        {
          id: "4328",
          name: "Tirupur",
          state_id: "35",
        },
        {
          id: "4329",
          name: "Tirusulam",
          state_id: "35",
        },
        {
          id: "4330",
          name: "Tiruttani",
          state_id: "35",
        },
        {
          id: "4331",
          name: "Tiruvallur",
          state_id: "35",
        },
        {
          id: "4332",
          name: "Tiruvannamalai",
          state_id: "35",
        },
        {
          id: "4333",
          name: "Tiruverambur",
          state_id: "35",
        },
        {
          id: "4334",
          name: "Tiruverkadu",
          state_id: "35",
        },
        {
          id: "4335",
          name: "Tiruvethipuram",
          state_id: "35",
        },
        {
          id: "4336",
          name: "Tiruvidaimarudur",
          state_id: "35",
        },
        {
          id: "4337",
          name: "Tiruvottiyur",
          state_id: "35",
        },
        {
          id: "4338",
          name: "Tittakudi",
          state_id: "35",
        },
        {
          id: "4339",
          name: "Tondi",
          state_id: "35",
        },
        {
          id: "4340",
          name: "Turaiyur",
          state_id: "35",
        },
        {
          id: "4341",
          name: "Tuticorin",
          state_id: "35",
        },
        {
          id: "4342",
          name: "Udagamandalam",
          state_id: "35",
        },
        {
          id: "4343",
          name: "Udagamandalam Valley",
          state_id: "35",
        },
        {
          id: "4344",
          name: "Udankudi",
          state_id: "35",
        },
        {
          id: "4345",
          name: "Udayarpalayam",
          state_id: "35",
        },
        {
          id: "4346",
          name: "Udumalaipettai",
          state_id: "35",
        },
        {
          id: "4347",
          name: "Udumalpet",
          state_id: "35",
        },
        {
          id: "4348",
          name: "Ullur",
          state_id: "35",
        },
        {
          id: "4349",
          name: "Ulundurpettai",
          state_id: "35",
        },
        {
          id: "4350",
          name: "Unjalaur",
          state_id: "35",
        },
        {
          id: "4351",
          name: "Unnamalaikadai",
          state_id: "35",
        },
        {
          id: "4352",
          name: "Uppidamangalam",
          state_id: "35",
        },
        {
          id: "4353",
          name: "Uppiliapuram",
          state_id: "35",
        },
        {
          id: "4354",
          name: "Urachikkottai",
          state_id: "35",
        },
        {
          id: "4355",
          name: "Urapakkam",
          state_id: "35",
        },
        {
          id: "4356",
          name: "Usilampatti",
          state_id: "35",
        },
        {
          id: "4357",
          name: "Uthangarai",
          state_id: "35",
        },
        {
          id: "4358",
          name: "Uthayendram",
          state_id: "35",
        },
        {
          id: "4359",
          name: "Uthiramerur",
          state_id: "35",
        },
        {
          id: "4360",
          name: "Uthukkottai",
          state_id: "35",
        },
        {
          id: "4361",
          name: "Uttamapalaiyam",
          state_id: "35",
        },
        {
          id: "4362",
          name: "Uttukkuli",
          state_id: "35",
        },
        {
          id: "4363",
          name: "Vadakarai Kizhpadugai",
          state_id: "35",
        },
        {
          id: "4364",
          name: "Vadakkanandal",
          state_id: "35",
        },
        {
          id: "4365",
          name: "Vadakku Valliyur",
          state_id: "35",
        },
        {
          id: "4366",
          name: "Vadalur",
          state_id: "35",
        },
        {
          id: "4367",
          name: "Vadamadurai",
          state_id: "35",
        },
        {
          id: "4368",
          name: "Vadavalli",
          state_id: "35",
        },
        {
          id: "4369",
          name: "Vadipatti",
          state_id: "35",
        },
        {
          id: "4370",
          name: "Vadugapatti",
          state_id: "35",
        },
        {
          id: "4371",
          name: "Vaithiswarankoil",
          state_id: "35",
        },
        {
          id: "4372",
          name: "Valangaiman",
          state_id: "35",
        },
        {
          id: "4373",
          name: "Valasaravakkam",
          state_id: "35",
        },
        {
          id: "4374",
          name: "Valavanur",
          state_id: "35",
        },
        {
          id: "4375",
          name: "Vallam",
          state_id: "35",
        },
        {
          id: "4376",
          name: "Valparai",
          state_id: "35",
        },
        {
          id: "4377",
          name: "Valvaithankoshtam",
          state_id: "35",
        },
        {
          id: "4378",
          name: "Vanavasi",
          state_id: "35",
        },
        {
          id: "4379",
          name: "Vandalur",
          state_id: "35",
        },
        {
          id: "4380",
          name: "Vandavasi",
          state_id: "35",
        },
        {
          id: "4381",
          name: "Vandiyur",
          state_id: "35",
        },
        {
          id: "4382",
          name: "Vaniputhur",
          state_id: "35",
        },
        {
          id: "4383",
          name: "Vaniyambadi",
          state_id: "35",
        },
        {
          id: "4384",
          name: "Varadarajanpettai",
          state_id: "35",
        },
        {
          id: "4385",
          name: "Varadharajapuram",
          state_id: "35",
        },
        {
          id: "4386",
          name: "Vasudevanallur",
          state_id: "35",
        },
        {
          id: "4387",
          name: "Vathirairuppu",
          state_id: "35",
        },
        {
          id: "4388",
          name: "Vattalkundu",
          state_id: "35",
        },
        {
          id: "4389",
          name: "Vazhapadi",
          state_id: "35",
        },
        {
          id: "4390",
          name: "Vedapatti",
          state_id: "35",
        },
        {
          id: "4391",
          name: "Vedaranniyam",
          state_id: "35",
        },
        {
          id: "4392",
          name: "Vedasandur",
          state_id: "35",
        },
        {
          id: "4393",
          name: "Velampalaiyam",
          state_id: "35",
        },
        {
          id: "4394",
          name: "Velankanni",
          state_id: "35",
        },
        {
          id: "4395",
          name: "Vellakinar",
          state_id: "35",
        },
        {
          id: "4396",
          name: "Vellakoil",
          state_id: "35",
        },
        {
          id: "4397",
          name: "Vellalapatti",
          state_id: "35",
        },
        {
          id: "4398",
          name: "Vellalur",
          state_id: "35",
        },
        {
          id: "4399",
          name: "Vellanur",
          state_id: "35",
        },
        {
          id: "4400",
          name: "Vellimalai",
          state_id: "35",
        },
        {
          id: "4401",
          name: "Vellore",
          state_id: "35",
        },
        {
          id: "4402",
          name: "Vellottamparappu",
          state_id: "35",
        },
        {
          id: "4403",
          name: "Velluru",
          state_id: "35",
        },
        {
          id: "4404",
          name: "Vengampudur",
          state_id: "35",
        },
        {
          id: "4405",
          name: "Vengathur",
          state_id: "35",
        },
        {
          id: "4406",
          name: "Vengavasal",
          state_id: "35",
        },
        {
          id: "4407",
          name: "Venghatur",
          state_id: "35",
        },
        {
          id: "4408",
          name: "Venkarai",
          state_id: "35",
        },
        {
          id: "4409",
          name: "Vennanthur",
          state_id: "35",
        },
        {
          id: "4410",
          name: "Veppathur",
          state_id: "35",
        },
        {
          id: "4411",
          name: "Verkilambi",
          state_id: "35",
        },
        {
          id: "4412",
          name: "Vettaikaranpudur",
          state_id: "35",
        },
        {
          id: "4413",
          name: "Vettavalam",
          state_id: "35",
        },
        {
          id: "4414",
          name: "Vijayapuri",
          state_id: "35",
        },
        {
          id: "4415",
          name: "Vikramasingapuram",
          state_id: "35",
        },
        {
          id: "4416",
          name: "Vikravandi",
          state_id: "35",
        },
        {
          id: "4417",
          name: "Vilangudi",
          state_id: "35",
        },
        {
          id: "4418",
          name: "Vilankurichi",
          state_id: "35",
        },
        {
          id: "4419",
          name: "Vilapakkam",
          state_id: "35",
        },
        {
          id: "4420",
          name: "Vilathikulam",
          state_id: "35",
        },
        {
          id: "4421",
          name: "Vilavur",
          state_id: "35",
        },
        {
          id: "4422",
          name: "Villukuri",
          state_id: "35",
        },
        {
          id: "4423",
          name: "Villupuram",
          state_id: "35",
        },
        {
          id: "4424",
          name: "Viraganur",
          state_id: "35",
        },
        {
          id: "4425",
          name: "Virakeralam",
          state_id: "35",
        },
        {
          id: "4426",
          name: "Virakkalpudur",
          state_id: "35",
        },
        {
          id: "4427",
          name: "Virapandi",
          state_id: "35",
        },
        {
          id: "4428",
          name: "Virapandi Cantonment",
          state_id: "35",
        },
        {
          id: "4429",
          name: "Virappanchatram",
          state_id: "35",
        },
        {
          id: "4430",
          name: "Viravanallur",
          state_id: "35",
        },
        {
          id: "4431",
          name: "Virudambattu",
          state_id: "35",
        },
        {
          id: "4432",
          name: "Virudhachalam",
          state_id: "35",
        },
        {
          id: "4433",
          name: "Virudhunagar",
          state_id: "35",
        },
        {
          id: "4434",
          name: "Virupakshipuram",
          state_id: "35",
        },
        {
          id: "4435",
          name: "Viswanatham",
          state_id: "35",
        },
        {
          id: "4436",
          name: "Vriddhachalam",
          state_id: "35",
        },
        {
          id: "4437",
          name: "Walajabad",
          state_id: "35",
        },
        {
          id: "4438",
          name: "Walajapet",
          state_id: "35",
        },
        {
          id: "4439",
          name: "Wellington",
          state_id: "35",
        },
        {
          id: "4440",
          name: "Yercaud",
          state_id: "35",
        },
        {
          id: "4441",
          name: "Zamin Uthukuli",
          state_id: "35",
        },
      ],
      Telangana: [
        {
          id: "4442",
          name: "Achampet",
          state_id: "36",
        },
        {
          id: "4443",
          name: "Adilabad",
          state_id: "36",
        },
        {
          id: "4444",
          name: "Armoor",
          state_id: "36",
        },
        {
          id: "4445",
          name: "Asifabad",
          state_id: "36",
        },
        {
          id: "4446",
          name: "Badepally",
          state_id: "36",
        },
        {
          id: "4447",
          name: "Banswada",
          state_id: "36",
        },
        {
          id: "4448",
          name: "Bellampalli",
          state_id: "36",
        },
        {
          id: "4449",
          name: "Bhadrachalam",
          state_id: "36",
        },
        {
          id: "4450",
          name: "Bhainsa",
          state_id: "36",
        },
        {
          id: "4451",
          name: "Bhongir",
          state_id: "36",
        },
        {
          id: "4452",
          name: "Bhupalpally",
          state_id: "36",
        },
        {
          id: "4453",
          name: "Bodhan",
          state_id: "36",
        },
        {
          id: "4454",
          name: "Bollaram",
          state_id: "36",
        },
        {
          id: "4455",
          name: "Devarkonda",
          state_id: "36",
        },
        {
          id: "4456",
          name: "Farooqnagar",
          state_id: "36",
        },
        {
          id: "4457",
          name: "Gadwal",
          state_id: "36",
        },
        {
          id: "4458",
          name: "Gajwel",
          state_id: "36",
        },
        {
          id: "4459",
          name: "Ghatkesar",
          state_id: "36",
        },
        {
          id: "4460",
          name: "Hyderabad",
          state_id: "36",
        },
        {
          id: "4461",
          name: "Jagtial",
          state_id: "36",
        },
        {
          id: "4462",
          name: "Jangaon",
          state_id: "36",
        },
        {
          id: "4463",
          name: "Kagaznagar",
          state_id: "36",
        },
        {
          id: "4464",
          name: "Kalwakurthy",
          state_id: "36",
        },
        {
          id: "4465",
          name: "Kamareddy",
          state_id: "36",
        },
        {
          id: "4466",
          name: "Karimnagar",
          state_id: "36",
        },
        {
          id: "4467",
          name: "Khammam",
          state_id: "36",
        },
        {
          id: "4468",
          name: "Kodada",
          state_id: "36",
        },
        {
          id: "4469",
          name: "Koratla",
          state_id: "36",
        },
        {
          id: "4470",
          name: "Kottagudem",
          state_id: "36",
        },
        {
          id: "4471",
          name: "Kyathampalle",
          state_id: "36",
        },
        {
          id: "4472",
          name: "Madhira",
          state_id: "36",
        },
        {
          id: "4473",
          name: "Mahabubabad",
          state_id: "36",
        },
        {
          id: "4474",
          name: "Mahbubnagar",
          state_id: "36",
        },
        {
          id: "4475",
          name: "Mancherial",
          state_id: "36",
        },
        {
          id: "4476",
          name: "Mandamarri",
          state_id: "36",
        },
        {
          id: "4477",
          name: "Manuguru",
          state_id: "36",
        },
        {
          id: "4479",
          name: "Medchal",
          state_id: "36",
        },
        {
          id: "4480",
          name: "Miryalaguda",
          state_id: "36",
        },
        {
          id: "4481",
          name: "Nagar Karnul",
          state_id: "36",
        },
        {
          id: "4482",
          name: "Nakrekal",
          state_id: "36",
        },
        {
          id: "4483",
          name: "Nalgonda",
          state_id: "36",
        },
        {
          id: "4484",
          name: "Narayanpet",
          state_id: "36",
        },
        {
          id: "4485",
          name: "Narsampet",
          state_id: "36",
        },
        {
          id: "4486",
          name: "Nirmal",
          state_id: "36",
        },
        {
          id: "4487",
          name: "Nizamabad",
          state_id: "36",
        },
        {
          id: "4488",
          name: "Palwancha",
          state_id: "36",
        },
        {
          id: "4489",
          name: "Peddapalli",
          state_id: "36",
        },
        {
          id: "4490",
          name: "Ramagundam",
          state_id: "36",
        },
        {
          id: "4491",
          name: "Ranga Reddy district",
          state_id: "36",
        },
        {
          id: "4492",
          name: "Sadasivpet",
          state_id: "36",
        },
        {
          id: "4493",
          name: "Sangareddy",
          state_id: "36",
        },
        {
          id: "4494",
          name: "Sarapaka",
          state_id: "36",
        },
        {
          id: "4495",
          name: "Sathupalle",
          state_id: "36",
        },
        {
          id: "4496",
          name: "Secunderabad",
          state_id: "36",
        },
        {
          id: "4497",
          name: "Siddipet",
          state_id: "36",
        },
        {
          id: "4498",
          name: "Singapur",
          state_id: "36",
        },
        {
          id: "4499",
          name: "Sircilla",
          state_id: "36",
        },
        {
          id: "4500",
          name: "Suryapet",
          state_id: "36",
        },
        {
          id: "4501",
          name: "Tandur",
          state_id: "36",
        },
        {
          id: "4502",
          name: "Vemulawada",
          state_id: "36",
        },
        {
          id: "4503",
          name: "Vikarabad",
          state_id: "36",
        },
        {
          id: "4504",
          name: "Wanaparthy",
          state_id: "36",
        },
        {
          id: "4505",
          name: "Warangal",
          state_id: "36",
        },
        {
          id: "4506",
          name: "Yellandu",
          state_id: "36",
        },
        {
          id: "4507",
          name: "Zahirabad",
          state_id: "36",
        },
      ],
      Tripura: [
        {
          id: "4508",
          name: "Agartala",
          state_id: "37",
        },
        {
          id: "4509",
          name: "Amarpur",
          state_id: "37",
        },
        {
          id: "4510",
          name: "Ambassa",
          state_id: "37",
        },
        {
          id: "4511",
          name: "Badharghat",
          state_id: "37",
        },
        {
          id: "4512",
          name: "Belonia",
          state_id: "37",
        },
        {
          id: "4513",
          name: "Dharmanagar",
          state_id: "37",
        },
        {
          id: "4514",
          name: "Gakulnagar",
          state_id: "37",
        },
        {
          id: "4515",
          name: "Gandhigram",
          state_id: "37",
        },
        {
          id: "4516",
          name: "Indranagar",
          state_id: "37",
        },
        {
          id: "4517",
          name: "Jogendranagar",
          state_id: "37",
        },
        {
          id: "4518",
          name: "Kailasahar",
          state_id: "37",
        },
        {
          id: "4519",
          name: "Kamalpur",
          state_id: "37",
        },
        {
          id: "4520",
          name: "Kanchanpur",
          state_id: "37",
        },
        {
          id: "4521",
          name: "Khowai",
          state_id: "37",
        },
        {
          id: "4522",
          name: "Kumarghat",
          state_id: "37",
        },
        {
          id: "4523",
          name: "Kunjaban",
          state_id: "37",
        },
        {
          id: "4524",
          name: "Narsingarh",
          state_id: "37",
        },
        {
          id: "4525",
          name: "Pratapgarh",
          state_id: "37",
        },
        {
          id: "4526",
          name: "Ranir Bazar",
          state_id: "37",
        },
        {
          id: "4527",
          name: "Sabrum",
          state_id: "37",
        },
        {
          id: "4528",
          name: "Sonamura",
          state_id: "37",
        },
        {
          id: "4529",
          name: "Teliamura",
          state_id: "37",
        },
        {
          id: "4530",
          name: "Udaipur",
          state_id: "37",
        },
      ],
      "Uttar Pradesh": [
        {
          id: "4531",
          name: "Achhalda",
          state_id: "38",
        },
        {
          id: "4532",
          name: "Achhnera",
          state_id: "38",
        },
        {
          id: "4533",
          name: "Adari",
          state_id: "38",
        },
        {
          id: "4534",
          name: "Afzalgarh",
          state_id: "38",
        },
        {
          id: "4535",
          name: "Agarwal Mandi",
          state_id: "38",
        },
        {
          id: "4536",
          name: "Agra",
          state_id: "38",
        },
        {
          id: "4537",
          name: "Agra Cantonment",
          state_id: "38",
        },
        {
          id: "4538",
          name: "Ahraura",
          state_id: "38",
        },
        {
          id: "4539",
          name: "Ailum",
          state_id: "38",
        },
        {
          id: "4540",
          name: "Air Force Area",
          state_id: "38",
        },
        {
          id: "4541",
          name: "Ajhuwa",
          state_id: "38",
        },
        {
          id: "4542",
          name: "Akbarpur",
          state_id: "38",
        },
        {
          id: "4543",
          name: "Alapur",
          state_id: "38",
        },
        {
          id: "4544",
          name: "Aliganj",
          state_id: "38",
        },
        {
          id: "4545",
          name: "Aligarh",
          state_id: "38",
        },
        {
          id: "4546",
          name: "Allahabad",
          state_id: "38",
        },
        {
          id: "4547",
          name: "Allahabad Cantonment",
          state_id: "38",
        },
        {
          id: "4548",
          name: "Allahganj",
          state_id: "38",
        },
        {
          id: "4549",
          name: "Amanpur",
          state_id: "38",
        },
        {
          id: "4550",
          name: "Ambahta",
          state_id: "38",
        },
        {
          id: "4551",
          name: "Amethi",
          state_id: "38",
        },
        {
          id: "4552",
          name: "Amila",
          state_id: "38",
        },
        {
          id: "4553",
          name: "Amilo",
          state_id: "38",
        },
        {
          id: "4554",
          name: "Aminagar Sarai",
          state_id: "38",
        },
        {
          id: "4555",
          name: "Aminagar Urf Bhurbaral",
          state_id: "38",
        },
        {
          id: "4556",
          name: "Amraudha",
          state_id: "38",
        },
        {
          id: "4557",
          name: "Amroha",
          state_id: "38",
        },
        {
          id: "4558",
          name: "Anandnagar",
          state_id: "38",
        },
        {
          id: "4559",
          name: "Anpara",
          state_id: "38",
        },
        {
          id: "4560",
          name: "Antu",
          state_id: "38",
        },
        {
          id: "4561",
          name: "Anupshahr",
          state_id: "38",
        },
        {
          id: "4562",
          name: "Aonla",
          state_id: "38",
        },
        {
          id: "4563",
          name: "Armapur Estate",
          state_id: "38",
        },
        {
          id: "4564",
          name: "Ashokpuram",
          state_id: "38",
        },
        {
          id: "4565",
          name: "Ashrafpur Kichhauchha",
          state_id: "38",
        },
        {
          id: "4566",
          name: "Atarra",
          state_id: "38",
        },
        {
          id: "4567",
          name: "Atasu",
          state_id: "38",
        },
        {
          id: "4568",
          name: "Atrauli",
          state_id: "38",
        },
        {
          id: "4569",
          name: "Atraulia",
          state_id: "38",
        },
        {
          id: "4570",
          name: "Auraiya",
          state_id: "38",
        },
        {
          id: "4571",
          name: "Aurangabad",
          state_id: "38",
        },
        {
          id: "4572",
          name: "Aurangabad Bangar",
          state_id: "38",
        },
        {
          id: "4573",
          name: "Auras",
          state_id: "38",
        },
        {
          id: "4574",
          name: "Awagarh",
          state_id: "38",
        },
        {
          id: "4575",
          name: "Ayodhya",
          state_id: "38",
        },
        {
          id: "4576",
          name: "Azamgarh",
          state_id: "38",
        },
        {
          id: "4577",
          name: "Azizpur",
          state_id: "38",
        },
        {
          id: "4578",
          name: "Azmatgarh",
          state_id: "38",
        },
        {
          id: "4579",
          name: "Babarpur Ajitmal",
          state_id: "38",
        },
        {
          id: "4580",
          name: "Baberu",
          state_id: "38",
        },
        {
          id: "4581",
          name: "Babina",
          state_id: "38",
        },
        {
          id: "4582",
          name: "Babrala",
          state_id: "38",
        },
        {
          id: "4583",
          name: "Babugarh",
          state_id: "38",
        },
        {
          id: "4584",
          name: "Bachhiowan",
          state_id: "38",
        },
        {
          id: "4585",
          name: "Bachhraon",
          state_id: "38",
        },
        {
          id: "4586",
          name: "Bad",
          state_id: "38",
        },
        {
          id: "4587",
          name: "Badaun",
          state_id: "38",
        },
        {
          id: "4588",
          name: "Baghpat",
          state_id: "38",
        },
        {
          id: "4589",
          name: "Bah",
          state_id: "38",
        },
        {
          id: "4590",
          name: "Bahadurganj",
          state_id: "38",
        },
        {
          id: "4591",
          name: "Baheri",
          state_id: "38",
        },
        {
          id: "4592",
          name: "Bahjoi",
          state_id: "38",
        },
        {
          id: "4593",
          name: "Bahraich",
          state_id: "38",
        },
        {
          id: "4594",
          name: "Bahsuma",
          state_id: "38",
        },
        {
          id: "4595",
          name: "Bahua",
          state_id: "38",
        },
        {
          id: "4596",
          name: "Bajna",
          state_id: "38",
        },
        {
          id: "4597",
          name: "Bakewar",
          state_id: "38",
        },
        {
          id: "4598",
          name: "Bakiabad",
          state_id: "38",
        },
        {
          id: "4599",
          name: "Baldeo",
          state_id: "38",
        },
        {
          id: "4600",
          name: "Ballia",
          state_id: "38",
        },
        {
          id: "4601",
          name: "Balrampur",
          state_id: "38",
        },
        {
          id: "4602",
          name: "Banat",
          state_id: "38",
        },
        {
          id: "4603",
          name: "Banda",
          state_id: "38",
        },
        {
          id: "4604",
          name: "Bangarmau",
          state_id: "38",
        },
        {
          id: "4605",
          name: "Banki",
          state_id: "38",
        },
        {
          id: "4606",
          name: "Bansdih",
          state_id: "38",
        },
        {
          id: "4607",
          name: "Bansgaon",
          state_id: "38",
        },
        {
          id: "4608",
          name: "Bansi",
          state_id: "38",
        },
        {
          id: "4609",
          name: "Barabanki",
          state_id: "38",
        },
        {
          id: "4610",
          name: "Baragaon",
          state_id: "38",
        },
        {
          id: "4611",
          name: "Baraut",
          state_id: "38",
        },
        {
          id: "4612",
          name: "Bareilly",
          state_id: "38",
        },
        {
          id: "4613",
          name: "Bareilly Cantonment",
          state_id: "38",
        },
        {
          id: "4614",
          name: "Barhalganj",
          state_id: "38",
        },
        {
          id: "4615",
          name: "Barhani",
          state_id: "38",
        },
        {
          id: "4616",
          name: "Barhapur",
          state_id: "38",
        },
        {
          id: "4617",
          name: "Barkhera",
          state_id: "38",
        },
        {
          id: "4618",
          name: "Barsana",
          state_id: "38",
        },
        {
          id: "4619",
          name: "Barva Sagar",
          state_id: "38",
        },
        {
          id: "4620",
          name: "Barwar",
          state_id: "38",
        },
        {
          id: "4621",
          name: "Basti",
          state_id: "38",
        },
        {
          id: "4622",
          name: "Begumabad Budhana",
          state_id: "38",
        },
        {
          id: "4623",
          name: "Behat",
          state_id: "38",
        },
        {
          id: "4624",
          name: "Behta Hajipur",
          state_id: "38",
        },
        {
          id: "4625",
          name: "Bela",
          state_id: "38",
        },
        {
          id: "4626",
          name: "Belthara",
          state_id: "38",
        },
        {
          id: "4627",
          name: "Beniganj",
          state_id: "38",
        },
        {
          id: "4628",
          name: "Beswan",
          state_id: "38",
        },
        {
          id: "4629",
          name: "Bewar",
          state_id: "38",
        },
        {
          id: "4630",
          name: "Bhadarsa",
          state_id: "38",
        },
        {
          id: "4631",
          name: "Bhadohi",
          state_id: "38",
        },
        {
          id: "4632",
          name: "Bhagwantnagar",
          state_id: "38",
        },
        {
          id: "4633",
          name: "Bharatganj",
          state_id: "38",
        },
        {
          id: "4634",
          name: "Bhargain",
          state_id: "38",
        },
        {
          id: "4635",
          name: "Bharthana",
          state_id: "38",
        },
        {
          id: "4636",
          name: "Bharuhana",
          state_id: "38",
        },
        {
          id: "4637",
          name: "Bharwari",
          state_id: "38",
        },
        {
          id: "4638",
          name: "Bhatni Bazar",
          state_id: "38",
        },
        {
          id: "4639",
          name: "Bhatpar Rani",
          state_id: "38",
        },
        {
          id: "4640",
          name: "Bhawan Bahadurnagar",
          state_id: "38",
        },
        {
          id: "4641",
          name: "Bhinga",
          state_id: "38",
        },
        {
          id: "4642",
          name: "Bhojpur Dharampur",
          state_id: "38",
        },
        {
          id: "4643",
          name: "Bhokarhedi",
          state_id: "38",
        },
        {
          id: "4644",
          name: "Bhongaon",
          state_id: "38",
        },
        {
          id: "4645",
          name: "Bhulepur",
          state_id: "38",
        },
        {
          id: "4646",
          name: "Bidhuna",
          state_id: "38",
        },
        {
          id: "4647",
          name: "Bighapur",
          state_id: "38",
        },
        {
          id: "4648",
          name: "Bijnor",
          state_id: "38",
        },
        {
          id: "4649",
          name: "Bijpur",
          state_id: "38",
        },
        {
          id: "4650",
          name: "Bikapur",
          state_id: "38",
        },
        {
          id: "4651",
          name: "Bilari",
          state_id: "38",
        },
        {
          id: "4652",
          name: "Bilaspur",
          state_id: "38",
        },
        {
          id: "4653",
          name: "Bilgram",
          state_id: "38",
        },
        {
          id: "4654",
          name: "Bilhaur",
          state_id: "38",
        },
        {
          id: "4655",
          name: "Bilram",
          state_id: "38",
        },
        {
          id: "4656",
          name: "Bilrayaganj",
          state_id: "38",
        },
        {
          id: "4657",
          name: "Bilsanda",
          state_id: "38",
        },
        {
          id: "4658",
          name: "Bilsi",
          state_id: "38",
        },
        {
          id: "4659",
          name: "Bindki",
          state_id: "38",
        },
        {
          id: "4660",
          name: "Bisalpur",
          state_id: "38",
        },
        {
          id: "4661",
          name: "Bisanda Buzurg",
          state_id: "38",
        },
        {
          id: "4662",
          name: "Bisauli",
          state_id: "38",
        },
        {
          id: "4663",
          name: "Bisharatganj",
          state_id: "38",
        },
        {
          id: "4664",
          name: "Bisokhar",
          state_id: "38",
        },
        {
          id: "4665",
          name: "Biswan",
          state_id: "38",
        },
        {
          id: "4666",
          name: "Bithur",
          state_id: "38",
        },
        {
          id: "4667",
          name: "Budaun",
          state_id: "38",
        },
        {
          id: "4668",
          name: "Bugrasi",
          state_id: "38",
        },
        {
          id: "4669",
          name: "Bulandshahar",
          state_id: "38",
        },
        {
          id: "4670",
          name: "Burhana",
          state_id: "38",
        },
        {
          id: "4671",
          name: "Chail",
          state_id: "38",
        },
        {
          id: "4672",
          name: "Chak Imam Ali",
          state_id: "38",
        },
        {
          id: "4673",
          name: "Chakeri",
          state_id: "38",
        },
        {
          id: "4674",
          name: "Chakia",
          state_id: "38",
        },
        {
          id: "4675",
          name: "Chandauli",
          state_id: "38",
        },
        {
          id: "4676",
          name: "Chandausi",
          state_id: "38",
        },
        {
          id: "4677",
          name: "Chandpur",
          state_id: "38",
        },
        {
          id: "4678",
          name: "Charkhari",
          state_id: "38",
        },
        {
          id: "4679",
          name: "Charthawal",
          state_id: "38",
        },
        {
          id: "4680",
          name: "Chaumuhan",
          state_id: "38",
        },
        {
          id: "4681",
          name: "Chhaprauli",
          state_id: "38",
        },
        {
          id: "4682",
          name: "Chhara Rafatpur",
          state_id: "38",
        },
        {
          id: "4683",
          name: "Chharprauli",
          state_id: "38",
        },
        {
          id: "4684",
          name: "Chhata",
          state_id: "38",
        },
        {
          id: "4685",
          name: "Chhatari",
          state_id: "38",
        },
        {
          id: "4686",
          name: "Chhibramau",
          state_id: "38",
        },
        {
          id: "4687",
          name: "Chhutmalpur",
          state_id: "38",
        },
        {
          id: "4688",
          name: "Chilkana Sultanpur",
          state_id: "38",
        },
        {
          id: "4689",
          name: "Chirgaon",
          state_id: "38",
        },
        {
          id: "4690",
          name: "Chit Baragaon",
          state_id: "38",
        },
        {
          id: "4691",
          name: "Chitrakut Dham",
          state_id: "38",
        },
        {
          id: "4692",
          name: "Chopan",
          state_id: "38",
        },
        {
          id: "4693",
          name: "Choubepur Kalan",
          state_id: "38",
        },
        {
          id: "4694",
          name: "Chunar",
          state_id: "38",
        },
        {
          id: "4695",
          name: "Churk Ghurma",
          state_id: "38",
        },
        {
          id: "4696",
          name: "Colonelganj",
          state_id: "38",
        },
        {
          id: "4697",
          name: "Dadri",
          state_id: "38",
        },
        {
          id: "4698",
          name: "Dalmau",
          state_id: "38",
        },
        {
          id: "4699",
          name: "Dankaur",
          state_id: "38",
        },
        {
          id: "4700",
          name: "Dariyabad",
          state_id: "38",
        },
        {
          id: "4701",
          name: "Dasna",
          state_id: "38",
        },
        {
          id: "4702",
          name: "Dataganj",
          state_id: "38",
        },
        {
          id: "4703",
          name: "Daurala",
          state_id: "38",
        },
        {
          id: "4704",
          name: "Dayal Bagh",
          state_id: "38",
        },
        {
          id: "4705",
          name: "Deoband",
          state_id: "38",
        },
        {
          id: "4706",
          name: "Deoranian",
          state_id: "38",
        },
        {
          id: "4707",
          name: "Deoria",
          state_id: "38",
        },
        {
          id: "4708",
          name: "Dewa",
          state_id: "38",
        },
        {
          id: "4709",
          name: "Dhampur",
          state_id: "38",
        },
        {
          id: "4710",
          name: "Dhanauha",
          state_id: "38",
        },
        {
          id: "4711",
          name: "Dhanauli",
          state_id: "38",
        },
        {
          id: "4712",
          name: "Dhanaura",
          state_id: "38",
        },
        {
          id: "4713",
          name: "Dharoti Khurd",
          state_id: "38",
        },
        {
          id: "4714",
          name: "Dhauratanda",
          state_id: "38",
        },
        {
          id: "4715",
          name: "Dhaurhra",
          state_id: "38",
        },
        {
          id: "4716",
          name: "Dibai",
          state_id: "38",
        },
        {
          id: "4717",
          name: "Dibiyapur",
          state_id: "38",
        },
        {
          id: "4718",
          name: "Dildarnagar Fatehpur",
          state_id: "38",
        },
        {
          id: "4719",
          name: "Do Ghat",
          state_id: "38",
        },
        {
          id: "4720",
          name: "Dohrighat",
          state_id: "38",
        },
        {
          id: "4721",
          name: "Dostpur",
          state_id: "38",
        },
        {
          id: "4722",
          name: "Dudhinagar",
          state_id: "38",
        },
        {
          id: "4723",
          name: "Dulhipur",
          state_id: "38",
        },
        {
          id: "4724",
          name: "Dundwaraganj",
          state_id: "38",
        },
        {
          id: "4725",
          name: "Ekdil",
          state_id: "38",
        },
        {
          id: "4726",
          name: "Erich",
          state_id: "38",
        },
        {
          id: "4727",
          name: "Etah",
          state_id: "38",
        },
        {
          id: "4728",
          name: "Etawah",
          state_id: "38",
        },
        {
          id: "4729",
          name: "Faizabad",
          state_id: "38",
        },
        {
          id: "4730",
          name: "Faizabad Cantonment",
          state_id: "38",
        },
        {
          id: "4731",
          name: "Faizganj",
          state_id: "38",
        },
        {
          id: "4732",
          name: "Farah",
          state_id: "38",
        },
        {
          id: "4733",
          name: "Faridnagar",
          state_id: "38",
        },
        {
          id: "4734",
          name: "Faridpur",
          state_id: "38",
        },
        {
          id: "4735",
          name: "Faridpur Cantonment",
          state_id: "38",
        },
        {
          id: "4736",
          name: "Fariha",
          state_id: "38",
        },
        {
          id: "4737",
          name: "Farrukhabad",
          state_id: "38",
        },
        {
          id: "4738",
          name: "Fatehabad",
          state_id: "38",
        },
        {
          id: "4739",
          name: "Fatehganj Pashchimi",
          state_id: "38",
        },
        {
          id: "4740",
          name: "Fatehganj Purvi",
          state_id: "38",
        },
        {
          id: "4741",
          name: "Fatehgarh",
          state_id: "38",
        },
        {
          id: "4742",
          name: "Fatehpur",
          state_id: "38",
        },
        {
          id: "4743",
          name: "Fatehpur Chaurasi",
          state_id: "38",
        },
        {
          id: "4744",
          name: "Fatehpur Sikri",
          state_id: "38",
        },
        {
          id: "4745",
          name: "Firozabad",
          state_id: "38",
        },
        {
          id: "4746",
          name: "Gajraula",
          state_id: "38",
        },
        {
          id: "4747",
          name: "Ganga Ghat",
          state_id: "38",
        },
        {
          id: "4748",
          name: "Gangapur",
          state_id: "38",
        },
        {
          id: "4749",
          name: "Gangoh",
          state_id: "38",
        },
        {
          id: "4750",
          name: "Ganj Muradabad",
          state_id: "38",
        },
        {
          id: "4751",
          name: "Garautha",
          state_id: "38",
        },
        {
          id: "4752",
          name: "Garhi Pukhta",
          state_id: "38",
        },
        {
          id: "4753",
          name: "Garhmukteshwar",
          state_id: "38",
        },
        {
          id: "4754",
          name: "Gaura Barahaj",
          state_id: "38",
        },
        {
          id: "4755",
          name: "Gauri Bazar",
          state_id: "38",
        },
        {
          id: "4756",
          name: "Gausganj",
          state_id: "38",
        },
        {
          id: "4757",
          name: "Gawan",
          state_id: "38",
        },
        {
          id: "4758",
          name: "Ghatampur",
          state_id: "38",
        },
        {
          id: "4759",
          name: "Ghaziabad",
          state_id: "38",
        },
        {
          id: "4760",
          name: "Ghazipur",
          state_id: "38",
        },
        {
          id: "4761",
          name: "Ghiror",
          state_id: "38",
        },
        {
          id: "4762",
          name: "Ghorawal",
          state_id: "38",
        },
        {
          id: "4763",
          name: "Ghosi",
          state_id: "38",
        },
        {
          id: "4764",
          name: "Ghosia Bazar",
          state_id: "38",
        },
        {
          id: "4765",
          name: "Ghughuli",
          state_id: "38",
        },
        {
          id: "4766",
          name: "Gohand",
          state_id: "38",
        },
        {
          id: "4767",
          name: "Gokul",
          state_id: "38",
        },
        {
          id: "4768",
          name: "Gola Bazar",
          state_id: "38",
        },
        {
          id: "4769",
          name: "Gola Gokarannath",
          state_id: "38",
        },
        {
          id: "4770",
          name: "Gonda",
          state_id: "38",
        },
        {
          id: "4771",
          name: "Gopamau",
          state_id: "38",
        },
        {
          id: "4772",
          name: "Gopiganj",
          state_id: "38",
        },
        {
          id: "4773",
          name: "Gorakhpur",
          state_id: "38",
        },
        {
          id: "4774",
          name: "Gosainganj",
          state_id: "38",
        },
        {
          id: "4775",
          name: "Govardhan",
          state_id: "38",
        },
        {
          id: "4776",
          name: "Greater Noida",
          state_id: "38",
        },
        {
          id: "4777",
          name: "Gulaothi",
          state_id: "38",
        },
        {
          id: "4778",
          name: "Gulariya",
          state_id: "38",
        },
        {
          id: "4779",
          name: "Gulariya Bhindara",
          state_id: "38",
        },
        {
          id: "4780",
          name: "Gunnaur",
          state_id: "38",
        },
        {
          id: "4781",
          name: "Gursahaiganj",
          state_id: "38",
        },
        {
          id: "4782",
          name: "Gursarai",
          state_id: "38",
        },
        {
          id: "4783",
          name: "Gyanpur",
          state_id: "38",
        },
        {
          id: "4784",
          name: "Hafizpur",
          state_id: "38",
        },
        {
          id: "4785",
          name: "Haidergarh",
          state_id: "38",
        },
        {
          id: "4786",
          name: "Haldaur",
          state_id: "38",
        },
        {
          id: "4787",
          name: "Hamirpur",
          state_id: "38",
        },
        {
          id: "4788",
          name: "Handia",
          state_id: "38",
        },
        {
          id: "4789",
          name: "Hapur",
          state_id: "38",
        },
        {
          id: "4790",
          name: "Hardoi",
          state_id: "38",
        },
        {
          id: "4791",
          name: "Harduaganj",
          state_id: "38",
        },
        {
          id: "4792",
          name: "Hargaon",
          state_id: "38",
        },
        {
          id: "4793",
          name: "Hariharpur",
          state_id: "38",
        },
        {
          id: "4794",
          name: "Harraiya",
          state_id: "38",
        },
        {
          id: "4795",
          name: "Hasanpur",
          state_id: "38",
        },
        {
          id: "4796",
          name: "Hasayan",
          state_id: "38",
        },
        {
          id: "4797",
          name: "Hastinapur",
          state_id: "38",
        },
        {
          id: "4798",
          name: "Hata",
          state_id: "38",
        },
        {
          id: "4799",
          name: "Hathras",
          state_id: "38",
        },
        {
          id: "4800",
          name: "Hyderabad",
          state_id: "38",
        },
        {
          id: "4801",
          name: "Ibrahimpur",
          state_id: "38",
        },
        {
          id: "4802",
          name: "Iglas",
          state_id: "38",
        },
        {
          id: "4803",
          name: "Ikauna",
          state_id: "38",
        },
        {
          id: "4804",
          name: "Iltifatganj Bazar",
          state_id: "38",
        },
        {
          id: "4805",
          name: "Indian Telephone Industry Mank",
          state_id: "38",
        },
        {
          id: "4806",
          name: "Islamnagar",
          state_id: "38",
        },
        {
          id: "4807",
          name: "Itaunja",
          state_id: "38",
        },
        {
          id: "4808",
          name: "Itimadpur",
          state_id: "38",
        },
        {
          id: "4809",
          name: "Jagner",
          state_id: "38",
        },
        {
          id: "4810",
          name: "Jahanabad",
          state_id: "38",
        },
        {
          id: "4811",
          name: "Jahangirabad",
          state_id: "38",
        },
        {
          id: "4812",
          name: "Jahangirpur",
          state_id: "38",
        },
        {
          id: "4813",
          name: "Jais",
          state_id: "38",
        },
        {
          id: "4814",
          name: "Jaithara",
          state_id: "38",
        },
        {
          id: "4815",
          name: "Jalalabad",
          state_id: "38",
        },
        {
          id: "4816",
          name: "Jalali",
          state_id: "38",
        },
        {
          id: "4817",
          name: "Jalalpur",
          state_id: "38",
        },
        {
          id: "4818",
          name: "Jalaun",
          state_id: "38",
        },
        {
          id: "4819",
          name: "Jalesar",
          state_id: "38",
        },
        {
          id: "4820",
          name: "Jamshila",
          state_id: "38",
        },
        {
          id: "4821",
          name: "Jangipur",
          state_id: "38",
        },
        {
          id: "4822",
          name: "Jansath",
          state_id: "38",
        },
        {
          id: "4823",
          name: "Jarwal",
          state_id: "38",
        },
        {
          id: "4824",
          name: "Jasrana",
          state_id: "38",
        },
        {
          id: "4825",
          name: "Jaswantnagar",
          state_id: "38",
        },
        {
          id: "4826",
          name: "Jatari",
          state_id: "38",
        },
        {
          id: "4827",
          name: "Jaunpur",
          state_id: "38",
        },
        {
          id: "4828",
          name: "Jewar",
          state_id: "38",
        },
        {
          id: "4829",
          name: "Jhalu",
          state_id: "38",
        },
        {
          id: "4830",
          name: "Jhansi",
          state_id: "38",
        },
        {
          id: "4831",
          name: "Jhansi Cantonment",
          state_id: "38",
        },
        {
          id: "4832",
          name: "Jhansi Railway Settlement",
          state_id: "38",
        },
        {
          id: "4833",
          name: "Jhinjhak",
          state_id: "38",
        },
        {
          id: "4834",
          name: "Jhinjhana",
          state_id: "38",
        },
        {
          id: "4835",
          name: "Jhusi",
          state_id: "38",
        },
        {
          id: "4836",
          name: "Jhusi Kohna",
          state_id: "38",
        },
        {
          id: "4837",
          name: "Jiyanpur",
          state_id: "38",
        },
        {
          id: "4838",
          name: "Joya",
          state_id: "38",
        },
        {
          id: "4839",
          name: "Jyoti Khuria",
          state_id: "38",
        },
        {
          id: "4840",
          name: "Jyotiba Phule Nagar",
          state_id: "38",
        },
        {
          id: "4841",
          name: "Kabrai",
          state_id: "38",
        },
        {
          id: "4842",
          name: "Kachhauna Patseni",
          state_id: "38",
        },
        {
          id: "4843",
          name: "Kachhla",
          state_id: "38",
        },
        {
          id: "4844",
          name: "Kachhwa",
          state_id: "38",
        },
        {
          id: "4845",
          name: "Kadaura",
          state_id: "38",
        },
        {
          id: "4846",
          name: "Kadipur",
          state_id: "38",
        },
        {
          id: "4847",
          name: "Kailashpur",
          state_id: "38",
        },
        {
          id: "4848",
          name: "Kaimganj",
          state_id: "38",
        },
        {
          id: "4849",
          name: "Kairana",
          state_id: "38",
        },
        {
          id: "4850",
          name: "Kakgaina",
          state_id: "38",
        },
        {
          id: "4851",
          name: "Kakod",
          state_id: "38",
        },
        {
          id: "4852",
          name: "Kakori",
          state_id: "38",
        },
        {
          id: "4853",
          name: "Kakrala",
          state_id: "38",
        },
        {
          id: "4854",
          name: "Kalinagar",
          state_id: "38",
        },
        {
          id: "4855",
          name: "Kalpi",
          state_id: "38",
        },
        {
          id: "4856",
          name: "Kamalganj",
          state_id: "38",
        },
        {
          id: "4857",
          name: "Kampil",
          state_id: "38",
        },
        {
          id: "4858",
          name: "Kandhla",
          state_id: "38",
        },
        {
          id: "4859",
          name: "Kandwa",
          state_id: "38",
        },
        {
          id: "4860",
          name: "Kannauj",
          state_id: "38",
        },
        {
          id: "4861",
          name: "Kanpur",
          state_id: "38",
        },
        {
          id: "4862",
          name: "Kant",
          state_id: "38",
        },
        {
          id: "4863",
          name: "Kanth",
          state_id: "38",
        },
        {
          id: "4864",
          name: "Kaptanganj",
          state_id: "38",
        },
        {
          id: "4865",
          name: "Karaon",
          state_id: "38",
        },
        {
          id: "4866",
          name: "Karari",
          state_id: "38",
        },
        {
          id: "4867",
          name: "Karhal",
          state_id: "38",
        },
        {
          id: "4868",
          name: "Karnawal",
          state_id: "38",
        },
        {
          id: "4869",
          name: "Kasganj",
          state_id: "38",
        },
        {
          id: "4870",
          name: "Katariya",
          state_id: "38",
        },
        {
          id: "4871",
          name: "Katghar Lalganj",
          state_id: "38",
        },
        {
          id: "4872",
          name: "Kathera",
          state_id: "38",
        },
        {
          id: "4873",
          name: "Katra",
          state_id: "38",
        },
        {
          id: "4874",
          name: "Katra Medniganj",
          state_id: "38",
        },
        {
          id: "4875",
          name: "Kauriaganj",
          state_id: "38",
        },
        {
          id: "4876",
          name: "Kemri",
          state_id: "38",
        },
        {
          id: "4877",
          name: "Kerakat",
          state_id: "38",
        },
        {
          id: "4878",
          name: "Khadda",
          state_id: "38",
        },
        {
          id: "4879",
          name: "Khaga",
          state_id: "38",
        },
        {
          id: "4880",
          name: "Khailar",
          state_id: "38",
        },
        {
          id: "4881",
          name: "Khair",
          state_id: "38",
        },
        {
          id: "4882",
          name: "Khairabad",
          state_id: "38",
        },
        {
          id: "4883",
          name: "Khairagarh",
          state_id: "38",
        },
        {
          id: "4884",
          name: "Khalilabad",
          state_id: "38",
        },
        {
          id: "4885",
          name: "Khamaria",
          state_id: "38",
        },
        {
          id: "4886",
          name: "Khanpur",
          state_id: "38",
        },
        {
          id: "4887",
          name: "Kharela",
          state_id: "38",
        },
        {
          id: "4888",
          name: "Khargupur",
          state_id: "38",
        },
        {
          id: "4889",
          name: "Khariya",
          state_id: "38",
        },
        {
          id: "4890",
          name: "Kharkhoda",
          state_id: "38",
        },
        {
          id: "4891",
          name: "Khatauli",
          state_id: "38",
        },
        {
          id: "4892",
          name: "Khatauli Rural",
          state_id: "38",
        },
        {
          id: "4893",
          name: "Khekra",
          state_id: "38",
        },
        {
          id: "4894",
          name: "Kheri",
          state_id: "38",
        },
        {
          id: "4895",
          name: "Kheta Sarai",
          state_id: "38",
        },
        {
          id: "4896",
          name: "Khudaganj",
          state_id: "38",
        },
        {
          id: "4897",
          name: "Khurja",
          state_id: "38",
        },
        {
          id: "4898",
          name: "Khutar",
          state_id: "38",
        },
        {
          id: "4899",
          name: "Kiraoli",
          state_id: "38",
        },
        {
          id: "4900",
          name: "Kiratpur",
          state_id: "38",
        },
        {
          id: "4901",
          name: "Kishanpur",
          state_id: "38",
        },
        {
          id: "4902",
          name: "Kishni",
          state_id: "38",
        },
        {
          id: "4903",
          name: "Kithaur",
          state_id: "38",
        },
        {
          id: "4904",
          name: "Koiripur",
          state_id: "38",
        },
        {
          id: "4905",
          name: "Konch",
          state_id: "38",
        },
        {
          id: "4906",
          name: "Kopaganj",
          state_id: "38",
        },
        {
          id: "4907",
          name: "Kora Jahanabad",
          state_id: "38",
        },
        {
          id: "4908",
          name: "Korwa",
          state_id: "38",
        },
        {
          id: "4909",
          name: "Kosi Kalan",
          state_id: "38",
        },
        {
          id: "4910",
          name: "Kota",
          state_id: "38",
        },
        {
          id: "4911",
          name: "Kotra",
          state_id: "38",
        },
        {
          id: "4912",
          name: "Kotwa",
          state_id: "38",
        },
        {
          id: "4913",
          name: "Kulpahar",
          state_id: "38",
        },
        {
          id: "4914",
          name: "Kunda",
          state_id: "38",
        },
        {
          id: "4915",
          name: "Kundarki",
          state_id: "38",
        },
        {
          id: "4916",
          name: "Kunwargaon",
          state_id: "38",
        },
        {
          id: "4917",
          name: "Kurara",
          state_id: "38",
        },
        {
          id: "4918",
          name: "Kurawali",
          state_id: "38",
        },
        {
          id: "4919",
          name: "Kursath",
          state_id: "38",
        },
        {
          id: "4920",
          name: "Kurthi Jafarpur",
          state_id: "38",
        },
        {
          id: "4921",
          name: "Kushinagar",
          state_id: "38",
        },
        {
          id: "4922",
          name: "Kusmara",
          state_id: "38",
        },
        {
          id: "4923",
          name: "Laharpur",
          state_id: "38",
        },
        {
          id: "4924",
          name: "Lakhimpur",
          state_id: "38",
        },
        {
          id: "4925",
          name: "Lakhna",
          state_id: "38",
        },
        {
          id: "4926",
          name: "Lalganj",
          state_id: "38",
        },
        {
          id: "4927",
          name: "Lalitpur",
          state_id: "38",
        },
        {
          id: "4928",
          name: "Lar",
          state_id: "38",
        },
        {
          id: "4929",
          name: "Lawar",
          state_id: "38",
        },
        {
          id: "4930",
          name: "Ledwa Mahuwa",
          state_id: "38",
        },
        {
          id: "4931",
          name: "Lohta",
          state_id: "38",
        },
        {
          id: "4932",
          name: "Loni",
          state_id: "38",
        },
        {
          id: "4933",
          name: "Lucknow",
          state_id: "38",
        },
        {
          id: "4934",
          name: "Machhlishahr",
          state_id: "38",
        },
        {
          id: "4935",
          name: "Madhoganj",
          state_id: "38",
        },
        {
          id: "4936",
          name: "Madhogarh",
          state_id: "38",
        },
        {
          id: "4937",
          name: "Maghar",
          state_id: "38",
        },
        {
          id: "4938",
          name: "Mahaban",
          state_id: "38",
        },
        {
          id: "4939",
          name: "Maharajganj",
          state_id: "38",
        },
        {
          id: "4940",
          name: "Mahmudabad",
          state_id: "38",
        },
        {
          id: "4941",
          name: "Mahoba",
          state_id: "38",
        },
        {
          id: "4942",
          name: "Maholi",
          state_id: "38",
        },
        {
          id: "4943",
          name: "Mahona",
          state_id: "38",
        },
        {
          id: "4944",
          name: "Mahroni",
          state_id: "38",
        },
        {
          id: "4945",
          name: "Mailani",
          state_id: "38",
        },
        {
          id: "4946",
          name: "Mainpuri",
          state_id: "38",
        },
        {
          id: "4947",
          name: "Majhara Pipar Ehatmali",
          state_id: "38",
        },
        {
          id: "4948",
          name: "Majhauli Raj",
          state_id: "38",
        },
        {
          id: "4949",
          name: "Malihabad",
          state_id: "38",
        },
        {
          id: "4950",
          name: "Mallanwam",
          state_id: "38",
        },
        {
          id: "4951",
          name: "Mandawar",
          state_id: "38",
        },
        {
          id: "4952",
          name: "Manikpur",
          state_id: "38",
        },
        {
          id: "4953",
          name: "Maniyar",
          state_id: "38",
        },
        {
          id: "4954",
          name: "Manjhanpur",
          state_id: "38",
        },
        {
          id: "4955",
          name: "Mankapur",
          state_id: "38",
        },
        {
          id: "4956",
          name: "Marehra",
          state_id: "38",
        },
        {
          id: "4957",
          name: "Mariahu",
          state_id: "38",
        },
        {
          id: "4958",
          name: "Maruadih",
          state_id: "38",
        },
        {
          id: "4959",
          name: "Maswasi",
          state_id: "38",
        },
        {
          id: "4960",
          name: "Mataundh",
          state_id: "38",
        },
        {
          id: "4961",
          name: "Mathu",
          state_id: "38",
        },
        {
          id: "4962",
          name: "Mathura",
          state_id: "38",
        },
        {
          id: "4963",
          name: "Mathura Cantonment",
          state_id: "38",
        },
        {
          id: "4964",
          name: "Mau",
          state_id: "38",
        },
        {
          id: "4965",
          name: "Mau Aima",
          state_id: "38",
        },
        {
          id: "4966",
          name: "Maudaha",
          state_id: "38",
        },
        {
          id: "4967",
          name: "Mauranipur",
          state_id: "38",
        },
        {
          id: "4968",
          name: "Maurawan",
          state_id: "38",
        },
        {
          id: "4969",
          name: "Mawana",
          state_id: "38",
        },
        {
          id: "4970",
          name: "Meerut",
          state_id: "38",
        },
        {
          id: "4971",
          name: "Mehnagar",
          state_id: "38",
        },
        {
          id: "4972",
          name: "Mehndawal",
          state_id: "38",
        },
        {
          id: "4973",
          name: "Mendu",
          state_id: "38",
        },
        {
          id: "4974",
          name: "Milak",
          state_id: "38",
        },
        {
          id: "4975",
          name: "Miranpur",
          state_id: "38",
        },
        {
          id: "4976",
          name: "Mirat",
          state_id: "38",
        },
        {
          id: "4977",
          name: "Mirat Cantonment",
          state_id: "38",
        },
        {
          id: "4978",
          name: "Mirganj",
          state_id: "38",
        },
        {
          id: "4979",
          name: "Mirzapur",
          state_id: "38",
        },
        {
          id: "4980",
          name: "Misrikh",
          state_id: "38",
        },
        {
          id: "4981",
          name: "Modinagar",
          state_id: "38",
        },
        {
          id: "4982",
          name: "Mogra Badshahpur",
          state_id: "38",
        },
        {
          id: "4983",
          name: "Mohan",
          state_id: "38",
        },
        {
          id: "4984",
          name: "Mohanpur",
          state_id: "38",
        },
        {
          id: "4985",
          name: "Mohiuddinpur",
          state_id: "38",
        },
        {
          id: "4986",
          name: "Moradabad",
          state_id: "38",
        },
        {
          id: "4987",
          name: "Moth",
          state_id: "38",
        },
        {
          id: "4988",
          name: "Mubarakpur",
          state_id: "38",
        },
        {
          id: "4989",
          name: "Mughal Sarai",
          state_id: "38",
        },
        {
          id: "4990",
          name: "Mughal Sarai Railway Settlemen",
          state_id: "38",
        },
        {
          id: "4991",
          name: "Muhammadabad",
          state_id: "38",
        },
        {
          id: "4992",
          name: "Muhammadi",
          state_id: "38",
        },
        {
          id: "4993",
          name: "Mukrampur Khema",
          state_id: "38",
        },
        {
          id: "4994",
          name: "Mundia",
          state_id: "38",
        },
        {
          id: "4995",
          name: "Mundora",
          state_id: "38",
        },
        {
          id: "4996",
          name: "Muradnagar",
          state_id: "38",
        },
        {
          id: "4997",
          name: "Mursan",
          state_id: "38",
        },
        {
          id: "4998",
          name: "Musafirkhana",
          state_id: "38",
        },
        {
          id: "4999",
          name: "Muzaffarnagar",
          state_id: "38",
        },
        {
          id: "5000",
          name: "Nadigaon",
          state_id: "38",
        },
        {
          id: "5001",
          name: "Nagina",
          state_id: "38",
        },
        {
          id: "5002",
          name: "Nagram",
          state_id: "38",
        },
        {
          id: "5003",
          name: "Nai Bazar",
          state_id: "38",
        },
        {
          id: "5004",
          name: "Nainana Jat",
          state_id: "38",
        },
        {
          id: "5005",
          name: "Najibabad",
          state_id: "38",
        },
        {
          id: "5006",
          name: "Nakur",
          state_id: "38",
        },
        {
          id: "5007",
          name: "Nanaunta",
          state_id: "38",
        },
        {
          id: "5008",
          name: "Nandgaon",
          state_id: "38",
        },
        {
          id: "5009",
          name: "Nanpara",
          state_id: "38",
        },
        {
          id: "5010",
          name: "Naraini",
          state_id: "38",
        },
        {
          id: "5011",
          name: "Narauli",
          state_id: "38",
        },
        {
          id: "5012",
          name: "Naraura",
          state_id: "38",
        },
        {
          id: "5013",
          name: "Naugawan Sadat",
          state_id: "38",
        },
        {
          id: "5014",
          name: "Nautanwa",
          state_id: "38",
        },
        {
          id: "5015",
          name: "Nawabganj",
          state_id: "38",
        },
        {
          id: "5016",
          name: "Nichlaul",
          state_id: "38",
        },
        {
          id: "5017",
          name: "Nidhauli Kalan",
          state_id: "38",
        },
        {
          id: "5018",
          name: "Nihtaur",
          state_id: "38",
        },
        {
          id: "5019",
          name: "Nindaura",
          state_id: "38",
        },
        {
          id: "5020",
          name: "Niwari",
          state_id: "38",
        },
        {
          id: "5021",
          name: "Nizamabad",
          state_id: "38",
        },
        {
          id: "5022",
          name: "Noida",
          state_id: "38",
        },
        {
          id: "5023",
          name: "Northern Railway Colony",
          state_id: "38",
        },
        {
          id: "5024",
          name: "Nurpur",
          state_id: "38",
        },
        {
          id: "5025",
          name: "Nyoria Husenpur",
          state_id: "38",
        },
        {
          id: "5026",
          name: "Nyotini",
          state_id: "38",
        },
        {
          id: "5027",
          name: "Obra",
          state_id: "38",
        },
        {
          id: "5028",
          name: "Oel Dhakwa",
          state_id: "38",
        },
        {
          id: "5029",
          name: "Orai",
          state_id: "38",
        },
        {
          id: "5030",
          name: "Oran",
          state_id: "38",
        },
        {
          id: "5031",
          name: "Ordinance Factory Muradnagar",
          state_id: "38",
        },
        {
          id: "5032",
          name: "Pachperwa",
          state_id: "38",
        },
        {
          id: "5033",
          name: "Padrauna",
          state_id: "38",
        },
        {
          id: "5034",
          name: "Pahasu",
          state_id: "38",
        },
        {
          id: "5035",
          name: "Paintepur",
          state_id: "38",
        },
        {
          id: "5036",
          name: "Pali",
          state_id: "38",
        },
        {
          id: "5037",
          name: "Palia Kalan",
          state_id: "38",
        },
        {
          id: "5038",
          name: "Parasi",
          state_id: "38",
        },
        {
          id: "5039",
          name: "Parichha",
          state_id: "38",
        },
        {
          id: "5040",
          name: "Parichhatgarh",
          state_id: "38",
        },
        {
          id: "5041",
          name: "Parsadepur",
          state_id: "38",
        },
        {
          id: "5042",
          name: "Patala",
          state_id: "38",
        },
        {
          id: "5043",
          name: "Patiyali",
          state_id: "38",
        },
        {
          id: "5044",
          name: "Patti",
          state_id: "38",
        },
        {
          id: "5045",
          name: "Pawayan",
          state_id: "38",
        },
        {
          id: "5046",
          name: "Phalauda",
          state_id: "38",
        },
        {
          id: "5047",
          name: "Phaphund",
          state_id: "38",
        },
        {
          id: "5048",
          name: "Phulpur",
          state_id: "38",
        },
        {
          id: "5049",
          name: "Phulwaria",
          state_id: "38",
        },
        {
          id: "5050",
          name: "Pihani",
          state_id: "38",
        },
        {
          id: "5051",
          name: "Pilibhit",
          state_id: "38",
        },
        {
          id: "5052",
          name: "Pilkana",
          state_id: "38",
        },
        {
          id: "5053",
          name: "Pilkhuwa",
          state_id: "38",
        },
        {
          id: "5054",
          name: "Pinahat",
          state_id: "38",
        },
        {
          id: "5055",
          name: "Pipalsana Chaudhari",
          state_id: "38",
        },
        {
          id: "5056",
          name: "Pipiganj",
          state_id: "38",
        },
        {
          id: "5057",
          name: "Pipraich",
          state_id: "38",
        },
        {
          id: "5058",
          name: "Pipri",
          state_id: "38",
        },
        {
          id: "5059",
          name: "Pratapgarh",
          state_id: "38",
        },
        {
          id: "5060",
          name: "Pukhrayan",
          state_id: "38",
        },
        {
          id: "5061",
          name: "Puranpur",
          state_id: "38",
        },
        {
          id: "5062",
          name: "Purdil Nagar",
          state_id: "38",
        },
        {
          id: "5063",
          name: "Purqazi",
          state_id: "38",
        },
        {
          id: "5064",
          name: "Purwa",
          state_id: "38",
        },
        {
          id: "5065",
          name: "Qasimpur",
          state_id: "38",
        },
        {
          id: "5066",
          name: "Rabupura",
          state_id: "38",
        },
        {
          id: "5067",
          name: "Radha Kund",
          state_id: "38",
        },
        {
          id: "5068",
          name: "Rae Bareilly",
          state_id: "38",
        },
        {
          id: "5069",
          name: "Raja Ka Rampur",
          state_id: "38",
        },
        {
          id: "5070",
          name: "Rajapur",
          state_id: "38",
        },
        {
          id: "5071",
          name: "Ramkola",
          state_id: "38",
        },
        {
          id: "5072",
          name: "Ramnagar",
          state_id: "38",
        },
        {
          id: "5073",
          name: "Rampur",
          state_id: "38",
        },
        {
          id: "5074",
          name: "Rampur Bhawanipur",
          state_id: "38",
        },
        {
          id: "5075",
          name: "Rampur Karkhana",
          state_id: "38",
        },
        {
          id: "5076",
          name: "Rampur Maniharan",
          state_id: "38",
        },
        {
          id: "5077",
          name: "Rampura",
          state_id: "38",
        },
        {
          id: "5078",
          name: "Ranipur",
          state_id: "38",
        },
        {
          id: "5079",
          name: "Rashidpur Garhi",
          state_id: "38",
        },
        {
          id: "5080",
          name: "Rasra",
          state_id: "38",
        },
        {
          id: "5081",
          name: "Rasulabad",
          state_id: "38",
        },
        {
          id: "5082",
          name: "Rath",
          state_id: "38",
        },
        {
          id: "5083",
          name: "Raya",
          state_id: "38",
        },
        {
          id: "5084",
          name: "Renukut",
          state_id: "38",
        },
        {
          id: "5085",
          name: "Reoti",
          state_id: "38",
        },
        {
          id: "5086",
          name: "Richha",
          state_id: "38",
        },
        {
          id: "5087",
          name: "Risia Bazar",
          state_id: "38",
        },
        {
          id: "5088",
          name: "Rithora",
          state_id: "38",
        },
        {
          id: "5089",
          name: "Robertsganj",
          state_id: "38",
        },
        {
          id: "5090",
          name: "Roza",
          state_id: "38",
        },
        {
          id: "5091",
          name: "Rudarpur",
          state_id: "38",
        },
        {
          id: "5092",
          name: "Rudauli",
          state_id: "38",
        },
        {
          id: "5093",
          name: "Rudayan",
          state_id: "38",
        },
        {
          id: "5094",
          name: "Rura",
          state_id: "38",
        },
        {
          id: "5095",
          name: "Rustamnagar Sahaspur",
          state_id: "38",
        },
        {
          id: "5096",
          name: "Sabatwar",
          state_id: "38",
        },
        {
          id: "5097",
          name: "Sadabad",
          state_id: "38",
        },
        {
          id: "5098",
          name: "Sadat",
          state_id: "38",
        },
        {
          id: "5099",
          name: "Safipur",
          state_id: "38",
        },
        {
          id: "5100",
          name: "Sahanpur",
          state_id: "38",
        },
        {
          id: "5101",
          name: "Saharanpur",
          state_id: "38",
        },
        {
          id: "5102",
          name: "Sahaspur",
          state_id: "38",
        },
        {
          id: "5103",
          name: "Sahaswan",
          state_id: "38",
        },
        {
          id: "5104",
          name: "Sahawar",
          state_id: "38",
        },
        {
          id: "5105",
          name: "Sahibabad",
          state_id: "38",
        },
        {
          id: "5106",
          name: "Sahjanwa",
          state_id: "38",
        },
        {
          id: "5107",
          name: "Sahpau",
          state_id: "38",
        },
        {
          id: "5108",
          name: "Saidpur",
          state_id: "38",
        },
        {
          id: "5109",
          name: "Sainthal",
          state_id: "38",
        },
        {
          id: "5110",
          name: "Saiyadraja",
          state_id: "38",
        },
        {
          id: "5111",
          name: "Sakhanu",
          state_id: "38",
        },
        {
          id: "5112",
          name: "Sakit",
          state_id: "38",
        },
        {
          id: "5113",
          name: "Salarpur Khadar",
          state_id: "38",
        },
        {
          id: "5114",
          name: "Salimpur",
          state_id: "38",
        },
        {
          id: "5115",
          name: "Salon",
          state_id: "38",
        },
        {
          id: "5116",
          name: "Sambhal",
          state_id: "38",
        },
        {
          id: "5117",
          name: "Sambhawali",
          state_id: "38",
        },
        {
          id: "5118",
          name: "Samdhan",
          state_id: "38",
        },
        {
          id: "5119",
          name: "Samthar",
          state_id: "38",
        },
        {
          id: "5120",
          name: "Sandi",
          state_id: "38",
        },
        {
          id: "5121",
          name: "Sandila",
          state_id: "38",
        },
        {
          id: "5122",
          name: "Sarai Mir",
          state_id: "38",
        },
        {
          id: "5123",
          name: "Sarai akil",
          state_id: "38",
        },
        {
          id: "5124",
          name: "Sarauli",
          state_id: "38",
        },
        {
          id: "5125",
          name: "Sardhana",
          state_id: "38",
        },
        {
          id: "5126",
          name: "Sarila",
          state_id: "38",
        },
        {
          id: "5127",
          name: "Sarsawan",
          state_id: "38",
        },
        {
          id: "5128",
          name: "Sasni",
          state_id: "38",
        },
        {
          id: "5129",
          name: "Satrikh",
          state_id: "38",
        },
        {
          id: "5130",
          name: "Saunkh",
          state_id: "38",
        },
        {
          id: "5131",
          name: "Saurikh",
          state_id: "38",
        },
        {
          id: "5132",
          name: "Seohara",
          state_id: "38",
        },
        {
          id: "5133",
          name: "Sewal Khas",
          state_id: "38",
        },
        {
          id: "5134",
          name: "Sewarhi",
          state_id: "38",
        },
        {
          id: "5135",
          name: "Shahabad",
          state_id: "38",
        },
        {
          id: "5136",
          name: "Shahganj",
          state_id: "38",
        },
        {
          id: "5137",
          name: "Shahi",
          state_id: "38",
        },
        {
          id: "5138",
          name: "Shahjahanpur",
          state_id: "38",
        },
        {
          id: "5139",
          name: "Shahjahanpur Cantonment",
          state_id: "38",
        },
        {
          id: "5140",
          name: "Shahpur",
          state_id: "38",
        },
        {
          id: "5141",
          name: "Shamli",
          state_id: "38",
        },
        {
          id: "5142",
          name: "Shamsabad",
          state_id: "38",
        },
        {
          id: "5143",
          name: "Shankargarh",
          state_id: "38",
        },
        {
          id: "5144",
          name: "Shergarh",
          state_id: "38",
        },
        {
          id: "5145",
          name: "Sherkot",
          state_id: "38",
        },
        {
          id: "5146",
          name: "Shikarpur",
          state_id: "38",
        },
        {
          id: "5147",
          name: "Shikohabad",
          state_id: "38",
        },
        {
          id: "5148",
          name: "Shisgarh",
          state_id: "38",
        },
        {
          id: "5149",
          name: "Shivdaspur",
          state_id: "38",
        },
        {
          id: "5150",
          name: "Shivli",
          state_id: "38",
        },
        {
          id: "5151",
          name: "Shivrajpur",
          state_id: "38",
        },
        {
          id: "5152",
          name: "Shohratgarh",
          state_id: "38",
        },
        {
          id: "5153",
          name: "Siddhanur",
          state_id: "38",
        },
        {
          id: "5154",
          name: "Siddharthnagar",
          state_id: "38",
        },
        {
          id: "5155",
          name: "Sidhauli",
          state_id: "38",
        },
        {
          id: "5156",
          name: "Sidhpura",
          state_id: "38",
        },
        {
          id: "5157",
          name: "Sikandarabad",
          state_id: "38",
        },
        {
          id: "5158",
          name: "Sikandarpur",
          state_id: "38",
        },
        {
          id: "5159",
          name: "Sikandra",
          state_id: "38",
        },
        {
          id: "5160",
          name: "Sikandra Rao",
          state_id: "38",
        },
        {
          id: "5161",
          name: "Singahi Bhiraura",
          state_id: "38",
        },
        {
          id: "5162",
          name: "Sirathu",
          state_id: "38",
        },
        {
          id: "5163",
          name: "Sirsa",
          state_id: "38",
        },
        {
          id: "5164",
          name: "Sirsaganj",
          state_id: "38",
        },
        {
          id: "5165",
          name: "Sirsi",
          state_id: "38",
        },
        {
          id: "5166",
          name: "Sisauli",
          state_id: "38",
        },
        {
          id: "5167",
          name: "Siswa Bazar",
          state_id: "38",
        },
        {
          id: "5168",
          name: "Sitapur",
          state_id: "38",
        },
        {
          id: "5169",
          name: "Siyana",
          state_id: "38",
        },
        {
          id: "5170",
          name: "Som",
          state_id: "38",
        },
        {
          id: "5171",
          name: "Sonbhadra",
          state_id: "38",
        },
        {
          id: "5172",
          name: "Soron",
          state_id: "38",
        },
        {
          id: "5173",
          name: "Suar",
          state_id: "38",
        },
        {
          id: "5174",
          name: "Sukhmalpur Nizamabad",
          state_id: "38",
        },
        {
          id: "5175",
          name: "Sultanpur",
          state_id: "38",
        },
        {
          id: "5176",
          name: "Sumerpur",
          state_id: "38",
        },
        {
          id: "5177",
          name: "Suriyawan",
          state_id: "38",
        },
        {
          id: "5178",
          name: "Swamibagh",
          state_id: "38",
        },
        {
          id: "5179",
          name: "Tajpur",
          state_id: "38",
        },
        {
          id: "5180",
          name: "Talbahat",
          state_id: "38",
        },
        {
          id: "5181",
          name: "Talgram",
          state_id: "38",
        },
        {
          id: "5182",
          name: "Tambaur",
          state_id: "38",
        },
        {
          id: "5183",
          name: "Tanda",
          state_id: "38",
        },
        {
          id: "5184",
          name: "Tatarpur Lallu",
          state_id: "38",
        },
        {
          id: "5185",
          name: "Tetribazar",
          state_id: "38",
        },
        {
          id: "5186",
          name: "Thakurdwara",
          state_id: "38",
        },
        {
          id: "5187",
          name: "Thana Bhawan",
          state_id: "38",
        },
        {
          id: "5188",
          name: "Thiriya Nizamat Khan",
          state_id: "38",
        },
        {
          id: "5189",
          name: "Tikaitnagar",
          state_id: "38",
        },
        {
          id: "5190",
          name: "Tikri",
          state_id: "38",
        },
        {
          id: "5191",
          name: "Tilhar",
          state_id: "38",
        },
        {
          id: "5192",
          name: "Tindwari",
          state_id: "38",
        },
        {
          id: "5193",
          name: "Tirwaganj",
          state_id: "38",
        },
        {
          id: "5194",
          name: "Titron",
          state_id: "38",
        },
        {
          id: "5195",
          name: "Tori Fatehpur",
          state_id: "38",
        },
        {
          id: "5196",
          name: "Tulsipur",
          state_id: "38",
        },
        {
          id: "5197",
          name: "Tundla",
          state_id: "38",
        },
        {
          id: "5198",
          name: "Tundla Kham",
          state_id: "38",
        },
        {
          id: "5199",
          name: "Tundla Railway Colony",
          state_id: "38",
        },
        {
          id: "5200",
          name: "Ugu",
          state_id: "38",
        },
        {
          id: "5201",
          name: "Ujhani",
          state_id: "38",
        },
        {
          id: "5202",
          name: "Ujhari",
          state_id: "38",
        },
        {
          id: "5203",
          name: "Umri",
          state_id: "38",
        },
        {
          id: "5204",
          name: "Umri Kalan",
          state_id: "38",
        },
        {
          id: "5205",
          name: "Un",
          state_id: "38",
        },
        {
          id: "5206",
          name: "Unchahar",
          state_id: "38",
        },
        {
          id: "5207",
          name: "Unnao",
          state_id: "38",
        },
        {
          id: "5208",
          name: "Usaihat",
          state_id: "38",
        },
        {
          id: "5209",
          name: "Usawan",
          state_id: "38",
        },
        {
          id: "5210",
          name: "Utraula",
          state_id: "38",
        },
        {
          id: "5211",
          name: "Varanasi",
          state_id: "38",
        },
        {
          id: "5212",
          name: "Varanasi Cantonment",
          state_id: "38",
        },
        {
          id: "5213",
          name: "Vijaigarh",
          state_id: "38",
        },
        {
          id: "5214",
          name: "Vrindavan",
          state_id: "38",
        },
        {
          id: "5215",
          name: "Wazirganj",
          state_id: "38",
        },
        {
          id: "5216",
          name: "Zafarabad",
          state_id: "38",
        },
        {
          id: "5217",
          name: "Zaidpur",
          state_id: "38",
        },
        {
          id: "5218",
          name: "Zamania",
          state_id: "38",
        },
      ],
      Uttarakhand: [
        {
          id: "5219",
          name: "Almora",
          state_id: "39",
        },
        {
          id: "5220",
          name: "Almora Cantonment",
          state_id: "39",
        },
        {
          id: "5221",
          name: "Badrinathpuri",
          state_id: "39",
        },
        {
          id: "5222",
          name: "Bageshwar",
          state_id: "39",
        },
        {
          id: "5223",
          name: "Bah Bazar",
          state_id: "39",
        },
        {
          id: "5224",
          name: "Banbasa",
          state_id: "39",
        },
        {
          id: "5225",
          name: "Bandia",
          state_id: "39",
        },
        {
          id: "5226",
          name: "Barkot",
          state_id: "39",
        },
        {
          id: "5227",
          name: "Bazpur",
          state_id: "39",
        },
        {
          id: "5228",
          name: "Bhim Tal",
          state_id: "39",
        },
        {
          id: "5229",
          name: "Bhowali",
          state_id: "39",
        },
        {
          id: "5230",
          name: "Chakrata",
          state_id: "39",
        },
        {
          id: "5231",
          name: "Chamba",
          state_id: "39",
        },
        {
          id: "5232",
          name: "Chamoli and Gopeshwar",
          state_id: "39",
        },
        {
          id: "5233",
          name: "Champawat",
          state_id: "39",
        },
        {
          id: "5234",
          name: "Clement Town",
          state_id: "39",
        },
        {
          id: "5235",
          name: "Dehra Dun Cantonment",
          state_id: "39",
        },
        {
          id: "5236",
          name: "Dehradun",
          state_id: "39",
        },
        {
          id: "5237",
          name: "Dehrakhas",
          state_id: "39",
        },
        {
          id: "5238",
          name: "Devaprayag",
          state_id: "39",
        },
        {
          id: "5239",
          name: "Dhaluwala",
          state_id: "39",
        },
        {
          id: "5240",
          name: "Dhandera",
          state_id: "39",
        },
        {
          id: "5241",
          name: "Dharchula",
          state_id: "39",
        },
        {
          id: "5242",
          name: "Dharchula Dehat",
          state_id: "39",
        },
        {
          id: "5243",
          name: "Didihat",
          state_id: "39",
        },
        {
          id: "5244",
          name: "Dineshpur",
          state_id: "39",
        },
        {
          id: "5245",
          name: "Doiwala",
          state_id: "39",
        },
        {
          id: "5246",
          name: "Dugadda",
          state_id: "39",
        },
        {
          id: "5247",
          name: "Dwarahat",
          state_id: "39",
        },
        {
          id: "5248",
          name: "Gadarpur",
          state_id: "39",
        },
        {
          id: "5249",
          name: "Gangotri",
          state_id: "39",
        },
        {
          id: "5250",
          name: "Gauchar",
          state_id: "39",
        },
        {
          id: "5251",
          name: "Haldwani",
          state_id: "39",
        },
        {
          id: "5252",
          name: "Haridwar",
          state_id: "39",
        },
        {
          id: "5253",
          name: "Herbertpur",
          state_id: "39",
        },
        {
          id: "5254",
          name: "Jaspur",
          state_id: "39",
        },
        {
          id: "5255",
          name: "Jhabrera",
          state_id: "39",
        },
        {
          id: "5256",
          name: "Joshimath",
          state_id: "39",
        },
        {
          id: "5257",
          name: "Kachnal Gosain",
          state_id: "39",
        },
        {
          id: "5258",
          name: "Kaladungi",
          state_id: "39",
        },
        {
          id: "5259",
          name: "Kalagarh",
          state_id: "39",
        },
        {
          id: "5260",
          name: "Karnaprayang",
          state_id: "39",
        },
        {
          id: "5261",
          name: "Kashipur",
          state_id: "39",
        },
        {
          id: "5262",
          name: "Kashirampur",
          state_id: "39",
        },
        {
          id: "5263",
          name: "Kausani",
          state_id: "39",
        },
        {
          id: "5264",
          name: "Kedarnath",
          state_id: "39",
        },
        {
          id: "5265",
          name: "Kelakhera",
          state_id: "39",
        },
        {
          id: "5266",
          name: "Khatima",
          state_id: "39",
        },
        {
          id: "5267",
          name: "Kichha",
          state_id: "39",
        },
        {
          id: "5268",
          name: "Kirtinagar",
          state_id: "39",
        },
        {
          id: "5269",
          name: "Kotdwara",
          state_id: "39",
        },
        {
          id: "5270",
          name: "Laksar",
          state_id: "39",
        },
        {
          id: "5271",
          name: "Lalkuan",
          state_id: "39",
        },
        {
          id: "5272",
          name: "Landaura",
          state_id: "39",
        },
        {
          id: "5273",
          name: "Landhaura Cantonment",
          state_id: "39",
        },
        {
          id: "5274",
          name: "Lensdaun",
          state_id: "39",
        },
        {
          id: "5275",
          name: "Logahat",
          state_id: "39",
        },
        {
          id: "5276",
          name: "Mahua Dabra Haripura",
          state_id: "39",
        },
        {
          id: "5277",
          name: "Mahua Kheraganj",
          state_id: "39",
        },
        {
          id: "5278",
          name: "Manglaur",
          state_id: "39",
        },
        {
          id: "5279",
          name: "Masuri",
          state_id: "39",
        },
        {
          id: "5280",
          name: "Mohanpur Mohammadpur",
          state_id: "39",
        },
        {
          id: "5281",
          name: "Muni Ki Reti",
          state_id: "39",
        },
        {
          id: "5282",
          name: "Nagla",
          state_id: "39",
        },
        {
          id: "5283",
          name: "Nainital",
          state_id: "39",
        },
        {
          id: "5284",
          name: "Nainital Cantonment",
          state_id: "39",
        },
        {
          id: "5285",
          name: "Nandaprayang",
          state_id: "39",
        },
        {
          id: "5286",
          name: "Narendranagar",
          state_id: "39",
        },
        {
          id: "5287",
          name: "Pauri",
          state_id: "39",
        },
        {
          id: "5288",
          name: "Pithoragarh",
          state_id: "39",
        },
        {
          id: "5289",
          name: "Pratitnagar",
          state_id: "39",
        },
        {
          id: "5290",
          name: "Raipur",
          state_id: "39",
        },
        {
          id: "5291",
          name: "Raiwala",
          state_id: "39",
        },
        {
          id: "5292",
          name: "Ramnagar",
          state_id: "39",
        },
        {
          id: "5293",
          name: "Ranikhet",
          state_id: "39",
        },
        {
          id: "5294",
          name: "Ranipur",
          state_id: "39",
        },
        {
          id: "5295",
          name: "Rishikesh",
          state_id: "39",
        },
        {
          id: "5296",
          name: "Rishikesh Cantonment",
          state_id: "39",
        },
        {
          id: "5297",
          name: "Roorkee",
          state_id: "39",
        },
        {
          id: "5298",
          name: "Rudraprayag",
          state_id: "39",
        },
        {
          id: "5299",
          name: "Rudrapur",
          state_id: "39",
        },
        {
          id: "5300",
          name: "Rurki",
          state_id: "39",
        },
        {
          id: "5301",
          name: "Rurki Cantonment",
          state_id: "39",
        },
        {
          id: "5302",
          name: "Shaktigarh",
          state_id: "39",
        },
        {
          id: "5303",
          name: "Sitarganj",
          state_id: "39",
        },
        {
          id: "5304",
          name: "Srinagar",
          state_id: "39",
        },
        {
          id: "5305",
          name: "Sultanpur",
          state_id: "39",
        },
        {
          id: "5306",
          name: "Tanakpur",
          state_id: "39",
        },
        {
          id: "5307",
          name: "Tehri",
          state_id: "39",
        },
        {
          id: "5308",
          name: "Udham Singh Nagar",
          state_id: "39",
        },
        {
          id: "5309",
          name: "Uttarkashi",
          state_id: "39",
        },
        {
          id: "5310",
          name: "Vikasnagar",
          state_id: "39",
        },
        {
          id: "5311",
          name: "Virbhadra",
          state_id: "39",
        },
      ],
      Vaishali: [],
      "West Bengal": [
        {
          id: "5312",
          name: "24 Parganas (n)",
          state_id: "41",
        },
        {
          id: "5313",
          name: "24 Parganas (s)",
          state_id: "41",
        },
        {
          id: "5314",
          name: "Adra",
          state_id: "41",
        },
        {
          id: "5315",
          name: "Ahmadpur",
          state_id: "41",
        },
        {
          id: "5316",
          name: "Aiho",
          state_id: "41",
        },
        {
          id: "5317",
          name: "Aistala",
          state_id: "41",
        },
        {
          id: "5318",
          name: "Alipur Duar",
          state_id: "41",
        },
        {
          id: "5319",
          name: "Alipur Duar Railway Junction",
          state_id: "41",
        },
        {
          id: "5320",
          name: "Alpur",
          state_id: "41",
        },
        {
          id: "5321",
          name: "Amalhara",
          state_id: "41",
        },
        {
          id: "5322",
          name: "Amkula",
          state_id: "41",
        },
        {
          id: "5323",
          name: "Amlagora",
          state_id: "41",
        },
        {
          id: "5324",
          name: "Amodghata",
          state_id: "41",
        },
        {
          id: "5325",
          name: "Amtala",
          state_id: "41",
        },
        {
          id: "5326",
          name: "Andul",
          state_id: "41",
        },
        {
          id: "5327",
          name: "Anksa",
          state_id: "41",
        },
        {
          id: "5328",
          name: "Ankurhati",
          state_id: "41",
        },
        {
          id: "5329",
          name: "Anup Nagar",
          state_id: "41",
        },
        {
          id: "5330",
          name: "Arambagh",
          state_id: "41",
        },
        {
          id: "5331",
          name: "Argari",
          state_id: "41",
        },
        {
          id: "5332",
          name: "Arsha",
          state_id: "41",
        },
        {
          id: "5333",
          name: "Asansol",
          state_id: "41",
        },
        {
          id: "5334",
          name: "Ashoknagar Kalyangarh",
          state_id: "41",
        },
        {
          id: "5335",
          name: "Aurangabad",
          state_id: "41",
        },
        {
          id: "5336",
          name: "Bablari Dewanganj",
          state_id: "41",
        },
        {
          id: "5337",
          name: "Badhagachhi",
          state_id: "41",
        },
        {
          id: "5338",
          name: "Baduria",
          state_id: "41",
        },
        {
          id: "5339",
          name: "Baghdogra",
          state_id: "41",
        },
        {
          id: "5340",
          name: "Bagnan",
          state_id: "41",
        },
        {
          id: "5341",
          name: "Bagra",
          state_id: "41",
        },
        {
          id: "5342",
          name: "Bagula",
          state_id: "41",
        },
        {
          id: "5343",
          name: "Baharampur",
          state_id: "41",
        },
        {
          id: "5344",
          name: "Bahirgram",
          state_id: "41",
        },
        {
          id: "5345",
          name: "Bahula",
          state_id: "41",
        },
        {
          id: "5346",
          name: "Baidyabati",
          state_id: "41",
        },
        {
          id: "5347",
          name: "Bairatisal",
          state_id: "41",
        },
        {
          id: "5348",
          name: "Baj Baj",
          state_id: "41",
        },
        {
          id: "5349",
          name: "Bakreswar",
          state_id: "41",
        },
        {
          id: "5350",
          name: "Balaram Pota",
          state_id: "41",
        },
        {
          id: "5351",
          name: "Balarampur",
          state_id: "41",
        },
        {
          id: "5352",
          name: "Bali Chak",
          state_id: "41",
        },
        {
          id: "5353",
          name: "Ballavpur",
          state_id: "41",
        },
        {
          id: "5354",
          name: "Bally",
          state_id: "41",
        },
        {
          id: "5355",
          name: "Balurghat",
          state_id: "41",
        },
        {
          id: "5356",
          name: "Bamunari",
          state_id: "41",
        },
        {
          id: "5357",
          name: "Banarhat Tea Garden",
          state_id: "41",
        },
        {
          id: "5358",
          name: "Bandel",
          state_id: "41",
        },
        {
          id: "5359",
          name: "Bangaon",
          state_id: "41",
        },
        {
          id: "5360",
          name: "Bankra",
          state_id: "41",
        },
        {
          id: "5361",
          name: "Bankura",
          state_id: "41",
        },
        {
          id: "5362",
          name: "Bansbaria",
          state_id: "41",
        },
        {
          id: "5363",
          name: "Banshra",
          state_id: "41",
        },
        {
          id: "5364",
          name: "Banupur",
          state_id: "41",
        },
        {
          id: "5365",
          name: "Bara Bamonia",
          state_id: "41",
        },
        {
          id: "5366",
          name: "Barakpur",
          state_id: "41",
        },
        {
          id: "5367",
          name: "Barakpur Cantonment",
          state_id: "41",
        },
        {
          id: "5368",
          name: "Baranagar",
          state_id: "41",
        },
        {
          id: "5369",
          name: "Barasat",
          state_id: "41",
        },
        {
          id: "5370",
          name: "Barddhaman",
          state_id: "41",
        },
        {
          id: "5371",
          name: "Barijhati",
          state_id: "41",
        },
        {
          id: "5372",
          name: "Barjora",
          state_id: "41",
        },
        {
          id: "5373",
          name: "Barrackpore",
          state_id: "41",
        },
        {
          id: "5374",
          name: "Baruihuda",
          state_id: "41",
        },
        {
          id: "5375",
          name: "Baruipur",
          state_id: "41",
        },
        {
          id: "5376",
          name: "Barunda",
          state_id: "41",
        },
        {
          id: "5377",
          name: "Basirhat",
          state_id: "41",
        },
        {
          id: "5378",
          name: "Baska",
          state_id: "41",
        },
        {
          id: "5379",
          name: "Begampur",
          state_id: "41",
        },
        {
          id: "5380",
          name: "Beldanga",
          state_id: "41",
        },
        {
          id: "5381",
          name: "Beldubi",
          state_id: "41",
        },
        {
          id: "5382",
          name: "Belebathan",
          state_id: "41",
        },
        {
          id: "5383",
          name: "Beliator",
          state_id: "41",
        },
        {
          id: "5384",
          name: "Bhadreswar",
          state_id: "41",
        },
        {
          id: "5385",
          name: "Bhandardaha",
          state_id: "41",
        },
        {
          id: "5386",
          name: "Bhangar Raghunathpur",
          state_id: "41",
        },
        {
          id: "5387",
          name: "Bhangri Pratham Khanda",
          state_id: "41",
        },
        {
          id: "5388",
          name: "Bhanowara",
          state_id: "41",
        },
        {
          id: "5389",
          name: "Bhatpara",
          state_id: "41",
        },
        {
          id: "5390",
          name: "Bholar Dabri",
          state_id: "41",
        },
        {
          id: "5391",
          name: "Bidhannagar",
          state_id: "41",
        },
        {
          id: "5392",
          name: "Bidyadharpur",
          state_id: "41",
        },
        {
          id: "5393",
          name: "Biki Hakola",
          state_id: "41",
        },
        {
          id: "5394",
          name: "Bilandapur",
          state_id: "41",
        },
        {
          id: "5395",
          name: "Bilpahari",
          state_id: "41",
        },
        {
          id: "5396",
          name: "Bipra Noapara",
          state_id: "41",
        },
        {
          id: "5397",
          name: "Birlapur",
          state_id: "41",
        },
        {
          id: "5398",
          name: "Birnagar",
          state_id: "41",
        },
        {
          id: "5399",
          name: "Bisarpara",
          state_id: "41",
        },
        {
          id: "5400",
          name: "Bishnupur",
          state_id: "41",
        },
        {
          id: "5401",
          name: "Bolpur",
          state_id: "41",
        },
        {
          id: "5402",
          name: "Bongaon",
          state_id: "41",
        },
        {
          id: "5403",
          name: "Bowali",
          state_id: "41",
        },
        {
          id: "5404",
          name: "Burdwan",
          state_id: "41",
        },
        {
          id: "5405",
          name: "Canning",
          state_id: "41",
        },
        {
          id: "5406",
          name: "Cart Road",
          state_id: "41",
        },
        {
          id: "5407",
          name: "Chachanda",
          state_id: "41",
        },
        {
          id: "5408",
          name: "Chak Bankola",
          state_id: "41",
        },
        {
          id: "5409",
          name: "Chak Enayetnagar",
          state_id: "41",
        },
        {
          id: "5410",
          name: "Chak Kashipur",
          state_id: "41",
        },
        {
          id: "5411",
          name: "Chakalampur",
          state_id: "41",
        },
        {
          id: "5412",
          name: "Chakbansberia",
          state_id: "41",
        },
        {
          id: "5413",
          name: "Chakdaha",
          state_id: "41",
        },
        {
          id: "5414",
          name: "Chakpara",
          state_id: "41",
        },
        {
          id: "5415",
          name: "Champahati",
          state_id: "41",
        },
        {
          id: "5416",
          name: "Champdani",
          state_id: "41",
        },
        {
          id: "5417",
          name: "Chamrail",
          state_id: "41",
        },
        {
          id: "5418",
          name: "Chandannagar",
          state_id: "41",
        },
        {
          id: "5419",
          name: "Chandpur",
          state_id: "41",
        },
        {
          id: "5420",
          name: "Chandrakona",
          state_id: "41",
        },
        {
          id: "5421",
          name: "Chapari",
          state_id: "41",
        },
        {
          id: "5422",
          name: "Chapui",
          state_id: "41",
        },
        {
          id: "5423",
          name: "Char Brahmanagar",
          state_id: "41",
        },
        {
          id: "5424",
          name: "Char Maijdia",
          state_id: "41",
        },
        {
          id: "5425",
          name: "Charka",
          state_id: "41",
        },
        {
          id: "5426",
          name: "Chata Kalikapur",
          state_id: "41",
        },
        {
          id: "5427",
          name: "Chauhati",
          state_id: "41",
        },
        {
          id: "5428",
          name: "Checha Khata",
          state_id: "41",
        },
        {
          id: "5429",
          name: "Chelad",
          state_id: "41",
        },
        {
          id: "5430",
          name: "Chhora",
          state_id: "41",
        },
        {
          id: "5431",
          name: "Chikrand",
          state_id: "41",
        },
        {
          id: "5432",
          name: "Chittaranjan",
          state_id: "41",
        },
        {
          id: "5433",
          name: "Contai",
          state_id: "41",
        },
        {
          id: "5434",
          name: "Cooch Behar",
          state_id: "41",
        },
        {
          id: "5435",
          name: "Dainhat",
          state_id: "41",
        },
        {
          id: "5436",
          name: "Dakshin Baguan",
          state_id: "41",
        },
        {
          id: "5437",
          name: "Dakshin Jhapardaha",
          state_id: "41",
        },
        {
          id: "5438",
          name: "Dakshin Rajyadharpur",
          state_id: "41",
        },
        {
          id: "5439",
          name: "Dakshin Raypur",
          state_id: "41",
        },
        {
          id: "5440",
          name: "Dalkola",
          state_id: "41",
        },
        {
          id: "5441",
          name: "Dalurband",
          state_id: "41",
        },
        {
          id: "5442",
          name: "Darap Pur",
          state_id: "41",
        },
        {
          id: "5443",
          name: "Darjiling",
          state_id: "41",
        },
        {
          id: "5444",
          name: "Daulatpur",
          state_id: "41",
        },
        {
          id: "5445",
          name: "Debipur",
          state_id: "41",
        },
        {
          id: "5446",
          name: "Defahat",
          state_id: "41",
        },
        {
          id: "5447",
          name: "Deora",
          state_id: "41",
        },
        {
          id: "5448",
          name: "Deulia",
          state_id: "41",
        },
        {
          id: "5449",
          name: "Dhakuria",
          state_id: "41",
        },
        {
          id: "5450",
          name: "Dhandadihi",
          state_id: "41",
        },
        {
          id: "5451",
          name: "Dhanyakuria",
          state_id: "41",
        },
        {
          id: "5452",
          name: "Dharmapur",
          state_id: "41",
        },
        {
          id: "5453",
          name: "Dhatri Gram",
          state_id: "41",
        },
        {
          id: "5454",
          name: "Dhuilya",
          state_id: "41",
        },
        {
          id: "5455",
          name: "Dhulagari",
          state_id: "41",
        },
        {
          id: "5456",
          name: "Dhulian",
          state_id: "41",
        },
        {
          id: "5457",
          name: "Dhupgari",
          state_id: "41",
        },
        {
          id: "5458",
          name: "Dhusaripara",
          state_id: "41",
        },
        {
          id: "5459",
          name: "Diamond Harbour",
          state_id: "41",
        },
        {
          id: "5460",
          name: "Digha",
          state_id: "41",
        },
        {
          id: "5461",
          name: "Dignala",
          state_id: "41",
        },
        {
          id: "5462",
          name: "Dinhata",
          state_id: "41",
        },
        {
          id: "5463",
          name: "Dubrajpur",
          state_id: "41",
        },
        {
          id: "5464",
          name: "Dumjor",
          state_id: "41",
        },
        {
          id: "5465",
          name: "Durgapur",
          state_id: "41",
        },
        {
          id: "5466",
          name: "Durllabhganj",
          state_id: "41",
        },
        {
          id: "5467",
          name: "Egra",
          state_id: "41",
        },
        {
          id: "5468",
          name: "Eksara",
          state_id: "41",
        },
        {
          id: "5469",
          name: "Falakata",
          state_id: "41",
        },
        {
          id: "5470",
          name: "Farakka",
          state_id: "41",
        },
        {
          id: "5471",
          name: "Fatellapur",
          state_id: "41",
        },
        {
          id: "5472",
          name: "Fort Gloster",
          state_id: "41",
        },
        {
          id: "5473",
          name: "Gabberia",
          state_id: "41",
        },
        {
          id: "5474",
          name: "Gadigachha",
          state_id: "41",
        },
        {
          id: "5475",
          name: "Gairkata",
          state_id: "41",
        },
        {
          id: "5476",
          name: "Gangarampur",
          state_id: "41",
        },
        {
          id: "5477",
          name: "Garalgachha",
          state_id: "41",
        },
        {
          id: "5478",
          name: "Garbeta Amlagora",
          state_id: "41",
        },
        {
          id: "5479",
          name: "Garhbeta",
          state_id: "41",
        },
        {
          id: "5480",
          name: "Garshyamnagar",
          state_id: "41",
        },
        {
          id: "5481",
          name: "Garui",
          state_id: "41",
        },
        {
          id: "5482",
          name: "Garulia",
          state_id: "41",
        },
        {
          id: "5483",
          name: "Gayespur",
          state_id: "41",
        },
        {
          id: "5484",
          name: "Ghatal",
          state_id: "41",
        },
        {
          id: "5485",
          name: "Ghorsala",
          state_id: "41",
        },
        {
          id: "5486",
          name: "Goaljan",
          state_id: "41",
        },
        {
          id: "5487",
          name: "Goasafat",
          state_id: "41",
        },
        {
          id: "5488",
          name: "Gobardanga",
          state_id: "41",
        },
        {
          id: "5489",
          name: "Gobindapur",
          state_id: "41",
        },
        {
          id: "5490",
          name: "Gopalpur",
          state_id: "41",
        },
        {
          id: "5491",
          name: "Gopinathpur",
          state_id: "41",
        },
        {
          id: "5492",
          name: "Gora Bazar",
          state_id: "41",
        },
        {
          id: "5493",
          name: "Guma",
          state_id: "41",
        },
        {
          id: "5494",
          name: "Gurdaha",
          state_id: "41",
        },
        {
          id: "5495",
          name: "Guriahati",
          state_id: "41",
        },
        {
          id: "5496",
          name: "Guskhara",
          state_id: "41",
        },
        {
          id: "5497",
          name: "Habra",
          state_id: "41",
        },
        {
          id: "5498",
          name: "Haldia",
          state_id: "41",
        },
        {
          id: "5499",
          name: "Haldibari",
          state_id: "41",
        },
        {
          id: "5500",
          name: "Halisahar",
          state_id: "41",
        },
        {
          id: "5501",
          name: "Haora",
          state_id: "41",
        },
        {
          id: "5502",
          name: "Harharia Chak",
          state_id: "41",
        },
        {
          id: "5503",
          name: "Harindanga",
          state_id: "41",
        },
        {
          id: "5504",
          name: "Haringhata",
          state_id: "41",
        },
        {
          id: "5505",
          name: "Haripur",
          state_id: "41",
        },
        {
          id: "5506",
          name: "Harishpur",
          state_id: "41",
        },
        {
          id: "5507",
          name: "Hatgachha",
          state_id: "41",
        },
        {
          id: "5508",
          name: "Hatsimla",
          state_id: "41",
        },
        {
          id: "5509",
          name: "Hijuli",
          state_id: "41",
        },
        {
          id: "5510",
          name: "Hindustan Cables Town",
          state_id: "41",
        },
        {
          id: "5511",
          name: "Hooghly",
          state_id: "41",
        },
        {
          id: "5512",
          name: "Howrah",
          state_id: "41",
        },
        {
          id: "5513",
          name: "Hugli-Chunchura",
          state_id: "41",
        },
        {
          id: "5514",
          name: "Humaipur",
          state_id: "41",
        },
        {
          id: "5515",
          name: "Ichha Pur Defence Estate",
          state_id: "41",
        },
        {
          id: "5516",
          name: "Ingraj Bazar",
          state_id: "41",
        },
        {
          id: "5517",
          name: "Islampur",
          state_id: "41",
        },
        {
          id: "5518",
          name: "Jafarpur",
          state_id: "41",
        },
        {
          id: "5519",
          name: "Jagadanandapur",
          state_id: "41",
        },
        {
          id: "5520",
          name: "Jagdishpur",
          state_id: "41",
        },
        {
          id: "5521",
          name: "Jagtaj",
          state_id: "41",
        },
        {
          id: "5522",
          name: "Jala Kendua",
          state_id: "41",
        },
        {
          id: "5523",
          name: "Jaldhaka",
          state_id: "41",
        },
        {
          id: "5524",
          name: "Jalkhura",
          state_id: "41",
        },
        {
          id: "5525",
          name: "Jalpaiguri",
          state_id: "41",
        },
        {
          id: "5526",
          name: "Jamuria",
          state_id: "41",
        },
        {
          id: "5527",
          name: "Jangipur",
          state_id: "41",
        },
        {
          id: "5528",
          name: "Jaygaon",
          state_id: "41",
        },
        {
          id: "5529",
          name: "Jaynagar-Majilpur",
          state_id: "41",
        },
        {
          id: "5530",
          name: "Jemari",
          state_id: "41",
        },
        {
          id: "5531",
          name: "Jemari Township",
          state_id: "41",
        },
        {
          id: "5532",
          name: "Jetia",
          state_id: "41",
        },
        {
          id: "5533",
          name: "Jhalida",
          state_id: "41",
        },
        {
          id: "5534",
          name: "Jhargram",
          state_id: "41",
        },
        {
          id: "5535",
          name: "Jhorhat",
          state_id: "41",
        },
        {
          id: "5536",
          name: "Jiaganj-Azimganj",
          state_id: "41",
        },
        {
          id: "5537",
          name: "Joka",
          state_id: "41",
        },
        {
          id: "5538",
          name: "Jot Kamal",
          state_id: "41",
        },
        {
          id: "5539",
          name: "Kachu Pukur",
          state_id: "41",
        },
        {
          id: "5540",
          name: "Kajora",
          state_id: "41",
        },
        {
          id: "5541",
          name: "Kakdihi",
          state_id: "41",
        },
        {
          id: "5542",
          name: "Kakdwip",
          state_id: "41",
        },
        {
          id: "5543",
          name: "Kalaikunda",
          state_id: "41",
        },
        {
          id: "5544",
          name: "Kalara",
          state_id: "41",
        },
        {
          id: "5545",
          name: "Kalimpong",
          state_id: "41",
        },
        {
          id: "5546",
          name: "Kaliyaganj",
          state_id: "41",
        },
        {
          id: "5547",
          name: "Kalna",
          state_id: "41",
        },
        {
          id: "5548",
          name: "Kalyani",
          state_id: "41",
        },
        {
          id: "5549",
          name: "Kamarhati",
          state_id: "41",
        },
        {
          id: "5550",
          name: "Kanaipur",
          state_id: "41",
        },
        {
          id: "5551",
          name: "Kanchrapara",
          state_id: "41",
        },
        {
          id: "5552",
          name: "Kandi",
          state_id: "41",
        },
        {
          id: "5553",
          name: "Kanki",
          state_id: "41",
        },
        {
          id: "5554",
          name: "Kankuria",
          state_id: "41",
        },
        {
          id: "5555",
          name: "Kantlia",
          state_id: "41",
        },
        {
          id: "5556",
          name: "Kanyanagar",
          state_id: "41",
        },
        {
          id: "5557",
          name: "Karimpur",
          state_id: "41",
        },
        {
          id: "5558",
          name: "Karsiyang",
          state_id: "41",
        },
        {
          id: "5559",
          name: "Kasba",
          state_id: "41",
        },
        {
          id: "5560",
          name: "Kasimbazar",
          state_id: "41",
        },
        {
          id: "5561",
          name: "Katwa",
          state_id: "41",
        },
        {
          id: "5562",
          name: "Kaugachhi",
          state_id: "41",
        },
        {
          id: "5563",
          name: "Kenda",
          state_id: "41",
        },
        {
          id: "5564",
          name: "Kendra Khottamdi",
          state_id: "41",
        },
        {
          id: "5565",
          name: "Kendua",
          state_id: "41",
        },
        {
          id: "5566",
          name: "Kesabpur",
          state_id: "41",
        },
        {
          id: "5567",
          name: "Khagrabari",
          state_id: "41",
        },
        {
          id: "5568",
          name: "Khalia",
          state_id: "41",
        },
        {
          id: "5569",
          name: "Khalor",
          state_id: "41",
        },
        {
          id: "5570",
          name: "Khandra",
          state_id: "41",
        },
        {
          id: "5571",
          name: "Khantora",
          state_id: "41",
        },
        {
          id: "5572",
          name: "Kharagpur",
          state_id: "41",
        },
        {
          id: "5573",
          name: "Kharagpur Railway Settlement",
          state_id: "41",
        },
        {
          id: "5574",
          name: "Kharar",
          state_id: "41",
        },
        {
          id: "5575",
          name: "Khardaha",
          state_id: "41",
        },
        {
          id: "5576",
          name: "Khari Mala Khagrabari",
          state_id: "41",
        },
        {
          id: "5577",
          name: "Kharsarai",
          state_id: "41",
        },
        {
          id: "5578",
          name: "Khatra",
          state_id: "41",
        },
        {
          id: "5579",
          name: "Khodarampur",
          state_id: "41",
        },
        {
          id: "5580",
          name: "Kodalia",
          state_id: "41",
        },
        {
          id: "5581",
          name: "Kolaghat",
          state_id: "41",
        },
        {
          id: "5582",
          name: "Kolaghat Thermal Power Project",
          state_id: "41",
        },
        {
          id: "5583",
          name: "Kolkata",
          state_id: "41",
        },
        {
          id: "5584",
          name: "Konardihi",
          state_id: "41",
        },
        {
          id: "5585",
          name: "Konnogar",
          state_id: "41",
        },
        {
          id: "5586",
          name: "Krishnanagar",
          state_id: "41",
        },
        {
          id: "5587",
          name: "Krishnapur",
          state_id: "41",
        },
        {
          id: "5588",
          name: "Kshidirpur",
          state_id: "41",
        },
        {
          id: "5589",
          name: "Kshirpai",
          state_id: "41",
        },
        {
          id: "5590",
          name: "Kulihanda",
          state_id: "41",
        },
        {
          id: "5591",
          name: "Kulti",
          state_id: "41",
        },
        {
          id: "5592",
          name: "Kunustara",
          state_id: "41",
        },
        {
          id: "5593",
          name: "Kuperskem",
          state_id: "41",
        },
        {
          id: "5594",
          name: "Madanpur",
          state_id: "41",
        },
        {
          id: "5595",
          name: "Madhusudanpur",
          state_id: "41",
        },
        {
          id: "5596",
          name: "Madhyamgram",
          state_id: "41",
        },
        {
          id: "5597",
          name: "Maheshtala",
          state_id: "41",
        },
        {
          id: "5598",
          name: "Mahiari",
          state_id: "41",
        },
        {
          id: "5599",
          name: "Mahikpur",
          state_id: "41",
        },
        {
          id: "5600",
          name: "Mahira",
          state_id: "41",
        },
        {
          id: "5601",
          name: "Mahishadal",
          state_id: "41",
        },
        {
          id: "5602",
          name: "Mainaguri",
          state_id: "41",
        },
        {
          id: "5603",
          name: "Makardaha",
          state_id: "41",
        },
        {
          id: "5604",
          name: "Mal",
          state_id: "41",
        },
        {
          id: "5605",
          name: "Malda",
          state_id: "41",
        },
        {
          id: "5606",
          name: "Mandarbani",
          state_id: "41",
        },
        {
          id: "5607",
          name: "Mansinhapur",
          state_id: "41",
        },
        {
          id: "5608",
          name: "Masila",
          state_id: "41",
        },
        {
          id: "5609",
          name: "Maslandapur",
          state_id: "41",
        },
        {
          id: "5610",
          name: "Mathabhanga",
          state_id: "41",
        },
        {
          id: "5611",
          name: "Mekliganj",
          state_id: "41",
        },
        {
          id: "5612",
          name: "Memari",
          state_id: "41",
        },
        {
          id: "5613",
          name: "Midnapur",
          state_id: "41",
        },
        {
          id: "5614",
          name: "Mirik",
          state_id: "41",
        },
        {
          id: "5615",
          name: "Monoharpur",
          state_id: "41",
        },
        {
          id: "5616",
          name: "Mrigala",
          state_id: "41",
        },
        {
          id: "5617",
          name: "Muragachha",
          state_id: "41",
        },
        {
          id: "5618",
          name: "Murgathaul",
          state_id: "41",
        },
        {
          id: "5619",
          name: "Murshidabad",
          state_id: "41",
        },
        {
          id: "5620",
          name: "Nabadhai Dutta Pukur",
          state_id: "41",
        },
        {
          id: "5621",
          name: "Nabagram",
          state_id: "41",
        },
        {
          id: "5622",
          name: "Nabgram",
          state_id: "41",
        },
        {
          id: "5623",
          name: "Nachhratpur Katabari",
          state_id: "41",
        },
        {
          id: "5624",
          name: "Nadia",
          state_id: "41",
        },
        {
          id: "5625",
          name: "Naihati",
          state_id: "41",
        },
        {
          id: "5626",
          name: "Nalhati",
          state_id: "41",
        },
        {
          id: "5627",
          name: "Nasra",
          state_id: "41",
        },
        {
          id: "5628",
          name: "Natibpur",
          state_id: "41",
        },
        {
          id: "5629",
          name: "Naupala",
          state_id: "41",
        },
        {
          id: "5630",
          name: "Navadwip",
          state_id: "41",
        },
        {
          id: "5631",
          name: "Nebadhai Duttapukur",
          state_id: "41",
        },
        {
          id: "5632",
          name: "New Barrackpore",
          state_id: "41",
        },
        {
          id: "5633",
          name: "Ni Barakpur",
          state_id: "41",
        },
        {
          id: "5634",
          name: "Nibra",
          state_id: "41",
        },
        {
          id: "5635",
          name: "Noapara",
          state_id: "41",
        },
        {
          id: "5636",
          name: "Nokpul",
          state_id: "41",
        },
        {
          id: "5637",
          name: "North Barakpur",
          state_id: "41",
        },
        {
          id: "5638",
          name: "Odlabari",
          state_id: "41",
        },
        {
          id: "5639",
          name: "Old Maldah",
          state_id: "41",
        },
        {
          id: "5640",
          name: "Ondal",
          state_id: "41",
        },
        {
          id: "5641",
          name: "Pairagachha",
          state_id: "41",
        },
        {
          id: "5642",
          name: "Palashban",
          state_id: "41",
        },
        {
          id: "5643",
          name: "Panchla",
          state_id: "41",
        },
        {
          id: "5644",
          name: "Panchpara",
          state_id: "41",
        },
        {
          id: "5645",
          name: "Pandua",
          state_id: "41",
        },
        {
          id: "5646",
          name: "Pangachhiya",
          state_id: "41",
        },
        {
          id: "5647",
          name: "Paniara",
          state_id: "41",
        },
        {
          id: "5648",
          name: "Panihati",
          state_id: "41",
        },
        {
          id: "5649",
          name: "Panuhat",
          state_id: "41",
        },
        {
          id: "5650",
          name: "Par Beliya",
          state_id: "41",
        },
        {
          id: "5651",
          name: "Parashkol",
          state_id: "41",
        },
        {
          id: "5652",
          name: "Parasia",
          state_id: "41",
        },
        {
          id: "5653",
          name: "Parbbatipur",
          state_id: "41",
        },
        {
          id: "5654",
          name: "Parui",
          state_id: "41",
        },
        {
          id: "5655",
          name: "Paschim Jitpur",
          state_id: "41",
        },
        {
          id: "5656",
          name: "Paschim Punro Para",
          state_id: "41",
        },
        {
          id: "5657",
          name: "Patrasaer",
          state_id: "41",
        },
        {
          id: "5658",
          name: "Pattabong Tea Garden",
          state_id: "41",
        },
        {
          id: "5659",
          name: "Patuli",
          state_id: "41",
        },
        {
          id: "5660",
          name: "Patulia",
          state_id: "41",
        },
        {
          id: "5661",
          name: "Phulia",
          state_id: "41",
        },
        {
          id: "5662",
          name: "Podara",
          state_id: "41",
        },
        {
          id: "5663",
          name: "Port Blair",
          state_id: "41",
        },
        {
          id: "5664",
          name: "Prayagpur",
          state_id: "41",
        },
        {
          id: "5665",
          name: "Pujali",
          state_id: "41",
        },
        {
          id: "5666",
          name: "Purba Medinipur",
          state_id: "41",
        },
        {
          id: "5667",
          name: "Purba Tajpur",
          state_id: "41",
        },
        {
          id: "5668",
          name: "Purulia",
          state_id: "41",
        },
        {
          id: "5669",
          name: "Raghudebbati",
          state_id: "41",
        },
        {
          id: "5670",
          name: "Raghudebpur",
          state_id: "41",
        },
        {
          id: "5671",
          name: "Raghunathchak",
          state_id: "41",
        },
        {
          id: "5672",
          name: "Raghunathpur",
          state_id: "41",
        },
        {
          id: "5673",
          name: "Raghunathpur-Dankuni",
          state_id: "41",
        },
        {
          id: "5674",
          name: "Raghunathpur-Magra",
          state_id: "41",
        },
        {
          id: "5675",
          name: "Raigachhi",
          state_id: "41",
        },
        {
          id: "5676",
          name: "Raiganj",
          state_id: "41",
        },
        {
          id: "5677",
          name: "Raipur",
          state_id: "41",
        },
        {
          id: "5678",
          name: "Rajarhat Gopalpur",
          state_id: "41",
        },
        {
          id: "5679",
          name: "Rajpur",
          state_id: "41",
        },
        {
          id: "5680",
          name: "Ramchandrapur",
          state_id: "41",
        },
        {
          id: "5681",
          name: "Ramjibanpur",
          state_id: "41",
        },
        {
          id: "5682",
          name: "Ramnagar",
          state_id: "41",
        },
        {
          id: "5683",
          name: "Rampur Hat",
          state_id: "41",
        },
        {
          id: "5684",
          name: "Ranaghat",
          state_id: "41",
        },
        {
          id: "5685",
          name: "Raniganj",
          state_id: "41",
        },
        {
          id: "5686",
          name: "Ratibati",
          state_id: "41",
        },
        {
          id: "5687",
          name: "Raypur",
          state_id: "41",
        },
        {
          id: "5688",
          name: "Rishra",
          state_id: "41",
        },
        {
          id: "5689",
          name: "Rishra Cantonment",
          state_id: "41",
        },
        {
          id: "5690",
          name: "Ruiya",
          state_id: "41",
        },
        {
          id: "5691",
          name: "Sahajadpur",
          state_id: "41",
        },
        {
          id: "5692",
          name: "Sahapur",
          state_id: "41",
        },
        {
          id: "5693",
          name: "Sainthia",
          state_id: "41",
        },
        {
          id: "5694",
          name: "Salap",
          state_id: "41",
        },
        {
          id: "5695",
          name: "Sankarpur",
          state_id: "41",
        },
        {
          id: "5696",
          name: "Sankrail",
          state_id: "41",
        },
        {
          id: "5697",
          name: "Santoshpur",
          state_id: "41",
        },
        {
          id: "5698",
          name: "Saontaidih",
          state_id: "41",
        },
        {
          id: "5699",
          name: "Sarenga",
          state_id: "41",
        },
        {
          id: "5700",
          name: "Sarpi",
          state_id: "41",
        },
        {
          id: "5701",
          name: "Satigachha",
          state_id: "41",
        },
        {
          id: "5702",
          name: "Serpur",
          state_id: "41",
        },
        {
          id: "5703",
          name: "Shankhanagar",
          state_id: "41",
        },
        {
          id: "5704",
          name: "Shantipur",
          state_id: "41",
        },
        {
          id: "5705",
          name: "Shrirampur",
          state_id: "41",
        },
        {
          id: "5706",
          name: "Siduli",
          state_id: "41",
        },
        {
          id: "5707",
          name: "Siliguri",
          state_id: "41",
        },
        {
          id: "5708",
          name: "Simla",
          state_id: "41",
        },
        {
          id: "5709",
          name: "Singur",
          state_id: "41",
        },
        {
          id: "5710",
          name: "Sirsha",
          state_id: "41",
        },
        {
          id: "5711",
          name: "Siuri",
          state_id: "41",
        },
        {
          id: "5712",
          name: "Sobhaganj",
          state_id: "41",
        },
        {
          id: "5713",
          name: "Sodpur",
          state_id: "41",
        },
        {
          id: "5714",
          name: "Sonamukhi",
          state_id: "41",
        },
        {
          id: "5715",
          name: "Sonatikiri",
          state_id: "41",
        },
        {
          id: "5716",
          name: "Srikantabati",
          state_id: "41",
        },
        {
          id: "5717",
          name: "Srirampur",
          state_id: "41",
        },
        {
          id: "5718",
          name: "Sukdal",
          state_id: "41",
        },
        {
          id: "5719",
          name: "Taherpur",
          state_id: "41",
        },
        {
          id: "5720",
          name: "Taki",
          state_id: "41",
        },
        {
          id: "5721",
          name: "Talbandha",
          state_id: "41",
        },
        {
          id: "5722",
          name: "Tamluk",
          state_id: "41",
        },
        {
          id: "5723",
          name: "Tarakeswar",
          state_id: "41",
        },
        {
          id: "5724",
          name: "Tentulberia",
          state_id: "41",
        },
        {
          id: "5725",
          name: "Tentulkuli",
          state_id: "41",
        },
        {
          id: "5726",
          name: "Thermal Power Project",
          state_id: "41",
        },
        {
          id: "5727",
          name: "Tinsukia",
          state_id: "41",
        },
        {
          id: "5728",
          name: "Titagarh",
          state_id: "41",
        },
        {
          id: "5729",
          name: "Tufanganj",
          state_id: "41",
        },
        {
          id: "5730",
          name: "Ukhra",
          state_id: "41",
        },
        {
          id: "5731",
          name: "Ula",
          state_id: "41",
        },
        {
          id: "5732",
          name: "Ulubaria",
          state_id: "41",
        },
        {
          id: "5733",
          name: "Uttar Durgapur",
          state_id: "41",
        },
        {
          id: "5734",
          name: "Uttar Goara",
          state_id: "41",
        },
        {
          id: "5735",
          name: "Uttar Kalas",
          state_id: "41",
        },
        {
          id: "5736",
          name: "Uttar Kamakhyaguri",
          state_id: "41",
        },
        {
          id: "5737",
          name: "Uttar Latabari",
          state_id: "41",
        },
        {
          id: "5738",
          name: "Uttar Mahammadpur",
          state_id: "41",
        },
        {
          id: "5739",
          name: "Uttar Pirpur",
          state_id: "41",
        },
        {
          id: "5740",
          name: "Uttar Raypur",
          state_id: "41",
        },
        {
          id: "5741",
          name: "Uttarpara-Kotrung",
          state_id: "41",
        },
      ],
    },
  },
  IO: {
    name: "British Indian Ocean Territory",
    native: "British Indian Ocean Territory",
    phone: "246",
    continent: "AS",
    capital: "Diego Garcia",
    currency: "USD",
    languages: ["en"],
    emoji: "🇮🇴",
    emojiU: "U+1F1EE U+1F1F4",
    states: {
      "British Indian Ocean Territory": [],
    },
  },
  IQ: {
    name: "Iraq",
    native: "العراق",
    phone: "964",
    continent: "AS",
    capital: "Baghdad",
    currency: "IQD",
    languages: ["ar", "ku"],
    emoji: "🇮🇶",
    emojiU: "U+1F1EE U+1F1F6",
    states: {
      Babil: [
        {
          id: "21787",
          name: "Jurf-as-Sakhr",
          state_id: "1729",
        },
        {
          id: "21788",
          name: "Saddat-al-Hindiyah",
          state_id: "1729",
        },
        {
          id: "21789",
          name: "al-Hillah",
          state_id: "1729",
        },
        {
          id: "21790",
          name: "al-Madhatiyah",
          state_id: "1729",
        },
        {
          id: "21791",
          name: "al-Musayyib",
          state_id: "1729",
        },
        {
          id: "21792",
          name: "al-Qasim",
          state_id: "1729",
        },
      ],
      Baghdad: [
        {
          id: "21793",
          name: "Baghdad",
          state_id: "1730",
        },
      ],
      Dahuk: [
        {
          id: "21794",
          name: "Dahuk",
          state_id: "1731",
        },
        {
          id: "21795",
          name: "Zakhu",
          state_id: "1731",
        },
      ],
      "Dhi Qar": [],
      Diyala: [
        {
          id: "21796",
          name: "Ba''qubah",
          state_id: "1733",
        },
        {
          id: "21797",
          name: "Hanaqin",
          state_id: "1733",
        },
        {
          id: "21798",
          name: "Jalula",
          state_id: "1733",
        },
        {
          id: "21799",
          name: "Kifri",
          state_id: "1733",
        },
        {
          id: "21800",
          name: "Mandali",
          state_id: "1733",
        },
        {
          id: "21801",
          name: "al-Fuhud",
          state_id: "1733",
        },
        {
          id: "21802",
          name: "al-Khalis",
          state_id: "1733",
        },
        {
          id: "21803",
          name: "al-Miqdadiyah",
          state_id: "1733",
        },
        {
          id: "21804",
          name: "ash-Shatrah",
          state_id: "1733",
        },
      ],
      Erbil: [
        {
          id: "21805",
          name: "Ankawa",
          state_id: "1734",
        },
      ],
      Irbil: [
        {
          id: "21806",
          name: "Chaqalawa",
          state_id: "1735",
        },
        {
          id: "21807",
          name: "Irbil",
          state_id: "1735",
        },
        {
          id: "21808",
          name: "Rawanduz",
          state_id: "1735",
        },
      ],
      Karbala: [
        {
          id: "21809",
          name: "Karbala",
          state_id: "1736",
        },
        {
          id: "21810",
          name: "al-Hindiyah",
          state_id: "1736",
        },
      ],
      Kurdistan: [
        {
          id: "21811",
          name: "Erbil",
          state_id: "1737",
        },
      ],
      Maysan: [
        {
          id: "21812",
          name: "Ali al Gharbi",
          state_id: "1738",
        },
        {
          id: "21813",
          name: "al-''Amarah",
          state_id: "1738",
        },
        {
          id: "21814",
          name: "al-Majarr-al-Kabir",
          state_id: "1738",
        },
      ],
      Ninawa: [
        {
          id: "21815",
          name: "Qarah Qush",
          state_id: "1739",
        },
        {
          id: "21816",
          name: "Sinjar",
          state_id: "1739",
        },
        {
          id: "21817",
          name: "Tall ''Afar",
          state_id: "1739",
        },
        {
          id: "21818",
          name: "Tall Kayf",
          state_id: "1739",
        },
        {
          id: "21819",
          name: "al-Mawsil",
          state_id: "1739",
        },
        {
          id: "21820",
          name: "ash-Shaykhan",
          state_id: "1739",
        },
      ],
      "Salah-ad-Din": [
        {
          id: "21821",
          name: "Balad",
          state_id: "1740",
        },
        {
          id: "21822",
          name: "Bayji",
          state_id: "1740",
        },
        {
          id: "21823",
          name: "Dhalu''iyah",
          state_id: "1740",
        },
        {
          id: "21824",
          name: "Samarra",
          state_id: "1740",
        },
        {
          id: "21825",
          name: "Tikrit",
          state_id: "1740",
        },
        {
          id: "21826",
          name: "Tuz",
          state_id: "1740",
        },
        {
          id: "21827",
          name: "ad-Dujayl",
          state_id: "1740",
        },
      ],
      Wasit: [
        {
          id: "21828",
          name: "al-''Aziziyah",
          state_id: "1741",
        },
        {
          id: "21829",
          name: "al-Hayy",
          state_id: "1741",
        },
        {
          id: "21830",
          name: "al-Kut",
          state_id: "1741",
        },
        {
          id: "21831",
          name: "an-Nu''maniyah",
          state_id: "1741",
        },
        {
          id: "21832",
          name: "as-Suwayrah",
          state_id: "1741",
        },
      ],
      "al-Anbar": [
        {
          id: "21833",
          name: "Anah",
          state_id: "1742",
        },
        {
          id: "21834",
          name: "Hit",
          state_id: "1742",
        },
        {
          id: "21835",
          name: "Rawah",
          state_id: "1742",
        },
        {
          id: "21836",
          name: "al-Fallujah",
          state_id: "1742",
        },
        {
          id: "21837",
          name: "al-Habbaniyah",
          state_id: "1742",
        },
        {
          id: "21838",
          name: "al-Hadithah",
          state_id: "1742",
        },
        {
          id: "21839",
          name: "ar-Ramadi",
          state_id: "1742",
        },
        {
          id: "21840",
          name: "ar-Rutbah",
          state_id: "1742",
        },
      ],
      "al-Basrah": [
        {
          id: "21841",
          name: "Abu al-Khasib",
          state_id: "1743",
        },
        {
          id: "21842",
          name: "Harithah",
          state_id: "1743",
        },
        {
          id: "21843",
          name: "Shatt-al-''Arab",
          state_id: "1743",
        },
        {
          id: "21844",
          name: "al-Basrah",
          state_id: "1743",
        },
        {
          id: "21845",
          name: "al-Faw",
          state_id: "1743",
        },
        {
          id: "21846",
          name: "al-Qurnah",
          state_id: "1743",
        },
        {
          id: "21847",
          name: "az-Zubayr",
          state_id: "1743",
        },
      ],
      "al-Muthanna": [
        {
          id: "21848",
          name: "ar-Rumaythah",
          state_id: "1744",
        },
        {
          id: "21849",
          name: "as-Samawah",
          state_id: "1744",
        },
      ],
      "al-Qadisiyah": [
        {
          id: "21850",
          name: "Afak",
          state_id: "1745",
        },
        {
          id: "21851",
          name: "ad-Diwaniyah",
          state_id: "1745",
        },
        {
          id: "21852",
          name: "al-Ghammas",
          state_id: "1745",
        },
        {
          id: "21853",
          name: "al-Hamzah",
          state_id: "1745",
        },
        {
          id: "21854",
          name: "ash-Shamiyah",
          state_id: "1745",
        },
        {
          id: "21855",
          name: "ash-Shinafiyah",
          state_id: "1745",
        },
      ],
      "an-Najaf": [
        {
          id: "21856",
          name: "al-Kufah",
          state_id: "1746",
        },
        {
          id: "21857",
          name: "al-Mishkhab",
          state_id: "1746",
        },
        {
          id: "21858",
          name: "an-Najaf",
          state_id: "1746",
        },
      ],
      "as-Sulaymaniyah": [
        {
          id: "21859",
          name: "Chamchamal",
          state_id: "1747",
        },
        {
          id: "21860",
          name: "Halabjah",
          state_id: "1747",
        },
        {
          id: "21861",
          name: "Kusanjaq",
          state_id: "1747",
        },
        {
          id: "21862",
          name: "Panjwin",
          state_id: "1747",
        },
        {
          id: "21863",
          name: "Qal''at Dizeh",
          state_id: "1747",
        },
        {
          id: "21864",
          name: "as-Sulaymaniyah",
          state_id: "1747",
        },
      ],
      "at-Ta''mim": [
        {
          id: "21865",
          name: "Aqrah",
          state_id: "1748",
        },
        {
          id: "21866",
          name: "Kirkuk",
          state_id: "1748",
        },
      ],
    },
  },
  IR: {
    name: "Iran",
    native: "ایران",
    phone: "98",
    continent: "AS",
    capital: "Tehran",
    currency: "IRR",
    languages: ["fa"],
    emoji: "🇮🇷",
    emojiU: "U+1F1EE U+1F1F7",
    states: {
      Ardabil: [
        {
          id: "21554",
          name: "Ardabil",
          state_id: "1700",
        },
        {
          id: "21555",
          name: "Garmi",
          state_id: "1700",
        },
        {
          id: "21556",
          name: "Khalkhal",
          state_id: "1700",
        },
        {
          id: "21557",
          name: "Meshkinshahr",
          state_id: "1700",
        },
        {
          id: "21558",
          name: "Parsabad",
          state_id: "1700",
        },
      ],
      "Azarbayjan-e Bakhtari": [],
      "Azarbayjan-e Khavari": [],
      Bushehr: [
        {
          id: "21559",
          name: "Bandar-e Gonaveh",
          state_id: "1703",
        },
        {
          id: "21560",
          name: "Borazjan",
          state_id: "1703",
        },
        {
          id: "21561",
          name: "Bushehr",
          state_id: "1703",
        },
        {
          id: "21562",
          name: "Dashti",
          state_id: "1703",
        },
        {
          id: "21563",
          name: "Dir",
          state_id: "1703",
        },
        {
          id: "21564",
          name: "Khormuj",
          state_id: "1703",
        },
        {
          id: "21565",
          name: "Kongan",
          state_id: "1703",
        },
        {
          id: "21566",
          name: "Tangestan",
          state_id: "1703",
        },
      ],
      "Chahar Mahal-e Bakhtiari": [],
      Esfahan: [
        {
          id: "21567",
          name: "Ardistan",
          state_id: "1705",
        },
        {
          id: "21568",
          name: "Dorchehpiyaz",
          state_id: "1705",
        },
        {
          id: "21569",
          name: "Dowlatabad",
          state_id: "1705",
        },
        {
          id: "21570",
          name: "Esfahan",
          state_id: "1705",
        },
        {
          id: "21571",
          name: "Falavarjan",
          state_id: "1705",
        },
        {
          id: "21572",
          name: "Faridan",
          state_id: "1705",
        },
        {
          id: "21573",
          name: "Fereydunshahr",
          state_id: "1705",
        },
        {
          id: "21574",
          name: "Fuladshahr",
          state_id: "1705",
        },
        {
          id: "21575",
          name: "Golara",
          state_id: "1705",
        },
        {
          id: "21576",
          name: "Golpayegan",
          state_id: "1705",
        },
        {
          id: "21577",
          name: "Kashan",
          state_id: "1705",
        },
        {
          id: "21578",
          name: "Kelishad",
          state_id: "1705",
        },
        {
          id: "21579",
          name: "Khomeynishahr",
          state_id: "1705",
        },
        {
          id: "21580",
          name: "Khonsar",
          state_id: "1705",
        },
        {
          id: "21581",
          name: "Khuresgan",
          state_id: "1705",
        },
        {
          id: "21582",
          name: "Mobarakeh",
          state_id: "1705",
        },
        {
          id: "21583",
          name: "Na''in",
          state_id: "1705",
        },
        {
          id: "21584",
          name: "Najafabad",
          state_id: "1705",
        },
        {
          id: "21585",
          name: "Natnaz",
          state_id: "1705",
        },
        {
          id: "21586",
          name: "Qahdarijan",
          state_id: "1705",
        },
        {
          id: "21587",
          name: "Rehnan",
          state_id: "1705",
        },
        {
          id: "21588",
          name: "Semirom",
          state_id: "1705",
        },
        {
          id: "21589",
          name: "Shahinshahr",
          state_id: "1705",
        },
        {
          id: "21590",
          name: "Shahreza",
          state_id: "1705",
        },
        {
          id: "21591",
          name: "Zarinshahr",
          state_id: "1705",
        },
      ],
      Fars: [
        {
          id: "21592",
          name: "Abadeh",
          state_id: "1706",
        },
        {
          id: "21593",
          name: "Akbarabad",
          state_id: "1706",
        },
        {
          id: "21594",
          name: "Darab",
          state_id: "1706",
        },
        {
          id: "21595",
          name: "Eqlid",
          state_id: "1706",
        },
        {
          id: "21596",
          name: "Estehban",
          state_id: "1706",
        },
        {
          id: "21597",
          name: "Fasa",
          state_id: "1706",
        },
        {
          id: "21598",
          name: "Firuzabad",
          state_id: "1706",
        },
        {
          id: "21599",
          name: "Gerash",
          state_id: "1706",
        },
        {
          id: "21600",
          name: "Jahrom",
          state_id: "1706",
        },
        {
          id: "21601",
          name: "Kazerun",
          state_id: "1706",
        },
        {
          id: "21602",
          name: "Lar",
          state_id: "1706",
        },
        {
          id: "21603",
          name: "Marv Dasht",
          state_id: "1706",
        },
        {
          id: "21604",
          name: "Neyriz",
          state_id: "1706",
        },
        {
          id: "21605",
          name: "Nurabad",
          state_id: "1706",
        },
        {
          id: "21606",
          name: "Qa''emiyeh",
          state_id: "1706",
        },
        {
          id: "21607",
          name: "Sepidan",
          state_id: "1706",
        },
        {
          id: "21608",
          name: "Shiraz",
          state_id: "1706",
        },
      ],
      Gilan: [
        {
          id: "21609",
          name: "Astaneh-ye Ashrafiyeh",
          state_id: "1707",
        },
        {
          id: "21610",
          name: "Astara",
          state_id: "1707",
        },
        {
          id: "21611",
          name: "Bandar-e Anzali",
          state_id: "1707",
        },
        {
          id: "21612",
          name: "Faman",
          state_id: "1707",
        },
        {
          id: "21613",
          name: "Hashtpar",
          state_id: "1707",
        },
        {
          id: "21614",
          name: "Lahijan",
          state_id: "1707",
        },
        {
          id: "21615",
          name: "Langarud",
          state_id: "1707",
        },
        {
          id: "21616",
          name: "Rasht",
          state_id: "1707",
        },
        {
          id: "21617",
          name: "Rudbar",
          state_id: "1707",
        },
        {
          id: "21618",
          name: "Rudsar",
          state_id: "1707",
        },
        {
          id: "21619",
          name: "Sawma''eh Sara",
          state_id: "1707",
        },
      ],
      Golestan: [
        {
          id: "21620",
          name: "Aq Qal''eh",
          state_id: "1708",
        },
        {
          id: "21621",
          name: "Azad Shahr",
          state_id: "1708",
        },
        {
          id: "21622",
          name: "Bandar-e Torkaman",
          state_id: "1708",
        },
        {
          id: "21623",
          name: "Gonbad-e Qabus",
          state_id: "1708",
        },
        {
          id: "21624",
          name: "Gorgan",
          state_id: "1708",
        },
      ],
      Hamadan: [
        {
          id: "21625",
          name: "Asadabad",
          state_id: "1709",
        },
        {
          id: "21626",
          name: "Bahar",
          state_id: "1709",
        },
        {
          id: "21627",
          name: "Hamadan",
          state_id: "1709",
        },
        {
          id: "21628",
          name: "Malayer",
          state_id: "1709",
        },
        {
          id: "21629",
          name: "Nahavand",
          state_id: "1709",
        },
        {
          id: "21630",
          name: "Tuysarkan",
          state_id: "1709",
        },
      ],
      Hormozgan: [
        {
          id: "21631",
          name: "Bandar Abbas",
          state_id: "1710",
        },
        {
          id: "21632",
          name: "Bandar-e ''Abbas",
          state_id: "1710",
        },
        {
          id: "21633",
          name: "Bandar-e Lengeh",
          state_id: "1710",
        },
        {
          id: "21634",
          name: "Gheshm",
          state_id: "1710",
        },
        {
          id: "21635",
          name: "Jask",
          state_id: "1710",
        },
        {
          id: "21636",
          name: "Kish",
          state_id: "1710",
        },
        {
          id: "21637",
          name: "Kish Island",
          state_id: "1710",
        },
        {
          id: "21638",
          name: "Minab",
          state_id: "1710",
        },
      ],
      Ilam: [
        {
          id: "21639",
          name: "Abdanan",
          state_id: "1711",
        },
        {
          id: "21640",
          name: "Darrehshahr",
          state_id: "1711",
        },
        {
          id: "21641",
          name: "Dehloran",
          state_id: "1711",
        },
        {
          id: "21642",
          name: "Ilam",
          state_id: "1711",
        },
        {
          id: "21643",
          name: "Ivan",
          state_id: "1711",
        },
        {
          id: "21644",
          name: "Mehran",
          state_id: "1711",
        },
      ],
      Kerman: [
        {
          id: "21645",
          name: "Baft",
          state_id: "1712",
        },
        {
          id: "21646",
          name: "Bam",
          state_id: "1712",
        },
        {
          id: "21647",
          name: "Bardsir",
          state_id: "1712",
        },
        {
          id: "21648",
          name: "Jiroft",
          state_id: "1712",
        },
        {
          id: "21649",
          name: "Kahnuj",
          state_id: "1712",
        },
        {
          id: "21650",
          name: "Kerman",
          state_id: "1712",
        },
        {
          id: "21651",
          name: "Rafsanjan",
          state_id: "1712",
        },
        {
          id: "21652",
          name: "Ravar",
          state_id: "1712",
        },
        {
          id: "21653",
          name: "Shahr-e Babak",
          state_id: "1712",
        },
        {
          id: "21654",
          name: "Sirjan",
          state_id: "1712",
        },
        {
          id: "21655",
          name: "Zarand",
          state_id: "1712",
        },
      ],
      Kermanshah: [
        {
          id: "21656",
          name: "Eslamabad",
          state_id: "1713",
        },
        {
          id: "21657",
          name: "Gilan-e Garb",
          state_id: "1713",
        },
        {
          id: "21658",
          name: "Harsin",
          state_id: "1713",
        },
        {
          id: "21659",
          name: "Javanrud",
          state_id: "1713",
        },
        {
          id: "21660",
          name: "Kangavar",
          state_id: "1713",
        },
        {
          id: "21661",
          name: "Kermanshah",
          state_id: "1713",
        },
        {
          id: "21662",
          name: "Paveh",
          state_id: "1713",
        },
        {
          id: "21663",
          name: "Sahneh",
          state_id: "1713",
        },
        {
          id: "21664",
          name: "Sar-e-Pol-e-Zohab",
          state_id: "1713",
        },
        {
          id: "21665",
          name: "Sonqor",
          state_id: "1713",
        },
      ],
      Khorasan: [
        {
          id: "21666",
          name: "Birjand",
          state_id: "1714",
        },
        {
          id: "21667",
          name: "Bojnurd",
          state_id: "1714",
        },
        {
          id: "21668",
          name: "Chenaran",
          state_id: "1714",
        },
        {
          id: "21669",
          name: "Darreh Gaz",
          state_id: "1714",
        },
        {
          id: "21670",
          name: "Esfarayen",
          state_id: "1714",
        },
        {
          id: "21671",
          name: "Fariman",
          state_id: "1714",
        },
        {
          id: "21672",
          name: "Ferdus",
          state_id: "1714",
        },
        {
          id: "21673",
          name: "Gha''nat",
          state_id: "1714",
        },
        {
          id: "21674",
          name: "Gonabad",
          state_id: "1714",
        },
        {
          id: "21675",
          name: "Kashmar",
          state_id: "1714",
        },
        {
          id: "21676",
          name: "Mashad",
          state_id: "1714",
        },
        {
          id: "21677",
          name: "Mashhad",
          state_id: "1714",
        },
        {
          id: "21678",
          name: "Neyshabur",
          state_id: "1714",
        },
        {
          id: "21679",
          name: "Qayen",
          state_id: "1714",
        },
        {
          id: "21680",
          name: "Quchan",
          state_id: "1714",
        },
        {
          id: "21681",
          name: "Sabzevar",
          state_id: "1714",
        },
        {
          id: "21682",
          name: "Sarakhs",
          state_id: "1714",
        },
        {
          id: "21683",
          name: "Shirvan",
          state_id: "1714",
        },
        {
          id: "21684",
          name: "Tabas",
          state_id: "1714",
        },
        {
          id: "21685",
          name: "Tayyebat",
          state_id: "1714",
        },
        {
          id: "21686",
          name: "Torbat-e Heydariyeh",
          state_id: "1714",
        },
        {
          id: "21687",
          name: "Torbat-e Jam",
          state_id: "1714",
        },
      ],
      Khuzestan: [
        {
          id: "21688",
          name: "Abadan",
          state_id: "1715",
        },
        {
          id: "21689",
          name: "Agha Jari",
          state_id: "1715",
        },
        {
          id: "21690",
          name: "Ahvaz",
          state_id: "1715",
        },
        {
          id: "21691",
          name: "Ahwaz",
          state_id: "1715",
        },
        {
          id: "21692",
          name: "Andimeshk",
          state_id: "1715",
        },
        {
          id: "21693",
          name: "Bandar-e Emam Khomeyni",
          state_id: "1715",
        },
        {
          id: "21694",
          name: "Bandar-e Mahshahr",
          state_id: "1715",
        },
        {
          id: "21695",
          name: "Behbahan",
          state_id: "1715",
        },
        {
          id: "21696",
          name: "Dezful",
          state_id: "1715",
        },
        {
          id: "21697",
          name: "Ezeh",
          state_id: "1715",
        },
        {
          id: "21698",
          name: "Hendijan",
          state_id: "1715",
        },
        {
          id: "21699",
          name: "Khorramshahr",
          state_id: "1715",
        },
        {
          id: "21700",
          name: "Masjed-e Soleyman",
          state_id: "1715",
        },
        {
          id: "21701",
          name: "Omidiyeh",
          state_id: "1715",
        },
        {
          id: "21702",
          name: "Ramhormoz",
          state_id: "1715",
        },
        {
          id: "21703",
          name: "Ramshir",
          state_id: "1715",
        },
        {
          id: "21704",
          name: "Shadegan",
          state_id: "1715",
        },
        {
          id: "21705",
          name: "Shush",
          state_id: "1715",
        },
        {
          id: "21706",
          name: "Shushtar",
          state_id: "1715",
        },
        {
          id: "21707",
          name: "Susangerd",
          state_id: "1715",
        },
      ],
      "Kohgiluyeh-e Boyerahmad": [],
      Kordestan: [
        {
          id: "21708",
          name: "Baneh",
          state_id: "1717",
        },
        {
          id: "21709",
          name: "Bijar",
          state_id: "1717",
        },
        {
          id: "21710",
          name: "Kamyaran",
          state_id: "1717",
        },
        {
          id: "21711",
          name: "Marivan",
          state_id: "1717",
        },
        {
          id: "21712",
          name: "Qorveh",
          state_id: "1717",
        },
        {
          id: "21713",
          name: "Sanandaj",
          state_id: "1717",
        },
        {
          id: "21714",
          name: "Saqqez",
          state_id: "1717",
        },
      ],
      Lorestan: [
        {
          id: "21715",
          name: "Alashtar",
          state_id: "1718",
        },
        {
          id: "21716",
          name: "Aligudarz",
          state_id: "1718",
        },
        {
          id: "21717",
          name: "Azna",
          state_id: "1718",
        },
        {
          id: "21718",
          name: "Borujerd",
          state_id: "1718",
        },
        {
          id: "21719",
          name: "Do Rud",
          state_id: "1718",
        },
        {
          id: "21720",
          name: "Khorramabad",
          state_id: "1718",
        },
        {
          id: "21721",
          name: "Kuhdasht",
          state_id: "1718",
        },
        {
          id: "21722",
          name: "Nurabad",
          state_id: "1718",
        },
      ],
      Markazi: [
        {
          id: "21723",
          name: "Arak",
          state_id: "1719",
        },
        {
          id: "21724",
          name: "Ashtian",
          state_id: "1719",
        },
        {
          id: "21725",
          name: "Delijan",
          state_id: "1719",
        },
        {
          id: "21726",
          name: "Khomeyn",
          state_id: "1719",
        },
        {
          id: "21727",
          name: "Mahallat",
          state_id: "1719",
        },
        {
          id: "21728",
          name: "Sarband",
          state_id: "1719",
        },
        {
          id: "21729",
          name: "Saveh",
          state_id: "1719",
        },
        {
          id: "21730",
          name: "Tafresh",
          state_id: "1719",
        },
      ],
      Mazandaran: [
        {
          id: "21731",
          name: "Aliabad",
          state_id: "1720",
        },
        {
          id: "21732",
          name: "Amir Kala",
          state_id: "1720",
        },
        {
          id: "21733",
          name: "Amol",
          state_id: "1720",
        },
        {
          id: "21734",
          name: "Babol",
          state_id: "1720",
        },
        {
          id: "21735",
          name: "Babol Sar",
          state_id: "1720",
        },
        {
          id: "21736",
          name: "Behshahr",
          state_id: "1720",
        },
        {
          id: "21737",
          name: "Chalus",
          state_id: "1720",
        },
        {
          id: "21738",
          name: "Fereydunkenar",
          state_id: "1720",
        },
        {
          id: "21739",
          name: "Juybar",
          state_id: "1720",
        },
        {
          id: "21740",
          name: "Kalaleh",
          state_id: "1720",
        },
        {
          id: "21741",
          name: "Kordkuy",
          state_id: "1720",
        },
        {
          id: "21742",
          name: "Mahmudabad",
          state_id: "1720",
        },
        {
          id: "21743",
          name: "Minudasht",
          state_id: "1720",
        },
        {
          id: "21744",
          name: "Neka",
          state_id: "1720",
        },
        {
          id: "21745",
          name: "Nur",
          state_id: "1720",
        },
        {
          id: "21746",
          name: "Nushahr",
          state_id: "1720",
        },
        {
          id: "21747",
          name: "Qa''emshahr",
          state_id: "1720",
        },
        {
          id: "21748",
          name: "Ramsar",
          state_id: "1720",
        },
        {
          id: "21749",
          name: "Sari",
          state_id: "1720",
        },
        {
          id: "21750",
          name: "Savadkuh",
          state_id: "1720",
        },
        {
          id: "21751",
          name: "Tonekabon",
          state_id: "1720",
        },
      ],
      "Ostan-e Esfahan": [],
      Qazvin: [
        {
          id: "21752",
          name: "Abhar",
          state_id: "1722",
        },
        {
          id: "21753",
          name: "Abyek",
          state_id: "1722",
        },
        {
          id: "21754",
          name: "Qazvin",
          state_id: "1722",
        },
        {
          id: "21755",
          name: "Takestan",
          state_id: "1722",
        },
      ],
      Qom: [
        {
          id: "21756",
          name: "Qom",
          state_id: "1723",
        },
      ],
      Semnan: [
        {
          id: "21757",
          name: "Damghan",
          state_id: "1724",
        },
        {
          id: "21758",
          name: "Garmsar",
          state_id: "1724",
        },
        {
          id: "21759",
          name: "Semnan",
          state_id: "1724",
        },
        {
          id: "21760",
          name: "Shahrud",
          state_id: "1724",
        },
      ],
      "Sistan-e Baluchestan": [],
      Tehran: [
        {
          id: "21761",
          name: "Damavand",
          state_id: "1726",
        },
        {
          id: "21762",
          name: "Eqbaliyeh",
          state_id: "1726",
        },
        {
          id: "21763",
          name: "Eslamshahr",
          state_id: "1726",
        },
        {
          id: "21764",
          name: "Hashtgerd",
          state_id: "1726",
        },
        {
          id: "21765",
          name: "Karaj",
          state_id: "1726",
        },
        {
          id: "21766",
          name: "Mahdasht",
          state_id: "1726",
        },
        {
          id: "21767",
          name: "Malard",
          state_id: "1726",
        },
        {
          id: "21768",
          name: "Mohammadiyeh",
          state_id: "1726",
        },
        {
          id: "21769",
          name: "Nazarabad",
          state_id: "1726",
        },
        {
          id: "21770",
          name: "Pakdasht",
          state_id: "1726",
        },
        {
          id: "21771",
          name: "Pishva",
          state_id: "1726",
        },
        {
          id: "21772",
          name: "Qarchak",
          state_id: "1726",
        },
        {
          id: "21773",
          name: "Qods",
          state_id: "1726",
        },
        {
          id: "21774",
          name: "Robat Karim",
          state_id: "1726",
        },
        {
          id: "21775",
          name: "Shahriyar",
          state_id: "1726",
        },
        {
          id: "21776",
          name: "Tehran",
          state_id: "1726",
        },
        {
          id: "21777",
          name: "Varamin",
          state_id: "1726",
        },
      ],
      Yazd: [
        {
          id: "21778",
          name: "Ardakan",
          state_id: "1727",
        },
        {
          id: "21779",
          name: "Bafq",
          state_id: "1727",
        },
        {
          id: "21780",
          name: "Mehriz",
          state_id: "1727",
        },
        {
          id: "21781",
          name: "Meybod",
          state_id: "1727",
        },
        {
          id: "21782",
          name: "Taft",
          state_id: "1727",
        },
        {
          id: "21783",
          name: "Yazd",
          state_id: "1727",
        },
      ],
      Zanjan: [
        {
          id: "21784",
          name: "Alvand",
          state_id: "1728",
        },
        {
          id: "21785",
          name: "Khorramdarreh",
          state_id: "1728",
        },
        {
          id: "21786",
          name: "Zanjan",
          state_id: "1728",
        },
      ],
    },
  },
  IS: {
    name: "Iceland",
    native: "Ísland",
    phone: "354",
    continent: "EU",
    capital: "Reykjavik",
    currency: "ISK",
    languages: ["is"],
    emoji: "🇮🇸",
    emojiU: "U+1F1EE U+1F1F8",
    states: {
      Austurland: [
        {
          id: "21435",
          name: "Bakkafjor ur",
          state_id: "1657",
        },
        {
          id: "21436",
          name: "Borgarfjor ur",
          state_id: "1657",
        },
        {
          id: "21437",
          name: "Brei dalsvik",
          state_id: "1657",
        },
        {
          id: "21438",
          name: "Djupivogur",
          state_id: "1657",
        },
        {
          id: "21439",
          name: "Egilssta ir",
          state_id: "1657",
        },
        {
          id: "21440",
          name: "Eskifjor ur",
          state_id: "1657",
        },
        {
          id: "21441",
          name: "Faskru sfjor ur",
          state_id: "1657",
        },
        {
          id: "21442",
          name: "Fellabar",
          state_id: "1657",
        },
        {
          id: "21443",
          name: "Hallormssta ur",
          state_id: "1657",
        },
        {
          id: "21444",
          name: "Hofn",
          state_id: "1657",
        },
        {
          id: "21445",
          name: "Nesjakauptun",
          state_id: "1657",
        },
        {
          id: "21446",
          name: "Neskaupsta ur",
          state_id: "1657",
        },
        {
          id: "21447",
          name: "Rey arfjor ur",
          state_id: "1657",
        },
        {
          id: "21448",
          name: "Sey isfjor ur",
          state_id: "1657",
        },
        {
          id: "21449",
          name: "Sto varfjor ur",
          state_id: "1657",
        },
        {
          id: "21450",
          name: "Vopnafjor ur",
          state_id: "1657",
        },
      ],
      Gullbringusysla: [],
      "Hofu borgarsva i": [],
      "Nor urland eystra": [],
      "Nor urland vestra": [],
      "Su urland": [],
      "Su urnes": [],
      "Vestfir ir": [],
      Vesturland: [
        {
          id: "21451",
          name: "Akranes",
          state_id: "1665",
        },
        {
          id: "21452",
          name: "Borgarnes",
          state_id: "1665",
        },
        {
          id: "21453",
          name: "Bu ardalur",
          state_id: "1665",
        },
        {
          id: "21454",
          name: "Grundarfjor ur",
          state_id: "1665",
        },
        {
          id: "21455",
          name: "Hellissandur",
          state_id: "1665",
        },
        {
          id: "21456",
          name: "Hvanneyri",
          state_id: "1665",
        },
        {
          id: "21457",
          name: "Olafsvik",
          state_id: "1665",
        },
        {
          id: "21458",
          name: "Rif",
          state_id: "1665",
        },
        {
          id: "21459",
          name: "Stykkisholmur",
          state_id: "1665",
        },
      ],
    },
  },
  IT: {
    name: "Italy",
    native: "Italia",
    phone: "39",
    continent: "EU",
    capital: "Rome",
    currency: "EUR",
    languages: ["it"],
    emoji: "🇮🇹",
    emojiU: "U+1F1EE U+1F1F9",
    states: {
      Abruzzi: [
        {
          id: "22163",
          name: "Meta",
          state_id: "1802",
        },
        {
          id: "22164",
          name: "Miano",
          state_id: "1802",
        },
      ],
      Abruzzo: [
        {
          id: "22165",
          name: "Alba Adriatica",
          state_id: "1803",
        },
        {
          id: "22166",
          name: "Atessa",
          state_id: "1803",
        },
        {
          id: "22167",
          name: "Atri",
          state_id: "1803",
        },
        {
          id: "22168",
          name: "Avezzano",
          state_id: "1803",
        },
        {
          id: "22169",
          name: "Celano",
          state_id: "1803",
        },
        {
          id: "22170",
          name: "Cepagatti",
          state_id: "1803",
        },
        {
          id: "22171",
          name: "Chieti",
          state_id: "1803",
        },
        {
          id: "22172",
          name: "Citta Sant''Angelo",
          state_id: "1803",
        },
        {
          id: "22173",
          name: "Francavilla al Mare",
          state_id: "1803",
        },
        {
          id: "22174",
          name: "Giulianova",
          state_id: "1803",
        },
        {
          id: "22175",
          name: "Guardiagrele",
          state_id: "1803",
        },
        {
          id: "22176",
          name: "L''Aquila",
          state_id: "1803",
        },
        {
          id: "22177",
          name: "Lanciano",
          state_id: "1803",
        },
        {
          id: "22178",
          name: "Martinsicuro",
          state_id: "1803",
        },
        {
          id: "22179",
          name: "Montesilvano",
          state_id: "1803",
        },
        {
          id: "22180",
          name: "Montorio al Vomano",
          state_id: "1803",
        },
        {
          id: "22181",
          name: "Mosciano Sant''Angelo",
          state_id: "1803",
        },
        {
          id: "22182",
          name: "Ortona",
          state_id: "1803",
        },
        {
          id: "22183",
          name: "Penne",
          state_id: "1803",
        },
        {
          id: "22184",
          name: "Pescara",
          state_id: "1803",
        },
        {
          id: "22185",
          name: "Pineto",
          state_id: "1803",
        },
        {
          id: "22186",
          name: "Roseto degli Abruzzi",
          state_id: "1803",
        },
        {
          id: "22187",
          name: "San Giovanni Teatino",
          state_id: "1803",
        },
        {
          id: "22188",
          name: "San Salvo",
          state_id: "1803",
        },
        {
          id: "22189",
          name: "Sant''Egidio alla Vibrata",
          state_id: "1803",
        },
        {
          id: "22190",
          name: "Silvi",
          state_id: "1803",
        },
        {
          id: "22191",
          name: "Spoltore",
          state_id: "1803",
        },
        {
          id: "22192",
          name: "Sulmona",
          state_id: "1803",
        },
        {
          id: "22193",
          name: "Teramo",
          state_id: "1803",
        },
        {
          id: "22194",
          name: "Vasto",
          state_id: "1803",
        },
      ],
      Agrigento: [
        {
          id: "22195",
          name: "Agrigento",
          state_id: "1804",
        },
        {
          id: "22196",
          name: "Alessandria della Rocca",
          state_id: "1804",
        },
        {
          id: "22197",
          name: "Aragona",
          state_id: "1804",
        },
        {
          id: "22198",
          name: "Bivona",
          state_id: "1804",
        },
        {
          id: "22199",
          name: "Burgio",
          state_id: "1804",
        },
        {
          id: "22200",
          name: "Calamonaci",
          state_id: "1804",
        },
        {
          id: "22201",
          name: "Caltabellotta",
          state_id: "1804",
        },
        {
          id: "22202",
          name: "Camastra",
          state_id: "1804",
        },
        {
          id: "22203",
          name: "Cammarata",
          state_id: "1804",
        },
        {
          id: "22204",
          name: "Campobello di Licata",
          state_id: "1804",
        },
        {
          id: "22205",
          name: "CanicattÃƒÂ¬",
          state_id: "1804",
        },
        {
          id: "22206",
          name: "Casteltermini",
          state_id: "1804",
        },
        {
          id: "22207",
          name: "Castrofilippo",
          state_id: "1804",
        },
        {
          id: "22208",
          name: "Cattolica Eraclea",
          state_id: "1804",
        },
        {
          id: "22209",
          name: "Cianciana",
          state_id: "1804",
        },
        {
          id: "22210",
          name: "Comitini",
          state_id: "1804",
        },
        {
          id: "22211",
          name: "Favara",
          state_id: "1804",
        },
        {
          id: "22212",
          name: "Grotte",
          state_id: "1804",
        },
        {
          id: "22213",
          name: "Joppolo Giancaxio",
          state_id: "1804",
        },
        {
          id: "22214",
          name: "Lampedusa e Linosa",
          state_id: "1804",
        },
        {
          id: "22215",
          name: "Licata",
          state_id: "1804",
        },
        {
          id: "22216",
          name: "Lucca Sicula",
          state_id: "1804",
        },
        {
          id: "22217",
          name: "Menfi",
          state_id: "1804",
        },
        {
          id: "22218",
          name: "Montallegro",
          state_id: "1804",
        },
        {
          id: "22219",
          name: "Montevago",
          state_id: "1804",
        },
        {
          id: "22220",
          name: "Naro",
          state_id: "1804",
        },
        {
          id: "22221",
          name: "Palma di Montechiaro",
          state_id: "1804",
        },
        {
          id: "22222",
          name: "Porto Empedocle",
          state_id: "1804",
        },
        {
          id: "22223",
          name: "Racalmuto",
          state_id: "1804",
        },
        {
          id: "22224",
          name: "Raffadali",
          state_id: "1804",
        },
        {
          id: "22225",
          name: "Ravanusa",
          state_id: "1804",
        },
        {
          id: "22226",
          name: "Realmonte",
          state_id: "1804",
        },
        {
          id: "22227",
          name: "Ribera",
          state_id: "1804",
        },
        {
          id: "22228",
          name: "Sambuca di Sicilia",
          state_id: "1804",
        },
        {
          id: "22229",
          name: "San Biagio Platani",
          state_id: "1804",
        },
        {
          id: "22230",
          name: "San Giovanni Gemini",
          state_id: "1804",
        },
        {
          id: "22231",
          name: "Sant Angelo Muxaro",
          state_id: "1804",
        },
        {
          id: "22232",
          name: "Santa Elisabetta",
          state_id: "1804",
        },
        {
          id: "22233",
          name: "Santa Margherita di Belice",
          state_id: "1804",
        },
        {
          id: "22234",
          name: "Santo Stefano Quisquina",
          state_id: "1804",
        },
        {
          id: "22235",
          name: "Sciacca",
          state_id: "1804",
        },
        {
          id: "22236",
          name: "Siculiana",
          state_id: "1804",
        },
        {
          id: "22237",
          name: "Villafranca Sicula",
          state_id: "1804",
        },
      ],
      Alessandria: [
        {
          id: "22238",
          name: "Castellazzo Bormida",
          state_id: "1805",
        },
        {
          id: "22239",
          name: "Gavi",
          state_id: "1805",
        },
        {
          id: "22240",
          name: "Villanova Monferrato",
          state_id: "1805",
        },
      ],
      Ancona: [
        {
          id: "22241",
          name: "Camerano",
          state_id: "1806",
        },
        {
          id: "22242",
          name: "Castelplanio",
          state_id: "1806",
        },
      ],
      Arezzo: [
        {
          id: "22243",
          name: "Capolona",
          state_id: "1807",
        },
        {
          id: "22244",
          name: "Montevarchi",
          state_id: "1807",
        },
        {
          id: "22245",
          name: "Subbiano",
          state_id: "1807",
        },
      ],
      "Ascoli Piceno": [],
      Asti: [
        {
          id: "22246",
          name: "Buttigliera d''Asti",
          state_id: "1809",
        },
      ],
      Avellino: [
        {
          id: "22247",
          name: "Flumeri",
          state_id: "1810",
        },
        {
          id: "22248",
          name: "Nusco",
          state_id: "1810",
        },
        {
          id: "22249",
          name: "Prata di Principato Ultra",
          state_id: "1810",
        },
        {
          id: "22250",
          name: "Villanova del Battista",
          state_id: "1810",
        },
      ],
      Bari: [],
      Basilicata: [
        {
          id: "22251",
          name: "Avigliano",
          state_id: "1812",
        },
        {
          id: "22252",
          name: "Bernalda",
          state_id: "1812",
        },
        {
          id: "22253",
          name: "Ferrandina",
          state_id: "1812",
        },
        {
          id: "22254",
          name: "Lauria",
          state_id: "1812",
        },
        {
          id: "22255",
          name: "Lavello",
          state_id: "1812",
        },
        {
          id: "22256",
          name: "Matera",
          state_id: "1812",
        },
        {
          id: "22257",
          name: "Melfi",
          state_id: "1812",
        },
        {
          id: "22258",
          name: "Montescaglioso",
          state_id: "1812",
        },
        {
          id: "22259",
          name: "Pisticci",
          state_id: "1812",
        },
        {
          id: "22260",
          name: "Policoro",
          state_id: "1812",
        },
        {
          id: "22261",
          name: "Potenza",
          state_id: "1812",
        },
        {
          id: "22262",
          name: "Rionero in Vulture",
          state_id: "1812",
        },
        {
          id: "22263",
          name: "Venosa",
          state_id: "1812",
        },
      ],
      Belluno: [
        {
          id: "22264",
          name: "Belluno",
          state_id: "1813",
        },
        {
          id: "22265",
          name: "D''alpago",
          state_id: "1813",
        },
        {
          id: "22266",
          name: "Longarone",
          state_id: "1813",
        },
        {
          id: "22267",
          name: "Pedavena",
          state_id: "1813",
        },
      ],
      Benevento: [
        {
          id: "22268",
          name: "San Bartolomeo",
          state_id: "1814",
        },
      ],
      Bergamo: [
        {
          id: "22269",
          name: "",
          state_id: "1815",
        },
        {
          id: "22270",
          name: "Bagnatica",
          state_id: "1815",
        },
        {
          id: "22271",
          name: "Bergamo",
          state_id: "1815",
        },
        {
          id: "22272",
          name: "Bolgare",
          state_id: "1815",
        },
        {
          id: "22273",
          name: "Bottanuco",
          state_id: "1815",
        },
        {
          id: "22274",
          name: "Brignano Gera d''Adda",
          state_id: "1815",
        },
        {
          id: "22275",
          name: "Calcio",
          state_id: "1815",
        },
        {
          id: "22276",
          name: "Caravaggio",
          state_id: "1815",
        },
        {
          id: "22277",
          name: "Chiuduno",
          state_id: "1815",
        },
        {
          id: "22278",
          name: "Ciserano",
          state_id: "1815",
        },
        {
          id: "22279",
          name: "Comun Nuovo",
          state_id: "1815",
        },
        {
          id: "22280",
          name: "Costa di Mezzate",
          state_id: "1815",
        },
        {
          id: "22281",
          name: "Gandino",
          state_id: "1815",
        },
        {
          id: "22282",
          name: "Grassobbio",
          state_id: "1815",
        },
        {
          id: "22283",
          name: "Grumello Del Monte",
          state_id: "1815",
        },
        {
          id: "22284",
          name: "Grumello del Monte",
          state_id: "1815",
        },
        {
          id: "22285",
          name: "Lallio",
          state_id: "1815",
        },
        {
          id: "22286",
          name: "Levate",
          state_id: "1815",
        },
        {
          id: "22287",
          name: "Lurano",
          state_id: "1815",
        },
        {
          id: "22288",
          name: "Mapello",
          state_id: "1815",
        },
        {
          id: "22289",
          name: "Pagazzano",
          state_id: "1815",
        },
        {
          id: "22290",
          name: "Ponteranica",
          state_id: "1815",
        },
        {
          id: "22291",
          name: "Pontida",
          state_id: "1815",
        },
        {
          id: "22292",
          name: "Sant Omobono Imagna",
          state_id: "1815",
        },
        {
          id: "22293",
          name: "Torre Pallavicina",
          state_id: "1815",
        },
        {
          id: "22294",
          name: "Trescore Balneario",
          state_id: "1815",
        },
        {
          id: "22295",
          name: "Verdellino",
          state_id: "1815",
        },
        {
          id: "22296",
          name: "Zingonia",
          state_id: "1815",
        },
      ],
      Biella: [
        {
          id: "22297",
          name: "Camburzano",
          state_id: "1816",
        },
        {
          id: "22298",
          name: "Crevacuore",
          state_id: "1816",
        },
        {
          id: "22299",
          name: "Gaglianico",
          state_id: "1816",
        },
        {
          id: "22300",
          name: "Sandigliano",
          state_id: "1816",
        },
        {
          id: "22301",
          name: "Vigliano Biellese",
          state_id: "1816",
        },
      ],
      Bologna: [
        {
          id: "22302",
          name: "Anzola dell''Emilia",
          state_id: "1817",
        },
        {
          id: "22303",
          name: "Bologna",
          state_id: "1817",
        },
        {
          id: "22304",
          name: "Borgo Tossignano",
          state_id: "1817",
        },
        {
          id: "22305",
          name: "Casalfiumanese",
          state_id: "1817",
        },
        {
          id: "22306",
          name: "Castiglione Dei Pepoli",
          state_id: "1817",
        },
        {
          id: "22307",
          name: "Funo",
          state_id: "1817",
        },
        {
          id: "22308",
          name: "Loiano",
          state_id: "1817",
        },
        {
          id: "22309",
          name: "Monterenzio",
          state_id: "1817",
        },
        {
          id: "22310",
          name: "Osteria Grande",
          state_id: "1817",
        },
      ],
      Bolzano: [
        {
          id: "22311",
          name: "Frangarto",
          state_id: "1818",
        },
      ],
      Brescia: [
        {
          id: "22312",
          name: "Agnosine",
          state_id: "1819",
        },
        {
          id: "22313",
          name: "Brescia",
          state_id: "1819",
        },
        {
          id: "22314",
          name: "Capriano del Colle",
          state_id: "1819",
        },
        {
          id: "22315",
          name: "Capriolo",
          state_id: "1819",
        },
        {
          id: "22316",
          name: "Castegnato",
          state_id: "1819",
        },
        {
          id: "22317",
          name: "Castelcovati",
          state_id: "1819",
        },
        {
          id: "22318",
          name: "Cellatica",
          state_id: "1819",
        },
        {
          id: "22319",
          name: "Coccaglio",
          state_id: "1819",
        },
        {
          id: "22320",
          name: "Comezzano-Cizzago",
          state_id: "1819",
        },
        {
          id: "22321",
          name: "Erbusco",
          state_id: "1819",
        },
        {
          id: "22322",
          name: "Flero",
          state_id: "1819",
        },
        {
          id: "22323",
          name: "Lavenone",
          state_id: "1819",
        },
        {
          id: "22324",
          name: "Longhena",
          state_id: "1819",
        },
        {
          id: "22325",
          name: "Maclodio",
          state_id: "1819",
        },
        {
          id: "22326",
          name: "Muscoline",
          state_id: "1819",
        },
        {
          id: "22327",
          name: "Padenghe sul Garda",
          state_id: "1819",
        },
        {
          id: "22328",
          name: "Paderno Franciacorta",
          state_id: "1819",
        },
        {
          id: "22329",
          name: "Paratico",
          state_id: "1819",
        },
        {
          id: "22330",
          name: "Passirano",
          state_id: "1819",
        },
        {
          id: "22331",
          name: "Polaveno",
          state_id: "1819",
        },
        {
          id: "22332",
          name: "Poncarale",
          state_id: "1819",
        },
        {
          id: "22333",
          name: "Prevalle",
          state_id: "1819",
        },
        {
          id: "22334",
          name: "Provaglio dIseo",
          state_id: "1819",
        },
        {
          id: "22335",
          name: "Roncadelle",
          state_id: "1819",
        },
        {
          id: "22336",
          name: "Verolavecchia",
          state_id: "1819",
        },
        {
          id: "22337",
          name: "Visano",
          state_id: "1819",
        },
      ],
      Brindisi: [
        {
          id: "22338",
          name: "San Donaci",
          state_id: "1820",
        },
      ],
      Calabria: [
        {
          id: "22339",
          name: "Acri",
          state_id: "1821",
        },
        {
          id: "22340",
          name: "Amantea",
          state_id: "1821",
        },
        {
          id: "22341",
          name: "Bagnara Calabra",
          state_id: "1821",
        },
        {
          id: "22342",
          name: "Belvedere Marittimo",
          state_id: "1821",
        },
        {
          id: "22343",
          name: "Bisignano",
          state_id: "1821",
        },
        {
          id: "22344",
          name: "Bovalino",
          state_id: "1821",
        },
        {
          id: "22345",
          name: "Cariati",
          state_id: "1821",
        },
        {
          id: "22346",
          name: "Cassano allo Ionio",
          state_id: "1821",
        },
        {
          id: "22347",
          name: "Castrolibero",
          state_id: "1821",
        },
        {
          id: "22348",
          name: "Castrovillari",
          state_id: "1821",
        },
        {
          id: "22349",
          name: "Catanzaro",
          state_id: "1821",
        },
        {
          id: "22350",
          name: "Cetraro",
          state_id: "1821",
        },
        {
          id: "22351",
          name: "Ciro Marina",
          state_id: "1821",
        },
        {
          id: "22352",
          name: "Cittanova",
          state_id: "1821",
        },
        {
          id: "22353",
          name: "Corigliano Calabro",
          state_id: "1821",
        },
        {
          id: "22354",
          name: "Cosenza",
          state_id: "1821",
        },
        {
          id: "22355",
          name: "Crosia",
          state_id: "1821",
        },
        {
          id: "22356",
          name: "Crotone",
          state_id: "1821",
        },
        {
          id: "22357",
          name: "Cutro",
          state_id: "1821",
        },
        {
          id: "22358",
          name: "Fuscaldo",
          state_id: "1821",
        },
        {
          id: "22359",
          name: "Gioia Tauro",
          state_id: "1821",
        },
        {
          id: "22360",
          name: "Isola di Capo Rizzuto",
          state_id: "1821",
        },
        {
          id: "22361",
          name: "Lamezia Terme",
          state_id: "1821",
        },
        {
          id: "22362",
          name: "Locri",
          state_id: "1821",
        },
        {
          id: "22363",
          name: "Luzzi",
          state_id: "1821",
        },
        {
          id: "22364",
          name: "Melito di Porto Salvo",
          state_id: "1821",
        },
        {
          id: "22365",
          name: "Mendicino",
          state_id: "1821",
        },
        {
          id: "22366",
          name: "Montalto Uffugo",
          state_id: "1821",
        },
        {
          id: "22367",
          name: "Palmi",
          state_id: "1821",
        },
        {
          id: "22368",
          name: "Paola",
          state_id: "1821",
        },
        {
          id: "22369",
          name: "Petilia Policastro",
          state_id: "1821",
        },
        {
          id: "22370",
          name: "Pizzo",
          state_id: "1821",
        },
        {
          id: "22371",
          name: "Polistena",
          state_id: "1821",
        },
        {
          id: "22372",
          name: "Reggio di Calabria",
          state_id: "1821",
        },
        {
          id: "22373",
          name: "Rende",
          state_id: "1821",
        },
        {
          id: "22374",
          name: "Rosarno",
          state_id: "1821",
        },
        {
          id: "22375",
          name: "Rossano",
          state_id: "1821",
        },
        {
          id: "22376",
          name: "San Giovanni in Fiore",
          state_id: "1821",
        },
        {
          id: "22377",
          name: "Scalea",
          state_id: "1821",
        },
        {
          id: "22378",
          name: "Sellia Marina",
          state_id: "1821",
        },
        {
          id: "22379",
          name: "Siderno",
          state_id: "1821",
        },
        {
          id: "22380",
          name: "Soverato",
          state_id: "1821",
        },
        {
          id: "22381",
          name: "Taurianova",
          state_id: "1821",
        },
        {
          id: "22382",
          name: "Trebisacce",
          state_id: "1821",
        },
        {
          id: "22383",
          name: "Vibo Valentia",
          state_id: "1821",
        },
        {
          id: "22384",
          name: "Villa San Giovanni",
          state_id: "1821",
        },
      ],
      Campania: [
        {
          id: "22385",
          name: "Acerra",
          state_id: "1822",
        },
        {
          id: "22386",
          name: "Afragola",
          state_id: "1822",
        },
        {
          id: "22387",
          name: "Agropoli",
          state_id: "1822",
        },
        {
          id: "22388",
          name: "Angri",
          state_id: "1822",
        },
        {
          id: "22389",
          name: "Ariano Irpino",
          state_id: "1822",
        },
        {
          id: "22390",
          name: "Arzano",
          state_id: "1822",
        },
        {
          id: "22391",
          name: "Atripalda",
          state_id: "1822",
        },
        {
          id: "22392",
          name: "Avellino",
          state_id: "1822",
        },
        {
          id: "22393",
          name: "Aversa",
          state_id: "1822",
        },
        {
          id: "22394",
          name: "Bacoli",
          state_id: "1822",
        },
        {
          id: "22395",
          name: "Barano d''Ischia",
          state_id: "1822",
        },
        {
          id: "22396",
          name: "Baronissi",
          state_id: "1822",
        },
        {
          id: "22397",
          name: "Battipaglia",
          state_id: "1822",
        },
        {
          id: "22398",
          name: "Bellizzi",
          state_id: "1822",
        },
        {
          id: "22399",
          name: "Benevento",
          state_id: "1822",
        },
        {
          id: "22400",
          name: "Boscoreale",
          state_id: "1822",
        },
        {
          id: "22401",
          name: "Boscotrecase",
          state_id: "1822",
        },
        {
          id: "22402",
          name: "Brusciano",
          state_id: "1822",
        },
        {
          id: "22403",
          name: "Caivano",
          state_id: "1822",
        },
        {
          id: "22404",
          name: "Calvizzano",
          state_id: "1822",
        },
        {
          id: "22405",
          name: "Campagna",
          state_id: "1822",
        },
        {
          id: "22406",
          name: "Capaccio",
          state_id: "1822",
        },
        {
          id: "22407",
          name: "Capua",
          state_id: "1822",
        },
        {
          id: "22408",
          name: "Cardito",
          state_id: "1822",
        },
        {
          id: "22409",
          name: "Carinola",
          state_id: "1822",
        },
        {
          id: "22410",
          name: "Casagiove",
          state_id: "1822",
        },
        {
          id: "22411",
          name: "Casal di Principe",
          state_id: "1822",
        },
        {
          id: "22412",
          name: "Casalnuovo di Napoli",
          state_id: "1822",
        },
        {
          id: "22413",
          name: "Casaluce",
          state_id: "1822",
        },
        {
          id: "22414",
          name: "Casandrino",
          state_id: "1822",
        },
        {
          id: "22415",
          name: "Casavatore",
          state_id: "1822",
        },
        {
          id: "22416",
          name: "Caserta",
          state_id: "1822",
        },
        {
          id: "22417",
          name: "Casoria",
          state_id: "1822",
        },
        {
          id: "22418",
          name: "Castel San Giorgio",
          state_id: "1822",
        },
        {
          id: "22419",
          name: "Castel Volturno",
          state_id: "1822",
        },
        {
          id: "22420",
          name: "Castellammare di Stabia",
          state_id: "1822",
        },
        {
          id: "22421",
          name: "Cava de'' Tirreni",
          state_id: "1822",
        },
        {
          id: "22422",
          name: "Cercola",
          state_id: "1822",
        },
        {
          id: "22423",
          name: "Cervinara",
          state_id: "1822",
        },
        {
          id: "22424",
          name: "Cicciano",
          state_id: "1822",
        },
        {
          id: "22425",
          name: "Crispano",
          state_id: "1822",
        },
        {
          id: "22426",
          name: "Eboli",
          state_id: "1822",
        },
        {
          id: "22427",
          name: "Ercolano",
          state_id: "1822",
        },
        {
          id: "22428",
          name: "Fisciano",
          state_id: "1822",
        },
        {
          id: "22429",
          name: "Forio",
          state_id: "1822",
        },
        {
          id: "22430",
          name: "Frattamaggiore",
          state_id: "1822",
        },
        {
          id: "22431",
          name: "Frattaminore",
          state_id: "1822",
        },
        {
          id: "22432",
          name: "Frignano",
          state_id: "1822",
        },
        {
          id: "22433",
          name: "Giffoni Valle Piana",
          state_id: "1822",
        },
        {
          id: "22434",
          name: "Giugliano in Campania",
          state_id: "1822",
        },
        {
          id: "22435",
          name: "Gragnano",
          state_id: "1822",
        },
        {
          id: "22436",
          name: "Gricignano di Aversa",
          state_id: "1822",
        },
        {
          id: "22437",
          name: "Grottaminarda",
          state_id: "1822",
        },
        {
          id: "22438",
          name: "Grumo Nevano",
          state_id: "1822",
        },
        {
          id: "22439",
          name: "Ischia",
          state_id: "1822",
        },
        {
          id: "22440",
          name: "Lusciano",
          state_id: "1822",
        },
        {
          id: "22441",
          name: "Macerata Campania",
          state_id: "1822",
        },
        {
          id: "22442",
          name: "Maddaloni",
          state_id: "1822",
        },
        {
          id: "22443",
          name: "Marano di Napoli",
          state_id: "1822",
        },
        {
          id: "22444",
          name: "Marcianise",
          state_id: "1822",
        },
        {
          id: "22445",
          name: "Marigliano",
          state_id: "1822",
        },
        {
          id: "22446",
          name: "Massa Lubrense",
          state_id: "1822",
        },
        {
          id: "22447",
          name: "Melito di Napoli",
          state_id: "1822",
        },
        {
          id: "22448",
          name: "Mercato San Severino",
          state_id: "1822",
        },
        {
          id: "22449",
          name: "Mercogliano",
          state_id: "1822",
        },
        {
          id: "22450",
          name: "Meta",
          state_id: "1822",
        },
        {
          id: "22451",
          name: "Mirabella Eclano",
          state_id: "1822",
        },
        {
          id: "22452",
          name: "Mondragone",
          state_id: "1822",
        },
        {
          id: "22453",
          name: "Monte di Procida",
          state_id: "1822",
        },
        {
          id: "22454",
          name: "Montecorvino Rovella",
          state_id: "1822",
        },
        {
          id: "22455",
          name: "Monteforte Irpino",
          state_id: "1822",
        },
        {
          id: "22456",
          name: "Montesarchio",
          state_id: "1822",
        },
        {
          id: "22457",
          name: "Montoro Inferiore",
          state_id: "1822",
        },
        {
          id: "22458",
          name: "Mugnano di Napoli",
          state_id: "1822",
        },
        {
          id: "22459",
          name: "Naples",
          state_id: "1822",
        },
        {
          id: "22460",
          name: "Napoli",
          state_id: "1822",
        },
        {
          id: "22461",
          name: "Nocera Inferiore",
          state_id: "1822",
        },
        {
          id: "22462",
          name: "Nocera Superiore",
          state_id: "1822",
        },
        {
          id: "22463",
          name: "Nola",
          state_id: "1822",
        },
        {
          id: "22464",
          name: "Orta di Atella",
          state_id: "1822",
        },
        {
          id: "22465",
          name: "Ottaviano",
          state_id: "1822",
        },
        {
          id: "22466",
          name: "Pagani",
          state_id: "1822",
        },
        {
          id: "22467",
          name: "Palma Campania",
          state_id: "1822",
        },
        {
          id: "22468",
          name: "Parete",
          state_id: "1822",
        },
        {
          id: "22469",
          name: "Pellezzano",
          state_id: "1822",
        },
        {
          id: "22470",
          name: "Piano di Sorrento",
          state_id: "1822",
        },
        {
          id: "22471",
          name: "Piedimonte Matese",
          state_id: "1822",
        },
        {
          id: "22472",
          name: "Poggiomarino",
          state_id: "1822",
        },
        {
          id: "22473",
          name: "Pollena Trocchia",
          state_id: "1822",
        },
        {
          id: "22474",
          name: "Pomigliano d''Arco",
          state_id: "1822",
        },
        {
          id: "22475",
          name: "Pompei",
          state_id: "1822",
        },
        {
          id: "22476",
          name: "Pontecagnano",
          state_id: "1822",
        },
        {
          id: "22477",
          name: "Portici",
          state_id: "1822",
        },
        {
          id: "22478",
          name: "Positano",
          state_id: "1822",
        },
        {
          id: "22479",
          name: "Pozzuoli",
          state_id: "1822",
        },
        {
          id: "22480",
          name: "Procida",
          state_id: "1822",
        },
        {
          id: "22481",
          name: "Qualiano",
          state_id: "1822",
        },
        {
          id: "22482",
          name: "Quarto",
          state_id: "1822",
        },
        {
          id: "22483",
          name: "Roccapiemonte",
          state_id: "1822",
        },
        {
          id: "22484",
          name: "Sala Consilina",
          state_id: "1822",
        },
        {
          id: "22485",
          name: "Salerno",
          state_id: "1822",
        },
        {
          id: "22486",
          name: "San Cipriano d''Aversa",
          state_id: "1822",
        },
        {
          id: "22487",
          name: "San Felice a Cancello",
          state_id: "1822",
        },
        {
          id: "22488",
          name: "San Gennaro Vesuviano",
          state_id: "1822",
        },
        {
          id: "22489",
          name: "San Giorgio a Cremano",
          state_id: "1822",
        },
        {
          id: "22490",
          name: "San Giorgio del Sannio",
          state_id: "1822",
        },
        {
          id: "22491",
          name: "San Giuseppe Vesuviano",
          state_id: "1822",
        },
        {
          id: "22492",
          name: "San Marcellino",
          state_id: "1822",
        },
        {
          id: "22493",
          name: "San Marzano sul Sarno",
          state_id: "1822",
        },
        {
          id: "22494",
          name: "San Nicola",
          state_id: "1822",
        },
        {
          id: "22495",
          name: "San Prisco",
          state_id: "1822",
        },
        {
          id: "22496",
          name: "San Sebastiano al Vesuvio",
          state_id: "1822",
        },
        {
          id: "22497",
          name: "San Valentino Torio",
          state_id: "1822",
        },
        {
          id: "22498",
          name: "Sant Antimo",
          state_id: "1822",
        },
        {
          id: "22499",
          name: "Sant''Agata de'' Goti",
          state_id: "1822",
        },
        {
          id: "22500",
          name: "Sant''Agnello",
          state_id: "1822",
        },
        {
          id: "22501",
          name: "Sant''Anastasia",
          state_id: "1822",
        },
        {
          id: "22502",
          name: "Sant''Antonio Abate",
          state_id: "1822",
        },
        {
          id: "22503",
          name: "Sant''Arpino",
          state_id: "1822",
        },
        {
          id: "22504",
          name: "Sant''Egidio del Monte Albino",
          state_id: "1822",
        },
        {
          id: "22505",
          name: "Santa Maria Capua Vetere",
          state_id: "1822",
        },
        {
          id: "22506",
          name: "Santa Maria a Vico",
          state_id: "1822",
        },
        {
          id: "22507",
          name: "Santa Maria la Carita",
          state_id: "1822",
        },
        {
          id: "22508",
          name: "Sarno",
          state_id: "1822",
        },
        {
          id: "22509",
          name: "Saviano",
          state_id: "1822",
        },
        {
          id: "22510",
          name: "Scafati",
          state_id: "1822",
        },
        {
          id: "22511",
          name: "Sessa Aurunca",
          state_id: "1822",
        },
        {
          id: "22512",
          name: "Siano",
          state_id: "1822",
        },
        {
          id: "22513",
          name: "Solofra",
          state_id: "1822",
        },
        {
          id: "22514",
          name: "Somma Vesuviana",
          state_id: "1822",
        },
        {
          id: "22515",
          name: "Sorrento",
          state_id: "1822",
        },
        {
          id: "22516",
          name: "Teano",
          state_id: "1822",
        },
        {
          id: "22517",
          name: "Teggiano",
          state_id: "1822",
        },
        {
          id: "22518",
          name: "Terzigno",
          state_id: "1822",
        },
        {
          id: "22519",
          name: "Teverola",
          state_id: "1822",
        },
        {
          id: "22520",
          name: "Torre Annunziata",
          state_id: "1822",
        },
        {
          id: "22521",
          name: "Torre del Greco",
          state_id: "1822",
        },
        {
          id: "22522",
          name: "Trecase",
          state_id: "1822",
        },
        {
          id: "22523",
          name: "Trentola-Ducenta",
          state_id: "1822",
        },
        {
          id: "22524",
          name: "Vallo della Lucania",
          state_id: "1822",
        },
        {
          id: "22525",
          name: "Vico Equense",
          state_id: "1822",
        },
        {
          id: "22526",
          name: "Vietri sul Mare",
          state_id: "1822",
        },
        {
          id: "22527",
          name: "Villa Literno",
          state_id: "1822",
        },
        {
          id: "22528",
          name: "Villaricca",
          state_id: "1822",
        },
        {
          id: "22529",
          name: "Volla",
          state_id: "1822",
        },
      ],
      Cartoceto: [
        {
          id: "22530",
          name: "Cartoceto",
          state_id: "1823",
        },
      ],
      Caserta: [
        {
          id: "22531",
          name: "Carinaro",
          state_id: "1824",
        },
        {
          id: "22532",
          name: "San Marco Evangelista",
          state_id: "1824",
        },
      ],
      Catania: [
        {
          id: "22533",
          name: "Fiandaca Di Acireale",
          state_id: "1825",
        },
        {
          id: "22534",
          name: "San Cono",
          state_id: "1825",
        },
      ],
      Chieti: [
        {
          id: "22535",
          name: "Altino",
          state_id: "1826",
        },
        {
          id: "22536",
          name: "Archi",
          state_id: "1826",
        },
        {
          id: "22537",
          name: "Ari",
          state_id: "1826",
        },
        {
          id: "22538",
          name: "Arielli",
          state_id: "1826",
        },
        {
          id: "22539",
          name: "Atessa",
          state_id: "1826",
        },
        {
          id: "22540",
          name: "Bomba",
          state_id: "1826",
        },
        {
          id: "22541",
          name: "Borrello",
          state_id: "1826",
        },
        {
          id: "22542",
          name: "Bucchianico",
          state_id: "1826",
        },
        {
          id: "22543",
          name: "Canosa Sannita",
          state_id: "1826",
        },
        {
          id: "22544",
          name: "Carpineto Sinello",
          state_id: "1826",
        },
        {
          id: "22545",
          name: "Carunchio",
          state_id: "1826",
        },
        {
          id: "22546",
          name: "Casacanditella",
          state_id: "1826",
        },
        {
          id: "22547",
          name: "Casalanguida",
          state_id: "1826",
        },
        {
          id: "22548",
          name: "Casalbordino",
          state_id: "1826",
        },
        {
          id: "22549",
          name: "Casalincontrada",
          state_id: "1826",
        },
        {
          id: "22550",
          name: "Casoli",
          state_id: "1826",
        },
        {
          id: "22551",
          name: "Castel Frentano",
          state_id: "1826",
        },
        {
          id: "22552",
          name: "Castelguidone",
          state_id: "1826",
        },
        {
          id: "22553",
          name: "Castiglione Messer Marino",
          state_id: "1826",
        },
        {
          id: "22554",
          name: "Celenza sul Trigno",
          state_id: "1826",
        },
        {
          id: "22555",
          name: "Chieti",
          state_id: "1826",
        },
        {
          id: "22556",
          name: "Civitaluparella",
          state_id: "1826",
        },
        {
          id: "22557",
          name: "Civitella Messer Raimondo",
          state_id: "1826",
        },
        {
          id: "22558",
          name: "Colledimacine",
          state_id: "1826",
        },
        {
          id: "22559",
          name: "Colledimezzo",
          state_id: "1826",
        },
        {
          id: "22560",
          name: "Crecchio",
          state_id: "1826",
        },
        {
          id: "22561",
          name: "Cupello",
          state_id: "1826",
        },
        {
          id: "22562",
          name: "Dogliola",
          state_id: "1826",
        },
        {
          id: "22563",
          name: "Fallo",
          state_id: "1826",
        },
        {
          id: "22564",
          name: "Fara Filiorum Petri",
          state_id: "1826",
        },
        {
          id: "22565",
          name: "Fara San Martino",
          state_id: "1826",
        },
        {
          id: "22566",
          name: "Filetto",
          state_id: "1826",
        },
        {
          id: "22567",
          name: "Fossacesia",
          state_id: "1826",
        },
        {
          id: "22568",
          name: "Fraine",
          state_id: "1826",
        },
        {
          id: "22569",
          name: "Francavilla al Mare",
          state_id: "1826",
        },
        {
          id: "22570",
          name: "Fresagrandinaria",
          state_id: "1826",
        },
        {
          id: "22571",
          name: "Frisa",
          state_id: "1826",
        },
        {
          id: "22572",
          name: "Furci",
          state_id: "1826",
        },
        {
          id: "22573",
          name: "Gamberale",
          state_id: "1826",
        },
        {
          id: "22574",
          name: "Gessopalena",
          state_id: "1826",
        },
        {
          id: "22575",
          name: "Gissi",
          state_id: "1826",
        },
        {
          id: "22576",
          name: "Giuliano Teatino",
          state_id: "1826",
        },
        {
          id: "22577",
          name: "Guardiagrele",
          state_id: "1826",
        },
        {
          id: "22578",
          name: "Guilmi",
          state_id: "1826",
        },
        {
          id: "22579",
          name: "Lama dei Peligni",
          state_id: "1826",
        },
        {
          id: "22580",
          name: "Lanciano",
          state_id: "1826",
        },
        {
          id: "22581",
          name: "Lentella",
          state_id: "1826",
        },
        {
          id: "22582",
          name: "Lettopalena",
          state_id: "1826",
        },
        {
          id: "22583",
          name: "Liscia",
          state_id: "1826",
        },
        {
          id: "22584",
          name: "Miglianico",
          state_id: "1826",
        },
        {
          id: "22585",
          name: "Montazzoli",
          state_id: "1826",
        },
        {
          id: "22586",
          name: "Montebello sul Sangro",
          state_id: "1826",
        },
        {
          id: "22588",
          name: "Montelapiano",
          state_id: "1826",
        },
        {
          id: "22589",
          name: "Montenerodomo",
          state_id: "1826",
        },
        {
          id: "22590",
          name: "Monteodorisio",
          state_id: "1826",
        },
        {
          id: "22591",
          name: "Mozzagrogna",
          state_id: "1826",
        },
        {
          id: "22592",
          name: "Orsogna",
          state_id: "1826",
        },
        {
          id: "22593",
          name: "Ortona",
          state_id: "1826",
        },
        {
          id: "22594",
          name: "Paglieta",
          state_id: "1826",
        },
        {
          id: "22595",
          name: "Palena",
          state_id: "1826",
        },
        {
          id: "22596",
          name: "Palmoli",
          state_id: "1826",
        },
        {
          id: "22597",
          name: "Palombaro",
          state_id: "1826",
        },
        {
          id: "22598",
          name: "Pennadomo",
          state_id: "1826",
        },
        {
          id: "22599",
          name: "Pennapiedimonte",
          state_id: "1826",
        },
        {
          id: "22600",
          name: "Perano",
          state_id: "1826",
        },
        {
          id: "22601",
          name: "Pietraferrazzana",
          state_id: "1826",
        },
        {
          id: "22602",
          name: "Pizzoferrato",
          state_id: "1826",
        },
        {
          id: "22603",
          name: "Poggiofiorito",
          state_id: "1826",
        },
        {
          id: "22604",
          name: "Pollutri",
          state_id: "1826",
        },
        {
          id: "22605",
          name: "Pretoro",
          state_id: "1826",
        },
        {
          id: "22606",
          name: "Quadri",
          state_id: "1826",
        },
        {
          id: "22607",
          name: "Rapino",
          state_id: "1826",
        },
        {
          id: "22608",
          name: "Ripa Teatina",
          state_id: "1826",
        },
        {
          id: "22609",
          name: "Rocca San Giovanni",
          state_id: "1826",
        },
        {
          id: "22610",
          name: "Roccamontepiano",
          state_id: "1826",
        },
        {
          id: "22611",
          name: "Roccascalegna",
          state_id: "1826",
        },
        {
          id: "22612",
          name: "Roccaspinalveti",
          state_id: "1826",
        },
        {
          id: "22613",
          name: "Roio del Sangro",
          state_id: "1826",
        },
        {
          id: "22614",
          name: "Rosello",
          state_id: "1826",
        },
        {
          id: "22615",
          name: "San Buono",
          state_id: "1826",
        },
        {
          id: "22616",
          name: "San Giovanni Lipioni",
          state_id: "1826",
        },
        {
          id: "22617",
          name: "San Giovanni Teatino",
          state_id: "1826",
        },
        {
          id: "22618",
          name: "San Martino sulla Marrucina",
          state_id: "1826",
        },
        {
          id: "22619",
          name: "San Salvo",
          state_id: "1826",
        },
        {
          id: "22620",
          name: "San Vito Chietino",
          state_id: "1826",
        },
        {
          id: "22621",
          name: "Sant Eusanio del Sangro",
          state_id: "1826",
        },
        {
          id: "22622",
          name: "Santa Maria Imbaro",
          state_id: "1826",
        },
        {
          id: "22623",
          name: "Scerni",
          state_id: "1826",
        },
        {
          id: "22624",
          name: "Schiavi di Abruzzo",
          state_id: "1826",
        },
        {
          id: "22625",
          name: "Taranta Peligna",
          state_id: "1826",
        },
        {
          id: "22626",
          name: "Tollo",
          state_id: "1826",
        },
        {
          id: "22627",
          name: "Torino di Sangro",
          state_id: "1826",
        },
        {
          id: "22628",
          name: "Tornareccio",
          state_id: "1826",
        },
        {
          id: "22629",
          name: "Torrebruna",
          state_id: "1826",
        },
        {
          id: "22630",
          name: "Torrevecchia Teatina",
          state_id: "1826",
        },
        {
          id: "22631",
          name: "Torricella Peligna",
          state_id: "1826",
        },
        {
          id: "22632",
          name: "Treglio",
          state_id: "1826",
        },
        {
          id: "22633",
          name: "Tufillo",
          state_id: "1826",
        },
        {
          id: "22634",
          name: "Vacri",
          state_id: "1826",
        },
        {
          id: "22635",
          name: "Vasto",
          state_id: "1826",
        },
        {
          id: "22636",
          name: "Villa Santa Maria",
          state_id: "1826",
        },
        {
          id: "22637",
          name: "Villalfonsina",
          state_id: "1826",
        },
        {
          id: "22638",
          name: "Villamagna",
          state_id: "1826",
        },
      ],
      Como: [
        {
          id: "22639",
          name: "Albavilla",
          state_id: "1827",
        },
        {
          id: "22640",
          name: "Cadorago",
          state_id: "1827",
        },
        {
          id: "22641",
          name: "Carimate",
          state_id: "1827",
        },
        {
          id: "22642",
          name: "Castelmarte",
          state_id: "1827",
        },
        {
          id: "22643",
          name: "Cavaria",
          state_id: "1827",
        },
        {
          id: "22644",
          name: "Cernobbio",
          state_id: "1827",
        },
        {
          id: "22645",
          name: "Comocrea",
          state_id: "1827",
        },
        {
          id: "22646",
          name: "Dongo",
          state_id: "1827",
        },
        {
          id: "22647",
          name: "Gironico",
          state_id: "1827",
        },
        {
          id: "22648",
          name: "Grandate",
          state_id: "1827",
        },
        {
          id: "22649",
          name: "Lurago dErba",
          state_id: "1827",
        },
        {
          id: "22650",
          name: "Mozzate",
          state_id: "1827",
        },
        {
          id: "22651",
          name: "Novedrate",
          state_id: "1827",
        },
        {
          id: "22652",
          name: "Orsenigo",
          state_id: "1827",
        },
        {
          id: "22653",
          name: "Turate",
          state_id: "1827",
        },
        {
          id: "22654",
          name: "Uggiate",
          state_id: "1827",
        },
      ],
      Cosenza: [
        {
          id: "22655",
          name: "Corso del Tirreno",
          state_id: "1828",
        },
        {
          id: "22656",
          name: "Mangone",
          state_id: "1828",
        },
      ],
      Cremona: [
        {
          id: "22657",
          name: "Casalbuttano",
          state_id: "1829",
        },
        {
          id: "22658",
          name: "Casalmaggiore",
          state_id: "1829",
        },
        {
          id: "22659",
          name: "Castelverde",
          state_id: "1829",
        },
        {
          id: "22660",
          name: "Madignano",
          state_id: "1829",
        },
        {
          id: "22661",
          name: "Pieve San Giacomo",
          state_id: "1829",
        },
      ],
      Cuneo: [
        {
          id: "22662",
          name: "Bandito",
          state_id: "1830",
        },
        {
          id: "22663",
          name: "Bra",
          state_id: "1830",
        },
        {
          id: "22664",
          name: "Casalgrasso",
          state_id: "1830",
        },
        {
          id: "22665",
          name: "Cossano Belbo",
          state_id: "1830",
        },
        {
          id: "22666",
          name: "Magliano Alpi",
          state_id: "1830",
        },
        {
          id: "22667",
          name: "Mondovi",
          state_id: "1830",
        },
        {
          id: "22668",
          name: "Roddi",
          state_id: "1830",
        },
        {
          id: "22669",
          name: "Santa Vittoria d''Alba",
          state_id: "1830",
        },
        {
          id: "22670",
          name: "Verduno",
          state_id: "1830",
        },
      ],
      "Emilia-Romagna": [
        {
          id: "22671",
          name: "Alfonsine",
          state_id: "1831",
        },
        {
          id: "22672",
          name: "Argelato",
          state_id: "1831",
        },
        {
          id: "22673",
          name: "Argenta",
          state_id: "1831",
        },
        {
          id: "22674",
          name: "Bagnacavallo",
          state_id: "1831",
        },
        {
          id: "22675",
          name: "Bagnolo in Piano",
          state_id: "1831",
        },
        {
          id: "22676",
          name: "Bellaria-Igea Marina",
          state_id: "1831",
        },
        {
          id: "22677",
          name: "Bertinoro",
          state_id: "1831",
        },
        {
          id: "22678",
          name: "Bologna",
          state_id: "1831",
        },
        {
          id: "22679",
          name: "Bondeno",
          state_id: "1831",
        },
        {
          id: "22680",
          name: "Budrio",
          state_id: "1831",
        },
        {
          id: "22681",
          name: "Calderara di Reno",
          state_id: "1831",
        },
        {
          id: "22682",
          name: "Carpi",
          state_id: "1831",
        },
        {
          id: "22683",
          name: "Casalecchio di Reno",
          state_id: "1831",
        },
        {
          id: "22684",
          name: "Casalgrande",
          state_id: "1831",
        },
        {
          id: "22685",
          name: "Castel Bolognese",
          state_id: "1831",
        },
        {
          id: "22686",
          name: "Castel Maggiore",
          state_id: "1831",
        },
        {
          id: "22687",
          name: "Castel San Giovanni",
          state_id: "1831",
        },
        {
          id: "22688",
          name: "Castel San Pietro Terme",
          state_id: "1831",
        },
        {
          id: "22689",
          name: "Castelfranco Emilia",
          state_id: "1831",
        },
        {
          id: "22690",
          name: "Castellarano",
          state_id: "1831",
        },
        {
          id: "22691",
          name: "Castelnovo ne'' Monti",
          state_id: "1831",
        },
        {
          id: "22692",
          name: "Castelnuovo Rangone",
          state_id: "1831",
        },
        {
          id: "22693",
          name: "Castelvetro di Modena",
          state_id: "1831",
        },
        {
          id: "22694",
          name: "Castenaso",
          state_id: "1831",
        },
        {
          id: "22695",
          name: "Cattolica",
          state_id: "1831",
        },
        {
          id: "22696",
          name: "Cavriago",
          state_id: "1831",
        },
        {
          id: "22697",
          name: "Cento",
          state_id: "1831",
        },
        {
          id: "22698",
          name: "Cervia",
          state_id: "1831",
        },
        {
          id: "22699",
          name: "Cesena",
          state_id: "1831",
        },
        {
          id: "22700",
          name: "Cesenatico",
          state_id: "1831",
        },
        {
          id: "22701",
          name: "Codigoro",
          state_id: "1831",
        },
        {
          id: "22702",
          name: "Collecchio",
          state_id: "1831",
        },
        {
          id: "22703",
          name: "Comacchio",
          state_id: "1831",
        },
        {
          id: "22704",
          name: "Concordia sulla Secchia",
          state_id: "1831",
        },
        {
          id: "22705",
          name: "Conselice",
          state_id: "1831",
        },
        {
          id: "22706",
          name: "Copparo",
          state_id: "1831",
        },
        {
          id: "22707",
          name: "Coriano",
          state_id: "1831",
        },
        {
          id: "22708",
          name: "Correggio",
          state_id: "1831",
        },
        {
          id: "22709",
          name: "Crespellano",
          state_id: "1831",
        },
        {
          id: "22710",
          name: "Crevalcore",
          state_id: "1831",
        },
        {
          id: "22711",
          name: "Faenza",
          state_id: "1831",
        },
        {
          id: "22712",
          name: "Ferrara",
          state_id: "1831",
        },
        {
          id: "22713",
          name: "Fidenza",
          state_id: "1831",
        },
        {
          id: "22714",
          name: "Finale Emilia",
          state_id: "1831",
        },
        {
          id: "22715",
          name: "Fiorano Modenese",
          state_id: "1831",
        },
        {
          id: "22716",
          name: "Fiorenzuola d''Arda",
          state_id: "1831",
        },
        {
          id: "22717",
          name: "Forli",
          state_id: "1831",
        },
        {
          id: "22718",
          name: "Forlimpopoli",
          state_id: "1831",
        },
        {
          id: "22719",
          name: "Formigine",
          state_id: "1831",
        },
        {
          id: "22720",
          name: "Gambettola",
          state_id: "1831",
        },
        {
          id: "22721",
          name: "Granarolo dell''Emilia",
          state_id: "1831",
        },
        {
          id: "22722",
          name: "Guastalla",
          state_id: "1831",
        },
        {
          id: "22723",
          name: "Imola",
          state_id: "1831",
        },
        {
          id: "22724",
          name: "Langhirano",
          state_id: "1831",
        },
        {
          id: "22725",
          name: "Lugo",
          state_id: "1831",
        },
        {
          id: "22726",
          name: "Luzzara",
          state_id: "1831",
        },
        {
          id: "22727",
          name: "Maranello",
          state_id: "1831",
        },
        {
          id: "22728",
          name: "Massa Lombarda",
          state_id: "1831",
        },
        {
          id: "22729",
          name: "Medesano",
          state_id: "1831",
        },
        {
          id: "22730",
          name: "Medicina",
          state_id: "1831",
        },
        {
          id: "22731",
          name: "Meldola",
          state_id: "1831",
        },
        {
          id: "22732",
          name: "Mirandola",
          state_id: "1831",
        },
        {
          id: "22733",
          name: "Misano Adriatico",
          state_id: "1831",
        },
        {
          id: "22734",
          name: "Modena",
          state_id: "1831",
        },
        {
          id: "22735",
          name: "Molinella",
          state_id: "1831",
        },
        {
          id: "22736",
          name: "Monte San Pietro",
          state_id: "1831",
        },
        {
          id: "22737",
          name: "Montecchio Emilia",
          state_id: "1831",
        },
        {
          id: "22738",
          name: "Montechiarugolo",
          state_id: "1831",
        },
        {
          id: "22739",
          name: "Noceto",
          state_id: "1831",
        },
        {
          id: "22740",
          name: "Nonantola",
          state_id: "1831",
        },
        {
          id: "22741",
          name: "Novellara",
          state_id: "1831",
        },
        {
          id: "22742",
          name: "Novi di Modena",
          state_id: "1831",
        },
        {
          id: "22743",
          name: "Ozzano dell''Emilia",
          state_id: "1831",
        },
        {
          id: "22744",
          name: "Parma",
          state_id: "1831",
        },
        {
          id: "22745",
          name: "Pavullo nel Frignano",
          state_id: "1831",
        },
        {
          id: "22746",
          name: "Piacenza",
          state_id: "1831",
        },
        {
          id: "22747",
          name: "Pianoro",
          state_id: "1831",
        },
        {
          id: "22748",
          name: "Ponticino",
          state_id: "1831",
        },
        {
          id: "22749",
          name: "Portomaggiore",
          state_id: "1831",
        },
        {
          id: "22750",
          name: "Quattro Castella",
          state_id: "1831",
        },
        {
          id: "22751",
          name: "Ravenna",
          state_id: "1831",
        },
        {
          id: "22752",
          name: "Reggio nell''Emilia",
          state_id: "1831",
        },
        {
          id: "22753",
          name: "Reggiolo",
          state_id: "1831",
        },
        {
          id: "22754",
          name: "Riccione",
          state_id: "1831",
        },
        {
          id: "22755",
          name: "Rimini",
          state_id: "1831",
        },
        {
          id: "22756",
          name: "Rottofreno",
          state_id: "1831",
        },
        {
          id: "22757",
          name: "Rubiera",
          state_id: "1831",
        },
        {
          id: "22758",
          name: "Russi",
          state_id: "1831",
        },
        {
          id: "22759",
          name: "Salsomaggiore Terme",
          state_id: "1831",
        },
        {
          id: "22760",
          name: "San Felice sul Panaro",
          state_id: "1831",
        },
        {
          id: "22761",
          name: "San Giovanni in Persiceto",
          state_id: "1831",
        },
        {
          id: "22762",
          name: "San Lazzaro di Savena",
          state_id: "1831",
        },
        {
          id: "22763",
          name: "San Mauro Pascoli",
          state_id: "1831",
        },
        {
          id: "22764",
          name: "San Pietro in Casale",
          state_id: "1831",
        },
        {
          id: "22765",
          name: "Sant''Ilario d''Enza",
          state_id: "1831",
        },
        {
          id: "22766",
          name: "Santarcangelo di Romagna",
          state_id: "1831",
        },
        {
          id: "22767",
          name: "Sasso Marconi",
          state_id: "1831",
        },
        {
          id: "22768",
          name: "Sassuolo",
          state_id: "1831",
        },
        {
          id: "22769",
          name: "Savignano sul Panaro",
          state_id: "1831",
        },
        {
          id: "22770",
          name: "Savignano sul Rubicone",
          state_id: "1831",
        },
        {
          id: "22771",
          name: "Scandiano",
          state_id: "1831",
        },
        {
          id: "22772",
          name: "Soliera",
          state_id: "1831",
        },
        {
          id: "22773",
          name: "Sorbolo",
          state_id: "1831",
        },
        {
          id: "22774",
          name: "Spilamberto",
          state_id: "1831",
        },
        {
          id: "22775",
          name: "Verucchio",
          state_id: "1831",
        },
        {
          id: "22776",
          name: "Vignola",
          state_id: "1831",
        },
        {
          id: "22777",
          name: "Zola Predosa",
          state_id: "1831",
        },
      ],
      Ferrara: [
        {
          id: "22778",
          name: "Saint Agostino",
          state_id: "1832",
        },
      ],
      Firenze: [
        {
          id: "22779",
          name: "Capalle",
          state_id: "1833",
        },
        {
          id: "22780",
          name: "Firenze",
          state_id: "1833",
        },
        {
          id: "22781",
          name: "Pelago",
          state_id: "1833",
        },
        {
          id: "22782",
          name: "San Donnino",
          state_id: "1833",
        },
        {
          id: "22783",
          name: "Scarperia",
          state_id: "1833",
        },
      ],
      Florence: [
        {
          id: "22784",
          name: "Scandicci",
          state_id: "1834",
        },
        {
          id: "22785",
          name: "Sesto Fiorentino",
          state_id: "1834",
        },
      ],
      "Forli-Cesena": [],
      "Friuli-Venezia Giulia": [],
      Frosinone: [
        {
          id: "22786",
          name: "Casalvieri",
          state_id: "1837",
        },
        {
          id: "22787",
          name: "Frosinone",
          state_id: "1837",
        },
        {
          id: "22788",
          name: "Sgurgola",
          state_id: "1837",
        },
      ],
      Genoa: [
        {
          id: "22789",
          name: "Genoa",
          state_id: "1838",
        },
        {
          id: "22790",
          name: "Moneglia",
          state_id: "1838",
        },
      ],
      Gorizia: [
        {
          id: "22791",
          name: "Romans d''Isonzo",
          state_id: "1839",
        },
        {
          id: "22792",
          name: "Savogna d''Isonzo",
          state_id: "1839",
        },
      ],
      "L''Aquila": [
        {
          id: "22793",
          name: "Magliano de Marsi",
          state_id: "1840",
        },
      ],
      Lazio: [
        {
          id: "22794",
          name: "Alatri",
          state_id: "1841",
        },
        {
          id: "22795",
          name: "Albano Laziale",
          state_id: "1841",
        },
        {
          id: "22796",
          name: "Anagni",
          state_id: "1841",
        },
        {
          id: "22797",
          name: "Anguillara Sabazia",
          state_id: "1841",
        },
        {
          id: "22798",
          name: "Anzio",
          state_id: "1841",
        },
        {
          id: "22799",
          name: "Aprilia",
          state_id: "1841",
        },
        {
          id: "22800",
          name: "Ardea",
          state_id: "1841",
        },
        {
          id: "22801",
          name: "Ariccia",
          state_id: "1841",
        },
        {
          id: "22802",
          name: "Artena",
          state_id: "1841",
        },
        {
          id: "22803",
          name: "Boville Ernica",
          state_id: "1841",
        },
        {
          id: "22804",
          name: "Bracciano",
          state_id: "1841",
        },
        {
          id: "22805",
          name: "Campagnano di Roma",
          state_id: "1841",
        },
        {
          id: "22806",
          name: "Cassino",
          state_id: "1841",
        },
        {
          id: "22807",
          name: "Cave",
          state_id: "1841",
        },
        {
          id: "22808",
          name: "Ceccano",
          state_id: "1841",
        },
        {
          id: "22809",
          name: "Ceprano",
          state_id: "1841",
        },
        {
          id: "22810",
          name: "Cerveteri",
          state_id: "1841",
        },
        {
          id: "22811",
          name: "Ciampino",
          state_id: "1841",
        },
        {
          id: "22812",
          name: "Cisterna",
          state_id: "1841",
        },
        {
          id: "22813",
          name: "Civita Castellana",
          state_id: "1841",
        },
        {
          id: "22814",
          name: "Civitavecchia",
          state_id: "1841",
        },
        {
          id: "22815",
          name: "Colleferro",
          state_id: "1841",
        },
        {
          id: "22816",
          name: "Cori",
          state_id: "1841",
        },
        {
          id: "22817",
          name: "Fara in Sabina",
          state_id: "1841",
        },
        {
          id: "22818",
          name: "Ferentino",
          state_id: "1841",
        },
        {
          id: "22819",
          name: "Fiano Romano",
          state_id: "1841",
        },
        {
          id: "22820",
          name: "Fiuggi",
          state_id: "1841",
        },
        {
          id: "22821",
          name: "Fiumicino",
          state_id: "1841",
        },
        {
          id: "22822",
          name: "Fondi",
          state_id: "1841",
        },
        {
          id: "22823",
          name: "Fonte Nuova",
          state_id: "1841",
        },
        {
          id: "22824",
          name: "Formello",
          state_id: "1841",
        },
        {
          id: "22825",
          name: "Formia",
          state_id: "1841",
        },
        {
          id: "22826",
          name: "Frascati",
          state_id: "1841",
        },
        {
          id: "22827",
          name: "Frosinone",
          state_id: "1841",
        },
        {
          id: "22828",
          name: "Gaeta",
          state_id: "1841",
        },
        {
          id: "22829",
          name: "Genzano di Roma",
          state_id: "1841",
        },
        {
          id: "22830",
          name: "Grottaferrata",
          state_id: "1841",
        },
        {
          id: "22831",
          name: "Guidonia",
          state_id: "1841",
        },
        {
          id: "22832",
          name: "Isola del Liri",
          state_id: "1841",
        },
        {
          id: "22833",
          name: "Itri",
          state_id: "1841",
        },
        {
          id: "22834",
          name: "Ladispoli",
          state_id: "1841",
        },
        {
          id: "22835",
          name: "Lanuvio",
          state_id: "1841",
        },
        {
          id: "22836",
          name: "Lariano",
          state_id: "1841",
        },
        {
          id: "22837",
          name: "Latina",
          state_id: "1841",
        },
        {
          id: "22838",
          name: "Marino",
          state_id: "1841",
        },
        {
          id: "22839",
          name: "Mentana",
          state_id: "1841",
        },
        {
          id: "22840",
          name: "Minturno",
          state_id: "1841",
        },
        {
          id: "22841",
          name: "Monte San Giovanni Campano",
          state_id: "1841",
        },
        {
          id: "22842",
          name: "Montefiascone",
          state_id: "1841",
        },
        {
          id: "22843",
          name: "Monterotondo",
          state_id: "1841",
        },
        {
          id: "22844",
          name: "Nettuno",
          state_id: "1841",
        },
        {
          id: "22845",
          name: "Palestrina",
          state_id: "1841",
        },
        {
          id: "22846",
          name: "Palombara Sabina",
          state_id: "1841",
        },
        {
          id: "22847",
          name: "Pomezia",
          state_id: "1841",
        },
        {
          id: "22848",
          name: "Pontecorvo",
          state_id: "1841",
        },
        {
          id: "22849",
          name: "Pontinia",
          state_id: "1841",
        },
        {
          id: "22850",
          name: "Priverno",
          state_id: "1841",
        },
        {
          id: "22851",
          name: "Rieti",
          state_id: "1841",
        },
        {
          id: "22852",
          name: "Rocca Priora",
          state_id: "1841",
        },
        {
          id: "22853",
          name: "Rocca di Papa",
          state_id: "1841",
        },
        {
          id: "22854",
          name: "Roma",
          state_id: "1841",
        },
        {
          id: "22855",
          name: "Rome",
          state_id: "1841",
        },
        {
          id: "22856",
          name: "Sabaudia",
          state_id: "1841",
        },
        {
          id: "22857",
          name: "San Cesareo",
          state_id: "1841",
        },
        {
          id: "22858",
          name: "Santa Marinella",
          state_id: "1841",
        },
        {
          id: "22859",
          name: "Segni",
          state_id: "1841",
        },
        {
          id: "22860",
          name: "Sezze",
          state_id: "1841",
        },
        {
          id: "22861",
          name: "Sora",
          state_id: "1841",
        },
        {
          id: "22862",
          name: "Soriano nel Cimino",
          state_id: "1841",
        },
        {
          id: "22863",
          name: "Subiaco",
          state_id: "1841",
        },
        {
          id: "22864",
          name: "Tarquinia",
          state_id: "1841",
        },
        {
          id: "22865",
          name: "Terracina",
          state_id: "1841",
        },
        {
          id: "22866",
          name: "Tivoli",
          state_id: "1841",
        },
        {
          id: "22867",
          name: "Valmontone",
          state_id: "1841",
        },
        {
          id: "22868",
          name: "Velletri",
          state_id: "1841",
        },
        {
          id: "22869",
          name: "Veroli",
          state_id: "1841",
        },
        {
          id: "22870",
          name: "Vetralla",
          state_id: "1841",
        },
        {
          id: "22871",
          name: "Viterbo",
          state_id: "1841",
        },
        {
          id: "22872",
          name: "Zagarolo",
          state_id: "1841",
        },
      ],
      Lecce: [
        {
          id: "22873",
          name: "Acquarica del Capo",
          state_id: "1842",
        },
      ],
      Lecco: [
        {
          id: "22874",
          name: "Airuno",
          state_id: "1843",
        },
        {
          id: "22875",
          name: "Bosisio Parini",
          state_id: "1843",
        },
        {
          id: "22876",
          name: "Lecco",
          state_id: "1843",
        },
        {
          id: "22877",
          name: "Margno",
          state_id: "1843",
        },
        {
          id: "22878",
          name: "Osnago",
          state_id: "1843",
        },
        {
          id: "22879",
          name: "Sirone",
          state_id: "1843",
        },
      ],
      "Lecco Province": [
        {
          id: "22880",
          name: "Airuno",
          state_id: "1844",
        },
        {
          id: "22881",
          name: "Bosisio Parini",
          state_id: "1844",
        },
        {
          id: "22882",
          name: "Lecco",
          state_id: "1844",
        },
        {
          id: "22883",
          name: "Margno",
          state_id: "1844",
        },
        {
          id: "22884",
          name: "Osnago",
          state_id: "1844",
        },
        {
          id: "22885",
          name: "Sirone",
          state_id: "1844",
        },
      ],
      Liguria: [
        {
          id: "22886",
          name: "Alassio",
          state_id: "1845",
        },
        {
          id: "22887",
          name: "Albenga",
          state_id: "1845",
        },
        {
          id: "22888",
          name: "Albisola Superiore",
          state_id: "1845",
        },
        {
          id: "22889",
          name: "Arcola",
          state_id: "1845",
        },
        {
          id: "22890",
          name: "Arenzano",
          state_id: "1845",
        },
        {
          id: "22891",
          name: "Bordighera",
          state_id: "1845",
        },
        {
          id: "22892",
          name: "Borgonuovo",
          state_id: "1845",
        },
        {
          id: "22893",
          name: "Cairo Montenotte",
          state_id: "1845",
        },
        {
          id: "22894",
          name: "Chiavari",
          state_id: "1845",
        },
        {
          id: "22895",
          name: "Cogoleto",
          state_id: "1845",
        },
        {
          id: "22896",
          name: "Finale Ligure",
          state_id: "1845",
        },
        {
          id: "22897",
          name: "Genova",
          state_id: "1845",
        },
        {
          id: "22898",
          name: "Imperia",
          state_id: "1845",
        },
        {
          id: "22899",
          name: "La Spezia",
          state_id: "1845",
        },
        {
          id: "22900",
          name: "Lavagna",
          state_id: "1845",
        },
        {
          id: "22901",
          name: "Lerici",
          state_id: "1845",
        },
        {
          id: "22902",
          name: "Loano",
          state_id: "1845",
        },
        {
          id: "22903",
          name: "Ortonovo",
          state_id: "1845",
        },
        {
          id: "22904",
          name: "Pietra Ligure",
          state_id: "1845",
        },
        {
          id: "22905",
          name: "Rapallo",
          state_id: "1845",
        },
        {
          id: "22906",
          name: "Recco",
          state_id: "1845",
        },
        {
          id: "22907",
          name: "San Remo",
          state_id: "1845",
        },
        {
          id: "22908",
          name: "Santa Margherita Ligure",
          state_id: "1845",
        },
        {
          id: "22909",
          name: "Santo Stefano di Magra",
          state_id: "1845",
        },
        {
          id: "22910",
          name: "Sarzana",
          state_id: "1845",
        },
        {
          id: "22911",
          name: "Savona",
          state_id: "1845",
        },
        {
          id: "22912",
          name: "Sestri Levante",
          state_id: "1845",
        },
        {
          id: "22913",
          name: "Taggia",
          state_id: "1845",
        },
        {
          id: "22914",
          name: "Varazze",
          state_id: "1845",
        },
        {
          id: "22915",
          name: "Ventimiglia",
          state_id: "1845",
        },
      ],
      Lodi: [
        {
          id: "22916",
          name: "Somaglia",
          state_id: "1846",
        },
      ],
      Lombardia: [
        {
          id: "22917",
          name: "Abbiategrasso",
          state_id: "1847",
        },
        {
          id: "22918",
          name: "Agrate Brianza",
          state_id: "1847",
        },
        {
          id: "22919",
          name: "Albiate",
          state_id: "1847",
        },
        {
          id: "22920",
          name: "Albino",
          state_id: "1847",
        },
        {
          id: "22921",
          name: "Albizzate",
          state_id: "1847",
        },
        {
          id: "22922",
          name: "Alzano Lombardo",
          state_id: "1847",
        },
        {
          id: "22923",
          name: "Arcisate",
          state_id: "1847",
        },
        {
          id: "22924",
          name: "Arconate",
          state_id: "1847",
        },
        {
          id: "22925",
          name: "Arcore",
          state_id: "1847",
        },
        {
          id: "22926",
          name: "Arese",
          state_id: "1847",
        },
        {
          id: "22927",
          name: "Arluno",
          state_id: "1847",
        },
        {
          id: "22928",
          name: "Asola",
          state_id: "1847",
        },
        {
          id: "22929",
          name: "Bagnolo Mella",
          state_id: "1847",
        },
        {
          id: "22930",
          name: "Ballabio",
          state_id: "1847",
        },
        {
          id: "22931",
          name: "Bareggio",
          state_id: "1847",
        },
        {
          id: "22932",
          name: "Basiglio",
          state_id: "1847",
        },
        {
          id: "22933",
          name: "Bedizzole",
          state_id: "1847",
        },
        {
          id: "22934",
          name: "Bergamo",
          state_id: "1847",
        },
        {
          id: "22935",
          name: "Bernareggio",
          state_id: "1847",
        },
        {
          id: "22936",
          name: "Besana in Brianza",
          state_id: "1847",
        },
        {
          id: "22937",
          name: "Besozzo",
          state_id: "1847",
        },
        {
          id: "22938",
          name: "Biassono",
          state_id: "1847",
        },
        {
          id: "22939",
          name: "Bienate",
          state_id: "1847",
        },
        {
          id: "22940",
          name: "Bollate",
          state_id: "1847",
        },
        {
          id: "22941",
          name: "Botticino",
          state_id: "1847",
        },
        {
          id: "22942",
          name: "Bovisio-Masciago",
          state_id: "1847",
        },
        {
          id: "22943",
          name: "Brembilla",
          state_id: "1847",
        },
        {
          id: "22944",
          name: "Brescia",
          state_id: "1847",
        },
        {
          id: "22945",
          name: "Bresso",
          state_id: "1847",
        },
        {
          id: "22946",
          name: "Broni",
          state_id: "1847",
        },
        {
          id: "22947",
          name: "Brugherio",
          state_id: "1847",
        },
        {
          id: "22948",
          name: "Buccinasco",
          state_id: "1847",
        },
        {
          id: "22949",
          name: "Bussero",
          state_id: "1847",
        },
        {
          id: "22950",
          name: "Busto Arsizio",
          state_id: "1847",
        },
        {
          id: "22951",
          name: "Busto Garolfo",
          state_id: "1847",
        },
        {
          id: "22952",
          name: "Cairate",
          state_id: "1847",
        },
        {
          id: "22953",
          name: "Calcinato",
          state_id: "1847",
        },
        {
          id: "22954",
          name: "Calolziocorte",
          state_id: "1847",
        },
        {
          id: "22955",
          name: "Calusco d''Adda",
          state_id: "1847",
        },
        {
          id: "22956",
          name: "Canegrate",
          state_id: "1847",
        },
        {
          id: "22957",
          name: "Cantu",
          state_id: "1847",
        },
        {
          id: "22958",
          name: "Capriolo",
          state_id: "1847",
        },
        {
          id: "22959",
          name: "Carate Brianza",
          state_id: "1847",
        },
        {
          id: "22960",
          name: "Caravaggio",
          state_id: "1847",
        },
        {
          id: "22961",
          name: "Cardano al Campo",
          state_id: "1847",
        },
        {
          id: "22962",
          name: "Caronno Pertusella",
          state_id: "1847",
        },
        {
          id: "22963",
          name: "Carpenedolo",
          state_id: "1847",
        },
        {
          id: "22964",
          name: "Carugate",
          state_id: "1847",
        },
        {
          id: "22965",
          name: "Carvico",
          state_id: "1847",
        },
        {
          id: "22966",
          name: "Casalmaggiore",
          state_id: "1847",
        },
        {
          id: "22967",
          name: "Casalpusterlengo",
          state_id: "1847",
        },
        {
          id: "22968",
          name: "Casatenovo",
          state_id: "1847",
        },
        {
          id: "22969",
          name: "Casazza",
          state_id: "1847",
        },
        {
          id: "22970",
          name: "Casnigo",
          state_id: "1847",
        },
        {
          id: "22971",
          name: "Cassano Magnago",
          state_id: "1847",
        },
        {
          id: "22972",
          name: "Cassano d''Adda",
          state_id: "1847",
        },
        {
          id: "22973",
          name: "Cassina de'' Pecchi",
          state_id: "1847",
        },
        {
          id: "22974",
          name: "Castano Primo",
          state_id: "1847",
        },
        {
          id: "22975",
          name: "Castel Goffredo",
          state_id: "1847",
        },
        {
          id: "22976",
          name: "Castel Mella",
          state_id: "1847",
        },
        {
          id: "22977",
          name: "Castellanza",
          state_id: "1847",
        },
        {
          id: "22978",
          name: "Castelleone",
          state_id: "1847",
        },
        {
          id: "22979",
          name: "Castelli Calepio",
          state_id: "1847",
        },
        {
          id: "22980",
          name: "Castenedolo",
          state_id: "1847",
        },
        {
          id: "22981",
          name: "Castiglione delle Stiviere",
          state_id: "1847",
        },
        {
          id: "22982",
          name: "Cazzago San Martino",
          state_id: "1847",
        },
        {
          id: "22983",
          name: "Cene",
          state_id: "1847",
        },
        {
          id: "22984",
          name: "Cermenate",
          state_id: "1847",
        },
        {
          id: "22985",
          name: "Cernusco sul Naviglio",
          state_id: "1847",
        },
        {
          id: "22986",
          name: "Cerro Maggiore",
          state_id: "1847",
        },
        {
          id: "22987",
          name: "Cesano Boscone",
          state_id: "1847",
        },
        {
          id: "22988",
          name: "Cesano Maderno",
          state_id: "1847",
        },
        {
          id: "22989",
          name: "Cesate",
          state_id: "1847",
        },
        {
          id: "22990",
          name: "Chiari",
          state_id: "1847",
        },
        {
          id: "22991",
          name: "Cilavegna",
          state_id: "1847",
        },
        {
          id: "22992",
          name: "Cinisello Balsamo",
          state_id: "1847",
        },
        {
          id: "22993",
          name: "Cislago",
          state_id: "1847",
        },
        {
          id: "22994",
          name: "Clusone",
          state_id: "1847",
        },
        {
          id: "22995",
          name: "Codogno",
          state_id: "1847",
        },
        {
          id: "22996",
          name: "Cologno Monzese",
          state_id: "1847",
        },
        {
          id: "22997",
          name: "Cologno al Serio",
          state_id: "1847",
        },
        {
          id: "22998",
          name: "Como",
          state_id: "1847",
        },
        {
          id: "22999",
          name: "Concesio",
          state_id: "1847",
        },
        {
          id: "23000",
          name: "Concorezzo",
          state_id: "1847",
        },
        {
          id: "23001",
          name: "Corbetta",
          state_id: "1847",
        },
        {
          id: "23002",
          name: "Cormano",
          state_id: "1847",
        },
        {
          id: "23003",
          name: "Cornaredo",
          state_id: "1847",
        },
        {
          id: "23004",
          name: "Cornate d''Adda",
          state_id: "1847",
        },
        {
          id: "23005",
          name: "Corsico",
          state_id: "1847",
        },
        {
          id: "23006",
          name: "Corte dei Cortesi",
          state_id: "1847",
        },
        {
          id: "23007",
          name: "Costa Volpino",
          state_id: "1847",
        },
        {
          id: "23008",
          name: "Crema",
          state_id: "1847",
        },
        {
          id: "23009",
          name: "Cremona",
          state_id: "1847",
        },
        {
          id: "23010",
          name: "Crocetta",
          state_id: "1847",
        },
        {
          id: "23011",
          name: "Curtatone",
          state_id: "1847",
        },
        {
          id: "23012",
          name: "Cusano Milanino",
          state_id: "1847",
        },
        {
          id: "23013",
          name: "Dalmine",
          state_id: "1847",
        },
        {
          id: "23014",
          name: "Darfo",
          state_id: "1847",
        },
        {
          id: "23015",
          name: "Desenzano del Garda",
          state_id: "1847",
        },
        {
          id: "23016",
          name: "Desio",
          state_id: "1847",
        },
        {
          id: "23017",
          name: "Erba",
          state_id: "1847",
        },
        {
          id: "23018",
          name: "Fagnano Olona",
          state_id: "1847",
        },
        {
          id: "23019",
          name: "Fino Mornasco",
          state_id: "1847",
        },
        {
          id: "23020",
          name: "Gaggiano",
          state_id: "1847",
        },
        {
          id: "23021",
          name: "Galbiate",
          state_id: "1847",
        },
        {
          id: "23022",
          name: "Gallarate",
          state_id: "1847",
        },
        {
          id: "23023",
          name: "Gambolo",
          state_id: "1847",
        },
        {
          id: "23024",
          name: "Garbagnate Milanese",
          state_id: "1847",
        },
        {
          id: "23025",
          name: "Gardone Val Trompia",
          state_id: "1847",
        },
        {
          id: "23026",
          name: "Garlasco",
          state_id: "1847",
        },
        {
          id: "23027",
          name: "Gavardo",
          state_id: "1847",
        },
        {
          id: "23028",
          name: "Gavirate",
          state_id: "1847",
        },
        {
          id: "23029",
          name: "Gerenzano",
          state_id: "1847",
        },
        {
          id: "23030",
          name: "Ghedi",
          state_id: "1847",
        },
        {
          id: "23031",
          name: "Giussano",
          state_id: "1847",
        },
        {
          id: "23032",
          name: "Goito",
          state_id: "1847",
        },
        {
          id: "23033",
          name: "Gonzaga",
          state_id: "1847",
        },
        {
          id: "23034",
          name: "Gorgonzola",
          state_id: "1847",
        },
        {
          id: "23035",
          name: "Gussago",
          state_id: "1847",
        },
        {
          id: "23036",
          name: "Gussola",
          state_id: "1847",
        },
        {
          id: "23037",
          name: "Induno Olona",
          state_id: "1847",
        },
        {
          id: "23038",
          name: "Inveruno",
          state_id: "1847",
        },
        {
          id: "23039",
          name: "Inzago",
          state_id: "1847",
        },
        {
          id: "23040",
          name: "Iseo",
          state_id: "1847",
        },
        {
          id: "23041",
          name: "Isola Dovarese",
          state_id: "1847",
        },
        {
          id: "23042",
          name: "Lacchiarella",
          state_id: "1847",
        },
        {
          id: "23043",
          name: "Lainate",
          state_id: "1847",
        },
        {
          id: "23044",
          name: "Laveno-Mombello",
          state_id: "1847",
        },
        {
          id: "23045",
          name: "Lecco",
          state_id: "1847",
        },
        {
          id: "23046",
          name: "Leffe",
          state_id: "1847",
        },
        {
          id: "23047",
          name: "Legnano",
          state_id: "1847",
        },
        {
          id: "23048",
          name: "Leno",
          state_id: "1847",
        },
        {
          id: "23049",
          name: "Lentate sul Seveso",
          state_id: "1847",
        },
        {
          id: "23050",
          name: "Limbiate",
          state_id: "1847",
        },
        {
          id: "23051",
          name: "Lissone",
          state_id: "1847",
        },
        {
          id: "23052",
          name: "Locate di Triulzi",
          state_id: "1847",
        },
        {
          id: "23053",
          name: "Lodi",
          state_id: "1847",
        },
        {
          id: "23054",
          name: "Lomazzo",
          state_id: "1847",
        },
        {
          id: "23055",
          name: "Lonate Pozzolo",
          state_id: "1847",
        },
        {
          id: "23056",
          name: "Lonato",
          state_id: "1847",
        },
        {
          id: "23057",
          name: "Luino",
          state_id: "1847",
        },
        {
          id: "23058",
          name: "Lumezzane",
          state_id: "1847",
        },
        {
          id: "23059",
          name: "Lurate Caccivio",
          state_id: "1847",
        },
        {
          id: "23060",
          name: "Magenta",
          state_id: "1847",
        },
        {
          id: "23061",
          name: "Malnate",
          state_id: "1847",
        },
        {
          id: "23062",
          name: "Mandello del Lario",
          state_id: "1847",
        },
        {
          id: "23063",
          name: "Manerbio",
          state_id: "1847",
        },
        {
          id: "23064",
          name: "Mantova",
          state_id: "1847",
        },
        {
          id: "23065",
          name: "Mariano Comense",
          state_id: "1847",
        },
        {
          id: "23066",
          name: "Martinengo",
          state_id: "1847",
        },
        {
          id: "23067",
          name: "Mazzano",
          state_id: "1847",
        },
        {
          id: "23068",
          name: "Meda",
          state_id: "1847",
        },
        {
          id: "23069",
          name: "Mediglia",
          state_id: "1847",
        },
        {
          id: "23070",
          name: "Melegnano",
          state_id: "1847",
        },
        {
          id: "23071",
          name: "Melzo",
          state_id: "1847",
        },
        {
          id: "23072",
          name: "Merate",
          state_id: "1847",
        },
        {
          id: "23073",
          name: "Milano",
          state_id: "1847",
        },
        {
          id: "23074",
          name: "Molteno",
          state_id: "1847",
        },
        {
          id: "23075",
          name: "Montichiari",
          state_id: "1847",
        },
        {
          id: "23076",
          name: "Monza",
          state_id: "1847",
        },
        {
          id: "23077",
          name: "Morbegno",
          state_id: "1847",
        },
        {
          id: "23078",
          name: "Mornago",
          state_id: "1847",
        },
        {
          id: "23079",
          name: "Mortara",
          state_id: "1847",
        },
        {
          id: "23080",
          name: "Muggio",
          state_id: "1847",
        },
        {
          id: "23081",
          name: "Nave",
          state_id: "1847",
        },
        {
          id: "23082",
          name: "Nembro",
          state_id: "1847",
        },
        {
          id: "23083",
          name: "Nerviano",
          state_id: "1847",
        },
        {
          id: "23084",
          name: "Nova Milanese",
          state_id: "1847",
        },
        {
          id: "23085",
          name: "Novate Milanese",
          state_id: "1847",
        },
        {
          id: "23086",
          name: "Olgiate Comasco",
          state_id: "1847",
        },
        {
          id: "23087",
          name: "Olgiate Olona",
          state_id: "1847",
        },
        {
          id: "23088",
          name: "Opera",
          state_id: "1847",
        },
        {
          id: "23089",
          name: "Orzinuovi",
          state_id: "1847",
        },
        {
          id: "23090",
          name: "Osio Sotto",
          state_id: "1847",
        },
        {
          id: "23091",
          name: "Ospitaletto",
          state_id: "1847",
        },
        {
          id: "23092",
          name: "Paderno Dugnano",
          state_id: "1847",
        },
        {
          id: "23093",
          name: "Palazzolo sull''Oglio",
          state_id: "1847",
        },
        {
          id: "23094",
          name: "Pandino",
          state_id: "1847",
        },
        {
          id: "23095",
          name: "Parabiago",
          state_id: "1847",
        },
        {
          id: "23096",
          name: "Paullo",
          state_id: "1847",
        },
        {
          id: "23097",
          name: "Pavia",
          state_id: "1847",
        },
        {
          id: "23098",
          name: "Pero",
          state_id: "1847",
        },
        {
          id: "23099",
          name: "Peschiera Borromeo",
          state_id: "1847",
        },
        {
          id: "23100",
          name: "Pessano con Bornago",
          state_id: "1847",
        },
        {
          id: "23101",
          name: "Pieve Emanuele",
          state_id: "1847",
        },
        {
          id: "23102",
          name: "Pioltello",
          state_id: "1847",
        },
        {
          id: "23103",
          name: "Ponte Nossa",
          state_id: "1847",
        },
        {
          id: "23104",
          name: "Ponte San Pietro",
          state_id: "1847",
        },
        {
          id: "23105",
          name: "Porto Mantovano",
          state_id: "1847",
        },
        {
          id: "23106",
          name: "Pozzolengo",
          state_id: "1847",
        },
        {
          id: "23107",
          name: "Rescaldina",
          state_id: "1847",
        },
        {
          id: "23108",
          name: "Rezzato",
          state_id: "1847",
        },
        {
          id: "23109",
          name: "Rho",
          state_id: "1847",
        },
        {
          id: "23110",
          name: "Rivarolo Mantovano",
          state_id: "1847",
        },
        {
          id: "23111",
          name: "Rodano",
          state_id: "1847",
        },
        {
          id: "23112",
          name: "Romano di Lombardia",
          state_id: "1847",
        },
        {
          id: "23113",
          name: "Rovato",
          state_id: "1847",
        },
        {
          id: "23114",
          name: "Rozzano",
          state_id: "1847",
        },
        {
          id: "23115",
          name: "Saletto",
          state_id: "1847",
        },
        {
          id: "23116",
          name: "Salo",
          state_id: "1847",
        },
        {
          id: "23117",
          name: "Samarate",
          state_id: "1847",
        },
        {
          id: "23118",
          name: "San Donato Milanese",
          state_id: "1847",
        },
        {
          id: "23119",
          name: "San Giuliano Milanese",
          state_id: "1847",
        },
        {
          id: "23120",
          name: "Sant''Angelo Lodigiano",
          state_id: "1847",
        },
        {
          id: "23121",
          name: "Sarezzo",
          state_id: "1847",
        },
        {
          id: "23122",
          name: "Saronno",
          state_id: "1847",
        },
        {
          id: "23123",
          name: "Scanzorosciate",
          state_id: "1847",
        },
        {
          id: "23124",
          name: "Sedriano",
          state_id: "1847",
        },
        {
          id: "23125",
          name: "Segrate",
          state_id: "1847",
        },
        {
          id: "23126",
          name: "Senago",
          state_id: "1847",
        },
        {
          id: "23127",
          name: "Seregno",
          state_id: "1847",
        },
        {
          id: "23128",
          name: "Seriate",
          state_id: "1847",
        },
        {
          id: "23129",
          name: "Sesto Calende",
          state_id: "1847",
        },
        {
          id: "23130",
          name: "Sesto San Giovanni",
          state_id: "1847",
        },
        {
          id: "23131",
          name: "Settimo Milanese",
          state_id: "1847",
        },
        {
          id: "23132",
          name: "Seveso",
          state_id: "1847",
        },
        {
          id: "23133",
          name: "Sirmione",
          state_id: "1847",
        },
        {
          id: "23134",
          name: "Solaro",
          state_id: "1847",
        },
        {
          id: "23135",
          name: "Somma Lombardo",
          state_id: "1847",
        },
        {
          id: "23136",
          name: "Sondrio",
          state_id: "1847",
        },
        {
          id: "23137",
          name: "Soresina",
          state_id: "1847",
        },
        {
          id: "23138",
          name: "Sorisole",
          state_id: "1847",
        },
        {
          id: "23139",
          name: "Stezzano",
          state_id: "1847",
        },
        {
          id: "23140",
          name: "Stradella",
          state_id: "1847",
        },
        {
          id: "23141",
          name: "Suzzara",
          state_id: "1847",
        },
        {
          id: "23142",
          name: "Tirano",
          state_id: "1847",
        },
        {
          id: "23143",
          name: "Tornata",
          state_id: "1847",
        },
        {
          id: "23144",
          name: "Tradate",
          state_id: "1847",
        },
        {
          id: "23145",
          name: "Travagliato",
          state_id: "1847",
        },
        {
          id: "23146",
          name: "Treviglio",
          state_id: "1847",
        },
        {
          id: "23147",
          name: "Treviolo",
          state_id: "1847",
        },
        {
          id: "23148",
          name: "Trezzano sul Naviglio",
          state_id: "1847",
        },
        {
          id: "23149",
          name: "Trezzo",
          state_id: "1847",
        },
        {
          id: "23150",
          name: "Tromello",
          state_id: "1847",
        },
        {
          id: "23151",
          name: "Uboldo",
          state_id: "1847",
        },
        {
          id: "23152",
          name: "Urgnano",
          state_id: "1847",
        },
        {
          id: "23153",
          name: "Usmate Velate",
          state_id: "1847",
        },
        {
          id: "23154",
          name: "Valmadrera",
          state_id: "1847",
        },
        {
          id: "23155",
          name: "Varedo",
          state_id: "1847",
        },
        {
          id: "23156",
          name: "Varese",
          state_id: "1847",
        },
        {
          id: "23157",
          name: "Verano Brianza",
          state_id: "1847",
        },
        {
          id: "23158",
          name: "Vergiate",
          state_id: "1847",
        },
        {
          id: "23159",
          name: "Viadana",
          state_id: "1847",
        },
        {
          id: "23160",
          name: "Vigevano",
          state_id: "1847",
        },
        {
          id: "23161",
          name: "Vignate",
          state_id: "1847",
        },
        {
          id: "23162",
          name: "Villa Carcina",
          state_id: "1847",
        },
        {
          id: "23163",
          name: "Villa Guardia",
          state_id: "1847",
        },
        {
          id: "23164",
          name: "Villasanta",
          state_id: "1847",
        },
        {
          id: "23165",
          name: "Vimercate",
          state_id: "1847",
        },
        {
          id: "23166",
          name: "Vimodrone",
          state_id: "1847",
        },
        {
          id: "23167",
          name: "Virgilio",
          state_id: "1847",
        },
        {
          id: "23168",
          name: "Voghera",
          state_id: "1847",
        },
        {
          id: "23169",
          name: "Zibido San Giacomo",
          state_id: "1847",
        },
        {
          id: "23170",
          name: "Zogno",
          state_id: "1847",
        },
      ],
      Lombardy: [
        {
          id: "23171",
          name: "Barasso",
          state_id: "1848",
        },
        {
          id: "23172",
          name: "Bergamo",
          state_id: "1848",
        },
        {
          id: "23173",
          name: "Bolladello",
          state_id: "1848",
        },
        {
          id: "23174",
          name: "Capergnanica",
          state_id: "1848",
        },
        {
          id: "23175",
          name: "Costa Masnaga",
          state_id: "1848",
        },
        {
          id: "23176",
          name: "Medolago",
          state_id: "1848",
        },
        {
          id: "23177",
          name: "Nibionno",
          state_id: "1848",
        },
        {
          id: "23178",
          name: "Rodano",
          state_id: "1848",
        },
        {
          id: "23179",
          name: "Sordio",
          state_id: "1848",
        },
        {
          id: "23180",
          name: "Torre d''Isola",
          state_id: "1848",
        },
        {
          id: "23181",
          name: "Varese",
          state_id: "1848",
        },
        {
          id: "23182",
          name: "Villongo",
          state_id: "1848",
        },
        {
          id: "23183",
          name: "milan",
          state_id: "1848",
        },
      ],
      Macerata: [
        {
          id: "23184",
          name: "Colmurano",
          state_id: "1849",
        },
        {
          id: "23185",
          name: "Monte San Giusto",
          state_id: "1849",
        },
      ],
      Mantova: [
        {
          id: "23186",
          name: "Castel",
          state_id: "1850",
        },
        {
          id: "23187",
          name: "Gazoldo",
          state_id: "1850",
        },
        {
          id: "23188",
          name: "Marmirolo",
          state_id: "1850",
        },
        {
          id: "23189",
          name: "Monzambano",
          state_id: "1850",
        },
        {
          id: "23190",
          name: "Ostiglia",
          state_id: "1850",
        },
        {
          id: "23191",
          name: "Pegognaga",
          state_id: "1850",
        },
        {
          id: "23192",
          name: "Poggio Rusco",
          state_id: "1850",
        },
        {
          id: "23193",
          name: "Quistello",
          state_id: "1850",
        },
        {
          id: "23194",
          name: "Roverbella",
          state_id: "1850",
        },
        {
          id: "23195",
          name: "Suzzara",
          state_id: "1850",
        },
      ],
      Marche: [
        {
          id: "23196",
          name: "Ancona",
          state_id: "1851",
        },
        {
          id: "23197",
          name: "Ascoli Piceno",
          state_id: "1851",
        },
        {
          id: "23198",
          name: "Barchi",
          state_id: "1851",
        },
        {
          id: "23199",
          name: "Cagli",
          state_id: "1851",
        },
        {
          id: "23200",
          name: "Castelfidardo",
          state_id: "1851",
        },
        {
          id: "23201",
          name: "Chiaravalle",
          state_id: "1851",
        },
        {
          id: "23202",
          name: "Cingoli",
          state_id: "1851",
        },
        {
          id: "23203",
          name: "Civitanova Marche",
          state_id: "1851",
        },
        {
          id: "23204",
          name: "Corridonia",
          state_id: "1851",
        },
        {
          id: "23205",
          name: "Fabriano",
          state_id: "1851",
        },
        {
          id: "23206",
          name: "Falconara Marittima",
          state_id: "1851",
        },
        {
          id: "23207",
          name: "Fano",
          state_id: "1851",
        },
        {
          id: "23208",
          name: "Fermo",
          state_id: "1851",
        },
        {
          id: "23209",
          name: "Filottrano",
          state_id: "1851",
        },
        {
          id: "23210",
          name: "Folignano",
          state_id: "1851",
        },
        {
          id: "23211",
          name: "Fossombrone",
          state_id: "1851",
        },
        {
          id: "23212",
          name: "Grottammare",
          state_id: "1851",
        },
        {
          id: "23213",
          name: "Jesi",
          state_id: "1851",
        },
        {
          id: "23214",
          name: "Loreto",
          state_id: "1851",
        },
        {
          id: "23215",
          name: "Macerata",
          state_id: "1851",
        },
        {
          id: "23216",
          name: "Matelica",
          state_id: "1851",
        },
        {
          id: "23217",
          name: "Mondavio",
          state_id: "1851",
        },
        {
          id: "23218",
          name: "Mondolfo",
          state_id: "1851",
        },
        {
          id: "23219",
          name: "Montappone",
          state_id: "1851",
        },
        {
          id: "23220",
          name: "Montecosaro",
          state_id: "1851",
        },
        {
          id: "23221",
          name: "Montegranaro",
          state_id: "1851",
        },
        {
          id: "23222",
          name: "Montemarciano",
          state_id: "1851",
        },
        {
          id: "23223",
          name: "Monteprandone",
          state_id: "1851",
        },
        {
          id: "23224",
          name: "Morrovalle",
          state_id: "1851",
        },
        {
          id: "23225",
          name: "Osimo",
          state_id: "1851",
        },
        {
          id: "23226",
          name: "Pesaro",
          state_id: "1851",
        },
        {
          id: "23227",
          name: "Polverigi",
          state_id: "1851",
        },
        {
          id: "23228",
          name: "Porto Recanati",
          state_id: "1851",
        },
        {
          id: "23229",
          name: "Porto San Giorgio",
          state_id: "1851",
        },
        {
          id: "23230",
          name: "Porto Sant''Elpidio",
          state_id: "1851",
        },
        {
          id: "23231",
          name: "Potenza Picena",
          state_id: "1851",
        },
        {
          id: "23232",
          name: "Recanati",
          state_id: "1851",
        },
        {
          id: "23233",
          name: "San Benedetto del Tronto",
          state_id: "1851",
        },
        {
          id: "23234",
          name: "San Severino Marche",
          state_id: "1851",
        },
        {
          id: "23235",
          name: "Sant''Elpidio a Mare",
          state_id: "1851",
        },
        {
          id: "23236",
          name: "Senigallia",
          state_id: "1851",
        },
        {
          id: "23237",
          name: "Tolentino",
          state_id: "1851",
        },
        {
          id: "23238",
          name: "Treia",
          state_id: "1851",
        },
        {
          id: "23239",
          name: "Urbino",
          state_id: "1851",
        },
      ],
      Messina: [
        {
          id: "23240",
          name: "Cumiana",
          state_id: "1852",
        },
        {
          id: "23241",
          name: "Giammoro",
          state_id: "1852",
        },
      ],
      Milan: [
        {
          id: "23242",
          name: "Assago",
          state_id: "1853",
        },
        {
          id: "23243",
          name: "Besana in Brianza",
          state_id: "1853",
        },
        {
          id: "23244",
          name: "Biassono",
          state_id: "1853",
        },
        {
          id: "23245",
          name: "Burago Molgora",
          state_id: "1853",
        },
        {
          id: "23246",
          name: "Cernusco Sul Naviglio",
          state_id: "1853",
        },
        {
          id: "23247",
          name: "Cologno Monzese",
          state_id: "1853",
        },
        {
          id: "23248",
          name: "Concorezzo",
          state_id: "1853",
        },
        {
          id: "23249",
          name: "Cornaredo",
          state_id: "1853",
        },
        {
          id: "23250",
          name: "Cuggiono",
          state_id: "1853",
        },
        {
          id: "23251",
          name: "Cusago",
          state_id: "1853",
        },
        {
          id: "23252",
          name: "Foro Buonaparte",
          state_id: "1853",
        },
        {
          id: "23253",
          name: "Gessate",
          state_id: "1853",
        },
        {
          id: "23254",
          name: "Gorgonzola",
          state_id: "1853",
        },
        {
          id: "23255",
          name: "Liscate",
          state_id: "1853",
        },
        {
          id: "23256",
          name: "Magenta",
          state_id: "1853",
        },
        {
          id: "23257",
          name: "Milan",
          state_id: "1853",
        },
        {
          id: "23258",
          name: "Noviglio",
          state_id: "1853",
        },
        {
          id: "23259",
          name: "Passirana Di Rho",
          state_id: "1853",
        },
        {
          id: "23260",
          name: "Pregnana Milane",
          state_id: "1853",
        },
        {
          id: "23261",
          name: "San Donato Milanese",
          state_id: "1853",
        },
        {
          id: "23262",
          name: "Seregno",
          state_id: "1853",
        },
        {
          id: "23263",
          name: "Trezzo Sull''adda",
          state_id: "1853",
        },
        {
          id: "23264",
          name: "Tribiano",
          state_id: "1853",
        },
        {
          id: "23265",
          name: "Vaprio d''Adda",
          state_id: "1853",
        },
        {
          id: "23266",
          name: "Vermezzo",
          state_id: "1853",
        },
      ],
      Modena: [
        {
          id: "23267",
          name: "Bomporto",
          state_id: "1854",
        },
        {
          id: "23268",
          name: "Campogalliano",
          state_id: "1854",
        },
        {
          id: "23269",
          name: "Cavezzo",
          state_id: "1854",
        },
        {
          id: "23270",
          name: "Medolla",
          state_id: "1854",
        },
        {
          id: "23271",
          name: "Nonantola",
          state_id: "1854",
        },
        {
          id: "23272",
          name: "San Possidonio",
          state_id: "1854",
        },
        {
          id: "23273",
          name: "Sassuolo",
          state_id: "1854",
        },
        {
          id: "23274",
          name: "Spilamberto",
          state_id: "1854",
        },
      ],
      Molise: [
        {
          id: "23275",
          name: "Bojano",
          state_id: "1855",
        },
        {
          id: "23276",
          name: "Campobasso",
          state_id: "1855",
        },
        {
          id: "23277",
          name: "Cantalupo",
          state_id: "1855",
        },
        {
          id: "23278",
          name: "Isernia",
          state_id: "1855",
        },
        {
          id: "23279",
          name: "Termoli",
          state_id: "1855",
        },
        {
          id: "23280",
          name: "Venafro",
          state_id: "1855",
        },
      ],
      Molteno: [],
      Montenegro: [
        {
          id: "23281",
          name: "Montenegro",
          state_id: "1857",
        },
      ],
      "Monza and Brianza": [],
      Naples: [
        {
          id: "23282",
          name: "Forio d''Ischia",
          state_id: "1859",
        },
      ],
      Novara: [
        {
          id: "23283",
          name: "Bogogno",
          state_id: "1860",
        },
        {
          id: "23284",
          name: "Invorio",
          state_id: "1860",
        },
        {
          id: "23285",
          name: "Pombia",
          state_id: "1860",
        },
      ],
      Padova: [
        {
          id: "23286",
          name: "Bagnoli di Sopra",
          state_id: "1861",
        },
        {
          id: "23287",
          name: "Bovolenta",
          state_id: "1861",
        },
        {
          id: "23288",
          name: "Casale Di Scodosia",
          state_id: "1861",
        },
        {
          id: "23289",
          name: "Cervarese Santa Croce",
          state_id: "1861",
        },
        {
          id: "23290",
          name: "Fontaniva",
          state_id: "1861",
        },
        {
          id: "23291",
          name: "Galliera Veneta",
          state_id: "1861",
        },
        {
          id: "23292",
          name: "Legnaro",
          state_id: "1861",
        },
        {
          id: "23293",
          name: "Limena",
          state_id: "1861",
        },
        {
          id: "23294",
          name: "Loreggia",
          state_id: "1861",
        },
        {
          id: "23295",
          name: "Massanzago",
          state_id: "1861",
        },
        {
          id: "23296",
          name: "Onara",
          state_id: "1861",
        },
        {
          id: "23297",
          name: "Ponso",
          state_id: "1861",
        },
        {
          id: "23298",
          name: "Portogallo",
          state_id: "1861",
        },
        {
          id: "23299",
          name: "Tribano",
          state_id: "1861",
        },
      ],
      Parma: [
        {
          id: "23300",
          name: "Baganzola",
          state_id: "1862",
        },
        {
          id: "23301",
          name: "Busseto",
          state_id: "1862",
        },
        {
          id: "23302",
          name: "Casale Di Mezzani",
          state_id: "1862",
        },
        {
          id: "23303",
          name: "Fontevivo",
          state_id: "1862",
        },
        {
          id: "23304",
          name: "Solignano",
          state_id: "1862",
        },
        {
          id: "23305",
          name: "Torrile",
          state_id: "1862",
        },
      ],
      Pavia: [
        {
          id: "23306",
          name: "Codevilla",
          state_id: "1863",
        },
        {
          id: "23307",
          name: "Marcignago",
          state_id: "1863",
        },
        {
          id: "23308",
          name: "Pavia",
          state_id: "1863",
        },
        {
          id: "23309",
          name: "Siziano",
          state_id: "1863",
        },
      ],
      Perugia: [
        {
          id: "23310",
          name: "Pianello",
          state_id: "1864",
        },
        {
          id: "23311",
          name: "Ponte Felcino",
          state_id: "1864",
        },
        {
          id: "23312",
          name: "Zanica",
          state_id: "1864",
        },
      ],
      "Pesaro-Urbino": [
        {
          id: "23313",
          name: "Gradara",
          state_id: "1865",
        },
        {
          id: "23314",
          name: "Monte Porzio",
          state_id: "1865",
        },
        {
          id: "23315",
          name: "Pergola",
          state_id: "1865",
        },
        {
          id: "23316",
          name: "Tavullia",
          state_id: "1865",
        },
      ],
      Piacenza: [
        {
          id: "23317",
          name: "Alseno",
          state_id: "1866",
        },
        {
          id: "23318",
          name: "Gossolengo",
          state_id: "1866",
        },
        {
          id: "23319",
          name: "Vigolzone",
          state_id: "1866",
        },
      ],
      Piedmont: [
        {
          id: "23320",
          name: "Armeno",
          state_id: "1867",
        },
        {
          id: "23321",
          name: "Bergamasco",
          state_id: "1867",
        },
        {
          id: "23322",
          name: "Caselette",
          state_id: "1867",
        },
        {
          id: "23323",
          name: "Rosta",
          state_id: "1867",
        },
        {
          id: "23324",
          name: "San Damiano",
          state_id: "1867",
        },
        {
          id: "23325",
          name: "Spinetta Marengo",
          state_id: "1867",
        },
      ],
      Piemonte: [
        {
          id: "23326",
          name: "Acqui Terme",
          state_id: "1868",
        },
        {
          id: "23327",
          name: "Alba",
          state_id: "1868",
        },
        {
          id: "23328",
          name: "Alessandria",
          state_id: "1868",
        },
        {
          id: "23329",
          name: "Alpignano",
          state_id: "1868",
        },
        {
          id: "23330",
          name: "Andezeno",
          state_id: "1868",
        },
        {
          id: "23331",
          name: "Andonno",
          state_id: "1868",
        },
        {
          id: "23332",
          name: "Arona",
          state_id: "1868",
        },
        {
          id: "23333",
          name: "Asti",
          state_id: "1868",
        },
        {
          id: "23334",
          name: "Avigliana",
          state_id: "1868",
        },
        {
          id: "23335",
          name: "Baveno",
          state_id: "1868",
        },
        {
          id: "23336",
          name: "Beinasco",
          state_id: "1868",
        },
        {
          id: "23337",
          name: "Bellinzago Novarese",
          state_id: "1868",
        },
        {
          id: "23338",
          name: "Biella",
          state_id: "1868",
        },
        {
          id: "23339",
          name: "Borgaro Torinese",
          state_id: "1868",
        },
        {
          id: "23340",
          name: "Borgo San Dalmazzo",
          state_id: "1868",
        },
        {
          id: "23341",
          name: "Borgomanero",
          state_id: "1868",
        },
        {
          id: "23342",
          name: "Borgosesia",
          state_id: "1868",
        },
        {
          id: "23343",
          name: "Boves",
          state_id: "1868",
        },
        {
          id: "23344",
          name: "Bra",
          state_id: "1868",
        },
        {
          id: "23345",
          name: "Busca",
          state_id: "1868",
        },
        {
          id: "23346",
          name: "Cameri",
          state_id: "1868",
        },
        {
          id: "23347",
          name: "Canelli",
          state_id: "1868",
        },
        {
          id: "23348",
          name: "Carignano",
          state_id: "1868",
        },
        {
          id: "23349",
          name: "Carmagnola",
          state_id: "1868",
        },
        {
          id: "23350",
          name: "Casale Monferrato",
          state_id: "1868",
        },
        {
          id: "23351",
          name: "Caselle Torinese",
          state_id: "1868",
        },
        {
          id: "23352",
          name: "Castellamonte",
          state_id: "1868",
        },
        {
          id: "23353",
          name: "Castelletto sopra Ticino",
          state_id: "1868",
        },
        {
          id: "23354",
          name: "Chieri",
          state_id: "1868",
        },
        {
          id: "23355",
          name: "Chivasso",
          state_id: "1868",
        },
        {
          id: "23356",
          name: "Cirie",
          state_id: "1868",
        },
        {
          id: "23357",
          name: "Collegno",
          state_id: "1868",
        },
        {
          id: "23358",
          name: "Cossato",
          state_id: "1868",
        },
        {
          id: "23359",
          name: "Cuneo",
          state_id: "1868",
        },
        {
          id: "23360",
          name: "Cuorgne",
          state_id: "1868",
        },
        {
          id: "23361",
          name: "Domodossola",
          state_id: "1868",
        },
        {
          id: "23362",
          name: "Druento",
          state_id: "1868",
        },
        {
          id: "23363",
          name: "Fossano",
          state_id: "1868",
        },
        {
          id: "23364",
          name: "Galliate",
          state_id: "1868",
        },
        {
          id: "23365",
          name: "Gassino Torinese",
          state_id: "1868",
        },
        {
          id: "23366",
          name: "Gattinara",
          state_id: "1868",
        },
        {
          id: "23367",
          name: "Giaveno",
          state_id: "1868",
        },
        {
          id: "23368",
          name: "Grugliasco",
          state_id: "1868",
        },
        {
          id: "23369",
          name: "Ivrea",
          state_id: "1868",
        },
        {
          id: "23370",
          name: "Leini",
          state_id: "1868",
        },
        {
          id: "23371",
          name: "LusigliÃƒÂ¨",
          state_id: "1868",
        },
        {
          id: "23372",
          name: "Marano Ticino",
          state_id: "1868",
        },
        {
          id: "23373",
          name: "Mergozzo",
          state_id: "1868",
        },
        {
          id: "23374",
          name: "Moncalieri",
          state_id: "1868",
        },
        {
          id: "23375",
          name: "Mondovi",
          state_id: "1868",
        },
        {
          id: "23376",
          name: "Mongrando",
          state_id: "1868",
        },
        {
          id: "23377",
          name: "Nichelino",
          state_id: "1868",
        },
        {
          id: "23378",
          name: "Nizza Monferrato",
          state_id: "1868",
        },
        {
          id: "23379",
          name: "Novara",
          state_id: "1868",
        },
        {
          id: "23380",
          name: "Novi Ligure",
          state_id: "1868",
        },
        {
          id: "23381",
          name: "Oleggio",
          state_id: "1868",
        },
        {
          id: "23382",
          name: "Omegna",
          state_id: "1868",
        },
        {
          id: "23383",
          name: "Orbassano",
          state_id: "1868",
        },
        {
          id: "23384",
          name: "Ovada",
          state_id: "1868",
        },
        {
          id: "23385",
          name: "Pianezza",
          state_id: "1868",
        },
        {
          id: "23386",
          name: "Pinerolo",
          state_id: "1868",
        },
        {
          id: "23387",
          name: "Pino Torinese",
          state_id: "1868",
        },
        {
          id: "23388",
          name: "Piossasco",
          state_id: "1868",
        },
        {
          id: "23389",
          name: "Poirino",
          state_id: "1868",
        },
        {
          id: "23390",
          name: "Racconigi",
          state_id: "1868",
        },
        {
          id: "23391",
          name: "Rivalta di Torino",
          state_id: "1868",
        },
        {
          id: "23392",
          name: "Rivarolo Canavese",
          state_id: "1868",
        },
        {
          id: "23393",
          name: "Rivoli",
          state_id: "1868",
        },
        {
          id: "23394",
          name: "Saluzzo",
          state_id: "1868",
        },
        {
          id: "23395",
          name: "San Maurizio",
          state_id: "1868",
        },
        {
          id: "23396",
          name: "San Mauro Torinese",
          state_id: "1868",
        },
        {
          id: "23397",
          name: "Sandigliano",
          state_id: "1868",
        },
        {
          id: "23398",
          name: "Santena",
          state_id: "1868",
        },
        {
          id: "23399",
          name: "Santhia",
          state_id: "1868",
        },
        {
          id: "23400",
          name: "Savigliano",
          state_id: "1868",
        },
        {
          id: "23401",
          name: "Settimo Torinese",
          state_id: "1868",
        },
        {
          id: "23402",
          name: "Torino",
          state_id: "1868",
        },
        {
          id: "23403",
          name: "Tortona",
          state_id: "1868",
        },
        {
          id: "23404",
          name: "Trecate",
          state_id: "1868",
        },
        {
          id: "23405",
          name: "Trofarello",
          state_id: "1868",
        },
        {
          id: "23406",
          name: "Valduggia",
          state_id: "1868",
        },
        {
          id: "23407",
          name: "Valenza",
          state_id: "1868",
        },
        {
          id: "23408",
          name: "Venaria Reale",
          state_id: "1868",
        },
        {
          id: "23409",
          name: "Verbania",
          state_id: "1868",
        },
        {
          id: "23410",
          name: "Vercelli",
          state_id: "1868",
        },
        {
          id: "23411",
          name: "Vigliano Biellese",
          state_id: "1868",
        },
        {
          id: "23412",
          name: "Vinovo",
          state_id: "1868",
        },
        {
          id: "23413",
          name: "Volpiano",
          state_id: "1868",
        },
      ],
      Pisa: [
        {
          id: "23414",
          name: "Perignano",
          state_id: "1869",
        },
        {
          id: "23415",
          name: "Ponte a Egola",
          state_id: "1869",
        },
      ],
      Pordenone: [
        {
          id: "23416",
          name: "San Quirino",
          state_id: "1870",
        },
      ],
      Potenza: [
        {
          id: "23417",
          name: "Latronico",
          state_id: "1871",
        },
      ],
      Puglia: [
        {
          id: "23418",
          name: "Acquaviva delle Fonti",
          state_id: "1872",
        },
        {
          id: "23419",
          name: "Adelfia",
          state_id: "1872",
        },
        {
          id: "23420",
          name: "Alberobello",
          state_id: "1872",
        },
        {
          id: "23421",
          name: "Altamura",
          state_id: "1872",
        },
        {
          id: "23422",
          name: "Andria",
          state_id: "1872",
        },
        {
          id: "23423",
          name: "Apricena",
          state_id: "1872",
        },
        {
          id: "23424",
          name: "Aradeo",
          state_id: "1872",
        },
        {
          id: "23425",
          name: "Bari",
          state_id: "1872",
        },
        {
          id: "23426",
          name: "Barletta",
          state_id: "1872",
        },
        {
          id: "23427",
          name: "Bisceglie",
          state_id: "1872",
        },
        {
          id: "23428",
          name: "Bitetto",
          state_id: "1872",
        },
        {
          id: "23429",
          name: "Bitonto",
          state_id: "1872",
        },
        {
          id: "23430",
          name: "Bitritto",
          state_id: "1872",
        },
        {
          id: "23431",
          name: "Brindisi",
          state_id: "1872",
        },
        {
          id: "23432",
          name: "Campi Salentina",
          state_id: "1872",
        },
        {
          id: "23433",
          name: "Canosa di Puglia",
          state_id: "1872",
        },
        {
          id: "23434",
          name: "Capurso",
          state_id: "1872",
        },
        {
          id: "23435",
          name: "Carmiano",
          state_id: "1872",
        },
        {
          id: "23436",
          name: "Carovigno",
          state_id: "1872",
        },
        {
          id: "23437",
          name: "Casamassima",
          state_id: "1872",
        },
        {
          id: "23438",
          name: "Casarano",
          state_id: "1872",
        },
        {
          id: "23439",
          name: "Cassano delle Murge",
          state_id: "1872",
        },
        {
          id: "23440",
          name: "Castellana Grotte",
          state_id: "1872",
        },
        {
          id: "23441",
          name: "Castellaneta",
          state_id: "1872",
        },
        {
          id: "23442",
          name: "Cavallino",
          state_id: "1872",
        },
        {
          id: "23443",
          name: "Ceglie Messapica",
          state_id: "1872",
        },
        {
          id: "23444",
          name: "Cerignola",
          state_id: "1872",
        },
        {
          id: "23445",
          name: "Cisternino",
          state_id: "1872",
        },
        {
          id: "23446",
          name: "Conversano",
          state_id: "1872",
        },
        {
          id: "23447",
          name: "Copertino",
          state_id: "1872",
        },
        {
          id: "23448",
          name: "Corato",
          state_id: "1872",
        },
        {
          id: "23449",
          name: "Crispiano",
          state_id: "1872",
        },
        {
          id: "23450",
          name: "Cutrofiano",
          state_id: "1872",
        },
        {
          id: "23451",
          name: "Erchie",
          state_id: "1872",
        },
        {
          id: "23452",
          name: "Fasano",
          state_id: "1872",
        },
        {
          id: "23453",
          name: "Foggia",
          state_id: "1872",
        },
        {
          id: "23454",
          name: "Francavilla Fontana",
          state_id: "1872",
        },
        {
          id: "23455",
          name: "Galatina",
          state_id: "1872",
        },
        {
          id: "23456",
          name: "Galatone",
          state_id: "1872",
        },
        {
          id: "23457",
          name: "Gallipoli",
          state_id: "1872",
        },
        {
          id: "23458",
          name: "Ginosa",
          state_id: "1872",
        },
        {
          id: "23459",
          name: "Gioia del Colle",
          state_id: "1872",
        },
        {
          id: "23460",
          name: "Giovinazzo",
          state_id: "1872",
        },
        {
          id: "23461",
          name: "Gravina in Puglia",
          state_id: "1872",
        },
        {
          id: "23462",
          name: "Grottaglie",
          state_id: "1872",
        },
        {
          id: "23463",
          name: "Grumo Appula",
          state_id: "1872",
        },
        {
          id: "23464",
          name: "Laterza",
          state_id: "1872",
        },
        {
          id: "23465",
          name: "Latiano",
          state_id: "1872",
        },
        {
          id: "23466",
          name: "Lecce",
          state_id: "1872",
        },
        {
          id: "23467",
          name: "Leverano",
          state_id: "1872",
        },
        {
          id: "23468",
          name: "Lizzanello",
          state_id: "1872",
        },
        {
          id: "23469",
          name: "Lizzano",
          state_id: "1872",
        },
        {
          id: "23470",
          name: "Locorotondo",
          state_id: "1872",
        },
        {
          id: "23471",
          name: "Lucera",
          state_id: "1872",
        },
        {
          id: "23472",
          name: "Maglie",
          state_id: "1872",
        },
        {
          id: "23473",
          name: "Manduria",
          state_id: "1872",
        },
        {
          id: "23474",
          name: "Manfredonia",
          state_id: "1872",
        },
        {
          id: "23475",
          name: "Margherita di Savoia",
          state_id: "1872",
        },
        {
          id: "23476",
          name: "Martano",
          state_id: "1872",
        },
        {
          id: "23477",
          name: "Martina Franca",
          state_id: "1872",
        },
        {
          id: "23478",
          name: "Massafra",
          state_id: "1872",
        },
        {
          id: "23479",
          name: "Matino",
          state_id: "1872",
        },
        {
          id: "23480",
          name: "Melendugno",
          state_id: "1872",
        },
        {
          id: "23481",
          name: "Mesagne",
          state_id: "1872",
        },
        {
          id: "23482",
          name: "Minervino Murge",
          state_id: "1872",
        },
        {
          id: "23483",
          name: "Modugno",
          state_id: "1872",
        },
        {
          id: "23484",
          name: "Mola di Bari",
          state_id: "1872",
        },
        {
          id: "23485",
          name: "Molfetta",
          state_id: "1872",
        },
        {
          id: "23486",
          name: "Monopoli",
          state_id: "1872",
        },
        {
          id: "23487",
          name: "Monte Sant''Angelo",
          state_id: "1872",
        },
        {
          id: "23488",
          name: "Monteroni di Lecce",
          state_id: "1872",
        },
        {
          id: "23489",
          name: "Mottola",
          state_id: "1872",
        },
        {
          id: "23490",
          name: "Nardo",
          state_id: "1872",
        },
        {
          id: "23491",
          name: "Neviano",
          state_id: "1872",
        },
        {
          id: "23492",
          name: "Noci",
          state_id: "1872",
        },
        {
          id: "23493",
          name: "Noicattaro",
          state_id: "1872",
        },
        {
          id: "23494",
          name: "Novoli",
          state_id: "1872",
        },
        {
          id: "23495",
          name: "Oria",
          state_id: "1872",
        },
        {
          id: "23496",
          name: "Orta Nova",
          state_id: "1872",
        },
        {
          id: "23497",
          name: "Ostuni",
          state_id: "1872",
        },
        {
          id: "23498",
          name: "Palagiano",
          state_id: "1872",
        },
        {
          id: "23499",
          name: "Palo del Colle",
          state_id: "1872",
        },
        {
          id: "23500",
          name: "Parabita",
          state_id: "1872",
        },
        {
          id: "23501",
          name: "Polignano a Mare",
          state_id: "1872",
        },
        {
          id: "23502",
          name: "Pulsano",
          state_id: "1872",
        },
        {
          id: "23504",
          name: "Putignano",
          state_id: "1872",
        },
        {
          id: "23505",
          name: "Racale",
          state_id: "1872",
        },
        {
          id: "23506",
          name: "Ruffano",
          state_id: "1872",
        },
        {
          id: "23507",
          name: "Rutigliano",
          state_id: "1872",
        },
        {
          id: "23508",
          name: "Ruvo di Puglia",
          state_id: "1872",
        },
        {
          id: "23509",
          name: "Salice Salentino",
          state_id: "1872",
        },
        {
          id: "23510",
          name: "San Ferdinando di Puglia",
          state_id: "1872",
        },
        {
          id: "23511",
          name: "San Giorgio Ionico",
          state_id: "1872",
        },
        {
          id: "23512",
          name: "San Giovanni Rotondo",
          state_id: "1872",
        },
        {
          id: "23513",
          name: "San Marco in Lamis",
          state_id: "1872",
        },
        {
          id: "23514",
          name: "San Marzano di San Giuseppe",
          state_id: "1872",
        },
        {
          id: "23515",
          name: "San Nicandro Garganico",
          state_id: "1872",
        },
        {
          id: "23516",
          name: "San Pancrazio Salentino",
          state_id: "1872",
        },
        {
          id: "23517",
          name: "San Pietro Vernotico",
          state_id: "1872",
        },
        {
          id: "23518",
          name: "San Severo",
          state_id: "1872",
        },
        {
          id: "23519",
          name: "San Vito dei Normanni",
          state_id: "1872",
        },
        {
          id: "23520",
          name: "Sannicandro di Bari",
          state_id: "1872",
        },
        {
          id: "23521",
          name: "Santeramo in Colle",
          state_id: "1872",
        },
        {
          id: "23522",
          name: "Sava",
          state_id: "1872",
        },
        {
          id: "23523",
          name: "Squinzano",
          state_id: "1872",
        },
        {
          id: "23524",
          name: "Statte",
          state_id: "1872",
        },
        {
          id: "23525",
          name: "Surbo",
          state_id: "1872",
        },
        {
          id: "23526",
          name: "Taranto",
          state_id: "1872",
        },
        {
          id: "23527",
          name: "Taurisano",
          state_id: "1872",
        },
        {
          id: "23528",
          name: "Taviano",
          state_id: "1872",
        },
        {
          id: "23529",
          name: "Terlizzi",
          state_id: "1872",
        },
        {
          id: "23530",
          name: "Toritto",
          state_id: "1872",
        },
        {
          id: "23531",
          name: "Torre Santa Susanna",
          state_id: "1872",
        },
        {
          id: "23532",
          name: "Torremaggiore",
          state_id: "1872",
        },
        {
          id: "23533",
          name: "Trani",
          state_id: "1872",
        },
        {
          id: "23534",
          name: "Trepuzzi",
          state_id: "1872",
        },
        {
          id: "23535",
          name: "Tricase",
          state_id: "1872",
        },
        {
          id: "23536",
          name: "Triggiano",
          state_id: "1872",
        },
        {
          id: "23537",
          name: "Trinitapoli",
          state_id: "1872",
        },
        {
          id: "23538",
          name: "Turi",
          state_id: "1872",
        },
        {
          id: "23539",
          name: "Ugento",
          state_id: "1872",
        },
        {
          id: "23540",
          name: "Valenzano",
          state_id: "1872",
        },
        {
          id: "23541",
          name: "Veglie",
          state_id: "1872",
        },
        {
          id: "23542",
          name: "Vico del Gargano",
          state_id: "1872",
        },
        {
          id: "23543",
          name: "Vieste",
          state_id: "1872",
        },
        {
          id: "23544",
          name: "Villa Castelli",
          state_id: "1872",
        },
      ],
      "Reggio Emilia": [],
      Rimini: [
        {
          id: "23545",
          name: "San Giovanni in Marignano",
          state_id: "1874",
        },
        {
          id: "23546",
          name: "Torriana",
          state_id: "1874",
        },
      ],
      Roma: [
        {
          id: "23547",
          name: "Anzio",
          state_id: "1875",
        },
      ],
      Salerno: [
        {
          id: "23548",
          name: "Atena Lucana",
          state_id: "1876",
        },
        {
          id: "23549",
          name: "Castel San Giorgio",
          state_id: "1876",
        },
        {
          id: "23550",
          name: "Fisciano",
          state_id: "1876",
        },
        {
          id: "23551",
          name: "Giungano",
          state_id: "1876",
        },
        {
          id: "23552",
          name: "Omignano",
          state_id: "1876",
        },
      ],
      Sardegna: [
        {
          id: "23553",
          name: "Alghero",
          state_id: "1877",
        },
        {
          id: "23554",
          name: "Arzachena",
          state_id: "1877",
        },
        {
          id: "23555",
          name: "Assemini",
          state_id: "1877",
        },
        {
          id: "23556",
          name: "Cabras",
          state_id: "1877",
        },
        {
          id: "23557",
          name: "Cagliari",
          state_id: "1877",
        },
        {
          id: "23558",
          name: "Capoterra",
          state_id: "1877",
        },
        {
          id: "23559",
          name: "Carbonia",
          state_id: "1877",
        },
        {
          id: "23560",
          name: "Dorgali",
          state_id: "1877",
        },
        {
          id: "23561",
          name: "Guspini",
          state_id: "1877",
        },
        {
          id: "23562",
          name: "Iglesias",
          state_id: "1877",
        },
        {
          id: "23563",
          name: "Ittiri",
          state_id: "1877",
        },
        {
          id: "23564",
          name: "La Maddalena",
          state_id: "1877",
        },
        {
          id: "23565",
          name: "Macomer",
          state_id: "1877",
        },
        {
          id: "23566",
          name: "Monserrato",
          state_id: "1877",
        },
        {
          id: "23567",
          name: "Nuoro",
          state_id: "1877",
        },
        {
          id: "23568",
          name: "Olbia",
          state_id: "1877",
        },
        {
          id: "23569",
          name: "Oristano",
          state_id: "1877",
        },
        {
          id: "23570",
          name: "Ozieri",
          state_id: "1877",
        },
        {
          id: "23571",
          name: "Porto Torres",
          state_id: "1877",
        },
        {
          id: "23572",
          name: "Quartu Sant''Elena",
          state_id: "1877",
        },
        {
          id: "23573",
          name: "Quartucciu",
          state_id: "1877",
        },
        {
          id: "23574",
          name: "San Gavino Monreale",
          state_id: "1877",
        },
        {
          id: "23575",
          name: "Sanluri",
          state_id: "1877",
        },
        {
          id: "23576",
          name: "Sant''Antioco",
          state_id: "1877",
        },
        {
          id: "23577",
          name: "Sassari",
          state_id: "1877",
        },
        {
          id: "23578",
          name: "Selargius",
          state_id: "1877",
        },
        {
          id: "23579",
          name: "Serramanna",
          state_id: "1877",
        },
        {
          id: "23580",
          name: "Sestu",
          state_id: "1877",
        },
        {
          id: "23581",
          name: "Siniscola",
          state_id: "1877",
        },
        {
          id: "23582",
          name: "Sinnai",
          state_id: "1877",
        },
        {
          id: "23583",
          name: "Sorso",
          state_id: "1877",
        },
        {
          id: "23584",
          name: "Tempio Pausania",
          state_id: "1877",
        },
        {
          id: "23585",
          name: "Terralba",
          state_id: "1877",
        },
        {
          id: "23586",
          name: "Tortoli",
          state_id: "1877",
        },
        {
          id: "23587",
          name: "Villacidro",
          state_id: "1877",
        },
      ],
      Sassari: [
        {
          id: "23588",
          name: "Nule",
          state_id: "1878",
        },
      ],
      Savona: [
        {
          id: "23589",
          name: "Altare",
          state_id: "1879",
        },
      ],
      Sicilia: [
        {
          id: "23590",
          name: "Aci Castello",
          state_id: "1880",
        },
        {
          id: "23591",
          name: "Aci Catena",
          state_id: "1880",
        },
        {
          id: "23592",
          name: "Aci Sant''Antonio",
          state_id: "1880",
        },
        {
          id: "23593",
          name: "Acireale",
          state_id: "1880",
        },
        {
          id: "23594",
          name: "Adrano",
          state_id: "1880",
        },
        {
          id: "23595",
          name: "Agira",
          state_id: "1880",
        },
        {
          id: "23596",
          name: "Agrigento",
          state_id: "1880",
        },
        {
          id: "23597",
          name: "Alcamo",
          state_id: "1880",
        },
        {
          id: "23598",
          name: "Altofonte",
          state_id: "1880",
        },
        {
          id: "23599",
          name: "Aragona",
          state_id: "1880",
        },
        {
          id: "23600",
          name: "Augusta",
          state_id: "1880",
        },
        {
          id: "23601",
          name: "Avola",
          state_id: "1880",
        },
        {
          id: "23602",
          name: "Bagheria",
          state_id: "1880",
        },
        {
          id: "23603",
          name: "Barcellona",
          state_id: "1880",
        },
        {
          id: "23604",
          name: "Barrafranca",
          state_id: "1880",
        },
        {
          id: "23605",
          name: "Belmonte Mezzagno",
          state_id: "1880",
        },
        {
          id: "23606",
          name: "Belpasso",
          state_id: "1880",
        },
        {
          id: "23607",
          name: "Biancavilla",
          state_id: "1880",
        },
        {
          id: "23608",
          name: "Bronte",
          state_id: "1880",
        },
        {
          id: "23609",
          name: "Caccamo",
          state_id: "1880",
        },
        {
          id: "23610",
          name: "Caltagirone",
          state_id: "1880",
        },
        {
          id: "23611",
          name: "Caltanissetta",
          state_id: "1880",
        },
        {
          id: "23612",
          name: "Campobello di Licata",
          state_id: "1880",
        },
        {
          id: "23613",
          name: "Campobello di Mazara",
          state_id: "1880",
        },
        {
          id: "23614",
          name: "Canicatti",
          state_id: "1880",
        },
        {
          id: "23615",
          name: "Capaci",
          state_id: "1880",
        },
        {
          id: "23616",
          name: "Capo d''Orlando",
          state_id: "1880",
        },
        {
          id: "23617",
          name: "Carini",
          state_id: "1880",
        },
        {
          id: "23618",
          name: "Carlentini",
          state_id: "1880",
        },
        {
          id: "23619",
          name: "Castelbuono",
          state_id: "1880",
        },
        {
          id: "23620",
          name: "Casteldaccia",
          state_id: "1880",
        },
        {
          id: "23621",
          name: "Castellammare del Golfo",
          state_id: "1880",
        },
        {
          id: "23622",
          name: "Casteltermini",
          state_id: "1880",
        },
        {
          id: "23623",
          name: "Castelvetrano",
          state_id: "1880",
        },
        {
          id: "23624",
          name: "Catania",
          state_id: "1880",
        },
        {
          id: "23625",
          name: "Catenanuova",
          state_id: "1880",
        },
        {
          id: "23626",
          name: "Cefalu",
          state_id: "1880",
        },
        {
          id: "23627",
          name: "Chiaramonte Gulfi",
          state_id: "1880",
        },
        {
          id: "23628",
          name: "Cinisi",
          state_id: "1880",
        },
        {
          id: "23629",
          name: "Comiso",
          state_id: "1880",
        },
        {
          id: "23630",
          name: "Corleone",
          state_id: "1880",
        },
        {
          id: "23631",
          name: "Enna",
          state_id: "1880",
        },
        {
          id: "23632",
          name: "Erice",
          state_id: "1880",
        },
        {
          id: "23633",
          name: "Favara",
          state_id: "1880",
        },
        {
          id: "23634",
          name: "Ficarazzi",
          state_id: "1880",
        },
        {
          id: "23635",
          name: "Fiumefreddo di Sicilia",
          state_id: "1880",
        },
        {
          id: "23636",
          name: "Floridia",
          state_id: "1880",
        },
        {
          id: "23637",
          name: "Francofonte",
          state_id: "1880",
        },
        {
          id: "23638",
          name: "Gela",
          state_id: "1880",
        },
        {
          id: "23639",
          name: "Giardini-Naxos",
          state_id: "1880",
        },
        {
          id: "23640",
          name: "Giarre",
          state_id: "1880",
        },
        {
          id: "23641",
          name: "Grammichele",
          state_id: "1880",
        },
        {
          id: "23642",
          name: "Gravina di Catania",
          state_id: "1880",
        },
        {
          id: "23643",
          name: "Ispica",
          state_id: "1880",
        },
        {
          id: "23644",
          name: "Lentini",
          state_id: "1880",
        },
        {
          id: "23645",
          name: "Leonforte",
          state_id: "1880",
        },
        {
          id: "23646",
          name: "Licata",
          state_id: "1880",
        },
        {
          id: "23647",
          name: "Lipari",
          state_id: "1880",
        },
        {
          id: "23648",
          name: "Marsala",
          state_id: "1880",
        },
        {
          id: "23649",
          name: "Mascali",
          state_id: "1880",
        },
        {
          id: "23650",
          name: "Mascalucia",
          state_id: "1880",
        },
        {
          id: "23651",
          name: "Mazara del Vallo",
          state_id: "1880",
        },
        {
          id: "23652",
          name: "Mazzarino",
          state_id: "1880",
        },
        {
          id: "23653",
          name: "Melilli",
          state_id: "1880",
        },
        {
          id: "23654",
          name: "Menfi",
          state_id: "1880",
        },
        {
          id: "23655",
          name: "Messina",
          state_id: "1880",
        },
        {
          id: "23656",
          name: "Milazzo",
          state_id: "1880",
        },
        {
          id: "23657",
          name: "Militello in Val di Catania",
          state_id: "1880",
        },
        {
          id: "23658",
          name: "Misilmeri",
          state_id: "1880",
        },
        {
          id: "23659",
          name: "Misterbianco",
          state_id: "1880",
        },
        {
          id: "23660",
          name: "Modica",
          state_id: "1880",
        },
        {
          id: "23661",
          name: "Monreale",
          state_id: "1880",
        },
        {
          id: "23662",
          name: "Motta Sant''Anastasia",
          state_id: "1880",
        },
        {
          id: "23663",
          name: "Mussomeli",
          state_id: "1880",
        },
        {
          id: "23664",
          name: "Naro",
          state_id: "1880",
        },
        {
          id: "23665",
          name: "Nicosia",
          state_id: "1880",
        },
        {
          id: "23666",
          name: "Niscemi",
          state_id: "1880",
        },
        {
          id: "23667",
          name: "Noto",
          state_id: "1880",
        },
        {
          id: "23668",
          name: "Paceco",
          state_id: "1880",
        },
        {
          id: "23669",
          name: "Pachino",
          state_id: "1880",
        },
        {
          id: "23670",
          name: "Palagonia",
          state_id: "1880",
        },
        {
          id: "23671",
          name: "Palazzolo Acreide",
          state_id: "1880",
        },
        {
          id: "23672",
          name: "Palermo",
          state_id: "1880",
        },
        {
          id: "23673",
          name: "Palma di Montechiaro",
          state_id: "1880",
        },
        {
          id: "23674",
          name: "Partanna",
          state_id: "1880",
        },
        {
          id: "23675",
          name: "Partinico",
          state_id: "1880",
        },
        {
          id: "23676",
          name: "Paterno",
          state_id: "1880",
        },
        {
          id: "23677",
          name: "Patti",
          state_id: "1880",
        },
        {
          id: "23678",
          name: "Pedara",
          state_id: "1880",
        },
        {
          id: "23679",
          name: "Piazza Armerina",
          state_id: "1880",
        },
        {
          id: "23680",
          name: "Porto Empedocle",
          state_id: "1880",
        },
        {
          id: "23681",
          name: "Pozzallo",
          state_id: "1880",
        },
        {
          id: "23682",
          name: "Priolo Gargallo",
          state_id: "1880",
        },
        {
          id: "23683",
          name: "Racalmuto",
          state_id: "1880",
        },
        {
          id: "23684",
          name: "Raffadali",
          state_id: "1880",
        },
        {
          id: "23685",
          name: "Ragusa",
          state_id: "1880",
        },
        {
          id: "23686",
          name: "Ramacca",
          state_id: "1880",
        },
        {
          id: "23687",
          name: "Randazzo",
          state_id: "1880",
        },
        {
          id: "23688",
          name: "Ravanusa",
          state_id: "1880",
        },
        {
          id: "23689",
          name: "Ribera",
          state_id: "1880",
        },
        {
          id: "23690",
          name: "Riesi",
          state_id: "1880",
        },
        {
          id: "23691",
          name: "Riposto",
          state_id: "1880",
        },
        {
          id: "23692",
          name: "Rosolini",
          state_id: "1880",
        },
        {
          id: "23693",
          name: "Salemi",
          state_id: "1880",
        },
        {
          id: "23694",
          name: "San Cataldo",
          state_id: "1880",
        },
        {
          id: "23695",
          name: "San Giovanni Gemini",
          state_id: "1880",
        },
        {
          id: "23696",
          name: "San Giovanni la Punta",
          state_id: "1880",
        },
        {
          id: "23697",
          name: "San Giuseppe Jato",
          state_id: "1880",
        },
        {
          id: "23698",
          name: "San Gregorio di Catania",
          state_id: "1880",
        },
        {
          id: "23699",
          name: "Sant''Agata di Militello",
          state_id: "1880",
        },
        {
          id: "23700",
          name: "Sant''Agata li Battiati",
          state_id: "1880",
        },
        {
          id: "23701",
          name: "Santa Croce Camerina",
          state_id: "1880",
        },
        {
          id: "23702",
          name: "Santa Flavia",
          state_id: "1880",
        },
        {
          id: "23703",
          name: "Santa Teresa di Riva",
          state_id: "1880",
        },
        {
          id: "23704",
          name: "Sciacca",
          state_id: "1880",
        },
        {
          id: "23705",
          name: "Scicli",
          state_id: "1880",
        },
        {
          id: "23706",
          name: "Scordia",
          state_id: "1880",
        },
        {
          id: "23707",
          name: "Siracusa",
          state_id: "1880",
        },
        {
          id: "23708",
          name: "Sortino",
          state_id: "1880",
        },
        {
          id: "23709",
          name: "Taormina",
          state_id: "1880",
        },
        {
          id: "23710",
          name: "Termini Imerese",
          state_id: "1880",
        },
        {
          id: "23711",
          name: "Terrasini",
          state_id: "1880",
        },
        {
          id: "23712",
          name: "Trabia",
          state_id: "1880",
        },
        {
          id: "23713",
          name: "Trapani",
          state_id: "1880",
        },
        {
          id: "23714",
          name: "Trecastagni",
          state_id: "1880",
        },
        {
          id: "23715",
          name: "Tremestieri Etneo",
          state_id: "1880",
        },
        {
          id: "23716",
          name: "Troina",
          state_id: "1880",
        },
        {
          id: "23717",
          name: "Valderice",
          state_id: "1880",
        },
        {
          id: "23718",
          name: "Valguarnera Caropepe",
          state_id: "1880",
        },
        {
          id: "23719",
          name: "Villabate",
          state_id: "1880",
        },
        {
          id: "23720",
          name: "Villafranca Tirrena",
          state_id: "1880",
        },
        {
          id: "23721",
          name: "Vittoria",
          state_id: "1880",
        },
        {
          id: "23722",
          name: "Zafferana Etnea",
          state_id: "1880",
        },
      ],
      Siena: [
        {
          id: "23723",
          name: "Monteriggioni",
          state_id: "1881",
        },
        {
          id: "23724",
          name: "Monteroni d Arbia",
          state_id: "1881",
        },
      ],
      Sondrio: [
        {
          id: "23725",
          name: "Delebio",
          state_id: "1882",
        },
        {
          id: "23726",
          name: "Talamona",
          state_id: "1882",
        },
      ],
      "South Tyrol": [],
      Taranto: [
        {
          id: "23727",
          name: "Faggiano",
          state_id: "1884",
        },
        {
          id: "23728",
          name: "Riva del Garda",
          state_id: "1884",
        },
      ],
      Teramo: [
        {
          id: "23729",
          name: "Castilenti",
          state_id: "1885",
        },
        {
          id: "23730",
          name: "Controguerra",
          state_id: "1885",
        },
      ],
      Torino: [
        {
          id: "23731",
          name: "Bruino",
          state_id: "1886",
        },
        {
          id: "23732",
          name: "Busano",
          state_id: "1886",
        },
        {
          id: "23733",
          name: "Buttigliera Alta",
          state_id: "1886",
        },
        {
          id: "23734",
          name: "Cavour",
          state_id: "1886",
        },
        {
          id: "23735",
          name: "Chieri",
          state_id: "1886",
        },
        {
          id: "23736",
          name: "Colleretto Giacosa",
          state_id: "1886",
        },
        {
          id: "23737",
          name: "Cuceglio",
          state_id: "1886",
        },
        {
          id: "23738",
          name: "Giaveno",
          state_id: "1886",
        },
        {
          id: "23739",
          name: "Mazze",
          state_id: "1886",
        },
        {
          id: "23740",
          name: "Mercenasco",
          state_id: "1886",
        },
        {
          id: "23741",
          name: "Piobesi",
          state_id: "1886",
        },
        {
          id: "23742",
          name: "Rivoli",
          state_id: "1886",
        },
        {
          id: "23743",
          name: "Robassomero",
          state_id: "1886",
        },
        {
          id: "23744",
          name: "Scarmagno",
          state_id: "1886",
        },
        {
          id: "23745",
          name: "Strambino",
          state_id: "1886",
        },
        {
          id: "23746",
          name: "Turin",
          state_id: "1886",
        },
        {
          id: "23747",
          name: "Villar Perosa",
          state_id: "1886",
        },
        {
          id: "23748",
          name: "Volpiano",
          state_id: "1886",
        },
      ],
      Toscana: [
        {
          id: "23749",
          name: "Agliana",
          state_id: "1887",
        },
        {
          id: "23750",
          name: "Altopascio",
          state_id: "1887",
        },
        {
          id: "23751",
          name: "Anghiari",
          state_id: "1887",
        },
        {
          id: "23752",
          name: "Arezzo",
          state_id: "1887",
        },
        {
          id: "23753",
          name: "Aulla",
          state_id: "1887",
        },
        {
          id: "23754",
          name: "Bagno a Ripoli",
          state_id: "1887",
        },
        {
          id: "23755",
          name: "Barberino di Mugello",
          state_id: "1887",
        },
        {
          id: "23756",
          name: "Barga",
          state_id: "1887",
        },
        {
          id: "23757",
          name: "Bibbiena",
          state_id: "1887",
        },
        {
          id: "23758",
          name: "Borgo San Lorenzo",
          state_id: "1887",
        },
        {
          id: "23759",
          name: "Bucine",
          state_id: "1887",
        },
        {
          id: "23760",
          name: "Buggiano",
          state_id: "1887",
        },
        {
          id: "23761",
          name: "Calcinaia",
          state_id: "1887",
        },
        {
          id: "23762",
          name: "Calenzano",
          state_id: "1887",
        },
        {
          id: "23763",
          name: "Camaiore",
          state_id: "1887",
        },
        {
          id: "23764",
          name: "Campi Bisenzio",
          state_id: "1887",
        },
        {
          id: "23765",
          name: "Campiglia Marittima",
          state_id: "1887",
        },
        {
          id: "23766",
          name: "Capannori",
          state_id: "1887",
        },
        {
          id: "23767",
          name: "Cappelle",
          state_id: "1887",
        },
        {
          id: "23768",
          name: "Capraia",
          state_id: "1887",
        },
        {
          id: "23769",
          name: "Carmignano",
          state_id: "1887",
        },
        {
          id: "23770",
          name: "Carrara",
          state_id: "1887",
        },
        {
          id: "23771",
          name: "Cascina",
          state_id: "1887",
        },
        {
          id: "23772",
          name: "Castagneto Carducci",
          state_id: "1887",
        },
        {
          id: "23773",
          name: "Castelfiorentino",
          state_id: "1887",
        },
        {
          id: "23774",
          name: "Castelfranco di Sotto",
          state_id: "1887",
        },
        {
          id: "23775",
          name: "Castiglion Fiorentino",
          state_id: "1887",
        },
        {
          id: "23776",
          name: "Cecina",
          state_id: "1887",
        },
        {
          id: "23777",
          name: "Cerreto Guidi",
          state_id: "1887",
        },
        {
          id: "23778",
          name: "Certaldo",
          state_id: "1887",
        },
        {
          id: "23779",
          name: "Chiesina Uzzanese",
          state_id: "1887",
        },
        {
          id: "23780",
          name: "Chiusi",
          state_id: "1887",
        },
        {
          id: "23781",
          name: "Civitella in Val di Chiana",
          state_id: "1887",
        },
        {
          id: "23782",
          name: "Colle di Val d''Elsa",
          state_id: "1887",
        },
        {
          id: "23783",
          name: "Collesalvetti",
          state_id: "1887",
        },
        {
          id: "23784",
          name: "Cortona",
          state_id: "1887",
        },
        {
          id: "23785",
          name: "Empoli",
          state_id: "1887",
        },
        {
          id: "23786",
          name: "Fiesole",
          state_id: "1887",
        },
        {
          id: "23787",
          name: "Figline Valdarno",
          state_id: "1887",
        },
        {
          id: "23788",
          name: "Firenze",
          state_id: "1887",
        },
        {
          id: "23789",
          name: "Fivizzano",
          state_id: "1887",
        },
        {
          id: "23790",
          name: "Florence",
          state_id: "1887",
        },
        {
          id: "23791",
          name: "Foiano della Chiana",
          state_id: "1887",
        },
        {
          id: "23792",
          name: "Follonica",
          state_id: "1887",
        },
        {
          id: "23793",
          name: "Forte dei Marmi",
          state_id: "1887",
        },
        {
          id: "23794",
          name: "Fucecchio",
          state_id: "1887",
        },
        {
          id: "23795",
          name: "Gavorrano",
          state_id: "1887",
        },
        {
          id: "23796",
          name: "Greve in Chianti",
          state_id: "1887",
        },
        {
          id: "23797",
          name: "Grosseto",
          state_id: "1887",
        },
        {
          id: "23798",
          name: "Impruneta",
          state_id: "1887",
        },
        {
          id: "23799",
          name: "Lari",
          state_id: "1887",
        },
        {
          id: "23800",
          name: "Lastra a Signa",
          state_id: "1887",
        },
        {
          id: "23801",
          name: "Livorno",
          state_id: "1887",
        },
        {
          id: "23802",
          name: "Lucca",
          state_id: "1887",
        },
        {
          id: "23803",
          name: "Massa",
          state_id: "1887",
        },
        {
          id: "23804",
          name: "Massa Marittima",
          state_id: "1887",
        },
        {
          id: "23805",
          name: "Massarosa",
          state_id: "1887",
        },
        {
          id: "23806",
          name: "Monsummano Terme",
          state_id: "1887",
        },
        {
          id: "23807",
          name: "Montale",
          state_id: "1887",
        },
        {
          id: "23808",
          name: "Monte Argentario",
          state_id: "1887",
        },
        {
          id: "23809",
          name: "Monte San Savino",
          state_id: "1887",
        },
        {
          id: "23810",
          name: "Montecatini-Terme",
          state_id: "1887",
        },
        {
          id: "23811",
          name: "Montelupo Fiorentino",
          state_id: "1887",
        },
        {
          id: "23812",
          name: "Montemurlo",
          state_id: "1887",
        },
        {
          id: "23813",
          name: "Montepulciano",
          state_id: "1887",
        },
        {
          id: "23814",
          name: "Montespertoli",
          state_id: "1887",
        },
        {
          id: "23815",
          name: "Montevarchi",
          state_id: "1887",
        },
        {
          id: "23816",
          name: "Montignoso",
          state_id: "1887",
        },
        {
          id: "23817",
          name: "Montopoli in Val d''Arno",
          state_id: "1887",
        },
        {
          id: "23818",
          name: "Orbetello",
          state_id: "1887",
        },
        {
          id: "23819",
          name: "Pescia",
          state_id: "1887",
        },
        {
          id: "23820",
          name: "Pietrasanta",
          state_id: "1887",
        },
        {
          id: "23821",
          name: "Pieve a Nievole",
          state_id: "1887",
        },
        {
          id: "23822",
          name: "Piombino",
          state_id: "1887",
        },
        {
          id: "23823",
          name: "Pisa",
          state_id: "1887",
        },
        {
          id: "23824",
          name: "Pistoia",
          state_id: "1887",
        },
        {
          id: "23825",
          name: "Poggibonsi",
          state_id: "1887",
        },
        {
          id: "23826",
          name: "Poggio a Caiano",
          state_id: "1887",
        },
        {
          id: "23827",
          name: "Ponsacco",
          state_id: "1887",
        },
        {
          id: "23828",
          name: "Pontassieve",
          state_id: "1887",
        },
        {
          id: "23829",
          name: "Pontedera",
          state_id: "1887",
        },
        {
          id: "23830",
          name: "Ponticino",
          state_id: "1887",
        },
        {
          id: "23831",
          name: "Pontremoli",
          state_id: "1887",
        },
        {
          id: "23832",
          name: "Portoferraio",
          state_id: "1887",
        },
        {
          id: "23833",
          name: "Prato",
          state_id: "1887",
        },
        {
          id: "23834",
          name: "Quarrata",
          state_id: "1887",
        },
        {
          id: "23835",
          name: "Reggello",
          state_id: "1887",
        },
        {
          id: "23836",
          name: "Rignano",
          state_id: "1887",
        },
        {
          id: "23837",
          name: "Roccastrada",
          state_id: "1887",
        },
        {
          id: "23838",
          name: "Rosignano Marittimo",
          state_id: "1887",
        },
        {
          id: "23839",
          name: "San Casciano",
          state_id: "1887",
        },
        {
          id: "23840",
          name: "San Giovanni Valdarno",
          state_id: "1887",
        },
        {
          id: "23841",
          name: "San Giuliano Terme",
          state_id: "1887",
        },
        {
          id: "23842",
          name: "San Miniato",
          state_id: "1887",
        },
        {
          id: "23843",
          name: "Sansepolcro",
          state_id: "1887",
        },
        {
          id: "23844",
          name: "Santa Croce sull''Arno",
          state_id: "1887",
        },
        {
          id: "23845",
          name: "Santa Maria a Monte",
          state_id: "1887",
        },
        {
          id: "23846",
          name: "Scandicci",
          state_id: "1887",
        },
        {
          id: "23847",
          name: "Seravezza",
          state_id: "1887",
        },
        {
          id: "23848",
          name: "Serravalle Pistoiese",
          state_id: "1887",
        },
        {
          id: "23849",
          name: "Sesto Fiorentino",
          state_id: "1887",
        },
        {
          id: "23850",
          name: "Siena",
          state_id: "1887",
        },
        {
          id: "23851",
          name: "Signa",
          state_id: "1887",
        },
        {
          id: "23852",
          name: "Sinalunga",
          state_id: "1887",
        },
        {
          id: "23853",
          name: "Sovicille",
          state_id: "1887",
        },
        {
          id: "23854",
          name: "Terranuova Bracciolini",
          state_id: "1887",
        },
        {
          id: "23855",
          name: "Vaiano",
          state_id: "1887",
        },
        {
          id: "23856",
          name: "Varna",
          state_id: "1887",
        },
        {
          id: "23857",
          name: "Vecchiano",
          state_id: "1887",
        },
        {
          id: "23858",
          name: "Viareggio",
          state_id: "1887",
        },
        {
          id: "23859",
          name: "Vinci",
          state_id: "1887",
        },
        {
          id: "23860",
          name: "Volterra",
          state_id: "1887",
        },
      ],
      Trapani: [
        {
          id: "23861",
          name: "Guarrato",
          state_id: "1888",
        },
      ],
      "Trentino-Alto Adige": [],
      Trento: [
        {
          id: "23862",
          name: "San Giorgio",
          state_id: "1890",
        },
        {
          id: "23863",
          name: "Dro",
          state_id: "1890",
        },
      ],
      Treviso: [
        {
          id: "23864",
          name: "Asolo",
          state_id: "1891",
        },
        {
          id: "23865",
          name: "Conegliano",
          state_id: "1891",
        },
        {
          id: "23866",
          name: "Cordignano",
          state_id: "1891",
        },
        {
          id: "23867",
          name: "Gaiarine",
          state_id: "1891",
        },
        {
          id: "23868",
          name: "Ormelle",
          state_id: "1891",
        },
        {
          id: "23869",
          name: "Possagno",
          state_id: "1891",
        },
        {
          id: "23870",
          name: "Revine Lago",
          state_id: "1891",
        },
      ],
      Udine: [
        {
          id: "23871",
          name: "Basiliano",
          state_id: "1892",
        },
        {
          id: "23872",
          name: "Bicinicco",
          state_id: "1892",
        },
        {
          id: "23873",
          name: "Buttrio",
          state_id: "1892",
        },
        {
          id: "23874",
          name: "Coseano",
          state_id: "1892",
        },
        {
          id: "23875",
          name: "Pradamano",
          state_id: "1892",
        },
        {
          id: "23876",
          name: "San Giovanni al Natisone",
          state_id: "1892",
        },
        {
          id: "23877",
          name: "Torreano",
          state_id: "1892",
        },
      ],
      Umbria: [
        {
          id: "23878",
          name: "Amelia",
          state_id: "1893",
        },
        {
          id: "23879",
          name: "Assisi",
          state_id: "1893",
        },
        {
          id: "23880",
          name: "Bastia Umbra",
          state_id: "1893",
        },
        {
          id: "23881",
          name: "Castiglione del Lago",
          state_id: "1893",
        },
        {
          id: "23882",
          name: "Citta di Castello",
          state_id: "1893",
        },
        {
          id: "23883",
          name: "Corciano",
          state_id: "1893",
        },
        {
          id: "23884",
          name: "Deruta",
          state_id: "1893",
        },
        {
          id: "23885",
          name: "Foligno",
          state_id: "1893",
        },
        {
          id: "23886",
          name: "Gualdo Tadino",
          state_id: "1893",
        },
        {
          id: "23887",
          name: "Gubbio",
          state_id: "1893",
        },
        {
          id: "23888",
          name: "Magione",
          state_id: "1893",
        },
        {
          id: "23889",
          name: "Marsciano",
          state_id: "1893",
        },
        {
          id: "23890",
          name: "Narni",
          state_id: "1893",
        },
        {
          id: "23891",
          name: "Orvieto",
          state_id: "1893",
        },
        {
          id: "23892",
          name: "Perugia",
          state_id: "1893",
        },
        {
          id: "23893",
          name: "San Giustino",
          state_id: "1893",
        },
        {
          id: "23894",
          name: "Spello",
          state_id: "1893",
        },
        {
          id: "23895",
          name: "Spoleto",
          state_id: "1893",
        },
        {
          id: "23896",
          name: "Terni",
          state_id: "1893",
        },
        {
          id: "23897",
          name: "Todi",
          state_id: "1893",
        },
        {
          id: "23898",
          name: "Umbertide",
          state_id: "1893",
        },
      ],
      "Valle d''Aosta": [],
      Varese: [
        {
          id: "23899",
          name: "Arsago Seprio",
          state_id: "1895",
        },
        {
          id: "23900",
          name: "Busto Arsizio",
          state_id: "1895",
        },
        {
          id: "23901",
          name: "Cassano Magnago",
          state_id: "1895",
        },
        {
          id: "23902",
          name: "Gazzada",
          state_id: "1895",
        },
        {
          id: "23903",
          name: "Oggiona Con Santo Stefano",
          state_id: "1895",
        },
        {
          id: "23904",
          name: "Solbiate Arno",
          state_id: "1895",
        },
        {
          id: "23905",
          name: "Solbiate Olona",
          state_id: "1895",
        },
        {
          id: "23906",
          name: "Ternate",
          state_id: "1895",
        },
        {
          id: "23907",
          name: "Venegono Inferiore",
          state_id: "1895",
        },
      ],
      Veneto: [
        {
          id: "23908",
          name: "Abano Terme",
          state_id: "1896",
        },
        {
          id: "23909",
          name: "Adria",
          state_id: "1896",
        },
        {
          id: "23910",
          name: "Albignasego",
          state_id: "1896",
        },
        {
          id: "23911",
          name: "Altavilla Vicentina",
          state_id: "1896",
        },
        {
          id: "23912",
          name: "Arzignano",
          state_id: "1896",
        },
        {
          id: "23913",
          name: "Badia Polesine",
          state_id: "1896",
        },
        {
          id: "23914",
          name: "Bassano del Grappa",
          state_id: "1896",
        },
        {
          id: "23915",
          name: "Belfiore",
          state_id: "1896",
        },
        {
          id: "23916",
          name: "Belluno",
          state_id: "1896",
        },
        {
          id: "23917",
          name: "Borso del Grappa",
          state_id: "1896",
        },
        {
          id: "23918",
          name: "Bovolone",
          state_id: "1896",
        },
        {
          id: "23919",
          name: "Bussolengo",
          state_id: "1896",
        },
        {
          id: "23920",
          name: "Cadoneghe",
          state_id: "1896",
        },
        {
          id: "23921",
          name: "Caldogno",
          state_id: "1896",
        },
        {
          id: "23922",
          name: "Camisano Vicentino",
          state_id: "1896",
        },
        {
          id: "23923",
          name: "Campodarsego",
          state_id: "1896",
        },
        {
          id: "23924",
          name: "Campolongo Maggiore",
          state_id: "1896",
        },
        {
          id: "23925",
          name: "Camponogara",
          state_id: "1896",
        },
        {
          id: "23926",
          name: "Camposampiero",
          state_id: "1896",
        },
        {
          id: "23927",
          name: "Caorle",
          state_id: "1896",
        },
        {
          id: "23928",
          name: "Carbonera",
          state_id: "1896",
        },
        {
          id: "23929",
          name: "Casale sul Sile",
          state_id: "1896",
        },
        {
          id: "23930",
          name: "Casier",
          state_id: "1896",
        },
        {
          id: "23931",
          name: "Cassola",
          state_id: "1896",
        },
        {
          id: "23932",
          name: "Castel d''Azzano",
          state_id: "1896",
        },
        {
          id: "23933",
          name: "Castelfranco Veneto",
          state_id: "1896",
        },
        {
          id: "23934",
          name: "Castello di Godego",
          state_id: "1896",
        },
        {
          id: "23935",
          name: "Castelnuovo del Garda",
          state_id: "1896",
        },
        {
          id: "23936",
          name: "Cavallino-Treporti",
          state_id: "1896",
        },
        {
          id: "23937",
          name: "Cavarzere",
          state_id: "1896",
        },
        {
          id: "23938",
          name: "Cerea",
          state_id: "1896",
        },
        {
          id: "23939",
          name: "Chiampo",
          state_id: "1896",
        },
        {
          id: "23940",
          name: "Chioggia",
          state_id: "1896",
        },
        {
          id: "23941",
          name: "Cittadella",
          state_id: "1896",
        },
        {
          id: "23942",
          name: "Colombano",
          state_id: "1896",
        },
        {
          id: "23943",
          name: "Concordia Sagittaria",
          state_id: "1896",
        },
        {
          id: "23944",
          name: "Conegliano",
          state_id: "1896",
        },
        {
          id: "23945",
          name: "Conselve",
          state_id: "1896",
        },
        {
          id: "23946",
          name: "Cornedo Vicentino",
          state_id: "1896",
        },
        {
          id: "23947",
          name: "Creazzo",
          state_id: "1896",
        },
        {
          id: "23948",
          name: "Dolo",
          state_id: "1896",
        },
        {
          id: "23949",
          name: "Due Carrare",
          state_id: "1896",
        },
        {
          id: "23950",
          name: "Dueville",
          state_id: "1896",
        },
        {
          id: "23951",
          name: "Eraclea",
          state_id: "1896",
        },
        {
          id: "23952",
          name: "Este",
          state_id: "1896",
        },
        {
          id: "23953",
          name: "Feltre",
          state_id: "1896",
        },
        {
          id: "23954",
          name: "Galzignano Terme",
          state_id: "1896",
        },
        {
          id: "23955",
          name: "Grezzana",
          state_id: "1896",
        },
        {
          id: "23956",
          name: "Iesolo",
          state_id: "1896",
        },
        {
          id: "23957",
          name: "Isola Vicentina",
          state_id: "1896",
        },
        {
          id: "23958",
          name: "Isola della Scala",
          state_id: "1896",
        },
        {
          id: "23959",
          name: "Jesolo",
          state_id: "1896",
        },
        {
          id: "23960",
          name: "Legnago",
          state_id: "1896",
        },
        {
          id: "23961",
          name: "Lendinara",
          state_id: "1896",
        },
        {
          id: "23962",
          name: "Lonigo",
          state_id: "1896",
        },
        {
          id: "23963",
          name: "Malo",
          state_id: "1896",
        },
        {
          id: "23964",
          name: "Marano Vicentino",
          state_id: "1896",
        },
        {
          id: "23965",
          name: "Marcon",
          state_id: "1896",
        },
        {
          id: "23966",
          name: "Marostica",
          state_id: "1896",
        },
        {
          id: "23967",
          name: "Martellago",
          state_id: "1896",
        },
        {
          id: "23968",
          name: "Mestrino",
          state_id: "1896",
        },
        {
          id: "23969",
          name: "Mira",
          state_id: "1896",
        },
        {
          id: "23970",
          name: "Mirano",
          state_id: "1896",
        },
        {
          id: "23971",
          name: "Mogliano Veneto",
          state_id: "1896",
        },
        {
          id: "23972",
          name: "Monselice",
          state_id: "1896",
        },
        {
          id: "23973",
          name: "Montagnana",
          state_id: "1896",
        },
        {
          id: "23974",
          name: "Montebelluna",
          state_id: "1896",
        },
        {
          id: "23975",
          name: "Montecchio Maggiore",
          state_id: "1896",
        },
        {
          id: "23976",
          name: "Montegrotto Terme",
          state_id: "1896",
        },
        {
          id: "23977",
          name: "Monticello Conte Otto",
          state_id: "1896",
        },
        {
          id: "23978",
          name: "Motta di Livenza",
          state_id: "1896",
        },
        {
          id: "23979",
          name: "Murano",
          state_id: "1896",
        },
        {
          id: "23980",
          name: "Musile di Piave",
          state_id: "1896",
        },
        {
          id: "23981",
          name: "Mussolente",
          state_id: "1896",
        },
        {
          id: "23982",
          name: "Negrar",
          state_id: "1896",
        },
        {
          id: "23983",
          name: "Noale",
          state_id: "1896",
        },
        {
          id: "23984",
          name: "Noventa Padovana",
          state_id: "1896",
        },
        {
          id: "23985",
          name: "Noventa Vicentina",
          state_id: "1896",
        },
        {
          id: "23986",
          name: "Occhiobello",
          state_id: "1896",
        },
        {
          id: "23987",
          name: "Oderzo",
          state_id: "1896",
        },
        {
          id: "23988",
          name: "Ormelle",
          state_id: "1896",
        },
        {
          id: "23989",
          name: "Padova",
          state_id: "1896",
        },
        {
          id: "23990",
          name: "Padua",
          state_id: "1896",
        },
        {
          id: "23991",
          name: "Paese",
          state_id: "1896",
        },
        {
          id: "23992",
          name: "Pescantina",
          state_id: "1896",
        },
        {
          id: "23993",
          name: "Peschiera del Garda",
          state_id: "1896",
        },
        {
          id: "23994",
          name: "Pianiga",
          state_id: "1896",
        },
        {
          id: "23995",
          name: "Piazzola sul Brenta",
          state_id: "1896",
        },
        {
          id: "23996",
          name: "Pieve di Soligo",
          state_id: "1896",
        },
        {
          id: "23997",
          name: "Pievebelvicino",
          state_id: "1896",
        },
        {
          id: "23998",
          name: "Piombino Dese",
          state_id: "1896",
        },
        {
          id: "23999",
          name: "Piove di Sacco",
          state_id: "1896",
        },
        {
          id: "24000",
          name: "Ponte San Nicolo",
          state_id: "1896",
        },
        {
          id: "24001",
          name: "Ponzano Veneto",
          state_id: "1896",
        },
        {
          id: "24002",
          name: "Porto Tolle",
          state_id: "1896",
        },
        {
          id: "24003",
          name: "Porto Viro",
          state_id: "1896",
        },
        {
          id: "24004",
          name: "Portogruaro",
          state_id: "1896",
        },
        {
          id: "24005",
          name: "Preganziol",
          state_id: "1896",
        },
        {
          id: "24006",
          name: "Quinto di Treviso",
          state_id: "1896",
        },
        {
          id: "24007",
          name: "Riese Pio X",
          state_id: "1896",
        },
        {
          id: "24008",
          name: "Romano dEzzelino",
          state_id: "1896",
        },
        {
          id: "24009",
          name: "Roncade",
          state_id: "1896",
        },
        {
          id: "24010",
          name: "Rosa",
          state_id: "1896",
        },
        {
          id: "24011",
          name: "Rovigo",
          state_id: "1896",
        },
        {
          id: "24012",
          name: "Rubano",
          state_id: "1896",
        },
        {
          id: "24013",
          name: "Salzano",
          state_id: "1896",
        },
        {
          id: "24014",
          name: "San Biagio di Callalta",
          state_id: "1896",
        },
        {
          id: "24015",
          name: "San Bonifacio",
          state_id: "1896",
        },
        {
          id: "24016",
          name: "San Dona di Piave",
          state_id: "1896",
        },
        {
          id: "24017",
          name: "San Giovanni Lupatoto",
          state_id: "1896",
        },
        {
          id: "24018",
          name: "San Martino Buon Albergo",
          state_id: "1896",
        },
        {
          id: "24019",
          name: "San Martino di Lupari",
          state_id: "1896",
        },
        {
          id: "24020",
          name: "San Michele al Tagliamento",
          state_id: "1896",
        },
        {
          id: "24021",
          name: "San Pietro in Cariano",
          state_id: "1896",
        },
        {
          id: "24022",
          name: "San Vendemiano",
          state_id: "1896",
        },
        {
          id: "24023",
          name: "Sant''Ambrogio",
          state_id: "1896",
        },
        {
          id: "24024",
          name: "Santa Maria di Sala",
          state_id: "1896",
        },
        {
          id: "24025",
          name: "Santo Stino di Livenza",
          state_id: "1896",
        },
        {
          id: "24026",
          name: "Santorso",
          state_id: "1896",
        },
        {
          id: "24027",
          name: "Saonara",
          state_id: "1896",
        },
        {
          id: "24028",
          name: "Sarcedo",
          state_id: "1896",
        },
        {
          id: "24029",
          name: "Schio",
          state_id: "1896",
        },
        {
          id: "24030",
          name: "Scorze",
          state_id: "1896",
        },
        {
          id: "24031",
          name: "Sedico",
          state_id: "1896",
        },
        {
          id: "24032",
          name: "Selvazzano Dentro",
          state_id: "1896",
        },
        {
          id: "24033",
          name: "Silea",
          state_id: "1896",
        },
        {
          id: "24034",
          name: "Sivizzo",
          state_id: "1896",
        },
        {
          id: "24035",
          name: "Sommacampagna",
          state_id: "1896",
        },
        {
          id: "24036",
          name: "Sona",
          state_id: "1896",
        },
        {
          id: "24037",
          name: "Spinea",
          state_id: "1896",
        },
        {
          id: "24038",
          name: "Spresiano",
          state_id: "1896",
        },
        {
          id: "24039",
          name: "Susegana",
          state_id: "1896",
        },
        {
          id: "24040",
          name: "Taglio di Po",
          state_id: "1896",
        },
        {
          id: "24041",
          name: "Teolo",
          state_id: "1896",
        },
        {
          id: "24042",
          name: "Tezze sul Brenta",
          state_id: "1896",
        },
        {
          id: "24043",
          name: "Thiene",
          state_id: "1896",
        },
        {
          id: "24044",
          name: "Torri di Quartesolo",
          state_id: "1896",
        },
        {
          id: "24045",
          name: "Trebaseleghe",
          state_id: "1896",
        },
        {
          id: "24046",
          name: "Trevignano",
          state_id: "1896",
        },
        {
          id: "24047",
          name: "Treviso",
          state_id: "1896",
        },
        {
          id: "24048",
          name: "Trissino",
          state_id: "1896",
        },
        {
          id: "24049",
          name: "Valdagno",
          state_id: "1896",
        },
        {
          id: "24050",
          name: "Valdobbiadene",
          state_id: "1896",
        },
        {
          id: "24051",
          name: "Valeggio sul Mincio",
          state_id: "1896",
        },
        {
          id: "24052",
          name: "Vedelago",
          state_id: "1896",
        },
        {
          id: "24053",
          name: "Venezia",
          state_id: "1896",
        },
        {
          id: "24054",
          name: "Venice",
          state_id: "1896",
        },
        {
          id: "24055",
          name: "Verona",
          state_id: "1896",
        },
        {
          id: "24056",
          name: "Vicenza",
          state_id: "1896",
        },
        {
          id: "24057",
          name: "Vigodarzere",
          state_id: "1896",
        },
        {
          id: "24058",
          name: "Vigonovo",
          state_id: "1896",
        },
        {
          id: "24059",
          name: "Vigonza",
          state_id: "1896",
        },
        {
          id: "24060",
          name: "Villafranca di Verona",
          state_id: "1896",
        },
        {
          id: "24061",
          name: "Villorba",
          state_id: "1896",
        },
        {
          id: "24062",
          name: "Vittorio Veneto",
          state_id: "1896",
        },
        {
          id: "24063",
          name: "Volpago del Montello",
          state_id: "1896",
        },
        {
          id: "24064",
          name: "Zane",
          state_id: "1896",
        },
        {
          id: "24065",
          name: "Zero Branco",
          state_id: "1896",
        },
        {
          id: "24066",
          name: "Zevio",
          state_id: "1896",
        },
      ],
      Venezia: [
        {
          id: "24067",
          name: "Cona",
          state_id: "1897",
        },
        {
          id: "24068",
          name: "Marghera",
          state_id: "1897",
        },
        {
          id: "24069",
          name: "Oriago di Mira",
          state_id: "1897",
        },
        {
          id: "24070",
          name: "Tessera",
          state_id: "1897",
        },
      ],
      "Verbano-Cusio-Ossola": [
        {
          id: "24071",
          name: "Piedimulera",
          state_id: "1898",
        },
      ],
      Vercelli: [
        {
          id: "24072",
          name: "Crescentino",
          state_id: "1899",
        },
        {
          id: "24073",
          name: "Moncrivello",
          state_id: "1899",
        },
        {
          id: "24074",
          name: "Rovasenda",
          state_id: "1899",
        },
        {
          id: "24075",
          name: "Trino",
          state_id: "1899",
        },
      ],
      Verona: [
        {
          id: "24076",
          name: "Valeggio Sul Mincio",
          state_id: "1900",
        },
        {
          id: "24077",
          name: "Cadidavid",
          state_id: "1900",
        },
        {
          id: "24078",
          name: "Colognola ai Colli",
          state_id: "1900",
        },
        {
          id: "24079",
          name: "Pastrengo",
          state_id: "1900",
        },
        {
          id: "24080",
          name: "Valgatara",
          state_id: "1900",
        },
      ],
      Vicenza: [
        {
          id: "24081",
          name: "Montebello Vicentino",
          state_id: "1901",
        },
        {
          id: "24082",
          name: "Alonte",
          state_id: "1901",
        },
        {
          id: "24083",
          name: "Arcugnano",
          state_id: "1901",
        },
        {
          id: "24084",
          name: "Arzignano",
          state_id: "1901",
        },
        {
          id: "24085",
          name: "Barbarano Vicentino",
          state_id: "1901",
        },
        {
          id: "24086",
          name: "Breganze",
          state_id: "1901",
        },
        {
          id: "24087",
          name: "Brendola",
          state_id: "1901",
        },
        {
          id: "24088",
          name: "Bressanvido",
          state_id: "1901",
        },
        {
          id: "24089",
          name: "Carre",
          state_id: "1901",
        },
        {
          id: "24090",
          name: "Castelgomberto",
          state_id: "1901",
        },
        {
          id: "24091",
          name: "Costabissara",
          state_id: "1901",
        },
        {
          id: "24092",
          name: "Grumolo delle Abbadesse",
          state_id: "1901",
        },
        {
          id: "24093",
          name: "Piovene Rocchette",
          state_id: "1901",
        },
        {
          id: "24094",
          name: "Povolaro",
          state_id: "1901",
        },
        {
          id: "24095",
          name: "Rossano Veneto",
          state_id: "1901",
        },
        {
          id: "24096",
          name: "San Pietro di Rosa",
          state_id: "1901",
        },
        {
          id: "24097",
          name: "San Vito di Leguzzano",
          state_id: "1901",
        },
        {
          id: "24098",
          name: "Sandrigo",
          state_id: "1901",
        },
        {
          id: "24099",
          name: "Thiene",
          state_id: "1901",
        },
        {
          id: "24100",
          name: "Torrebelvicino",
          state_id: "1901",
        },
        {
          id: "24101",
          name: "Torri di Quartesolo",
          state_id: "1901",
        },
        {
          id: "24102",
          name: "Villaverla",
          state_id: "1901",
        },
      ],
      Viterbo: [
        {
          id: "24103",
          name: "Nepi",
          state_id: "1902",
        },
      ],
    },
  },
  JE: {
    name: "Jersey",
    native: "Jersey",
    phone: "44",
    continent: "EU",
    capital: "Saint Helier",
    currency: "GBP",
    languages: ["en", "fr"],
    emoji: "🇯🇪",
    emojiU: "U+1F1EF U+1F1EA",
    states: {},
  },
  JM: {
    name: "Jamaica",
    native: "Jamaica",
    phone: "1876",
    continent: "NA",
    capital: "Kingston",
    currency: "JMD",
    languages: ["en"],
    emoji: "🇯🇲",
    emojiU: "U+1F1EF U+1F1F2",
    states: {
      "Buxoro Viloyati": [],
      Clarendon: [
        {
          id: "24104",
          name: "May Pen",
          state_id: "1904",
        },
      ],
      Hanover: [
        {
          id: "24105",
          name: "Lucea",
          state_id: "1905",
        },
      ],
      Kingston: [
        {
          id: "24106",
          name: "Kingston",
          state_id: "1906",
        },
      ],
      Manchester: [
        {
          id: "24107",
          name: "Mandeville",
          state_id: "1907",
        },
      ],
      Portland: [
        {
          id: "24108",
          name: "Port Antonio",
          state_id: "1908",
        },
      ],
      "Saint Andrews": [],
      "Saint Ann": [],
      "Saint Catherine": [],
      "Saint Elizabeth": [],
      "Saint James": [],
      "Saint Mary": [],
      "Saint Thomas": [],
      Trelawney: [
        {
          id: "24109",
          name: "Albert Town",
          state_id: "1916",
        },
        {
          id: "24110",
          name: "Falmouth",
          state_id: "1916",
        },
      ],
      Westmoreland: [
        {
          id: "24111",
          name: "Savanna la Mar",
          state_id: "1917",
        },
      ],
    },
  },
  JO: {
    name: "Jordan",
    native: "الأردن",
    phone: "962",
    continent: "AS",
    capital: "Amman",
    currency: "JOD",
    languages: ["ar"],
    emoji: "🇯🇴",
    emojiU: "U+1F1EF U+1F1F4",
    states: {
      Ajlun: [
        {
          id: "25164",
          name: "Abbin",
          state_id: "1977",
        },
        {
          id: "25165",
          name: "Ajlun",
          state_id: "1977",
        },
        {
          id: "25166",
          name: "Anjarah",
          state_id: "1977",
        },
        {
          id: "25167",
          name: "Arjan",
          state_id: "1977",
        },
        {
          id: "25168",
          name: "Ayn Janna",
          state_id: "1977",
        },
        {
          id: "25169",
          name: "Halawah",
          state_id: "1977",
        },
        {
          id: "25170",
          name: "Kharbat al-Wahadnah",
          state_id: "1977",
        },
        {
          id: "25171",
          name: "Kufranjah",
          state_id: "1977",
        },
        {
          id: "25172",
          name: "Sakhrah",
          state_id: "1977",
        },
        {
          id: "25173",
          name: "al-Hashamiyah",
          state_id: "1977",
        },
      ],
      Amman: [
        {
          id: "25174",
          name: "Abu ''Alanda",
          state_id: "1978",
        },
        {
          id: "25175",
          name: "Amman",
          state_id: "1978",
        },
        {
          id: "25176",
          name: "Askan Abu Nusayr",
          state_id: "1978",
        },
        {
          id: "25177",
          name: "Jawa",
          state_id: "1978",
        },
        {
          id: "25178",
          name: "Khalda wa Tila''-al-''Ali",
          state_id: "1978",
        },
        {
          id: "25179",
          name: "Khraybat As-Suq",
          state_id: "1978",
        },
        {
          id: "25180",
          name: "Marj al-Hammam",
          state_id: "1978",
        },
        {
          id: "25181",
          name: "Na''ur",
          state_id: "1978",
        },
        {
          id: "25182",
          name: "Nuzhat Sahab",
          state_id: "1978",
        },
        {
          id: "25183",
          name: "Sahab",
          state_id: "1978",
        },
        {
          id: "25184",
          name: "Shafa Badran",
          state_id: "1978",
        },
        {
          id: "25185",
          name: "Suwaylih",
          state_id: "1978",
        },
        {
          id: "25186",
          name: "Tariq",
          state_id: "1978",
        },
        {
          id: "25187",
          name: "Umm As-Summaq",
          state_id: "1978",
        },
        {
          id: "25188",
          name: "Umm Nuwarah",
          state_id: "1978",
        },
        {
          id: "25189",
          name: "Umm Qusayr wal Muqabalin",
          state_id: "1978",
        },
        {
          id: "25190",
          name: "Umm al-Basatin",
          state_id: "1978",
        },
        {
          id: "25191",
          name: "Wadi as-Sir",
          state_id: "1978",
        },
        {
          id: "25192",
          name: "al-''Abdaliyah",
          state_id: "1978",
        },
        {
          id: "25193",
          name: "al-Binayat",
          state_id: "1978",
        },
        {
          id: "25194",
          name: "al-Faysaliyah",
          state_id: "1978",
        },
        {
          id: "25195",
          name: "al-Jizah",
          state_id: "1978",
        },
        {
          id: "25196",
          name: "al-Jubayhah",
          state_id: "1978",
        },
        {
          id: "25197",
          name: "al-Juwaydah",
          state_id: "1978",
        },
        {
          id: "25198",
          name: "al-Quwaysimah",
          state_id: "1978",
        },
        {
          id: "25199",
          name: "al-Yadudah",
          state_id: "1978",
        },
        {
          id: "25200",
          name: "ar-Rawdah",
          state_id: "1978",
        },
        {
          id: "25201",
          name: "at-Talbiyah",
          state_id: "1978",
        },
        {
          id: "25202",
          name: "at-Taybah",
          state_id: "1978",
        },
      ],
      Irbid: [
        {
          id: "25203",
          name: "Al''al",
          state_id: "1979",
        },
        {
          id: "25204",
          name: "Anbah",
          state_id: "1979",
        },
        {
          id: "25205",
          name: "Arhaba",
          state_id: "1979",
        },
        {
          id: "25206",
          name: "Aydun",
          state_id: "1979",
        },
        {
          id: "25207",
          name: "Bayt Idas",
          state_id: "1979",
        },
        {
          id: "25208",
          name: "Bayt Ras",
          state_id: "1979",
        },
        {
          id: "25209",
          name: "Bayt Yafa",
          state_id: "1979",
        },
        {
          id: "25210",
          name: "Bushra",
          state_id: "1979",
        },
        {
          id: "25211",
          name: "Dayr Abi Sa''id",
          state_id: "1979",
        },
        {
          id: "25212",
          name: "Dayr Yusif",
          state_id: "1979",
        },
        {
          id: "25213",
          name: "Dayr as-Sa''anah",
          state_id: "1979",
        },
        {
          id: "25214",
          name: "Duwaqarah",
          state_id: "1979",
        },
        {
          id: "25215",
          name: "Hakama",
          state_id: "1979",
        },
        {
          id: "25216",
          name: "Hartha",
          state_id: "1979",
        },
        {
          id: "25217",
          name: "Hatam",
          state_id: "1979",
        },
        {
          id: "25218",
          name: "Hawwarah",
          state_id: "1979",
        },
        {
          id: "25219",
          name: "Irbid",
          state_id: "1979",
        },
        {
          id: "25220",
          name: "Jasar ash-Shaykh Hussayn",
          state_id: "1979",
        },
        {
          id: "25221",
          name: "Judayta",
          state_id: "1979",
        },
        {
          id: "25222",
          name: "Katam",
          state_id: "1979",
        },
        {
          id: "25223",
          name: "Kharja",
          state_id: "1979",
        },
        {
          id: "25224",
          name: "Kufur ''Awan",
          state_id: "1979",
        },
        {
          id: "25225",
          name: "Kufur Abil",
          state_id: "1979",
        },
        {
          id: "25226",
          name: "Kufur Asad",
          state_id: "1979",
        },
        {
          id: "25227",
          name: "Kufur Rakab",
          state_id: "1979",
        },
        {
          id: "25228",
          name: "Kufur Sum",
          state_id: "1979",
        },
        {
          id: "25229",
          name: "Kufur Yuba",
          state_id: "1979",
        },
        {
          id: "25230",
          name: "Kufur al-Ma",
          state_id: "1979",
        },
        {
          id: "25231",
          name: "Kuraymah",
          state_id: "1979",
        },
        {
          id: "25232",
          name: "Malka",
          state_id: "1979",
        },
        {
          id: "25233",
          name: "Mukhayyam al-Husun",
          state_id: "1979",
        },
        {
          id: "25234",
          name: "Qumaym",
          state_id: "1979",
        },
        {
          id: "25235",
          name: "Saham",
          state_id: "1979",
        },
        {
          id: "25236",
          name: "Sal",
          state_id: "1979",
        },
        {
          id: "25237",
          name: "Samma",
          state_id: "1979",
        },
        {
          id: "25238",
          name: "Sammaw",
          state_id: "1979",
        },
        {
          id: "25239",
          name: "Sum",
          state_id: "1979",
        },
        {
          id: "25240",
          name: "Tabnah",
          state_id: "1979",
        },
        {
          id: "25241",
          name: "Umm Qays",
          state_id: "1979",
        },
        {
          id: "25242",
          name: "Wadi al-Yabas",
          state_id: "1979",
        },
        {
          id: "25243",
          name: "Waqqas",
          state_id: "1979",
        },
        {
          id: "25244",
          name: "Zahar",
          state_id: "1979",
        },
        {
          id: "25245",
          name: "al-Ashrafiyah",
          state_id: "1979",
        },
        {
          id: "25246",
          name: "al-Balawnah",
          state_id: "1979",
        },
        {
          id: "25247",
          name: "al-Buwaydah",
          state_id: "1979",
        },
        {
          id: "25248",
          name: "al-Husun",
          state_id: "1979",
        },
        {
          id: "25249",
          name: "al-Manshiyah",
          state_id: "1979",
        },
        {
          id: "25250",
          name: "al-Mashari''a",
          state_id: "1979",
        },
        {
          id: "25251",
          name: "al-Mazar ash-Shamaliyah",
          state_id: "1979",
        },
        {
          id: "25252",
          name: "al-Mughayyar",
          state_id: "1979",
        },
        {
          id: "25253",
          name: "an-Nu''aymeh",
          state_id: "1979",
        },
        {
          id: "25254",
          name: "ar-Ramtha",
          state_id: "1979",
        },
        {
          id: "25255",
          name: "as-Sarih",
          state_id: "1979",
        },
        {
          id: "25256",
          name: "ash-Shajarah",
          state_id: "1979",
        },
        {
          id: "25257",
          name: "ash-Shunah ash-Shamaliyah",
          state_id: "1979",
        },
        {
          id: "25258",
          name: "at-Taybah",
          state_id: "1979",
        },
        {
          id: "25259",
          name: "at-Turrah",
          state_id: "1979",
        },
      ],
      Jarash: [
        {
          id: "25260",
          name: "Balila",
          state_id: "1980",
        },
        {
          id: "25261",
          name: "Burma",
          state_id: "1980",
        },
        {
          id: "25262",
          name: "Jarash",
          state_id: "1980",
        },
        {
          id: "25263",
          name: "Kufur Khall",
          state_id: "1980",
        },
        {
          id: "25264",
          name: "Mukhayyam Ghazzah",
          state_id: "1980",
        },
        {
          id: "25265",
          name: "Mukhayyam Suf",
          state_id: "1980",
        },
        {
          id: "25266",
          name: "Qafqafa",
          state_id: "1980",
        },
        {
          id: "25267",
          name: "Raymun",
          state_id: "1980",
        },
        {
          id: "25268",
          name: "Sakab",
          state_id: "1980",
        },
        {
          id: "25269",
          name: "Suf",
          state_id: "1980",
        },
        {
          id: "25270",
          name: "al-Kattah",
          state_id: "1980",
        },
      ],
      "Ma''an": [
        {
          id: "25271",
          name: "Bayar",
          state_id: "1981",
        },
        {
          id: "25272",
          name: "Ma''an",
          state_id: "1981",
        },
        {
          id: "25273",
          name: "Wadi Musa",
          state_id: "1981",
        },
        {
          id: "25274",
          name: "al-Hussayniyah",
          state_id: "1981",
        },
        {
          id: "25275",
          name: "al-Jafar",
          state_id: "1981",
        },
        {
          id: "25276",
          name: "at-Taybah",
          state_id: "1981",
        },
      ],
      Madaba: [
        {
          id: "25277",
          name: "Dhiban",
          state_id: "1982",
        },
        {
          id: "25278",
          name: "Ma''in",
          state_id: "1982",
        },
        {
          id: "25279",
          name: "Madaba",
          state_id: "1982",
        },
        {
          id: "25280",
          name: "Mulayh",
          state_id: "1982",
        },
        {
          id: "25281",
          name: "al-Faysaliyah",
          state_id: "1982",
        },
      ],
      "al-''Aqabah": [
        {
          id: "25282",
          name: "al-''Aqabah",
          state_id: "1983",
        },
        {
          id: "25283",
          name: "al-Quwayrah",
          state_id: "1983",
        },
      ],
      "al-Balqa": [
        {
          id: "25284",
          name: "Ayn al-Basha",
          state_id: "1984",
        },
        {
          id: "25285",
          name: "Darar",
          state_id: "1984",
        },
        {
          id: "25286",
          name: "Juwafat al-Kafrayn",
          state_id: "1984",
        },
        {
          id: "25287",
          name: "Ma''addi",
          state_id: "1984",
        },
        {
          id: "25288",
          name: "Mahas",
          state_id: "1984",
        },
        {
          id: "25289",
          name: "Safut",
          state_id: "1984",
        },
        {
          id: "25290",
          name: "Suknat ash-Shunah",
          state_id: "1984",
        },
        {
          id: "25291",
          name: "Yarqa",
          state_id: "1984",
        },
        {
          id: "25292",
          name: "al-Baq''ah",
          state_id: "1984",
        },
        {
          id: "25293",
          name: "al-Fuhays",
          state_id: "1984",
        },
        {
          id: "25294",
          name: "al-Karamah",
          state_id: "1984",
        },
        {
          id: "25295",
          name: "ar-Rawdah",
          state_id: "1984",
        },
        {
          id: "25296",
          name: "as-Salt",
          state_id: "1984",
        },
        {
          id: "25297",
          name: "as-Sawalhah",
          state_id: "1984",
        },
        {
          id: "25298",
          name: "as-Subayhi",
          state_id: "1984",
        },
        {
          id: "25299",
          name: "at-Tawal al-Janubi",
          state_id: "1984",
        },
        {
          id: "25300",
          name: "at-Tuwal ash-Shamali",
          state_id: "1984",
        },
      ],
      "al-Karak": [
        {
          id: "25301",
          name: "Ayy",
          state_id: "1985",
        },
        {
          id: "25302",
          name: "Adar",
          state_id: "1985",
        },
        {
          id: "25303",
          name: "Faqqu",
          state_id: "1985",
        },
        {
          id: "25304",
          name: "Ghawr al-Mazra''ah",
          state_id: "1985",
        },
        {
          id: "25305",
          name: "Ghawr as-Safi",
          state_id: "1985",
        },
        {
          id: "25306",
          name: "Maw''tah",
          state_id: "1985",
        },
        {
          id: "25307",
          name: "Sirfa",
          state_id: "1985",
        },
        {
          id: "25308",
          name: "al-Hussayniyah",
          state_id: "1985",
        },
        {
          id: "25309",
          name: "al-Karak",
          state_id: "1985",
        },
        {
          id: "25310",
          name: "al-Mazar",
          state_id: "1985",
        },
        {
          id: "25311",
          name: "al-Qasr",
          state_id: "1985",
        },
        {
          id: "25312",
          name: "al-Qitranah",
          state_id: "1985",
        },
        {
          id: "25313",
          name: "ar-Rabbah",
          state_id: "1985",
        },
        {
          id: "25314",
          name: "ash-Shahabiyah",
          state_id: "1985",
        },
        {
          id: "25315",
          name: "at-Taybah",
          state_id: "1985",
        },
      ],
      "al-Mafraq": [
        {
          id: "25316",
          name: "Badiyat ar-Ruwayshid",
          state_id: "1986",
        },
        {
          id: "25317",
          name: "Bal''ama",
          state_id: "1986",
        },
        {
          id: "25318",
          name: "Manshiyat Bani Hassan",
          state_id: "1986",
        },
        {
          id: "25319",
          name: "Mugayyar as-Sarhan",
          state_id: "1986",
        },
        {
          id: "25320",
          name: "Sabha",
          state_id: "1986",
        },
        {
          id: "25321",
          name: "Sama as-Sarhan",
          state_id: "1986",
        },
        {
          id: "25322",
          name: "Umm al-Quttayn",
          state_id: "1986",
        },
        {
          id: "25323",
          name: "al-Hamra",
          state_id: "1986",
        },
        {
          id: "25324",
          name: "al-Khaldiyah al-Jadidah",
          state_id: "1986",
        },
        {
          id: "25325",
          name: "al-Mabrukah",
          state_id: "1986",
        },
        {
          id: "25326",
          name: "al-Mafraq",
          state_id: "1986",
        },
        {
          id: "25327",
          name: "ar-Ruwayshid",
          state_id: "1986",
        },
        {
          id: "25328",
          name: "az-Za''tari",
          state_id: "1986",
        },
      ],
      "at-Tafilah": [
        {
          id: "25329",
          name: "Busayrah",
          state_id: "1987",
        },
        {
          id: "25330",
          name: "al-''Ayn al-Bayda",
          state_id: "1987",
        },
        {
          id: "25331",
          name: "al-Hasa",
          state_id: "1987",
        },
        {
          id: "25332",
          name: "al-Qadisiyah",
          state_id: "1987",
        },
        {
          id: "25333",
          name: "at-Tafilah",
          state_id: "1987",
        },
      ],
      "az-Zarqa": [
        {
          id: "25334",
          name: "Iskan al-Hashamiyah",
          state_id: "1988",
        },
        {
          id: "25335",
          name: "Mushayrfat Ras al-''Ayn",
          state_id: "1988",
        },
        {
          id: "25336",
          name: "Shnillar",
          state_id: "1988",
        },
        {
          id: "25337",
          name: "ad-Dulayl",
          state_id: "1988",
        },
        {
          id: "25338",
          name: "al-Azraq ash-Shamali",
          state_id: "1988",
        },
        {
          id: "25339",
          name: "al-Hashamiyah",
          state_id: "1988",
        },
        {
          id: "25340",
          name: "ar-Russayfah",
          state_id: "1988",
        },
        {
          id: "25341",
          name: "as-Sukhnah",
          state_id: "1988",
        },
        {
          id: "25342",
          name: "az-Zarqa",
          state_id: "1988",
        },
      ],
    },
  },
  JP: {
    name: "Japan",
    native: "日本",
    phone: "81",
    continent: "AS",
    capital: "Tokyo",
    currency: "JPY",
    languages: ["ja"],
    emoji: "🇯🇵",
    emojiU: "U+1F1EF U+1F1F5",
    states: {
      Aichi: [
        {
          id: "24112",
          name: "Agui",
          state_id: "1918",
        },
        {
          id: "24113",
          name: "Anjo",
          state_id: "1918",
        },
        {
          id: "24114",
          name: "Atsumi",
          state_id: "1918",
        },
        {
          id: "24115",
          name: "Bisai",
          state_id: "1918",
        },
        {
          id: "24116",
          name: "Chiryu",
          state_id: "1918",
        },
        {
          id: "24117",
          name: "Chita",
          state_id: "1918",
        },
        {
          id: "24118",
          name: "Fujioka",
          state_id: "1918",
        },
        {
          id: "24119",
          name: "Fuso",
          state_id: "1918",
        },
        {
          id: "24120",
          name: "Gamagori",
          state_id: "1918",
        },
        {
          id: "24121",
          name: "Handa",
          state_id: "1918",
        },
        {
          id: "24122",
          name: "Hekinan",
          state_id: "1918",
        },
        {
          id: "24123",
          name: "Higashiura",
          state_id: "1918",
        },
        {
          id: "24124",
          name: "Ichinomiya",
          state_id: "1918",
        },
        {
          id: "24125",
          name: "Inazawa",
          state_id: "1918",
        },
        {
          id: "24126",
          name: "Inuyama",
          state_id: "1918",
        },
        {
          id: "24127",
          name: "Isshiki",
          state_id: "1918",
        },
        {
          id: "24128",
          name: "Iwakura",
          state_id: "1918",
        },
        {
          id: "24129",
          name: "Jimokuji",
          state_id: "1918",
        },
        {
          id: "24130",
          name: "Kanie",
          state_id: "1918",
        },
        {
          id: "24131",
          name: "Kariya",
          state_id: "1918",
        },
        {
          id: "24132",
          name: "Kasugai",
          state_id: "1918",
        },
        {
          id: "24133",
          name: "Kira",
          state_id: "1918",
        },
        {
          id: "24134",
          name: "Kisogawa",
          state_id: "1918",
        },
        {
          id: "24135",
          name: "Komaki",
          state_id: "1918",
        },
        {
          id: "24136",
          name: "Konan",
          state_id: "1918",
        },
        {
          id: "24137",
          name: "Kota",
          state_id: "1918",
        },
        {
          id: "24138",
          name: "Kozakai",
          state_id: "1918",
        },
        {
          id: "24139",
          name: "Mihama",
          state_id: "1918",
        },
        {
          id: "24140",
          name: "Minamichita",
          state_id: "1918",
        },
        {
          id: "24141",
          name: "Miwa",
          state_id: "1918",
        },
        {
          id: "24142",
          name: "Miyoshi",
          state_id: "1918",
        },
        {
          id: "24143",
          name: "Nagakute",
          state_id: "1918",
        },
        {
          id: "24144",
          name: "Nagoya",
          state_id: "1918",
        },
        {
          id: "24145",
          name: "Nishiharu",
          state_id: "1918",
        },
        {
          id: "24146",
          name: "Nishio",
          state_id: "1918",
        },
        {
          id: "24147",
          name: "Nisshin",
          state_id: "1918",
        },
        {
          id: "24148",
          name: "Obu",
          state_id: "1918",
        },
        {
          id: "24149",
          name: "Oharu",
          state_id: "1918",
        },
        {
          id: "24150",
          name: "Okazaki",
          state_id: "1918",
        },
        {
          id: "24151",
          name: "Owariashi",
          state_id: "1918",
        },
        {
          id: "24152",
          name: "Saori",
          state_id: "1918",
        },
        {
          id: "24153",
          name: "Saya",
          state_id: "1918",
        },
        {
          id: "24154",
          name: "Seto",
          state_id: "1918",
        },
        {
          id: "24155",
          name: "Shikatsu",
          state_id: "1918",
        },
        {
          id: "24156",
          name: "Shinshiro",
          state_id: "1918",
        },
        {
          id: "24157",
          name: "Shippo",
          state_id: "1918",
        },
        {
          id: "24158",
          name: "Sobue",
          state_id: "1918",
        },
        {
          id: "24159",
          name: "Tahara",
          state_id: "1918",
        },
        {
          id: "24160",
          name: "Takahama",
          state_id: "1918",
        },
        {
          id: "24161",
          name: "Taketoyo",
          state_id: "1918",
        },
        {
          id: "24162",
          name: "Togo",
          state_id: "1918",
        },
        {
          id: "24163",
          name: "Tokai",
          state_id: "1918",
        },
        {
          id: "24164",
          name: "Tokoname",
          state_id: "1918",
        },
        {
          id: "24165",
          name: "Toyoake",
          state_id: "1918",
        },
        {
          id: "24166",
          name: "Toyohashi",
          state_id: "1918",
        },
        {
          id: "24167",
          name: "Toyokawa",
          state_id: "1918",
        },
        {
          id: "24168",
          name: "Toyota",
          state_id: "1918",
        },
        {
          id: "24169",
          name: "Tsushima",
          state_id: "1918",
        },
        {
          id: "24170",
          name: "Yatomi",
          state_id: "1918",
        },
      ],
      Akita: [
        {
          id: "24171",
          name: "Akita",
          state_id: "1919",
        },
        {
          id: "24172",
          name: "Honjo",
          state_id: "1919",
        },
        {
          id: "24173",
          name: "Kazuno",
          state_id: "1919",
        },
        {
          id: "24174",
          name: "Noshiro",
          state_id: "1919",
        },
        {
          id: "24175",
          name: "Odate",
          state_id: "1919",
        },
        {
          id: "24176",
          name: "Oga",
          state_id: "1919",
        },
        {
          id: "24177",
          name: "Omagari",
          state_id: "1919",
        },
        {
          id: "24178",
          name: "Takanosu",
          state_id: "1919",
        },
        {
          id: "24179",
          name: "Tenno",
          state_id: "1919",
        },
        {
          id: "24180",
          name: "Ugo",
          state_id: "1919",
        },
        {
          id: "24181",
          name: "Yokote",
          state_id: "1919",
        },
        {
          id: "24182",
          name: "Yuzawa",
          state_id: "1919",
        },
      ],
      Aomori: [
        {
          id: "24183",
          name: "Aomori",
          state_id: "1920",
        },
        {
          id: "24184",
          name: "Goshogawara",
          state_id: "1920",
        },
        {
          id: "24185",
          name: "Hachinohe",
          state_id: "1920",
        },
        {
          id: "24186",
          name: "Hiraka",
          state_id: "1920",
        },
        {
          id: "24187",
          name: "Hirosaki",
          state_id: "1920",
        },
        {
          id: "24188",
          name: "Kizukuri",
          state_id: "1920",
        },
        {
          id: "24189",
          name: "Kuroishi",
          state_id: "1920",
        },
        {
          id: "24190",
          name: "Misawa",
          state_id: "1920",
        },
        {
          id: "24191",
          name: "Mutsu",
          state_id: "1920",
        },
        {
          id: "24192",
          name: "Namioka",
          state_id: "1920",
        },
        {
          id: "24193",
          name: "Towada",
          state_id: "1920",
        },
      ],
      Chiba: [
        {
          id: "24194",
          name: "Abiko",
          state_id: "1921",
        },
        {
          id: "24195",
          name: "Asahi",
          state_id: "1921",
        },
        {
          id: "24196",
          name: "Chiba",
          state_id: "1921",
        },
        {
          id: "24197",
          name: "Choshi",
          state_id: "1921",
        },
        {
          id: "24198",
          name: "Funabashi",
          state_id: "1921",
        },
        {
          id: "24199",
          name: "Fussa",
          state_id: "1921",
        },
        {
          id: "24200",
          name: "Futtsu",
          state_id: "1921",
        },
        {
          id: "24201",
          name: "Ichihara",
          state_id: "1921",
        },
        {
          id: "24202",
          name: "Ichikawa",
          state_id: "1921",
        },
        {
          id: "24203",
          name: "Inzai",
          state_id: "1921",
        },
        {
          id: "24204",
          name: "Kamagaya",
          state_id: "1921",
        },
        {
          id: "24205",
          name: "Kamogawa",
          state_id: "1921",
        },
        {
          id: "24206",
          name: "Kashiwa",
          state_id: "1921",
        },
        {
          id: "24207",
          name: "Katsuura",
          state_id: "1921",
        },
        {
          id: "24208",
          name: "Kimitsu",
          state_id: "1921",
        },
        {
          id: "24209",
          name: "Kisarazu",
          state_id: "1921",
        },
        {
          id: "24210",
          name: "Kujukuri",
          state_id: "1921",
        },
        {
          id: "24211",
          name: "Matsudo",
          state_id: "1921",
        },
        {
          id: "24212",
          name: "Mobara",
          state_id: "1921",
        },
        {
          id: "24213",
          name: "Nagareyama",
          state_id: "1921",
        },
        {
          id: "24214",
          name: "Narashino",
          state_id: "1921",
        },
        {
          id: "24215",
          name: "Narita",
          state_id: "1921",
        },
        {
          id: "24216",
          name: "Naruto",
          state_id: "1921",
        },
        {
          id: "24217",
          name: "Noda",
          state_id: "1921",
        },
        {
          id: "24218",
          name: "Oamishirasato",
          state_id: "1921",
        },
        {
          id: "24219",
          name: "Ohara",
          state_id: "1921",
        },
        {
          id: "24220",
          name: "Omigawa",
          state_id: "1921",
        },
        {
          id: "24221",
          name: "Sakae",
          state_id: "1921",
        },
        {
          id: "24222",
          name: "Sakura",
          state_id: "1921",
        },
        {
          id: "24223",
          name: "Sambu",
          state_id: "1921",
        },
        {
          id: "24224",
          name: "Sawara",
          state_id: "1921",
        },
        {
          id: "24225",
          name: "Sekiyado",
          state_id: "1921",
        },
        {
          id: "24226",
          name: "Shiroi",
          state_id: "1921",
        },
        {
          id: "24227",
          name: "Shisui",
          state_id: "1921",
        },
        {
          id: "24228",
          name: "Shonan",
          state_id: "1921",
        },
        {
          id: "24229",
          name: "Sodegaura",
          state_id: "1921",
        },
        {
          id: "24230",
          name: "Tateyama",
          state_id: "1921",
        },
        {
          id: "24231",
          name: "Togane",
          state_id: "1921",
        },
        {
          id: "24232",
          name: "Tomisato",
          state_id: "1921",
        },
        {
          id: "24233",
          name: "Urayasu",
          state_id: "1921",
        },
        {
          id: "24234",
          name: "Yachimata",
          state_id: "1921",
        },
        {
          id: "24235",
          name: "Yachiyo",
          state_id: "1921",
        },
        {
          id: "24236",
          name: "Yokaichiba",
          state_id: "1921",
        },
        {
          id: "24237",
          name: "Yotsukaido",
          state_id: "1921",
        },
      ],
      Ehime: [
        {
          id: "24238",
          name: "Hojo",
          state_id: "1922",
        },
        {
          id: "24239",
          name: "Imabari",
          state_id: "1922",
        },
        {
          id: "24240",
          name: "Iyo",
          state_id: "1922",
        },
        {
          id: "24241",
          name: "Iyomishima",
          state_id: "1922",
        },
        {
          id: "24242",
          name: "Kawanoe",
          state_id: "1922",
        },
        {
          id: "24243",
          name: "Masaki",
          state_id: "1922",
        },
        {
          id: "24244",
          name: "Matsuyama",
          state_id: "1922",
        },
        {
          id: "24245",
          name: "Niihama",
          state_id: "1922",
        },
        {
          id: "24246",
          name: "Ozu",
          state_id: "1922",
        },
        {
          id: "24247",
          name: "Saijo",
          state_id: "1922",
        },
        {
          id: "24248",
          name: "Shigenobu",
          state_id: "1922",
        },
        {
          id: "24249",
          name: "Tobe",
          state_id: "1922",
        },
        {
          id: "24250",
          name: "Toyo",
          state_id: "1922",
        },
        {
          id: "24251",
          name: "Uwajima",
          state_id: "1922",
        },
        {
          id: "24252",
          name: "Yawatahama",
          state_id: "1922",
        },
      ],
      Fukui: [
        {
          id: "24253",
          name: "Fukui",
          state_id: "1923",
        },
        {
          id: "24254",
          name: "Harue",
          state_id: "1923",
        },
        {
          id: "24255",
          name: "Katsuyama",
          state_id: "1923",
        },
        {
          id: "24256",
          name: "Maruoka",
          state_id: "1923",
        },
        {
          id: "24257",
          name: "Mikuni",
          state_id: "1923",
        },
        {
          id: "24258",
          name: "Obama",
          state_id: "1923",
        },
        {
          id: "24259",
          name: "Ono",
          state_id: "1923",
        },
        {
          id: "24260",
          name: "Sabae",
          state_id: "1923",
        },
        {
          id: "24261",
          name: "Takefu",
          state_id: "1923",
        },
        {
          id: "24262",
          name: "Tsuruga",
          state_id: "1923",
        },
      ],
      Fukuoka: [
        {
          id: "24263",
          name: "Amagi",
          state_id: "1924",
        },
        {
          id: "24264",
          name: "Buzen",
          state_id: "1924",
        },
        {
          id: "24265",
          name: "Chikugo",
          state_id: "1924",
        },
        {
          id: "24266",
          name: "Chikushino",
          state_id: "1924",
        },
        {
          id: "24267",
          name: "Dazaifu",
          state_id: "1924",
        },
        {
          id: "24268",
          name: "Fukuma",
          state_id: "1924",
        },
        {
          id: "24269",
          name: "Fukuoka",
          state_id: "1924",
        },
        {
          id: "24270",
          name: "Hirokawa",
          state_id: "1924",
        },
        {
          id: "24271",
          name: "Honami",
          state_id: "1924",
        },
        {
          id: "24272",
          name: "Iizuka",
          state_id: "1924",
        },
        {
          id: "24273",
          name: "Inatsuki",
          state_id: "1924",
        },
        {
          id: "24274",
          name: "Kanda",
          state_id: "1924",
        },
        {
          id: "24275",
          name: "Kasuga",
          state_id: "1924",
        },
        {
          id: "24276",
          name: "Kasuya",
          state_id: "1924",
        },
        {
          id: "24277",
          name: "Kawasaki",
          state_id: "1924",
        },
        {
          id: "24278",
          name: "Kitakyushu",
          state_id: "1924",
        },
        {
          id: "24279",
          name: "Koga",
          state_id: "1924",
        },
        {
          id: "24280",
          name: "Kurate",
          state_id: "1924",
        },
        {
          id: "24281",
          name: "Kurume",
          state_id: "1924",
        },
        {
          id: "24282",
          name: "Maebaru",
          state_id: "1924",
        },
        {
          id: "24283",
          name: "Miyata",
          state_id: "1924",
        },
        {
          id: "24284",
          name: "Mizumaki",
          state_id: "1924",
        },
        {
          id: "24285",
          name: "Munakata",
          state_id: "1924",
        },
        {
          id: "24286",
          name: "Nakagawa",
          state_id: "1924",
        },
        {
          id: "24287",
          name: "Nakama",
          state_id: "1924",
        },
        {
          id: "24288",
          name: "Nogata",
          state_id: "1924",
        },
        {
          id: "24289",
          name: "Ogori",
          state_id: "1924",
        },
        {
          id: "24290",
          name: "Okagaki",
          state_id: "1924",
        },
        {
          id: "24291",
          name: "Okawa",
          state_id: "1924",
        },
        {
          id: "24292",
          name: "Omuta",
          state_id: "1924",
        },
        {
          id: "24293",
          name: "Onojo",
          state_id: "1924",
        },
        {
          id: "24294",
          name: "Sasaguri",
          state_id: "1924",
        },
        {
          id: "24295",
          name: "Setaka",
          state_id: "1924",
        },
        {
          id: "24296",
          name: "Shime",
          state_id: "1924",
        },
        {
          id: "24297",
          name: "Shingu",
          state_id: "1924",
        },
        {
          id: "24298",
          name: "Sue",
          state_id: "1924",
        },
        {
          id: "24299",
          name: "Tagawa",
          state_id: "1924",
        },
        {
          id: "24300",
          name: "Tanushimaru",
          state_id: "1924",
        },
        {
          id: "24301",
          name: "Umi",
          state_id: "1924",
        },
        {
          id: "24302",
          name: "Yamada",
          state_id: "1924",
        },
        {
          id: "24303",
          name: "Yame",
          state_id: "1924",
        },
        {
          id: "24304",
          name: "Yanagawa",
          state_id: "1924",
        },
        {
          id: "24305",
          name: "Yukuhashi",
          state_id: "1924",
        },
      ],
      Fukushima: [
        {
          id: "24306",
          name: "Aizubange",
          state_id: "1925",
        },
        {
          id: "24307",
          name: "Aizuwakamatsu",
          state_id: "1925",
        },
        {
          id: "24308",
          name: "Fukushima",
          state_id: "1925",
        },
        {
          id: "24309",
          name: "Funehiki",
          state_id: "1925",
        },
        {
          id: "24310",
          name: "Haramachi",
          state_id: "1925",
        },
        {
          id: "24311",
          name: "Hobara",
          state_id: "1925",
        },
        {
          id: "24312",
          name: "Inawashiro",
          state_id: "1925",
        },
        {
          id: "24313",
          name: "Ishikawa",
          state_id: "1925",
        },
        {
          id: "24314",
          name: "Iwaki",
          state_id: "1925",
        },
        {
          id: "24315",
          name: "Kawamata",
          state_id: "1925",
        },
        {
          id: "24316",
          name: "Kitakata",
          state_id: "1925",
        },
        {
          id: "24317",
          name: "Koriyama",
          state_id: "1925",
        },
        {
          id: "24318",
          name: "Miharu",
          state_id: "1925",
        },
        {
          id: "24319",
          name: "Motomiya",
          state_id: "1925",
        },
        {
          id: "24320",
          name: "Namie",
          state_id: "1925",
        },
        {
          id: "24321",
          name: "Nihommatsu",
          state_id: "1925",
        },
        {
          id: "24322",
          name: "Shirakawa",
          state_id: "1925",
        },
        {
          id: "24323",
          name: "Soma",
          state_id: "1925",
        },
        {
          id: "24324",
          name: "Sukagawa",
          state_id: "1925",
        },
        {
          id: "24325",
          name: "Yanagawa",
          state_id: "1925",
        },
      ],
      Gifu: [
        {
          id: "24326",
          name: "Ena",
          state_id: "1926",
        },
        {
          id: "24327",
          name: "Gifu",
          state_id: "1926",
        },
        {
          id: "24328",
          name: "Ginan",
          state_id: "1926",
        },
        {
          id: "24329",
          name: "Godo",
          state_id: "1926",
        },
        {
          id: "24330",
          name: "Hashima",
          state_id: "1926",
        },
        {
          id: "24331",
          name: "Hozumi",
          state_id: "1926",
        },
        {
          id: "24332",
          name: "Ibigawa",
          state_id: "1926",
        },
        {
          id: "24333",
          name: "Ikeda",
          state_id: "1926",
        },
        {
          id: "24334",
          name: "Kakamigahara",
          state_id: "1926",
        },
        {
          id: "24335",
          name: "Kani",
          state_id: "1926",
        },
        {
          id: "24336",
          name: "Kasamatsu",
          state_id: "1926",
        },
        {
          id: "24337",
          name: "Mino",
          state_id: "1926",
        },
        {
          id: "24338",
          name: "Minokamo",
          state_id: "1926",
        },
        {
          id: "24339",
          name: "Mitake",
          state_id: "1926",
        },
        {
          id: "24340",
          name: "Mizunami",
          state_id: "1926",
        },
        {
          id: "24341",
          name: "Nakatsugawa",
          state_id: "1926",
        },
        {
          id: "24342",
          name: "Ogaki",
          state_id: "1926",
        },
        {
          id: "24343",
          name: "Ono",
          state_id: "1926",
        },
        {
          id: "24344",
          name: "Seki",
          state_id: "1926",
        },
        {
          id: "24345",
          name: "Tajimi",
          state_id: "1926",
        },
        {
          id: "24346",
          name: "Takayama",
          state_id: "1926",
        },
        {
          id: "24347",
          name: "Tarui",
          state_id: "1926",
        },
        {
          id: "24348",
          name: "Toki",
          state_id: "1926",
        },
        {
          id: "24349",
          name: "Yoro",
          state_id: "1926",
        },
      ],
      Gumma: [
        {
          id: "24350",
          name: "Annaka",
          state_id: "1927",
        },
        {
          id: "24351",
          name: "Azuma",
          state_id: "1927",
        },
        {
          id: "24352",
          name: "Fujimi",
          state_id: "1927",
        },
        {
          id: "24353",
          name: "Fujioka",
          state_id: "1927",
        },
        {
          id: "24354",
          name: "Gumma",
          state_id: "1927",
        },
        {
          id: "24355",
          name: "Haruna",
          state_id: "1927",
        },
        {
          id: "24356",
          name: "Isesaki",
          state_id: "1927",
        },
        {
          id: "24357",
          name: "Kasakake",
          state_id: "1927",
        },
        {
          id: "24358",
          name: "Kiryu",
          state_id: "1927",
        },
        {
          id: "24359",
          name: "Maebashi",
          state_id: "1927",
        },
        {
          id: "24360",
          name: "Nakanojo",
          state_id: "1927",
        },
        {
          id: "24361",
          name: "Nitta",
          state_id: "1927",
        },
        {
          id: "24362",
          name: "Numata",
          state_id: "1927",
        },
        {
          id: "24363",
          name: "Oizumi",
          state_id: "1927",
        },
        {
          id: "24364",
          name: "Omama",
          state_id: "1927",
        },
        {
          id: "24365",
          name: "Ora",
          state_id: "1927",
        },
        {
          id: "24366",
          name: "Ota",
          state_id: "1927",
        },
        {
          id: "24367",
          name: "Sakai",
          state_id: "1927",
        },
        {
          id: "24368",
          name: "Shibukawa",
          state_id: "1927",
        },
        {
          id: "24369",
          name: "Takasaki",
          state_id: "1927",
        },
        {
          id: "24370",
          name: "Tamamura",
          state_id: "1927",
        },
        {
          id: "24371",
          name: "Tatebayashi",
          state_id: "1927",
        },
        {
          id: "24372",
          name: "Tomioka",
          state_id: "1927",
        },
        {
          id: "24373",
          name: "Yoshii",
          state_id: "1927",
        },
      ],
      Hiroshima: [
        {
          id: "24374",
          name: "Fuchu",
          state_id: "1928",
        },
        {
          id: "24375",
          name: "Fukuyama",
          state_id: "1928",
        },
        {
          id: "24376",
          name: "Hatsukaichi",
          state_id: "1928",
        },
        {
          id: "24377",
          name: "Higashihiroshima",
          state_id: "1928",
        },
        {
          id: "24378",
          name: "Hiroshima",
          state_id: "1928",
        },
        {
          id: "24379",
          name: "Innoshima",
          state_id: "1928",
        },
        {
          id: "24380",
          name: "Kaita",
          state_id: "1928",
        },
        {
          id: "24381",
          name: "Kannabe",
          state_id: "1928",
        },
        {
          id: "24382",
          name: "Kumano",
          state_id: "1928",
        },
        {
          id: "24383",
          name: "Kure",
          state_id: "1928",
        },
        {
          id: "24384",
          name: "Kurose",
          state_id: "1928",
        },
        {
          id: "24385",
          name: "Mihara",
          state_id: "1928",
        },
        {
          id: "24386",
          name: "Miyoshi",
          state_id: "1928",
        },
        {
          id: "24387",
          name: "Ono",
          state_id: "1928",
        },
        {
          id: "24388",
          name: "Onomichi",
          state_id: "1928",
        },
        {
          id: "24389",
          name: "Otake",
          state_id: "1928",
        },
        {
          id: "24390",
          name: "Shinichi",
          state_id: "1928",
        },
        {
          id: "24391",
          name: "Shobara",
          state_id: "1928",
        },
        {
          id: "24392",
          name: "Takehara",
          state_id: "1928",
        },
      ],
      Hokkaido: [
        {
          id: "24393",
          name: "Abashiri",
          state_id: "1929",
        },
        {
          id: "24394",
          name: "Akabira",
          state_id: "1929",
        },
        {
          id: "24395",
          name: "Asahikawa",
          state_id: "1929",
        },
        {
          id: "24396",
          name: "Ashibetsu",
          state_id: "1929",
        },
        {
          id: "24397",
          name: "Bibai",
          state_id: "1929",
        },
        {
          id: "24398",
          name: "Bihoro",
          state_id: "1929",
        },
        {
          id: "24399",
          name: "Chitose",
          state_id: "1929",
        },
        {
          id: "24400",
          name: "Date",
          state_id: "1929",
        },
        {
          id: "24401",
          name: "Ebetsu",
          state_id: "1929",
        },
        {
          id: "24402",
          name: "Eniwa",
          state_id: "1929",
        },
        {
          id: "24403",
          name: "Fukagawa",
          state_id: "1929",
        },
        {
          id: "24404",
          name: "Furano",
          state_id: "1929",
        },
        {
          id: "24405",
          name: "Hakodate",
          state_id: "1929",
        },
        {
          id: "24406",
          name: "Hokkaido",
          state_id: "1929",
        },
        {
          id: "24407",
          name: "Hyogo",
          state_id: "1929",
        },
        {
          id: "24408",
          name: "Ishikari",
          state_id: "1929",
        },
        {
          id: "24409",
          name: "Iwamizawa",
          state_id: "1929",
        },
        {
          id: "24410",
          name: "Iwanai",
          state_id: "1929",
        },
        {
          id: "24411",
          name: "Kamiiso",
          state_id: "1929",
        },
        {
          id: "24412",
          name: "Kitahiroshima",
          state_id: "1929",
        },
        {
          id: "24413",
          name: "Kitami",
          state_id: "1929",
        },
        {
          id: "24414",
          name: "Kushiro",
          state_id: "1929",
        },
        {
          id: "24415",
          name: "Makubetsu",
          state_id: "1929",
        },
        {
          id: "24416",
          name: "Mikasa",
          state_id: "1929",
        },
        {
          id: "24417",
          name: "Mombetsu",
          state_id: "1929",
        },
        {
          id: "24418",
          name: "Muroran",
          state_id: "1929",
        },
        {
          id: "24419",
          name: "Nakashibetsu",
          state_id: "1929",
        },
        {
          id: "24420",
          name: "Nanae",
          state_id: "1929",
        },
        {
          id: "24421",
          name: "Nayoro",
          state_id: "1929",
        },
        {
          id: "24422",
          name: "Nemuro",
          state_id: "1929",
        },
        {
          id: "24423",
          name: "Noboribetsu",
          state_id: "1929",
        },
        {
          id: "24424",
          name: "Obihiro",
          state_id: "1929",
        },
        {
          id: "24425",
          name: "Otaru",
          state_id: "1929",
        },
        {
          id: "24426",
          name: "Otofuke",
          state_id: "1929",
        },
        {
          id: "24427",
          name: "Rumoi",
          state_id: "1929",
        },
        {
          id: "24428",
          name: "Sapporo",
          state_id: "1929",
        },
        {
          id: "24429",
          name: "Shibetsu",
          state_id: "1929",
        },
        {
          id: "24430",
          name: "Shiraoi",
          state_id: "1929",
        },
        {
          id: "24431",
          name: "Shizunai",
          state_id: "1929",
        },
        {
          id: "24432",
          name: "Sunagawa",
          state_id: "1929",
        },
        {
          id: "24433",
          name: "Takikawa",
          state_id: "1929",
        },
        {
          id: "24434",
          name: "Tobetsu",
          state_id: "1929",
        },
        {
          id: "24435",
          name: "Tomakomai",
          state_id: "1929",
        },
        {
          id: "24436",
          name: "Utashinai",
          state_id: "1929",
        },
        {
          id: "24437",
          name: "Wakkanai",
          state_id: "1929",
        },
        {
          id: "24438",
          name: "Yoichi",
          state_id: "1929",
        },
        {
          id: "24439",
          name: "Yubari",
          state_id: "1929",
        },
      ],
      Hyogo: [
        {
          id: "24440",
          name: "Aioi",
          state_id: "1930",
        },
        {
          id: "24441",
          name: "Akashi",
          state_id: "1930",
        },
        {
          id: "24442",
          name: "Ako",
          state_id: "1930",
        },
        {
          id: "24443",
          name: "Amagasaki",
          state_id: "1930",
        },
        {
          id: "24444",
          name: "Ashiya",
          state_id: "1930",
        },
        {
          id: "24445",
          name: "Fukusaki",
          state_id: "1930",
        },
        {
          id: "24446",
          name: "Harima",
          state_id: "1930",
        },
        {
          id: "24447",
          name: "Himeji",
          state_id: "1930",
        },
        {
          id: "24448",
          name: "Inagawa",
          state_id: "1930",
        },
        {
          id: "24449",
          name: "Inami",
          state_id: "1930",
        },
        {
          id: "24450",
          name: "Itami",
          state_id: "1930",
        },
        {
          id: "24451",
          name: "Kakogawa",
          state_id: "1930",
        },
        {
          id: "24452",
          name: "Kasai",
          state_id: "1930",
        },
        {
          id: "24453",
          name: "Kawanishi",
          state_id: "1930",
        },
        {
          id: "24454",
          name: "Kobe",
          state_id: "1930",
        },
        {
          id: "24455",
          name: "Kodera",
          state_id: "1930",
        },
        {
          id: "24456",
          name: "Miki",
          state_id: "1930",
        },
        {
          id: "24457",
          name: "Nandan",
          state_id: "1930",
        },
        {
          id: "24458",
          name: "Nishinomiya",
          state_id: "1930",
        },
        {
          id: "24459",
          name: "Nishiwaki",
          state_id: "1930",
        },
        {
          id: "24460",
          name: "Ono",
          state_id: "1930",
        },
        {
          id: "24461",
          name: "Sanda",
          state_id: "1930",
        },
        {
          id: "24463",
          name: "Sumoto",
          state_id: "1930",
        },
        {
          id: "24464",
          name: "Taishi",
          state_id: "1930",
        },
        {
          id: "24465",
          name: "Takarazuka",
          state_id: "1930",
        },
        {
          id: "24466",
          name: "Takasago",
          state_id: "1930",
        },
        {
          id: "24467",
          name: "Tatsuno",
          state_id: "1930",
        },
        {
          id: "24468",
          name: "Toyooka",
          state_id: "1930",
        },
        {
          id: "24469",
          name: "Yamasaki",
          state_id: "1930",
        },
        {
          id: "24470",
          name: "Yashiro",
          state_id: "1930",
        },
        {
          id: "24471",
          name: "Yumesaki",
          state_id: "1930",
        },
      ],
      Ibaraki: [
        {
          id: "24472",
          name: "Ami",
          state_id: "1931",
        },
        {
          id: "24473",
          name: "Chiyoda",
          state_id: "1931",
        },
        {
          id: "24474",
          name: "Daigo",
          state_id: "1931",
        },
        {
          id: "24475",
          name: "Edosaki",
          state_id: "1931",
        },
        {
          id: "24476",
          name: "Fujishiro",
          state_id: "1931",
        },
        {
          id: "24477",
          name: "Hasaki",
          state_id: "1931",
        },
        {
          id: "24478",
          name: "Hitachi",
          state_id: "1931",
        },
        {
          id: "24479",
          name: "Hitachinaka",
          state_id: "1931",
        },
        {
          id: "24480",
          name: "Hitachiota",
          state_id: "1931",
        },
        {
          id: "24481",
          name: "Hokota",
          state_id: "1931",
        },
        {
          id: "24482",
          name: "Ibaraki",
          state_id: "1931",
        },
        {
          id: "24483",
          name: "Ina",
          state_id: "1931",
        },
        {
          id: "24484",
          name: "Ishige",
          state_id: "1931",
        },
        {
          id: "24485",
          name: "Ishioka",
          state_id: "1931",
        },
        {
          id: "24486",
          name: "Itako",
          state_id: "1931",
        },
        {
          id: "24487",
          name: "Iwai",
          state_id: "1931",
        },
        {
          id: "24488",
          name: "Iwase",
          state_id: "1931",
        },
        {
          id: "24489",
          name: "Kamisu",
          state_id: "1931",
        },
        {
          id: "24490",
          name: "Kasama",
          state_id: "1931",
        },
        {
          id: "24491",
          name: "Kashima",
          state_id: "1931",
        },
        {
          id: "24492",
          name: "Kasumigaura",
          state_id: "1931",
        },
        {
          id: "24493",
          name: "Kitaibaraki",
          state_id: "1931",
        },
        {
          id: "24494",
          name: "Koga",
          state_id: "1931",
        },
        {
          id: "24495",
          name: "Kukizaki",
          state_id: "1931",
        },
        {
          id: "24496",
          name: "Makabe",
          state_id: "1931",
        },
        {
          id: "24497",
          name: "Minori",
          state_id: "1931",
        },
        {
          id: "24498",
          name: "Mito",
          state_id: "1931",
        },
        {
          id: "24499",
          name: "Mitsukaido",
          state_id: "1931",
        },
        {
          id: "24500",
          name: "Moriya",
          state_id: "1931",
        },
        {
          id: "24501",
          name: "Naka",
          state_id: "1931",
        },
        {
          id: "24502",
          name: "Oarai",
          state_id: "1931",
        },
        {
          id: "24503",
          name: "Omiya",
          state_id: "1931",
        },
        {
          id: "24504",
          name: "Ryugasaki",
          state_id: "1931",
        },
        {
          id: "24505",
          name: "Sakai",
          state_id: "1931",
        },
        {
          id: "24506",
          name: "Sanwa",
          state_id: "1931",
        },
        {
          id: "24507",
          name: "Shimodate",
          state_id: "1931",
        },
        {
          id: "24508",
          name: "Shimotsuma",
          state_id: "1931",
        },
        {
          id: "24509",
          name: "Sowa",
          state_id: "1931",
        },
        {
          id: "24510",
          name: "Takahagi",
          state_id: "1931",
        },
        {
          id: "24511",
          name: "Tokai",
          state_id: "1931",
        },
        {
          id: "24512",
          name: "Tomobe",
          state_id: "1931",
        },
        {
          id: "24513",
          name: "Tone",
          state_id: "1931",
        },
        {
          id: "24514",
          name: "Toride",
          state_id: "1931",
        },
        {
          id: "24515",
          name: "Tsukuba",
          state_id: "1931",
        },
        {
          id: "24516",
          name: "Ushiku",
          state_id: "1931",
        },
        {
          id: "24517",
          name: "Yachiyo",
          state_id: "1931",
        },
        {
          id: "24518",
          name: "Yasato",
          state_id: "1931",
        },
        {
          id: "24519",
          name: "Yuki",
          state_id: "1931",
        },
      ],
      Ishikawa: [
        {
          id: "24520",
          name: "Hakui",
          state_id: "1932",
        },
        {
          id: "24521",
          name: "Kaga",
          state_id: "1932",
        },
        {
          id: "24522",
          name: "Kanazawa",
          state_id: "1932",
        },
        {
          id: "24523",
          name: "Komatsu",
          state_id: "1932",
        },
        {
          id: "24524",
          name: "Matto",
          state_id: "1932",
        },
        {
          id: "24525",
          name: "Nanao",
          state_id: "1932",
        },
        {
          id: "24526",
          name: "Nonoichi",
          state_id: "1932",
        },
        {
          id: "24527",
          name: "Suzu",
          state_id: "1932",
        },
        {
          id: "24528",
          name: "Tsubata",
          state_id: "1932",
        },
        {
          id: "24529",
          name: "Tsurugi",
          state_id: "1932",
        },
        {
          id: "24530",
          name: "Uchinada",
          state_id: "1932",
        },
        {
          id: "24531",
          name: "Wajima",
          state_id: "1932",
        },
      ],
      Iwate: [
        {
          id: "24532",
          name: "Daito",
          state_id: "1933",
        },
        {
          id: "24533",
          name: "Esashi",
          state_id: "1933",
        },
        {
          id: "24534",
          name: "Hanamaki",
          state_id: "1933",
        },
        {
          id: "24535",
          name: "Ichinohe",
          state_id: "1933",
        },
        {
          id: "24536",
          name: "Ichinoseki",
          state_id: "1933",
        },
        {
          id: "24537",
          name: "Iwate",
          state_id: "1933",
        },
        {
          id: "24538",
          name: "Kamaishi",
          state_id: "1933",
        },
        {
          id: "24539",
          name: "Kitakami",
          state_id: "1933",
        },
        {
          id: "24540",
          name: "Kuji",
          state_id: "1933",
        },
        {
          id: "24541",
          name: "Miyako",
          state_id: "1933",
        },
        {
          id: "24542",
          name: "Mizusawa",
          state_id: "1933",
        },
        {
          id: "24543",
          name: "Morioka",
          state_id: "1933",
        },
        {
          id: "24544",
          name: "Ninohe",
          state_id: "1933",
        },
        {
          id: "24545",
          name: "Ofunato",
          state_id: "1933",
        },
        {
          id: "24546",
          name: "Otsuchi",
          state_id: "1933",
        },
        {
          id: "24547",
          name: "Rikuzentakata",
          state_id: "1933",
        },
        {
          id: "24548",
          name: "Shiwa",
          state_id: "1933",
        },
        {
          id: "24549",
          name: "Shizukuishi",
          state_id: "1933",
        },
        {
          id: "24550",
          name: "Takizawa",
          state_id: "1933",
        },
        {
          id: "24551",
          name: "Tono",
          state_id: "1933",
        },
        {
          id: "24552",
          name: "Yahaba",
          state_id: "1933",
        },
        {
          id: "24553",
          name: "Yamada",
          state_id: "1933",
        },
      ],
      Kagawa: [
        {
          id: "24554",
          name: "Kagawa",
          state_id: "1934",
        },
        {
          id: "24555",
          name: "Kanonji",
          state_id: "1934",
        },
        {
          id: "24556",
          name: "Kokubunji",
          state_id: "1934",
        },
        {
          id: "24557",
          name: "Marugame",
          state_id: "1934",
        },
        {
          id: "24558",
          name: "Miki",
          state_id: "1934",
        },
        {
          id: "24559",
          name: "Ryonan",
          state_id: "1934",
        },
        {
          id: "24560",
          name: "Sakaide",
          state_id: "1934",
        },
        {
          id: "24561",
          name: "Shido",
          state_id: "1934",
        },
        {
          id: "24562",
          name: "Tadotsu",
          state_id: "1934",
        },
        {
          id: "24563",
          name: "Takamatsu",
          state_id: "1934",
        },
        {
          id: "24564",
          name: "Tonosho",
          state_id: "1934",
        },
        {
          id: "24565",
          name: "Zentsuji",
          state_id: "1934",
        },
      ],
      Kagoshima: [
        {
          id: "24566",
          name: "Aira",
          state_id: "1935",
        },
        {
          id: "24567",
          name: "Akune",
          state_id: "1935",
        },
        {
          id: "24568",
          name: "Hayato",
          state_id: "1935",
        },
        {
          id: "24569",
          name: "Ibusuki",
          state_id: "1935",
        },
        {
          id: "24570",
          name: "Ijuin",
          state_id: "1935",
        },
        {
          id: "24571",
          name: "Izumi",
          state_id: "1935",
        },
        {
          id: "24572",
          name: "Kagoshima",
          state_id: "1935",
        },
        {
          id: "24573",
          name: "Kajiki",
          state_id: "1935",
        },
        {
          id: "24574",
          name: "Kanoya",
          state_id: "1935",
        },
        {
          id: "24575",
          name: "Kaseda",
          state_id: "1935",
        },
        {
          id: "24576",
          name: "Kokubu",
          state_id: "1935",
        },
        {
          id: "24577",
          name: "Kushikino",
          state_id: "1935",
        },
        {
          id: "24578",
          name: "Makurazaki",
          state_id: "1935",
        },
        {
          id: "24579",
          name: "Naze",
          state_id: "1935",
        },
        {
          id: "24580",
          name: "Nishinoomote",
          state_id: "1935",
        },
        {
          id: "24581",
          name: "Okuchi",
          state_id: "1935",
        },
        {
          id: "24582",
          name: "Sendai",
          state_id: "1935",
        },
        {
          id: "24583",
          name: "Shibushi",
          state_id: "1935",
        },
        {
          id: "24584",
          name: "Sueyoshi",
          state_id: "1935",
        },
        {
          id: "24585",
          name: "Tarumizu",
          state_id: "1935",
        },
      ],
      Kanagawa: [
        {
          id: "24586",
          name: "Aikawa",
          state_id: "1936",
        },
        {
          id: "24587",
          name: "Atsugi",
          state_id: "1936",
        },
        {
          id: "24588",
          name: "Ayase",
          state_id: "1936",
        },
        {
          id: "24589",
          name: "Chigasaki",
          state_id: "1936",
        },
        {
          id: "24590",
          name: "Ebina",
          state_id: "1936",
        },
        {
          id: "24591",
          name: "Fujisawa",
          state_id: "1936",
        },
        {
          id: "24592",
          name: "Hadano",
          state_id: "1936",
        },
        {
          id: "24593",
          name: "Hakone",
          state_id: "1936",
        },
        {
          id: "24594",
          name: "Hayama",
          state_id: "1936",
        },
        {
          id: "24595",
          name: "Hiratsuka",
          state_id: "1936",
        },
        {
          id: "24596",
          name: "Isehara",
          state_id: "1936",
        },
        {
          id: "24597",
          name: "Kamakura",
          state_id: "1936",
        },
        {
          id: "24598",
          name: "Kawasaki",
          state_id: "1936",
        },
        {
          id: "24599",
          name: "Minamiashigara",
          state_id: "1936",
        },
        {
          id: "24600",
          name: "Miura",
          state_id: "1936",
        },
        {
          id: "24601",
          name: "Ninomiya",
          state_id: "1936",
        },
        {
          id: "24602",
          name: "Odawara",
          state_id: "1936",
        },
        {
          id: "24603",
          name: "Oiso",
          state_id: "1936",
        },
        {
          id: "24604",
          name: "Sagamihara",
          state_id: "1936",
        },
        {
          id: "24605",
          name: "Samukawa",
          state_id: "1936",
        },
        {
          id: "24606",
          name: "Shiroyama",
          state_id: "1936",
        },
        {
          id: "24607",
          name: "Takatsu-Ku",
          state_id: "1936",
        },
        {
          id: "24608",
          name: "Tsukui",
          state_id: "1936",
        },
        {
          id: "24609",
          name: "Yamato",
          state_id: "1936",
        },
        {
          id: "24610",
          name: "Yokohama",
          state_id: "1936",
        },
        {
          id: "24611",
          name: "Yokosuka",
          state_id: "1936",
        },
        {
          id: "24612",
          name: "Yugawara",
          state_id: "1936",
        },
        {
          id: "24613",
          name: "Zama",
          state_id: "1936",
        },
        {
          id: "24614",
          name: "Zushi",
          state_id: "1936",
        },
      ],
      Kanto: [
        {
          id: "24615",
          name: "Gunma",
          state_id: "1937",
        },
        {
          id: "24616",
          name: "Saitama",
          state_id: "1937",
        },
      ],
      Kochi: [
        {
          id: "24617",
          name: "Aki",
          state_id: "1938",
        },
        {
          id: "24618",
          name: "Ino",
          state_id: "1938",
        },
        {
          id: "24619",
          name: "Kochi",
          state_id: "1938",
        },
        {
          id: "24620",
          name: "Muroto",
          state_id: "1938",
        },
        {
          id: "24621",
          name: "Nakamura",
          state_id: "1938",
        },
        {
          id: "24622",
          name: "Nankoku",
          state_id: "1938",
        },
        {
          id: "24623",
          name: "Sukumo",
          state_id: "1938",
        },
        {
          id: "24624",
          name: "Susaki",
          state_id: "1938",
        },
        {
          id: "24625",
          name: "Tosa",
          state_id: "1938",
        },
        {
          id: "24626",
          name: "Tosashimizu",
          state_id: "1938",
        },
        {
          id: "24627",
          name: "Tosayamada",
          state_id: "1938",
        },
      ],
      Kumamoto: [
        {
          id: "24628",
          name: "Arao",
          state_id: "1939",
        },
        {
          id: "24629",
          name: "Ashikita",
          state_id: "1939",
        },
        {
          id: "24630",
          name: "Aso",
          state_id: "1939",
        },
        {
          id: "24631",
          name: "Hitoyoshi",
          state_id: "1939",
        },
        {
          id: "24632",
          name: "Hondo",
          state_id: "1939",
        },
        {
          id: "24633",
          name: "Jonan",
          state_id: "1939",
        },
        {
          id: "24634",
          name: "Kikuchi",
          state_id: "1939",
        },
        {
          id: "24635",
          name: "Kikuyo",
          state_id: "1939",
        },
        {
          id: "24636",
          name: "Koshi",
          state_id: "1939",
        },
        {
          id: "24637",
          name: "Kumamoto",
          state_id: "1939",
        },
        {
          id: "24638",
          name: "Mashiki",
          state_id: "1939",
        },
        {
          id: "24639",
          name: "Matsubase",
          state_id: "1939",
        },
        {
          id: "24640",
          name: "Minamata",
          state_id: "1939",
        },
        {
          id: "24641",
          name: "Nishigoshi",
          state_id: "1939",
        },
        {
          id: "24642",
          name: "Ozu",
          state_id: "1939",
        },
        {
          id: "24643",
          name: "Tamana",
          state_id: "1939",
        },
        {
          id: "24644",
          name: "Ueki",
          state_id: "1939",
        },
        {
          id: "24645",
          name: "Ushibuka",
          state_id: "1939",
        },
        {
          id: "24646",
          name: "Uto",
          state_id: "1939",
        },
        {
          id: "24647",
          name: "Yamaga",
          state_id: "1939",
        },
        {
          id: "24648",
          name: "Yatsushiro",
          state_id: "1939",
        },
      ],
      Kyoto: [
        {
          id: "24649",
          name: "Ayabe",
          state_id: "1940",
        },
        {
          id: "24650",
          name: "Fukuchiyama",
          state_id: "1940",
        },
        {
          id: "24651",
          name: "Joyo",
          state_id: "1940",
        },
        {
          id: "24652",
          name: "Kameoka",
          state_id: "1940",
        },
        {
          id: "24653",
          name: "Kizu",
          state_id: "1940",
        },
        {
          id: "24654",
          name: "Kumiyama",
          state_id: "1940",
        },
        {
          id: "24655",
          name: "Kyotanabe",
          state_id: "1940",
        },
        {
          id: "24656",
          name: "Kyoto",
          state_id: "1940",
        },
        {
          id: "24657",
          name: "Maizuru",
          state_id: "1940",
        },
        {
          id: "24658",
          name: "Miyazu",
          state_id: "1940",
        },
        {
          id: "24659",
          name: "Muko",
          state_id: "1940",
        },
        {
          id: "24660",
          name: "Nagaokakyo",
          state_id: "1940",
        },
        {
          id: "24661",
          name: "Seika",
          state_id: "1940",
        },
        {
          id: "24662",
          name: "Uji",
          state_id: "1940",
        },
        {
          id: "24663",
          name: "Yawata",
          state_id: "1940",
        },
      ],
      Mie: [
        {
          id: "24664",
          name: "Ago",
          state_id: "1941",
        },
        {
          id: "24665",
          name: "Hisai",
          state_id: "1941",
        },
        {
          id: "24666",
          name: "Ise",
          state_id: "1941",
        },
        {
          id: "24667",
          name: "Kameyama",
          state_id: "1941",
        },
        {
          id: "24668",
          name: "Komono",
          state_id: "1941",
        },
        {
          id: "24669",
          name: "Kumano",
          state_id: "1941",
        },
        {
          id: "24670",
          name: "Kuwana",
          state_id: "1941",
        },
        {
          id: "24671",
          name: "Matsusaka",
          state_id: "1941",
        },
        {
          id: "24672",
          name: "Meiwa",
          state_id: "1941",
        },
        {
          id: "24673",
          name: "Nabari",
          state_id: "1941",
        },
        {
          id: "24674",
          name: "Owase",
          state_id: "1941",
        },
        {
          id: "24675",
          name: "Suzuka",
          state_id: "1941",
        },
        {
          id: "24676",
          name: "Toba",
          state_id: "1941",
        },
        {
          id: "24677",
          name: "Toin",
          state_id: "1941",
        },
        {
          id: "24678",
          name: "Tsu",
          state_id: "1941",
        },
        {
          id: "24679",
          name: "Ueno",
          state_id: "1941",
        },
        {
          id: "24680",
          name: "Yokkaichi",
          state_id: "1941",
        },
      ],
      Miyagi: [
        {
          id: "24681",
          name: "Furukawa",
          state_id: "1942",
        },
        {
          id: "24682",
          name: "Hasama",
          state_id: "1942",
        },
        {
          id: "24683",
          name: "Ishinomaki",
          state_id: "1942",
        },
        {
          id: "24684",
          name: "Iwanuma",
          state_id: "1942",
        },
        {
          id: "24685",
          name: "Kakuda",
          state_id: "1942",
        },
        {
          id: "24686",
          name: "Kesennuma",
          state_id: "1942",
        },
        {
          id: "24687",
          name: "Kogota",
          state_id: "1942",
        },
        {
          id: "24688",
          name: "Marumori",
          state_id: "1942",
        },
        {
          id: "24689",
          name: "Natori",
          state_id: "1942",
        },
        {
          id: "24690",
          name: "Ogawara",
          state_id: "1942",
        },
        {
          id: "24691",
          name: "Rifu",
          state_id: "1942",
        },
        {
          id: "24692",
          name: "Sendai",
          state_id: "1942",
        },
        {
          id: "24693",
          name: "Shibata",
          state_id: "1942",
        },
        {
          id: "24694",
          name: "Shichigahama",
          state_id: "1942",
        },
        {
          id: "24695",
          name: "Shiogama",
          state_id: "1942",
        },
        {
          id: "24696",
          name: "Shiroishi",
          state_id: "1942",
        },
        {
          id: "24697",
          name: "Tagajo",
          state_id: "1942",
        },
        {
          id: "24698",
          name: "Taiwa",
          state_id: "1942",
        },
        {
          id: "24699",
          name: "Tomiya",
          state_id: "1942",
        },
        {
          id: "24700",
          name: "Wakuya",
          state_id: "1942",
        },
        {
          id: "24701",
          name: "Watari",
          state_id: "1942",
        },
        {
          id: "24702",
          name: "Yamoto",
          state_id: "1942",
        },
      ],
      Miyazaki: [
        {
          id: "24703",
          name: "Ebino",
          state_id: "1943",
        },
        {
          id: "24704",
          name: "Hyuga",
          state_id: "1943",
        },
        {
          id: "24705",
          name: "Kiyotake",
          state_id: "1943",
        },
        {
          id: "24706",
          name: "Kobayashi",
          state_id: "1943",
        },
        {
          id: "24707",
          name: "Kunitomi",
          state_id: "1943",
        },
        {
          id: "24708",
          name: "Kushima",
          state_id: "1943",
        },
        {
          id: "24709",
          name: "Mimata",
          state_id: "1943",
        },
        {
          id: "24710",
          name: "Miyakonojo",
          state_id: "1943",
        },
        {
          id: "24711",
          name: "Miyazaki",
          state_id: "1943",
        },
        {
          id: "24712",
          name: "Nichinan",
          state_id: "1943",
        },
        {
          id: "24713",
          name: "Nobeoka",
          state_id: "1943",
        },
        {
          id: "24714",
          name: "Sadowara",
          state_id: "1943",
        },
        {
          id: "24715",
          name: "Saito",
          state_id: "1943",
        },
        {
          id: "24716",
          name: "Shintomi",
          state_id: "1943",
        },
        {
          id: "24717",
          name: "Takanabe",
          state_id: "1943",
        },
      ],
      Nagano: [
        {
          id: "24718",
          name: "Chino",
          state_id: "1944",
        },
        {
          id: "24719",
          name: "Hotaka",
          state_id: "1944",
        },
        {
          id: "24720",
          name: "Iida",
          state_id: "1944",
        },
        {
          id: "24721",
          name: "Iiyama",
          state_id: "1944",
        },
        {
          id: "24722",
          name: "Ina",
          state_id: "1944",
        },
        {
          id: "24723",
          name: "Komagane",
          state_id: "1944",
        },
        {
          id: "24724",
          name: "Komoro",
          state_id: "1944",
        },
        {
          id: "24725",
          name: "Koshoku",
          state_id: "1944",
        },
        {
          id: "24726",
          name: "Maruko",
          state_id: "1944",
        },
        {
          id: "24727",
          name: "Matsumoto",
          state_id: "1944",
        },
        {
          id: "24728",
          name: "Minowa",
          state_id: "1944",
        },
        {
          id: "24729",
          name: "Nagano",
          state_id: "1944",
        },
        {
          id: "24730",
          name: "Nakano",
          state_id: "1944",
        },
        {
          id: "24731",
          name: "Okaya",
          state_id: "1944",
        },
        {
          id: "24732",
          name: "Omachi",
          state_id: "1944",
        },
        {
          id: "24733",
          name: "Saku",
          state_id: "1944",
        },
        {
          id: "24734",
          name: "Shimosuwa",
          state_id: "1944",
        },
        {
          id: "24735",
          name: "Shiojiri",
          state_id: "1944",
        },
        {
          id: "24736",
          name: "Suwa",
          state_id: "1944",
        },
        {
          id: "24737",
          name: "Suzaka",
          state_id: "1944",
        },
        {
          id: "24738",
          name: "Tatsuno",
          state_id: "1944",
        },
        {
          id: "24739",
          name: "Tobu",
          state_id: "1944",
        },
        {
          id: "24740",
          name: "Toyoshina",
          state_id: "1944",
        },
        {
          id: "24741",
          name: "Ueda",
          state_id: "1944",
        },
      ],
      Nagasaki: [
        {
          id: "24742",
          name: "Fukue",
          state_id: "1945",
        },
        {
          id: "24743",
          name: "Hirado",
          state_id: "1945",
        },
        {
          id: "24744",
          name: "Isahaya",
          state_id: "1945",
        },
        {
          id: "24745",
          name: "Matsuura",
          state_id: "1945",
        },
        {
          id: "24746",
          name: "Nagasaki",
          state_id: "1945",
        },
        {
          id: "24747",
          name: "Nagayo",
          state_id: "1945",
        },
        {
          id: "24748",
          name: "Omura",
          state_id: "1945",
        },
        {
          id: "24749",
          name: "Sasebo",
          state_id: "1945",
        },
        {
          id: "24750",
          name: "Shimabara",
          state_id: "1945",
        },
        {
          id: "24751",
          name: "Togitsu",
          state_id: "1945",
        },
      ],
      Nara: [
        {
          id: "24752",
          name: "Gojo",
          state_id: "1946",
        },
        {
          id: "24753",
          name: "Gose",
          state_id: "1946",
        },
        {
          id: "24754",
          name: "Haibara",
          state_id: "1946",
        },
        {
          id: "24755",
          name: "Heguri",
          state_id: "1946",
        },
        {
          id: "24756",
          name: "Ikagura",
          state_id: "1946",
        },
        {
          id: "24757",
          name: "Ikoma",
          state_id: "1946",
        },
        {
          id: "24758",
          name: "Kammaki",
          state_id: "1946",
        },
        {
          id: "24759",
          name: "Kashiba",
          state_id: "1946",
        },
        {
          id: "24760",
          name: "Kashihara",
          state_id: "1946",
        },
        {
          id: "24761",
          name: "Kawai",
          state_id: "1946",
        },
        {
          id: "24762",
          name: "Koryo",
          state_id: "1946",
        },
        {
          id: "24763",
          name: "Nara",
          state_id: "1946",
        },
        {
          id: "24764",
          name: "Oji",
          state_id: "1946",
        },
        {
          id: "24765",
          name: "Oyodo",
          state_id: "1946",
        },
        {
          id: "24766",
          name: "Sakurai",
          state_id: "1946",
        },
        {
          id: "24767",
          name: "Sango",
          state_id: "1946",
        },
        {
          id: "24768",
          name: "Tawaramoto",
          state_id: "1946",
        },
        {
          id: "24769",
          name: "Tenri",
          state_id: "1946",
        },
        {
          id: "24770",
          name: "Yamatokoriyama",
          state_id: "1946",
        },
        {
          id: "24771",
          name: "Yamatotakada",
          state_id: "1946",
        },
      ],
      Niigata: [
        {
          id: "24772",
          name: "Arai",
          state_id: "1947",
        },
        {
          id: "24773",
          name: "Fuchu",
          state_id: "1947",
        },
        {
          id: "24774",
          name: "Gosen",
          state_id: "1947",
        },
        {
          id: "24775",
          name: "Itoigawa",
          state_id: "1947",
        },
        {
          id: "24776",
          name: "Joetsu",
          state_id: "1947",
        },
        {
          id: "24777",
          name: "Kameda",
          state_id: "1947",
        },
        {
          id: "24778",
          name: "Kamo",
          state_id: "1947",
        },
        {
          id: "24779",
          name: "Kashiwazaki",
          state_id: "1947",
        },
        {
          id: "24780",
          name: "Kurosaki",
          state_id: "1947",
        },
        {
          id: "24781",
          name: "Maki",
          state_id: "1947",
        },
        {
          id: "24782",
          name: "Mitsuke",
          state_id: "1947",
        },
        {
          id: "24783",
          name: "Muika",
          state_id: "1947",
        },
        {
          id: "24784",
          name: "Murakami",
          state_id: "1947",
        },
        {
          id: "24785",
          name: "Muramatsu",
          state_id: "1947",
        },
        {
          id: "24786",
          name: "Nagaoka",
          state_id: "1947",
        },
        {
          id: "24787",
          name: "Nakajo",
          state_id: "1947",
        },
        {
          id: "24788",
          name: "Niigata",
          state_id: "1947",
        },
        {
          id: "24789",
          name: "Niitsu",
          state_id: "1947",
        },
        {
          id: "24790",
          name: "Ojiya",
          state_id: "1947",
        },
        {
          id: "24791",
          name: "Ryotsu",
          state_id: "1947",
        },
        {
          id: "24792",
          name: "Sanjo",
          state_id: "1947",
        },
        {
          id: "24793",
          name: "Shibata",
          state_id: "1947",
        },
        {
          id: "24794",
          name: "Shiozawa",
          state_id: "1947",
        },
        {
          id: "24795",
          name: "Shirone",
          state_id: "1947",
        },
        {
          id: "24796",
          name: "Suibara",
          state_id: "1947",
        },
        {
          id: "24797",
          name: "Tochio",
          state_id: "1947",
        },
        {
          id: "24798",
          name: "Tokamachi",
          state_id: "1947",
        },
        {
          id: "24799",
          name: "Toyosaka",
          state_id: "1947",
        },
        {
          id: "24800",
          name: "Tsubame",
          state_id: "1947",
        },
        {
          id: "24801",
          name: "Yoshida",
          state_id: "1947",
        },
      ],
      Oita: [
        {
          id: "24802",
          name: "Beppu",
          state_id: "1948",
        },
        {
          id: "24803",
          name: "Bungotakada",
          state_id: "1948",
        },
        {
          id: "24804",
          name: "Hiji",
          state_id: "1948",
        },
        {
          id: "24805",
          name: "Hita",
          state_id: "1948",
        },
        {
          id: "24806",
          name: "Kitsuki",
          state_id: "1948",
        },
        {
          id: "24807",
          name: "Kusu",
          state_id: "1948",
        },
        {
          id: "24808",
          name: "Nakatsu",
          state_id: "1948",
        },
        {
          id: "24809",
          name: "Oita",
          state_id: "1948",
        },
        {
          id: "24810",
          name: "Saiki",
          state_id: "1948",
        },
        {
          id: "24811",
          name: "Taketa",
          state_id: "1948",
        },
        {
          id: "24812",
          name: "Tsukumi",
          state_id: "1948",
        },
        {
          id: "24813",
          name: "Usa",
          state_id: "1948",
        },
        {
          id: "24814",
          name: "Usuki",
          state_id: "1948",
        },
      ],
      Okayama: [
        {
          id: "24815",
          name: "Bizen",
          state_id: "1949",
        },
        {
          id: "24816",
          name: "Ibara",
          state_id: "1949",
        },
        {
          id: "24817",
          name: "Kamogata",
          state_id: "1949",
        },
        {
          id: "24818",
          name: "Kasaoka",
          state_id: "1949",
        },
        {
          id: "24819",
          name: "Kurashiki",
          state_id: "1949",
        },
        {
          id: "24820",
          name: "Mabi",
          state_id: "1949",
        },
        {
          id: "24821",
          name: "Niimi",
          state_id: "1949",
        },
        {
          id: "24822",
          name: "Okayama",
          state_id: "1949",
        },
        {
          id: "24823",
          name: "Sanyo",
          state_id: "1949",
        },
        {
          id: "24824",
          name: "Soja",
          state_id: "1949",
        },
        {
          id: "24825",
          name: "Takahashi",
          state_id: "1949",
        },
        {
          id: "24826",
          name: "Tamano",
          state_id: "1949",
        },
        {
          id: "24827",
          name: "Tsuyama",
          state_id: "1949",
        },
      ],
      Okinawa: [
        {
          id: "24828",
          name: "Chatan",
          state_id: "1950",
        },
        {
          id: "24829",
          name: "Ginowan",
          state_id: "1950",
        },
        {
          id: "24830",
          name: "Gushikawa",
          state_id: "1950",
        },
        {
          id: "24831",
          name: "Haebaru",
          state_id: "1950",
        },
        {
          id: "24832",
          name: "Hirara",
          state_id: "1950",
        },
        {
          id: "24833",
          name: "Ishigaki",
          state_id: "1950",
        },
        {
          id: "24834",
          name: "Ishikawa",
          state_id: "1950",
        },
        {
          id: "24835",
          name: "Itoman",
          state_id: "1950",
        },
        {
          id: "24836",
          name: "Nago",
          state_id: "1950",
        },
        {
          id: "24837",
          name: "Naha",
          state_id: "1950",
        },
        {
          id: "24838",
          name: "Nishihara",
          state_id: "1950",
        },
        {
          id: "24839",
          name: "Okinawa",
          state_id: "1950",
        },
        {
          id: "24840",
          name: "Tomigusuku",
          state_id: "1950",
        },
        {
          id: "24841",
          name: "Urasoe",
          state_id: "1950",
        },
        {
          id: "24842",
          name: "Yomitan",
          state_id: "1950",
        },
      ],
      Osaka: [
        {
          id: "24843",
          name: "Daito",
          state_id: "1951",
        },
        {
          id: "24844",
          name: "Fujiidera",
          state_id: "1951",
        },
        {
          id: "24845",
          name: "Habikino",
          state_id: "1951",
        },
        {
          id: "24846",
          name: "Hannan",
          state_id: "1951",
        },
        {
          id: "24847",
          name: "Higashiosaka",
          state_id: "1951",
        },
        {
          id: "24848",
          name: "Hirakata",
          state_id: "1951",
        },
        {
          id: "24849",
          name: "Ibaraki",
          state_id: "1951",
        },
        {
          id: "24850",
          name: "Ikeda",
          state_id: "1951",
        },
        {
          id: "24851",
          name: "Izumi",
          state_id: "1951",
        },
        {
          id: "24852",
          name: "Izumiotsu",
          state_id: "1951",
        },
        {
          id: "24853",
          name: "Izumisano",
          state_id: "1951",
        },
        {
          id: "24854",
          name: "Kadoma",
          state_id: "1951",
        },
        {
          id: "24855",
          name: "Kaizuka",
          state_id: "1951",
        },
        {
          id: "24856",
          name: "Kashiwara",
          state_id: "1951",
        },
        {
          id: "24857",
          name: "Katano",
          state_id: "1951",
        },
        {
          id: "24858",
          name: "Kawachinagano",
          state_id: "1951",
        },
        {
          id: "24859",
          name: "Kishiwada",
          state_id: "1951",
        },
        {
          id: "24860",
          name: "Kobe",
          state_id: "1951",
        },
        {
          id: "24861",
          name: "Kumatori",
          state_id: "1951",
        },
        {
          id: "24862",
          name: "Matsubara",
          state_id: "1951",
        },
        {
          id: "24863",
          name: "Mihara",
          state_id: "1951",
        },
        {
          id: "24864",
          name: "Mino",
          state_id: "1951",
        },
        {
          id: "24865",
          name: "Misaki",
          state_id: "1951",
        },
        {
          id: "24866",
          name: "Moriguchi",
          state_id: "1951",
        },
        {
          id: "24867",
          name: "Neyagawa",
          state_id: "1951",
        },
        {
          id: "24868",
          name: "Osaka",
          state_id: "1951",
        },
        {
          id: "24869",
          name: "Osakasayama",
          state_id: "1951",
        },
        {
          id: "24870",
          name: "Sakai",
          state_id: "1951",
        },
        {
          id: "24871",
          name: "Sennan",
          state_id: "1951",
        },
        {
          id: "24872",
          name: "Settsu",
          state_id: "1951",
        },
        {
          id: "24873",
          name: "Shijonawate",
          state_id: "1951",
        },
        {
          id: "24874",
          name: "Shimamoto",
          state_id: "1951",
        },
        {
          id: "24875",
          name: "Suita",
          state_id: "1951",
        },
        {
          id: "24876",
          name: "Takaishi",
          state_id: "1951",
        },
        {
          id: "24877",
          name: "Takatsuki",
          state_id: "1951",
        },
        {
          id: "24878",
          name: "Tondabayashi",
          state_id: "1951",
        },
        {
          id: "24879",
          name: "Toyonaka",
          state_id: "1951",
        },
        {
          id: "24880",
          name: "Toyono",
          state_id: "1951",
        },
        {
          id: "24881",
          name: "Yao",
          state_id: "1951",
        },
      ],
      Saga: [
        {
          id: "24882",
          name: "Imari",
          state_id: "1952",
        },
        {
          id: "24883",
          name: "Kanzaki",
          state_id: "1952",
        },
        {
          id: "24884",
          name: "Karatsu",
          state_id: "1952",
        },
        {
          id: "24885",
          name: "Kashima",
          state_id: "1952",
        },
        {
          id: "24886",
          name: "Kawasoe",
          state_id: "1952",
        },
        {
          id: "24887",
          name: "Saga",
          state_id: "1952",
        },
        {
          id: "24888",
          name: "Takeo",
          state_id: "1952",
        },
        {
          id: "24889",
          name: "Taku",
          state_id: "1952",
        },
        {
          id: "24890",
          name: "Tosu",
          state_id: "1952",
        },
        {
          id: "24891",
          name: "Ureshino",
          state_id: "1952",
        },
        {
          id: "24892",
          name: "Yamato",
          state_id: "1952",
        },
      ],
      Saitama: [
        {
          id: "24893",
          name: "Ageo",
          state_id: "1953",
        },
        {
          id: "24894",
          name: "Asaka",
          state_id: "1953",
        },
        {
          id: "24895",
          name: "Chichibu",
          state_id: "1953",
        },
        {
          id: "24896",
          name: "Fujimi",
          state_id: "1953",
        },
        {
          id: "24897",
          name: "Fukaya",
          state_id: "1953",
        },
        {
          id: "24898",
          name: "Fukiage",
          state_id: "1953",
        },
        {
          id: "24899",
          name: "Gyoda",
          state_id: "1953",
        },
        {
          id: "24900",
          name: "Hanno",
          state_id: "1953",
        },
        {
          id: "24901",
          name: "Hanyu",
          state_id: "1953",
        },
        {
          id: "24902",
          name: "Hasuda",
          state_id: "1953",
        },
        {
          id: "24903",
          name: "Hatogaya",
          state_id: "1953",
        },
        {
          id: "24904",
          name: "Hatoyama",
          state_id: "1953",
        },
        {
          id: "24905",
          name: "Hidaka",
          state_id: "1953",
        },
        {
          id: "24906",
          name: "Higashimatsuyama",
          state_id: "1953",
        },
        {
          id: "24907",
          name: "Honjo",
          state_id: "1953",
        },
        {
          id: "24908",
          name: "Ina",
          state_id: "1953",
        },
        {
          id: "24909",
          name: "Iruma",
          state_id: "1953",
        },
        {
          id: "24910",
          name: "Iwatsuki",
          state_id: "1953",
        },
        {
          id: "24911",
          name: "Kamifukuoka",
          state_id: "1953",
        },
        {
          id: "24912",
          name: "Kamisato",
          state_id: "1953",
        },
        {
          id: "24913",
          name: "Kasukabe",
          state_id: "1953",
        },
        {
          id: "24914",
          name: "Kawagoe",
          state_id: "1953",
        },
        {
          id: "24915",
          name: "Kawaguchi",
          state_id: "1953",
        },
        {
          id: "24916",
          name: "Kawajima",
          state_id: "1953",
        },
        {
          id: "24917",
          name: "Kazo",
          state_id: "1953",
        },
        {
          id: "24918",
          name: "Kisai",
          state_id: "1953",
        },
        {
          id: "24919",
          name: "Kitamoto",
          state_id: "1953",
        },
        {
          id: "24920",
          name: "Kodama",
          state_id: "1953",
        },
        {
          id: "24921",
          name: "Konosu",
          state_id: "1953",
        },
        {
          id: "24922",
          name: "Koshigaya",
          state_id: "1953",
        },
        {
          id: "24923",
          name: "Kuki",
          state_id: "1953",
        },
        {
          id: "24924",
          name: "Kumagaya",
          state_id: "1953",
        },
        {
          id: "24925",
          name: "Kurihashi",
          state_id: "1953",
        },
        {
          id: "24926",
          name: "Matsubushi",
          state_id: "1953",
        },
        {
          id: "24927",
          name: "Menuma",
          state_id: "1953",
        },
        {
          id: "24928",
          name: "Misato",
          state_id: "1953",
        },
        {
          id: "24929",
          name: "Miyashiro",
          state_id: "1953",
        },
        {
          id: "24930",
          name: "Miyoshi",
          state_id: "1953",
        },
        {
          id: "24931",
          name: "Moroyama",
          state_id: "1953",
        },
        {
          id: "24932",
          name: "Niiza",
          state_id: "1953",
        },
        {
          id: "24933",
          name: "Ogawa",
          state_id: "1953",
        },
        {
          id: "24934",
          name: "Oi",
          state_id: "1953",
        },
        {
          id: "24935",
          name: "Okegawa",
          state_id: "1953",
        },
        {
          id: "24936",
          name: "Omiya",
          state_id: "1953",
        },
        {
          id: "24937",
          name: "Saitma-Shi",
          state_id: "1953",
        },
        {
          id: "24938",
          name: "Sakado",
          state_id: "1953",
        },
        {
          id: "24939",
          name: "Satte",
          state_id: "1953",
        },
        {
          id: "24940",
          name: "Sayama",
          state_id: "1953",
        },
        {
          id: "24941",
          name: "Shiki",
          state_id: "1953",
        },
        {
          id: "24942",
          name: "Shiraoka",
          state_id: "1953",
        },
        {
          id: "24943",
          name: "Shobu",
          state_id: "1953",
        },
        {
          id: "24944",
          name: "Showa",
          state_id: "1953",
        },
        {
          id: "24945",
          name: "Soka",
          state_id: "1953",
        },
        {
          id: "24946",
          name: "Sugito",
          state_id: "1953",
        },
        {
          id: "24947",
          name: "Toda",
          state_id: "1953",
        },
        {
          id: "24948",
          name: "Tokorozawa",
          state_id: "1953",
        },
        {
          id: "24949",
          name: "Tsurugashima",
          state_id: "1953",
        },
        {
          id: "24950",
          name: "Urawa",
          state_id: "1953",
        },
        {
          id: "24951",
          name: "Wako",
          state_id: "1953",
        },
        {
          id: "24952",
          name: "Warabi",
          state_id: "1953",
        },
        {
          id: "24953",
          name: "Washimiya",
          state_id: "1953",
        },
        {
          id: "24954",
          name: "Yashio",
          state_id: "1953",
        },
        {
          id: "24955",
          name: "Yono",
          state_id: "1953",
        },
        {
          id: "24956",
          name: "Yorii",
          state_id: "1953",
        },
        {
          id: "24957",
          name: "Yoshikawa",
          state_id: "1953",
        },
        {
          id: "24958",
          name: "Yoshimi",
          state_id: "1953",
        },
      ],
      Shiga: [
        {
          id: "24959",
          name: "Hikone",
          state_id: "1954",
        },
        {
          id: "24960",
          name: "Hino",
          state_id: "1954",
        },
        {
          id: "24961",
          name: "Konan",
          state_id: "1954",
        },
        {
          id: "24962",
          name: "Kosei",
          state_id: "1954",
        },
        {
          id: "24963",
          name: "Kusatsu",
          state_id: "1954",
        },
        {
          id: "24964",
          name: "Minakuchi",
          state_id: "1954",
        },
        {
          id: "24965",
          name: "Moriyama",
          state_id: "1954",
        },
        {
          id: "24966",
          name: "Nagahama",
          state_id: "1954",
        },
        {
          id: "24967",
          name: "Notogawa",
          state_id: "1954",
        },
        {
          id: "24968",
          name: "Omihachiman",
          state_id: "1954",
        },
        {
          id: "24969",
          name: "Otsu",
          state_id: "1954",
        },
        {
          id: "24970",
          name: "Ritto",
          state_id: "1954",
        },
        {
          id: "24971",
          name: "Shiga",
          state_id: "1954",
        },
        {
          id: "24972",
          name: "Yasu",
          state_id: "1954",
        },
        {
          id: "24973",
          name: "Yokaichi",
          state_id: "1954",
        },
      ],
      Shimane: [
        {
          id: "24974",
          name: "Gotsu",
          state_id: "1955",
        },
        {
          id: "24975",
          name: "Hamada",
          state_id: "1955",
        },
        {
          id: "24976",
          name: "Hikawa",
          state_id: "1955",
        },
        {
          id: "24977",
          name: "Hirata",
          state_id: "1955",
        },
        {
          id: "24978",
          name: "Izumo",
          state_id: "1955",
        },
        {
          id: "24979",
          name: "Masuda",
          state_id: "1955",
        },
        {
          id: "24980",
          name: "Matsue",
          state_id: "1955",
        },
        {
          id: "24981",
          name: "Oda",
          state_id: "1955",
        },
        {
          id: "24982",
          name: "Yasugi",
          state_id: "1955",
        },
      ],
      Shizuoka: [
        {
          id: "24983",
          name: "Asaba",
          state_id: "1956",
        },
        {
          id: "24984",
          name: "Atami",
          state_id: "1956",
        },
        {
          id: "24985",
          name: "Daito",
          state_id: "1956",
        },
        {
          id: "24986",
          name: "Fuji",
          state_id: "1956",
        },
        {
          id: "24987",
          name: "Fujieda",
          state_id: "1956",
        },
        {
          id: "24988",
          name: "Fujinomiya",
          state_id: "1956",
        },
        {
          id: "24989",
          name: "Fukuroi",
          state_id: "1956",
        },
        {
          id: "24990",
          name: "Gotemba",
          state_id: "1956",
        },
        {
          id: "24991",
          name: "Haibara",
          state_id: "1956",
        },
        {
          id: "24992",
          name: "Hamakita",
          state_id: "1956",
        },
        {
          id: "24993",
          name: "Hamamatsu",
          state_id: "1956",
        },
        {
          id: "24994",
          name: "Hamaoka",
          state_id: "1956",
        },
        {
          id: "24995",
          name: "Hosoe",
          state_id: "1956",
        },
        {
          id: "24996",
          name: "Ito",
          state_id: "1956",
        },
        {
          id: "24997",
          name: "Iwata",
          state_id: "1956",
        },
        {
          id: "24998",
          name: "Kakegawa",
          state_id: "1956",
        },
        {
          id: "24999",
          name: "Kanaya",
          state_id: "1956",
        },
        {
          id: "25000",
          name: "Kannami",
          state_id: "1956",
        },
        {
          id: "25001",
          name: "Kikugawa",
          state_id: "1956",
        },
        {
          id: "25002",
          name: "Kosai",
          state_id: "1956",
        },
        {
          id: "25003",
          name: "Mishima",
          state_id: "1956",
        },
        {
          id: "25004",
          name: "Mori",
          state_id: "1956",
        },
        {
          id: "25005",
          name: "Nagaizumi",
          state_id: "1956",
        },
        {
          id: "25006",
          name: "Numazu",
          state_id: "1956",
        },
        {
          id: "25007",
          name: "Oigawa",
          state_id: "1956",
        },
        {
          id: "25008",
          name: "Oyama",
          state_id: "1956",
        },
        {
          id: "25009",
          name: "Ryuyo",
          state_id: "1956",
        },
        {
          id: "25010",
          name: "Sagara",
          state_id: "1956",
        },
        {
          id: "25011",
          name: "Shimada",
          state_id: "1956",
        },
        {
          id: "25012",
          name: "Shimizu",
          state_id: "1956",
        },
        {
          id: "25013",
          name: "Shimoda",
          state_id: "1956",
        },
        {
          id: "25014",
          name: "Shizuoka",
          state_id: "1956",
        },
        {
          id: "25015",
          name: "Susono",
          state_id: "1956",
        },
        {
          id: "25016",
          name: "Tenryu",
          state_id: "1956",
        },
        {
          id: "25017",
          name: "Toyoda",
          state_id: "1956",
        },
        {
          id: "25018",
          name: "Yaizu",
          state_id: "1956",
        },
        {
          id: "25019",
          name: "Yoshida",
          state_id: "1956",
        },
      ],
      Tochigi: [
        {
          id: "25020",
          name: "Ashikaga",
          state_id: "1957",
        },
        {
          id: "25021",
          name: "Fujioka",
          state_id: "1957",
        },
        {
          id: "25022",
          name: "Imaichi",
          state_id: "1957",
        },
        {
          id: "25023",
          name: "Iwafune",
          state_id: "1957",
        },
        {
          id: "25024",
          name: "Kaminokawa",
          state_id: "1957",
        },
        {
          id: "25025",
          name: "Kanuma",
          state_id: "1957",
        },
        {
          id: "25026",
          name: "Karasuyama",
          state_id: "1957",
        },
        {
          id: "25027",
          name: "Kawachi",
          state_id: "1957",
        },
        {
          id: "25028",
          name: "Kuroiso",
          state_id: "1957",
        },
        {
          id: "25029",
          name: "Mashiko",
          state_id: "1957",
        },
        {
          id: "25030",
          name: "Mibu",
          state_id: "1957",
        },
        {
          id: "25031",
          name: "Minamikawachi",
          state_id: "1957",
        },
        {
          id: "25032",
          name: "Moka",
          state_id: "1957",
        },
        {
          id: "25033",
          name: "Motegi",
          state_id: "1957",
        },
        {
          id: "25034",
          name: "Nasu",
          state_id: "1957",
        },
        {
          id: "25035",
          name: "Nikko",
          state_id: "1957",
        },
        {
          id: "25036",
          name: "Nishinasuno",
          state_id: "1957",
        },
        {
          id: "25037",
          name: "Nogi",
          state_id: "1957",
        },
        {
          id: "25038",
          name: "Ohira",
          state_id: "1957",
        },
        {
          id: "25039",
          name: "Otawara",
          state_id: "1957",
        },
        {
          id: "25040",
          name: "Oyama",
          state_id: "1957",
        },
        {
          id: "25041",
          name: "Sano",
          state_id: "1957",
        },
        {
          id: "25042",
          name: "Takanezawa",
          state_id: "1957",
        },
        {
          id: "25043",
          name: "Tanuma",
          state_id: "1957",
        },
        {
          id: "25044",
          name: "Tochigi",
          state_id: "1957",
        },
        {
          id: "25045",
          name: "Ujiie",
          state_id: "1957",
        },
        {
          id: "25046",
          name: "Utsunomiya",
          state_id: "1957",
        },
        {
          id: "25047",
          name: "Yaita",
          state_id: "1957",
        },
      ],
      Tokushima: [
        {
          id: "25048",
          name: "Aizumi",
          state_id: "1958",
        },
        {
          id: "25049",
          name: "Anan",
          state_id: "1958",
        },
        {
          id: "25050",
          name: "Ikeda",
          state_id: "1958",
        },
        {
          id: "25051",
          name: "Ishii",
          state_id: "1958",
        },
        {
          id: "25052",
          name: "Kamojima",
          state_id: "1958",
        },
        {
          id: "25053",
          name: "Kitajima",
          state_id: "1958",
        },
        {
          id: "25054",
          name: "Komatsushima",
          state_id: "1958",
        },
        {
          id: "25055",
          name: "Naruto",
          state_id: "1958",
        },
        {
          id: "25056",
          name: "Tokushima",
          state_id: "1958",
        },
        {
          id: "25057",
          name: "Waki",
          state_id: "1958",
        },
      ],
      Tokyo: [
        {
          id: "25058",
          name: "Akiruno",
          state_id: "1959",
        },
        {
          id: "25059",
          name: "Akishima",
          state_id: "1959",
        },
        {
          id: "25060",
          name: "Chofu",
          state_id: "1959",
        },
        {
          id: "25061",
          name: "Fuchu",
          state_id: "1959",
        },
        {
          id: "25062",
          name: "Hachioji",
          state_id: "1959",
        },
        {
          id: "25063",
          name: "Hamura",
          state_id: "1959",
        },
        {
          id: "25064",
          name: "Higashikurume",
          state_id: "1959",
        },
        {
          id: "25065",
          name: "Higashimurayama",
          state_id: "1959",
        },
        {
          id: "25066",
          name: "Higashiyamato",
          state_id: "1959",
        },
        {
          id: "25067",
          name: "Hino",
          state_id: "1959",
        },
        {
          id: "25068",
          name: "Hoya",
          state_id: "1959",
        },
        {
          id: "25069",
          name: "Inagi",
          state_id: "1959",
        },
        {
          id: "25070",
          name: "Kiyose",
          state_id: "1959",
        },
        {
          id: "25071",
          name: "Kodaira",
          state_id: "1959",
        },
        {
          id: "25072",
          name: "Koganei",
          state_id: "1959",
        },
        {
          id: "25073",
          name: "Kokubunji",
          state_id: "1959",
        },
        {
          id: "25074",
          name: "Komae",
          state_id: "1959",
        },
        {
          id: "25075",
          name: "Kunitachi",
          state_id: "1959",
        },
        {
          id: "25076",
          name: "Machida",
          state_id: "1959",
        },
        {
          id: "25077",
          name: "Mitaka",
          state_id: "1959",
        },
        {
          id: "25078",
          name: "Mizuho",
          state_id: "1959",
        },
        {
          id: "25079",
          name: "Musashimurayama",
          state_id: "1959",
        },
        {
          id: "25080",
          name: "Musashino",
          state_id: "1959",
        },
        {
          id: "25081",
          name: "Ome",
          state_id: "1959",
        },
        {
          id: "25082",
          name: "Tachikawa",
          state_id: "1959",
        },
        {
          id: "25083",
          name: "Tama",
          state_id: "1959",
        },
        {
          id: "25084",
          name: "Tanashi",
          state_id: "1959",
        },
        {
          id: "25085",
          name: "Tokyo",
          state_id: "1959",
        },
      ],
      Tottori: [
        {
          id: "25086",
          name: "Kurayoshi",
          state_id: "1960",
        },
        {
          id: "25087",
          name: "Sakaiminato",
          state_id: "1960",
        },
        {
          id: "25088",
          name: "Tottori",
          state_id: "1960",
        },
        {
          id: "25089",
          name: "Yonago",
          state_id: "1960",
        },
      ],
      Toyama: [
        {
          id: "25090",
          name: "Fukumitsu",
          state_id: "1961",
        },
        {
          id: "25091",
          name: "Himi",
          state_id: "1961",
        },
        {
          id: "25092",
          name: "Kamiichi",
          state_id: "1961",
        },
        {
          id: "25093",
          name: "Kosugi",
          state_id: "1961",
        },
        {
          id: "25094",
          name: "Kurobe",
          state_id: "1961",
        },
        {
          id: "25095",
          name: "Namerikawa",
          state_id: "1961",
        },
        {
          id: "25096",
          name: "Nyuzen",
          state_id: "1961",
        },
        {
          id: "25097",
          name: "Osawano",
          state_id: "1961",
        },
        {
          id: "25098",
          name: "Oyabe",
          state_id: "1961",
        },
        {
          id: "25099",
          name: "Shimminato",
          state_id: "1961",
        },
        {
          id: "25100",
          name: "Takaoka",
          state_id: "1961",
        },
        {
          id: "25101",
          name: "Tateyama",
          state_id: "1961",
        },
        {
          id: "25102",
          name: "Tonami",
          state_id: "1961",
        },
        {
          id: "25103",
          name: "Toyama",
          state_id: "1961",
        },
        {
          id: "25104",
          name: "Uozu",
          state_id: "1961",
        },
        {
          id: "25105",
          name: "Yatsuo",
          state_id: "1961",
        },
      ],
      Wakayama: [
        {
          id: "25106",
          name: "Arida",
          state_id: "1962",
        },
        {
          id: "25107",
          name: "Gobo",
          state_id: "1962",
        },
        {
          id: "25108",
          name: "Hashimoto",
          state_id: "1962",
        },
        {
          id: "25109",
          name: "Iwade",
          state_id: "1962",
        },
        {
          id: "25110",
          name: "Kainan",
          state_id: "1962",
        },
        {
          id: "25111",
          name: "Katsuragi",
          state_id: "1962",
        },
        {
          id: "25112",
          name: "Kishigawa",
          state_id: "1962",
        },
        {
          id: "25113",
          name: "Nachikatsuura",
          state_id: "1962",
        },
        {
          id: "25114",
          name: "Shingu",
          state_id: "1962",
        },
        {
          id: "25115",
          name: "Tanabe",
          state_id: "1962",
        },
        {
          id: "25116",
          name: "Wakayama",
          state_id: "1962",
        },
      ],
      Yamagata: [
        {
          id: "25117",
          name: "Higashine",
          state_id: "1963",
        },
        {
          id: "25118",
          name: "Kahoku",
          state_id: "1963",
        },
        {
          id: "25119",
          name: "Kaminoyama",
          state_id: "1963",
        },
        {
          id: "25120",
          name: "Kawanishi",
          state_id: "1963",
        },
        {
          id: "25121",
          name: "Murayama",
          state_id: "1963",
        },
        {
          id: "25122",
          name: "Nagai",
          state_id: "1963",
        },
        {
          id: "25123",
          name: "Nanyo",
          state_id: "1963",
        },
        {
          id: "25124",
          name: "Obanazawa",
          state_id: "1963",
        },
        {
          id: "25125",
          name: "Sagae",
          state_id: "1963",
        },
        {
          id: "25126",
          name: "Sakata",
          state_id: "1963",
        },
        {
          id: "25127",
          name: "Shinjo",
          state_id: "1963",
        },
        {
          id: "25128",
          name: "Takahata",
          state_id: "1963",
        },
        {
          id: "25129",
          name: "Tendo",
          state_id: "1963",
        },
        {
          id: "25130",
          name: "Tsuchiura",
          state_id: "1963",
        },
        {
          id: "25131",
          name: "Tsuruoka",
          state_id: "1963",
        },
        {
          id: "25132",
          name: "Yamagata",
          state_id: "1963",
        },
        {
          id: "25133",
          name: "Yonezawa",
          state_id: "1963",
        },
        {
          id: "25134",
          name: "Yuza",
          state_id: "1963",
        },
      ],
      Yamaguchi: [
        {
          id: "25135",
          name: "Hagi",
          state_id: "1964",
        },
        {
          id: "25136",
          name: "Hikari",
          state_id: "1964",
        },
        {
          id: "25137",
          name: "Hofu",
          state_id: "1964",
        },
        {
          id: "25138",
          name: "Iwakuni",
          state_id: "1964",
        },
        {
          id: "25139",
          name: "Kudamatsu",
          state_id: "1964",
        },
        {
          id: "25140",
          name: "Mine",
          state_id: "1964",
        },
        {
          id: "25141",
          name: "Nagato",
          state_id: "1964",
        },
        {
          id: "25142",
          name: "Ogori",
          state_id: "1964",
        },
        {
          id: "25143",
          name: "Onoda",
          state_id: "1964",
        },
        {
          id: "25144",
          name: "Sanyo",
          state_id: "1964",
        },
        {
          id: "25145",
          name: "Shimonoseki",
          state_id: "1964",
        },
        {
          id: "25146",
          name: "Shinnanyo",
          state_id: "1964",
        },
        {
          id: "25147",
          name: "Tokuyama",
          state_id: "1964",
        },
        {
          id: "25148",
          name: "Toyoura",
          state_id: "1964",
        },
        {
          id: "25149",
          name: "Ube",
          state_id: "1964",
        },
        {
          id: "25150",
          name: "Yamaguchi",
          state_id: "1964",
        },
        {
          id: "25151",
          name: "Yanai",
          state_id: "1964",
        },
      ],
      Yamanashi: [
        {
          id: "25152",
          name: "Enzan",
          state_id: "1965",
        },
        {
          id: "25153",
          name: "Fujiyoshida",
          state_id: "1965",
        },
        {
          id: "25154",
          name: "Isawa",
          state_id: "1965",
        },
        {
          id: "25155",
          name: "Kofu",
          state_id: "1965",
        },
        {
          id: "25156",
          name: "Nirasaki",
          state_id: "1965",
        },
        {
          id: "25157",
          name: "Otsuki",
          state_id: "1965",
        },
        {
          id: "25158",
          name: "Ryuo",
          state_id: "1965",
        },
        {
          id: "25159",
          name: "Tsuru",
          state_id: "1965",
        },
        {
          id: "25160",
          name: "Uenohara",
          state_id: "1965",
        },
        {
          id: "25161",
          name: "Yamanashi",
          state_id: "1965",
        },
      ],
    },
  },
  KE: {
    name: "Kenya",
    native: "Kenya",
    phone: "254",
    continent: "AF",
    capital: "Nairobi",
    currency: "KES",
    languages: ["en", "sw"],
    emoji: "🇰🇪",
    emojiU: "U+1F1F0 U+1F1EA",
    states: {
      Central: [
        {
          id: "25462",
          name: "Gilgil",
          state_id: "2004",
        },
        {
          id: "25463",
          name: "Karatina",
          state_id: "2004",
        },
        {
          id: "25464",
          name: "Kiambu",
          state_id: "2004",
        },
        {
          id: "25465",
          name: "Kijabe",
          state_id: "2004",
        },
        {
          id: "25466",
          name: "Kikuyu",
          state_id: "2004",
        },
        {
          id: "25467",
          name: "Limuru",
          state_id: "2004",
        },
        {
          id: "25468",
          name: "Maragua",
          state_id: "2004",
        },
        {
          id: "25469",
          name: "Muranga",
          state_id: "2004",
        },
        {
          id: "25470",
          name: "Nyeri",
          state_id: "2004",
        },
        {
          id: "25471",
          name: "Ruiru",
          state_id: "2004",
        },
        {
          id: "25472",
          name: "Sagana",
          state_id: "2004",
        },
        {
          id: "25473",
          name: "Thika",
          state_id: "2004",
        },
        {
          id: "25474",
          name: "Vanga",
          state_id: "2004",
        },
      ],
      Coast: [
        {
          id: "25475",
          name: "Changamwe",
          state_id: "2005",
        },
        {
          id: "25476",
          name: "Garsen",
          state_id: "2005",
        },
        {
          id: "25477",
          name: "Gazi",
          state_id: "2005",
        },
        {
          id: "25478",
          name: "Hola",
          state_id: "2005",
        },
        {
          id: "25479",
          name: "Kaloleni",
          state_id: "2005",
        },
        {
          id: "25480",
          name: "Kilifi",
          state_id: "2005",
        },
        {
          id: "25481",
          name: "Kinango",
          state_id: "2005",
        },
        {
          id: "25482",
          name: "Kipini",
          state_id: "2005",
        },
        {
          id: "25483",
          name: "Kwale",
          state_id: "2005",
        },
        {
          id: "25484",
          name: "Lamu",
          state_id: "2005",
        },
        {
          id: "25485",
          name: "Malindi",
          state_id: "2005",
        },
        {
          id: "25486",
          name: "Mambrui",
          state_id: "2005",
        },
        {
          id: "25487",
          name: "Mombasa",
          state_id: "2005",
        },
        {
          id: "25488",
          name: "Sawasawa",
          state_id: "2005",
        },
        {
          id: "25489",
          name: "Shimoni",
          state_id: "2005",
        },
        {
          id: "25490",
          name: "Takaungu",
          state_id: "2005",
        },
        {
          id: "25491",
          name: "Taveta",
          state_id: "2005",
        },
        {
          id: "25492",
          name: "Voi",
          state_id: "2005",
        },
        {
          id: "25493",
          name: "Witu",
          state_id: "2005",
        },
        {
          id: "25494",
          name: "Wundanyi",
          state_id: "2005",
        },
      ],
      Eastern: [
        {
          id: "25495",
          name: "Athi River",
          state_id: "2006",
        },
        {
          id: "25496",
          name: "Chuka",
          state_id: "2006",
        },
        {
          id: "25497",
          name: "Embu",
          state_id: "2006",
        },
        {
          id: "25498",
          name: "Isiolo",
          state_id: "2006",
        },
        {
          id: "25499",
          name: "Kangonde",
          state_id: "2006",
        },
        {
          id: "25500",
          name: "Kitui",
          state_id: "2006",
        },
        {
          id: "25501",
          name: "Machakos",
          state_id: "2006",
        },
        {
          id: "25502",
          name: "Mado Gashi",
          state_id: "2006",
        },
        {
          id: "25503",
          name: "Marsabit",
          state_id: "2006",
        },
        {
          id: "25504",
          name: "Meru",
          state_id: "2006",
        },
        {
          id: "25505",
          name: "Moyale",
          state_id: "2006",
        },
        {
          id: "25506",
          name: "Mutomo",
          state_id: "2006",
        },
      ],
      Nairobi: [
        {
          id: "25507",
          name: "Nairobi",
          state_id: "2007",
        },
      ],
      "North Eastern": [],
      Nyanza: [
        {
          id: "25508",
          name: "Homa Bay",
          state_id: "2009",
        },
        {
          id: "25509",
          name: "Kisii",
          state_id: "2009",
        },
        {
          id: "25510",
          name: "Kisumu",
          state_id: "2009",
        },
        {
          id: "25511",
          name: "Migori",
          state_id: "2009",
        },
      ],
      "Rift Valley": [],
      Western: [
        {
          id: "25512",
          name: "Bungoma",
          state_id: "2011",
        },
        {
          id: "25513",
          name: "Busia",
          state_id: "2011",
        },
        {
          id: "25514",
          name: "Kakamega",
          state_id: "2011",
        },
        {
          id: "25515",
          name: "Mumias",
          state_id: "2011",
        },
        {
          id: "25516",
          name: "Webuye",
          state_id: "2011",
        },
      ],
    },
  },
  KG: {
    name: "Kyrgyzstan",
    native: "Кыргызстан",
    phone: "996",
    continent: "AS",
    capital: "Bishkek",
    currency: "KGS",
    languages: ["ky", "ru"],
    emoji: "🇰🇬",
    emojiU: "U+1F1F0 U+1F1EC",
    states: {
      Batken: [
        {
          id: "25842",
          name: "Batken",
          state_id: "2092",
        },
        {
          id: "25843",
          name: "Isfana",
          state_id: "2092",
        },
        {
          id: "25844",
          name: "Khaidarkan",
          state_id: "2092",
        },
        {
          id: "25845",
          name: "Kyzyl-Kiya",
          state_id: "2092",
        },
        {
          id: "25846",
          name: "Ravat",
          state_id: "2092",
        },
        {
          id: "25847",
          name: "Sulukta",
          state_id: "2092",
        },
      ],
      Bishkek: [
        {
          id: "25848",
          name: "Bishkek",
          state_id: "2093",
        },
      ],
      Chui: [
        {
          id: "25849",
          name: "Ak-Suu",
          state_id: "2094",
        },
        {
          id: "25850",
          name: "Belovodskoye",
          state_id: "2094",
        },
        {
          id: "25851",
          name: "Boroldoy",
          state_id: "2094",
        },
        {
          id: "25852",
          name: "Chaldovar",
          state_id: "2094",
        },
        {
          id: "25853",
          name: "Chatkyol",
          state_id: "2094",
        },
        {
          id: "25854",
          name: "Chui",
          state_id: "2094",
        },
        {
          id: "25855",
          name: "Don Arik",
          state_id: "2094",
        },
        {
          id: "25856",
          name: "Ivanovka",
          state_id: "2094",
        },
        {
          id: "25857",
          name: "Jangyjar",
          state_id: "2094",
        },
        {
          id: "25858",
          name: "Jangypakhtar",
          state_id: "2094",
        },
        {
          id: "25859",
          name: "Kalininskoye",
          state_id: "2094",
        },
        {
          id: "25860",
          name: "Kalinovka",
          state_id: "2094",
        },
        {
          id: "25861",
          name: "Kant",
          state_id: "2094",
        },
        {
          id: "25862",
          name: "Kara-Suu",
          state_id: "2094",
        },
        {
          id: "25863",
          name: "Karabalta",
          state_id: "2094",
        },
        {
          id: "25864",
          name: "Kayingdi",
          state_id: "2094",
        },
        {
          id: "25865",
          name: "Kegety",
          state_id: "2094",
        },
        {
          id: "25866",
          name: "Kemin",
          state_id: "2094",
        },
        {
          id: "25867",
          name: "Kosh Tegirmen",
          state_id: "2094",
        },
        {
          id: "25868",
          name: "Krasnaya Rechka",
          state_id: "2094",
        },
        {
          id: "25869",
          name: "Orlovka",
          state_id: "2094",
        },
        {
          id: "25870",
          name: "Sokuluk",
          state_id: "2094",
        },
        {
          id: "25871",
          name: "Sopokov",
          state_id: "2094",
        },
        {
          id: "25872",
          name: "Sosnovka",
          state_id: "2094",
        },
        {
          id: "25873",
          name: "Tokmok",
          state_id: "2094",
        },
        {
          id: "25874",
          name: "Tunuk",
          state_id: "2094",
        },
        {
          id: "25875",
          name: "Yuryevka",
          state_id: "2094",
        },
      ],
      "Issyk-Kul": [
        {
          id: "25876",
          name: "Ak-Bulok",
          state_id: "2095",
        },
        {
          id: "25877",
          name: "Ak-Terek",
          state_id: "2095",
        },
        {
          id: "25878",
          name: "Ananyevo",
          state_id: "2095",
        },
        {
          id: "25879",
          name: "Balykchy",
          state_id: "2095",
        },
        {
          id: "25880",
          name: "Barskoon",
          state_id: "2095",
        },
        {
          id: "25881",
          name: "Cholpon-Ata",
          state_id: "2095",
        },
        {
          id: "25882",
          name: "Darkhon",
          state_id: "2095",
        },
        {
          id: "25883",
          name: "Enilchek",
          state_id: "2095",
        },
        {
          id: "25884",
          name: "Grigoryevka",
          state_id: "2095",
        },
        {
          id: "25885",
          name: "Jyrgolon",
          state_id: "2095",
        },
        {
          id: "25886",
          name: "Kara-Say",
          state_id: "2095",
        },
        {
          id: "25887",
          name: "Karako",
          state_id: "2095",
        },
        {
          id: "25888",
          name: "Karakol",
          state_id: "2095",
        },
        {
          id: "25889",
          name: "Kuturgu",
          state_id: "2095",
        },
        {
          id: "25890",
          name: "Mikhaylovka",
          state_id: "2095",
        },
        {
          id: "25891",
          name: "Novovoznesenovka",
          state_id: "2095",
        },
        {
          id: "25892",
          name: "Ottuk",
          state_id: "2095",
        },
        {
          id: "25893",
          name: "Semyonovka",
          state_id: "2095",
        },
        {
          id: "25894",
          name: "Taldy-Suu",
          state_id: "2095",
        },
        {
          id: "25895",
          name: "Teploklyuchenka",
          state_id: "2095",
        },
        {
          id: "25896",
          name: "Tyup",
          state_id: "2095",
        },
      ],
      "Jalal-Abad": [
        {
          id: "25897",
          name: "Ala Buka",
          state_id: "2096",
        },
        {
          id: "25898",
          name: "Bazarkurgon",
          state_id: "2096",
        },
        {
          id: "25899",
          name: "Jalal-Abad",
          state_id: "2096",
        },
        {
          id: "25900",
          name: "Jangybazar",
          state_id: "2096",
        },
        {
          id: "25901",
          name: "Karavan",
          state_id: "2096",
        },
        {
          id: "25902",
          name: "Kochkor-Ata",
          state_id: "2096",
        },
        {
          id: "25903",
          name: "Kok-Jangak",
          state_id: "2096",
        },
        {
          id: "25904",
          name: "Mailuu-Suu",
          state_id: "2096",
        },
        {
          id: "25905",
          name: "Tash-Kumyr",
          state_id: "2096",
        },
      ],
      Naryn: [
        {
          id: "25906",
          name: "At-Bashi",
          state_id: "2097",
        },
        {
          id: "25907",
          name: "Chaiek",
          state_id: "2097",
        },
        {
          id: "25908",
          name: "Kara-Suu",
          state_id: "2097",
        },
        {
          id: "25909",
          name: "Kayirma",
          state_id: "2097",
        },
        {
          id: "25910",
          name: "Kek-Algyp",
          state_id: "2097",
        },
        {
          id: "25911",
          name: "Kochkorka",
          state_id: "2097",
        },
        {
          id: "25912",
          name: "Kulanak",
          state_id: "2097",
        },
        {
          id: "25913",
          name: "Mingbulok",
          state_id: "2097",
        },
        {
          id: "25914",
          name: "Mingkush",
          state_id: "2097",
        },
        {
          id: "25915",
          name: "Naryn",
          state_id: "2097",
        },
        {
          id: "25916",
          name: "Ugyut",
          state_id: "2097",
        },
      ],
      Osh: [
        {
          id: "25917",
          name: "Daraut-Korgan",
          state_id: "2098",
        },
        {
          id: "25918",
          name: "Gulcha",
          state_id: "2098",
        },
        {
          id: "25919",
          name: "Kara-Suu",
          state_id: "2098",
        },
        {
          id: "25920",
          name: "Leninskoye",
          state_id: "2098",
        },
        {
          id: "25921",
          name: "Osh",
          state_id: "2098",
        },
        {
          id: "25922",
          name: "Uzgen",
          state_id: "2098",
        },
      ],
      Talas: [
        {
          id: "25923",
          name: "Chat-Bazar",
          state_id: "2099",
        },
        {
          id: "25924",
          name: "Groznoye",
          state_id: "2099",
        },
        {
          id: "25925",
          name: "Kara-Kul",
          state_id: "2099",
        },
        {
          id: "25926",
          name: "Klyuchevka",
          state_id: "2099",
        },
        {
          id: "25927",
          name: "Kyzyl-Adyr",
          state_id: "2099",
        },
        {
          id: "25928",
          name: "Leninopol",
          state_id: "2099",
        },
        {
          id: "25929",
          name: "Maimak",
          state_id: "2099",
        },
        {
          id: "25930",
          name: "Talas",
          state_id: "2099",
        },
        {
          id: "25931",
          name: "Toktogul",
          state_id: "2099",
        },
      ],
    },
  },
  KH: {
    name: "Cambodia",
    native: "Kâmpŭchéa",
    phone: "855",
    continent: "AS",
    capital: "Phnom Penh",
    currency: "KHR",
    languages: ["km"],
    emoji: "🇰🇭",
    emojiU: "U+1F1F0 U+1F1ED",
    states: {
      "Banteay Mean Chey": [],
      "Bat Dambang": [],
      "Kampong Cham": [],
      "Kampong Chhnang": [],
      "Kampong Spoeu": [],
      "Kampong Thum": [],
      Kampot: [
        {
          id: "10008",
          name: "Kampot",
          state_id: "635",
        },
      ],
      Kandal: [
        {
          id: "10009",
          name: "Ta Khmau",
          state_id: "636",
        },
      ],
      "Kaoh Kong": [],
      Kracheh: [
        {
          id: "10010",
          name: "Kracheh",
          state_id: "638",
        },
      ],
      "Krong Kaeb": [],
      "Krong Pailin": [],
      "Krong Preah Sihanouk": [],
      "Mondol Kiri": [],
      "Otdar Mean Chey": [],
      "Phnum Penh": [],
      Pousat: [
        {
          id: "10011",
          name: "Pousat",
          state_id: "645",
        },
      ],
      "Preah Vihear": [],
      "Prey Veaeng": [],
      "Rotanak Kiri": [],
      "Siem Reab": [],
      "Stueng Traeng": [],
      "Svay Rieng": [],
      Takaev: [
        {
          id: "10012",
          name: "Phumi Takaev",
          state_id: "652",
        },
      ],
    },
  },
  KI: {
    name: "Kiribati",
    native: "Kiribati",
    phone: "686",
    continent: "OC",
    capital: "South Tarawa",
    currency: "AUD",
    languages: ["en"],
    emoji: "🇰🇮",
    emojiU: "U+1F1F0 U+1F1EE",
    states: {
      Abaiang: [
        {
          id: "25517",
          name: "Taburao",
          state_id: "2012",
        },
      ],
      Abemana: [
        {
          id: "25518",
          name: "Binoinano",
          state_id: "2013",
        },
      ],
      Aranuka: [
        {
          id: "25519",
          name: "Takaeang",
          state_id: "2014",
        },
      ],
      Arorae: [
        {
          id: "25520",
          name: "Roreti",
          state_id: "2015",
        },
      ],
      Banaba: [
        {
          id: "25521",
          name: "Ooma",
          state_id: "2016",
        },
      ],
      Beru: [
        {
          id: "25522",
          name: "Tabukiniberu",
          state_id: "2017",
        },
      ],
      Butaritari: [
        {
          id: "25523",
          name: "Butaritari",
          state_id: "2018",
        },
      ],
      Kiritimati: [
        {
          id: "25524",
          name: "London",
          state_id: "2019",
        },
      ],
      Kuria: [
        {
          id: "25525",
          name: "Tabontebike",
          state_id: "2020",
        },
      ],
      Maiana: [
        {
          id: "25526",
          name: "Tabiauea",
          state_id: "2021",
        },
      ],
      Makin: [
        {
          id: "25527",
          name: "Makin",
          state_id: "2022",
        },
      ],
      Marakei: [
        {
          id: "25528",
          name: "Rawannawi",
          state_id: "2023",
        },
      ],
      Nikunau: [
        {
          id: "25529",
          name: "Rungata",
          state_id: "2024",
        },
      ],
      Nonouti: [
        {
          id: "25530",
          name: "Temaraia",
          state_id: "2025",
        },
      ],
      Onotoa: [
        {
          id: "25531",
          name: "Ijaki",
          state_id: "2026",
        },
      ],
      "Phoenix Islands": [],
      "Tabiteuea North": [],
      "Tabiteuea South": [],
      Tabuaeran: [
        {
          id: "25532",
          name: "Nabari",
          state_id: "2030",
        },
      ],
      Tamana: [
        {
          id: "25533",
          name: "Abaokoro",
          state_id: "2031",
        },
      ],
      "Tarawa North": [],
      "Tarawa South": [],
      Teraina: [
        {
          id: "25534",
          name: "Washington",
          state_id: "2034",
        },
      ],
    },
  },
  KM: {
    name: "Comoros",
    native: "Komori",
    phone: "269",
    continent: "AF",
    capital: "Moroni",
    currency: "KMF",
    languages: ["ar", "fr"],
    emoji: "🇰🇲",
    emojiU: "U+1F1F0 U+1F1F2",
    states: {
      Mwali: [
        {
          id: "13532",
          name: "Fomboni",
          state_id: "808",
        },
      ],
      Njazidja: [
        {
          id: "13533",
          name: "Mitsamiouli",
          state_id: "809",
        },
        {
          id: "13534",
          name: "Moroni",
          state_id: "809",
        },
      ],
      Nzwani: [
        {
          id: "13535",
          name: "Domoni",
          state_id: "810",
        },
        {
          id: "13536",
          name: "Mutsamudu",
          state_id: "810",
        },
      ],
    },
  },
  KN: {
    name: "Saint Kitts and Nevis",
    native: "Saint Kitts and Nevis",
    phone: "1869",
    continent: "NA",
    capital: "Basseterre",
    currency: "XCD",
    languages: ["en"],
    emoji: "🇰🇳",
    emojiU: "U+1F1F0 U+1F1F3",
    states: {
      "Christ Church Nichola Town": [],
      "Saint Anne Sandy Point": [],
      "Saint George Basseterre": [],
      "Saint George Gingerland": [],
      "Saint James Windward": [],
      "Saint John Capesterre": [],
      "Saint John Figtree": [],
      "Saint Mary Cayon": [],
      "Saint Paul Capesterre": [],
      "Saint Paul Charlestown": [],
      "Saint Peter Basseterre": [],
      "Saint Thomas Lowland": [],
      "Saint Thomas Middle Island": [],
      "Trinity Palmetto Point": [],
    },
  },
  KP: {
    name: "North Korea",
    native: "북한",
    phone: "850",
    continent: "AS",
    capital: "Pyongyang",
    currency: "KPW",
    languages: ["ko"],
    emoji: "🇰🇵",
    emojiU: "U+1F1F0 U+1F1F5",
    states: {
      Chagangdo: [
        {
          id: "25535",
          name: "Kanggye",
          state_id: "2035",
        },
      ],
      Hamgyeongbukto: [
        {
          id: "25536",
          name: "Cheongjin",
          state_id: "2036",
        },
        {
          id: "25537",
          name: "Kimchaek",
          state_id: "2036",
        },
        {
          id: "25538",
          name: "Najin",
          state_id: "2036",
        },
      ],
      Hamgyeongnamdo: [
        {
          id: "25539",
          name: "Hamheung",
          state_id: "2037",
        },
      ],
      Hwanghaebukto: [
        {
          id: "25540",
          name: "Sariweon",
          state_id: "2038",
        },
        {
          id: "25541",
          name: "Seongnim",
          state_id: "2038",
        },
      ],
      Hwanghaenamdo: [
        {
          id: "25542",
          name: "Haeju",
          state_id: "2039",
        },
      ],
      Kaeseong: [
        {
          id: "25543",
          name: "Kaeseong",
          state_id: "2040",
        },
      ],
      Kangweon: [
        {
          id: "25544",
          name: "Weonsan",
          state_id: "2041",
        },
      ],
      Nampo: [
        {
          id: "25545",
          name: "Nampo",
          state_id: "2042",
        },
      ],
      Pyeonganbukto: [
        {
          id: "25546",
          name: "Sineuiju",
          state_id: "2043",
        },
      ],
      Pyeongannamdo: [
        {
          id: "25547",
          name: "Phyeongseong",
          state_id: "2044",
        },
      ],
      Pyeongyang: [
        {
          id: "25548",
          name: "Pyeongyang",
          state_id: "2045",
        },
        {
          id: "25549",
          name: "Pyongyang",
          state_id: "2045",
        },
      ],
      Yanggang: [
        {
          id: "25550",
          name: "Hyesan",
          state_id: "2046",
        },
      ],
    },
  },
  KR: {
    name: "South Korea",
    native: "대한민국",
    phone: "82",
    continent: "AS",
    capital: "Seoul",
    currency: "KRW",
    languages: ["ko"],
    emoji: "🇰🇷",
    emojiU: "U+1F1F0 U+1F1F7",
    states: {
      Busan: [
        {
          id: "25551",
          name: "Busan",
          state_id: "2047",
        },
      ],
      Cheju: [
        {
          id: "25552",
          name: "Aeweol",
          state_id: "2048",
        },
        {
          id: "25553",
          name: "Cheju",
          state_id: "2048",
        },
        {
          id: "25554",
          name: "Seogwipo",
          state_id: "2048",
        },
      ],
      Chollabuk: [
        {
          id: "25555",
          name: "Cheonju",
          state_id: "2049",
        },
        {
          id: "25556",
          name: "Chongup",
          state_id: "2049",
        },
        {
          id: "25557",
          name: "Iksan",
          state_id: "2049",
        },
        {
          id: "25558",
          name: "Kimje",
          state_id: "2049",
        },
        {
          id: "25559",
          name: "Kochang",
          state_id: "2049",
        },
        {
          id: "25560",
          name: "Kunsan",
          state_id: "2049",
        },
        {
          id: "25561",
          name: "Namwon",
          state_id: "2049",
        },
        {
          id: "25562",
          name: "Puan",
          state_id: "2049",
        },
      ],
      Chollanam: [
        {
          id: "25563",
          name: "Haenam",
          state_id: "2050",
        },
        {
          id: "25564",
          name: "Hwasun",
          state_id: "2050",
        },
        {
          id: "25565",
          name: "Kwangyang",
          state_id: "2050",
        },
        {
          id: "25566",
          name: "Kwangyang Up",
          state_id: "2050",
        },
        {
          id: "25567",
          name: "Mokpo",
          state_id: "2050",
        },
        {
          id: "25568",
          name: "Naju",
          state_id: "2050",
        },
        {
          id: "25569",
          name: "Peolgyo",
          state_id: "2050",
        },
        {
          id: "25570",
          name: "Suncheon",
          state_id: "2050",
        },
        {
          id: "25571",
          name: "Yeocheon",
          state_id: "2050",
        },
        {
          id: "25572",
          name: "Yeosu",
          state_id: "2050",
        },
        {
          id: "25573",
          name: "Yonggwang",
          state_id: "2050",
        },
      ],
      Chungbuk: [
        {
          id: "25574",
          name: "Cheongwon-gun",
          state_id: "2051",
        },
        {
          id: "25575",
          name: "Eumsung-Kun",
          state_id: "2051",
        },
        {
          id: "25576",
          name: "Jinchunkun",
          state_id: "2051",
        },
        {
          id: "25577",
          name: "Okcheon-gun",
          state_id: "2051",
        },
        {
          id: "25578",
          name: "Um Sung Gun",
          state_id: "2051",
        },
      ],
      Chungcheongbuk: [
        {
          id: "25579",
          name: "Chechon",
          state_id: "2052",
        },
        {
          id: "25580",
          name: "Cheongju",
          state_id: "2052",
        },
        {
          id: "25581",
          name: "Chincheon",
          state_id: "2052",
        },
        {
          id: "25582",
          name: "Chungju",
          state_id: "2052",
        },
        {
          id: "25583",
          name: "Jincheon-gun",
          state_id: "2052",
        },
        {
          id: "25584",
          name: "Okchon",
          state_id: "2052",
        },
        {
          id: "25585",
          name: "Yongdong",
          state_id: "2052",
        },
      ],
      Chungcheongnam: [
        {
          id: "25586",
          name: "Asan",
          state_id: "2053",
        },
        {
          id: "25587",
          name: "Cheonan",
          state_id: "2053",
        },
        {
          id: "25588",
          name: "Chochiwon",
          state_id: "2053",
        },
        {
          id: "25589",
          name: "Geumsan-Gun",
          state_id: "2053",
        },
        {
          id: "25590",
          name: "Hongseong",
          state_id: "2053",
        },
        {
          id: "25591",
          name: "Kongju",
          state_id: "2053",
        },
        {
          id: "25592",
          name: "Kumsan",
          state_id: "2053",
        },
        {
          id: "25593",
          name: "Nonsan",
          state_id: "2053",
        },
        {
          id: "25594",
          name: "Poryong",
          state_id: "2053",
        },
        {
          id: "25595",
          name: "Puyeo",
          state_id: "2053",
        },
        {
          id: "25596",
          name: "Seonghwan",
          state_id: "2053",
        },
        {
          id: "25597",
          name: "Seosan",
          state_id: "2053",
        },
        {
          id: "25598",
          name: "Taean",
          state_id: "2053",
        },
        {
          id: "25599",
          name: "Taesan",
          state_id: "2053",
        },
        {
          id: "25600",
          name: "Tangjin",
          state_id: "2053",
        },
        {
          id: "25601",
          name: "Yesan",
          state_id: "2053",
        },
        {
          id: "25602",
          name: "Yonmu",
          state_id: "2053",
        },
      ],
      Chungnam: [
        {
          id: "25603",
          name: "Chonan",
          state_id: "2054",
        },
        {
          id: "25604",
          name: "Danjin-gun",
          state_id: "2054",
        },
        {
          id: "25605",
          name: "Gongjusi",
          state_id: "2054",
        },
      ],
      Daegu: [
        {
          id: "25606",
          name: "Daegu",
          state_id: "2055",
        },
        {
          id: "25607",
          name: "Dalseo-gu",
          state_id: "2055",
        },
      ],
      "Gangwon-do": [
        {
          id: "25608",
          name: "Chungcheong",
          state_id: "2056",
        },
        {
          id: "25609",
          name: "Hoengseong",
          state_id: "2056",
        },
        {
          id: "25610",
          name: "Mummakeup",
          state_id: "2056",
        },
        {
          id: "25611",
          name: "Wonju",
          state_id: "2056",
        },
      ],
      "Goyang-si": [
        {
          id: "25612",
          name: "Gimhae",
          state_id: "2057",
        },
        {
          id: "25613",
          name: "Goyang-si",
          state_id: "2057",
        },
      ],
      "Gyeonggi-do": [
        {
          id: "25614",
          name: "Ansan",
          state_id: "2058",
        },
        {
          id: "25615",
          name: "Anyang",
          state_id: "2058",
        },
        {
          id: "25616",
          name: "Anyang-Si",
          state_id: "2058",
        },
        {
          id: "25617",
          name: "Anyangsi",
          state_id: "2058",
        },
        {
          id: "25618",
          name: "Buchon",
          state_id: "2058",
        },
        {
          id: "25619",
          name: "Buchun-Si",
          state_id: "2058",
        },
        {
          id: "25620",
          name: "Byeoryangdong",
          state_id: "2058",
        },
        {
          id: "25621",
          name: "Dongan-gu",
          state_id: "2058",
        },
        {
          id: "25622",
          name: "Gimpo City",
          state_id: "2058",
        },
        {
          id: "25623",
          name: "Goyang",
          state_id: "2058",
        },
        {
          id: "25624",
          name: "Gupo-si",
          state_id: "2058",
        },
        {
          id: "25625",
          name: "Guri-Si",
          state_id: "2058",
        },
        {
          id: "25626",
          name: "Gwacheon Si",
          state_id: "2058",
        },
        {
          id: "25627",
          name: "Gwangju-Si",
          state_id: "2058",
        },
        {
          id: "25628",
          name: "Hwaseong-si",
          state_id: "2058",
        },
        {
          id: "25629",
          name: "Icheon-si",
          state_id: "2058",
        },
        {
          id: "25630",
          name: "Iljuk-myeon",
          state_id: "2058",
        },
        {
          id: "25631",
          name: "Kwangju",
          state_id: "2058",
        },
        {
          id: "25632",
          name: "Pocheon-Si",
          state_id: "2058",
        },
        {
          id: "25633",
          name: "Seongnam",
          state_id: "2058",
        },
        {
          id: "25634",
          name: "Shihung-Si",
          state_id: "2058",
        },
        {
          id: "25635",
          name: "Siheung",
          state_id: "2058",
        },
        {
          id: "25636",
          name: "Sihung-si",
          state_id: "2058",
        },
        {
          id: "25637",
          name: "Suwon",
          state_id: "2058",
        },
        {
          id: "25638",
          name: "Uijeongbu-dong",
          state_id: "2058",
        },
        {
          id: "25639",
          name: "Uiwang",
          state_id: "2058",
        },
        {
          id: "25640",
          name: "Yangju",
          state_id: "2058",
        },
        {
          id: "25641",
          name: "Yangpyeong-Gun",
          state_id: "2058",
        },
        {
          id: "25642",
          name: "Yeokbuk-Dong-Si",
          state_id: "2058",
        },
      ],
      Gyeongsang: [],
      "Gyeongsangnam-do": [
        {
          id: "25643",
          name: "Changwon",
          state_id: "2060",
        },
        {
          id: "25644",
          name: "Gimhae-si",
          state_id: "2060",
        },
      ],
      Incheon: [
        {
          id: "25645",
          name: "Incheon",
          state_id: "2061",
        },
        {
          id: "25646",
          name: "Kanghwa",
          state_id: "2061",
        },
        {
          id: "25647",
          name: "Namdongku",
          state_id: "2061",
        },
      ],
      "Jeju-Si": [
        {
          id: "25648",
          name: "Jeju",
          state_id: "2062",
        },
        {
          id: "25649",
          name: "Yeongpyeong-Dong",
          state_id: "2062",
        },
      ],
      Jeonbuk: [
        {
          id: "25650",
          name: "Jeonju-Si",
          state_id: "2063",
        },
      ],
      Kangweon: [
        {
          id: "25651",
          name: "Chuncheon",
          state_id: "2064",
        },
        {
          id: "25652",
          name: "Hongcheon",
          state_id: "2064",
        },
        {
          id: "25653",
          name: "Kangneung",
          state_id: "2064",
        },
        {
          id: "25654",
          name: "Samchok",
          state_id: "2064",
        },
        {
          id: "25655",
          name: "Seokcho",
          state_id: "2064",
        },
        {
          id: "25656",
          name: "Taebaek",
          state_id: "2064",
        },
        {
          id: "25657",
          name: "Tonghae",
          state_id: "2064",
        },
        {
          id: "25658",
          name: "Weonju",
          state_id: "2064",
        },
        {
          id: "25659",
          name: "Yeongweol",
          state_id: "2064",
        },
      ],
      Kwangju: [
        {
          id: "25660",
          name: "Kwangju",
          state_id: "2065",
        },
      ],
      Kyeonggi: [
        {
          id: "25661",
          name: "Ansan",
          state_id: "2066",
        },
        {
          id: "25662",
          name: "Anseong",
          state_id: "2066",
        },
        {
          id: "25663",
          name: "Anyang",
          state_id: "2066",
        },
        {
          id: "25664",
          name: "Chongok",
          state_id: "2066",
        },
        {
          id: "25665",
          name: "Euijeongbu",
          state_id: "2066",
        },
        {
          id: "25666",
          name: "Euiwang",
          state_id: "2066",
        },
        {
          id: "25667",
          name: "Hanam",
          state_id: "2066",
        },
        {
          id: "25668",
          name: "Hoechon",
          state_id: "2066",
        },
        {
          id: "25669",
          name: "Hwado",
          state_id: "2066",
        },
        {
          id: "25670",
          name: "Hwasung",
          state_id: "2066",
        },
        {
          id: "25671",
          name: "Ichon",
          state_id: "2066",
        },
        {
          id: "25672",
          name: "Kihung",
          state_id: "2066",
        },
        {
          id: "25673",
          name: "Kimpo",
          state_id: "2066",
        },
        {
          id: "25674",
          name: "Koyang",
          state_id: "2066",
        },
        {
          id: "25675",
          name: "Kumchon",
          state_id: "2066",
        },
        {
          id: "25676",
          name: "Kunpo",
          state_id: "2066",
        },
        {
          id: "25677",
          name: "Kuri",
          state_id: "2066",
        },
        {
          id: "25678",
          name: "Kwacheon",
          state_id: "2066",
        },
        {
          id: "25679",
          name: "Kwangju",
          state_id: "2066",
        },
        {
          id: "25680",
          name: "Kwangmyeong",
          state_id: "2066",
        },
        {
          id: "25681",
          name: "Munsan",
          state_id: "2066",
        },
        {
          id: "25682",
          name: "Namyangju",
          state_id: "2066",
        },
        {
          id: "25683",
          name: "Osan",
          state_id: "2066",
        },
        {
          id: "25684",
          name: "Paengseong",
          state_id: "2066",
        },
        {
          id: "25685",
          name: "Pochon",
          state_id: "2066",
        },
        {
          id: "25686",
          name: "Pubal",
          state_id: "2066",
        },
        {
          id: "25687",
          name: "Pucheon",
          state_id: "2066",
        },
        {
          id: "25688",
          name: "Pyeongtaek",
          state_id: "2066",
        },
        {
          id: "25689",
          name: "Seongnam",
          state_id: "2066",
        },
        {
          id: "25690",
          name: "Shiheung",
          state_id: "2066",
        },
        {
          id: "25691",
          name: "Suweon",
          state_id: "2066",
        },
        {
          id: "25692",
          name: "Taean",
          state_id: "2066",
        },
        {
          id: "25693",
          name: "Tongducheon",
          state_id: "2066",
        },
        {
          id: "25694",
          name: "Wabu",
          state_id: "2066",
        },
        {
          id: "25695",
          name: "Yeoju",
          state_id: "2066",
        },
        {
          id: "25696",
          name: "Yongin",
          state_id: "2066",
        },
      ],
      Kyeongsangbuk: [
        {
          id: "25697",
          name: "Andong",
          state_id: "2067",
        },
        {
          id: "25698",
          name: "Angang",
          state_id: "2067",
        },
        {
          id: "25699",
          name: "Hayang",
          state_id: "2067",
        },
        {
          id: "25700",
          name: "Heunghae",
          state_id: "2067",
        },
        {
          id: "25701",
          name: "Kimcheon",
          state_id: "2067",
        },
        {
          id: "25702",
          name: "Kumi",
          state_id: "2067",
        },
        {
          id: "25703",
          name: "Kyeongju",
          state_id: "2067",
        },
        {
          id: "25704",
          name: "Kyeongsan",
          state_id: "2067",
        },
        {
          id: "25705",
          name: "Mungyong",
          state_id: "2067",
        },
        {
          id: "25706",
          name: "Ochon",
          state_id: "2067",
        },
        {
          id: "25707",
          name: "Oedong",
          state_id: "2067",
        },
        {
          id: "25708",
          name: "Pohang",
          state_id: "2067",
        },
        {
          id: "25709",
          name: "Sangju",
          state_id: "2067",
        },
        {
          id: "25710",
          name: "Seonsan",
          state_id: "2067",
        },
        {
          id: "25711",
          name: "Waegwan",
          state_id: "2067",
        },
        {
          id: "25712",
          name: "Yechon",
          state_id: "2067",
        },
        {
          id: "25713",
          name: "Yeongcheon",
          state_id: "2067",
        },
        {
          id: "25714",
          name: "Yeongju",
          state_id: "2067",
        },
        {
          id: "25715",
          name: "Yeonil",
          state_id: "2067",
        },
      ],
      Kyeongsangnam: [
        {
          id: "25716",
          name: "Changweon",
          state_id: "2068",
        },
        {
          id: "25717",
          name: "Chinhae",
          state_id: "2068",
        },
        {
          id: "25718",
          name: "Chinju",
          state_id: "2068",
        },
        {
          id: "25719",
          name: "Chinyeong",
          state_id: "2068",
        },
        {
          id: "25720",
          name: "Keoje",
          state_id: "2068",
        },
        {
          id: "25721",
          name: "Kimhae",
          state_id: "2068",
        },
        {
          id: "25722",
          name: "Kochang",
          state_id: "2068",
        },
        {
          id: "25723",
          name: "Koseong",
          state_id: "2068",
        },
        {
          id: "25724",
          name: "Masan",
          state_id: "2068",
        },
        {
          id: "25725",
          name: "Miryang",
          state_id: "2068",
        },
        {
          id: "25726",
          name: "Naeso",
          state_id: "2068",
        },
        {
          id: "25727",
          name: "Sacheon",
          state_id: "2068",
        },
        {
          id: "25728",
          name: "Sinhyeon",
          state_id: "2068",
        },
        {
          id: "25729",
          name: "Tongyong",
          state_id: "2068",
        },
        {
          id: "25730",
          name: "Ungsang",
          state_id: "2068",
        },
        {
          id: "25731",
          name: "Yangju",
          state_id: "2068",
        },
        {
          id: "25732",
          name: "Yangsan",
          state_id: "2068",
        },
      ],
      "Kyonggi-do": [
        {
          id: "25733",
          name: "Anyang-Si",
          state_id: "2069",
        },
        {
          id: "25734",
          name: "Bucheon",
          state_id: "2069",
        },
        {
          id: "25735",
          name: "Paju",
          state_id: "2069",
        },
        {
          id: "25736",
          name: "Sungnamshi",
          state_id: "2069",
        },
        {
          id: "25737",
          name: "Suwon",
          state_id: "2069",
        },
        {
          id: "25738",
          name: "Uijongbu",
          state_id: "2069",
        },
        {
          id: "25739",
          name: "Yangju",
          state_id: "2069",
        },
      ],
      "Kyungbuk-Do": [
        {
          id: "25740",
          name: "Gumi-Shi",
          state_id: "2070",
        },
        {
          id: "25741",
          name: "Kyungsan",
          state_id: "2070",
        },
        {
          id: "25742",
          name: "Youngcheon-Si",
          state_id: "2070",
        },
      ],
      "Kyunggi-Do": [
        {
          id: "25743",
          name: "Bundang",
          state_id: "2071",
        },
        {
          id: "25744",
          name: "Gunpo",
          state_id: "2071",
        },
        {
          id: "25745",
          name: "Yangu",
          state_id: "2071",
        },
      ],
      "Kyunggi-do": [
        {
          id: "25746",
          name: "Pochun",
          state_id: "2072",
        },
        {
          id: "25747",
          name: "Yangju",
          state_id: "2072",
        },
        {
          id: "25748",
          name: "Yonggi",
          state_id: "2072",
        },
      ],
      Pusan: [
        {
          id: "25749",
          name: "Kijang",
          state_id: "2073",
        },
        {
          id: "25750",
          name: "Pusan",
          state_id: "2073",
        },
      ],
      Seoul: [
        {
          id: "25751",
          name: "Seoul",
          state_id: "2074",
        },
      ],
      Sudogwon: [
        {
          id: "25752",
          name: "Paju",
          state_id: "2075",
        },
      ],
      Taegu: [
        {
          id: "25753",
          name: "Hwawon",
          state_id: "2076",
        },
        {
          id: "25754",
          name: "Taegu",
          state_id: "2076",
        },
      ],
      Taejeon: [
        {
          id: "25755",
          name: "Taejeon",
          state_id: "2077",
        },
      ],
      "Taejon-gwangyoksi": [
        {
          id: "25756",
          name: "Daejeon",
          state_id: "2078",
        },
      ],
      Ulsan: [
        {
          id: "25757",
          name: "Nongso",
          state_id: "2079",
        },
        {
          id: "25758",
          name: "Ulsan",
          state_id: "2079",
        },
      ],
      Wonju: [
        {
          id: "25759",
          name: "Heungup-Myun",
          state_id: "2080",
        },
      ],
      gwangyoksi: [
        {
          id: "25760",
          name: "Inchon",
          state_id: "2081",
        },
        {
          id: "25761",
          name: "Pusan",
          state_id: "2081",
        },
        {
          id: "25762",
          name: "Taejon",
          state_id: "2081",
        },
      ],
    },
  },
  KW: {
    name: "Kuwait",
    native: "الكويت",
    phone: "965",
    continent: "AS",
    capital: "Kuwait City",
    currency: "KWD",
    languages: ["ar"],
    emoji: "🇰🇼",
    emojiU: "U+1F1F0 U+1F1FC",
    states: {
      "Al Asimah": [],
      Hawalli: [
        {
          id: "25763",
          name: "Bayan",
          state_id: "2083",
        },
        {
          id: "25764",
          name: "Hawalli",
          state_id: "2083",
        },
        {
          id: "25765",
          name: "Massilah",
          state_id: "2083",
        },
        {
          id: "25766",
          name: "Mushrif",
          state_id: "2083",
        },
        {
          id: "25767",
          name: "Salwa",
          state_id: "2083",
        },
        {
          id: "25768",
          name: "Sha''''ab",
          state_id: "2083",
        },
        {
          id: "25769",
          name: "Subbah-as-Salim",
          state_id: "2083",
        },
        {
          id: "25770",
          name: "al-Funaytis",
          state_id: "2083",
        },
        {
          id: "25771",
          name: "al-Funaytis-al-Garbiyah",
          state_id: "2083",
        },
        {
          id: "25772",
          name: "al-Jabiriyah",
          state_id: "2083",
        },
        {
          id: "25773",
          name: "al-Karim",
          state_id: "2083",
        },
        {
          id: "25774",
          name: "ar-Rumaythiyah",
          state_id: "2083",
        },
        {
          id: "25775",
          name: "as-Salimiyah",
          state_id: "2083",
        },
      ],
      Mishref: [
        {
          id: "25776",
          name: "Mishref",
          state_id: "2084",
        },
      ],
      Qadesiya: [
        {
          id: "25777",
          name: "Qadesiya",
          state_id: "2085",
        },
      ],
      Safat: [
        {
          id: "25778",
          name: "Safat",
          state_id: "2086",
        },
      ],
      Salmiya: [
        {
          id: "25779",
          name: "Salmiya",
          state_id: "2087",
        },
      ],
      "al-Ahmadi": [
        {
          id: "25780",
          name: "A''qaylah",
          state_id: "2088",
        },
        {
          id: "25781",
          name: "Abu Hulayfah",
          state_id: "2088",
        },
        {
          id: "25782",
          name: "Dahar",
          state_id: "2088",
        },
        {
          id: "25783",
          name: "Desert Area",
          state_id: "2088",
        },
        {
          id: "25784",
          name: "Hadiyah",
          state_id: "2088",
        },
        {
          id: "25785",
          name: "Jabbar-al-''Ali",
          state_id: "2088",
        },
        {
          id: "25786",
          name: "Shu''aybah",
          state_id: "2088",
        },
        {
          id: "25787",
          name: "al-Ahmadi",
          state_id: "2088",
        },
        {
          id: "25788",
          name: "al-Fintas",
          state_id: "2088",
        },
        {
          id: "25789",
          name: "al-Fuhayhil",
          state_id: "2088",
        },
        {
          id: "25790",
          name: "al-Mahbulah",
          state_id: "2088",
        },
        {
          id: "25791",
          name: "al-Manqaf",
          state_id: "2088",
        },
        {
          id: "25792",
          name: "al-Wafrah",
          state_id: "2088",
        },
        {
          id: "25793",
          name: "ar-Riqqah",
          state_id: "2088",
        },
        {
          id: "25794",
          name: "as-Sabahiyah",
          state_id: "2088",
        },
        {
          id: "25795",
          name: "az-Zawr",
          state_id: "2088",
        },
      ],
      "al-Farwaniyah": [
        {
          id: "25796",
          name: "Umayriyah",
          state_id: "2089",
        },
        {
          id: "25797",
          name: "Abraq Khitan",
          state_id: "2089",
        },
        {
          id: "25798",
          name: "Ardiyah",
          state_id: "2089",
        },
        {
          id: "25799",
          name: "Fardaws",
          state_id: "2089",
        },
        {
          id: "25800",
          name: "Jalib ash-Shuyuh",
          state_id: "2089",
        },
        {
          id: "25801",
          name: "Janub-as-Surrah",
          state_id: "2089",
        },
        {
          id: "25802",
          name: "Khitan-al-Janubiyah",
          state_id: "2089",
        },
        {
          id: "25803",
          name: "Qartaba",
          state_id: "2089",
        },
        {
          id: "25804",
          name: "Ray",
          state_id: "2089",
        },
        {
          id: "25805",
          name: "Riqay",
          state_id: "2089",
        },
        {
          id: "25806",
          name: "Sabhan",
          state_id: "2089",
        },
        {
          id: "25807",
          name: "Sarbah-an-Nasr",
          state_id: "2089",
        },
        {
          id: "25808",
          name: "Warmawk",
          state_id: "2089",
        },
        {
          id: "25809",
          name: "al-Andalus",
          state_id: "2089",
        },
        {
          id: "25810",
          name: "al-Farwaniyah",
          state_id: "2089",
        },
        {
          id: "25811",
          name: "ar-Rabbiyah",
          state_id: "2089",
        },
      ],
      "al-Jahra": [
        {
          id: "25812",
          name: "Amgarah",
          state_id: "2090",
        },
        {
          id: "25813",
          name: "Desert Area",
          state_id: "2090",
        },
        {
          id: "25814",
          name: "Nasim",
          state_id: "2090",
        },
        {
          id: "25815",
          name: "Tayma",
          state_id: "2090",
        },
        {
          id: "25816",
          name: "Uyawn",
          state_id: "2090",
        },
        {
          id: "25817",
          name: "Waha",
          state_id: "2090",
        },
        {
          id: "25818",
          name: "al-Jahra",
          state_id: "2090",
        },
        {
          id: "25819",
          name: "al-Qusayr",
          state_id: "2090",
        },
        {
          id: "25820",
          name: "as-Sulaybiyah",
          state_id: "2090",
        },
      ],
      "al-Kuwayt": [
        {
          id: "25821",
          name: "Abullah-as-Salam",
          state_id: "2091",
        },
        {
          id: "25822",
          name: "Ardhiyah",
          state_id: "2091",
        },
        {
          id: "25823",
          name: "Banayd-al-Qar",
          state_id: "2091",
        },
        {
          id: "25824",
          name: "Health District",
          state_id: "2091",
        },
        {
          id: "25825",
          name: "Kayfan",
          state_id: "2091",
        },
        {
          id: "25826",
          name: "Khalidiyah",
          state_id: "2091",
        },
        {
          id: "25827",
          name: "Mansuriyah",
          state_id: "2091",
        },
        {
          id: "25828",
          name: "Nuzha",
          state_id: "2091",
        },
        {
          id: "25829",
          name: "Qarnadah",
          state_id: "2091",
        },
        {
          id: "25830",
          name: "Shamiyah",
          state_id: "2091",
        },
        {
          id: "25831",
          name: "ad-Da''iyah",
          state_id: "2091",
        },
        {
          id: "25832",
          name: "ad-Dasma",
          state_id: "2091",
        },
        {
          id: "25833",
          name: "ad-Dawhah",
          state_id: "2091",
        },
        {
          id: "25834",
          name: "al-''Udayliyah",
          state_id: "2091",
        },
        {
          id: "25835",
          name: "al-Fayha",
          state_id: "2091",
        },
        {
          id: "25836",
          name: "al-Kuwayt",
          state_id: "2091",
        },
        {
          id: "25837",
          name: "al-Qadisiyah",
          state_id: "2091",
        },
        {
          id: "25838",
          name: "ar-Rawdah",
          state_id: "2091",
        },
        {
          id: "25839",
          name: "as-Sulaybihat",
          state_id: "2091",
        },
        {
          id: "25840",
          name: "ash-Shuwaykh Industrial",
          state_id: "2091",
        },
        {
          id: "25841",
          name: "ash-Shuwaykh Reservoir",
          state_id: "2091",
        },
      ],
    },
  },
  KY: {
    name: "Cayman Islands",
    native: "Cayman Islands",
    phone: "1345",
    continent: "NA",
    capital: "George Town",
    currency: "KYD",
    languages: ["en"],
    emoji: "🇰🇾",
    emojiU: "U+1F1F0 U+1F1FE",
    states: {
      "Grand Cayman": [],
    },
  },
  KZ: {
    name: "Kazakhstan",
    native: "Қазақстан",
    phone: "76,77",
    continent: "AS",
    capital: "Astana",
    currency: "KZT",
    languages: ["kk", "ru"],
    emoji: "🇰🇿",
    emojiU: "U+1F1F0 U+1F1FF",
    states: {
      Akmecet: [
        {
          id: "25343",
          name: "Akmecet",
          state_id: "1989",
        },
        {
          id: "25344",
          name: "Aral",
          state_id: "1989",
        },
        {
          id: "25345",
          name: "Baykonir",
          state_id: "1989",
        },
        {
          id: "25346",
          name: "Canakazali",
          state_id: "1989",
        },
        {
          id: "25347",
          name: "Canakorgan",
          state_id: "1989",
        },
        {
          id: "25348",
          name: "Cosali",
          state_id: "1989",
        },
        {
          id: "25349",
          name: "Kazali",
          state_id: "1989",
        },
        {
          id: "25350",
          name: "Sieli",
          state_id: "1989",
        },
        {
          id: "25351",
          name: "Tasboget",
          state_id: "1989",
        },
      ],
      Akmola: [
        {
          id: "25352",
          name: "Aksu",
          state_id: "1990",
        },
        {
          id: "25353",
          name: "Alekseevka",
          state_id: "1990",
        },
        {
          id: "25354",
          name: "Astana",
          state_id: "1990",
        },
        {
          id: "25355",
          name: "Atbasar",
          state_id: "1990",
        },
        {
          id: "25356",
          name: "Bestobe",
          state_id: "1990",
        },
        {
          id: "25357",
          name: "Caltir",
          state_id: "1990",
        },
        {
          id: "25358",
          name: "Colimbet",
          state_id: "1990",
        },
        {
          id: "25359",
          name: "Ereymentau",
          state_id: "1990",
        },
        {
          id: "25360",
          name: "Koksetau",
          state_id: "1990",
        },
        {
          id: "25361",
          name: "Makin",
          state_id: "1990",
        },
        {
          id: "25362",
          name: "Stepnogorsk",
          state_id: "1990",
        },
      ],
      Aktobe: [
        {
          id: "25363",
          name: "Aktobe",
          state_id: "1991",
        },
        {
          id: "25364",
          name: "Alka",
          state_id: "1991",
        },
        {
          id: "25365",
          name: "Batamsi",
          state_id: "1991",
        },
        {
          id: "25366",
          name: "Embi",
          state_id: "1991",
        },
        {
          id: "25367",
          name: "Hromtau",
          state_id: "1991",
        },
        {
          id: "25368",
          name: "Kandagac",
          state_id: "1991",
        },
        {
          id: "25369",
          name: "Salkar",
          state_id: "1991",
        },
        {
          id: "25370",
          name: "Subarkudik",
          state_id: "1991",
        },
        {
          id: "25371",
          name: "Subarsi",
          state_id: "1991",
        },
        {
          id: "25372",
          name: "Temir",
          state_id: "1991",
        },
      ],
      Almati: [
        {
          id: "25373",
          name: "Almati",
          state_id: "1992",
        },
        {
          id: "25374",
          name: "Almaty",
          state_id: "1992",
        },
        {
          id: "25375",
          name: "Boralday",
          state_id: "1992",
        },
        {
          id: "25376",
          name: "Carkant",
          state_id: "1992",
        },
        {
          id: "25377",
          name: "Energetyceskiy",
          state_id: "1992",
        },
        {
          id: "25378",
          name: "Esik",
          state_id: "1992",
        },
        {
          id: "25379",
          name: "Fabrichniy",
          state_id: "1992",
        },
        {
          id: "25380",
          name: "Kapsagay",
          state_id: "1992",
        },
        {
          id: "25381",
          name: "Karabulak",
          state_id: "1992",
        },
        {
          id: "25382",
          name: "Kaskelen",
          state_id: "1992",
        },
        {
          id: "25383",
          name: "Kirov",
          state_id: "1992",
        },
        {
          id: "25384",
          name: "Sariozek",
          state_id: "1992",
        },
        {
          id: "25385",
          name: "Sarkand",
          state_id: "1992",
        },
        {
          id: "25386",
          name: "Selek",
          state_id: "1992",
        },
        {
          id: "25387",
          name: "Taldikorgan",
          state_id: "1992",
        },
        {
          id: "25388",
          name: "Talgar",
          state_id: "1992",
        },
        {
          id: "25389",
          name: "Tekeli",
          state_id: "1992",
        },
        {
          id: "25390",
          name: "Ustobe",
          state_id: "1992",
        },
        {
          id: "25391",
          name: "Uzunagac",
          state_id: "1992",
        },
      ],
      Atirau: [
        {
          id: "25392",
          name: "Atirau",
          state_id: "1993",
        },
        {
          id: "25393",
          name: "Atyrau",
          state_id: "1993",
        },
        {
          id: "25394",
          name: "Dossor",
          state_id: "1993",
        },
        {
          id: "25395",
          name: "Inderbor",
          state_id: "1993",
        },
        {
          id: "25396",
          name: "Karaton",
          state_id: "1993",
        },
        {
          id: "25397",
          name: "Kulsari",
          state_id: "1993",
        },
        {
          id: "25398",
          name: "Makat",
          state_id: "1993",
        },
        {
          id: "25399",
          name: "Oporni",
          state_id: "1993",
        },
        {
          id: "25400",
          name: "Sumisker",
          state_id: "1993",
        },
      ],
      "Batis Kazakstan": [],
      "Burlinsky Region": [],
      Karagandi: [
        {
          id: "25401",
          name: "Abay",
          state_id: "1996",
        },
        {
          id: "25402",
          name: "Akadir",
          state_id: "1996",
        },
        {
          id: "25403",
          name: "Aktas",
          state_id: "1996",
        },
        {
          id: "25404",
          name: "Aktau",
          state_id: "1996",
        },
        {
          id: "25405",
          name: "Atasu",
          state_id: "1996",
        },
        {
          id: "25406",
          name: "Balkas",
          state_id: "1996",
        },
        {
          id: "25407",
          name: "Cayrem",
          state_id: "1996",
        },
        {
          id: "25408",
          name: "Cezkazgan",
          state_id: "1996",
        },
        {
          id: "25409",
          name: "Gulsat",
          state_id: "1996",
        },
        {
          id: "25410",
          name: "Karacal",
          state_id: "1996",
        },
        {
          id: "25411",
          name: "Karaganda",
          state_id: "1996",
        },
        {
          id: "25412",
          name: "Karkarali",
          state_id: "1996",
        },
        {
          id: "25413",
          name: "Karsakbay",
          state_id: "1996",
        },
        {
          id: "25414",
          name: "Konrat",
          state_id: "1996",
        },
        {
          id: "25415",
          name: "Novodolinskiy",
          state_id: "1996",
        },
        {
          id: "25416",
          name: "Osakarovka",
          state_id: "1996",
        },
        {
          id: "25417",
          name: "Sahti",
          state_id: "1996",
        },
        {
          id: "25418",
          name: "Saran",
          state_id: "1996",
        },
        {
          id: "25419",
          name: "Sarisagan",
          state_id: "1996",
        },
        {
          id: "25420",
          name: "Satpaev",
          state_id: "1996",
        },
        {
          id: "25421",
          name: "Temirtau",
          state_id: "1996",
        },
        {
          id: "25422",
          name: "Tokaryovka",
          state_id: "1996",
        },
      ],
      Kostanay: [
        {
          id: "25423",
          name: "Arkalik",
          state_id: "1997",
        },
        {
          id: "25424",
          name: "Borovskoy",
          state_id: "1997",
        },
        {
          id: "25425",
          name: "Cetikara",
          state_id: "1997",
        },
        {
          id: "25426",
          name: "Derjavinsk",
          state_id: "1997",
        },
        {
          id: "25427",
          name: "Esil",
          state_id: "1997",
        },
        {
          id: "25428",
          name: "Fodorov",
          state_id: "1997",
        },
        {
          id: "25429",
          name: "Kacar",
          state_id: "1997",
        },
        {
          id: "25430",
          name: "Komsomol",
          state_id: "1997",
        },
        {
          id: "25431",
          name: "Kostanay",
          state_id: "1997",
        },
        {
          id: "25432",
          name: "Kusmurin",
          state_id: "1997",
        },
        {
          id: "25433",
          name: "Lisakovsk",
          state_id: "1997",
        },
        {
          id: "25434",
          name: "Rudni",
          state_id: "1997",
        },
        {
          id: "25435",
          name: "Tobol",
          state_id: "1997",
        },
        {
          id: "25436",
          name: "Uritsk",
          state_id: "1997",
        },
        {
          id: "25437",
          name: "Zatobolsk",
          state_id: "1997",
        },
      ],
      Mankistau: [
        {
          id: "25438",
          name: "Aktau",
          state_id: "1998",
        },
        {
          id: "25439",
          name: "Beyneu",
          state_id: "1998",
        },
        {
          id: "25440",
          name: "Canaozen",
          state_id: "1998",
        },
        {
          id: "25441",
          name: "Cetibay",
          state_id: "1998",
        },
        {
          id: "25442",
          name: "Fort-Sevcenko",
          state_id: "1998",
        },
        {
          id: "25443",
          name: "Kurik",
          state_id: "1998",
        },
        {
          id: "25444",
          name: "Mangyslak",
          state_id: "1998",
        },
        {
          id: "25445",
          name: "Setpe",
          state_id: "1998",
        },
      ],
      "Ontustik Kazakstan": [],
      Pavlodar: [
        {
          id: "25446",
          name: "Ekibastuz",
          state_id: "2000",
        },
        {
          id: "25447",
          name: "Ermak",
          state_id: "2000",
        },
        {
          id: "25448",
          name: "Ertis",
          state_id: "2000",
        },
        {
          id: "25449",
          name: "Kaciri",
          state_id: "2000",
        },
        {
          id: "25450",
          name: "Maykain",
          state_id: "2000",
        },
        {
          id: "25451",
          name: "Pavlodar",
          state_id: "2000",
        },
        {
          id: "25452",
          name: "Sarbakti",
          state_id: "2000",
        },
      ],
      "Sigis Kazakstan": [],
      "Soltustik Kazakstan": [],
      Taraz: [
        {
          id: "25453",
          name: "Canatas",
          state_id: "2003",
        },
        {
          id: "25454",
          name: "Georgiyev",
          state_id: "2003",
        },
        {
          id: "25455",
          name: "Karatau",
          state_id: "2003",
        },
        {
          id: "25456",
          name: "Lugovoy",
          state_id: "2003",
        },
        {
          id: "25457",
          name: "Merke",
          state_id: "2003",
        },
        {
          id: "25458",
          name: "Mihaylov",
          state_id: "2003",
        },
        {
          id: "25459",
          name: "Oytal",
          state_id: "2003",
        },
        {
          id: "25460",
          name: "Su",
          state_id: "2003",
        },
        {
          id: "25461",
          name: "Taraz",
          state_id: "2003",
        },
      ],
    },
  },
  LA: {
    name: "Laos",
    native: "ສປປລາວ",
    phone: "856",
    continent: "AS",
    capital: "Vientiane",
    currency: "LAK",
    languages: ["lo"],
    emoji: "🇱🇦",
    emojiU: "U+1F1F1 U+1F1E6",
    states: {
      Attopu: [
        {
          id: "25932",
          name: "Samakhixai",
          state_id: "2100",
        },
      ],
      Bokeo: [
        {
          id: "25933",
          name: "Huayxay",
          state_id: "2101",
        },
      ],
      Bolikhamsay: [
        {
          id: "25934",
          name: "Pakxan",
          state_id: "2102",
        },
      ],
      Champasak: [
        {
          id: "25935",
          name: "Champasak",
          state_id: "2103",
        },
        {
          id: "25936",
          name: "Muang Khong",
          state_id: "2103",
        },
        {
          id: "25937",
          name: "Muang Khongxedon",
          state_id: "2103",
        },
        {
          id: "25938",
          name: "Pakxe",
          state_id: "2103",
        },
      ],
      Houaphanh: [
        {
          id: "25939",
          name: "Xam Nua",
          state_id: "2104",
        },
      ],
      Khammouane: [
        {
          id: "25940",
          name: "Thakek",
          state_id: "2105",
        },
      ],
      "Luang Nam Tha": [],
      "Luang Prabang": [],
      Oudomxay: [
        {
          id: "25941",
          name: "Ban Nahin",
          state_id: "2108",
        },
      ],
      Phongsaly: [
        {
          id: "25942",
          name: "Phongsaly",
          state_id: "2109",
        },
      ],
      Saravan: [
        {
          id: "25943",
          name: "Saravan",
          state_id: "2110",
        },
      ],
      Savannakhet: [
        {
          id: "25944",
          name: "Savannakhet",
          state_id: "2111",
        },
      ],
      Sekong: [
        {
          id: "25945",
          name: "Sekong",
          state_id: "2112",
        },
      ],
      "Viangchan Prefecture": [],
      "Viangchan Province": [],
      Xaignabury: [
        {
          id: "25946",
          name: "Xaignabury",
          state_id: "2115",
        },
      ],
      "Xiang Khuang": [],
    },
  },
  LB: {
    name: "Lebanon",
    native: "لبنان",
    phone: "961",
    continent: "AS",
    capital: "Beirut",
    currency: "LBP",
    languages: ["ar", "fr"],
    emoji: "🇱🇧",
    emojiU: "U+1F1F1 U+1F1E7",
    states: {
      Beirut: [
        {
          id: "26025",
          name: "Beirut",
          state_id: "2150",
        },
        {
          id: "26026",
          name: "Jdeidet el Metn",
          state_id: "2150",
        },
        {
          id: "26027",
          name: "Jnaah",
          state_id: "2150",
        },
      ],
      "Jabal Lubnan": [],
      "Mohafazat Liban-Nord": [],
      "Mohafazat Mont-Liban": [],
      Sidon: [
        {
          id: "26028",
          name: "Sidon",
          state_id: "2154",
        },
      ],
      "al-Biqa": [
        {
          id: "26029",
          name: "Ba''labakk",
          state_id: "2155",
        },
        {
          id: "26030",
          name: "Jubb Jannin",
          state_id: "2155",
        },
        {
          id: "26031",
          name: "Rashayya",
          state_id: "2155",
        },
        {
          id: "26032",
          name: "Riyak",
          state_id: "2155",
        },
        {
          id: "26033",
          name: "Zahlah",
          state_id: "2155",
        },
        {
          id: "26034",
          name: "al-Hirmil",
          state_id: "2155",
        },
      ],
      "al-Janub": [
        {
          id: "26035",
          name: "Jazzin",
          state_id: "2156",
        },
        {
          id: "26036",
          name: "Juwayya",
          state_id: "2156",
        },
        {
          id: "26037",
          name: "Sayda",
          state_id: "2156",
        },
        {
          id: "26038",
          name: "Sur",
          state_id: "2156",
        },
      ],
      "an-Nabatiyah": [
        {
          id: "26039",
          name: "Marj ''Uyun",
          state_id: "2157",
        },
        {
          id: "26040",
          name: "Nabatieh",
          state_id: "2157",
        },
        {
          id: "26041",
          name: "an-Nabatiyat-at-Tahta",
          state_id: "2157",
        },
      ],
      "ash-Shamal": [
        {
          id: "26042",
          name: "Tarabulus ash-Sham",
          state_id: "2158",
        },
        {
          id: "26043",
          name: "al-Batrun",
          state_id: "2158",
        },
      ],
    },
  },
  LC: {
    name: "Saint Lucia",
    native: "Saint Lucia",
    phone: "1758",
    continent: "NA",
    capital: "Castries",
    currency: "XCD",
    languages: ["en"],
    emoji: "🇱🇨",
    emojiU: "U+1F1F1 U+1F1E8",
    states: {
      "Anse-la-Raye": [
        {
          id: "37370",
          name: "Anse-la-Raye",
          state_id: "3102",
        },
      ],
      Canaries: [
        {
          id: "37371",
          name: "Canaries",
          state_id: "3103",
        },
      ],
      Castries: [
        {
          id: "37372",
          name: "Castries",
          state_id: "3104",
        },
        {
          id: "37373",
          name: "Choc",
          state_id: "3104",
        },
      ],
      Choiseul: [
        {
          id: "37374",
          name: "Choiseul",
          state_id: "3105",
        },
      ],
      Dennery: [
        {
          id: "37375",
          name: "Dennery",
          state_id: "3106",
        },
      ],
      "Gros Inlet": [],
      Laborie: [
        {
          id: "37376",
          name: "Laborie",
          state_id: "3108",
        },
      ],
      Micoud: [
        {
          id: "37377",
          name: "Micoud",
          state_id: "3109",
        },
      ],
      Soufriere: [
        {
          id: "37378",
          name: "Soufriere",
          state_id: "3110",
        },
      ],
      "Vieux Fort": [],
    },
  },
  LI: {
    name: "Liechtenstein",
    native: "Liechtenstein",
    phone: "423",
    continent: "EU",
    capital: "Vaduz",
    currency: "CHF",
    languages: ["de"],
    emoji: "🇱🇮",
    emojiU: "U+1F1F1 U+1F1EE",
    states: {
      Balzers: [
        {
          id: "26101",
          name: "Balzers",
          state_id: "2207",
        },
      ],
      Eschen: [
        {
          id: "26102",
          name: "Eschen",
          state_id: "2208",
        },
      ],
      Gamprin: [
        {
          id: "26103",
          name: "Gamprin",
          state_id: "2209",
        },
      ],
      Mauren: [
        {
          id: "26104",
          name: "Mauren",
          state_id: "2210",
        },
      ],
      Planken: [
        {
          id: "26105",
          name: "Planken",
          state_id: "2211",
        },
      ],
      Ruggell: [
        {
          id: "26106",
          name: "Ruggell",
          state_id: "2212",
        },
      ],
      Schaan: [
        {
          id: "26107",
          name: "Schaan",
          state_id: "2213",
        },
      ],
      Schellenberg: [
        {
          id: "26108",
          name: "Schellenberg",
          state_id: "2214",
        },
      ],
      Triesen: [
        {
          id: "26109",
          name: "Triesen",
          state_id: "2215",
        },
      ],
      Triesenberg: [
        {
          id: "26110",
          name: "Triesenberg",
          state_id: "2216",
        },
      ],
      Vaduz: [
        {
          id: "26111",
          name: "Vaduz",
          state_id: "2217",
        },
      ],
    },
  },
  LK: {
    name: "Sri Lanka",
    native: "śrī laṃkāva",
    phone: "94",
    continent: "AS",
    capital: "Colombo",
    currency: "LKR",
    languages: ["si", "ta"],
    emoji: "🇱🇰",
    emojiU: "U+1F1F1 U+1F1F0",
    states: {
      Amparai: [
        {
          id: "38855",
          name: "Amparai",
          state_id: "3320",
        },
        {
          id: "38856",
          name: "Galmune",
          state_id: "3320",
        },
      ],
      Anuradhapuraya: [
        {
          id: "38857",
          name: "Anuradhapuraya",
          state_id: "3321",
        },
      ],
      Badulla: [
        {
          id: "38858",
          name: "Badulla",
          state_id: "3322",
        },
        {
          id: "38859",
          name: "Bandarawela",
          state_id: "3322",
        },
        {
          id: "38860",
          name: "Haputale",
          state_id: "3322",
        },
      ],
      Boralesgamuwa: [
        {
          id: "38861",
          name: "Boralesgamuwa",
          state_id: "3323",
        },
      ],
      Colombo: [
        {
          id: "38862",
          name: "Battaramulla",
          state_id: "3324",
        },
        {
          id: "38863",
          name: "Colombo",
          state_id: "3324",
        },
        {
          id: "38864",
          name: "Dehiwala-Mount Lavinia",
          state_id: "3324",
        },
        {
          id: "38865",
          name: "Homagama",
          state_id: "3324",
        },
        {
          id: "38866",
          name: "Jayawardanapura",
          state_id: "3324",
        },
        {
          id: "38867",
          name: "Kolonnawa",
          state_id: "3324",
        },
        {
          id: "38868",
          name: "Kotikawatta",
          state_id: "3324",
        },
        {
          id: "38869",
          name: "Maharagama",
          state_id: "3324",
        },
        {
          id: "38870",
          name: "Moratuwa",
          state_id: "3324",
        },
        {
          id: "38871",
          name: "Mulleriyawa",
          state_id: "3324",
        },
        {
          id: "38872",
          name: "Ratmalana",
          state_id: "3324",
        },
        {
          id: "38873",
          name: "Seethawakapura",
          state_id: "3324",
        },
        {
          id: "38874",
          name: "Sri Jayawardanapura",
          state_id: "3324",
        },
      ],
      Galla: [
        {
          id: "38875",
          name: "Ambalamgoda",
          state_id: "3325",
        },
        {
          id: "38876",
          name: "Galla",
          state_id: "3325",
        },
      ],
      Gampaha: [
        {
          id: "38877",
          name: "Daluguma",
          state_id: "3326",
        },
        {
          id: "38878",
          name: "Gampaha",
          state_id: "3326",
        },
        {
          id: "38879",
          name: "Hendala",
          state_id: "3326",
        },
        {
          id: "38880",
          name: "Jaela",
          state_id: "3326",
        },
        {
          id: "38881",
          name: "Kandana",
          state_id: "3326",
        },
        {
          id: "38882",
          name: "Katunayaka",
          state_id: "3326",
        },
        {
          id: "38883",
          name: "Kelaniya",
          state_id: "3326",
        },
        {
          id: "38884",
          name: "Migamuwa",
          state_id: "3326",
        },
        {
          id: "38885",
          name: "Minuwangoda",
          state_id: "3326",
        },
        {
          id: "38886",
          name: "Peliyagoda",
          state_id: "3326",
        },
        {
          id: "38887",
          name: "Ragama",
          state_id: "3326",
        },
        {
          id: "38888",
          name: "Wattala",
          state_id: "3326",
        },
        {
          id: "38889",
          name: "Welesara",
          state_id: "3326",
        },
      ],
      Hambantota: [
        {
          id: "38890",
          name: "Hambantota",
          state_id: "3327",
        },
        {
          id: "38891",
          name: "Tanggalla",
          state_id: "3327",
        },
      ],
      Kalatura: [
        {
          id: "38892",
          name: "Beruwala",
          state_id: "3328",
        },
        {
          id: "38893",
          name: "Horana",
          state_id: "3328",
        },
        {
          id: "38894",
          name: "Kalutara",
          state_id: "3328",
        },
        {
          id: "38895",
          name: "Keselwatta",
          state_id: "3328",
        },
        {
          id: "38896",
          name: "Panadraya",
          state_id: "3328",
        },
      ],
      Kegalla: [
        {
          id: "38897",
          name: "Kegalla",
          state_id: "3329",
        },
      ],
      Kilinochchi: [
        {
          id: "38898",
          name: "Kilinochchi",
          state_id: "3330",
        },
      ],
      Kurunegala: [
        {
          id: "38899",
          name: "Kuliyapitiya",
          state_id: "3331",
        },
        {
          id: "38900",
          name: "Kurunegala",
          state_id: "3331",
        },
        {
          id: "38901",
          name: "Polgahawela",
          state_id: "3331",
        },
      ],
      Madakalpuwa: [
        {
          id: "38902",
          name: "Eravur",
          state_id: "3332",
        },
        {
          id: "38903",
          name: "Katankudi",
          state_id: "3332",
        },
        {
          id: "38904",
          name: "Madakalpuwa",
          state_id: "3332",
        },
      ],
      "Maha Nuwara": [],
      Malwana: [
        {
          id: "38905",
          name: "Malwana",
          state_id: "3334",
        },
      ],
      Mannarama: [
        {
          id: "38906",
          name: "Mannarama",
          state_id: "3335",
        },
      ],
      Matale: [
        {
          id: "38907",
          name: "Dambulla",
          state_id: "3336",
        },
        {
          id: "38908",
          name: "Matale",
          state_id: "3336",
        },
        {
          id: "38909",
          name: "Sigiriya",
          state_id: "3336",
        },
      ],
      Matara: [
        {
          id: "38910",
          name: "Matara",
          state_id: "3337",
        },
        {
          id: "38911",
          name: "Weligama",
          state_id: "3337",
        },
      ],
      Monaragala: [
        {
          id: "38912",
          name: "Monaragala",
          state_id: "3338",
        },
        {
          id: "38913",
          name: "Wattegama",
          state_id: "3338",
        },
      ],
      Mullaitivu: [
        {
          id: "38914",
          name: "Mullaitivu",
          state_id: "3339",
        },
      ],
      "North Eastern Province": [],
      "North Western Province": [],
      "Nuwara Eliya": [],
      Polonnaruwa: [
        {
          id: "38915",
          name: "Polonnaruwa",
          state_id: "3343",
        },
      ],
      Puttalama: [
        {
          id: "38916",
          name: "Halawata",
          state_id: "3344",
        },
        {
          id: "38917",
          name: "Puttalama",
          state_id: "3344",
        },
      ],
      Ratnapuraya: [
        {
          id: "38918",
          name: "Balangoda",
          state_id: "3345",
        },
        {
          id: "38919",
          name: "Ratnapuraya",
          state_id: "3345",
        },
      ],
      "Southern Province": [],
      Tirikunamalaya: [
        {
          id: "38920",
          name: "Tirikunamalaya",
          state_id: "3347",
        },
      ],
      Tuscany: [
        {
          id: "38921",
          name: "Querceta",
          state_id: "3348",
        },
      ],
      Vavuniyawa: [
        {
          id: "38922",
          name: "Vavuniyawa",
          state_id: "3349",
        },
      ],
      "Western Province": [],
      Yapanaya: [
        {
          id: "38923",
          name: "Chavakachcheri",
          state_id: "3351",
        },
        {
          id: "38924",
          name: "Peduru Tuduwa",
          state_id: "3351",
        },
        {
          id: "38925",
          name: "Valvedditturai",
          state_id: "3351",
        },
        {
          id: "38926",
          name: "Yapanaya",
          state_id: "3351",
        },
      ],
      kadawatha: [
        {
          id: "38927",
          name: "Mahara",
          state_id: "3352",
        },
      ],
    },
  },
  LR: {
    name: "Liberia",
    native: "Liberia",
    phone: "231",
    continent: "AF",
    capital: "Monrovia",
    currency: "LRD",
    languages: ["en"],
    emoji: "🇱🇷",
    emojiU: "U+1F1F1 U+1F1F7",
    states: {
      Bomi: [
        {
          id: "26053",
          name: "Tubmanburg",
          state_id: "2169",
        },
      ],
      Bong: [
        {
          id: "26054",
          name: "Gbarnga",
          state_id: "2170",
        },
      ],
      "Grand Bassa": [],
      "Grand Cape Mount": [],
      "Grand Gedeh": [],
      Loffa: [
        {
          id: "26055",
          name: "Voinjama",
          state_id: "2174",
        },
      ],
      Margibi: [
        {
          id: "26056",
          name: "Harbel",
          state_id: "2175",
        },
        {
          id: "26057",
          name: "Kakata",
          state_id: "2175",
        },
      ],
      "Maryland and Grand Kru": [],
      Montserrado: [
        {
          id: "26058",
          name: "Bensonville",
          state_id: "2177",
        },
        {
          id: "26059",
          name: "Monrovia",
          state_id: "2177",
        },
      ],
      Nimba: [
        {
          id: "26060",
          name: "Ganta",
          state_id: "2178",
        },
        {
          id: "26061",
          name: "Sanniquellie",
          state_id: "2178",
        },
        {
          id: "26062",
          name: "Yekepa",
          state_id: "2178",
        },
      ],
      Rivercess: [
        {
          id: "26063",
          name: "Rivercess",
          state_id: "2179",
        },
      ],
      Sinoe: [
        {
          id: "26064",
          name: "Greenville",
          state_id: "2180",
        },
      ],
    },
  },
  LS: {
    name: "Lesotho",
    native: "Lesotho",
    phone: "266",
    continent: "AF",
    capital: "Maseru",
    currency: "LSL,ZAR",
    languages: ["en", "st"],
    emoji: "🇱🇸",
    emojiU: "U+1F1F1 U+1F1F8",
    states: {
      Berea: [
        {
          id: "26044",
          name: "Teyateyaneng",
          state_id: "2159",
        },
      ],
      "Butha-Buthe": [
        {
          id: "26045",
          name: "Butha Buthe",
          state_id: "2160",
        },
      ],
      Leribe: [
        {
          id: "26046",
          name: "Hlotse",
          state_id: "2161",
        },
        {
          id: "26047",
          name: "Maputsoa",
          state_id: "2161",
        },
      ],
      Mafeteng: [
        {
          id: "26048",
          name: "Mafeteng",
          state_id: "2162",
        },
      ],
      Maseru: [
        {
          id: "26049",
          name: "Maseru",
          state_id: "2163",
        },
      ],
      "Mohale''s Hoek": [],
      Mokhotlong: [
        {
          id: "26050",
          name: "Mokhotlong",
          state_id: "2165",
        },
      ],
      "Qacha''s Nek": [],
      Quthing: [
        {
          id: "26051",
          name: "Quthing",
          state_id: "2167",
        },
      ],
      "Thaba-Tseka": [
        {
          id: "26052",
          name: "Thaba-Tseka",
          state_id: "2168",
        },
      ],
    },
  },
  LT: {
    name: "Lithuania",
    native: "Lietuva",
    phone: "370",
    continent: "EU",
    capital: "Vilnius",
    currency: "LTL",
    languages: ["lt"],
    emoji: "🇱🇹",
    emojiU: "U+1F1F1 U+1F1F9",
    states: {
      Alytaus: [
        {
          id: "26112",
          name: "Alytus",
          state_id: "2218",
        },
        {
          id: "26113",
          name: "Daugai",
          state_id: "2218",
        },
        {
          id: "26114",
          name: "Druskininkai",
          state_id: "2218",
        },
        {
          id: "26115",
          name: "Lazdijai",
          state_id: "2218",
        },
        {
          id: "26116",
          name: "Simnas",
          state_id: "2218",
        },
        {
          id: "26117",
          name: "Varena",
          state_id: "2218",
        },
        {
          id: "26118",
          name: "Veisiejai",
          state_id: "2218",
        },
      ],
      Anyksciai: [
        {
          id: "26119",
          name: "Anyksciai",
          state_id: "2219",
        },
      ],
      Kauno: [
        {
          id: "26120",
          name: "Ariogala",
          state_id: "2220",
        },
        {
          id: "26121",
          name: "Birshtonas",
          state_id: "2220",
        },
        {
          id: "26122",
          name: "Dotnuva",
          state_id: "2220",
        },
        {
          id: "26123",
          name: "Ezherelis",
          state_id: "2220",
        },
        {
          id: "26124",
          name: "Garliava",
          state_id: "2220",
        },
        {
          id: "26125",
          name: "Jieznas",
          state_id: "2220",
        },
        {
          id: "26126",
          name: "Jonava",
          state_id: "2220",
        },
        {
          id: "26127",
          name: "Kachergine",
          state_id: "2220",
        },
        {
          id: "26128",
          name: "Kaishiadorys",
          state_id: "2220",
        },
        {
          id: "26129",
          name: "Kaunas",
          state_id: "2220",
        },
        {
          id: "26130",
          name: "Kedainiai",
          state_id: "2220",
        },
        {
          id: "26131",
          name: "Kulautuva",
          state_id: "2220",
        },
        {
          id: "26132",
          name: "Prienai",
          state_id: "2220",
        },
        {
          id: "26133",
          name: "Raseiniai",
          state_id: "2220",
        },
        {
          id: "26134",
          name: "Vilkija",
          state_id: "2220",
        },
        {
          id: "26135",
          name: "Zhiezhmariai",
          state_id: "2220",
        },
      ],
      Klaipedos: [
        {
          id: "26136",
          name: "Gargzhdai",
          state_id: "2221",
        },
        {
          id: "26137",
          name: "Klaipeda",
          state_id: "2221",
        },
        {
          id: "26138",
          name: "Kretinga",
          state_id: "2221",
        },
        {
          id: "26139",
          name: "Neringa",
          state_id: "2221",
        },
        {
          id: "26140",
          name: "Pagegiai",
          state_id: "2221",
        },
        {
          id: "26141",
          name: "Palanga",
          state_id: "2221",
        },
        {
          id: "26142",
          name: "Panemune",
          state_id: "2221",
        },
        {
          id: "26143",
          name: "Priekule",
          state_id: "2221",
        },
        {
          id: "26144",
          name: "Rusne",
          state_id: "2221",
        },
        {
          id: "26145",
          name: "Salantai",
          state_id: "2221",
        },
        {
          id: "26146",
          name: "Shilute",
          state_id: "2221",
        },
        {
          id: "26147",
          name: "Skuodas",
          state_id: "2221",
        },
        {
          id: "26148",
          name: "Zhemaichiu Naumiestis",
          state_id: "2221",
        },
      ],
      Marijampoles: [
        {
          id: "26149",
          name: "Gelgaudishkis",
          state_id: "2222",
        },
        {
          id: "26150",
          name: "Kalvarija",
          state_id: "2222",
        },
        {
          id: "26151",
          name: "Kazlu Ruda",
          state_id: "2222",
        },
        {
          id: "26152",
          name: "Kudirkos Naumiestis",
          state_id: "2222",
        },
        {
          id: "26153",
          name: "Kybartai",
          state_id: "2222",
        },
        {
          id: "26154",
          name: "Marijampole",
          state_id: "2222",
        },
        {
          id: "26155",
          name: "Shakiai",
          state_id: "2222",
        },
        {
          id: "26156",
          name: "Vilkavishkis",
          state_id: "2222",
        },
        {
          id: "26157",
          name: "Virbalis",
          state_id: "2222",
        },
      ],
      Panevezhio: [
        {
          id: "26158",
          name: "Birzhai",
          state_id: "2223",
        },
        {
          id: "26159",
          name: "Jonishkelis",
          state_id: "2223",
        },
        {
          id: "26160",
          name: "Juodupe",
          state_id: "2223",
        },
        {
          id: "26161",
          name: "Kupishkis",
          state_id: "2223",
        },
        {
          id: "26162",
          name: "Obeliai",
          state_id: "2223",
        },
        {
          id: "26163",
          name: "Pandelys",
          state_id: "2223",
        },
        {
          id: "26164",
          name: "Panevezhys",
          state_id: "2223",
        },
        {
          id: "26165",
          name: "Panevezio",
          state_id: "2223",
        },
        {
          id: "26166",
          name: "Pasvalys",
          state_id: "2223",
        },
        {
          id: "26167",
          name: "Ramygala",
          state_id: "2223",
        },
        {
          id: "26168",
          name: "Rokishkis",
          state_id: "2223",
        },
        {
          id: "26169",
          name: "Subachius",
          state_id: "2223",
        },
        {
          id: "26170",
          name: "Vabalninkas",
          state_id: "2223",
        },
      ],
      Panevezys: [
        {
          id: "26171",
          name: "Panevezys",
          state_id: "2224",
        },
      ],
      Shiauliu: [
        {
          id: "26172",
          name: "Akmene",
          state_id: "2225",
        },
        {
          id: "26173",
          name: "Jonishkis",
          state_id: "2225",
        },
        {
          id: "26174",
          name: "Kelme",
          state_id: "2225",
        },
        {
          id: "26175",
          name: "Kurshenai",
          state_id: "2225",
        },
        {
          id: "26176",
          name: "Linkuva",
          state_id: "2225",
        },
        {
          id: "26177",
          name: "Naujoji Akmene",
          state_id: "2225",
        },
        {
          id: "26178",
          name: "Pakruojis",
          state_id: "2225",
        },
        {
          id: "26179",
          name: "Radvilishkis",
          state_id: "2225",
        },
        {
          id: "26180",
          name: "Sheduva",
          state_id: "2225",
        },
        {
          id: "26181",
          name: "Shiauliai",
          state_id: "2225",
        },
        {
          id: "26182",
          name: "Siauliai",
          state_id: "2225",
        },
        {
          id: "26183",
          name: "Tyruliai",
          state_id: "2225",
        },
        {
          id: "26184",
          name: "Tytuvenai",
          state_id: "2225",
        },
        {
          id: "26185",
          name: "Uzhventis",
          state_id: "2225",
        },
        {
          id: "26186",
          name: "Venta",
          state_id: "2225",
        },
        {
          id: "26187",
          name: "Viekshniai",
          state_id: "2225",
        },
        {
          id: "26188",
          name: "Zhagare",
          state_id: "2225",
        },
      ],
      Taurages: [
        {
          id: "26189",
          name: "Jurbarkas",
          state_id: "2226",
        },
        {
          id: "26190",
          name: "Shilale",
          state_id: "2226",
        },
        {
          id: "26191",
          name: "Skaudvile",
          state_id: "2226",
        },
        {
          id: "26192",
          name: "Smalininkai",
          state_id: "2226",
        },
        {
          id: "26193",
          name: "Taurage",
          state_id: "2226",
        },
      ],
      Telshiu: [
        {
          id: "26194",
          name: "Guglingen",
          state_id: "2227",
        },
        {
          id: "26195",
          name: "Mazheikiai",
          state_id: "2227",
        },
        {
          id: "26196",
          name: "Plunge",
          state_id: "2227",
        },
        {
          id: "26197",
          name: "Rietavas",
          state_id: "2227",
        },
        {
          id: "26198",
          name: "Seda",
          state_id: "2227",
        },
        {
          id: "26199",
          name: "Telshiai",
          state_id: "2227",
        },
        {
          id: "26200",
          name: "Varniai",
          state_id: "2227",
        },
      ],
      Telsiai: [
        {
          id: "26201",
          name: "Mazeikiai",
          state_id: "2228",
        },
      ],
      Utenos: [
        {
          id: "26202",
          name: "Anykshchiai",
          state_id: "2229",
        },
        {
          id: "26203",
          name: "Dukshtas",
          state_id: "2229",
        },
        {
          id: "26204",
          name: "Dusetos",
          state_id: "2229",
        },
        {
          id: "26205",
          name: "Ignalina",
          state_id: "2229",
        },
        {
          id: "26206",
          name: "Kavarskas",
          state_id: "2229",
        },
        {
          id: "26207",
          name: "Moletai",
          state_id: "2229",
        },
        {
          id: "26208",
          name: "Troshkunai",
          state_id: "2229",
        },
        {
          id: "26209",
          name: "Turmantas",
          state_id: "2229",
        },
        {
          id: "26210",
          name: "Utena",
          state_id: "2229",
        },
        {
          id: "26211",
          name: "Visaginas",
          state_id: "2229",
        },
        {
          id: "26212",
          name: "Zarasai",
          state_id: "2229",
        },
      ],
      Vilniaus: [
        {
          id: "26213",
          name: "Baltoji Voke",
          state_id: "2230",
        },
        {
          id: "26214",
          name: "Eishishkes",
          state_id: "2230",
        },
        {
          id: "26215",
          name: "Elektrenai",
          state_id: "2230",
        },
        {
          id: "26216",
          name: "Grigishkes",
          state_id: "2230",
        },
        {
          id: "26217",
          name: "Lentvaris",
          state_id: "2230",
        },
        {
          id: "26218",
          name: "Nemenchine",
          state_id: "2230",
        },
        {
          id: "26219",
          name: "Pabrade",
          state_id: "2230",
        },
        {
          id: "26220",
          name: "Rudishkes",
          state_id: "2230",
        },
        {
          id: "26221",
          name: "Shalchininkai",
          state_id: "2230",
        },
        {
          id: "26222",
          name: "Shirvintos",
          state_id: "2230",
        },
        {
          id: "26223",
          name: "Shvenchioneliai",
          state_id: "2230",
        },
        {
          id: "26224",
          name: "Shvenchionys",
          state_id: "2230",
        },
        {
          id: "26225",
          name: "Trakai",
          state_id: "2230",
        },
        {
          id: "26226",
          name: "Ukmerge",
          state_id: "2230",
        },
        {
          id: "26227",
          name: "Vievis",
          state_id: "2230",
        },
        {
          id: "26228",
          name: "Vilnius",
          state_id: "2230",
        },
      ],
    },
  },
  LU: {
    name: "Luxembourg",
    native: "Luxembourg",
    phone: "352",
    continent: "EU",
    capital: "Luxembourg",
    currency: "EUR",
    languages: ["fr", "de", "lb"],
    emoji: "🇱🇺",
    emojiU: "U+1F1F1 U+1F1FA",
    states: {
      Capellen: [
        {
          id: "26229",
          name: "Bascharage",
          state_id: "2231",
        },
        {
          id: "26230",
          name: "Bettange-sur-Mess",
          state_id: "2231",
        },
        {
          id: "26231",
          name: "Bridel",
          state_id: "2231",
        },
        {
          id: "26232",
          name: "Capellen",
          state_id: "2231",
        },
        {
          id: "26233",
          name: "Clemency",
          state_id: "2231",
        },
        {
          id: "26234",
          name: "Dahlem",
          state_id: "2231",
        },
        {
          id: "26235",
          name: "Dippach",
          state_id: "2231",
        },
        {
          id: "26236",
          name: "Dondelange",
          state_id: "2231",
        },
        {
          id: "26237",
          name: "Eischen",
          state_id: "2231",
        },
        {
          id: "26238",
          name: "Fingig",
          state_id: "2231",
        },
        {
          id: "26239",
          name: "Garnich",
          state_id: "2231",
        },
        {
          id: "26240",
          name: "Goeblange",
          state_id: "2231",
        },
        {
          id: "26241",
          name: "Goetzingen",
          state_id: "2231",
        },
        {
          id: "26242",
          name: "Grass",
          state_id: "2231",
        },
        {
          id: "26243",
          name: "Greisch",
          state_id: "2231",
        },
        {
          id: "26244",
          name: "Hagen",
          state_id: "2231",
        },
        {
          id: "26245",
          name: "Hautcharage",
          state_id: "2231",
        },
        {
          id: "26246",
          name: "Hivange",
          state_id: "2231",
        },
        {
          id: "26247",
          name: "Hobscheid",
          state_id: "2231",
        },
        {
          id: "26248",
          name: "Holzem",
          state_id: "2231",
        },
        {
          id: "26249",
          name: "Kahler",
          state_id: "2231",
        },
        {
          id: "26250",
          name: "Kehlen",
          state_id: "2231",
        },
        {
          id: "26251",
          name: "Keispelt",
          state_id: "2231",
        },
        {
          id: "26252",
          name: "Kleinbettingen",
          state_id: "2231",
        },
        {
          id: "26253",
          name: "Koerich",
          state_id: "2231",
        },
        {
          id: "26254",
          name: "Kospstal",
          state_id: "2231",
        },
        {
          id: "26255",
          name: "Linger",
          state_id: "2231",
        },
        {
          id: "26256",
          name: "Mamer",
          state_id: "2231",
        },
        {
          id: "26257",
          name: "Meispelt",
          state_id: "2231",
        },
        {
          id: "26258",
          name: "Nospelt",
          state_id: "2231",
        },
        {
          id: "26259",
          name: "Olm",
          state_id: "2231",
        },
        {
          id: "26260",
          name: "Roodt",
          state_id: "2231",
        },
        {
          id: "26261",
          name: "Schouweiler",
          state_id: "2231",
        },
        {
          id: "26262",
          name: "Septfontaines",
          state_id: "2231",
        },
        {
          id: "26263",
          name: "Sprinkange",
          state_id: "2231",
        },
        {
          id: "26264",
          name: "Steinfort",
          state_id: "2231",
        },
      ],
      Clervaux: [
        {
          id: "26265",
          name: "Allerborn",
          state_id: "2232",
        },
        {
          id: "26266",
          name: "Asselborn",
          state_id: "2232",
        },
        {
          id: "26267",
          name: "Basbellain",
          state_id: "2232",
        },
        {
          id: "26268",
          name: "Beiler",
          state_id: "2232",
        },
        {
          id: "26269",
          name: "Binsfeld",
          state_id: "2232",
        },
        {
          id: "26270",
          name: "Biwisch",
          state_id: "2232",
        },
        {
          id: "26271",
          name: "Bockholtz",
          state_id: "2232",
        },
        {
          id: "26272",
          name: "Boevange",
          state_id: "2232",
        },
        {
          id: "26273",
          name: "Boxhorn",
          state_id: "2232",
        },
        {
          id: "26274",
          name: "Brachtenbach",
          state_id: "2232",
        },
        {
          id: "26275",
          name: "Breidfeld",
          state_id: "2232",
        },
        {
          id: "26276",
          name: "Cinqfontaines",
          state_id: "2232",
        },
        {
          id: "26277",
          name: "Clervaux",
          state_id: "2232",
        },
        {
          id: "26278",
          name: "Consthum",
          state_id: "2232",
        },
        {
          id: "26279",
          name: "Crendal",
          state_id: "2232",
        },
        {
          id: "26280",
          name: "Deiffelt-Lentzweiler",
          state_id: "2232",
        },
        {
          id: "26281",
          name: "Derenbach",
          state_id: "2232",
        },
        {
          id: "26282",
          name: "Doennange",
          state_id: "2232",
        },
        {
          id: "26283",
          name: "Dorscheid",
          state_id: "2232",
        },
        {
          id: "26284",
          name: "Drauffelt",
          state_id: "2232",
        },
        {
          id: "26285",
          name: "Drinklange",
          state_id: "2232",
        },
        {
          id: "26286",
          name: "Eisenbach",
          state_id: "2232",
        },
        {
          id: "26287",
          name: "Eselborn",
          state_id: "2232",
        },
        {
          id: "26288",
          name: "Fischbach",
          state_id: "2232",
        },
        {
          id: "26289",
          name: "Goedange",
          state_id: "2232",
        },
        {
          id: "26290",
          name: "Grindhausen",
          state_id: "2232",
        },
        {
          id: "26291",
          name: "Hachiville",
          state_id: "2232",
        },
        {
          id: "26292",
          name: "Hamiville",
          state_id: "2232",
        },
        {
          id: "26293",
          name: "Hautbellain",
          state_id: "2232",
        },
        {
          id: "26294",
          name: "Heinerscheid",
          state_id: "2232",
        },
        {
          id: "26295",
          name: "Hoffelt",
          state_id: "2232",
        },
        {
          id: "26296",
          name: "Holler",
          state_id: "2232",
        },
        {
          id: "26297",
          name: "Holzthum",
          state_id: "2232",
        },
        {
          id: "26298",
          name: "Hosingen",
          state_id: "2232",
        },
        {
          id: "26299",
          name: "Huldange",
          state_id: "2232",
        },
        {
          id: "26300",
          name: "Hupperdange",
          state_id: "2232",
        },
        {
          id: "26301",
          name: "Kalborn",
          state_id: "2232",
        },
        {
          id: "26302",
          name: "Leithum",
          state_id: "2232",
        },
        {
          id: "26303",
          name: "Lieler",
          state_id: "2232",
        },
        {
          id: "26304",
          name: "Lullange",
          state_id: "2232",
        },
        {
          id: "26305",
          name: "Marnach",
          state_id: "2232",
        },
        {
          id: "26306",
          name: "Maulusmuehle",
          state_id: "2232",
        },
        {
          id: "26307",
          name: "Munshausen",
          state_id: "2232",
        },
        {
          id: "26308",
          name: "Neidhausen",
          state_id: "2232",
        },
        {
          id: "26309",
          name: "Niederwampach-Schimpach",
          state_id: "2232",
        },
        {
          id: "26310",
          name: "Oberwampach",
          state_id: "2232",
        },
        {
          id: "26311",
          name: "Reuler",
          state_id: "2232",
        },
        {
          id: "26312",
          name: "Roder",
          state_id: "2232",
        },
        {
          id: "26313",
          name: "Rodershausen",
          state_id: "2232",
        },
        {
          id: "26314",
          name: "Rumlange-Lentzweiler",
          state_id: "2232",
        },
        {
          id: "26315",
          name: "Sassel",
          state_id: "2232",
        },
        {
          id: "26316",
          name: "Siebenaler",
          state_id: "2232",
        },
        {
          id: "26317",
          name: "Stockem",
          state_id: "2232",
        },
        {
          id: "26318",
          name: "Troine-Hinterhasselt",
          state_id: "2232",
        },
        {
          id: "26319",
          name: "Troine-Route",
          state_id: "2232",
        },
        {
          id: "26320",
          name: "Troisvierges",
          state_id: "2232",
        },
        {
          id: "26321",
          name: "Urspelt",
          state_id: "2232",
        },
        {
          id: "26322",
          name: "Wahlhausen",
          state_id: "2232",
        },
        {
          id: "26323",
          name: "Weicherdange",
          state_id: "2232",
        },
        {
          id: "26324",
          name: "Weiler",
          state_id: "2232",
        },
        {
          id: "26325",
          name: "Weiswampach",
          state_id: "2232",
        },
        {
          id: "26326",
          name: "Wilwerdange",
          state_id: "2232",
        },
        {
          id: "26327",
          name: "Wincrange",
          state_id: "2232",
        },
      ],
      Diekirch: [
        {
          id: "26328",
          name: "Bastendorf",
          state_id: "2233",
        },
        {
          id: "26329",
          name: "Bettendorf",
          state_id: "2233",
        },
        {
          id: "26330",
          name: "Bigelbach",
          state_id: "2233",
        },
        {
          id: "26331",
          name: "Bourscheid",
          state_id: "2233",
        },
        {
          id: "26332",
          name: "Brandenbourg",
          state_id: "2233",
        },
        {
          id: "26333",
          name: "Burden",
          state_id: "2233",
        },
        {
          id: "26334",
          name: "Diekirch",
          state_id: "2233",
        },
        {
          id: "26335",
          name: "Eppeldorf",
          state_id: "2233",
        },
        {
          id: "26336",
          name: "Ermsdorf",
          state_id: "2233",
        },
        {
          id: "26337",
          name: "Erpeldange",
          state_id: "2233",
        },
        {
          id: "26338",
          name: "Ettelbruck",
          state_id: "2233",
        },
        {
          id: "26339",
          name: "Folkendange",
          state_id: "2233",
        },
        {
          id: "26340",
          name: "Gilsdorf",
          state_id: "2233",
        },
        {
          id: "26341",
          name: "Hoesdorf",
          state_id: "2233",
        },
        {
          id: "26342",
          name: "Hoscheid",
          state_id: "2233",
        },
        {
          id: "26343",
          name: "Hoscheid-Dickt",
          state_id: "2233",
        },
        {
          id: "26344",
          name: "Ingeldorf",
          state_id: "2233",
        },
        {
          id: "26345",
          name: "Kehmen-Scheidel",
          state_id: "2233",
        },
        {
          id: "26346",
          name: "Landscheid",
          state_id: "2233",
        },
        {
          id: "26347",
          name: "Lipperscheid",
          state_id: "2233",
        },
        {
          id: "26348",
          name: "Medernach",
          state_id: "2233",
        },
        {
          id: "26349",
          name: "Mertzig",
          state_id: "2233",
        },
        {
          id: "26350",
          name: "Michelau",
          state_id: "2233",
        },
        {
          id: "26351",
          name: "Moestroff",
          state_id: "2233",
        },
        {
          id: "26352",
          name: "Niederfeulen",
          state_id: "2233",
        },
        {
          id: "26353",
          name: "Oberfeulen",
          state_id: "2233",
        },
        {
          id: "26354",
          name: "Reisdorf",
          state_id: "2233",
        },
        {
          id: "26355",
          name: "Savelborn + Fermes",
          state_id: "2233",
        },
        {
          id: "26356",
          name: "Schieren",
          state_id: "2233",
        },
        {
          id: "26357",
          name: "Schlindermanderscheid",
          state_id: "2233",
        },
        {
          id: "26358",
          name: "Stegen",
          state_id: "2233",
        },
        {
          id: "26359",
          name: "Tandel",
          state_id: "2233",
        },
        {
          id: "26360",
          name: "Wallendorf",
          state_id: "2233",
        },
        {
          id: "26361",
          name: "Warken",
          state_id: "2233",
        },
        {
          id: "26362",
          name: "Welscheid",
          state_id: "2233",
        },
      ],
      Echternach: [
        {
          id: "26363",
          name: "Altrier",
          state_id: "2234",
        },
        {
          id: "26364",
          name: "Beaufort",
          state_id: "2234",
        },
        {
          id: "26365",
          name: "Bech",
          state_id: "2234",
        },
        {
          id: "26366",
          name: "Berdorf",
          state_id: "2234",
        },
        {
          id: "26367",
          name: "Bollendorf-Pont",
          state_id: "2234",
        },
        {
          id: "26368",
          name: "Born",
          state_id: "2234",
        },
        {
          id: "26369",
          name: "Boursdorf",
          state_id: "2234",
        },
        {
          id: "26370",
          name: "Breidweiler",
          state_id: "2234",
        },
        {
          id: "26371",
          name: "Christnach",
          state_id: "2234",
        },
        {
          id: "26372",
          name: "Consdorf",
          state_id: "2234",
        },
        {
          id: "26373",
          name: "Dickweiler",
          state_id: "2234",
        },
        {
          id: "26374",
          name: "Dillingen",
          state_id: "2234",
        },
        {
          id: "26375",
          name: "Echternach",
          state_id: "2234",
        },
        {
          id: "26376",
          name: "Girst",
          state_id: "2234",
        },
        {
          id: "26377",
          name: "Girsterklaus",
          state_id: "2234",
        },
        {
          id: "26378",
          name: "Givenich",
          state_id: "2234",
        },
        {
          id: "26379",
          name: "Grundhof",
          state_id: "2234",
        },
        {
          id: "26380",
          name: "Haller",
          state_id: "2234",
        },
        {
          id: "26381",
          name: "Hemstal",
          state_id: "2234",
        },
        {
          id: "26382",
          name: "Herborn",
          state_id: "2234",
        },
        {
          id: "26383",
          name: "Hersberg-Kobenbour-Graulinster",
          state_id: "2234",
        },
        {
          id: "26384",
          name: "Hinkel",
          state_id: "2234",
        },
        {
          id: "26385",
          name: "Moersdorf",
          state_id: "2234",
        },
        {
          id: "26386",
          name: "Mompach",
          state_id: "2234",
        },
        {
          id: "26387",
          name: "Mullerthal",
          state_id: "2234",
        },
        {
          id: "26388",
          name: "Osweiler",
          state_id: "2234",
        },
        {
          id: "26389",
          name: "Rippig",
          state_id: "2234",
        },
        {
          id: "26390",
          name: "Rosport",
          state_id: "2234",
        },
        {
          id: "26391",
          name: "Scheidgen",
          state_id: "2234",
        },
        {
          id: "26392",
          name: "Steinheim",
          state_id: "2234",
        },
        {
          id: "26393",
          name: "Waldbillig",
          state_id: "2234",
        },
        {
          id: "26394",
          name: "Weilerbach",
          state_id: "2234",
        },
        {
          id: "26395",
          name: "Zittig",
          state_id: "2234",
        },
      ],
      "Esch-sur-Alzette": [
        {
          id: "26396",
          name: "Abweiler",
          state_id: "2235",
        },
        {
          id: "26397",
          name: "Aspelt",
          state_id: "2235",
        },
        {
          id: "26398",
          name: "Belvaux",
          state_id: "2235",
        },
        {
          id: "26399",
          name: "Berchem",
          state_id: "2235",
        },
        {
          id: "26400",
          name: "Bergem",
          state_id: "2235",
        },
        {
          id: "26401",
          name: "Bettembourg",
          state_id: "2235",
        },
        {
          id: "26402",
          name: "Bivange",
          state_id: "2235",
        },
        {
          id: "26403",
          name: "Crauthem",
          state_id: "2235",
        },
        {
          id: "26404",
          name: "Differdange",
          state_id: "2235",
        },
        {
          id: "26405",
          name: "Dudelange",
          state_id: "2235",
        },
        {
          id: "26406",
          name: "Ehlange",
          state_id: "2235",
        },
        {
          id: "26407",
          name: "Ehlerange",
          state_id: "2235",
        },
        {
          id: "26408",
          name: "Esch-Alzette",
          state_id: "2235",
        },
        {
          id: "26409",
          name: "Fennange",
          state_id: "2235",
        },
        {
          id: "26410",
          name: "Foetz",
          state_id: "2235",
        },
        {
          id: "26411",
          name: "Fousbann",
          state_id: "2235",
        },
        {
          id: "26412",
          name: "Frisange",
          state_id: "2235",
        },
        {
          id: "26413",
          name: "Hellange",
          state_id: "2235",
        },
        {
          id: "26414",
          name: "Huncherange",
          state_id: "2235",
        },
        {
          id: "26415",
          name: "Kayl",
          state_id: "2235",
        },
        {
          id: "26416",
          name: "Kockelscheuer",
          state_id: "2235",
        },
        {
          id: "26417",
          name: "Lamadelaine",
          state_id: "2235",
        },
        {
          id: "26418",
          name: "Lasauvage",
          state_id: "2235",
        },
        {
          id: "26419",
          name: "Leudelange",
          state_id: "2235",
        },
        {
          id: "26420",
          name: "Limpach",
          state_id: "2235",
        },
        {
          id: "26421",
          name: "Livange",
          state_id: "2235",
        },
        {
          id: "26422",
          name: "Mondercange",
          state_id: "2235",
        },
        {
          id: "26423",
          name: "Niedercorn",
          state_id: "2235",
        },
        {
          id: "26424",
          name: "Noertzange",
          state_id: "2235",
        },
        {
          id: "26425",
          name: "Obercorn",
          state_id: "2235",
        },
        {
          id: "26426",
          name: "Peppange",
          state_id: "2235",
        },
        {
          id: "26427",
          name: "Petange",
          state_id: "2235",
        },
        {
          id: "26428",
          name: "Pissange",
          state_id: "2235",
        },
        {
          id: "26429",
          name: "Pontpierre",
          state_id: "2235",
        },
        {
          id: "26430",
          name: "Reckange-sur-Mess",
          state_id: "2235",
        },
        {
          id: "26431",
          name: "Rodange",
          state_id: "2235",
        },
        {
          id: "26432",
          name: "Roedgen",
          state_id: "2235",
        },
        {
          id: "26433",
          name: "Roeser",
          state_id: "2235",
        },
        {
          id: "26434",
          name: "Rumelange",
          state_id: "2235",
        },
        {
          id: "26435",
          name: "Sanem",
          state_id: "2235",
        },
        {
          id: "26436",
          name: "Schifflange",
          state_id: "2235",
        },
        {
          id: "26437",
          name: "Soleuvre",
          state_id: "2235",
        },
        {
          id: "26438",
          name: "Tetange",
          state_id: "2235",
        },
        {
          id: "26439",
          name: "Wickrange",
          state_id: "2235",
        },
      ],
      Grevenmacher: [
        {
          id: "26440",
          name: "Ahn-Dreiborn",
          state_id: "2236",
        },
        {
          id: "26441",
          name: "Altlinster",
          state_id: "2236",
        },
        {
          id: "26442",
          name: "Beidweiler",
          state_id: "2236",
        },
        {
          id: "26443",
          name: "Berbourg",
          state_id: "2236",
        },
        {
          id: "26444",
          name: "Berg",
          state_id: "2236",
        },
        {
          id: "26445",
          name: "Betzdorf",
          state_id: "2236",
        },
        {
          id: "26446",
          name: "Beyren",
          state_id: "2236",
        },
        {
          id: "26447",
          name: "Biwer",
          state_id: "2236",
        },
        {
          id: "26448",
          name: "Biwerbach",
          state_id: "2236",
        },
        {
          id: "26449",
          name: "Boudler",
          state_id: "2236",
        },
        {
          id: "26450",
          name: "Boudlerbach",
          state_id: "2236",
        },
        {
          id: "26451",
          name: "Bourglinster",
          state_id: "2236",
        },
        {
          id: "26452",
          name: "Breinert",
          state_id: "2236",
        },
        {
          id: "26453",
          name: "Brouch",
          state_id: "2236",
        },
        {
          id: "26454",
          name: "Ehnen",
          state_id: "2236",
        },
        {
          id: "26455",
          name: "Eisenborn",
          state_id: "2236",
        },
        {
          id: "26456",
          name: "Eschweiler",
          state_id: "2236",
        },
        {
          id: "26457",
          name: "Flaxweiler",
          state_id: "2236",
        },
        {
          id: "26458",
          name: "Godbrange",
          state_id: "2236",
        },
        {
          id: "26459",
          name: "Gonderange",
          state_id: "2236",
        },
        {
          id: "26460",
          name: "Gostingen",
          state_id: "2236",
        },
        {
          id: "26461",
          name: "Graulinster-Blumenthal",
          state_id: "2236",
        },
        {
          id: "26462",
          name: "Grevenmacher",
          state_id: "2236",
        },
        {
          id: "26463",
          name: "Hagelsdorf",
          state_id: "2236",
        },
        {
          id: "26464",
          name: "Imbringen",
          state_id: "2236",
        },
        {
          id: "26465",
          name: "Junglinster",
          state_id: "2236",
        },
        {
          id: "26466",
          name: "Lellig",
          state_id: "2236",
        },
        {
          id: "26467",
          name: "Machtum",
          state_id: "2236",
        },
        {
          id: "26468",
          name: "Manternach",
          state_id: "2236",
        },
        {
          id: "26469",
          name: "Mensdorf",
          state_id: "2236",
        },
        {
          id: "26470",
          name: "Mertert",
          state_id: "2236",
        },
        {
          id: "26471",
          name: "Munschecker",
          state_id: "2236",
        },
        {
          id: "26472",
          name: "Niederdonven",
          state_id: "2236",
        },
        {
          id: "26473",
          name: "Oberdonven",
          state_id: "2236",
        },
        {
          id: "26474",
          name: "Olingen",
          state_id: "2236",
        },
        {
          id: "26475",
          name: "Rodenbourg",
          state_id: "2236",
        },
        {
          id: "26477",
          name: "Wasserbillig",
          state_id: "2236",
        },
        {
          id: "26478",
          name: "Wecker",
          state_id: "2236",
        },
        {
          id: "26479",
          name: "Wecker-Gare",
          state_id: "2236",
        },
        {
          id: "26480",
          name: "Weydig",
          state_id: "2236",
        },
        {
          id: "26481",
          name: "Wormeldange",
          state_id: "2236",
        },
        {
          id: "26482",
          name: "Wormeldange-Haut",
          state_id: "2236",
        },
      ],
      Luxembourg: [
        {
          id: "26483",
          name: "Alzingen",
          state_id: "2237",
        },
        {
          id: "26484",
          name: "Bereldange",
          state_id: "2237",
        },
        {
          id: "26485",
          name: "Bertrange",
          state_id: "2237",
        },
        {
          id: "26486",
          name: "Contern",
          state_id: "2237",
        },
        {
          id: "26487",
          name: "Ernster",
          state_id: "2237",
        },
        {
          id: "26488",
          name: "Fentange",
          state_id: "2237",
        },
        {
          id: "26489",
          name: "Findel",
          state_id: "2237",
        },
        {
          id: "26490",
          name: "Hassel",
          state_id: "2237",
        },
        {
          id: "26491",
          name: "Heisdorf",
          state_id: "2237",
        },
        {
          id: "26492",
          name: "Helmsange",
          state_id: "2237",
        },
        {
          id: "26493",
          name: "Hesperange",
          state_id: "2237",
        },
        {
          id: "26494",
          name: "Hostert",
          state_id: "2237",
        },
        {
          id: "26495",
          name: "Howald",
          state_id: "2237",
        },
        {
          id: "26496",
          name: "Itzig",
          state_id: "2237",
        },
        {
          id: "26497",
          name: "Luxembourg",
          state_id: "2237",
        },
        {
          id: "26498",
          name: "Medingen",
          state_id: "2237",
        },
        {
          id: "26499",
          name: "Moutfort",
          state_id: "2237",
        },
        {
          id: "26500",
          name: "Mullendorf",
          state_id: "2237",
        },
        {
          id: "26501",
          name: "Munsbach",
          state_id: "2237",
        },
        {
          id: "26502",
          name: "Neuhaeusgen",
          state_id: "2237",
        },
        {
          id: "26503",
          name: "Niederanven",
          state_id: "2237",
        },
        {
          id: "26504",
          name: "Oberanven",
          state_id: "2237",
        },
        {
          id: "26505",
          name: "Oetrange",
          state_id: "2237",
        },
        {
          id: "26506",
          name: "Rameldange",
          state_id: "2237",
        },
        {
          id: "26507",
          name: "Sandweiler",
          state_id: "2237",
        },
        {
          id: "26508",
          name: "Schrassig",
          state_id: "2237",
        },
        {
          id: "26509",
          name: "Schuttrange",
          state_id: "2237",
        },
        {
          id: "26510",
          name: "Senningen",
          state_id: "2237",
        },
        {
          id: "26511",
          name: "Senningerberg",
          state_id: "2237",
        },
        {
          id: "26512",
          name: "Steinsel",
          state_id: "2237",
        },
        {
          id: "26513",
          name: "Strassen",
          state_id: "2237",
        },
        {
          id: "26514",
          name: "Syren",
          state_id: "2237",
        },
        {
          id: "26515",
          name: "Uebersyren",
          state_id: "2237",
        },
        {
          id: "26516",
          name: "Waldhof",
          state_id: "2237",
        },
        {
          id: "26517",
          name: "Walferdange",
          state_id: "2237",
        },
        {
          id: "26518",
          name: "Weiler-la-Tour",
          state_id: "2237",
        },
      ],
      Mersch: [
        {
          id: "26519",
          name: "Angelsberg",
          state_id: "2238",
        },
        {
          id: "26520",
          name: "Ansembourg",
          state_id: "2238",
        },
        {
          id: "26521",
          name: "Beringen",
          state_id: "2238",
        },
        {
          id: "26522",
          name: "Bissen",
          state_id: "2238",
        },
        {
          id: "26523",
          name: "Blaschette",
          state_id: "2238",
        },
        {
          id: "26524",
          name: "Boevange-Attert",
          state_id: "2238",
        },
        {
          id: "26525",
          name: "Bofferdange",
          state_id: "2238",
        },
        {
          id: "26526",
          name: "Bour",
          state_id: "2238",
        },
        {
          id: "26527",
          name: "Brouch",
          state_id: "2238",
        },
        {
          id: "26528",
          name: "Buschdorf",
          state_id: "2238",
        },
        {
          id: "26529",
          name: "Colmar-Berg",
          state_id: "2238",
        },
        {
          id: "26530",
          name: "Cruchten",
          state_id: "2238",
        },
        {
          id: "26531",
          name: "Ernzen",
          state_id: "2238",
        },
        {
          id: "26532",
          name: "Essingen",
          state_id: "2238",
        },
        {
          id: "26533",
          name: "Fischbach",
          state_id: "2238",
        },
        {
          id: "26534",
          name: "Glabach",
          state_id: "2238",
        },
        {
          id: "26535",
          name: "Gosseldange",
          state_id: "2238",
        },
        {
          id: "26536",
          name: "Grevenknapp-Bill-Finsterthal",
          state_id: "2238",
        },
        {
          id: "26537",
          name: "Heffingen",
          state_id: "2238",
        },
        {
          id: "26538",
          name: "Helmdange",
          state_id: "2238",
        },
        {
          id: "26539",
          name: "Hollenfels",
          state_id: "2238",
        },
        {
          id: "26540",
          name: "Hunsdorf",
          state_id: "2238",
        },
        {
          id: "26541",
          name: "Larochette",
          state_id: "2238",
        },
        {
          id: "26542",
          name: "Lintgen",
          state_id: "2238",
        },
        {
          id: "26543",
          name: "Lorentzweiler",
          state_id: "2238",
        },
        {
          id: "26544",
          name: "Marienthal",
          state_id: "2238",
        },
        {
          id: "26545",
          name: "Mersch",
          state_id: "2238",
        },
        {
          id: "26546",
          name: "Moesdorf",
          state_id: "2238",
        },
        {
          id: "26547",
          name: "Nommern",
          state_id: "2238",
        },
        {
          id: "26548",
          name: "Pettingen",
          state_id: "2238",
        },
        {
          id: "26549",
          name: "Prettange",
          state_id: "2238",
        },
        {
          id: "26550",
          name: "Reckange",
          state_id: "2238",
        },
        {
          id: "26551",
          name: "Reuland",
          state_id: "2238",
        },
        {
          id: "26552",
          name: "Rollingen",
          state_id: "2238",
        },
        {
          id: "26553",
          name: "Scherbach",
          state_id: "2238",
        },
        {
          id: "26554",
          name: "Scherfenhof",
          state_id: "2238",
        },
        {
          id: "26555",
          name: "Schiltzberg",
          state_id: "2238",
        },
        {
          id: "26556",
          name: "Schoenfels",
          state_id: "2238",
        },
        {
          id: "26557",
          name: "Schoos",
          state_id: "2238",
        },
        {
          id: "26558",
          name: "Schrondweiler",
          state_id: "2238",
        },
        {
          id: "26559",
          name: "Tuntange",
          state_id: "2238",
        },
      ],
      Redange: [
        {
          id: "26560",
          name: "Arsdorf",
          state_id: "2239",
        },
        {
          id: "26561",
          name: "Beckerich",
          state_id: "2239",
        },
        {
          id: "26562",
          name: "Bettborn",
          state_id: "2239",
        },
        {
          id: "26563",
          name: "Bigonville",
          state_id: "2239",
        },
        {
          id: "26564",
          name: "Bilsdorf",
          state_id: "2239",
        },
        {
          id: "26565",
          name: "Brattert-Rindschleiden",
          state_id: "2239",
        },
        {
          id: "26566",
          name: "Buschrodt",
          state_id: "2239",
        },
        {
          id: "26567",
          name: "Calmus",
          state_id: "2239",
        },
        {
          id: "26568",
          name: "Colpach-Bas",
          state_id: "2239",
        },
        {
          id: "26569",
          name: "Colpach-Haut",
          state_id: "2239",
        },
        {
          id: "26570",
          name: "Dellen-Lehrhof-Grevels",
          state_id: "2239",
        },
        {
          id: "26571",
          name: "Ehner",
          state_id: "2239",
        },
        {
          id: "26572",
          name: "Ell",
          state_id: "2239",
        },
        {
          id: "26573",
          name: "Eltz",
          state_id: "2239",
        },
        {
          id: "26574",
          name: "Elvange",
          state_id: "2239",
        },
        {
          id: "26575",
          name: "Eschette",
          state_id: "2239",
        },
        {
          id: "26576",
          name: "Everlange",
          state_id: "2239",
        },
        {
          id: "26577",
          name: "Folschette",
          state_id: "2239",
        },
        {
          id: "26578",
          name: "Grevels",
          state_id: "2239",
        },
        {
          id: "26579",
          name: "Grosbous",
          state_id: "2239",
        },
        {
          id: "26580",
          name: "Haut-Martelange",
          state_id: "2239",
        },
        {
          id: "26581",
          name: "Heispelt",
          state_id: "2239",
        },
        {
          id: "26582",
          name: "Holtz",
          state_id: "2239",
        },
        {
          id: "26583",
          name: "Hostert",
          state_id: "2239",
        },
        {
          id: "26584",
          name: "Hovelange",
          state_id: "2239",
        },
        {
          id: "26585",
          name: "Huttange",
          state_id: "2239",
        },
        {
          id: "26586",
          name: "Kapweiler",
          state_id: "2239",
        },
        {
          id: "26587",
          name: "Koetschette",
          state_id: "2239",
        },
        {
          id: "26588",
          name: "Kuborn",
          state_id: "2239",
        },
        {
          id: "26589",
          name: "Lannen",
          state_id: "2239",
        },
        {
          id: "26590",
          name: "Levelange",
          state_id: "2239",
        },
        {
          id: "26591",
          name: "Michelbouch",
          state_id: "2239",
        },
        {
          id: "26592",
          name: "Nagem",
          state_id: "2239",
        },
        {
          id: "26593",
          name: "Niederpallen",
          state_id: "2239",
        },
        {
          id: "26594",
          name: "Noerdange",
          state_id: "2239",
        },
        {
          id: "26595",
          name: "Oberpallen",
          state_id: "2239",
        },
        {
          id: "26596",
          name: "Ospern",
          state_id: "2239",
        },
        {
          id: "26597",
          name: "Perle",
          state_id: "2239",
        },
        {
          id: "26598",
          name: "Petit-Nobressart",
          state_id: "2239",
        },
        {
          id: "26599",
          name: "Platen",
          state_id: "2239",
        },
        {
          id: "26600",
          name: "Pratz",
          state_id: "2239",
        },
        {
          id: "26601",
          name: "Rambrouch",
          state_id: "2239",
        },
        {
          id: "26602",
          name: "Redange",
          state_id: "2239",
        },
        {
          id: "26603",
          name: "Reichlange",
          state_id: "2239",
        },
        {
          id: "26604",
          name: "Reimberg",
          state_id: "2239",
        },
        {
          id: "26605",
          name: "Rippweiler",
          state_id: "2239",
        },
        {
          id: "26606",
          name: "Rombach",
          state_id: "2239",
        },
        {
          id: "26607",
          name: "Roodt",
          state_id: "2239",
        },
        {
          id: "26608",
          name: "Saeul",
          state_id: "2239",
        },
        {
          id: "26609",
          name: "Schandel",
          state_id: "2239",
        },
        {
          id: "26610",
          name: "Schwebach",
          state_id: "2239",
        },
        {
          id: "26611",
          name: "Schweich",
          state_id: "2239",
        },
        {
          id: "26612",
          name: "Useldange",
          state_id: "2239",
        },
        {
          id: "26613",
          name: "Vichten",
          state_id: "2239",
        },
        {
          id: "26614",
          name: "Wahl",
          state_id: "2239",
        },
        {
          id: "26615",
          name: "Wolwelange",
          state_id: "2239",
        },
      ],
      Remich: [
        {
          id: "26616",
          name: "Altwies",
          state_id: "2240",
        },
        {
          id: "26617",
          name: "Assel",
          state_id: "2240",
        },
        {
          id: "26618",
          name: "Bech-Kleinmacher",
          state_id: "2240",
        },
        {
          id: "26619",
          name: "Bous",
          state_id: "2240",
        },
        {
          id: "26620",
          name: "Burmerange",
          state_id: "2240",
        },
        {
          id: "26621",
          name: "Canach",
          state_id: "2240",
        },
        {
          id: "26622",
          name: "Dalheim",
          state_id: "2240",
        },
        {
          id: "26623",
          name: "Ellange",
          state_id: "2240",
        },
        {
          id: "26624",
          name: "Elvange",
          state_id: "2240",
        },
        {
          id: "26625",
          name: "Emerange",
          state_id: "2240",
        },
        {
          id: "26626",
          name: "Erpeldange",
          state_id: "2240",
        },
        {
          id: "26627",
          name: "Filsdorf",
          state_id: "2240",
        },
        {
          id: "26628",
          name: "Greiveldange",
          state_id: "2240",
        },
        {
          id: "26629",
          name: "Lenningen",
          state_id: "2240",
        },
        {
          id: "26630",
          name: "Mondorf-les-Bains",
          state_id: "2240",
        },
        {
          id: "26631",
          name: "Remerschen",
          state_id: "2240",
        },
        {
          id: "26632",
          name: "Remich",
          state_id: "2240",
        },
        {
          id: "26633",
          name: "Rolling",
          state_id: "2240",
        },
        {
          id: "26634",
          name: "Schengen",
          state_id: "2240",
        },
        {
          id: "26635",
          name: "Schwebsingen",
          state_id: "2240",
        },
        {
          id: "26636",
          name: "Stadtbredimus",
          state_id: "2240",
        },
        {
          id: "26637",
          name: "Trintange",
          state_id: "2240",
        },
        {
          id: "26638",
          name: "Trintange-Ersange-Roedt",
          state_id: "2240",
        },
        {
          id: "26639",
          name: "Waldbredimus",
          state_id: "2240",
        },
        {
          id: "26640",
          name: "Welfrange",
          state_id: "2240",
        },
        {
          id: "26641",
          name: "Wellenstein",
          state_id: "2240",
        },
        {
          id: "26642",
          name: "Wintrange",
          state_id: "2240",
        },
      ],
      Vianden: [
        {
          id: "26643",
          name: "Bettel",
          state_id: "2241",
        },
        {
          id: "26644",
          name: "Bivels",
          state_id: "2241",
        },
        {
          id: "26645",
          name: "Fouhren",
          state_id: "2241",
        },
        {
          id: "26646",
          name: "Gralingen",
          state_id: "2241",
        },
        {
          id: "26647",
          name: "Longsdorf",
          state_id: "2241",
        },
        {
          id: "26648",
          name: "Merscheid",
          state_id: "2241",
        },
        {
          id: "26649",
          name: "Nachtmanderscheid",
          state_id: "2241",
        },
        {
          id: "26650",
          name: "Putscheid",
          state_id: "2241",
        },
        {
          id: "26651",
          name: "Stolzembourg",
          state_id: "2241",
        },
        {
          id: "26652",
          name: "Vianden",
          state_id: "2241",
        },
        {
          id: "26653",
          name: "Walsdorf",
          state_id: "2241",
        },
        {
          id: "26654",
          name: "Weiler",
          state_id: "2241",
        },
      ],
      Wiltz: [
        {
          id: "26655",
          name: "Alscheid",
          state_id: "2242",
        },
        {
          id: "26656",
          name: "Baschleiden",
          state_id: "2242",
        },
        {
          id: "26657",
          name: "Bavigne",
          state_id: "2242",
        },
        {
          id: "26658",
          name: "Berle",
          state_id: "2242",
        },
        {
          id: "26659",
          name: "Bockholtz",
          state_id: "2242",
        },
        {
          id: "26660",
          name: "Boulaide",
          state_id: "2242",
        },
        {
          id: "26661",
          name: "Buderscheid",
          state_id: "2242",
        },
        {
          id: "26662",
          name: "Dahl",
          state_id: "2242",
        },
        {
          id: "26663",
          name: "Doncols",
          state_id: "2242",
        },
        {
          id: "26664",
          name: "Enscherange",
          state_id: "2242",
        },
        {
          id: "26665",
          name: "Erpeldange",
          state_id: "2242",
        },
        {
          id: "26666",
          name: "Esch-sur-Sure",
          state_id: "2242",
        },
        {
          id: "26667",
          name: "Eschdorf",
          state_id: "2242",
        },
        {
          id: "26668",
          name: "Eschweiler",
          state_id: "2242",
        },
        {
          id: "26669",
          name: "Goesdorf",
          state_id: "2242",
        },
        {
          id: "26670",
          name: "Grumelscheid",
          state_id: "2242",
        },
        {
          id: "26671",
          name: "Harlange",
          state_id: "2242",
        },
        {
          id: "26672",
          name: "Heiderscheid",
          state_id: "2242",
        },
        {
          id: "26673",
          name: "Heiderscheid-Fond",
          state_id: "2242",
        },
        {
          id: "26674",
          name: "Hierheck",
          state_id: "2242",
        },
        {
          id: "26675",
          name: "Insenborn",
          state_id: "2242",
        },
        {
          id: "26676",
          name: "Kaundorf",
          state_id: "2242",
        },
        {
          id: "26677",
          name: "Kautenbach",
          state_id: "2242",
        },
        {
          id: "26678",
          name: "Knaphoscheid",
          state_id: "2242",
        },
        {
          id: "26679",
          name: "Lellingen",
          state_id: "2242",
        },
        {
          id: "26680",
          name: "Liefrange",
          state_id: "2242",
        },
        {
          id: "26681",
          name: "Lultzhausen",
          state_id: "2242",
        },
        {
          id: "26682",
          name: "Masseler",
          state_id: "2242",
        },
        {
          id: "26683",
          name: "Mecher",
          state_id: "2242",
        },
        {
          id: "26684",
          name: "Merckholtz",
          state_id: "2242",
        },
        {
          id: "26685",
          name: "Merscheid",
          state_id: "2242",
        },
        {
          id: "26686",
          name: "Neunhausen",
          state_id: "2242",
        },
        {
          id: "26687",
          name: "Nocher",
          state_id: "2242",
        },
        {
          id: "26688",
          name: "Nocher-Route",
          state_id: "2242",
        },
        {
          id: "26689",
          name: "Noertrange",
          state_id: "2242",
        },
        {
          id: "26690",
          name: "Nothum",
          state_id: "2242",
        },
        {
          id: "26691",
          name: "Pintsch",
          state_id: "2242",
        },
        {
          id: "26692",
          name: "Pommerloch",
          state_id: "2242",
        },
        {
          id: "26693",
          name: "Schleif",
          state_id: "2242",
        },
        {
          id: "26694",
          name: "Selscheid",
          state_id: "2242",
        },
        {
          id: "26695",
          name: "Sonlez",
          state_id: "2242",
        },
        {
          id: "26696",
          name: "Surre",
          state_id: "2242",
        },
        {
          id: "26697",
          name: "Tadler-Ringel-Dirbach",
          state_id: "2242",
        },
        {
          id: "26698",
          name: "Tarchamps",
          state_id: "2242",
        },
        {
          id: "26699",
          name: "Watrange",
          state_id: "2242",
        },
        {
          id: "26700",
          name: "Wiltz",
          state_id: "2242",
        },
        {
          id: "26701",
          name: "Wilwerwiltz",
          state_id: "2242",
        },
        {
          id: "26702",
          name: "Winseler",
          state_id: "2242",
        },
      ],
    },
  },
  LV: {
    name: "Latvia",
    native: "Latvija",
    phone: "371",
    continent: "EU",
    capital: "Riga",
    currency: "EUR",
    languages: ["lv"],
    emoji: "🇱🇻",
    emojiU: "U+1F1F1 U+1F1FB",
    states: {
      Aizkraukles: [
        {
          id: "25947",
          name: "Aizkraukle",
          state_id: "2117",
        },
        {
          id: "25948",
          name: "Jaunjelgava",
          state_id: "2117",
        },
        {
          id: "25949",
          name: "Plavinas",
          state_id: "2117",
        },
      ],
      Aluksnes: [
        {
          id: "25950",
          name: "Aluksne",
          state_id: "2118",
        },
        {
          id: "25951",
          name: "Ape",
          state_id: "2118",
        },
      ],
      Balvu: [
        {
          id: "25952",
          name: "Balvi",
          state_id: "2119",
        },
        {
          id: "25953",
          name: "Vilaka",
          state_id: "2119",
        },
      ],
      Bauskas: [
        {
          id: "25954",
          name: "Bauska",
          state_id: "2120",
        },
      ],
      Cesu: [
        {
          id: "25955",
          name: "Cesis",
          state_id: "2121",
        },
        {
          id: "25956",
          name: "Ligatne",
          state_id: "2121",
        },
      ],
      Daugavpils: [
        {
          id: "25957",
          name: "Ilukste",
          state_id: "2122",
        },
        {
          id: "25958",
          name: "Subate",
          state_id: "2122",
        },
      ],
      "Daugavpils City": [
        {
          id: "25959",
          name: "Ilukste",
          state_id: "2123",
        },
        {
          id: "25960",
          name: "Subate",
          state_id: "2123",
        },
      ],
      Dobeles: [
        {
          id: "25961",
          name: "Auce",
          state_id: "2124",
        },
        {
          id: "25962",
          name: "Dobele",
          state_id: "2124",
        },
      ],
      Gulbenes: [
        {
          id: "25963",
          name: "Gulbene",
          state_id: "2125",
        },
      ],
      Jekabspils: [
        {
          id: "25964",
          name: "Akniste",
          state_id: "2126",
        },
        {
          id: "25965",
          name: "Jekabspils",
          state_id: "2126",
        },
        {
          id: "25966",
          name: "Viesite",
          state_id: "2126",
        },
      ],
      Jelgava: [
        {
          id: "25967",
          name: "Jelgava",
          state_id: "2127",
        },
      ],
      Jelgavas: [
        {
          id: "25968",
          name: "Kalnciems",
          state_id: "2128",
        },
      ],
      "Jurmala City": [],
      Kraslavas: [
        {
          id: "25969",
          name: "Dagda",
          state_id: "2130",
        },
        {
          id: "25970",
          name: "Kraslava",
          state_id: "2130",
        },
      ],
      Kuldigas: [
        {
          id: "25971",
          name: "Kuldiga",
          state_id: "2131",
        },
        {
          id: "25972",
          name: "Skrunda",
          state_id: "2131",
        },
      ],
      Liepaja: [
        {
          id: "25973",
          name: "Liepaja",
          state_id: "2132",
        },
      ],
      Liepajas: [
        {
          id: "25974",
          name: "Aizpute",
          state_id: "2133",
        },
        {
          id: "25975",
          name: "Durbe",
          state_id: "2133",
        },
        {
          id: "25976",
          name: "Grobina",
          state_id: "2133",
        },
        {
          id: "25977",
          name: "Pavilosta",
          state_id: "2133",
        },
        {
          id: "25978",
          name: "Priekule",
          state_id: "2133",
        },
      ],
      Limbazhu: [
        {
          id: "25979",
          name: "Ainazhi",
          state_id: "2134",
        },
        {
          id: "25980",
          name: "Aloja",
          state_id: "2134",
        },
        {
          id: "25981",
          name: "Limbazhi",
          state_id: "2134",
        },
        {
          id: "25982",
          name: "Salacgriva",
          state_id: "2134",
        },
        {
          id: "25983",
          name: "Staicele",
          state_id: "2134",
        },
      ],
      Ludzas: [
        {
          id: "25984",
          name: "Karsava",
          state_id: "2135",
        },
        {
          id: "25985",
          name: "Ludza",
          state_id: "2135",
        },
        {
          id: "25986",
          name: "Zilupe",
          state_id: "2135",
        },
      ],
      Madonas: [
        {
          id: "25987",
          name: "Cesvaine",
          state_id: "2136",
        },
        {
          id: "25988",
          name: "Lubana",
          state_id: "2136",
        },
        {
          id: "25989",
          name: "Madona",
          state_id: "2136",
        },
        {
          id: "25990",
          name: "Varaklani",
          state_id: "2136",
        },
      ],
      Ogres: [
        {
          id: "25991",
          name: "Ikskile",
          state_id: "2137",
        },
        {
          id: "25992",
          name: "Kegums",
          state_id: "2137",
        },
        {
          id: "25993",
          name: "Les Hautes-Rivieres",
          state_id: "2137",
        },
        {
          id: "25994",
          name: "Lielvarde",
          state_id: "2137",
        },
        {
          id: "25995",
          name: "Ogre",
          state_id: "2137",
        },
      ],
      Preilu: [
        {
          id: "25996",
          name: "Livani",
          state_id: "2138",
        },
        {
          id: "25997",
          name: "Preili",
          state_id: "2138",
        },
      ],
      Rezekne: [
        {
          id: "25998",
          name: "Rezekne",
          state_id: "2139",
        },
      ],
      Rezeknes: [
        {
          id: "25999",
          name: "Vilani",
          state_id: "2140",
        },
      ],
      Riga: [
        {
          id: "26000",
          name: "Riga",
          state_id: "2141",
        },
      ],
      Rigas: [
        {
          id: "26001",
          name: "Baldone",
          state_id: "2142",
        },
        {
          id: "26002",
          name: "Balozhi",
          state_id: "2142",
        },
        {
          id: "26003",
          name: "Olaine",
          state_id: "2142",
        },
        {
          id: "26004",
          name: "Salaspils",
          state_id: "2142",
        },
        {
          id: "26005",
          name: "Saulkrasti",
          state_id: "2142",
        },
        {
          id: "26006",
          name: "Sigulda",
          state_id: "2142",
        },
        {
          id: "26007",
          name: "Vangazhi",
          state_id: "2142",
        },
      ],
      Saldus: [
        {
          id: "26008",
          name: "Broceni",
          state_id: "2143",
        },
        {
          id: "26009",
          name: "Saldus",
          state_id: "2143",
        },
      ],
      Talsu: [
        {
          id: "26010",
          name: "Sabile",
          state_id: "2144",
        },
        {
          id: "26011",
          name: "Stende",
          state_id: "2144",
        },
        {
          id: "26012",
          name: "Talsi",
          state_id: "2144",
        },
        {
          id: "26013",
          name: "Valdemarpils",
          state_id: "2144",
        },
      ],
      Tukuma: [
        {
          id: "26014",
          name: "Kandava",
          state_id: "2145",
        },
        {
          id: "26015",
          name: "Tukums",
          state_id: "2145",
        },
      ],
      Valkas: [
        {
          id: "26016",
          name: "Seda",
          state_id: "2146",
        },
        {
          id: "26017",
          name: "Smiltene",
          state_id: "2146",
        },
        {
          id: "26018",
          name: "Strenchi",
          state_id: "2146",
        },
        {
          id: "26019",
          name: "Valka",
          state_id: "2146",
        },
      ],
      Valmieras: [
        {
          id: "26020",
          name: "Mazsalaca",
          state_id: "2147",
        },
        {
          id: "26021",
          name: "Rujiena",
          state_id: "2147",
        },
        {
          id: "26022",
          name: "Valmiera",
          state_id: "2147",
        },
      ],
      Ventspils: [
        {
          id: "26023",
          name: "Piltene",
          state_id: "2148",
        },
      ],
      "Ventspils City": [
        {
          id: "26024",
          name: "Piltene",
          state_id: "2149",
        },
      ],
    },
  },
  LY: {
    name: "Libya",
    native: "‏ليبيا",
    phone: "218",
    continent: "AF",
    capital: "Tripoli",
    currency: "LYD",
    languages: ["ar"],
    emoji: "🇱🇾",
    emojiU: "U+1F1F1 U+1F1FE",
    states: {
      Ajdabiya: [
        {
          id: "26065",
          name: "Ajdabiya",
          state_id: "2181",
        },
        {
          id: "26066",
          name: "Awjilah",
          state_id: "2181",
        },
        {
          id: "26067",
          name: "Marsa al-Burayqah",
          state_id: "2181",
        },
        {
          id: "26068",
          name: "az-Zuwaytinah",
          state_id: "2181",
        },
      ],
      Fezzan: [
        {
          id: "26069",
          name: "Awbari",
          state_id: "2182",
        },
        {
          id: "26070",
          name: "Ghat",
          state_id: "2182",
        },
      ],
      Banghazi: [
        {
          id: "26071",
          name: "Banghazi",
          state_id: "2183",
        },
        {
          id: "26072",
          name: "Suluq",
          state_id: "2183",
        },
        {
          id: "26073",
          name: "al-Quriyah",
          state_id: "2183",
        },
      ],
      Darnah: [
        {
          id: "26074",
          name: "Darnah",
          state_id: "2184",
        },
      ],
      Ghadamis: [
        {
          id: "26075",
          name: "Ghadamis",
          state_id: "2185",
        },
        {
          id: "26076",
          name: "Nalut",
          state_id: "2185",
        },
      ],
      Gharyan: [
        {
          id: "26077",
          name: "Gharyan",
          state_id: "2186",
        },
        {
          id: "26078",
          name: "Mizdah",
          state_id: "2186",
        },
        {
          id: "26079",
          name: "al-Qaryah-ash-Sharqiyah",
          state_id: "2186",
        },
      ],
      Misratah: [
        {
          id: "26080",
          name: "Misratah",
          state_id: "2187",
        },
      ],
      Murzuq: [
        {
          id: "26081",
          name: "Murzuq",
          state_id: "2188",
        },
      ],
      Sabha: [
        {
          id: "26082",
          name: "Sabha",
          state_id: "2189",
        },
      ],
      Sawfajjin: [
        {
          id: "26083",
          name: "Bani Walid",
          state_id: "2190",
        },
      ],
      Surt: [
        {
          id: "26084",
          name: "Surt",
          state_id: "2191",
        },
      ],
      Tarabulus: [
        {
          id: "26085",
          name: "Tarabulus",
          state_id: "2192",
        },
        {
          id: "26086",
          name: "Tripoli",
          state_id: "2192",
        },
      ],
      Tarhunah: [
        {
          id: "26087",
          name: "Tarhunah",
          state_id: "2193",
        },
      ],
      Tripolitania: [
        {
          id: "26088",
          name: "Misrata",
          state_id: "2194",
        },
      ],
      Tubruq: [
        {
          id: "26089",
          name: "Bardiyah",
          state_id: "2195",
        },
        {
          id: "26090",
          name: "Tubruq",
          state_id: "2195",
        },
      ],
      Yafran: [
        {
          id: "26091",
          name: "Yafran",
          state_id: "2196",
        },
      ],
      Zlitan: [
        {
          id: "26092",
          name: "Zlitan",
          state_id: "2197",
        },
      ],
      "al-''Aziziyah": [
        {
          id: "26093",
          name: "al-Aziziyah",
          state_id: "2198",
        },
      ],
      "al-Fatih": [
        {
          id: "26094",
          name: "al-Abyar",
          state_id: "2199",
        },
        {
          id: "26095",
          name: "al-Marj",
          state_id: "2199",
        },
      ],
      "al-Jabal al Akhdar": [],
      "al-Jufrah": [
        {
          id: "26096",
          name: "Waddan",
          state_id: "2201",
        },
      ],
      "al-Khums": [
        {
          id: "26097",
          name: "al-Khums",
          state_id: "2202",
        },
      ],
      "al-Kufrah": [
        {
          id: "26098",
          name: "al-Jawf",
          state_id: "2203",
        },
      ],
      "an-Nuqat al-Khams": [],
      "ash-Shati": [
        {
          id: "26099",
          name: "Birak",
          state_id: "2205",
        },
      ],
      "az-Zawiyah": [
        {
          id: "26100",
          name: "az-Zawiyah",
          state_id: "2206",
        },
      ],
    },
  },
  MA: {
    name: "Morocco",
    native: "المغرب",
    phone: "212",
    continent: "AF",
    capital: "Rabat",
    currency: "MAD",
    languages: ["ar"],
    emoji: "🇲🇦",
    emojiU: "U+1F1F2 U+1F1E6",
    states: {
      Agadir: [
        {
          id: "29576",
          name: "Agadir",
          state_id: "2504",
        },
      ],
      Casablanca: [
        {
          id: "29577",
          name: "Mohammedia",
          state_id: "2505",
        },
        {
          id: "29578",
          name: "ad-Dar-al-Bayda",
          state_id: "2505",
        },
      ],
      "Chaouia-Ouardigha": [
        {
          id: "29579",
          name: "Bin Sulayman",
          state_id: "2506",
        },
        {
          id: "29580",
          name: "Bir Rashid",
          state_id: "2506",
        },
        {
          id: "29581",
          name: "Bu-al-Jad",
          state_id: "2506",
        },
        {
          id: "29582",
          name: "Buznika",
          state_id: "2506",
        },
        {
          id: "29583",
          name: "Khuribghah",
          state_id: "2506",
        },
        {
          id: "29584",
          name: "Sattat",
          state_id: "2506",
        },
        {
          id: "29585",
          name: "Wad Zam",
          state_id: "2506",
        },
      ],
      "Doukkala-Abda": [
        {
          id: "29586",
          name: "Asfi",
          state_id: "2507",
        },
        {
          id: "29587",
          name: "Azimur",
          state_id: "2507",
        },
        {
          id: "29588",
          name: "Sidi Binnur",
          state_id: "2507",
        },
        {
          id: "29589",
          name: "Sidi Isma''il",
          state_id: "2507",
        },
        {
          id: "29590",
          name: "Yussufiyah",
          state_id: "2507",
        },
        {
          id: "29591",
          name: "al-Jadidah",
          state_id: "2507",
        },
      ],
      "Fes-Boulemane": [
        {
          id: "29592",
          name: "Fas",
          state_id: "2508",
        },
        {
          id: "29593",
          name: "Fes",
          state_id: "2508",
        },
        {
          id: "29594",
          name: "Safru",
          state_id: "2508",
        },
      ],
      "Gharb-Chrarda-Beni Hssen": [],
      Guelmim: [
        {
          id: "29595",
          name: "Ghulimim",
          state_id: "2510",
        },
        {
          id: "29596",
          name: "Sidi Ifni",
          state_id: "2510",
        },
        {
          id: "29597",
          name: "Tafraut",
          state_id: "2510",
        },
        {
          id: "29598",
          name: "Tantan",
          state_id: "2510",
        },
      ],
      Kenitra: [
        {
          id: "29599",
          name: "Kenitra",
          state_id: "2511",
        },
      ],
      "Marrakech-Tensift-Al Haouz": [],
      "Meknes-Tafilalet": [
        {
          id: "29600",
          name: "Amalu Ighriban",
          state_id: "2513",
        },
        {
          id: "29601",
          name: "Azru",
          state_id: "2513",
        },
        {
          id: "29602",
          name: "Jama''at-al-Marirt",
          state_id: "2513",
        },
        {
          id: "29603",
          name: "Khanifrah",
          state_id: "2513",
        },
        {
          id: "29604",
          name: "Meknes",
          state_id: "2513",
        },
        {
          id: "29605",
          name: "Midalt",
          state_id: "2513",
        },
        {
          id: "29606",
          name: "Miknas",
          state_id: "2513",
        },
        {
          id: "29607",
          name: "Mulay Idris",
          state_id: "2513",
        },
        {
          id: "29608",
          name: "al-Hajab",
          state_id: "2513",
        },
        {
          id: "29609",
          name: "ar-Rasidiyah",
          state_id: "2513",
        },
      ],
      Oriental: [
        {
          id: "29610",
          name: "Ahfir",
          state_id: "2514",
        },
        {
          id: "29611",
          name: "Bin Ansar",
          state_id: "2514",
        },
        {
          id: "29612",
          name: "Birkan",
          state_id: "2514",
        },
        {
          id: "29613",
          name: "Fijij",
          state_id: "2514",
        },
        {
          id: "29614",
          name: "Jaradah",
          state_id: "2514",
        },
        {
          id: "29615",
          name: "Tawrirt",
          state_id: "2514",
        },
        {
          id: "29616",
          name: "Ujdah",
          state_id: "2514",
        },
        {
          id: "29617",
          name: "Zayu",
          state_id: "2514",
        },
        {
          id: "29618",
          name: "al-Arwi",
          state_id: "2514",
        },
        {
          id: "29619",
          name: "al-Ayun Sidi Malluk",
          state_id: "2514",
        },
        {
          id: "29620",
          name: "an-Nadur",
          state_id: "2514",
        },
      ],
      Oujda: [
        {
          id: "29621",
          name: "Oujda",
          state_id: "2515",
        },
      ],
      "Province de Tanger": [],
      "Rabat-Sale-Zammour-Zaer": [
        {
          id: "29622",
          name: "Khamissat",
          state_id: "2517",
        },
        {
          id: "29623",
          name: "Sakhirat",
          state_id: "2517",
        },
        {
          id: "29624",
          name: "Tiflat",
          state_id: "2517",
        },
        {
          id: "29625",
          name: "ar-Ribat",
          state_id: "2517",
        },
      ],
      "Sala Al Jadida": [],
      Settat: [
        {
          id: "29626",
          name: "Settat",
          state_id: "2519",
        },
      ],
      "Souss Massa-Draa": [],
      "Tadla-Azilal": [
        {
          id: "29627",
          name: "Bani Mallal",
          state_id: "2521",
        },
        {
          id: "29628",
          name: "Beni Mellal",
          state_id: "2521",
        },
        {
          id: "29629",
          name: "Qasbat Tadlah",
          state_id: "2521",
        },
        {
          id: "29630",
          name: "Suq Sabt Awlat Nama",
          state_id: "2521",
        },
        {
          id: "29631",
          name: "al-Faqih Bin Salah",
          state_id: "2521",
        },
      ],
      "Tangier-Tetouan": [
        {
          id: "29632",
          name: "Asilah",
          state_id: "2522",
        },
        {
          id: "29633",
          name: "Finidiq",
          state_id: "2522",
        },
        {
          id: "29634",
          name: "Martil",
          state_id: "2522",
        },
        {
          id: "29635",
          name: "Midiq",
          state_id: "2522",
        },
        {
          id: "29636",
          name: "Shifshawn",
          state_id: "2522",
        },
        {
          id: "29637",
          name: "Tangier",
          state_id: "2522",
        },
        {
          id: "29638",
          name: "Tanjah",
          state_id: "2522",
        },
        {
          id: "29639",
          name: "Tittawin",
          state_id: "2522",
        },
        {
          id: "29640",
          name: "Titwan",
          state_id: "2522",
        },
        {
          id: "29641",
          name: "al-''Ara''ish",
          state_id: "2522",
        },
        {
          id: "29642",
          name: "al-Qasr-al-Kabir",
          state_id: "2522",
        },
      ],
      "Taza-Al Hoceima-Taounate": [],
      "Wilaya de Casablanca": [],
      "Wilaya de Rabat-Sale": [],
    },
  },
  MC: {
    name: "Monaco",
    native: "Monaco",
    phone: "377",
    continent: "EU",
    capital: "Monaco",
    currency: "EUR",
    languages: ["fr"],
    emoji: "🇲🇨",
    emojiU: "U+1F1F2 U+1F1E8",
    states: {
      Fontvieille: [
        {
          id: "29548",
          name: "Fontvieille",
          state_id: "2477",
        },
      ],
      "La Condamine": [],
      "Monaco-Ville": [
        {
          id: "29549",
          name: "Monaco-Ville",
          state_id: "2479",
        },
      ],
      "Monte Carlo": [],
    },
  },
  MD: {
    name: "Moldova",
    native: "Moldova",
    phone: "373",
    continent: "EU",
    capital: "Chișinău",
    currency: "MDL",
    languages: ["ro"],
    emoji: "🇲🇩",
    emojiU: "U+1F1F2 U+1F1E9",
    states: {
      Balti: [
        {
          id: "29511",
          name: "Balti",
          state_id: "2464",
        },
        {
          id: "29512",
          name: "Falesti",
          state_id: "2464",
        },
        {
          id: "29513",
          name: "Glodeni",
          state_id: "2464",
        },
        {
          id: "29514",
          name: "Rascani",
          state_id: "2464",
        },
      ],
      Cahul: [
        {
          id: "29515",
          name: "Cahul",
          state_id: "2465",
        },
      ],
      Chisinau: [
        {
          id: "29516",
          name: "Straseni",
          state_id: "2466",
        },
      ],
      "Chisinau Oras": [
        {
          id: "29517",
          name: "Straseni",
          state_id: "2467",
        },
      ],
      Edinet: [
        {
          id: "29518",
          name: "Briceni",
          state_id: "2468",
        },
        {
          id: "29519",
          name: "Donduseni",
          state_id: "2468",
        },
        {
          id: "29520",
          name: "Edinet",
          state_id: "2468",
        },
        {
          id: "29521",
          name: "Ocnita",
          state_id: "2468",
        },
      ],
      Gagauzia: [
        {
          id: "29522",
          name: "Ciadar Lunga",
          state_id: "2469",
        },
        {
          id: "29523",
          name: "Comrat",
          state_id: "2469",
        },
        {
          id: "29524",
          name: "Vulcanesti",
          state_id: "2469",
        },
      ],
      Lapusna: [
        {
          id: "29525",
          name: "Basarabeasca",
          state_id: "2470",
        },
        {
          id: "29526",
          name: "Cimislia",
          state_id: "2470",
        },
        {
          id: "29527",
          name: "Hancesti",
          state_id: "2470",
        },
        {
          id: "29528",
          name: "Leova",
          state_id: "2470",
        },
      ],
      Orhei: [
        {
          id: "29529",
          name: "Orhei",
          state_id: "2471",
        },
        {
          id: "29530",
          name: "Rezina",
          state_id: "2471",
        },
        {
          id: "29531",
          name: "Telenesti",
          state_id: "2471",
        },
      ],
      Soroca: [
        {
          id: "29532",
          name: "Drochia",
          state_id: "2472",
        },
        {
          id: "29533",
          name: "Floresti",
          state_id: "2472",
        },
        {
          id: "29534",
          name: "Soroca",
          state_id: "2472",
        },
      ],
      Taraclia: [
        {
          id: "29535",
          name: "Taraclia",
          state_id: "2473",
        },
      ],
      Tighina: [
        {
          id: "29536",
          name: "Causani",
          state_id: "2474",
        },
      ],
      Transnistria: [
        {
          id: "29537",
          name: "Camenca",
          state_id: "2475",
        },
        {
          id: "29538",
          name: "Dnestrovsc",
          state_id: "2475",
        },
        {
          id: "29539",
          name: "Dubasari",
          state_id: "2475",
        },
        {
          id: "29540",
          name: "Griguriopol",
          state_id: "2475",
        },
        {
          id: "29541",
          name: "Rabnita",
          state_id: "2475",
        },
        {
          id: "29542",
          name: "Slobozia",
          state_id: "2475",
        },
        {
          id: "29543",
          name: "Tighina",
          state_id: "2475",
        },
        {
          id: "29544",
          name: "Tiraspol",
          state_id: "2475",
        },
      ],
      Ungheni: [
        {
          id: "29545",
          name: "Calarasi",
          state_id: "2476",
        },
        {
          id: "29546",
          name: "Nisporeni",
          state_id: "2476",
        },
        {
          id: "29547",
          name: "Ungheni",
          state_id: "2476",
        },
      ],
    },
  },
  ME: {
    name: "Montenegro",
    native: "Црна Гора",
    phone: "382",
    continent: "EU",
    capital: "Podgorica",
    currency: "EUR",
    languages: ["sr", "bs", "sq", "hr"],
    emoji: "🇲🇪",
    emojiU: "U+1F1F2 U+1F1EA",
    states: {},
  },
  MF: {
    name: "Saint Martin",
    native: "Saint-Martin",
    phone: "590",
    continent: "NA",
    capital: "Marigot",
    currency: "EUR",
    languages: ["en", "fr", "nl"],
    emoji: "🇲🇫",
    emojiU: "U+1F1F2 U+1F1EB",
    states: {},
  },
  MG: {
    name: "Madagascar",
    native: "Madagasikara",
    phone: "261",
    continent: "AF",
    capital: "Antananarivo",
    currency: "MGA",
    languages: ["fr", "mg"],
    emoji: "🇲🇬",
    emojiU: "U+1F1F2 U+1F1EC",
    states: {
      Antananarivo: [
        {
          id: "26816",
          name: "Ambatolampy",
          state_id: "2274",
        },
        {
          id: "26817",
          name: "Anjozorobe",
          state_id: "2274",
        },
        {
          id: "26818",
          name: "Ankazobe",
          state_id: "2274",
        },
        {
          id: "26819",
          name: "Antananarivo",
          state_id: "2274",
        },
        {
          id: "26820",
          name: "Antanifotsy",
          state_id: "2274",
        },
        {
          id: "26821",
          name: "Antsirabe",
          state_id: "2274",
        },
        {
          id: "26822",
          name: "Arivonimamo",
          state_id: "2274",
        },
        {
          id: "26823",
          name: "Betafo",
          state_id: "2274",
        },
        {
          id: "26824",
          name: "Faratsiho",
          state_id: "2274",
        },
        {
          id: "26825",
          name: "Fenoarivo",
          state_id: "2274",
        },
        {
          id: "26826",
          name: "Manjakandriana",
          state_id: "2274",
        },
        {
          id: "26827",
          name: "Soavinandriana",
          state_id: "2274",
        },
        {
          id: "26828",
          name: "Tsiroanomandidy",
          state_id: "2274",
        },
      ],
      Antsiranana: [
        {
          id: "26829",
          name: "Ambanja",
          state_id: "2275",
        },
        {
          id: "26830",
          name: "Ambilobe",
          state_id: "2275",
        },
        {
          id: "26831",
          name: "Andapa",
          state_id: "2275",
        },
        {
          id: "26832",
          name: "Antalaha",
          state_id: "2275",
        },
        {
          id: "26833",
          name: "Antsirambazaha",
          state_id: "2275",
        },
        {
          id: "26834",
          name: "Antsiranana",
          state_id: "2275",
        },
        {
          id: "26835",
          name: "Sambava",
          state_id: "2275",
        },
      ],
      Fianarantsoa: [
        {
          id: "26836",
          name: "Ambalavao",
          state_id: "2276",
        },
        {
          id: "26837",
          name: "Ambatofinandrahana",
          state_id: "2276",
        },
        {
          id: "26838",
          name: "Ambositra",
          state_id: "2276",
        },
        {
          id: "26839",
          name: "Fandriana",
          state_id: "2276",
        },
        {
          id: "26840",
          name: "Farafangana",
          state_id: "2276",
        },
        {
          id: "26841",
          name: "Fianarantsoa",
          state_id: "2276",
        },
        {
          id: "26842",
          name: "Ifanadiana",
          state_id: "2276",
        },
        {
          id: "26843",
          name: "Ihosy",
          state_id: "2276",
        },
        {
          id: "26844",
          name: "Ikalamavony",
          state_id: "2276",
        },
        {
          id: "26845",
          name: "Ikongo",
          state_id: "2276",
        },
        {
          id: "26846",
          name: "Manakara",
          state_id: "2276",
        },
        {
          id: "26847",
          name: "Manandriana",
          state_id: "2276",
        },
        {
          id: "26848",
          name: "Mananjary",
          state_id: "2276",
        },
        {
          id: "26849",
          name: "Nosy Varika",
          state_id: "2276",
        },
        {
          id: "26850",
          name: "Vangaindrano",
          state_id: "2276",
        },
        {
          id: "26851",
          name: "Vondrozo",
          state_id: "2276",
        },
      ],
      Mahajanga: [
        {
          id: "26852",
          name: "Ambato Boina",
          state_id: "2277",
        },
        {
          id: "26853",
          name: "Antsohihy",
          state_id: "2277",
        },
        {
          id: "26854",
          name: "Bealanana",
          state_id: "2277",
        },
        {
          id: "26855",
          name: "Mahajanga",
          state_id: "2277",
        },
        {
          id: "26856",
          name: "Marovoay",
          state_id: "2277",
        },
        {
          id: "26857",
          name: "Tsaratanana",
          state_id: "2277",
        },
      ],
      Toamasina: [
        {
          id: "26858",
          name: "Ambatondrazaka",
          state_id: "2278",
        },
        {
          id: "26859",
          name: "Ambodifototra",
          state_id: "2278",
        },
        {
          id: "26860",
          name: "Amparafaravola",
          state_id: "2278",
        },
        {
          id: "26861",
          name: "Andevoranto",
          state_id: "2278",
        },
        {
          id: "26862",
          name: "Andilamena",
          state_id: "2278",
        },
        {
          id: "26863",
          name: "Anosibe An''ala",
          state_id: "2278",
        },
        {
          id: "26864",
          name: "Fenoarivo Atsinanana",
          state_id: "2278",
        },
        {
          id: "26865",
          name: "Mahanoro",
          state_id: "2278",
        },
        {
          id: "26866",
          name: "Mananara",
          state_id: "2278",
        },
        {
          id: "26867",
          name: "Maroantsetra",
          state_id: "2278",
        },
        {
          id: "26868",
          name: "Marolambo",
          state_id: "2278",
        },
        {
          id: "26869",
          name: "Moramanga",
          state_id: "2278",
        },
        {
          id: "26870",
          name: "Soanierana Ivongo",
          state_id: "2278",
        },
        {
          id: "26871",
          name: "Toamasina",
          state_id: "2278",
        },
        {
          id: "26872",
          name: "Vavatenina",
          state_id: "2278",
        },
        {
          id: "26873",
          name: "Vohibinany",
          state_id: "2278",
        },
      ],
      Toliary: [
        {
          id: "26874",
          name: "Amboasary",
          state_id: "2279",
        },
        {
          id: "26875",
          name: "Ambovombe",
          state_id: "2279",
        },
        {
          id: "26876",
          name: "Ampanihy",
          state_id: "2279",
        },
        {
          id: "26877",
          name: "Ankazoabo",
          state_id: "2279",
        },
        {
          id: "26878",
          name: "Beloha",
          state_id: "2279",
        },
        {
          id: "26879",
          name: "Belon''i Tsiribihina",
          state_id: "2279",
        },
        {
          id: "26880",
          name: "Beroroha",
          state_id: "2279",
        },
        {
          id: "26881",
          name: "Betioky",
          state_id: "2279",
        },
        {
          id: "26882",
          name: "Miandrivazo",
          state_id: "2279",
        },
        {
          id: "26883",
          name: "Morondava",
          state_id: "2279",
        },
        {
          id: "26884",
          name: "Sakaraha",
          state_id: "2279",
        },
        {
          id: "26885",
          name: "Taolanaro",
          state_id: "2279",
        },
        {
          id: "26886",
          name: "Toliary",
          state_id: "2279",
        },
        {
          id: "26887",
          name: "Tsihombe",
          state_id: "2279",
        },
      ],
    },
  },
  MH: {
    name: "Marshall Islands",
    native: "M̧ajeļ",
    phone: "692",
    continent: "OC",
    capital: "Majuro",
    currency: "USD",
    languages: ["en", "mh"],
    emoji: "🇲🇭",
    emojiU: "U+1F1F2 U+1F1ED",
    states: {
      Ailinlaplap: [
        {
          id: "27282",
          name: "Aerok",
          state_id: "2370",
        },
        {
          id: "27283",
          name: "Beran",
          state_id: "2370",
        },
        {
          id: "27284",
          name: "Bikeer",
          state_id: "2370",
        },
        {
          id: "27285",
          name: "Buoj",
          state_id: "2370",
        },
        {
          id: "27286",
          name: "Enewe",
          state_id: "2370",
        },
        {
          id: "27287",
          name: "Jabwan",
          state_id: "2370",
        },
        {
          id: "27288",
          name: "Jah",
          state_id: "2370",
        },
        {
          id: "27289",
          name: "Jeh",
          state_id: "2370",
        },
        {
          id: "27290",
          name: "Kattiej",
          state_id: "2370",
        },
        {
          id: "27291",
          name: "Mejajok",
          state_id: "2370",
        },
        {
          id: "27292",
          name: "Mejil",
          state_id: "2370",
        },
        {
          id: "27293",
          name: "Tobomaro",
          state_id: "2370",
        },
        {
          id: "27294",
          name: "Woja",
          state_id: "2370",
        },
        {
          id: "27295",
          name: "Wolar",
          state_id: "2370",
        },
      ],
      Ailuk: [
        {
          id: "27296",
          name: "Ailuk",
          state_id: "2371",
        },
        {
          id: "27297",
          name: "Ajelep",
          state_id: "2371",
        },
        {
          id: "27298",
          name: "Aliej",
          state_id: "2371",
        },
        {
          id: "27299",
          name: "Biken",
          state_id: "2371",
        },
        {
          id: "27300",
          name: "Enejabrok",
          state_id: "2371",
        },
        {
          id: "27301",
          name: "Enejelar",
          state_id: "2371",
        },
        {
          id: "27302",
          name: "Kapen",
          state_id: "2371",
        },
      ],
      Arno: [
        {
          id: "27303",
          name: "Arno Arno",
          state_id: "2372",
        },
        {
          id: "27304",
          name: "Bikarej",
          state_id: "2372",
        },
        {
          id: "27305",
          name: "Bikonele",
          state_id: "2372",
        },
        {
          id: "27306",
          name: "Boken",
          state_id: "2372",
        },
        {
          id: "27307",
          name: "Eneaidrik",
          state_id: "2372",
        },
        {
          id: "27308",
          name: "Enirik",
          state_id: "2372",
        },
        {
          id: "27309",
          name: "Ijoen",
          state_id: "2372",
        },
        {
          id: "27310",
          name: "Ine",
          state_id: "2372",
        },
        {
          id: "27311",
          name: "Japo",
          state_id: "2372",
        },
        {
          id: "27312",
          name: "Jilane",
          state_id: "2372",
        },
        {
          id: "27313",
          name: "Kejbwe",
          state_id: "2372",
        },
        {
          id: "27314",
          name: "Kilange",
          state_id: "2372",
        },
        {
          id: "27315",
          name: "Kilemman",
          state_id: "2372",
        },
        {
          id: "27316",
          name: "Kinajon",
          state_id: "2372",
        },
        {
          id: "27317",
          name: "Langor",
          state_id: "2372",
        },
        {
          id: "27318",
          name: "Lukoj",
          state_id: "2372",
        },
        {
          id: "27319",
          name: "Malel",
          state_id: "2372",
        },
        {
          id: "27320",
          name: "Manrar",
          state_id: "2372",
        },
        {
          id: "27321",
          name: "Matolen",
          state_id: "2372",
        },
        {
          id: "27322",
          name: "Meetdik",
          state_id: "2372",
        },
        {
          id: "27323",
          name: "Mian",
          state_id: "2372",
        },
        {
          id: "27324",
          name: "Najaj",
          state_id: "2372",
        },
        {
          id: "27325",
          name: "Namwi",
          state_id: "2372",
        },
        {
          id: "27326",
          name: "Neenkotkot",
          state_id: "2372",
        },
        {
          id: "27327",
          name: "Taklep",
          state_id: "2372",
        },
        {
          id: "27328",
          name: "Tinak",
          state_id: "2372",
        },
        {
          id: "27329",
          name: "Tutu",
          state_id: "2372",
        },
        {
          id: "27330",
          name: "Ulien",
          state_id: "2372",
        },
      ],
      Aur: [
        {
          id: "27331",
          name: "Aur",
          state_id: "2373",
        },
        {
          id: "27332",
          name: "Tabal",
          state_id: "2373",
        },
      ],
      Bikini: [
        {
          id: "27333",
          name: "Eneu",
          state_id: "2374",
        },
      ],
      Ebon: [
        {
          id: "27334",
          name: "Emej",
          state_id: "2375",
        },
        {
          id: "27335",
          name: "Enearmij",
          state_id: "2375",
        },
        {
          id: "27336",
          name: "Enekoion",
          state_id: "2375",
        },
        {
          id: "27337",
          name: "Enilok",
          state_id: "2375",
        },
        {
          id: "27338",
          name: "Jittaken",
          state_id: "2375",
        },
        {
          id: "27339",
          name: "Jittoen",
          state_id: "2375",
        },
        {
          id: "27340",
          name: "Rerok",
          state_id: "2375",
        },
        {
          id: "27341",
          name: "Toka",
          state_id: "2375",
        },
      ],
      Enewetak: [
        {
          id: "27342",
          name: "Enewetak",
          state_id: "2376",
        },
        {
          id: "27343",
          name: "Japtan",
          state_id: "2376",
        },
        {
          id: "27344",
          name: "Medren",
          state_id: "2376",
        },
      ],
      Jabat: [
        {
          id: "27345",
          name: "Jabat",
          state_id: "2377",
        },
      ],
      Jaluit: [
        {
          id: "27346",
          name: "Ae",
          state_id: "2378",
        },
        {
          id: "27347",
          name: "Ajejen",
          state_id: "2378",
        },
        {
          id: "27348",
          name: "Anilep",
          state_id: "2378",
        },
        {
          id: "27349",
          name: "Arreen",
          state_id: "2378",
        },
        {
          id: "27350",
          name: "Bokanake",
          state_id: "2378",
        },
        {
          id: "27351",
          name: "Bokkan",
          state_id: "2378",
        },
        {
          id: "27352",
          name: "Bukantorak",
          state_id: "2378",
        },
        {
          id: "27353",
          name: "Dede",
          state_id: "2378",
        },
        {
          id: "27354",
          name: "Ewo",
          state_id: "2378",
        },
        {
          id: "27355",
          name: "Imiej",
          state_id: "2378",
        },
        {
          id: "27356",
          name: "Imroj",
          state_id: "2378",
        },
        {
          id: "27357",
          name: "Jabnoren",
          state_id: "2378",
        },
        {
          id: "27358",
          name: "Jabwor",
          state_id: "2378",
        },
        {
          id: "27359",
          name: "Jaluit",
          state_id: "2378",
        },
        {
          id: "27360",
          name: "Lonone",
          state_id: "2378",
        },
        {
          id: "27361",
          name: "Mejatto",
          state_id: "2378",
        },
        {
          id: "27362",
          name: "Mejrirok",
          state_id: "2378",
        },
        {
          id: "27363",
          name: "Menge",
          state_id: "2378",
        },
        {
          id: "27364",
          name: "Nabbe",
          state_id: "2378",
        },
        {
          id: "27365",
          name: "Narmej",
          state_id: "2378",
        },
        {
          id: "27366",
          name: "Urbaj",
          state_id: "2378",
        },
      ],
      Kili: [
        {
          id: "27367",
          name: "Kili",
          state_id: "2379",
        },
      ],
      Kwajalein: [
        {
          id: "27368",
          name: "Arbwa",
          state_id: "2380",
        },
        {
          id: "27369",
          name: "Ebadon",
          state_id: "2380",
        },
        {
          id: "27370",
          name: "Ebeye",
          state_id: "2380",
        },
        {
          id: "27371",
          name: "Ebjadik",
          state_id: "2380",
        },
        {
          id: "27372",
          name: "Ebwaj",
          state_id: "2380",
        },
        {
          id: "27373",
          name: "Ennilabegan",
          state_id: "2380",
        },
        {
          id: "27374",
          name: "Enubirr",
          state_id: "2380",
        },
        {
          id: "27375",
          name: "Enubuj",
          state_id: "2380",
        },
        {
          id: "27376",
          name: "Gugeegue",
          state_id: "2380",
        },
        {
          id: "27377",
          name: "Mejatto",
          state_id: "2380",
        },
        {
          id: "27378",
          name: "Ningi",
          state_id: "2380",
        },
        {
          id: "27379",
          name: "North Loi",
          state_id: "2380",
        },
        {
          id: "27380",
          name: "Orpap",
          state_id: "2380",
        },
        {
          id: "27381",
          name: "South Loi",
          state_id: "2380",
        },
      ],
      Lae: [
        {
          id: "27382",
          name: "Enerein",
          state_id: "2381",
        },
        {
          id: "27383",
          name: "Lae",
          state_id: "2381",
        },
        {
          id: "27384",
          name: "Lejab",
          state_id: "2381",
        },
      ],
      Lib: [
        {
          id: "27385",
          name: "Lib",
          state_id: "2382",
        },
      ],
      Likiep: [
        {
          id: "27386",
          name: "Jebal",
          state_id: "2383",
        },
        {
          id: "27387",
          name: "Likiep",
          state_id: "2383",
        },
        {
          id: "27388",
          name: "Liklal",
          state_id: "2383",
        },
        {
          id: "27389",
          name: "Melang",
          state_id: "2383",
        },
      ],
      Majuro: [
        {
          id: "27390",
          name: "Ajeltake",
          state_id: "2384",
        },
        {
          id: "27391",
          name: "Aneenwudej",
          state_id: "2384",
        },
        {
          id: "27392",
          name: "Aneko",
          state_id: "2384",
        },
        {
          id: "27393",
          name: "Arrak",
          state_id: "2384",
        },
        {
          id: "27394",
          name: "Biken",
          state_id: "2384",
        },
        {
          id: "27395",
          name: "Bokaetoktok",
          state_id: "2384",
        },
        {
          id: "27396",
          name: "Denmeo",
          state_id: "2384",
        },
        {
          id: "27397",
          name: "Didej",
          state_id: "2384",
        },
        {
          id: "27398",
          name: "Ejit",
          state_id: "2384",
        },
        {
          id: "27399",
          name: "Enemanet",
          state_id: "2384",
        },
        {
          id: "27400",
          name: "Jelter",
          state_id: "2384",
        },
        {
          id: "27401",
          name: "Kalalen",
          state_id: "2384",
        },
        {
          id: "27402",
          name: "Kemman",
          state_id: "2384",
        },
        {
          id: "27403",
          name: "Laura",
          state_id: "2384",
        },
        {
          id: "27404",
          name: "Pikiriin",
          state_id: "2384",
        },
        {
          id: "27405",
          name: "Rita",
          state_id: "2384",
        },
        {
          id: "27406",
          name: "Rongrong",
          state_id: "2384",
        },
        {
          id: "27407",
          name: "Woja",
          state_id: "2384",
        },
      ],
      Maloelap: [
        {
          id: "27408",
          name: "Airok",
          state_id: "2385",
        },
        {
          id: "27409",
          name: "Jang",
          state_id: "2385",
        },
        {
          id: "27410",
          name: "Kaben",
          state_id: "2385",
        },
        {
          id: "27411",
          name: "Tarawa",
          state_id: "2385",
        },
        {
          id: "27412",
          name: "Wolot",
          state_id: "2385",
        },
      ],
      Mejit: [
        {
          id: "27413",
          name: "Mejit",
          state_id: "2386",
        },
      ],
      Mili: [
        {
          id: "27414",
          name: "Aeloneo",
          state_id: "2387",
        },
        {
          id: "27415",
          name: "Anel",
          state_id: "2387",
        },
        {
          id: "27416",
          name: "Arbar",
          state_id: "2387",
        },
        {
          id: "27417",
          name: "Bar",
          state_id: "2387",
        },
        {
          id: "27418",
          name: "Bikonel",
          state_id: "2387",
        },
        {
          id: "27419",
          name: "Enajet",
          state_id: "2387",
        },
        {
          id: "27420",
          name: "Eoo",
          state_id: "2387",
        },
        {
          id: "27421",
          name: "Jabonwod",
          state_id: "2387",
        },
        {
          id: "27422",
          name: "Loen",
          state_id: "2387",
        },
        {
          id: "27423",
          name: "Lukoj",
          state_id: "2387",
        },
        {
          id: "27424",
          name: "Lukonwor",
          state_id: "2387",
        },
        {
          id: "27425",
          name: "Mae",
          state_id: "2387",
        },
        {
          id: "27426",
          name: "Majkin",
          state_id: "2387",
        },
        {
          id: "27427",
          name: "Mili",
          state_id: "2387",
        },
        {
          id: "27428",
          name: "Nad",
          state_id: "2387",
        },
        {
          id: "27429",
          name: "Nallu",
          state_id: "2387",
        },
        {
          id: "27430",
          name: "Tokewa",
          state_id: "2387",
        },
        {
          id: "27431",
          name: "Wau",
          state_id: "2387",
        },
      ],
      Namorik: [
        {
          id: "27432",
          name: "Namorik",
          state_id: "2388",
        },
      ],
      Namu: [
        {
          id: "27433",
          name: "Namu",
          state_id: "2389",
        },
      ],
      Rongelap: [
        {
          id: "27434",
          name: "Rongelap",
          state_id: "2390",
        },
      ],
      Ujae: [
        {
          id: "27435",
          name: "Ujae",
          state_id: "2391",
        },
      ],
      Utrik: [
        {
          id: "27436",
          name: "Utirik",
          state_id: "2392",
        },
      ],
      Wotho: [
        {
          id: "27437",
          name: "Wotho",
          state_id: "2393",
        },
      ],
      Wotje: [
        {
          id: "27438",
          name: "Didi",
          state_id: "2394",
        },
        {
          id: "27439",
          name: "Nibun",
          state_id: "2394",
        },
        {
          id: "27440",
          name: "Wormej",
          state_id: "2394",
        },
        {
          id: "27441",
          name: "Wotje",
          state_id: "2394",
        },
      ],
    },
  },
  MK: {
    name: "Macedonia",
    native: "Македонија",
    phone: "389",
    continent: "EU",
    capital: "Skopje",
    currency: "MKD",
    languages: ["mk"],
    emoji: "🇲🇰",
    emojiU: "U+1F1F2 U+1F1F0",
    states: {
      Berovo: [
        {
          id: "26704",
          name: "Berovo",
          state_id: "2244",
        },
        {
          id: "26705",
          name: "Pehchevo",
          state_id: "2244",
        },
      ],
      Bitola: [
        {
          id: "26706",
          name: "Bach",
          state_id: "2245",
        },
        {
          id: "26707",
          name: "Bistrica",
          state_id: "2245",
        },
        {
          id: "26708",
          name: "Bitola",
          state_id: "2245",
        },
        {
          id: "26709",
          name: "Capari",
          state_id: "2245",
        },
        {
          id: "26710",
          name: "Dobrushevo",
          state_id: "2245",
        },
        {
          id: "26711",
          name: "Kukurechani",
          state_id: "2245",
        },
        {
          id: "26712",
          name: "Mogila",
          state_id: "2245",
        },
        {
          id: "26713",
          name: "Novaci",
          state_id: "2245",
        },
        {
          id: "26714",
          name: "Staravina",
          state_id: "2245",
        },
      ],
      Brod: [
        {
          id: "26715",
          name: "Brod",
          state_id: "2246",
        },
        {
          id: "26716",
          name: "Plasnica",
          state_id: "2246",
        },
        {
          id: "26717",
          name: "Samokov",
          state_id: "2246",
        },
      ],
      Debar: [
        {
          id: "26718",
          name: "Debar",
          state_id: "2247",
        },
        {
          id: "26719",
          name: "Zhupa",
          state_id: "2247",
        },
      ],
      Delchevo: [
        {
          id: "26720",
          name: "Delchevo",
          state_id: "2248",
        },
        {
          id: "26721",
          name: "Kamenica",
          state_id: "2248",
        },
      ],
      "Demir Hisar": [],
      Gevgelija: [
        {
          id: "26722",
          name: "Bogdanci",
          state_id: "2250",
        },
        {
          id: "26723",
          name: "Gevgelija",
          state_id: "2250",
        },
        {
          id: "26724",
          name: "Miravci",
          state_id: "2250",
        },
        {
          id: "26725",
          name: "Star Dojran",
          state_id: "2250",
        },
      ],
      Gostivar: [
        {
          id: "26726",
          name: "Chegrane",
          state_id: "2251",
        },
        {
          id: "26727",
          name: "Dolna Banjica",
          state_id: "2251",
        },
        {
          id: "26728",
          name: "Gostivar",
          state_id: "2251",
        },
        {
          id: "26729",
          name: "Mavrovi Anovi",
          state_id: "2251",
        },
        {
          id: "26730",
          name: "Negotino-Poloshko",
          state_id: "2251",
        },
        {
          id: "26731",
          name: "Rostusha",
          state_id: "2251",
        },
        {
          id: "26732",
          name: "Srbinovo",
          state_id: "2251",
        },
        {
          id: "26733",
          name: "Vrapchishte",
          state_id: "2251",
        },
        {
          id: "26734",
          name: "Vrutok",
          state_id: "2251",
        },
      ],
      Kavadarci: [
        {
          id: "26735",
          name: "Kavadarci",
          state_id: "2252",
        },
        {
          id: "26736",
          name: "Konopishte",
          state_id: "2252",
        },
        {
          id: "26737",
          name: "Rosoman",
          state_id: "2252",
        },
      ],
      Kichevo: [
        {
          id: "26738",
          name: "Drugovo",
          state_id: "2253",
        },
        {
          id: "26739",
          name: "Kichevo",
          state_id: "2253",
        },
        {
          id: "26740",
          name: "Oslomej",
          state_id: "2253",
        },
        {
          id: "26741",
          name: "Vraneshtica",
          state_id: "2253",
        },
        {
          id: "26742",
          name: "Zajas",
          state_id: "2253",
        },
      ],
      Kochani: [
        {
          id: "26743",
          name: "Cheshinovo",
          state_id: "2254",
        },
        {
          id: "26744",
          name: "Kochani",
          state_id: "2254",
        },
        {
          id: "26745",
          name: "Obleshevo",
          state_id: "2254",
        },
        {
          id: "26746",
          name: "Zletovo",
          state_id: "2254",
        },
      ],
      Kratovo: [
        {
          id: "26747",
          name: "Kratovo",
          state_id: "2255",
        },
      ],
      "Kriva Palanka": [],
      Krushevo: [
        {
          id: "26748",
          name: "Krushevo",
          state_id: "2257",
        },
        {
          id: "26749",
          name: "Zhitoshe",
          state_id: "2257",
        },
      ],
      Kumanovo: [
        {
          id: "26750",
          name: "Izvor",
          state_id: "2258",
        },
        {
          id: "26751",
          name: "Klechevce",
          state_id: "2258",
        },
        {
          id: "26752",
          name: "Kumanovo",
          state_id: "2258",
        },
        {
          id: "26753",
          name: "Lipkovo",
          state_id: "2258",
        },
        {
          id: "26754",
          name: "Orashac",
          state_id: "2258",
        },
        {
          id: "26755",
          name: "Staro Nagorichane",
          state_id: "2258",
        },
      ],
      Negotino: [
        {
          id: "26756",
          name: "Demir Kapija",
          state_id: "2259",
        },
        {
          id: "26757",
          name: "Negotino",
          state_id: "2259",
        },
      ],
      Ohrid: [
        {
          id: "26758",
          name: "Belchishta",
          state_id: "2260",
        },
        {
          id: "26759",
          name: "Kosel",
          state_id: "2260",
        },
        {
          id: "26760",
          name: "Mesheishta",
          state_id: "2260",
        },
        {
          id: "26761",
          name: "Ohrid",
          state_id: "2260",
        },
      ],
      Prilep: [
        {
          id: "26762",
          name: "Dolneni",
          state_id: "2261",
        },
        {
          id: "26763",
          name: "Krivogashtani",
          state_id: "2261",
        },
        {
          id: "26764",
          name: "Prilep",
          state_id: "2261",
        },
        {
          id: "26765",
          name: "Topolchani",
          state_id: "2261",
        },
        {
          id: "26766",
          name: "Vitolishte",
          state_id: "2261",
        },
      ],
      Probishtip: [
        {
          id: "26767",
          name: "Probishtip",
          state_id: "2262",
        },
      ],
      Radovish: [
        {
          id: "26768",
          name: "Konche",
          state_id: "2263",
        },
        {
          id: "26769",
          name: "Podaresh",
          state_id: "2263",
        },
        {
          id: "26770",
          name: "Radovish",
          state_id: "2263",
        },
      ],
      Resen: [
        {
          id: "26771",
          name: "Resen",
          state_id: "2264",
        },
      ],
      Shtip: [
        {
          id: "26772",
          name: "Karbinci",
          state_id: "2265",
        },
        {
          id: "26773",
          name: "Shtip",
          state_id: "2265",
        },
        {
          id: "26774",
          name: "Stip",
          state_id: "2265",
        },
      ],
      Skopje: [
        {
          id: "26775",
          name: "Arachinovo",
          state_id: "2266",
        },
        {
          id: "26776",
          name: "Chucher",
          state_id: "2266",
        },
        {
          id: "26777",
          name: "Ilinden",
          state_id: "2266",
        },
        {
          id: "26778",
          name: "Kondovo",
          state_id: "2266",
        },
        {
          id: "26779",
          name: "Petrovec",
          state_id: "2266",
        },
        {
          id: "26780",
          name: "Saraj",
          state_id: "2266",
        },
        {
          id: "26781",
          name: "Skopje",
          state_id: "2266",
        },
        {
          id: "26782",
          name: "Sopishte",
          state_id: "2266",
        },
        {
          id: "26783",
          name: "Studenichani",
          state_id: "2266",
        },
        {
          id: "26784",
          name: "Zelenikovo",
          state_id: "2266",
        },
      ],
      Struga: [
        {
          id: "26785",
          name: "Delogozhdi",
          state_id: "2267",
        },
        {
          id: "26786",
          name: "Labunishta",
          state_id: "2267",
        },
        {
          id: "26787",
          name: "Lukovo",
          state_id: "2267",
        },
        {
          id: "26788",
          name: "Struga",
          state_id: "2267",
        },
        {
          id: "26789",
          name: "Veleshta",
          state_id: "2267",
        },
        {
          id: "26790",
          name: "Vevchani",
          state_id: "2267",
        },
      ],
      Strumica: [
        {
          id: "26791",
          name: "Bosilovo",
          state_id: "2268",
        },
        {
          id: "26792",
          name: "Kuklish",
          state_id: "2268",
        },
        {
          id: "26793",
          name: "Murtino",
          state_id: "2268",
        },
        {
          id: "26794",
          name: "Novo Selo",
          state_id: "2268",
        },
        {
          id: "26795",
          name: "Strumica",
          state_id: "2268",
        },
        {
          id: "26796",
          name: "Vasilevo",
          state_id: "2268",
        },
      ],
      "Sveti Nikole": [],
      Tetovo: [
        {
          id: "26797",
          name: "Bogovinje",
          state_id: "2270",
        },
        {
          id: "26798",
          name: "Brvenica",
          state_id: "2270",
        },
        {
          id: "26799",
          name: "Dzhepchishte",
          state_id: "2270",
        },
        {
          id: "26800",
          name: "Jegunovce",
          state_id: "2270",
        },
        {
          id: "26801",
          name: "Kamenjance",
          state_id: "2270",
        },
        {
          id: "26802",
          name: "Shipkovica",
          state_id: "2270",
        },
        {
          id: "26803",
          name: "Tearce",
          state_id: "2270",
        },
        {
          id: "26804",
          name: "Tetovo",
          state_id: "2270",
        },
        {
          id: "26805",
          name: "Vratnica",
          state_id: "2270",
        },
        {
          id: "26806",
          name: "Zhelino",
          state_id: "2270",
        },
      ],
      Valandovo: [
        {
          id: "26807",
          name: "Valandovo",
          state_id: "2271",
        },
      ],
      Veles: [
        {
          id: "26808",
          name: "Bogomila",
          state_id: "2272",
        },
        {
          id: "26809",
          name: "Chashka",
          state_id: "2272",
        },
        {
          id: "26810",
          name: "Gradsko",
          state_id: "2272",
        },
        {
          id: "26811",
          name: "Veles",
          state_id: "2272",
        },
      ],
      Vinica: [
        {
          id: "26812",
          name: "Blatec",
          state_id: "2273",
        },
        {
          id: "26813",
          name: "Orizari",
          state_id: "2273",
        },
        {
          id: "26814",
          name: "Vinica",
          state_id: "2273",
        },
        {
          id: "26815",
          name: "Zrnovci",
          state_id: "2273",
        },
      ],
    },
  },
  ML: {
    name: "Mali",
    native: "Mali",
    phone: "223",
    continent: "AF",
    capital: "Bamako",
    currency: "XOF",
    languages: ["fr"],
    emoji: "🇲🇱",
    emojiU: "U+1F1F2 U+1F1F1",
    states: {
      Bamako: [
        {
          id: "27222",
          name: "Bamako",
          state_id: "2346",
        },
      ],
      Gao: [
        {
          id: "27223",
          name: "Gao",
          state_id: "2347",
        },
      ],
      Kayes: [
        {
          id: "27224",
          name: "Bafoulabe",
          state_id: "2348",
        },
        {
          id: "27225",
          name: "Kayes",
          state_id: "2348",
        },
        {
          id: "27226",
          name: "Kita",
          state_id: "2348",
        },
        {
          id: "27227",
          name: "Nioro",
          state_id: "2348",
        },
      ],
      Kidal: [
        {
          id: "27228",
          name: "Kidal",
          state_id: "2349",
        },
        {
          id: "27229",
          name: "Tessalit",
          state_id: "2349",
        },
      ],
      Koulikoro: [
        {
          id: "27230",
          name: "Banamba",
          state_id: "2350",
        },
        {
          id: "27231",
          name: "Kangaba",
          state_id: "2350",
        },
        {
          id: "27232",
          name: "Kati",
          state_id: "2350",
        },
        {
          id: "27233",
          name: "Kolokani",
          state_id: "2350",
        },
        {
          id: "27234",
          name: "Koulikoro",
          state_id: "2350",
        },
        {
          id: "27235",
          name: "Nara",
          state_id: "2350",
        },
      ],
      Mopti: [
        {
          id: "27236",
          name: "Bandiagara",
          state_id: "2351",
        },
        {
          id: "27237",
          name: "Djenne",
          state_id: "2351",
        },
        {
          id: "27238",
          name: "Douentza",
          state_id: "2351",
        },
        {
          id: "27239",
          name: "Koro",
          state_id: "2351",
        },
        {
          id: "27240",
          name: "Mopti",
          state_id: "2351",
        },
        {
          id: "27241",
          name: "Tenenkou",
          state_id: "2351",
        },
      ],
      Segou: [
        {
          id: "27242",
          name: "Ke-Massina",
          state_id: "2352",
        },
        {
          id: "27243",
          name: "Kimparana",
          state_id: "2352",
        },
        {
          id: "27244",
          name: "Markala",
          state_id: "2352",
        },
        {
          id: "27245",
          name: "Niono",
          state_id: "2352",
        },
        {
          id: "27246",
          name: "San",
          state_id: "2352",
        },
        {
          id: "27247",
          name: "Segou",
          state_id: "2352",
        },
        {
          id: "27248",
          name: "Sokolo",
          state_id: "2352",
        },
      ],
      Sikasso: [
        {
          id: "27249",
          name: "Bougouni",
          state_id: "2353",
        },
        {
          id: "27250",
          name: "Kolondieba",
          state_id: "2353",
        },
        {
          id: "27251",
          name: "Koutiala",
          state_id: "2353",
        },
        {
          id: "27252",
          name: "Sikasso",
          state_id: "2353",
        },
        {
          id: "27253",
          name: "Yorosso",
          state_id: "2353",
        },
      ],
      Tombouctou: [
        {
          id: "27254",
          name: "Araouane",
          state_id: "2354",
        },
        {
          id: "27255",
          name: "Dire",
          state_id: "2354",
        },
        {
          id: "27256",
          name: "Goundam",
          state_id: "2354",
        },
        {
          id: "27257",
          name: "Niafunke",
          state_id: "2354",
        },
        {
          id: "27258",
          name: "Taoudenni",
          state_id: "2354",
        },
        {
          id: "27259",
          name: "Tombouctou",
          state_id: "2354",
        },
      ],
    },
  },
  MM: {
    name: "Myanmar [Burma]",
    native: "Myanma",
    phone: "95",
    continent: "AS",
    capital: "Naypyidaw",
    currency: "MMK",
    languages: ["my"],
    emoji: "🇲🇲",
    emojiU: "U+1F1F2 U+1F1F2",
    states: {
      Ayeyarwady: [
        {
          id: "29679",
          name: "Bogale",
          state_id: "2537",
        },
        {
          id: "29680",
          name: "Henzada",
          state_id: "2537",
        },
        {
          id: "29681",
          name: "Kyaiklat",
          state_id: "2537",
        },
        {
          id: "29682",
          name: "Labutta",
          state_id: "2537",
        },
        {
          id: "29683",
          name: "Maubin",
          state_id: "2537",
        },
        {
          id: "29684",
          name: "Moulmeingyun",
          state_id: "2537",
        },
        {
          id: "29685",
          name: "Myanaung",
          state_id: "2537",
        },
        {
          id: "29686",
          name: "Pathein",
          state_id: "2537",
        },
        {
          id: "29687",
          name: "Pyapon",
          state_id: "2537",
        },
        {
          id: "29688",
          name: "Wakema",
          state_id: "2537",
        },
        {
          id: "29689",
          name: "Yandoon",
          state_id: "2537",
        },
        {
          id: "29690",
          name: "Ye",
          state_id: "2537",
        },
      ],
      Bago: [
        {
          id: "29691",
          name: "Bago",
          state_id: "2538",
        },
        {
          id: "29692",
          name: "Letpadan",
          state_id: "2538",
        },
        {
          id: "29693",
          name: "Nyaunglebin",
          state_id: "2538",
        },
        {
          id: "29694",
          name: "Paungde",
          state_id: "2538",
        },
        {
          id: "29695",
          name: "Pyay",
          state_id: "2538",
        },
        {
          id: "29696",
          name: "Pyu",
          state_id: "2538",
        },
        {
          id: "29697",
          name: "Thanatpin",
          state_id: "2538",
        },
        {
          id: "29698",
          name: "Tharrawaddy",
          state_id: "2538",
        },
        {
          id: "29699",
          name: "Toungoo",
          state_id: "2538",
        },
      ],
      Chin: [
        {
          id: "29700",
          name: "Falam",
          state_id: "2539",
        },
      ],
      Kachin: [
        {
          id: "29701",
          name: "Banmo",
          state_id: "2540",
        },
        {
          id: "29702",
          name: "Myitkyina",
          state_id: "2540",
        },
      ],
      Kayah: [
        {
          id: "29703",
          name: "Loikaw",
          state_id: "2541",
        },
      ],
      Kayin: [
        {
          id: "29704",
          name: "Hpa-an",
          state_id: "2542",
        },
      ],
      Magway: [
        {
          id: "29705",
          name: "Allanmyo",
          state_id: "2543",
        },
        {
          id: "29706",
          name: "Chauk",
          state_id: "2543",
        },
        {
          id: "29707",
          name: "Magway",
          state_id: "2543",
        },
        {
          id: "29708",
          name: "Minbu",
          state_id: "2543",
        },
        {
          id: "29709",
          name: "Pakokku",
          state_id: "2543",
        },
        {
          id: "29710",
          name: "Taungdwingyi",
          state_id: "2543",
        },
        {
          id: "29711",
          name: "Thayetmyo",
          state_id: "2543",
        },
        {
          id: "29712",
          name: "Yenangyaung",
          state_id: "2543",
        },
      ],
      Mandalay: [
        {
          id: "29713",
          name: "Kyaukse",
          state_id: "2544",
        },
        {
          id: "29714",
          name: "Mandalay",
          state_id: "2544",
        },
        {
          id: "29715",
          name: "Maymyo",
          state_id: "2544",
        },
        {
          id: "29716",
          name: "Meiktila",
          state_id: "2544",
        },
        {
          id: "29717",
          name: "Mogok",
          state_id: "2544",
        },
        {
          id: "29718",
          name: "Myingyan",
          state_id: "2544",
        },
        {
          id: "29719",
          name: "Pyinmana",
          state_id: "2544",
        },
        {
          id: "29720",
          name: "Yamethin",
          state_id: "2544",
        },
      ],
      Mon: [
        {
          id: "29721",
          name: "Kyaikkami",
          state_id: "2545",
        },
        {
          id: "29722",
          name: "Kyaikto",
          state_id: "2545",
        },
        {
          id: "29723",
          name: "Martaban",
          state_id: "2545",
        },
        {
          id: "29724",
          name: "Mawlamyine",
          state_id: "2545",
        },
        {
          id: "29725",
          name: "Mudon",
          state_id: "2545",
        },
        {
          id: "29726",
          name: "Thaton",
          state_id: "2545",
        },
      ],
      "Nay Pyi Taw": [],
      Rakhine: [
        {
          id: "29727",
          name: "Akyab",
          state_id: "2547",
        },
        {
          id: "29728",
          name: "Arakan",
          state_id: "2547",
        },
      ],
      Sagaing: [
        {
          id: "29729",
          name: "Kalay",
          state_id: "2548",
        },
        {
          id: "29730",
          name: "Katha",
          state_id: "2548",
        },
        {
          id: "29731",
          name: "Mawlaik",
          state_id: "2548",
        },
        {
          id: "29732",
          name: "Monywa",
          state_id: "2548",
        },
        {
          id: "29733",
          name: "Sagaing",
          state_id: "2548",
        },
        {
          id: "29734",
          name: "Shwebo",
          state_id: "2548",
        },
      ],
      Shan: [
        {
          id: "29735",
          name: "Keng Tung",
          state_id: "2549",
        },
        {
          id: "29736",
          name: "Lashio",
          state_id: "2549",
        },
        {
          id: "29737",
          name: "Taunggyi",
          state_id: "2549",
        },
      ],
      Tanintharyi: [
        {
          id: "29738",
          name: "Dawei",
          state_id: "2550",
        },
        {
          id: "29739",
          name: "Mergui",
          state_id: "2550",
        },
      ],
      Yangon: [
        {
          id: "29740",
          name: "Kanbe",
          state_id: "2551",
        },
        {
          id: "29741",
          name: "Kayan",
          state_id: "2551",
        },
        {
          id: "29742",
          name: "Syriam",
          state_id: "2551",
        },
        {
          id: "29743",
          name: "Thongwa",
          state_id: "2551",
        },
        {
          id: "29744",
          name: "Twante",
          state_id: "2551",
        },
        {
          id: "29745",
          name: "Yangon",
          state_id: "2551",
        },
      ],
    },
  },
  MN: {
    name: "Mongolia",
    native: "Монгол улс",
    phone: "976",
    continent: "AS",
    capital: "Ulan Bator",
    currency: "MNT",
    languages: ["mn"],
    emoji: "🇲🇳",
    emojiU: "U+1F1F2 U+1F1F3",
    states: {
      Arhangaj: [
        {
          id: "29550",
          name: "Cecerleg",
          state_id: "2481",
        },
      ],
      "Bajan-Olgij": [
        {
          id: "29551",
          name: "Olgij",
          state_id: "2482",
        },
      ],
      Bajanhongor: [
        {
          id: "29552",
          name: "Bajanhongor",
          state_id: "2483",
        },
      ],
      Bulgan: [
        {
          id: "29553",
          name: "Bulgan",
          state_id: "2484",
        },
      ],
      "Darhan-Uul": [
        {
          id: "29554",
          name: "Darhan",
          state_id: "2485",
        },
      ],
      Dornod: [
        {
          id: "29555",
          name: "Chojbalsan",
          state_id: "2486",
        },
      ],
      Dornogovi: [
        {
          id: "29556",
          name: "Sajnshand",
          state_id: "2487",
        },
      ],
      Dundgovi: [
        {
          id: "29557",
          name: "Mandalgovi",
          state_id: "2488",
        },
      ],
      "Govi-Altaj": [
        {
          id: "29558",
          name: "Altaj",
          state_id: "2489",
        },
      ],
      Govisumber: [
        {
          id: "29559",
          name: "Chojr",
          state_id: "2490",
        },
      ],
      Hentij: [
        {
          id: "29560",
          name: "Ondorhaan",
          state_id: "2491",
        },
      ],
      Hovd: [
        {
          id: "29561",
          name: "Hovd",
          state_id: "2492",
        },
      ],
      Hovsgol: [
        {
          id: "29562",
          name: "Moron",
          state_id: "2493",
        },
      ],
      Omnogovi: [
        {
          id: "29563",
          name: "Dalanzadgad",
          state_id: "2494",
        },
      ],
      Orhon: [
        {
          id: "29564",
          name: "Erdenet",
          state_id: "2495",
        },
      ],
      Ovorhangaj: [
        {
          id: "29565",
          name: "Arvajheer",
          state_id: "2496",
        },
      ],
      Selenge: [
        {
          id: "29566",
          name: "Suhbaatar",
          state_id: "2497",
        },
        {
          id: "29567",
          name: "Zuunharaa",
          state_id: "2497",
        },
      ],
      Suhbaatar: [
        {
          id: "29568",
          name: "Baruun-Urt",
          state_id: "2498",
        },
      ],
      Tov: [
        {
          id: "29569",
          name: "Nalajh",
          state_id: "2499",
        },
        {
          id: "29570",
          name: "Zuunmod",
          state_id: "2499",
        },
      ],
      Ulaanbaatar: [
        {
          id: "29571",
          name: "Ulaanbaatar",
          state_id: "2500",
        },
      ],
      Uvs: [
        {
          id: "29572",
          name: "Ulaangom",
          state_id: "2501",
        },
      ],
      Zavhan: [
        {
          id: "29573",
          name: "Tosoncengel",
          state_id: "2502",
        },
        {
          id: "29574",
          name: "Uliastaj",
          state_id: "2502",
        },
      ],
    },
  },
  MO: {
    name: "Macao",
    native: "澳門",
    phone: "853",
    continent: "AS",
    capital: "",
    currency: "MOP",
    languages: ["zh", "pt"],
    emoji: "🇲🇴",
    emojiU: "U+1F1F2 U+1F1F4",
    states: {
      Macau: [
        {
          id: "26703",
          name: "Macau",
          state_id: "2243",
        },
      ],
    },
  },
  MP: {
    name: "Northern Mariana Islands",
    native: "Northern Mariana Islands",
    phone: "1670",
    continent: "OC",
    capital: "Saipan",
    currency: "USD",
    languages: ["en", "ch"],
    emoji: "🇲🇵",
    emojiU: "U+1F1F2 U+1F1F5",
    states: {
      "Northern Islands": [],
      Rota: [
        {
          id: "31153",
          name: "Songsong",
          state_id: "2687",
        },
      ],
      Saipan: [
        {
          id: "31154",
          name: "Capital Hill",
          state_id: "2688",
        },
        {
          id: "31155",
          name: "Chalan Kanoa",
          state_id: "2688",
        },
        {
          id: "31156",
          name: "Dandan",
          state_id: "2688",
        },
        {
          id: "31157",
          name: "Garapan",
          state_id: "2688",
        },
        {
          id: "31158",
          name: "Gualo Rai",
          state_id: "2688",
        },
        {
          id: "31159",
          name: "Kagman",
          state_id: "2688",
        },
        {
          id: "31160",
          name: "Koblerville",
          state_id: "2688",
        },
        {
          id: "31161",
          name: "San Antonio",
          state_id: "2688",
        },
        {
          id: "31162",
          name: "San Jose",
          state_id: "2688",
        },
        {
          id: "31163",
          name: "San Roque",
          state_id: "2688",
        },
        {
          id: "31164",
          name: "San Vicente",
          state_id: "2688",
        },
        {
          id: "31165",
          name: "Susupe",
          state_id: "2688",
        },
        {
          id: "31166",
          name: "Tanapag",
          state_id: "2688",
        },
      ],
      Tinian: [
        {
          id: "31167",
          name: "San Jose",
          state_id: "2689",
        },
      ],
    },
  },
  MQ: {
    name: "Martinique",
    native: "Martinique",
    phone: "596",
    continent: "NA",
    capital: "Fort-de-France",
    currency: "EUR",
    languages: ["fr"],
    emoji: "🇲🇶",
    emojiU: "U+1F1F2 U+1F1F6",
    states: {
      "Fort-de-France": [
        {
          id: "27442",
          name: "Fort-de-France",
          state_id: "2395",
        },
        {
          id: "27443",
          name: "Le Lamentin",
          state_id: "2395",
        },
        {
          id: "27444",
          name: "Saint-Joseph",
          state_id: "2395",
        },
        {
          id: "27445",
          name: "Schoelcher",
          state_id: "2395",
        },
      ],
      "La Trinite": [],
      "Le Marin": [],
      "Saint-Pierre": [
        {
          id: "27446",
          name: "Le Morne-Rouge",
          state_id: "2398",
        },
        {
          id: "27447",
          name: "Saint-Pierre",
          state_id: "2398",
        },
      ],
    },
  },
  MR: {
    name: "Mauritania",
    native: "موريتانيا",
    phone: "222",
    continent: "AF",
    capital: "Nouakchott",
    currency: "MRO",
    languages: ["ar"],
    emoji: "🇲🇷",
    emojiU: "U+1F1F2 U+1F1F7",
    states: {
      Adrar: [
        {
          id: "27448",
          name: "Atar",
          state_id: "2399",
        },
        {
          id: "27449",
          name: "Shingati",
          state_id: "2399",
        },
      ],
      Assaba: [
        {
          id: "27450",
          name: "Kifah",
          state_id: "2400",
        },
      ],
      Brakna: [
        {
          id: "27451",
          name: "Alaq",
          state_id: "2401",
        },
        {
          id: "27452",
          name: "Buqah",
          state_id: "2401",
        },
        {
          id: "27453",
          name: "Magta'' Lahjar",
          state_id: "2401",
        },
      ],
      "Dhakhlat Nawadibu": [],
      "Hudh-al-Gharbi": [
        {
          id: "27454",
          name: "Ayun-al-''Atrus",
          state_id: "2403",
        },
        {
          id: "27455",
          name: "Kubanni",
          state_id: "2403",
        },
      ],
      "Hudh-ash-Sharqi": [
        {
          id: "27456",
          name: "Timbedra",
          state_id: "2404",
        },
        {
          id: "27457",
          name: "Walatah",
          state_id: "2404",
        },
        {
          id: "27458",
          name: "an-Na''mah",
          state_id: "2404",
        },
      ],
      Inshiri: [
        {
          id: "27459",
          name: "Aqjawajat",
          state_id: "2405",
        },
      ],
      Nawakshut: [
        {
          id: "27460",
          name: "Nawakshut",
          state_id: "2406",
        },
      ],
      Qidimagha: [
        {
          id: "27461",
          name: "Hsay Walad ''Ali Babi",
          state_id: "2407",
        },
      ],
      Qurqul: [
        {
          id: "27462",
          name: "Kayhaydi",
          state_id: "2408",
        },
      ],
      Taqant: [
        {
          id: "27463",
          name: "Tijiqjah",
          state_id: "2409",
        },
      ],
      "Tiris Zammur": [],
      Trarza: [
        {
          id: "27464",
          name: "Rusu",
          state_id: "2411",
        },
      ],
    },
  },
  MS: {
    name: "Montserrat",
    native: "Montserrat",
    phone: "1664",
    continent: "NA",
    capital: "Plymouth",
    currency: "XCD",
    languages: ["en"],
    emoji: "🇲🇸",
    emojiU: "U+1F1F2 U+1F1F8",
    states: {
      Montserrat: [
        {
          id: "29575",
          name: "Montserrat",
          state_id: "2503",
        },
      ],
    },
  },
  MT: {
    name: "Malta",
    native: "Malta",
    phone: "356",
    continent: "EU",
    capital: "Valletta",
    currency: "EUR",
    languages: ["mt", "en"],
    emoji: "🇲🇹",
    emojiU: "U+1F1F2 U+1F1F9",
    states: {
      "Gozo and Comino": [],
      "Inner Harbour": [],
      Northern: [
        {
          id: "27260",
          name: "Gharghur",
          state_id: "2357",
        },
        {
          id: "27261",
          name: "Mellieha",
          state_id: "2357",
        },
        {
          id: "27262",
          name: "Mgarr",
          state_id: "2357",
        },
        {
          id: "27263",
          name: "Mosta",
          state_id: "2357",
        },
        {
          id: "27264",
          name: "Naxxar",
          state_id: "2357",
        },
        {
          id: "27265",
          name: "San Pawl il-Bahar",
          state_id: "2357",
        },
      ],
      "Outer Harbour": [],
      "South Eastern": [],
      Valletta: [
        {
          id: "27266",
          name: "L-Iklin",
          state_id: "2360",
        },
      ],
      Western: [
        {
          id: "27267",
          name: "Attard",
          state_id: "2361",
        },
        {
          id: "27268",
          name: "Balzan",
          state_id: "2361",
        },
        {
          id: "27269",
          name: "Dingli",
          state_id: "2361",
        },
        {
          id: "27270",
          name: "Iklin",
          state_id: "2361",
        },
        {
          id: "27271",
          name: "Lija",
          state_id: "2361",
        },
        {
          id: "27272",
          name: "Mdina",
          state_id: "2361",
        },
        {
          id: "27273",
          name: "Rabat",
          state_id: "2361",
        },
        {
          id: "27274",
          name: "Sighghiewi",
          state_id: "2361",
        },
        {
          id: "27275",
          name: "Zebbug",
          state_id: "2361",
        },
      ],
    },
  },
  MU: {
    name: "Mauritius",
    native: "Maurice",
    phone: "230",
    continent: "AF",
    capital: "Port Louis",
    currency: "MUR",
    languages: ["en"],
    emoji: "🇲🇺",
    emojiU: "U+1F1F2 U+1F1FA",
    states: {
      "Black River": [],
      "Eau Coulee": [],
      Flacq: [
        {
          id: "27465",
          name: "Bel Air",
          state_id: "2414",
        },
        {
          id: "27466",
          name: "Bon Accueil",
          state_id: "2414",
        },
        {
          id: "27467",
          name: "Brisee Verdiere",
          state_id: "2414",
        },
        {
          id: "27468",
          name: "Camp Ithier",
          state_id: "2414",
        },
        {
          id: "27469",
          name: "Camp de Masque",
          state_id: "2414",
        },
        {
          id: "27470",
          name: "Camp de Masque Pave",
          state_id: "2414",
        },
        {
          id: "27471",
          name: "Central Flacq",
          state_id: "2414",
        },
        {
          id: "27472",
          name: "Clemencia",
          state_id: "2414",
        },
        {
          id: "27473",
          name: "Ecroignard",
          state_id: "2414",
        },
        {
          id: "27474",
          name: "Grand River South East",
          state_id: "2414",
        },
        {
          id: "27475",
          name: "Lalmatie",
          state_id: "2414",
        },
        {
          id: "27476",
          name: "Laventure",
          state_id: "2414",
        },
        {
          id: "27477",
          name: "Mare La Chaux",
          state_id: "2414",
        },
        {
          id: "27478",
          name: "Medine-Camp de Masque",
          state_id: "2414",
        },
        {
          id: "27479",
          name: "Olivia",
          state_id: "2414",
        },
        {
          id: "27480",
          name: "Poste de Flacq",
          state_id: "2414",
        },
        {
          id: "27481",
          name: "Quatre Cocos",
          state_id: "2414",
        },
        {
          id: "27482",
          name: "Quatre Soeurs",
          state_id: "2414",
        },
        {
          id: "27483",
          name: "Queen Victoria",
          state_id: "2414",
        },
        {
          id: "27484",
          name: "Saint Julien",
          state_id: "2414",
        },
        {
          id: "27485",
          name: "Saint Julien d''Hotman",
          state_id: "2414",
        },
        {
          id: "27486",
          name: "Sebastopol",
          state_id: "2414",
        },
        {
          id: "27487",
          name: "Trou d''Eau Douce",
          state_id: "2414",
        },
      ],
      Floreal: [
        {
          id: "27488",
          name: "Floreal",
          state_id: "2415",
        },
      ],
      "Grand Port": [],
      Moka: [
        {
          id: "27489",
          name: "Camp Thorel",
          state_id: "2417",
        },
        {
          id: "27490",
          name: "Dagotiere",
          state_id: "2417",
        },
        {
          id: "27491",
          name: "Dubreuil",
          state_id: "2417",
        },
        {
          id: "27492",
          name: "Esperance",
          state_id: "2417",
        },
        {
          id: "27493",
          name: "L''Avenir",
          state_id: "2417",
        },
        {
          id: "27494",
          name: "La Laura-Malenga",
          state_id: "2417",
        },
        {
          id: "27495",
          name: "Melrose",
          state_id: "2417",
        },
        {
          id: "27496",
          name: "Moka",
          state_id: "2417",
        },
        {
          id: "27497",
          name: "Montagne Blanche",
          state_id: "2417",
        },
        {
          id: "27498",
          name: "Pailles",
          state_id: "2417",
        },
        {
          id: "27499",
          name: "Providence",
          state_id: "2417",
        },
        {
          id: "27500",
          name: "Quartier Militaire",
          state_id: "2417",
        },
        {
          id: "27501",
          name: "Ripailles",
          state_id: "2417",
        },
        {
          id: "27502",
          name: "Saint Pierre",
          state_id: "2417",
        },
        {
          id: "27503",
          name: "Verdun",
          state_id: "2417",
        },
      ],
      Pamplempousses: [
        {
          id: "27504",
          name: "Arsenal",
          state_id: "2418",
        },
        {
          id: "27505",
          name: "Baie du Tombeau",
          state_id: "2418",
        },
        {
          id: "27506",
          name: "Calebasses",
          state_id: "2418",
        },
        {
          id: "27507",
          name: "Congomah",
          state_id: "2418",
        },
        {
          id: "27508",
          name: "Creve Coeur",
          state_id: "2418",
        },
        {
          id: "27509",
          name: "D''Epinay",
          state_id: "2418",
        },
        {
          id: "27510",
          name: "Fond du Sac",
          state_id: "2418",
        },
        {
          id: "27511",
          name: "La Tour Koenig",
          state_id: "2418",
        },
        {
          id: "27512",
          name: "Le Hochet",
          state_id: "2418",
        },
        {
          id: "27513",
          name: "Long Mountain",
          state_id: "2418",
        },
        {
          id: "27514",
          name: "Morcellement Saint Andre",
          state_id: "2418",
        },
        {
          id: "27515",
          name: "Notre Dame",
          state_id: "2418",
        },
        {
          id: "27516",
          name: "Pamplemousse",
          state_id: "2418",
        },
        {
          id: "27517",
          name: "Plaines des Papayes",
          state_id: "2418",
        },
        {
          id: "27518",
          name: "Pointe aux Piments",
          state_id: "2418",
        },
        {
          id: "27519",
          name: "Terre Rouge",
          state_id: "2418",
        },
        {
          id: "27520",
          name: "Triolet",
          state_id: "2418",
        },
        {
          id: "27521",
          name: "Villebague",
          state_id: "2418",
        },
      ],
      "Plaines Wilhelm": [],
      "Port Louis": [],
      "Riviere du Rempart": [],
      Rodrigues: [
        {
          id: "27522",
          name: "Baie Malgache",
          state_id: "2422",
        },
        {
          id: "27523",
          name: "Coromandel-Graviers",
          state_id: "2422",
        },
        {
          id: "27524",
          name: "Grand Baie-Montagne Goyaves",
          state_id: "2422",
        },
        {
          id: "27525",
          name: "La Ferme",
          state_id: "2422",
        },
        {
          id: "27526",
          name: "Lataniers-Mont Lubin",
          state_id: "2422",
        },
        {
          id: "27527",
          name: "Mangues-Quatre Vents",
          state_id: "2422",
        },
        {
          id: "27528",
          name: "Oyster Bay",
          state_id: "2422",
        },
        {
          id: "27529",
          name: "Petit Gabriel",
          state_id: "2422",
        },
        {
          id: "27530",
          name: "Piments-Baie Topaze",
          state_id: "2422",
        },
        {
          id: "27531",
          name: "Plaine Corail-La Fouche Corail",
          state_id: "2422",
        },
        {
          id: "27532",
          name: "Port Mathurin",
          state_id: "2422",
        },
        {
          id: "27533",
          name: "Port Sud-Est",
          state_id: "2422",
        },
        {
          id: "27534",
          name: "Riviere Cocos",
          state_id: "2422",
        },
        {
          id: "27535",
          name: "Roche Bon Dieu-Trefles",
          state_id: "2422",
        },
      ],
      "Rose Hill": [],
      Savanne: [
        {
          id: "27536",
          name: "Baie du Cap",
          state_id: "2424",
        },
        {
          id: "27537",
          name: "Bel Ombre",
          state_id: "2424",
        },
        {
          id: "27538",
          name: "Benares",
          state_id: "2424",
        },
        {
          id: "27539",
          name: "Bois Cheri",
          state_id: "2424",
        },
        {
          id: "27540",
          name: "Britannia",
          state_id: "2424",
        },
        {
          id: "27541",
          name: "Camp Diable",
          state_id: "2424",
        },
        {
          id: "27542",
          name: "Chamouny",
          state_id: "2424",
        },
        {
          id: "27543",
          name: "Chemin Grenier",
          state_id: "2424",
        },
        {
          id: "27544",
          name: "Grand Bois",
          state_id: "2424",
        },
        {
          id: "27545",
          name: "Riviere des Anguilles",
          state_id: "2424",
        },
        {
          id: "27546",
          name: "Saint Aubin",
          state_id: "2424",
        },
        {
          id: "27547",
          name: "Souillac",
          state_id: "2424",
        },
        {
          id: "27548",
          name: "Surinam",
          state_id: "2424",
        },
      ],
    },
  },
  MV: {
    name: "Maldives",
    native: "Maldives",
    phone: "960",
    continent: "AS",
    capital: "Malé",
    currency: "MVR",
    languages: ["dv"],
    emoji: "🇲🇻",
    emojiU: "U+1F1F2 U+1F1FB",
    states: {
      "Alif Alif": [],
      "Alif Dhaal": [],
      Baa: [
        {
          id: "27093",
          name: "Dharavandhoo",
          state_id: "2327",
        },
        {
          id: "27094",
          name: "Dhonfanu",
          state_id: "2327",
        },
        {
          id: "27095",
          name: "Eydhafushi",
          state_id: "2327",
        },
        {
          id: "27096",
          name: "Fehendhoo",
          state_id: "2327",
        },
        {
          id: "27097",
          name: "Fulhadhoo",
          state_id: "2327",
        },
        {
          id: "27098",
          name: "Goidhoo",
          state_id: "2327",
        },
        {
          id: "27099",
          name: "Hithaadhoo",
          state_id: "2327",
        },
        {
          id: "27100",
          name: "Kamadhoo",
          state_id: "2327",
        },
        {
          id: "27101",
          name: "Kendhoo",
          state_id: "2327",
        },
        {
          id: "27102",
          name: "Kihaadhoo",
          state_id: "2327",
        },
        {
          id: "27103",
          name: "Kudarikilu",
          state_id: "2327",
        },
        {
          id: "27104",
          name: "Maalhos",
          state_id: "2327",
        },
        {
          id: "27105",
          name: "Thulhaadhoo",
          state_id: "2327",
        },
      ],
      Dhaal: [
        {
          id: "27106",
          name: "Badidhoo",
          state_id: "2328",
        },
        {
          id: "27107",
          name: "Gemendhoo",
          state_id: "2328",
        },
        {
          id: "27108",
          name: "Hulhudheli",
          state_id: "2328",
        },
        {
          id: "27109",
          name: "Kudahuvadhoo",
          state_id: "2328",
        },
        {
          id: "27110",
          name: "Maaeboodhoo",
          state_id: "2328",
        },
        {
          id: "27111",
          name: "Meedhoo",
          state_id: "2328",
        },
        {
          id: "27112",
          name: "Ribudhoo",
          state_id: "2328",
        },
        {
          id: "27113",
          name: "Vaanee",
          state_id: "2328",
        },
      ],
      Faaf: [
        {
          id: "27114",
          name: "Biledhdhoo",
          state_id: "2329",
        },
        {
          id: "27115",
          name: "Dharaboodhoo",
          state_id: "2329",
        },
        {
          id: "27116",
          name: "Feeali",
          state_id: "2329",
        },
        {
          id: "27117",
          name: "Magoodhoo",
          state_id: "2329",
        },
        {
          id: "27118",
          name: "Nilandhoo",
          state_id: "2329",
        },
      ],
      "Gaaf Alif": [],
      "Gaaf Dhaal": [],
      Ghaviyani: [
        {
          id: "27119",
          name: "Fuvammulah",
          state_id: "2332",
        },
      ],
      "Haa Alif": [],
      "Haa Dhaalu": [],
      Kaaf: [
        {
          id: "27120",
          name: "Dhiffushi",
          state_id: "2335",
        },
        {
          id: "27121",
          name: "Gaafaru",
          state_id: "2335",
        },
        {
          id: "27122",
          name: "Gulhi",
          state_id: "2335",
        },
        {
          id: "27123",
          name: "Guraidhoo",
          state_id: "2335",
        },
        {
          id: "27124",
          name: "Himmafushi",
          state_id: "2335",
        },
        {
          id: "27125",
          name: "Huraa",
          state_id: "2335",
        },
        {
          id: "27126",
          name: "Kaashidhoo",
          state_id: "2335",
        },
        {
          id: "27127",
          name: "Maafushi",
          state_id: "2335",
        },
        {
          id: "27128",
          name: "Thulusdhoo",
          state_id: "2335",
        },
      ],
      Laam: [
        {
          id: "27129",
          name: "Dhabidhoo",
          state_id: "2336",
        },
        {
          id: "27130",
          name: "Fonadhoo",
          state_id: "2336",
        },
        {
          id: "27131",
          name: "Gaadhoo",
          state_id: "2336",
        },
        {
          id: "27132",
          name: "Gamu",
          state_id: "2336",
        },
        {
          id: "27133",
          name: "Hithadhoo",
          state_id: "2336",
        },
        {
          id: "27134",
          name: "Isdhoo",
          state_id: "2336",
        },
        {
          id: "27135",
          name: "Kalhaidhoo",
          state_id: "2336",
        },
        {
          id: "27136",
          name: "Kunahandhoo",
          state_id: "2336",
        },
        {
          id: "27137",
          name: "Maabaidhoo",
          state_id: "2336",
        },
        {
          id: "27138",
          name: "Maamendhoo",
          state_id: "2336",
        },
        {
          id: "27139",
          name: "Maavah",
          state_id: "2336",
        },
        {
          id: "27140",
          name: "Mundhoo",
          state_id: "2336",
        },
      ],
      Lhaviyani: [
        {
          id: "27141",
          name: "Hinnavaru",
          state_id: "2337",
        },
        {
          id: "27142",
          name: "Kurendhoo",
          state_id: "2337",
        },
        {
          id: "27143",
          name: "Maafilaafushi",
          state_id: "2337",
        },
        {
          id: "27144",
          name: "Naifaru",
          state_id: "2337",
        },
        {
          id: "27145",
          name: "Olhuvelifushi",
          state_id: "2337",
        },
      ],
      Male: [],
      Miim: [
        {
          id: "27146",
          name: "Dhiggaru",
          state_id: "2339",
        },
        {
          id: "27147",
          name: "Kolhufushi",
          state_id: "2339",
        },
        {
          id: "27148",
          name: "Madifushi",
          state_id: "2339",
        },
        {
          id: "27149",
          name: "Maduvvari",
          state_id: "2339",
        },
        {
          id: "27150",
          name: "Mulah",
          state_id: "2339",
        },
        {
          id: "27151",
          name: "Muli",
          state_id: "2339",
        },
        {
          id: "27152",
          name: "Naalaafushi",
          state_id: "2339",
        },
        {
          id: "27153",
          name: "Raimandhoo",
          state_id: "2339",
        },
        {
          id: "27154",
          name: "Veyvah",
          state_id: "2339",
        },
      ],
      Nuun: [
        {
          id: "27155",
          name: "Fodhdhoo",
          state_id: "2340",
        },
        {
          id: "27156",
          name: "Hebadhoo",
          state_id: "2340",
        },
        {
          id: "27157",
          name: "Holhudhoo",
          state_id: "2340",
        },
        {
          id: "27158",
          name: "Kedhikolhudhoo",
          state_id: "2340",
        },
        {
          id: "27159",
          name: "Kudafari",
          state_id: "2340",
        },
        {
          id: "27160",
          name: "Landhoo",
          state_id: "2340",
        },
        {
          id: "27161",
          name: "Lhohi",
          state_id: "2340",
        },
        {
          id: "27162",
          name: "Maafaru",
          state_id: "2340",
        },
        {
          id: "27163",
          name: "Maalhendhoo",
          state_id: "2340",
        },
        {
          id: "27164",
          name: "Magoodhoo",
          state_id: "2340",
        },
        {
          id: "27165",
          name: "Manadhoo",
          state_id: "2340",
        },
        {
          id: "27166",
          name: "Miladhoo",
          state_id: "2340",
        },
        {
          id: "27167",
          name: "Velidhoo",
          state_id: "2340",
        },
      ],
      Raa: [
        {
          id: "27168",
          name: "Agolhitheemu",
          state_id: "2341",
        },
        {
          id: "27169",
          name: "Alifushi",
          state_id: "2341",
        },
        {
          id: "27170",
          name: "Fainu",
          state_id: "2341",
        },
        {
          id: "27171",
          name: "Hulhudhuffaaru",
          state_id: "2341",
        },
        {
          id: "27172",
          name: "Iguraidhoo",
          state_id: "2341",
        },
        {
          id: "27173",
          name: "Innamaadhoo",
          state_id: "2341",
        },
        {
          id: "27174",
          name: "Kadholhudhoo",
          state_id: "2341",
        },
        {
          id: "27175",
          name: "Kinolhas",
          state_id: "2341",
        },
        {
          id: "27176",
          name: "Maakurathu",
          state_id: "2341",
        },
        {
          id: "27177",
          name: "Maduvvari",
          state_id: "2341",
        },
        {
          id: "27178",
          name: "Meedhoo",
          state_id: "2341",
        },
        {
          id: "27179",
          name: "Rasgetheemu",
          state_id: "2341",
        },
        {
          id: "27180",
          name: "Rasmaadhoo",
          state_id: "2341",
        },
        {
          id: "27181",
          name: "Ugoofaaru",
          state_id: "2341",
        },
        {
          id: "27182",
          name: "Vaadhoo",
          state_id: "2341",
        },
      ],
      Shaviyani: [
        {
          id: "27183",
          name: "Bilehffahi",
          state_id: "2342",
        },
        {
          id: "27184",
          name: "Feevah",
          state_id: "2342",
        },
        {
          id: "27185",
          name: "Feydhoo",
          state_id: "2342",
        },
        {
          id: "27186",
          name: "Firubaidhoo",
          state_id: "2342",
        },
        {
          id: "27187",
          name: "Foakaidhoo",
          state_id: "2342",
        },
        {
          id: "27188",
          name: "Funadhoo",
          state_id: "2342",
        },
        {
          id: "27189",
          name: "Goidhoo",
          state_id: "2342",
        },
        {
          id: "27190",
          name: "Kaditheemu",
          state_id: "2342",
        },
        {
          id: "27191",
          name: "Komandoo",
          state_id: "2342",
        },
        {
          id: "27192",
          name: "Lhaimagu",
          state_id: "2342",
        },
        {
          id: "27193",
          name: "Maakandoodhoo",
          state_id: "2342",
        },
        {
          id: "27194",
          name: "Maaugoodhoo",
          state_id: "2342",
        },
        {
          id: "27195",
          name: "Maroshi",
          state_id: "2342",
        },
        {
          id: "27196",
          name: "Narudhoo",
          state_id: "2342",
        },
        {
          id: "27197",
          name: "Noomaraa",
          state_id: "2342",
        },
      ],
      Siin: [
        {
          id: "27198",
          name: "Feydhoo",
          state_id: "2343",
        },
        {
          id: "27199",
          name: "Hithadhoo",
          state_id: "2343",
        },
        {
          id: "27200",
          name: "Hulhudhoo",
          state_id: "2343",
        },
        {
          id: "27201",
          name: "Maradhoo",
          state_id: "2343",
        },
        {
          id: "27202",
          name: "Maradhoo-Feydhoo",
          state_id: "2343",
        },
        {
          id: "27203",
          name: "Meedhoo",
          state_id: "2343",
        },
      ],
      Thaa: [
        {
          id: "27204",
          name: "Buruni",
          state_id: "2344",
        },
        {
          id: "27205",
          name: "Dhiyamigili",
          state_id: "2344",
        },
        {
          id: "27206",
          name: "Gaadhiffushi",
          state_id: "2344",
        },
        {
          id: "27207",
          name: "Guraidhoo",
          state_id: "2344",
        },
        {
          id: "27208",
          name: "Hirilandhoo",
          state_id: "2344",
        },
        {
          id: "27209",
          name: "Kadoodhoo",
          state_id: "2344",
        },
        {
          id: "27210",
          name: "Kibidhoo",
          state_id: "2344",
        },
        {
          id: "27211",
          name: "Madifushi",
          state_id: "2344",
        },
        {
          id: "27212",
          name: "Omadhoo",
          state_id: "2344",
        },
        {
          id: "27213",
          name: "Thimarafushi",
          state_id: "2344",
        },
        {
          id: "27214",
          name: "Vandhoo",
          state_id: "2344",
        },
        {
          id: "27215",
          name: "Veymandhoo",
          state_id: "2344",
        },
        {
          id: "27216",
          name: "Vilufushi",
          state_id: "2344",
        },
      ],
      Vaav: [
        {
          id: "27217",
          name: "Felidhoo",
          state_id: "2345",
        },
        {
          id: "27218",
          name: "Fulidhoo",
          state_id: "2345",
        },
        {
          id: "27219",
          name: "Keyodhoo",
          state_id: "2345",
        },
        {
          id: "27220",
          name: "Rakeedhoo",
          state_id: "2345",
        },
        {
          id: "27221",
          name: "Thinadhoo",
          state_id: "2345",
        },
      ],
      "Upper North Province": [
        {
          id: "48426",
          name: "Kulhudhuffushi",
          state_id: "4121",
        },
        {
          id: "48427",
          name: "Haa Alif",
          state_id: "4121",
        },
        {
          id: "48428",
          name: "Haa Dhaalu",
          state_id: "4121",
        },
        {
          id: "48429",
          name: "Shaviyani",
          state_id: "4121",
        },
        {
          id: "48430",
          name: "Kulhudhuffushi",
          state_id: "4121",
        },
      ],
      "North Province": [
        {
          id: "48431",
          name: "Felivaru",
          state_id: "4122",
        },
        {
          id: "48432",
          name: "Baa",
          state_id: "4122",
        },
        {
          id: "48433",
          name: "Lhaviyani",
          state_id: "4122",
        },
        {
          id: "48434",
          name: "Noonu",
          state_id: "4122",
        },
        {
          id: "48435",
          name: "Raa",
          state_id: "4122",
        },
      ],
      "North Central Province": [
        {
          id: "48436",
          name: "Alif Alif",
          state_id: "4123",
        },
        {
          id: "48437",
          name: "Alif Dhaal",
          state_id: "4123",
        },
        {
          id: "48438",
          name: "Kaafu",
          state_id: "4123",
        },
        {
          id: "48439",
          name: "Vaavu",
          state_id: "4123",
        },
        {
          id: "48440",
          name: "Male",
          state_id: "4123",
        },
        {
          id: "48441",
          name: "Thulusdhoo",
          state_id: "4123",
        },
      ],
      "Central Province": [
        {
          id: "48442",
          name: "Dhaalu",
          state_id: "4124",
        },
        {
          id: "48442",
          name: "Faafu",
          state_id: "4124",
        },
        {
          id: "48443",
          name: "Meemu",
          state_id: "4124",
        },
        {
          id: "48444",
          name: "Kudahuvadhoo",
          state_id: "4124",
        },
      ],
      "South Central Province": [
        {
          id: "48445",
          name: "Thaa",
          state_id: "4125",
        },
        {
          id: "48446",
          name: "Laamu",
          state_id: "4125",
        },
        {
          id: "48447",
          name: "Gan",
          state_id: "4125",
        },
      ],
      "Upper South Province": [
        {
          id: "48448",
          name: "Gaafu Alif",
          state_id: "4126",
        },
        {
          id: "48449",
          name: "Gaafu Dhaalu",
          state_id: "4126",
        },
        {
          id: "48450",
          name: "Thinadhoo",
          state_id: "4126",
        },
      ],
      "South Province": [
        {
          id: "48451",
          name: "Gnaviyani",
          state_id: "4127",
        },
        {
          id: "48452",
          name: "Addu City",
          state_id: "4127",
        },
        {
          id: "48453",
          name: "Hithadhoo",
          state_id: "4127",
        },
      ],
    },
  },
  MW: {
    name: "Malawi",
    native: "Malawi",
    phone: "265",
    continent: "AF",
    capital: "Lilongwe",
    currency: "MWK",
    languages: ["en", "ny"],
    emoji: "🇲🇼",
    emojiU: "U+1F1F2 U+1F1FC",
    states: {
      Balaka: [
        {
          id: "26888",
          name: "Balaka",
          state_id: "2280",
        },
      ],
      "Blantyre City": [],
      Chikwawa: [
        {
          id: "26889",
          name: "Chikwawa",
          state_id: "2282",
        },
      ],
      Chiradzulu: [
        {
          id: "26890",
          name: "Chiradzulu",
          state_id: "2283",
        },
      ],
      Chitipa: [
        {
          id: "26891",
          name: "Chitipa",
          state_id: "2284",
        },
      ],
      Dedza: [
        {
          id: "26892",
          name: "Chipoka",
          state_id: "2285",
        },
        {
          id: "26893",
          name: "Dedza",
          state_id: "2285",
        },
      ],
      Dowa: [
        {
          id: "26894",
          name: "Dowa",
          state_id: "2286",
        },
        {
          id: "26895",
          name: "Mponela",
          state_id: "2286",
        },
      ],
      Karonga: [
        {
          id: "26896",
          name: "Chilumba",
          state_id: "2287",
        },
        {
          id: "26897",
          name: "Karonga",
          state_id: "2287",
        },
        {
          id: "26898",
          name: "Livingstonia",
          state_id: "2287",
        },
      ],
      Kasungu: [
        {
          id: "26899",
          name: "Kasungu",
          state_id: "2288",
        },
      ],
      "Lilongwe City": [],
      Machinga: [
        {
          id: "26900",
          name: "Liwonde",
          state_id: "2290",
        },
        {
          id: "26901",
          name: "Machinga",
          state_id: "2290",
        },
      ],
      Mangochi: [
        {
          id: "26902",
          name: "Mangochi",
          state_id: "2291",
        },
        {
          id: "26903",
          name: "Monkey Bay",
          state_id: "2291",
        },
      ],
      Mchinji: [
        {
          id: "26904",
          name: "Mchinji",
          state_id: "2292",
        },
      ],
      Mulanje: [
        {
          id: "26905",
          name: "Mulanje",
          state_id: "2293",
        },
      ],
      Mwanza: [
        {
          id: "26906",
          name: "Mwanza",
          state_id: "2294",
        },
      ],
      Mzimba: [
        {
          id: "26907",
          name: "Mzimba",
          state_id: "2295",
        },
      ],
      "Mzuzu City": [],
      "Nkhata Bay": [],
      Nkhotakota: [
        {
          id: "26908",
          name: "Nkhotakota",
          state_id: "2298",
        },
      ],
      Nsanje: [
        {
          id: "26909",
          name: "Nsanje",
          state_id: "2299",
        },
      ],
      Ntcheu: [
        {
          id: "26910",
          name: "Ntcheu",
          state_id: "2300",
        },
      ],
      Ntchisi: [
        {
          id: "26911",
          name: "Ntchisi",
          state_id: "2301",
        },
      ],
      Phalombe: [
        {
          id: "26912",
          name: "Phalombe",
          state_id: "2302",
        },
      ],
      Rumphi: [
        {
          id: "26913",
          name: "Rumphi",
          state_id: "2303",
        },
      ],
      Salima: [
        {
          id: "26914",
          name: "Salima",
          state_id: "2304",
        },
      ],
      Thyolo: [
        {
          id: "26915",
          name: "Luchenza",
          state_id: "2305",
        },
        {
          id: "26916",
          name: "Thyolo",
          state_id: "2305",
        },
      ],
      "Zomba Municipality": [],
    },
  },
  MX: {
    name: "Mexico",
    native: "México",
    phone: "52",
    continent: "NA",
    capital: "Mexico City",
    currency: "MXN",
    languages: ["es"],
    emoji: "🇲🇽",
    emojiU: "U+1F1F2 U+1F1FD",
    states: {
      Aguascalientes: [
        {
          id: "27566",
          name: "Aguascalientes",
          state_id: "2427",
        },
        {
          id: "27567",
          name: "Asientos",
          state_id: "2427",
        },
        {
          id: "27568",
          name: "Calvillo",
          state_id: "2427",
        },
        {
          id: "27569",
          name: "Cosio",
          state_id: "2427",
        },
        {
          id: "27570",
          name: "Margaritas",
          state_id: "2427",
        },
        {
          id: "27571",
          name: "Ojocaliente",
          state_id: "2427",
        },
        {
          id: "27572",
          name: "Pabellon de Arteaga",
          state_id: "2427",
        },
        {
          id: "27573",
          name: "Pabellon de Hidalgo",
          state_id: "2427",
        },
        {
          id: "27574",
          name: "Palo Alto",
          state_id: "2427",
        },
        {
          id: "27575",
          name: "Rincon de Romos",
          state_id: "2427",
        },
        {
          id: "27576",
          name: "San Francisco de los Romo",
          state_id: "2427",
        },
        {
          id: "27577",
          name: "San Jose de Gracia",
          state_id: "2427",
        },
        {
          id: "27578",
          name: "Tepezala",
          state_id: "2427",
        },
        {
          id: "27579",
          name: "Villa Juarez",
          state_id: "2427",
        },
      ],
      "Baja California": [],
      "Baja California Sur": [],
      Campeche: [
        {
          id: "27580",
          name: "Becal",
          state_id: "2430",
        },
        {
          id: "27581",
          name: "Bolonchen",
          state_id: "2430",
        },
        {
          id: "27582",
          name: "Calkini",
          state_id: "2430",
        },
        {
          id: "27583",
          name: "Campeche",
          state_id: "2430",
        },
        {
          id: "27584",
          name: "Candelaria",
          state_id: "2430",
        },
        {
          id: "27585",
          name: "Carmen",
          state_id: "2430",
        },
        {
          id: "27586",
          name: "Champoton",
          state_id: "2430",
        },
        {
          id: "27587",
          name: "China",
          state_id: "2430",
        },
        {
          id: "27588",
          name: "Dzitbalche",
          state_id: "2430",
        },
        {
          id: "27589",
          name: "Escarcega",
          state_id: "2430",
        },
        {
          id: "27590",
          name: "Hecelchakan",
          state_id: "2430",
        },
        {
          id: "27591",
          name: "Hopelchen",
          state_id: "2430",
        },
        {
          id: "27592",
          name: "Isla Aguada",
          state_id: "2430",
        },
        {
          id: "27593",
          name: "Nuevo Progreso",
          state_id: "2430",
        },
        {
          id: "27594",
          name: "Nunkini",
          state_id: "2430",
        },
        {
          id: "27595",
          name: "Palizada",
          state_id: "2430",
        },
        {
          id: "27596",
          name: "Pomuch",
          state_id: "2430",
        },
        {
          id: "27597",
          name: "Sabancuy",
          state_id: "2430",
        },
        {
          id: "27598",
          name: "Seybaplaya",
          state_id: "2430",
        },
        {
          id: "27599",
          name: "Tenabo",
          state_id: "2430",
        },
      ],
      Chiapas: [
        {
          id: "27600",
          name: "Acacoyagua",
          state_id: "2431",
        },
        {
          id: "27601",
          name: "Acala",
          state_id: "2431",
        },
        {
          id: "27602",
          name: "Acapetahua",
          state_id: "2431",
        },
        {
          id: "27603",
          name: "Altamirano",
          state_id: "2431",
        },
        {
          id: "27604",
          name: "Alvaro Obregon",
          state_id: "2431",
        },
        {
          id: "27605",
          name: "Amatan",
          state_id: "2431",
        },
        {
          id: "27606",
          name: "Amatenango del Valle",
          state_id: "2431",
        },
        {
          id: "27607",
          name: "Arriaga",
          state_id: "2431",
        },
        {
          id: "27608",
          name: "Benemerito de las Americas",
          state_id: "2431",
        },
        {
          id: "27609",
          name: "Berriozabal",
          state_id: "2431",
        },
        {
          id: "27610",
          name: "Bochil",
          state_id: "2431",
        },
        {
          id: "27611",
          name: "Cacahoatan",
          state_id: "2431",
        },
        {
          id: "27612",
          name: "Cancuc",
          state_id: "2431",
        },
        {
          id: "27613",
          name: "Catazaja",
          state_id: "2431",
        },
        {
          id: "27614",
          name: "Chalchihiutan",
          state_id: "2431",
        },
        {
          id: "27615",
          name: "Chanal",
          state_id: "2431",
        },
        {
          id: "27616",
          name: "Chiapa",
          state_id: "2431",
        },
        {
          id: "27617",
          name: "Chiapilla",
          state_id: "2431",
        },
        {
          id: "27618",
          name: "Chicomuselo",
          state_id: "2431",
        },
        {
          id: "27619",
          name: "Chilon",
          state_id: "2431",
        },
        {
          id: "27620",
          name: "Cintalapa",
          state_id: "2431",
        },
        {
          id: "27621",
          name: "Comaltitlan",
          state_id: "2431",
        },
        {
          id: "27622",
          name: "Comitan",
          state_id: "2431",
        },
        {
          id: "27623",
          name: "Copainala",
          state_id: "2431",
        },
        {
          id: "27624",
          name: "Copoya",
          state_id: "2431",
        },
        {
          id: "27625",
          name: "Cristobal Obregon",
          state_id: "2431",
        },
        {
          id: "27626",
          name: "El Bosque",
          state_id: "2431",
        },
        {
          id: "27627",
          name: "El Parral",
          state_id: "2431",
        },
        {
          id: "27628",
          name: "Escuintla",
          state_id: "2431",
        },
        {
          id: "27629",
          name: "Frontera Comalapa",
          state_id: "2431",
        },
        {
          id: "27630",
          name: "Frontera Corozal",
          state_id: "2431",
        },
        {
          id: "27631",
          name: "Frontera Hidalgo",
          state_id: "2431",
        },
        {
          id: "27632",
          name: "Huehuetan",
          state_id: "2431",
        },
        {
          id: "27633",
          name: "Huehuetan Estacion",
          state_id: "2431",
        },
        {
          id: "27634",
          name: "Huixtla",
          state_id: "2431",
        },
        {
          id: "27635",
          name: "Ixhuatan",
          state_id: "2431",
        },
        {
          id: "27636",
          name: "Ixtacomitan",
          state_id: "2431",
        },
        {
          id: "27637",
          name: "Ixtapa",
          state_id: "2431",
        },
        {
          id: "27638",
          name: "Jaltenango",
          state_id: "2431",
        },
        {
          id: "27639",
          name: "Jesus Maria Garza",
          state_id: "2431",
        },
        {
          id: "27640",
          name: "Jiquipilas",
          state_id: "2431",
        },
        {
          id: "27641",
          name: "Jitotol",
          state_id: "2431",
        },
        {
          id: "27642",
          name: "Juarez",
          state_id: "2431",
        },
        {
          id: "27643",
          name: "La Concordia",
          state_id: "2431",
        },
        {
          id: "27644",
          name: "La Libertad",
          state_id: "2431",
        },
        {
          id: "27645",
          name: "La Trinitaria",
          state_id: "2431",
        },
        {
          id: "27646",
          name: "Las Margaritas",
          state_id: "2431",
        },
        {
          id: "27647",
          name: "Las Rosas",
          state_id: "2431",
        },
        {
          id: "27648",
          name: "Mapastepec",
          state_id: "2431",
        },
        {
          id: "27649",
          name: "Mazatan",
          state_id: "2431",
        },
        {
          id: "27650",
          name: "Motozintla",
          state_id: "2431",
        },
        {
          id: "27651",
          name: "Navenchauc",
          state_id: "2431",
        },
        {
          id: "27652",
          name: "Nicolas Ruiz",
          state_id: "2431",
        },
        {
          id: "27653",
          name: "Ocosingo",
          state_id: "2431",
        },
        {
          id: "27654",
          name: "Ocotepec",
          state_id: "2431",
        },
        {
          id: "27655",
          name: "Ocozocoautla",
          state_id: "2431",
        },
        {
          id: "27656",
          name: "Ostuacan",
          state_id: "2431",
        },
        {
          id: "27657",
          name: "Oxchuc",
          state_id: "2431",
        },
        {
          id: "27658",
          name: "Palenque",
          state_id: "2431",
        },
        {
          id: "27659",
          name: "Palestina",
          state_id: "2431",
        },
        {
          id: "27660",
          name: "Pantelho",
          state_id: "2431",
        },
        {
          id: "27661",
          name: "Paredon",
          state_id: "2431",
        },
        {
          id: "27662",
          name: "Petalcingo",
          state_id: "2431",
        },
        {
          id: "27663",
          name: "Pichucalco",
          state_id: "2431",
        },
        {
          id: "27664",
          name: "Pijijiapan",
          state_id: "2431",
        },
        {
          id: "27665",
          name: "Pueblo Nuevo Solistahuacan",
          state_id: "2431",
        },
        {
          id: "27666",
          name: "Puerto Madero",
          state_id: "2431",
        },
        {
          id: "27667",
          name: "Pujiltic",
          state_id: "2431",
        },
        {
          id: "27668",
          name: "Raudales Malpaso",
          state_id: "2431",
        },
        {
          id: "27669",
          name: "Rayon",
          state_id: "2431",
        },
        {
          id: "27670",
          name: "Reforma",
          state_id: "2431",
        },
        {
          id: "27671",
          name: "Revolucion Mexicana",
          state_id: "2431",
        },
        {
          id: "27672",
          name: "Rincon Chamula",
          state_id: "2431",
        },
        {
          id: "27673",
          name: "Salto de Agua",
          state_id: "2431",
        },
        {
          id: "27674",
          name: "San Cristobal de las Casas",
          state_id: "2431",
        },
        {
          id: "27675",
          name: "San Fernando",
          state_id: "2431",
        },
        {
          id: "27676",
          name: "San Lucas",
          state_id: "2431",
        },
        {
          id: "27677",
          name: "San Pedro Buenavista",
          state_id: "2431",
        },
        {
          id: "27678",
          name: "Simojovel",
          state_id: "2431",
        },
        {
          id: "27679",
          name: "Socoltenango",
          state_id: "2431",
        },
        {
          id: "27680",
          name: "Soyalo",
          state_id: "2431",
        },
        {
          id: "27681",
          name: "Suchiapa",
          state_id: "2431",
        },
        {
          id: "27682",
          name: "Suchiate",
          state_id: "2431",
        },
        {
          id: "27683",
          name: "Tapachula",
          state_id: "2431",
        },
        {
          id: "27684",
          name: "Tapilula",
          state_id: "2431",
        },
        {
          id: "27685",
          name: "Tecpatan",
          state_id: "2431",
        },
        {
          id: "27686",
          name: "Tenango",
          state_id: "2431",
        },
        {
          id: "27687",
          name: "Teopisca",
          state_id: "2431",
        },
        {
          id: "27688",
          name: "Tila",
          state_id: "2431",
        },
        {
          id: "27689",
          name: "Tonala",
          state_id: "2431",
        },
        {
          id: "27690",
          name: "Totolapa",
          state_id: "2431",
        },
        {
          id: "27691",
          name: "Tres Picos",
          state_id: "2431",
        },
        {
          id: "27692",
          name: "Tuxtla Chico",
          state_id: "2431",
        },
        {
          id: "27693",
          name: "Tuxtla Gutierrez",
          state_id: "2431",
        },
        {
          id: "27694",
          name: "Tzimol",
          state_id: "2431",
        },
        {
          id: "27695",
          name: "Veinte de Noviembre",
          state_id: "2431",
        },
        {
          id: "27696",
          name: "Venustiano Carranza",
          state_id: "2431",
        },
        {
          id: "27697",
          name: "Villa Corzo",
          state_id: "2431",
        },
        {
          id: "27698",
          name: "Villaflores",
          state_id: "2431",
        },
        {
          id: "27699",
          name: "Yajalon",
          state_id: "2431",
        },
        {
          id: "27700",
          name: "Zinacantan",
          state_id: "2431",
        },
      ],
      Chihuahua: [
        {
          id: "27701",
          name: "Adolfo Lopez Mateos",
          state_id: "2432",
        },
        {
          id: "27702",
          name: "Ahumada",
          state_id: "2432",
        },
        {
          id: "27703",
          name: "Anahuac",
          state_id: "2432",
        },
        {
          id: "27704",
          name: "Ascension",
          state_id: "2432",
        },
        {
          id: "27705",
          name: "Benito Juarez",
          state_id: "2432",
        },
        {
          id: "27706",
          name: "Camargo",
          state_id: "2432",
        },
        {
          id: "27707",
          name: "Carichi",
          state_id: "2432",
        },
        {
          id: "27708",
          name: "Casas Grandes",
          state_id: "2432",
        },
        {
          id: "27709",
          name: "Chihuahua",
          state_id: "2432",
        },
        {
          id: "27710",
          name: "Colonia Municipio Libre",
          state_id: "2432",
        },
        {
          id: "27711",
          name: "Creel",
          state_id: "2432",
        },
        {
          id: "27712",
          name: "Cuauhtemoc",
          state_id: "2432",
        },
        {
          id: "27713",
          name: "Delicias",
          state_id: "2432",
        },
        {
          id: "27714",
          name: "El Largo",
          state_id: "2432",
        },
        {
          id: "27715",
          name: "Guachochi",
          state_id: "2432",
        },
        {
          id: "27716",
          name: "Guadalupe",
          state_id: "2432",
        },
        {
          id: "27717",
          name: "Guadalupe y Calvo",
          state_id: "2432",
        },
        {
          id: "27718",
          name: "Hermenegildo Galeana",
          state_id: "2432",
        },
        {
          id: "27719",
          name: "Hidalgo",
          state_id: "2432",
        },
        {
          id: "27720",
          name: "Ignacio Zaragoza",
          state_id: "2432",
        },
        {
          id: "27721",
          name: "Jimenez",
          state_id: "2432",
        },
        {
          id: "27722",
          name: "Juan Aldama",
          state_id: "2432",
        },
        {
          id: "27723",
          name: "Juarez",
          state_id: "2432",
        },
        {
          id: "27724",
          name: "Lazaro Cardenas",
          state_id: "2432",
        },
        {
          id: "27725",
          name: "Madera",
          state_id: "2432",
        },
        {
          id: "27726",
          name: "Majimachi",
          state_id: "2432",
        },
        {
          id: "27727",
          name: "Meoqui",
          state_id: "2432",
        },
        {
          id: "27728",
          name: "Naica",
          state_id: "2432",
        },
        {
          id: "27729",
          name: "Nuevo Casas Grandes",
          state_id: "2432",
        },
        {
          id: "27730",
          name: "Octaviano Lopez",
          state_id: "2432",
        },
        {
          id: "27731",
          name: "Ojinaga",
          state_id: "2432",
        },
        {
          id: "27732",
          name: "Praxedis Guerrero",
          state_id: "2432",
        },
        {
          id: "27733",
          name: "Puerto Palomas",
          state_id: "2432",
        },
        {
          id: "27734",
          name: "Puerto de Anapra",
          state_id: "2432",
        },
        {
          id: "27735",
          name: "San Buenaventura",
          state_id: "2432",
        },
        {
          id: "27736",
          name: "San Francisco el Oro",
          state_id: "2432",
        },
        {
          id: "27737",
          name: "Santa Barbara",
          state_id: "2432",
        },
        {
          id: "27738",
          name: "Santa Cruz de Rosales",
          state_id: "2432",
        },
        {
          id: "27739",
          name: "Saucillo",
          state_id: "2432",
        },
        {
          id: "27740",
          name: "Valentin Gomez Farias",
          state_id: "2432",
        },
        {
          id: "27741",
          name: "Valle de Allende",
          state_id: "2432",
        },
        {
          id: "27742",
          name: "Vicente Guerrero",
          state_id: "2432",
        },
      ],
      Coahuila: [
        {
          id: "27743",
          name: "Acuna",
          state_id: "2433",
        },
        {
          id: "27744",
          name: "Allende",
          state_id: "2433",
        },
        {
          id: "27745",
          name: "Arteaga",
          state_id: "2433",
        },
        {
          id: "27746",
          name: "Castanos",
          state_id: "2433",
        },
        {
          id: "27747",
          name: "Concordia",
          state_id: "2433",
        },
        {
          id: "27748",
          name: "Cuatrocienagas",
          state_id: "2433",
        },
        {
          id: "27749",
          name: "El Coyote",
          state_id: "2433",
        },
        {
          id: "27750",
          name: "Frontera",
          state_id: "2433",
        },
        {
          id: "27751",
          name: "General Cepeda",
          state_id: "2433",
        },
        {
          id: "27752",
          name: "Hercules",
          state_id: "2433",
        },
        {
          id: "27753",
          name: "Matamoros",
          state_id: "2433",
        },
        {
          id: "27754",
          name: "Minas de Barroteran",
          state_id: "2433",
        },
        {
          id: "27755",
          name: "Monclova",
          state_id: "2433",
        },
        {
          id: "27756",
          name: "Muzquiz",
          state_id: "2433",
        },
        {
          id: "27757",
          name: "Nadadores",
          state_id: "2433",
        },
        {
          id: "27758",
          name: "Nava",
          state_id: "2433",
        },
        {
          id: "27759",
          name: "Nueva Rosita",
          state_id: "2433",
        },
        {
          id: "27760",
          name: "Ocampo",
          state_id: "2433",
        },
        {
          id: "27761",
          name: "Palau",
          state_id: "2433",
        },
        {
          id: "27762",
          name: "Parras",
          state_id: "2433",
        },
        {
          id: "27763",
          name: "Piedras Negras",
          state_id: "2433",
        },
        {
          id: "27764",
          name: "Ramos Arizpe",
          state_id: "2433",
        },
        {
          id: "27765",
          name: "Sabinas",
          state_id: "2433",
        },
        {
          id: "27766",
          name: "Saltillo",
          state_id: "2433",
        },
        {
          id: "27767",
          name: "San Buenaventura",
          state_id: "2433",
        },
        {
          id: "27768",
          name: "San Pedro",
          state_id: "2433",
        },
        {
          id: "27769",
          name: "Torreon",
          state_id: "2433",
        },
        {
          id: "27770",
          name: "Venustiano Carranza",
          state_id: "2433",
        },
        {
          id: "27771",
          name: "Viesca",
          state_id: "2433",
        },
        {
          id: "27772",
          name: "Villa Madero",
          state_id: "2433",
        },
        {
          id: "27773",
          name: "Villa Union",
          state_id: "2433",
        },
        {
          id: "27774",
          name: "Zaragoza",
          state_id: "2433",
        },
      ],
      Colima: [
        {
          id: "27775",
          name: "Armeria",
          state_id: "2434",
        },
        {
          id: "27776",
          name: "Cofradia",
          state_id: "2434",
        },
        {
          id: "27777",
          name: "Colima",
          state_id: "2434",
        },
        {
          id: "27778",
          name: "Colonia Bayardo",
          state_id: "2434",
        },
        {
          id: "27779",
          name: "Comala",
          state_id: "2434",
        },
        {
          id: "27780",
          name: "Coquimatlan",
          state_id: "2434",
        },
        {
          id: "27781",
          name: "Cuauhtemoc",
          state_id: "2434",
        },
        {
          id: "27782",
          name: "El Colomo",
          state_id: "2434",
        },
        {
          id: "27783",
          name: "Madrid",
          state_id: "2434",
        },
        {
          id: "27784",
          name: "Manzanillo",
          state_id: "2434",
        },
        {
          id: "27785",
          name: "Minatitlan",
          state_id: "2434",
        },
        {
          id: "27786",
          name: "Queseria",
          state_id: "2434",
        },
        {
          id: "27787",
          name: "Suchitlan",
          state_id: "2434",
        },
        {
          id: "27788",
          name: "Tecoman",
          state_id: "2434",
        },
        {
          id: "27789",
          name: "Villa de Alvarez",
          state_id: "2434",
        },
      ],
      "Distrito Federal": [],
      Durango: [
        {
          id: "27790",
          name: "Bermejillo",
          state_id: "2436",
        },
        {
          id: "27791",
          name: "Canatlan",
          state_id: "2436",
        },
        {
          id: "27792",
          name: "Cuencame",
          state_id: "2436",
        },
        {
          id: "27793",
          name: "Durango",
          state_id: "2436",
        },
        {
          id: "27794",
          name: "Gomez Palacio",
          state_id: "2436",
        },
        {
          id: "27795",
          name: "Guadalupe Victoria",
          state_id: "2436",
        },
        {
          id: "27796",
          name: "Juarez",
          state_id: "2436",
        },
        {
          id: "27797",
          name: "Lerdo",
          state_id: "2436",
        },
        {
          id: "27798",
          name: "Mapimi",
          state_id: "2436",
        },
        {
          id: "27799",
          name: "Nazareno",
          state_id: "2436",
        },
        {
          id: "27800",
          name: "Nazas",
          state_id: "2436",
        },
        {
          id: "27801",
          name: "Nombre de Dios",
          state_id: "2436",
        },
        {
          id: "27802",
          name: "Nuevo Ideal",
          state_id: "2436",
        },
        {
          id: "27803",
          name: "Ocampo",
          state_id: "2436",
        },
        {
          id: "27804",
          name: "Panuco",
          state_id: "2436",
        },
        {
          id: "27805",
          name: "Papasquiaro",
          state_id: "2436",
        },
        {
          id: "27806",
          name: "Penon Blanco",
          state_id: "2436",
        },
        {
          id: "27807",
          name: "Poanas",
          state_id: "2436",
        },
        {
          id: "27808",
          name: "Pueblo Nuevo",
          state_id: "2436",
        },
        {
          id: "27809",
          name: "Rodeo",
          state_id: "2436",
        },
        {
          id: "27810",
          name: "Santa Catarina de Tepehuanes",
          state_id: "2436",
        },
        {
          id: "27811",
          name: "Santa Clara",
          state_id: "2436",
        },
        {
          id: "27812",
          name: "Santa Maria del Oro",
          state_id: "2436",
        },
        {
          id: "27813",
          name: "Suchil",
          state_id: "2436",
        },
        {
          id: "27814",
          name: "Tayoltita",
          state_id: "2436",
        },
        {
          id: "27815",
          name: "Tlahualilo",
          state_id: "2436",
        },
        {
          id: "27816",
          name: "Vicente Guerrero",
          state_id: "2436",
        },
      ],
      "Estado de Mexico": [],
      Guanajuato: [
        {
          id: "27817",
          name: "Abasolo",
          state_id: "2438",
        },
        {
          id: "27818",
          name: "Acambaro",
          state_id: "2438",
        },
        {
          id: "27819",
          name: "Aldama",
          state_id: "2438",
        },
        {
          id: "27820",
          name: "Allende",
          state_id: "2438",
        },
        {
          id: "27821",
          name: "Antonio Rodriguez",
          state_id: "2438",
        },
        {
          id: "27822",
          name: "Apaseo el Alto",
          state_id: "2438",
        },
        {
          id: "27823",
          name: "Apaseo el Grande",
          state_id: "2438",
        },
        {
          id: "27824",
          name: "Celaya",
          state_id: "2438",
        },
        {
          id: "27825",
          name: "Centro Familiar la Soledad",
          state_id: "2438",
        },
        {
          id: "27826",
          name: "Cerano",
          state_id: "2438",
        },
        {
          id: "27827",
          name: "Cerro Gordo",
          state_id: "2438",
        },
        {
          id: "27828",
          name: "Colonias Nuevo Mexico",
          state_id: "2438",
        },
        {
          id: "27829",
          name: "Comonfort",
          state_id: "2438",
        },
        {
          id: "27830",
          name: "Coroneo",
          state_id: "2438",
        },
        {
          id: "27831",
          name: "Cortazar",
          state_id: "2438",
        },
        {
          id: "27832",
          name: "Cueramaro",
          state_id: "2438",
        },
        {
          id: "27833",
          name: "Doctor Mora",
          state_id: "2438",
        },
        {
          id: "27834",
          name: "Dolores Hidalgo",
          state_id: "2438",
        },
        {
          id: "27835",
          name: "Duarte",
          state_id: "2438",
        },
        {
          id: "27836",
          name: "El Sabino",
          state_id: "2438",
        },
        {
          id: "27837",
          name: "Escobedo",
          state_id: "2438",
        },
        {
          id: "27838",
          name: "Guanajuato",
          state_id: "2438",
        },
        {
          id: "27839",
          name: "Huanimaro",
          state_id: "2438",
        },
        {
          id: "27840",
          name: "Iramuco",
          state_id: "2438",
        },
        {
          id: "27841",
          name: "Irapuato",
          state_id: "2438",
        },
        {
          id: "27842",
          name: "Jaral del Progreso",
          state_id: "2438",
        },
        {
          id: "27843",
          name: "Jerecuaro",
          state_id: "2438",
        },
        {
          id: "27844",
          name: "Juventino Rosas",
          state_id: "2438",
        },
        {
          id: "27845",
          name: "La Aldea",
          state_id: "2438",
        },
        {
          id: "27846",
          name: "La Calera",
          state_id: "2438",
        },
        {
          id: "27847",
          name: "La Ermita",
          state_id: "2438",
        },
        {
          id: "27848",
          name: "La Moncada",
          state_id: "2438",
        },
        {
          id: "27849",
          name: "Leon",
          state_id: "2438",
        },
        {
          id: "27850",
          name: "Loma Pelada",
          state_id: "2438",
        },
        {
          id: "27851",
          name: "Manuel Doblado",
          state_id: "2438",
        },
        {
          id: "27852",
          name: "Maravatio",
          state_id: "2438",
        },
        {
          id: "27853",
          name: "Marfil",
          state_id: "2438",
        },
        {
          id: "27854",
          name: "Medina",
          state_id: "2438",
        },
        {
          id: "27855",
          name: "Mexicanos",
          state_id: "2438",
        },
        {
          id: "27856",
          name: "Moroleon",
          state_id: "2438",
        },
        {
          id: "27857",
          name: "Ocampo",
          state_id: "2438",
        },
        {
          id: "27858",
          name: "Octopan",
          state_id: "2438",
        },
        {
          id: "27859",
          name: "Pacueco",
          state_id: "2438",
        },
        {
          id: "27860",
          name: "Palo Verde",
          state_id: "2438",
        },
        {
          id: "27861",
          name: "Paracuaro",
          state_id: "2438",
        },
        {
          id: "27862",
          name: "Penjamo",
          state_id: "2438",
        },
        {
          id: "27863",
          name: "Plan de Ayala",
          state_id: "2438",
        },
        {
          id: "27864",
          name: "Pueblo Nuevo",
          state_id: "2438",
        },
        {
          id: "27865",
          name: "Purisima de Bustos",
          state_id: "2438",
        },
        {
          id: "27866",
          name: "Rincon de Tamayo",
          state_id: "2438",
        },
        {
          id: "27867",
          name: "Romita",
          state_id: "2438",
        },
        {
          id: "27868",
          name: "Salamanca",
          state_id: "2438",
        },
        {
          id: "27869",
          name: "Salvatierra",
          state_id: "2438",
        },
        {
          id: "27870",
          name: "San Bartolo de Berrios",
          state_id: "2438",
        },
        {
          id: "27871",
          name: "San Cristobal",
          state_id: "2438",
        },
        {
          id: "27872",
          name: "San Diego de la Union",
          state_id: "2438",
        },
        {
          id: "27873",
          name: "San Felipe",
          state_id: "2438",
        },
        {
          id: "27874",
          name: "San Francisco del Rincon",
          state_id: "2438",
        },
        {
          id: "27875",
          name: "San Jose Agua Azul",
          state_id: "2438",
        },
        {
          id: "27876",
          name: "San Jose Iturbide",
          state_id: "2438",
        },
        {
          id: "27877",
          name: "San Jose Temascatio",
          state_id: "2438",
        },
        {
          id: "27878",
          name: "San Juan de la Vega",
          state_id: "2438",
        },
        {
          id: "27879",
          name: "San Luis de la Paz",
          state_id: "2438",
        },
        {
          id: "27880",
          name: "San Nicolas de los Agustinos",
          state_id: "2438",
        },
        {
          id: "27881",
          name: "San Pedro de los Naranjos",
          state_id: "2438",
        },
        {
          id: "27882",
          name: "San Roque",
          state_id: "2438",
        },
        {
          id: "27883",
          name: "Santa Teresa",
          state_id: "2438",
        },
        {
          id: "27884",
          name: "Santiago de Cuenda",
          state_id: "2438",
        },
        {
          id: "27885",
          name: "Sarabia",
          state_id: "2438",
        },
        {
          id: "27886",
          name: "Silao",
          state_id: "2438",
        },
        {
          id: "27887",
          name: "Tarandacuao",
          state_id: "2438",
        },
        {
          id: "27888",
          name: "Tarimoro",
          state_id: "2438",
        },
        {
          id: "27889",
          name: "Teneria del Santuario",
          state_id: "2438",
        },
        {
          id: "27890",
          name: "Uriangato",
          state_id: "2438",
        },
        {
          id: "27891",
          name: "Urireo",
          state_id: "2438",
        },
        {
          id: "27892",
          name: "Valle de Santiago",
          state_id: "2438",
        },
        {
          id: "27893",
          name: "Valtierrilla",
          state_id: "2438",
        },
        {
          id: "27894",
          name: "Victoria",
          state_id: "2438",
        },
        {
          id: "27895",
          name: "Villagran",
          state_id: "2438",
        },
        {
          id: "27896",
          name: "Villas de Irapuato",
          state_id: "2438",
        },
        {
          id: "27897",
          name: "Yerbabuena",
          state_id: "2438",
        },
        {
          id: "27898",
          name: "Yuriria",
          state_id: "2438",
        },
      ],
      Guerrero: [
        {
          id: "27899",
          name: "Acamixtla",
          state_id: "2439",
        },
        {
          id: "27900",
          name: "Acapulco",
          state_id: "2439",
        },
        {
          id: "27901",
          name: "Acatlan",
          state_id: "2439",
        },
        {
          id: "27902",
          name: "Ajuchitlan",
          state_id: "2439",
        },
        {
          id: "27903",
          name: "Alpoyeca",
          state_id: "2439",
        },
        {
          id: "27904",
          name: "Altamirano",
          state_id: "2439",
        },
        {
          id: "27905",
          name: "Apango",
          state_id: "2439",
        },
        {
          id: "27906",
          name: "Apaxtla",
          state_id: "2439",
        },
        {
          id: "27907",
          name: "Arcelia",
          state_id: "2439",
        },
        {
          id: "27908",
          name: "Atliaca",
          state_id: "2439",
        },
        {
          id: "27909",
          name: "Atoyac",
          state_id: "2439",
        },
        {
          id: "27910",
          name: "Ayutla",
          state_id: "2439",
        },
        {
          id: "27911",
          name: "Azoyu",
          state_id: "2439",
        },
        {
          id: "27912",
          name: "Bajos de Ejido",
          state_id: "2439",
        },
        {
          id: "27913",
          name: "Buenavista",
          state_id: "2439",
        },
        {
          id: "27914",
          name: "Chichihualco",
          state_id: "2439",
        },
        {
          id: "27915",
          name: "Chilapa",
          state_id: "2439",
        },
        {
          id: "27916",
          name: "Chilpancingo",
          state_id: "2439",
        },
        {
          id: "27917",
          name: "Coacoyul",
          state_id: "2439",
        },
        {
          id: "27918",
          name: "Cocula",
          state_id: "2439",
        },
        {
          id: "27919",
          name: "Copala",
          state_id: "2439",
        },
        {
          id: "27920",
          name: "Copalillo",
          state_id: "2439",
        },
        {
          id: "27921",
          name: "Coyuca",
          state_id: "2439",
        },
        {
          id: "27922",
          name: "Cruz Grande",
          state_id: "2439",
        },
        {
          id: "27923",
          name: "Cuajinicuilapa",
          state_id: "2439",
        },
        {
          id: "27924",
          name: "Cuautepec",
          state_id: "2439",
        },
        {
          id: "27925",
          name: "Cutzamala",
          state_id: "2439",
        },
        {
          id: "27926",
          name: "El Ocotito",
          state_id: "2439",
        },
        {
          id: "27927",
          name: "El Paraiso",
          state_id: "2439",
        },
        {
          id: "27928",
          name: "El Suchil",
          state_id: "2439",
        },
        {
          id: "27929",
          name: "Huamuxtitlan",
          state_id: "2439",
        },
        {
          id: "27930",
          name: "Huitziltepec",
          state_id: "2439",
        },
        {
          id: "27931",
          name: "Huitzuco",
          state_id: "2439",
        },
        {
          id: "27932",
          name: "Iguala",
          state_id: "2439",
        },
        {
          id: "27933",
          name: "Ixtapa",
          state_id: "2439",
        },
        {
          id: "27934",
          name: "Kilometro Treinta",
          state_id: "2439",
        },
        {
          id: "27935",
          name: "La Loma",
          state_id: "2439",
        },
        {
          id: "27936",
          name: "La Union",
          state_id: "2439",
        },
        {
          id: "27937",
          name: "Las Petaquillas",
          state_id: "2439",
        },
        {
          id: "27938",
          name: "Las Vigas",
          state_id: "2439",
        },
        {
          id: "27939",
          name: "Marquelia",
          state_id: "2439",
        },
        {
          id: "27940",
          name: "Mazatlan",
          state_id: "2439",
        },
        {
          id: "27941",
          name: "Mochitlan",
          state_id: "2439",
        },
        {
          id: "27942",
          name: "Olinala",
          state_id: "2439",
        },
        {
          id: "27943",
          name: "Ometepec",
          state_id: "2439",
        },
        {
          id: "27944",
          name: "Petatlan",
          state_id: "2439",
        },
        {
          id: "27945",
          name: "Pilcaya",
          state_id: "2439",
        },
        {
          id: "27946",
          name: "Quechultenango",
          state_id: "2439",
        },
        {
          id: "27947",
          name: "San Jeronimito",
          state_id: "2439",
        },
        {
          id: "27948",
          name: "San Jeronimo",
          state_id: "2439",
        },
        {
          id: "27949",
          name: "San Jose Ixtapa",
          state_id: "2439",
        },
        {
          id: "27950",
          name: "San Luis San Pedro",
          state_id: "2439",
        },
        {
          id: "27951",
          name: "San Marcos",
          state_id: "2439",
        },
        {
          id: "27952",
          name: "Taxco",
          state_id: "2439",
        },
        {
          id: "27953",
          name: "Taxco de Alarcon",
          state_id: "2439",
        },
        {
          id: "27954",
          name: "Tecoanapa",
          state_id: "2439",
        },
        {
          id: "27955",
          name: "Tecpan",
          state_id: "2439",
        },
        {
          id: "27956",
          name: "Teloloapan",
          state_id: "2439",
        },
        {
          id: "27957",
          name: "Tepecoacuilco",
          state_id: "2439",
        },
        {
          id: "27958",
          name: "Tierra Colorada",
          state_id: "2439",
        },
        {
          id: "27959",
          name: "Tixtla",
          state_id: "2439",
        },
        {
          id: "27960",
          name: "Tlacoachistlahuaca",
          state_id: "2439",
        },
        {
          id: "27961",
          name: "Tlacotepec",
          state_id: "2439",
        },
        {
          id: "27962",
          name: "Tlalchapa",
          state_id: "2439",
        },
        {
          id: "27963",
          name: "Tlamacazapa",
          state_id: "2439",
        },
        {
          id: "27964",
          name: "Tlapa",
          state_id: "2439",
        },
        {
          id: "27965",
          name: "Tlapehuala",
          state_id: "2439",
        },
        {
          id: "27966",
          name: "Totolapan",
          state_id: "2439",
        },
        {
          id: "27967",
          name: "Tres Palos",
          state_id: "2439",
        },
        {
          id: "27968",
          name: "Xalpatlahuac",
          state_id: "2439",
        },
        {
          id: "27969",
          name: "Xaltianguis",
          state_id: "2439",
        },
        {
          id: "27970",
          name: "Xochihuehuetlan",
          state_id: "2439",
        },
        {
          id: "27971",
          name: "Xochistlahuaca",
          state_id: "2439",
        },
        {
          id: "27972",
          name: "Zacualpan",
          state_id: "2439",
        },
        {
          id: "27973",
          name: "Zihuatanejo",
          state_id: "2439",
        },
        {
          id: "27974",
          name: "Zirandaro",
          state_id: "2439",
        },
        {
          id: "27975",
          name: "Zitlala",
          state_id: "2439",
        },
        {
          id: "27976",
          name: "Zumpango",
          state_id: "2439",
        },
      ],
      Hidalgo: [
        {
          id: "27977",
          name: "Acaxochitlan",
          state_id: "2440",
        },
        {
          id: "27978",
          name: "Acayuca",
          state_id: "2440",
        },
        {
          id: "27979",
          name: "Actopan",
          state_id: "2440",
        },
        {
          id: "27980",
          name: "Ajacuba",
          state_id: "2440",
        },
        {
          id: "27981",
          name: "Almoloya",
          state_id: "2440",
        },
        {
          id: "27982",
          name: "Apan",
          state_id: "2440",
        },
        {
          id: "27983",
          name: "Atengo",
          state_id: "2440",
        },
        {
          id: "27984",
          name: "Atitalaquia",
          state_id: "2440",
        },
        {
          id: "27985",
          name: "Atotonilco de Tula",
          state_id: "2440",
        },
        {
          id: "27986",
          name: "Atotonilco el Grande",
          state_id: "2440",
        },
        {
          id: "27987",
          name: "Calnali",
          state_id: "2440",
        },
        {
          id: "27988",
          name: "Cardonal",
          state_id: "2440",
        },
        {
          id: "27989",
          name: "Chapulhuacan",
          state_id: "2440",
        },
        {
          id: "27990",
          name: "Cuautepec",
          state_id: "2440",
        },
        {
          id: "27991",
          name: "Doxey",
          state_id: "2440",
        },
        {
          id: "27992",
          name: "El Arenal",
          state_id: "2440",
        },
        {
          id: "27993",
          name: "El Llano",
          state_id: "2440",
        },
        {
          id: "27994",
          name: "El Rosario",
          state_id: "2440",
        },
        {
          id: "27995",
          name: "Emiliano Zapata",
          state_id: "2440",
        },
        {
          id: "27996",
          name: "Huautla",
          state_id: "2440",
        },
        {
          id: "27997",
          name: "Huejutla",
          state_id: "2440",
        },
        {
          id: "27998",
          name: "Hueytlalpan",
          state_id: "2440",
        },
        {
          id: "27999",
          name: "Huichapan",
          state_id: "2440",
        },
        {
          id: "28000",
          name: "Ixmiquilpan",
          state_id: "2440",
        },
        {
          id: "28001",
          name: "Jacala",
          state_id: "2440",
        },
        {
          id: "28002",
          name: "Jaltocan",
          state_id: "2440",
        },
        {
          id: "28003",
          name: "Los Reyes",
          state_id: "2440",
        },
        {
          id: "28004",
          name: "Mineral del Monte",
          state_id: "2440",
        },
        {
          id: "28005",
          name: "Mixquiahuala",
          state_id: "2440",
        },
        {
          id: "28006",
          name: "Molango",
          state_id: "2440",
        },
        {
          id: "28007",
          name: "Orizatlan",
          state_id: "2440",
        },
        {
          id: "28008",
          name: "Pachuca",
          state_id: "2440",
        },
        {
          id: "28009",
          name: "Pachuquilla",
          state_id: "2440",
        },
        {
          id: "28010",
          name: "Progreso",
          state_id: "2440",
        },
        {
          id: "28011",
          name: "Sahagun",
          state_id: "2440",
        },
        {
          id: "28012",
          name: "San Ildefonso",
          state_id: "2440",
        },
        {
          id: "28013",
          name: "San Juan Tepa",
          state_id: "2440",
        },
        {
          id: "28014",
          name: "San Marcos",
          state_id: "2440",
        },
        {
          id: "28015",
          name: "Singuilucan",
          state_id: "2440",
        },
        {
          id: "28016",
          name: "Tasquillo",
          state_id: "2440",
        },
        {
          id: "28017",
          name: "Tecozautla",
          state_id: "2440",
        },
        {
          id: "28018",
          name: "Tepatepec",
          state_id: "2440",
        },
        {
          id: "28019",
          name: "Tepeapulco",
          state_id: "2440",
        },
        {
          id: "28020",
          name: "Tepeji",
          state_id: "2440",
        },
        {
          id: "28021",
          name: "Tepepa",
          state_id: "2440",
        },
        {
          id: "28022",
          name: "Tetepango",
          state_id: "2440",
        },
        {
          id: "28023",
          name: "Tezontepec",
          state_id: "2440",
        },
        {
          id: "28024",
          name: "Tizayuca",
          state_id: "2440",
        },
        {
          id: "28025",
          name: "Tlahuelilpan",
          state_id: "2440",
        },
        {
          id: "28026",
          name: "Tlanalapa",
          state_id: "2440",
        },
        {
          id: "28027",
          name: "Tlanchinol",
          state_id: "2440",
        },
        {
          id: "28028",
          name: "Tlaxcoapan",
          state_id: "2440",
        },
        {
          id: "28029",
          name: "Tlaxiaca",
          state_id: "2440",
        },
        {
          id: "28030",
          name: "Tolcayuca",
          state_id: "2440",
        },
        {
          id: "28031",
          name: "Tula de Allende",
          state_id: "2440",
        },
        {
          id: "28032",
          name: "Tulancingo",
          state_id: "2440",
        },
        {
          id: "28033",
          name: "Tulantepec",
          state_id: "2440",
        },
        {
          id: "28034",
          name: "Vindho",
          state_id: "2440",
        },
        {
          id: "28035",
          name: "Zacualtipan",
          state_id: "2440",
        },
        {
          id: "28036",
          name: "Zapotlan",
          state_id: "2440",
        },
        {
          id: "28037",
          name: "Zempoala",
          state_id: "2440",
        },
        {
          id: "28038",
          name: "Zimapan",
          state_id: "2440",
        },
      ],
      Jalisco: [
        {
          id: "28039",
          name: "Acatic",
          state_id: "2441",
        },
        {
          id: "28040",
          name: "Acatlan",
          state_id: "2441",
        },
        {
          id: "28041",
          name: "Ahualulco",
          state_id: "2441",
        },
        {
          id: "28042",
          name: "Ajijic",
          state_id: "2441",
        },
        {
          id: "28043",
          name: "Alejandria",
          state_id: "2441",
        },
        {
          id: "28044",
          name: "Amatitan",
          state_id: "2441",
        },
        {
          id: "28045",
          name: "Ameca",
          state_id: "2441",
        },
        {
          id: "28046",
          name: "Antonio Escobedo",
          state_id: "2441",
        },
        {
          id: "28047",
          name: "Arandas",
          state_id: "2441",
        },
        {
          id: "28048",
          name: "Atemajac",
          state_id: "2441",
        },
        {
          id: "28049",
          name: "Atequiza",
          state_id: "2441",
        },
        {
          id: "28050",
          name: "Atotonilco el Alto",
          state_id: "2441",
        },
        {
          id: "28051",
          name: "Atotonilquillo",
          state_id: "2441",
        },
        {
          id: "28052",
          name: "Atoyac",
          state_id: "2441",
        },
        {
          id: "28053",
          name: "Autlan",
          state_id: "2441",
        },
        {
          id: "28054",
          name: "Ayotlan",
          state_id: "2441",
        },
        {
          id: "28055",
          name: "Ayutla",
          state_id: "2441",
        },
        {
          id: "28056",
          name: "Bellavista",
          state_id: "2441",
        },
        {
          id: "28057",
          name: "Cajititlan",
          state_id: "2441",
        },
        {
          id: "28058",
          name: "Capilla de Guadalupe",
          state_id: "2441",
        },
        {
          id: "28059",
          name: "Casimiro Castillo",
          state_id: "2441",
        },
        {
          id: "28060",
          name: "Centro de Readaptacion Social",
          state_id: "2441",
        },
        {
          id: "28061",
          name: "Chapala",
          state_id: "2441",
        },
        {
          id: "28062",
          name: "Chiquilistlan",
          state_id: "2441",
        },
        {
          id: "28063",
          name: "Cihuatlan",
          state_id: "2441",
        },
        {
          id: "28064",
          name: "Cocula",
          state_id: "2441",
        },
        {
          id: "28065",
          name: "Colotlan",
          state_id: "2441",
        },
        {
          id: "28066",
          name: "Concepcion de Buenos Aires",
          state_id: "2441",
        },
        {
          id: "28067",
          name: "Cosala",
          state_id: "2441",
        },
        {
          id: "28068",
          name: "Coyula",
          state_id: "2441",
        },
        {
          id: "28069",
          name: "Cuitzeo",
          state_id: "2441",
        },
        {
          id: "28070",
          name: "Cuqio",
          state_id: "2441",
        },
        {
          id: "28071",
          name: "Cuyutlan",
          state_id: "2441",
        },
        {
          id: "28072",
          name: "Degollado",
          state_id: "2441",
        },
        {
          id: "28073",
          name: "El Arenal",
          state_id: "2441",
        },
        {
          id: "28074",
          name: "El Grullo",
          state_id: "2441",
        },
        {
          id: "28075",
          name: "El Limon",
          state_id: "2441",
        },
        {
          id: "28076",
          name: "El Quince",
          state_id: "2441",
        },
        {
          id: "28077",
          name: "El Refugio",
          state_id: "2441",
        },
        {
          id: "28078",
          name: "El Salto",
          state_id: "2441",
        },
        {
          id: "28079",
          name: "El Verde",
          state_id: "2441",
        },
        {
          id: "28080",
          name: "Encarnacion",
          state_id: "2441",
        },
        {
          id: "28081",
          name: "Etzatlan",
          state_id: "2441",
        },
        {
          id: "28082",
          name: "Guadalajara",
          state_id: "2441",
        },
        {
          id: "28083",
          name: "Guzman",
          state_id: "2441",
        },
        {
          id: "28084",
          name: "Hidalgo",
          state_id: "2441",
        },
        {
          id: "28085",
          name: "Hostotipaquillo",
          state_id: "2441",
        },
        {
          id: "28086",
          name: "Huejucar",
          state_id: "2441",
        },
        {
          id: "28087",
          name: "Huejuquilla el Alto",
          state_id: "2441",
        },
        {
          id: "28088",
          name: "Itzican",
          state_id: "2441",
        },
        {
          id: "28089",
          name: "Ixtapa",
          state_id: "2441",
        },
        {
          id: "28090",
          name: "Ixtlahuacan de los Membrillos",
          state_id: "2441",
        },
        {
          id: "28091",
          name: "Ixtlahuacan del Rio",
          state_id: "2441",
        },
        {
          id: "28092",
          name: "Ixtlan",
          state_id: "2441",
        },
        {
          id: "28093",
          name: "Jalostotitlan",
          state_id: "2441",
        },
        {
          id: "28094",
          name: "Jamay",
          state_id: "2441",
        },
        {
          id: "28095",
          name: "Jesus Maria",
          state_id: "2441",
        },
        {
          id: "28096",
          name: "Jocotepec",
          state_id: "2441",
        },
        {
          id: "28097",
          name: "Juanacatlan",
          state_id: "2441",
        },
        {
          id: "28098",
          name: "Juchitlan",
          state_id: "2441",
        },
        {
          id: "28099",
          name: "La Barca",
          state_id: "2441",
        },
        {
          id: "28100",
          name: "La Huerta",
          state_id: "2441",
        },
        {
          id: "28101",
          name: "La Ribera",
          state_id: "2441",
        },
        {
          id: "28102",
          name: "La Tijera",
          state_id: "2441",
        },
        {
          id: "28103",
          name: "La Venta del Astillero",
          state_id: "2441",
        },
        {
          id: "28104",
          name: "Lagos de Moreno",
          state_id: "2441",
        },
        {
          id: "28105",
          name: "Las Juntas",
          state_id: "2441",
        },
        {
          id: "28106",
          name: "Las Pintas",
          state_id: "2441",
        },
        {
          id: "28107",
          name: "Las Pintitas",
          state_id: "2441",
        },
        {
          id: "28108",
          name: "Lo Arado",
          state_id: "2441",
        },
        {
          id: "28109",
          name: "Magdalena",
          state_id: "2441",
        },
        {
          id: "28110",
          name: "Mascota",
          state_id: "2441",
        },
        {
          id: "28111",
          name: "Mazamitla",
          state_id: "2441",
        },
        {
          id: "28112",
          name: "Mexticacan",
          state_id: "2441",
        },
        {
          id: "28113",
          name: "Mezcala",
          state_id: "2441",
        },
        {
          id: "28114",
          name: "Nuevo Mexico",
          state_id: "2441",
        },
        {
          id: "28115",
          name: "Ocotlan",
          state_id: "2441",
        },
        {
          id: "28116",
          name: "Ojuelos de Jalisco",
          state_id: "2441",
        },
        {
          id: "28117",
          name: "Pihuamo",
          state_id: "2441",
        },
        {
          id: "28118",
          name: "Poncitlan",
          state_id: "2441",
        },
        {
          id: "28119",
          name: "Puente Grande",
          state_id: "2441",
        },
        {
          id: "28120",
          name: "Puerto Vallarta",
          state_id: "2441",
        },
        {
          id: "28121",
          name: "Purificacion",
          state_id: "2441",
        },
        {
          id: "28122",
          name: "San Agustin",
          state_id: "2441",
        },
        {
          id: "28123",
          name: "San Francisco de Asis",
          state_id: "2441",
        },
        {
          id: "28124",
          name: "San Gabriel",
          state_id: "2441",
        },
        {
          id: "28125",
          name: "San Jose de Gracia",
          state_id: "2441",
        },
        {
          id: "28126",
          name: "San Jose del Castillo",
          state_id: "2441",
        },
        {
          id: "28127",
          name: "San Juan de los Lagos",
          state_id: "2441",
        },
        {
          id: "28128",
          name: "San Julian",
          state_id: "2441",
        },
        {
          id: "28129",
          name: "San Marcos",
          state_id: "2441",
        },
        {
          id: "28130",
          name: "San Martin de Hidalgo",
          state_id: "2441",
        },
        {
          id: "28131",
          name: "San Miguel el Alto",
          state_id: "2441",
        },
        {
          id: "28132",
          name: "San Patricio",
          state_id: "2441",
        },
        {
          id: "28133",
          name: "San Sebastian del Sur",
          state_id: "2441",
        },
        {
          id: "28134",
          name: "San Sebastian el Grande",
          state_id: "2441",
        },
        {
          id: "28135",
          name: "Santa Anita",
          state_id: "2441",
        },
        {
          id: "28136",
          name: "Santa Cruz de las Flores",
          state_id: "2441",
        },
        {
          id: "28137",
          name: "Santa Cruz del Valle",
          state_id: "2441",
        },
        {
          id: "28138",
          name: "Sayula",
          state_id: "2441",
        },
        {
          id: "28139",
          name: "Tala",
          state_id: "2441",
        },
        {
          id: "28140",
          name: "Talpa",
          state_id: "2441",
        },
        {
          id: "28141",
          name: "Tamazula",
          state_id: "2441",
        },
        {
          id: "28142",
          name: "Tapalpa",
          state_id: "2441",
        },
        {
          id: "28143",
          name: "Tecalitlan",
          state_id: "2441",
        },
        {
          id: "28144",
          name: "Tecolotlan",
          state_id: "2441",
        },
        {
          id: "28145",
          name: "Tenamaxtlan",
          state_id: "2441",
        },
        {
          id: "28146",
          name: "Teocaltiche",
          state_id: "2441",
        },
        {
          id: "28147",
          name: "Teocuitatlan de Corona",
          state_id: "2441",
        },
        {
          id: "28148",
          name: "Tepatitlan",
          state_id: "2441",
        },
        {
          id: "28149",
          name: "Tequila",
          state_id: "2441",
        },
        {
          id: "28150",
          name: "Tesistan",
          state_id: "2441",
        },
        {
          id: "28151",
          name: "Teuchitlan",
          state_id: "2441",
        },
        {
          id: "28152",
          name: "Tizapan el Alto",
          state_id: "2441",
        },
        {
          id: "28153",
          name: "Tlajomulco",
          state_id: "2441",
        },
        {
          id: "28154",
          name: "Tlaquepaque",
          state_id: "2441",
        },
        {
          id: "28155",
          name: "Tomatlan",
          state_id: "2441",
        },
        {
          id: "28156",
          name: "Tonala",
          state_id: "2441",
        },
        {
          id: "28157",
          name: "Tonaya",
          state_id: "2441",
        },
        {
          id: "28158",
          name: "Tonila",
          state_id: "2441",
        },
        {
          id: "28159",
          name: "Tototlan",
          state_id: "2441",
        },
        {
          id: "28160",
          name: "Tuxpan",
          state_id: "2441",
        },
        {
          id: "28161",
          name: "Union de San Antonio",
          state_id: "2441",
        },
        {
          id: "28162",
          name: "Union de Tula",
          state_id: "2441",
        },
        {
          id: "28163",
          name: "Usmajac",
          state_id: "2441",
        },
        {
          id: "28164",
          name: "Valle de Guadalupe",
          state_id: "2441",
        },
        {
          id: "28165",
          name: "Valle de Juarez",
          state_id: "2441",
        },
        {
          id: "28166",
          name: "Villa Corona",
          state_id: "2441",
        },
        {
          id: "28167",
          name: "Villa Guerrero",
          state_id: "2441",
        },
        {
          id: "28168",
          name: "Yahualica",
          state_id: "2441",
        },
        {
          id: "28169",
          name: "Zacoalco",
          state_id: "2441",
        },
        {
          id: "28170",
          name: "Zapopan",
          state_id: "2441",
        },
        {
          id: "28171",
          name: "Zapote",
          state_id: "2441",
        },
        {
          id: "28172",
          name: "Zapotiltic",
          state_id: "2441",
        },
        {
          id: "28173",
          name: "Zapotlanejo",
          state_id: "2441",
        },
      ],
      Mexico: [
        {
          id: "28174",
          name: "Acahualco",
          state_id: "2442",
        },
        {
          id: "28175",
          name: "Acambay",
          state_id: "2442",
        },
        {
          id: "28176",
          name: "Acazulco",
          state_id: "2442",
        },
        {
          id: "28177",
          name: "Acolman",
          state_id: "2442",
        },
        {
          id: "28178",
          name: "Acuautla",
          state_id: "2442",
        },
        {
          id: "28179",
          name: "Acutzilapan",
          state_id: "2442",
        },
        {
          id: "28180",
          name: "Ajoloapan",
          state_id: "2442",
        },
        {
          id: "28181",
          name: "Alborada",
          state_id: "2442",
        },
        {
          id: "28182",
          name: "Almaya",
          state_id: "2442",
        },
        {
          id: "28183",
          name: "Almoloya",
          state_id: "2442",
        },
        {
          id: "28184",
          name: "Almoloya del Rio",
          state_id: "2442",
        },
        {
          id: "28185",
          name: "Amanalco",
          state_id: "2442",
        },
        {
          id: "28186",
          name: "Amecameca",
          state_id: "2442",
        },
        {
          id: "28187",
          name: "Ameyalco",
          state_id: "2442",
        },
        {
          id: "28188",
          name: "Apaxco",
          state_id: "2442",
        },
        {
          id: "28189",
          name: "Atarasquillo",
          state_id: "2442",
        },
        {
          id: "28190",
          name: "Atenco",
          state_id: "2442",
        },
        {
          id: "28191",
          name: "Atizapan",
          state_id: "2442",
        },
        {
          id: "28192",
          name: "Atlacomulco",
          state_id: "2442",
        },
        {
          id: "28193",
          name: "Atlatlahuca",
          state_id: "2442",
        },
        {
          id: "28194",
          name: "Atlatongo",
          state_id: "2442",
        },
        {
          id: "28195",
          name: "Atlautla",
          state_id: "2442",
        },
        {
          id: "28196",
          name: "Atlazalpan",
          state_id: "2442",
        },
        {
          id: "28197",
          name: "Autopan",
          state_id: "2442",
        },
        {
          id: "28198",
          name: "Axapusco",
          state_id: "2442",
        },
        {
          id: "28199",
          name: "Ayotuzco",
          state_id: "2442",
        },
        {
          id: "28200",
          name: "Ayotzingo",
          state_id: "2442",
        },
        {
          id: "28201",
          name: "Azcatepec",
          state_id: "2442",
        },
        {
          id: "28202",
          name: "Balderas",
          state_id: "2442",
        },
        {
          id: "28203",
          name: "Bocanegra",
          state_id: "2442",
        },
        {
          id: "28204",
          name: "Boreje",
          state_id: "2442",
        },
        {
          id: "28205",
          name: "Buenavista",
          state_id: "2442",
        },
        {
          id: "28206",
          name: "Cacalomacan",
          state_id: "2442",
        },
        {
          id: "28207",
          name: "Cahuacan",
          state_id: "2442",
        },
        {
          id: "28208",
          name: "Calimaya",
          state_id: "2442",
        },
        {
          id: "28209",
          name: "Calixtlahuaca",
          state_id: "2442",
        },
        {
          id: "28210",
          name: "Capulhuac",
          state_id: "2442",
        },
        {
          id: "28211",
          name: "Carbon",
          state_id: "2442",
        },
        {
          id: "28212",
          name: "Cautzingo",
          state_id: "2442",
        },
        {
          id: "28213",
          name: "Chalco",
          state_id: "2442",
        },
        {
          id: "28214",
          name: "Chapultepec",
          state_id: "2442",
        },
        {
          id: "28215",
          name: "Chiautla",
          state_id: "2442",
        },
        {
          id: "28216",
          name: "Chicoloapan",
          state_id: "2442",
        },
        {
          id: "28217",
          name: "Chiconautla",
          state_id: "2442",
        },
        {
          id: "28218",
          name: "Chiconcuac",
          state_id: "2442",
        },
        {
          id: "28219",
          name: "Chimalhuacan",
          state_id: "2442",
        },
        {
          id: "28220",
          name: "Chimalpa",
          state_id: "2442",
        },
        {
          id: "28221",
          name: "Cholula",
          state_id: "2442",
        },
        {
          id: "28222",
          name: "Citendeje",
          state_id: "2442",
        },
        {
          id: "28223",
          name: "Coacalco",
          state_id: "2442",
        },
        {
          id: "28224",
          name: "Coachochitlan",
          state_id: "2442",
        },
        {
          id: "28225",
          name: "Coacomulco",
          state_id: "2442",
        },
        {
          id: "28226",
          name: "Coapango",
          state_id: "2442",
        },
        {
          id: "28227",
          name: "Coatepec",
          state_id: "2442",
        },
        {
          id: "28228",
          name: "Coatepec Harinas",
          state_id: "2442",
        },
        {
          id: "28229",
          name: "Coatlinchan",
          state_id: "2442",
        },
        {
          id: "28230",
          name: "Cocotitlan",
          state_id: "2442",
        },
        {
          id: "28231",
          name: "Colorines",
          state_id: "2442",
        },
        {
          id: "28232",
          name: "Concepcion Jolalpan",
          state_id: "2442",
        },
        {
          id: "28233",
          name: "Coyotepec",
          state_id: "2442",
        },
        {
          id: "28234",
          name: "Cuauhtemoc",
          state_id: "2442",
        },
        {
          id: "28235",
          name: "Cuauhtenco",
          state_id: "2442",
        },
        {
          id: "28236",
          name: "Cuautitlan",
          state_id: "2442",
        },
        {
          id: "28237",
          name: "Cuautitlan Izcalli",
          state_id: "2442",
        },
        {
          id: "28238",
          name: "Cuautlalpan",
          state_id: "2442",
        },
        {
          id: "28239",
          name: "Cuaxustenco",
          state_id: "2442",
        },
        {
          id: "28240",
          name: "Cuexontitlan",
          state_id: "2442",
        },
        {
          id: "28241",
          name: "Cuijingo",
          state_id: "2442",
        },
        {
          id: "28242",
          name: "Ecatepec",
          state_id: "2442",
        },
        {
          id: "28243",
          name: "Ecatzingo",
          state_id: "2442",
        },
        {
          id: "28244",
          name: "Ejido Cahuacan",
          state_id: "2442",
        },
        {
          id: "28245",
          name: "Ejido Veinte de Noviembre la C",
          state_id: "2442",
        },
        {
          id: "28246",
          name: "Ejido de la Y Seccion Siete a",
          state_id: "2442",
        },
        {
          id: "28247",
          name: "El Coporo",
          state_id: "2442",
        },
        {
          id: "28248",
          name: "El Oro",
          state_id: "2442",
        },
        {
          id: "28249",
          name: "Enchisi",
          state_id: "2442",
        },
        {
          id: "28250",
          name: "Enthavi",
          state_id: "2442",
        },
        {
          id: "28251",
          name: "Fuentes del Valle",
          state_id: "2442",
        },
        {
          id: "28252",
          name: "Huehuetoca",
          state_id: "2442",
        },
        {
          id: "28253",
          name: "Huexoculco",
          state_id: "2442",
        },
        {
          id: "28254",
          name: "Hueypoxtla",
          state_id: "2442",
        },
        {
          id: "28255",
          name: "Huilango",
          state_id: "2442",
        },
        {
          id: "28256",
          name: "Huitzilzingo",
          state_id: "2442",
        },
        {
          id: "28257",
          name: "Huixquilucan",
          state_id: "2442",
        },
        {
          id: "28258",
          name: "Huixquilucan de Degollado",
          state_id: "2442",
        },
        {
          id: "28259",
          name: "Huixtoco",
          state_id: "2442",
        },
        {
          id: "28260",
          name: "Ixlahuaca",
          state_id: "2442",
        },
        {
          id: "28261",
          name: "Ixtacalco",
          state_id: "2442",
        },
        {
          id: "28262",
          name: "Ixtapaluca",
          state_id: "2442",
        },
        {
          id: "28263",
          name: "Ixtapan",
          state_id: "2442",
        },
        {
          id: "28264",
          name: "Ixtlahuatzingo",
          state_id: "2442",
        },
        {
          id: "28265",
          name: "Jajalpa",
          state_id: "2442",
        },
        {
          id: "28266",
          name: "Jaltenco",
          state_id: "2442",
        },
        {
          id: "28267",
          name: "Jaltepec",
          state_id: "2442",
        },
        {
          id: "28268",
          name: "Jesus del Monte",
          state_id: "2442",
        },
        {
          id: "28269",
          name: "Jicaltepec Autopan",
          state_id: "2442",
        },
        {
          id: "28270",
          name: "Jilotepec",
          state_id: "2442",
        },
        {
          id: "28271",
          name: "Jilotzingo",
          state_id: "2442",
        },
        {
          id: "28272",
          name: "Jocotitlan",
          state_id: "2442",
        },
        {
          id: "28273",
          name: "Joquicingo",
          state_id: "2442",
        },
        {
          id: "28274",
          name: "Jorge Jimenez Cantu",
          state_id: "2442",
        },
        {
          id: "28275",
          name: "Juchitepec",
          state_id: "2442",
        },
        {
          id: "28276",
          name: "La Concepcion los Banos",
          state_id: "2442",
        },
        {
          id: "28277",
          name: "La Constitucion",
          state_id: "2442",
        },
        {
          id: "28278",
          name: "La Magdalema",
          state_id: "2442",
        },
        {
          id: "28279",
          name: "Lerma",
          state_id: "2442",
        },
        {
          id: "28280",
          name: "Loma de Juarez",
          state_id: "2442",
        },
        {
          id: "28281",
          name: "Lomas de Zacamulpa",
          state_id: "2442",
        },
        {
          id: "28282",
          name: "Lopez Mateos",
          state_id: "2442",
        },
        {
          id: "28283",
          name: "Los Esparragos",
          state_id: "2442",
        },
        {
          id: "28284",
          name: "Los Reyes",
          state_id: "2442",
        },
        {
          id: "28285",
          name: "Los Reyes Acozac",
          state_id: "2442",
        },
        {
          id: "28286",
          name: "Luvianos",
          state_id: "2442",
        },
        {
          id: "28287",
          name: "Malinalco",
          state_id: "2442",
        },
        {
          id: "28288",
          name: "Melchor Ocampo",
          state_id: "2442",
        },
        {
          id: "28289",
          name: "Metepec",
          state_id: "2442",
        },
        {
          id: "28290",
          name: "Mexicaltzingo",
          state_id: "2442",
        },
        {
          id: "28291",
          name: "Mextepec",
          state_id: "2442",
        },
        {
          id: "28292",
          name: "Montecillo",
          state_id: "2442",
        },
        {
          id: "28293",
          name: "Nativitas",
          state_id: "2442",
        },
        {
          id: "28294",
          name: "Naucalpan",
          state_id: "2442",
        },
        {
          id: "28295",
          name: "Nexquipayac",
          state_id: "2442",
        },
        {
          id: "28296",
          name: "Nextlalpan",
          state_id: "2442",
        },
        {
          id: "28297",
          name: "Nezahualcoyotl",
          state_id: "2442",
        },
        {
          id: "28298",
          name: "Nicolas Romero",
          state_id: "2442",
        },
        {
          id: "28299",
          name: "Nopaltepec",
          state_id: "2442",
        },
        {
          id: "28300",
          name: "Ocotitlan",
          state_id: "2442",
        },
        {
          id: "28301",
          name: "Ocotlan",
          state_id: "2442",
        },
        {
          id: "28302",
          name: "Ocoyoacac",
          state_id: "2442",
        },
        {
          id: "28303",
          name: "Ojo de Agua",
          state_id: "2442",
        },
        {
          id: "28304",
          name: "Otumba",
          state_id: "2442",
        },
        {
          id: "28305",
          name: "Otzacatipan",
          state_id: "2442",
        },
        {
          id: "28306",
          name: "Oyamel",
          state_id: "2442",
        },
        {
          id: "28307",
          name: "Oztolotepec",
          state_id: "2442",
        },
        {
          id: "28308",
          name: "Ozumba",
          state_id: "2442",
        },
        {
          id: "28309",
          name: "Papalotla",
          state_id: "2442",
        },
        {
          id: "28310",
          name: "Progreso Industrial",
          state_id: "2442",
        },
        {
          id: "28311",
          name: "Pueblo Nuevo",
          state_id: "2442",
        },
        {
          id: "28312",
          name: "Rayon",
          state_id: "2442",
        },
        {
          id: "28313",
          name: "Rio Frio",
          state_id: "2442",
        },
        {
          id: "28314",
          name: "Salitrillo",
          state_id: "2442",
        },
        {
          id: "28315",
          name: "San Antonio Buenavista",
          state_id: "2442",
        },
        {
          id: "28316",
          name: "San Antonio La Isla",
          state_id: "2442",
        },
        {
          id: "28317",
          name: "San Bartolo",
          state_id: "2442",
        },
        {
          id: "28318",
          name: "San Bartolo del Llano",
          state_id: "2442",
        },
        {
          id: "28319",
          name: "San Bernardino",
          state_id: "2442",
        },
        {
          id: "28320",
          name: "San Buenaventura",
          state_id: "2442",
        },
        {
          id: "28321",
          name: "San Felipe del Progreso",
          state_id: "2442",
        },
        {
          id: "28322",
          name: "San Jeronimo",
          state_id: "2442",
        },
        {
          id: "28323",
          name: "San Jose Guadalupe",
          state_id: "2442",
        },
        {
          id: "28324",
          name: "San Jose el Vidrio",
          state_id: "2442",
        },
        {
          id: "28325",
          name: "San Juan Tilapa",
          state_id: "2442",
        },
        {
          id: "28326",
          name: "San Juan de las Huertas",
          state_id: "2442",
        },
        {
          id: "28327",
          name: "San Juan y San Pedro Tezompa",
          state_id: "2442",
        },
        {
          id: "28328",
          name: "San Lorenzo Cuauhtenco",
          state_id: "2442",
        },
        {
          id: "28329",
          name: "San Martin de las Piramides",
          state_id: "2442",
        },
        {
          id: "28330",
          name: "San Miguel la Labor",
          state_id: "2442",
        },
        {
          id: "28331",
          name: "San Nicolas Guadalupe",
          state_id: "2442",
        },
        {
          id: "28332",
          name: "San Nicolas Tolentino",
          state_id: "2442",
        },
        {
          id: "28333",
          name: "San Pablo de las Salinas",
          state_id: "2442",
        },
        {
          id: "28334",
          name: "San Pedro Abajo",
          state_id: "2442",
        },
        {
          id: "28335",
          name: "San Pedro Arriba",
          state_id: "2442",
        },
        {
          id: "28336",
          name: "San Pedro el Alto",
          state_id: "2442",
        },
        {
          id: "28337",
          name: "San Pedro los Banos",
          state_id: "2442",
        },
        {
          id: "28338",
          name: "San Simon de la Laguna",
          state_id: "2442",
        },
        {
          id: "28339",
          name: "Santa Catarina del Monte",
          state_id: "2442",
        },
        {
          id: "28340",
          name: "Santa Cruz del Monte",
          state_id: "2442",
        },
        {
          id: "28341",
          name: "Santa Gertrudis",
          state_id: "2442",
        },
        {
          id: "28342",
          name: "Santa Maria del Monte",
          state_id: "2442",
        },
        {
          id: "28343",
          name: "Santo Domingo de Guzman",
          state_id: "2442",
        },
        {
          id: "28344",
          name: "Soyaniquilpan",
          state_id: "2442",
        },
        {
          id: "28345",
          name: "Sultepec",
          state_id: "2442",
        },
        {
          id: "28346",
          name: "Tecalco",
          state_id: "2442",
        },
        {
          id: "28347",
          name: "Tecamac",
          state_id: "2442",
        },
        {
          id: "28348",
          name: "Techuchulco",
          state_id: "2442",
        },
        {
          id: "28349",
          name: "Tecuahutitlan",
          state_id: "2442",
        },
        {
          id: "28350",
          name: "Tehuixtitlan",
          state_id: "2442",
        },
        {
          id: "28351",
          name: "Tejupilco",
          state_id: "2442",
        },
        {
          id: "28352",
          name: "Temamatla",
          state_id: "2442",
        },
        {
          id: "28353",
          name: "Temascalapa",
          state_id: "2442",
        },
        {
          id: "28355",
          name: "Temoaya",
          state_id: "2442",
        },
        {
          id: "28356",
          name: "Tenancingo",
          state_id: "2442",
        },
        {
          id: "28357",
          name: "Tenango de Arista",
          state_id: "2442",
        },
        {
          id: "28358",
          name: "Tenango del Aire",
          state_id: "2442",
        },
        {
          id: "28359",
          name: "Tenochtitlan",
          state_id: "2442",
        },
        {
          id: "28360",
          name: "Teoloyucan",
          state_id: "2442",
        },
        {
          id: "28361",
          name: "Teotihuacan",
          state_id: "2442",
        },
        {
          id: "28362",
          name: "Tepeolulco",
          state_id: "2442",
        },
        {
          id: "28363",
          name: "Tepetitlan",
          state_id: "2442",
        },
        {
          id: "28364",
          name: "Tepetlaoxtoc",
          state_id: "2442",
        },
        {
          id: "28365",
          name: "Tepetlixpa",
          state_id: "2442",
        },
        {
          id: "28366",
          name: "Tepexpan",
          state_id: "2442",
        },
        {
          id: "28367",
          name: "Tepotzotlan",
          state_id: "2442",
        },
        {
          id: "28368",
          name: "Tequexquinahuac",
          state_id: "2442",
        },
        {
          id: "28369",
          name: "Tequisistlan",
          state_id: "2442",
        },
        {
          id: "28370",
          name: "Tequixquiac",
          state_id: "2442",
        },
        {
          id: "28371",
          name: "Texcalyacac",
          state_id: "2442",
        },
        {
          id: "28372",
          name: "Texcoco",
          state_id: "2442",
        },
        {
          id: "28373",
          name: "Teyahualco",
          state_id: "2442",
        },
        {
          id: "28374",
          name: "Tezoquipan",
          state_id: "2442",
        },
        {
          id: "28375",
          name: "Tezoyuca",
          state_id: "2442",
        },
        {
          id: "28376",
          name: "Tianguistenco",
          state_id: "2442",
        },
        {
          id: "28377",
          name: "Tilapa",
          state_id: "2442",
        },
        {
          id: "28378",
          name: "Tlachaloya Segunda Seccion",
          state_id: "2442",
        },
        {
          id: "28379",
          name: "Tlachihualpa",
          state_id: "2442",
        },
        {
          id: "28380",
          name: "Tlacotepec",
          state_id: "2442",
        },
        {
          id: "28381",
          name: "Tlahuelilpan",
          state_id: "2442",
        },
        {
          id: "28382",
          name: "Tlaixpan",
          state_id: "2442",
        },
        {
          id: "28383",
          name: "Tlalcilalcalli",
          state_id: "2442",
        },
        {
          id: "28384",
          name: "Tlalcilalcalpan",
          state_id: "2442",
        },
        {
          id: "28385",
          name: "Tlalmanalco",
          state_id: "2442",
        },
        {
          id: "28386",
          name: "Tlalmimilolpan",
          state_id: "2442",
        },
        {
          id: "28387",
          name: "Tlalnepantla",
          state_id: "2442",
        },
        {
          id: "28388",
          name: "Tlaltelulco",
          state_id: "2442",
        },
        {
          id: "28389",
          name: "Tlaltizapan",
          state_id: "2442",
        },
        {
          id: "28390",
          name: "Tlanisco",
          state_id: "2442",
        },
        {
          id: "28391",
          name: "Toluca",
          state_id: "2442",
        },
        {
          id: "28392",
          name: "Tonanitla",
          state_id: "2442",
        },
        {
          id: "28393",
          name: "Tonatico",
          state_id: "2442",
        },
        {
          id: "28394",
          name: "Totocuitlapilco",
          state_id: "2442",
        },
        {
          id: "28395",
          name: "Totoltepec",
          state_id: "2442",
        },
        {
          id: "28396",
          name: "Tulantongo",
          state_id: "2442",
        },
        {
          id: "28397",
          name: "Tultepec",
          state_id: "2442",
        },
        {
          id: "28398",
          name: "Tultitlan",
          state_id: "2442",
        },
        {
          id: "28399",
          name: "Valle de Bravo",
          state_id: "2442",
        },
        {
          id: "28400",
          name: "Victoria",
          state_id: "2442",
        },
        {
          id: "28401",
          name: "Villa Guerrero",
          state_id: "2442",
        },
        {
          id: "28402",
          name: "Vista Hermosa",
          state_id: "2442",
        },
        {
          id: "28403",
          name: "Xalatlaco",
          state_id: "2442",
        },
        {
          id: "28404",
          name: "Xalpa",
          state_id: "2442",
        },
        {
          id: "28405",
          name: "Xico",
          state_id: "2442",
        },
        {
          id: "28406",
          name: "Xochimanca",
          state_id: "2442",
        },
        {
          id: "28407",
          name: "Xolalpa",
          state_id: "2442",
        },
        {
          id: "28408",
          name: "Xoloc",
          state_id: "2442",
        },
        {
          id: "28409",
          name: "Xometla",
          state_id: "2442",
        },
        {
          id: "28410",
          name: "Xonacatlan",
          state_id: "2442",
        },
        {
          id: "28411",
          name: "Yachihuacaltepec",
          state_id: "2442",
        },
        {
          id: "28412",
          name: "Yancuitlalpan",
          state_id: "2442",
        },
        {
          id: "28413",
          name: "Zacacalco",
          state_id: "2442",
        },
        {
          id: "28414",
          name: "Zacamulpa",
          state_id: "2442",
        },
        {
          id: "28415",
          name: "Zacualpan",
          state_id: "2442",
        },
        {
          id: "28416",
          name: "Zaragoza",
          state_id: "2442",
        },
        {
          id: "28417",
          name: "Zictepec",
          state_id: "2442",
        },
        {
          id: "28418",
          name: "Zinacantepec",
          state_id: "2442",
        },
        {
          id: "28419",
          name: "Zolotepec",
          state_id: "2442",
        },
        {
          id: "28420",
          name: "Zumpahuacan",
          state_id: "2442",
        },
        {
          id: "28421",
          name: "Zumpango",
          state_id: "2442",
        },
      ],
      Michoacan: [
        {
          id: "28422",
          name: "Acuitzio",
          state_id: "2443",
        },
        {
          id: "28423",
          name: "Aguililla",
          state_id: "2443",
        },
        {
          id: "28424",
          name: "Alvaro Obregon",
          state_id: "2443",
        },
        {
          id: "28425",
          name: "Angahuan",
          state_id: "2443",
        },
        {
          id: "28426",
          name: "Angamacutiro",
          state_id: "2443",
        },
        {
          id: "28427",
          name: "Angangueo",
          state_id: "2443",
        },
        {
          id: "28428",
          name: "Antunez",
          state_id: "2443",
        },
        {
          id: "28429",
          name: "Apatzingan",
          state_id: "2443",
        },
        {
          id: "28430",
          name: "Ario",
          state_id: "2443",
        },
        {
          id: "28431",
          name: "Arteaga",
          state_id: "2443",
        },
        {
          id: "28432",
          name: "Benito Juarez",
          state_id: "2443",
        },
        {
          id: "28433",
          name: "Brisenas",
          state_id: "2443",
        },
        {
          id: "28434",
          name: "Buenavista",
          state_id: "2443",
        },
        {
          id: "28435",
          name: "Buenos Aires",
          state_id: "2443",
        },
        {
          id: "28436",
          name: "Caltzontzin",
          state_id: "2443",
        },
        {
          id: "28437",
          name: "Capacuaro",
          state_id: "2443",
        },
        {
          id: "28438",
          name: "Capula",
          state_id: "2443",
        },
        {
          id: "28439",
          name: "Caracuaro",
          state_id: "2443",
        },
        {
          id: "28440",
          name: "Charapan",
          state_id: "2443",
        },
        {
          id: "28441",
          name: "Charo",
          state_id: "2443",
        },
        {
          id: "28442",
          name: "Chavinda",
          state_id: "2443",
        },
        {
          id: "28443",
          name: "Cheran",
          state_id: "2443",
        },
        {
          id: "28444",
          name: "Chilchota",
          state_id: "2443",
        },
        {
          id: "28445",
          name: "Churintzio",
          state_id: "2443",
        },
        {
          id: "28446",
          name: "Churumuco",
          state_id: "2443",
        },
        {
          id: "28447",
          name: "Coahuayana",
          state_id: "2443",
        },
        {
          id: "28448",
          name: "Coalcoman",
          state_id: "2443",
        },
        {
          id: "28449",
          name: "Coeneo",
          state_id: "2443",
        },
        {
          id: "28450",
          name: "Cojumatlan",
          state_id: "2443",
        },
        {
          id: "28451",
          name: "Comachuen",
          state_id: "2443",
        },
        {
          id: "28452",
          name: "Contepec",
          state_id: "2443",
        },
        {
          id: "28453",
          name: "Copandaro",
          state_id: "2443",
        },
        {
          id: "28454",
          name: "Cotija",
          state_id: "2443",
        },
        {
          id: "28455",
          name: "Cuanajo",
          state_id: "2443",
        },
        {
          id: "28456",
          name: "Cuitareo",
          state_id: "2443",
        },
        {
          id: "28457",
          name: "Cuitzeo",
          state_id: "2443",
        },
        {
          id: "28458",
          name: "Ecuandureo",
          state_id: "2443",
        },
        {
          id: "28459",
          name: "Hidalgo",
          state_id: "2443",
        },
        {
          id: "28460",
          name: "Huandacareo",
          state_id: "2443",
        },
        {
          id: "28461",
          name: "Huetamo",
          state_id: "2443",
        },
        {
          id: "28462",
          name: "Indaparapeo",
          state_id: "2443",
        },
        {
          id: "28463",
          name: "Irimbo",
          state_id: "2443",
        },
        {
          id: "28464",
          name: "Ixtlan",
          state_id: "2443",
        },
        {
          id: "28465",
          name: "Jacona",
          state_id: "2443",
        },
        {
          id: "28466",
          name: "Jiquilpan",
          state_id: "2443",
        },
        {
          id: "28467",
          name: "Jungapeo",
          state_id: "2443",
        },
        {
          id: "28468",
          name: "La Huacana",
          state_id: "2443",
        },
        {
          id: "28469",
          name: "La Mira",
          state_id: "2443",
        },
        {
          id: "28470",
          name: "La Orilla",
          state_id: "2443",
        },
        {
          id: "28471",
          name: "La Piedad",
          state_id: "2443",
        },
        {
          id: "28472",
          name: "La Ruana",
          state_id: "2443",
        },
        {
          id: "28473",
          name: "Las Guacamayas",
          state_id: "2443",
        },
        {
          id: "28474",
          name: "Lazaro Cardenas",
          state_id: "2443",
        },
        {
          id: "28475",
          name: "Lombardia",
          state_id: "2443",
        },
        {
          id: "28476",
          name: "Los Reyes",
          state_id: "2443",
        },
        {
          id: "28477",
          name: "Madero",
          state_id: "2443",
        },
        {
          id: "28478",
          name: "Maravatio",
          state_id: "2443",
        },
        {
          id: "28479",
          name: "Maya",
          state_id: "2443",
        },
        {
          id: "28480",
          name: "Morelia",
          state_id: "2443",
        },
        {
          id: "28481",
          name: "Morelos",
          state_id: "2443",
        },
        {
          id: "28482",
          name: "Nahuatzen",
          state_id: "2443",
        },
        {
          id: "28483",
          name: "Nocupetaro",
          state_id: "2443",
        },
        {
          id: "28484",
          name: "Nueva Italia de Ruiz",
          state_id: "2443",
        },
        {
          id: "28485",
          name: "Nuevo San Juan Parangaricutiro",
          state_id: "2443",
        },
        {
          id: "28486",
          name: "Numaran",
          state_id: "2443",
        },
        {
          id: "28487",
          name: "Ocampo",
          state_id: "2443",
        },
        {
          id: "28488",
          name: "Opopeo",
          state_id: "2443",
        },
        {
          id: "28489",
          name: "Pajacuaran",
          state_id: "2443",
        },
        {
          id: "28490",
          name: "Panindicuaro",
          state_id: "2443",
        },
        {
          id: "28491",
          name: "Paracho",
          state_id: "2443",
        },
        {
          id: "28492",
          name: "Paracuaro",
          state_id: "2443",
        },
        {
          id: "28493",
          name: "Pastor Ortiz",
          state_id: "2443",
        },
        {
          id: "28494",
          name: "Patzcuaro",
          state_id: "2443",
        },
        {
          id: "28495",
          name: "Pedernales",
          state_id: "2443",
        },
        {
          id: "28496",
          name: "Penjamillo",
          state_id: "2443",
        },
        {
          id: "28497",
          name: "Periban",
          state_id: "2443",
        },
        {
          id: "28498",
          name: "Pichataro",
          state_id: "2443",
        },
        {
          id: "28499",
          name: "Purepero",
          state_id: "2443",
        },
        {
          id: "28500",
          name: "Puruandiro",
          state_id: "2443",
        },
        {
          id: "28501",
          name: "Puruaran",
          state_id: "2443",
        },
        {
          id: "28502",
          name: "Querendaro",
          state_id: "2443",
        },
        {
          id: "28503",
          name: "Quiroga",
          state_id: "2443",
        },
        {
          id: "28504",
          name: "Rincon de Nicolas Romero",
          state_id: "2443",
        },
        {
          id: "28505",
          name: "Riva Palacio",
          state_id: "2443",
        },
        {
          id: "28506",
          name: "Sahuayo",
          state_id: "2443",
        },
        {
          id: "28507",
          name: "San Jose de Gracia",
          state_id: "2443",
        },
        {
          id: "28508",
          name: "San Lucas",
          state_id: "2443",
        },
        {
          id: "28509",
          name: "San Matias Grande",
          state_id: "2443",
        },
        {
          id: "28510",
          name: "Santa Clara de Valladares",
          state_id: "2443",
        },
        {
          id: "28511",
          name: "Santa Clara del Cobre",
          state_id: "2443",
        },
        {
          id: "28512",
          name: "Santa Fe de la Laguna",
          state_id: "2443",
        },
        {
          id: "28513",
          name: "Tacambaro",
          state_id: "2443",
        },
        {
          id: "28514",
          name: "Tancitaro",
          state_id: "2443",
        },
        {
          id: "28515",
          name: "Tangamandapio",
          state_id: "2443",
        },
        {
          id: "28516",
          name: "Tangancicuaro",
          state_id: "2443",
        },
        {
          id: "28517",
          name: "Tanhuato",
          state_id: "2443",
        },
        {
          id: "28518",
          name: "Tarecuato",
          state_id: "2443",
        },
        {
          id: "28519",
          name: "Taretan",
          state_id: "2443",
        },
        {
          id: "28520",
          name: "Tarimbaro",
          state_id: "2443",
        },
        {
          id: "28521",
          name: "Tejaro",
          state_id: "2443",
        },
        {
          id: "28522",
          name: "Tepalcatepec",
          state_id: "2443",
        },
        {
          id: "28523",
          name: "Tingambato",
          state_id: "2443",
        },
        {
          id: "28524",
          name: "Tinguindin",
          state_id: "2443",
        },
        {
          id: "28525",
          name: "Tiquicheo",
          state_id: "2443",
        },
        {
          id: "28526",
          name: "Tlalpujahua",
          state_id: "2443",
        },
        {
          id: "28527",
          name: "Tlazazalca",
          state_id: "2443",
        },
        {
          id: "28528",
          name: "Tungareo",
          state_id: "2443",
        },
        {
          id: "28529",
          name: "Tuxpan",
          state_id: "2443",
        },
        {
          id: "28530",
          name: "Tzintzuntzan",
          state_id: "2443",
        },
        {
          id: "28531",
          name: "Uruapan",
          state_id: "2443",
        },
        {
          id: "28532",
          name: "Venustiano Carranza",
          state_id: "2443",
        },
        {
          id: "28533",
          name: "Villa Jimenez",
          state_id: "2443",
        },
        {
          id: "28534",
          name: "Villachuato",
          state_id: "2443",
        },
        {
          id: "28535",
          name: "Villamar",
          state_id: "2443",
        },
        {
          id: "28536",
          name: "Vista Hermosa",
          state_id: "2443",
        },
        {
          id: "28537",
          name: "Yurecuaro",
          state_id: "2443",
        },
        {
          id: "28538",
          name: "Zacapu",
          state_id: "2443",
        },
        {
          id: "28539",
          name: "Zamora",
          state_id: "2443",
        },
        {
          id: "28540",
          name: "Zinapecuaro",
          state_id: "2443",
        },
        {
          id: "28541",
          name: "Zitacuaro",
          state_id: "2443",
        },
      ],
      Morelos: [
        {
          id: "28542",
          name: "Alpuyeca",
          state_id: "2444",
        },
        {
          id: "28543",
          name: "Amacuzac",
          state_id: "2444",
        },
        {
          id: "28544",
          name: "Amayuca",
          state_id: "2444",
        },
        {
          id: "28545",
          name: "Anenecuilco",
          state_id: "2444",
        },
        {
          id: "28546",
          name: "Apatlaco",
          state_id: "2444",
        },
        {
          id: "28547",
          name: "Atlatlahucan",
          state_id: "2444",
        },
        {
          id: "28548",
          name: "Axochiapan",
          state_id: "2444",
        },
        {
          id: "28549",
          name: "Ayala",
          state_id: "2444",
        },
        {
          id: "28550",
          name: "Calera Chica",
          state_id: "2444",
        },
        {
          id: "28551",
          name: "Chiconcuac",
          state_id: "2444",
        },
        {
          id: "28552",
          name: "Coatetelco",
          state_id: "2444",
        },
        {
          id: "28553",
          name: "Cocoyoc",
          state_id: "2444",
        },
        {
          id: "28554",
          name: "Cuautla",
          state_id: "2444",
        },
        {
          id: "28555",
          name: "Cuernavaca",
          state_id: "2444",
        },
        {
          id: "28556",
          name: "Emiliano Zapata",
          state_id: "2444",
        },
        {
          id: "28557",
          name: "Higueron",
          state_id: "2444",
        },
        {
          id: "28558",
          name: "Hueyapan",
          state_id: "2444",
        },
        {
          id: "28559",
          name: "Huiztilac",
          state_id: "2444",
        },
        {
          id: "28560",
          name: "Independencia",
          state_id: "2444",
        },
        {
          id: "28561",
          name: "Jantetelco",
          state_id: "2444",
        },
        {
          id: "28562",
          name: "Jiutepec",
          state_id: "2444",
        },
        {
          id: "28563",
          name: "Jojutla",
          state_id: "2444",
        },
        {
          id: "28564",
          name: "Jonacatepec",
          state_id: "2444",
        },
        {
          id: "28565",
          name: "Juan Morales",
          state_id: "2444",
        },
        {
          id: "28566",
          name: "La Joya",
          state_id: "2444",
        },
        {
          id: "28567",
          name: "Los Arcos",
          state_id: "2444",
        },
        {
          id: "28568",
          name: "Mazatepec",
          state_id: "2444",
        },
        {
          id: "28569",
          name: "Miacatlan",
          state_id: "2444",
        },
        {
          id: "28570",
          name: "Oaxtepec",
          state_id: "2444",
        },
        {
          id: "28571",
          name: "Ocuituco",
          state_id: "2444",
        },
        {
          id: "28572",
          name: "Pedro Amaro",
          state_id: "2444",
        },
        {
          id: "28573",
          name: "Progreso",
          state_id: "2444",
        },
        {
          id: "28574",
          name: "Puente de Ixtla",
          state_id: "2444",
        },
        {
          id: "28575",
          name: "San Jose Vista Hermosa",
          state_id: "2444",
        },
        {
          id: "28576",
          name: "San Nicolas Galeana",
          state_id: "2444",
        },
        {
          id: "28577",
          name: "Santa Catarina",
          state_id: "2444",
        },
        {
          id: "28578",
          name: "Santa Rosa Treinta",
          state_id: "2444",
        },
        {
          id: "28579",
          name: "Tehuixtla",
          state_id: "2444",
        },
        {
          id: "28580",
          name: "Telixtac",
          state_id: "2444",
        },
        {
          id: "28581",
          name: "Temixco",
          state_id: "2444",
        },
        {
          id: "28582",
          name: "Temoac",
          state_id: "2444",
        },
        {
          id: "28583",
          name: "Tenextepango",
          state_id: "2444",
        },
        {
          id: "28584",
          name: "Tepalcingo",
          state_id: "2444",
        },
        {
          id: "28585",
          name: "Tepoztlan",
          state_id: "2444",
        },
        {
          id: "28586",
          name: "Tetecala",
          state_id: "2444",
        },
        {
          id: "28587",
          name: "Tetela del Volcan",
          state_id: "2444",
        },
        {
          id: "28588",
          name: "Tilzapotla",
          state_id: "2444",
        },
        {
          id: "28589",
          name: "Tlacotepec",
          state_id: "2444",
        },
        {
          id: "28590",
          name: "Tlalnepantla",
          state_id: "2444",
        },
        {
          id: "28591",
          name: "Tlaltizapan",
          state_id: "2444",
        },
        {
          id: "28592",
          name: "Tlaquiltenango",
          state_id: "2444",
        },
        {
          id: "28593",
          name: "Tlatenchi",
          state_id: "2444",
        },
        {
          id: "28594",
          name: "Tlayacapan",
          state_id: "2444",
        },
        {
          id: "28595",
          name: "Totolapan",
          state_id: "2444",
        },
        {
          id: "28596",
          name: "Tres Marias",
          state_id: "2444",
        },
        {
          id: "28597",
          name: "Unidad Habitacional Jose Maria",
          state_id: "2444",
        },
        {
          id: "28598",
          name: "Xochitepec",
          state_id: "2444",
        },
        {
          id: "28599",
          name: "Xoxocotla",
          state_id: "2444",
        },
        {
          id: "28600",
          name: "Yautepec",
          state_id: "2444",
        },
        {
          id: "28601",
          name: "Yecapixtla",
          state_id: "2444",
        },
        {
          id: "28602",
          name: "Zacatepec",
          state_id: "2444",
        },
        {
          id: "28603",
          name: "Zacualpan",
          state_id: "2444",
        },
      ],
      Nayarit: [
        {
          id: "28604",
          name: "Acaponeta",
          state_id: "2445",
        },
        {
          id: "28605",
          name: "Ahuacatlan",
          state_id: "2445",
        },
        {
          id: "28606",
          name: "Amatlan",
          state_id: "2445",
        },
        {
          id: "28607",
          name: "Aztatan",
          state_id: "2445",
        },
        {
          id: "28608",
          name: "Bucerias",
          state_id: "2445",
        },
        {
          id: "28609",
          name: "Carmen",
          state_id: "2445",
        },
        {
          id: "28610",
          name: "Cerralvo",
          state_id: "2445",
        },
        {
          id: "28611",
          name: "Compostela",
          state_id: "2445",
        },
        {
          id: "28612",
          name: "Hidalgo",
          state_id: "2445",
        },
        {
          id: "28613",
          name: "Ixcuintla",
          state_id: "2445",
        },
        {
          id: "28614",
          name: "Ixtlan del Rio",
          state_id: "2445",
        },
        {
          id: "28615",
          name: "Jala",
          state_id: "2445",
        },
        {
          id: "28616",
          name: "Jalcocotan",
          state_id: "2445",
        },
        {
          id: "28617",
          name: "La Penita de Jaltemba",
          state_id: "2445",
        },
        {
          id: "28618",
          name: "La Presa",
          state_id: "2445",
        },
        {
          id: "28619",
          name: "Lagunillas",
          state_id: "2445",
        },
        {
          id: "28620",
          name: "Las Jarretaderas",
          state_id: "2445",
        },
        {
          id: "28621",
          name: "Las Varas",
          state_id: "2445",
        },
        {
          id: "28622",
          name: "Puga",
          state_id: "2445",
        },
        {
          id: "28623",
          name: "Rosamorada",
          state_id: "2445",
        },
        {
          id: "28624",
          name: "Ruiz",
          state_id: "2445",
        },
        {
          id: "28625",
          name: "San Blas",
          state_id: "2445",
        },
        {
          id: "28626",
          name: "San Jose del Valle",
          state_id: "2445",
        },
        {
          id: "28627",
          name: "San Juan de Abajo",
          state_id: "2445",
        },
        {
          id: "28628",
          name: "San Vicente",
          state_id: "2445",
        },
        {
          id: "28629",
          name: "Santa Maria del Oro",
          state_id: "2445",
        },
        {
          id: "28630",
          name: "Tecuala",
          state_id: "2445",
        },
        {
          id: "28631",
          name: "Tepic",
          state_id: "2445",
        },
        {
          id: "28632",
          name: "Tuxpan",
          state_id: "2445",
        },
        {
          id: "28633",
          name: "Valle de Banderas",
          state_id: "2445",
        },
        {
          id: "28634",
          name: "Xalisco",
          state_id: "2445",
        },
        {
          id: "28635",
          name: "Yago",
          state_id: "2445",
        },
        {
          id: "28636",
          name: "Zacualpan",
          state_id: "2445",
        },
      ],
      "Nuevo Leon": [],
      Oaxaca: [
        {
          id: "28637",
          name: "Acatlan",
          state_id: "2447",
        },
        {
          id: "28638",
          name: "Amatlan",
          state_id: "2447",
        },
        {
          id: "28639",
          name: "Amilpas",
          state_id: "2447",
        },
        {
          id: "28640",
          name: "Amuzgos",
          state_id: "2447",
        },
        {
          id: "28641",
          name: "Asuncion Ixtaltepec",
          state_id: "2447",
        },
        {
          id: "28642",
          name: "Asuncion Nochixtlan",
          state_id: "2447",
        },
        {
          id: "28643",
          name: "Asuncion Ocotlan",
          state_id: "2447",
        },
        {
          id: "28644",
          name: "Atempa",
          state_id: "2447",
        },
        {
          id: "28645",
          name: "Atzompa",
          state_id: "2447",
        },
        {
          id: "28646",
          name: "Ayautla",
          state_id: "2447",
        },
        {
          id: "28647",
          name: "Ayoquezco",
          state_id: "2447",
        },
        {
          id: "28648",
          name: "Ayotzintepec",
          state_id: "2447",
        },
        {
          id: "28649",
          name: "Bajos de Chila",
          state_id: "2447",
        },
        {
          id: "28650",
          name: "Brisas de Zicatela",
          state_id: "2447",
        },
        {
          id: "28651",
          name: "Cacahuatepec",
          state_id: "2447",
        },
        {
          id: "28652",
          name: "Cacaotepec",
          state_id: "2447",
        },
        {
          id: "28653",
          name: "Chahuites",
          state_id: "2447",
        },
        {
          id: "28654",
          name: "Chichicapam",
          state_id: "2447",
        },
        {
          id: "28655",
          name: "Chiltepec",
          state_id: "2447",
        },
        {
          id: "28656",
          name: "Cienaga de Zimatlan",
          state_id: "2447",
        },
        {
          id: "28657",
          name: "Coatlan",
          state_id: "2447",
        },
        {
          id: "28658",
          name: "Comitancillo",
          state_id: "2447",
        },
        {
          id: "28659",
          name: "Cosolapa",
          state_id: "2447",
        },
        {
          id: "28660",
          name: "Coyotepec",
          state_id: "2447",
        },
        {
          id: "28661",
          name: "Crucecita",
          state_id: "2447",
        },
        {
          id: "28662",
          name: "Cuicatlan",
          state_id: "2447",
        },
        {
          id: "28663",
          name: "Cuilapam",
          state_id: "2447",
        },
        {
          id: "28664",
          name: "Ejutla de Crespo",
          state_id: "2447",
        },
        {
          id: "28665",
          name: "El Espinal",
          state_id: "2447",
        },
        {
          id: "28666",
          name: "Etla",
          state_id: "2447",
        },
        {
          id: "28667",
          name: "Fraccionamiento el Rosario",
          state_id: "2447",
        },
        {
          id: "28668",
          name: "Guelavia",
          state_id: "2447",
        },
        {
          id: "28669",
          name: "Guichicovi",
          state_id: "2447",
        },
        {
          id: "28670",
          name: "Huajuapan",
          state_id: "2447",
        },
        {
          id: "28671",
          name: "Huatulco",
          state_id: "2447",
        },
        {
          id: "28672",
          name: "Huautla",
          state_id: "2447",
        },
        {
          id: "28673",
          name: "Huaxpaltepec",
          state_id: "2447",
        },
        {
          id: "28674",
          name: "Huayapam",
          state_id: "2447",
        },
        {
          id: "28675",
          name: "Huazolotitlan",
          state_id: "2447",
        },
        {
          id: "28676",
          name: "Huitzo",
          state_id: "2447",
        },
        {
          id: "28677",
          name: "Huixtepec",
          state_id: "2447",
        },
        {
          id: "28678",
          name: "Ingenio",
          state_id: "2447",
        },
        {
          id: "28679",
          name: "Ixcatlan",
          state_id: "2447",
        },
        {
          id: "28680",
          name: "Ixhuatan",
          state_id: "2447",
        },
        {
          id: "28681",
          name: "Ixtepec",
          state_id: "2447",
        },
        {
          id: "28682",
          name: "Jalapa",
          state_id: "2447",
        },
        {
          id: "28683",
          name: "Jamiltepec",
          state_id: "2447",
        },
        {
          id: "28684",
          name: "Jicayan",
          state_id: "2447",
        },
        {
          id: "28685",
          name: "Juchitan",
          state_id: "2447",
        },
        {
          id: "28686",
          name: "Juquila",
          state_id: "2447",
        },
        {
          id: "28687",
          name: "Juxtlahuaca",
          state_id: "2447",
        },
        {
          id: "28688",
          name: "Loma Bonita",
          state_id: "2447",
        },
        {
          id: "28689",
          name: "Magdalena Teitipac",
          state_id: "2447",
        },
        {
          id: "28690",
          name: "Magdalena Tequisistlan",
          state_id: "2447",
        },
        {
          id: "28691",
          name: "Matatlan",
          state_id: "2447",
        },
        {
          id: "28692",
          name: "Matias Romero",
          state_id: "2447",
        },
        {
          id: "28693",
          name: "Mechoacan",
          state_id: "2447",
        },
        {
          id: "28694",
          name: "Miahuatlan",
          state_id: "2447",
        },
        {
          id: "28695",
          name: "Mitla",
          state_id: "2447",
        },
        {
          id: "28696",
          name: "Mixtepec",
          state_id: "2447",
        },
        {
          id: "28697",
          name: "Mixtequilla",
          state_id: "2447",
        },
        {
          id: "28698",
          name: "Nazareno Etla",
          state_id: "2447",
        },
        {
          id: "28699",
          name: "Niltepec",
          state_id: "2447",
        },
        {
          id: "28700",
          name: "Oaxaca",
          state_id: "2447",
        },
        {
          id: "28701",
          name: "Ocotepec",
          state_id: "2447",
        },
        {
          id: "28702",
          name: "Ocotlan",
          state_id: "2447",
        },
        {
          id: "28703",
          name: "Ojitlan",
          state_id: "2447",
        },
        {
          id: "28704",
          name: "Palomares",
          state_id: "2447",
        },
        {
          id: "28705",
          name: "Panixtlahuaca",
          state_id: "2447",
        },
        {
          id: "28706",
          name: "Petapa",
          state_id: "2447",
        },
        {
          id: "28707",
          name: "Pinotepa Nacional",
          state_id: "2447",
        },
        {
          id: "28708",
          name: "Pinotepa de Don Luis",
          state_id: "2447",
        },
        {
          id: "28709",
          name: "Pochutla",
          state_id: "2447",
        },
        {
          id: "28710",
          name: "Puerto Escondido",
          state_id: "2447",
        },
        {
          id: "28711",
          name: "Putla",
          state_id: "2447",
        },
        {
          id: "28712",
          name: "Quetzaltepec",
          state_id: "2447",
        },
        {
          id: "28713",
          name: "Rincon Viejo",
          state_id: "2447",
        },
        {
          id: "28714",
          name: "Rio Grande",
          state_id: "2447",
        },
        {
          id: "28715",
          name: "Salina Cruz",
          state_id: "2447",
        },
        {
          id: "28716",
          name: "San Agustin de las Juntas",
          state_id: "2447",
        },
        {
          id: "28717",
          name: "San Antonio Castillo Velasco",
          state_id: "2447",
        },
        {
          id: "28718",
          name: "San Antonio de la Cal",
          state_id: "2447",
        },
        {
          id: "28719",
          name: "San Dionisio del Mar",
          state_id: "2447",
        },
        {
          id: "28720",
          name: "San Francisco del Mar",
          state_id: "2447",
        },
        {
          id: "28721",
          name: "San Jose del Progreso",
          state_id: "2447",
        },
        {
          id: "28722",
          name: "San Juan Colorado",
          state_id: "2447",
        },
        {
          id: "28723",
          name: "San Mateo del Mar",
          state_id: "2447",
        },
        {
          id: "28724",
          name: "Santa Lucia del Camino",
          state_id: "2447",
        },
        {
          id: "28725",
          name: "Santa Maria del Tule",
          state_id: "2447",
        },
        {
          id: "28726",
          name: "Santiago Apostol",
          state_id: "2447",
        },
        {
          id: "28727",
          name: "Santos Reyes Nopala",
          state_id: "2447",
        },
        {
          id: "28728",
          name: "Soyaltepec",
          state_id: "2447",
        },
        {
          id: "28729",
          name: "Suchilquitongo",
          state_id: "2447",
        },
        {
          id: "28730",
          name: "Tamazulapam",
          state_id: "2447",
        },
        {
          id: "28731",
          name: "Tapanatepec",
          state_id: "2447",
        },
        {
          id: "28732",
          name: "Tehuantepec",
          state_id: "2447",
        },
        {
          id: "28733",
          name: "Teitipac",
          state_id: "2447",
        },
        {
          id: "28734",
          name: "Telixtlahuaca",
          state_id: "2447",
        },
        {
          id: "28735",
          name: "Teotitlan",
          state_id: "2447",
        },
        {
          id: "28736",
          name: "Teotitlan den Valle",
          state_id: "2447",
        },
        {
          id: "28737",
          name: "Tilquiapam",
          state_id: "2447",
        },
        {
          id: "28738",
          name: "Tlacolula",
          state_id: "2447",
        },
        {
          id: "28739",
          name: "Tlalixtac",
          state_id: "2447",
        },
        {
          id: "28740",
          name: "Tlaxiaco",
          state_id: "2447",
        },
        {
          id: "28741",
          name: "Tutla",
          state_id: "2447",
        },
        {
          id: "28742",
          name: "Tuxtepec",
          state_id: "2447",
        },
        {
          id: "28743",
          name: "Union Hidalgo",
          state_id: "2447",
        },
        {
          id: "28744",
          name: "Usila",
          state_id: "2447",
        },
        {
          id: "28745",
          name: "Valle Nacional",
          state_id: "2447",
        },
        {
          id: "28746",
          name: "Vicente Camalote",
          state_id: "2447",
        },
        {
          id: "28747",
          name: "Vicente Guerrero",
          state_id: "2447",
        },
        {
          id: "28748",
          name: "Xadani",
          state_id: "2447",
        },
        {
          id: "28749",
          name: "Xitla",
          state_id: "2447",
        },
        {
          id: "28750",
          name: "Xoxocotlan",
          state_id: "2447",
        },
        {
          id: "28751",
          name: "Yaitepec",
          state_id: "2447",
        },
        {
          id: "28752",
          name: "Yatareni",
          state_id: "2447",
        },
        {
          id: "28753",
          name: "Zaachila",
          state_id: "2447",
        },
        {
          id: "28754",
          name: "Zacatepec",
          state_id: "2447",
        },
        {
          id: "28755",
          name: "Zanatepec",
          state_id: "2447",
        },
        {
          id: "28756",
          name: "Zimatlan",
          state_id: "2447",
        },
      ],
      Puebla: [
        {
          id: "28757",
          name: "Acajete",
          state_id: "2448",
        },
        {
          id: "28758",
          name: "Acateno",
          state_id: "2448",
        },
        {
          id: "28759",
          name: "Acatlan",
          state_id: "2448",
        },
        {
          id: "28760",
          name: "Acatzingo",
          state_id: "2448",
        },
        {
          id: "28761",
          name: "Actipan",
          state_id: "2448",
        },
        {
          id: "28762",
          name: "Acuexcomac",
          state_id: "2448",
        },
        {
          id: "28763",
          name: "Ahuatempan",
          state_id: "2448",
        },
        {
          id: "28764",
          name: "Ajalpan",
          state_id: "2448",
        },
        {
          id: "28765",
          name: "Aljojuca",
          state_id: "2448",
        },
        {
          id: "28766",
          name: "Almecatla",
          state_id: "2448",
        },
        {
          id: "28767",
          name: "Alseseca",
          state_id: "2448",
        },
        {
          id: "28768",
          name: "Altepexi",
          state_id: "2448",
        },
        {
          id: "28769",
          name: "Amecac",
          state_id: "2448",
        },
        {
          id: "28770",
          name: "Amozoc",
          state_id: "2448",
        },
        {
          id: "28771",
          name: "Aparicio",
          state_id: "2448",
        },
        {
          id: "28772",
          name: "Atempan",
          state_id: "2448",
        },
        {
          id: "28773",
          name: "Atencingo",
          state_id: "2448",
        },
        {
          id: "28774",
          name: "Atlixco",
          state_id: "2448",
        },
        {
          id: "28775",
          name: "Atoyatempan",
          state_id: "2448",
        },
        {
          id: "28776",
          name: "Atzitzintla",
          state_id: "2448",
        },
        {
          id: "28777",
          name: "Atzompa",
          state_id: "2448",
        },
        {
          id: "28778",
          name: "Ayutla",
          state_id: "2448",
        },
        {
          id: "28779",
          name: "Azumiatla",
          state_id: "2448",
        },
        {
          id: "28780",
          name: "Benito Juarez",
          state_id: "2448",
        },
        {
          id: "28781",
          name: "Buenos Aires",
          state_id: "2448",
        },
        {
          id: "28782",
          name: "Cacaloxuchitl",
          state_id: "2448",
        },
        {
          id: "28783",
          name: "Calipan",
          state_id: "2448",
        },
        {
          id: "28784",
          name: "Calmeca",
          state_id: "2448",
        },
        {
          id: "28785",
          name: "Calpan",
          state_id: "2448",
        },
        {
          id: "28786",
          name: "Caltenco",
          state_id: "2448",
        },
        {
          id: "28787",
          name: "Canada",
          state_id: "2448",
        },
        {
          id: "28788",
          name: "Canoa",
          state_id: "2448",
        },
        {
          id: "28789",
          name: "Caxhuacan",
          state_id: "2448",
        },
        {
          id: "28790",
          name: "Chalchihuapan",
          state_id: "2448",
        },
        {
          id: "28791",
          name: "Chapulco",
          state_id: "2448",
        },
        {
          id: "28792",
          name: "Chautla",
          state_id: "2448",
        },
        {
          id: "28793",
          name: "Chiapa",
          state_id: "2448",
        },
        {
          id: "28794",
          name: "Chiautla",
          state_id: "2448",
        },
        {
          id: "28795",
          name: "Chiautzingo",
          state_id: "2448",
        },
        {
          id: "28796",
          name: "Chiconquiac",
          state_id: "2448",
        },
        {
          id: "28797",
          name: "Chietla",
          state_id: "2448",
        },
        {
          id: "28798",
          name: "Chignahuapan",
          state_id: "2448",
        },
        {
          id: "28799",
          name: "Chignautla",
          state_id: "2448",
        },
        {
          id: "28800",
          name: "Chilac",
          state_id: "2448",
        },
        {
          id: "28801",
          name: "Chilchotla",
          state_id: "2448",
        },
        {
          id: "28802",
          name: "Cholula",
          state_id: "2448",
        },
        {
          id: "28803",
          name: "Citlaltepetl",
          state_id: "2448",
        },
        {
          id: "28804",
          name: "Coatepec",
          state_id: "2448",
        },
        {
          id: "28805",
          name: "Coronango",
          state_id: "2448",
        },
        {
          id: "28806",
          name: "Coxcatlan",
          state_id: "2448",
        },
        {
          id: "28807",
          name: "Coyula",
          state_id: "2448",
        },
        {
          id: "28808",
          name: "Cuacnopalan",
          state_id: "2448",
        },
        {
          id: "28809",
          name: "Cuanala",
          state_id: "2448",
        },
        {
          id: "28810",
          name: "Cuapiaxtla",
          state_id: "2448",
        },
        {
          id: "28811",
          name: "Cuautlancingo",
          state_id: "2448",
        },
        {
          id: "28812",
          name: "Cuayucatepec",
          state_id: "2448",
        },
        {
          id: "28813",
          name: "Cuetzalan",
          state_id: "2448",
        },
        {
          id: "28814",
          name: "Domingo Arenas",
          state_id: "2448",
        },
        {
          id: "28815",
          name: "Escape",
          state_id: "2448",
        },
        {
          id: "28816",
          name: "Esperanza",
          state_id: "2448",
        },
        {
          id: "28817",
          name: "Guadalupe Victoria",
          state_id: "2448",
        },
        {
          id: "28818",
          name: "Huaquechula",
          state_id: "2448",
        },
        {
          id: "28819",
          name: "Huauchinango",
          state_id: "2448",
        },
        {
          id: "28820",
          name: "Huehuetlan",
          state_id: "2448",
        },
        {
          id: "28821",
          name: "Huejotzingo",
          state_id: "2448",
        },
        {
          id: "28822",
          name: "Hueyapan",
          state_id: "2448",
        },
        {
          id: "28823",
          name: "Hueyotlipan",
          state_id: "2448",
        },
        {
          id: "28824",
          name: "Hueytamalco",
          state_id: "2448",
        },
        {
          id: "28825",
          name: "Huixcolotla",
          state_id: "2448",
        },
        {
          id: "28826",
          name: "Ixcaquixtla",
          state_id: "2448",
        },
        {
          id: "28827",
          name: "Ixtiyucan",
          state_id: "2448",
        },
        {
          id: "28828",
          name: "Izucar",
          state_id: "2448",
        },
        {
          id: "28829",
          name: "Jolalpan",
          state_id: "2448",
        },
        {
          id: "28830",
          name: "La Ceiba",
          state_id: "2448",
        },
        {
          id: "28831",
          name: "La Galarza",
          state_id: "2448",
        },
        {
          id: "28832",
          name: "La Resureccion",
          state_id: "2448",
        },
        {
          id: "28833",
          name: "Lazaro Cardenas",
          state_id: "2448",
        },
        {
          id: "28834",
          name: "Libres",
          state_id: "2448",
        },
        {
          id: "28835",
          name: "Los Ranchos",
          state_id: "2448",
        },
        {
          id: "28836",
          name: "Los Reyes de Juarez",
          state_id: "2448",
        },
        {
          id: "28837",
          name: "Malacatepec",
          state_id: "2448",
        },
        {
          id: "28838",
          name: "Metlaltoyuca",
          state_id: "2448",
        },
        {
          id: "28839",
          name: "Miahuatlan",
          state_id: "2448",
        },
        {
          id: "28840",
          name: "Mihuacan",
          state_id: "2448",
        },
        {
          id: "28841",
          name: "Momoxpan",
          state_id: "2448",
        },
        {
          id: "28842",
          name: "Moyotzingo",
          state_id: "2448",
        },
        {
          id: "28843",
          name: "Nealtican",
          state_id: "2448",
        },
        {
          id: "28844",
          name: "Necaxa",
          state_id: "2448",
        },
        {
          id: "28845",
          name: "Nopalucan",
          state_id: "2448",
        },
        {
          id: "28846",
          name: "Ocotitlan",
          state_id: "2448",
        },
        {
          id: "28847",
          name: "Ocotlan",
          state_id: "2448",
        },
        {
          id: "28848",
          name: "Ocoyucan",
          state_id: "2448",
        },
        {
          id: "28849",
          name: "Oriental",
          state_id: "2448",
        },
        {
          id: "28850",
          name: "Pahuatlan",
          state_id: "2448",
        },
        {
          id: "28851",
          name: "Palmar de Bravo",
          state_id: "2448",
        },
        {
          id: "28852",
          name: "Puebla",
          state_id: "2448",
        },
        {
          id: "28853",
          name: "Quecholac",
          state_id: "2448",
        },
        {
          id: "28854",
          name: "Raboso",
          state_id: "2448",
        },
        {
          id: "28855",
          name: "Rafael Lara Grajales",
          state_id: "2448",
        },
        {
          id: "28856",
          name: "San Gabriel Casa Blanca",
          state_id: "2448",
        },
        {
          id: "28857",
          name: "San Lucas el Grande",
          state_id: "2448",
        },
        {
          id: "28858",
          name: "San Salvador el Seco",
          state_id: "2448",
        },
        {
          id: "28859",
          name: "San Sebastian Villanueva",
          state_id: "2448",
        },
        {
          id: "28860",
          name: "Sanctorum",
          state_id: "2448",
        },
        {
          id: "28861",
          name: "Santa Maria la Alta",
          state_id: "2448",
        },
        {
          id: "28862",
          name: "Serdan",
          state_id: "2448",
        },
        {
          id: "28863",
          name: "Soltepec",
          state_id: "2448",
        },
        {
          id: "28864",
          name: "Tatoxcac",
          state_id: "2448",
        },
        {
          id: "28865",
          name: "Tecali",
          state_id: "2448",
        },
        {
          id: "28866",
          name: "Tecamachalco",
          state_id: "2448",
        },
        {
          id: "28867",
          name: "Tehuacan",
          state_id: "2448",
        },
        {
          id: "28868",
          name: "Tehuitzingo",
          state_id: "2448",
        },
        {
          id: "28869",
          name: "Tenango",
          state_id: "2448",
        },
        {
          id: "28870",
          name: "Tenango de las Flores",
          state_id: "2448",
        },
        {
          id: "28871",
          name: "Tenextatiloyan",
          state_id: "2448",
        },
        {
          id: "28872",
          name: "Teontepec",
          state_id: "2448",
        },
        {
          id: "28873",
          name: "Teopantlan",
          state_id: "2448",
        },
        {
          id: "28874",
          name: "Teotlalcingo",
          state_id: "2448",
        },
        {
          id: "28875",
          name: "Tepango",
          state_id: "2448",
        },
        {
          id: "28876",
          name: "Tepatlaxco",
          state_id: "2448",
        },
        {
          id: "28877",
          name: "Tepeaca",
          state_id: "2448",
        },
        {
          id: "28878",
          name: "Tepeojuma",
          state_id: "2448",
        },
        {
          id: "28879",
          name: "Tepexi",
          state_id: "2448",
        },
        {
          id: "28880",
          name: "Tepulco",
          state_id: "2448",
        },
        {
          id: "28881",
          name: "Tetela Morelos",
          state_id: "2448",
        },
        {
          id: "28882",
          name: "Tetela de Ocampo",
          state_id: "2448",
        },
        {
          id: "28883",
          name: "Teteles",
          state_id: "2448",
        },
        {
          id: "28884",
          name: "Tetzoyocan",
          state_id: "2448",
        },
        {
          id: "28885",
          name: "Texmelucan",
          state_id: "2448",
        },
        {
          id: "28886",
          name: "Teziutlan",
          state_id: "2448",
        },
        {
          id: "28887",
          name: "Tianguismanalco",
          state_id: "2448",
        },
        {
          id: "28888",
          name: "Tlachichuca",
          state_id: "2448",
        },
        {
          id: "28889",
          name: "Tlacotepec",
          state_id: "2448",
        },
        {
          id: "28890",
          name: "Tlacoyalco",
          state_id: "2448",
        },
        {
          id: "28891",
          name: "Tlahuapan",
          state_id: "2448",
        },
        {
          id: "28892",
          name: "Tlaixpan",
          state_id: "2448",
        },
        {
          id: "28893",
          name: "Tlalancaleca",
          state_id: "2448",
        },
        {
          id: "28894",
          name: "Tlaltenango",
          state_id: "2448",
        },
        {
          id: "28895",
          name: "Tlanalapan",
          state_id: "2448",
        },
        {
          id: "28896",
          name: "Tlancualpican",
          state_id: "2448",
        },
        {
          id: "28897",
          name: "Tlanepantla",
          state_id: "2448",
        },
        {
          id: "28898",
          name: "Tlapanala",
          state_id: "2448",
        },
        {
          id: "28899",
          name: "Tlatlauquitepec",
          state_id: "2448",
        },
        {
          id: "28900",
          name: "Tlaxcalancingo",
          state_id: "2448",
        },
        {
          id: "28901",
          name: "Tlaxco",
          state_id: "2448",
        },
        {
          id: "28902",
          name: "Tochapan",
          state_id: "2448",
        },
        {
          id: "28903",
          name: "Tochimilco",
          state_id: "2448",
        },
        {
          id: "28904",
          name: "Tochtepec",
          state_id: "2448",
        },
        {
          id: "28905",
          name: "Tulcingo",
          state_id: "2448",
        },
        {
          id: "28906",
          name: "Tuxco",
          state_id: "2448",
        },
        {
          id: "28907",
          name: "Venustiano Carranza",
          state_id: "2448",
        },
        {
          id: "28908",
          name: "Xalmimilulco",
          state_id: "2448",
        },
        {
          id: "28909",
          name: "Xaltepec",
          state_id: "2448",
        },
        {
          id: "28910",
          name: "Xicotepec",
          state_id: "2448",
        },
        {
          id: "28911",
          name: "Xiutetelco",
          state_id: "2448",
        },
        {
          id: "28912",
          name: "Xochiltenango",
          state_id: "2448",
        },
        {
          id: "28913",
          name: "Xochitlan",
          state_id: "2448",
        },
        {
          id: "28914",
          name: "Xonatepec",
          state_id: "2448",
        },
        {
          id: "28915",
          name: "Xoxtla",
          state_id: "2448",
        },
        {
          id: "28916",
          name: "Yaonahuac",
          state_id: "2448",
        },
        {
          id: "28917",
          name: "Yehualtepec",
          state_id: "2448",
        },
        {
          id: "28918",
          name: "Zacapechpan",
          state_id: "2448",
        },
        {
          id: "28919",
          name: "Zacapoaxtla",
          state_id: "2448",
        },
        {
          id: "28920",
          name: "Zacatepec",
          state_id: "2448",
        },
        {
          id: "28921",
          name: "Zacatlan",
          state_id: "2448",
        },
        {
          id: "28922",
          name: "Zaragoza",
          state_id: "2448",
        },
        {
          id: "28923",
          name: "Zinacatepec",
          state_id: "2448",
        },
        {
          id: "28924",
          name: "Zongozotla",
          state_id: "2448",
        },
        {
          id: "28925",
          name: "Zozutla",
          state_id: "2448",
        },
      ],
      Queretaro: [
        {
          id: "28926",
          name: "Ajuchitlan",
          state_id: "2449",
        },
        {
          id: "28927",
          name: "Amazcala",
          state_id: "2449",
        },
        {
          id: "28928",
          name: "Amealco",
          state_id: "2449",
        },
        {
          id: "28929",
          name: "Cadereyta",
          state_id: "2449",
        },
        {
          id: "28930",
          name: "Candiles",
          state_id: "2449",
        },
        {
          id: "28931",
          name: "Colon",
          state_id: "2449",
        },
        {
          id: "28932",
          name: "El Colorado",
          state_id: "2449",
        },
        {
          id: "28933",
          name: "El Pueblito",
          state_id: "2449",
        },
        {
          id: "28934",
          name: "El Sauz",
          state_id: "2449",
        },
        {
          id: "28935",
          name: "Ezequiel Montes",
          state_id: "2449",
        },
        {
          id: "28936",
          name: "Huimilpan",
          state_id: "2449",
        },
        {
          id: "28937",
          name: "Jalpan",
          state_id: "2449",
        },
        {
          id: "28938",
          name: "Jauregui",
          state_id: "2449",
        },
        {
          id: "28939",
          name: "La Canada",
          state_id: "2449",
        },
        {
          id: "28940",
          name: "La Estancia",
          state_id: "2449",
        },
        {
          id: "28941",
          name: "La Lira",
          state_id: "2449",
        },
        {
          id: "28942",
          name: "La Llave",
          state_id: "2449",
        },
        {
          id: "28943",
          name: "Paso de Mata",
          state_id: "2449",
        },
        {
          id: "28944",
          name: "Pedro Escobedo",
          state_id: "2449",
        },
        {
          id: "28945",
          name: "Queretaro",
          state_id: "2449",
        },
        {
          id: "28946",
          name: "San Jose de los Olvera",
          state_id: "2449",
        },
        {
          id: "28947",
          name: "San Jose el Alto",
          state_id: "2449",
        },
        {
          id: "28948",
          name: "San Juan del Rio",
          state_id: "2449",
        },
        {
          id: "28949",
          name: "San Nicolas",
          state_id: "2449",
        },
        {
          id: "28950",
          name: "San Pedro Martir",
          state_id: "2449",
        },
        {
          id: "28951",
          name: "Santa Maria Magdalena",
          state_id: "2449",
        },
        {
          id: "28952",
          name: "Tequisquiapan",
          state_id: "2449",
        },
        {
          id: "28953",
          name: "Tlacote el Bajo",
          state_id: "2449",
        },
      ],
      "Quintana Roo": [],
      "San Luis Potosi": [],
      Sinaloa: [
        {
          id: "28954",
          name: "Adolfo Ruiz Cortines",
          state_id: "2452",
        },
        {
          id: "28955",
          name: "Agua Verde",
          state_id: "2452",
        },
        {
          id: "28956",
          name: "Ahome",
          state_id: "2452",
        },
        {
          id: "28957",
          name: "Angostura",
          state_id: "2452",
        },
        {
          id: "28958",
          name: "Badiraguato",
          state_id: "2452",
        },
        {
          id: "28959",
          name: "Bagojo",
          state_id: "2452",
        },
        {
          id: "28960",
          name: "Benito Juarez",
          state_id: "2452",
        },
        {
          id: "28961",
          name: "Campo Gobierno",
          state_id: "2452",
        },
        {
          id: "28962",
          name: "Choix",
          state_id: "2452",
        },
        {
          id: "28963",
          name: "Compuertas",
          state_id: "2452",
        },
        {
          id: "28964",
          name: "Concordia",
          state_id: "2452",
        },
        {
          id: "28965",
          name: "Constancia",
          state_id: "2452",
        },
        {
          id: "28966",
          name: "Cosala",
          state_id: "2452",
        },
        {
          id: "28967",
          name: "Costa Rica",
          state_id: "2452",
        },
        {
          id: "28968",
          name: "Culiacan",
          state_id: "2452",
        },
        {
          id: "28969",
          name: "Culiacancito",
          state_id: "2452",
        },
        {
          id: "28970",
          name: "El Burrion",
          state_id: "2452",
        },
        {
          id: "28971",
          name: "El Carrizo",
          state_id: "2452",
        },
        {
          id: "28972",
          name: "El Diez",
          state_id: "2452",
        },
        {
          id: "28973",
          name: "El Estero",
          state_id: "2452",
        },
        {
          id: "28974",
          name: "El Fuerte",
          state_id: "2452",
        },
        {
          id: "28975",
          name: "El Rosario",
          state_id: "2452",
        },
        {
          id: "28976",
          name: "El Tamarindo",
          state_id: "2452",
        },
        {
          id: "28977",
          name: "Eldorado",
          state_id: "2452",
        },
        {
          id: "28978",
          name: "Escuinapa",
          state_id: "2452",
        },
        {
          id: "28979",
          name: "Estacion Naranjo",
          state_id: "2452",
        },
        {
          id: "28980",
          name: "Estancia Bamoa",
          state_id: "2452",
        },
        {
          id: "28981",
          name: "Gabriel Leyva Solano",
          state_id: "2452",
        },
        {
          id: "28982",
          name: "Guamuchil",
          state_id: "2452",
        },
        {
          id: "28983",
          name: "Guasave",
          state_id: "2452",
        },
        {
          id: "28984",
          name: "Higuera",
          state_id: "2452",
        },
        {
          id: "28985",
          name: "Isla del Bosque",
          state_id: "2452",
        },
        {
          id: "28986",
          name: "Jahuara Segundo",
          state_id: "2452",
        },
        {
          id: "28987",
          name: "Juan Jose Rios",
          state_id: "2452",
        },
        {
          id: "28988",
          name: "La Cruz",
          state_id: "2452",
        },
        {
          id: "28989",
          name: "La Palma",
          state_id: "2452",
        },
        {
          id: "28990",
          name: "La Reforma",
          state_id: "2452",
        },
        {
          id: "28991",
          name: "La Trinidad",
          state_id: "2452",
        },
        {
          id: "28992",
          name: "Los Mochis",
          state_id: "2452",
        },
        {
          id: "28993",
          name: "Mazatlan",
          state_id: "2452",
        },
        {
          id: "28994",
          name: "Mochicahui",
          state_id: "2452",
        },
        {
          id: "28995",
          name: "Mocorito",
          state_id: "2452",
        },
        {
          id: "28996",
          name: "Navolato",
          state_id: "2452",
        },
        {
          id: "28997",
          name: "Pericos",
          state_id: "2452",
        },
        {
          id: "28998",
          name: "Pueblos Unidos",
          state_id: "2452",
        },
        {
          id: "28999",
          name: "Quila",
          state_id: "2452",
        },
        {
          id: "29000",
          name: "San Blas",
          state_id: "2452",
        },
        {
          id: "29001",
          name: "San Ignacio",
          state_id: "2452",
        },
        {
          id: "29002",
          name: "Sinaloa",
          state_id: "2452",
        },
        {
          id: "29003",
          name: "Teacapan",
          state_id: "2452",
        },
        {
          id: "29004",
          name: "Topolobampo",
          state_id: "2452",
        },
        {
          id: "29005",
          name: "Villa Union",
          state_id: "2452",
        },
        {
          id: "29006",
          name: "Zapotitlan",
          state_id: "2452",
        },
      ],
      Sonora: [
        {
          id: "29007",
          name: "Agua Prieta",
          state_id: "2453",
        },
        {
          id: "29008",
          name: "Alamos",
          state_id: "2453",
        },
        {
          id: "29009",
          name: "Altar",
          state_id: "2453",
        },
        {
          id: "29010",
          name: "Bacobampo",
          state_id: "2453",
        },
        {
          id: "29011",
          name: "Bacum",
          state_id: "2453",
        },
        {
          id: "29012",
          name: "Bahia de Kino",
          state_id: "2453",
        },
        {
          id: "29013",
          name: "Benjamin Hill",
          state_id: "2453",
        },
        {
          id: "29014",
          name: "Caborca",
          state_id: "2453",
        },
        {
          id: "29015",
          name: "Campo Sesenta",
          state_id: "2453",
        },
        {
          id: "29016",
          name: "Cananea",
          state_id: "2453",
        },
        {
          id: "29017",
          name: "Carbo",
          state_id: "2453",
        },
        {
          id: "29018",
          name: "Cocorit",
          state_id: "2453",
        },
        {
          id: "29019",
          name: "Cumpas",
          state_id: "2453",
        },
        {
          id: "29020",
          name: "Empalme",
          state_id: "2453",
        },
        {
          id: "29021",
          name: "Esperanza",
          state_id: "2453",
        },
        {
          id: "29022",
          name: "Esqueda",
          state_id: "2453",
        },
        {
          id: "29023",
          name: "Etchojoa",
          state_id: "2453",
        },
        {
          id: "29024",
          name: "Etchoropo",
          state_id: "2453",
        },
        {
          id: "29025",
          name: "Guaymas",
          state_id: "2453",
        },
        {
          id: "29026",
          name: "Hermosillo",
          state_id: "2453",
        },
        {
          id: "29027",
          name: "Huatabampo",
          state_id: "2453",
        },
        {
          id: "29028",
          name: "Imuris",
          state_id: "2453",
        },
        {
          id: "29029",
          name: "Juarez",
          state_id: "2453",
        },
        {
          id: "29030",
          name: "Kino",
          state_id: "2453",
        },
        {
          id: "29031",
          name: "La Doce",
          state_id: "2453",
        },
        {
          id: "29032",
          name: "La Union",
          state_id: "2453",
        },
        {
          id: "29033",
          name: "Moctezuma",
          state_id: "2453",
        },
        {
          id: "29034",
          name: "Naco",
          state_id: "2453",
        },
        {
          id: "29035",
          name: "Nacozari",
          state_id: "2453",
        },
        {
          id: "29036",
          name: "Navajoa",
          state_id: "2453",
        },
        {
          id: "29037",
          name: "Nogales",
          state_id: "2453",
        },
        {
          id: "29038",
          name: "Obregon",
          state_id: "2453",
        },
        {
          id: "29039",
          name: "Pitiquito",
          state_id: "2453",
        },
        {
          id: "29040",
          name: "Potam",
          state_id: "2453",
        },
        {
          id: "29041",
          name: "Providencia",
          state_id: "2453",
        },
        {
          id: "29042",
          name: "Puerto Penasco",
          state_id: "2453",
        },
        {
          id: "29043",
          name: "Rio Muerto",
          state_id: "2453",
        },
        {
          id: "29044",
          name: "Sahuaripa",
          state_id: "2453",
        },
        {
          id: "29045",
          name: "San Jose de Bacum",
          state_id: "2453",
        },
        {
          id: "29046",
          name: "San Luis Rio Colorado",
          state_id: "2453",
        },
        {
          id: "29047",
          name: "Sanchez",
          state_id: "2453",
        },
        {
          id: "29048",
          name: "Santa Ana",
          state_id: "2453",
        },
        {
          id: "29049",
          name: "Sonoita",
          state_id: "2453",
        },
        {
          id: "29050",
          name: "Tobarito",
          state_id: "2453",
        },
        {
          id: "29051",
          name: "Ures",
          state_id: "2453",
        },
        {
          id: "29052",
          name: "Vicam",
          state_id: "2453",
        },
        {
          id: "29053",
          name: "Yaqui",
          state_id: "2453",
        },
        {
          id: "29054",
          name: "Yavaros",
          state_id: "2453",
        },
      ],
      Tabasco: [
        {
          id: "29055",
          name: "Aquiles Serdan",
          state_id: "2454",
        },
        {
          id: "29056",
          name: "Ayapa",
          state_id: "2454",
        },
        {
          id: "29057",
          name: "Balancan",
          state_id: "2454",
        },
        {
          id: "29058",
          name: "Barra de Santa Ana",
          state_id: "2454",
        },
        {
          id: "29059",
          name: "Belen",
          state_id: "2454",
        },
        {
          id: "29060",
          name: "Bosque de Saloya",
          state_id: "2454",
        },
        {
          id: "29061",
          name: "Buenavista",
          state_id: "2454",
        },
        {
          id: "29062",
          name: "Campo Magellanes",
          state_id: "2454",
        },
        {
          id: "29063",
          name: "Cardenas",
          state_id: "2454",
        },
        {
          id: "29064",
          name: "Chichicapa",
          state_id: "2454",
        },
        {
          id: "29065",
          name: "Chontalpa",
          state_id: "2454",
        },
        {
          id: "29066",
          name: "Comalcalco",
          state_id: "2454",
        },
        {
          id: "29067",
          name: "Cunduacan",
          state_id: "2454",
        },
        {
          id: "29068",
          name: "El Triunfo",
          state_id: "2454",
        },
        {
          id: "29069",
          name: "Emiliano Zapata",
          state_id: "2454",
        },
        {
          id: "29070",
          name: "Fraccionamiento la Selva",
          state_id: "2454",
        },
        {
          id: "29071",
          name: "Frontera",
          state_id: "2454",
        },
        {
          id: "29072",
          name: "Huimanguillo",
          state_id: "2454",
        },
        {
          id: "29073",
          name: "Jalapa",
          state_id: "2454",
        },
        {
          id: "29074",
          name: "Jalpa",
          state_id: "2454",
        },
        {
          id: "29075",
          name: "Jonuta",
          state_id: "2454",
        },
        {
          id: "29076",
          name: "La Curva",
          state_id: "2454",
        },
        {
          id: "29077",
          name: "La Venta",
          state_id: "2454",
        },
        {
          id: "29078",
          name: "Luis Gil Perez",
          state_id: "2454",
        },
        {
          id: "29079",
          name: "Macultepec",
          state_id: "2454",
        },
        {
          id: "29080",
          name: "Macuspana",
          state_id: "2454",
        },
        {
          id: "29081",
          name: "Magana",
          state_id: "2454",
        },
        {
          id: "29082",
          name: "Miguel Hidalgo",
          state_id: "2454",
        },
        {
          id: "29083",
          name: "Nacajuca",
          state_id: "2454",
        },
        {
          id: "29084",
          name: "Ocuiltzapotlan",
          state_id: "2454",
        },
        {
          id: "29085",
          name: "Once de Febrero",
          state_id: "2454",
        },
        {
          id: "29086",
          name: "Paraiso",
          state_id: "2454",
        },
        {
          id: "29087",
          name: "Parrilla",
          state_id: "2454",
        },
        {
          id: "29088",
          name: "Pemex",
          state_id: "2454",
        },
        {
          id: "29089",
          name: "Playas del Rosario",
          state_id: "2454",
        },
        {
          id: "29090",
          name: "Rio Viejo",
          state_id: "2454",
        },
        {
          id: "29091",
          name: "San Carlos",
          state_id: "2454",
        },
        {
          id: "29092",
          name: "Santa Rosalia",
          state_id: "2454",
        },
        {
          id: "29093",
          name: "Simon Sarlat",
          state_id: "2454",
        },
        {
          id: "29094",
          name: "Tacotalpa",
          state_id: "2454",
        },
        {
          id: "29095",
          name: "Tamulte",
          state_id: "2454",
        },
        {
          id: "29096",
          name: "Teapa",
          state_id: "2454",
        },
        {
          id: "29097",
          name: "Tecolutilla",
          state_id: "2454",
        },
        {
          id: "29098",
          name: "Tenosique",
          state_id: "2454",
        },
        {
          id: "29099",
          name: "Vicente Guerrero",
          state_id: "2454",
        },
        {
          id: "29100",
          name: "Villa Aldama",
          state_id: "2454",
        },
        {
          id: "29101",
          name: "Villahermosa",
          state_id: "2454",
        },
      ],
      Tamaulipas: [
        {
          id: "29102",
          name: "Abasolo",
          state_id: "2455",
        },
        {
          id: "29103",
          name: "Aldama",
          state_id: "2455",
        },
        {
          id: "29104",
          name: "Altamira",
          state_id: "2455",
        },
        {
          id: "29105",
          name: "Antiguo Morelos",
          state_id: "2455",
        },
        {
          id: "29106",
          name: "Camargo",
          state_id: "2455",
        },
        {
          id: "29107",
          name: "Cuauhtemoc",
          state_id: "2455",
        },
        {
          id: "29108",
          name: "El Mante",
          state_id: "2455",
        },
        {
          id: "29109",
          name: "Estacion Manuel",
          state_id: "2455",
        },
        {
          id: "29110",
          name: "Gonzalez",
          state_id: "2455",
        },
        {
          id: "29111",
          name: "Graciano Sanchez",
          state_id: "2455",
        },
        {
          id: "29112",
          name: "Guerrero",
          state_id: "2455",
        },
        {
          id: "29113",
          name: "Gustavo Diaz Ordaz",
          state_id: "2455",
        },
        {
          id: "29114",
          name: "Hidalgo",
          state_id: "2455",
        },
        {
          id: "29115",
          name: "Jaumave",
          state_id: "2455",
        },
        {
          id: "29116",
          name: "Llerca",
          state_id: "2455",
        },
        {
          id: "29117",
          name: "Los Guerra",
          state_id: "2455",
        },
        {
          id: "29118",
          name: "Madero",
          state_id: "2455",
        },
        {
          id: "29119",
          name: "Matamoros",
          state_id: "2455",
        },
        {
          id: "29120",
          name: "Mier",
          state_id: "2455",
        },
        {
          id: "29121",
          name: "Miguel Aleman",
          state_id: "2455",
        },
        {
          id: "29122",
          name: "Miramar",
          state_id: "2455",
        },
        {
          id: "29123",
          name: "Nuevo Laredo",
          state_id: "2455",
        },
        {
          id: "29124",
          name: "Nuevo Progreso",
          state_id: "2455",
        },
        {
          id: "29125",
          name: "Ocampo",
          state_id: "2455",
        },
        {
          id: "29126",
          name: "Padilla",
          state_id: "2455",
        },
        {
          id: "29127",
          name: "Reynosa",
          state_id: "2455",
        },
        {
          id: "29128",
          name: "Rio Bravo",
          state_id: "2455",
        },
        {
          id: "29129",
          name: "San Fernando",
          state_id: "2455",
        },
        {
          id: "29130",
          name: "Santa Engracia",
          state_id: "2455",
        },
        {
          id: "29131",
          name: "Santander Jimenez",
          state_id: "2455",
        },
        {
          id: "29132",
          name: "Soto la Marina",
          state_id: "2455",
        },
        {
          id: "29133",
          name: "Tampico",
          state_id: "2455",
        },
        {
          id: "29134",
          name: "Tula",
          state_id: "2455",
        },
        {
          id: "29135",
          name: "Valle Hermoso",
          state_id: "2455",
        },
        {
          id: "29136",
          name: "Victoria",
          state_id: "2455",
        },
        {
          id: "29137",
          name: "Xicotencatl",
          state_id: "2455",
        },
      ],
      Tlaxcala: [
        {
          id: "29138",
          name: "Ahuashuatepec",
          state_id: "2456",
        },
        {
          id: "29139",
          name: "Altzayanca",
          state_id: "2456",
        },
        {
          id: "29140",
          name: "Amaxac",
          state_id: "2456",
        },
        {
          id: "29141",
          name: "Apetatitlan",
          state_id: "2456",
        },
        {
          id: "29142",
          name: "Apizaco",
          state_id: "2456",
        },
        {
          id: "29143",
          name: "Apizaquito",
          state_id: "2456",
        },
        {
          id: "29144",
          name: "Atexcatzingo",
          state_id: "2456",
        },
        {
          id: "29145",
          name: "Axocomanitla",
          state_id: "2456",
        },
        {
          id: "29146",
          name: "Ayometla",
          state_id: "2456",
        },
        {
          id: "29147",
          name: "Benito Juarez",
          state_id: "2456",
        },
        {
          id: "29148",
          name: "Buen Suceso",
          state_id: "2456",
        },
        {
          id: "29149",
          name: "Calpulalpan",
          state_id: "2456",
        },
        {
          id: "29150",
          name: "Chiautempan",
          state_id: "2456",
        },
        {
          id: "29151",
          name: "Contla",
          state_id: "2456",
        },
        {
          id: "29152",
          name: "Cuapiaxtla",
          state_id: "2456",
        },
        {
          id: "29153",
          name: "Huactzinco",
          state_id: "2456",
        },
        {
          id: "29154",
          name: "Huamantla",
          state_id: "2456",
        },
        {
          id: "29155",
          name: "Hueyotlipan",
          state_id: "2456",
        },
        {
          id: "29156",
          name: "Huiloac",
          state_id: "2456",
        },
        {
          id: "29157",
          name: "Ignacio Zaragoza",
          state_id: "2456",
        },
        {
          id: "29158",
          name: "Ixtacuixtla",
          state_id: "2456",
        },
        {
          id: "29159",
          name: "Ixtenco",
          state_id: "2456",
        },
        {
          id: "29160",
          name: "Mazatecochco",
          state_id: "2456",
        },
        {
          id: "29161",
          name: "Nanacamilpa",
          state_id: "2456",
        },
        {
          id: "29162",
          name: "Nativitas",
          state_id: "2456",
        },
        {
          id: "29163",
          name: "Nopalucan",
          state_id: "2456",
        },
        {
          id: "29164",
          name: "Panotla",
          state_id: "2456",
        },
        {
          id: "29165",
          name: "Papalotla",
          state_id: "2456",
        },
        {
          id: "29166",
          name: "Quilehtla",
          state_id: "2456",
        },
        {
          id: "29167",
          name: "Sanctorum",
          state_id: "2456",
        },
        {
          id: "29168",
          name: "Teacalco",
          state_id: "2456",
        },
        {
          id: "29169",
          name: "Tenancingo",
          state_id: "2456",
        },
        {
          id: "29170",
          name: "Teolocholco",
          state_id: "2456",
        },
        {
          id: "29171",
          name: "Tepetitla",
          state_id: "2456",
        },
        {
          id: "29172",
          name: "Tepeyanco",
          state_id: "2456",
        },
        {
          id: "29173",
          name: "Tequixquitla",
          state_id: "2456",
        },
        {
          id: "29174",
          name: "Terrenate",
          state_id: "2456",
        },
        {
          id: "29175",
          name: "Tetla",
          state_id: "2456",
        },
        {
          id: "29176",
          name: "Tetlanohcan",
          state_id: "2456",
        },
        {
          id: "29177",
          name: "Tetlatlahuca",
          state_id: "2456",
        },
        {
          id: "29178",
          name: "Texcalac",
          state_id: "2456",
        },
        {
          id: "29179",
          name: "Texoloc",
          state_id: "2456",
        },
        {
          id: "29180",
          name: "Tlaltelulco",
          state_id: "2456",
        },
        {
          id: "29181",
          name: "Tlaxcala",
          state_id: "2456",
        },
        {
          id: "29182",
          name: "Tlaxco",
          state_id: "2456",
        },
        {
          id: "29183",
          name: "Tocatlan",
          state_id: "2456",
        },
        {
          id: "29184",
          name: "Totolac",
          state_id: "2456",
        },
        {
          id: "29185",
          name: "Vicente Guerrero",
          state_id: "2456",
        },
        {
          id: "29186",
          name: "Villa Alta",
          state_id: "2456",
        },
        {
          id: "29187",
          name: "Xaloztoc",
          state_id: "2456",
        },
        {
          id: "29188",
          name: "Xaltocan",
          state_id: "2456",
        },
        {
          id: "29189",
          name: "Xicohtzinco",
          state_id: "2456",
        },
        {
          id: "29190",
          name: "Xicotencatl",
          state_id: "2456",
        },
        {
          id: "29191",
          name: "Xiloxoxtla",
          state_id: "2456",
        },
        {
          id: "29192",
          name: "Yauhquemecan",
          state_id: "2456",
        },
        {
          id: "29193",
          name: "Zacatelco",
          state_id: "2456",
        },
        {
          id: "29194",
          name: "Zacualpan",
          state_id: "2456",
        },
        {
          id: "29195",
          name: "Zitlaltepec",
          state_id: "2456",
        },
      ],
      Veracruz: [
        {
          id: "29196",
          name: "Acayucan",
          state_id: "2457",
        },
        {
          id: "29197",
          name: "Actopan",
          state_id: "2457",
        },
        {
          id: "29198",
          name: "Acultzingo",
          state_id: "2457",
        },
        {
          id: "29199",
          name: "Agua Dulce",
          state_id: "2457",
        },
        {
          id: "29200",
          name: "Alamo",
          state_id: "2457",
        },
        {
          id: "29201",
          name: "Allende",
          state_id: "2457",
        },
        {
          id: "29202",
          name: "Altamirano",
          state_id: "2457",
        },
        {
          id: "29203",
          name: "Alto Lucero",
          state_id: "2457",
        },
        {
          id: "29204",
          name: "Altotonga",
          state_id: "2457",
        },
        {
          id: "29205",
          name: "Alvarado",
          state_id: "2457",
        },
        {
          id: "29206",
          name: "Amatlan",
          state_id: "2457",
        },
        {
          id: "29207",
          name: "Anahuac",
          state_id: "2457",
        },
        {
          id: "29208",
          name: "Anton Lizardo",
          state_id: "2457",
        },
        {
          id: "29209",
          name: "Atzacan",
          state_id: "2457",
        },
        {
          id: "29210",
          name: "Azueta",
          state_id: "2457",
        },
        {
          id: "29211",
          name: "Banderilla",
          state_id: "2457",
        },
        {
          id: "29212",
          name: "Benito Juarez",
          state_id: "2457",
        },
        {
          id: "29213",
          name: "Boca del Monte",
          state_id: "2457",
        },
        {
          id: "29214",
          name: "Boca del Rio",
          state_id: "2457",
        },
        {
          id: "29215",
          name: "Cabada",
          state_id: "2457",
        },
        {
          id: "29216",
          name: "Cabezas",
          state_id: "2457",
        },
        {
          id: "29217",
          name: "Carrillo",
          state_id: "2457",
        },
        {
          id: "29218",
          name: "Castillo de Teayo",
          state_id: "2457",
        },
        {
          id: "29219",
          name: "Catemaco",
          state_id: "2457",
        },
        {
          id: "29220",
          name: "Cazones",
          state_id: "2457",
        },
        {
          id: "29221",
          name: "Cerro Azul",
          state_id: "2457",
        },
        {
          id: "29222",
          name: "Chacaltianguis",
          state_id: "2457",
        },
        {
          id: "29223",
          name: "Chicontepec",
          state_id: "2457",
        },
        {
          id: "29224",
          name: "Chinameca",
          state_id: "2457",
        },
        {
          id: "29225",
          name: "Chinampa",
          state_id: "2457",
        },
        {
          id: "29226",
          name: "Chocaman",
          state_id: "2457",
        },
        {
          id: "29227",
          name: "Citlaltepetl",
          state_id: "2457",
        },
        {
          id: "29228",
          name: "Clara",
          state_id: "2457",
        },
        {
          id: "29229",
          name: "Coacoatzintla",
          state_id: "2457",
        },
        {
          id: "29230",
          name: "Coacotla",
          state_id: "2457",
        },
        {
          id: "29231",
          name: "Coatepec",
          state_id: "2457",
        },
        {
          id: "29232",
          name: "Coatzacoalcos",
          state_id: "2457",
        },
        {
          id: "29233",
          name: "Coatzintla",
          state_id: "2457",
        },
        {
          id: "29234",
          name: "Comoapan",
          state_id: "2457",
        },
        {
          id: "29235",
          name: "Cordoba",
          state_id: "2457",
        },
        {
          id: "29236",
          name: "Corral Nuevo",
          state_id: "2457",
        },
        {
          id: "29237",
          name: "Cosamaloapan",
          state_id: "2457",
        },
        {
          id: "29238",
          name: "Cosautlan",
          state_id: "2457",
        },
        {
          id: "29239",
          name: "Coscomatepec",
          state_id: "2457",
        },
        {
          id: "29240",
          name: "Cosoleacaque",
          state_id: "2457",
        },
        {
          id: "29241",
          name: "Covarrubias",
          state_id: "2457",
        },
        {
          id: "29242",
          name: "Coxquihui",
          state_id: "2457",
        },
        {
          id: "29243",
          name: "Coyutla",
          state_id: "2457",
        },
        {
          id: "29244",
          name: "Cuauhtemoc",
          state_id: "2457",
        },
        {
          id: "29245",
          name: "Cuautlapan",
          state_id: "2457",
        },
        {
          id: "29246",
          name: "Cuichapa",
          state_id: "2457",
        },
        {
          id: "29247",
          name: "Cuitlahuac",
          state_id: "2457",
        },
        {
          id: "29248",
          name: "El Castillo",
          state_id: "2457",
        },
        {
          id: "29249",
          name: "El Higo",
          state_id: "2457",
        },
        {
          id: "29250",
          name: "El Naranjito",
          state_id: "2457",
        },
        {
          id: "29251",
          name: "El Pueblito",
          state_id: "2457",
        },
        {
          id: "29252",
          name: "El Tejar",
          state_id: "2457",
        },
        {
          id: "29253",
          name: "Emilio Carranza",
          state_id: "2457",
        },
        {
          id: "29254",
          name: "Estacion Juanita",
          state_id: "2457",
        },
        {
          id: "29255",
          name: "Estacion del Idolo",
          state_id: "2457",
        },
        {
          id: "29256",
          name: "Filomeno Mata",
          state_id: "2457",
        },
        {
          id: "29257",
          name: "Fortin",
          state_id: "2457",
        },
        {
          id: "29258",
          name: "Gabino Barreda",
          state_id: "2457",
        },
        {
          id: "29259",
          name: "Guadalupe Victoria",
          state_id: "2457",
        },
        {
          id: "29260",
          name: "Gutierrez Zamora",
          state_id: "2457",
        },
        {
          id: "29261",
          name: "Hidalgo",
          state_id: "2457",
        },
        {
          id: "29262",
          name: "Hidalgotitlan",
          state_id: "2457",
        },
        {
          id: "29263",
          name: "Huatusco",
          state_id: "2457",
        },
        {
          id: "29264",
          name: "Huayacoctla",
          state_id: "2457",
        },
        {
          id: "29265",
          name: "Hueyapan",
          state_id: "2457",
        },
        {
          id: "29266",
          name: "Huiloapan",
          state_id: "2457",
        },
        {
          id: "29267",
          name: "Ignacio de la Llave",
          state_id: "2457",
        },
        {
          id: "29268",
          name: "Isla",
          state_id: "2457",
        },
        {
          id: "29269",
          name: "Ixcatepec",
          state_id: "2457",
        },
        {
          id: "29270",
          name: "Ixhuatlan del Cafe",
          state_id: "2457",
        },
        {
          id: "29271",
          name: "Ixhuatlan del Sureste",
          state_id: "2457",
        },
        {
          id: "29272",
          name: "Ixhuatlancillo",
          state_id: "2457",
        },
        {
          id: "29273",
          name: "Ixtaczoquitlan",
          state_id: "2457",
        },
        {
          id: "29274",
          name: "Jalacingo",
          state_id: "2457",
        },
        {
          id: "29275",
          name: "Jalapilla",
          state_id: "2457",
        },
        {
          id: "29276",
          name: "Jaltipan",
          state_id: "2457",
        },
        {
          id: "29277",
          name: "Jamapa",
          state_id: "2457",
        },
        {
          id: "29278",
          name: "Jesus Carranza",
          state_id: "2457",
        },
        {
          id: "29279",
          name: "Jilotepec",
          state_id: "2457",
        },
        {
          id: "29280",
          name: "La Antigua",
          state_id: "2457",
        },
        {
          id: "29281",
          name: "La Estanzuela",
          state_id: "2457",
        },
        {
          id: "29282",
          name: "La Pena",
          state_id: "2457",
        },
        {
          id: "29283",
          name: "La Perla",
          state_id: "2457",
        },
        {
          id: "29284",
          name: "La Poza",
          state_id: "2457",
        },
        {
          id: "29285",
          name: "Las Amapolas",
          state_id: "2457",
        },
        {
          id: "29286",
          name: "Las Choapas",
          state_id: "2457",
        },
        {
          id: "29287",
          name: "Las Vigas",
          state_id: "2457",
        },
        {
          id: "29288",
          name: "Lerdo",
          state_id: "2457",
        },
        {
          id: "29289",
          name: "Lomas de Barillas",
          state_id: "2457",
        },
        {
          id: "29290",
          name: "Los Altos",
          state_id: "2457",
        },
        {
          id: "29291",
          name: "Los Mangos",
          state_id: "2457",
        },
        {
          id: "29292",
          name: "Maltrata",
          state_id: "2457",
        },
        {
          id: "29293",
          name: "Mariano Escobedo",
          state_id: "2457",
        },
        {
          id: "29294",
          name: "Martinez",
          state_id: "2457",
        },
        {
          id: "29295",
          name: "Mecatlan",
          state_id: "2457",
        },
        {
          id: "29296",
          name: "Mecayapan",
          state_id: "2457",
        },
        {
          id: "29297",
          name: "Mendoza",
          state_id: "2457",
        },
        {
          id: "29298",
          name: "Minatitlan",
          state_id: "2457",
        },
        {
          id: "29299",
          name: "Misantla",
          state_id: "2457",
        },
        {
          id: "29300",
          name: "Monte Blanco",
          state_id: "2457",
        },
        {
          id: "29301",
          name: "Moralillo",
          state_id: "2457",
        },
        {
          id: "29302",
          name: "Motzorongo",
          state_id: "2457",
        },
        {
          id: "29303",
          name: "Mundo Nuevo",
          state_id: "2457",
        },
        {
          id: "29304",
          name: "Nanchital",
          state_id: "2457",
        },
        {
          id: "29305",
          name: "Naolinco",
          state_id: "2457",
        },
        {
          id: "29306",
          name: "Naranjos",
          state_id: "2457",
        },
        {
          id: "29307",
          name: "Nautla",
          state_id: "2457",
        },
        {
          id: "29308",
          name: "Nogales",
          state_id: "2457",
        },
        {
          id: "29309",
          name: "Oluta",
          state_id: "2457",
        },
        {
          id: "29310",
          name: "Omealca",
          state_id: "2457",
        },
        {
          id: "29311",
          name: "Orizaba",
          state_id: "2457",
        },
        {
          id: "29312",
          name: "Otatitlan",
          state_id: "2457",
        },
        {
          id: "29313",
          name: "Oteapan",
          state_id: "2457",
        },
        {
          id: "29314",
          name: "Ozuluama",
          state_id: "2457",
        },
        {
          id: "29315",
          name: "Pajapan",
          state_id: "2457",
        },
        {
          id: "29316",
          name: "Palmira",
          state_id: "2457",
        },
        {
          id: "29317",
          name: "Panuco",
          state_id: "2457",
        },
        {
          id: "29318",
          name: "Papantla",
          state_id: "2457",
        },
        {
          id: "29319",
          name: "Paraje Nuevo",
          state_id: "2457",
        },
        {
          id: "29320",
          name: "Paso de Ovejas",
          state_id: "2457",
        },
        {
          id: "29321",
          name: "Paso del Macho",
          state_id: "2457",
        },
        {
          id: "29322",
          name: "Paso del Toro",
          state_id: "2457",
        },
        {
          id: "29323",
          name: "Penuela",
          state_id: "2457",
        },
        {
          id: "29324",
          name: "Perote",
          state_id: "2457",
        },
        {
          id: "29325",
          name: "Piedras Negras",
          state_id: "2457",
        },
        {
          id: "29326",
          name: "Plan de Ayala",
          state_id: "2457",
        },
        {
          id: "29327",
          name: "Platon Sanchez",
          state_id: "2457",
        },
        {
          id: "29328",
          name: "Playa Vicente",
          state_id: "2457",
        },
        {
          id: "29329",
          name: "Potrero Nuevo",
          state_id: "2457",
        },
        {
          id: "29330",
          name: "Potrero del Llano",
          state_id: "2457",
        },
        {
          id: "29331",
          name: "Poza Rica",
          state_id: "2457",
        },
        {
          id: "29332",
          name: "Puntilla Aldama",
          state_id: "2457",
        },
        {
          id: "29333",
          name: "Rafael Delgado",
          state_id: "2457",
        },
        {
          id: "29334",
          name: "Rafael Lucio",
          state_id: "2457",
        },
        {
          id: "29335",
          name: "Rinconada",
          state_id: "2457",
        },
        {
          id: "29336",
          name: "Saltabarranca",
          state_id: "2457",
        },
        {
          id: "29337",
          name: "San Juan Evangelista",
          state_id: "2457",
        },
        {
          id: "29338",
          name: "San Marcos",
          state_id: "2457",
        },
        {
          id: "29339",
          name: "San Rafael",
          state_id: "2457",
        },
        {
          id: "29340",
          name: "San Roman",
          state_id: "2457",
        },
        {
          id: "29341",
          name: "Santiago Tuxtla",
          state_id: "2457",
        },
        {
          id: "29342",
          name: "Sayula",
          state_id: "2457",
        },
        {
          id: "29343",
          name: "Soconusco",
          state_id: "2457",
        },
        {
          id: "29344",
          name: "Soledad",
          state_id: "2457",
        },
        {
          id: "29345",
          name: "Soteapan",
          state_id: "2457",
        },
        {
          id: "29346",
          name: "Tamalin",
          state_id: "2457",
        },
        {
          id: "29347",
          name: "Tamiahua",
          state_id: "2457",
        },
        {
          id: "29348",
          name: "Tantoyuca",
          state_id: "2457",
        },
        {
          id: "29349",
          name: "Tatahuicapan",
          state_id: "2457",
        },
        {
          id: "29350",
          name: "Tecolutla",
          state_id: "2457",
        },
        {
          id: "29351",
          name: "Tempoal",
          state_id: "2457",
        },
        {
          id: "29352",
          name: "Tenango de Rio Blanco",
          state_id: "2457",
        },
        {
          id: "29353",
          name: "Teocelo",
          state_id: "2457",
        },
        {
          id: "29354",
          name: "Tepetzintla",
          state_id: "2457",
        },
        {
          id: "29355",
          name: "Tequila",
          state_id: "2457",
        },
        {
          id: "29356",
          name: "Tetelzingo",
          state_id: "2457",
        },
        {
          id: "29357",
          name: "Texistepec",
          state_id: "2457",
        },
        {
          id: "29358",
          name: "Tezonapa",
          state_id: "2457",
        },
        {
          id: "29359",
          name: "Tierra Blanca",
          state_id: "2457",
        },
        {
          id: "29360",
          name: "Tihuatlan",
          state_id: "2457",
        },
        {
          id: "29361",
          name: "Tlacojalpan",
          state_id: "2457",
        },
        {
          id: "29362",
          name: "Tlacotalpan",
          state_id: "2457",
        },
        {
          id: "29363",
          name: "Tlaltetela",
          state_id: "2457",
        },
        {
          id: "29364",
          name: "Tlapacoyan",
          state_id: "2457",
        },
        {
          id: "29365",
          name: "Tocuila",
          state_id: "2457",
        },
        {
          id: "29366",
          name: "Tomatlan",
          state_id: "2457",
        },
        {
          id: "29367",
          name: "Totolapa",
          state_id: "2457",
        },
        {
          id: "29368",
          name: "Totula",
          state_id: "2457",
        },
        {
          id: "29369",
          name: "Tres Valles",
          state_id: "2457",
        },
        {
          id: "29370",
          name: "Tuxpam",
          state_id: "2457",
        },
        {
          id: "29371",
          name: "Tuxtla",
          state_id: "2457",
        },
        {
          id: "29372",
          name: "Tuzamapan",
          state_id: "2457",
        },
        {
          id: "29373",
          name: "Union y Progreso",
          state_id: "2457",
        },
        {
          id: "29374",
          name: "Ursulo Galvan",
          state_id: "2457",
        },
        {
          id: "29375",
          name: "Valente Diaz",
          state_id: "2457",
        },
        {
          id: "29376",
          name: "Vega de Alatorre",
          state_id: "2457",
        },
        {
          id: "29377",
          name: "Veracruz",
          state_id: "2457",
        },
        {
          id: "29378",
          name: "Xalapa",
          state_id: "2457",
        },
        {
          id: "29379",
          name: "Xico",
          state_id: "2457",
        },
        {
          id: "29380",
          name: "Xocotla",
          state_id: "2457",
        },
        {
          id: "29381",
          name: "Yanga",
          state_id: "2457",
        },
        {
          id: "29382",
          name: "Yecuatla",
          state_id: "2457",
        },
        {
          id: "29383",
          name: "Zaragoza",
          state_id: "2457",
        },
        {
          id: "29384",
          name: "Zempoala",
          state_id: "2457",
        },
        {
          id: "29385",
          name: "Zongolica",
          state_id: "2457",
        },
        {
          id: "29386",
          name: "Zozocolco",
          state_id: "2457",
        },
      ],
      Yucatan: [
        {
          id: "29387",
          name: "Acanceh",
          state_id: "2458",
        },
        {
          id: "29388",
          name: "Akil",
          state_id: "2458",
        },
        {
          id: "29389",
          name: "Baca",
          state_id: "2458",
        },
        {
          id: "29390",
          name: "Buctzotz",
          state_id: "2458",
        },
        {
          id: "29391",
          name: "Cacalchen",
          state_id: "2458",
        },
        {
          id: "29392",
          name: "Cansahcab",
          state_id: "2458",
        },
        {
          id: "29393",
          name: "Caucel",
          state_id: "2458",
        },
        {
          id: "29394",
          name: "Celestun",
          state_id: "2458",
        },
        {
          id: "29395",
          name: "Cenotillo",
          state_id: "2458",
        },
        {
          id: "29396",
          name: "Chemax",
          state_id: "2458",
        },
        {
          id: "29397",
          name: "Chichimila",
          state_id: "2458",
        },
        {
          id: "29398",
          name: "Chicxulub",
          state_id: "2458",
        },
        {
          id: "29399",
          name: "Chochola",
          state_id: "2458",
        },
        {
          id: "29400",
          name: "Cholul",
          state_id: "2458",
        },
        {
          id: "29401",
          name: "Chumayel",
          state_id: "2458",
        },
        {
          id: "29402",
          name: "Conkal",
          state_id: "2458",
        },
        {
          id: "29403",
          name: "Cuzama",
          state_id: "2458",
        },
        {
          id: "29404",
          name: "Dzan",
          state_id: "2458",
        },
        {
          id: "29405",
          name: "Dzemul",
          state_id: "2458",
        },
        {
          id: "29406",
          name: "Dzidzantun",
          state_id: "2458",
        },
        {
          id: "29407",
          name: "Dzilam Gonzalez",
          state_id: "2458",
        },
        {
          id: "29408",
          name: "Dzitas",
          state_id: "2458",
        },
        {
          id: "29409",
          name: "Espita",
          state_id: "2458",
        },
        {
          id: "29410",
          name: "Halacho",
          state_id: "2458",
        },
        {
          id: "29411",
          name: "Hocaba",
          state_id: "2458",
        },
        {
          id: "29412",
          name: "Hoctun",
          state_id: "2458",
        },
        {
          id: "29413",
          name: "Homun",
          state_id: "2458",
        },
        {
          id: "29414",
          name: "Huhi",
          state_id: "2458",
        },
        {
          id: "29415",
          name: "Hunucma",
          state_id: "2458",
        },
        {
          id: "29416",
          name: "Itzincab",
          state_id: "2458",
        },
        {
          id: "29417",
          name: "Ixil",
          state_id: "2458",
        },
        {
          id: "29418",
          name: "Izamal",
          state_id: "2458",
        },
        {
          id: "29419",
          name: "Kanasin",
          state_id: "2458",
        },
        {
          id: "29420",
          name: "Kantunil",
          state_id: "2458",
        },
        {
          id: "29421",
          name: "Kinchil",
          state_id: "2458",
        },
        {
          id: "29422",
          name: "Mama",
          state_id: "2458",
        },
        {
          id: "29423",
          name: "Mani",
          state_id: "2458",
        },
        {
          id: "29424",
          name: "Maxcanu",
          state_id: "2458",
        },
        {
          id: "29425",
          name: "Merida",
          state_id: "2458",
        },
        {
          id: "29426",
          name: "Motul",
          state_id: "2458",
        },
        {
          id: "29427",
          name: "Muna",
          state_id: "2458",
        },
        {
          id: "29428",
          name: "Opichen",
          state_id: "2458",
        },
        {
          id: "29429",
          name: "Oxkutzcab",
          state_id: "2458",
        },
        {
          id: "29430",
          name: "Panaba",
          state_id: "2458",
        },
        {
          id: "29431",
          name: "Peto",
          state_id: "2458",
        },
        {
          id: "29432",
          name: "Piste",
          state_id: "2458",
        },
        {
          id: "29433",
          name: "Progreso",
          state_id: "2458",
        },
        {
          id: "29434",
          name: "Sacalum",
          state_id: "2458",
        },
        {
          id: "29435",
          name: "Santa Elena",
          state_id: "2458",
        },
        {
          id: "29436",
          name: "Seye",
          state_id: "2458",
        },
        {
          id: "29437",
          name: "Sotuta",
          state_id: "2458",
        },
        {
          id: "29438",
          name: "Sucila",
          state_id: "2458",
        },
        {
          id: "29439",
          name: "Tahmek",
          state_id: "2458",
        },
        {
          id: "29440",
          name: "Teabo",
          state_id: "2458",
        },
        {
          id: "29441",
          name: "Tecoh",
          state_id: "2458",
        },
        {
          id: "29442",
          name: "Tekanto",
          state_id: "2458",
        },
        {
          id: "29443",
          name: "Tekax",
          state_id: "2458",
        },
        {
          id: "29444",
          name: "Tekit",
          state_id: "2458",
        },
        {
          id: "29445",
          name: "Telchac",
          state_id: "2458",
        },
        {
          id: "29446",
          name: "Temax",
          state_id: "2458",
        },
        {
          id: "29447",
          name: "Temozon",
          state_id: "2458",
        },
        {
          id: "29448",
          name: "Tetiz",
          state_id: "2458",
        },
        {
          id: "29449",
          name: "Ticul",
          state_id: "2458",
        },
        {
          id: "29450",
          name: "Timucuy",
          state_id: "2458",
        },
        {
          id: "29451",
          name: "Tixkokob",
          state_id: "2458",
        },
        {
          id: "29452",
          name: "Tixpehual",
          state_id: "2458",
        },
        {
          id: "29453",
          name: "Tizimin",
          state_id: "2458",
        },
        {
          id: "29454",
          name: "Tunkas",
          state_id: "2458",
        },
        {
          id: "29455",
          name: "Tzucacab",
          state_id: "2458",
        },
        {
          id: "29456",
          name: "Uman",
          state_id: "2458",
        },
        {
          id: "29457",
          name: "Valladolid",
          state_id: "2458",
        },
        {
          id: "29458",
          name: "X-Can",
          state_id: "2458",
        },
        {
          id: "29459",
          name: "Yucatan",
          state_id: "2458",
        },
      ],
      Zacatecas: [
        {
          id: "29460",
          name: "Apozol",
          state_id: "2459",
        },
        {
          id: "29461",
          name: "Banon",
          state_id: "2459",
        },
        {
          id: "29462",
          name: "Canitas",
          state_id: "2459",
        },
        {
          id: "29463",
          name: "Chalchihuites",
          state_id: "2459",
        },
        {
          id: "29464",
          name: "Concepcion del Oro",
          state_id: "2459",
        },
        {
          id: "29465",
          name: "Cos",
          state_id: "2459",
        },
        {
          id: "29466",
          name: "Estrada",
          state_id: "2459",
        },
        {
          id: "29467",
          name: "Fresnillo",
          state_id: "2459",
        },
        {
          id: "29468",
          name: "Garcia",
          state_id: "2459",
        },
        {
          id: "29469",
          name: "Gonzalez Ortega",
          state_id: "2459",
        },
        {
          id: "29470",
          name: "Guadalupe",
          state_id: "2459",
        },
        {
          id: "29471",
          name: "Hidalgo",
          state_id: "2459",
        },
        {
          id: "29472",
          name: "Jalpa",
          state_id: "2459",
        },
        {
          id: "29473",
          name: "Jerez",
          state_id: "2459",
        },
        {
          id: "29474",
          name: "Juan Aldama",
          state_id: "2459",
        },
        {
          id: "29475",
          name: "Juchipila",
          state_id: "2459",
        },
        {
          id: "29476",
          name: "Loreto",
          state_id: "2459",
        },
        {
          id: "29477",
          name: "Lourdes",
          state_id: "2459",
        },
        {
          id: "29478",
          name: "Luis Moya",
          state_id: "2459",
        },
        {
          id: "29479",
          name: "Miguel Auza",
          state_id: "2459",
        },
        {
          id: "29480",
          name: "Monte Escobedo",
          state_id: "2459",
        },
        {
          id: "29481",
          name: "Morelos",
          state_id: "2459",
        },
        {
          id: "29482",
          name: "Natera",
          state_id: "2459",
        },
        {
          id: "29483",
          name: "Nieves",
          state_id: "2459",
        },
        {
          id: "29484",
          name: "Nochistlan",
          state_id: "2459",
        },
        {
          id: "29485",
          name: "Ojo Caliente",
          state_id: "2459",
        },
        {
          id: "29486",
          name: "Piedra Gorda",
          state_id: "2459",
        },
        {
          id: "29487",
          name: "Pinos",
          state_id: "2459",
        },
        {
          id: "29488",
          name: "Plateros",
          state_id: "2459",
        },
        {
          id: "29489",
          name: "Pozo de Gamboa",
          state_id: "2459",
        },
        {
          id: "29490",
          name: "Rio Grande",
          state_id: "2459",
        },
        {
          id: "29491",
          name: "Sain Alto",
          state_id: "2459",
        },
        {
          id: "29492",
          name: "Sombrerete",
          state_id: "2459",
        },
        {
          id: "29493",
          name: "Tabasco",
          state_id: "2459",
        },
        {
          id: "29494",
          name: "Tacoaleche",
          state_id: "2459",
        },
        {
          id: "29495",
          name: "Tepechitlan",
          state_id: "2459",
        },
        {
          id: "29496",
          name: "Teul",
          state_id: "2459",
        },
        {
          id: "29497",
          name: "Tlaltenango",
          state_id: "2459",
        },
        {
          id: "29498",
          name: "Toribio",
          state_id: "2459",
        },
        {
          id: "29499",
          name: "Trancoso",
          state_id: "2459",
        },
        {
          id: "29500",
          name: "Valparaiso",
          state_id: "2459",
        },
        {
          id: "29501",
          name: "Victor Rosales",
          state_id: "2459",
        },
        {
          id: "29502",
          name: "Villa Gonzalez Ortega",
          state_id: "2459",
        },
        {
          id: "29503",
          name: "Villanueva",
          state_id: "2459",
        },
        {
          id: "29504",
          name: "Zacatecas",
          state_id: "2459",
        },
      ],
    },
  },
  MY: {
    name: "Malaysia",
    native: "Malaysia",
    phone: "60",
    continent: "AS",
    capital: "Kuala Lumpur",
    currency: "MYR",
    languages: ["ms"],
    emoji: "🇲🇾",
    emojiU: "U+1F1F2 U+1F1FE",
    states: {
      Johor: [
        {
          id: "26917",
          name: "Bandar Maharani",
          state_id: "2307",
        },
        {
          id: "26918",
          name: "Bandar Penggaram",
          state_id: "2307",
        },
        {
          id: "26919",
          name: "Bukit Bakri",
          state_id: "2307",
        },
        {
          id: "26920",
          name: "Buloh Kasap",
          state_id: "2307",
        },
        {
          id: "26921",
          name: "Chaah",
          state_id: "2307",
        },
        {
          id: "26922",
          name: "Johor Bahru",
          state_id: "2307",
        },
        {
          id: "26923",
          name: "Kelapa Sawit",
          state_id: "2307",
        },
        {
          id: "26924",
          name: "Kluang",
          state_id: "2307",
        },
        {
          id: "26925",
          name: "Kota Tinggi",
          state_id: "2307",
        },
        {
          id: "26926",
          name: "Kulai",
          state_id: "2307",
        },
        {
          id: "26927",
          name: "Labis",
          state_id: "2307",
        },
        {
          id: "26928",
          name: "Ledang",
          state_id: "2307",
        },
        {
          id: "26929",
          name: "Masai",
          state_id: "2307",
        },
        {
          id: "26930",
          name: "Mersing",
          state_id: "2307",
        },
        {
          id: "26931",
          name: "Parit Raja",
          state_id: "2307",
        },
        {
          id: "26932",
          name: "Pasir Gudang",
          state_id: "2307",
        },
        {
          id: "26933",
          name: "Pekan Nenas",
          state_id: "2307",
        },
        {
          id: "26934",
          name: "Pontian Kecil",
          state_id: "2307",
        },
        {
          id: "26935",
          name: "Segamat",
          state_id: "2307",
        },
        {
          id: "26936",
          name: "Sekudai",
          state_id: "2307",
        },
        {
          id: "26937",
          name: "Senai",
          state_id: "2307",
        },
        {
          id: "26938",
          name: "Simpang Rengam",
          state_id: "2307",
        },
        {
          id: "26939",
          name: "Tangkak",
          state_id: "2307",
        },
        {
          id: "26940",
          name: "Ulu Tiram",
          state_id: "2307",
        },
        {
          id: "26941",
          name: "Yong Peng",
          state_id: "2307",
        },
      ],
      Kedah: [
        {
          id: "26942",
          name: "Alor Setar",
          state_id: "2308",
        },
        {
          id: "26943",
          name: "Bailing",
          state_id: "2308",
        },
        {
          id: "26944",
          name: "Bedong",
          state_id: "2308",
        },
        {
          id: "26945",
          name: "Gurun",
          state_id: "2308",
        },
        {
          id: "26946",
          name: "Jitra",
          state_id: "2308",
        },
        {
          id: "26947",
          name: "Kuah",
          state_id: "2308",
        },
        {
          id: "26948",
          name: "Kuala Kedah",
          state_id: "2308",
        },
        {
          id: "26949",
          name: "Kulim",
          state_id: "2308",
        },
        {
          id: "26950",
          name: "Langgar",
          state_id: "2308",
        },
        {
          id: "26951",
          name: "Sungai Petani",
          state_id: "2308",
        },
      ],
      Kelantan: [
        {
          id: "26952",
          name: "Gua Musang",
          state_id: "2309",
        },
        {
          id: "26953",
          name: "Kadok",
          state_id: "2309",
        },
        {
          id: "26954",
          name: "Kota Bahru",
          state_id: "2309",
        },
        {
          id: "26955",
          name: "Kuala Krai",
          state_id: "2309",
        },
        {
          id: "26956",
          name: "Pangkal Kalong",
          state_id: "2309",
        },
        {
          id: "26957",
          name: "Pasir Mas",
          state_id: "2309",
        },
        {
          id: "26958",
          name: "Peringat",
          state_id: "2309",
        },
        {
          id: "26959",
          name: "Tanah Merah",
          state_id: "2309",
        },
        {
          id: "26960",
          name: "Tumpat",
          state_id: "2309",
        },
        {
          id: "26961",
          name: "Wakaf Baru",
          state_id: "2309",
        },
      ],
      "Kuala Lumpur": [],
      Labuan: [
        {
          id: "26962",
          name: "Labuan",
          state_id: "2311",
        },
      ],
      Melaka: [
        {
          id: "26963",
          name: "Alor Gajah",
          state_id: "2312",
        },
        {
          id: "26964",
          name: "Ayer Keroh",
          state_id: "2312",
        },
        {
          id: "26965",
          name: "Ayer Molek",
          state_id: "2312",
        },
        {
          id: "26966",
          name: "Batu Berendam",
          state_id: "2312",
        },
        {
          id: "26967",
          name: "Bemban",
          state_id: "2312",
        },
        {
          id: "26968",
          name: "Bukit Baru",
          state_id: "2312",
        },
        {
          id: "26969",
          name: "Bukit Rambai",
          state_id: "2312",
        },
        {
          id: "26970",
          name: "Klebang",
          state_id: "2312",
        },
        {
          id: "26971",
          name: "Kuala Sungai Baru",
          state_id: "2312",
        },
        {
          id: "26972",
          name: "Malacca",
          state_id: "2312",
        },
        {
          id: "26973",
          name: "Masjid Tanah",
          state_id: "2312",
        },
        {
          id: "26974",
          name: "Melaka",
          state_id: "2312",
        },
        {
          id: "26975",
          name: "Pulau Sebang",
          state_id: "2312",
        },
        {
          id: "26976",
          name: "Sungai Udang",
          state_id: "2312",
        },
      ],
      "Negeri Johor": [],
      "Negeri Sembilan": [],
      Pahang: [
        {
          id: "26977",
          name: "Bandar Jengka Pusat",
          state_id: "2315",
        },
        {
          id: "26978",
          name: "Bentong",
          state_id: "2315",
        },
        {
          id: "26979",
          name: "Bukit Tinggi",
          state_id: "2315",
        },
        {
          id: "26980",
          name: "Jerantut",
          state_id: "2315",
        },
        {
          id: "26981",
          name: "Karak",
          state_id: "2315",
        },
        {
          id: "26982",
          name: "Kuala Lipis",
          state_id: "2315",
        },
        {
          id: "26983",
          name: "Kuantan",
          state_id: "2315",
        },
        {
          id: "26984",
          name: "Mentakab",
          state_id: "2315",
        },
        {
          id: "26985",
          name: "Pekan",
          state_id: "2315",
        },
        {
          id: "26986",
          name: "Pulau Pinang",
          state_id: "2315",
        },
        {
          id: "26987",
          name: "Raub",
          state_id: "2315",
        },
        {
          id: "26988",
          name: "Temerloh",
          state_id: "2315",
        },
      ],
      Penang: [
        {
          id: "26989",
          name: "Bayan Lepas",
          state_id: "2316",
        },
        {
          id: "26990",
          name: "Church Town",
          state_id: "2316",
        },
        {
          id: "26991",
          name: "George Town",
          state_id: "2316",
        },
      ],
      Perak: [
        {
          id: "26992",
          name: "Ayer Tawar",
          state_id: "2317",
        },
        {
          id: "26993",
          name: "Bagan Serai",
          state_id: "2317",
        },
        {
          id: "26994",
          name: "Batu Gajah",
          state_id: "2317",
        },
        {
          id: "26995",
          name: "Bidor",
          state_id: "2317",
        },
        {
          id: "26996",
          name: "Ipoh",
          state_id: "2317",
        },
        {
          id: "26997",
          name: "Jelapang",
          state_id: "2317",
        },
        {
          id: "26998",
          name: "Kampar",
          state_id: "2317",
        },
        {
          id: "26999",
          name: "Kampong Koh",
          state_id: "2317",
        },
        {
          id: "27000",
          name: "Kuala Kangsar",
          state_id: "2317",
        },
        {
          id: "27001",
          name: "Lawan Kuda Baharu",
          state_id: "2317",
        },
        {
          id: "27002",
          name: "Lumut",
          state_id: "2317",
        },
        {
          id: "27003",
          name: "Pantai Remis",
          state_id: "2317",
        },
        {
          id: "27004",
          name: "Parit Buntar",
          state_id: "2317",
        },
        {
          id: "27005",
          name: "Perak",
          state_id: "2317",
        },
        {
          id: "27006",
          name: "Pusing",
          state_id: "2317",
        },
        {
          id: "27007",
          name: "Simpang Empat",
          state_id: "2317",
        },
        {
          id: "27008",
          name: "Sungai Siput Utara",
          state_id: "2317",
        },
        {
          id: "27009",
          name: "Taiping",
          state_id: "2317",
        },
        {
          id: "27010",
          name: "Tanjong Malim",
          state_id: "2317",
        },
        {
          id: "27011",
          name: "Tapah",
          state_id: "2317",
        },
        {
          id: "27012",
          name: "Teluk Intan",
          state_id: "2317",
        },
      ],
      Perlis: [
        {
          id: "27013",
          name: "Kangar",
          state_id: "2318",
        },
        {
          id: "27014",
          name: "Kuala Perlis",
          state_id: "2318",
        },
      ],
      "Pulau Pinang": [],
      Sabah: [
        {
          id: "27015",
          name: "Beaufort",
          state_id: "2320",
        },
        {
          id: "27016",
          name: "Donggongon",
          state_id: "2320",
        },
        {
          id: "27017",
          name: "Keningau",
          state_id: "2320",
        },
        {
          id: "27018",
          name: "Kinarut",
          state_id: "2320",
        },
        {
          id: "27019",
          name: "Kota Belud",
          state_id: "2320",
        },
        {
          id: "27020",
          name: "Kota Kinabalu",
          state_id: "2320",
        },
        {
          id: "27021",
          name: "Kudat",
          state_id: "2320",
        },
        {
          id: "27022",
          name: "Kunak",
          state_id: "2320",
        },
        {
          id: "27023",
          name: "Lahad Datu",
          state_id: "2320",
        },
        {
          id: "27024",
          name: "Papar",
          state_id: "2320",
        },
        {
          id: "27025",
          name: "Putatan",
          state_id: "2320",
        },
        {
          id: "27026",
          name: "Ranau",
          state_id: "2320",
        },
        {
          id: "27027",
          name: "Sandakan",
          state_id: "2320",
        },
        {
          id: "27028",
          name: "Semporna",
          state_id: "2320",
        },
        {
          id: "27029",
          name: "Tawau",
          state_id: "2320",
        },
      ],
      Sarawak: [
        {
          id: "27030",
          name: "Batu Delapan Bazaar",
          state_id: "2321",
        },
        {
          id: "27031",
          name: "Bintulu",
          state_id: "2321",
        },
        {
          id: "27032",
          name: "Kapit",
          state_id: "2321",
        },
        {
          id: "27033",
          name: "Kota Samarahan",
          state_id: "2321",
        },
        {
          id: "27034",
          name: "Kuching",
          state_id: "2321",
        },
        {
          id: "27035",
          name: "Limbang",
          state_id: "2321",
        },
        {
          id: "27036",
          name: "Miri",
          state_id: "2321",
        },
        {
          id: "27037",
          name: "Sarawak",
          state_id: "2321",
        },
        {
          id: "27038",
          name: "Sarikel",
          state_id: "2321",
        },
        {
          id: "27039",
          name: "Sibu",
          state_id: "2321",
        },
        {
          id: "27040",
          name: "Sri Aman",
          state_id: "2321",
        },
      ],
      Selangor: [
        {
          id: "27041",
          name: "Ampang",
          state_id: "2322",
        },
        {
          id: "27042",
          name: "Ampang Jaya",
          state_id: "2322",
        },
        {
          id: "27043",
          name: "Balakong",
          state_id: "2322",
        },
        {
          id: "27044",
          name: "Bandar Baru Bangi",
          state_id: "2322",
        },
        {
          id: "27045",
          name: "Bandar Baru Salak Tinggi",
          state_id: "2322",
        },
        {
          id: "27046",
          name: "Bander Baro Bangi",
          state_id: "2322",
        },
        {
          id: "27047",
          name: "Banting",
          state_id: "2322",
        },
        {
          id: "27048",
          name: "Batang Berjuntai",
          state_id: "2322",
        },
        {
          id: "27049",
          name: "Batu Arang",
          state_id: "2322",
        },
        {
          id: "27050",
          name: "Batu Sembilan Cheras",
          state_id: "2322",
        },
        {
          id: "27051",
          name: "Beranang",
          state_id: "2322",
        },
        {
          id: "27052",
          name: "Bukit Beruntung",
          state_id: "2322",
        },
        {
          id: "27053",
          name: "Cyberjaya",
          state_id: "2322",
        },
        {
          id: "27054",
          name: "Darul Ehsan",
          state_id: "2322",
        },
        {
          id: "27055",
          name: "Dungun",
          state_id: "2322",
        },
        {
          id: "27056",
          name: "Gombak Setia",
          state_id: "2322",
        },
        {
          id: "27057",
          name: "Jenjarom",
          state_id: "2322",
        },
        {
          id: "27058",
          name: "Kajang",
          state_id: "2322",
        },
        {
          id: "27059",
          name: "Kajang-Sungai Chua",
          state_id: "2322",
        },
        {
          id: "27060",
          name: "Klang",
          state_id: "2322",
        },
        {
          id: "27061",
          name: "Kuala Kubu Baru",
          state_id: "2322",
        },
        {
          id: "27062",
          name: "Kuala Selangor",
          state_id: "2322",
        },
        {
          id: "27063",
          name: "Kuang",
          state_id: "2322",
        },
        {
          id: "27064",
          name: "Pengkalan Kundang",
          state_id: "2322",
        },
        {
          id: "27065",
          name: "Petaling Jaya",
          state_id: "2322",
        },
        {
          id: "27066",
          name: "Port Klang",
          state_id: "2322",
        },
        {
          id: "27067",
          name: "Puchong",
          state_id: "2322",
        },
        {
          id: "27068",
          name: "Rawang",
          state_id: "2322",
        },
        {
          id: "27069",
          name: "Sabak",
          state_id: "2322",
        },
        {
          id: "27070",
          name: "Sekinchan",
          state_id: "2322",
        },
        {
          id: "27071",
          name: "Selayang Baru",
          state_id: "2322",
        },
        {
          id: "27072",
          name: "Semenyih",
          state_id: "2322",
        },
        {
          id: "27073",
          name: "Serendah",
          state_id: "2322",
        },
        {
          id: "27074",
          name: "Seri Kembangan",
          state_id: "2322",
        },
        {
          id: "27075",
          name: "Shah Alam",
          state_id: "2322",
        },
        {
          id: "27076",
          name: "Subang Jaya",
          state_id: "2322",
        },
        {
          id: "27077",
          name: "Sungai Besar",
          state_id: "2322",
        },
        {
          id: "27078",
          name: "Sungai Buloh",
          state_id: "2322",
        },
        {
          id: "27079",
          name: "Sungai Pelek",
          state_id: "2322",
        },
        {
          id: "27080",
          name: "Taman Greenwood",
          state_id: "2322",
        },
        {
          id: "27081",
          name: "Tanjong Karang",
          state_id: "2322",
        },
        {
          id: "27082",
          name: "Tanjong Sepat",
          state_id: "2322",
        },
      ],
      Sembilan: [
        {
          id: "27083",
          name: "Bahaiyah",
          state_id: "2323",
        },
        {
          id: "27084",
          name: "Langkap",
          state_id: "2323",
        },
      ],
      Terengganu: [
        {
          id: "27085",
          name: "Cukai",
          state_id: "2324",
        },
        {
          id: "27086",
          name: "Jertih",
          state_id: "2324",
        },
        {
          id: "27087",
          name: "Kemaman",
          state_id: "2324",
        },
        {
          id: "27088",
          name: "Kerteh",
          state_id: "2324",
        },
        {
          id: "27089",
          name: "Kuala Terengganu",
          state_id: "2324",
        },
        {
          id: "27090",
          name: "Marang",
          state_id: "2324",
        },
        {
          id: "27091",
          name: "Paka",
          state_id: "2324",
        },
        {
          id: "27092",
          name: "Serdang",
          state_id: "2324",
        },
      ],
    },
  },
  MZ: {
    name: "Mozambique",
    native: "Moçambique",
    phone: "258",
    continent: "AF",
    capital: "Maputo",
    currency: "MZN",
    languages: ["pt"],
    emoji: "🇲🇿",
    emojiU: "U+1F1F2 U+1F1FF",
    states: {
      "Cabo Delgado": [],
      Gaza: [
        {
          id: "29643",
          name: "Chibuto",
          state_id: "2527",
        },
        {
          id: "29644",
          name: "Chidenguele",
          state_id: "2527",
        },
        {
          id: "29645",
          name: "Chokwe",
          state_id: "2527",
        },
        {
          id: "29646",
          name: "Chongoene",
          state_id: "2527",
        },
        {
          id: "29647",
          name: "Guija",
          state_id: "2527",
        },
        {
          id: "29648",
          name: "Macia",
          state_id: "2527",
        },
        {
          id: "29649",
          name: "Manjacaze",
          state_id: "2527",
        },
        {
          id: "29650",
          name: "Xai-Xai",
          state_id: "2527",
        },
      ],
      Inhambane: [
        {
          id: "29651",
          name: "Homoine",
          state_id: "2528",
        },
        {
          id: "29652",
          name: "Inhambane",
          state_id: "2528",
        },
        {
          id: "29653",
          name: "Inharrime",
          state_id: "2528",
        },
        {
          id: "29654",
          name: "Jangamo",
          state_id: "2528",
        },
        {
          id: "29655",
          name: "Maxixe",
          state_id: "2528",
        },
        {
          id: "29656",
          name: "Panda",
          state_id: "2528",
        },
        {
          id: "29657",
          name: "Quissico",
          state_id: "2528",
        },
      ],
      Manica: [
        {
          id: "29658",
          name: "Chimoio",
          state_id: "2529",
        },
        {
          id: "29659",
          name: "Manica",
          state_id: "2529",
        },
      ],
      Maputo: [
        {
          id: "29660",
          name: "Maputo",
          state_id: "2530",
        },
      ],
      "Maputo Provincia": [
        {
          id: "29661",
          name: "Maputo",
          state_id: "2531",
        },
      ],
      Nampula: [
        {
          id: "29662",
          name: "Angoche",
          state_id: "2532",
        },
        {
          id: "29663",
          name: "Lumbo",
          state_id: "2532",
        },
        {
          id: "29664",
          name: "Mocambique",
          state_id: "2532",
        },
        {
          id: "29665",
          name: "Nacala",
          state_id: "2532",
        },
        {
          id: "29666",
          name: "Nampula",
          state_id: "2532",
        },
      ],
      Niassa: [
        {
          id: "29667",
          name: "Cuamba",
          state_id: "2533",
        },
        {
          id: "29668",
          name: "Lichinga",
          state_id: "2533",
        },
        {
          id: "29669",
          name: "Mandimba",
          state_id: "2533",
        },
        {
          id: "29670",
          name: "Maniamba",
          state_id: "2533",
        },
        {
          id: "29671",
          name: "Marrupa",
          state_id: "2533",
        },
      ],
      Sofala: [
        {
          id: "29672",
          name: "Beira",
          state_id: "2534",
        },
        {
          id: "29673",
          name: "Dondo",
          state_id: "2534",
        },
      ],
      Tete: [
        {
          id: "29674",
          name: "Tete",
          state_id: "2535",
        },
        {
          id: "29675",
          name: "Zumbo",
          state_id: "2535",
        },
      ],
      Zambezia: [
        {
          id: "29676",
          name: "Garue",
          state_id: "2536",
        },
        {
          id: "29677",
          name: "Mocuba",
          state_id: "2536",
        },
        {
          id: "29678",
          name: "Quelimane",
          state_id: "2536",
        },
      ],
    },
  },
  NA: {
    name: "Namibia",
    native: "Namibia",
    phone: "264",
    continent: "AF",
    capital: "Windhoek",
    currency: "NAD,ZAR",
    languages: ["en", "af"],
    emoji: "🇳🇦",
    emojiU: "U+1F1F3 U+1F1E6",
    states: {
      Caprivi: [
        {
          id: "29746",
          name: "Katima Mulilo",
          state_id: "2552",
        },
      ],
      Erongo: [
        {
          id: "29747",
          name: "Henties Bay",
          state_id: "2553",
        },
        {
          id: "29748",
          name: "Karibib",
          state_id: "2553",
        },
        {
          id: "29749",
          name: "Kuisebmond",
          state_id: "2553",
        },
        {
          id: "29750",
          name: "Omaruru",
          state_id: "2553",
        },
        {
          id: "29751",
          name: "Otjimbingwe",
          state_id: "2553",
        },
        {
          id: "29752",
          name: "Swakopmund",
          state_id: "2553",
        },
        {
          id: "29753",
          name: "Usakos",
          state_id: "2553",
        },
        {
          id: "29754",
          name: "Walvis Bay",
          state_id: "2553",
        },
      ],
      Hardap: [
        {
          id: "29755",
          name: "Aranos",
          state_id: "2554",
        },
        {
          id: "29756",
          name: "Maltahohe",
          state_id: "2554",
        },
        {
          id: "29757",
          name: "Mariental",
          state_id: "2554",
        },
        {
          id: "29758",
          name: "Rehoboth",
          state_id: "2554",
        },
      ],
      Karas: [
        {
          id: "29759",
          name: "Bethanien",
          state_id: "2555",
        },
        {
          id: "29760",
          name: "Karasburg",
          state_id: "2555",
        },
        {
          id: "29761",
          name: "Keetmanshoop",
          state_id: "2555",
        },
        {
          id: "29762",
          name: "Luderitz",
          state_id: "2555",
        },
        {
          id: "29763",
          name: "Oranjemund",
          state_id: "2555",
        },
        {
          id: "29764",
          name: "Warmbad",
          state_id: "2555",
        },
      ],
      Kavango: [
        {
          id: "29765",
          name: "Rundu",
          state_id: "2556",
        },
      ],
      Khomas: [
        {
          id: "29766",
          name: "Windhoek",
          state_id: "2557",
        },
      ],
      Kunene: [
        {
          id: "29767",
          name: "Arandis",
          state_id: "2558",
        },
        {
          id: "29768",
          name: "Khorixas",
          state_id: "2558",
        },
        {
          id: "29769",
          name: "Opuwo",
          state_id: "2558",
        },
        {
          id: "29770",
          name: "Outjo",
          state_id: "2558",
        },
      ],
      Ohangwena: [
        {
          id: "29771",
          name: "Oshikango",
          state_id: "2559",
        },
      ],
      Omaheke: [
        {
          id: "29772",
          name: "Gobabis",
          state_id: "2560",
        },
        {
          id: "29773",
          name: "Leonardville",
          state_id: "2560",
        },
      ],
      Omusati: [
        {
          id: "29774",
          name: "Ongandjera",
          state_id: "2561",
        },
      ],
      Oshana: [
        {
          id: "29775",
          name: "Ongwediva",
          state_id: "2562",
        },
        {
          id: "29776",
          name: "Oshakati",
          state_id: "2562",
        },
      ],
      Oshikoto: [
        {
          id: "29777",
          name: "Ondangwa",
          state_id: "2563",
        },
        {
          id: "29778",
          name: "Otavi",
          state_id: "2563",
        },
        {
          id: "29779",
          name: "Tsumeb",
          state_id: "2563",
        },
      ],
      Otjozondjupa: [
        {
          id: "29780",
          name: "Grootfontein",
          state_id: "2564",
        },
        {
          id: "29781",
          name: "Okahandja",
          state_id: "2564",
        },
        {
          id: "29782",
          name: "Okakarara",
          state_id: "2564",
        },
        {
          id: "29783",
          name: "Otjiwarongo",
          state_id: "2564",
        },
      ],
    },
  },
  NC: {
    name: "New Caledonia",
    native: "Nouvelle-Calédonie",
    phone: "687",
    continent: "OC",
    capital: "Nouméa",
    currency: "XPF",
    languages: ["fr"],
    emoji: "🇳🇨",
    emojiU: "U+1F1F3 U+1F1E8",
    states: {
      Iles: [
        {
          id: "30452",
          name: "Belep",
          state_id: "2600",
        },
        {
          id: "30453",
          name: "Fayaoue",
          state_id: "2600",
        },
        {
          id: "30454",
          name: "Tadine",
          state_id: "2600",
        },
        {
          id: "30455",
          name: "Vao",
          state_id: "2600",
        },
        {
          id: "30456",
          name: "We",
          state_id: "2600",
        },
      ],
      Nord: [
        {
          id: "30457",
          name: "Canala",
          state_id: "2601",
        },
        {
          id: "30458",
          name: "Hienghene",
          state_id: "2601",
        },
        {
          id: "30459",
          name: "Houailu",
          state_id: "2601",
        },
        {
          id: "30460",
          name: "Kaala Gomen",
          state_id: "2601",
        },
        {
          id: "30461",
          name: "Kone",
          state_id: "2601",
        },
        {
          id: "30462",
          name: "Koumac",
          state_id: "2601",
        },
        {
          id: "30463",
          name: "Ouegoa",
          state_id: "2601",
        },
        {
          id: "30464",
          name: "Poindimie",
          state_id: "2601",
        },
        {
          id: "30465",
          name: "Ponerihouen",
          state_id: "2601",
        },
        {
          id: "30466",
          name: "Pouebo",
          state_id: "2601",
        },
        {
          id: "30467",
          name: "Pouembout",
          state_id: "2601",
        },
        {
          id: "30468",
          name: "Poum",
          state_id: "2601",
        },
        {
          id: "30469",
          name: "Poya",
          state_id: "2601",
        },
        {
          id: "30470",
          name: "Touho",
          state_id: "2601",
        },
        {
          id: "30471",
          name: "Voh",
          state_id: "2601",
        },
      ],
      Sud: [
        {
          id: "30472",
          name: "Bouloupari",
          state_id: "2602",
        },
        {
          id: "30473",
          name: "Bourail",
          state_id: "2602",
        },
        {
          id: "30474",
          name: "Dumbea",
          state_id: "2602",
        },
        {
          id: "30475",
          name: "Farino",
          state_id: "2602",
        },
        {
          id: "30476",
          name: "La Foa",
          state_id: "2602",
        },
        {
          id: "30477",
          name: "Moindou",
          state_id: "2602",
        },
        {
          id: "30478",
          name: "Mont-Dore",
          state_id: "2602",
        },
        {
          id: "30479",
          name: "Noumea",
          state_id: "2602",
        },
        {
          id: "30480",
          name: "Paita",
          state_id: "2602",
        },
        {
          id: "30481",
          name: "Sarramea",
          state_id: "2602",
        },
        {
          id: "30482",
          name: "Thio",
          state_id: "2602",
        },
        {
          id: "30483",
          name: "Yate",
          state_id: "2602",
        },
      ],
    },
  },
  NE: {
    name: "Niger",
    native: "Niger",
    phone: "227",
    continent: "AF",
    capital: "Niamey",
    currency: "XOF",
    languages: ["fr"],
    emoji: "🇳🇪",
    emojiU: "U+1F1F3 U+1F1EA",
    states: {
      Agadez: [
        {
          id: "30644",
          name: "Agadez",
          state_id: "2639",
        },
        {
          id: "30645",
          name: "Arlit",
          state_id: "2639",
        },
        {
          id: "30646",
          name: "Bilma",
          state_id: "2639",
        },
        {
          id: "30647",
          name: "Fachi",
          state_id: "2639",
        },
        {
          id: "30648",
          name: "Ingall",
          state_id: "2639",
        },
        {
          id: "30649",
          name: "Tchirozerine",
          state_id: "2639",
        },
      ],
      Diffa: [
        {
          id: "30650",
          name: "Diffa",
          state_id: "2640",
        },
        {
          id: "30651",
          name: "Maine-Soroa",
          state_id: "2640",
        },
        {
          id: "30652",
          name: "N''Guigmi",
          state_id: "2640",
        },
      ],
      Dosso: [
        {
          id: "30653",
          name: "Birni N''Gaoure",
          state_id: "2641",
        },
        {
          id: "30654",
          name: "Boboye",
          state_id: "2641",
        },
        {
          id: "30655",
          name: "Dogondoutchi",
          state_id: "2641",
        },
        {
          id: "30656",
          name: "Dosso",
          state_id: "2641",
        },
        {
          id: "30657",
          name: "Gaya",
          state_id: "2641",
        },
        {
          id: "30658",
          name: "Loga",
          state_id: "2641",
        },
      ],
      Maradi: [
        {
          id: "30659",
          name: "Aguie",
          state_id: "2642",
        },
        {
          id: "30660",
          name: "Dakoro",
          state_id: "2642",
        },
        {
          id: "30661",
          name: "Gazaoua",
          state_id: "2642",
        },
        {
          id: "30662",
          name: "Guidan Roumdji",
          state_id: "2642",
        },
        {
          id: "30663",
          name: "Madarounfa",
          state_id: "2642",
        },
        {
          id: "30664",
          name: "Maradi",
          state_id: "2642",
        },
        {
          id: "30665",
          name: "Mayahi",
          state_id: "2642",
        },
        {
          id: "30666",
          name: "Tessaoua",
          state_id: "2642",
        },
        {
          id: "30667",
          name: "Tibiri",
          state_id: "2642",
        },
      ],
      Niamey: [
        {
          id: "30668",
          name: "Niamey",
          state_id: "2643",
        },
      ],
      Tahoua: [
        {
          id: "30669",
          name: "Birni N''Konni",
          state_id: "2644",
        },
        {
          id: "30670",
          name: "Bouza",
          state_id: "2644",
        },
        {
          id: "30671",
          name: "Illela",
          state_id: "2644",
        },
        {
          id: "30672",
          name: "Keita",
          state_id: "2644",
        },
        {
          id: "30673",
          name: "Madaoua",
          state_id: "2644",
        },
        {
          id: "30674",
          name: "Malbaza''uzine",
          state_id: "2644",
        },
        {
          id: "30675",
          name: "Tahoua",
          state_id: "2644",
        },
        {
          id: "30676",
          name: "Tchintabaraden",
          state_id: "2644",
        },
      ],
      Tillabery: [
        {
          id: "30677",
          name: "Ayorou",
          state_id: "2645",
        },
        {
          id: "30678",
          name: "Filingue",
          state_id: "2645",
        },
        {
          id: "30679",
          name: "Kollo",
          state_id: "2645",
        },
        {
          id: "30680",
          name: "Ouallam",
          state_id: "2645",
        },
        {
          id: "30681",
          name: "Say",
          state_id: "2645",
        },
        {
          id: "30682",
          name: "Tera",
          state_id: "2645",
        },
        {
          id: "30683",
          name: "Tillabery",
          state_id: "2645",
        },
      ],
      Zinder: [
        {
          id: "30684",
          name: "Goure",
          state_id: "2646",
        },
        {
          id: "30685",
          name: "Kantche",
          state_id: "2646",
        },
        {
          id: "30686",
          name: "Magaria",
          state_id: "2646",
        },
        {
          id: "30687",
          name: "Matameye",
          state_id: "2646",
        },
        {
          id: "30688",
          name: "Mirriah",
          state_id: "2646",
        },
        {
          id: "30689",
          name: "Tanout",
          state_id: "2646",
        },
        {
          id: "30690",
          name: "Zinder",
          state_id: "2646",
        },
      ],
    },
  },
  NF: {
    name: "Norfolk Island",
    native: "Norfolk Island",
    phone: "672",
    continent: "OC",
    capital: "Kingston",
    currency: "AUD",
    languages: ["en"],
    emoji: "🇳🇫",
    emojiU: "U+1F1F3 U+1F1EB",
    states: {
      "Norfolk Island": [],
    },
  },
  NG: {
    name: "Nigeria",
    native: "Nigeria",
    phone: "234",
    continent: "AF",
    capital: "Abuja",
    currency: "NGN",
    languages: ["en"],
    emoji: "🇳🇬",
    emojiU: "U+1F1F3 U+1F1EC",
    states: {
      Abia: [
        {
          id: "30691",
          name: "Aba",
          state_id: "2647",
        },
        {
          id: "30692",
          name: "Amaigbo",
          state_id: "2647",
        },
        {
          id: "30693",
          name: "Arochukwu",
          state_id: "2647",
        },
        {
          id: "30694",
          name: "Bende",
          state_id: "2647",
        },
        {
          id: "30695",
          name: "Ohafia",
          state_id: "2647",
        },
        {
          id: "30696",
          name: "Okwe",
          state_id: "2647",
        },
        {
          id: "30697",
          name: "Umuahia",
          state_id: "2647",
        },
      ],
      "Abuja (Federal Capital Territory)": [
        {
          id: "48381",
          name: "Abuja",
          state_id: "2648",
        },
        {
          id: "48382",
          name: "Abaji",
          state_id: "2648",
        },
        {
          id: "48383",
          name: "Bwari",
          state_id: "2648",
        },
        {
          id: "48384",
          name: "Gwagwalada",
          state_id: "2648",
        },
        {
          id: "48385",
          name: "Kubwa",
          state_id: "2648",
        },
        {
          id: "48386",
          name: "Kuje",
          state_id: "2648",
        },
        {
          id: "48387",
          name: "Kwali",
          state_id: "2648",
        },
        {
          id: "48388",
          name: "Zuba",
          state_id: "2648",
        },
        {
          id: "48389",
          name: "Dei dei",
          state_id: "2648",
        },
      ],
      Adamawa: [
        {
          id: "30698",
          name: "Demsa",
          state_id: "2649",
        },
        {
          id: "30699",
          name: "Ganye",
          state_id: "2649",
        },
        {
          id: "30700",
          name: "Girei",
          state_id: "2649",
        },
        {
          id: "30701",
          name: "Gombi",
          state_id: "2649",
        },
        {
          id: "30702",
          name: "Jada",
          state_id: "2649",
        },
        {
          id: "30703",
          name: "Jimeta",
          state_id: "2649",
        },
        {
          id: "30704",
          name: "Lamurde",
          state_id: "2649",
        },
        {
          id: "30705",
          name: "Madagala",
          state_id: "2649",
        },
        {
          id: "30706",
          name: "Maiha",
          state_id: "2649",
        },
        {
          id: "30707",
          name: "Mubi",
          state_id: "2649",
        },
        {
          id: "30708",
          name: "Ngurore",
          state_id: "2649",
        },
        {
          id: "30709",
          name: "Numan",
          state_id: "2649",
        },
        {
          id: "30710",
          name: "Shelleng",
          state_id: "2649",
        },
        {
          id: "30711",
          name: "Song",
          state_id: "2649",
        },
        {
          id: "30712",
          name: "Toungo",
          state_id: "2649",
        },
        {
          id: "30713",
          name: "Yola",
          state_id: "2649",
        },
      ],
      "Akwa Ibom": [
        {
          id: "48352",
          name: "Uyo",
          state_id: "2650",
        },
        {
          id: "48353",
          name: "Eket",
          state_id: "2650",
        },
        {
          id: "48354",
          name: "Ikot Ekpene",
          state_id: "2650",
        },
        {
          id: "48355",
          name: "Ikot Abasi",
          state_id: "2650",
        },
        {
          id: "48356",
          name: "Oron",
          state_id: "2650",
        },
        {
          id: "48357",
          name: "Oruk Anam",
          state_id: "2650",
        },
        {
          id: "48358",
          name: "Ibiono Ibom",
          state_id: "2650",
        },
        {
          id: "48359",
          name: "Nsit Ubiom",
          state_id: "2650",
        },
        {
          id: "48360",
          name: "Nsit Ibom",
          state_id: "2650",
        },
        {
          id: "48361",
          name: "Abak",
          state_id: "2650",
        },
        {
          id: "48362",
          name: "Ibeno",
          state_id: "2650",
        },
      ],
      Anambra: [
        {
          id: "30714",
          name: "Aguata",
          state_id: "2651",
        },
        {
          id: "30715",
          name: "Agulu",
          state_id: "2651",
        },
        {
          id: "30716",
          name: "Anambra",
          state_id: "2651",
        },
        {
          id: "30717",
          name: "Awka",
          state_id: "2651",
        },
        {
          id: "30718",
          name: "Enugu Ukwu",
          state_id: "2651",
        },
        {
          id: "30719",
          name: "Igbo Ukwu",
          state_id: "2651",
        },
        {
          id: "30720",
          name: "Ihiala",
          state_id: "2651",
        },
        {
          id: "30721",
          name: "Nkpor",
          state_id: "2651",
        },
        {
          id: "30722",
          name: "Nnewi",
          state_id: "2651",
        },
        {
          id: "30723",
          name: "Obosi",
          state_id: "2651",
        },
        {
          id: "30724",
          name: "Okija",
          state_id: "2651",
        },
        {
          id: "30725",
          name: "Okpoko",
          state_id: "2651",
        },
        {
          id: "30726",
          name: "Onitsha",
          state_id: "2651",
        },
        {
          id: "30727",
          name: "Ozubulu",
          state_id: "2651",
        },
        {
          id: "30728",
          name: "Uga",
          state_id: "2651",
        },
        {
          id: "48363",
          name: "Abatete",
          state_id: "2651",
        },
        {
          id: "48364",
          name: "Ogidi",
          state_id: "2651",
        },
        {
          id: "48365",
          name: "Nkwelle Ezunaka",
          state_id: "2651",
        },
        {
          id: "48366",
          name: "Ojoto",
          state_id: "2651",
        },
        {
          id: "48367",
          name: "Oba",
          state_id: "2651",
        },
        {
          id: "48368",
          name: "Nsugbe",
          state_id: "2651",
        },
        {
          id: "48369",
          name: "Aguleri",
          state_id: "2651",
        },
        {
          id: "48370",
          name: "Anam",
          state_id: "2651",
        },
        {
          id: "48371",
          name: "Otuocha",
          state_id: "2651",
        },
        {
          id: "48372",
          name: "Atani",
          state_id: "2651",
        },
      ],
      Bauchi: [
        {
          id: "30729",
          name: "Alkaleri",
          state_id: "2652",
        },
        {
          id: "30730",
          name: "Azare",
          state_id: "2652",
        },
        {
          id: "30731",
          name: "Bauchi",
          state_id: "2652",
        },
        {
          id: "30732",
          name: "Bogoro",
          state_id: "2652",
        },
        {
          id: "30733",
          name: "Bununu Dass",
          state_id: "2652",
        },
        {
          id: "30734",
          name: "Darazo",
          state_id: "2652",
        },
        {
          id: "30735",
          name: "Gamawa",
          state_id: "2652",
        },
        {
          id: "30736",
          name: "Ganjuwa",
          state_id: "2652",
        },
        {
          id: "30737",
          name: "Jamari",
          state_id: "2652",
        },
        {
          id: "30738",
          name: "Katagum",
          state_id: "2652",
        },
        {
          id: "30739",
          name: "Misau",
          state_id: "2652",
        },
        {
          id: "30740",
          name: "Ningi",
          state_id: "2652",
        },
        {
          id: "30741",
          name: "Tafawa Balewa",
          state_id: "2652",
        },
      ],
      Bayelsa: [
        {
          id: "30742",
          name: "Brass",
          state_id: "2653",
        },
        {
          id: "30743",
          name: "Ekeremor",
          state_id: "2653",
        },
        {
          id: "30744",
          name: "Nembe",
          state_id: "2653",
        },
        {
          id: "30745",
          name: "Yenagoa",
          state_id: "2653",
        },
      ],
      Benue: [
        {
          id: "30746",
          name: "Aliade",
          state_id: "2654",
        },
        {
          id: "30747",
          name: "Gboko",
          state_id: "2654",
        },
        {
          id: "30748",
          name: "Katsina-Ala",
          state_id: "2654",
        },
        {
          id: "30749",
          name: "Makurdi",
          state_id: "2654",
        },
        {
          id: "30750",
          name: "Otukpo",
          state_id: "2654",
        },
        {
          id: "30751",
          name: "Ukum",
          state_id: "2654",
        },
        {
          id: "30752",
          name: "Zaki Biam",
          state_id: "2654",
        },
      ],
      Borno: [
        {
          id: "30753",
          name: "Abadan",
          state_id: "2655",
        },
        {
          id: "30754",
          name: "Askira",
          state_id: "2655",
        },
        {
          id: "30755",
          name: "Bama",
          state_id: "2655",
        },
        {
          id: "30756",
          name: "Biu",
          state_id: "2655",
        },
        {
          id: "30757",
          name: "Chibok",
          state_id: "2655",
        },
        {
          id: "30758",
          name: "Damboa",
          state_id: "2655",
        },
        {
          id: "30759",
          name: "Dikwa",
          state_id: "2655",
        },
        {
          id: "30760",
          name: "Gamboru",
          state_id: "2655",
        },
        {
          id: "30761",
          name: "Gubio",
          state_id: "2655",
        },
        {
          id: "30762",
          name: "Gwoza",
          state_id: "2655",
        },
        {
          id: "30763",
          name: "Kaga",
          state_id: "2655",
        },
        {
          id: "30764",
          name: "Kala",
          state_id: "2655",
        },
        {
          id: "30765",
          name: "Konduga",
          state_id: "2655",
        },
        {
          id: "30766",
          name: "Kukawa",
          state_id: "2655",
        },
        {
          id: "30767",
          name: "Mafa",
          state_id: "2655",
        },
        {
          id: "30768",
          name: "Magumeri",
          state_id: "2655",
        },
        {
          id: "30769",
          name: "Maiduguri",
          state_id: "2655",
        },
        {
          id: "30770",
          name: "Marte",
          state_id: "2655",
        },
        {
          id: "30771",
          name: "Monguno",
          state_id: "2655",
        },
        {
          id: "30772",
          name: "Ngala",
          state_id: "2655",
        },
        {
          id: "30773",
          name: "Shani",
          state_id: "2655",
        },
      ],
      "Cross River": [
        {
          id: "48373",
          name: "Calabar",
          state_id: "2656",
        },
        {
          id: "48374",
          name: "Ikom",
          state_id: "2656",
        },
        {
          id: "48375",
          name: "Ogoja",
          state_id: "2656",
        },
        {
          id: "48376",
          name: "Ugep",
          state_id: "2656",
        },
        {
          id: "48377",
          name: "Obudu",
          state_id: "2656",
        },
        {
          id: "48378",
          name: "Sankwala",
          state_id: "2656",
        },
        {
          id: "48379",
          name: "Ikot Offiong",
          state_id: "2656",
        },
        {
          id: "48380",
          name: "Ekong",
          state_id: "2656",
        },
      ],
      Delta: [
        {
          id: "30774",
          name: "Agbor",
          state_id: "2657",
        },
        {
          id: "30775",
          name: "Asaba",
          state_id: "2657",
        },
        {
          id: "30776",
          name: "Bomadi",
          state_id: "2657",
        },
        {
          id: "30777",
          name: "Burutu",
          state_id: "2657",
        },
        {
          id: "30778",
          name: "Okpe",
          state_id: "2657",
        },
        {
          id: "30779",
          name: "Patani",
          state_id: "2657",
        },
        {
          id: "30780",
          name: "Sapele",
          state_id: "2657",
        },
        {
          id: "30781",
          name: "Ughelli",
          state_id: "2657",
        },
        {
          id: "30782",
          name: "Warri",
          state_id: "2657",
        },
      ],
      Ebonyi: [
        {
          id: "30783",
          name: "Abakaliki",
          state_id: "2658",
        },
        {
          id: "30784",
          name: "Afikpo",
          state_id: "2658",
        },
        {
          id: "30785",
          name: "Effium",
          state_id: "2658",
        },
        {
          id: "30786",
          name: "Ezza",
          state_id: "2658",
        },
        {
          id: "30787",
          name: "Ishieke",
          state_id: "2658",
        },
        {
          id: "30788",
          name: "Uburu",
          state_id: "2658",
        },
      ],
      Edo: [
        {
          id: "30789",
          name: "Auchi",
          state_id: "2659",
        },
        {
          id: "30790",
          name: "Benin",
          state_id: "2659",
        },
        {
          id: "30791",
          name: "Ekpoma",
          state_id: "2659",
        },
        {
          id: "30792",
          name: "Igarra",
          state_id: "2659",
        },
        {
          id: "30793",
          name: "Ikpoba",
          state_id: "2659",
        },
        {
          id: "30794",
          name: "Irrua",
          state_id: "2659",
        },
        {
          id: "30795",
          name: "Sabongida",
          state_id: "2659",
        },
        {
          id: "30796",
          name: "Ubiaja",
          state_id: "2659",
        },
        {
          id: "30797",
          name: "Uromi",
          state_id: "2659",
        },
      ],
      Ekiti: [
        {
          id: "30798",
          name: "Ado",
          state_id: "2660",
        },
        {
          id: "30799",
          name: "Aramoko",
          state_id: "2660",
        },
        {
          id: "30800",
          name: "Efon Alaye",
          state_id: "2660",
        },
        {
          id: "30801",
          name: "Emure",
          state_id: "2660",
        },
        {
          id: "30802",
          name: "Igbara Odo",
          state_id: "2660",
        },
        {
          id: "30803",
          name: "Igede",
          state_id: "2660",
        },
        {
          id: "30804",
          name: "Ijero",
          state_id: "2660",
        },
        {
          id: "30805",
          name: "Ikere",
          state_id: "2660",
        },
        {
          id: "30806",
          name: "Ikole",
          state_id: "2660",
        },
        {
          id: "30807",
          name: "Ilawe",
          state_id: "2660",
        },
        {
          id: "30808",
          name: "Ipoti",
          state_id: "2660",
        },
        {
          id: "30809",
          name: "Ise",
          state_id: "2660",
        },
        {
          id: "30810",
          name: "Ode",
          state_id: "2660",
        },
        {
          id: "30811",
          name: "Omuo",
          state_id: "2660",
        },
        {
          id: "30812",
          name: "Osi",
          state_id: "2660",
        },
      ],
      Enugu: [
        {
          id: "30813",
          name: "Agwa",
          state_id: "2661",
        },
        {
          id: "30814",
          name: "Aku",
          state_id: "2661",
        },
        {
          id: "30815",
          name: "Awgu",
          state_id: "2661",
        },
        {
          id: "30816",
          name: "Eha Amufu",
          state_id: "2661",
        },
        {
          id: "30817",
          name: "Enugu",
          state_id: "2661",
        },
        {
          id: "30818",
          name: "Enugu Ezike",
          state_id: "2661",
        },
        {
          id: "30819",
          name: "Enugu Ngwo",
          state_id: "2661",
        },
        {
          id: "30820",
          name: "Ezeagu",
          state_id: "2661",
        },
        {
          id: "30821",
          name: "Mberubu",
          state_id: "2661",
        },
        {
          id: "30822",
          name: "Nsukka",
          state_id: "2661",
        },
        {
          id: "30823",
          name: "Oji",
          state_id: "2661",
        },
        {
          id: "30824",
          name: "Udi",
          state_id: "2661",
        },
      ],
      Gombe: [
        {
          id: "30825",
          name: "Ako",
          state_id: "2662",
        },
        {
          id: "30826",
          name: "Deba",
          state_id: "2662",
        },
        {
          id: "30827",
          name: "Duku",
          state_id: "2662",
        },
        {
          id: "30828",
          name: "Garko",
          state_id: "2662",
        },
        {
          id: "30829",
          name: "Gombe",
          state_id: "2662",
        },
        {
          id: "30830",
          name: "Kaltungo",
          state_id: "2662",
        },
        {
          id: "30831",
          name: "Kumo",
          state_id: "2662",
        },
        {
          id: "30832",
          name: "Nafada",
          state_id: "2662",
        },
        {
          id: "30833",
          name: "Pindiga",
          state_id: "2662",
        },
      ],
      Imo: [
        {
          id: "30834",
          name: "Aboh",
          state_id: "2663",
        },
        {
          id: "30835",
          name: "Etiti",
          state_id: "2663",
        },
        {
          id: "30836",
          name: "Ihite",
          state_id: "2663",
        },
        {
          id: "30837",
          name: "Nkwerre",
          state_id: "2663",
        },
        {
          id: "30838",
          name: "Oguta",
          state_id: "2663",
        },
        {
          id: "30839",
          name: "Okigwe",
          state_id: "2663",
        },
        {
          id: "30840",
          name: "Owerri",
          state_id: "2663",
        },
        {
          id: "48390",
          name: "Orlu",
          state_id: "2663",
        },
        {
          id: "48391",
          name: "Mbaise",
          state_id: "2663",
        },
        {
          id: "48392",
          name: "Ohaji/Egbema",
          state_id: "2663",
        },
        {
          id: "48393",
          name: "Ngor Okpala",
          state_id: "2663",
        },
        {
          id: "48394",
          name: "Mgbidi",
          state_id: "2663",
        },
        {
          id: "48395",
          name: "Izombe",
          state_id: "2663",
        },
        {
          id: "48396",
          name: "Isu",
          state_id: "2663",
        },
        {
          id: "48397",
          name: "Mbaitoli",
          state_id: "2663",
        },
        {
          id: "48398",
          name: "Orsu",
          state_id: "2663",
        },
        {
          id: "48399",
          name: "Amaigbo",
          state_id: "2663",
        },
      ],
      Jigawa: [
        {
          id: "30841",
          name: "Babura",
          state_id: "2664",
        },
        {
          id: "30842",
          name: "Birnin Kudu",
          state_id: "2664",
        },
        {
          id: "30843",
          name: "Buji",
          state_id: "2664",
        },
        {
          id: "30844",
          name: "Dutse",
          state_id: "2664",
        },
        {
          id: "30845",
          name: "Garki",
          state_id: "2664",
        },
        {
          id: "30846",
          name: "Gumel",
          state_id: "2664",
        },
        {
          id: "30847",
          name: "Gwaram",
          state_id: "2664",
        },
        {
          id: "30848",
          name: "Gwiwa",
          state_id: "2664",
        },
        {
          id: "30849",
          name: "Hadejia",
          state_id: "2664",
        },
        {
          id: "30850",
          name: "Jahun",
          state_id: "2664",
        },
        {
          id: "30851",
          name: "Kaugama",
          state_id: "2664",
        },
        {
          id: "30852",
          name: "Kazaure",
          state_id: "2664",
        },
        {
          id: "30853",
          name: "Keffin Hausa",
          state_id: "2664",
        },
        {
          id: "30854",
          name: "Kiyawa",
          state_id: "2664",
        },
        {
          id: "30855",
          name: "Maigatari",
          state_id: "2664",
        },
        {
          id: "30856",
          name: "Malammaduri",
          state_id: "2664",
        },
        {
          id: "30857",
          name: "Ringim",
          state_id: "2664",
        },
        {
          id: "30858",
          name: "Sule Tankarkar",
          state_id: "2664",
        },
        {
          id: "30859",
          name: "Taura",
          state_id: "2664",
        },
      ],
      Kaduna: [
        {
          id: "30860",
          name: "Birnin Gwari",
          state_id: "2665",
        },
        {
          id: "30861",
          name: "Doka",
          state_id: "2665",
        },
        {
          id: "30862",
          name: "Giwa",
          state_id: "2665",
        },
        {
          id: "30863",
          name: "Gwagwada",
          state_id: "2665",
        },
        {
          id: "30864",
          name: "Hunkuyi",
          state_id: "2665",
        },
        {
          id: "30865",
          name: "Igabi",
          state_id: "2665",
        },
        {
          id: "30866",
          name: "Ikara",
          state_id: "2665",
        },
        {
          id: "30867",
          name: "Jemaa",
          state_id: "2665",
        },
        {
          id: "30868",
          name: "Kachia",
          state_id: "2665",
        },
        {
          id: "30869",
          name: "Kaduna",
          state_id: "2665",
        },
        {
          id: "30870",
          name: "Kafanchan",
          state_id: "2665",
        },
        {
          id: "30871",
          name: "Kagarko",
          state_id: "2665",
        },
        {
          id: "30872",
          name: "Kagoro",
          state_id: "2665",
        },
        {
          id: "30873",
          name: "Kaura",
          state_id: "2665",
        },
        {
          id: "30874",
          name: "Kudan",
          state_id: "2665",
        },
        {
          id: "30875",
          name: "Lere",
          state_id: "2665",
        },
        {
          id: "30876",
          name: "Makarfi",
          state_id: "2665",
        },
        {
          id: "30877",
          name: "Sabon Birnin Gwari",
          state_id: "2665",
        },
        {
          id: "30878",
          name: "Sabongari",
          state_id: "2665",
        },
        {
          id: "30879",
          name: "Sanga",
          state_id: "2665",
        },
        {
          id: "30880",
          name: "Soba",
          state_id: "2665",
        },
        {
          id: "30881",
          name: "Tudun Wada",
          state_id: "2665",
        },
        {
          id: "30882",
          name: "Zangon Katab",
          state_id: "2665",
        },
        {
          id: "30883",
          name: "Zaria",
          state_id: "2665",
        },
      ],
      Kano: [
        {
          id: "30884",
          name: "Ajingi",
          state_id: "2666",
        },
        {
          id: "30885",
          name: "Albasu",
          state_id: "2666",
        },
        {
          id: "30886",
          name: "Bagwai",
          state_id: "2666",
        },
        {
          id: "30887",
          name: "Bebeji",
          state_id: "2666",
        },
        {
          id: "30888",
          name: "Bichi",
          state_id: "2666",
        },
        {
          id: "30889",
          name: "Bunkure",
          state_id: "2666",
        },
        {
          id: "30890",
          name: "Dambarta",
          state_id: "2666",
        },
        {
          id: "30891",
          name: "Dawakin Tofe",
          state_id: "2666",
        },
        {
          id: "30892",
          name: "Fagge",
          state_id: "2666",
        },
        {
          id: "30893",
          name: "Garko",
          state_id: "2666",
        },
        {
          id: "30894",
          name: "Garun Mallam",
          state_id: "2666",
        },
        {
          id: "30895",
          name: "Gaya",
          state_id: "2666",
        },
        {
          id: "30896",
          name: "Gezawa",
          state_id: "2666",
        },
        {
          id: "30897",
          name: "Gwarzo",
          state_id: "2666",
        },
        {
          id: "30898",
          name: "Kabo",
          state_id: "2666",
        },
        {
          id: "30899",
          name: "Kano",
          state_id: "2666",
        },
        {
          id: "30900",
          name: "Karaye",
          state_id: "2666",
        },
        {
          id: "30901",
          name: "Kibiya",
          state_id: "2666",
        },
        {
          id: "30902",
          name: "Kiru",
          state_id: "2666",
        },
        {
          id: "30903",
          name: "Kumbotso",
          state_id: "2666",
        },
        {
          id: "30904",
          name: "Kunchi",
          state_id: "2666",
        },
        {
          id: "30905",
          name: "Kura",
          state_id: "2666",
        },
        {
          id: "30906",
          name: "Madobi",
          state_id: "2666",
        },
        {
          id: "30907",
          name: "Makoda",
          state_id: "2666",
        },
        {
          id: "30908",
          name: "Nassarawa",
          state_id: "2666",
        },
        {
          id: "30909",
          name: "Rano",
          state_id: "2666",
        },
        {
          id: "30910",
          name: "Rimin Gado",
          state_id: "2666",
        },
        {
          id: "30911",
          name: "Shanono",
          state_id: "2666",
        },
        {
          id: "30912",
          name: "Sumaila",
          state_id: "2666",
        },
        {
          id: "30913",
          name: "Takai",
          state_id: "2666",
        },
        {
          id: "30914",
          name: "Tofa",
          state_id: "2666",
        },
        {
          id: "30915",
          name: "Tudun Wada",
          state_id: "2666",
        },
        {
          id: "30916",
          name: "Wudil",
          state_id: "2666",
        },
      ],
      Katsina: [
        {
          id: "30917",
          name: "Bakori",
          state_id: "2667",
        },
        {
          id: "30918",
          name: "Batsari",
          state_id: "2667",
        },
        {
          id: "30919",
          name: "Bindawa",
          state_id: "2667",
        },
        {
          id: "30920",
          name: "Cheranchi",
          state_id: "2667",
        },
        {
          id: "30921",
          name: "Dan Dume",
          state_id: "2667",
        },
        {
          id: "30922",
          name: "Danja",
          state_id: "2667",
        },
        {
          id: "30923",
          name: "Daura",
          state_id: "2667",
        },
        {
          id: "30924",
          name: "Dutsi",
          state_id: "2667",
        },
        {
          id: "30925",
          name: "Dutsin Ma",
          state_id: "2667",
        },
        {
          id: "30926",
          name: "Faskari",
          state_id: "2667",
        },
        {
          id: "30927",
          name: "Funtua",
          state_id: "2667",
        },
        {
          id: "30928",
          name: "Ingawa",
          state_id: "2667",
        },
        {
          id: "30929",
          name: "Jibiya",
          state_id: "2667",
        },
        {
          id: "30930",
          name: "Kangiwa",
          state_id: "2667",
        },
        {
          id: "30931",
          name: "Kankara",
          state_id: "2667",
        },
        {
          id: "30932",
          name: "Kankiya",
          state_id: "2667",
        },
        {
          id: "30933",
          name: "Katsina",
          state_id: "2667",
        },
        {
          id: "30934",
          name: "Kurfi",
          state_id: "2667",
        },
        {
          id: "30935",
          name: "Malumfashi",
          state_id: "2667",
        },
        {
          id: "30936",
          name: "Mani",
          state_id: "2667",
        },
        {
          id: "30937",
          name: "Mashi",
          state_id: "2667",
        },
        {
          id: "30938",
          name: "Musawa",
          state_id: "2667",
        },
        {
          id: "30939",
          name: "Rimi",
          state_id: "2667",
        },
        {
          id: "30940",
          name: "Sandamu",
          state_id: "2667",
        },
        {
          id: "30941",
          name: "Zango",
          state_id: "2667",
        },
      ],
      Kebbi: [
        {
          id: "30942",
          name: "Argungu",
          state_id: "2668",
        },
        {
          id: "30943",
          name: "Augie",
          state_id: "2668",
        },
        {
          id: "30944",
          name: "Bagudo",
          state_id: "2668",
        },
        {
          id: "30945",
          name: "Birnin Kebbi",
          state_id: "2668",
        },
        {
          id: "30946",
          name: "Birnin Yauri",
          state_id: "2668",
        },
        {
          id: "30947",
          name: "Bunza",
          state_id: "2668",
        },
        {
          id: "30948",
          name: "Fakai",
          state_id: "2668",
        },
        {
          id: "30949",
          name: "Gwandu",
          state_id: "2668",
        },
        {
          id: "30950",
          name: "Jega",
          state_id: "2668",
        },
        {
          id: "30951",
          name: "Kalgo",
          state_id: "2668",
        },
        {
          id: "30952",
          name: "Koko",
          state_id: "2668",
        },
        {
          id: "30953",
          name: "Maiyema",
          state_id: "2668",
        },
        {
          id: "30954",
          name: "Sakaba",
          state_id: "2668",
        },
        {
          id: "30955",
          name: "Shanga",
          state_id: "2668",
        },
        {
          id: "30956",
          name: "Suru",
          state_id: "2668",
        },
        {
          id: "30957",
          name: "Wasagu",
          state_id: "2668",
        },
        {
          id: "30958",
          name: "Zuru",
          state_id: "2668",
        },
      ],
      Kogi: [
        {
          id: "30959",
          name: "Ajaokuta",
          state_id: "2669",
        },
        {
          id: "30960",
          name: "Ankpa",
          state_id: "2669",
        },
        {
          id: "30961",
          name: "Dekina",
          state_id: "2669",
        },
        {
          id: "30962",
          name: "Idah",
          state_id: "2669",
        },
        {
          id: "30963",
          name: "Kabba",
          state_id: "2669",
        },
        {
          id: "30964",
          name: "Koton-Karifi",
          state_id: "2669",
        },
        {
          id: "30965",
          name: "Kuroro",
          state_id: "2669",
        },
        {
          id: "30966",
          name: "Lokoja",
          state_id: "2669",
        },
        {
          id: "30967",
          name: "Mopa",
          state_id: "2669",
        },
        {
          id: "30968",
          name: "Ogaminana",
          state_id: "2669",
        },
        {
          id: "30969",
          name: "Ogori",
          state_id: "2669",
        },
        {
          id: "30970",
          name: "Okene",
          state_id: "2669",
        },
      ],
      Kwara: [
        {
          id: "30971",
          name: "Ajasse",
          state_id: "2670",
        },
        {
          id: "30972",
          name: "Ilorin",
          state_id: "2670",
        },
        {
          id: "30973",
          name: "Jebba",
          state_id: "2670",
        },
        {
          id: "30974",
          name: "Kaiama",
          state_id: "2670",
        },
        {
          id: "30975",
          name: "Lafiagi",
          state_id: "2670",
        },
        {
          id: "30976",
          name: "Offa",
          state_id: "2670",
        },
        {
          id: "30977",
          name: "Pategi",
          state_id: "2670",
        },
      ],
      Lagos: [
        {
          id: "30978",
          name: "Apapa",
          state_id: "2671",
        },
        {
          id: "30979",
          name: "Badagry",
          state_id: "2671",
        },
        {
          id: "30980",
          name: "Epe",
          state_id: "2671",
        },
        {
          id: "30981",
          name: "Ibeju",
          state_id: "2671",
        },
        {
          id: "30982",
          name: "Iganmu",
          state_id: "2671",
        },
        {
          id: "30983",
          name: "Ikeja",
          state_id: "2671",
        },
        {
          id: "30984",
          name: "Ikorodu",
          state_id: "2671",
        },
        {
          id: "30985",
          name: "Lagos",
          state_id: "2671",
        },
        {
          id: "30986",
          name: "Ojo",
          state_id: "2671",
        },
        {
          id: "30987",
          name: "Surulere",
          state_id: "2671",
        },
        {
          id: "48315",
          name: "Isolo",
          state_id: "2671",
        },
        {
          id: "48316",
          name: "Ejigbo",
          state_id: "2671",
        },
        {
          id: "48317",
          name: "Okota",
          state_id: "2671",
        },
        {
          id: "48318",
          name: "Ilasamaja",
          state_id: "2671",
        },
        {
          id: "48319",
          name: "Festac Town",
          state_id: "2671",
        },
        {
          id: "48320",
          name: "Ijeshatedo",
          state_id: "2671",
        },
        {
          id: "48321",
          name: "Amuwo Odofin",
          state_id: "2671",
        },
        {
          id: "48322",
          name: "Ajegunle",
          state_id: "2671",
        },
        {
          id: "48323",
          name: "Ojodu",
          state_id: "2671",
        },
        {
          id: "48324",
          name: "Onigbongbo",
          state_id: "2671",
        },
        {
          id: "48325",
          name: "Ojokoro",
          state_id: "2671",
        },
        {
          id: "48326",
          name: "Ajah",
          state_id: "2671",
        },
        {
          id: "48327",
          name: "Lekki",
          state_id: "2671",
        },
        {
          id: "48328",
          name: "Eredo",
          state_id: "2671",
        },
        {
          id: "48329",
          name: "Igando",
          state_id: "2671",
        },
        {
          id: "48330",
          name: "Idimu",
          state_id: "2671",
        },
        {
          id: "48331",
          name: "Egbe",
          state_id: "2671",
        },
        {
          id: "48332",
          name: "Ipaja",
          state_id: "2671",
        },
        {
          id: "48333",
          name: "Ayobo",
          state_id: "2671",
        },
        {
          id: "48334",
          name: "Abule Egba",
          state_id: "2671",
        },
        {
          id: "48335",
          name: "Agege",
          state_id: "2671",
        },
        {
          id: "48336",
          name: "Ojota",
          state_id: "2671",
        },
        {
          id: "48337",
          name: "Igbogbo",
          state_id: "2671",
        },
        {
          id: "48338",
          name: "Ketu",
          state_id: "2671",
        },
        {
          id: "48339",
          name: "Imota",
          state_id: "2671",
        },
        {
          id: "48340",
          name: "Yaba",
          state_id: "2671",
        },
        {
          id: "48341",
          name: "Bariga",
          state_id: "2671",
        },
        {
          id: "48342",
          name: "Mushin",
          state_id: "2671",
        },
        {
          id: "48343",
          name: "Oshodi",
          state_id: "2671",
        },
        {
          id: "48344",
          name: "Gbagada",
          state_id: "2671",
        },
        {
          id: "48345",
          name: "Oworonshoki",
          state_id: "2671",
        },
        {
          id: "48346",
          name: "Maryland",
          state_id: "2671",
        },
        {
          id: "48347",
          name: "Egbeda",
          state_id: "2671",
        },
        {
          id: "48348",
          name: "Alimosho",
          state_id: "2671",
        },
        {
          id: "48349",
          name: "Ogba",
          state_id: "2671",
        },
        {
          id: "48350",
          name: "Somolu",
          state_id: "2671",
        },
        {
          id: "48351",
          name: "Kosofe",
          state_id: "2671",
        },
      ],
      Nassarawa: [
        {
          id: "30988",
          name: "Akwanga",
          state_id: "2672",
        },
        {
          id: "30989",
          name: "Awe",
          state_id: "2672",
        },
        {
          id: "30990",
          name: "Doma",
          state_id: "2672",
        },
        {
          id: "30991",
          name: "Keana",
          state_id: "2672",
        },
        {
          id: "30992",
          name: "Keffi",
          state_id: "2672",
        },
        {
          id: "30993",
          name: "Lafia",
          state_id: "2672",
        },
        {
          id: "30994",
          name: "Nassarawa",
          state_id: "2672",
        },
        {
          id: "30995",
          name: "Obi",
          state_id: "2672",
        },
        {
          id: "30996",
          name: "Toto",
          state_id: "2672",
        },
        {
          id: "30997",
          name: "Wamba",
          state_id: "2672",
        },
      ],
      Niger: [
        {
          id: "30998",
          name: "Agale",
          state_id: "2673",
        },
        {
          id: "30999",
          name: "Babana",
          state_id: "2673",
        },
        {
          id: "31000",
          name: "Bida",
          state_id: "2673",
        },
        {
          id: "31001",
          name: "Bosso",
          state_id: "2673",
        },
        {
          id: "31002",
          name: "Chanchaga",
          state_id: "2673",
        },
        {
          id: "31003",
          name: "Gbako",
          state_id: "2673",
        },
        {
          id: "31004",
          name: "Kontagora",
          state_id: "2673",
        },
        {
          id: "31005",
          name: "Lapai",
          state_id: "2673",
        },
        {
          id: "31006",
          name: "Minna",
          state_id: "2673",
        },
        {
          id: "31007",
          name: "Mokwa",
          state_id: "2673",
        },
        {
          id: "31008",
          name: "New Bussa",
          state_id: "2673",
        },
        {
          id: "31009",
          name: "Rijau",
          state_id: "2673",
        },
        {
          id: "31010",
          name: "Shiroro",
          state_id: "2673",
        },
        {
          id: "31011",
          name: "Suleja",
          state_id: "2673",
        },
        {
          id: "31012",
          name: "Wushishi",
          state_id: "2673",
        },
      ],
      Ogun: [
        {
          id: "31013",
          name: "Abeokuta",
          state_id: "2674",
        },
        {
          id: "31014",
          name: "Ado Odo",
          state_id: "2674",
        },
        {
          id: "31015",
          name: "Agbara",
          state_id: "2674",
        },
        {
          id: "31016",
          name: "Aiyetoro",
          state_id: "2674",
        },
        {
          id: "31017",
          name: "Ewekoro",
          state_id: "2674",
        },
        {
          id: "31018",
          name: "Ifo",
          state_id: "2674",
        },
        {
          id: "31019",
          name: "Ijebu Igbo",
          state_id: "2674",
        },
        {
          id: "31020",
          name: "Ijebu Ode",
          state_id: "2674",
        },
        {
          id: "31021",
          name: "Ikene",
          state_id: "2674",
        },
        {
          id: "31022",
          name: "Ilaro",
          state_id: "2674",
        },
        {
          id: "31023",
          name: "Ipokia",
          state_id: "2674",
        },
        {
          id: "31024",
          name: "Odogbolu",
          state_id: "2674",
        },
        {
          id: "31025",
          name: "Owode",
          state_id: "2674",
        },
        {
          id: "31026",
          name: "Sango Ota",
          state_id: "2674",
        },
        {
          id: "31027",
          name: "Shagamu",
          state_id: "2674",
        },
      ],
      Ondo: [
        {
          id: "31028",
          name: "Akure",
          state_id: "2675",
        },
        {
          id: "31029",
          name: "Idanre",
          state_id: "2675",
        },
        {
          id: "31030",
          name: "Ikare",
          state_id: "2675",
        },
        {
          id: "31031",
          name: "Irele",
          state_id: "2675",
        },
        {
          id: "31032",
          name: "Odigbo",
          state_id: "2675",
        },
        {
          id: "31033",
          name: "Oka",
          state_id: "2675",
        },
        {
          id: "31034",
          name: "Okitipupa",
          state_id: "2675",
        },
        {
          id: "31035",
          name: "Ondo",
          state_id: "2675",
        },
        {
          id: "31036",
          name: "Owo",
          state_id: "2675",
        },
      ],
      Osun: [
        {
          id: "31037",
          name: "Apomu",
          state_id: "2676",
        },
        {
          id: "31038",
          name: "Ede",
          state_id: "2676",
        },
        {
          id: "31039",
          name: "Ejigbo",
          state_id: "2676",
        },
        {
          id: "31040",
          name: "Erin-Oshogbo",
          state_id: "2676",
        },
        {
          id: "31041",
          name: "Gbongan",
          state_id: "2676",
        },
        {
          id: "31042",
          name: "Ife",
          state_id: "2676",
        },
        {
          id: "31043",
          name: "Ifon Osun",
          state_id: "2676",
        },
        {
          id: "31044",
          name: "Ijesha",
          state_id: "2676",
        },
        {
          id: "31045",
          name: "Ikire",
          state_id: "2676",
        },
        {
          id: "31046",
          name: "Ikirun",
          state_id: "2676",
        },
        {
          id: "31047",
          name: "Ila",
          state_id: "2676",
        },
        {
          id: "31048",
          name: "Ilesha",
          state_id: "2676",
        },
        {
          id: "31049",
          name: "Ilobu",
          state_id: "2676",
        },
        {
          id: "31050",
          name: "Inisa",
          state_id: "2676",
        },
        {
          id: "31051",
          name: "Iwo",
          state_id: "2676",
        },
        {
          id: "31052",
          name: "Modakeke",
          state_id: "2676",
        },
        {
          id: "31053",
          name: "Oke-Mesi",
          state_id: "2676",
        },
        {
          id: "31054",
          name: "Olorunda",
          state_id: "2676",
        },
        {
          id: "31055",
          name: "Olupona",
          state_id: "2676",
        },
        {
          id: "31056",
          name: "Ore",
          state_id: "2676",
        },
        {
          id: "31057",
          name: "Orolu",
          state_id: "2676",
        },
        {
          id: "31058",
          name: "Oshogbo",
          state_id: "2676",
        },
        {
          id: "31059",
          name: "Oyan",
          state_id: "2676",
        },
      ],
      Oyo: [
        {
          id: "31060",
          name: "Akinyele",
          state_id: "2677",
        },
        {
          id: "31061",
          name: "Egbeda",
          state_id: "2677",
        },
        {
          id: "31062",
          name: "Eruwa",
          state_id: "2677",
        },
        {
          id: "31063",
          name: "Fiditi",
          state_id: "2677",
        },
        {
          id: "31064",
          name: "Ibadan",
          state_id: "2677",
        },
        {
          id: "31065",
          name: "Ibeto",
          state_id: "2677",
        },
        {
          id: "31066",
          name: "Igbo Ora",
          state_id: "2677",
        },
        {
          id: "31067",
          name: "Igboho",
          state_id: "2677",
        },
        {
          id: "31068",
          name: "Iseyin",
          state_id: "2677",
        },
        {
          id: "31069",
          name: "Kajola",
          state_id: "2677",
        },
        {
          id: "31070",
          name: "Kishi",
          state_id: "2677",
        },
        {
          id: "31071",
          name: "Lalupon",
          state_id: "2677",
        },
        {
          id: "31072",
          name: "Ogbomosho",
          state_id: "2677",
        },
        {
          id: "31073",
          name: "Ogo",
          state_id: "2677",
        },
        {
          id: "31074",
          name: "Oke-Iho",
          state_id: "2677",
        },
        {
          id: "31075",
          name: "Oyo",
          state_id: "2677",
        },
        {
          id: "31076",
          name: "Shaki",
          state_id: "2677",
        },
      ],
      Plateau: [
        {
          id: "31077",
          name: "Barakin",
          state_id: "2678",
        },
        {
          id: "31078",
          name: "Bassa",
          state_id: "2678",
        },
        {
          id: "31079",
          name: "Bokkos",
          state_id: "2678",
        },
        {
          id: "31080",
          name: "Bukuru",
          state_id: "2678",
        },
        {
          id: "31081",
          name: "Jos",
          state_id: "2678",
        },
        {
          id: "31082",
          name: "Langtang",
          state_id: "2678",
        },
        {
          id: "31083",
          name: "Pankshin",
          state_id: "2678",
        },
        {
          id: "31084",
          name: "Riyom",
          state_id: "2678",
        },
        {
          id: "31085",
          name: "Shendam",
          state_id: "2678",
        },
        {
          id: "31086",
          name: "Vom",
          state_id: "2678",
        },
        {
          id: "31087",
          name: "Wase",
          state_id: "2678",
        },
      ],
      Rivers: [
        {
          id: "31088",
          name: "Abonnema",
          state_id: "2679",
        },
        {
          id: "31089",
          name: "Abua",
          state_id: "2679",
        },
        {
          id: "31090",
          name: "Ahoada",
          state_id: "2679",
        },
        {
          id: "31091",
          name: "Bonny",
          state_id: "2679",
        },
        {
          id: "31092",
          name: "Bugama",
          state_id: "2679",
        },
        {
          id: "31093",
          name: "Degema",
          state_id: "2679",
        },
        {
          id: "31094",
          name: "Egbema",
          state_id: "2679",
        },
        {
          id: "31095",
          name: "Ogu",
          state_id: "2679",
        },
        {
          id: "31096",
          name: "Okrika",
          state_id: "2679",
        },
        {
          id: "31097",
          name: "Omoko",
          state_id: "2679",
        },
        {
          id: "31098",
          name: "Opobo",
          state_id: "2679",
        },
        {
          id: "31099",
          name: "Oyigbo",
          state_id: "2679",
        },
        {
          id: "31100",
          name: "Port Harcourt",
          state_id: "2679",
        },
      ],
      Sokoto: [
        {
          id: "31101",
          name: "Binji",
          state_id: "2680",
        },
        {
          id: "31102",
          name: "Bodinga",
          state_id: "2680",
        },
        {
          id: "31103",
          name: "Dange",
          state_id: "2680",
        },
        {
          id: "31104",
          name: "Gada",
          state_id: "2680",
        },
        {
          id: "31105",
          name: "Goronyo",
          state_id: "2680",
        },
        {
          id: "31106",
          name: "Gwadabawa",
          state_id: "2680",
        },
        {
          id: "31107",
          name: "Illela",
          state_id: "2680",
        },
        {
          id: "31108",
          name: "Kebbe",
          state_id: "2680",
        },
        {
          id: "31109",
          name: "Kware",
          state_id: "2680",
        },
        {
          id: "31110",
          name: "Rabah",
          state_id: "2680",
        },
        {
          id: "31111",
          name: "Raka",
          state_id: "2680",
        },
        {
          id: "31112",
          name: "Sabon Birni",
          state_id: "2680",
        },
        {
          id: "31113",
          name: "Sokoto",
          state_id: "2680",
        },
        {
          id: "31114",
          name: "Tambawel",
          state_id: "2680",
        },
        {
          id: "31115",
          name: "Tureta",
          state_id: "2680",
        },
        {
          id: "31116",
          name: "Wamako",
          state_id: "2680",
        },
        {
          id: "31117",
          name: "Wurno",
          state_id: "2680",
        },
      ],
      Taraba: [
        {
          id: "31118",
          name: "Bali",
          state_id: "2681",
        },
        {
          id: "31119",
          name: "Gashaka",
          state_id: "2681",
        },
        {
          id: "31120",
          name: "Gassol",
          state_id: "2681",
        },
        {
          id: "31121",
          name: "Ibi",
          state_id: "2681",
        },
        {
          id: "31122",
          name: "Jalingo",
          state_id: "2681",
        },
        {
          id: "31123",
          name: "Lau",
          state_id: "2681",
        },
        {
          id: "31124",
          name: "Takum",
          state_id: "2681",
        },
        {
          id: "31125",
          name: "Wukari",
          state_id: "2681",
        },
        {
          id: "31126",
          name: "Yorro",
          state_id: "2681",
        },
      ],
      Yobe: [
        {
          id: "31127",
          name: "Damaturu",
          state_id: "2682",
        },
        {
          id: "31128",
          name: "Fika",
          state_id: "2682",
        },
        {
          id: "31129",
          name: "Gashua",
          state_id: "2682",
        },
        {
          id: "31130",
          name: "Geidam",
          state_id: "2682",
        },
        {
          id: "31131",
          name: "Gorgoram",
          state_id: "2682",
        },
        {
          id: "31132",
          name: "Gujba",
          state_id: "2682",
        },
        {
          id: "31133",
          name: "Gulani",
          state_id: "2682",
        },
        {
          id: "31134",
          name: "Jakusko",
          state_id: "2682",
        },
        {
          id: "31135",
          name: "Matsena",
          state_id: "2682",
        },
        {
          id: "31136",
          name: "Nguru",
          state_id: "2682",
        },
        {
          id: "31137",
          name: "Potiskum",
          state_id: "2682",
        },
        {
          id: "31138",
          name: "Yusufari",
          state_id: "2682",
        },
      ],
      Zamfara: [
        {
          id: "31139",
          name: "Anka",
          state_id: "2683",
        },
        {
          id: "31140",
          name: "Bungudu",
          state_id: "2683",
        },
        {
          id: "31141",
          name: "Chafe",
          state_id: "2683",
        },
        {
          id: "31142",
          name: "Gummi",
          state_id: "2683",
        },
        {
          id: "31143",
          name: "Gusau",
          state_id: "2683",
        },
        {
          id: "31144",
          name: "Isa",
          state_id: "2683",
        },
        {
          id: "31145",
          name: "Kaura Namoda",
          state_id: "2683",
        },
        {
          id: "31146",
          name: "Kiyawa",
          state_id: "2683",
        },
        {
          id: "31147",
          name: "Maradun",
          state_id: "2683",
        },
        {
          id: "31148",
          name: "Maru",
          state_id: "2683",
        },
        {
          id: "31149",
          name: "Shinkafe",
          state_id: "2683",
        },
        {
          id: "31150",
          name: "Talata Mafara",
          state_id: "2683",
        },
        {
          id: "31151",
          name: "Zurmi",
          state_id: "2683",
        },
      ],
    },
  },
  NI: {
    name: "Nicaragua",
    native: "Nicaragua",
    phone: "505",
    continent: "NA",
    capital: "Managua",
    currency: "NIO",
    languages: ["es"],
    emoji: "🇳🇮",
    emojiU: "U+1F1F3 U+1F1EE",
    states: {
      "Atlantico Norte": [],
      "Atlantico Sur": [],
      Boaco: [
        {
          id: "30588",
          name: "Boaco",
          state_id: "2624",
        },
        {
          id: "30589",
          name: "Camoapa",
          state_id: "2624",
        },
        {
          id: "30590",
          name: "San Lorenzo",
          state_id: "2624",
        },
      ],
      Carazo: [
        {
          id: "30591",
          name: "Diriamba",
          state_id: "2625",
        },
        {
          id: "30592",
          name: "Dolores",
          state_id: "2625",
        },
        {
          id: "30593",
          name: "Jinotepe",
          state_id: "2625",
        },
        {
          id: "30594",
          name: "Masatepe",
          state_id: "2625",
        },
        {
          id: "30595",
          name: "San Marcos",
          state_id: "2625",
        },
        {
          id: "30596",
          name: "Santa Teresa",
          state_id: "2625",
        },
      ],
      Chinandega: [
        {
          id: "30597",
          name: "Chichigalpa",
          state_id: "2626",
        },
        {
          id: "30598",
          name: "Chinandega",
          state_id: "2626",
        },
        {
          id: "30599",
          name: "Corinto",
          state_id: "2626",
        },
        {
          id: "30600",
          name: "El Viejo",
          state_id: "2626",
        },
        {
          id: "30601",
          name: "Puerto Morazan",
          state_id: "2626",
        },
        {
          id: "30602",
          name: "Somotillo",
          state_id: "2626",
        },
      ],
      Chontales: [
        {
          id: "30603",
          name: "Acoyapa",
          state_id: "2627",
        },
        {
          id: "30604",
          name: "Juigalpa",
          state_id: "2627",
        },
        {
          id: "30605",
          name: "Santo Domingo",
          state_id: "2627",
        },
        {
          id: "30606",
          name: "Santo Tomas",
          state_id: "2627",
        },
        {
          id: "30607",
          name: "Villa Sandino",
          state_id: "2627",
        },
      ],
      Esteli: [
        {
          id: "30608",
          name: "Condega",
          state_id: "2628",
        },
        {
          id: "30609",
          name: "Esteli",
          state_id: "2628",
        },
        {
          id: "30610",
          name: "La Trinidad",
          state_id: "2628",
        },
      ],
      Granada: [
        {
          id: "30611",
          name: "Diriomo",
          state_id: "2629",
        },
        {
          id: "30612",
          name: "Granada",
          state_id: "2629",
        },
        {
          id: "30613",
          name: "Nandaime",
          state_id: "2629",
        },
      ],
      Jinotega: [
        {
          id: "30614",
          name: "Jinotega",
          state_id: "2630",
        },
        {
          id: "30615",
          name: "Wiwili",
          state_id: "2630",
        },
      ],
      Leon: [
        {
          id: "30616",
          name: "El Sauce",
          state_id: "2631",
        },
        {
          id: "30617",
          name: "La Paz Centro",
          state_id: "2631",
        },
        {
          id: "30618",
          name: "Larreynaga",
          state_id: "2631",
        },
        {
          id: "30619",
          name: "Leon",
          state_id: "2631",
        },
        {
          id: "30620",
          name: "Nagarote",
          state_id: "2631",
        },
        {
          id: "30621",
          name: "Telica",
          state_id: "2631",
        },
      ],
      Madriz: [
        {
          id: "30622",
          name: "Somoto",
          state_id: "2632",
        },
      ],
      Managua: [
        {
          id: "30623",
          name: "Managua",
          state_id: "2633",
        },
        {
          id: "30624",
          name: "Mateare",
          state_id: "2633",
        },
        {
          id: "30625",
          name: "San Rafael del Sur",
          state_id: "2633",
        },
        {
          id: "30626",
          name: "Ticuantepe",
          state_id: "2633",
        },
        {
          id: "30627",
          name: "Tipitapa",
          state_id: "2633",
        },
      ],
      Masaya: [
        {
          id: "30628",
          name: "La Concepcion",
          state_id: "2634",
        },
        {
          id: "30629",
          name: "Masaya",
          state_id: "2634",
        },
        {
          id: "30630",
          name: "Nandasmo",
          state_id: "2634",
        },
        {
          id: "30631",
          name: "Nindiri",
          state_id: "2634",
        },
        {
          id: "30632",
          name: "Niquinohomo",
          state_id: "2634",
        },
      ],
      Matagalpa: [
        {
          id: "30633",
          name: "Ciudad Dario",
          state_id: "2635",
        },
        {
          id: "30634",
          name: "Esquipulas",
          state_id: "2635",
        },
        {
          id: "30635",
          name: "Matagalpa",
          state_id: "2635",
        },
        {
          id: "30636",
          name: "Matiguas",
          state_id: "2635",
        },
        {
          id: "30637",
          name: "Rio Blanco",
          state_id: "2635",
        },
        {
          id: "30638",
          name: "San Isidro",
          state_id: "2635",
        },
        {
          id: "30639",
          name: "Sebaco",
          state_id: "2635",
        },
      ],
      "Nueva Segovia": [],
      "Rio San Juan": [],
      Rivas: [
        {
          id: "30640",
          name: "Belen",
          state_id: "2638",
        },
        {
          id: "30641",
          name: "Rivas",
          state_id: "2638",
        },
        {
          id: "30642",
          name: "San Jorge",
          state_id: "2638",
        },
        {
          id: "30643",
          name: "San Juan del Sur",
          state_id: "2638",
        },
      ],
    },
  },
  NL: {
    name: "Netherlands",
    native: "Nederland",
    phone: "31",
    continent: "EU",
    capital: "Amsterdam",
    currency: "EUR",
    languages: ["nl"],
    emoji: "🇳🇱",
    emojiU: "U+1F1F3 U+1F1F1",
    states: {
      Amsterdam: [
        {
          id: "29855",
          name: "SchipolRijk",
          state_id: "2585",
        },
      ],
      Benelux: [
        {
          id: "29856",
          name: "Amstelveen",
          state_id: "2586",
        },
      ],
      Drenthe: [
        {
          id: "29857",
          name: "Aa en Hunze",
          state_id: "2587",
        },
        {
          id: "29858",
          name: "Assen",
          state_id: "2587",
        },
        {
          id: "29859",
          name: "Borger-Odoorn",
          state_id: "2587",
        },
        {
          id: "29860",
          name: "Coevorden",
          state_id: "2587",
        },
        {
          id: "29861",
          name: "De Wolden",
          state_id: "2587",
        },
        {
          id: "29862",
          name: "Den Oever",
          state_id: "2587",
        },
        {
          id: "29863",
          name: "Emmen",
          state_id: "2587",
        },
        {
          id: "29864",
          name: "Gasteren",
          state_id: "2587",
        },
        {
          id: "29865",
          name: "Hoogeveen",
          state_id: "2587",
        },
        {
          id: "29866",
          name: "Menterwolde",
          state_id: "2587",
        },
        {
          id: "29867",
          name: "Meppel",
          state_id: "2587",
        },
        {
          id: "29868",
          name: "Midden-Drenthe",
          state_id: "2587",
        },
        {
          id: "29869",
          name: "Noordenveld",
          state_id: "2587",
        },
        {
          id: "29870",
          name: "Stadskanaal",
          state_id: "2587",
        },
        {
          id: "29871",
          name: "Tynaarlo",
          state_id: "2587",
        },
        {
          id: "29872",
          name: "Veenoord",
          state_id: "2587",
        },
        {
          id: "29873",
          name: "Westerveld",
          state_id: "2587",
        },
        {
          id: "29874",
          name: "Zuidlaren",
          state_id: "2587",
        },
      ],
      Flevoland: [
        {
          id: "29875",
          name: "Almere",
          state_id: "2588",
        },
        {
          id: "29876",
          name: "Dronten",
          state_id: "2588",
        },
        {
          id: "29877",
          name: "Lelystad",
          state_id: "2588",
        },
        {
          id: "29878",
          name: "Noordoostpolder",
          state_id: "2588",
        },
        {
          id: "29879",
          name: "Urk",
          state_id: "2588",
        },
        {
          id: "29880",
          name: "Zeewolde",
          state_id: "2588",
        },
      ],
      Friesland: [
        {
          id: "29881",
          name: "Achtkarspelen",
          state_id: "2589",
        },
        {
          id: "29882",
          name: "Ameland",
          state_id: "2589",
        },
        {
          id: "29883",
          name: "Boarnsterhim",
          state_id: "2589",
        },
        {
          id: "29884",
          name: "Bolsward",
          state_id: "2589",
        },
        {
          id: "29885",
          name: "Dantumadeel",
          state_id: "2589",
        },
        {
          id: "29886",
          name: "Dongeradeel",
          state_id: "2589",
        },
        {
          id: "29887",
          name: "Drachten",
          state_id: "2589",
        },
        {
          id: "29888",
          name: "Ferwerderadiel",
          state_id: "2589",
        },
        {
          id: "29889",
          name: "Franekeradeel",
          state_id: "2589",
        },
        {
          id: "29890",
          name: "Gaasterlan-Sleat",
          state_id: "2589",
        },
        {
          id: "29891",
          name: "Gorredijk",
          state_id: "2589",
        },
        {
          id: "29892",
          name: "Harlingen",
          state_id: "2589",
        },
        {
          id: "29893",
          name: "Heerenveen",
          state_id: "2589",
        },
        {
          id: "29894",
          name: "Het Bildt",
          state_id: "2589",
        },
        {
          id: "29895",
          name: "Kollumerland",
          state_id: "2589",
        },
        {
          id: "29896",
          name: "Leeuwarden",
          state_id: "2589",
        },
        {
          id: "29897",
          name: "Leeuwarderadeel",
          state_id: "2589",
        },
        {
          id: "29898",
          name: "Lemsterland",
          state_id: "2589",
        },
        {
          id: "29899",
          name: "Littenseradiel",
          state_id: "2589",
        },
        {
          id: "29900",
          name: "Menaldumadeel",
          state_id: "2589",
        },
        {
          id: "29901",
          name: "Nijefurd",
          state_id: "2589",
        },
        {
          id: "29902",
          name: "Oostrum",
          state_id: "2589",
        },
        {
          id: "29903",
          name: "Ooststellingwerf",
          state_id: "2589",
        },
        {
          id: "29904",
          name: "Opsterland",
          state_id: "2589",
        },
        {
          id: "29905",
          name: "Schiermonnikoog",
          state_id: "2589",
        },
        {
          id: "29906",
          name: "Skasterlan",
          state_id: "2589",
        },
        {
          id: "29907",
          name: "Smallingerland",
          state_id: "2589",
        },
        {
          id: "29908",
          name: "Sneek",
          state_id: "2589",
        },
        {
          id: "29909",
          name: "Terschelling",
          state_id: "2589",
        },
        {
          id: "29910",
          name: "Tytsjerksteradiel",
          state_id: "2589",
        },
        {
          id: "29911",
          name: "Ureterp",
          state_id: "2589",
        },
        {
          id: "29912",
          name: "Weststellingwerf",
          state_id: "2589",
        },
        {
          id: "29913",
          name: "Wolvega",
          state_id: "2589",
        },
        {
          id: "29914",
          name: "Wunseradiel",
          state_id: "2589",
        },
        {
          id: "29915",
          name: "Wymbritseradiel",
          state_id: "2589",
        },
      ],
      Gelderland: [
        {
          id: "29916",
          name: "Aalten",
          state_id: "2590",
        },
        {
          id: "29917",
          name: "Angerlo",
          state_id: "2590",
        },
        {
          id: "29918",
          name: "Apeldoorn",
          state_id: "2590",
        },
        {
          id: "29919",
          name: "Appeldoorn",
          state_id: "2590",
        },
        {
          id: "29920",
          name: "Arnhem",
          state_id: "2590",
        },
        {
          id: "29921",
          name: "Barneveld",
          state_id: "2590",
        },
        {
          id: "29922",
          name: "Bemmel",
          state_id: "2590",
        },
        {
          id: "29923",
          name: "Bergh",
          state_id: "2590",
        },
        {
          id: "29924",
          name: "Beuningen",
          state_id: "2590",
        },
        {
          id: "29925",
          name: "Borculo",
          state_id: "2590",
        },
        {
          id: "29926",
          name: "Brummen",
          state_id: "2590",
        },
        {
          id: "29927",
          name: "Buren",
          state_id: "2590",
        },
        {
          id: "29928",
          name: "Culemborg",
          state_id: "2590",
        },
        {
          id: "29929",
          name: "Delden",
          state_id: "2590",
        },
        {
          id: "29930",
          name: "Didam",
          state_id: "2590",
        },
        {
          id: "29931",
          name: "Dieren",
          state_id: "2590",
        },
        {
          id: "29932",
          name: "Dinxperlo",
          state_id: "2590",
        },
        {
          id: "29933",
          name: "Dodewaard",
          state_id: "2590",
        },
        {
          id: "29934",
          name: "Doesburg",
          state_id: "2590",
        },
        {
          id: "29935",
          name: "Doetinchem",
          state_id: "2590",
        },
        {
          id: "29936",
          name: "Druten",
          state_id: "2590",
        },
        {
          id: "29937",
          name: "Duiven",
          state_id: "2590",
        },
        {
          id: "29938",
          name: "Ede",
          state_id: "2590",
        },
        {
          id: "29939",
          name: "Eerbeek",
          state_id: "2590",
        },
        {
          id: "29940",
          name: "Eibergen",
          state_id: "2590",
        },
        {
          id: "29941",
          name: "Elburg",
          state_id: "2590",
        },
        {
          id: "29942",
          name: "Epe",
          state_id: "2590",
        },
        {
          id: "29943",
          name: "Ermelo",
          state_id: "2590",
        },
        {
          id: "29944",
          name: "Geldermalsen",
          state_id: "2590",
        },
        {
          id: "29945",
          name: "Gendringen",
          state_id: "2590",
        },
        {
          id: "29946",
          name: "Giesbeek",
          state_id: "2590",
        },
        {
          id: "29947",
          name: "Gorssel",
          state_id: "2590",
        },
        {
          id: "29948",
          name: "Groenlo",
          state_id: "2590",
        },
        {
          id: "29949",
          name: "Groesbeek",
          state_id: "2590",
        },
        {
          id: "29950",
          name: "Harderwijk",
          state_id: "2590",
        },
        {
          id: "29951",
          name: "Hattem",
          state_id: "2590",
        },
        {
          id: "29952",
          name: "Heerde",
          state_id: "2590",
        },
        {
          id: "29953",
          name: "Hengelo",
          state_id: "2590",
        },
        {
          id: "29954",
          name: "Heumen",
          state_id: "2590",
        },
        {
          id: "29955",
          name: "Huisen",
          state_id: "2590",
        },
        {
          id: "29956",
          name: "Hummelo en Keppel",
          state_id: "2590",
        },
        {
          id: "29957",
          name: "Kesteren",
          state_id: "2590",
        },
        {
          id: "29958",
          name: "Kootwijkerbroek",
          state_id: "2590",
        },
        {
          id: "29959",
          name: "Leerdam",
          state_id: "2590",
        },
        {
          id: "29960",
          name: "Leeuwen",
          state_id: "2590",
        },
        {
          id: "29961",
          name: "Lichtenvoorde",
          state_id: "2590",
        },
        {
          id: "29962",
          name: "Lingewaal",
          state_id: "2590",
        },
        {
          id: "29963",
          name: "Lochem",
          state_id: "2590",
        },
        {
          id: "29964",
          name: "Loppersum",
          state_id: "2590",
        },
        {
          id: "29965",
          name: "Maasdriel",
          state_id: "2590",
        },
        {
          id: "29966",
          name: "Malden",
          state_id: "2590",
        },
        {
          id: "29967",
          name: "Millingen",
          state_id: "2590",
        },
        {
          id: "29968",
          name: "Molenhoek",
          state_id: "2590",
        },
        {
          id: "29969",
          name: "Neede",
          state_id: "2590",
        },
        {
          id: "29970",
          name: "Neerijnen",
          state_id: "2590",
        },
        {
          id: "29971",
          name: "Nijkerk",
          state_id: "2590",
        },
        {
          id: "29972",
          name: "Nijmegen",
          state_id: "2590",
        },
        {
          id: "29973",
          name: "Nunspeet",
          state_id: "2590",
        },
        {
          id: "29974",
          name: "Oldebroek",
          state_id: "2590",
        },
        {
          id: "29975",
          name: "Oosterbeek",
          state_id: "2590",
        },
        {
          id: "29976",
          name: "Overbetuwe",
          state_id: "2590",
        },
        {
          id: "29977",
          name: "Putten",
          state_id: "2590",
        },
        {
          id: "29978",
          name: "Renkum",
          state_id: "2590",
        },
        {
          id: "29979",
          name: "Rheden",
          state_id: "2590",
        },
        {
          id: "29980",
          name: "Rijnwaarden",
          state_id: "2590",
        },
        {
          id: "29981",
          name: "Rozendaal",
          state_id: "2590",
        },
        {
          id: "29982",
          name: "Ruurlo",
          state_id: "2590",
        },
        {
          id: "29983",
          name: "Scherpenzeel",
          state_id: "2590",
        },
        {
          id: "29984",
          name: "Steenderen",
          state_id: "2590",
        },
        {
          id: "29985",
          name: "Terborg",
          state_id: "2590",
        },
        {
          id: "29986",
          name: "Tiel",
          state_id: "2590",
        },
        {
          id: "29987",
          name: "Twello",
          state_id: "2590",
        },
        {
          id: "29988",
          name: "Ubbergen",
          state_id: "2590",
        },
        {
          id: "29989",
          name: "Vaassen",
          state_id: "2590",
        },
        {
          id: "29990",
          name: "Varsseveld",
          state_id: "2590",
        },
        {
          id: "29991",
          name: "Voorst",
          state_id: "2590",
        },
        {
          id: "29992",
          name: "Vorden",
          state_id: "2590",
        },
        {
          id: "29993",
          name: "Waardenburg",
          state_id: "2590",
        },
        {
          id: "29994",
          name: "Wageningen",
          state_id: "2590",
        },
        {
          id: "29995",
          name: "Warmsveld",
          state_id: "2590",
        },
        {
          id: "29996",
          name: "Wehl",
          state_id: "2590",
        },
        {
          id: "29997",
          name: "Westervoort",
          state_id: "2590",
        },
        {
          id: "29998",
          name: "Wijchen",
          state_id: "2590",
        },
        {
          id: "29999",
          name: "Winterswijk",
          state_id: "2590",
        },
        {
          id: "30000",
          name: "Wisch",
          state_id: "2590",
        },
        {
          id: "30001",
          name: "Zaltbommel",
          state_id: "2590",
        },
        {
          id: "30002",
          name: "Zelhem",
          state_id: "2590",
        },
        {
          id: "30003",
          name: "Zevenaar",
          state_id: "2590",
        },
        {
          id: "30004",
          name: "Zutphen",
          state_id: "2590",
        },
        {
          id: "30005",
          name: "s-Heerenberg",
          state_id: "2590",
        },
      ],
      Groningen: [
        {
          id: "30006",
          name: "Appingedam",
          state_id: "2591",
        },
        {
          id: "30007",
          name: "Bedum",
          state_id: "2591",
        },
        {
          id: "30008",
          name: "Bellingwedde",
          state_id: "2591",
        },
        {
          id: "30009",
          name: "De Marne",
          state_id: "2591",
        },
        {
          id: "30010",
          name: "Delfzijl",
          state_id: "2591",
        },
        {
          id: "30011",
          name: "Eemsmond",
          state_id: "2591",
        },
        {
          id: "30012",
          name: "Groningen",
          state_id: "2591",
        },
        {
          id: "30013",
          name: "Grootegast",
          state_id: "2591",
        },
        {
          id: "30014",
          name: "Haren",
          state_id: "2591",
        },
        {
          id: "30015",
          name: "Hoogezand-Sappemeer",
          state_id: "2591",
        },
        {
          id: "30016",
          name: "Leek",
          state_id: "2591",
        },
        {
          id: "30017",
          name: "Marum",
          state_id: "2591",
        },
        {
          id: "30018",
          name: "Midwolda",
          state_id: "2591",
        },
        {
          id: "30019",
          name: "Muntendam",
          state_id: "2591",
        },
        {
          id: "30020",
          name: "Pekela",
          state_id: "2591",
        },
        {
          id: "30021",
          name: "Reiderland",
          state_id: "2591",
        },
        {
          id: "30022",
          name: "Scheemda",
          state_id: "2591",
        },
        {
          id: "30023",
          name: "Slochteren",
          state_id: "2591",
        },
        {
          id: "30024",
          name: "Ten Boer",
          state_id: "2591",
        },
        {
          id: "30025",
          name: "Tolbert",
          state_id: "2591",
        },
        {
          id: "30026",
          name: "Veendam",
          state_id: "2591",
        },
        {
          id: "30027",
          name: "Vlagtwedde",
          state_id: "2591",
        },
        {
          id: "30028",
          name: "Winschoten",
          state_id: "2591",
        },
        {
          id: "30029",
          name: "Winsum",
          state_id: "2591",
        },
        {
          id: "30030",
          name: "Zuidhorn",
          state_id: "2591",
        },
      ],
      Limburg: [
        {
          id: "30031",
          name: "Ambt Montfort",
          state_id: "2592",
        },
        {
          id: "30032",
          name: "Arcen en Velden",
          state_id: "2592",
        },
        {
          id: "30033",
          name: "Beek",
          state_id: "2592",
        },
        {
          id: "30034",
          name: "Beesel",
          state_id: "2592",
        },
        {
          id: "30035",
          name: "Bergen",
          state_id: "2592",
        },
        {
          id: "30036",
          name: "Blerick",
          state_id: "2592",
        },
        {
          id: "30037",
          name: "Brunssum",
          state_id: "2592",
        },
        {
          id: "30038",
          name: "Echt",
          state_id: "2592",
        },
        {
          id: "30039",
          name: "Eijsden",
          state_id: "2592",
        },
        {
          id: "30040",
          name: "Gennep",
          state_id: "2592",
        },
        {
          id: "30041",
          name: "Gulpen-Wittem",
          state_id: "2592",
        },
        {
          id: "30042",
          name: "Haelen",
          state_id: "2592",
        },
        {
          id: "30043",
          name: "Heel",
          state_id: "2592",
        },
        {
          id: "30044",
          name: "Heerlen",
          state_id: "2592",
        },
        {
          id: "30045",
          name: "Helden",
          state_id: "2592",
        },
        {
          id: "30046",
          name: "Heythuysen",
          state_id: "2592",
        },
        {
          id: "30047",
          name: "Horst",
          state_id: "2592",
        },
        {
          id: "30048",
          name: "Hunsel",
          state_id: "2592",
        },
        {
          id: "30049",
          name: "Kerkrade",
          state_id: "2592",
        },
        {
          id: "30050",
          name: "Kessel",
          state_id: "2592",
        },
        {
          id: "30051",
          name: "Landgraaf",
          state_id: "2592",
        },
        {
          id: "30052",
          name: "Maasbracht",
          state_id: "2592",
        },
        {
          id: "30053",
          name: "Maasbree",
          state_id: "2592",
        },
        {
          id: "30054",
          name: "Maastricht",
          state_id: "2592",
        },
        {
          id: "30055",
          name: "Margraten",
          state_id: "2592",
        },
        {
          id: "30056",
          name: "Meerlo-Wanssum",
          state_id: "2592",
        },
        {
          id: "30057",
          name: "Meerssen",
          state_id: "2592",
        },
        {
          id: "30058",
          name: "Meijel",
          state_id: "2592",
        },
        {
          id: "30059",
          name: "Mook en Middelaar",
          state_id: "2592",
        },
        {
          id: "30060",
          name: "Nederweert",
          state_id: "2592",
        },
        {
          id: "30061",
          name: "Nuth",
          state_id: "2592",
        },
        {
          id: "30062",
          name: "Onderbanken",
          state_id: "2592",
        },
        {
          id: "30063",
          name: "Roerdalen",
          state_id: "2592",
        },
        {
          id: "30064",
          name: "Roermond",
          state_id: "2592",
        },
        {
          id: "30065",
          name: "Roggel",
          state_id: "2592",
        },
        {
          id: "30066",
          name: "Roggel en Neer",
          state_id: "2592",
        },
        {
          id: "30067",
          name: "Schinnen",
          state_id: "2592",
        },
        {
          id: "30068",
          name: "Sevenum",
          state_id: "2592",
        },
        {
          id: "30069",
          name: "Simpelveld",
          state_id: "2592",
        },
        {
          id: "30070",
          name: "Sittard",
          state_id: "2592",
        },
        {
          id: "30071",
          name: "Sittard-Geleen",
          state_id: "2592",
        },
        {
          id: "30072",
          name: "Stein",
          state_id: "2592",
        },
        {
          id: "30073",
          name: "Stramproy",
          state_id: "2592",
        },
        {
          id: "30074",
          name: "Susteren",
          state_id: "2592",
        },
        {
          id: "30075",
          name: "Swalmen",
          state_id: "2592",
        },
        {
          id: "30076",
          name: "Tegelen",
          state_id: "2592",
        },
        {
          id: "30077",
          name: "Thorn",
          state_id: "2592",
        },
        {
          id: "30078",
          name: "Vaals",
          state_id: "2592",
        },
        {
          id: "30079",
          name: "Valkenburg",
          state_id: "2592",
        },
        {
          id: "30080",
          name: "Venlo",
          state_id: "2592",
        },
        {
          id: "30081",
          name: "Venray",
          state_id: "2592",
        },
        {
          id: "30082",
          name: "Vilt Limburg",
          state_id: "2592",
        },
        {
          id: "30083",
          name: "Voerendaal",
          state_id: "2592",
        },
        {
          id: "30084",
          name: "Weert",
          state_id: "2592",
        },
      ],
      "Noord-Brabant": [
        {
          id: "30085",
          name: "s-Hertogenbosch",
          state_id: "2593",
        },
        {
          id: "30086",
          name: "Aalburg",
          state_id: "2593",
        },
        {
          id: "30087",
          name: "Alphen-Chaam",
          state_id: "2593",
        },
        {
          id: "30088",
          name: "Asten",
          state_id: "2593",
        },
        {
          id: "30089",
          name: "Baarle-Nassau",
          state_id: "2593",
        },
        {
          id: "30090",
          name: "Bergeijk",
          state_id: "2593",
        },
        {
          id: "30091",
          name: "Bergen op Zoom",
          state_id: "2593",
        },
        {
          id: "30092",
          name: "Berghem",
          state_id: "2593",
        },
        {
          id: "30093",
          name: "Bernheze",
          state_id: "2593",
        },
        {
          id: "30094",
          name: "Bernisse",
          state_id: "2593",
        },
        {
          id: "30095",
          name: "Best",
          state_id: "2593",
        },
        {
          id: "30096",
          name: "Bladel",
          state_id: "2593",
        },
        {
          id: "30097",
          name: "Boekel",
          state_id: "2593",
        },
        {
          id: "30098",
          name: "Boxmeer",
          state_id: "2593",
        },
        {
          id: "30099",
          name: "Boxtel",
          state_id: "2593",
        },
        {
          id: "30100",
          name: "Breda",
          state_id: "2593",
        },
        {
          id: "30101",
          name: "Budel",
          state_id: "2593",
        },
        {
          id: "30102",
          name: "Cranendonck",
          state_id: "2593",
        },
        {
          id: "30103",
          name: "Cuijk",
          state_id: "2593",
        },
        {
          id: "30104",
          name: "Den Bosch",
          state_id: "2593",
        },
        {
          id: "30105",
          name: "Den Dungen",
          state_id: "2593",
        },
        {
          id: "30106",
          name: "Deurne",
          state_id: "2593",
        },
        {
          id: "30107",
          name: "Dongen",
          state_id: "2593",
        },
        {
          id: "30108",
          name: "Drimmelen",
          state_id: "2593",
        },
        {
          id: "30109",
          name: "Drunen",
          state_id: "2593",
        },
        {
          id: "30110",
          name: "Duizel",
          state_id: "2593",
        },
        {
          id: "30111",
          name: "Eersel",
          state_id: "2593",
        },
        {
          id: "30112",
          name: "Eindhoven",
          state_id: "2593",
        },
        {
          id: "30113",
          name: "Etten-Leur",
          state_id: "2593",
        },
        {
          id: "30114",
          name: "Geertruidenberg",
          state_id: "2593",
        },
        {
          id: "30115",
          name: "Geldrop",
          state_id: "2593",
        },
        {
          id: "30116",
          name: "Gemert-Bakel",
          state_id: "2593",
        },
        {
          id: "30117",
          name: "Gilze en Rijen",
          state_id: "2593",
        },
        {
          id: "30118",
          name: "Goirle",
          state_id: "2593",
        },
        {
          id: "30119",
          name: "Grave",
          state_id: "2593",
        },
        {
          id: "30120",
          name: "Haaren",
          state_id: "2593",
        },
        {
          id: "30121",
          name: "Halderberge",
          state_id: "2593",
        },
        {
          id: "30122",
          name: "Heeze-Leende",
          state_id: "2593",
        },
        {
          id: "30123",
          name: "Heijningen",
          state_id: "2593",
        },
        {
          id: "30124",
          name: "Helmond",
          state_id: "2593",
        },
        {
          id: "30125",
          name: "Heusden",
          state_id: "2593",
        },
        {
          id: "30126",
          name: "Hilvarenbeek",
          state_id: "2593",
        },
        {
          id: "30127",
          name: "Hoeven",
          state_id: "2593",
        },
        {
          id: "30128",
          name: "Hoogerheide",
          state_id: "2593",
        },
        {
          id: "30129",
          name: "Kaatsheuvel",
          state_id: "2593",
        },
        {
          id: "30130",
          name: "Korendijk",
          state_id: "2593",
        },
        {
          id: "30131",
          name: "Laarbeek",
          state_id: "2593",
        },
        {
          id: "30132",
          name: "Landerd",
          state_id: "2593",
        },
        {
          id: "30133",
          name: "Lith",
          state_id: "2593",
        },
        {
          id: "30134",
          name: "Loon op Zand",
          state_id: "2593",
        },
        {
          id: "30135",
          name: "Maarheeze",
          state_id: "2593",
        },
        {
          id: "30136",
          name: "Maasdonk",
          state_id: "2593",
        },
        {
          id: "30137",
          name: "Mierlo",
          state_id: "2593",
        },
        {
          id: "30138",
          name: "Mill en Sint Hubert",
          state_id: "2593",
        },
        {
          id: "30139",
          name: "Moerdijk",
          state_id: "2593",
        },
        {
          id: "30140",
          name: "Nieuwkuijk",
          state_id: "2593",
        },
        {
          id: "30141",
          name: "Nuenen",
          state_id: "2593",
        },
        {
          id: "30142",
          name: "Oirschot",
          state_id: "2593",
        },
        {
          id: "30143",
          name: "Oisterwijk",
          state_id: "2593",
        },
        {
          id: "30144",
          name: "Oosterhout",
          state_id: "2593",
        },
        {
          id: "30145",
          name: "Oss",
          state_id: "2593",
        },
        {
          id: "30146",
          name: "Raamsdonksveer",
          state_id: "2593",
        },
        {
          id: "30147",
          name: "Ravenstein",
          state_id: "2593",
        },
        {
          id: "30148",
          name: "Reusel-De Mierden",
          state_id: "2593",
        },
        {
          id: "30149",
          name: "Roosendaal",
          state_id: "2593",
        },
        {
          id: "30150",
          name: "Rosmalen",
          state_id: "2593",
        },
        {
          id: "30151",
          name: "Rucphen",
          state_id: "2593",
        },
        {
          id: "30152",
          name: "Schaijk",
          state_id: "2593",
        },
        {
          id: "30153",
          name: "Schijndel",
          state_id: "2593",
        },
        {
          id: "30154",
          name: "Sint Anthonis",
          state_id: "2593",
        },
        {
          id: "30155",
          name: "Sint Willebrord",
          state_id: "2593",
        },
        {
          id: "30156",
          name: "Sint-Michielsgestel",
          state_id: "2593",
        },
        {
          id: "30157",
          name: "Sint-Oedenrode",
          state_id: "2593",
        },
        {
          id: "30158",
          name: "Sleeuwijk",
          state_id: "2593",
        },
        {
          id: "30159",
          name: "Someren",
          state_id: "2593",
        },
        {
          id: "30160",
          name: "Son en Breugel",
          state_id: "2593",
        },
        {
          id: "30161",
          name: "Steenbergen",
          state_id: "2593",
        },
        {
          id: "30162",
          name: "Tilburg",
          state_id: "2593",
        },
        {
          id: "30163",
          name: "Uden",
          state_id: "2593",
        },
        {
          id: "30164",
          name: "Valkenswaard",
          state_id: "2593",
        },
        {
          id: "30165",
          name: "Veghel",
          state_id: "2593",
        },
        {
          id: "30166",
          name: "Veldhoven",
          state_id: "2593",
        },
        {
          id: "30167",
          name: "Vinkel",
          state_id: "2593",
        },
        {
          id: "30168",
          name: "Vught",
          state_id: "2593",
        },
        {
          id: "30169",
          name: "Waalre",
          state_id: "2593",
        },
        {
          id: "30170",
          name: "Waalwijk",
          state_id: "2593",
        },
        {
          id: "30171",
          name: "Werkendam",
          state_id: "2593",
        },
        {
          id: "30172",
          name: "Woensdrecht",
          state_id: "2593",
        },
        {
          id: "30173",
          name: "Woudrichem",
          state_id: "2593",
        },
        {
          id: "30174",
          name: "Zundert",
          state_id: "2593",
        },
      ],
      "Noord-Holland": [
        {
          id: "30175",
          name: "Aalsmeer",
          state_id: "2594",
        },
        {
          id: "30176",
          name: "Alkmaar",
          state_id: "2594",
        },
        {
          id: "30177",
          name: "Amstelveen",
          state_id: "2594",
        },
        {
          id: "30178",
          name: "Amsterdam",
          state_id: "2594",
        },
        {
          id: "30179",
          name: "Andijk",
          state_id: "2594",
        },
        {
          id: "30180",
          name: "Ankeveen",
          state_id: "2594",
        },
        {
          id: "30181",
          name: "Anna Paulowna",
          state_id: "2594",
        },
        {
          id: "30182",
          name: "Assendelft",
          state_id: "2594",
        },
        {
          id: "30183",
          name: "Badhoevedorp",
          state_id: "2594",
        },
        {
          id: "30184",
          name: "Beemster",
          state_id: "2594",
        },
        {
          id: "30185",
          name: "Bennebroek",
          state_id: "2594",
        },
        {
          id: "30186",
          name: "Bergen",
          state_id: "2594",
        },
        {
          id: "30187",
          name: "Beverwijk",
          state_id: "2594",
        },
        {
          id: "30188",
          name: "Blaricum",
          state_id: "2594",
        },
        {
          id: "30189",
          name: "Bloemendaal",
          state_id: "2594",
        },
        {
          id: "30190",
          name: "Bovenkarspel",
          state_id: "2594",
        },
        {
          id: "30191",
          name: "Bussum",
          state_id: "2594",
        },
        {
          id: "30192",
          name: "Castricum",
          state_id: "2594",
        },
        {
          id: "30193",
          name: "Den Helder",
          state_id: "2594",
        },
        {
          id: "30194",
          name: "Diemen",
          state_id: "2594",
        },
        {
          id: "30195",
          name: "Drechterland",
          state_id: "2594",
        },
        {
          id: "30196",
          name: "Edam-Volendam",
          state_id: "2594",
        },
        {
          id: "30197",
          name: "Enkhuizen",
          state_id: "2594",
        },
        {
          id: "30198",
          name: "Graft-De Rijp",
          state_id: "2594",
        },
        {
          id: "30199",
          name: "Haarlem",
          state_id: "2594",
        },
        {
          id: "30200",
          name: "Haarlemmerliede",
          state_id: "2594",
        },
        {
          id: "30201",
          name: "Haarlemmermeer",
          state_id: "2594",
        },
        {
          id: "30202",
          name: "Harenkarspel",
          state_id: "2594",
        },
        {
          id: "30203",
          name: "Heemskerk",
          state_id: "2594",
        },
        {
          id: "30204",
          name: "Heemstede",
          state_id: "2594",
        },
        {
          id: "30205",
          name: "Heerhugowaard",
          state_id: "2594",
        },
        {
          id: "30206",
          name: "Heiloo",
          state_id: "2594",
        },
        {
          id: "30207",
          name: "Hillegom",
          state_id: "2594",
        },
        {
          id: "30208",
          name: "Hilversum",
          state_id: "2594",
        },
        {
          id: "30209",
          name: "Hoofddorp",
          state_id: "2594",
        },
        {
          id: "30210",
          name: "Hoorn",
          state_id: "2594",
        },
        {
          id: "30211",
          name: "Huizen",
          state_id: "2594",
        },
        {
          id: "30212",
          name: "Ijmuiden",
          state_id: "2594",
        },
        {
          id: "30213",
          name: "Katwijk",
          state_id: "2594",
        },
        {
          id: "30214",
          name: "Krommenie",
          state_id: "2594",
        },
        {
          id: "30215",
          name: "Landsmeer",
          state_id: "2594",
        },
        {
          id: "30216",
          name: "Langedijk",
          state_id: "2594",
        },
        {
          id: "30217",
          name: "Laren",
          state_id: "2594",
        },
        {
          id: "30218",
          name: "Loosdrecht",
          state_id: "2594",
        },
        {
          id: "30219",
          name: "Medemblik",
          state_id: "2594",
        },
        {
          id: "30220",
          name: "Middenbeemster",
          state_id: "2594",
        },
        {
          id: "30221",
          name: "Muiden",
          state_id: "2594",
        },
        {
          id: "30222",
          name: "Naarden",
          state_id: "2594",
        },
        {
          id: "30223",
          name: "Niedorp",
          state_id: "2594",
        },
        {
          id: "30224",
          name: "Nieuw-Vennep",
          state_id: "2594",
        },
        {
          id: "30225",
          name: "Noorder-Koggenland",
          state_id: "2594",
        },
        {
          id: "30226",
          name: "Obdam",
          state_id: "2594",
        },
        {
          id: "30227",
          name: "Oostzaan",
          state_id: "2594",
        },
        {
          id: "30228",
          name: "Opmeer",
          state_id: "2594",
        },
        {
          id: "30229",
          name: "Oude Meer",
          state_id: "2594",
        },
        {
          id: "30230",
          name: "Ouder-Amstel",
          state_id: "2594",
        },
        {
          id: "30231",
          name: "Oudkarspel",
          state_id: "2594",
        },
        {
          id: "30232",
          name: "Purmerend",
          state_id: "2594",
        },
        {
          id: "30233",
          name: "Rozenburg",
          state_id: "2594",
        },
        {
          id: "30234",
          name: "Schagen",
          state_id: "2594",
        },
        {
          id: "30235",
          name: "Schermer",
          state_id: "2594",
        },
        {
          id: "30236",
          name: "Stede Broec",
          state_id: "2594",
        },
        {
          id: "30237",
          name: "Texel",
          state_id: "2594",
        },
        {
          id: "30238",
          name: "Tuitjenhorn",
          state_id: "2594",
        },
        {
          id: "30239",
          name: "Uitgeest",
          state_id: "2594",
        },
        {
          id: "30240",
          name: "Uithoorn",
          state_id: "2594",
        },
        {
          id: "30241",
          name: "Velsen",
          state_id: "2594",
        },
        {
          id: "30242",
          name: "Venhuizen",
          state_id: "2594",
        },
        {
          id: "30243",
          name: "Vijfhuizen",
          state_id: "2594",
        },
        {
          id: "30244",
          name: "Waarland",
          state_id: "2594",
        },
        {
          id: "30245",
          name: "Waterland",
          state_id: "2594",
        },
        {
          id: "30246",
          name: "Weesp",
          state_id: "2594",
        },
        {
          id: "30247",
          name: "Wervershoof",
          state_id: "2594",
        },
        {
          id: "30248",
          name: "Wester-Koggenland",
          state_id: "2594",
        },
        {
          id: "30249",
          name: "Westwoud",
          state_id: "2594",
        },
        {
          id: "30250",
          name: "Wieringen",
          state_id: "2594",
        },
        {
          id: "30251",
          name: "Wieringermeer",
          state_id: "2594",
        },
        {
          id: "30252",
          name: "Wognum",
          state_id: "2594",
        },
        {
          id: "30253",
          name: "Wormer",
          state_id: "2594",
        },
        {
          id: "30254",
          name: "Wormerland",
          state_id: "2594",
        },
        {
          id: "30255",
          name: "Wormerveer",
          state_id: "2594",
        },
        {
          id: "30257",
          name: "Zaanstad",
          state_id: "2594",
        },
        {
          id: "30258",
          name: "Zandvoort",
          state_id: "2594",
        },
        {
          id: "30259",
          name: "Zeevang",
          state_id: "2594",
        },
        {
          id: "30260",
          name: "Zwaag",
          state_id: "2594",
        },
        {
          id: "30261",
          name: "Zwanenburg",
          state_id: "2594",
        },
      ],
      Overijssel: [
        {
          id: "30262",
          name: "Almelo",
          state_id: "2595",
        },
        {
          id: "30263",
          name: "Bathmen",
          state_id: "2595",
        },
        {
          id: "30264",
          name: "Borne",
          state_id: "2595",
        },
        {
          id: "30265",
          name: "Dalfsen",
          state_id: "2595",
        },
        {
          id: "30266",
          name: "Dedemsvaart",
          state_id: "2595",
        },
        {
          id: "30267",
          name: "Denekamp",
          state_id: "2595",
        },
        {
          id: "30268",
          name: "Deventer",
          state_id: "2595",
        },
        {
          id: "30269",
          name: "Diepenheim",
          state_id: "2595",
        },
        {
          id: "30270",
          name: "Enschede",
          state_id: "2595",
        },
        {
          id: "30271",
          name: "Genemuiden",
          state_id: "2595",
        },
        {
          id: "30272",
          name: "Haaksbergen",
          state_id: "2595",
        },
        {
          id: "30273",
          name: "Hardenberg",
          state_id: "2595",
        },
        {
          id: "30274",
          name: "Hasselt",
          state_id: "2595",
        },
        {
          id: "30275",
          name: "Hellendoorn",
          state_id: "2595",
        },
        {
          id: "30276",
          name: "Hengelo",
          state_id: "2595",
        },
        {
          id: "30277",
          name: "Hof van Twente",
          state_id: "2595",
        },
        {
          id: "30278",
          name: "IJsselmuiden",
          state_id: "2595",
        },
        {
          id: "30279",
          name: "Kampen",
          state_id: "2595",
        },
        {
          id: "30280",
          name: "Lemelerveld",
          state_id: "2595",
        },
        {
          id: "30281",
          name: "Losser",
          state_id: "2595",
        },
        {
          id: "30282",
          name: "Nieuwleusen",
          state_id: "2595",
        },
        {
          id: "30283",
          name: "Nijverdal",
          state_id: "2595",
        },
        {
          id: "30284",
          name: "Oldenzaal",
          state_id: "2595",
        },
        {
          id: "30285",
          name: "Olst",
          state_id: "2595",
        },
        {
          id: "30286",
          name: "Ommen",
          state_id: "2595",
        },
        {
          id: "30287",
          name: "Ootmarsum",
          state_id: "2595",
        },
        {
          id: "30288",
          name: "Raalte",
          state_id: "2595",
        },
        {
          id: "30289",
          name: "Rijssen",
          state_id: "2595",
        },
        {
          id: "30290",
          name: "Staphorst",
          state_id: "2595",
        },
        {
          id: "30291",
          name: "Steenwijk",
          state_id: "2595",
        },
        {
          id: "30292",
          name: "Tubbergen",
          state_id: "2595",
        },
        {
          id: "30293",
          name: "Vriezenveen",
          state_id: "2595",
        },
        {
          id: "30294",
          name: "Vroomshoop",
          state_id: "2595",
        },
        {
          id: "30295",
          name: "Weerselo",
          state_id: "2595",
        },
        {
          id: "30296",
          name: "Wierden",
          state_id: "2595",
        },
        {
          id: "30297",
          name: "Zwartewaterland",
          state_id: "2595",
        },
        {
          id: "30298",
          name: "Zwolle",
          state_id: "2595",
        },
      ],
      "South Holland": [],
      Utrecht: [
        {
          id: "30299",
          name: "Abcoude",
          state_id: "2597",
        },
        {
          id: "30300",
          name: "Amerongen",
          state_id: "2597",
        },
        {
          id: "30301",
          name: "Amersfoort",
          state_id: "2597",
        },
        {
          id: "30302",
          name: "Baarn",
          state_id: "2597",
        },
        {
          id: "30303",
          name: "Benschop",
          state_id: "2597",
        },
        {
          id: "30304",
          name: "Breukelen",
          state_id: "2597",
        },
        {
          id: "30305",
          name: "Bunnik",
          state_id: "2597",
        },
        {
          id: "30306",
          name: "Bunschoten",
          state_id: "2597",
        },
        {
          id: "30307",
          name: "De Bilt",
          state_id: "2597",
        },
        {
          id: "30308",
          name: "De Ronde Venen",
          state_id: "2597",
        },
        {
          id: "30309",
          name: "Den Dolder",
          state_id: "2597",
        },
        {
          id: "30310",
          name: "Doorn",
          state_id: "2597",
        },
        {
          id: "30311",
          name: "Driebergen-Rijsenburg",
          state_id: "2597",
        },
        {
          id: "30312",
          name: "Eemnes",
          state_id: "2597",
        },
        {
          id: "30313",
          name: "Houten",
          state_id: "2597",
        },
        {
          id: "30314",
          name: "IJsselstein",
          state_id: "2597",
        },
        {
          id: "30315",
          name: "Kockengen",
          state_id: "2597",
        },
        {
          id: "30316",
          name: "Leersum",
          state_id: "2597",
        },
        {
          id: "30317",
          name: "Leusden",
          state_id: "2597",
        },
        {
          id: "30318",
          name: "Loenen",
          state_id: "2597",
        },
        {
          id: "30319",
          name: "Lopik",
          state_id: "2597",
        },
        {
          id: "30320",
          name: "Maarn",
          state_id: "2597",
        },
        {
          id: "30321",
          name: "Maarsen",
          state_id: "2597",
        },
        {
          id: "30322",
          name: "Mijdrecht",
          state_id: "2597",
        },
        {
          id: "30323",
          name: "Montfoort",
          state_id: "2597",
        },
        {
          id: "30324",
          name: "Nieuwegein",
          state_id: "2597",
        },
        {
          id: "30325",
          name: "Nigtevecht",
          state_id: "2597",
        },
        {
          id: "30326",
          name: "Odijk",
          state_id: "2597",
        },
        {
          id: "30327",
          name: "Oudewater",
          state_id: "2597",
        },
        {
          id: "30328",
          name: "Renswoude",
          state_id: "2597",
        },
        {
          id: "30329",
          name: "Rhenen",
          state_id: "2597",
        },
        {
          id: "30330",
          name: "Soest",
          state_id: "2597",
        },
        {
          id: "30331",
          name: "Soesterberg",
          state_id: "2597",
        },
        {
          id: "30332",
          name: "Utrecht",
          state_id: "2597",
        },
        {
          id: "30333",
          name: "Veenendaal",
          state_id: "2597",
        },
        {
          id: "30334",
          name: "Vianen",
          state_id: "2597",
        },
        {
          id: "30335",
          name: "Wijdemeren",
          state_id: "2597",
        },
        {
          id: "30336",
          name: "Wijk",
          state_id: "2597",
        },
        {
          id: "30337",
          name: "Wilnis",
          state_id: "2597",
        },
        {
          id: "30338",
          name: "Woerden",
          state_id: "2597",
        },
        {
          id: "30339",
          name: "Woudenberg",
          state_id: "2597",
        },
        {
          id: "30340",
          name: "Zeist",
          state_id: "2597",
        },
      ],
      Zeeland: [
        {
          id: "30341",
          name: "Axel",
          state_id: "2598",
        },
        {
          id: "30342",
          name: "Borsele",
          state_id: "2598",
        },
        {
          id: "30343",
          name: "Goes",
          state_id: "2598",
        },
        {
          id: "30344",
          name: "Hontenisse",
          state_id: "2598",
        },
        {
          id: "30345",
          name: "Hulst",
          state_id: "2598",
        },
        {
          id: "30346",
          name: "Kapelle",
          state_id: "2598",
        },
        {
          id: "30347",
          name: "Middelburg",
          state_id: "2598",
        },
        {
          id: "30348",
          name: "Noord-Beveland",
          state_id: "2598",
        },
        {
          id: "30349",
          name: "Oostburg",
          state_id: "2598",
        },
        {
          id: "30350",
          name: "Reimerswaal",
          state_id: "2598",
        },
        {
          id: "30351",
          name: "Sas van Gent",
          state_id: "2598",
        },
        {
          id: "30352",
          name: "Schouwen-Duiveland",
          state_id: "2598",
        },
        {
          id: "30353",
          name: "Sluis-Aardenburg",
          state_id: "2598",
        },
        {
          id: "30354",
          name: "Terneuzen",
          state_id: "2598",
        },
        {
          id: "30355",
          name: "Tholen",
          state_id: "2598",
        },
        {
          id: "30356",
          name: "Veere",
          state_id: "2598",
        },
        {
          id: "30357",
          name: "Vlissingen",
          state_id: "2598",
        },
        {
          id: "30358",
          name: "Zierikzee",
          state_id: "2598",
        },
        {
          id: "30359",
          name: "Zijpe",
          state_id: "2598",
        },
      ],
      "Zuid-Holland": [
        {
          id: "30360",
          name: "s-Gravendeel",
          state_id: "2599",
        },
        {
          id: "30361",
          name: "s-Gravenhage",
          state_id: "2599",
        },
        {
          id: "30362",
          name: "s-Gravenzande",
          state_id: "2599",
        },
        {
          id: "30363",
          name: "Alblasserdam",
          state_id: "2599",
        },
        {
          id: "30364",
          name: "Albrandswaard",
          state_id: "2599",
        },
        {
          id: "30365",
          name: "Alkemade",
          state_id: "2599",
        },
        {
          id: "30366",
          name: "Alphen",
          state_id: "2599",
        },
        {
          id: "30367",
          name: "Alphen aan den Rijn",
          state_id: "2599",
        },
        {
          id: "30368",
          name: "Barendrecht",
          state_id: "2599",
        },
        {
          id: "30369",
          name: "Bergambacht",
          state_id: "2599",
        },
        {
          id: "30370",
          name: "Bergschenhoek",
          state_id: "2599",
        },
        {
          id: "30371",
          name: "Berkel en Rodenrijs",
          state_id: "2599",
        },
        {
          id: "30372",
          name: "Binnenmaas",
          state_id: "2599",
        },
        {
          id: "30373",
          name: "Bleiswijk",
          state_id: "2599",
        },
        {
          id: "30374",
          name: "Bodegraven",
          state_id: "2599",
        },
        {
          id: "30375",
          name: "Boskoop",
          state_id: "2599",
        },
        {
          id: "30376",
          name: "Brielle",
          state_id: "2599",
        },
        {
          id: "30377",
          name: "Capelle",
          state_id: "2599",
        },
        {
          id: "30378",
          name: "Cromstrijen",
          state_id: "2599",
        },
        {
          id: "30379",
          name: "De Lier",
          state_id: "2599",
        },
        {
          id: "30380",
          name: "Delft",
          state_id: "2599",
        },
        {
          id: "30381",
          name: "Dirksland",
          state_id: "2599",
        },
        {
          id: "30382",
          name: "Dordrecht",
          state_id: "2599",
        },
        {
          id: "30383",
          name: "Giessenlanden",
          state_id: "2599",
        },
        {
          id: "30384",
          name: "Goedereede",
          state_id: "2599",
        },
        {
          id: "30385",
          name: "Gorinchem",
          state_id: "2599",
        },
        {
          id: "30386",
          name: "Gouda",
          state_id: "2599",
        },
        {
          id: "30387",
          name: "Graafstroom",
          state_id: "2599",
        },
        {
          id: "30388",
          name: "Hardinxveld-Giessendam",
          state_id: "2599",
        },
        {
          id: "30389",
          name: "Heerjansdam",
          state_id: "2599",
        },
        {
          id: "30390",
          name: "Hellevoetsluis",
          state_id: "2599",
        },
        {
          id: "30391",
          name: "Hendrik-Ido-Ambacht",
          state_id: "2599",
        },
        {
          id: "30392",
          name: "Jacobswoude",
          state_id: "2599",
        },
        {
          id: "30393",
          name: "Katwijk",
          state_id: "2599",
        },
        {
          id: "30394",
          name: "Kinderdijk",
          state_id: "2599",
        },
        {
          id: "30395",
          name: "Krimpen",
          state_id: "2599",
        },
        {
          id: "30396",
          name: "Leiden",
          state_id: "2599",
        },
        {
          id: "30397",
          name: "Leiderdorp",
          state_id: "2599",
        },
        {
          id: "30398",
          name: "Leidschendam-Voorburg",
          state_id: "2599",
        },
        {
          id: "30399",
          name: "Liemeer",
          state_id: "2599",
        },
        {
          id: "30400",
          name: "Liesveld",
          state_id: "2599",
        },
        {
          id: "30401",
          name: "Lisse",
          state_id: "2599",
        },
        {
          id: "30402",
          name: "Maasland",
          state_id: "2599",
        },
        {
          id: "30403",
          name: "Maassluis",
          state_id: "2599",
        },
        {
          id: "30404",
          name: "Middelharnis",
          state_id: "2599",
        },
        {
          id: "30405",
          name: "Monster",
          state_id: "2599",
        },
        {
          id: "30406",
          name: "Moordrecht",
          state_id: "2599",
        },
        {
          id: "30407",
          name: "Naaldwijk",
          state_id: "2599",
        },
        {
          id: "30408",
          name: "Nederlek",
          state_id: "2599",
        },
        {
          id: "30409",
          name: "Nieuw-Lekkerland",
          state_id: "2599",
        },
        {
          id: "30410",
          name: "Nieuwekerk aan den IJssel",
          state_id: "2599",
        },
        {
          id: "30411",
          name: "Nieuwkoop",
          state_id: "2599",
        },
        {
          id: "30412",
          name: "Noordwijk",
          state_id: "2599",
        },
        {
          id: "30413",
          name: "Noordwijkerhout",
          state_id: "2599",
        },
        {
          id: "30414",
          name: "Oegestgeest",
          state_id: "2599",
        },
        {
          id: "30415",
          name: "Oostflakkee",
          state_id: "2599",
        },
        {
          id: "30416",
          name: "Oud-Beijerland",
          state_id: "2599",
        },
        {
          id: "30417",
          name: "Ouderkerk",
          state_id: "2599",
        },
        {
          id: "30418",
          name: "Papendrecht",
          state_id: "2599",
        },
        {
          id: "30419",
          name: "Pijnacker-Nootdorp",
          state_id: "2599",
        },
        {
          id: "30420",
          name: "Reeuwijk",
          state_id: "2599",
        },
        {
          id: "30421",
          name: "Ridderkerk",
          state_id: "2599",
        },
        {
          id: "30422",
          name: "Rijnsburg",
          state_id: "2599",
        },
        {
          id: "30423",
          name: "Rijnwoude",
          state_id: "2599",
        },
        {
          id: "30424",
          name: "Rijswijk",
          state_id: "2599",
        },
        {
          id: "30425",
          name: "Rotterdam",
          state_id: "2599",
        },
        {
          id: "30426",
          name: "Sassenheim",
          state_id: "2599",
        },
        {
          id: "30427",
          name: "Schiedam",
          state_id: "2599",
        },
        {
          id: "30428",
          name: "Schipluiden",
          state_id: "2599",
        },
        {
          id: "30429",
          name: "Schoonhoven",
          state_id: "2599",
        },
        {
          id: "30430",
          name: "Sliedrecht",
          state_id: "2599",
        },
        {
          id: "30431",
          name: "Spijkenisse",
          state_id: "2599",
        },
        {
          id: "30432",
          name: "Strijen",
          state_id: "2599",
        },
        {
          id: "30433",
          name: "Ter Aar",
          state_id: "2599",
        },
        {
          id: "30434",
          name: "The Hague",
          state_id: "2599",
        },
        {
          id: "30435",
          name: "Valkenburg",
          state_id: "2599",
        },
        {
          id: "30436",
          name: "Vierpolders",
          state_id: "2599",
        },
        {
          id: "30437",
          name: "Vlaardingen",
          state_id: "2599",
        },
        {
          id: "30438",
          name: "Vlist",
          state_id: "2599",
        },
        {
          id: "30439",
          name: "Voorhout",
          state_id: "2599",
        },
        {
          id: "30440",
          name: "Voorschoten",
          state_id: "2599",
        },
        {
          id: "30441",
          name: "Waddinxveen",
          state_id: "2599",
        },
        {
          id: "30442",
          name: "Warmond",
          state_id: "2599",
        },
        {
          id: "30443",
          name: "Wassenaar",
          state_id: "2599",
        },
        {
          id: "30444",
          name: "Wateringen",
          state_id: "2599",
        },
        {
          id: "30445",
          name: "West Maas en Waal",
          state_id: "2599",
        },
        {
          id: "30446",
          name: "Westvoorne",
          state_id: "2599",
        },
        {
          id: "30447",
          name: "Zederik",
          state_id: "2599",
        },
        {
          id: "30448",
          name: "Zevenhuizen-Moerkapelle",
          state_id: "2599",
        },
        {
          id: "30449",
          name: "Zoetermeer",
          state_id: "2599",
        },
        {
          id: "30450",
          name: "Zoeterwoude",
          state_id: "2599",
        },
        {
          id: "30451",
          name: "Zwijndrecht",
          state_id: "2599",
        },
      ],
    },
  },
  NO: {
    name: "Norway",
    native: "Norge",
    phone: "47",
    continent: "EU",
    capital: "Oslo",
    currency: "NOK",
    languages: ["no", "nb", "nn"],
    emoji: "🇳🇴",
    emojiU: "U+1F1F3 U+1F1F4",
    states: {
      Akershus: [
        {
          id: "31168",
          name: "Asker",
          state_id: "2690",
        },
        {
          id: "31169",
          name: "Billingstad",
          state_id: "2690",
        },
        {
          id: "31170",
          name: "Haslum",
          state_id: "2690",
        },
        {
          id: "31171",
          name: "Hosle",
          state_id: "2690",
        },
        {
          id: "31172",
          name: "Kjeller",
          state_id: "2690",
        },
        {
          id: "31173",
          name: "Lillestrom",
          state_id: "2690",
        },
        {
          id: "31174",
          name: "Lorenskog",
          state_id: "2690",
        },
        {
          id: "31175",
          name: "Lysaker",
          state_id: "2690",
        },
        {
          id: "31176",
          name: "LÃƒÂ¸renskog",
          state_id: "2690",
        },
        {
          id: "31177",
          name: "Rud",
          state_id: "2690",
        },
        {
          id: "31178",
          name: "Sandvika",
          state_id: "2690",
        },
        {
          id: "31179",
          name: "Strommen",
          state_id: "2690",
        },
      ],
      "Aust Agder": [],
      Bergen: [
        {
          id: "31180",
          name: "Kokstad",
          state_id: "2692",
        },
      ],
      Buskerud: [
        {
          id: "31181",
          name: "Drammen",
          state_id: "2693",
        },
        {
          id: "31182",
          name: "Hokksund",
          state_id: "2693",
        },
        {
          id: "31183",
          name: "Honefoss",
          state_id: "2693",
        },
        {
          id: "31184",
          name: "Kongsberg",
          state_id: "2693",
        },
        {
          id: "31185",
          name: "Lyngdal",
          state_id: "2693",
        },
        {
          id: "31186",
          name: "NÃƒÂ¦rsnes",
          state_id: "2693",
        },
        {
          id: "31187",
          name: "Vestby",
          state_id: "2693",
        },
      ],
      Finnmark: [
        {
          id: "31188",
          name: "Baatsfjord",
          state_id: "2694",
        },
        {
          id: "31189",
          name: "Hammerfest",
          state_id: "2694",
        },
      ],
      Hedmark: [
        {
          id: "31190",
          name: "Brumunddal",
          state_id: "2695",
        },
        {
          id: "31191",
          name: "Elverum",
          state_id: "2695",
        },
        {
          id: "31192",
          name: "Hamar",
          state_id: "2695",
        },
        {
          id: "31193",
          name: "Ilseng",
          state_id: "2695",
        },
        {
          id: "31194",
          name: "Rena",
          state_id: "2695",
        },
        {
          id: "31195",
          name: "Trysil",
          state_id: "2695",
        },
      ],
      Hordaland: [
        {
          id: "31196",
          name: "Bergen",
          state_id: "2696",
        },
        {
          id: "31197",
          name: "HÃƒÂ¸ylandsbygd",
          state_id: "2696",
        },
        {
          id: "31198",
          name: "Lonevag",
          state_id: "2696",
        },
        {
          id: "31199",
          name: "Straume",
          state_id: "2696",
        },
        {
          id: "31200",
          name: "Tysnes",
          state_id: "2696",
        },
        {
          id: "31201",
          name: "Voss",
          state_id: "2696",
        },
      ],
      "Moere og Romsdal": [],
      "Nord Trondelag": [],
      Nordland: [
        {
          id: "31202",
          name: "Bodo",
          state_id: "2699",
        },
        {
          id: "31203",
          name: "Mosjoen",
          state_id: "2699",
        },
        {
          id: "31204",
          name: "Narvik",
          state_id: "2699",
        },
        {
          id: "31205",
          name: "Nesna",
          state_id: "2699",
        },
        {
          id: "31206",
          name: "Saltdal",
          state_id: "2699",
        },
        {
          id: "31207",
          name: "Sortland",
          state_id: "2699",
        },
        {
          id: "31208",
          name: "Steigen",
          state_id: "2699",
        },
      ],
      Oestfold: [
        {
          id: "31209",
          name: "Askim",
          state_id: "2700",
        },
        {
          id: "31210",
          name: "Fredrikstad",
          state_id: "2700",
        },
        {
          id: "31211",
          name: "Halden",
          state_id: "2700",
        },
        {
          id: "31212",
          name: "Hovik",
          state_id: "2700",
        },
        {
          id: "31213",
          name: "Moss",
          state_id: "2700",
        },
        {
          id: "31214",
          name: "Mysen",
          state_id: "2700",
        },
        {
          id: "31215",
          name: "Sarpsborg",
          state_id: "2700",
        },
        {
          id: "31216",
          name: "Tistedal",
          state_id: "2700",
        },
      ],
      Oppland: [
        {
          id: "31217",
          name: "Lena",
          state_id: "2701",
        },
        {
          id: "31218",
          name: "Lillehammer",
          state_id: "2701",
        },
      ],
      Oslo: [
        {
          id: "31219",
          name: "Oslo",
          state_id: "2702",
        },
        {
          id: "31220",
          name: "Skedsmo",
          state_id: "2702",
        },
        {
          id: "31221",
          name: "Skjetten",
          state_id: "2702",
        },
      ],
      Rogaland: [
        {
          id: "31222",
          name: "Egersund",
          state_id: "2703",
        },
        {
          id: "31223",
          name: "Haugesund",
          state_id: "2703",
        },
        {
          id: "31224",
          name: "Kleppe",
          state_id: "2703",
        },
        {
          id: "31225",
          name: "Sandnes",
          state_id: "2703",
        },
        {
          id: "31226",
          name: "Sola",
          state_id: "2703",
        },
        {
          id: "31227",
          name: "Stavanger",
          state_id: "2703",
        },
      ],
      "Soer Troendelag": [],
      "Sogn og Fjordane": [],
      Stavern: [
        {
          id: "31228",
          name: "Stavern",
          state_id: "2706",
        },
      ],
      Sykkylven: [
        {
          id: "31229",
          name: "Sykkylven",
          state_id: "2707",
        },
      ],
      Telemark: [
        {
          id: "31230",
          name: "Notodden",
          state_id: "2708",
        },
        {
          id: "31231",
          name: "Skien",
          state_id: "2708",
        },
      ],
      Troms: [
        {
          id: "31232",
          name: "Harstad",
          state_id: "2709",
        },
        {
          id: "31233",
          name: "Troms",
          state_id: "2709",
        },
        {
          id: "31234",
          name: "TromsÃƒÂ¸",
          state_id: "2709",
        },
      ],
      "Vest Agder": [],
      Vestfold: [
        {
          id: "31235",
          name: "Horten",
          state_id: "2711",
        },
        {
          id: "31236",
          name: "HusÃƒÂ¸ysund",
          state_id: "2711",
        },
        {
          id: "31237",
          name: "Larvik",
          state_id: "2711",
        },
        {
          id: "31238",
          name: "Rygge",
          state_id: "2711",
        },
        {
          id: "31239",
          name: "Sandefjord",
          state_id: "2711",
        },
        {
          id: "31240",
          name: "TÃƒÂ¸nsberg",
          state_id: "2711",
        },
      ],
      "ÃƒÂ˜stfold": [],
    },
  },
  NP: {
    name: "Nepal",
    native: "नपल",
    phone: "977",
    continent: "AS",
    capital: "Kathmandu",
    currency: "NPR",
    languages: ["ne"],
    emoji: "🇳🇵",
    emojiU: "U+1F1F3 U+1F1F5",
    states: {
      Bagmati: [
        {
          id: "29785",
          name: "Banepa",
          state_id: "2566",
        },
        {
          id: "29786",
          name: "Bhaktapur",
          state_id: "2566",
        },
        {
          id: "29787",
          name: "Bidur",
          state_id: "2566",
        },
        {
          id: "29788",
          name: "Bishalter",
          state_id: "2566",
        },
        {
          id: "29789",
          name: "Dhulikhel",
          state_id: "2566",
        },
        {
          id: "29790",
          name: "Kathmandu",
          state_id: "2566",
        },
        {
          id: "29791",
          name: "Kirtipur",
          state_id: "2566",
        },
        {
          id: "29792",
          name: "Lalitpur",
          state_id: "2566",
        },
        {
          id: "29793",
          name: "Madhyapur Thimi",
          state_id: "2566",
        },
        {
          id: "29794",
          name: "Panauti",
          state_id: "2566",
        },
        {
          id: "29795",
          name: "Tribuvannagar",
          state_id: "2566",
        },
      ],
      Bheri: [
        {
          id: "29796",
          name: "Birendranagar",
          state_id: "2567",
        },
        {
          id: "29797",
          name: "Gulariya",
          state_id: "2567",
        },
        {
          id: "29798",
          name: "Narayan",
          state_id: "2567",
        },
        {
          id: "29799",
          name: "Nepalganj",
          state_id: "2567",
        },
        {
          id: "29800",
          name: "Surkhet",
          state_id: "2567",
        },
      ],
      Dhawalagiri: [
        {
          id: "29801",
          name: "Baglung",
          state_id: "2568",
        },
        {
          id: "29802",
          name: "Weni",
          state_id: "2568",
        },
      ],
      Gandaki: [
        {
          id: "29803",
          name: "Byas",
          state_id: "2569",
        },
        {
          id: "29804",
          name: "Leknath",
          state_id: "2569",
        },
        {
          id: "29805",
          name: "Pokhara",
          state_id: "2569",
        },
        {
          id: "29806",
          name: "Prithivinarayan",
          state_id: "2569",
        },
        {
          id: "29807",
          name: "Putalibazar",
          state_id: "2569",
        },
        {
          id: "29808",
          name: "Waling",
          state_id: "2569",
        },
      ],
      Janakpur: [
        {
          id: "29809",
          name: "Bhimeshwar",
          state_id: "2570",
        },
        {
          id: "29810",
          name: "Jaleshwar",
          state_id: "2570",
        },
        {
          id: "29811",
          name: "Janakpur",
          state_id: "2570",
        },
        {
          id: "29812",
          name: "Kamalamai",
          state_id: "2570",
        },
        {
          id: "29813",
          name: "Malangwa",
          state_id: "2570",
        },
        {
          id: "29814",
          name: "Sinduli Marhi",
          state_id: "2570",
        },
      ],
      Karnali: [
        {
          id: "29815",
          name: "Jumla",
          state_id: "2571",
        },
      ],
      Koshi: [
        {
          id: "29816",
          name: "Biratnagar",
          state_id: "2572",
        },
        {
          id: "29817",
          name: "Dhankuta",
          state_id: "2572",
        },
        {
          id: "29818",
          name: "Dharan",
          state_id: "2572",
        },
        {
          id: "29819",
          name: "Inaruwa",
          state_id: "2572",
        },
        {
          id: "29820",
          name: "Itahari",
          state_id: "2572",
        },
        {
          id: "29821",
          name: "Khandbari",
          state_id: "2572",
        },
      ],
      Lumbini: [
        {
          id: "29822",
          name: "Butwal",
          state_id: "2573",
        },
        {
          id: "29823",
          name: "Kapilwastu",
          state_id: "2573",
        },
        {
          id: "29824",
          name: "Ramgram",
          state_id: "2573",
        },
        {
          id: "29825",
          name: "Sidharthanagar",
          state_id: "2573",
        },
        {
          id: "29826",
          name: "Tansen",
          state_id: "2573",
        },
        {
          id: "29827",
          name: "Wahadurganj",
          state_id: "2573",
        },
      ],
      Mahakali: [
        {
          id: "29828",
          name: "Amargadhi",
          state_id: "2574",
        },
        {
          id: "29829",
          name: "Dashrathchand",
          state_id: "2574",
        },
        {
          id: "29830",
          name: "Mahendranagar",
          state_id: "2574",
        },
      ],
      Mechi: [
        {
          id: "29831",
          name: "Bhadrapur",
          state_id: "2575",
        },
        {
          id: "29832",
          name: "Damak",
          state_id: "2575",
        },
        {
          id: "29833",
          name: "Ilam",
          state_id: "2575",
        },
        {
          id: "29834",
          name: "Mechinagar",
          state_id: "2575",
        },
      ],
      Narayani: [
        {
          id: "29835",
          name: "Bharatpur",
          state_id: "2576",
        },
        {
          id: "29836",
          name: "Birganj",
          state_id: "2576",
        },
        {
          id: "29837",
          name: "Chitwan",
          state_id: "2576",
        },
        {
          id: "29838",
          name: "Gaur",
          state_id: "2576",
        },
        {
          id: "29839",
          name: "Hetauda",
          state_id: "2576",
        },
        {
          id: "29840",
          name: "Kalaiya",
          state_id: "2576",
        },
        {
          id: "29841",
          name: "Ratnanagar",
          state_id: "2576",
        },
      ],
      Rapti: [
        {
          id: "29842",
          name: "Salyan",
          state_id: "2577",
        },
        {
          id: "29843",
          name: "Tulsipur",
          state_id: "2577",
        },
      ],
      Sagarmatha: [
        {
          id: "29844",
          name: "Lahan",
          state_id: "2578",
        },
        {
          id: "29845",
          name: "Rajbiraj",
          state_id: "2578",
        },
        {
          id: "29846",
          name: "Siraha",
          state_id: "2578",
        },
        {
          id: "29847",
          name: "Triyuga",
          state_id: "2578",
        },
      ],
      Seti: [
        {
          id: "29848",
          name: "Dhangadi",
          state_id: "2579",
        },
        {
          id: "29849",
          name: "Dipayal",
          state_id: "2579",
        },
        {
          id: "29850",
          name: "Tikapur",
          state_id: "2579",
        },
      ],
    },
  },
  NR: {
    name: "Nauru",
    native: "Nauru",
    phone: "674",
    continent: "OC",
    capital: "Yaren",
    currency: "AUD",
    languages: ["en", "na"],
    emoji: "🇳🇷",
    emojiU: "U+1F1F3 U+1F1F7",
    states: {
      Yaren: [
        {
          id: "29784",
          name: "Yaren",
          state_id: "2565",
        },
      ],
    },
  },
  NU: {
    name: "Niue",
    native: "Niuē",
    phone: "683",
    continent: "OC",
    capital: "Alofi",
    currency: "NZD",
    languages: ["en"],
    emoji: "🇳🇺",
    emojiU: "U+1F1F3 U+1F1FA",
    states: {
      Niue: [
        {
          id: "31152",
          name: "Niue",
          state_id: "2684",
        },
      ],
    },
  },
  NZ: {
    name: "New Zealand",
    native: "New Zealand",
    phone: "64",
    continent: "OC",
    capital: "Wellington",
    currency: "NZD",
    languages: ["en", "mi"],
    emoji: "🇳🇿",
    emojiU: "U+1F1F3 U+1F1FF",
    states: {
      Auckland: [
        {
          id: "30484",
          name: "Auckland",
          state_id: "2604",
        },
        {
          id: "30485",
          name: "Helensville",
          state_id: "2604",
        },
        {
          id: "30486",
          name: "Henderson",
          state_id: "2604",
        },
        {
          id: "30487",
          name: "Hillsborough",
          state_id: "2604",
        },
        {
          id: "30488",
          name: "Lynfield",
          state_id: "2604",
        },
        {
          id: "30489",
          name: "Manukau",
          state_id: "2604",
        },
        {
          id: "30490",
          name: "Manurewa",
          state_id: "2604",
        },
        {
          id: "30491",
          name: "Mt. Roskill",
          state_id: "2604",
        },
        {
          id: "30492",
          name: "North Shore",
          state_id: "2604",
        },
        {
          id: "30493",
          name: "Onehunga",
          state_id: "2604",
        },
        {
          id: "30494",
          name: "Orewa",
          state_id: "2604",
        },
        {
          id: "30495",
          name: "Otahuhu",
          state_id: "2604",
        },
        {
          id: "30496",
          name: "Panmure",
          state_id: "2604",
        },
        {
          id: "30497",
          name: "Papakura",
          state_id: "2604",
        },
        {
          id: "30498",
          name: "Papatoetoe",
          state_id: "2604",
        },
        {
          id: "30499",
          name: "Ponsonby",
          state_id: "2604",
        },
        {
          id: "30500",
          name: "Royal Oak",
          state_id: "2604",
        },
        {
          id: "30501",
          name: "Sandringham",
          state_id: "2604",
        },
        {
          id: "30502",
          name: "Snells Beach",
          state_id: "2604",
        },
        {
          id: "30503",
          name: "Takanini",
          state_id: "2604",
        },
        {
          id: "30504",
          name: "Waiheke",
          state_id: "2604",
        },
        {
          id: "30505",
          name: "Waitakere",
          state_id: "2604",
        },
      ],
      "Area Outside Region": [],
      "Bay of Plenty": [],
      Canterbury: [
        {
          id: "30506",
          name: "Amberley",
          state_id: "2606",
        },
        {
          id: "30507",
          name: "Ashburton",
          state_id: "2606",
        },
        {
          id: "30508",
          name: "Christchurch",
          state_id: "2606",
        },
        {
          id: "30509",
          name: "Fairlie",
          state_id: "2606",
        },
        {
          id: "30510",
          name: "Geraldine",
          state_id: "2606",
        },
        {
          id: "30511",
          name: "Kaikoura",
          state_id: "2606",
        },
        {
          id: "30512",
          name: "Leeston",
          state_id: "2606",
        },
        {
          id: "30513",
          name: "Lyttelton",
          state_id: "2606",
        },
        {
          id: "30514",
          name: "Oamaru",
          state_id: "2606",
        },
        {
          id: "30515",
          name: "Rangiora",
          state_id: "2606",
        },
        {
          id: "30516",
          name: "Temuka",
          state_id: "2606",
        },
        {
          id: "30517",
          name: "Timaru",
          state_id: "2606",
        },
        {
          id: "30518",
          name: "Waimate",
          state_id: "2606",
        },
      ],
      Christchurch: [],
      Gisborne: [
        {
          id: "30519",
          name: "Gisborne",
          state_id: "2608",
        },
      ],
      "Hawke''s Bay": [],
      "Manawatu-Wanganui": [
        {
          id: "30520",
          name: "Dannevirke",
          state_id: "2610",
        },
        {
          id: "30521",
          name: "Feilding",
          state_id: "2610",
        },
        {
          id: "30522",
          name: "Foxton",
          state_id: "2610",
        },
        {
          id: "30523",
          name: "Levin",
          state_id: "2610",
        },
        {
          id: "30524",
          name: "Marton",
          state_id: "2610",
        },
        {
          id: "30525",
          name: "Palmerston North",
          state_id: "2610",
        },
        {
          id: "30526",
          name: "Picton",
          state_id: "2610",
        },
        {
          id: "30527",
          name: "Taumarunui",
          state_id: "2610",
        },
        {
          id: "30528",
          name: "Wanganui",
          state_id: "2610",
        },
      ],
      Marlborough: [
        {
          id: "30529",
          name: "Blenheim",
          state_id: "2611",
        },
        {
          id: "30530",
          name: "Havelock",
          state_id: "2611",
        },
      ],
      Nelson: [
        {
          id: "30531",
          name: "Nelson",
          state_id: "2612",
        },
      ],
      Northland: [
        {
          id: "30532",
          name: "Dargaville",
          state_id: "2613",
        },
        {
          id: "30533",
          name: "Kaikohe",
          state_id: "2613",
        },
        {
          id: "30534",
          name: "Kaitaia",
          state_id: "2613",
        },
        {
          id: "30535",
          name: "Kerikeri",
          state_id: "2613",
        },
        {
          id: "30536",
          name: "Maungatapere",
          state_id: "2613",
        },
        {
          id: "30537",
          name: "Whangarei",
          state_id: "2613",
        },
      ],
      Otago: [
        {
          id: "30538",
          name: "Alexandra",
          state_id: "2614",
        },
        {
          id: "30539",
          name: "Balclutha",
          state_id: "2614",
        },
        {
          id: "30540",
          name: "Dunedin",
          state_id: "2614",
        },
        {
          id: "30541",
          name: "Queenstown",
          state_id: "2614",
        },
        {
          id: "30542",
          name: "Wanaka",
          state_id: "2614",
        },
      ],
      Rodney: [
        {
          id: "30543",
          name: "Warkworth",
          state_id: "2615",
        },
      ],
      Southland: [
        {
          id: "30544",
          name: "Gore",
          state_id: "2616",
        },
        {
          id: "30545",
          name: "Invercargill",
          state_id: "2616",
        },
      ],
      Taranaki: [
        {
          id: "30546",
          name: "Eltham",
          state_id: "2617",
        },
        {
          id: "30547",
          name: "Hawera",
          state_id: "2617",
        },
        {
          id: "30548",
          name: "Inglewood",
          state_id: "2617",
        },
        {
          id: "30549",
          name: "New Plymouth",
          state_id: "2617",
        },
        {
          id: "30550",
          name: "Oakura",
          state_id: "2617",
        },
        {
          id: "30551",
          name: "Stratford",
          state_id: "2617",
        },
        {
          id: "30552",
          name: "Waitara",
          state_id: "2617",
        },
      ],
      Tasman: [
        {
          id: "30553",
          name: "Motueka",
          state_id: "2618",
        },
        {
          id: "30554",
          name: "Richmond",
          state_id: "2618",
        },
      ],
      Waikato: [
        {
          id: "30555",
          name: "Cambridge",
          state_id: "2619",
        },
        {
          id: "30556",
          name: "Coromandel",
          state_id: "2619",
        },
        {
          id: "30557",
          name: "Hamilton",
          state_id: "2619",
        },
        {
          id: "30558",
          name: "Hillcrest",
          state_id: "2619",
        },
        {
          id: "30559",
          name: "Huntly",
          state_id: "2619",
        },
        {
          id: "30560",
          name: "Matamata",
          state_id: "2619",
        },
        {
          id: "30561",
          name: "Morrinsville",
          state_id: "2619",
        },
        {
          id: "30562",
          name: "Ngaruawahia",
          state_id: "2619",
        },
        {
          id: "30563",
          name: "Otorohanga",
          state_id: "2619",
        },
        {
          id: "30564",
          name: "Paeroa",
          state_id: "2619",
        },
        {
          id: "30565",
          name: "Pukekohe",
          state_id: "2619",
        },
        {
          id: "30566",
          name: "Putaruru",
          state_id: "2619",
        },
        {
          id: "30567",
          name: "Taupo",
          state_id: "2619",
        },
        {
          id: "30568",
          name: "Te Aroha",
          state_id: "2619",
        },
        {
          id: "30569",
          name: "Te Awamutu",
          state_id: "2619",
        },
        {
          id: "30570",
          name: "Te Kuiti",
          state_id: "2619",
        },
        {
          id: "30571",
          name: "Thames",
          state_id: "2619",
        },
        {
          id: "30572",
          name: "Tokoroa",
          state_id: "2619",
        },
        {
          id: "30573",
          name: "Turangi",
          state_id: "2619",
        },
        {
          id: "30574",
          name: "Waiuku",
          state_id: "2619",
        },
        {
          id: "30575",
          name: "Whangamata",
          state_id: "2619",
        },
        {
          id: "30576",
          name: "Whitianga",
          state_id: "2619",
        },
      ],
      Wellington: [
        {
          id: "30577",
          name: "Carterton",
          state_id: "2620",
        },
        {
          id: "30578",
          name: "Kapiti",
          state_id: "2620",
        },
        {
          id: "30579",
          name: "Lower Hutt",
          state_id: "2620",
        },
        {
          id: "30580",
          name: "Martinborough",
          state_id: "2620",
        },
        {
          id: "30581",
          name: "Masterton",
          state_id: "2620",
        },
        {
          id: "30582",
          name: "Otaki",
          state_id: "2620",
        },
        {
          id: "30583",
          name: "Paraparaumu",
          state_id: "2620",
        },
        {
          id: "30584",
          name: "Porirua",
          state_id: "2620",
        },
        {
          id: "30585",
          name: "Upper Hutt",
          state_id: "2620",
        },
        {
          id: "30586",
          name: "Wairarapa",
          state_id: "2620",
        },
        {
          id: "30587",
          name: "Wellington",
          state_id: "2620",
        },
      ],
      "West Coast": [],
    },
  },
  OM: {
    name: "Oman",
    native: "عمان",
    phone: "968",
    continent: "AS",
    capital: "Muscat",
    currency: "OMR",
    languages: ["ar"],
    emoji: "🇴🇲",
    emojiU: "U+1F1F4 U+1F1F2",
    states: {
      "Al Buraimi": [],
      Dhufar: [
        {
          id: "31241",
          name: "Salalah",
          state_id: "2714",
        },
      ],
      Masqat: [
        {
          id: "31242",
          name: "Azaiba",
          state_id: "2715",
        },
        {
          id: "31243",
          name: "Bawshar",
          state_id: "2715",
        },
        {
          id: "31244",
          name: "Madinat Qabus",
          state_id: "2715",
        },
        {
          id: "31245",
          name: "Masqat",
          state_id: "2715",
        },
        {
          id: "31246",
          name: "Matrah",
          state_id: "2715",
        },
        {
          id: "31247",
          name: "Muscat",
          state_id: "2715",
        },
        {
          id: "31248",
          name: "Muttrah",
          state_id: "2715",
        },
        {
          id: "31249",
          name: "Qurayyat",
          state_id: "2715",
        },
        {
          id: "31250",
          name: "Qurm",
          state_id: "2715",
        },
        {
          id: "31251",
          name: "Ruwi",
          state_id: "2715",
        },
        {
          id: "31252",
          name: "Wadi Al Kabir",
          state_id: "2715",
        },
        {
          id: "31253",
          name: "as-Sib",
          state_id: "2715",
        },
      ],
      Musandam: [
        {
          id: "31254",
          name: "Khasab",
          state_id: "2716",
        },
      ],
      Rusayl: [
        {
          id: "31255",
          name: "Rusayl",
          state_id: "2717",
        },
      ],
      "Wadi Kabir": [],
      "ad-Dakhiliyah": [
        {
          id: "31256",
          name: "Bahla",
          state_id: "2719",
        },
        {
          id: "31257",
          name: "Nizwa",
          state_id: "2719",
        },
        {
          id: "31258",
          name: "Sumayl",
          state_id: "2719",
        },
      ],
      "adh-Dhahirah": [
        {
          id: "31259",
          name: "Ibri",
          state_id: "2720",
        },
        {
          id: "31260",
          name: "al-Buraymi",
          state_id: "2720",
        },
      ],
      "al-Batinah": [
        {
          id: "31261",
          name: "Al khuwair",
          state_id: "2721",
        },
        {
          id: "31262",
          name: "Barkah",
          state_id: "2721",
        },
        {
          id: "31263",
          name: "Saham",
          state_id: "2721",
        },
        {
          id: "31264",
          name: "Shinas",
          state_id: "2721",
        },
        {
          id: "31265",
          name: "Suhar",
          state_id: "2721",
        },
        {
          id: "31266",
          name: "al-Khaburah",
          state_id: "2721",
        },
        {
          id: "31267",
          name: "al-Masna''ah",
          state_id: "2721",
        },
        {
          id: "31268",
          name: "ar-Rustaq",
          state_id: "2721",
        },
        {
          id: "31269",
          name: "as-Suwayq",
          state_id: "2721",
        },
      ],
      "ash-Sharqiyah": [
        {
          id: "31270",
          name: "Ibra",
          state_id: "2722",
        },
        {
          id: "31271",
          name: "Sur",
          state_id: "2722",
        },
        {
          id: "31272",
          name: "al-Mudaybi",
          state_id: "2722",
        },
      ],
    },
  },
  PA: {
    name: "Panama",
    native: "Panamá",
    phone: "507",
    continent: "NA",
    capital: "Panama City",
    currency: "PAB,USD",
    languages: ["es"],
    emoji: "🇵🇦",
    emojiU: "U+1F1F5 U+1F1E6",
    states: {
      "Bocas del Toro": [],
      Chiriqui: [
        {
          id: "31732",
          name: "Alanje",
          state_id: "2764",
        },
        {
          id: "31733",
          name: "Bajo Boquete",
          state_id: "2764",
        },
        {
          id: "31734",
          name: "Boqueron",
          state_id: "2764",
        },
        {
          id: "31735",
          name: "Bugaba",
          state_id: "2764",
        },
        {
          id: "31736",
          name: "David",
          state_id: "2764",
        },
        {
          id: "31737",
          name: "Dolega",
          state_id: "2764",
        },
        {
          id: "31738",
          name: "Gualaca",
          state_id: "2764",
        },
        {
          id: "31739",
          name: "Horconcitos",
          state_id: "2764",
        },
        {
          id: "31740",
          name: "Las Lajas",
          state_id: "2764",
        },
        {
          id: "31741",
          name: "Puerto Armuelles",
          state_id: "2764",
        },
        {
          id: "31742",
          name: "Remedios",
          state_id: "2764",
        },
        {
          id: "31743",
          name: "Rio Sereno",
          state_id: "2764",
        },
        {
          id: "31744",
          name: "Tole",
          state_id: "2764",
        },
      ],
      Cocle: [
        {
          id: "31745",
          name: "Aguadulce",
          state_id: "2765",
        },
        {
          id: "31746",
          name: "Anton",
          state_id: "2765",
        },
        {
          id: "31747",
          name: "La Pintada",
          state_id: "2765",
        },
        {
          id: "31748",
          name: "Nata",
          state_id: "2765",
        },
        {
          id: "31749",
          name: "Ola",
          state_id: "2765",
        },
        {
          id: "31750",
          name: "Penonome",
          state_id: "2765",
        },
      ],
      Colon: [
        {
          id: "31751",
          name: "Colon",
          state_id: "2766",
        },
        {
          id: "31752",
          name: "Miguel de la Borda",
          state_id: "2766",
        },
        {
          id: "31753",
          name: "Nuevo Chagres",
          state_id: "2766",
        },
        {
          id: "31754",
          name: "Portobelo",
          state_id: "2766",
        },
        {
          id: "31755",
          name: "Santa Isabel",
          state_id: "2766",
        },
      ],
      Darien: [
        {
          id: "31756",
          name: "El Real de Santa Maria",
          state_id: "2767",
        },
        {
          id: "31757",
          name: "La Palma",
          state_id: "2767",
        },
      ],
      Embera: [
        {
          id: "31758",
          name: "Cirilo Guainora",
          state_id: "2768",
        },
        {
          id: "31759",
          name: "Rio Sabalo",
          state_id: "2768",
        },
      ],
      Herrera: [
        {
          id: "31760",
          name: "Chitre",
          state_id: "2769",
        },
        {
          id: "31761",
          name: "Las Minas",
          state_id: "2769",
        },
        {
          id: "31762",
          name: "Los Pozos",
          state_id: "2769",
        },
        {
          id: "31763",
          name: "Ocu",
          state_id: "2769",
        },
        {
          id: "31764",
          name: "Parita",
          state_id: "2769",
        },
        {
          id: "31765",
          name: "Pese",
          state_id: "2769",
        },
        {
          id: "31766",
          name: "Santa Maria",
          state_id: "2769",
        },
      ],
      "Kuna Yala": [],
      "Los Santos": [],
      "Ngobe Bugle": [],
      Panama: [
        {
          id: "31767",
          name: "Arraijan",
          state_id: "2773",
        },
        {
          id: "31768",
          name: "Capira",
          state_id: "2773",
        },
        {
          id: "31769",
          name: "Chame",
          state_id: "2773",
        },
        {
          id: "31770",
          name: "Chepo",
          state_id: "2773",
        },
        {
          id: "31771",
          name: "Chiman",
          state_id: "2773",
        },
        {
          id: "31772",
          name: "La Chorrera",
          state_id: "2773",
        },
        {
          id: "31773",
          name: "Panama",
          state_id: "2773",
        },
        {
          id: "31774",
          name: "San Carlos",
          state_id: "2773",
        },
        {
          id: "31775",
          name: "San Miguel",
          state_id: "2773",
        },
        {
          id: "31776",
          name: "San Miguelito",
          state_id: "2773",
        },
        {
          id: "31777",
          name: "Taboga",
          state_id: "2773",
        },
      ],
      Veraguas: [
        {
          id: "31778",
          name: "Atalaya",
          state_id: "2774",
        },
        {
          id: "31779",
          name: "Calobre",
          state_id: "2774",
        },
        {
          id: "31780",
          name: "Canazas",
          state_id: "2774",
        },
        {
          id: "31781",
          name: "La Mesa",
          state_id: "2774",
        },
        {
          id: "31782",
          name: "Las Palmas",
          state_id: "2774",
        },
        {
          id: "31783",
          name: "Montijo",
          state_id: "2774",
        },
        {
          id: "31784",
          name: "Rio de Jesus",
          state_id: "2774",
        },
        {
          id: "31785",
          name: "San Francisco",
          state_id: "2774",
        },
        {
          id: "31786",
          name: "Santa Fe",
          state_id: "2774",
        },
        {
          id: "31787",
          name: "Santiago",
          state_id: "2774",
        },
        {
          id: "31788",
          name: "Sona",
          state_id: "2774",
        },
      ],
    },
  },
  PE: {
    name: "Peru",
    native: "Perú",
    phone: "51",
    continent: "SA",
    capital: "Lima",
    currency: "PEN",
    languages: ["es"],
    emoji: "🇵🇪",
    emojiU: "U+1F1F5 U+1F1EA",
    states: {
      Amazonas: [
        {
          id: "31986",
          name: "Bagua Grande",
          state_id: "2812",
        },
        {
          id: "31987",
          name: "Cajaruro",
          state_id: "2812",
        },
        {
          id: "31988",
          name: "Chachapoyas",
          state_id: "2812",
        },
        {
          id: "31989",
          name: "Jazan",
          state_id: "2812",
        },
        {
          id: "31990",
          name: "La Peca",
          state_id: "2812",
        },
      ],
      Ancash: [
        {
          id: "31991",
          name: "Ancash",
          state_id: "2813",
        },
        {
          id: "31992",
          name: "Caraz",
          state_id: "2813",
        },
        {
          id: "31993",
          name: "Carhuaz",
          state_id: "2813",
        },
        {
          id: "31994",
          name: "Casma",
          state_id: "2813",
        },
        {
          id: "31995",
          name: "Chimbote",
          state_id: "2813",
        },
        {
          id: "31996",
          name: "Choishco",
          state_id: "2813",
        },
        {
          id: "31997",
          name: "Huallanca",
          state_id: "2813",
        },
        {
          id: "31998",
          name: "Huaraz",
          state_id: "2813",
        },
        {
          id: "31999",
          name: "Huari",
          state_id: "2813",
        },
        {
          id: "32000",
          name: "Huarmey",
          state_id: "2813",
        },
        {
          id: "32001",
          name: "Pomabamba",
          state_id: "2813",
        },
        {
          id: "32002",
          name: "Santa",
          state_id: "2813",
        },
        {
          id: "32003",
          name: "Yungay",
          state_id: "2813",
        },
      ],
      Apurimac: [
        {
          id: "32004",
          name: "Abancay",
          state_id: "2814",
        },
        {
          id: "32005",
          name: "Andahuaylas",
          state_id: "2814",
        },
        {
          id: "32006",
          name: "San Jeronimo",
          state_id: "2814",
        },
        {
          id: "32007",
          name: "Talavera",
          state_id: "2814",
        },
      ],
      Arequipa: [
        {
          id: "32008",
          name: "Acari",
          state_id: "2815",
        },
        {
          id: "32009",
          name: "Arequipa",
          state_id: "2815",
        },
        {
          id: "32010",
          name: "Camana",
          state_id: "2815",
        },
        {
          id: "32011",
          name: "Chivay",
          state_id: "2815",
        },
        {
          id: "32012",
          name: "Cocachacra",
          state_id: "2815",
        },
        {
          id: "32013",
          name: "Dean Valdivia",
          state_id: "2815",
        },
        {
          id: "32014",
          name: "Lluta",
          state_id: "2815",
        },
        {
          id: "32015",
          name: "Mollendo",
          state_id: "2815",
        },
        {
          id: "32016",
          name: "Nicolas de Pierola",
          state_id: "2815",
        },
        {
          id: "32017",
          name: "Orcopampa",
          state_id: "2815",
        },
        {
          id: "32018",
          name: "Punta de Bombon",
          state_id: "2815",
        },
        {
          id: "32019",
          name: "Rio Grande",
          state_id: "2815",
        },
        {
          id: "32020",
          name: "Yura",
          state_id: "2815",
        },
      ],
      Ayacucho: [
        {
          id: "32021",
          name: "Ayacucho",
          state_id: "2816",
        },
        {
          id: "32022",
          name: "Ayna",
          state_id: "2816",
        },
        {
          id: "32023",
          name: "Coracora",
          state_id: "2816",
        },
        {
          id: "32024",
          name: "Huanta",
          state_id: "2816",
        },
        {
          id: "32025",
          name: "Puquio",
          state_id: "2816",
        },
        {
          id: "32026",
          name: "San Miguel",
          state_id: "2816",
        },
        {
          id: "32027",
          name: "Santa Rosa",
          state_id: "2816",
        },
        {
          id: "32028",
          name: "Silvia",
          state_id: "2816",
        },
        {
          id: "32029",
          name: "Tambo",
          state_id: "2816",
        },
      ],
      Cajamarca: [
        {
          id: "32030",
          name: "Bambamarca",
          state_id: "2817",
        },
        {
          id: "32031",
          name: "Bellavista",
          state_id: "2817",
        },
        {
          id: "32032",
          name: "Cajabamba",
          state_id: "2817",
        },
        {
          id: "32033",
          name: "Cajamarca",
          state_id: "2817",
        },
        {
          id: "32034",
          name: "Celendin",
          state_id: "2817",
        },
        {
          id: "32035",
          name: "Chota",
          state_id: "2817",
        },
        {
          id: "32036",
          name: "Cutervo",
          state_id: "2817",
        },
        {
          id: "32037",
          name: "Jaen",
          state_id: "2817",
        },
        {
          id: "32038",
          name: "Pedro Galvez",
          state_id: "2817",
        },
        {
          id: "32039",
          name: "Pucara",
          state_id: "2817",
        },
        {
          id: "32040",
          name: "San Ignacio",
          state_id: "2817",
        },
        {
          id: "32041",
          name: "Santa Cruz",
          state_id: "2817",
        },
        {
          id: "32042",
          name: "Yonan",
          state_id: "2817",
        },
      ],
      Cusco: [
        {
          id: "32043",
          name: "Anta",
          state_id: "2818",
        },
        {
          id: "32044",
          name: "Calca",
          state_id: "2818",
        },
        {
          id: "32045",
          name: "Cusco",
          state_id: "2818",
        },
        {
          id: "32046",
          name: "Espinar",
          state_id: "2818",
        },
        {
          id: "32047",
          name: "Oropesa",
          state_id: "2818",
        },
        {
          id: "32048",
          name: "Quillabamba",
          state_id: "2818",
        },
        {
          id: "32049",
          name: "Santa Ana",
          state_id: "2818",
        },
        {
          id: "32050",
          name: "Santo Tomas",
          state_id: "2818",
        },
        {
          id: "32051",
          name: "Sicuani",
          state_id: "2818",
        },
        {
          id: "32052",
          name: "Urcos",
          state_id: "2818",
        },
        {
          id: "32053",
          name: "Urubamba",
          state_id: "2818",
        },
      ],
      Huancavelica: [
        {
          id: "32054",
          name: "Huancavelica",
          state_id: "2819",
        },
        {
          id: "32055",
          name: "Lircay",
          state_id: "2819",
        },
        {
          id: "32056",
          name: "Pampas",
          state_id: "2819",
        },
      ],
      Huanuco: [
        {
          id: "32057",
          name: "Ambos",
          state_id: "2820",
        },
        {
          id: "32058",
          name: "Huanuco",
          state_id: "2820",
        },
        {
          id: "32059",
          name: "Jose Crespo y Castillo",
          state_id: "2820",
        },
        {
          id: "32060",
          name: "La Union",
          state_id: "2820",
        },
        {
          id: "32061",
          name: "Llata",
          state_id: "2820",
        },
        {
          id: "32062",
          name: "Rupa-Rupa",
          state_id: "2820",
        },
        {
          id: "32063",
          name: "San Miguel de Cauri",
          state_id: "2820",
        },
        {
          id: "32064",
          name: "Tingo Maria",
          state_id: "2820",
        },
      ],
      Ica: [
        {
          id: "32065",
          name: "Chincha Alta",
          state_id: "2821",
        },
        {
          id: "32066",
          name: "Ica",
          state_id: "2821",
        },
        {
          id: "32067",
          name: "Los Aquijes",
          state_id: "2821",
        },
        {
          id: "32068",
          name: "Marcona",
          state_id: "2821",
        },
        {
          id: "32069",
          name: "Nazca",
          state_id: "2821",
        },
        {
          id: "32070",
          name: "Pachacutec",
          state_id: "2821",
        },
        {
          id: "32071",
          name: "Palpa",
          state_id: "2821",
        },
        {
          id: "32072",
          name: "Pisco",
          state_id: "2821",
        },
        {
          id: "32073",
          name: "Salas",
          state_id: "2821",
        },
        {
          id: "32074",
          name: "San Andres",
          state_id: "2821",
        },
        {
          id: "32075",
          name: "San Clemente",
          state_id: "2821",
        },
        {
          id: "32076",
          name: "San Juan Bautista",
          state_id: "2821",
        },
        {
          id: "32077",
          name: "Santiago",
          state_id: "2821",
        },
        {
          id: "32078",
          name: "Subtanjalla",
          state_id: "2821",
        },
        {
          id: "32079",
          name: "Tupac Amaru Inca",
          state_id: "2821",
        },
        {
          id: "32080",
          name: "Vista Alegre",
          state_id: "2821",
        },
      ],
      Junin: [
        {
          id: "32081",
          name: "Acobamba",
          state_id: "2822",
        },
        {
          id: "32082",
          name: "Acolla",
          state_id: "2822",
        },
        {
          id: "32083",
          name: "Carhuamayo",
          state_id: "2822",
        },
        {
          id: "32084",
          name: "Chanchamayo",
          state_id: "2822",
        },
        {
          id: "32085",
          name: "Chupaca",
          state_id: "2822",
        },
        {
          id: "32086",
          name: "Concepcion",
          state_id: "2822",
        },
        {
          id: "32087",
          name: "Huancayo",
          state_id: "2822",
        },
        {
          id: "32088",
          name: "Huasahuasi",
          state_id: "2822",
        },
        {
          id: "32089",
          name: "Huayucachi",
          state_id: "2822",
        },
        {
          id: "32090",
          name: "Jauja",
          state_id: "2822",
        },
        {
          id: "32091",
          name: "Junin",
          state_id: "2822",
        },
        {
          id: "32092",
          name: "La Oroya",
          state_id: "2822",
        },
        {
          id: "32093",
          name: "Mazamari",
          state_id: "2822",
        },
        {
          id: "32094",
          name: "Morococha",
          state_id: "2822",
        },
        {
          id: "32095",
          name: "Orcotuna",
          state_id: "2822",
        },
        {
          id: "32096",
          name: "Pangoa",
          state_id: "2822",
        },
        {
          id: "32097",
          name: "Perene",
          state_id: "2822",
        },
        {
          id: "32098",
          name: "Pichanaqui",
          state_id: "2822",
        },
        {
          id: "32099",
          name: "Pilcomayo",
          state_id: "2822",
        },
        {
          id: "32100",
          name: "San Agustin",
          state_id: "2822",
        },
        {
          id: "32101",
          name: "San Jeronimo de Tunan",
          state_id: "2822",
        },
        {
          id: "32102",
          name: "San Pedro de Cajas",
          state_id: "2822",
        },
        {
          id: "32103",
          name: "San Ramon",
          state_id: "2822",
        },
        {
          id: "32104",
          name: "Santa Rosa de Saco",
          state_id: "2822",
        },
        {
          id: "32105",
          name: "Satipo",
          state_id: "2822",
        },
        {
          id: "32106",
          name: "Sicaya",
          state_id: "2822",
        },
        {
          id: "32107",
          name: "Tarma",
          state_id: "2822",
        },
        {
          id: "32108",
          name: "Yauli",
          state_id: "2822",
        },
        {
          id: "32109",
          name: "Yauya",
          state_id: "2822",
        },
      ],
      "La Libertad": [],
      Lambayeque: [
        {
          id: "32110",
          name: "Chiclayo",
          state_id: "2824",
        },
        {
          id: "32111",
          name: "Chongoyape",
          state_id: "2824",
        },
        {
          id: "32112",
          name: "Eten",
          state_id: "2824",
        },
        {
          id: "32113",
          name: "Ferrenafe",
          state_id: "2824",
        },
        {
          id: "32114",
          name: "Illimo",
          state_id: "2824",
        },
        {
          id: "32115",
          name: "Jayanca",
          state_id: "2824",
        },
        {
          id: "32116",
          name: "Lagunas",
          state_id: "2824",
        },
        {
          id: "32117",
          name: "Lambayeque",
          state_id: "2824",
        },
        {
          id: "32118",
          name: "Manuel Mesones Muro",
          state_id: "2824",
        },
        {
          id: "32119",
          name: "Mochumi",
          state_id: "2824",
        },
        {
          id: "32120",
          name: "Monsefu",
          state_id: "2824",
        },
        {
          id: "32121",
          name: "Morrope",
          state_id: "2824",
        },
        {
          id: "32122",
          name: "Motupe",
          state_id: "2824",
        },
        {
          id: "32123",
          name: "Olmos",
          state_id: "2824",
        },
        {
          id: "32124",
          name: "Oyotun",
          state_id: "2824",
        },
        {
          id: "32125",
          name: "Picsi",
          state_id: "2824",
        },
        {
          id: "32126",
          name: "Pimentel",
          state_id: "2824",
        },
        {
          id: "32127",
          name: "Pueblo Nuevo",
          state_id: "2824",
        },
        {
          id: "32128",
          name: "Reque",
          state_id: "2824",
        },
        {
          id: "32129",
          name: "San Jose",
          state_id: "2824",
        },
        {
          id: "32130",
          name: "Sana",
          state_id: "2824",
        },
        {
          id: "32131",
          name: "Santa Rosa",
          state_id: "2824",
        },
        {
          id: "32132",
          name: "Tucume",
          state_id: "2824",
        },
      ],
      "Lima y Callao": [],
      Loreto: [
        {
          id: "32133",
          name: "Barranca",
          state_id: "2826",
        },
        {
          id: "32134",
          name: "Contamana",
          state_id: "2826",
        },
        {
          id: "32135",
          name: "Fernando Lores",
          state_id: "2826",
        },
        {
          id: "32136",
          name: "Iquitos",
          state_id: "2826",
        },
        {
          id: "32137",
          name: "Lagunas",
          state_id: "2826",
        },
        {
          id: "32138",
          name: "Nauta",
          state_id: "2826",
        },
        {
          id: "32139",
          name: "Paucarpata",
          state_id: "2826",
        },
        {
          id: "32140",
          name: "Ramon Castilla",
          state_id: "2826",
        },
        {
          id: "32141",
          name: "Requena",
          state_id: "2826",
        },
        {
          id: "32142",
          name: "Saquena",
          state_id: "2826",
        },
        {
          id: "32143",
          name: "Vargas Guerra",
          state_id: "2826",
        },
        {
          id: "32144",
          name: "Yurimaguas",
          state_id: "2826",
        },
      ],
      "Madre de Dios": [],
      Moquegua: [
        {
          id: "32145",
          name: "Ilo",
          state_id: "2828",
        },
        {
          id: "32146",
          name: "Moquegua",
          state_id: "2828",
        },
        {
          id: "32147",
          name: "Pacocha",
          state_id: "2828",
        },
        {
          id: "32148",
          name: "Torata",
          state_id: "2828",
        },
      ],
      Pasco: [
        {
          id: "32149",
          name: "Cerro de Pasco",
          state_id: "2829",
        },
        {
          id: "32150",
          name: "Chaupimarca",
          state_id: "2829",
        },
        {
          id: "32151",
          name: "Oxapampa",
          state_id: "2829",
        },
        {
          id: "32152",
          name: "Paucartambo",
          state_id: "2829",
        },
        {
          id: "32153",
          name: "Simon Bolivar",
          state_id: "2829",
        },
        {
          id: "32154",
          name: "Tinyahuarco",
          state_id: "2829",
        },
        {
          id: "32155",
          name: "Villa Rica",
          state_id: "2829",
        },
        {
          id: "32156",
          name: "Yanacancha",
          state_id: "2829",
        },
        {
          id: "32157",
          name: "Yanahuanca",
          state_id: "2829",
        },
      ],
      Piura: [
        {
          id: "32158",
          name: "Ayabaca",
          state_id: "2830",
        },
        {
          id: "32159",
          name: "Bernal",
          state_id: "2830",
        },
        {
          id: "32160",
          name: "Buenos Aires",
          state_id: "2830",
        },
        {
          id: "32161",
          name: "Catacaos",
          state_id: "2830",
        },
        {
          id: "32162",
          name: "Chulucanas",
          state_id: "2830",
        },
        {
          id: "32163",
          name: "Colan",
          state_id: "2830",
        },
        {
          id: "32164",
          name: "Cura Mori",
          state_id: "2830",
        },
        {
          id: "32165",
          name: "El Alto",
          state_id: "2830",
        },
        {
          id: "32166",
          name: "Huancabamba",
          state_id: "2830",
        },
        {
          id: "32167",
          name: "Ignacio Escudero",
          state_id: "2830",
        },
        {
          id: "32168",
          name: "La Arena",
          state_id: "2830",
        },
        {
          id: "32169",
          name: "La Brea",
          state_id: "2830",
        },
        {
          id: "32170",
          name: "La Huaca",
          state_id: "2830",
        },
        {
          id: "32171",
          name: "La Matanza",
          state_id: "2830",
        },
        {
          id: "32172",
          name: "La Union",
          state_id: "2830",
        },
        {
          id: "32173",
          name: "Las Lomas",
          state_id: "2830",
        },
        {
          id: "32174",
          name: "Los Organos",
          state_id: "2830",
        },
        {
          id: "32175",
          name: "Mancora",
          state_id: "2830",
        },
        {
          id: "32176",
          name: "Marcavelica",
          state_id: "2830",
        },
        {
          id: "32177",
          name: "Morropon",
          state_id: "2830",
        },
        {
          id: "32178",
          name: "Paita",
          state_id: "2830",
        },
        {
          id: "32179",
          name: "Piura",
          state_id: "2830",
        },
        {
          id: "32180",
          name: "Querecotillo",
          state_id: "2830",
        },
        {
          id: "32181",
          name: "Salitral",
          state_id: "2830",
        },
        {
          id: "32182",
          name: "San Juan de Bigote",
          state_id: "2830",
        },
        {
          id: "32183",
          name: "Sechura",
          state_id: "2830",
        },
        {
          id: "32184",
          name: "Sullana",
          state_id: "2830",
        },
        {
          id: "32185",
          name: "Talara",
          state_id: "2830",
        },
        {
          id: "32186",
          name: "Tamarindo",
          state_id: "2830",
        },
        {
          id: "32187",
          name: "Tambo Grande",
          state_id: "2830",
        },
        {
          id: "32188",
          name: "Vice",
          state_id: "2830",
        },
        {
          id: "32189",
          name: "Vichayal",
          state_id: "2830",
        },
      ],
      Puno: [
        {
          id: "32190",
          name: "Ayaviri",
          state_id: "2831",
        },
        {
          id: "32191",
          name: "Azangaro",
          state_id: "2831",
        },
        {
          id: "32192",
          name: "Desaguadero",
          state_id: "2831",
        },
        {
          id: "32193",
          name: "Huancane",
          state_id: "2831",
        },
        {
          id: "32194",
          name: "Ilave",
          state_id: "2831",
        },
        {
          id: "32195",
          name: "Juli",
          state_id: "2831",
        },
        {
          id: "32196",
          name: "Juliaca",
          state_id: "2831",
        },
        {
          id: "32197",
          name: "Lampa",
          state_id: "2831",
        },
        {
          id: "32198",
          name: "Macusani",
          state_id: "2831",
        },
        {
          id: "32199",
          name: "Nunoa",
          state_id: "2831",
        },
        {
          id: "32200",
          name: "Puno",
          state_id: "2831",
        },
        {
          id: "32201",
          name: "Putina",
          state_id: "2831",
        },
        {
          id: "32202",
          name: "Santa Lucia",
          state_id: "2831",
        },
        {
          id: "32203",
          name: "Yanahuara",
          state_id: "2831",
        },
        {
          id: "32204",
          name: "Yunguyo",
          state_id: "2831",
        },
      ],
      "San Martin": [],
      Tacna: [
        {
          id: "32205",
          name: "Ilabaya",
          state_id: "2833",
        },
        {
          id: "32206",
          name: "Tacna",
          state_id: "2833",
        },
        {
          id: "32207",
          name: "Tarata",
          state_id: "2833",
        },
      ],
      Tumbes: [
        {
          id: "32208",
          name: "Aguas Verdes",
          state_id: "2834",
        },
        {
          id: "32209",
          name: "Corrales",
          state_id: "2834",
        },
        {
          id: "32210",
          name: "La Cruz",
          state_id: "2834",
        },
        {
          id: "32211",
          name: "Papayal",
          state_id: "2834",
        },
        {
          id: "32212",
          name: "San Jacinto",
          state_id: "2834",
        },
        {
          id: "32213",
          name: "Tumbes",
          state_id: "2834",
        },
        {
          id: "32214",
          name: "Zarumilla",
          state_id: "2834",
        },
        {
          id: "32215",
          name: "Zorritos",
          state_id: "2834",
        },
      ],
      Ucayali: [
        {
          id: "32216",
          name: "Campoverde",
          state_id: "2835",
        },
        {
          id: "32217",
          name: "Padre Abad",
          state_id: "2835",
        },
        {
          id: "32218",
          name: "Pucallpa",
          state_id: "2835",
        },
        {
          id: "32219",
          name: "Raymondi",
          state_id: "2835",
        },
      ],
    },
  },
  PF: {
    name: "French Polynesia",
    native: "Polynésie française",
    phone: "689",
    continent: "OC",
    capital: "Papeetē",
    currency: "XPF",
    languages: ["fr"],
    emoji: "🇵🇫",
    emojiU: "U+1F1F5 U+1F1EB",
    states: {
      "Iles du Vent": [],
      "Iles sous le Vent": [],
      Marquesas: [
        {
          id: "18153",
          name: "Atuona",
          state_id: "1319",
        },
        {
          id: "18154",
          name: "Fatu-Hiva",
          state_id: "1319",
        },
        {
          id: "18155",
          name: "Hakahao",
          state_id: "1319",
        },
        {
          id: "18156",
          name: "Hakamaii",
          state_id: "1319",
        },
        {
          id: "18157",
          name: "Hatiheu",
          state_id: "1319",
        },
        {
          id: "18158",
          name: "Tahuata",
          state_id: "1319",
        },
        {
          id: "18159",
          name: "Taiohae",
          state_id: "1319",
        },
        {
          id: "18160",
          name: "Taipivai",
          state_id: "1319",
        },
        {
          id: "18161",
          name: "Ua-Huka",
          state_id: "1319",
        },
      ],
      Tuamotu: [
        {
          id: "18162",
          name: "Ahe",
          state_id: "1320",
        },
        {
          id: "18163",
          name: "Amanu",
          state_id: "1320",
        },
        {
          id: "18164",
          name: "Anaa",
          state_id: "1320",
        },
        {
          id: "18165",
          name: "Apataki",
          state_id: "1320",
        },
        {
          id: "18166",
          name: "Arutua",
          state_id: "1320",
        },
        {
          id: "18167",
          name: "Faaite",
          state_id: "1320",
        },
        {
          id: "18168",
          name: "Fakahima",
          state_id: "1320",
        },
        {
          id: "18169",
          name: "Fakarava",
          state_id: "1320",
        },
        {
          id: "18170",
          name: "Fangatau",
          state_id: "1320",
        },
        {
          id: "18171",
          name: "Hao",
          state_id: "1320",
        },
        {
          id: "18172",
          name: "Hereheretue",
          state_id: "1320",
        },
        {
          id: "18173",
          name: "Hikueru",
          state_id: "1320",
        },
        {
          id: "18174",
          name: "Katiu",
          state_id: "1320",
        },
        {
          id: "18175",
          name: "Kauehi",
          state_id: "1320",
        },
        {
          id: "18176",
          name: "Kaukura",
          state_id: "1320",
        },
        {
          id: "18177",
          name: "Makatea",
          state_id: "1320",
        },
        {
          id: "18178",
          name: "Makemo",
          state_id: "1320",
        },
        {
          id: "18179",
          name: "Manihi",
          state_id: "1320",
        },
        {
          id: "18180",
          name: "Marokau",
          state_id: "1320",
        },
        {
          id: "18181",
          name: "Napuka",
          state_id: "1320",
        },
        {
          id: "18182",
          name: "Niau",
          state_id: "1320",
        },
        {
          id: "18183",
          name: "Nukutavake",
          state_id: "1320",
        },
        {
          id: "18184",
          name: "Puamau",
          state_id: "1320",
        },
        {
          id: "18185",
          name: "Pukapuka",
          state_id: "1320",
        },
        {
          id: "18186",
          name: "Pukarua",
          state_id: "1320",
        },
        {
          id: "18187",
          name: "Rangiroa",
          state_id: "1320",
        },
        {
          id: "18188",
          name: "Raroia",
          state_id: "1320",
        },
        {
          id: "18189",
          name: "Reao",
          state_id: "1320",
        },
        {
          id: "18190",
          name: "Rikitea",
          state_id: "1320",
        },
        {
          id: "18191",
          name: "Taenga",
          state_id: "1320",
        },
        {
          id: "18192",
          name: "Takapoto",
          state_id: "1320",
        },
        {
          id: "18193",
          name: "Takaroa",
          state_id: "1320",
        },
        {
          id: "18194",
          name: "Tatakoto",
          state_id: "1320",
        },
        {
          id: "18195",
          name: "Tepoto",
          state_id: "1320",
        },
        {
          id: "18196",
          name: "Tikehau",
          state_id: "1320",
        },
        {
          id: "18197",
          name: "Tureia",
          state_id: "1320",
        },
        {
          id: "18198",
          name: "Vahitahi",
          state_id: "1320",
        },
        {
          id: "18199",
          name: "Vairaatea",
          state_id: "1320",
        },
      ],
      Tubuai: [
        {
          id: "18200",
          name: "Amaru",
          state_id: "1321",
        },
        {
          id: "18201",
          name: "Anapoto",
          state_id: "1321",
        },
        {
          id: "18202",
          name: "Anatonu",
          state_id: "1321",
        },
        {
          id: "18203",
          name: "Auti",
          state_id: "1321",
        },
        {
          id: "18204",
          name: "Avera",
          state_id: "1321",
        },
        {
          id: "18205",
          name: "Mahu",
          state_id: "1321",
        },
        {
          id: "18206",
          name: "Mataura",
          state_id: "1321",
        },
        {
          id: "18207",
          name: "Moerai",
          state_id: "1321",
        },
        {
          id: "18208",
          name: "Mutuaura",
          state_id: "1321",
        },
        {
          id: "18209",
          name: "Rairua",
          state_id: "1321",
        },
        {
          id: "18210",
          name: "Rapa",
          state_id: "1321",
        },
        {
          id: "18211",
          name: "Taahuaia",
          state_id: "1321",
        },
        {
          id: "18212",
          name: "Vaiuru",
          state_id: "1321",
        },
      ],
    },
  },
  PG: {
    name: "Papua New Guinea",
    native: "Papua Niugini",
    phone: "675",
    continent: "OC",
    capital: "Port Moresby",
    currency: "PGK",
    languages: ["en"],
    emoji: "🇵🇬",
    emojiU: "U+1F1F5 U+1F1EC",
    states: {
      "East New Britain": [],
      "East Sepik": [],
      "Eastern Highlands": [],
      Enga: [
        {
          id: "31789",
          name: "Laiagam",
          state_id: "2778",
        },
        {
          id: "31790",
          name: "Porgera",
          state_id: "2778",
        },
        {
          id: "31791",
          name: "Wabag",
          state_id: "2778",
        },
      ],
      "Fly River": [],
      Gulf: [
        {
          id: "31792",
          name: "Kerema",
          state_id: "2780",
        },
      ],
      Madang: [
        {
          id: "31793",
          name: "Finschhafen",
          state_id: "2781",
        },
        {
          id: "31794",
          name: "Madang",
          state_id: "2781",
        },
      ],
      Manus: [
        {
          id: "31795",
          name: "Lorengau",
          state_id: "2782",
        },
      ],
      "Milne Bay": [],
      Morobe: [
        {
          id: "31796",
          name: "Bulolo",
          state_id: "2784",
        },
        {
          id: "31797",
          name: "Lae",
          state_id: "2784",
        },
        {
          id: "31798",
          name: "Wau",
          state_id: "2784",
        },
      ],
      "National Capital District": [],
      "New Ireland": [],
      "North Solomons": [],
      Oro: [
        {
          id: "31799",
          name: "Kokoda",
          state_id: "2788",
        },
        {
          id: "31800",
          name: "Popondetta",
          state_id: "2788",
        },
      ],
      Sandaun: [
        {
          id: "31801",
          name: "Vanimo",
          state_id: "2789",
        },
      ],
      Simbu: [
        {
          id: "31802",
          name: "Kundiawa",
          state_id: "2790",
        },
      ],
      "Southern Highlands": [],
      "West New Britain": [],
      "Western Highlands": [],
    },
  },
  PH: {
    name: "Philippines",
    native: "Pilipinas",
    phone: "63",
    continent: "AS",
    capital: "Manila",
    currency: "PHP",
    languages: ["en"],
    emoji: "🇵🇭",
    emojiU: "U+1F1F5 U+1F1ED",
    states: {
      Batangas: [
        {
          id: "32220",
          name: "San Juan",
          state_id: "2836",
        },
      ],
      Bicol: [
        {
          id: "32221",
          name: "Albay",
          state_id: "2837",
        },
        {
          id: "32222",
          name: "Daet",
          state_id: "2837",
        },
        {
          id: "32223",
          name: "Iriga",
          state_id: "2837",
        },
        {
          id: "32224",
          name: "Legaspi",
          state_id: "2837",
        },
        {
          id: "32225",
          name: "Naga",
          state_id: "2837",
        },
        {
          id: "32226",
          name: "Sorsogon",
          state_id: "2837",
        },
      ],
      Bulacan: [
        {
          id: "32227",
          name: "Bulacan",
          state_id: "2838",
        },
        {
          id: "32228",
          name: "Marilao",
          state_id: "2838",
        },
      ],
      Cagayan: [
        {
          id: "32229",
          name: "Cagayan de Oro",
          state_id: "2839",
        },
        {
          id: "32230",
          name: "Santiago",
          state_id: "2839",
        },
        {
          id: "32231",
          name: "Solano",
          state_id: "2839",
        },
        {
          id: "32232",
          name: "Tuguegarao",
          state_id: "2839",
        },
      ],
      Caraga: [
        {
          id: "32233",
          name: "Bislig",
          state_id: "2840",
        },
        {
          id: "32234",
          name: "Butuan",
          state_id: "2840",
        },
        {
          id: "32235",
          name: "Surigao",
          state_id: "2840",
        },
      ],
      "Central Luzon": [],
      "Central Mindanao": [],
      "Central Visayas": [],
      Cordillera: [
        {
          id: "32236",
          name: "Baguio",
          state_id: "2844",
        },
        {
          id: "32237",
          name: "Bangued",
          state_id: "2844",
        },
      ],
      Davao: [
        {
          id: "32238",
          name: "Davao",
          state_id: "2845",
        },
      ],
      "Eastern Visayas": [],
      "Greater Metropolitan Area": [],
      Ilocos: [
        {
          id: "32240",
          name: "Laoag",
          state_id: "2848",
        },
        {
          id: "32241",
          name: "Manaoag",
          state_id: "2848",
        },
        {
          id: "32242",
          name: "Mangaldan",
          state_id: "2848",
        },
        {
          id: "32243",
          name: "San Fernando",
          state_id: "2848",
        },
        {
          id: "32244",
          name: "Urdaneta",
          state_id: "2848",
        },
        {
          id: "32245",
          name: "Vigan",
          state_id: "2848",
        },
      ],
      Laguna: [
        {
          id: "32246",
          name: "Binan",
          state_id: "2849",
        },
        {
          id: "32247",
          name: "Laguna",
          state_id: "2849",
        },
        {
          id: "32248",
          name: "Pangil",
          state_id: "2849",
        },
        {
          id: "32249",
          name: "San Pedro",
          state_id: "2849",
        },
      ],
      Luzon: [
        {
          id: "32250",
          name: "Manila",
          state_id: "2850",
        },
        {
          id: "32251",
          name: "Marikina",
          state_id: "2850",
        },
      ],
      Mactan: [
        {
          id: "32252",
          name: "Mactan",
          state_id: "2851",
        },
      ],
      "Metropolitan Manila Area": [],
      "Muslim Mindanao": [],
      "Northern Mindanao": [],
      "Southern Mindanao": [],
      "Southern Tagalog": [],
      "Western Mindanao": [],
      "Western Visayas": [],
    },
  },
  PK: {
    name: "Pakistan",
    native: "Pakistan",
    phone: "92",
    continent: "AS",
    capital: "Islamabad",
    currency: "PKR",
    languages: ["en", "ur"],
    emoji: "🇵🇰",
    emojiU: "U+1F1F5 U+1F1F0",
    states: {
      Baluchistan: [
        {
          id: "31273",
          name: "Barkhan",
          state_id: "2723",
        },
        {
          id: "31274",
          name: "Bela",
          state_id: "2723",
        },
        {
          id: "31275",
          name: "Bhag",
          state_id: "2723",
        },
        {
          id: "31276",
          name: "Chaman",
          state_id: "2723",
        },
        {
          id: "31277",
          name: "Chitkan",
          state_id: "2723",
        },
        {
          id: "31278",
          name: "Dalbandin",
          state_id: "2723",
        },
        {
          id: "31279",
          name: "Dera Allah Yar",
          state_id: "2723",
        },
        {
          id: "31280",
          name: "Dera Bugti",
          state_id: "2723",
        },
        {
          id: "31281",
          name: "Dera Murad Jamali",
          state_id: "2723",
        },
        {
          id: "31282",
          name: "Dhadar",
          state_id: "2723",
        },
        {
          id: "31283",
          name: "Duki",
          state_id: "2723",
        },
        {
          id: "31284",
          name: "Gaddani",
          state_id: "2723",
        },
        {
          id: "31285",
          name: "Gwadar",
          state_id: "2723",
        },
        {
          id: "31286",
          name: "Harnai",
          state_id: "2723",
        },
        {
          id: "31287",
          name: "Hub",
          state_id: "2723",
        },
        {
          id: "31288",
          name: "Jiwani",
          state_id: "2723",
        },
        {
          id: "31289",
          name: "Kalat",
          state_id: "2723",
        },
        {
          id: "31290",
          name: "Kharan",
          state_id: "2723",
        },
        {
          id: "31291",
          name: "Khuzdar",
          state_id: "2723",
        },
        {
          id: "31292",
          name: "Kohlu",
          state_id: "2723",
        },
        {
          id: "31293",
          name: "Loralai",
          state_id: "2723",
        },
        {
          id: "31294",
          name: "Mach",
          state_id: "2723",
        },
        {
          id: "31295",
          name: "Mastung",
          state_id: "2723",
        },
        {
          id: "31296",
          name: "Nushki",
          state_id: "2723",
        },
        {
          id: "31297",
          name: "Ormara",
          state_id: "2723",
        },
        {
          id: "31298",
          name: "Pasni",
          state_id: "2723",
        },
        {
          id: "31299",
          name: "Pishin",
          state_id: "2723",
        },
        {
          id: "31300",
          name: "Quetta",
          state_id: "2723",
        },
        {
          id: "31301",
          name: "Sibi",
          state_id: "2723",
        },
        {
          id: "31302",
          name: "Sohbatpur",
          state_id: "2723",
        },
        {
          id: "31303",
          name: "Surab",
          state_id: "2723",
        },
        {
          id: "31304",
          name: "Turbat",
          state_id: "2723",
        },
        {
          id: "31305",
          name: "Usta Muhammad",
          state_id: "2723",
        },
        {
          id: "31306",
          name: "Uthal",
          state_id: "2723",
        },
        {
          id: "31307",
          name: "Wadh",
          state_id: "2723",
        },
        {
          id: "31308",
          name: "Winder",
          state_id: "2723",
        },
        {
          id: "31309",
          name: "Zehri",
          state_id: "2723",
        },
        {
          id: "31310",
          name: "Zhob",
          state_id: "2723",
        },
        {
          id: "31311",
          name: "Ziarat",
          state_id: "2723",
        },
      ],
      "Federal Capital Area": [],
      "Federally administered Tribal": [],
      "North-West Frontier": [],
      "Northern Areas": [],
      Punjab: [
        {
          id: "5742",
          name: "Abohar",
          state_id: "2728",
        },
        {
          id: "5743",
          name: "Adampur",
          state_id: "2728",
        },
        {
          id: "5744",
          name: "Ahmedgarh",
          state_id: "2728",
        },
        {
          id: "5745",
          name: "Ajnala",
          state_id: "2728",
        },
        {
          id: "5746",
          name: "Akalgarh",
          state_id: "2728",
        },
        {
          id: "5747",
          name: "Alawalpur",
          state_id: "2728",
        },
        {
          id: "5748",
          name: "Amloh",
          state_id: "2728",
        },
        {
          id: "5749",
          name: "Amritsar",
          state_id: "2728",
        },
        {
          id: "5750",
          name: "Amritsar Cantonment",
          state_id: "2728",
        },
        {
          id: "5751",
          name: "Anandpur Sahib",
          state_id: "2728",
        },
        {
          id: "5752",
          name: "Badhni Kalan",
          state_id: "2728",
        },
        {
          id: "5753",
          name: "Bagh Purana",
          state_id: "2728",
        },
        {
          id: "5754",
          name: "Balachaur",
          state_id: "2728",
        },
        {
          id: "5755",
          name: "Banaur",
          state_id: "2728",
        },
        {
          id: "5756",
          name: "Banga",
          state_id: "2728",
        },
        {
          id: "5757",
          name: "Banur",
          state_id: "2728",
        },
        {
          id: "5758",
          name: "Baretta",
          state_id: "2728",
        },
        {
          id: "5759",
          name: "Bariwala",
          state_id: "2728",
        },
        {
          id: "5760",
          name: "Barnala",
          state_id: "2728",
        },
        {
          id: "5761",
          name: "Bassi Pathana",
          state_id: "2728",
        },
        {
          id: "5762",
          name: "Batala",
          state_id: "2728",
        },
        {
          id: "5763",
          name: "Bathinda",
          state_id: "2728",
        },
        {
          id: "5764",
          name: "Begowal",
          state_id: "2728",
        },
        {
          id: "5765",
          name: "Behrampur",
          state_id: "2728",
        },
        {
          id: "5766",
          name: "Bhabat",
          state_id: "2728",
        },
        {
          id: "5767",
          name: "Bhadur",
          state_id: "2728",
        },
        {
          id: "5768",
          name: "Bhankharpur",
          state_id: "2728",
        },
        {
          id: "5769",
          name: "Bharoli Kalan",
          state_id: "2728",
        },
        {
          id: "5770",
          name: "Bhawanigarh",
          state_id: "2728",
        },
        {
          id: "5771",
          name: "Bhikhi",
          state_id: "2728",
        },
        {
          id: "5772",
          name: "Bhikhiwind",
          state_id: "2728",
        },
        {
          id: "5773",
          name: "Bhisiana",
          state_id: "2728",
        },
        {
          id: "5774",
          name: "Bhogpur",
          state_id: "2728",
        },
        {
          id: "5775",
          name: "Bhuch",
          state_id: "2728",
        },
        {
          id: "5776",
          name: "Bhulath",
          state_id: "2728",
        },
        {
          id: "5777",
          name: "Budha Theh",
          state_id: "2728",
        },
        {
          id: "5778",
          name: "Budhlada",
          state_id: "2728",
        },
        {
          id: "5779",
          name: "Chima",
          state_id: "2728",
        },
        {
          id: "5780",
          name: "Chohal",
          state_id: "2728",
        },
        {
          id: "5781",
          name: "Dasuya",
          state_id: "2728",
        },
        {
          id: "5782",
          name: "Daulatpur",
          state_id: "2728",
        },
        {
          id: "5783",
          name: "Dera Baba Nanak",
          state_id: "2728",
        },
        {
          id: "5784",
          name: "Dera Bassi",
          state_id: "2728",
        },
        {
          id: "5785",
          name: "Dhanaula",
          state_id: "2728",
        },
        {
          id: "5786",
          name: "Dharam Kot",
          state_id: "2728",
        },
        {
          id: "5787",
          name: "Dhariwal",
          state_id: "2728",
        },
        {
          id: "5788",
          name: "Dhilwan",
          state_id: "2728",
        },
        {
          id: "5789",
          name: "Dhuri",
          state_id: "2728",
        },
        {
          id: "5790",
          name: "Dinanagar",
          state_id: "2728",
        },
        {
          id: "5791",
          name: "Dirba",
          state_id: "2728",
        },
        {
          id: "5792",
          name: "Doraha",
          state_id: "2728",
        },
        {
          id: "5793",
          name: "Faridkot",
          state_id: "2728",
        },
        {
          id: "5794",
          name: "Fateh Nangal",
          state_id: "2728",
        },
        {
          id: "5795",
          name: "Fatehgarh Churian",
          state_id: "2728",
        },
        {
          id: "5796",
          name: "Fatehgarh Sahib",
          state_id: "2728",
        },
        {
          id: "5797",
          name: "Fazilka",
          state_id: "2728",
        },
        {
          id: "5798",
          name: "Firozpur",
          state_id: "2728",
        },
        {
          id: "5799",
          name: "Firozpur Cantonment",
          state_id: "2728",
        },
        {
          id: "5800",
          name: "Gardhiwala",
          state_id: "2728",
        },
        {
          id: "5801",
          name: "Garhshankar",
          state_id: "2728",
        },
        {
          id: "5802",
          name: "Ghagga",
          state_id: "2728",
        },
        {
          id: "5803",
          name: "Ghanaur",
          state_id: "2728",
        },
        {
          id: "5804",
          name: "Giddarbaha",
          state_id: "2728",
        },
        {
          id: "5805",
          name: "Gobindgarh",
          state_id: "2728",
        },
        {
          id: "5806",
          name: "Goniana",
          state_id: "2728",
        },
        {
          id: "5807",
          name: "Goraya",
          state_id: "2728",
        },
        {
          id: "5808",
          name: "Gurdaspur",
          state_id: "2728",
        },
        {
          id: "5809",
          name: "Guru Har Sahai",
          state_id: "2728",
        },
        {
          id: "5810",
          name: "Hajipur",
          state_id: "2728",
        },
        {
          id: "5811",
          name: "Handiaya",
          state_id: "2728",
        },
        {
          id: "5812",
          name: "Hariana",
          state_id: "2728",
        },
        {
          id: "5813",
          name: "Hoshiarpur",
          state_id: "2728",
        },
        {
          id: "5814",
          name: "Hussainpur",
          state_id: "2728",
        },
        {
          id: "5815",
          name: "Jagraon",
          state_id: "2728",
        },
        {
          id: "5816",
          name: "Jaitu",
          state_id: "2728",
        },
        {
          id: "5817",
          name: "Jalalabad",
          state_id: "2728",
        },
        {
          id: "5818",
          name: "Jalandhar",
          state_id: "2728",
        },
        {
          id: "5819",
          name: "Jalandhar Cantonment",
          state_id: "2728",
        },
        {
          id: "5820",
          name: "Jandiala",
          state_id: "2728",
        },
        {
          id: "5821",
          name: "Jugial",
          state_id: "2728",
        },
        {
          id: "5822",
          name: "Kalanaur",
          state_id: "2728",
        },
        {
          id: "5823",
          name: "Kapurthala",
          state_id: "2728",
        },
        {
          id: "5824",
          name: "Karoran",
          state_id: "2728",
        },
        {
          id: "5825",
          name: "Kartarpur",
          state_id: "2728",
        },
        {
          id: "5826",
          name: "Khamanon",
          state_id: "2728",
        },
        {
          id: "5827",
          name: "Khanauri",
          state_id: "2728",
        },
        {
          id: "5828",
          name: "Khanna",
          state_id: "2728",
        },
        {
          id: "5829",
          name: "Kharar",
          state_id: "2728",
        },
        {
          id: "5830",
          name: "Khem Karan",
          state_id: "2728",
        },
        {
          id: "5831",
          name: "Kot Fatta",
          state_id: "2728",
        },
        {
          id: "5832",
          name: "Kot Isa Khan",
          state_id: "2728",
        },
        {
          id: "5833",
          name: "Kot Kapura",
          state_id: "2728",
        },
        {
          id: "5834",
          name: "Kotkapura",
          state_id: "2728",
        },
        {
          id: "5835",
          name: "Kurali",
          state_id: "2728",
        },
        {
          id: "5836",
          name: "Lalru",
          state_id: "2728",
        },
        {
          id: "5837",
          name: "Lehra Gaga",
          state_id: "2728",
        },
        {
          id: "5838",
          name: "Lodhian Khas",
          state_id: "2728",
        },
        {
          id: "5839",
          name: "Longowal",
          state_id: "2728",
        },
        {
          id: "5840",
          name: "Ludhiana",
          state_id: "2728",
        },
        {
          id: "5841",
          name: "Machhiwara",
          state_id: "2728",
        },
        {
          id: "5842",
          name: "Mahilpur",
          state_id: "2728",
        },
        {
          id: "5843",
          name: "Majitha",
          state_id: "2728",
        },
        {
          id: "5844",
          name: "Makhu",
          state_id: "2728",
        },
        {
          id: "5845",
          name: "Malaut",
          state_id: "2728",
        },
        {
          id: "5846",
          name: "Malerkotla",
          state_id: "2728",
        },
        {
          id: "5847",
          name: "Maloud",
          state_id: "2728",
        },
        {
          id: "5848",
          name: "Mandi Gobindgarh",
          state_id: "2728",
        },
        {
          id: "5849",
          name: "Mansa",
          state_id: "2728",
        },
        {
          id: "5850",
          name: "Maur",
          state_id: "2728",
        },
        {
          id: "5851",
          name: "Moga",
          state_id: "2728",
        },
        {
          id: "5852",
          name: "Mohali",
          state_id: "2728",
        },
        {
          id: "5853",
          name: "Moonak",
          state_id: "2728",
        },
        {
          id: "5854",
          name: "Morinda",
          state_id: "2728",
        },
        {
          id: "5855",
          name: "Mukerian",
          state_id: "2728",
        },
        {
          id: "5856",
          name: "Muktsar",
          state_id: "2728",
        },
        {
          id: "5857",
          name: "Mullanpur Dakha",
          state_id: "2728",
        },
        {
          id: "5858",
          name: "Mullanpur Garibdas",
          state_id: "2728",
        },
        {
          id: "5859",
          name: "Munak",
          state_id: "2728",
        },
        {
          id: "5860",
          name: "Muradpura",
          state_id: "2728",
        },
        {
          id: "5861",
          name: "Nabha",
          state_id: "2728",
        },
        {
          id: "5862",
          name: "Nakodar",
          state_id: "2728",
        },
        {
          id: "5863",
          name: "Nangal",
          state_id: "2728",
        },
        {
          id: "5864",
          name: "Nawashahr",
          state_id: "2728",
        },
        {
          id: "5865",
          name: "Naya Nangal",
          state_id: "2728",
        },
        {
          id: "5866",
          name: "Nehon",
          state_id: "2728",
        },
        {
          id: "5867",
          name: "Nurmahal",
          state_id: "2728",
        },
        {
          id: "5868",
          name: "Pathankot",
          state_id: "2728",
        },
        {
          id: "5869",
          name: "Patiala",
          state_id: "2728",
        },
        {
          id: "5870",
          name: "Patti",
          state_id: "2728",
        },
        {
          id: "5871",
          name: "Pattran",
          state_id: "2728",
        },
        {
          id: "5872",
          name: "Payal",
          state_id: "2728",
        },
        {
          id: "5873",
          name: "Phagwara",
          state_id: "2728",
        },
        {
          id: "5874",
          name: "Phillaur",
          state_id: "2728",
        },
        {
          id: "5875",
          name: "Qadian",
          state_id: "2728",
        },
        {
          id: "5876",
          name: "Rahon",
          state_id: "2728",
        },
        {
          id: "5877",
          name: "Raikot",
          state_id: "2728",
        },
        {
          id: "5878",
          name: "Raja Sansi",
          state_id: "2728",
        },
        {
          id: "5879",
          name: "Rajpura",
          state_id: "2728",
        },
        {
          id: "5880",
          name: "Ram Das",
          state_id: "2728",
        },
        {
          id: "5881",
          name: "Raman",
          state_id: "2728",
        },
        {
          id: "5882",
          name: "Rampura",
          state_id: "2728",
        },
        {
          id: "5883",
          name: "Rayya",
          state_id: "2728",
        },
        {
          id: "5884",
          name: "Rupnagar",
          state_id: "2728",
        },
        {
          id: "5885",
          name: "Rurki Kasba",
          state_id: "2728",
        },
        {
          id: "5886",
          name: "Sahnewal",
          state_id: "2728",
        },
        {
          id: "5887",
          name: "Samana",
          state_id: "2728",
        },
        {
          id: "5888",
          name: "Samrala",
          state_id: "2728",
        },
        {
          id: "5889",
          name: "Sanaur",
          state_id: "2728",
        },
        {
          id: "5890",
          name: "Sangat",
          state_id: "2728",
        },
        {
          id: "5891",
          name: "Sangrur",
          state_id: "2728",
        },
        {
          id: "5892",
          name: "Sansarpur",
          state_id: "2728",
        },
        {
          id: "5893",
          name: "Sardulgarh",
          state_id: "2728",
        },
        {
          id: "5894",
          name: "Shahkot",
          state_id: "2728",
        },
        {
          id: "5895",
          name: "Sham Churasi",
          state_id: "2728",
        },
        {
          id: "5896",
          name: "Shekhpura",
          state_id: "2728",
        },
        {
          id: "5897",
          name: "Sirhind",
          state_id: "2728",
        },
        {
          id: "5898",
          name: "Sri Hargobindpur",
          state_id: "2728",
        },
        {
          id: "5899",
          name: "Sujanpur",
          state_id: "2728",
        },
        {
          id: "5900",
          name: "Sultanpur Lodhi",
          state_id: "2728",
        },
        {
          id: "5901",
          name: "Sunam",
          state_id: "2728",
        },
        {
          id: "5902",
          name: "Talwandi Bhai",
          state_id: "2728",
        },
        {
          id: "5903",
          name: "Talwara",
          state_id: "2728",
        },
        {
          id: "5904",
          name: "Tappa",
          state_id: "2728",
        },
        {
          id: "5905",
          name: "Tarn Taran",
          state_id: "2728",
        },
        {
          id: "5906",
          name: "Urmar Tanda",
          state_id: "2728",
        },
        {
          id: "5907",
          name: "Zira",
          state_id: "2728",
        },
        {
          id: "5908",
          name: "Zirakpur",
          state_id: "2728",
        },
        {
          id: "31312",
          name: "Abdul Hakim",
          state_id: "2728",
        },
        {
          id: "31313",
          name: "Ahmadpur East",
          state_id: "2728",
        },
        {
          id: "31314",
          name: "Ahmadpur Lumma",
          state_id: "2728",
        },
        {
          id: "31315",
          name: "Ahmadpur Sial",
          state_id: "2728",
        },
        {
          id: "31316",
          name: "Ahmedabad",
          state_id: "2728",
        },
        {
          id: "31317",
          name: "Alipur",
          state_id: "2728",
        },
        {
          id: "31318",
          name: "Alipur Chatha",
          state_id: "2728",
        },
        {
          id: "31319",
          name: "Arifwala",
          state_id: "2728",
        },
        {
          id: "31320",
          name: "Attock",
          state_id: "2728",
        },
        {
          id: "31321",
          name: "Baddomalhi",
          state_id: "2728",
        },
        {
          id: "31322",
          name: "Bagh",
          state_id: "2728",
        },
        {
          id: "31323",
          name: "Bahawalnagar",
          state_id: "2728",
        },
        {
          id: "31324",
          name: "Bahawalpur",
          state_id: "2728",
        },
        {
          id: "31325",
          name: "Bai Pheru",
          state_id: "2728",
        },
        {
          id: "31326",
          name: "Basirpur",
          state_id: "2728",
        },
        {
          id: "31327",
          name: "Begowala",
          state_id: "2728",
        },
        {
          id: "31328",
          name: "Bhakkar",
          state_id: "2728",
        },
        {
          id: "31329",
          name: "Bhalwal",
          state_id: "2728",
        },
        {
          id: "31330",
          name: "Bhawana",
          state_id: "2728",
        },
        {
          id: "31331",
          name: "Bhera",
          state_id: "2728",
        },
        {
          id: "31332",
          name: "Bhopalwala",
          state_id: "2728",
        },
        {
          id: "31333",
          name: "Burewala",
          state_id: "2728",
        },
        {
          id: "31334",
          name: "Chak Azam Sahu",
          state_id: "2728",
        },
        {
          id: "31335",
          name: "Chak Jhumra",
          state_id: "2728",
        },
        {
          id: "31336",
          name: "Chak Sarwar Shahid",
          state_id: "2728",
        },
        {
          id: "31337",
          name: "Chakwal",
          state_id: "2728",
        },
        {
          id: "31338",
          name: "Chawinda",
          state_id: "2728",
        },
        {
          id: "31339",
          name: "Chichawatni",
          state_id: "2728",
        },
        {
          id: "31340",
          name: "Chiniot",
          state_id: "2728",
        },
        {
          id: "31341",
          name: "Chishtian Mandi",
          state_id: "2728",
        },
        {
          id: "31342",
          name: "Choa Saidan Shah",
          state_id: "2728",
        },
        {
          id: "31343",
          name: "Chuhar Kana",
          state_id: "2728",
        },
        {
          id: "31344",
          name: "Chunian",
          state_id: "2728",
        },
        {
          id: "31345",
          name: "Dajal",
          state_id: "2728",
        },
        {
          id: "31346",
          name: "Darya Khan",
          state_id: "2728",
        },
        {
          id: "31347",
          name: "Daska",
          state_id: "2728",
        },
        {
          id: "31348",
          name: "Daud Khel",
          state_id: "2728",
        },
        {
          id: "31349",
          name: "Daultala",
          state_id: "2728",
        },
        {
          id: "31350",
          name: "Dera Din Panah",
          state_id: "2728",
        },
        {
          id: "31351",
          name: "Dera Ghazi Khan",
          state_id: "2728",
        },
        {
          id: "31352",
          name: "Dhanote",
          state_id: "2728",
        },
        {
          id: "31353",
          name: "Dhonkal",
          state_id: "2728",
        },
        {
          id: "31354",
          name: "Dijkot",
          state_id: "2728",
        },
        {
          id: "31355",
          name: "Dina",
          state_id: "2728",
        },
        {
          id: "31356",
          name: "Dinga",
          state_id: "2728",
        },
        {
          id: "31357",
          name: "Dipalpur",
          state_id: "2728",
        },
        {
          id: "31358",
          name: "Dullewala",
          state_id: "2728",
        },
        {
          id: "31359",
          name: "Dunga Bunga",
          state_id: "2728",
        },
        {
          id: "31360",
          name: "Dunyapur",
          state_id: "2728",
        },
        {
          id: "31361",
          name: "Eminabad",
          state_id: "2728",
        },
        {
          id: "31362",
          name: "Faisalabad",
          state_id: "2728",
        },
        {
          id: "31363",
          name: "Faqirwali",
          state_id: "2728",
        },
        {
          id: "31364",
          name: "Faruka",
          state_id: "2728",
        },
        {
          id: "31365",
          name: "Fateh Jang",
          state_id: "2728",
        },
        {
          id: "31366",
          name: "Fatehpur",
          state_id: "2728",
        },
        {
          id: "31367",
          name: "Fazalpur",
          state_id: "2728",
        },
        {
          id: "31368",
          name: "Ferozwala",
          state_id: "2728",
        },
        {
          id: "31369",
          name: "Fort Abbas",
          state_id: "2728",
        },
        {
          id: "31370",
          name: "Garh Maharaja",
          state_id: "2728",
        },
        {
          id: "31371",
          name: "Ghakar",
          state_id: "2728",
        },
        {
          id: "31372",
          name: "Ghurgushti",
          state_id: "2728",
        },
        {
          id: "31373",
          name: "Gojra",
          state_id: "2728",
        },
        {
          id: "31374",
          name: "Gujar Khan",
          state_id: "2728",
        },
        {
          id: "31375",
          name: "Gujranwala",
          state_id: "2728",
        },
        {
          id: "31376",
          name: "Gujrat",
          state_id: "2728",
        },
        {
          id: "31377",
          name: "Hadali",
          state_id: "2728",
        },
        {
          id: "31378",
          name: "Hafizabad",
          state_id: "2728",
        },
        {
          id: "31379",
          name: "Harnoli",
          state_id: "2728",
        },
        {
          id: "31380",
          name: "Harunabad",
          state_id: "2728",
        },
        {
          id: "31381",
          name: "Hasan Abdal",
          state_id: "2728",
        },
        {
          id: "31382",
          name: "Hasilpur",
          state_id: "2728",
        },
        {
          id: "31383",
          name: "Haveli",
          state_id: "2728",
        },
        {
          id: "31384",
          name: "Hazro",
          state_id: "2728",
        },
        {
          id: "31385",
          name: "Hujra Shah Muqim",
          state_id: "2728",
        },
        {
          id: "31386",
          name: "Isa Khel",
          state_id: "2728",
        },
        {
          id: "31387",
          name: "Jahanian",
          state_id: "2728",
        },
        {
          id: "31388",
          name: "Jalalpur Bhattian",
          state_id: "2728",
        },
        {
          id: "31389",
          name: "Jalalpur Jattan",
          state_id: "2728",
        },
        {
          id: "31390",
          name: "Jalalpur Pirwala",
          state_id: "2728",
        },
        {
          id: "31391",
          name: "Jalla Jeem",
          state_id: "2728",
        },
        {
          id: "31392",
          name: "Jamke Chima",
          state_id: "2728",
        },
        {
          id: "31393",
          name: "Jampur",
          state_id: "2728",
        },
        {
          id: "31394",
          name: "Jand",
          state_id: "2728",
        },
        {
          id: "31395",
          name: "Jandanwala",
          state_id: "2728",
        },
        {
          id: "31396",
          name: "Jandiala Sherkhan",
          state_id: "2728",
        },
        {
          id: "31397",
          name: "Jaranwala",
          state_id: "2728",
        },
        {
          id: "31398",
          name: "Jatoi",
          state_id: "2728",
        },
        {
          id: "31399",
          name: "Jauharabad",
          state_id: "2728",
        },
        {
          id: "31400",
          name: "Jhang",
          state_id: "2728",
        },
        {
          id: "31401",
          name: "Jhawarian",
          state_id: "2728",
        },
        {
          id: "31402",
          name: "Jhelum",
          state_id: "2728",
        },
        {
          id: "31403",
          name: "Kabirwala",
          state_id: "2728",
        },
        {
          id: "31404",
          name: "Kahna Nau",
          state_id: "2728",
        },
        {
          id: "31405",
          name: "Kahror Pakka",
          state_id: "2728",
        },
        {
          id: "31406",
          name: "Kahuta",
          state_id: "2728",
        },
        {
          id: "31407",
          name: "Kalabagh",
          state_id: "2728",
        },
        {
          id: "31408",
          name: "Kalaswala",
          state_id: "2728",
        },
        {
          id: "31409",
          name: "Kaleke",
          state_id: "2728",
        },
        {
          id: "31410",
          name: "Kalur Kot",
          state_id: "2728",
        },
        {
          id: "31411",
          name: "Kamalia",
          state_id: "2728",
        },
        {
          id: "31412",
          name: "Kamar Mashani",
          state_id: "2728",
        },
        {
          id: "31413",
          name: "Kamir",
          state_id: "2728",
        },
        {
          id: "31414",
          name: "Kamoke",
          state_id: "2728",
        },
        {
          id: "31415",
          name: "Kamra",
          state_id: "2728",
        },
        {
          id: "31416",
          name: "Kanganpur",
          state_id: "2728",
        },
        {
          id: "31417",
          name: "Karampur",
          state_id: "2728",
        },
        {
          id: "31418",
          name: "Karor Lal Esan",
          state_id: "2728",
        },
        {
          id: "31419",
          name: "Kasur",
          state_id: "2728",
        },
        {
          id: "31420",
          name: "Khairpur Tamewali",
          state_id: "2728",
        },
        {
          id: "31421",
          name: "Khanewal",
          state_id: "2728",
        },
        {
          id: "31422",
          name: "Khangah Dogran",
          state_id: "2728",
        },
        {
          id: "31423",
          name: "Khangarh",
          state_id: "2728",
        },
        {
          id: "31424",
          name: "Khanpur",
          state_id: "2728",
        },
        {
          id: "31425",
          name: "Kharian",
          state_id: "2728",
        },
        {
          id: "31426",
          name: "Khewra",
          state_id: "2728",
        },
        {
          id: "31427",
          name: "Khundian",
          state_id: "2728",
        },
        {
          id: "31428",
          name: "Khurianwala",
          state_id: "2728",
        },
        {
          id: "31429",
          name: "Khushab",
          state_id: "2728",
        },
        {
          id: "31430",
          name: "Kot Abdul Malik",
          state_id: "2728",
        },
        {
          id: "31431",
          name: "Kot Addu",
          state_id: "2728",
        },
        {
          id: "31432",
          name: "Kot Mithan",
          state_id: "2728",
        },
        {
          id: "31433",
          name: "Kot Moman",
          state_id: "2728",
        },
        {
          id: "31434",
          name: "Kot Radha Kishan",
          state_id: "2728",
        },
        {
          id: "31435",
          name: "Kot Samaba",
          state_id: "2728",
        },
        {
          id: "31436",
          name: "Kotli Loharan",
          state_id: "2728",
        },
        {
          id: "31437",
          name: "Kundian",
          state_id: "2728",
        },
        {
          id: "31438",
          name: "Kunjah",
          state_id: "2728",
        },
        {
          id: "31439",
          name: "Lahore",
          state_id: "2728",
        },
        {
          id: "31440",
          name: "Lalamusa",
          state_id: "2728",
        },
        {
          id: "31441",
          name: "Lalian",
          state_id: "2728",
        },
        {
          id: "31442",
          name: "Liaqatabad",
          state_id: "2728",
        },
        {
          id: "31443",
          name: "Liaqatpur",
          state_id: "2728",
        },
        {
          id: "31444",
          name: "Lieah",
          state_id: "2728",
        },
        {
          id: "31445",
          name: "Liliani",
          state_id: "2728",
        },
        {
          id: "31446",
          name: "Lodhran",
          state_id: "2728",
        },
        {
          id: "31447",
          name: "Ludhewala Waraich",
          state_id: "2728",
        },
        {
          id: "31448",
          name: "Mailsi",
          state_id: "2728",
        },
        {
          id: "31449",
          name: "Makhdumpur",
          state_id: "2728",
        },
        {
          id: "31450",
          name: "Makhdumpur Rashid",
          state_id: "2728",
        },
        {
          id: "31451",
          name: "Malakwal",
          state_id: "2728",
        },
        {
          id: "31452",
          name: "Mamu Kanjan",
          state_id: "2728",
        },
        {
          id: "31453",
          name: "Mananwala Jodh Singh",
          state_id: "2728",
        },
        {
          id: "31454",
          name: "Mandi Bahauddin",
          state_id: "2728",
        },
        {
          id: "31455",
          name: "Mandi Sadiq Ganj",
          state_id: "2728",
        },
        {
          id: "31456",
          name: "Mangat",
          state_id: "2728",
        },
        {
          id: "31457",
          name: "Mangla",
          state_id: "2728",
        },
        {
          id: "31458",
          name: "Mankera",
          state_id: "2728",
        },
        {
          id: "31459",
          name: "Mian Channun",
          state_id: "2728",
        },
        {
          id: "31460",
          name: "Miani",
          state_id: "2728",
        },
        {
          id: "31461",
          name: "Mianwali",
          state_id: "2728",
        },
        {
          id: "31462",
          name: "Minchinabad",
          state_id: "2728",
        },
        {
          id: "31463",
          name: "Mitha Tiwana",
          state_id: "2728",
        },
        {
          id: "31464",
          name: "Multan",
          state_id: "2728",
        },
        {
          id: "31465",
          name: "Muridke",
          state_id: "2728",
        },
        {
          id: "31466",
          name: "Murree",
          state_id: "2728",
        },
        {
          id: "31467",
          name: "Mustafabad",
          state_id: "2728",
        },
        {
          id: "31468",
          name: "Muzaffargarh",
          state_id: "2728",
        },
        {
          id: "31469",
          name: "Nankana Sahib",
          state_id: "2728",
        },
        {
          id: "31470",
          name: "Narang",
          state_id: "2728",
        },
        {
          id: "31471",
          name: "Narowal",
          state_id: "2728",
        },
        {
          id: "31472",
          name: "Noorpur Thal",
          state_id: "2728",
        },
        {
          id: "31473",
          name: "Nowshera",
          state_id: "2728",
        },
        {
          id: "31474",
          name: "Nowshera Virkan",
          state_id: "2728",
        },
        {
          id: "31475",
          name: "Okara",
          state_id: "2728",
        },
        {
          id: "31476",
          name: "Pakpattan",
          state_id: "2728",
        },
        {
          id: "31477",
          name: "Pasrur",
          state_id: "2728",
        },
        {
          id: "31478",
          name: "Pattoki",
          state_id: "2728",
        },
        {
          id: "31479",
          name: "Phalia",
          state_id: "2728",
        },
        {
          id: "31480",
          name: "Phularwan",
          state_id: "2728",
        },
        {
          id: "31481",
          name: "Pind Dadan Khan",
          state_id: "2728",
        },
        {
          id: "31482",
          name: "Pindi Bhattian",
          state_id: "2728",
        },
        {
          id: "31483",
          name: "Pindi Gheb",
          state_id: "2728",
        },
        {
          id: "31484",
          name: "Pirmahal",
          state_id: "2728",
        },
        {
          id: "31485",
          name: "Qadirabad",
          state_id: "2728",
        },
        {
          id: "31486",
          name: "Qadirpur Ran",
          state_id: "2728",
        },
        {
          id: "31487",
          name: "Qila Disar Singh",
          state_id: "2728",
        },
        {
          id: "31488",
          name: "Qila Sobha Singh",
          state_id: "2728",
        },
        {
          id: "31489",
          name: "Quaidabad",
          state_id: "2728",
        },
        {
          id: "31490",
          name: "Rabwah",
          state_id: "2728",
        },
        {
          id: "31491",
          name: "Rahim Yar Khan",
          state_id: "2728",
        },
        {
          id: "31492",
          name: "Raiwind",
          state_id: "2728",
        },
        {
          id: "31493",
          name: "Raja Jang",
          state_id: "2728",
        },
        {
          id: "31494",
          name: "Rajanpur",
          state_id: "2728",
        },
        {
          id: "31495",
          name: "Rasulnagar",
          state_id: "2728",
        },
        {
          id: "31496",
          name: "Rawalpindi",
          state_id: "2728",
        },
        {
          id: "31497",
          name: "Renala Khurd",
          state_id: "2728",
        },
        {
          id: "31498",
          name: "Rojhan",
          state_id: "2728",
        },
        {
          id: "31499",
          name: "Saddar Gogera",
          state_id: "2728",
        },
        {
          id: "31500",
          name: "Sadiqabad",
          state_id: "2728",
        },
        {
          id: "31501",
          name: "Safdarabad",
          state_id: "2728",
        },
        {
          id: "31502",
          name: "Sahiwal",
          state_id: "2728",
        },
        {
          id: "31503",
          name: "Samasatta",
          state_id: "2728",
        },
        {
          id: "31504",
          name: "Sambrial",
          state_id: "2728",
        },
        {
          id: "31505",
          name: "Sammundri",
          state_id: "2728",
        },
        {
          id: "31506",
          name: "Sangala Hill",
          state_id: "2728",
        },
        {
          id: "31507",
          name: "Sanjwal",
          state_id: "2728",
        },
        {
          id: "31508",
          name: "Sarai Alamgir",
          state_id: "2728",
        },
        {
          id: "31509",
          name: "Sarai Sidhu",
          state_id: "2728",
        },
        {
          id: "31510",
          name: "Sargodha",
          state_id: "2728",
        },
        {
          id: "31511",
          name: "Shadiwal",
          state_id: "2728",
        },
        {
          id: "31512",
          name: "Shahkot",
          state_id: "2728",
        },
        {
          id: "31513",
          name: "Shahpur City",
          state_id: "2728",
        },
        {
          id: "31514",
          name: "Shahpur Saddar",
          state_id: "2728",
        },
        {
          id: "31515",
          name: "Shakargarh",
          state_id: "2728",
        },
        {
          id: "31516",
          name: "Sharqpur",
          state_id: "2728",
        },
        {
          id: "31517",
          name: "Shehr Sultan",
          state_id: "2728",
        },
        {
          id: "31518",
          name: "Shekhupura",
          state_id: "2728",
        },
        {
          id: "31519",
          name: "Shujaabad",
          state_id: "2728",
        },
        {
          id: "31520",
          name: "Sialkot",
          state_id: "2728",
        },
        {
          id: "31521",
          name: "Sillanwali",
          state_id: "2728",
        },
        {
          id: "31522",
          name: "Sodhra",
          state_id: "2728",
        },
        {
          id: "31523",
          name: "Sohawa",
          state_id: "2728",
        },
        {
          id: "31524",
          name: "Sukheke",
          state_id: "2728",
        },
        {
          id: "31525",
          name: "Talagang",
          state_id: "2728",
        },
        {
          id: "31526",
          name: "Tandlianwala",
          state_id: "2728",
        },
        {
          id: "31527",
          name: "Taunsa",
          state_id: "2728",
        },
        {
          id: "31528",
          name: "Taxila",
          state_id: "2728",
        },
        {
          id: "31529",
          name: "Tibba Sultanpur",
          state_id: "2728",
        },
        {
          id: "31530",
          name: "Toba Tek Singh",
          state_id: "2728",
        },
        {
          id: "31531",
          name: "Tulamba",
          state_id: "2728",
        },
        {
          id: "31532",
          name: "Uch",
          state_id: "2728",
        },
        {
          id: "31533",
          name: "Vihari",
          state_id: "2728",
        },
        {
          id: "31534",
          name: "Wah",
          state_id: "2728",
        },
        {
          id: "31535",
          name: "Warburton",
          state_id: "2728",
        },
        {
          id: "31536",
          name: "Wazirabad",
          state_id: "2728",
        },
        {
          id: "31537",
          name: "Yazman",
          state_id: "2728",
        },
        {
          id: "31538",
          name: "Zafarwal",
          state_id: "2728",
        },
        {
          id: "31539",
          name: "Zahir Pir",
          state_id: "2728",
        },
      ],
      Sind: [
        {
          id: "31540",
          name: "Adilpur",
          state_id: "2729",
        },
        {
          id: "31541",
          name: "Badah",
          state_id: "2729",
        },
        {
          id: "31542",
          name: "Badin",
          state_id: "2729",
        },
        {
          id: "31543",
          name: "Bagarji",
          state_id: "2729",
        },
        {
          id: "31544",
          name: "Bakshshapur",
          state_id: "2729",
        },
        {
          id: "31545",
          name: "Bandhi",
          state_id: "2729",
        },
        {
          id: "31546",
          name: "Berani",
          state_id: "2729",
        },
        {
          id: "31547",
          name: "Bhan",
          state_id: "2729",
        },
        {
          id: "31548",
          name: "Bhiria City",
          state_id: "2729",
        },
        {
          id: "31549",
          name: "Bhiria Road",
          state_id: "2729",
        },
        {
          id: "31550",
          name: "Bhit Shah",
          state_id: "2729",
        },
        {
          id: "31551",
          name: "Bozdar",
          state_id: "2729",
        },
        {
          id: "31552",
          name: "Bulri",
          state_id: "2729",
        },
        {
          id: "31553",
          name: "Chak",
          state_id: "2729",
        },
        {
          id: "31554",
          name: "Chambar",
          state_id: "2729",
        },
        {
          id: "31555",
          name: "Chohar Jamali",
          state_id: "2729",
        },
        {
          id: "31556",
          name: "Chor",
          state_id: "2729",
        },
        {
          id: "31557",
          name: "Dadu",
          state_id: "2729",
        },
        {
          id: "31558",
          name: "Daharki",
          state_id: "2729",
        },
        {
          id: "31559",
          name: "Daro",
          state_id: "2729",
        },
        {
          id: "31560",
          name: "Darya Khan Mari",
          state_id: "2729",
        },
        {
          id: "31561",
          name: "Daulatpur",
          state_id: "2729",
        },
        {
          id: "31562",
          name: "Daur",
          state_id: "2729",
        },
        {
          id: "31563",
          name: "Dhoronaro",
          state_id: "2729",
        },
        {
          id: "31564",
          name: "Digri",
          state_id: "2729",
        },
        {
          id: "31565",
          name: "Diplo",
          state_id: "2729",
        },
        {
          id: "31566",
          name: "Dokri",
          state_id: "2729",
        },
        {
          id: "31567",
          name: "Faqirabad",
          state_id: "2729",
        },
        {
          id: "31568",
          name: "Gambat",
          state_id: "2729",
        },
        {
          id: "31569",
          name: "Garello",
          state_id: "2729",
        },
        {
          id: "31570",
          name: "Garhi Khairo",
          state_id: "2729",
        },
        {
          id: "31571",
          name: "Garhi Yasin",
          state_id: "2729",
        },
        {
          id: "31572",
          name: "Gharo",
          state_id: "2729",
        },
        {
          id: "31573",
          name: "Ghauspur",
          state_id: "2729",
        },
        {
          id: "31574",
          name: "Ghotki",
          state_id: "2729",
        },
        {
          id: "31575",
          name: "Golarchi",
          state_id: "2729",
        },
        {
          id: "31576",
          name: "Guddu",
          state_id: "2729",
        },
        {
          id: "31577",
          name: "Gulistan-E-Jauhar",
          state_id: "2729",
        },
        {
          id: "31578",
          name: "Hala",
          state_id: "2729",
        },
        {
          id: "31579",
          name: "Hingorja",
          state_id: "2729",
        },
        {
          id: "31580",
          name: "Hyderabad",
          state_id: "2729",
        },
        {
          id: "31581",
          name: "Islamkot",
          state_id: "2729",
        },
        {
          id: "31582",
          name: "Jacobabad",
          state_id: "2729",
        },
        {
          id: "31583",
          name: "Jam Nawaz Ali",
          state_id: "2729",
        },
        {
          id: "31584",
          name: "Jam Sahib",
          state_id: "2729",
        },
        {
          id: "31585",
          name: "Jati",
          state_id: "2729",
        },
        {
          id: "31586",
          name: "Jhol",
          state_id: "2729",
        },
        {
          id: "31587",
          name: "Jhudo",
          state_id: "2729",
        },
        {
          id: "31588",
          name: "Johi",
          state_id: "2729",
        },
        {
          id: "31589",
          name: "Kadhan",
          state_id: "2729",
        },
        {
          id: "31590",
          name: "Kambar",
          state_id: "2729",
        },
        {
          id: "31591",
          name: "Kandhra",
          state_id: "2729",
        },
        {
          id: "31592",
          name: "Kandiari",
          state_id: "2729",
        },
        {
          id: "31593",
          name: "Kandiaro",
          state_id: "2729",
        },
        {
          id: "31594",
          name: "Karachi",
          state_id: "2729",
        },
        {
          id: "31595",
          name: "Karampur",
          state_id: "2729",
        },
        {
          id: "31596",
          name: "Kario Ghanwar",
          state_id: "2729",
        },
        {
          id: "31597",
          name: "Karoondi",
          state_id: "2729",
        },
        {
          id: "31598",
          name: "Kashmor",
          state_id: "2729",
        },
        {
          id: "31599",
          name: "Kazi Ahmad",
          state_id: "2729",
        },
        {
          id: "31600",
          name: "Keti Bandar",
          state_id: "2729",
        },
        {
          id: "31601",
          name: "Khadro",
          state_id: "2729",
        },
        {
          id: "31602",
          name: "Khairpur",
          state_id: "2729",
        },
        {
          id: "31603",
          name: "Khairpur Nathan Shah",
          state_id: "2729",
        },
        {
          id: "31604",
          name: "Khandh Kot",
          state_id: "2729",
        },
        {
          id: "31605",
          name: "Khanpur",
          state_id: "2729",
        },
        {
          id: "31606",
          name: "Khipro",
          state_id: "2729",
        },
        {
          id: "31607",
          name: "Khoski",
          state_id: "2729",
        },
        {
          id: "31608",
          name: "Khuhra",
          state_id: "2729",
        },
        {
          id: "31609",
          name: "Khyber",
          state_id: "2729",
        },
        {
          id: "31610",
          name: "Kot Diji",
          state_id: "2729",
        },
        {
          id: "31611",
          name: "Kot Ghulam Mohammad",
          state_id: "2729",
        },
        {
          id: "31612",
          name: "Kotri",
          state_id: "2729",
        },
        {
          id: "31613",
          name: "Kumb",
          state_id: "2729",
        },
        {
          id: "31614",
          name: "Kunri",
          state_id: "2729",
        },
        {
          id: "31615",
          name: "Lakhi",
          state_id: "2729",
        },
        {
          id: "31616",
          name: "Larkana",
          state_id: "2729",
        },
        {
          id: "31617",
          name: "Madeji",
          state_id: "2729",
        },
        {
          id: "31618",
          name: "Matiari",
          state_id: "2729",
        },
        {
          id: "31619",
          name: "Matli",
          state_id: "2729",
        },
        {
          id: "31620",
          name: "Mehar",
          state_id: "2729",
        },
        {
          id: "31621",
          name: "Mehrabpur",
          state_id: "2729",
        },
        {
          id: "31622",
          name: "Miro Khan",
          state_id: "2729",
        },
        {
          id: "31623",
          name: "Mirpur Bathoro",
          state_id: "2729",
        },
        {
          id: "31624",
          name: "Mirpur Khas",
          state_id: "2729",
        },
        {
          id: "31625",
          name: "Mirpur Mathelo",
          state_id: "2729",
        },
        {
          id: "31626",
          name: "Mirpur Sakro",
          state_id: "2729",
        },
        {
          id: "31627",
          name: "Mirwah",
          state_id: "2729",
        },
        {
          id: "31628",
          name: "Mithi",
          state_id: "2729",
        },
        {
          id: "31629",
          name: "Moro",
          state_id: "2729",
        },
        {
          id: "31630",
          name: "Nabisar",
          state_id: "2729",
        },
        {
          id: "31631",
          name: "Nasarpur",
          state_id: "2729",
        },
        {
          id: "31632",
          name: "Nasirabad",
          state_id: "2729",
        },
        {
          id: "31633",
          name: "Naudero",
          state_id: "2729",
        },
        {
          id: "31634",
          name: "Naukot",
          state_id: "2729",
        },
        {
          id: "31635",
          name: "Naushahro Firoz",
          state_id: "2729",
        },
        {
          id: "31636",
          name: "Nawabshah",
          state_id: "2729",
        },
        {
          id: "31637",
          name: "Oderolal Station",
          state_id: "2729",
        },
        {
          id: "31638",
          name: "Pacca Chang",
          state_id: "2729",
        },
        {
          id: "31639",
          name: "Padidan",
          state_id: "2729",
        },
        {
          id: "31640",
          name: "Pano Aqil",
          state_id: "2729",
        },
        {
          id: "31641",
          name: "Perumal",
          state_id: "2729",
        },
        {
          id: "31642",
          name: "Phulji",
          state_id: "2729",
        },
        {
          id: "31643",
          name: "Pirjo Goth",
          state_id: "2729",
        },
        {
          id: "31644",
          name: "Piryaloi",
          state_id: "2729",
        },
        {
          id: "31645",
          name: "Pithoro",
          state_id: "2729",
        },
        {
          id: "31646",
          name: "Radhan",
          state_id: "2729",
        },
        {
          id: "31647",
          name: "Rajo Khanani",
          state_id: "2729",
        },
        {
          id: "31648",
          name: "Ranipur",
          state_id: "2729",
        },
        {
          id: "31649",
          name: "Ratodero",
          state_id: "2729",
        },
        {
          id: "31650",
          name: "Rohri",
          state_id: "2729",
        },
        {
          id: "31651",
          name: "Rustam",
          state_id: "2729",
        },
        {
          id: "31652",
          name: "Saeedabad",
          state_id: "2729",
        },
        {
          id: "31653",
          name: "Sakrand",
          state_id: "2729",
        },
        {
          id: "31654",
          name: "Samaro",
          state_id: "2729",
        },
        {
          id: "31655",
          name: "Sanghar",
          state_id: "2729",
        },
        {
          id: "31656",
          name: "Sann",
          state_id: "2729",
        },
        {
          id: "31657",
          name: "Sarhari",
          state_id: "2729",
        },
        {
          id: "31658",
          name: "Sehwan",
          state_id: "2729",
        },
        {
          id: "31659",
          name: "Setharja",
          state_id: "2729",
        },
        {
          id: "31660",
          name: "Shah Dipalli",
          state_id: "2729",
        },
        {
          id: "31661",
          name: "Shahdadkot",
          state_id: "2729",
        },
        {
          id: "31662",
          name: "Shahdadpur",
          state_id: "2729",
        },
        {
          id: "31663",
          name: "Shahpur Chakar",
          state_id: "2729",
        },
        {
          id: "31664",
          name: "Shahpur Jahania",
          state_id: "2729",
        },
        {
          id: "31665",
          name: "Shikarpur",
          state_id: "2729",
        },
        {
          id: "31666",
          name: "Sinjhoro",
          state_id: "2729",
        },
        {
          id: "31667",
          name: "Sita Road",
          state_id: "2729",
        },
        {
          id: "31668",
          name: "Sobhodero",
          state_id: "2729",
        },
        {
          id: "31669",
          name: "Sujawal",
          state_id: "2729",
        },
        {
          id: "31670",
          name: "Sukkur",
          state_id: "2729",
        },
        {
          id: "31671",
          name: "Talhar",
          state_id: "2729",
        },
        {
          id: "31672",
          name: "Tando Adam",
          state_id: "2729",
        },
        {
          id: "31673",
          name: "Tando Allah Yar",
          state_id: "2729",
        },
        {
          id: "31674",
          name: "Tando Bagho",
          state_id: "2729",
        },
        {
          id: "31675",
          name: "Tando Ghulam Ali",
          state_id: "2729",
        },
        {
          id: "31676",
          name: "Tando Jam",
          state_id: "2729",
        },
        {
          id: "31677",
          name: "Tando Jan Mohammad",
          state_id: "2729",
        },
        {
          id: "31678",
          name: "Tando Mitha Khan",
          state_id: "2729",
        },
        {
          id: "31679",
          name: "Tando Muhammad Khan",
          state_id: "2729",
        },
        {
          id: "31680",
          name: "Tangwani",
          state_id: "2729",
        },
        {
          id: "31681",
          name: "Thano Bula Khan",
          state_id: "2729",
        },
        {
          id: "31682",
          name: "Thari Mirwah",
          state_id: "2729",
        },
        {
          id: "31683",
          name: "Tharushah",
          state_id: "2729",
        },
        {
          id: "31684",
          name: "Thatta",
          state_id: "2729",
        },
        {
          id: "31685",
          name: "Ther I",
          state_id: "2729",
        },
        {
          id: "31686",
          name: "Ther I Mohabat",
          state_id: "2729",
        },
        {
          id: "31687",
          name: "Thul",
          state_id: "2729",
        },
        {
          id: "31688",
          name: "Ubauro",
          state_id: "2729",
        },
        {
          id: "31689",
          name: "Umarkot",
          state_id: "2729",
        },
        {
          id: "31690",
          name: "Warah",
          state_id: "2729",
        },
      ],
    },
  },
  PL: {
    name: "Poland",
    native: "Polska",
    phone: "48",
    continent: "EU",
    capital: "Warsaw",
    currency: "PLN",
    languages: ["pl"],
    emoji: "🇵🇱",
    emojiU: "U+1F1F5 U+1F1F1",
    states: {
      "Biale Blota": [],
      Dobroszyce: [
        {
          id: "32253",
          name: "Fabryczna",
          state_id: "2861",
        },
      ],
      Dolnoslaskie: [
        {
          id: "32254",
          name: "Bielawa",
          state_id: "2862",
        },
        {
          id: "32255",
          name: "Bogatynia",
          state_id: "2862",
        },
        {
          id: "32256",
          name: "Boguszow-Gorce",
          state_id: "2862",
        },
        {
          id: "32257",
          name: "Boleslawiec",
          state_id: "2862",
        },
        {
          id: "32258",
          name: "Brzeg Dolny",
          state_id: "2862",
        },
        {
          id: "32259",
          name: "Bystrzyca Klodzka",
          state_id: "2862",
        },
        {
          id: "32260",
          name: "Chojnow",
          state_id: "2862",
        },
        {
          id: "32261",
          name: "Dzierzoniow",
          state_id: "2862",
        },
        {
          id: "32262",
          name: "Glogow",
          state_id: "2862",
        },
        {
          id: "32263",
          name: "Gora",
          state_id: "2862",
        },
        {
          id: "32264",
          name: "Jawor",
          state_id: "2862",
        },
        {
          id: "32265",
          name: "Jelcz-Laskowice",
          state_id: "2862",
        },
        {
          id: "32266",
          name: "Jelenia Gora",
          state_id: "2862",
        },
        {
          id: "32267",
          name: "Kamienna Gora",
          state_id: "2862",
        },
        {
          id: "32268",
          name: "Klodzko",
          state_id: "2862",
        },
        {
          id: "32269",
          name: "Kowary",
          state_id: "2862",
        },
        {
          id: "32270",
          name: "Kudowa-Zdroj",
          state_id: "2862",
        },
        {
          id: "32271",
          name: "Legnica",
          state_id: "2862",
        },
        {
          id: "32272",
          name: "Luban",
          state_id: "2862",
        },
        {
          id: "32273",
          name: "Lubin",
          state_id: "2862",
        },
        {
          id: "32274",
          name: "Lwowek Slaski",
          state_id: "2862",
        },
        {
          id: "32275",
          name: "Milicz",
          state_id: "2862",
        },
        {
          id: "32276",
          name: "Nowa Ruda",
          state_id: "2862",
        },
        {
          id: "32277",
          name: "Olawa",
          state_id: "2862",
        },
        {
          id: "32278",
          name: "Olesnica",
          state_id: "2862",
        },
        {
          id: "32279",
          name: "Piechowice",
          state_id: "2862",
        },
        {
          id: "32280",
          name: "Pieszyce",
          state_id: "2862",
        },
        {
          id: "32281",
          name: "Polkowice",
          state_id: "2862",
        },
        {
          id: "32282",
          name: "Strzegom",
          state_id: "2862",
        },
        {
          id: "32283",
          name: "Strzelin",
          state_id: "2862",
        },
        {
          id: "32284",
          name: "Swidnica",
          state_id: "2862",
        },
        {
          id: "32285",
          name: "Swiebodzice",
          state_id: "2862",
        },
        {
          id: "32286",
          name: "Sycow",
          state_id: "2862",
        },
        {
          id: "32287",
          name: "Trzebnica",
          state_id: "2862",
        },
        {
          id: "32288",
          name: "Walbrzych",
          state_id: "2862",
        },
        {
          id: "32289",
          name: "Wolow",
          state_id: "2862",
        },
        {
          id: "32290",
          name: "Wroclaw",
          state_id: "2862",
        },
        {
          id: "32291",
          name: "Zabkowice Slaskie",
          state_id: "2862",
        },
        {
          id: "32292",
          name: "Zgorzelec",
          state_id: "2862",
        },
        {
          id: "32293",
          name: "Ziebice",
          state_id: "2862",
        },
        {
          id: "32294",
          name: "Zlotoryja",
          state_id: "2862",
        },
      ],
      "Dziekanow Lesny": [],
      Hopowo: [
        {
          id: "32295",
          name: "Hopowo",
          state_id: "2864",
        },
      ],
      Kartuzy: [
        {
          id: "32296",
          name: "Chwaszczyno",
          state_id: "2865",
        },
      ],
      Koscian: [
        {
          id: "32297",
          name: "Smigiel",
          state_id: "2866",
        },
      ],
      Krakow: [
        {
          id: "32298",
          name: "Jerzmanowice",
          state_id: "2867",
        },
        {
          id: "32299",
          name: "Zabierzow",
          state_id: "2867",
        },
      ],
      "Kujawsko-Pomorskie": [
        {
          id: "32300",
          name: "Aleksandrow Kujawski",
          state_id: "2868",
        },
        {
          id: "32301",
          name: "Brodnica",
          state_id: "2868",
        },
        {
          id: "32302",
          name: "Bydgoszcz",
          state_id: "2868",
        },
        {
          id: "32303",
          name: "Chelmno",
          state_id: "2868",
        },
        {
          id: "32304",
          name: "Chelmza",
          state_id: "2868",
        },
        {
          id: "32305",
          name: "Ciechocinek",
          state_id: "2868",
        },
        {
          id: "32306",
          name: "Golub-Dobrzyn",
          state_id: "2868",
        },
        {
          id: "32307",
          name: "Grudziadz",
          state_id: "2868",
        },
        {
          id: "32308",
          name: "Inowroclaw",
          state_id: "2868",
        },
        {
          id: "32309",
          name: "Janikowo",
          state_id: "2868",
        },
        {
          id: "32310",
          name: "Koronowo",
          state_id: "2868",
        },
        {
          id: "32311",
          name: "Kruszwica",
          state_id: "2868",
        },
        {
          id: "32312",
          name: "Lipno",
          state_id: "2868",
        },
        {
          id: "32313",
          name: "Mogilno",
          state_id: "2868",
        },
        {
          id: "32314",
          name: "Naklo nad Notecia",
          state_id: "2868",
        },
        {
          id: "32315",
          name: "Radziejow",
          state_id: "2868",
        },
        {
          id: "32316",
          name: "Rypin",
          state_id: "2868",
        },
        {
          id: "32317",
          name: "Sepolno Krajenskie",
          state_id: "2868",
        },
        {
          id: "32318",
          name: "Solec Kujawski",
          state_id: "2868",
        },
        {
          id: "32319",
          name: "Swiecie",
          state_id: "2868",
        },
        {
          id: "32320",
          name: "Szubin",
          state_id: "2868",
        },
        {
          id: "32321",
          name: "Torun",
          state_id: "2868",
        },
        {
          id: "32322",
          name: "Tuchola",
          state_id: "2868",
        },
        {
          id: "32323",
          name: "Wabrzezno",
          state_id: "2868",
        },
        {
          id: "32324",
          name: "Wloclawek",
          state_id: "2868",
        },
        {
          id: "32325",
          name: "Znin",
          state_id: "2868",
        },
      ],
      Lodzkie: [
        {
          id: "32326",
          name: "Aleksandrow Lodzki",
          state_id: "2869",
        },
        {
          id: "32327",
          name: "Belchatow",
          state_id: "2869",
        },
        {
          id: "32328",
          name: "Bratoszewice",
          state_id: "2869",
        },
        {
          id: "32329",
          name: "Brzeziny",
          state_id: "2869",
        },
        {
          id: "32330",
          name: "Glowno",
          state_id: "2869",
        },
        {
          id: "32331",
          name: "Koluszki",
          state_id: "2869",
        },
        {
          id: "32332",
          name: "Konstantynow Lodzki",
          state_id: "2869",
        },
        {
          id: "32333",
          name: "Kutno",
          state_id: "2869",
        },
        {
          id: "32334",
          name: "Lask",
          state_id: "2869",
        },
        {
          id: "32335",
          name: "Leczyca",
          state_id: "2869",
        },
        {
          id: "32336",
          name: "Lodz",
          state_id: "2869",
        },
        {
          id: "32337",
          name: "Lowicz",
          state_id: "2869",
        },
        {
          id: "32338",
          name: "Opoczno",
          state_id: "2869",
        },
        {
          id: "32339",
          name: "Ozorkow",
          state_id: "2869",
        },
        {
          id: "32340",
          name: "Pabianice",
          state_id: "2869",
        },
        {
          id: "32341",
          name: "Piotrkow Trybunalski",
          state_id: "2869",
        },
        {
          id: "32342",
          name: "Radomsko",
          state_id: "2869",
        },
        {
          id: "32343",
          name: "Rawa Mazowiecka",
          state_id: "2869",
        },
        {
          id: "32344",
          name: "Sieradz",
          state_id: "2869",
        },
        {
          id: "32345",
          name: "Skierniewice",
          state_id: "2869",
        },
        {
          id: "32346",
          name: "Tomaszow Mazowiecki",
          state_id: "2869",
        },
        {
          id: "32347",
          name: "Tuszyn",
          state_id: "2869",
        },
        {
          id: "32348",
          name: "Wielun",
          state_id: "2869",
        },
        {
          id: "32349",
          name: "Zdunska Wola",
          state_id: "2869",
        },
        {
          id: "32350",
          name: "Zgierz",
          state_id: "2869",
        },
        {
          id: "32351",
          name: "Zychlin",
          state_id: "2869",
        },
      ],
      Lubelskie: [
        {
          id: "32352",
          name: "Biala Podlaska",
          state_id: "2870",
        },
        {
          id: "32353",
          name: "Bilgoraj",
          state_id: "2870",
        },
        {
          id: "32354",
          name: "Chelm",
          state_id: "2870",
        },
        {
          id: "32355",
          name: "Deblin",
          state_id: "2870",
        },
        {
          id: "32356",
          name: "Hrubieszow",
          state_id: "2870",
        },
        {
          id: "32357",
          name: "Janow Lubelski",
          state_id: "2870",
        },
        {
          id: "32358",
          name: "Krasnik",
          state_id: "2870",
        },
        {
          id: "32359",
          name: "Krasnystaw",
          state_id: "2870",
        },
        {
          id: "32360",
          name: "Leczna",
          state_id: "2870",
        },
        {
          id: "32361",
          name: "Lubartow",
          state_id: "2870",
        },
        {
          id: "32362",
          name: "Lublin",
          state_id: "2870",
        },
        {
          id: "32363",
          name: "Lukow",
          state_id: "2870",
        },
        {
          id: "32364",
          name: "Miedzyrzec Podlaski",
          state_id: "2870",
        },
        {
          id: "32365",
          name: "Opole Lubelskie",
          state_id: "2870",
        },
        {
          id: "32366",
          name: "Parczew",
          state_id: "2870",
        },
        {
          id: "32367",
          name: "Poniatowa",
          state_id: "2870",
        },
        {
          id: "32368",
          name: "Pulawy",
          state_id: "2870",
        },
        {
          id: "32369",
          name: "Radzyn Podlaski",
          state_id: "2870",
        },
        {
          id: "32370",
          name: "Ryki",
          state_id: "2870",
        },
        {
          id: "32371",
          name: "Swidnik",
          state_id: "2870",
        },
        {
          id: "32372",
          name: "Tomaszow Lubelski",
          state_id: "2870",
        },
        {
          id: "32373",
          name: "Wlodawa",
          state_id: "2870",
        },
        {
          id: "32374",
          name: "Zamosc",
          state_id: "2870",
        },
      ],
      Lubuskie: [
        {
          id: "32375",
          name: "Drezdenko",
          state_id: "2871",
        },
        {
          id: "32376",
          name: "Gorzow Wielkopolski",
          state_id: "2871",
        },
        {
          id: "32377",
          name: "Gubin",
          state_id: "2871",
        },
        {
          id: "32378",
          name: "Kostrzyn",
          state_id: "2871",
        },
        {
          id: "32379",
          name: "Kozuchow",
          state_id: "2871",
        },
        {
          id: "32380",
          name: "Krosno Odrzanskie",
          state_id: "2871",
        },
        {
          id: "32381",
          name: "Lubsko",
          state_id: "2871",
        },
        {
          id: "32382",
          name: "Miedzyrzecz",
          state_id: "2871",
        },
        {
          id: "32383",
          name: "Nowa Sol",
          state_id: "2871",
        },
        {
          id: "32384",
          name: "Skwierzyna",
          state_id: "2871",
        },
        {
          id: "32385",
          name: "Slubice",
          state_id: "2871",
        },
        {
          id: "32386",
          name: "Strzelce Krajenskie",
          state_id: "2871",
        },
        {
          id: "32387",
          name: "Sulechow",
          state_id: "2871",
        },
        {
          id: "32388",
          name: "Sulecin",
          state_id: "2871",
        },
        {
          id: "32389",
          name: "Swiebodzin",
          state_id: "2871",
        },
        {
          id: "32390",
          name: "Szprotawa",
          state_id: "2871",
        },
        {
          id: "32391",
          name: "Wschowa",
          state_id: "2871",
        },
        {
          id: "32392",
          name: "Zagan",
          state_id: "2871",
        },
        {
          id: "32393",
          name: "Zary",
          state_id: "2871",
        },
        {
          id: "32394",
          name: "Zielona Gora",
          state_id: "2871",
        },
      ],
      Malomice: [
        {
          id: "32395",
          name: "Malomice",
          state_id: "2872",
        },
      ],
      Malopolskie: [
        {
          id: "32396",
          name: "Andrychow",
          state_id: "2873",
        },
        {
          id: "32397",
          name: "Bochnia",
          state_id: "2873",
        },
        {
          id: "32398",
          name: "Brzesko",
          state_id: "2873",
        },
        {
          id: "32399",
          name: "Brzeszcze",
          state_id: "2873",
        },
        {
          id: "32400",
          name: "Bukowno",
          state_id: "2873",
        },
        {
          id: "32401",
          name: "Chelmek",
          state_id: "2873",
        },
        {
          id: "32402",
          name: "Chrzanow",
          state_id: "2873",
        },
        {
          id: "32403",
          name: "Dabrowa Tarnowska",
          state_id: "2873",
        },
        {
          id: "32404",
          name: "Gorlice",
          state_id: "2873",
        },
        {
          id: "32405",
          name: "Kety",
          state_id: "2873",
        },
        {
          id: "32406",
          name: "Krakow",
          state_id: "2873",
        },
        {
          id: "32407",
          name: "Krynica",
          state_id: "2873",
        },
        {
          id: "32408",
          name: "Krzeszowice",
          state_id: "2873",
        },
        {
          id: "32409",
          name: "Libiaz",
          state_id: "2873",
        },
        {
          id: "32410",
          name: "Limanowa",
          state_id: "2873",
        },
        {
          id: "32411",
          name: "Miechow",
          state_id: "2873",
        },
        {
          id: "32412",
          name: "Myslenice",
          state_id: "2873",
        },
        {
          id: "32413",
          name: "Nowy Sacz",
          state_id: "2873",
        },
        {
          id: "32414",
          name: "Nowy Targ",
          state_id: "2873",
        },
        {
          id: "32415",
          name: "Olkusz",
          state_id: "2873",
        },
        {
          id: "32416",
          name: "Oswiecim",
          state_id: "2873",
        },
        {
          id: "32417",
          name: "Poronin",
          state_id: "2873",
        },
        {
          id: "32418",
          name: "Rabka",
          state_id: "2873",
        },
        {
          id: "32419",
          name: "Skawina",
          state_id: "2873",
        },
        {
          id: "32420",
          name: "Stary Sacz",
          state_id: "2873",
        },
        {
          id: "32421",
          name: "Sucha Beskidzka",
          state_id: "2873",
        },
        {
          id: "32422",
          name: "Tarnow",
          state_id: "2873",
        },
        {
          id: "32423",
          name: "Trzebinia",
          state_id: "2873",
        },
        {
          id: "32424",
          name: "Wadowice",
          state_id: "2873",
        },
        {
          id: "32425",
          name: "Wieliczka",
          state_id: "2873",
        },
        {
          id: "32426",
          name: "Wolbrom",
          state_id: "2873",
        },
        {
          id: "32427",
          name: "Zakopane",
          state_id: "2873",
        },
      ],
      Mazowieckie: [
        {
          id: "32428",
          name: "Blonie",
          state_id: "2874",
        },
        {
          id: "32429",
          name: "Brwinow",
          state_id: "2874",
        },
        {
          id: "32430",
          name: "Ciechanow",
          state_id: "2874",
        },
        {
          id: "32431",
          name: "Garwolin",
          state_id: "2874",
        },
        {
          id: "32432",
          name: "Gora Kalwaria",
          state_id: "2874",
        },
        {
          id: "32433",
          name: "Gostynin",
          state_id: "2874",
        },
        {
          id: "32434",
          name: "Grodzisk Mazowiecki",
          state_id: "2874",
        },
        {
          id: "32435",
          name: "Grojec",
          state_id: "2874",
        },
        {
          id: "32436",
          name: "Jozefow",
          state_id: "2874",
        },
        {
          id: "32437",
          name: "Karczew",
          state_id: "2874",
        },
        {
          id: "32438",
          name: "Kobylka",
          state_id: "2874",
        },
        {
          id: "32439",
          name: "Konstancin-Jeziorna",
          state_id: "2874",
        },
        {
          id: "32440",
          name: "Kozienice",
          state_id: "2874",
        },
        {
          id: "32441",
          name: "Legionowo",
          state_id: "2874",
        },
        {
          id: "32442",
          name: "Lomianki",
          state_id: "2874",
        },
        {
          id: "32443",
          name: "Makow Mazowiecki",
          state_id: "2874",
        },
        {
          id: "32444",
          name: "Marki",
          state_id: "2874",
        },
        {
          id: "32445",
          name: "Milanowek",
          state_id: "2874",
        },
        {
          id: "32446",
          name: "Minsk Mazowiecki",
          state_id: "2874",
        },
        {
          id: "32447",
          name: "Mlawa",
          state_id: "2874",
        },
        {
          id: "32448",
          name: "Nowy Dwor Mazowiecki",
          state_id: "2874",
        },
        {
          id: "32449",
          name: "Ostroleka",
          state_id: "2874",
        },
        {
          id: "32450",
          name: "Ostrow Mazowiecka",
          state_id: "2874",
        },
        {
          id: "32451",
          name: "Otwock",
          state_id: "2874",
        },
        {
          id: "32452",
          name: "Piaseczno",
          state_id: "2874",
        },
        {
          id: "32453",
          name: "Piastow",
          state_id: "2874",
        },
        {
          id: "32454",
          name: "Pionki",
          state_id: "2874",
        },
        {
          id: "32455",
          name: "Plock",
          state_id: "2874",
        },
        {
          id: "32456",
          name: "Plonsk",
          state_id: "2874",
        },
        {
          id: "32457",
          name: "Pruszkow",
          state_id: "2874",
        },
        {
          id: "32458",
          name: "Przasnysz",
          state_id: "2874",
        },
        {
          id: "32459",
          name: "Pultusk",
          state_id: "2874",
        },
        {
          id: "32460",
          name: "Radom",
          state_id: "2874",
        },
        {
          id: "32461",
          name: "Siedlce",
          state_id: "2874",
        },
        {
          id: "32462",
          name: "Sierpc",
          state_id: "2874",
        },
        {
          id: "32463",
          name: "Sochaczew",
          state_id: "2874",
        },
        {
          id: "32464",
          name: "Sokolow Podlaski",
          state_id: "2874",
        },
        {
          id: "32465",
          name: "Sulejowek",
          state_id: "2874",
        },
        {
          id: "32466",
          name: "Szydlowiec",
          state_id: "2874",
        },
        {
          id: "32467",
          name: "Warka",
          state_id: "2874",
        },
        {
          id: "32468",
          name: "Warszawa",
          state_id: "2874",
        },
        {
          id: "32469",
          name: "Wegrow",
          state_id: "2874",
        },
        {
          id: "32470",
          name: "Wesola",
          state_id: "2874",
        },
        {
          id: "32471",
          name: "Wolomin",
          state_id: "2874",
        },
        {
          id: "32472",
          name: "Wyszkow",
          state_id: "2874",
        },
        {
          id: "32473",
          name: "Zabki",
          state_id: "2874",
        },
        {
          id: "32474",
          name: "Zielonka",
          state_id: "2874",
        },
        {
          id: "32475",
          name: "Zyrardow",
          state_id: "2874",
        },
      ],
      Mirkow: [
        {
          id: "32476",
          name: "Dlugoteka",
          state_id: "2875",
        },
      ],
      Opolskie: [
        {
          id: "32477",
          name: "Brzeg",
          state_id: "2876",
        },
        {
          id: "32478",
          name: "Glubczyce",
          state_id: "2876",
        },
        {
          id: "32479",
          name: "Glucholazy",
          state_id: "2876",
        },
        {
          id: "32480",
          name: "Grodkow",
          state_id: "2876",
        },
        {
          id: "32481",
          name: "Kedzierzyn-Kozle",
          state_id: "2876",
        },
        {
          id: "32482",
          name: "Kluczbork",
          state_id: "2876",
        },
        {
          id: "32483",
          name: "Krapkowice",
          state_id: "2876",
        },
        {
          id: "32484",
          name: "Namyslow",
          state_id: "2876",
        },
        {
          id: "32485",
          name: "Niemodlin",
          state_id: "2876",
        },
        {
          id: "32486",
          name: "Nysa",
          state_id: "2876",
        },
        {
          id: "32487",
          name: "Olesno",
          state_id: "2876",
        },
        {
          id: "32488",
          name: "Opole",
          state_id: "2876",
        },
        {
          id: "32489",
          name: "Ozimek",
          state_id: "2876",
        },
        {
          id: "32490",
          name: "Prudnik",
          state_id: "2876",
        },
        {
          id: "32491",
          name: "Strzelce Opolskie",
          state_id: "2876",
        },
        {
          id: "32492",
          name: "Zawadzkie",
          state_id: "2876",
        },
        {
          id: "32493",
          name: "Zdzieszowice",
          state_id: "2876",
        },
      ],
      Ostrowiec: [
        {
          id: "32494",
          name: "Cmielow",
          state_id: "2877",
        },
      ],
      Podkarpackie: [
        {
          id: "32495",
          name: "Debica",
          state_id: "2878",
        },
        {
          id: "32496",
          name: "Jaroslaw",
          state_id: "2878",
        },
        {
          id: "32497",
          name: "Jaslo",
          state_id: "2878",
        },
        {
          id: "32498",
          name: "Krosno",
          state_id: "2878",
        },
        {
          id: "32499",
          name: "Lancut",
          state_id: "2878",
        },
        {
          id: "32500",
          name: "Lezajsk",
          state_id: "2878",
        },
        {
          id: "32501",
          name: "Lubaczow",
          state_id: "2878",
        },
        {
          id: "32502",
          name: "Mielec",
          state_id: "2878",
        },
        {
          id: "32503",
          name: "Nisko",
          state_id: "2878",
        },
        {
          id: "32504",
          name: "Nowa Deba",
          state_id: "2878",
        },
        {
          id: "32505",
          name: "Przemysl",
          state_id: "2878",
        },
        {
          id: "32506",
          name: "Przeworsk",
          state_id: "2878",
        },
        {
          id: "32507",
          name: "Ropczyce",
          state_id: "2878",
        },
        {
          id: "32508",
          name: "Rzeszow",
          state_id: "2878",
        },
        {
          id: "32509",
          name: "Sanok",
          state_id: "2878",
        },
        {
          id: "32510",
          name: "Stalowa Wola",
          state_id: "2878",
        },
        {
          id: "32511",
          name: "Tarnobrzeg",
          state_id: "2878",
        },
        {
          id: "32512",
          name: "Ustrzyki Dolne",
          state_id: "2878",
        },
      ],
      Podlaskie: [
        {
          id: "32513",
          name: "Augustow",
          state_id: "2879",
        },
        {
          id: "32514",
          name: "Bialystok",
          state_id: "2879",
        },
        {
          id: "32515",
          name: "Bielsk Podlaski",
          state_id: "2879",
        },
        {
          id: "32516",
          name: "Czarna Bialostocka",
          state_id: "2879",
        },
        {
          id: "32517",
          name: "Grajewo",
          state_id: "2879",
        },
        {
          id: "32518",
          name: "Hajnowka",
          state_id: "2879",
        },
        {
          id: "32519",
          name: "Kolno",
          state_id: "2879",
        },
        {
          id: "32520",
          name: "Lapy",
          state_id: "2879",
        },
        {
          id: "32521",
          name: "Lomza",
          state_id: "2879",
        },
        {
          id: "32522",
          name: "Monki",
          state_id: "2879",
        },
        {
          id: "32523",
          name: "Siemiatycze",
          state_id: "2879",
        },
        {
          id: "32524",
          name: "Sokolka",
          state_id: "2879",
        },
        {
          id: "32525",
          name: "Suwalki",
          state_id: "2879",
        },
        {
          id: "32526",
          name: "Wysokie Mazowieckie",
          state_id: "2879",
        },
        {
          id: "32527",
          name: "Zambrow",
          state_id: "2879",
        },
      ],
      Polska: [
        {
          id: "32528",
          name: "Bogumilowice",
          state_id: "2880",
        },
      ],
      Pomorskie: [
        {
          id: "32529",
          name: "Bytow",
          state_id: "2881",
        },
        {
          id: "32530",
          name: "Chojnice",
          state_id: "2881",
        },
        {
          id: "32531",
          name: "Czersk",
          state_id: "2881",
        },
        {
          id: "32532",
          name: "Czluchow",
          state_id: "2881",
        },
        {
          id: "32533",
          name: "Gdansk",
          state_id: "2881",
        },
        {
          id: "32534",
          name: "Gdynia",
          state_id: "2881",
        },
        {
          id: "32535",
          name: "Kartuzy",
          state_id: "2881",
        },
        {
          id: "32536",
          name: "Koscierzyna",
          state_id: "2881",
        },
        {
          id: "32537",
          name: "Kwidzyn",
          state_id: "2881",
        },
        {
          id: "32538",
          name: "Lebork",
          state_id: "2881",
        },
        {
          id: "32539",
          name: "Malbork",
          state_id: "2881",
        },
        {
          id: "32540",
          name: "Miastko",
          state_id: "2881",
        },
        {
          id: "32541",
          name: "Nowy Dwor Gdanski",
          state_id: "2881",
        },
        {
          id: "32542",
          name: "Pruszcz Gdanski",
          state_id: "2881",
        },
        {
          id: "32543",
          name: "Puck",
          state_id: "2881",
        },
        {
          id: "32544",
          name: "Reda",
          state_id: "2881",
        },
        {
          id: "32545",
          name: "Rumia",
          state_id: "2881",
        },
        {
          id: "32546",
          name: "Slupsk",
          state_id: "2881",
        },
        {
          id: "32547",
          name: "Sopot",
          state_id: "2881",
        },
        {
          id: "32548",
          name: "Starogard Gdanski",
          state_id: "2881",
        },
        {
          id: "32549",
          name: "Sztum",
          state_id: "2881",
        },
        {
          id: "32550",
          name: "Tczew",
          state_id: "2881",
        },
        {
          id: "32551",
          name: "Ustka",
          state_id: "2881",
        },
        {
          id: "32552",
          name: "Wejherowo",
          state_id: "2881",
        },
        {
          id: "32553",
          name: "Wladyslawowo",
          state_id: "2881",
        },
      ],
      Poznan: [
        {
          id: "32554",
          name: "Komorniki",
          state_id: "2882",
        },
        {
          id: "32555",
          name: "Steszew",
          state_id: "2882",
        },
      ],
      Pruszkow: [
        {
          id: "32556",
          name: "Raszyn",
          state_id: "2883",
        },
      ],
      Rymanowska: [
        {
          id: "32557",
          name: "Rymanowska",
          state_id: "2884",
        },
      ],
      Rzeszow: [
        {
          id: "32558",
          name: "Glogow Malopolski",
          state_id: "2885",
        },
      ],
      Slaskie: [
        {
          id: "32559",
          name: "Bedzin",
          state_id: "2886",
        },
        {
          id: "32560",
          name: "Bielsko-Biala",
          state_id: "2886",
        },
        {
          id: "32561",
          name: "Bierun",
          state_id: "2886",
        },
        {
          id: "32562",
          name: "Blachowania",
          state_id: "2886",
        },
        {
          id: "32563",
          name: "Bytom",
          state_id: "2886",
        },
        {
          id: "32564",
          name: "Chorzow",
          state_id: "2886",
        },
        {
          id: "32565",
          name: "Cieszyn",
          state_id: "2886",
        },
        {
          id: "32566",
          name: "Czechowice-Dziedzice",
          state_id: "2886",
        },
        {
          id: "32567",
          name: "Czeladz",
          state_id: "2886",
        },
        {
          id: "32568",
          name: "Czerwionka-Leszczyny",
          state_id: "2886",
        },
        {
          id: "32569",
          name: "Czestochowa",
          state_id: "2886",
        },
        {
          id: "32570",
          name: "Dabrowa Gornicza",
          state_id: "2886",
        },
        {
          id: "32571",
          name: "Gliwice",
          state_id: "2886",
        },
        {
          id: "32572",
          name: "Jastrzebie-Zdroj",
          state_id: "2886",
        },
        {
          id: "32573",
          name: "Jaworzno",
          state_id: "2886",
        },
        {
          id: "32574",
          name: "Kalety",
          state_id: "2886",
        },
        {
          id: "32575",
          name: "Katowice",
          state_id: "2886",
        },
        {
          id: "32576",
          name: "Klobuck",
          state_id: "2886",
        },
        {
          id: "32577",
          name: "Knurow",
          state_id: "2886",
        },
        {
          id: "32578",
          name: "Laziska Gorne",
          state_id: "2886",
        },
        {
          id: "32579",
          name: "Ledziny",
          state_id: "2886",
        },
        {
          id: "32580",
          name: "Lubliniec",
          state_id: "2886",
        },
        {
          id: "32581",
          name: "Mikolow",
          state_id: "2886",
        },
        {
          id: "32582",
          name: "Myslowice",
          state_id: "2886",
        },
        {
          id: "32583",
          name: "Myszkow",
          state_id: "2886",
        },
        {
          id: "32584",
          name: "Orzesze",
          state_id: "2886",
        },
        {
          id: "32585",
          name: "Piekary Slaskie",
          state_id: "2886",
        },
        {
          id: "32586",
          name: "Poreba",
          state_id: "2886",
        },
        {
          id: "32587",
          name: "Pszczyna",
          state_id: "2886",
        },
        {
          id: "32588",
          name: "Pszow",
          state_id: "2886",
        },
        {
          id: "32589",
          name: "Pyskowice",
          state_id: "2886",
        },
        {
          id: "32590",
          name: "Raciborz",
          state_id: "2886",
        },
        {
          id: "32591",
          name: "Radlin",
          state_id: "2886",
        },
        {
          id: "32592",
          name: "Radzionkow",
          state_id: "2886",
        },
        {
          id: "32593",
          name: "Ruda Slaska",
          state_id: "2886",
        },
        {
          id: "32594",
          name: "Rybnik",
          state_id: "2886",
        },
        {
          id: "32595",
          name: "Rydultowy",
          state_id: "2886",
        },
        {
          id: "32596",
          name: "Siemianowice Slaskie",
          state_id: "2886",
        },
        {
          id: "32597",
          name: "Skoczow",
          state_id: "2886",
        },
        {
          id: "32598",
          name: "Sosnowiec",
          state_id: "2886",
        },
        {
          id: "32599",
          name: "Swietochlowice",
          state_id: "2886",
        },
        {
          id: "32600",
          name: "Tarnowskie Gory",
          state_id: "2886",
        },
        {
          id: "32601",
          name: "Tychy",
          state_id: "2886",
        },
        {
          id: "32602",
          name: "Ustron",
          state_id: "2886",
        },
        {
          id: "32603",
          name: "Wisla",
          state_id: "2886",
        },
        {
          id: "32604",
          name: "Wodzislaw Slaski",
          state_id: "2886",
        },
        {
          id: "32605",
          name: "Wojkowice",
          state_id: "2886",
        },
        {
          id: "32606",
          name: "Zabrze",
          state_id: "2886",
        },
        {
          id: "32607",
          name: "Zawiercie",
          state_id: "2886",
        },
        {
          id: "32608",
          name: "Zory",
          state_id: "2886",
        },
        {
          id: "32609",
          name: "Zywiec",
          state_id: "2886",
        },
      ],
      "Stare Pole": [],
      Swietokrzyskie: [
        {
          id: "32610",
          name: "Busko-Zdroj",
          state_id: "2888",
        },
        {
          id: "32611",
          name: "Jedrzejow",
          state_id: "2888",
        },
        {
          id: "32612",
          name: "Kielce",
          state_id: "2888",
        },
        {
          id: "32613",
          name: "Konskie",
          state_id: "2888",
        },
        {
          id: "32614",
          name: "Ostrowiec Swietokrzyski",
          state_id: "2888",
        },
        {
          id: "32615",
          name: "Pinczow",
          state_id: "2888",
        },
        {
          id: "32616",
          name: "Polaniec",
          state_id: "2888",
        },
        {
          id: "32617",
          name: "Sandomierz",
          state_id: "2888",
        },
        {
          id: "32618",
          name: "Skarzysko-Kamienna",
          state_id: "2888",
        },
        {
          id: "32619",
          name: "Starachowice",
          state_id: "2888",
        },
        {
          id: "32620",
          name: "Staszow",
          state_id: "2888",
        },
        {
          id: "32621",
          name: "Suchedniow",
          state_id: "2888",
        },
        {
          id: "32622",
          name: "Wloszczowa",
          state_id: "2888",
        },
      ],
      "Warminsko-Mazurskie": [
        {
          id: "32623",
          name: "Bartoszyce",
          state_id: "2889",
        },
        {
          id: "32624",
          name: "Biskupiec",
          state_id: "2889",
        },
        {
          id: "32625",
          name: "Braniewo",
          state_id: "2889",
        },
        {
          id: "32626",
          name: "Dobre Miasto",
          state_id: "2889",
        },
        {
          id: "32627",
          name: "Dzialdowo",
          state_id: "2889",
        },
        {
          id: "32628",
          name: "Elblag",
          state_id: "2889",
        },
        {
          id: "32629",
          name: "Elk",
          state_id: "2889",
        },
        {
          id: "32630",
          name: "Gizycko",
          state_id: "2889",
        },
        {
          id: "32631",
          name: "Goldap",
          state_id: "2889",
        },
        {
          id: "32632",
          name: "Ilawa",
          state_id: "2889",
        },
        {
          id: "32633",
          name: "Ketrzyn",
          state_id: "2889",
        },
        {
          id: "32634",
          name: "Lidzbark Warminski",
          state_id: "2889",
        },
        {
          id: "32635",
          name: "Lubawa",
          state_id: "2889",
        },
        {
          id: "32636",
          name: "Morag",
          state_id: "2889",
        },
        {
          id: "32637",
          name: "Mragowo",
          state_id: "2889",
        },
        {
          id: "32638",
          name: "Nidzica",
          state_id: "2889",
        },
        {
          id: "32639",
          name: "Nowe Miasto Lubawskie",
          state_id: "2889",
        },
        {
          id: "32640",
          name: "Olecko",
          state_id: "2889",
        },
        {
          id: "32641",
          name: "Olsztyn",
          state_id: "2889",
        },
        {
          id: "32642",
          name: "Orneta",
          state_id: "2889",
        },
        {
          id: "32643",
          name: "Ostroda",
          state_id: "2889",
        },
        {
          id: "32644",
          name: "Paslek",
          state_id: "2889",
        },
        {
          id: "32645",
          name: "Pisz",
          state_id: "2889",
        },
        {
          id: "32646",
          name: "Szczytno",
          state_id: "2889",
        },
        {
          id: "32647",
          name: "Wegorzewo",
          state_id: "2889",
        },
      ],
      Warsaw: [
        {
          id: "32648",
          name: "Nadarzyn",
          state_id: "2890",
        },
        {
          id: "32649",
          name: "Szemud",
          state_id: "2890",
        },
        {
          id: "32650",
          name: "Warsaw",
          state_id: "2890",
        },
      ],
      Wejherowo: [
        {
          id: "32651",
          name: "Goscicino",
          state_id: "2891",
        },
      ],
      Wielkopolskie: [
        {
          id: "32652",
          name: "Chodziez",
          state_id: "2892",
        },
        {
          id: "32653",
          name: "Czarnkow",
          state_id: "2892",
        },
        {
          id: "32654",
          name: "Gniezno",
          state_id: "2892",
        },
        {
          id: "32655",
          name: "Gostyn",
          state_id: "2892",
        },
        {
          id: "32656",
          name: "Grodzisk Wielkopolski",
          state_id: "2892",
        },
        {
          id: "32657",
          name: "Jarocin",
          state_id: "2892",
        },
        {
          id: "32658",
          name: "Kalisz",
          state_id: "2892",
        },
        {
          id: "32659",
          name: "Kepno",
          state_id: "2892",
        },
        {
          id: "32660",
          name: "Kolo",
          state_id: "2892",
        },
        {
          id: "32661",
          name: "Konin",
          state_id: "2892",
        },
        {
          id: "32662",
          name: "Koscian",
          state_id: "2892",
        },
        {
          id: "32663",
          name: "Krotoszyn",
          state_id: "2892",
        },
        {
          id: "32664",
          name: "Leszno",
          state_id: "2892",
        },
        {
          id: "32665",
          name: "Lubon",
          state_id: "2892",
        },
        {
          id: "32666",
          name: "Miedzychod",
          state_id: "2892",
        },
        {
          id: "32667",
          name: "Mosina",
          state_id: "2892",
        },
        {
          id: "32668",
          name: "Murowana Goslina",
          state_id: "2892",
        },
        {
          id: "32669",
          name: "Nowy Tomysl",
          state_id: "2892",
        },
        {
          id: "32670",
          name: "Oborniki",
          state_id: "2892",
        },
        {
          id: "32671",
          name: "Opalenica",
          state_id: "2892",
        },
        {
          id: "32672",
          name: "Ostrow Wielkopolski",
          state_id: "2892",
        },
        {
          id: "32673",
          name: "Ostrzeszow",
          state_id: "2892",
        },
        {
          id: "32674",
          name: "Pila",
          state_id: "2892",
        },
        {
          id: "32675",
          name: "Pleszew",
          state_id: "2892",
        },
        {
          id: "32676",
          name: "Poznan",
          state_id: "2892",
        },
        {
          id: "32677",
          name: "Rawicz",
          state_id: "2892",
        },
        {
          id: "32678",
          name: "Rogozno",
          state_id: "2892",
        },
        {
          id: "32679",
          name: "Slupca",
          state_id: "2892",
        },
        {
          id: "32680",
          name: "Srem",
          state_id: "2892",
        },
        {
          id: "32681",
          name: "Sroda Wielkopolska",
          state_id: "2892",
        },
        {
          id: "32682",
          name: "Swarzedz",
          state_id: "2892",
        },
        {
          id: "32683",
          name: "Szamotuly",
          state_id: "2892",
        },
        {
          id: "32684",
          name: "Trzcianka",
          state_id: "2892",
        },
        {
          id: "32685",
          name: "Tuliszkow",
          state_id: "2892",
        },
        {
          id: "32686",
          name: "Turek",
          state_id: "2892",
        },
        {
          id: "32687",
          name: "Wagrowiec",
          state_id: "2892",
        },
        {
          id: "32688",
          name: "Wolsztyn",
          state_id: "2892",
        },
        {
          id: "32689",
          name: "Wronki",
          state_id: "2892",
        },
        {
          id: "32690",
          name: "Wrzesnia",
          state_id: "2892",
        },
        {
          id: "32691",
          name: "Zlotow",
          state_id: "2892",
        },
      ],
      Wroclaw: [
        {
          id: "32692",
          name: "Borowa",
          state_id: "2893",
        },
      ],
      "Zachodnio-Pomorskie": [
        {
          id: "32693",
          name: "Barlinek",
          state_id: "2894",
        },
        {
          id: "32694",
          name: "Bialogard",
          state_id: "2894",
        },
        {
          id: "32695",
          name: "Choszczno",
          state_id: "2894",
        },
        {
          id: "32696",
          name: "Darlowo",
          state_id: "2894",
        },
        {
          id: "32697",
          name: "Debno",
          state_id: "2894",
        },
        {
          id: "32698",
          name: "Drawsko Pomorskie",
          state_id: "2894",
        },
        {
          id: "32699",
          name: "Goleniow",
          state_id: "2894",
        },
        {
          id: "32700",
          name: "Gryfice",
          state_id: "2894",
        },
        {
          id: "32701",
          name: "Gryfino",
          state_id: "2894",
        },
        {
          id: "32702",
          name: "Kamien Pomorski",
          state_id: "2894",
        },
        {
          id: "32703",
          name: "Kolobrzeg",
          state_id: "2894",
        },
        {
          id: "32704",
          name: "Koszalin",
          state_id: "2894",
        },
        {
          id: "32705",
          name: "Lobez",
          state_id: "2894",
        },
        {
          id: "32706",
          name: "Mysliborz",
          state_id: "2894",
        },
        {
          id: "32707",
          name: "Nowogard",
          state_id: "2894",
        },
        {
          id: "32708",
          name: "Polczyn-Zdroj",
          state_id: "2894",
        },
        {
          id: "32709",
          name: "Police",
          state_id: "2894",
        },
        {
          id: "32710",
          name: "Pyrzyce",
          state_id: "2894",
        },
        {
          id: "32711",
          name: "Slawno",
          state_id: "2894",
        },
        {
          id: "32712",
          name: "Stargard Szczecinski",
          state_id: "2894",
        },
        {
          id: "32713",
          name: "Swidwin",
          state_id: "2894",
        },
        {
          id: "32714",
          name: "Swinoujscie",
          state_id: "2894",
        },
        {
          id: "32715",
          name: "Szczecin",
          state_id: "2894",
        },
        {
          id: "32716",
          name: "Szczecinek",
          state_id: "2894",
        },
        {
          id: "32717",
          name: "Trzebiatow",
          state_id: "2894",
        },
        {
          id: "32718",
          name: "Walcz",
          state_id: "2894",
        },
        {
          id: "32719",
          name: "Zlocieniec",
          state_id: "2894",
        },
      ],
      Zukowo: [
        {
          id: "32720",
          name: "Zukowskie",
          state_id: "2895",
        },
      ],
    },
  },
  PM: {
    name: "Saint Pierre and Miquelon",
    native: "Saint-Pierre-et-Miquelon",
    phone: "508",
    continent: "NA",
    capital: "Saint-Pierre",
    currency: "EUR",
    languages: ["fr"],
    emoji: "🇵🇲",
    emojiU: "U+1F1F5 U+1F1F2",
    states: {
      "Miquelon-Langlade": [
        {
          id: "37379",
          name: "Miquelon",
          state_id: "3112",
        },
      ],
      "Saint-Pierre": [
        {
          id: "37380",
          name: "Saint-Pierre",
          state_id: "3113",
        },
      ],
    },
  },
  PN: {
    name: "Pitcairn Islands",
    native: "Pitcairn Islands",
    phone: "64",
    continent: "OC",
    capital: "Adamstown",
    currency: "NZD",
    languages: ["en"],
    emoji: "🇵🇳",
    emojiU: "U+1F1F5 U+1F1F3",
    states: {
      "Pitcairn Island": [],
    },
  },
  PR: {
    name: "Puerto Rico",
    native: "Puerto Rico",
    phone: "1787,1939",
    continent: "NA",
    capital: "San Juan",
    currency: "USD",
    languages: ["es", "en"],
    emoji: "🇵🇷",
    emojiU: "U+1F1F5 U+1F1F7",
    states: {
      Arecibo: [
        {
          id: "33045",
          name: "Arecibo",
          state_id: "2910",
        },
        {
          id: "33046",
          name: "Barceloneta",
          state_id: "2910",
        },
        {
          id: "33047",
          name: "Camuy",
          state_id: "2910",
        },
        {
          id: "33048",
          name: "Dorado",
          state_id: "2910",
        },
        {
          id: "33049",
          name: "Isabela",
          state_id: "2910",
        },
        {
          id: "33050",
          name: "Manati",
          state_id: "2910",
        },
        {
          id: "33051",
          name: "Vega Alta",
          state_id: "2910",
        },
        {
          id: "33052",
          name: "Vega Baja",
          state_id: "2910",
        },
      ],
      Bayamon: [
        {
          id: "33053",
          name: "Bayamon",
          state_id: "2911",
        },
        {
          id: "33054",
          name: "Catano",
          state_id: "2911",
        },
        {
          id: "33055",
          name: "Guaynabo",
          state_id: "2911",
        },
        {
          id: "33056",
          name: "Levittown",
          state_id: "2911",
        },
        {
          id: "33057",
          name: "Valencia",
          state_id: "2911",
        },
      ],
      Carolina: [
        {
          id: "33058",
          name: "Canovanas",
          state_id: "2912",
        },
        {
          id: "33059",
          name: "Carolina",
          state_id: "2912",
        },
        {
          id: "33060",
          name: "Trujillo Alto",
          state_id: "2912",
        },
      ],
      Florida: [
        {
          id: "33061",
          name: "Florida",
          state_id: "2913",
        },
      ],
      Guayama: [
        {
          id: "33062",
          name: "Aibonito",
          state_id: "2914",
        },
        {
          id: "33063",
          name: "Arroyo",
          state_id: "2914",
        },
        {
          id: "33064",
          name: "Barranquitas",
          state_id: "2914",
        },
        {
          id: "33065",
          name: "Cayey",
          state_id: "2914",
        },
        {
          id: "33066",
          name: "Coamo",
          state_id: "2914",
        },
        {
          id: "33067",
          name: "Corozal",
          state_id: "2914",
        },
        {
          id: "33068",
          name: "Guayama",
          state_id: "2914",
        },
        {
          id: "33069",
          name: "Juana Diaz",
          state_id: "2914",
        },
      ],
      Humacao: [
        {
          id: "33070",
          name: "Aguas Buenas",
          state_id: "2915",
        },
        {
          id: "33071",
          name: "Caguas",
          state_id: "2915",
        },
        {
          id: "33072",
          name: "Culebra",
          state_id: "2915",
        },
        {
          id: "33073",
          name: "Fajardo",
          state_id: "2915",
        },
        {
          id: "33074",
          name: "Gurabo",
          state_id: "2915",
        },
        {
          id: "33075",
          name: "Humacao",
          state_id: "2915",
        },
        {
          id: "33076",
          name: "Juncos",
          state_id: "2915",
        },
        {
          id: "33077",
          name: "Rio Grande",
          state_id: "2915",
        },
        {
          id: "33078",
          name: "Vieques",
          state_id: "2915",
        },
      ],
      "Mayaguez-Aguadilla": [
        {
          id: "33079",
          name: "Aguada",
          state_id: "2916",
        },
        {
          id: "33080",
          name: "Aguadilla",
          state_id: "2916",
        },
        {
          id: "33081",
          name: "Anasco",
          state_id: "2916",
        },
        {
          id: "33082",
          name: "Cabo Rojo",
          state_id: "2916",
        },
        {
          id: "33083",
          name: "Hormigueros",
          state_id: "2916",
        },
        {
          id: "33084",
          name: "Mayaguez",
          state_id: "2916",
        },
        {
          id: "33085",
          name: "San German",
          state_id: "2916",
        },
        {
          id: "33086",
          name: "San Sebastian",
          state_id: "2916",
        },
      ],
      Ponce: [
        {
          id: "33087",
          name: "Adjuntas",
          state_id: "2917",
        },
        {
          id: "33088",
          name: "Guanica",
          state_id: "2917",
        },
        {
          id: "33089",
          name: "Ponce",
          state_id: "2917",
        },
        {
          id: "33090",
          name: "Utuado",
          state_id: "2917",
        },
        {
          id: "33091",
          name: "Yauco",
          state_id: "2917",
        },
      ],
      Salinas: [
        {
          id: "33092",
          name: "Salinas",
          state_id: "2918",
        },
      ],
      "San Juan": [],
    },
  },
  PS: {
    name: "Palestine",
    native: "فلسطين",
    phone: "970",
    continent: "AS",
    capital: "Ramallah",
    currency: "ILS",
    languages: ["ar"],
    emoji: "🇵🇸",
    emojiU: "U+1F1F5 U+1F1F8",
    states: {
      Ariha: [
        {
          id: "31708",
          name: "Ariha",
          state_id: "2746",
        },
      ],
      "Bayt Lahm": [],
      Bethlehem: [
        {
          id: "31709",
          name: "Beit Jala",
          state_id: "2748",
        },
      ],
      "Dayr-al-Balah": [
        {
          id: "31710",
          name: "Dayr-al-Balah",
          state_id: "2749",
        },
        {
          id: "31711",
          name: "al-Burayj",
          state_id: "2749",
        },
        {
          id: "31712",
          name: "al-Insayrat",
          state_id: "2749",
        },
        {
          id: "31713",
          name: "al-Maghazi",
          state_id: "2749",
        },
      ],
      Ghazzah: [
        {
          id: "31714",
          name: "Ghazzah",
          state_id: "2750",
        },
      ],
      "Ghazzah ash-Shamaliyah": [
        {
          id: "31715",
          name: "Ghazzah",
          state_id: "2751",
        },
      ],
      Janin: [
        {
          id: "31716",
          name: "Janin",
          state_id: "2752",
        },
        {
          id: "31717",
          name: "Qabatiyah",
          state_id: "2752",
        },
      ],
      "Khan Yunis": [],
      Nabulus: [
        {
          id: "31718",
          name: "Nabulus",
          state_id: "2754",
        },
      ],
      Qalqilyah: [
        {
          id: "31719",
          name: "Qalqilyah",
          state_id: "2755",
        },
      ],
      Rafah: [
        {
          id: "31720",
          name: "Rafah",
          state_id: "2756",
        },
        {
          id: "31721",
          name: "Tall as-Sultan",
          state_id: "2756",
        },
      ],
      "Ram Allah wal-Birah": [],
      Salfit: [
        {
          id: "31722",
          name: "Salfit",
          state_id: "2758",
        },
      ],
      Tubas: [
        {
          id: "31723",
          name: "Tubas",
          state_id: "2759",
        },
      ],
      Tulkarm: [
        {
          id: "31724",
          name: "Tulkarm",
          state_id: "2760",
        },
      ],
      "al-Khalil": [
        {
          id: "31725",
          name: "Dura",
          state_id: "2761",
        },
        {
          id: "31726",
          name: "Halhul",
          state_id: "2761",
        },
        {
          id: "31727",
          name: "Yattah",
          state_id: "2761",
        },
        {
          id: "31728",
          name: "ad-Dahiriyah",
          state_id: "2761",
        },
        {
          id: "31729",
          name: "al-Khalil",
          state_id: "2761",
        },
      ],
      "al-Quds": [
        {
          id: "31730",
          name: "Ma''ale Adummim",
          state_id: "2762",
        },
        {
          id: "31731",
          name: "al-Quds",
          state_id: "2762",
        },
      ],
    },
  },
  PT: {
    name: "Portugal",
    native: "Portugal",
    phone: "351",
    continent: "EU",
    capital: "Lisbon",
    currency: "EUR",
    languages: ["pt"],
    emoji: "🇵🇹",
    emojiU: "U+1F1F5 U+1F1F9",
    states: {
      Abrantes: [
        {
          id: "32721",
          name: "Tramagal",
          state_id: "2896",
        },
      ],
      Acores: [
        {
          id: "32722",
          name: "Angra",
          state_id: "2897",
        },
        {
          id: "32723",
          name: "Arrifes",
          state_id: "2897",
        },
        {
          id: "32724",
          name: "Faja de Baixo",
          state_id: "2897",
        },
        {
          id: "32725",
          name: "Horta",
          state_id: "2897",
        },
        {
          id: "32726",
          name: "Lagoa",
          state_id: "2897",
        },
        {
          id: "32727",
          name: "Ponta Delgada",
          state_id: "2897",
        },
        {
          id: "32728",
          name: "Praia da Vitoria",
          state_id: "2897",
        },
        {
          id: "32729",
          name: "Rabo de Peixe",
          state_id: "2897",
        },
        {
          id: "32730",
          name: "Ribeira Grande",
          state_id: "2897",
        },
        {
          id: "32731",
          name: "Rosto do Cao",
          state_id: "2897",
        },
        {
          id: "32732",
          name: "Vila Franca do Campo",
          state_id: "2897",
        },
      ],
      Alentejo: [
        {
          id: "32733",
          name: "Alcacer do Sal",
          state_id: "2898",
        },
        {
          id: "32734",
          name: "Aljustrel",
          state_id: "2898",
        },
        {
          id: "32735",
          name: "Beja",
          state_id: "2898",
        },
        {
          id: "32736",
          name: "Borba",
          state_id: "2898",
        },
        {
          id: "32737",
          name: "Caia e Sao Pedro",
          state_id: "2898",
        },
        {
          id: "32738",
          name: "Campo Maior",
          state_id: "2898",
        },
        {
          id: "32739",
          name: "Castro Verde",
          state_id: "2898",
        },
        {
          id: "32740",
          name: "Cercal",
          state_id: "2898",
        },
        {
          id: "32741",
          name: "Elvas",
          state_id: "2898",
        },
        {
          id: "32742",
          name: "Estremoz",
          state_id: "2898",
        },
        {
          id: "32743",
          name: "Evora",
          state_id: "2898",
        },
        {
          id: "32744",
          name: "Ferreira do Alentejo",
          state_id: "2898",
        },
        {
          id: "32745",
          name: "Grandola",
          state_id: "2898",
        },
        {
          id: "32746",
          name: "Montemor-o-Novo",
          state_id: "2898",
        },
        {
          id: "32747",
          name: "Moura",
          state_id: "2898",
        },
        {
          id: "32748",
          name: "Odemira",
          state_id: "2898",
        },
        {
          id: "32749",
          name: "Ponte de Sor",
          state_id: "2898",
        },
        {
          id: "32750",
          name: "Portalegre",
          state_id: "2898",
        },
        {
          id: "32751",
          name: "Redondo",
          state_id: "2898",
        },
        {
          id: "32752",
          name: "Reguengos de Monsaraz",
          state_id: "2898",
        },
        {
          id: "32753",
          name: "Santiago do Cacem",
          state_id: "2898",
        },
        {
          id: "32754",
          name: "Santo Andre",
          state_id: "2898",
        },
        {
          id: "32755",
          name: "Sao Teotonio",
          state_id: "2898",
        },
        {
          id: "32756",
          name: "Serpa",
          state_id: "2898",
        },
        {
          id: "32757",
          name: "Sines",
          state_id: "2898",
        },
        {
          id: "32758",
          name: "Vendas Novas",
          state_id: "2898",
        },
        {
          id: "32759",
          name: "Vila Nova de Milfontes",
          state_id: "2898",
        },
        {
          id: "32760",
          name: "Vila Vicosa",
          state_id: "2898",
        },
      ],
      Algarve: [
        {
          id: "32761",
          name: "Albufeira",
          state_id: "2899",
        },
        {
          id: "32762",
          name: "Aljezur",
          state_id: "2899",
        },
        {
          id: "32763",
          name: "Almancil",
          state_id: "2899",
        },
        {
          id: "32764",
          name: "Alvor",
          state_id: "2899",
        },
        {
          id: "32765",
          name: "Armacao de Pera",
          state_id: "2899",
        },
        {
          id: "32766",
          name: "Boliqueime",
          state_id: "2899",
        },
        {
          id: "32767",
          name: "Castro Marim",
          state_id: "2899",
        },
        {
          id: "32768",
          name: "Estombar",
          state_id: "2899",
        },
        {
          id: "32769",
          name: "Faro",
          state_id: "2899",
        },
        {
          id: "32770",
          name: "Ferreiras",
          state_id: "2899",
        },
        {
          id: "32771",
          name: "Guia",
          state_id: "2899",
        },
        {
          id: "32772",
          name: "Lagoa",
          state_id: "2899",
        },
        {
          id: "32773",
          name: "Lagos",
          state_id: "2899",
        },
        {
          id: "32774",
          name: "Loule",
          state_id: "2899",
        },
        {
          id: "32775",
          name: "Luz",
          state_id: "2899",
        },
        {
          id: "32776",
          name: "Moncarapacho",
          state_id: "2899",
        },
        {
          id: "32777",
          name: "Monchique",
          state_id: "2899",
        },
        {
          id: "32778",
          name: "Monte Gordo",
          state_id: "2899",
        },
        {
          id: "32779",
          name: "Montenegro",
          state_id: "2899",
        },
        {
          id: "32780",
          name: "Olhao",
          state_id: "2899",
        },
        {
          id: "32781",
          name: "Portimao",
          state_id: "2899",
        },
        {
          id: "32782",
          name: "Quarteira",
          state_id: "2899",
        },
        {
          id: "32783",
          name: "Santa Barbara de Nexe",
          state_id: "2899",
        },
        {
          id: "32784",
          name: "Sao Bartolomeu de Messines",
          state_id: "2899",
        },
        {
          id: "32785",
          name: "Sao Bras de Alportel",
          state_id: "2899",
        },
        {
          id: "32786",
          name: "Silves",
          state_id: "2899",
        },
        {
          id: "32787",
          name: "Tavira",
          state_id: "2899",
        },
        {
          id: "32788",
          name: "Vila Real de Santo Antonio",
          state_id: "2899",
        },
      ],
      Braga: [
        {
          id: "32789",
          name: "Fafe",
          state_id: "2900",
        },
        {
          id: "32790",
          name: "Forjaes",
          state_id: "2900",
        },
        {
          id: "32791",
          name: "Vianna do Castello",
          state_id: "2900",
        },
      ],
      Centro: [
        {
          id: "32792",
          name: "Abraveses",
          state_id: "2901",
        },
        {
          id: "32793",
          name: "Aguada de Cima",
          state_id: "2901",
        },
        {
          id: "32794",
          name: "Agueda",
          state_id: "2901",
        },
        {
          id: "32795",
          name: "Albergaria-A-Velha",
          state_id: "2901",
        },
        {
          id: "32796",
          name: "Alcains",
          state_id: "2901",
        },
        {
          id: "32797",
          name: "Alhadas",
          state_id: "2901",
        },
        {
          id: "32798",
          name: "Amor",
          state_id: "2901",
        },
        {
          id: "32799",
          name: "Aradas",
          state_id: "2901",
        },
        {
          id: "32800",
          name: "Arazede",
          state_id: "2901",
        },
        {
          id: "32801",
          name: "Arcos",
          state_id: "2901",
        },
        {
          id: "32802",
          name: "Arganil",
          state_id: "2901",
        },
        {
          id: "32803",
          name: "Avanca",
          state_id: "2901",
        },
        {
          id: "32804",
          name: "Aveiro",
          state_id: "2901",
        },
        {
          id: "32805",
          name: "Batalha",
          state_id: "2901",
        },
        {
          id: "32806",
          name: "Beduido",
          state_id: "2901",
        },
        {
          id: "32807",
          name: "Branca",
          state_id: "2901",
        },
        {
          id: "32808",
          name: "Buarcos",
          state_id: "2901",
        },
        {
          id: "32809",
          name: "Campo",
          state_id: "2901",
        },
        {
          id: "32810",
          name: "Cantanhede",
          state_id: "2901",
        },
        {
          id: "32811",
          name: "Caranguejeira",
          state_id: "2901",
        },
        {
          id: "32812",
          name: "Castanheira de Pera",
          state_id: "2901",
        },
        {
          id: "32813",
          name: "Castelo Branco",
          state_id: "2901",
        },
        {
          id: "32814",
          name: "Castro Daire",
          state_id: "2901",
        },
        {
          id: "32815",
          name: "Coimbra",
          state_id: "2901",
        },
        {
          id: "32816",
          name: "Condeixa-A-Nova",
          state_id: "2901",
        },
        {
          id: "32817",
          name: "Cortegaca",
          state_id: "2901",
        },
        {
          id: "32818",
          name: "Covilha",
          state_id: "2901",
        },
        {
          id: "32819",
          name: "Eixo",
          state_id: "2901",
        },
        {
          id: "32820",
          name: "Esmoriz",
          state_id: "2901",
        },
        {
          id: "32821",
          name: "Figueira da Foz",
          state_id: "2901",
        },
        {
          id: "32822",
          name: "Fundao",
          state_id: "2901",
        },
        {
          id: "32823",
          name: "Gafanha da Encarnacao",
          state_id: "2901",
        },
        {
          id: "32824",
          name: "Gafanha da Nazare",
          state_id: "2901",
        },
        {
          id: "32825",
          name: "Guarda",
          state_id: "2901",
        },
        {
          id: "32826",
          name: "Ilhavo",
          state_id: "2901",
        },
        {
          id: "32827",
          name: "Lavos",
          state_id: "2901",
        },
        {
          id: "32828",
          name: "Leiria",
          state_id: "2901",
        },
        {
          id: "32829",
          name: "Lorvao",
          state_id: "2901",
        },
        {
          id: "32830",
          name: "Lourical",
          state_id: "2901",
        },
        {
          id: "32831",
          name: "Lousa",
          state_id: "2901",
        },
        {
          id: "32832",
          name: "Maceira",
          state_id: "2901",
        },
        {
          id: "32833",
          name: "Mangualde",
          state_id: "2901",
        },
        {
          id: "32834",
          name: "Marinha Grande",
          state_id: "2901",
        },
        {
          id: "32835",
          name: "Mealhada",
          state_id: "2901",
        },
        {
          id: "32836",
          name: "Mira",
          state_id: "2901",
        },
        {
          id: "32837",
          name: "Mira de Aire",
          state_id: "2901",
        },
        {
          id: "32838",
          name: "Miranda do Corvo",
          state_id: "2901",
        },
        {
          id: "32839",
          name: "Monte Redondo",
          state_id: "2901",
        },
        {
          id: "32840",
          name: "Nelas",
          state_id: "2901",
        },
        {
          id: "32841",
          name: "Oia",
          state_id: "2901",
        },
        {
          id: "32842",
          name: "Oliveira do Bairro",
          state_id: "2901",
        },
        {
          id: "32843",
          name: "Oliveira do Hospital",
          state_id: "2901",
        },
        {
          id: "32844",
          name: "Oliveirinha",
          state_id: "2901",
        },
        {
          id: "32845",
          name: "Ovar",
          state_id: "2901",
        },
        {
          id: "32846",
          name: "Pampilhosa",
          state_id: "2901",
        },
        {
          id: "32847",
          name: "Pardilho",
          state_id: "2901",
        },
        {
          id: "32848",
          name: "Poiares",
          state_id: "2901",
        },
        {
          id: "32849",
          name: "Pombal",
          state_id: "2901",
        },
        {
          id: "32850",
          name: "Porto de Mos",
          state_id: "2901",
        },
        {
          id: "32851",
          name: "Proenca-A-Nova",
          state_id: "2901",
        },
        {
          id: "32852",
          name: "Rio de Loba",
          state_id: "2901",
        },
        {
          id: "32853",
          name: "Salreu",
          state_id: "2901",
        },
        {
          id: "32854",
          name: "Sangalhos",
          state_id: "2901",
        },
        {
          id: "32855",
          name: "Santa Catarina da Serra",
          state_id: "2901",
        },
        {
          id: "32856",
          name: "Sao Joao",
          state_id: "2901",
        },
        {
          id: "32857",
          name: "Sao Pedro do Sul",
          state_id: "2901",
        },
        {
          id: "32858",
          name: "Satao",
          state_id: "2901",
        },
        {
          id: "32859",
          name: "Seia",
          state_id: "2901",
        },
        {
          id: "32860",
          name: "Serta",
          state_id: "2901",
        },
        {
          id: "32861",
          name: "Soure",
          state_id: "2901",
        },
        {
          id: "32862",
          name: "Souto da Carpalhosa",
          state_id: "2901",
        },
        {
          id: "32863",
          name: "Tavarede",
          state_id: "2901",
        },
        {
          id: "32864",
          name: "Teixoso",
          state_id: "2901",
        },
        {
          id: "32865",
          name: "Tondela",
          state_id: "2901",
        },
        {
          id: "32866",
          name: "Tortosendo",
          state_id: "2901",
        },
        {
          id: "32867",
          name: "Vagos",
          state_id: "2901",
        },
        {
          id: "32868",
          name: "Valega",
          state_id: "2901",
        },
        {
          id: "32869",
          name: "Valongo do Vouga",
          state_id: "2901",
        },
        {
          id: "32870",
          name: "Vieira de Leiria",
          state_id: "2901",
        },
        {
          id: "32871",
          name: "Viseu",
          state_id: "2901",
        },
      ],
      "Distrito de Leiria": [],
      "Distrito de Viana do Castelo": [],
      "Distrito de Vila Real": [],
      "Distrito do Porto": [],
      "Lisboa e Vale do Tejo": [],
      Madeira: [
        {
          id: "32872",
          name: "Camacha",
          state_id: "2907",
        },
        {
          id: "32873",
          name: "Camara de Lobos",
          state_id: "2907",
        },
        {
          id: "32874",
          name: "Campanario",
          state_id: "2907",
        },
        {
          id: "32875",
          name: "Canico",
          state_id: "2907",
        },
        {
          id: "32876",
          name: "Funchal",
          state_id: "2907",
        },
        {
          id: "32877",
          name: "Machico",
          state_id: "2907",
        },
        {
          id: "32878",
          name: "Ponta do Sol",
          state_id: "2907",
        },
        {
          id: "32879",
          name: "Porto Santo",
          state_id: "2907",
        },
        {
          id: "32880",
          name: "Ribeira Brava",
          state_id: "2907",
        },
        {
          id: "32881",
          name: "Santa Cruz",
          state_id: "2907",
        },
      ],
      Norte: [
        {
          id: "32882",
          name: "A Ver-o-Mar",
          state_id: "2908",
        },
        {
          id: "32883",
          name: "Adaufe",
          state_id: "2908",
        },
        {
          id: "32884",
          name: "Aguas Santas",
          state_id: "2908",
        },
        {
          id: "32885",
          name: "Agucadoura",
          state_id: "2908",
        },
        {
          id: "32886",
          name: "Alfena",
          state_id: "2908",
        },
        {
          id: "32887",
          name: "Alpendurada e Matos",
          state_id: "2908",
        },
        {
          id: "32888",
          name: "Amarante",
          state_id: "2908",
        },
        {
          id: "32889",
          name: "Anta",
          state_id: "2908",
        },
        {
          id: "32890",
          name: "Antas",
          state_id: "2908",
        },
        {
          id: "32891",
          name: "Apulia",
          state_id: "2908",
        },
        {
          id: "32892",
          name: "Arcozelo",
          state_id: "2908",
        },
        {
          id: "32893",
          name: "Areosa",
          state_id: "2908",
        },
        {
          id: "32894",
          name: "Argoncilhe",
          state_id: "2908",
        },
        {
          id: "32895",
          name: "Aroes",
          state_id: "2908",
        },
        {
          id: "32896",
          name: "Arrifana",
          state_id: "2908",
        },
        {
          id: "32897",
          name: "Arvore",
          state_id: "2908",
        },
        {
          id: "32898",
          name: "Aves",
          state_id: "2908",
        },
        {
          id: "32899",
          name: "Avintes",
          state_id: "2908",
        },
        {
          id: "32900",
          name: "Baguim do Monte",
          state_id: "2908",
        },
        {
          id: "32901",
          name: "Baltar",
          state_id: "2908",
        },
        {
          id: "32902",
          name: "Barcelos",
          state_id: "2908",
        },
        {
          id: "32903",
          name: "Barrosas",
          state_id: "2908",
        },
        {
          id: "32904",
          name: "Bougado",
          state_id: "2908",
        },
        {
          id: "32905",
          name: "Braga",
          state_id: "2908",
        },
        {
          id: "32906",
          name: "Braganca",
          state_id: "2908",
        },
        {
          id: "32907",
          name: "Brito",
          state_id: "2908",
        },
        {
          id: "32908",
          name: "Caldas de Vizela",
          state_id: "2908",
        },
        {
          id: "32909",
          name: "Caldelas",
          state_id: "2908",
        },
        {
          id: "32910",
          name: "Calendario",
          state_id: "2908",
        },
        {
          id: "32911",
          name: "Campo",
          state_id: "2908",
        },
        {
          id: "32912",
          name: "Candoso",
          state_id: "2908",
        },
        {
          id: "32913",
          name: "Canedo",
          state_id: "2908",
        },
        {
          id: "32914",
          name: "Canelas",
          state_id: "2908",
        },
        {
          id: "32915",
          name: "Canidelo",
          state_id: "2908",
        },
        {
          id: "32916",
          name: "Carvalhosa",
          state_id: "2908",
        },
        {
          id: "32917",
          name: "Casteloes de Cepeda",
          state_id: "2908",
        },
        {
          id: "32918",
          name: "Chaves",
          state_id: "2908",
        },
        {
          id: "32919",
          name: "Coronado",
          state_id: "2908",
        },
        {
          id: "32920",
          name: "Couto",
          state_id: "2908",
        },
        {
          id: "32921",
          name: "Custoias",
          state_id: "2908",
        },
        {
          id: "32922",
          name: "Darque",
          state_id: "2908",
        },
        {
          id: "32923",
          name: "Ermesinde",
          state_id: "2908",
        },
        {
          id: "32924",
          name: "Espinho",
          state_id: "2908",
        },
        {
          id: "32925",
          name: "Fafe",
          state_id: "2908",
        },
        {
          id: "32926",
          name: "Fanzeres",
          state_id: "2908",
        },
        {
          id: "32927",
          name: "Feira",
          state_id: "2908",
        },
        {
          id: "32928",
          name: "Ferreira",
          state_id: "2908",
        },
        {
          id: "32929",
          name: "Ferreiros",
          state_id: "2908",
        },
        {
          id: "32930",
          name: "Fiaes",
          state_id: "2908",
        },
        {
          id: "32931",
          name: "Figueiro",
          state_id: "2908",
        },
        {
          id: "32932",
          name: "Foz do Sousa",
          state_id: "2908",
        },
        {
          id: "32933",
          name: "Frazao",
          state_id: "2908",
        },
        {
          id: "32934",
          name: "Freamunde",
          state_id: "2908",
        },
        {
          id: "32935",
          name: "Galegos",
          state_id: "2908",
        },
        {
          id: "32936",
          name: "Gandra",
          state_id: "2908",
        },
        {
          id: "32937",
          name: "Gemunde",
          state_id: "2908",
        },
        {
          id: "32938",
          name: "Godim",
          state_id: "2908",
        },
        {
          id: "32939",
          name: "Gondomar",
          state_id: "2908",
        },
        {
          id: "32940",
          name: "Grijo",
          state_id: "2908",
        },
        {
          id: "32941",
          name: "Gueifaes",
          state_id: "2908",
        },
        {
          id: "32942",
          name: "Guifoes",
          state_id: "2908",
        },
        {
          id: "32943",
          name: "Guimaraes",
          state_id: "2908",
        },
        {
          id: "32944",
          name: "Gulpilhares",
          state_id: "2908",
        },
        {
          id: "32945",
          name: "Joane",
          state_id: "2908",
        },
        {
          id: "32946",
          name: "Jovim",
          state_id: "2908",
        },
        {
          id: "32947",
          name: "Lamego",
          state_id: "2908",
        },
        {
          id: "32948",
          name: "Lavra",
          state_id: "2908",
        },
        {
          id: "32949",
          name: "Leca da Palmeira",
          state_id: "2908",
        },
        {
          id: "32950",
          name: "Leca do Bailio",
          state_id: "2908",
        },
        {
          id: "32951",
          name: "Lobao",
          state_id: "2908",
        },
        {
          id: "32952",
          name: "Lordelo",
          state_id: "2908",
        },
        {
          id: "32953",
          name: "Lourosa",
          state_id: "2908",
        },
        {
          id: "32954",
          name: "Lustosa",
          state_id: "2908",
        },
        {
          id: "32955",
          name: "Macedo de Cavaleiros",
          state_id: "2908",
        },
        {
          id: "32956",
          name: "Macieira de Cambra",
          state_id: "2908",
        },
        {
          id: "32957",
          name: "Madalena",
          state_id: "2908",
        },
        {
          id: "32958",
          name: "Maia",
          state_id: "2908",
        },
        {
          id: "32959",
          name: "Margaride",
          state_id: "2908",
        },
        {
          id: "32960",
          name: "Marinhas",
          state_id: "2908",
        },
        {
          id: "32961",
          name: "Matosinhos",
          state_id: "2908",
        },
        {
          id: "32962",
          name: "Meadela",
          state_id: "2908",
        },
        {
          id: "32963",
          name: "Meinedo",
          state_id: "2908",
        },
        {
          id: "32964",
          name: "Milheiros",
          state_id: "2908",
        },
        {
          id: "32965",
          name: "Milheiros de Poiares",
          state_id: "2908",
        },
        {
          id: "32966",
          name: "Mirandela",
          state_id: "2908",
        },
        {
          id: "32967",
          name: "Mogadouro",
          state_id: "2908",
        },
        {
          id: "32968",
          name: "Moreira",
          state_id: "2908",
        },
        {
          id: "32969",
          name: "Moreira de Conegos",
          state_id: "2908",
        },
        {
          id: "32970",
          name: "Mozelos",
          state_id: "2908",
        },
        {
          id: "32971",
          name: "Negrelos",
          state_id: "2908",
        },
        {
          id: "32972",
          name: "Nogueira",
          state_id: "2908",
        },
        {
          id: "32973",
          name: "Nogueira da Regedoura",
          state_id: "2908",
        },
        {
          id: "32974",
          name: "Olival",
          state_id: "2908",
        },
        {
          id: "32975",
          name: "Oliveira",
          state_id: "2908",
        },
        {
          id: "32976",
          name: "Oliveira de Azemeis",
          state_id: "2908",
        },
        {
          id: "32977",
          name: "Oliveira do Douro",
          state_id: "2908",
        },
        {
          id: "32978",
          name: "Pacos de Brandao",
          state_id: "2908",
        },
        {
          id: "32979",
          name: "Pacos de Ferreira",
          state_id: "2908",
        },
        {
          id: "32980",
          name: "Pedroso",
          state_id: "2908",
        },
        {
          id: "32981",
          name: "Pedroucos",
          state_id: "2908",
        },
        {
          id: "32982",
          name: "Penafiel",
          state_id: "2908",
        },
        {
          id: "32983",
          name: "Perafita",
          state_id: "2908",
        },
        {
          id: "32984",
          name: "Perozinho",
          state_id: "2908",
        },
        {
          id: "32985",
          name: "Peso da Regua",
          state_id: "2908",
        },
        {
          id: "32986",
          name: "Ponte",
          state_id: "2908",
        },
        {
          id: "32987",
          name: "Porto",
          state_id: "2908",
        },
        {
          id: "32988",
          name: "Povoa de Lanhoso",
          state_id: "2908",
        },
        {
          id: "32989",
          name: "Povoa de Varzim",
          state_id: "2908",
        },
        {
          id: "32990",
          name: "Real",
          state_id: "2908",
        },
        {
          id: "32991",
          name: "Rebordosa",
          state_id: "2908",
        },
        {
          id: "32992",
          name: "Recarei",
          state_id: "2908",
        },
        {
          id: "32993",
          name: "Refojos de Basto",
          state_id: "2908",
        },
        {
          id: "32994",
          name: "Ribeirao",
          state_id: "2908",
        },
        {
          id: "32995",
          name: "Rio Meao",
          state_id: "2908",
        },
        {
          id: "32996",
          name: "Rio Tinto",
          state_id: "2908",
        },
        {
          id: "32997",
          name: "Ronfe",
          state_id: "2908",
        },
        {
          id: "32998",
          name: "Sande",
          state_id: "2908",
        },
        {
          id: "32999",
          name: "Sandim",
          state_id: "2908",
        },
        {
          id: "33000",
          name: "Santa Cruz do Bispo",
          state_id: "2908",
        },
        {
          id: "33001",
          name: "Santa Maria de Lamas",
          state_id: "2908",
        },
        {
          id: "33002",
          name: "Santiago da Riba-Ul",
          state_id: "2908",
        },
        {
          id: "33003",
          name: "Santo Tirso",
          state_id: "2908",
        },
        {
          id: "33004",
          name: "Sao Felix da Marinha",
          state_id: "2908",
        },
        {
          id: "33005",
          name: "Sao Joao da Madeira",
          state_id: "2908",
        },
        {
          id: "33006",
          name: "Sao Joao de Ver",
          state_id: "2908",
        },
        {
          id: "33007",
          name: "Sao Mamede de Infesta",
          state_id: "2908",
        },
        {
          id: "33008",
          name: "Sao Pedro da Cova",
          state_id: "2908",
        },
        {
          id: "33009",
          name: "Sao Pedro de Casteloes",
          state_id: "2908",
        },
        {
          id: "33010",
          name: "Sao Roque",
          state_id: "2908",
        },
        {
          id: "33011",
          name: "Selho",
          state_id: "2908",
        },
        {
          id: "33012",
          name: "Senhora da Hora",
          state_id: "2908",
        },
        {
          id: "33013",
          name: "Seroa",
          state_id: "2908",
        },
        {
          id: "33014",
          name: "Serzedelo",
          state_id: "2908",
        },
        {
          id: "33015",
          name: "Serzedo",
          state_id: "2908",
        },
        {
          id: "33016",
          name: "Silvalde",
          state_id: "2908",
        },
        {
          id: "33017",
          name: "Sobrado",
          state_id: "2908",
        },
        {
          id: "33018",
          name: "Sobreira",
          state_id: "2908",
        },
        {
          id: "33019",
          name: "Souto",
          state_id: "2908",
        },
        {
          id: "33020",
          name: "Teloes",
          state_id: "2908",
        },
        {
          id: "33021",
          name: "Urgezes",
          state_id: "2908",
        },
        {
          id: "33022",
          name: "Valadares",
          state_id: "2908",
        },
        {
          id: "33023",
          name: "Valbom",
          state_id: "2908",
        },
        {
          id: "33024",
          name: "Vale",
          state_id: "2908",
        },
        {
          id: "33025",
          name: "Valongo",
          state_id: "2908",
        },
        {
          id: "33026",
          name: "Valpacos",
          state_id: "2908",
        },
        {
          id: "33027",
          name: "Viana do Castelo",
          state_id: "2908",
        },
        {
          id: "33028",
          name: "Vila Cha",
          state_id: "2908",
        },
        {
          id: "33029",
          name: "Vila Frescainha",
          state_id: "2908",
        },
        {
          id: "33030",
          name: "Vila Nova da Telha",
          state_id: "2908",
        },
        {
          id: "33031",
          name: "Vila Nova de Famalicao",
          state_id: "2908",
        },
        {
          id: "33032",
          name: "Vila Nova de Gaia",
          state_id: "2908",
        },
        {
          id: "33033",
          name: "Vila Praia de Ancora",
          state_id: "2908",
        },
        {
          id: "33034",
          name: "Vila Real",
          state_id: "2908",
        },
        {
          id: "33035",
          name: "Vila Verde",
          state_id: "2908",
        },
        {
          id: "33036",
          name: "Vila de Cucujaes",
          state_id: "2908",
        },
        {
          id: "33037",
          name: "Vila de Prado",
          state_id: "2908",
        },
        {
          id: "33038",
          name: "Vila do Conde",
          state_id: "2908",
        },
        {
          id: "33039",
          name: "Vilar de Andorinho",
          state_id: "2908",
        },
        {
          id: "33040",
          name: "Vilar do Paraiso",
          state_id: "2908",
        },
        {
          id: "33041",
          name: "Vilarinho",
          state_id: "2908",
        },
        {
          id: "33042",
          name: "Vilela",
          state_id: "2908",
        },
        {
          id: "33043",
          name: "Vizela",
          state_id: "2908",
        },
      ],
      Paivas: [
        {
          id: "33044",
          name: "Paivas",
          state_id: "2909",
        },
      ],
    },
  },
  PW: {
    name: "Palau",
    native: "Palau",
    phone: "680",
    continent: "OC",
    capital: "Ngerulmud",
    currency: "USD",
    languages: ["en"],
    emoji: "🇵🇼",
    emojiU: "U+1F1F5 U+1F1FC",
    states: {
      Aimeliik: [
        {
          id: "31691",
          name: "Ulimang",
          state_id: "2730",
        },
      ],
      Airai: [
        {
          id: "31692",
          name: "Airai",
          state_id: "2731",
        },
      ],
      Angaur: [
        {
          id: "31693",
          name: "Ngaramash",
          state_id: "2732",
        },
      ],
      Hatobohei: [
        {
          id: "31694",
          name: "Hatohobei",
          state_id: "2733",
        },
      ],
      Kayangel: [
        {
          id: "31695",
          name: "Kayangel",
          state_id: "2734",
        },
      ],
      Koror: [
        {
          id: "31696",
          name: "Koror",
          state_id: "2735",
        },
        {
          id: "31697",
          name: "Meyungs",
          state_id: "2735",
        },
      ],
      Melekeok: [
        {
          id: "31698",
          name: "Melekeok",
          state_id: "2736",
        },
      ],
      Ngaraard: [
        {
          id: "31699",
          name: "Ngermechau",
          state_id: "2737",
        },
      ],
      Ngardmau: [
        {
          id: "31700",
          name: "Chol",
          state_id: "2738",
        },
      ],
      Ngaremlengui: [
        {
          id: "31701",
          name: "Ollei",
          state_id: "2739",
        },
      ],
      Ngatpang: [
        {
          id: "31702",
          name: "Oikul",
          state_id: "2740",
        },
      ],
      Ngchesar: [
        {
          id: "31703",
          name: "Ngerkeai",
          state_id: "2741",
        },
      ],
      Ngerchelong: [
        {
          id: "31704",
          name: "Imeong",
          state_id: "2742",
        },
      ],
      Ngiwal: [
        {
          id: "31705",
          name: "Ngetkip",
          state_id: "2743",
        },
      ],
      Peleliu: [
        {
          id: "31706",
          name: "Kloulklubed",
          state_id: "2744",
        },
      ],
      Sonsorol: [
        {
          id: "31707",
          name: "Dongosaru",
          state_id: "2745",
        },
      ],
    },
  },
  PY: {
    name: "Paraguay",
    native: "Paraguay",
    phone: "595",
    continent: "SA",
    capital: "Asunción",
    currency: "PYG",
    languages: ["es", "gn"],
    emoji: "🇵🇾",
    emojiU: "U+1F1F5 U+1F1FE",
    states: {
      "Alto Paraguay": [],
      "Alto Parana": [],
      Amambay: [
        {
          id: "31803",
          name: "Bella Vista",
          state_id: "2796",
        },
        {
          id: "31804",
          name: "Capitan Bado",
          state_id: "2796",
        },
        {
          id: "31805",
          name: "Pedro Juan Caballero",
          state_id: "2796",
        },
      ],
      Asuncion: [
        {
          id: "31806",
          name: "Asuncion",
          state_id: "2797",
        },
      ],
      Boqueron: [
        {
          id: "31807",
          name: "Doctor Pedro P. Pena",
          state_id: "2798",
        },
        {
          id: "31808",
          name: "Filadelfia",
          state_id: "2798",
        },
        {
          id: "31809",
          name: "Marechal Estigarribia",
          state_id: "2798",
        },
        {
          id: "31810",
          name: "Menno",
          state_id: "2798",
        },
        {
          id: "31811",
          name: "Neuland",
          state_id: "2798",
        },
      ],
      Caaguazu: [
        {
          id: "31812",
          name: "Caaguazu",
          state_id: "2799",
        },
        {
          id: "31813",
          name: "Carayao",
          state_id: "2799",
        },
        {
          id: "31814",
          name: "Coronel Oviedo",
          state_id: "2799",
        },
        {
          id: "31815",
          name: "Doctor Cecilio Baez",
          state_id: "2799",
        },
        {
          id: "31816",
          name: "Doctor Eulogio Estigarribia",
          state_id: "2799",
        },
        {
          id: "31817",
          name: "Doctor Juan Manuel Frutos",
          state_id: "2799",
        },
        {
          id: "31818",
          name: "Jose Ocampos",
          state_id: "2799",
        },
        {
          id: "31819",
          name: "La Pastoria",
          state_id: "2799",
        },
        {
          id: "31820",
          name: "Marechal Francisco Solano Lope",
          state_id: "2799",
        },
        {
          id: "31821",
          name: "Mbutuy",
          state_id: "2799",
        },
        {
          id: "31822",
          name: "Nueva Londres",
          state_id: "2799",
        },
        {
          id: "31823",
          name: "Raul Arsenio Oviedo",
          state_id: "2799",
        },
        {
          id: "31824",
          name: "Repatriacion",
          state_id: "2799",
        },
        {
          id: "31825",
          name: "San Joaquin",
          state_id: "2799",
        },
        {
          id: "31826",
          name: "San Jose de los Arroyos",
          state_id: "2799",
        },
        {
          id: "31827",
          name: "Simon Bolivar",
          state_id: "2799",
        },
        {
          id: "31828",
          name: "Tres Corrales",
          state_id: "2799",
        },
        {
          id: "31829",
          name: "Tres de Febrero",
          state_id: "2799",
        },
        {
          id: "31830",
          name: "Vaqueria",
          state_id: "2799",
        },
        {
          id: "31831",
          name: "Yhu",
          state_id: "2799",
        },
      ],
      Caazapa: [
        {
          id: "31832",
          name: "Abai",
          state_id: "2800",
        },
        {
          id: "31833",
          name: "Buena Vista",
          state_id: "2800",
        },
        {
          id: "31834",
          name: "Caazapa",
          state_id: "2800",
        },
        {
          id: "31835",
          name: "Doctor Moises Bertoni",
          state_id: "2800",
        },
        {
          id: "31836",
          name: "General Higinio Morinigo",
          state_id: "2800",
        },
        {
          id: "31837",
          name: "Maciel",
          state_id: "2800",
        },
        {
          id: "31838",
          name: "San Juan Nepomuceno",
          state_id: "2800",
        },
        {
          id: "31839",
          name: "Tavai",
          state_id: "2800",
        },
        {
          id: "31840",
          name: "Yegros",
          state_id: "2800",
        },
        {
          id: "31841",
          name: "Yuty",
          state_id: "2800",
        },
      ],
      Canendiyu: [
        {
          id: "31842",
          name: "Corpus Christi",
          state_id: "2801",
        },
        {
          id: "31843",
          name: "Curuguaty",
          state_id: "2801",
        },
        {
          id: "31844",
          name: "General Francisco Alvarez",
          state_id: "2801",
        },
        {
          id: "31845",
          name: "Itanara",
          state_id: "2801",
        },
        {
          id: "31846",
          name: "Katuete",
          state_id: "2801",
        },
        {
          id: "31847",
          name: "La Paloma",
          state_id: "2801",
        },
        {
          id: "31848",
          name: "Nueva Esperanza",
          state_id: "2801",
        },
        {
          id: "31849",
          name: "Salto del Guaira",
          state_id: "2801",
        },
        {
          id: "31850",
          name: "Ygatimi",
          state_id: "2801",
        },
        {
          id: "31851",
          name: "Ypehu",
          state_id: "2801",
        },
      ],
      Central: [
        {
          id: "31852",
          name: "Aregua",
          state_id: "2802",
        },
        {
          id: "31853",
          name: "Capiata",
          state_id: "2802",
        },
        {
          id: "31854",
          name: "Fernando de la Mora",
          state_id: "2802",
        },
        {
          id: "31855",
          name: "Guarambare",
          state_id: "2802",
        },
        {
          id: "31856",
          name: "Ita",
          state_id: "2802",
        },
        {
          id: "31857",
          name: "Itaugua",
          state_id: "2802",
        },
        {
          id: "31858",
          name: "Juan Augusto Saldivar",
          state_id: "2802",
        },
        {
          id: "31859",
          name: "Lambare",
          state_id: "2802",
        },
        {
          id: "31860",
          name: "Limpio",
          state_id: "2802",
        },
        {
          id: "31861",
          name: "Luque",
          state_id: "2802",
        },
        {
          id: "31862",
          name: "Nemby",
          state_id: "2802",
        },
        {
          id: "31863",
          name: "Nueva Italia",
          state_id: "2802",
        },
        {
          id: "31864",
          name: "San Antonio",
          state_id: "2802",
        },
        {
          id: "31865",
          name: "San Lorenzo",
          state_id: "2802",
        },
        {
          id: "31866",
          name: "Villa Elisa",
          state_id: "2802",
        },
        {
          id: "31867",
          name: "Villeta",
          state_id: "2802",
        },
        {
          id: "31868",
          name: "Ypacarai",
          state_id: "2802",
        },
        {
          id: "31869",
          name: "Ypane",
          state_id: "2802",
        },
      ],
      Concepcion: [
        {
          id: "31870",
          name: "Belen",
          state_id: "2803",
        },
        {
          id: "31871",
          name: "Concepcion",
          state_id: "2803",
        },
        {
          id: "31872",
          name: "Horqueta",
          state_id: "2803",
        },
        {
          id: "31873",
          name: "Loreto",
          state_id: "2803",
        },
        {
          id: "31874",
          name: "San Carlos",
          state_id: "2803",
        },
        {
          id: "31875",
          name: "San Lazaro",
          state_id: "2803",
        },
      ],
      Cordillera: [
        {
          id: "31876",
          name: "Altos",
          state_id: "2804",
        },
        {
          id: "31877",
          name: "Arroyos y Esteros",
          state_id: "2804",
        },
        {
          id: "31878",
          name: "Atyra",
          state_id: "2804",
        },
        {
          id: "31879",
          name: "Caacupe",
          state_id: "2804",
        },
        {
          id: "31880",
          name: "Caraguatay",
          state_id: "2804",
        },
        {
          id: "31881",
          name: "Emboscada",
          state_id: "2804",
        },
        {
          id: "31882",
          name: "Eusebio Ayala",
          state_id: "2804",
        },
        {
          id: "31883",
          name: "Isla Pucu",
          state_id: "2804",
        },
        {
          id: "31884",
          name: "Itacurubi de la Cordillera",
          state_id: "2804",
        },
        {
          id: "31885",
          name: "Juan de Mena",
          state_id: "2804",
        },
        {
          id: "31886",
          name: "Loma Grande",
          state_id: "2804",
        },
        {
          id: "31887",
          name: "Mbocayty del Yhaguy",
          state_id: "2804",
        },
        {
          id: "31888",
          name: "Nueva Colombia",
          state_id: "2804",
        },
        {
          id: "31889",
          name: "Piribebuy",
          state_id: "2804",
        },
        {
          id: "31890",
          name: "Primero de Marzo",
          state_id: "2804",
        },
        {
          id: "31891",
          name: "San Bernardino",
          state_id: "2804",
        },
        {
          id: "31892",
          name: "San Jose Obrero",
          state_id: "2804",
        },
        {
          id: "31893",
          name: "Santa Elena",
          state_id: "2804",
        },
        {
          id: "31894",
          name: "Tobati",
          state_id: "2804",
        },
        {
          id: "31895",
          name: "Valenzuela",
          state_id: "2804",
        },
      ],
      Guaira: [
        {
          id: "31896",
          name: "Borja",
          state_id: "2805",
        },
        {
          id: "31897",
          name: "Capitan Mauricio Jose Troche",
          state_id: "2805",
        },
        {
          id: "31898",
          name: "Coronel Martinez",
          state_id: "2805",
        },
        {
          id: "31899",
          name: "Doctor Botrell",
          state_id: "2805",
        },
        {
          id: "31900",
          name: "Felix Perez Cardozo",
          state_id: "2805",
        },
        {
          id: "31901",
          name: "General Eugenio Alejandrino Ga",
          state_id: "2805",
        },
        {
          id: "31902",
          name: "Independencia",
          state_id: "2805",
        },
        {
          id: "31903",
          name: "Itape",
          state_id: "2805",
        },
        {
          id: "31904",
          name: "Iturbe",
          state_id: "2805",
        },
        {
          id: "31905",
          name: "Jose Fasardi",
          state_id: "2805",
        },
        {
          id: "31906",
          name: "Mbocayaty",
          state_id: "2805",
        },
        {
          id: "31907",
          name: "Natalicio Talavera",
          state_id: "2805",
        },
        {
          id: "31908",
          name: "Numi",
          state_id: "2805",
        },
        {
          id: "31909",
          name: "Paso Yobai",
          state_id: "2805",
        },
        {
          id: "31910",
          name: "San Salvador",
          state_id: "2805",
        },
        {
          id: "31911",
          name: "Villarrica",
          state_id: "2805",
        },
        {
          id: "31912",
          name: "Yataity",
          state_id: "2805",
        },
      ],
      Itapua: [
        {
          id: "31913",
          name: "Alto Vera",
          state_id: "2806",
        },
        {
          id: "31914",
          name: "Bella Vista",
          state_id: "2806",
        },
        {
          id: "31915",
          name: "Cambyreta",
          state_id: "2806",
        },
        {
          id: "31916",
          name: "Capitan Meza",
          state_id: "2806",
        },
        {
          id: "31917",
          name: "Capitan Miranda",
          state_id: "2806",
        },
        {
          id: "31918",
          name: "Carlos Antonio Lopez",
          state_id: "2806",
        },
        {
          id: "31919",
          name: "Carmen del Parana",
          state_id: "2806",
        },
        {
          id: "31920",
          name: "Coronel Bogado",
          state_id: "2806",
        },
        {
          id: "31921",
          name: "Edelira",
          state_id: "2806",
        },
        {
          id: "31922",
          name: "Encarnacion",
          state_id: "2806",
        },
        {
          id: "31923",
          name: "Fram",
          state_id: "2806",
        },
        {
          id: "31924",
          name: "General Artigas",
          state_id: "2806",
        },
        {
          id: "31925",
          name: "General Delgado",
          state_id: "2806",
        },
        {
          id: "31926",
          name: "Hohenau",
          state_id: "2806",
        },
        {
          id: "31927",
          name: "Itapua Poty",
          state_id: "2806",
        },
        {
          id: "31928",
          name: "Jesus",
          state_id: "2806",
        },
        {
          id: "31929",
          name: "La Paz",
          state_id: "2806",
        },
        {
          id: "31930",
          name: "Leandro Oviedo",
          state_id: "2806",
        },
        {
          id: "31931",
          name: "Mayor Otano",
          state_id: "2806",
        },
        {
          id: "31932",
          name: "Natalio",
          state_id: "2806",
        },
        {
          id: "31933",
          name: "Nueva Alborada",
          state_id: "2806",
        },
        {
          id: "31934",
          name: "Obligado",
          state_id: "2806",
        },
        {
          id: "31935",
          name: "Pirapo",
          state_id: "2806",
        },
        {
          id: "31936",
          name: "San Cosme y Damian",
          state_id: "2806",
        },
        {
          id: "31937",
          name: "San Juan del Parana",
          state_id: "2806",
        },
        {
          id: "31938",
          name: "San Pedro del Parana",
          state_id: "2806",
        },
        {
          id: "31939",
          name: "San Rafael del Parana",
          state_id: "2806",
        },
        {
          id: "31940",
          name: "Tomas Romero Pereira",
          state_id: "2806",
        },
        {
          id: "31941",
          name: "Trinidad",
          state_id: "2806",
        },
        {
          id: "31942",
          name: "Yatytay",
          state_id: "2806",
        },
      ],
      Misiones: [
        {
          id: "31943",
          name: "Ayolas",
          state_id: "2807",
        },
        {
          id: "31944",
          name: "San Ignacio",
          state_id: "2807",
        },
        {
          id: "31945",
          name: "San Juan Bautista",
          state_id: "2807",
        },
        {
          id: "31946",
          name: "San Miguel",
          state_id: "2807",
        },
        {
          id: "31947",
          name: "San Patricio",
          state_id: "2807",
        },
        {
          id: "31948",
          name: "Santa Maria",
          state_id: "2807",
        },
        {
          id: "31949",
          name: "Santa Rosa",
          state_id: "2807",
        },
        {
          id: "31950",
          name: "Santiago",
          state_id: "2807",
        },
        {
          id: "31951",
          name: "Villa Florida",
          state_id: "2807",
        },
        {
          id: "31952",
          name: "Yabebyry",
          state_id: "2807",
        },
      ],
      Neembucu: [
        {
          id: "31953",
          name: "Alberdi",
          state_id: "2808",
        },
        {
          id: "31954",
          name: "Cerrito",
          state_id: "2808",
        },
        {
          id: "31955",
          name: "Desmochados",
          state_id: "2808",
        },
        {
          id: "31956",
          name: "General Jose Eduvigis Diaz",
          state_id: "2808",
        },
        {
          id: "31957",
          name: "Guazu Cua",
          state_id: "2808",
        },
        {
          id: "31958",
          name: "Humaita",
          state_id: "2808",
        },
        {
          id: "31959",
          name: "Isla Umbu",
          state_id: "2808",
        },
        {
          id: "31960",
          name: "Laureles",
          state_id: "2808",
        },
        {
          id: "31961",
          name: "Mayor Jose Dejesus Martinez",
          state_id: "2808",
        },
        {
          id: "31962",
          name: "Paso de Patria",
          state_id: "2808",
        },
        {
          id: "31963",
          name: "Pilar",
          state_id: "2808",
        },
        {
          id: "31964",
          name: "San Juan Bautista de Neembucu",
          state_id: "2808",
        },
        {
          id: "31965",
          name: "Tacuaras",
          state_id: "2808",
        },
        {
          id: "31966",
          name: "Villa Franca",
          state_id: "2808",
        },
        {
          id: "31967",
          name: "Villa Oliva",
          state_id: "2808",
        },
        {
          id: "31968",
          name: "Villalbin",
          state_id: "2808",
        },
      ],
      Paraguari: [
        {
          id: "31969",
          name: "Acahay",
          state_id: "2809",
        },
        {
          id: "31970",
          name: "Caapucu",
          state_id: "2809",
        },
        {
          id: "31971",
          name: "Carapegua",
          state_id: "2809",
        },
        {
          id: "31972",
          name: "Escobar",
          state_id: "2809",
        },
        {
          id: "31973",
          name: "General Bernardino Caballero",
          state_id: "2809",
        },
        {
          id: "31974",
          name: "La Colmena",
          state_id: "2809",
        },
        {
          id: "31975",
          name: "Mbuyapey",
          state_id: "2809",
        },
        {
          id: "31976",
          name: "Paraguari",
          state_id: "2809",
        },
        {
          id: "31977",
          name: "Pirayu",
          state_id: "2809",
        },
        {
          id: "31978",
          name: "Quiindy",
          state_id: "2809",
        },
        {
          id: "31979",
          name: "Quyquyho",
          state_id: "2809",
        },
        {
          id: "31980",
          name: "San Roque Gonzalez de Santa Cr",
          state_id: "2809",
        },
        {
          id: "31981",
          name: "Sapucai",
          state_id: "2809",
        },
        {
          id: "31982",
          name: "Tebicuarymi",
          state_id: "2809",
        },
        {
          id: "31983",
          name: "Yaguaron",
          state_id: "2809",
        },
        {
          id: "31984",
          name: "Ybycui",
          state_id: "2809",
        },
        {
          id: "31985",
          name: "Ybytimi",
          state_id: "2809",
        },
      ],
      "Presidente Hayes": [],
      "San Pedro": [],
    },
  },
  QA: {
    name: "Qatar",
    native: "قطر",
    phone: "974",
    continent: "AS",
    capital: "Doha",
    currency: "QAR",
    languages: ["ar"],
    emoji: "🇶🇦",
    emojiU: "U+1F1F6 U+1F1E6",
    states: {
      Doha: [
        {
          id: "33093",
          name: "Doha",
          state_id: "2920",
        },
      ],
      "Jarian-al-Batnah": [
        {
          id: "33094",
          name: "Umm Bab",
          state_id: "2921",
        },
      ],
      "Umm Salal": [],
      "ad-Dawhah": [
        {
          id: "33095",
          name: "ad-Dawhah",
          state_id: "2923",
        },
      ],
      "al-Ghuwayriyah": [
        {
          id: "33096",
          name: "al-Ghuwayriyah",
          state_id: "2924",
        },
      ],
      "al-Jumayliyah": [
        {
          id: "33097",
          name: "Dukhan",
          state_id: "2925",
        },
        {
          id: "33098",
          name: "al-Jumayliyah",
          state_id: "2925",
        },
      ],
      "al-Khawr": [
        {
          id: "33099",
          name: "al-Khawr",
          state_id: "2926",
        },
      ],
      "al-Wakrah": [
        {
          id: "33100",
          name: "Musay''id",
          state_id: "2927",
        },
        {
          id: "33101",
          name: "al-Wakrah",
          state_id: "2927",
        },
        {
          id: "33102",
          name: "al-Wukayr",
          state_id: "2927",
        },
      ],
      "ar-Rayyan": [
        {
          id: "33103",
          name: "ar-Rayyan",
          state_id: "2928",
        },
        {
          id: "33104",
          name: "ash-Shahaniyah",
          state_id: "2928",
        },
      ],
      "ash-Shamal": [
        {
          id: "33105",
          name: "ar-Ruways",
          state_id: "2929",
        },
      ],
    },
  },
  RE: {
    name: "Réunion",
    native: "La Réunion",
    phone: "262",
    continent: "AF",
    capital: "Saint-Denis",
    currency: "EUR",
    languages: ["fr"],
    emoji: "🇷🇪",
    emojiU: "U+1F1F7 U+1F1EA",
    states: {
      "Saint-Benoit": [
        {
          id: "33106",
          name: "Bras-Panon",
          state_id: "2930",
        },
        {
          id: "33107",
          name: "Saint-Andre",
          state_id: "2930",
        },
        {
          id: "33108",
          name: "Saint-Benoit",
          state_id: "2930",
        },
        {
          id: "33109",
          name: "Sainte-Rose",
          state_id: "2930",
        },
        {
          id: "33110",
          name: "Salazie",
          state_id: "2930",
        },
      ],
      "Saint-Denis": [
        {
          id: "33111",
          name: "La Possession",
          state_id: "2931",
        },
        {
          id: "33112",
          name: "Le Port",
          state_id: "2931",
        },
        {
          id: "33113",
          name: "Saint-Denis",
          state_id: "2931",
        },
        {
          id: "33114",
          name: "Sainte-Marie",
          state_id: "2931",
        },
        {
          id: "33115",
          name: "Sainte-Suzanne",
          state_id: "2931",
        },
      ],
      "Saint-Paul": [
        {
          id: "33116",
          name: "L''Etang-Sale",
          state_id: "2932",
        },
        {
          id: "33117",
          name: "Les Aviron",
          state_id: "2932",
        },
        {
          id: "33118",
          name: "Les Trois-Bassins",
          state_id: "2932",
        },
        {
          id: "33119",
          name: "Saint-Leu",
          state_id: "2932",
        },
        {
          id: "33120",
          name: "Saint-Paul",
          state_id: "2932",
        },
      ],
      "Saint-Pierre": [
        {
          id: "33121",
          name: "Cilaos",
          state_id: "2933",
        },
        {
          id: "33122",
          name: "Entre-Deux",
          state_id: "2933",
        },
        {
          id: "33123",
          name: "Le Tampon",
          state_id: "2933",
        },
        {
          id: "33124",
          name: "Petite-Ile",
          state_id: "2933",
        },
        {
          id: "33125",
          name: "Saint-Joseph",
          state_id: "2933",
        },
        {
          id: "33126",
          name: "Saint-Louis",
          state_id: "2933",
        },
        {
          id: "33127",
          name: "Saint-Philippe",
          state_id: "2933",
        },
        {
          id: "33128",
          name: "Saint-Pierre",
          state_id: "2933",
        },
      ],
    },
  },
  RO: {
    name: "Romania",
    native: "România",
    phone: "40",
    continent: "EU",
    capital: "Bucharest",
    currency: "RON",
    languages: ["ro"],
    emoji: "🇷🇴",
    emojiU: "U+1F1F7 U+1F1F4",
    states: {
      Alba: [
        {
          id: "33129",
          name: "Abrud",
          state_id: "2934",
        },
        {
          id: "33130",
          name: "Aiud",
          state_id: "2934",
        },
        {
          id: "33131",
          name: "Alba Iulia",
          state_id: "2934",
        },
        {
          id: "33132",
          name: "Albac",
          state_id: "2934",
        },
        {
          id: "33133",
          name: "Almasu Mare",
          state_id: "2934",
        },
        {
          id: "33134",
          name: "Arieseni",
          state_id: "2934",
        },
        {
          id: "33135",
          name: "Avram Iancu",
          state_id: "2934",
        },
        {
          id: "33136",
          name: "Baia de Aries",
          state_id: "2934",
        },
        {
          id: "33137",
          name: "Berghin",
          state_id: "2934",
        },
        {
          id: "33138",
          name: "Bistra",
          state_id: "2934",
        },
        {
          id: "33139",
          name: "Blaj",
          state_id: "2934",
        },
        {
          id: "33140",
          name: "Blandiana",
          state_id: "2934",
        },
        {
          id: "33141",
          name: "Bucium",
          state_id: "2934",
        },
        {
          id: "33142",
          name: "Calnic",
          state_id: "2934",
        },
        {
          id: "33143",
          name: "Campeni",
          state_id: "2934",
        },
        {
          id: "33144",
          name: "Cenade",
          state_id: "2934",
        },
        {
          id: "33145",
          name: "Cergau",
          state_id: "2934",
        },
        {
          id: "33146",
          name: "Ceru-Bacainti",
          state_id: "2934",
        },
        {
          id: "33147",
          name: "Cetatea de Balta",
          state_id: "2934",
        },
        {
          id: "33148",
          name: "Ciugud",
          state_id: "2934",
        },
        {
          id: "33149",
          name: "Ciuruleasa",
          state_id: "2934",
        },
        {
          id: "33150",
          name: "Craciunelu de Jos",
          state_id: "2934",
        },
        {
          id: "33151",
          name: "Cricau",
          state_id: "2934",
        },
        {
          id: "33152",
          name: "Cugir",
          state_id: "2934",
        },
        {
          id: "33153",
          name: "Daia Romana",
          state_id: "2934",
        },
        {
          id: "33154",
          name: "Dostat",
          state_id: "2934",
        },
        {
          id: "33155",
          name: "Farau",
          state_id: "2934",
        },
        {
          id: "33156",
          name: "Galda de Jos",
          state_id: "2934",
        },
        {
          id: "33157",
          name: "Garbova",
          state_id: "2934",
        },
        {
          id: "33158",
          name: "Garda de Sus",
          state_id: "2934",
        },
        {
          id: "33159",
          name: "Hoparta",
          state_id: "2934",
        },
        {
          id: "33160",
          name: "Horea",
          state_id: "2934",
        },
        {
          id: "33161",
          name: "Ighiu",
          state_id: "2934",
        },
        {
          id: "33162",
          name: "Intregalde",
          state_id: "2934",
        },
        {
          id: "33163",
          name: "Jidvei",
          state_id: "2934",
        },
        {
          id: "33164",
          name: "Livezile",
          state_id: "2934",
        },
        {
          id: "33165",
          name: "Lopadea Noua",
          state_id: "2934",
        },
        {
          id: "33166",
          name: "Lunca Muresului",
          state_id: "2934",
        },
        {
          id: "33167",
          name: "Lupsa",
          state_id: "2934",
        },
        {
          id: "33168",
          name: "Metes",
          state_id: "2934",
        },
        {
          id: "33169",
          name: "Mihalt",
          state_id: "2934",
        },
        {
          id: "33170",
          name: "Miraslau",
          state_id: "2934",
        },
        {
          id: "33171",
          name: "Mogos",
          state_id: "2934",
        },
        {
          id: "33172",
          name: "Noslac",
          state_id: "2934",
        },
        {
          id: "33173",
          name: "Ocna Mures",
          state_id: "2934",
        },
        {
          id: "33174",
          name: "Ocolis",
          state_id: "2934",
        },
        {
          id: "33175",
          name: "Ohaba",
          state_id: "2934",
        },
        {
          id: "33176",
          name: "Pianu",
          state_id: "2934",
        },
        {
          id: "33177",
          name: "Poiana Vadului",
          state_id: "2934",
        },
        {
          id: "33178",
          name: "Ponor",
          state_id: "2934",
        },
        {
          id: "33179",
          name: "Posaga",
          state_id: "2934",
        },
        {
          id: "33180",
          name: "Radesti",
          state_id: "2934",
        },
        {
          id: "33181",
          name: "Ramet",
          state_id: "2934",
        },
        {
          id: "33182",
          name: "Rimetea",
          state_id: "2934",
        },
        {
          id: "33183",
          name: "Rosia Montana",
          state_id: "2934",
        },
        {
          id: "33184",
          name: "Rosia de Secas",
          state_id: "2934",
        },
        {
          id: "33185",
          name: "Salciua",
          state_id: "2934",
        },
        {
          id: "33186",
          name: "Salistea",
          state_id: "2934",
        },
        {
          id: "33187",
          name: "Sancel",
          state_id: "2934",
        },
        {
          id: "33188",
          name: "Santimbru",
          state_id: "2934",
        },
        {
          id: "33189",
          name: "Sasciori",
          state_id: "2934",
        },
        {
          id: "33190",
          name: "Scarisoara",
          state_id: "2934",
        },
        {
          id: "33191",
          name: "Sebes",
          state_id: "2934",
        },
        {
          id: "33192",
          name: "Sibot",
          state_id: "2934",
        },
        {
          id: "33193",
          name: "Sohodol",
          state_id: "2934",
        },
        {
          id: "33194",
          name: "Sona",
          state_id: "2934",
        },
        {
          id: "33195",
          name: "Spring",
          state_id: "2934",
        },
        {
          id: "33196",
          name: "Stremt",
          state_id: "2934",
        },
        {
          id: "33197",
          name: "Sugag",
          state_id: "2934",
        },
        {
          id: "33198",
          name: "Teius",
          state_id: "2934",
        },
        {
          id: "33199",
          name: "Unirea",
          state_id: "2934",
        },
        {
          id: "33200",
          name: "Vadu Motilor",
          state_id: "2934",
        },
        {
          id: "33201",
          name: "Valea Lunga",
          state_id: "2934",
        },
        {
          id: "33202",
          name: "Vidra",
          state_id: "2934",
        },
        {
          id: "33203",
          name: "Vintu de Jos",
          state_id: "2934",
        },
        {
          id: "33204",
          name: "Zlatna",
          state_id: "2934",
        },
      ],
      Arad: [
        {
          id: "33205",
          name: "Almas",
          state_id: "2935",
        },
        {
          id: "33206",
          name: "Apateu",
          state_id: "2935",
        },
        {
          id: "33207",
          name: "Arad",
          state_id: "2935",
        },
        {
          id: "33208",
          name: "Archis",
          state_id: "2935",
        },
        {
          id: "33209",
          name: "Barsa",
          state_id: "2935",
        },
        {
          id: "33210",
          name: "Barzava",
          state_id: "2935",
        },
        {
          id: "33211",
          name: "Bata",
          state_id: "2935",
        },
        {
          id: "33212",
          name: "Beliu",
          state_id: "2935",
        },
        {
          id: "33213",
          name: "Birchis",
          state_id: "2935",
        },
        {
          id: "33214",
          name: "Bocsig",
          state_id: "2935",
        },
        {
          id: "33215",
          name: "Brazii",
          state_id: "2935",
        },
        {
          id: "33216",
          name: "Buteni",
          state_id: "2935",
        },
        {
          id: "33217",
          name: "Carand",
          state_id: "2935",
        },
        {
          id: "33218",
          name: "Cermei",
          state_id: "2935",
        },
        {
          id: "33219",
          name: "Chisindia",
          state_id: "2935",
        },
        {
          id: "33220",
          name: "Chisineu Cris",
          state_id: "2935",
        },
        {
          id: "33221",
          name: "Conop",
          state_id: "2935",
        },
        {
          id: "33222",
          name: "Covasint",
          state_id: "2935",
        },
        {
          id: "33223",
          name: "Craiva",
          state_id: "2935",
        },
        {
          id: "33224",
          name: "Curtici",
          state_id: "2935",
        },
        {
          id: "33225",
          name: "Dezna",
          state_id: "2935",
        },
        {
          id: "33226",
          name: "Dieci",
          state_id: "2935",
        },
        {
          id: "33227",
          name: "Dorgos",
          state_id: "2935",
        },
        {
          id: "33228",
          name: "Fantanele",
          state_id: "2935",
        },
        {
          id: "33229",
          name: "Felnac",
          state_id: "2935",
        },
        {
          id: "33230",
          name: "Ghioroc",
          state_id: "2935",
        },
        {
          id: "33231",
          name: "Graniceri",
          state_id: "2935",
        },
        {
          id: "33232",
          name: "Gurahont",
          state_id: "2935",
        },
        {
          id: "33233",
          name: "Halmagel",
          state_id: "2935",
        },
        {
          id: "33234",
          name: "Halmagiu",
          state_id: "2935",
        },
        {
          id: "33235",
          name: "Hasmas",
          state_id: "2935",
        },
        {
          id: "33236",
          name: "Ignesti",
          state_id: "2935",
        },
        {
          id: "33237",
          name: "Ineu",
          state_id: "2935",
        },
        {
          id: "33238",
          name: "Iratosu",
          state_id: "2935",
        },
        {
          id: "33239",
          name: "Lipova",
          state_id: "2935",
        },
        {
          id: "33240",
          name: "Livada",
          state_id: "2935",
        },
        {
          id: "33241",
          name: "Macea",
          state_id: "2935",
        },
        {
          id: "33242",
          name: "Masca",
          state_id: "2935",
        },
        {
          id: "33243",
          name: "Moneasa",
          state_id: "2935",
        },
        {
          id: "33244",
          name: "Nadlac",
          state_id: "2935",
        },
        {
          id: "33245",
          name: "Olari",
          state_id: "2935",
        },
        {
          id: "33246",
          name: "Pancota",
          state_id: "2935",
        },
        {
          id: "33247",
          name: "Paulis",
          state_id: "2935",
        },
        {
          id: "33248",
          name: "Pecica",
          state_id: "2935",
        },
        {
          id: "33249",
          name: "Peregu Mare",
          state_id: "2935",
        },
        {
          id: "33250",
          name: "Petris",
          state_id: "2935",
        },
        {
          id: "33251",
          name: "Pilu",
          state_id: "2935",
        },
        {
          id: "33252",
          name: "Plescuta",
          state_id: "2935",
        },
        {
          id: "33253",
          name: "Sagu",
          state_id: "2935",
        },
        {
          id: "33254",
          name: "Santana",
          state_id: "2935",
        },
        {
          id: "33255",
          name: "Savarsin",
          state_id: "2935",
        },
        {
          id: "33256",
          name: "Sebis",
          state_id: "2935",
        },
        {
          id: "33257",
          name: "Secusigiu",
          state_id: "2935",
        },
        {
          id: "33258",
          name: "Seitin",
          state_id: "2935",
        },
        {
          id: "33259",
          name: "Seleus",
          state_id: "2935",
        },
        {
          id: "33260",
          name: "Semlac",
          state_id: "2935",
        },
        {
          id: "33261",
          name: "Sepreus",
          state_id: "2935",
        },
        {
          id: "33262",
          name: "Sicula",
          state_id: "2935",
        },
        {
          id: "33263",
          name: "Silindia",
          state_id: "2935",
        },
        {
          id: "33264",
          name: "Simand",
          state_id: "2935",
        },
        {
          id: "33265",
          name: "Sintea Mare",
          state_id: "2935",
        },
        {
          id: "33266",
          name: "Siria",
          state_id: "2935",
        },
        {
          id: "33267",
          name: "Sistarovat",
          state_id: "2935",
        },
        {
          id: "33268",
          name: "Socodor",
          state_id: "2935",
        },
        {
          id: "33269",
          name: "Sofronea",
          state_id: "2935",
        },
        {
          id: "33270",
          name: "Tarnova",
          state_id: "2935",
        },
        {
          id: "33271",
          name: "Taut",
          state_id: "2935",
        },
        {
          id: "33272",
          name: "Varadia de Mures",
          state_id: "2935",
        },
        {
          id: "33273",
          name: "Varfurile",
          state_id: "2935",
        },
        {
          id: "33274",
          name: "Vinga",
          state_id: "2935",
        },
        {
          id: "33275",
          name: "Vladimirescu",
          state_id: "2935",
        },
        {
          id: "33276",
          name: "Zabrani",
          state_id: "2935",
        },
        {
          id: "33277",
          name: "Zarand",
          state_id: "2935",
        },
        {
          id: "33278",
          name: "Zerind",
          state_id: "2935",
        },
        {
          id: "33279",
          name: "Zimandu Nou",
          state_id: "2935",
        },
      ],
      Arges: [
        {
          id: "33280",
          name: "Albesti",
          state_id: "2936",
        },
        {
          id: "33281",
          name: "Albestii-Pamanteni",
          state_id: "2936",
        },
        {
          id: "33282",
          name: "Albota",
          state_id: "2936",
        },
        {
          id: "33283",
          name: "Aninoasa",
          state_id: "2936",
        },
        {
          id: "33284",
          name: "Arefu",
          state_id: "2936",
        },
        {
          id: "33285",
          name: "Babana",
          state_id: "2936",
        },
        {
          id: "33286",
          name: "Baiculesti",
          state_id: "2936",
        },
        {
          id: "33287",
          name: "Balilesti",
          state_id: "2936",
        },
        {
          id: "33288",
          name: "Barla",
          state_id: "2936",
        },
        {
          id: "33289",
          name: "Bascov",
          state_id: "2936",
        },
        {
          id: "33290",
          name: "Beleti-Negresti",
          state_id: "2936",
        },
        {
          id: "33291",
          name: "Berevoesti",
          state_id: "2936",
        },
        {
          id: "33292",
          name: "Bogati",
          state_id: "2936",
        },
        {
          id: "33293",
          name: "Boteni",
          state_id: "2936",
        },
        {
          id: "33294",
          name: "Botesti",
          state_id: "2936",
        },
        {
          id: "33295",
          name: "Bradu",
          state_id: "2936",
        },
        {
          id: "33296",
          name: "Bradulet",
          state_id: "2936",
        },
        {
          id: "33297",
          name: "Budeasa",
          state_id: "2936",
        },
        {
          id: "33298",
          name: "Bughea de Jos",
          state_id: "2936",
        },
        {
          id: "33299",
          name: "Buzoesti",
          state_id: "2936",
        },
        {
          id: "33300",
          name: "Caldararu",
          state_id: "2936",
        },
        {
          id: "33301",
          name: "Calinesti",
          state_id: "2936",
        },
        {
          id: "33302",
          name: "Campulung",
          state_id: "2936",
        },
        {
          id: "33303",
          name: "Cateasca",
          state_id: "2936",
        },
        {
          id: "33304",
          name: "Cepari",
          state_id: "2936",
        },
        {
          id: "33305",
          name: "Cetateni",
          state_id: "2936",
        },
        {
          id: "33306",
          name: "Cicanesti",
          state_id: "2936",
        },
        {
          id: "33307",
          name: "Ciofrangeni",
          state_id: "2936",
        },
        {
          id: "33308",
          name: "Ciomagesti",
          state_id: "2936",
        },
        {
          id: "33309",
          name: "Cocu",
          state_id: "2936",
        },
        {
          id: "33310",
          name: "Corbeni",
          state_id: "2936",
        },
        {
          id: "33311",
          name: "Corbi",
          state_id: "2936",
        },
        {
          id: "33312",
          name: "Cosesti",
          state_id: "2936",
        },
        {
          id: "33313",
          name: "Costesti",
          state_id: "2936",
        },
        {
          id: "33314",
          name: "Cotmeana",
          state_id: "2936",
        },
        {
          id: "33315",
          name: "Cuca",
          state_id: "2936",
        },
        {
          id: "33316",
          name: "Curtea de Arges",
          state_id: "2936",
        },
        {
          id: "33317",
          name: "Dambovicioara",
          state_id: "2936",
        },
        {
          id: "33318",
          name: "Darmanesti",
          state_id: "2936",
        },
        {
          id: "33319",
          name: "Davidesti",
          state_id: "2936",
        },
        {
          id: "33320",
          name: "Dobresti",
          state_id: "2936",
        },
        {
          id: "33321",
          name: "Domnesti",
          state_id: "2936",
        },
        {
          id: "33322",
          name: "Draganu",
          state_id: "2936",
        },
        {
          id: "33323",
          name: "Dragoslavele",
          state_id: "2936",
        },
        {
          id: "33324",
          name: "Godeni",
          state_id: "2936",
        },
        {
          id: "33325",
          name: "Harsesti",
          state_id: "2936",
        },
        {
          id: "33326",
          name: "Hartiesti",
          state_id: "2936",
        },
        {
          id: "33327",
          name: "Izvoru",
          state_id: "2936",
        },
        {
          id: "33328",
          name: "Leordeni",
          state_id: "2936",
        },
        {
          id: "33329",
          name: "Leresti",
          state_id: "2936",
        },
        {
          id: "33330",
          name: "Lunca Corbului",
          state_id: "2936",
        },
        {
          id: "33331",
          name: "Malureni",
          state_id: "2936",
        },
        {
          id: "33332",
          name: "Maracineni",
          state_id: "2936",
        },
        {
          id: "33333",
          name: "Merisani",
          state_id: "2936",
        },
        {
          id: "33334",
          name: "Micesti",
          state_id: "2936",
        },
        {
          id: "33335",
          name: "Mihaesti",
          state_id: "2936",
        },
        {
          id: "33336",
          name: "Mioarele",
          state_id: "2936",
        },
        {
          id: "33337",
          name: "Mioveni",
          state_id: "2936",
        },
        {
          id: "33338",
          name: "Mirosi",
          state_id: "2936",
        },
        {
          id: "33339",
          name: "Moraresti",
          state_id: "2936",
        },
        {
          id: "33340",
          name: "Mosoaia",
          state_id: "2936",
        },
        {
          id: "33341",
          name: "Mozaceni",
          state_id: "2936",
        },
        {
          id: "33342",
          name: "Musatesti",
          state_id: "2936",
        },
        {
          id: "33343",
          name: "Negrasi",
          state_id: "2936",
        },
        {
          id: "33344",
          name: "Nucsoara",
          state_id: "2936",
        },
        {
          id: "33345",
          name: "Oarja",
          state_id: "2936",
        },
        {
          id: "33346",
          name: "Pietrosani",
          state_id: "2936",
        },
        {
          id: "33347",
          name: "Pitesti",
          state_id: "2936",
        },
        {
          id: "33348",
          name: "Poenari",
          state_id: "2936",
        },
        {
          id: "33349",
          name: "Poiana Lacului",
          state_id: "2936",
        },
        {
          id: "33350",
          name: "Popesti",
          state_id: "2936",
        },
        {
          id: "33351",
          name: "Priboieni",
          state_id: "2936",
        },
        {
          id: "33352",
          name: "Ratesti",
          state_id: "2936",
        },
        {
          id: "33353",
          name: "Recea",
          state_id: "2936",
        },
        {
          id: "33354",
          name: "Rociu",
          state_id: "2936",
        },
        {
          id: "33355",
          name: "Rucar",
          state_id: "2936",
        },
        {
          id: "33356",
          name: "Salatrucu",
          state_id: "2936",
        },
        {
          id: "33357",
          name: "Sapata",
          state_id: "2936",
        },
        {
          id: "33358",
          name: "Schitu-Golesti",
          state_id: "2936",
        },
        {
          id: "33359",
          name: "Slobozia",
          state_id: "2936",
        },
        {
          id: "33360",
          name: "Stalpeni",
          state_id: "2936",
        },
        {
          id: "33361",
          name: "Stefan cel Mare",
          state_id: "2936",
        },
        {
          id: "33362",
          name: "Stefanesti",
          state_id: "2936",
        },
        {
          id: "33363",
          name: "Stoenesti",
          state_id: "2936",
        },
        {
          id: "33364",
          name: "Stolnici",
          state_id: "2936",
        },
        {
          id: "33365",
          name: "Suici",
          state_id: "2936",
        },
        {
          id: "33366",
          name: "Suseni",
          state_id: "2936",
        },
        {
          id: "33367",
          name: "Teiu",
          state_id: "2936",
        },
        {
          id: "33368",
          name: "Tigveni",
          state_id: "2936",
        },
        {
          id: "33369",
          name: "Titesti",
          state_id: "2936",
        },
        {
          id: "33370",
          name: "Topoloveni",
          state_id: "2936",
        },
        {
          id: "33371",
          name: "Uda",
          state_id: "2936",
        },
        {
          id: "33372",
          name: "Ungheni",
          state_id: "2936",
        },
        {
          id: "33373",
          name: "Valea Danului",
          state_id: "2936",
        },
        {
          id: "33374",
          name: "Valea Iasului",
          state_id: "2936",
        },
        {
          id: "33375",
          name: "Valea Mare-Pravat",
          state_id: "2936",
        },
        {
          id: "33376",
          name: "Vedea",
          state_id: "2936",
        },
        {
          id: "33377",
          name: "Vladesti",
          state_id: "2936",
        },
      ],
      Bacau: [
        {
          id: "33378",
          name: "Agas",
          state_id: "2937",
        },
        {
          id: "33379",
          name: "Ardeoani",
          state_id: "2937",
        },
        {
          id: "33380",
          name: "Asau",
          state_id: "2937",
        },
        {
          id: "33381",
          name: "Bacau",
          state_id: "2937",
        },
        {
          id: "33382",
          name: "Balcani",
          state_id: "2937",
        },
        {
          id: "33383",
          name: "Barsanesti",
          state_id: "2937",
        },
        {
          id: "33384",
          name: "Beresti-Bistrita",
          state_id: "2937",
        },
        {
          id: "33385",
          name: "Beresti-Tazlau",
          state_id: "2937",
        },
        {
          id: "33386",
          name: "Berzunti",
          state_id: "2937",
        },
        {
          id: "33387",
          name: "Blagesti",
          state_id: "2937",
        },
        {
          id: "33388",
          name: "Bogdanesti",
          state_id: "2937",
        },
        {
          id: "33389",
          name: "Brusturoasa",
          state_id: "2937",
        },
        {
          id: "33390",
          name: "Buhoci",
          state_id: "2937",
        },
        {
          id: "33391",
          name: "Buhusi",
          state_id: "2937",
        },
        {
          id: "33392",
          name: "Caiuti",
          state_id: "2937",
        },
        {
          id: "33393",
          name: "Casin",
          state_id: "2937",
        },
        {
          id: "33394",
          name: "Cleja",
          state_id: "2937",
        },
        {
          id: "33395",
          name: "Colonesti",
          state_id: "2937",
        },
        {
          id: "33396",
          name: "Comanesti",
          state_id: "2937",
        },
        {
          id: "33397",
          name: "Corbasca",
          state_id: "2937",
        },
        {
          id: "33398",
          name: "Cotofanesti",
          state_id: "2937",
        },
        {
          id: "33399",
          name: "Damienesti",
          state_id: "2937",
        },
        {
          id: "33400",
          name: "Darmanesti",
          state_id: "2937",
        },
        {
          id: "33401",
          name: "Dealu Morii",
          state_id: "2937",
        },
        {
          id: "33402",
          name: "Dofteana",
          state_id: "2937",
        },
        {
          id: "33403",
          name: "Faraoani",
          state_id: "2937",
        },
        {
          id: "33404",
          name: "Filipeni",
          state_id: "2937",
        },
        {
          id: "33405",
          name: "Filipesti",
          state_id: "2937",
        },
        {
          id: "33406",
          name: "Gaiceana",
          state_id: "2937",
        },
        {
          id: "33407",
          name: "Garleni",
          state_id: "2937",
        },
        {
          id: "33408",
          name: "Ghimes-Faget",
          state_id: "2937",
        },
        {
          id: "33409",
          name: "Glavanesti",
          state_id: "2937",
        },
        {
          id: "33410",
          name: "Gura Vaii",
          state_id: "2937",
        },
        {
          id: "33411",
          name: "Helegiu",
          state_id: "2937",
        },
        {
          id: "33412",
          name: "Hemeius",
          state_id: "2937",
        },
        {
          id: "33413",
          name: "Horgesti",
          state_id: "2937",
        },
        {
          id: "33414",
          name: "Huruesti",
          state_id: "2937",
        },
        {
          id: "33415",
          name: "Izvoru Berheciului",
          state_id: "2937",
        },
        {
          id: "33416",
          name: "Letea Veche",
          state_id: "2937",
        },
        {
          id: "33417",
          name: "Lipova",
          state_id: "2937",
        },
        {
          id: "33418",
          name: "Livezi",
          state_id: "2937",
        },
        {
          id: "33419",
          name: "Luizi-Calugara",
          state_id: "2937",
        },
        {
          id: "33420",
          name: "Magiresti",
          state_id: "2937",
        },
        {
          id: "33421",
          name: "Magura",
          state_id: "2937",
        },
        {
          id: "33422",
          name: "Manastirea Casin",
          state_id: "2937",
        },
        {
          id: "33423",
          name: "Margineni",
          state_id: "2937",
        },
        {
          id: "33424",
          name: "Moinesti",
          state_id: "2937",
        },
        {
          id: "33425",
          name: "Motoseni",
          state_id: "2937",
        },
        {
          id: "33426",
          name: "Negri",
          state_id: "2937",
        },
        {
          id: "33427",
          name: "Nicolae Balcescu",
          state_id: "2937",
        },
        {
          id: "33428",
          name: "Oituz",
          state_id: "2937",
        },
        {
          id: "33429",
          name: "Oncesti",
          state_id: "2937",
        },
        {
          id: "33430",
          name: "Onesti",
          state_id: "2937",
        },
        {
          id: "33431",
          name: "Orbeni",
          state_id: "2937",
        },
        {
          id: "33432",
          name: "Palanca",
          state_id: "2937",
        },
        {
          id: "33433",
          name: "Pancesti",
          state_id: "2937",
        },
        {
          id: "33434",
          name: "Parava",
          state_id: "2937",
        },
        {
          id: "33435",
          name: "Pargaresti",
          state_id: "2937",
        },
        {
          id: "33436",
          name: "Parincea",
          state_id: "2937",
        },
        {
          id: "33437",
          name: "Parjol",
          state_id: "2937",
        },
        {
          id: "33438",
          name: "Plopana",
          state_id: "2937",
        },
        {
          id: "33439",
          name: "Podu Turcului",
          state_id: "2937",
        },
        {
          id: "33440",
          name: "Poduri",
          state_id: "2937",
        },
        {
          id: "33441",
          name: "Racaciuni",
          state_id: "2937",
        },
        {
          id: "33442",
          name: "Rachitoasa",
          state_id: "2937",
        },
        {
          id: "33443",
          name: "Racova",
          state_id: "2937",
        },
        {
          id: "33444",
          name: "Rosiori",
          state_id: "2937",
        },
        {
          id: "33445",
          name: "Sanduleni",
          state_id: "2937",
        },
        {
          id: "33446",
          name: "Sascut",
          state_id: "2937",
        },
        {
          id: "33447",
          name: "Saucesti",
          state_id: "2937",
        },
        {
          id: "33448",
          name: "Scorteni",
          state_id: "2937",
        },
        {
          id: "33449",
          name: "Secuieni",
          state_id: "2937",
        },
        {
          id: "33450",
          name: "Slanic-Moldova",
          state_id: "2937",
        },
        {
          id: "33451",
          name: "Solont",
          state_id: "2937",
        },
        {
          id: "33452",
          name: "Stanisesti",
          state_id: "2937",
        },
        {
          id: "33453",
          name: "Stefan cel Mare",
          state_id: "2937",
        },
        {
          id: "33454",
          name: "Strugari",
          state_id: "2937",
        },
        {
          id: "33455",
          name: "Tamasi",
          state_id: "2937",
        },
        {
          id: "33456",
          name: "Targu Ocna",
          state_id: "2937",
        },
        {
          id: "33457",
          name: "Targu-Trotus",
          state_id: "2937",
        },
        {
          id: "33458",
          name: "Tatarasti",
          state_id: "2937",
        },
        {
          id: "33459",
          name: "Traian",
          state_id: "2937",
        },
        {
          id: "33460",
          name: "Ungureni",
          state_id: "2937",
        },
        {
          id: "33461",
          name: "Urechesti",
          state_id: "2937",
        },
        {
          id: "33462",
          name: "Valea Seaca",
          state_id: "2937",
        },
        {
          id: "33463",
          name: "Vultureni",
          state_id: "2937",
        },
        {
          id: "33464",
          name: "Zemes",
          state_id: "2937",
        },
      ],
      Bihor: [
        {
          id: "33465",
          name: "Abram",
          state_id: "2938",
        },
        {
          id: "33466",
          name: "Abramut",
          state_id: "2938",
        },
        {
          id: "33467",
          name: "Alesd",
          state_id: "2938",
        },
        {
          id: "33468",
          name: "Astileu",
          state_id: "2938",
        },
        {
          id: "33469",
          name: "Auseu",
          state_id: "2938",
        },
        {
          id: "33470",
          name: "Avram Iancu",
          state_id: "2938",
        },
        {
          id: "33471",
          name: "Balc",
          state_id: "2938",
        },
        {
          id: "33472",
          name: "Batar",
          state_id: "2938",
        },
        {
          id: "33473",
          name: "Beius",
          state_id: "2938",
        },
        {
          id: "33474",
          name: "Biharia",
          state_id: "2938",
        },
        {
          id: "33475",
          name: "Boianu Mare",
          state_id: "2938",
        },
        {
          id: "33476",
          name: "Borod",
          state_id: "2938",
        },
        {
          id: "33477",
          name: "Bors",
          state_id: "2938",
        },
        {
          id: "33478",
          name: "Bratca",
          state_id: "2938",
        },
        {
          id: "33479",
          name: "Brusturi",
          state_id: "2938",
        },
        {
          id: "33480",
          name: "Budureasa",
          state_id: "2938",
        },
        {
          id: "33481",
          name: "Buduslau",
          state_id: "2938",
        },
        {
          id: "33482",
          name: "Bulz",
          state_id: "2938",
        },
        {
          id: "33483",
          name: "Buntesti",
          state_id: "2938",
        },
        {
          id: "33484",
          name: "Cabesti",
          state_id: "2938",
        },
        {
          id: "33485",
          name: "Campani",
          state_id: "2938",
        },
        {
          id: "33486",
          name: "Capalna",
          state_id: "2938",
        },
        {
          id: "33487",
          name: "Carpinet",
          state_id: "2938",
        },
        {
          id: "33488",
          name: "Cefa",
          state_id: "2938",
        },
        {
          id: "33489",
          name: "Ceica",
          state_id: "2938",
        },
        {
          id: "33490",
          name: "Cetariu",
          state_id: "2938",
        },
        {
          id: "33491",
          name: "Cherechiu",
          state_id: "2938",
        },
        {
          id: "33492",
          name: "Chislaz",
          state_id: "2938",
        },
        {
          id: "33493",
          name: "Ciuhoiu",
          state_id: "2938",
        },
        {
          id: "33494",
          name: "Ciumeghiu",
          state_id: "2938",
        },
        {
          id: "33495",
          name: "Cociuba Mare",
          state_id: "2938",
        },
        {
          id: "33496",
          name: "Copacel",
          state_id: "2938",
        },
        {
          id: "33497",
          name: "Cristioru de Jos",
          state_id: "2938",
        },
        {
          id: "33498",
          name: "Curatele",
          state_id: "2938",
        },
        {
          id: "33499",
          name: "Curtuiseni",
          state_id: "2938",
        },
        {
          id: "33500",
          name: "Derna",
          state_id: "2938",
        },
        {
          id: "33501",
          name: "Diosig",
          state_id: "2938",
        },
        {
          id: "33502",
          name: "Dobresti",
          state_id: "2938",
        },
        {
          id: "33503",
          name: "Draganesti",
          state_id: "2938",
        },
        {
          id: "33504",
          name: "Dragesti",
          state_id: "2938",
        },
        {
          id: "33505",
          name: "Finis",
          state_id: "2938",
        },
        {
          id: "33506",
          name: "Girisu de Cris",
          state_id: "2938",
        },
        {
          id: "33507",
          name: "Hidiselu de Sus",
          state_id: "2938",
        },
        {
          id: "33508",
          name: "Holod",
          state_id: "2938",
        },
        {
          id: "33509",
          name: "Husasau de Tinca",
          state_id: "2938",
        },
        {
          id: "33510",
          name: "Ineu",
          state_id: "2938",
        },
        {
          id: "33511",
          name: "Lazareni",
          state_id: "2938",
        },
        {
          id: "33512",
          name: "Lazuri de Beius",
          state_id: "2938",
        },
        {
          id: "33513",
          name: "Lugasu de Jos",
          state_id: "2938",
        },
        {
          id: "33514",
          name: "Lunca",
          state_id: "2938",
        },
        {
          id: "33515",
          name: "Madaras",
          state_id: "2938",
        },
        {
          id: "33516",
          name: "Magesti",
          state_id: "2938",
        },
        {
          id: "33517",
          name: "Marghita",
          state_id: "2938",
        },
        {
          id: "33518",
          name: "Nojorid",
          state_id: "2938",
        },
        {
          id: "33519",
          name: "Nucet",
          state_id: "2938",
        },
        {
          id: "33520",
          name: "Olcea",
          state_id: "2938",
        },
        {
          id: "33521",
          name: "Oradea",
          state_id: "2938",
        },
        {
          id: "33522",
          name: "Osorheiu",
          state_id: "2938",
        },
        {
          id: "33523",
          name: "Pietroasa",
          state_id: "2938",
        },
        {
          id: "33524",
          name: "Pocola",
          state_id: "2938",
        },
        {
          id: "33525",
          name: "Pomezeu",
          state_id: "2938",
        },
        {
          id: "33526",
          name: "Popesti",
          state_id: "2938",
        },
        {
          id: "33527",
          name: "Rabagani",
          state_id: "2938",
        },
        {
          id: "33528",
          name: "Remetea",
          state_id: "2938",
        },
        {
          id: "33529",
          name: "Rieni",
          state_id: "2938",
        },
        {
          id: "33530",
          name: "Rosia",
          state_id: "2938",
        },
        {
          id: "33531",
          name: "Sacadat",
          state_id: "2938",
        },
        {
          id: "33532",
          name: "Sacueni",
          state_id: "2938",
        },
        {
          id: "33533",
          name: "Salacea",
          state_id: "2938",
        },
        {
          id: "33534",
          name: "Salard",
          state_id: "2938",
        },
        {
          id: "33535",
          name: "Salonta",
          state_id: "2938",
        },
        {
          id: "33536",
          name: "Sambata",
          state_id: "2938",
        },
        {
          id: "33537",
          name: "Sanmartin",
          state_id: "2938",
        },
        {
          id: "33538",
          name: "Santandrei",
          state_id: "2938",
        },
        {
          id: "33539",
          name: "Sarbi",
          state_id: "2938",
        },
        {
          id: "33540",
          name: "Simian",
          state_id: "2938",
        },
        {
          id: "33541",
          name: "Sinteu",
          state_id: "2938",
        },
        {
          id: "33542",
          name: "Soimi",
          state_id: "2938",
        },
        {
          id: "33543",
          name: "Spinus",
          state_id: "2938",
        },
        {
          id: "33544",
          name: "Stei",
          state_id: "2938",
        },
        {
          id: "33545",
          name: "Suncuius",
          state_id: "2938",
        },
        {
          id: "33546",
          name: "Suplacu de Barcau",
          state_id: "2938",
        },
        {
          id: "33547",
          name: "Tarcaia",
          state_id: "2938",
        },
        {
          id: "33548",
          name: "Tarcea",
          state_id: "2938",
        },
        {
          id: "33549",
          name: "Tauteu",
          state_id: "2938",
        },
        {
          id: "33550",
          name: "Tetchea",
          state_id: "2938",
        },
        {
          id: "33551",
          name: "Tileagd",
          state_id: "2938",
        },
        {
          id: "33552",
          name: "Tinca",
          state_id: "2938",
        },
        {
          id: "33553",
          name: "Tulca",
          state_id: "2938",
        },
        {
          id: "33554",
          name: "Uileacu de Beius",
          state_id: "2938",
        },
        {
          id: "33555",
          name: "Vadu Crisului",
          state_id: "2938",
        },
        {
          id: "33556",
          name: "Valea lui Mihai",
          state_id: "2938",
        },
        {
          id: "33557",
          name: "Varciorog",
          state_id: "2938",
        },
        {
          id: "33558",
          name: "Vascau",
          state_id: "2938",
        },
        {
          id: "33559",
          name: "Viisoara",
          state_id: "2938",
        },
      ],
      "Bistrita-Nasaud": [
        {
          id: "33560",
          name: "Beclean",
          state_id: "2939",
        },
        {
          id: "33561",
          name: "Bistrita",
          state_id: "2939",
        },
        {
          id: "33562",
          name: "Bistrita Bargaului",
          state_id: "2939",
        },
        {
          id: "33563",
          name: "Branistea",
          state_id: "2939",
        },
        {
          id: "33564",
          name: "Budacu de Jos",
          state_id: "2939",
        },
        {
          id: "33565",
          name: "Budesti",
          state_id: "2939",
        },
        {
          id: "33566",
          name: "Caianu Mic",
          state_id: "2939",
        },
        {
          id: "33567",
          name: "Cetate",
          state_id: "2939",
        },
        {
          id: "33568",
          name: "Chiochis",
          state_id: "2939",
        },
        {
          id: "33569",
          name: "Chiuza",
          state_id: "2939",
        },
        {
          id: "33570",
          name: "Ciceu-Giurgesti",
          state_id: "2939",
        },
        {
          id: "33571",
          name: "Cosbuc",
          state_id: "2939",
        },
        {
          id: "33572",
          name: "Dumitra",
          state_id: "2939",
        },
        {
          id: "33573",
          name: "Feldru",
          state_id: "2939",
        },
        {
          id: "33574",
          name: "Galatii Bistritei",
          state_id: "2939",
        },
        {
          id: "33575",
          name: "Ilva Mare",
          state_id: "2939",
        },
        {
          id: "33576",
          name: "Ilva Mica",
          state_id: "2939",
        },
        {
          id: "33577",
          name: "Josenii Bargaului",
          state_id: "2939",
        },
        {
          id: "33578",
          name: "Lechinta",
          state_id: "2939",
        },
        {
          id: "33579",
          name: "Lesu",
          state_id: "2939",
        },
        {
          id: "33580",
          name: "Livezile",
          state_id: "2939",
        },
        {
          id: "33581",
          name: "Lunca Ilvei",
          state_id: "2939",
        },
        {
          id: "33582",
          name: "Magura Ilvei",
          state_id: "2939",
        },
        {
          id: "33583",
          name: "Maieru",
          state_id: "2939",
        },
        {
          id: "33584",
          name: "Mariselu",
          state_id: "2939",
        },
        {
          id: "33585",
          name: "Matei",
          state_id: "2939",
        },
        {
          id: "33586",
          name: "Micestii de Campie",
          state_id: "2939",
        },
        {
          id: "33587",
          name: "Milas",
          state_id: "2939",
        },
        {
          id: "33588",
          name: "Monor",
          state_id: "2939",
        },
        {
          id: "33589",
          name: "Nasaud",
          state_id: "2939",
        },
        {
          id: "33590",
          name: "Nimigea",
          state_id: "2939",
        },
        {
          id: "33591",
          name: "Nuseni",
          state_id: "2939",
        },
        {
          id: "33592",
          name: "Parva",
          state_id: "2939",
        },
        {
          id: "33593",
          name: "Petru Rares",
          state_id: "2939",
        },
        {
          id: "33594",
          name: "Prundu Bargaului",
          state_id: "2939",
        },
        {
          id: "33595",
          name: "Rebra",
          state_id: "2939",
        },
        {
          id: "33596",
          name: "Rebrisoara",
          state_id: "2939",
        },
        {
          id: "33597",
          name: "Rodna",
          state_id: "2939",
        },
        {
          id: "33598",
          name: "Romuli",
          state_id: "2939",
        },
        {
          id: "33599",
          name: "Salva",
          state_id: "2939",
        },
        {
          id: "33600",
          name: "Sangeorz-Bai",
          state_id: "2939",
        },
        {
          id: "33601",
          name: "Sanmihaiu de Campie",
          state_id: "2939",
        },
        {
          id: "33602",
          name: "Sant",
          state_id: "2939",
        },
        {
          id: "33603",
          name: "Sieu",
          state_id: "2939",
        },
        {
          id: "33604",
          name: "Sieu-Magherus",
          state_id: "2939",
        },
        {
          id: "33605",
          name: "Sieu-Odorhei",
          state_id: "2939",
        },
        {
          id: "33606",
          name: "Sieut",
          state_id: "2939",
        },
        {
          id: "33607",
          name: "Silvasu de Campie",
          state_id: "2939",
        },
        {
          id: "33608",
          name: "Sintereag",
          state_id: "2939",
        },
        {
          id: "33609",
          name: "Spermezeu",
          state_id: "2939",
        },
        {
          id: "33610",
          name: "Tarlisua",
          state_id: "2939",
        },
        {
          id: "33611",
          name: "Teaca",
          state_id: "2939",
        },
        {
          id: "33612",
          name: "Telciu",
          state_id: "2939",
        },
        {
          id: "33613",
          name: "Tiha Bargaului",
          state_id: "2939",
        },
        {
          id: "33614",
          name: "Uriu",
          state_id: "2939",
        },
        {
          id: "33615",
          name: "Urmenis",
          state_id: "2939",
        },
        {
          id: "33616",
          name: "Zagra",
          state_id: "2939",
        },
      ],
      Botosani: [
        {
          id: "33617",
          name: "Albesti",
          state_id: "2940",
        },
        {
          id: "33618",
          name: "Avrameni",
          state_id: "2940",
        },
        {
          id: "33619",
          name: "Baluseni",
          state_id: "2940",
        },
        {
          id: "33620",
          name: "Botosani",
          state_id: "2940",
        },
        {
          id: "33621",
          name: "Braesti",
          state_id: "2940",
        },
        {
          id: "33622",
          name: "Broscauti",
          state_id: "2940",
        },
        {
          id: "33623",
          name: "Bucecea",
          state_id: "2940",
        },
        {
          id: "33624",
          name: "Calarasi",
          state_id: "2940",
        },
        {
          id: "33625",
          name: "Concesti",
          state_id: "2940",
        },
        {
          id: "33626",
          name: "Copalau",
          state_id: "2940",
        },
        {
          id: "33627",
          name: "Cordareni",
          state_id: "2940",
        },
        {
          id: "33628",
          name: "Corlateni",
          state_id: "2940",
        },
        {
          id: "33629",
          name: "Corni",
          state_id: "2940",
        },
        {
          id: "33630",
          name: "Cotusca",
          state_id: "2940",
        },
        {
          id: "33631",
          name: "Cristesti",
          state_id: "2940",
        },
        {
          id: "33632",
          name: "Cristinesti",
          state_id: "2940",
        },
        {
          id: "33633",
          name: "Curtesti",
          state_id: "2940",
        },
        {
          id: "33634",
          name: "Dangeni",
          state_id: "2940",
        },
        {
          id: "33635",
          name: "Darabani",
          state_id: "2940",
        },
        {
          id: "33636",
          name: "Dersca",
          state_id: "2940",
        },
        {
          id: "33637",
          name: "Dobarceni",
          state_id: "2940",
        },
        {
          id: "33638",
          name: "Dorohoi",
          state_id: "2940",
        },
        {
          id: "33639",
          name: "Draguseni",
          state_id: "2940",
        },
        {
          id: "33640",
          name: "Durnesti",
          state_id: "2940",
        },
        {
          id: "33641",
          name: "Flamanzi",
          state_id: "2940",
        },
        {
          id: "33642",
          name: "Frumusica",
          state_id: "2940",
        },
        {
          id: "33643",
          name: "George Enescu",
          state_id: "2940",
        },
        {
          id: "33644",
          name: "Gorbanesti",
          state_id: "2940",
        },
        {
          id: "33645",
          name: "Hanesti",
          state_id: "2940",
        },
        {
          id: "33646",
          name: "Havarna",
          state_id: "2940",
        },
        {
          id: "33647",
          name: "Hiliseu-Horia",
          state_id: "2940",
        },
        {
          id: "33648",
          name: "Hlipiceni",
          state_id: "2940",
        },
        {
          id: "33649",
          name: "Hudesti",
          state_id: "2940",
        },
        {
          id: "33650",
          name: "Ibanesti",
          state_id: "2940",
        },
        {
          id: "33651",
          name: "Leorda",
          state_id: "2940",
        },
        {
          id: "33652",
          name: "Lunca",
          state_id: "2940",
        },
        {
          id: "33653",
          name: "Manoleasa",
          state_id: "2940",
        },
        {
          id: "33654",
          name: "Mihail Eminescu",
          state_id: "2940",
        },
        {
          id: "33655",
          name: "Mihaileni",
          state_id: "2940",
        },
        {
          id: "33656",
          name: "Mihalaseni",
          state_id: "2940",
        },
        {
          id: "33657",
          name: "Mileanca",
          state_id: "2940",
        },
        {
          id: "33658",
          name: "Mitoc",
          state_id: "2940",
        },
        {
          id: "33659",
          name: "Nicseni",
          state_id: "2940",
        },
        {
          id: "33660",
          name: "Paltinis",
          state_id: "2940",
        },
        {
          id: "33661",
          name: "Pomarla",
          state_id: "2940",
        },
        {
          id: "33662",
          name: "Prajeni",
          state_id: "2940",
        },
        {
          id: "33663",
          name: "Rachiti",
          state_id: "2940",
        },
        {
          id: "33664",
          name: "Radauti-Prut",
          state_id: "2940",
        },
        {
          id: "33665",
          name: "Rauseni",
          state_id: "2940",
        },
        {
          id: "33666",
          name: "Ripiceni",
          state_id: "2940",
        },
        {
          id: "33667",
          name: "Roma",
          state_id: "2940",
        },
        {
          id: "33668",
          name: "Romanesti",
          state_id: "2940",
        },
        {
          id: "33669",
          name: "Santa-Maria",
          state_id: "2940",
        },
        {
          id: "33670",
          name: "Saveni",
          state_id: "2940",
        },
        {
          id: "33671",
          name: "Sendriceni",
          state_id: "2940",
        },
        {
          id: "33672",
          name: "Stauceni",
          state_id: "2940",
        },
        {
          id: "33673",
          name: "Stefanesti",
          state_id: "2940",
        },
        {
          id: "33674",
          name: "Stiubieni",
          state_id: "2940",
        },
        {
          id: "33675",
          name: "Suharau",
          state_id: "2940",
        },
        {
          id: "33676",
          name: "Sulita",
          state_id: "2940",
        },
        {
          id: "33677",
          name: "Todireni",
          state_id: "2940",
        },
        {
          id: "33678",
          name: "Trusesti",
          state_id: "2940",
        },
        {
          id: "33679",
          name: "Tudora",
          state_id: "2940",
        },
        {
          id: "33680",
          name: "Ungureni",
          state_id: "2940",
        },
        {
          id: "33681",
          name: "Unteni",
          state_id: "2940",
        },
        {
          id: "33682",
          name: "Vaculesti",
          state_id: "2940",
        },
        {
          id: "33683",
          name: "Varfu Campului",
          state_id: "2940",
        },
        {
          id: "33684",
          name: "Viisoara",
          state_id: "2940",
        },
        {
          id: "33685",
          name: "Vladeni",
          state_id: "2940",
        },
        {
          id: "33686",
          name: "Vlasinesti",
          state_id: "2940",
        },
        {
          id: "33687",
          name: "Vorniceni",
          state_id: "2940",
        },
        {
          id: "33688",
          name: "Vorona",
          state_id: "2940",
        },
      ],
      Braila: [
        {
          id: "33689",
          name: "Baraganul",
          state_id: "2941",
        },
        {
          id: "33690",
          name: "Bertestii de Jos",
          state_id: "2941",
        },
        {
          id: "33691",
          name: "Bordei Verde",
          state_id: "2941",
        },
        {
          id: "33692",
          name: "Braila",
          state_id: "2941",
        },
        {
          id: "33693",
          name: "Chiscani",
          state_id: "2941",
        },
        {
          id: "33694",
          name: "Ciocile",
          state_id: "2941",
        },
        {
          id: "33695",
          name: "Ciresu",
          state_id: "2941",
        },
        {
          id: "33696",
          name: "Dudesti",
          state_id: "2941",
        },
        {
          id: "33697",
          name: "Faurei",
          state_id: "2941",
        },
        {
          id: "33698",
          name: "Frecatei",
          state_id: "2941",
        },
        {
          id: "33699",
          name: "Galbenu",
          state_id: "2941",
        },
        {
          id: "33700",
          name: "Gemenele",
          state_id: "2941",
        },
        {
          id: "33701",
          name: "Gradistea",
          state_id: "2941",
        },
        {
          id: "33702",
          name: "Gropeni",
          state_id: "2941",
        },
        {
          id: "33703",
          name: "Ianca",
          state_id: "2941",
        },
        {
          id: "33704",
          name: "Insuratei",
          state_id: "2941",
        },
        {
          id: "33705",
          name: "Jirlau",
          state_id: "2941",
        },
        {
          id: "33706",
          name: "Marasu",
          state_id: "2941",
        },
        {
          id: "33707",
          name: "Maxineni",
          state_id: "2941",
        },
        {
          id: "33708",
          name: "Mircea Voda",
          state_id: "2941",
        },
        {
          id: "33709",
          name: "Movila Miresei",
          state_id: "2941",
        },
        {
          id: "33710",
          name: "Racovita",
          state_id: "2941",
        },
        {
          id: "33711",
          name: "Ramnicelu",
          state_id: "2941",
        },
        {
          id: "33712",
          name: "Romanu",
          state_id: "2941",
        },
        {
          id: "33713",
          name: "Rosiori",
          state_id: "2941",
        },
        {
          id: "33714",
          name: "Salcia Tudor",
          state_id: "2941",
        },
        {
          id: "33715",
          name: "Scortaru Nou",
          state_id: "2941",
        },
        {
          id: "33716",
          name: "Silistea",
          state_id: "2941",
        },
        {
          id: "33717",
          name: "Stancuta",
          state_id: "2941",
        },
        {
          id: "33718",
          name: "Surdila-Gaiseanca",
          state_id: "2941",
        },
        {
          id: "33719",
          name: "Surdila-Greci",
          state_id: "2941",
        },
        {
          id: "33720",
          name: "Sutesti",
          state_id: "2941",
        },
        {
          id: "33721",
          name: "Tichilesti",
          state_id: "2941",
        },
        {
          id: "33722",
          name: "Traian",
          state_id: "2941",
        },
        {
          id: "33723",
          name: "Tudor Vladimirescu",
          state_id: "2941",
        },
        {
          id: "33724",
          name: "Tufesti",
          state_id: "2941",
        },
        {
          id: "33725",
          name: "Ulmu",
          state_id: "2941",
        },
        {
          id: "33726",
          name: "Unirea",
          state_id: "2941",
        },
        {
          id: "33727",
          name: "Vadeni",
          state_id: "2941",
        },
        {
          id: "33728",
          name: "Victoria",
          state_id: "2941",
        },
        {
          id: "33729",
          name: "Visani",
          state_id: "2941",
        },
        {
          id: "33730",
          name: "Viziru",
          state_id: "2941",
        },
        {
          id: "33731",
          name: "Zavoaia",
          state_id: "2941",
        },
      ],
      Brasov: [
        {
          id: "33732",
          name: "Apata",
          state_id: "2942",
        },
        {
          id: "33733",
          name: "Beclean",
          state_id: "2942",
        },
        {
          id: "33734",
          name: "Bod",
          state_id: "2942",
        },
        {
          id: "33735",
          name: "Bran",
          state_id: "2942",
        },
        {
          id: "33736",
          name: "Brasov",
          state_id: "2942",
        },
        {
          id: "33737",
          name: "Budila",
          state_id: "2942",
        },
        {
          id: "33738",
          name: "Bunesti",
          state_id: "2942",
        },
        {
          id: "33739",
          name: "Cata",
          state_id: "2942",
        },
        {
          id: "33740",
          name: "Cincu",
          state_id: "2942",
        },
        {
          id: "33741",
          name: "Codlea",
          state_id: "2942",
        },
        {
          id: "33742",
          name: "Comana",
          state_id: "2942",
        },
        {
          id: "33743",
          name: "Cristian",
          state_id: "2942",
        },
        {
          id: "33744",
          name: "Dumbravita",
          state_id: "2942",
        },
        {
          id: "33745",
          name: "Fagaras",
          state_id: "2942",
        },
        {
          id: "33746",
          name: "Feldioara",
          state_id: "2942",
        },
        {
          id: "33747",
          name: "Fundata",
          state_id: "2942",
        },
        {
          id: "33748",
          name: "Ghimbav",
          state_id: "2942",
        },
        {
          id: "33749",
          name: "Halchiu",
          state_id: "2942",
        },
        {
          id: "33750",
          name: "Harman",
          state_id: "2942",
        },
        {
          id: "33751",
          name: "Harseni",
          state_id: "2942",
        },
        {
          id: "33752",
          name: "Hoghiz",
          state_id: "2942",
        },
        {
          id: "33753",
          name: "Homorod",
          state_id: "2942",
        },
        {
          id: "33754",
          name: "Jibert",
          state_id: "2942",
        },
        {
          id: "33755",
          name: "Lisa",
          state_id: "2942",
        },
        {
          id: "33756",
          name: "Maierus",
          state_id: "2942",
        },
        {
          id: "33757",
          name: "Mandra",
          state_id: "2942",
        },
        {
          id: "33758",
          name: "Moeciu",
          state_id: "2942",
        },
        {
          id: "33759",
          name: "Ormenis",
          state_id: "2942",
        },
        {
          id: "33760",
          name: "Parau",
          state_id: "2942",
        },
        {
          id: "33761",
          name: "Poiana Marului",
          state_id: "2942",
        },
        {
          id: "33762",
          name: "Predeal",
          state_id: "2942",
        },
        {
          id: "33763",
          name: "Prejmer",
          state_id: "2942",
        },
        {
          id: "33764",
          name: "Racos",
          state_id: "2942",
        },
        {
          id: "33765",
          name: "Rasnov",
          state_id: "2942",
        },
        {
          id: "33766",
          name: "Recea",
          state_id: "2942",
        },
        {
          id: "33767",
          name: "Rupea",
          state_id: "2942",
        },
        {
          id: "33768",
          name: "Sacele",
          state_id: "2942",
        },
        {
          id: "33769",
          name: "Sanpetru",
          state_id: "2942",
        },
        {
          id: "33770",
          name: "Sercaia",
          state_id: "2942",
        },
        {
          id: "33771",
          name: "Sinca",
          state_id: "2942",
        },
        {
          id: "33772",
          name: "Soars",
          state_id: "2942",
        },
        {
          id: "33773",
          name: "Tarlungeni",
          state_id: "2942",
        },
        {
          id: "33774",
          name: "Teliu",
          state_id: "2942",
        },
        {
          id: "33775",
          name: "Ticusul",
          state_id: "2942",
        },
        {
          id: "33776",
          name: "Ucea",
          state_id: "2942",
        },
        {
          id: "33777",
          name: "Ungra",
          state_id: "2942",
        },
        {
          id: "33778",
          name: "Vama Buzaului",
          state_id: "2942",
        },
        {
          id: "33779",
          name: "Victoria",
          state_id: "2942",
        },
        {
          id: "33780",
          name: "Vistea",
          state_id: "2942",
        },
        {
          id: "33781",
          name: "Voila",
          state_id: "2942",
        },
        {
          id: "33782",
          name: "Vulcan",
          state_id: "2942",
        },
        {
          id: "33783",
          name: "Zarnesti",
          state_id: "2942",
        },
      ],
      Bucuresti: [
        {
          id: "33784",
          name: "Bucharest",
          state_id: "2943",
        },
        {
          id: "33785",
          name: "Bucuresti",
          state_id: "2943",
        },
      ],
      Buzau: [
        {
          id: "33786",
          name: "Amaru",
          state_id: "2944",
        },
        {
          id: "33787",
          name: "Balaceanu",
          state_id: "2944",
        },
        {
          id: "33788",
          name: "Balta Alba",
          state_id: "2944",
        },
        {
          id: "33789",
          name: "Beceni",
          state_id: "2944",
        },
        {
          id: "33790",
          name: "Berca",
          state_id: "2944",
        },
        {
          id: "33791",
          name: "Bisoca",
          state_id: "2944",
        },
        {
          id: "33792",
          name: "Blajani",
          state_id: "2944",
        },
        {
          id: "33793",
          name: "Boldu",
          state_id: "2944",
        },
        {
          id: "33794",
          name: "Bozioru",
          state_id: "2944",
        },
        {
          id: "33795",
          name: "Bradeanu",
          state_id: "2944",
        },
        {
          id: "33796",
          name: "Braesti",
          state_id: "2944",
        },
        {
          id: "33797",
          name: "Breaza",
          state_id: "2944",
        },
        {
          id: "33798",
          name: "Buda",
          state_id: "2944",
        },
        {
          id: "33799",
          name: "Buzau",
          state_id: "2944",
        },
        {
          id: "33800",
          name: "Calvini",
          state_id: "2944",
        },
        {
          id: "33801",
          name: "Canesti",
          state_id: "2944",
        },
        {
          id: "33802",
          name: "Catina",
          state_id: "2944",
        },
        {
          id: "33803",
          name: "Cernatesti",
          state_id: "2944",
        },
        {
          id: "33804",
          name: "Chiliile",
          state_id: "2944",
        },
        {
          id: "33805",
          name: "Chiojdu",
          state_id: "2944",
        },
        {
          id: "33806",
          name: "Cilibia",
          state_id: "2944",
        },
        {
          id: "33807",
          name: "Cislau",
          state_id: "2944",
        },
        {
          id: "33808",
          name: "Cochirleanca",
          state_id: "2944",
        },
        {
          id: "33809",
          name: "Colti",
          state_id: "2944",
        },
        {
          id: "33810",
          name: "Constantin Rosetti",
          state_id: "2944",
        },
        {
          id: "33811",
          name: "Costesti",
          state_id: "2944",
        },
        {
          id: "33812",
          name: "Cozieni",
          state_id: "2944",
        },
        {
          id: "33813",
          name: "Galbinasi",
          state_id: "2944",
        },
        {
          id: "33814",
          name: "Gheraseni",
          state_id: "2944",
        },
        {
          id: "33815",
          name: "Ghergheasa",
          state_id: "2944",
        },
        {
          id: "33816",
          name: "Glodeanu-Silistea",
          state_id: "2944",
        },
        {
          id: "33817",
          name: "Glodeanul Sarat",
          state_id: "2944",
        },
        {
          id: "33818",
          name: "Grebanu",
          state_id: "2944",
        },
        {
          id: "33819",
          name: "Gura Teghii",
          state_id: "2944",
        },
        {
          id: "33820",
          name: "Largu",
          state_id: "2944",
        },
        {
          id: "33821",
          name: "Lopatari",
          state_id: "2944",
        },
        {
          id: "33822",
          name: "Luciu",
          state_id: "2944",
        },
        {
          id: "33823",
          name: "Magura",
          state_id: "2944",
        },
        {
          id: "33824",
          name: "Manzalesti",
          state_id: "2944",
        },
        {
          id: "33825",
          name: "Maracineni",
          state_id: "2944",
        },
        {
          id: "33826",
          name: "Margaritesti",
          state_id: "2944",
        },
        {
          id: "33827",
          name: "Merei",
          state_id: "2944",
        },
        {
          id: "33828",
          name: "Mihailesti",
          state_id: "2944",
        },
        {
          id: "33829",
          name: "Movila Banului",
          state_id: "2944",
        },
        {
          id: "33830",
          name: "Murgesti",
          state_id: "2944",
        },
        {
          id: "33831",
          name: "Naeni",
          state_id: "2944",
        },
        {
          id: "33832",
          name: "Nehoiu",
          state_id: "2944",
        },
        {
          id: "33833",
          name: "Odaile",
          state_id: "2944",
        },
        {
          id: "33834",
          name: "Padina",
          state_id: "2944",
        },
        {
          id: "33835",
          name: "Panatau",
          state_id: "2944",
        },
        {
          id: "33836",
          name: "Pardosi",
          state_id: "2944",
        },
        {
          id: "33837",
          name: "Parscov",
          state_id: "2944",
        },
        {
          id: "33838",
          name: "Patarlagele",
          state_id: "2944",
        },
        {
          id: "33839",
          name: "Pietroasele",
          state_id: "2944",
        },
        {
          id: "33840",
          name: "Podgoria",
          state_id: "2944",
        },
        {
          id: "33841",
          name: "Pogoanele",
          state_id: "2944",
        },
        {
          id: "33842",
          name: "Posta Calnau",
          state_id: "2944",
        },
        {
          id: "33843",
          name: "Puiesti",
          state_id: "2944",
        },
        {
          id: "33844",
          name: "Racoviteni",
          state_id: "2944",
        },
        {
          id: "33845",
          name: "Ramnicelu",
          state_id: "2944",
        },
        {
          id: "33846",
          name: "Ramnicu Sarat",
          state_id: "2944",
        },
        {
          id: "33847",
          name: "Robeasca",
          state_id: "2944",
        },
        {
          id: "33848",
          name: "Rusetu",
          state_id: "2944",
        },
        {
          id: "33849",
          name: "Sageata",
          state_id: "2944",
        },
        {
          id: "33850",
          name: "Sahateni",
          state_id: "2944",
        },
        {
          id: "33851",
          name: "Sapoca",
          state_id: "2944",
        },
        {
          id: "33852",
          name: "Sarulesti",
          state_id: "2944",
        },
        {
          id: "33853",
          name: "Scortoasa",
          state_id: "2944",
        },
        {
          id: "33854",
          name: "Scutelnici",
          state_id: "2944",
        },
        {
          id: "33855",
          name: "Siriu",
          state_id: "2944",
        },
        {
          id: "33856",
          name: "Smeeni",
          state_id: "2944",
        },
        {
          id: "33857",
          name: "Stalpu",
          state_id: "2944",
        },
        {
          id: "33858",
          name: "Tintesti",
          state_id: "2944",
        },
        {
          id: "33859",
          name: "Tisau",
          state_id: "2944",
        },
        {
          id: "33860",
          name: "Topliceni",
          state_id: "2944",
        },
        {
          id: "33861",
          name: "Ulmeni",
          state_id: "2944",
        },
        {
          id: "33862",
          name: "Vadu Pasii",
          state_id: "2944",
        },
        {
          id: "33863",
          name: "Valcelele",
          state_id: "2944",
        },
        {
          id: "33864",
          name: "Valea Ramnicului",
          state_id: "2944",
        },
        {
          id: "33865",
          name: "Valea Salciei",
          state_id: "2944",
        },
        {
          id: "33866",
          name: "Vernesti",
          state_id: "2944",
        },
        {
          id: "33867",
          name: "Vintila Voda",
          state_id: "2944",
        },
        {
          id: "33868",
          name: "Viperesti",
          state_id: "2944",
        },
        {
          id: "33869",
          name: "Zarnesti",
          state_id: "2944",
        },
        {
          id: "33870",
          name: "Ziduri",
          state_id: "2944",
        },
      ],
      Calarasi: [
        {
          id: "33871",
          name: "Alexandru Odobescu",
          state_id: "2945",
        },
        {
          id: "33872",
          name: "Belciugatele",
          state_id: "2945",
        },
        {
          id: "33873",
          name: "Borcea",
          state_id: "2945",
        },
        {
          id: "33874",
          name: "Budesti",
          state_id: "2945",
        },
        {
          id: "33875",
          name: "Calarasi",
          state_id: "2945",
        },
        {
          id: "33876",
          name: "Cascioarele",
          state_id: "2945",
        },
        {
          id: "33877",
          name: "Chirnogi",
          state_id: "2945",
        },
        {
          id: "33878",
          name: "Chiselet",
          state_id: "2945",
        },
        {
          id: "33879",
          name: "Ciocanesti",
          state_id: "2945",
        },
        {
          id: "33880",
          name: "Curcani",
          state_id: "2945",
        },
        {
          id: "33881",
          name: "Cuza Voda",
          state_id: "2945",
        },
        {
          id: "33882",
          name: "Dichiseni",
          state_id: "2945",
        },
        {
          id: "33883",
          name: "Dor Marunt",
          state_id: "2945",
        },
        {
          id: "33884",
          name: "Dorobantu",
          state_id: "2945",
        },
        {
          id: "33885",
          name: "Dragalina",
          state_id: "2945",
        },
        {
          id: "33886",
          name: "Dragos Voda",
          state_id: "2945",
        },
        {
          id: "33887",
          name: "Frasinet",
          state_id: "2945",
        },
        {
          id: "33888",
          name: "Frumusani",
          state_id: "2945",
        },
        {
          id: "33889",
          name: "Fundeni",
          state_id: "2945",
        },
        {
          id: "33890",
          name: "Fundulea",
          state_id: "2945",
        },
        {
          id: "33891",
          name: "Gradistea",
          state_id: "2945",
        },
        {
          id: "33892",
          name: "Gurbanesti",
          state_id: "2945",
        },
        {
          id: "33893",
          name: "Ileana",
          state_id: "2945",
        },
        {
          id: "33894",
          name: "Independenta",
          state_id: "2945",
        },
        {
          id: "33895",
          name: "Jegalia",
          state_id: "2945",
        },
        {
          id: "33896",
          name: "Lehliu",
          state_id: "2945",
        },
        {
          id: "33897",
          name: "Lehliu-Gara",
          state_id: "2945",
        },
        {
          id: "33898",
          name: "Luica",
          state_id: "2945",
        },
        {
          id: "33899",
          name: "Lupsanu",
          state_id: "2945",
        },
        {
          id: "33900",
          name: "Manastirea",
          state_id: "2945",
        },
        {
          id: "33901",
          name: "Mitreni",
          state_id: "2945",
        },
        {
          id: "33902",
          name: "Modelu",
          state_id: "2945",
        },
        {
          id: "33903",
          name: "Nana",
          state_id: "2945",
        },
        {
          id: "33904",
          name: "Nicolae Balcescu",
          state_id: "2945",
        },
        {
          id: "33905",
          name: "Oltenita",
          state_id: "2945",
        },
        {
          id: "33906",
          name: "Perisoru",
          state_id: "2945",
        },
        {
          id: "33907",
          name: "Plataresti",
          state_id: "2945",
        },
        {
          id: "33908",
          name: "Radovanu",
          state_id: "2945",
        },
        {
          id: "33909",
          name: "Roseti",
          state_id: "2945",
        },
        {
          id: "33910",
          name: "Sarulesti",
          state_id: "2945",
        },
        {
          id: "33911",
          name: "Sohatu",
          state_id: "2945",
        },
        {
          id: "33912",
          name: "Soldanu",
          state_id: "2945",
        },
        {
          id: "33913",
          name: "Spantov",
          state_id: "2945",
        },
        {
          id: "33914",
          name: "Stefan Voda",
          state_id: "2945",
        },
        {
          id: "33915",
          name: "Stefan cel Mare",
          state_id: "2945",
        },
        {
          id: "33916",
          name: "Tamadau Mare",
          state_id: "2945",
        },
        {
          id: "33917",
          name: "Ulmeni",
          state_id: "2945",
        },
        {
          id: "33918",
          name: "Ulmu",
          state_id: "2945",
        },
        {
          id: "33919",
          name: "Unirea",
          state_id: "2945",
        },
        {
          id: "33920",
          name: "Valcelele",
          state_id: "2945",
        },
        {
          id: "33921",
          name: "Valea Argovei",
          state_id: "2945",
        },
        {
          id: "33922",
          name: "Vasilati",
          state_id: "2945",
        },
        {
          id: "33923",
          name: "Vlad Tepes",
          state_id: "2945",
        },
      ],
      "Caras-Severin": [
        {
          id: "33924",
          name: "Anina",
          state_id: "2946",
        },
        {
          id: "33925",
          name: "Armenis",
          state_id: "2946",
        },
        {
          id: "33926",
          name: "Baile Herculane",
          state_id: "2946",
        },
        {
          id: "33927",
          name: "Bania",
          state_id: "2946",
        },
        {
          id: "33928",
          name: "Bautar",
          state_id: "2946",
        },
        {
          id: "33929",
          name: "Berliste",
          state_id: "2946",
        },
        {
          id: "33930",
          name: "Berzasca",
          state_id: "2946",
        },
        {
          id: "33931",
          name: "Berzovia",
          state_id: "2946",
        },
        {
          id: "33932",
          name: "Bocsa",
          state_id: "2946",
        },
        {
          id: "33933",
          name: "Bolvasnita",
          state_id: "2946",
        },
        {
          id: "33934",
          name: "Bozovici",
          state_id: "2946",
        },
        {
          id: "33935",
          name: "Brebu",
          state_id: "2946",
        },
        {
          id: "33936",
          name: "Brebu Nou",
          state_id: "2946",
        },
        {
          id: "33937",
          name: "Buchin",
          state_id: "2946",
        },
        {
          id: "33938",
          name: "Bucosnita",
          state_id: "2946",
        },
        {
          id: "33939",
          name: "Caransebes",
          state_id: "2946",
        },
        {
          id: "33940",
          name: "Carasova",
          state_id: "2946",
        },
        {
          id: "33941",
          name: "Carbunari",
          state_id: "2946",
        },
        {
          id: "33942",
          name: "Ciclova Romana",
          state_id: "2946",
        },
        {
          id: "33943",
          name: "Ciuchici",
          state_id: "2946",
        },
        {
          id: "33944",
          name: "Ciudanovita",
          state_id: "2946",
        },
        {
          id: "33945",
          name: "Constantin Daicoviciu",
          state_id: "2946",
        },
        {
          id: "33946",
          name: "Copacele",
          state_id: "2946",
        },
        {
          id: "33947",
          name: "Cornea",
          state_id: "2946",
        },
        {
          id: "33948",
          name: "Cornereva",
          state_id: "2946",
        },
        {
          id: "33949",
          name: "Coronini",
          state_id: "2946",
        },
        {
          id: "33950",
          name: "Dalboset",
          state_id: "2946",
        },
        {
          id: "33951",
          name: "Doclin",
          state_id: "2946",
        },
        {
          id: "33952",
          name: "Dognecea",
          state_id: "2946",
        },
        {
          id: "33953",
          name: "Domasnea",
          state_id: "2946",
        },
        {
          id: "33954",
          name: "Eftimie Murgu",
          state_id: "2946",
        },
        {
          id: "33955",
          name: "Ezeris",
          state_id: "2946",
        },
        {
          id: "33956",
          name: "Farliug",
          state_id: "2946",
        },
        {
          id: "33957",
          name: "Forotic",
          state_id: "2946",
        },
        {
          id: "33958",
          name: "Garnic",
          state_id: "2946",
        },
        {
          id: "33959",
          name: "Glimboca",
          state_id: "2946",
        },
        {
          id: "33960",
          name: "Goruia",
          state_id: "2946",
        },
        {
          id: "33961",
          name: "Gradinari",
          state_id: "2946",
        },
        {
          id: "33962",
          name: "Iablanita",
          state_id: "2946",
        },
        {
          id: "33963",
          name: "Lapusnicel",
          state_id: "2946",
        },
        {
          id: "33964",
          name: "Lapusnicu Mare",
          state_id: "2946",
        },
        {
          id: "33965",
          name: "Luncavita",
          state_id: "2946",
        },
        {
          id: "33966",
          name: "Lupac",
          state_id: "2946",
        },
        {
          id: "33967",
          name: "Marga",
          state_id: "2946",
        },
        {
          id: "33968",
          name: "Maureni",
          state_id: "2946",
        },
        {
          id: "33969",
          name: "Mehadia",
          state_id: "2946",
        },
        {
          id: "33970",
          name: "Mehadica",
          state_id: "2946",
        },
        {
          id: "33971",
          name: "Moldova Noua",
          state_id: "2946",
        },
        {
          id: "33972",
          name: "Naidas",
          state_id: "2946",
        },
        {
          id: "33973",
          name: "Obreja",
          state_id: "2946",
        },
        {
          id: "33974",
          name: "Ocna de Fier",
          state_id: "2946",
        },
        {
          id: "33975",
          name: "Oravita",
          state_id: "2946",
        },
        {
          id: "33976",
          name: "Otelu Rosu",
          state_id: "2946",
        },
        {
          id: "33977",
          name: "Paltinis",
          state_id: "2946",
        },
        {
          id: "33978",
          name: "Pojejena",
          state_id: "2946",
        },
        {
          id: "33979",
          name: "Prigor",
          state_id: "2946",
        },
        {
          id: "33980",
          name: "Racasdia",
          state_id: "2946",
        },
        {
          id: "33981",
          name: "Ramna",
          state_id: "2946",
        },
        {
          id: "33982",
          name: "Resita",
          state_id: "2946",
        },
        {
          id: "33983",
          name: "Rusca Montana",
          state_id: "2946",
        },
        {
          id: "33984",
          name: "Sacu",
          state_id: "2946",
        },
        {
          id: "33985",
          name: "Sasca Montana",
          state_id: "2946",
        },
        {
          id: "33986",
          name: "Sichevita",
          state_id: "2946",
        },
        {
          id: "33987",
          name: "Slatina-Timis",
          state_id: "2946",
        },
        {
          id: "33988",
          name: "Socol",
          state_id: "2946",
        },
        {
          id: "33989",
          name: "Sopotu Nou",
          state_id: "2946",
        },
        {
          id: "33990",
          name: "Tarnova",
          state_id: "2946",
        },
        {
          id: "33991",
          name: "Teregova",
          state_id: "2946",
        },
        {
          id: "33992",
          name: "Ticvaniu Mare",
          state_id: "2946",
        },
        {
          id: "33993",
          name: "Toplet",
          state_id: "2946",
        },
        {
          id: "33994",
          name: "Turnu Ruieni",
          state_id: "2946",
        },
        {
          id: "33995",
          name: "Valiug",
          state_id: "2946",
        },
        {
          id: "33996",
          name: "Varadia",
          state_id: "2946",
        },
        {
          id: "33997",
          name: "Vermes",
          state_id: "2946",
        },
        {
          id: "33998",
          name: "Vrani",
          state_id: "2946",
        },
        {
          id: "33999",
          name: "Zavoi",
          state_id: "2946",
        },
        {
          id: "34000",
          name: "Zorlentu Mare",
          state_id: "2946",
        },
      ],
      Cluj: [
        {
          id: "34001",
          name: "Aghiresu",
          state_id: "2947",
        },
        {
          id: "34002",
          name: "Aiton",
          state_id: "2947",
        },
        {
          id: "34003",
          name: "Alunis",
          state_id: "2947",
        },
        {
          id: "34004",
          name: "Apahida",
          state_id: "2947",
        },
        {
          id: "34005",
          name: "Aschileu",
          state_id: "2947",
        },
        {
          id: "34006",
          name: "Baciu",
          state_id: "2947",
        },
        {
          id: "34007",
          name: "Baisoara",
          state_id: "2947",
        },
        {
          id: "34008",
          name: "Belis",
          state_id: "2947",
        },
        {
          id: "34009",
          name: "Bobalna",
          state_id: "2947",
        },
        {
          id: "34010",
          name: "Bontida",
          state_id: "2947",
        },
        {
          id: "34011",
          name: "Borsa",
          state_id: "2947",
        },
        {
          id: "34012",
          name: "Buza",
          state_id: "2947",
        },
        {
          id: "34013",
          name: "Caianu",
          state_id: "2947",
        },
        {
          id: "34014",
          name: "Calarasi",
          state_id: "2947",
        },
        {
          id: "34015",
          name: "Calatele",
          state_id: "2947",
        },
        {
          id: "34016",
          name: "Camarasu",
          state_id: "2947",
        },
        {
          id: "34017",
          name: "Campia Turzii",
          state_id: "2947",
        },
        {
          id: "34018",
          name: "Capusu Mare",
          state_id: "2947",
        },
        {
          id: "34019",
          name: "Caseiu",
          state_id: "2947",
        },
        {
          id: "34020",
          name: "Catcau",
          state_id: "2947",
        },
        {
          id: "34021",
          name: "Catina",
          state_id: "2947",
        },
        {
          id: "34022",
          name: "Ceanu Mare",
          state_id: "2947",
        },
        {
          id: "34023",
          name: "Chinteni",
          state_id: "2947",
        },
        {
          id: "34024",
          name: "Chiuiesti",
          state_id: "2947",
        },
        {
          id: "34025",
          name: "Ciucea",
          state_id: "2947",
        },
        {
          id: "34026",
          name: "Ciurila",
          state_id: "2947",
        },
        {
          id: "34027",
          name: "Cluj-Napoca",
          state_id: "2947",
        },
        {
          id: "34028",
          name: "Cojocna",
          state_id: "2947",
        },
        {
          id: "34029",
          name: "Cornesti",
          state_id: "2947",
        },
        {
          id: "34030",
          name: "Cuzdrioara",
          state_id: "2947",
        },
        {
          id: "34031",
          name: "Dabaca",
          state_id: "2947",
        },
        {
          id: "34032",
          name: "Dej",
          state_id: "2947",
        },
        {
          id: "34033",
          name: "Feleacu",
          state_id: "2947",
        },
        {
          id: "34034",
          name: "Fizesu Gherlii",
          state_id: "2947",
        },
        {
          id: "34035",
          name: "Floresti",
          state_id: "2947",
        },
        {
          id: "34036",
          name: "Frata",
          state_id: "2947",
        },
        {
          id: "34037",
          name: "Garbau",
          state_id: "2947",
        },
        {
          id: "34038",
          name: "Geaca",
          state_id: "2947",
        },
        {
          id: "34039",
          name: "Gherla",
          state_id: "2947",
        },
        {
          id: "34040",
          name: "Gilau",
          state_id: "2947",
        },
        {
          id: "34041",
          name: "Huedin",
          state_id: "2947",
        },
        {
          id: "34042",
          name: "Iara",
          state_id: "2947",
        },
        {
          id: "34043",
          name: "Iclod",
          state_id: "2947",
        },
        {
          id: "34044",
          name: "Izvoru Crisului",
          state_id: "2947",
        },
        {
          id: "34045",
          name: "Jichisu de Jos",
          state_id: "2947",
        },
        {
          id: "34046",
          name: "Jucu",
          state_id: "2947",
        },
        {
          id: "34047",
          name: "Luna",
          state_id: "2947",
        },
        {
          id: "34048",
          name: "Maguri-Racatau",
          state_id: "2947",
        },
        {
          id: "34049",
          name: "Manastireni",
          state_id: "2947",
        },
        {
          id: "34050",
          name: "Margau",
          state_id: "2947",
        },
        {
          id: "34051",
          name: "Marisel",
          state_id: "2947",
        },
        {
          id: "34052",
          name: "Mica",
          state_id: "2947",
        },
        {
          id: "34053",
          name: "Mihai Viteazu",
          state_id: "2947",
        },
        {
          id: "34054",
          name: "Mintiu Gherlii",
          state_id: "2947",
        },
        {
          id: "34055",
          name: "Mociu",
          state_id: "2947",
        },
        {
          id: "34056",
          name: "Moldovenesti",
          state_id: "2947",
        },
        {
          id: "34057",
          name: "Palatca",
          state_id: "2947",
        },
        {
          id: "34058",
          name: "Panticeu",
          state_id: "2947",
        },
        {
          id: "34059",
          name: "Petrestii de Jos",
          state_id: "2947",
        },
        {
          id: "34060",
          name: "Ploscos",
          state_id: "2947",
        },
        {
          id: "34061",
          name: "Poieni",
          state_id: "2947",
        },
        {
          id: "34062",
          name: "Rasca",
          state_id: "2947",
        },
        {
          id: "34063",
          name: "Recea Cristur",
          state_id: "2947",
        },
        {
          id: "34064",
          name: "Sacuieu",
          state_id: "2947",
        },
        {
          id: "34065",
          name: "Sancraiu",
          state_id: "2947",
        },
        {
          id: "34066",
          name: "Sandulesti",
          state_id: "2947",
        },
        {
          id: "34067",
          name: "Sanmartin",
          state_id: "2947",
        },
        {
          id: "34068",
          name: "Sanpaul",
          state_id: "2947",
        },
        {
          id: "34069",
          name: "Savadisla",
          state_id: "2947",
        },
        {
          id: "34070",
          name: "Sic",
          state_id: "2947",
        },
        {
          id: "34071",
          name: "Suatu",
          state_id: "2947",
        },
        {
          id: "34072",
          name: "Taga",
          state_id: "2947",
        },
        {
          id: "34073",
          name: "Tritenii de Jos",
          state_id: "2947",
        },
        {
          id: "34074",
          name: "Turda",
          state_id: "2947",
        },
        {
          id: "34075",
          name: "Tureni",
          state_id: "2947",
        },
        {
          id: "34076",
          name: "Unguras",
          state_id: "2947",
        },
        {
          id: "34077",
          name: "Vad",
          state_id: "2947",
        },
        {
          id: "34078",
          name: "Valea Ierii",
          state_id: "2947",
        },
        {
          id: "34079",
          name: "Viisoara",
          state_id: "2947",
        },
        {
          id: "34080",
          name: "Vultureni",
          state_id: "2947",
        },
      ],
      Constanta: [
        {
          id: "34081",
          name: "Adamclisi",
          state_id: "2948",
        },
        {
          id: "34082",
          name: "Agigea",
          state_id: "2948",
        },
        {
          id: "34083",
          name: "Albesti",
          state_id: "2948",
        },
        {
          id: "34084",
          name: "Aliman",
          state_id: "2948",
        },
        {
          id: "34085",
          name: "Amzacea",
          state_id: "2948",
        },
        {
          id: "34086",
          name: "Baneasa",
          state_id: "2948",
        },
        {
          id: "34087",
          name: "Basarabi",
          state_id: "2948",
        },
        {
          id: "34088",
          name: "Castelu",
          state_id: "2948",
        },
        {
          id: "34089",
          name: "Cerchezu",
          state_id: "2948",
        },
        {
          id: "34090",
          name: "Cernavoda",
          state_id: "2948",
        },
        {
          id: "34091",
          name: "Chirnogeni",
          state_id: "2948",
        },
        {
          id: "34092",
          name: "Ciobanu",
          state_id: "2948",
        },
        {
          id: "34093",
          name: "Ciocarlia",
          state_id: "2948",
        },
        {
          id: "34094",
          name: "Cobadin",
          state_id: "2948",
        },
        {
          id: "34095",
          name: "Cogealac",
          state_id: "2948",
        },
        {
          id: "34096",
          name: "Comana",
          state_id: "2948",
        },
        {
          id: "34097",
          name: "Constanta",
          state_id: "2948",
        },
        {
          id: "34098",
          name: "Corbu",
          state_id: "2948",
        },
        {
          id: "34099",
          name: "Costinesti",
          state_id: "2948",
        },
        {
          id: "34100",
          name: "Crucea",
          state_id: "2948",
        },
        {
          id: "34101",
          name: "Cumpana",
          state_id: "2948",
        },
        {
          id: "34102",
          name: "Deleni",
          state_id: "2948",
        },
        {
          id: "34103",
          name: "Dobromir",
          state_id: "2948",
        },
        {
          id: "34104",
          name: "Douazeci si Trei August",
          state_id: "2948",
        },
        {
          id: "34105",
          name: "Dumbraveni",
          state_id: "2948",
        },
        {
          id: "34106",
          name: "Eforie",
          state_id: "2948",
        },
        {
          id: "34107",
          name: "Garliciu",
          state_id: "2948",
        },
        {
          id: "34108",
          name: "Ghindaresti",
          state_id: "2948",
        },
        {
          id: "34109",
          name: "Harsova",
          state_id: "2948",
        },
        {
          id: "34110",
          name: "Horia",
          state_id: "2948",
        },
        {
          id: "34111",
          name: "Independenta",
          state_id: "2948",
        },
        {
          id: "34112",
          name: "Ion Corvin",
          state_id: "2948",
        },
        {
          id: "34113",
          name: "Istria",
          state_id: "2948",
        },
        {
          id: "34114",
          name: "Limanu",
          state_id: "2948",
        },
        {
          id: "34115",
          name: "Lipnita",
          state_id: "2948",
        },
        {
          id: "34116",
          name: "Lumina",
          state_id: "2948",
        },
        {
          id: "34117",
          name: "Mangalia",
          state_id: "2948",
        },
        {
          id: "34118",
          name: "Medgidia",
          state_id: "2948",
        },
        {
          id: "34119",
          name: "Mereni",
          state_id: "2948",
        },
        {
          id: "34120",
          name: "Mihai Viteazu",
          state_id: "2948",
        },
        {
          id: "34121",
          name: "Mihail Kogalniceanu",
          state_id: "2948",
        },
        {
          id: "34122",
          name: "Mircea Voda",
          state_id: "2948",
        },
        {
          id: "34123",
          name: "Navodari",
          state_id: "2948",
        },
        {
          id: "34124",
          name: "Negru Voda",
          state_id: "2948",
        },
        {
          id: "34125",
          name: "Nicolae Balcescu",
          state_id: "2948",
        },
        {
          id: "34126",
          name: "Oltina",
          state_id: "2948",
        },
        {
          id: "34127",
          name: "Ostrov",
          state_id: "2948",
        },
        {
          id: "34128",
          name: "Ovidiu",
          state_id: "2948",
        },
        {
          id: "34129",
          name: "Pantelimon",
          state_id: "2948",
        },
        {
          id: "34130",
          name: "Pecineaga",
          state_id: "2948",
        },
        {
          id: "34131",
          name: "Pestera",
          state_id: "2948",
        },
        {
          id: "34132",
          name: "Poarta Alba",
          state_id: "2948",
        },
        {
          id: "34133",
          name: "Rasova",
          state_id: "2948",
        },
        {
          id: "34134",
          name: "Sacele",
          state_id: "2948",
        },
        {
          id: "34135",
          name: "Saraiu",
          state_id: "2948",
        },
        {
          id: "34136",
          name: "Seimeni",
          state_id: "2948",
        },
        {
          id: "34137",
          name: "Silistea",
          state_id: "2948",
        },
        {
          id: "34138",
          name: "Targusor",
          state_id: "2948",
        },
        {
          id: "34139",
          name: "Techirghiol",
          state_id: "2948",
        },
        {
          id: "34140",
          name: "Topalu",
          state_id: "2948",
        },
        {
          id: "34141",
          name: "Topraisar",
          state_id: "2948",
        },
        {
          id: "34142",
          name: "Tortoman",
          state_id: "2948",
        },
        {
          id: "34143",
          name: "Tuzla",
          state_id: "2948",
        },
        {
          id: "34144",
          name: "Valu lui Traian",
          state_id: "2948",
        },
        {
          id: "34145",
          name: "Vulturu",
          state_id: "2948",
        },
      ],
      Covasna: [
        {
          id: "34146",
          name: "Aita Mare",
          state_id: "2949",
        },
        {
          id: "34147",
          name: "Baraolt",
          state_id: "2949",
        },
        {
          id: "34148",
          name: "Barcani",
          state_id: "2949",
        },
        {
          id: "34149",
          name: "Batani",
          state_id: "2949",
        },
        {
          id: "34150",
          name: "Belin",
          state_id: "2949",
        },
        {
          id: "34151",
          name: "Bodoc",
          state_id: "2949",
        },
        {
          id: "34152",
          name: "Borosneu Mare",
          state_id: "2949",
        },
        {
          id: "34153",
          name: "Bradut",
          state_id: "2949",
        },
        {
          id: "34154",
          name: "Brates",
          state_id: "2949",
        },
        {
          id: "34155",
          name: "Bretcu",
          state_id: "2949",
        },
        {
          id: "34156",
          name: "Catalina",
          state_id: "2949",
        },
        {
          id: "34157",
          name: "Cernat",
          state_id: "2949",
        },
        {
          id: "34158",
          name: "Chichis",
          state_id: "2949",
        },
        {
          id: "34159",
          name: "Comandau",
          state_id: "2949",
        },
        {
          id: "34160",
          name: "Covasna",
          state_id: "2949",
        },
        {
          id: "34161",
          name: "Dobarlau",
          state_id: "2949",
        },
        {
          id: "34162",
          name: "Ghelinta",
          state_id: "2949",
        },
        {
          id: "34163",
          name: "Ghidfalau",
          state_id: "2949",
        },
        {
          id: "34164",
          name: "Haghig",
          state_id: "2949",
        },
        {
          id: "34165",
          name: "Ilieni",
          state_id: "2949",
        },
        {
          id: "34166",
          name: "Intorsura Buzaului",
          state_id: "2949",
        },
        {
          id: "34167",
          name: "Lemnia",
          state_id: "2949",
        },
        {
          id: "34168",
          name: "Malnas",
          state_id: "2949",
        },
        {
          id: "34169",
          name: "Moacsa",
          state_id: "2949",
        },
        {
          id: "34170",
          name: "Ojdula",
          state_id: "2949",
        },
        {
          id: "34171",
          name: "Ozun",
          state_id: "2949",
        },
        {
          id: "34172",
          name: "Poian",
          state_id: "2949",
        },
        {
          id: "34173",
          name: "Reci",
          state_id: "2949",
        },
        {
          id: "34174",
          name: "Sanzieni",
          state_id: "2949",
        },
        {
          id: "34175",
          name: "Sfantu Gheorghe",
          state_id: "2949",
        },
        {
          id: "34176",
          name: "Sita Buzaului",
          state_id: "2949",
        },
        {
          id: "34177",
          name: "Targu Secuiesc",
          state_id: "2949",
        },
        {
          id: "34178",
          name: "Turia",
          state_id: "2949",
        },
        {
          id: "34179",
          name: "Valcele",
          state_id: "2949",
        },
        {
          id: "34180",
          name: "Valea Crisului",
          state_id: "2949",
        },
        {
          id: "34181",
          name: "Valea Mare",
          state_id: "2949",
        },
        {
          id: "34182",
          name: "Varghis",
          state_id: "2949",
        },
        {
          id: "34183",
          name: "Zabala",
          state_id: "2949",
        },
        {
          id: "34184",
          name: "Zagon",
          state_id: "2949",
        },
      ],
      Dambovita: [
        {
          id: "34185",
          name: "Aninoasa",
          state_id: "2950",
        },
        {
          id: "34186",
          name: "Baleni",
          state_id: "2950",
        },
        {
          id: "34187",
          name: "Barbuletu",
          state_id: "2950",
        },
        {
          id: "34188",
          name: "Bezdead",
          state_id: "2950",
        },
        {
          id: "34189",
          name: "Bilciuresti",
          state_id: "2950",
        },
        {
          id: "34190",
          name: "Branesti",
          state_id: "2950",
        },
        {
          id: "34191",
          name: "Branistea",
          state_id: "2950",
        },
        {
          id: "34192",
          name: "Brezoaiele",
          state_id: "2950",
        },
        {
          id: "34193",
          name: "Buciumeni",
          state_id: "2950",
        },
        {
          id: "34194",
          name: "Bucsani",
          state_id: "2950",
        },
        {
          id: "34195",
          name: "Butimanu",
          state_id: "2950",
        },
        {
          id: "34197",
          name: "Ciocanesti",
          state_id: "2950",
        },
        {
          id: "34198",
          name: "Cobia",
          state_id: "2950",
        },
        {
          id: "34199",
          name: "Cojasca",
          state_id: "2950",
        },
        {
          id: "34200",
          name: "Comisani",
          state_id: "2950",
        },
        {
          id: "34201",
          name: "Contesti",
          state_id: "2950",
        },
        {
          id: "34202",
          name: "Corbii Mari",
          state_id: "2950",
        },
        {
          id: "34203",
          name: "Cornatelu",
          state_id: "2950",
        },
        {
          id: "34204",
          name: "Cornesti",
          state_id: "2950",
        },
        {
          id: "34205",
          name: "Costestii din Vale",
          state_id: "2950",
        },
        {
          id: "34206",
          name: "Crangurile de Sus",
          state_id: "2950",
        },
        {
          id: "34207",
          name: "Crevedia",
          state_id: "2950",
        },
        {
          id: "34208",
          name: "Darmanesti",
          state_id: "2950",
        },
        {
          id: "34209",
          name: "Dobra",
          state_id: "2950",
        },
        {
          id: "34210",
          name: "Doicesti",
          state_id: "2950",
        },
        {
          id: "34211",
          name: "Dragodana",
          state_id: "2950",
        },
        {
          id: "34212",
          name: "Dragomiresti",
          state_id: "2950",
        },
        {
          id: "34213",
          name: "Edera de Jos",
          state_id: "2950",
        },
        {
          id: "34214",
          name: "Fieni",
          state_id: "2950",
        },
        {
          id: "34215",
          name: "Finta",
          state_id: "2950",
        },
        {
          id: "34216",
          name: "Gaesti",
          state_id: "2950",
        },
        {
          id: "34217",
          name: "Glodeni",
          state_id: "2950",
        },
        {
          id: "34218",
          name: "Gura Foii",
          state_id: "2950",
        },
        {
          id: "34219",
          name: "Gura Ocnitei",
          state_id: "2950",
        },
        {
          id: "34220",
          name: "Gura Sutii",
          state_id: "2950",
        },
        {
          id: "34221",
          name: "Hulubesti",
          state_id: "2950",
        },
        {
          id: "34222",
          name: "Ion luca Caragiale",
          state_id: "2950",
        },
        {
          id: "34223",
          name: "Lucieni",
          state_id: "2950",
        },
        {
          id: "34224",
          name: "Ludesti",
          state_id: "2950",
        },
        {
          id: "34225",
          name: "Lunguletu",
          state_id: "2950",
        },
        {
          id: "34226",
          name: "Malu cu Flori",
          state_id: "2950",
        },
        {
          id: "34227",
          name: "Manesti",
          state_id: "2950",
        },
        {
          id: "34228",
          name: "Matasaru",
          state_id: "2950",
        },
        {
          id: "34229",
          name: "Mogosani",
          state_id: "2950",
        },
        {
          id: "34230",
          name: "Moreni",
          state_id: "2950",
        },
        {
          id: "34231",
          name: "Moroeni",
          state_id: "2950",
        },
        {
          id: "34232",
          name: "Morteni",
          state_id: "2950",
        },
        {
          id: "34233",
          name: "Motaeni",
          state_id: "2950",
        },
        {
          id: "34234",
          name: "Niculesti",
          state_id: "2950",
        },
        {
          id: "34235",
          name: "Nucet",
          state_id: "2950",
        },
        {
          id: "34236",
          name: "Ocnita",
          state_id: "2950",
        },
        {
          id: "34237",
          name: "Odobesti",
          state_id: "2950",
        },
        {
          id: "34238",
          name: "Petresti",
          state_id: "2950",
        },
        {
          id: "34239",
          name: "Pietrosita",
          state_id: "2950",
        },
        {
          id: "34240",
          name: "Poiana",
          state_id: "2950",
        },
        {
          id: "34241",
          name: "Potlogi",
          state_id: "2950",
        },
        {
          id: "34242",
          name: "Produlesti",
          state_id: "2950",
        },
        {
          id: "34243",
          name: "Pucheni",
          state_id: "2950",
        },
        {
          id: "34244",
          name: "Pucioasa",
          state_id: "2950",
        },
        {
          id: "34245",
          name: "Racari",
          state_id: "2950",
        },
        {
          id: "34246",
          name: "Razvad",
          state_id: "2950",
        },
        {
          id: "34247",
          name: "Runcu",
          state_id: "2950",
        },
        {
          id: "34248",
          name: "Salcioara",
          state_id: "2950",
        },
        {
          id: "34249",
          name: "Selaru",
          state_id: "2950",
        },
        {
          id: "34250",
          name: "Slobozia Moara",
          state_id: "2950",
        },
        {
          id: "34251",
          name: "Sotanga",
          state_id: "2950",
        },
        {
          id: "34252",
          name: "Targoviste",
          state_id: "2950",
        },
        {
          id: "34253",
          name: "Tartasesti",
          state_id: "2950",
        },
        {
          id: "34254",
          name: "Tatarani",
          state_id: "2950",
        },
        {
          id: "34255",
          name: "Titu",
          state_id: "2950",
        },
        {
          id: "34256",
          name: "Uliesti",
          state_id: "2950",
        },
        {
          id: "34257",
          name: "Ulmi",
          state_id: "2950",
        },
        {
          id: "34258",
          name: "Vacaresti",
          state_id: "2950",
        },
        {
          id: "34259",
          name: "Valea Lunga",
          state_id: "2950",
        },
        {
          id: "34260",
          name: "Valea Mare",
          state_id: "2950",
        },
        {
          id: "34261",
          name: "Valeni-Dambovita",
          state_id: "2950",
        },
        {
          id: "34262",
          name: "Varfuri",
          state_id: "2950",
        },
        {
          id: "34263",
          name: "Visina",
          state_id: "2950",
        },
        {
          id: "34264",
          name: "Visinesti",
          state_id: "2950",
        },
        {
          id: "34265",
          name: "Voinesti",
          state_id: "2950",
        },
        {
          id: "34266",
          name: "Vulcana Bai",
          state_id: "2950",
        },
      ],
      Dolj: [
        {
          id: "34267",
          name: "Afumati",
          state_id: "2951",
        },
        {
          id: "34268",
          name: "Almajiu",
          state_id: "2951",
        },
        {
          id: "34269",
          name: "Amarastii de Jos",
          state_id: "2951",
        },
        {
          id: "34270",
          name: "Amarastii de Sus",
          state_id: "2951",
        },
        {
          id: "34271",
          name: "Apele Vii",
          state_id: "2951",
        },
        {
          id: "34272",
          name: "Argetoaia",
          state_id: "2951",
        },
        {
          id: "34273",
          name: "Bailesti",
          state_id: "2951",
        },
        {
          id: "34274",
          name: "Barca",
          state_id: "2951",
        },
        {
          id: "34275",
          name: "Bechet",
          state_id: "2951",
        },
        {
          id: "34276",
          name: "Bistret",
          state_id: "2951",
        },
        {
          id: "34277",
          name: "Botosesti-Paia",
          state_id: "2951",
        },
        {
          id: "34278",
          name: "Brabova",
          state_id: "2951",
        },
        {
          id: "34279",
          name: "Bradesti",
          state_id: "2951",
        },
        {
          id: "34280",
          name: "Bralostita",
          state_id: "2951",
        },
        {
          id: "34281",
          name: "Bratovoesti",
          state_id: "2951",
        },
        {
          id: "34282",
          name: "Breasta",
          state_id: "2951",
        },
        {
          id: "34283",
          name: "Bucovat",
          state_id: "2951",
        },
        {
          id: "34284",
          name: "Bulzesti",
          state_id: "2951",
        },
        {
          id: "34285",
          name: "Calafat",
          state_id: "2951",
        },
        {
          id: "34286",
          name: "Calarasi",
          state_id: "2951",
        },
        {
          id: "34287",
          name: "Calopar",
          state_id: "2951",
        },
        {
          id: "34288",
          name: "Caraula",
          state_id: "2951",
        },
        {
          id: "34289",
          name: "Carpen",
          state_id: "2951",
        },
        {
          id: "34290",
          name: "Castra-Nova",
          state_id: "2951",
        },
        {
          id: "34291",
          name: "Celaru",
          state_id: "2951",
        },
        {
          id: "34292",
          name: "Ceratu",
          state_id: "2951",
        },
        {
          id: "34293",
          name: "Cernatesti",
          state_id: "2951",
        },
        {
          id: "34294",
          name: "Cetate",
          state_id: "2951",
        },
        {
          id: "34295",
          name: "Cioroiasiu",
          state_id: "2951",
        },
        {
          id: "34296",
          name: "Ciupercenii Noi",
          state_id: "2951",
        },
        {
          id: "34297",
          name: "Cosoveni",
          state_id: "2951",
        },
        {
          id: "34298",
          name: "Cotofenii din Dos",
          state_id: "2951",
        },
        {
          id: "34299",
          name: "Craiova",
          state_id: "2951",
        },
        {
          id: "34300",
          name: "Dabuleni",
          state_id: "2951",
        },
        {
          id: "34301",
          name: "Daneti",
          state_id: "2951",
        },
        {
          id: "34302",
          name: "Desa",
          state_id: "2951",
        },
        {
          id: "34303",
          name: "Diosti",
          state_id: "2951",
        },
        {
          id: "34304",
          name: "Dobresti",
          state_id: "2951",
        },
        {
          id: "34305",
          name: "Dragotesti",
          state_id: "2951",
        },
        {
          id: "34306",
          name: "Dranic",
          state_id: "2951",
        },
        {
          id: "34307",
          name: "Farcasu",
          state_id: "2951",
        },
        {
          id: "34308",
          name: "Filiasi",
          state_id: "2951",
        },
        {
          id: "34309",
          name: "Galicea Mare",
          state_id: "2951",
        },
        {
          id: "34310",
          name: "Gangiova",
          state_id: "2951",
        },
        {
          id: "34311",
          name: "Ghercesti",
          state_id: "2951",
        },
        {
          id: "34312",
          name: "Gighera",
          state_id: "2951",
        },
        {
          id: "34313",
          name: "Giubega",
          state_id: "2951",
        },
        {
          id: "34314",
          name: "Giurgita",
          state_id: "2951",
        },
        {
          id: "34315",
          name: "Gogosu",
          state_id: "2951",
        },
        {
          id: "34316",
          name: "Goicea",
          state_id: "2951",
        },
        {
          id: "34317",
          name: "Goiesti",
          state_id: "2951",
        },
        {
          id: "34318",
          name: "Grecesti",
          state_id: "2951",
        },
        {
          id: "34319",
          name: "Isalnita",
          state_id: "2951",
        },
        {
          id: "34320",
          name: "Izvoare",
          state_id: "2951",
        },
        {
          id: "34321",
          name: "Leu",
          state_id: "2951",
        },
        {
          id: "34322",
          name: "Lipovu",
          state_id: "2951",
        },
        {
          id: "34323",
          name: "Macesu de Jos",
          state_id: "2951",
        },
        {
          id: "34324",
          name: "Macesu de Sus",
          state_id: "2951",
        },
        {
          id: "34325",
          name: "Maglavit",
          state_id: "2951",
        },
        {
          id: "34326",
          name: "Malu Mare",
          state_id: "2951",
        },
        {
          id: "34327",
          name: "Marsani",
          state_id: "2951",
        },
        {
          id: "34328",
          name: "Melinesti",
          state_id: "2951",
        },
        {
          id: "34329",
          name: "Mischii",
          state_id: "2951",
        },
        {
          id: "34330",
          name: "Motatei",
          state_id: "2951",
        },
        {
          id: "34331",
          name: "Murgasi",
          state_id: "2951",
        },
        {
          id: "34332",
          name: "Negoi",
          state_id: "2951",
        },
        {
          id: "34333",
          name: "Orodel",
          state_id: "2951",
        },
        {
          id: "34334",
          name: "Ostroveni",
          state_id: "2951",
        },
        {
          id: "34335",
          name: "Perisor",
          state_id: "2951",
        },
        {
          id: "34336",
          name: "Pielesti",
          state_id: "2951",
        },
        {
          id: "34337",
          name: "Piscu Vechi",
          state_id: "2951",
        },
        {
          id: "34338",
          name: "Plenita",
          state_id: "2951",
        },
        {
          id: "34339",
          name: "Podari",
          state_id: "2951",
        },
        {
          id: "34340",
          name: "Poiana Mare",
          state_id: "2951",
        },
        {
          id: "34341",
          name: "Predesti",
          state_id: "2951",
        },
        {
          id: "34342",
          name: "Radovan",
          state_id: "2951",
        },
        {
          id: "34343",
          name: "Rastu",
          state_id: "2951",
        },
        {
          id: "34344",
          name: "Robanesti",
          state_id: "2951",
        },
        {
          id: "34345",
          name: "Sadova",
          state_id: "2951",
        },
        {
          id: "34346",
          name: "Salcuta",
          state_id: "2951",
        },
        {
          id: "34347",
          name: "Scaesti",
          state_id: "2951",
        },
        {
          id: "34348",
          name: "Seaca de Camp",
          state_id: "2951",
        },
        {
          id: "34349",
          name: "Seaca de Padure",
          state_id: "2951",
        },
        {
          id: "34350",
          name: "Secu",
          state_id: "2951",
        },
        {
          id: "34351",
          name: "Segarcea",
          state_id: "2951",
        },
        {
          id: "34352",
          name: "Silistea Crucii",
          state_id: "2951",
        },
        {
          id: "34353",
          name: "Simnicu de Sus",
          state_id: "2951",
        },
        {
          id: "34354",
          name: "Sopot",
          state_id: "2951",
        },
        {
          id: "34355",
          name: "Teasc",
          state_id: "2951",
        },
        {
          id: "34356",
          name: "Terpezita",
          state_id: "2951",
        },
        {
          id: "34357",
          name: "Teslui",
          state_id: "2951",
        },
        {
          id: "34358",
          name: "Tuglui",
          state_id: "2951",
        },
        {
          id: "34359",
          name: "Unirea",
          state_id: "2951",
        },
        {
          id: "34360",
          name: "Urzicuta",
          state_id: "2951",
        },
        {
          id: "34361",
          name: "Valea Stanciului",
          state_id: "2951",
        },
        {
          id: "34362",
          name: "Vartop",
          state_id: "2951",
        },
        {
          id: "34363",
          name: "Varvoru",
          state_id: "2951",
        },
        {
          id: "34364",
          name: "Vela",
          state_id: "2951",
        },
        {
          id: "34365",
          name: "Verbita",
          state_id: "2951",
        },
      ],
      Galati: [
        {
          id: "34366",
          name: "Balabanesti",
          state_id: "2952",
        },
        {
          id: "34367",
          name: "Balasesti",
          state_id: "2952",
        },
        {
          id: "34368",
          name: "Baleni",
          state_id: "2952",
        },
        {
          id: "34369",
          name: "Baneasa",
          state_id: "2952",
        },
        {
          id: "34370",
          name: "Barcea",
          state_id: "2952",
        },
        {
          id: "34371",
          name: "Beresti",
          state_id: "2952",
        },
        {
          id: "34372",
          name: "Beresti-Sat",
          state_id: "2952",
        },
        {
          id: "34373",
          name: "Brahasesti",
          state_id: "2952",
        },
        {
          id: "34374",
          name: "Branistea",
          state_id: "2952",
        },
        {
          id: "34375",
          name: "Buciumeni",
          state_id: "2952",
        },
        {
          id: "34376",
          name: "Cavadinesti",
          state_id: "2952",
        },
        {
          id: "34377",
          name: "Certesti",
          state_id: "2952",
        },
        {
          id: "34378",
          name: "Corni",
          state_id: "2952",
        },
        {
          id: "34379",
          name: "Corod",
          state_id: "2952",
        },
        {
          id: "34380",
          name: "Cosmesti",
          state_id: "2952",
        },
        {
          id: "34381",
          name: "Costache Negri",
          state_id: "2952",
        },
        {
          id: "34382",
          name: "Cuca",
          state_id: "2952",
        },
        {
          id: "34383",
          name: "Cudalbi",
          state_id: "2952",
        },
        {
          id: "34384",
          name: "Draganesti",
          state_id: "2952",
        },
        {
          id: "34385",
          name: "Draguseni",
          state_id: "2952",
        },
        {
          id: "34386",
          name: "Fartanesti",
          state_id: "2952",
        },
        {
          id: "34387",
          name: "Foltesti",
          state_id: "2952",
        },
        {
          id: "34388",
          name: "Frumusita",
          state_id: "2952",
        },
        {
          id: "34389",
          name: "Fundeni",
          state_id: "2952",
        },
        {
          id: "34390",
          name: "Galati",
          state_id: "2952",
        },
        {
          id: "34391",
          name: "Ghidigeni",
          state_id: "2952",
        },
        {
          id: "34392",
          name: "Gohor",
          state_id: "2952",
        },
        {
          id: "34393",
          name: "Grivita",
          state_id: "2952",
        },
        {
          id: "34394",
          name: "Independenta",
          state_id: "2952",
        },
        {
          id: "34395",
          name: "Ivesti",
          state_id: "2952",
        },
        {
          id: "34396",
          name: "Jorasti",
          state_id: "2952",
        },
        {
          id: "34397",
          name: "Liesti",
          state_id: "2952",
        },
        {
          id: "34398",
          name: "Mastacani",
          state_id: "2952",
        },
        {
          id: "34399",
          name: "Matca",
          state_id: "2952",
        },
        {
          id: "34400",
          name: "Movileni",
          state_id: "2952",
        },
        {
          id: "34401",
          name: "Munteni",
          state_id: "2952",
        },
        {
          id: "34402",
          name: "Namoloasa",
          state_id: "2952",
        },
        {
          id: "34403",
          name: "Nicoresti",
          state_id: "2952",
        },
        {
          id: "34404",
          name: "Oancea",
          state_id: "2952",
        },
        {
          id: "34405",
          name: "Pechea",
          state_id: "2952",
        },
        {
          id: "34406",
          name: "Piscu",
          state_id: "2952",
        },
        {
          id: "34407",
          name: "Priponesti",
          state_id: "2952",
        },
        {
          id: "34408",
          name: "Rediu",
          state_id: "2952",
        },
        {
          id: "34409",
          name: "Scanteiesti",
          state_id: "2952",
        },
        {
          id: "34410",
          name: "Schela",
          state_id: "2952",
        },
        {
          id: "34411",
          name: "Sendreni",
          state_id: "2952",
        },
        {
          id: "34412",
          name: "Slobozia-Conachi",
          state_id: "2952",
        },
        {
          id: "34413",
          name: "Smardan",
          state_id: "2952",
        },
        {
          id: "34414",
          name: "Smulti",
          state_id: "2952",
        },
        {
          id: "34415",
          name: "Suceveni",
          state_id: "2952",
        },
        {
          id: "34416",
          name: "Targu Bujor",
          state_id: "2952",
        },
        {
          id: "34417",
          name: "Tecuci",
          state_id: "2952",
        },
        {
          id: "34418",
          name: "Tepu",
          state_id: "2952",
        },
        {
          id: "34419",
          name: "Tudor Vladimirescu",
          state_id: "2952",
        },
        {
          id: "34420",
          name: "Tulucesti",
          state_id: "2952",
        },
        {
          id: "34421",
          name: "Umbraresti",
          state_id: "2952",
        },
        {
          id: "34422",
          name: "Valea Marului",
          state_id: "2952",
        },
        {
          id: "34423",
          name: "Vanatori",
          state_id: "2952",
        },
        {
          id: "34424",
          name: "Varlezi",
          state_id: "2952",
        },
        {
          id: "34425",
          name: "Vladesti",
          state_id: "2952",
        },
      ],
      Giurgiu: [
        {
          id: "34426",
          name: "Adunatii-Copaceni",
          state_id: "2953",
        },
        {
          id: "34427",
          name: "Baneasa",
          state_id: "2953",
        },
        {
          id: "34428",
          name: "Bolintin Deal",
          state_id: "2953",
        },
        {
          id: "34429",
          name: "Bolintinu-din-Vale",
          state_id: "2953",
        },
        {
          id: "34430",
          name: "Bucsani",
          state_id: "2953",
        },
        {
          id: "34431",
          name: "Bulbucata",
          state_id: "2953",
        },
        {
          id: "34432",
          name: "Buturugeni",
          state_id: "2953",
        },
        {
          id: "34433",
          name: "Calugareni",
          state_id: "2953",
        },
        {
          id: "34434",
          name: "Clejani",
          state_id: "2953",
        },
        {
          id: "34435",
          name: "Colibasi",
          state_id: "2953",
        },
        {
          id: "34436",
          name: "Comana",
          state_id: "2953",
        },
        {
          id: "34437",
          name: "Crevedia Mare",
          state_id: "2953",
        },
        {
          id: "34438",
          name: "Daia",
          state_id: "2953",
        },
        {
          id: "34439",
          name: "Floresti-Stoenesti",
          state_id: "2953",
        },
        {
          id: "34440",
          name: "Fratesti",
          state_id: "2953",
        },
        {
          id: "34441",
          name: "Gaiseni",
          state_id: "2953",
        },
        {
          id: "34442",
          name: "Gaujani",
          state_id: "2953",
        },
        {
          id: "34443",
          name: "Ghimpati",
          state_id: "2953",
        },
        {
          id: "34444",
          name: "Giurgiu",
          state_id: "2953",
        },
        {
          id: "34445",
          name: "Gogosari",
          state_id: "2953",
        },
        {
          id: "34446",
          name: "Gostinari",
          state_id: "2953",
        },
        {
          id: "34447",
          name: "Gostinu",
          state_id: "2953",
        },
        {
          id: "34448",
          name: "Gradinari",
          state_id: "2953",
        },
        {
          id: "34449",
          name: "Greaca",
          state_id: "2953",
        },
        {
          id: "34450",
          name: "Hotarele",
          state_id: "2953",
        },
        {
          id: "34451",
          name: "Iepuresti",
          state_id: "2953",
        },
        {
          id: "34452",
          name: "Izvoarele",
          state_id: "2953",
        },
        {
          id: "34453",
          name: "Joita",
          state_id: "2953",
        },
        {
          id: "34454",
          name: "Letca Noua",
          state_id: "2953",
        },
        {
          id: "34455",
          name: "Marsa",
          state_id: "2953",
        },
        {
          id: "34456",
          name: "Mihai Bravu",
          state_id: "2953",
        },
        {
          id: "34457",
          name: "Mihailesti",
          state_id: "2953",
        },
        {
          id: "34458",
          name: "Ogrezeni",
          state_id: "2953",
        },
        {
          id: "34459",
          name: "Oinacu",
          state_id: "2953",
        },
        {
          id: "34460",
          name: "Prundu",
          state_id: "2953",
        },
        {
          id: "34461",
          name: "Putineiu",
          state_id: "2953",
        },
        {
          id: "34462",
          name: "Rasuceni",
          state_id: "2953",
        },
        {
          id: "34463",
          name: "Roata de Jos",
          state_id: "2953",
        },
        {
          id: "34464",
          name: "Schitu",
          state_id: "2953",
        },
        {
          id: "34465",
          name: "Singureni",
          state_id: "2953",
        },
        {
          id: "34466",
          name: "Slobozia",
          state_id: "2953",
        },
        {
          id: "34467",
          name: "Stanesti",
          state_id: "2953",
        },
        {
          id: "34468",
          name: "Stoenesti",
          state_id: "2953",
        },
        {
          id: "34469",
          name: "Toporu",
          state_id: "2953",
        },
        {
          id: "34470",
          name: "Ulmi",
          state_id: "2953",
        },
        {
          id: "34471",
          name: "Valea Dragului",
          state_id: "2953",
        },
        {
          id: "34472",
          name: "Vanatorii Mici",
          state_id: "2953",
        },
        {
          id: "34473",
          name: "Varasti",
          state_id: "2953",
        },
        {
          id: "34474",
          name: "Vedea",
          state_id: "2953",
        },
      ],
      Gorj: [
        {
          id: "34475",
          name: "Albeni",
          state_id: "2954",
        },
        {
          id: "34476",
          name: "Alimpesti",
          state_id: "2954",
        },
        {
          id: "34477",
          name: "Aninoasa",
          state_id: "2954",
        },
        {
          id: "34478",
          name: "Arcani",
          state_id: "2954",
        },
        {
          id: "34479",
          name: "Baia de Fier",
          state_id: "2954",
        },
        {
          id: "34480",
          name: "Balanesti",
          state_id: "2954",
        },
        {
          id: "34481",
          name: "Balesti",
          state_id: "2954",
        },
        {
          id: "34482",
          name: "Balteni",
          state_id: "2954",
        },
        {
          id: "34483",
          name: "Barbatesti",
          state_id: "2954",
        },
        {
          id: "34484",
          name: "Bengesti",
          state_id: "2954",
        },
        {
          id: "34485",
          name: "Berlesti",
          state_id: "2954",
        },
        {
          id: "34486",
          name: "Bolbosi",
          state_id: "2954",
        },
        {
          id: "34487",
          name: "Borascu",
          state_id: "2954",
        },
        {
          id: "34488",
          name: "Branesti",
          state_id: "2954",
        },
        {
          id: "34489",
          name: "Bumbesti-Jiu",
          state_id: "2954",
        },
        {
          id: "34490",
          name: "Bumbesti-Piticu",
          state_id: "2954",
        },
        {
          id: "34491",
          name: "Bustuchin",
          state_id: "2954",
        },
        {
          id: "34492",
          name: "Calnic",
          state_id: "2954",
        },
        {
          id: "34493",
          name: "Capreni",
          state_id: "2954",
        },
        {
          id: "34494",
          name: "Catunele",
          state_id: "2954",
        },
        {
          id: "34495",
          name: "Ciuperceni",
          state_id: "2954",
        },
        {
          id: "34496",
          name: "Crasna",
          state_id: "2954",
        },
        {
          id: "34497",
          name: "Crusetu",
          state_id: "2954",
        },
        {
          id: "34498",
          name: "Danciulesti",
          state_id: "2954",
        },
        {
          id: "34499",
          name: "Danesti",
          state_id: "2954",
        },
        {
          id: "34500",
          name: "Dragotesti",
          state_id: "2954",
        },
        {
          id: "34501",
          name: "Dragutesti",
          state_id: "2954",
        },
        {
          id: "34502",
          name: "Farcasesti",
          state_id: "2954",
        },
        {
          id: "34503",
          name: "Glogova",
          state_id: "2954",
        },
        {
          id: "34504",
          name: "Godinesti",
          state_id: "2954",
        },
        {
          id: "34505",
          name: "Hurezani",
          state_id: "2954",
        },
        {
          id: "34506",
          name: "Ionesti",
          state_id: "2954",
        },
        {
          id: "34507",
          name: "Jupanesti",
          state_id: "2954",
        },
        {
          id: "34508",
          name: "Lelesti",
          state_id: "2954",
        },
        {
          id: "34509",
          name: "Licuriciu",
          state_id: "2954",
        },
        {
          id: "34510",
          name: "Logresti",
          state_id: "2954",
        },
        {
          id: "34511",
          name: "Matasari",
          state_id: "2954",
        },
        {
          id: "34512",
          name: "Motru",
          state_id: "2954",
        },
        {
          id: "34513",
          name: "Musetesti",
          state_id: "2954",
        },
        {
          id: "34514",
          name: "Negomiru",
          state_id: "2954",
        },
        {
          id: "34515",
          name: "Novaci",
          state_id: "2954",
        },
        {
          id: "34516",
          name: "Pades",
          state_id: "2954",
        },
        {
          id: "34517",
          name: "Pestisani",
          state_id: "2954",
        },
        {
          id: "34518",
          name: "Plopsoru",
          state_id: "2954",
        },
        {
          id: "34519",
          name: "Polovragi",
          state_id: "2954",
        },
        {
          id: "34520",
          name: "Prigoria",
          state_id: "2954",
        },
        {
          id: "34521",
          name: "Rosia de Amaradia",
          state_id: "2954",
        },
        {
          id: "34522",
          name: "Rovinari",
          state_id: "2954",
        },
        {
          id: "34523",
          name: "Runcu",
          state_id: "2954",
        },
        {
          id: "34524",
          name: "Sacelu",
          state_id: "2954",
        },
        {
          id: "34525",
          name: "Samarinesti",
          state_id: "2954",
        },
        {
          id: "34526",
          name: "Saulesti",
          state_id: "2954",
        },
        {
          id: "34527",
          name: "Schela",
          state_id: "2954",
        },
        {
          id: "34528",
          name: "Scoarta",
          state_id: "2954",
        },
        {
          id: "34529",
          name: "Slivilesti",
          state_id: "2954",
        },
        {
          id: "34530",
          name: "Stanesti",
          state_id: "2954",
        },
        {
          id: "34531",
          name: "Stejari",
          state_id: "2954",
        },
        {
          id: "34532",
          name: "Stoina",
          state_id: "2954",
        },
        {
          id: "34533",
          name: "Tantareni",
          state_id: "2954",
        },
        {
          id: "34534",
          name: "Targu Carbunesti",
          state_id: "2954",
        },
        {
          id: "34535",
          name: "Targu Jiu",
          state_id: "2954",
        },
        {
          id: "34536",
          name: "Telesti",
          state_id: "2954",
        },
        {
          id: "34537",
          name: "Ticleni",
          state_id: "2954",
        },
        {
          id: "34538",
          name: "Tismana",
          state_id: "2954",
        },
        {
          id: "34539",
          name: "Turburea",
          state_id: "2954",
        },
        {
          id: "34540",
          name: "Turceni",
          state_id: "2954",
        },
        {
          id: "34541",
          name: "Turcinesti",
          state_id: "2954",
        },
        {
          id: "34542",
          name: "Urdari",
          state_id: "2954",
        },
        {
          id: "34543",
          name: "Vagiulesti",
          state_id: "2954",
        },
        {
          id: "34544",
          name: "Vladimir",
          state_id: "2954",
        },
      ],
      Harghita: [
        {
          id: "34545",
          name: "Atid",
          state_id: "2955",
        },
        {
          id: "34546",
          name: "Avramesti",
          state_id: "2955",
        },
        {
          id: "34547",
          name: "Baile Tusnad",
          state_id: "2955",
        },
        {
          id: "34548",
          name: "Balan",
          state_id: "2955",
        },
        {
          id: "34549",
          name: "Bilbor",
          state_id: "2955",
        },
        {
          id: "34550",
          name: "Borsec",
          state_id: "2955",
        },
        {
          id: "34551",
          name: "Bradesti",
          state_id: "2955",
        },
        {
          id: "34552",
          name: "Capalnita",
          state_id: "2955",
        },
        {
          id: "34553",
          name: "Carta",
          state_id: "2955",
        },
        {
          id: "34554",
          name: "Ciucsangeorgiu",
          state_id: "2955",
        },
        {
          id: "34555",
          name: "Ciumani",
          state_id: "2955",
        },
        {
          id: "34556",
          name: "Corbu",
          state_id: "2955",
        },
        {
          id: "34557",
          name: "Corund",
          state_id: "2955",
        },
        {
          id: "34558",
          name: "Cristuru Secuiesc",
          state_id: "2955",
        },
        {
          id: "34559",
          name: "Danesti",
          state_id: "2955",
        },
        {
          id: "34560",
          name: "Darjiu",
          state_id: "2955",
        },
        {
          id: "34561",
          name: "Dealu",
          state_id: "2955",
        },
        {
          id: "34562",
          name: "Ditrau",
          state_id: "2955",
        },
        {
          id: "34563",
          name: "Feliceni",
          state_id: "2955",
        },
        {
          id: "34564",
          name: "Frumoasa",
          state_id: "2955",
        },
        {
          id: "34565",
          name: "Galautas",
          state_id: "2955",
        },
        {
          id: "34566",
          name: "Gheorgheni",
          state_id: "2955",
        },
        {
          id: "34567",
          name: "Joseni",
          state_id: "2955",
        },
        {
          id: "34568",
          name: "Lazarea",
          state_id: "2955",
        },
        {
          id: "34569",
          name: "Lueta",
          state_id: "2955",
        },
        {
          id: "34570",
          name: "Lunca de Jos",
          state_id: "2955",
        },
        {
          id: "34571",
          name: "Lunca de Sus",
          state_id: "2955",
        },
        {
          id: "34572",
          name: "Lupeni",
          state_id: "2955",
        },
        {
          id: "34573",
          name: "Martinis",
          state_id: "2955",
        },
        {
          id: "34574",
          name: "Meresti",
          state_id: "2955",
        },
        {
          id: "34575",
          name: "Miercurea-Ciuc",
          state_id: "2955",
        },
        {
          id: "34576",
          name: "Mihaileni",
          state_id: "2955",
        },
        {
          id: "34577",
          name: "Mugeni",
          state_id: "2955",
        },
        {
          id: "34578",
          name: "Ocland",
          state_id: "2955",
        },
        {
          id: "34579",
          name: "Odorheiu Secuiesc",
          state_id: "2955",
        },
        {
          id: "34580",
          name: "Pauleni-Ciuc",
          state_id: "2955",
        },
        {
          id: "34581",
          name: "Plaiesii-de-Jos",
          state_id: "2955",
        },
        {
          id: "34582",
          name: "Praid",
          state_id: "2955",
        },
        {
          id: "34583",
          name: "Remetea",
          state_id: "2955",
        },
        {
          id: "34584",
          name: "Sacel",
          state_id: "2955",
        },
        {
          id: "34585",
          name: "Sancraieni",
          state_id: "2955",
        },
        {
          id: "34586",
          name: "Sandominic",
          state_id: "2955",
        },
        {
          id: "34587",
          name: "Sanmartin",
          state_id: "2955",
        },
        {
          id: "34588",
          name: "Sansimion",
          state_id: "2955",
        },
        {
          id: "34589",
          name: "Sarmas",
          state_id: "2955",
        },
        {
          id: "34590",
          name: "Secuieni",
          state_id: "2955",
        },
        {
          id: "34591",
          name: "Siculeni",
          state_id: "2955",
        },
        {
          id: "34592",
          name: "Simonesti",
          state_id: "2955",
        },
        {
          id: "34593",
          name: "Subcetate",
          state_id: "2955",
        },
        {
          id: "34594",
          name: "Suseni",
          state_id: "2955",
        },
        {
          id: "34595",
          name: "Toplita",
          state_id: "2955",
        },
        {
          id: "34596",
          name: "Tulghes",
          state_id: "2955",
        },
        {
          id: "34597",
          name: "Tusnad",
          state_id: "2955",
        },
        {
          id: "34598",
          name: "Ulies",
          state_id: "2955",
        },
        {
          id: "34599",
          name: "Varsag",
          state_id: "2955",
        },
        {
          id: "34600",
          name: "Vlahita",
          state_id: "2955",
        },
        {
          id: "34601",
          name: "Voslobeni",
          state_id: "2955",
        },
        {
          id: "34602",
          name: "Zetea",
          state_id: "2955",
        },
      ],
      Hunedoara: [
        {
          id: "34603",
          name: "Aninoasa",
          state_id: "2956",
        },
        {
          id: "34604",
          name: "Bacia",
          state_id: "2956",
        },
        {
          id: "34605",
          name: "Baia de Cris",
          state_id: "2956",
        },
        {
          id: "34606",
          name: "Baita",
          state_id: "2956",
        },
        {
          id: "34607",
          name: "Balsa",
          state_id: "2956",
        },
        {
          id: "34608",
          name: "Banita",
          state_id: "2956",
        },
        {
          id: "34609",
          name: "Baru",
          state_id: "2956",
        },
        {
          id: "34610",
          name: "Batrana",
          state_id: "2956",
        },
        {
          id: "34611",
          name: "Beriu",
          state_id: "2956",
        },
        {
          id: "34612",
          name: "Berthelot",
          state_id: "2956",
        },
        {
          id: "34613",
          name: "Blajeni",
          state_id: "2956",
        },
        {
          id: "34614",
          name: "Bosorod",
          state_id: "2956",
        },
        {
          id: "34615",
          name: "Brad",
          state_id: "2956",
        },
        {
          id: "34616",
          name: "Branisca",
          state_id: "2956",
        },
        {
          id: "34617",
          name: "Bretea Romana",
          state_id: "2956",
        },
        {
          id: "34618",
          name: "Buces",
          state_id: "2956",
        },
        {
          id: "34619",
          name: "Bucuresci",
          state_id: "2956",
        },
        {
          id: "34620",
          name: "Bulzesti",
          state_id: "2956",
        },
        {
          id: "34621",
          name: "Bunila",
          state_id: "2956",
        },
        {
          id: "34622",
          name: "Burjuc",
          state_id: "2956",
        },
        {
          id: "34623",
          name: "Calan",
          state_id: "2956",
        },
        {
          id: "34624",
          name: "Carjiti",
          state_id: "2956",
        },
        {
          id: "34625",
          name: "Cerbal",
          state_id: "2956",
        },
        {
          id: "34626",
          name: "Certeju de Sus",
          state_id: "2956",
        },
        {
          id: "34627",
          name: "Criscior",
          state_id: "2956",
        },
        {
          id: "34628",
          name: "Densus",
          state_id: "2956",
        },
        {
          id: "34629",
          name: "Deva",
          state_id: "2956",
        },
        {
          id: "34630",
          name: "Dobra",
          state_id: "2956",
        },
        {
          id: "34631",
          name: "Geoagiu",
          state_id: "2956",
        },
        {
          id: "34632",
          name: "Ghelari",
          state_id: "2956",
        },
        {
          id: "34633",
          name: "Gurasada",
          state_id: "2956",
        },
        {
          id: "34634",
          name: "Harau",
          state_id: "2956",
        },
        {
          id: "34635",
          name: "Hateg",
          state_id: "2956",
        },
        {
          id: "34636",
          name: "Hunedoara",
          state_id: "2956",
        },
        {
          id: "34637",
          name: "Ilia",
          state_id: "2956",
        },
        {
          id: "34638",
          name: "Lapugiu de Jos",
          state_id: "2956",
        },
        {
          id: "34639",
          name: "Lelese",
          state_id: "2956",
        },
        {
          id: "34640",
          name: "Lunca Cernii de Jos",
          state_id: "2956",
        },
        {
          id: "34641",
          name: "Luncoiu de Jos",
          state_id: "2956",
        },
        {
          id: "34642",
          name: "Lupeni",
          state_id: "2956",
        },
        {
          id: "34643",
          name: "Martinesti",
          state_id: "2956",
        },
        {
          id: "34644",
          name: "Orastie",
          state_id: "2956",
        },
        {
          id: "34645",
          name: "Orastioara de Sus",
          state_id: "2956",
        },
        {
          id: "34646",
          name: "Pestisu Mic",
          state_id: "2956",
        },
        {
          id: "34647",
          name: "Petrila",
          state_id: "2956",
        },
        {
          id: "34648",
          name: "Petrosani",
          state_id: "2956",
        },
        {
          id: "34649",
          name: "Pui",
          state_id: "2956",
        },
        {
          id: "34650",
          name: "Rachitova",
          state_id: "2956",
        },
        {
          id: "34651",
          name: "Rapoltu Mare",
          state_id: "2956",
        },
        {
          id: "34652",
          name: "Rau de Mori",
          state_id: "2956",
        },
        {
          id: "34653",
          name: "Ribita",
          state_id: "2956",
        },
        {
          id: "34654",
          name: "Romos",
          state_id: "2956",
        },
        {
          id: "34655",
          name: "Salasu de Sus",
          state_id: "2956",
        },
        {
          id: "34656",
          name: "Santamaria Orlea",
          state_id: "2956",
        },
        {
          id: "34657",
          name: "Sarmizegetusa",
          state_id: "2956",
        },
        {
          id: "34658",
          name: "Simeria",
          state_id: "2956",
        },
        {
          id: "34659",
          name: "Soimus",
          state_id: "2956",
        },
        {
          id: "34660",
          name: "Teliucu Inferior",
          state_id: "2956",
        },
        {
          id: "34661",
          name: "Tomesti",
          state_id: "2956",
        },
        {
          id: "34662",
          name: "Toplita",
          state_id: "2956",
        },
        {
          id: "34663",
          name: "Totesti",
          state_id: "2956",
        },
        {
          id: "34664",
          name: "Turdas",
          state_id: "2956",
        },
        {
          id: "34665",
          name: "Uricani",
          state_id: "2956",
        },
        {
          id: "34666",
          name: "Valisoara",
          state_id: "2956",
        },
        {
          id: "34667",
          name: "Vata de Jos",
          state_id: "2956",
        },
        {
          id: "34668",
          name: "Vetel",
          state_id: "2956",
        },
        {
          id: "34669",
          name: "Vorta",
          state_id: "2956",
        },
        {
          id: "34670",
          name: "Vulcan",
          state_id: "2956",
        },
        {
          id: "34671",
          name: "Zam",
          state_id: "2956",
        },
      ],
      Ialomita: [
        {
          id: "34672",
          name: "Adancata",
          state_id: "2957",
        },
        {
          id: "34673",
          name: "Albesti",
          state_id: "2957",
        },
        {
          id: "34674",
          name: "Alexeni",
          state_id: "2957",
        },
        {
          id: "34675",
          name: "Amara",
          state_id: "2957",
        },
        {
          id: "34676",
          name: "Andrasesti",
          state_id: "2957",
        },
        {
          id: "34677",
          name: "Armasesti",
          state_id: "2957",
        },
        {
          id: "34678",
          name: "Axintele",
          state_id: "2957",
        },
        {
          id: "34679",
          name: "Balaciu",
          state_id: "2957",
        },
        {
          id: "34680",
          name: "Barcanesti",
          state_id: "2957",
        },
        {
          id: "34681",
          name: "Bordusani",
          state_id: "2957",
        },
        {
          id: "34682",
          name: "Brazii",
          state_id: "2957",
        },
        {
          id: "34683",
          name: "Bucu",
          state_id: "2957",
        },
        {
          id: "34684",
          name: "Cazanesti",
          state_id: "2957",
        },
        {
          id: "34685",
          name: "Ciocarlia",
          state_id: "2957",
        },
        {
          id: "34686",
          name: "Ciochina",
          state_id: "2957",
        },
        {
          id: "34687",
          name: "Ciulnita",
          state_id: "2957",
        },
        {
          id: "34688",
          name: "Cocora",
          state_id: "2957",
        },
        {
          id: "34689",
          name: "Cosambesti",
          state_id: "2957",
        },
        {
          id: "34690",
          name: "Cosereni",
          state_id: "2957",
        },
        {
          id: "34691",
          name: "Dragoesti",
          state_id: "2957",
        },
        {
          id: "34692",
          name: "Dridu",
          state_id: "2957",
        },
        {
          id: "34693",
          name: "Facaeni",
          state_id: "2957",
        },
        {
          id: "34694",
          name: "Fetesti",
          state_id: "2957",
        },
        {
          id: "34695",
          name: "Fierbinti-Targ",
          state_id: "2957",
        },
        {
          id: "34696",
          name: "Garbovi",
          state_id: "2957",
        },
        {
          id: "34697",
          name: "Gheorghe Doja",
          state_id: "2957",
        },
        {
          id: "34698",
          name: "Gheorghe Lazar",
          state_id: "2957",
        },
        {
          id: "34699",
          name: "Giurgeni",
          state_id: "2957",
        },
        {
          id: "34700",
          name: "Grindu",
          state_id: "2957",
        },
        {
          id: "34701",
          name: "Grivita",
          state_id: "2957",
        },
        {
          id: "34702",
          name: "Ion Roata",
          state_id: "2957",
        },
        {
          id: "34703",
          name: "Jilavele",
          state_id: "2957",
        },
        {
          id: "34704",
          name: "Manasia",
          state_id: "2957",
        },
        {
          id: "34705",
          name: "Mihail Kogalniceanu",
          state_id: "2957",
        },
        {
          id: "34706",
          name: "Milosesti",
          state_id: "2957",
        },
        {
          id: "34707",
          name: "Movila",
          state_id: "2957",
        },
        {
          id: "34708",
          name: "Movilita",
          state_id: "2957",
        },
        {
          id: "34709",
          name: "Munteni Buzau",
          state_id: "2957",
        },
        {
          id: "34710",
          name: "Perieti",
          state_id: "2957",
        },
        {
          id: "34711",
          name: "Reviga",
          state_id: "2957",
        },
        {
          id: "34712",
          name: "Salcioara",
          state_id: "2957",
        },
        {
          id: "34713",
          name: "Saveni",
          state_id: "2957",
        },
        {
          id: "34714",
          name: "Scanteia",
          state_id: "2957",
        },
        {
          id: "34715",
          name: "Sfantu Gheorghe",
          state_id: "2957",
        },
        {
          id: "34716",
          name: "Sinesti",
          state_id: "2957",
        },
        {
          id: "34717",
          name: "Slobozia",
          state_id: "2957",
        },
        {
          id: "34718",
          name: "Stelnica",
          state_id: "2957",
        },
        {
          id: "34719",
          name: "Suditi",
          state_id: "2957",
        },
        {
          id: "34720",
          name: "Tandarei",
          state_id: "2957",
        },
        {
          id: "34721",
          name: "Urziceni",
          state_id: "2957",
        },
        {
          id: "34722",
          name: "Valea Ciorii",
          state_id: "2957",
        },
        {
          id: "34723",
          name: "Valea Macrisului",
          state_id: "2957",
        },
        {
          id: "34724",
          name: "Vladeni",
          state_id: "2957",
        },
      ],
      Iasi: [
        {
          id: "34725",
          name: "Alexandru Ioan Cuza",
          state_id: "2958",
        },
        {
          id: "34726",
          name: "Andrieseni",
          state_id: "2958",
        },
        {
          id: "34727",
          name: "Aroneanu",
          state_id: "2958",
        },
        {
          id: "34728",
          name: "Baltati",
          state_id: "2958",
        },
        {
          id: "34729",
          name: "Barnova",
          state_id: "2958",
        },
        {
          id: "34730",
          name: "Belcesti",
          state_id: "2958",
        },
        {
          id: "34731",
          name: "Bivolari",
          state_id: "2958",
        },
        {
          id: "34732",
          name: "Braesti",
          state_id: "2958",
        },
        {
          id: "34733",
          name: "Butea",
          state_id: "2958",
        },
        {
          id: "34734",
          name: "Ceplenita",
          state_id: "2958",
        },
        {
          id: "34735",
          name: "Ciortesti",
          state_id: "2958",
        },
        {
          id: "34736",
          name: "Ciurea",
          state_id: "2958",
        },
        {
          id: "34737",
          name: "Coarnele Caprei",
          state_id: "2958",
        },
        {
          id: "34738",
          name: "Comarna",
          state_id: "2958",
        },
        {
          id: "34739",
          name: "Costuleni",
          state_id: "2958",
        },
        {
          id: "34740",
          name: "Cotnari",
          state_id: "2958",
        },
        {
          id: "34741",
          name: "Cozmesti",
          state_id: "2958",
        },
        {
          id: "34742",
          name: "Cristesti",
          state_id: "2958",
        },
        {
          id: "34743",
          name: "Cucuteni",
          state_id: "2958",
        },
        {
          id: "34744",
          name: "Dagata",
          state_id: "2958",
        },
        {
          id: "34745",
          name: "Deleni",
          state_id: "2958",
        },
        {
          id: "34746",
          name: "Dobrovat",
          state_id: "2958",
        },
        {
          id: "34747",
          name: "Dolhesti",
          state_id: "2958",
        },
        {
          id: "34748",
          name: "Dumesti",
          state_id: "2958",
        },
        {
          id: "34749",
          name: "Erbiceni",
          state_id: "2958",
        },
        {
          id: "34750",
          name: "Focuri",
          state_id: "2958",
        },
        {
          id: "34751",
          name: "Golaesti",
          state_id: "2958",
        },
        {
          id: "34752",
          name: "Gorban",
          state_id: "2958",
        },
        {
          id: "34753",
          name: "Grajduri",
          state_id: "2958",
        },
        {
          id: "34754",
          name: "Gropnita",
          state_id: "2958",
        },
        {
          id: "34755",
          name: "Grozesti",
          state_id: "2958",
        },
        {
          id: "34756",
          name: "Halaucesti",
          state_id: "2958",
        },
        {
          id: "34757",
          name: "Harlau",
          state_id: "2958",
        },
        {
          id: "34758",
          name: "Helesteni Harmaneasa",
          state_id: "2958",
        },
        {
          id: "34759",
          name: "Holboca",
          state_id: "2958",
        },
        {
          id: "34760",
          name: "Horlesti",
          state_id: "2958",
        },
        {
          id: "34761",
          name: "Iasi",
          state_id: "2958",
        },
        {
          id: "34762",
          name: "Ipatele",
          state_id: "2958",
        },
        {
          id: "34763",
          name: "Lespezi",
          state_id: "2958",
        },
        {
          id: "34764",
          name: "Letcani",
          state_id: "2958",
        },
        {
          id: "34765",
          name: "Lungani",
          state_id: "2958",
        },
        {
          id: "34766",
          name: "Madarjac",
          state_id: "2958",
        },
        {
          id: "34767",
          name: "Mircesti",
          state_id: "2958",
        },
        {
          id: "34768",
          name: "Mironeasa",
          state_id: "2958",
        },
        {
          id: "34769",
          name: "Miroslava",
          state_id: "2958",
        },
        {
          id: "34770",
          name: "Miroslovesti",
          state_id: "2958",
        },
        {
          id: "34771",
          name: "Mogosesti",
          state_id: "2958",
        },
        {
          id: "34772",
          name: "Mogosesti-Siret",
          state_id: "2958",
        },
        {
          id: "34773",
          name: "Mosna",
          state_id: "2958",
        },
        {
          id: "34774",
          name: "Motca",
          state_id: "2958",
        },
        {
          id: "34775",
          name: "Movileni",
          state_id: "2958",
        },
        {
          id: "34776",
          name: "Oteleni",
          state_id: "2958",
        },
        {
          id: "34777",
          name: "Pascani",
          state_id: "2958",
        },
        {
          id: "34778",
          name: "Plugari",
          state_id: "2958",
        },
        {
          id: "34779",
          name: "Podu Iloaiei",
          state_id: "2958",
        },
        {
          id: "34780",
          name: "Popesti",
          state_id: "2958",
        },
        {
          id: "34781",
          name: "Popricani",
          state_id: "2958",
        },
        {
          id: "34782",
          name: "Prisacani",
          state_id: "2958",
        },
        {
          id: "34783",
          name: "Probota",
          state_id: "2958",
        },
        {
          id: "34784",
          name: "Raducaneni",
          state_id: "2958",
        },
        {
          id: "34785",
          name: "Rediu",
          state_id: "2958",
        },
        {
          id: "34786",
          name: "Romanesti",
          state_id: "2958",
        },
        {
          id: "34787",
          name: "Ruginoasa",
          state_id: "2958",
        },
        {
          id: "34788",
          name: "Scanteia",
          state_id: "2958",
        },
        {
          id: "34789",
          name: "Scheia",
          state_id: "2958",
        },
        {
          id: "34790",
          name: "Schitu-Duca",
          state_id: "2958",
        },
        {
          id: "34791",
          name: "Scobinti",
          state_id: "2958",
        },
        {
          id: "34792",
          name: "Sinesti",
          state_id: "2958",
        },
        {
          id: "34793",
          name: "Sipote",
          state_id: "2958",
        },
        {
          id: "34794",
          name: "Siretel",
          state_id: "2958",
        },
        {
          id: "34795",
          name: "Stolniceni-Prajescu",
          state_id: "2958",
        },
        {
          id: "34796",
          name: "Strunga",
          state_id: "2958",
        },
        {
          id: "34797",
          name: "Tansa",
          state_id: "2958",
        },
        {
          id: "34798",
          name: "Targu Gangiulesti",
          state_id: "2958",
        },
        {
          id: "34799",
          name: "Tatarusi",
          state_id: "2958",
        },
        {
          id: "34800",
          name: "Tibana",
          state_id: "2958",
        },
        {
          id: "34801",
          name: "Tibanesti",
          state_id: "2958",
        },
        {
          id: "34802",
          name: "Tiganasi",
          state_id: "2958",
        },
        {
          id: "34803",
          name: "Todiresti",
          state_id: "2958",
        },
        {
          id: "34804",
          name: "Tomesti",
          state_id: "2958",
        },
        {
          id: "34805",
          name: "Trifesti",
          state_id: "2958",
        },
        {
          id: "34806",
          name: "Tutora",
          state_id: "2958",
        },
        {
          id: "34807",
          name: "Ungheni",
          state_id: "2958",
        },
        {
          id: "34808",
          name: "Valea Seaca",
          state_id: "2958",
        },
        {
          id: "34809",
          name: "Vanatori",
          state_id: "2958",
        },
        {
          id: "34810",
          name: "Victoria",
          state_id: "2958",
        },
        {
          id: "34811",
          name: "Vladeni",
          state_id: "2958",
        },
        {
          id: "34812",
          name: "Voinesti",
          state_id: "2958",
        },
      ],
      Ilfov: [
        {
          id: "34813",
          name: "Afumati",
          state_id: "2959",
        },
        {
          id: "34814",
          name: "Balotesti",
          state_id: "2959",
        },
        {
          id: "34815",
          name: "Berceni",
          state_id: "2959",
        },
        {
          id: "34816",
          name: "Bragadiru",
          state_id: "2959",
        },
        {
          id: "34817",
          name: "Branesti",
          state_id: "2959",
        },
        {
          id: "34818",
          name: "Buftea",
          state_id: "2959",
        },
        {
          id: "34819",
          name: "Cernica",
          state_id: "2959",
        },
        {
          id: "34820",
          name: "Chiajna",
          state_id: "2959",
        },
        {
          id: "34821",
          name: "Chitila",
          state_id: "2959",
        },
        {
          id: "34822",
          name: "Ciolpani",
          state_id: "2959",
        },
        {
          id: "34823",
          name: "Ciorogarla",
          state_id: "2959",
        },
        {
          id: "34824",
          name: "Clinceni",
          state_id: "2959",
        },
        {
          id: "34825",
          name: "Corbeanca",
          state_id: "2959",
        },
        {
          id: "34826",
          name: "Cornetu",
          state_id: "2959",
        },
        {
          id: "34827",
          name: "Darasti-Ilfov",
          state_id: "2959",
        },
        {
          id: "34828",
          name: "Dascalu",
          state_id: "2959",
        },
        {
          id: "34829",
          name: "Dobroesti",
          state_id: "2959",
        },
        {
          id: "34830",
          name: "Domnesti",
          state_id: "2959",
        },
        {
          id: "34831",
          name: "Dragomiresti-Vale",
          state_id: "2959",
        },
        {
          id: "34832",
          name: "Ganeasa",
          state_id: "2959",
        },
        {
          id: "34833",
          name: "Glina",
          state_id: "2959",
        },
        {
          id: "34834",
          name: "Gradistea",
          state_id: "2959",
        },
        {
          id: "34835",
          name: "Gruiu",
          state_id: "2959",
        },
        {
          id: "34836",
          name: "Jilava",
          state_id: "2959",
        },
        {
          id: "34837",
          name: "Magurele",
          state_id: "2959",
        },
        {
          id: "34838",
          name: "Moara Vlasiei",
          state_id: "2959",
        },
        {
          id: "34839",
          name: "Mogosoaia",
          state_id: "2959",
        },
        {
          id: "34840",
          name: "Nuci",
          state_id: "2959",
        },
        {
          id: "34841",
          name: "Otopeni",
          state_id: "2959",
        },
        {
          id: "34842",
          name: "Pantelimon",
          state_id: "2959",
        },
        {
          id: "34843",
          name: "Peris",
          state_id: "2959",
        },
        {
          id: "34844",
          name: "Petrachioaia",
          state_id: "2959",
        },
        {
          id: "34845",
          name: "Popesti-Leordeni",
          state_id: "2959",
        },
        {
          id: "34846",
          name: "Prim Decembrie",
          state_id: "2959",
        },
        {
          id: "34847",
          name: "Snagov",
          state_id: "2959",
        },
        {
          id: "34848",
          name: "Stefanestii de Jos",
          state_id: "2959",
        },
        {
          id: "34849",
          name: "Tunari",
          state_id: "2959",
        },
        {
          id: "34850",
          name: "Vidra",
          state_id: "2959",
        },
        {
          id: "34851",
          name: "Voluntari",
          state_id: "2959",
        },
      ],
      Maramures: [
        {
          id: "34852",
          name: "Ardusat",
          state_id: "2960",
        },
        {
          id: "34853",
          name: "Arinis",
          state_id: "2960",
        },
        {
          id: "34854",
          name: "Asuaju de Sus",
          state_id: "2960",
        },
        {
          id: "34855",
          name: "Baia Mare",
          state_id: "2960",
        },
        {
          id: "34856",
          name: "Baia-Sprie",
          state_id: "2960",
        },
        {
          id: "34857",
          name: "Baita de sub Codru",
          state_id: "2960",
        },
        {
          id: "34858",
          name: "Baiut",
          state_id: "2960",
        },
        {
          id: "34859",
          name: "Barsana",
          state_id: "2960",
        },
        {
          id: "34860",
          name: "Basesti",
          state_id: "2960",
        },
        {
          id: "34861",
          name: "Bicaz",
          state_id: "2960",
        },
        {
          id: "34862",
          name: "Bistra",
          state_id: "2960",
        },
        {
          id: "34863",
          name: "Bocicoiu Mare",
          state_id: "2960",
        },
        {
          id: "34864",
          name: "Bogdan Voda",
          state_id: "2960",
        },
        {
          id: "34865",
          name: "Boiu Mare",
          state_id: "2960",
        },
        {
          id: "34866",
          name: "Borsa",
          state_id: "2960",
        },
        {
          id: "34867",
          name: "Botiza",
          state_id: "2960",
        },
        {
          id: "34868",
          name: "Budesti",
          state_id: "2960",
        },
        {
          id: "34869",
          name: "Calinesti",
          state_id: "2960",
        },
        {
          id: "34870",
          name: "Campulung la Tisa",
          state_id: "2960",
        },
        {
          id: "34871",
          name: "Cavnic",
          state_id: "2960",
        },
        {
          id: "34872",
          name: "Cernesti",
          state_id: "2960",
        },
        {
          id: "34873",
          name: "Cicarlau",
          state_id: "2960",
        },
        {
          id: "34874",
          name: "Copalnic Manastur",
          state_id: "2960",
        },
        {
          id: "34875",
          name: "Coroieni",
          state_id: "2960",
        },
        {
          id: "34876",
          name: "Cupseni",
          state_id: "2960",
        },
        {
          id: "34877",
          name: "Desesti",
          state_id: "2960",
        },
        {
          id: "34878",
          name: "Dragomiresti",
          state_id: "2960",
        },
        {
          id: "34879",
          name: "Dumbravita",
          state_id: "2960",
        },
        {
          id: "34880",
          name: "Farcasa",
          state_id: "2960",
        },
        {
          id: "34881",
          name: "Giulesti",
          state_id: "2960",
        },
        {
          id: "34882",
          name: "Grosi",
          state_id: "2960",
        },
        {
          id: "34883",
          name: "Ieud",
          state_id: "2960",
        },
        {
          id: "34884",
          name: "Lapus",
          state_id: "2960",
        },
        {
          id: "34885",
          name: "Leordina",
          state_id: "2960",
        },
        {
          id: "34886",
          name: "Miresu Mare",
          state_id: "2960",
        },
        {
          id: "34887",
          name: "Moisei",
          state_id: "2960",
        },
        {
          id: "34888",
          name: "Oarta de Jos",
          state_id: "2960",
        },
        {
          id: "34889",
          name: "Ocna Sugatag",
          state_id: "2960",
        },
        {
          id: "34890",
          name: "Petrova",
          state_id: "2960",
        },
        {
          id: "34891",
          name: "Poienile Izei",
          state_id: "2960",
        },
        {
          id: "34892",
          name: "Poienile de sub Munte",
          state_id: "2960",
        },
        {
          id: "34893",
          name: "Recea",
          state_id: "2960",
        },
        {
          id: "34894",
          name: "Remetea Chioarului",
          state_id: "2960",
        },
        {
          id: "34895",
          name: "Remeti",
          state_id: "2960",
        },
        {
          id: "34896",
          name: "Repedea",
          state_id: "2960",
        },
        {
          id: "34897",
          name: "Rona de Jos",
          state_id: "2960",
        },
        {
          id: "34898",
          name: "Rona de Sus",
          state_id: "2960",
        },
        {
          id: "34899",
          name: "Rozavlea",
          state_id: "2960",
        },
        {
          id: "34900",
          name: "Ruscova",
          state_id: "2960",
        },
        {
          id: "34901",
          name: "Sacalaseni",
          state_id: "2960",
        },
        {
          id: "34902",
          name: "Sacel",
          state_id: "2960",
        },
        {
          id: "34903",
          name: "Salistea de Sus",
          state_id: "2960",
        },
        {
          id: "34904",
          name: "Salsig",
          state_id: "2960",
        },
        {
          id: "34905",
          name: "Sapanta",
          state_id: "2960",
        },
        {
          id: "34906",
          name: "Sarasau",
          state_id: "2960",
        },
        {
          id: "34907",
          name: "Sasar",
          state_id: "2960",
        },
        {
          id: "34908",
          name: "Satulung",
          state_id: "2960",
        },
        {
          id: "34909",
          name: "Seini",
          state_id: "2960",
        },
        {
          id: "34910",
          name: "Sighetu Marmatiei",
          state_id: "2960",
        },
        {
          id: "34911",
          name: "Sisesti",
          state_id: "2960",
        },
        {
          id: "34912",
          name: "Somcuta Mare",
          state_id: "2960",
        },
        {
          id: "34913",
          name: "Stramtura",
          state_id: "2960",
        },
        {
          id: "34914",
          name: "Suciu de Sus",
          state_id: "2960",
        },
        {
          id: "34915",
          name: "Targu-Lapus",
          state_id: "2960",
        },
        {
          id: "34916",
          name: "Tautii Margheraus",
          state_id: "2960",
        },
        {
          id: "34917",
          name: "Ulmeni",
          state_id: "2960",
        },
        {
          id: "34918",
          name: "Vadu Izei",
          state_id: "2960",
        },
        {
          id: "34919",
          name: "Valea Chioarului",
          state_id: "2960",
        },
        {
          id: "34920",
          name: "Vima Mica",
          state_id: "2960",
        },
        {
          id: "34921",
          name: "Viseu de Jos",
          state_id: "2960",
        },
        {
          id: "34922",
          name: "Viseu de Sus",
          state_id: "2960",
        },
      ],
      Mehedinti: [
        {
          id: "34923",
          name: "Baclesu",
          state_id: "2961",
        },
        {
          id: "34924",
          name: "Baia de Arama",
          state_id: "2961",
        },
        {
          id: "34925",
          name: "Bala",
          state_id: "2961",
        },
        {
          id: "34926",
          name: "Balacita",
          state_id: "2961",
        },
        {
          id: "34927",
          name: "Balta",
          state_id: "2961",
        },
        {
          id: "34928",
          name: "Balvanesti",
          state_id: "2961",
        },
        {
          id: "34929",
          name: "Breznita Ocol",
          state_id: "2961",
        },
        {
          id: "34930",
          name: "Breznita-Motru",
          state_id: "2961",
        },
        {
          id: "34931",
          name: "Brosteni",
          state_id: "2961",
        },
        {
          id: "34932",
          name: "Burila Mare",
          state_id: "2961",
        },
        {
          id: "34933",
          name: "Butoiesti",
          state_id: "2961",
        },
        {
          id: "34934",
          name: "Cazanesti",
          state_id: "2961",
        },
        {
          id: "34935",
          name: "Ciresu",
          state_id: "2961",
        },
        {
          id: "34936",
          name: "Corcova",
          state_id: "2961",
        },
        {
          id: "34937",
          name: "Corlatel",
          state_id: "2961",
        },
        {
          id: "34938",
          name: "Cujmir",
          state_id: "2961",
        },
        {
          id: "34939",
          name: "Darvari",
          state_id: "2961",
        },
        {
          id: "34940",
          name: "Devesel",
          state_id: "2961",
        },
        {
          id: "34941",
          name: "Drobeta-Turnu Severin",
          state_id: "2961",
        },
        {
          id: "34942",
          name: "Dubova",
          state_id: "2961",
        },
        {
          id: "34943",
          name: "Dumbrava",
          state_id: "2961",
        },
        {
          id: "34944",
          name: "Eselnita",
          state_id: "2961",
        },
        {
          id: "34945",
          name: "Floresti",
          state_id: "2961",
        },
        {
          id: "34946",
          name: "Garla Mare",
          state_id: "2961",
        },
        {
          id: "34947",
          name: "Godeanu",
          state_id: "2961",
        },
        {
          id: "34948",
          name: "Gogosu",
          state_id: "2961",
        },
        {
          id: "34949",
          name: "Greci",
          state_id: "2961",
        },
        {
          id: "34950",
          name: "Grozesti",
          state_id: "2961",
        },
        {
          id: "34951",
          name: "Gruia",
          state_id: "2961",
        },
        {
          id: "34952",
          name: "Hinova",
          state_id: "2961",
        },
        {
          id: "34953",
          name: "Husnicioara",
          state_id: "2961",
        },
        {
          id: "34954",
          name: "Ilovat",
          state_id: "2961",
        },
        {
          id: "34955",
          name: "Ilovita",
          state_id: "2961",
        },
        {
          id: "34956",
          name: "Isverna",
          state_id: "2961",
        },
        {
          id: "34957",
          name: "Izvoru Barzii",
          state_id: "2961",
        },
        {
          id: "34958",
          name: "Jiana",
          state_id: "2961",
        },
        {
          id: "34959",
          name: "Livezile",
          state_id: "2961",
        },
        {
          id: "34960",
          name: "Malovat",
          state_id: "2961",
        },
        {
          id: "34961",
          name: "Obarsia Noua",
          state_id: "2961",
        },
        {
          id: "34962",
          name: "Obarsia-Closani",
          state_id: "2961",
        },
        {
          id: "34963",
          name: "Oprisor",
          state_id: "2961",
        },
        {
          id: "34964",
          name: "Orsova",
          state_id: "2961",
        },
        {
          id: "34965",
          name: "Padina",
          state_id: "2961",
        },
        {
          id: "34966",
          name: "Patulele",
          state_id: "2961",
        },
        {
          id: "34967",
          name: "Podeni",
          state_id: "2961",
        },
        {
          id: "34968",
          name: "Ponoarele",
          state_id: "2961",
        },
        {
          id: "34969",
          name: "Poroina Mare",
          state_id: "2961",
        },
        {
          id: "34970",
          name: "Pristol",
          state_id: "2961",
        },
        {
          id: "34971",
          name: "Prunisor",
          state_id: "2961",
        },
        {
          id: "34972",
          name: "Punghina",
          state_id: "2961",
        },
        {
          id: "34973",
          name: "Rogova",
          state_id: "2961",
        },
        {
          id: "34974",
          name: "Salcia",
          state_id: "2961",
        },
        {
          id: "34975",
          name: "Simian",
          state_id: "2961",
        },
        {
          id: "34976",
          name: "Sisesti",
          state_id: "2961",
        },
        {
          id: "34977",
          name: "Sovarna",
          state_id: "2961",
        },
        {
          id: "34978",
          name: "Stangaceaua",
          state_id: "2961",
        },
        {
          id: "34979",
          name: "Strehaia",
          state_id: "2961",
        },
        {
          id: "34980",
          name: "Svinita",
          state_id: "2961",
        },
        {
          id: "34981",
          name: "Tamna",
          state_id: "2961",
        },
        {
          id: "34982",
          name: "Vanatori",
          state_id: "2961",
        },
        {
          id: "34983",
          name: "Vanju Mare",
          state_id: "2961",
        },
        {
          id: "34984",
          name: "Vanjulet",
          state_id: "2961",
        },
        {
          id: "34985",
          name: "Vladaia",
          state_id: "2961",
        },
        {
          id: "34986",
          name: "Voloiac",
          state_id: "2961",
        },
      ],
      Mures: [
        {
          id: "34987",
          name: "Acatari",
          state_id: "2962",
        },
        {
          id: "34988",
          name: "Adamus",
          state_id: "2962",
        },
        {
          id: "34989",
          name: "Albesti",
          state_id: "2962",
        },
        {
          id: "34990",
          name: "Alunis",
          state_id: "2962",
        },
        {
          id: "34991",
          name: "Apold",
          state_id: "2962",
        },
        {
          id: "34992",
          name: "Atintis",
          state_id: "2962",
        },
        {
          id: "34993",
          name: "Bagaciu",
          state_id: "2962",
        },
        {
          id: "34994",
          name: "Bahnea",
          state_id: "2962",
        },
        {
          id: "34995",
          name: "Bala",
          state_id: "2962",
        },
        {
          id: "34996",
          name: "Balauseri",
          state_id: "2962",
        },
        {
          id: "34997",
          name: "Band",
          state_id: "2962",
        },
        {
          id: "34998",
          name: "Batos",
          state_id: "2962",
        },
        {
          id: "34999",
          name: "Beica de Jos",
          state_id: "2962",
        },
        {
          id: "35000",
          name: "Bichis",
          state_id: "2962",
        },
        {
          id: "35001",
          name: "Bogata",
          state_id: "2962",
        },
        {
          id: "35002",
          name: "Brancovenesti",
          state_id: "2962",
        },
        {
          id: "35003",
          name: "Breaza",
          state_id: "2962",
        },
        {
          id: "35004",
          name: "Ceuasul-de Campie",
          state_id: "2962",
        },
        {
          id: "35005",
          name: "Chetani",
          state_id: "2962",
        },
        {
          id: "35006",
          name: "Chiheru de Jos",
          state_id: "2962",
        },
        {
          id: "35007",
          name: "Coroisanmartin",
          state_id: "2962",
        },
        {
          id: "35008",
          name: "Cozma",
          state_id: "2962",
        },
        {
          id: "35009",
          name: "Craciunesti",
          state_id: "2962",
        },
        {
          id: "35010",
          name: "Craiesti",
          state_id: "2962",
        },
        {
          id: "35011",
          name: "Cristesti",
          state_id: "2962",
        },
        {
          id: "35012",
          name: "Cucerdea",
          state_id: "2962",
        },
        {
          id: "35013",
          name: "Cuci",
          state_id: "2962",
        },
        {
          id: "35014",
          name: "Danes",
          state_id: "2962",
        },
        {
          id: "35015",
          name: "Deda",
          state_id: "2962",
        },
        {
          id: "35016",
          name: "Eremitu",
          state_id: "2962",
        },
        {
          id: "35017",
          name: "Ernei",
          state_id: "2962",
        },
        {
          id: "35018",
          name: "Fantanele",
          state_id: "2962",
        },
        {
          id: "35019",
          name: "Faragau",
          state_id: "2962",
        },
        {
          id: "35020",
          name: "Galesti",
          state_id: "2962",
        },
        {
          id: "35021",
          name: "Ganesti",
          state_id: "2962",
        },
        {
          id: "35022",
          name: "Gheorghe Doja",
          state_id: "2962",
        },
        {
          id: "35023",
          name: "Ghindari",
          state_id: "2962",
        },
        {
          id: "35024",
          name: "Glodeni",
          state_id: "2962",
        },
        {
          id: "35025",
          name: "Gornesti",
          state_id: "2962",
        },
        {
          id: "35026",
          name: "Grebenisu de Campie",
          state_id: "2962",
        },
        {
          id: "35027",
          name: "Gurghiu",
          state_id: "2962",
        },
        {
          id: "35028",
          name: "Hodac",
          state_id: "2962",
        },
        {
          id: "35029",
          name: "Hodosa",
          state_id: "2962",
        },
        {
          id: "35030",
          name: "Ibanesti",
          state_id: "2962",
        },
        {
          id: "35031",
          name: "Iclanzel",
          state_id: "2962",
        },
        {
          id: "35032",
          name: "Ideciu de Jos",
          state_id: "2962",
        },
        {
          id: "35033",
          name: "Iernut",
          state_id: "2962",
        },
        {
          id: "35034",
          name: "Livezeni",
          state_id: "2962",
        },
        {
          id: "35035",
          name: "Ludus",
          state_id: "2962",
        },
        {
          id: "35036",
          name: "Lunca",
          state_id: "2962",
        },
        {
          id: "35037",
          name: "Lunca Bradului",
          state_id: "2962",
        },
        {
          id: "35038",
          name: "Magherani",
          state_id: "2962",
        },
        {
          id: "35039",
          name: "Mica",
          state_id: "2962",
        },
        {
          id: "35040",
          name: "Miercurea Nirajului",
          state_id: "2962",
        },
        {
          id: "35041",
          name: "Mihesu de Campie",
          state_id: "2962",
        },
        {
          id: "35042",
          name: "Nades",
          state_id: "2962",
        },
        {
          id: "35043",
          name: "Neaua",
          state_id: "2962",
        },
        {
          id: "35044",
          name: "Ogra",
          state_id: "2962",
        },
        {
          id: "35045",
          name: "Panet",
          state_id: "2962",
        },
        {
          id: "35046",
          name: "Papiu Ilarian",
          state_id: "2962",
        },
        {
          id: "35047",
          name: "Pasareni",
          state_id: "2962",
        },
        {
          id: "35048",
          name: "Petelea",
          state_id: "2962",
        },
        {
          id: "35049",
          name: "Pogaceaua",
          state_id: "2962",
        },
        {
          id: "35050",
          name: "Raciu",
          state_id: "2962",
        },
        {
          id: "35051",
          name: "Rastolita",
          state_id: "2962",
        },
        {
          id: "35052",
          name: "Reghin",
          state_id: "2962",
        },
        {
          id: "35053",
          name: "Rusii Munti",
          state_id: "2962",
        },
        {
          id: "35054",
          name: "Sancraiul-de-Mures",
          state_id: "2962",
        },
        {
          id: "35055",
          name: "Sangeorg-de Mures",
          state_id: "2962",
        },
        {
          id: "35056",
          name: "Sangeorgiu-de-Padure",
          state_id: "2962",
        },
        {
          id: "35057",
          name: "Sanger",
          state_id: "2962",
        },
        {
          id: "35058",
          name: "Sanpaul",
          state_id: "2962",
        },
        {
          id: "35059",
          name: "Sanpetru-de-Campie",
          state_id: "2962",
        },
        {
          id: "35060",
          name: "Santana-de-Mures",
          state_id: "2962",
        },
        {
          id: "35061",
          name: "Sarmasu",
          state_id: "2962",
        },
        {
          id: "35062",
          name: "Saschiz",
          state_id: "2962",
        },
        {
          id: "35063",
          name: "Saulia",
          state_id: "2962",
        },
        {
          id: "35064",
          name: "Sighisoara",
          state_id: "2962",
        },
        {
          id: "35065",
          name: "Sincai",
          state_id: "2962",
        },
        {
          id: "35066",
          name: "Solovastru",
          state_id: "2962",
        },
        {
          id: "35067",
          name: "Sovata",
          state_id: "2962",
        },
        {
          id: "35068",
          name: "Stanceni",
          state_id: "2962",
        },
        {
          id: "35069",
          name: "Suplac",
          state_id: "2962",
        },
        {
          id: "35070",
          name: "Suseni",
          state_id: "2962",
        },
        {
          id: "35071",
          name: "Targu-Mures",
          state_id: "2962",
        },
        {
          id: "35072",
          name: "Tarnaveni",
          state_id: "2962",
        },
        {
          id: "35073",
          name: "Taureni",
          state_id: "2962",
        },
        {
          id: "35074",
          name: "Ungheni",
          state_id: "2962",
        },
        {
          id: "35075",
          name: "Valea Larga",
          state_id: "2962",
        },
        {
          id: "35076",
          name: "Vanatori",
          state_id: "2962",
        },
        {
          id: "35077",
          name: "Vargata",
          state_id: "2962",
        },
        {
          id: "35078",
          name: "Vatava",
          state_id: "2962",
        },
        {
          id: "35079",
          name: "Vetca",
          state_id: "2962",
        },
        {
          id: "35080",
          name: "Viisoara",
          state_id: "2962",
        },
        {
          id: "35081",
          name: "Voivodeni",
          state_id: "2962",
        },
        {
          id: "35082",
          name: "Zagar",
          state_id: "2962",
        },
        {
          id: "35083",
          name: "Zau de Campie",
          state_id: "2962",
        },
      ],
      Neamt: [
        {
          id: "35084",
          name: "Agapia",
          state_id: "2963",
        },
        {
          id: "35085",
          name: "Bahna",
          state_id: "2963",
        },
        {
          id: "35086",
          name: "Baltatesti",
          state_id: "2963",
        },
        {
          id: "35087",
          name: "Bara",
          state_id: "2963",
        },
        {
          id: "35088",
          name: "Bargaoani",
          state_id: "2963",
        },
        {
          id: "35089",
          name: "Bicaz",
          state_id: "2963",
        },
        {
          id: "35090",
          name: "Bicaz Chei",
          state_id: "2963",
        },
        {
          id: "35091",
          name: "Bicazu Ardelean",
          state_id: "2963",
        },
        {
          id: "35092",
          name: "Bodesti",
          state_id: "2963",
        },
        {
          id: "35093",
          name: "Borca",
          state_id: "2963",
        },
        {
          id: "35094",
          name: "Borlesti",
          state_id: "2963",
        },
        {
          id: "35095",
          name: "Botesti",
          state_id: "2963",
        },
        {
          id: "35096",
          name: "Bozieni",
          state_id: "2963",
        },
        {
          id: "35097",
          name: "Brusturi-Draganesti",
          state_id: "2963",
        },
        {
          id: "35098",
          name: "Candesti",
          state_id: "2963",
        },
        {
          id: "35099",
          name: "Ceahlau",
          state_id: "2963",
        },
        {
          id: "35100",
          name: "Cordun",
          state_id: "2963",
        },
        {
          id: "35101",
          name: "Costisa",
          state_id: "2963",
        },
        {
          id: "35102",
          name: "Cracaoani",
          state_id: "2963",
        },
        {
          id: "35103",
          name: "Damuc",
          state_id: "2963",
        },
        {
          id: "35104",
          name: "Dobreni",
          state_id: "2963",
        },
        {
          id: "35105",
          name: "Doljesti",
          state_id: "2963",
        },
        {
          id: "35106",
          name: "Dragomiresti",
          state_id: "2963",
        },
        {
          id: "35107",
          name: "Dulcesti",
          state_id: "2963",
        },
        {
          id: "35108",
          name: "Dumbrava Rosie",
          state_id: "2963",
        },
        {
          id: "35109",
          name: "Farcasa",
          state_id: "2963",
        },
        {
          id: "35110",
          name: "Faurei",
          state_id: "2963",
        },
        {
          id: "35111",
          name: "Garcina",
          state_id: "2963",
        },
        {
          id: "35112",
          name: "Gheraesti",
          state_id: "2963",
        },
        {
          id: "35113",
          name: "Girov",
          state_id: "2963",
        },
        {
          id: "35114",
          name: "Grinties",
          state_id: "2963",
        },
        {
          id: "35115",
          name: "Grumazesti",
          state_id: "2963",
        },
        {
          id: "35116",
          name: "Hangu",
          state_id: "2963",
        },
        {
          id: "35117",
          name: "Horia",
          state_id: "2963",
        },
        {
          id: "35118",
          name: "Icusesti",
          state_id: "2963",
        },
        {
          id: "35119",
          name: "Ion Creanga",
          state_id: "2963",
        },
        {
          id: "35120",
          name: "Margineni",
          state_id: "2963",
        },
        {
          id: "35121",
          name: "Moldoveni",
          state_id: "2963",
        },
        {
          id: "35122",
          name: "Oniceni",
          state_id: "2963",
        },
        {
          id: "35123",
          name: "Pangarati",
          state_id: "2963",
        },
        {
          id: "35124",
          name: "Pastraveni",
          state_id: "2963",
        },
        {
          id: "35125",
          name: "Petricani",
          state_id: "2963",
        },
        {
          id: "35126",
          name: "Piatra Neamt",
          state_id: "2963",
        },
        {
          id: "35127",
          name: "Piatra Soimului",
          state_id: "2963",
        },
        {
          id: "35128",
          name: "Pipirig",
          state_id: "2963",
        },
        {
          id: "35129",
          name: "Podoleni",
          state_id: "2963",
        },
        {
          id: "35130",
          name: "Poiana Teiului",
          state_id: "2963",
        },
        {
          id: "35131",
          name: "Poienari",
          state_id: "2963",
        },
        {
          id: "35132",
          name: "Raucesti",
          state_id: "2963",
        },
        {
          id: "35133",
          name: "Razboieni",
          state_id: "2963",
        },
        {
          id: "35134",
          name: "Rediu",
          state_id: "2963",
        },
        {
          id: "35135",
          name: "Roman",
          state_id: "2963",
        },
        {
          id: "35136",
          name: "Romani",
          state_id: "2963",
        },
        {
          id: "35137",
          name: "Roznov",
          state_id: "2963",
        },
        {
          id: "35138",
          name: "Sabaoani",
          state_id: "2963",
        },
        {
          id: "35139",
          name: "Sagna",
          state_id: "2963",
        },
        {
          id: "35140",
          name: "Savinesti",
          state_id: "2963",
        },
        {
          id: "35141",
          name: "Secuieni",
          state_id: "2963",
        },
        {
          id: "35142",
          name: "Stanita",
          state_id: "2963",
        },
        {
          id: "35143",
          name: "Stefan cel Mare",
          state_id: "2963",
        },
        {
          id: "35144",
          name: "Tamaseni",
          state_id: "2963",
        },
        {
          id: "35145",
          name: "Tarcau",
          state_id: "2963",
        },
        {
          id: "35146",
          name: "Targu-Neamt",
          state_id: "2963",
        },
        {
          id: "35147",
          name: "Tasca",
          state_id: "2963",
        },
        {
          id: "35148",
          name: "Tazlau",
          state_id: "2963",
        },
        {
          id: "35149",
          name: "Tibucani",
          state_id: "2963",
        },
        {
          id: "35150",
          name: "Timisesti",
          state_id: "2963",
        },
        {
          id: "35151",
          name: "Trifesti",
          state_id: "2963",
        },
        {
          id: "35152",
          name: "Tupilati",
          state_id: "2963",
        },
        {
          id: "35153",
          name: "Urecheni",
          state_id: "2963",
        },
        {
          id: "35154",
          name: "Valea Ursului",
          state_id: "2963",
        },
        {
          id: "35155",
          name: "Vanatori-Neamt",
          state_id: "2963",
        },
        {
          id: "35156",
          name: "Viisoara",
          state_id: "2963",
        },
        {
          id: "35157",
          name: "Zanesti",
          state_id: "2963",
        },
      ],
      Olt: [
        {
          id: "35158",
          name: "Babiciu",
          state_id: "2964",
        },
        {
          id: "35159",
          name: "Baldovinesti",
          state_id: "2964",
        },
        {
          id: "35160",
          name: "Bals",
          state_id: "2964",
        },
        {
          id: "35161",
          name: "Barasti",
          state_id: "2964",
        },
        {
          id: "35162",
          name: "Barza",
          state_id: "2964",
        },
        {
          id: "35163",
          name: "Bobicesti",
          state_id: "2964",
        },
        {
          id: "35164",
          name: "Brancoveni",
          state_id: "2964",
        },
        {
          id: "35165",
          name: "Brastavatu",
          state_id: "2964",
        },
        {
          id: "35166",
          name: "Brebeni",
          state_id: "2964",
        },
        {
          id: "35167",
          name: "Bucinisu",
          state_id: "2964",
        },
        {
          id: "35168",
          name: "Caracal",
          state_id: "2964",
        },
        {
          id: "35169",
          name: "Carlogani",
          state_id: "2964",
        },
        {
          id: "35170",
          name: "Cezieni",
          state_id: "2964",
        },
        {
          id: "35171",
          name: "Cilieni",
          state_id: "2964",
        },
        {
          id: "35172",
          name: "Colonesti",
          state_id: "2964",
        },
        {
          id: "35173",
          name: "Corabia",
          state_id: "2964",
        },
        {
          id: "35174",
          name: "Corbu",
          state_id: "2964",
        },
        {
          id: "35175",
          name: "Coteana",
          state_id: "2964",
        },
        {
          id: "35176",
          name: "Crampoaia",
          state_id: "2964",
        },
        {
          id: "35177",
          name: "Cungrea",
          state_id: "2964",
        },
        {
          id: "35178",
          name: "Curtisoara",
          state_id: "2964",
        },
        {
          id: "35179",
          name: "Daneasa",
          state_id: "2964",
        },
        {
          id: "35180",
          name: "Deveselu",
          state_id: "2964",
        },
        {
          id: "35181",
          name: "Dobretu",
          state_id: "2964",
        },
        {
          id: "35182",
          name: "Dobrosloveni",
          state_id: "2964",
        },
        {
          id: "35183",
          name: "Dobroteasa",
          state_id: "2964",
        },
        {
          id: "35184",
          name: "Dobrun",
          state_id: "2964",
        },
        {
          id: "35185",
          name: "Draganesti-Olt",
          state_id: "2964",
        },
        {
          id: "35186",
          name: "Draghiceni",
          state_id: "2964",
        },
        {
          id: "35187",
          name: "Fagetelu",
          state_id: "2964",
        },
        {
          id: "35188",
          name: "Falcoiu",
          state_id: "2964",
        },
        {
          id: "35189",
          name: "Farcasele",
          state_id: "2964",
        },
        {
          id: "35190",
          name: "Ganeasa",
          state_id: "2964",
        },
        {
          id: "35191",
          name: "Garcovu",
          state_id: "2964",
        },
        {
          id: "35192",
          name: "Giuvarasti",
          state_id: "2964",
        },
        {
          id: "35193",
          name: "Gostavatu",
          state_id: "2964",
        },
        {
          id: "35194",
          name: "Gradinari",
          state_id: "2964",
        },
        {
          id: "35195",
          name: "Grojdibodu",
          state_id: "2964",
        },
        {
          id: "35196",
          name: "Ianca",
          state_id: "2964",
        },
        {
          id: "35197",
          name: "Iancu Jianu",
          state_id: "2964",
        },
        {
          id: "35198",
          name: "Icoana",
          state_id: "2964",
        },
        {
          id: "35199",
          name: "Izbiceni",
          state_id: "2964",
        },
        {
          id: "35200",
          name: "Izvoarele",
          state_id: "2964",
        },
        {
          id: "35201",
          name: "Leleasca",
          state_id: "2964",
        },
        {
          id: "35202",
          name: "Maruntei",
          state_id: "2964",
        },
        {
          id: "35203",
          name: "Mihaesti",
          state_id: "2964",
        },
        {
          id: "35204",
          name: "Milcov",
          state_id: "2964",
        },
        {
          id: "35205",
          name: "Morunglav",
          state_id: "2964",
        },
        {
          id: "35206",
          name: "Movileni",
          state_id: "2964",
        },
        {
          id: "35207",
          name: "Nicolae Titulescu",
          state_id: "2964",
        },
        {
          id: "35208",
          name: "Obarsia",
          state_id: "2964",
        },
        {
          id: "35209",
          name: "Oboga",
          state_id: "2964",
        },
        {
          id: "35210",
          name: "Oporelu",
          state_id: "2964",
        },
        {
          id: "35211",
          name: "Optasi",
          state_id: "2964",
        },
        {
          id: "35212",
          name: "Orlea",
          state_id: "2964",
        },
        {
          id: "35213",
          name: "Osica de Sus",
          state_id: "2964",
        },
        {
          id: "35214",
          name: "Parscoveni",
          state_id: "2964",
        },
        {
          id: "35215",
          name: "Perieti",
          state_id: "2964",
        },
        {
          id: "35216",
          name: "Piatra Olt",
          state_id: "2964",
        },
        {
          id: "35217",
          name: "Plesoiu",
          state_id: "2964",
        },
        {
          id: "35218",
          name: "Poboru",
          state_id: "2964",
        },
        {
          id: "35219",
          name: "Potcoava",
          state_id: "2964",
        },
        {
          id: "35220",
          name: "Priseaca",
          state_id: "2964",
        },
        {
          id: "35221",
          name: "Radomiresti",
          state_id: "2964",
        },
        {
          id: "35222",
          name: "Redea",
          state_id: "2964",
        },
        {
          id: "35223",
          name: "Rotunda",
          state_id: "2964",
        },
        {
          id: "35224",
          name: "Rusanesti",
          state_id: "2964",
        },
        {
          id: "35225",
          name: "Samburesti",
          state_id: "2964",
        },
        {
          id: "35226",
          name: "Scarisoara",
          state_id: "2964",
        },
        {
          id: "35227",
          name: "Schitu",
          state_id: "2964",
        },
        {
          id: "35228",
          name: "Scornicesti",
          state_id: "2964",
        },
        {
          id: "35229",
          name: "Seaca",
          state_id: "2964",
        },
        {
          id: "35230",
          name: "Serbanesti",
          state_id: "2964",
        },
        {
          id: "35231",
          name: "Slatina",
          state_id: "2964",
        },
        {
          id: "35232",
          name: "Slatioara",
          state_id: "2964",
        },
        {
          id: "35233",
          name: "Spineni",
          state_id: "2964",
        },
        {
          id: "35234",
          name: "Sprancenata",
          state_id: "2964",
        },
        {
          id: "35235",
          name: "Stefan cel Mare",
          state_id: "2964",
        },
        {
          id: "35236",
          name: "Stoenesti",
          state_id: "2964",
        },
        {
          id: "35237",
          name: "Stoicanesti",
          state_id: "2964",
        },
        {
          id: "35238",
          name: "Strejesti",
          state_id: "2964",
        },
        {
          id: "35239",
          name: "Studina",
          state_id: "2964",
        },
        {
          id: "35240",
          name: "Tatulesti",
          state_id: "2964",
        },
        {
          id: "35241",
          name: "Teslui",
          state_id: "2964",
        },
        {
          id: "35242",
          name: "Tia Mare",
          state_id: "2964",
        },
        {
          id: "35243",
          name: "Topana",
          state_id: "2964",
        },
        {
          id: "35244",
          name: "Traian",
          state_id: "2964",
        },
        {
          id: "35245",
          name: "Tufeni",
          state_id: "2964",
        },
        {
          id: "35246",
          name: "Urzica",
          state_id: "2964",
        },
        {
          id: "35247",
          name: "Vadastra",
          state_id: "2964",
        },
        {
          id: "35248",
          name: "Vadastrita",
          state_id: "2964",
        },
        {
          id: "35249",
          name: "Valcele",
          state_id: "2964",
        },
        {
          id: "35250",
          name: "Valea Mare",
          state_id: "2964",
        },
        {
          id: "35251",
          name: "Valeni",
          state_id: "2964",
        },
        {
          id: "35252",
          name: "Verguleasa",
          state_id: "2964",
        },
        {
          id: "35253",
          name: "Visina",
          state_id: "2964",
        },
        {
          id: "35254",
          name: "Vitomiresti",
          state_id: "2964",
        },
        {
          id: "35255",
          name: "Vladila",
          state_id: "2964",
        },
        {
          id: "35256",
          name: "Voineasa",
          state_id: "2964",
        },
        {
          id: "35257",
          name: "Vulpeni",
          state_id: "2964",
        },
        {
          id: "35258",
          name: "Vulturesti",
          state_id: "2964",
        },
      ],
      Prahova: [
        {
          id: "35259",
          name: "Adunati",
          state_id: "2965",
        },
        {
          id: "35260",
          name: "Albesti-Paleologu",
          state_id: "2965",
        },
        {
          id: "35261",
          name: "Alunis",
          state_id: "2965",
        },
        {
          id: "35262",
          name: "Apostolache",
          state_id: "2965",
        },
        {
          id: "35263",
          name: "Aricestii-Rahtivani",
          state_id: "2965",
        },
        {
          id: "35264",
          name: "Aricestii-Zeletin",
          state_id: "2965",
        },
        {
          id: "35265",
          name: "Azuga",
          state_id: "2965",
        },
        {
          id: "35266",
          name: "Baba Ana",
          state_id: "2965",
        },
        {
          id: "35267",
          name: "Baicoi",
          state_id: "2965",
        },
        {
          id: "35268",
          name: "Balta Doamnei",
          state_id: "2965",
        },
        {
          id: "35269",
          name: "Baltesti",
          state_id: "2965",
        },
        {
          id: "35270",
          name: "Banesti",
          state_id: "2965",
        },
        {
          id: "35271",
          name: "Barcanesti",
          state_id: "2965",
        },
        {
          id: "35272",
          name: "Berceni",
          state_id: "2965",
        },
        {
          id: "35273",
          name: "Bertea",
          state_id: "2965",
        },
        {
          id: "35274",
          name: "Blejoi",
          state_id: "2965",
        },
        {
          id: "35275",
          name: "Boldesti",
          state_id: "2965",
        },
        {
          id: "35276",
          name: "Boldesti-Scaeni",
          state_id: "2965",
        },
        {
          id: "35277",
          name: "Brazi",
          state_id: "2965",
        },
        {
          id: "35278",
          name: "Breaza",
          state_id: "2965",
        },
        {
          id: "35279",
          name: "Brebu",
          state_id: "2965",
        },
        {
          id: "35280",
          name: "Bucov",
          state_id: "2965",
        },
        {
          id: "35281",
          name: "Busteni",
          state_id: "2965",
        },
        {
          id: "35282",
          name: "Calugareni",
          state_id: "2965",
        },
        {
          id: "35283",
          name: "Campina",
          state_id: "2965",
        },
        {
          id: "35284",
          name: "Carbunesti",
          state_id: "2965",
        },
        {
          id: "35285",
          name: "Ceptura",
          state_id: "2965",
        },
        {
          id: "35286",
          name: "Cerasu",
          state_id: "2965",
        },
        {
          id: "35287",
          name: "Chiojdeanca",
          state_id: "2965",
        },
        {
          id: "35288",
          name: "Ciorani",
          state_id: "2965",
        },
        {
          id: "35289",
          name: "Cocorastii-Misli",
          state_id: "2965",
        },
        {
          id: "35290",
          name: "Colceag",
          state_id: "2965",
        },
        {
          id: "35291",
          name: "Comarnic",
          state_id: "2965",
        },
        {
          id: "35292",
          name: "Cornu",
          state_id: "2965",
        },
        {
          id: "35293",
          name: "Cosminele",
          state_id: "2965",
        },
        {
          id: "35294",
          name: "Doftana",
          state_id: "2965",
        },
        {
          id: "35295",
          name: "Draganesti",
          state_id: "2965",
        },
        {
          id: "35296",
          name: "Drajna",
          state_id: "2965",
        },
        {
          id: "35297",
          name: "Dumbrava",
          state_id: "2965",
        },
        {
          id: "35298",
          name: "Dumbravesti",
          state_id: "2965",
        },
        {
          id: "35299",
          name: "Fantanele",
          state_id: "2965",
        },
        {
          id: "35300",
          name: "Filipestii de Padure",
          state_id: "2965",
        },
        {
          id: "35301",
          name: "Filipestii de Targ",
          state_id: "2965",
        },
        {
          id: "35302",
          name: "Floresti",
          state_id: "2965",
        },
        {
          id: "35303",
          name: "Fulga",
          state_id: "2965",
        },
        {
          id: "35304",
          name: "Gherghita",
          state_id: "2965",
        },
        {
          id: "35305",
          name: "Gorgota",
          state_id: "2965",
        },
        {
          id: "35306",
          name: "Gornet",
          state_id: "2965",
        },
        {
          id: "35307",
          name: "Gornet-Cricov",
          state_id: "2965",
        },
        {
          id: "35308",
          name: "Gura Vadului",
          state_id: "2965",
        },
        {
          id: "35309",
          name: "Gura Vitioarei",
          state_id: "2965",
        },
        {
          id: "35310",
          name: "Iordacheanu",
          state_id: "2965",
        },
        {
          id: "35311",
          name: "Izvoarele",
          state_id: "2965",
        },
        {
          id: "35312",
          name: "Jugureni",
          state_id: "2965",
        },
        {
          id: "35313",
          name: "Lapos",
          state_id: "2965",
        },
        {
          id: "35314",
          name: "Lipanesti",
          state_id: "2965",
        },
        {
          id: "35315",
          name: "Magurele",
          state_id: "2965",
        },
        {
          id: "35316",
          name: "Magureni",
          state_id: "2965",
        },
        {
          id: "35317",
          name: "Maneciu",
          state_id: "2965",
        },
        {
          id: "35318",
          name: "Manesti",
          state_id: "2965",
        },
        {
          id: "35319",
          name: "Mizil",
          state_id: "2965",
        },
        {
          id: "35320",
          name: "Pacureti",
          state_id: "2965",
        },
        {
          id: "35321",
          name: "Paulesti",
          state_id: "2965",
        },
        {
          id: "35322",
          name: "Ploiesti",
          state_id: "2965",
        },
        {
          id: "35323",
          name: "Plopeni",
          state_id: "2965",
        },
        {
          id: "35324",
          name: "Plopu",
          state_id: "2965",
        },
        {
          id: "35325",
          name: "Podenii Noi",
          state_id: "2965",
        },
        {
          id: "35326",
          name: "Poenarii-Burchi",
          state_id: "2965",
        },
        {
          id: "35327",
          name: "Poiana Campina",
          state_id: "2965",
        },
        {
          id: "35328",
          name: "Posesti",
          state_id: "2965",
        },
        {
          id: "35329",
          name: "Predeal-Sarari",
          state_id: "2965",
        },
        {
          id: "35330",
          name: "Provita de Jos",
          state_id: "2965",
        },
        {
          id: "35331",
          name: "Provita de Sus",
          state_id: "2965",
        },
        {
          id: "35332",
          name: "Puchenii Mari",
          state_id: "2965",
        },
        {
          id: "35333",
          name: "Rafov",
          state_id: "2965",
        },
        {
          id: "35334",
          name: "Salcia",
          state_id: "2965",
        },
        {
          id: "35335",
          name: "Salciile",
          state_id: "2965",
        },
        {
          id: "35336",
          name: "Sangeru",
          state_id: "2965",
        },
        {
          id: "35337",
          name: "Scorteni",
          state_id: "2965",
        },
        {
          id: "35338",
          name: "Secaria",
          state_id: "2965",
        },
        {
          id: "35339",
          name: "Sinaia",
          state_id: "2965",
        },
        {
          id: "35340",
          name: "Sirna",
          state_id: "2965",
        },
        {
          id: "35341",
          name: "Slanic",
          state_id: "2965",
        },
        {
          id: "35342",
          name: "Soimari",
          state_id: "2965",
        },
        {
          id: "35343",
          name: "Sotrile",
          state_id: "2965",
        },
        {
          id: "35344",
          name: "Starchiojd",
          state_id: "2965",
        },
        {
          id: "35345",
          name: "Stefesti",
          state_id: "2965",
        },
        {
          id: "35346",
          name: "Surani",
          state_id: "2965",
        },
        {
          id: "35347",
          name: "Talea",
          state_id: "2965",
        },
        {
          id: "35348",
          name: "Targsorul-Vechi",
          state_id: "2965",
        },
        {
          id: "35349",
          name: "Tataru",
          state_id: "2965",
        },
        {
          id: "35350",
          name: "Teisani",
          state_id: "2965",
        },
        {
          id: "35351",
          name: "Telega",
          state_id: "2965",
        },
        {
          id: "35352",
          name: "Tinosu",
          state_id: "2965",
        },
        {
          id: "35353",
          name: "Tomsani",
          state_id: "2965",
        },
        {
          id: "35354",
          name: "Urlati",
          state_id: "2965",
        },
        {
          id: "35355",
          name: "Valcanesti",
          state_id: "2965",
        },
        {
          id: "35356",
          name: "Valea Calugareasca",
          state_id: "2965",
        },
        {
          id: "35357",
          name: "Valenii de Munte",
          state_id: "2965",
        },
        {
          id: "35358",
          name: "Varbilau",
          state_id: "2965",
        },
      ],
      Salaj: [
        {
          id: "35359",
          name: "Agrij",
          state_id: "2966",
        },
        {
          id: "35360",
          name: "Almasu",
          state_id: "2966",
        },
        {
          id: "35361",
          name: "Babeni",
          state_id: "2966",
        },
        {
          id: "35362",
          name: "Balan",
          state_id: "2966",
        },
        {
          id: "35363",
          name: "Banisor",
          state_id: "2966",
        },
        {
          id: "35364",
          name: "Benesat",
          state_id: "2966",
        },
        {
          id: "35365",
          name: "Bobota",
          state_id: "2966",
        },
        {
          id: "35366",
          name: "Bocsa",
          state_id: "2966",
        },
        {
          id: "35367",
          name: "Buciumi",
          state_id: "2966",
        },
        {
          id: "35368",
          name: "Camar",
          state_id: "2966",
        },
        {
          id: "35369",
          name: "Carastelec",
          state_id: "2966",
        },
        {
          id: "35370",
          name: "Cehu Silvaniei",
          state_id: "2966",
        },
        {
          id: "35371",
          name: "Chiesd",
          state_id: "2966",
        },
        {
          id: "35372",
          name: "Cizer",
          state_id: "2966",
        },
        {
          id: "35373",
          name: "Coseiu",
          state_id: "2966",
        },
        {
          id: "35374",
          name: "Crasna",
          state_id: "2966",
        },
        {
          id: "35375",
          name: "Creaca",
          state_id: "2966",
        },
        {
          id: "35376",
          name: "Criseni",
          state_id: "2966",
        },
        {
          id: "35377",
          name: "Cristolt",
          state_id: "2966",
        },
        {
          id: "35378",
          name: "Cuzaplac",
          state_id: "2966",
        },
        {
          id: "35379",
          name: "Dobrin",
          state_id: "2966",
        },
        {
          id: "35380",
          name: "Dragu",
          state_id: "2966",
        },
        {
          id: "35381",
          name: "Fildu de Jos",
          state_id: "2966",
        },
        {
          id: "35382",
          name: "Galgau",
          state_id: "2966",
        },
        {
          id: "35383",
          name: "Garbou",
          state_id: "2966",
        },
        {
          id: "35384",
          name: "Halmasd",
          state_id: "2966",
        },
        {
          id: "35385",
          name: "Hereclean",
          state_id: "2966",
        },
        {
          id: "35386",
          name: "Hida",
          state_id: "2966",
        },
        {
          id: "35387",
          name: "Horoatu Crasnei",
          state_id: "2966",
        },
        {
          id: "35388",
          name: "Ileanda",
          state_id: "2966",
        },
        {
          id: "35389",
          name: "Ip",
          state_id: "2966",
        },
        {
          id: "35390",
          name: "Jibou",
          state_id: "2966",
        },
        {
          id: "35391",
          name: "Letca",
          state_id: "2966",
        },
        {
          id: "35392",
          name: "Lozna",
          state_id: "2966",
        },
        {
          id: "35393",
          name: "Maeriste",
          state_id: "2966",
        },
        {
          id: "35394",
          name: "Marca",
          state_id: "2966",
        },
        {
          id: "35395",
          name: "Mesesenii de Jos",
          state_id: "2966",
        },
        {
          id: "35396",
          name: "Mirsid",
          state_id: "2966",
        },
        {
          id: "35397",
          name: "Napradea",
          state_id: "2966",
        },
        {
          id: "35398",
          name: "Nusfalau",
          state_id: "2966",
        },
        {
          id: "35399",
          name: "Periceiu",
          state_id: "2966",
        },
        {
          id: "35400",
          name: "Plopis",
          state_id: "2966",
        },
        {
          id: "35401",
          name: "Poiana Blenchii",
          state_id: "2966",
        },
        {
          id: "35402",
          name: "Romanasi",
          state_id: "2966",
        },
        {
          id: "35403",
          name: "Rus",
          state_id: "2966",
        },
        {
          id: "35404",
          name: "Sag",
          state_id: "2966",
        },
        {
          id: "35405",
          name: "Salatig",
          state_id: "2966",
        },
        {
          id: "35406",
          name: "Samsud",
          state_id: "2966",
        },
        {
          id: "35407",
          name: "Sanmihaiul-Almasului",
          state_id: "2966",
        },
        {
          id: "35408",
          name: "Sarmasag",
          state_id: "2966",
        },
        {
          id: "35409",
          name: "Simleu Silvaniei",
          state_id: "2966",
        },
        {
          id: "35410",
          name: "Somes-Odorhei",
          state_id: "2966",
        },
        {
          id: "35411",
          name: "Surduc",
          state_id: "2966",
        },
        {
          id: "35412",
          name: "Treznea",
          state_id: "2966",
        },
        {
          id: "35413",
          name: "Valcau de Jos",
          state_id: "2966",
        },
        {
          id: "35414",
          name: "Varsolt",
          state_id: "2966",
        },
        {
          id: "35415",
          name: "Zalau",
          state_id: "2966",
        },
        {
          id: "35416",
          name: "Zalha",
          state_id: "2966",
        },
        {
          id: "35417",
          name: "Zimbor",
          state_id: "2966",
        },
      ],
      "Satu Mare": [],
      Sibiu: [
        {
          id: "35418",
          name: "Agnita",
          state_id: "2968",
        },
        {
          id: "35419",
          name: "Altina",
          state_id: "2968",
        },
        {
          id: "35420",
          name: "Apoldu de Jos",
          state_id: "2968",
        },
        {
          id: "35421",
          name: "Arpasu de Jos",
          state_id: "2968",
        },
        {
          id: "35422",
          name: "Atel",
          state_id: "2968",
        },
        {
          id: "35423",
          name: "Avrig",
          state_id: "2968",
        },
        {
          id: "35424",
          name: "Axente Sever",
          state_id: "2968",
        },
        {
          id: "35425",
          name: "Barghis",
          state_id: "2968",
        },
        {
          id: "35426",
          name: "Bazna",
          state_id: "2968",
        },
        {
          id: "35427",
          name: "Biertan",
          state_id: "2968",
        },
        {
          id: "35428",
          name: "Blajel",
          state_id: "2968",
        },
        {
          id: "35429",
          name: "Bradeni",
          state_id: "2968",
        },
        {
          id: "35430",
          name: "Brateiu",
          state_id: "2968",
        },
        {
          id: "35431",
          name: "Bruiu",
          state_id: "2968",
        },
        {
          id: "35432",
          name: "Carta",
          state_id: "2968",
        },
        {
          id: "35433",
          name: "Cartisoara",
          state_id: "2968",
        },
        {
          id: "35434",
          name: "Chirpar",
          state_id: "2968",
        },
        {
          id: "35435",
          name: "Cisnadie",
          state_id: "2968",
        },
        {
          id: "35436",
          name: "Copsa Mica",
          state_id: "2968",
        },
        {
          id: "35437",
          name: "Cristian",
          state_id: "2968",
        },
        {
          id: "35438",
          name: "Darlos",
          state_id: "2968",
        },
        {
          id: "35439",
          name: "Dumbraveni",
          state_id: "2968",
        },
        {
          id: "35440",
          name: "Gura Raului",
          state_id: "2968",
        },
        {
          id: "35441",
          name: "Hoghilag",
          state_id: "2968",
        },
        {
          id: "35442",
          name: "Iacobeni",
          state_id: "2968",
        },
        {
          id: "35443",
          name: "Jina",
          state_id: "2968",
        },
        {
          id: "35444",
          name: "Laslea",
          state_id: "2968",
        },
        {
          id: "35445",
          name: "Loamnes",
          state_id: "2968",
        },
        {
          id: "35446",
          name: "Ludos",
          state_id: "2968",
        },
        {
          id: "35447",
          name: "Marpod",
          state_id: "2968",
        },
        {
          id: "35448",
          name: "Medias",
          state_id: "2968",
        },
        {
          id: "35449",
          name: "Merghindeal",
          state_id: "2968",
        },
        {
          id: "35450",
          name: "Micasasa",
          state_id: "2968",
        },
        {
          id: "35451",
          name: "Miercurea Sibiului",
          state_id: "2968",
        },
        {
          id: "35452",
          name: "Mihaileni",
          state_id: "2968",
        },
        {
          id: "35453",
          name: "Mosna",
          state_id: "2968",
        },
        {
          id: "35454",
          name: "Nocrich",
          state_id: "2968",
        },
        {
          id: "35455",
          name: "Ocna Sibiului",
          state_id: "2968",
        },
        {
          id: "35456",
          name: "Orlat",
          state_id: "2968",
        },
        {
          id: "35457",
          name: "Pauca",
          state_id: "2968",
        },
        {
          id: "35458",
          name: "Poiana Sibiului",
          state_id: "2968",
        },
        {
          id: "35459",
          name: "Poplaca",
          state_id: "2968",
        },
        {
          id: "35460",
          name: "Porumbacu de Jos",
          state_id: "2968",
        },
        {
          id: "35461",
          name: "Racovita",
          state_id: "2968",
        },
        {
          id: "35462",
          name: "Rasinari",
          state_id: "2968",
        },
        {
          id: "35463",
          name: "Rau Sadului",
          state_id: "2968",
        },
        {
          id: "35464",
          name: "Rosia",
          state_id: "2968",
        },
        {
          id: "35465",
          name: "Sadu",
          state_id: "2968",
        },
        {
          id: "35466",
          name: "Saliste",
          state_id: "2968",
        },
        {
          id: "35467",
          name: "Seica Mare",
          state_id: "2968",
        },
        {
          id: "35468",
          name: "Seica Mica",
          state_id: "2968",
        },
        {
          id: "35469",
          name: "Selimbar",
          state_id: "2968",
        },
        {
          id: "35470",
          name: "Sibiu",
          state_id: "2968",
        },
        {
          id: "35471",
          name: "Slimnic",
          state_id: "2968",
        },
        {
          id: "35472",
          name: "Sura Mare",
          state_id: "2968",
        },
        {
          id: "35473",
          name: "Sura Mica",
          state_id: "2968",
        },
        {
          id: "35474",
          name: "Talmaciu",
          state_id: "2968",
        },
        {
          id: "35475",
          name: "Tarnava",
          state_id: "2968",
        },
        {
          id: "35476",
          name: "Tilisca",
          state_id: "2968",
        },
        {
          id: "35477",
          name: "Turnu Rosu",
          state_id: "2968",
        },
        {
          id: "35478",
          name: "Valea Viilor",
          state_id: "2968",
        },
        {
          id: "35479",
          name: "Vurpar",
          state_id: "2968",
        },
      ],
      Sondelor: [
        {
          id: "35480",
          name: "Sondelor",
          state_id: "2969",
        },
      ],
      Suceava: [
        {
          id: "35481",
          name: "Adancata",
          state_id: "2970",
        },
        {
          id: "35482",
          name: "Arbore",
          state_id: "2970",
        },
        {
          id: "35483",
          name: "Baia",
          state_id: "2970",
        },
        {
          id: "35484",
          name: "Balcauti",
          state_id: "2970",
        },
        {
          id: "35485",
          name: "Bilca",
          state_id: "2970",
        },
        {
          id: "35486",
          name: "Bogdanesti",
          state_id: "2970",
        },
        {
          id: "35487",
          name: "Boroaia",
          state_id: "2970",
        },
        {
          id: "35488",
          name: "Bosanci",
          state_id: "2970",
        },
        {
          id: "35489",
          name: "Botosana",
          state_id: "2970",
        },
        {
          id: "35490",
          name: "Breaza",
          state_id: "2970",
        },
        {
          id: "35491",
          name: "Brodina",
          state_id: "2970",
        },
        {
          id: "35492",
          name: "Brosteni",
          state_id: "2970",
        },
        {
          id: "35493",
          name: "Bunesti",
          state_id: "2970",
        },
        {
          id: "35494",
          name: "Cacica",
          state_id: "2970",
        },
        {
          id: "35495",
          name: "Cajvana",
          state_id: "2970",
        },
        {
          id: "35496",
          name: "Calafindesti",
          state_id: "2970",
        },
        {
          id: "35497",
          name: "Campulung Moldovenesc",
          state_id: "2970",
        },
        {
          id: "35498",
          name: "Carlibaba",
          state_id: "2970",
        },
        {
          id: "35499",
          name: "Ciprian Porumbescu",
          state_id: "2970",
        },
        {
          id: "35500",
          name: "Cornu Luncii",
          state_id: "2970",
        },
        {
          id: "35501",
          name: "Crucea",
          state_id: "2970",
        },
        {
          id: "35502",
          name: "Darmanesti",
          state_id: "2970",
        },
        {
          id: "35503",
          name: "Dolhasca",
          state_id: "2970",
        },
        {
          id: "35504",
          name: "Dolhesti",
          state_id: "2970",
        },
        {
          id: "35505",
          name: "Dorna",
          state_id: "2970",
        },
        {
          id: "35506",
          name: "Dorna Candrenilor",
          state_id: "2970",
        },
        {
          id: "35507",
          name: "Dornesti",
          state_id: "2970",
        },
        {
          id: "35508",
          name: "Dragoesti",
          state_id: "2970",
        },
        {
          id: "35509",
          name: "Draguseni",
          state_id: "2970",
        },
        {
          id: "35510",
          name: "Dumbraveni",
          state_id: "2970",
        },
        {
          id: "35511",
          name: "Falticeni",
          state_id: "2970",
        },
        {
          id: "35512",
          name: "Fantanele",
          state_id: "2970",
        },
        {
          id: "35513",
          name: "Forasti",
          state_id: "2970",
        },
        {
          id: "35514",
          name: "Frasin",
          state_id: "2970",
        },
        {
          id: "35515",
          name: "Fratautii Noi",
          state_id: "2970",
        },
        {
          id: "35516",
          name: "Fratautii Vechi",
          state_id: "2970",
        },
        {
          id: "35517",
          name: "Frumosu",
          state_id: "2970",
        },
        {
          id: "35518",
          name: "Fundu Moldovei",
          state_id: "2970",
        },
        {
          id: "35519",
          name: "Galanesti",
          state_id: "2970",
        },
        {
          id: "35520",
          name: "Gramesti",
          state_id: "2970",
        },
        {
          id: "35521",
          name: "Granicesti",
          state_id: "2970",
        },
        {
          id: "35522",
          name: "Gura Humorului",
          state_id: "2970",
        },
        {
          id: "35523",
          name: "Horodniceni",
          state_id: "2970",
        },
        {
          id: "35524",
          name: "Horodnicu",
          state_id: "2970",
        },
        {
          id: "35525",
          name: "Iacobeni",
          state_id: "2970",
        },
        {
          id: "35526",
          name: "Ipotesti",
          state_id: "2970",
        },
        {
          id: "35527",
          name: "Izvoarele Sucevei",
          state_id: "2970",
        },
        {
          id: "35528",
          name: "Liteni",
          state_id: "2970",
        },
        {
          id: "35529",
          name: "Malini",
          state_id: "2970",
        },
        {
          id: "35530",
          name: "Manastirea Homorului",
          state_id: "2970",
        },
        {
          id: "35531",
          name: "Marginea",
          state_id: "2970",
        },
        {
          id: "35532",
          name: "Milisauti",
          state_id: "2970",
        },
        {
          id: "35533",
          name: "Mitocu Dragomirnei",
          state_id: "2970",
        },
        {
          id: "35534",
          name: "Moara",
          state_id: "2970",
        },
        {
          id: "35535",
          name: "Moldova Sulita",
          state_id: "2970",
        },
        {
          id: "35536",
          name: "Moldovita",
          state_id: "2970",
        },
        {
          id: "35537",
          name: "Musenita",
          state_id: "2970",
        },
        {
          id: "35538",
          name: "Ostra",
          state_id: "2970",
        },
        {
          id: "35539",
          name: "Paltinoasa",
          state_id: "2970",
        },
        {
          id: "35540",
          name: "Panaci",
          state_id: "2970",
        },
        {
          id: "35541",
          name: "Partestii de Jos",
          state_id: "2970",
        },
        {
          id: "35542",
          name: "Patrauti",
          state_id: "2970",
        },
        {
          id: "35543",
          name: "Poiana Stampei",
          state_id: "2970",
        },
        {
          id: "35544",
          name: "Pojorata",
          state_id: "2970",
        },
        {
          id: "35545",
          name: "Preutesti",
          state_id: "2970",
        },
        {
          id: "35546",
          name: "Putna",
          state_id: "2970",
        },
        {
          id: "35547",
          name: "Radaseni",
          state_id: "2970",
        },
        {
          id: "35548",
          name: "Radauti",
          state_id: "2970",
        },
        {
          id: "35549",
          name: "Rasca",
          state_id: "2970",
        },
        {
          id: "35550",
          name: "Sadova",
          state_id: "2970",
        },
        {
          id: "35551",
          name: "Salcea",
          state_id: "2970",
        },
        {
          id: "35552",
          name: "Saru Dornei",
          state_id: "2970",
        },
        {
          id: "35553",
          name: "Satu Mare",
          state_id: "2970",
        },
        {
          id: "35554",
          name: "Scheia",
          state_id: "2970",
        },
        {
          id: "35555",
          name: "Siminicea",
          state_id: "2970",
        },
        {
          id: "35556",
          name: "Siret",
          state_id: "2970",
        },
        {
          id: "35557",
          name: "Slatina",
          state_id: "2970",
        },
        {
          id: "35558",
          name: "Solca",
          state_id: "2970",
        },
        {
          id: "35559",
          name: "Straja",
          state_id: "2970",
        },
        {
          id: "35560",
          name: "Stroiesti",
          state_id: "2970",
        },
        {
          id: "35561",
          name: "Stulpicani",
          state_id: "2970",
        },
        {
          id: "35562",
          name: "Suceava",
          state_id: "2970",
        },
        {
          id: "35563",
          name: "Sucevita",
          state_id: "2970",
        },
        {
          id: "35564",
          name: "Todiresti",
          state_id: "2970",
        },
        {
          id: "35565",
          name: "Udesti",
          state_id: "2970",
        },
        {
          id: "35566",
          name: "Ulma",
          state_id: "2970",
        },
        {
          id: "35567",
          name: "Vadu Moldovei",
          state_id: "2970",
        },
        {
          id: "35568",
          name: "Valea Moldovei",
          state_id: "2970",
        },
        {
          id: "35569",
          name: "Vama",
          state_id: "2970",
        },
        {
          id: "35570",
          name: "Vatra Dornei",
          state_id: "2970",
        },
        {
          id: "35571",
          name: "Vatra Moldovitei",
          state_id: "2970",
        },
        {
          id: "35572",
          name: "Veresti",
          state_id: "2970",
        },
        {
          id: "35573",
          name: "Vicovu de Jos",
          state_id: "2970",
        },
        {
          id: "35574",
          name: "Vicovu de Sus",
          state_id: "2970",
        },
        {
          id: "35575",
          name: "Volovat",
          state_id: "2970",
        },
        {
          id: "35576",
          name: "Vulturesti",
          state_id: "2970",
        },
        {
          id: "35577",
          name: "Zamostea",
          state_id: "2970",
        },
        {
          id: "35578",
          name: "Zvoristea",
          state_id: "2970",
        },
      ],
      Teleorman: [
        {
          id: "35579",
          name: "Alexandria",
          state_id: "2971",
        },
        {
          id: "35580",
          name: "Babaita",
          state_id: "2971",
        },
        {
          id: "35581",
          name: "Balaci",
          state_id: "2971",
        },
        {
          id: "35582",
          name: "Blejesti",
          state_id: "2971",
        },
        {
          id: "35583",
          name: "Bogdana",
          state_id: "2971",
        },
        {
          id: "35584",
          name: "Botoroaga",
          state_id: "2971",
        },
        {
          id: "35585",
          name: "Bragadiru",
          state_id: "2971",
        },
        {
          id: "35586",
          name: "Branceni",
          state_id: "2971",
        },
        {
          id: "35587",
          name: "Bujoreni",
          state_id: "2971",
        },
        {
          id: "35588",
          name: "Bujoru",
          state_id: "2971",
        },
        {
          id: "35589",
          name: "Buzescu",
          state_id: "2971",
        },
        {
          id: "35590",
          name: "Calinesti",
          state_id: "2971",
        },
        {
          id: "35591",
          name: "Calmatuiu",
          state_id: "2971",
        },
        {
          id: "35592",
          name: "Cervenia",
          state_id: "2971",
        },
        {
          id: "35593",
          name: "Ciolanesti",
          state_id: "2971",
        },
        {
          id: "35594",
          name: "Ciuperceni",
          state_id: "2971",
        },
        {
          id: "35595",
          name: "Contesti",
          state_id: "2971",
        },
        {
          id: "35596",
          name: "Cosmesti",
          state_id: "2971",
        },
        {
          id: "35597",
          name: "Crangeni",
          state_id: "2971",
        },
        {
          id: "35598",
          name: "Crangu",
          state_id: "2971",
        },
        {
          id: "35599",
          name: "Crevenicu",
          state_id: "2971",
        },
        {
          id: "35600",
          name: "Didesti",
          state_id: "2971",
        },
        {
          id: "35601",
          name: "Dobrotesti",
          state_id: "2971",
        },
        {
          id: "35602",
          name: "Dracsenei",
          state_id: "2971",
        },
        {
          id: "35603",
          name: "Draganesti de Vede",
          state_id: "2971",
        },
        {
          id: "35604",
          name: "Draganesti-Vlasca",
          state_id: "2971",
        },
        {
          id: "35605",
          name: "Frumoasa",
          state_id: "2971",
        },
        {
          id: "35606",
          name: "Furculesti",
          state_id: "2971",
        },
        {
          id: "35607",
          name: "Galateni",
          state_id: "2971",
        },
        {
          id: "35608",
          name: "Gratia",
          state_id: "2971",
        },
        {
          id: "35609",
          name: "Islaz",
          state_id: "2971",
        },
        {
          id: "35610",
          name: "Izvoarele",
          state_id: "2971",
        },
        {
          id: "35611",
          name: "Lisa",
          state_id: "2971",
        },
        {
          id: "35612",
          name: "Lita",
          state_id: "2971",
        },
        {
          id: "35613",
          name: "Lunca",
          state_id: "2971",
        },
        {
          id: "35614",
          name: "Magura",
          state_id: "2971",
        },
        {
          id: "35615",
          name: "Maldaeni",
          state_id: "2971",
        },
        {
          id: "35616",
          name: "Marzanesti",
          state_id: "2971",
        },
        {
          id: "35617",
          name: "Mavrodin",
          state_id: "2971",
        },
        {
          id: "35618",
          name: "Mereni",
          state_id: "2971",
        },
        {
          id: "35619",
          name: "Mosteni",
          state_id: "2971",
        },
        {
          id: "35620",
          name: "Nanov",
          state_id: "2971",
        },
        {
          id: "35621",
          name: "Nasturelu",
          state_id: "2971",
        },
        {
          id: "35622",
          name: "Necsesti",
          state_id: "2971",
        },
        {
          id: "35623",
          name: "Olteni",
          state_id: "2971",
        },
        {
          id: "35624",
          name: "Orbeasca",
          state_id: "2971",
        },
        {
          id: "35625",
          name: "Peretu",
          state_id: "2971",
        },
        {
          id: "35626",
          name: "Piatra",
          state_id: "2971",
        },
        {
          id: "35627",
          name: "Pietrosani",
          state_id: "2971",
        },
        {
          id: "35628",
          name: "Plopii Slavitesti",
          state_id: "2971",
        },
        {
          id: "35629",
          name: "Plosca",
          state_id: "2971",
        },
        {
          id: "35630",
          name: "Poeni",
          state_id: "2971",
        },
        {
          id: "35631",
          name: "Poroschia",
          state_id: "2971",
        },
        {
          id: "35632",
          name: "Putineiu",
          state_id: "2971",
        },
        {
          id: "35633",
          name: "Radoiesti",
          state_id: "2971",
        },
        {
          id: "35634",
          name: "Rasmiresti",
          state_id: "2971",
        },
        {
          id: "35635",
          name: "Rosiori de Vede",
          state_id: "2971",
        },
        {
          id: "35636",
          name: "Saceni",
          state_id: "2971",
        },
        {
          id: "35637",
          name: "Salcia",
          state_id: "2971",
        },
        {
          id: "35638",
          name: "Sarbeni",
          state_id: "2971",
        },
        {
          id: "35639",
          name: "Scrioastea",
          state_id: "2971",
        },
        {
          id: "35640",
          name: "Scurtu Mare",
          state_id: "2971",
        },
        {
          id: "35641",
          name: "Seaca",
          state_id: "2971",
        },
        {
          id: "35642",
          name: "Segarcea Vale",
          state_id: "2971",
        },
        {
          id: "35643",
          name: "Sfintesti",
          state_id: "2971",
        },
        {
          id: "35644",
          name: "Silistea",
          state_id: "2971",
        },
        {
          id: "35645",
          name: "Silistea-Gumesti",
          state_id: "2971",
        },
        {
          id: "35646",
          name: "Slobozia-Mandra",
          state_id: "2971",
        },
        {
          id: "35647",
          name: "Smardioasa",
          state_id: "2971",
        },
        {
          id: "35648",
          name: "Stejaru",
          state_id: "2971",
        },
        {
          id: "35649",
          name: "Storobaneasa",
          state_id: "2971",
        },
        {
          id: "35650",
          name: "Suhaia",
          state_id: "2971",
        },
        {
          id: "35651",
          name: "Talpa",
          state_id: "2971",
        },
        {
          id: "35652",
          name: "Tatarastii de Jos",
          state_id: "2971",
        },
        {
          id: "35653",
          name: "Tatarastii de Sus",
          state_id: "2971",
        },
        {
          id: "35654",
          name: "Tiganesti",
          state_id: "2971",
        },
        {
          id: "35655",
          name: "Traian",
          state_id: "2971",
        },
        {
          id: "35656",
          name: "Trivalea-Mosteni",
          state_id: "2971",
        },
        {
          id: "35657",
          name: "Troianul",
          state_id: "2971",
        },
        {
          id: "35658",
          name: "Turnu Magurele",
          state_id: "2971",
        },
        {
          id: "35659",
          name: "Vartoapele-de-Jos",
          state_id: "2971",
        },
        {
          id: "35660",
          name: "Vedea",
          state_id: "2971",
        },
        {
          id: "35661",
          name: "Videle",
          state_id: "2971",
        },
        {
          id: "35662",
          name: "Viisoara",
          state_id: "2971",
        },
        {
          id: "35663",
          name: "Vitanesti",
          state_id: "2971",
        },
        {
          id: "35664",
          name: "Zambreasca",
          state_id: "2971",
        },
        {
          id: "35665",
          name: "Zimnicea",
          state_id: "2971",
        },
      ],
      Timis: [
        {
          id: "35666",
          name: "Balint",
          state_id: "2972",
        },
        {
          id: "35667",
          name: "Banloc",
          state_id: "2972",
        },
        {
          id: "35668",
          name: "Bara",
          state_id: "2972",
        },
        {
          id: "35669",
          name: "Barna",
          state_id: "2972",
        },
        {
          id: "35670",
          name: "Beba Veche",
          state_id: "2972",
        },
        {
          id: "35671",
          name: "Becicherecu Mic",
          state_id: "2972",
        },
        {
          id: "35672",
          name: "Belint",
          state_id: "2972",
        },
        {
          id: "35673",
          name: "Bethausen",
          state_id: "2972",
        },
        {
          id: "35674",
          name: "Biled",
          state_id: "2972",
        },
        {
          id: "35675",
          name: "Bogda",
          state_id: "2972",
        },
        {
          id: "35676",
          name: "Boldur",
          state_id: "2972",
        },
        {
          id: "35677",
          name: "Brestovat",
          state_id: "2972",
        },
        {
          id: "35678",
          name: "Buzias",
          state_id: "2972",
        },
        {
          id: "35679",
          name: "Carpinis",
          state_id: "2972",
        },
        {
          id: "35680",
          name: "Cenad",
          state_id: "2972",
        },
        {
          id: "35681",
          name: "Cenei",
          state_id: "2972",
        },
        {
          id: "35682",
          name: "Cheveresu Mare",
          state_id: "2972",
        },
        {
          id: "35683",
          name: "Ciacova",
          state_id: "2972",
        },
        {
          id: "35684",
          name: "Comlosu Mare",
          state_id: "2972",
        },
        {
          id: "35685",
          name: "Costeiu",
          state_id: "2972",
        },
        {
          id: "35686",
          name: "Criciova",
          state_id: "2972",
        },
        {
          id: "35687",
          name: "Curtea",
          state_id: "2972",
        },
        {
          id: "35688",
          name: "Darova",
          state_id: "2972",
        },
        {
          id: "35689",
          name: "Denta",
          state_id: "2972",
        },
        {
          id: "35690",
          name: "Deta",
          state_id: "2972",
        },
        {
          id: "35691",
          name: "Dudestii Vechi",
          state_id: "2972",
        },
        {
          id: "35692",
          name: "Dumbrava",
          state_id: "2972",
        },
        {
          id: "35693",
          name: "Dumbravita",
          state_id: "2972",
        },
        {
          id: "35694",
          name: "Faget",
          state_id: "2972",
        },
        {
          id: "35695",
          name: "Fardea",
          state_id: "2972",
        },
        {
          id: "35696",
          name: "Foeni",
          state_id: "2972",
        },
        {
          id: "35697",
          name: "Gataia",
          state_id: "2972",
        },
        {
          id: "35698",
          name: "Gavojdia",
          state_id: "2972",
        },
        {
          id: "35699",
          name: "Ghiroda",
          state_id: "2972",
        },
        {
          id: "35700",
          name: "Ghizela",
          state_id: "2972",
        },
        {
          id: "35701",
          name: "Giarmata",
          state_id: "2972",
        },
        {
          id: "35702",
          name: "Giera",
          state_id: "2972",
        },
        {
          id: "35703",
          name: "Giroc",
          state_id: "2972",
        },
        {
          id: "35704",
          name: "Giulvaz",
          state_id: "2972",
        },
        {
          id: "35705",
          name: "Jamu Mare",
          state_id: "2972",
        },
        {
          id: "35706",
          name: "Jebel",
          state_id: "2972",
        },
        {
          id: "35707",
          name: "Jimbolia",
          state_id: "2972",
        },
        {
          id: "35708",
          name: "Lenauheim",
          state_id: "2972",
        },
        {
          id: "35709",
          name: "Liebling",
          state_id: "2972",
        },
        {
          id: "35710",
          name: "Lovrin",
          state_id: "2972",
        },
        {
          id: "35711",
          name: "Lugoj",
          state_id: "2972",
        },
        {
          id: "35712",
          name: "Manastiur",
          state_id: "2972",
        },
        {
          id: "35713",
          name: "Margina",
          state_id: "2972",
        },
        {
          id: "35714",
          name: "Masloc",
          state_id: "2972",
        },
        {
          id: "35715",
          name: "Moravita",
          state_id: "2972",
        },
        {
          id: "35716",
          name: "Mosnita Noua",
          state_id: "2972",
        },
        {
          id: "35717",
          name: "Nadrag",
          state_id: "2972",
        },
        {
          id: "35718",
          name: "Nitchidorf",
          state_id: "2972",
        },
        {
          id: "35719",
          name: "Ohaba Lunga",
          state_id: "2972",
        },
        {
          id: "35720",
          name: "Ortisoara",
          state_id: "2972",
        },
        {
          id: "35721",
          name: "Peciu Nou",
          state_id: "2972",
        },
        {
          id: "35722",
          name: "Periam",
          state_id: "2972",
        },
        {
          id: "35723",
          name: "Pietroasa",
          state_id: "2972",
        },
        {
          id: "35724",
          name: "Pischia",
          state_id: "2972",
        },
        {
          id: "35725",
          name: "Racovita",
          state_id: "2972",
        },
        {
          id: "35726",
          name: "Recas",
          state_id: "2972",
        },
        {
          id: "35727",
          name: "Remetea Mare",
          state_id: "2972",
        },
        {
          id: "35728",
          name: "Sacalaz",
          state_id: "2972",
        },
        {
          id: "35729",
          name: "Sacosu Turcesc",
          state_id: "2972",
        },
        {
          id: "35730",
          name: "Sag",
          state_id: "2972",
        },
        {
          id: "35731",
          name: "Sanandrei",
          state_id: "2972",
        },
        {
          id: "35732",
          name: "Sanmihaiu Roman",
          state_id: "2972",
        },
        {
          id: "35733",
          name: "Sannicolaul Mare",
          state_id: "2972",
        },
        {
          id: "35734",
          name: "Sanpetrul-Mare",
          state_id: "2972",
        },
        {
          id: "35735",
          name: "Satchinez",
          state_id: "2972",
        },
        {
          id: "35736",
          name: "Secas",
          state_id: "2972",
        },
        {
          id: "35737",
          name: "Stiuca",
          state_id: "2972",
        },
        {
          id: "35738",
          name: "Teremia Mare",
          state_id: "2972",
        },
        {
          id: "35739",
          name: "Timisoara",
          state_id: "2972",
        },
        {
          id: "35740",
          name: "Tomesti",
          state_id: "2972",
        },
        {
          id: "35741",
          name: "Topolovatu Mare",
          state_id: "2972",
        },
        {
          id: "35742",
          name: "Tormac",
          state_id: "2972",
        },
        {
          id: "35743",
          name: "Traian Vuia",
          state_id: "2972",
        },
        {
          id: "35744",
          name: "Uivar",
          state_id: "2972",
        },
        {
          id: "35745",
          name: "Varias",
          state_id: "2972",
        },
        {
          id: "35746",
          name: "Victor Vlad Delamarina",
          state_id: "2972",
        },
        {
          id: "35747",
          name: "Voiteg",
          state_id: "2972",
        },
      ],
      Tulcea: [
        {
          id: "35748",
          name: "Babadag",
          state_id: "2973",
        },
        {
          id: "35749",
          name: "Baia",
          state_id: "2973",
        },
        {
          id: "35750",
          name: "Beidaud",
          state_id: "2973",
        },
        {
          id: "35751",
          name: "Carcaliu",
          state_id: "2973",
        },
        {
          id: "35752",
          name: "Casimcea",
          state_id: "2973",
        },
        {
          id: "35753",
          name: "Ceamurlia de Jos",
          state_id: "2973",
        },
        {
          id: "35754",
          name: "Ceatalchioi",
          state_id: "2973",
        },
        {
          id: "35755",
          name: "Cerna",
          state_id: "2973",
        },
        {
          id: "35756",
          name: "Chilia Veche",
          state_id: "2973",
        },
        {
          id: "35757",
          name: "Ciucurova",
          state_id: "2973",
        },
        {
          id: "35758",
          name: "Constantin Rosetti",
          state_id: "2973",
        },
        {
          id: "35759",
          name: "Crisan",
          state_id: "2973",
        },
        {
          id: "35760",
          name: "Daeni",
          state_id: "2973",
        },
        {
          id: "35761",
          name: "Dorobantu",
          state_id: "2973",
        },
        {
          id: "35762",
          name: "Frecatei",
          state_id: "2973",
        },
        {
          id: "35763",
          name: "Greci",
          state_id: "2973",
        },
        {
          id: "35764",
          name: "Grindu",
          state_id: "2973",
        },
        {
          id: "35765",
          name: "Hamcearca",
          state_id: "2973",
        },
        {
          id: "35766",
          name: "Horia",
          state_id: "2973",
        },
        {
          id: "35767",
          name: "Ion Bratianu",
          state_id: "2973",
        },
        {
          id: "35768",
          name: "Isaccea",
          state_id: "2973",
        },
        {
          id: "35769",
          name: "Izvoarele",
          state_id: "2973",
        },
        {
          id: "35770",
          name: "Jijila",
          state_id: "2973",
        },
        {
          id: "35771",
          name: "Jurilovca",
          state_id: "2973",
        },
        {
          id: "35772",
          name: "Luncavita",
          state_id: "2973",
        },
        {
          id: "35773",
          name: "Macin",
          state_id: "2973",
        },
        {
          id: "35774",
          name: "Mahmudia",
          state_id: "2973",
        },
        {
          id: "35775",
          name: "Malnas",
          state_id: "2973",
        },
        {
          id: "35776",
          name: "Mihai Bravu",
          state_id: "2973",
        },
        {
          id: "35777",
          name: "Mihail Kogalniceanu",
          state_id: "2973",
        },
        {
          id: "35778",
          name: "Murighiol",
          state_id: "2973",
        },
        {
          id: "35779",
          name: "Nalbant",
          state_id: "2973",
        },
        {
          id: "35780",
          name: "Niculitel",
          state_id: "2973",
        },
        {
          id: "35781",
          name: "Nufaru",
          state_id: "2973",
        },
        {
          id: "35782",
          name: "Ostrov",
          state_id: "2973",
        },
        {
          id: "35783",
          name: "Pardina",
          state_id: "2973",
        },
        {
          id: "35784",
          name: "Peceneaga",
          state_id: "2973",
        },
        {
          id: "35785",
          name: "Sarichioi",
          state_id: "2973",
        },
        {
          id: "35786",
          name: "Sfantu Gheorghe",
          state_id: "2973",
        },
        {
          id: "35787",
          name: "Slava Cercheza",
          state_id: "2973",
        },
        {
          id: "35788",
          name: "Smardan",
          state_id: "2973",
        },
        {
          id: "35789",
          name: "Somova",
          state_id: "2973",
        },
        {
          id: "35790",
          name: "Stejaru",
          state_id: "2973",
        },
        {
          id: "35791",
          name: "Sulina",
          state_id: "2973",
        },
        {
          id: "35792",
          name: "Topolog",
          state_id: "2973",
        },
        {
          id: "35793",
          name: "Tulcea",
          state_id: "2973",
        },
        {
          id: "35794",
          name: "Turcoaia",
          state_id: "2973",
        },
        {
          id: "35795",
          name: "Valea Nucarilor",
          state_id: "2973",
        },
      ],
      Valcea: [
        {
          id: "35796",
          name: "Alunu",
          state_id: "2974",
        },
        {
          id: "35797",
          name: "Amarasti",
          state_id: "2974",
        },
        {
          id: "35798",
          name: "Babeni",
          state_id: "2974",
        },
        {
          id: "35799",
          name: "Baile Govora",
          state_id: "2974",
        },
        {
          id: "35800",
          name: "Baile Olanesti",
          state_id: "2974",
        },
        {
          id: "35801",
          name: "Balcesti",
          state_id: "2974",
        },
        {
          id: "35802",
          name: "Barbatesti",
          state_id: "2974",
        },
        {
          id: "35803",
          name: "Berbesti",
          state_id: "2974",
        },
        {
          id: "35804",
          name: "Berislavesti",
          state_id: "2974",
        },
        {
          id: "35805",
          name: "Boisoara",
          state_id: "2974",
        },
        {
          id: "35806",
          name: "Brezoi",
          state_id: "2974",
        },
        {
          id: "35807",
          name: "Budesti",
          state_id: "2974",
        },
        {
          id: "35808",
          name: "Bujoreni",
          state_id: "2974",
        },
        {
          id: "35809",
          name: "Bunesti",
          state_id: "2974",
        },
        {
          id: "35810",
          name: "Caineni",
          state_id: "2974",
        },
        {
          id: "35811",
          name: "Calimanesti",
          state_id: "2974",
        },
        {
          id: "35812",
          name: "Cernisoara",
          state_id: "2974",
        },
        {
          id: "35813",
          name: "Copaceni",
          state_id: "2974",
        },
        {
          id: "35814",
          name: "Costesti",
          state_id: "2974",
        },
        {
          id: "35815",
          name: "Creteni",
          state_id: "2974",
        },
        {
          id: "35816",
          name: "Daesti",
          state_id: "2974",
        },
        {
          id: "35817",
          name: "Danicei",
          state_id: "2974",
        },
        {
          id: "35818",
          name: "Dragasani",
          state_id: "2974",
        },
        {
          id: "35819",
          name: "Dragoesti",
          state_id: "2974",
        },
        {
          id: "35820",
          name: "Fartatesti",
          state_id: "2974",
        },
        {
          id: "35821",
          name: "Fauresti",
          state_id: "2974",
        },
        {
          id: "35822",
          name: "Francesti",
          state_id: "2974",
        },
        {
          id: "35823",
          name: "Galicea",
          state_id: "2974",
        },
        {
          id: "35824",
          name: "Ghioroiu",
          state_id: "2974",
        },
        {
          id: "35825",
          name: "Glavile",
          state_id: "2974",
        },
        {
          id: "35826",
          name: "Golesti",
          state_id: "2974",
        },
        {
          id: "35827",
          name: "Gradistea",
          state_id: "2974",
        },
        {
          id: "35828",
          name: "Gusoeni",
          state_id: "2974",
        },
        {
          id: "35829",
          name: "Horezu",
          state_id: "2974",
        },
        {
          id: "35830",
          name: "Ionesti",
          state_id: "2974",
        },
        {
          id: "35831",
          name: "Ladesti",
          state_id: "2974",
        },
        {
          id: "35832",
          name: "Lalosu",
          state_id: "2974",
        },
        {
          id: "35833",
          name: "Lapusata",
          state_id: "2974",
        },
        {
          id: "35834",
          name: "Livezi",
          state_id: "2974",
        },
        {
          id: "35835",
          name: "Lungesti",
          state_id: "2974",
        },
        {
          id: "35836",
          name: "Maciuca",
          state_id: "2974",
        },
        {
          id: "35837",
          name: "Madulari",
          state_id: "2974",
        },
        {
          id: "35838",
          name: "Malaia",
          state_id: "2974",
        },
        {
          id: "35839",
          name: "Maldaresti",
          state_id: "2974",
        },
        {
          id: "35840",
          name: "Mateesti",
          state_id: "2974",
        },
        {
          id: "35841",
          name: "Mihaesti",
          state_id: "2974",
        },
        {
          id: "35842",
          name: "Milcoiu",
          state_id: "2974",
        },
        {
          id: "35843",
          name: "Muereasca",
          state_id: "2974",
        },
        {
          id: "35844",
          name: "Nicolae Balcescu",
          state_id: "2974",
        },
        {
          id: "35845",
          name: "Ocnele Mari",
          state_id: "2974",
        },
        {
          id: "35846",
          name: "Olanu",
          state_id: "2974",
        },
        {
          id: "35847",
          name: "Orlesti",
          state_id: "2974",
        },
        {
          id: "35848",
          name: "Otesani",
          state_id: "2974",
        },
        {
          id: "35849",
          name: "Pausesti",
          state_id: "2974",
        },
        {
          id: "35850",
          name: "Pausesti-Maglasi",
          state_id: "2974",
        },
        {
          id: "35851",
          name: "Perisani",
          state_id: "2974",
        },
        {
          id: "35852",
          name: "Pesceana",
          state_id: "2974",
        },
        {
          id: "35853",
          name: "Pietrari",
          state_id: "2974",
        },
        {
          id: "35854",
          name: "Popesti",
          state_id: "2974",
        },
        {
          id: "35855",
          name: "Prundeni",
          state_id: "2974",
        },
        {
          id: "35856",
          name: "Racovita",
          state_id: "2974",
        },
        {
          id: "35857",
          name: "Ramnicu Valcea",
          state_id: "2974",
        },
        {
          id: "35858",
          name: "Roesti",
          state_id: "2974",
        },
        {
          id: "35859",
          name: "Rosiile",
          state_id: "2974",
        },
        {
          id: "35860",
          name: "Runcu",
          state_id: "2974",
        },
        {
          id: "35861",
          name: "Salatrucel",
          state_id: "2974",
        },
        {
          id: "35862",
          name: "Scundu",
          state_id: "2974",
        },
        {
          id: "35863",
          name: "Sinesti",
          state_id: "2974",
        },
        {
          id: "35864",
          name: "Sirineasa",
          state_id: "2974",
        },
        {
          id: "35865",
          name: "Slatioara",
          state_id: "2974",
        },
        {
          id: "35866",
          name: "Stanesti",
          state_id: "2974",
        },
        {
          id: "35867",
          name: "Stefanesti",
          state_id: "2974",
        },
        {
          id: "35868",
          name: "Stoenesti",
          state_id: "2974",
        },
        {
          id: "35869",
          name: "Stoilesti",
          state_id: "2974",
        },
        {
          id: "35870",
          name: "Stroesti",
          state_id: "2974",
        },
        {
          id: "35871",
          name: "Susani",
          state_id: "2974",
        },
        {
          id: "35872",
          name: "Sutesti",
          state_id: "2974",
        },
        {
          id: "35873",
          name: "Tetoiu",
          state_id: "2974",
        },
        {
          id: "35874",
          name: "Tomsani",
          state_id: "2974",
        },
        {
          id: "35875",
          name: "Vaideeni",
          state_id: "2974",
        },
        {
          id: "35876",
          name: "Valea Mare",
          state_id: "2974",
        },
        {
          id: "35877",
          name: "Vladesti",
          state_id: "2974",
        },
        {
          id: "35878",
          name: "Voicesti",
          state_id: "2974",
        },
        {
          id: "35879",
          name: "Voineasa",
          state_id: "2974",
        },
        {
          id: "35880",
          name: "Zatreni",
          state_id: "2974",
        },
      ],
      Vaslui: [
        {
          id: "35881",
          name: "Albesti",
          state_id: "2975",
        },
        {
          id: "35882",
          name: "Alexandru Vlahuta",
          state_id: "2975",
        },
        {
          id: "35883",
          name: "Arsura",
          state_id: "2975",
        },
        {
          id: "35884",
          name: "Bacani",
          state_id: "2975",
        },
        {
          id: "35885",
          name: "Bacesti",
          state_id: "2975",
        },
        {
          id: "35886",
          name: "Balteni",
          state_id: "2975",
        },
        {
          id: "35887",
          name: "Banca",
          state_id: "2975",
        },
        {
          id: "35888",
          name: "Barlad",
          state_id: "2975",
        },
        {
          id: "35889",
          name: "Berezeni",
          state_id: "2975",
        },
        {
          id: "35890",
          name: "Blagesti",
          state_id: "2975",
        },
        {
          id: "35891",
          name: "Bogdana",
          state_id: "2975",
        },
        {
          id: "35892",
          name: "Bogdanesti",
          state_id: "2975",
        },
        {
          id: "35893",
          name: "Bogdanita",
          state_id: "2975",
        },
        {
          id: "35894",
          name: "Botesti",
          state_id: "2975",
        },
        {
          id: "35895",
          name: "Bunesti",
          state_id: "2975",
        },
        {
          id: "35896",
          name: "Codaesti",
          state_id: "2975",
        },
        {
          id: "35897",
          name: "Coroiesti",
          state_id: "2975",
        },
        {
          id: "35898",
          name: "Costesti",
          state_id: "2975",
        },
        {
          id: "35899",
          name: "Cretesti",
          state_id: "2975",
        },
        {
          id: "35900",
          name: "Danesti",
          state_id: "2975",
        },
        {
          id: "35901",
          name: "Deleni",
          state_id: "2975",
        },
        {
          id: "35902",
          name: "Delesti",
          state_id: "2975",
        },
        {
          id: "35903",
          name: "Dimitrie Cantemir",
          state_id: "2975",
        },
        {
          id: "35904",
          name: "Dragomiresti",
          state_id: "2975",
        },
        {
          id: "35905",
          name: "Dranceni Sat",
          state_id: "2975",
        },
        {
          id: "35906",
          name: "Duda",
          state_id: "2975",
        },
        {
          id: "35907",
          name: "Dumesti",
          state_id: "2975",
        },
        {
          id: "35908",
          name: "Epureni",
          state_id: "2975",
        },
        {
          id: "35909",
          name: "Falciu",
          state_id: "2975",
        },
        {
          id: "35910",
          name: "Gagesti",
          state_id: "2975",
        },
        {
          id: "35911",
          name: "Garceni",
          state_id: "2975",
        },
        {
          id: "35912",
          name: "Gherghesti",
          state_id: "2975",
        },
        {
          id: "35913",
          name: "Grivita",
          state_id: "2975",
        },
        {
          id: "35914",
          name: "Hoceni",
          state_id: "2975",
        },
        {
          id: "35915",
          name: "Husi",
          state_id: "2975",
        },
        {
          id: "35916",
          name: "Iana",
          state_id: "2975",
        },
        {
          id: "35917",
          name: "Ivanesti",
          state_id: "2975",
        },
        {
          id: "35918",
          name: "Ivesti",
          state_id: "2975",
        },
        {
          id: "35919",
          name: "Laza",
          state_id: "2975",
        },
        {
          id: "35920",
          name: "Lipovat",
          state_id: "2975",
        },
        {
          id: "35921",
          name: "Lunca Banului",
          state_id: "2975",
        },
        {
          id: "35922",
          name: "Malusteni",
          state_id: "2975",
        },
        {
          id: "35923",
          name: "Miclesti",
          state_id: "2975",
        },
        {
          id: "35924",
          name: "Muntenii de Jos",
          state_id: "2975",
        },
        {
          id: "35925",
          name: "Murgeni",
          state_id: "2975",
        },
        {
          id: "35926",
          name: "Negresti",
          state_id: "2975",
        },
        {
          id: "35927",
          name: "Oltenesti",
          state_id: "2975",
        },
        {
          id: "35928",
          name: "Osesti",
          state_id: "2975",
        },
        {
          id: "35929",
          name: "Padureni",
          state_id: "2975",
        },
        {
          id: "35930",
          name: "Perieni",
          state_id: "2975",
        },
        {
          id: "35931",
          name: "Pogana",
          state_id: "2975",
        },
        {
          id: "35932",
          name: "Poienesti",
          state_id: "2975",
        },
        {
          id: "35933",
          name: "Puiesti",
          state_id: "2975",
        },
        {
          id: "35934",
          name: "Pungesti",
          state_id: "2975",
        },
        {
          id: "35935",
          name: "Rebricea",
          state_id: "2975",
        },
        {
          id: "35936",
          name: "Rosiesti",
          state_id: "2975",
        },
        {
          id: "35937",
          name: "Solesti",
          state_id: "2975",
        },
        {
          id: "35938",
          name: "Stanilesti",
          state_id: "2975",
        },
        {
          id: "35939",
          name: "Stefan cel Mare",
          state_id: "2975",
        },
        {
          id: "35940",
          name: "Suletea",
          state_id: "2975",
        },
        {
          id: "35941",
          name: "Tacuta",
          state_id: "2975",
        },
        {
          id: "35942",
          name: "Tanacu",
          state_id: "2975",
        },
        {
          id: "35943",
          name: "Tatarani",
          state_id: "2975",
        },
        {
          id: "35944",
          name: "Todiresti",
          state_id: "2975",
        },
        {
          id: "35945",
          name: "Tutova",
          state_id: "2975",
        },
        {
          id: "35946",
          name: "Valeni",
          state_id: "2975",
        },
        {
          id: "35947",
          name: "Vaslui",
          state_id: "2975",
        },
        {
          id: "35948",
          name: "Vetrisoaia",
          state_id: "2975",
        },
        {
          id: "35949",
          name: "Viisoara",
          state_id: "2975",
        },
        {
          id: "35950",
          name: "Vinderei",
          state_id: "2975",
        },
        {
          id: "35951",
          name: "Voinesti",
          state_id: "2975",
        },
        {
          id: "35952",
          name: "Vulturesti",
          state_id: "2975",
        },
        {
          id: "35953",
          name: "Vutcani",
          state_id: "2975",
        },
        {
          id: "35954",
          name: "Zapodeni",
          state_id: "2975",
        },
        {
          id: "35955",
          name: "Zorleni",
          state_id: "2975",
        },
      ],
      Vrancea: [
        {
          id: "35956",
          name: "Adjud",
          state_id: "2976",
        },
        {
          id: "35957",
          name: "Andreiasu de Jos",
          state_id: "2976",
        },
        {
          id: "35958",
          name: "Balesti",
          state_id: "2976",
        },
        {
          id: "35959",
          name: "Barsesti",
          state_id: "2976",
        },
        {
          id: "35960",
          name: "Boghesti",
          state_id: "2976",
        },
        {
          id: "35961",
          name: "Bolotesti",
          state_id: "2976",
        },
        {
          id: "35962",
          name: "Bordesti",
          state_id: "2976",
        },
        {
          id: "35963",
          name: "Brosteni",
          state_id: "2976",
        },
        {
          id: "35964",
          name: "Campineanca",
          state_id: "2976",
        },
        {
          id: "35965",
          name: "Campuri",
          state_id: "2976",
        },
        {
          id: "35966",
          name: "Carligele",
          state_id: "2976",
        },
        {
          id: "35967",
          name: "Chiojdeni",
          state_id: "2976",
        },
        {
          id: "35968",
          name: "Ciorasti",
          state_id: "2976",
        },
        {
          id: "35969",
          name: "Corbita",
          state_id: "2976",
        },
        {
          id: "35970",
          name: "Cotesti",
          state_id: "2976",
        },
        {
          id: "35971",
          name: "Dumbraveni",
          state_id: "2976",
        },
        {
          id: "35972",
          name: "Dumitresti",
          state_id: "2976",
        },
        {
          id: "35973",
          name: "Fitionesti",
          state_id: "2976",
        },
        {
          id: "35974",
          name: "Focsani",
          state_id: "2976",
        },
        {
          id: "35975",
          name: "Garoafa",
          state_id: "2976",
        },
        {
          id: "35976",
          name: "Golesti",
          state_id: "2976",
        },
        {
          id: "35977",
          name: "Gugesti",
          state_id: "2976",
        },
        {
          id: "35978",
          name: "Gura Calitei",
          state_id: "2976",
        },
        {
          id: "35979",
          name: "Homocea",
          state_id: "2976",
        },
        {
          id: "35980",
          name: "Jaristea",
          state_id: "2976",
        },
        {
          id: "35981",
          name: "Jitia",
          state_id: "2976",
        },
        {
          id: "35982",
          name: "Maicanesti",
          state_id: "2976",
        },
        {
          id: "35983",
          name: "Marasesti",
          state_id: "2976",
        },
        {
          id: "35984",
          name: "Mera",
          state_id: "2976",
        },
        {
          id: "35985",
          name: "Milcovul",
          state_id: "2976",
        },
        {
          id: "35986",
          name: "Movilita",
          state_id: "2976",
        },
        {
          id: "35987",
          name: "Nanesti",
          state_id: "2976",
        },
        {
          id: "35988",
          name: "Naruja",
          state_id: "2976",
        },
        {
          id: "35989",
          name: "Nereju",
          state_id: "2976",
        },
        {
          id: "35990",
          name: "Nistoresti",
          state_id: "2976",
        },
        {
          id: "35991",
          name: "Odobesti",
          state_id: "2976",
        },
        {
          id: "35992",
          name: "Paltin",
          state_id: "2976",
        },
        {
          id: "35993",
          name: "Panciu",
          state_id: "2976",
        },
        {
          id: "35994",
          name: "Paunesti",
          state_id: "2976",
        },
        {
          id: "35995",
          name: "Poiana Cristei",
          state_id: "2976",
        },
        {
          id: "35996",
          name: "Pufesti",
          state_id: "2976",
        },
        {
          id: "35997",
          name: "Racoasa",
          state_id: "2976",
        },
        {
          id: "35998",
          name: "Reghiu",
          state_id: "2976",
        },
        {
          id: "35999",
          name: "Ruginesti",
          state_id: "2976",
        },
        {
          id: "36000",
          name: "Sihlea",
          state_id: "2976",
        },
        {
          id: "36001",
          name: "Slobozia Bradului",
          state_id: "2976",
        },
        {
          id: "36002",
          name: "Slobozia-Ciorasti",
          state_id: "2976",
        },
        {
          id: "36003",
          name: "Soveja",
          state_id: "2976",
        },
        {
          id: "36004",
          name: "Straoane",
          state_id: "2976",
        },
        {
          id: "36005",
          name: "Suraia",
          state_id: "2976",
        },
        {
          id: "36006",
          name: "Tamboesti",
          state_id: "2976",
        },
        {
          id: "36007",
          name: "Tanasoaia",
          state_id: "2976",
        },
        {
          id: "36008",
          name: "Tataranu",
          state_id: "2976",
        },
        {
          id: "36009",
          name: "Tifesti",
          state_id: "2976",
        },
        {
          id: "36010",
          name: "Tulnici",
          state_id: "2976",
        },
        {
          id: "36011",
          name: "Urechesti",
          state_id: "2976",
        },
        {
          id: "36012",
          name: "Valea Sarii",
          state_id: "2976",
        },
        {
          id: "36013",
          name: "Vanatori",
          state_id: "2976",
        },
        {
          id: "36014",
          name: "Vartescoiu",
          state_id: "2976",
        },
        {
          id: "36015",
          name: "Vidra",
          state_id: "2976",
        },
        {
          id: "36016",
          name: "Vintileasca",
          state_id: "2976",
        },
        {
          id: "36017",
          name: "Vizantea",
          state_id: "2976",
        },
        {
          id: "36018",
          name: "Vrancioaia",
          state_id: "2976",
        },
        {
          id: "36019",
          name: "Vulturu",
          state_id: "2976",
        },
      ],
    },
  },
  RS: {
    name: "Serbia",
    native: "Србија",
    phone: "381",
    continent: "EU",
    capital: "Belgrade",
    currency: "RSD",
    languages: ["sr"],
    emoji: "🇷🇸",
    emojiU: "U+1F1F7 U+1F1F8",
    states: {
      "Central Serbia": [],
      "Kosovo and Metohija": [],
      Vojvodina: [],
    },
  },
  RU: {
    name: "Russia",
    native: "Россия",
    phone: "7",
    continent: "EU",
    capital: "Moscow",
    currency: "RUB",
    languages: ["ru"],
    emoji: "🇷🇺",
    emojiU: "U+1F1F7 U+1F1FA",
    states: {
      Adygeja: [
        {
          id: "36020",
          name: "Adygejsk",
          state_id: "2977",
        },
        {
          id: "36021",
          name: "Enem",
          state_id: "2977",
        },
        {
          id: "36022",
          name: "Jablonovskij",
          state_id: "2977",
        },
        {
          id: "36023",
          name: "Kamennomostskij",
          state_id: "2977",
        },
        {
          id: "36024",
          name: "Majkop",
          state_id: "2977",
        },
        {
          id: "36025",
          name: "Tulskij",
          state_id: "2977",
        },
      ],
      Aga: [
        {
          id: "36026",
          name: "Aginskoje",
          state_id: "2978",
        },
      ],
      Alanija: [
        {
          id: "36027",
          name: "Alagir",
          state_id: "2979",
        },
        {
          id: "36028",
          name: "Ardon",
          state_id: "2979",
        },
        {
          id: "36029",
          name: "Beslan",
          state_id: "2979",
        },
        {
          id: "36030",
          name: "Digora",
          state_id: "2979",
        },
        {
          id: "36031",
          name: "Mozdok",
          state_id: "2979",
        },
        {
          id: "36032",
          name: "Vladikavkaz",
          state_id: "2979",
        },
        {
          id: "36033",
          name: "Zavodskoj",
          state_id: "2979",
        },
      ],
      Altaj: [
        {
          id: "36034",
          name: "Alejsk",
          state_id: "2980",
        },
        {
          id: "36035",
          name: "Barnaul",
          state_id: "2980",
        },
        {
          id: "36036",
          name: "Belojarsk",
          state_id: "2980",
        },
        {
          id: "36037",
          name: "Belokuriha",
          state_id: "2980",
        },
        {
          id: "36038",
          name: "Bijsk",
          state_id: "2980",
        },
        {
          id: "36039",
          name: "Blagoveshchenka",
          state_id: "2980",
        },
        {
          id: "36040",
          name: "Gornjak",
          state_id: "2980",
        },
        {
          id: "36041",
          name: "Jarovoe",
          state_id: "2980",
        },
        {
          id: "36042",
          name: "Juzhnyj",
          state_id: "2980",
        },
        {
          id: "36043",
          name: "Kamen-na-Obi",
          state_id: "2980",
        },
        {
          id: "36044",
          name: "Novoaltajsk",
          state_id: "2980",
        },
        {
          id: "36045",
          name: "Novosilikatnyj",
          state_id: "2980",
        },
        {
          id: "36046",
          name: "Rubcovsk",
          state_id: "2980",
        },
        {
          id: "36047",
          name: "Sibirskiy",
          state_id: "2980",
        },
        {
          id: "36048",
          name: "Slavgorod",
          state_id: "2980",
        },
        {
          id: "36049",
          name: "Talmenka",
          state_id: "2980",
        },
        {
          id: "36050",
          name: "Zarinsk",
          state_id: "2980",
        },
        {
          id: "36051",
          name: "Zmeinogorsk",
          state_id: "2980",
        },
      ],
      Amur: [
        {
          id: "36052",
          name: "Arhara",
          state_id: "2981",
        },
        {
          id: "36053",
          name: "Belogorsk",
          state_id: "2981",
        },
        {
          id: "36054",
          name: "Blagoveshchensk",
          state_id: "2981",
        },
        {
          id: "36055",
          name: "Jerofej Pavlovich",
          state_id: "2981",
        },
        {
          id: "36056",
          name: "Magdagachi",
          state_id: "2981",
        },
        {
          id: "36057",
          name: "Novoburejskij",
          state_id: "2981",
        },
        {
          id: "36058",
          name: "Progress",
          state_id: "2981",
        },
        {
          id: "36059",
          name: "Rajchihinsk",
          state_id: "2981",
        },
        {
          id: "36060",
          name: "Seryshevo",
          state_id: "2981",
        },
        {
          id: "36061",
          name: "Shimanovsk",
          state_id: "2981",
        },
        {
          id: "36062",
          name: "Skovorodino",
          state_id: "2981",
        },
        {
          id: "36063",
          name: "Svobodnyj",
          state_id: "2981",
        },
        {
          id: "36064",
          name: "Tynda",
          state_id: "2981",
        },
        {
          id: "36065",
          name: "Urusha",
          state_id: "2981",
        },
        {
          id: "36066",
          name: "Zavitinsk",
          state_id: "2981",
        },
        {
          id: "36067",
          name: "Zeja",
          state_id: "2981",
        },
      ],
      Arhangelsk: [
        {
          id: "36068",
          name: "Arhangelsk",
          state_id: "2982",
        },
        {
          id: "36069",
          name: "Jemca",
          state_id: "2982",
        },
        {
          id: "36070",
          name: "Jercevo",
          state_id: "2982",
        },
        {
          id: "36071",
          name: "Kargopol",
          state_id: "2982",
        },
        {
          id: "36072",
          name: "Konosha",
          state_id: "2982",
        },
        {
          id: "36073",
          name: "Korjazhma",
          state_id: "2982",
        },
        {
          id: "36074",
          name: "Kotlas",
          state_id: "2982",
        },
        {
          id: "36075",
          name: "Kuloj",
          state_id: "2982",
        },
        {
          id: "36076",
          name: "Maloshujka",
          state_id: "2982",
        },
        {
          id: "36077",
          name: "Mirnyj",
          state_id: "2982",
        },
        {
          id: "36078",
          name: "Njandoma",
          state_id: "2982",
        },
        {
          id: "36079",
          name: "Novodvinsk",
          state_id: "2982",
        },
        {
          id: "36080",
          name: "Obozjorskij",
          state_id: "2982",
        },
        {
          id: "36081",
          name: "Oktjabrskij",
          state_id: "2982",
        },
        {
          id: "36082",
          name: "Onega",
          state_id: "2982",
        },
        {
          id: "36083",
          name: "Plesetsk",
          state_id: "2982",
        },
        {
          id: "36084",
          name: "Podjuga",
          state_id: "2982",
        },
        {
          id: "36085",
          name: "Puksoozero",
          state_id: "2982",
        },
        {
          id: "36086",
          name: "Samoded",
          state_id: "2982",
        },
        {
          id: "36087",
          name: "Savinskij",
          state_id: "2982",
        },
        {
          id: "36088",
          name: "Severodvinsk",
          state_id: "2982",
        },
        {
          id: "36089",
          name: "Shenkursk",
          state_id: "2982",
        },
        {
          id: "36090",
          name: "Udimskij",
          state_id: "2982",
        },
        {
          id: "36091",
          name: "Urdoma",
          state_id: "2982",
        },
        {
          id: "36092",
          name: "Velsk",
          state_id: "2982",
        },
        {
          id: "36093",
          name: "Vychegodskij",
          state_id: "2982",
        },
      ],
      Astrahan: [
        {
          id: "36094",
          name: "Ahtubinsk",
          state_id: "2983",
        },
        {
          id: "36095",
          name: "Astrahan",
          state_id: "2983",
        },
        {
          id: "36096",
          name: "Harabali",
          state_id: "2983",
        },
        {
          id: "36097",
          name: "Kamyzjak",
          state_id: "2983",
        },
        {
          id: "36098",
          name: "Kapustin Jar",
          state_id: "2983",
        },
        {
          id: "36099",
          name: "Liman",
          state_id: "2983",
        },
        {
          id: "36100",
          name: "Narimanov",
          state_id: "2983",
        },
        {
          id: "36101",
          name: "Verhnij Baskunchak",
          state_id: "2983",
        },
        {
          id: "36102",
          name: "Volodarskij",
          state_id: "2983",
        },
        {
          id: "36103",
          name: "Znamensk",
          state_id: "2983",
        },
      ],
      Bashkortostan: [
        {
          id: "36104",
          name: "Agidel",
          state_id: "2984",
        },
        {
          id: "36105",
          name: "Bajmak",
          state_id: "2984",
        },
        {
          id: "36106",
          name: "Belebej",
          state_id: "2984",
        },
        {
          id: "36107",
          name: "Beloreck",
          state_id: "2984",
        },
        {
          id: "36108",
          name: "Birsk",
          state_id: "2984",
        },
        {
          id: "36109",
          name: "Blagoveshchensk",
          state_id: "2984",
        },
        {
          id: "36110",
          name: "Chishmy",
          state_id: "2984",
        },
        {
          id: "36111",
          name: "Davlekanovo",
          state_id: "2984",
        },
        {
          id: "36112",
          name: "Djurtjuli",
          state_id: "2984",
        },
        {
          id: "36113",
          name: "Iglino",
          state_id: "2984",
        },
        {
          id: "36114",
          name: "Ishimbaj",
          state_id: "2984",
        },
        {
          id: "36115",
          name: "Janaul",
          state_id: "2984",
        },
        {
          id: "36116",
          name: "Jermolajevo",
          state_id: "2984",
        },
        {
          id: "36117",
          name: "Kandry",
          state_id: "2984",
        },
        {
          id: "36118",
          name: "Krasnousolskij",
          state_id: "2984",
        },
        {
          id: "36119",
          name: "Kumertau",
          state_id: "2984",
        },
        {
          id: "36120",
          name: "Meleuz",
          state_id: "2984",
        },
        {
          id: "36121",
          name: "Mezhgorje",
          state_id: "2984",
        },
        {
          id: "36122",
          name: "Neftekamsk",
          state_id: "2984",
        },
        {
          id: "36123",
          name: "Oktjabrskij",
          state_id: "2984",
        },
        {
          id: "36124",
          name: "Oktyabrsky",
          state_id: "2984",
        },
        {
          id: "36125",
          name: "Prijutovo",
          state_id: "2984",
        },
        {
          id: "36126",
          name: "Rajevskij",
          state_id: "2984",
        },
        {
          id: "36127",
          name: "Salavat",
          state_id: "2984",
        },
        {
          id: "36128",
          name: "Serafimovskij",
          state_id: "2984",
        },
        {
          id: "36129",
          name: "Sibaj",
          state_id: "2984",
        },
        {
          id: "36130",
          name: "Sterlitamak",
          state_id: "2984",
        },
        {
          id: "36131",
          name: "Tujmazy",
          state_id: "2984",
        },
        {
          id: "36132",
          name: "Uchaly",
          state_id: "2984",
        },
        {
          id: "36133",
          name: "Ufa",
          state_id: "2984",
        },
      ],
      Belgorod: [
        {
          id: "36134",
          name: "Aleksejevka",
          state_id: "2985",
        },
        {
          id: "36135",
          name: "Belgorod",
          state_id: "2985",
        },
        {
          id: "36136",
          name: "Borisovka",
          state_id: "2985",
        },
        {
          id: "36137",
          name: "Chernjanka",
          state_id: "2985",
        },
        {
          id: "36138",
          name: "Grajvoron",
          state_id: "2985",
        },
        {
          id: "36139",
          name: "Gubkin",
          state_id: "2985",
        },
        {
          id: "36140",
          name: "Novyj Oskol",
          state_id: "2985",
        },
        {
          id: "36141",
          name: "Rakitnoe",
          state_id: "2985",
        },
        {
          id: "36142",
          name: "Razumnoe",
          state_id: "2985",
        },
        {
          id: "36143",
          name: "Shebekino",
          state_id: "2985",
        },
        {
          id: "36144",
          name: "Staryj Oskol",
          state_id: "2985",
        },
        {
          id: "36145",
          name: "Stroitel",
          state_id: "2985",
        },
        {
          id: "36146",
          name: "Tomarovka",
          state_id: "2985",
        },
        {
          id: "36147",
          name: "Valujki",
          state_id: "2985",
        },
        {
          id: "36148",
          name: "Volokonovka",
          state_id: "2985",
        },
      ],
      Brjansk: [
        {
          id: "36149",
          name: "Belye Berega",
          state_id: "2986",
        },
        {
          id: "36150",
          name: "Brjansk",
          state_id: "2986",
        },
        {
          id: "36151",
          name: "Djatkovo",
          state_id: "2986",
        },
        {
          id: "36152",
          name: "Fokino",
          state_id: "2986",
        },
        {
          id: "36153",
          name: "Karachev",
          state_id: "2986",
        },
        {
          id: "36154",
          name: "Kletnja",
          state_id: "2986",
        },
        {
          id: "36155",
          name: "Klimovo",
          state_id: "2986",
        },
        {
          id: "36156",
          name: "Klincy",
          state_id: "2986",
        },
        {
          id: "36157",
          name: "Lokot",
          state_id: "2986",
        },
        {
          id: "36158",
          name: "Navlja",
          state_id: "2986",
        },
        {
          id: "36159",
          name: "Novozybkov",
          state_id: "2986",
        },
        {
          id: "36160",
          name: "Pochjop",
          state_id: "2986",
        },
        {
          id: "36161",
          name: "Pogar",
          state_id: "2986",
        },
        {
          id: "36163",
          name: "Starodub",
          state_id: "2986",
        },
        {
          id: "36164",
          name: "Surazh",
          state_id: "2986",
        },
        {
          id: "36165",
          name: "Suzjomka",
          state_id: "2986",
        },
        {
          id: "36166",
          name: "Trubchjovsk",
          state_id: "2986",
        },
        {
          id: "36167",
          name: "Unecha",
          state_id: "2986",
        },
        {
          id: "36168",
          name: "Zhukovka",
          state_id: "2986",
        },
      ],
      Burjatija: [
        {
          id: "36169",
          name: "Gusinoozjorsk",
          state_id: "2987",
        },
        {
          id: "36170",
          name: "Kamensk",
          state_id: "2987",
        },
        {
          id: "36171",
          name: "Kjahta",
          state_id: "2987",
        },
        {
          id: "36172",
          name: "Novyj Uojan",
          state_id: "2987",
        },
        {
          id: "36173",
          name: "Onohoj",
          state_id: "2987",
        },
        {
          id: "36174",
          name: "Selenginsk",
          state_id: "2987",
        },
        {
          id: "36175",
          name: "Severobajkalsk",
          state_id: "2987",
        },
        {
          id: "36176",
          name: "Taksimo",
          state_id: "2987",
        },
        {
          id: "36177",
          name: "Ulan-Ude",
          state_id: "2987",
        },
        {
          id: "36178",
          name: "Zakamensk",
          state_id: "2987",
        },
        {
          id: "36179",
          name: "Zarechnyj",
          state_id: "2987",
        },
      ],
      Chechenija: [
        {
          id: "36180",
          name: "Groznyj",
          state_id: "2988",
        },
        {
          id: "36181",
          name: "Gudermes",
          state_id: "2988",
        },
        {
          id: "36182",
          name: "Malgobek",
          state_id: "2988",
        },
        {
          id: "36183",
          name: "Urus-Martan",
          state_id: "2988",
        },
      ],
      Cheljabinsk: [
        {
          id: "36184",
          name: "Asha",
          state_id: "2989",
        },
        {
          id: "36185",
          name: "Bakal",
          state_id: "2989",
        },
        {
          id: "36186",
          name: "Bazhovo",
          state_id: "2989",
        },
        {
          id: "36187",
          name: "Berdjaush",
          state_id: "2989",
        },
        {
          id: "36188",
          name: "Chebarkul",
          state_id: "2989",
        },
        {
          id: "36189",
          name: "Cheljabinsk",
          state_id: "2989",
        },
        {
          id: "36190",
          name: "Chelyabinsk",
          state_id: "2989",
        },
        {
          id: "36191",
          name: "Gornjak",
          state_id: "2989",
        },
        {
          id: "36192",
          name: "Jemanzhelinsk",
          state_id: "2989",
        },
        {
          id: "36193",
          name: "Jurjuzan",
          state_id: "2989",
        },
        {
          id: "36194",
          name: "Juznouralsk",
          state_id: "2989",
        },
        {
          id: "36195",
          name: "Karabash",
          state_id: "2989",
        },
        {
          id: "36196",
          name: "Kartaly",
          state_id: "2989",
        },
        {
          id: "36197",
          name: "Kasli",
          state_id: "2989",
        },
        {
          id: "36198",
          name: "Katav-Ivanovsk",
          state_id: "2989",
        },
        {
          id: "36199",
          name: "Kopejsk",
          state_id: "2989",
        },
        {
          id: "36200",
          name: "Korkino",
          state_id: "2989",
        },
        {
          id: "36201",
          name: "Krasnogorskij",
          state_id: "2989",
        },
        {
          id: "36202",
          name: "Kusa",
          state_id: "2989",
        },
        {
          id: "36203",
          name: "Kyshtym",
          state_id: "2989",
        },
        {
          id: "36204",
          name: "Lokomotivnyj",
          state_id: "2989",
        },
        {
          id: "36205",
          name: "Magnitka",
          state_id: "2989",
        },
        {
          id: "36206",
          name: "Magnitogorsk",
          state_id: "2989",
        },
        {
          id: "36207",
          name: "Miass",
          state_id: "2989",
        },
        {
          id: "36208",
          name: "Minjar",
          state_id: "2989",
        },
        {
          id: "36209",
          name: "Njazepetrovsk",
          state_id: "2989",
        },
        {
          id: "36210",
          name: "Novosineglazovskij",
          state_id: "2989",
        },
        {
          id: "36211",
          name: "Ozjorsk",
          state_id: "2989",
        },
        {
          id: "36212",
          name: "Pervomajskij",
          state_id: "2989",
        },
        {
          id: "36213",
          name: "Plast",
          state_id: "2989",
        },
        {
          id: "36214",
          name: "Roza",
          state_id: "2989",
        },
        {
          id: "36215",
          name: "Satka",
          state_id: "2989",
        },
        {
          id: "36216",
          name: "Sim",
          state_id: "2989",
        },
        {
          id: "36217",
          name: "Snezhinsk",
          state_id: "2989",
        },
        {
          id: "36218",
          name: "Starokamyshinsk",
          state_id: "2989",
        },
        {
          id: "36219",
          name: "Suleja",
          state_id: "2989",
        },
        {
          id: "36220",
          name: "Trjohgornij",
          state_id: "2989",
        },
        {
          id: "36221",
          name: "Troick",
          state_id: "2989",
        },
        {
          id: "36222",
          name: "Ust-Katav",
          state_id: "2989",
        },
        {
          id: "36223",
          name: "Verhneuralsk",
          state_id: "2989",
        },
        {
          id: "36224",
          name: "Verhnij Ufalej",
          state_id: "2989",
        },
        {
          id: "36225",
          name: "Zlatoust",
          state_id: "2989",
        },
      ],
      Chita: [
        {
          id: "36226",
          name: "Atamanovka",
          state_id: "2990",
        },
        {
          id: "36227",
          name: "Balej",
          state_id: "2990",
        },
        {
          id: "36228",
          name: "Borzja",
          state_id: "2990",
        },
        {
          id: "36229",
          name: "Bukachacha",
          state_id: "2990",
        },
        {
          id: "36230",
          name: "Chernyshevsk",
          state_id: "2990",
        },
        {
          id: "36231",
          name: "Chita",
          state_id: "2990",
        },
        {
          id: "36232",
          name: "Darasun",
          state_id: "2990",
        },
        {
          id: "36233",
          name: "Gornyy",
          state_id: "2990",
        },
        {
          id: "36234",
          name: "Hilok",
          state_id: "2990",
        },
        {
          id: "36235",
          name: "Karymskoje",
          state_id: "2990",
        },
        {
          id: "36236",
          name: "Krasnokamensk",
          state_id: "2990",
        },
        {
          id: "36237",
          name: "Mogocha",
          state_id: "2990",
        },
        {
          id: "36238",
          name: "Nerchinsk",
          state_id: "2990",
        },
        {
          id: "36239",
          name: "Novaja Chara",
          state_id: "2990",
        },
        {
          id: "36240",
          name: "Novokruchuninskij",
          state_id: "2990",
        },
        {
          id: "36241",
          name: "Olovjannaja",
          state_id: "2990",
        },
        {
          id: "36242",
          name: "Pervomajskij",
          state_id: "2990",
        },
        {
          id: "36243",
          name: "Petrovsk-Zabajkalskij",
          state_id: "2990",
        },
        {
          id: "36244",
          name: "Sherlovaja Gora",
          state_id: "2990",
        },
        {
          id: "36245",
          name: "Shilka",
          state_id: "2990",
        },
        {
          id: "36246",
          name: "Sretensk",
          state_id: "2990",
        },
        {
          id: "36247",
          name: "Vershino-Darasunskij",
          state_id: "2990",
        },
        {
          id: "36248",
          name: "Zabajkalsk",
          state_id: "2990",
        },
      ],
      Chukotka: [
        {
          id: "36249",
          name: "Anadyr",
          state_id: "2991",
        },
        {
          id: "36250",
          name: "Bilibino",
          state_id: "2991",
        },
        {
          id: "36251",
          name: "Pevek",
          state_id: "2991",
        },
        {
          id: "36252",
          name: "Ugolnyje Kopi",
          state_id: "2991",
        },
      ],
      Chuvashija: [
        {
          id: "36253",
          name: "Alatyr",
          state_id: "2992",
        },
        {
          id: "36254",
          name: "Cheboksary",
          state_id: "2992",
        },
        {
          id: "36255",
          name: "Civilsk",
          state_id: "2992",
        },
        {
          id: "36256",
          name: "Ibresi",
          state_id: "2992",
        },
        {
          id: "36257",
          name: "Jadrin",
          state_id: "2992",
        },
        {
          id: "36258",
          name: "Kanash",
          state_id: "2992",
        },
        {
          id: "36259",
          name: "Kozlovka",
          state_id: "2992",
        },
        {
          id: "36260",
          name: "Kugesy",
          state_id: "2992",
        },
        {
          id: "36261",
          name: "Mariinskij Posad",
          state_id: "2992",
        },
        {
          id: "36262",
          name: "Novocheboksarsk",
          state_id: "2992",
        },
        {
          id: "36263",
          name: "Shumerlja",
          state_id: "2992",
        },
        {
          id: "36264",
          name: "Vurnary",
          state_id: "2992",
        },
      ],
      Dagestan: [
        {
          id: "36265",
          name: "Belidzhi",
          state_id: "2993",
        },
        {
          id: "36266",
          name: "Bujnaksk",
          state_id: "2993",
        },
        {
          id: "36267",
          name: "Dagestanskije Ogni",
          state_id: "2993",
        },
        {
          id: "36268",
          name: "Derbent",
          state_id: "2993",
        },
        {
          id: "36269",
          name: "Hasavjurt",
          state_id: "2993",
        },
        {
          id: "36270",
          name: "Izberbash",
          state_id: "2993",
        },
        {
          id: "36271",
          name: "Juzhno-Suhokumsk",
          state_id: "2993",
        },
        {
          id: "36272",
          name: "Kaspijsk",
          state_id: "2993",
        },
        {
          id: "36273",
          name: "Kiziljurt",
          state_id: "2993",
        },
        {
          id: "36274",
          name: "Kizljar",
          state_id: "2993",
        },
        {
          id: "36275",
          name: "Mahackala",
          state_id: "2993",
        },
      ],
      Evenkija: [
        {
          id: "36276",
          name: "Tura",
          state_id: "2994",
        },
      ],
      "Gorno-Altaj": [
        {
          id: "36277",
          name: "Gorno-Altajsk",
          state_id: "2995",
        },
      ],
      Habarovsk: [
        {
          id: "36278",
          name: "Amursk",
          state_id: "2996",
        },
        {
          id: "36279",
          name: "Bikin",
          state_id: "2996",
        },
        {
          id: "36280",
          name: "Chegdomyn",
          state_id: "2996",
        },
        {
          id: "36281",
          name: "Cherdomyn",
          state_id: "2996",
        },
        {
          id: "36282",
          name: "Habarovsk",
          state_id: "2996",
        },
        {
          id: "36283",
          name: "Hor",
          state_id: "2996",
        },
        {
          id: "36284",
          name: "Jelban",
          state_id: "2996",
        },
        {
          id: "36285",
          name: "Komsomolsk-na-Amure",
          state_id: "2996",
        },
        {
          id: "36286",
          name: "Litovko",
          state_id: "2996",
        },
        {
          id: "36287",
          name: "Nikolajevsk-na-Amure",
          state_id: "2996",
        },
        {
          id: "36288",
          name: "Ohotsk",
          state_id: "2996",
        },
        {
          id: "36289",
          name: "Perejaslavka",
          state_id: "2996",
        },
        {
          id: "36290",
          name: "Solnechnyj",
          state_id: "2996",
        },
        {
          id: "36291",
          name: "Sovetskaja Gavan",
          state_id: "2996",
        },
        {
          id: "36292",
          name: "Uglegorsk",
          state_id: "2996",
        },
        {
          id: "36293",
          name: "Vanino",
          state_id: "2996",
        },
        {
          id: "36294",
          name: "Vjazemskij",
          state_id: "2996",
        },
        {
          id: "36295",
          name: "Zavety Iljicha",
          state_id: "2996",
        },
      ],
      Hakasija: [
        {
          id: "36296",
          name: "Abakan",
          state_id: "2997",
        },
        {
          id: "36297",
          name: "Abaza",
          state_id: "2997",
        },
        {
          id: "36298",
          name: "Cherjomushki",
          state_id: "2997",
        },
        {
          id: "36299",
          name: "Chernogorsk",
          state_id: "2997",
        },
        {
          id: "36300",
          name: "Sajanogorsk",
          state_id: "2997",
        },
        {
          id: "36301",
          name: "Shira",
          state_id: "2997",
        },
        {
          id: "36302",
          name: "Sorsk",
          state_id: "2997",
        },
        {
          id: "36303",
          name: "Ust-Abakan",
          state_id: "2997",
        },
      ],
      "Hanty-Mansija": [
        {
          id: "36304",
          name: "Belojarskij",
          state_id: "2998",
        },
        {
          id: "36305",
          name: "Belyj Jar",
          state_id: "2998",
        },
        {
          id: "36306",
          name: "Fjodorovskij",
          state_id: "2998",
        },
        {
          id: "36307",
          name: "Hanty-Mansijsk",
          state_id: "2998",
        },
        {
          id: "36308",
          name: "Igrim",
          state_id: "2998",
        },
        {
          id: "36309",
          name: "Izluchinsk",
          state_id: "2998",
        },
        {
          id: "36310",
          name: "Jugorsk",
          state_id: "2998",
        },
        {
          id: "36311",
          name: "Kogalym",
          state_id: "2998",
        },
        {
          id: "36312",
          name: "Langepas",
          state_id: "2998",
        },
        {
          id: "36313",
          name: "Ljantor",
          state_id: "2998",
        },
        {
          id: "36314",
          name: "Megion",
          state_id: "2998",
        },
        {
          id: "36315",
          name: "Mezhdurechenskij",
          state_id: "2998",
        },
        {
          id: "36316",
          name: "Neftejugansk",
          state_id: "2998",
        },
        {
          id: "36317",
          name: "Nizhnevartovsk",
          state_id: "2998",
        },
        {
          id: "36318",
          name: "Njagan",
          state_id: "2998",
        },
        {
          id: "36319",
          name: "Novoagansk",
          state_id: "2998",
        },
        {
          id: "36320",
          name: "Pojkovskij",
          state_id: "2998",
        },
        {
          id: "36321",
          name: "Pokachi",
          state_id: "2998",
        },
        {
          id: "36322",
          name: "Raduzhnyj",
          state_id: "2998",
        },
        {
          id: "36323",
          name: "Sovetskij",
          state_id: "2998",
        },
        {
          id: "36324",
          name: "Surgut",
          state_id: "2998",
        },
        {
          id: "36325",
          name: "Uraj",
          state_id: "2998",
        },
      ],
      Ingusetija: [
        {
          id: "36326",
          name: "Karabulak",
          state_id: "2999",
        },
        {
          id: "36327",
          name: "Nazran",
          state_id: "2999",
        },
      ],
      Irkutsk: [
        {
          id: "36328",
          name: "Angarsk",
          state_id: "3000",
        },
        {
          id: "36329",
          name: "Bajkalsk",
          state_id: "3000",
        },
        {
          id: "36330",
          name: "Balagansk",
          state_id: "3000",
        },
        {
          id: "36331",
          name: "Birjusinsk",
          state_id: "3000",
        },
        {
          id: "36332",
          name: "Bodajbo",
          state_id: "3000",
        },
        {
          id: "36333",
          name: "Bratsk",
          state_id: "3000",
        },
        {
          id: "36334",
          name: "Cheremhovo",
          state_id: "3000",
        },
        {
          id: "36335",
          name: "Chunskij",
          state_id: "3000",
        },
        {
          id: "36336",
          name: "Irkutsk",
          state_id: "3000",
        },
        {
          id: "36337",
          name: "Kirensk",
          state_id: "3000",
        },
        {
          id: "36338",
          name: "Kujtun",
          state_id: "3000",
        },
        {
          id: "36339",
          name: "Mihajlovka",
          state_id: "3000",
        },
        {
          id: "36340",
          name: "Nizhneudinsk",
          state_id: "3000",
        },
        {
          id: "36341",
          name: "Novaja Igirma",
          state_id: "3000",
        },
        {
          id: "36342",
          name: "Sajansk",
          state_id: "3000",
        },
        {
          id: "36343",
          name: "Shelehov",
          state_id: "3000",
        },
        {
          id: "36344",
          name: "Sljudjanka",
          state_id: "3000",
        },
        {
          id: "36345",
          name: "Svirsk",
          state_id: "3000",
        },
        {
          id: "36346",
          name: "Tajshet",
          state_id: "3000",
        },
        {
          id: "36347",
          name: "Tulun",
          state_id: "3000",
        },
        {
          id: "36348",
          name: "Usolje-Sibirskoje",
          state_id: "3000",
        },
        {
          id: "36349",
          name: "Ust-Ilimsk",
          state_id: "3000",
        },
        {
          id: "36350",
          name: "Ust-Kut",
          state_id: "3000",
        },
        {
          id: "36351",
          name: "Vihorevka",
          state_id: "3000",
        },
        {
          id: "36352",
          name: "Zalari",
          state_id: "3000",
        },
        {
          id: "36353",
          name: "Zheleznodorozhnyj",
          state_id: "3000",
        },
        {
          id: "36354",
          name: "Zheleznogorsk-Ilimskij",
          state_id: "3000",
        },
        {
          id: "36355",
          name: "Zima",
          state_id: "3000",
        },
      ],
      Ivanovo: [
        {
          id: "36356",
          name: "Furmanov",
          state_id: "3001",
        },
        {
          id: "36357",
          name: "Ivanovo",
          state_id: "3001",
        },
        {
          id: "36358",
          name: "Jurjevec",
          state_id: "3001",
        },
        {
          id: "36359",
          name: "Juzha",
          state_id: "3001",
        },
        {
          id: "36360",
          name: "Kineshma",
          state_id: "3001",
        },
        {
          id: "36361",
          name: "Kohma",
          state_id: "3001",
        },
        {
          id: "36362",
          name: "Komsomolsk",
          state_id: "3001",
        },
        {
          id: "36363",
          name: "Lezhnjovo",
          state_id: "3001",
        },
        {
          id: "36364",
          name: "Navoloki",
          state_id: "3001",
        },
        {
          id: "36365",
          name: "Privolzhsk",
          state_id: "3001",
        },
        {
          id: "36366",
          name: "Puchezh",
          state_id: "3001",
        },
        {
          id: "36367",
          name: "Rodniki",
          state_id: "3001",
        },
        {
          id: "36368",
          name: "Shuja",
          state_id: "3001",
        },
        {
          id: "36369",
          name: "Tejkovo",
          state_id: "3001",
        },
        {
          id: "36370",
          name: "Vichuga",
          state_id: "3001",
        },
      ],
      "Jamalo-Nenets": [
        {
          id: "36371",
          name: "Gubkinskij",
          state_id: "3002",
        },
        {
          id: "36372",
          name: "Korotchajevo",
          state_id: "3002",
        },
        {
          id: "36373",
          name: "Labytnangi",
          state_id: "3002",
        },
        {
          id: "36374",
          name: "Muravlenko",
          state_id: "3002",
        },
        {
          id: "36375",
          name: "Nadym",
          state_id: "3002",
        },
        {
          id: "36376",
          name: "Nojabrsk",
          state_id: "3002",
        },
        {
          id: "36377",
          name: "Novyj Urengoj",
          state_id: "3002",
        },
        {
          id: "36378",
          name: "Pangody",
          state_id: "3002",
        },
        {
          id: "36379",
          name: "Salehard",
          state_id: "3002",
        },
        {
          id: "36380",
          name: "Tarko-Sale",
          state_id: "3002",
        },
        {
          id: "36381",
          name: "Urengoj",
          state_id: "3002",
        },
      ],
      Jaroslavl: [
        {
          id: "36382",
          name: "Danilov",
          state_id: "3003",
        },
        {
          id: "36383",
          name: "Gavrilov-Jam",
          state_id: "3003",
        },
        {
          id: "36384",
          name: "Jaroslavl",
          state_id: "3003",
        },
        {
          id: "36385",
          name: "Pereslavl-Zalesskij",
          state_id: "3003",
        },
        {
          id: "36386",
          name: "Rostov",
          state_id: "3003",
        },
        {
          id: "36387",
          name: "Rybinsk",
          state_id: "3003",
        },
        {
          id: "36388",
          name: "Tutajev",
          state_id: "3003",
        },
        {
          id: "36389",
          name: "Uglich",
          state_id: "3003",
        },
      ],
      Jevrej: [
        {
          id: "36390",
          name: "Birakan",
          state_id: "3004",
        },
        {
          id: "36391",
          name: "Birobidzhan",
          state_id: "3004",
        },
        {
          id: "36392",
          name: "Imeni Telmana",
          state_id: "3004",
        },
        {
          id: "36393",
          name: "Izvestkovyj",
          state_id: "3004",
        },
        {
          id: "36394",
          name: "Londoko",
          state_id: "3004",
        },
        {
          id: "36395",
          name: "Obluchje",
          state_id: "3004",
        },
        {
          id: "36396",
          name: "Teploozjorsk",
          state_id: "3004",
        },
      ],
      "Kabardino-Balkarija": [
        {
          id: "36397",
          name: "Baksan",
          state_id: "3005",
        },
        {
          id: "36398",
          name: "Chegem Pervyj",
          state_id: "3005",
        },
        {
          id: "36399",
          name: "Majskij",
          state_id: "3005",
        },
        {
          id: "36400",
          name: "Nalchik",
          state_id: "3005",
        },
        {
          id: "36401",
          name: "Nartkala",
          state_id: "3005",
        },
        {
          id: "36402",
          name: "Prohladnyj",
          state_id: "3005",
        },
        {
          id: "36403",
          name: "Terek",
          state_id: "3005",
        },
        {
          id: "36404",
          name: "Tyrnyauz",
          state_id: "3005",
        },
      ],
      Kaliningrad: [
        {
          id: "36405",
          name: "Bagrationovsk",
          state_id: "3006",
        },
        {
          id: "36406",
          name: "Baltijsk",
          state_id: "3006",
        },
        {
          id: "36407",
          name: "Chernjahovsk",
          state_id: "3006",
        },
        {
          id: "36408",
          name: "Gurjevsk",
          state_id: "3006",
        },
        {
          id: "36409",
          name: "Gusev",
          state_id: "3006",
        },
        {
          id: "36410",
          name: "Gvardejsk",
          state_id: "3006",
        },
        {
          id: "36411",
          name: "Kaliningrad",
          state_id: "3006",
        },
        {
          id: "36412",
          name: "Mamonovo",
          state_id: "3006",
        },
        {
          id: "36413",
          name: "Neman",
          state_id: "3006",
        },
        {
          id: "36414",
          name: "Nesterov",
          state_id: "3006",
        },
        {
          id: "36415",
          name: "Ozjorsk",
          state_id: "3006",
        },
        {
          id: "36416",
          name: "Pionerskij",
          state_id: "3006",
        },
        {
          id: "36417",
          name: "Sovetsk",
          state_id: "3006",
        },
        {
          id: "36418",
          name: "Svetlogorsk",
          state_id: "3006",
        },
        {
          id: "36419",
          name: "Svetlyj",
          state_id: "3006",
        },
        {
          id: "36420",
          name: "Zeljenogradsk",
          state_id: "3006",
        },
        {
          id: "36421",
          name: "Znamensk",
          state_id: "3006",
        },
      ],
      Kalmykija: [
        {
          id: "36422",
          name: "Elista",
          state_id: "3007",
        },
        {
          id: "36423",
          name: "Gorodovikovsk",
          state_id: "3007",
        },
        {
          id: "36424",
          name: "Lagan",
          state_id: "3007",
        },
      ],
      Kaluga: [
        {
          id: "36425",
          name: "Balabanovo",
          state_id: "3008",
        },
        {
          id: "36426",
          name: "Belousovo",
          state_id: "3008",
        },
        {
          id: "36427",
          name: "Borovsk",
          state_id: "3008",
        },
        {
          id: "36428",
          name: "Jermolino",
          state_id: "3008",
        },
        {
          id: "36429",
          name: "Kaluga",
          state_id: "3008",
        },
        {
          id: "36430",
          name: "Kirov",
          state_id: "3008",
        },
        {
          id: "36431",
          name: "Kondrovo",
          state_id: "3008",
        },
        {
          id: "36432",
          name: "Kozelsk",
          state_id: "3008",
        },
        {
          id: "36433",
          name: "Kremenki",
          state_id: "3008",
        },
        {
          id: "36434",
          name: "Ljudinovo",
          state_id: "3008",
        },
        {
          id: "36435",
          name: "Malojaroslavec",
          state_id: "3008",
        },
        {
          id: "36436",
          name: "Obninsk",
          state_id: "3008",
        },
        {
          id: "36437",
          name: "Sosenskij",
          state_id: "3008",
        },
        {
          id: "36438",
          name: "Suhinichi",
          state_id: "3008",
        },
        {
          id: "36439",
          name: "Tarusa",
          state_id: "3008",
        },
        {
          id: "36440",
          name: "Tovarkovo",
          state_id: "3008",
        },
        {
          id: "36441",
          name: "Zhukov",
          state_id: "3008",
        },
      ],
      Kamchatka: [
        {
          id: "36442",
          name: "Jelizovo",
          state_id: "3009",
        },
        {
          id: "36443",
          name: "Kljuchi",
          state_id: "3009",
        },
        {
          id: "36444",
          name: "Mohovaja",
          state_id: "3009",
        },
        {
          id: "36445",
          name: "Petropavlovsk-Kamchatskij",
          state_id: "3009",
        },
        {
          id: "36446",
          name: "Ust-Kamchatsk",
          state_id: "3009",
        },
        {
          id: "36447",
          name: "Viljuchinsk",
          state_id: "3009",
        },
        {
          id: "36448",
          name: "Vulkannyj",
          state_id: "3009",
        },
      ],
      "Karachaj-Cherkessija": [
        {
          id: "36449",
          name: "Cherkessk",
          state_id: "3010",
        },
        {
          id: "36450",
          name: "Karachajevsk",
          state_id: "3010",
        },
        {
          id: "36451",
          name: "Ust-Dzheguta",
          state_id: "3010",
        },
      ],
      Karelija: [
        {
          id: "36452",
          name: "Belomorsk",
          state_id: "3011",
        },
        {
          id: "36453",
          name: "Kem",
          state_id: "3011",
        },
        {
          id: "36454",
          name: "Kondopoga",
          state_id: "3011",
        },
        {
          id: "36455",
          name: "Kostomuksha",
          state_id: "3011",
        },
        {
          id: "36456",
          name: "Lahdenpohja",
          state_id: "3011",
        },
        {
          id: "36457",
          name: "Medvezhjegorsk",
          state_id: "3011",
        },
        {
          id: "36458",
          name: "Nadvoicy",
          state_id: "3011",
        },
        {
          id: "36459",
          name: "Olonec",
          state_id: "3011",
        },
        {
          id: "36460",
          name: "Petrozavodsk",
          state_id: "3011",
        },
        {
          id: "36461",
          name: "Pitkjaranta",
          state_id: "3011",
        },
        {
          id: "36462",
          name: "Pudozh",
          state_id: "3011",
        },
        {
          id: "36463",
          name: "Segezha",
          state_id: "3011",
        },
        {
          id: "36464",
          name: "Sortavala",
          state_id: "3011",
        },
        {
          id: "36465",
          name: "Suojarvi",
          state_id: "3011",
        },
      ],
      Kemerovo: [
        {
          id: "36466",
          name: "Anzhero-Sudzhensk",
          state_id: "3012",
        },
        {
          id: "36467",
          name: "Bachatskij",
          state_id: "3012",
        },
        {
          id: "36468",
          name: "Belovo",
          state_id: "3012",
        },
        {
          id: "36469",
          name: "Berjozovskij",
          state_id: "3012",
        },
        {
          id: "36470",
          name: "Gramoteino",
          state_id: "3012",
        },
        {
          id: "36471",
          name: "Gurjevsk",
          state_id: "3012",
        },
        {
          id: "36472",
          name: "Inskoj",
          state_id: "3012",
        },
        {
          id: "36473",
          name: "Jashkino",
          state_id: "3012",
        },
        {
          id: "36474",
          name: "Jurga",
          state_id: "3012",
        },
        {
          id: "36475",
          name: "Kaltan",
          state_id: "3012",
        },
        {
          id: "36476",
          name: "Kedrovka",
          state_id: "3012",
        },
        {
          id: "36477",
          name: "Kemerovo",
          state_id: "3012",
        },
        {
          id: "36478",
          name: "Kiseljovsk",
          state_id: "3012",
        },
        {
          id: "36479",
          name: "Krasnobrodskij",
          state_id: "3012",
        },
        {
          id: "36480",
          name: "Leninsk-Kuzneckij",
          state_id: "3012",
        },
        {
          id: "36481",
          name: "Malinovka",
          state_id: "3012",
        },
        {
          id: "36482",
          name: "Mariinsk",
          state_id: "3012",
        },
        {
          id: "36483",
          name: "Mezhdurechensk",
          state_id: "3012",
        },
        {
          id: "36484",
          name: "Myski",
          state_id: "3012",
        },
        {
          id: "36485",
          name: "Novokuzneck",
          state_id: "3012",
        },
        {
          id: "36486",
          name: "Novokuznetsk",
          state_id: "3012",
        },
        {
          id: "36487",
          name: "Novyj Gorodok",
          state_id: "3012",
        },
        {
          id: "36488",
          name: "Osinniki",
          state_id: "3012",
        },
        {
          id: "36489",
          name: "Polsaevo",
          state_id: "3012",
        },
        {
          id: "36490",
          name: "Prokopjevsk",
          state_id: "3012",
        },
        {
          id: "36491",
          name: "Promyshlennaja",
          state_id: "3012",
        },
        {
          id: "36492",
          name: "Promyshlennovskij",
          state_id: "3012",
        },
        {
          id: "36493",
          name: "Salair",
          state_id: "3012",
        },
        {
          id: "36494",
          name: "Starobachaty",
          state_id: "3012",
        },
        {
          id: "36495",
          name: "Tajga",
          state_id: "3012",
        },
        {
          id: "36496",
          name: "Tajzhina",
          state_id: "3012",
        },
        {
          id: "36497",
          name: "Tashtagol",
          state_id: "3012",
        },
        {
          id: "36498",
          name: "Temirtau",
          state_id: "3012",
        },
        {
          id: "36499",
          name: "Tisul",
          state_id: "3012",
        },
        {
          id: "36500",
          name: "Tjazhinskij",
          state_id: "3012",
        },
        {
          id: "36501",
          name: "Topki",
          state_id: "3012",
        },
      ],
      "Khabarovskiy Kray": [],
      Kirov: [
        {
          id: "36502",
          name: "Belaja Holunica",
          state_id: "3014",
        },
        {
          id: "36503",
          name: "Jaransk",
          state_id: "3014",
        },
        {
          id: "36504",
          name: "Jurja",
          state_id: "3014",
        },
        {
          id: "36505",
          name: "Kirov",
          state_id: "3014",
        },
        {
          id: "36506",
          name: "Kirovo-Chepeck",
          state_id: "3014",
        },
        {
          id: "36507",
          name: "Kirs",
          state_id: "3014",
        },
        {
          id: "36508",
          name: "Kotelnich",
          state_id: "3014",
        },
        {
          id: "36509",
          name: "Ljangasovo",
          state_id: "3014",
        },
        {
          id: "36510",
          name: "Luza",
          state_id: "3014",
        },
        {
          id: "36511",
          name: "Malmyzh",
          state_id: "3014",
        },
        {
          id: "36512",
          name: "Murashi",
          state_id: "3014",
        },
        {
          id: "36513",
          name: "Nolinsk",
          state_id: "3014",
        },
        {
          id: "36514",
          name: "Omutninsk",
          state_id: "3014",
        },
        {
          id: "36515",
          name: "Orichi",
          state_id: "3014",
        },
        {
          id: "36516",
          name: "Orlov",
          state_id: "3014",
        },
        {
          id: "36517",
          name: "Pervomajskij",
          state_id: "3014",
        },
        {
          id: "36518",
          name: "Peskovka",
          state_id: "3014",
        },
        {
          id: "36519",
          name: "Slobodskoj",
          state_id: "3014",
        },
        {
          id: "36520",
          name: "Sosnovka",
          state_id: "3014",
        },
        {
          id: "36521",
          name: "Sovetsk",
          state_id: "3014",
        },
        {
          id: "36522",
          name: "Urzhum",
          state_id: "3014",
        },
        {
          id: "36523",
          name: "Vahrushi",
          state_id: "3014",
        },
        {
          id: "36524",
          name: "Vjatskije Poljany",
          state_id: "3014",
        },
        {
          id: "36525",
          name: "Zujevka",
          state_id: "3014",
        },
      ],
      Komi: [
        {
          id: "36526",
          name: "Blagoevo",
          state_id: "3015",
        },
        {
          id: "36527",
          name: "Inta",
          state_id: "3015",
        },
        {
          id: "36528",
          name: "Jarega",
          state_id: "3015",
        },
        {
          id: "36529",
          name: "Jeletskij",
          state_id: "3015",
        },
        {
          id: "36530",
          name: "Jemva",
          state_id: "3015",
        },
        {
          id: "36531",
          name: "Komsomolskij",
          state_id: "3015",
        },
        {
          id: "36532",
          name: "Krasnozatonskij",
          state_id: "3015",
        },
        {
          id: "36533",
          name: "Mikun",
          state_id: "3015",
        },
        {
          id: "36534",
          name: "Nizhnij Odes",
          state_id: "3015",
        },
        {
          id: "36535",
          name: "Pechora",
          state_id: "3015",
        },
        {
          id: "36536",
          name: "Promyshlennyj",
          state_id: "3015",
        },
        {
          id: "36537",
          name: "Severnyj",
          state_id: "3015",
        },
        {
          id: "36538",
          name: "Sosnogorsk",
          state_id: "3015",
        },
        {
          id: "36539",
          name: "Syktyvkar",
          state_id: "3015",
        },
        {
          id: "36540",
          name: "Troicko-Pechorsk",
          state_id: "3015",
        },
        {
          id: "36541",
          name: "Uhta",
          state_id: "3015",
        },
        {
          id: "36542",
          name: "Usinsk",
          state_id: "3015",
        },
        {
          id: "36543",
          name: "Usogorsk",
          state_id: "3015",
        },
        {
          id: "36544",
          name: "Vorgashor",
          state_id: "3015",
        },
        {
          id: "36545",
          name: "Vorkuta",
          state_id: "3015",
        },
        {
          id: "36546",
          name: "Vuktyl",
          state_id: "3015",
        },
        {
          id: "36547",
          name: "Zheshart",
          state_id: "3015",
        },
      ],
      "Komi-Permjakija": [
        {
          id: "36548",
          name: "Kudymkar",
          state_id: "3016",
        },
      ],
      Korjakija: [
        {
          id: "36549",
          name: "Palana",
          state_id: "3017",
        },
      ],
      Kostroma: [
        {
          id: "36550",
          name: "Buj",
          state_id: "3018",
        },
        {
          id: "36551",
          name: "Galich",
          state_id: "3018",
        },
        {
          id: "36552",
          name: "Kostroma",
          state_id: "3018",
        },
        {
          id: "36553",
          name: "Makarjev",
          state_id: "3018",
        },
        {
          id: "36554",
          name: "Manturovo",
          state_id: "3018",
        },
        {
          id: "36555",
          name: "Neja",
          state_id: "3018",
        },
        {
          id: "36556",
          name: "Nerehta",
          state_id: "3018",
        },
        {
          id: "36557",
          name: "Sharja",
          state_id: "3018",
        },
        {
          id: "36558",
          name: "Vetluzhskij",
          state_id: "3018",
        },
        {
          id: "36559",
          name: "Volgorechensk",
          state_id: "3018",
        },
        {
          id: "36560",
          name: "Zavolzhsk",
          state_id: "3018",
        },
      ],
      Krasnodar: [
        {
          id: "36561",
          name: "Abinsk",
          state_id: "3019",
        },
        {
          id: "36562",
          name: "Achujevo",
          state_id: "3019",
        },
        {
          id: "36563",
          name: "Afipskij",
          state_id: "3019",
        },
        {
          id: "36564",
          name: "Ahtyrskij",
          state_id: "3019",
        },
        {
          id: "36565",
          name: "Anapa",
          state_id: "3019",
        },
        {
          id: "36566",
          name: "Apsheronsk",
          state_id: "3019",
        },
        {
          id: "36567",
          name: "Armavir",
          state_id: "3019",
        },
        {
          id: "36568",
          name: "Belorechensk",
          state_id: "3019",
        },
        {
          id: "36569",
          name: "Gelendzhik",
          state_id: "3019",
        },
        {
          id: "36570",
          name: "Gorjachi Kljuch",
          state_id: "3019",
        },
        {
          id: "36571",
          name: "Gulkevichi",
          state_id: "3019",
        },
        {
          id: "36572",
          name: "Hadyzhensk",
          state_id: "3019",
        },
        {
          id: "36573",
          name: "Ilskij",
          state_id: "3019",
        },
        {
          id: "36574",
          name: "Jejsk",
          state_id: "3019",
        },
        {
          id: "36575",
          name: "Kalinino",
          state_id: "3019",
        },
        {
          id: "36576",
          name: "Korenovsk",
          state_id: "3019",
        },
        {
          id: "36577",
          name: "Krasnodar",
          state_id: "3019",
        },
        {
          id: "36578",
          name: "Kropotkin",
          state_id: "3019",
        },
        {
          id: "36579",
          name: "Krymsk",
          state_id: "3019",
        },
        {
          id: "36580",
          name: "Kurganinsk",
          state_id: "3019",
        },
        {
          id: "36581",
          name: "Labinsk",
          state_id: "3019",
        },
        {
          id: "36582",
          name: "Mostovskoj",
          state_id: "3019",
        },
        {
          id: "36583",
          name: "Neftegorsk",
          state_id: "3019",
        },
        {
          id: "36584",
          name: "Novokubansk",
          state_id: "3019",
        },
        {
          id: "36585",
          name: "Novomihajlovskij",
          state_id: "3019",
        },
        {
          id: "36586",
          name: "Novorossijsk",
          state_id: "3019",
        },
        {
          id: "36587",
          name: "Pashkovskij",
          state_id: "3019",
        },
        {
          id: "36588",
          name: "Primorsko-Ahtarsk",
          state_id: "3019",
        },
        {
          id: "36589",
          name: "Psebaj",
          state_id: "3019",
        },
        {
          id: "36590",
          name: "Slavjansk-na-Kubani",
          state_id: "3019",
        },
        {
          id: "36591",
          name: "Sochi",
          state_id: "3019",
        },
        {
          id: "36592",
          name: "Srednjaja Ahtuba",
          state_id: "3019",
        },
        {
          id: "36593",
          name: "Temrjuk",
          state_id: "3019",
        },
        {
          id: "36594",
          name: "Tihoreck",
          state_id: "3019",
        },
        {
          id: "36595",
          name: "Timashevsk",
          state_id: "3019",
        },
        {
          id: "36596",
          name: "Tuapse",
          state_id: "3019",
        },
        {
          id: "36597",
          name: "Ust-Labinsk",
          state_id: "3019",
        },
      ],
      Krasnojarsk: [
        {
          id: "36598",
          name: "Aban",
          state_id: "3020",
        },
        {
          id: "36599",
          name: "Achinsk",
          state_id: "3020",
        },
        {
          id: "36600",
          name: "Artjomovsk",
          state_id: "3020",
        },
        {
          id: "36601",
          name: "Berjozovka",
          state_id: "3020",
        },
        {
          id: "36602",
          name: "Bogotol",
          state_id: "3020",
        },
        {
          id: "36603",
          name: "Borodino",
          state_id: "3020",
        },
        {
          id: "36604",
          name: "Divnogorsk",
          state_id: "3020",
        },
        {
          id: "36605",
          name: "Dubinino",
          state_id: "3020",
        },
        {
          id: "36606",
          name: "Igarka",
          state_id: "3020",
        },
        {
          id: "36607",
          name: "Ilanskij",
          state_id: "3020",
        },
        {
          id: "36608",
          name: "Jemeljanovo",
          state_id: "3020",
        },
        {
          id: "36609",
          name: "Jenisejsk",
          state_id: "3020",
        },
        {
          id: "36610",
          name: "Kajerkan",
          state_id: "3020",
        },
        {
          id: "36611",
          name: "Kansk",
          state_id: "3020",
        },
        {
          id: "36612",
          name: "Kedrovyj",
          state_id: "3020",
        },
        {
          id: "36613",
          name: "Kodinsk",
          state_id: "3020",
        },
        {
          id: "36614",
          name: "Krasnojarsk",
          state_id: "3020",
        },
        {
          id: "36615",
          name: "Kuragino",
          state_id: "3020",
        },
        {
          id: "36616",
          name: "Lesosibirsk",
          state_id: "3020",
        },
        {
          id: "36617",
          name: "Minusinsk",
          state_id: "3020",
        },
        {
          id: "36618",
          name: "Nazarovo",
          state_id: "3020",
        },
        {
          id: "36619",
          name: "Nizhnjaja Pojma",
          state_id: "3020",
        },
        {
          id: "36620",
          name: "Norilsk",
          state_id: "3020",
        },
        {
          id: "36621",
          name: "Podgornyj",
          state_id: "3020",
        },
        {
          id: "36622",
          name: "Sharypovo",
          state_id: "3020",
        },
        {
          id: "36623",
          name: "Shushenskoe",
          state_id: "3020",
        },
        {
          id: "36624",
          name: "Solnechnyj",
          state_id: "3020",
        },
        {
          id: "36625",
          name: "Sosnovoborsk",
          state_id: "3020",
        },
        {
          id: "36626",
          name: "Talnah",
          state_id: "3020",
        },
        {
          id: "36627",
          name: "Ujar",
          state_id: "3020",
        },
        {
          id: "36628",
          name: "Uzhur",
          state_id: "3020",
        },
        {
          id: "36629",
          name: "Zaozjornyj",
          state_id: "3020",
        },
        {
          id: "36630",
          name: "Zelenogorsk",
          state_id: "3020",
        },
        {
          id: "36631",
          name: "Zheleznogorsk",
          state_id: "3020",
        },
      ],
      "Krasnoyarskiy Kray": [],
      Kurgan: [
        {
          id: "36632",
          name: "Dalmatovo",
          state_id: "3022",
        },
        {
          id: "36633",
          name: "Kargapolje",
          state_id: "3022",
        },
        {
          id: "36634",
          name: "Katajsk",
          state_id: "3022",
        },
        {
          id: "36635",
          name: "Kurgan",
          state_id: "3022",
        },
        {
          id: "36636",
          name: "Kurtamysh",
          state_id: "3022",
        },
        {
          id: "36637",
          name: "Makushino",
          state_id: "3022",
        },
        {
          id: "36638",
          name: "Petuhovo",
          state_id: "3022",
        },
        {
          id: "36639",
          name: "Shadrinsk",
          state_id: "3022",
        },
        {
          id: "36640",
          name: "Shumiha",
          state_id: "3022",
        },
        {
          id: "36641",
          name: "Vargashi",
          state_id: "3022",
        },
      ],
      Kursk: [
        {
          id: "36642",
          name: "Dmitriev Lgovskij",
          state_id: "3023",
        },
        {
          id: "36643",
          name: "Imeni Karla Libknehta",
          state_id: "3023",
        },
        {
          id: "36644",
          name: "Kurchatov",
          state_id: "3023",
        },
        {
          id: "36645",
          name: "Kursk",
          state_id: "3023",
        },
        {
          id: "36646",
          name: "Lgov",
          state_id: "3023",
        },
        {
          id: "36647",
          name: "Obojan",
          state_id: "3023",
        },
        {
          id: "36648",
          name: "Rylsk",
          state_id: "3023",
        },
        {
          id: "36649",
          name: "Shchigry",
          state_id: "3023",
        },
        {
          id: "36650",
          name: "Shchuchje",
          state_id: "3023",
        },
        {
          id: "36651",
          name: "Sudzha",
          state_id: "3023",
        },
        {
          id: "36652",
          name: "Zheleznogorsk",
          state_id: "3023",
        },
      ],
      Leningrad: [
        {
          id: "36653",
          name: "Boksitogorsk",
          state_id: "3024",
        },
        {
          id: "36654",
          name: "Dubrovka",
          state_id: "3024",
        },
        {
          id: "36655",
          name: "Gatchina",
          state_id: "3024",
        },
        {
          id: "36656",
          name: "Imeni Morozova",
          state_id: "3024",
        },
        {
          id: "36657",
          name: "Ivangorod",
          state_id: "3024",
        },
        {
          id: "36658",
          name: "Kingisepp",
          state_id: "3024",
        },
        {
          id: "36659",
          name: "Kirishi",
          state_id: "3024",
        },
        {
          id: "36660",
          name: "Kirovsk",
          state_id: "3024",
        },
        {
          id: "36661",
          name: "Kolpino",
          state_id: "3024",
        },
        {
          id: "36662",
          name: "Kommunar",
          state_id: "3024",
        },
        {
          id: "36663",
          name: "Kuzmolovskiy",
          state_id: "3024",
        },
        {
          id: "36664",
          name: "Lodejnoje Pole",
          state_id: "3024",
        },
        {
          id: "36665",
          name: "Luga",
          state_id: "3024",
        },
        {
          id: "36666",
          name: "Nikolskoe",
          state_id: "3024",
        },
        {
          id: "36667",
          name: "Novaja Ladoga",
          state_id: "3024",
        },
        {
          id: "36668",
          name: "Otradnoe",
          state_id: "3024",
        },
        {
          id: "36669",
          name: "Pikaljovo",
          state_id: "3024",
        },
        {
          id: "36670",
          name: "Podporozhje",
          state_id: "3024",
        },
        {
          id: "36671",
          name: "Priozjorsk",
          state_id: "3024",
        },
        {
          id: "36672",
          name: "Sertolovo",
          state_id: "3024",
        },
        {
          id: "36673",
          name: "Shlisselburg",
          state_id: "3024",
        },
        {
          id: "36674",
          name: "Siverskij",
          state_id: "3024",
        },
        {
          id: "36675",
          name: "Sjasstroj",
          state_id: "3024",
        },
        {
          id: "36676",
          name: "Slancy",
          state_id: "3024",
        },
        {
          id: "36677",
          name: "Sosnovyj Bor",
          state_id: "3024",
        },
        {
          id: "36678",
          name: "Svetogorsk",
          state_id: "3024",
        },
        {
          id: "36679",
          name: "Tihvin",
          state_id: "3024",
        },
        {
          id: "36680",
          name: "Tosno",
          state_id: "3024",
        },
        {
          id: "36681",
          name: "Uljanovka",
          state_id: "3024",
        },
        {
          id: "36682",
          name: "Volhov",
          state_id: "3024",
        },
        {
          id: "36683",
          name: "Volosovo",
          state_id: "3024",
        },
        {
          id: "36684",
          name: "Vsevolozhsk",
          state_id: "3024",
        },
        {
          id: "36685",
          name: "Vyborg",
          state_id: "3024",
        },
        {
          id: "36686",
          name: "Vyrica",
          state_id: "3024",
        },
        {
          id: "36687",
          name: "Zarskoje Selo",
          state_id: "3024",
        },
      ],
      Lipeck: [
        {
          id: "36688",
          name: "Chaplygin",
          state_id: "3025",
        },
        {
          id: "36689",
          name: "Dankov",
          state_id: "3025",
        },
        {
          id: "36690",
          name: "Dobrinka",
          state_id: "3025",
        },
        {
          id: "36691",
          name: "Grjazi",
          state_id: "3025",
        },
        {
          id: "36692",
          name: "Jelec",
          state_id: "3025",
        },
        {
          id: "36693",
          name: "Lebedjan",
          state_id: "3025",
        },
        {
          id: "36694",
          name: "Lipeck",
          state_id: "3025",
        },
        {
          id: "36695",
          name: "Usman",
          state_id: "3025",
        },
        {
          id: "36696",
          name: "Zadonsk",
          state_id: "3025",
        },
      ],
      Magadan: [
        {
          id: "36697",
          name: "Jagodnoje",
          state_id: "3026",
        },
        {
          id: "36698",
          name: "Magadan",
          state_id: "3026",
        },
        {
          id: "36699",
          name: "Ola",
          state_id: "3026",
        },
        {
          id: "36700",
          name: "Omsukchan",
          state_id: "3026",
        },
        {
          id: "36701",
          name: "Palatka",
          state_id: "3026",
        },
        {
          id: "36702",
          name: "Sinegorje",
          state_id: "3026",
        },
        {
          id: "36703",
          name: "Susuman",
          state_id: "3026",
        },
        {
          id: "36704",
          name: "Ust-Omchug",
          state_id: "3026",
        },
      ],
      "Marij El": [],
      Mordovija: [
        {
          id: "36705",
          name: "Ardatov",
          state_id: "3028",
        },
        {
          id: "36706",
          name: "Chamzinka",
          state_id: "3028",
        },
        {
          id: "36707",
          name: "Insar",
          state_id: "3028",
        },
        {
          id: "36708",
          name: "Komsomolskij",
          state_id: "3028",
        },
        {
          id: "36709",
          name: "Kovylkino",
          state_id: "3028",
        },
        {
          id: "36710",
          name: "Krasnoslobodsk",
          state_id: "3028",
        },
        {
          id: "36711",
          name: "Luhovka",
          state_id: "3028",
        },
        {
          id: "36712",
          name: "Romodanovo",
          state_id: "3028",
        },
        {
          id: "36713",
          name: "Ruzajevka",
          state_id: "3028",
        },
        {
          id: "36714",
          name: "Saransk",
          state_id: "3028",
        },
        {
          id: "36715",
          name: "Temnikov",
          state_id: "3028",
        },
        {
          id: "36716",
          name: "Torbeevo",
          state_id: "3028",
        },
        {
          id: "36717",
          name: "Zubova Poljana",
          state_id: "3028",
        },
      ],
      Moscow: [
        {
          id: "36718",
          name: "Moscow",
          state_id: "3029",
        },
      ],
      "Moskovskaja Oblast": [],
      "Moskovskaya Oblast": [],
      Moskva: [
        {
          id: "36719",
          name: "Moskva",
          state_id: "3032",
        },
        {
          id: "36720",
          name: "Vostochnyj",
          state_id: "3032",
        },
        {
          id: "36721",
          name: "Zeljenograd",
          state_id: "3032",
        },
      ],
      Murmansk: [
        {
          id: "36722",
          name: "Apatity",
          state_id: "3033",
        },
        {
          id: "36723",
          name: "Gadzhievo",
          state_id: "3033",
        },
        {
          id: "36724",
          name: "Kandalaksha",
          state_id: "3033",
        },
        {
          id: "36725",
          name: "Kirovsk",
          state_id: "3033",
        },
        {
          id: "36726",
          name: "Kola",
          state_id: "3033",
        },
        {
          id: "36727",
          name: "Kovdor",
          state_id: "3033",
        },
        {
          id: "36728",
          name: "Monchegorsk",
          state_id: "3033",
        },
        {
          id: "36729",
          name: "Murmansk",
          state_id: "3033",
        },
        {
          id: "36730",
          name: "Murmashi",
          state_id: "3033",
        },
        {
          id: "36731",
          name: "Nikel",
          state_id: "3033",
        },
        {
          id: "36732",
          name: "Olenegorsk",
          state_id: "3033",
        },
        {
          id: "36733",
          name: "Ostrovnoj",
          state_id: "3033",
        },
        {
          id: "36734",
          name: "Poljarnye Zory",
          state_id: "3033",
        },
        {
          id: "36735",
          name: "Poljarnyj",
          state_id: "3033",
        },
        {
          id: "36736",
          name: "Revda",
          state_id: "3033",
        },
        {
          id: "36737",
          name: "Severomorsk",
          state_id: "3033",
        },
        {
          id: "36738",
          name: "Snezhnogorsk",
          state_id: "3033",
        },
        {
          id: "36739",
          name: "Zaozjorsk",
          state_id: "3033",
        },
        {
          id: "36740",
          name: "Zapoljarnyj",
          state_id: "3033",
        },
        {
          id: "36741",
          name: "Zeljenoborskij",
          state_id: "3033",
        },
      ],
      Nenets: [
        {
          id: "36742",
          name: "Narjan-Mar",
          state_id: "3034",
        },
      ],
      "Nizhnij Novgorod": [],
      Novgorod: [
        {
          id: "36743",
          name: "Borovichi",
          state_id: "3036",
        },
        {
          id: "36744",
          name: "Chudovo",
          state_id: "3036",
        },
        {
          id: "36745",
          name: "Krestcy",
          state_id: "3036",
        },
        {
          id: "36746",
          name: "Malaja Vishera",
          state_id: "3036",
        },
        {
          id: "36747",
          name: "Okulovka",
          state_id: "3036",
        },
        {
          id: "36748",
          name: "Pestovo",
          state_id: "3036",
        },
        {
          id: "36749",
          name: "Proletarij",
          state_id: "3036",
        },
        {
          id: "36750",
          name: "Solcy",
          state_id: "3036",
        },
        {
          id: "36751",
          name: "Staraja Russa",
          state_id: "3036",
        },
        {
          id: "36752",
          name: "Uglovka",
          state_id: "3036",
        },
        {
          id: "36753",
          name: "Valdaj",
          state_id: "3036",
        },
        {
          id: "36754",
          name: "Velikij Novgorod",
          state_id: "3036",
        },
      ],
      Novokusnezk: [
        {
          id: "36755",
          name: "Novokusnezk",
          state_id: "3037",
        },
      ],
      Novosibirsk: [
        {
          id: "36756",
          name: "Barabinsk",
          state_id: "3038",
        },
        {
          id: "36757",
          name: "Berdsk",
          state_id: "3038",
        },
        {
          id: "36758",
          name: "Bolotnoe",
          state_id: "3038",
        },
        {
          id: "36759",
          name: "Chany",
          state_id: "3038",
        },
        {
          id: "36760",
          name: "Cherepanovo",
          state_id: "3038",
        },
        {
          id: "36761",
          name: "Chulym",
          state_id: "3038",
        },
        {
          id: "36762",
          name: "Iskitim",
          state_id: "3038",
        },
        {
          id: "36763",
          name: "Karasuk",
          state_id: "3038",
        },
        {
          id: "36764",
          name: "Kargat",
          state_id: "3038",
        },
        {
          id: "36765",
          name: "Kochenjovo",
          state_id: "3038",
        },
        {
          id: "36766",
          name: "Kolcovo",
          state_id: "3038",
        },
        {
          id: "36767",
          name: "Kolyvan",
          state_id: "3038",
        },
        {
          id: "36768",
          name: "Krasnoobsk",
          state_id: "3038",
        },
        {
          id: "36769",
          name: "Krasnozerskoe",
          state_id: "3038",
        },
        {
          id: "36770",
          name: "Kujbyshev",
          state_id: "3038",
        },
        {
          id: "36771",
          name: "Kupino",
          state_id: "3038",
        },
        {
          id: "36772",
          name: "Linjovo",
          state_id: "3038",
        },
        {
          id: "36773",
          name: "Masljanino",
          state_id: "3038",
        },
        {
          id: "36774",
          name: "Novosibirsk",
          state_id: "3038",
        },
        {
          id: "36775",
          name: "Ob",
          state_id: "3038",
        },
        {
          id: "36776",
          name: "Suzun",
          state_id: "3038",
        },
        {
          id: "36777",
          name: "Tatarsk",
          state_id: "3038",
        },
        {
          id: "36778",
          name: "Toguchin",
          state_id: "3038",
        },
      ],
      Omsk: [
        {
          id: "36779",
          name: "Bolsherechje",
          state_id: "3039",
        },
        {
          id: "36780",
          name: "Cherlak",
          state_id: "3039",
        },
        {
          id: "36781",
          name: "Isilkul",
          state_id: "3039",
        },
        {
          id: "36782",
          name: "Kalachinsk",
          state_id: "3039",
        },
        {
          id: "36783",
          name: "Kormilovka",
          state_id: "3039",
        },
        {
          id: "36784",
          name: "Ljubinskij",
          state_id: "3039",
        },
        {
          id: "36785",
          name: "Moskaljoni",
          state_id: "3039",
        },
        {
          id: "36786",
          name: "Muromcevo",
          state_id: "3039",
        },
        {
          id: "36787",
          name: "Nazyvajevsk",
          state_id: "3039",
        },
        {
          id: "36788",
          name: "Omsk",
          state_id: "3039",
        },
        {
          id: "36789",
          name: "Tara",
          state_id: "3039",
        },
        {
          id: "36790",
          name: "Tavricheskoje",
          state_id: "3039",
        },
        {
          id: "36791",
          name: "Tjukalinsk",
          state_id: "3039",
        },
      ],
      Orenburg: [
        {
          id: "36792",
          name: "Abdulino",
          state_id: "3040",
        },
        {
          id: "36793",
          name: "Buguruslan",
          state_id: "3040",
        },
        {
          id: "36794",
          name: "Buzuluk",
          state_id: "3040",
        },
        {
          id: "36795",
          name: "Jasnyj",
          state_id: "3040",
        },
        {
          id: "36796",
          name: "Komarovskiy",
          state_id: "3040",
        },
        {
          id: "36797",
          name: "Kuvandyk",
          state_id: "3040",
        },
        {
          id: "36798",
          name: "Mednogorsk",
          state_id: "3040",
        },
        {
          id: "36799",
          name: "Novotroick",
          state_id: "3040",
        },
        {
          id: "36800",
          name: "Orenburg",
          state_id: "3040",
        },
        {
          id: "36801",
          name: "Orsk",
          state_id: "3040",
        },
        {
          id: "36802",
          name: "Sol-Ileck",
          state_id: "3040",
        },
        {
          id: "36803",
          name: "Sorochinsk",
          state_id: "3040",
        },
      ],
      Orjol: [
        {
          id: "36804",
          name: "Bolhov",
          state_id: "3041",
        },
        {
          id: "36805",
          name: "Gaj",
          state_id: "3041",
        },
        {
          id: "36806",
          name: "Livny",
          state_id: "3041",
        },
        {
          id: "36807",
          name: "Mcensk",
          state_id: "3041",
        },
        {
          id: "36808",
          name: "Orjol",
          state_id: "3041",
        },
        {
          id: "36809",
          name: "Znamenka",
          state_id: "3041",
        },
      ],
      Penza: [
        {
          id: "36810",
          name: "Bashmakovo",
          state_id: "3042",
        },
        {
          id: "36811",
          name: "Bekovo",
          state_id: "3042",
        },
        {
          id: "36812",
          name: "Belinskiy",
          state_id: "3042",
        },
        {
          id: "36813",
          name: "Kamenka",
          state_id: "3042",
        },
        {
          id: "36814",
          name: "Kolyshlej",
          state_id: "3042",
        },
        {
          id: "36815",
          name: "Kuzneck",
          state_id: "3042",
        },
        {
          id: "36816",
          name: "Mokshan",
          state_id: "3042",
        },
        {
          id: "36817",
          name: "Nikolsk",
          state_id: "3042",
        },
        {
          id: "36818",
          name: "Nizhnij Lomov",
          state_id: "3042",
        },
        {
          id: "36819",
          name: "Pachelma",
          state_id: "3042",
        },
        {
          id: "36820",
          name: "Penza",
          state_id: "3042",
        },
        {
          id: "36821",
          name: "Serdobsk",
          state_id: "3042",
        },
        {
          id: "36822",
          name: "Sursk",
          state_id: "3042",
        },
        {
          id: "36823",
          name: "Zarechnyj",
          state_id: "3042",
        },
        {
          id: "36824",
          name: "Zemetchino",
          state_id: "3042",
        },
      ],
      Perm: [
        {
          id: "36825",
          name: "Aleksandrovsk",
          state_id: "3043",
        },
        {
          id: "36826",
          name: "Berezniki",
          state_id: "3043",
        },
        {
          id: "36827",
          name: "Chajkovskij",
          state_id: "3043",
        },
        {
          id: "36828",
          name: "Chermoz",
          state_id: "3043",
        },
        {
          id: "36829",
          name: "Chernushka",
          state_id: "3043",
        },
        {
          id: "36830",
          name: "Chusovoj",
          state_id: "3043",
        },
        {
          id: "36831",
          name: "Dobrjanka",
          state_id: "3043",
        },
        {
          id: "36832",
          name: "Gornozavodsk",
          state_id: "3043",
        },
        {
          id: "36833",
          name: "Gremjachinsk",
          state_id: "3043",
        },
        {
          id: "36834",
          name: "Gubaha",
          state_id: "3043",
        },
        {
          id: "36835",
          name: "Jajva",
          state_id: "3043",
        },
        {
          id: "36836",
          name: "Kizel",
          state_id: "3043",
        },
        {
          id: "36837",
          name: "Komsomolsky",
          state_id: "3043",
        },
        {
          id: "36838",
          name: "Krasnokamsk",
          state_id: "3043",
        },
        {
          id: "36839",
          name: "Krasnovishersk",
          state_id: "3043",
        },
        {
          id: "36840",
          name: "Kungur",
          state_id: "3043",
        },
        {
          id: "36841",
          name: "Lysva",
          state_id: "3043",
        },
        {
          id: "36842",
          name: "Novye Ljady",
          state_id: "3043",
        },
        {
          id: "36843",
          name: "Nytva",
          state_id: "3043",
        },
        {
          id: "36844",
          name: "Ocher",
          state_id: "3043",
        },
        {
          id: "36845",
          name: "Oktjabrskij",
          state_id: "3043",
        },
        {
          id: "36846",
          name: "Osa",
          state_id: "3043",
        },
        {
          id: "36847",
          name: "Pashija",
          state_id: "3043",
        },
        {
          id: "36848",
          name: "Perm",
          state_id: "3043",
        },
        {
          id: "36849",
          name: "Polazna",
          state_id: "3043",
        },
        {
          id: "36850",
          name: "Skalnyj",
          state_id: "3043",
        },
        {
          id: "36851",
          name: "Solikamsk",
          state_id: "3043",
        },
        {
          id: "36852",
          name: "Ugleuralskij",
          state_id: "3043",
        },
        {
          id: "36853",
          name: "Uralskij",
          state_id: "3043",
        },
        {
          id: "36854",
          name: "Usolje",
          state_id: "3043",
        },
        {
          id: "36855",
          name: "Vereshchagino",
          state_id: "3043",
        },
        {
          id: "36856",
          name: "Zvjozdnyj",
          state_id: "3043",
        },
      ],
      Primorje: [
        {
          id: "36857",
          name: "Arsenjev",
          state_id: "3044",
        },
        {
          id: "36858",
          name: "Artjom",
          state_id: "3044",
        },
        {
          id: "36859",
          name: "Artjomovskij",
          state_id: "3044",
        },
        {
          id: "36860",
          name: "Bolshoj Kamen",
          state_id: "3044",
        },
        {
          id: "36861",
          name: "Dalnegorsk",
          state_id: "3044",
        },
        {
          id: "36862",
          name: "Dalnerechensk",
          state_id: "3044",
        },
        {
          id: "36863",
          name: "Dunaj",
          state_id: "3044",
        },
        {
          id: "36864",
          name: "Fokino",
          state_id: "3044",
        },
        {
          id: "36865",
          name: "Jaroslavskij",
          state_id: "3044",
        },
        {
          id: "36866",
          name: "Kavalerovo",
          state_id: "3044",
        },
        {
          id: "36867",
          name: "Kirovskiy",
          state_id: "3044",
        },
        {
          id: "36868",
          name: "Lesozavodsk",
          state_id: "3044",
        },
        {
          id: "36869",
          name: "Lipovcy",
          state_id: "3044",
        },
        {
          id: "36870",
          name: "Livadija",
          state_id: "3044",
        },
        {
          id: "36871",
          name: "Luchegorsk",
          state_id: "3044",
        },
        {
          id: "36872",
          name: "Nahodka",
          state_id: "3044",
        },
        {
          id: "36873",
          name: "Novoshahtinskij",
          state_id: "3044",
        },
        {
          id: "36874",
          name: "Partizansk",
          state_id: "3044",
        },
        {
          id: "36875",
          name: "Pogranichnyj",
          state_id: "3044",
        },
        {
          id: "36876",
          name: "Preobrazhenie",
          state_id: "3044",
        },
        {
          id: "36877",
          name: "Putjatin",
          state_id: "3044",
        },
        {
          id: "36878",
          name: "Sibircevo",
          state_id: "3044",
        },
        {
          id: "36879",
          name: "Slavjanka",
          state_id: "3044",
        },
        {
          id: "36880",
          name: "Spassk-Dalnij",
          state_id: "3044",
        },
        {
          id: "36881",
          name: "Tavrichanka",
          state_id: "3044",
        },
        {
          id: "36882",
          name: "Trudovoe",
          state_id: "3044",
        },
        {
          id: "36883",
          name: "Uglekamensk",
          state_id: "3044",
        },
        {
          id: "36884",
          name: "Uglovoe",
          state_id: "3044",
        },
        {
          id: "36885",
          name: "Ussurijsk",
          state_id: "3044",
        },
        {
          id: "36886",
          name: "Vladivostok",
          state_id: "3044",
        },
        {
          id: "36887",
          name: "Vrangel",
          state_id: "3044",
        },
        {
          id: "36888",
          name: "Zavodskoj",
          state_id: "3044",
        },
      ],
      Pskov: [
        {
          id: "36889",
          name: "Dedovichi",
          state_id: "3045",
        },
        {
          id: "36890",
          name: "Dno",
          state_id: "3045",
        },
        {
          id: "36891",
          name: "Nevel",
          state_id: "3045",
        },
        {
          id: "36892",
          name: "Novosokolniki",
          state_id: "3045",
        },
        {
          id: "36893",
          name: "Opochka",
          state_id: "3045",
        },
        {
          id: "36894",
          name: "Ostrov",
          state_id: "3045",
        },
        {
          id: "36895",
          name: "Pechory",
          state_id: "3045",
        },
        {
          id: "36896",
          name: "Porhov",
          state_id: "3045",
        },
        {
          id: "36897",
          name: "Pskov",
          state_id: "3045",
        },
        {
          id: "36898",
          name: "Sebezh",
          state_id: "3045",
        },
        {
          id: "36899",
          name: "Strugi-Krasnye",
          state_id: "3045",
        },
        {
          id: "36900",
          name: "Velikije Luki",
          state_id: "3045",
        },
      ],
      "Pskovskaya Oblast": [],
      Rjazan: [
        {
          id: "36901",
          name: "Kasimov",
          state_id: "3047",
        },
        {
          id: "36902",
          name: "Korablino",
          state_id: "3047",
        },
        {
          id: "36903",
          name: "Mihajlov",
          state_id: "3047",
        },
        {
          id: "36904",
          name: "Novomichurinsk",
          state_id: "3047",
        },
        {
          id: "36905",
          name: "Rjazan",
          state_id: "3047",
        },
        {
          id: "36906",
          name: "Rjazhsk",
          state_id: "3047",
        },
        {
          id: "36907",
          name: "Rybnoje",
          state_id: "3047",
        },
        {
          id: "36908",
          name: "Sasovo",
          state_id: "3047",
        },
        {
          id: "36909",
          name: "Shilovo",
          state_id: "3047",
        },
        {
          id: "36910",
          name: "Skopin",
          state_id: "3047",
        },
      ],
      Rostov: [
        {
          id: "36911",
          name: "Ajutinskij",
          state_id: "3048",
        },
        {
          id: "36912",
          name: "Aksaj",
          state_id: "3048",
        },
        {
          id: "36913",
          name: "Azov",
          state_id: "3048",
        },
        {
          id: "36914",
          name: "Batajsk",
          state_id: "3048",
        },
        {
          id: "36915",
          name: "Belaja Kalitva",
          state_id: "3048",
        },
        {
          id: "36916",
          name: "Cimljansk",
          state_id: "3048",
        },
        {
          id: "36917",
          name: "Doneck",
          state_id: "3048",
        },
        {
          id: "36918",
          name: "Donskoj",
          state_id: "3048",
        },
        {
          id: "36919",
          name: "Gigant",
          state_id: "3048",
        },
        {
          id: "36920",
          name: "Glubokij",
          state_id: "3048",
        },
        {
          id: "36921",
          name: "Gornjackij",
          state_id: "3048",
        },
        {
          id: "36922",
          name: "Gukovo",
          state_id: "3048",
        },
        {
          id: "36923",
          name: "Kamenolomni",
          state_id: "3048",
        },
        {
          id: "36924",
          name: "Kamensk-Shahtinskij",
          state_id: "3048",
        },
        {
          id: "36925",
          name: "Konstantinovsk",
          state_id: "3048",
        },
        {
          id: "36926",
          name: "Krasnyj Sulin",
          state_id: "3048",
        },
        {
          id: "36927",
          name: "Lihovskoj",
          state_id: "3048",
        },
        {
          id: "36928",
          name: "Majskij",
          state_id: "3048",
        },
        {
          id: "36929",
          name: "Millerovo",
          state_id: "3048",
        },
        {
          id: "36930",
          name: "Morozovsk",
          state_id: "3048",
        },
        {
          id: "36931",
          name: "Novocherkassk",
          state_id: "3048",
        },
        {
          id: "36932",
          name: "Novoshahtinsk",
          state_id: "3048",
        },
        {
          id: "36933",
          name: "Proletarsk",
          state_id: "3048",
        },
        {
          id: "36934",
          name: "Rostov",
          state_id: "3048",
        },
        {
          id: "36935",
          name: "Rostov-na-Donu",
          state_id: "3048",
        },
        {
          id: "36936",
          name: "Salsk",
          state_id: "3048",
        },
        {
          id: "36937",
          name: "Semikarakorsk",
          state_id: "3048",
        },
        {
          id: "36938",
          name: "Shahty",
          state_id: "3048",
        },
        {
          id: "36939",
          name: "Sholohovskij",
          state_id: "3048",
        },
        {
          id: "36940",
          name: "Sinegorskij",
          state_id: "3048",
        },
        {
          id: "36941",
          name: "Sokolovo",
          state_id: "3048",
        },
        {
          id: "36942",
          name: "Taganrog",
          state_id: "3048",
        },
        {
          id: "36943",
          name: "Ust-Doneckij",
          state_id: "3048",
        },
        {
          id: "36944",
          name: "Volgodonsk",
          state_id: "3048",
        },
        {
          id: "36945",
          name: "Zernograd",
          state_id: "3048",
        },
        {
          id: "36946",
          name: "Zhirnov",
          state_id: "3048",
        },
        {
          id: "36947",
          name: "Zverevo",
          state_id: "3048",
        },
      ],
      Saha: [
        {
          id: "36948",
          name: "Ajhan",
          state_id: "3049",
        },
        {
          id: "36949",
          name: "Aldan",
          state_id: "3049",
        },
        {
          id: "36950",
          name: "Cherskij",
          state_id: "3049",
        },
        {
          id: "36951",
          name: "Chulman",
          state_id: "3049",
        },
        {
          id: "36952",
          name: "Deputatskij",
          state_id: "3049",
        },
        {
          id: "36953",
          name: "Jakutsk",
          state_id: "3049",
        },
        {
          id: "36954",
          name: "Lensk",
          state_id: "3049",
        },
        {
          id: "36955",
          name: "Marha",
          state_id: "3049",
        },
        {
          id: "36956",
          name: "Mirnyj",
          state_id: "3049",
        },
        {
          id: "36957",
          name: "Nerjungri",
          state_id: "3049",
        },
        {
          id: "36958",
          name: "Njurba",
          state_id: "3049",
        },
        {
          id: "36959",
          name: "Oljokminsk",
          state_id: "3049",
        },
        {
          id: "36960",
          name: "Pokrovsk",
          state_id: "3049",
        },
        {
          id: "36961",
          name: "Sangar",
          state_id: "3049",
        },
        {
          id: "36962",
          name: "Serebrjanyj Bor",
          state_id: "3049",
        },
        {
          id: "36963",
          name: "Tiksi",
          state_id: "3049",
        },
        {
          id: "36964",
          name: "Tommot",
          state_id: "3049",
        },
        {
          id: "36965",
          name: "Udachnyj",
          state_id: "3049",
        },
        {
          id: "36966",
          name: "Ust-Nera",
          state_id: "3049",
        },
        {
          id: "36967",
          name: "Verhojansk",
          state_id: "3049",
        },
        {
          id: "36968",
          name: "Viljujsk",
          state_id: "3049",
        },
      ],
      Sahalin: [
        {
          id: "36969",
          name: "Aleksandrovsk-Sahalinskij",
          state_id: "3050",
        },
        {
          id: "36970",
          name: "Dolinsk",
          state_id: "3050",
        },
        {
          id: "36971",
          name: "Gornozavodsk",
          state_id: "3050",
        },
        {
          id: "36972",
          name: "Holmsk",
          state_id: "3050",
        },
        {
          id: "36973",
          name: "Juzhno-Sahalinsk",
          state_id: "3050",
        },
        {
          id: "36974",
          name: "Korsakov",
          state_id: "3050",
        },
        {
          id: "36975",
          name: "Makarov",
          state_id: "3050",
        },
        {
          id: "36976",
          name: "Nevelsk",
          state_id: "3050",
        },
        {
          id: "36977",
          name: "Nogliki",
          state_id: "3050",
        },
        {
          id: "36978",
          name: "Oha",
          state_id: "3050",
        },
        {
          id: "36979",
          name: "Poronajsk",
          state_id: "3050",
        },
        {
          id: "36980",
          name: "Shahtjorsk",
          state_id: "3050",
        },
        {
          id: "36981",
          name: "Tymovskoje",
          state_id: "3050",
        },
        {
          id: "36982",
          name: "Uglegorsk",
          state_id: "3050",
        },
      ],
      Samara: [
        {
          id: "36983",
          name: "Aleksejevka",
          state_id: "3051",
        },
        {
          id: "36984",
          name: "Bezenchuk",
          state_id: "3051",
        },
        {
          id: "36985",
          name: "Chapajevsk",
          state_id: "3051",
        },
        {
          id: "36986",
          name: "Fjodorovka",
          state_id: "3051",
        },
        {
          id: "36987",
          name: "Kinel",
          state_id: "3051",
        },
        {
          id: "36988",
          name: "Mirnyj",
          state_id: "3051",
        },
        {
          id: "36989",
          name: "Novokujbyshevsk",
          state_id: "3051",
        },
        {
          id: "36990",
          name: "Novosemejkino",
          state_id: "3051",
        },
        {
          id: "36991",
          name: "Oktjabrsk",
          state_id: "3051",
        },
        {
          id: "36992",
          name: "Otradnyj",
          state_id: "3051",
        },
        {
          id: "36993",
          name: "Pohvistnevo",
          state_id: "3051",
        },
        {
          id: "36994",
          name: "Povolzhskij",
          state_id: "3051",
        },
        {
          id: "36995",
          name: "Pribrezhnyj",
          state_id: "3051",
        },
        {
          id: "36996",
          name: "Roscinskij",
          state_id: "3051",
        },
        {
          id: "36997",
          name: "Samara",
          state_id: "3051",
        },
        {
          id: "36998",
          name: "Smyshljaevka",
          state_id: "3051",
        },
        {
          id: "36999",
          name: "Suhodol",
          state_id: "3051",
        },
        {
          id: "37000",
          name: "Syzran",
          state_id: "3051",
        },
        {
          id: "37001",
          name: "Timashjovo",
          state_id: "3051",
        },
        {
          id: "37002",
          name: "Toljatti",
          state_id: "3051",
        },
        {
          id: "37003",
          name: "Zhigulevsk",
          state_id: "3051",
        },
      ],
      Samarskaya: [
        {
          id: "37004",
          name: "Togliatti",
          state_id: "3052",
        },
      ],
      "Sankt-Peterburg": [
        {
          id: "37005",
          name: "Saint Petersburg",
          state_id: "3053",
        },
        {
          id: "37006",
          name: "Sankt Peterburg",
          state_id: "3053",
        },
      ],
      Saratov: [
        {
          id: "37007",
          name: "Arkadak",
          state_id: "3054",
        },
        {
          id: "37008",
          name: "Atkarsk",
          state_id: "3054",
        },
        {
          id: "37009",
          name: "Balakovo",
          state_id: "3054",
        },
        {
          id: "37010",
          name: "Balashov",
          state_id: "3054",
        },
        {
          id: "37011",
          name: "Bazarnyj Karabulak",
          state_id: "3054",
        },
        {
          id: "37012",
          name: "Dergachi",
          state_id: "3054",
        },
        {
          id: "37013",
          name: "Engels",
          state_id: "3054",
        },
        {
          id: "37014",
          name: "Hvalynsk",
          state_id: "3054",
        },
        {
          id: "37015",
          name: "Jershov",
          state_id: "3054",
        },
        {
          id: "37016",
          name: "Kalininsk",
          state_id: "3054",
        },
        {
          id: "37017",
          name: "Krasnoarmejsk",
          state_id: "3054",
        },
        {
          id: "37018",
          name: "Krasnyj Kut",
          state_id: "3054",
        },
        {
          id: "37019",
          name: "Marks",
          state_id: "3054",
        },
        {
          id: "37020",
          name: "Novouzensk",
          state_id: "3054",
        },
        {
          id: "37021",
          name: "Ozinki",
          state_id: "3054",
        },
        {
          id: "37022",
          name: "Petrovsk",
          state_id: "3054",
        },
        {
          id: "37023",
          name: "Privolzhskij",
          state_id: "3054",
        },
        {
          id: "37024",
          name: "Pugachjov",
          state_id: "3054",
        },
        {
          id: "37025",
          name: "Rtishchevo",
          state_id: "3054",
        },
        {
          id: "37026",
          name: "Saratov",
          state_id: "3054",
        },
        {
          id: "37027",
          name: "Shihany",
          state_id: "3054",
        },
        {
          id: "37028",
          name: "Stepnoe",
          state_id: "3054",
        },
        {
          id: "37029",
          name: "Svetlyj",
          state_id: "3054",
        },
        {
          id: "37030",
          name: "Tatishchevo",
          state_id: "3054",
        },
        {
          id: "37031",
          name: "Volsk",
          state_id: "3054",
        },
      ],
      Smolensk: [
        {
          id: "37032",
          name: "Demidov",
          state_id: "3055",
        },
        {
          id: "37033",
          name: "Desnogorsk",
          state_id: "3055",
        },
        {
          id: "37034",
          name: "Dorogobuzh",
          state_id: "3055",
        },
        {
          id: "37035",
          name: "Gagarin",
          state_id: "3055",
        },
        {
          id: "37036",
          name: "Hislavichi",
          state_id: "3055",
        },
        {
          id: "37037",
          name: "Jarcevo",
          state_id: "3055",
        },
        {
          id: "37038",
          name: "Jelnja",
          state_id: "3055",
        },
        {
          id: "37039",
          name: "Pochinok",
          state_id: "3055",
        },
        {
          id: "37040",
          name: "Roslavl",
          state_id: "3055",
        },
        {
          id: "37041",
          name: "Rudnja",
          state_id: "3055",
        },
        {
          id: "37042",
          name: "Safonovo",
          state_id: "3055",
        },
        {
          id: "37043",
          name: "Smolensk",
          state_id: "3055",
        },
        {
          id: "37044",
          name: "Verhnedneprovskij",
          state_id: "3055",
        },
        {
          id: "37045",
          name: "Vjazma",
          state_id: "3055",
        },
      ],
      Stavropol: [
        {
          id: "37046",
          name: "Blagodarnyj",
          state_id: "3056",
        },
        {
          id: "37047",
          name: "Budjonnovsk",
          state_id: "3056",
        },
        {
          id: "37048",
          name: "Georgijevsk",
          state_id: "3056",
        },
        {
          id: "37049",
          name: "Gorjachevodskij",
          state_id: "3056",
        },
        {
          id: "37050",
          name: "Inozemcevo",
          state_id: "3056",
        },
        {
          id: "37051",
          name: "Ipatovo",
          state_id: "3056",
        },
        {
          id: "37052",
          name: "Izobilnyj",
          state_id: "3056",
        },
        {
          id: "37053",
          name: "Jessentuki",
          state_id: "3056",
        },
        {
          id: "37054",
          name: "Kislovodsk",
          state_id: "3056",
        },
        {
          id: "37055",
          name: "Lermontov",
          state_id: "3056",
        },
        {
          id: "37056",
          name: "Mihajlovsk",
          state_id: "3056",
        },
        {
          id: "37057",
          name: "Mineralnyje Vody",
          state_id: "3056",
        },
        {
          id: "37058",
          name: "Neftekumsk",
          state_id: "3056",
        },
        {
          id: "37059",
          name: "Nevinnomyssk",
          state_id: "3056",
        },
        {
          id: "37060",
          name: "Novoaleksandrovsk",
          state_id: "3056",
        },
        {
          id: "37061",
          name: "Novopavlovsk",
          state_id: "3056",
        },
        {
          id: "37062",
          name: "Pjatigorsk",
          state_id: "3056",
        },
        {
          id: "37063",
          name: "Solnechnodolsk",
          state_id: "3056",
        },
        {
          id: "37064",
          name: "Stavropol",
          state_id: "3056",
        },
        {
          id: "37065",
          name: "Svetlograd",
          state_id: "3056",
        },
        {
          id: "37066",
          name: "Svobody",
          state_id: "3056",
        },
        {
          id: "37067",
          name: "Zeljenokumsk",
          state_id: "3056",
        },
        {
          id: "37068",
          name: "Zheleznovodsk",
          state_id: "3056",
        },
      ],
      Sverdlovsk: [
        {
          id: "37069",
          name: "Alapajevsk",
          state_id: "3057",
        },
        {
          id: "37070",
          name: "Aramil",
          state_id: "3057",
        },
        {
          id: "37071",
          name: "Arti",
          state_id: "3057",
        },
        {
          id: "37072",
          name: "Artjomovskij",
          state_id: "3057",
        },
        {
          id: "37073",
          name: "Asbest",
          state_id: "3057",
        },
        {
          id: "37074",
          name: "Baranchinskij",
          state_id: "3057",
        },
        {
          id: "37075",
          name: "Belojarskij",
          state_id: "3057",
        },
        {
          id: "37076",
          name: "Berjozovskij",
          state_id: "3057",
        },
        {
          id: "37077",
          name: "Bisert",
          state_id: "3057",
        },
        {
          id: "37078",
          name: "Bogdanovich",
          state_id: "3057",
        },
        {
          id: "37079",
          name: "Bulanash",
          state_id: "3057",
        },
        {
          id: "37080",
          name: "Degtjarsk",
          state_id: "3057",
        },
        {
          id: "37081",
          name: "Ekaterinburg",
          state_id: "3057",
        },
        {
          id: "37082",
          name: "Irbit",
          state_id: "3057",
        },
        {
          id: "37083",
          name: "Ivdel",
          state_id: "3057",
        },
        {
          id: "37084",
          name: "Izumrud",
          state_id: "3057",
        },
        {
          id: "37085",
          name: "Jekaterinburg",
          state_id: "3057",
        },
        {
          id: "37086",
          name: "Kachkanar",
          state_id: "3057",
        },
        {
          id: "37087",
          name: "Kamensk-Uralskij",
          state_id: "3057",
        },
        {
          id: "37088",
          name: "Kamyshlov",
          state_id: "3057",
        },
        {
          id: "37089",
          name: "Karpinsk",
          state_id: "3057",
        },
        {
          id: "37090",
          name: "Kirovgrad",
          state_id: "3057",
        },
        {
          id: "37091",
          name: "Kolcovo",
          state_id: "3057",
        },
        {
          id: "37092",
          name: "Krasnoturinsk",
          state_id: "3057",
        },
        {
          id: "37093",
          name: "Krasnoufimsk",
          state_id: "3057",
        },
        {
          id: "37094",
          name: "Krasnouralsk",
          state_id: "3057",
        },
        {
          id: "37095",
          name: "Kushva",
          state_id: "3057",
        },
        {
          id: "37096",
          name: "Lesnoj",
          state_id: "3057",
        },
        {
          id: "37097",
          name: "Leviha",
          state_id: "3057",
        },
        {
          id: "37098",
          name: "Lobva",
          state_id: "3057",
        },
        {
          id: "37099",
          name: "Malysheva",
          state_id: "3057",
        },
        {
          id: "37100",
          name: "Mihajlovsk",
          state_id: "3057",
        },
        {
          id: "37101",
          name: "Monetnyj",
          state_id: "3057",
        },
        {
          id: "37102",
          name: "Nevjansk",
          state_id: "3057",
        },
        {
          id: "37103",
          name: "Nizhnie Sergi",
          state_id: "3057",
        },
        {
          id: "37104",
          name: "Nizhnij Tagil",
          state_id: "3057",
        },
        {
          id: "37105",
          name: "Nizhnjaja Salda",
          state_id: "3057",
        },
        {
          id: "37106",
          name: "Nizhnjaja Tura",
          state_id: "3057",
        },
        {
          id: "37107",
          name: "Novaja Ljalja",
          state_id: "3057",
        },
        {
          id: "37108",
          name: "Novouralsk",
          state_id: "3057",
        },
        {
          id: "37109",
          name: "Pervouralsk",
          state_id: "3057",
        },
        {
          id: "37110",
          name: "Polevskoj",
          state_id: "3057",
        },
        {
          id: "37111",
          name: "Pyshma",
          state_id: "3057",
        },
        {
          id: "37112",
          name: "Pyt-Jah",
          state_id: "3057",
        },
        {
          id: "37113",
          name: "Reftinskij",
          state_id: "3057",
        },
        {
          id: "37114",
          name: "Revda",
          state_id: "3057",
        },
        {
          id: "37115",
          name: "Rezh",
          state_id: "3057",
        },
        {
          id: "37116",
          name: "Serov",
          state_id: "3057",
        },
        {
          id: "37117",
          name: "Severouralsk",
          state_id: "3057",
        },
        {
          id: "37118",
          name: "Sosva",
          state_id: "3057",
        },
        {
          id: "37119",
          name: "Sredneuralsk",
          state_id: "3057",
        },
        {
          id: "37120",
          name: "Suhoj Log",
          state_id: "3057",
        },
        {
          id: "37121",
          name: "Svobodnyj",
          state_id: "3057",
        },
        {
          id: "37122",
          name: "Sysert",
          state_id: "3057",
        },
        {
          id: "37123",
          name: "Talica",
          state_id: "3057",
        },
        {
          id: "37124",
          name: "Tavda",
          state_id: "3057",
        },
        {
          id: "37125",
          name: "Troickij",
          state_id: "3057",
        },
        {
          id: "37126",
          name: "Turinsk",
          state_id: "3057",
        },
        {
          id: "37127",
          name: "Uralskij",
          state_id: "3057",
        },
        {
          id: "37128",
          name: "Verhnij Tagil",
          state_id: "3057",
        },
        {
          id: "37129",
          name: "Verhnjaja Pyshma",
          state_id: "3057",
        },
        {
          id: "37130",
          name: "Verhnjaja Salda",
          state_id: "3057",
        },
        {
          id: "37131",
          name: "Verhnjaja Sinyachiha",
          state_id: "3057",
        },
        {
          id: "37132",
          name: "Verhnjaja Tura",
          state_id: "3057",
        },
        {
          id: "37133",
          name: "Verhoturje",
          state_id: "3057",
        },
        {
          id: "37134",
          name: "Volchansk",
          state_id: "3057",
        },
        {
          id: "37135",
          name: "Yekaterinburg",
          state_id: "3057",
        },
        {
          id: "37136",
          name: "Zarechnyj",
          state_id: "3057",
        },
        {
          id: "37137",
          name: "Zjuzelskij",
          state_id: "3057",
        },
      ],
      Tajmyrija: [
        {
          id: "37138",
          name: "Dudinka",
          state_id: "3058",
        },
      ],
      Tambov: [
        {
          id: "37139",
          name: "Dmitrievka",
          state_id: "3059",
        },
        {
          id: "37140",
          name: "Inzhavino",
          state_id: "3059",
        },
        {
          id: "37141",
          name: "Kirsanov",
          state_id: "3059",
        },
        {
          id: "37142",
          name: "Kotovsk",
          state_id: "3059",
        },
        {
          id: "37143",
          name: "Michurinsk",
          state_id: "3059",
        },
        {
          id: "37144",
          name: "Morshansk",
          state_id: "3059",
        },
        {
          id: "37145",
          name: "Pervomajskij",
          state_id: "3059",
        },
        {
          id: "37146",
          name: "Rasskazovo",
          state_id: "3059",
        },
        {
          id: "37147",
          name: "Sosnovka",
          state_id: "3059",
        },
        {
          id: "37148",
          name: "Tambov",
          state_id: "3059",
        },
        {
          id: "37149",
          name: "Uvarovo",
          state_id: "3059",
        },
        {
          id: "37150",
          name: "Zherdevka",
          state_id: "3059",
        },
        {
          id: "37151",
          name: "Znamenka",
          state_id: "3059",
        },
      ],
      Tatarstan: [
        {
          id: "37152",
          name: "Agryz",
          state_id: "3060",
        },
        {
          id: "37153",
          name: "Aksubajevo",
          state_id: "3060",
        },
        {
          id: "37154",
          name: "Aktjubinskij",
          state_id: "3060",
        },
        {
          id: "37155",
          name: "Aleksejevskoje",
          state_id: "3060",
        },
        {
          id: "37156",
          name: "Almetjevsk",
          state_id: "3060",
        },
        {
          id: "37157",
          name: "Arsk",
          state_id: "3060",
        },
        {
          id: "37158",
          name: "Aznakajevo",
          state_id: "3060",
        },
        {
          id: "37159",
          name: "Bavly",
          state_id: "3060",
        },
        {
          id: "37160",
          name: "Bugulma",
          state_id: "3060",
        },
        {
          id: "37161",
          name: "Buinsk",
          state_id: "3060",
        },
        {
          id: "37162",
          name: "Chistopol",
          state_id: "3060",
        },
        {
          id: "37163",
          name: "Dzhalil",
          state_id: "3060",
        },
        {
          id: "37164",
          name: "Jelabuga",
          state_id: "3060",
        },
        {
          id: "37165",
          name: "Kamskie Poljany",
          state_id: "3060",
        },
        {
          id: "37166",
          name: "Kazan",
          state_id: "3060",
        },
        {
          id: "37167",
          name: "Kukmor",
          state_id: "3060",
        },
        {
          id: "37168",
          name: "Leninogorsk",
          state_id: "3060",
        },
        {
          id: "37169",
          name: "Mamadysh",
          state_id: "3060",
        },
        {
          id: "37170",
          name: "Mendelejevsk",
          state_id: "3060",
        },
        {
          id: "37171",
          name: "Menzelinsk",
          state_id: "3060",
        },
        {
          id: "37172",
          name: "Naberezhnyje Chelny",
          state_id: "3060",
        },
        {
          id: "37173",
          name: "Nizhnekamsk",
          state_id: "3060",
        },
        {
          id: "37174",
          name: "Niznjaja Maktama",
          state_id: "3060",
        },
        {
          id: "37175",
          name: "Nurlat",
          state_id: "3060",
        },
        {
          id: "37176",
          name: "Tetjushi",
          state_id: "3060",
        },
        {
          id: "37177",
          name: "Urussu",
          state_id: "3060",
        },
        {
          id: "37178",
          name: "Vasiljevo",
          state_id: "3060",
        },
        {
          id: "37179",
          name: "Zainsk",
          state_id: "3060",
        },
        {
          id: "37180",
          name: "Zeljonodolsk",
          state_id: "3060",
        },
      ],
      Tjumen: [
        {
          id: "37181",
          name: "Bogandinskij",
          state_id: "3061",
        },
        {
          id: "37182",
          name: "Borovskij",
          state_id: "3061",
        },
        {
          id: "37183",
          name: "Golyshmanovo",
          state_id: "3061",
        },
        {
          id: "37184",
          name: "Ishim",
          state_id: "3061",
        },
        {
          id: "37185",
          name: "Jalutorovosk",
          state_id: "3061",
        },
        {
          id: "37186",
          name: "Tjumen",
          state_id: "3061",
        },
        {
          id: "37187",
          name: "Tobolsk",
          state_id: "3061",
        },
        {
          id: "37188",
          name: "Vinzili",
          state_id: "3061",
        },
        {
          id: "37189",
          name: "Zavodoukovsk",
          state_id: "3061",
        },
      ],
      Tomsk: [
        {
          id: "37190",
          name: "Asino",
          state_id: "3062",
        },
        {
          id: "37191",
          name: "Jaja",
          state_id: "3062",
        },
        {
          id: "37192",
          name: "Kolpashevo",
          state_id: "3062",
        },
        {
          id: "37193",
          name: "Seversk",
          state_id: "3062",
        },
        {
          id: "37194",
          name: "Strezhevoj",
          state_id: "3062",
        },
        {
          id: "37195",
          name: "Tomsk",
          state_id: "3062",
        },
      ],
      Tula: [
        {
          id: "37196",
          name: "Agejevo",
          state_id: "3063",
        },
        {
          id: "37197",
          name: "Aleksin",
          state_id: "3063",
        },
        {
          id: "37198",
          name: "Beljov",
          state_id: "3063",
        },
        {
          id: "37199",
          name: "Bogoroditsk",
          state_id: "3063",
        },
        {
          id: "37200",
          name: "Bolohovo",
          state_id: "3063",
        },
        {
          id: "37201",
          name: "Donskoj",
          state_id: "3063",
        },
        {
          id: "37202",
          name: "Dubovka",
          state_id: "3063",
        },
        {
          id: "37203",
          name: "Jasnogorsk",
          state_id: "3063",
        },
        {
          id: "37204",
          name: "Jefremov",
          state_id: "3063",
        },
        {
          id: "37205",
          name: "Kimovsk",
          state_id: "3063",
        },
        {
          id: "37206",
          name: "Kirejevsk",
          state_id: "3063",
        },
        {
          id: "37207",
          name: "Kosaja Gora",
          state_id: "3063",
        },
        {
          id: "37208",
          name: "Leninskij",
          state_id: "3063",
        },
        {
          id: "37209",
          name: "Lipki",
          state_id: "3063",
        },
        {
          id: "37210",
          name: "Mendelejevskij",
          state_id: "3063",
        },
        {
          id: "37211",
          name: "Novomoskovsk",
          state_id: "3063",
        },
        {
          id: "37212",
          name: "Pervomajskij",
          state_id: "3063",
        },
        {
          id: "37213",
          name: "Plavsk",
          state_id: "3063",
        },
        {
          id: "37214",
          name: "Severo-Zadonsk",
          state_id: "3063",
        },
        {
          id: "37215",
          name: "Shchjokino",
          state_id: "3063",
        },
        {
          id: "37216",
          name: "Skuratovskij",
          state_id: "3063",
        },
        {
          id: "37217",
          name: "Sokolniki",
          state_id: "3063",
        },
        {
          id: "37218",
          name: "Sovetsk",
          state_id: "3063",
        },
        {
          id: "37219",
          name: "Suvorov",
          state_id: "3063",
        },
        {
          id: "37220",
          name: "Tovarkovskij",
          state_id: "3063",
        },
        {
          id: "37221",
          name: "Tula",
          state_id: "3063",
        },
        {
          id: "37222",
          name: "Uzlovaja",
          state_id: "3063",
        },
        {
          id: "37223",
          name: "Venjov",
          state_id: "3063",
        },
      ],
      Tver: [
        {
          id: "37224",
          name: "Andreapol",
          state_id: "3064",
        },
        {
          id: "37225",
          name: "Bezheck",
          state_id: "3064",
        },
        {
          id: "37226",
          name: "Bologoe",
          state_id: "3064",
        },
        {
          id: "37227",
          name: "Kaljazin",
          state_id: "3064",
        },
        {
          id: "37228",
          name: "Kashin",
          state_id: "3064",
        },
        {
          id: "37229",
          name: "Kimry",
          state_id: "3064",
        },
        {
          id: "37230",
          name: "Konakovo",
          state_id: "3064",
        },
        {
          id: "37231",
          name: "Kuvshinovo",
          state_id: "3064",
        },
        {
          id: "37232",
          name: "Lihoslavl",
          state_id: "3064",
        },
        {
          id: "37233",
          name: "Maksatiha",
          state_id: "3064",
        },
        {
          id: "37234",
          name: "Ostashkov",
          state_id: "3064",
        },
        {
          id: "37235",
          name: "Ozjornyj",
          state_id: "3064",
        },
        {
          id: "37236",
          name: "Pelidovo",
          state_id: "3064",
        },
        {
          id: "37237",
          name: "Rameshki",
          state_id: "3064",
        },
        {
          id: "37238",
          name: "Redkino",
          state_id: "3064",
        },
        {
          id: "37239",
          name: "Rzhev",
          state_id: "3064",
        },
        {
          id: "37240",
          name: "Solnechnyj",
          state_id: "3064",
        },
        {
          id: "37241",
          name: "Starica",
          state_id: "3064",
        },
        {
          id: "37242",
          name: "Toropec",
          state_id: "3064",
        },
        {
          id: "37243",
          name: "Torzhok",
          state_id: "3064",
        },
        {
          id: "37244",
          name: "Tver",
          state_id: "3064",
        },
        {
          id: "37245",
          name: "Udomlja",
          state_id: "3064",
        },
        {
          id: "37246",
          name: "Vyshnij Volochok",
          state_id: "3064",
        },
        {
          id: "37247",
          name: "Zapadnaja Dvina",
          state_id: "3064",
        },
      ],
      Tyva: [
        {
          id: "37248",
          name: "Ak-Dovurak",
          state_id: "3065",
        },
        {
          id: "37249",
          name: "Kyzyl",
          state_id: "3065",
        },
      ],
      Udmurtija: [
        {
          id: "37250",
          name: "Balezino",
          state_id: "3066",
        },
        {
          id: "37251",
          name: "Glazov",
          state_id: "3066",
        },
        {
          id: "37252",
          name: "Igra",
          state_id: "3066",
        },
        {
          id: "37253",
          name: "Izhevsk",
          state_id: "3066",
        },
        {
          id: "37254",
          name: "Kambarka",
          state_id: "3066",
        },
        {
          id: "37255",
          name: "Kez",
          state_id: "3066",
        },
        {
          id: "37256",
          name: "Kizner",
          state_id: "3066",
        },
        {
          id: "37257",
          name: "Mozhga",
          state_id: "3066",
        },
        {
          id: "37258",
          name: "Sarapul",
          state_id: "3066",
        },
        {
          id: "37259",
          name: "Uva",
          state_id: "3066",
        },
        {
          id: "37260",
          name: "Votkinsk",
          state_id: "3066",
        },
      ],
      Uljanovsk: [
        {
          id: "37261",
          name: "Barysh",
          state_id: "3067",
        },
        {
          id: "37262",
          name: "Cherdakly",
          state_id: "3067",
        },
        {
          id: "37263",
          name: "Dimitrovgrad",
          state_id: "3067",
        },
        {
          id: "37264",
          name: "Inza",
          state_id: "3067",
        },
        {
          id: "37265",
          name: "Isheevka",
          state_id: "3067",
        },
        {
          id: "37266",
          name: "Novospasskoe",
          state_id: "3067",
        },
        {
          id: "37267",
          name: "Novouljanovsk",
          state_id: "3067",
        },
        {
          id: "37268",
          name: "Sengilej",
          state_id: "3067",
        },
        {
          id: "37269",
          name: "Uljanovsk",
          state_id: "3067",
        },
      ],
      "Ulyanovskaya Oblast": [],
      "Ust-Orda": [
        {
          id: "37270",
          name: "Ust-Ordynskij",
          state_id: "3069",
        },
      ],
      Vladimir: [
        {
          id: "37271",
          name: "Aleksandrov",
          state_id: "3070",
        },
        {
          id: "37272",
          name: "Balakirevo",
          state_id: "3070",
        },
        {
          id: "37273",
          name: "Gorohovec",
          state_id: "3070",
        },
        {
          id: "37274",
          name: "Gus-Hrustalnyj",
          state_id: "3070",
        },
        {
          id: "37275",
          name: "Jurjev Polskij",
          state_id: "3070",
        },
        {
          id: "37276",
          name: "Kameshkovo",
          state_id: "3070",
        },
        {
          id: "37277",
          name: "Karabanovo",
          state_id: "3070",
        },
        {
          id: "37278",
          name: "Kirzhach",
          state_id: "3070",
        },
        {
          id: "37279",
          name: "Kolchugino",
          state_id: "3070",
        },
        {
          id: "37280",
          name: "Kosterovo",
          state_id: "3070",
        },
        {
          id: "37281",
          name: "Kovrov",
          state_id: "3070",
        },
        {
          id: "37282",
          name: "Krasnaja Gorbatka",
          state_id: "3070",
        },
        {
          id: "37283",
          name: "Krasnyj Oktjabr",
          state_id: "3070",
        },
        {
          id: "37284",
          name: "Lakinsk",
          state_id: "3070",
        },
        {
          id: "37285",
          name: "Melenki",
          state_id: "3070",
        },
        {
          id: "37286",
          name: "Murom",
          state_id: "3070",
        },
        {
          id: "37287",
          name: "Novovjazniki",
          state_id: "3070",
        },
        {
          id: "37288",
          name: "Pokrov",
          state_id: "3070",
        },
        {
          id: "37289",
          name: "Raduzhnyj",
          state_id: "3070",
        },
        {
          id: "37290",
          name: "Sobinka",
          state_id: "3070",
        },
        {
          id: "37291",
          name: "Strunino",
          state_id: "3070",
        },
        {
          id: "37292",
          name: "Sudogda",
          state_id: "3070",
        },
        {
          id: "37293",
          name: "Suzdal",
          state_id: "3070",
        },
        {
          id: "37294",
          name: "Vjazniki",
          state_id: "3070",
        },
        {
          id: "37295",
          name: "Vladimir",
          state_id: "3070",
        },
      ],
      Volgograd: [
        {
          id: "37296",
          name: "Dubovka",
          state_id: "3071",
        },
        {
          id: "37297",
          name: "Frolovo",
          state_id: "3071",
        },
        {
          id: "37298",
          name: "Gorkovskij",
          state_id: "3071",
        },
        {
          id: "37299",
          name: "Gorodishche",
          state_id: "3071",
        },
        {
          id: "37300",
          name: "Ilovlja",
          state_id: "3071",
        },
        {
          id: "37301",
          name: "Jelan",
          state_id: "3071",
        },
        {
          id: "37302",
          name: "Kalach-na-Donu",
          state_id: "3071",
        },
        {
          id: "37303",
          name: "Kamyshin",
          state_id: "3071",
        },
        {
          id: "37304",
          name: "Kotelnikovo",
          state_id: "3071",
        },
        {
          id: "37305",
          name: "Kotovo",
          state_id: "3071",
        },
        {
          id: "37306",
          name: "Krasnoslobodsk",
          state_id: "3071",
        },
        {
          id: "37307",
          name: "Leninsk",
          state_id: "3071",
        },
        {
          id: "37308",
          name: "Mihajlovka",
          state_id: "3071",
        },
        {
          id: "37309",
          name: "Nikolajevsk",
          state_id: "3071",
        },
        {
          id: "37310",
          name: "Nizhny Novgorod",
          state_id: "3071",
        },
        {
          id: "37311",
          name: "Novoanninskij",
          state_id: "3071",
        },
        {
          id: "37312",
          name: "Novonikolajevskij",
          state_id: "3071",
        },
        {
          id: "37313",
          name: "Pallasovka",
          state_id: "3071",
        },
        {
          id: "37314",
          name: "Petrov Val",
          state_id: "3071",
        },
        {
          id: "37315",
          name: "Serafimovich",
          state_id: "3071",
        },
        {
          id: "37316",
          name: "Surovikino",
          state_id: "3071",
        },
        {
          id: "37317",
          name: "Svetlyj Jar",
          state_id: "3071",
        },
        {
          id: "37318",
          name: "Urjupinsk",
          state_id: "3071",
        },
        {
          id: "37319",
          name: "Volgograd",
          state_id: "3071",
        },
        {
          id: "37320",
          name: "Volzhskij",
          state_id: "3071",
        },
        {
          id: "37321",
          name: "Zhirnovsk",
          state_id: "3071",
        },
      ],
      Vologda: [
        {
          id: "37322",
          name: "Babajevo",
          state_id: "3072",
        },
        {
          id: "37323",
          name: "Belozjorsk",
          state_id: "3072",
        },
        {
          id: "37324",
          name: "Cherepovec",
          state_id: "3072",
        },
        {
          id: "37325",
          name: "Grjazovec",
          state_id: "3072",
        },
        {
          id: "37326",
          name: "Harovsk",
          state_id: "3072",
        },
        {
          id: "37327",
          name: "Kaduj",
          state_id: "3072",
        },
        {
          id: "37328",
          name: "Krasavino",
          state_id: "3072",
        },
        {
          id: "37329",
          name: "Sheksna",
          state_id: "3072",
        },
        {
          id: "37330",
          name: "Sokol",
          state_id: "3072",
        },
        {
          id: "37331",
          name: "Totma",
          state_id: "3072",
        },
        {
          id: "37332",
          name: "Velikij Ustjug",
          state_id: "3072",
        },
        {
          id: "37333",
          name: "Vologda",
          state_id: "3072",
        },
        {
          id: "37334",
          name: "Vytegra",
          state_id: "3072",
        },
      ],
      Voronezh: [
        {
          id: "37335",
          name: "Anna",
          state_id: "3073",
        },
        {
          id: "37336",
          name: "Bobrov",
          state_id: "3073",
        },
        {
          id: "37337",
          name: "Boguchar",
          state_id: "3073",
        },
        {
          id: "37338",
          name: "Borisoglebsk",
          state_id: "3073",
        },
        {
          id: "37339",
          name: "Buturlinovka",
          state_id: "3073",
        },
        {
          id: "37340",
          name: "Ertil",
          state_id: "3073",
        },
        {
          id: "37341",
          name: "Gribanovskij",
          state_id: "3073",
        },
        {
          id: "37342",
          name: "Kalach",
          state_id: "3073",
        },
        {
          id: "37343",
          name: "Kamenka",
          state_id: "3073",
        },
        {
          id: "37344",
          name: "Kantemirovka",
          state_id: "3073",
        },
        {
          id: "37345",
          name: "Liski",
          state_id: "3073",
        },
        {
          id: "37346",
          name: "Novohopjorsk",
          state_id: "3073",
        },
        {
          id: "37347",
          name: "Novovoronezh",
          state_id: "3073",
        },
        {
          id: "37348",
          name: "Ostrogozhsk",
          state_id: "3073",
        },
        {
          id: "37349",
          name: "Pavlovsk",
          state_id: "3073",
        },
        {
          id: "37350",
          name: "Povorino",
          state_id: "3073",
        },
        {
          id: "37351",
          name: "Pridonskij",
          state_id: "3073",
        },
        {
          id: "37352",
          name: "Rossosh",
          state_id: "3073",
        },
        {
          id: "37353",
          name: "Semiluki",
          state_id: "3073",
        },
        {
          id: "37354",
          name: "Somovo",
          state_id: "3073",
        },
        {
          id: "37355",
          name: "Talovaja",
          state_id: "3073",
        },
        {
          id: "37356",
          name: "Voronezh",
          state_id: "3073",
        },
      ],
    },
  },
  RW: {
    name: "Rwanda",
    native: "Rwanda",
    phone: "250",
    continent: "AF",
    capital: "Kigali",
    currency: "RWF",
    languages: ["rw", "en", "fr"],
    emoji: "🇷🇼",
    emojiU: "U+1F1F7 U+1F1FC",
    states: {
      Butare: [
        {
          id: "37357",
          name: "Butare",
          state_id: "3074",
        },
        {
          id: "37358",
          name: "Nyanza",
          state_id: "3074",
        },
      ],
      Byumba: [
        {
          id: "37359",
          name: "Byumba",
          state_id: "3075",
        },
      ],
      Cyangugu: [
        {
          id: "37360",
          name: "Cyangugu",
          state_id: "3076",
        },
      ],
      Gikongoro: [
        {
          id: "37361",
          name: "Gikongoro",
          state_id: "3077",
        },
      ],
      Gisenyi: [
        {
          id: "37362",
          name: "Gisenyi",
          state_id: "3078",
        },
      ],
      Gitarama: [
        {
          id: "37363",
          name: "Gitarama",
          state_id: "3079",
        },
      ],
      Kibungo: [
        {
          id: "37364",
          name: "Kibungo",
          state_id: "3080",
        },
        {
          id: "37365",
          name: "Rwamagana",
          state_id: "3080",
        },
      ],
      Kibuye: [
        {
          id: "37366",
          name: "Kibuye",
          state_id: "3081",
        },
      ],
      "Kigali-ngali": [
        {
          id: "37367",
          name: "Kigali",
          state_id: "3082",
        },
      ],
      Ruhengeri: [
        {
          id: "37368",
          name: "Ruhengeri",
          state_id: "3083",
        },
      ],
    },
  },
  SA: {
    name: "Saudi Arabia",
    native: "العربية السعودية",
    phone: "966",
    continent: "AS",
    capital: "Riyadh",
    currency: "SAR",
    languages: ["ar"],
    emoji: "🇸🇦",
    emojiU: "U+1F1F8 U+1F1E6",
    states: {
      "Al Khobar": [],
      Aseer: [
        {
          id: "37410",
          name: "Mahayel",
          state_id: "3147",
        },
      ],
      "Ash Sharqiyah": [],
      Asir: [
        {
          id: "37411",
          name: "Abha",
          state_id: "3149",
        },
        {
          id: "37412",
          name: "Abu ''Aris",
          state_id: "3149",
        },
        {
          id: "37413",
          name: "Khamis Mushayt",
          state_id: "3149",
        },
        {
          id: "37414",
          name: "Qal''at Bishah",
          state_id: "3149",
        },
      ],
      "Central Province": [],
      "Eastern Province": [],
      "Ha''il": [
        {
          id: "37415",
          name: "Ha''il",
          state_id: "3152",
        },
      ],
      Jawf: [
        {
          id: "37416",
          name: "Jawf",
          state_id: "3153",
        },
        {
          id: "37417",
          name: "Sakakah",
          state_id: "3153",
        },
      ],
      Jizan: [
        {
          id: "37418",
          name: "Jizan",
          state_id: "3154",
        },
        {
          id: "37419",
          name: "Sabya",
          state_id: "3154",
        },
      ],
      Makkah: [
        {
          id: "37420",
          name: "Makkah",
          state_id: "3155",
        },
        {
          id: "37421",
          name: "Rabig",
          state_id: "3155",
        },
        {
          id: "37422",
          name: "al-Hawiyah",
          state_id: "3155",
        },
        {
          id: "37423",
          name: "at-Ta''if",
          state_id: "3155",
        },
      ],
      Najran: [
        {
          id: "37424",
          name: "Dar''iyah",
          state_id: "3156",
        },
        {
          id: "37425",
          name: "Najran",
          state_id: "3156",
        },
        {
          id: "37426",
          name: "Sharurah",
          state_id: "3156",
        },
      ],
      Qasim: [
        {
          id: "37427",
          name: "Unayzah",
          state_id: "3157",
        },
        {
          id: "37428",
          name: "Buraydah",
          state_id: "3157",
        },
        {
          id: "37429",
          name: "ar-Rass",
          state_id: "3157",
        },
      ],
      Tabuk: [
        {
          id: "37430",
          name: "Tabuk",
          state_id: "3158",
        },
        {
          id: "37431",
          name: "Umm Lajj",
          state_id: "3158",
        },
      ],
      "Western Province": [],
      "al-Bahah": [
        {
          id: "37432",
          name: "al-Bahah",
          state_id: "3160",
        },
      ],
      "al-Hudud-ash-Shamaliyah": [
        {
          id: "37433",
          name: "Ara''ar",
          state_id: "3161",
        },
        {
          id: "37434",
          name: "Rafha",
          state_id: "3161",
        },
        {
          id: "37435",
          name: "Turayf",
          state_id: "3161",
        },
        {
          id: "37436",
          name: "al-Qurayyat",
          state_id: "3161",
        },
      ],
      "al-Madinah": [
        {
          id: "37437",
          name: "Yanbu",
          state_id: "3162",
        },
        {
          id: "37438",
          name: "al-Madinah",
          state_id: "3162",
        },
      ],
      "ar-Riyad": [
        {
          id: "37439",
          name: "Afif",
          state_id: "3163",
        },
        {
          id: "37440",
          name: "ad-Dawadimi",
          state_id: "3163",
        },
        {
          id: "37441",
          name: "ad-Dilam",
          state_id: "3163",
        },
        {
          id: "37442",
          name: "al-Kharj",
          state_id: "3163",
        },
        {
          id: "37443",
          name: "al-Majma''ah",
          state_id: "3163",
        },
        {
          id: "37444",
          name: "ar-Riyad",
          state_id: "3163",
        },
        {
          id: "37445",
          name: "az-Zulfi",
          state_id: "3163",
        },
      ],
    },
  },
  SB: {
    name: "Solomon Islands",
    native: "Solomon Islands",
    phone: "677",
    continent: "OC",
    capital: "Honiara",
    currency: "SBD",
    languages: ["en"],
    emoji: "🇸🇧",
    emojiU: "U+1F1F8 U+1F1E7",
    states: {
      Central: [
        {
          id: "37975",
          name: "Tulagi",
          state_id: "3212",
        },
      ],
      Choiseul: [
        {
          id: "37976",
          name: "Taro Island",
          state_id: "3213",
        },
      ],
      Guadalcanal: [
        {
          id: "37977",
          name: "Honiara",
          state_id: "3214",
        },
      ],
      Isabel: [
        {
          id: "37978",
          name: "Buala",
          state_id: "3215",
        },
      ],
      "Makira and Ulawa": [],
      Malaita: [
        {
          id: "37979",
          name: "Auki",
          state_id: "3217",
        },
      ],
      "Rennell and Bellona": [],
      Temotu: [
        {
          id: "37980",
          name: "Lata",
          state_id: "3219",
        },
      ],
      Western: [
        {
          id: "37981",
          name: "Gizo",
          state_id: "3220",
        },
      ],
    },
  },
  SC: {
    name: "Seychelles",
    native: "Seychelles",
    phone: "248",
    continent: "AF",
    capital: "Victoria",
    currency: "SCR",
    languages: ["fr", "en"],
    emoji: "🇸🇨",
    emojiU: "U+1F1F8 U+1F1E8",
    states: {
      "Anse Boileau": [],
      "Anse Royale": [],
      Cascade: [
        {
          id: "37508",
          name: "Cascade",
          state_id: "3179",
        },
      ],
      Takamaka: [
        {
          id: "37509",
          name: "Takamaka",
          state_id: "3180",
        },
      ],
      Victoria: [
        {
          id: "37510",
          name: "Mahe",
          state_id: "3181",
        },
      ],
    },
  },
  SD: {
    name: "Sudan",
    native: "السودان",
    phone: "249",
    continent: "AF",
    capital: "Khartoum",
    currency: "SDG",
    languages: ["ar", "en"],
    emoji: "🇸🇩",
    emojiU: "U+1F1F8 U+1F1E9",
    states: {
      "A''ali-an-Nil": [
        {
          id: "38928",
          name: "Kodok",
          state_id: "3353",
        },
        {
          id: "38929",
          name: "Malakal",
          state_id: "3353",
        },
        {
          id: "38930",
          name: "Nasir",
          state_id: "3353",
        },
        {
          id: "38931",
          name: "ar-Rank",
          state_id: "3353",
        },
      ],
      "Bahr-al-Jabal": [
        {
          id: "38932",
          name: "Juba",
          state_id: "3354",
        },
        {
          id: "38933",
          name: "Yei",
          state_id: "3354",
        },
      ],
      "Central Equatoria": [],
      "Gharb Bahr-al-Ghazal": [],
      "Gharb Darfur": [],
      "Gharb Kurdufan": [],
      "Gharb-al-Istiwa''iyah": [
        {
          id: "38934",
          name: "Maridi",
          state_id: "3359",
        },
        {
          id: "38935",
          name: "Nzara",
          state_id: "3359",
        },
        {
          id: "38936",
          name: "Tambura",
          state_id: "3359",
        },
        {
          id: "38937",
          name: "Yambio",
          state_id: "3359",
        },
      ],
      "Janub Darfur": [],
      "Janub Kurdufan": [],
      Junqali: [
        {
          id: "38938",
          name: "Bur",
          state_id: "3362",
        },
      ],
      Kassala: [
        {
          id: "38939",
          name: "Aruma",
          state_id: "3363",
        },
        {
          id: "38940",
          name: "Halfa al-Jadidah",
          state_id: "3363",
        },
        {
          id: "38941",
          name: "Kassala",
          state_id: "3363",
        },
        {
          id: "38942",
          name: "Khashm-al-Qirbah",
          state_id: "3363",
        },
        {
          id: "38943",
          name: "Wagar",
          state_id: "3363",
        },
        {
          id: "38944",
          name: "al-Masnah",
          state_id: "3363",
        },
      ],
      "Nahr-an-Nil": [
        {
          id: "38945",
          name: "Atbarah",
          state_id: "3364",
        },
        {
          id: "38946",
          name: "Barbar",
          state_id: "3364",
        },
        {
          id: "38947",
          name: "Kabushiyah",
          state_id: "3364",
        },
        {
          id: "38948",
          name: "Shandi",
          state_id: "3364",
        },
        {
          id: "38949",
          name: "ad-Damir",
          state_id: "3364",
        },
        {
          id: "38950",
          name: "al-Bawga",
          state_id: "3364",
        },
        {
          id: "38951",
          name: "al-Matammah",
          state_id: "3364",
        },
      ],
      "Shamal Bahr-al-Ghazal": [],
      "Shamal Darfur": [],
      "Shamal Kurdufan": [],
      "Sharq-al-Istiwa''iyah": [
        {
          id: "38952",
          name: "Kapoeta",
          state_id: "3368",
        },
        {
          id: "38953",
          name: "Torit",
          state_id: "3368",
        },
      ],
      Sinnar: [
        {
          id: "38954",
          name: "Abu Hijar",
          state_id: "3369",
        },
        {
          id: "38955",
          name: "Galgani",
          state_id: "3369",
        },
        {
          id: "38956",
          name: "Hajj ''Abdallah",
          state_id: "3369",
        },
        {
          id: "38957",
          name: "Karkawj",
          state_id: "3369",
        },
        {
          id: "38958",
          name: "Mayurnu",
          state_id: "3369",
        },
        {
          id: "38959",
          name: "Sinjah",
          state_id: "3369",
        },
        {
          id: "38960",
          name: "Sinnar",
          state_id: "3369",
        },
        {
          id: "38961",
          name: "Sinnar-at-Tagatu",
          state_id: "3369",
        },
        {
          id: "38962",
          name: "Umm Shawkah",
          state_id: "3369",
        },
        {
          id: "38963",
          name: "ad-Dindar",
          state_id: "3369",
        },
        {
          id: "38964",
          name: "as-Suki",
          state_id: "3369",
        },
      ],
      Warab: [
        {
          id: "38965",
          name: "Mashra ar-Raqq",
          state_id: "3370",
        },
        {
          id: "38966",
          name: "Tonj",
          state_id: "3370",
        },
        {
          id: "38967",
          name: "Warab",
          state_id: "3370",
        },
      ],
      "Wilayat al Khartum": [],
      "al-Bahr-al-Ahmar": [
        {
          id: "38968",
          name: "Bur Sudan",
          state_id: "3372",
        },
        {
          id: "38969",
          name: "Gabait",
          state_id: "3372",
        },
        {
          id: "38970",
          name: "Sawakin",
          state_id: "3372",
        },
        {
          id: "38971",
          name: "Sinkat",
          state_id: "3372",
        },
        {
          id: "38972",
          name: "Tawkar",
          state_id: "3372",
        },
      ],
      "al-Buhayrat": [
        {
          id: "38973",
          name: "Rumbik",
          state_id: "3373",
        },
        {
          id: "38974",
          name: "Yirol",
          state_id: "3373",
        },
      ],
      "al-Jazirah": [
        {
          id: "38975",
          name: "Abu ''Usar",
          state_id: "3374",
        },
        {
          id: "38976",
          name: "Arba''atun wa ''Ishrun-al-Qurash",
          state_id: "3374",
        },
        {
          id: "38977",
          name: "Maharaybah",
          state_id: "3374",
        },
        {
          id: "38978",
          name: "Miallayab",
          state_id: "3374",
        },
        {
          id: "38979",
          name: "Rufa''a",
          state_id: "3374",
        },
        {
          id: "38980",
          name: "Sharafat",
          state_id: "3374",
        },
        {
          id: "38981",
          name: "Tabat",
          state_id: "3374",
        },
        {
          id: "38982",
          name: "Tambul",
          state_id: "3374",
        },
        {
          id: "38983",
          name: "Wad Madani",
          state_id: "3374",
        },
        {
          id: "38984",
          name: "Wad Rawah",
          state_id: "3374",
        },
        {
          id: "38985",
          name: "al-Hawsh",
          state_id: "3374",
        },
        {
          id: "38986",
          name: "al-Hilaliyah",
          state_id: "3374",
        },
        {
          id: "38987",
          name: "al-Huda",
          state_id: "3374",
        },
        {
          id: "38988",
          name: "al-Husayhisah",
          state_id: "3374",
        },
        {
          id: "38989",
          name: "al-Kamilin",
          state_id: "3374",
        },
        {
          id: "38990",
          name: "al-Karaymat",
          state_id: "3374",
        },
        {
          id: "38991",
          name: "al-Manaqil",
          state_id: "3374",
        },
        {
          id: "38992",
          name: "al-Mu''sadiyah",
          state_id: "3374",
        },
        {
          id: "38993",
          name: "al-Musallamiyah",
          state_id: "3374",
        },
      ],
      "al-Khartum": [
        {
          id: "38994",
          name: "Umm Dawm",
          state_id: "3375",
        },
        {
          id: "38995",
          name: "Umm Durman",
          state_id: "3375",
        },
        {
          id: "38996",
          name: "al-Khartum",
          state_id: "3375",
        },
        {
          id: "38997",
          name: "al-Khartum Bahri",
          state_id: "3375",
        },
      ],
      "al-Qadarif": [
        {
          id: "38998",
          name: "Doka",
          state_id: "3376",
        },
        {
          id: "38999",
          name: "Qala''-an-Nahl",
          state_id: "3376",
        },
        {
          id: "39000",
          name: "Shuwak",
          state_id: "3376",
        },
        {
          id: "39001",
          name: "al-Faw",
          state_id: "3376",
        },
        {
          id: "39002",
          name: "al-Hawatah",
          state_id: "3376",
        },
        {
          id: "39003",
          name: "al-Qadarif",
          state_id: "3376",
        },
      ],
      "al-Wahdah": [
        {
          id: "39004",
          name: "Bentiu",
          state_id: "3377",
        },
        {
          id: "39005",
          name: "Ler",
          state_id: "3377",
        },
      ],
      "an-Nil-al-Abyad": [
        {
          id: "39006",
          name: "Asalaya",
          state_id: "3378",
        },
        {
          id: "39007",
          name: "Bufi",
          state_id: "3378",
        },
        {
          id: "39008",
          name: "Gulli",
          state_id: "3378",
        },
        {
          id: "39009",
          name: "Kinanah",
          state_id: "3378",
        },
        {
          id: "39010",
          name: "Kusti",
          state_id: "3378",
        },
        {
          id: "39011",
          name: "Marabba",
          state_id: "3378",
        },
        {
          id: "39012",
          name: "Rabak",
          state_id: "3378",
        },
        {
          id: "39013",
          name: "Shabashah",
          state_id: "3378",
        },
        {
          id: "39014",
          name: "Tandalti",
          state_id: "3378",
        },
        {
          id: "39015",
          name: "Umm Jarr",
          state_id: "3378",
        },
        {
          id: "39016",
          name: "Wad-az-Zaki",
          state_id: "3378",
        },
        {
          id: "39017",
          name: "ad-Duwaym",
          state_id: "3378",
        },
        {
          id: "39018",
          name: "al-Jazirah",
          state_id: "3378",
        },
        {
          id: "39019",
          name: "al-Kawah",
          state_id: "3378",
        },
        {
          id: "39020",
          name: "al-Qutaynah",
          state_id: "3378",
        },
      ],
      "an-Nil-al-Azraq": [
        {
          id: "39021",
          name: "ad-Damazin",
          state_id: "3379",
        },
        {
          id: "39022",
          name: "al-Kurumuk",
          state_id: "3379",
        },
        {
          id: "39023",
          name: "al-Quwaysi",
          state_id: "3379",
        },
        {
          id: "39024",
          name: "ar-Rusayris",
          state_id: "3379",
        },
      ],
      "ash-Shamaliyah": [
        {
          id: "39025",
          name: "Argu",
          state_id: "3380",
        },
        {
          id: "39026",
          name: "Dalqu",
          state_id: "3380",
        },
        {
          id: "39027",
          name: "Dunqulah",
          state_id: "3380",
        },
        {
          id: "39028",
          name: "Kanisah",
          state_id: "3380",
        },
        {
          id: "39029",
          name: "Karmah-an-Nuzul",
          state_id: "3380",
        },
        {
          id: "39030",
          name: "Kuraymah",
          state_id: "3380",
        },
        {
          id: "39031",
          name: "Kurti",
          state_id: "3380",
        },
        {
          id: "39032",
          name: "Marawi",
          state_id: "3380",
        },
        {
          id: "39033",
          name: "Tangasi-ar-Ru''ays",
          state_id: "3380",
        },
        {
          id: "39034",
          name: "Wadi Halfa",
          state_id: "3380",
        },
        {
          id: "39035",
          name: "ad-Dabbah",
          state_id: "3380",
        },
      ],
    },
  },
  SE: {
    name: "Sweden",
    native: "Sverige",
    phone: "46",
    continent: "EU",
    capital: "Stockholm",
    currency: "SEK",
    languages: ["sv"],
    emoji: "🇸🇪",
    emojiU: "U+1F1F8 U+1F1EA",
    states: {
      "Alvsborgs Lan": [],
      Angermanland: [],
      Blekinge: [
        {
          id: "39081",
          name: "Karlshamn",
          state_id: "3397",
        },
        {
          id: "39082",
          name: "Karlskrona",
          state_id: "3397",
        },
        {
          id: "39083",
          name: "Ronneby",
          state_id: "3397",
        },
      ],
      Bohuslan: [
        {
          id: "39084",
          name: "Stenungsund",
          state_id: "3398",
        },
      ],
      Dalarna: [
        {
          id: "39085",
          name: "Avesta",
          state_id: "3399",
        },
        {
          id: "39086",
          name: "Borlange",
          state_id: "3399",
        },
        {
          id: "39087",
          name: "Falun",
          state_id: "3399",
        },
        {
          id: "39088",
          name: "Hedemora",
          state_id: "3399",
        },
        {
          id: "39089",
          name: "Ludvika",
          state_id: "3399",
        },
        {
          id: "39090",
          name: "Malung",
          state_id: "3399",
        },
      ],
      Gavleborg: [
        {
          id: "39091",
          name: "Bollnas",
          state_id: "3400",
        },
        {
          id: "39092",
          name: "Bro",
          state_id: "3400",
        },
        {
          id: "39093",
          name: "Gavle",
          state_id: "3400",
        },
        {
          id: "39094",
          name: "Hudiksvall",
          state_id: "3400",
        },
        {
          id: "39095",
          name: "Sandviken",
          state_id: "3400",
        },
        {
          id: "39096",
          name: "Soderhamn",
          state_id: "3400",
        },
      ],
      Gaza: [],
      Gotland: [
        {
          id: "39097",
          name: "Skara",
          state_id: "3402",
        },
        {
          id: "39098",
          name: "Visby",
          state_id: "3402",
        },
      ],
      Halland: [
        {
          id: "39099",
          name: "Anderstorp",
          state_id: "3403",
        },
        {
          id: "39100",
          name: "Falkenberg",
          state_id: "3403",
        },
        {
          id: "39101",
          name: "Halmstad",
          state_id: "3403",
        },
        {
          id: "39102",
          name: "Ullared",
          state_id: "3403",
        },
        {
          id: "39103",
          name: "Varberg",
          state_id: "3403",
        },
      ],
      Jamtland: [
        {
          id: "39104",
          name: "Farjestaden",
          state_id: "3404",
        },
        {
          id: "39105",
          name: "Ostersund",
          state_id: "3404",
        },
      ],
      Jonkoping: [
        {
          id: "39106",
          name: "Gislaved",
          state_id: "3405",
        },
        {
          id: "39107",
          name: "Jonkoping",
          state_id: "3405",
        },
        {
          id: "39108",
          name: "Nassjo",
          state_id: "3405",
        },
        {
          id: "39109",
          name: "Tranas",
          state_id: "3405",
        },
        {
          id: "39110",
          name: "Varnamo",
          state_id: "3405",
        },
        {
          id: "39111",
          name: "Vetlanda",
          state_id: "3405",
        },
      ],
      Kalmar: [
        {
          id: "39112",
          name: "Blomstermala",
          state_id: "3406",
        },
        {
          id: "39113",
          name: "Kalmar",
          state_id: "3406",
        },
        {
          id: "39114",
          name: "Nybro",
          state_id: "3406",
        },
        {
          id: "39115",
          name: "Oskarshamn",
          state_id: "3406",
        },
        {
          id: "39116",
          name: "Solna",
          state_id: "3406",
        },
        {
          id: "39117",
          name: "Torsas",
          state_id: "3406",
        },
        {
          id: "39118",
          name: "Vastervik",
          state_id: "3406",
        },
      ],
      Kristianstads: [
        {
          id: "39119",
          name: "Habo",
          state_id: "3407",
        },
        {
          id: "39120",
          name: "Limhamn",
          state_id: "3407",
        },
        {
          id: "39121",
          name: "Segeltorp",
          state_id: "3407",
        },
        {
          id: "39122",
          name: "Svedala",
          state_id: "3407",
        },
      ],
      Kronoberg: [
        {
          id: "39123",
          name: "Ljungby",
          state_id: "3408",
        },
        {
          id: "39124",
          name: "Vaxjo",
          state_id: "3408",
        },
      ],
      Norrbotten: [
        {
          id: "39125",
          name: "Boden",
          state_id: "3409",
        },
        {
          id: "39126",
          name: "Kiruna",
          state_id: "3409",
        },
        {
          id: "39127",
          name: "Lulea",
          state_id: "3409",
        },
        {
          id: "39128",
          name: "Pitea",
          state_id: "3409",
        },
      ],
      Orebro: [
        {
          id: "39129",
          name: "Askersund",
          state_id: "3410",
        },
        {
          id: "39130",
          name: "Karlskoga",
          state_id: "3410",
        },
        {
          id: "39131",
          name: "Kumla",
          state_id: "3410",
        },
        {
          id: "39132",
          name: "Orebro",
          state_id: "3410",
        },
      ],
      Ostergotland: [
        {
          id: "39133",
          name: "Finspang",
          state_id: "3411",
        },
        {
          id: "39134",
          name: "Follinge",
          state_id: "3411",
        },
        {
          id: "39135",
          name: "Kisa",
          state_id: "3411",
        },
        {
          id: "39136",
          name: "Linkoping",
          state_id: "3411",
        },
        {
          id: "39137",
          name: "Mjolby",
          state_id: "3411",
        },
        {
          id: "39138",
          name: "Motala",
          state_id: "3411",
        },
        {
          id: "39139",
          name: "Norrkoping",
          state_id: "3411",
        },
        {
          id: "39140",
          name: "Vadstena",
          state_id: "3411",
        },
      ],
      "Saltsjo-Boo": [
        {
          id: "39141",
          name: "Skarpovagen",
          state_id: "3412",
        },
      ],
      Skane: [
        {
          id: "39142",
          name: "Angelholm",
          state_id: "3413",
        },
        {
          id: "39143",
          name: "Arlov",
          state_id: "3413",
        },
        {
          id: "39144",
          name: "Bastad",
          state_id: "3413",
        },
        {
          id: "39145",
          name: "Eslov",
          state_id: "3413",
        },
        {
          id: "39146",
          name: "Hassleholm",
          state_id: "3413",
        },
        {
          id: "39147",
          name: "Helsingborg",
          state_id: "3413",
        },
        {
          id: "39148",
          name: "Hjarup",
          state_id: "3413",
        },
        {
          id: "39149",
          name: "Hoganas",
          state_id: "3413",
        },
        {
          id: "39150",
          name: "Horby",
          state_id: "3413",
        },
        {
          id: "39151",
          name: "Jonstorp",
          state_id: "3413",
        },
        {
          id: "39152",
          name: "Klagstorp",
          state_id: "3413",
        },
        {
          id: "39153",
          name: "Kristianstad",
          state_id: "3413",
        },
        {
          id: "39154",
          name: "Landskrona",
          state_id: "3413",
        },
        {
          id: "39155",
          name: "Lund",
          state_id: "3413",
        },
        {
          id: "39156",
          name: "Malmo",
          state_id: "3413",
        },
        {
          id: "39157",
          name: "Skanor",
          state_id: "3413",
        },
        {
          id: "39158",
          name: "Staffanstorp",
          state_id: "3413",
        },
        {
          id: "39159",
          name: "Trelleborg",
          state_id: "3413",
        },
        {
          id: "39160",
          name: "Ystad",
          state_id: "3413",
        },
      ],
      Smaland: [
        {
          id: "39161",
          name: "Hillerstorp",
          state_id: "3414",
        },
        {
          id: "39162",
          name: "Markaryd",
          state_id: "3414",
        },
        {
          id: "39163",
          name: "Smalandsstenar",
          state_id: "3414",
        },
      ],
      Sodermanland: [
        {
          id: "39164",
          name: "Eskilstuna",
          state_id: "3415",
        },
        {
          id: "39165",
          name: "Gnesta",
          state_id: "3415",
        },
        {
          id: "39166",
          name: "Katrineholm",
          state_id: "3415",
        },
        {
          id: "39167",
          name: "Nacka Strand",
          state_id: "3415",
        },
        {
          id: "39168",
          name: "Nykoping",
          state_id: "3415",
        },
        {
          id: "39169",
          name: "Strangnas",
          state_id: "3415",
        },
        {
          id: "39170",
          name: "Vingaker",
          state_id: "3415",
        },
      ],
      Stockholm: [
        {
          id: "39171",
          name: "Akersberga",
          state_id: "3416",
        },
        {
          id: "39172",
          name: "Boo",
          state_id: "3416",
        },
        {
          id: "39173",
          name: "Bromma",
          state_id: "3416",
        },
        {
          id: "39174",
          name: "Djursholm",
          state_id: "3416",
        },
        {
          id: "39175",
          name: "Hallstavik",
          state_id: "3416",
        },
        {
          id: "39176",
          name: "Jarfalla",
          state_id: "3416",
        },
        {
          id: "39177",
          name: "Johannesfred",
          state_id: "3416",
        },
        {
          id: "39178",
          name: "Lidingo",
          state_id: "3416",
        },
        {
          id: "39179",
          name: "Marsta",
          state_id: "3416",
        },
        {
          id: "39180",
          name: "Norrtalje",
          state_id: "3416",
        },
        {
          id: "39181",
          name: "Norsborg",
          state_id: "3416",
        },
        {
          id: "39182",
          name: "Nynashamn",
          state_id: "3416",
        },
        {
          id: "39183",
          name: "Rosersberg",
          state_id: "3416",
        },
        {
          id: "39184",
          name: "Sodertalje",
          state_id: "3416",
        },
        {
          id: "39185",
          name: "Sollentuna",
          state_id: "3416",
        },
        {
          id: "39186",
          name: "Stockholm",
          state_id: "3416",
        },
        {
          id: "39187",
          name: "Sundbyberg",
          state_id: "3416",
        },
        {
          id: "39188",
          name: "Taby",
          state_id: "3416",
        },
        {
          id: "39189",
          name: "Tumba",
          state_id: "3416",
        },
        {
          id: "39190",
          name: "Upplands-Vasby",
          state_id: "3416",
        },
        {
          id: "39191",
          name: "Vallentuna",
          state_id: "3416",
        },
        {
          id: "39192",
          name: "Vasterhaninge",
          state_id: "3416",
        },
      ],
      Uppsala: [
        {
          id: "39193",
          name: "Balsta",
          state_id: "3417",
        },
        {
          id: "39194",
          name: "Enkoping",
          state_id: "3417",
        },
        {
          id: "39195",
          name: "Knivsta",
          state_id: "3417",
        },
        {
          id: "39196",
          name: "Skyttorp",
          state_id: "3417",
        },
        {
          id: "39197",
          name: "Storvreta",
          state_id: "3417",
        },
        {
          id: "39198",
          name: "Uppsala",
          state_id: "3417",
        },
      ],
      Varmland: [
        {
          id: "39199",
          name: "Arvika",
          state_id: "3418",
        },
        {
          id: "39200",
          name: "Hammaro",
          state_id: "3418",
        },
        {
          id: "39201",
          name: "Karlstad",
          state_id: "3418",
        },
        {
          id: "39202",
          name: "Kristinehamn",
          state_id: "3418",
        },
        {
          id: "39203",
          name: "Skoghall",
          state_id: "3418",
        },
      ],
      Vasterbotten: [
        {
          id: "39204",
          name: "Guglingen",
          state_id: "3419",
        },
        {
          id: "39205",
          name: "Robertsfors",
          state_id: "3419",
        },
        {
          id: "39206",
          name: "Skelleftea",
          state_id: "3419",
        },
        {
          id: "39207",
          name: "Umea",
          state_id: "3419",
        },
      ],
      Vastergotland: [
        {
          id: "39208",
          name: "Gothenburg",
          state_id: "3420",
        },
        {
          id: "39209",
          name: "Kallered",
          state_id: "3420",
        },
        {
          id: "39210",
          name: "Kvanum",
          state_id: "3420",
        },
        {
          id: "39211",
          name: "Timmersdala",
          state_id: "3420",
        },
      ],
      Vasternorrland: [
        {
          id: "39212",
          name: "Harnosand",
          state_id: "3421",
        },
        {
          id: "39213",
          name: "Ornskoldsvik",
          state_id: "3421",
        },
        {
          id: "39214",
          name: "Sundsvall",
          state_id: "3421",
        },
      ],
      Vastmanland: [
        {
          id: "39215",
          name: "Arboga",
          state_id: "3422",
        },
        {
          id: "39216",
          name: "Fagersta",
          state_id: "3422",
        },
        {
          id: "39217",
          name: "Hallstahammar",
          state_id: "3422",
        },
        {
          id: "39218",
          name: "Koping",
          state_id: "3422",
        },
        {
          id: "39219",
          name: "Sala",
          state_id: "3422",
        },
        {
          id: "39220",
          name: "Vasteras",
          state_id: "3422",
        },
      ],
      "Vastra Gotaland": [],
    },
  },
  SG: {
    name: "Singapore",
    native: "Singapore",
    phone: "65",
    continent: "AS",
    capital: "Singapore",
    currency: "SGD",
    languages: ["en", "ms", "ta", "zh"],
    emoji: "🇸🇬",
    emojiU: "U+1F1F8 U+1F1EC",
    states: {
      Singapore: [
        {
          id: "37541",
          name: "Singapore",
          state_id: "3186",
        },
      ],
    },
  },
  SH: {
    name: "Saint Helena",
    native: "Saint Helena",
    phone: "290",
    continent: "AF",
    capital: "Jamestown",
    currency: "SHP",
    languages: ["en"],
    emoji: "🇸🇭",
    emojiU: "U+1F1F8 U+1F1ED",
    states: {
      Ascension: [
        {
          id: "37369",
          name: "Georgetown",
          state_id: "3084",
        },
      ],
      "Gough Island": [],
      "Saint Helena": [],
      "Tristan da Cunha": [],
    },
  },
  SI: {
    name: "Slovenia",
    native: "Slovenija",
    phone: "386",
    continent: "EU",
    capital: "Ljubljana",
    currency: "EUR",
    languages: ["sl"],
    emoji: "🇸🇮",
    emojiU: "U+1F1F8 U+1F1EE",
    states: {
      Benedikt: [
        {
          id: "37715",
          name: "Semic",
          state_id: "3195",
        },
        {
          id: "37716",
          name: "Skofljica",
          state_id: "3195",
        },
        {
          id: "37717",
          name: "Zelezniki",
          state_id: "3195",
        },
      ],
      Gorenjska: [
        {
          id: "37718",
          name: "Begunje na Gorenjskem",
          state_id: "3196",
        },
        {
          id: "37719",
          name: "Bistrica ob Trzhichu",
          state_id: "3196",
        },
        {
          id: "37720",
          name: "Bled",
          state_id: "3196",
        },
        {
          id: "37721",
          name: "Blejska Dobrava",
          state_id: "3196",
        },
        {
          id: "37722",
          name: "Bohinjska Bistrica",
          state_id: "3196",
        },
        {
          id: "37723",
          name: "Britof",
          state_id: "3196",
        },
        {
          id: "37724",
          name: "Cerklje na Gorenjskem",
          state_id: "3196",
        },
        {
          id: "37725",
          name: "Golnik",
          state_id: "3196",
        },
        {
          id: "37726",
          name: "Gorenja Vas",
          state_id: "3196",
        },
        {
          id: "37727",
          name: "Hrastje",
          state_id: "3196",
        },
        {
          id: "37728",
          name: "Hrushica",
          state_id: "3196",
        },
        {
          id: "37729",
          name: "Jesenice",
          state_id: "3196",
        },
        {
          id: "37730",
          name: "Kokrica",
          state_id: "3196",
        },
        {
          id: "37731",
          name: "Koroshka Bela",
          state_id: "3196",
        },
        {
          id: "37732",
          name: "Kranj",
          state_id: "3196",
        },
        {
          id: "37733",
          name: "Kranjska Gora",
          state_id: "3196",
        },
        {
          id: "37734",
          name: "Krizhe",
          state_id: "3196",
        },
        {
          id: "37735",
          name: "Kropa",
          state_id: "3196",
        },
        {
          id: "37736",
          name: "Lesce",
          state_id: "3196",
        },
        {
          id: "37737",
          name: "Mlaka pri Kranju",
          state_id: "3196",
        },
        {
          id: "37738",
          name: "Mojstrana",
          state_id: "3196",
        },
        {
          id: "37739",
          name: "Preddvor",
          state_id: "3196",
        },
        {
          id: "37740",
          name: "Predoslje",
          state_id: "3196",
        },
        {
          id: "37741",
          name: "Pristava",
          state_id: "3196",
        },
        {
          id: "37742",
          name: "Radovljica",
          state_id: "3196",
        },
        {
          id: "37743",
          name: "Shenchur",
          state_id: "3196",
        },
        {
          id: "37744",
          name: "Shkofja Loka",
          state_id: "3196",
        },
        {
          id: "37745",
          name: "Slovenski Javornik",
          state_id: "3196",
        },
        {
          id: "37746",
          name: "Spodnja Besnica",
          state_id: "3196",
        },
        {
          id: "37747",
          name: "Spodnje Gorje",
          state_id: "3196",
        },
        {
          id: "37748",
          name: "Stara Loka",
          state_id: "3196",
        },
        {
          id: "37749",
          name: "Sveti Duh",
          state_id: "3196",
        },
        {
          id: "37750",
          name: "Trzhich",
          state_id: "3196",
        },
        {
          id: "37751",
          name: "Visoko",
          state_id: "3196",
        },
        {
          id: "37752",
          name: "Zasip",
          state_id: "3196",
        },
        {
          id: "37753",
          name: "Zgornje Bitnje",
          state_id: "3196",
        },
        {
          id: "37754",
          name: "Zhelezniki",
          state_id: "3196",
        },
        {
          id: "37755",
          name: "Zhiri",
          state_id: "3196",
        },
      ],
      Gorishka: [
        {
          id: "37756",
          name: "Ajdovshchina",
          state_id: "3197",
        },
        {
          id: "37757",
          name: "Bilje",
          state_id: "3197",
        },
        {
          id: "37758",
          name: "Bovec",
          state_id: "3197",
        },
        {
          id: "37759",
          name: "Branik",
          state_id: "3197",
        },
        {
          id: "37760",
          name: "Cerkno",
          state_id: "3197",
        },
        {
          id: "37761",
          name: "Deskle",
          state_id: "3197",
        },
        {
          id: "37762",
          name: "Idrija",
          state_id: "3197",
        },
        {
          id: "37763",
          name: "Kanal",
          state_id: "3197",
        },
        {
          id: "37764",
          name: "Kobarid",
          state_id: "3197",
        },
        {
          id: "37765",
          name: "Kromberk",
          state_id: "3197",
        },
        {
          id: "37766",
          name: "Lokavec",
          state_id: "3197",
        },
        {
          id: "37767",
          name: "Miren",
          state_id: "3197",
        },
        {
          id: "37768",
          name: "Nova Gorica",
          state_id: "3197",
        },
        {
          id: "37769",
          name: "Prvachina",
          state_id: "3197",
        },
        {
          id: "37770",
          name: "Renche",
          state_id: "3197",
        },
        {
          id: "37771",
          name: "Rozhna Dolina",
          state_id: "3197",
        },
        {
          id: "37772",
          name: "Shempas",
          state_id: "3197",
        },
        {
          id: "37773",
          name: "Shempeter",
          state_id: "3197",
        },
        {
          id: "37774",
          name: "Solkan",
          state_id: "3197",
        },
        {
          id: "37775",
          name: "Spodnja Idrija",
          state_id: "3197",
        },
        {
          id: "37776",
          name: "Tolmin",
          state_id: "3197",
        },
        {
          id: "37777",
          name: "Vipava",
          state_id: "3197",
        },
        {
          id: "37778",
          name: "Vrtojba",
          state_id: "3197",
        },
      ],
      "Jugovzhodna Slovenija": [],
      Koroshka: [
        {
          id: "37779",
          name: "Chrna na Koroshkem",
          state_id: "3199",
        },
        {
          id: "37780",
          name: "Dravograd",
          state_id: "3199",
        },
        {
          id: "37781",
          name: "Legen",
          state_id: "3199",
        },
        {
          id: "37782",
          name: "Mezhica",
          state_id: "3199",
        },
        {
          id: "37783",
          name: "Mislinja",
          state_id: "3199",
        },
        {
          id: "37784",
          name: "Muta",
          state_id: "3199",
        },
        {
          id: "37785",
          name: "Otishki Vrh",
          state_id: "3199",
        },
        {
          id: "37786",
          name: "Pameche",
          state_id: "3199",
        },
        {
          id: "37787",
          name: "Podgorje",
          state_id: "3199",
        },
        {
          id: "37788",
          name: "Prevalje",
          state_id: "3199",
        },
        {
          id: "37789",
          name: "Radlje ob Dravi",
          state_id: "3199",
        },
        {
          id: "37790",
          name: "Ravne",
          state_id: "3199",
        },
        {
          id: "37791",
          name: "Shmartno pri Slovenj Gradcu",
          state_id: "3199",
        },
        {
          id: "37792",
          name: "Slovenj Gradec",
          state_id: "3199",
        },
        {
          id: "37793",
          name: "Vuhred",
          state_id: "3199",
        },
        {
          id: "37794",
          name: "Vuzenica",
          state_id: "3199",
        },
      ],
      "Notranjsko-krashka": [
        {
          id: "37795",
          name: "Cerknica",
          state_id: "3200",
        },
        {
          id: "37796",
          name: "Ilirska Bistrica",
          state_id: "3200",
        },
        {
          id: "37797",
          name: "Pivka",
          state_id: "3200",
        },
        {
          id: "37798",
          name: "Postojna",
          state_id: "3200",
        },
        {
          id: "37799",
          name: "Rakek",
          state_id: "3200",
        },
        {
          id: "37800",
          name: "Stari trg pri Lozhu",
          state_id: "3200",
        },
      ],
      "Obalno-krashka": [
        {
          id: "37801",
          name: "Ankaran",
          state_id: "3201",
        },
        {
          id: "37802",
          name: "Bertoki",
          state_id: "3201",
        },
        {
          id: "37803",
          name: "Dekani",
          state_id: "3201",
        },
        {
          id: "37804",
          name: "Divacha",
          state_id: "3201",
        },
        {
          id: "37805",
          name: "Hrvatni",
          state_id: "3201",
        },
        {
          id: "37806",
          name: "Izola",
          state_id: "3201",
        },
        {
          id: "37807",
          name: "Jagodje",
          state_id: "3201",
        },
        {
          id: "37808",
          name: "Koper",
          state_id: "3201",
        },
        {
          id: "37809",
          name: "Lucija",
          state_id: "3201",
        },
        {
          id: "37810",
          name: "Pareceg",
          state_id: "3201",
        },
        {
          id: "37811",
          name: "Piran",
          state_id: "3201",
        },
        {
          id: "37812",
          name: "Pobegi",
          state_id: "3201",
        },
        {
          id: "37813",
          name: "Portorozh",
          state_id: "3201",
        },
        {
          id: "37814",
          name: "Prade",
          state_id: "3201",
        },
        {
          id: "37815",
          name: "Secha",
          state_id: "3201",
        },
        {
          id: "37816",
          name: "Sezhana",
          state_id: "3201",
        },
        {
          id: "37817",
          name: "Spodnje Shkofije",
          state_id: "3201",
        },
        {
          id: "37818",
          name: "Sveti Anton",
          state_id: "3201",
        },
      ],
      "Obcina Domzale": [],
      "Obcina Vitanje": [],
      Osrednjeslovenska: [
        {
          id: "37819",
          name: "Borovnica",
          state_id: "3204",
        },
        {
          id: "37820",
          name: "Brezovica pri Ljubljani",
          state_id: "3204",
        },
        {
          id: "37821",
          name: "Dob",
          state_id: "3204",
        },
        {
          id: "37822",
          name: "Dobrova",
          state_id: "3204",
        },
        {
          id: "37823",
          name: "Domzhale",
          state_id: "3204",
        },
        {
          id: "37824",
          name: "Dragomer",
          state_id: "3204",
        },
        {
          id: "37825",
          name: "Grosuplje",
          state_id: "3204",
        },
        {
          id: "37826",
          name: "Horjul",
          state_id: "3204",
        },
        {
          id: "37827",
          name: "Ig",
          state_id: "3204",
        },
        {
          id: "37828",
          name: "Ivanchna Gorica",
          state_id: "3204",
        },
        {
          id: "37829",
          name: "Kamnik",
          state_id: "3204",
        },
        {
          id: "37830",
          name: "Komenda",
          state_id: "3204",
        },
        {
          id: "37831",
          name: "Lavrica",
          state_id: "3204",
        },
        {
          id: "37832",
          name: "Litija",
          state_id: "3204",
        },
        {
          id: "37833",
          name: "Ljubljana",
          state_id: "3204",
        },
        {
          id: "37834",
          name: "Log pri Brezovici",
          state_id: "3204",
        },
        {
          id: "37835",
          name: "Logatec",
          state_id: "3204",
        },
        {
          id: "37836",
          name: "Medvode",
          state_id: "3204",
        },
        {
          id: "37837",
          name: "Mekinje",
          state_id: "3204",
        },
        {
          id: "37838",
          name: "Mengesh",
          state_id: "3204",
        },
        {
          id: "37839",
          name: "Moravche",
          state_id: "3204",
        },
        {
          id: "37840",
          name: "Notranje",
          state_id: "3204",
        },
        {
          id: "37841",
          name: "Podgorje",
          state_id: "3204",
        },
        {
          id: "37842",
          name: "Preserje pri Radomljah",
          state_id: "3204",
        },
        {
          id: "37843",
          name: "Radomlje",
          state_id: "3204",
        },
        {
          id: "37844",
          name: "Rovte",
          state_id: "3204",
        },
        {
          id: "37845",
          name: "Shentvid pri Stichni",
          state_id: "3204",
        },
        {
          id: "37846",
          name: "Shkofljica",
          state_id: "3204",
        },
        {
          id: "37847",
          name: "Shmarca",
          state_id: "3204",
        },
        {
          id: "37848",
          name: "Shmartno pri Litiji",
          state_id: "3204",
        },
        {
          id: "37849",
          name: "Smarje-Sap",
          state_id: "3204",
        },
        {
          id: "37850",
          name: "Trzin",
          state_id: "3204",
        },
        {
          id: "37851",
          name: "Verd",
          state_id: "3204",
        },
        {
          id: "37852",
          name: "Vir",
          state_id: "3204",
        },
        {
          id: "37853",
          name: "Vishnja Gora",
          state_id: "3204",
        },
        {
          id: "37854",
          name: "Vnanje Gorice",
          state_id: "3204",
        },
        {
          id: "37855",
          name: "Vodice",
          state_id: "3204",
        },
        {
          id: "37856",
          name: "Vrhnika",
          state_id: "3204",
        },
        {
          id: "37857",
          name: "Zgornje Pirniche",
          state_id: "3204",
        },
      ],
      Podravska: [
        {
          id: "37858",
          name: "Bistrica ob Dravi",
          state_id: "3205",
        },
        {
          id: "37859",
          name: "Bresternica",
          state_id: "3205",
        },
        {
          id: "37860",
          name: "Bukovci",
          state_id: "3205",
        },
        {
          id: "37861",
          name: "Dogoshe",
          state_id: "3205",
        },
        {
          id: "37862",
          name: "Dornava",
          state_id: "3205",
        },
        {
          id: "37863",
          name: "Fram",
          state_id: "3205",
        },
        {
          id: "37864",
          name: "Hotinja Vas",
          state_id: "3205",
        },
        {
          id: "37865",
          name: "Kamnica",
          state_id: "3205",
        },
        {
          id: "37866",
          name: "Kidrichevo",
          state_id: "3205",
        },
        {
          id: "37867",
          name: "Koshaki",
          state_id: "3205",
        },
        {
          id: "37868",
          name: "Krchevina pri Vurbergu",
          state_id: "3205",
        },
        {
          id: "37869",
          name: "Lenart",
          state_id: "3205",
        },
        {
          id: "37870",
          name: "Limbush",
          state_id: "3205",
        },
        {
          id: "37871",
          name: "Lovrenc na Pohorju",
          state_id: "3205",
        },
        {
          id: "37872",
          name: "Maribor",
          state_id: "3205",
        },
        {
          id: "37873",
          name: "Miklavzh na Dravskem Polju",
          state_id: "3205",
        },
        {
          id: "37874",
          name: "Ormozh",
          state_id: "3205",
        },
        {
          id: "37875",
          name: "Pekre",
          state_id: "3205",
        },
        {
          id: "37876",
          name: "Pesnica pri Mariboru",
          state_id: "3205",
        },
        {
          id: "37877",
          name: "Pobrezhje",
          state_id: "3205",
        },
        {
          id: "37878",
          name: "Podvinci",
          state_id: "3205",
        },
        {
          id: "37879",
          name: "Poljchane",
          state_id: "3205",
        },
        {
          id: "37880",
          name: "Pragersko",
          state_id: "3205",
        },
        {
          id: "37881",
          name: "Ptuj",
          state_id: "3205",
        },
        {
          id: "37882",
          name: "Rache",
          state_id: "3205",
        },
        {
          id: "37883",
          name: "Radizel",
          state_id: "3205",
        },
        {
          id: "37884",
          name: "Razvanje",
          state_id: "3205",
        },
        {
          id: "37885",
          name: "Rogoza",
          state_id: "3205",
        },
        {
          id: "37886",
          name: "Rushe",
          state_id: "3205",
        },
        {
          id: "37887",
          name: "Selnica ob Dravi",
          state_id: "3205",
        },
        {
          id: "37888",
          name: "Selnica ob Muri",
          state_id: "3205",
        },
        {
          id: "37889",
          name: "Shentilj",
          state_id: "3205",
        },
        {
          id: "37890",
          name: "Skoke",
          state_id: "3205",
        },
        {
          id: "37891",
          name: "Slovenska Bistrica",
          state_id: "3205",
        },
        {
          id: "37892",
          name: "Spodnja Polskava",
          state_id: "3205",
        },
        {
          id: "37893",
          name: "Spodnje Hoche",
          state_id: "3205",
        },
        {
          id: "37894",
          name: "Spodnji Duplek",
          state_id: "3205",
        },
        {
          id: "37895",
          name: "Spuhlja",
          state_id: "3205",
        },
        {
          id: "37896",
          name: "Sredishche ob Dravi",
          state_id: "3205",
        },
        {
          id: "37897",
          name: "Stojnci",
          state_id: "3205",
        },
        {
          id: "37898",
          name: "Zgornja Polskava",
          state_id: "3205",
        },
        {
          id: "37899",
          name: "Zgornje Poljchane",
          state_id: "3205",
        },
        {
          id: "37900",
          name: "Zgornji Duplek",
          state_id: "3205",
        },
      ],
      Pomurska: [
        {
          id: "37901",
          name: "Bakovci",
          state_id: "3206",
        },
        {
          id: "37902",
          name: "Beltinci",
          state_id: "3206",
        },
        {
          id: "37903",
          name: "Chernelavci",
          state_id: "3206",
        },
        {
          id: "37904",
          name: "Chrenshovci",
          state_id: "3206",
        },
        {
          id: "37905",
          name: "Dobrovnik",
          state_id: "3206",
        },
        {
          id: "37906",
          name: "Doklezhovje",
          state_id: "3206",
        },
        {
          id: "37907",
          name: "Ganchani",
          state_id: "3206",
        },
        {
          id: "37908",
          name: "Gornja Radgona",
          state_id: "3206",
        },
        {
          id: "37909",
          name: "Izhakovci",
          state_id: "3206",
        },
        {
          id: "37910",
          name: "Krog",
          state_id: "3206",
        },
        {
          id: "37911",
          name: "Lendava",
          state_id: "3206",
        },
        {
          id: "37912",
          name: "Lipovci",
          state_id: "3206",
        },
        {
          id: "37913",
          name: "Ljutomer",
          state_id: "3206",
        },
        {
          id: "37914",
          name: "Melinci",
          state_id: "3206",
        },
        {
          id: "37915",
          name: "Murska Sobota",
          state_id: "3206",
        },
        {
          id: "37916",
          name: "Odranci",
          state_id: "3206",
        },
        {
          id: "37917",
          name: "Petishovci",
          state_id: "3206",
        },
        {
          id: "37918",
          name: "Radenci",
          state_id: "3206",
        },
        {
          id: "37919",
          name: "Rakichan",
          state_id: "3206",
        },
        {
          id: "37920",
          name: "Turnishche",
          state_id: "3206",
        },
        {
          id: "37921",
          name: "Velika Polana",
          state_id: "3206",
        },
        {
          id: "37922",
          name: "Verzej",
          state_id: "3206",
        },
      ],
      Savinjska: [
        {
          id: "37923",
          name: "Breg pri Polzeli",
          state_id: "3207",
        },
        {
          id: "37924",
          name: "Celje",
          state_id: "3207",
        },
        {
          id: "37925",
          name: "Gornji Grad",
          state_id: "3207",
        },
        {
          id: "37926",
          name: "Gotovlje",
          state_id: "3207",
        },
        {
          id: "37927",
          name: "Kasaze",
          state_id: "3207",
        },
        {
          id: "37928",
          name: "Lashko",
          state_id: "3207",
        },
        {
          id: "37929",
          name: "Ljubechna",
          state_id: "3207",
        },
        {
          id: "37930",
          name: "Ljubno ob Savinji",
          state_id: "3207",
        },
        {
          id: "37931",
          name: "Loka pri Zusmu",
          state_id: "3207",
        },
        {
          id: "37932",
          name: "Lokovica",
          state_id: "3207",
        },
        {
          id: "37933",
          name: "Mozirje",
          state_id: "3207",
        },
        {
          id: "37934",
          name: "Naklo",
          state_id: "3207",
        },
        {
          id: "37935",
          name: "Nazarje",
          state_id: "3207",
        },
        {
          id: "37936",
          name: "Oplotnica",
          state_id: "3207",
        },
        {
          id: "37937",
          name: "Petrovche",
          state_id: "3207",
        },
        {
          id: "37938",
          name: "Polzela",
          state_id: "3207",
        },
        {
          id: "37939",
          name: "Prebold",
          state_id: "3207",
        },
        {
          id: "37940",
          name: "Radeche",
          state_id: "3207",
        },
        {
          id: "37941",
          name: "Ravne",
          state_id: "3207",
        },
        {
          id: "37942",
          name: "Rimske Toplica",
          state_id: "3207",
        },
        {
          id: "37943",
          name: "Rogashka Slatina",
          state_id: "3207",
        },
        {
          id: "37944",
          name: "Rogatec",
          state_id: "3207",
        },
        {
          id: "37945",
          name: "Sentjernej",
          state_id: "3207",
        },
        {
          id: "37946",
          name: "Shempeter",
          state_id: "3207",
        },
        {
          id: "37947",
          name: "Shentjur",
          state_id: "3207",
        },
        {
          id: "37948",
          name: "Shkale",
          state_id: "3207",
        },
        {
          id: "37949",
          name: "Shmarje pri Jelshah",
          state_id: "3207",
        },
        {
          id: "37950",
          name: "Shoshtanj",
          state_id: "3207",
        },
        {
          id: "37951",
          name: "Shtore",
          state_id: "3207",
        },
        {
          id: "37952",
          name: "Slovenske Konjice",
          state_id: "3207",
        },
        {
          id: "37953",
          name: "Topolshica",
          state_id: "3207",
        },
        {
          id: "37954",
          name: "Trnovlje pri Celju",
          state_id: "3207",
        },
        {
          id: "37955",
          name: "Velenje",
          state_id: "3207",
        },
        {
          id: "37956",
          name: "Vitanje",
          state_id: "3207",
        },
        {
          id: "37957",
          name: "Vojnik",
          state_id: "3207",
        },
        {
          id: "37958",
          name: "Zabukovica",
          state_id: "3207",
        },
        {
          id: "37959",
          name: "Zadobrova",
          state_id: "3207",
        },
        {
          id: "37960",
          name: "Zhalec",
          state_id: "3207",
        },
        {
          id: "37961",
          name: "Zreche",
          state_id: "3207",
        },
      ],
      "Slovenian Littoral": [],
      Spodnjeposavska: [
        {
          id: "37962",
          name: "Brestanica",
          state_id: "3209",
        },
        {
          id: "37963",
          name: "Brezhice",
          state_id: "3209",
        },
        {
          id: "37964",
          name: "Krshko",
          state_id: "3209",
        },
        {
          id: "37965",
          name: "Leskovac pri Krshkem",
          state_id: "3209",
        },
        {
          id: "37966",
          name: "Senovo",
          state_id: "3209",
        },
        {
          id: "37967",
          name: "Sevnica",
          state_id: "3209",
        },
      ],
      Zasavska: [
        {
          id: "37968",
          name: "Dol pri Hrastniku",
          state_id: "3210",
        },
        {
          id: "37969",
          name: "Hrastnik",
          state_id: "3210",
        },
        {
          id: "37970",
          name: "Izlake",
          state_id: "3210",
        },
        {
          id: "37971",
          name: "Kisovec",
          state_id: "3210",
        },
        {
          id: "37972",
          name: "Trbovlje",
          state_id: "3210",
        },
        {
          id: "37973",
          name: "Zagorje ob Savi",
          state_id: "3210",
        },
      ],
    },
  },
  SJ: {
    name: "Svalbard and Jan Mayen",
    native: "Svalbard og Jan Mayen",
    phone: "4779",
    continent: "EU",
    capital: "Longyearbyen",
    currency: "NOK",
    languages: ["no"],
    emoji: "🇸🇯",
    emojiU: "U+1F1F8 U+1F1EF",
    states: {
      Svalbard: [
        {
          id: "39050",
          name: "Barentsburg",
          state_id: "3390",
        },
        {
          id: "39051",
          name: "Hornsund",
          state_id: "3390",
        },
        {
          id: "39052",
          name: "Isfjord Radio",
          state_id: "3390",
        },
        {
          id: "39053",
          name: "Longyearbyen",
          state_id: "3390",
        },
        {
          id: "39054",
          name: "Ny-Alesund",
          state_id: "3390",
        },
      ],
    },
  },
  SK: {
    name: "Slovakia",
    native: "Slovensko",
    phone: "421",
    continent: "EU",
    capital: "Bratislava",
    currency: "EUR",
    languages: ["sk"],
    emoji: "🇸🇰",
    emojiU: "U+1F1F8 U+1F1F0",
    states: {
      Banskobystricky: [
        {
          id: "37542",
          name: "Banska Bystrica",
          state_id: "3187",
        },
        {
          id: "37543",
          name: "Banska Shtiavnica",
          state_id: "3187",
        },
        {
          id: "37544",
          name: "Brezno",
          state_id: "3187",
        },
        {
          id: "37545",
          name: "Chierny Balog",
          state_id: "3187",
        },
        {
          id: "37546",
          name: "Detva",
          state_id: "3187",
        },
        {
          id: "37547",
          name: "Fil''akovo",
          state_id: "3187",
        },
        {
          id: "37548",
          name: "Hnusht''a",
          state_id: "3187",
        },
        {
          id: "37549",
          name: "Hrinova",
          state_id: "3187",
        },
        {
          id: "37550",
          name: "Kremnica",
          state_id: "3187",
        },
        {
          id: "37551",
          name: "Krupina",
          state_id: "3187",
        },
        {
          id: "37552",
          name: "Luchenec",
          state_id: "3187",
        },
        {
          id: "37553",
          name: "Nova Bana",
          state_id: "3187",
        },
        {
          id: "37554",
          name: "Podbrezova",
          state_id: "3187",
        },
        {
          id: "37555",
          name: "Poltar",
          state_id: "3187",
        },
        {
          id: "37556",
          name: "Revuca",
          state_id: "3187",
        },
        {
          id: "37557",
          name: "Rimavska Sobota",
          state_id: "3187",
        },
        {
          id: "37558",
          name: "Sliach",
          state_id: "3187",
        },
        {
          id: "37559",
          name: "Tisovec",
          state_id: "3187",
        },
        {
          id: "37560",
          name: "Tornal''a",
          state_id: "3187",
        },
        {
          id: "37561",
          name: "Vel''ky Krtish",
          state_id: "3187",
        },
        {
          id: "37562",
          name: "Vlkanova",
          state_id: "3187",
        },
        {
          id: "37563",
          name: "Zharnovica",
          state_id: "3187",
        },
        {
          id: "37564",
          name: "Zhiar",
          state_id: "3187",
        },
        {
          id: "37565",
          name: "Ziar nad Hronom",
          state_id: "3187",
        },
        {
          id: "37566",
          name: "Zvolen",
          state_id: "3187",
        },
      ],
      Bratislavsky: [
        {
          id: "37567",
          name: "Bernolakovo",
          state_id: "3188",
        },
        {
          id: "37568",
          name: "Bratislava",
          state_id: "3188",
        },
        {
          id: "37569",
          name: "Ivanka pri Dunaji",
          state_id: "3188",
        },
        {
          id: "37570",
          name: "Malacky",
          state_id: "3188",
        },
        {
          id: "37571",
          name: "Modra",
          state_id: "3188",
        },
        {
          id: "37572",
          name: "Pezinok",
          state_id: "3188",
        },
        {
          id: "37573",
          name: "Senec",
          state_id: "3188",
        },
        {
          id: "37574",
          name: "Shenkvice",
          state_id: "3188",
        },
        {
          id: "37575",
          name: "Stupava",
          state_id: "3188",
        },
        {
          id: "37576",
          name: "Svaty Jur",
          state_id: "3188",
        },
      ],
      Kosicky: [
        {
          id: "37577",
          name: "Chana",
          state_id: "3189",
        },
        {
          id: "37578",
          name: "Chierna nad Tisou",
          state_id: "3189",
        },
        {
          id: "37579",
          name: "Dobshina",
          state_id: "3189",
        },
        {
          id: "37580",
          name: "Gelnica",
          state_id: "3189",
        },
        {
          id: "37581",
          name: "Kosice",
          state_id: "3189",
        },
        {
          id: "37582",
          name: "Kral''ovsky Chlmec",
          state_id: "3189",
        },
        {
          id: "37583",
          name: "Krompachy",
          state_id: "3189",
        },
        {
          id: "37584",
          name: "Medzev",
          state_id: "3189",
        },
        {
          id: "37585",
          name: "Michalovce",
          state_id: "3189",
        },
        {
          id: "37586",
          name: "Moldava nad Bodvou",
          state_id: "3189",
        },
        {
          id: "37587",
          name: "Pavlovce nad Uhom",
          state_id: "3189",
        },
        {
          id: "37588",
          name: "Rozhnava",
          state_id: "3189",
        },
        {
          id: "37589",
          name: "Sechovce",
          state_id: "3189",
        },
        {
          id: "37590",
          name: "Smizhany",
          state_id: "3189",
        },
        {
          id: "37591",
          name: "Sobrance",
          state_id: "3189",
        },
        {
          id: "37592",
          name: "Strazhske",
          state_id: "3189",
        },
        {
          id: "37593",
          name: "Trebishov",
          state_id: "3189",
        },
        {
          id: "37594",
          name: "Vel''ke Kapushany",
          state_id: "3189",
        },
        {
          id: "37595",
          name: "Vranov",
          state_id: "3189",
        },
      ],
      Nitriansky: [
        {
          id: "37596",
          name: "Dvory nad Zhitavou",
          state_id: "3190",
        },
        {
          id: "37597",
          name: "Hurbanovo",
          state_id: "3190",
        },
        {
          id: "37598",
          name: "Kolarovo",
          state_id: "3190",
        },
        {
          id: "37599",
          name: "Komarno",
          state_id: "3190",
        },
        {
          id: "37600",
          name: "Komjatice",
          state_id: "3190",
        },
        {
          id: "37601",
          name: "Levice",
          state_id: "3190",
        },
        {
          id: "37602",
          name: "Levocha",
          state_id: "3190",
        },
        {
          id: "37603",
          name: "Mocenok",
          state_id: "3190",
        },
        {
          id: "37604",
          name: "Nesvady",
          state_id: "3190",
        },
        {
          id: "37605",
          name: "Nitra",
          state_id: "3190",
        },
        {
          id: "37606",
          name: "Nove Zamky",
          state_id: "3190",
        },
        {
          id: "37607",
          name: "Palarikovo",
          state_id: "3190",
        },
        {
          id: "37608",
          name: "Shahy",
          state_id: "3190",
        },
        {
          id: "37609",
          name: "Shal''a",
          state_id: "3190",
        },
        {
          id: "37610",
          name: "Shturovo",
          state_id: "3190",
        },
        {
          id: "37611",
          name: "Shurany",
          state_id: "3190",
        },
        {
          id: "37612",
          name: "Svodin",
          state_id: "3190",
        },
        {
          id: "37613",
          name: "Tlmache",
          state_id: "3190",
        },
        {
          id: "37614",
          name: "Tvrdoshovce",
          state_id: "3190",
        },
        {
          id: "37615",
          name: "Vrable",
          state_id: "3190",
        },
        {
          id: "37616",
          name: "Zlate Moravce",
          state_id: "3190",
        },
      ],
      Presovsky: [
        {
          id: "37617",
          name: "Bardejov",
          state_id: "3191",
        },
        {
          id: "37618",
          name: "Giraltovce",
          state_id: "3191",
        },
        {
          id: "37619",
          name: "Humenne",
          state_id: "3191",
        },
        {
          id: "37620",
          name: "Jarovnice",
          state_id: "3191",
        },
        {
          id: "37621",
          name: "Kezhmarok",
          state_id: "3191",
        },
        {
          id: "37622",
          name: "Lipany",
          state_id: "3191",
        },
        {
          id: "37623",
          name: "Medzilaborce",
          state_id: "3191",
        },
        {
          id: "37624",
          name: "Podolinec",
          state_id: "3191",
        },
        {
          id: "37625",
          name: "Poprad",
          state_id: "3191",
        },
        {
          id: "37626",
          name: "Preshov",
          state_id: "3191",
        },
        {
          id: "37627",
          name: "Presov",
          state_id: "3191",
        },
        {
          id: "37628",
          name: "Sabinov",
          state_id: "3191",
        },
        {
          id: "37629",
          name: "Snina",
          state_id: "3191",
        },
        {
          id: "37630",
          name: "Spishska Bela",
          state_id: "3191",
        },
        {
          id: "37631",
          name: "Spishska Nova Ves",
          state_id: "3191",
        },
        {
          id: "37632",
          name: "Spishske Podhradie",
          state_id: "3191",
        },
        {
          id: "37633",
          name: "Stara L''ubovna",
          state_id: "3191",
        },
        {
          id: "37634",
          name: "Stropkov",
          state_id: "3191",
        },
        {
          id: "37635",
          name: "Svidnik",
          state_id: "3191",
        },
        {
          id: "37636",
          name: "Svit",
          state_id: "3191",
        },
        {
          id: "37637",
          name: "Vel''ky Sharish",
          state_id: "3191",
        },
        {
          id: "37638",
          name: "Vysoke Tatry",
          state_id: "3191",
        },
      ],
      Trenciansky: [
        {
          id: "37639",
          name: "Banovce",
          state_id: "3192",
        },
        {
          id: "37640",
          name: "Belusha",
          state_id: "3192",
        },
        {
          id: "37641",
          name: "Bojnice",
          state_id: "3192",
        },
        {
          id: "37642",
          name: "Boshany",
          state_id: "3192",
        },
        {
          id: "37643",
          name: "Dubnica",
          state_id: "3192",
        },
        {
          id: "37644",
          name: "Handlova",
          state_id: "3192",
        },
        {
          id: "37645",
          name: "Ilava",
          state_id: "3192",
        },
        {
          id: "37646",
          name: "Lednicke Rovne",
          state_id: "3192",
        },
        {
          id: "37647",
          name: "Lendak",
          state_id: "3192",
        },
        {
          id: "37648",
          name: "Myjava",
          state_id: "3192",
        },
        {
          id: "37649",
          name: "Nemshova",
          state_id: "3192",
        },
        {
          id: "37650",
          name: "Nova Dubnica",
          state_id: "3192",
        },
        {
          id: "37651",
          name: "Novaky",
          state_id: "3192",
        },
        {
          id: "37652",
          name: "Nove Mesto",
          state_id: "3192",
        },
        {
          id: "37653",
          name: "Partizanske",
          state_id: "3192",
        },
        {
          id: "37654",
          name: "Povazhska Bystrica",
          state_id: "3192",
        },
        {
          id: "37655",
          name: "Prievidza",
          state_id: "3192",
        },
        {
          id: "37656",
          name: "Puchov",
          state_id: "3192",
        },
        {
          id: "37657",
          name: "Stara Tura",
          state_id: "3192",
        },
        {
          id: "37658",
          name: "Topol''chany",
          state_id: "3192",
        },
        {
          id: "37659",
          name: "Trenchianske Teplice",
          state_id: "3192",
        },
        {
          id: "37660",
          name: "Trenchin",
          state_id: "3192",
        },
        {
          id: "37661",
          name: "Trencin",
          state_id: "3192",
        },
      ],
      Trnavsky: [
        {
          id: "37662",
          name: "Brezova pod Bradlom",
          state_id: "3193",
        },
        {
          id: "37663",
          name: "Dunajska Streda",
          state_id: "3193",
        },
        {
          id: "37664",
          name: "Gabchikovo",
          state_id: "3193",
        },
        {
          id: "37665",
          name: "Galanta",
          state_id: "3193",
        },
        {
          id: "37666",
          name: "Gbely",
          state_id: "3193",
        },
        {
          id: "37667",
          name: "Hlohovec",
          state_id: "3193",
        },
        {
          id: "37668",
          name: "Holich",
          state_id: "3193",
        },
        {
          id: "37669",
          name: "Kuty",
          state_id: "3193",
        },
        {
          id: "37670",
          name: "Leopoldov",
          state_id: "3193",
        },
        {
          id: "37671",
          name: "Piesht''any",
          state_id: "3193",
        },
        {
          id: "37672",
          name: "Piestany",
          state_id: "3193",
        },
        {
          id: "37673",
          name: "Senica",
          state_id: "3193",
        },
        {
          id: "37674",
          name: "Sered",
          state_id: "3193",
        },
        {
          id: "37675",
          name: "Shamorin",
          state_id: "3193",
        },
        {
          id: "37676",
          name: "Shashtin-Strazhe",
          state_id: "3193",
        },
        {
          id: "37677",
          name: "Shoporna",
          state_id: "3193",
        },
        {
          id: "37678",
          name: "Skalica",
          state_id: "3193",
        },
        {
          id: "37679",
          name: "Sladkovichovo",
          state_id: "3193",
        },
        {
          id: "37680",
          name: "Trnava",
          state_id: "3193",
        },
        {
          id: "37681",
          name: "Vel''ke Ul''any",
          state_id: "3193",
        },
        {
          id: "37682",
          name: "Vel''ky Meder",
          state_id: "3193",
        },
        {
          id: "37683",
          name: "Vrbove",
          state_id: "3193",
        },
      ],
      Zilinsky: [
        {
          id: "37684",
          name: "Bytcha",
          state_id: "3194",
        },
        {
          id: "37685",
          name: "Chadca",
          state_id: "3194",
        },
        {
          id: "37686",
          name: "Chierne",
          state_id: "3194",
        },
        {
          id: "37687",
          name: "Dolny Kubin",
          state_id: "3194",
        },
        {
          id: "37688",
          name: "Krasno nad Kysucou",
          state_id: "3194",
        },
        {
          id: "37689",
          name: "Kysucke Nove Mesto",
          state_id: "3194",
        },
        {
          id: "37690",
          name: "Liptovsky Hradok",
          state_id: "3194",
        },
        {
          id: "37691",
          name: "Liptovsky Mikulash",
          state_id: "3194",
        },
        {
          id: "37692",
          name: "Martin",
          state_id: "3194",
        },
        {
          id: "37693",
          name: "Namestovo",
          state_id: "3194",
        },
        {
          id: "37694",
          name: "Nizhna",
          state_id: "3194",
        },
        {
          id: "37695",
          name: "Oshchadnica",
          state_id: "3194",
        },
        {
          id: "37696",
          name: "Rabcha",
          state_id: "3194",
        },
        {
          id: "37697",
          name: "Rajec",
          state_id: "3194",
        },
        {
          id: "37698",
          name: "Rakova",
          state_id: "3194",
        },
        {
          id: "37699",
          name: "Ruzhomberok",
          state_id: "3194",
        },
        {
          id: "37700",
          name: "Ruzomberok",
          state_id: "3194",
        },
        {
          id: "37701",
          name: "Shtiavnik",
          state_id: "3194",
        },
        {
          id: "37702",
          name: "Skalite",
          state_id: "3194",
        },
        {
          id: "37703",
          name: "Suchany",
          state_id: "3194",
        },
        {
          id: "37704",
          name: "Terchova",
          state_id: "3194",
        },
        {
          id: "37705",
          name: "Trstena",
          state_id: "3194",
        },
        {
          id: "37706",
          name: "Turany",
          state_id: "3194",
        },
        {
          id: "37707",
          name: "Turchianske Teplice",
          state_id: "3194",
        },
        {
          id: "37708",
          name: "Turzovka",
          state_id: "3194",
        },
        {
          id: "37709",
          name: "Tvrdoshin",
          state_id: "3194",
        },
        {
          id: "37710",
          name: "Vel''ke Rovne",
          state_id: "3194",
        },
        {
          id: "37711",
          name: "Vrutky",
          state_id: "3194",
        },
        {
          id: "37712",
          name: "Zakamenne",
          state_id: "3194",
        },
        {
          id: "37713",
          name: "Zhilina",
          state_id: "3194",
        },
        {
          id: "37714",
          name: "Zilina",
          state_id: "3194",
        },
      ],
    },
  },
  SL: {
    name: "Sierra Leone",
    native: "Sierra Leone",
    phone: "232",
    continent: "AF",
    capital: "Freetown",
    currency: "SLL",
    languages: ["en"],
    emoji: "🇸🇱",
    emojiU: "U+1F1F8 U+1F1F1",
    states: {
      Eastern: [
        {
          id: "37511",
          name: "Biama",
          state_id: "3182",
        },
        {
          id: "37512",
          name: "Daru",
          state_id: "3182",
        },
        {
          id: "37513",
          name: "Kailahun",
          state_id: "3182",
        },
        {
          id: "37514",
          name: "Kenema",
          state_id: "3182",
        },
        {
          id: "37515",
          name: "Koidu",
          state_id: "3182",
        },
        {
          id: "37516",
          name: "Koindu",
          state_id: "3182",
        },
        {
          id: "37517",
          name: "Pendembu",
          state_id: "3182",
        },
        {
          id: "37518",
          name: "Sefadu",
          state_id: "3182",
        },
        {
          id: "37519",
          name: "Segbwema",
          state_id: "3182",
        },
        {
          id: "37520",
          name: "Yengema",
          state_id: "3182",
        },
      ],
      Northern: [
        {
          id: "37521",
          name: "Kabala",
          state_id: "3183",
        },
        {
          id: "37522",
          name: "Kambia",
          state_id: "3183",
        },
        {
          id: "37523",
          name: "Lungi",
          state_id: "3183",
        },
        {
          id: "37524",
          name: "Lunsar",
          state_id: "3183",
        },
        {
          id: "37525",
          name: "Magburaka",
          state_id: "3183",
        },
        {
          id: "37526",
          name: "Makeni",
          state_id: "3183",
        },
        {
          id: "37527",
          name: "Mambolo",
          state_id: "3183",
        },
        {
          id: "37528",
          name: "Moyamba",
          state_id: "3183",
        },
        {
          id: "37529",
          name: "Pepel",
          state_id: "3183",
        },
        {
          id: "37530",
          name: "Port Loko",
          state_id: "3183",
        },
        {
          id: "37531",
          name: "Yele",
          state_id: "3183",
        },
      ],
      Southern: [
        {
          id: "37532",
          name: "Binkolo",
          state_id: "3184",
        },
        {
          id: "37533",
          name: "Bo",
          state_id: "3184",
        },
        {
          id: "37534",
          name: "Bonthe",
          state_id: "3184",
        },
        {
          id: "37535",
          name: "Bumpe",
          state_id: "3184",
        },
        {
          id: "37536",
          name: "Matru",
          state_id: "3184",
        },
        {
          id: "37537",
          name: "Pujehun",
          state_id: "3184",
        },
        {
          id: "37538",
          name: "Taiama",
          state_id: "3184",
        },
      ],
      Western: [
        {
          id: "37539",
          name: "Freetown",
          state_id: "3185",
        },
        {
          id: "37540",
          name: "York",
          state_id: "3185",
        },
      ],
    },
  },
  SM: {
    name: "San Marino",
    native: "San Marino",
    phone: "378",
    continent: "EU",
    capital: "City of San Marino",
    currency: "EUR",
    languages: ["it"],
    emoji: "🇸🇲",
    emojiU: "U+1F1F8 U+1F1F2",
    states: {
      Acquaviva: [
        {
          id: "37398",
          name: "Acquaviva",
          state_id: "3131",
        },
      ],
      "Borgo Maggiore": [],
      Chiesanuova: [
        {
          id: "37399",
          name: "Chiesanuova",
          state_id: "3133",
        },
      ],
      Domagnano: [
        {
          id: "37400",
          name: "Domagnano",
          state_id: "3134",
        },
      ],
      Faetano: [
        {
          id: "37401",
          name: "Faetano",
          state_id: "3135",
        },
      ],
      Fiorentino: [
        {
          id: "37402",
          name: "Fiorentino",
          state_id: "3136",
        },
      ],
      Montegiardino: [
        {
          id: "37403",
          name: "Montegiardino",
          state_id: "3137",
        },
      ],
      "San Marino": [],
      Serravalle: [
        {
          id: "37404",
          name: "Serravalle",
          state_id: "3139",
        },
      ],
    },
  },
  SN: {
    name: "Senegal",
    native: "Sénégal",
    phone: "221",
    continent: "AF",
    capital: "Dakar",
    currency: "XOF",
    languages: ["fr"],
    emoji: "🇸🇳",
    emojiU: "U+1F1F8 U+1F1F3",
    states: {
      Dakar: [
        {
          id: "37446",
          name: "Dakar",
          state_id: "3164",
        },
      ],
      Diourbel: [
        {
          id: "37447",
          name: "Bambey",
          state_id: "3165",
        },
        {
          id: "37448",
          name: "Diourbel",
          state_id: "3165",
        },
        {
          id: "37449",
          name: "Mbacke",
          state_id: "3165",
        },
        {
          id: "37450",
          name: "Touba",
          state_id: "3165",
        },
      ],
      Fatick: [
        {
          id: "37451",
          name: "Diofior",
          state_id: "3166",
        },
        {
          id: "37452",
          name: "Fatick",
          state_id: "3166",
        },
        {
          id: "37453",
          name: "Foundiougne",
          state_id: "3166",
        },
        {
          id: "37454",
          name: "Gossas",
          state_id: "3166",
        },
        {
          id: "37455",
          name: "Guinguineo",
          state_id: "3166",
        },
        {
          id: "37456",
          name: "Kahone",
          state_id: "3166",
        },
        {
          id: "37457",
          name: "Passy",
          state_id: "3166",
        },
        {
          id: "37458",
          name: "Sokone",
          state_id: "3166",
        },
      ],
      Kaolack: [
        {
          id: "37459",
          name: "Gandiaye",
          state_id: "3167",
        },
        {
          id: "37460",
          name: "Kaffrine",
          state_id: "3167",
        },
        {
          id: "37461",
          name: "Kaolack",
          state_id: "3167",
        },
        {
          id: "37462",
          name: "Koungheul",
          state_id: "3167",
        },
        {
          id: "37463",
          name: "Medina",
          state_id: "3167",
        },
        {
          id: "37464",
          name: "Ndoffane Lagheme",
          state_id: "3167",
        },
        {
          id: "37465",
          name: "Nioro du Rip",
          state_id: "3167",
        },
        {
          id: "37466",
          name: "Toubakouta",
          state_id: "3167",
        },
      ],
      Kolda: [
        {
          id: "37467",
          name: "Dabo",
          state_id: "3168",
        },
        {
          id: "37468",
          name: "Goudomp",
          state_id: "3168",
        },
        {
          id: "37469",
          name: "Kolda",
          state_id: "3168",
        },
        {
          id: "37470",
          name: "Marsassoum",
          state_id: "3168",
        },
        {
          id: "37471",
          name: "Medina Gounas",
          state_id: "3168",
        },
        {
          id: "37472",
          name: "Sedhiou",
          state_id: "3168",
        },
        {
          id: "37473",
          name: "Velingara",
          state_id: "3168",
        },
        {
          id: "37474",
          name: "Wassadou",
          state_id: "3168",
        },
      ],
      Louga: [
        {
          id: "37475",
          name: "Dahra",
          state_id: "3169",
        },
        {
          id: "37476",
          name: "Kebemer",
          state_id: "3169",
        },
        {
          id: "37477",
          name: "Linguere",
          state_id: "3169",
        },
        {
          id: "37478",
          name: "Louga",
          state_id: "3169",
        },
      ],
      "Saint-Louis": [
        {
          id: "37479",
          name: "Dagana",
          state_id: "3170",
        },
        {
          id: "37480",
          name: "Gollere",
          state_id: "3170",
        },
        {
          id: "37481",
          name: "Kanel",
          state_id: "3170",
        },
        {
          id: "37482",
          name: "Matam",
          state_id: "3170",
        },
        {
          id: "37483",
          name: "Ndioum",
          state_id: "3170",
        },
        {
          id: "37484",
          name: "Ourossogui",
          state_id: "3170",
        },
        {
          id: "37485",
          name: "Podor",
          state_id: "3170",
        },
        {
          id: "37486",
          name: "Richard Toll",
          state_id: "3170",
        },
        {
          id: "37487",
          name: "Saint-Louis",
          state_id: "3170",
        },
        {
          id: "37488",
          name: "Semme",
          state_id: "3170",
        },
        {
          id: "37489",
          name: "Thilogne",
          state_id: "3170",
        },
        {
          id: "37490",
          name: "Waounde",
          state_id: "3170",
        },
      ],
      Tambacounda: [
        {
          id: "37491",
          name: "Bakel",
          state_id: "3171",
        },
        {
          id: "37492",
          name: "Kedougou",
          state_id: "3171",
        },
        {
          id: "37493",
          name: "Tambacounda",
          state_id: "3171",
        },
      ],
      Thies: [
        {
          id: "37494",
          name: "Joal-Fadiouth",
          state_id: "3172",
        },
        {
          id: "37495",
          name: "Kayar",
          state_id: "3172",
        },
        {
          id: "37496",
          name: "Khombole",
          state_id: "3172",
        },
        {
          id: "37497",
          name: "Mbour",
          state_id: "3172",
        },
        {
          id: "37498",
          name: "Meckhe",
          state_id: "3172",
        },
        {
          id: "37499",
          name: "Nguekhokh",
          state_id: "3172",
        },
        {
          id: "37500",
          name: "Pout",
          state_id: "3172",
        },
        {
          id: "37501",
          name: "Thiadiaye",
          state_id: "3172",
        },
        {
          id: "37502",
          name: "Thies",
          state_id: "3172",
        },
        {
          id: "37503",
          name: "Tivaouane",
          state_id: "3172",
        },
      ],
      Ziguinchor: [
        {
          id: "37504",
          name: "Bignona",
          state_id: "3173",
        },
        {
          id: "37505",
          name: "Oussouye",
          state_id: "3173",
        },
        {
          id: "37506",
          name: "Thionck-Essyl",
          state_id: "3173",
        },
        {
          id: "37507",
          name: "Ziguinchor",
          state_id: "3173",
        },
      ],
    },
  },
  SO: {
    name: "Somalia",
    native: "Soomaaliya",
    phone: "252",
    continent: "AF",
    capital: "Mogadishu",
    currency: "SOS",
    languages: ["so", "ar"],
    emoji: "🇸🇴",
    emojiU: "U+1F1F8 U+1F1F4",
    states: {
      Awdal: [
        {
          id: "37982",
          name: "Baki",
          state_id: "3221",
        },
        {
          id: "37983",
          name: "Borama",
          state_id: "3221",
        },
        {
          id: "37984",
          name: "Gebilay",
          state_id: "3221",
        },
        {
          id: "37985",
          name: "Sayla",
          state_id: "3221",
        },
      ],
      Bakol: [
        {
          id: "37986",
          name: "Tayeglo",
          state_id: "3222",
        },
        {
          id: "37987",
          name: "Xuddur",
          state_id: "3222",
        },
        {
          id: "37988",
          name: "Yet",
          state_id: "3222",
        },
      ],
      Banadir: [
        {
          id: "37989",
          name: "Muqdisho",
          state_id: "3223",
        },
      ],
      Bari: [
        {
          id: "37990",
          name: "Alula",
          state_id: "3224",
        },
        {
          id: "37991",
          name: "Bandarbeyla",
          state_id: "3224",
        },
        {
          id: "37992",
          name: "Bandarmu''ayo",
          state_id: "3224",
        },
        {
          id: "37993",
          name: "Bargal",
          state_id: "3224",
        },
        {
          id: "37994",
          name: "Bereda",
          state_id: "3224",
        },
        {
          id: "37995",
          name: "Bosaso",
          state_id: "3224",
        },
        {
          id: "37996",
          name: "Iskushuban",
          state_id: "3224",
        },
        {
          id: "37997",
          name: "Qandala",
          state_id: "3224",
        },
        {
          id: "37998",
          name: "Qardho",
          state_id: "3224",
        },
        {
          id: "37999",
          name: "Xafun",
          state_id: "3224",
        },
      ],
      Bay: [
        {
          id: "38000",
          name: "Baydhabo",
          state_id: "3225",
        },
        {
          id: "38001",
          name: "Bur Hakkaba",
          state_id: "3225",
        },
        {
          id: "38002",
          name: "Dinsor",
          state_id: "3225",
        },
      ],
      Galgudug: [
        {
          id: "38003",
          name: "Elbur",
          state_id: "3226",
        },
        {
          id: "38004",
          name: "Eldhere",
          state_id: "3226",
        },
        {
          id: "38005",
          name: "Dhusa Marreb",
          state_id: "3226",
        },
      ],
      Gedo: [
        {
          id: "38006",
          name: "Bardhere",
          state_id: "3227",
        },
        {
          id: "38007",
          name: "Dolaw",
          state_id: "3227",
        },
        {
          id: "38008",
          name: "Dujuma",
          state_id: "3227",
        },
        {
          id: "38009",
          name: "Garbaharey",
          state_id: "3227",
        },
        {
          id: "38010",
          name: "Luq",
          state_id: "3227",
        },
        {
          id: "38011",
          name: "Sa''o",
          state_id: "3227",
        },
        {
          id: "38012",
          name: "Wajid",
          state_id: "3227",
        },
      ],
      Hiran: [
        {
          id: "38013",
          name: "Bal''ad",
          state_id: "3228",
        },
        {
          id: "38014",
          name: "Beled Weyne",
          state_id: "3228",
        },
        {
          id: "38015",
          name: "Bulobarde",
          state_id: "3228",
        },
        {
          id: "38016",
          name: "Jalalassi",
          state_id: "3228",
        },
      ],
      "Jubbada Hose": [],
      "Jubbadha Dexe": [],
      Mudug: [
        {
          id: "38017",
          name: "Galka''yo",
          state_id: "3231",
        },
        {
          id: "38018",
          name: "Hobyo",
          state_id: "3231",
        },
        {
          id: "38019",
          name: "Xarardhere",
          state_id: "3231",
        },
      ],
      Nugal: [
        {
          id: "38020",
          name: "Eyl",
          state_id: "3232",
        },
        {
          id: "38021",
          name: "Garowe",
          state_id: "3232",
        },
        {
          id: "38022",
          name: "Las''anod",
          state_id: "3232",
        },
      ],
      Sanag: [
        {
          id: "38023",
          name: "Erigabo",
          state_id: "3233",
        },
        {
          id: "38024",
          name: "Lasqoray",
          state_id: "3233",
        },
      ],
      "Shabellaha Dhexe": [],
      "Shabellaha Hose": [],
      Togdher: [
        {
          id: "38025",
          name: "Ek",
          state_id: "3236",
        },
        {
          id: "38026",
          name: "Bur''o",
          state_id: "3236",
        },
        {
          id: "38027",
          name: "Odweyne",
          state_id: "3236",
        },
      ],
      "Woqoyi Galbed": [],
    },
  },
  SR: {
    name: "Suriname",
    native: "Suriname",
    phone: "597",
    continent: "SA",
    capital: "Paramaribo",
    currency: "SRD",
    languages: ["nl"],
    emoji: "🇸🇷",
    emojiU: "U+1F1F8 U+1F1F7",
    states: {
      Brokopondo: [
        {
          id: "39036",
          name: "Brokopondo",
          state_id: "3381",
        },
        {
          id: "39037",
          name: "Brownsweg",
          state_id: "3381",
        },
      ],
      Commewijne: [
        {
          id: "39038",
          name: "Marienburg",
          state_id: "3382",
        },
        {
          id: "39039",
          name: "Meerzorg",
          state_id: "3382",
        },
        {
          id: "39040",
          name: "Nieuw Amsterdam",
          state_id: "3382",
        },
      ],
      Coronie: [
        {
          id: "39041",
          name: "Totness",
          state_id: "3383",
        },
      ],
      Marowijne: [
        {
          id: "39042",
          name: "Albina",
          state_id: "3384",
        },
        {
          id: "39043",
          name: "Moengo",
          state_id: "3384",
        },
      ],
      Nickerie: [
        {
          id: "39044",
          name: "Nieuw Nickerie",
          state_id: "3385",
        },
        {
          id: "39045",
          name: "Wageningen",
          state_id: "3385",
        },
      ],
      Para: [
        {
          id: "39046",
          name: "Onverwacht",
          state_id: "3386",
        },
      ],
      Paramaribo: [
        {
          id: "39047",
          name: "Paramaribo",
          state_id: "3387",
        },
      ],
      Saramacca: [
        {
          id: "39048",
          name: "Groningen",
          state_id: "3388",
        },
      ],
      Wanica: [
        {
          id: "39049",
          name: "Lelydorp",
          state_id: "3389",
        },
      ],
    },
  },
  SS: {
    name: "South Sudan",
    native: "South Sudan",
    phone: "211",
    continent: "AF",
    capital: "Juba",
    currency: "SSP",
    languages: ["en"],
    emoji: "🇸🇸",
    emojiU: "U+1F1F8 U+1F1F8",
    states: {
      "Central Equatoria": [],
    },
  },
  ST: {
    name: "São Tomé and Príncipe",
    native: "São Tomé e Príncipe",
    phone: "239",
    continent: "AF",
    capital: "São Tomé",
    currency: "STD",
    languages: ["pt"],
    emoji: "🇸🇹",
    emojiU: "U+1F1F8 U+1F1F9",
    states: {
      "Agua Grande": [],
      Cantagalo: [
        {
          id: "37405",
          name: "Santana",
          state_id: "3141",
        },
      ],
      Lemba: [
        {
          id: "37406",
          name: "Neves",
          state_id: "3142",
        },
      ],
      Lobata: [
        {
          id: "37407",
          name: "Santo Amaro",
          state_id: "3143",
        },
      ],
      "Me-Zochi": [
        {
          id: "37408",
          name: "Trindade",
          state_id: "3144",
        },
      ],
      Pague: [
        {
          id: "37409",
          name: "Santo Antonio",
          state_id: "3145",
        },
      ],
    },
  },
  SV: {
    name: "El Salvador",
    native: "El Salvador",
    phone: "503",
    continent: "NA",
    capital: "San Salvador",
    currency: "SVC,USD",
    languages: ["es"],
    emoji: "🇸🇻",
    emojiU: "U+1F1F8 U+1F1FB",
    states: {
      Ahuachapan: [
        {
          id: "15612",
          name: "Ahuachapan",
          state_id: "1077",
        },
        {
          id: "15613",
          name: "Atiquizaya",
          state_id: "1077",
        },
        {
          id: "15614",
          name: "Concepcion de Ataco",
          state_id: "1077",
        },
        {
          id: "15615",
          name: "Guaymango",
          state_id: "1077",
        },
        {
          id: "15616",
          name: "Jujutla",
          state_id: "1077",
        },
        {
          id: "15617",
          name: "San Francisco Menendez",
          state_id: "1077",
        },
        {
          id: "15618",
          name: "Tacuba",
          state_id: "1077",
        },
      ],
      Cabanas: [
        {
          id: "15619",
          name: "Ilobasco",
          state_id: "1078",
        },
        {
          id: "15620",
          name: "Sensuntepeque",
          state_id: "1078",
        },
        {
          id: "15621",
          name: "Victoria",
          state_id: "1078",
        },
      ],
      Chalatenango: [
        {
          id: "15622",
          name: "Chalatenango",
          state_id: "1079",
        },
        {
          id: "15623",
          name: "La Palma",
          state_id: "1079",
        },
        {
          id: "15624",
          name: "Nueva Concepcion",
          state_id: "1079",
        },
        {
          id: "15625",
          name: "San Francisco Morazan",
          state_id: "1079",
        },
      ],
      Cuscatlan: [
        {
          id: "15626",
          name: "Cojutepeque",
          state_id: "1080",
        },
        {
          id: "15627",
          name: "San Pedro Perulapan",
          state_id: "1080",
        },
        {
          id: "15628",
          name: "Suchitoto",
          state_id: "1080",
        },
        {
          id: "15629",
          name: "Tecoluca",
          state_id: "1080",
        },
        {
          id: "15630",
          name: "Tenancingo",
          state_id: "1080",
        },
      ],
      "La Libertad": [],
      "La Paz": [],
      "La Union": [],
      Morazan: [
        {
          id: "15631",
          name: "Cacaopera",
          state_id: "1084",
        },
        {
          id: "15632",
          name: "Corinto",
          state_id: "1084",
        },
        {
          id: "15633",
          name: "Gotera",
          state_id: "1084",
        },
        {
          id: "15634",
          name: "Guatajiagua",
          state_id: "1084",
        },
        {
          id: "15635",
          name: "Jocoro",
          state_id: "1084",
        },
        {
          id: "15636",
          name: "Sociedad",
          state_id: "1084",
        },
      ],
      "San Miguel": [],
      "San Salvador": [],
      "San Vicente": [],
      "Santa Ana": [],
      Sonsonate: [
        {
          id: "15637",
          name: "Acajutla",
          state_id: "1089",
        },
        {
          id: "15638",
          name: "Armenia",
          state_id: "1089",
        },
        {
          id: "15639",
          name: "Izalco",
          state_id: "1089",
        },
        {
          id: "15640",
          name: "Juayua",
          state_id: "1089",
        },
        {
          id: "15641",
          name: "Nahuizalco",
          state_id: "1089",
        },
        {
          id: "15642",
          name: "San Antonio del Monte",
          state_id: "1089",
        },
        {
          id: "15643",
          name: "San Julian",
          state_id: "1089",
        },
        {
          id: "15644",
          name: "Sonsonate",
          state_id: "1089",
        },
        {
          id: "15645",
          name: "Sonzacate",
          state_id: "1089",
        },
      ],
      Usulutan: [
        {
          id: "15646",
          name: "Berlin",
          state_id: "1090",
        },
        {
          id: "15647",
          name: "Concepcion Batres",
          state_id: "1090",
        },
        {
          id: "15648",
          name: "Estanzuelas",
          state_id: "1090",
        },
        {
          id: "15649",
          name: "Jiquilisco",
          state_id: "1090",
        },
        {
          id: "15650",
          name: "Jucuapa",
          state_id: "1090",
        },
        {
          id: "15651",
          name: "Jucuaran",
          state_id: "1090",
        },
        {
          id: "15652",
          name: "Ozatlan",
          state_id: "1090",
        },
        {
          id: "15653",
          name: "Puerto El Triunfo",
          state_id: "1090",
        },
        {
          id: "15654",
          name: "San Agustin",
          state_id: "1090",
        },
        {
          id: "15655",
          name: "Santa Elena",
          state_id: "1090",
        },
        {
          id: "15656",
          name: "Santiago de Maria",
          state_id: "1090",
        },
        {
          id: "15657",
          name: "Usulutan",
          state_id: "1090",
        },
      ],
    },
  },
  SX: {
    name: "Sint Maarten",
    native: "Sint Maarten",
    phone: "1721",
    continent: "NA",
    capital: "Philipsburg",
    currency: "ANG",
    languages: ["nl", "en"],
    emoji: "🇸🇽",
    emojiU: "U+1F1F8 U+1F1FD",
    states: {},
  },
  SY: {
    name: "Syria",
    native: "سوريا",
    phone: "963",
    continent: "AS",
    capital: "Damascus",
    currency: "SYP",
    languages: ["ar"],
    emoji: "🇸🇾",
    emojiU: "U+1F1F8 U+1F1FE",
    states: {
      Aleppo: [
        {
          id: "39597",
          name: "Aleppo",
          state_id: "3456",
        },
      ],
      "Dar''a": [
        {
          id: "39598",
          name: "Dar''a",
          state_id: "3457",
        },
        {
          id: "39599",
          name: "Nawa",
          state_id: "3457",
        },
      ],
      "Dayr-az-Zawr": [
        {
          id: "39600",
          name: "Abu Kamal",
          state_id: "3458",
        },
        {
          id: "39601",
          name: "Dayr az-Zawr",
          state_id: "3458",
        },
        {
          id: "39602",
          name: "al-Mayadin",
          state_id: "3458",
        },
      ],
      Dimashq: [
        {
          id: "39603",
          name: "Damascus",
          state_id: "3459",
        },
        {
          id: "39604",
          name: "Darayya",
          state_id: "3459",
        },
        {
          id: "39605",
          name: "Duma",
          state_id: "3459",
        },
        {
          id: "39606",
          name: "Hajar Aswad",
          state_id: "3459",
        },
        {
          id: "39607",
          name: "Harasta al-Bas",
          state_id: "3459",
        },
        {
          id: "39608",
          name: "Jaramanah",
          state_id: "3459",
        },
        {
          id: "39609",
          name: "Kabir-as-Sit",
          state_id: "3459",
        },
        {
          id: "39610",
          name: "Kesweh",
          state_id: "3459",
        },
        {
          id: "39611",
          name: "Qatana",
          state_id: "3459",
        },
        {
          id: "39612",
          name: "Yabrud",
          state_id: "3459",
        },
        {
          id: "39613",
          name: "al-Qutayfah",
          state_id: "3459",
        },
        {
          id: "39614",
          name: "an-Nabk",
          state_id: "3459",
        },
        {
          id: "39615",
          name: "at-Tall",
          state_id: "3459",
        },
        {
          id: "39616",
          name: "az-Zabadani",
          state_id: "3459",
        },
      ],
      Halab: [
        {
          id: "39617",
          name: "Afrin",
          state_id: "3460",
        },
        {
          id: "39618",
          name: "Ayn-al-''Arab",
          state_id: "3460",
        },
        {
          id: "39619",
          name: "A''zaz",
          state_id: "3460",
        },
        {
          id: "39620",
          name: "Halab",
          state_id: "3460",
        },
        {
          id: "39621",
          name: "Manbij",
          state_id: "3460",
        },
        {
          id: "39622",
          name: "al-Bab",
          state_id: "3460",
        },
        {
          id: "39623",
          name: "as-Safirah",
          state_id: "3460",
        },
      ],
      Hamah: [
        {
          id: "39624",
          name: "Hamah",
          state_id: "3461",
        },
        {
          id: "39625",
          name: "Masyaf",
          state_id: "3461",
        },
        {
          id: "39626",
          name: "Muhradah",
          state_id: "3461",
        },
        {
          id: "39627",
          name: "Salamiyah",
          state_id: "3461",
        },
      ],
      Hims: [
        {
          id: "39628",
          name: "Hims",
          state_id: "3462",
        },
        {
          id: "39629",
          name: "Homs",
          state_id: "3462",
        },
        {
          id: "39630",
          name: "Tudmur",
          state_id: "3462",
        },
        {
          id: "39631",
          name: "al-Qusayr",
          state_id: "3462",
        },
        {
          id: "39632",
          name: "ar-Rastan",
          state_id: "3462",
        },
      ],
      Idlib: [
        {
          id: "39633",
          name: "Ariha",
          state_id: "3463",
        },
        {
          id: "39634",
          name: "Idlib",
          state_id: "3463",
        },
        {
          id: "39635",
          name: "Jisr-ash-Shughur",
          state_id: "3463",
        },
        {
          id: "39636",
          name: "Ma''arrat-an-Nu''man",
          state_id: "3463",
        },
      ],
      "Madinat Dimashq": [],
      Tartus: [
        {
          id: "39637",
          name: "Baniyas",
          state_id: "3465",
        },
        {
          id: "39638",
          name: "Safita",
          state_id: "3465",
        },
        {
          id: "39639",
          name: "Tartus",
          state_id: "3465",
        },
      ],
      "al-Hasakah": [
        {
          id: "39640",
          name: "Ra''s-al-''Ayn",
          state_id: "3466",
        },
        {
          id: "39641",
          name: "al-Hasakah",
          state_id: "3466",
        },
        {
          id: "39642",
          name: "al-Malikiyah",
          state_id: "3466",
        },
        {
          id: "39643",
          name: "al-Qamishli",
          state_id: "3466",
        },
      ],
      "al-Ladhiqiyah": [
        {
          id: "39644",
          name: "Jablah",
          state_id: "3467",
        },
        {
          id: "39645",
          name: "Lattakia",
          state_id: "3467",
        },
        {
          id: "39646",
          name: "al-Ladhiqiyah",
          state_id: "3467",
        },
      ],
      "al-Qunaytirah": [
        {
          id: "39647",
          name: "al-Qunaytirah",
          state_id: "3468",
        },
      ],
      "ar-Raqqah": [
        {
          id: "39648",
          name: "ar-Raqqah",
          state_id: "3469",
        },
        {
          id: "39649",
          name: "ath-Thawrah",
          state_id: "3469",
        },
      ],
      "as-Suwayda": [
        {
          id: "39650",
          name: "as-Suwayda",
          state_id: "3470",
        },
      ],
    },
  },
  SZ: {
    name: "Swaziland",
    native: "Swaziland",
    phone: "268",
    continent: "AF",
    capital: "Lobamba",
    currency: "SZL",
    languages: ["en", "ss"],
    emoji: "🇸🇿",
    emojiU: "U+1F1F8 U+1F1FF",
    states: {
      Hhohho: [
        {
          id: "39055",
          name: "Bulembu",
          state_id: "3391",
        },
        {
          id: "39056",
          name: "Ezulwini",
          state_id: "3391",
        },
        {
          id: "39057",
          name: "Mbabane",
          state_id: "3391",
        },
        {
          id: "39058",
          name: "Ngwenya",
          state_id: "3391",
        },
        {
          id: "39059",
          name: "Pigg''s Peak",
          state_id: "3391",
        },
      ],
      Lubombo: [
        {
          id: "39060",
          name: "Big Bend",
          state_id: "3392",
        },
        {
          id: "39061",
          name: "Mhlume",
          state_id: "3392",
        },
        {
          id: "39062",
          name: "Mpaka",
          state_id: "3392",
        },
        {
          id: "39063",
          name: "Nsoko",
          state_id: "3392",
        },
        {
          id: "39064",
          name: "Simunye",
          state_id: "3392",
        },
        {
          id: "39065",
          name: "Siteki",
          state_id: "3392",
        },
        {
          id: "39066",
          name: "Tshaneni",
          state_id: "3392",
        },
      ],
      Manzini: [
        {
          id: "39067",
          name: "Bhunya",
          state_id: "3393",
        },
        {
          id: "39068",
          name: "Kwaluseni",
          state_id: "3393",
        },
        {
          id: "39069",
          name: "Lobamba",
          state_id: "3393",
        },
        {
          id: "39070",
          name: "Malkerns",
          state_id: "3393",
        },
        {
          id: "39071",
          name: "Mankayane",
          state_id: "3393",
        },
        {
          id: "39072",
          name: "Manzini",
          state_id: "3393",
        },
        {
          id: "39073",
          name: "Matsapha",
          state_id: "3393",
        },
        {
          id: "39074",
          name: "Mhlambanyatsi",
          state_id: "3393",
        },
        {
          id: "39075",
          name: "Sidvokodvo",
          state_id: "3393",
        },
      ],
      Shiselweni: [
        {
          id: "39076",
          name: "Hlatikulu",
          state_id: "3394",
        },
        {
          id: "39077",
          name: "Hluti",
          state_id: "3394",
        },
        {
          id: "39078",
          name: "Kubuta",
          state_id: "3394",
        },
        {
          id: "39079",
          name: "Lavumisa",
          state_id: "3394",
        },
        {
          id: "39080",
          name: "Nhlangano",
          state_id: "3394",
        },
      ],
    },
  },
  TC: {
    name: "Turks and Caicos Islands",
    native: "Turks and Caicos Islands",
    phone: "1649",
    continent: "NA",
    capital: "Cockburn Town",
    currency: "USD",
    languages: ["en"],
    emoji: "🇹🇨",
    emojiU: "U+1F1F9 U+1F1E8",
    states: {
      "Grand Turk": [],
      "South Caicos and East Caicos": [],
    },
  },
  TD: {
    name: "Chad",
    native: "Tchad",
    phone: "235",
    continent: "AF",
    capital: "N'Djamena",
    currency: "XAF",
    languages: ["fr", "ar"],
    emoji: "🇹🇩",
    emojiU: "U+1F1F9 U+1F1E9",
    states: {
      Batha: [
        {
          id: "10913",
          name: "Ati",
          state_id: "703",
        },
        {
          id: "10914",
          name: "Oum Hadjer",
          state_id: "703",
        },
      ],
      Biltine: [
        {
          id: "10915",
          name: "Biltine",
          state_id: "704",
        },
      ],
      "Bourkou-Ennedi-Tibesti": [
        {
          id: "10916",
          name: "Aouzou",
          state_id: "705",
        },
        {
          id: "10917",
          name: "Bardai",
          state_id: "705",
        },
        {
          id: "10918",
          name: "Fada",
          state_id: "705",
        },
        {
          id: "10919",
          name: "Faya",
          state_id: "705",
        },
      ],
      "Chari-Baguirmi": [
        {
          id: "10920",
          name: "Bokoro",
          state_id: "706",
        },
        {
          id: "10921",
          name: "Bousso",
          state_id: "706",
        },
        {
          id: "10922",
          name: "Dourbali",
          state_id: "706",
        },
        {
          id: "10923",
          name: "Massaguet",
          state_id: "706",
        },
        {
          id: "10924",
          name: "Massakory",
          state_id: "706",
        },
        {
          id: "10925",
          name: "Massenya",
          state_id: "706",
        },
        {
          id: "10926",
          name: "N''Djamena",
          state_id: "706",
        },
        {
          id: "10927",
          name: "Ngama",
          state_id: "706",
        },
      ],
      Guera: [
        {
          id: "10928",
          name: "Bitkine",
          state_id: "707",
        },
        {
          id: "10929",
          name: "Melfi",
          state_id: "707",
        },
        {
          id: "10930",
          name: "Mongo",
          state_id: "707",
        },
      ],
      Kanem: [
        {
          id: "10931",
          name: "Mao",
          state_id: "708",
        },
        {
          id: "10932",
          name: "Moussoro",
          state_id: "708",
        },
        {
          id: "10933",
          name: "Rig-Rig",
          state_id: "708",
        },
      ],
      Lac: [
        {
          id: "10934",
          name: "Bol",
          state_id: "709",
        },
      ],
      "Logone Occidental": [],
      "Logone Oriental": [],
      "Mayo-Kebbi": [
        {
          id: "10935",
          name: "Bongor",
          state_id: "712",
        },
        {
          id: "10936",
          name: "Fianga",
          state_id: "712",
        },
        {
          id: "10937",
          name: "Gounou Gaya",
          state_id: "712",
        },
        {
          id: "10938",
          name: "Guelengdeng",
          state_id: "712",
        },
        {
          id: "10939",
          name: "Lere",
          state_id: "712",
        },
        {
          id: "10940",
          name: "Pala",
          state_id: "712",
        },
      ],
      "Moyen-Chari": [
        {
          id: "10941",
          name: "Goundi",
          state_id: "713",
        },
        {
          id: "10942",
          name: "Koumra",
          state_id: "713",
        },
        {
          id: "10943",
          name: "Kyabe",
          state_id: "713",
        },
        {
          id: "10944",
          name: "Moissala",
          state_id: "713",
        },
        {
          id: "10945",
          name: "Sarh",
          state_id: "713",
        },
      ],
      Ouaddai: [
        {
          id: "10946",
          name: "Abeche",
          state_id: "714",
        },
        {
          id: "10947",
          name: "Adre",
          state_id: "714",
        },
        {
          id: "10948",
          name: "Am Dam",
          state_id: "714",
        },
      ],
      Salamat: [
        {
          id: "10949",
          name: "Abou Deia",
          state_id: "715",
        },
        {
          id: "10950",
          name: "Am Timan",
          state_id: "715",
        },
        {
          id: "10951",
          name: "Mangueigne",
          state_id: "715",
        },
      ],
      Tandjile: [
        {
          id: "10952",
          name: "Benoy",
          state_id: "716",
        },
        {
          id: "10953",
          name: "Bere",
          state_id: "716",
        },
        {
          id: "10954",
          name: "Kelo",
          state_id: "716",
        },
        {
          id: "10955",
          name: "Lai",
          state_id: "716",
        },
      ],
    },
  },
  TF: {
    name: "French Southern Territories",
    native: "Territoire des Terres australes et antarctiques fr",
    phone: "262",
    continent: "AN",
    capital: "Port-aux-Français",
    currency: "EUR",
    languages: ["fr"],
    emoji: "🇹🇫",
    emojiU: "U+1F1F9 U+1F1EB",
    states: {
      Amsterdam: [
        {
          id: "18213",
          name: "Martin-de-Vivies",
          state_id: "1322",
        },
      ],
      "Crozet Islands": [],
      Kerguelen: [
        {
          id: "18214",
          name: "Port-aux-Francais",
          state_id: "1324",
        },
      ],
    },
  },
  TG: {
    name: "Togo",
    native: "Togo",
    phone: "228",
    continent: "AF",
    capital: "Lomé",
    currency: "XOF",
    languages: ["fr"],
    emoji: "🇹🇬",
    emojiU: "U+1F1F9 U+1F1EC",
    states: {
      Centre: [
        {
          id: "39957",
          name: "Guerin Kouka",
          state_id: "3604",
        },
        {
          id: "39958",
          name: "Sokode",
          state_id: "3604",
        },
        {
          id: "39959",
          name: "Sotouboua",
          state_id: "3604",
        },
        {
          id: "39960",
          name: "Tchamba",
          state_id: "3604",
        },
      ],
      Kara: [
        {
          id: "39961",
          name: "Bafilo",
          state_id: "3605",
        },
        {
          id: "39962",
          name: "Bassar",
          state_id: "3605",
        },
        {
          id: "39963",
          name: "Kande",
          state_id: "3605",
        },
        {
          id: "39964",
          name: "Kara",
          state_id: "3605",
        },
        {
          id: "39965",
          name: "Kpagouda",
          state_id: "3605",
        },
        {
          id: "39966",
          name: "Niamtougou",
          state_id: "3605",
        },
      ],
      Maritime: [
        {
          id: "39967",
          name: "Agbelouve",
          state_id: "3606",
        },
        {
          id: "39968",
          name: "Aneho",
          state_id: "3606",
        },
        {
          id: "39969",
          name: "Lome",
          state_id: "3606",
        },
        {
          id: "39970",
          name: "Tabligbo",
          state_id: "3606",
        },
        {
          id: "39971",
          name: "Tsevie",
          state_id: "3606",
        },
        {
          id: "39972",
          name: "Vogan",
          state_id: "3606",
        },
      ],
      Plateaux: [
        {
          id: "39973",
          name: "Amlame",
          state_id: "3607",
        },
        {
          id: "39974",
          name: "Anie",
          state_id: "3607",
        },
        {
          id: "39975",
          name: "Atakpame",
          state_id: "3607",
        },
        {
          id: "39976",
          name: "Badou",
          state_id: "3607",
        },
        {
          id: "39977",
          name: "Blitta",
          state_id: "3607",
        },
        {
          id: "39978",
          name: "Kouve",
          state_id: "3607",
        },
        {
          id: "39979",
          name: "Kpalime",
          state_id: "3607",
        },
        {
          id: "39980",
          name: "Kpessi",
          state_id: "3607",
        },
        {
          id: "39981",
          name: "Notse",
          state_id: "3607",
        },
      ],
      Savanes: [
        {
          id: "39982",
          name: "Dapaong",
          state_id: "3608",
        },
        {
          id: "39983",
          name: "Mango",
          state_id: "3608",
        },
        {
          id: "39984",
          name: "Tandjouare",
          state_id: "3608",
        },
      ],
    },
  },
  TH: {
    name: "Thailand",
    native: "ประเทศไทย",
    phone: "66",
    continent: "AS",
    capital: "Bangkok",
    currency: "THB",
    languages: ["th"],
    emoji: "🇹🇭",
    emojiU: "U+1F1F9 U+1F1ED",
    states: {
      "Amnat Charoen": [],
      "Ang Thong": [],
      Bangkok: [
        {
          id: "39824",
          name: "Bangkhen",
          state_id: "3528",
        },
        {
          id: "39825",
          name: "Bangkok",
          state_id: "3528",
        },
        {
          id: "39826",
          name: "Phatumthanee",
          state_id: "3528",
        },
      ],
      "Buri Ram": [],
      Chachoengsao: [
        {
          id: "39827",
          name: "Bang Khla",
          state_id: "3530",
        },
        {
          id: "39828",
          name: "Bang Pakong",
          state_id: "3530",
        },
        {
          id: "39829",
          name: "Bangpakong",
          state_id: "3530",
        },
        {
          id: "39830",
          name: "Chachoengsao",
          state_id: "3530",
        },
        {
          id: "39831",
          name: "Phanom Sarakham",
          state_id: "3530",
        },
        {
          id: "39832",
          name: "Plaeng Yao",
          state_id: "3530",
        },
      ],
      "Chai Nat": [],
      Chaiyaphum: [
        {
          id: "39833",
          name: "Bamnet Narong",
          state_id: "3532",
        },
        {
          id: "39834",
          name: "Chaiyaphum",
          state_id: "3532",
        },
        {
          id: "39835",
          name: "Kaeng Khlo",
          state_id: "3532",
        },
        {
          id: "39836",
          name: "Kaset Sombun",
          state_id: "3532",
        },
        {
          id: "39837",
          name: "Phu Khieo",
          state_id: "3532",
        },
      ],
      "Changwat Chaiyaphum": [],
      Chanthaburi: [
        {
          id: "39838",
          name: "Chanthaburi",
          state_id: "3534",
        },
        {
          id: "39839",
          name: "Khlung",
          state_id: "3534",
        },
        {
          id: "39840",
          name: "Laem Sing",
          state_id: "3534",
        },
        {
          id: "39841",
          name: "Soydow",
          state_id: "3534",
        },
        {
          id: "39842",
          name: "Tha Mai",
          state_id: "3534",
        },
      ],
      "Chiang Mai": [],
      "Chiang Rai": [],
      "Chon Buri": [],
      Chumphon: [
        {
          id: "39843",
          name: "Chumphon",
          state_id: "3538",
        },
        {
          id: "39844",
          name: "Lang Suan",
          state_id: "3538",
        },
      ],
      Kalasin: [
        {
          id: "39845",
          name: "Huai Mek",
          state_id: "3539",
        },
        {
          id: "39846",
          name: "Kalasin",
          state_id: "3539",
        },
        {
          id: "39847",
          name: "Kamalasai",
          state_id: "3539",
        },
        {
          id: "39848",
          name: "Khao Wong",
          state_id: "3539",
        },
        {
          id: "39849",
          name: "Kuchinarai",
          state_id: "3539",
        },
        {
          id: "39850",
          name: "Nong Kung Si",
          state_id: "3539",
        },
        {
          id: "39851",
          name: "Yang Talat",
          state_id: "3539",
        },
      ],
      "Kamphaeng Phet": [],
      Kanchanaburi: [
        {
          id: "39852",
          name: "Bo Phloi",
          state_id: "3541",
        },
        {
          id: "39853",
          name: "Kanchanaburi",
          state_id: "3541",
        },
        {
          id: "39854",
          name: "Phanom Thuan",
          state_id: "3541",
        },
        {
          id: "39855",
          name: "Tha Maka",
          state_id: "3541",
        },
        {
          id: "39856",
          name: "Tha Muang",
          state_id: "3541",
        },
      ],
      "Khon Kaen": [],
      Krabi: [
        {
          id: "39857",
          name: "Ao Luk",
          state_id: "3543",
        },
        {
          id: "39858",
          name: "Krabi",
          state_id: "3543",
        },
      ],
      "Krung Thep": [],
      Lampang: [
        {
          id: "39859",
          name: "Lampang",
          state_id: "3545",
        },
        {
          id: "39860",
          name: "Thoen",
          state_id: "3545",
        },
      ],
      Lamphun: [
        {
          id: "39861",
          name: "Lamphun",
          state_id: "3546",
        },
        {
          id: "39862",
          name: "Mae Tha",
          state_id: "3546",
        },
        {
          id: "39863",
          name: "Pa Sang",
          state_id: "3546",
        },
      ],
      Loei: [
        {
          id: "39864",
          name: "Loei",
          state_id: "3547",
        },
        {
          id: "39865",
          name: "Phu Kra Dung",
          state_id: "3547",
        },
        {
          id: "39866",
          name: "Wang Saphung",
          state_id: "3547",
        },
      ],
      "Lop Buri": [],
      "Mae Hong Son": [],
      "Maha Sarakham": [],
      Mukdahan: [
        {
          id: "39867",
          name: "Mukdahan",
          state_id: "3551",
        },
      ],
      "Nakhon Nayok": [],
      "Nakhon Pathom": [],
      "Nakhon Phanom": [],
      "Nakhon Ratchasima": [],
      "Nakhon Sawan": [],
      "Nakhon Si Thammarat": [],
      Nan: [
        {
          id: "39868",
          name: "Chiang Klang",
          state_id: "3558",
        },
        {
          id: "39869",
          name: "Nan",
          state_id: "3558",
        },
      ],
      Narathiwat: [
        {
          id: "39870",
          name: "Bacho",
          state_id: "3559",
        },
        {
          id: "39871",
          name: "Narathiwat",
          state_id: "3559",
        },
        {
          id: "39872",
          name: "Rangae",
          state_id: "3559",
        },
        {
          id: "39873",
          name: "Sungai Kolok",
          state_id: "3559",
        },
        {
          id: "39874",
          name: "Sungai Padi",
          state_id: "3559",
        },
        {
          id: "39875",
          name: "Tak Bai",
          state_id: "3559",
        },
      ],
      "Nong Bua Lam Phu": [],
      "Nong Khai": [],
      Nonthaburi: [
        {
          id: "39876",
          name: "Bang Bo Thong",
          state_id: "3562",
        },
        {
          id: "39877",
          name: "Bang Kruai",
          state_id: "3562",
        },
        {
          id: "39878",
          name: "Bang Yai",
          state_id: "3562",
        },
        {
          id: "39879",
          name: "Nonthaburi",
          state_id: "3562",
        },
        {
          id: "39880",
          name: "Pak Kret",
          state_id: "3562",
        },
        {
          id: "39881",
          name: "Sainoi",
          state_id: "3562",
        },
      ],
      "Pathum Thani": [],
      Pattani: [
        {
          id: "39882",
          name: "Nong Chik",
          state_id: "3564",
        },
        {
          id: "39883",
          name: "Pattani",
          state_id: "3564",
        },
        {
          id: "39884",
          name: "Sai Buri",
          state_id: "3564",
        },
        {
          id: "39885",
          name: "Yaring",
          state_id: "3564",
        },
      ],
      Phangnga: [
        {
          id: "39886",
          name: "Phangnga",
          state_id: "3565",
        },
      ],
      Phatthalung: [
        {
          id: "39887",
          name: "Phatthalung",
          state_id: "3566",
        },
      ],
      Phayao: [
        {
          id: "39888",
          name: "Chiang Kham",
          state_id: "3567",
        },
        {
          id: "39889",
          name: "Dok Kham Tai",
          state_id: "3567",
        },
        {
          id: "39890",
          name: "Phayao",
          state_id: "3567",
        },
        {
          id: "39891",
          name: "Pong",
          state_id: "3567",
        },
      ],
      Phetchabun: [
        {
          id: "39892",
          name: "Chon Daen",
          state_id: "3568",
        },
        {
          id: "39893",
          name: "Lom Sak",
          state_id: "3568",
        },
        {
          id: "39894",
          name: "Nong Phai",
          state_id: "3568",
        },
        {
          id: "39895",
          name: "Phetchabun",
          state_id: "3568",
        },
        {
          id: "39896",
          name: "Wichian Buri",
          state_id: "3568",
        },
      ],
      Phetchaburi: [
        {
          id: "39897",
          name: "Ban Laem",
          state_id: "3569",
        },
        {
          id: "39898",
          name: "Chaam",
          state_id: "3569",
        },
        {
          id: "39899",
          name: "Khao Yoi",
          state_id: "3569",
        },
        {
          id: "39900",
          name: "Phetchaburi",
          state_id: "3569",
        },
        {
          id: "39901",
          name: "Tha Yang",
          state_id: "3569",
        },
      ],
      Phichit: [
        {
          id: "39902",
          name: "Bang Mun Nak",
          state_id: "3570",
        },
        {
          id: "39903",
          name: "Phichit",
          state_id: "3570",
        },
        {
          id: "39904",
          name: "Taphan Hin",
          state_id: "3570",
        },
        {
          id: "39905",
          name: "Thap Khlo",
          state_id: "3570",
        },
      ],
      Phitsanulok: [
        {
          id: "39906",
          name: "Bang Krathum",
          state_id: "3571",
        },
        {
          id: "39907",
          name: "Bang Rakam",
          state_id: "3571",
        },
        {
          id: "39908",
          name: "Nakhon Thai",
          state_id: "3571",
        },
        {
          id: "39909",
          name: "Phitsanulok",
          state_id: "3571",
        },
      ],
      "Phra Nakhon Si Ayutthaya": [],
      Phrae: [
        {
          id: "39910",
          name: "Den Chai",
          state_id: "3573",
        },
        {
          id: "39911",
          name: "Long",
          state_id: "3573",
        },
        {
          id: "39912",
          name: "Phrae",
          state_id: "3573",
        },
        {
          id: "39913",
          name: "Rong Kwang",
          state_id: "3573",
        },
      ],
      Phuket: [
        {
          id: "39914",
          name: "Kathu",
          state_id: "3574",
        },
        {
          id: "39915",
          name: "Phuket",
          state_id: "3574",
        },
      ],
      "Prachin Buri": [],
      "Prachuap Khiri Khan": [],
      Ranong: [
        {
          id: "39916",
          name: "Ranong",
          state_id: "3577",
        },
      ],
      Ratchaburi: [
        {
          id: "39917",
          name: "Ban Pong",
          state_id: "3578",
        },
        {
          id: "39918",
          name: "Bang Phae",
          state_id: "3578",
        },
        {
          id: "39919",
          name: "Chom Bung",
          state_id: "3578",
        },
        {
          id: "39920",
          name: "Damnoen Saduak",
          state_id: "3578",
        },
        {
          id: "39921",
          name: "Photharam",
          state_id: "3578",
        },
        {
          id: "39922",
          name: "Ratchaburi",
          state_id: "3578",
        },
      ],
      Rayong: [
        {
          id: "39923",
          name: "Ban Chang",
          state_id: "3579",
        },
        {
          id: "39924",
          name: "Klaeng",
          state_id: "3579",
        },
        {
          id: "39925",
          name: "Rayong",
          state_id: "3579",
        },
      ],
      "Roi Et": [],
      "Sa Kaeo": [],
      "Sakon Nakhon": [],
      "Samut Prakan": [],
      "Samut Sakhon": [],
      "Samut Songkhran": [],
      Saraburi: [
        {
          id: "39926",
          name: "Ban Mo",
          state_id: "3586",
        },
        {
          id: "39927",
          name: "Kaeng Khoi",
          state_id: "3586",
        },
        {
          id: "39928",
          name: "Nong Khae",
          state_id: "3586",
        },
        {
          id: "39929",
          name: "Phra Phutthabat",
          state_id: "3586",
        },
        {
          id: "39930",
          name: "Saraburi",
          state_id: "3586",
        },
      ],
      Satun: [
        {
          id: "39931",
          name: "Satun",
          state_id: "3587",
        },
      ],
      "Si Sa Ket": [],
      "Sing Buri": [],
      Songkhla: [
        {
          id: "39932",
          name: "Hat Yai",
          state_id: "3590",
        },
        {
          id: "39933",
          name: "Ranot",
          state_id: "3590",
        },
        {
          id: "39934",
          name: "Sadao",
          state_id: "3590",
        },
        {
          id: "39935",
          name: "Singha Nakhon",
          state_id: "3590",
        },
        {
          id: "39936",
          name: "Songkhla",
          state_id: "3590",
        },
      ],
      Sukhothai: [
        {
          id: "39937",
          name: "Khiri Mat",
          state_id: "3591",
        },
        {
          id: "39938",
          name: "Sawankhalok",
          state_id: "3591",
        },
        {
          id: "39939",
          name: "Si Satchanalai",
          state_id: "3591",
        },
        {
          id: "39940",
          name: "Sukhothai",
          state_id: "3591",
        },
      ],
      "Suphan Buri": [],
      "Surat Thani": [],
      Surin: [
        {
          id: "39941",
          name: "Phasat",
          state_id: "3594",
        },
        {
          id: "39942",
          name: "Surin",
          state_id: "3594",
        },
      ],
      Tak: [
        {
          id: "39943",
          name: "Ban Tak",
          state_id: "3595",
        },
        {
          id: "39944",
          name: "Mae Ramat",
          state_id: "3595",
        },
        {
          id: "39945",
          name: "Mae Sot",
          state_id: "3595",
        },
        {
          id: "39946",
          name: "Tak",
          state_id: "3595",
        },
      ],
      Trang: [
        {
          id: "39947",
          name: "Huai Yot",
          state_id: "3596",
        },
        {
          id: "39948",
          name: "Kantang",
          state_id: "3596",
        },
        {
          id: "39949",
          name: "Trang",
          state_id: "3596",
        },
      ],
      Trat: [
        {
          id: "39950",
          name: "Bo Rai",
          state_id: "3597",
        },
        {
          id: "39951",
          name: "Trat",
          state_id: "3597",
        },
      ],
      "Ubon Ratchathani": [],
      "Udon Thani": [],
      "Uthai Thani": [],
      Uttaradit: [
        {
          id: "39952",
          name: "Laplae",
          state_id: "3601",
        },
        {
          id: "39953",
          name: "Uttaradit",
          state_id: "3601",
        },
      ],
      Yala: [
        {
          id: "39954",
          name: "Betong",
          state_id: "3602",
        },
        {
          id: "39955",
          name: "Yala",
          state_id: "3602",
        },
      ],
      Yasothon: [
        {
          id: "39956",
          name: "Yasothon",
          state_id: "3603",
        },
      ],
    },
  },
  TJ: {
    name: "Tajikistan",
    native: "Тоҷикистон",
    phone: "992",
    continent: "AS",
    capital: "Dushanbe",
    currency: "TJS",
    languages: ["tg", "ru"],
    emoji: "🇹🇯",
    emojiU: "U+1F1F9 U+1F1EF",
    states: {
      Dushanbe: [
        {
          id: "39720",
          name: "Dushanbe",
          state_id: "3500",
        },
      ],
      "Gorno-Badakhshan": [
        {
          id: "39721",
          name: "Khorug",
          state_id: "3501",
        },
        {
          id: "39722",
          name: "Murgob",
          state_id: "3501",
        },
      ],
      Karotegin: [
        {
          id: "39723",
          name: "Garm",
          state_id: "3502",
        },
        {
          id: "39724",
          name: "Hisor",
          state_id: "3502",
        },
        {
          id: "39725",
          name: "Kofarnihon",
          state_id: "3502",
        },
        {
          id: "39726",
          name: "Leninskiy",
          state_id: "3502",
        },
        {
          id: "39727",
          name: "Rogun",
          state_id: "3502",
        },
        {
          id: "39728",
          name: "Shakhrinau",
          state_id: "3502",
        },
        {
          id: "39729",
          name: "Tursunzoda",
          state_id: "3502",
        },
      ],
      Khatlon: [
        {
          id: "39730",
          name: "Dangara",
          state_id: "3503",
        },
        {
          id: "39731",
          name: "Farkhor",
          state_id: "3503",
        },
        {
          id: "39732",
          name: "Jilikul",
          state_id: "3503",
        },
        {
          id: "39733",
          name: "Khojamaston",
          state_id: "3503",
        },
        {
          id: "39734",
          name: "Kolhozobod",
          state_id: "3503",
        },
        {
          id: "39735",
          name: "Kulob",
          state_id: "3503",
        },
        {
          id: "39736",
          name: "Kumsangir",
          state_id: "3503",
        },
        {
          id: "39737",
          name: "Moskva",
          state_id: "3503",
        },
        {
          id: "39738",
          name: "Mu''minobod",
          state_id: "3503",
        },
        {
          id: "39739",
          name: "Nurak",
          state_id: "3503",
        },
        {
          id: "39740",
          name: "Pyanj",
          state_id: "3503",
        },
        {
          id: "39741",
          name: "Qurgonteppa",
          state_id: "3503",
        },
        {
          id: "39742",
          name: "Sarband",
          state_id: "3503",
        },
        {
          id: "39743",
          name: "Shaartuz",
          state_id: "3503",
        },
        {
          id: "39744",
          name: "Sovetskiy",
          state_id: "3503",
        },
        {
          id: "39745",
          name: "Vakhsh",
          state_id: "3503",
        },
        {
          id: "39746",
          name: "Vose",
          state_id: "3503",
        },
        {
          id: "39747",
          name: "Yovon",
          state_id: "3503",
        },
      ],
      Sughd: [
        {
          id: "39748",
          name: "Adrasmon",
          state_id: "3504",
        },
        {
          id: "39749",
          name: "Asht",
          state_id: "3504",
        },
        {
          id: "39750",
          name: "Ayni",
          state_id: "3504",
        },
        {
          id: "39751",
          name: "Buston",
          state_id: "3504",
        },
        {
          id: "39752",
          name: "Chkalov",
          state_id: "3504",
        },
        {
          id: "39753",
          name: "Chorku",
          state_id: "3504",
        },
        {
          id: "39754",
          name: "Gafurov",
          state_id: "3504",
        },
        {
          id: "39755",
          name: "Ganchi",
          state_id: "3504",
        },
        {
          id: "39756",
          name: "Isfara",
          state_id: "3504",
        },
        {
          id: "39757",
          name: "Khujand",
          state_id: "3504",
        },
        {
          id: "39758",
          name: "Konibodom",
          state_id: "3504",
        },
        {
          id: "39759",
          name: "Matcha",
          state_id: "3504",
        },
        {
          id: "39760",
          name: "Nau",
          state_id: "3504",
        },
        {
          id: "39761",
          name: "Panjakent",
          state_id: "3504",
        },
        {
          id: "39762",
          name: "Proletarsk",
          state_id: "3504",
        },
        {
          id: "39763",
          name: "Qayroqqum",
          state_id: "3504",
        },
        {
          id: "39764",
          name: "Shurob",
          state_id: "3504",
        },
        {
          id: "39765",
          name: "Taboshar",
          state_id: "3504",
        },
        {
          id: "39766",
          name: "Uroteppa",
          state_id: "3504",
        },
        {
          id: "39767",
          name: "Zafarobod",
          state_id: "3504",
        },
      ],
    },
  },
  TK: {
    name: "Tokelau",
    native: "Tokelau",
    phone: "690",
    continent: "OC",
    capital: "Fakaofo",
    currency: "NZD",
    languages: ["en"],
    emoji: "🇹🇰",
    emojiU: "U+1F1F9 U+1F1F0",
    states: {
      Atafu: [
        {
          id: "39985",
          name: "Atafu",
          state_id: "3609",
        },
      ],
      Fakaofo: [
        {
          id: "39986",
          name: "Fakaofo",
          state_id: "3610",
        },
      ],
      Nukunonu: [
        {
          id: "39987",
          name: "Nukunonu",
          state_id: "3611",
        },
      ],
    },
  },
  TL: {
    name: "East Timor",
    native: "Timor-Leste",
    phone: "670",
    continent: "OC",
    capital: "Dili",
    currency: "USD",
    languages: ["pt"],
    emoji: "🇹🇱",
    emojiU: "U+1F1F9 U+1F1F1",
    states: {},
  },
  TM: {
    name: "Turkmenistan",
    native: "Türkmenistan",
    phone: "993",
    continent: "AS",
    capital: "Ashgabat",
    currency: "TMT",
    languages: ["tk", "ru"],
    emoji: "🇹🇲",
    emojiU: "U+1F1F9 U+1F1F2",
    states: {
      Ahal: [
        {
          id: "41119",
          name: "Ahchadepe",
          state_id: "3746",
        },
        {
          id: "41120",
          name: "Annau",
          state_id: "3746",
        },
        {
          id: "41121",
          name: "Babadayhan",
          state_id: "3746",
        },
        {
          id: "41122",
          name: "Baherden",
          state_id: "3746",
        },
        {
          id: "41123",
          name: "Birleshik Pervi",
          state_id: "3746",
        },
        {
          id: "41124",
          name: "Buzmeyin",
          state_id: "3746",
        },
        {
          id: "41125",
          name: "Dushak",
          state_id: "3746",
        },
        {
          id: "41126",
          name: "Gokedepe",
          state_id: "3746",
        },
        {
          id: "41127",
          name: "Kaka",
          state_id: "3746",
        },
        {
          id: "41128",
          name: "Miana",
          state_id: "3746",
        },
        {
          id: "41129",
          name: "Ovaz Jalatay",
          state_id: "3746",
        },
        {
          id: "41130",
          name: "Saragt",
          state_id: "3746",
        },
        {
          id: "41131",
          name: "Tecen",
          state_id: "3746",
        },
      ],
      Asgabat: [
        {
          id: "41132",
          name: "Asgabat",
          state_id: "3747",
        },
      ],
      Balkan: [
        {
          id: "41133",
          name: "Adyndaky",
          state_id: "3748",
        },
        {
          id: "41134",
          name: "Balkanabat",
          state_id: "3748",
        },
        {
          id: "41135",
          name: "Bekdash",
          state_id: "3748",
        },
        {
          id: "41136",
          name: "Gasanguli",
          state_id: "3748",
        },
        {
          id: "41137",
          name: "Gazanjyk",
          state_id: "3748",
        },
        {
          id: "41138",
          name: "Goturdepe",
          state_id: "3748",
        },
        {
          id: "41139",
          name: "Gumdag",
          state_id: "3748",
        },
        {
          id: "41140",
          name: "Jebel",
          state_id: "3748",
        },
        {
          id: "41141",
          name: "Karakala",
          state_id: "3748",
        },
        {
          id: "41142",
          name: "Khazar",
          state_id: "3748",
        },
        {
          id: "41143",
          name: "Serdar",
          state_id: "3748",
        },
        {
          id: "41144",
          name: "Sharlawuk",
          state_id: "3748",
        },
        {
          id: "41145",
          name: "Turkmenbasi",
          state_id: "3748",
        },
      ],
      Dasoguz: [
        {
          id: "41146",
          name: "Akdepe",
          state_id: "3749",
        },
        {
          id: "41147",
          name: "Boldumsaz",
          state_id: "3749",
        },
        {
          id: "41148",
          name: "Dasoguz",
          state_id: "3749",
        },
        {
          id: "41149",
          name: "Gubadag",
          state_id: "3749",
        },
        {
          id: "41150",
          name: "Kohne Urgenc",
          state_id: "3749",
        },
        {
          id: "41151",
          name: "Moskva",
          state_id: "3749",
        },
        {
          id: "41152",
          name: "Tagta",
          state_id: "3749",
        },
        {
          id: "41153",
          name: "Yilanli",
          state_id: "3749",
        },
      ],
      Lebap: [
        {
          id: "41154",
          name: "Darganata",
          state_id: "3750",
        },
        {
          id: "41155",
          name: "Esenmengli",
          state_id: "3750",
        },
        {
          id: "41156",
          name: "Farap",
          state_id: "3750",
        },
        {
          id: "41157",
          name: "Gazojak",
          state_id: "3750",
        },
        {
          id: "41158",
          name: "Govurdak",
          state_id: "3750",
        },
        {
          id: "41159",
          name: "Halac",
          state_id: "3750",
        },
        {
          id: "41160",
          name: "Kerki",
          state_id: "3750",
        },
        {
          id: "41161",
          name: "Komsomolsk",
          state_id: "3750",
        },
        {
          id: "41162",
          name: "Mukri",
          state_id: "3750",
        },
        {
          id: "41163",
          name: "Sayat",
          state_id: "3750",
        },
        {
          id: "41164",
          name: "Seydi",
          state_id: "3750",
        },
        {
          id: "41165",
          name: "Turkmenabat",
          state_id: "3750",
        },
      ],
      Mari: [
        {
          id: "41166",
          name: "Bayramali",
          state_id: "3751",
        },
        {
          id: "41167",
          name: "Eloten",
          state_id: "3751",
        },
        {
          id: "41168",
          name: "Mari",
          state_id: "3751",
        },
        {
          id: "41169",
          name: "Murgab",
          state_id: "3751",
        },
        {
          id: "41170",
          name: "Sakarchage",
          state_id: "3751",
        },
        {
          id: "41171",
          name: "Tagtabazar",
          state_id: "3751",
        },
        {
          id: "41172",
          name: "Turkmengala",
          state_id: "3751",
        },
      ],
    },
  },
  TN: {
    name: "Tunisia",
    native: "تونس",
    phone: "216",
    continent: "AF",
    capital: "Tunis",
    currency: "TND",
    languages: ["ar"],
    emoji: "🇹🇳",
    emojiU: "U+1F1F9 U+1F1F3",
    states: {
      Aryanah: [
        {
          id: "40009",
          name: "Aryanah",
          state_id: "3633",
        },
        {
          id: "40010",
          name: "Bordj Aalouine",
          state_id: "3633",
        },
        {
          id: "40011",
          name: "Burj-al-''Amri",
          state_id: "3633",
        },
        {
          id: "40012",
          name: "La Soukra",
          state_id: "3633",
        },
        {
          id: "40013",
          name: "Qal''at-al-Andalus",
          state_id: "3633",
        },
        {
          id: "40014",
          name: "Sidi Thabit",
          state_id: "3633",
        },
        {
          id: "40015",
          name: "Taburbah",
          state_id: "3633",
        },
        {
          id: "40016",
          name: "Wadi al-Layl",
          state_id: "3633",
        },
        {
          id: "40017",
          name: "ad-Dandan",
          state_id: "3633",
        },
        {
          id: "40018",
          name: "al-Battan",
          state_id: "3633",
        },
        {
          id: "40019",
          name: "al-Jadidah",
          state_id: "3633",
        },
        {
          id: "40020",
          name: "al-Murnaqiyah",
          state_id: "3633",
        },
        {
          id: "40021",
          name: "at-Tadaman Dawwar Hishar",
          state_id: "3633",
        },
      ],
      Bajah: [
        {
          id: "40022",
          name: "Bajah",
          state_id: "3634",
        },
        {
          id: "40023",
          name: "Majaz-al-Bab",
          state_id: "3634",
        },
        {
          id: "40024",
          name: "Nafzah",
          state_id: "3634",
        },
        {
          id: "40025",
          name: "Quballat",
          state_id: "3634",
        },
        {
          id: "40026",
          name: "Tabursuq",
          state_id: "3634",
        },
        {
          id: "40028",
          name: "Zahrat Madina",
          state_id: "3634",
        },
        {
          id: "40029",
          name: "al-Ma''qulah",
          state_id: "3634",
        },
      ],
      "Bin ''Arus": [],
      Binzart: [
        {
          id: "40030",
          name: "Awsajah",
          state_id: "3636",
        },
        {
          id: "40031",
          name: "Binzart",
          state_id: "3636",
        },
        {
          id: "40032",
          name: "Ghar-al-Milh",
          state_id: "3636",
        },
        {
          id: "40033",
          name: "Manzil ''Abd-ar-Rahman",
          state_id: "3636",
        },
        {
          id: "40034",
          name: "Manzil Bu Ruqaybah",
          state_id: "3636",
        },
        {
          id: "40035",
          name: "Manzil Jamil",
          state_id: "3636",
        },
        {
          id: "40036",
          name: "Matir",
          state_id: "3636",
        },
        {
          id: "40037",
          name: "Rafraf",
          state_id: "3636",
        },
        {
          id: "40038",
          name: "Ras-al-Jabal",
          state_id: "3636",
        },
        {
          id: "40039",
          name: "Sajanan",
          state_id: "3636",
        },
        {
          id: "40040",
          name: "Tinjah",
          state_id: "3636",
        },
        {
          id: "40041",
          name: "al-''Aliyah",
          state_id: "3636",
        },
        {
          id: "40042",
          name: "al-Matlin",
          state_id: "3636",
        },
      ],
      "Gouvernorat de Ariana": [],
      "Gouvernorat de Nabeul": [],
      "Gouvernorat de Sousse": [],
      "Hammamet Yasmine": [],
      Jundubah: [
        {
          id: "40043",
          name: "Ayn Darahim",
          state_id: "3641",
        },
        {
          id: "40044",
          name: "Bani Matir",
          state_id: "3641",
        },
        {
          id: "40045",
          name: "Bu Salim",
          state_id: "3641",
        },
        {
          id: "40046",
          name: "Firnanah",
          state_id: "3641",
        },
        {
          id: "40047",
          name: "Ghar-ad-Dima",
          state_id: "3641",
        },
        {
          id: "40048",
          name: "Jundubah",
          state_id: "3641",
        },
        {
          id: "40049",
          name: "Tabarqah",
          state_id: "3641",
        },
        {
          id: "40050",
          name: "Wadi Maliz",
          state_id: "3641",
        },
      ],
      Madaniyin: [
        {
          id: "40051",
          name: "Bani Khaddash",
          state_id: "3642",
        },
        {
          id: "40052",
          name: "Bin Qirdan",
          state_id: "3642",
        },
        {
          id: "40053",
          name: "Jarbah Ajim",
          state_id: "3642",
        },
        {
          id: "40054",
          name: "Jarbah Hawmat-as-Suq",
          state_id: "3642",
        },
        {
          id: "40055",
          name: "Jarbah Midun",
          state_id: "3642",
        },
        {
          id: "40056",
          name: "Jarjis",
          state_id: "3642",
        },
        {
          id: "40057",
          name: "Madaniyin",
          state_id: "3642",
        },
      ],
      Manubah: [
        {
          id: "40058",
          name: "Manubah",
          state_id: "3643",
        },
      ],
      Monastir: [
        {
          id: "40059",
          name: "Monastir",
          state_id: "3644",
        },
      ],
      Nabul: [
        {
          id: "40060",
          name: "Azimur",
          state_id: "3645",
        },
        {
          id: "40061",
          name: "Bani Hiyar",
          state_id: "3645",
        },
        {
          id: "40062",
          name: "Bani Khallad",
          state_id: "3645",
        },
        {
          id: "40063",
          name: "Bu ''Urqub",
          state_id: "3645",
        },
        {
          id: "40064",
          name: "Dar ''Alush",
          state_id: "3645",
        },
        {
          id: "40065",
          name: "Dar Sha''ban",
          state_id: "3645",
        },
        {
          id: "40066",
          name: "Hammam-al-Aghzaz",
          state_id: "3645",
        },
        {
          id: "40067",
          name: "Manzil Bu Zalafah",
          state_id: "3645",
        },
        {
          id: "40068",
          name: "Manzil Hurr",
          state_id: "3645",
        },
        {
          id: "40069",
          name: "Manzil Tamim",
          state_id: "3645",
        },
        {
          id: "40070",
          name: "Nabul",
          state_id: "3645",
        },
        {
          id: "40071",
          name: "Qalibiyah",
          state_id: "3645",
        },
        {
          id: "40072",
          name: "Qurbah",
          state_id: "3645",
        },
        {
          id: "40073",
          name: "Qurbus",
          state_id: "3645",
        },
        {
          id: "40074",
          name: "Qurunbaliyah",
          state_id: "3645",
        },
        {
          id: "40075",
          name: "Sulayman",
          state_id: "3645",
        },
        {
          id: "40076",
          name: "Taklisah",
          state_id: "3645",
        },
        {
          id: "40077",
          name: "Tazirkah",
          state_id: "3645",
        },
        {
          id: "40078",
          name: "Zawiyat-al-Jadidi",
          state_id: "3645",
        },
        {
          id: "40079",
          name: "al-Hammamat",
          state_id: "3645",
        },
        {
          id: "40080",
          name: "al-Huwariyah",
          state_id: "3645",
        },
        {
          id: "40081",
          name: "al-Ma''murah",
          state_id: "3645",
        },
        {
          id: "40082",
          name: "al-Middah",
          state_id: "3645",
        },
        {
          id: "40083",
          name: "as-Sama''ah",
          state_id: "3645",
        },
      ],
      Qabis: [
        {
          id: "40084",
          name: "Ghannush",
          state_id: "3646",
        },
        {
          id: "40085",
          name: "Marath",
          state_id: "3646",
        },
        {
          id: "40086",
          name: "Matmatat-al-Jadidah",
          state_id: "3646",
        },
        {
          id: "40087",
          name: "Matmatat-al-Qadimah",
          state_id: "3646",
        },
        {
          id: "40088",
          name: "Qabis",
          state_id: "3646",
        },
        {
          id: "40089",
          name: "Sanini an-Nahal",
          state_id: "3646",
        },
        {
          id: "40090",
          name: "Wadhraf",
          state_id: "3646",
        },
        {
          id: "40091",
          name: "al-Hammah",
          state_id: "3646",
        },
        {
          id: "40092",
          name: "al-Matwiyah",
          state_id: "3646",
        },
        {
          id: "40093",
          name: "az-Zarat",
          state_id: "3646",
        },
      ],
      Qafsah: [
        {
          id: "40094",
          name: "Qafsah",
          state_id: "3647",
        },
        {
          id: "40095",
          name: "Umm-al-''Arais",
          state_id: "3647",
        },
        {
          id: "40096",
          name: "al-Madilah",
          state_id: "3647",
        },
        {
          id: "40097",
          name: "al-Mitlawi",
          state_id: "3647",
        },
        {
          id: "40098",
          name: "al-Qasr",
          state_id: "3647",
        },
        {
          id: "40099",
          name: "al-Qatar",
          state_id: "3647",
        },
        {
          id: "40100",
          name: "ar-Rudayyif",
          state_id: "3647",
        },
        {
          id: "40101",
          name: "as-Sanad",
          state_id: "3647",
        },
      ],
      Qibili: [
        {
          id: "40102",
          name: "Duz",
          state_id: "3648",
        },
        {
          id: "40103",
          name: "Jamnah",
          state_id: "3648",
        },
        {
          id: "40104",
          name: "Qibili",
          state_id: "3648",
        },
        {
          id: "40105",
          name: "Suq-al-Ahad",
          state_id: "3648",
        },
        {
          id: "40106",
          name: "al-Qal''ah",
          state_id: "3648",
        },
      ],
      Safaqis: [
        {
          id: "40107",
          name: "Aqarib",
          state_id: "3649",
        },
        {
          id: "40108",
          name: "Bi''r Ali Bin Khalifah",
          state_id: "3649",
        },
        {
          id: "40109",
          name: "Jabinyanah",
          state_id: "3649",
        },
        {
          id: "40110",
          name: "Manzil Shakir",
          state_id: "3649",
        },
        {
          id: "40111",
          name: "Qarmadah",
          state_id: "3649",
        },
        {
          id: "40112",
          name: "Qarqannah",
          state_id: "3649",
        },
        {
          id: "40113",
          name: "Safaqis",
          state_id: "3649",
        },
        {
          id: "40114",
          name: "Saqiyat-ad-Dair",
          state_id: "3649",
        },
        {
          id: "40115",
          name: "Saqiyat-az-Zayt",
          state_id: "3649",
        },
        {
          id: "40116",
          name: "Sfax",
          state_id: "3649",
        },
        {
          id: "40117",
          name: "Tinah",
          state_id: "3649",
        },
        {
          id: "40118",
          name: "al-''Ayn",
          state_id: "3649",
        },
        {
          id: "40119",
          name: "al-Hanashah",
          state_id: "3649",
        },
        {
          id: "40120",
          name: "al-Mahras",
          state_id: "3649",
        },
        {
          id: "40121",
          name: "as-Sukhayrah",
          state_id: "3649",
        },
        {
          id: "40122",
          name: "ash-Shayhiyah",
          state_id: "3649",
        },
      ],
      Sfax: [
        {
          id: "40123",
          name: "Sfax",
          state_id: "3650",
        },
      ],
      "Sidi Bu Zayd": [],
      Silyanah: [
        {
          id: "40124",
          name: "Barqu",
          state_id: "3652",
        },
        {
          id: "40125",
          name: "Bu ''Aradah",
          state_id: "3652",
        },
        {
          id: "40126",
          name: "Bu Ruwis",
          state_id: "3652",
        },
        {
          id: "40127",
          name: "Kasra",
          state_id: "3652",
        },
        {
          id: "40128",
          name: "Makthar",
          state_id: "3652",
        },
        {
          id: "40129",
          name: "Qa''afur",
          state_id: "3652",
        },
        {
          id: "40130",
          name: "Silyanah",
          state_id: "3652",
        },
        {
          id: "40131",
          name: "al-''Arusah",
          state_id: "3652",
        },
        {
          id: "40132",
          name: "al-Karib",
          state_id: "3652",
        },
        {
          id: "40133",
          name: "ar-Rawhiyah",
          state_id: "3652",
        },
      ],
      Susah: [
        {
          id: "40134",
          name: "Akkudah",
          state_id: "3653",
        },
        {
          id: "40135",
          name: "Bu Fishah",
          state_id: "3653",
        },
        {
          id: "40136",
          name: "Hammam Susah",
          state_id: "3653",
        },
        {
          id: "40137",
          name: "Harqalah",
          state_id: "3653",
        },
        {
          id: "40138",
          name: "Masakin",
          state_id: "3653",
        },
        {
          id: "40139",
          name: "Qusaybat-ath-Thurayat",
          state_id: "3653",
        },
        {
          id: "40140",
          name: "Sidi Bu ''Ali",
          state_id: "3653",
        },
        {
          id: "40141",
          name: "Sidi al-Hani",
          state_id: "3653",
        },
        {
          id: "40142",
          name: "Susah",
          state_id: "3653",
        },
        {
          id: "40143",
          name: "Zawiyat Susah",
          state_id: "3653",
        },
        {
          id: "40144",
          name: "al-Masa''din",
          state_id: "3653",
        },
        {
          id: "40145",
          name: "al-Qal''at-al-Kabirah",
          state_id: "3653",
        },
        {
          id: "40146",
          name: "al-Qal''at-as-Saghirah",
          state_id: "3653",
        },
        {
          id: "40147",
          name: "an-Nafidah",
          state_id: "3653",
        },
        {
          id: "40148",
          name: "az-Zuhur",
          state_id: "3653",
        },
      ],
      Tatawin: [
        {
          id: "40149",
          name: "Bi''r-al-Ahmar",
          state_id: "3654",
        },
        {
          id: "40150",
          name: "Dhahibah",
          state_id: "3654",
        },
        {
          id: "40151",
          name: "Ghumrassin",
          state_id: "3654",
        },
        {
          id: "40152",
          name: "Rimadah",
          state_id: "3654",
        },
        {
          id: "40153",
          name: "Tatawin",
          state_id: "3654",
        },
      ],
      Tawzar: [
        {
          id: "40154",
          name: "Daqash",
          state_id: "3655",
        },
        {
          id: "40155",
          name: "Hammat-al-Jarid",
          state_id: "3655",
        },
        {
          id: "40156",
          name: "Naftah",
          state_id: "3655",
        },
        {
          id: "40157",
          name: "Tamaghzah",
          state_id: "3655",
        },
        {
          id: "40158",
          name: "Tawzar",
          state_id: "3655",
        },
      ],
      Tunis: [
        {
          id: "40159",
          name: "Bardaw",
          state_id: "3656",
        },
        {
          id: "40160",
          name: "Ben Arous",
          state_id: "3656",
        },
        {
          id: "40161",
          name: "Carthage",
          state_id: "3656",
        },
        {
          id: "40162",
          name: "Halq-al-Wadi",
          state_id: "3656",
        },
        {
          id: "40163",
          name: "Megrine",
          state_id: "3656",
        },
        {
          id: "40164",
          name: "Qartaj",
          state_id: "3656",
        },
        {
          id: "40165",
          name: "Sidi Bu Sa''id",
          state_id: "3656",
        },
        {
          id: "40166",
          name: "Tunis",
          state_id: "3656",
        },
        {
          id: "40167",
          name: "al-Marsa",
          state_id: "3656",
        },
      ],
      Zaghwan: [
        {
          id: "40168",
          name: "Bi''r Mashariqah",
          state_id: "3657",
        },
        {
          id: "40169",
          name: "Jabal-al-Wust",
          state_id: "3657",
        },
        {
          id: "40170",
          name: "Zaghwan",
          state_id: "3657",
        },
        {
          id: "40171",
          name: "al-Fahs",
          state_id: "3657",
        },
        {
          id: "40172",
          name: "an-Nazur",
          state_id: "3657",
        },
        {
          id: "40173",
          name: "az-Zaribah",
          state_id: "3657",
        },
      ],
      "al-Kaf": [
        {
          id: "40174",
          name: "Manzil Salim",
          state_id: "3658",
        },
        {
          id: "40175",
          name: "Nibbar",
          state_id: "3658",
        },
        {
          id: "40176",
          name: "Qal''at-as-Sanan",
          state_id: "3658",
        },
        {
          id: "40177",
          name: "Saqiyat Sidi Yussuf",
          state_id: "3658",
        },
        {
          id: "40178",
          name: "Tajarwin",
          state_id: "3658",
        },
        {
          id: "40179",
          name: "ad-Dahmani",
          state_id: "3658",
        },
        {
          id: "40180",
          name: "al-Jarissah",
          state_id: "3658",
        },
        {
          id: "40181",
          name: "al-Kaf",
          state_id: "3658",
        },
        {
          id: "40182",
          name: "al-Qal''at-al-Khasba",
          state_id: "3658",
        },
        {
          id: "40183",
          name: "al-Qusur",
          state_id: "3658",
        },
        {
          id: "40184",
          name: "as-Sars",
          state_id: "3658",
        },
        {
          id: "40185",
          name: "at-Tawiraf",
          state_id: "3658",
        },
      ],
      "al-Mahdiyah": [
        {
          id: "40186",
          name: "Awlad ash-Shamakh",
          state_id: "3659",
        },
        {
          id: "40187",
          name: "Bumirdas",
          state_id: "3659",
        },
        {
          id: "40188",
          name: "Habirah",
          state_id: "3659",
        },
        {
          id: "40189",
          name: "Karkar",
          state_id: "3659",
        },
        {
          id: "40190",
          name: "Mallulash",
          state_id: "3659",
        },
        {
          id: "40191",
          name: "Qusur-as-Saf",
          state_id: "3659",
        },
        {
          id: "40192",
          name: "Rajish",
          state_id: "3659",
        },
        {
          id: "40193",
          name: "Shurban",
          state_id: "3659",
        },
        {
          id: "40194",
          name: "Sidi ''Ulwan",
          state_id: "3659",
        },
        {
          id: "40195",
          name: "al-Baradi''ah",
          state_id: "3659",
        },
        {
          id: "40196",
          name: "al-Jamm",
          state_id: "3659",
        },
        {
          id: "40197",
          name: "al-Mahdiyah",
          state_id: "3659",
        },
        {
          id: "40198",
          name: "as-Sawasi",
          state_id: "3659",
        },
        {
          id: "40199",
          name: "ash-Shabbah",
          state_id: "3659",
        },
      ],
      "al-Munastir": [
        {
          id: "40200",
          name: "Amirat-al-Fahul",
          state_id: "3660",
        },
        {
          id: "40201",
          name: "Amirat-al-Hajjaj",
          state_id: "3660",
        },
        {
          id: "40202",
          name: "Amirat-at-Tawazarah",
          state_id: "3660",
        },
        {
          id: "40203",
          name: "Banan Budar",
          state_id: "3660",
        },
        {
          id: "40204",
          name: "Banblat wal-Manarah",
          state_id: "3660",
        },
        {
          id: "40205",
          name: "Bani Hassan",
          state_id: "3660",
        },
        {
          id: "40206",
          name: "Bu Hajjar",
          state_id: "3660",
        },
        {
          id: "40207",
          name: "Ghanadah",
          state_id: "3660",
        },
        {
          id: "40208",
          name: "Jammal",
          state_id: "3660",
        },
        {
          id: "40209",
          name: "Khunays",
          state_id: "3660",
        },
        {
          id: "40210",
          name: "Lamtah",
          state_id: "3660",
        },
        {
          id: "40211",
          name: "Manzil Farsi",
          state_id: "3660",
        },
        {
          id: "40212",
          name: "Manzil Hayah",
          state_id: "3660",
        },
        {
          id: "40213",
          name: "Manzil Kamil",
          state_id: "3660",
        },
        {
          id: "40214",
          name: "Manzil Nur",
          state_id: "3660",
        },
        {
          id: "40215",
          name: "Qasr Hallal",
          state_id: "3660",
        },
        {
          id: "40216",
          name: "Qusaybat-al-Madyuni",
          state_id: "3660",
        },
        {
          id: "40217",
          name: "Sahilin Ma''atmar",
          state_id: "3660",
        },
        {
          id: "40218",
          name: "Sayyadah",
          state_id: "3660",
        },
        {
          id: "40219",
          name: "Sidi ''Amara",
          state_id: "3660",
        },
        {
          id: "40220",
          name: "Sidi Bin Nur",
          state_id: "3660",
        },
        {
          id: "40221",
          name: "Tabulbah",
          state_id: "3660",
        },
        {
          id: "40222",
          name: "Tuzah",
          state_id: "3660",
        },
        {
          id: "40223",
          name: "Zaramidin",
          state_id: "3660",
        },
        {
          id: "40224",
          name: "Zawiyat Quntash",
          state_id: "3660",
        },
        {
          id: "40225",
          name: "al-Baqalitah",
          state_id: "3660",
        },
        {
          id: "40226",
          name: "al-Masdur",
          state_id: "3660",
        },
        {
          id: "40227",
          name: "al-Muknin",
          state_id: "3660",
        },
        {
          id: "40228",
          name: "al-Munastir",
          state_id: "3660",
        },
        {
          id: "40229",
          name: "al-Wardanin",
          state_id: "3660",
        },
        {
          id: "40230",
          name: "ash-Sharahil",
          state_id: "3660",
        },
      ],
      "al-Qasrayn": [
        {
          id: "40231",
          name: "Firyanah",
          state_id: "3661",
        },
        {
          id: "40232",
          name: "Fussanah",
          state_id: "3661",
        },
        {
          id: "40233",
          name: "Haydrah",
          state_id: "3661",
        },
        {
          id: "40234",
          name: "Jadliyan",
          state_id: "3661",
        },
        {
          id: "40235",
          name: "Majal Bal ''Abbas",
          state_id: "3661",
        },
        {
          id: "40236",
          name: "Sabibah",
          state_id: "3661",
        },
        {
          id: "40237",
          name: "Subaytilah",
          state_id: "3661",
        },
        {
          id: "40238",
          name: "Talabat",
          state_id: "3661",
        },
        {
          id: "40239",
          name: "Talah",
          state_id: "3661",
        },
        {
          id: "40240",
          name: "al-Qasrayn",
          state_id: "3661",
        },
      ],
      "al-Qayrawan": [
        {
          id: "40241",
          name: "Ayn Jalulah",
          state_id: "3662",
        },
        {
          id: "40242",
          name: "Buhajlah",
          state_id: "3662",
        },
        {
          id: "40243",
          name: "Haffuz",
          state_id: "3662",
        },
        {
          id: "40244",
          name: "Hajib-al-''Ayun",
          state_id: "3662",
        },
        {
          id: "40245",
          name: "Manzil Mahidi",
          state_id: "3662",
        },
        {
          id: "40246",
          name: "Nasr Allah",
          state_id: "3662",
        },
        {
          id: "40247",
          name: "al-''Ala",
          state_id: "3662",
        },
        {
          id: "40248",
          name: "al-Qayrawan",
          state_id: "3662",
        },
        {
          id: "40249",
          name: "al-Waslatiyah",
          state_id: "3662",
        },
        {
          id: "40250",
          name: "as-Subaykhah",
          state_id: "3662",
        },
        {
          id: "40251",
          name: "ash-Shabikah",
          state_id: "3662",
        },
        {
          id: "40252",
          name: "ash-Sharardah",
          state_id: "3662",
        },
      ],
    },
  },
  TO: {
    name: "Tonga",
    native: "Tonga",
    phone: "676",
    continent: "OC",
    capital: "Nuku'alofa",
    currency: "TOP",
    languages: ["en", "to"],
    emoji: "🇹🇴",
    emojiU: "U+1F1F9 U+1F1F4",
    states: {
      Eua: [
        {
          id: "39988",
          name: "Ohonua",
          state_id: "3612",
        },
      ],
      "Ha''apai": [
        {
          id: "39989",
          name: "Pangai",
          state_id: "3613",
        },
      ],
      Niuas: [
        {
          id: "39990",
          name: "Hihifo",
          state_id: "3614",
        },
      ],
      Tongatapu: [
        {
          id: "39991",
          name: "Haveloloto",
          state_id: "3615",
        },
        {
          id: "39992",
          name: "Mu''a",
          state_id: "3615",
        },
        {
          id: "39993",
          name: "Nuku''alofa",
          state_id: "3615",
        },
        {
          id: "39994",
          name: "Tofoa-Koloua",
          state_id: "3615",
        },
        {
          id: "39995",
          name: "Vaini",
          state_id: "3615",
        },
      ],
      "Vava''u": [
        {
          id: "39996",
          name: "Neiafu",
          state_id: "3616",
        },
      ],
    },
  },
  TR: {
    name: "Turkey",
    native: "Türkiye",
    phone: "90",
    continent: "AS",
    capital: "Ankara",
    currency: "TRY",
    languages: ["tr"],
    emoji: "🇹🇷",
    emojiU: "U+1F1F9 U+1F1F7",
    states: {
      Adana: [
        {
          id: "40253",
          name: "Adana",
          state_id: "3663",
        },
        {
          id: "40254",
          name: "Aladag",
          state_id: "3663",
        },
        {
          id: "40255",
          name: "Ceyhan",
          state_id: "3663",
        },
        {
          id: "40256",
          name: "Feke",
          state_id: "3663",
        },
        {
          id: "40257",
          name: "Imamoglu",
          state_id: "3663",
        },
        {
          id: "40258",
          name: "Karaisali",
          state_id: "3663",
        },
        {
          id: "40259",
          name: "Karatas",
          state_id: "3663",
        },
        {
          id: "40260",
          name: "Kozan",
          state_id: "3663",
        },
        {
          id: "40261",
          name: "Pozanti",
          state_id: "3663",
        },
        {
          id: "40262",
          name: "Saimbeyli",
          state_id: "3663",
        },
        {
          id: "40263",
          name: "Tufanbeyli",
          state_id: "3663",
        },
        {
          id: "40264",
          name: "Yumurtalik",
          state_id: "3663",
        },
      ],
      Adiyaman: [
        {
          id: "40265",
          name: "Adiyaman",
          state_id: "3664",
        },
        {
          id: "40266",
          name: "Besni",
          state_id: "3664",
        },
        {
          id: "40267",
          name: "Celikhan",
          state_id: "3664",
        },
        {
          id: "40268",
          name: "Gerger",
          state_id: "3664",
        },
        {
          id: "40269",
          name: "Golbasi",
          state_id: "3664",
        },
        {
          id: "40270",
          name: "Kahta",
          state_id: "3664",
        },
        {
          id: "40271",
          name: "Samsat",
          state_id: "3664",
        },
        {
          id: "40272",
          name: "Sincik",
          state_id: "3664",
        },
        {
          id: "40273",
          name: "Tut",
          state_id: "3664",
        },
      ],
      Afyon: [
        {
          id: "40274",
          name: "Afyonkarahisar",
          state_id: "3665",
        },
        {
          id: "40275",
          name: "Basmakci",
          state_id: "3665",
        },
        {
          id: "40276",
          name: "Bayat",
          state_id: "3665",
        },
        {
          id: "40277",
          name: "Bolvadin",
          state_id: "3665",
        },
        {
          id: "40278",
          name: "Cay",
          state_id: "3665",
        },
        {
          id: "40279",
          name: "Dazkiri",
          state_id: "3665",
        },
        {
          id: "40280",
          name: "Dinar",
          state_id: "3665",
        },
        {
          id: "40281",
          name: "Emirdag",
          state_id: "3665",
        },
        {
          id: "40282",
          name: "Evciler",
          state_id: "3665",
        },
        {
          id: "40283",
          name: "Hocalar",
          state_id: "3665",
        },
        {
          id: "40284",
          name: "Ihsaniye",
          state_id: "3665",
        },
        {
          id: "40285",
          name: "Iscehisar",
          state_id: "3665",
        },
        {
          id: "40286",
          name: "Kiziloren",
          state_id: "3665",
        },
        {
          id: "40287",
          name: "Sandikli",
          state_id: "3665",
        },
        {
          id: "40288",
          name: "Sincanli",
          state_id: "3665",
        },
        {
          id: "40289",
          name: "Suhut",
          state_id: "3665",
        },
        {
          id: "40290",
          name: "Sultandagi",
          state_id: "3665",
        },
      ],
      Agri: [
        {
          id: "40291",
          name: "Diyadin",
          state_id: "3666",
        },
        {
          id: "40292",
          name: "Dogubeyazit",
          state_id: "3666",
        },
        {
          id: "40293",
          name: "Eleskirt",
          state_id: "3666",
        },
        {
          id: "40294",
          name: "Hamur",
          state_id: "3666",
        },
        {
          id: "40295",
          name: "Karakose",
          state_id: "3666",
        },
        {
          id: "40296",
          name: "Patnos",
          state_id: "3666",
        },
        {
          id: "40297",
          name: "Taslicay",
          state_id: "3666",
        },
        {
          id: "40298",
          name: "Tutak",
          state_id: "3666",
        },
      ],
      Aksaray: [
        {
          id: "40299",
          name: "Agacoren",
          state_id: "3667",
        },
        {
          id: "40300",
          name: "Aksaray",
          state_id: "3667",
        },
        {
          id: "40301",
          name: "Eskil",
          state_id: "3667",
        },
        {
          id: "40302",
          name: "Gulagac",
          state_id: "3667",
        },
        {
          id: "40303",
          name: "Guzelyurt",
          state_id: "3667",
        },
        {
          id: "40304",
          name: "Ortakoy",
          state_id: "3667",
        },
        {
          id: "40305",
          name: "Sariyahsi",
          state_id: "3667",
        },
      ],
      Amasya: [
        {
          id: "40306",
          name: "Amasya",
          state_id: "3668",
        },
        {
          id: "40307",
          name: "Goynucek",
          state_id: "3668",
        },
        {
          id: "40308",
          name: "Gumushacikoy",
          state_id: "3668",
        },
        {
          id: "40309",
          name: "Hamamozu",
          state_id: "3668",
        },
        {
          id: "40310",
          name: "Merzifon",
          state_id: "3668",
        },
        {
          id: "40311",
          name: "Suluova",
          state_id: "3668",
        },
        {
          id: "40312",
          name: "Tasova",
          state_id: "3668",
        },
      ],
      Ankara: [
        {
          id: "40313",
          name: "Akyurt",
          state_id: "3669",
        },
        {
          id: "40314",
          name: "Ankara",
          state_id: "3669",
        },
        {
          id: "40315",
          name: "Ayas",
          state_id: "3669",
        },
        {
          id: "40316",
          name: "Beypazari",
          state_id: "3669",
        },
        {
          id: "40317",
          name: "Camlidere",
          state_id: "3669",
        },
        {
          id: "40318",
          name: "Cubuk",
          state_id: "3669",
        },
        {
          id: "40319",
          name: "Elmadag",
          state_id: "3669",
        },
        {
          id: "40320",
          name: "Evren",
          state_id: "3669",
        },
        {
          id: "40321",
          name: "Gudul",
          state_id: "3669",
        },
        {
          id: "40322",
          name: "Haymana",
          state_id: "3669",
        },
        {
          id: "40323",
          name: "Kalecik",
          state_id: "3669",
        },
        {
          id: "40324",
          name: "Kazan",
          state_id: "3669",
        },
        {
          id: "40325",
          name: "Kizilcahamam",
          state_id: "3669",
        },
        {
          id: "40326",
          name: "Nallihan",
          state_id: "3669",
        },
        {
          id: "40327",
          name: "Polatli",
          state_id: "3669",
        },
        {
          id: "40328",
          name: "Sereflikochisar",
          state_id: "3669",
        },
        {
          id: "40329",
          name: "Yenisehir",
          state_id: "3669",
        },
      ],
      Antalya: [
        {
          id: "40330",
          name: "Akseki",
          state_id: "3670",
        },
        {
          id: "40331",
          name: "Alanya",
          state_id: "3670",
        },
        {
          id: "40332",
          name: "Antalya",
          state_id: "3670",
        },
        {
          id: "40333",
          name: "Elmali",
          state_id: "3670",
        },
        {
          id: "40334",
          name: "Finike",
          state_id: "3670",
        },
        {
          id: "40335",
          name: "Gazipasa",
          state_id: "3670",
        },
        {
          id: "40336",
          name: "Gundogmus",
          state_id: "3670",
        },
        {
          id: "40337",
          name: "Ibradi",
          state_id: "3670",
        },
        {
          id: "40338",
          name: "Kale",
          state_id: "3670",
        },
        {
          id: "40339",
          name: "Kas",
          state_id: "3670",
        },
        {
          id: "40340",
          name: "Kemer",
          state_id: "3670",
        },
        {
          id: "40341",
          name: "Konya",
          state_id: "3670",
        },
        {
          id: "40342",
          name: "Korkuteli",
          state_id: "3670",
        },
        {
          id: "40343",
          name: "Kumluca",
          state_id: "3670",
        },
        {
          id: "40344",
          name: "Manavgat",
          state_id: "3670",
        },
        {
          id: "40345",
          name: "Serik",
          state_id: "3670",
        },
      ],
      Ardahan: [
        {
          id: "40346",
          name: "Ardahan",
          state_id: "3671",
        },
        {
          id: "40347",
          name: "Damal",
          state_id: "3671",
        },
        {
          id: "40348",
          name: "Gole",
          state_id: "3671",
        },
        {
          id: "40349",
          name: "Hanak",
          state_id: "3671",
        },
        {
          id: "40350",
          name: "Posof",
          state_id: "3671",
        },
      ],
      Artvin: [
        {
          id: "40351",
          name: "Ardanuc",
          state_id: "3672",
        },
        {
          id: "40352",
          name: "Arhavi",
          state_id: "3672",
        },
        {
          id: "40353",
          name: "Artvin",
          state_id: "3672",
        },
        {
          id: "40354",
          name: "Borcka",
          state_id: "3672",
        },
        {
          id: "40355",
          name: "Hopa",
          state_id: "3672",
        },
        {
          id: "40356",
          name: "Murgul",
          state_id: "3672",
        },
        {
          id: "40357",
          name: "Savsat",
          state_id: "3672",
        },
        {
          id: "40358",
          name: "Yusufeli",
          state_id: "3672",
        },
      ],
      Aydin: [
        {
          id: "40359",
          name: "Aydin",
          state_id: "3673",
        },
        {
          id: "40360",
          name: "Bozdogan",
          state_id: "3673",
        },
        {
          id: "40361",
          name: "Buharkent",
          state_id: "3673",
        },
        {
          id: "40362",
          name: "Cine",
          state_id: "3673",
        },
        {
          id: "40363",
          name: "Didim",
          state_id: "3673",
        },
        {
          id: "40364",
          name: "Germencik",
          state_id: "3673",
        },
        {
          id: "40365",
          name: "Incirliova",
          state_id: "3673",
        },
        {
          id: "40366",
          name: "Karacasu",
          state_id: "3673",
        },
        {
          id: "40367",
          name: "Karpuzlu",
          state_id: "3673",
        },
        {
          id: "40368",
          name: "Kocarli",
          state_id: "3673",
        },
        {
          id: "40369",
          name: "Kosk",
          state_id: "3673",
        },
        {
          id: "40370",
          name: "Kusadasi",
          state_id: "3673",
        },
        {
          id: "40371",
          name: "Kuyucak",
          state_id: "3673",
        },
        {
          id: "40372",
          name: "Nazilli",
          state_id: "3673",
        },
        {
          id: "40373",
          name: "Soke",
          state_id: "3673",
        },
        {
          id: "40374",
          name: "Sultanhisar",
          state_id: "3673",
        },
        {
          id: "40375",
          name: "Yenipazar",
          state_id: "3673",
        },
      ],
      Balikesir: [
        {
          id: "40376",
          name: "Ayvalik",
          state_id: "3674",
        },
        {
          id: "40377",
          name: "Balikesir",
          state_id: "3674",
        },
        {
          id: "40378",
          name: "Balya",
          state_id: "3674",
        },
        {
          id: "40379",
          name: "Bandirma",
          state_id: "3674",
        },
        {
          id: "40380",
          name: "Bigadic",
          state_id: "3674",
        },
        {
          id: "40381",
          name: "Burhaniye",
          state_id: "3674",
        },
        {
          id: "40382",
          name: "Dursunbey",
          state_id: "3674",
        },
        {
          id: "40383",
          name: "Edremit",
          state_id: "3674",
        },
        {
          id: "40384",
          name: "Erdek",
          state_id: "3674",
        },
        {
          id: "40385",
          name: "Gomec",
          state_id: "3674",
        },
        {
          id: "40386",
          name: "Gonen",
          state_id: "3674",
        },
        {
          id: "40387",
          name: "Havran",
          state_id: "3674",
        },
        {
          id: "40388",
          name: "Ivrindi",
          state_id: "3674",
        },
        {
          id: "40389",
          name: "Kepsut",
          state_id: "3674",
        },
        {
          id: "40390",
          name: "Manyas",
          state_id: "3674",
        },
        {
          id: "40391",
          name: "Marmara",
          state_id: "3674",
        },
        {
          id: "40392",
          name: "Sakarya",
          state_id: "3674",
        },
        {
          id: "40393",
          name: "Savastepe",
          state_id: "3674",
        },
        {
          id: "40394",
          name: "Sindirgi",
          state_id: "3674",
        },
        {
          id: "40395",
          name: "Susurluk",
          state_id: "3674",
        },
      ],
      Bartin: [
        {
          id: "40396",
          name: "Amasra",
          state_id: "3675",
        },
        {
          id: "40397",
          name: "Bartin",
          state_id: "3675",
        },
        {
          id: "40398",
          name: "Kurucasile",
          state_id: "3675",
        },
        {
          id: "40399",
          name: "Ulus",
          state_id: "3675",
        },
      ],
      Batman: [
        {
          id: "40400",
          name: "Batman",
          state_id: "3676",
        },
        {
          id: "40401",
          name: "Besiri",
          state_id: "3676",
        },
        {
          id: "40402",
          name: "Gercus",
          state_id: "3676",
        },
        {
          id: "40403",
          name: "Hasankeyf",
          state_id: "3676",
        },
        {
          id: "40404",
          name: "Kozluk",
          state_id: "3676",
        },
        {
          id: "40405",
          name: "Sason",
          state_id: "3676",
        },
      ],
      Bayburt: [
        {
          id: "40406",
          name: "Aydintepe",
          state_id: "3677",
        },
        {
          id: "40407",
          name: "Bayburt",
          state_id: "3677",
        },
        {
          id: "40408",
          name: "Demirozu",
          state_id: "3677",
        },
      ],
      Bilecik: [
        {
          id: "40409",
          name: "Bilecik",
          state_id: "3678",
        },
        {
          id: "40410",
          name: "Bozuyuk",
          state_id: "3678",
        },
        {
          id: "40411",
          name: "Golpazari",
          state_id: "3678",
        },
        {
          id: "40412",
          name: "Inhisar",
          state_id: "3678",
        },
        {
          id: "40413",
          name: "Osmaneli",
          state_id: "3678",
        },
        {
          id: "40414",
          name: "Pazaryeri",
          state_id: "3678",
        },
        {
          id: "40415",
          name: "Sogut",
          state_id: "3678",
        },
        {
          id: "40416",
          name: "Yenipazar",
          state_id: "3678",
        },
      ],
      Bingol: [
        {
          id: "40417",
          name: "Adakli",
          state_id: "3679",
        },
        {
          id: "40418",
          name: "Bingol",
          state_id: "3679",
        },
        {
          id: "40419",
          name: "Genc",
          state_id: "3679",
        },
        {
          id: "40420",
          name: "Karliova",
          state_id: "3679",
        },
        {
          id: "40421",
          name: "Kigi",
          state_id: "3679",
        },
        {
          id: "40422",
          name: "Solhan",
          state_id: "3679",
        },
        {
          id: "40423",
          name: "Yayladere",
          state_id: "3679",
        },
        {
          id: "40424",
          name: "Yedisu",
          state_id: "3679",
        },
      ],
      Bitlis: [
        {
          id: "40425",
          name: "Adilcevaz",
          state_id: "3680",
        },
        {
          id: "40426",
          name: "Ahlat",
          state_id: "3680",
        },
        {
          id: "40427",
          name: "Bitlis",
          state_id: "3680",
        },
        {
          id: "40428",
          name: "Guroymak",
          state_id: "3680",
        },
        {
          id: "40429",
          name: "Hizan",
          state_id: "3680",
        },
        {
          id: "40430",
          name: "Mutki",
          state_id: "3680",
        },
        {
          id: "40431",
          name: "Tatvan",
          state_id: "3680",
        },
      ],
      Bolu: [
        {
          id: "40432",
          name: "Akcakoca",
          state_id: "3681",
        },
        {
          id: "40433",
          name: "Bolu",
          state_id: "3681",
        },
        {
          id: "40434",
          name: "Dortdivan",
          state_id: "3681",
        },
        {
          id: "40435",
          name: "Gerede",
          state_id: "3681",
        },
        {
          id: "40436",
          name: "Goynuk",
          state_id: "3681",
        },
        {
          id: "40437",
          name: "Kibriscik",
          state_id: "3681",
        },
        {
          id: "40438",
          name: "Mengen",
          state_id: "3681",
        },
        {
          id: "40439",
          name: "Mudurnu",
          state_id: "3681",
        },
        {
          id: "40440",
          name: "Seben",
          state_id: "3681",
        },
        {
          id: "40441",
          name: "Yenicaga",
          state_id: "3681",
        },
      ],
      Burdur: [
        {
          id: "40442",
          name: "Aglasun",
          state_id: "3682",
        },
        {
          id: "40443",
          name: "Altinyayla",
          state_id: "3682",
        },
        {
          id: "40444",
          name: "Bucak",
          state_id: "3682",
        },
        {
          id: "40445",
          name: "Burdur",
          state_id: "3682",
        },
        {
          id: "40446",
          name: "Golhisar",
          state_id: "3682",
        },
        {
          id: "40447",
          name: "Karamanli",
          state_id: "3682",
        },
        {
          id: "40448",
          name: "Kemer",
          state_id: "3682",
        },
        {
          id: "40449",
          name: "Tefenni",
          state_id: "3682",
        },
        {
          id: "40450",
          name: "Yesilova",
          state_id: "3682",
        },
      ],
      Bursa: [
        {
          id: "40451",
          name: "Bursa",
          state_id: "3683",
        },
        {
          id: "40452",
          name: "Buyukorhan",
          state_id: "3683",
        },
        {
          id: "40453",
          name: "Gemlik",
          state_id: "3683",
        },
        {
          id: "40454",
          name: "Gursu",
          state_id: "3683",
        },
        {
          id: "40455",
          name: "Harmancik",
          state_id: "3683",
        },
        {
          id: "40456",
          name: "Inegol",
          state_id: "3683",
        },
        {
          id: "40457",
          name: "Iznik",
          state_id: "3683",
        },
        {
          id: "40458",
          name: "Karacabey",
          state_id: "3683",
        },
        {
          id: "40459",
          name: "Keles",
          state_id: "3683",
        },
        {
          id: "40460",
          name: "Kestel",
          state_id: "3683",
        },
        {
          id: "40461",
          name: "Mudanya",
          state_id: "3683",
        },
        {
          id: "40462",
          name: "Mustafakemalpasa",
          state_id: "3683",
        },
        {
          id: "40463",
          name: "Orhaneli",
          state_id: "3683",
        },
        {
          id: "40464",
          name: "Orhangazi",
          state_id: "3683",
        },
        {
          id: "40465",
          name: "Yenisehir",
          state_id: "3683",
        },
      ],
      Canakkale: [
        {
          id: "40466",
          name: "Ayvacik",
          state_id: "3684",
        },
        {
          id: "40467",
          name: "Bayramic",
          state_id: "3684",
        },
        {
          id: "40468",
          name: "Biga",
          state_id: "3684",
        },
        {
          id: "40469",
          name: "Bozcaada",
          state_id: "3684",
        },
        {
          id: "40470",
          name: "Can",
          state_id: "3684",
        },
        {
          id: "40471",
          name: "Canakkale",
          state_id: "3684",
        },
        {
          id: "40472",
          name: "Eceabat",
          state_id: "3684",
        },
        {
          id: "40473",
          name: "Ezine",
          state_id: "3684",
        },
        {
          id: "40474",
          name: "Gelibolu",
          state_id: "3684",
        },
        {
          id: "40475",
          name: "Gokceada",
          state_id: "3684",
        },
        {
          id: "40476",
          name: "Lapseki",
          state_id: "3684",
        },
        {
          id: "40477",
          name: "Yenice",
          state_id: "3684",
        },
      ],
      Cankiri: [
        {
          id: "40478",
          name: "Atkaracalar",
          state_id: "3685",
        },
        {
          id: "40479",
          name: "Bayramoren",
          state_id: "3685",
        },
        {
          id: "40480",
          name: "Cankiri",
          state_id: "3685",
        },
        {
          id: "40481",
          name: "Cerkes",
          state_id: "3685",
        },
        {
          id: "40482",
          name: "Eldivan",
          state_id: "3685",
        },
        {
          id: "40483",
          name: "Ilgaz",
          state_id: "3685",
        },
        {
          id: "40484",
          name: "Kizilirmak",
          state_id: "3685",
        },
        {
          id: "40485",
          name: "Korgun",
          state_id: "3685",
        },
        {
          id: "40486",
          name: "Kursunlu",
          state_id: "3685",
        },
        {
          id: "40487",
          name: "Orta",
          state_id: "3685",
        },
        {
          id: "40488",
          name: "Sabanozu",
          state_id: "3685",
        },
        {
          id: "40489",
          name: "Yaprakli",
          state_id: "3685",
        },
      ],
      Corum: [
        {
          id: "40490",
          name: "Alaca",
          state_id: "3686",
        },
        {
          id: "40491",
          name: "Bayat",
          state_id: "3686",
        },
        {
          id: "40492",
          name: "Corum",
          state_id: "3686",
        },
        {
          id: "40493",
          name: "Dodurga",
          state_id: "3686",
        },
        {
          id: "40494",
          name: "Iskilip",
          state_id: "3686",
        },
        {
          id: "40495",
          name: "Kargi",
          state_id: "3686",
        },
        {
          id: "40496",
          name: "Lacin",
          state_id: "3686",
        },
        {
          id: "40497",
          name: "Mecitozu",
          state_id: "3686",
        },
        {
          id: "40498",
          name: "Oguzlar",
          state_id: "3686",
        },
        {
          id: "40499",
          name: "Ortakoy",
          state_id: "3686",
        },
        {
          id: "40500",
          name: "Osmancik",
          state_id: "3686",
        },
        {
          id: "40501",
          name: "Sungurlu",
          state_id: "3686",
        },
        {
          id: "40502",
          name: "Ugurludag",
          state_id: "3686",
        },
      ],
      Denizli: [
        {
          id: "40503",
          name: "Acipayam",
          state_id: "3687",
        },
        {
          id: "40504",
          name: "Akkoy",
          state_id: "3687",
        },
        {
          id: "40505",
          name: "Babadag",
          state_id: "3687",
        },
        {
          id: "40506",
          name: "Baklan",
          state_id: "3687",
        },
        {
          id: "40507",
          name: "Bekilli",
          state_id: "3687",
        },
        {
          id: "40508",
          name: "Bozkurt",
          state_id: "3687",
        },
        {
          id: "40509",
          name: "Buldan",
          state_id: "3687",
        },
        {
          id: "40510",
          name: "Cardak",
          state_id: "3687",
        },
        {
          id: "40511",
          name: "Civril",
          state_id: "3687",
        },
        {
          id: "40512",
          name: "Denizli",
          state_id: "3687",
        },
        {
          id: "40513",
          name: "Guney",
          state_id: "3687",
        },
        {
          id: "40514",
          name: "Honaz",
          state_id: "3687",
        },
        {
          id: "40515",
          name: "Kale",
          state_id: "3687",
        },
        {
          id: "40516",
          name: "Saraykoy",
          state_id: "3687",
        },
        {
          id: "40517",
          name: "Serinhisar",
          state_id: "3687",
        },
        {
          id: "40518",
          name: "Tavas",
          state_id: "3687",
        },
      ],
      Diyarbakir: [
        {
          id: "40519",
          name: "Bismil",
          state_id: "3688",
        },
        {
          id: "40520",
          name: "Cermik",
          state_id: "3688",
        },
        {
          id: "40521",
          name: "Cinar",
          state_id: "3688",
        },
        {
          id: "40522",
          name: "Cungus",
          state_id: "3688",
        },
        {
          id: "40523",
          name: "Dicle",
          state_id: "3688",
        },
        {
          id: "40524",
          name: "Diyarbakir",
          state_id: "3688",
        },
        {
          id: "40525",
          name: "Egil",
          state_id: "3688",
        },
        {
          id: "40526",
          name: "Ergani",
          state_id: "3688",
        },
        {
          id: "40527",
          name: "Hani",
          state_id: "3688",
        },
        {
          id: "40528",
          name: "Hazro",
          state_id: "3688",
        },
        {
          id: "40529",
          name: "Kocakoy",
          state_id: "3688",
        },
        {
          id: "40530",
          name: "Kulp",
          state_id: "3688",
        },
        {
          id: "40531",
          name: "Lice",
          state_id: "3688",
        },
        {
          id: "40532",
          name: "Silvan",
          state_id: "3688",
        },
      ],
      Duzce: [
        {
          id: "40533",
          name: "Cumayeri",
          state_id: "3689",
        },
        {
          id: "40534",
          name: "Duzce",
          state_id: "3689",
        },
        {
          id: "40535",
          name: "Golyaka",
          state_id: "3689",
        },
        {
          id: "40536",
          name: "Gumusova",
          state_id: "3689",
        },
        {
          id: "40537",
          name: "Kaynasli",
          state_id: "3689",
        },
        {
          id: "40538",
          name: "Yigilca",
          state_id: "3689",
        },
      ],
      Edirne: [
        {
          id: "40539",
          name: "Edirne",
          state_id: "3690",
        },
        {
          id: "40540",
          name: "Enez",
          state_id: "3690",
        },
        {
          id: "40541",
          name: "Havsa",
          state_id: "3690",
        },
        {
          id: "40542",
          name: "Ipsala",
          state_id: "3690",
        },
        {
          id: "40543",
          name: "Kesan",
          state_id: "3690",
        },
        {
          id: "40544",
          name: "Lalapasa",
          state_id: "3690",
        },
        {
          id: "40545",
          name: "Meric",
          state_id: "3690",
        },
        {
          id: "40546",
          name: "Suleoglu",
          state_id: "3690",
        },
        {
          id: "40547",
          name: "Uzunkopru",
          state_id: "3690",
        },
      ],
      Elazig: [
        {
          id: "40548",
          name: "Agin",
          state_id: "3691",
        },
        {
          id: "40549",
          name: "Alacakaya",
          state_id: "3691",
        },
        {
          id: "40550",
          name: "Aricak",
          state_id: "3691",
        },
        {
          id: "40551",
          name: "Baskil",
          state_id: "3691",
        },
        {
          id: "40552",
          name: "Elazig",
          state_id: "3691",
        },
        {
          id: "40553",
          name: "Karakocan",
          state_id: "3691",
        },
        {
          id: "40554",
          name: "Keban",
          state_id: "3691",
        },
        {
          id: "40555",
          name: "Kovancilar",
          state_id: "3691",
        },
        {
          id: "40556",
          name: "Maden",
          state_id: "3691",
        },
        {
          id: "40557",
          name: "Palu",
          state_id: "3691",
        },
        {
          id: "40558",
          name: "Sivrice",
          state_id: "3691",
        },
      ],
      Erzincan: [
        {
          id: "40559",
          name: "Erzincan",
          state_id: "3692",
        },
        {
          id: "40560",
          name: "Ilic",
          state_id: "3692",
        },
        {
          id: "40561",
          name: "Kemah",
          state_id: "3692",
        },
        {
          id: "40562",
          name: "Kemaliye",
          state_id: "3692",
        },
        {
          id: "40563",
          name: "Otlukbeli",
          state_id: "3692",
        },
        {
          id: "40564",
          name: "Refahiye",
          state_id: "3692",
        },
        {
          id: "40565",
          name: "Tercan",
          state_id: "3692",
        },
        {
          id: "40566",
          name: "Uzumlu",
          state_id: "3692",
        },
      ],
      Erzurum: [
        {
          id: "40567",
          name: "Askale",
          state_id: "3693",
        },
        {
          id: "40568",
          name: "Erzurum",
          state_id: "3693",
        },
        {
          id: "40569",
          name: "Hinis",
          state_id: "3693",
        },
        {
          id: "40570",
          name: "Horasan",
          state_id: "3693",
        },
        {
          id: "40571",
          name: "Ilica",
          state_id: "3693",
        },
        {
          id: "40572",
          name: "Ispir",
          state_id: "3693",
        },
        {
          id: "40573",
          name: "Karacoban",
          state_id: "3693",
        },
        {
          id: "40574",
          name: "Karayazi",
          state_id: "3693",
        },
        {
          id: "40575",
          name: "Koprukoy",
          state_id: "3693",
        },
        {
          id: "40576",
          name: "Narman",
          state_id: "3693",
        },
        {
          id: "40577",
          name: "Oltu",
          state_id: "3693",
        },
        {
          id: "40578",
          name: "Olur",
          state_id: "3693",
        },
        {
          id: "40579",
          name: "Pasinler",
          state_id: "3693",
        },
        {
          id: "40580",
          name: "Pazaryolu",
          state_id: "3693",
        },
        {
          id: "40581",
          name: "Senkaya",
          state_id: "3693",
        },
        {
          id: "40582",
          name: "Tekman",
          state_id: "3693",
        },
        {
          id: "40583",
          name: "Tortum",
          state_id: "3693",
        },
        {
          id: "40584",
          name: "Uzundere",
          state_id: "3693",
        },
      ],
      Eskisehir: [
        {
          id: "40585",
          name: "Alpu",
          state_id: "3694",
        },
        {
          id: "40586",
          name: "Beylikova",
          state_id: "3694",
        },
        {
          id: "40587",
          name: "Cifteler",
          state_id: "3694",
        },
        {
          id: "40588",
          name: "Eskisehir",
          state_id: "3694",
        },
        {
          id: "40589",
          name: "Gunyuzu",
          state_id: "3694",
        },
        {
          id: "40590",
          name: "Han",
          state_id: "3694",
        },
        {
          id: "40591",
          name: "Inonu",
          state_id: "3694",
        },
        {
          id: "40592",
          name: "Mahmudiye",
          state_id: "3694",
        },
        {
          id: "40593",
          name: "Mihalgazi",
          state_id: "3694",
        },
        {
          id: "40594",
          name: "Mihaliccik",
          state_id: "3694",
        },
        {
          id: "40595",
          name: "Saricakaya",
          state_id: "3694",
        },
        {
          id: "40596",
          name: "Seyitgazi",
          state_id: "3694",
        },
        {
          id: "40597",
          name: "Sivrihisar",
          state_id: "3694",
        },
      ],
      Gaziantep: [
        {
          id: "40598",
          name: "Araban",
          state_id: "3695",
        },
        {
          id: "40599",
          name: "Gaziantep",
          state_id: "3695",
        },
        {
          id: "40600",
          name: "Islahiye",
          state_id: "3695",
        },
        {
          id: "40601",
          name: "Karkamis",
          state_id: "3695",
        },
        {
          id: "40602",
          name: "Nizip",
          state_id: "3695",
        },
        {
          id: "40603",
          name: "Nurdagi",
          state_id: "3695",
        },
        {
          id: "40604",
          name: "Oguzeli",
          state_id: "3695",
        },
        {
          id: "40605",
          name: "Sehitkamil",
          state_id: "3695",
        },
        {
          id: "40606",
          name: "Yavuzeli",
          state_id: "3695",
        },
      ],
      Giresun: [
        {
          id: "40607",
          name: "Aluca",
          state_id: "3696",
        },
        {
          id: "40608",
          name: "Bulancak",
          state_id: "3696",
        },
        {
          id: "40609",
          name: "Dereli",
          state_id: "3696",
        },
        {
          id: "40610",
          name: "Dogankent",
          state_id: "3696",
        },
        {
          id: "40611",
          name: "Espiye",
          state_id: "3696",
        },
        {
          id: "40612",
          name: "Eynesil",
          state_id: "3696",
        },
        {
          id: "40613",
          name: "Giresun",
          state_id: "3696",
        },
        {
          id: "40614",
          name: "Gorele",
          state_id: "3696",
        },
        {
          id: "40615",
          name: "Guce",
          state_id: "3696",
        },
        {
          id: "40616",
          name: "Kesap",
          state_id: "3696",
        },
        {
          id: "40617",
          name: "Piraziz",
          state_id: "3696",
        },
        {
          id: "40618",
          name: "Sebinkarahisar",
          state_id: "3696",
        },
        {
          id: "40619",
          name: "Tirebolu",
          state_id: "3696",
        },
        {
          id: "40620",
          name: "Yaglidere",
          state_id: "3696",
        },
      ],
      Gumushane: [
        {
          id: "40621",
          name: "Gumushane",
          state_id: "3697",
        },
        {
          id: "40622",
          name: "Kelkit",
          state_id: "3697",
        },
        {
          id: "40623",
          name: "Kose",
          state_id: "3697",
        },
        {
          id: "40624",
          name: "Kurtun",
          state_id: "3697",
        },
        {
          id: "40625",
          name: "Siran",
          state_id: "3697",
        },
        {
          id: "40626",
          name: "Torul",
          state_id: "3697",
        },
      ],
      Hakkari: [
        {
          id: "40627",
          name: "Cukurca",
          state_id: "3698",
        },
        {
          id: "40628",
          name: "Hakkari",
          state_id: "3698",
        },
        {
          id: "40629",
          name: "Semdinli",
          state_id: "3698",
        },
        {
          id: "40630",
          name: "Yuksekova",
          state_id: "3698",
        },
      ],
      Hatay: [
        {
          id: "40631",
          name: "Altinozu",
          state_id: "3699",
        },
        {
          id: "40632",
          name: "Antakya",
          state_id: "3699",
        },
        {
          id: "40633",
          name: "Belen",
          state_id: "3699",
        },
        {
          id: "40634",
          name: "Dortyol",
          state_id: "3699",
        },
        {
          id: "40635",
          name: "Erzin",
          state_id: "3699",
        },
        {
          id: "40636",
          name: "Hassa",
          state_id: "3699",
        },
        {
          id: "40637",
          name: "Iskenderun",
          state_id: "3699",
        },
        {
          id: "40638",
          name: "Kirikhan",
          state_id: "3699",
        },
        {
          id: "40639",
          name: "Kumlu",
          state_id: "3699",
        },
        {
          id: "40640",
          name: "Reyhanli",
          state_id: "3699",
        },
        {
          id: "40641",
          name: "Samandag",
          state_id: "3699",
        },
        {
          id: "40642",
          name: "Yayladagi",
          state_id: "3699",
        },
      ],
      Icel: [
        {
          id: "40643",
          name: "Anamur",
          state_id: "3700",
        },
        {
          id: "40644",
          name: "Aydincik",
          state_id: "3700",
        },
        {
          id: "40645",
          name: "Bozyazi",
          state_id: "3700",
        },
        {
          id: "40646",
          name: "Erdemli",
          state_id: "3700",
        },
        {
          id: "40647",
          name: "Gulnar",
          state_id: "3700",
        },
        {
          id: "40648",
          name: "Mersin",
          state_id: "3700",
        },
        {
          id: "40649",
          name: "Mut",
          state_id: "3700",
        },
        {
          id: "40650",
          name: "Silifke",
          state_id: "3700",
        },
        {
          id: "40651",
          name: "Tarsus",
          state_id: "3700",
        },
      ],
      Igdir: [
        {
          id: "40652",
          name: "Aralik",
          state_id: "3701",
        },
        {
          id: "40653",
          name: "Igdir",
          state_id: "3701",
        },
        {
          id: "40654",
          name: "Karakoyunlu",
          state_id: "3701",
        },
        {
          id: "40655",
          name: "Tuzluca",
          state_id: "3701",
        },
      ],
      Isparta: [
        {
          id: "40656",
          name: "Aksu",
          state_id: "3702",
        },
        {
          id: "40657",
          name: "Atabey",
          state_id: "3702",
        },
        {
          id: "40658",
          name: "Egirdir",
          state_id: "3702",
        },
        {
          id: "40659",
          name: "Gelendost",
          state_id: "3702",
        },
        {
          id: "40660",
          name: "Gonen",
          state_id: "3702",
        },
        {
          id: "40661",
          name: "Isparta",
          state_id: "3702",
        },
        {
          id: "40662",
          name: "Keciborlu",
          state_id: "3702",
        },
        {
          id: "40663",
          name: "Sarkikaraagac",
          state_id: "3702",
        },
        {
          id: "40664",
          name: "Senirkent",
          state_id: "3702",
        },
        {
          id: "40665",
          name: "Sutculer",
          state_id: "3702",
        },
        {
          id: "40666",
          name: "Uluborlu",
          state_id: "3702",
        },
        {
          id: "40667",
          name: "Yalvac",
          state_id: "3702",
        },
        {
          id: "40668",
          name: "Yenisarbademli",
          state_id: "3702",
        },
      ],
      Istanbul: [
        {
          id: "40669",
          name: "Buyukcekmece",
          state_id: "3703",
        },
        {
          id: "40670",
          name: "Catalca",
          state_id: "3703",
        },
        {
          id: "40671",
          name: "Eminonu",
          state_id: "3703",
        },
        {
          id: "40672",
          name: "Esenler",
          state_id: "3703",
        },
        {
          id: "40673",
          name: "Istanbul",
          state_id: "3703",
        },
        {
          id: "40674",
          name: "KadÃ„Â±koy",
          state_id: "3703",
        },
        {
          id: "40675",
          name: "Sile",
          state_id: "3703",
        },
        {
          id: "40676",
          name: "Silivri",
          state_id: "3703",
        },
        {
          id: "40677",
          name: "Sultanbeyli",
          state_id: "3703",
        },
        {
          id: "40678",
          name: "TopkapÃ„Â±",
          state_id: "3703",
        },
        {
          id: "40679",
          name: "Tuzla",
          state_id: "3703",
        },
        {
          id: "40680",
          name: "Umraniye",
          state_id: "3703",
        },
      ],
      Izmir: [
        {
          id: "40681",
          name: "Aliaga",
          state_id: "3704",
        },
        {
          id: "40682",
          name: "Alsancak",
          state_id: "3704",
        },
        {
          id: "40683",
          name: "Bayindir",
          state_id: "3704",
        },
        {
          id: "40684",
          name: "Bergama",
          state_id: "3704",
        },
        {
          id: "40685",
          name: "Beyagac",
          state_id: "3704",
        },
        {
          id: "40686",
          name: "Bornova",
          state_id: "3704",
        },
        {
          id: "40687",
          name: "Cesme",
          state_id: "3704",
        },
        {
          id: "40688",
          name: "Digor",
          state_id: "3704",
        },
        {
          id: "40689",
          name: "Dikili",
          state_id: "3704",
        },
        {
          id: "40690",
          name: "Foca",
          state_id: "3704",
        },
        {
          id: "40691",
          name: "Izmir",
          state_id: "3704",
        },
        {
          id: "40692",
          name: "Karaburun",
          state_id: "3704",
        },
        {
          id: "40693",
          name: "Kemalpasa",
          state_id: "3704",
        },
        {
          id: "40694",
          name: "Kinik",
          state_id: "3704",
        },
        {
          id: "40695",
          name: "Kiraz",
          state_id: "3704",
        },
        {
          id: "40696",
          name: "Menderes",
          state_id: "3704",
        },
        {
          id: "40697",
          name: "Menemen",
          state_id: "3704",
        },
        {
          id: "40698",
          name: "Merkezi",
          state_id: "3704",
        },
        {
          id: "40699",
          name: "Mersinli",
          state_id: "3704",
        },
        {
          id: "40700",
          name: "Odemis",
          state_id: "3704",
        },
        {
          id: "40701",
          name: "Seferihisar",
          state_id: "3704",
        },
        {
          id: "40702",
          name: "Selcuk",
          state_id: "3704",
        },
        {
          id: "40703",
          name: "Tire",
          state_id: "3704",
        },
        {
          id: "40704",
          name: "Torbali",
          state_id: "3704",
        },
        {
          id: "40705",
          name: "Urla",
          state_id: "3704",
        },
      ],
      Kahramanmaras: [
        {
          id: "40706",
          name: "Afsin",
          state_id: "3705",
        },
        {
          id: "40707",
          name: "Andirin",
          state_id: "3705",
        },
        {
          id: "40708",
          name: "Caglayancerit",
          state_id: "3705",
        },
        {
          id: "40709",
          name: "Ekinozu",
          state_id: "3705",
        },
        {
          id: "40710",
          name: "Elbistan",
          state_id: "3705",
        },
        {
          id: "40711",
          name: "Goksun",
          state_id: "3705",
        },
        {
          id: "40712",
          name: "Kahramanmaras",
          state_id: "3705",
        },
        {
          id: "40713",
          name: "Nurhak",
          state_id: "3705",
        },
        {
          id: "40714",
          name: "Pazarcik",
          state_id: "3705",
        },
        {
          id: "40715",
          name: "Turkoglu",
          state_id: "3705",
        },
      ],
      Karabuk: [
        {
          id: "40716",
          name: "Eflani",
          state_id: "3706",
        },
        {
          id: "40717",
          name: "Eskipazar",
          state_id: "3706",
        },
        {
          id: "40718",
          name: "Karabuk",
          state_id: "3706",
        },
        {
          id: "40719",
          name: "Ovacik",
          state_id: "3706",
        },
        {
          id: "40720",
          name: "Safranbolu",
          state_id: "3706",
        },
        {
          id: "40721",
          name: "Yenice",
          state_id: "3706",
        },
      ],
      Karaman: [
        {
          id: "40722",
          name: "Ayranci",
          state_id: "3707",
        },
        {
          id: "40723",
          name: "Basyayla",
          state_id: "3707",
        },
        {
          id: "40724",
          name: "Ermenek",
          state_id: "3707",
        },
        {
          id: "40725",
          name: "Karaman",
          state_id: "3707",
        },
        {
          id: "40726",
          name: "Kazimkarabekir",
          state_id: "3707",
        },
        {
          id: "40727",
          name: "Sariveliler",
          state_id: "3707",
        },
      ],
      Kars: [
        {
          id: "40728",
          name: "Akyaka",
          state_id: "3708",
        },
        {
          id: "40729",
          name: "Arpacay",
          state_id: "3708",
        },
        {
          id: "40730",
          name: "Kagizman",
          state_id: "3708",
        },
        {
          id: "40731",
          name: "Kars",
          state_id: "3708",
        },
        {
          id: "40732",
          name: "Sarikamis",
          state_id: "3708",
        },
        {
          id: "40733",
          name: "Selim",
          state_id: "3708",
        },
        {
          id: "40734",
          name: "Susuz",
          state_id: "3708",
        },
      ],
      Karsiyaka: [
        {
          id: "40735",
          name: "Karsiyaka",
          state_id: "3709",
        },
      ],
      Kastamonu: [
        {
          id: "40736",
          name: "Abana",
          state_id: "3710",
        },
        {
          id: "40737",
          name: "Agli",
          state_id: "3710",
        },
        {
          id: "40738",
          name: "Arac",
          state_id: "3710",
        },
        {
          id: "40739",
          name: "Azdavay",
          state_id: "3710",
        },
        {
          id: "40740",
          name: "Bozkurt",
          state_id: "3710",
        },
        {
          id: "40741",
          name: "Daday",
          state_id: "3710",
        },
        {
          id: "40742",
          name: "Devrekani",
          state_id: "3710",
        },
        {
          id: "40743",
          name: "Doganyurt",
          state_id: "3710",
        },
        {
          id: "40744",
          name: "Hanonu",
          state_id: "3710",
        },
        {
          id: "40745",
          name: "Ihsangazi",
          state_id: "3710",
        },
        {
          id: "40746",
          name: "Inebolu",
          state_id: "3710",
        },
        {
          id: "40747",
          name: "Kastamonu",
          state_id: "3710",
        },
        {
          id: "40748",
          name: "Kure",
          state_id: "3710",
        },
        {
          id: "40749",
          name: "Pinarbasi",
          state_id: "3710",
        },
        {
          id: "40750",
          name: "Senpazar",
          state_id: "3710",
        },
        {
          id: "40751",
          name: "Seydiler",
          state_id: "3710",
        },
        {
          id: "40752",
          name: "Taskopru",
          state_id: "3710",
        },
        {
          id: "40753",
          name: "Tosya",
          state_id: "3710",
        },
      ],
      Kayseri: [
        {
          id: "40754",
          name: "Akkisla",
          state_id: "3711",
        },
        {
          id: "40755",
          name: "Bunyan",
          state_id: "3711",
        },
        {
          id: "40756",
          name: "Develi",
          state_id: "3711",
        },
        {
          id: "40757",
          name: "Felahiye",
          state_id: "3711",
        },
        {
          id: "40758",
          name: "Hacilar",
          state_id: "3711",
        },
        {
          id: "40759",
          name: "Incesu",
          state_id: "3711",
        },
        {
          id: "40760",
          name: "Kayseri",
          state_id: "3711",
        },
        {
          id: "40761",
          name: "Ozvatan",
          state_id: "3711",
        },
        {
          id: "40762",
          name: "Pinarbasi",
          state_id: "3711",
        },
        {
          id: "40763",
          name: "Sarioglan",
          state_id: "3711",
        },
        {
          id: "40764",
          name: "Sariz",
          state_id: "3711",
        },
        {
          id: "40765",
          name: "Talas",
          state_id: "3711",
        },
        {
          id: "40766",
          name: "Tomarza",
          state_id: "3711",
        },
        {
          id: "40767",
          name: "Yahyali",
          state_id: "3711",
        },
        {
          id: "40768",
          name: "Yesilhisar",
          state_id: "3711",
        },
      ],
      Kilis: [
        {
          id: "40769",
          name: "Elbeyli",
          state_id: "3712",
        },
        {
          id: "40770",
          name: "Kilis",
          state_id: "3712",
        },
        {
          id: "40771",
          name: "Musabeyli",
          state_id: "3712",
        },
        {
          id: "40772",
          name: "Polateli",
          state_id: "3712",
        },
      ],
      Kirikkale: [
        {
          id: "40773",
          name: "Bahsili",
          state_id: "3713",
        },
        {
          id: "40774",
          name: "Baliseyh",
          state_id: "3713",
        },
        {
          id: "40775",
          name: "Delice",
          state_id: "3713",
        },
        {
          id: "40776",
          name: "Karakecili",
          state_id: "3713",
        },
        {
          id: "40777",
          name: "Keskin",
          state_id: "3713",
        },
        {
          id: "40778",
          name: "Kirikkale",
          state_id: "3713",
        },
        {
          id: "40779",
          name: "Sulakyurt",
          state_id: "3713",
        },
        {
          id: "40780",
          name: "Yahsihan",
          state_id: "3713",
        },
      ],
      Kirklareli: [
        {
          id: "40781",
          name: "Babaeski",
          state_id: "3714",
        },
        {
          id: "40782",
          name: "Demirkoy",
          state_id: "3714",
        },
        {
          id: "40783",
          name: "Kirklareli",
          state_id: "3714",
        },
        {
          id: "40784",
          name: "Kofcaz",
          state_id: "3714",
        },
        {
          id: "40785",
          name: "Kumkoy",
          state_id: "3714",
        },
        {
          id: "40786",
          name: "Luleburgaz",
          state_id: "3714",
        },
        {
          id: "40787",
          name: "Pehlivankoy",
          state_id: "3714",
        },
        {
          id: "40788",
          name: "Pinarhisar",
          state_id: "3714",
        },
        {
          id: "40789",
          name: "Vize",
          state_id: "3714",
        },
      ],
      Kirsehir: [
        {
          id: "40790",
          name: "Akcakent",
          state_id: "3715",
        },
        {
          id: "40791",
          name: "Akpinar",
          state_id: "3715",
        },
        {
          id: "40792",
          name: "Boztepe",
          state_id: "3715",
        },
        {
          id: "40793",
          name: "Kaman",
          state_id: "3715",
        },
        {
          id: "40794",
          name: "Kirsehir",
          state_id: "3715",
        },
        {
          id: "40795",
          name: "Mucur",
          state_id: "3715",
        },
      ],
      Kocaeli: [
        {
          id: "40796",
          name: "CayÃ„Â±rova",
          state_id: "3716",
        },
        {
          id: "40797",
          name: "Derince",
          state_id: "3716",
        },
        {
          id: "40798",
          name: "DilovasÃ„Â±",
          state_id: "3716",
        },
        {
          id: "40799",
          name: "Gebze",
          state_id: "3716",
        },
        {
          id: "40800",
          name: "Golcuk",
          state_id: "3716",
        },
        {
          id: "40801",
          name: "Izmit",
          state_id: "3716",
        },
        {
          id: "40802",
          name: "Kandira",
          state_id: "3716",
        },
        {
          id: "40803",
          name: "Karamursel",
          state_id: "3716",
        },
        {
          id: "40804",
          name: "Kocaeli",
          state_id: "3716",
        },
        {
          id: "40805",
          name: "Korfez",
          state_id: "3716",
        },
      ],
      Konya: [
        {
          id: "40806",
          name: "Ahirli",
          state_id: "3717",
        },
        {
          id: "40807",
          name: "Akoren",
          state_id: "3717",
        },
        {
          id: "40808",
          name: "Aksehir",
          state_id: "3717",
        },
        {
          id: "40809",
          name: "Altinekin",
          state_id: "3717",
        },
        {
          id: "40810",
          name: "Beysehir",
          state_id: "3717",
        },
        {
          id: "40811",
          name: "Bozkir",
          state_id: "3717",
        },
        {
          id: "40812",
          name: "Cihanbeyli",
          state_id: "3717",
        },
        {
          id: "40813",
          name: "Cumra",
          state_id: "3717",
        },
        {
          id: "40814",
          name: "Derbent",
          state_id: "3717",
        },
        {
          id: "40815",
          name: "Derebucak",
          state_id: "3717",
        },
        {
          id: "40816",
          name: "Doganhisar",
          state_id: "3717",
        },
        {
          id: "40817",
          name: "Emirgazi",
          state_id: "3717",
        },
        {
          id: "40818",
          name: "Eregli",
          state_id: "3717",
        },
        {
          id: "40819",
          name: "Guneysinir",
          state_id: "3717",
        },
        {
          id: "40820",
          name: "Hadim",
          state_id: "3717",
        },
        {
          id: "40821",
          name: "Halkapinar",
          state_id: "3717",
        },
        {
          id: "40822",
          name: "Huyuk",
          state_id: "3717",
        },
        {
          id: "40823",
          name: "Ilgin",
          state_id: "3717",
        },
        {
          id: "40824",
          name: "Kadinhani",
          state_id: "3717",
        },
        {
          id: "40825",
          name: "Karapinar",
          state_id: "3717",
        },
        {
          id: "40826",
          name: "Konya",
          state_id: "3717",
        },
        {
          id: "40827",
          name: "Kulu",
          state_id: "3717",
        },
        {
          id: "40828",
          name: "Sarayonu",
          state_id: "3717",
        },
        {
          id: "40829",
          name: "Seydisehir",
          state_id: "3717",
        },
        {
          id: "40830",
          name: "Taskent",
          state_id: "3717",
        },
        {
          id: "40831",
          name: "Tuzlukcu",
          state_id: "3717",
        },
        {
          id: "40832",
          name: "Yalihuyuk",
          state_id: "3717",
        },
        {
          id: "40833",
          name: "Yunak",
          state_id: "3717",
        },
      ],
      Kutahya: [
        {
          id: "40834",
          name: "Altinas",
          state_id: "3718",
        },
        {
          id: "40835",
          name: "Aslanapa",
          state_id: "3718",
        },
        {
          id: "40836",
          name: "Domanic",
          state_id: "3718",
        },
        {
          id: "40837",
          name: "Dumlupinar",
          state_id: "3718",
        },
        {
          id: "40838",
          name: "Emet",
          state_id: "3718",
        },
        {
          id: "40839",
          name: "Gediz",
          state_id: "3718",
        },
        {
          id: "40840",
          name: "Kutahya",
          state_id: "3718",
        },
        {
          id: "40841",
          name: "Pazarlar",
          state_id: "3718",
        },
        {
          id: "40842",
          name: "Saphane",
          state_id: "3718",
        },
        {
          id: "40843",
          name: "Simav",
          state_id: "3718",
        },
        {
          id: "40844",
          name: "Tavsanli",
          state_id: "3718",
        },
      ],
      Lefkosa: [
        {
          id: "40845",
          name: "Lefkosa",
          state_id: "3719",
        },
      ],
      Malatya: [
        {
          id: "40846",
          name: "Akcadag",
          state_id: "3720",
        },
        {
          id: "40847",
          name: "Arapkir",
          state_id: "3720",
        },
        {
          id: "40848",
          name: "Arguvan",
          state_id: "3720",
        },
        {
          id: "40849",
          name: "Battalgazi",
          state_id: "3720",
        },
        {
          id: "40850",
          name: "Darende",
          state_id: "3720",
        },
        {
          id: "40851",
          name: "Dogansehir",
          state_id: "3720",
        },
        {
          id: "40852",
          name: "Doganyol",
          state_id: "3720",
        },
        {
          id: "40853",
          name: "Hekimhan",
          state_id: "3720",
        },
        {
          id: "40854",
          name: "Kale",
          state_id: "3720",
        },
        {
          id: "40855",
          name: "Kuluncak",
          state_id: "3720",
        },
        {
          id: "40856",
          name: "Malatya",
          state_id: "3720",
        },
        {
          id: "40857",
          name: "Poturge",
          state_id: "3720",
        },
        {
          id: "40858",
          name: "Yazihan",
          state_id: "3720",
        },
        {
          id: "40859",
          name: "Yesilyurt",
          state_id: "3720",
        },
      ],
      Manisa: [
        {
          id: "40860",
          name: "Ahmetli",
          state_id: "3721",
        },
        {
          id: "40861",
          name: "Akhisar",
          state_id: "3721",
        },
        {
          id: "40862",
          name: "Alasehir",
          state_id: "3721",
        },
        {
          id: "40863",
          name: "Demirci",
          state_id: "3721",
        },
        {
          id: "40864",
          name: "Golmarmara",
          state_id: "3721",
        },
        {
          id: "40865",
          name: "Gordes",
          state_id: "3721",
        },
        {
          id: "40866",
          name: "Kirkagac",
          state_id: "3721",
        },
        {
          id: "40867",
          name: "Koprubasi",
          state_id: "3721",
        },
        {
          id: "40868",
          name: "Kula",
          state_id: "3721",
        },
        {
          id: "40869",
          name: "Manisa",
          state_id: "3721",
        },
        {
          id: "40870",
          name: "Salihli",
          state_id: "3721",
        },
        {
          id: "40871",
          name: "Sarigol",
          state_id: "3721",
        },
        {
          id: "40872",
          name: "Saruhanli",
          state_id: "3721",
        },
        {
          id: "40873",
          name: "Selendi",
          state_id: "3721",
        },
        {
          id: "40874",
          name: "Soma",
          state_id: "3721",
        },
        {
          id: "40875",
          name: "Turgutlu",
          state_id: "3721",
        },
      ],
      Mardin: [
        {
          id: "40876",
          name: "Dargecit",
          state_id: "3722",
        },
        {
          id: "40877",
          name: "Derik",
          state_id: "3722",
        },
        {
          id: "40878",
          name: "Kiziltepe",
          state_id: "3722",
        },
        {
          id: "40879",
          name: "Mardin",
          state_id: "3722",
        },
        {
          id: "40880",
          name: "Mazidagi",
          state_id: "3722",
        },
        {
          id: "40881",
          name: "Midyat",
          state_id: "3722",
        },
        {
          id: "40882",
          name: "Nusaybin",
          state_id: "3722",
        },
        {
          id: "40883",
          name: "Omerli",
          state_id: "3722",
        },
        {
          id: "40884",
          name: "Savur",
          state_id: "3722",
        },
        {
          id: "40885",
          name: "Yesilli",
          state_id: "3722",
        },
      ],
      Mugla: [
        {
          id: "40886",
          name: "Bodrum",
          state_id: "3723",
        },
        {
          id: "40887",
          name: "Dalaman",
          state_id: "3723",
        },
        {
          id: "40888",
          name: "Datca",
          state_id: "3723",
        },
        {
          id: "40889",
          name: "Fethiye",
          state_id: "3723",
        },
        {
          id: "40890",
          name: "Kavaklidere",
          state_id: "3723",
        },
        {
          id: "40891",
          name: "Koycegiz",
          state_id: "3723",
        },
        {
          id: "40892",
          name: "Marmaris",
          state_id: "3723",
        },
        {
          id: "40893",
          name: "Milas",
          state_id: "3723",
        },
        {
          id: "40894",
          name: "Mugla",
          state_id: "3723",
        },
        {
          id: "40895",
          name: "Ortaca",
          state_id: "3723",
        },
        {
          id: "40896",
          name: "Ula",
          state_id: "3723",
        },
        {
          id: "40897",
          name: "Yatagan",
          state_id: "3723",
        },
      ],
      Mus: [
        {
          id: "40898",
          name: "Bulanik",
          state_id: "3724",
        },
        {
          id: "40899",
          name: "Haskoy",
          state_id: "3724",
        },
        {
          id: "40900",
          name: "Korkut",
          state_id: "3724",
        },
        {
          id: "40901",
          name: "Malazgirt",
          state_id: "3724",
        },
        {
          id: "40902",
          name: "Mus",
          state_id: "3724",
        },
        {
          id: "40903",
          name: "Varto",
          state_id: "3724",
        },
      ],
      Nevsehir: [
        {
          id: "40904",
          name: "Acigol",
          state_id: "3725",
        },
        {
          id: "40905",
          name: "Avanos",
          state_id: "3725",
        },
        {
          id: "40906",
          name: "Derinkuyu",
          state_id: "3725",
        },
        {
          id: "40907",
          name: "Gulsehir",
          state_id: "3725",
        },
        {
          id: "40908",
          name: "Hacibektas",
          state_id: "3725",
        },
        {
          id: "40909",
          name: "Kozakli",
          state_id: "3725",
        },
        {
          id: "40910",
          name: "Nevsehir",
          state_id: "3725",
        },
        {
          id: "40911",
          name: "Urgup",
          state_id: "3725",
        },
      ],
      Nigde: [
        {
          id: "40912",
          name: "Altunhisar",
          state_id: "3726",
        },
        {
          id: "40913",
          name: "Bor",
          state_id: "3726",
        },
        {
          id: "40914",
          name: "Nigde",
          state_id: "3726",
        },
        {
          id: "40915",
          name: "Ulukisla",
          state_id: "3726",
        },
      ],
      Ordu: [
        {
          id: "40916",
          name: "Akkus",
          state_id: "3727",
        },
        {
          id: "40917",
          name: "Aybasti",
          state_id: "3727",
        },
        {
          id: "40918",
          name: "Camas",
          state_id: "3727",
        },
        {
          id: "40919",
          name: "Fatsa",
          state_id: "3727",
        },
        {
          id: "40920",
          name: "Golkoy",
          state_id: "3727",
        },
        {
          id: "40921",
          name: "Gulyali",
          state_id: "3727",
        },
        {
          id: "40922",
          name: "Gurgentepe",
          state_id: "3727",
        },
        {
          id: "40923",
          name: "Ikizce",
          state_id: "3727",
        },
        {
          id: "40924",
          name: "Kabaduz",
          state_id: "3727",
        },
        {
          id: "40925",
          name: "Kabatas",
          state_id: "3727",
        },
        {
          id: "40926",
          name: "Korgan",
          state_id: "3727",
        },
        {
          id: "40927",
          name: "Kumru",
          state_id: "3727",
        },
        {
          id: "40928",
          name: "Mesudiye",
          state_id: "3727",
        },
        {
          id: "40929",
          name: "Ordu",
          state_id: "3727",
        },
        {
          id: "40930",
          name: "Persembe",
          state_id: "3727",
        },
        {
          id: "40931",
          name: "Ulubey",
          state_id: "3727",
        },
        {
          id: "40932",
          name: "Unye",
          state_id: "3727",
        },
      ],
      Osmaniye: [
        {
          id: "40933",
          name: "Bahce",
          state_id: "3728",
        },
        {
          id: "40934",
          name: "Duzici",
          state_id: "3728",
        },
        {
          id: "40935",
          name: "Hasanbeyli",
          state_id: "3728",
        },
        {
          id: "40936",
          name: "Kadirli",
          state_id: "3728",
        },
        {
          id: "40937",
          name: "Osmaniye",
          state_id: "3728",
        },
        {
          id: "40938",
          name: "Sumbas",
          state_id: "3728",
        },
        {
          id: "40939",
          name: "Toprakkale",
          state_id: "3728",
        },
      ],
      Rize: [
        {
          id: "40940",
          name: "Ardesen",
          state_id: "3729",
        },
        {
          id: "40941",
          name: "Cayeli",
          state_id: "3729",
        },
        {
          id: "40942",
          name: "Derepazan",
          state_id: "3729",
        },
        {
          id: "40943",
          name: "Findikli",
          state_id: "3729",
        },
        {
          id: "40944",
          name: "Guneysu",
          state_id: "3729",
        },
        {
          id: "40945",
          name: "Hemsin",
          state_id: "3729",
        },
        {
          id: "40946",
          name: "Ikizdere",
          state_id: "3729",
        },
        {
          id: "40947",
          name: "Iyidere",
          state_id: "3729",
        },
        {
          id: "40948",
          name: "Kalkandere",
          state_id: "3729",
        },
        {
          id: "40949",
          name: "Pazar",
          state_id: "3729",
        },
        {
          id: "40950",
          name: "Rize",
          state_id: "3729",
        },
      ],
      Sakarya: [
        {
          id: "40951",
          name: "Adapazari",
          state_id: "3730",
        },
        {
          id: "40952",
          name: "Akyazi",
          state_id: "3730",
        },
        {
          id: "40953",
          name: "Ferizli",
          state_id: "3730",
        },
        {
          id: "40954",
          name: "Geyve",
          state_id: "3730",
        },
        {
          id: "40955",
          name: "Hendek",
          state_id: "3730",
        },
        {
          id: "40956",
          name: "Karapurcek",
          state_id: "3730",
        },
        {
          id: "40957",
          name: "Karasu",
          state_id: "3730",
        },
        {
          id: "40958",
          name: "Kaynarca",
          state_id: "3730",
        },
        {
          id: "40959",
          name: "Kocaali",
          state_id: "3730",
        },
        {
          id: "40960",
          name: "Pamukova",
          state_id: "3730",
        },
        {
          id: "40961",
          name: "Sapanca",
          state_id: "3730",
        },
        {
          id: "40962",
          name: "Sogutlu",
          state_id: "3730",
        },
        {
          id: "40963",
          name: "Tarakli",
          state_id: "3730",
        },
      ],
      Samsun: [
        {
          id: "40964",
          name: "Akcakale",
          state_id: "3731",
        },
        {
          id: "40965",
          name: "Alacam",
          state_id: "3731",
        },
        {
          id: "40966",
          name: "Asarcik",
          state_id: "3731",
        },
        {
          id: "40967",
          name: "Ayvacik",
          state_id: "3731",
        },
        {
          id: "40968",
          name: "Bafra",
          state_id: "3731",
        },
        {
          id: "40969",
          name: "Carsamba",
          state_id: "3731",
        },
        {
          id: "40970",
          name: "Havza",
          state_id: "3731",
        },
        {
          id: "40971",
          name: "Kavak",
          state_id: "3731",
        },
        {
          id: "40972",
          name: "Ladik",
          state_id: "3731",
        },
        {
          id: "40973",
          name: "Mayis 19",
          state_id: "3731",
        },
        {
          id: "40974",
          name: "Salipazan",
          state_id: "3731",
        },
        {
          id: "40975",
          name: "Samsun",
          state_id: "3731",
        },
        {
          id: "40976",
          name: "Tekkekoy",
          state_id: "3731",
        },
        {
          id: "40977",
          name: "Terme",
          state_id: "3731",
        },
        {
          id: "40978",
          name: "Vezirkopru",
          state_id: "3731",
        },
        {
          id: "40979",
          name: "Yakakent",
          state_id: "3731",
        },
      ],
      Sanliurfa: [
        {
          id: "40980",
          name: "Birecik",
          state_id: "3732",
        },
        {
          id: "40981",
          name: "Bozova",
          state_id: "3732",
        },
        {
          id: "40982",
          name: "Ceylanpinar",
          state_id: "3732",
        },
        {
          id: "40983",
          name: "Halfeti",
          state_id: "3732",
        },
        {
          id: "40984",
          name: "Harran",
          state_id: "3732",
        },
        {
          id: "40985",
          name: "Hilvan",
          state_id: "3732",
        },
        {
          id: "40986",
          name: "Sanliurfa",
          state_id: "3732",
        },
        {
          id: "40987",
          name: "Siverek",
          state_id: "3732",
        },
        {
          id: "40988",
          name: "Suruc",
          state_id: "3732",
        },
        {
          id: "40989",
          name: "Urfa",
          state_id: "3732",
        },
        {
          id: "40990",
          name: "Viransehir",
          state_id: "3732",
        },
      ],
      Siirt: [
        {
          id: "40991",
          name: "Aydinlar",
          state_id: "3733",
        },
        {
          id: "40992",
          name: "Baykan",
          state_id: "3733",
        },
        {
          id: "40993",
          name: "Eruh",
          state_id: "3733",
        },
        {
          id: "40994",
          name: "Kurtalan",
          state_id: "3733",
        },
        {
          id: "40995",
          name: "Pervari",
          state_id: "3733",
        },
        {
          id: "40996",
          name: "Siirt",
          state_id: "3733",
        },
        {
          id: "40997",
          name: "Sirvan",
          state_id: "3733",
        },
      ],
      Sinop: [
        {
          id: "40998",
          name: "Ayancik",
          state_id: "3734",
        },
        {
          id: "40999",
          name: "Boyabat",
          state_id: "3734",
        },
        {
          id: "41000",
          name: "Dikmen",
          state_id: "3734",
        },
        {
          id: "41001",
          name: "Duragan",
          state_id: "3734",
        },
        {
          id: "41002",
          name: "Erfelek",
          state_id: "3734",
        },
        {
          id: "41003",
          name: "Gerze",
          state_id: "3734",
        },
        {
          id: "41004",
          name: "Sarayduzu",
          state_id: "3734",
        },
        {
          id: "41005",
          name: "Sinop",
          state_id: "3734",
        },
        {
          id: "41006",
          name: "Turkeli",
          state_id: "3734",
        },
      ],
      Sirnak: [
        {
          id: "41007",
          name: "Beytussebap",
          state_id: "3735",
        },
        {
          id: "41008",
          name: "Cizre",
          state_id: "3735",
        },
        {
          id: "41009",
          name: "Guclukonak",
          state_id: "3735",
        },
        {
          id: "41010",
          name: "Idil",
          state_id: "3735",
        },
        {
          id: "41011",
          name: "Silopi",
          state_id: "3735",
        },
        {
          id: "41012",
          name: "Sirnak",
          state_id: "3735",
        },
        {
          id: "41013",
          name: "Uludere",
          state_id: "3735",
        },
      ],
      Sivas: [
        {
          id: "41014",
          name: "Akincilar",
          state_id: "3736",
        },
        {
          id: "41015",
          name: "Altinyayla",
          state_id: "3736",
        },
        {
          id: "41016",
          name: "Divrigi",
          state_id: "3736",
        },
        {
          id: "41017",
          name: "Dogansar",
          state_id: "3736",
        },
        {
          id: "41018",
          name: "Gemerek",
          state_id: "3736",
        },
        {
          id: "41019",
          name: "Golova",
          state_id: "3736",
        },
        {
          id: "41020",
          name: "Gurun",
          state_id: "3736",
        },
        {
          id: "41021",
          name: "Hafik",
          state_id: "3736",
        },
        {
          id: "41022",
          name: "Imranli",
          state_id: "3736",
        },
        {
          id: "41023",
          name: "Kangal",
          state_id: "3736",
        },
        {
          id: "41024",
          name: "Koyulhisar",
          state_id: "3736",
        },
        {
          id: "41025",
          name: "Sarkisla",
          state_id: "3736",
        },
        {
          id: "41026",
          name: "Sivas",
          state_id: "3736",
        },
        {
          id: "41027",
          name: "Susehri",
          state_id: "3736",
        },
        {
          id: "41028",
          name: "Ulas",
          state_id: "3736",
        },
        {
          id: "41029",
          name: "Yildizeli",
          state_id: "3736",
        },
        {
          id: "41030",
          name: "Zara",
          state_id: "3736",
        },
      ],
      Tekirdag: [
        {
          id: "41031",
          name: "Cerkezkoy",
          state_id: "3737",
        },
        {
          id: "41032",
          name: "Corlu",
          state_id: "3737",
        },
        {
          id: "41033",
          name: "Hayrabolu",
          state_id: "3737",
        },
        {
          id: "41034",
          name: "Malkara",
          state_id: "3737",
        },
        {
          id: "41035",
          name: "Marmaraereglisi",
          state_id: "3737",
        },
        {
          id: "41036",
          name: "Muratli",
          state_id: "3737",
        },
        {
          id: "41037",
          name: "Saray",
          state_id: "3737",
        },
        {
          id: "41038",
          name: "Sarkoy",
          state_id: "3737",
        },
        {
          id: "41039",
          name: "Tekirdag",
          state_id: "3737",
        },
      ],
      Tokat: [
        {
          id: "41040",
          name: "Almus",
          state_id: "3738",
        },
        {
          id: "41041",
          name: "Artova",
          state_id: "3738",
        },
        {
          id: "41042",
          name: "Basciftlik",
          state_id: "3738",
        },
        {
          id: "41043",
          name: "Erbaa",
          state_id: "3738",
        },
        {
          id: "41044",
          name: "Niksar",
          state_id: "3738",
        },
        {
          id: "41045",
          name: "Pazar",
          state_id: "3738",
        },
        {
          id: "41046",
          name: "Resadiye",
          state_id: "3738",
        },
        {
          id: "41047",
          name: "Sulusaray",
          state_id: "3738",
        },
        {
          id: "41048",
          name: "Tokat",
          state_id: "3738",
        },
        {
          id: "41049",
          name: "Turhal",
          state_id: "3738",
        },
        {
          id: "41050",
          name: "Yesilyurt",
          state_id: "3738",
        },
        {
          id: "41051",
          name: "Zile",
          state_id: "3738",
        },
      ],
      Trabzon: [
        {
          id: "41052",
          name: "Akcaabat",
          state_id: "3739",
        },
        {
          id: "41053",
          name: "Arakli",
          state_id: "3739",
        },
        {
          id: "41054",
          name: "Arsin",
          state_id: "3739",
        },
        {
          id: "41055",
          name: "Besikduzu",
          state_id: "3739",
        },
        {
          id: "41056",
          name: "Caykara",
          state_id: "3739",
        },
        {
          id: "41057",
          name: "Dernekpazari",
          state_id: "3739",
        },
        {
          id: "41058",
          name: "Duzkoy",
          state_id: "3739",
        },
        {
          id: "41059",
          name: "Hayrat",
          state_id: "3739",
        },
        {
          id: "41060",
          name: "Koprubasi",
          state_id: "3739",
        },
        {
          id: "41061",
          name: "Macka",
          state_id: "3739",
        },
        {
          id: "41062",
          name: "Of",
          state_id: "3739",
        },
        {
          id: "41063",
          name: "Salpazari",
          state_id: "3739",
        },
        {
          id: "41064",
          name: "Surmene",
          state_id: "3739",
        },
        {
          id: "41065",
          name: "Tonya",
          state_id: "3739",
        },
        {
          id: "41066",
          name: "Trabzon",
          state_id: "3739",
        },
        {
          id: "41067",
          name: "Vakfikebir",
          state_id: "3739",
        },
        {
          id: "41068",
          name: "Yomra",
          state_id: "3739",
        },
      ],
      Tunceli: [
        {
          id: "41069",
          name: "Hozat",
          state_id: "3740",
        },
        {
          id: "41070",
          name: "Mazgirt",
          state_id: "3740",
        },
        {
          id: "41071",
          name: "Nazimiye",
          state_id: "3740",
        },
        {
          id: "41072",
          name: "Ovacik",
          state_id: "3740",
        },
        {
          id: "41073",
          name: "Pertek",
          state_id: "3740",
        },
        {
          id: "41074",
          name: "Pulumur",
          state_id: "3740",
        },
        {
          id: "41075",
          name: "Tunceli",
          state_id: "3740",
        },
      ],
      Usak: [
        {
          id: "41076",
          name: "Banaz",
          state_id: "3741",
        },
        {
          id: "41077",
          name: "Esme",
          state_id: "3741",
        },
        {
          id: "41078",
          name: "Karahalli",
          state_id: "3741",
        },
        {
          id: "41079",
          name: "Sivasli",
          state_id: "3741",
        },
        {
          id: "41080",
          name: "Ulubey",
          state_id: "3741",
        },
        {
          id: "41081",
          name: "Usak",
          state_id: "3741",
        },
      ],
      Van: [
        {
          id: "41082",
          name: "Bahcesaray",
          state_id: "3742",
        },
        {
          id: "41083",
          name: "Baskale",
          state_id: "3742",
        },
        {
          id: "41084",
          name: "Caldiran",
          state_id: "3742",
        },
        {
          id: "41085",
          name: "Edremit",
          state_id: "3742",
        },
        {
          id: "41086",
          name: "Ercis",
          state_id: "3742",
        },
        {
          id: "41087",
          name: "Gevas",
          state_id: "3742",
        },
        {
          id: "41088",
          name: "Gurpinar",
          state_id: "3742",
        },
        {
          id: "41089",
          name: "Muradiye",
          state_id: "3742",
        },
        {
          id: "41090",
          name: "Ozalp",
          state_id: "3742",
        },
        {
          id: "41091",
          name: "Saray",
          state_id: "3742",
        },
        {
          id: "41092",
          name: "Van",
          state_id: "3742",
        },
      ],
      Yalova: [
        {
          id: "41093",
          name: "Altinova",
          state_id: "3743",
        },
        {
          id: "41094",
          name: "Armutlu",
          state_id: "3743",
        },
        {
          id: "41095",
          name: "Ciftlikkoy",
          state_id: "3743",
        },
        {
          id: "41096",
          name: "Cinarcik",
          state_id: "3743",
        },
        {
          id: "41097",
          name: "Termal",
          state_id: "3743",
        },
        {
          id: "41098",
          name: "Yalova",
          state_id: "3743",
        },
      ],
      Yozgat: [
        {
          id: "41099",
          name: "Akdagmadeni",
          state_id: "3744",
        },
        {
          id: "41100",
          name: "Aydincik",
          state_id: "3744",
        },
        {
          id: "41101",
          name: "Bogaziliyan",
          state_id: "3744",
        },
        {
          id: "41102",
          name: "Candir",
          state_id: "3744",
        },
        {
          id: "41103",
          name: "Cayiralan",
          state_id: "3744",
        },
        {
          id: "41104",
          name: "Cekerek",
          state_id: "3744",
        },
        {
          id: "41105",
          name: "Kadisehri",
          state_id: "3744",
        },
        {
          id: "41106",
          name: "Saraykent",
          state_id: "3744",
        },
        {
          id: "41107",
          name: "Sarikaya",
          state_id: "3744",
        },
        {
          id: "41108",
          name: "Sefaatli",
          state_id: "3744",
        },
        {
          id: "41109",
          name: "Sorgun",
          state_id: "3744",
        },
        {
          id: "41110",
          name: "Yenifakili",
          state_id: "3744",
        },
        {
          id: "41111",
          name: "Yerkoy",
          state_id: "3744",
        },
        {
          id: "41112",
          name: "Yozgat",
          state_id: "3744",
        },
      ],
      Zonguldak: [
        {
          id: "41113",
          name: "Alapli",
          state_id: "3745",
        },
        {
          id: "41114",
          name: "Caycuma",
          state_id: "3745",
        },
        {
          id: "41115",
          name: "Devrek",
          state_id: "3745",
        },
        {
          id: "41116",
          name: "Eregli",
          state_id: "3745",
        },
        {
          id: "41117",
          name: "Gokcebey",
          state_id: "3745",
        },
        {
          id: "41118",
          name: "Zonguldak",
          state_id: "3745",
        },
      ],
    },
  },
  TT: {
    name: "Trinidad and Tobago",
    native: "Trinidad and Tobago",
    phone: "1868",
    continent: "NA",
    capital: "Port of Spain",
    currency: "TTD",
    languages: ["en"],
    emoji: "🇹🇹",
    emojiU: "U+1F1F9 U+1F1F9",
    states: {
      "Arima-Tunapuna-Piarco": [
        {
          id: "39997",
          name: "Arima",
          state_id: "3617",
        },
        {
          id: "39998",
          name: "Arouca",
          state_id: "3617",
        },
        {
          id: "39999",
          name: "Tacarigua",
          state_id: "3617",
        },
        {
          id: "40000",
          name: "Tunapuna",
          state_id: "3617",
        },
      ],
      Caroni: [
        {
          id: "40001",
          name: "Carapichaima",
          state_id: "3618",
        },
        {
          id: "40002",
          name: "Claxton Bay",
          state_id: "3618",
        },
      ],
      Chaguanas: [
        {
          id: "40003",
          name: "Chaguanas",
          state_id: "3619",
        },
      ],
      "Couva-Tabaquite-Talparo": [
        {
          id: "40004",
          name: "Couva",
          state_id: "3620",
        },
        {
          id: "40005",
          name: "Tabaquite",
          state_id: "3620",
        },
      ],
      "Diego Martin": [],
      Glencoe: [
        {
          id: "40006",
          name: "Glencoe",
          state_id: "3622",
        },
      ],
      "Penal Debe": [],
      "Point Fortin": [],
      "Port of Spain": [],
      "Princes Town": [],
      "Saint George": [],
      "San Fernando": [],
      "San Juan": [],
      "Sangre Grande": [],
      Siparia: [
        {
          id: "40007",
          name: "Siparia",
          state_id: "3631",
        },
      ],
      Tobago: [
        {
          id: "40008",
          name: "Scarborough",
          state_id: "3632",
        },
      ],
    },
  },
  TV: {
    name: "Tuvalu",
    native: "Tuvalu",
    phone: "688",
    continent: "OC",
    capital: "Funafuti",
    currency: "AUD",
    languages: ["en"],
    emoji: "🇹🇻",
    emojiU: "U+1F1F9 U+1F1FB",
    states: {
      Funafuti: [
        {
          id: "41173",
          name: "Vaiaku",
          state_id: "3754",
        },
      ],
      Nanumanga: [
        {
          id: "41174",
          name: "Tonga",
          state_id: "3755",
        },
      ],
      Nanumea: [
        {
          id: "41175",
          name: "Lolua",
          state_id: "3756",
        },
      ],
      Niutao: [
        {
          id: "41176",
          name: "Kua",
          state_id: "3757",
        },
      ],
      Nui: [
        {
          id: "41177",
          name: "Tanrake",
          state_id: "3758",
        },
      ],
      Nukufetau: [
        {
          id: "41178",
          name: "Savave",
          state_id: "3759",
        },
      ],
      Nukulaelae: [
        {
          id: "41179",
          name: "Fangaua",
          state_id: "3760",
        },
      ],
      Vaitupu: [
        {
          id: "41180",
          name: "Asau",
          state_id: "3761",
        },
      ],
    },
  },
  TW: {
    name: "Taiwan",
    native: "臺灣",
    phone: "886",
    continent: "AS",
    capital: "Taipei",
    currency: "TWD",
    languages: ["zh"],
    emoji: "🇹🇼",
    emojiU: "U+1F1F9 U+1F1FC",
    states: {
      Changhwa: [
        {
          id: "39651",
          name: "Changhua City",
          state_id: "3471",
        },
        {
          id: "39652",
          name: "Changhwa",
          state_id: "3471",
        },
        {
          id: "39653",
          name: "Chihu",
          state_id: "3471",
        },
        {
          id: "39654",
          name: "Erhlin",
          state_id: "3471",
        },
        {
          id: "39655",
          name: "Hemei",
          state_id: "3471",
        },
        {
          id: "39656",
          name: "Homei",
          state_id: "3471",
        },
        {
          id: "39657",
          name: "Hua Tan Hsiang",
          state_id: "3471",
        },
        {
          id: "39658",
          name: "Huatan Township",
          state_id: "3471",
        },
        {
          id: "39659",
          name: "Lukang",
          state_id: "3471",
        },
        {
          id: "39660",
          name: "Peitou",
          state_id: "3471",
        },
        {
          id: "39661",
          name: "Puyen Hsiang",
          state_id: "3471",
        },
        {
          id: "39662",
          name: "Tienchung",
          state_id: "3471",
        },
        {
          id: "39663",
          name: "Yuanlin",
          state_id: "3471",
        },
      ],
      "Chiayi Hsien": [],
      "Chiayi Shih": [],
      "Eastern Taipei": [],
      "Hsinchu Hsien": [],
      "Hsinchu Shih": [],
      Hualien: [
        {
          id: "39664",
          name: "Fenglin",
          state_id: "3477",
        },
        {
          id: "39665",
          name: "Hualian",
          state_id: "3477",
        },
        {
          id: "39666",
          name: "Yuli",
          state_id: "3477",
        },
      ],
      Ilan: [
        {
          id: "39667",
          name: "Ilan",
          state_id: "3478",
        },
        {
          id: "39668",
          name: "Lotung",
          state_id: "3478",
        },
        {
          id: "39669",
          name: "Suao",
          state_id: "3478",
        },
        {
          id: "39670",
          name: "Toucheng",
          state_id: "3478",
        },
      ],
      "Kaohsiung Hsien": [],
      "Kaohsiung Shih": [],
      "Keelung Shih": [],
      Kinmen: [
        {
          id: "39671",
          name: "Kincheng",
          state_id: "3482",
        },
        {
          id: "39672",
          name: "Kinhsia",
          state_id: "3482",
        },
        {
          id: "39673",
          name: "Kinhu",
          state_id: "3482",
        },
      ],
      Miaoli: [
        {
          id: "39674",
          name: "Cholan",
          state_id: "3483",
        },
        {
          id: "39675",
          name: "Chunan",
          state_id: "3483",
        },
        {
          id: "39676",
          name: "Houlung",
          state_id: "3483",
        },
        {
          id: "39677",
          name: "Miaoli",
          state_id: "3483",
        },
        {
          id: "39678",
          name: "Toufen",
          state_id: "3483",
        },
        {
          id: "39679",
          name: "Tunghsiao",
          state_id: "3483",
        },
        {
          id: "39680",
          name: "Yuanli",
          state_id: "3483",
        },
        {
          id: "39681",
          name: "Zaociao",
          state_id: "3483",
        },
      ],
      Nantou: [
        {
          id: "39682",
          name: "Chichi",
          state_id: "3484",
        },
        {
          id: "39683",
          name: "Chushan",
          state_id: "3484",
        },
        {
          id: "39684",
          name: "Nantou",
          state_id: "3484",
        },
        {
          id: "39685",
          name: "Puli",
          state_id: "3484",
        },
        {
          id: "39686",
          name: "Tsaotun",
          state_id: "3484",
        },
      ],
      "Northern Taiwan": [],
      Penghu: [
        {
          id: "39687",
          name: "Makung",
          state_id: "3486",
        },
      ],
      Pingtung: [
        {
          id: "39688",
          name: "Chaochou",
          state_id: "3487",
        },
        {
          id: "39689",
          name: "Hengchun",
          state_id: "3487",
        },
        {
          id: "39690",
          name: "Pingtung",
          state_id: "3487",
        },
        {
          id: "39691",
          name: "Tungkang",
          state_id: "3487",
        },
      ],
      Taichung: [
        {
          id: "39692",
          name: "Dali",
          state_id: "3488",
        },
        {
          id: "39693",
          name: "South District",
          state_id: "3488",
        },
        {
          id: "39694",
          name: "Ta-Ya Shang",
          state_id: "3488",
        },
      ],
      "Taichung Hsien": [
        {
          id: "39695",
          name: "Dali",
          state_id: "3489",
        },
        {
          id: "39696",
          name: "South District",
          state_id: "3489",
        },
        {
          id: "39697",
          name: "Ta-Ya Shang",
          state_id: "3489",
        },
      ],
      "Taichung Shih": [
        {
          id: "39698",
          name: "Dali",
          state_id: "3490",
        },
        {
          id: "39699",
          name: "South District",
          state_id: "3490",
        },
        {
          id: "39700",
          name: "Ta-Ya Shang",
          state_id: "3490",
        },
      ],
      "Tainan Hsien": [],
      "Tainan Shih": [],
      "Taipei Hsien": [],
      "Taipei Shih / Taipei Hsien": [],
      Taitung: [
        {
          id: "39701",
          name: "Kuanshan",
          state_id: "3495",
        },
        {
          id: "39702",
          name: "Taitung",
          state_id: "3495",
        },
      ],
      Taoyuan: [
        {
          id: "39703",
          name: "Chengkung",
          state_id: "3496",
        },
        {
          id: "39704",
          name: "Chungli",
          state_id: "3496",
        },
        {
          id: "39705",
          name: "Kuan Yin",
          state_id: "3496",
        },
        {
          id: "39706",
          name: "Pate",
          state_id: "3496",
        },
        {
          id: "39707",
          name: "Pingchen",
          state_id: "3496",
        },
        {
          id: "39708",
          name: "Ta Yuan",
          state_id: "3496",
        },
        {
          id: "39709",
          name: "Tachi",
          state_id: "3496",
        },
        {
          id: "39710",
          name: "Taoyuan",
          state_id: "3496",
        },
        {
          id: "39711",
          name: "Tungshih",
          state_id: "3496",
        },
        {
          id: "39712",
          name: "Yangmei",
          state_id: "3496",
        },
      ],
      Yilan: [
        {
          id: "39713",
          name: "Wujie",
          state_id: "3497",
        },
      ],
      "Yun-Lin Hsien": [],
      Yunlin: [
        {
          id: "39714",
          name: "Hsilo",
          state_id: "3499",
        },
        {
          id: "39715",
          name: "Huwei",
          state_id: "3499",
        },
        {
          id: "39716",
          name: "Peikang",
          state_id: "3499",
        },
        {
          id: "39717",
          name: "Touliu",
          state_id: "3499",
        },
        {
          id: "39718",
          name: "Tounan",
          state_id: "3499",
        },
        {
          id: "39719",
          name: "Tuku",
          state_id: "3499",
        },
      ],
    },
  },
  TZ: {
    name: "Tanzania",
    native: "Tanzania",
    phone: "255",
    continent: "AF",
    capital: "Dodoma",
    currency: "TZS",
    languages: ["sw", "en"],
    emoji: "🇹🇿",
    emojiU: "U+1F1F9 U+1F1FF",
    states: {
      Arusha: [
        {
          id: "39768",
          name: "Arusha",
          state_id: "3505",
        },
      ],
      "Dar es Salaam": [],
      Dodoma: [
        {
          id: "39769",
          name: "Dodoma",
          state_id: "3507",
        },
        {
          id: "39770",
          name: "Kondoa",
          state_id: "3507",
        },
        {
          id: "39771",
          name: "Mpwapwa",
          state_id: "3507",
        },
      ],
      Iringa: [
        {
          id: "39772",
          name: "Iringa",
          state_id: "3508",
        },
        {
          id: "39773",
          name: "Njombe",
          state_id: "3508",
        },
      ],
      Kagera: [
        {
          id: "39774",
          name: "Bukoba",
          state_id: "3509",
        },
        {
          id: "39775",
          name: "Bwanga",
          state_id: "3509",
        },
        {
          id: "39776",
          name: "Ngara",
          state_id: "3509",
        },
      ],
      Kigoma: [
        {
          id: "39777",
          name: "Kasulu",
          state_id: "3510",
        },
        {
          id: "39778",
          name: "Kigoma",
          state_id: "3510",
        },
        {
          id: "39779",
          name: "Uvinza",
          state_id: "3510",
        },
      ],
      Kilimanjaro: [
        {
          id: "39780",
          name: "Moshi",
          state_id: "3511",
        },
        {
          id: "39781",
          name: "Same",
          state_id: "3511",
        },
      ],
      Lindi: [
        {
          id: "39782",
          name: "Kilwa Kivinje",
          state_id: "3512",
        },
        {
          id: "39783",
          name: "Lindi",
          state_id: "3512",
        },
        {
          id: "39784",
          name: "Nachingwea",
          state_id: "3512",
        },
      ],
      Mara: [
        {
          id: "39785",
          name: "Musoma",
          state_id: "3513",
        },
        {
          id: "39786",
          name: "Tarime",
          state_id: "3513",
        },
      ],
      Mbeya: [
        {
          id: "39787",
          name: "Mbeya",
          state_id: "3514",
        },
        {
          id: "39788",
          name: "Mwaya",
          state_id: "3514",
        },
        {
          id: "39789",
          name: "Tukuyu",
          state_id: "3514",
        },
      ],
      Morogoro: [
        {
          id: "39790",
          name: "Kilosa",
          state_id: "3515",
        },
        {
          id: "39791",
          name: "Mahenge",
          state_id: "3515",
        },
        {
          id: "39792",
          name: "Morogoro",
          state_id: "3515",
        },
      ],
      Mtwara: [
        {
          id: "39793",
          name: "Masasi",
          state_id: "3516",
        },
        {
          id: "39794",
          name: "Mikindani",
          state_id: "3516",
        },
        {
          id: "39795",
          name: "Mtwara",
          state_id: "3516",
        },
        {
          id: "39796",
          name: "Newala",
          state_id: "3516",
        },
      ],
      Mwanza: [
        {
          id: "39797",
          name: "Magu",
          state_id: "3517",
        },
        {
          id: "39798",
          name: "Mwanza",
          state_id: "3517",
        },
        {
          id: "39799",
          name: "Nansio",
          state_id: "3517",
        },
        {
          id: "39800",
          name: "Sengerama",
          state_id: "3517",
        },
      ],
      Pwani: [
        {
          id: "39801",
          name: "Bagamoyo",
          state_id: "3518",
        },
        {
          id: "39802",
          name: "Kibaha",
          state_id: "3518",
        },
        {
          id: "39803",
          name: "Rufiji",
          state_id: "3518",
        },
        {
          id: "39804",
          name: "Utete",
          state_id: "3518",
        },
      ],
      Rukwa: [
        {
          id: "39805",
          name: "Mpanda",
          state_id: "3519",
        },
        {
          id: "39806",
          name: "Sumbawanga",
          state_id: "3519",
        },
      ],
      Ruvuma: [
        {
          id: "39807",
          name: "Songea",
          state_id: "3520",
        },
        {
          id: "39808",
          name: "Tunduru",
          state_id: "3520",
        },
      ],
      Shinyanga: [
        {
          id: "39809",
          name: "Kahama",
          state_id: "3521",
        },
        {
          id: "39810",
          name: "Maswa",
          state_id: "3521",
        },
        {
          id: "39811",
          name: "Mwadui",
          state_id: "3521",
        },
        {
          id: "39812",
          name: "Old Shinyanga",
          state_id: "3521",
        },
        {
          id: "39813",
          name: "Shinyanga",
          state_id: "3521",
        },
      ],
      Singida: [
        {
          id: "39814",
          name: "Manyoni",
          state_id: "3522",
        },
        {
          id: "39815",
          name: "Singida",
          state_id: "3522",
        },
      ],
      Tabora: [
        {
          id: "39816",
          name: "Bukene",
          state_id: "3523",
        },
        {
          id: "39817",
          name: "Nzega",
          state_id: "3523",
        },
        {
          id: "39818",
          name: "Tabora",
          state_id: "3523",
        },
        {
          id: "39819",
          name: "Urambo",
          state_id: "3523",
        },
      ],
      Tanga: [
        {
          id: "39820",
          name: "Korogwe",
          state_id: "3524",
        },
        {
          id: "39821",
          name: "Muheza",
          state_id: "3524",
        },
        {
          id: "39822",
          name: "Pangani",
          state_id: "3524",
        },
        {
          id: "39823",
          name: "Tanga",
          state_id: "3524",
        },
      ],
      "Zanzibar and Pemba": [],
    },
  },
  UA: {
    name: "Ukraine",
    native: "Україна",
    phone: "380",
    continent: "EU",
    capital: "Kyiv",
    currency: "UAH",
    languages: ["uk"],
    emoji: "🇺🇦",
    emojiU: "U+1F1FA U+1F1E6",
    states: {
      "Cherkas''ka": [
        {
          id: "41271",
          name: "Cherkasy",
          state_id: "3766",
        },
        {
          id: "41272",
          name: "Smila",
          state_id: "3766",
        },
        {
          id: "41273",
          name: "Uman",
          state_id: "3766",
        },
      ],
      "Chernihivs''ka": [
        {
          id: "41274",
          name: "Chernihiv",
          state_id: "3767",
        },
        {
          id: "41275",
          name: "Nizhyn",
          state_id: "3767",
        },
        {
          id: "41276",
          name: "Pryluky",
          state_id: "3767",
        },
      ],
      "Chernivets''ka": [
        {
          id: "41277",
          name: "Chernivtsi",
          state_id: "3768",
        },
      ],
      Crimea: [
        {
          id: "41278",
          name: "Alushta",
          state_id: "3769",
        },
        {
          id: "41279",
          name: "Sevastopol",
          state_id: "3769",
        },
      ],
      Dnipropetrovska: [
        {
          id: "41280",
          name: "Dneprodzerzhinsk",
          state_id: "3770",
        },
        {
          id: "41281",
          name: "Dnipropetrovsk",
          state_id: "3770",
        },
        {
          id: "41282",
          name: "Kryvyy Rih",
          state_id: "3770",
        },
        {
          id: "41283",
          name: "Marhanets",
          state_id: "3770",
        },
        {
          id: "41284",
          name: "Nikopol",
          state_id: "3770",
        },
        {
          id: "41285",
          name: "Novomoskovs''k",
          state_id: "3770",
        },
        {
          id: "41286",
          name: "Pavlohrad",
          state_id: "3770",
        },
        {
          id: "41287",
          name: "Plekhanov",
          state_id: "3770",
        },
        {
          id: "41288",
          name: "Zhovti Vody",
          state_id: "3770",
        },
      ],
      "Donets''ka": [
        {
          id: "41289",
          name: "Artemivs''k",
          state_id: "3771",
        },
        {
          id: "41290",
          name: "Donets''k",
          state_id: "3771",
        },
        {
          id: "41291",
          name: "Donetsk",
          state_id: "3771",
        },
        {
          id: "41292",
          name: "Druzhkivka",
          state_id: "3771",
        },
        {
          id: "41293",
          name: "Dymytrov",
          state_id: "3771",
        },
        {
          id: "41294",
          name: "Dzerzhyns''k",
          state_id: "3771",
        },
        {
          id: "41295",
          name: "Horlivka",
          state_id: "3771",
        },
        {
          id: "41296",
          name: "Khartsyz''k",
          state_id: "3771",
        },
        {
          id: "41297",
          name: "Kostyantynivka",
          state_id: "3771",
        },
        {
          id: "41298",
          name: "Kramators''k",
          state_id: "3771",
        },
        {
          id: "41299",
          name: "Krasnoarmiys''k",
          state_id: "3771",
        },
        {
          id: "41300",
          name: "Makiyivka",
          state_id: "3771",
        },
        {
          id: "41301",
          name: "Mariupol",
          state_id: "3771",
        },
        {
          id: "41302",
          name: "Shakhtars''k",
          state_id: "3771",
        },
        {
          id: "41303",
          name: "Slov''yans''k",
          state_id: "3771",
        },
        {
          id: "41304",
          name: "Snizhne",
          state_id: "3771",
        },
        {
          id: "41305",
          name: "Torez",
          state_id: "3771",
        },
        {
          id: "41306",
          name: "Yenakiyeve",
          state_id: "3771",
        },
      ],
      "Ivano-Frankivs''ka": [
        {
          id: "41307",
          name: "Ivano-Frankivs''k",
          state_id: "3772",
        },
        {
          id: "41308",
          name: "Kalush",
          state_id: "3772",
        },
        {
          id: "41309",
          name: "Kolomyya",
          state_id: "3772",
        },
      ],
      Kharkiv: [
        {
          id: "41310",
          name: "Izyum",
          state_id: "3773",
        },
        {
          id: "41311",
          name: "Kharkiv",
          state_id: "3773",
        },
        {
          id: "41312",
          name: "Lozova",
          state_id: "3773",
        },
      ],
      Kharkov: [
        {
          id: "41313",
          name: "Volchansk",
          state_id: "3774",
        },
      ],
      Khersonska: [
        {
          id: "41314",
          name: "Kherson",
          state_id: "3775",
        },
        {
          id: "41315",
          name: "Nova Kakhovka",
          state_id: "3775",
        },
      ],
      "Khmel''nyts''ka": [
        {
          id: "41316",
          name: "Geologov",
          state_id: "3776",
        },
        {
          id: "41317",
          name: "Kam''yanets''-Podil''s''kyy",
          state_id: "3776",
        },
        {
          id: "41318",
          name: "Khmel''nyts''kyy",
          state_id: "3776",
        },
        {
          id: "41319",
          name: "Shepetivka",
          state_id: "3776",
        },
        {
          id: "41320",
          name: "khmelnitskiy",
          state_id: "3776",
        },
      ],
      Kirovohrad: [
        {
          id: "41321",
          name: "Kirovohrad",
          state_id: "3777",
        },
        {
          id: "41322",
          name: "Oleksandriya",
          state_id: "3777",
        },
        {
          id: "41323",
          name: "Svidlovodsk",
          state_id: "3777",
        },
      ],
      Krym: [
        {
          id: "41324",
          name: "Dzhankoy",
          state_id: "3778",
        },
        {
          id: "41325",
          name: "Feodosiya",
          state_id: "3778",
        },
        {
          id: "41326",
          name: "Kerch",
          state_id: "3778",
        },
        {
          id: "41327",
          name: "Simferopol",
          state_id: "3778",
        },
        {
          id: "41328",
          name: "Yalta",
          state_id: "3778",
        },
        {
          id: "41329",
          name: "Yevpatoriya",
          state_id: "3778",
        },
      ],
      Kyyiv: [
        {
          id: "41330",
          name: "Kiev",
          state_id: "3779",
        },
        {
          id: "41331",
          name: "Kyyiv",
          state_id: "3779",
        },
      ],
      "Kyyivs''ka": [
        {
          id: "41332",
          name: "Bila Tserkva",
          state_id: "3780",
        },
        {
          id: "41333",
          name: "Boryspil",
          state_id: "3780",
        },
        {
          id: "41334",
          name: "Brovary",
          state_id: "3780",
        },
        {
          id: "41335",
          name: "Fastiv",
          state_id: "3780",
        },
      ],
      "L''vivs''ka": [
        {
          id: "41336",
          name: "Chervonohrad",
          state_id: "3781",
        },
        {
          id: "41337",
          name: "Drohobych",
          state_id: "3781",
        },
        {
          id: "41338",
          name: "L''viv",
          state_id: "3781",
        },
        {
          id: "41339",
          name: "Stryy",
          state_id: "3781",
        },
        {
          id: "41340",
          name: "Yavoriv",
          state_id: "3781",
        },
      ],
      "Luhans''ka": [
        {
          id: "41341",
          name: "Alchevs''k",
          state_id: "3782",
        },
        {
          id: "41342",
          name: "Antratsyt",
          state_id: "3782",
        },
        {
          id: "41343",
          name: "Bryanka",
          state_id: "3782",
        },
        {
          id: "41344",
          name: "Krasnodon",
          state_id: "3782",
        },
        {
          id: "41345",
          name: "Krasnyy Luch",
          state_id: "3782",
        },
        {
          id: "41346",
          name: "Luhans''k",
          state_id: "3782",
        },
        {
          id: "41347",
          name: "Luhansk",
          state_id: "3782",
        },
        {
          id: "41348",
          name: "Lysychans''k",
          state_id: "3782",
        },
        {
          id: "41349",
          name: "Pervomays''k",
          state_id: "3782",
        },
        {
          id: "41350",
          name: "Roven''ky",
          state_id: "3782",
        },
        {
          id: "41351",
          name: "Rubizhne",
          state_id: "3782",
        },
        {
          id: "41352",
          name: "Stakhanov",
          state_id: "3782",
        },
        {
          id: "41353",
          name: "Sverdlovs''k",
          state_id: "3782",
        },
        {
          id: "41354",
          name: "Syeverodonets''k",
          state_id: "3782",
        },
      ],
      "Mykolayivs''ka": [
        {
          id: "41355",
          name: "Mykolayiv",
          state_id: "3783",
        },
        {
          id: "41356",
          name: "Pervomays''k",
          state_id: "3783",
        },
      ],
      "Odes''ka": [
        {
          id: "41357",
          name: "Bilhorod-Dnistrovs''kyy",
          state_id: "3784",
        },
        {
          id: "41358",
          name: "Illichivs''k",
          state_id: "3784",
        },
        {
          id: "41359",
          name: "Izmayil",
          state_id: "3784",
        },
        {
          id: "41360",
          name: "Odesa",
          state_id: "3784",
        },
      ],
      Odessa: [
        {
          id: "41361",
          name: "Odessa",
          state_id: "3785",
        },
      ],
      "Poltavs''ka": [
        {
          id: "41362",
          name: "Komsomol''s''k",
          state_id: "3786",
        },
        {
          id: "41363",
          name: "Kremenchuh",
          state_id: "3786",
        },
        {
          id: "41364",
          name: "Lubny",
          state_id: "3786",
        },
        {
          id: "41365",
          name: "Poltava",
          state_id: "3786",
        },
      ],
      "Rivnens''ka": [
        {
          id: "41366",
          name: "Rivne",
          state_id: "3787",
        },
      ],
      Sevastopol: [],
      "Sums''ka": [
        {
          id: "41367",
          name: "Konotop",
          state_id: "3789",
        },
        {
          id: "41368",
          name: "Okhtyrka",
          state_id: "3789",
        },
        {
          id: "41369",
          name: "Romny",
          state_id: "3789",
        },
        {
          id: "41370",
          name: "Shostka",
          state_id: "3789",
        },
        {
          id: "41371",
          name: "Sumy",
          state_id: "3789",
        },
      ],
      "Ternopil''s''ka": [
        {
          id: "41372",
          name: "Ternopil",
          state_id: "3790",
        },
      ],
      "Volyns''ka": [
        {
          id: "41373",
          name: "Kovel",
          state_id: "3791",
        },
        {
          id: "41374",
          name: "Luts''k",
          state_id: "3791",
        },
        {
          id: "41375",
          name: "Novovolyns''k",
          state_id: "3791",
        },
      ],
      "Vynnyts''ka": [
        {
          id: "41376",
          name: "Vinnitsa",
          state_id: "3792",
        },
        {
          id: "41377",
          name: "Vinnytsya",
          state_id: "3792",
        },
      ],
      "Zakarpats''ka": [
        {
          id: "41378",
          name: "Mukacheve",
          state_id: "3793",
        },
        {
          id: "41379",
          name: "Uzhhorod",
          state_id: "3793",
        },
      ],
      Zaporizhia: [
        {
          id: "41380",
          name: "Berdyans''k",
          state_id: "3794",
        },
        {
          id: "41381",
          name: "Enerhodar",
          state_id: "3794",
        },
        {
          id: "41382",
          name: "Melitpol",
          state_id: "3794",
        },
        {
          id: "41383",
          name: "Zaporizhia",
          state_id: "3794",
        },
      ],
      "Zhytomyrs''ka": [
        {
          id: "41384",
          name: "Berdychiv",
          state_id: "3795",
        },
        {
          id: "41385",
          name: "Korosten",
          state_id: "3795",
        },
        {
          id: "41386",
          name: "Novohrad-Volyns''kyy",
          state_id: "3795",
        },
        {
          id: "41387",
          name: "Zhytomyr",
          state_id: "3795",
        },
      ],
    },
  },
  UG: {
    name: "Uganda",
    native: "Uganda",
    phone: "256",
    continent: "AF",
    capital: "Kampala",
    currency: "UGX",
    languages: ["en", "sw"],
    emoji: "🇺🇬",
    emojiU: "U+1F1FA U+1F1EC",
    states: {
      Central: [
        {
          id: "41181",
          name: "Bombo",
          state_id: "3762",
        },
        {
          id: "41182",
          name: "Bweyogerere",
          state_id: "3762",
        },
        {
          id: "41183",
          name: "Entebbe",
          state_id: "3762",
        },
        {
          id: "41184",
          name: "Jinja-Kawempe",
          state_id: "3762",
        },
        {
          id: "41185",
          name: "Kajansi",
          state_id: "3762",
        },
        {
          id: "41186",
          name: "Kalangala",
          state_id: "3762",
        },
        {
          id: "41187",
          name: "Kampala",
          state_id: "3762",
        },
        {
          id: "41188",
          name: "Kayunga",
          state_id: "3762",
        },
        {
          id: "41189",
          name: "Kiboga",
          state_id: "3762",
        },
        {
          id: "41190",
          name: "Kireka",
          state_id: "3762",
        },
        {
          id: "41191",
          name: "Kyotera",
          state_id: "3762",
        },
        {
          id: "41192",
          name: "Lugazi",
          state_id: "3762",
        },
        {
          id: "41193",
          name: "Lukaya",
          state_id: "3762",
        },
        {
          id: "41194",
          name: "Luwero",
          state_id: "3762",
        },
        {
          id: "41195",
          name: "Lyantonde",
          state_id: "3762",
        },
        {
          id: "41196",
          name: "Masaka",
          state_id: "3762",
        },
        {
          id: "41197",
          name: "Mityana",
          state_id: "3762",
        },
        {
          id: "41198",
          name: "Mpigi",
          state_id: "3762",
        },
        {
          id: "41199",
          name: "Mubende",
          state_id: "3762",
        },
        {
          id: "41200",
          name: "Mukono",
          state_id: "3762",
        },
        {
          id: "41201",
          name: "Nakasongola",
          state_id: "3762",
        },
        {
          id: "41202",
          name: "Namasuba",
          state_id: "3762",
        },
        {
          id: "41203",
          name: "Njeru",
          state_id: "3762",
        },
        {
          id: "41204",
          name: "Nkonkonjeru",
          state_id: "3762",
        },
        {
          id: "41205",
          name: "Rakai",
          state_id: "3762",
        },
        {
          id: "41206",
          name: "Sembabule",
          state_id: "3762",
        },
        {
          id: "41207",
          name: "Wakiso",
          state_id: "3762",
        },
        {
          id: "41208",
          name: "Wobulenzi",
          state_id: "3762",
        },
      ],
      Eastern: [
        {
          id: "41209",
          name: "Bugembe",
          state_id: "3763",
        },
        {
          id: "41210",
          name: "Bugiri",
          state_id: "3763",
        },
        {
          id: "41211",
          name: "Busembatia",
          state_id: "3763",
        },
        {
          id: "41212",
          name: "Busia",
          state_id: "3763",
        },
        {
          id: "41213",
          name: "Buwenge",
          state_id: "3763",
        },
        {
          id: "41214",
          name: "Iganga",
          state_id: "3763",
        },
        {
          id: "41215",
          name: "Jinja",
          state_id: "3763",
        },
        {
          id: "41216",
          name: "Kaberamaido",
          state_id: "3763",
        },
        {
          id: "41217",
          name: "Kamuli",
          state_id: "3763",
        },
        {
          id: "41218",
          name: "Kapchorwa",
          state_id: "3763",
        },
        {
          id: "41219",
          name: "Katakwi",
          state_id: "3763",
        },
        {
          id: "41220",
          name: "Kumi",
          state_id: "3763",
        },
        {
          id: "41221",
          name: "Malaba",
          state_id: "3763",
        },
        {
          id: "41222",
          name: "Mayuge",
          state_id: "3763",
        },
        {
          id: "41223",
          name: "Mbale",
          state_id: "3763",
        },
        {
          id: "41224",
          name: "Ngora",
          state_id: "3763",
        },
        {
          id: "41225",
          name: "Pallisa",
          state_id: "3763",
        },
        {
          id: "41226",
          name: "Sironko",
          state_id: "3763",
        },
        {
          id: "41227",
          name: "Soroti",
          state_id: "3763",
        },
        {
          id: "41228",
          name: "Tororo",
          state_id: "3763",
        },
      ],
      Northern: [
        {
          id: "41229",
          name: "Adjumani",
          state_id: "3764",
        },
        {
          id: "41230",
          name: "Amudat",
          state_id: "3764",
        },
        {
          id: "41231",
          name: "Apac",
          state_id: "3764",
        },
        {
          id: "41232",
          name: "Arua",
          state_id: "3764",
        },
        {
          id: "41233",
          name: "Gulu",
          state_id: "3764",
        },
        {
          id: "41234",
          name: "Kaabong",
          state_id: "3764",
        },
        {
          id: "41235",
          name: "Kitgum",
          state_id: "3764",
        },
        {
          id: "41236",
          name: "Koboko",
          state_id: "3764",
        },
        {
          id: "41237",
          name: "Kotido",
          state_id: "3764",
        },
        {
          id: "41238",
          name: "Lira",
          state_id: "3764",
        },
        {
          id: "41239",
          name: "Moroto",
          state_id: "3764",
        },
        {
          id: "41240",
          name: "Moyo",
          state_id: "3764",
        },
        {
          id: "41241",
          name: "Nakapiripirit",
          state_id: "3764",
        },
        {
          id: "41242",
          name: "Nebbi",
          state_id: "3764",
        },
        {
          id: "41243",
          name: "Pader",
          state_id: "3764",
        },
        {
          id: "41244",
          name: "Paidha",
          state_id: "3764",
        },
        {
          id: "41245",
          name: "Pakwach",
          state_id: "3764",
        },
        {
          id: "41246",
          name: "Yumbe",
          state_id: "3764",
        },
      ],
      Western: [
        {
          id: "41247",
          name: "Bundibugyo",
          state_id: "3765",
        },
        {
          id: "41248",
          name: "Bushenyi",
          state_id: "3765",
        },
        {
          id: "41249",
          name: "Fort Portal",
          state_id: "3765",
        },
        {
          id: "41250",
          name: "Hima",
          state_id: "3765",
        },
        {
          id: "41251",
          name: "Hoima",
          state_id: "3765",
        },
        {
          id: "41252",
          name: "Ibanda",
          state_id: "3765",
        },
        {
          id: "41253",
          name: "Kabale",
          state_id: "3765",
        },
        {
          id: "41254",
          name: "Kabwohe-Itendero",
          state_id: "3765",
        },
        {
          id: "41255",
          name: "Kagadi",
          state_id: "3765",
        },
        {
          id: "41256",
          name: "Kamwenge",
          state_id: "3765",
        },
        {
          id: "41257",
          name: "Kanungu",
          state_id: "3765",
        },
        {
          id: "41258",
          name: "Kasese",
          state_id: "3765",
        },
        {
          id: "41259",
          name: "Katwe",
          state_id: "3765",
        },
        {
          id: "41260",
          name: "Kibaale",
          state_id: "3765",
        },
        {
          id: "41261",
          name: "Kigorobya",
          state_id: "3765",
        },
        {
          id: "41262",
          name: "Kilembe",
          state_id: "3765",
        },
        {
          id: "41263",
          name: "Kisoro",
          state_id: "3765",
        },
        {
          id: "41264",
          name: "Kyenjojo",
          state_id: "3765",
        },
        {
          id: "41265",
          name: "Masindi",
          state_id: "3765",
        },
        {
          id: "41266",
          name: "Masindi-Port",
          state_id: "3765",
        },
        {
          id: "41267",
          name: "Mbarara",
          state_id: "3765",
        },
        {
          id: "41268",
          name: "Muhororo",
          state_id: "3765",
        },
        {
          id: "41269",
          name: "Ntungamo",
          state_id: "3765",
        },
        {
          id: "41270",
          name: "Rukungiri",
          state_id: "3765",
        },
      ],
    },
  },
  UM: {
    name: "U.S. Minor Outlying Islands",
    native: "United States Minor Outlying Islands",
    phone: "1",
    continent: "OC",
    capital: "",
    currency: "USD",
    languages: ["en"],
    emoji: "🇺🇲",
    emojiU: "U+1F1FA U+1F1F2",
    states: {
      "United States Minor Outlying I": [],
    },
  },
  US: {
    name: "United States",
    native: "United States",
    phone: "1",
    continent: "NA",
    capital: "Washington D.C.",
    currency: "USD,USN,USS",
    languages: ["en"],
    emoji: "🇺🇸",
    emojiU: "U+1F1FA U+1F1F8",
    states: {
      AA: [],
      AE: [],
      AP: [],
      Alabama: [
        {
          id: "42594",
          name: "Alabaster",
          state_id: "3919",
        },
        {
          id: "42595",
          name: "Albertville",
          state_id: "3919",
        },
        {
          id: "42596",
          name: "Alexander City",
          state_id: "3919",
        },
        {
          id: "42597",
          name: "Anniston",
          state_id: "3919",
        },
        {
          id: "42598",
          name: "Arab",
          state_id: "3919",
        },
        {
          id: "42599",
          name: "Ashville",
          state_id: "3919",
        },
        {
          id: "42600",
          name: "Athens",
          state_id: "3919",
        },
        {
          id: "42601",
          name: "Atmore",
          state_id: "3919",
        },
        {
          id: "42602",
          name: "Auburn",
          state_id: "3919",
        },
        {
          id: "42603",
          name: "Bessemer",
          state_id: "3919",
        },
        {
          id: "42604",
          name: "Birmingham",
          state_id: "3919",
        },
        {
          id: "42605",
          name: "Capshaw",
          state_id: "3919",
        },
        {
          id: "42606",
          name: "Center Point",
          state_id: "3919",
        },
        {
          id: "42607",
          name: "Childersburg",
          state_id: "3919",
        },
        {
          id: "42608",
          name: "Cullman",
          state_id: "3919",
        },
        {
          id: "42609",
          name: "Daleville",
          state_id: "3919",
        },
        {
          id: "42610",
          name: "Daphne",
          state_id: "3919",
        },
        {
          id: "42611",
          name: "Decatur",
          state_id: "3919",
        },
        {
          id: "42612",
          name: "Dothan",
          state_id: "3919",
        },
        {
          id: "42613",
          name: "Enterprise",
          state_id: "3919",
        },
        {
          id: "42614",
          name: "Eufaula",
          state_id: "3919",
        },
        {
          id: "42615",
          name: "Fairfield",
          state_id: "3919",
        },
        {
          id: "42616",
          name: "Fairhope",
          state_id: "3919",
        },
        {
          id: "42617",
          name: "Florence",
          state_id: "3919",
        },
        {
          id: "42618",
          name: "Fort Payne",
          state_id: "3919",
        },
        {
          id: "42619",
          name: "Gadsden",
          state_id: "3919",
        },
        {
          id: "42620",
          name: "Grand Bay",
          state_id: "3919",
        },
        {
          id: "42621",
          name: "Grove Hill",
          state_id: "3919",
        },
        {
          id: "42622",
          name: "Guntersville",
          state_id: "3919",
        },
        {
          id: "42623",
          name: "Hampton Cove",
          state_id: "3919",
        },
        {
          id: "42624",
          name: "Hanceville",
          state_id: "3919",
        },
        {
          id: "42625",
          name: "Hartselle",
          state_id: "3919",
        },
        {
          id: "42626",
          name: "Headland",
          state_id: "3919",
        },
        {
          id: "42627",
          name: "Helena",
          state_id: "3919",
        },
        {
          id: "42628",
          name: "Hodges",
          state_id: "3919",
        },
        {
          id: "42629",
          name: "Homewood",
          state_id: "3919",
        },
        {
          id: "42630",
          name: "Hoover",
          state_id: "3919",
        },
        {
          id: "42631",
          name: "Hueytown",
          state_id: "3919",
        },
        {
          id: "42632",
          name: "Huntsville",
          state_id: "3919",
        },
        {
          id: "42633",
          name: "Jacksonville",
          state_id: "3919",
        },
        {
          id: "42634",
          name: "Jasper",
          state_id: "3919",
        },
        {
          id: "42635",
          name: "Leeds",
          state_id: "3919",
        },
        {
          id: "42636",
          name: "Luverne",
          state_id: "3919",
        },
        {
          id: "42637",
          name: "Madison",
          state_id: "3919",
        },
        {
          id: "42638",
          name: "Mobile",
          state_id: "3919",
        },
        {
          id: "42639",
          name: "Montgomery",
          state_id: "3919",
        },
        {
          id: "42640",
          name: "Mountain Brook",
          state_id: "3919",
        },
        {
          id: "42641",
          name: "Muscle Shoals",
          state_id: "3919",
        },
        {
          id: "42642",
          name: "Northport",
          state_id: "3919",
        },
        {
          id: "42643",
          name: "Notasulga",
          state_id: "3919",
        },
        {
          id: "42644",
          name: "Opelika",
          state_id: "3919",
        },
        {
          id: "42645",
          name: "Oxford",
          state_id: "3919",
        },
        {
          id: "42646",
          name: "Ozark",
          state_id: "3919",
        },
        {
          id: "42647",
          name: "Pelham",
          state_id: "3919",
        },
        {
          id: "42648",
          name: "Pell City",
          state_id: "3919",
        },
        {
          id: "42649",
          name: "Pennsylvania",
          state_id: "3919",
        },
        {
          id: "42650",
          name: "Phenix City",
          state_id: "3919",
        },
        {
          id: "42651",
          name: "Prattville",
          state_id: "3919",
        },
        {
          id: "42652",
          name: "Prichard",
          state_id: "3919",
        },
        {
          id: "42653",
          name: "Ramer",
          state_id: "3919",
        },
        {
          id: "42654",
          name: "Roanoke",
          state_id: "3919",
        },
        {
          id: "42655",
          name: "Saraland",
          state_id: "3919",
        },
        {
          id: "42656",
          name: "Scottsboro",
          state_id: "3919",
        },
        {
          id: "42657",
          name: "Selma",
          state_id: "3919",
        },
        {
          id: "42658",
          name: "Sheffield",
          state_id: "3919",
        },
        {
          id: "42659",
          name: "Smiths",
          state_id: "3919",
        },
        {
          id: "42660",
          name: "Sumiton",
          state_id: "3919",
        },
        {
          id: "42661",
          name: "Sylacauga",
          state_id: "3919",
        },
        {
          id: "42662",
          name: "Talladega",
          state_id: "3919",
        },
        {
          id: "42663",
          name: "Thomasville",
          state_id: "3919",
        },
        {
          id: "42664",
          name: "Trafford",
          state_id: "3919",
        },
        {
          id: "42665",
          name: "Troy",
          state_id: "3919",
        },
        {
          id: "42666",
          name: "Trussville",
          state_id: "3919",
        },
        {
          id: "42667",
          name: "Tuscaloosa",
          state_id: "3919",
        },
        {
          id: "42668",
          name: "Tuskegee",
          state_id: "3919",
        },
        {
          id: "42669",
          name: "Vestavia Hills",
          state_id: "3919",
        },
      ],
      Alaska: [
        {
          id: "42670",
          name: "Anchorage",
          state_id: "3920",
        },
        {
          id: "42671",
          name: "Barrow",
          state_id: "3920",
        },
        {
          id: "42672",
          name: "Bethel",
          state_id: "3920",
        },
        {
          id: "42673",
          name: "College",
          state_id: "3920",
        },
        {
          id: "42674",
          name: "Fairbanks",
          state_id: "3920",
        },
        {
          id: "42675",
          name: "Homer",
          state_id: "3920",
        },
        {
          id: "42676",
          name: "Juneau",
          state_id: "3920",
        },
        {
          id: "42677",
          name: "Kenai",
          state_id: "3920",
        },
        {
          id: "42678",
          name: "Ketchikan",
          state_id: "3920",
        },
        {
          id: "42679",
          name: "Kodiak",
          state_id: "3920",
        },
        {
          id: "42680",
          name: "Nome",
          state_id: "3920",
        },
        {
          id: "42681",
          name: "Palmer",
          state_id: "3920",
        },
        {
          id: "42682",
          name: "Sitka",
          state_id: "3920",
        },
        {
          id: "42683",
          name: "Soldotna",
          state_id: "3920",
        },
        {
          id: "42684",
          name: "Sterling",
          state_id: "3920",
        },
        {
          id: "42685",
          name: "Unalaska",
          state_id: "3920",
        },
        {
          id: "42686",
          name: "Valdez",
          state_id: "3920",
        },
        {
          id: "42687",
          name: "Wasilla",
          state_id: "3920",
        },
      ],
      Arizona: [
        {
          id: "42688",
          name: "Apache Junction",
          state_id: "3921",
        },
        {
          id: "42689",
          name: "Avondale",
          state_id: "3921",
        },
        {
          id: "42690",
          name: "Bisbee",
          state_id: "3921",
        },
        {
          id: "42691",
          name: "Bouse",
          state_id: "3921",
        },
        {
          id: "42692",
          name: "Bullhead City",
          state_id: "3921",
        },
        {
          id: "42693",
          name: "Carefree",
          state_id: "3921",
        },
        {
          id: "42694",
          name: "Casa Grande",
          state_id: "3921",
        },
        {
          id: "42695",
          name: "Casas Adobes",
          state_id: "3921",
        },
        {
          id: "42696",
          name: "Chandler",
          state_id: "3921",
        },
        {
          id: "42697",
          name: "Clarkdale",
          state_id: "3921",
        },
        {
          id: "42698",
          name: "Cottonwood",
          state_id: "3921",
        },
        {
          id: "42699",
          name: "Douglas",
          state_id: "3921",
        },
        {
          id: "42700",
          name: "Drexel Heights",
          state_id: "3921",
        },
        {
          id: "42701",
          name: "El Mirage",
          state_id: "3921",
        },
        {
          id: "42702",
          name: "Flagstaff",
          state_id: "3921",
        },
        {
          id: "42703",
          name: "Florence",
          state_id: "3921",
        },
        {
          id: "42704",
          name: "Flowing Wells",
          state_id: "3921",
        },
        {
          id: "42705",
          name: "Fort Mohave",
          state_id: "3921",
        },
        {
          id: "42706",
          name: "Fortuna Foothills",
          state_id: "3921",
        },
        {
          id: "42707",
          name: "Fountain Hills",
          state_id: "3921",
        },
        {
          id: "42708",
          name: "Gilbert",
          state_id: "3921",
        },
        {
          id: "42709",
          name: "Glendale",
          state_id: "3921",
        },
        {
          id: "42710",
          name: "Globe",
          state_id: "3921",
        },
        {
          id: "42711",
          name: "Goodyear",
          state_id: "3921",
        },
        {
          id: "42712",
          name: "Green Valley",
          state_id: "3921",
        },
        {
          id: "42713",
          name: "Kingman",
          state_id: "3921",
        },
        {
          id: "42714",
          name: "Lake Havasu City",
          state_id: "3921",
        },
        {
          id: "42715",
          name: "Laveen",
          state_id: "3921",
        },
        {
          id: "42716",
          name: "Litchfield Park",
          state_id: "3921",
        },
        {
          id: "42717",
          name: "Marana",
          state_id: "3921",
        },
        {
          id: "42718",
          name: "Mesa",
          state_id: "3921",
        },
        {
          id: "42719",
          name: "New Kingman-Butler",
          state_id: "3921",
        },
        {
          id: "42720",
          name: "Nogales",
          state_id: "3921",
        },
        {
          id: "42721",
          name: "Oracle",
          state_id: "3921",
        },
        {
          id: "42722",
          name: "Oro Valley",
          state_id: "3921",
        },
        {
          id: "42723",
          name: "Paradise Valley",
          state_id: "3921",
        },
        {
          id: "42724",
          name: "Parker",
          state_id: "3921",
        },
        {
          id: "42725",
          name: "Payson",
          state_id: "3921",
        },
        {
          id: "42726",
          name: "Peoria",
          state_id: "3921",
        },
        {
          id: "42727",
          name: "Phoenix",
          state_id: "3921",
        },
        {
          id: "42728",
          name: "Pine",
          state_id: "3921",
        },
        {
          id: "42729",
          name: "Pinetop",
          state_id: "3921",
        },
        {
          id: "42730",
          name: "Prescott",
          state_id: "3921",
        },
        {
          id: "42731",
          name: "Prescott Valley",
          state_id: "3921",
        },
        {
          id: "42732",
          name: "Quartzsite",
          state_id: "3921",
        },
        {
          id: "42733",
          name: "Queen Creek",
          state_id: "3921",
        },
        {
          id: "42734",
          name: "Rio Rico",
          state_id: "3921",
        },
        {
          id: "42735",
          name: "Safford",
          state_id: "3921",
        },
        {
          id: "42736",
          name: "San Luis",
          state_id: "3921",
        },
        {
          id: "42737",
          name: "Scottsdale",
          state_id: "3921",
        },
        {
          id: "42738",
          name: "Sedona",
          state_id: "3921",
        },
        {
          id: "42739",
          name: "Sierra Vista",
          state_id: "3921",
        },
        {
          id: "42740",
          name: "Sierra Vista Southeast",
          state_id: "3921",
        },
        {
          id: "42741",
          name: "Sun City",
          state_id: "3921",
        },
        {
          id: "42742",
          name: "Sun City West",
          state_id: "3921",
        },
        {
          id: "42743",
          name: "Surprise",
          state_id: "3921",
        },
        {
          id: "42744",
          name: "Tempe",
          state_id: "3921",
        },
        {
          id: "42745",
          name: "Tombstone",
          state_id: "3921",
        },
        {
          id: "42746",
          name: "Tucson",
          state_id: "3921",
        },
        {
          id: "42747",
          name: "Winslow",
          state_id: "3921",
        },
        {
          id: "42748",
          name: "Yuma",
          state_id: "3921",
        },
      ],
      Arkansas: [
        {
          id: "42749",
          name: "Alexander",
          state_id: "3922",
        },
        {
          id: "42750",
          name: "Arkadelphia",
          state_id: "3922",
        },
        {
          id: "42751",
          name: "Batesville",
          state_id: "3922",
        },
        {
          id: "42752",
          name: "Bella Vista",
          state_id: "3922",
        },
        {
          id: "42753",
          name: "Benton",
          state_id: "3922",
        },
        {
          id: "42754",
          name: "Bentonville",
          state_id: "3922",
        },
        {
          id: "42755",
          name: "Berryville",
          state_id: "3922",
        },
        {
          id: "42756",
          name: "Blytheville",
          state_id: "3922",
        },
        {
          id: "42757",
          name: "Cabot",
          state_id: "3922",
        },
        {
          id: "42758",
          name: "Camden",
          state_id: "3922",
        },
        {
          id: "42759",
          name: "Cherry Valley",
          state_id: "3922",
        },
        {
          id: "42760",
          name: "Conway",
          state_id: "3922",
        },
        {
          id: "42761",
          name: "Corning",
          state_id: "3922",
        },
        {
          id: "42762",
          name: "El Dorado",
          state_id: "3922",
        },
        {
          id: "42763",
          name: "Fayetteville",
          state_id: "3922",
        },
        {
          id: "42764",
          name: "Forrest City",
          state_id: "3922",
        },
        {
          id: "42765",
          name: "Fort Smith",
          state_id: "3922",
        },
        {
          id: "42766",
          name: "Harrison",
          state_id: "3922",
        },
        {
          id: "42767",
          name: "Hope",
          state_id: "3922",
        },
        {
          id: "42768",
          name: "Hot Springs",
          state_id: "3922",
        },
        {
          id: "42769",
          name: "Jacksonville",
          state_id: "3922",
        },
        {
          id: "42770",
          name: "Jonesboro",
          state_id: "3922",
        },
        {
          id: "42771",
          name: "Lake City",
          state_id: "3922",
        },
        {
          id: "42772",
          name: "Little Rock",
          state_id: "3922",
        },
        {
          id: "42773",
          name: "Magnolia",
          state_id: "3922",
        },
        {
          id: "42774",
          name: "Mount Vernon",
          state_id: "3922",
        },
        {
          id: "42775",
          name: "Mountain Home",
          state_id: "3922",
        },
        {
          id: "42776",
          name: "Norfork",
          state_id: "3922",
        },
        {
          id: "42777",
          name: "North Little Rock",
          state_id: "3922",
        },
        {
          id: "42778",
          name: "Paragould",
          state_id: "3922",
        },
        {
          id: "42779",
          name: "Piggott",
          state_id: "3922",
        },
        {
          id: "42780",
          name: "Pine Bluff",
          state_id: "3922",
        },
        {
          id: "42781",
          name: "Pocahontas",
          state_id: "3922",
        },
        {
          id: "42782",
          name: "Prescott",
          state_id: "3922",
        },
        {
          id: "42783",
          name: "Quitman",
          state_id: "3922",
        },
        {
          id: "42784",
          name: "Rogers",
          state_id: "3922",
        },
        {
          id: "42785",
          name: "Russellville",
          state_id: "3922",
        },
        {
          id: "42786",
          name: "Searcy",
          state_id: "3922",
        },
        {
          id: "42787",
          name: "Sheridan",
          state_id: "3922",
        },
        {
          id: "42788",
          name: "Sherwood",
          state_id: "3922",
        },
        {
          id: "42789",
          name: "Siloam Springs",
          state_id: "3922",
        },
        {
          id: "42790",
          name: "Springdale",
          state_id: "3922",
        },
        {
          id: "42791",
          name: "Stuttgart",
          state_id: "3922",
        },
        {
          id: "42792",
          name: "Texarkana",
          state_id: "3922",
        },
        {
          id: "42793",
          name: "Van Buren",
          state_id: "3922",
        },
        {
          id: "42794",
          name: "Ward",
          state_id: "3922",
        },
        {
          id: "42795",
          name: "West Helena",
          state_id: "3922",
        },
        {
          id: "42796",
          name: "West Memphis",
          state_id: "3922",
        },
        {
          id: "42797",
          name: "Wynne",
          state_id: "3922",
        },
      ],
      California: [
        {
          id: "42798",
          name: "Acton",
          state_id: "3924",
        },
        {
          id: "42799",
          name: "Adelanto",
          state_id: "3924",
        },
        {
          id: "42800",
          name: "Agoura Hills",
          state_id: "3924",
        },
        {
          id: "42801",
          name: "Aguanga",
          state_id: "3924",
        },
        {
          id: "42802",
          name: "Alameda",
          state_id: "3924",
        },
        {
          id: "42803",
          name: "Alamo",
          state_id: "3924",
        },
        {
          id: "42804",
          name: "Albany",
          state_id: "3924",
        },
        {
          id: "42805",
          name: "Alhambra",
          state_id: "3924",
        },
        {
          id: "42806",
          name: "Aliso Viejo",
          state_id: "3924",
        },
        {
          id: "42807",
          name: "Alondra Park",
          state_id: "3924",
        },
        {
          id: "42808",
          name: "Alpine",
          state_id: "3924",
        },
        {
          id: "42809",
          name: "Alta Loma",
          state_id: "3924",
        },
        {
          id: "42810",
          name: "Altadena",
          state_id: "3924",
        },
        {
          id: "42811",
          name: "American Canyon",
          state_id: "3924",
        },
        {
          id: "42812",
          name: "Anaheim",
          state_id: "3924",
        },
        {
          id: "42813",
          name: "Anderson",
          state_id: "3924",
        },
        {
          id: "42814",
          name: "Antelope",
          state_id: "3924",
        },
        {
          id: "42815",
          name: "Antioch",
          state_id: "3924",
        },
        {
          id: "42816",
          name: "Apple Valley",
          state_id: "3924",
        },
        {
          id: "42817",
          name: "Aptos",
          state_id: "3924",
        },
        {
          id: "42818",
          name: "Arcadia",
          state_id: "3924",
        },
        {
          id: "42819",
          name: "Arcata",
          state_id: "3924",
        },
        {
          id: "42820",
          name: "Arden-Arcade",
          state_id: "3924",
        },
        {
          id: "42821",
          name: "Arroyo Grande",
          state_id: "3924",
        },
        {
          id: "42822",
          name: "Artesia",
          state_id: "3924",
        },
        {
          id: "42823",
          name: "Arvin",
          state_id: "3924",
        },
        {
          id: "42824",
          name: "Ashland",
          state_id: "3924",
        },
        {
          id: "42825",
          name: "Atascadero",
          state_id: "3924",
        },
        {
          id: "42826",
          name: "Atwater",
          state_id: "3924",
        },
        {
          id: "42827",
          name: "Auburn",
          state_id: "3924",
        },
        {
          id: "42828",
          name: "Avalon",
          state_id: "3924",
        },
        {
          id: "42829",
          name: "Avenal",
          state_id: "3924",
        },
        {
          id: "42830",
          name: "Avocado Heights",
          state_id: "3924",
        },
        {
          id: "42831",
          name: "Azusa",
          state_id: "3924",
        },
        {
          id: "42832",
          name: "Bakersfield",
          state_id: "3924",
        },
        {
          id: "42833",
          name: "Baldwin Park",
          state_id: "3924",
        },
        {
          id: "42834",
          name: "Banning",
          state_id: "3924",
        },
        {
          id: "42835",
          name: "Barstow",
          state_id: "3924",
        },
        {
          id: "42836",
          name: "Bay Point",
          state_id: "3924",
        },
        {
          id: "42837",
          name: "Baywood-Los Osos",
          state_id: "3924",
        },
        {
          id: "42838",
          name: "Bear Valley Springs",
          state_id: "3924",
        },
        {
          id: "42839",
          name: "Beaumont",
          state_id: "3924",
        },
        {
          id: "42840",
          name: "Bell",
          state_id: "3924",
        },
        {
          id: "42841",
          name: "Bell Gardens",
          state_id: "3924",
        },
        {
          id: "42842",
          name: "Bellflower",
          state_id: "3924",
        },
        {
          id: "42843",
          name: "Belmont",
          state_id: "3924",
        },
        {
          id: "42844",
          name: "Ben Lomond",
          state_id: "3924",
        },
        {
          id: "42845",
          name: "Benicia",
          state_id: "3924",
        },
        {
          id: "42846",
          name: "Berkeley",
          state_id: "3924",
        },
        {
          id: "42847",
          name: "Beverly Hills",
          state_id: "3924",
        },
        {
          id: "42848",
          name: "Big Bear Lake",
          state_id: "3924",
        },
        {
          id: "42849",
          name: "Bloomington",
          state_id: "3924",
        },
        {
          id: "42850",
          name: "Blythe",
          state_id: "3924",
        },
        {
          id: "42851",
          name: "Bonita",
          state_id: "3924",
        },
        {
          id: "42852",
          name: "Bostonia",
          state_id: "3924",
        },
        {
          id: "42853",
          name: "Brawley",
          state_id: "3924",
        },
        {
          id: "42854",
          name: "Brea",
          state_id: "3924",
        },
        {
          id: "42855",
          name: "Brentwood",
          state_id: "3924",
        },
        {
          id: "42856",
          name: "Brisbane",
          state_id: "3924",
        },
        {
          id: "42857",
          name: "Brookdale",
          state_id: "3924",
        },
        {
          id: "42858",
          name: "Buena Park",
          state_id: "3924",
        },
        {
          id: "42859",
          name: "Burbank",
          state_id: "3924",
        },
        {
          id: "42860",
          name: "Burlingame",
          state_id: "3924",
        },
        {
          id: "42861",
          name: "Burnham",
          state_id: "3924",
        },
        {
          id: "42862",
          name: "Byron",
          state_id: "3924",
        },
        {
          id: "42863",
          name: "Calabasas",
          state_id: "3924",
        },
        {
          id: "42864",
          name: "Calexico",
          state_id: "3924",
        },
        {
          id: "42865",
          name: "California City",
          state_id: "3924",
        },
        {
          id: "42866",
          name: "Camarillo",
          state_id: "3924",
        },
        {
          id: "42867",
          name: "Cameron Park",
          state_id: "3924",
        },
        {
          id: "42868",
          name: "Camino",
          state_id: "3924",
        },
        {
          id: "42869",
          name: "Camp Pendleton North",
          state_id: "3924",
        },
        {
          id: "42870",
          name: "Camp Pendleton South",
          state_id: "3924",
        },
        {
          id: "42871",
          name: "Campbell",
          state_id: "3924",
        },
        {
          id: "42872",
          name: "Canoga Park",
          state_id: "3924",
        },
        {
          id: "42873",
          name: "Canyon Lake",
          state_id: "3924",
        },
        {
          id: "42874",
          name: "Capitola",
          state_id: "3924",
        },
        {
          id: "42875",
          name: "Carlsbad",
          state_id: "3924",
        },
        {
          id: "42876",
          name: "Carmel",
          state_id: "3924",
        },
        {
          id: "42877",
          name: "Carmel Valley",
          state_id: "3924",
        },
        {
          id: "42878",
          name: "Carmichael",
          state_id: "3924",
        },
        {
          id: "42879",
          name: "Carpinteria",
          state_id: "3924",
        },
        {
          id: "42880",
          name: "Carson",
          state_id: "3924",
        },
        {
          id: "42881",
          name: "Casa de Oro-Mount Helix",
          state_id: "3924",
        },
        {
          id: "42882",
          name: "Castaic",
          state_id: "3924",
        },
        {
          id: "42883",
          name: "Castro Valley",
          state_id: "3924",
        },
        {
          id: "42884",
          name: "Cathedral City",
          state_id: "3924",
        },
        {
          id: "42885",
          name: "Cayucos",
          state_id: "3924",
        },
        {
          id: "42886",
          name: "Ceres",
          state_id: "3924",
        },
        {
          id: "42887",
          name: "Cerritos",
          state_id: "3924",
        },
        {
          id: "42888",
          name: "Charter Oak",
          state_id: "3924",
        },
        {
          id: "42889",
          name: "Chatsworth",
          state_id: "3924",
        },
        {
          id: "42890",
          name: "Cherryland",
          state_id: "3924",
        },
        {
          id: "42891",
          name: "Chico",
          state_id: "3924",
        },
        {
          id: "42892",
          name: "Chino",
          state_id: "3924",
        },
        {
          id: "42893",
          name: "Chino Hills",
          state_id: "3924",
        },
        {
          id: "42894",
          name: "Chula Vista",
          state_id: "3924",
        },
        {
          id: "42895",
          name: "Citrus",
          state_id: "3924",
        },
        {
          id: "42896",
          name: "Citrus Heights",
          state_id: "3924",
        },
        {
          id: "42897",
          name: "City of Commerce",
          state_id: "3924",
        },
        {
          id: "42898",
          name: "City of Industry",
          state_id: "3924",
        },
        {
          id: "42899",
          name: "Claremont",
          state_id: "3924",
        },
        {
          id: "42900",
          name: "Clearlake",
          state_id: "3924",
        },
        {
          id: "42901",
          name: "Clovis",
          state_id: "3924",
        },
        {
          id: "42902",
          name: "Coachella",
          state_id: "3924",
        },
        {
          id: "42903",
          name: "Coalinga",
          state_id: "3924",
        },
        {
          id: "42904",
          name: "Colfax",
          state_id: "3924",
        },
        {
          id: "42905",
          name: "Colton",
          state_id: "3924",
        },
        {
          id: "42906",
          name: "Colusa",
          state_id: "3924",
        },
        {
          id: "42907",
          name: "Commerce",
          state_id: "3924",
        },
        {
          id: "42908",
          name: "Compton",
          state_id: "3924",
        },
        {
          id: "42909",
          name: "Concord",
          state_id: "3924",
        },
        {
          id: "42910",
          name: "Corcoran",
          state_id: "3924",
        },
        {
          id: "42911",
          name: "Corning",
          state_id: "3924",
        },
        {
          id: "42912",
          name: "Corona",
          state_id: "3924",
        },
        {
          id: "42913",
          name: "Coronado",
          state_id: "3924",
        },
        {
          id: "42914",
          name: "Corte Madera",
          state_id: "3924",
        },
        {
          id: "42915",
          name: "Costa Mesa",
          state_id: "3924",
        },
        {
          id: "42916",
          name: "Cotati",
          state_id: "3924",
        },
        {
          id: "42917",
          name: "Cottonwood",
          state_id: "3924",
        },
        {
          id: "42918",
          name: "Country Club",
          state_id: "3924",
        },
        {
          id: "42919",
          name: "Covina",
          state_id: "3924",
        },
        {
          id: "42920",
          name: "Crestline",
          state_id: "3924",
        },
        {
          id: "42921",
          name: "Cudahy",
          state_id: "3924",
        },
        {
          id: "42922",
          name: "Culver City",
          state_id: "3924",
        },
        {
          id: "42923",
          name: "Cupertino",
          state_id: "3924",
        },
        {
          id: "42924",
          name: "Cypress",
          state_id: "3924",
        },
        {
          id: "42925",
          name: "Daly City",
          state_id: "3924",
        },
        {
          id: "42926",
          name: "Dana Point",
          state_id: "3924",
        },
        {
          id: "42927",
          name: "Danville",
          state_id: "3924",
        },
        {
          id: "42928",
          name: "Davis",
          state_id: "3924",
        },
        {
          id: "42929",
          name: "Del Mar",
          state_id: "3924",
        },
        {
          id: "42930",
          name: "Delano",
          state_id: "3924",
        },
        {
          id: "42931",
          name: "Desert Hot Springs",
          state_id: "3924",
        },
        {
          id: "42932",
          name: "Diamond Bar",
          state_id: "3924",
        },
        {
          id: "42933",
          name: "Dinuba",
          state_id: "3924",
        },
        {
          id: "42934",
          name: "Dixon",
          state_id: "3924",
        },
        {
          id: "42935",
          name: "Downey",
          state_id: "3924",
        },
        {
          id: "42936",
          name: "Duarte",
          state_id: "3924",
        },
        {
          id: "42937",
          name: "Dublin",
          state_id: "3924",
        },
        {
          id: "42938",
          name: "East Foothills",
          state_id: "3924",
        },
        {
          id: "42939",
          name: "East Hemet",
          state_id: "3924",
        },
        {
          id: "42940",
          name: "East La Mirada",
          state_id: "3924",
        },
        {
          id: "42941",
          name: "East Palo Alto",
          state_id: "3924",
        },
        {
          id: "42942",
          name: "East San Gabriel",
          state_id: "3924",
        },
        {
          id: "42943",
          name: "El Cajon",
          state_id: "3924",
        },
        {
          id: "42944",
          name: "El Centro",
          state_id: "3924",
        },
        {
          id: "42945",
          name: "El Cerrito",
          state_id: "3924",
        },
        {
          id: "42946",
          name: "El Granada",
          state_id: "3924",
        },
        {
          id: "42947",
          name: "El Monte",
          state_id: "3924",
        },
        {
          id: "42948",
          name: "El Paso de Robles",
          state_id: "3924",
        },
        {
          id: "42949",
          name: "El Segundo",
          state_id: "3924",
        },
        {
          id: "42950",
          name: "El Sobrante",
          state_id: "3924",
        },
        {
          id: "42951",
          name: "Elk Grove",
          state_id: "3924",
        },
        {
          id: "42952",
          name: "Emeryville",
          state_id: "3924",
        },
        {
          id: "42953",
          name: "Encinitas",
          state_id: "3924",
        },
        {
          id: "42954",
          name: "Encino",
          state_id: "3924",
        },
        {
          id: "42955",
          name: "Escondido",
          state_id: "3924",
        },
        {
          id: "42956",
          name: "Etna",
          state_id: "3924",
        },
        {
          id: "42957",
          name: "Eureka",
          state_id: "3924",
        },
        {
          id: "42958",
          name: "Exeter",
          state_id: "3924",
        },
        {
          id: "42959",
          name: "Fair Oaks",
          state_id: "3924",
        },
        {
          id: "42960",
          name: "Fairfax",
          state_id: "3924",
        },
        {
          id: "42961",
          name: "Fairfield",
          state_id: "3924",
        },
        {
          id: "42962",
          name: "Fairview",
          state_id: "3924",
        },
        {
          id: "42963",
          name: "Fallbrook",
          state_id: "3924",
        },
        {
          id: "42964",
          name: "Ferndale",
          state_id: "3924",
        },
        {
          id: "42965",
          name: "Fillmore",
          state_id: "3924",
        },
        {
          id: "42966",
          name: "Florence-Graham",
          state_id: "3924",
        },
        {
          id: "42967",
          name: "Florin",
          state_id: "3924",
        },
        {
          id: "42968",
          name: "Folsom",
          state_id: "3924",
        },
        {
          id: "42969",
          name: "Fontana",
          state_id: "3924",
        },
        {
          id: "42970",
          name: "Foothill Farms",
          state_id: "3924",
        },
        {
          id: "42971",
          name: "Foothill Ranch",
          state_id: "3924",
        },
        {
          id: "42972",
          name: "Forestville",
          state_id: "3924",
        },
        {
          id: "42973",
          name: "Fort Bragg",
          state_id: "3924",
        },
        {
          id: "42974",
          name: "Fortuna",
          state_id: "3924",
        },
        {
          id: "42975",
          name: "Foster City",
          state_id: "3924",
        },
        {
          id: "42976",
          name: "Fountain Valley",
          state_id: "3924",
        },
        {
          id: "42977",
          name: "Freedom",
          state_id: "3924",
        },
        {
          id: "42978",
          name: "Fremont",
          state_id: "3924",
        },
        {
          id: "42979",
          name: "Fresno",
          state_id: "3924",
        },
        {
          id: "42980",
          name: "Fullerton",
          state_id: "3924",
        },
        {
          id: "42981",
          name: "Galt",
          state_id: "3924",
        },
        {
          id: "42982",
          name: "Garberville",
          state_id: "3924",
        },
        {
          id: "42983",
          name: "Garden Acres",
          state_id: "3924",
        },
        {
          id: "42984",
          name: "Garden Grove",
          state_id: "3924",
        },
        {
          id: "42985",
          name: "Gardena",
          state_id: "3924",
        },
        {
          id: "42986",
          name: "Georgetown",
          state_id: "3924",
        },
        {
          id: "42987",
          name: "Gilroy",
          state_id: "3924",
        },
        {
          id: "42988",
          name: "Glen Avon",
          state_id: "3924",
        },
        {
          id: "42989",
          name: "Glendale",
          state_id: "3924",
        },
        {
          id: "42990",
          name: "Glendora",
          state_id: "3924",
        },
        {
          id: "42991",
          name: "Goleta",
          state_id: "3924",
        },
        {
          id: "42992",
          name: "Gonzales",
          state_id: "3924",
        },
        {
          id: "42993",
          name: "Granada Hills",
          state_id: "3924",
        },
        {
          id: "42994",
          name: "Grand Terrace",
          state_id: "3924",
        },
        {
          id: "42995",
          name: "Grass Valley",
          state_id: "3924",
        },
        {
          id: "42996",
          name: "Greenfield",
          state_id: "3924",
        },
        {
          id: "42997",
          name: "Grover Beach",
          state_id: "3924",
        },
        {
          id: "42998",
          name: "Gualala",
          state_id: "3924",
        },
        {
          id: "42999",
          name: "Guerneville",
          state_id: "3924",
        },
        {
          id: "43000",
          name: "Hacienda Heights",
          state_id: "3924",
        },
        {
          id: "43001",
          name: "Half Moon Bay",
          state_id: "3924",
        },
        {
          id: "43002",
          name: "Hanford",
          state_id: "3924",
        },
        {
          id: "43003",
          name: "Harbor City",
          state_id: "3924",
        },
        {
          id: "43004",
          name: "Hawaiian Gardens",
          state_id: "3924",
        },
        {
          id: "43005",
          name: "Hawthorne",
          state_id: "3924",
        },
        {
          id: "43006",
          name: "Hayward",
          state_id: "3924",
        },
        {
          id: "43007",
          name: "Hemet",
          state_id: "3924",
        },
        {
          id: "43008",
          name: "Hercules",
          state_id: "3924",
        },
        {
          id: "43009",
          name: "Hermosa Beach",
          state_id: "3924",
        },
        {
          id: "43010",
          name: "Hesperia",
          state_id: "3924",
        },
        {
          id: "43011",
          name: "Highland",
          state_id: "3924",
        },
        {
          id: "43012",
          name: "Hillsborough",
          state_id: "3924",
        },
        {
          id: "43013",
          name: "Hollister",
          state_id: "3924",
        },
        {
          id: "43014",
          name: "Hollywood",
          state_id: "3924",
        },
        {
          id: "43015",
          name: "Huntington Beach",
          state_id: "3924",
        },
        {
          id: "43016",
          name: "Huntington Park",
          state_id: "3924",
        },
        {
          id: "43017",
          name: "Idyllwild",
          state_id: "3924",
        },
        {
          id: "43018",
          name: "Imperial Beach",
          state_id: "3924",
        },
        {
          id: "43019",
          name: "Indio",
          state_id: "3924",
        },
        {
          id: "43020",
          name: "Industry",
          state_id: "3924",
        },
        {
          id: "43021",
          name: "Inglewood",
          state_id: "3924",
        },
        {
          id: "43022",
          name: "Irvine",
          state_id: "3924",
        },
        {
          id: "43023",
          name: "Irwindale",
          state_id: "3924",
        },
        {
          id: "43024",
          name: "Isla Vista",
          state_id: "3924",
        },
        {
          id: "43025",
          name: "Jackson",
          state_id: "3924",
        },
        {
          id: "43026",
          name: "Jamul",
          state_id: "3924",
        },
        {
          id: "43027",
          name: "La Canada Flintridge",
          state_id: "3924",
        },
        {
          id: "43028",
          name: "La Crescenta-Montrose",
          state_id: "3924",
        },
        {
          id: "43029",
          name: "La Habra",
          state_id: "3924",
        },
        {
          id: "43030",
          name: "La Jolla",
          state_id: "3924",
        },
        {
          id: "43031",
          name: "La Mesa",
          state_id: "3924",
        },
        {
          id: "43032",
          name: "La Mirada",
          state_id: "3924",
        },
        {
          id: "43033",
          name: "La Palma",
          state_id: "3924",
        },
        {
          id: "43034",
          name: "La Presa",
          state_id: "3924",
        },
        {
          id: "43035",
          name: "La Puente",
          state_id: "3924",
        },
        {
          id: "43036",
          name: "La Quinta",
          state_id: "3924",
        },
        {
          id: "43037",
          name: "La Riviera",
          state_id: "3924",
        },
        {
          id: "43038",
          name: "La Verne",
          state_id: "3924",
        },
        {
          id: "43039",
          name: "LaVerne",
          state_id: "3924",
        },
        {
          id: "43040",
          name: "Ladera Ranch",
          state_id: "3924",
        },
        {
          id: "43041",
          name: "Lafayette",
          state_id: "3924",
        },
        {
          id: "43042",
          name: "Laguna",
          state_id: "3924",
        },
        {
          id: "43043",
          name: "Laguna Beach",
          state_id: "3924",
        },
        {
          id: "43044",
          name: "Laguna Hills",
          state_id: "3924",
        },
        {
          id: "43045",
          name: "Laguna Niguel",
          state_id: "3924",
        },
        {
          id: "43046",
          name: "Lake Elsinore",
          state_id: "3924",
        },
        {
          id: "43047",
          name: "Lake Forest",
          state_id: "3924",
        },
        {
          id: "43048",
          name: "Lakeside",
          state_id: "3924",
        },
        {
          id: "43049",
          name: "Lakewood",
          state_id: "3924",
        },
        {
          id: "43050",
          name: "Lamont",
          state_id: "3924",
        },
        {
          id: "43051",
          name: "Lancaster",
          state_id: "3924",
        },
        {
          id: "43052",
          name: "Larkspur",
          state_id: "3924",
        },
        {
          id: "43053",
          name: "Lawndale",
          state_id: "3924",
        },
        {
          id: "43054",
          name: "Laytonville",
          state_id: "3924",
        },
        {
          id: "43055",
          name: "Lemon Grove",
          state_id: "3924",
        },
        {
          id: "43056",
          name: "Lemoore",
          state_id: "3924",
        },
        {
          id: "43057",
          name: "Lennox",
          state_id: "3924",
        },
        {
          id: "43058",
          name: "Linda",
          state_id: "3924",
        },
        {
          id: "43059",
          name: "Lindsay",
          state_id: "3924",
        },
        {
          id: "43060",
          name: "Live Oak",
          state_id: "3924",
        },
        {
          id: "43061",
          name: "Livermore",
          state_id: "3924",
        },
        {
          id: "43062",
          name: "Livingston",
          state_id: "3924",
        },
        {
          id: "43063",
          name: "Lodi",
          state_id: "3924",
        },
        {
          id: "43064",
          name: "Loma Linda",
          state_id: "3924",
        },
        {
          id: "43065",
          name: "Lomita",
          state_id: "3924",
        },
        {
          id: "43066",
          name: "Lompoc",
          state_id: "3924",
        },
        {
          id: "43067",
          name: "Long Beach",
          state_id: "3924",
        },
        {
          id: "43068",
          name: "Los Alamitos",
          state_id: "3924",
        },
        {
          id: "43069",
          name: "Los Altos",
          state_id: "3924",
        },
        {
          id: "43070",
          name: "Los Angeles",
          state_id: "3924",
        },
        {
          id: "43071",
          name: "Los Angeles East",
          state_id: "3924",
        },
        {
          id: "43072",
          name: "Los Banos",
          state_id: "3924",
        },
        {
          id: "43073",
          name: "Los Gatos",
          state_id: "3924",
        },
        {
          id: "43074",
          name: "Los Olivos",
          state_id: "3924",
        },
        {
          id: "43075",
          name: "Lynwood",
          state_id: "3924",
        },
        {
          id: "43076",
          name: "MacKinleyville",
          state_id: "3924",
        },
        {
          id: "43077",
          name: "Madera",
          state_id: "3924",
        },
        {
          id: "43078",
          name: "Magalia",
          state_id: "3924",
        },
        {
          id: "43079",
          name: "Malibu",
          state_id: "3924",
        },
        {
          id: "43080",
          name: "Mammoth Lakes",
          state_id: "3924",
        },
        {
          id: "43081",
          name: "Manhattan Beach",
          state_id: "3924",
        },
        {
          id: "43082",
          name: "Manteca",
          state_id: "3924",
        },
        {
          id: "43083",
          name: "Marina",
          state_id: "3924",
        },
        {
          id: "43084",
          name: "Marina del Rey",
          state_id: "3924",
        },
        {
          id: "43085",
          name: "Mariposa",
          state_id: "3924",
        },
        {
          id: "43086",
          name: "Marshall",
          state_id: "3924",
        },
        {
          id: "43087",
          name: "Martinez",
          state_id: "3924",
        },
        {
          id: "43088",
          name: "Marysville",
          state_id: "3924",
        },
        {
          id: "43089",
          name: "Maywood",
          state_id: "3924",
        },
        {
          id: "43090",
          name: "Menlo Park",
          state_id: "3924",
        },
        {
          id: "43091",
          name: "Merced",
          state_id: "3924",
        },
        {
          id: "43092",
          name: "Middletown",
          state_id: "3924",
        },
        {
          id: "43093",
          name: "Midway City",
          state_id: "3924",
        },
        {
          id: "43094",
          name: "Mill Valley",
          state_id: "3924",
        },
        {
          id: "43095",
          name: "Millbrae",
          state_id: "3924",
        },
        {
          id: "43096",
          name: "Milpitas",
          state_id: "3924",
        },
        {
          id: "43097",
          name: "Mira Loma",
          state_id: "3924",
        },
        {
          id: "43098",
          name: "Miranda",
          state_id: "3924",
        },
        {
          id: "43099",
          name: "Mission Viejo",
          state_id: "3924",
        },
        {
          id: "43100",
          name: "Modesto",
          state_id: "3924",
        },
        {
          id: "43101",
          name: "Monclair",
          state_id: "3924",
        },
        {
          id: "43102",
          name: "Monrovia",
          state_id: "3924",
        },
        {
          id: "43103",
          name: "Montara",
          state_id: "3924",
        },
        {
          id: "43104",
          name: "Montclair",
          state_id: "3924",
        },
        {
          id: "43105",
          name: "Montebello",
          state_id: "3924",
        },
        {
          id: "43106",
          name: "Montecito",
          state_id: "3924",
        },
        {
          id: "43107",
          name: "Monterey",
          state_id: "3924",
        },
        {
          id: "43108",
          name: "Monterey Park",
          state_id: "3924",
        },
        {
          id: "43109",
          name: "Moorpark",
          state_id: "3924",
        },
        {
          id: "43110",
          name: "Moraga Town",
          state_id: "3924",
        },
        {
          id: "43111",
          name: "Moreno Valley",
          state_id: "3924",
        },
        {
          id: "43112",
          name: "Morgan Hill",
          state_id: "3924",
        },
        {
          id: "43113",
          name: "Morro Bay",
          state_id: "3924",
        },
        {
          id: "43114",
          name: "Moss Beach",
          state_id: "3924",
        },
        {
          id: "43115",
          name: "Mount Shasta",
          state_id: "3924",
        },
        {
          id: "43116",
          name: "Mountain View",
          state_id: "3924",
        },
        {
          id: "43117",
          name: "Murrieta",
          state_id: "3924",
        },
        {
          id: "43118",
          name: "N. Hollywood",
          state_id: "3924",
        },
        {
          id: "43119",
          name: "Napa",
          state_id: "3924",
        },
        {
          id: "43120",
          name: "National City",
          state_id: "3924",
        },
        {
          id: "43121",
          name: "Nevada City",
          state_id: "3924",
        },
        {
          id: "43122",
          name: "Newark",
          state_id: "3924",
        },
        {
          id: "43123",
          name: "Newport Beach",
          state_id: "3924",
        },
        {
          id: "43124",
          name: "Norco",
          state_id: "3924",
        },
        {
          id: "43125",
          name: "North Auburn",
          state_id: "3924",
        },
        {
          id: "43126",
          name: "North Fair Oaks",
          state_id: "3924",
        },
        {
          id: "43127",
          name: "North Fork",
          state_id: "3924",
        },
        {
          id: "43128",
          name: "North Highlands",
          state_id: "3924",
        },
        {
          id: "43129",
          name: "North Hills",
          state_id: "3924",
        },
        {
          id: "43130",
          name: "North Hollywood",
          state_id: "3924",
        },
        {
          id: "43131",
          name: "Northridge",
          state_id: "3924",
        },
        {
          id: "43132",
          name: "Norwalk",
          state_id: "3924",
        },
        {
          id: "43133",
          name: "Novato",
          state_id: "3924",
        },
        {
          id: "43134",
          name: "Nuevo",
          state_id: "3924",
        },
        {
          id: "43135",
          name: "Oak View",
          state_id: "3924",
        },
        {
          id: "43136",
          name: "Oakdale",
          state_id: "3924",
        },
        {
          id: "43137",
          name: "Oakhurst",
          state_id: "3924",
        },
        {
          id: "43138",
          name: "Oakland",
          state_id: "3924",
        },
        {
          id: "43139",
          name: "Oakley",
          state_id: "3924",
        },
        {
          id: "43140",
          name: "Oceanside",
          state_id: "3924",
        },
        {
          id: "43141",
          name: "Oildale",
          state_id: "3924",
        },
        {
          id: "43142",
          name: "Ojai",
          state_id: "3924",
        },
        {
          id: "43143",
          name: "Olivehurst",
          state_id: "3924",
        },
        {
          id: "43144",
          name: "Ontario",
          state_id: "3924",
        },
        {
          id: "43145",
          name: "Orange",
          state_id: "3924",
        },
        {
          id: "43146",
          name: "Orangevale",
          state_id: "3924",
        },
        {
          id: "43147",
          name: "Orcutt",
          state_id: "3924",
        },
        {
          id: "43148",
          name: "Oregon House",
          state_id: "3924",
        },
        {
          id: "43149",
          name: "Orinda",
          state_id: "3924",
        },
        {
          id: "43150",
          name: "Oroville",
          state_id: "3924",
        },
        {
          id: "43151",
          name: "Oxnard",
          state_id: "3924",
        },
        {
          id: "43152",
          name: "Pacific Grove",
          state_id: "3924",
        },
        {
          id: "43153",
          name: "Pacific Palisades",
          state_id: "3924",
        },
        {
          id: "43154",
          name: "Pacifica",
          state_id: "3924",
        },
        {
          id: "43155",
          name: "Pacoima",
          state_id: "3924",
        },
        {
          id: "43156",
          name: "Pajaro",
          state_id: "3924",
        },
        {
          id: "43157",
          name: "Palm Desert",
          state_id: "3924",
        },
        {
          id: "43158",
          name: "Palm Springs",
          state_id: "3924",
        },
        {
          id: "43159",
          name: "Palmdale",
          state_id: "3924",
        },
        {
          id: "43160",
          name: "Palo Alto",
          state_id: "3924",
        },
        {
          id: "43161",
          name: "Palos Verdes Estates",
          state_id: "3924",
        },
        {
          id: "43162",
          name: "Pamona",
          state_id: "3924",
        },
        {
          id: "43163",
          name: "Panorama City",
          state_id: "3924",
        },
        {
          id: "43164",
          name: "Paradise",
          state_id: "3924",
        },
        {
          id: "43165",
          name: "Paramount",
          state_id: "3924",
        },
        {
          id: "43166",
          name: "Parkway-South Sacramento",
          state_id: "3924",
        },
        {
          id: "43167",
          name: "Parlier",
          state_id: "3924",
        },
        {
          id: "43168",
          name: "Pasadena",
          state_id: "3924",
        },
        {
          id: "43169",
          name: "Patterson",
          state_id: "3924",
        },
        {
          id: "43170",
          name: "Pedley",
          state_id: "3924",
        },
        {
          id: "43171",
          name: "Perris",
          state_id: "3924",
        },
        {
          id: "43172",
          name: "Petaluma",
          state_id: "3924",
        },
        {
          id: "43173",
          name: "Pico Rivera",
          state_id: "3924",
        },
        {
          id: "43174",
          name: "Piedmont",
          state_id: "3924",
        },
        {
          id: "43175",
          name: "Pinole",
          state_id: "3924",
        },
        {
          id: "43176",
          name: "Pismo Beach",
          state_id: "3924",
        },
        {
          id: "43177",
          name: "Pittsburg",
          state_id: "3924",
        },
        {
          id: "43178",
          name: "Placentia",
          state_id: "3924",
        },
        {
          id: "43179",
          name: "Placerville",
          state_id: "3924",
        },
        {
          id: "43180",
          name: "Playa del Rey",
          state_id: "3924",
        },
        {
          id: "43181",
          name: "Pleasant Hill",
          state_id: "3924",
        },
        {
          id: "43182",
          name: "Pleasanton",
          state_id: "3924",
        },
        {
          id: "43183",
          name: "Plymouth",
          state_id: "3924",
        },
        {
          id: "43184",
          name: "Point Reyes Station",
          state_id: "3924",
        },
        {
          id: "43185",
          name: "Pollock Pines",
          state_id: "3924",
        },
        {
          id: "43186",
          name: "Pomona",
          state_id: "3924",
        },
        {
          id: "43187",
          name: "Port Costa",
          state_id: "3924",
        },
        {
          id: "43188",
          name: "Port Hueneme",
          state_id: "3924",
        },
        {
          id: "43189",
          name: "Porterville",
          state_id: "3924",
        },
        {
          id: "43190",
          name: "Poway",
          state_id: "3924",
        },
        {
          id: "43191",
          name: "Quartz Hill",
          state_id: "3924",
        },
        {
          id: "43192",
          name: "Ramona",
          state_id: "3924",
        },
        {
          id: "43193",
          name: "Rancho Cordova",
          state_id: "3924",
        },
        {
          id: "43194",
          name: "Rancho Cucamonga",
          state_id: "3924",
        },
        {
          id: "43195",
          name: "Rancho Dominguez",
          state_id: "3924",
        },
        {
          id: "43196",
          name: "Rancho Mirage",
          state_id: "3924",
        },
        {
          id: "43197",
          name: "Rancho Murieta",
          state_id: "3924",
        },
        {
          id: "43198",
          name: "Rancho Palos Verdes",
          state_id: "3924",
        },
        {
          id: "43199",
          name: "Rancho San Diego",
          state_id: "3924",
        },
        {
          id: "43200",
          name: "Rancho Santa Margarita",
          state_id: "3924",
        },
        {
          id: "43201",
          name: "Red Bluff",
          state_id: "3924",
        },
        {
          id: "43202",
          name: "Redding",
          state_id: "3924",
        },
        {
          id: "43203",
          name: "Redlands",
          state_id: "3924",
        },
        {
          id: "43204",
          name: "Redondo Beach",
          state_id: "3924",
        },
        {
          id: "43205",
          name: "Redway",
          state_id: "3924",
        },
        {
          id: "43206",
          name: "Redwood City",
          state_id: "3924",
        },
        {
          id: "43207",
          name: "Reedley",
          state_id: "3924",
        },
        {
          id: "43208",
          name: "Reseda",
          state_id: "3924",
        },
        {
          id: "43209",
          name: "Rialto",
          state_id: "3924",
        },
        {
          id: "43210",
          name: "Richmond",
          state_id: "3924",
        },
        {
          id: "43211",
          name: "Ridgecrest",
          state_id: "3924",
        },
        {
          id: "43212",
          name: "Rio Linda",
          state_id: "3924",
        },
        {
          id: "43213",
          name: "Rio Nido",
          state_id: "3924",
        },
        {
          id: "43214",
          name: "Rio del Mar",
          state_id: "3924",
        },
        {
          id: "43215",
          name: "Riverbank",
          state_id: "3924",
        },
        {
          id: "43216",
          name: "Riverside",
          state_id: "3924",
        },
        {
          id: "43217",
          name: "Rocklin",
          state_id: "3924",
        },
        {
          id: "43218",
          name: "Rohnert Park",
          state_id: "3924",
        },
        {
          id: "43219",
          name: "Rolling Hills",
          state_id: "3924",
        },
        {
          id: "43220",
          name: "Rosamond",
          state_id: "3924",
        },
        {
          id: "43221",
          name: "Roseland",
          state_id: "3924",
        },
        {
          id: "43222",
          name: "Rosemead",
          state_id: "3924",
        },
        {
          id: "43223",
          name: "Rosemont",
          state_id: "3924",
        },
        {
          id: "43224",
          name: "Roseville",
          state_id: "3924",
        },
        {
          id: "43225",
          name: "Rossmoor",
          state_id: "3924",
        },
        {
          id: "43226",
          name: "Rowland Heights",
          state_id: "3924",
        },
        {
          id: "43227",
          name: "Rubidoux",
          state_id: "3924",
        },
        {
          id: "43228",
          name: "Sacramento",
          state_id: "3924",
        },
        {
          id: "43229",
          name: "Salinas",
          state_id: "3924",
        },
        {
          id: "43230",
          name: "San Anselmo",
          state_id: "3924",
        },
        {
          id: "43231",
          name: "San Bernardino",
          state_id: "3924",
        },
        {
          id: "43232",
          name: "San Bruno",
          state_id: "3924",
        },
        {
          id: "43233",
          name: "San Buenaventura",
          state_id: "3924",
        },
        {
          id: "43234",
          name: "San Carlos",
          state_id: "3924",
        },
        {
          id: "43235",
          name: "San Clemente",
          state_id: "3924",
        },
        {
          id: "43236",
          name: "San Diego",
          state_id: "3924",
        },
        {
          id: "43237",
          name: "San Dimas",
          state_id: "3924",
        },
        {
          id: "43238",
          name: "San Fernando",
          state_id: "3924",
        },
        {
          id: "43239",
          name: "San Francisco",
          state_id: "3924",
        },
        {
          id: "43240",
          name: "San Gabriel",
          state_id: "3924",
        },
        {
          id: "43241",
          name: "San Jacinto",
          state_id: "3924",
        },
        {
          id: "43242",
          name: "San Jose",
          state_id: "3924",
        },
        {
          id: "43243",
          name: "San Juan Capistrano",
          state_id: "3924",
        },
        {
          id: "43244",
          name: "San Leandro",
          state_id: "3924",
        },
        {
          id: "43245",
          name: "San Lorenzo",
          state_id: "3924",
        },
        {
          id: "43246",
          name: "San Luis Obispo",
          state_id: "3924",
        },
        {
          id: "43247",
          name: "San Marcos",
          state_id: "3924",
        },
        {
          id: "43248",
          name: "San Marino",
          state_id: "3924",
        },
        {
          id: "43249",
          name: "San Mateo",
          state_id: "3924",
        },
        {
          id: "43250",
          name: "San Pablo",
          state_id: "3924",
        },
        {
          id: "43251",
          name: "San Pedro",
          state_id: "3924",
        },
        {
          id: "43252",
          name: "San Rafael",
          state_id: "3924",
        },
        {
          id: "43253",
          name: "San Ramon",
          state_id: "3924",
        },
        {
          id: "43254",
          name: "San Ysidro",
          state_id: "3924",
        },
        {
          id: "43255",
          name: "Sanger",
          state_id: "3924",
        },
        {
          id: "43256",
          name: "Santa Ana",
          state_id: "3924",
        },
        {
          id: "43257",
          name: "Santa Barbara",
          state_id: "3924",
        },
        {
          id: "43258",
          name: "Santa Clara",
          state_id: "3924",
        },
        {
          id: "43259",
          name: "Santa Clarita",
          state_id: "3924",
        },
        {
          id: "43260",
          name: "Santa Cruz",
          state_id: "3924",
        },
        {
          id: "43261",
          name: "Santa Fe Springs",
          state_id: "3924",
        },
        {
          id: "43262",
          name: "Santa Maria",
          state_id: "3924",
        },
        {
          id: "43263",
          name: "Santa Monica",
          state_id: "3924",
        },
        {
          id: "43264",
          name: "Santa Paula",
          state_id: "3924",
        },
        {
          id: "43265",
          name: "Santa Rosa",
          state_id: "3924",
        },
        {
          id: "43266",
          name: "Santa Ynez",
          state_id: "3924",
        },
        {
          id: "43267",
          name: "Santee",
          state_id: "3924",
        },
        {
          id: "43268",
          name: "Saratoga",
          state_id: "3924",
        },
        {
          id: "43269",
          name: "Sausalito",
          state_id: "3924",
        },
        {
          id: "43270",
          name: "Scotts Valley",
          state_id: "3924",
        },
        {
          id: "43271",
          name: "Seal Beach",
          state_id: "3924",
        },
        {
          id: "43272",
          name: "Seaside",
          state_id: "3924",
        },
        {
          id: "43273",
          name: "Sebastopol",
          state_id: "3924",
        },
        {
          id: "43274",
          name: "Selma",
          state_id: "3924",
        },
        {
          id: "43275",
          name: "Shafter",
          state_id: "3924",
        },
        {
          id: "43276",
          name: "Sherman Oaks",
          state_id: "3924",
        },
        {
          id: "43277",
          name: "Sierra Madre",
          state_id: "3924",
        },
        {
          id: "43278",
          name: "Signal Hill",
          state_id: "3924",
        },
        {
          id: "43279",
          name: "Simi Valley",
          state_id: "3924",
        },
        {
          id: "43280",
          name: "Solana Beach",
          state_id: "3924",
        },
        {
          id: "43281",
          name: "Soledad",
          state_id: "3924",
        },
        {
          id: "43282",
          name: "Solvang",
          state_id: "3924",
        },
        {
          id: "43283",
          name: "Sonoma",
          state_id: "3924",
        },
        {
          id: "43284",
          name: "Sonora",
          state_id: "3924",
        },
        {
          id: "43285",
          name: "Soquel",
          state_id: "3924",
        },
        {
          id: "43286",
          name: "South El Monte",
          state_id: "3924",
        },
        {
          id: "43287",
          name: "South Gate",
          state_id: "3924",
        },
        {
          id: "43288",
          name: "South Lake Tahoe",
          state_id: "3924",
        },
        {
          id: "43289",
          name: "South Pasadena",
          state_id: "3924",
        },
        {
          id: "43290",
          name: "South San Francisco",
          state_id: "3924",
        },
        {
          id: "43291",
          name: "South San Jose Hills",
          state_id: "3924",
        },
        {
          id: "43292",
          name: "South Whittier",
          state_id: "3924",
        },
        {
          id: "43293",
          name: "South Yuba City",
          state_id: "3924",
        },
        {
          id: "43294",
          name: "Spring Valley",
          state_id: "3924",
        },
        {
          id: "43295",
          name: "St. Helena",
          state_id: "3924",
        },
        {
          id: "43296",
          name: "Stanford",
          state_id: "3924",
        },
        {
          id: "43297",
          name: "Stanton",
          state_id: "3924",
        },
        {
          id: "43298",
          name: "Stevenson Ranch",
          state_id: "3924",
        },
        {
          id: "43299",
          name: "Stockton",
          state_id: "3924",
        },
        {
          id: "43300",
          name: "Strathmore",
          state_id: "3924",
        },
        {
          id: "43301",
          name: "Studio City",
          state_id: "3924",
        },
        {
          id: "43302",
          name: "Suisun City",
          state_id: "3924",
        },
        {
          id: "43303",
          name: "Sun City",
          state_id: "3924",
        },
        {
          id: "43304",
          name: "Sun Valley",
          state_id: "3924",
        },
        {
          id: "43305",
          name: "Sunland",
          state_id: "3924",
        },
        {
          id: "43306",
          name: "Sunnyvale",
          state_id: "3924",
        },
        {
          id: "43307",
          name: "Susanville",
          state_id: "3924",
        },
        {
          id: "43308",
          name: "Sutter",
          state_id: "3924",
        },
        {
          id: "43309",
          name: "Sylmar",
          state_id: "3924",
        },
        {
          id: "43310",
          name: "Tahoe City",
          state_id: "3924",
        },
        {
          id: "43311",
          name: "Tamalpais-Homestead Valley",
          state_id: "3924",
        },
        {
          id: "43312",
          name: "Tarzana",
          state_id: "3924",
        },
        {
          id: "43313",
          name: "Tehachapi",
          state_id: "3924",
        },
        {
          id: "43314",
          name: "Temecula",
          state_id: "3924",
        },
        {
          id: "43315",
          name: "Temple City",
          state_id: "3924",
        },
        {
          id: "43316",
          name: "Thousand Oaks",
          state_id: "3924",
        },
        {
          id: "43317",
          name: "Tiburon",
          state_id: "3924",
        },
        {
          id: "43318",
          name: "Topanga",
          state_id: "3924",
        },
        {
          id: "43319",
          name: "Torrance",
          state_id: "3924",
        },
        {
          id: "43320",
          name: "Trabuco Canyon",
          state_id: "3924",
        },
        {
          id: "43321",
          name: "Tracy",
          state_id: "3924",
        },
        {
          id: "43322",
          name: "Trinidad",
          state_id: "3924",
        },
        {
          id: "43323",
          name: "Trona",
          state_id: "3924",
        },
        {
          id: "43324",
          name: "Truckee",
          state_id: "3924",
        },
        {
          id: "43325",
          name: "Tujunga",
          state_id: "3924",
        },
        {
          id: "43326",
          name: "Tulare",
          state_id: "3924",
        },
        {
          id: "43327",
          name: "Turlock",
          state_id: "3924",
        },
        {
          id: "43328",
          name: "Tustin",
          state_id: "3924",
        },
        {
          id: "43329",
          name: "Tustin Foothills",
          state_id: "3924",
        },
        {
          id: "43330",
          name: "Twentynine Palms",
          state_id: "3924",
        },
        {
          id: "43331",
          name: "Twentynine Palms Base",
          state_id: "3924",
        },
        {
          id: "43332",
          name: "Ukiah",
          state_id: "3924",
        },
        {
          id: "43333",
          name: "Union City",
          state_id: "3924",
        },
        {
          id: "43334",
          name: "Upland",
          state_id: "3924",
        },
        {
          id: "43335",
          name: "Vacaville",
          state_id: "3924",
        },
        {
          id: "43336",
          name: "Valencia",
          state_id: "3924",
        },
        {
          id: "43337",
          name: "Valinda",
          state_id: "3924",
        },
        {
          id: "43338",
          name: "Valle Vista",
          state_id: "3924",
        },
        {
          id: "43339",
          name: "Vallejo",
          state_id: "3924",
        },
        {
          id: "43340",
          name: "Valley Center",
          state_id: "3924",
        },
        {
          id: "43341",
          name: "Valley Glen",
          state_id: "3924",
        },
        {
          id: "43342",
          name: "Valley Village",
          state_id: "3924",
        },
        {
          id: "43343",
          name: "Van Nuys",
          state_id: "3924",
        },
        {
          id: "43344",
          name: "Vandenberg Air Force Base",
          state_id: "3924",
        },
        {
          id: "43345",
          name: "Venice",
          state_id: "3924",
        },
        {
          id: "43346",
          name: "Ventura",
          state_id: "3924",
        },
        {
          id: "43347",
          name: "Vernon",
          state_id: "3924",
        },
        {
          id: "43348",
          name: "Victorville",
          state_id: "3924",
        },
        {
          id: "43349",
          name: "View Park-Windsor Hills",
          state_id: "3924",
        },
        {
          id: "43350",
          name: "Vincent",
          state_id: "3924",
        },
        {
          id: "43351",
          name: "Visalia",
          state_id: "3924",
        },
        {
          id: "43352",
          name: "Vista",
          state_id: "3924",
        },
        {
          id: "43353",
          name: "Walnut",
          state_id: "3924",
        },
        {
          id: "43354",
          name: "Walnut Creek",
          state_id: "3924",
        },
        {
          id: "43355",
          name: "Walnut Park",
          state_id: "3924",
        },
        {
          id: "43356",
          name: "Wasco",
          state_id: "3924",
        },
        {
          id: "43357",
          name: "Waterford",
          state_id: "3924",
        },
        {
          id: "43358",
          name: "Watsonville",
          state_id: "3924",
        },
        {
          id: "43359",
          name: "West Athens",
          state_id: "3924",
        },
        {
          id: "43360",
          name: "West Carson",
          state_id: "3924",
        },
        {
          id: "43361",
          name: "West Covina",
          state_id: "3924",
        },
        {
          id: "43362",
          name: "West Hills",
          state_id: "3924",
        },
        {
          id: "43363",
          name: "West Hollywood",
          state_id: "3924",
        },
        {
          id: "43364",
          name: "West Puente Valley",
          state_id: "3924",
        },
        {
          id: "43365",
          name: "West Sacramento",
          state_id: "3924",
        },
        {
          id: "43366",
          name: "West Whittier-Los Nietos",
          state_id: "3924",
        },
        {
          id: "43367",
          name: "Westlake Village",
          state_id: "3924",
        },
        {
          id: "43368",
          name: "Westminster",
          state_id: "3924",
        },
        {
          id: "43369",
          name: "Westmont",
          state_id: "3924",
        },
        {
          id: "43370",
          name: "Whittier",
          state_id: "3924",
        },
        {
          id: "43371",
          name: "Wildomar",
          state_id: "3924",
        },
        {
          id: "43372",
          name: "Willits",
          state_id: "3924",
        },
        {
          id: "43373",
          name: "Willowbrook",
          state_id: "3924",
        },
        {
          id: "43374",
          name: "Wilmington",
          state_id: "3924",
        },
        {
          id: "43375",
          name: "Windsor",
          state_id: "3924",
        },
        {
          id: "43376",
          name: "Woodland",
          state_id: "3924",
        },
        {
          id: "43377",
          name: "Woodland Hills",
          state_id: "3924",
        },
        {
          id: "43378",
          name: "Yorba Linda",
          state_id: "3924",
        },
        {
          id: "43379",
          name: "Yreka",
          state_id: "3924",
        },
        {
          id: "43380",
          name: "Yuba City",
          state_id: "3924",
        },
        {
          id: "43381",
          name: "Yucaipa",
          state_id: "3924",
        },
        {
          id: "43382",
          name: "Yucca Valley",
          state_id: "3924",
        },
      ],
      Colorado: [
        {
          id: "43383",
          name: "Air Force Academy",
          state_id: "3926",
        },
        {
          id: "43384",
          name: "Alamosa",
          state_id: "3926",
        },
        {
          id: "43385",
          name: "Applewood",
          state_id: "3926",
        },
        {
          id: "43386",
          name: "Arvada",
          state_id: "3926",
        },
        {
          id: "43387",
          name: "Aspen",
          state_id: "3926",
        },
        {
          id: "43388",
          name: "Aurora",
          state_id: "3926",
        },
        {
          id: "43389",
          name: "Avon",
          state_id: "3926",
        },
        {
          id: "43390",
          name: "Basalt",
          state_id: "3926",
        },
        {
          id: "43391",
          name: "Bellvue",
          state_id: "3926",
        },
        {
          id: "43392",
          name: "Black Forest",
          state_id: "3926",
        },
        {
          id: "43393",
          name: "Boulder",
          state_id: "3926",
        },
        {
          id: "43394",
          name: "Brighton",
          state_id: "3926",
        },
        {
          id: "43395",
          name: "Broomfield",
          state_id: "3926",
        },
        {
          id: "43396",
          name: "Canon City",
          state_id: "3926",
        },
        {
          id: "43397",
          name: "Carbondale",
          state_id: "3926",
        },
        {
          id: "43398",
          name: "Castle Rock",
          state_id: "3926",
        },
        {
          id: "43399",
          name: "Castlewood",
          state_id: "3926",
        },
        {
          id: "43400",
          name: "Centennial",
          state_id: "3926",
        },
        {
          id: "43401",
          name: "Cimarron Hills",
          state_id: "3926",
        },
        {
          id: "43402",
          name: "Clifton",
          state_id: "3926",
        },
        {
          id: "43403",
          name: "Colorado Springs",
          state_id: "3926",
        },
        {
          id: "43404",
          name: "Columbine",
          state_id: "3926",
        },
        {
          id: "43405",
          name: "Commerce City",
          state_id: "3926",
        },
        {
          id: "43406",
          name: "Cortez",
          state_id: "3926",
        },
        {
          id: "43407",
          name: "Crawford",
          state_id: "3926",
        },
        {
          id: "43408",
          name: "Denver",
          state_id: "3926",
        },
        {
          id: "43409",
          name: "Durango",
          state_id: "3926",
        },
        {
          id: "43410",
          name: "Edwards",
          state_id: "3926",
        },
        {
          id: "43411",
          name: "Elizabeth",
          state_id: "3926",
        },
        {
          id: "43412",
          name: "Englewood",
          state_id: "3926",
        },
        {
          id: "43413",
          name: "Estes Park",
          state_id: "3926",
        },
        {
          id: "43414",
          name: "Evergreen",
          state_id: "3926",
        },
        {
          id: "43415",
          name: "Federal Heights",
          state_id: "3926",
        },
        {
          id: "43416",
          name: "Fort Carson",
          state_id: "3926",
        },
        {
          id: "43417",
          name: "Fort Collins",
          state_id: "3926",
        },
        {
          id: "43418",
          name: "Fort Morgan",
          state_id: "3926",
        },
        {
          id: "43419",
          name: "Fountain",
          state_id: "3926",
        },
        {
          id: "43420",
          name: "Golden",
          state_id: "3926",
        },
        {
          id: "43421",
          name: "Grand Junction",
          state_id: "3926",
        },
        {
          id: "43422",
          name: "Greeley",
          state_id: "3926",
        },
        {
          id: "43423",
          name: "Greenwood Village",
          state_id: "3926",
        },
        {
          id: "43424",
          name: "Gunbarrel",
          state_id: "3926",
        },
        {
          id: "43425",
          name: "Highlands Ranch",
          state_id: "3926",
        },
        {
          id: "43426",
          name: "Holly",
          state_id: "3926",
        },
        {
          id: "43427",
          name: "Ken Caryl",
          state_id: "3926",
        },
        {
          id: "43428",
          name: "Lafayette",
          state_id: "3926",
        },
        {
          id: "43429",
          name: "Lakewood",
          state_id: "3926",
        },
        {
          id: "43430",
          name: "Littleton",
          state_id: "3926",
        },
        {
          id: "43431",
          name: "Longmont",
          state_id: "3926",
        },
        {
          id: "43432",
          name: "Louisville",
          state_id: "3926",
        },
        {
          id: "43433",
          name: "Loveland",
          state_id: "3926",
        },
        {
          id: "43434",
          name: "Lyons",
          state_id: "3926",
        },
        {
          id: "43435",
          name: "Montrose",
          state_id: "3926",
        },
        {
          id: "43436",
          name: "Monument",
          state_id: "3926",
        },
        {
          id: "43437",
          name: "Nederland",
          state_id: "3926",
        },
        {
          id: "43438",
          name: "Niwot",
          state_id: "3926",
        },
        {
          id: "43439",
          name: "Northglenn",
          state_id: "3926",
        },
        {
          id: "43440",
          name: "Pagosa Springs",
          state_id: "3926",
        },
        {
          id: "43441",
          name: "Parker",
          state_id: "3926",
        },
        {
          id: "43442",
          name: "Penrose",
          state_id: "3926",
        },
        {
          id: "43443",
          name: "Peyton",
          state_id: "3926",
        },
        {
          id: "43444",
          name: "Pueblo",
          state_id: "3926",
        },
        {
          id: "43445",
          name: "Redlands",
          state_id: "3926",
        },
        {
          id: "43446",
          name: "Ridgway",
          state_id: "3926",
        },
        {
          id: "43447",
          name: "Rifle",
          state_id: "3926",
        },
        {
          id: "43448",
          name: "Rocky Ford",
          state_id: "3926",
        },
        {
          id: "43449",
          name: "Sanford",
          state_id: "3926",
        },
        {
          id: "43450",
          name: "Security-Widefield",
          state_id: "3926",
        },
        {
          id: "43451",
          name: "Sherrelwood",
          state_id: "3926",
        },
        {
          id: "43452",
          name: "Silver Cliff",
          state_id: "3926",
        },
        {
          id: "43453",
          name: "Snowmass Village",
          state_id: "3926",
        },
        {
          id: "43454",
          name: "Southglenn",
          state_id: "3926",
        },
        {
          id: "43455",
          name: "Steamboat Springs",
          state_id: "3926",
        },
        {
          id: "43456",
          name: "Sterling",
          state_id: "3926",
        },
        {
          id: "43457",
          name: "Superior",
          state_id: "3926",
        },
        {
          id: "43458",
          name: "Telluride",
          state_id: "3926",
        },
        {
          id: "43459",
          name: "Thornton",
          state_id: "3926",
        },
        {
          id: "43460",
          name: "Vail",
          state_id: "3926",
        },
        {
          id: "43461",
          name: "Welby",
          state_id: "3926",
        },
        {
          id: "43462",
          name: "Westcliffe",
          state_id: "3926",
        },
        {
          id: "43463",
          name: "Westminster",
          state_id: "3926",
        },
        {
          id: "43464",
          name: "Wheat Ridge",
          state_id: "3926",
        },
        {
          id: "43465",
          name: "Woodland Park",
          state_id: "3926",
        },
      ],
      Connecticut: [
        {
          id: "43466",
          name: "Ansonia",
          state_id: "3927",
        },
        {
          id: "43467",
          name: "Avon",
          state_id: "3927",
        },
        {
          id: "43468",
          name: "Bethel",
          state_id: "3927",
        },
        {
          id: "43469",
          name: "Bethlehem",
          state_id: "3927",
        },
        {
          id: "43470",
          name: "Bloomfield",
          state_id: "3927",
        },
        {
          id: "43471",
          name: "Branford",
          state_id: "3927",
        },
        {
          id: "43472",
          name: "Bridgeport",
          state_id: "3927",
        },
        {
          id: "43473",
          name: "Bristol",
          state_id: "3927",
        },
        {
          id: "43474",
          name: "Canaan",
          state_id: "3927",
        },
        {
          id: "43475",
          name: "Canton",
          state_id: "3927",
        },
        {
          id: "43476",
          name: "Central Manchester",
          state_id: "3927",
        },
        {
          id: "43477",
          name: "Cheshire",
          state_id: "3927",
        },
        {
          id: "43478",
          name: "Colchester",
          state_id: "3927",
        },
        {
          id: "43479",
          name: "Conning Towers-Nautilus Park",
          state_id: "3927",
        },
        {
          id: "43480",
          name: "Coscob",
          state_id: "3927",
        },
        {
          id: "43481",
          name: "Cranbury",
          state_id: "3927",
        },
        {
          id: "43482",
          name: "Cromwell",
          state_id: "3927",
        },
        {
          id: "43483",
          name: "Danbury",
          state_id: "3927",
        },
        {
          id: "43484",
          name: "Darien",
          state_id: "3927",
        },
        {
          id: "43485",
          name: "Dayville",
          state_id: "3927",
        },
        {
          id: "43486",
          name: "Derby",
          state_id: "3927",
        },
        {
          id: "43487",
          name: "East Hartford",
          state_id: "3927",
        },
        {
          id: "43488",
          name: "East Haven",
          state_id: "3927",
        },
        {
          id: "43489",
          name: "Ellington",
          state_id: "3927",
        },
        {
          id: "43490",
          name: "Enfield",
          state_id: "3927",
        },
        {
          id: "43491",
          name: "Fairfield",
          state_id: "3927",
        },
        {
          id: "43492",
          name: "Farmington",
          state_id: "3927",
        },
        {
          id: "43493",
          name: "Glastonbury",
          state_id: "3927",
        },
        {
          id: "43494",
          name: "Greens Farms",
          state_id: "3927",
        },
        {
          id: "43495",
          name: "Greenwich",
          state_id: "3927",
        },
        {
          id: "43496",
          name: "Groton",
          state_id: "3927",
        },
        {
          id: "43497",
          name: "Guilford",
          state_id: "3927",
        },
        {
          id: "43498",
          name: "Haddam",
          state_id: "3927",
        },
        {
          id: "43499",
          name: "Hamden",
          state_id: "3927",
        },
        {
          id: "43500",
          name: "Hartford",
          state_id: "3927",
        },
        {
          id: "43501",
          name: "Harwinton",
          state_id: "3927",
        },
        {
          id: "43502",
          name: "Lakeville",
          state_id: "3927",
        },
        {
          id: "43503",
          name: "Lyme",
          state_id: "3927",
        },
        {
          id: "43504",
          name: "Madison",
          state_id: "3927",
        },
        {
          id: "43505",
          name: "Manchester",
          state_id: "3927",
        },
        {
          id: "43506",
          name: "Meriden",
          state_id: "3927",
        },
        {
          id: "43507",
          name: "Middletown",
          state_id: "3927",
        },
        {
          id: "43508",
          name: "Milford",
          state_id: "3927",
        },
        {
          id: "43509",
          name: "Monroe",
          state_id: "3927",
        },
        {
          id: "43510",
          name: "Mystic",
          state_id: "3927",
        },
        {
          id: "43511",
          name: "Naugatuck",
          state_id: "3927",
        },
        {
          id: "43512",
          name: "New Britain",
          state_id: "3927",
        },
        {
          id: "43513",
          name: "New Canaan",
          state_id: "3927",
        },
        {
          id: "43514",
          name: "New Hartford",
          state_id: "3927",
        },
        {
          id: "43515",
          name: "New Haven",
          state_id: "3927",
        },
        {
          id: "43516",
          name: "New London",
          state_id: "3927",
        },
        {
          id: "43517",
          name: "New Milford",
          state_id: "3927",
        },
        {
          id: "43518",
          name: "New Town",
          state_id: "3927",
        },
        {
          id: "43519",
          name: "Newington",
          state_id: "3927",
        },
        {
          id: "43520",
          name: "North Haven",
          state_id: "3927",
        },
        {
          id: "43521",
          name: "North Stonington",
          state_id: "3927",
        },
        {
          id: "43522",
          name: "Norwalk",
          state_id: "3927",
        },
        {
          id: "43523",
          name: "Norwich",
          state_id: "3927",
        },
        {
          id: "43524",
          name: "Old Saybrook",
          state_id: "3927",
        },
        {
          id: "43525",
          name: "Oneco",
          state_id: "3927",
        },
        {
          id: "43526",
          name: "Orange",
          state_id: "3927",
        },
        {
          id: "43527",
          name: "Pawcatuck",
          state_id: "3927",
        },
        {
          id: "43528",
          name: "Plainville",
          state_id: "3927",
        },
        {
          id: "43529",
          name: "Portland",
          state_id: "3927",
        },
        {
          id: "43530",
          name: "Putnam",
          state_id: "3927",
        },
        {
          id: "43531",
          name: "Riverside",
          state_id: "3927",
        },
        {
          id: "43532",
          name: "Rocky Hill",
          state_id: "3927",
        },
        {
          id: "43533",
          name: "Rowayton",
          state_id: "3927",
        },
        {
          id: "43534",
          name: "Sandy Hook",
          state_id: "3927",
        },
        {
          id: "43535",
          name: "Seymour",
          state_id: "3927",
        },
        {
          id: "43536",
          name: "Sharon",
          state_id: "3927",
        },
        {
          id: "43537",
          name: "Shelton",
          state_id: "3927",
        },
        {
          id: "43538",
          name: "South Windsor",
          state_id: "3927",
        },
        {
          id: "43539",
          name: "Southington",
          state_id: "3927",
        },
        {
          id: "43540",
          name: "Southport",
          state_id: "3927",
        },
        {
          id: "43541",
          name: "Stamford",
          state_id: "3927",
        },
        {
          id: "43542",
          name: "Sterling",
          state_id: "3927",
        },
        {
          id: "43543",
          name: "Storrs",
          state_id: "3927",
        },
        {
          id: "43544",
          name: "Stratford",
          state_id: "3927",
        },
        {
          id: "43545",
          name: "Suffield",
          state_id: "3927",
        },
        {
          id: "43546",
          name: "Taftville",
          state_id: "3927",
        },
        {
          id: "43547",
          name: "Terryville",
          state_id: "3927",
        },
        {
          id: "43548",
          name: "Tolland",
          state_id: "3927",
        },
        {
          id: "43549",
          name: "Torrington",
          state_id: "3927",
        },
        {
          id: "43550",
          name: "Trumbull",
          state_id: "3927",
        },
        {
          id: "43551",
          name: "Vernon",
          state_id: "3927",
        },
        {
          id: "43552",
          name: "Wallingford Center",
          state_id: "3927",
        },
        {
          id: "43553",
          name: "Waterbury",
          state_id: "3927",
        },
        {
          id: "43554",
          name: "Watertown",
          state_id: "3927",
        },
        {
          id: "43555",
          name: "West Hartford",
          state_id: "3927",
        },
        {
          id: "43556",
          name: "West Haven",
          state_id: "3927",
        },
        {
          id: "43557",
          name: "Weston",
          state_id: "3927",
        },
        {
          id: "43558",
          name: "Westport",
          state_id: "3927",
        },
        {
          id: "43559",
          name: "Wethersfield",
          state_id: "3927",
        },
        {
          id: "43560",
          name: "Willimantic",
          state_id: "3927",
        },
        {
          id: "43561",
          name: "Wilton",
          state_id: "3927",
        },
        {
          id: "43562",
          name: "Windsor",
          state_id: "3927",
        },
        {
          id: "43563",
          name: "Windsor Locks",
          state_id: "3927",
        },
        {
          id: "43564",
          name: "Winsted",
          state_id: "3927",
        },
        {
          id: "43565",
          name: "Woodbury",
          state_id: "3927",
        },
        {
          id: "43566",
          name: "Woodstock",
          state_id: "3927",
        },
        {
          id: "43567",
          name: "pomfret",
          state_id: "3927",
        },
      ],
      Delaware: [
        {
          id: "43568",
          name: "Bear",
          state_id: "3928",
        },
        {
          id: "43569",
          name: "Brookside",
          state_id: "3928",
        },
        {
          id: "43570",
          name: "Claymont",
          state_id: "3928",
        },
        {
          id: "43571",
          name: "Dover",
          state_id: "3928",
        },
        {
          id: "43572",
          name: "Dover Base Housing",
          state_id: "3928",
        },
        {
          id: "43573",
          name: "Edgemoor",
          state_id: "3928",
        },
        {
          id: "43574",
          name: "Elsmere",
          state_id: "3928",
        },
        {
          id: "43575",
          name: "Georgetown",
          state_id: "3928",
        },
        {
          id: "43576",
          name: "Greenville",
          state_id: "3928",
        },
        {
          id: "43577",
          name: "Middletown",
          state_id: "3928",
        },
        {
          id: "43578",
          name: "Milford",
          state_id: "3928",
        },
        {
          id: "43579",
          name: "Milton",
          state_id: "3928",
        },
        {
          id: "43580",
          name: "Newark",
          state_id: "3928",
        },
        {
          id: "43581",
          name: "Pike Creek",
          state_id: "3928",
        },
        {
          id: "43582",
          name: "Seaford",
          state_id: "3928",
        },
        {
          id: "43583",
          name: "Smyrna",
          state_id: "3928",
        },
        {
          id: "43584",
          name: "Stanton",
          state_id: "3928",
        },
        {
          id: "43585",
          name: "Talleyville",
          state_id: "3928",
        },
        {
          id: "43586",
          name: "Wilmington",
          state_id: "3928",
        },
        {
          id: "43587",
          name: "Wilmington Manor",
          state_id: "3928",
        },
      ],
      "District of Columbia": [],
      Florida: [
        {
          id: "43588",
          name: "Alachua",
          state_id: "3930",
        },
        {
          id: "43589",
          name: "Altamonte Springs",
          state_id: "3930",
        },
        {
          id: "43590",
          name: "Apopka",
          state_id: "3930",
        },
        {
          id: "43591",
          name: "Atlantic Beach",
          state_id: "3930",
        },
        {
          id: "43592",
          name: "Auburndale",
          state_id: "3930",
        },
        {
          id: "43593",
          name: "Aventura",
          state_id: "3930",
        },
        {
          id: "43594",
          name: "Avon Park",
          state_id: "3930",
        },
        {
          id: "43595",
          name: "Azalea Park",
          state_id: "3930",
        },
        {
          id: "43596",
          name: "Bal Harbour",
          state_id: "3930",
        },
        {
          id: "43597",
          name: "Bartow",
          state_id: "3930",
        },
        {
          id: "43598",
          name: "Bayonet Point",
          state_id: "3930",
        },
        {
          id: "43599",
          name: "Bayshore Gardens",
          state_id: "3930",
        },
        {
          id: "43600",
          name: "Beach",
          state_id: "3930",
        },
        {
          id: "43601",
          name: "Bellair-Meadowbrook Terrace",
          state_id: "3930",
        },
        {
          id: "43602",
          name: "Belle Glade",
          state_id: "3930",
        },
        {
          id: "43603",
          name: "Bellview",
          state_id: "3930",
        },
        {
          id: "43604",
          name: "Beverly Hills",
          state_id: "3930",
        },
        {
          id: "43605",
          name: "Bloomingdale",
          state_id: "3930",
        },
        {
          id: "43606",
          name: "Boca Raton",
          state_id: "3930",
        },
        {
          id: "43607",
          name: "Boca del Mar",
          state_id: "3930",
        },
        {
          id: "43608",
          name: "Bonita Springs",
          state_id: "3930",
        },
        {
          id: "43609",
          name: "Boynton Beach",
          state_id: "3930",
        },
        {
          id: "43610",
          name: "Bradenton",
          state_id: "3930",
        },
        {
          id: "43611",
          name: "Brandon",
          state_id: "3930",
        },
        {
          id: "43612",
          name: "Brent",
          state_id: "3930",
        },
        {
          id: "43613",
          name: "Brooksville",
          state_id: "3930",
        },
        {
          id: "43614",
          name: "Brownsville",
          state_id: "3930",
        },
        {
          id: "43615",
          name: "Buena Ventura Lakes",
          state_id: "3930",
        },
        {
          id: "43616",
          name: "Bunnell",
          state_id: "3930",
        },
        {
          id: "43617",
          name: "Callaway",
          state_id: "3930",
        },
        {
          id: "43618",
          name: "Cape Coral",
          state_id: "3930",
        },
        {
          id: "43619",
          name: "Carol City",
          state_id: "3930",
        },
        {
          id: "43620",
          name: "Casselberry",
          state_id: "3930",
        },
        {
          id: "43621",
          name: "Catalina Foothills",
          state_id: "3930",
        },
        {
          id: "43622",
          name: "Celebration",
          state_id: "3930",
        },
        {
          id: "43623",
          name: "Century Village",
          state_id: "3930",
        },
        {
          id: "43624",
          name: "Citrus Park",
          state_id: "3930",
        },
        {
          id: "43625",
          name: "Clearwater",
          state_id: "3930",
        },
        {
          id: "43626",
          name: "Clermont",
          state_id: "3930",
        },
        {
          id: "43627",
          name: "Cocoa",
          state_id: "3930",
        },
        {
          id: "43628",
          name: "Cocoa Beach",
          state_id: "3930",
        },
        {
          id: "43629",
          name: "Coconut Creek",
          state_id: "3930",
        },
        {
          id: "43630",
          name: "Coconut Grove",
          state_id: "3930",
        },
        {
          id: "43631",
          name: "Conway",
          state_id: "3930",
        },
        {
          id: "43632",
          name: "Cooper City",
          state_id: "3930",
        },
        {
          id: "43633",
          name: "Coral Gables",
          state_id: "3930",
        },
        {
          id: "43634",
          name: "Coral Springs",
          state_id: "3930",
        },
        {
          id: "43635",
          name: "Coral Terrace",
          state_id: "3930",
        },
        {
          id: "43636",
          name: "Cortlandt Manor",
          state_id: "3930",
        },
        {
          id: "43637",
          name: "Country Club",
          state_id: "3930",
        },
        {
          id: "43638",
          name: "Crestview",
          state_id: "3930",
        },
        {
          id: "43639",
          name: "Crystal River",
          state_id: "3930",
        },
        {
          id: "43640",
          name: "Cutler",
          state_id: "3930",
        },
        {
          id: "43641",
          name: "Cutler Ridge",
          state_id: "3930",
        },
        {
          id: "43642",
          name: "Cypress Gardens",
          state_id: "3930",
        },
        {
          id: "43643",
          name: "Cypress Lake",
          state_id: "3930",
        },
        {
          id: "43644",
          name: "Dania",
          state_id: "3930",
        },
        {
          id: "43645",
          name: "Dania Beach",
          state_id: "3930",
        },
        {
          id: "43646",
          name: "Davie",
          state_id: "3930",
        },
        {
          id: "43647",
          name: "Daytona Beach",
          state_id: "3930",
        },
        {
          id: "43648",
          name: "De Bary",
          state_id: "3930",
        },
        {
          id: "43649",
          name: "De Funiak Springs",
          state_id: "3930",
        },
        {
          id: "43650",
          name: "De Land",
          state_id: "3930",
        },
        {
          id: "43651",
          name: "Debary",
          state_id: "3930",
        },
        {
          id: "43652",
          name: "Deer Park",
          state_id: "3930",
        },
        {
          id: "43653",
          name: "Deerfield Beach",
          state_id: "3930",
        },
        {
          id: "43654",
          name: "Del Rio",
          state_id: "3930",
        },
        {
          id: "43655",
          name: "Delray Beach",
          state_id: "3930",
        },
        {
          id: "43656",
          name: "Deltona",
          state_id: "3930",
        },
        {
          id: "43657",
          name: "Destin",
          state_id: "3930",
        },
        {
          id: "43658",
          name: "Doctor Phillips",
          state_id: "3930",
        },
        {
          id: "43659",
          name: "Dora",
          state_id: "3930",
        },
        {
          id: "43660",
          name: "Doral",
          state_id: "3930",
        },
        {
          id: "43661",
          name: "Dundee",
          state_id: "3930",
        },
        {
          id: "43662",
          name: "Dunedin",
          state_id: "3930",
        },
        {
          id: "43663",
          name: "East Lake",
          state_id: "3930",
        },
        {
          id: "43664",
          name: "Edgewater",
          state_id: "3930",
        },
        {
          id: "43665",
          name: "Eglin Air Force Base",
          state_id: "3930",
        },
        {
          id: "43666",
          name: "Egypt Lake-Leto",
          state_id: "3930",
        },
        {
          id: "43667",
          name: "Elfers",
          state_id: "3930",
        },
        {
          id: "43668",
          name: "Englewood",
          state_id: "3930",
        },
        {
          id: "43669",
          name: "Ensley",
          state_id: "3930",
        },
        {
          id: "43670",
          name: "Eustis",
          state_id: "3930",
        },
        {
          id: "43671",
          name: "Fairview Shores",
          state_id: "3930",
        },
        {
          id: "43672",
          name: "Fern Park",
          state_id: "3930",
        },
        {
          id: "43673",
          name: "Fernandina Beach",
          state_id: "3930",
        },
        {
          id: "43674",
          name: "Ferry Pass",
          state_id: "3930",
        },
        {
          id: "43675",
          name: "Flagler Beach",
          state_id: "3930",
        },
        {
          id: "43676",
          name: "Floral City",
          state_id: "3930",
        },
        {
          id: "43677",
          name: "Florida City",
          state_id: "3930",
        },
        {
          id: "43678",
          name: "Florida Ridge",
          state_id: "3930",
        },
        {
          id: "43679",
          name: "Forest City",
          state_id: "3930",
        },
        {
          id: "43680",
          name: "Fort Lauderdale",
          state_id: "3930",
        },
        {
          id: "43681",
          name: "Fort Myers",
          state_id: "3930",
        },
        {
          id: "43682",
          name: "Fort Myers Beach",
          state_id: "3930",
        },
        {
          id: "43683",
          name: "Fort Pierce",
          state_id: "3930",
        },
        {
          id: "43684",
          name: "Fort Walton Beach",
          state_id: "3930",
        },
        {
          id: "43685",
          name: "Freeport",
          state_id: "3930",
        },
        {
          id: "43686",
          name: "Fruitville",
          state_id: "3930",
        },
        {
          id: "43687",
          name: "Ft. Lauderdale",
          state_id: "3930",
        },
        {
          id: "43688",
          name: "Gainesville",
          state_id: "3930",
        },
        {
          id: "43689",
          name: "Gladeview",
          state_id: "3930",
        },
        {
          id: "43690",
          name: "Glenvar Heights",
          state_id: "3930",
        },
        {
          id: "43691",
          name: "Golden Gate",
          state_id: "3930",
        },
        {
          id: "43692",
          name: "Golden Glades",
          state_id: "3930",
        },
        {
          id: "43693",
          name: "Goldenrod",
          state_id: "3930",
        },
        {
          id: "43694",
          name: "Greater Carrollwood",
          state_id: "3930",
        },
        {
          id: "43695",
          name: "Greater Northdale",
          state_id: "3930",
        },
        {
          id: "43696",
          name: "Green Cove Springs",
          state_id: "3930",
        },
        {
          id: "43697",
          name: "Greenacres",
          state_id: "3930",
        },
        {
          id: "43698",
          name: "Gulf Gate Estates",
          state_id: "3930",
        },
        {
          id: "43699",
          name: "Gulfport",
          state_id: "3930",
        },
        {
          id: "43700",
          name: "Haines City",
          state_id: "3930",
        },
        {
          id: "43701",
          name: "Hallandale",
          state_id: "3930",
        },
        {
          id: "43702",
          name: "Hallandale Beach",
          state_id: "3930",
        },
        {
          id: "43703",
          name: "Hammocks",
          state_id: "3930",
        },
        {
          id: "43704",
          name: "Hamptons at Boca Raton",
          state_id: "3930",
        },
        {
          id: "43705",
          name: "Havana",
          state_id: "3930",
        },
        {
          id: "43706",
          name: "Hialeah",
          state_id: "3930",
        },
        {
          id: "43707",
          name: "Hialeah Gardens",
          state_id: "3930",
        },
        {
          id: "43708",
          name: "Highpoint",
          state_id: "3930",
        },
        {
          id: "43709",
          name: "Hobe Sound",
          state_id: "3930",
        },
        {
          id: "43710",
          name: "Holiday",
          state_id: "3930",
        },
        {
          id: "43711",
          name: "Holly Hill",
          state_id: "3930",
        },
        {
          id: "43712",
          name: "Hollywood",
          state_id: "3930",
        },
        {
          id: "43713",
          name: "Homestead",
          state_id: "3930",
        },
        {
          id: "43714",
          name: "Homosassa",
          state_id: "3930",
        },
        {
          id: "43715",
          name: "Hudson",
          state_id: "3930",
        },
        {
          id: "43716",
          name: "Immokalee",
          state_id: "3930",
        },
        {
          id: "43717",
          name: "Inverness",
          state_id: "3930",
        },
        {
          id: "43718",
          name: "Iona",
          state_id: "3930",
        },
        {
          id: "43719",
          name: "Ives Estates",
          state_id: "3930",
        },
        {
          id: "43720",
          name: "Jacksonville",
          state_id: "3930",
        },
        {
          id: "43721",
          name: "Jacksonville Beach",
          state_id: "3930",
        },
        {
          id: "43722",
          name: "Jasmine Estates",
          state_id: "3930",
        },
        {
          id: "43723",
          name: "Jensen Beach",
          state_id: "3930",
        },
        {
          id: "43724",
          name: "Jupiter",
          state_id: "3930",
        },
        {
          id: "43725",
          name: "Kendale Lakes",
          state_id: "3930",
        },
        {
          id: "43726",
          name: "Kendall",
          state_id: "3930",
        },
        {
          id: "43727",
          name: "Kendall West",
          state_id: "3930",
        },
        {
          id: "43728",
          name: "Key Biscayne",
          state_id: "3930",
        },
        {
          id: "43729",
          name: "Key Largo",
          state_id: "3930",
        },
        {
          id: "43730",
          name: "Key West",
          state_id: "3930",
        },
        {
          id: "43731",
          name: "Kings Point",
          state_id: "3930",
        },
        {
          id: "43732",
          name: "Kissimmee",
          state_id: "3930",
        },
        {
          id: "43733",
          name: "Lady Lake",
          state_id: "3930",
        },
        {
          id: "43734",
          name: "Lake Alfred",
          state_id: "3930",
        },
        {
          id: "43735",
          name: "Lake City",
          state_id: "3930",
        },
        {
          id: "43736",
          name: "Lake Lucerne",
          state_id: "3930",
        },
        {
          id: "43737",
          name: "Lake Magdalene",
          state_id: "3930",
        },
        {
          id: "43738",
          name: "Lake Mary",
          state_id: "3930",
        },
        {
          id: "43739",
          name: "Lake Placid",
          state_id: "3930",
        },
        {
          id: "43740",
          name: "Lake Wales",
          state_id: "3930",
        },
        {
          id: "43741",
          name: "Lake Worth",
          state_id: "3930",
        },
        {
          id: "43742",
          name: "Lakeland",
          state_id: "3930",
        },
        {
          id: "43743",
          name: "Lakeland Highlands",
          state_id: "3930",
        },
        {
          id: "43744",
          name: "Lakeside",
          state_id: "3930",
        },
        {
          id: "43745",
          name: "Land O''Lakes",
          state_id: "3930",
        },
        {
          id: "43746",
          name: "Largo",
          state_id: "3930",
        },
        {
          id: "43747",
          name: "Lauderdale Lakes",
          state_id: "3930",
        },
        {
          id: "43748",
          name: "Lauderhill",
          state_id: "3930",
        },
        {
          id: "43749",
          name: "Laurel",
          state_id: "3930",
        },
        {
          id: "43750",
          name: "Lecanto",
          state_id: "3930",
        },
        {
          id: "43751",
          name: "Leesburg",
          state_id: "3930",
        },
        {
          id: "43752",
          name: "Lehigh Acres",
          state_id: "3930",
        },
        {
          id: "43753",
          name: "Leisure City",
          state_id: "3930",
        },
        {
          id: "43754",
          name: "Lighthouse Point",
          state_id: "3930",
        },
        {
          id: "43755",
          name: "Lockhart",
          state_id: "3930",
        },
        {
          id: "43756",
          name: "Longwood",
          state_id: "3930",
        },
        {
          id: "43757",
          name: "Loxahatchee",
          state_id: "3930",
        },
        {
          id: "43758",
          name: "Lutz",
          state_id: "3930",
        },
        {
          id: "43759",
          name: "Lynn Haven",
          state_id: "3930",
        },
        {
          id: "43760",
          name: "Madison",
          state_id: "3930",
        },
        {
          id: "43761",
          name: "Maitland",
          state_id: "3930",
        },
        {
          id: "43762",
          name: "Mango",
          state_id: "3930",
        },
        {
          id: "43763",
          name: "Marathon",
          state_id: "3930",
        },
        {
          id: "43764",
          name: "Marco",
          state_id: "3930",
        },
        {
          id: "43765",
          name: "Margate",
          state_id: "3930",
        },
        {
          id: "43766",
          name: "Medley",
          state_id: "3930",
        },
        {
          id: "43767",
          name: "Melbourne",
          state_id: "3930",
        },
        {
          id: "43768",
          name: "Merritt Island",
          state_id: "3930",
        },
        {
          id: "43769",
          name: "Miami",
          state_id: "3930",
        },
        {
          id: "43770",
          name: "Miami Beach",
          state_id: "3930",
        },
        {
          id: "43771",
          name: "Miami Gardens",
          state_id: "3930",
        },
        {
          id: "43772",
          name: "Miami Lakes",
          state_id: "3930",
        },
        {
          id: "43773",
          name: "Miami Shores",
          state_id: "3930",
        },
        {
          id: "43774",
          name: "Miami Springs",
          state_id: "3930",
        },
        {
          id: "43775",
          name: "Micco",
          state_id: "3930",
        },
        {
          id: "43776",
          name: "Milton",
          state_id: "3930",
        },
        {
          id: "43777",
          name: "Mims",
          state_id: "3930",
        },
        {
          id: "43778",
          name: "Miramar",
          state_id: "3930",
        },
        {
          id: "43779",
          name: "Mulberry",
          state_id: "3930",
        },
        {
          id: "43780",
          name: "Myrtle Grove",
          state_id: "3930",
        },
        {
          id: "43781",
          name: "Naples",
          state_id: "3930",
        },
        {
          id: "43782",
          name: "Naples Park",
          state_id: "3930",
        },
        {
          id: "43783",
          name: "Naranja",
          state_id: "3930",
        },
        {
          id: "43784",
          name: "New Port Richey",
          state_id: "3930",
        },
        {
          id: "43785",
          name: "New Port Richey East",
          state_id: "3930",
        },
        {
          id: "43786",
          name: "New Smyrna Beach",
          state_id: "3930",
        },
        {
          id: "43787",
          name: "Niceville",
          state_id: "3930",
        },
        {
          id: "43788",
          name: "Nokomis",
          state_id: "3930",
        },
        {
          id: "43789",
          name: "Norland",
          state_id: "3930",
        },
        {
          id: "43790",
          name: "North Andrews Gardens",
          state_id: "3930",
        },
        {
          id: "43791",
          name: "North Fort Myers",
          state_id: "3930",
        },
        {
          id: "43792",
          name: "North Lauderdale",
          state_id: "3930",
        },
        {
          id: "43793",
          name: "North Miami",
          state_id: "3930",
        },
        {
          id: "43794",
          name: "North Miami Beach",
          state_id: "3930",
        },
        {
          id: "43795",
          name: "North Naples",
          state_id: "3930",
        },
        {
          id: "43796",
          name: "North Palm Beach",
          state_id: "3930",
        },
        {
          id: "43797",
          name: "North Port",
          state_id: "3930",
        },
        {
          id: "43798",
          name: "Oak Ridge",
          state_id: "3930",
        },
        {
          id: "43799",
          name: "Oakland Park",
          state_id: "3930",
        },
        {
          id: "43800",
          name: "Ocala",
          state_id: "3930",
        },
        {
          id: "43801",
          name: "Ocoee",
          state_id: "3930",
        },
        {
          id: "43802",
          name: "Ojus",
          state_id: "3930",
        },
        {
          id: "43803",
          name: "Okeechobee",
          state_id: "3930",
        },
        {
          id: "43804",
          name: "Oldsmar",
          state_id: "3930",
        },
        {
          id: "43805",
          name: "Olympia Heights",
          state_id: "3930",
        },
        {
          id: "43806",
          name: "Opa-locka",
          state_id: "3930",
        },
        {
          id: "43807",
          name: "Orange City",
          state_id: "3930",
        },
        {
          id: "43808",
          name: "Orange Park",
          state_id: "3930",
        },
        {
          id: "43809",
          name: "Orlando",
          state_id: "3930",
        },
        {
          id: "43810",
          name: "Ormond Beach",
          state_id: "3930",
        },
        {
          id: "43811",
          name: "Ormond-by-the-Sea",
          state_id: "3930",
        },
        {
          id: "43812",
          name: "Osprey",
          state_id: "3930",
        },
        {
          id: "43813",
          name: "Oviedo",
          state_id: "3930",
        },
        {
          id: "43814",
          name: "Palatka",
          state_id: "3930",
        },
        {
          id: "43815",
          name: "Palm Bay",
          state_id: "3930",
        },
        {
          id: "43816",
          name: "Palm Beach",
          state_id: "3930",
        },
        {
          id: "43817",
          name: "Palm Beach Gardens",
          state_id: "3930",
        },
        {
          id: "43818",
          name: "Palm City",
          state_id: "3930",
        },
        {
          id: "43819",
          name: "Palm Coast",
          state_id: "3930",
        },
        {
          id: "43820",
          name: "Palm Harbor",
          state_id: "3930",
        },
        {
          id: "43821",
          name: "Palm River-Clair Mel",
          state_id: "3930",
        },
        {
          id: "43822",
          name: "Palm Valley",
          state_id: "3930",
        },
        {
          id: "43823",
          name: "Palmetto",
          state_id: "3930",
        },
        {
          id: "43824",
          name: "Palmetto Estates",
          state_id: "3930",
        },
        {
          id: "43825",
          name: "Panama City",
          state_id: "3930",
        },
        {
          id: "43826",
          name: "Parkland",
          state_id: "3930",
        },
        {
          id: "43827",
          name: "Pembroke Park",
          state_id: "3930",
        },
        {
          id: "43828",
          name: "Pembroke Pines",
          state_id: "3930",
        },
        {
          id: "43829",
          name: "Pensacola",
          state_id: "3930",
        },
        {
          id: "43830",
          name: "Perrine",
          state_id: "3930",
        },
        {
          id: "43831",
          name: "Pine Castle",
          state_id: "3930",
        },
        {
          id: "43832",
          name: "Pine Hills",
          state_id: "3930",
        },
        {
          id: "43833",
          name: "Pinellas Park",
          state_id: "3930",
        },
        {
          id: "43834",
          name: "Pinewood",
          state_id: "3930",
        },
        {
          id: "43835",
          name: "Plant City",
          state_id: "3930",
        },
        {
          id: "43836",
          name: "Plantation",
          state_id: "3930",
        },
        {
          id: "43837",
          name: "Pompano Beach",
          state_id: "3930",
        },
        {
          id: "43838",
          name: "Pompano Beach Highlands",
          state_id: "3930",
        },
        {
          id: "43839",
          name: "Ponte Vedra",
          state_id: "3930",
        },
        {
          id: "43840",
          name: "Port Charlotte",
          state_id: "3930",
        },
        {
          id: "43841",
          name: "Port Orange",
          state_id: "3930",
        },
        {
          id: "43842",
          name: "Port Saint John",
          state_id: "3930",
        },
        {
          id: "43843",
          name: "Port Saint Lucie",
          state_id: "3930",
        },
        {
          id: "43844",
          name: "Punta Gorda",
          state_id: "3930",
        },
        {
          id: "43845",
          name: "Quincy",
          state_id: "3930",
        },
        {
          id: "43846",
          name: "Redington Shores",
          state_id: "3930",
        },
        {
          id: "43847",
          name: "Richmond Heights",
          state_id: "3930",
        },
        {
          id: "43848",
          name: "Richmond West",
          state_id: "3930",
        },
        {
          id: "43849",
          name: "Riverview",
          state_id: "3930",
        },
        {
          id: "43850",
          name: "Riviera Beach",
          state_id: "3930",
        },
        {
          id: "43851",
          name: "Rockledge",
          state_id: "3930",
        },
        {
          id: "43852",
          name: "Royal Palm Beach",
          state_id: "3930",
        },
        {
          id: "43853",
          name: "Safety Harbor",
          state_id: "3930",
        },
        {
          id: "43854",
          name: "Saint Augustine",
          state_id: "3930",
        },
        {
          id: "43855",
          name: "Saint Cloud",
          state_id: "3930",
        },
        {
          id: "43856",
          name: "Saint Petersburg",
          state_id: "3930",
        },
        {
          id: "43857",
          name: "Saint Petersburg Beach",
          state_id: "3930",
        },
        {
          id: "43858",
          name: "San Carlos Park",
          state_id: "3930",
        },
        {
          id: "43859",
          name: "Sandalfoot Cove",
          state_id: "3930",
        },
        {
          id: "43860",
          name: "Sanford",
          state_id: "3930",
        },
        {
          id: "43861",
          name: "Sanibel",
          state_id: "3930",
        },
        {
          id: "43862",
          name: "Sarasota",
          state_id: "3930",
        },
        {
          id: "43863",
          name: "Sarasota Springs",
          state_id: "3930",
        },
        {
          id: "43864",
          name: "Satellite Beach",
          state_id: "3930",
        },
        {
          id: "43865",
          name: "Scott Lake",
          state_id: "3930",
        },
        {
          id: "43866",
          name: "Sebastian",
          state_id: "3930",
        },
        {
          id: "43867",
          name: "Seminole",
          state_id: "3930",
        },
        {
          id: "43868",
          name: "Shalimar",
          state_id: "3930",
        },
        {
          id: "43869",
          name: "South Bradenton",
          state_id: "3930",
        },
        {
          id: "43870",
          name: "South Daytona",
          state_id: "3930",
        },
        {
          id: "43871",
          name: "South Miami",
          state_id: "3930",
        },
        {
          id: "43872",
          name: "South Miami Heights",
          state_id: "3930",
        },
        {
          id: "43873",
          name: "South Patrick Shores",
          state_id: "3930",
        },
        {
          id: "43874",
          name: "South Venice",
          state_id: "3930",
        },
        {
          id: "43875",
          name: "Spring Hill",
          state_id: "3930",
        },
        {
          id: "43876",
          name: "Stuart",
          state_id: "3930",
        },
        {
          id: "43878",
          name: "Sunny Isles",
          state_id: "3930",
        },
        {
          id: "43879",
          name: "Sunrise",
          state_id: "3930",
        },
        {
          id: "43880",
          name: "Sunset",
          state_id: "3930",
        },
        {
          id: "43881",
          name: "Sweetwater",
          state_id: "3930",
        },
        {
          id: "43882",
          name: "Tallahassee",
          state_id: "3930",
        },
        {
          id: "43883",
          name: "Tamarac",
          state_id: "3930",
        },
        {
          id: "43884",
          name: "Tamiami",
          state_id: "3930",
        },
        {
          id: "43885",
          name: "Tampa",
          state_id: "3930",
        },
        {
          id: "43886",
          name: "Tarpon Springs",
          state_id: "3930",
        },
        {
          id: "43887",
          name: "Temple Terrace",
          state_id: "3930",
        },
        {
          id: "43888",
          name: "The Crossings",
          state_id: "3930",
        },
        {
          id: "43889",
          name: "The Hammocks",
          state_id: "3930",
        },
        {
          id: "43890",
          name: "Titusville",
          state_id: "3930",
        },
        {
          id: "43891",
          name: "Town''n''Country",
          state_id: "3930",
        },
        {
          id: "43892",
          name: "University",
          state_id: "3930",
        },
        {
          id: "43893",
          name: "University Park",
          state_id: "3930",
        },
        {
          id: "43894",
          name: "Valrico",
          state_id: "3930",
        },
        {
          id: "43895",
          name: "Venice",
          state_id: "3930",
        },
        {
          id: "43896",
          name: "Vero Beach",
          state_id: "3930",
        },
        {
          id: "43897",
          name: "Vero Beach South",
          state_id: "3930",
        },
        {
          id: "43898",
          name: "Villas",
          state_id: "3930",
        },
        {
          id: "43899",
          name: "Warrington",
          state_id: "3930",
        },
        {
          id: "43900",
          name: "Wekiva Springs",
          state_id: "3930",
        },
        {
          id: "43901",
          name: "Wellington",
          state_id: "3930",
        },
        {
          id: "43902",
          name: "Wesley Chapel",
          state_id: "3930",
        },
        {
          id: "43903",
          name: "West Little River",
          state_id: "3930",
        },
        {
          id: "43904",
          name: "West Palm Beach",
          state_id: "3930",
        },
        {
          id: "43905",
          name: "West Park",
          state_id: "3930",
        },
        {
          id: "43906",
          name: "West Pensacola",
          state_id: "3930",
        },
        {
          id: "43907",
          name: "West and East Lealman",
          state_id: "3930",
        },
        {
          id: "43908",
          name: "Westchester",
          state_id: "3930",
        },
        {
          id: "43909",
          name: "Weston",
          state_id: "3930",
        },
        {
          id: "43910",
          name: "Westview",
          state_id: "3930",
        },
        {
          id: "43911",
          name: "Westwood Lakes",
          state_id: "3930",
        },
        {
          id: "43912",
          name: "Wilton Manors",
          state_id: "3930",
        },
        {
          id: "43913",
          name: "Windermere",
          state_id: "3930",
        },
        {
          id: "43914",
          name: "Winston",
          state_id: "3930",
        },
        {
          id: "43915",
          name: "Winter Garden",
          state_id: "3930",
        },
        {
          id: "43916",
          name: "Winter Haven",
          state_id: "3930",
        },
        {
          id: "43917",
          name: "Winter Park",
          state_id: "3930",
        },
        {
          id: "43918",
          name: "Winter Springs",
          state_id: "3930",
        },
        {
          id: "43919",
          name: "Wright",
          state_id: "3930",
        },
        {
          id: "43920",
          name: "Yeehaw Junction",
          state_id: "3930",
        },
      ],
      Georgia: [
        {
          id: "43921",
          name: "Acworth",
          state_id: "3931",
        },
        {
          id: "43922",
          name: "Adel",
          state_id: "3931",
        },
        {
          id: "43923",
          name: "Albany",
          state_id: "3931",
        },
        {
          id: "43924",
          name: "Alma",
          state_id: "3931",
        },
        {
          id: "43925",
          name: "Alpharetta",
          state_id: "3931",
        },
        {
          id: "43926",
          name: "Americus",
          state_id: "3931",
        },
        {
          id: "43927",
          name: "Athens",
          state_id: "3931",
        },
        {
          id: "43928",
          name: "Athens-Clarke",
          state_id: "3931",
        },
        {
          id: "43929",
          name: "Atlanta",
          state_id: "3931",
        },
        {
          id: "43930",
          name: "Auburn",
          state_id: "3931",
        },
        {
          id: "43931",
          name: "Augusta-Richmond",
          state_id: "3931",
        },
        {
          id: "43932",
          name: "Austell",
          state_id: "3931",
        },
        {
          id: "43933",
          name: "Bainbridge",
          state_id: "3931",
        },
        {
          id: "43934",
          name: "Barnesville",
          state_id: "3931",
        },
        {
          id: "43935",
          name: "Belvedere Park",
          state_id: "3931",
        },
        {
          id: "43936",
          name: "Bogart",
          state_id: "3931",
        },
        {
          id: "43937",
          name: "Bowdon",
          state_id: "3931",
        },
        {
          id: "43938",
          name: "Braselton",
          state_id: "3931",
        },
        {
          id: "43939",
          name: "Brunswick",
          state_id: "3931",
        },
        {
          id: "43940",
          name: "Buford",
          state_id: "3931",
        },
        {
          id: "43941",
          name: "Byron",
          state_id: "3931",
        },
        {
          id: "43942",
          name: "Cairo",
          state_id: "3931",
        },
        {
          id: "43943",
          name: "Calhoun",
          state_id: "3931",
        },
        {
          id: "43944",
          name: "Candler-MacAfee",
          state_id: "3931",
        },
        {
          id: "43945",
          name: "Canton",
          state_id: "3931",
        },
        {
          id: "43946",
          name: "Carrollton",
          state_id: "3931",
        },
        {
          id: "43947",
          name: "Cartersville",
          state_id: "3931",
        },
        {
          id: "43948",
          name: "Chamblee",
          state_id: "3931",
        },
        {
          id: "43949",
          name: "Clarkston",
          state_id: "3931",
        },
        {
          id: "43950",
          name: "Cochran",
          state_id: "3931",
        },
        {
          id: "43951",
          name: "College Park",
          state_id: "3931",
        },
        {
          id: "43952",
          name: "Columbus",
          state_id: "3931",
        },
        {
          id: "43953",
          name: "Comer",
          state_id: "3931",
        },
        {
          id: "43954",
          name: "Conley",
          state_id: "3931",
        },
        {
          id: "43955",
          name: "Conyers",
          state_id: "3931",
        },
        {
          id: "43956",
          name: "Cordele",
          state_id: "3931",
        },
        {
          id: "43957",
          name: "Covington",
          state_id: "3931",
        },
        {
          id: "43958",
          name: "Culloden",
          state_id: "3931",
        },
        {
          id: "43959",
          name: "Cumming",
          state_id: "3931",
        },
        {
          id: "43960",
          name: "Dacula",
          state_id: "3931",
        },
        {
          id: "43961",
          name: "Dahlonega",
          state_id: "3931",
        },
        {
          id: "43962",
          name: "Dallas",
          state_id: "3931",
        },
        {
          id: "43963",
          name: "Dalton",
          state_id: "3931",
        },
        {
          id: "43964",
          name: "Decatur",
          state_id: "3931",
        },
        {
          id: "43965",
          name: "Dewy Rose",
          state_id: "3931",
        },
        {
          id: "43966",
          name: "Doraville",
          state_id: "3931",
        },
        {
          id: "43967",
          name: "Douglas",
          state_id: "3931",
        },
        {
          id: "43968",
          name: "Douglasville",
          state_id: "3931",
        },
        {
          id: "43969",
          name: "Druid Hills",
          state_id: "3931",
        },
        {
          id: "43970",
          name: "Dublin",
          state_id: "3931",
        },
        {
          id: "43971",
          name: "Duluth",
          state_id: "3931",
        },
        {
          id: "43972",
          name: "Dunwoody",
          state_id: "3931",
        },
        {
          id: "43973",
          name: "East Point",
          state_id: "3931",
        },
        {
          id: "43974",
          name: "Elberton",
          state_id: "3931",
        },
        {
          id: "43975",
          name: "Ellenwood",
          state_id: "3931",
        },
        {
          id: "43976",
          name: "Ellijay",
          state_id: "3931",
        },
        {
          id: "43977",
          name: "Evans",
          state_id: "3931",
        },
        {
          id: "43978",
          name: "Fairmount",
          state_id: "3931",
        },
        {
          id: "43979",
          name: "Fayetteville",
          state_id: "3931",
        },
        {
          id: "43980",
          name: "Flowery Branch",
          state_id: "3931",
        },
        {
          id: "43981",
          name: "Folkston",
          state_id: "3931",
        },
        {
          id: "43982",
          name: "Forest Park",
          state_id: "3931",
        },
        {
          id: "43983",
          name: "Fort Benning South",
          state_id: "3931",
        },
        {
          id: "43984",
          name: "Fort Gordon",
          state_id: "3931",
        },
        {
          id: "43985",
          name: "Fort Stewart",
          state_id: "3931",
        },
        {
          id: "43986",
          name: "Fort Valley",
          state_id: "3931",
        },
        {
          id: "43987",
          name: "Foxborough",
          state_id: "3931",
        },
        {
          id: "43988",
          name: "Gaines School",
          state_id: "3931",
        },
        {
          id: "43989",
          name: "Gainesville",
          state_id: "3931",
        },
        {
          id: "43990",
          name: "Glennville",
          state_id: "3931",
        },
        {
          id: "43991",
          name: "Gresham Park",
          state_id: "3931",
        },
        {
          id: "43992",
          name: "Griffin",
          state_id: "3931",
        },
        {
          id: "43993",
          name: "Grovetown",
          state_id: "3931",
        },
        {
          id: "43994",
          name: "Hampton",
          state_id: "3931",
        },
        {
          id: "43995",
          name: "Hartwell",
          state_id: "3931",
        },
        {
          id: "43996",
          name: "Hinesville",
          state_id: "3931",
        },
        {
          id: "43997",
          name: "Jackson",
          state_id: "3931",
        },
        {
          id: "43998",
          name: "Jonesboro",
          state_id: "3931",
        },
        {
          id: "43999",
          name: "Kennesaw",
          state_id: "3931",
        },
        {
          id: "44000",
          name: "Kingsland",
          state_id: "3931",
        },
        {
          id: "44001",
          name: "LaGrange",
          state_id: "3931",
        },
        {
          id: "44002",
          name: "Lawrenceville",
          state_id: "3931",
        },
        {
          id: "44003",
          name: "Lilburn",
          state_id: "3931",
        },
        {
          id: "44004",
          name: "Lithia Springs",
          state_id: "3931",
        },
        {
          id: "44005",
          name: "Lithonia",
          state_id: "3931",
        },
        {
          id: "44006",
          name: "Locust Grove",
          state_id: "3931",
        },
        {
          id: "44007",
          name: "Loganville",
          state_id: "3931",
        },
        {
          id: "44008",
          name: "Louisville",
          state_id: "3931",
        },
        {
          id: "44009",
          name: "Mableton",
          state_id: "3931",
        },
        {
          id: "44010",
          name: "Macon",
          state_id: "3931",
        },
        {
          id: "44011",
          name: "Madison",
          state_id: "3931",
        },
        {
          id: "44012",
          name: "Marietta",
          state_id: "3931",
        },
        {
          id: "44013",
          name: "Martinez",
          state_id: "3931",
        },
        {
          id: "44014",
          name: "McDonough",
          state_id: "3931",
        },
        {
          id: "44015",
          name: "Milledgeville",
          state_id: "3931",
        },
        {
          id: "44016",
          name: "Monroe",
          state_id: "3931",
        },
        {
          id: "44017",
          name: "Morrow",
          state_id: "3931",
        },
        {
          id: "44018",
          name: "Moultrie",
          state_id: "3931",
        },
        {
          id: "44019",
          name: "Mountain",
          state_id: "3931",
        },
        {
          id: "44020",
          name: "Mountain Park",
          state_id: "3931",
        },
        {
          id: "44021",
          name: "Newnan",
          state_id: "3931",
        },
        {
          id: "44022",
          name: "Norcross",
          state_id: "3931",
        },
        {
          id: "44023",
          name: "North Atlanta",
          state_id: "3931",
        },
        {
          id: "44024",
          name: "North Decatur",
          state_id: "3931",
        },
        {
          id: "44025",
          name: "North Druid Hills",
          state_id: "3931",
        },
        {
          id: "44026",
          name: "Oakwood",
          state_id: "3931",
        },
        {
          id: "44027",
          name: "Panthersville",
          state_id: "3931",
        },
        {
          id: "44028",
          name: "Peachtree City",
          state_id: "3931",
        },
        {
          id: "44029",
          name: "Powder Springs",
          state_id: "3931",
        },
        {
          id: "44030",
          name: "Redan",
          state_id: "3931",
        },
        {
          id: "44031",
          name: "Rex",
          state_id: "3931",
        },
        {
          id: "44032",
          name: "Riverdale",
          state_id: "3931",
        },
        {
          id: "44033",
          name: "Rome",
          state_id: "3931",
        },
        {
          id: "44034",
          name: "Rossville",
          state_id: "3931",
        },
        {
          id: "44035",
          name: "Roswell",
          state_id: "3931",
        },
        {
          id: "44036",
          name: "Saint Marys",
          state_id: "3931",
        },
        {
          id: "44037",
          name: "Saint Simons",
          state_id: "3931",
        },
        {
          id: "44038",
          name: "Sandy Springs",
          state_id: "3931",
        },
        {
          id: "44039",
          name: "Savannah",
          state_id: "3931",
        },
        {
          id: "44040",
          name: "Scottdale",
          state_id: "3931",
        },
        {
          id: "44041",
          name: "Sharpsburg",
          state_id: "3931",
        },
        {
          id: "44042",
          name: "Smyrna",
          state_id: "3931",
        },
        {
          id: "44043",
          name: "Snellville",
          state_id: "3931",
        },
        {
          id: "44044",
          name: "Sparks",
          state_id: "3931",
        },
        {
          id: "44045",
          name: "Statesboro",
          state_id: "3931",
        },
        {
          id: "44046",
          name: "Stockbridge",
          state_id: "3931",
        },
        {
          id: "44047",
          name: "Stone Mountain",
          state_id: "3931",
        },
        {
          id: "44048",
          name: "Suwanee",
          state_id: "3931",
        },
        {
          id: "44049",
          name: "Thomasville",
          state_id: "3931",
        },
        {
          id: "44050",
          name: "Tifton",
          state_id: "3931",
        },
        {
          id: "44051",
          name: "Tucker",
          state_id: "3931",
        },
        {
          id: "44052",
          name: "Tybee Island",
          state_id: "3931",
        },
        {
          id: "44053",
          name: "Union City",
          state_id: "3931",
        },
        {
          id: "44054",
          name: "Valdosta",
          state_id: "3931",
        },
        {
          id: "44055",
          name: "Vidalia",
          state_id: "3931",
        },
        {
          id: "44056",
          name: "Villa Rica",
          state_id: "3931",
        },
        {
          id: "44057",
          name: "Warner Robins",
          state_id: "3931",
        },
        {
          id: "44058",
          name: "Waycross",
          state_id: "3931",
        },
        {
          id: "44059",
          name: "Wilmington Island",
          state_id: "3931",
        },
        {
          id: "44060",
          name: "Winder",
          state_id: "3931",
        },
        {
          id: "44061",
          name: "Woodbine",
          state_id: "3931",
        },
        {
          id: "44062",
          name: "Woodstock",
          state_id: "3931",
        },
      ],
      Hawaii: [
        {
          id: "44063",
          name: "Ahuimanu",
          state_id: "3932",
        },
        {
          id: "44064",
          name: "Aiea",
          state_id: "3932",
        },
        {
          id: "44065",
          name: "Aliamanu",
          state_id: "3932",
        },
        {
          id: "44066",
          name: "Ewa Beach",
          state_id: "3932",
        },
        {
          id: "44067",
          name: "Haiku",
          state_id: "3932",
        },
        {
          id: "44068",
          name: "Halawa",
          state_id: "3932",
        },
        {
          id: "44069",
          name: "Hanalei",
          state_id: "3932",
        },
        {
          id: "44070",
          name: "Hilo",
          state_id: "3932",
        },
        {
          id: "44071",
          name: "Holualoa",
          state_id: "3932",
        },
        {
          id: "44072",
          name: "Honolulu",
          state_id: "3932",
        },
        {
          id: "44073",
          name: "Kahului",
          state_id: "3932",
        },
        {
          id: "44074",
          name: "Kailua",
          state_id: "3932",
        },
        {
          id: "44075",
          name: "Kalaheo",
          state_id: "3932",
        },
        {
          id: "44076",
          name: "Kamuela",
          state_id: "3932",
        },
        {
          id: "44077",
          name: "Kaneohe",
          state_id: "3932",
        },
        {
          id: "44078",
          name: "Kaneohe Station",
          state_id: "3932",
        },
        {
          id: "44079",
          name: "Kapaa",
          state_id: "3932",
        },
        {
          id: "44080",
          name: "Kapolei",
          state_id: "3932",
        },
        {
          id: "44081",
          name: "Kihei",
          state_id: "3932",
        },
        {
          id: "44082",
          name: "Kula",
          state_id: "3932",
        },
        {
          id: "44083",
          name: "Lahaina",
          state_id: "3932",
        },
        {
          id: "44084",
          name: "Lanai City",
          state_id: "3932",
        },
        {
          id: "44085",
          name: "Lihue",
          state_id: "3932",
        },
        {
          id: "44086",
          name: "Makaha",
          state_id: "3932",
        },
        {
          id: "44087",
          name: "Makakilo City",
          state_id: "3932",
        },
        {
          id: "44088",
          name: "Makawao",
          state_id: "3932",
        },
        {
          id: "44089",
          name: "Mi-Wuk Village",
          state_id: "3932",
        },
        {
          id: "44090",
          name: "Mililani Town",
          state_id: "3932",
        },
        {
          id: "44091",
          name: "Naalehu",
          state_id: "3932",
        },
        {
          id: "44092",
          name: "Nanakuli",
          state_id: "3932",
        },
        {
          id: "44093",
          name: "Pahoa",
          state_id: "3932",
        },
        {
          id: "44094",
          name: "Pearl City",
          state_id: "3932",
        },
        {
          id: "44095",
          name: "Schofield Barracks",
          state_id: "3932",
        },
        {
          id: "44096",
          name: "Wahiawa",
          state_id: "3932",
        },
        {
          id: "44097",
          name: "Waialua",
          state_id: "3932",
        },
        {
          id: "44098",
          name: "Waianae",
          state_id: "3932",
        },
        {
          id: "44099",
          name: "Wailuku",
          state_id: "3932",
        },
        {
          id: "44100",
          name: "Waimalu",
          state_id: "3932",
        },
        {
          id: "44101",
          name: "Waipahu",
          state_id: "3932",
        },
        {
          id: "44102",
          name: "Waipio",
          state_id: "3932",
        },
      ],
      Idaho: [
        {
          id: "44103",
          name: "Blackfoot",
          state_id: "3933",
        },
        {
          id: "44104",
          name: "Boise",
          state_id: "3933",
        },
        {
          id: "44105",
          name: "Boise City",
          state_id: "3933",
        },
        {
          id: "44106",
          name: "Boulder Hill",
          state_id: "3933",
        },
        {
          id: "44107",
          name: "Burley",
          state_id: "3933",
        },
        {
          id: "44108",
          name: "Caldwell",
          state_id: "3933",
        },
        {
          id: "44109",
          name: "Coeur d''Alene",
          state_id: "3933",
        },
        {
          id: "44110",
          name: "Eagle",
          state_id: "3933",
        },
        {
          id: "44111",
          name: "Garden City",
          state_id: "3933",
        },
        {
          id: "44112",
          name: "Idaho Falls",
          state_id: "3933",
        },
        {
          id: "44113",
          name: "Lewiston",
          state_id: "3933",
        },
        {
          id: "44114",
          name: "Meridian",
          state_id: "3933",
        },
        {
          id: "44115",
          name: "Moscow",
          state_id: "3933",
        },
        {
          id: "44116",
          name: "Mountain Home",
          state_id: "3933",
        },
        {
          id: "44117",
          name: "Nampa",
          state_id: "3933",
        },
        {
          id: "44118",
          name: "Payette",
          state_id: "3933",
        },
        {
          id: "44119",
          name: "Pocatello",
          state_id: "3933",
        },
        {
          id: "44120",
          name: "Post Falls",
          state_id: "3933",
        },
        {
          id: "44121",
          name: "Preston",
          state_id: "3933",
        },
        {
          id: "44122",
          name: "Rexburg",
          state_id: "3933",
        },
        {
          id: "44123",
          name: "Rigby",
          state_id: "3933",
        },
        {
          id: "44124",
          name: "Sandpoint",
          state_id: "3933",
        },
        {
          id: "44125",
          name: "Troy",
          state_id: "3933",
        },
        {
          id: "44126",
          name: "Twin Falls",
          state_id: "3933",
        },
      ],
      Illinois: [
        {
          id: "44127",
          name: "Addison",
          state_id: "3934",
        },
        {
          id: "44128",
          name: "Algonquin",
          state_id: "3934",
        },
        {
          id: "44129",
          name: "Alsip",
          state_id: "3934",
        },
        {
          id: "44130",
          name: "Alton",
          state_id: "3934",
        },
        {
          id: "44131",
          name: "Arlington Heights",
          state_id: "3934",
        },
        {
          id: "44132",
          name: "Aurora",
          state_id: "3934",
        },
        {
          id: "44133",
          name: "Bannockburn",
          state_id: "3934",
        },
        {
          id: "44134",
          name: "Barrington",
          state_id: "3934",
        },
        {
          id: "44135",
          name: "Bartlett",
          state_id: "3934",
        },
        {
          id: "44136",
          name: "Batavia",
          state_id: "3934",
        },
        {
          id: "44137",
          name: "Beach Park",
          state_id: "3934",
        },
        {
          id: "44138",
          name: "Beardstown",
          state_id: "3934",
        },
        {
          id: "44139",
          name: "Bedford Park",
          state_id: "3934",
        },
        {
          id: "44140",
          name: "Belleville",
          state_id: "3934",
        },
        {
          id: "44141",
          name: "Bellwood",
          state_id: "3934",
        },
        {
          id: "44142",
          name: "Belvidere",
          state_id: "3934",
        },
        {
          id: "44143",
          name: "Bensenville",
          state_id: "3934",
        },
        {
          id: "44144",
          name: "Berwyn",
          state_id: "3934",
        },
        {
          id: "44145",
          name: "Bloomingdale",
          state_id: "3934",
        },
        {
          id: "44146",
          name: "Bloomington",
          state_id: "3934",
        },
        {
          id: "44147",
          name: "Blue Island",
          state_id: "3934",
        },
        {
          id: "44148",
          name: "Boling Brook",
          state_id: "3934",
        },
        {
          id: "44149",
          name: "Bolingbrook",
          state_id: "3934",
        },
        {
          id: "44150",
          name: "Bourbonnais",
          state_id: "3934",
        },
        {
          id: "44151",
          name: "Bradley",
          state_id: "3934",
        },
        {
          id: "44152",
          name: "Breese",
          state_id: "3934",
        },
        {
          id: "44153",
          name: "Bridgeview",
          state_id: "3934",
        },
        {
          id: "44154",
          name: "Brimfield",
          state_id: "3934",
        },
        {
          id: "44155",
          name: "Broadview",
          state_id: "3934",
        },
        {
          id: "44156",
          name: "Brookfield",
          state_id: "3934",
        },
        {
          id: "44157",
          name: "Buffalo Grove",
          state_id: "3934",
        },
        {
          id: "44158",
          name: "Burbank",
          state_id: "3934",
        },
        {
          id: "44159",
          name: "Burr Ridge",
          state_id: "3934",
        },
        {
          id: "44160",
          name: "Cahokia",
          state_id: "3934",
        },
        {
          id: "44161",
          name: "Calumet City",
          state_id: "3934",
        },
        {
          id: "44162",
          name: "Canton",
          state_id: "3934",
        },
        {
          id: "44163",
          name: "Carbondale",
          state_id: "3934",
        },
        {
          id: "44164",
          name: "Carlinville",
          state_id: "3934",
        },
        {
          id: "44165",
          name: "Carol Stream",
          state_id: "3934",
        },
        {
          id: "44166",
          name: "Carpentersville",
          state_id: "3934",
        },
        {
          id: "44167",
          name: "Carthage",
          state_id: "3934",
        },
        {
          id: "44168",
          name: "Cary",
          state_id: "3934",
        },
        {
          id: "44169",
          name: "Centralia",
          state_id: "3934",
        },
        {
          id: "44170",
          name: "Champaign",
          state_id: "3934",
        },
        {
          id: "44171",
          name: "Channahon",
          state_id: "3934",
        },
        {
          id: "44172",
          name: "Charleston",
          state_id: "3934",
        },
        {
          id: "44173",
          name: "Chicago",
          state_id: "3934",
        },
        {
          id: "44174",
          name: "Chicago Heights",
          state_id: "3934",
        },
        {
          id: "44175",
          name: "Chicago Ridge",
          state_id: "3934",
        },
        {
          id: "44176",
          name: "Cicero",
          state_id: "3934",
        },
        {
          id: "44177",
          name: "Coal City",
          state_id: "3934",
        },
        {
          id: "44178",
          name: "Collinsville",
          state_id: "3934",
        },
        {
          id: "44179",
          name: "Congerville",
          state_id: "3934",
        },
        {
          id: "44180",
          name: "Country Club Hills",
          state_id: "3934",
        },
        {
          id: "44181",
          name: "Crest Hill",
          state_id: "3934",
        },
        {
          id: "44182",
          name: "Crestwood",
          state_id: "3934",
        },
        {
          id: "44183",
          name: "Crystal Lake",
          state_id: "3934",
        },
        {
          id: "44184",
          name: "Danville",
          state_id: "3934",
        },
        {
          id: "44185",
          name: "Darien",
          state_id: "3934",
        },
        {
          id: "44186",
          name: "DeKalb",
          state_id: "3934",
        },
        {
          id: "44187",
          name: "Decatur",
          state_id: "3934",
        },
        {
          id: "44188",
          name: "Deerfield",
          state_id: "3934",
        },
        {
          id: "44189",
          name: "Des Plaines",
          state_id: "3934",
        },
        {
          id: "44190",
          name: "Dixon",
          state_id: "3934",
        },
        {
          id: "44191",
          name: "Dolton",
          state_id: "3934",
        },
        {
          id: "44192",
          name: "Downers Grove",
          state_id: "3934",
        },
        {
          id: "44193",
          name: "Earlville",
          state_id: "3934",
        },
        {
          id: "44194",
          name: "East Dundee",
          state_id: "3934",
        },
        {
          id: "44195",
          name: "East Moline",
          state_id: "3934",
        },
        {
          id: "44196",
          name: "East Peoria",
          state_id: "3934",
        },
        {
          id: "44197",
          name: "East Saint Louis",
          state_id: "3934",
        },
        {
          id: "44198",
          name: "Edwardsville",
          state_id: "3934",
        },
        {
          id: "44199",
          name: "Effingham",
          state_id: "3934",
        },
        {
          id: "44200",
          name: "Elburn",
          state_id: "3934",
        },
        {
          id: "44201",
          name: "Elgin",
          state_id: "3934",
        },
        {
          id: "44202",
          name: "Elk Grove",
          state_id: "3934",
        },
        {
          id: "44203",
          name: "Elk Grove Village",
          state_id: "3934",
        },
        {
          id: "44204",
          name: "Elmhurst",
          state_id: "3934",
        },
        {
          id: "44205",
          name: "Elmwood Park",
          state_id: "3934",
        },
        {
          id: "44206",
          name: "Evanston",
          state_id: "3934",
        },
        {
          id: "44207",
          name: "Evergreen Park",
          state_id: "3934",
        },
        {
          id: "44208",
          name: "Fairview Heights",
          state_id: "3934",
        },
        {
          id: "44209",
          name: "Flossmoor",
          state_id: "3934",
        },
        {
          id: "44210",
          name: "Forest Park",
          state_id: "3934",
        },
        {
          id: "44211",
          name: "Frankfort",
          state_id: "3934",
        },
        {
          id: "44212",
          name: "Franklin Park",
          state_id: "3934",
        },
        {
          id: "44213",
          name: "Freeport",
          state_id: "3934",
        },
        {
          id: "44214",
          name: "Galena",
          state_id: "3934",
        },
        {
          id: "44215",
          name: "Galesburg",
          state_id: "3934",
        },
        {
          id: "44216",
          name: "Geneva",
          state_id: "3934",
        },
        {
          id: "44217",
          name: "Genoa",
          state_id: "3934",
        },
        {
          id: "44218",
          name: "Glen Carbon",
          state_id: "3934",
        },
        {
          id: "44219",
          name: "Glen Ellyn",
          state_id: "3934",
        },
        {
          id: "44220",
          name: "Glencoe",
          state_id: "3934",
        },
        {
          id: "44221",
          name: "Glendale Heights",
          state_id: "3934",
        },
        {
          id: "44222",
          name: "Glenview",
          state_id: "3934",
        },
        {
          id: "44223",
          name: "Godfrey",
          state_id: "3934",
        },
        {
          id: "44224",
          name: "Goodings Grove",
          state_id: "3934",
        },
        {
          id: "44225",
          name: "Granite City",
          state_id: "3934",
        },
        {
          id: "44226",
          name: "Grayslake",
          state_id: "3934",
        },
        {
          id: "44227",
          name: "Gurnee",
          state_id: "3934",
        },
        {
          id: "44228",
          name: "Hamilton",
          state_id: "3934",
        },
        {
          id: "44229",
          name: "Hampshire",
          state_id: "3934",
        },
        {
          id: "44230",
          name: "Hanover Park",
          state_id: "3934",
        },
        {
          id: "44231",
          name: "Harvard",
          state_id: "3934",
        },
        {
          id: "44232",
          name: "Harvey",
          state_id: "3934",
        },
        {
          id: "44233",
          name: "Hawthorn Woods",
          state_id: "3934",
        },
        {
          id: "44234",
          name: "Hazel Crest",
          state_id: "3934",
        },
        {
          id: "44235",
          name: "Herrin",
          state_id: "3934",
        },
        {
          id: "44236",
          name: "Hickory Hills",
          state_id: "3934",
        },
        {
          id: "44237",
          name: "Highland Park",
          state_id: "3934",
        },
        {
          id: "44238",
          name: "Hinsdale",
          state_id: "3934",
        },
        {
          id: "44239",
          name: "Hoffman Estates",
          state_id: "3934",
        },
        {
          id: "44240",
          name: "Homewood",
          state_id: "3934",
        },
        {
          id: "44241",
          name: "Huntley",
          state_id: "3934",
        },
        {
          id: "44242",
          name: "Illinois City",
          state_id: "3934",
        },
        {
          id: "44243",
          name: "Ingleside",
          state_id: "3934",
        },
        {
          id: "44244",
          name: "Itasca",
          state_id: "3934",
        },
        {
          id: "44245",
          name: "Jacksonville",
          state_id: "3934",
        },
        {
          id: "44246",
          name: "Johnston City",
          state_id: "3934",
        },
        {
          id: "44247",
          name: "Joliet",
          state_id: "3934",
        },
        {
          id: "44248",
          name: "Justice",
          state_id: "3934",
        },
        {
          id: "44249",
          name: "Kankakee",
          state_id: "3934",
        },
        {
          id: "44250",
          name: "Kenilworth",
          state_id: "3934",
        },
        {
          id: "44251",
          name: "Kewanee",
          state_id: "3934",
        },
        {
          id: "44252",
          name: "La Grange",
          state_id: "3934",
        },
        {
          id: "44253",
          name: "La Grange Park",
          state_id: "3934",
        },
        {
          id: "44254",
          name: "La Salle",
          state_id: "3934",
        },
        {
          id: "44255",
          name: "Lake Bluff",
          state_id: "3934",
        },
        {
          id: "44256",
          name: "Lake Forest",
          state_id: "3934",
        },
        {
          id: "44257",
          name: "Lake Zurich",
          state_id: "3934",
        },
        {
          id: "44258",
          name: "Lake in the Hills",
          state_id: "3934",
        },
        {
          id: "44259",
          name: "Lansing",
          state_id: "3934",
        },
        {
          id: "44260",
          name: "Lemont",
          state_id: "3934",
        },
        {
          id: "44261",
          name: "Libertyville",
          state_id: "3934",
        },
        {
          id: "44262",
          name: "Lincoln",
          state_id: "3934",
        },
        {
          id: "44263",
          name: "Lincolnwood",
          state_id: "3934",
        },
        {
          id: "44264",
          name: "Lindenhurst",
          state_id: "3934",
        },
        {
          id: "44265",
          name: "Lindenwood",
          state_id: "3934",
        },
        {
          id: "44266",
          name: "Lisle",
          state_id: "3934",
        },
        {
          id: "44267",
          name: "Lockport",
          state_id: "3934",
        },
        {
          id: "44268",
          name: "Lombard",
          state_id: "3934",
        },
        {
          id: "44269",
          name: "Long Grove",
          state_id: "3934",
        },
        {
          id: "44270",
          name: "Loves Park",
          state_id: "3934",
        },
        {
          id: "44271",
          name: "Lyons",
          state_id: "3934",
        },
        {
          id: "44272",
          name: "MacHenry",
          state_id: "3934",
        },
        {
          id: "44273",
          name: "Machesney Park",
          state_id: "3934",
        },
        {
          id: "44274",
          name: "Macomb",
          state_id: "3934",
        },
        {
          id: "44275",
          name: "Marion",
          state_id: "3934",
        },
        {
          id: "44276",
          name: "Markham",
          state_id: "3934",
        },
        {
          id: "44277",
          name: "Marshall",
          state_id: "3934",
        },
        {
          id: "44278",
          name: "Martinsville",
          state_id: "3934",
        },
        {
          id: "44279",
          name: "Maryville",
          state_id: "3934",
        },
        {
          id: "44280",
          name: "Matteson",
          state_id: "3934",
        },
        {
          id: "44281",
          name: "Mattoon",
          state_id: "3934",
        },
        {
          id: "44282",
          name: "Maywood",
          state_id: "3934",
        },
        {
          id: "44283",
          name: "McHenry",
          state_id: "3934",
        },
        {
          id: "44284",
          name: "Melrose Park",
          state_id: "3934",
        },
        {
          id: "44285",
          name: "Midlothian",
          state_id: "3934",
        },
        {
          id: "44286",
          name: "Milan",
          state_id: "3934",
        },
        {
          id: "44287",
          name: "Minooka",
          state_id: "3934",
        },
        {
          id: "44288",
          name: "Mokena",
          state_id: "3934",
        },
        {
          id: "44289",
          name: "Moline",
          state_id: "3934",
        },
        {
          id: "44290",
          name: "Momence",
          state_id: "3934",
        },
        {
          id: "44291",
          name: "Montgomery",
          state_id: "3934",
        },
        {
          id: "44292",
          name: "Monticello",
          state_id: "3934",
        },
        {
          id: "44293",
          name: "Morris",
          state_id: "3934",
        },
        {
          id: "44294",
          name: "Morton",
          state_id: "3934",
        },
        {
          id: "44295",
          name: "Morton Grove",
          state_id: "3934",
        },
        {
          id: "44296",
          name: "Mossville",
          state_id: "3934",
        },
        {
          id: "44297",
          name: "Mount Prospect",
          state_id: "3934",
        },
        {
          id: "44298",
          name: "Mount Vernon",
          state_id: "3934",
        },
        {
          id: "44299",
          name: "Mount Zion",
          state_id: "3934",
        },
        {
          id: "44300",
          name: "Mundelein",
          state_id: "3934",
        },
        {
          id: "44301",
          name: "Naperville",
          state_id: "3934",
        },
        {
          id: "44302",
          name: "New Lenox",
          state_id: "3934",
        },
        {
          id: "44303",
          name: "Niles",
          state_id: "3934",
        },
        {
          id: "44304",
          name: "Normal",
          state_id: "3934",
        },
        {
          id: "44305",
          name: "Norridge",
          state_id: "3934",
        },
        {
          id: "44306",
          name: "North Aurora",
          state_id: "3934",
        },
        {
          id: "44307",
          name: "North Chicago",
          state_id: "3934",
        },
        {
          id: "44308",
          name: "Northbrook",
          state_id: "3934",
        },
        {
          id: "44309",
          name: "Northfield",
          state_id: "3934",
        },
        {
          id: "44310",
          name: "Northlake",
          state_id: "3934",
        },
        {
          id: "44311",
          name: "O''Fallon",
          state_id: "3934",
        },
        {
          id: "44312",
          name: "Oak Forest",
          state_id: "3934",
        },
        {
          id: "44313",
          name: "Oak Lawn",
          state_id: "3934",
        },
        {
          id: "44314",
          name: "Oak Park",
          state_id: "3934",
        },
        {
          id: "44315",
          name: "Oakbrook",
          state_id: "3934",
        },
        {
          id: "44316",
          name: "Oakwood",
          state_id: "3934",
        },
        {
          id: "44317",
          name: "Olney",
          state_id: "3934",
        },
        {
          id: "44318",
          name: "Orland Park",
          state_id: "3934",
        },
        {
          id: "44319",
          name: "Osco",
          state_id: "3934",
        },
        {
          id: "44320",
          name: "Ottawa",
          state_id: "3934",
        },
        {
          id: "44321",
          name: "Palatine",
          state_id: "3934",
        },
        {
          id: "44322",
          name: "Palos Heights",
          state_id: "3934",
        },
        {
          id: "44323",
          name: "Palos Hills",
          state_id: "3934",
        },
        {
          id: "44324",
          name: "Park Forest",
          state_id: "3934",
        },
        {
          id: "44325",
          name: "Park Ridge",
          state_id: "3934",
        },
        {
          id: "44326",
          name: "Pekin",
          state_id: "3934",
        },
        {
          id: "44327",
          name: "Peoria",
          state_id: "3934",
        },
        {
          id: "44328",
          name: "Peru",
          state_id: "3934",
        },
        {
          id: "44329",
          name: "Plainfield",
          state_id: "3934",
        },
        {
          id: "44330",
          name: "Pontiac",
          state_id: "3934",
        },
        {
          id: "44331",
          name: "Princeton",
          state_id: "3934",
        },
        {
          id: "44332",
          name: "Prospect Heights",
          state_id: "3934",
        },
        {
          id: "44333",
          name: "Quincy",
          state_id: "3934",
        },
        {
          id: "44334",
          name: "Ramsey",
          state_id: "3934",
        },
        {
          id: "44335",
          name: "Rantoul",
          state_id: "3934",
        },
        {
          id: "44336",
          name: "Richmond",
          state_id: "3934",
        },
        {
          id: "44337",
          name: "Richton Park",
          state_id: "3934",
        },
        {
          id: "44338",
          name: "River Forest",
          state_id: "3934",
        },
        {
          id: "44339",
          name: "Riverdale",
          state_id: "3934",
        },
        {
          id: "44340",
          name: "Rochelle",
          state_id: "3934",
        },
        {
          id: "44341",
          name: "Rock Island",
          state_id: "3934",
        },
        {
          id: "44342",
          name: "Rockford",
          state_id: "3934",
        },
        {
          id: "44343",
          name: "Rolling Meadows",
          state_id: "3934",
        },
        {
          id: "44344",
          name: "Romeoville",
          state_id: "3934",
        },
        {
          id: "44345",
          name: "Roscoe",
          state_id: "3934",
        },
        {
          id: "44346",
          name: "Roselle",
          state_id: "3934",
        },
        {
          id: "44347",
          name: "Round Lake Beach",
          state_id: "3934",
        },
        {
          id: "44348",
          name: "Saint Charles",
          state_id: "3934",
        },
        {
          id: "44349",
          name: "Sauget",
          state_id: "3934",
        },
        {
          id: "44350",
          name: "Sauk Village",
          state_id: "3934",
        },
        {
          id: "44351",
          name: "Schaumburg",
          state_id: "3934",
        },
        {
          id: "44352",
          name: "Schiller Park",
          state_id: "3934",
        },
        {
          id: "44353",
          name: "Shumway",
          state_id: "3934",
        },
        {
          id: "44354",
          name: "Skokie",
          state_id: "3934",
        },
        {
          id: "44355",
          name: "South Elgin",
          state_id: "3934",
        },
        {
          id: "44356",
          name: "South Holland",
          state_id: "3934",
        },
        {
          id: "44357",
          name: "Spring Valley",
          state_id: "3934",
        },
        {
          id: "44358",
          name: "Springfield",
          state_id: "3934",
        },
        {
          id: "44359",
          name: "Sterling",
          state_id: "3934",
        },
        {
          id: "44360",
          name: "Streamwood",
          state_id: "3934",
        },
        {
          id: "44361",
          name: "Streator",
          state_id: "3934",
        },
        {
          id: "44362",
          name: "Swansea",
          state_id: "3934",
        },
        {
          id: "44363",
          name: "Sycamore",
          state_id: "3934",
        },
        {
          id: "44364",
          name: "Taylorville",
          state_id: "3934",
        },
        {
          id: "44365",
          name: "Tinley Park",
          state_id: "3934",
        },
        {
          id: "44366",
          name: "Trenton",
          state_id: "3934",
        },
        {
          id: "44367",
          name: "Urbana",
          state_id: "3934",
        },
        {
          id: "44368",
          name: "Ursa",
          state_id: "3934",
        },
        {
          id: "44369",
          name: "Vernon Hills",
          state_id: "3934",
        },
        {
          id: "44370",
          name: "Villa Park",
          state_id: "3934",
        },
        {
          id: "44371",
          name: "Walnut",
          state_id: "3934",
        },
        {
          id: "44372",
          name: "Warrenville",
          state_id: "3934",
        },
        {
          id: "44373",
          name: "Washington",
          state_id: "3934",
        },
        {
          id: "44374",
          name: "Waukegan",
          state_id: "3934",
        },
        {
          id: "44375",
          name: "West Chicago",
          state_id: "3934",
        },
        {
          id: "44376",
          name: "West Dundee",
          state_id: "3934",
        },
        {
          id: "44377",
          name: "Westchester",
          state_id: "3934",
        },
        {
          id: "44378",
          name: "Western Springs",
          state_id: "3934",
        },
        {
          id: "44379",
          name: "Westmont",
          state_id: "3934",
        },
        {
          id: "44380",
          name: "Wheaton",
          state_id: "3934",
        },
        {
          id: "44381",
          name: "Wheeling",
          state_id: "3934",
        },
        {
          id: "44382",
          name: "Willowbrook",
          state_id: "3934",
        },
        {
          id: "44383",
          name: "Wilmette",
          state_id: "3934",
        },
        {
          id: "44384",
          name: "Winnebago",
          state_id: "3934",
        },
        {
          id: "44385",
          name: "Winnetka",
          state_id: "3934",
        },
        {
          id: "44386",
          name: "Wood Dale",
          state_id: "3934",
        },
        {
          id: "44387",
          name: "Wood River",
          state_id: "3934",
        },
        {
          id: "44388",
          name: "Woodridge",
          state_id: "3934",
        },
        {
          id: "44389",
          name: "Woodstock",
          state_id: "3934",
        },
        {
          id: "44390",
          name: "Worth",
          state_id: "3934",
        },
        {
          id: "44391",
          name: "Zion",
          state_id: "3934",
        },
      ],
      Indiana: [
        {
          id: "44392",
          name: "Albion",
          state_id: "3935",
        },
        {
          id: "44393",
          name: "Anderson",
          state_id: "3935",
        },
        {
          id: "44394",
          name: "Angola",
          state_id: "3935",
        },
        {
          id: "44395",
          name: "Auburn",
          state_id: "3935",
        },
        {
          id: "44396",
          name: "Bedford",
          state_id: "3935",
        },
        {
          id: "44397",
          name: "Beech Grove",
          state_id: "3935",
        },
        {
          id: "44398",
          name: "Bloomington",
          state_id: "3935",
        },
        {
          id: "44399",
          name: "Brownsburg",
          state_id: "3935",
        },
        {
          id: "44400",
          name: "Carmel",
          state_id: "3935",
        },
        {
          id: "44401",
          name: "Cedar Lake",
          state_id: "3935",
        },
        {
          id: "44402",
          name: "Chesterton",
          state_id: "3935",
        },
        {
          id: "44403",
          name: "Clarksville",
          state_id: "3935",
        },
        {
          id: "44404",
          name: "Columbus",
          state_id: "3935",
        },
        {
          id: "44405",
          name: "Connersville",
          state_id: "3935",
        },
        {
          id: "44406",
          name: "Crawfordsville",
          state_id: "3935",
        },
        {
          id: "44407",
          name: "Crown Point",
          state_id: "3935",
        },
        {
          id: "44408",
          name: "Dyer",
          state_id: "3935",
        },
        {
          id: "44409",
          name: "East Chicago",
          state_id: "3935",
        },
        {
          id: "44410",
          name: "Elkhart",
          state_id: "3935",
        },
        {
          id: "44411",
          name: "Evansville",
          state_id: "3935",
        },
        {
          id: "44412",
          name: "Fishers",
          state_id: "3935",
        },
        {
          id: "44413",
          name: "Fort Wayne",
          state_id: "3935",
        },
        {
          id: "44414",
          name: "Frankfort",
          state_id: "3935",
        },
        {
          id: "44415",
          name: "Franklin",
          state_id: "3935",
        },
        {
          id: "44416",
          name: "Gary",
          state_id: "3935",
        },
        {
          id: "44417",
          name: "Goshen",
          state_id: "3935",
        },
        {
          id: "44418",
          name: "Gosport",
          state_id: "3935",
        },
        {
          id: "44419",
          name: "Granger",
          state_id: "3935",
        },
        {
          id: "44420",
          name: "Greenfield",
          state_id: "3935",
        },
        {
          id: "44421",
          name: "Greensburg",
          state_id: "3935",
        },
        {
          id: "44422",
          name: "Greenwood",
          state_id: "3935",
        },
        {
          id: "44423",
          name: "Griffith",
          state_id: "3935",
        },
        {
          id: "44424",
          name: "Hammond",
          state_id: "3935",
        },
        {
          id: "44425",
          name: "Helmsburg",
          state_id: "3935",
        },
        {
          id: "44426",
          name: "Highland",
          state_id: "3935",
        },
        {
          id: "44427",
          name: "Hobart",
          state_id: "3935",
        },
        {
          id: "44428",
          name: "Huntington",
          state_id: "3935",
        },
        {
          id: "44429",
          name: "Indianapolis",
          state_id: "3935",
        },
        {
          id: "44430",
          name: "Jasper",
          state_id: "3935",
        },
        {
          id: "44431",
          name: "Jeffersonville",
          state_id: "3935",
        },
        {
          id: "44432",
          name: "Knightstown",
          state_id: "3935",
        },
        {
          id: "44433",
          name: "Kokomo",
          state_id: "3935",
        },
        {
          id: "44434",
          name: "La Porte",
          state_id: "3935",
        },
        {
          id: "44435",
          name: "Lafayette",
          state_id: "3935",
        },
        {
          id: "44436",
          name: "Lake Station",
          state_id: "3935",
        },
        {
          id: "44437",
          name: "Lawrence",
          state_id: "3935",
        },
        {
          id: "44438",
          name: "Lebanon",
          state_id: "3935",
        },
        {
          id: "44439",
          name: "Liberty",
          state_id: "3935",
        },
        {
          id: "44440",
          name: "Logansport",
          state_id: "3935",
        },
        {
          id: "44441",
          name: "Madison",
          state_id: "3935",
        },
        {
          id: "44442",
          name: "Marion",
          state_id: "3935",
        },
        {
          id: "44443",
          name: "Martinsville",
          state_id: "3935",
        },
        {
          id: "44444",
          name: "Merrillville",
          state_id: "3935",
        },
        {
          id: "44445",
          name: "Michigan City",
          state_id: "3935",
        },
        {
          id: "44446",
          name: "Mishawaka",
          state_id: "3935",
        },
        {
          id: "44447",
          name: "Muncie",
          state_id: "3935",
        },
        {
          id: "44448",
          name: "Munster",
          state_id: "3935",
        },
        {
          id: "44449",
          name: "N. Albany",
          state_id: "3935",
        },
        {
          id: "44450",
          name: "Nashville",
          state_id: "3935",
        },
        {
          id: "44451",
          name: "New Albany",
          state_id: "3935",
        },
        {
          id: "44452",
          name: "New Castle",
          state_id: "3935",
        },
        {
          id: "44453",
          name: "New Haven",
          state_id: "3935",
        },
        {
          id: "44454",
          name: "New Trenton",
          state_id: "3935",
        },
        {
          id: "44455",
          name: "Noblesville",
          state_id: "3935",
        },
        {
          id: "44456",
          name: "North Vernon",
          state_id: "3935",
        },
        {
          id: "44457",
          name: "Osceola",
          state_id: "3935",
        },
        {
          id: "44458",
          name: "Peru",
          state_id: "3935",
        },
        {
          id: "44459",
          name: "Plainfield",
          state_id: "3935",
        },
        {
          id: "44460",
          name: "Plymouth",
          state_id: "3935",
        },
        {
          id: "44461",
          name: "Poland",
          state_id: "3935",
        },
        {
          id: "44462",
          name: "Portage",
          state_id: "3935",
        },
        {
          id: "44463",
          name: "Richmond",
          state_id: "3935",
        },
        {
          id: "44464",
          name: "Rising Sun",
          state_id: "3935",
        },
        {
          id: "44465",
          name: "Roanoke",
          state_id: "3935",
        },
        {
          id: "44466",
          name: "Rockport",
          state_id: "3935",
        },
        {
          id: "44467",
          name: "Schererville",
          state_id: "3935",
        },
        {
          id: "44468",
          name: "Scottsburg",
          state_id: "3935",
        },
        {
          id: "44469",
          name: "Seymour",
          state_id: "3935",
        },
        {
          id: "44470",
          name: "Shelbyville",
          state_id: "3935",
        },
        {
          id: "44471",
          name: "South Bend",
          state_id: "3935",
        },
        {
          id: "44472",
          name: "Speedway",
          state_id: "3935",
        },
        {
          id: "44473",
          name: "St. John",
          state_id: "3935",
        },
        {
          id: "44474",
          name: "Terre Haute",
          state_id: "3935",
        },
        {
          id: "44475",
          name: "Thorntown",
          state_id: "3935",
        },
        {
          id: "44476",
          name: "Tippecanoe",
          state_id: "3935",
        },
        {
          id: "44477",
          name: "Troy",
          state_id: "3935",
        },
        {
          id: "44478",
          name: "Valparaiso",
          state_id: "3935",
        },
        {
          id: "44479",
          name: "Vermont",
          state_id: "3935",
        },
        {
          id: "44480",
          name: "Vincennes",
          state_id: "3935",
        },
        {
          id: "44481",
          name: "Wabash",
          state_id: "3935",
        },
        {
          id: "44482",
          name: "Warsaw",
          state_id: "3935",
        },
        {
          id: "44483",
          name: "Washington",
          state_id: "3935",
        },
        {
          id: "44484",
          name: "West Lafayette",
          state_id: "3935",
        },
        {
          id: "44485",
          name: "Williams",
          state_id: "3935",
        },
      ],
      Iowa: [
        {
          id: "44486",
          name: "Altoona",
          state_id: "3936",
        },
        {
          id: "44487",
          name: "Ames",
          state_id: "3936",
        },
        {
          id: "44488",
          name: "Ankeny",
          state_id: "3936",
        },
        {
          id: "44489",
          name: "Bettendorf",
          state_id: "3936",
        },
        {
          id: "44490",
          name: "Boone",
          state_id: "3936",
        },
        {
          id: "44491",
          name: "Burlington",
          state_id: "3936",
        },
        {
          id: "44492",
          name: "Carroll",
          state_id: "3936",
        },
        {
          id: "44493",
          name: "Cedar Falls",
          state_id: "3936",
        },
        {
          id: "44494",
          name: "Cedar Rapids",
          state_id: "3936",
        },
        {
          id: "44495",
          name: "Clarinda",
          state_id: "3936",
        },
        {
          id: "44496",
          name: "Clinton",
          state_id: "3936",
        },
        {
          id: "44497",
          name: "Clive",
          state_id: "3936",
        },
        {
          id: "44498",
          name: "Coralville",
          state_id: "3936",
        },
        {
          id: "44499",
          name: "Council Bluffs",
          state_id: "3936",
        },
        {
          id: "44500",
          name: "Davenport",
          state_id: "3936",
        },
        {
          id: "44501",
          name: "Des Moines",
          state_id: "3936",
        },
        {
          id: "44502",
          name: "Dubuque",
          state_id: "3936",
        },
        {
          id: "44503",
          name: "Eldridge",
          state_id: "3936",
        },
        {
          id: "44504",
          name: "Elkader",
          state_id: "3936",
        },
        {
          id: "44505",
          name: "Essex",
          state_id: "3936",
        },
        {
          id: "44506",
          name: "Fairfield",
          state_id: "3936",
        },
        {
          id: "44507",
          name: "Fayette",
          state_id: "3936",
        },
        {
          id: "44508",
          name: "Fort Dodge",
          state_id: "3936",
        },
        {
          id: "44509",
          name: "Fort Madison",
          state_id: "3936",
        },
        {
          id: "44510",
          name: "Harlan",
          state_id: "3936",
        },
        {
          id: "44511",
          name: "Indianola",
          state_id: "3936",
        },
        {
          id: "44512",
          name: "Iowa City",
          state_id: "3936",
        },
        {
          id: "44513",
          name: "Kalona",
          state_id: "3936",
        },
        {
          id: "44514",
          name: "Keokuk",
          state_id: "3936",
        },
        {
          id: "44515",
          name: "Marion",
          state_id: "3936",
        },
        {
          id: "44516",
          name: "Marshalltown",
          state_id: "3936",
        },
        {
          id: "44517",
          name: "Mason City",
          state_id: "3936",
        },
        {
          id: "44518",
          name: "Muscatine",
          state_id: "3936",
        },
        {
          id: "44519",
          name: "Newton",
          state_id: "3936",
        },
        {
          id: "44520",
          name: "Orange City",
          state_id: "3936",
        },
        {
          id: "44521",
          name: "Oskaloosa",
          state_id: "3936",
        },
        {
          id: "44522",
          name: "Ottumwa",
          state_id: "3936",
        },
        {
          id: "44523",
          name: "Pella",
          state_id: "3936",
        },
        {
          id: "44524",
          name: "Sioux City",
          state_id: "3936",
        },
        {
          id: "44525",
          name: "Spencer",
          state_id: "3936",
        },
        {
          id: "44526",
          name: "Storm Lake",
          state_id: "3936",
        },
        {
          id: "44527",
          name: "Urbandale",
          state_id: "3936",
        },
        {
          id: "44528",
          name: "Waterloo",
          state_id: "3936",
        },
        {
          id: "44529",
          name: "West Des Moines",
          state_id: "3936",
        },
      ],
      Kansas: [
        {
          id: "44530",
          name: "Arkansas City",
          state_id: "3937",
        },
        {
          id: "44531",
          name: "Atchison",
          state_id: "3937",
        },
        {
          id: "44532",
          name: "Coffeyville",
          state_id: "3937",
        },
        {
          id: "44533",
          name: "Derby",
          state_id: "3937",
        },
        {
          id: "44534",
          name: "Dodge City",
          state_id: "3937",
        },
        {
          id: "44535",
          name: "El Dorado",
          state_id: "3937",
        },
        {
          id: "44536",
          name: "Elk City",
          state_id: "3937",
        },
        {
          id: "44537",
          name: "Emporia",
          state_id: "3937",
        },
        {
          id: "44538",
          name: "Fort Riley North",
          state_id: "3937",
        },
        {
          id: "44539",
          name: "Garden City",
          state_id: "3937",
        },
        {
          id: "44540",
          name: "Great Bend",
          state_id: "3937",
        },
        {
          id: "44541",
          name: "Hays",
          state_id: "3937",
        },
        {
          id: "44542",
          name: "Hutchinson",
          state_id: "3937",
        },
        {
          id: "44543",
          name: "Independence",
          state_id: "3937",
        },
        {
          id: "44544",
          name: "Junction City",
          state_id: "3937",
        },
        {
          id: "44545",
          name: "Kansas City",
          state_id: "3937",
        },
        {
          id: "44546",
          name: "Kingman",
          state_id: "3937",
        },
        {
          id: "44547",
          name: "Lawrence",
          state_id: "3937",
        },
        {
          id: "44548",
          name: "Leavenworth",
          state_id: "3937",
        },
        {
          id: "44549",
          name: "Leawood",
          state_id: "3937",
        },
        {
          id: "44550",
          name: "Lenexa",
          state_id: "3937",
        },
        {
          id: "44551",
          name: "Liberal",
          state_id: "3937",
        },
        {
          id: "44552",
          name: "MacPherson",
          state_id: "3937",
        },
        {
          id: "44553",
          name: "Manhattan",
          state_id: "3937",
        },
        {
          id: "44554",
          name: "Merriam",
          state_id: "3937",
        },
        {
          id: "44555",
          name: "Minneapolis",
          state_id: "3937",
        },
        {
          id: "44556",
          name: "Moscow",
          state_id: "3937",
        },
        {
          id: "44557",
          name: "Moundridge",
          state_id: "3937",
        },
        {
          id: "44558",
          name: "Nashville",
          state_id: "3937",
        },
        {
          id: "44559",
          name: "Newton",
          state_id: "3937",
        },
        {
          id: "44560",
          name: "Olathe",
          state_id: "3937",
        },
        {
          id: "44561",
          name: "Ottawa",
          state_id: "3937",
        },
        {
          id: "44562",
          name: "Overland Park",
          state_id: "3937",
        },
        {
          id: "44563",
          name: "Parsons",
          state_id: "3937",
        },
        {
          id: "44564",
          name: "Pittsburg",
          state_id: "3937",
        },
        {
          id: "44565",
          name: "Prairie Village",
          state_id: "3937",
        },
        {
          id: "44566",
          name: "Rose Hill",
          state_id: "3937",
        },
        {
          id: "44567",
          name: "Salina",
          state_id: "3937",
        },
        {
          id: "44568",
          name: "Shawnee",
          state_id: "3937",
        },
        {
          id: "44569",
          name: "Topeka",
          state_id: "3937",
        },
        {
          id: "44570",
          name: "Wichita",
          state_id: "3937",
        },
        {
          id: "44571",
          name: "Winfield",
          state_id: "3937",
        },
        {
          id: "44572",
          name: "tecumseh",
          state_id: "3937",
        },
      ],
      Kentucky: [
        {
          id: "44573",
          name: "Albany",
          state_id: "3938",
        },
        {
          id: "44574",
          name: "Ashland",
          state_id: "3938",
        },
        {
          id: "44575",
          name: "Bardstown",
          state_id: "3938",
        },
        {
          id: "44576",
          name: "Berea",
          state_id: "3938",
        },
        {
          id: "44577",
          name: "Bowling Green",
          state_id: "3938",
        },
        {
          id: "44578",
          name: "Campbellsville",
          state_id: "3938",
        },
        {
          id: "44579",
          name: "Catlettsburg",
          state_id: "3938",
        },
        {
          id: "44580",
          name: "Covington",
          state_id: "3938",
        },
        {
          id: "44581",
          name: "Crescent Springs",
          state_id: "3938",
        },
        {
          id: "44582",
          name: "Danville",
          state_id: "3938",
        },
        {
          id: "44583",
          name: "Dawson Springs",
          state_id: "3938",
        },
        {
          id: "44584",
          name: "Eastview",
          state_id: "3938",
        },
        {
          id: "44585",
          name: "Eddyville",
          state_id: "3938",
        },
        {
          id: "44586",
          name: "Elizabethtown",
          state_id: "3938",
        },
        {
          id: "44587",
          name: "Erlanger",
          state_id: "3938",
        },
        {
          id: "44588",
          name: "Evarts",
          state_id: "3938",
        },
        {
          id: "44589",
          name: "Fern Creek",
          state_id: "3938",
        },
        {
          id: "44590",
          name: "Florence",
          state_id: "3938",
        },
        {
          id: "44591",
          name: "Fort Campbell North",
          state_id: "3938",
        },
        {
          id: "44592",
          name: "Fort Knox",
          state_id: "3938",
        },
        {
          id: "44593",
          name: "Fort Mitchell",
          state_id: "3938",
        },
        {
          id: "44594",
          name: "Fort Thomas",
          state_id: "3938",
        },
        {
          id: "44595",
          name: "Frankfort",
          state_id: "3938",
        },
        {
          id: "44596",
          name: "Georgetown",
          state_id: "3938",
        },
        {
          id: "44597",
          name: "Glasgow",
          state_id: "3938",
        },
        {
          id: "44598",
          name: "Grays Knob",
          state_id: "3938",
        },
        {
          id: "44599",
          name: "Henderson",
          state_id: "3938",
        },
        {
          id: "44600",
          name: "Highview",
          state_id: "3938",
        },
        {
          id: "44601",
          name: "Hopkinsville",
          state_id: "3938",
        },
        {
          id: "44602",
          name: "Independence",
          state_id: "3938",
        },
        {
          id: "44603",
          name: "Jeffersontown",
          state_id: "3938",
        },
        {
          id: "44604",
          name: "Lawrenceburg",
          state_id: "3938",
        },
        {
          id: "44605",
          name: "Lebanon",
          state_id: "3938",
        },
        {
          id: "44606",
          name: "Lexington",
          state_id: "3938",
        },
        {
          id: "44607",
          name: "Lexington-Fayette",
          state_id: "3938",
        },
        {
          id: "44608",
          name: "Louisville",
          state_id: "3938",
        },
        {
          id: "44609",
          name: "Madisonville",
          state_id: "3938",
        },
        {
          id: "44610",
          name: "Marion",
          state_id: "3938",
        },
        {
          id: "44611",
          name: "Mayfield",
          state_id: "3938",
        },
        {
          id: "44612",
          name: "Maysville",
          state_id: "3938",
        },
        {
          id: "44613",
          name: "Middlesborough",
          state_id: "3938",
        },
        {
          id: "44614",
          name: "Murray",
          state_id: "3938",
        },
        {
          id: "44615",
          name: "Nebo",
          state_id: "3938",
        },
        {
          id: "44616",
          name: "Newburg",
          state_id: "3938",
        },
        {
          id: "44617",
          name: "Newport",
          state_id: "3938",
        },
        {
          id: "44618",
          name: "Nicholasville",
          state_id: "3938",
        },
        {
          id: "44619",
          name: "Okolona",
          state_id: "3938",
        },
        {
          id: "44620",
          name: "Olive Hill",
          state_id: "3938",
        },
        {
          id: "44621",
          name: "Owensboro",
          state_id: "3938",
        },
        {
          id: "44622",
          name: "Paducah",
          state_id: "3938",
        },
        {
          id: "44623",
          name: "Paris",
          state_id: "3938",
        },
        {
          id: "44624",
          name: "Pikeville",
          state_id: "3938",
        },
        {
          id: "44625",
          name: "Pleasure Ridge Park",
          state_id: "3938",
        },
        {
          id: "44626",
          name: "Queens",
          state_id: "3938",
        },
        {
          id: "44627",
          name: "Radcliff",
          state_id: "3938",
        },
        {
          id: "44628",
          name: "Richmond",
          state_id: "3938",
        },
        {
          id: "44629",
          name: "Saint Dennis",
          state_id: "3938",
        },
        {
          id: "44630",
          name: "Saint Matthews",
          state_id: "3938",
        },
        {
          id: "44631",
          name: "Scottsville",
          state_id: "3938",
        },
        {
          id: "44632",
          name: "Shively",
          state_id: "3938",
        },
        {
          id: "44633",
          name: "Somerset",
          state_id: "3938",
        },
        {
          id: "44634",
          name: "South Shore",
          state_id: "3938",
        },
        {
          id: "44635",
          name: "Tollesboro",
          state_id: "3938",
        },
        {
          id: "44636",
          name: "Valley Station",
          state_id: "3938",
        },
        {
          id: "44637",
          name: "Wallins Creek",
          state_id: "3938",
        },
        {
          id: "44638",
          name: "Walton",
          state_id: "3938",
        },
        {
          id: "44639",
          name: "Winchester",
          state_id: "3938",
        },
      ],
      Louisiana: [
        {
          id: "44640",
          name: "Abbeville",
          state_id: "3939",
        },
        {
          id: "44641",
          name: "Alexandria",
          state_id: "3939",
        },
        {
          id: "44642",
          name: "Amite",
          state_id: "3939",
        },
        {
          id: "44643",
          name: "Baker",
          state_id: "3939",
        },
        {
          id: "44644",
          name: "Bastrop",
          state_id: "3939",
        },
        {
          id: "44645",
          name: "Baton Rouge",
          state_id: "3939",
        },
        {
          id: "44646",
          name: "Bayou Cane",
          state_id: "3939",
        },
        {
          id: "44647",
          name: "Bogalusa",
          state_id: "3939",
        },
        {
          id: "44648",
          name: "Bossier City",
          state_id: "3939",
        },
        {
          id: "44649",
          name: "Broussard",
          state_id: "3939",
        },
        {
          id: "44650",
          name: "Calhoun",
          state_id: "3939",
        },
        {
          id: "44651",
          name: "Chalmette",
          state_id: "3939",
        },
        {
          id: "44652",
          name: "Covington",
          state_id: "3939",
        },
        {
          id: "44653",
          name: "Crowley",
          state_id: "3939",
        },
        {
          id: "44654",
          name: "De Ridder",
          state_id: "3939",
        },
        {
          id: "44655",
          name: "Delcambre",
          state_id: "3939",
        },
        {
          id: "44656",
          name: "Denham Springs",
          state_id: "3939",
        },
        {
          id: "44657",
          name: "Estelle",
          state_id: "3939",
        },
        {
          id: "44658",
          name: "Eunice",
          state_id: "3939",
        },
        {
          id: "44659",
          name: "Fort Polk South",
          state_id: "3939",
        },
        {
          id: "44660",
          name: "Franklin",
          state_id: "3939",
        },
        {
          id: "44661",
          name: "French Settlement",
          state_id: "3939",
        },
        {
          id: "44662",
          name: "Garyville",
          state_id: "3939",
        },
        {
          id: "44663",
          name: "Geismar",
          state_id: "3939",
        },
        {
          id: "44664",
          name: "Gretna",
          state_id: "3939",
        },
        {
          id: "44665",
          name: "Hammond",
          state_id: "3939",
        },
        {
          id: "44666",
          name: "Harahan",
          state_id: "3939",
        },
        {
          id: "44667",
          name: "Harvey",
          state_id: "3939",
        },
        {
          id: "44668",
          name: "Houma",
          state_id: "3939",
        },
        {
          id: "44669",
          name: "Independence",
          state_id: "3939",
        },
        {
          id: "44670",
          name: "Jefferson",
          state_id: "3939",
        },
        {
          id: "44671",
          name: "Jennings",
          state_id: "3939",
        },
        {
          id: "44672",
          name: "Kenner",
          state_id: "3939",
        },
        {
          id: "44673",
          name: "Lafayette",
          state_id: "3939",
        },
        {
          id: "44674",
          name: "Lake Charles",
          state_id: "3939",
        },
        {
          id: "44675",
          name: "Laplace",
          state_id: "3939",
        },
        {
          id: "44676",
          name: "Mandeville",
          state_id: "3939",
        },
        {
          id: "44677",
          name: "Marrero",
          state_id: "3939",
        },
        {
          id: "44678",
          name: "Merrydale",
          state_id: "3939",
        },
        {
          id: "44679",
          name: "Metairie",
          state_id: "3939",
        },
        {
          id: "44680",
          name: "Minden",
          state_id: "3939",
        },
        {
          id: "44681",
          name: "Monroe",
          state_id: "3939",
        },
        {
          id: "44682",
          name: "Morgan City",
          state_id: "3939",
        },
        {
          id: "44683",
          name: "Natchitoches",
          state_id: "3939",
        },
        {
          id: "44684",
          name: "New Iberia",
          state_id: "3939",
        },
        {
          id: "44685",
          name: "New Orleans",
          state_id: "3939",
        },
        {
          id: "44686",
          name: "Opelousas",
          state_id: "3939",
        },
        {
          id: "44687",
          name: "Pineville",
          state_id: "3939",
        },
        {
          id: "44688",
          name: "Pioneer",
          state_id: "3939",
        },
        {
          id: "44689",
          name: "Prairieville",
          state_id: "3939",
        },
        {
          id: "44690",
          name: "River Ridge",
          state_id: "3939",
        },
        {
          id: "44691",
          name: "Ruston",
          state_id: "3939",
        },
        {
          id: "44692",
          name: "Saint Amant",
          state_id: "3939",
        },
        {
          id: "44693",
          name: "Saint Martinville",
          state_id: "3939",
        },
        {
          id: "44694",
          name: "Shenandoah",
          state_id: "3939",
        },
        {
          id: "44695",
          name: "Shreveport",
          state_id: "3939",
        },
        {
          id: "44696",
          name: "Slidell",
          state_id: "3939",
        },
        {
          id: "44697",
          name: "Sulphur",
          state_id: "3939",
        },
        {
          id: "44698",
          name: "Terrytown",
          state_id: "3939",
        },
        {
          id: "44699",
          name: "Thibodaux",
          state_id: "3939",
        },
        {
          id: "44700",
          name: "Timberlane",
          state_id: "3939",
        },
        {
          id: "44701",
          name: "Vinton",
          state_id: "3939",
        },
        {
          id: "44702",
          name: "Waggaman",
          state_id: "3939",
        },
        {
          id: "44703",
          name: "West Monroe",
          state_id: "3939",
        },
        {
          id: "44704",
          name: "Westwego",
          state_id: "3939",
        },
        {
          id: "44705",
          name: "Zachary",
          state_id: "3939",
        },
      ],
      Maine: [
        {
          id: "44708",
          name: "Auburn",
          state_id: "3941",
        },
        {
          id: "44709",
          name: "Augusta",
          state_id: "3941",
        },
        {
          id: "44710",
          name: "Bangor",
          state_id: "3941",
        },
        {
          id: "44711",
          name: "Bath",
          state_id: "3941",
        },
        {
          id: "44712",
          name: "Biddeford",
          state_id: "3941",
        },
        {
          id: "44713",
          name: "Brunswick",
          state_id: "3941",
        },
        {
          id: "44714",
          name: "Cornish",
          state_id: "3941",
        },
        {
          id: "44715",
          name: "Dover-Foxcroft",
          state_id: "3941",
        },
        {
          id: "44716",
          name: "Ellsworth",
          state_id: "3941",
        },
        {
          id: "44717",
          name: "Etna",
          state_id: "3941",
        },
        {
          id: "44718",
          name: "Freeport",
          state_id: "3941",
        },
        {
          id: "44719",
          name: "Gorham",
          state_id: "3941",
        },
        {
          id: "44720",
          name: "Greene",
          state_id: "3941",
        },
        {
          id: "44721",
          name: "Harmony",
          state_id: "3941",
        },
        {
          id: "44722",
          name: "Lewiston",
          state_id: "3941",
        },
        {
          id: "44723",
          name: "Liberty",
          state_id: "3941",
        },
        {
          id: "44724",
          name: "Limerick",
          state_id: "3941",
        },
        {
          id: "44725",
          name: "Lyman",
          state_id: "3941",
        },
        {
          id: "44726",
          name: "Maine",
          state_id: "3941",
        },
        {
          id: "44727",
          name: "New Gloucester",
          state_id: "3941",
        },
        {
          id: "44728",
          name: "Norridgewock",
          state_id: "3941",
        },
        {
          id: "44729",
          name: "North Yarmouth",
          state_id: "3941",
        },
        {
          id: "44730",
          name: "Old Town",
          state_id: "3941",
        },
        {
          id: "44731",
          name: "Orono",
          state_id: "3941",
        },
        {
          id: "44732",
          name: "Portland",
          state_id: "3941",
        },
        {
          id: "44733",
          name: "Presque Isle",
          state_id: "3941",
        },
        {
          id: "44734",
          name: "Saco",
          state_id: "3941",
        },
        {
          id: "44735",
          name: "Sanford",
          state_id: "3941",
        },
        {
          id: "44736",
          name: "Scarborough",
          state_id: "3941",
        },
        {
          id: "44737",
          name: "South Portland",
          state_id: "3941",
        },
        {
          id: "44738",
          name: "Spruce Head",
          state_id: "3941",
        },
        {
          id: "44739",
          name: "Thomaston",
          state_id: "3941",
        },
        {
          id: "44740",
          name: "Waldoboro",
          state_id: "3941",
        },
        {
          id: "44741",
          name: "Waterville",
          state_id: "3941",
        },
        {
          id: "44742",
          name: "West Buxton",
          state_id: "3941",
        },
        {
          id: "44743",
          name: "Westbrook",
          state_id: "3941",
        },
        {
          id: "44744",
          name: "Whitefield",
          state_id: "3941",
        },
        {
          id: "44745",
          name: "Windham",
          state_id: "3941",
        },
        {
          id: "44746",
          name: "Yarmouth",
          state_id: "3941",
        },
        {
          id: "44747",
          name: "York Harbor",
          state_id: "3941",
        },
        {
          id: "44748",
          name: "stockton springs",
          state_id: "3941",
        },
      ],
      Maryland: [
        {
          id: "44749",
          name: "Aberdeen",
          state_id: "3942",
        },
        {
          id: "44750",
          name: "Accokeek",
          state_id: "3942",
        },
        {
          id: "44751",
          name: "Adelphi",
          state_id: "3942",
        },
        {
          id: "44752",
          name: "Andrews Air Force Base",
          state_id: "3942",
        },
        {
          id: "44753",
          name: "Annapolis",
          state_id: "3942",
        },
        {
          id: "44754",
          name: "Arbutus",
          state_id: "3942",
        },
        {
          id: "44755",
          name: "Arnold",
          state_id: "3942",
        },
        {
          id: "44756",
          name: "Aspen Hill",
          state_id: "3942",
        },
        {
          id: "44757",
          name: "Baltimore",
          state_id: "3942",
        },
        {
          id: "44758",
          name: "Bel Air North",
          state_id: "3942",
        },
        {
          id: "44759",
          name: "Bel Air South",
          state_id: "3942",
        },
        {
          id: "44760",
          name: "Beltsville",
          state_id: "3942",
        },
        {
          id: "44761",
          name: "Berlin",
          state_id: "3942",
        },
        {
          id: "44762",
          name: "Bethesda",
          state_id: "3942",
        },
        {
          id: "44763",
          name: "Bladensburg",
          state_id: "3942",
        },
        {
          id: "44764",
          name: "Boonsboro",
          state_id: "3942",
        },
        {
          id: "44765",
          name: "Bowie",
          state_id: "3942",
        },
        {
          id: "44766",
          name: "Brookeville",
          state_id: "3942",
        },
        {
          id: "44767",
          name: "Brooklandville",
          state_id: "3942",
        },
        {
          id: "44768",
          name: "Brooklyn Park",
          state_id: "3942",
        },
        {
          id: "44769",
          name: "Burtonsville",
          state_id: "3942",
        },
        {
          id: "44770",
          name: "Calverton",
          state_id: "3942",
        },
        {
          id: "44771",
          name: "Cambridge",
          state_id: "3942",
        },
        {
          id: "44772",
          name: "Camp Springs",
          state_id: "3942",
        },
        {
          id: "44773",
          name: "Capitol Heights",
          state_id: "3942",
        },
        {
          id: "44774",
          name: "Carney",
          state_id: "3942",
        },
        {
          id: "44775",
          name: "Catonsville",
          state_id: "3942",
        },
        {
          id: "44776",
          name: "Chestertown",
          state_id: "3942",
        },
        {
          id: "44777",
          name: "Chillum",
          state_id: "3942",
        },
        {
          id: "44778",
          name: "Clarksburg",
          state_id: "3942",
        },
        {
          id: "44779",
          name: "Clarksville",
          state_id: "3942",
        },
        {
          id: "44780",
          name: "Clinton",
          state_id: "3942",
        },
        {
          id: "44781",
          name: "Cockeysville",
          state_id: "3942",
        },
        {
          id: "44782",
          name: "Colesville",
          state_id: "3942",
        },
        {
          id: "44783",
          name: "College Park",
          state_id: "3942",
        },
        {
          id: "44784",
          name: "Columbia",
          state_id: "3942",
        },
        {
          id: "44785",
          name: "Cooksville",
          state_id: "3942",
        },
        {
          id: "44786",
          name: "Coral Hills",
          state_id: "3942",
        },
        {
          id: "44787",
          name: "Crofton",
          state_id: "3942",
        },
        {
          id: "44788",
          name: "Cumberland",
          state_id: "3942",
        },
        {
          id: "44789",
          name: "Damascus",
          state_id: "3942",
        },
        {
          id: "44790",
          name: "Darlington",
          state_id: "3942",
        },
        {
          id: "44791",
          name: "District Heights",
          state_id: "3942",
        },
        {
          id: "44792",
          name: "Dundalk",
          state_id: "3942",
        },
        {
          id: "44793",
          name: "East Riverdale",
          state_id: "3942",
        },
        {
          id: "44794",
          name: "Easton",
          state_id: "3942",
        },
        {
          id: "44795",
          name: "Edgemere",
          state_id: "3942",
        },
        {
          id: "44796",
          name: "Edgewood",
          state_id: "3942",
        },
        {
          id: "44797",
          name: "Eldersburg",
          state_id: "3942",
        },
        {
          id: "44798",
          name: "Elkridge",
          state_id: "3942",
        },
        {
          id: "44799",
          name: "Elkton",
          state_id: "3942",
        },
        {
          id: "44800",
          name: "Ellicott City",
          state_id: "3942",
        },
        {
          id: "44801",
          name: "Essex",
          state_id: "3942",
        },
        {
          id: "44802",
          name: "Fairland",
          state_id: "3942",
        },
        {
          id: "44803",
          name: "Ferndale",
          state_id: "3942",
        },
        {
          id: "44804",
          name: "Forest Hill",
          state_id: "3942",
        },
        {
          id: "44805",
          name: "Forestville",
          state_id: "3942",
        },
        {
          id: "44806",
          name: "Fort Meade",
          state_id: "3942",
        },
        {
          id: "44807",
          name: "Fort Washington",
          state_id: "3942",
        },
        {
          id: "44808",
          name: "Frederick",
          state_id: "3942",
        },
        {
          id: "44809",
          name: "Fredrick",
          state_id: "3942",
        },
        {
          id: "44810",
          name: "Friendly",
          state_id: "3942",
        },
        {
          id: "44811",
          name: "Gaithersburg",
          state_id: "3942",
        },
        {
          id: "44812",
          name: "Germantown",
          state_id: "3942",
        },
        {
          id: "44813",
          name: "Glen Burnie",
          state_id: "3942",
        },
        {
          id: "44814",
          name: "Glenn Dale",
          state_id: "3942",
        },
        {
          id: "44815",
          name: "Greater Landover",
          state_id: "3942",
        },
        {
          id: "44816",
          name: "Greater Upper Marlboro",
          state_id: "3942",
        },
        {
          id: "44817",
          name: "Green Haven",
          state_id: "3942",
        },
        {
          id: "44818",
          name: "Green Valley",
          state_id: "3942",
        },
        {
          id: "44819",
          name: "Greenbelt",
          state_id: "3942",
        },
        {
          id: "44820",
          name: "Hagerstown",
          state_id: "3942",
        },
        {
          id: "44821",
          name: "Hanover",
          state_id: "3942",
        },
        {
          id: "44822",
          name: "Harmans",
          state_id: "3942",
        },
        {
          id: "44823",
          name: "Havre de Grace",
          state_id: "3942",
        },
        {
          id: "44824",
          name: "Hillandale",
          state_id: "3942",
        },
        {
          id: "44825",
          name: "Hillcrest Heights",
          state_id: "3942",
        },
        {
          id: "44826",
          name: "Hunt Valley",
          state_id: "3942",
        },
        {
          id: "44827",
          name: "Hurlock",
          state_id: "3942",
        },
        {
          id: "44828",
          name: "Hyattsville",
          state_id: "3942",
        },
        {
          id: "44829",
          name: "Ijamsville",
          state_id: "3942",
        },
        {
          id: "44830",
          name: "Jefferson",
          state_id: "3942",
        },
        {
          id: "44831",
          name: "Jessup",
          state_id: "3942",
        },
        {
          id: "44832",
          name: "Joppatowne",
          state_id: "3942",
        },
        {
          id: "44833",
          name: "Kettering",
          state_id: "3942",
        },
        {
          id: "44834",
          name: "Lake Shore",
          state_id: "3942",
        },
        {
          id: "44835",
          name: "Langley Park",
          state_id: "3942",
        },
        {
          id: "44836",
          name: "Lanham",
          state_id: "3942",
        },
        {
          id: "44837",
          name: "Lanham-Seabrook",
          state_id: "3942",
        },
        {
          id: "44838",
          name: "Lansdowne-Baltimore Highlands",
          state_id: "3942",
        },
        {
          id: "44839",
          name: "Largo",
          state_id: "3942",
        },
        {
          id: "44840",
          name: "Laurel",
          state_id: "3942",
        },
        {
          id: "44841",
          name: "Lexington Park",
          state_id: "3942",
        },
        {
          id: "44842",
          name: "Lochearn",
          state_id: "3942",
        },
        {
          id: "44843",
          name: "Lutherville-Timonium",
          state_id: "3942",
        },
        {
          id: "44844",
          name: "Marriottsville",
          state_id: "3942",
        },
        {
          id: "44845",
          name: "Maryland City",
          state_id: "3942",
        },
        {
          id: "44846",
          name: "Mays Chapel",
          state_id: "3942",
        },
        {
          id: "44847",
          name: "Middle River",
          state_id: "3942",
        },
        {
          id: "44848",
          name: "Milford Mill",
          state_id: "3942",
        },
        {
          id: "44849",
          name: "Millersville",
          state_id: "3942",
        },
        {
          id: "44850",
          name: "Mitchellville",
          state_id: "3942",
        },
        {
          id: "44851",
          name: "Montgomery Village",
          state_id: "3942",
        },
        {
          id: "44852",
          name: "National Harbor",
          state_id: "3942",
        },
        {
          id: "44853",
          name: "New Carrollton",
          state_id: "3942",
        },
        {
          id: "44854",
          name: "North Bethesda",
          state_id: "3942",
        },
        {
          id: "44855",
          name: "North Laurel",
          state_id: "3942",
        },
        {
          id: "44856",
          name: "North Potomac",
          state_id: "3942",
        },
        {
          id: "44857",
          name: "Odenton",
          state_id: "3942",
        },
        {
          id: "44858",
          name: "Olney",
          state_id: "3942",
        },
        {
          id: "44859",
          name: "Overlea",
          state_id: "3942",
        },
        {
          id: "44860",
          name: "Owings Mills",
          state_id: "3942",
        },
        {
          id: "44861",
          name: "Oxon Hill-Glassmanor",
          state_id: "3942",
        },
        {
          id: "44862",
          name: "Parkville",
          state_id: "3942",
        },
        {
          id: "44863",
          name: "Parole",
          state_id: "3942",
        },
        {
          id: "44864",
          name: "Pasadena",
          state_id: "3942",
        },
        {
          id: "44865",
          name: "Perry Hall",
          state_id: "3942",
        },
        {
          id: "44866",
          name: "Pikesville",
          state_id: "3942",
        },
        {
          id: "44867",
          name: "Poolesville",
          state_id: "3942",
        },
        {
          id: "44868",
          name: "Potomac",
          state_id: "3942",
        },
        {
          id: "44869",
          name: "Randallstown",
          state_id: "3942",
        },
        {
          id: "44870",
          name: "Redland",
          state_id: "3942",
        },
        {
          id: "44871",
          name: "Reisterstown",
          state_id: "3942",
        },
        {
          id: "44872",
          name: "Riviera Beach",
          state_id: "3942",
        },
        {
          id: "44873",
          name: "Rockville",
          state_id: "3942",
        },
        {
          id: "44874",
          name: "Rosaryville",
          state_id: "3942",
        },
        {
          id: "44875",
          name: "Rosedale",
          state_id: "3942",
        },
        {
          id: "44876",
          name: "Rossville",
          state_id: "3942",
        },
        {
          id: "44877",
          name: "Saint Charles",
          state_id: "3942",
        },
        {
          id: "44878",
          name: "Salisbury",
          state_id: "3942",
        },
        {
          id: "44879",
          name: "Sandy Spring",
          state_id: "3942",
        },
        {
          id: "44880",
          name: "Savage Guilford",
          state_id: "3942",
        },
        {
          id: "44881",
          name: "Severn",
          state_id: "3942",
        },
        {
          id: "44882",
          name: "Severna Park",
          state_id: "3942",
        },
        {
          id: "44883",
          name: "Silver Spring",
          state_id: "3942",
        },
        {
          id: "44884",
          name: "Snow Hill",
          state_id: "3942",
        },
        {
          id: "44885",
          name: "South Gate",
          state_id: "3942",
        },
        {
          id: "44886",
          name: "South Laurel",
          state_id: "3942",
        },
        {
          id: "44887",
          name: "Suitland-Silver Hill",
          state_id: "3942",
        },
        {
          id: "44888",
          name: "Takoma Park",
          state_id: "3942",
        },
        {
          id: "44889",
          name: "Temple Hill",
          state_id: "3942",
        },
        {
          id: "44890",
          name: "Thurmont",
          state_id: "3942",
        },
        {
          id: "44891",
          name: "Timonium",
          state_id: "3942",
        },
        {
          id: "44892",
          name: "Towson",
          state_id: "3942",
        },
        {
          id: "44893",
          name: "Upper Marlboro",
          state_id: "3942",
        },
        {
          id: "44894",
          name: "Waldorf",
          state_id: "3942",
        },
        {
          id: "44895",
          name: "Walker Mill",
          state_id: "3942",
        },
        {
          id: "44896",
          name: "Washington Grove",
          state_id: "3942",
        },
        {
          id: "44897",
          name: "Westminster",
          state_id: "3942",
        },
        {
          id: "44898",
          name: "Wheaton-Glenmont",
          state_id: "3942",
        },
        {
          id: "44899",
          name: "White Oak",
          state_id: "3942",
        },
        {
          id: "44900",
          name: "Windsor Mill",
          state_id: "3942",
        },
        {
          id: "44901",
          name: "Woodlawn",
          state_id: "3942",
        },
      ],
      Massachusetts: [
        {
          id: "44902",
          name: "Abington",
          state_id: "3943",
        },
        {
          id: "44903",
          name: "Acton",
          state_id: "3943",
        },
        {
          id: "44904",
          name: "Agawam",
          state_id: "3943",
        },
        {
          id: "44905",
          name: "Amesbury",
          state_id: "3943",
        },
        {
          id: "44906",
          name: "Amherst Center",
          state_id: "3943",
        },
        {
          id: "44907",
          name: "Arlington",
          state_id: "3943",
        },
        {
          id: "44908",
          name: "Ashland",
          state_id: "3943",
        },
        {
          id: "44909",
          name: "Athol",
          state_id: "3943",
        },
        {
          id: "44910",
          name: "Attleboro",
          state_id: "3943",
        },
        {
          id: "44911",
          name: "Barnstable Town",
          state_id: "3943",
        },
        {
          id: "44912",
          name: "Baxboro",
          state_id: "3943",
        },
        {
          id: "44913",
          name: "Becket",
          state_id: "3943",
        },
        {
          id: "44914",
          name: "Bedford",
          state_id: "3943",
        },
        {
          id: "44915",
          name: "Belmont",
          state_id: "3943",
        },
        {
          id: "44916",
          name: "Beverly",
          state_id: "3943",
        },
        {
          id: "44917",
          name: "Billerica",
          state_id: "3943",
        },
        {
          id: "44918",
          name: "Boston",
          state_id: "3943",
        },
        {
          id: "44919",
          name: "Boylston",
          state_id: "3943",
        },
        {
          id: "44920",
          name: "Braintree",
          state_id: "3943",
        },
        {
          id: "44921",
          name: "Brockton",
          state_id: "3943",
        },
        {
          id: "44922",
          name: "Brookfield",
          state_id: "3943",
        },
        {
          id: "44923",
          name: "Brookline",
          state_id: "3943",
        },
        {
          id: "44924",
          name: "Burlington",
          state_id: "3943",
        },
        {
          id: "44925",
          name: "Cambridge",
          state_id: "3943",
        },
        {
          id: "44926",
          name: "Canton",
          state_id: "3943",
        },
        {
          id: "44927",
          name: "Charlestown",
          state_id: "3943",
        },
        {
          id: "44928",
          name: "Chelmsford",
          state_id: "3943",
        },
        {
          id: "44929",
          name: "Chelsea",
          state_id: "3943",
        },
        {
          id: "44930",
          name: "Chicopee",
          state_id: "3943",
        },
        {
          id: "44931",
          name: "Clinton",
          state_id: "3943",
        },
        {
          id: "44932",
          name: "Concord",
          state_id: "3943",
        },
        {
          id: "44933",
          name: "Danvers",
          state_id: "3943",
        },
        {
          id: "44934",
          name: "Dedham",
          state_id: "3943",
        },
        {
          id: "44935",
          name: "Devens",
          state_id: "3943",
        },
        {
          id: "44936",
          name: "Devenscrest",
          state_id: "3943",
        },
        {
          id: "44937",
          name: "Duxbury",
          state_id: "3943",
        },
        {
          id: "44938",
          name: "Easthampton",
          state_id: "3943",
        },
        {
          id: "44939",
          name: "Everett",
          state_id: "3943",
        },
        {
          id: "44940",
          name: "Fairhaven",
          state_id: "3943",
        },
        {
          id: "44941",
          name: "Fall River",
          state_id: "3943",
        },
        {
          id: "44942",
          name: "Fitchburg",
          state_id: "3943",
        },
        {
          id: "44943",
          name: "Florence",
          state_id: "3943",
        },
        {
          id: "44944",
          name: "Framingham",
          state_id: "3943",
        },
        {
          id: "44945",
          name: "Franklin",
          state_id: "3943",
        },
        {
          id: "44946",
          name: "Gardner",
          state_id: "3943",
        },
        {
          id: "44947",
          name: "Gloucester",
          state_id: "3943",
        },
        {
          id: "44948",
          name: "Great Barrington",
          state_id: "3943",
        },
        {
          id: "44949",
          name: "Greenfield",
          state_id: "3943",
        },
        {
          id: "44950",
          name: "Groton",
          state_id: "3943",
        },
        {
          id: "44951",
          name: "Hadley",
          state_id: "3943",
        },
        {
          id: "44952",
          name: "Harvard",
          state_id: "3943",
        },
        {
          id: "44953",
          name: "Haverhill",
          state_id: "3943",
        },
        {
          id: "44954",
          name: "Hingham",
          state_id: "3943",
        },
        {
          id: "44955",
          name: "Holbrook",
          state_id: "3943",
        },
        {
          id: "44956",
          name: "Holliston",
          state_id: "3943",
        },
        {
          id: "44957",
          name: "Holyoke",
          state_id: "3943",
        },
        {
          id: "44958",
          name: "Hopedale",
          state_id: "3943",
        },
        {
          id: "44959",
          name: "Housatonic",
          state_id: "3943",
        },
        {
          id: "44960",
          name: "Hubbardston",
          state_id: "3943",
        },
        {
          id: "44961",
          name: "Hudson",
          state_id: "3943",
        },
        {
          id: "44962",
          name: "Hull",
          state_id: "3943",
        },
        {
          id: "44963",
          name: "Hyannis",
          state_id: "3943",
        },
        {
          id: "44964",
          name: "Ipswich",
          state_id: "3943",
        },
        {
          id: "44965",
          name: "Jamaica Plain",
          state_id: "3943",
        },
        {
          id: "44966",
          name: "Lawrence",
          state_id: "3943",
        },
        {
          id: "44967",
          name: "Lee",
          state_id: "3943",
        },
        {
          id: "44968",
          name: "Lenox",
          state_id: "3943",
        },
        {
          id: "44969",
          name: "Leominster",
          state_id: "3943",
        },
        {
          id: "44970",
          name: "Lexington",
          state_id: "3943",
        },
        {
          id: "44971",
          name: "Longmeadow",
          state_id: "3943",
        },
        {
          id: "44972",
          name: "Lowell",
          state_id: "3943",
        },
        {
          id: "44973",
          name: "Lynn",
          state_id: "3943",
        },
        {
          id: "44974",
          name: "Lynnfield",
          state_id: "3943",
        },
        {
          id: "44975",
          name: "Malden",
          state_id: "3943",
        },
        {
          id: "44976",
          name: "Manchester",
          state_id: "3943",
        },
        {
          id: "44977",
          name: "Marblehead",
          state_id: "3943",
        },
        {
          id: "44978",
          name: "Marion",
          state_id: "3943",
        },
        {
          id: "44979",
          name: "Marlborough",
          state_id: "3943",
        },
        {
          id: "44980",
          name: "Marshfield",
          state_id: "3943",
        },
        {
          id: "44981",
          name: "Massachusetts",
          state_id: "3943",
        },
        {
          id: "44982",
          name: "Maynard",
          state_id: "3943",
        },
        {
          id: "44983",
          name: "Medfield",
          state_id: "3943",
        },
        {
          id: "44984",
          name: "Medford",
          state_id: "3943",
        },
        {
          id: "44985",
          name: "Medway",
          state_id: "3943",
        },
        {
          id: "44986",
          name: "Melrose",
          state_id: "3943",
        },
        {
          id: "44987",
          name: "Methuen",
          state_id: "3943",
        },
        {
          id: "44988",
          name: "Middleboro",
          state_id: "3943",
        },
        {
          id: "44989",
          name: "Milford",
          state_id: "3943",
        },
        {
          id: "44990",
          name: "Milton",
          state_id: "3943",
        },
        {
          id: "44991",
          name: "Monson",
          state_id: "3943",
        },
        {
          id: "44992",
          name: "Montague",
          state_id: "3943",
        },
        {
          id: "44993",
          name: "Nantucket",
          state_id: "3943",
        },
        {
          id: "44994",
          name: "Natick",
          state_id: "3943",
        },
        {
          id: "44995",
          name: "Needham",
          state_id: "3943",
        },
        {
          id: "44996",
          name: "New Bedford",
          state_id: "3943",
        },
        {
          id: "44997",
          name: "Newburyport",
          state_id: "3943",
        },
        {
          id: "44998",
          name: "Newton",
          state_id: "3943",
        },
        {
          id: "44999",
          name: "North Adams",
          state_id: "3943",
        },
        {
          id: "45000",
          name: "North Andover",
          state_id: "3943",
        },
        {
          id: "45001",
          name: "North Attleborough Center",
          state_id: "3943",
        },
        {
          id: "45002",
          name: "North Easton",
          state_id: "3943",
        },
        {
          id: "45003",
          name: "Northampton",
          state_id: "3943",
        },
        {
          id: "45004",
          name: "Northborough",
          state_id: "3943",
        },
        {
          id: "45005",
          name: "Norwood",
          state_id: "3943",
        },
        {
          id: "45006",
          name: "Orleans",
          state_id: "3943",
        },
        {
          id: "45007",
          name: "Peabody",
          state_id: "3943",
        },
        {
          id: "45008",
          name: "Pepperell",
          state_id: "3943",
        },
        {
          id: "45009",
          name: "Pittsfield",
          state_id: "3943",
        },
        {
          id: "45010",
          name: "Plainfield",
          state_id: "3943",
        },
        {
          id: "45011",
          name: "Plymouth",
          state_id: "3943",
        },
        {
          id: "45012",
          name: "Provincetown",
          state_id: "3943",
        },
        {
          id: "45013",
          name: "Quincy",
          state_id: "3943",
        },
        {
          id: "45014",
          name: "Randolph",
          state_id: "3943",
        },
        {
          id: "45015",
          name: "Reading",
          state_id: "3943",
        },
        {
          id: "45016",
          name: "Rehoboth",
          state_id: "3943",
        },
        {
          id: "45017",
          name: "Revere",
          state_id: "3943",
        },
        {
          id: "45018",
          name: "Rockland",
          state_id: "3943",
        },
        {
          id: "45019",
          name: "Rockport",
          state_id: "3943",
        },
        {
          id: "45020",
          name: "Roslindale",
          state_id: "3943",
        },
        {
          id: "45021",
          name: "Salem",
          state_id: "3943",
        },
        {
          id: "45022",
          name: "Saugus",
          state_id: "3943",
        },
        {
          id: "45023",
          name: "Scituate",
          state_id: "3943",
        },
        {
          id: "45024",
          name: "Seekonk",
          state_id: "3943",
        },
        {
          id: "45025",
          name: "Shelburne Falls",
          state_id: "3943",
        },
        {
          id: "45026",
          name: "Sherborn",
          state_id: "3943",
        },
        {
          id: "45027",
          name: "Shrewsbury",
          state_id: "3943",
        },
        {
          id: "45028",
          name: "Somerset",
          state_id: "3943",
        },
        {
          id: "45029",
          name: "Somerville",
          state_id: "3943",
        },
        {
          id: "45030",
          name: "South Boston",
          state_id: "3943",
        },
        {
          id: "45031",
          name: "South Deerfield",
          state_id: "3943",
        },
        {
          id: "45032",
          name: "South Hadley",
          state_id: "3943",
        },
        {
          id: "45033",
          name: "South Lee",
          state_id: "3943",
        },
        {
          id: "45034",
          name: "South Yarmouth",
          state_id: "3943",
        },
        {
          id: "45035",
          name: "Southborough",
          state_id: "3943",
        },
        {
          id: "45036",
          name: "Southbridge",
          state_id: "3943",
        },
        {
          id: "45037",
          name: "Southwick",
          state_id: "3943",
        },
        {
          id: "45038",
          name: "Springfield",
          state_id: "3943",
        },
        {
          id: "45039",
          name: "Stoneham",
          state_id: "3943",
        },
        {
          id: "45040",
          name: "Sturbridge",
          state_id: "3943",
        },
        {
          id: "45041",
          name: "Swampscott",
          state_id: "3943",
        },
        {
          id: "45042",
          name: "Swansea",
          state_id: "3943",
        },
        {
          id: "45043",
          name: "Taunton",
          state_id: "3943",
        },
        {
          id: "45044",
          name: "Tewksbury",
          state_id: "3943",
        },
        {
          id: "45045",
          name: "Three Rivers",
          state_id: "3943",
        },
        {
          id: "45046",
          name: "Truro",
          state_id: "3943",
        },
        {
          id: "45047",
          name: "Upton",
          state_id: "3943",
        },
        {
          id: "45048",
          name: "Vineyard Haven",
          state_id: "3943",
        },
        {
          id: "45049",
          name: "Wakefield",
          state_id: "3943",
        },
        {
          id: "45050",
          name: "Waltham",
          state_id: "3943",
        },
        {
          id: "45051",
          name: "Ware",
          state_id: "3943",
        },
        {
          id: "45052",
          name: "Wareham",
          state_id: "3943",
        },
        {
          id: "45053",
          name: "Watertown",
          state_id: "3943",
        },
        {
          id: "45054",
          name: "Wayland",
          state_id: "3943",
        },
        {
          id: "45055",
          name: "Webster",
          state_id: "3943",
        },
        {
          id: "45056",
          name: "Wellesley",
          state_id: "3943",
        },
        {
          id: "45057",
          name: "Wellesley Hills",
          state_id: "3943",
        },
        {
          id: "45058",
          name: "West Concord",
          state_id: "3943",
        },
        {
          id: "45059",
          name: "West Roxbury",
          state_id: "3943",
        },
        {
          id: "45060",
          name: "West Springfield",
          state_id: "3943",
        },
        {
          id: "45061",
          name: "West Yarmouth",
          state_id: "3943",
        },
        {
          id: "45062",
          name: "Westborough",
          state_id: "3943",
        },
        {
          id: "45063",
          name: "Westfield",
          state_id: "3943",
        },
        {
          id: "45064",
          name: "Westford",
          state_id: "3943",
        },
        {
          id: "45065",
          name: "Weston",
          state_id: "3943",
        },
        {
          id: "45066",
          name: "Weymouth",
          state_id: "3943",
        },
        {
          id: "45067",
          name: "Wilbraham",
          state_id: "3943",
        },
        {
          id: "45068",
          name: "Wilmington",
          state_id: "3943",
        },
        {
          id: "45069",
          name: "Winchester",
          state_id: "3943",
        },
        {
          id: "45070",
          name: "Winthrop",
          state_id: "3943",
        },
        {
          id: "45071",
          name: "Woburn",
          state_id: "3943",
        },
        {
          id: "45072",
          name: "Worcester",
          state_id: "3943",
        },
        {
          id: "45073",
          name: "Yarmouthport",
          state_id: "3943",
        },
      ],
      Michigan: [
        {
          id: "45074",
          name: "Adrian",
          state_id: "3945",
        },
        {
          id: "45075",
          name: "Albion",
          state_id: "3945",
        },
        {
          id: "45076",
          name: "Allegan",
          state_id: "3945",
        },
        {
          id: "45077",
          name: "Allen Park",
          state_id: "3945",
        },
        {
          id: "45078",
          name: "Alma",
          state_id: "3945",
        },
        {
          id: "45079",
          name: "Alpena",
          state_id: "3945",
        },
        {
          id: "45080",
          name: "Ann Arbor",
          state_id: "3945",
        },
        {
          id: "45081",
          name: "Attica",
          state_id: "3945",
        },
        {
          id: "45082",
          name: "Auburn Hills",
          state_id: "3945",
        },
        {
          id: "45083",
          name: "Battle Creek",
          state_id: "3945",
        },
        {
          id: "45084",
          name: "Bay City",
          state_id: "3945",
        },
        {
          id: "45085",
          name: "Beecher",
          state_id: "3945",
        },
        {
          id: "45086",
          name: "Belleville",
          state_id: "3945",
        },
        {
          id: "45087",
          name: "Benton Harbor",
          state_id: "3945",
        },
        {
          id: "45088",
          name: "Berkley",
          state_id: "3945",
        },
        {
          id: "45089",
          name: "Beverly Hills",
          state_id: "3945",
        },
        {
          id: "45090",
          name: "Big Rapids",
          state_id: "3945",
        },
        {
          id: "45091",
          name: "Birmingham",
          state_id: "3945",
        },
        {
          id: "45092",
          name: "Bloomfield Hills",
          state_id: "3945",
        },
        {
          id: "45093",
          name: "Bloomfield Township",
          state_id: "3945",
        },
        {
          id: "45094",
          name: "Boyne City",
          state_id: "3945",
        },
        {
          id: "45095",
          name: "Brighton",
          state_id: "3945",
        },
        {
          id: "45096",
          name: "Burt",
          state_id: "3945",
        },
        {
          id: "45097",
          name: "Burton",
          state_id: "3945",
        },
        {
          id: "45098",
          name: "Cadillac",
          state_id: "3945",
        },
        {
          id: "45099",
          name: "Canton",
          state_id: "3945",
        },
        {
          id: "45100",
          name: "Charlotte",
          state_id: "3945",
        },
        {
          id: "45101",
          name: "Chesterfield",
          state_id: "3945",
        },
        {
          id: "45102",
          name: "Clarkston",
          state_id: "3945",
        },
        {
          id: "45103",
          name: "Clawson",
          state_id: "3945",
        },
        {
          id: "45104",
          name: "Clinton",
          state_id: "3945",
        },
        {
          id: "45105",
          name: "Commerce",
          state_id: "3945",
        },
        {
          id: "45106",
          name: "Comstock Park",
          state_id: "3945",
        },
        {
          id: "45107",
          name: "Coopersville",
          state_id: "3945",
        },
        {
          id: "45108",
          name: "Cornell",
          state_id: "3945",
        },
        {
          id: "45109",
          name: "Cutlerville",
          state_id: "3945",
        },
        {
          id: "45110",
          name: "Davisburg",
          state_id: "3945",
        },
        {
          id: "45111",
          name: "Dearborn",
          state_id: "3945",
        },
        {
          id: "45112",
          name: "Dearborn Heights",
          state_id: "3945",
        },
        {
          id: "45113",
          name: "Delton",
          state_id: "3945",
        },
        {
          id: "45114",
          name: "Detroit",
          state_id: "3945",
        },
        {
          id: "45115",
          name: "Dexter",
          state_id: "3945",
        },
        {
          id: "45116",
          name: "Dowagiac",
          state_id: "3945",
        },
        {
          id: "45117",
          name: "East Grand Rapids",
          state_id: "3945",
        },
        {
          id: "45118",
          name: "East Lansing",
          state_id: "3945",
        },
        {
          id: "45119",
          name: "Eastpointe",
          state_id: "3945",
        },
        {
          id: "45120",
          name: "Ecorse",
          state_id: "3945",
        },
        {
          id: "45121",
          name: "Escanaba",
          state_id: "3945",
        },
        {
          id: "45122",
          name: "Evart",
          state_id: "3945",
        },
        {
          id: "45123",
          name: "Fair Haven",
          state_id: "3945",
        },
        {
          id: "45124",
          name: "Fairgrove",
          state_id: "3945",
        },
        {
          id: "45125",
          name: "Farmington",
          state_id: "3945",
        },
        {
          id: "45126",
          name: "Farmington Hills",
          state_id: "3945",
        },
        {
          id: "45127",
          name: "Fenton",
          state_id: "3945",
        },
        {
          id: "45128",
          name: "Ferndale",
          state_id: "3945",
        },
        {
          id: "45129",
          name: "Flint",
          state_id: "3945",
        },
        {
          id: "45130",
          name: "Forest Hills",
          state_id: "3945",
        },
        {
          id: "45131",
          name: "Fowlerville",
          state_id: "3945",
        },
        {
          id: "45132",
          name: "Frankenmuth",
          state_id: "3945",
        },
        {
          id: "45133",
          name: "Fraser",
          state_id: "3945",
        },
        {
          id: "45134",
          name: "Fremont",
          state_id: "3945",
        },
        {
          id: "45135",
          name: "Fruitport",
          state_id: "3945",
        },
        {
          id: "45136",
          name: "Garden City",
          state_id: "3945",
        },
        {
          id: "45137",
          name: "Goodrich",
          state_id: "3945",
        },
        {
          id: "45138",
          name: "Grand Blanc",
          state_id: "3945",
        },
        {
          id: "45139",
          name: "Grand Haven",
          state_id: "3945",
        },
        {
          id: "45140",
          name: "Grand Rapids",
          state_id: "3945",
        },
        {
          id: "45141",
          name: "Grandville",
          state_id: "3945",
        },
        {
          id: "45142",
          name: "Grosse Ile",
          state_id: "3945",
        },
        {
          id: "45143",
          name: "Grosse Pointe Farms",
          state_id: "3945",
        },
        {
          id: "45144",
          name: "Grosse Pointe Park",
          state_id: "3945",
        },
        {
          id: "45145",
          name: "Grosse Pointe Woods",
          state_id: "3945",
        },
        {
          id: "45146",
          name: "Gwinn",
          state_id: "3945",
        },
        {
          id: "45147",
          name: "Hamtramck",
          state_id: "3945",
        },
        {
          id: "45148",
          name: "Hancock",
          state_id: "3945",
        },
        {
          id: "45149",
          name: "Harper Woods",
          state_id: "3945",
        },
        {
          id: "45150",
          name: "Harrison",
          state_id: "3945",
        },
        {
          id: "45151",
          name: "Haslett",
          state_id: "3945",
        },
        {
          id: "45152",
          name: "Hazel Park",
          state_id: "3945",
        },
        {
          id: "45153",
          name: "Highland Park",
          state_id: "3945",
        },
        {
          id: "45154",
          name: "Holland",
          state_id: "3945",
        },
        {
          id: "45155",
          name: "Holly",
          state_id: "3945",
        },
        {
          id: "45156",
          name: "Holt",
          state_id: "3945",
        },
        {
          id: "45157",
          name: "Houghton",
          state_id: "3945",
        },
        {
          id: "45158",
          name: "Hudsonville",
          state_id: "3945",
        },
        {
          id: "45159",
          name: "Huntington Woods",
          state_id: "3945",
        },
        {
          id: "45160",
          name: "Imlay",
          state_id: "3945",
        },
        {
          id: "45161",
          name: "Inkster",
          state_id: "3945",
        },
        {
          id: "45162",
          name: "Jackon",
          state_id: "3945",
        },
        {
          id: "45163",
          name: "Jackson",
          state_id: "3945",
        },
        {
          id: "45164",
          name: "Jenison",
          state_id: "3945",
        },
        {
          id: "45165",
          name: "Kalamazoo",
          state_id: "3945",
        },
        {
          id: "45166",
          name: "Kalkaska",
          state_id: "3945",
        },
        {
          id: "45167",
          name: "Kentwood",
          state_id: "3945",
        },
        {
          id: "45168",
          name: "Kingsford",
          state_id: "3945",
        },
        {
          id: "45169",
          name: "Lansing",
          state_id: "3945",
        },
        {
          id: "45170",
          name: "Lapeer",
          state_id: "3945",
        },
        {
          id: "45171",
          name: "Lincoln Park",
          state_id: "3945",
        },
        {
          id: "45172",
          name: "Litchfield",
          state_id: "3945",
        },
        {
          id: "45173",
          name: "Livonia",
          state_id: "3945",
        },
        {
          id: "45174",
          name: "Ludington",
          state_id: "3945",
        },
        {
          id: "45175",
          name: "Macomb",
          state_id: "3945",
        },
        {
          id: "45176",
          name: "Madison Heights",
          state_id: "3945",
        },
        {
          id: "45177",
          name: "Manistee",
          state_id: "3945",
        },
        {
          id: "45178",
          name: "Marquette",
          state_id: "3945",
        },
        {
          id: "45179",
          name: "Marysville",
          state_id: "3945",
        },
        {
          id: "45180",
          name: "Melvindale",
          state_id: "3945",
        },
        {
          id: "45181",
          name: "Midland",
          state_id: "3945",
        },
        {
          id: "45182",
          name: "Monroe",
          state_id: "3945",
        },
        {
          id: "45183",
          name: "Mount Clemens",
          state_id: "3945",
        },
        {
          id: "45184",
          name: "Mount Morris",
          state_id: "3945",
        },
        {
          id: "45185",
          name: "Mount Pleasant",
          state_id: "3945",
        },
        {
          id: "45186",
          name: "Mt. Pleasant",
          state_id: "3945",
        },
        {
          id: "45187",
          name: "Muskegon",
          state_id: "3945",
        },
        {
          id: "45188",
          name: "Muskegon Heights",
          state_id: "3945",
        },
        {
          id: "45189",
          name: "New Hudson",
          state_id: "3945",
        },
        {
          id: "45190",
          name: "Newaygo",
          state_id: "3945",
        },
        {
          id: "45191",
          name: "Niles",
          state_id: "3945",
        },
        {
          id: "45192",
          name: "Northview",
          state_id: "3945",
        },
        {
          id: "45193",
          name: "Northville",
          state_id: "3945",
        },
        {
          id: "45194",
          name: "Norton Shores",
          state_id: "3945",
        },
        {
          id: "45195",
          name: "Novi",
          state_id: "3945",
        },
        {
          id: "45196",
          name: "Oak Park",
          state_id: "3945",
        },
        {
          id: "45197",
          name: "Okemos",
          state_id: "3945",
        },
        {
          id: "45198",
          name: "Oscoda",
          state_id: "3945",
        },
        {
          id: "45199",
          name: "Owosso",
          state_id: "3945",
        },
        {
          id: "45200",
          name: "Oxford",
          state_id: "3945",
        },
        {
          id: "45201",
          name: "Petoskey",
          state_id: "3945",
        },
        {
          id: "45202",
          name: "Pinckney",
          state_id: "3945",
        },
        {
          id: "45203",
          name: "Plymouth Township",
          state_id: "3945",
        },
        {
          id: "45204",
          name: "Pontiac",
          state_id: "3945",
        },
        {
          id: "45205",
          name: "Port Huron",
          state_id: "3945",
        },
        {
          id: "45206",
          name: "Portage",
          state_id: "3945",
        },
        {
          id: "45207",
          name: "Redford",
          state_id: "3945",
        },
        {
          id: "45208",
          name: "Reese",
          state_id: "3945",
        },
        {
          id: "45209",
          name: "River Rouge",
          state_id: "3945",
        },
        {
          id: "45210",
          name: "Riverview",
          state_id: "3945",
        },
        {
          id: "45211",
          name: "Rochester Hills",
          state_id: "3945",
        },
        {
          id: "45212",
          name: "Rockford",
          state_id: "3945",
        },
        {
          id: "45213",
          name: "Romeo",
          state_id: "3945",
        },
        {
          id: "45214",
          name: "Romulus",
          state_id: "3945",
        },
        {
          id: "45215",
          name: "Roseville",
          state_id: "3945",
        },
        {
          id: "45216",
          name: "Royal Oak",
          state_id: "3945",
        },
        {
          id: "45217",
          name: "Saginaw",
          state_id: "3945",
        },
        {
          id: "45218",
          name: "Saginaw Township North",
          state_id: "3945",
        },
        {
          id: "45219",
          name: "Saginaw Township South",
          state_id: "3945",
        },
        {
          id: "45220",
          name: "Saint Clair Shores",
          state_id: "3945",
        },
        {
          id: "45221",
          name: "Saint Louis",
          state_id: "3945",
        },
        {
          id: "45222",
          name: "Saline",
          state_id: "3945",
        },
        {
          id: "45223",
          name: "Saugatuck",
          state_id: "3945",
        },
        {
          id: "45224",
          name: "Sault Sainte Marie",
          state_id: "3945",
        },
        {
          id: "45225",
          name: "Schoolcraft",
          state_id: "3945",
        },
        {
          id: "45226",
          name: "Shelby",
          state_id: "3945",
        },
        {
          id: "45227",
          name: "Southfield",
          state_id: "3945",
        },
        {
          id: "45228",
          name: "Southgate",
          state_id: "3945",
        },
        {
          id: "45229",
          name: "Sterling Heights",
          state_id: "3945",
        },
        {
          id: "45230",
          name: "Sturgis",
          state_id: "3945",
        },
        {
          id: "45231",
          name: "Taylor",
          state_id: "3945",
        },
        {
          id: "45232",
          name: "Traverse City",
          state_id: "3945",
        },
        {
          id: "45233",
          name: "Trenton",
          state_id: "3945",
        },
        {
          id: "45234",
          name: "Troy",
          state_id: "3945",
        },
        {
          id: "45235",
          name: "Walker",
          state_id: "3945",
        },
        {
          id: "45236",
          name: "Walled Lake",
          state_id: "3945",
        },
        {
          id: "45237",
          name: "Warren",
          state_id: "3945",
        },
        {
          id: "45238",
          name: "Waterford",
          state_id: "3945",
        },
        {
          id: "45239",
          name: "Waverly",
          state_id: "3945",
        },
        {
          id: "45240",
          name: "Wayne",
          state_id: "3945",
        },
        {
          id: "45241",
          name: "West Bloomfield Township",
          state_id: "3945",
        },
        {
          id: "45242",
          name: "Westland",
          state_id: "3945",
        },
        {
          id: "45243",
          name: "White Lake",
          state_id: "3945",
        },
        {
          id: "45244",
          name: "Whitmore Lake",
          state_id: "3945",
        },
        {
          id: "45245",
          name: "Williamston",
          state_id: "3945",
        },
        {
          id: "45246",
          name: "Wixom",
          state_id: "3945",
        },
        {
          id: "45247",
          name: "Woodhaven",
          state_id: "3945",
        },
        {
          id: "45248",
          name: "Wyandotte",
          state_id: "3945",
        },
        {
          id: "45249",
          name: "Wyoming",
          state_id: "3945",
        },
        {
          id: "45250",
          name: "Ypsilanti",
          state_id: "3945",
        },
      ],
      Minnesota: [
        {
          id: "45251",
          name: "Albert Lea",
          state_id: "3946",
        },
        {
          id: "45252",
          name: "Alger",
          state_id: "3946",
        },
        {
          id: "45253",
          name: "Andover",
          state_id: "3946",
        },
        {
          id: "45254",
          name: "Annandale",
          state_id: "3946",
        },
        {
          id: "45255",
          name: "Anoka",
          state_id: "3946",
        },
        {
          id: "45256",
          name: "Apple Valley",
          state_id: "3946",
        },
        {
          id: "45257",
          name: "Austin",
          state_id: "3946",
        },
        {
          id: "45258",
          name: "Baxter",
          state_id: "3946",
        },
        {
          id: "45259",
          name: "Bemidji",
          state_id: "3946",
        },
        {
          id: "45260",
          name: "Blaine",
          state_id: "3946",
        },
        {
          id: "45261",
          name: "Blomkest",
          state_id: "3946",
        },
        {
          id: "45262",
          name: "Bloomington",
          state_id: "3946",
        },
        {
          id: "45263",
          name: "Blue Earth",
          state_id: "3946",
        },
        {
          id: "45264",
          name: "Brainerd",
          state_id: "3946",
        },
        {
          id: "45265",
          name: "Brooklyn Center",
          state_id: "3946",
        },
        {
          id: "45266",
          name: "Brooklyn Park",
          state_id: "3946",
        },
        {
          id: "45267",
          name: "Burnsville",
          state_id: "3946",
        },
        {
          id: "45268",
          name: "Champlin",
          state_id: "3946",
        },
        {
          id: "45269",
          name: "Chanhassen",
          state_id: "3946",
        },
        {
          id: "45270",
          name: "Chaska",
          state_id: "3946",
        },
        {
          id: "45271",
          name: "Chatfield",
          state_id: "3946",
        },
        {
          id: "45272",
          name: "Circle Pines",
          state_id: "3946",
        },
        {
          id: "45273",
          name: "Cloquet",
          state_id: "3946",
        },
        {
          id: "45274",
          name: "Cokato",
          state_id: "3946",
        },
        {
          id: "45275",
          name: "Columbia Heights",
          state_id: "3946",
        },
        {
          id: "45276",
          name: "Coon Rapids",
          state_id: "3946",
        },
        {
          id: "45277",
          name: "Cottage Grove",
          state_id: "3946",
        },
        {
          id: "45278",
          name: "Crystal",
          state_id: "3946",
        },
        {
          id: "45279",
          name: "Duluth",
          state_id: "3946",
        },
        {
          id: "45280",
          name: "Eagan",
          state_id: "3946",
        },
        {
          id: "45281",
          name: "East Bethel",
          state_id: "3946",
        },
        {
          id: "45282",
          name: "Eden Prairie",
          state_id: "3946",
        },
        {
          id: "45283",
          name: "Edina",
          state_id: "3946",
        },
        {
          id: "45284",
          name: "Elk River",
          state_id: "3946",
        },
        {
          id: "45285",
          name: "Ely",
          state_id: "3946",
        },
        {
          id: "45286",
          name: "Fairmont",
          state_id: "3946",
        },
        {
          id: "45287",
          name: "Faribault",
          state_id: "3946",
        },
        {
          id: "45288",
          name: "Farmington",
          state_id: "3946",
        },
        {
          id: "45289",
          name: "Fergus Falls",
          state_id: "3946",
        },
        {
          id: "45290",
          name: "Frazee",
          state_id: "3946",
        },
        {
          id: "45291",
          name: "Fridley",
          state_id: "3946",
        },
        {
          id: "45292",
          name: "Golden Valley",
          state_id: "3946",
        },
        {
          id: "45293",
          name: "Grand Rapids",
          state_id: "3946",
        },
        {
          id: "45294",
          name: "Ham Lake",
          state_id: "3946",
        },
        {
          id: "45295",
          name: "Hamel",
          state_id: "3946",
        },
        {
          id: "45296",
          name: "Hastings",
          state_id: "3946",
        },
        {
          id: "45297",
          name: "Hibbing",
          state_id: "3946",
        },
        {
          id: "45298",
          name: "Hopkins",
          state_id: "3946",
        },
        {
          id: "45299",
          name: "Houston",
          state_id: "3946",
        },
        {
          id: "45300",
          name: "Hutchinson",
          state_id: "3946",
        },
        {
          id: "45301",
          name: "Inver Grove Heights",
          state_id: "3946",
        },
        {
          id: "45302",
          name: "Isanti",
          state_id: "3946",
        },
        {
          id: "45303",
          name: "LaCrescent",
          state_id: "3946",
        },
        {
          id: "45304",
          name: "Lakeville",
          state_id: "3946",
        },
        {
          id: "45305",
          name: "Le Sueur",
          state_id: "3946",
        },
        {
          id: "45306",
          name: "Lino Lakes",
          state_id: "3946",
        },
        {
          id: "45307",
          name: "Litchfield",
          state_id: "3946",
        },
        {
          id: "45308",
          name: "Mankato",
          state_id: "3946",
        },
        {
          id: "45309",
          name: "Maple Grove",
          state_id: "3946",
        },
        {
          id: "45310",
          name: "Maplewood",
          state_id: "3946",
        },
        {
          id: "45311",
          name: "Marshall",
          state_id: "3946",
        },
        {
          id: "45312",
          name: "Mendota Heights",
          state_id: "3946",
        },
        {
          id: "45313",
          name: "Minneapolis",
          state_id: "3946",
        },
        {
          id: "45314",
          name: "Minnetonka",
          state_id: "3946",
        },
        {
          id: "45315",
          name: "Moorhead",
          state_id: "3946",
        },
        {
          id: "45316",
          name: "Mounds View",
          state_id: "3946",
        },
        {
          id: "45317",
          name: "Nelson",
          state_id: "3946",
        },
        {
          id: "45318",
          name: "New Brighton",
          state_id: "3946",
        },
        {
          id: "45319",
          name: "New Hope",
          state_id: "3946",
        },
        {
          id: "45320",
          name: "New Ulm",
          state_id: "3946",
        },
        {
          id: "45321",
          name: "North Mankato",
          state_id: "3946",
        },
        {
          id: "45322",
          name: "North Saint Paul",
          state_id: "3946",
        },
        {
          id: "45323",
          name: "Northfield",
          state_id: "3946",
        },
        {
          id: "45324",
          name: "Oakdale",
          state_id: "3946",
        },
        {
          id: "45325",
          name: "Onamia",
          state_id: "3946",
        },
        {
          id: "45326",
          name: "Owatonna",
          state_id: "3946",
        },
        {
          id: "45327",
          name: "Pequot Lakes",
          state_id: "3946",
        },
        {
          id: "45328",
          name: "Plymouth",
          state_id: "3946",
        },
        {
          id: "45329",
          name: "Prior Lake",
          state_id: "3946",
        },
        {
          id: "45330",
          name: "Ramsey",
          state_id: "3946",
        },
        {
          id: "45331",
          name: "Red Wing",
          state_id: "3946",
        },
        {
          id: "45332",
          name: "Renville",
          state_id: "3946",
        },
        {
          id: "45333",
          name: "Richfield",
          state_id: "3946",
        },
        {
          id: "45334",
          name: "Robbinsdale",
          state_id: "3946",
        },
        {
          id: "45335",
          name: "Rochester",
          state_id: "3946",
        },
        {
          id: "45336",
          name: "Rosemount",
          state_id: "3946",
        },
        {
          id: "45337",
          name: "Roseville",
          state_id: "3946",
        },
        {
          id: "45338",
          name: "Royalton",
          state_id: "3946",
        },
        {
          id: "45339",
          name: "Saint Cloud",
          state_id: "3946",
        },
        {
          id: "45340",
          name: "Saint Louis Park",
          state_id: "3946",
        },
        {
          id: "45341",
          name: "Saint Michael",
          state_id: "3946",
        },
        {
          id: "45342",
          name: "Saint Paul",
          state_id: "3946",
        },
        {
          id: "45343",
          name: "Saint Peter",
          state_id: "3946",
        },
        {
          id: "45344",
          name: "Sauk Rapids",
          state_id: "3946",
        },
        {
          id: "45345",
          name: "Savage",
          state_id: "3946",
        },
        {
          id: "45346",
          name: "Shakopee",
          state_id: "3946",
        },
        {
          id: "45347",
          name: "Shoreview",
          state_id: "3946",
        },
        {
          id: "45348",
          name: "South Saint Paul",
          state_id: "3946",
        },
        {
          id: "45349",
          name: "St. Paul",
          state_id: "3946",
        },
        {
          id: "45350",
          name: "Stewartville",
          state_id: "3946",
        },
        {
          id: "45351",
          name: "Stillwater",
          state_id: "3946",
        },
        {
          id: "45352",
          name: "Vadnais Heights",
          state_id: "3946",
        },
        {
          id: "45353",
          name: "Waconia",
          state_id: "3946",
        },
        {
          id: "45354",
          name: "Wadena",
          state_id: "3946",
        },
        {
          id: "45355",
          name: "West Saint Paul",
          state_id: "3946",
        },
        {
          id: "45356",
          name: "White Bear Lake",
          state_id: "3946",
        },
        {
          id: "45357",
          name: "Willmar",
          state_id: "3946",
        },
        {
          id: "45358",
          name: "Winona",
          state_id: "3946",
        },
        {
          id: "45359",
          name: "Woodbury",
          state_id: "3946",
        },
        {
          id: "45360",
          name: "Worthington",
          state_id: "3946",
        },
      ],
      Mississippi: [
        {
          id: "45361",
          name: "Bay Saint Louis",
          state_id: "3947",
        },
        {
          id: "45362",
          name: "Biloxi",
          state_id: "3947",
        },
        {
          id: "45363",
          name: "Brandon",
          state_id: "3947",
        },
        {
          id: "45364",
          name: "Brookhaven",
          state_id: "3947",
        },
        {
          id: "45365",
          name: "Byhalia",
          state_id: "3947",
        },
        {
          id: "45366",
          name: "Byram",
          state_id: "3947",
        },
        {
          id: "45367",
          name: "Canton",
          state_id: "3947",
        },
        {
          id: "45368",
          name: "Clarksdale",
          state_id: "3947",
        },
        {
          id: "45369",
          name: "Cleveland",
          state_id: "3947",
        },
        {
          id: "45370",
          name: "Clinton",
          state_id: "3947",
        },
        {
          id: "45371",
          name: "Columbus",
          state_id: "3947",
        },
        {
          id: "45372",
          name: "Corinth",
          state_id: "3947",
        },
        {
          id: "45373",
          name: "Diamondhead",
          state_id: "3947",
        },
        {
          id: "45374",
          name: "Gautier",
          state_id: "3947",
        },
        {
          id: "45375",
          name: "Greenville",
          state_id: "3947",
        },
        {
          id: "45376",
          name: "Greenwood",
          state_id: "3947",
        },
        {
          id: "45377",
          name: "Grenada",
          state_id: "3947",
        },
        {
          id: "45378",
          name: "Gulfport",
          state_id: "3947",
        },
        {
          id: "45379",
          name: "Hattiesburg",
          state_id: "3947",
        },
        {
          id: "45380",
          name: "Hernando",
          state_id: "3947",
        },
        {
          id: "45381",
          name: "Horn Lake",
          state_id: "3947",
        },
        {
          id: "45382",
          name: "Indianola",
          state_id: "3947",
        },
        {
          id: "45383",
          name: "Jackson",
          state_id: "3947",
        },
        {
          id: "45384",
          name: "Laurel",
          state_id: "3947",
        },
        {
          id: "45385",
          name: "Long Beach",
          state_id: "3947",
        },
        {
          id: "45386",
          name: "Lucedale",
          state_id: "3947",
        },
        {
          id: "45387",
          name: "MacComb",
          state_id: "3947",
        },
        {
          id: "45388",
          name: "Madison",
          state_id: "3947",
        },
        {
          id: "45389",
          name: "Magnolia",
          state_id: "3947",
        },
        {
          id: "45390",
          name: "Meridian",
          state_id: "3947",
        },
        {
          id: "45391",
          name: "Michigan City",
          state_id: "3947",
        },
        {
          id: "45392",
          name: "Moselle",
          state_id: "3947",
        },
        {
          id: "45393",
          name: "Moss Point",
          state_id: "3947",
        },
        {
          id: "45394",
          name: "Natchez",
          state_id: "3947",
        },
        {
          id: "45395",
          name: "Ocean Springs",
          state_id: "3947",
        },
        {
          id: "45396",
          name: "Olive Branch",
          state_id: "3947",
        },
        {
          id: "45397",
          name: "Orange Grove",
          state_id: "3947",
        },
        {
          id: "45398",
          name: "Oxford",
          state_id: "3947",
        },
        {
          id: "45399",
          name: "Pascagoula",
          state_id: "3947",
        },
        {
          id: "45400",
          name: "Pearl",
          state_id: "3947",
        },
        {
          id: "45401",
          name: "Pelahatchie",
          state_id: "3947",
        },
        {
          id: "45402",
          name: "Picayune",
          state_id: "3947",
        },
        {
          id: "45403",
          name: "Quitman",
          state_id: "3947",
        },
        {
          id: "45404",
          name: "Ridgeland",
          state_id: "3947",
        },
        {
          id: "45405",
          name: "Senatobia",
          state_id: "3947",
        },
        {
          id: "45406",
          name: "Southaven",
          state_id: "3947",
        },
        {
          id: "45407",
          name: "Southhaven",
          state_id: "3947",
        },
        {
          id: "45408",
          name: "Starkville",
          state_id: "3947",
        },
        {
          id: "45409",
          name: "Tupelo",
          state_id: "3947",
        },
        {
          id: "45410",
          name: "Utica",
          state_id: "3947",
        },
        {
          id: "45411",
          name: "Vicksburg",
          state_id: "3947",
        },
        {
          id: "45412",
          name: "Yazoo City",
          state_id: "3947",
        },
      ],
      Missouri: [
        {
          id: "45413",
          name: "Affton",
          state_id: "3948",
        },
        {
          id: "45414",
          name: "Annapolis",
          state_id: "3948",
        },
        {
          id: "45415",
          name: "Arnold",
          state_id: "3948",
        },
        {
          id: "45416",
          name: "Ballwin",
          state_id: "3948",
        },
        {
          id: "45417",
          name: "Belgique",
          state_id: "3948",
        },
        {
          id: "45418",
          name: "Bellefontaine Neighbors",
          state_id: "3948",
        },
        {
          id: "45419",
          name: "Belton",
          state_id: "3948",
        },
        {
          id: "45420",
          name: "Berkeley",
          state_id: "3948",
        },
        {
          id: "45421",
          name: "Blue Springs",
          state_id: "3948",
        },
        {
          id: "45422",
          name: "Branson",
          state_id: "3948",
        },
        {
          id: "45423",
          name: "Bridgeton",
          state_id: "3948",
        },
        {
          id: "45424",
          name: "Brighton",
          state_id: "3948",
        },
        {
          id: "45425",
          name: "California",
          state_id: "3948",
        },
        {
          id: "45426",
          name: "Camdenton",
          state_id: "3948",
        },
        {
          id: "45427",
          name: "Cape Girardeau",
          state_id: "3948",
        },
        {
          id: "45428",
          name: "Carthage",
          state_id: "3948",
        },
        {
          id: "45429",
          name: "Chaffee",
          state_id: "3948",
        },
        {
          id: "45430",
          name: "Chesterfield",
          state_id: "3948",
        },
        {
          id: "45431",
          name: "Chillicothe",
          state_id: "3948",
        },
        {
          id: "45432",
          name: "Clayton",
          state_id: "3948",
        },
        {
          id: "45433",
          name: "Clever",
          state_id: "3948",
        },
        {
          id: "45434",
          name: "Columbia",
          state_id: "3948",
        },
        {
          id: "45435",
          name: "Concord",
          state_id: "3948",
        },
        {
          id: "45436",
          name: "Crestwood",
          state_id: "3948",
        },
        {
          id: "45437",
          name: "Creve Coeur",
          state_id: "3948",
        },
        {
          id: "45438",
          name: "Desloge",
          state_id: "3948",
        },
        {
          id: "45439",
          name: "Dora",
          state_id: "3948",
        },
        {
          id: "45440",
          name: "Earth City",
          state_id: "3948",
        },
        {
          id: "45441",
          name: "Excelsior Springs",
          state_id: "3948",
        },
        {
          id: "45442",
          name: "Farmington",
          state_id: "3948",
        },
        {
          id: "45443",
          name: "Fenton",
          state_id: "3948",
        },
        {
          id: "45444",
          name: "Ferguson",
          state_id: "3948",
        },
        {
          id: "45445",
          name: "Florissant",
          state_id: "3948",
        },
        {
          id: "45446",
          name: "Forsyth",
          state_id: "3948",
        },
        {
          id: "45447",
          name: "Fort Leonard Wood",
          state_id: "3948",
        },
        {
          id: "45448",
          name: "Fulton",
          state_id: "3948",
        },
        {
          id: "45449",
          name: "Gladstone",
          state_id: "3948",
        },
        {
          id: "45450",
          name: "Grain Valley",
          state_id: "3948",
        },
        {
          id: "45451",
          name: "Grandview",
          state_id: "3948",
        },
        {
          id: "45452",
          name: "Gravois Mills",
          state_id: "3948",
        },
        {
          id: "45453",
          name: "Hannibal",
          state_id: "3948",
        },
        {
          id: "45454",
          name: "Harrisonville",
          state_id: "3948",
        },
        {
          id: "45455",
          name: "Hazelwood",
          state_id: "3948",
        },
        {
          id: "45456",
          name: "High Ridge",
          state_id: "3948",
        },
        {
          id: "45457",
          name: "Independence",
          state_id: "3948",
        },
        {
          id: "45458",
          name: "Jackson",
          state_id: "3948",
        },
        {
          id: "45459",
          name: "Jefferson City",
          state_id: "3948",
        },
        {
          id: "45460",
          name: "Jennings",
          state_id: "3948",
        },
        {
          id: "45461",
          name: "Joplin",
          state_id: "3948",
        },
        {
          id: "45462",
          name: "Kansas City",
          state_id: "3948",
        },
        {
          id: "45463",
          name: "Kennett",
          state_id: "3948",
        },
        {
          id: "45464",
          name: "Kirksville",
          state_id: "3948",
        },
        {
          id: "45465",
          name: "Kirkwood",
          state_id: "3948",
        },
        {
          id: "45466",
          name: "Kissee Mills",
          state_id: "3948",
        },
        {
          id: "45467",
          name: "Lamar",
          state_id: "3948",
        },
        {
          id: "45468",
          name: "Lebanon",
          state_id: "3948",
        },
        {
          id: "45469",
          name: "Lees Summit",
          state_id: "3948",
        },
        {
          id: "45470",
          name: "Lemay",
          state_id: "3948",
        },
        {
          id: "45471",
          name: "Liberty",
          state_id: "3948",
        },
        {
          id: "45472",
          name: "Lone Jack",
          state_id: "3948",
        },
        {
          id: "45473",
          name: "Marshall",
          state_id: "3948",
        },
        {
          id: "45474",
          name: "Maryland Heights",
          state_id: "3948",
        },
        {
          id: "45475",
          name: "Maryville",
          state_id: "3948",
        },
        {
          id: "45476",
          name: "Mehlville",
          state_id: "3948",
        },
        {
          id: "45477",
          name: "Mexico",
          state_id: "3948",
        },
        {
          id: "45478",
          name: "Moberly",
          state_id: "3948",
        },
        {
          id: "45479",
          name: "Murphy",
          state_id: "3948",
        },
        {
          id: "45480",
          name: "Nixa",
          state_id: "3948",
        },
        {
          id: "45481",
          name: "O''Fallon",
          state_id: "3948",
        },
        {
          id: "45482",
          name: "Oakville",
          state_id: "3948",
        },
        {
          id: "45483",
          name: "Overland",
          state_id: "3948",
        },
        {
          id: "45484",
          name: "Pacific",
          state_id: "3948",
        },
        {
          id: "45485",
          name: "Park Hills",
          state_id: "3948",
        },
        {
          id: "45486",
          name: "Parkville",
          state_id: "3948",
        },
        {
          id: "45487",
          name: "Peculiar",
          state_id: "3948",
        },
        {
          id: "45488",
          name: "Poplar Bluff",
          state_id: "3948",
        },
        {
          id: "45489",
          name: "Raytown",
          state_id: "3948",
        },
        {
          id: "45490",
          name: "Richmond Heights",
          state_id: "3948",
        },
        {
          id: "45491",
          name: "Rolla",
          state_id: "3948",
        },
        {
          id: "45492",
          name: "Saint Ann",
          state_id: "3948",
        },
        {
          id: "45493",
          name: "Saint Charles",
          state_id: "3948",
        },
        {
          id: "45494",
          name: "Saint Clair",
          state_id: "3948",
        },
        {
          id: "45495",
          name: "Saint Joseph",
          state_id: "3948",
        },
        {
          id: "45496",
          name: "Saint Louis",
          state_id: "3948",
        },
        {
          id: "45497",
          name: "Saint Peters",
          state_id: "3948",
        },
        {
          id: "45498",
          name: "Sappington",
          state_id: "3948",
        },
        {
          id: "45499",
          name: "Sedalia",
          state_id: "3948",
        },
        {
          id: "45500",
          name: "Sikeston",
          state_id: "3948",
        },
        {
          id: "45501",
          name: "Spanish Lake",
          state_id: "3948",
        },
        {
          id: "45502",
          name: "Springfield",
          state_id: "3948",
        },
        {
          id: "45503",
          name: "St. Louis",
          state_id: "3948",
        },
        {
          id: "45504",
          name: "Steelville",
          state_id: "3948",
        },
        {
          id: "45505",
          name: "Sunrise Beach",
          state_id: "3948",
        },
        {
          id: "45506",
          name: "Town and Country",
          state_id: "3948",
        },
        {
          id: "45507",
          name: "Trimble",
          state_id: "3948",
        },
        {
          id: "45508",
          name: "Troy",
          state_id: "3948",
        },
        {
          id: "45509",
          name: "University City",
          state_id: "3948",
        },
        {
          id: "45510",
          name: "Warrensburg",
          state_id: "3948",
        },
        {
          id: "45511",
          name: "Washington",
          state_id: "3948",
        },
        {
          id: "45512",
          name: "Webb City",
          state_id: "3948",
        },
        {
          id: "45513",
          name: "Webster Groves",
          state_id: "3948",
        },
        {
          id: "45514",
          name: "Wentzville",
          state_id: "3948",
        },
        {
          id: "45515",
          name: "West Plains",
          state_id: "3948",
        },
        {
          id: "45516",
          name: "Wildwood",
          state_id: "3948",
        },
      ],
      Montana: [
        {
          id: "45517",
          name: "Anaconda-Deer Lodge County",
          state_id: "3949",
        },
        {
          id: "45518",
          name: "Arlee",
          state_id: "3949",
        },
        {
          id: "45519",
          name: "Belgrade",
          state_id: "3949",
        },
        {
          id: "45520",
          name: "Billings",
          state_id: "3949",
        },
        {
          id: "45521",
          name: "Bozeman",
          state_id: "3949",
        },
        {
          id: "45522",
          name: "Butte",
          state_id: "3949",
        },
        {
          id: "45523",
          name: "Butte-Silver Bow",
          state_id: "3949",
        },
        {
          id: "45524",
          name: "Great Falls",
          state_id: "3949",
        },
        {
          id: "45525",
          name: "Hamilton",
          state_id: "3949",
        },
        {
          id: "45526",
          name: "Havre",
          state_id: "3949",
        },
        {
          id: "45527",
          name: "Helena",
          state_id: "3949",
        },
        {
          id: "45528",
          name: "Helena Valley Southeast",
          state_id: "3949",
        },
        {
          id: "45529",
          name: "Helena Valley West Central",
          state_id: "3949",
        },
        {
          id: "45530",
          name: "Kalispell",
          state_id: "3949",
        },
        {
          id: "45531",
          name: "Lame Deer",
          state_id: "3949",
        },
        {
          id: "45532",
          name: "Laurel",
          state_id: "3949",
        },
        {
          id: "45533",
          name: "Lewistown",
          state_id: "3949",
        },
        {
          id: "45534",
          name: "Livingston",
          state_id: "3949",
        },
        {
          id: "45535",
          name: "Malmstrom Air Force Base",
          state_id: "3949",
        },
        {
          id: "45536",
          name: "Manhattan",
          state_id: "3949",
        },
        {
          id: "45537",
          name: "Miles City",
          state_id: "3949",
        },
        {
          id: "45538",
          name: "Missoula",
          state_id: "3949",
        },
        {
          id: "45539",
          name: "Orchard Homes",
          state_id: "3949",
        },
        {
          id: "45540",
          name: "Pablo",
          state_id: "3949",
        },
        {
          id: "45541",
          name: "Polson",
          state_id: "3949",
        },
        {
          id: "45542",
          name: "Roberts",
          state_id: "3949",
        },
        {
          id: "45543",
          name: "Ryegate",
          state_id: "3949",
        },
        {
          id: "45544",
          name: "Sidney",
          state_id: "3949",
        },
        {
          id: "45545",
          name: "Stevensville",
          state_id: "3949",
        },
        {
          id: "45546",
          name: "Whitefish",
          state_id: "3949",
        },
      ],
      Nebraska: [
        {
          id: "45547",
          name: "Beatrice",
          state_id: "3950",
        },
        {
          id: "45548",
          name: "Bellevue",
          state_id: "3950",
        },
        {
          id: "45549",
          name: "Central City",
          state_id: "3950",
        },
        {
          id: "45550",
          name: "Columbus",
          state_id: "3950",
        },
        {
          id: "45551",
          name: "Cozad",
          state_id: "3950",
        },
        {
          id: "45552",
          name: "Creighton",
          state_id: "3950",
        },
        {
          id: "45553",
          name: "Fremont",
          state_id: "3950",
        },
        {
          id: "45554",
          name: "Gering",
          state_id: "3950",
        },
        {
          id: "45555",
          name: "Grand Island",
          state_id: "3950",
        },
        {
          id: "45556",
          name: "Hastings",
          state_id: "3950",
        },
        {
          id: "45557",
          name: "Homer",
          state_id: "3950",
        },
        {
          id: "45558",
          name: "Keamey",
          state_id: "3950",
        },
        {
          id: "45559",
          name: "Kearney",
          state_id: "3950",
        },
        {
          id: "45560",
          name: "La Vista",
          state_id: "3950",
        },
        {
          id: "45561",
          name: "Lexington",
          state_id: "3950",
        },
        {
          id: "45562",
          name: "Lincoln",
          state_id: "3950",
        },
        {
          id: "45563",
          name: "McCook",
          state_id: "3950",
        },
        {
          id: "45564",
          name: "Norfolk",
          state_id: "3950",
        },
        {
          id: "45565",
          name: "North Platte",
          state_id: "3950",
        },
        {
          id: "45566",
          name: "Offutt Air Force Base West",
          state_id: "3950",
        },
        {
          id: "45567",
          name: "Ogallala",
          state_id: "3950",
        },
        {
          id: "45568",
          name: "Omaha",
          state_id: "3950",
        },
        {
          id: "45569",
          name: "Papillion",
          state_id: "3950",
        },
        {
          id: "45570",
          name: "Scottsbluff",
          state_id: "3950",
        },
        {
          id: "45571",
          name: "South Sioux City",
          state_id: "3950",
        },
      ],
      Nevada: [
        {
          id: "45572",
          name: "Boulder City",
          state_id: "3951",
        },
        {
          id: "45573",
          name: "Carson City",
          state_id: "3951",
        },
        {
          id: "45574",
          name: "Elko",
          state_id: "3951",
        },
        {
          id: "45575",
          name: "Goldfield",
          state_id: "3951",
        },
        {
          id: "45576",
          name: "Henderson",
          state_id: "3951",
        },
        {
          id: "45577",
          name: "Las Vegas",
          state_id: "3951",
        },
        {
          id: "45578",
          name: "Laughlin",
          state_id: "3951",
        },
        {
          id: "45579",
          name: "Lovelock",
          state_id: "3951",
        },
        {
          id: "45580",
          name: "Mesquite",
          state_id: "3951",
        },
        {
          id: "45581",
          name: "Nellis Air Force Base",
          state_id: "3951",
        },
        {
          id: "45582",
          name: "North Las Vegas",
          state_id: "3951",
        },
        {
          id: "45583",
          name: "Pahrump",
          state_id: "3951",
        },
        {
          id: "45584",
          name: "Paradise",
          state_id: "3951",
        },
        {
          id: "45585",
          name: "Reno",
          state_id: "3951",
        },
        {
          id: "45586",
          name: "Sparks",
          state_id: "3951",
        },
        {
          id: "45587",
          name: "Spring Valley",
          state_id: "3951",
        },
        {
          id: "45588",
          name: "Sun Valley",
          state_id: "3951",
        },
        {
          id: "45589",
          name: "Sunrise Manor",
          state_id: "3951",
        },
        {
          id: "45590",
          name: "Winchester",
          state_id: "3951",
        },
        {
          id: "45591",
          name: "Winnemucca",
          state_id: "3951",
        },
      ],
      "New Hampshire": [
        {
          id: "47577",
          name: "Manchester",
          state_id: "3952",
        },
        {
          id: "47578",
          name: "Nashua",
          state_id: "3952",
        },
        {
          id: "47579",
          name: "Concord",
          state_id: "3952",
        },
        {
          id: "47580",
          name: "Derry",
          state_id: "3952",
        },
        {
          id: "47581",
          name: "Dover",
          state_id: "3952",
        },
        {
          id: "47582",
          name: "Rochester",
          state_id: "3952",
        },
        {
          id: "47583",
          name: "Salem",
          state_id: "3952",
        },
        {
          id: "47584",
          name: "Merrimack",
          state_id: "3952",
        },
        {
          id: "47585",
          name: "Hudson",
          state_id: "3952",
        },
        {
          id: "47586",
          name: "Londonderry",
          state_id: "3952",
        },
        {
          id: "47587",
          name: "Keene",
          state_id: "3952",
        },
        {
          id: "47588",
          name: "Bedford",
          state_id: "3952",
        },
        {
          id: "47589",
          name: "Portsmouth",
          state_id: "3952",
        },
        {
          id: "47590",
          name: "Goffstown",
          state_id: "3952",
        },
        {
          id: "47591",
          name: "Laconia",
          state_id: "3952",
        },
        {
          id: "47592",
          name: "Hampton",
          state_id: "3952",
        },
        {
          id: "47593",
          name: "Milford",
          state_id: "3952",
        },
        {
          id: "47594",
          name: "Durham",
          state_id: "3952",
        },
        {
          id: "47595",
          name: "Exeter",
          state_id: "3952",
        },
        {
          id: "47596",
          name: "Windham",
          state_id: "3952",
        },
        {
          id: "47597",
          name: "Hooksett",
          state_id: "3952",
        },
        {
          id: "47598",
          name: "Claremont",
          state_id: "3952",
        },
        {
          id: "47599",
          name: "Lebanon",
          state_id: "3952",
        },
        {
          id: "47600",
          name: "Pelham",
          state_id: "3952",
        },
        {
          id: "47601",
          name: "Somersworth",
          state_id: "3952",
        },
        {
          id: "47602",
          name: "Hanover",
          state_id: "3952",
        },
        {
          id: "47603",
          name: "Amherst",
          state_id: "3952",
        },
        {
          id: "47604",
          name: "Raymond",
          state_id: "3952",
        },
        {
          id: "47605",
          name: "Conway",
          state_id: "3952",
        },
        {
          id: "47606",
          name: "Berlin",
          state_id: "3952",
        },
        {
          id: "47607",
          name: "Newmarket",
          state_id: "3952",
        },
        {
          id: "47608",
          name: "Weare",
          state_id: "3952",
        },
        {
          id: "47609",
          name: "Seabrook",
          state_id: "3952",
        },
        {
          id: "47610",
          name: "Barrington",
          state_id: "3952",
        },
        {
          id: "47611",
          name: "Hampstead",
          state_id: "3952",
        },
        {
          id: "47612",
          name: "Franklin",
          state_id: "3952",
        },
        {
          id: "47613",
          name: "Litchfield",
          state_id: "3952",
        },
        {
          id: "47614",
          name: "Hollis",
          state_id: "3952",
        },
        {
          id: "47615",
          name: "Plaistow",
          state_id: "3952",
        },
        {
          id: "47616",
          name: "Bow",
          state_id: "3952",
        },
        {
          id: "47617",
          name: "Belmont",
          state_id: "3952",
        },
        {
          id: "47618",
          name: "Stratham",
          state_id: "3952",
        },
        {
          id: "47619",
          name: "Swanzey",
          state_id: "3952",
        },
        {
          id: "47620",
          name: "Gilford",
          state_id: "3952",
        },
        {
          id: "47621",
          name: "Pembroke",
          state_id: "3952",
        },
        {
          id: "47622",
          name: "Plymouth",
          state_id: "3952",
        },
        {
          id: "47623",
          name: "Farmington",
          state_id: "3952",
        },
        {
          id: "47624",
          name: "Atkinson",
          state_id: "3952",
        },
        {
          id: "47625",
          name: "Newport",
          state_id: "3952",
        },
        {
          id: "47626",
          name: "Epping",
          state_id: "3952",
        },
        {
          id: "47627",
          name: "Peterborough",
          state_id: "3952",
        },
        {
          id: "47628",
          name: "Wolfeboro",
          state_id: "3952",
        },
        {
          id: "47629",
          name: "Meredith",
          state_id: "3952",
        },
        {
          id: "47630",
          name: "Kingston",
          state_id: "3952",
        },
        {
          id: "47631",
          name: "Rindge",
          state_id: "3952",
        },
        {
          id: "47632",
          name: "Hillsborough",
          state_id: "3952",
        },
      ],
      "New Jersey": [
        {
          id: "47633",
          name: "Newark",
          state_id: "3953",
        },
        {
          id: "47634",
          name: "Jersey City",
          state_id: "3953",
        },
        {
          id: "47635",
          name: "Paterson",
          state_id: "3953",
        },
        {
          id: "47636",
          name: "Elizabeth",
          state_id: "3953",
        },
        {
          id: "47637",
          name: "Edison",
          state_id: "3953",
        },
        {
          id: "47638",
          name: "Woodbridge",
          state_id: "3953",
        },
        {
          id: "47639",
          name: "Lakewood",
          state_id: "3953",
        },
        {
          id: "47640",
          name: "Toms River",
          state_id: "3953",
        },
        {
          id: "47641",
          name: "Hamilton",
          state_id: "3953",
        },
        {
          id: "47642",
          name: "Trenton",
          state_id: "3953",
        },
        {
          id: "47643",
          name: "Clifton",
          state_id: "3953",
        },
        {
          id: "47644",
          name: "Camden",
          state_id: "3953",
        },
        {
          id: "47645",
          name: "Brick",
          state_id: "3953",
        },
        {
          id: "47646",
          name: "Cherry Hill",
          state_id: "3953",
        },
        {
          id: "47647",
          name: "Passaic",
          state_id: "3953",
        },
        {
          id: "47648",
          name: "Middletown",
          state_id: "3953",
        },
        {
          id: "47649",
          name: "Union City",
          state_id: "3953",
        },
        {
          id: "47650",
          name: "Old Bridge",
          state_id: "3953",
        },
        {
          id: "47651",
          name: "Gloucester Township",
          state_id: "3953",
        },
        {
          id: "47652",
          name: "East Orange",
          state_id: "3953",
        },
        {
          id: "47653",
          name: "Bayonne",
          state_id: "3953",
        },
        {
          id: "47654",
          name: "Franklin",
          state_id: "3953",
        },
        {
          id: "47655",
          name: "North Bergen",
          state_id: "3953",
        },
        {
          id: "47656",
          name: "Vineland",
          state_id: "3953",
        },
        {
          id: "47657",
          name: "Union",
          state_id: "3953",
        },
        {
          id: "47658",
          name: "Piscataway",
          state_id: "3953",
        },
        {
          id: "47659",
          name: "New Brunswick",
          state_id: "3953",
        },
        {
          id: "47660",
          name: "Jackson",
          state_id: "3953",
        },
        {
          id: "47661",
          name: "Wayne",
          state_id: "3953",
        },
        {
          id: "47662",
          name: "Irvington",
          state_id: "3953",
        },
        {
          id: "47663",
          name: "Parsippany-Troy Hills",
          state_id: "3953",
        },
        {
          id: "47664",
          name: "Howell",
          state_id: "3953",
        },
        {
          id: "47665",
          name: "Perth Amboy",
          state_id: "3953",
        },
        {
          id: "47666",
          name: "Hoboken",
          state_id: "3953",
        },
        {
          id: "47667",
          name: "Plainfield",
          state_id: "3953",
        },
        {
          id: "47668",
          name: "West New York",
          state_id: "3953",
        },
        {
          id: "47669",
          name: "Washington Township",
          state_id: "3953",
        },
        {
          id: "47670",
          name: "East Brunswick",
          state_id: "3953",
        },
        {
          id: "47671",
          name: "Bloomfield",
          state_id: "3953",
        },
        {
          id: "47672",
          name: "West Orange",
          state_id: "3953",
        },
        {
          id: "47673",
          name: "Evesham",
          state_id: "3953",
        },
        {
          id: "47674",
          name: "Bridgewater",
          state_id: "3953",
        },
        {
          id: "47675",
          name: "South Brunswick",
          state_id: "3953",
        },
        {
          id: "47676",
          name: "Egg Harbor",
          state_id: "3953",
        },
        {
          id: "47677",
          name: "Manchester",
          state_id: "3953",
        },
        {
          id: "47678",
          name: "Hackensack",
          state_id: "3953",
        },
        {
          id: "47679",
          name: "Sayreville",
          state_id: "3953",
        },
        {
          id: "47680",
          name: "Mount Laurel",
          state_id: "3953",
        },
        {
          id: "47681",
          name: "Berkeley",
          state_id: "3953",
        },
        {
          id: "47682",
          name: "North Brunswick",
          state_id: "3953",
        },
        {
          id: "47683",
          name: "Kearny",
          state_id: "3953",
        },
        {
          id: "47684",
          name: "Linden",
          state_id: "3953",
        },
        {
          id: "47685",
          name: "Marlboro",
          state_id: "3953",
        },
        {
          id: "47686",
          name: "Teaneck",
          state_id: "3953",
        },
        {
          id: "47687",
          name: "Atlantic City",
          state_id: "3953",
        },
        {
          id: "47688",
          name: "Winslow",
          state_id: "3953",
        },
        {
          id: "47689",
          name: "Monroe",
          state_id: "3953",
        },
        {
          id: "47690",
          name: "Manalapan",
          state_id: "3953",
        },
        {
          id: "47691",
          name: "Hillsborough",
          state_id: "3953",
        },
        {
          id: "47692",
          name: "Montclair",
          state_id: "3953",
        },
        {
          id: "47693",
          name: "Galloway",
          state_id: "3953",
        },
        {
          id: "47694",
          name: "Freehold Township",
          state_id: "3953",
        },
        {
          id: "47695",
          name: "Monroe Township",
          state_id: "3953",
        },
        {
          id: "47696",
          name: "Belleville",
          state_id: "3953",
        },
        {
          id: "47697",
          name: "Pennsauken",
          state_id: "3953",
        },
        {
          id: "47698",
          name: "Ewing",
          state_id: "3953",
        },
        {
          id: "47699",
          name: "Fort Lee",
          state_id: "3953",
        },
        {
          id: "47700",
          name: "Lawrence",
          state_id: "3953",
        },
        {
          id: "47701",
          name: "Fair Lawn",
          state_id: "3953",
        },
        {
          id: "47702",
          name: "Willingboro",
          state_id: "3953",
        },
        {
          id: "47703",
          name: "Long Branch",
          state_id: "3953",
        },
        {
          id: "47704",
          name: "Deptford",
          state_id: "3953",
        },
        {
          id: "47705",
          name: "Garfield",
          state_id: "3953",
        },
        {
          id: "47706",
          name: "Westfield",
          state_id: "3953",
        },
        {
          id: "47707",
          name: "City of Orange",
          state_id: "3953",
        },
        {
          id: "47708",
          name: "Livingston",
          state_id: "3953",
        },
        {
          id: "47709",
          name: "Voorhees",
          state_id: "3953",
        },
        {
          id: "47710",
          name: "Princeton",
          state_id: "3953",
        },
        {
          id: "47711",
          name: "Millville",
          state_id: "3953",
        },
        {
          id: "47712",
          name: "Nutley",
          state_id: "3953",
        },
        {
          id: "47713",
          name: "Mount Olive",
          state_id: "3953",
        },
        {
          id: "47714",
          name: "Neptune",
          state_id: "3953",
        },
        {
          id: "47715",
          name: "Pemberton Township",
          state_id: "3953",
        },
        {
          id: "47716",
          name: "Lacey",
          state_id: "3953",
        },
        {
          id: "47717",
          name: "Rahway",
          state_id: "3953",
        },
        {
          id: "47718",
          name: "Ocean Township",
          state_id: "3953",
        },
        {
          id: "47719",
          name: "East Windsor",
          state_id: "3953",
        },
        {
          id: "47720",
          name: "West Windsor",
          state_id: "3953",
        },
        {
          id: "47721",
          name: "Englewood",
          state_id: "3953",
        },
        {
          id: "47722",
          name: "Bergenfield",
          state_id: "3953",
        },
        {
          id: "47723",
          name: "Bernards Township",
          state_id: "3953",
        },
        {
          id: "47724",
          name: "Stafford Township",
          state_id: "3953",
        },
        {
          id: "47725",
          name: "Hamilton Township",
          state_id: "3953",
        },
        {
          id: "47726",
          name: "Paramus",
          state_id: "3953",
        },
        {
          id: "47727",
          name: "Wall",
          state_id: "3953",
        },
        {
          id: "47728",
          name: "Mahwah",
          state_id: "3953",
        },
        {
          id: "47729",
          name: "West Milford",
          state_id: "3953",
        },
        {
          id: "47730",
          name: "Randolph",
          state_id: "3953",
        },
        {
          id: "47731",
          name: "Bridgeton",
          state_id: "3953",
        },
        {
          id: "47732",
          name: "Ridgewood",
          state_id: "3953",
        },
        {
          id: "47733",
          name: "Rockaway Township",
          state_id: "3953",
        },
        {
          id: "47734",
          name: "Lodi",
          state_id: "3953",
        },
        {
          id: "47735",
          name: "Vernon",
          state_id: "3953",
        },
        {
          id: "47736",
          name: "Maplewood",
          state_id: "3953",
        },
        {
          id: "47737",
          name: "Cliffside Park",
          state_id: "3953",
        },
        {
          id: "47738",
          name: "Scotch Plains",
          state_id: "3953",
        },
        {
          id: "47739",
          name: "South Plainfield",
          state_id: "3953",
        },
        {
          id: "47740",
          name: "Roxbury",
          state_id: "3953",
        },
        {
          id: "47741",
          name: "Medford",
          state_id: "3953",
        },
        {
          id: "47742",
          name: "Plainsboro",
          state_id: "3953",
        },
        {
          id: "47743",
          name: "Lower Township",
          state_id: "3953",
        },
        {
          id: "47744",
          name: "Carteret",
          state_id: "3953",
        },
        {
          id: "47745",
          name: "Cranford",
          state_id: "3953",
        },
        {
          id: "47746",
          name: "Burlington Township",
          state_id: "3953",
        },
        {
          id: "47747",
          name: "Morris Township",
          state_id: "3953",
        },
        {
          id: "47748",
          name: "Montgomery",
          state_id: "3953",
        },
        {
          id: "47749",
          name: "Raritan Township",
          state_id: "3953",
        },
        {
          id: "47750",
          name: "North Plainfield",
          state_id: "3953",
        },
        {
          id: "47751",
          name: "West Deptford",
          state_id: "3953",
        },
        {
          id: "47752",
          name: "Montville",
          state_id: "3953",
        },
        {
          id: "47753",
          name: "Summit",
          state_id: "3953",
        },
        {
          id: "47754",
          name: "Hillside",
          state_id: "3953",
        },
        {
          id: "47755",
          name: "Jefferson",
          state_id: "3953",
        },
        {
          id: "47756",
          name: "Roselle",
          state_id: "3953",
        },
        {
          id: "47757",
          name: "Barnegat",
          state_id: "3953",
        },
        {
          id: "47758",
          name: "Moorestown",
          state_id: "3953",
        },
        {
          id: "47759",
          name: "Lyndhurst",
          state_id: "3953",
        },
        {
          id: "47760",
          name: "Hazlet",
          state_id: "3953",
        },
        {
          id: "47761",
          name: "Pleasantville",
          state_id: "3953",
        },
        {
          id: "47762",
          name: "Millburn",
          state_id: "3953",
        },
        {
          id: "47763",
          name: "Little Egg Harbor",
          state_id: "3953",
        },
        {
          id: "47764",
          name: "Sparta",
          state_id: "3953",
        },
        {
          id: "47765",
          name: "Palisades Park",
          state_id: "3953",
        },
        {
          id: "47766",
          name: "Elmwood Park",
          state_id: "3953",
        },
        {
          id: "47767",
          name: "Maple Shade",
          state_id: "3953",
        },
        {
          id: "47768",
          name: "Middle Township",
          state_id: "3953",
        },
        {
          id: "47769",
          name: "Hawthorne",
          state_id: "3953",
        },
        {
          id: "47770",
          name: "Glassboro",
          state_id: "3953",
        },
        {
          id: "47771",
          name: "Washington Township",
          state_id: "3953",
        },
        {
          id: "47772",
          name: "Morristown",
          state_id: "3953",
        },
        {
          id: "47773",
          name: "Point Pleasant",
          state_id: "3953",
        },
        {
          id: "47774",
          name: "Aberdeen",
          state_id: "3953",
        },
        {
          id: "47775",
          name: "Dover",
          state_id: "3953",
        },
        {
          id: "47776",
          name: "Rutherford",
          state_id: "3953",
        },
        {
          id: "47777",
          name: "Tinton Falls",
          state_id: "3953",
        },
        {
          id: "47778",
          name: "Lindenwold",
          state_id: "3953",
        },
        {
          id: "47779",
          name: "Dumont",
          state_id: "3953",
        },
        {
          id: "47780",
          name: "Hopewell Township",
          state_id: "3953",
        },
        {
          id: "47781",
          name: "Delran",
          state_id: "3953",
        },
        {
          id: "47782",
          name: "Franklin Township",
          state_id: "3953",
        },
        {
          id: "47783",
          name: "Holmdel",
          state_id: "3953",
        },
        {
          id: "47784",
          name: "Wyckoff",
          state_id: "3953",
        },
        {
          id: "47785",
          name: "Denville",
          state_id: "3953",
        },
        {
          id: "47786",
          name: "New Milford",
          state_id: "3953",
        },
        {
          id: "47787",
          name: "Secaucus",
          state_id: "3953",
        },
        {
          id: "47788",
          name: "South Orange Village",
          state_id: "3953",
        },
        {
          id: "47789",
          name: "Readington",
          state_id: "3953",
        },
        {
          id: "47790",
          name: "Asbury Park",
          state_id: "3953",
        },
        {
          id: "47791",
          name: "South River",
          state_id: "3953",
        },
        {
          id: "47792",
          name: "Madison",
          state_id: "3953",
        },
        {
          id: "47793",
          name: "Springfield",
          state_id: "3953",
        },
        {
          id: "47794",
          name: "Cinnaminson",
          state_id: "3953",
        },
        {
          id: "47795",
          name: "Pequannock",
          state_id: "3953",
        },
        {
          id: "47796",
          name: "North Arlington",
          state_id: "3953",
        },
        {
          id: "47797",
          name: "Warren",
          state_id: "3953",
        },
        {
          id: "47798",
          name: "Mantua",
          state_id: "3953",
        },
        {
          id: "47799",
          name: "Hopatcong",
          state_id: "3953",
        },
        {
          id: "47800",
          name: "Phillipsburg",
          state_id: "3953",
        },
        {
          id: "47801",
          name: "Hammonton",
          state_id: "3953",
        },
        {
          id: "47802",
          name: "Clark",
          state_id: "3953",
        },
        {
          id: "47803",
          name: "Haddon Township",
          state_id: "3953",
        },
        {
          id: "47804",
          name: "Tenafly",
          state_id: "3953",
        },
        {
          id: "47805",
          name: "Ramsey",
          state_id: "3953",
        },
        {
          id: "47806",
          name: "Branchburg",
          state_id: "3953",
        },
        {
          id: "47807",
          name: "Little Falls",
          state_id: "3953",
        },
        {
          id: "47808",
          name: "Highland Park",
          state_id: "3953",
        },
        {
          id: "47809",
          name: "Collingswood",
          state_id: "3953",
        },
        {
          id: "47810",
          name: "Fairview",
          state_id: "3953",
        },
        {
          id: "47811",
          name: "Hanover",
          state_id: "3953",
        },
        {
          id: "47812",
          name: "Saddle Brook",
          state_id: "3953",
        },
        {
          id: "47813",
          name: "Robbinsville",
          state_id: "3953",
        },
        {
          id: "47814",
          name: "Middlesex",
          state_id: "3953",
        },
        {
          id: "47815",
          name: "Harrison",
          state_id: "3953",
        },
        {
          id: "47816",
          name: "Metuchen",
          state_id: "3953",
        },
        {
          id: "47817",
          name: "Clinton Township",
          state_id: "3953",
        },
        {
          id: "47818",
          name: "Pennsville",
          state_id: "3953",
        },
        {
          id: "47819",
          name: "Verona",
          state_id: "3953",
        },
      ],
      "New Mexico": [
        {
          id: "47820",
          name: "Albuquerque",
          state_id: "3955",
        },
        {
          id: "47821",
          name: "Las Cruces",
          state_id: "3955",
        },
        {
          id: "47822",
          name: "Rio Rancho",
          state_id: "3955",
        },
        {
          id: "47823",
          name: "Santa Fe",
          state_id: "3955",
        },
        {
          id: "47824",
          name: "Roswell",
          state_id: "3955",
        },
        {
          id: "47825",
          name: "Farmington",
          state_id: "3955",
        },
        {
          id: "47826",
          name: "South Valley",
          state_id: "3955",
        },
        {
          id: "47827",
          name: "Clovis",
          state_id: "3955",
        },
        {
          id: "47828",
          name: "Hobbs",
          state_id: "3955",
        },
        {
          id: "47829",
          name: "Alamogordo",
          state_id: "3955",
        },
        {
          id: "47830",
          name: "Carlsbad",
          state_id: "3955",
        },
        {
          id: "47831",
          name: "Gallup",
          state_id: "3955",
        },
        {
          id: "47832",
          name: "Deming",
          state_id: "3955",
        },
        {
          id: "47833",
          name: "Los Lunas",
          state_id: "3955",
        },
        {
          id: "47834",
          name: "Chaparral",
          state_id: "3955",
        },
        {
          id: "47835",
          name: "Sunland Park",
          state_id: "3955",
        },
        {
          id: "47836",
          name: "Las Vegas",
          state_id: "3955",
        },
        {
          id: "47837",
          name: "Portales",
          state_id: "3955",
        },
        {
          id: "47838",
          name: "Los Alamos",
          state_id: "3955",
        },
        {
          id: "47839",
          name: "North Valley",
          state_id: "3955",
        },
        {
          id: "47840",
          name: "Artesia",
          state_id: "3955",
        },
        {
          id: "47841",
          name: "Lovington",
          state_id: "3955",
        },
        {
          id: "47842",
          name: "Silver City",
          state_id: "3955",
        },
        {
          id: "47843",
          name: "Espanola",
          state_id: "3955",
        },
        {
          id: "47844",
          name: "Anthony",
          state_id: "3955",
        },
        {
          id: "47845",
          name: "Grants",
          state_id: "3955",
        },
        {
          id: "47846",
          name: "Socorro",
          state_id: "3955",
        },
        {
          id: "47847",
          name: "Corrales",
          state_id: "3955",
        },
        {
          id: "47848",
          name: "Bernalillo",
          state_id: "3955",
        },
        {
          id: "47849",
          name: "Shiprock",
          state_id: "3955",
        },
        {
          id: "47850",
          name: "Bloomfield",
          state_id: "3955",
        },
        {
          id: "47851",
          name: "Ruidoso",
          state_id: "3955",
        },
        {
          id: "47852",
          name: "Kirtland",
          state_id: "3955",
        },
        {
          id: "47853",
          name: "Belen",
          state_id: "3955",
        },
      ],
      "New York": [
        {
          id: "47854",
          name: "Airmont",
          state_id: "3956",
        },
        {
          id: "47855",
          name: "Albany",
          state_id: "3956",
        },
        {
          id: "47856",
          name: "Alden",
          state_id: "3956",
        },
        {
          id: "47857",
          name: "Amherst",
          state_id: "3956",
        },
        {
          id: "47858",
          name: "Amityville",
          state_id: "3956",
        },
        {
          id: "47859",
          name: "Amsterdam",
          state_id: "3956",
        },
        {
          id: "47860",
          name: "Arcadia",
          state_id: "3956",
        },
        {
          id: "47861",
          name: "Auburn",
          state_id: "3956",
        },
        {
          id: "47862",
          name: "Aurora",
          state_id: "3956",
        },
        {
          id: "47863",
          name: "Babylon",
          state_id: "3956",
        },
        {
          id: "47864",
          name: "Baldwinsville",
          state_id: "3956",
        },
        {
          id: "47865",
          name: "Ballston",
          state_id: "3956",
        },
        {
          id: "47866",
          name: "Batavia",
          state_id: "3956",
        },
        {
          id: "47867",
          name: "Bath",
          state_id: "3956",
        },
        {
          id: "47868",
          name: "Beacon",
          state_id: "3956",
        },
        {
          id: "47869",
          name: "Bedford",
          state_id: "3956",
        },
        {
          id: "47870",
          name: "Beekman",
          state_id: "3956",
        },
        {
          id: "47871",
          name: "Bethlehem",
          state_id: "3956",
        },
        {
          id: "47872",
          name: "Binghamton",
          state_id: "3956",
        },
        {
          id: "47873",
          name: "Blooming Grove",
          state_id: "3956",
        },
        {
          id: "47874",
          name: "Briarcliff Manor",
          state_id: "3956",
        },
        {
          id: "47875",
          name: "Brighton",
          state_id: "3956",
        },
        {
          id: "47876",
          name: "Brockport",
          state_id: "3956",
        },
        {
          id: "47877",
          name: "Brookhaven",
          state_id: "3956",
        },
        {
          id: "47878",
          name: "Brunswick",
          state_id: "3956",
        },
        {
          id: "47879",
          name: "Buffalo",
          state_id: "3956",
        },
        {
          id: "47880",
          name: "Camillus",
          state_id: "3956",
        },
        {
          id: "47881",
          name: "Canandaigua",
          state_id: "3956",
        },
        {
          id: "47882",
          name: "Canton",
          state_id: "3956",
        },
        {
          id: "47883",
          name: "Carmel",
          state_id: "3956",
        },
        {
          id: "47884",
          name: "Catskill",
          state_id: "3956",
        },
        {
          id: "47885",
          name: "Cheektowaga",
          state_id: "3956",
        },
        {
          id: "47886",
          name: "Chenango",
          state_id: "3956",
        },
        {
          id: "47887",
          name: "Chester",
          state_id: "3956",
        },
        {
          id: "47888",
          name: "Chestnut Ridge",
          state_id: "3956",
        },
        {
          id: "47889",
          name: "Chili",
          state_id: "3956",
        },
        {
          id: "47890",
          name: "Cicero",
          state_id: "3956",
        },
        {
          id: "47891",
          name: "Clarence",
          state_id: "3956",
        },
        {
          id: "47892",
          name: "Clarkstown",
          state_id: "3956",
        },
        {
          id: "47893",
          name: "Clay",
          state_id: "3956",
        },
        {
          id: "47894",
          name: "Clifton Park",
          state_id: "3956",
        },
        {
          id: "47895",
          name: "Cohoes",
          state_id: "3956",
        },
        {
          id: "47896",
          name: "Colonie",
          state_id: "3956",
        },
        {
          id: "47897",
          name: "Corning",
          state_id: "3956",
        },
        {
          id: "47898",
          name: "Cornwall",
          state_id: "3956",
        },
        {
          id: "47899",
          name: "Cortland",
          state_id: "3956",
        },
        {
          id: "47900",
          name: "Cortlandt",
          state_id: "3956",
        },
        {
          id: "47901",
          name: "Crawford",
          state_id: "3956",
        },
        {
          id: "47902",
          name: "Croton-on-Hudson",
          state_id: "3956",
        },
        {
          id: "47903",
          name: "Depew",
          state_id: "3956",
        },
        {
          id: "47904",
          name: "DeWitt (De Witt)",
          state_id: "3956",
        },
        {
          id: "47905",
          name: "Dobbs Ferry",
          state_id: "3956",
        },
        {
          id: "47906",
          name: "Dryden",
          state_id: "3956",
        },
        {
          id: "47907",
          name: "Dunkirk",
          state_id: "3956",
        },
        {
          id: "47908",
          name: "East Fishkill",
          state_id: "3956",
        },
        {
          id: "47909",
          name: "East Greenbush",
          state_id: "3956",
        },
        {
          id: "47910",
          name: "East Hampton",
          state_id: "3956",
        },
        {
          id: "47911",
          name: "East Hills",
          state_id: "3956",
        },
        {
          id: "47912",
          name: "East Rockaway",
          state_id: "3956",
        },
        {
          id: "47913",
          name: "Eastchester",
          state_id: "3956",
        },
        {
          id: "47914",
          name: "Elma",
          state_id: "3956",
        },
        {
          id: "47915",
          name: "Elmira",
          state_id: "3956",
        },
        {
          id: "47916",
          name: "Endicott",
          state_id: "3956",
        },
        {
          id: "47917",
          name: "Esopus",
          state_id: "3956",
        },
        {
          id: "47918",
          name: "Evans",
          state_id: "3956",
        },
        {
          id: "47919",
          name: "Fallsburg",
          state_id: "3956",
        },
        {
          id: "47920",
          name: "Farmingdale",
          state_id: "3956",
        },
        {
          id: "47921",
          name: "Farmington",
          state_id: "3956",
        },
        {
          id: "47922",
          name: "Fishkill",
          state_id: "3956",
        },
        {
          id: "47923",
          name: "Floral Park",
          state_id: "3956",
        },
        {
          id: "47924",
          name: "Fredonia",
          state_id: "3956",
        },
        {
          id: "47925",
          name: "Freeport",
          state_id: "3956",
        },
        {
          id: "47926",
          name: "Fulton",
          state_id: "3956",
        },
        {
          id: "47927",
          name: "Garden City",
          state_id: "3956",
        },
        {
          id: "47928",
          name: "Gates",
          state_id: "3956",
        },
        {
          id: "47929",
          name: "Geddes",
          state_id: "3956",
        },
        {
          id: "47930",
          name: "Geneseo",
          state_id: "3956",
        },
        {
          id: "47931",
          name: "Geneva",
          state_id: "3956",
        },
        {
          id: "47932",
          name: "German Flatts",
          state_id: "3956",
        },
        {
          id: "47933",
          name: "Glen Cove",
          state_id: "3956",
        },
        {
          id: "47934",
          name: "Glens Falls",
          state_id: "3956",
        },
        {
          id: "47935",
          name: "Glenville",
          state_id: "3956",
        },
        {
          id: "47936",
          name: "Gloversville",
          state_id: "3956",
        },
        {
          id: "47937",
          name: "Goshen",
          state_id: "3956",
        },
        {
          id: "47938",
          name: "Grand Island",
          state_id: "3956",
        },
        {
          id: "47939",
          name: "Great Neck",
          state_id: "3956",
        },
        {
          id: "47940",
          name: "Greece",
          state_id: "3956",
        },
        {
          id: "47941",
          name: "Greenburgh",
          state_id: "3956",
        },
        {
          id: "47942",
          name: "Guilderland",
          state_id: "3956",
        },
        {
          id: "47943",
          name: "Halfmoon",
          state_id: "3956",
        },
        {
          id: "47944",
          name: "Hamburg",
          state_id: "3956",
        },
        {
          id: "47945",
          name: "Hamlin",
          state_id: "3956",
        },
        {
          id: "47946",
          name: "Harrison",
          state_id: "3956",
        },
        {
          id: "47947",
          name: "Hastings",
          state_id: "3956",
        },
        {
          id: "47948",
          name: "Hastings-on-Hudson",
          state_id: "3956",
        },
        {
          id: "47949",
          name: "Haverstraw",
          state_id: "3956",
        },
        {
          id: "47950",
          name: "Hempstead",
          state_id: "3956",
        },
        {
          id: "47951",
          name: "Henrietta",
          state_id: "3956",
        },
        {
          id: "47952",
          name: "Herkimer",
          state_id: "3956",
        },
        {
          id: "47953",
          name: "Highlands",
          state_id: "3956",
        },
        {
          id: "47954",
          name: "Hornell",
          state_id: "3956",
        },
        {
          id: "47955",
          name: "Horseheads",
          state_id: "3956",
        },
        {
          id: "47956",
          name: "Hudson",
          state_id: "3956",
        },
        {
          id: "47957",
          name: "Hudson Falls",
          state_id: "3956",
        },
        {
          id: "47958",
          name: "Huntington",
          state_id: "3956",
        },
        {
          id: "47959",
          name: "Hyde Park",
          state_id: "3956",
        },
        {
          id: "47960",
          name: "Ilion",
          state_id: "3956",
        },
        {
          id: "47961",
          name: "Irondequoit",
          state_id: "3956",
        },
        {
          id: "47962",
          name: "Islip",
          state_id: "3956",
        },
        {
          id: "47963",
          name: "Ithaca",
          state_id: "3956",
        },
        {
          id: "47964",
          name: "Jamestown",
          state_id: "3956",
        },
        {
          id: "47965",
          name: "Johnson City",
          state_id: "3956",
        },
        {
          id: "47966",
          name: "Johnstown",
          state_id: "3956",
        },
        {
          id: "47967",
          name: "Kenmore",
          state_id: "3956",
        },
        {
          id: "47968",
          name: "Kent",
          state_id: "3956",
        },
        {
          id: "47969",
          name: "Kingsbury",
          state_id: "3956",
        },
        {
          id: "47970",
          name: "Kingston",
          state_id: "3956",
        },
        {
          id: "47971",
          name: "Kirkland",
          state_id: "3956",
        },
        {
          id: "47972",
          name: "Kiryas Joel",
          state_id: "3956",
        },
        {
          id: "47973",
          name: "Lackawanna",
          state_id: "3956",
        },
        {
          id: "47974",
          name: "LaGrange (La Grange)",
          state_id: "3956",
        },
        {
          id: "47975",
          name: "Lake Grove",
          state_id: "3956",
        },
        {
          id: "47976",
          name: "Lancaster",
          state_id: "3956",
        },
        {
          id: "47977",
          name: "Lansing",
          state_id: "3956",
        },
        {
          id: "47978",
          name: "Le Ray",
          state_id: "3956",
        },
        {
          id: "47979",
          name: "Lenox",
          state_id: "3956",
        },
        {
          id: "47980",
          name: "Lewisboro",
          state_id: "3956",
        },
        {
          id: "47981",
          name: "Lewiston",
          state_id: "3956",
        },
        {
          id: "47982",
          name: "Liberty",
          state_id: "3956",
        },
        {
          id: "47983",
          name: "Lindenhurst",
          state_id: "3956",
        },
        {
          id: "47984",
          name: "Little Falls",
          state_id: "3956",
        },
        {
          id: "47985",
          name: "Lloyd",
          state_id: "3956",
        },
        {
          id: "47986",
          name: "Lockport",
          state_id: "3956",
        },
        {
          id: "47987",
          name: "Long Beach",
          state_id: "3956",
        },
        {
          id: "47988",
          name: "Lynbrook",
          state_id: "3956",
        },
        {
          id: "47989",
          name: "Lysander",
          state_id: "3956",
        },
        {
          id: "47990",
          name: "Macedon",
          state_id: "3956",
        },
        {
          id: "47991",
          name: "Malone",
          state_id: "3956",
        },
        {
          id: "47992",
          name: "Malta",
          state_id: "3956",
        },
        {
          id: "47993",
          name: "Malverne",
          state_id: "3956",
        },
        {
          id: "47994",
          name: "Mamakating",
          state_id: "3956",
        },
        {
          id: "47995",
          name: "Mamaroneck",
          state_id: "3956",
        },
        {
          id: "47996",
          name: "Manchester",
          state_id: "3956",
        },
        {
          id: "47997",
          name: "Manlius",
          state_id: "3956",
        },
        {
          id: "47998",
          name: "Massapequa Park",
          state_id: "3956",
        },
        {
          id: "47999",
          name: "Massena",
          state_id: "3956",
        },
        {
          id: "48000",
          name: "Mastic Beach",
          state_id: "3956",
        },
        {
          id: "48001",
          name: "Mechanicville",
          state_id: "3956",
        },
        {
          id: "48002",
          name: "Mendon",
          state_id: "3956",
        },
        {
          id: "48003",
          name: "Middletown",
          state_id: "3956",
        },
        {
          id: "48004",
          name: "Milton",
          state_id: "3956",
        },
        {
          id: "48005",
          name: "Mineola",
          state_id: "3956",
        },
        {
          id: "48006",
          name: "Monroe",
          state_id: "3956",
        },
        {
          id: "48007",
          name: "Montgomery",
          state_id: "3956",
        },
        {
          id: "48008",
          name: "Moreau",
          state_id: "3956",
        },
        {
          id: "48009",
          name: "Mount Kisco",
          state_id: "3956",
        },
        {
          id: "48010",
          name: "Mount Pleasant",
          state_id: "3956",
        },
        {
          id: "48011",
          name: "Mount Vernon",
          state_id: "3956",
        },
        {
          id: "48012",
          name: "New Castle",
          state_id: "3956",
        },
        {
          id: "48013",
          name: "New Hartford",
          state_id: "3956",
        },
        {
          id: "48014",
          name: "New Hyde Park",
          state_id: "3956",
        },
        {
          id: "48015",
          name: "New Paltz",
          state_id: "3956",
        },
        {
          id: "48016",
          name: "New Rochelle",
          state_id: "3956",
        },
        {
          id: "48017",
          name: "New Square",
          state_id: "3956",
        },
        {
          id: "48018",
          name: "New Windsor",
          state_id: "3956",
        },
        {
          id: "48019",
          name: "New York",
          state_id: "3956",
        },
        {
          id: "48020",
          name: "Newark",
          state_id: "3956",
        },
        {
          id: "48021",
          name: "Newburgh",
          state_id: "3956",
        },
        {
          id: "48022",
          name: "Newfane",
          state_id: "3956",
        },
        {
          id: "48023",
          name: "Niagara Falls",
          state_id: "3956",
        },
        {
          id: "48024",
          name: "Niskayuna",
          state_id: "3956",
        },
        {
          id: "48025",
          name: "North Castle",
          state_id: "3956",
        },
        {
          id: "48026",
          name: "North Greenbush",
          state_id: "3956",
        },
        {
          id: "48027",
          name: "North Hempstead",
          state_id: "3956",
        },
        {
          id: "48028",
          name: "North Syracuse",
          state_id: "3956",
        },
        {
          id: "48029",
          name: "North Tonawanda",
          state_id: "3956",
        },
        {
          id: "48030",
          name: "Northport",
          state_id: "3956",
        },
        {
          id: "48031",
          name: "Norwich",
          state_id: "3956",
        },
        {
          id: "48032",
          name: "Nyack",
          state_id: "3956",
        },
        {
          id: "48033",
          name: "Ogden",
          state_id: "3956",
        },
        {
          id: "48034",
          name: "Ogdensburg",
          state_id: "3956",
        },
        {
          id: "48035",
          name: "Olean",
          state_id: "3956",
        },
        {
          id: "48036",
          name: "Oneida",
          state_id: "3956",
        },
        {
          id: "48037",
          name: "Oneonta",
          state_id: "3956",
        },
        {
          id: "48038",
          name: "Onondaga",
          state_id: "3956",
        },
        {
          id: "48039",
          name: "Ontario",
          state_id: "3956",
        },
        {
          id: "48040",
          name: "Orangetown",
          state_id: "3956",
        },
        {
          id: "48041",
          name: "Orchard Park",
          state_id: "3956",
        },
        {
          id: "48042",
          name: "Ossining",
          state_id: "3956",
        },
        {
          id: "48043",
          name: "Oswego",
          state_id: "3956",
        },
        {
          id: "48044",
          name: "Owego",
          state_id: "3956",
        },
        {
          id: "48045",
          name: "Oyster Bay",
          state_id: "3956",
        },
        {
          id: "48046",
          name: "Parma",
          state_id: "3956",
        },
        {
          id: "48047",
          name: "Patchogue",
          state_id: "3956",
        },
        {
          id: "48048",
          name: "Patterson",
          state_id: "3956",
        },
        {
          id: "48049",
          name: "Peekskill",
          state_id: "3956",
        },
        {
          id: "48050",
          name: "Pelham",
          state_id: "3956",
        },
        {
          id: "48051",
          name: "Penfield",
          state_id: "3956",
        },
        {
          id: "48052",
          name: "Perinton",
          state_id: "3956",
        },
        {
          id: "48053",
          name: "Philipstown",
          state_id: "3956",
        },
        {
          id: "48054",
          name: "Pittsford",
          state_id: "3956",
        },
        {
          id: "48055",
          name: "Plattekill",
          state_id: "3956",
        },
        {
          id: "48056",
          name: "Plattsburgh",
          state_id: "3956",
        },
        {
          id: "48057",
          name: "Pleasant Valley",
          state_id: "3956",
        },
        {
          id: "48058",
          name: "Pleasantville",
          state_id: "3956",
        },
        {
          id: "48059",
          name: "Pomfret",
          state_id: "3956",
        },
        {
          id: "48060",
          name: "Port Chester",
          state_id: "3956",
        },
        {
          id: "48061",
          name: "Port Jefferson",
          state_id: "3956",
        },
        {
          id: "48062",
          name: "Port Jervis",
          state_id: "3956",
        },
        {
          id: "48063",
          name: "Potsdam",
          state_id: "3956",
        },
        {
          id: "48064",
          name: "Poughkeepsie",
          state_id: "3956",
        },
        {
          id: "48065",
          name: "Putnam Valley",
          state_id: "3956",
        },
        {
          id: "48066",
          name: "Queensbury",
          state_id: "3956",
        },
        {
          id: "48067",
          name: "Ramapo",
          state_id: "3956",
        },
        {
          id: "48068",
          name: "Red Hook",
          state_id: "3956",
        },
        {
          id: "48069",
          name: "Rensselaer",
          state_id: "3956",
        },
        {
          id: "48070",
          name: "Riverhead",
          state_id: "3956",
        },
        {
          id: "48071",
          name: "Rochester",
          state_id: "3956",
        },
        {
          id: "48072",
          name: "Rockville Centre",
          state_id: "3956",
        },
        {
          id: "48073",
          name: "Rome",
          state_id: "3956",
        },
        {
          id: "48074",
          name: "Rotterdam",
          state_id: "3956",
        },
        {
          id: "48075",
          name: "Rye",
          state_id: "3956",
        },
        {
          id: "48076",
          name: "Rye Brook",
          state_id: "3956",
        },
        {
          id: "48077",
          name: "Salamanca",
          state_id: "3956",
        },
        {
          id: "48078",
          name: "Salina",
          state_id: "3956",
        },
        {
          id: "48079",
          name: "Saratoga Springs",
          state_id: "3956",
        },
        {
          id: "48080",
          name: "Saugerties",
          state_id: "3956",
        },
        {
          id: "48081",
          name: "Scarsdale",
          state_id: "3956",
        },
        {
          id: "48082",
          name: "Schenectady",
          state_id: "3956",
        },
        {
          id: "48083",
          name: "Schodack",
          state_id: "3956",
        },
        {
          id: "48084",
          name: "Scotia",
          state_id: "3956",
        },
        {
          id: "48085",
          name: "Seneca Falls",
          state_id: "3956",
        },
        {
          id: "48086",
          name: "Shawangunk",
          state_id: "3956",
        },
        {
          id: "48087",
          name: "Sherrill",
          state_id: "3956",
        },
        {
          id: "48088",
          name: "Sleepy Hollow",
          state_id: "3956",
        },
        {
          id: "48089",
          name: "Smithtown",
          state_id: "3956",
        },
        {
          id: "48090",
          name: "Somers",
          state_id: "3956",
        },
        {
          id: "48091",
          name: "Southampton",
          state_id: "3956",
        },
        {
          id: "48092",
          name: "Southeast",
          state_id: "3956",
        },
        {
          id: "48093",
          name: "Southold",
          state_id: "3956",
        },
        {
          id: "48094",
          name: "Southport",
          state_id: "3956",
        },
        {
          id: "48095",
          name: "Spring Valley",
          state_id: "3956",
        },
        {
          id: "48096",
          name: "Stony Point",
          state_id: "3956",
        },
        {
          id: "48097",
          name: "Suffern",
          state_id: "3956",
        },
        {
          id: "48098",
          name: "Sullivan",
          state_id: "3956",
        },
        {
          id: "48099",
          name: "Sweden",
          state_id: "3956",
        },
        {
          id: "48100",
          name: "Syracuse",
          state_id: "3956",
        },
        {
          id: "48101",
          name: "Tarrytown",
          state_id: "3956",
        },
        {
          id: "48102",
          name: "Thompson",
          state_id: "3956",
        },
        {
          id: "48103",
          name: "Tonawanda",
          state_id: "3956",
        },
        {
          id: "48104",
          name: "Troy",
          state_id: "3956",
        },
        {
          id: "48105",
          name: "Ulster",
          state_id: "3956",
        },
        {
          id: "48106",
          name: "Union",
          state_id: "3956",
        },
        {
          id: "48107",
          name: "Utica",
          state_id: "3956",
        },
        {
          id: "48108",
          name: "Valley Stream",
          state_id: "3956",
        },
        {
          id: "48109",
          name: "Van Buren",
          state_id: "3956",
        },
        {
          id: "48110",
          name: "Vestal",
          state_id: "3956",
        },
        {
          id: "48111",
          name: "Victor",
          state_id: "3956",
        },
        {
          id: "48112",
          name: "Walden",
          state_id: "3956",
        },
        {
          id: "48113",
          name: "Wallkill",
          state_id: "3956",
        },
        {
          id: "48114",
          name: "Walworth",
          state_id: "3956",
        },
        {
          id: "48115",
          name: "Wappinger",
          state_id: "3956",
        },
        {
          id: "48116",
          name: "Warwick",
          state_id: "3956",
        },
        {
          id: "48117",
          name: "Watertown",
          state_id: "3956",
        },
        {
          id: "48118",
          name: "Watervliet",
          state_id: "3956",
        },
        {
          id: "48119",
          name: "Wawarsing",
          state_id: "3956",
        },
        {
          id: "48120",
          name: "Webster",
          state_id: "3956",
        },
        {
          id: "48121",
          name: "West Haverstraw",
          state_id: "3956",
        },
        {
          id: "48122",
          name: "West Seneca",
          state_id: "3956",
        },
        {
          id: "48123",
          name: "Westbury",
          state_id: "3956",
        },
        {
          id: "48124",
          name: "Wheatfield",
          state_id: "3956",
        },
        {
          id: "48125",
          name: "White Plains",
          state_id: "3956",
        },
        {
          id: "48126",
          name: "Whitestown",
          state_id: "3956",
        },
        {
          id: "48127",
          name: "Williston Park",
          state_id: "3956",
        },
        {
          id: "48128",
          name: "Wilton",
          state_id: "3956",
        },
        {
          id: "48129",
          name: "Woodbury",
          state_id: "3956",
        },
        {
          id: "48130",
          name: "Yonkers",
          state_id: "3956",
        },
        {
          id: "48131",
          name: "Yorktown",
          state_id: "3956",
        },
      ],
      "North Carolina": [
        {
          id: "48132",
          name: "Charlotte",
          state_id: "3957",
        },
        {
          id: "48133",
          name: "Raleigh",
          state_id: "3957",
        },
        {
          id: "48134",
          name: "Greensboro",
          state_id: "3957",
        },
        {
          id: "48135",
          name: "Durham",
          state_id: "3957",
        },
        {
          id: "48136",
          name: "Winston-Salem",
          state_id: "3957",
        },
        {
          id: "48137",
          name: "Fayetteville",
          state_id: "3957",
        },
        {
          id: "48138",
          name: "Cary",
          state_id: "3957",
        },
        {
          id: "48139",
          name: "Wilmington",
          state_id: "3957",
        },
        {
          id: "48140",
          name: "High Point",
          state_id: "3957",
        },
        {
          id: "48141",
          name: "Greenville",
          state_id: "3957",
        },
        {
          id: "48142",
          name: "Asheville",
          state_id: "3957",
        },
        {
          id: "48143",
          name: "Concord",
          state_id: "3957",
        },
        {
          id: "48144",
          name: "Gastonia",
          state_id: "3957",
        },
        {
          id: "48145",
          name: "Jacksonville",
          state_id: "3957",
        },
        {
          id: "48146",
          name: "Chapel Hill",
          state_id: "3957",
        },
        {
          id: "48147",
          name: "Rocky Mount",
          state_id: "3957",
        },
        {
          id: "48148",
          name: "Burlington",
          state_id: "3957",
        },
        {
          id: "48149",
          name: "Huntersville",
          state_id: "3957",
        },
        {
          id: "48150",
          name: "Wilson",
          state_id: "3957",
        },
        {
          id: "48151",
          name: "Kannapolis",
          state_id: "3957",
        },
        {
          id: "48152",
          name: "Apex",
          state_id: "3957",
        },
        {
          id: "48153",
          name: "Hickory",
          state_id: "3957",
        },
        {
          id: "48154",
          name: "Wake Forest",
          state_id: "3957",
        },
        {
          id: "48155",
          name: "Indian Trail",
          state_id: "3957",
        },
        {
          id: "48156",
          name: "Goldsboro",
          state_id: "3957",
        },
        {
          id: "48157",
          name: "Mooresville",
          state_id: "3957",
        },
        {
          id: "48158",
          name: "Monroe",
          state_id: "3957",
        },
        {
          id: "48159",
          name: "Salisbury",
          state_id: "3957",
        },
        {
          id: "48160",
          name: "New Bern",
          state_id: "3957",
        },
        {
          id: "48161",
          name: "Holly Springs",
          state_id: "3957",
        },
        {
          id: "48162",
          name: "Matthews",
          state_id: "3957",
        },
        {
          id: "48163",
          name: "Sanford",
          state_id: "3957",
        },
        {
          id: "48164",
          name: "Garner",
          state_id: "3957",
        },
        {
          id: "48165",
          name: "Cornelius",
          state_id: "3957",
        },
        {
          id: "48166",
          name: "Thomasville",
          state_id: "3957",
        },
        {
          id: "48167",
          name: "Asheboro",
          state_id: "3957",
        },
        {
          id: "48168",
          name: "Statesville",
          state_id: "3957",
        },
        {
          id: "48169",
          name: "Mint Hill",
          state_id: "3957",
        },
        {
          id: "48170",
          name: "Kernersville",
          state_id: "3957",
        },
        {
          id: "48171",
          name: "Morrisville",
          state_id: "3957",
        },
        {
          id: "48172",
          name: "Fuquay-Varina",
          state_id: "3957",
        },
        {
          id: "48173",
          name: "Lumberton",
          state_id: "3957",
        },
        {
          id: "48174",
          name: "Kinston",
          state_id: "3957",
        },
        {
          id: "48175",
          name: "Carrboro",
          state_id: "3957",
        },
        {
          id: "48176",
          name: "Havelock",
          state_id: "3957",
        },
        {
          id: "48177",
          name: "Shelby",
          state_id: "3957",
        },
        {
          id: "48178",
          name: "Clemmons",
          state_id: "3957",
        },
        {
          id: "48179",
          name: "Lexington",
          state_id: "3957",
        },
        {
          id: "48180",
          name: "Clayton",
          state_id: "3957",
        },
        {
          id: "48181",
          name: "Boone",
          state_id: "3957",
        },
      ],
      "North Dakota": [
        {
          id: "48182",
          name: "Fargo",
          state_id: "3958",
        },
        {
          id: "48183",
          name: "Bismarck",
          state_id: "3958",
        },
        {
          id: "48184",
          name: "Grand Forks",
          state_id: "3958",
        },
        {
          id: "48185",
          name: "Minot",
          state_id: "3958",
        },
        {
          id: "48186",
          name: "West Fargo",
          state_id: "3958",
        },
        {
          id: "48187",
          name: "Williston",
          state_id: "3958",
        },
        {
          id: "48188",
          name: "Dickinson",
          state_id: "3958",
        },
        {
          id: "48189",
          name: "Mandan",
          state_id: "3958",
        },
        {
          id: "48190",
          name: "Jamestown",
          state_id: "3958",
        },
        {
          id: "48191",
          name: "Wahpeton",
          state_id: "3958",
        },
        {
          id: "48192",
          name: "Devils Lake",
          state_id: "3958",
        },
        {
          id: "48193",
          name: "Valley City",
          state_id: "3958",
        },
      ],
      Ohio: [
        {
          id: "45592",
          name: "Akron",
          state_id: "3959",
        },
        {
          id: "45593",
          name: "Alledonia",
          state_id: "3959",
        },
        {
          id: "45594",
          name: "Alliance",
          state_id: "3959",
        },
        {
          id: "45595",
          name: "Amherst",
          state_id: "3959",
        },
        {
          id: "45596",
          name: "Apple Creek",
          state_id: "3959",
        },
        {
          id: "45597",
          name: "Archbold",
          state_id: "3959",
        },
        {
          id: "45598",
          name: "Ashland",
          state_id: "3959",
        },
        {
          id: "45599",
          name: "Ashtabula",
          state_id: "3959",
        },
        {
          id: "45600",
          name: "Athens",
          state_id: "3959",
        },
        {
          id: "45601",
          name: "Atwater",
          state_id: "3959",
        },
        {
          id: "45602",
          name: "Aurora",
          state_id: "3959",
        },
        {
          id: "45603",
          name: "Austintown",
          state_id: "3959",
        },
        {
          id: "45604",
          name: "Avon Lake",
          state_id: "3959",
        },
        {
          id: "45605",
          name: "Barberton",
          state_id: "3959",
        },
        {
          id: "45606",
          name: "Batavia",
          state_id: "3959",
        },
        {
          id: "45607",
          name: "Bay Village",
          state_id: "3959",
        },
        {
          id: "45608",
          name: "Beachwood",
          state_id: "3959",
        },
        {
          id: "45609",
          name: "Beavercreek",
          state_id: "3959",
        },
        {
          id: "45610",
          name: "Bedford",
          state_id: "3959",
        },
        {
          id: "45611",
          name: "Bedford Heights",
          state_id: "3959",
        },
        {
          id: "45612",
          name: "Bellaire",
          state_id: "3959",
        },
        {
          id: "45613",
          name: "Bellefontaine",
          state_id: "3959",
        },
        {
          id: "45614",
          name: "Bellevue",
          state_id: "3959",
        },
        {
          id: "45615",
          name: "Berea",
          state_id: "3959",
        },
        {
          id: "45616",
          name: "Bexley",
          state_id: "3959",
        },
        {
          id: "45617",
          name: "Blacklick",
          state_id: "3959",
        },
        {
          id: "45618",
          name: "Blacklick Estates",
          state_id: "3959",
        },
        {
          id: "45619",
          name: "Blanchester",
          state_id: "3959",
        },
        {
          id: "45620",
          name: "Blue Ash",
          state_id: "3959",
        },
        {
          id: "45621",
          name: "Boardman",
          state_id: "3959",
        },
        {
          id: "45622",
          name: "Bowling Green",
          state_id: "3959",
        },
        {
          id: "45623",
          name: "Brecksville",
          state_id: "3959",
        },
        {
          id: "45624",
          name: "Bridgetown North",
          state_id: "3959",
        },
        {
          id: "45625",
          name: "Bristolville",
          state_id: "3959",
        },
        {
          id: "45626",
          name: "Broadview Heights",
          state_id: "3959",
        },
        {
          id: "45627",
          name: "Brook Park",
          state_id: "3959",
        },
        {
          id: "45628",
          name: "Brooklyn",
          state_id: "3959",
        },
        {
          id: "45629",
          name: "Brunswick",
          state_id: "3959",
        },
        {
          id: "45630",
          name: "Bryan",
          state_id: "3959",
        },
        {
          id: "45631",
          name: "Bucyrus",
          state_id: "3959",
        },
        {
          id: "45632",
          name: "Burton",
          state_id: "3959",
        },
        {
          id: "45633",
          name: "Cambridge",
          state_id: "3959",
        },
        {
          id: "45634",
          name: "Campbell",
          state_id: "3959",
        },
        {
          id: "45635",
          name: "Canal Winchester",
          state_id: "3959",
        },
        {
          id: "45636",
          name: "Canton",
          state_id: "3959",
        },
        {
          id: "45637",
          name: "Carlisle",
          state_id: "3959",
        },
        {
          id: "45638",
          name: "Celina",
          state_id: "3959",
        },
        {
          id: "45639",
          name: "Centerville",
          state_id: "3959",
        },
        {
          id: "45640",
          name: "Chagrin Falls",
          state_id: "3959",
        },
        {
          id: "45641",
          name: "Chardon",
          state_id: "3959",
        },
        {
          id: "45642",
          name: "Cheshire",
          state_id: "3959",
        },
        {
          id: "45643",
          name: "Chillicothe",
          state_id: "3959",
        },
        {
          id: "45644",
          name: "Chippewa Lake",
          state_id: "3959",
        },
        {
          id: "45645",
          name: "Cincinnati",
          state_id: "3959",
        },
        {
          id: "45646",
          name: "Circleville",
          state_id: "3959",
        },
        {
          id: "45647",
          name: "Cleveland",
          state_id: "3959",
        },
        {
          id: "45648",
          name: "Cleveland Heights",
          state_id: "3959",
        },
        {
          id: "45649",
          name: "Columbus",
          state_id: "3959",
        },
        {
          id: "45650",
          name: "Conneaut",
          state_id: "3959",
        },
        {
          id: "45651",
          name: "Coshocton",
          state_id: "3959",
        },
        {
          id: "45652",
          name: "Cuyahoga Falls",
          state_id: "3959",
        },
        {
          id: "45653",
          name: "Dayton",
          state_id: "3959",
        },
        {
          id: "45654",
          name: "Defiance",
          state_id: "3959",
        },
        {
          id: "45655",
          name: "Delaware",
          state_id: "3959",
        },
        {
          id: "45656",
          name: "Dover",
          state_id: "3959",
        },
        {
          id: "45657",
          name: "Dublin",
          state_id: "3959",
        },
        {
          id: "45658",
          name: "East Cleveland",
          state_id: "3959",
        },
        {
          id: "45659",
          name: "East Liverpool",
          state_id: "3959",
        },
        {
          id: "45660",
          name: "Eastlake",
          state_id: "3959",
        },
        {
          id: "45661",
          name: "Elyria",
          state_id: "3959",
        },
        {
          id: "45662",
          name: "Englewood",
          state_id: "3959",
        },
        {
          id: "45663",
          name: "Euclid",
          state_id: "3959",
        },
        {
          id: "45664",
          name: "Fairborn",
          state_id: "3959",
        },
        {
          id: "45665",
          name: "Fairfield",
          state_id: "3959",
        },
        {
          id: "45666",
          name: "Fairview Park",
          state_id: "3959",
        },
        {
          id: "45667",
          name: "Findlay",
          state_id: "3959",
        },
        {
          id: "45668",
          name: "Finneytown",
          state_id: "3959",
        },
        {
          id: "45669",
          name: "Forest Park",
          state_id: "3959",
        },
        {
          id: "45670",
          name: "Fort MacKinley",
          state_id: "3959",
        },
        {
          id: "45671",
          name: "Fostoria",
          state_id: "3959",
        },
        {
          id: "45672",
          name: "Fremont",
          state_id: "3959",
        },
        {
          id: "45673",
          name: "Gahanna",
          state_id: "3959",
        },
        {
          id: "45674",
          name: "Galion",
          state_id: "3959",
        },
        {
          id: "45675",
          name: "Garfield Heights",
          state_id: "3959",
        },
        {
          id: "45676",
          name: "Girard",
          state_id: "3959",
        },
        {
          id: "45677",
          name: "Glenwillow",
          state_id: "3959",
        },
        {
          id: "45678",
          name: "Green",
          state_id: "3959",
        },
        {
          id: "45679",
          name: "Greenville",
          state_id: "3959",
        },
        {
          id: "45680",
          name: "Grove City",
          state_id: "3959",
        },
        {
          id: "45681",
          name: "Hamilton",
          state_id: "3959",
        },
        {
          id: "45682",
          name: "Harrison",
          state_id: "3959",
        },
        {
          id: "45683",
          name: "Hilliard",
          state_id: "3959",
        },
        {
          id: "45684",
          name: "Hiram",
          state_id: "3959",
        },
        {
          id: "45685",
          name: "Holland",
          state_id: "3959",
        },
        {
          id: "45686",
          name: "Huber Heights",
          state_id: "3959",
        },
        {
          id: "45687",
          name: "Hudson",
          state_id: "3959",
        },
        {
          id: "45688",
          name: "Ironton",
          state_id: "3959",
        },
        {
          id: "45689",
          name: "Kent",
          state_id: "3959",
        },
        {
          id: "45690",
          name: "Kettering",
          state_id: "3959",
        },
        {
          id: "45691",
          name: "Kidron",
          state_id: "3959",
        },
        {
          id: "45692",
          name: "Lakewood",
          state_id: "3959",
        },
        {
          id: "45693",
          name: "Lancaster",
          state_id: "3959",
        },
        {
          id: "45694",
          name: "Lebanon",
          state_id: "3959",
        },
        {
          id: "45695",
          name: "Lewis Center",
          state_id: "3959",
        },
        {
          id: "45696",
          name: "Lima",
          state_id: "3959",
        },
        {
          id: "45697",
          name: "Lincoln Village",
          state_id: "3959",
        },
        {
          id: "45698",
          name: "Lorain",
          state_id: "3959",
        },
        {
          id: "45699",
          name: "Loveland",
          state_id: "3959",
        },
        {
          id: "45700",
          name: "Lyndhurst",
          state_id: "3959",
        },
        {
          id: "45701",
          name: "Macedonia",
          state_id: "3959",
        },
        {
          id: "45702",
          name: "Madison",
          state_id: "3959",
        },
        {
          id: "45703",
          name: "Maineville",
          state_id: "3959",
        },
        {
          id: "45704",
          name: "Mansfield",
          state_id: "3959",
        },
        {
          id: "45705",
          name: "Maple Heights",
          state_id: "3959",
        },
        {
          id: "45706",
          name: "Marietta",
          state_id: "3959",
        },
        {
          id: "45707",
          name: "Marion",
          state_id: "3959",
        },
        {
          id: "45708",
          name: "Marysville",
          state_id: "3959",
        },
        {
          id: "45709",
          name: "Mason",
          state_id: "3959",
        },
        {
          id: "45710",
          name: "Massillon",
          state_id: "3959",
        },
        {
          id: "45711",
          name: "Maumee",
          state_id: "3959",
        },
        {
          id: "45712",
          name: "Mayfield Heights",
          state_id: "3959",
        },
        {
          id: "45713",
          name: "Medina",
          state_id: "3959",
        },
        {
          id: "45714",
          name: "Mentor",
          state_id: "3959",
        },
        {
          id: "45715",
          name: "Miamisburg",
          state_id: "3959",
        },
        {
          id: "45716",
          name: "Middleburg Heights",
          state_id: "3959",
        },
        {
          id: "45717",
          name: "Middletown",
          state_id: "3959",
        },
        {
          id: "45718",
          name: "Milford",
          state_id: "3959",
        },
        {
          id: "45719",
          name: "Millbury",
          state_id: "3959",
        },
        {
          id: "45720",
          name: "Mineral City",
          state_id: "3959",
        },
        {
          id: "45721",
          name: "Minster",
          state_id: "3959",
        },
        {
          id: "45722",
          name: "Mount Gilead",
          state_id: "3959",
        },
        {
          id: "45723",
          name: "Mount Vernon",
          state_id: "3959",
        },
        {
          id: "45724",
          name: "Nelsonville",
          state_id: "3959",
        },
        {
          id: "45725",
          name: "New Albany",
          state_id: "3959",
        },
        {
          id: "45726",
          name: "New Philadelphia",
          state_id: "3959",
        },
        {
          id: "45727",
          name: "Newark",
          state_id: "3959",
        },
        {
          id: "45728",
          name: "Niles",
          state_id: "3959",
        },
        {
          id: "45729",
          name: "North Canton",
          state_id: "3959",
        },
        {
          id: "45730",
          name: "North College Hill",
          state_id: "3959",
        },
        {
          id: "45731",
          name: "North Lewisburg",
          state_id: "3959",
        },
        {
          id: "45732",
          name: "North Olmsted",
          state_id: "3959",
        },
        {
          id: "45733",
          name: "North Ridgeville",
          state_id: "3959",
        },
        {
          id: "45734",
          name: "North Royalton",
          state_id: "3959",
        },
        {
          id: "45735",
          name: "Northbrook",
          state_id: "3959",
        },
        {
          id: "45736",
          name: "Northfield",
          state_id: "3959",
        },
        {
          id: "45737",
          name: "Northview",
          state_id: "3959",
        },
        {
          id: "45738",
          name: "Norton",
          state_id: "3959",
        },
        {
          id: "45739",
          name: "Norwalk",
          state_id: "3959",
        },
        {
          id: "45740",
          name: "Norwood",
          state_id: "3959",
        },
        {
          id: "45741",
          name: "Oberlin",
          state_id: "3959",
        },
        {
          id: "45742",
          name: "Ohio",
          state_id: "3959",
        },
        {
          id: "45743",
          name: "Oregon",
          state_id: "3959",
        },
        {
          id: "45744",
          name: "Overlook-Page Manor",
          state_id: "3959",
        },
        {
          id: "45745",
          name: "Oxford",
          state_id: "3959",
        },
        {
          id: "45746",
          name: "Painesville",
          state_id: "3959",
        },
        {
          id: "45747",
          name: "Parma",
          state_id: "3959",
        },
        {
          id: "45748",
          name: "Parma Heights",
          state_id: "3959",
        },
        {
          id: "45749",
          name: "Peninsula",
          state_id: "3959",
        },
        {
          id: "45750",
          name: "Perrysburg",
          state_id: "3959",
        },
        {
          id: "45751",
          name: "Pickerington",
          state_id: "3959",
        },
        {
          id: "45752",
          name: "Piqua",
          state_id: "3959",
        },
        {
          id: "45753",
          name: "Portage Lakes",
          state_id: "3959",
        },
        {
          id: "45754",
          name: "Portsmouth",
          state_id: "3959",
        },
        {
          id: "45755",
          name: "Powell",
          state_id: "3959",
        },
        {
          id: "45756",
          name: "Ravenna",
          state_id: "3959",
        },
        {
          id: "45757",
          name: "Reading",
          state_id: "3959",
        },
        {
          id: "45758",
          name: "Reynoldsburg",
          state_id: "3959",
        },
        {
          id: "45759",
          name: "Rittman",
          state_id: "3959",
        },
        {
          id: "45760",
          name: "Riverside",
          state_id: "3959",
        },
        {
          id: "45761",
          name: "Rocky River",
          state_id: "3959",
        },
        {
          id: "45762",
          name: "Rossford",
          state_id: "3959",
        },
        {
          id: "45763",
          name: "Salem",
          state_id: "3959",
        },
        {
          id: "45764",
          name: "Sandusky",
          state_id: "3959",
        },
        {
          id: "45765",
          name: "Seven Hills",
          state_id: "3959",
        },
        {
          id: "45766",
          name: "Seville",
          state_id: "3959",
        },
        {
          id: "45767",
          name: "Shaker Heights",
          state_id: "3959",
        },
        {
          id: "45768",
          name: "Sharonville",
          state_id: "3959",
        },
        {
          id: "45769",
          name: "Sheffield Lake",
          state_id: "3959",
        },
        {
          id: "45770",
          name: "Shelby",
          state_id: "3959",
        },
        {
          id: "45771",
          name: "Sidney",
          state_id: "3959",
        },
        {
          id: "45772",
          name: "Solon",
          state_id: "3959",
        },
        {
          id: "45773",
          name: "South Euclid",
          state_id: "3959",
        },
        {
          id: "45774",
          name: "Springdale",
          state_id: "3959",
        },
        {
          id: "45775",
          name: "Springfield",
          state_id: "3959",
        },
        {
          id: "45776",
          name: "Steubenville",
          state_id: "3959",
        },
        {
          id: "45778",
          name: "Streetsboro",
          state_id: "3959",
        },
        {
          id: "45779",
          name: "Strongsville",
          state_id: "3959",
        },
        {
          id: "45780",
          name: "Struthers",
          state_id: "3959",
        },
        {
          id: "45781",
          name: "Sylvania",
          state_id: "3959",
        },
        {
          id: "45782",
          name: "Tallmadge",
          state_id: "3959",
        },
        {
          id: "45783",
          name: "Tiffin",
          state_id: "3959",
        },
        {
          id: "45784",
          name: "Toledo",
          state_id: "3959",
        },
        {
          id: "45785",
          name: "Trotwood",
          state_id: "3959",
        },
        {
          id: "45786",
          name: "Troy",
          state_id: "3959",
        },
        {
          id: "45787",
          name: "Twinsburg",
          state_id: "3959",
        },
        {
          id: "45788",
          name: "University Heights",
          state_id: "3959",
        },
        {
          id: "45789",
          name: "Upper Arlington",
          state_id: "3959",
        },
        {
          id: "45790",
          name: "Urbana",
          state_id: "3959",
        },
        {
          id: "45791",
          name: "Valley Glen",
          state_id: "3959",
        },
        {
          id: "45792",
          name: "Van Wert",
          state_id: "3959",
        },
        {
          id: "45793",
          name: "Vandalia",
          state_id: "3959",
        },
        {
          id: "45794",
          name: "Vermilion",
          state_id: "3959",
        },
        {
          id: "45795",
          name: "Wadsworth",
          state_id: "3959",
        },
        {
          id: "45796",
          name: "Warren",
          state_id: "3959",
        },
        {
          id: "45797",
          name: "Warrensville Heights",
          state_id: "3959",
        },
        {
          id: "45798",
          name: "Washington",
          state_id: "3959",
        },
        {
          id: "45799",
          name: "Waverly",
          state_id: "3959",
        },
        {
          id: "45800",
          name: "West Carrollton City",
          state_id: "3959",
        },
        {
          id: "45801",
          name: "West Chester",
          state_id: "3959",
        },
        {
          id: "45802",
          name: "Westerville",
          state_id: "3959",
        },
        {
          id: "45803",
          name: "Westlake",
          state_id: "3959",
        },
        {
          id: "45804",
          name: "White Oak",
          state_id: "3959",
        },
        {
          id: "45805",
          name: "Whitehall",
          state_id: "3959",
        },
        {
          id: "45806",
          name: "Wickliffe",
          state_id: "3959",
        },
        {
          id: "45807",
          name: "Willoughby",
          state_id: "3959",
        },
        {
          id: "45808",
          name: "Willowick",
          state_id: "3959",
        },
        {
          id: "45809",
          name: "Wilmington",
          state_id: "3959",
        },
        {
          id: "45810",
          name: "Winesburg",
          state_id: "3959",
        },
        {
          id: "45811",
          name: "Wooster",
          state_id: "3959",
        },
        {
          id: "45812",
          name: "Worthington",
          state_id: "3959",
        },
        {
          id: "45813",
          name: "Xenia",
          state_id: "3959",
        },
        {
          id: "45814",
          name: "Yellow Springs",
          state_id: "3959",
        },
        {
          id: "45815",
          name: "Youngstown",
          state_id: "3959",
        },
        {
          id: "45816",
          name: "Zanesville",
          state_id: "3959",
        },
      ],
      Oklahoma: [
        {
          id: "45817",
          name: "Ada",
          state_id: "3960",
        },
        {
          id: "45818",
          name: "Altus",
          state_id: "3960",
        },
        {
          id: "45819",
          name: "Ardmore",
          state_id: "3960",
        },
        {
          id: "45820",
          name: "Bartlesville",
          state_id: "3960",
        },
        {
          id: "45821",
          name: "Bethany",
          state_id: "3960",
        },
        {
          id: "45822",
          name: "Bixby",
          state_id: "3960",
        },
        {
          id: "45823",
          name: "Broken Arrow",
          state_id: "3960",
        },
        {
          id: "45824",
          name: "Catoosa",
          state_id: "3960",
        },
        {
          id: "45825",
          name: "Chickasha",
          state_id: "3960",
        },
        {
          id: "45826",
          name: "Choctaw",
          state_id: "3960",
        },
        {
          id: "45827",
          name: "Claremore",
          state_id: "3960",
        },
        {
          id: "45828",
          name: "Del City",
          state_id: "3960",
        },
        {
          id: "45829",
          name: "Duncan",
          state_id: "3960",
        },
        {
          id: "45830",
          name: "Durant",
          state_id: "3960",
        },
        {
          id: "45831",
          name: "Edmond",
          state_id: "3960",
        },
        {
          id: "45832",
          name: "El Reno",
          state_id: "3960",
        },
        {
          id: "45833",
          name: "Elk City",
          state_id: "3960",
        },
        {
          id: "45834",
          name: "Enid",
          state_id: "3960",
        },
        {
          id: "45835",
          name: "Fort Sill",
          state_id: "3960",
        },
        {
          id: "45836",
          name: "Grove",
          state_id: "3960",
        },
        {
          id: "45837",
          name: "Guthrie",
          state_id: "3960",
        },
        {
          id: "45838",
          name: "Heavener",
          state_id: "3960",
        },
        {
          id: "45839",
          name: "Hugo",
          state_id: "3960",
        },
        {
          id: "45840",
          name: "Lawton",
          state_id: "3960",
        },
        {
          id: "45841",
          name: "Lindsay",
          state_id: "3960",
        },
        {
          id: "45842",
          name: "MacAlester",
          state_id: "3960",
        },
        {
          id: "45843",
          name: "Miami",
          state_id: "3960",
        },
        {
          id: "45844",
          name: "Midwest City",
          state_id: "3960",
        },
        {
          id: "45845",
          name: "Moore",
          state_id: "3960",
        },
        {
          id: "45846",
          name: "Morrison",
          state_id: "3960",
        },
        {
          id: "45847",
          name: "Muskogee",
          state_id: "3960",
        },
        {
          id: "45848",
          name: "Mustang",
          state_id: "3960",
        },
        {
          id: "45849",
          name: "Norman",
          state_id: "3960",
        },
        {
          id: "45850",
          name: "Oklahoma City",
          state_id: "3960",
        },
        {
          id: "45851",
          name: "Okmulgee",
          state_id: "3960",
        },
        {
          id: "45852",
          name: "Owasso",
          state_id: "3960",
        },
        {
          id: "45853",
          name: "Pawnee",
          state_id: "3960",
        },
        {
          id: "45854",
          name: "Ponca City",
          state_id: "3960",
        },
        {
          id: "45855",
          name: "Rattan",
          state_id: "3960",
        },
        {
          id: "45856",
          name: "Sand Springs",
          state_id: "3960",
        },
        {
          id: "45857",
          name: "Sapulpa",
          state_id: "3960",
        },
        {
          id: "45858",
          name: "Shawnee",
          state_id: "3960",
        },
        {
          id: "45859",
          name: "Stillwater",
          state_id: "3960",
        },
        {
          id: "45860",
          name: "Sulphur",
          state_id: "3960",
        },
        {
          id: "45861",
          name: "Tahlequah",
          state_id: "3960",
        },
        {
          id: "45862",
          name: "The Village",
          state_id: "3960",
        },
        {
          id: "45863",
          name: "Tulsa",
          state_id: "3960",
        },
        {
          id: "45864",
          name: "Weatherford",
          state_id: "3960",
        },
        {
          id: "45865",
          name: "Welch",
          state_id: "3960",
        },
        {
          id: "45866",
          name: "Woodward",
          state_id: "3960",
        },
        {
          id: "45867",
          name: "Yukon",
          state_id: "3960",
        },
      ],
      Oregon: [
        {
          id: "45870",
          name: "Albany",
          state_id: "3962",
        },
        {
          id: "45871",
          name: "Aloha",
          state_id: "3962",
        },
        {
          id: "45872",
          name: "Altamont",
          state_id: "3962",
        },
        {
          id: "45873",
          name: "Arleta",
          state_id: "3962",
        },
        {
          id: "45874",
          name: "Ashland",
          state_id: "3962",
        },
        {
          id: "45875",
          name: "Astoria",
          state_id: "3962",
        },
        {
          id: "45876",
          name: "Baker City",
          state_id: "3962",
        },
        {
          id: "45877",
          name: "Beaverton",
          state_id: "3962",
        },
        {
          id: "45878",
          name: "Bend",
          state_id: "3962",
        },
        {
          id: "45879",
          name: "Canby",
          state_id: "3962",
        },
        {
          id: "45880",
          name: "Cave Junction",
          state_id: "3962",
        },
        {
          id: "45881",
          name: "Cedar Hills",
          state_id: "3962",
        },
        {
          id: "45882",
          name: "Cedar Mill",
          state_id: "3962",
        },
        {
          id: "45883",
          name: "Central Point",
          state_id: "3962",
        },
        {
          id: "45884",
          name: "City of The Dalles",
          state_id: "3962",
        },
        {
          id: "45885",
          name: "Coos Bay",
          state_id: "3962",
        },
        {
          id: "45886",
          name: "Corvallis",
          state_id: "3962",
        },
        {
          id: "45887",
          name: "Creswell",
          state_id: "3962",
        },
        {
          id: "45888",
          name: "Dallas",
          state_id: "3962",
        },
        {
          id: "45889",
          name: "Donald",
          state_id: "3962",
        },
        {
          id: "45890",
          name: "Eugene",
          state_id: "3962",
        },
        {
          id: "45891",
          name: "Forest Grove",
          state_id: "3962",
        },
        {
          id: "45892",
          name: "Four Corners",
          state_id: "3962",
        },
        {
          id: "45893",
          name: "Gladstone",
          state_id: "3962",
        },
        {
          id: "45894",
          name: "Glide",
          state_id: "3962",
        },
        {
          id: "45895",
          name: "Grants Pass",
          state_id: "3962",
        },
        {
          id: "45896",
          name: "Gresham",
          state_id: "3962",
        },
        {
          id: "45897",
          name: "Hayesville",
          state_id: "3962",
        },
        {
          id: "45898",
          name: "Hazelwood",
          state_id: "3962",
        },
        {
          id: "45899",
          name: "Hermiston",
          state_id: "3962",
        },
        {
          id: "45900",
          name: "Hillsboro",
          state_id: "3962",
        },
        {
          id: "45901",
          name: "Hood River",
          state_id: "3962",
        },
        {
          id: "45902",
          name: "Hubbard",
          state_id: "3962",
        },
        {
          id: "45903",
          name: "John Day",
          state_id: "3962",
        },
        {
          id: "45904",
          name: "Jordan Valley",
          state_id: "3962",
        },
        {
          id: "45905",
          name: "Keizer",
          state_id: "3962",
        },
        {
          id: "45906",
          name: "Klamath Falls",
          state_id: "3962",
        },
        {
          id: "45907",
          name: "La Grande",
          state_id: "3962",
        },
        {
          id: "45908",
          name: "Lake Oswego",
          state_id: "3962",
        },
        {
          id: "45909",
          name: "Lebanon",
          state_id: "3962",
        },
        {
          id: "45910",
          name: "Lincoln",
          state_id: "3962",
        },
        {
          id: "45911",
          name: "MacMinnville",
          state_id: "3962",
        },
        {
          id: "45912",
          name: "Medford",
          state_id: "3962",
        },
        {
          id: "45913",
          name: "Milwaukie",
          state_id: "3962",
        },
        {
          id: "45914",
          name: "Newberg",
          state_id: "3962",
        },
        {
          id: "45915",
          name: "Newport",
          state_id: "3962",
        },
        {
          id: "45916",
          name: "North Bend",
          state_id: "3962",
        },
        {
          id: "45917",
          name: "OBrien",
          state_id: "3962",
        },
        {
          id: "45918",
          name: "Oak Grove",
          state_id: "3962",
        },
        {
          id: "45919",
          name: "Oatfield",
          state_id: "3962",
        },
        {
          id: "45920",
          name: "Ontario",
          state_id: "3962",
        },
        {
          id: "45921",
          name: "Oregon City",
          state_id: "3962",
        },
        {
          id: "45922",
          name: "Pendleton",
          state_id: "3962",
        },
        {
          id: "45923",
          name: "Portland",
          state_id: "3962",
        },
        {
          id: "45924",
          name: "Redmond",
          state_id: "3962",
        },
        {
          id: "45925",
          name: "Riddle",
          state_id: "3962",
        },
        {
          id: "45926",
          name: "River Road",
          state_id: "3962",
        },
        {
          id: "45927",
          name: "Roseburg",
          state_id: "3962",
        },
        {
          id: "45928",
          name: "Salem",
          state_id: "3962",
        },
        {
          id: "45929",
          name: "Sherwood",
          state_id: "3962",
        },
        {
          id: "45930",
          name: "Springfield",
          state_id: "3962",
        },
        {
          id: "45931",
          name: "Sublimity",
          state_id: "3962",
        },
        {
          id: "45932",
          name: "Sutherlin",
          state_id: "3962",
        },
        {
          id: "45933",
          name: "Talent",
          state_id: "3962",
        },
        {
          id: "45934",
          name: "Tigard",
          state_id: "3962",
        },
        {
          id: "45935",
          name: "Troutdale",
          state_id: "3962",
        },
        {
          id: "45936",
          name: "Tualatin",
          state_id: "3962",
        },
        {
          id: "45937",
          name: "Turner",
          state_id: "3962",
        },
        {
          id: "45938",
          name: "Vaughn",
          state_id: "3962",
        },
        {
          id: "45939",
          name: "West Linn",
          state_id: "3962",
        },
        {
          id: "45940",
          name: "Wilsonville",
          state_id: "3962",
        },
        {
          id: "45941",
          name: "Woodburn",
          state_id: "3962",
        },
      ],
      Pennsylvania: [
        {
          id: "45942",
          name: "Akron",
          state_id: "3963",
        },
        {
          id: "45943",
          name: "Aliquippa",
          state_id: "3963",
        },
        {
          id: "45944",
          name: "Allentown",
          state_id: "3963",
        },
        {
          id: "45945",
          name: "Altoona",
          state_id: "3963",
        },
        {
          id: "45946",
          name: "Ambler",
          state_id: "3963",
        },
        {
          id: "45947",
          name: "Amityville",
          state_id: "3963",
        },
        {
          id: "45948",
          name: "Ardmore",
          state_id: "3963",
        },
        {
          id: "45949",
          name: "Audubon",
          state_id: "3963",
        },
        {
          id: "45950",
          name: "Back Mountain",
          state_id: "3963",
        },
        {
          id: "45951",
          name: "Baldwin",
          state_id: "3963",
        },
        {
          id: "45952",
          name: "Bangor",
          state_id: "3963",
        },
        {
          id: "45953",
          name: "Beaver Falls",
          state_id: "3963",
        },
        {
          id: "45954",
          name: "Belle Vernon",
          state_id: "3963",
        },
        {
          id: "45955",
          name: "Bensalem",
          state_id: "3963",
        },
        {
          id: "45956",
          name: "Berwick",
          state_id: "3963",
        },
        {
          id: "45957",
          name: "Berwyn",
          state_id: "3963",
        },
        {
          id: "45958",
          name: "Bethel Park",
          state_id: "3963",
        },
        {
          id: "45959",
          name: "Bethlehem",
          state_id: "3963",
        },
        {
          id: "45960",
          name: "Bloomsburg",
          state_id: "3963",
        },
        {
          id: "45961",
          name: "Boyertown",
          state_id: "3963",
        },
        {
          id: "45962",
          name: "Bradford",
          state_id: "3963",
        },
        {
          id: "45963",
          name: "Brentwood",
          state_id: "3963",
        },
        {
          id: "45964",
          name: "Bridgeport",
          state_id: "3963",
        },
        {
          id: "45965",
          name: "Bristol",
          state_id: "3963",
        },
        {
          id: "45966",
          name: "Brockway",
          state_id: "3963",
        },
        {
          id: "45967",
          name: "Broomall",
          state_id: "3963",
        },
        {
          id: "45968",
          name: "Bushkill",
          state_id: "3963",
        },
        {
          id: "45969",
          name: "Butler",
          state_id: "3963",
        },
        {
          id: "45970",
          name: "Camp Hill",
          state_id: "3963",
        },
        {
          id: "45971",
          name: "Canonsburg",
          state_id: "3963",
        },
        {
          id: "45972",
          name: "Carbondale",
          state_id: "3963",
        },
        {
          id: "45973",
          name: "Carlisle",
          state_id: "3963",
        },
        {
          id: "45974",
          name: "Carnegie",
          state_id: "3963",
        },
        {
          id: "45975",
          name: "Carnot Moon",
          state_id: "3963",
        },
        {
          id: "45976",
          name: "Chambersburg",
          state_id: "3963",
        },
        {
          id: "45977",
          name: "Chester",
          state_id: "3963",
        },
        {
          id: "45978",
          name: "Chester Springs",
          state_id: "3963",
        },
        {
          id: "45979",
          name: "Clarks Summit",
          state_id: "3963",
        },
        {
          id: "45980",
          name: "Coatesville",
          state_id: "3963",
        },
        {
          id: "45981",
          name: "Colonial Park",
          state_id: "3963",
        },
        {
          id: "45982",
          name: "Columbia",
          state_id: "3963",
        },
        {
          id: "45983",
          name: "Conshohocken",
          state_id: "3963",
        },
        {
          id: "45984",
          name: "Coraopolis",
          state_id: "3963",
        },
        {
          id: "45985",
          name: "Corry",
          state_id: "3963",
        },
        {
          id: "45986",
          name: "Cranberry Township",
          state_id: "3963",
        },
        {
          id: "45987",
          name: "Cresco",
          state_id: "3963",
        },
        {
          id: "45988",
          name: "Croydon",
          state_id: "3963",
        },
        {
          id: "45989",
          name: "Dallas",
          state_id: "3963",
        },
        {
          id: "45990",
          name: "Dallastown",
          state_id: "3963",
        },
        {
          id: "45991",
          name: "Darby",
          state_id: "3963",
        },
        {
          id: "45992",
          name: "Darby Township",
          state_id: "3963",
        },
        {
          id: "45993",
          name: "Downingtown",
          state_id: "3963",
        },
        {
          id: "45994",
          name: "Drexel Hill",
          state_id: "3963",
        },
        {
          id: "45995",
          name: "Duncansville",
          state_id: "3963",
        },
        {
          id: "45996",
          name: "Dunmore",
          state_id: "3963",
        },
        {
          id: "45997",
          name: "East Norriton",
          state_id: "3963",
        },
        {
          id: "45998",
          name: "East Stroudsburg",
          state_id: "3963",
        },
        {
          id: "45999",
          name: "Easton",
          state_id: "3963",
        },
        {
          id: "46000",
          name: "Economy",
          state_id: "3963",
        },
        {
          id: "46001",
          name: "Edinboro",
          state_id: "3963",
        },
        {
          id: "46002",
          name: "Elizabethtown",
          state_id: "3963",
        },
        {
          id: "46003",
          name: "Elkins Park",
          state_id: "3963",
        },
        {
          id: "46004",
          name: "Emmaus",
          state_id: "3963",
        },
        {
          id: "46005",
          name: "Ephrata",
          state_id: "3963",
        },
        {
          id: "46006",
          name: "Erdenheim",
          state_id: "3963",
        },
        {
          id: "46007",
          name: "Erie",
          state_id: "3963",
        },
        {
          id: "46008",
          name: "Erwinna",
          state_id: "3963",
        },
        {
          id: "46009",
          name: "Exton",
          state_id: "3963",
        },
        {
          id: "46010",
          name: "Feasterville",
          state_id: "3963",
        },
        {
          id: "46011",
          name: "Folcroft",
          state_id: "3963",
        },
        {
          id: "46012",
          name: "Franklin",
          state_id: "3963",
        },
        {
          id: "46013",
          name: "Franklin Park",
          state_id: "3963",
        },
        {
          id: "46014",
          name: "Frederick",
          state_id: "3963",
        },
        {
          id: "46015",
          name: "Fullerton",
          state_id: "3963",
        },
        {
          id: "46016",
          name: "Furlong",
          state_id: "3963",
        },
        {
          id: "46017",
          name: "Gettysburg",
          state_id: "3963",
        },
        {
          id: "46018",
          name: "Gibsonia",
          state_id: "3963",
        },
        {
          id: "46019",
          name: "Glenside",
          state_id: "3963",
        },
        {
          id: "46020",
          name: "Gordonville",
          state_id: "3963",
        },
        {
          id: "46021",
          name: "Greensburg",
          state_id: "3963",
        },
        {
          id: "46022",
          name: "Gwynedd",
          state_id: "3963",
        },
        {
          id: "46023",
          name: "Hampden Township",
          state_id: "3963",
        },
        {
          id: "46024",
          name: "Hanover",
          state_id: "3963",
        },
        {
          id: "46025",
          name: "Harleysville",
          state_id: "3963",
        },
        {
          id: "46026",
          name: "Harrisburg",
          state_id: "3963",
        },
        {
          id: "46027",
          name: "Harrison Township",
          state_id: "3963",
        },
        {
          id: "46028",
          name: "Hatboro",
          state_id: "3963",
        },
        {
          id: "46029",
          name: "Haverford",
          state_id: "3963",
        },
        {
          id: "46030",
          name: "Havertown",
          state_id: "3963",
        },
        {
          id: "46031",
          name: "Hazleton",
          state_id: "3963",
        },
        {
          id: "46032",
          name: "Hermitage",
          state_id: "3963",
        },
        {
          id: "46033",
          name: "Hershey",
          state_id: "3963",
        },
        {
          id: "46034",
          name: "Hollidaysburg",
          state_id: "3963",
        },
        {
          id: "46035",
          name: "Horsham",
          state_id: "3963",
        },
        {
          id: "46036",
          name: "Huntingdon Valley",
          state_id: "3963",
        },
        {
          id: "46037",
          name: "Indiana",
          state_id: "3963",
        },
        {
          id: "46038",
          name: "Irvine",
          state_id: "3963",
        },
        {
          id: "46039",
          name: "Ivyland",
          state_id: "3963",
        },
        {
          id: "46040",
          name: "Jeannette",
          state_id: "3963",
        },
        {
          id: "46041",
          name: "Jefferson",
          state_id: "3963",
        },
        {
          id: "46042",
          name: "Jenkintown",
          state_id: "3963",
        },
        {
          id: "46043",
          name: "Johnstown",
          state_id: "3963",
        },
        {
          id: "46044",
          name: "Kempton",
          state_id: "3963",
        },
        {
          id: "46045",
          name: "Kennett Square",
          state_id: "3963",
        },
        {
          id: "46046",
          name: "King of Prussia",
          state_id: "3963",
        },
        {
          id: "46047",
          name: "Kingston",
          state_id: "3963",
        },
        {
          id: "46048",
          name: "Kutztown",
          state_id: "3963",
        },
        {
          id: "46049",
          name: "Lafayette Hill",
          state_id: "3963",
        },
        {
          id: "46050",
          name: "Lancaster",
          state_id: "3963",
        },
        {
          id: "46051",
          name: "Landenberg",
          state_id: "3963",
        },
        {
          id: "46052",
          name: "Langhorne",
          state_id: "3963",
        },
        {
          id: "46053",
          name: "Lansdale",
          state_id: "3963",
        },
        {
          id: "46054",
          name: "Lansdowne",
          state_id: "3963",
        },
        {
          id: "46055",
          name: "Lansford",
          state_id: "3963",
        },
        {
          id: "46056",
          name: "Laurys Station",
          state_id: "3963",
        },
        {
          id: "46057",
          name: "Lebanon",
          state_id: "3963",
        },
        {
          id: "46058",
          name: "Lehighton",
          state_id: "3963",
        },
        {
          id: "46059",
          name: "Levittown",
          state_id: "3963",
        },
        {
          id: "46060",
          name: "Lincoln University",
          state_id: "3963",
        },
        {
          id: "46061",
          name: "Linesville",
          state_id: "3963",
        },
        {
          id: "46062",
          name: "Linwood",
          state_id: "3963",
        },
        {
          id: "46063",
          name: "Lower Burrell",
          state_id: "3963",
        },
        {
          id: "46064",
          name: "Lower Merion",
          state_id: "3963",
        },
        {
          id: "46065",
          name: "MacCandless Township",
          state_id: "3963",
        },
        {
          id: "46066",
          name: "MacKeesport",
          state_id: "3963",
        },
        {
          id: "46067",
          name: "Malvern",
          state_id: "3963",
        },
        {
          id: "46068",
          name: "Meadville",
          state_id: "3963",
        },
        {
          id: "46069",
          name: "Mechanicsburg",
          state_id: "3963",
        },
        {
          id: "46070",
          name: "Media",
          state_id: "3963",
        },
        {
          id: "46071",
          name: "Merion Station",
          state_id: "3963",
        },
        {
          id: "46072",
          name: "Middleburg",
          state_id: "3963",
        },
        {
          id: "46073",
          name: "Mifflinville",
          state_id: "3963",
        },
        {
          id: "46074",
          name: "Milanville",
          state_id: "3963",
        },
        {
          id: "46075",
          name: "Milford",
          state_id: "3963",
        },
        {
          id: "46076",
          name: "Millersburg",
          state_id: "3963",
        },
        {
          id: "46077",
          name: "Monessen",
          state_id: "3963",
        },
        {
          id: "46078",
          name: "Moscow",
          state_id: "3963",
        },
        {
          id: "46079",
          name: "Mount Carmel",
          state_id: "3963",
        },
        {
          id: "46080",
          name: "Mount Lebanon",
          state_id: "3963",
        },
        {
          id: "46081",
          name: "Mountville",
          state_id: "3963",
        },
        {
          id: "46082",
          name: "Munhall",
          state_id: "3963",
        },
        {
          id: "46083",
          name: "Municipality of Monroeville",
          state_id: "3963",
        },
        {
          id: "46084",
          name: "Municipality of Murrysville",
          state_id: "3963",
        },
        {
          id: "46085",
          name: "N. Charleroi",
          state_id: "3963",
        },
        {
          id: "46086",
          name: "Nanticoke",
          state_id: "3963",
        },
        {
          id: "46087",
          name: "Narberth",
          state_id: "3963",
        },
        {
          id: "46088",
          name: "Natrona Heights",
          state_id: "3963",
        },
        {
          id: "46089",
          name: "Nazareth",
          state_id: "3963",
        },
        {
          id: "46090",
          name: "Nether Providence Township",
          state_id: "3963",
        },
        {
          id: "46091",
          name: "New Buffalo",
          state_id: "3963",
        },
        {
          id: "46092",
          name: "New Carlisle",
          state_id: "3963",
        },
        {
          id: "46093",
          name: "New Castle",
          state_id: "3963",
        },
        {
          id: "46094",
          name: "New Cumberland",
          state_id: "3963",
        },
        {
          id: "46095",
          name: "New Hope",
          state_id: "3963",
        },
        {
          id: "46096",
          name: "New Kensington",
          state_id: "3963",
        },
        {
          id: "46097",
          name: "Newton",
          state_id: "3963",
        },
        {
          id: "46098",
          name: "Newtown",
          state_id: "3963",
        },
        {
          id: "46099",
          name: "Newville",
          state_id: "3963",
        },
        {
          id: "46100",
          name: "Norristown",
          state_id: "3963",
        },
        {
          id: "46101",
          name: "North East",
          state_id: "3963",
        },
        {
          id: "46102",
          name: "North Versailles",
          state_id: "3963",
        },
        {
          id: "46103",
          name: "North Wales",
          state_id: "3963",
        },
        {
          id: "46104",
          name: "Oaks",
          state_id: "3963",
        },
        {
          id: "46105",
          name: "Oil City",
          state_id: "3963",
        },
        {
          id: "46106",
          name: "Olyphant",
          state_id: "3963",
        },
        {
          id: "46107",
          name: "Orrtanna",
          state_id: "3963",
        },
        {
          id: "46108",
          name: "Orwigsburg",
          state_id: "3963",
        },
        {
          id: "46109",
          name: "Oxford",
          state_id: "3963",
        },
        {
          id: "46110",
          name: "Paoli",
          state_id: "3963",
        },
        {
          id: "46111",
          name: "Parksburg",
          state_id: "3963",
        },
        {
          id: "46112",
          name: "Penn Hills",
          state_id: "3963",
        },
        {
          id: "46113",
          name: "Philadelphia",
          state_id: "3963",
        },
        {
          id: "46114",
          name: "Phildelphia",
          state_id: "3963",
        },
        {
          id: "46115",
          name: "Phoenixville",
          state_id: "3963",
        },
        {
          id: "46116",
          name: "Pipersville",
          state_id: "3963",
        },
        {
          id: "46117",
          name: "Pittsburgh",
          state_id: "3963",
        },
        {
          id: "46118",
          name: "Pleasantville",
          state_id: "3963",
        },
        {
          id: "46119",
          name: "Plum",
          state_id: "3963",
        },
        {
          id: "46120",
          name: "Pocono Summit",
          state_id: "3963",
        },
        {
          id: "46121",
          name: "Pottstown",
          state_id: "3963",
        },
        {
          id: "46122",
          name: "Pottsville",
          state_id: "3963",
        },
        {
          id: "46123",
          name: "Primos",
          state_id: "3963",
        },
        {
          id: "46124",
          name: "Progress",
          state_id: "3963",
        },
        {
          id: "46125",
          name: "Prospect",
          state_id: "3963",
        },
        {
          id: "46126",
          name: "Quakertown",
          state_id: "3963",
        },
        {
          id: "46127",
          name: "Radnor Township",
          state_id: "3963",
        },
        {
          id: "46128",
          name: "Reading",
          state_id: "3963",
        },
        {
          id: "46129",
          name: "Robinson Township",
          state_id: "3963",
        },
        {
          id: "46130",
          name: "Roseto",
          state_id: "3963",
        },
        {
          id: "46131",
          name: "Ross Township",
          state_id: "3963",
        },
        {
          id: "46132",
          name: "Royersford",
          state_id: "3963",
        },
        {
          id: "46133",
          name: "Saint Marys",
          state_id: "3963",
        },
        {
          id: "46134",
          name: "Sarver",
          state_id: "3963",
        },
        {
          id: "46135",
          name: "Saxonburg",
          state_id: "3963",
        },
        {
          id: "46136",
          name: "Scott Township",
          state_id: "3963",
        },
        {
          id: "46137",
          name: "Scranton",
          state_id: "3963",
        },
        {
          id: "46138",
          name: "Seward",
          state_id: "3963",
        },
        {
          id: "46139",
          name: "Sewickley",
          state_id: "3963",
        },
        {
          id: "46140",
          name: "Shaler Township",
          state_id: "3963",
        },
        {
          id: "46141",
          name: "Sharon",
          state_id: "3963",
        },
        {
          id: "46142",
          name: "Shermans Dale",
          state_id: "3963",
        },
        {
          id: "46143",
          name: "Somerset",
          state_id: "3963",
        },
        {
          id: "46144",
          name: "Souderton",
          state_id: "3963",
        },
        {
          id: "46145",
          name: "South Park Township",
          state_id: "3963",
        },
        {
          id: "46146",
          name: "Southampton",
          state_id: "3963",
        },
        {
          id: "46147",
          name: "Springfield",
          state_id: "3963",
        },
        {
          id: "46148",
          name: "State College",
          state_id: "3963",
        },
        {
          id: "46149",
          name: "Strasburg",
          state_id: "3963",
        },
        {
          id: "46150",
          name: "Sunbury",
          state_id: "3963",
        },
        {
          id: "46151",
          name: "Susquehanna",
          state_id: "3963",
        },
        {
          id: "46152",
          name: "Swissvale",
          state_id: "3963",
        },
        {
          id: "46153",
          name: "Tamaqua",
          state_id: "3963",
        },
        {
          id: "46154",
          name: "Taylor",
          state_id: "3963",
        },
        {
          id: "46155",
          name: "Telford",
          state_id: "3963",
        },
        {
          id: "46156",
          name: "Trevose",
          state_id: "3963",
        },
        {
          id: "46157",
          name: "Turtle Creek",
          state_id: "3963",
        },
        {
          id: "46158",
          name: "Tyrone",
          state_id: "3963",
        },
        {
          id: "46159",
          name: "Uniontown",
          state_id: "3963",
        },
        {
          id: "46160",
          name: "Upper Darby",
          state_id: "3963",
        },
        {
          id: "46161",
          name: "Upper Providence Township",
          state_id: "3963",
        },
        {
          id: "46162",
          name: "Upper Saint Clair",
          state_id: "3963",
        },
        {
          id: "46163",
          name: "Vanderbilt",
          state_id: "3963",
        },
        {
          id: "46164",
          name: "Warminster",
          state_id: "3963",
        },
        {
          id: "46165",
          name: "Warren",
          state_id: "3963",
        },
        {
          id: "46166",
          name: "Warrendale",
          state_id: "3963",
        },
        {
          id: "46167",
          name: "Washington",
          state_id: "3963",
        },
        {
          id: "46168",
          name: "Waterford",
          state_id: "3963",
        },
        {
          id: "46169",
          name: "Waverly",
          state_id: "3963",
        },
        {
          id: "46170",
          name: "Wayne",
          state_id: "3963",
        },
        {
          id: "46171",
          name: "Waynesboro",
          state_id: "3963",
        },
        {
          id: "46172",
          name: "West Chester",
          state_id: "3963",
        },
        {
          id: "46173",
          name: "West Mifflin",
          state_id: "3963",
        },
        {
          id: "46174",
          name: "West Norriton",
          state_id: "3963",
        },
        {
          id: "46175",
          name: "West Point",
          state_id: "3963",
        },
        {
          id: "46176",
          name: "Wexford",
          state_id: "3963",
        },
        {
          id: "46177",
          name: "Whitehall",
          state_id: "3963",
        },
        {
          id: "46178",
          name: "Wilcox",
          state_id: "3963",
        },
        {
          id: "46179",
          name: "Wilkes-Barre",
          state_id: "3963",
        },
        {
          id: "46180",
          name: "Wilkinsburg",
          state_id: "3963",
        },
        {
          id: "46181",
          name: "Williamsport",
          state_id: "3963",
        },
        {
          id: "46182",
          name: "Willow Grove",
          state_id: "3963",
        },
        {
          id: "46183",
          name: "Womelsdorf",
          state_id: "3963",
        },
        {
          id: "46184",
          name: "Woodlyn",
          state_id: "3963",
        },
        {
          id: "46185",
          name: "Woolrich",
          state_id: "3963",
        },
        {
          id: "46186",
          name: "Wyncote",
          state_id: "3963",
        },
        {
          id: "46187",
          name: "Wyndmoor",
          state_id: "3963",
        },
        {
          id: "46188",
          name: "Wynnewood",
          state_id: "3963",
        },
        {
          id: "46189",
          name: "Yardley",
          state_id: "3963",
        },
        {
          id: "46190",
          name: "Yeadon",
          state_id: "3963",
        },
        {
          id: "46191",
          name: "York",
          state_id: "3963",
        },
      ],
      "Rhode Island": [
        {
          id: "48194",
          name: "Providence",
          state_id: "3965",
        },
        {
          id: "48195",
          name: "Warwick",
          state_id: "3965",
        },
        {
          id: "48196",
          name: "Cranston",
          state_id: "3965",
        },
        {
          id: "48197",
          name: "Pawtucket",
          state_id: "3965",
        },
        {
          id: "48198",
          name: "East Providence",
          state_id: "3965",
        },
        {
          id: "48199",
          name: "Woonsocket",
          state_id: "3965",
        },
        {
          id: "48200",
          name: "Coventry",
          state_id: "3965",
        },
        {
          id: "48201",
          name: "Cumberland",
          state_id: "3965",
        },
        {
          id: "48202",
          name: "North Providence",
          state_id: "3965",
        },
        {
          id: "48203",
          name: "South Kingstown",
          state_id: "3965",
        },
        {
          id: "48204",
          name: "West Warwick",
          state_id: "3965",
        },
        {
          id: "48205",
          name: "Johnston",
          state_id: "3965",
        },
        {
          id: "48206",
          name: "North Kingstown",
          state_id: "3965",
        },
        {
          id: "48207",
          name: "Newport",
          state_id: "3965",
        },
        {
          id: "48208",
          name: "Bristol",
          state_id: "3965",
        },
        {
          id: "48209",
          name: "Westerly",
          state_id: "3965",
        },
        {
          id: "48210",
          name: "Smithfield",
          state_id: "3965",
        },
        {
          id: "48211",
          name: "Lincoln",
          state_id: "3965",
        },
        {
          id: "48212",
          name: "Central Falls",
          state_id: "3965",
        },
        {
          id: "48213",
          name: "Portsmouth",
          state_id: "3965",
        },
        {
          id: "48214",
          name: "Barrington",
          state_id: "3965",
        },
        {
          id: "48215",
          name: "Middletown",
          state_id: "3965",
        },
        {
          id: "48216",
          name: "Burrillville",
          state_id: "3965",
        },
        {
          id: "48217",
          name: "Narragansett",
          state_id: "3965",
        },
        {
          id: "48218",
          name: "Tiverton",
          state_id: "3965",
        },
        {
          id: "48219",
          name: "East Greenwich",
          state_id: "3965",
        },
        {
          id: "48220",
          name: "North Smithfield",
          state_id: "3965",
        },
        {
          id: "48221",
          name: "Warren",
          state_id: "3965",
        },
        {
          id: "48222",
          name: "Scituate",
          state_id: "3965",
        },
        {
          id: "48223",
          name: "Glocester",
          state_id: "3965",
        },
        {
          id: "48224",
          name: "Hopkinton",
          state_id: "3965",
        },
        {
          id: "48225",
          name: "Charlestown",
          state_id: "3965",
        },
        {
          id: "48226",
          name: "Richmond",
          state_id: "3965",
        },
      ],
      "South Carolina": [
        {
          id: "48227",
          name: "Columbia",
          state_id: "3966",
        },
        {
          id: "48228",
          name: "Charleston",
          state_id: "3966",
        },
        {
          id: "48229",
          name: "North Charleston",
          state_id: "3966",
        },
        {
          id: "48230",
          name: "Mount Pleasant",
          state_id: "3966",
        },
        {
          id: "48231",
          name: "Rock Hill",
          state_id: "3966",
        },
        {
          id: "48232",
          name: "Greenville",
          state_id: "3966",
        },
        {
          id: "48233",
          name: "Summerville",
          state_id: "3966",
        },
        {
          id: "48234",
          name: "Sumter",
          state_id: "3966",
        },
        {
          id: "48235",
          name: "Hilton Head Island",
          state_id: "3966",
        },
        {
          id: "48236",
          name: "Spartanburg",
          state_id: "3966",
        },
        {
          id: "48237",
          name: "Florence",
          state_id: "3966",
        },
        {
          id: "48238",
          name: "Goose Creek",
          state_id: "3966",
        },
        {
          id: "48239",
          name: "Aiken",
          state_id: "3966",
        },
        {
          id: "48240",
          name: "Myrtle Beach",
          state_id: "3966",
        },
        {
          id: "48241",
          name: "Anderson",
          state_id: "3966",
        },
        {
          id: "48242",
          name: "Greer",
          state_id: "3966",
        },
        {
          id: "48243",
          name: "Mauldin",
          state_id: "3966",
        },
        {
          id: "48244",
          name: "Greenwood",
          state_id: "3966",
        },
        {
          id: "48245",
          name: "North Augusta",
          state_id: "3966",
        },
        {
          id: "48246",
          name: "Easley",
          state_id: "3966",
        },
        {
          id: "48247",
          name: "Simpsonville",
          state_id: "3966",
        },
        {
          id: "48248",
          name: "Hanahan",
          state_id: "3966",
        },
        {
          id: "48249",
          name: "Lexington",
          state_id: "3966",
        },
        {
          id: "48250",
          name: "Conway",
          state_id: "3966",
        },
        {
          id: "48251",
          name: "West Columbia",
          state_id: "3966",
        },
        {
          id: "48252",
          name: "North Myrtle Beach",
          state_id: "3966",
        },
        {
          id: "48253",
          name: "Clemson",
          state_id: "3966",
        },
        {
          id: "48254",
          name: "Orangeburg",
          state_id: "3966",
        },
        {
          id: "48255",
          name: "Cayce",
          state_id: "3966",
        },
        {
          id: "48256",
          name: "Bluffton",
          state_id: "3966",
        },
        {
          id: "48257",
          name: "Beaufort",
          state_id: "3966",
        },
        {
          id: "48258",
          name: "Gaffney",
          state_id: "3966",
        },
        {
          id: "48259",
          name: "Irmo",
          state_id: "3966",
        },
        {
          id: "48260",
          name: "Fort Mill",
          state_id: "3966",
        },
        {
          id: "48261",
          name: "Port Royal",
          state_id: "3966",
        },
        {
          id: "48262",
          name: "Forest Acres",
          state_id: "3966",
        },
        {
          id: "48263",
          name: "Newberry",
          state_id: "3966",
        },
      ],
      "South Dakota": [
        {
          id: "48264",
          name: "Sioux Falls",
          state_id: "3967",
        },
        {
          id: "48265",
          name: "Rapid City",
          state_id: "3967",
        },
        {
          id: "48266",
          name: "Aberdeen",
          state_id: "3967",
        },
        {
          id: "48267",
          name: "Brookings",
          state_id: "3967",
        },
        {
          id: "48268",
          name: "Watertown",
          state_id: "3967",
        },
        {
          id: "48269",
          name: "Mitchell",
          state_id: "3967",
        },
        {
          id: "48270",
          name: "Yankton",
          state_id: "3967",
        },
        {
          id: "48271",
          name: "Pierre",
          state_id: "3967",
        },
        {
          id: "48272",
          name: "Huron",
          state_id: "3967",
        },
        {
          id: "48273",
          name: "Spearfish",
          state_id: "3967",
        },
        {
          id: "48274",
          name: "Vermillion",
          state_id: "3967",
        },
        {
          id: "48275",
          name: "Brandon",
          state_id: "3967",
        },
        {
          id: "48276",
          name: "Box Elder",
          state_id: "3967",
        },
        {
          id: "48277",
          name: "Madison",
          state_id: "3967",
        },
        {
          id: "48278",
          name: "Sturgis",
          state_id: "3967",
        },
        {
          id: "48279",
          name: "Belle Fourche",
          state_id: "3967",
        },
        {
          id: "48280",
          name: "Harrisburg",
          state_id: "3967",
        },
      ],
      Tennessee: [
        {
          id: "46193",
          name: "Adamsville",
          state_id: "3969",
        },
        {
          id: "46194",
          name: "Alcoa",
          state_id: "3969",
        },
        {
          id: "46195",
          name: "Antioch",
          state_id: "3969",
        },
        {
          id: "46196",
          name: "Arlington",
          state_id: "3969",
        },
        {
          id: "46197",
          name: "Athens",
          state_id: "3969",
        },
        {
          id: "46198",
          name: "Bartlett",
          state_id: "3969",
        },
        {
          id: "46199",
          name: "Bell Buckle",
          state_id: "3969",
        },
        {
          id: "46200",
          name: "Bloomingdale",
          state_id: "3969",
        },
        {
          id: "46201",
          name: "Blountville",
          state_id: "3969",
        },
        {
          id: "46202",
          name: "Brentwood",
          state_id: "3969",
        },
        {
          id: "46203",
          name: "Bristol",
          state_id: "3969",
        },
        {
          id: "46204",
          name: "Brownsville",
          state_id: "3969",
        },
        {
          id: "46205",
          name: "Burns",
          state_id: "3969",
        },
        {
          id: "46206",
          name: "Chattanooga",
          state_id: "3969",
        },
        {
          id: "46207",
          name: "Clarksville",
          state_id: "3969",
        },
        {
          id: "46208",
          name: "Cleveland",
          state_id: "3969",
        },
        {
          id: "46209",
          name: "Collierville",
          state_id: "3969",
        },
        {
          id: "46210",
          name: "Columbia",
          state_id: "3969",
        },
        {
          id: "46211",
          name: "Cookeville",
          state_id: "3969",
        },
        {
          id: "46212",
          name: "Cornersville",
          state_id: "3969",
        },
        {
          id: "46213",
          name: "Crossville",
          state_id: "3969",
        },
        {
          id: "46214",
          name: "Dayton",
          state_id: "3969",
        },
        {
          id: "46215",
          name: "Dickson",
          state_id: "3969",
        },
        {
          id: "46216",
          name: "Dyersburg",
          state_id: "3969",
        },
        {
          id: "46217",
          name: "East Brainerd",
          state_id: "3969",
        },
        {
          id: "46218",
          name: "East Ridge",
          state_id: "3969",
        },
        {
          id: "46219",
          name: "Elizabethton",
          state_id: "3969",
        },
        {
          id: "46220",
          name: "Farragut",
          state_id: "3969",
        },
        {
          id: "46221",
          name: "Franklin",
          state_id: "3969",
        },
        {
          id: "46222",
          name: "Gainesboro",
          state_id: "3969",
        },
        {
          id: "46223",
          name: "Gallatin",
          state_id: "3969",
        },
        {
          id: "46224",
          name: "Gatlinburg",
          state_id: "3969",
        },
        {
          id: "46225",
          name: "Germantown",
          state_id: "3969",
        },
        {
          id: "46226",
          name: "Goodlettsville",
          state_id: "3969",
        },
        {
          id: "46227",
          name: "Greeneville",
          state_id: "3969",
        },
        {
          id: "46228",
          name: "Hendersonville",
          state_id: "3969",
        },
        {
          id: "46229",
          name: "Hixson",
          state_id: "3969",
        },
        {
          id: "46230",
          name: "Jackson",
          state_id: "3969",
        },
        {
          id: "46231",
          name: "Johnson City",
          state_id: "3969",
        },
        {
          id: "46232",
          name: "Kingsport",
          state_id: "3969",
        },
        {
          id: "46233",
          name: "Knoxville",
          state_id: "3969",
        },
        {
          id: "46234",
          name: "Kodak",
          state_id: "3969",
        },
        {
          id: "46235",
          name: "La Vergne",
          state_id: "3969",
        },
        {
          id: "46236",
          name: "Lawrenceburg",
          state_id: "3969",
        },
        {
          id: "46237",
          name: "Lebanon",
          state_id: "3969",
        },
        {
          id: "46238",
          name: "Lenoir City",
          state_id: "3969",
        },
        {
          id: "46239",
          name: "Lewisburg",
          state_id: "3969",
        },
        {
          id: "46240",
          name: "MacMinnville",
          state_id: "3969",
        },
        {
          id: "46241",
          name: "Maryville",
          state_id: "3969",
        },
        {
          id: "46242",
          name: "Memphis",
          state_id: "3969",
        },
        {
          id: "46243",
          name: "Middle Valley",
          state_id: "3969",
        },
        {
          id: "46244",
          name: "Millington",
          state_id: "3969",
        },
        {
          id: "46245",
          name: "Morristown",
          state_id: "3969",
        },
        {
          id: "46246",
          name: "Mulberry",
          state_id: "3969",
        },
        {
          id: "46247",
          name: "Murfreesboro",
          state_id: "3969",
        },
        {
          id: "46248",
          name: "Nashville",
          state_id: "3969",
        },
        {
          id: "46249",
          name: "Oak Ridge",
          state_id: "3969",
        },
        {
          id: "46250",
          name: "Ooltewah",
          state_id: "3969",
        },
        {
          id: "46251",
          name: "Pinson",
          state_id: "3969",
        },
        {
          id: "46252",
          name: "Red Bank",
          state_id: "3969",
        },
        {
          id: "46253",
          name: "Selmer",
          state_id: "3969",
        },
        {
          id: "46254",
          name: "Sevierville",
          state_id: "3969",
        },
        {
          id: "46255",
          name: "Shelbyville",
          state_id: "3969",
        },
        {
          id: "46256",
          name: "Smithville",
          state_id: "3969",
        },
        {
          id: "46257",
          name: "Smyrna",
          state_id: "3969",
        },
        {
          id: "46258",
          name: "Spring City",
          state_id: "3969",
        },
        {
          id: "46259",
          name: "Springfield",
          state_id: "3969",
        },
        {
          id: "46260",
          name: "Tazewell",
          state_id: "3969",
        },
        {
          id: "46261",
          name: "Trenton",
          state_id: "3969",
        },
        {
          id: "46262",
          name: "Tullahoma",
          state_id: "3969",
        },
        {
          id: "46263",
          name: "Union City",
          state_id: "3969",
        },
      ],
      Texas: [
        {
          id: "46264",
          name: "Abilene",
          state_id: "3970",
        },
        {
          id: "46265",
          name: "Addison",
          state_id: "3970",
        },
        {
          id: "46266",
          name: "Alamo",
          state_id: "3970",
        },
        {
          id: "46267",
          name: "Aldine",
          state_id: "3970",
        },
        {
          id: "46268",
          name: "Alice",
          state_id: "3970",
        },
        {
          id: "46269",
          name: "Allen",
          state_id: "3970",
        },
        {
          id: "46270",
          name: "Alvin",
          state_id: "3970",
        },
        {
          id: "46271",
          name: "Amarillo",
          state_id: "3970",
        },
        {
          id: "46272",
          name: "Anderson Mill",
          state_id: "3970",
        },
        {
          id: "46273",
          name: "Andrews",
          state_id: "3970",
        },
        {
          id: "46274",
          name: "Angleton",
          state_id: "3970",
        },
        {
          id: "46275",
          name: "Argyle",
          state_id: "3970",
        },
        {
          id: "46276",
          name: "Arlington",
          state_id: "3970",
        },
        {
          id: "46277",
          name: "Aspermont",
          state_id: "3970",
        },
        {
          id: "46278",
          name: "Atascocita",
          state_id: "3970",
        },
        {
          id: "46279",
          name: "Athens",
          state_id: "3970",
        },
        {
          id: "46280",
          name: "Austin",
          state_id: "3970",
        },
        {
          id: "46281",
          name: "Austinn",
          state_id: "3970",
        },
        {
          id: "46282",
          name: "Azle",
          state_id: "3970",
        },
        {
          id: "46283",
          name: "Balch Springs",
          state_id: "3970",
        },
        {
          id: "46284",
          name: "Barry",
          state_id: "3970",
        },
        {
          id: "46285",
          name: "Bay City",
          state_id: "3970",
        },
        {
          id: "46286",
          name: "Baytown",
          state_id: "3970",
        },
        {
          id: "46287",
          name: "Beaumont",
          state_id: "3970",
        },
        {
          id: "46288",
          name: "Bedford",
          state_id: "3970",
        },
        {
          id: "46289",
          name: "Beeville",
          state_id: "3970",
        },
        {
          id: "46290",
          name: "Bellaire",
          state_id: "3970",
        },
        {
          id: "46291",
          name: "Belton",
          state_id: "3970",
        },
        {
          id: "46292",
          name: "Benbrook",
          state_id: "3970",
        },
        {
          id: "46293",
          name: "Big Spring",
          state_id: "3970",
        },
        {
          id: "46294",
          name: "Bluff Dale",
          state_id: "3970",
        },
        {
          id: "46295",
          name: "Boerne",
          state_id: "3970",
        },
        {
          id: "46296",
          name: "Borger",
          state_id: "3970",
        },
        {
          id: "46297",
          name: "Breckenridge",
          state_id: "3970",
        },
        {
          id: "46298",
          name: "Brenham",
          state_id: "3970",
        },
        {
          id: "46299",
          name: "Brownfield",
          state_id: "3970",
        },
        {
          id: "46300",
          name: "Brownsville",
          state_id: "3970",
        },
        {
          id: "46301",
          name: "Brownwood",
          state_id: "3970",
        },
        {
          id: "46302",
          name: "Bryan",
          state_id: "3970",
        },
        {
          id: "46303",
          name: "Buda",
          state_id: "3970",
        },
        {
          id: "46304",
          name: "Burkburnett",
          state_id: "3970",
        },
        {
          id: "46305",
          name: "Burleson",
          state_id: "3970",
        },
        {
          id: "46306",
          name: "Campbell",
          state_id: "3970",
        },
        {
          id: "46307",
          name: "Canyon",
          state_id: "3970",
        },
        {
          id: "46308",
          name: "Canyon Lake",
          state_id: "3970",
        },
        {
          id: "46309",
          name: "Carrollton",
          state_id: "3970",
        },
        {
          id: "46310",
          name: "Cat Spring",
          state_id: "3970",
        },
        {
          id: "46311",
          name: "Cedar Hill",
          state_id: "3970",
        },
        {
          id: "46312",
          name: "Cedar Park",
          state_id: "3970",
        },
        {
          id: "46313",
          name: "Celina",
          state_id: "3970",
        },
        {
          id: "46314",
          name: "Center",
          state_id: "3970",
        },
        {
          id: "46315",
          name: "Channelview",
          state_id: "3970",
        },
        {
          id: "46316",
          name: "City of Dallas",
          state_id: "3970",
        },
        {
          id: "46317",
          name: "Cleburne",
          state_id: "3970",
        },
        {
          id: "46318",
          name: "Cloverleaf",
          state_id: "3970",
        },
        {
          id: "46319",
          name: "Clute",
          state_id: "3970",
        },
        {
          id: "46320",
          name: "College Station",
          state_id: "3970",
        },
        {
          id: "46321",
          name: "Colleyville",
          state_id: "3970",
        },
        {
          id: "46322",
          name: "Columbus",
          state_id: "3970",
        },
        {
          id: "46323",
          name: "Comanche",
          state_id: "3970",
        },
        {
          id: "46324",
          name: "Conroe",
          state_id: "3970",
        },
        {
          id: "46325",
          name: "Converse",
          state_id: "3970",
        },
        {
          id: "46326",
          name: "Coppell",
          state_id: "3970",
        },
        {
          id: "46327",
          name: "Copperas Cove",
          state_id: "3970",
        },
        {
          id: "46328",
          name: "Corinth",
          state_id: "3970",
        },
        {
          id: "46329",
          name: "Corpus Christi",
          state_id: "3970",
        },
        {
          id: "46330",
          name: "Corsicana",
          state_id: "3970",
        },
        {
          id: "46331",
          name: "Cotulla",
          state_id: "3970",
        },
        {
          id: "46332",
          name: "Crandall",
          state_id: "3970",
        },
        {
          id: "46333",
          name: "Cypress",
          state_id: "3970",
        },
        {
          id: "46334",
          name: "Dallas",
          state_id: "3970",
        },
        {
          id: "46335",
          name: "Dayton",
          state_id: "3970",
        },
        {
          id: "46336",
          name: "DeSoto",
          state_id: "3970",
        },
        {
          id: "46337",
          name: "Deer Park",
          state_id: "3970",
        },
        {
          id: "46338",
          name: "Del Rio",
          state_id: "3970",
        },
        {
          id: "46339",
          name: "Denison",
          state_id: "3970",
        },
        {
          id: "46340",
          name: "Denton",
          state_id: "3970",
        },
        {
          id: "46341",
          name: "Dickinson",
          state_id: "3970",
        },
        {
          id: "46342",
          name: "Donna",
          state_id: "3970",
        },
        {
          id: "46343",
          name: "Dumas",
          state_id: "3970",
        },
        {
          id: "46344",
          name: "Duncanville",
          state_id: "3970",
        },
        {
          id: "46345",
          name: "Eagle Pass",
          state_id: "3970",
        },
        {
          id: "46346",
          name: "Edinburg",
          state_id: "3970",
        },
        {
          id: "46347",
          name: "El Campo",
          state_id: "3970",
        },
        {
          id: "46348",
          name: "El Paso",
          state_id: "3970",
        },
        {
          id: "46349",
          name: "Elmendorf",
          state_id: "3970",
        },
        {
          id: "46350",
          name: "Ennis",
          state_id: "3970",
        },
        {
          id: "46351",
          name: "Euless",
          state_id: "3970",
        },
        {
          id: "46352",
          name: "Fairfield",
          state_id: "3970",
        },
        {
          id: "46353",
          name: "Farmers Branch",
          state_id: "3970",
        },
        {
          id: "46354",
          name: "Flower Mound",
          state_id: "3970",
        },
        {
          id: "46355",
          name: "Forest Hill",
          state_id: "3970",
        },
        {
          id: "46356",
          name: "Forney",
          state_id: "3970",
        },
        {
          id: "46357",
          name: "Fort Bliss",
          state_id: "3970",
        },
        {
          id: "46358",
          name: "Fort Hood",
          state_id: "3970",
        },
        {
          id: "46359",
          name: "Fort Worth",
          state_id: "3970",
        },
        {
          id: "46360",
          name: "Freeport",
          state_id: "3970",
        },
        {
          id: "46361",
          name: "Friendswood",
          state_id: "3970",
        },
        {
          id: "46362",
          name: "Frisco",
          state_id: "3970",
        },
        {
          id: "46363",
          name: "Gainesville",
          state_id: "3970",
        },
        {
          id: "46364",
          name: "Galena Park",
          state_id: "3970",
        },
        {
          id: "46365",
          name: "Galveston",
          state_id: "3970",
        },
        {
          id: "46366",
          name: "Garland",
          state_id: "3970",
        },
        {
          id: "46367",
          name: "Gatesville",
          state_id: "3970",
        },
        {
          id: "46368",
          name: "Georgetown",
          state_id: "3970",
        },
        {
          id: "46369",
          name: "Grand Prairie",
          state_id: "3970",
        },
        {
          id: "46370",
          name: "Grandview",
          state_id: "3970",
        },
        {
          id: "46371",
          name: "Grapeland",
          state_id: "3970",
        },
        {
          id: "46372",
          name: "Grapevine",
          state_id: "3970",
        },
        {
          id: "46373",
          name: "Greenville",
          state_id: "3970",
        },
        {
          id: "46374",
          name: "Gregory",
          state_id: "3970",
        },
        {
          id: "46375",
          name: "Groves",
          state_id: "3970",
        },
        {
          id: "46376",
          name: "Haltom City",
          state_id: "3970",
        },
        {
          id: "46377",
          name: "Harker Heights",
          state_id: "3970",
        },
        {
          id: "46378",
          name: "Harlingen",
          state_id: "3970",
        },
        {
          id: "46379",
          name: "Henderson",
          state_id: "3970",
        },
        {
          id: "46380",
          name: "Hereford",
          state_id: "3970",
        },
        {
          id: "46381",
          name: "Hewitt",
          state_id: "3970",
        },
        {
          id: "46382",
          name: "Highland Village",
          state_id: "3970",
        },
        {
          id: "46383",
          name: "Hillsboro",
          state_id: "3970",
        },
        {
          id: "46384",
          name: "Houston",
          state_id: "3970",
        },
        {
          id: "46385",
          name: "Humble",
          state_id: "3970",
        },
        {
          id: "46386",
          name: "Huntsville",
          state_id: "3970",
        },
        {
          id: "46387",
          name: "Hurst",
          state_id: "3970",
        },
        {
          id: "46388",
          name: "Ingleside",
          state_id: "3970",
        },
        {
          id: "46389",
          name: "Irving",
          state_id: "3970",
        },
        {
          id: "46390",
          name: "Jacksonville",
          state_id: "3970",
        },
        {
          id: "46391",
          name: "Jefferson",
          state_id: "3970",
        },
        {
          id: "46392",
          name: "Jollyville",
          state_id: "3970",
        },
        {
          id: "46393",
          name: "Justin",
          state_id: "3970",
        },
        {
          id: "46394",
          name: "Katy",
          state_id: "3970",
        },
        {
          id: "46395",
          name: "Kaufman",
          state_id: "3970",
        },
        {
          id: "46396",
          name: "Keller",
          state_id: "3970",
        },
        {
          id: "46397",
          name: "Kemah",
          state_id: "3970",
        },
        {
          id: "46398",
          name: "Kemp",
          state_id: "3970",
        },
        {
          id: "46399",
          name: "Kerrville",
          state_id: "3970",
        },
        {
          id: "46400",
          name: "Kilgore",
          state_id: "3970",
        },
        {
          id: "46401",
          name: "Killeen",
          state_id: "3970",
        },
        {
          id: "46402",
          name: "Kingsville",
          state_id: "3970",
        },
        {
          id: "46403",
          name: "Kingwood",
          state_id: "3970",
        },
        {
          id: "46404",
          name: "La Marque",
          state_id: "3970",
        },
        {
          id: "46405",
          name: "La Porte",
          state_id: "3970",
        },
        {
          id: "46406",
          name: "Lackland Air Force Base",
          state_id: "3970",
        },
        {
          id: "46407",
          name: "Lago Vista",
          state_id: "3970",
        },
        {
          id: "46408",
          name: "Lake Jackson",
          state_id: "3970",
        },
        {
          id: "46409",
          name: "Lamesa",
          state_id: "3970",
        },
        {
          id: "46410",
          name: "Lampasas",
          state_id: "3970",
        },
        {
          id: "46411",
          name: "Lancaster",
          state_id: "3970",
        },
        {
          id: "46412",
          name: "Laredo",
          state_id: "3970",
        },
        {
          id: "46413",
          name: "League City",
          state_id: "3970",
        },
        {
          id: "46414",
          name: "Leon Valley",
          state_id: "3970",
        },
        {
          id: "46415",
          name: "Levelland",
          state_id: "3970",
        },
        {
          id: "46416",
          name: "Lewisville",
          state_id: "3970",
        },
        {
          id: "46417",
          name: "Liberty Hill",
          state_id: "3970",
        },
        {
          id: "46418",
          name: "Lindsay",
          state_id: "3970",
        },
        {
          id: "46419",
          name: "Little Elm",
          state_id: "3970",
        },
        {
          id: "46420",
          name: "Live Oak",
          state_id: "3970",
        },
        {
          id: "46421",
          name: "Llano",
          state_id: "3970",
        },
        {
          id: "46422",
          name: "Lockhart",
          state_id: "3970",
        },
        {
          id: "46423",
          name: "Longview",
          state_id: "3970",
        },
        {
          id: "46424",
          name: "Lubbock",
          state_id: "3970",
        },
        {
          id: "46425",
          name: "Lufkin",
          state_id: "3970",
        },
        {
          id: "46426",
          name: "Lumberton",
          state_id: "3970",
        },
        {
          id: "46427",
          name: "MacAllen",
          state_id: "3970",
        },
        {
          id: "46428",
          name: "MacKinney",
          state_id: "3970",
        },
        {
          id: "46429",
          name: "Magnolia",
          state_id: "3970",
        },
        {
          id: "46430",
          name: "Malakoff",
          state_id: "3970",
        },
        {
          id: "46431",
          name: "Mansfield",
          state_id: "3970",
        },
        {
          id: "46432",
          name: "Marshall",
          state_id: "3970",
        },
        {
          id: "46433",
          name: "McAllen",
          state_id: "3970",
        },
        {
          id: "46434",
          name: "McKinney",
          state_id: "3970",
        },
        {
          id: "46435",
          name: "Medina",
          state_id: "3970",
        },
        {
          id: "46436",
          name: "Mercedes",
          state_id: "3970",
        },
        {
          id: "46437",
          name: "Mesquite",
          state_id: "3970",
        },
        {
          id: "46438",
          name: "Midland",
          state_id: "3970",
        },
        {
          id: "46439",
          name: "Mineral Wells",
          state_id: "3970",
        },
        {
          id: "46440",
          name: "Mission",
          state_id: "3970",
        },
        {
          id: "46441",
          name: "Mission Bend",
          state_id: "3970",
        },
        {
          id: "46442",
          name: "Missouri City",
          state_id: "3970",
        },
        {
          id: "46443",
          name: "Montgomery",
          state_id: "3970",
        },
        {
          id: "46444",
          name: "Mount Pleasant",
          state_id: "3970",
        },
        {
          id: "46445",
          name: "Murphy",
          state_id: "3970",
        },
        {
          id: "46446",
          name: "Nacogdoches",
          state_id: "3970",
        },
        {
          id: "46447",
          name: "Nederland",
          state_id: "3970",
        },
        {
          id: "46448",
          name: "New Braunfels",
          state_id: "3970",
        },
        {
          id: "46449",
          name: "New Caney",
          state_id: "3970",
        },
        {
          id: "46450",
          name: "North Richland Hills",
          state_id: "3970",
        },
        {
          id: "46451",
          name: "North Zulch",
          state_id: "3970",
        },
        {
          id: "46452",
          name: "Odessa",
          state_id: "3970",
        },
        {
          id: "46453",
          name: "Orange",
          state_id: "3970",
        },
        {
          id: "46454",
          name: "Ovalo",
          state_id: "3970",
        },
        {
          id: "46455",
          name: "Palestine",
          state_id: "3970",
        },
        {
          id: "46456",
          name: "Pampa",
          state_id: "3970",
        },
        {
          id: "46457",
          name: "Paris",
          state_id: "3970",
        },
        {
          id: "46458",
          name: "Pasadena",
          state_id: "3970",
        },
        {
          id: "46459",
          name: "Pearland",
          state_id: "3970",
        },
        {
          id: "46460",
          name: "Pecan Grove",
          state_id: "3970",
        },
        {
          id: "46461",
          name: "Pecos",
          state_id: "3970",
        },
        {
          id: "46462",
          name: "Pflugerville",
          state_id: "3970",
        },
        {
          id: "46463",
          name: "Pharr",
          state_id: "3970",
        },
        {
          id: "46464",
          name: "Pinehurst",
          state_id: "3970",
        },
        {
          id: "46465",
          name: "Plainview",
          state_id: "3970",
        },
        {
          id: "46466",
          name: "Plano",
          state_id: "3970",
        },
        {
          id: "46467",
          name: "Pontotoc",
          state_id: "3970",
        },
        {
          id: "46468",
          name: "Port Arthur",
          state_id: "3970",
        },
        {
          id: "46469",
          name: "Port Lavaca",
          state_id: "3970",
        },
        {
          id: "46470",
          name: "Port Neches",
          state_id: "3970",
        },
        {
          id: "46471",
          name: "Portland",
          state_id: "3970",
        },
        {
          id: "46472",
          name: "Pottsboro",
          state_id: "3970",
        },
        {
          id: "46473",
          name: "Princeton",
          state_id: "3970",
        },
        {
          id: "46474",
          name: "Richardson",
          state_id: "3970",
        },
        {
          id: "46475",
          name: "Richmond",
          state_id: "3970",
        },
        {
          id: "46476",
          name: "Rio Grande City",
          state_id: "3970",
        },
        {
          id: "46477",
          name: "Robstown",
          state_id: "3970",
        },
        {
          id: "46478",
          name: "Rockport",
          state_id: "3970",
        },
        {
          id: "46479",
          name: "Rockwall",
          state_id: "3970",
        },
        {
          id: "46480",
          name: "Roma",
          state_id: "3970",
        },
        {
          id: "46481",
          name: "Rosenberg",
          state_id: "3970",
        },
        {
          id: "46482",
          name: "Round Rock",
          state_id: "3970",
        },
        {
          id: "46483",
          name: "Rowlett",
          state_id: "3970",
        },
        {
          id: "46484",
          name: "Royse City",
          state_id: "3970",
        },
        {
          id: "46485",
          name: "Sachse",
          state_id: "3970",
        },
        {
          id: "46486",
          name: "Saginaw",
          state_id: "3970",
        },
        {
          id: "46487",
          name: "San Angelo",
          state_id: "3970",
        },
        {
          id: "46488",
          name: "San Antonio",
          state_id: "3970",
        },
        {
          id: "46489",
          name: "San Benito",
          state_id: "3970",
        },
        {
          id: "46490",
          name: "San Juan",
          state_id: "3970",
        },
        {
          id: "46491",
          name: "San Marcos",
          state_id: "3970",
        },
        {
          id: "46492",
          name: "Santa Fe",
          state_id: "3970",
        },
        {
          id: "46493",
          name: "Schertz",
          state_id: "3970",
        },
        {
          id: "46494",
          name: "Seabrook",
          state_id: "3970",
        },
        {
          id: "46495",
          name: "Seagoville",
          state_id: "3970",
        },
        {
          id: "46496",
          name: "Seguin",
          state_id: "3970",
        },
        {
          id: "46497",
          name: "Sherman",
          state_id: "3970",
        },
        {
          id: "46498",
          name: "Slaton",
          state_id: "3970",
        },
        {
          id: "46499",
          name: "Smithville",
          state_id: "3970",
        },
        {
          id: "46500",
          name: "Snyder",
          state_id: "3970",
        },
        {
          id: "46501",
          name: "Socorro",
          state_id: "3970",
        },
        {
          id: "46502",
          name: "South Houston",
          state_id: "3970",
        },
        {
          id: "46503",
          name: "South Padre Island",
          state_id: "3970",
        },
        {
          id: "46504",
          name: "Southlake",
          state_id: "3970",
        },
        {
          id: "46505",
          name: "Spring",
          state_id: "3970",
        },
        {
          id: "46506",
          name: "Stafford",
          state_id: "3970",
        },
        {
          id: "46507",
          name: "Stephenville",
          state_id: "3970",
        },
        {
          id: "46508",
          name: "Strawn",
          state_id: "3970",
        },
        {
          id: "46509",
          name: "Sugar Land",
          state_id: "3970",
        },
        {
          id: "46510",
          name: "Sulphur Springs",
          state_id: "3970",
        },
        {
          id: "46511",
          name: "Sweetwater",
          state_id: "3970",
        },
        {
          id: "46512",
          name: "Taylor",
          state_id: "3970",
        },
        {
          id: "46513",
          name: "Temple",
          state_id: "3970",
        },
        {
          id: "46514",
          name: "Terrell",
          state_id: "3970",
        },
        {
          id: "46515",
          name: "Texarkana",
          state_id: "3970",
        },
        {
          id: "46516",
          name: "Texas City",
          state_id: "3970",
        },
        {
          id: "46517",
          name: "The Colony",
          state_id: "3970",
        },
        {
          id: "46518",
          name: "The Woodlands",
          state_id: "3970",
        },
        {
          id: "46519",
          name: "Tomball",
          state_id: "3970",
        },
        {
          id: "46520",
          name: "Tyler",
          state_id: "3970",
        },
        {
          id: "46521",
          name: "Universal City",
          state_id: "3970",
        },
        {
          id: "46522",
          name: "University Park",
          state_id: "3970",
        },
        {
          id: "46523",
          name: "Uvalde",
          state_id: "3970",
        },
        {
          id: "46524",
          name: "Vernon",
          state_id: "3970",
        },
        {
          id: "46525",
          name: "Victoria",
          state_id: "3970",
        },
        {
          id: "46526",
          name: "Vidor",
          state_id: "3970",
        },
        {
          id: "46527",
          name: "Waco",
          state_id: "3970",
        },
        {
          id: "46528",
          name: "Watauga",
          state_id: "3970",
        },
        {
          id: "46529",
          name: "Waxahachie",
          state_id: "3970",
        },
        {
          id: "46530",
          name: "Weatherford",
          state_id: "3970",
        },
        {
          id: "46531",
          name: "Weslaco",
          state_id: "3970",
        },
        {
          id: "46532",
          name: "West Odessa",
          state_id: "3970",
        },
        {
          id: "46533",
          name: "West University Place",
          state_id: "3970",
        },
        {
          id: "46534",
          name: "White Settlement",
          state_id: "3970",
        },
        {
          id: "46535",
          name: "Wichita Falls",
          state_id: "3970",
        },
        {
          id: "46536",
          name: "Winnsboro",
          state_id: "3970",
        },
        {
          id: "46537",
          name: "Woodway",
          state_id: "3970",
        },
        {
          id: "46538",
          name: "Wylie",
          state_id: "3970",
        },
        {
          id: "46539",
          name: "Yoakum",
          state_id: "3970",
        },
        {
          id: "46540",
          name: "austinn",
          state_id: "3970",
        },
      ],
      Utah: [
        {
          id: "46542",
          name: "Alpine",
          state_id: "3972",
        },
        {
          id: "46543",
          name: "American Fork",
          state_id: "3972",
        },
        {
          id: "46544",
          name: "Bluffdale",
          state_id: "3972",
        },
        {
          id: "46545",
          name: "Bountiful",
          state_id: "3972",
        },
        {
          id: "46546",
          name: "Brigham City",
          state_id: "3972",
        },
        {
          id: "46547",
          name: "Canyon Rim",
          state_id: "3972",
        },
        {
          id: "46548",
          name: "Castle Dale",
          state_id: "3972",
        },
        {
          id: "46549",
          name: "Cedar City",
          state_id: "3972",
        },
        {
          id: "46550",
          name: "Centerville",
          state_id: "3972",
        },
        {
          id: "46551",
          name: "Clearfield",
          state_id: "3972",
        },
        {
          id: "46552",
          name: "Clinton",
          state_id: "3972",
        },
        {
          id: "46553",
          name: "Cottonwood Heights",
          state_id: "3972",
        },
        {
          id: "46554",
          name: "Cottonwood West",
          state_id: "3972",
        },
        {
          id: "46555",
          name: "Draper",
          state_id: "3972",
        },
        {
          id: "46556",
          name: "East Millcreek",
          state_id: "3972",
        },
        {
          id: "46557",
          name: "Farmington",
          state_id: "3972",
        },
        {
          id: "46558",
          name: "Holladay-Cottonwood",
          state_id: "3972",
        },
        {
          id: "46559",
          name: "Ivins",
          state_id: "3972",
        },
        {
          id: "46560",
          name: "Kaysville",
          state_id: "3972",
        },
        {
          id: "46561",
          name: "Kearns",
          state_id: "3972",
        },
        {
          id: "46562",
          name: "Layton",
          state_id: "3972",
        },
        {
          id: "46563",
          name: "Lehi",
          state_id: "3972",
        },
        {
          id: "46564",
          name: "Logan",
          state_id: "3972",
        },
        {
          id: "46565",
          name: "Magna",
          state_id: "3972",
        },
        {
          id: "46566",
          name: "Mapleton",
          state_id: "3972",
        },
        {
          id: "46567",
          name: "Midvale",
          state_id: "3972",
        },
        {
          id: "46568",
          name: "Millcreek",
          state_id: "3972",
        },
        {
          id: "46569",
          name: "Moab",
          state_id: "3972",
        },
        {
          id: "46570",
          name: "Monticello",
          state_id: "3972",
        },
        {
          id: "46571",
          name: "Murray",
          state_id: "3972",
        },
        {
          id: "46572",
          name: "North Logan",
          state_id: "3972",
        },
        {
          id: "46573",
          name: "North Ogden",
          state_id: "3972",
        },
        {
          id: "46574",
          name: "Ogden",
          state_id: "3972",
        },
        {
          id: "46575",
          name: "Orem",
          state_id: "3972",
        },
        {
          id: "46576",
          name: "Panguitch",
          state_id: "3972",
        },
        {
          id: "46577",
          name: "Park City",
          state_id: "3972",
        },
        {
          id: "46578",
          name: "Payson",
          state_id: "3972",
        },
        {
          id: "46579",
          name: "Pleasant Grove",
          state_id: "3972",
        },
        {
          id: "46580",
          name: "Provo",
          state_id: "3972",
        },
        {
          id: "46581",
          name: "Riverton",
          state_id: "3972",
        },
        {
          id: "46582",
          name: "Roy",
          state_id: "3972",
        },
        {
          id: "46583",
          name: "Saint George",
          state_id: "3972",
        },
        {
          id: "46584",
          name: "Salt Lake City",
          state_id: "3972",
        },
        {
          id: "46585",
          name: "Sandy",
          state_id: "3972",
        },
        {
          id: "46586",
          name: "Santaquin",
          state_id: "3972",
        },
        {
          id: "46587",
          name: "South Jordan",
          state_id: "3972",
        },
        {
          id: "46588",
          name: "South Ogden",
          state_id: "3972",
        },
        {
          id: "46589",
          name: "South Salt Lake",
          state_id: "3972",
        },
        {
          id: "46590",
          name: "Spanish Fork",
          state_id: "3972",
        },
        {
          id: "46591",
          name: "Springville",
          state_id: "3972",
        },
        {
          id: "46592",
          name: "Taylorsville",
          state_id: "3972",
        },
        {
          id: "46593",
          name: "Tooele",
          state_id: "3972",
        },
        {
          id: "46594",
          name: "Tremonton",
          state_id: "3972",
        },
        {
          id: "46595",
          name: "Union",
          state_id: "3972",
        },
        {
          id: "46596",
          name: "Washington",
          state_id: "3972",
        },
        {
          id: "46597",
          name: "West Jordan",
          state_id: "3972",
        },
        {
          id: "46598",
          name: "West Valley City",
          state_id: "3972",
        },
        {
          id: "46599",
          name: "Woods Cross",
          state_id: "3972",
        },
      ],
      Vermont: [
        {
          id: "46600",
          name: "Barre",
          state_id: "3973",
        },
        {
          id: "46601",
          name: "Bennington",
          state_id: "3973",
        },
        {
          id: "46602",
          name: "Brattleboro",
          state_id: "3973",
        },
        {
          id: "46603",
          name: "Bristol",
          state_id: "3973",
        },
        {
          id: "46604",
          name: "Burlington",
          state_id: "3973",
        },
        {
          id: "46605",
          name: "Cabot",
          state_id: "3973",
        },
        {
          id: "46606",
          name: "Colchester",
          state_id: "3973",
        },
        {
          id: "46607",
          name: "Danville",
          state_id: "3973",
        },
        {
          id: "46608",
          name: "Dorset",
          state_id: "3973",
        },
        {
          id: "46609",
          name: "Dummerston",
          state_id: "3973",
        },
        {
          id: "46610",
          name: "East Corinth",
          state_id: "3973",
        },
        {
          id: "46611",
          name: "East Fairfield",
          state_id: "3973",
        },
        {
          id: "46612",
          name: "East Randolph",
          state_id: "3973",
        },
        {
          id: "46613",
          name: "Essex",
          state_id: "3973",
        },
        {
          id: "46614",
          name: "Essex Junction",
          state_id: "3973",
        },
        {
          id: "46615",
          name: "Grand Isle",
          state_id: "3973",
        },
        {
          id: "46616",
          name: "Hartford",
          state_id: "3973",
        },
        {
          id: "46617",
          name: "Jericho",
          state_id: "3973",
        },
        {
          id: "46618",
          name: "Manchester",
          state_id: "3973",
        },
        {
          id: "46619",
          name: "Manchester Center",
          state_id: "3973",
        },
        {
          id: "46620",
          name: "Middlebury",
          state_id: "3973",
        },
        {
          id: "46621",
          name: "Milton",
          state_id: "3973",
        },
        {
          id: "46622",
          name: "Montpelier",
          state_id: "3973",
        },
        {
          id: "46623",
          name: "Putney",
          state_id: "3973",
        },
        {
          id: "46624",
          name: "Randolph",
          state_id: "3973",
        },
        {
          id: "46625",
          name: "Rochester",
          state_id: "3973",
        },
        {
          id: "46626",
          name: "Rutland",
          state_id: "3973",
        },
        {
          id: "46627",
          name: "Saint Albans",
          state_id: "3973",
        },
        {
          id: "46628",
          name: "Saint Johnsbury",
          state_id: "3973",
        },
        {
          id: "46629",
          name: "Saxtons River",
          state_id: "3973",
        },
        {
          id: "46630",
          name: "South Burlington",
          state_id: "3973",
        },
        {
          id: "46631",
          name: "South Strafford",
          state_id: "3973",
        },
        {
          id: "46632",
          name: "Springfield",
          state_id: "3973",
        },
        {
          id: "46633",
          name: "Townshend",
          state_id: "3973",
        },
        {
          id: "46634",
          name: "Tunbridge",
          state_id: "3973",
        },
        {
          id: "46635",
          name: "Van",
          state_id: "3973",
        },
        {
          id: "46636",
          name: "Vernon",
          state_id: "3973",
        },
        {
          id: "46637",
          name: "Wallingford",
          state_id: "3973",
        },
        {
          id: "46638",
          name: "Watisfield",
          state_id: "3973",
        },
        {
          id: "46639",
          name: "West Brookfield",
          state_id: "3973",
        },
        {
          id: "46640",
          name: "West Charleston",
          state_id: "3973",
        },
        {
          id: "46641",
          name: "West Newbury",
          state_id: "3973",
        },
        {
          id: "46642",
          name: "Williston",
          state_id: "3973",
        },
        {
          id: "46643",
          name: "Winooski",
          state_id: "3973",
        },
      ],
      Virginia: [
        {
          id: "46644",
          name: "Abingdon",
          state_id: "3974",
        },
        {
          id: "46645",
          name: "Alexandria",
          state_id: "3974",
        },
        {
          id: "46646",
          name: "Annandale",
          state_id: "3974",
        },
        {
          id: "46647",
          name: "Arlington",
          state_id: "3974",
        },
        {
          id: "46648",
          name: "Ashburn",
          state_id: "3974",
        },
        {
          id: "46649",
          name: "Ashland",
          state_id: "3974",
        },
        {
          id: "46650",
          name: "Aylett",
          state_id: "3974",
        },
        {
          id: "46651",
          name: "Bailey''s Crossroads",
          state_id: "3974",
        },
        {
          id: "46652",
          name: "Blacksburg",
          state_id: "3974",
        },
        {
          id: "46653",
          name: "Bland",
          state_id: "3974",
        },
        {
          id: "46654",
          name: "Bluefield",
          state_id: "3974",
        },
        {
          id: "46655",
          name: "Bon Air",
          state_id: "3974",
        },
        {
          id: "46656",
          name: "Bristol",
          state_id: "3974",
        },
        {
          id: "46657",
          name: "Burke",
          state_id: "3974",
        },
        {
          id: "46658",
          name: "Cave Spring",
          state_id: "3974",
        },
        {
          id: "46659",
          name: "Centreville",
          state_id: "3974",
        },
        {
          id: "46660",
          name: "Chantilly",
          state_id: "3974",
        },
        {
          id: "46661",
          name: "Charlottesville",
          state_id: "3974",
        },
        {
          id: "46662",
          name: "Chesapeake",
          state_id: "3974",
        },
        {
          id: "46663",
          name: "Chester",
          state_id: "3974",
        },
        {
          id: "46664",
          name: "Christiansburg",
          state_id: "3974",
        },
        {
          id: "46665",
          name: "Churchville",
          state_id: "3974",
        },
        {
          id: "46666",
          name: "Clifton",
          state_id: "3974",
        },
        {
          id: "46667",
          name: "Colonial Heights",
          state_id: "3974",
        },
        {
          id: "46668",
          name: "Culloden",
          state_id: "3974",
        },
        {
          id: "46669",
          name: "Dale City",
          state_id: "3974",
        },
        {
          id: "46670",
          name: "Danville",
          state_id: "3974",
        },
        {
          id: "46671",
          name: "Dublin",
          state_id: "3974",
        },
        {
          id: "46672",
          name: "Eagle Rock",
          state_id: "3974",
        },
        {
          id: "46673",
          name: "East Highland Park",
          state_id: "3974",
        },
        {
          id: "46674",
          name: "Faber",
          state_id: "3974",
        },
        {
          id: "46675",
          name: "Fairfax",
          state_id: "3974",
        },
        {
          id: "46676",
          name: "Falls Church",
          state_id: "3974",
        },
        {
          id: "46677",
          name: "Fishersville",
          state_id: "3974",
        },
        {
          id: "46678",
          name: "Fort Hunt",
          state_id: "3974",
        },
        {
          id: "46679",
          name: "Fort Valley",
          state_id: "3974",
        },
        {
          id: "46680",
          name: "Franconia",
          state_id: "3974",
        },
        {
          id: "46681",
          name: "Franklin",
          state_id: "3974",
        },
        {
          id: "46682",
          name: "Fredericksburg",
          state_id: "3974",
        },
        {
          id: "46683",
          name: "Front Royal",
          state_id: "3974",
        },
        {
          id: "46684",
          name: "Gainesville",
          state_id: "3974",
        },
        {
          id: "46685",
          name: "Glen Allen",
          state_id: "3974",
        },
        {
          id: "46686",
          name: "Gloucester",
          state_id: "3974",
        },
        {
          id: "46687",
          name: "Goochland",
          state_id: "3974",
        },
        {
          id: "46688",
          name: "Great Falls",
          state_id: "3974",
        },
        {
          id: "46689",
          name: "Groveton",
          state_id: "3974",
        },
        {
          id: "46690",
          name: "Hampton",
          state_id: "3974",
        },
        {
          id: "46691",
          name: "Harrisonburg",
          state_id: "3974",
        },
        {
          id: "46692",
          name: "Henrico",
          state_id: "3974",
        },
        {
          id: "46693",
          name: "Herndon",
          state_id: "3974",
        },
        {
          id: "46694",
          name: "Highland Springs",
          state_id: "3974",
        },
        {
          id: "46695",
          name: "Hollins",
          state_id: "3974",
        },
        {
          id: "46696",
          name: "Hopewell",
          state_id: "3974",
        },
        {
          id: "46697",
          name: "Hybla Valley",
          state_id: "3974",
        },
        {
          id: "46698",
          name: "Idylwood",
          state_id: "3974",
        },
        {
          id: "46699",
          name: "Irvington",
          state_id: "3974",
        },
        {
          id: "46700",
          name: "Jamesville",
          state_id: "3974",
        },
        {
          id: "46701",
          name: "Jefferson",
          state_id: "3974",
        },
        {
          id: "46702",
          name: "Keen Mountain",
          state_id: "3974",
        },
        {
          id: "46703",
          name: "Keswick",
          state_id: "3974",
        },
        {
          id: "46704",
          name: "Lake Ridge",
          state_id: "3974",
        },
        {
          id: "46705",
          name: "Lakeside",
          state_id: "3974",
        },
        {
          id: "46706",
          name: "Laurel",
          state_id: "3974",
        },
        {
          id: "46707",
          name: "Leesburg",
          state_id: "3974",
        },
        {
          id: "46708",
          name: "Lincolnia",
          state_id: "3974",
        },
        {
          id: "46709",
          name: "Lorton",
          state_id: "3974",
        },
        {
          id: "46710",
          name: "Lynchburg",
          state_id: "3974",
        },
        {
          id: "46711",
          name: "MacLean",
          state_id: "3974",
        },
        {
          id: "46712",
          name: "Madison",
          state_id: "3974",
        },
        {
          id: "46713",
          name: "Madison Heights",
          state_id: "3974",
        },
        {
          id: "46714",
          name: "Manassas",
          state_id: "3974",
        },
        {
          id: "46715",
          name: "Marion",
          state_id: "3974",
        },
        {
          id: "46716",
          name: "Martinsville",
          state_id: "3974",
        },
        {
          id: "46717",
          name: "Mclean",
          state_id: "3974",
        },
        {
          id: "46718",
          name: "Mechanicsville",
          state_id: "3974",
        },
        {
          id: "46719",
          name: "Melfa",
          state_id: "3974",
        },
        {
          id: "46720",
          name: "Midlothian",
          state_id: "3974",
        },
        {
          id: "46721",
          name: "Montclair",
          state_id: "3974",
        },
        {
          id: "46722",
          name: "Montross",
          state_id: "3974",
        },
        {
          id: "46723",
          name: "Mount Vernon",
          state_id: "3974",
        },
        {
          id: "46724",
          name: "Newington",
          state_id: "3974",
        },
        {
          id: "46725",
          name: "Newport News",
          state_id: "3974",
        },
        {
          id: "46726",
          name: "Norfolk",
          state_id: "3974",
        },
        {
          id: "46727",
          name: "North Springfield",
          state_id: "3974",
        },
        {
          id: "46728",
          name: "Oakton",
          state_id: "3974",
        },
        {
          id: "46729",
          name: "Orange",
          state_id: "3974",
        },
        {
          id: "46730",
          name: "Petersburg",
          state_id: "3974",
        },
        {
          id: "46731",
          name: "Poquoson",
          state_id: "3974",
        },
        {
          id: "46732",
          name: "Portsmouth",
          state_id: "3974",
        },
        {
          id: "46733",
          name: "Radford",
          state_id: "3974",
        },
        {
          id: "46734",
          name: "Reston",
          state_id: "3974",
        },
        {
          id: "46735",
          name: "Richmond",
          state_id: "3974",
        },
        {
          id: "46736",
          name: "Roanoke",
          state_id: "3974",
        },
        {
          id: "46737",
          name: "Rose Hill",
          state_id: "3974",
        },
        {
          id: "46738",
          name: "Salem",
          state_id: "3974",
        },
        {
          id: "46739",
          name: "Seaford",
          state_id: "3974",
        },
        {
          id: "46740",
          name: "South Boston",
          state_id: "3974",
        },
        {
          id: "46741",
          name: "Springfield",
          state_id: "3974",
        },
        {
          id: "46742",
          name: "Stafford",
          state_id: "3974",
        },
        {
          id: "46743",
          name: "Staffordshire",
          state_id: "3974",
        },
        {
          id: "46744",
          name: "Staunton",
          state_id: "3974",
        },
        {
          id: "46745",
          name: "Sterling",
          state_id: "3974",
        },
        {
          id: "46746",
          name: "Suffolk",
          state_id: "3974",
        },
        {
          id: "46747",
          name: "Sugarland Run",
          state_id: "3974",
        },
        {
          id: "46748",
          name: "Tappahannock",
          state_id: "3974",
        },
        {
          id: "46749",
          name: "Timberlake",
          state_id: "3974",
        },
        {
          id: "46750",
          name: "Triangle",
          state_id: "3974",
        },
        {
          id: "46751",
          name: "Tuckahoe",
          state_id: "3974",
        },
        {
          id: "46752",
          name: "Tysons Corner",
          state_id: "3974",
        },
        {
          id: "46753",
          name: "Vienna",
          state_id: "3974",
        },
        {
          id: "46754",
          name: "Virginia Beach",
          state_id: "3974",
        },
        {
          id: "46755",
          name: "Warrenton",
          state_id: "3974",
        },
        {
          id: "46756",
          name: "Washington",
          state_id: "3974",
        },
        {
          id: "46757",
          name: "Waterford",
          state_id: "3974",
        },
        {
          id: "46758",
          name: "Waynesboro",
          state_id: "3974",
        },
        {
          id: "46759",
          name: "West Springfield",
          state_id: "3974",
        },
        {
          id: "46760",
          name: "Williamsburg",
          state_id: "3974",
        },
        {
          id: "46761",
          name: "Winchester",
          state_id: "3974",
        },
        {
          id: "46762",
          name: "Wolf Trap",
          state_id: "3974",
        },
        {
          id: "46763",
          name: "Woodbridge",
          state_id: "3974",
        },
        {
          id: "46764",
          name: "Wytheville",
          state_id: "3974",
        },
        {
          id: "46765",
          name: "Yorktown",
          state_id: "3974",
        },
      ],
      Washington: [
        {
          id: "46766",
          name: "Aberdeen",
          state_id: "3975",
        },
        {
          id: "46767",
          name: "Airway Heights",
          state_id: "3975",
        },
        {
          id: "46768",
          name: "Alderwood Manor",
          state_id: "3975",
        },
        {
          id: "46769",
          name: "Anacortes",
          state_id: "3975",
        },
        {
          id: "46770",
          name: "Arlington",
          state_id: "3975",
        },
        {
          id: "46771",
          name: "Auburn",
          state_id: "3975",
        },
        {
          id: "46772",
          name: "Bainbridge Island",
          state_id: "3975",
        },
        {
          id: "46773",
          name: "Battle Ground",
          state_id: "3975",
        },
        {
          id: "46774",
          name: "Bellevue",
          state_id: "3975",
        },
        {
          id: "46775",
          name: "Bellingham",
          state_id: "3975",
        },
        {
          id: "46776",
          name: "Bingen",
          state_id: "3975",
        },
        {
          id: "46777",
          name: "Blaine",
          state_id: "3975",
        },
        {
          id: "46778",
          name: "Bothell",
          state_id: "3975",
        },
        {
          id: "46779",
          name: "Bremerton",
          state_id: "3975",
        },
        {
          id: "46780",
          name: "Bryn Mawr-Skyway",
          state_id: "3975",
        },
        {
          id: "46781",
          name: "Buckley",
          state_id: "3975",
        },
        {
          id: "46782",
          name: "Burien",
          state_id: "3975",
        },
        {
          id: "46783",
          name: "Burlington",
          state_id: "3975",
        },
        {
          id: "46784",
          name: "Camano Island",
          state_id: "3975",
        },
        {
          id: "46785",
          name: "Camas",
          state_id: "3975",
        },
        {
          id: "46786",
          name: "Cascade-Fairwood",
          state_id: "3975",
        },
        {
          id: "46787",
          name: "Centralia",
          state_id: "3975",
        },
        {
          id: "46788",
          name: "Chehalis",
          state_id: "3975",
        },
        {
          id: "46789",
          name: "Cheney",
          state_id: "3975",
        },
        {
          id: "46790",
          name: "Clear Lake",
          state_id: "3975",
        },
        {
          id: "46791",
          name: "Colbert",
          state_id: "3975",
        },
        {
          id: "46792",
          name: "Cottage Lake",
          state_id: "3975",
        },
        {
          id: "46793",
          name: "Covington-Sawyer-Wilderness",
          state_id: "3975",
        },
        {
          id: "46794",
          name: "Des Moines",
          state_id: "3975",
        },
        {
          id: "46795",
          name: "Duvall",
          state_id: "3975",
        },
        {
          id: "46796",
          name: "East Hill-Meridian",
          state_id: "3975",
        },
        {
          id: "46797",
          name: "East Renton Highlands",
          state_id: "3975",
        },
        {
          id: "46798",
          name: "East Wenatchee Bench",
          state_id: "3975",
        },
        {
          id: "46799",
          name: "Eastsound",
          state_id: "3975",
        },
        {
          id: "46800",
          name: "Eatonville",
          state_id: "3975",
        },
        {
          id: "46801",
          name: "Edgewood-North Hill",
          state_id: "3975",
        },
        {
          id: "46802",
          name: "Edmonds",
          state_id: "3975",
        },
        {
          id: "46803",
          name: "Elk Plain",
          state_id: "3975",
        },
        {
          id: "46804",
          name: "Ellensburg",
          state_id: "3975",
        },
        {
          id: "46805",
          name: "Enumclaw",
          state_id: "3975",
        },
        {
          id: "46806",
          name: "Esperance",
          state_id: "3975",
        },
        {
          id: "46807",
          name: "Everett",
          state_id: "3975",
        },
        {
          id: "46808",
          name: "Evergreen",
          state_id: "3975",
        },
        {
          id: "46809",
          name: "Fairchild",
          state_id: "3975",
        },
        {
          id: "46810",
          name: "Federal Way",
          state_id: "3975",
        },
        {
          id: "46811",
          name: "Ferndale",
          state_id: "3975",
        },
        {
          id: "46812",
          name: "Fircrest",
          state_id: "3975",
        },
        {
          id: "46813",
          name: "Ford",
          state_id: "3975",
        },
        {
          id: "46814",
          name: "Fort Lewis",
          state_id: "3975",
        },
        {
          id: "46815",
          name: "Friday Harbor",
          state_id: "3975",
        },
        {
          id: "46816",
          name: "Gig Harbor",
          state_id: "3975",
        },
        {
          id: "46817",
          name: "Graham",
          state_id: "3975",
        },
        {
          id: "46818",
          name: "Harbour Pointe",
          state_id: "3975",
        },
        {
          id: "46819",
          name: "Inglewood-Finn Hill",
          state_id: "3975",
        },
        {
          id: "46820",
          name: "Issaquah",
          state_id: "3975",
        },
        {
          id: "46821",
          name: "Kelso",
          state_id: "3975",
        },
        {
          id: "46822",
          name: "Kenmore",
          state_id: "3975",
        },
        {
          id: "46823",
          name: "Kennewick",
          state_id: "3975",
        },
        {
          id: "46824",
          name: "Kent",
          state_id: "3975",
        },
        {
          id: "46825",
          name: "Kingsgate",
          state_id: "3975",
        },
        {
          id: "46826",
          name: "Kirkland",
          state_id: "3975",
        },
        {
          id: "46827",
          name: "Lacey",
          state_id: "3975",
        },
        {
          id: "46828",
          name: "Lake Serene-North Lynnwood",
          state_id: "3975",
        },
        {
          id: "46829",
          name: "Lakeland North",
          state_id: "3975",
        },
        {
          id: "46830",
          name: "Lakeland South",
          state_id: "3975",
        },
        {
          id: "46831",
          name: "Lakewood",
          state_id: "3975",
        },
        {
          id: "46832",
          name: "Longview",
          state_id: "3975",
        },
        {
          id: "46833",
          name: "Lynnwood",
          state_id: "3975",
        },
        {
          id: "46834",
          name: "Martha Lake",
          state_id: "3975",
        },
        {
          id: "46835",
          name: "Marysville",
          state_id: "3975",
        },
        {
          id: "46836",
          name: "Mercer Island",
          state_id: "3975",
        },
        {
          id: "46837",
          name: "Minnehaha",
          state_id: "3975",
        },
        {
          id: "46838",
          name: "Monroe",
          state_id: "3975",
        },
        {
          id: "46839",
          name: "Moses Lake",
          state_id: "3975",
        },
        {
          id: "46840",
          name: "Mossyrock",
          state_id: "3975",
        },
        {
          id: "46841",
          name: "Mount Vernon",
          state_id: "3975",
        },
        {
          id: "46842",
          name: "Mountlake Terrace",
          state_id: "3975",
        },
        {
          id: "46843",
          name: "Mukilteo",
          state_id: "3975",
        },
        {
          id: "46844",
          name: "Newport Hills",
          state_id: "3975",
        },
        {
          id: "46845",
          name: "North City-Ridgecrest",
          state_id: "3975",
        },
        {
          id: "46846",
          name: "North Creek",
          state_id: "3975",
        },
        {
          id: "46847",
          name: "North Marysville",
          state_id: "3975",
        },
        {
          id: "46848",
          name: "Oak Harbor",
          state_id: "3975",
        },
        {
          id: "46849",
          name: "Ocean Shores",
          state_id: "3975",
        },
        {
          id: "46850",
          name: "Olympia",
          state_id: "3975",
        },
        {
          id: "46851",
          name: "Opportunity",
          state_id: "3975",
        },
        {
          id: "46852",
          name: "Orchards South",
          state_id: "3975",
        },
        {
          id: "46853",
          name: "Orting",
          state_id: "3975",
        },
        {
          id: "46854",
          name: "Paine Field-Lake Stickney",
          state_id: "3975",
        },
        {
          id: "46855",
          name: "Parkland",
          state_id: "3975",
        },
        {
          id: "46856",
          name: "Pasco",
          state_id: "3975",
        },
        {
          id: "46857",
          name: "Picnic Point-North Lynnwood",
          state_id: "3975",
        },
        {
          id: "46858",
          name: "Pine Lake",
          state_id: "3975",
        },
        {
          id: "46859",
          name: "Port Angeles",
          state_id: "3975",
        },
        {
          id: "46860",
          name: "Port Hadlock",
          state_id: "3975",
        },
        {
          id: "46861",
          name: "Port Ludlow",
          state_id: "3975",
        },
        {
          id: "46862",
          name: "Port Orchard",
          state_id: "3975",
        },
        {
          id: "46863",
          name: "Poulsbo",
          state_id: "3975",
        },
        {
          id: "46864",
          name: "Pullman",
          state_id: "3975",
        },
        {
          id: "46865",
          name: "Puyallup",
          state_id: "3975",
        },
        {
          id: "46866",
          name: "Redmond",
          state_id: "3975",
        },
        {
          id: "46867",
          name: "Renton",
          state_id: "3975",
        },
        {
          id: "46868",
          name: "Republic",
          state_id: "3975",
        },
        {
          id: "46869",
          name: "Richland",
          state_id: "3975",
        },
        {
          id: "46870",
          name: "Riverton-Boulevard Park",
          state_id: "3975",
        },
        {
          id: "46871",
          name: "Sahalee",
          state_id: "3975",
        },
        {
          id: "46872",
          name: "Salmon Creek",
          state_id: "3975",
        },
        {
          id: "46873",
          name: "Sammamish",
          state_id: "3975",
        },
        {
          id: "46874",
          name: "SeaTac",
          state_id: "3975",
        },
        {
          id: "46875",
          name: "Seattle",
          state_id: "3975",
        },
        {
          id: "46876",
          name: "Seattle Hill-Silver Firs",
          state_id: "3975",
        },
        {
          id: "46877",
          name: "Sedro Woolley",
          state_id: "3975",
        },
        {
          id: "46878",
          name: "Shelton",
          state_id: "3975",
        },
        {
          id: "46879",
          name: "Shoreline",
          state_id: "3975",
        },
        {
          id: "46880",
          name: "Silverdale",
          state_id: "3975",
        },
        {
          id: "46881",
          name: "Snohomish",
          state_id: "3975",
        },
        {
          id: "46882",
          name: "South Hill",
          state_id: "3975",
        },
        {
          id: "46883",
          name: "South Prairie",
          state_id: "3975",
        },
        {
          id: "46884",
          name: "South Seattle",
          state_id: "3975",
        },
        {
          id: "46885",
          name: "Spanaway",
          state_id: "3975",
        },
        {
          id: "46886",
          name: "Spokane",
          state_id: "3975",
        },
        {
          id: "46887",
          name: "Sumas",
          state_id: "3975",
        },
        {
          id: "46888",
          name: "Sumner",
          state_id: "3975",
        },
        {
          id: "46889",
          name: "Sunnyside",
          state_id: "3975",
        },
        {
          id: "46890",
          name: "Tacoma",
          state_id: "3975",
        },
        {
          id: "46891",
          name: "Tukwila",
          state_id: "3975",
        },
        {
          id: "46892",
          name: "Tumwater",
          state_id: "3975",
        },
        {
          id: "46893",
          name: "University Place",
          state_id: "3975",
        },
        {
          id: "46894",
          name: "Vancouver",
          state_id: "3975",
        },
        {
          id: "46895",
          name: "Vashon",
          state_id: "3975",
        },
        {
          id: "46896",
          name: "Walla Walla",
          state_id: "3975",
        },
        {
          id: "46897",
          name: "Washougal",
          state_id: "3975",
        },
        {
          id: "46898",
          name: "Wenatchee",
          state_id: "3975",
        },
        {
          id: "46899",
          name: "West Lake Stevens",
          state_id: "3975",
        },
        {
          id: "46900",
          name: "White Center",
          state_id: "3975",
        },
        {
          id: "46901",
          name: "White Salmon",
          state_id: "3975",
        },
        {
          id: "46902",
          name: "White Swan",
          state_id: "3975",
        },
        {
          id: "46903",
          name: "Woodinville",
          state_id: "3975",
        },
        {
          id: "46904",
          name: "Yakima",
          state_id: "3975",
        },
        {
          id: "46905",
          name: "Yelm",
          state_id: "3975",
        },
      ],
      "West Virginia": [
        {
          id: "48281",
          name: "Charleston",
          state_id: "3976",
        },
        {
          id: "48282",
          name: "Huntington",
          state_id: "3976",
        },
        {
          id: "48283",
          name: "Morgantown",
          state_id: "3976",
        },
        {
          id: "48284",
          name: "Parkersburg",
          state_id: "3976",
        },
        {
          id: "48285",
          name: "Wheeling",
          state_id: "3976",
        },
        {
          id: "48286",
          name: "Weirton",
          state_id: "3976",
        },
        {
          id: "48287",
          name: "Fairmont",
          state_id: "3976",
        },
        {
          id: "48288",
          name: "Martinsburg",
          state_id: "3976",
        },
        {
          id: "48289",
          name: "Beckley",
          state_id: "3976",
        },
        {
          id: "48290",
          name: "Clarksburg",
          state_id: "3976",
        },
        {
          id: "48291",
          name: "South Charleston",
          state_id: "3976",
        },
        {
          id: "48292",
          name: "St. Albans",
          state_id: "3976",
        },
        {
          id: "48293",
          name: "Vienna",
          state_id: "3976",
        },
        {
          id: "48294",
          name: "Bluefield",
          state_id: "3976",
        },
        {
          id: "48295",
          name: "Moundsville",
          state_id: "3976",
        },
        {
          id: "48296",
          name: "Bridgeport",
          state_id: "3976",
        },
        {
          id: "48297",
          name: "Oak Hill",
          state_id: "3976",
        },
        {
          id: "48298",
          name: "Dunbar",
          state_id: "3976",
        },
        {
          id: "48299",
          name: "Elkins",
          state_id: "3976",
        },
        {
          id: "48300",
          name: "Nitro",
          state_id: "3976",
        },
        {
          id: "48301",
          name: "Hurricane",
          state_id: "3976",
        },
        {
          id: "48302",
          name: "Princeton",
          state_id: "3976",
        },
        {
          id: "48303",
          name: "Charles Town",
          state_id: "3976",
        },
        {
          id: "48304",
          name: "Buckhannon",
          state_id: "3976",
        },
        {
          id: "48305",
          name: "Keyser",
          state_id: "3976",
        },
        {
          id: "48306",
          name: "New Martinsville",
          state_id: "3976",
        },
        {
          id: "48307",
          name: "Grafton",
          state_id: "3976",
        },
        {
          id: "48308",
          name: "Ranson",
          state_id: "3976",
        },
        {
          id: "48309",
          name: "Point Pleasant",
          state_id: "3976",
        },
        {
          id: "48310",
          name: "Westover",
          state_id: "3976",
        },
        {
          id: "48311",
          name: "Weston",
          state_id: "3976",
        },
        {
          id: "48312",
          name: "Lewisburg",
          state_id: "3976",
        },
        {
          id: "48313",
          name: "Ravenswood",
          state_id: "3976",
        },
        {
          id: "48314",
          name: "Summersville",
          state_id: "3976",
        },
      ],
      Wisconsin: [
        {
          id: "46906",
          name: "Adams",
          state_id: "3977",
        },
        {
          id: "46907",
          name: "Allouez",
          state_id: "3977",
        },
        {
          id: "46908",
          name: "Appleton",
          state_id: "3977",
        },
        {
          id: "46909",
          name: "Ashland",
          state_id: "3977",
        },
        {
          id: "46910",
          name: "Ashwaubenon",
          state_id: "3977",
        },
        {
          id: "46911",
          name: "Baraboo",
          state_id: "3977",
        },
        {
          id: "46912",
          name: "Beaver Dam",
          state_id: "3977",
        },
        {
          id: "46913",
          name: "Beloit",
          state_id: "3977",
        },
        {
          id: "46914",
          name: "Brookfield",
          state_id: "3977",
        },
        {
          id: "46915",
          name: "Brown Deer",
          state_id: "3977",
        },
        {
          id: "46916",
          name: "Burlington",
          state_id: "3977",
        },
        {
          id: "46917",
          name: "Caledonia",
          state_id: "3977",
        },
        {
          id: "46918",
          name: "Carter",
          state_id: "3977",
        },
        {
          id: "46919",
          name: "Cedarburg",
          state_id: "3977",
        },
        {
          id: "46920",
          name: "Chippewa Falls",
          state_id: "3977",
        },
        {
          id: "46921",
          name: "Cudahy",
          state_id: "3977",
        },
        {
          id: "46922",
          name: "De Pere",
          state_id: "3977",
        },
        {
          id: "46923",
          name: "Deer Park",
          state_id: "3977",
        },
        {
          id: "46924",
          name: "Delafield",
          state_id: "3977",
        },
        {
          id: "46925",
          name: "Eau Claire",
          state_id: "3977",
        },
        {
          id: "46926",
          name: "Elkhorn",
          state_id: "3977",
        },
        {
          id: "46927",
          name: "Elroy",
          state_id: "3977",
        },
        {
          id: "46928",
          name: "Fitchburg",
          state_id: "3977",
        },
        {
          id: "46929",
          name: "Fond du Lac",
          state_id: "3977",
        },
        {
          id: "46930",
          name: "Fort Atkinson",
          state_id: "3977",
        },
        {
          id: "46931",
          name: "Franklin",
          state_id: "3977",
        },
        {
          id: "46932",
          name: "Galesville",
          state_id: "3977",
        },
        {
          id: "46933",
          name: "Germantown",
          state_id: "3977",
        },
        {
          id: "46934",
          name: "Glen Flora",
          state_id: "3977",
        },
        {
          id: "46935",
          name: "Glendale",
          state_id: "3977",
        },
        {
          id: "46936",
          name: "Goodman",
          state_id: "3977",
        },
        {
          id: "46937",
          name: "Grafton",
          state_id: "3977",
        },
        {
          id: "46938",
          name: "Green Bay",
          state_id: "3977",
        },
        {
          id: "46939",
          name: "Greendale",
          state_id: "3977",
        },
        {
          id: "46940",
          name: "Greenfield",
          state_id: "3977",
        },
        {
          id: "46941",
          name: "Hartford",
          state_id: "3977",
        },
        {
          id: "46942",
          name: "Hartland",
          state_id: "3977",
        },
        {
          id: "46943",
          name: "Howard",
          state_id: "3977",
        },
        {
          id: "46944",
          name: "Hudson",
          state_id: "3977",
        },
        {
          id: "46945",
          name: "Janesville",
          state_id: "3977",
        },
        {
          id: "46946",
          name: "Jefferson",
          state_id: "3977",
        },
        {
          id: "46947",
          name: "Junction City",
          state_id: "3977",
        },
        {
          id: "46948",
          name: "Kaukauna",
          state_id: "3977",
        },
        {
          id: "46949",
          name: "Kenosha",
          state_id: "3977",
        },
        {
          id: "46950",
          name: "Kiel",
          state_id: "3977",
        },
        {
          id: "46951",
          name: "Kohler",
          state_id: "3977",
        },
        {
          id: "46952",
          name: "La Crosse",
          state_id: "3977",
        },
        {
          id: "46953",
          name: "Little Chute",
          state_id: "3977",
        },
        {
          id: "46954",
          name: "Madison",
          state_id: "3977",
        },
        {
          id: "46955",
          name: "Manitowoc",
          state_id: "3977",
        },
        {
          id: "46956",
          name: "Marinette",
          state_id: "3977",
        },
        {
          id: "46957",
          name: "Marshfield",
          state_id: "3977",
        },
        {
          id: "46958",
          name: "Medford",
          state_id: "3977",
        },
        {
          id: "46959",
          name: "Menasha",
          state_id: "3977",
        },
        {
          id: "46960",
          name: "Menomonee Falls",
          state_id: "3977",
        },
        {
          id: "46961",
          name: "Menomonie",
          state_id: "3977",
        },
        {
          id: "46962",
          name: "Mequon",
          state_id: "3977",
        },
        {
          id: "46963",
          name: "Merrill",
          state_id: "3977",
        },
        {
          id: "46964",
          name: "Middleton",
          state_id: "3977",
        },
        {
          id: "46965",
          name: "Milwaukee",
          state_id: "3977",
        },
        {
          id: "46966",
          name: "Mineral Point",
          state_id: "3977",
        },
        {
          id: "46967",
          name: "Monroe",
          state_id: "3977",
        },
        {
          id: "46968",
          name: "Mount Pleasant",
          state_id: "3977",
        },
        {
          id: "46969",
          name: "Mukwonago",
          state_id: "3977",
        },
        {
          id: "46970",
          name: "Muskego",
          state_id: "3977",
        },
        {
          id: "46971",
          name: "Neenah",
          state_id: "3977",
        },
        {
          id: "46972",
          name: "New Berlin",
          state_id: "3977",
        },
        {
          id: "46973",
          name: "New Richmond",
          state_id: "3977",
        },
        {
          id: "46974",
          name: "Oak Creek",
          state_id: "3977",
        },
        {
          id: "46975",
          name: "Oconomowoc",
          state_id: "3977",
        },
        {
          id: "46976",
          name: "Onalaska",
          state_id: "3977",
        },
        {
          id: "46977",
          name: "Orfordville",
          state_id: "3977",
        },
        {
          id: "46978",
          name: "Oshkosh",
          state_id: "3977",
        },
        {
          id: "46979",
          name: "Pigeon Falls",
          state_id: "3977",
        },
        {
          id: "46980",
          name: "Platteville",
          state_id: "3977",
        },
        {
          id: "46981",
          name: "Pleasant Prairie",
          state_id: "3977",
        },
        {
          id: "46982",
          name: "Plover",
          state_id: "3977",
        },
        {
          id: "46983",
          name: "Port Washington",
          state_id: "3977",
        },
        {
          id: "46984",
          name: "Portage",
          state_id: "3977",
        },
        {
          id: "46985",
          name: "Pound",
          state_id: "3977",
        },
        {
          id: "46986",
          name: "Racine",
          state_id: "3977",
        },
        {
          id: "46987",
          name: "Reedsburg",
          state_id: "3977",
        },
        {
          id: "46988",
          name: "Rhinelander",
          state_id: "3977",
        },
        {
          id: "46989",
          name: "River Falls",
          state_id: "3977",
        },
        {
          id: "46990",
          name: "Saint Francis",
          state_id: "3977",
        },
        {
          id: "46991",
          name: "Sheboygan",
          state_id: "3977",
        },
        {
          id: "46992",
          name: "Shorewood",
          state_id: "3977",
        },
        {
          id: "46993",
          name: "South Milwaukee",
          state_id: "3977",
        },
        {
          id: "46994",
          name: "Spring Valley",
          state_id: "3977",
        },
        {
          id: "46995",
          name: "Stevens Point",
          state_id: "3977",
        },
        {
          id: "46996",
          name: "Stoughton",
          state_id: "3977",
        },
        {
          id: "46997",
          name: "Strum",
          state_id: "3977",
        },
        {
          id: "46998",
          name: "Sturtevant",
          state_id: "3977",
        },
        {
          id: "46999",
          name: "Sun Prairie",
          state_id: "3977",
        },
        {
          id: "47000",
          name: "Superior",
          state_id: "3977",
        },
        {
          id: "47001",
          name: "Three Lakes",
          state_id: "3977",
        },
        {
          id: "47002",
          name: "Tomah",
          state_id: "3977",
        },
        {
          id: "47003",
          name: "Two Rivers",
          state_id: "3977",
        },
        {
          id: "47004",
          name: "Washington Island",
          state_id: "3977",
        },
        {
          id: "47005",
          name: "Waterford",
          state_id: "3977",
        },
        {
          id: "47006",
          name: "Watertown",
          state_id: "3977",
        },
        {
          id: "47007",
          name: "Waukesha",
          state_id: "3977",
        },
        {
          id: "47008",
          name: "Waupun",
          state_id: "3977",
        },
        {
          id: "47009",
          name: "Wausau",
          state_id: "3977",
        },
        {
          id: "47010",
          name: "Wautoma",
          state_id: "3977",
        },
        {
          id: "47011",
          name: "Wauwatosa",
          state_id: "3977",
        },
        {
          id: "47012",
          name: "West Allis",
          state_id: "3977",
        },
        {
          id: "47013",
          name: "West Bend",
          state_id: "3977",
        },
        {
          id: "47014",
          name: "Weston",
          state_id: "3977",
        },
        {
          id: "47015",
          name: "Whitefish Bay",
          state_id: "3977",
        },
        {
          id: "47016",
          name: "Whitewater",
          state_id: "3977",
        },
        {
          id: "47017",
          name: "Wisconsin Rapids",
          state_id: "3977",
        },
      ],
      Wyoming: [
        {
          id: "47018",
          name: "Buffalo",
          state_id: "3978",
        },
        {
          id: "47019",
          name: "Casper",
          state_id: "3978",
        },
        {
          id: "47020",
          name: "Cheyenne",
          state_id: "3978",
        },
        {
          id: "47021",
          name: "Cody",
          state_id: "3978",
        },
        {
          id: "47022",
          name: "Douglas",
          state_id: "3978",
        },
        {
          id: "47023",
          name: "Evanston",
          state_id: "3978",
        },
        {
          id: "47024",
          name: "Gillette",
          state_id: "3978",
        },
        {
          id: "47025",
          name: "Green River",
          state_id: "3978",
        },
        {
          id: "47026",
          name: "Jackson",
          state_id: "3978",
        },
        {
          id: "47027",
          name: "Lander",
          state_id: "3978",
        },
        {
          id: "47028",
          name: "Laramie",
          state_id: "3978",
        },
        {
          id: "47029",
          name: "Powell",
          state_id: "3978",
        },
        {
          id: "47030",
          name: "Rawlins",
          state_id: "3978",
        },
        {
          id: "47031",
          name: "Riverton",
          state_id: "3978",
        },
        {
          id: "47032",
          name: "Rock Springs",
          state_id: "3978",
        },
        {
          id: "47033",
          name: "Sheridan",
          state_id: "3978",
        },
        {
          id: "47034",
          name: "Torrington",
          state_id: "3978",
        },
        {
          id: "47035",
          name: "Worland",
          state_id: "3978",
        },
      ],
    },
  },
  UY: {
    name: "Uruguay",
    native: "Uruguay",
    phone: "598",
    continent: "SA",
    capital: "Montevideo",
    currency: "UYI,UYU",
    languages: ["es"],
    emoji: "🇺🇾",
    emojiU: "U+1F1FA U+1F1FE",
    states: {
      Artigas: [
        {
          id: "47036",
          name: "Artigas",
          state_id: "3980",
        },
        {
          id: "47037",
          name: "Bella Union",
          state_id: "3980",
        },
      ],
      Canelones: [
        {
          id: "47038",
          name: "Camino Maldonado",
          state_id: "3981",
        },
        {
          id: "47039",
          name: "Canelones",
          state_id: "3981",
        },
        {
          id: "47040",
          name: "Ciudad de la Costa",
          state_id: "3981",
        },
        {
          id: "47041",
          name: "Juan Antonio Artigas",
          state_id: "3981",
        },
        {
          id: "47042",
          name: "Las Piedras",
          state_id: "3981",
        },
        {
          id: "47043",
          name: "Pando",
          state_id: "3981",
        },
        {
          id: "47044",
          name: "Paso de Carrasco",
          state_id: "3981",
        },
        {
          id: "47045",
          name: "Progreso",
          state_id: "3981",
        },
        {
          id: "47046",
          name: "Santa Lucia",
          state_id: "3981",
        },
      ],
      "Cerro Largo": [],
      Colonia: [
        {
          id: "47047",
          name: "Carmelo",
          state_id: "3983",
        },
        {
          id: "47048",
          name: "Colonia",
          state_id: "3983",
        },
        {
          id: "47049",
          name: "Juan Lacaze",
          state_id: "3983",
        },
        {
          id: "47050",
          name: "Nueva Helvecia",
          state_id: "3983",
        },
      ],
      Durazno: [
        {
          id: "47051",
          name: "Durazno",
          state_id: "3984",
        },
      ],
      FLorida: [
        {
          id: "47052",
          name: "Florida",
          state_id: "3985",
        },
      ],
      Flores: [
        {
          id: "47053",
          name: "Trinidad",
          state_id: "3986",
        },
      ],
      Lavalleja: [
        {
          id: "47054",
          name: "Minas",
          state_id: "3987",
        },
      ],
      Maldonado: [
        {
          id: "47055",
          name: "Maldonado",
          state_id: "3988",
        },
        {
          id: "47056",
          name: "San Carlos",
          state_id: "3988",
        },
      ],
      Montevideo: [
        {
          id: "47057",
          name: "La Paz",
          state_id: "3989",
        },
        {
          id: "47058",
          name: "Montevideo",
          state_id: "3989",
        },
      ],
      Paysandu: [
        {
          id: "47059",
          name: "Paysandu",
          state_id: "3990",
        },
      ],
      "Rio Negro": [],
      Rivera: [
        {
          id: "47060",
          name: "Rivera",
          state_id: "3992",
        },
      ],
      Rocha: [
        {
          id: "47061",
          name: "Chuy",
          state_id: "3993",
        },
        {
          id: "47062",
          name: "Rocha",
          state_id: "3993",
        },
      ],
      Salto: [
        {
          id: "47063",
          name: "Salto",
          state_id: "3994",
        },
      ],
      "San Jose": [],
      Soriano: [
        {
          id: "47064",
          name: "Dolores",
          state_id: "3996",
        },
        {
          id: "47065",
          name: "Mercedes",
          state_id: "3996",
        },
      ],
      Tacuarembo: [
        {
          id: "47066",
          name: "Paso de los Toros",
          state_id: "3997",
        },
        {
          id: "47067",
          name: "Tacuarembo",
          state_id: "3997",
        },
      ],
      "Treinta y Tres": [],
    },
  },
  UZ: {
    name: "Uzbekistan",
    native: "O‘zbekiston",
    phone: "998",
    continent: "AS",
    capital: "Tashkent",
    currency: "UZS",
    languages: ["uz", "ru"],
    emoji: "🇺🇿",
    emojiU: "U+1F1FA U+1F1FF",
    states: {
      Andijon: [
        {
          id: "47068",
          name: "Ahunabayev",
          state_id: "3999",
        },
        {
          id: "47069",
          name: "Andijon",
          state_id: "3999",
        },
        {
          id: "47070",
          name: "Asaka",
          state_id: "3999",
        },
        {
          id: "47071",
          name: "Boz",
          state_id: "3999",
        },
        {
          id: "47072",
          name: "Hakkulobod",
          state_id: "3999",
        },
        {
          id: "47073",
          name: "Hocaobod",
          state_id: "3999",
        },
        {
          id: "47074",
          name: "Honobod",
          state_id: "3999",
        },
        {
          id: "47075",
          name: "Ilyichevsk",
          state_id: "3999",
        },
        {
          id: "47076",
          name: "Karabagis",
          state_id: "3999",
        },
        {
          id: "47077",
          name: "Kurgontepa",
          state_id: "3999",
        },
        {
          id: "47078",
          name: "Marhomat",
          state_id: "3999",
        },
        {
          id: "47079",
          name: "Pahtaobod",
          state_id: "3999",
        },
        {
          id: "47080",
          name: "Paytug",
          state_id: "3999",
        },
        {
          id: "47081",
          name: "Sahrihan",
          state_id: "3999",
        },
      ],
      Buhoro: [
        {
          id: "47082",
          name: "Buhoro",
          state_id: "4000",
        },
        {
          id: "47083",
          name: "Cangeldi",
          state_id: "4000",
        },
        {
          id: "47084",
          name: "Galaosiye",
          state_id: "4000",
        },
        {
          id: "47085",
          name: "Gazli",
          state_id: "4000",
        },
        {
          id: "47086",
          name: "Gijduvon",
          state_id: "4000",
        },
        {
          id: "47087",
          name: "Kizilravbe",
          state_id: "4000",
        },
        {
          id: "47088",
          name: "Kogon",
          state_id: "4000",
        },
        {
          id: "47089",
          name: "Korakul",
          state_id: "4000",
        },
        {
          id: "47090",
          name: "Korovulbazar",
          state_id: "4000",
        },
        {
          id: "47091",
          name: "Kukca",
          state_id: "4000",
        },
        {
          id: "47092",
          name: "Olot",
          state_id: "4000",
        },
        {
          id: "47093",
          name: "Oyokkuduk",
          state_id: "4000",
        },
        {
          id: "47094",
          name: "Romitan",
          state_id: "4000",
        },
        {
          id: "47095",
          name: "Safirkon",
          state_id: "4000",
        },
        {
          id: "47096",
          name: "Vobkent",
          state_id: "4000",
        },
      ],
      "Buxoro Viloyati": [],
      Cizah: [
        {
          id: "47097",
          name: "Cizah",
          state_id: "4002",
        },
        {
          id: "47098",
          name: "Dustlik",
          state_id: "4002",
        },
        {
          id: "47099",
          name: "Gagarin",
          state_id: "4002",
        },
        {
          id: "47100",
          name: "Gallaorol",
          state_id: "4002",
        },
        {
          id: "47101",
          name: "Marcanbulok",
          state_id: "4002",
        },
        {
          id: "47102",
          name: "Pahtakor",
          state_id: "4002",
        },
        {
          id: "47103",
          name: "Ulyanovo",
          state_id: "4002",
        },
        {
          id: "47104",
          name: "Zomin",
          state_id: "4002",
        },
      ],
      Fargona: [
        {
          id: "47105",
          name: "Altyarik",
          state_id: "4003",
        },
        {
          id: "47106",
          name: "Avval",
          state_id: "4003",
        },
        {
          id: "47107",
          name: "Besarik",
          state_id: "4003",
        },
        {
          id: "47108",
          name: "Fargona",
          state_id: "4003",
        },
        {
          id: "47109",
          name: "Hamza",
          state_id: "4003",
        },
        {
          id: "47110",
          name: "Kirgili",
          state_id: "4003",
        },
        {
          id: "47111",
          name: "Kukon",
          state_id: "4003",
        },
        {
          id: "47112",
          name: "Kuva",
          state_id: "4003",
        },
        {
          id: "47113",
          name: "Kuvasoy",
          state_id: "4003",
        },
        {
          id: "47114",
          name: "Margilon",
          state_id: "4003",
        },
        {
          id: "47115",
          name: "Rapkan",
          state_id: "4003",
        },
        {
          id: "47116",
          name: "Riston",
          state_id: "4003",
        },
        {
          id: "47117",
          name: "Toslok",
          state_id: "4003",
        },
        {
          id: "47118",
          name: "Yaypan",
          state_id: "4003",
        },
      ],
      Horazm: [
        {
          id: "47119",
          name: "Drujba",
          state_id: "4004",
        },
        {
          id: "47120",
          name: "Gurlan",
          state_id: "4004",
        },
        {
          id: "47121",
          name: "Hazorasp",
          state_id: "4004",
        },
        {
          id: "47122",
          name: "Heva",
          state_id: "4004",
        },
        {
          id: "47123",
          name: "Honko",
          state_id: "4004",
        },
        {
          id: "47124",
          name: "Kuskupir",
          state_id: "4004",
        },
        {
          id: "47125",
          name: "Mesekli",
          state_id: "4004",
        },
        {
          id: "47126",
          name: "Sovot",
          state_id: "4004",
        },
        {
          id: "47127",
          name: "Turpokkala",
          state_id: "4004",
        },
        {
          id: "47128",
          name: "Urgenc",
          state_id: "4004",
        },
      ],
      Kaskadar: [
        {
          id: "47129",
          name: "Beskent",
          state_id: "4005",
        },
        {
          id: "47130",
          name: "Ceynau",
          state_id: "4005",
        },
        {
          id: "47131",
          name: "Cirakci",
          state_id: "4005",
        },
        {
          id: "47132",
          name: "Dehkanobod",
          state_id: "4005",
        },
        {
          id: "47133",
          name: "Dinau",
          state_id: "4005",
        },
        {
          id: "47134",
          name: "Guzor",
          state_id: "4005",
        },
        {
          id: "47135",
          name: "Kallig",
          state_id: "4005",
        },
        {
          id: "47136",
          name: "Kamasi",
          state_id: "4005",
        },
        {
          id: "47137",
          name: "Karabag",
          state_id: "4005",
        },
        {
          id: "47138",
          name: "Karsi",
          state_id: "4005",
        },
        {
          id: "47139",
          name: "Kasbi",
          state_id: "4005",
        },
        {
          id: "47140",
          name: "Kitob",
          state_id: "4005",
        },
        {
          id: "47141",
          name: "Koson",
          state_id: "4005",
        },
        {
          id: "47142",
          name: "Madaniyat",
          state_id: "4005",
        },
        {
          id: "47143",
          name: "Maydayap",
          state_id: "4005",
        },
        {
          id: "47144",
          name: "Maymanak",
          state_id: "4005",
        },
        {
          id: "47145",
          name: "Muborak",
          state_id: "4005",
        },
        {
          id: "47146",
          name: "Oktyabrskiy",
          state_id: "4005",
        },
        {
          id: "47147",
          name: "Sahrisabz",
          state_id: "4005",
        },
        {
          id: "47148",
          name: "Talimarcon",
          state_id: "4005",
        },
        {
          id: "47149",
          name: "Urtacim",
          state_id: "4005",
        },
        {
          id: "47150",
          name: "Yakkabog",
          state_id: "4005",
        },
        {
          id: "47151",
          name: "Yaninison",
          state_id: "4005",
        },
      ],
      Korakalpogiston: [
        {
          id: "47152",
          name: "Beruni",
          state_id: "4006",
        },
        {
          id: "47153",
          name: "Buston",
          state_id: "4006",
        },
        {
          id: "47154",
          name: "Cimboy",
          state_id: "4006",
        },
        {
          id: "47155",
          name: "Halkobod",
          state_id: "4006",
        },
        {
          id: "47156",
          name: "Hucayli",
          state_id: "4006",
        },
        {
          id: "47157",
          name: "Karauzyak",
          state_id: "4006",
        },
        {
          id: "47158",
          name: "Kegayli",
          state_id: "4006",
        },
        {
          id: "47159",
          name: "Kizketken",
          state_id: "4006",
        },
        {
          id: "47160",
          name: "Kozokdaryo",
          state_id: "4006",
        },
        {
          id: "47161",
          name: "Kungirot",
          state_id: "4006",
        },
        {
          id: "47162",
          name: "Mangit",
          state_id: "4006",
        },
        {
          id: "47163",
          name: "Muynok",
          state_id: "4006",
        },
        {
          id: "47164",
          name: "Nukus",
          state_id: "4006",
        },
        {
          id: "47165",
          name: "Tahiatos",
          state_id: "4006",
        },
        {
          id: "47166",
          name: "Tahtakupir",
          state_id: "4006",
        },
        {
          id: "47167",
          name: "Turtkul",
          state_id: "4006",
        },
      ],
      Namangan: [
        {
          id: "47168",
          name: "Aytim",
          state_id: "4007",
        },
        {
          id: "47169",
          name: "Besbulok",
          state_id: "4007",
        },
        {
          id: "47170",
          name: "Cartak",
          state_id: "4007",
        },
        {
          id: "47171",
          name: "Cingeldi",
          state_id: "4007",
        },
        {
          id: "47172",
          name: "Cust",
          state_id: "4007",
        },
        {
          id: "47173",
          name: "Gozgon",
          state_id: "4007",
        },
        {
          id: "47174",
          name: "Iskavat",
          state_id: "4007",
        },
        {
          id: "47175",
          name: "Kalkuduk",
          state_id: "4007",
        },
        {
          id: "47176",
          name: "Konimeh",
          state_id: "4007",
        },
        {
          id: "47177",
          name: "Kosonsoy",
          state_id: "4007",
        },
        {
          id: "47178",
          name: "Minbulok",
          state_id: "4007",
        },
        {
          id: "47179",
          name: "Namangan",
          state_id: "4007",
        },
        {
          id: "47180",
          name: "Nurota",
          state_id: "4007",
        },
        {
          id: "47181",
          name: "Pop",
          state_id: "4007",
        },
        {
          id: "47182",
          name: "Tomdibulok",
          state_id: "4007",
        },
        {
          id: "47183",
          name: "Tosbulok",
          state_id: "4007",
        },
        {
          id: "47184",
          name: "Turakurgon",
          state_id: "4007",
        },
        {
          id: "47185",
          name: "Uckurgon",
          state_id: "4007",
        },
        {
          id: "47186",
          name: "Unhoyat",
          state_id: "4007",
        },
        {
          id: "47187",
          name: "Uyci",
          state_id: "4007",
        },
        {
          id: "47188",
          name: "Uzunkuduk",
          state_id: "4007",
        },
        {
          id: "47189",
          name: "Yanikurgon",
          state_id: "4007",
        },
      ],
      Navoi: [
        {
          id: "47190",
          name: "Karmana",
          state_id: "4008",
        },
        {
          id: "47191",
          name: "Kiziltepa",
          state_id: "4008",
        },
        {
          id: "47192",
          name: "Navoi",
          state_id: "4008",
        },
        {
          id: "47193",
          name: "Uckuduk",
          state_id: "4008",
        },
        {
          id: "47194",
          name: "Zarafson",
          state_id: "4008",
        },
      ],
      Samarkand: [
        {
          id: "47195",
          name: "Bulungur",
          state_id: "4009",
        },
        {
          id: "47196",
          name: "Camboy",
          state_id: "4009",
        },
        {
          id: "47197",
          name: "Carhin",
          state_id: "4009",
        },
        {
          id: "47198",
          name: "Celak",
          state_id: "4009",
        },
        {
          id: "47199",
          name: "Cuma",
          state_id: "4009",
        },
        {
          id: "47200",
          name: "Dahbed",
          state_id: "4009",
        },
        {
          id: "47201",
          name: "Istihon",
          state_id: "4009",
        },
        {
          id: "47202",
          name: "Kattakurgon",
          state_id: "4009",
        },
        {
          id: "47203",
          name: "Kusrobod",
          state_id: "4009",
        },
        {
          id: "47204",
          name: "Nurobod",
          state_id: "4009",
        },
        {
          id: "47205",
          name: "Oktos",
          state_id: "4009",
        },
        {
          id: "47206",
          name: "Paysanba",
          state_id: "4009",
        },
        {
          id: "47207",
          name: "Samarkand",
          state_id: "4009",
        },
        {
          id: "47208",
          name: "Superfosfatniy",
          state_id: "4009",
        },
        {
          id: "47209",
          name: "Urgut",
          state_id: "4009",
        },
        {
          id: "47210",
          name: "Yanirobod",
          state_id: "4009",
        },
        {
          id: "47211",
          name: "Ziadin",
          state_id: "4009",
        },
      ],
      Sirdare: [
        {
          id: "47212",
          name: "Baht",
          state_id: "4010",
        },
        {
          id: "47213",
          name: "Guliston",
          state_id: "4010",
        },
        {
          id: "47214",
          name: "Hovos",
          state_id: "4010",
        },
        {
          id: "47215",
          name: "Sirdare",
          state_id: "4010",
        },
        {
          id: "47216",
          name: "Sirin",
          state_id: "4010",
        },
        {
          id: "47217",
          name: "Yaniyer",
          state_id: "4010",
        },
      ],
      Surhondar: [
        {
          id: "47218",
          name: "Akkurgon",
          state_id: "4011",
        },
        {
          id: "47219",
          name: "Boysun",
          state_id: "4011",
        },
        {
          id: "47220",
          name: "Carkurgon",
          state_id: "4011",
        },
        {
          id: "47221",
          name: "Denau",
          state_id: "4011",
        },
        {
          id: "47222",
          name: "Kumkurgon",
          state_id: "4011",
        },
        {
          id: "47223",
          name: "Paskurd",
          state_id: "4011",
        },
        {
          id: "47224",
          name: "Sargun",
          state_id: "4011",
        },
        {
          id: "47225",
          name: "Sariasiya",
          state_id: "4011",
        },
        {
          id: "47226",
          name: "Serobod",
          state_id: "4011",
        },
        {
          id: "47227",
          name: "Surci",
          state_id: "4011",
        },
        {
          id: "47228",
          name: "Termiz",
          state_id: "4011",
        },
        {
          id: "47229",
          name: "Zan",
          state_id: "4011",
        },
      ],
      Toskent: [
        {
          id: "47230",
          name: "Almazar",
          state_id: "4012",
        },
        {
          id: "47231",
          name: "Angren",
          state_id: "4012",
        },
        {
          id: "47232",
          name: "Bekobod",
          state_id: "4012",
        },
        {
          id: "47233",
          name: "Bektemir",
          state_id: "4012",
        },
        {
          id: "47234",
          name: "Buka",
          state_id: "4012",
        },
        {
          id: "47235",
          name: "Cinoz",
          state_id: "4012",
        },
        {
          id: "47236",
          name: "Circik",
          state_id: "4012",
        },
        {
          id: "47237",
          name: "Gazalkent",
          state_id: "4012",
        },
        {
          id: "47238",
          name: "Iskandar",
          state_id: "4012",
        },
        {
          id: "47239",
          name: "Keles",
          state_id: "4012",
        },
        {
          id: "47240",
          name: "Kibray",
          state_id: "4012",
        },
        {
          id: "47241",
          name: "Krasnogorskiy",
          state_id: "4012",
        },
        {
          id: "47242",
          name: "Kuyluk",
          state_id: "4012",
        },
        {
          id: "47243",
          name: "Ohangaron",
          state_id: "4012",
        },
        {
          id: "47244",
          name: "Olmalik",
          state_id: "4012",
        },
        {
          id: "47245",
          name: "Parkent",
          state_id: "4012",
        },
        {
          id: "47246",
          name: "Pskent",
          state_id: "4012",
        },
        {
          id: "47247",
          name: "Salar",
          state_id: "4012",
        },
        {
          id: "47248",
          name: "Soldatski",
          state_id: "4012",
        },
        {
          id: "47249",
          name: "Tashkent",
          state_id: "4012",
        },
        {
          id: "47250",
          name: "Toskent",
          state_id: "4012",
        },
        {
          id: "47251",
          name: "Tuytepa",
          state_id: "4012",
        },
        {
          id: "47252",
          name: "Urtaaul",
          state_id: "4012",
        },
        {
          id: "47253",
          name: "Yaniobod",
          state_id: "4012",
        },
        {
          id: "47254",
          name: "Yaniyul",
          state_id: "4012",
        },
      ],
    },
  },
  VA: {
    name: "Vatican City",
    native: "Vaticano",
    phone: "39066,379",
    continent: "EU",
    capital: "Vatican City",
    currency: "EUR",
    languages: ["it", "la"],
    emoji: "🇻🇦",
    emojiU: "U+1F1FB U+1F1E6",
    states: {
      "Vatican City State (Holy See)": [],
    },
  },
  VC: {
    name: "Saint Vincent and the Grenadines",
    native: "Saint Vincent and the Grenadines",
    phone: "1784",
    continent: "NA",
    capital: "Kingstown",
    currency: "XCD",
    languages: ["en"],
    emoji: "🇻🇨",
    emojiU: "U+1F1FB U+1F1E8",
    states: {
      Charlotte: [
        {
          id: "37381",
          name: "Biabou",
          state_id: "3114",
        },
        {
          id: "37382",
          name: "Byera",
          state_id: "3114",
        },
        {
          id: "37383",
          name: "Georgetown",
          state_id: "3114",
        },
      ],
      Grenadines: [
        {
          id: "37384",
          name: "Dovers",
          state_id: "3115",
        },
        {
          id: "37385",
          name: "Hamilton",
          state_id: "3115",
        },
        {
          id: "37386",
          name: "Port Elizabeth",
          state_id: "3115",
        },
      ],
      "Saint Andrew": [],
      "Saint David": [],
      "Saint George": [],
      "Saint Patrick": [],
    },
  },
  VE: {
    name: "Venezuela",
    native: "Venezuela",
    phone: "58",
    continent: "SA",
    capital: "Caracas",
    currency: "VEF",
    languages: ["es"],
    emoji: "🇻🇪",
    emojiU: "U+1F1FB U+1F1EA",
    states: {
      Amazonas: [
        {
          id: "47263",
          name: "Puerto Ayacucho",
          state_id: "4020",
        },
      ],
      Anzoategui: [
        {
          id: "47264",
          name: "Anaco",
          state_id: "4021",
        },
        {
          id: "47265",
          name: "Barcelona",
          state_id: "4021",
        },
        {
          id: "47266",
          name: "Cantaura",
          state_id: "4021",
        },
        {
          id: "47267",
          name: "El Tigre",
          state_id: "4021",
        },
        {
          id: "47268",
          name: "Puerto la Cruz",
          state_id: "4021",
        },
        {
          id: "47269",
          name: "San Jose de Guanipa",
          state_id: "4021",
        },
      ],
      Apure: [
        {
          id: "47270",
          name: "Guasdualito",
          state_id: "4022",
        },
        {
          id: "47271",
          name: "San Fernando",
          state_id: "4022",
        },
      ],
      Aragua: [
        {
          id: "47272",
          name: "Cagua",
          state_id: "4023",
        },
        {
          id: "47273",
          name: "El Limon",
          state_id: "4023",
        },
        {
          id: "47274",
          name: "La Victoria",
          state_id: "4023",
        },
        {
          id: "47275",
          name: "Las Teyerias",
          state_id: "4023",
        },
        {
          id: "47276",
          name: "Maracay",
          state_id: "4023",
        },
        {
          id: "47277",
          name: "Palo Negro",
          state_id: "4023",
        },
        {
          id: "47278",
          name: "San Mateo",
          state_id: "4023",
        },
        {
          id: "47279",
          name: "Turmero",
          state_id: "4023",
        },
        {
          id: "47280",
          name: "Villa de Cura",
          state_id: "4023",
        },
      ],
      Barinas: [
        {
          id: "47281",
          name: "Barinas",
          state_id: "4024",
        },
        {
          id: "47282",
          name: "Barinitas",
          state_id: "4024",
        },
      ],
      Bolivar: [
        {
          id: "47283",
          name: "Ciudad Bolivar",
          state_id: "4025",
        },
        {
          id: "47284",
          name: "Ciudad Guayana",
          state_id: "4025",
        },
        {
          id: "47285",
          name: "Upata",
          state_id: "4025",
        },
      ],
      Carabobo: [
        {
          id: "47286",
          name: "Goaigoaza",
          state_id: "4026",
        },
        {
          id: "47287",
          name: "Guacara",
          state_id: "4026",
        },
        {
          id: "47288",
          name: "Guigue",
          state_id: "4026",
        },
        {
          id: "47289",
          name: "Mariara",
          state_id: "4026",
        },
        {
          id: "47290",
          name: "Moron",
          state_id: "4026",
        },
        {
          id: "47291",
          name: "Puerto Cabello",
          state_id: "4026",
        },
        {
          id: "47292",
          name: "San Joaquin",
          state_id: "4026",
        },
        {
          id: "47293",
          name: "Tacarigua",
          state_id: "4026",
        },
        {
          id: "47294",
          name: "Valencia",
          state_id: "4026",
        },
      ],
      Cojedes: [
        {
          id: "47295",
          name: "San Carlos",
          state_id: "4027",
        },
        {
          id: "47296",
          name: "Tinaquillo",
          state_id: "4027",
        },
      ],
      "Delta Amacuro": [],
      "Distrito Federal": [],
      Falcon: [
        {
          id: "47297",
          name: "Coro",
          state_id: "4030",
        },
        {
          id: "47298",
          name: "Punta Cardon",
          state_id: "4030",
        },
        {
          id: "47299",
          name: "Punto Fijo",
          state_id: "4030",
        },
      ],
      Guarico: [
        {
          id: "47300",
          name: "Altagracia de Orituco",
          state_id: "4031",
        },
        {
          id: "47301",
          name: "Calabozo",
          state_id: "4031",
        },
        {
          id: "47302",
          name: "San Juan de los Morros",
          state_id: "4031",
        },
        {
          id: "47303",
          name: "Valle de la Pascua",
          state_id: "4031",
        },
        {
          id: "47304",
          name: "Zaraza",
          state_id: "4031",
        },
      ],
      Lara: [
        {
          id: "47305",
          name: "Barquisimeto",
          state_id: "4032",
        },
        {
          id: "47306",
          name: "Cabudare",
          state_id: "4032",
        },
        {
          id: "47307",
          name: "Carora",
          state_id: "4032",
        },
        {
          id: "47308",
          name: "El Tocuyo",
          state_id: "4032",
        },
        {
          id: "47309",
          name: "Los Rastrojos",
          state_id: "4032",
        },
        {
          id: "47310",
          name: "Quibor",
          state_id: "4032",
        },
      ],
      Merida: [
        {
          id: "47311",
          name: "Ejido",
          state_id: "4033",
        },
        {
          id: "47312",
          name: "El Vigia",
          state_id: "4033",
        },
        {
          id: "47313",
          name: "Merida",
          state_id: "4033",
        },
      ],
      Miranda: [
        {
          id: "47314",
          name: "Baruta",
          state_id: "4034",
        },
        {
          id: "47315",
          name: "Carrizal",
          state_id: "4034",
        },
        {
          id: "47316",
          name: "Catia La Mar",
          state_id: "4034",
        },
        {
          id: "47317",
          name: "Caucaguita",
          state_id: "4034",
        },
        {
          id: "47318",
          name: "Chacao",
          state_id: "4034",
        },
        {
          id: "47319",
          name: "Charallave",
          state_id: "4034",
        },
        {
          id: "47320",
          name: "Cua",
          state_id: "4034",
        },
        {
          id: "47321",
          name: "El Cafetal",
          state_id: "4034",
        },
        {
          id: "47322",
          name: "El Hatillo",
          state_id: "4034",
        },
        {
          id: "47323",
          name: "Filas de Mariche",
          state_id: "4034",
        },
        {
          id: "47324",
          name: "Guarenas",
          state_id: "4034",
        },
        {
          id: "47325",
          name: "Guatire",
          state_id: "4034",
        },
        {
          id: "47326",
          name: "La Dolorita",
          state_id: "4034",
        },
        {
          id: "47327",
          name: "Los Dos Caminos",
          state_id: "4034",
        },
        {
          id: "47328",
          name: "Los Teques",
          state_id: "4034",
        },
        {
          id: "47329",
          name: "Ocumare del Tuy",
          state_id: "4034",
        },
        {
          id: "47330",
          name: "Petare",
          state_id: "4034",
        },
        {
          id: "47331",
          name: "San Antonio de los Altos",
          state_id: "4034",
        },
        {
          id: "47332",
          name: "Santa Teresa",
          state_id: "4034",
        },
      ],
      Monagas: [
        {
          id: "47333",
          name: "Maturin",
          state_id: "4035",
        },
      ],
      "Nueva Esparta": [],
      Portuguesa: [
        {
          id: "47334",
          name: "Acarigua",
          state_id: "4037",
        },
        {
          id: "47335",
          name: "Araure",
          state_id: "4037",
        },
        {
          id: "47336",
          name: "Guanare",
          state_id: "4037",
        },
        {
          id: "47337",
          name: "Villa Bruzual",
          state_id: "4037",
        },
      ],
      Sucre: [
        {
          id: "47338",
          name: "Carupano",
          state_id: "4038",
        },
        {
          id: "47339",
          name: "Cumana",
          state_id: "4038",
        },
      ],
      Tachira: [
        {
          id: "47340",
          name: "La Fria",
          state_id: "4039",
        },
        {
          id: "47341",
          name: "Rubio",
          state_id: "4039",
        },
        {
          id: "47342",
          name: "San Antonio del Tachira",
          state_id: "4039",
        },
        {
          id: "47343",
          name: "San Cristobal",
          state_id: "4039",
        },
        {
          id: "47344",
          name: "San Juan de Colon",
          state_id: "4039",
        },
        {
          id: "47345",
          name: "Tariba",
          state_id: "4039",
        },
      ],
      Trujillo: [
        {
          id: "47346",
          name: "Trujillo",
          state_id: "4040",
        },
        {
          id: "47347",
          name: "Valera",
          state_id: "4040",
        },
      ],
      Vargas: [
        {
          id: "47348",
          name: "Caraballeda",
          state_id: "4041",
        },
        {
          id: "47349",
          name: "La Guaira",
          state_id: "4041",
        },
        {
          id: "47350",
          name: "Maiquetia",
          state_id: "4041",
        },
      ],
      Yaracuy: [
        {
          id: "47351",
          name: "Chivacoa",
          state_id: "4042",
        },
        {
          id: "47352",
          name: "Nirgua",
          state_id: "4042",
        },
        {
          id: "47353",
          name: "San Felipe",
          state_id: "4042",
        },
        {
          id: "47354",
          name: "Yaritagua",
          state_id: "4042",
        },
      ],
      Zulia: [
        {
          id: "47355",
          name: "Bachaquero",
          state_id: "4043",
        },
        {
          id: "47356",
          name: "Cabimas",
          state_id: "4043",
        },
        {
          id: "47357",
          name: "Ciudad Ojeda",
          state_id: "4043",
        },
        {
          id: "47358",
          name: "Lagunillas",
          state_id: "4043",
        },
        {
          id: "47359",
          name: "Machiques",
          state_id: "4043",
        },
        {
          id: "47360",
          name: "Maracaibo",
          state_id: "4043",
        },
        {
          id: "47361",
          name: "San Carlos del Zulia",
          state_id: "4043",
        },
        {
          id: "47362",
          name: "Santa Rita",
          state_id: "4043",
        },
        {
          id: "47363",
          name: "Villa del Rosario",
          state_id: "4043",
        },
      ],
    },
  },
  VG: {
    name: "British Virgin Islands",
    native: "British Virgin Islands",
    phone: "1284",
    continent: "NA",
    capital: "Road Town",
    currency: "USD",
    languages: ["en"],
    emoji: "🇻🇬",
    emojiU: "U+1F1FB U+1F1EC",
    states: {
      Anegada: [
        {
          id: "47367",
          name: "Settlement",
          state_id: "4064",
        },
      ],
      "Jost van Dyke": [],
      Tortola: [
        {
          id: "47368",
          name: "East End-Long Look",
          state_id: "4066",
        },
        {
          id: "47369",
          name: "Road Town",
          state_id: "4066",
        },
        {
          id: "47370",
          name: "West End",
          state_id: "4066",
        },
      ],
    },
  },
  VI: {
    name: "U.S. Virgin Islands",
    native: "United States Virgin Islands",
    phone: "1340",
    continent: "NA",
    capital: "Charlotte Amalie",
    currency: "USD",
    languages: ["en"],
    emoji: "🇻🇮",
    emojiU: "U+1F1FB U+1F1EE",
    states: {
      "Saint Croix": [],
      "Saint John": [],
      "Saint Thomas": [],
    },
  },
  VN: {
    name: "Vietnam",
    native: "Việt Nam",
    phone: "84",
    continent: "AS",
    capital: "Hanoi",
    currency: "VND",
    languages: ["vi"],
    emoji: "🇻🇳",
    emojiU: "U+1F1FB U+1F1F3",
    states: {
      "Bac Giang": [],
      "Binh Dinh": [],
      "Binh Duong": [],
      "Da Nang": [],
      "Dong Bang Song Cuu Long": [],
      "Dong Bang Song Hong": [],
      "Dong Nai": [],
      "Dong Nam Bo": [],
      "Duyen Hai Mien Trung": [],
      Hanoi: [
        {
          id: "47364",
          name: "Ha noi",
          state_id: "4053",
        },
        {
          id: "47365",
          name: "Hoang Mai",
          state_id: "4053",
        },
        {
          id: "47366",
          name: "Lang Ha",
          state_id: "4053",
        },
      ],
      "Hung Yen": [],
      "Khu Bon Cu": [],
      "Long An": [],
      "Mien Nui Va Trung Du": [],
      "Thai Nguyen": [],
      "Thanh Pho Ho Chi Minh": [],
      "Thu Do Ha Noi": [],
      "Tinh Can Tho": [],
      "Tinh Da Nang": [],
      "Tinh Gia Lai": [],
    },
  },
  VU: {
    name: "Vanuatu",
    native: "Vanuatu",
    phone: "678",
    continent: "OC",
    capital: "Port Vila",
    currency: "VUV",
    languages: ["bi", "en", "fr"],
    emoji: "🇻🇺",
    emojiU: "U+1F1FB U+1F1FA",
    states: {
      Malampa: [
        {
          id: "47255",
          name: "Lakatoro",
          state_id: "4013",
        },
        {
          id: "47256",
          name: "Norsup",
          state_id: "4013",
        },
      ],
      Penama: [
        {
          id: "47257",
          name: "Longana",
          state_id: "4014",
        },
      ],
      Sanma: [
        {
          id: "47258",
          name: "Luganville",
          state_id: "4015",
        },
        {
          id: "47259",
          name: "Port Olry",
          state_id: "4015",
        },
      ],
      Shefa: [
        {
          id: "47260",
          name: "Vila",
          state_id: "4016",
        },
      ],
      Tafea: [
        {
          id: "47261",
          name: "Isangel",
          state_id: "4017",
        },
      ],
      Torba: [
        {
          id: "47262",
          name: "Sola",
          state_id: "4018",
        },
      ],
    },
  },
  WF: {
    name: "Wallis and Futuna",
    native: "Wallis et Futuna",
    phone: "681",
    continent: "OC",
    capital: "Mata-Utu",
    currency: "XPF",
    languages: ["fr"],
    emoji: "🇼🇫",
    emojiU: "U+1F1FC U+1F1EB",
    states: {
      Alo: [
        {
          id: "47371",
          name: "Kolia",
          state_id: "4070",
        },
        {
          id: "47372",
          name: "Mala''e",
          state_id: "4070",
        },
        {
          id: "47373",
          name: "Ono",
          state_id: "4070",
        },
        {
          id: "47374",
          name: "Poi",
          state_id: "4070",
        },
        {
          id: "47375",
          name: "Tamana",
          state_id: "4070",
        },
        {
          id: "47376",
          name: "Taoa",
          state_id: "4070",
        },
        {
          id: "47377",
          name: "Tuatafa",
          state_id: "4070",
        },
        {
          id: "47378",
          name: "Vele",
          state_id: "4070",
        },
      ],
      Singave: [
        {
          id: "47379",
          name: "Fiua",
          state_id: "4071",
        },
        {
          id: "47380",
          name: "Leava",
          state_id: "4071",
        },
        {
          id: "47381",
          name: "Nuku",
          state_id: "4071",
        },
        {
          id: "47382",
          name: "Tavai",
          state_id: "4071",
        },
        {
          id: "47383",
          name: "Toloke",
          state_id: "4071",
        },
        {
          id: "47384",
          name: "Vaisei",
          state_id: "4071",
        },
      ],
      Wallis: [
        {
          id: "47385",
          name: "Ahoa",
          state_id: "4072",
        },
        {
          id: "47386",
          name: "Aka Aka",
          state_id: "4072",
        },
        {
          id: "47387",
          name: "Alele",
          state_id: "4072",
        },
        {
          id: "47388",
          name: "Falaleu",
          state_id: "4072",
        },
        {
          id: "47389",
          name: "Gahi",
          state_id: "4072",
        },
        {
          id: "47390",
          name: "Haafuasia",
          state_id: "4072",
        },
        {
          id: "47391",
          name: "Haatofo",
          state_id: "4072",
        },
        {
          id: "47392",
          name: "Halalo",
          state_id: "4072",
        },
        {
          id: "47393",
          name: "Kolopopo",
          state_id: "4072",
        },
        {
          id: "47394",
          name: "Lavegahau",
          state_id: "4072",
        },
        {
          id: "47395",
          name: "Liku",
          state_id: "4072",
        },
        {
          id: "47396",
          name: "Mala''e",
          state_id: "4072",
        },
        {
          id: "47397",
          name: "Malaefoou",
          state_id: "4072",
        },
        {
          id: "47398",
          name: "Mata''Utu",
          state_id: "4072",
        },
        {
          id: "47399",
          name: "Teesi",
          state_id: "4072",
        },
        {
          id: "47400",
          name: "Tepa",
          state_id: "4072",
        },
        {
          id: "47401",
          name: "Utuofa",
          state_id: "4072",
        },
        {
          id: "47402",
          name: "Vailala",
          state_id: "4072",
        },
        {
          id: "47403",
          name: "Vaimalau",
          state_id: "4072",
        },
        {
          id: "47404",
          name: "Vaitupu",
          state_id: "4072",
        },
      ],
    },
  },
  WS: {
    name: "Samoa",
    native: "Samoa",
    phone: "685",
    continent: "OC",
    capital: "Apia",
    currency: "WST",
    languages: ["sm", "en"],
    emoji: "🇼🇸",
    emojiU: "U+1F1FC U+1F1F8",
    states: {
      "A''ana": [
        {
          id: "37387",
          name: "Falelatai",
          state_id: "3120",
        },
      ],
      "Aiga-i-le-Tai": [
        {
          id: "37388",
          name: "Mulifanua",
          state_id: "3121",
        },
      ],
      Atua: [
        {
          id: "37389",
          name: "Solosolo",
          state_id: "3122",
        },
      ],
      "Fa''asaleleaga": [
        {
          id: "37390",
          name: "Safotulafai",
          state_id: "3123",
        },
      ],
      "Gaga''emauga": [
        {
          id: "37391",
          name: "Samalae''ulu",
          state_id: "3124",
        },
      ],
      Gagaifomauga: [
        {
          id: "37392",
          name: "A''opo",
          state_id: "3125",
        },
      ],
      Palauli: [
        {
          id: "37393",
          name: "Taga",
          state_id: "3126",
        },
      ],
      "Satupa''itea": [
        {
          id: "37394",
          name: "Gautavai",
          state_id: "3127",
        },
      ],
      Tuamasaga: [
        {
          id: "37395",
          name: "Apia",
          state_id: "3128",
        },
      ],
      "Va''a-o-Fonoti": [
        {
          id: "37396",
          name: "Samamea",
          state_id: "3129",
        },
      ],
      Vaisigano: [
        {
          id: "37397",
          name: "Neiafu",
          state_id: "3130",
        },
      ],
    },
  },
  XK: {
    name: "Kosovo",
    native: "Republika e Kosovës",
    phone: "377,381,383,386",
    continent: "EU",
    capital: "Pristina",
    currency: "EUR",
    languages: ["sq", "sr"],
    emoji: "🇽🇰",
    emojiU: "U+1F1FD U+1F1F0",
    states: {},
  },
  YE: {
    name: "Yemen",
    native: "اليَمَن",
    phone: "967",
    continent: "AS",
    capital: "Sana'a",
    currency: "YER",
    languages: ["ar"],
    emoji: "🇾🇪",
    emojiU: "U+1F1FE U+1F1EA",
    states: {
      Adan: [
        {
          id: "47408",
          name: "Adan",
          state_id: "4077",
        },
        {
          id: "47409",
          name: "Aden",
          state_id: "4077",
        },
      ],
      Abyan: [
        {
          id: "47410",
          name: "Ahwar",
          state_id: "4078",
        },
        {
          id: "47411",
          name: "Ja''ar",
          state_id: "4078",
        },
        {
          id: "47412",
          name: "Zinjibar",
          state_id: "4078",
        },
      ],
      Dhamar: [
        {
          id: "47413",
          name: "Dhamar",
          state_id: "4079",
        },
      ],
      Hadramaut: [
        {
          id: "47414",
          name: "Shaqra",
          state_id: "4080",
        },
        {
          id: "47415",
          name: "al-Mukalla",
          state_id: "4080",
        },
        {
          id: "47416",
          name: "ash-Shahir",
          state_id: "4080",
        },
      ],
      Hajjah: [
        {
          id: "47417",
          name: "Hajjah",
          state_id: "4081",
        },
      ],
      Hudaydah: [
        {
          id: "47418",
          name: "Hodaidah",
          state_id: "4082",
        },
      ],
      Ibb: [
        {
          id: "47419",
          name: "Dhi Sufal",
          state_id: "4083",
        },
        {
          id: "47420",
          name: "Ibb",
          state_id: "4083",
        },
        {
          id: "47421",
          name: "Jiblah",
          state_id: "4083",
        },
        {
          id: "47422",
          name: "Qa''tabah",
          state_id: "4083",
        },
        {
          id: "47423",
          name: "Yarim",
          state_id: "4083",
        },
      ],
      Lahij: [
        {
          id: "47424",
          name: "Tuban",
          state_id: "4084",
        },
      ],
      "Ma''rib": [
        {
          id: "47425",
          name: "Ma''rib",
          state_id: "4085",
        },
      ],
      "Madinat San''a": [],
      "Sa''dah": [
        {
          id: "47426",
          name: "Sa''dah",
          state_id: "4087",
        },
      ],
      Sana: [
        {
          id: "47427",
          name: "Amran",
          state_id: "4088",
        },
        {
          id: "47428",
          name: "Sahar",
          state_id: "4088",
        },
        {
          id: "47429",
          name: "Sanaa",
          state_id: "4088",
        },
        {
          id: "47430",
          name: "Sayyan",
          state_id: "4088",
        },
      ],
      Shabwah: [
        {
          id: "47431",
          name: "Ataq",
          state_id: "4089",
        },
        {
          id: "47432",
          name: "Habban",
          state_id: "4089",
        },
        {
          id: "47433",
          name: "Taiz",
          state_id: "4089",
        },
      ],
      "Ta''izz": [
        {
          id: "47434",
          name: "Ta''izz",
          state_id: "4090",
        },
        {
          id: "47435",
          name: "al-Mukha",
          state_id: "4090",
        },
      ],
      "al-Bayda": [
        {
          id: "47436",
          name: "Raydah",
          state_id: "4091",
        },
        {
          id: "47437",
          name: "al-Bayda",
          state_id: "4091",
        },
      ],
      "al-Hudaydah": [
        {
          id: "47438",
          name: "Bajil",
          state_id: "4092",
        },
        {
          id: "47439",
          name: "Bayt-al-Faqih",
          state_id: "4092",
        },
        {
          id: "47440",
          name: "Zabid",
          state_id: "4092",
        },
        {
          id: "47441",
          name: "al-Hudaydah",
          state_id: "4092",
        },
        {
          id: "47442",
          name: "al-Marawi''ah",
          state_id: "4092",
        },
        {
          id: "47443",
          name: "az-Zaydiyah",
          state_id: "4092",
        },
      ],
      "al-Jawf": [
        {
          id: "47444",
          name: "al-Hazm",
          state_id: "4093",
        },
      ],
      "al-Mahrah": [
        {
          id: "47445",
          name: "al-Ghaydah",
          state_id: "4094",
        },
      ],
      "al-Mahwit": [
        {
          id: "47446",
          name: "Mahwit",
          state_id: "4095",
        },
      ],
    },
  },
  YT: {
    name: "Mayotte",
    native: "Mayotte",
    phone: "262",
    continent: "AF",
    capital: "Mamoudzou",
    currency: "EUR",
    languages: ["fr"],
    emoji: "🇾🇹",
    emojiU: "U+1F1FE U+1F1F9",
    states: {
      Mayotte: [
        {
          id: "27549",
          name: "Acoua",
          state_id: "2425",
        },
        {
          id: "27550",
          name: "Bandraboua",
          state_id: "2425",
        },
        {
          id: "27551",
          name: "Bandrele",
          state_id: "2425",
        },
        {
          id: "27552",
          name: "Boueni",
          state_id: "2425",
        },
        {
          id: "27553",
          name: "Chiconi",
          state_id: "2425",
        },
        {
          id: "27554",
          name: "Chirongui",
          state_id: "2425",
        },
        {
          id: "27555",
          name: "Dembeni",
          state_id: "2425",
        },
        {
          id: "27556",
          name: "Kanikeli",
          state_id: "2425",
        },
        {
          id: "27557",
          name: "Koungou",
          state_id: "2425",
        },
        {
          id: "27558",
          name: "Mamoudzou",
          state_id: "2425",
        },
        {
          id: "27559",
          name: "Mtsamboro",
          state_id: "2425",
        },
        {
          id: "27560",
          name: "Mtsangamouji",
          state_id: "2425",
        },
        {
          id: "27561",
          name: "Ouangani",
          state_id: "2425",
        },
        {
          id: "27562",
          name: "Sada",
          state_id: "2425",
        },
        {
          id: "27563",
          name: "Tsingoni",
          state_id: "2425",
        },
      ],
      Pamanzi: [
        {
          id: "27564",
          name: "Dzaoudzi",
          state_id: "2426",
        },
        {
          id: "27565",
          name: "Pamanzi",
          state_id: "2426",
        },
      ],
    },
  },
  ZA: {
    name: "South Africa",
    native: "South Africa",
    phone: "27",
    continent: "AF",
    capital: "Pretoria",
    currency: "ZAR",
    languages: ["af", "en", "nr", "st", "ss", "tn", "ts", "ve", "xh", "zu"],
    emoji: "🇿🇦",
    emojiU: "U+1F1FF U+1F1E6",
    states: {
      "Eastern Cape": [],
      "Free State": [],
      Gauteng: [
        {
          id: "38028",
          name: "Alberton",
          state_id: "3240",
        },
        {
          id: "38029",
          name: "Alrode",
          state_id: "3240",
        },
        {
          id: "38030",
          name: "Benmore",
          state_id: "3240",
        },
        {
          id: "38031",
          name: "Benoni",
          state_id: "3240",
        },
        {
          id: "38032",
          name: "Boksburg",
          state_id: "3240",
        },
        {
          id: "38033",
          name: "Booysens",
          state_id: "3240",
        },
        {
          id: "38034",
          name: "Brakpan",
          state_id: "3240",
        },
        {
          id: "38035",
          name: "Bronkhorstspruit",
          state_id: "3240",
        },
        {
          id: "38036",
          name: "Bryanston",
          state_id: "3240",
        },
        {
          id: "38037",
          name: "Carltonville",
          state_id: "3240",
        },
        {
          id: "38038",
          name: "Centurion",
          state_id: "3240",
        },
        {
          id: "38039",
          name: "Cullinan",
          state_id: "3240",
        },
        {
          id: "38040",
          name: "Dainfern",
          state_id: "3240",
        },
        {
          id: "38041",
          name: "Edenvale",
          state_id: "3240",
        },
        {
          id: "38042",
          name: "Ferndale",
          state_id: "3240",
        },
        {
          id: "38043",
          name: "Fourways",
          state_id: "3240",
        },
        {
          id: "38044",
          name: "Gardenview",
          state_id: "3240",
        },
        {
          id: "38045",
          name: "Gauteng",
          state_id: "3240",
        },
        {
          id: "38046",
          name: "Grant Park",
          state_id: "3240",
        },
        {
          id: "38047",
          name: "Heidelberg",
          state_id: "3240",
        },
        {
          id: "38048",
          name: "Isando",
          state_id: "3240",
        },
        {
          id: "38049",
          name: "Johannesburg",
          state_id: "3240",
        },
        {
          id: "38050",
          name: "Kelvin",
          state_id: "3240",
        },
        {
          id: "38051",
          name: "Krugersdorp",
          state_id: "3240",
        },
        {
          id: "38052",
          name: "Linmeyer",
          state_id: "3240",
        },
        {
          id: "38053",
          name: "Maraisburg",
          state_id: "3240",
        },
        {
          id: "38054",
          name: "Midrand",
          state_id: "3240",
        },
        {
          id: "38055",
          name: "Nigel",
          state_id: "3240",
        },
        {
          id: "38056",
          name: "Northmead",
          state_id: "3240",
        },
        {
          id: "38057",
          name: "Petervale",
          state_id: "3240",
        },
        {
          id: "38058",
          name: "Pinegowrie",
          state_id: "3240",
        },
        {
          id: "38059",
          name: "Pretoria",
          state_id: "3240",
        },
        {
          id: "38060",
          name: "Primrose",
          state_id: "3240",
        },
        {
          id: "38061",
          name: "Randburg",
          state_id: "3240",
        },
        {
          id: "38062",
          name: "Randfontein",
          state_id: "3240",
        },
        {
          id: "38063",
          name: "Randvaal",
          state_id: "3240",
        },
        {
          id: "38064",
          name: "Rivonia",
          state_id: "3240",
        },
        {
          id: "38065",
          name: "Robertville",
          state_id: "3240",
        },
        {
          id: "38066",
          name: "Soweto",
          state_id: "3240",
        },
        {
          id: "38067",
          name: "Springs",
          state_id: "3240",
        },
        {
          id: "38068",
          name: "Temba",
          state_id: "3240",
        },
        {
          id: "38069",
          name: "Tembisa",
          state_id: "3240",
        },
        {
          id: "38070",
          name: "Troyeville",
          state_id: "3240",
        },
        {
          id: "38071",
          name: "Vanderbijlpark",
          state_id: "3240",
        },
        {
          id: "38072",
          name: "Vereeniging",
          state_id: "3240",
        },
        {
          id: "38073",
          name: "Verwoerdburg",
          state_id: "3240",
        },
        {
          id: "38074",
          name: "Vorna Valley",
          state_id: "3240",
        },
        {
          id: "38075",
          name: "Wadeville",
          state_id: "3240",
        },
        {
          id: "38076",
          name: "Westonaria",
          state_id: "3240",
        },
      ],
      "Kempton Park": [],
      Kramerville: [
        {
          id: "38077",
          name: "Sandton",
          state_id: "3242",
        },
      ],
      "KwaZulu Natal": [],
      Limpopo: [
        {
          id: "38078",
          name: "Bela-Bela",
          state_id: "3244",
        },
        {
          id: "38079",
          name: "Dendron",
          state_id: "3244",
        },
        {
          id: "38080",
          name: "Duiwelskloof",
          state_id: "3244",
        },
        {
          id: "38081",
          name: "Ellisras",
          state_id: "3244",
        },
        {
          id: "38082",
          name: "Giyani",
          state_id: "3244",
        },
        {
          id: "38083",
          name: "Lebowakgomo",
          state_id: "3244",
        },
        {
          id: "38084",
          name: "Louis Trichardt",
          state_id: "3244",
        },
        {
          id: "38085",
          name: "Lulekani",
          state_id: "3244",
        },
        {
          id: "38086",
          name: "Mankweng",
          state_id: "3244",
        },
        {
          id: "38087",
          name: "Messina",
          state_id: "3244",
        },
        {
          id: "38088",
          name: "Mogalakwena",
          state_id: "3244",
        },
        {
          id: "38089",
          name: "Mutale",
          state_id: "3244",
        },
        {
          id: "38090",
          name: "Nkowakowa",
          state_id: "3244",
        },
        {
          id: "38091",
          name: "Nylstroom",
          state_id: "3244",
        },
        {
          id: "38092",
          name: "Phalaborwa",
          state_id: "3244",
        },
        {
          id: "38093",
          name: "Pietersburg",
          state_id: "3244",
        },
        {
          id: "38094",
          name: "Polokwane",
          state_id: "3244",
        },
        {
          id: "38095",
          name: "Soekmekaar",
          state_id: "3244",
        },
        {
          id: "38096",
          name: "Southdale",
          state_id: "3244",
        },
        {
          id: "38098",
          name: "Thohoyandou",
          state_id: "3244",
        },
        {
          id: "38099",
          name: "Thulamahashe",
          state_id: "3244",
        },
        {
          id: "38100",
          name: "Tzaneen",
          state_id: "3244",
        },
      ],
      Mpumalanga: [
        {
          id: "38101",
          name: "Botleng",
          state_id: "3245",
        },
        {
          id: "38102",
          name: "Ekangala",
          state_id: "3245",
        },
        {
          id: "38103",
          name: "Embalenhle",
          state_id: "3245",
        },
        {
          id: "38104",
          name: "Emjindini",
          state_id: "3245",
        },
        {
          id: "38105",
          name: "Empuluzi",
          state_id: "3245",
        },
        {
          id: "38106",
          name: "Emzinoni",
          state_id: "3245",
        },
        {
          id: "38107",
          name: "Ermelo",
          state_id: "3245",
        },
        {
          id: "38108",
          name: "Ethandakukhanja",
          state_id: "3245",
        },
        {
          id: "38109",
          name: "Groblersdal",
          state_id: "3245",
        },
        {
          id: "38110",
          name: "Komatipoort",
          state_id: "3245",
        },
        {
          id: "38111",
          name: "Kriel",
          state_id: "3245",
        },
        {
          id: "38112",
          name: "KwaZanele",
          state_id: "3245",
        },
        {
          id: "38113",
          name: "Kwazamokuhle",
          state_id: "3245",
        },
        {
          id: "38114",
          name: "Lebohang",
          state_id: "3245",
        },
        {
          id: "38115",
          name: "Marblehall",
          state_id: "3245",
        },
        {
          id: "38116",
          name: "Mashishing",
          state_id: "3245",
        },
        {
          id: "38117",
          name: "Mhluzi",
          state_id: "3245",
        },
        {
          id: "38118",
          name: "Nelspruit",
          state_id: "3245",
        },
        {
          id: "38119",
          name: "Phola",
          state_id: "3245",
        },
        {
          id: "38120",
          name: "Sakhile",
          state_id: "3245",
        },
        {
          id: "38121",
          name: "Secunda",
          state_id: "3245",
        },
        {
          id: "38122",
          name: "Siyabuswa",
          state_id: "3245",
        },
        {
          id: "38123",
          name: "Siyathemba",
          state_id: "3245",
        },
        {
          id: "38124",
          name: "Siyathuthuka",
          state_id: "3245",
        },
        {
          id: "38125",
          name: "Vukuzakhe",
          state_id: "3245",
        },
        {
          id: "38126",
          name: "Witbank",
          state_id: "3245",
        },
        {
          id: "38127",
          name: "Witrivier",
          state_id: "3245",
        },
        {
          id: "38128",
          name: "eLukwatini",
          state_id: "3245",
        },
      ],
      "North West": [],
      "Northern Cape": [],
      Parow: [
        {
          id: "38129",
          name: "Parow",
          state_id: "3248",
        },
      ],
      "Table View": [],
      Umtentweni: [
        {
          id: "38130",
          name: "Umtentweni",
          state_id: "3250",
        },
      ],
      "Western Cape": [],
    },
  },
  ZM: {
    name: "Zambia",
    native: "Zambia",
    phone: "260",
    continent: "AF",
    capital: "Lusaka",
    currency: "ZMK",
    languages: ["en"],
    emoji: "🇿🇲",
    emojiU: "U+1F1FF U+1F1F2",
    states: {
      Central: [
        {
          id: "47508",
          name: "Kabwe",
          state_id: "4102",
        },
        {
          id: "47509",
          name: "Kapiri Mposhi",
          state_id: "4102",
        },
        {
          id: "47510",
          name: "Mkushi",
          state_id: "4102",
        },
        {
          id: "47511",
          name: "Mumbwa",
          state_id: "4102",
        },
        {
          id: "47512",
          name: "Serenje",
          state_id: "4102",
        },
      ],
      Copperbelt: [
        {
          id: "47513",
          name: "Chambishi",
          state_id: "4103",
        },
        {
          id: "47514",
          name: "Chililabombwe",
          state_id: "4103",
        },
        {
          id: "47515",
          name: "Chingola",
          state_id: "4103",
        },
        {
          id: "47516",
          name: "Kalulushi",
          state_id: "4103",
        },
        {
          id: "47517",
          name: "Kitwe",
          state_id: "4103",
        },
        {
          id: "47518",
          name: "Luanshya",
          state_id: "4103",
        },
        {
          id: "47519",
          name: "Mpongwe",
          state_id: "4103",
        },
        {
          id: "47520",
          name: "Mufulira",
          state_id: "4103",
        },
        {
          id: "47521",
          name: "Ndola",
          state_id: "4103",
        },
      ],
      Eastern: [
        {
          id: "47522",
          name: "Chipata",
          state_id: "4104",
        },
        {
          id: "47523",
          name: "Katete",
          state_id: "4104",
        },
        {
          id: "47524",
          name: "Lundazi",
          state_id: "4104",
        },
        {
          id: "47525",
          name: "Petauke",
          state_id: "4104",
        },
      ],
      Luapala: [
        {
          id: "47526",
          name: "Mansa",
          state_id: "4105",
        },
        {
          id: "47527",
          name: "Mwansabombwe",
          state_id: "4105",
        },
        {
          id: "47528",
          name: "Nchelenge",
          state_id: "4105",
        },
        {
          id: "47529",
          name: "Samfya",
          state_id: "4105",
        },
      ],
      Lusaka: [
        {
          id: "47530",
          name: "Chilanga",
          state_id: "4106",
        },
        {
          id: "47531",
          name: "Kafue",
          state_id: "4106",
        },
        {
          id: "47532",
          name: "Lusaka",
          state_id: "4106",
        },
      ],
      "North-Western": [
        {
          id: "47533",
          name: "Kalengwa",
          state_id: "4107",
        },
        {
          id: "47534",
          name: "Kansanshi",
          state_id: "4107",
        },
        {
          id: "47535",
          name: "Mwinilunga",
          state_id: "4107",
        },
        {
          id: "47536",
          name: "Solwezi",
          state_id: "4107",
        },
        {
          id: "47537",
          name: "Zambezi",
          state_id: "4107",
        },
      ],
      Northern: [
        {
          id: "47538",
          name: "Chinsali",
          state_id: "4108",
        },
        {
          id: "47539",
          name: "Isoka",
          state_id: "4108",
        },
        {
          id: "47540",
          name: "Kasama",
          state_id: "4108",
        },
        {
          id: "47541",
          name: "Mbala",
          state_id: "4108",
        },
        {
          id: "47542",
          name: "Mpika",
          state_id: "4108",
        },
      ],
      Southern: [
        {
          id: "47543",
          name: "Choma",
          state_id: "4109",
        },
        {
          id: "47544",
          name: "Itezhi-Tezhi",
          state_id: "4109",
        },
        {
          id: "47545",
          name: "Kalomo",
          state_id: "4109",
        },
        {
          id: "47546",
          name: "Livingstone",
          state_id: "4109",
        },
        {
          id: "47547",
          name: "Maamba",
          state_id: "4109",
        },
        {
          id: "47548",
          name: "Mazabuka",
          state_id: "4109",
        },
        {
          id: "47549",
          name: "Monze",
          state_id: "4109",
        },
        {
          id: "47550",
          name: "Nakambala",
          state_id: "4109",
        },
        {
          id: "47551",
          name: "Siavonga",
          state_id: "4109",
        },
      ],
      Western: [
        {
          id: "47552",
          name: "Kalabo",
          state_id: "4110",
        },
        {
          id: "47553",
          name: "Kaoma",
          state_id: "4110",
        },
        {
          id: "47554",
          name: "Limulunga",
          state_id: "4110",
        },
        {
          id: "47555",
          name: "Mongu",
          state_id: "4110",
        },
        {
          id: "47556",
          name: "Senanga",
          state_id: "4110",
        },
        {
          id: "47557",
          name: "Sesheke",
          state_id: "4110",
        },
      ],
    },
  },
  ZW: {
    name: "Zimbabwe",
    native: "Zimbabwe",
    phone: "263",
    continent: "AF",
    capital: "Harare",
    currency: "ZWL",
    languages: ["en", "sn", "nd"],
    emoji: "🇿🇼",
    emojiU: "U+1F1FF U+1F1FC",
    states: {
      Bulawayo: [
        {
          id: "47558",
          name: "Bulawayo",
          state_id: "4111",
        },
      ],
      Harare: [
        {
          id: "47559",
          name: "Chitungwiza",
          state_id: "4112",
        },
        {
          id: "47560",
          name: "Harare",
          state_id: "4112",
        },
      ],
      Manicaland: [
        {
          id: "47561",
          name: "Chimanimani",
          state_id: "4113",
        },
        {
          id: "47562",
          name: "Chipinge",
          state_id: "4113",
        },
        {
          id: "47563",
          name: "Mutare",
          state_id: "4113",
        },
        {
          id: "47564",
          name: "Nyanga",
          state_id: "4113",
        },
        {
          id: "47565",
          name: "Rusape",
          state_id: "4113",
        },
        {
          id: "47566",
          name: "Sakubva",
          state_id: "4113",
        },
      ],
      "Mashonaland Central": [],
      "Mashonaland East": [],
      "Mashonaland West": [],
      Masvingo: [
        {
          id: "47567",
          name: "Chiredzi",
          state_id: "4117",
        },
        {
          id: "47568",
          name: "Gaths",
          state_id: "4117",
        },
        {
          id: "47569",
          name: "Masvingo",
          state_id: "4117",
        },
      ],
      "Matabeleland North": [],
      "Matabeleland South": [],
      Midlands: [
        {
          id: "47570",
          name: "Chivhu",
          state_id: "4120",
        },
        {
          id: "47571",
          name: "Gweru",
          state_id: "4120",
        },
        {
          id: "47572",
          name: "Kwekwe",
          state_id: "4120",
        },
        {
          id: "47573",
          name: "Mvuma",
          state_id: "4120",
        },
        {
          id: "47574",
          name: "Redcliffe",
          state_id: "4120",
        },
        {
          id: "47575",
          name: "Shurugwi",
          state_id: "4120",
        },
      ],
    },
  },
};
